// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27%23a0aec0%27%3e%3cpath d=%27M15.3 9.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27rgb%28191, 191, 191%29%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 viewBox=%270 0 24 24%27 %3E%3Cline x1=%276%27 y1=%2712%27 x2=%2718%27 y2=%2712%27 stroke=%27white%27 stroke-linejoin=%27arcs%27 stroke-width=%273%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27rgb%2855, 164, 220%29%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27rgb%28191, 191, 191%29%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3ccircle cx=%278%27 cy=%278%27 r=%273%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27%23ffffff%27%3e%3cpath d=%27M15.3 9.3a1 1 0 0 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 1.4-1.4l3.3 3.29 3.3-3.3z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/png;base64,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", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/png;base64,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", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Open+Sans:400,600,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*----------------------------------------*\\
  MAIN
\\*----------------------------------------*/

/**
* Settings
*/

/*----------------------------------------*\\
  VARIABLES
\\*----------------------------------------*/

:root {
  --t-duration: 250ms;
  --t-duration-long: 500ms;
  --t-easing: cubic-bezier(.3, 1.1, .7, .9);
}

/**
* Base
*/

/*! normalize.css v8.0.1 | MIT License | github.com/necolas/normalize.css */

/* Document
   ========================================================================== */

/**
 * 1. Correct the line height in all browsers.
 * 2. Prevent adjustments of font size after orientation changes in iOS.
 */

html {
  line-height: 1.15; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
}

/* Sections
   ========================================================================== */

/**
 * Remove the margin in all browsers.
 */

body {
  margin: 0;
}

/**
 * Render the \`main\` element consistently in IE.
 */

main {
  display: block;
}

/**
 * Correct the font size and margin on \`h1\` elements within \`section\` and
 * \`article\` contexts in Chrome, Firefox, and Safari.
 */

h1 {
  font-size: 2em;
  margin: 0.67em 0;
}

/* Grouping content
   ========================================================================== */

/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */

hr {
  box-sizing: content-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */

pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/* Text-level semantics
   ========================================================================== */

/**
 * Remove the gray background on active links in IE 10.
 */

a {
  background-color: transparent;
}

/**
 * 1. Remove the bottom border in Chrome 57-
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */

abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  text-decoration: underline;
  -webkit-text-decoration: underline dotted currentColor;
          text-decoration: underline dotted currentColor; /* 2 */
}

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */

b,
strong {
  font-weight: bolder;
}

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd \`em\` font sizing in all browsers.
 */

code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}

/**
 * Add the correct font size in all browsers.
 */

small {
  font-size: 80%;
}

/**
 * Prevent \`sub\` and \`sup\` elements from affecting the line height in
 * all browsers.
 */

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/* Embedded content
   ========================================================================== */

/**
 * Remove the border on images inside links in IE 10.
 */

img {
  border-style: none;
}

/* Forms
   ========================================================================== */

/**
 * 1. Change the font styles in all browsers.
 * 2. Remove the margin in Firefox and Safari.
 */

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-size: 100%; /* 1 */
  line-height: 1.15; /* 1 */
  margin: 0; /* 2 */
}

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */

button,
input { /* 1 */
  overflow: visible;
}

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */

button,
select { /* 1 */
  text-transform: none;
}

/**
 * Correct the inability to style clickable types in iOS and Safari.
 */

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

/**
 * Remove the inner border and padding in Firefox.
 */

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}

/**
 * Restore the focus styles unset by the previous rule.
 */

button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}

/**
 * Correct the padding in Firefox.
 */

fieldset {
  padding: 0.35em 0.75em 0.625em;
}

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from \`fieldset\` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    \`fieldset\` elements in all browsers.
 */

legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}

/**
 * Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */

progress {
  vertical-align: baseline;
}

/**
 * Remove the default vertical scrollbar in IE 10+.
 */

textarea {
  overflow: auto;
}

/**
 * 1. Add the correct box sizing in IE 10.
 * 2. Remove the padding in IE 10.
 */

[type="checkbox"],
[type="radio"] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */

[type="search"] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/**
 * Remove the inner padding in Chrome and Safari on macOS.
 */

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to \`inherit\` in Safari.
 */

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/* Interactive
   ========================================================================== */

/*
 * Add the correct display in Edge, IE 10+, and Firefox.
 */

details {
  display: block;
}

/*
 * Add the correct display in all browsers.
 */

summary {
  display: list-item;
}

/* Misc
   ========================================================================== */

/**
 * Add the correct display in IE 10+.
 */

template {
  display: none;
}

/**
 * Add the correct display in IE 10.
 */

[hidden] {
  display: none;
}

/**
 * Manually forked from SUIT CSS Base: https://github.com/suitcss/base
 * A thin layer on top of normalize.css that provides a starting point more
 * suitable for web applications.
 */

/**
 * Removes the default spacing and border for appropriate elements.
 */

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

button {
  background-color: transparent;
  background-image: none;
}

/**
 * Work around a Firefox/IE bug where the transparent \`button\` background
 * results in a loss of the default \`button\` focus styles.
 */

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

fieldset {
  margin: 0;
  padding: 0;
}

ol,
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

/**
 * Tailwind custom reset styles
 */

/**
 * 1. Use the user's configured \`sans\` font-family (with Tailwind's default
 *    sans-serif font stack as a fallback) as a sane default.
 * 2. Use Tailwind's default "normal" line-height so the user isn't forced
 *    to override it to ensure consistency even when using the default theme.
 */

html {
  font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 1 */
  line-height: 1.5; /* 2 */
}

/**
 * 1. Prevent padding and border from affecting element width.
 *
 *    We used to set this in the html element and inherit from
 *    the parent element for everything else. This caused issues
 *    in shadow-dom-enhanced elements like <details> where the content
 *    is wrapped by a div with box-sizing set to \`content-box\`.
 *
 *    https://github.com/mozdevs/cssremedy/issues/4
 *
 *
 * 2. Allow adding a border to an element by just adding a border-width.
 *
 *    By default, the way the browser specifies that an element should have no
 *    border is by setting it's border-style to \`none\` in the user-agent
 *    stylesheet.
 *
 *    In order to easily add borders to elements by just setting the \`border-width\`
 *    property, we change the default border-style for all elements to \`solid\`, and
 *    use border-width to hide them instead. This way our \`border\` utilities only
 *    need to set the \`border-width\` property instead of the entire \`border\`
 *    shorthand, making our border utilities much more straightforward to compose.
 *
 *    https://github.com/tailwindcss/tailwindcss/pull/116
 */

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #BFBFBF; /* 2 */
}

/*
 * Ensure horizontal rules are visible by default
 */

hr {
  border-top-width: 1px;
}

/**
 * Undo the \`border-style: none\` reset that Normalize applies to images so that
 * our \`border-{width}\` utilities have the expected effect.
 *
 * The Normalize reset is unnecessary for us since we default the border-width
 * to 0 on all elements.
 *
 * https://github.com/tailwindcss/tailwindcss/issues/362
 */

img {
  border-style: solid;
}

textarea {
  resize: vertical;
}

input::placeholder,
textarea::placeholder {
  color: #a0aec0;
}

button,
[role="button"] {
  cursor: pointer;
}

table {
  border-collapse: collapse;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/**
 * Reset links to optimize for opt-in styling instead of
 * opt-out.
 */

a {
  color: inherit;
  text-decoration: inherit;
}

/**
 * Reset form element properties that are easy to forget to
 * style explicitly so you don't inadvertently introduce
 * styles that deviate from your design system. These styles
 * supplement a partial reset that is already applied by
 * normalize.css.
 */

button,
input,
optgroup,
select,
textarea {
  padding: 0;
  line-height: inherit;
  color: inherit;
}

/**
 * Use the configured 'mono' font family for elements that
 * are expected to be rendered with a monospace font, falling
 * back to the system monospace stack if there is no configured
 * 'mono' font family.
 */

pre,
code,
kbd,
samp {
  font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

/**
 * Make replaced elements \`display: block\` by default as that's
 * the behavior you want almost all of the time. Inspired by
 * CSS Remedy, with \`svg\` added as well.
 *
 * https://github.com/mozdevs/cssremedy/issues/14
 */

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block;
  vertical-align: middle;
}

/**
 * Constrain images and videos to the parent width and preserve
 * their instrinsic aspect ratio.
 *
 * https://github.com/mozdevs/cssremedy/issues/14
 */

img,
video {
  max-width: 100%;
  height: auto;
}

/**
 z-indexes used across the app
 Based on: https://intranet.mindmaze.ch/confluence/display/COM/Z-indexes+in+the+webapp
 */

/* Table headers above checkboxes components */

.z-above-checkboxes {
  z-index: 1;
}

/* Vidyo video frame */

.vidyo-rendering-container
.application-grid
.video-container:not(.pinned-video)
.popup-application {
  position: absolute; /* new z stack */
  z-index: 10;
}

/* Program bar */

.z-program-content-frame {
  z-index: 10;
}

.z-program-bar-selected-program {
  z-index: 12;
}

.z-program-bar-action-button {
  z-index: 12;
}

.z-program-bar-gradient {
  z-index: 16;
}

/* Program Schedule */

.z-program-extension {
  z-index: 10;
}

.z-main-slot {
  z-index: 11;
}

.z-available-slots {
  z-index: 12;
}

.z-available-slot-drop-zones {
  z-index: 14;
}

/* Program activity items */

.z-activity-item {
  z-index: 11;
}

.z-program-activity-action-buttons {
  z-index: 12;
}

.z-program-activity-unlicensed-overlay {
  z-index: 19;
}

.z-activity-drop-mask {
  z-index: 19;
}

.z-panel-mask {
  z-index: 19;
}

.z-program-activity-drag-handle {
  z-index: 20;
}

.z-unlicensed-description {
  z-index: 20;
}

/* Pages */

.z-page-header {
  z-index: 20;
}

.z-information-panel {
  z-index: 30;
}

.z-invalid-calibration-information {
  z-index: 21;
}

/**
 @See also: PhoneInput.vue
 */

.z-action-panel {
  z-index: 30;
}

.z-loading-layout {
  z-index: 50;
}

/* Sidebar */

.z-sidebar {
  z-index: 60;
}

.z-expand-collapse-button {
  z-index: 61;
}

.z-entry-callout {
  z-index: 62;
}

.z-sidebar-base-button {
  z-index: 63;
}

.z-sidebar-entry-tooltip {
  z-index: 62;
}

.z-sidebar-close-panel-layer {
  z-index: 65;
}

/* modals */

.modal {
  z-index: 100;
}

.confirm-modal {
  z-index: 100;
}

/* Tooltips */

.tooltip {
  z-index: 110;
}

.tooltip .tooltip-arrow {
  position: absolute; /* new z stack */
  z-index: 1;
}

.z-cookie-bar {
  z-index: 9999;
}

/**
 * Ensure the login modal is above the Material tailwind modals from ePRO
 * Tailwind material modal are using z-index: 9999
 */

.z-login-modal {
  z-index: 10000;
}

/**
 Outdated-browser bar
 @see: src/assets/css/outdated-browser-rework.css
 */

#outdated {
  z-index: 10100 !important;
}

/*----------------------------------------*\\
  ELEMENTS
\\*----------------------------------------*/

html, body {
  font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --text-opacity: 1;
  color: #1F4566;
  color: rgba(31, 69, 102, 1);
  color: rgba(31, 69, 102, var(--text-opacity));
  letter-spacing: 0.01em;
  height: 100%;
  font-size: 14px;
}

body {
  width: 100%;
  /* 45rem == sm screen width in tailwind.css for a root font of 14px  */
  min-width: 45rem;
  overflow-y: scroll;
}

h1,
.text-h1 {
  font-size: 1.85rem;
  line-height: 1.3;
  font-weight: 400;
  --text-opacity: 1;
  color: #1F4566;
  color: rgba(31, 69, 102, 1);
  color: rgba(31, 69, 102, var(--text-opacity));
  letter-spacing: 0.01em;
}

h2,
.text-h2 {
  font-size: 1.42rem;
  line-height: 1.3;
  font-weight: 400;
  --text-opacity: 1;
  color: #1F4566;
  color: rgba(31, 69, 102, 1);
  color: rgba(31, 69, 102, var(--text-opacity));
}

h3,
.text-h3 {
  font-size: 1.15rem;
  line-height: 1.3;
  font-weight: 600;
  --text-opacity: 1;
  color: #1F4566;
  color: rgba(31, 69, 102, 1);
  color: rgba(31, 69, 102, var(--text-opacity));
}

h4,
.text-h4 {
  font-size: 1rem;
  line-height: 1.3;
  font-weight: 600;
  --text-opacity: 1;
  color: #1F4566;
  color: rgba(31, 69, 102, 1);
  color: rgba(31, 69, 102, var(--text-opacity));
}

a,
.text-link {
  --text-opacity: 1;
  color: #37A4DC;
  color: rgba(55, 164, 220, 1);
  color: rgba(55, 164, 220, var(--text-opacity));
  font-weight: 600;
  outline: 2px solid transparent;
  outline-offset: 2px;
  transition: color 300ms;
}

a:hover, .text-link:hover {
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

a:focus, .text-link:focus {
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

.hr-gradient-blue {
  height: 1px;
  border-top-width: 0;
  margin: auto;
  background-image: linear-gradient(to right, var(--gradient-color-stops));
  --gradient-from-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  --gradient-via-color: #37A4DC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  --gradient-to-color: transparent
}

.hr-gradient-orange {
  height: 1px;
  border-top-width: 0;
  margin: auto;
  background-image: linear-gradient(to right, var(--gradient-color-stops));
  --gradient-from-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  --gradient-via-color: #F07313;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  --gradient-to-color: transparent
}

.hr-gradient-gray {
  height: 1px;
  border-top-width: 0;
  margin: auto;
  background-image: linear-gradient(to right, var(--gradient-color-stops));
  --gradient-from-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  --gradient-via-color: #BFBFBF;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  --gradient-to-color: transparent
}

/**
* Description List
*/

dl dt {
    float: left;
    width: 12rem;
  }

dl dd {
    margin-left: calc(1rem + 12rem);
  }

dl dt:not(:first-of-type), dl dd:not(:first-of-type) {
      margin-top: 2rem;
    }

/*----------------------------------------*\\
  FORM
\\*----------------------------------------*/

label {
  display: block;
  margin-top: 1rem;
  --text-opacity: 1;
  color: #1F4566;
  color: rgba(31, 69, 102, 1);
  color: rgba(31, 69, 102, var(--text-opacity));
}

input[type="date"],
input[type="email"],
input[type="file"],
input[type="number"],
input[type="password"],
input[type="search"],
input[type="tel"],
input[type="text"],
input[type="time"],
input[type="url"],
textarea {
  display: block;
  width: 100%;
  font-size: 1rem;
  padding: 0.6em 1em;
  transition: border-color 300ms, color 300ms;
}

input[type="date"]::placeholder, input[type="email"]::placeholder, input[type="file"]::placeholder, input[type="number"]::placeholder, input[type="password"]::placeholder, input[type="search"]::placeholder, input[type="tel"]::placeholder, input[type="text"]::placeholder, input[type="time"]::placeholder, input[type="url"]::placeholder, textarea::placeholder {
    color: rgba(90,98,107,0.8);
    font: inherit;
  }

input[type="date"]:hover, input[type="email"]:hover, input[type="file"]:hover, input[type="number"]:hover, input[type="password"]:hover, input[type="search"]:hover, input[type="tel"]:hover, input[type="text"]:hover, input[type="time"]:hover, input[type="url"]:hover, textarea:hover {
    border-color: rgba(4, 21, 39, 0.8);
  }

input[type="date"]:hover::placeholder, input[type="email"]:hover::placeholder, input[type="file"]:hover::placeholder, input[type="number"]:hover::placeholder, input[type="password"]:hover::placeholder, input[type="search"]:hover::placeholder, input[type="tel"]:hover::placeholder, input[type="text"]:hover::placeholder, input[type="time"]:hover::placeholder, input[type="url"]:hover::placeholder, textarea:hover::placeholder {
      --text-opacity: 1;
      color: #727272;
      color: rgba(114, 114, 114, 1);
      color: rgba(114, 114, 114, var(--text-opacity));
    }

input[type="date"]:focus, input[type="email"]:focus, input[type="file"]:focus, input[type="number"]:focus, input[type="password"]:focus, input[type="search"]:focus, input[type="tel"]:focus, input[type="text"]:focus, input[type="time"]:focus, input[type="url"]:focus, textarea:focus {
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

input.form-input-error[type="date"], input.form-input-error[type="email"], input.form-input-error[type="file"], input.form-input-error[type="number"], input.form-input-error[type="password"], input.form-input-error[type="search"], input.form-input-error[type="tel"], input.form-input-error[type="text"], input.form-input-error[type="time"], input.form-input-error[type="url"], textarea.form-input-error {
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

input.form-input-search[type="date"], input.form-input-search[type="email"], input.form-input-search[type="file"], input.form-input-search[type="number"], input.form-input-search[type="password"], input.form-input-search[type="search"], input.form-input-search[type="tel"], input.form-input-search[type="text"], input.form-input-search[type="time"], input.form-input-search[type="url"], textarea.form-input-search {
    background-color: transparent;
  }

[dir="ltr"] input.form-input-search[type="date"]::placeholder,[dir="ltr"]  input.form-input-search[type="email"]::placeholder,[dir="ltr"]  input.form-input-search[type="file"]::placeholder,[dir="ltr"]  input.form-input-search[type="number"]::placeholder,[dir="ltr"]  input.form-input-search[type="password"]::placeholder,[dir="ltr"]  input.form-input-search[type="search"]::placeholder,[dir="ltr"]  input.form-input-search[type="tel"]::placeholder,[dir="ltr"]  input.form-input-search[type="text"]::placeholder,[dir="ltr"]  input.form-input-search[type="time"]::placeholder,[dir="ltr"]  input.form-input-search[type="url"]::placeholder,[dir="ltr"]  textarea.form-input-search::placeholder{
      padding-right: 1.5rem;
}

[dir="rtl"] input.form-input-search[type="date"]::placeholder,[dir="rtl"]  input.form-input-search[type="email"]::placeholder,[dir="rtl"]  input.form-input-search[type="file"]::placeholder,[dir="rtl"]  input.form-input-search[type="number"]::placeholder,[dir="rtl"]  input.form-input-search[type="password"]::placeholder,[dir="rtl"]  input.form-input-search[type="search"]::placeholder,[dir="rtl"]  input.form-input-search[type="tel"]::placeholder,[dir="rtl"]  input.form-input-search[type="text"]::placeholder,[dir="rtl"]  input.form-input-search[type="time"]::placeholder,[dir="rtl"]  input.form-input-search[type="url"]::placeholder,[dir="rtl"]  textarea.form-input-search::placeholder{
      padding-left: 1.5rem;
}

input.form-input-search[type="date"]::placeholder, input.form-input-search[type="email"]::placeholder, input.form-input-search[type="file"]::placeholder, input.form-input-search[type="number"]::placeholder, input.form-input-search[type="password"]::placeholder, input.form-input-search[type="search"]::placeholder, input.form-input-search[type="tel"]::placeholder, input.form-input-search[type="text"]::placeholder, input.form-input-search[type="time"]::placeholder, input.form-input-search[type="url"]::placeholder, textarea.form-input-search::placeholder {
      --text-opacity: 1;
      color: #727272;
      color: rgba(114, 114, 114, 1);
      color: rgba(114, 114, 114, var(--text-opacity));
    }

select {
  margin-top: 0.5rem;
}

select:hover {
    border-color: rgba(4, 21, 39, 0.8);
  }

select:focus {
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

option {
  --text-opacity: 1;
  color: #000;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--text-opacity));
  --bg-opacity: 1;
  background-color: #fff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
}

/*----------------------------------------*\\
  TABLE BASE
\\*----------------------------------------*/

table {
  width: 100%;
  position: relative;
  --bg-opacity: 1;
  background-color: #fff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
  border-radius: .375rem;
}

td,
th {
  padding: 0.5rem;
  font-weight: 400;
  text-align: left;
  height: 40px;
  max-width: 160px;
  min-width: 80px;
}

td.is-small, th.is-small {
    width: 80px;
  }

[dir="rtl"] td,
[dir="rtl"] th {
  text-align: right;
}

th > svg {
  display: inline-block;
  float: right;
  margin-top: 0.5rem;
}

[dir="rtl"] th > svg {
  float: left;
}

th {
  /* applies .z-above-checkboxes
   but applying a custom class is not reliable at this level,
   and can fail on reload sometimes, so we apply the base style.
  */
  z-index: 1;
  --text-opacity: 1;
  color: #041527;
  color: rgba(4, 21, 39, 1);
  color: rgba(4, 21, 39, var(--text-opacity));
  --border-opacity: 1;
  border-color: #BFBFBF;
  border-color: rgba(191, 191, 191, var(--border-opacity));
  /* 
    Make the table rounded on top.
    Works only or Chrome, as Firefox needs to apply that on thead and tbody but doesn't support it
  */
}

th:first-child {
    border-top-left-radius: .375rem;
  }

th:last-child {
    border-top-right-radius: .375rem;
  }

th {
  /* Table sticky headers must be applied on th/tr */
  /* https://css-tricks.com/position-sticky-and-table-headers/ */
  --bg-opacity: 1;
  background-color: #fff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
  position: sticky;
  top: 0;
  /* Only works on Firefox, Chrome doesn't apply margin between box-shadow on th */
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  /* Safari, placed last in case of parsing issues, as seen on Chrome */
  position: -webkit-sticky;
}

td {
  --text-opacity: 1;
  color: #727272;
  color: rgba(114, 114, 114, 1);
  color: rgba(114, 114, 114, var(--text-opacity));
  --border-opacity: 1;
  border-color: #E0E2E4;
  border-color: rgba(224, 226, 228, var(--border-opacity));
  border-top-width: 1px;
  border-bottom-width: 1px;
}

th > svg {
  --text-opacity: 1;
  color: #37A4DC;
  color: rgba(55, 164, 220, 1);
  color: rgba(55, 164, 220, var(--text-opacity));
  margin-top: 0.25rem;
  height: 18px;
}

/*----------------------------------------*\\
  PAGES
\\*----------------------------------------*/

/* basic full page */

.site-page {
  padding-top: 2rem;
  padding-bottom: 2rem;
  padding-left: 3rem;
  padding-right: 3rem;
}

/**
* Objects
*/

/* ----------------------------------------*\\
  CONTAINER
\\* ---------------------------------------- */

.container-2xs {
  max-width: 32rem;
  margin-left: auto;
  margin-right: auto;
}

.container-xs {
  max-width: 36rem;
  margin-left: auto;
  margin-right: auto;
}

.container-sm {
  max-width: 48rem;
  margin-left: auto;
  margin-right: auto;
}

.container-md {
  max-width: 64rem;
  margin-left: auto;
  margin-right: auto;
}

.container-lg {
  max-width: 92rem;
  margin-left: auto;
  margin-right: auto;
}

.container-lg-left-align {
  max-width: 92rem;
}

.container-xl {
  max-width: 130rem;
  margin-left: auto;
  margin-right: auto;
}

/*----------------------------------------*\\
  EDITOR
\\*----------------------------------------*/

.editor h1,
  .editor h2,
  .editor h3,
  .editor h4,
  .editor h5,
  .editor h6 {
    margin-top: 2rem;
    margin-bottom: 1rem;
  }

.editor p {
    margin-top: 1rem;
  }

.editor p + p {
      margin-top: 0.5rem;
    }

/*----------------------------------------*\\
  MindMaze Grid class
\\*----------------------------------------*/

.mm-grid {
  display: flex;
  flex-wrap: wrap;
  margin-left: -1rem;
  margin-right: -1rem;
  overflow: hidden;
}

.mm-grid.mm-grid-tight {
    margin-left: 0;
    margin-right: 0;
  }

.mm-grid.mm-grid-tight > .mm-grid-col {
      padding-left: 0;
      padding-right: 0;
    }

.mm-grid.mm-grid-wide {
    margin-left: -2rem;
    margin-right: -2rem;
  }

.mm-grid.mm-grid-wide > .mm-grid-col {
      padding-left: 2rem;
      padding-right: 2rem;
    }

.mm-grid.mm-grid-wider {
    margin-left: -3rem;
    margin-right: -3rem;
  }

.mm-grid.mm-grid-wider > .mm-grid-col {
      padding-left: 3rem;
      padding-right: 3rem;
    }

[dir="ltr"] .mm-grid.mm-grid-separator .mm-grid-col:not(:first-child){
      border-left-width: 1px;
}

[dir="rtl"] .mm-grid.mm-grid-separator .mm-grid-col:not(:first-child){
      border-right-width: 1px;
}

.mm-grid-col {
  padding-left: 1rem;
  padding-right: 1rem;
}

.mm-nav li{
    font-weight:bold;
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

.mm-nav li:hover,
    .mm-nav li.active {
      --text-opacity: 1;
      color: #041527;
      color: rgba(4, 21, 39, 1);
      color: rgba(4, 21, 39, var(--text-opacity));
    }

.mm-radio label{
    border-radius: .375rem;
    padding: 1rem;
    border-width: 1px;
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

.mm-radio label.checked{
      --bg-opacity: 1;
      background-color: #CCE6F5;
      background-color: rgba(204, 230, 245, var(--bg-opacity));
      --text-opacity: 1;
      color: #1F4566;
      color: rgba(31, 69, 102, 1);
      color: rgba(31, 69, 102, var(--text-opacity));
    }

.mm-radio input[type="radio"]
  {
    -webkit-appearance: none;
            appearance: none;
  }

/**
* Components
*/

.form-input{
  -webkit-appearance: none;
          appearance: none;
  background-color: #fff;
  border-color: #BFBFBF;
  border-width: 1px;
  border-radius: .375rem;
  padding-top: 0;
  padding-right: 0;
  padding-bottom: 0;
  padding-left: 0;
  font-size: 1rem;
  line-height: 1.5;
}

.form-input::placeholder{
  opacity: 1;
}

.form-input:focus{
  outline: none;
}

.form-textarea{
  -webkit-appearance: none;
          appearance: none;
  background-color: #fff;
  border-color: #BFBFBF;
  border-width: 1px;
  border-radius: .375rem;
  padding-top: 0;
  padding-right: 0;
  padding-bottom: 0;
  padding-left: 0;
  font-size: 1rem;
  line-height: 1.5;
}

.form-textarea::placeholder{
  opacity: 1;
}

.form-textarea:focus{
  outline: none;
}

.form-multiselect{
  -webkit-appearance: none;
          appearance: none;
  background-color: #fff;
  border-color: #BFBFBF;
  border-width: 1px;
  border-radius: .375rem;
  padding-top: 0.5rem;
  padding-right: 0.75rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
}

.form-multiselect:focus{
  outline: none;
}

.form-multiselect::placeholder{
}

.form-select{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  -webkit-appearance: none;
          appearance: none;
  -webkit-print-color-adjust: exact;
          color-adjust: exact;
  background-repeat: no-repeat;
  background-color: #fff;
  border-color: #BFBFBF;
  border-width: 1px;
  border-radius: .375rem;
  padding-top: 0.5rem;
  padding-right: 2.5rem;
  padding-bottom: 0.5rem;
  padding-left: 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  background-position: right 0.5rem center;
  background-size: 1.5em 1.5em;
}

.form-select::-ms-expand{
  color: #a0aec0;
  border: none;
}

@media not print{
  .form-select::-ms-expand{
    display: none;
  }
}

@media print and (-ms-high-contrast: active), print and (-ms-high-contrast: none){
  .form-select{
    padding-right: 0.75rem;
  }
}

.form-select:focus{
  outline: none;
}

.form-select::placeholder{
}

.form-checkbox:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

@media not print{
  .form-checkbox::-ms-check{
    border-width: 1px;
    color: transparent;
    background: inherit;
    border-color: inherit;
    border-radius: inherit;
  }
}

.form-checkbox{
  -webkit-appearance: none;
          appearance: none;
  -webkit-print-color-adjust: exact;
          color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  height: 1em;
  width: 1em;
  color: #4299e1;
  background-color: #fff;
  border-color: #e2e8f0;
  border-width: 1px;
  border-radius: 0.25rem;
}

.form-checkbox:focus{
  outline: none;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  border-color: #63b3ed;
}

.form-radio:checked{
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

@media not print{
  .form-radio::-ms-check{
    border-width: 1px;
    color: transparent;
    background: inherit;
    border-color: inherit;
    border-radius: inherit;
  }
}

.form-radio{
  -webkit-appearance: none;
          appearance: none;
  -webkit-print-color-adjust: exact;
          color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
          user-select: none;
  flex-shrink: 0;
  border-radius: 100%;
  height: 1em;
  width: 1em;
  color: #4299e1;
  background-color: #fff;
  border-color: #e2e8f0;
  border-width: 1px;
}

.form-radio:focus{
  outline: none;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.5);
  border-color: #63b3ed;
}

.prose{
  color: #4a5568;
  max-width: 65ch;
}

.prose [class~="lead"]{
  color: #4a5568;
  font-size: 1.25em;
  line-height: 1.6;
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}

.prose a{
  color: #1a202c;
  text-decoration: underline;
}

.prose strong{
  color: #1a202c;
  font-weight: 600;
}

.prose ol{
  counter-reset: list-counter;
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}

.prose ol > li{
  position: relative;
  counter-increment: list-counter;
  padding-left: 1.75em;
}

.prose ol > li::before{
  content: ;
  position: absolute;
  font-weight: 400;
  color: #718096;
}

.prose ul > li{
  position: relative;
  padding-left: 1.75em;
}

.prose ul > li::before{
  content: "";
  position: absolute;
  background-color: #cbd5e0;
  border-radius: 50%;
  width: 0.375em;
  height: 0.375em;
  top: calc(0.875em - 0.1875em);
  left: 0.25em;
}

.prose hr{
  border-color: #e2e8f0;
  border-top-width: 1px;
  margin-top: 3em;
  margin-bottom: 3em;
}

.prose blockquote{
  font-weight: 500;
  font-style: italic;
  color: #1a202c;
  border-left-width: 0.25rem;
  border-left-color: #e2e8f0;
  quotes: "\\201C""\\201D""\\2018""\\2019";
  margin-top: 1.6em;
  margin-bottom: 1.6em;
  padding-left: 1em;
}

.prose blockquote p:first-of-type::before{
  content: open-quote;
}

.prose blockquote p:last-of-type::after{
  content: close-quote;
}

.prose h1{
  color: #1a202c;
  font-weight: 800;
  font-size: 2.25em;
  margin-top: 0;
  margin-bottom: 0.8888889em;
  line-height: 1.1111111;
}

.prose h2{
  color: #1a202c;
  font-weight: 700;
  font-size: 1.5em;
  margin-top: 2em;
  margin-bottom: 1em;
  line-height: 1.3333333;
}

.prose h3{
  color: #1a202c;
  font-weight: 600;
  font-size: 1.25em;
  margin-top: 1.6em;
  margin-bottom: 0.6em;
  line-height: 1.6;
}

.prose h4{
  color: #1a202c;
  font-weight: 600;
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  line-height: 1.5;
}

.prose figure figcaption{
  color: #718096;
  font-size: 0.875em;
  line-height: 1.4285714;
  margin-top: 0.8571429em;
}

.prose code{
  color: #1a202c;
  font-weight: 600;
  font-size: 0.875em;
}

.prose code::before{
  content: "\`";
}

.prose code::after{
  content: "\`";
}

.prose pre{
  color: #e2e8f0;
  background-color: #2d3748;
  overflow-x: auto;
  font-size: 0.875em;
  line-height: 1.7142857;
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
  border-radius: 0.375rem;
  padding-top: 0.8571429em;
  padding-right: 1.1428571em;
  padding-bottom: 0.8571429em;
  padding-left: 1.1428571em;
}

.prose pre code{
  background-color: transparent;
  border-width: 0;
  border-radius: 0;
  padding: 0;
  font-weight: 400;
  color: inherit;
  font-size: inherit;
  font-family: inherit;
  line-height: inherit;
}

.prose pre code::before{
  content: "";
}

.prose pre code::after{
  content: "";
}

.prose table{
  width: 100%;
  table-layout: auto;
  text-align: left;
  margin-top: 2em;
  margin-bottom: 2em;
  font-size: 0.875em;
  line-height: 1.7142857;
}

.prose thead{
  color: #1a202c;
  font-weight: 600;
  border-bottom-width: 1px;
  border-bottom-color: #cbd5e0;
}

.prose thead th{
  vertical-align: bottom;
  padding-right: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-left: 0.5714286em;
}

.prose tbody tr{
  border-bottom-width: 1px;
  border-bottom-color: #e2e8f0;
}

.prose tbody tr:last-child{
  border-bottom-width: 0;
}

.prose tbody td{
  vertical-align: top;
  padding-top: 0.5714286em;
  padding-right: 0.5714286em;
  padding-bottom: 0.5714286em;
  padding-left: 0.5714286em;
}

.prose{
  font-size: 1rem;
  line-height: 1.75;
}

.prose p{
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}

.prose img{
  margin-top: 2em;
  margin-bottom: 2em;
}

.prose video{
  margin-top: 2em;
  margin-bottom: 2em;
}

.prose figure{
  margin-top: 2em;
  margin-bottom: 2em;
}

.prose figure > *{
  margin-top: 0;
  margin-bottom: 0;
}

.prose h2 code{
  font-size: 0.875em;
}

.prose h3 code{
  font-size: 0.9em;
}

.prose ul{
  margin-top: 1.25em;
  margin-bottom: 1.25em;
}

.prose li{
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.prose ol > li:before{
  left: 0;
}

.prose > ul > li p{
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}

.prose > ul > li > *:first-child{
  margin-top: 1.25em;
}

.prose > ul > li > *:last-child{
  margin-bottom: 1.25em;
}

.prose > ol > li > *:first-child{
  margin-top: 1.25em;
}

.prose > ol > li > *:last-child{
  margin-bottom: 1.25em;
}

.prose ul ul, .prose ul ol, .prose ol ul, .prose ol ol{
  margin-top: 0.75em;
  margin-bottom: 0.75em;
}

.prose hr + *{
  margin-top: 0;
}

.prose h2 + *{
  margin-top: 0;
}

.prose h3 + *{
  margin-top: 0;
}

.prose h4 + *{
  margin-top: 0;
}

.prose thead th:first-child{
  padding-left: 0;
}

.prose thead th:last-child{
  padding-right: 0;
}

.prose tbody td:first-child{
  padding-left: 0;
}

.prose tbody td:last-child{
  padding-right: 0;
}

.prose > :first-child{
  margin-top: 0;
}

.prose > :last-child{
  margin-bottom: 0;
}

.prose-sm{
  font-size: 0.875rem;
  line-height: 1.7142857;
}

.prose-sm p{
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
}

.prose-sm [class~="lead"]{
  font-size: 1.2857143em;
  line-height: 1.5555556;
  margin-top: 0.8888889em;
  margin-bottom: 0.8888889em;
}

.prose-sm blockquote{
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
  padding-left: 1.1111111em;
}

.prose-sm h1{
  font-size: 2.1428571em;
  margin-top: 0;
  margin-bottom: 0.8em;
  line-height: 1.2;
}

.prose-sm h2{
  font-size: 1.4285714em;
  margin-top: 1.6em;
  margin-bottom: 0.8em;
  line-height: 1.4;
}

.prose-sm h3{
  font-size: 1.2857143em;
  margin-top: 1.5555556em;
  margin-bottom: 0.4444444em;
  line-height: 1.5555556;
}

.prose-sm h4{
  margin-top: 1.4285714em;
  margin-bottom: 0.5714286em;
  line-height: 1.4285714;
}

.prose-sm img{
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}

.prose-sm video{
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}

.prose-sm figure{
  margin-top: 1.7142857em;
  margin-bottom: 1.7142857em;
}

.prose-sm figure > *{
  margin-top: 0;
  margin-bottom: 0;
}

.prose-sm figure figcaption{
  font-size: 0.8571429em;
  line-height: 1.3333333;
  margin-top: 0.6666667em;
}

.prose-sm code{
  font-size: 0.8571429em;
}

.prose-sm h2 code{
  font-size: 0.9em;
}

.prose-sm h3 code{
  font-size: 0.8888889em;
}

.prose-sm pre{
  font-size: 0.8571429em;
  line-height: 1.6666667;
  margin-top: 1.6666667em;
  margin-bottom: 1.6666667em;
  border-radius: 0.25rem;
  padding-top: 0.6666667em;
  padding-right: 1em;
  padding-bottom: 0.6666667em;
  padding-left: 1em;
}

.prose-sm ol{
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
}

.prose-sm ul{
  margin-top: 1.1428571em;
  margin-bottom: 1.1428571em;
}

.prose-sm li{
  margin-top: 0.2857143em;
  margin-bottom: 0.2857143em;
}

.prose-sm ol > li{
  padding-left: 1.5714286em;
}

.prose-sm ol > li:before{
  left: 0;
}

.prose-sm ul > li{
  padding-left: 1.5714286em;
}

.prose-sm ul > li::before{
  height: 0.3571429em;
  width: 0.3571429em;
  top: calc(0.8571429em - 0.1785714em);
  left: 0.2142857em;
}

.prose-sm > ul > li p{
  margin-top: 0.5714286em;
  margin-bottom: 0.5714286em;
}

.prose-sm > ul > li > *:first-child{
  margin-top: 1.1428571em;
}

.prose-sm > ul > li > *:last-child{
  margin-bottom: 1.1428571em;
}

.prose-sm > ol > li > *:first-child{
  margin-top: 1.1428571em;
}

.prose-sm > ol > li > *:last-child{
  margin-bottom: 1.1428571em;
}

.prose-sm ul ul, .prose-sm ul ol, .prose-sm ol ul, .prose-sm ol ol{
  margin-top: 0.5714286em;
  margin-bottom: 0.5714286em;
}

.prose-sm hr{
  margin-top: 2.8571429em;
  margin-bottom: 2.8571429em;
}

.prose-sm hr + *{
  margin-top: 0;
}

.prose-sm h2 + *{
  margin-top: 0;
}

.prose-sm h3 + *{
  margin-top: 0;
}

.prose-sm h4 + *{
  margin-top: 0;
}

.prose-sm table{
  font-size: 0.8571429em;
  line-height: 1.5;
}

.prose-sm thead th{
  padding-right: 1em;
  padding-bottom: 0.6666667em;
  padding-left: 1em;
}

.prose-sm thead th:first-child{
  padding-left: 0;
}

.prose-sm thead th:last-child{
  padding-right: 0;
}

.prose-sm tbody td{
  padding-top: 0.6666667em;
  padding-right: 1em;
  padding-bottom: 0.6666667em;
  padding-left: 1em;
}

.prose-sm tbody td:first-child{
  padding-left: 0;
}

.prose-sm tbody td:last-child{
  padding-right: 0;
}

.prose-sm > :first-child{
  margin-top: 0;
}

.prose-sm > :last-child{
  margin-bottom: 0;
}

.prose-lg{
  font-size: 1.125rem;
  line-height: 1.7777778;
}

.prose-lg p{
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}

.prose-lg [class~="lead"]{
  font-size: 1.2222222em;
  line-height: 1.4545455;
  margin-top: 1.0909091em;
  margin-bottom: 1.0909091em;
}

.prose-lg blockquote{
  margin-top: 1.6666667em;
  margin-bottom: 1.6666667em;
  padding-left: 1em;
}

.prose-lg h1{
  font-size: 2.6666667em;
  margin-top: 0;
  margin-bottom: 0.8333333em;
  line-height: 1;
}

.prose-lg h2{
  font-size: 1.6666667em;
  margin-top: 1.8666667em;
  margin-bottom: 1.0666667em;
  line-height: 1.3333333;
}

.prose-lg h3{
  font-size: 1.3333333em;
  margin-top: 1.6666667em;
  margin-bottom: 0.6666667em;
  line-height: 1.5;
}

.prose-lg h4{
  margin-top: 1.7777778em;
  margin-bottom: 0.4444444em;
  line-height: 1.5555556;
}

.prose-lg img{
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}

.prose-lg video{
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}

.prose-lg figure{
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
}

.prose-lg figure > *{
  margin-top: 0;
  margin-bottom: 0;
}

.prose-lg figure figcaption{
  font-size: 0.8888889em;
  line-height: 1.5;
  margin-top: 1em;
}

.prose-lg code{
  font-size: 0.8888889em;
}

.prose-lg h2 code{
  font-size: 0.8666667em;
}

.prose-lg h3 code{
  font-size: 0.875em;
}

.prose-lg pre{
  font-size: 0.8888889em;
  line-height: 1.75;
  margin-top: 2em;
  margin-bottom: 2em;
  border-radius: 0.375rem;
  padding-top: 1em;
  padding-right: 1.5em;
  padding-bottom: 1em;
  padding-left: 1.5em;
}

.prose-lg ol{
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}

.prose-lg ul{
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}

.prose-lg li{
  margin-top: 0.6666667em;
  margin-bottom: 0.6666667em;
}

.prose-lg ol > li{
  padding-left: 1.6666667em;
}

.prose-lg ol > li:before{
  left: 0;
}

.prose-lg ul > li{
  padding-left: 1.6666667em;
}

.prose-lg ul > li::before{
  width: 0.3333333em;
  height: 0.3333333em;
  top: calc(0.8888889em - 0.1666667em);
  left: 0.2222222em;
}

.prose-lg > ul > li p{
  margin-top: 0.8888889em;
  margin-bottom: 0.8888889em;
}

.prose-lg > ul > li > *:first-child{
  margin-top: 1.3333333em;
}

.prose-lg > ul > li > *:last-child{
  margin-bottom: 1.3333333em;
}

.prose-lg > ol > li > *:first-child{
  margin-top: 1.3333333em;
}

.prose-lg > ol > li > *:last-child{
  margin-bottom: 1.3333333em;
}

.prose-lg ul ul, .prose-lg ul ol, .prose-lg ol ul, .prose-lg ol ol{
  margin-top: 0.8888889em;
  margin-bottom: 0.8888889em;
}

.prose-lg hr{
  margin-top: 3.1111111em;
  margin-bottom: 3.1111111em;
}

.prose-lg hr + *{
  margin-top: 0;
}

.prose-lg h2 + *{
  margin-top: 0;
}

.prose-lg h3 + *{
  margin-top: 0;
}

.prose-lg h4 + *{
  margin-top: 0;
}

.prose-lg table{
  font-size: 0.8888889em;
  line-height: 1.5;
}

.prose-lg thead th{
  padding-right: 0.75em;
  padding-bottom: 0.75em;
  padding-left: 0.75em;
}

.prose-lg thead th:first-child{
  padding-left: 0;
}

.prose-lg thead th:last-child{
  padding-right: 0;
}

.prose-lg tbody td{
  padding-top: 0.75em;
  padding-right: 0.75em;
  padding-bottom: 0.75em;
  padding-left: 0.75em;
}

.prose-lg tbody td:first-child{
  padding-left: 0;
}

.prose-lg tbody td:last-child{
  padding-right: 0;
}

.prose-lg > :first-child{
  margin-top: 0;
}

.prose-lg > :last-child{
  margin-bottom: 0;
}

.prose-xl{
  font-size: 1.25rem;
  line-height: 1.8;
}

.prose-xl p{
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}

.prose-xl [class~="lead"]{
  font-size: 1.2em;
  line-height: 1.5;
  margin-top: 1em;
  margin-bottom: 1em;
}

.prose-xl blockquote{
  margin-top: 1.6em;
  margin-bottom: 1.6em;
  padding-left: 1.0666667em;
}

.prose-xl h1{
  font-size: 2.8em;
  margin-top: 0;
  margin-bottom: 0.8571429em;
  line-height: 1;
}

.prose-xl h2{
  font-size: 1.8em;
  margin-top: 1.5555556em;
  margin-bottom: 0.8888889em;
  line-height: 1.1111111;
}

.prose-xl h3{
  font-size: 1.5em;
  margin-top: 1.6em;
  margin-bottom: 0.6666667em;
  line-height: 1.3333333;
}

.prose-xl h4{
  margin-top: 1.8em;
  margin-bottom: 0.6em;
  line-height: 1.6;
}

.prose-xl img{
  margin-top: 2em;
  margin-bottom: 2em;
}

.prose-xl video{
  margin-top: 2em;
  margin-bottom: 2em;
}

.prose-xl figure{
  margin-top: 2em;
  margin-bottom: 2em;
}

.prose-xl figure > *{
  margin-top: 0;
  margin-bottom: 0;
}

.prose-xl figure figcaption{
  font-size: 0.9em;
  line-height: 1.5555556;
  margin-top: 1em;
}

.prose-xl code{
  font-size: 0.9em;
}

.prose-xl h2 code{
  font-size: 0.8611111em;
}

.prose-xl h3 code{
  font-size: 0.9em;
}

.prose-xl pre{
  font-size: 0.9em;
  line-height: 1.7777778;
  margin-top: 2em;
  margin-bottom: 2em;
  border-radius: 0.5rem;
  padding-top: 1.1111111em;
  padding-right: 1.3333333em;
  padding-bottom: 1.1111111em;
  padding-left: 1.3333333em;
}

.prose-xl ol{
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}

.prose-xl ul{
  margin-top: 1.2em;
  margin-bottom: 1.2em;
}

.prose-xl li{
  margin-top: 0.6em;
  margin-bottom: 0.6em;
}

.prose-xl ol > li{
  padding-left: 1.8em;
}

.prose-xl ol > li:before{
  left: 0;
}

.prose-xl ul > li{
  padding-left: 1.8em;
}

.prose-xl ul > li::before{
  width: 0.35em;
  height: 0.35em;
  top: calc(0.9em - 0.175em);
  left: 0.25em;
}

.prose-xl > ul > li p{
  margin-top: 0.8em;
  margin-bottom: 0.8em;
}

.prose-xl > ul > li > *:first-child{
  margin-top: 1.2em;
}

.prose-xl > ul > li > *:last-child{
  margin-bottom: 1.2em;
}

.prose-xl > ol > li > *:first-child{
  margin-top: 1.2em;
}

.prose-xl > ol > li > *:last-child{
  margin-bottom: 1.2em;
}

.prose-xl ul ul, .prose-xl ul ol, .prose-xl ol ul, .prose-xl ol ol{
  margin-top: 0.8em;
  margin-bottom: 0.8em;
}

.prose-xl hr{
  margin-top: 2.8em;
  margin-bottom: 2.8em;
}

.prose-xl hr + *{
  margin-top: 0;
}

.prose-xl h2 + *{
  margin-top: 0;
}

.prose-xl h3 + *{
  margin-top: 0;
}

.prose-xl h4 + *{
  margin-top: 0;
}

.prose-xl table{
  font-size: 0.9em;
  line-height: 1.5555556;
}

.prose-xl thead th{
  padding-right: 0.6666667em;
  padding-bottom: 0.8888889em;
  padding-left: 0.6666667em;
}

.prose-xl thead th:first-child{
  padding-left: 0;
}

.prose-xl thead th:last-child{
  padding-right: 0;
}

.prose-xl tbody td{
  padding-top: 0.8888889em;
  padding-right: 0.6666667em;
  padding-bottom: 0.8888889em;
  padding-left: 0.6666667em;
}

.prose-xl tbody td:first-child{
  padding-left: 0;
}

.prose-xl tbody td:last-child{
  padding-right: 0;
}

.prose-xl > :first-child{
  margin-top: 0;
}

.prose-xl > :last-child{
  margin-bottom: 0;
}

.prose-2xl{
  font-size: 1.5rem;
  line-height: 1.6666667;
}

.prose-2xl p{
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}

.prose-2xl [class~="lead"]{
  font-size: 1.25em;
  line-height: 1.4666667;
  margin-top: 1.0666667em;
  margin-bottom: 1.0666667em;
}

.prose-2xl blockquote{
  margin-top: 1.7777778em;
  margin-bottom: 1.7777778em;
  padding-left: 1.1111111em;
}

.prose-2xl h1{
  font-size: 2.6666667em;
  margin-top: 0;
  margin-bottom: 0.875em;
  line-height: 1;
}

.prose-2xl h2{
  font-size: 2em;
  margin-top: 1.5em;
  margin-bottom: 0.8333333em;
  line-height: 1.0833333;
}

.prose-2xl h3{
  font-size: 1.5em;
  margin-top: 1.5555556em;
  margin-bottom: 0.6666667em;
  line-height: 1.2222222;
}

.prose-2xl h4{
  margin-top: 1.6666667em;
  margin-bottom: 0.6666667em;
  line-height: 1.5;
}

.prose-2xl img{
  margin-top: 2em;
  margin-bottom: 2em;
}

.prose-2xl video{
  margin-top: 2em;
  margin-bottom: 2em;
}

.prose-2xl figure{
  margin-top: 2em;
  margin-bottom: 2em;
}

.prose-2xl figure > *{
  margin-top: 0;
  margin-bottom: 0;
}

.prose-2xl figure figcaption{
  font-size: 0.8333333em;
  line-height: 1.6;
  margin-top: 1em;
}

.prose-2xl code{
  font-size: 0.8333333em;
}

.prose-2xl h2 code{
  font-size: 0.875em;
}

.prose-2xl h3 code{
  font-size: 0.8888889em;
}

.prose-2xl pre{
  font-size: 0.8333333em;
  line-height: 1.8;
  margin-top: 2em;
  margin-bottom: 2em;
  border-radius: 0.5rem;
  padding-top: 1.2em;
  padding-right: 1.6em;
  padding-bottom: 1.2em;
  padding-left: 1.6em;
}

.prose-2xl ol{
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}

.prose-2xl ul{
  margin-top: 1.3333333em;
  margin-bottom: 1.3333333em;
}

.prose-2xl li{
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.prose-2xl ol > li{
  padding-left: 1.6666667em;
}

.prose-2xl ol > li:before{
  left: 0;
}

.prose-2xl ul > li{
  padding-left: 1.6666667em;
}

.prose-2xl ul > li::before{
  width: 0.3333333em;
  height: 0.3333333em;
  top: calc(0.8333333em - 0.1666667em);
  left: 0.25em;
}

.prose-2xl > ul > li p{
  margin-top: 0.8333333em;
  margin-bottom: 0.8333333em;
}

.prose-2xl > ul > li > *:first-child{
  margin-top: 1.3333333em;
}

.prose-2xl > ul > li > *:last-child{
  margin-bottom: 1.3333333em;
}

.prose-2xl > ol > li > *:first-child{
  margin-top: 1.3333333em;
}

.prose-2xl > ol > li > *:last-child{
  margin-bottom: 1.3333333em;
}

.prose-2xl ul ul, .prose-2xl ul ol, .prose-2xl ol ul, .prose-2xl ol ol{
  margin-top: 0.6666667em;
  margin-bottom: 0.6666667em;
}

.prose-2xl hr{
  margin-top: 3em;
  margin-bottom: 3em;
}

.prose-2xl hr + *{
  margin-top: 0;
}

.prose-2xl h2 + *{
  margin-top: 0;
}

.prose-2xl h3 + *{
  margin-top: 0;
}

.prose-2xl h4 + *{
  margin-top: 0;
}

.prose-2xl table{
  font-size: 0.8333333em;
  line-height: 1.4;
}

.prose-2xl thead th{
  padding-right: 0.6em;
  padding-bottom: 0.8em;
  padding-left: 0.6em;
}

.prose-2xl thead th:first-child{
  padding-left: 0;
}

.prose-2xl thead th:last-child{
  padding-right: 0;
}

.prose-2xl tbody td{
  padding-top: 0.8em;
  padding-right: 0.6em;
  padding-bottom: 0.8em;
  padding-left: 0.6em;
}

.prose-2xl tbody td:first-child{
  padding-left: 0;
}

.prose-2xl tbody td:last-child{
  padding-right: 0;
}

.prose-2xl > :first-child{
  margin-top: 0;
}

.prose-2xl > :last-child{
  margin-bottom: 0;
}

/*----------------------------------------*\\
  BADGE
\\*----------------------------------------*/

.badge {
  display: inline-block;
  padding-left: 0.75rem;
  padding-right: 0.75rem;
  --text-opacity: 1;
  color: #000;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--text-opacity));
  font-size: 0.86rem;
  line-height: 1.6;
  --bg-opacity: 1;
  background-color: #E0E2E4;
  background-color: rgba(224, 226, 228, var(--bg-opacity));
  border-radius: .75rem;
}

.new-badge {
  display: inline-block;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  --text-opacity: 1;
  color: #b86814;
  color: rgba(184, 104, 20, 1);
  color: rgba(184, 104, 20, var(--text-opacity));
  font-size: 0.74rem;
  font-weight: 700;
  font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  line-height: 1.6;
  --bg-opacity: 1;
  background-color: #f6c66f;
  background-color: rgba(246, 198, 111, var(--bg-opacity));
  border-radius: .75rem;
}

.badge-ok {
  display: inline-block;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  --text-opacity: 1;
  color: #3e7211;
  color: rgba(62, 114, 17, 1);
  color: rgba(62, 114, 17, var(--text-opacity));
  font-size: 0.74rem;
  font-weight: 700;
  font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  line-height: 1.6;
  border-width: 1px;
  --border-opacity: 1;
  border-color: #3e7211;
  border-color: rgba(62, 114, 17, var(--border-opacity));
  border-radius: .75rem;
}

.badge-error {
  display: inline-block;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  --text-opacity: 1;
  color: #A23C24;
  color: rgba(162, 60, 36, 1);
  color: rgba(162, 60, 36, var(--text-opacity));
  font-size: 0.74rem;
  font-weight: 700;
  font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  line-height: 1.6;
  border-width: 1px;
  --border-opacity: 1;
  border-color: #A23C24;
  border-color: rgba(162, 60, 36, var(--border-opacity));
  border-radius: .75rem;
}

.badge-warning {
  display: inline-block;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  --text-opacity: 1;
  color: #1F4566;
  color: rgba(31, 69, 102, 1);
  color: rgba(31, 69, 102, var(--text-opacity));
  font-size: 0.74rem;
  font-weight: 600;
  font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  line-height: 1.6;
  border-width: 1px;
  --bg-opacity: 1;
  background-color: #fdf0ea;
  background-color: rgba(253, 240, 234, var(--bg-opacity));
  --border-opacity: 1;
  border-color: #db5d0c;
  border-color: rgba(219, 93, 12, var(--border-opacity));
  border-radius: .75rem;
}

/*----------------------------------------*\\
  Buttons
\\*----------------------------------------*/

button,
.btn {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  font-size: 1.15rem;
  font-weight: 600;
  background-color: transparent;
  --text-opacity: 1;
  color: #37A4DC;
  color: rgba(55, 164, 220, 1);
  color: rgba(55, 164, 220, var(--text-opacity));
  border-width: 1px;
  border-color: transparent;
  border-radius: .375rem;
  cursor: pointer;
  transition: color 300ms, background-color 300ms;
}

button:hover,
  .btn:hover,
  button:active,
  .btn:active,
  button.hover,
  .btn.hover,
  button.active,
  .btn.active {
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

button:focus,
  .btn:focus,
  button.focus,
  .btn.focus {
    outline: 2px solid transparent;
    outline-offset: 2px;
  }

button[disabled="disabled"],
  .btn[disabled="disabled"],
  button.disabled,
  .btn.disabled {
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
    cursor: not-allowed;
  }

button[disabled="disabled"] > .svg-icon, .btn[disabled="disabled"] > .svg-icon, button.disabled > .svg-icon, .btn.disabled > .svg-icon {
      flex-shrink: 0;
      --text-opacity: 1;
      color: #E0E2E4;
      color: rgba(224, 226, 228, 1);
      color: rgba(224, 226, 228, var(--text-opacity));
    }

button[disabled="disabled"] > span, .btn[disabled="disabled"] > span, button.disabled > span, .btn.disabled > span {
      flex-shrink: 0;
    }

button[disabled="disabled"] > div, .btn[disabled="disabled"] > div, button.disabled > div, .btn.disabled > div {
      flex-shrink: 0;
    }

.btn-bare {
  padding: 0;
  margin: 0;
  border-style: none;
  border-radius: 0;
}

.btn-icon {
  padding: 0;
  margin: 0;
}

.btn-sm {
  font-size: 1rem;
}

.btn-xs {
  font-size: 0.86rem;
}

.btn-2xs {
  font-size: 0.74rem;
  padding: 0.5rem;
  border-radius: .375rem;
}

.btn-white {
  --text-opacity: 1;
  color: #000;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--text-opacity));
  --bg-opacity: 1;
  background-color: #F1F1F2;
  background-color: rgba(241, 241, 242, var(--bg-opacity));
}

.btn-white:hover,
  .btn-white:active,
  .btn-white.hover,
  .btn-white.active {
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

.btn-white:focus,
  .btn-white.focus {
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
    background-color: rgba(4, 21, 39, 0.8);
  }

.btn-white[disabled="disabled"],
  .btn-white.disabled {
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

.btn-primary {
  --text-opacity: 1;
  color: #fff;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--text-opacity));
  --bg-opacity: 1;
  background-color: #37A4DC;
  background-color: rgba(55, 164, 220, var(--bg-opacity));
}

.btn-primary:hover,
  .btn-primary:active,
  .btn-primary.hover,
  .btn-primary.active {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

.btn-primary:hover .second-icon, .btn-primary.hover .second-icon {
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

.btn-primary:focus,
  .btn-primary.focus {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

.btn-primary[disabled="disabled"],
  .btn-primary.disabled {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

.btn-primary[disabled="disabled"] > .second-icon, .btn-primary.disabled > .second-icon {
      flex-shrink: 0;
      --text-opacity: 1;
      color: #E0E2E4;
      color: rgba(224, 226, 228, 1);
      color: rgba(224, 226, 228, var(--text-opacity));
    }

.btn-secondary {
  --border-opacity: 1;
  border-color: #37A4DC;
  border-color: rgba(55, 164, 220, var(--border-opacity));
}

.btn-secondary:hover,
  .btn-secondary:active,
  .btn-secondary.hover,
  .btn-secondary.active {
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

.btn-secondary[disabled="disabled"],
  .btn-secondary.disabled {
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

.btn-secondary[disabled="disabled"] > .second-icon, .btn-secondary.disabled > .second-icon {
      flex-shrink: 0;
      --text-opacity: 1;
      color: #E0E2E4;
      color: rgba(224, 226, 228, 1);
      color: rgba(224, 226, 228, var(--text-opacity));
    }

.btn-success {
  --text-opacity: 1;
  color: #fff;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--text-opacity));
  --bg-opacity: 1;
  background-color: #3e7211;
  background-color: rgba(62, 114, 17, var(--bg-opacity));
}

.btn-success:hover,
  .btn-success:active,
  .btn-success.hover,
  .btn-success.active {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

.btn-success:focus,
  .btn-success.focus {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

.btn-success[disabled="disabled"],
  .btn-success.disabled {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

.btn-success[disabled="disabled"] > .second-icon, .btn-success.disabled > .second-icon {
      flex-shrink: 0;
      --text-opacity: 1;
      color: #E0E2E4;
      color: rgba(224, 226, 228, 1);
      color: rgba(224, 226, 228, var(--text-opacity));
    }

.btn-danger {
  --text-opacity: 1;
  color: #fff;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--text-opacity));
  --bg-opacity: 1;
  background-color: #A23C24;
  background-color: rgba(162, 60, 36, var(--bg-opacity));
}

.btn-danger:hover,
  .btn-danger:active,
  .btn-danger.hover,
  .btn-danger.active {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

.btn-danger:focus,
  .btn-danger.focus {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

.btn-danger[disabled="disabled"],
  .btn-danger.disabled {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

.btn-danger[disabled="disabled"] > .second-icon, .btn-danger.disabled > .second-icon {
      flex-shrink: 0;
      --text-opacity: 1;
      color: #E0E2E4;
      color: rgba(224, 226, 228, 1);
      color: rgba(224, 226, 228, var(--text-opacity));
    }

.btn-secondary-danger {
  --text-opacity: 1;
  color: #DD4746;
  color: rgba(221, 71, 70, 1);
  color: rgba(221, 71, 70, var(--text-opacity));
  --border-opacity: 1;
  border-color: #DD4746;
  border-color: rgba(221, 71, 70, var(--border-opacity));
}

.btn-secondary-danger:hover,
  .btn-secondary-danger:active,
  .btn-secondary-danger.hover,
  .btn-secondary-danger.active {
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

.btn-secondary-danger[disabled="disabled"],
  .btn-secondary-danger.disabled {
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

.btn-secondary-danger[disabled="disabled"] > .second-icon, .btn-secondary-danger.disabled > .second-icon {
      flex-shrink: 0;
      --text-opacity: 1;
      color: #E0E2E4;
      color: rgba(224, 226, 228, 1);
      color: rgba(224, 226, 228, var(--text-opacity));
    }

.btn-filter {
  display: inline-flex;
  align-items: center;
  width: 100%;
  padding: 0.75rem;
  font-size: 0.86rem;
  --text-opacity: 1;
  color: #1F4566;
  color: rgba(31, 69, 102, 1);
  color: rgba(31, 69, 102, var(--text-opacity));
  --bg-opacity: 1;
  background-color: #fff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
}

[dir="ltr"] .btn-filter > svg{
    margin-right: 1.25rem;
}

[dir="rtl"] .btn-filter > svg{
    margin-left: 1.25rem;
}

.btn-filter > svg {
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
    flex-shrink: 0;
  }

.btn-filter > span {
    flex-shrink: 0;
  }

.btn-filter > div {
    flex-shrink: 0;
  }

.btn-filter:hover {
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

.btn-filter:active,
  .btn-filter:focus {
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

.btn-filter.is-active {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

.btn-filter.is-active > svg {
      --text-opacity: 1;
      color: #fff;
      color: rgba(255, 255, 255, 1);
      color: rgba(255, 255, 255, var(--text-opacity));
      flex-shrink: 0;
    }

.btn-filter.is-active > span {
      flex-shrink: 0;
    }

.btn-filter.is-active > div {
      flex-shrink: 0;
    }

.has-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.has-icon > svg {
    width: 1.25rem;
    height: 1.25rem;
    flex-shrink: 0;
  }

[dir="ltr"] .has-icon > span{
    margin-left: 0.5rem;
}

[dir="rtl"] .has-icon > span{
    margin-right: 0.5rem;
}

.has-icon > span {
    flex-shrink: 0;
  }

[dir="ltr"] .has-icon > div{
    margin-left: 0.5rem;
}

[dir="rtl"] .has-icon > div{
    margin-right: 0.5rem;
}

.has-icon > div {
    flex-shrink: 0;
  }

/*----------------------------------------*\\
  FORM
  These styles overwrites
  the Tailwind forms extension
\\*----------------------------------------*/

.form-input,
.form-textarea {
  padding: 0.6em 1em;
  /* Firefox */
  scrollbar-width: auto;
  scrollbar-color: #bfbfbf transparent;
  /* Chrome Safari */
}

.form-input::-webkit-scrollbar-thumb, .form-textarea::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 1rem;
  }

.form-radio,
.form-checkbox {
  --border-opacity: 1;
  border-color: #5a626b;
  border-color: rgba(90, 98, 107, var(--border-opacity));
  outline: 2px solid transparent;
  outline-offset: 2px;
  width: 20px;
  height: 20px;
}

.form-radio:focus, .form-checkbox:focus {
    outline: none;
  }

.form-radio:hover,
  .form-checkbox:hover,
  .form-radio:focus,
  .form-checkbox:focus {
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

.form-radio[disabled='disabled'], .form-checkbox[disabled='disabled'] {
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

.form-checkbox:checked:disabled {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___})
}

.form-checkbox:indeterminate {
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.form-radio:checked {
  border-color: currentColor;
  background-color: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.form-radio:checked:disabled {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  }

.form-input,
.form-textarea,
.form-select {
  transition: border-color .3s;
}

.form-input:hover, .form-textarea:hover, .form-select:hover {
    border-color: rgba(4, 21, 39, 0.8);;
  }

.form-input[disabled='disabled'],
  .form-textarea[disabled='disabled'],
  .form-select[disabled='disabled'],
  .form-input.disabled,
  .form-textarea.disabled,
  .form-select.disabled {
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
    cursor: not-allowed;
  }

.form-input[disabled='disabled']:hover,
    .form-textarea[disabled='disabled']:hover,
    .form-select[disabled='disabled']:hover,
    .form-input.disabled:hover,
    .form-textarea.disabled:hover,
    .form-select.disabled:hover,
    .form-input[disabled='disabled']:focus,
    .form-textarea[disabled='disabled']:focus,
    .form-select[disabled='disabled']:focus,
    .form-input.disabled:focus,
    .form-textarea.disabled:focus,
    .form-select.disabled:focus {
      --border-opacity: 1;
      border-color: #E0E2E4;
      border-color: rgba(224, 226, 228, var(--border-opacity));
    }

.form-select-invert {
  background-color: transparent;
  --border-opacity: 1;
  border-color: #F1F1F2;
  border-color: rgba(241, 241, 242, var(--border-opacity));
  --text-opacity: 1;
  color: #fff;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--text-opacity));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.form-select-invert:hover,
  .form-select-invert:focus {
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

.input-error {
  animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
  transform: translate3d(0, 0, 0);
  backface-visibility: hidden;
  perspective: 1000px;
}

.input-required {
  border-width: 2px;
  --border-opacity: 1;
  border-color: #37A4DC;
  border-color: rgba(55, 164, 220, var(--border-opacity));
}

.form-required {
  --text-opacity: 1;
  color: #DD4746;
  color: rgba(221, 71, 70, 1);
  color: rgba(221, 71, 70, var(--text-opacity));
  font-size: 0.86rem;
}

.form-warning {
  --text-opacity: 1;
  color: #F07313;
  color: rgba(240, 115, 19, 1);
  color: rgba(240, 115, 19, var(--text-opacity));
  font-size: 0.86rem;
}

.form-input-label {
  color: rgba(114,114,114,0.8);
}

.form-input-label.disabled {
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

/*----------------------------------------*\\
  LIST
\\*----------------------------------------*/

dl.definition-list-compact dt,
  dl.definition-list-compact dd {
    margin-top: 0;
    margin-bottom: 0.5rem;
  }

dl.definition-list-compact dd {
    margin-left: calc(1rem + 12rem);
  }

/*----------------------------------------*\\
  Tooltip
\\*----------------------------------------*/

.tooltip {
  width: auto;
  padding: 0.5rem;
  font-size: 0.86rem;
  --text-opacity: 1;
  color: #fff;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--text-opacity));
  word-wrap: break-word;
  word-wrap: break-word;
  --bg-opacity: 1;
  background-color: #464C59;
  background-color: rgba(70, 76, 89, var(--bg-opacity));
  border-radius: .375rem;
  max-width: 600px;
}

.tooltip {
  display: block !important;
}

[dir="rtl"] .highcharts-tooltip {
  text-align: right;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip.popover-negative-margin[x-placement] {
  margin-top: -1rem;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-arrow,
.tooltip .tooltip-arrow {
  border-color: transparent !important;
}

.tooltip[aria-hidden="true"] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.25s;
}

.tooltip[aria-hidden="false"] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.25s;
}

/*----------------------------------------*\\
  MODAL
\\*----------------------------------------*/

.modal-backdrop {
  background-color: rgba(69, 110, 154, 0.75);
  transition: opacity 0.3s ease;
}

.modal-backdrop-blurred {
  backdrop-filter: blur(10px);
  background-color: rgba(69, 110, 154, 0.75);
  transition: opacity 0.3s ease;
}

.confirm-modal {
  position: fixed;
  display: flex;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  align-items: center;
  justify-content: center;
  background-color: rgba(69, 110, 154, 0.75);
}

/*----------------------------------------*\\
  Multiselect
\\*----------------------------------------*/

[dir="ltr"] .multiselect .multiselect__tags {
  padding-left: 0;
  padding-top: 0;
  display: flex;
  align-items: center;
  min-height: 39.78px;  /* to be same as form-input */
  height: 100%;
  border: 1px solid #BFBFBF;
  cursor: pointer;
}

[dir="rtl"] .multiselect .multiselect__tags {
  padding-right: 0;
  padding-top: 0;
  display: flex;
  align-items: center;
  min-height: 39.78px;  /* to be same as form-input */
  height: 100%;
  border: 1px solid #BFBFBF;
  cursor: pointer;
}

[dir="ltr"] .multiselect-required .multiselect__tags {
  padding-left: 0;
  padding-top: 0;
  display: flex;
  align-items: center;
  min-height: 41.78px;  /* to be same as form-input */
  border-width: 2px;
  --border-opacity: 1;
  border-color: #37A4DC;
  border-color: rgba(55, 164, 220, var(--border-opacity));
}

[dir="rtl"] .multiselect-required .multiselect__tags {
  padding-right: 0;
  padding-top: 0;
  display: flex;
  align-items: center;
  min-height: 41.78px;  /* to be same as form-input */
  border-width: 2px;
  --border-opacity: 1;
  border-color: #37A4DC;
  border-color: rgba(55, 164, 220, var(--border-opacity));
}

[dir="ltr"] .multiselect .multiselect__tags .multiselect__single {
  padding-left: 0;
  margin: 0;
  background-color: transparent;
}

[dir="rtl"] .multiselect .multiselect__tags .multiselect__single {
  padding-right: 0;
  margin: 0;
  background-color: transparent;
}

.multiselect .multiselect__element {
  display: flex;
}

.multiselect .multiselect__element .multiselect__option--selected {
  --bg-opacity: 1;
  background-color: #CCE6F5;
  background-color: rgba(204, 230, 245, var(--bg-opacity));
  --text-opacity: 1;
  color: #1F4566;
  color: rgba(31, 69, 102, 1);
  color: rgba(31, 69, 102, var(--text-opacity));
  font-weight: 400;
}

.multiselect .multiselect__element .multiselect__option--highlight {
  --text-opacity: 1;
  color: #456E9A;
  color: rgba(69, 110, 154, 1);
  color: rgba(69, 110, 154, var(--text-opacity));
  --bg-opacity: 1;
  background-color: #EBF6FC;
  background-color: rgba(235, 246, 252, var(--bg-opacity));
}

.multiselect .multiselect__select {
  margin: auto;
  top: 0;
  bottom: 0;
}

.multiselect .multiselect__tags:hover {
  border: 1px solid #1F4566; /* text-blue-800 */
}

.multiselect-required .multiselect__tags:hover {
  border: 2px solid #1F4566; /* text-blue-800 */
}

.multiselect .multiselect__option {
  background-color: transparent;
  display: flex;
  padding: 0;
  --text-opacity: 1;
  color: #1F4566;
  color: rgba(31, 69, 102, 1);
  color: rgba(31, 69, 102, var(--text-opacity));
  width: 100%;
  font-size: 1rem;
}

.multiselect .multiselect__option:hover {
  --text-opacity: 1;
  color: #456E9A;
  color: rgba(69, 110, 154, 1);
  color: rgba(69, 110, 154, var(--text-opacity));
  --bg-opacity: 1;
  background-color: #EBF6FC;
  background-color: rgba(235, 246, 252, var(--bg-opacity));
}

.multiselect .multiselect__content-wrapper {
  min-width: max-content;
  overflow-x: hidden;
  /* Firefox */
  scrollbar-width: auto;
  scrollbar-color: #bfbfbf transparent;
  /* Chrome Safari */
}

.multiselect .multiselect__content-wrapper::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 1rem;
  }

/* specific for dropdown filters */

.multiselect-filters {
  height: 100%;
}

.multiselect-filters .multiselect__option {
  padding: 0;
}

/*----------------------------------------*\\
  Meeting Lists
\\*----------------------------------------*/

.meeting-list-day, .meeting-list-day-past {
  cursor: auto;
  font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --text-opacity: 1;
  color: #1F4566;
  color: rgba(31, 69, 102, 1);
  color: rgba(31, 69, 102, var(--text-opacity));
  font-weight: 600;
  padding-top: 1.5rem;
  padding-bottom: 0.5rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  font-size: 1.15rem;
}

.meeting-list-day-past {
  color: rgba(114,114,114,0.8);
}

.meeting-list-today {
  font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-size: 1.15rem;
  font-weight: 600;
  padding-top: 1.5rem;
  padding-bottom: 0.5rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  cursor: auto;
  --text-opacity: 1;
  color: #37A4DC;
  color: rgba(55, 164, 220, 1);
  color: rgba(55, 164, 220, var(--text-opacity));
}

.meeting-details {
  font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  cursor: auto;
}

.meeting-row .meeting-details .status {
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

.meeting-row .meeting-details .meeting-duration {
    font-weight: normal;
  }

.meeting-in-the-past .meeting-duration {
    font-weight: normal;
  }

.meeting-in-the-past .meeting-row .meeting-details .status {
        --bg-opacity: 1;
        background-color: #F8CECC;
        background-color: rgba(248, 206, 204, var(--bg-opacity));
      }

.meeting-in-the-future.meeting-canceled-row .meeting-duration {
    font-weight: normal;
  }

.meeting-in-the-future.meeting-canceled-row .meeting-details .status {
      --bg-opacity: 1;
      background-color: #E0E2E4;
      background-color: rgba(224, 226, 228, var(--bg-opacity));
    }

.meeting-selected-row .meeting-duration {
    font-weight: normal;
  }

.meeting-selected-row .meeting-details {
    font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    border-radius: .375rem;
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

.meeting-selected-row .meeting-duration {
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

.meeting-in-the-past.meeting-canceled-row .meeting-duration {
    font-weight: normal;
  }

.meeting-in-the-past.meeting-canceled-row .meeting-details .status {
      --bg-opacity: 1;
      background-color: #E0E2E4;
      background-color: rgba(224, 226, 228, var(--bg-opacity));
    }

.meeting-in-the-future.meeting-declined-row .meeting-duration {
    font-weight: normal;
  }

.meeting-in-the-future.meeting-declined-row .meeting-details .status {
      --bg-opacity: 1;
      background-color: #F8CECC;
      background-color: rgba(248, 206, 204, var(--bg-opacity));
    }

.meeting-in-the-past.meeting-declined-row .meeting-duration {
    font-weight: normal;
  }

.meeting-in-the-past.meeting-declined-row .meeting-details .status {
      --bg-opacity: 1;
      background-color: #E0E2E4;
      background-color: rgba(224, 226, 228, var(--bg-opacity));
    }

.meeting-in-the-past.meeting-occurred-row .meeting-duration {
    font-weight: normal;
  }

.meeting-in-the-past.meeting-occurred-row .meeting-details .status {
      --bg-opacity: 1;
      background-color: #CCE6F5;
      background-color: rgba(204, 230, 245, var(--bg-opacity));
    }

.meeting-did-not-occur-row .meeting-details .status {
      --bg-opacity: 1;
      background-color: #F8CECC;
      background-color: rgba(248, 206, 204, var(--bg-opacity));
    }

.meeting-did-not-occur-row .meeting-subtext {
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

.meeting-occurring-now .meeting-duration {
    font-weight: semibold;
  }

.meeting-occurring-now .meeting-details {
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

.meeting-canceled-row .meeting-subtext {
    color: rgba(114,114,114,0.8);
  }

.meeting-declined-row .meeting-subtext {
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

.meeting-occurring-now .meeting-subtext {
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

.meeting-occurred-row .meeting-subtext {
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

[dir="ltr"] .meeting-table-header{
  padding-left: 1rem;
}

[dir="rtl"] .meeting-table-header{
  padding-right: 1rem;
}

.meeting-table-header {
  --bg-opacity: 1;
  background-color: #fff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
  border-bottom-width: 1px;
  --border-opacity: 1;
  border-color: #041527;
  border-color: rgba(4, 21, 39, var(--border-opacity));
  --text-opacity: 1;
  color: #041527;
  color: rgba(4, 21, 39, 1);
  color: rgba(4, 21, 39, var(--text-opacity));
  font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  font-weight: 600;
  padding: 0.25rem;
  padding-bottom: 0.25rem;
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  margin: 0;
}

#meeting-list {
  margin-top: 0;
}

.meeting-list-td {
  border-bottom-width: 0;
}

/*----------------------------------------*\\
  Radio button group
\\*----------------------------------------*/

.radio-pillbox {
  height: 27px;
  width: 100%;
  border-radius: 3px;
  overflow: hidden;
  background: transparent;
  box-shadow: none;
  display: flex;
}

.radio-pillbox > div {
  width: 100%;
  position: relative;
  border: 1px solid #5682aa;
  border-left: 0;
}

.radio-pillbox > div:first-child {
  border-left: 1px solid #5682aa;
}

.radio-pillbox input {
  -webkit-appearance: inherit;
  width: 100%;
  height: 100%;
  margin: 0;
  outline: 0;
}

.radio-pillbox input:checked {
  background: #5682aa;
}

.radio-pillbox input:checked + label {
  color: white;
}

.radio-pillbox label {
  position: absolute;
  top: 50%;
  line-height: 0;
  margin: 0;
  left: 0;
  width: 100%;
  height: 0;
  text-align: center;
  font-size: 0.8em;
  color: #5682aa;
}

.radio-pillbox input:focus {
  outline: 0;
}

/*----------------------------------------*\\
  vue-tel-input
\\*----------------------------------------*/

.vti__dropdown:hover {
  background-color: transparent !important;
}

.vti__dropdown.open {
  background-color: transparent !important;
}

.vti__dropdown-item.highlighted {
  --bg-opacity: 1 !important;
  background-color: #EBF6FC !important;
  background-color: rgba(235, 246, 252, var(--bg-opacity)) !important;
}

.vti__dropdown .vti__dropdown-item > strong {
    font-weight: 400;
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

.vti__dropdown .vti__dropdown-item > span {
    color: rgba(114,114,114,0.8);
    font-size: 0.86rem;
  }

[dir=rtl] .vti__dropdown .vti__dropdown-item {
  text-align: right;
  unicode-bidi: plaintext;
}

.vti__dropdown .vti__dropdown-list {
  /* Firefox */
  scrollbar-width: auto;
  scrollbar-color: #bfbfbf transparent;
  /* Chrome Safari */
}

.vti__dropdown .vti__dropdown-list::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 1rem;
  }

.vti__dropdown .vti__dropdown-list {
  resize: none;
  width: 300px;
  height: 150px;
}

[dir=rtl] .vti__dropdown .vti__dropdown-list {
  right: 0;
}

.vti__dropdown .vti__dropdown-list.below {
  top: 41px;
}

[dir="ltr"] .vti__input{
  margin-right: 0.25rem;
}

[dir="rtl"] .vti__input{
  margin-left: 0.25rem;
}

[dir=rtl] .vti__input {
  text-align: right;
  unicode-bidi: plaintext;
}

.vti__dropdown .vti__selection .vti__country-code {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
  font-size: 1rem;
}

.vue-tel-input {
  height: 3rem;
}

.vue-tel-input[focus-within] {
    --border-opacity: 1 !important;
    border-color: #041527 !important;
    border-color: rgba(4, 21, 39, var(--border-opacity)) !important;
    box-shadow: none !important;
  }

.vue-tel-input:focus-within {
    --border-opacity: 1 !important;
    border-color: #041527 !important;
    border-color: rgba(4, 21, 39, var(--border-opacity)) !important;
    box-shadow: none !important;
  }

.vue-tel-input.has-error {
    --border-opacity: 1 !important;
    border-color: #DD4746 !important;
    border-color: rgba(221, 71, 70, var(--border-opacity)) !important;
  }

.vue-tel-input.disabled > input {
      background-color: transparent;
    }

/*----------------------------------------*\\
  SIDEBAR
\\*----------------------------------------*/

.expanded-sidebar {
  width: 21rem;
}

[dir="ltr"] .margin-for-expanded-sidebar{
  margin-left: 21rem;
}

[dir="rtl"] .margin-for-expanded-sidebar{
  margin-right: 21rem;
}

.collapsed-sidebar {
  width: 6rem;
}

[dir="ltr"] .margin-for-collapsed-sidebar{
  margin-left: 6rem;
}

[dir="rtl"] .margin-for-collapsed-sidebar{
  margin-right: 6rem;
}

/*----------------------------------------*\\
  ICONS
\\*----------------------------------------*/

[dir="rtl"] .flip-icon-if-rtl {
  transform: scaleX(-1);
}

/**
* Utilities
*/

.space-y-0 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(0px * (1 - var(--space-y-reverse)));
  margin-top: calc(0px * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(0px * var(--space-y-reverse));
}

.space-x-0 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(0px * var(--space-x-reverse));
  margin-left: calc(0px * (1 - var(--space-x-reverse)));
  margin-left: calc(0px * calc(1 - var(--space-x-reverse)));
}

.space-y-1 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(0.25rem * (1 - var(--space-y-reverse)));
  margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--space-y-reverse));
}

.space-x-1 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(0.25rem * var(--space-x-reverse));
  margin-left: calc(0.25rem * (1 - var(--space-x-reverse)));
  margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));
}

.space-y-2 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(0.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--space-y-reverse));
}

.space-x-2 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(0.5rem * var(--space-x-reverse));
  margin-left: calc(0.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));
}

.space-y-3 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(0.75rem * (1 - var(--space-y-reverse)));
  margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--space-y-reverse));
}

.space-x-3 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--space-x-reverse));
  margin-left: calc(0.75rem * (1 - var(--space-x-reverse)));
  margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));
}

.space-y-4 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(1rem * (1 - var(--space-y-reverse)));
  margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(1rem * var(--space-y-reverse));
}

.space-x-4 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(1rem * var(--space-x-reverse));
  margin-left: calc(1rem * (1 - var(--space-x-reverse)));
  margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));
}

.space-y-5 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(1.25rem * (1 - var(--space-y-reverse)));
  margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--space-y-reverse));
}

.space-x-5 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(1.25rem * var(--space-x-reverse));
  margin-left: calc(1.25rem * (1 - var(--space-x-reverse)));
  margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));
}

.space-y-6 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(1.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--space-y-reverse));
}

.space-x-6 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--space-x-reverse));
  margin-left: calc(1.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));
}

.space-y-7 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(1.75rem * (1 - var(--space-y-reverse)));
  margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(1.75rem * var(--space-y-reverse));
}

.space-x-7 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(1.75rem * var(--space-x-reverse));
  margin-left: calc(1.75rem * (1 - var(--space-x-reverse)));
  margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));
}

.space-y-8 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(2rem * (1 - var(--space-y-reverse)));
  margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(2rem * var(--space-y-reverse));
}

.space-x-8 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(2rem * var(--space-x-reverse));
  margin-left: calc(2rem * (1 - var(--space-x-reverse)));
  margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));
}

.space-y-9 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(2.25rem * (1 - var(--space-y-reverse)));
  margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(2.25rem * var(--space-y-reverse));
}

.space-x-9 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(2.25rem * var(--space-x-reverse));
  margin-left: calc(2.25rem * (1 - var(--space-x-reverse)));
  margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));
}

.space-y-10 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(2.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(2.5rem * var(--space-y-reverse));
}

.space-x-10 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(2.5rem * var(--space-x-reverse));
  margin-left: calc(2.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));
}

.space-y-11 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(2.75rem * (1 - var(--space-y-reverse)));
  margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(2.75rem * var(--space-y-reverse));
}

.space-x-11 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(2.75rem * var(--space-x-reverse));
  margin-left: calc(2.75rem * (1 - var(--space-x-reverse)));
  margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));
}

.space-y-12 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(3rem * (1 - var(--space-y-reverse)));
  margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(3rem * var(--space-y-reverse));
}

.space-x-12 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(3rem * var(--space-x-reverse));
  margin-left: calc(3rem * (1 - var(--space-x-reverse)));
  margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));
}

.space-y-14 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(3.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(3.5rem * var(--space-y-reverse));
}

.space-x-14 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(3.5rem * var(--space-x-reverse));
  margin-left: calc(3.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));
}

.space-y-15 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(3.75rem * (1 - var(--space-y-reverse)));
  margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(3.75rem * var(--space-y-reverse));
}

.space-x-15 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(3.75rem * var(--space-x-reverse));
  margin-left: calc(3.75rem * (1 - var(--space-x-reverse)));
  margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));
}

.space-y-16 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(4rem * (1 - var(--space-y-reverse)));
  margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(4rem * var(--space-y-reverse));
}

.space-x-16 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(4rem * var(--space-x-reverse));
  margin-left: calc(4rem * (1 - var(--space-x-reverse)));
  margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));
}

.space-y-18 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(4.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(4.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(4.5rem * var(--space-y-reverse));
}

.space-x-18 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(4.5rem * var(--space-x-reverse));
  margin-left: calc(4.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(4.5rem * calc(1 - var(--space-x-reverse)));
}

.space-y-20 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(5rem * var(--space-y-reverse));
}

.space-x-20 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(5rem * var(--space-x-reverse));
  margin-left: calc(5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));
}

.space-y-22 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(5.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(5.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(5.5rem * var(--space-y-reverse));
}

.space-x-22 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(5.5rem * var(--space-x-reverse));
  margin-left: calc(5.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(5.5rem * calc(1 - var(--space-x-reverse)));
}

.space-y-23 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(5.75rem * (1 - var(--space-y-reverse)));
  margin-top: calc(5.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(5.75rem * var(--space-y-reverse));
}

.space-x-23 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(5.75rem * var(--space-x-reverse));
  margin-left: calc(5.75rem * (1 - var(--space-x-reverse)));
  margin-left: calc(5.75rem * calc(1 - var(--space-x-reverse)));
}

.space-y-24 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(6rem * (1 - var(--space-y-reverse)));
  margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(6rem * var(--space-y-reverse));
}

.space-x-24 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(6rem * var(--space-x-reverse));
  margin-left: calc(6rem * (1 - var(--space-x-reverse)));
  margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));
}

.space-y-25 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(6.25rem * (1 - var(--space-y-reverse)));
  margin-top: calc(6.25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(6.25rem * var(--space-y-reverse));
}

.space-x-25 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(6.25rem * var(--space-x-reverse));
  margin-left: calc(6.25rem * (1 - var(--space-x-reverse)));
  margin-left: calc(6.25rem * calc(1 - var(--space-x-reverse)));
}

.space-y-26 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(6.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(6.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(6.5rem * var(--space-y-reverse));
}

.space-x-26 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(6.5rem * var(--space-x-reverse));
  margin-left: calc(6.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(6.5rem * calc(1 - var(--space-x-reverse)));
}

.space-y-28 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(7rem * (1 - var(--space-y-reverse)));
  margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(7rem * var(--space-y-reverse));
}

.space-x-28 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(7rem * var(--space-x-reverse));
  margin-left: calc(7rem * (1 - var(--space-x-reverse)));
  margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));
}

.space-y-30 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(7.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(7.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(7.5rem * var(--space-y-reverse));
}

.space-x-30 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(7.5rem * var(--space-x-reverse));
  margin-left: calc(7.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(7.5rem * calc(1 - var(--space-x-reverse)));
}

.space-y-32 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(8rem * (1 - var(--space-y-reverse)));
  margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(8rem * var(--space-y-reverse));
}

.space-x-32 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(8rem * var(--space-x-reverse));
  margin-left: calc(8rem * (1 - var(--space-x-reverse)));
  margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));
}

.space-y-34 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(8.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(8.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(8.5rem * var(--space-y-reverse));
}

.space-x-34 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(8.5rem * var(--space-x-reverse));
  margin-left: calc(8.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(8.5rem * calc(1 - var(--space-x-reverse)));
}

.space-y-40 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(10rem * (1 - var(--space-y-reverse)));
  margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(10rem * var(--space-y-reverse));
}

.space-x-40 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(10rem * var(--space-x-reverse));
  margin-left: calc(10rem * (1 - var(--space-x-reverse)));
  margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));
}

.space-y-42 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(10.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(10.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(10.5rem * var(--space-y-reverse));
}

.space-x-42 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(10.5rem * var(--space-x-reverse));
  margin-left: calc(10.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(10.5rem * calc(1 - var(--space-x-reverse)));
}

.space-y-44 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(11rem * (1 - var(--space-y-reverse)));
  margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(11rem * var(--space-y-reverse));
}

.space-x-44 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(11rem * var(--space-x-reverse));
  margin-left: calc(11rem * (1 - var(--space-x-reverse)));
  margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));
}

.space-y-48 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(12rem * (1 - var(--space-y-reverse)));
  margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(12rem * var(--space-y-reverse));
}

.space-x-48 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(12rem * var(--space-x-reverse));
  margin-left: calc(12rem * (1 - var(--space-x-reverse)));
  margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));
}

.space-y-52 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(13rem * (1 - var(--space-y-reverse)));
  margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(13rem * var(--space-y-reverse));
}

.space-x-52 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(13rem * var(--space-x-reverse));
  margin-left: calc(13rem * (1 - var(--space-x-reverse)));
  margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));
}

.space-y-54 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(13.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(13.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(13.5rem * var(--space-y-reverse));
}

.space-x-54 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(13.5rem * var(--space-x-reverse));
  margin-left: calc(13.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(13.5rem * calc(1 - var(--space-x-reverse)));
}

.space-y-56 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(14rem * (1 - var(--space-y-reverse)));
  margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(14rem * var(--space-y-reverse));
}

.space-x-56 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(14rem * var(--space-x-reverse));
  margin-left: calc(14rem * (1 - var(--space-x-reverse)));
  margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));
}

.space-y-60 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(15rem * (1 - var(--space-y-reverse)));
  margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(15rem * var(--space-y-reverse));
}

.space-x-60 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(15rem * var(--space-x-reverse));
  margin-left: calc(15rem * (1 - var(--space-x-reverse)));
  margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));
}

.space-y-64 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(16rem * (1 - var(--space-y-reverse)));
  margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(16rem * var(--space-y-reverse));
}

.space-x-64 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(16rem * var(--space-x-reverse));
  margin-left: calc(16rem * (1 - var(--space-x-reverse)));
  margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));
}

.space-y-68 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(17rem * (1 - var(--space-y-reverse)));
  margin-top: calc(17rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(17rem * var(--space-y-reverse));
}

.space-x-68 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(17rem * var(--space-x-reverse));
  margin-left: calc(17rem * (1 - var(--space-x-reverse)));
  margin-left: calc(17rem * calc(1 - var(--space-x-reverse)));
}

.space-y-72 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(18rem * (1 - var(--space-y-reverse)));
  margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(18rem * var(--space-y-reverse));
}

.space-x-72 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(18rem * var(--space-x-reverse));
  margin-left: calc(18rem * (1 - var(--space-x-reverse)));
  margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));
}

.space-y-74 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(18.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(18.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(18.5rem * var(--space-y-reverse));
}

.space-x-74 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(18.5rem * var(--space-x-reverse));
  margin-left: calc(18.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(18.5rem * calc(1 - var(--space-x-reverse)));
}

.space-y-76 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(19rem * (1 - var(--space-y-reverse)));
  margin-top: calc(19rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(19rem * var(--space-y-reverse));
}

.space-x-76 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(19rem * var(--space-x-reverse));
  margin-left: calc(19rem * (1 - var(--space-x-reverse)));
  margin-left: calc(19rem * calc(1 - var(--space-x-reverse)));
}

.space-y-78 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(19.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(19.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(19.5rem * var(--space-y-reverse));
}

.space-x-78 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(19.5rem * var(--space-x-reverse));
  margin-left: calc(19.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(19.5rem * calc(1 - var(--space-x-reverse)));
}

.space-y-80 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(20rem * (1 - var(--space-y-reverse)));
  margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(20rem * var(--space-y-reverse));
}

.space-x-80 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(20rem * var(--space-x-reverse));
  margin-left: calc(20rem * (1 - var(--space-x-reverse)));
  margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));
}

.space-y-82 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(20.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(20.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(20.5rem * var(--space-y-reverse));
}

.space-x-82 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(20.5rem * var(--space-x-reverse));
  margin-left: calc(20.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(20.5rem * calc(1 - var(--space-x-reverse)));
}

.space-y-84 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(21rem * (1 - var(--space-y-reverse)));
  margin-top: calc(21rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(21rem * var(--space-y-reverse));
}

.space-x-84 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(21rem * var(--space-x-reverse));
  margin-left: calc(21rem * (1 - var(--space-x-reverse)));
  margin-left: calc(21rem * calc(1 - var(--space-x-reverse)));
}

.space-y-88 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(22rem * (1 - var(--space-y-reverse)));
  margin-top: calc(22rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(22rem * var(--space-y-reverse));
}

.space-x-88 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(22rem * var(--space-x-reverse));
  margin-left: calc(22rem * (1 - var(--space-x-reverse)));
  margin-left: calc(22rem * calc(1 - var(--space-x-reverse)));
}

.space-y-92 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(23rem * (1 - var(--space-y-reverse)));
  margin-top: calc(23rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(23rem * var(--space-y-reverse));
}

.space-x-92 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(23rem * var(--space-x-reverse));
  margin-left: calc(23rem * (1 - var(--space-x-reverse)));
  margin-left: calc(23rem * calc(1 - var(--space-x-reverse)));
}

.space-y-96 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(24rem * (1 - var(--space-y-reverse)));
  margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(24rem * var(--space-y-reverse));
}

.space-x-96 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(24rem * var(--space-x-reverse));
  margin-left: calc(24rem * (1 - var(--space-x-reverse)));
  margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));
}

.space-y-98 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(24.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(24.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(24.5rem * var(--space-y-reverse));
}

.space-x-98 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(24.5rem * var(--space-x-reverse));
  margin-left: calc(24.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(24.5rem * calc(1 - var(--space-x-reverse)));
}

.space-y-100 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(25rem * (1 - var(--space-y-reverse)));
  margin-top: calc(25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(25rem * var(--space-y-reverse));
}

.space-x-100 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(25rem * var(--space-x-reverse));
  margin-left: calc(25rem * (1 - var(--space-x-reverse)));
  margin-left: calc(25rem * calc(1 - var(--space-x-reverse)));
}

.space-y-104 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(26rem * (1 - var(--space-y-reverse)));
  margin-top: calc(26rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(26rem * var(--space-y-reverse));
}

.space-x-104 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(26rem * var(--space-x-reverse));
  margin-left: calc(26rem * (1 - var(--space-x-reverse)));
  margin-left: calc(26rem * calc(1 - var(--space-x-reverse)));
}

.space-y-112 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(28rem * (1 - var(--space-y-reverse)));
  margin-top: calc(28rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(28rem * var(--space-y-reverse));
}

.space-x-112 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(28rem * var(--space-x-reverse));
  margin-left: calc(28rem * (1 - var(--space-x-reverse)));
  margin-left: calc(28rem * calc(1 - var(--space-x-reverse)));
}

.space-y-124 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(31rem * (1 - var(--space-y-reverse)));
  margin-top: calc(31rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(31rem * var(--space-y-reverse));
}

.space-x-124 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(31rem * var(--space-x-reverse));
  margin-left: calc(31rem * (1 - var(--space-x-reverse)));
  margin-left: calc(31rem * calc(1 - var(--space-x-reverse)));
}

.space-y-128 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(32rem * (1 - var(--space-y-reverse)));
  margin-top: calc(32rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(32rem * var(--space-y-reverse));
}

.space-x-128 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(32rem * var(--space-x-reverse));
  margin-left: calc(32rem * (1 - var(--space-x-reverse)));
  margin-left: calc(32rem * calc(1 - var(--space-x-reverse)));
}

.space-y-140 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(35rem * (1 - var(--space-y-reverse)));
  margin-top: calc(35rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(35rem * var(--space-y-reverse));
}

.space-x-140 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(35rem * var(--space-x-reverse));
  margin-left: calc(35rem * (1 - var(--space-x-reverse)));
  margin-left: calc(35rem * calc(1 - var(--space-x-reverse)));
}

.space-y-152 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(38rem * (1 - var(--space-y-reverse)));
  margin-top: calc(38rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(38rem * var(--space-y-reverse));
}

.space-x-152 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(38rem * var(--space-x-reverse));
  margin-left: calc(38rem * (1 - var(--space-x-reverse)));
  margin-left: calc(38rem * calc(1 - var(--space-x-reverse)));
}

.space-y-160 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(40rem * (1 - var(--space-y-reverse)));
  margin-top: calc(40rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(40rem * var(--space-y-reverse));
}

.space-x-160 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(40rem * var(--space-x-reverse));
  margin-left: calc(40rem * (1 - var(--space-x-reverse)));
  margin-left: calc(40rem * calc(1 - var(--space-x-reverse)));
}

.space-y-162 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(41rem * (1 - var(--space-y-reverse)));
  margin-top: calc(41rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(41rem * var(--space-y-reverse));
}

.space-x-162 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(41rem * var(--space-x-reverse));
  margin-left: calc(41rem * (1 - var(--space-x-reverse)));
  margin-left: calc(41rem * calc(1 - var(--space-x-reverse)));
}

.space-y-192 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(48rem * (1 - var(--space-y-reverse)));
  margin-top: calc(48rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(48rem * var(--space-y-reverse));
}

.space-x-192 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(48rem * var(--space-x-reverse));
  margin-left: calc(48rem * (1 - var(--space-x-reverse)));
  margin-left: calc(48rem * calc(1 - var(--space-x-reverse)));
}

.space-y-208 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(52rem * (1 - var(--space-y-reverse)));
  margin-top: calc(52rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(52rem * var(--space-y-reverse));
}

.space-x-208 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(52rem * var(--space-x-reverse));
  margin-left: calc(52rem * (1 - var(--space-x-reverse)));
  margin-left: calc(52rem * calc(1 - var(--space-x-reverse)));
}

.space-y-224 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(56rem * (1 - var(--space-y-reverse)));
  margin-top: calc(56rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(56rem * var(--space-y-reverse));
}

.space-x-224 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(56rem * var(--space-x-reverse));
  margin-left: calc(56rem * (1 - var(--space-x-reverse)));
  margin-left: calc(56rem * calc(1 - var(--space-x-reverse)));
}

.space-y-256 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(64rem * (1 - var(--space-y-reverse)));
  margin-top: calc(64rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(64rem * var(--space-y-reverse));
}

.space-x-256 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(64rem * var(--space-x-reverse));
  margin-left: calc(64rem * (1 - var(--space-x-reverse)));
  margin-left: calc(64rem * calc(1 - var(--space-x-reverse)));
}

.space-y-px > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(1px * (1 - var(--space-y-reverse)));
  margin-top: calc(1px * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(1px * var(--space-y-reverse));
}

.space-x-px > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(1px * var(--space-x-reverse));
  margin-left: calc(1px * (1 - var(--space-x-reverse)));
  margin-left: calc(1px * calc(1 - var(--space-x-reverse)));
}

.-space-y-1 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-0.25rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-0.25rem * var(--space-y-reverse));
}

.-space-x-1 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-0.25rem * var(--space-x-reverse));
  margin-left: calc(-0.25rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-2 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-0.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-0.5rem * var(--space-y-reverse));
}

.-space-x-2 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-0.5rem * var(--space-x-reverse));
  margin-left: calc(-0.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-3 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-0.75rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-0.75rem * var(--space-y-reverse));
}

.-space-x-3 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-0.75rem * var(--space-x-reverse));
  margin-left: calc(-0.75rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-4 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-1rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-1rem * var(--space-y-reverse));
}

.-space-x-4 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-1rem * var(--space-x-reverse));
  margin-left: calc(-1rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-5 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-1.25rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-1.25rem * var(--space-y-reverse));
}

.-space-x-5 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-1.25rem * var(--space-x-reverse));
  margin-left: calc(-1.25rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-6 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-1.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-1.5rem * var(--space-y-reverse));
}

.-space-x-6 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-1.5rem * var(--space-x-reverse));
  margin-left: calc(-1.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-7 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-1.75rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-1.75rem * var(--space-y-reverse));
}

.-space-x-7 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-1.75rem * var(--space-x-reverse));
  margin-left: calc(-1.75rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-8 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-2rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-2rem * var(--space-y-reverse));
}

.-space-x-8 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-2rem * var(--space-x-reverse));
  margin-left: calc(-2rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-9 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-2.25rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-2.25rem * var(--space-y-reverse));
}

.-space-x-9 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-2.25rem * var(--space-x-reverse));
  margin-left: calc(-2.25rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-10 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-2.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-2.5rem * var(--space-y-reverse));
}

.-space-x-10 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-2.5rem * var(--space-x-reverse));
  margin-left: calc(-2.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-11 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-2.75rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-2.75rem * var(--space-y-reverse));
}

.-space-x-11 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-2.75rem * var(--space-x-reverse));
  margin-left: calc(-2.75rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-12 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-3rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-3rem * var(--space-y-reverse));
}

.-space-x-12 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-3rem * var(--space-x-reverse));
  margin-left: calc(-3rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-14 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-3.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-3.5rem * var(--space-y-reverse));
}

.-space-x-14 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-3.5rem * var(--space-x-reverse));
  margin-left: calc(-3.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-15 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-3.75rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-3.75rem * var(--space-y-reverse));
}

.-space-x-15 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-3.75rem * var(--space-x-reverse));
  margin-left: calc(-3.75rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-16 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-4rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-4rem * var(--space-y-reverse));
}

.-space-x-16 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-4rem * var(--space-x-reverse));
  margin-left: calc(-4rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-18 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-4.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-4.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-4.5rem * var(--space-y-reverse));
}

.-space-x-18 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-4.5rem * var(--space-x-reverse));
  margin-left: calc(-4.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-4.5rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-20 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-5rem * var(--space-y-reverse));
}

.-space-x-20 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-5rem * var(--space-x-reverse));
  margin-left: calc(-5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-22 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-5.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-5.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-5.5rem * var(--space-y-reverse));
}

.-space-x-22 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-5.5rem * var(--space-x-reverse));
  margin-left: calc(-5.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-5.5rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-23 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-5.75rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-5.75rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-5.75rem * var(--space-y-reverse));
}

.-space-x-23 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-5.75rem * var(--space-x-reverse));
  margin-left: calc(-5.75rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-5.75rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-24 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-6rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-6rem * var(--space-y-reverse));
}

.-space-x-24 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-6rem * var(--space-x-reverse));
  margin-left: calc(-6rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-25 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-6.25rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-6.25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-6.25rem * var(--space-y-reverse));
}

.-space-x-25 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-6.25rem * var(--space-x-reverse));
  margin-left: calc(-6.25rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-6.25rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-26 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-6.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-6.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-6.5rem * var(--space-y-reverse));
}

.-space-x-26 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-6.5rem * var(--space-x-reverse));
  margin-left: calc(-6.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-6.5rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-28 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-7rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-7rem * var(--space-y-reverse));
}

.-space-x-28 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-7rem * var(--space-x-reverse));
  margin-left: calc(-7rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-30 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-7.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-7.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-7.5rem * var(--space-y-reverse));
}

.-space-x-30 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-7.5rem * var(--space-x-reverse));
  margin-left: calc(-7.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-7.5rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-32 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-8rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-8rem * var(--space-y-reverse));
}

.-space-x-32 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-8rem * var(--space-x-reverse));
  margin-left: calc(-8rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-34 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-8.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-8.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-8.5rem * var(--space-y-reverse));
}

.-space-x-34 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-8.5rem * var(--space-x-reverse));
  margin-left: calc(-8.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-8.5rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-40 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-10rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-10rem * var(--space-y-reverse));
}

.-space-x-40 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-10rem * var(--space-x-reverse));
  margin-left: calc(-10rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-42 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-10.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-10.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-10.5rem * var(--space-y-reverse));
}

.-space-x-42 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-10.5rem * var(--space-x-reverse));
  margin-left: calc(-10.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-10.5rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-44 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-11rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-11rem * var(--space-y-reverse));
}

.-space-x-44 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-11rem * var(--space-x-reverse));
  margin-left: calc(-11rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-48 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-12rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-12rem * var(--space-y-reverse));
}

.-space-x-48 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-12rem * var(--space-x-reverse));
  margin-left: calc(-12rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-52 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-13rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-13rem * var(--space-y-reverse));
}

.-space-x-52 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-13rem * var(--space-x-reverse));
  margin-left: calc(-13rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-54 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-13.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-13.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-13.5rem * var(--space-y-reverse));
}

.-space-x-54 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-13.5rem * var(--space-x-reverse));
  margin-left: calc(-13.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-13.5rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-56 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-14rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-14rem * var(--space-y-reverse));
}

.-space-x-56 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-14rem * var(--space-x-reverse));
  margin-left: calc(-14rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-60 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-15rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-15rem * var(--space-y-reverse));
}

.-space-x-60 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-15rem * var(--space-x-reverse));
  margin-left: calc(-15rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-64 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-16rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-16rem * var(--space-y-reverse));
}

.-space-x-64 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-16rem * var(--space-x-reverse));
  margin-left: calc(-16rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-68 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-17rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-17rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-17rem * var(--space-y-reverse));
}

.-space-x-68 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-17rem * var(--space-x-reverse));
  margin-left: calc(-17rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-17rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-72 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-18rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-18rem * var(--space-y-reverse));
}

.-space-x-72 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-18rem * var(--space-x-reverse));
  margin-left: calc(-18rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-74 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-18.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-18.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-18.5rem * var(--space-y-reverse));
}

.-space-x-74 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-18.5rem * var(--space-x-reverse));
  margin-left: calc(-18.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-18.5rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-76 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-19rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-19rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-19rem * var(--space-y-reverse));
}

.-space-x-76 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-19rem * var(--space-x-reverse));
  margin-left: calc(-19rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-19rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-78 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-19.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-19.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-19.5rem * var(--space-y-reverse));
}

.-space-x-78 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-19.5rem * var(--space-x-reverse));
  margin-left: calc(-19.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-19.5rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-80 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-20rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-20rem * var(--space-y-reverse));
}

.-space-x-80 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-20rem * var(--space-x-reverse));
  margin-left: calc(-20rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-82 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-20.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-20.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-20.5rem * var(--space-y-reverse));
}

.-space-x-82 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-20.5rem * var(--space-x-reverse));
  margin-left: calc(-20.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-20.5rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-84 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-21rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-21rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-21rem * var(--space-y-reverse));
}

.-space-x-84 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-21rem * var(--space-x-reverse));
  margin-left: calc(-21rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-21rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-88 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-22rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-22rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-22rem * var(--space-y-reverse));
}

.-space-x-88 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-22rem * var(--space-x-reverse));
  margin-left: calc(-22rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-22rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-92 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-23rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-23rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-23rem * var(--space-y-reverse));
}

.-space-x-92 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-23rem * var(--space-x-reverse));
  margin-left: calc(-23rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-23rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-96 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-24rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-24rem * var(--space-y-reverse));
}

.-space-x-96 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-24rem * var(--space-x-reverse));
  margin-left: calc(-24rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-98 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-24.5rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-24.5rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-24.5rem * var(--space-y-reverse));
}

.-space-x-98 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-24.5rem * var(--space-x-reverse));
  margin-left: calc(-24.5rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-24.5rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-100 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-25rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-25rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-25rem * var(--space-y-reverse));
}

.-space-x-100 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-25rem * var(--space-x-reverse));
  margin-left: calc(-25rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-25rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-104 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-26rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-26rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-26rem * var(--space-y-reverse));
}

.-space-x-104 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-26rem * var(--space-x-reverse));
  margin-left: calc(-26rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-26rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-112 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-28rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-28rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-28rem * var(--space-y-reverse));
}

.-space-x-112 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-28rem * var(--space-x-reverse));
  margin-left: calc(-28rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-28rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-124 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-31rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-31rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-31rem * var(--space-y-reverse));
}

.-space-x-124 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-31rem * var(--space-x-reverse));
  margin-left: calc(-31rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-31rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-128 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-32rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-32rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-32rem * var(--space-y-reverse));
}

.-space-x-128 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-32rem * var(--space-x-reverse));
  margin-left: calc(-32rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-32rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-140 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-35rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-35rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-35rem * var(--space-y-reverse));
}

.-space-x-140 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-35rem * var(--space-x-reverse));
  margin-left: calc(-35rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-35rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-152 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-38rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-38rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-38rem * var(--space-y-reverse));
}

.-space-x-152 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-38rem * var(--space-x-reverse));
  margin-left: calc(-38rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-38rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-160 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-40rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-40rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-40rem * var(--space-y-reverse));
}

.-space-x-160 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-40rem * var(--space-x-reverse));
  margin-left: calc(-40rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-40rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-162 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-41rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-41rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-41rem * var(--space-y-reverse));
}

.-space-x-162 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-41rem * var(--space-x-reverse));
  margin-left: calc(-41rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-41rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-192 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-48rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-48rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-48rem * var(--space-y-reverse));
}

.-space-x-192 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-48rem * var(--space-x-reverse));
  margin-left: calc(-48rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-48rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-208 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-52rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-52rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-52rem * var(--space-y-reverse));
}

.-space-x-208 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-52rem * var(--space-x-reverse));
  margin-left: calc(-52rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-52rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-224 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-56rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-56rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-56rem * var(--space-y-reverse));
}

.-space-x-224 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-56rem * var(--space-x-reverse));
  margin-left: calc(-56rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-56rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-256 > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-64rem * (1 - var(--space-y-reverse)));
  margin-top: calc(-64rem * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-64rem * var(--space-y-reverse));
}

.-space-x-256 > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-64rem * var(--space-x-reverse));
  margin-left: calc(-64rem * (1 - var(--space-x-reverse)));
  margin-left: calc(-64rem * calc(1 - var(--space-x-reverse)));
}

.-space-y-px > :not(template) ~ :not(template){
  --space-y-reverse: 0;
  margin-top: calc(-1px * (1 - var(--space-y-reverse)));
  margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));
  margin-bottom: calc(-1px * var(--space-y-reverse));
}

.-space-x-px > :not(template) ~ :not(template){
  --space-x-reverse: 0;
  margin-right: calc(-1px * var(--space-x-reverse));
  margin-left: calc(-1px * (1 - var(--space-x-reverse)));
  margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));
}

.space-y-reverse > :not(template) ~ :not(template){
  --space-y-reverse: 1;
}

.space-x-reverse > :not(template) ~ :not(template){
  --space-x-reverse: 1;
}

.divide-y-0 > :not(template) ~ :not(template){
  --divide-y-reverse: 0;
  border-top-width: calc(0px * (1 - var(--divide-y-reverse)));
  border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));
  border-bottom-width: calc(0px * var(--divide-y-reverse));
}

.divide-x-0 > :not(template) ~ :not(template){
  --divide-x-reverse: 0;
  border-right-width: calc(0px * var(--divide-x-reverse));
  border-left-width: calc(0px * (1 - var(--divide-x-reverse)));
  border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));
}

.divide-y-2 > :not(template) ~ :not(template){
  --divide-y-reverse: 0;
  border-top-width: calc(2px * (1 - var(--divide-y-reverse)));
  border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));
  border-bottom-width: calc(2px * var(--divide-y-reverse));
}

.divide-x-2 > :not(template) ~ :not(template){
  --divide-x-reverse: 0;
  border-right-width: calc(2px * var(--divide-x-reverse));
  border-left-width: calc(2px * (1 - var(--divide-x-reverse)));
  border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));
}

.divide-y-3 > :not(template) ~ :not(template){
  --divide-y-reverse: 0;
  border-top-width: calc(3px * (1 - var(--divide-y-reverse)));
  border-top-width: calc(3px * calc(1 - var(--divide-y-reverse)));
  border-bottom-width: calc(3px * var(--divide-y-reverse));
}

.divide-x-3 > :not(template) ~ :not(template){
  --divide-x-reverse: 0;
  border-right-width: calc(3px * var(--divide-x-reverse));
  border-left-width: calc(3px * (1 - var(--divide-x-reverse)));
  border-left-width: calc(3px * calc(1 - var(--divide-x-reverse)));
}

.divide-y-4 > :not(template) ~ :not(template){
  --divide-y-reverse: 0;
  border-top-width: calc(4px * (1 - var(--divide-y-reverse)));
  border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));
  border-bottom-width: calc(4px * var(--divide-y-reverse));
}

.divide-x-4 > :not(template) ~ :not(template){
  --divide-x-reverse: 0;
  border-right-width: calc(4px * var(--divide-x-reverse));
  border-left-width: calc(4px * (1 - var(--divide-x-reverse)));
  border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));
}

.divide-y-5 > :not(template) ~ :not(template){
  --divide-y-reverse: 0;
  border-top-width: calc(5px * (1 - var(--divide-y-reverse)));
  border-top-width: calc(5px * calc(1 - var(--divide-y-reverse)));
  border-bottom-width: calc(5px * var(--divide-y-reverse));
}

.divide-x-5 > :not(template) ~ :not(template){
  --divide-x-reverse: 0;
  border-right-width: calc(5px * var(--divide-x-reverse));
  border-left-width: calc(5px * (1 - var(--divide-x-reverse)));
  border-left-width: calc(5px * calc(1 - var(--divide-x-reverse)));
}

.divide-y-6 > :not(template) ~ :not(template){
  --divide-y-reverse: 0;
  border-top-width: calc(6px * (1 - var(--divide-y-reverse)));
  border-top-width: calc(6px * calc(1 - var(--divide-y-reverse)));
  border-bottom-width: calc(6px * var(--divide-y-reverse));
}

.divide-x-6 > :not(template) ~ :not(template){
  --divide-x-reverse: 0;
  border-right-width: calc(6px * var(--divide-x-reverse));
  border-left-width: calc(6px * (1 - var(--divide-x-reverse)));
  border-left-width: calc(6px * calc(1 - var(--divide-x-reverse)));
}

.divide-y-8 > :not(template) ~ :not(template){
  --divide-y-reverse: 0;
  border-top-width: calc(8px * (1 - var(--divide-y-reverse)));
  border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));
  border-bottom-width: calc(8px * var(--divide-y-reverse));
}

.divide-x-8 > :not(template) ~ :not(template){
  --divide-x-reverse: 0;
  border-right-width: calc(8px * var(--divide-x-reverse));
  border-left-width: calc(8px * (1 - var(--divide-x-reverse)));
  border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));
}

.divide-y > :not(template) ~ :not(template){
  --divide-y-reverse: 0;
  border-top-width: calc(1px * (1 - var(--divide-y-reverse)));
  border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));
  border-bottom-width: calc(1px * var(--divide-y-reverse));
}

.divide-x > :not(template) ~ :not(template){
  --divide-x-reverse: 0;
  border-right-width: calc(1px * var(--divide-x-reverse));
  border-left-width: calc(1px * (1 - var(--divide-x-reverse)));
  border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));
}

.divide-y-reverse > :not(template) ~ :not(template){
  --divide-y-reverse: 1;
}

.divide-x-reverse > :not(template) ~ :not(template){
  --divide-x-reverse: 1;
}

.divide-transparent > :not(template) ~ :not(template){
  border-color: transparent;
}

.divide-focus > :not(template) ~ :not(template){
  border-color: rgba(4, 21, 39, 0.8);;
}

.divide-black > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #000;
  border-color: rgba(0, 0, 0, var(--divide-opacity));
}

.divide-white > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #fff;
  border-color: rgba(255, 255, 255, var(--divide-opacity));
}

.divide-primary > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #37A4DC;
  border-color: rgba(55, 164, 220, var(--divide-opacity));
}

.divide-disabled > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #BFBFBF;
  border-color: rgba(191, 191, 191, var(--divide-opacity));
}

.divide-translucent-60 > :not(template) ~ :not(template){
  border-color: rgba(256, 256, 256, 0.6);
}

.divide-translucent-90 > :not(template) ~ :not(template){
  border-color: rgba(256, 256, 256, 0.9);
}

.divide-green-200 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #f4fcea;
  border-color: rgba(244, 252, 234, var(--divide-opacity));
}

.divide-green-400 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #6CCA98;
  border-color: rgba(108, 202, 152, var(--divide-opacity));
}

.divide-green-500 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #97E812;
  border-color: rgba(151, 232, 18, var(--divide-opacity));
}

.divide-green-600 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #4f9112;
  border-color: rgba(79, 145, 18, var(--divide-opacity));
}

.divide-green-700 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #3e7211;
  border-color: rgba(62, 114, 17, var(--divide-opacity));
}

.divide-green-400a50 > :not(template) ~ :not(template){
  border-color: rgba(108,202,152,0.50196);
}

.divide-green-500a25 > :not(template) ~ :not(template){
  border-color: rgba(151,232,18,0.09804);
}

.divide-yellow-200 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #fff9eb;
  border-color: rgba(255, 249, 235, var(--divide-opacity));
}

.divide-yellow-300 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #ffe9bd;
  border-color: rgba(255, 233, 189, var(--divide-opacity));
}

.divide-yellow-500 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #FFC82C;
  border-color: rgba(255, 200, 44, var(--divide-opacity));
}

.divide-yellow-600 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #F7931E;
  border-color: rgba(247, 147, 30, var(--divide-opacity));
}

.divide-yellow-700 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #E1AD28;
  border-color: rgba(225, 173, 40, var(--divide-opacity));
}

.divide-yellow-300a66 > :not(template) ~ :not(template){
  border-color: rgba(255,233,189,0.66667);
}

.divide-yellow-500a25 > :not(template) ~ :not(template){
  border-color: rgba(255,200,44,0.09804);
}

.divide-orange-200 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #fdf0ea;
  border-color: rgba(253, 240, 234, var(--divide-opacity));
}

.divide-orange-400 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #f6c66f;
  border-color: rgba(246, 198, 111, var(--divide-opacity));
}

.divide-orange-500 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #F07313;
  border-color: rgba(240, 115, 19, var(--divide-opacity));
}

.divide-orange-800 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #db5d0c;
  border-color: rgba(219, 93, 12, var(--divide-opacity));
}

.divide-orange-900 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #b86814;
  border-color: rgba(184, 104, 20, var(--divide-opacity));
}

.divide-orange-500a25 > :not(template) ~ :not(template){
  border-color: rgba(240,115,23,0.09804);
}

.divide-red-100 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #FEF5F5;
  border-color: rgba(254, 245, 245, var(--divide-opacity));
}

.divide-red-150 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #ffe9e8;
  border-color: rgba(255, 233, 232, var(--divide-opacity));
}

.divide-red-200 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #F8CECC;
  border-color: rgba(248, 206, 204, var(--divide-opacity));
}

.divide-red-300 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #ff8585;
  border-color: rgba(255, 133, 133, var(--divide-opacity));
}

.divide-red-400 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #ff3535;
  border-color: rgba(255, 53, 53, var(--divide-opacity));
}

.divide-red-500 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #DD4746;
  border-color: rgba(221, 71, 70, var(--divide-opacity));
}

.divide-red-700 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #A23C24;
  border-color: rgba(162, 60, 36, var(--divide-opacity));
}

.divide-gray-50 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #F9F9F9;
  border-color: rgba(249, 249, 249, var(--divide-opacity));
}

.divide-gray-100 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #F1F1F2;
  border-color: rgba(241, 241, 242, var(--divide-opacity));
}

.divide-gray-150 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #e6e6e6;
  border-color: rgba(230, 230, 230, var(--divide-opacity));
}

.divide-gray-200 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #E0E2E4;
  border-color: rgba(224, 226, 228, var(--divide-opacity));
}

.divide-gray-300 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #BFBFBF;
  border-color: rgba(191, 191, 191, var(--divide-opacity));
}

.divide-gray-400 > :not(template) ~ :not(template){
  border-color: rgba(114,114,114,0.8);
}

.divide-gray-425 > :not(template) ~ :not(template){
  border-color: rgba(4, 21, 39, 0.8);
}

.divide-gray-450 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #959595;
  border-color: rgba(149, 149, 149, var(--divide-opacity));
}

.divide-gray-500 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #727272;
  border-color: rgba(114, 114, 114, var(--divide-opacity));
}

.divide-gray-600 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #5a626b;
  border-color: rgba(90, 98, 107, var(--divide-opacity));
}

.divide-gray-625 > :not(template) ~ :not(template){
  border-color: rgba(90,98,107,0.8);
}

.divide-gray-700 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #464C59;
  border-color: rgba(70, 76, 89, var(--divide-opacity));
}

.divide-gray-800 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #3c3b3b;
  border-color: rgba(60, 59, 59, var(--divide-opacity));
}

.divide-gray-200a50 > :not(template) ~ :not(template){
  border-color: rgba(224, 226, 228, 0.5);
}

.divide-blue-50 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #f2fbff;
  border-color: rgba(242, 251, 255, var(--divide-opacity));
}

.divide-blue-100 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #EBF6FC;
  border-color: rgba(235, 246, 252, var(--divide-opacity));
}

.divide-blue-150 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #E8EEF1;
  border-color: rgba(232, 238, 241, var(--divide-opacity));
}

.divide-blue-200 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #CCE6F5;
  border-color: rgba(204, 230, 245, var(--divide-opacity));
}

.divide-blue-300 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #73BFE7;
  border-color: rgba(115, 191, 231, var(--divide-opacity));
}

.divide-blue-400 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #4BA4F7;
  border-color: rgba(75, 164, 247, var(--divide-opacity));
}

.divide-blue-500 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #37A4DC;
  border-color: rgba(55, 164, 220, var(--divide-opacity));
}

.divide-blue-600 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #6AA2D6;
  border-color: rgba(106, 162, 214, var(--divide-opacity));
}

.divide-blue-700 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #456E9A;
  border-color: rgba(69, 110, 154, var(--divide-opacity));
}

.divide-blue-750 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #5682AA;
  border-color: rgba(86, 130, 170, var(--divide-opacity));
}

.divide-blue-800 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #1F4566;
  border-color: rgba(31, 69, 102, var(--divide-opacity));
}

.divide-blue-900 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #183453;
  border-color: rgba(24, 52, 83, var(--divide-opacity));
}

.divide-blue-950 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #041527;
  border-color: rgba(4, 21, 39, var(--divide-opacity));
}

.divide-blue-500a25 > :not(template) ~ :not(template){
  border-color: rgba(55, 164, 220, 0.2);
}

.divide-blue-500a50 > :not(template) ~ :not(template){
  border-color: rgba(55, 164, 220, 0.5);
}

.divide-blue-700a75 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #3B648D;
  border-color: rgba(59, 100, 141, var(--divide-opacity));
}

.divide-blue-700a30 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #2A5176;
  border-color: rgba(42, 81, 118, var(--divide-opacity));
}

.divide-blue-750a25 > :not(template) ~ :not(template){
  border-color: rgba(86,130,170,0.09804);
}

.divide-blue-750a15 > :not(template) ~ :not(template){
  border-color: rgba(86,130,170,0.05882);
}

.divide-blue-800a60 > :not(template) ~ :not(template){
  border-color: rgba(31, 69, 102, 0.6);
}

.divide-programEditorTabColors-1 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #3cacae;
  border-color: rgba(60, 172, 174, var(--divide-opacity));
}

.divide-programEditorTabColors-2 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #8e346a;
  border-color: rgba(142, 52, 106, var(--divide-opacity));
}

.divide-programEditorTabColors-3 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #ff72b7;
  border-color: rgba(255, 114, 183, var(--divide-opacity));
}

.divide-programEditorTabColors-4 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #ce941c;
  border-color: rgba(206, 148, 28, var(--divide-opacity));
}

.divide-programEditorTabColors-5 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #b973d9;
  border-color: rgba(185, 115, 217, var(--divide-opacity));
}

.divide-programEditorTabColors-6 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #ff9082;
  border-color: rgba(255, 144, 130, var(--divide-opacity));
}

.divide-programEditorTabColors-1h > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #d9f2f2;
  border-color: rgba(217, 242, 242, var(--divide-opacity));
}

.divide-programEditorTabColors-2h > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #f1dae8;
  border-color: rgba(241, 218, 232, var(--divide-opacity));
}

.divide-programEditorTabColors-3h > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #ffe6f2;
  border-color: rgba(255, 230, 242, var(--divide-opacity));
}

.divide-programEditorTabColors-4h > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #f9ecd2;
  border-color: rgba(249, 236, 210, var(--divide-opacity));
}

.divide-programEditorTabColors-5h > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #f5ebfa;
  border-color: rgba(245, 235, 250, var(--divide-opacity));
}

.divide-programEditorTabColors-6h > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #ffe8e6;
  border-color: rgba(255, 232, 230, var(--divide-opacity));
}

.divide-programEditorPresetTabColors-1 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #798fa3;
  border-color: rgba(121, 143, 163, var(--divide-opacity));
}

.divide-programEditorPresetTabColors-1h > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #798fa3;
  border-color: rgba(121, 143, 163, var(--divide-opacity));
}

.divide-borgScaleColors-0 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #c5d1ff;
  border-color: rgba(197, 209, 255, var(--divide-opacity));
}

.divide-borgScaleColors-1 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #a0b5fc;
  border-color: rgba(160, 181, 252, var(--divide-opacity));
}

.divide-borgScaleColors-2 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #7492ff;
  border-color: rgba(116, 146, 255, var(--divide-opacity));
}

.divide-borgScaleColors-3 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #82bbf1;
  border-color: rgba(130, 187, 241, var(--divide-opacity));
}

.divide-borgScaleColors-4 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #4ba4f7;
  border-color: rgba(75, 164, 247, var(--divide-opacity));
}

.divide-borgScaleColors-5 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #9cdd57;
  border-color: rgba(156, 221, 87, var(--divide-opacity));
}

.divide-borgScaleColors-6 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #68af00;
  border-color: rgba(104, 175, 0, var(--divide-opacity));
}

.divide-borgScaleColors-7 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #f5e380;
  border-color: rgba(245, 227, 128, var(--divide-opacity));
}

.divide-borgScaleColors-8 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #ffc246;
  border-color: rgba(255, 194, 70, var(--divide-opacity));
}

.divide-borgScaleColors-9 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #ff782f;
  border-color: rgba(255, 120, 47, var(--divide-opacity));
}

.divide-borgScaleColors-10 > :not(template) ~ :not(template){
  --divide-opacity: 1;
  border-color: #f25757;
  border-color: rgba(242, 87, 87, var(--divide-opacity));
}

.divide-solid > :not(template) ~ :not(template){
  border-style: solid;
}

.divide-dashed > :not(template) ~ :not(template){
  border-style: dashed;
}

.divide-dotted > :not(template) ~ :not(template){
  border-style: dotted;
}

.divide-double > :not(template) ~ :not(template){
  border-style: double;
}

.divide-none > :not(template) ~ :not(template){
  border-style: none;
}

.divide-opacity-0 > :not(template) ~ :not(template){
  --divide-opacity: 0;
}

.divide-opacity-25 > :not(template) ~ :not(template){
  --divide-opacity: .25;
}

.divide-opacity-50 > :not(template) ~ :not(template){
  --divide-opacity: .5;
}

.divide-opacity-75 > :not(template) ~ :not(template){
  --divide-opacity: .75;
}

.divide-opacity-100 > :not(template) ~ :not(template){
  --divide-opacity: 1;
}

.sr-only{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.not-sr-only{
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.focus\\:sr-only:focus{
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.focus\\:not-sr-only:focus{
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.appearance-none{
  -webkit-appearance: none;
          appearance: none;
}

.bg-fixed{
  background-attachment: fixed;
}

.bg-local{
  background-attachment: local;
}

.bg-scroll{
  background-attachment: scroll;
}

.bg-clip-border{
  background-clip: border-box;
}

.bg-clip-padding{
  background-clip: padding-box;
}

.bg-clip-content{
  background-clip: content-box;
}

.bg-clip-text{
  -webkit-background-clip: text;
          background-clip: text;
}

.bg-transparent{
  background-color: transparent;
}

.bg-focus{
  background-color: rgba(4, 21, 39, 0.8);;
}

.bg-black{
  --bg-opacity: 1;
  background-color: #000;
  background-color: rgba(0, 0, 0, var(--bg-opacity));
}

.bg-white{
  --bg-opacity: 1;
  background-color: #fff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
}

.bg-primary{
  --bg-opacity: 1;
  background-color: #37A4DC;
  background-color: rgba(55, 164, 220, var(--bg-opacity));
}

.bg-disabled{
  --bg-opacity: 1;
  background-color: #BFBFBF;
  background-color: rgba(191, 191, 191, var(--bg-opacity));
}

.bg-translucent-60{
  background-color: rgba(256, 256, 256, 0.6);
}

.bg-translucent-90{
  background-color: rgba(256, 256, 256, 0.9);
}

.bg-green-200{
  --bg-opacity: 1;
  background-color: #f4fcea;
  background-color: rgba(244, 252, 234, var(--bg-opacity));
}

.bg-green-400{
  --bg-opacity: 1;
  background-color: #6CCA98;
  background-color: rgba(108, 202, 152, var(--bg-opacity));
}

.bg-green-500{
  --bg-opacity: 1;
  background-color: #97E812;
  background-color: rgba(151, 232, 18, var(--bg-opacity));
}

.bg-green-600{
  --bg-opacity: 1;
  background-color: #4f9112;
  background-color: rgba(79, 145, 18, var(--bg-opacity));
}

.bg-green-700{
  --bg-opacity: 1;
  background-color: #3e7211;
  background-color: rgba(62, 114, 17, var(--bg-opacity));
}

.bg-green-400a50{
  background-color: rgba(108,202,152,0.50196);
}

.bg-green-500a25{
  background-color: rgba(151,232,18,0.09804);
}

.bg-yellow-200{
  --bg-opacity: 1;
  background-color: #fff9eb;
  background-color: rgba(255, 249, 235, var(--bg-opacity));
}

.bg-yellow-300{
  --bg-opacity: 1;
  background-color: #ffe9bd;
  background-color: rgba(255, 233, 189, var(--bg-opacity));
}

.bg-yellow-500{
  --bg-opacity: 1;
  background-color: #FFC82C;
  background-color: rgba(255, 200, 44, var(--bg-opacity));
}

.bg-yellow-600{
  --bg-opacity: 1;
  background-color: #F7931E;
  background-color: rgba(247, 147, 30, var(--bg-opacity));
}

.bg-yellow-700{
  --bg-opacity: 1;
  background-color: #E1AD28;
  background-color: rgba(225, 173, 40, var(--bg-opacity));
}

.bg-yellow-300a66{
  background-color: rgba(255,233,189,0.66667);
}

.bg-yellow-500a25{
  background-color: rgba(255,200,44,0.09804);
}

.bg-orange-200{
  --bg-opacity: 1;
  background-color: #fdf0ea;
  background-color: rgba(253, 240, 234, var(--bg-opacity));
}

.bg-orange-400{
  --bg-opacity: 1;
  background-color: #f6c66f;
  background-color: rgba(246, 198, 111, var(--bg-opacity));
}

.bg-orange-500{
  --bg-opacity: 1;
  background-color: #F07313;
  background-color: rgba(240, 115, 19, var(--bg-opacity));
}

.bg-orange-800{
  --bg-opacity: 1;
  background-color: #db5d0c;
  background-color: rgba(219, 93, 12, var(--bg-opacity));
}

.bg-orange-900{
  --bg-opacity: 1;
  background-color: #b86814;
  background-color: rgba(184, 104, 20, var(--bg-opacity));
}

.bg-orange-500a25{
  background-color: rgba(240,115,23,0.09804);
}

.bg-red-100{
  --bg-opacity: 1;
  background-color: #FEF5F5;
  background-color: rgba(254, 245, 245, var(--bg-opacity));
}

.bg-red-150{
  --bg-opacity: 1;
  background-color: #ffe9e8;
  background-color: rgba(255, 233, 232, var(--bg-opacity));
}

.bg-red-200{
  --bg-opacity: 1;
  background-color: #F8CECC;
  background-color: rgba(248, 206, 204, var(--bg-opacity));
}

.bg-red-300{
  --bg-opacity: 1;
  background-color: #ff8585;
  background-color: rgba(255, 133, 133, var(--bg-opacity));
}

.bg-red-400{
  --bg-opacity: 1;
  background-color: #ff3535;
  background-color: rgba(255, 53, 53, var(--bg-opacity));
}

.bg-red-500{
  --bg-opacity: 1;
  background-color: #DD4746;
  background-color: rgba(221, 71, 70, var(--bg-opacity));
}

.bg-red-700{
  --bg-opacity: 1;
  background-color: #A23C24;
  background-color: rgba(162, 60, 36, var(--bg-opacity));
}

.bg-gray-50{
  --bg-opacity: 1;
  background-color: #F9F9F9;
  background-color: rgba(249, 249, 249, var(--bg-opacity));
}

.bg-gray-100{
  --bg-opacity: 1;
  background-color: #F1F1F2;
  background-color: rgba(241, 241, 242, var(--bg-opacity));
}

.bg-gray-150{
  --bg-opacity: 1;
  background-color: #e6e6e6;
  background-color: rgba(230, 230, 230, var(--bg-opacity));
}

.bg-gray-200{
  --bg-opacity: 1;
  background-color: #E0E2E4;
  background-color: rgba(224, 226, 228, var(--bg-opacity));
}

.bg-gray-300{
  --bg-opacity: 1;
  background-color: #BFBFBF;
  background-color: rgba(191, 191, 191, var(--bg-opacity));
}

.bg-gray-400{
  background-color: rgba(114,114,114,0.8);
}

.bg-gray-425{
  background-color: rgba(4, 21, 39, 0.8);
}

.bg-gray-450{
  --bg-opacity: 1;
  background-color: #959595;
  background-color: rgba(149, 149, 149, var(--bg-opacity));
}

.bg-gray-500{
  --bg-opacity: 1;
  background-color: #727272;
  background-color: rgba(114, 114, 114, var(--bg-opacity));
}

.bg-gray-600{
  --bg-opacity: 1;
  background-color: #5a626b;
  background-color: rgba(90, 98, 107, var(--bg-opacity));
}

.bg-gray-625{
  background-color: rgba(90,98,107,0.8);
}

.bg-gray-700{
  --bg-opacity: 1;
  background-color: #464C59;
  background-color: rgba(70, 76, 89, var(--bg-opacity));
}

.bg-gray-800{
  --bg-opacity: 1;
  background-color: #3c3b3b;
  background-color: rgba(60, 59, 59, var(--bg-opacity));
}

.bg-gray-200a50{
  background-color: rgba(224, 226, 228, 0.5);
}

.bg-blue-50{
  --bg-opacity: 1;
  background-color: #f2fbff;
  background-color: rgba(242, 251, 255, var(--bg-opacity));
}

.bg-blue-100{
  --bg-opacity: 1;
  background-color: #EBF6FC;
  background-color: rgba(235, 246, 252, var(--bg-opacity));
}

.bg-blue-150{
  --bg-opacity: 1;
  background-color: #E8EEF1;
  background-color: rgba(232, 238, 241, var(--bg-opacity));
}

.bg-blue-200{
  --bg-opacity: 1;
  background-color: #CCE6F5;
  background-color: rgba(204, 230, 245, var(--bg-opacity));
}

.bg-blue-300{
  --bg-opacity: 1;
  background-color: #73BFE7;
  background-color: rgba(115, 191, 231, var(--bg-opacity));
}

.bg-blue-400{
  --bg-opacity: 1;
  background-color: #4BA4F7;
  background-color: rgba(75, 164, 247, var(--bg-opacity));
}

.bg-blue-500{
  --bg-opacity: 1;
  background-color: #37A4DC;
  background-color: rgba(55, 164, 220, var(--bg-opacity));
}

.bg-blue-600{
  --bg-opacity: 1;
  background-color: #6AA2D6;
  background-color: rgba(106, 162, 214, var(--bg-opacity));
}

.bg-blue-700{
  --bg-opacity: 1;
  background-color: #456E9A;
  background-color: rgba(69, 110, 154, var(--bg-opacity));
}

.bg-blue-750{
  --bg-opacity: 1;
  background-color: #5682AA;
  background-color: rgba(86, 130, 170, var(--bg-opacity));
}

.bg-blue-800{
  --bg-opacity: 1;
  background-color: #1F4566;
  background-color: rgba(31, 69, 102, var(--bg-opacity));
}

.bg-blue-900{
  --bg-opacity: 1;
  background-color: #183453;
  background-color: rgba(24, 52, 83, var(--bg-opacity));
}

.bg-blue-950{
  --bg-opacity: 1;
  background-color: #041527;
  background-color: rgba(4, 21, 39, var(--bg-opacity));
}

.bg-blue-500a25{
  background-color: rgba(55, 164, 220, 0.2);
}

.bg-blue-500a50{
  background-color: rgba(55, 164, 220, 0.5);
}

.bg-blue-700a75{
  --bg-opacity: 1;
  background-color: #3B648D;
  background-color: rgba(59, 100, 141, var(--bg-opacity));
}

.bg-blue-700a30{
  --bg-opacity: 1;
  background-color: #2A5176;
  background-color: rgba(42, 81, 118, var(--bg-opacity));
}

.bg-blue-750a25{
  background-color: rgba(86,130,170,0.09804);
}

.bg-blue-750a15{
  background-color: rgba(86,130,170,0.05882);
}

.bg-blue-800a60{
  background-color: rgba(31, 69, 102, 0.6);
}

.bg-programEditorTabColors-1{
  --bg-opacity: 1;
  background-color: #3cacae;
  background-color: rgba(60, 172, 174, var(--bg-opacity));
}

.bg-programEditorTabColors-2{
  --bg-opacity: 1;
  background-color: #8e346a;
  background-color: rgba(142, 52, 106, var(--bg-opacity));
}

.bg-programEditorTabColors-3{
  --bg-opacity: 1;
  background-color: #ff72b7;
  background-color: rgba(255, 114, 183, var(--bg-opacity));
}

.bg-programEditorTabColors-4{
  --bg-opacity: 1;
  background-color: #ce941c;
  background-color: rgba(206, 148, 28, var(--bg-opacity));
}

.bg-programEditorTabColors-5{
  --bg-opacity: 1;
  background-color: #b973d9;
  background-color: rgba(185, 115, 217, var(--bg-opacity));
}

.bg-programEditorTabColors-6{
  --bg-opacity: 1;
  background-color: #ff9082;
  background-color: rgba(255, 144, 130, var(--bg-opacity));
}

.bg-programEditorTabColors-1h{
  --bg-opacity: 1;
  background-color: #d9f2f2;
  background-color: rgba(217, 242, 242, var(--bg-opacity));
}

.bg-programEditorTabColors-2h{
  --bg-opacity: 1;
  background-color: #f1dae8;
  background-color: rgba(241, 218, 232, var(--bg-opacity));
}

.bg-programEditorTabColors-3h{
  --bg-opacity: 1;
  background-color: #ffe6f2;
  background-color: rgba(255, 230, 242, var(--bg-opacity));
}

.bg-programEditorTabColors-4h{
  --bg-opacity: 1;
  background-color: #f9ecd2;
  background-color: rgba(249, 236, 210, var(--bg-opacity));
}

.bg-programEditorTabColors-5h{
  --bg-opacity: 1;
  background-color: #f5ebfa;
  background-color: rgba(245, 235, 250, var(--bg-opacity));
}

.bg-programEditorTabColors-6h{
  --bg-opacity: 1;
  background-color: #ffe8e6;
  background-color: rgba(255, 232, 230, var(--bg-opacity));
}

.bg-programEditorPresetTabColors-1{
  --bg-opacity: 1;
  background-color: #798fa3;
  background-color: rgba(121, 143, 163, var(--bg-opacity));
}

.bg-programEditorPresetTabColors-1h{
  --bg-opacity: 1;
  background-color: #798fa3;
  background-color: rgba(121, 143, 163, var(--bg-opacity));
}

.bg-borgScaleColors-0{
  --bg-opacity: 1;
  background-color: #c5d1ff;
  background-color: rgba(197, 209, 255, var(--bg-opacity));
}

.bg-borgScaleColors-1{
  --bg-opacity: 1;
  background-color: #a0b5fc;
  background-color: rgba(160, 181, 252, var(--bg-opacity));
}

.bg-borgScaleColors-2{
  --bg-opacity: 1;
  background-color: #7492ff;
  background-color: rgba(116, 146, 255, var(--bg-opacity));
}

.bg-borgScaleColors-3{
  --bg-opacity: 1;
  background-color: #82bbf1;
  background-color: rgba(130, 187, 241, var(--bg-opacity));
}

.bg-borgScaleColors-4{
  --bg-opacity: 1;
  background-color: #4ba4f7;
  background-color: rgba(75, 164, 247, var(--bg-opacity));
}

.bg-borgScaleColors-5{
  --bg-opacity: 1;
  background-color: #9cdd57;
  background-color: rgba(156, 221, 87, var(--bg-opacity));
}

.bg-borgScaleColors-6{
  --bg-opacity: 1;
  background-color: #68af00;
  background-color: rgba(104, 175, 0, var(--bg-opacity));
}

.bg-borgScaleColors-7{
  --bg-opacity: 1;
  background-color: #f5e380;
  background-color: rgba(245, 227, 128, var(--bg-opacity));
}

.bg-borgScaleColors-8{
  --bg-opacity: 1;
  background-color: #ffc246;
  background-color: rgba(255, 194, 70, var(--bg-opacity));
}

.bg-borgScaleColors-9{
  --bg-opacity: 1;
  background-color: #ff782f;
  background-color: rgba(255, 120, 47, var(--bg-opacity));
}

.bg-borgScaleColors-10{
  --bg-opacity: 1;
  background-color: #f25757;
  background-color: rgba(242, 87, 87, var(--bg-opacity));
}

.hover\\:bg-transparent:hover{
  background-color: transparent;
}

.hover\\:bg-focus:hover{
  background-color: rgba(4, 21, 39, 0.8);;
}

.hover\\:bg-black:hover{
  --bg-opacity: 1;
  background-color: #000;
  background-color: rgba(0, 0, 0, var(--bg-opacity));
}

.hover\\:bg-white:hover{
  --bg-opacity: 1;
  background-color: #fff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
}

.hover\\:bg-primary:hover{
  --bg-opacity: 1;
  background-color: #37A4DC;
  background-color: rgba(55, 164, 220, var(--bg-opacity));
}

.hover\\:bg-disabled:hover{
  --bg-opacity: 1;
  background-color: #BFBFBF;
  background-color: rgba(191, 191, 191, var(--bg-opacity));
}

.hover\\:bg-translucent-60:hover{
  background-color: rgba(256, 256, 256, 0.6);
}

.hover\\:bg-translucent-90:hover{
  background-color: rgba(256, 256, 256, 0.9);
}

.hover\\:bg-green-200:hover{
  --bg-opacity: 1;
  background-color: #f4fcea;
  background-color: rgba(244, 252, 234, var(--bg-opacity));
}

.hover\\:bg-green-400:hover{
  --bg-opacity: 1;
  background-color: #6CCA98;
  background-color: rgba(108, 202, 152, var(--bg-opacity));
}

.hover\\:bg-green-500:hover{
  --bg-opacity: 1;
  background-color: #97E812;
  background-color: rgba(151, 232, 18, var(--bg-opacity));
}

.hover\\:bg-green-600:hover{
  --bg-opacity: 1;
  background-color: #4f9112;
  background-color: rgba(79, 145, 18, var(--bg-opacity));
}

.hover\\:bg-green-700:hover{
  --bg-opacity: 1;
  background-color: #3e7211;
  background-color: rgba(62, 114, 17, var(--bg-opacity));
}

.hover\\:bg-green-400a50:hover{
  background-color: rgba(108,202,152,0.50196);
}

.hover\\:bg-green-500a25:hover{
  background-color: rgba(151,232,18,0.09804);
}

.hover\\:bg-yellow-200:hover{
  --bg-opacity: 1;
  background-color: #fff9eb;
  background-color: rgba(255, 249, 235, var(--bg-opacity));
}

.hover\\:bg-yellow-300:hover{
  --bg-opacity: 1;
  background-color: #ffe9bd;
  background-color: rgba(255, 233, 189, var(--bg-opacity));
}

.hover\\:bg-yellow-500:hover{
  --bg-opacity: 1;
  background-color: #FFC82C;
  background-color: rgba(255, 200, 44, var(--bg-opacity));
}

.hover\\:bg-yellow-600:hover{
  --bg-opacity: 1;
  background-color: #F7931E;
  background-color: rgba(247, 147, 30, var(--bg-opacity));
}

.hover\\:bg-yellow-700:hover{
  --bg-opacity: 1;
  background-color: #E1AD28;
  background-color: rgba(225, 173, 40, var(--bg-opacity));
}

.hover\\:bg-yellow-300a66:hover{
  background-color: rgba(255,233,189,0.66667);
}

.hover\\:bg-yellow-500a25:hover{
  background-color: rgba(255,200,44,0.09804);
}

.hover\\:bg-orange-200:hover{
  --bg-opacity: 1;
  background-color: #fdf0ea;
  background-color: rgba(253, 240, 234, var(--bg-opacity));
}

.hover\\:bg-orange-400:hover{
  --bg-opacity: 1;
  background-color: #f6c66f;
  background-color: rgba(246, 198, 111, var(--bg-opacity));
}

.hover\\:bg-orange-500:hover{
  --bg-opacity: 1;
  background-color: #F07313;
  background-color: rgba(240, 115, 19, var(--bg-opacity));
}

.hover\\:bg-orange-800:hover{
  --bg-opacity: 1;
  background-color: #db5d0c;
  background-color: rgba(219, 93, 12, var(--bg-opacity));
}

.hover\\:bg-orange-900:hover{
  --bg-opacity: 1;
  background-color: #b86814;
  background-color: rgba(184, 104, 20, var(--bg-opacity));
}

.hover\\:bg-orange-500a25:hover{
  background-color: rgba(240,115,23,0.09804);
}

.hover\\:bg-red-100:hover{
  --bg-opacity: 1;
  background-color: #FEF5F5;
  background-color: rgba(254, 245, 245, var(--bg-opacity));
}

.hover\\:bg-red-150:hover{
  --bg-opacity: 1;
  background-color: #ffe9e8;
  background-color: rgba(255, 233, 232, var(--bg-opacity));
}

.hover\\:bg-red-200:hover{
  --bg-opacity: 1;
  background-color: #F8CECC;
  background-color: rgba(248, 206, 204, var(--bg-opacity));
}

.hover\\:bg-red-300:hover{
  --bg-opacity: 1;
  background-color: #ff8585;
  background-color: rgba(255, 133, 133, var(--bg-opacity));
}

.hover\\:bg-red-400:hover{
  --bg-opacity: 1;
  background-color: #ff3535;
  background-color: rgba(255, 53, 53, var(--bg-opacity));
}

.hover\\:bg-red-500:hover{
  --bg-opacity: 1;
  background-color: #DD4746;
  background-color: rgba(221, 71, 70, var(--bg-opacity));
}

.hover\\:bg-red-700:hover{
  --bg-opacity: 1;
  background-color: #A23C24;
  background-color: rgba(162, 60, 36, var(--bg-opacity));
}

.hover\\:bg-gray-50:hover{
  --bg-opacity: 1;
  background-color: #F9F9F9;
  background-color: rgba(249, 249, 249, var(--bg-opacity));
}

.hover\\:bg-gray-100:hover{
  --bg-opacity: 1;
  background-color: #F1F1F2;
  background-color: rgba(241, 241, 242, var(--bg-opacity));
}

.hover\\:bg-gray-150:hover{
  --bg-opacity: 1;
  background-color: #e6e6e6;
  background-color: rgba(230, 230, 230, var(--bg-opacity));
}

.hover\\:bg-gray-200:hover{
  --bg-opacity: 1;
  background-color: #E0E2E4;
  background-color: rgba(224, 226, 228, var(--bg-opacity));
}

.hover\\:bg-gray-300:hover{
  --bg-opacity: 1;
  background-color: #BFBFBF;
  background-color: rgba(191, 191, 191, var(--bg-opacity));
}

.hover\\:bg-gray-400:hover{
  background-color: rgba(114,114,114,0.8);
}

.hover\\:bg-gray-425:hover{
  background-color: rgba(4, 21, 39, 0.8);
}

.hover\\:bg-gray-450:hover{
  --bg-opacity: 1;
  background-color: #959595;
  background-color: rgba(149, 149, 149, var(--bg-opacity));
}

.hover\\:bg-gray-500:hover{
  --bg-opacity: 1;
  background-color: #727272;
  background-color: rgba(114, 114, 114, var(--bg-opacity));
}

.hover\\:bg-gray-600:hover{
  --bg-opacity: 1;
  background-color: #5a626b;
  background-color: rgba(90, 98, 107, var(--bg-opacity));
}

.hover\\:bg-gray-625:hover{
  background-color: rgba(90,98,107,0.8);
}

.hover\\:bg-gray-700:hover{
  --bg-opacity: 1;
  background-color: #464C59;
  background-color: rgba(70, 76, 89, var(--bg-opacity));
}

.hover\\:bg-gray-800:hover{
  --bg-opacity: 1;
  background-color: #3c3b3b;
  background-color: rgba(60, 59, 59, var(--bg-opacity));
}

.hover\\:bg-gray-200a50:hover{
  background-color: rgba(224, 226, 228, 0.5);
}

.hover\\:bg-blue-50:hover{
  --bg-opacity: 1;
  background-color: #f2fbff;
  background-color: rgba(242, 251, 255, var(--bg-opacity));
}

.hover\\:bg-blue-100:hover{
  --bg-opacity: 1;
  background-color: #EBF6FC;
  background-color: rgba(235, 246, 252, var(--bg-opacity));
}

.hover\\:bg-blue-150:hover{
  --bg-opacity: 1;
  background-color: #E8EEF1;
  background-color: rgba(232, 238, 241, var(--bg-opacity));
}

.hover\\:bg-blue-200:hover{
  --bg-opacity: 1;
  background-color: #CCE6F5;
  background-color: rgba(204, 230, 245, var(--bg-opacity));
}

.hover\\:bg-blue-300:hover{
  --bg-opacity: 1;
  background-color: #73BFE7;
  background-color: rgba(115, 191, 231, var(--bg-opacity));
}

.hover\\:bg-blue-400:hover{
  --bg-opacity: 1;
  background-color: #4BA4F7;
  background-color: rgba(75, 164, 247, var(--bg-opacity));
}

.hover\\:bg-blue-500:hover{
  --bg-opacity: 1;
  background-color: #37A4DC;
  background-color: rgba(55, 164, 220, var(--bg-opacity));
}

.hover\\:bg-blue-600:hover{
  --bg-opacity: 1;
  background-color: #6AA2D6;
  background-color: rgba(106, 162, 214, var(--bg-opacity));
}

.hover\\:bg-blue-700:hover{
  --bg-opacity: 1;
  background-color: #456E9A;
  background-color: rgba(69, 110, 154, var(--bg-opacity));
}

.hover\\:bg-blue-750:hover{
  --bg-opacity: 1;
  background-color: #5682AA;
  background-color: rgba(86, 130, 170, var(--bg-opacity));
}

.hover\\:bg-blue-800:hover{
  --bg-opacity: 1;
  background-color: #1F4566;
  background-color: rgba(31, 69, 102, var(--bg-opacity));
}

.hover\\:bg-blue-900:hover{
  --bg-opacity: 1;
  background-color: #183453;
  background-color: rgba(24, 52, 83, var(--bg-opacity));
}

.hover\\:bg-blue-950:hover{
  --bg-opacity: 1;
  background-color: #041527;
  background-color: rgba(4, 21, 39, var(--bg-opacity));
}

.hover\\:bg-blue-500a25:hover{
  background-color: rgba(55, 164, 220, 0.2);
}

.hover\\:bg-blue-500a50:hover{
  background-color: rgba(55, 164, 220, 0.5);
}

.hover\\:bg-blue-700a75:hover{
  --bg-opacity: 1;
  background-color: #3B648D;
  background-color: rgba(59, 100, 141, var(--bg-opacity));
}

.hover\\:bg-blue-700a30:hover{
  --bg-opacity: 1;
  background-color: #2A5176;
  background-color: rgba(42, 81, 118, var(--bg-opacity));
}

.hover\\:bg-blue-750a25:hover{
  background-color: rgba(86,130,170,0.09804);
}

.hover\\:bg-blue-750a15:hover{
  background-color: rgba(86,130,170,0.05882);
}

.hover\\:bg-blue-800a60:hover{
  background-color: rgba(31, 69, 102, 0.6);
}

.hover\\:bg-programEditorTabColors-1:hover{
  --bg-opacity: 1;
  background-color: #3cacae;
  background-color: rgba(60, 172, 174, var(--bg-opacity));
}

.hover\\:bg-programEditorTabColors-2:hover{
  --bg-opacity: 1;
  background-color: #8e346a;
  background-color: rgba(142, 52, 106, var(--bg-opacity));
}

.hover\\:bg-programEditorTabColors-3:hover{
  --bg-opacity: 1;
  background-color: #ff72b7;
  background-color: rgba(255, 114, 183, var(--bg-opacity));
}

.hover\\:bg-programEditorTabColors-4:hover{
  --bg-opacity: 1;
  background-color: #ce941c;
  background-color: rgba(206, 148, 28, var(--bg-opacity));
}

.hover\\:bg-programEditorTabColors-5:hover{
  --bg-opacity: 1;
  background-color: #b973d9;
  background-color: rgba(185, 115, 217, var(--bg-opacity));
}

.hover\\:bg-programEditorTabColors-6:hover{
  --bg-opacity: 1;
  background-color: #ff9082;
  background-color: rgba(255, 144, 130, var(--bg-opacity));
}

.hover\\:bg-programEditorTabColors-1h:hover{
  --bg-opacity: 1;
  background-color: #d9f2f2;
  background-color: rgba(217, 242, 242, var(--bg-opacity));
}

.hover\\:bg-programEditorTabColors-2h:hover{
  --bg-opacity: 1;
  background-color: #f1dae8;
  background-color: rgba(241, 218, 232, var(--bg-opacity));
}

.hover\\:bg-programEditorTabColors-3h:hover{
  --bg-opacity: 1;
  background-color: #ffe6f2;
  background-color: rgba(255, 230, 242, var(--bg-opacity));
}

.hover\\:bg-programEditorTabColors-4h:hover{
  --bg-opacity: 1;
  background-color: #f9ecd2;
  background-color: rgba(249, 236, 210, var(--bg-opacity));
}

.hover\\:bg-programEditorTabColors-5h:hover{
  --bg-opacity: 1;
  background-color: #f5ebfa;
  background-color: rgba(245, 235, 250, var(--bg-opacity));
}

.hover\\:bg-programEditorTabColors-6h:hover{
  --bg-opacity: 1;
  background-color: #ffe8e6;
  background-color: rgba(255, 232, 230, var(--bg-opacity));
}

.hover\\:bg-programEditorPresetTabColors-1:hover{
  --bg-opacity: 1;
  background-color: #798fa3;
  background-color: rgba(121, 143, 163, var(--bg-opacity));
}

.hover\\:bg-programEditorPresetTabColors-1h:hover{
  --bg-opacity: 1;
  background-color: #798fa3;
  background-color: rgba(121, 143, 163, var(--bg-opacity));
}

.hover\\:bg-borgScaleColors-0:hover{
  --bg-opacity: 1;
  background-color: #c5d1ff;
  background-color: rgba(197, 209, 255, var(--bg-opacity));
}

.hover\\:bg-borgScaleColors-1:hover{
  --bg-opacity: 1;
  background-color: #a0b5fc;
  background-color: rgba(160, 181, 252, var(--bg-opacity));
}

.hover\\:bg-borgScaleColors-2:hover{
  --bg-opacity: 1;
  background-color: #7492ff;
  background-color: rgba(116, 146, 255, var(--bg-opacity));
}

.hover\\:bg-borgScaleColors-3:hover{
  --bg-opacity: 1;
  background-color: #82bbf1;
  background-color: rgba(130, 187, 241, var(--bg-opacity));
}

.hover\\:bg-borgScaleColors-4:hover{
  --bg-opacity: 1;
  background-color: #4ba4f7;
  background-color: rgba(75, 164, 247, var(--bg-opacity));
}

.hover\\:bg-borgScaleColors-5:hover{
  --bg-opacity: 1;
  background-color: #9cdd57;
  background-color: rgba(156, 221, 87, var(--bg-opacity));
}

.hover\\:bg-borgScaleColors-6:hover{
  --bg-opacity: 1;
  background-color: #68af00;
  background-color: rgba(104, 175, 0, var(--bg-opacity));
}

.hover\\:bg-borgScaleColors-7:hover{
  --bg-opacity: 1;
  background-color: #f5e380;
  background-color: rgba(245, 227, 128, var(--bg-opacity));
}

.hover\\:bg-borgScaleColors-8:hover{
  --bg-opacity: 1;
  background-color: #ffc246;
  background-color: rgba(255, 194, 70, var(--bg-opacity));
}

.hover\\:bg-borgScaleColors-9:hover{
  --bg-opacity: 1;
  background-color: #ff782f;
  background-color: rgba(255, 120, 47, var(--bg-opacity));
}

.hover\\:bg-borgScaleColors-10:hover{
  --bg-opacity: 1;
  background-color: #f25757;
  background-color: rgba(242, 87, 87, var(--bg-opacity));
}

.focus\\:bg-transparent:focus{
  background-color: transparent;
}

.focus\\:bg-focus:focus{
  background-color: rgba(4, 21, 39, 0.8);;
}

.focus\\:bg-black:focus{
  --bg-opacity: 1;
  background-color: #000;
  background-color: rgba(0, 0, 0, var(--bg-opacity));
}

.focus\\:bg-white:focus{
  --bg-opacity: 1;
  background-color: #fff;
  background-color: rgba(255, 255, 255, var(--bg-opacity));
}

.focus\\:bg-primary:focus{
  --bg-opacity: 1;
  background-color: #37A4DC;
  background-color: rgba(55, 164, 220, var(--bg-opacity));
}

.focus\\:bg-disabled:focus{
  --bg-opacity: 1;
  background-color: #BFBFBF;
  background-color: rgba(191, 191, 191, var(--bg-opacity));
}

.focus\\:bg-translucent-60:focus{
  background-color: rgba(256, 256, 256, 0.6);
}

.focus\\:bg-translucent-90:focus{
  background-color: rgba(256, 256, 256, 0.9);
}

.focus\\:bg-green-200:focus{
  --bg-opacity: 1;
  background-color: #f4fcea;
  background-color: rgba(244, 252, 234, var(--bg-opacity));
}

.focus\\:bg-green-400:focus{
  --bg-opacity: 1;
  background-color: #6CCA98;
  background-color: rgba(108, 202, 152, var(--bg-opacity));
}

.focus\\:bg-green-500:focus{
  --bg-opacity: 1;
  background-color: #97E812;
  background-color: rgba(151, 232, 18, var(--bg-opacity));
}

.focus\\:bg-green-600:focus{
  --bg-opacity: 1;
  background-color: #4f9112;
  background-color: rgba(79, 145, 18, var(--bg-opacity));
}

.focus\\:bg-green-700:focus{
  --bg-opacity: 1;
  background-color: #3e7211;
  background-color: rgba(62, 114, 17, var(--bg-opacity));
}

.focus\\:bg-green-400a50:focus{
  background-color: rgba(108,202,152,0.50196);
}

.focus\\:bg-green-500a25:focus{
  background-color: rgba(151,232,18,0.09804);
}

.focus\\:bg-yellow-200:focus{
  --bg-opacity: 1;
  background-color: #fff9eb;
  background-color: rgba(255, 249, 235, var(--bg-opacity));
}

.focus\\:bg-yellow-300:focus{
  --bg-opacity: 1;
  background-color: #ffe9bd;
  background-color: rgba(255, 233, 189, var(--bg-opacity));
}

.focus\\:bg-yellow-500:focus{
  --bg-opacity: 1;
  background-color: #FFC82C;
  background-color: rgba(255, 200, 44, var(--bg-opacity));
}

.focus\\:bg-yellow-600:focus{
  --bg-opacity: 1;
  background-color: #F7931E;
  background-color: rgba(247, 147, 30, var(--bg-opacity));
}

.focus\\:bg-yellow-700:focus{
  --bg-opacity: 1;
  background-color: #E1AD28;
  background-color: rgba(225, 173, 40, var(--bg-opacity));
}

.focus\\:bg-yellow-300a66:focus{
  background-color: rgba(255,233,189,0.66667);
}

.focus\\:bg-yellow-500a25:focus{
  background-color: rgba(255,200,44,0.09804);
}

.focus\\:bg-orange-200:focus{
  --bg-opacity: 1;
  background-color: #fdf0ea;
  background-color: rgba(253, 240, 234, var(--bg-opacity));
}

.focus\\:bg-orange-400:focus{
  --bg-opacity: 1;
  background-color: #f6c66f;
  background-color: rgba(246, 198, 111, var(--bg-opacity));
}

.focus\\:bg-orange-500:focus{
  --bg-opacity: 1;
  background-color: #F07313;
  background-color: rgba(240, 115, 19, var(--bg-opacity));
}

.focus\\:bg-orange-800:focus{
  --bg-opacity: 1;
  background-color: #db5d0c;
  background-color: rgba(219, 93, 12, var(--bg-opacity));
}

.focus\\:bg-orange-900:focus{
  --bg-opacity: 1;
  background-color: #b86814;
  background-color: rgba(184, 104, 20, var(--bg-opacity));
}

.focus\\:bg-orange-500a25:focus{
  background-color: rgba(240,115,23,0.09804);
}

.focus\\:bg-red-100:focus{
  --bg-opacity: 1;
  background-color: #FEF5F5;
  background-color: rgba(254, 245, 245, var(--bg-opacity));
}

.focus\\:bg-red-150:focus{
  --bg-opacity: 1;
  background-color: #ffe9e8;
  background-color: rgba(255, 233, 232, var(--bg-opacity));
}

.focus\\:bg-red-200:focus{
  --bg-opacity: 1;
  background-color: #F8CECC;
  background-color: rgba(248, 206, 204, var(--bg-opacity));
}

.focus\\:bg-red-300:focus{
  --bg-opacity: 1;
  background-color: #ff8585;
  background-color: rgba(255, 133, 133, var(--bg-opacity));
}

.focus\\:bg-red-400:focus{
  --bg-opacity: 1;
  background-color: #ff3535;
  background-color: rgba(255, 53, 53, var(--bg-opacity));
}

.focus\\:bg-red-500:focus{
  --bg-opacity: 1;
  background-color: #DD4746;
  background-color: rgba(221, 71, 70, var(--bg-opacity));
}

.focus\\:bg-red-700:focus{
  --bg-opacity: 1;
  background-color: #A23C24;
  background-color: rgba(162, 60, 36, var(--bg-opacity));
}

.focus\\:bg-gray-50:focus{
  --bg-opacity: 1;
  background-color: #F9F9F9;
  background-color: rgba(249, 249, 249, var(--bg-opacity));
}

.focus\\:bg-gray-100:focus{
  --bg-opacity: 1;
  background-color: #F1F1F2;
  background-color: rgba(241, 241, 242, var(--bg-opacity));
}

.focus\\:bg-gray-150:focus{
  --bg-opacity: 1;
  background-color: #e6e6e6;
  background-color: rgba(230, 230, 230, var(--bg-opacity));
}

.focus\\:bg-gray-200:focus{
  --bg-opacity: 1;
  background-color: #E0E2E4;
  background-color: rgba(224, 226, 228, var(--bg-opacity));
}

.focus\\:bg-gray-300:focus{
  --bg-opacity: 1;
  background-color: #BFBFBF;
  background-color: rgba(191, 191, 191, var(--bg-opacity));
}

.focus\\:bg-gray-400:focus{
  background-color: rgba(114,114,114,0.8);
}

.focus\\:bg-gray-425:focus{
  background-color: rgba(4, 21, 39, 0.8);
}

.focus\\:bg-gray-450:focus{
  --bg-opacity: 1;
  background-color: #959595;
  background-color: rgba(149, 149, 149, var(--bg-opacity));
}

.focus\\:bg-gray-500:focus{
  --bg-opacity: 1;
  background-color: #727272;
  background-color: rgba(114, 114, 114, var(--bg-opacity));
}

.focus\\:bg-gray-600:focus{
  --bg-opacity: 1;
  background-color: #5a626b;
  background-color: rgba(90, 98, 107, var(--bg-opacity));
}

.focus\\:bg-gray-625:focus{
  background-color: rgba(90,98,107,0.8);
}

.focus\\:bg-gray-700:focus{
  --bg-opacity: 1;
  background-color: #464C59;
  background-color: rgba(70, 76, 89, var(--bg-opacity));
}

.focus\\:bg-gray-800:focus{
  --bg-opacity: 1;
  background-color: #3c3b3b;
  background-color: rgba(60, 59, 59, var(--bg-opacity));
}

.focus\\:bg-gray-200a50:focus{
  background-color: rgba(224, 226, 228, 0.5);
}

.focus\\:bg-blue-50:focus{
  --bg-opacity: 1;
  background-color: #f2fbff;
  background-color: rgba(242, 251, 255, var(--bg-opacity));
}

.focus\\:bg-blue-100:focus{
  --bg-opacity: 1;
  background-color: #EBF6FC;
  background-color: rgba(235, 246, 252, var(--bg-opacity));
}

.focus\\:bg-blue-150:focus{
  --bg-opacity: 1;
  background-color: #E8EEF1;
  background-color: rgba(232, 238, 241, var(--bg-opacity));
}

.focus\\:bg-blue-200:focus{
  --bg-opacity: 1;
  background-color: #CCE6F5;
  background-color: rgba(204, 230, 245, var(--bg-opacity));
}

.focus\\:bg-blue-300:focus{
  --bg-opacity: 1;
  background-color: #73BFE7;
  background-color: rgba(115, 191, 231, var(--bg-opacity));
}

.focus\\:bg-blue-400:focus{
  --bg-opacity: 1;
  background-color: #4BA4F7;
  background-color: rgba(75, 164, 247, var(--bg-opacity));
}

.focus\\:bg-blue-500:focus{
  --bg-opacity: 1;
  background-color: #37A4DC;
  background-color: rgba(55, 164, 220, var(--bg-opacity));
}

.focus\\:bg-blue-600:focus{
  --bg-opacity: 1;
  background-color: #6AA2D6;
  background-color: rgba(106, 162, 214, var(--bg-opacity));
}

.focus\\:bg-blue-700:focus{
  --bg-opacity: 1;
  background-color: #456E9A;
  background-color: rgba(69, 110, 154, var(--bg-opacity));
}

.focus\\:bg-blue-750:focus{
  --bg-opacity: 1;
  background-color: #5682AA;
  background-color: rgba(86, 130, 170, var(--bg-opacity));
}

.focus\\:bg-blue-800:focus{
  --bg-opacity: 1;
  background-color: #1F4566;
  background-color: rgba(31, 69, 102, var(--bg-opacity));
}

.focus\\:bg-blue-900:focus{
  --bg-opacity: 1;
  background-color: #183453;
  background-color: rgba(24, 52, 83, var(--bg-opacity));
}

.focus\\:bg-blue-950:focus{
  --bg-opacity: 1;
  background-color: #041527;
  background-color: rgba(4, 21, 39, var(--bg-opacity));
}

.focus\\:bg-blue-500a25:focus{
  background-color: rgba(55, 164, 220, 0.2);
}

.focus\\:bg-blue-500a50:focus{
  background-color: rgba(55, 164, 220, 0.5);
}

.focus\\:bg-blue-700a75:focus{
  --bg-opacity: 1;
  background-color: #3B648D;
  background-color: rgba(59, 100, 141, var(--bg-opacity));
}

.focus\\:bg-blue-700a30:focus{
  --bg-opacity: 1;
  background-color: #2A5176;
  background-color: rgba(42, 81, 118, var(--bg-opacity));
}

.focus\\:bg-blue-750a25:focus{
  background-color: rgba(86,130,170,0.09804);
}

.focus\\:bg-blue-750a15:focus{
  background-color: rgba(86,130,170,0.05882);
}

.focus\\:bg-blue-800a60:focus{
  background-color: rgba(31, 69, 102, 0.6);
}

.focus\\:bg-programEditorTabColors-1:focus{
  --bg-opacity: 1;
  background-color: #3cacae;
  background-color: rgba(60, 172, 174, var(--bg-opacity));
}

.focus\\:bg-programEditorTabColors-2:focus{
  --bg-opacity: 1;
  background-color: #8e346a;
  background-color: rgba(142, 52, 106, var(--bg-opacity));
}

.focus\\:bg-programEditorTabColors-3:focus{
  --bg-opacity: 1;
  background-color: #ff72b7;
  background-color: rgba(255, 114, 183, var(--bg-opacity));
}

.focus\\:bg-programEditorTabColors-4:focus{
  --bg-opacity: 1;
  background-color: #ce941c;
  background-color: rgba(206, 148, 28, var(--bg-opacity));
}

.focus\\:bg-programEditorTabColors-5:focus{
  --bg-opacity: 1;
  background-color: #b973d9;
  background-color: rgba(185, 115, 217, var(--bg-opacity));
}

.focus\\:bg-programEditorTabColors-6:focus{
  --bg-opacity: 1;
  background-color: #ff9082;
  background-color: rgba(255, 144, 130, var(--bg-opacity));
}

.focus\\:bg-programEditorTabColors-1h:focus{
  --bg-opacity: 1;
  background-color: #d9f2f2;
  background-color: rgba(217, 242, 242, var(--bg-opacity));
}

.focus\\:bg-programEditorTabColors-2h:focus{
  --bg-opacity: 1;
  background-color: #f1dae8;
  background-color: rgba(241, 218, 232, var(--bg-opacity));
}

.focus\\:bg-programEditorTabColors-3h:focus{
  --bg-opacity: 1;
  background-color: #ffe6f2;
  background-color: rgba(255, 230, 242, var(--bg-opacity));
}

.focus\\:bg-programEditorTabColors-4h:focus{
  --bg-opacity: 1;
  background-color: #f9ecd2;
  background-color: rgba(249, 236, 210, var(--bg-opacity));
}

.focus\\:bg-programEditorTabColors-5h:focus{
  --bg-opacity: 1;
  background-color: #f5ebfa;
  background-color: rgba(245, 235, 250, var(--bg-opacity));
}

.focus\\:bg-programEditorTabColors-6h:focus{
  --bg-opacity: 1;
  background-color: #ffe8e6;
  background-color: rgba(255, 232, 230, var(--bg-opacity));
}

.focus\\:bg-programEditorPresetTabColors-1:focus{
  --bg-opacity: 1;
  background-color: #798fa3;
  background-color: rgba(121, 143, 163, var(--bg-opacity));
}

.focus\\:bg-programEditorPresetTabColors-1h:focus{
  --bg-opacity: 1;
  background-color: #798fa3;
  background-color: rgba(121, 143, 163, var(--bg-opacity));
}

.focus\\:bg-borgScaleColors-0:focus{
  --bg-opacity: 1;
  background-color: #c5d1ff;
  background-color: rgba(197, 209, 255, var(--bg-opacity));
}

.focus\\:bg-borgScaleColors-1:focus{
  --bg-opacity: 1;
  background-color: #a0b5fc;
  background-color: rgba(160, 181, 252, var(--bg-opacity));
}

.focus\\:bg-borgScaleColors-2:focus{
  --bg-opacity: 1;
  background-color: #7492ff;
  background-color: rgba(116, 146, 255, var(--bg-opacity));
}

.focus\\:bg-borgScaleColors-3:focus{
  --bg-opacity: 1;
  background-color: #82bbf1;
  background-color: rgba(130, 187, 241, var(--bg-opacity));
}

.focus\\:bg-borgScaleColors-4:focus{
  --bg-opacity: 1;
  background-color: #4ba4f7;
  background-color: rgba(75, 164, 247, var(--bg-opacity));
}

.focus\\:bg-borgScaleColors-5:focus{
  --bg-opacity: 1;
  background-color: #9cdd57;
  background-color: rgba(156, 221, 87, var(--bg-opacity));
}

.focus\\:bg-borgScaleColors-6:focus{
  --bg-opacity: 1;
  background-color: #68af00;
  background-color: rgba(104, 175, 0, var(--bg-opacity));
}

.focus\\:bg-borgScaleColors-7:focus{
  --bg-opacity: 1;
  background-color: #f5e380;
  background-color: rgba(245, 227, 128, var(--bg-opacity));
}

.focus\\:bg-borgScaleColors-8:focus{
  --bg-opacity: 1;
  background-color: #ffc246;
  background-color: rgba(255, 194, 70, var(--bg-opacity));
}

.focus\\:bg-borgScaleColors-9:focus{
  --bg-opacity: 1;
  background-color: #ff782f;
  background-color: rgba(255, 120, 47, var(--bg-opacity));
}

.focus\\:bg-borgScaleColors-10:focus{
  --bg-opacity: 1;
  background-color: #f25757;
  background-color: rgba(242, 87, 87, var(--bg-opacity));
}

.bg-none{
  background-image: none;
}

.bg-gradient-to-t{
  background-image: linear-gradient(to top, var(--gradient-color-stops));
}

.bg-gradient-to-tr{
  background-image: linear-gradient(to top right, var(--gradient-color-stops));
}

.bg-gradient-to-r{
  background-image: linear-gradient(to right, var(--gradient-color-stops));
}

.bg-gradient-to-br{
  background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
}

.bg-gradient-to-b{
  background-image: linear-gradient(to bottom, var(--gradient-color-stops));
}

.bg-gradient-to-bl{
  background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
}

.bg-gradient-to-l{
  background-image: linear-gradient(to left, var(--gradient-color-stops));
}

.bg-gradient-to-tl{
  background-image: linear-gradient(to top left, var(--gradient-color-stops));
}

.from-transparent{
  --gradient-from-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.from-focus{
  --gradient-from-color: rgba(4, 21, 39, 0.8);;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.from-black{
  --gradient-from-color: #000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.from-white{
  --gradient-from-color: #fff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.from-primary{
  --gradient-from-color: #37A4DC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.from-disabled{
  --gradient-from-color: #BFBFBF;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
}

.from-translucent-60{
  --gradient-from-color: rgba(256, 256, 256, 0.6);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.from-translucent-90{
  --gradient-from-color: rgba(256, 256, 256, 0.9);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.from-green-200{
  --gradient-from-color: #f4fcea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
}

.from-green-400{
  --gradient-from-color: #6CCA98;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
}

.from-green-500{
  --gradient-from-color: #97E812;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
}

.from-green-600{
  --gradient-from-color: #4f9112;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
}

.from-green-700{
  --gradient-from-color: #3e7211;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
}

.from-green-400a50{
  --gradient-from-color: rgba(108,202,152,0.50196);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
}

.from-green-500a25{
  --gradient-from-color: rgba(151,232,18,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
}

.from-yellow-200{
  --gradient-from-color: #fff9eb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
}

.from-yellow-300{
  --gradient-from-color: #ffe9bd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
}

.from-yellow-500{
  --gradient-from-color: #FFC82C;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
}

.from-yellow-600{
  --gradient-from-color: #F7931E;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
}

.from-yellow-700{
  --gradient-from-color: #E1AD28;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
}

.from-yellow-300a66{
  --gradient-from-color: rgba(255,233,189,0.66667);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
}

.from-yellow-500a25{
  --gradient-from-color: rgba(255,200,44,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
}

.from-orange-200{
  --gradient-from-color: #fdf0ea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
}

.from-orange-400{
  --gradient-from-color: #f6c66f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
}

.from-orange-500{
  --gradient-from-color: #F07313;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
}

.from-orange-800{
  --gradient-from-color: #db5d0c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
}

.from-orange-900{
  --gradient-from-color: #b86814;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
}

.from-orange-500a25{
  --gradient-from-color: rgba(240,115,23,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
}

.from-red-100{
  --gradient-from-color: #FEF5F5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
}

.from-red-150{
  --gradient-from-color: #ffe9e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
}

.from-red-200{
  --gradient-from-color: #F8CECC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
}

.from-red-300{
  --gradient-from-color: #ff8585;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
}

.from-red-400{
  --gradient-from-color: #ff3535;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
}

.from-red-500{
  --gradient-from-color: #DD4746;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
}

.from-red-700{
  --gradient-from-color: #A23C24;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
}

.from-gray-50{
  --gradient-from-color: #F9F9F9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
}

.from-gray-100{
  --gradient-from-color: #F1F1F2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
}

.from-gray-150{
  --gradient-from-color: #e6e6e6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
}

.from-gray-200{
  --gradient-from-color: #E0E2E4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
}

.from-gray-300{
  --gradient-from-color: #BFBFBF;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
}

.from-gray-400{
  --gradient-from-color: rgba(114,114,114,0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
}

.from-gray-425{
  --gradient-from-color: rgba(4, 21, 39, 0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
}

.from-gray-450{
  --gradient-from-color: #959595;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
}

.from-gray-500{
  --gradient-from-color: #727272;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
}

.from-gray-600{
  --gradient-from-color: #5a626b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
}

.from-gray-625{
  --gradient-from-color: rgba(90,98,107,0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
}

.from-gray-700{
  --gradient-from-color: #464C59;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
}

.from-gray-800{
  --gradient-from-color: #3c3b3b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
}

.from-gray-200a50{
  --gradient-from-color: rgba(224, 226, 228, 0.5);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
}

.from-blue-50{
  --gradient-from-color: #f2fbff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
}

.from-blue-100{
  --gradient-from-color: #EBF6FC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
}

.from-blue-150{
  --gradient-from-color: #E8EEF1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
}

.from-blue-200{
  --gradient-from-color: #CCE6F5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
}

.from-blue-300{
  --gradient-from-color: #73BFE7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
}

.from-blue-400{
  --gradient-from-color: #4BA4F7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
}

.from-blue-500{
  --gradient-from-color: #37A4DC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.from-blue-600{
  --gradient-from-color: #6AA2D6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
}

.from-blue-700{
  --gradient-from-color: #456E9A;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
}

.from-blue-750{
  --gradient-from-color: #5682AA;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.from-blue-800{
  --gradient-from-color: #1F4566;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
}

.from-blue-900{
  --gradient-from-color: #183453;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
}

.from-blue-950{
  --gradient-from-color: #041527;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
}

.from-blue-500a25{
  --gradient-from-color: rgba(55, 164, 220, 0.2);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.from-blue-500a50{
  --gradient-from-color: rgba(55, 164, 220, 0.5);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.from-blue-700a75{
  --gradient-from-color: #3B648D;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
}

.from-blue-700a30{
  --gradient-from-color: #2A5176;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
}

.from-blue-750a25{
  --gradient-from-color: rgba(86,130,170,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.from-blue-750a15{
  --gradient-from-color: rgba(86,130,170,0.05882);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.from-blue-800a60{
  --gradient-from-color: rgba(31, 69, 102, 0.6);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
}

.from-programEditorTabColors-1{
  --gradient-from-color: #3cacae;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
}

.from-programEditorTabColors-2{
  --gradient-from-color: #8e346a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
}

.from-programEditorTabColors-3{
  --gradient-from-color: #ff72b7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
}

.from-programEditorTabColors-4{
  --gradient-from-color: #ce941c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
}

.from-programEditorTabColors-5{
  --gradient-from-color: #b973d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
}

.from-programEditorTabColors-6{
  --gradient-from-color: #ff9082;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
}

.from-programEditorTabColors-1h{
  --gradient-from-color: #d9f2f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
}

.from-programEditorTabColors-2h{
  --gradient-from-color: #f1dae8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
}

.from-programEditorTabColors-3h{
  --gradient-from-color: #ffe6f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
}

.from-programEditorTabColors-4h{
  --gradient-from-color: #f9ecd2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
}

.from-programEditorTabColors-5h{
  --gradient-from-color: #f5ebfa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
}

.from-programEditorTabColors-6h{
  --gradient-from-color: #ffe8e6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
}

.from-programEditorPresetTabColors-1{
  --gradient-from-color: #798fa3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
}

.from-programEditorPresetTabColors-1h{
  --gradient-from-color: #798fa3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
}

.from-borgScaleColors-0{
  --gradient-from-color: #c5d1ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
}

.from-borgScaleColors-1{
  --gradient-from-color: #a0b5fc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
}

.from-borgScaleColors-2{
  --gradient-from-color: #7492ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
}

.from-borgScaleColors-3{
  --gradient-from-color: #82bbf1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
}

.from-borgScaleColors-4{
  --gradient-from-color: #4ba4f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
}

.from-borgScaleColors-5{
  --gradient-from-color: #9cdd57;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
}

.from-borgScaleColors-6{
  --gradient-from-color: #68af00;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
}

.from-borgScaleColors-7{
  --gradient-from-color: #f5e380;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
}

.from-borgScaleColors-8{
  --gradient-from-color: #ffc246;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
}

.from-borgScaleColors-9{
  --gradient-from-color: #ff782f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
}

.from-borgScaleColors-10{
  --gradient-from-color: #f25757;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
}

.via-transparent{
  --gradient-via-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.via-focus{
  --gradient-via-color: rgba(4, 21, 39, 0.8);;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.via-black{
  --gradient-via-color: #000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.via-white{
  --gradient-via-color: #fff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.via-primary{
  --gradient-via-color: #37A4DC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.via-disabled{
  --gradient-via-color: #BFBFBF;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
}

.via-translucent-60{
  --gradient-via-color: rgba(256, 256, 256, 0.6);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.via-translucent-90{
  --gradient-via-color: rgba(256, 256, 256, 0.9);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.via-green-200{
  --gradient-via-color: #f4fcea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
}

.via-green-400{
  --gradient-via-color: #6CCA98;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
}

.via-green-500{
  --gradient-via-color: #97E812;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
}

.via-green-600{
  --gradient-via-color: #4f9112;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
}

.via-green-700{
  --gradient-via-color: #3e7211;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
}

.via-green-400a50{
  --gradient-via-color: rgba(108,202,152,0.50196);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
}

.via-green-500a25{
  --gradient-via-color: rgba(151,232,18,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
}

.via-yellow-200{
  --gradient-via-color: #fff9eb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
}

.via-yellow-300{
  --gradient-via-color: #ffe9bd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
}

.via-yellow-500{
  --gradient-via-color: #FFC82C;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
}

.via-yellow-600{
  --gradient-via-color: #F7931E;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
}

.via-yellow-700{
  --gradient-via-color: #E1AD28;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
}

.via-yellow-300a66{
  --gradient-via-color: rgba(255,233,189,0.66667);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
}

.via-yellow-500a25{
  --gradient-via-color: rgba(255,200,44,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
}

.via-orange-200{
  --gradient-via-color: #fdf0ea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
}

.via-orange-400{
  --gradient-via-color: #f6c66f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
}

.via-orange-500{
  --gradient-via-color: #F07313;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
}

.via-orange-800{
  --gradient-via-color: #db5d0c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
}

.via-orange-900{
  --gradient-via-color: #b86814;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
}

.via-orange-500a25{
  --gradient-via-color: rgba(240,115,23,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
}

.via-red-100{
  --gradient-via-color: #FEF5F5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
}

.via-red-150{
  --gradient-via-color: #ffe9e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
}

.via-red-200{
  --gradient-via-color: #F8CECC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
}

.via-red-300{
  --gradient-via-color: #ff8585;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
}

.via-red-400{
  --gradient-via-color: #ff3535;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
}

.via-red-500{
  --gradient-via-color: #DD4746;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
}

.via-red-700{
  --gradient-via-color: #A23C24;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
}

.via-gray-50{
  --gradient-via-color: #F9F9F9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
}

.via-gray-100{
  --gradient-via-color: #F1F1F2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
}

.via-gray-150{
  --gradient-via-color: #e6e6e6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
}

.via-gray-200{
  --gradient-via-color: #E0E2E4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
}

.via-gray-300{
  --gradient-via-color: #BFBFBF;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
}

.via-gray-400{
  --gradient-via-color: rgba(114,114,114,0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
}

.via-gray-425{
  --gradient-via-color: rgba(4, 21, 39, 0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
}

.via-gray-450{
  --gradient-via-color: #959595;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
}

.via-gray-500{
  --gradient-via-color: #727272;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
}

.via-gray-600{
  --gradient-via-color: #5a626b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
}

.via-gray-625{
  --gradient-via-color: rgba(90,98,107,0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
}

.via-gray-700{
  --gradient-via-color: #464C59;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
}

.via-gray-800{
  --gradient-via-color: #3c3b3b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
}

.via-gray-200a50{
  --gradient-via-color: rgba(224, 226, 228, 0.5);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
}

.via-blue-50{
  --gradient-via-color: #f2fbff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
}

.via-blue-100{
  --gradient-via-color: #EBF6FC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
}

.via-blue-150{
  --gradient-via-color: #E8EEF1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
}

.via-blue-200{
  --gradient-via-color: #CCE6F5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
}

.via-blue-300{
  --gradient-via-color: #73BFE7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
}

.via-blue-400{
  --gradient-via-color: #4BA4F7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
}

.via-blue-500{
  --gradient-via-color: #37A4DC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.via-blue-600{
  --gradient-via-color: #6AA2D6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
}

.via-blue-700{
  --gradient-via-color: #456E9A;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
}

.via-blue-750{
  --gradient-via-color: #5682AA;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.via-blue-800{
  --gradient-via-color: #1F4566;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
}

.via-blue-900{
  --gradient-via-color: #183453;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
}

.via-blue-950{
  --gradient-via-color: #041527;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
}

.via-blue-500a25{
  --gradient-via-color: rgba(55, 164, 220, 0.2);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.via-blue-500a50{
  --gradient-via-color: rgba(55, 164, 220, 0.5);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.via-blue-700a75{
  --gradient-via-color: #3B648D;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
}

.via-blue-700a30{
  --gradient-via-color: #2A5176;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
}

.via-blue-750a25{
  --gradient-via-color: rgba(86,130,170,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.via-blue-750a15{
  --gradient-via-color: rgba(86,130,170,0.05882);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.via-blue-800a60{
  --gradient-via-color: rgba(31, 69, 102, 0.6);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
}

.via-programEditorTabColors-1{
  --gradient-via-color: #3cacae;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
}

.via-programEditorTabColors-2{
  --gradient-via-color: #8e346a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
}

.via-programEditorTabColors-3{
  --gradient-via-color: #ff72b7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
}

.via-programEditorTabColors-4{
  --gradient-via-color: #ce941c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
}

.via-programEditorTabColors-5{
  --gradient-via-color: #b973d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
}

.via-programEditorTabColors-6{
  --gradient-via-color: #ff9082;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
}

.via-programEditorTabColors-1h{
  --gradient-via-color: #d9f2f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
}

.via-programEditorTabColors-2h{
  --gradient-via-color: #f1dae8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
}

.via-programEditorTabColors-3h{
  --gradient-via-color: #ffe6f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
}

.via-programEditorTabColors-4h{
  --gradient-via-color: #f9ecd2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
}

.via-programEditorTabColors-5h{
  --gradient-via-color: #f5ebfa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
}

.via-programEditorTabColors-6h{
  --gradient-via-color: #ffe8e6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
}

.via-programEditorPresetTabColors-1{
  --gradient-via-color: #798fa3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
}

.via-programEditorPresetTabColors-1h{
  --gradient-via-color: #798fa3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
}

.via-borgScaleColors-0{
  --gradient-via-color: #c5d1ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
}

.via-borgScaleColors-1{
  --gradient-via-color: #a0b5fc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
}

.via-borgScaleColors-2{
  --gradient-via-color: #7492ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
}

.via-borgScaleColors-3{
  --gradient-via-color: #82bbf1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
}

.via-borgScaleColors-4{
  --gradient-via-color: #4ba4f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
}

.via-borgScaleColors-5{
  --gradient-via-color: #9cdd57;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
}

.via-borgScaleColors-6{
  --gradient-via-color: #68af00;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
}

.via-borgScaleColors-7{
  --gradient-via-color: #f5e380;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
}

.via-borgScaleColors-8{
  --gradient-via-color: #ffc246;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
}

.via-borgScaleColors-9{
  --gradient-via-color: #ff782f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
}

.via-borgScaleColors-10{
  --gradient-via-color: #f25757;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
}

.to-transparent{
  --gradient-to-color: transparent;
}

.to-focus{
  --gradient-to-color: rgba(4, 21, 39, 0.8);;
}

.to-black{
  --gradient-to-color: #000;
}

.to-white{
  --gradient-to-color: #fff;
}

.to-primary{
  --gradient-to-color: #37A4DC;
}

.to-disabled{
  --gradient-to-color: #BFBFBF;
}

.to-translucent-60{
  --gradient-to-color: rgba(256, 256, 256, 0.6);
}

.to-translucent-90{
  --gradient-to-color: rgba(256, 256, 256, 0.9);
}

.to-green-200{
  --gradient-to-color: #f4fcea;
}

.to-green-400{
  --gradient-to-color: #6CCA98;
}

.to-green-500{
  --gradient-to-color: #97E812;
}

.to-green-600{
  --gradient-to-color: #4f9112;
}

.to-green-700{
  --gradient-to-color: #3e7211;
}

.to-green-400a50{
  --gradient-to-color: rgba(108,202,152,0.50196);
}

.to-green-500a25{
  --gradient-to-color: rgba(151,232,18,0.09804);
}

.to-yellow-200{
  --gradient-to-color: #fff9eb;
}

.to-yellow-300{
  --gradient-to-color: #ffe9bd;
}

.to-yellow-500{
  --gradient-to-color: #FFC82C;
}

.to-yellow-600{
  --gradient-to-color: #F7931E;
}

.to-yellow-700{
  --gradient-to-color: #E1AD28;
}

.to-yellow-300a66{
  --gradient-to-color: rgba(255,233,189,0.66667);
}

.to-yellow-500a25{
  --gradient-to-color: rgba(255,200,44,0.09804);
}

.to-orange-200{
  --gradient-to-color: #fdf0ea;
}

.to-orange-400{
  --gradient-to-color: #f6c66f;
}

.to-orange-500{
  --gradient-to-color: #F07313;
}

.to-orange-800{
  --gradient-to-color: #db5d0c;
}

.to-orange-900{
  --gradient-to-color: #b86814;
}

.to-orange-500a25{
  --gradient-to-color: rgba(240,115,23,0.09804);
}

.to-red-100{
  --gradient-to-color: #FEF5F5;
}

.to-red-150{
  --gradient-to-color: #ffe9e8;
}

.to-red-200{
  --gradient-to-color: #F8CECC;
}

.to-red-300{
  --gradient-to-color: #ff8585;
}

.to-red-400{
  --gradient-to-color: #ff3535;
}

.to-red-500{
  --gradient-to-color: #DD4746;
}

.to-red-700{
  --gradient-to-color: #A23C24;
}

.to-gray-50{
  --gradient-to-color: #F9F9F9;
}

.to-gray-100{
  --gradient-to-color: #F1F1F2;
}

.to-gray-150{
  --gradient-to-color: #e6e6e6;
}

.to-gray-200{
  --gradient-to-color: #E0E2E4;
}

.to-gray-300{
  --gradient-to-color: #BFBFBF;
}

.to-gray-400{
  --gradient-to-color: rgba(114,114,114,0.8);
}

.to-gray-425{
  --gradient-to-color: rgba(4, 21, 39, 0.8);
}

.to-gray-450{
  --gradient-to-color: #959595;
}

.to-gray-500{
  --gradient-to-color: #727272;
}

.to-gray-600{
  --gradient-to-color: #5a626b;
}

.to-gray-625{
  --gradient-to-color: rgba(90,98,107,0.8);
}

.to-gray-700{
  --gradient-to-color: #464C59;
}

.to-gray-800{
  --gradient-to-color: #3c3b3b;
}

.to-gray-200a50{
  --gradient-to-color: rgba(224, 226, 228, 0.5);
}

.to-blue-50{
  --gradient-to-color: #f2fbff;
}

.to-blue-100{
  --gradient-to-color: #EBF6FC;
}

.to-blue-150{
  --gradient-to-color: #E8EEF1;
}

.to-blue-200{
  --gradient-to-color: #CCE6F5;
}

.to-blue-300{
  --gradient-to-color: #73BFE7;
}

.to-blue-400{
  --gradient-to-color: #4BA4F7;
}

.to-blue-500{
  --gradient-to-color: #37A4DC;
}

.to-blue-600{
  --gradient-to-color: #6AA2D6;
}

.to-blue-700{
  --gradient-to-color: #456E9A;
}

.to-blue-750{
  --gradient-to-color: #5682AA;
}

.to-blue-800{
  --gradient-to-color: #1F4566;
}

.to-blue-900{
  --gradient-to-color: #183453;
}

.to-blue-950{
  --gradient-to-color: #041527;
}

.to-blue-500a25{
  --gradient-to-color: rgba(55, 164, 220, 0.2);
}

.to-blue-500a50{
  --gradient-to-color: rgba(55, 164, 220, 0.5);
}

.to-blue-700a75{
  --gradient-to-color: #3B648D;
}

.to-blue-700a30{
  --gradient-to-color: #2A5176;
}

.to-blue-750a25{
  --gradient-to-color: rgba(86,130,170,0.09804);
}

.to-blue-750a15{
  --gradient-to-color: rgba(86,130,170,0.05882);
}

.to-blue-800a60{
  --gradient-to-color: rgba(31, 69, 102, 0.6);
}

.to-programEditorTabColors-1{
  --gradient-to-color: #3cacae;
}

.to-programEditorTabColors-2{
  --gradient-to-color: #8e346a;
}

.to-programEditorTabColors-3{
  --gradient-to-color: #ff72b7;
}

.to-programEditorTabColors-4{
  --gradient-to-color: #ce941c;
}

.to-programEditorTabColors-5{
  --gradient-to-color: #b973d9;
}

.to-programEditorTabColors-6{
  --gradient-to-color: #ff9082;
}

.to-programEditorTabColors-1h{
  --gradient-to-color: #d9f2f2;
}

.to-programEditorTabColors-2h{
  --gradient-to-color: #f1dae8;
}

.to-programEditorTabColors-3h{
  --gradient-to-color: #ffe6f2;
}

.to-programEditorTabColors-4h{
  --gradient-to-color: #f9ecd2;
}

.to-programEditorTabColors-5h{
  --gradient-to-color: #f5ebfa;
}

.to-programEditorTabColors-6h{
  --gradient-to-color: #ffe8e6;
}

.to-programEditorPresetTabColors-1{
  --gradient-to-color: #798fa3;
}

.to-programEditorPresetTabColors-1h{
  --gradient-to-color: #798fa3;
}

.to-borgScaleColors-0{
  --gradient-to-color: #c5d1ff;
}

.to-borgScaleColors-1{
  --gradient-to-color: #a0b5fc;
}

.to-borgScaleColors-2{
  --gradient-to-color: #7492ff;
}

.to-borgScaleColors-3{
  --gradient-to-color: #82bbf1;
}

.to-borgScaleColors-4{
  --gradient-to-color: #4ba4f7;
}

.to-borgScaleColors-5{
  --gradient-to-color: #9cdd57;
}

.to-borgScaleColors-6{
  --gradient-to-color: #68af00;
}

.to-borgScaleColors-7{
  --gradient-to-color: #f5e380;
}

.to-borgScaleColors-8{
  --gradient-to-color: #ffc246;
}

.to-borgScaleColors-9{
  --gradient-to-color: #ff782f;
}

.to-borgScaleColors-10{
  --gradient-to-color: #f25757;
}

.hover\\:from-transparent:hover{
  --gradient-from-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.hover\\:from-focus:hover{
  --gradient-from-color: rgba(4, 21, 39, 0.8);;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.hover\\:from-black:hover{
  --gradient-from-color: #000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.hover\\:from-white:hover{
  --gradient-from-color: #fff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.hover\\:from-primary:hover{
  --gradient-from-color: #37A4DC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.hover\\:from-disabled:hover{
  --gradient-from-color: #BFBFBF;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
}

.hover\\:from-translucent-60:hover{
  --gradient-from-color: rgba(256, 256, 256, 0.6);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.hover\\:from-translucent-90:hover{
  --gradient-from-color: rgba(256, 256, 256, 0.9);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.hover\\:from-green-200:hover{
  --gradient-from-color: #f4fcea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
}

.hover\\:from-green-400:hover{
  --gradient-from-color: #6CCA98;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
}

.hover\\:from-green-500:hover{
  --gradient-from-color: #97E812;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
}

.hover\\:from-green-600:hover{
  --gradient-from-color: #4f9112;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
}

.hover\\:from-green-700:hover{
  --gradient-from-color: #3e7211;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
}

.hover\\:from-green-400a50:hover{
  --gradient-from-color: rgba(108,202,152,0.50196);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
}

.hover\\:from-green-500a25:hover{
  --gradient-from-color: rgba(151,232,18,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
}

.hover\\:from-yellow-200:hover{
  --gradient-from-color: #fff9eb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
}

.hover\\:from-yellow-300:hover{
  --gradient-from-color: #ffe9bd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
}

.hover\\:from-yellow-500:hover{
  --gradient-from-color: #FFC82C;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
}

.hover\\:from-yellow-600:hover{
  --gradient-from-color: #F7931E;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
}

.hover\\:from-yellow-700:hover{
  --gradient-from-color: #E1AD28;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
}

.hover\\:from-yellow-300a66:hover{
  --gradient-from-color: rgba(255,233,189,0.66667);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
}

.hover\\:from-yellow-500a25:hover{
  --gradient-from-color: rgba(255,200,44,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
}

.hover\\:from-orange-200:hover{
  --gradient-from-color: #fdf0ea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
}

.hover\\:from-orange-400:hover{
  --gradient-from-color: #f6c66f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
}

.hover\\:from-orange-500:hover{
  --gradient-from-color: #F07313;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
}

.hover\\:from-orange-800:hover{
  --gradient-from-color: #db5d0c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
}

.hover\\:from-orange-900:hover{
  --gradient-from-color: #b86814;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
}

.hover\\:from-orange-500a25:hover{
  --gradient-from-color: rgba(240,115,23,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
}

.hover\\:from-red-100:hover{
  --gradient-from-color: #FEF5F5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
}

.hover\\:from-red-150:hover{
  --gradient-from-color: #ffe9e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
}

.hover\\:from-red-200:hover{
  --gradient-from-color: #F8CECC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
}

.hover\\:from-red-300:hover{
  --gradient-from-color: #ff8585;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
}

.hover\\:from-red-400:hover{
  --gradient-from-color: #ff3535;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
}

.hover\\:from-red-500:hover{
  --gradient-from-color: #DD4746;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
}

.hover\\:from-red-700:hover{
  --gradient-from-color: #A23C24;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
}

.hover\\:from-gray-50:hover{
  --gradient-from-color: #F9F9F9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
}

.hover\\:from-gray-100:hover{
  --gradient-from-color: #F1F1F2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
}

.hover\\:from-gray-150:hover{
  --gradient-from-color: #e6e6e6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
}

.hover\\:from-gray-200:hover{
  --gradient-from-color: #E0E2E4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
}

.hover\\:from-gray-300:hover{
  --gradient-from-color: #BFBFBF;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
}

.hover\\:from-gray-400:hover{
  --gradient-from-color: rgba(114,114,114,0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
}

.hover\\:from-gray-425:hover{
  --gradient-from-color: rgba(4, 21, 39, 0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
}

.hover\\:from-gray-450:hover{
  --gradient-from-color: #959595;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
}

.hover\\:from-gray-500:hover{
  --gradient-from-color: #727272;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
}

.hover\\:from-gray-600:hover{
  --gradient-from-color: #5a626b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
}

.hover\\:from-gray-625:hover{
  --gradient-from-color: rgba(90,98,107,0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
}

.hover\\:from-gray-700:hover{
  --gradient-from-color: #464C59;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
}

.hover\\:from-gray-800:hover{
  --gradient-from-color: #3c3b3b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
}

.hover\\:from-gray-200a50:hover{
  --gradient-from-color: rgba(224, 226, 228, 0.5);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
}

.hover\\:from-blue-50:hover{
  --gradient-from-color: #f2fbff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
}

.hover\\:from-blue-100:hover{
  --gradient-from-color: #EBF6FC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
}

.hover\\:from-blue-150:hover{
  --gradient-from-color: #E8EEF1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
}

.hover\\:from-blue-200:hover{
  --gradient-from-color: #CCE6F5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
}

.hover\\:from-blue-300:hover{
  --gradient-from-color: #73BFE7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
}

.hover\\:from-blue-400:hover{
  --gradient-from-color: #4BA4F7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
}

.hover\\:from-blue-500:hover{
  --gradient-from-color: #37A4DC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.hover\\:from-blue-600:hover{
  --gradient-from-color: #6AA2D6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
}

.hover\\:from-blue-700:hover{
  --gradient-from-color: #456E9A;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
}

.hover\\:from-blue-750:hover{
  --gradient-from-color: #5682AA;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.hover\\:from-blue-800:hover{
  --gradient-from-color: #1F4566;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
}

.hover\\:from-blue-900:hover{
  --gradient-from-color: #183453;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
}

.hover\\:from-blue-950:hover{
  --gradient-from-color: #041527;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
}

.hover\\:from-blue-500a25:hover{
  --gradient-from-color: rgba(55, 164, 220, 0.2);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.hover\\:from-blue-500a50:hover{
  --gradient-from-color: rgba(55, 164, 220, 0.5);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.hover\\:from-blue-700a75:hover{
  --gradient-from-color: #3B648D;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
}

.hover\\:from-blue-700a30:hover{
  --gradient-from-color: #2A5176;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
}

.hover\\:from-blue-750a25:hover{
  --gradient-from-color: rgba(86,130,170,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.hover\\:from-blue-750a15:hover{
  --gradient-from-color: rgba(86,130,170,0.05882);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.hover\\:from-blue-800a60:hover{
  --gradient-from-color: rgba(31, 69, 102, 0.6);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
}

.hover\\:from-programEditorTabColors-1:hover{
  --gradient-from-color: #3cacae;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
}

.hover\\:from-programEditorTabColors-2:hover{
  --gradient-from-color: #8e346a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
}

.hover\\:from-programEditorTabColors-3:hover{
  --gradient-from-color: #ff72b7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
}

.hover\\:from-programEditorTabColors-4:hover{
  --gradient-from-color: #ce941c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
}

.hover\\:from-programEditorTabColors-5:hover{
  --gradient-from-color: #b973d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
}

.hover\\:from-programEditorTabColors-6:hover{
  --gradient-from-color: #ff9082;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
}

.hover\\:from-programEditorTabColors-1h:hover{
  --gradient-from-color: #d9f2f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
}

.hover\\:from-programEditorTabColors-2h:hover{
  --gradient-from-color: #f1dae8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
}

.hover\\:from-programEditorTabColors-3h:hover{
  --gradient-from-color: #ffe6f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
}

.hover\\:from-programEditorTabColors-4h:hover{
  --gradient-from-color: #f9ecd2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
}

.hover\\:from-programEditorTabColors-5h:hover{
  --gradient-from-color: #f5ebfa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
}

.hover\\:from-programEditorTabColors-6h:hover{
  --gradient-from-color: #ffe8e6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
}

.hover\\:from-programEditorPresetTabColors-1:hover{
  --gradient-from-color: #798fa3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
}

.hover\\:from-programEditorPresetTabColors-1h:hover{
  --gradient-from-color: #798fa3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
}

.hover\\:from-borgScaleColors-0:hover{
  --gradient-from-color: #c5d1ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
}

.hover\\:from-borgScaleColors-1:hover{
  --gradient-from-color: #a0b5fc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
}

.hover\\:from-borgScaleColors-2:hover{
  --gradient-from-color: #7492ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
}

.hover\\:from-borgScaleColors-3:hover{
  --gradient-from-color: #82bbf1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
}

.hover\\:from-borgScaleColors-4:hover{
  --gradient-from-color: #4ba4f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
}

.hover\\:from-borgScaleColors-5:hover{
  --gradient-from-color: #9cdd57;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
}

.hover\\:from-borgScaleColors-6:hover{
  --gradient-from-color: #68af00;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
}

.hover\\:from-borgScaleColors-7:hover{
  --gradient-from-color: #f5e380;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
}

.hover\\:from-borgScaleColors-8:hover{
  --gradient-from-color: #ffc246;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
}

.hover\\:from-borgScaleColors-9:hover{
  --gradient-from-color: #ff782f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
}

.hover\\:from-borgScaleColors-10:hover{
  --gradient-from-color: #f25757;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
}

.hover\\:via-transparent:hover{
  --gradient-via-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.hover\\:via-focus:hover{
  --gradient-via-color: rgba(4, 21, 39, 0.8);;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.hover\\:via-black:hover{
  --gradient-via-color: #000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.hover\\:via-white:hover{
  --gradient-via-color: #fff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.hover\\:via-primary:hover{
  --gradient-via-color: #37A4DC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.hover\\:via-disabled:hover{
  --gradient-via-color: #BFBFBF;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
}

.hover\\:via-translucent-60:hover{
  --gradient-via-color: rgba(256, 256, 256, 0.6);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.hover\\:via-translucent-90:hover{
  --gradient-via-color: rgba(256, 256, 256, 0.9);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.hover\\:via-green-200:hover{
  --gradient-via-color: #f4fcea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
}

.hover\\:via-green-400:hover{
  --gradient-via-color: #6CCA98;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
}

.hover\\:via-green-500:hover{
  --gradient-via-color: #97E812;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
}

.hover\\:via-green-600:hover{
  --gradient-via-color: #4f9112;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
}

.hover\\:via-green-700:hover{
  --gradient-via-color: #3e7211;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
}

.hover\\:via-green-400a50:hover{
  --gradient-via-color: rgba(108,202,152,0.50196);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
}

.hover\\:via-green-500a25:hover{
  --gradient-via-color: rgba(151,232,18,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
}

.hover\\:via-yellow-200:hover{
  --gradient-via-color: #fff9eb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
}

.hover\\:via-yellow-300:hover{
  --gradient-via-color: #ffe9bd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
}

.hover\\:via-yellow-500:hover{
  --gradient-via-color: #FFC82C;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
}

.hover\\:via-yellow-600:hover{
  --gradient-via-color: #F7931E;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
}

.hover\\:via-yellow-700:hover{
  --gradient-via-color: #E1AD28;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
}

.hover\\:via-yellow-300a66:hover{
  --gradient-via-color: rgba(255,233,189,0.66667);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
}

.hover\\:via-yellow-500a25:hover{
  --gradient-via-color: rgba(255,200,44,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
}

.hover\\:via-orange-200:hover{
  --gradient-via-color: #fdf0ea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
}

.hover\\:via-orange-400:hover{
  --gradient-via-color: #f6c66f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
}

.hover\\:via-orange-500:hover{
  --gradient-via-color: #F07313;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
}

.hover\\:via-orange-800:hover{
  --gradient-via-color: #db5d0c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
}

.hover\\:via-orange-900:hover{
  --gradient-via-color: #b86814;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
}

.hover\\:via-orange-500a25:hover{
  --gradient-via-color: rgba(240,115,23,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
}

.hover\\:via-red-100:hover{
  --gradient-via-color: #FEF5F5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
}

.hover\\:via-red-150:hover{
  --gradient-via-color: #ffe9e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
}

.hover\\:via-red-200:hover{
  --gradient-via-color: #F8CECC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
}

.hover\\:via-red-300:hover{
  --gradient-via-color: #ff8585;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
}

.hover\\:via-red-400:hover{
  --gradient-via-color: #ff3535;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
}

.hover\\:via-red-500:hover{
  --gradient-via-color: #DD4746;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
}

.hover\\:via-red-700:hover{
  --gradient-via-color: #A23C24;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
}

.hover\\:via-gray-50:hover{
  --gradient-via-color: #F9F9F9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
}

.hover\\:via-gray-100:hover{
  --gradient-via-color: #F1F1F2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
}

.hover\\:via-gray-150:hover{
  --gradient-via-color: #e6e6e6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
}

.hover\\:via-gray-200:hover{
  --gradient-via-color: #E0E2E4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
}

.hover\\:via-gray-300:hover{
  --gradient-via-color: #BFBFBF;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
}

.hover\\:via-gray-400:hover{
  --gradient-via-color: rgba(114,114,114,0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
}

.hover\\:via-gray-425:hover{
  --gradient-via-color: rgba(4, 21, 39, 0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
}

.hover\\:via-gray-450:hover{
  --gradient-via-color: #959595;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
}

.hover\\:via-gray-500:hover{
  --gradient-via-color: #727272;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
}

.hover\\:via-gray-600:hover{
  --gradient-via-color: #5a626b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
}

.hover\\:via-gray-625:hover{
  --gradient-via-color: rgba(90,98,107,0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
}

.hover\\:via-gray-700:hover{
  --gradient-via-color: #464C59;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
}

.hover\\:via-gray-800:hover{
  --gradient-via-color: #3c3b3b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
}

.hover\\:via-gray-200a50:hover{
  --gradient-via-color: rgba(224, 226, 228, 0.5);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
}

.hover\\:via-blue-50:hover{
  --gradient-via-color: #f2fbff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
}

.hover\\:via-blue-100:hover{
  --gradient-via-color: #EBF6FC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
}

.hover\\:via-blue-150:hover{
  --gradient-via-color: #E8EEF1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
}

.hover\\:via-blue-200:hover{
  --gradient-via-color: #CCE6F5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
}

.hover\\:via-blue-300:hover{
  --gradient-via-color: #73BFE7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
}

.hover\\:via-blue-400:hover{
  --gradient-via-color: #4BA4F7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
}

.hover\\:via-blue-500:hover{
  --gradient-via-color: #37A4DC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.hover\\:via-blue-600:hover{
  --gradient-via-color: #6AA2D6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
}

.hover\\:via-blue-700:hover{
  --gradient-via-color: #456E9A;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
}

.hover\\:via-blue-750:hover{
  --gradient-via-color: #5682AA;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.hover\\:via-blue-800:hover{
  --gradient-via-color: #1F4566;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
}

.hover\\:via-blue-900:hover{
  --gradient-via-color: #183453;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
}

.hover\\:via-blue-950:hover{
  --gradient-via-color: #041527;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
}

.hover\\:via-blue-500a25:hover{
  --gradient-via-color: rgba(55, 164, 220, 0.2);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.hover\\:via-blue-500a50:hover{
  --gradient-via-color: rgba(55, 164, 220, 0.5);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.hover\\:via-blue-700a75:hover{
  --gradient-via-color: #3B648D;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
}

.hover\\:via-blue-700a30:hover{
  --gradient-via-color: #2A5176;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
}

.hover\\:via-blue-750a25:hover{
  --gradient-via-color: rgba(86,130,170,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.hover\\:via-blue-750a15:hover{
  --gradient-via-color: rgba(86,130,170,0.05882);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.hover\\:via-blue-800a60:hover{
  --gradient-via-color: rgba(31, 69, 102, 0.6);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
}

.hover\\:via-programEditorTabColors-1:hover{
  --gradient-via-color: #3cacae;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
}

.hover\\:via-programEditorTabColors-2:hover{
  --gradient-via-color: #8e346a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
}

.hover\\:via-programEditorTabColors-3:hover{
  --gradient-via-color: #ff72b7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
}

.hover\\:via-programEditorTabColors-4:hover{
  --gradient-via-color: #ce941c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
}

.hover\\:via-programEditorTabColors-5:hover{
  --gradient-via-color: #b973d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
}

.hover\\:via-programEditorTabColors-6:hover{
  --gradient-via-color: #ff9082;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
}

.hover\\:via-programEditorTabColors-1h:hover{
  --gradient-via-color: #d9f2f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
}

.hover\\:via-programEditorTabColors-2h:hover{
  --gradient-via-color: #f1dae8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
}

.hover\\:via-programEditorTabColors-3h:hover{
  --gradient-via-color: #ffe6f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
}

.hover\\:via-programEditorTabColors-4h:hover{
  --gradient-via-color: #f9ecd2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
}

.hover\\:via-programEditorTabColors-5h:hover{
  --gradient-via-color: #f5ebfa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
}

.hover\\:via-programEditorTabColors-6h:hover{
  --gradient-via-color: #ffe8e6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
}

.hover\\:via-programEditorPresetTabColors-1:hover{
  --gradient-via-color: #798fa3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
}

.hover\\:via-programEditorPresetTabColors-1h:hover{
  --gradient-via-color: #798fa3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
}

.hover\\:via-borgScaleColors-0:hover{
  --gradient-via-color: #c5d1ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
}

.hover\\:via-borgScaleColors-1:hover{
  --gradient-via-color: #a0b5fc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
}

.hover\\:via-borgScaleColors-2:hover{
  --gradient-via-color: #7492ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
}

.hover\\:via-borgScaleColors-3:hover{
  --gradient-via-color: #82bbf1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
}

.hover\\:via-borgScaleColors-4:hover{
  --gradient-via-color: #4ba4f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
}

.hover\\:via-borgScaleColors-5:hover{
  --gradient-via-color: #9cdd57;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
}

.hover\\:via-borgScaleColors-6:hover{
  --gradient-via-color: #68af00;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
}

.hover\\:via-borgScaleColors-7:hover{
  --gradient-via-color: #f5e380;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
}

.hover\\:via-borgScaleColors-8:hover{
  --gradient-via-color: #ffc246;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
}

.hover\\:via-borgScaleColors-9:hover{
  --gradient-via-color: #ff782f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
}

.hover\\:via-borgScaleColors-10:hover{
  --gradient-via-color: #f25757;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
}

.hover\\:to-transparent:hover{
  --gradient-to-color: transparent;
}

.hover\\:to-focus:hover{
  --gradient-to-color: rgba(4, 21, 39, 0.8);;
}

.hover\\:to-black:hover{
  --gradient-to-color: #000;
}

.hover\\:to-white:hover{
  --gradient-to-color: #fff;
}

.hover\\:to-primary:hover{
  --gradient-to-color: #37A4DC;
}

.hover\\:to-disabled:hover{
  --gradient-to-color: #BFBFBF;
}

.hover\\:to-translucent-60:hover{
  --gradient-to-color: rgba(256, 256, 256, 0.6);
}

.hover\\:to-translucent-90:hover{
  --gradient-to-color: rgba(256, 256, 256, 0.9);
}

.hover\\:to-green-200:hover{
  --gradient-to-color: #f4fcea;
}

.hover\\:to-green-400:hover{
  --gradient-to-color: #6CCA98;
}

.hover\\:to-green-500:hover{
  --gradient-to-color: #97E812;
}

.hover\\:to-green-600:hover{
  --gradient-to-color: #4f9112;
}

.hover\\:to-green-700:hover{
  --gradient-to-color: #3e7211;
}

.hover\\:to-green-400a50:hover{
  --gradient-to-color: rgba(108,202,152,0.50196);
}

.hover\\:to-green-500a25:hover{
  --gradient-to-color: rgba(151,232,18,0.09804);
}

.hover\\:to-yellow-200:hover{
  --gradient-to-color: #fff9eb;
}

.hover\\:to-yellow-300:hover{
  --gradient-to-color: #ffe9bd;
}

.hover\\:to-yellow-500:hover{
  --gradient-to-color: #FFC82C;
}

.hover\\:to-yellow-600:hover{
  --gradient-to-color: #F7931E;
}

.hover\\:to-yellow-700:hover{
  --gradient-to-color: #E1AD28;
}

.hover\\:to-yellow-300a66:hover{
  --gradient-to-color: rgba(255,233,189,0.66667);
}

.hover\\:to-yellow-500a25:hover{
  --gradient-to-color: rgba(255,200,44,0.09804);
}

.hover\\:to-orange-200:hover{
  --gradient-to-color: #fdf0ea;
}

.hover\\:to-orange-400:hover{
  --gradient-to-color: #f6c66f;
}

.hover\\:to-orange-500:hover{
  --gradient-to-color: #F07313;
}

.hover\\:to-orange-800:hover{
  --gradient-to-color: #db5d0c;
}

.hover\\:to-orange-900:hover{
  --gradient-to-color: #b86814;
}

.hover\\:to-orange-500a25:hover{
  --gradient-to-color: rgba(240,115,23,0.09804);
}

.hover\\:to-red-100:hover{
  --gradient-to-color: #FEF5F5;
}

.hover\\:to-red-150:hover{
  --gradient-to-color: #ffe9e8;
}

.hover\\:to-red-200:hover{
  --gradient-to-color: #F8CECC;
}

.hover\\:to-red-300:hover{
  --gradient-to-color: #ff8585;
}

.hover\\:to-red-400:hover{
  --gradient-to-color: #ff3535;
}

.hover\\:to-red-500:hover{
  --gradient-to-color: #DD4746;
}

.hover\\:to-red-700:hover{
  --gradient-to-color: #A23C24;
}

.hover\\:to-gray-50:hover{
  --gradient-to-color: #F9F9F9;
}

.hover\\:to-gray-100:hover{
  --gradient-to-color: #F1F1F2;
}

.hover\\:to-gray-150:hover{
  --gradient-to-color: #e6e6e6;
}

.hover\\:to-gray-200:hover{
  --gradient-to-color: #E0E2E4;
}

.hover\\:to-gray-300:hover{
  --gradient-to-color: #BFBFBF;
}

.hover\\:to-gray-400:hover{
  --gradient-to-color: rgba(114,114,114,0.8);
}

.hover\\:to-gray-425:hover{
  --gradient-to-color: rgba(4, 21, 39, 0.8);
}

.hover\\:to-gray-450:hover{
  --gradient-to-color: #959595;
}

.hover\\:to-gray-500:hover{
  --gradient-to-color: #727272;
}

.hover\\:to-gray-600:hover{
  --gradient-to-color: #5a626b;
}

.hover\\:to-gray-625:hover{
  --gradient-to-color: rgba(90,98,107,0.8);
}

.hover\\:to-gray-700:hover{
  --gradient-to-color: #464C59;
}

.hover\\:to-gray-800:hover{
  --gradient-to-color: #3c3b3b;
}

.hover\\:to-gray-200a50:hover{
  --gradient-to-color: rgba(224, 226, 228, 0.5);
}

.hover\\:to-blue-50:hover{
  --gradient-to-color: #f2fbff;
}

.hover\\:to-blue-100:hover{
  --gradient-to-color: #EBF6FC;
}

.hover\\:to-blue-150:hover{
  --gradient-to-color: #E8EEF1;
}

.hover\\:to-blue-200:hover{
  --gradient-to-color: #CCE6F5;
}

.hover\\:to-blue-300:hover{
  --gradient-to-color: #73BFE7;
}

.hover\\:to-blue-400:hover{
  --gradient-to-color: #4BA4F7;
}

.hover\\:to-blue-500:hover{
  --gradient-to-color: #37A4DC;
}

.hover\\:to-blue-600:hover{
  --gradient-to-color: #6AA2D6;
}

.hover\\:to-blue-700:hover{
  --gradient-to-color: #456E9A;
}

.hover\\:to-blue-750:hover{
  --gradient-to-color: #5682AA;
}

.hover\\:to-blue-800:hover{
  --gradient-to-color: #1F4566;
}

.hover\\:to-blue-900:hover{
  --gradient-to-color: #183453;
}

.hover\\:to-blue-950:hover{
  --gradient-to-color: #041527;
}

.hover\\:to-blue-500a25:hover{
  --gradient-to-color: rgba(55, 164, 220, 0.2);
}

.hover\\:to-blue-500a50:hover{
  --gradient-to-color: rgba(55, 164, 220, 0.5);
}

.hover\\:to-blue-700a75:hover{
  --gradient-to-color: #3B648D;
}

.hover\\:to-blue-700a30:hover{
  --gradient-to-color: #2A5176;
}

.hover\\:to-blue-750a25:hover{
  --gradient-to-color: rgba(86,130,170,0.09804);
}

.hover\\:to-blue-750a15:hover{
  --gradient-to-color: rgba(86,130,170,0.05882);
}

.hover\\:to-blue-800a60:hover{
  --gradient-to-color: rgba(31, 69, 102, 0.6);
}

.hover\\:to-programEditorTabColors-1:hover{
  --gradient-to-color: #3cacae;
}

.hover\\:to-programEditorTabColors-2:hover{
  --gradient-to-color: #8e346a;
}

.hover\\:to-programEditorTabColors-3:hover{
  --gradient-to-color: #ff72b7;
}

.hover\\:to-programEditorTabColors-4:hover{
  --gradient-to-color: #ce941c;
}

.hover\\:to-programEditorTabColors-5:hover{
  --gradient-to-color: #b973d9;
}

.hover\\:to-programEditorTabColors-6:hover{
  --gradient-to-color: #ff9082;
}

.hover\\:to-programEditorTabColors-1h:hover{
  --gradient-to-color: #d9f2f2;
}

.hover\\:to-programEditorTabColors-2h:hover{
  --gradient-to-color: #f1dae8;
}

.hover\\:to-programEditorTabColors-3h:hover{
  --gradient-to-color: #ffe6f2;
}

.hover\\:to-programEditorTabColors-4h:hover{
  --gradient-to-color: #f9ecd2;
}

.hover\\:to-programEditorTabColors-5h:hover{
  --gradient-to-color: #f5ebfa;
}

.hover\\:to-programEditorTabColors-6h:hover{
  --gradient-to-color: #ffe8e6;
}

.hover\\:to-programEditorPresetTabColors-1:hover{
  --gradient-to-color: #798fa3;
}

.hover\\:to-programEditorPresetTabColors-1h:hover{
  --gradient-to-color: #798fa3;
}

.hover\\:to-borgScaleColors-0:hover{
  --gradient-to-color: #c5d1ff;
}

.hover\\:to-borgScaleColors-1:hover{
  --gradient-to-color: #a0b5fc;
}

.hover\\:to-borgScaleColors-2:hover{
  --gradient-to-color: #7492ff;
}

.hover\\:to-borgScaleColors-3:hover{
  --gradient-to-color: #82bbf1;
}

.hover\\:to-borgScaleColors-4:hover{
  --gradient-to-color: #4ba4f7;
}

.hover\\:to-borgScaleColors-5:hover{
  --gradient-to-color: #9cdd57;
}

.hover\\:to-borgScaleColors-6:hover{
  --gradient-to-color: #68af00;
}

.hover\\:to-borgScaleColors-7:hover{
  --gradient-to-color: #f5e380;
}

.hover\\:to-borgScaleColors-8:hover{
  --gradient-to-color: #ffc246;
}

.hover\\:to-borgScaleColors-9:hover{
  --gradient-to-color: #ff782f;
}

.hover\\:to-borgScaleColors-10:hover{
  --gradient-to-color: #f25757;
}

.focus\\:from-transparent:focus{
  --gradient-from-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.focus\\:from-focus:focus{
  --gradient-from-color: rgba(4, 21, 39, 0.8);;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.focus\\:from-black:focus{
  --gradient-from-color: #000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.focus\\:from-white:focus{
  --gradient-from-color: #fff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.focus\\:from-primary:focus{
  --gradient-from-color: #37A4DC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.focus\\:from-disabled:focus{
  --gradient-from-color: #BFBFBF;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
}

.focus\\:from-translucent-60:focus{
  --gradient-from-color: rgba(256, 256, 256, 0.6);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.focus\\:from-translucent-90:focus{
  --gradient-from-color: rgba(256, 256, 256, 0.9);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.focus\\:from-green-200:focus{
  --gradient-from-color: #f4fcea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
}

.focus\\:from-green-400:focus{
  --gradient-from-color: #6CCA98;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
}

.focus\\:from-green-500:focus{
  --gradient-from-color: #97E812;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
}

.focus\\:from-green-600:focus{
  --gradient-from-color: #4f9112;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
}

.focus\\:from-green-700:focus{
  --gradient-from-color: #3e7211;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
}

.focus\\:from-green-400a50:focus{
  --gradient-from-color: rgba(108,202,152,0.50196);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
}

.focus\\:from-green-500a25:focus{
  --gradient-from-color: rgba(151,232,18,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
}

.focus\\:from-yellow-200:focus{
  --gradient-from-color: #fff9eb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
}

.focus\\:from-yellow-300:focus{
  --gradient-from-color: #ffe9bd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
}

.focus\\:from-yellow-500:focus{
  --gradient-from-color: #FFC82C;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
}

.focus\\:from-yellow-600:focus{
  --gradient-from-color: #F7931E;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
}

.focus\\:from-yellow-700:focus{
  --gradient-from-color: #E1AD28;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
}

.focus\\:from-yellow-300a66:focus{
  --gradient-from-color: rgba(255,233,189,0.66667);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
}

.focus\\:from-yellow-500a25:focus{
  --gradient-from-color: rgba(255,200,44,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
}

.focus\\:from-orange-200:focus{
  --gradient-from-color: #fdf0ea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
}

.focus\\:from-orange-400:focus{
  --gradient-from-color: #f6c66f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
}

.focus\\:from-orange-500:focus{
  --gradient-from-color: #F07313;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
}

.focus\\:from-orange-800:focus{
  --gradient-from-color: #db5d0c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
}

.focus\\:from-orange-900:focus{
  --gradient-from-color: #b86814;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
}

.focus\\:from-orange-500a25:focus{
  --gradient-from-color: rgba(240,115,23,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
}

.focus\\:from-red-100:focus{
  --gradient-from-color: #FEF5F5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
}

.focus\\:from-red-150:focus{
  --gradient-from-color: #ffe9e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
}

.focus\\:from-red-200:focus{
  --gradient-from-color: #F8CECC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
}

.focus\\:from-red-300:focus{
  --gradient-from-color: #ff8585;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
}

.focus\\:from-red-400:focus{
  --gradient-from-color: #ff3535;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
}

.focus\\:from-red-500:focus{
  --gradient-from-color: #DD4746;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
}

.focus\\:from-red-700:focus{
  --gradient-from-color: #A23C24;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
}

.focus\\:from-gray-50:focus{
  --gradient-from-color: #F9F9F9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
}

.focus\\:from-gray-100:focus{
  --gradient-from-color: #F1F1F2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
}

.focus\\:from-gray-150:focus{
  --gradient-from-color: #e6e6e6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
}

.focus\\:from-gray-200:focus{
  --gradient-from-color: #E0E2E4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
}

.focus\\:from-gray-300:focus{
  --gradient-from-color: #BFBFBF;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
}

.focus\\:from-gray-400:focus{
  --gradient-from-color: rgba(114,114,114,0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
}

.focus\\:from-gray-425:focus{
  --gradient-from-color: rgba(4, 21, 39, 0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
}

.focus\\:from-gray-450:focus{
  --gradient-from-color: #959595;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
}

.focus\\:from-gray-500:focus{
  --gradient-from-color: #727272;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
}

.focus\\:from-gray-600:focus{
  --gradient-from-color: #5a626b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
}

.focus\\:from-gray-625:focus{
  --gradient-from-color: rgba(90,98,107,0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
}

.focus\\:from-gray-700:focus{
  --gradient-from-color: #464C59;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
}

.focus\\:from-gray-800:focus{
  --gradient-from-color: #3c3b3b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
}

.focus\\:from-gray-200a50:focus{
  --gradient-from-color: rgba(224, 226, 228, 0.5);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
}

.focus\\:from-blue-50:focus{
  --gradient-from-color: #f2fbff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
}

.focus\\:from-blue-100:focus{
  --gradient-from-color: #EBF6FC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
}

.focus\\:from-blue-150:focus{
  --gradient-from-color: #E8EEF1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
}

.focus\\:from-blue-200:focus{
  --gradient-from-color: #CCE6F5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
}

.focus\\:from-blue-300:focus{
  --gradient-from-color: #73BFE7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
}

.focus\\:from-blue-400:focus{
  --gradient-from-color: #4BA4F7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
}

.focus\\:from-blue-500:focus{
  --gradient-from-color: #37A4DC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.focus\\:from-blue-600:focus{
  --gradient-from-color: #6AA2D6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
}

.focus\\:from-blue-700:focus{
  --gradient-from-color: #456E9A;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
}

.focus\\:from-blue-750:focus{
  --gradient-from-color: #5682AA;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.focus\\:from-blue-800:focus{
  --gradient-from-color: #1F4566;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
}

.focus\\:from-blue-900:focus{
  --gradient-from-color: #183453;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
}

.focus\\:from-blue-950:focus{
  --gradient-from-color: #041527;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
}

.focus\\:from-blue-500a25:focus{
  --gradient-from-color: rgba(55, 164, 220, 0.2);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.focus\\:from-blue-500a50:focus{
  --gradient-from-color: rgba(55, 164, 220, 0.5);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.focus\\:from-blue-700a75:focus{
  --gradient-from-color: #3B648D;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
}

.focus\\:from-blue-700a30:focus{
  --gradient-from-color: #2A5176;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
}

.focus\\:from-blue-750a25:focus{
  --gradient-from-color: rgba(86,130,170,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.focus\\:from-blue-750a15:focus{
  --gradient-from-color: rgba(86,130,170,0.05882);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.focus\\:from-blue-800a60:focus{
  --gradient-from-color: rgba(31, 69, 102, 0.6);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
}

.focus\\:from-programEditorTabColors-1:focus{
  --gradient-from-color: #3cacae;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
}

.focus\\:from-programEditorTabColors-2:focus{
  --gradient-from-color: #8e346a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
}

.focus\\:from-programEditorTabColors-3:focus{
  --gradient-from-color: #ff72b7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
}

.focus\\:from-programEditorTabColors-4:focus{
  --gradient-from-color: #ce941c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
}

.focus\\:from-programEditorTabColors-5:focus{
  --gradient-from-color: #b973d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
}

.focus\\:from-programEditorTabColors-6:focus{
  --gradient-from-color: #ff9082;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
}

.focus\\:from-programEditorTabColors-1h:focus{
  --gradient-from-color: #d9f2f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
}

.focus\\:from-programEditorTabColors-2h:focus{
  --gradient-from-color: #f1dae8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
}

.focus\\:from-programEditorTabColors-3h:focus{
  --gradient-from-color: #ffe6f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
}

.focus\\:from-programEditorTabColors-4h:focus{
  --gradient-from-color: #f9ecd2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
}

.focus\\:from-programEditorTabColors-5h:focus{
  --gradient-from-color: #f5ebfa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
}

.focus\\:from-programEditorTabColors-6h:focus{
  --gradient-from-color: #ffe8e6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
}

.focus\\:from-programEditorPresetTabColors-1:focus{
  --gradient-from-color: #798fa3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
}

.focus\\:from-programEditorPresetTabColors-1h:focus{
  --gradient-from-color: #798fa3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
}

.focus\\:from-borgScaleColors-0:focus{
  --gradient-from-color: #c5d1ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
}

.focus\\:from-borgScaleColors-1:focus{
  --gradient-from-color: #a0b5fc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
}

.focus\\:from-borgScaleColors-2:focus{
  --gradient-from-color: #7492ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
}

.focus\\:from-borgScaleColors-3:focus{
  --gradient-from-color: #82bbf1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
}

.focus\\:from-borgScaleColors-4:focus{
  --gradient-from-color: #4ba4f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
}

.focus\\:from-borgScaleColors-5:focus{
  --gradient-from-color: #9cdd57;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
}

.focus\\:from-borgScaleColors-6:focus{
  --gradient-from-color: #68af00;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
}

.focus\\:from-borgScaleColors-7:focus{
  --gradient-from-color: #f5e380;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
}

.focus\\:from-borgScaleColors-8:focus{
  --gradient-from-color: #ffc246;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
}

.focus\\:from-borgScaleColors-9:focus{
  --gradient-from-color: #ff782f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
}

.focus\\:from-borgScaleColors-10:focus{
  --gradient-from-color: #f25757;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
}

.focus\\:via-transparent:focus{
  --gradient-via-color: transparent;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.focus\\:via-focus:focus{
  --gradient-via-color: rgba(4, 21, 39, 0.8);;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.focus\\:via-black:focus{
  --gradient-via-color: #000;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
}

.focus\\:via-white:focus{
  --gradient-via-color: #fff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.focus\\:via-primary:focus{
  --gradient-via-color: #37A4DC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.focus\\:via-disabled:focus{
  --gradient-via-color: #BFBFBF;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
}

.focus\\:via-translucent-60:focus{
  --gradient-via-color: rgba(256, 256, 256, 0.6);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.focus\\:via-translucent-90:focus{
  --gradient-via-color: rgba(256, 256, 256, 0.9);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
}

.focus\\:via-green-200:focus{
  --gradient-via-color: #f4fcea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
}

.focus\\:via-green-400:focus{
  --gradient-via-color: #6CCA98;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
}

.focus\\:via-green-500:focus{
  --gradient-via-color: #97E812;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
}

.focus\\:via-green-600:focus{
  --gradient-via-color: #4f9112;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
}

.focus\\:via-green-700:focus{
  --gradient-via-color: #3e7211;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
}

.focus\\:via-green-400a50:focus{
  --gradient-via-color: rgba(108,202,152,0.50196);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
}

.focus\\:via-green-500a25:focus{
  --gradient-via-color: rgba(151,232,18,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
}

.focus\\:via-yellow-200:focus{
  --gradient-via-color: #fff9eb;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
}

.focus\\:via-yellow-300:focus{
  --gradient-via-color: #ffe9bd;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
}

.focus\\:via-yellow-500:focus{
  --gradient-via-color: #FFC82C;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
}

.focus\\:via-yellow-600:focus{
  --gradient-via-color: #F7931E;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
}

.focus\\:via-yellow-700:focus{
  --gradient-via-color: #E1AD28;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
}

.focus\\:via-yellow-300a66:focus{
  --gradient-via-color: rgba(255,233,189,0.66667);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
}

.focus\\:via-yellow-500a25:focus{
  --gradient-via-color: rgba(255,200,44,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
}

.focus\\:via-orange-200:focus{
  --gradient-via-color: #fdf0ea;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
}

.focus\\:via-orange-400:focus{
  --gradient-via-color: #f6c66f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
}

.focus\\:via-orange-500:focus{
  --gradient-via-color: #F07313;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
}

.focus\\:via-orange-800:focus{
  --gradient-via-color: #db5d0c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
}

.focus\\:via-orange-900:focus{
  --gradient-via-color: #b86814;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
}

.focus\\:via-orange-500a25:focus{
  --gradient-via-color: rgba(240,115,23,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
}

.focus\\:via-red-100:focus{
  --gradient-via-color: #FEF5F5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
}

.focus\\:via-red-150:focus{
  --gradient-via-color: #ffe9e8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
}

.focus\\:via-red-200:focus{
  --gradient-via-color: #F8CECC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
}

.focus\\:via-red-300:focus{
  --gradient-via-color: #ff8585;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
}

.focus\\:via-red-400:focus{
  --gradient-via-color: #ff3535;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
}

.focus\\:via-red-500:focus{
  --gradient-via-color: #DD4746;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
}

.focus\\:via-red-700:focus{
  --gradient-via-color: #A23C24;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
}

.focus\\:via-gray-50:focus{
  --gradient-via-color: #F9F9F9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
}

.focus\\:via-gray-100:focus{
  --gradient-via-color: #F1F1F2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
}

.focus\\:via-gray-150:focus{
  --gradient-via-color: #e6e6e6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
}

.focus\\:via-gray-200:focus{
  --gradient-via-color: #E0E2E4;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
}

.focus\\:via-gray-300:focus{
  --gradient-via-color: #BFBFBF;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
}

.focus\\:via-gray-400:focus{
  --gradient-via-color: rgba(114,114,114,0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
}

.focus\\:via-gray-425:focus{
  --gradient-via-color: rgba(4, 21, 39, 0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
}

.focus\\:via-gray-450:focus{
  --gradient-via-color: #959595;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
}

.focus\\:via-gray-500:focus{
  --gradient-via-color: #727272;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
}

.focus\\:via-gray-600:focus{
  --gradient-via-color: #5a626b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
}

.focus\\:via-gray-625:focus{
  --gradient-via-color: rgba(90,98,107,0.8);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
}

.focus\\:via-gray-700:focus{
  --gradient-via-color: #464C59;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
}

.focus\\:via-gray-800:focus{
  --gradient-via-color: #3c3b3b;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
}

.focus\\:via-gray-200a50:focus{
  --gradient-via-color: rgba(224, 226, 228, 0.5);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
}

.focus\\:via-blue-50:focus{
  --gradient-via-color: #f2fbff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
}

.focus\\:via-blue-100:focus{
  --gradient-via-color: #EBF6FC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
}

.focus\\:via-blue-150:focus{
  --gradient-via-color: #E8EEF1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
}

.focus\\:via-blue-200:focus{
  --gradient-via-color: #CCE6F5;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
}

.focus\\:via-blue-300:focus{
  --gradient-via-color: #73BFE7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
}

.focus\\:via-blue-400:focus{
  --gradient-via-color: #4BA4F7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
}

.focus\\:via-blue-500:focus{
  --gradient-via-color: #37A4DC;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.focus\\:via-blue-600:focus{
  --gradient-via-color: #6AA2D6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
}

.focus\\:via-blue-700:focus{
  --gradient-via-color: #456E9A;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
}

.focus\\:via-blue-750:focus{
  --gradient-via-color: #5682AA;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.focus\\:via-blue-800:focus{
  --gradient-via-color: #1F4566;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
}

.focus\\:via-blue-900:focus{
  --gradient-via-color: #183453;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
}

.focus\\:via-blue-950:focus{
  --gradient-via-color: #041527;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
}

.focus\\:via-blue-500a25:focus{
  --gradient-via-color: rgba(55, 164, 220, 0.2);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.focus\\:via-blue-500a50:focus{
  --gradient-via-color: rgba(55, 164, 220, 0.5);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
}

.focus\\:via-blue-700a75:focus{
  --gradient-via-color: #3B648D;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
}

.focus\\:via-blue-700a30:focus{
  --gradient-via-color: #2A5176;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
}

.focus\\:via-blue-750a25:focus{
  --gradient-via-color: rgba(86,130,170,0.09804);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.focus\\:via-blue-750a15:focus{
  --gradient-via-color: rgba(86,130,170,0.05882);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
}

.focus\\:via-blue-800a60:focus{
  --gradient-via-color: rgba(31, 69, 102, 0.6);
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
}

.focus\\:via-programEditorTabColors-1:focus{
  --gradient-via-color: #3cacae;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
}

.focus\\:via-programEditorTabColors-2:focus{
  --gradient-via-color: #8e346a;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
}

.focus\\:via-programEditorTabColors-3:focus{
  --gradient-via-color: #ff72b7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
}

.focus\\:via-programEditorTabColors-4:focus{
  --gradient-via-color: #ce941c;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
}

.focus\\:via-programEditorTabColors-5:focus{
  --gradient-via-color: #b973d9;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
}

.focus\\:via-programEditorTabColors-6:focus{
  --gradient-via-color: #ff9082;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
}

.focus\\:via-programEditorTabColors-1h:focus{
  --gradient-via-color: #d9f2f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
}

.focus\\:via-programEditorTabColors-2h:focus{
  --gradient-via-color: #f1dae8;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
}

.focus\\:via-programEditorTabColors-3h:focus{
  --gradient-via-color: #ffe6f2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
}

.focus\\:via-programEditorTabColors-4h:focus{
  --gradient-via-color: #f9ecd2;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
}

.focus\\:via-programEditorTabColors-5h:focus{
  --gradient-via-color: #f5ebfa;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
}

.focus\\:via-programEditorTabColors-6h:focus{
  --gradient-via-color: #ffe8e6;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
}

.focus\\:via-programEditorPresetTabColors-1:focus{
  --gradient-via-color: #798fa3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
}

.focus\\:via-programEditorPresetTabColors-1h:focus{
  --gradient-via-color: #798fa3;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
}

.focus\\:via-borgScaleColors-0:focus{
  --gradient-via-color: #c5d1ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
}

.focus\\:via-borgScaleColors-1:focus{
  --gradient-via-color: #a0b5fc;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
}

.focus\\:via-borgScaleColors-2:focus{
  --gradient-via-color: #7492ff;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
}

.focus\\:via-borgScaleColors-3:focus{
  --gradient-via-color: #82bbf1;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
}

.focus\\:via-borgScaleColors-4:focus{
  --gradient-via-color: #4ba4f7;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
}

.focus\\:via-borgScaleColors-5:focus{
  --gradient-via-color: #9cdd57;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
}

.focus\\:via-borgScaleColors-6:focus{
  --gradient-via-color: #68af00;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
}

.focus\\:via-borgScaleColors-7:focus{
  --gradient-via-color: #f5e380;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
}

.focus\\:via-borgScaleColors-8:focus{
  --gradient-via-color: #ffc246;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
}

.focus\\:via-borgScaleColors-9:focus{
  --gradient-via-color: #ff782f;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
}

.focus\\:via-borgScaleColors-10:focus{
  --gradient-via-color: #f25757;
  --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
}

.focus\\:to-transparent:focus{
  --gradient-to-color: transparent;
}

.focus\\:to-focus:focus{
  --gradient-to-color: rgba(4, 21, 39, 0.8);;
}

.focus\\:to-black:focus{
  --gradient-to-color: #000;
}

.focus\\:to-white:focus{
  --gradient-to-color: #fff;
}

.focus\\:to-primary:focus{
  --gradient-to-color: #37A4DC;
}

.focus\\:to-disabled:focus{
  --gradient-to-color: #BFBFBF;
}

.focus\\:to-translucent-60:focus{
  --gradient-to-color: rgba(256, 256, 256, 0.6);
}

.focus\\:to-translucent-90:focus{
  --gradient-to-color: rgba(256, 256, 256, 0.9);
}

.focus\\:to-green-200:focus{
  --gradient-to-color: #f4fcea;
}

.focus\\:to-green-400:focus{
  --gradient-to-color: #6CCA98;
}

.focus\\:to-green-500:focus{
  --gradient-to-color: #97E812;
}

.focus\\:to-green-600:focus{
  --gradient-to-color: #4f9112;
}

.focus\\:to-green-700:focus{
  --gradient-to-color: #3e7211;
}

.focus\\:to-green-400a50:focus{
  --gradient-to-color: rgba(108,202,152,0.50196);
}

.focus\\:to-green-500a25:focus{
  --gradient-to-color: rgba(151,232,18,0.09804);
}

.focus\\:to-yellow-200:focus{
  --gradient-to-color: #fff9eb;
}

.focus\\:to-yellow-300:focus{
  --gradient-to-color: #ffe9bd;
}

.focus\\:to-yellow-500:focus{
  --gradient-to-color: #FFC82C;
}

.focus\\:to-yellow-600:focus{
  --gradient-to-color: #F7931E;
}

.focus\\:to-yellow-700:focus{
  --gradient-to-color: #E1AD28;
}

.focus\\:to-yellow-300a66:focus{
  --gradient-to-color: rgba(255,233,189,0.66667);
}

.focus\\:to-yellow-500a25:focus{
  --gradient-to-color: rgba(255,200,44,0.09804);
}

.focus\\:to-orange-200:focus{
  --gradient-to-color: #fdf0ea;
}

.focus\\:to-orange-400:focus{
  --gradient-to-color: #f6c66f;
}

.focus\\:to-orange-500:focus{
  --gradient-to-color: #F07313;
}

.focus\\:to-orange-800:focus{
  --gradient-to-color: #db5d0c;
}

.focus\\:to-orange-900:focus{
  --gradient-to-color: #b86814;
}

.focus\\:to-orange-500a25:focus{
  --gradient-to-color: rgba(240,115,23,0.09804);
}

.focus\\:to-red-100:focus{
  --gradient-to-color: #FEF5F5;
}

.focus\\:to-red-150:focus{
  --gradient-to-color: #ffe9e8;
}

.focus\\:to-red-200:focus{
  --gradient-to-color: #F8CECC;
}

.focus\\:to-red-300:focus{
  --gradient-to-color: #ff8585;
}

.focus\\:to-red-400:focus{
  --gradient-to-color: #ff3535;
}

.focus\\:to-red-500:focus{
  --gradient-to-color: #DD4746;
}

.focus\\:to-red-700:focus{
  --gradient-to-color: #A23C24;
}

.focus\\:to-gray-50:focus{
  --gradient-to-color: #F9F9F9;
}

.focus\\:to-gray-100:focus{
  --gradient-to-color: #F1F1F2;
}

.focus\\:to-gray-150:focus{
  --gradient-to-color: #e6e6e6;
}

.focus\\:to-gray-200:focus{
  --gradient-to-color: #E0E2E4;
}

.focus\\:to-gray-300:focus{
  --gradient-to-color: #BFBFBF;
}

.focus\\:to-gray-400:focus{
  --gradient-to-color: rgba(114,114,114,0.8);
}

.focus\\:to-gray-425:focus{
  --gradient-to-color: rgba(4, 21, 39, 0.8);
}

.focus\\:to-gray-450:focus{
  --gradient-to-color: #959595;
}

.focus\\:to-gray-500:focus{
  --gradient-to-color: #727272;
}

.focus\\:to-gray-600:focus{
  --gradient-to-color: #5a626b;
}

.focus\\:to-gray-625:focus{
  --gradient-to-color: rgba(90,98,107,0.8);
}

.focus\\:to-gray-700:focus{
  --gradient-to-color: #464C59;
}

.focus\\:to-gray-800:focus{
  --gradient-to-color: #3c3b3b;
}

.focus\\:to-gray-200a50:focus{
  --gradient-to-color: rgba(224, 226, 228, 0.5);
}

.focus\\:to-blue-50:focus{
  --gradient-to-color: #f2fbff;
}

.focus\\:to-blue-100:focus{
  --gradient-to-color: #EBF6FC;
}

.focus\\:to-blue-150:focus{
  --gradient-to-color: #E8EEF1;
}

.focus\\:to-blue-200:focus{
  --gradient-to-color: #CCE6F5;
}

.focus\\:to-blue-300:focus{
  --gradient-to-color: #73BFE7;
}

.focus\\:to-blue-400:focus{
  --gradient-to-color: #4BA4F7;
}

.focus\\:to-blue-500:focus{
  --gradient-to-color: #37A4DC;
}

.focus\\:to-blue-600:focus{
  --gradient-to-color: #6AA2D6;
}

.focus\\:to-blue-700:focus{
  --gradient-to-color: #456E9A;
}

.focus\\:to-blue-750:focus{
  --gradient-to-color: #5682AA;
}

.focus\\:to-blue-800:focus{
  --gradient-to-color: #1F4566;
}

.focus\\:to-blue-900:focus{
  --gradient-to-color: #183453;
}

.focus\\:to-blue-950:focus{
  --gradient-to-color: #041527;
}

.focus\\:to-blue-500a25:focus{
  --gradient-to-color: rgba(55, 164, 220, 0.2);
}

.focus\\:to-blue-500a50:focus{
  --gradient-to-color: rgba(55, 164, 220, 0.5);
}

.focus\\:to-blue-700a75:focus{
  --gradient-to-color: #3B648D;
}

.focus\\:to-blue-700a30:focus{
  --gradient-to-color: #2A5176;
}

.focus\\:to-blue-750a25:focus{
  --gradient-to-color: rgba(86,130,170,0.09804);
}

.focus\\:to-blue-750a15:focus{
  --gradient-to-color: rgba(86,130,170,0.05882);
}

.focus\\:to-blue-800a60:focus{
  --gradient-to-color: rgba(31, 69, 102, 0.6);
}

.focus\\:to-programEditorTabColors-1:focus{
  --gradient-to-color: #3cacae;
}

.focus\\:to-programEditorTabColors-2:focus{
  --gradient-to-color: #8e346a;
}

.focus\\:to-programEditorTabColors-3:focus{
  --gradient-to-color: #ff72b7;
}

.focus\\:to-programEditorTabColors-4:focus{
  --gradient-to-color: #ce941c;
}

.focus\\:to-programEditorTabColors-5:focus{
  --gradient-to-color: #b973d9;
}

.focus\\:to-programEditorTabColors-6:focus{
  --gradient-to-color: #ff9082;
}

.focus\\:to-programEditorTabColors-1h:focus{
  --gradient-to-color: #d9f2f2;
}

.focus\\:to-programEditorTabColors-2h:focus{
  --gradient-to-color: #f1dae8;
}

.focus\\:to-programEditorTabColors-3h:focus{
  --gradient-to-color: #ffe6f2;
}

.focus\\:to-programEditorTabColors-4h:focus{
  --gradient-to-color: #f9ecd2;
}

.focus\\:to-programEditorTabColors-5h:focus{
  --gradient-to-color: #f5ebfa;
}

.focus\\:to-programEditorTabColors-6h:focus{
  --gradient-to-color: #ffe8e6;
}

.focus\\:to-programEditorPresetTabColors-1:focus{
  --gradient-to-color: #798fa3;
}

.focus\\:to-programEditorPresetTabColors-1h:focus{
  --gradient-to-color: #798fa3;
}

.focus\\:to-borgScaleColors-0:focus{
  --gradient-to-color: #c5d1ff;
}

.focus\\:to-borgScaleColors-1:focus{
  --gradient-to-color: #a0b5fc;
}

.focus\\:to-borgScaleColors-2:focus{
  --gradient-to-color: #7492ff;
}

.focus\\:to-borgScaleColors-3:focus{
  --gradient-to-color: #82bbf1;
}

.focus\\:to-borgScaleColors-4:focus{
  --gradient-to-color: #4ba4f7;
}

.focus\\:to-borgScaleColors-5:focus{
  --gradient-to-color: #9cdd57;
}

.focus\\:to-borgScaleColors-6:focus{
  --gradient-to-color: #68af00;
}

.focus\\:to-borgScaleColors-7:focus{
  --gradient-to-color: #f5e380;
}

.focus\\:to-borgScaleColors-8:focus{
  --gradient-to-color: #ffc246;
}

.focus\\:to-borgScaleColors-9:focus{
  --gradient-to-color: #ff782f;
}

.focus\\:to-borgScaleColors-10:focus{
  --gradient-to-color: #f25757;
}

.bg-opacity-0{
  --bg-opacity: 0;
}

.bg-opacity-25{
  --bg-opacity: .25;
}

.bg-opacity-50{
  --bg-opacity: .5;
}

.bg-opacity-75{
  --bg-opacity: .75;
}

.bg-opacity-100{
  --bg-opacity: 1;
}

.hover\\:bg-opacity-0:hover{
  --bg-opacity: 0;
}

.hover\\:bg-opacity-25:hover{
  --bg-opacity: .25;
}

.hover\\:bg-opacity-50:hover{
  --bg-opacity: .5;
}

.hover\\:bg-opacity-75:hover{
  --bg-opacity: .75;
}

.hover\\:bg-opacity-100:hover{
  --bg-opacity: 1;
}

.focus\\:bg-opacity-0:focus{
  --bg-opacity: 0;
}

.focus\\:bg-opacity-25:focus{
  --bg-opacity: .25;
}

.focus\\:bg-opacity-50:focus{
  --bg-opacity: .5;
}

.focus\\:bg-opacity-75:focus{
  --bg-opacity: .75;
}

.focus\\:bg-opacity-100:focus{
  --bg-opacity: 1;
}

.bg-bottom{
  background-position: bottom;
}

.bg-center{
  background-position: center;
}

.bg-left{
  background-position: left;
}

.bg-left-bottom{
  background-position: left bottom;
}

.bg-left-top{
  background-position: left top;
}

.bg-right{
  background-position: right;
}

.bg-right-bottom{
  background-position: right bottom;
}

.bg-right-top{
  background-position: right top;
}

.bg-top{
  background-position: top;
}

.bg-repeat{
  background-repeat: repeat;
}

.bg-no-repeat{
  background-repeat: no-repeat;
}

.bg-repeat-x{
  background-repeat: repeat-x;
}

.bg-repeat-y{
  background-repeat: repeat-y;
}

.bg-repeat-round{
  background-repeat: round;
}

.bg-repeat-space{
  background-repeat: space;
}

.bg-auto{
  background-size: auto;
}

.bg-cover{
  background-size: cover;
}

.bg-contain{
  background-size: contain;
}

.border-collapse{
  border-collapse: collapse;
}

.border-separate{
  border-collapse: separate;
}

.border-transparent{
  border-color: transparent;
}

.border-focus{
  border-color: rgba(4, 21, 39, 0.8);;
}

.border-black{
  --border-opacity: 1;
  border-color: #000;
  border-color: rgba(0, 0, 0, var(--border-opacity));
}

.border-white{
  --border-opacity: 1;
  border-color: #fff;
  border-color: rgba(255, 255, 255, var(--border-opacity));
}

.border-primary{
  --border-opacity: 1;
  border-color: #37A4DC;
  border-color: rgba(55, 164, 220, var(--border-opacity));
}

.border-disabled{
  --border-opacity: 1;
  border-color: #BFBFBF;
  border-color: rgba(191, 191, 191, var(--border-opacity));
}

.border-translucent-60{
  border-color: rgba(256, 256, 256, 0.6);
}

.border-translucent-90{
  border-color: rgba(256, 256, 256, 0.9);
}

.border-green-200{
  --border-opacity: 1;
  border-color: #f4fcea;
  border-color: rgba(244, 252, 234, var(--border-opacity));
}

.border-green-400{
  --border-opacity: 1;
  border-color: #6CCA98;
  border-color: rgba(108, 202, 152, var(--border-opacity));
}

.border-green-500{
  --border-opacity: 1;
  border-color: #97E812;
  border-color: rgba(151, 232, 18, var(--border-opacity));
}

.border-green-600{
  --border-opacity: 1;
  border-color: #4f9112;
  border-color: rgba(79, 145, 18, var(--border-opacity));
}

.border-green-700{
  --border-opacity: 1;
  border-color: #3e7211;
  border-color: rgba(62, 114, 17, var(--border-opacity));
}

.border-green-400a50{
  border-color: rgba(108,202,152,0.50196);
}

.border-green-500a25{
  border-color: rgba(151,232,18,0.09804);
}

.border-yellow-200{
  --border-opacity: 1;
  border-color: #fff9eb;
  border-color: rgba(255, 249, 235, var(--border-opacity));
}

.border-yellow-300{
  --border-opacity: 1;
  border-color: #ffe9bd;
  border-color: rgba(255, 233, 189, var(--border-opacity));
}

.border-yellow-500{
  --border-opacity: 1;
  border-color: #FFC82C;
  border-color: rgba(255, 200, 44, var(--border-opacity));
}

.border-yellow-600{
  --border-opacity: 1;
  border-color: #F7931E;
  border-color: rgba(247, 147, 30, var(--border-opacity));
}

.border-yellow-700{
  --border-opacity: 1;
  border-color: #E1AD28;
  border-color: rgba(225, 173, 40, var(--border-opacity));
}

.border-yellow-300a66{
  border-color: rgba(255,233,189,0.66667);
}

.border-yellow-500a25{
  border-color: rgba(255,200,44,0.09804);
}

.border-orange-200{
  --border-opacity: 1;
  border-color: #fdf0ea;
  border-color: rgba(253, 240, 234, var(--border-opacity));
}

.border-orange-400{
  --border-opacity: 1;
  border-color: #f6c66f;
  border-color: rgba(246, 198, 111, var(--border-opacity));
}

.border-orange-500{
  --border-opacity: 1;
  border-color: #F07313;
  border-color: rgba(240, 115, 19, var(--border-opacity));
}

.border-orange-800{
  --border-opacity: 1;
  border-color: #db5d0c;
  border-color: rgba(219, 93, 12, var(--border-opacity));
}

.border-orange-900{
  --border-opacity: 1;
  border-color: #b86814;
  border-color: rgba(184, 104, 20, var(--border-opacity));
}

.border-orange-500a25{
  border-color: rgba(240,115,23,0.09804);
}

.border-red-100{
  --border-opacity: 1;
  border-color: #FEF5F5;
  border-color: rgba(254, 245, 245, var(--border-opacity));
}

.border-red-150{
  --border-opacity: 1;
  border-color: #ffe9e8;
  border-color: rgba(255, 233, 232, var(--border-opacity));
}

.border-red-200{
  --border-opacity: 1;
  border-color: #F8CECC;
  border-color: rgba(248, 206, 204, var(--border-opacity));
}

.border-red-300{
  --border-opacity: 1;
  border-color: #ff8585;
  border-color: rgba(255, 133, 133, var(--border-opacity));
}

.border-red-400{
  --border-opacity: 1;
  border-color: #ff3535;
  border-color: rgba(255, 53, 53, var(--border-opacity));
}

.border-red-500{
  --border-opacity: 1;
  border-color: #DD4746;
  border-color: rgba(221, 71, 70, var(--border-opacity));
}

.border-red-700{
  --border-opacity: 1;
  border-color: #A23C24;
  border-color: rgba(162, 60, 36, var(--border-opacity));
}

.border-gray-50{
  --border-opacity: 1;
  border-color: #F9F9F9;
  border-color: rgba(249, 249, 249, var(--border-opacity));
}

.border-gray-100{
  --border-opacity: 1;
  border-color: #F1F1F2;
  border-color: rgba(241, 241, 242, var(--border-opacity));
}

.border-gray-150{
  --border-opacity: 1;
  border-color: #e6e6e6;
  border-color: rgba(230, 230, 230, var(--border-opacity));
}

.border-gray-200{
  --border-opacity: 1;
  border-color: #E0E2E4;
  border-color: rgba(224, 226, 228, var(--border-opacity));
}

.border-gray-300{
  --border-opacity: 1;
  border-color: #BFBFBF;
  border-color: rgba(191, 191, 191, var(--border-opacity));
}

.border-gray-400{
  border-color: rgba(114,114,114,0.8);
}

.border-gray-425{
  border-color: rgba(4, 21, 39, 0.8);
}

.border-gray-450{
  --border-opacity: 1;
  border-color: #959595;
  border-color: rgba(149, 149, 149, var(--border-opacity));
}

.border-gray-500{
  --border-opacity: 1;
  border-color: #727272;
  border-color: rgba(114, 114, 114, var(--border-opacity));
}

.border-gray-600{
  --border-opacity: 1;
  border-color: #5a626b;
  border-color: rgba(90, 98, 107, var(--border-opacity));
}

.border-gray-625{
  border-color: rgba(90,98,107,0.8);
}

.border-gray-700{
  --border-opacity: 1;
  border-color: #464C59;
  border-color: rgba(70, 76, 89, var(--border-opacity));
}

.border-gray-800{
  --border-opacity: 1;
  border-color: #3c3b3b;
  border-color: rgba(60, 59, 59, var(--border-opacity));
}

.border-gray-200a50{
  border-color: rgba(224, 226, 228, 0.5);
}

.border-blue-50{
  --border-opacity: 1;
  border-color: #f2fbff;
  border-color: rgba(242, 251, 255, var(--border-opacity));
}

.border-blue-100{
  --border-opacity: 1;
  border-color: #EBF6FC;
  border-color: rgba(235, 246, 252, var(--border-opacity));
}

.border-blue-150{
  --border-opacity: 1;
  border-color: #E8EEF1;
  border-color: rgba(232, 238, 241, var(--border-opacity));
}

.border-blue-200{
  --border-opacity: 1;
  border-color: #CCE6F5;
  border-color: rgba(204, 230, 245, var(--border-opacity));
}

.border-blue-300{
  --border-opacity: 1;
  border-color: #73BFE7;
  border-color: rgba(115, 191, 231, var(--border-opacity));
}

.border-blue-400{
  --border-opacity: 1;
  border-color: #4BA4F7;
  border-color: rgba(75, 164, 247, var(--border-opacity));
}

.border-blue-500{
  --border-opacity: 1;
  border-color: #37A4DC;
  border-color: rgba(55, 164, 220, var(--border-opacity));
}

.border-blue-600{
  --border-opacity: 1;
  border-color: #6AA2D6;
  border-color: rgba(106, 162, 214, var(--border-opacity));
}

.border-blue-700{
  --border-opacity: 1;
  border-color: #456E9A;
  border-color: rgba(69, 110, 154, var(--border-opacity));
}

.border-blue-750{
  --border-opacity: 1;
  border-color: #5682AA;
  border-color: rgba(86, 130, 170, var(--border-opacity));
}

.border-blue-800{
  --border-opacity: 1;
  border-color: #1F4566;
  border-color: rgba(31, 69, 102, var(--border-opacity));
}

.border-blue-900{
  --border-opacity: 1;
  border-color: #183453;
  border-color: rgba(24, 52, 83, var(--border-opacity));
}

.border-blue-950{
  --border-opacity: 1;
  border-color: #041527;
  border-color: rgba(4, 21, 39, var(--border-opacity));
}

.border-blue-500a25{
  border-color: rgba(55, 164, 220, 0.2);
}

.border-blue-500a50{
  border-color: rgba(55, 164, 220, 0.5);
}

.border-blue-700a75{
  --border-opacity: 1;
  border-color: #3B648D;
  border-color: rgba(59, 100, 141, var(--border-opacity));
}

.border-blue-700a30{
  --border-opacity: 1;
  border-color: #2A5176;
  border-color: rgba(42, 81, 118, var(--border-opacity));
}

.border-blue-750a25{
  border-color: rgba(86,130,170,0.09804);
}

.border-blue-750a15{
  border-color: rgba(86,130,170,0.05882);
}

.border-blue-800a60{
  border-color: rgba(31, 69, 102, 0.6);
}

.border-programEditorTabColors-1{
  --border-opacity: 1;
  border-color: #3cacae;
  border-color: rgba(60, 172, 174, var(--border-opacity));
}

.border-programEditorTabColors-2{
  --border-opacity: 1;
  border-color: #8e346a;
  border-color: rgba(142, 52, 106, var(--border-opacity));
}

.border-programEditorTabColors-3{
  --border-opacity: 1;
  border-color: #ff72b7;
  border-color: rgba(255, 114, 183, var(--border-opacity));
}

.border-programEditorTabColors-4{
  --border-opacity: 1;
  border-color: #ce941c;
  border-color: rgba(206, 148, 28, var(--border-opacity));
}

.border-programEditorTabColors-5{
  --border-opacity: 1;
  border-color: #b973d9;
  border-color: rgba(185, 115, 217, var(--border-opacity));
}

.border-programEditorTabColors-6{
  --border-opacity: 1;
  border-color: #ff9082;
  border-color: rgba(255, 144, 130, var(--border-opacity));
}

.border-programEditorTabColors-1h{
  --border-opacity: 1;
  border-color: #d9f2f2;
  border-color: rgba(217, 242, 242, var(--border-opacity));
}

.border-programEditorTabColors-2h{
  --border-opacity: 1;
  border-color: #f1dae8;
  border-color: rgba(241, 218, 232, var(--border-opacity));
}

.border-programEditorTabColors-3h{
  --border-opacity: 1;
  border-color: #ffe6f2;
  border-color: rgba(255, 230, 242, var(--border-opacity));
}

.border-programEditorTabColors-4h{
  --border-opacity: 1;
  border-color: #f9ecd2;
  border-color: rgba(249, 236, 210, var(--border-opacity));
}

.border-programEditorTabColors-5h{
  --border-opacity: 1;
  border-color: #f5ebfa;
  border-color: rgba(245, 235, 250, var(--border-opacity));
}

.border-programEditorTabColors-6h{
  --border-opacity: 1;
  border-color: #ffe8e6;
  border-color: rgba(255, 232, 230, var(--border-opacity));
}

.border-programEditorPresetTabColors-1{
  --border-opacity: 1;
  border-color: #798fa3;
  border-color: rgba(121, 143, 163, var(--border-opacity));
}

.border-programEditorPresetTabColors-1h{
  --border-opacity: 1;
  border-color: #798fa3;
  border-color: rgba(121, 143, 163, var(--border-opacity));
}

.border-borgScaleColors-0{
  --border-opacity: 1;
  border-color: #c5d1ff;
  border-color: rgba(197, 209, 255, var(--border-opacity));
}

.border-borgScaleColors-1{
  --border-opacity: 1;
  border-color: #a0b5fc;
  border-color: rgba(160, 181, 252, var(--border-opacity));
}

.border-borgScaleColors-2{
  --border-opacity: 1;
  border-color: #7492ff;
  border-color: rgba(116, 146, 255, var(--border-opacity));
}

.border-borgScaleColors-3{
  --border-opacity: 1;
  border-color: #82bbf1;
  border-color: rgba(130, 187, 241, var(--border-opacity));
}

.border-borgScaleColors-4{
  --border-opacity: 1;
  border-color: #4ba4f7;
  border-color: rgba(75, 164, 247, var(--border-opacity));
}

.border-borgScaleColors-5{
  --border-opacity: 1;
  border-color: #9cdd57;
  border-color: rgba(156, 221, 87, var(--border-opacity));
}

.border-borgScaleColors-6{
  --border-opacity: 1;
  border-color: #68af00;
  border-color: rgba(104, 175, 0, var(--border-opacity));
}

.border-borgScaleColors-7{
  --border-opacity: 1;
  border-color: #f5e380;
  border-color: rgba(245, 227, 128, var(--border-opacity));
}

.border-borgScaleColors-8{
  --border-opacity: 1;
  border-color: #ffc246;
  border-color: rgba(255, 194, 70, var(--border-opacity));
}

.border-borgScaleColors-9{
  --border-opacity: 1;
  border-color: #ff782f;
  border-color: rgba(255, 120, 47, var(--border-opacity));
}

.border-borgScaleColors-10{
  --border-opacity: 1;
  border-color: #f25757;
  border-color: rgba(242, 87, 87, var(--border-opacity));
}

.hover\\:border-transparent:hover{
  border-color: transparent;
}

.hover\\:border-focus:hover{
  border-color: rgba(4, 21, 39, 0.8);;
}

.hover\\:border-black:hover{
  --border-opacity: 1;
  border-color: #000;
  border-color: rgba(0, 0, 0, var(--border-opacity));
}

.hover\\:border-white:hover{
  --border-opacity: 1;
  border-color: #fff;
  border-color: rgba(255, 255, 255, var(--border-opacity));
}

.hover\\:border-primary:hover{
  --border-opacity: 1;
  border-color: #37A4DC;
  border-color: rgba(55, 164, 220, var(--border-opacity));
}

.hover\\:border-disabled:hover{
  --border-opacity: 1;
  border-color: #BFBFBF;
  border-color: rgba(191, 191, 191, var(--border-opacity));
}

.hover\\:border-translucent-60:hover{
  border-color: rgba(256, 256, 256, 0.6);
}

.hover\\:border-translucent-90:hover{
  border-color: rgba(256, 256, 256, 0.9);
}

.hover\\:border-green-200:hover{
  --border-opacity: 1;
  border-color: #f4fcea;
  border-color: rgba(244, 252, 234, var(--border-opacity));
}

.hover\\:border-green-400:hover{
  --border-opacity: 1;
  border-color: #6CCA98;
  border-color: rgba(108, 202, 152, var(--border-opacity));
}

.hover\\:border-green-500:hover{
  --border-opacity: 1;
  border-color: #97E812;
  border-color: rgba(151, 232, 18, var(--border-opacity));
}

.hover\\:border-green-600:hover{
  --border-opacity: 1;
  border-color: #4f9112;
  border-color: rgba(79, 145, 18, var(--border-opacity));
}

.hover\\:border-green-700:hover{
  --border-opacity: 1;
  border-color: #3e7211;
  border-color: rgba(62, 114, 17, var(--border-opacity));
}

.hover\\:border-green-400a50:hover{
  border-color: rgba(108,202,152,0.50196);
}

.hover\\:border-green-500a25:hover{
  border-color: rgba(151,232,18,0.09804);
}

.hover\\:border-yellow-200:hover{
  --border-opacity: 1;
  border-color: #fff9eb;
  border-color: rgba(255, 249, 235, var(--border-opacity));
}

.hover\\:border-yellow-300:hover{
  --border-opacity: 1;
  border-color: #ffe9bd;
  border-color: rgba(255, 233, 189, var(--border-opacity));
}

.hover\\:border-yellow-500:hover{
  --border-opacity: 1;
  border-color: #FFC82C;
  border-color: rgba(255, 200, 44, var(--border-opacity));
}

.hover\\:border-yellow-600:hover{
  --border-opacity: 1;
  border-color: #F7931E;
  border-color: rgba(247, 147, 30, var(--border-opacity));
}

.hover\\:border-yellow-700:hover{
  --border-opacity: 1;
  border-color: #E1AD28;
  border-color: rgba(225, 173, 40, var(--border-opacity));
}

.hover\\:border-yellow-300a66:hover{
  border-color: rgba(255,233,189,0.66667);
}

.hover\\:border-yellow-500a25:hover{
  border-color: rgba(255,200,44,0.09804);
}

.hover\\:border-orange-200:hover{
  --border-opacity: 1;
  border-color: #fdf0ea;
  border-color: rgba(253, 240, 234, var(--border-opacity));
}

.hover\\:border-orange-400:hover{
  --border-opacity: 1;
  border-color: #f6c66f;
  border-color: rgba(246, 198, 111, var(--border-opacity));
}

.hover\\:border-orange-500:hover{
  --border-opacity: 1;
  border-color: #F07313;
  border-color: rgba(240, 115, 19, var(--border-opacity));
}

.hover\\:border-orange-800:hover{
  --border-opacity: 1;
  border-color: #db5d0c;
  border-color: rgba(219, 93, 12, var(--border-opacity));
}

.hover\\:border-orange-900:hover{
  --border-opacity: 1;
  border-color: #b86814;
  border-color: rgba(184, 104, 20, var(--border-opacity));
}

.hover\\:border-orange-500a25:hover{
  border-color: rgba(240,115,23,0.09804);
}

.hover\\:border-red-100:hover{
  --border-opacity: 1;
  border-color: #FEF5F5;
  border-color: rgba(254, 245, 245, var(--border-opacity));
}

.hover\\:border-red-150:hover{
  --border-opacity: 1;
  border-color: #ffe9e8;
  border-color: rgba(255, 233, 232, var(--border-opacity));
}

.hover\\:border-red-200:hover{
  --border-opacity: 1;
  border-color: #F8CECC;
  border-color: rgba(248, 206, 204, var(--border-opacity));
}

.hover\\:border-red-300:hover{
  --border-opacity: 1;
  border-color: #ff8585;
  border-color: rgba(255, 133, 133, var(--border-opacity));
}

.hover\\:border-red-400:hover{
  --border-opacity: 1;
  border-color: #ff3535;
  border-color: rgba(255, 53, 53, var(--border-opacity));
}

.hover\\:border-red-500:hover{
  --border-opacity: 1;
  border-color: #DD4746;
  border-color: rgba(221, 71, 70, var(--border-opacity));
}

.hover\\:border-red-700:hover{
  --border-opacity: 1;
  border-color: #A23C24;
  border-color: rgba(162, 60, 36, var(--border-opacity));
}

.hover\\:border-gray-50:hover{
  --border-opacity: 1;
  border-color: #F9F9F9;
  border-color: rgba(249, 249, 249, var(--border-opacity));
}

.hover\\:border-gray-100:hover{
  --border-opacity: 1;
  border-color: #F1F1F2;
  border-color: rgba(241, 241, 242, var(--border-opacity));
}

.hover\\:border-gray-150:hover{
  --border-opacity: 1;
  border-color: #e6e6e6;
  border-color: rgba(230, 230, 230, var(--border-opacity));
}

.hover\\:border-gray-200:hover{
  --border-opacity: 1;
  border-color: #E0E2E4;
  border-color: rgba(224, 226, 228, var(--border-opacity));
}

.hover\\:border-gray-300:hover{
  --border-opacity: 1;
  border-color: #BFBFBF;
  border-color: rgba(191, 191, 191, var(--border-opacity));
}

.hover\\:border-gray-400:hover{
  border-color: rgba(114,114,114,0.8);
}

.hover\\:border-gray-425:hover{
  border-color: rgba(4, 21, 39, 0.8);
}

.hover\\:border-gray-450:hover{
  --border-opacity: 1;
  border-color: #959595;
  border-color: rgba(149, 149, 149, var(--border-opacity));
}

.hover\\:border-gray-500:hover{
  --border-opacity: 1;
  border-color: #727272;
  border-color: rgba(114, 114, 114, var(--border-opacity));
}

.hover\\:border-gray-600:hover{
  --border-opacity: 1;
  border-color: #5a626b;
  border-color: rgba(90, 98, 107, var(--border-opacity));
}

.hover\\:border-gray-625:hover{
  border-color: rgba(90,98,107,0.8);
}

.hover\\:border-gray-700:hover{
  --border-opacity: 1;
  border-color: #464C59;
  border-color: rgba(70, 76, 89, var(--border-opacity));
}

.hover\\:border-gray-800:hover{
  --border-opacity: 1;
  border-color: #3c3b3b;
  border-color: rgba(60, 59, 59, var(--border-opacity));
}

.hover\\:border-gray-200a50:hover{
  border-color: rgba(224, 226, 228, 0.5);
}

.hover\\:border-blue-50:hover{
  --border-opacity: 1;
  border-color: #f2fbff;
  border-color: rgba(242, 251, 255, var(--border-opacity));
}

.hover\\:border-blue-100:hover{
  --border-opacity: 1;
  border-color: #EBF6FC;
  border-color: rgba(235, 246, 252, var(--border-opacity));
}

.hover\\:border-blue-150:hover{
  --border-opacity: 1;
  border-color: #E8EEF1;
  border-color: rgba(232, 238, 241, var(--border-opacity));
}

.hover\\:border-blue-200:hover{
  --border-opacity: 1;
  border-color: #CCE6F5;
  border-color: rgba(204, 230, 245, var(--border-opacity));
}

.hover\\:border-blue-300:hover{
  --border-opacity: 1;
  border-color: #73BFE7;
  border-color: rgba(115, 191, 231, var(--border-opacity));
}

.hover\\:border-blue-400:hover{
  --border-opacity: 1;
  border-color: #4BA4F7;
  border-color: rgba(75, 164, 247, var(--border-opacity));
}

.hover\\:border-blue-500:hover{
  --border-opacity: 1;
  border-color: #37A4DC;
  border-color: rgba(55, 164, 220, var(--border-opacity));
}

.hover\\:border-blue-600:hover{
  --border-opacity: 1;
  border-color: #6AA2D6;
  border-color: rgba(106, 162, 214, var(--border-opacity));
}

.hover\\:border-blue-700:hover{
  --border-opacity: 1;
  border-color: #456E9A;
  border-color: rgba(69, 110, 154, var(--border-opacity));
}

.hover\\:border-blue-750:hover{
  --border-opacity: 1;
  border-color: #5682AA;
  border-color: rgba(86, 130, 170, var(--border-opacity));
}

.hover\\:border-blue-800:hover{
  --border-opacity: 1;
  border-color: #1F4566;
  border-color: rgba(31, 69, 102, var(--border-opacity));
}

.hover\\:border-blue-900:hover{
  --border-opacity: 1;
  border-color: #183453;
  border-color: rgba(24, 52, 83, var(--border-opacity));
}

.hover\\:border-blue-950:hover{
  --border-opacity: 1;
  border-color: #041527;
  border-color: rgba(4, 21, 39, var(--border-opacity));
}

.hover\\:border-blue-500a25:hover{
  border-color: rgba(55, 164, 220, 0.2);
}

.hover\\:border-blue-500a50:hover{
  border-color: rgba(55, 164, 220, 0.5);
}

.hover\\:border-blue-700a75:hover{
  --border-opacity: 1;
  border-color: #3B648D;
  border-color: rgba(59, 100, 141, var(--border-opacity));
}

.hover\\:border-blue-700a30:hover{
  --border-opacity: 1;
  border-color: #2A5176;
  border-color: rgba(42, 81, 118, var(--border-opacity));
}

.hover\\:border-blue-750a25:hover{
  border-color: rgba(86,130,170,0.09804);
}

.hover\\:border-blue-750a15:hover{
  border-color: rgba(86,130,170,0.05882);
}

.hover\\:border-blue-800a60:hover{
  border-color: rgba(31, 69, 102, 0.6);
}

.hover\\:border-programEditorTabColors-1:hover{
  --border-opacity: 1;
  border-color: #3cacae;
  border-color: rgba(60, 172, 174, var(--border-opacity));
}

.hover\\:border-programEditorTabColors-2:hover{
  --border-opacity: 1;
  border-color: #8e346a;
  border-color: rgba(142, 52, 106, var(--border-opacity));
}

.hover\\:border-programEditorTabColors-3:hover{
  --border-opacity: 1;
  border-color: #ff72b7;
  border-color: rgba(255, 114, 183, var(--border-opacity));
}

.hover\\:border-programEditorTabColors-4:hover{
  --border-opacity: 1;
  border-color: #ce941c;
  border-color: rgba(206, 148, 28, var(--border-opacity));
}

.hover\\:border-programEditorTabColors-5:hover{
  --border-opacity: 1;
  border-color: #b973d9;
  border-color: rgba(185, 115, 217, var(--border-opacity));
}

.hover\\:border-programEditorTabColors-6:hover{
  --border-opacity: 1;
  border-color: #ff9082;
  border-color: rgba(255, 144, 130, var(--border-opacity));
}

.hover\\:border-programEditorTabColors-1h:hover{
  --border-opacity: 1;
  border-color: #d9f2f2;
  border-color: rgba(217, 242, 242, var(--border-opacity));
}

.hover\\:border-programEditorTabColors-2h:hover{
  --border-opacity: 1;
  border-color: #f1dae8;
  border-color: rgba(241, 218, 232, var(--border-opacity));
}

.hover\\:border-programEditorTabColors-3h:hover{
  --border-opacity: 1;
  border-color: #ffe6f2;
  border-color: rgba(255, 230, 242, var(--border-opacity));
}

.hover\\:border-programEditorTabColors-4h:hover{
  --border-opacity: 1;
  border-color: #f9ecd2;
  border-color: rgba(249, 236, 210, var(--border-opacity));
}

.hover\\:border-programEditorTabColors-5h:hover{
  --border-opacity: 1;
  border-color: #f5ebfa;
  border-color: rgba(245, 235, 250, var(--border-opacity));
}

.hover\\:border-programEditorTabColors-6h:hover{
  --border-opacity: 1;
  border-color: #ffe8e6;
  border-color: rgba(255, 232, 230, var(--border-opacity));
}

.hover\\:border-programEditorPresetTabColors-1:hover{
  --border-opacity: 1;
  border-color: #798fa3;
  border-color: rgba(121, 143, 163, var(--border-opacity));
}

.hover\\:border-programEditorPresetTabColors-1h:hover{
  --border-opacity: 1;
  border-color: #798fa3;
  border-color: rgba(121, 143, 163, var(--border-opacity));
}

.hover\\:border-borgScaleColors-0:hover{
  --border-opacity: 1;
  border-color: #c5d1ff;
  border-color: rgba(197, 209, 255, var(--border-opacity));
}

.hover\\:border-borgScaleColors-1:hover{
  --border-opacity: 1;
  border-color: #a0b5fc;
  border-color: rgba(160, 181, 252, var(--border-opacity));
}

.hover\\:border-borgScaleColors-2:hover{
  --border-opacity: 1;
  border-color: #7492ff;
  border-color: rgba(116, 146, 255, var(--border-opacity));
}

.hover\\:border-borgScaleColors-3:hover{
  --border-opacity: 1;
  border-color: #82bbf1;
  border-color: rgba(130, 187, 241, var(--border-opacity));
}

.hover\\:border-borgScaleColors-4:hover{
  --border-opacity: 1;
  border-color: #4ba4f7;
  border-color: rgba(75, 164, 247, var(--border-opacity));
}

.hover\\:border-borgScaleColors-5:hover{
  --border-opacity: 1;
  border-color: #9cdd57;
  border-color: rgba(156, 221, 87, var(--border-opacity));
}

.hover\\:border-borgScaleColors-6:hover{
  --border-opacity: 1;
  border-color: #68af00;
  border-color: rgba(104, 175, 0, var(--border-opacity));
}

.hover\\:border-borgScaleColors-7:hover{
  --border-opacity: 1;
  border-color: #f5e380;
  border-color: rgba(245, 227, 128, var(--border-opacity));
}

.hover\\:border-borgScaleColors-8:hover{
  --border-opacity: 1;
  border-color: #ffc246;
  border-color: rgba(255, 194, 70, var(--border-opacity));
}

.hover\\:border-borgScaleColors-9:hover{
  --border-opacity: 1;
  border-color: #ff782f;
  border-color: rgba(255, 120, 47, var(--border-opacity));
}

.hover\\:border-borgScaleColors-10:hover{
  --border-opacity: 1;
  border-color: #f25757;
  border-color: rgba(242, 87, 87, var(--border-opacity));
}

.focus\\:border-transparent:focus{
  border-color: transparent;
}

.focus\\:border-focus:focus{
  border-color: rgba(4, 21, 39, 0.8);;
}

.focus\\:border-black:focus{
  --border-opacity: 1;
  border-color: #000;
  border-color: rgba(0, 0, 0, var(--border-opacity));
}

.focus\\:border-white:focus{
  --border-opacity: 1;
  border-color: #fff;
  border-color: rgba(255, 255, 255, var(--border-opacity));
}

.focus\\:border-primary:focus{
  --border-opacity: 1;
  border-color: #37A4DC;
  border-color: rgba(55, 164, 220, var(--border-opacity));
}

.focus\\:border-disabled:focus{
  --border-opacity: 1;
  border-color: #BFBFBF;
  border-color: rgba(191, 191, 191, var(--border-opacity));
}

.focus\\:border-translucent-60:focus{
  border-color: rgba(256, 256, 256, 0.6);
}

.focus\\:border-translucent-90:focus{
  border-color: rgba(256, 256, 256, 0.9);
}

.focus\\:border-green-200:focus{
  --border-opacity: 1;
  border-color: #f4fcea;
  border-color: rgba(244, 252, 234, var(--border-opacity));
}

.focus\\:border-green-400:focus{
  --border-opacity: 1;
  border-color: #6CCA98;
  border-color: rgba(108, 202, 152, var(--border-opacity));
}

.focus\\:border-green-500:focus{
  --border-opacity: 1;
  border-color: #97E812;
  border-color: rgba(151, 232, 18, var(--border-opacity));
}

.focus\\:border-green-600:focus{
  --border-opacity: 1;
  border-color: #4f9112;
  border-color: rgba(79, 145, 18, var(--border-opacity));
}

.focus\\:border-green-700:focus{
  --border-opacity: 1;
  border-color: #3e7211;
  border-color: rgba(62, 114, 17, var(--border-opacity));
}

.focus\\:border-green-400a50:focus{
  border-color: rgba(108,202,152,0.50196);
}

.focus\\:border-green-500a25:focus{
  border-color: rgba(151,232,18,0.09804);
}

.focus\\:border-yellow-200:focus{
  --border-opacity: 1;
  border-color: #fff9eb;
  border-color: rgba(255, 249, 235, var(--border-opacity));
}

.focus\\:border-yellow-300:focus{
  --border-opacity: 1;
  border-color: #ffe9bd;
  border-color: rgba(255, 233, 189, var(--border-opacity));
}

.focus\\:border-yellow-500:focus{
  --border-opacity: 1;
  border-color: #FFC82C;
  border-color: rgba(255, 200, 44, var(--border-opacity));
}

.focus\\:border-yellow-600:focus{
  --border-opacity: 1;
  border-color: #F7931E;
  border-color: rgba(247, 147, 30, var(--border-opacity));
}

.focus\\:border-yellow-700:focus{
  --border-opacity: 1;
  border-color: #E1AD28;
  border-color: rgba(225, 173, 40, var(--border-opacity));
}

.focus\\:border-yellow-300a66:focus{
  border-color: rgba(255,233,189,0.66667);
}

.focus\\:border-yellow-500a25:focus{
  border-color: rgba(255,200,44,0.09804);
}

.focus\\:border-orange-200:focus{
  --border-opacity: 1;
  border-color: #fdf0ea;
  border-color: rgba(253, 240, 234, var(--border-opacity));
}

.focus\\:border-orange-400:focus{
  --border-opacity: 1;
  border-color: #f6c66f;
  border-color: rgba(246, 198, 111, var(--border-opacity));
}

.focus\\:border-orange-500:focus{
  --border-opacity: 1;
  border-color: #F07313;
  border-color: rgba(240, 115, 19, var(--border-opacity));
}

.focus\\:border-orange-800:focus{
  --border-opacity: 1;
  border-color: #db5d0c;
  border-color: rgba(219, 93, 12, var(--border-opacity));
}

.focus\\:border-orange-900:focus{
  --border-opacity: 1;
  border-color: #b86814;
  border-color: rgba(184, 104, 20, var(--border-opacity));
}

.focus\\:border-orange-500a25:focus{
  border-color: rgba(240,115,23,0.09804);
}

.focus\\:border-red-100:focus{
  --border-opacity: 1;
  border-color: #FEF5F5;
  border-color: rgba(254, 245, 245, var(--border-opacity));
}

.focus\\:border-red-150:focus{
  --border-opacity: 1;
  border-color: #ffe9e8;
  border-color: rgba(255, 233, 232, var(--border-opacity));
}

.focus\\:border-red-200:focus{
  --border-opacity: 1;
  border-color: #F8CECC;
  border-color: rgba(248, 206, 204, var(--border-opacity));
}

.focus\\:border-red-300:focus{
  --border-opacity: 1;
  border-color: #ff8585;
  border-color: rgba(255, 133, 133, var(--border-opacity));
}

.focus\\:border-red-400:focus{
  --border-opacity: 1;
  border-color: #ff3535;
  border-color: rgba(255, 53, 53, var(--border-opacity));
}

.focus\\:border-red-500:focus{
  --border-opacity: 1;
  border-color: #DD4746;
  border-color: rgba(221, 71, 70, var(--border-opacity));
}

.focus\\:border-red-700:focus{
  --border-opacity: 1;
  border-color: #A23C24;
  border-color: rgba(162, 60, 36, var(--border-opacity));
}

.focus\\:border-gray-50:focus{
  --border-opacity: 1;
  border-color: #F9F9F9;
  border-color: rgba(249, 249, 249, var(--border-opacity));
}

.focus\\:border-gray-100:focus{
  --border-opacity: 1;
  border-color: #F1F1F2;
  border-color: rgba(241, 241, 242, var(--border-opacity));
}

.focus\\:border-gray-150:focus{
  --border-opacity: 1;
  border-color: #e6e6e6;
  border-color: rgba(230, 230, 230, var(--border-opacity));
}

.focus\\:border-gray-200:focus{
  --border-opacity: 1;
  border-color: #E0E2E4;
  border-color: rgba(224, 226, 228, var(--border-opacity));
}

.focus\\:border-gray-300:focus{
  --border-opacity: 1;
  border-color: #BFBFBF;
  border-color: rgba(191, 191, 191, var(--border-opacity));
}

.focus\\:border-gray-400:focus{
  border-color: rgba(114,114,114,0.8);
}

.focus\\:border-gray-425:focus{
  border-color: rgba(4, 21, 39, 0.8);
}

.focus\\:border-gray-450:focus{
  --border-opacity: 1;
  border-color: #959595;
  border-color: rgba(149, 149, 149, var(--border-opacity));
}

.focus\\:border-gray-500:focus{
  --border-opacity: 1;
  border-color: #727272;
  border-color: rgba(114, 114, 114, var(--border-opacity));
}

.focus\\:border-gray-600:focus{
  --border-opacity: 1;
  border-color: #5a626b;
  border-color: rgba(90, 98, 107, var(--border-opacity));
}

.focus\\:border-gray-625:focus{
  border-color: rgba(90,98,107,0.8);
}

.focus\\:border-gray-700:focus{
  --border-opacity: 1;
  border-color: #464C59;
  border-color: rgba(70, 76, 89, var(--border-opacity));
}

.focus\\:border-gray-800:focus{
  --border-opacity: 1;
  border-color: #3c3b3b;
  border-color: rgba(60, 59, 59, var(--border-opacity));
}

.focus\\:border-gray-200a50:focus{
  border-color: rgba(224, 226, 228, 0.5);
}

.focus\\:border-blue-50:focus{
  --border-opacity: 1;
  border-color: #f2fbff;
  border-color: rgba(242, 251, 255, var(--border-opacity));
}

.focus\\:border-blue-100:focus{
  --border-opacity: 1;
  border-color: #EBF6FC;
  border-color: rgba(235, 246, 252, var(--border-opacity));
}

.focus\\:border-blue-150:focus{
  --border-opacity: 1;
  border-color: #E8EEF1;
  border-color: rgba(232, 238, 241, var(--border-opacity));
}

.focus\\:border-blue-200:focus{
  --border-opacity: 1;
  border-color: #CCE6F5;
  border-color: rgba(204, 230, 245, var(--border-opacity));
}

.focus\\:border-blue-300:focus{
  --border-opacity: 1;
  border-color: #73BFE7;
  border-color: rgba(115, 191, 231, var(--border-opacity));
}

.focus\\:border-blue-400:focus{
  --border-opacity: 1;
  border-color: #4BA4F7;
  border-color: rgba(75, 164, 247, var(--border-opacity));
}

.focus\\:border-blue-500:focus{
  --border-opacity: 1;
  border-color: #37A4DC;
  border-color: rgba(55, 164, 220, var(--border-opacity));
}

.focus\\:border-blue-600:focus{
  --border-opacity: 1;
  border-color: #6AA2D6;
  border-color: rgba(106, 162, 214, var(--border-opacity));
}

.focus\\:border-blue-700:focus{
  --border-opacity: 1;
  border-color: #456E9A;
  border-color: rgba(69, 110, 154, var(--border-opacity));
}

.focus\\:border-blue-750:focus{
  --border-opacity: 1;
  border-color: #5682AA;
  border-color: rgba(86, 130, 170, var(--border-opacity));
}

.focus\\:border-blue-800:focus{
  --border-opacity: 1;
  border-color: #1F4566;
  border-color: rgba(31, 69, 102, var(--border-opacity));
}

.focus\\:border-blue-900:focus{
  --border-opacity: 1;
  border-color: #183453;
  border-color: rgba(24, 52, 83, var(--border-opacity));
}

.focus\\:border-blue-950:focus{
  --border-opacity: 1;
  border-color: #041527;
  border-color: rgba(4, 21, 39, var(--border-opacity));
}

.focus\\:border-blue-500a25:focus{
  border-color: rgba(55, 164, 220, 0.2);
}

.focus\\:border-blue-500a50:focus{
  border-color: rgba(55, 164, 220, 0.5);
}

.focus\\:border-blue-700a75:focus{
  --border-opacity: 1;
  border-color: #3B648D;
  border-color: rgba(59, 100, 141, var(--border-opacity));
}

.focus\\:border-blue-700a30:focus{
  --border-opacity: 1;
  border-color: #2A5176;
  border-color: rgba(42, 81, 118, var(--border-opacity));
}

.focus\\:border-blue-750a25:focus{
  border-color: rgba(86,130,170,0.09804);
}

.focus\\:border-blue-750a15:focus{
  border-color: rgba(86,130,170,0.05882);
}

.focus\\:border-blue-800a60:focus{
  border-color: rgba(31, 69, 102, 0.6);
}

.focus\\:border-programEditorTabColors-1:focus{
  --border-opacity: 1;
  border-color: #3cacae;
  border-color: rgba(60, 172, 174, var(--border-opacity));
}

.focus\\:border-programEditorTabColors-2:focus{
  --border-opacity: 1;
  border-color: #8e346a;
  border-color: rgba(142, 52, 106, var(--border-opacity));
}

.focus\\:border-programEditorTabColors-3:focus{
  --border-opacity: 1;
  border-color: #ff72b7;
  border-color: rgba(255, 114, 183, var(--border-opacity));
}

.focus\\:border-programEditorTabColors-4:focus{
  --border-opacity: 1;
  border-color: #ce941c;
  border-color: rgba(206, 148, 28, var(--border-opacity));
}

.focus\\:border-programEditorTabColors-5:focus{
  --border-opacity: 1;
  border-color: #b973d9;
  border-color: rgba(185, 115, 217, var(--border-opacity));
}

.focus\\:border-programEditorTabColors-6:focus{
  --border-opacity: 1;
  border-color: #ff9082;
  border-color: rgba(255, 144, 130, var(--border-opacity));
}

.focus\\:border-programEditorTabColors-1h:focus{
  --border-opacity: 1;
  border-color: #d9f2f2;
  border-color: rgba(217, 242, 242, var(--border-opacity));
}

.focus\\:border-programEditorTabColors-2h:focus{
  --border-opacity: 1;
  border-color: #f1dae8;
  border-color: rgba(241, 218, 232, var(--border-opacity));
}

.focus\\:border-programEditorTabColors-3h:focus{
  --border-opacity: 1;
  border-color: #ffe6f2;
  border-color: rgba(255, 230, 242, var(--border-opacity));
}

.focus\\:border-programEditorTabColors-4h:focus{
  --border-opacity: 1;
  border-color: #f9ecd2;
  border-color: rgba(249, 236, 210, var(--border-opacity));
}

.focus\\:border-programEditorTabColors-5h:focus{
  --border-opacity: 1;
  border-color: #f5ebfa;
  border-color: rgba(245, 235, 250, var(--border-opacity));
}

.focus\\:border-programEditorTabColors-6h:focus{
  --border-opacity: 1;
  border-color: #ffe8e6;
  border-color: rgba(255, 232, 230, var(--border-opacity));
}

.focus\\:border-programEditorPresetTabColors-1:focus{
  --border-opacity: 1;
  border-color: #798fa3;
  border-color: rgba(121, 143, 163, var(--border-opacity));
}

.focus\\:border-programEditorPresetTabColors-1h:focus{
  --border-opacity: 1;
  border-color: #798fa3;
  border-color: rgba(121, 143, 163, var(--border-opacity));
}

.focus\\:border-borgScaleColors-0:focus{
  --border-opacity: 1;
  border-color: #c5d1ff;
  border-color: rgba(197, 209, 255, var(--border-opacity));
}

.focus\\:border-borgScaleColors-1:focus{
  --border-opacity: 1;
  border-color: #a0b5fc;
  border-color: rgba(160, 181, 252, var(--border-opacity));
}

.focus\\:border-borgScaleColors-2:focus{
  --border-opacity: 1;
  border-color: #7492ff;
  border-color: rgba(116, 146, 255, var(--border-opacity));
}

.focus\\:border-borgScaleColors-3:focus{
  --border-opacity: 1;
  border-color: #82bbf1;
  border-color: rgba(130, 187, 241, var(--border-opacity));
}

.focus\\:border-borgScaleColors-4:focus{
  --border-opacity: 1;
  border-color: #4ba4f7;
  border-color: rgba(75, 164, 247, var(--border-opacity));
}

.focus\\:border-borgScaleColors-5:focus{
  --border-opacity: 1;
  border-color: #9cdd57;
  border-color: rgba(156, 221, 87, var(--border-opacity));
}

.focus\\:border-borgScaleColors-6:focus{
  --border-opacity: 1;
  border-color: #68af00;
  border-color: rgba(104, 175, 0, var(--border-opacity));
}

.focus\\:border-borgScaleColors-7:focus{
  --border-opacity: 1;
  border-color: #f5e380;
  border-color: rgba(245, 227, 128, var(--border-opacity));
}

.focus\\:border-borgScaleColors-8:focus{
  --border-opacity: 1;
  border-color: #ffc246;
  border-color: rgba(255, 194, 70, var(--border-opacity));
}

.focus\\:border-borgScaleColors-9:focus{
  --border-opacity: 1;
  border-color: #ff782f;
  border-color: rgba(255, 120, 47, var(--border-opacity));
}

.focus\\:border-borgScaleColors-10:focus{
  --border-opacity: 1;
  border-color: #f25757;
  border-color: rgba(242, 87, 87, var(--border-opacity));
}

.border-opacity-0{
  --border-opacity: 0;
}

.border-opacity-25{
  --border-opacity: .25;
}

.border-opacity-50{
  --border-opacity: .5;
}

.border-opacity-75{
  --border-opacity: .75;
}

.border-opacity-100{
  --border-opacity: 1;
}

.hover\\:border-opacity-0:hover{
  --border-opacity: 0;
}

.hover\\:border-opacity-25:hover{
  --border-opacity: .25;
}

.hover\\:border-opacity-50:hover{
  --border-opacity: .5;
}

.hover\\:border-opacity-75:hover{
  --border-opacity: .75;
}

.hover\\:border-opacity-100:hover{
  --border-opacity: 1;
}

.focus\\:border-opacity-0:focus{
  --border-opacity: 0;
}

.focus\\:border-opacity-25:focus{
  --border-opacity: .25;
}

.focus\\:border-opacity-50:focus{
  --border-opacity: .5;
}

.focus\\:border-opacity-75:focus{
  --border-opacity: .75;
}

.focus\\:border-opacity-100:focus{
  --border-opacity: 1;
}

.rounded-none{
  border-radius: 0;
}

.rounded-sm{
  border-radius: .25rem;
}

.rounded{
  border-radius: .375rem;
}

.rounded-lg{
  border-radius: .5rem;
}

.rounded-xl{
  border-radius: .75rem;
}

.rounded-full{
  border-radius: 9999px;
}

.rounded-t-none{
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rounded-r-none{
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rounded-b-none{
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.rounded-l-none{
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rounded-t-sm{
  border-top-left-radius: .25rem;
  border-top-right-radius: .25rem;
}

.rounded-r-sm{
  border-top-right-radius: .25rem;
  border-bottom-right-radius: .25rem;
}

.rounded-b-sm{
  border-bottom-right-radius: .25rem;
  border-bottom-left-radius: .25rem;
}

.rounded-l-sm{
  border-top-left-radius: .25rem;
  border-bottom-left-radius: .25rem;
}

.rounded-t{
  border-top-left-radius: .375rem;
  border-top-right-radius: .375rem;
}

.rounded-r{
  border-top-right-radius: .375rem;
  border-bottom-right-radius: .375rem;
}

.rounded-b{
  border-bottom-right-radius: .375rem;
  border-bottom-left-radius: .375rem;
}

.rounded-l{
  border-top-left-radius: .375rem;
  border-bottom-left-radius: .375rem;
}

.rounded-t-lg{
  border-top-left-radius: .5rem;
  border-top-right-radius: .5rem;
}

.rounded-r-lg{
  border-top-right-radius: .5rem;
  border-bottom-right-radius: .5rem;
}

.rounded-b-lg{
  border-bottom-right-radius: .5rem;
  border-bottom-left-radius: .5rem;
}

.rounded-l-lg{
  border-top-left-radius: .5rem;
  border-bottom-left-radius: .5rem;
}

.rounded-t-xl{
  border-top-left-radius: .75rem;
  border-top-right-radius: .75rem;
}

.rounded-r-xl{
  border-top-right-radius: .75rem;
  border-bottom-right-radius: .75rem;
}

.rounded-b-xl{
  border-bottom-right-radius: .75rem;
  border-bottom-left-radius: .75rem;
}

.rounded-l-xl{
  border-top-left-radius: .75rem;
  border-bottom-left-radius: .75rem;
}

.rounded-t-full{
  border-top-left-radius: 9999px;
  border-top-right-radius: 9999px;
}

.rounded-r-full{
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}

.rounded-b-full{
  border-bottom-right-radius: 9999px;
  border-bottom-left-radius: 9999px;
}

.rounded-l-full{
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}

.rounded-tl-none{
  border-top-left-radius: 0;
}

.rounded-tr-none{
  border-top-right-radius: 0;
}

.rounded-br-none{
  border-bottom-right-radius: 0;
}

.rounded-bl-none{
  border-bottom-left-radius: 0;
}

.rounded-tl-sm{
  border-top-left-radius: .25rem;
}

.rounded-tr-sm{
  border-top-right-radius: .25rem;
}

.rounded-br-sm{
  border-bottom-right-radius: .25rem;
}

.rounded-bl-sm{
  border-bottom-left-radius: .25rem;
}

.rounded-tl{
  border-top-left-radius: .375rem;
}

.rounded-tr{
  border-top-right-radius: .375rem;
}

.rounded-br{
  border-bottom-right-radius: .375rem;
}

.rounded-bl{
  border-bottom-left-radius: .375rem;
}

.rounded-tl-lg{
  border-top-left-radius: .5rem;
}

.rounded-tr-lg{
  border-top-right-radius: .5rem;
}

.rounded-br-lg{
  border-bottom-right-radius: .5rem;
}

.rounded-bl-lg{
  border-bottom-left-radius: .5rem;
}

.rounded-tl-xl{
  border-top-left-radius: .75rem;
}

.rounded-tr-xl{
  border-top-right-radius: .75rem;
}

.rounded-br-xl{
  border-bottom-right-radius: .75rem;
}

.rounded-bl-xl{
  border-bottom-left-radius: .75rem;
}

.rounded-tl-full{
  border-top-left-radius: 9999px;
}

.rounded-tr-full{
  border-top-right-radius: 9999px;
}

.rounded-br-full{
  border-bottom-right-radius: 9999px;
}

.rounded-bl-full{
  border-bottom-left-radius: 9999px;
}

.border-solid{
  border-style: solid;
}

.border-dashed{
  border-style: dashed;
}

.border-dotted{
  border-style: dotted;
}

.border-double{
  border-style: double;
}

.border-none{
  border-style: none;
}

.border-0{
  border-width: 0;
}

.border-2{
  border-width: 2px;
}

.border-3{
  border-width: 3px;
}

.border-4{
  border-width: 4px;
}

.border-5{
  border-width: 5px;
}

.border-6{
  border-width: 6px;
}

.border-8{
  border-width: 8px;
}

.border{
  border-width: 1px;
}

.border-t-0{
  border-top-width: 0;
}

.border-r-0{
  border-right-width: 0;
}

.border-b-0{
  border-bottom-width: 0;
}

.border-l-0{
  border-left-width: 0;
}

.border-t-2{
  border-top-width: 2px;
}

.border-r-2{
  border-right-width: 2px;
}

.border-b-2{
  border-bottom-width: 2px;
}

.border-l-2{
  border-left-width: 2px;
}

.border-t-3{
  border-top-width: 3px;
}

.border-r-3{
  border-right-width: 3px;
}

.border-b-3{
  border-bottom-width: 3px;
}

.border-l-3{
  border-left-width: 3px;
}

.border-t-4{
  border-top-width: 4px;
}

.border-r-4{
  border-right-width: 4px;
}

.border-b-4{
  border-bottom-width: 4px;
}

.border-l-4{
  border-left-width: 4px;
}

.border-t-5{
  border-top-width: 5px;
}

.border-r-5{
  border-right-width: 5px;
}

.border-b-5{
  border-bottom-width: 5px;
}

.border-l-5{
  border-left-width: 5px;
}

.border-t-6{
  border-top-width: 6px;
}

.border-r-6{
  border-right-width: 6px;
}

.border-b-6{
  border-bottom-width: 6px;
}

.border-l-6{
  border-left-width: 6px;
}

.border-t-8{
  border-top-width: 8px;
}

.border-r-8{
  border-right-width: 8px;
}

.border-b-8{
  border-bottom-width: 8px;
}

.border-l-8{
  border-left-width: 8px;
}

.border-t{
  border-top-width: 1px;
}

.border-r{
  border-right-width: 1px;
}

.border-b{
  border-bottom-width: 1px;
}

.border-l{
  border-left-width: 1px;
}

.first\\:border-0:first-child{
  border-width: 0;
}

.first\\:border-2:first-child{
  border-width: 2px;
}

.first\\:border-3:first-child{
  border-width: 3px;
}

.first\\:border-4:first-child{
  border-width: 4px;
}

.first\\:border-5:first-child{
  border-width: 5px;
}

.first\\:border-6:first-child{
  border-width: 6px;
}

.first\\:border-8:first-child{
  border-width: 8px;
}

.first\\:border:first-child{
  border-width: 1px;
}

.first\\:border-t-0:first-child{
  border-top-width: 0;
}

.first\\:border-r-0:first-child{
  border-right-width: 0;
}

.first\\:border-b-0:first-child{
  border-bottom-width: 0;
}

.first\\:border-l-0:first-child{
  border-left-width: 0;
}

.first\\:border-t-2:first-child{
  border-top-width: 2px;
}

.first\\:border-r-2:first-child{
  border-right-width: 2px;
}

.first\\:border-b-2:first-child{
  border-bottom-width: 2px;
}

.first\\:border-l-2:first-child{
  border-left-width: 2px;
}

.first\\:border-t-3:first-child{
  border-top-width: 3px;
}

.first\\:border-r-3:first-child{
  border-right-width: 3px;
}

.first\\:border-b-3:first-child{
  border-bottom-width: 3px;
}

.first\\:border-l-3:first-child{
  border-left-width: 3px;
}

.first\\:border-t-4:first-child{
  border-top-width: 4px;
}

.first\\:border-r-4:first-child{
  border-right-width: 4px;
}

.first\\:border-b-4:first-child{
  border-bottom-width: 4px;
}

.first\\:border-l-4:first-child{
  border-left-width: 4px;
}

.first\\:border-t-5:first-child{
  border-top-width: 5px;
}

.first\\:border-r-5:first-child{
  border-right-width: 5px;
}

.first\\:border-b-5:first-child{
  border-bottom-width: 5px;
}

.first\\:border-l-5:first-child{
  border-left-width: 5px;
}

.first\\:border-t-6:first-child{
  border-top-width: 6px;
}

.first\\:border-r-6:first-child{
  border-right-width: 6px;
}

.first\\:border-b-6:first-child{
  border-bottom-width: 6px;
}

.first\\:border-l-6:first-child{
  border-left-width: 6px;
}

.first\\:border-t-8:first-child{
  border-top-width: 8px;
}

.first\\:border-r-8:first-child{
  border-right-width: 8px;
}

.first\\:border-b-8:first-child{
  border-bottom-width: 8px;
}

.first\\:border-l-8:first-child{
  border-left-width: 8px;
}

.first\\:border-t:first-child{
  border-top-width: 1px;
}

.first\\:border-r:first-child{
  border-right-width: 1px;
}

.first\\:border-b:first-child{
  border-bottom-width: 1px;
}

.first\\:border-l:first-child{
  border-left-width: 1px;
}

.box-border{
  box-sizing: border-box;
}

.box-content{
  box-sizing: content-box;
}

.cursor-auto{
  cursor: auto;
}

.cursor-default{
  cursor: default;
}

.cursor-pointer{
  cursor: pointer;
}

.cursor-wait{
  cursor: wait;
}

.cursor-move{
  cursor: move;
}

.cursor-not-allowed{
  cursor: not-allowed;
}

.block{
  display: block;
}

.inline-block{
  display: inline-block;
}

.inline{
  display: inline;
}

.flex{
  display: flex;
}

.inline-flex{
  display: inline-flex;
}

.table{
  display: table;
}

.table-caption{
  display: table-caption;
}

.table-cell{
  display: table-cell;
}

.table-column{
  display: table-column;
}

.table-column-group{
  display: table-column-group;
}

.table-footer-group{
  display: table-footer-group;
}

.table-header-group{
  display: table-header-group;
}

.table-row-group{
  display: table-row-group;
}

.table-row{
  display: table-row;
}

.flow-root{
  display: flow-root;
}

.grid{
  display: grid;
}

.inline-grid{
  display: inline-grid;
}

.contents{
  display: contents;
}

.hidden{
  display: none;
}

.flex-row{
  flex-direction: row;
}

.flex-row-reverse{
  flex-direction: row-reverse;
}

.flex-col{
  flex-direction: column;
}

.flex-col-reverse{
  flex-direction: column-reverse;
}

.flex-wrap{
  flex-wrap: wrap;
}

.flex-wrap-reverse{
  flex-wrap: wrap-reverse;
}

.flex-no-wrap{
  flex-wrap: nowrap;
}

.place-items-auto{
  align-items: auto;
  justify-items: auto;
  place-items: auto;
}

.place-items-start{
  align-items: start;
  justify-items: start;
  place-items: start;
}

.place-items-end{
  align-items: end;
  justify-items: end;
  place-items: end;
}

.place-items-center{
  align-items: center;
  justify-items: center;
  place-items: center;
}

.place-items-stretch{
  align-items: stretch;
  justify-items: stretch;
  place-items: stretch;
}

.place-content-center{
  align-content: center;
  justify-content: center;
  place-content: center;
}

.place-content-start{
  align-content: start;
  justify-content: start;
  place-content: start;
}

.place-content-end{
  align-content: end;
  justify-content: end;
  place-content: end;
}

.place-content-between{
  align-content: space-between;
  justify-content: space-between;
  place-content: space-between;
}

.place-content-around{
  align-content: space-around;
  justify-content: space-around;
  place-content: space-around;
}

.place-content-evenly{
  align-content: space-evenly;
  justify-content: space-evenly;
  place-content: space-evenly;
}

.place-content-stretch{
  align-content: stretch;
  justify-content: stretch;
  place-content: stretch;
}

.place-self-auto{
  align-self: auto;
  justify-self: auto;
  place-self: auto;
}

.place-self-start{
  align-self: start;
  justify-self: start;
  place-self: start;
}

.place-self-end{
  align-self: end;
  justify-self: end;
  place-self: end;
}

.place-self-center{
  align-self: center;
  justify-self: center;
  place-self: center;
}

.place-self-stretch{
  align-self: stretch;
  justify-self: stretch;
  place-self: stretch;
}

.items-start{
  align-items: flex-start;
}

.items-end{
  align-items: flex-end;
}

.items-center{
  align-items: center;
}

.items-baseline{
  align-items: baseline;
}

.items-stretch{
  align-items: stretch;
}

.content-center{
  align-content: center;
}

.content-start{
  align-content: flex-start;
}

.content-end{
  align-content: flex-end;
}

.content-between{
  align-content: space-between;
}

.content-around{
  align-content: space-around;
}

.content-evenly{
  align-content: space-evenly;
}

.self-auto{
  align-self: auto;
}

.self-start{
  align-self: flex-start;
}

.self-end{
  align-self: flex-end;
}

.self-center{
  align-self: center;
}

.self-stretch{
  align-self: stretch;
}

.justify-items-auto{
  justify-items: auto;
}

.justify-items-start{
  justify-items: start;
}

.justify-items-end{
  justify-items: end;
}

.justify-items-center{
  justify-items: center;
}

.justify-items-stretch{
  justify-items: stretch;
}

.justify-start{
  justify-content: flex-start;
}

.justify-end{
  justify-content: flex-end;
}

.justify-center{
  justify-content: center;
}

.justify-between{
  justify-content: space-between;
}

.justify-around{
  justify-content: space-around;
}

.justify-evenly{
  justify-content: space-evenly;
}

.justify-self-auto{
  justify-self: auto;
}

.justify-self-start{
  justify-self: start;
}

.justify-self-end{
  justify-self: end;
}

.justify-self-center{
  justify-self: center;
}

.justify-self-stretch{
  justify-self: stretch;
}

.flex-1{
  flex: 1 1 0%;
}

.flex-auto{
  flex: 1 1 auto;
}

.flex-initial{
  flex: 0 1 auto;
}

.flex-none{
  flex: none;
}

.flex-grow-0{
  flex-grow: 0;
}

.flex-grow{
  flex-grow: 1;
}

.flex-shrink-0{
  flex-shrink: 0;
}

.flex-shrink{
  flex-shrink: 1;
}

.order-1{
  order: 1;
}

.order-2{
  order: 2;
}

.order-3{
  order: 3;
}

.order-4{
  order: 4;
}

.order-5{
  order: 5;
}

.order-6{
  order: 6;
}

.order-7{
  order: 7;
}

.order-8{
  order: 8;
}

.order-9{
  order: 9;
}

.order-10{
  order: 10;
}

.order-11{
  order: 11;
}

.order-12{
  order: 12;
}

.order-first{
  order: -9999;
}

.order-last{
  order: 9999;
}

.order-none{
  order: 0;
}

.float-right{
  float: right;
}

.float-left{
  float: left;
}

.float-none{
  float: none;
}

.clearfix:after{
  content: "";
  display: table;
  clear: both;
}

.clear-left{
  clear: left;
}

.clear-right{
  clear: right;
}

.clear-both{
  clear: both;
}

.clear-none{
  clear: none;
}

.font-sans{
  font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
}

.font-serif{
  font-family: Georgia, Cambria, "Times New Roman", Times, serif;
}

.font-mono{
  font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

.font-light{
  font-weight: 100;
}

.font-regular{
  font-weight: 400;
}

.font-semibold{
  font-weight: 600;
}

.font-bold{
  font-weight: 700;
}

.hover\\:font-light:hover{
  font-weight: 100;
}

.hover\\:font-regular:hover{
  font-weight: 400;
}

.hover\\:font-semibold:hover{
  font-weight: 600;
}

.hover\\:font-bold:hover{
  font-weight: 700;
}

.focus\\:font-light:focus{
  font-weight: 100;
}

.focus\\:font-regular:focus{
  font-weight: 400;
}

.focus\\:font-semibold:focus{
  font-weight: 600;
}

.focus\\:font-bold:focus{
  font-weight: 700;
}

.h-0{
  height: 0;
}

.h-1{
  height: 0.25rem;
}

.h-2{
  height: 0.5rem;
}

.h-3{
  height: 0.75rem;
}

.h-4{
  height: 1rem;
}

.h-5{
  height: 1.25rem;
}

.h-6{
  height: 1.5rem;
}

.h-7{
  height: 1.75rem;
}

.h-8{
  height: 2rem;
}

.h-9{
  height: 2.25rem;
}

.h-10{
  height: 2.5rem;
}

.h-11{
  height: 2.75rem;
}

.h-12{
  height: 3rem;
}

.h-14{
  height: 3.5rem;
}

.h-15{
  height: 3.75rem;
}

.h-16{
  height: 4rem;
}

.h-18{
  height: 4.5rem;
}

.h-20{
  height: 5rem;
}

.h-22{
  height: 5.5rem;
}

.h-23{
  height: 5.75rem;
}

.h-24{
  height: 6rem;
}

.h-25{
  height: 6.25rem;
}

.h-26{
  height: 6.5rem;
}

.h-28{
  height: 7rem;
}

.h-30{
  height: 7.5rem;
}

.h-32{
  height: 8rem;
}

.h-34{
  height: 8.5rem;
}

.h-40{
  height: 10rem;
}

.h-42{
  height: 10.5rem;
}

.h-44{
  height: 11rem;
}

.h-48{
  height: 12rem;
}

.h-52{
  height: 13rem;
}

.h-54{
  height: 13.5rem;
}

.h-56{
  height: 14rem;
}

.h-60{
  height: 15rem;
}

.h-64{
  height: 16rem;
}

.h-68{
  height: 17rem;
}

.h-72{
  height: 18rem;
}

.h-74{
  height: 18.5rem;
}

.h-76{
  height: 19rem;
}

.h-78{
  height: 19.5rem;
}

.h-80{
  height: 20rem;
}

.h-82{
  height: 20.5rem;
}

.h-84{
  height: 21rem;
}

.h-88{
  height: 22rem;
}

.h-92{
  height: 23rem;
}

.h-96{
  height: 24rem;
}

.h-98{
  height: 24.5rem;
}

.h-100{
  height: 25rem;
}

.h-104{
  height: 26rem;
}

.h-112{
  height: 28rem;
}

.h-124{
  height: 31rem;
}

.h-128{
  height: 32rem;
}

.h-140{
  height: 35rem;
}

.h-152{
  height: 38rem;
}

.h-160{
  height: 40rem;
}

.h-162{
  height: 41rem;
}

.h-192{
  height: 48rem;
}

.h-208{
  height: 52rem;
}

.h-224{
  height: 56rem;
}

.h-256{
  height: 64rem;
}

.h-auto{
  height: auto;
}

.h-px{
  height: 1px;
}

.h-full{
  height: 100%;
}

.h-screen{
  height: 100vh;
}

.text-xs{
  font-size: 0.74rem;
}

.text-sm{
  font-size: 0.86rem;
}

.text-base{
  font-size: 1rem;
}

.text-lg{
  font-size: 1.15rem;
}

.text-xl{
  font-size: 1.42rem;
}

.text-2xl{
  font-size: 1.85rem;
}

.text-3xl{
  font-size: 1.95rem;
}

.text-4xl{
  font-size: 2.25rem;
}

.text-5xl{
  font-size: 3rem;
}

.text-6xl{
  font-size: 4rem;
}

.text-7xl{
  font-size: 5rem;
}

.leading-none{
  line-height: 1;
}

.leading-tight{
  line-height: 1.2;
}

.leading-snug{
  line-height: 1.3;
}

.leading-normal{
  line-height: 1.4;
}

.leading-relaxed{
  line-height: 1.6;
}

.list-inside{
  list-style-position: inside;
}

.list-outside{
  list-style-position: outside;
}

.list-none{
  list-style-type: none;
}

.list-disc{
  list-style-type: disc;
}

.list-decimal{
  list-style-type: decimal;
}

.m-0{
  margin: 0;
}

.m-1{
  margin: 0.25rem;
}

.m-2{
  margin: 0.5rem;
}

.m-3{
  margin: 0.75rem;
}

.m-4{
  margin: 1rem;
}

.m-5{
  margin: 1.25rem;
}

.m-6{
  margin: 1.5rem;
}

.m-7{
  margin: 1.75rem;
}

.m-8{
  margin: 2rem;
}

.m-9{
  margin: 2.25rem;
}

.m-10{
  margin: 2.5rem;
}

.m-11{
  margin: 2.75rem;
}

.m-12{
  margin: 3rem;
}

.m-14{
  margin: 3.5rem;
}

.m-15{
  margin: 3.75rem;
}

.m-16{
  margin: 4rem;
}

.m-18{
  margin: 4.5rem;
}

.m-20{
  margin: 5rem;
}

.m-22{
  margin: 5.5rem;
}

.m-23{
  margin: 5.75rem;
}

.m-24{
  margin: 6rem;
}

.m-25{
  margin: 6.25rem;
}

.m-26{
  margin: 6.5rem;
}

.m-28{
  margin: 7rem;
}

.m-30{
  margin: 7.5rem;
}

.m-32{
  margin: 8rem;
}

.m-34{
  margin: 8.5rem;
}

.m-40{
  margin: 10rem;
}

.m-42{
  margin: 10.5rem;
}

.m-44{
  margin: 11rem;
}

.m-48{
  margin: 12rem;
}

.m-52{
  margin: 13rem;
}

.m-54{
  margin: 13.5rem;
}

.m-56{
  margin: 14rem;
}

.m-60{
  margin: 15rem;
}

.m-64{
  margin: 16rem;
}

.m-68{
  margin: 17rem;
}

.m-72{
  margin: 18rem;
}

.m-74{
  margin: 18.5rem;
}

.m-76{
  margin: 19rem;
}

.m-78{
  margin: 19.5rem;
}

.m-80{
  margin: 20rem;
}

.m-82{
  margin: 20.5rem;
}

.m-84{
  margin: 21rem;
}

.m-88{
  margin: 22rem;
}

.m-92{
  margin: 23rem;
}

.m-96{
  margin: 24rem;
}

.m-98{
  margin: 24.5rem;
}

.m-100{
  margin: 25rem;
}

.m-104{
  margin: 26rem;
}

.m-112{
  margin: 28rem;
}

.m-124{
  margin: 31rem;
}

.m-128{
  margin: 32rem;
}

.m-140{
  margin: 35rem;
}

.m-152{
  margin: 38rem;
}

.m-160{
  margin: 40rem;
}

.m-162{
  margin: 41rem;
}

.m-192{
  margin: 48rem;
}

.m-208{
  margin: 52rem;
}

.m-224{
  margin: 56rem;
}

.m-256{
  margin: 64rem;
}

.m-auto{
  margin: auto;
}

.m-px{
  margin: 1px;
}

.-m-1{
  margin: -0.25rem;
}

.-m-2{
  margin: -0.5rem;
}

.-m-3{
  margin: -0.75rem;
}

.-m-4{
  margin: -1rem;
}

.-m-5{
  margin: -1.25rem;
}

.-m-6{
  margin: -1.5rem;
}

.-m-7{
  margin: -1.75rem;
}

.-m-8{
  margin: -2rem;
}

.-m-9{
  margin: -2.25rem;
}

.-m-10{
  margin: -2.5rem;
}

.-m-11{
  margin: -2.75rem;
}

.-m-12{
  margin: -3rem;
}

.-m-14{
  margin: -3.5rem;
}

.-m-15{
  margin: -3.75rem;
}

.-m-16{
  margin: -4rem;
}

.-m-18{
  margin: -4.5rem;
}

.-m-20{
  margin: -5rem;
}

.-m-22{
  margin: -5.5rem;
}

.-m-23{
  margin: -5.75rem;
}

.-m-24{
  margin: -6rem;
}

.-m-25{
  margin: -6.25rem;
}

.-m-26{
  margin: -6.5rem;
}

.-m-28{
  margin: -7rem;
}

.-m-30{
  margin: -7.5rem;
}

.-m-32{
  margin: -8rem;
}

.-m-34{
  margin: -8.5rem;
}

.-m-40{
  margin: -10rem;
}

.-m-42{
  margin: -10.5rem;
}

.-m-44{
  margin: -11rem;
}

.-m-48{
  margin: -12rem;
}

.-m-52{
  margin: -13rem;
}

.-m-54{
  margin: -13.5rem;
}

.-m-56{
  margin: -14rem;
}

.-m-60{
  margin: -15rem;
}

.-m-64{
  margin: -16rem;
}

.-m-68{
  margin: -17rem;
}

.-m-72{
  margin: -18rem;
}

.-m-74{
  margin: -18.5rem;
}

.-m-76{
  margin: -19rem;
}

.-m-78{
  margin: -19.5rem;
}

.-m-80{
  margin: -20rem;
}

.-m-82{
  margin: -20.5rem;
}

.-m-84{
  margin: -21rem;
}

.-m-88{
  margin: -22rem;
}

.-m-92{
  margin: -23rem;
}

.-m-96{
  margin: -24rem;
}

.-m-98{
  margin: -24.5rem;
}

.-m-100{
  margin: -25rem;
}

.-m-104{
  margin: -26rem;
}

.-m-112{
  margin: -28rem;
}

.-m-124{
  margin: -31rem;
}

.-m-128{
  margin: -32rem;
}

.-m-140{
  margin: -35rem;
}

.-m-152{
  margin: -38rem;
}

.-m-160{
  margin: -40rem;
}

.-m-162{
  margin: -41rem;
}

.-m-192{
  margin: -48rem;
}

.-m-208{
  margin: -52rem;
}

.-m-224{
  margin: -56rem;
}

.-m-256{
  margin: -64rem;
}

.-m-px{
  margin: -1px;
}

.my-0{
  margin-top: 0;
  margin-bottom: 0;
}

.mx-0{
  margin-left: 0;
  margin-right: 0;
}

.my-1{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.mx-1{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.my-2{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.mx-2{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.my-3{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}

.mx-3{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}

.my-4{
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.mx-4{
  margin-left: 1rem;
  margin-right: 1rem;
}

.my-5{
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}

.mx-5{
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}

.my-6{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.mx-6{
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}

.my-7{
  margin-top: 1.75rem;
  margin-bottom: 1.75rem;
}

.mx-7{
  margin-left: 1.75rem;
  margin-right: 1.75rem;
}

.my-8{
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.mx-8{
  margin-left: 2rem;
  margin-right: 2rem;
}

.my-9{
  margin-top: 2.25rem;
  margin-bottom: 2.25rem;
}

.mx-9{
  margin-left: 2.25rem;
  margin-right: 2.25rem;
}

.my-10{
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}

.mx-10{
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}

.my-11{
  margin-top: 2.75rem;
  margin-bottom: 2.75rem;
}

.mx-11{
  margin-left: 2.75rem;
  margin-right: 2.75rem;
}

.my-12{
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.mx-12{
  margin-left: 3rem;
  margin-right: 3rem;
}

.my-14{
  margin-top: 3.5rem;
  margin-bottom: 3.5rem;
}

.mx-14{
  margin-left: 3.5rem;
  margin-right: 3.5rem;
}

.my-15{
  margin-top: 3.75rem;
  margin-bottom: 3.75rem;
}

.mx-15{
  margin-left: 3.75rem;
  margin-right: 3.75rem;
}

.my-16{
  margin-top: 4rem;
  margin-bottom: 4rem;
}

.mx-16{
  margin-left: 4rem;
  margin-right: 4rem;
}

.my-18{
  margin-top: 4.5rem;
  margin-bottom: 4.5rem;
}

.mx-18{
  margin-left: 4.5rem;
  margin-right: 4.5rem;
}

.my-20{
  margin-top: 5rem;
  margin-bottom: 5rem;
}

.mx-20{
  margin-left: 5rem;
  margin-right: 5rem;
}

.my-22{
  margin-top: 5.5rem;
  margin-bottom: 5.5rem;
}

.mx-22{
  margin-left: 5.5rem;
  margin-right: 5.5rem;
}

.my-23{
  margin-top: 5.75rem;
  margin-bottom: 5.75rem;
}

.mx-23{
  margin-left: 5.75rem;
  margin-right: 5.75rem;
}

.my-24{
  margin-top: 6rem;
  margin-bottom: 6rem;
}

.mx-24{
  margin-left: 6rem;
  margin-right: 6rem;
}

.my-25{
  margin-top: 6.25rem;
  margin-bottom: 6.25rem;
}

.mx-25{
  margin-left: 6.25rem;
  margin-right: 6.25rem;
}

.my-26{
  margin-top: 6.5rem;
  margin-bottom: 6.5rem;
}

.mx-26{
  margin-left: 6.5rem;
  margin-right: 6.5rem;
}

.my-28{
  margin-top: 7rem;
  margin-bottom: 7rem;
}

.mx-28{
  margin-left: 7rem;
  margin-right: 7rem;
}

.my-30{
  margin-top: 7.5rem;
  margin-bottom: 7.5rem;
}

.mx-30{
  margin-left: 7.5rem;
  margin-right: 7.5rem;
}

.my-32{
  margin-top: 8rem;
  margin-bottom: 8rem;
}

.mx-32{
  margin-left: 8rem;
  margin-right: 8rem;
}

.my-34{
  margin-top: 8.5rem;
  margin-bottom: 8.5rem;
}

.mx-34{
  margin-left: 8.5rem;
  margin-right: 8.5rem;
}

.my-40{
  margin-top: 10rem;
  margin-bottom: 10rem;
}

.mx-40{
  margin-left: 10rem;
  margin-right: 10rem;
}

.my-42{
  margin-top: 10.5rem;
  margin-bottom: 10.5rem;
}

.mx-42{
  margin-left: 10.5rem;
  margin-right: 10.5rem;
}

.my-44{
  margin-top: 11rem;
  margin-bottom: 11rem;
}

.mx-44{
  margin-left: 11rem;
  margin-right: 11rem;
}

.my-48{
  margin-top: 12rem;
  margin-bottom: 12rem;
}

.mx-48{
  margin-left: 12rem;
  margin-right: 12rem;
}

.my-52{
  margin-top: 13rem;
  margin-bottom: 13rem;
}

.mx-52{
  margin-left: 13rem;
  margin-right: 13rem;
}

.my-54{
  margin-top: 13.5rem;
  margin-bottom: 13.5rem;
}

.mx-54{
  margin-left: 13.5rem;
  margin-right: 13.5rem;
}

.my-56{
  margin-top: 14rem;
  margin-bottom: 14rem;
}

.mx-56{
  margin-left: 14rem;
  margin-right: 14rem;
}

.my-60{
  margin-top: 15rem;
  margin-bottom: 15rem;
}

.mx-60{
  margin-left: 15rem;
  margin-right: 15rem;
}

.my-64{
  margin-top: 16rem;
  margin-bottom: 16rem;
}

.mx-64{
  margin-left: 16rem;
  margin-right: 16rem;
}

.my-68{
  margin-top: 17rem;
  margin-bottom: 17rem;
}

.mx-68{
  margin-left: 17rem;
  margin-right: 17rem;
}

.my-72{
  margin-top: 18rem;
  margin-bottom: 18rem;
}

.mx-72{
  margin-left: 18rem;
  margin-right: 18rem;
}

.my-74{
  margin-top: 18.5rem;
  margin-bottom: 18.5rem;
}

.mx-74{
  margin-left: 18.5rem;
  margin-right: 18.5rem;
}

.my-76{
  margin-top: 19rem;
  margin-bottom: 19rem;
}

.mx-76{
  margin-left: 19rem;
  margin-right: 19rem;
}

.my-78{
  margin-top: 19.5rem;
  margin-bottom: 19.5rem;
}

.mx-78{
  margin-left: 19.5rem;
  margin-right: 19.5rem;
}

.my-80{
  margin-top: 20rem;
  margin-bottom: 20rem;
}

.mx-80{
  margin-left: 20rem;
  margin-right: 20rem;
}

.my-82{
  margin-top: 20.5rem;
  margin-bottom: 20.5rem;
}

.mx-82{
  margin-left: 20.5rem;
  margin-right: 20.5rem;
}

.my-84{
  margin-top: 21rem;
  margin-bottom: 21rem;
}

.mx-84{
  margin-left: 21rem;
  margin-right: 21rem;
}

.my-88{
  margin-top: 22rem;
  margin-bottom: 22rem;
}

.mx-88{
  margin-left: 22rem;
  margin-right: 22rem;
}

.my-92{
  margin-top: 23rem;
  margin-bottom: 23rem;
}

.mx-92{
  margin-left: 23rem;
  margin-right: 23rem;
}

.my-96{
  margin-top: 24rem;
  margin-bottom: 24rem;
}

.mx-96{
  margin-left: 24rem;
  margin-right: 24rem;
}

.my-98{
  margin-top: 24.5rem;
  margin-bottom: 24.5rem;
}

.mx-98{
  margin-left: 24.5rem;
  margin-right: 24.5rem;
}

.my-100{
  margin-top: 25rem;
  margin-bottom: 25rem;
}

.mx-100{
  margin-left: 25rem;
  margin-right: 25rem;
}

.my-104{
  margin-top: 26rem;
  margin-bottom: 26rem;
}

.mx-104{
  margin-left: 26rem;
  margin-right: 26rem;
}

.my-112{
  margin-top: 28rem;
  margin-bottom: 28rem;
}

.mx-112{
  margin-left: 28rem;
  margin-right: 28rem;
}

.my-124{
  margin-top: 31rem;
  margin-bottom: 31rem;
}

.mx-124{
  margin-left: 31rem;
  margin-right: 31rem;
}

.my-128{
  margin-top: 32rem;
  margin-bottom: 32rem;
}

.mx-128{
  margin-left: 32rem;
  margin-right: 32rem;
}

.my-140{
  margin-top: 35rem;
  margin-bottom: 35rem;
}

.mx-140{
  margin-left: 35rem;
  margin-right: 35rem;
}

.my-152{
  margin-top: 38rem;
  margin-bottom: 38rem;
}

.mx-152{
  margin-left: 38rem;
  margin-right: 38rem;
}

.my-160{
  margin-top: 40rem;
  margin-bottom: 40rem;
}

.mx-160{
  margin-left: 40rem;
  margin-right: 40rem;
}

.my-162{
  margin-top: 41rem;
  margin-bottom: 41rem;
}

.mx-162{
  margin-left: 41rem;
  margin-right: 41rem;
}

.my-192{
  margin-top: 48rem;
  margin-bottom: 48rem;
}

.mx-192{
  margin-left: 48rem;
  margin-right: 48rem;
}

.my-208{
  margin-top: 52rem;
  margin-bottom: 52rem;
}

.mx-208{
  margin-left: 52rem;
  margin-right: 52rem;
}

.my-224{
  margin-top: 56rem;
  margin-bottom: 56rem;
}

.mx-224{
  margin-left: 56rem;
  margin-right: 56rem;
}

.my-256{
  margin-top: 64rem;
  margin-bottom: 64rem;
}

.mx-256{
  margin-left: 64rem;
  margin-right: 64rem;
}

.my-auto{
  margin-top: auto;
  margin-bottom: auto;
}

.mx-auto{
  margin-left: auto;
  margin-right: auto;
}

.my-px{
  margin-top: 1px;
  margin-bottom: 1px;
}

.mx-px{
  margin-left: 1px;
  margin-right: 1px;
}

.-my-1{
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}

.-mx-1{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}

.-my-2{
  margin-top: -0.5rem;
  margin-bottom: -0.5rem;
}

.-mx-2{
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}

.-my-3{
  margin-top: -0.75rem;
  margin-bottom: -0.75rem;
}

.-mx-3{
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}

.-my-4{
  margin-top: -1rem;
  margin-bottom: -1rem;
}

.-mx-4{
  margin-left: -1rem;
  margin-right: -1rem;
}

.-my-5{
  margin-top: -1.25rem;
  margin-bottom: -1.25rem;
}

.-mx-5{
  margin-left: -1.25rem;
  margin-right: -1.25rem;
}

.-my-6{
  margin-top: -1.5rem;
  margin-bottom: -1.5rem;
}

.-mx-6{
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}

.-my-7{
  margin-top: -1.75rem;
  margin-bottom: -1.75rem;
}

.-mx-7{
  margin-left: -1.75rem;
  margin-right: -1.75rem;
}

.-my-8{
  margin-top: -2rem;
  margin-bottom: -2rem;
}

.-mx-8{
  margin-left: -2rem;
  margin-right: -2rem;
}

.-my-9{
  margin-top: -2.25rem;
  margin-bottom: -2.25rem;
}

.-mx-9{
  margin-left: -2.25rem;
  margin-right: -2.25rem;
}

.-my-10{
  margin-top: -2.5rem;
  margin-bottom: -2.5rem;
}

.-mx-10{
  margin-left: -2.5rem;
  margin-right: -2.5rem;
}

.-my-11{
  margin-top: -2.75rem;
  margin-bottom: -2.75rem;
}

.-mx-11{
  margin-left: -2.75rem;
  margin-right: -2.75rem;
}

.-my-12{
  margin-top: -3rem;
  margin-bottom: -3rem;
}

.-mx-12{
  margin-left: -3rem;
  margin-right: -3rem;
}

.-my-14{
  margin-top: -3.5rem;
  margin-bottom: -3.5rem;
}

.-mx-14{
  margin-left: -3.5rem;
  margin-right: -3.5rem;
}

.-my-15{
  margin-top: -3.75rem;
  margin-bottom: -3.75rem;
}

.-mx-15{
  margin-left: -3.75rem;
  margin-right: -3.75rem;
}

.-my-16{
  margin-top: -4rem;
  margin-bottom: -4rem;
}

.-mx-16{
  margin-left: -4rem;
  margin-right: -4rem;
}

.-my-18{
  margin-top: -4.5rem;
  margin-bottom: -4.5rem;
}

.-mx-18{
  margin-left: -4.5rem;
  margin-right: -4.5rem;
}

.-my-20{
  margin-top: -5rem;
  margin-bottom: -5rem;
}

.-mx-20{
  margin-left: -5rem;
  margin-right: -5rem;
}

.-my-22{
  margin-top: -5.5rem;
  margin-bottom: -5.5rem;
}

.-mx-22{
  margin-left: -5.5rem;
  margin-right: -5.5rem;
}

.-my-23{
  margin-top: -5.75rem;
  margin-bottom: -5.75rem;
}

.-mx-23{
  margin-left: -5.75rem;
  margin-right: -5.75rem;
}

.-my-24{
  margin-top: -6rem;
  margin-bottom: -6rem;
}

.-mx-24{
  margin-left: -6rem;
  margin-right: -6rem;
}

.-my-25{
  margin-top: -6.25rem;
  margin-bottom: -6.25rem;
}

.-mx-25{
  margin-left: -6.25rem;
  margin-right: -6.25rem;
}

.-my-26{
  margin-top: -6.5rem;
  margin-bottom: -6.5rem;
}

.-mx-26{
  margin-left: -6.5rem;
  margin-right: -6.5rem;
}

.-my-28{
  margin-top: -7rem;
  margin-bottom: -7rem;
}

.-mx-28{
  margin-left: -7rem;
  margin-right: -7rem;
}

.-my-30{
  margin-top: -7.5rem;
  margin-bottom: -7.5rem;
}

.-mx-30{
  margin-left: -7.5rem;
  margin-right: -7.5rem;
}

.-my-32{
  margin-top: -8rem;
  margin-bottom: -8rem;
}

.-mx-32{
  margin-left: -8rem;
  margin-right: -8rem;
}

.-my-34{
  margin-top: -8.5rem;
  margin-bottom: -8.5rem;
}

.-mx-34{
  margin-left: -8.5rem;
  margin-right: -8.5rem;
}

.-my-40{
  margin-top: -10rem;
  margin-bottom: -10rem;
}

.-mx-40{
  margin-left: -10rem;
  margin-right: -10rem;
}

.-my-42{
  margin-top: -10.5rem;
  margin-bottom: -10.5rem;
}

.-mx-42{
  margin-left: -10.5rem;
  margin-right: -10.5rem;
}

.-my-44{
  margin-top: -11rem;
  margin-bottom: -11rem;
}

.-mx-44{
  margin-left: -11rem;
  margin-right: -11rem;
}

.-my-48{
  margin-top: -12rem;
  margin-bottom: -12rem;
}

.-mx-48{
  margin-left: -12rem;
  margin-right: -12rem;
}

.-my-52{
  margin-top: -13rem;
  margin-bottom: -13rem;
}

.-mx-52{
  margin-left: -13rem;
  margin-right: -13rem;
}

.-my-54{
  margin-top: -13.5rem;
  margin-bottom: -13.5rem;
}

.-mx-54{
  margin-left: -13.5rem;
  margin-right: -13.5rem;
}

.-my-56{
  margin-top: -14rem;
  margin-bottom: -14rem;
}

.-mx-56{
  margin-left: -14rem;
  margin-right: -14rem;
}

.-my-60{
  margin-top: -15rem;
  margin-bottom: -15rem;
}

.-mx-60{
  margin-left: -15rem;
  margin-right: -15rem;
}

.-my-64{
  margin-top: -16rem;
  margin-bottom: -16rem;
}

.-mx-64{
  margin-left: -16rem;
  margin-right: -16rem;
}

.-my-68{
  margin-top: -17rem;
  margin-bottom: -17rem;
}

.-mx-68{
  margin-left: -17rem;
  margin-right: -17rem;
}

.-my-72{
  margin-top: -18rem;
  margin-bottom: -18rem;
}

.-mx-72{
  margin-left: -18rem;
  margin-right: -18rem;
}

.-my-74{
  margin-top: -18.5rem;
  margin-bottom: -18.5rem;
}

.-mx-74{
  margin-left: -18.5rem;
  margin-right: -18.5rem;
}

.-my-76{
  margin-top: -19rem;
  margin-bottom: -19rem;
}

.-mx-76{
  margin-left: -19rem;
  margin-right: -19rem;
}

.-my-78{
  margin-top: -19.5rem;
  margin-bottom: -19.5rem;
}

.-mx-78{
  margin-left: -19.5rem;
  margin-right: -19.5rem;
}

.-my-80{
  margin-top: -20rem;
  margin-bottom: -20rem;
}

.-mx-80{
  margin-left: -20rem;
  margin-right: -20rem;
}

.-my-82{
  margin-top: -20.5rem;
  margin-bottom: -20.5rem;
}

.-mx-82{
  margin-left: -20.5rem;
  margin-right: -20.5rem;
}

.-my-84{
  margin-top: -21rem;
  margin-bottom: -21rem;
}

.-mx-84{
  margin-left: -21rem;
  margin-right: -21rem;
}

.-my-88{
  margin-top: -22rem;
  margin-bottom: -22rem;
}

.-mx-88{
  margin-left: -22rem;
  margin-right: -22rem;
}

.-my-92{
  margin-top: -23rem;
  margin-bottom: -23rem;
}

.-mx-92{
  margin-left: -23rem;
  margin-right: -23rem;
}

.-my-96{
  margin-top: -24rem;
  margin-bottom: -24rem;
}

.-mx-96{
  margin-left: -24rem;
  margin-right: -24rem;
}

.-my-98{
  margin-top: -24.5rem;
  margin-bottom: -24.5rem;
}

.-mx-98{
  margin-left: -24.5rem;
  margin-right: -24.5rem;
}

.-my-100{
  margin-top: -25rem;
  margin-bottom: -25rem;
}

.-mx-100{
  margin-left: -25rem;
  margin-right: -25rem;
}

.-my-104{
  margin-top: -26rem;
  margin-bottom: -26rem;
}

.-mx-104{
  margin-left: -26rem;
  margin-right: -26rem;
}

.-my-112{
  margin-top: -28rem;
  margin-bottom: -28rem;
}

.-mx-112{
  margin-left: -28rem;
  margin-right: -28rem;
}

.-my-124{
  margin-top: -31rem;
  margin-bottom: -31rem;
}

.-mx-124{
  margin-left: -31rem;
  margin-right: -31rem;
}

.-my-128{
  margin-top: -32rem;
  margin-bottom: -32rem;
}

.-mx-128{
  margin-left: -32rem;
  margin-right: -32rem;
}

.-my-140{
  margin-top: -35rem;
  margin-bottom: -35rem;
}

.-mx-140{
  margin-left: -35rem;
  margin-right: -35rem;
}

.-my-152{
  margin-top: -38rem;
  margin-bottom: -38rem;
}

.-mx-152{
  margin-left: -38rem;
  margin-right: -38rem;
}

.-my-160{
  margin-top: -40rem;
  margin-bottom: -40rem;
}

.-mx-160{
  margin-left: -40rem;
  margin-right: -40rem;
}

.-my-162{
  margin-top: -41rem;
  margin-bottom: -41rem;
}

.-mx-162{
  margin-left: -41rem;
  margin-right: -41rem;
}

.-my-192{
  margin-top: -48rem;
  margin-bottom: -48rem;
}

.-mx-192{
  margin-left: -48rem;
  margin-right: -48rem;
}

.-my-208{
  margin-top: -52rem;
  margin-bottom: -52rem;
}

.-mx-208{
  margin-left: -52rem;
  margin-right: -52rem;
}

.-my-224{
  margin-top: -56rem;
  margin-bottom: -56rem;
}

.-mx-224{
  margin-left: -56rem;
  margin-right: -56rem;
}

.-my-256{
  margin-top: -64rem;
  margin-bottom: -64rem;
}

.-mx-256{
  margin-left: -64rem;
  margin-right: -64rem;
}

.-my-px{
  margin-top: -1px;
  margin-bottom: -1px;
}

.-mx-px{
  margin-left: -1px;
  margin-right: -1px;
}

.mt-0{
  margin-top: 0;
}

.mr-0{
  margin-right: 0;
}

.mb-0{
  margin-bottom: 0;
}

.ml-0{
  margin-left: 0;
}

.mt-1{
  margin-top: 0.25rem;
}

.mr-1{
  margin-right: 0.25rem;
}

.mb-1{
  margin-bottom: 0.25rem;
}

.ml-1{
  margin-left: 0.25rem;
}

.mt-2{
  margin-top: 0.5rem;
}

.mr-2{
  margin-right: 0.5rem;
}

.mb-2{
  margin-bottom: 0.5rem;
}

.ml-2{
  margin-left: 0.5rem;
}

.mt-3{
  margin-top: 0.75rem;
}

.mr-3{
  margin-right: 0.75rem;
}

.mb-3{
  margin-bottom: 0.75rem;
}

.ml-3{
  margin-left: 0.75rem;
}

.mt-4{
  margin-top: 1rem;
}

.mr-4{
  margin-right: 1rem;
}

.mb-4{
  margin-bottom: 1rem;
}

.ml-4{
  margin-left: 1rem;
}

.mt-5{
  margin-top: 1.25rem;
}

.mr-5{
  margin-right: 1.25rem;
}

.mb-5{
  margin-bottom: 1.25rem;
}

.ml-5{
  margin-left: 1.25rem;
}

.mt-6{
  margin-top: 1.5rem;
}

.mr-6{
  margin-right: 1.5rem;
}

.mb-6{
  margin-bottom: 1.5rem;
}

.ml-6{
  margin-left: 1.5rem;
}

.mt-7{
  margin-top: 1.75rem;
}

.mr-7{
  margin-right: 1.75rem;
}

.mb-7{
  margin-bottom: 1.75rem;
}

.ml-7{
  margin-left: 1.75rem;
}

.mt-8{
  margin-top: 2rem;
}

.mr-8{
  margin-right: 2rem;
}

.mb-8{
  margin-bottom: 2rem;
}

.ml-8{
  margin-left: 2rem;
}

.mt-9{
  margin-top: 2.25rem;
}

.mr-9{
  margin-right: 2.25rem;
}

.mb-9{
  margin-bottom: 2.25rem;
}

.ml-9{
  margin-left: 2.25rem;
}

.mt-10{
  margin-top: 2.5rem;
}

.mr-10{
  margin-right: 2.5rem;
}

.mb-10{
  margin-bottom: 2.5rem;
}

.ml-10{
  margin-left: 2.5rem;
}

.mt-11{
  margin-top: 2.75rem;
}

.mr-11{
  margin-right: 2.75rem;
}

.mb-11{
  margin-bottom: 2.75rem;
}

.ml-11{
  margin-left: 2.75rem;
}

.mt-12{
  margin-top: 3rem;
}

.mr-12{
  margin-right: 3rem;
}

.mb-12{
  margin-bottom: 3rem;
}

.ml-12{
  margin-left: 3rem;
}

.mt-14{
  margin-top: 3.5rem;
}

.mr-14{
  margin-right: 3.5rem;
}

.mb-14{
  margin-bottom: 3.5rem;
}

.ml-14{
  margin-left: 3.5rem;
}

.mt-15{
  margin-top: 3.75rem;
}

.mr-15{
  margin-right: 3.75rem;
}

.mb-15{
  margin-bottom: 3.75rem;
}

.ml-15{
  margin-left: 3.75rem;
}

.mt-16{
  margin-top: 4rem;
}

.mr-16{
  margin-right: 4rem;
}

.mb-16{
  margin-bottom: 4rem;
}

.ml-16{
  margin-left: 4rem;
}

.mt-18{
  margin-top: 4.5rem;
}

.mr-18{
  margin-right: 4.5rem;
}

.mb-18{
  margin-bottom: 4.5rem;
}

.ml-18{
  margin-left: 4.5rem;
}

.mt-20{
  margin-top: 5rem;
}

.mr-20{
  margin-right: 5rem;
}

.mb-20{
  margin-bottom: 5rem;
}

.ml-20{
  margin-left: 5rem;
}

.mt-22{
  margin-top: 5.5rem;
}

.mr-22{
  margin-right: 5.5rem;
}

.mb-22{
  margin-bottom: 5.5rem;
}

.ml-22{
  margin-left: 5.5rem;
}

.mt-23{
  margin-top: 5.75rem;
}

.mr-23{
  margin-right: 5.75rem;
}

.mb-23{
  margin-bottom: 5.75rem;
}

.ml-23{
  margin-left: 5.75rem;
}

.mt-24{
  margin-top: 6rem;
}

.mr-24{
  margin-right: 6rem;
}

.mb-24{
  margin-bottom: 6rem;
}

.ml-24{
  margin-left: 6rem;
}

.mt-25{
  margin-top: 6.25rem;
}

.mr-25{
  margin-right: 6.25rem;
}

.mb-25{
  margin-bottom: 6.25rem;
}

.ml-25{
  margin-left: 6.25rem;
}

.mt-26{
  margin-top: 6.5rem;
}

.mr-26{
  margin-right: 6.5rem;
}

.mb-26{
  margin-bottom: 6.5rem;
}

.ml-26{
  margin-left: 6.5rem;
}

.mt-28{
  margin-top: 7rem;
}

.mr-28{
  margin-right: 7rem;
}

.mb-28{
  margin-bottom: 7rem;
}

.ml-28{
  margin-left: 7rem;
}

.mt-30{
  margin-top: 7.5rem;
}

.mr-30{
  margin-right: 7.5rem;
}

.mb-30{
  margin-bottom: 7.5rem;
}

.ml-30{
  margin-left: 7.5rem;
}

.mt-32{
  margin-top: 8rem;
}

.mr-32{
  margin-right: 8rem;
}

.mb-32{
  margin-bottom: 8rem;
}

.ml-32{
  margin-left: 8rem;
}

.mt-34{
  margin-top: 8.5rem;
}

.mr-34{
  margin-right: 8.5rem;
}

.mb-34{
  margin-bottom: 8.5rem;
}

.ml-34{
  margin-left: 8.5rem;
}

.mt-40{
  margin-top: 10rem;
}

.mr-40{
  margin-right: 10rem;
}

.mb-40{
  margin-bottom: 10rem;
}

.ml-40{
  margin-left: 10rem;
}

.mt-42{
  margin-top: 10.5rem;
}

.mr-42{
  margin-right: 10.5rem;
}

.mb-42{
  margin-bottom: 10.5rem;
}

.ml-42{
  margin-left: 10.5rem;
}

.mt-44{
  margin-top: 11rem;
}

.mr-44{
  margin-right: 11rem;
}

.mb-44{
  margin-bottom: 11rem;
}

.ml-44{
  margin-left: 11rem;
}

.mt-48{
  margin-top: 12rem;
}

.mr-48{
  margin-right: 12rem;
}

.mb-48{
  margin-bottom: 12rem;
}

.ml-48{
  margin-left: 12rem;
}

.mt-52{
  margin-top: 13rem;
}

.mr-52{
  margin-right: 13rem;
}

.mb-52{
  margin-bottom: 13rem;
}

.ml-52{
  margin-left: 13rem;
}

.mt-54{
  margin-top: 13.5rem;
}

.mr-54{
  margin-right: 13.5rem;
}

.mb-54{
  margin-bottom: 13.5rem;
}

.ml-54{
  margin-left: 13.5rem;
}

.mt-56{
  margin-top: 14rem;
}

.mr-56{
  margin-right: 14rem;
}

.mb-56{
  margin-bottom: 14rem;
}

.ml-56{
  margin-left: 14rem;
}

.mt-60{
  margin-top: 15rem;
}

.mr-60{
  margin-right: 15rem;
}

.mb-60{
  margin-bottom: 15rem;
}

.ml-60{
  margin-left: 15rem;
}

.mt-64{
  margin-top: 16rem;
}

.mr-64{
  margin-right: 16rem;
}

.mb-64{
  margin-bottom: 16rem;
}

.ml-64{
  margin-left: 16rem;
}

.mt-68{
  margin-top: 17rem;
}

.mr-68{
  margin-right: 17rem;
}

.mb-68{
  margin-bottom: 17rem;
}

.ml-68{
  margin-left: 17rem;
}

.mt-72{
  margin-top: 18rem;
}

.mr-72{
  margin-right: 18rem;
}

.mb-72{
  margin-bottom: 18rem;
}

.ml-72{
  margin-left: 18rem;
}

.mt-74{
  margin-top: 18.5rem;
}

.mr-74{
  margin-right: 18.5rem;
}

.mb-74{
  margin-bottom: 18.5rem;
}

.ml-74{
  margin-left: 18.5rem;
}

.mt-76{
  margin-top: 19rem;
}

.mr-76{
  margin-right: 19rem;
}

.mb-76{
  margin-bottom: 19rem;
}

.ml-76{
  margin-left: 19rem;
}

.mt-78{
  margin-top: 19.5rem;
}

.mr-78{
  margin-right: 19.5rem;
}

.mb-78{
  margin-bottom: 19.5rem;
}

.ml-78{
  margin-left: 19.5rem;
}

.mt-80{
  margin-top: 20rem;
}

.mr-80{
  margin-right: 20rem;
}

.mb-80{
  margin-bottom: 20rem;
}

.ml-80{
  margin-left: 20rem;
}

.mt-82{
  margin-top: 20.5rem;
}

.mr-82{
  margin-right: 20.5rem;
}

.mb-82{
  margin-bottom: 20.5rem;
}

.ml-82{
  margin-left: 20.5rem;
}

.mt-84{
  margin-top: 21rem;
}

.mr-84{
  margin-right: 21rem;
}

.mb-84{
  margin-bottom: 21rem;
}

.ml-84{
  margin-left: 21rem;
}

.mt-88{
  margin-top: 22rem;
}

.mr-88{
  margin-right: 22rem;
}

.mb-88{
  margin-bottom: 22rem;
}

.ml-88{
  margin-left: 22rem;
}

.mt-92{
  margin-top: 23rem;
}

.mr-92{
  margin-right: 23rem;
}

.mb-92{
  margin-bottom: 23rem;
}

.ml-92{
  margin-left: 23rem;
}

.mt-96{
  margin-top: 24rem;
}

.mr-96{
  margin-right: 24rem;
}

.mb-96{
  margin-bottom: 24rem;
}

.ml-96{
  margin-left: 24rem;
}

.mt-98{
  margin-top: 24.5rem;
}

.mr-98{
  margin-right: 24.5rem;
}

.mb-98{
  margin-bottom: 24.5rem;
}

.ml-98{
  margin-left: 24.5rem;
}

.mt-100{
  margin-top: 25rem;
}

.mr-100{
  margin-right: 25rem;
}

.mb-100{
  margin-bottom: 25rem;
}

.ml-100{
  margin-left: 25rem;
}

.mt-104{
  margin-top: 26rem;
}

.mr-104{
  margin-right: 26rem;
}

.mb-104{
  margin-bottom: 26rem;
}

.ml-104{
  margin-left: 26rem;
}

.mt-112{
  margin-top: 28rem;
}

.mr-112{
  margin-right: 28rem;
}

.mb-112{
  margin-bottom: 28rem;
}

.ml-112{
  margin-left: 28rem;
}

.mt-124{
  margin-top: 31rem;
}

.mr-124{
  margin-right: 31rem;
}

.mb-124{
  margin-bottom: 31rem;
}

.ml-124{
  margin-left: 31rem;
}

.mt-128{
  margin-top: 32rem;
}

.mr-128{
  margin-right: 32rem;
}

.mb-128{
  margin-bottom: 32rem;
}

.ml-128{
  margin-left: 32rem;
}

.mt-140{
  margin-top: 35rem;
}

.mr-140{
  margin-right: 35rem;
}

.mb-140{
  margin-bottom: 35rem;
}

.ml-140{
  margin-left: 35rem;
}

.mt-152{
  margin-top: 38rem;
}

.mr-152{
  margin-right: 38rem;
}

.mb-152{
  margin-bottom: 38rem;
}

.ml-152{
  margin-left: 38rem;
}

.mt-160{
  margin-top: 40rem;
}

.mr-160{
  margin-right: 40rem;
}

.mb-160{
  margin-bottom: 40rem;
}

.ml-160{
  margin-left: 40rem;
}

.mt-162{
  margin-top: 41rem;
}

.mr-162{
  margin-right: 41rem;
}

.mb-162{
  margin-bottom: 41rem;
}

.ml-162{
  margin-left: 41rem;
}

.mt-192{
  margin-top: 48rem;
}

.mr-192{
  margin-right: 48rem;
}

.mb-192{
  margin-bottom: 48rem;
}

.ml-192{
  margin-left: 48rem;
}

.mt-208{
  margin-top: 52rem;
}

.mr-208{
  margin-right: 52rem;
}

.mb-208{
  margin-bottom: 52rem;
}

.ml-208{
  margin-left: 52rem;
}

.mt-224{
  margin-top: 56rem;
}

.mr-224{
  margin-right: 56rem;
}

.mb-224{
  margin-bottom: 56rem;
}

.ml-224{
  margin-left: 56rem;
}

.mt-256{
  margin-top: 64rem;
}

.mr-256{
  margin-right: 64rem;
}

.mb-256{
  margin-bottom: 64rem;
}

.ml-256{
  margin-left: 64rem;
}

.mt-auto{
  margin-top: auto;
}

.mr-auto{
  margin-right: auto;
}

.mb-auto{
  margin-bottom: auto;
}

.ml-auto{
  margin-left: auto;
}

.mt-px{
  margin-top: 1px;
}

.mr-px{
  margin-right: 1px;
}

.mb-px{
  margin-bottom: 1px;
}

.ml-px{
  margin-left: 1px;
}

.-mt-1{
  margin-top: -0.25rem;
}

.-mr-1{
  margin-right: -0.25rem;
}

.-mb-1{
  margin-bottom: -0.25rem;
}

.-ml-1{
  margin-left: -0.25rem;
}

.-mt-2{
  margin-top: -0.5rem;
}

.-mr-2{
  margin-right: -0.5rem;
}

.-mb-2{
  margin-bottom: -0.5rem;
}

.-ml-2{
  margin-left: -0.5rem;
}

.-mt-3{
  margin-top: -0.75rem;
}

.-mr-3{
  margin-right: -0.75rem;
}

.-mb-3{
  margin-bottom: -0.75rem;
}

.-ml-3{
  margin-left: -0.75rem;
}

.-mt-4{
  margin-top: -1rem;
}

.-mr-4{
  margin-right: -1rem;
}

.-mb-4{
  margin-bottom: -1rem;
}

.-ml-4{
  margin-left: -1rem;
}

.-mt-5{
  margin-top: -1.25rem;
}

.-mr-5{
  margin-right: -1.25rem;
}

.-mb-5{
  margin-bottom: -1.25rem;
}

.-ml-5{
  margin-left: -1.25rem;
}

.-mt-6{
  margin-top: -1.5rem;
}

.-mr-6{
  margin-right: -1.5rem;
}

.-mb-6{
  margin-bottom: -1.5rem;
}

.-ml-6{
  margin-left: -1.5rem;
}

.-mt-7{
  margin-top: -1.75rem;
}

.-mr-7{
  margin-right: -1.75rem;
}

.-mb-7{
  margin-bottom: -1.75rem;
}

.-ml-7{
  margin-left: -1.75rem;
}

.-mt-8{
  margin-top: -2rem;
}

.-mr-8{
  margin-right: -2rem;
}

.-mb-8{
  margin-bottom: -2rem;
}

.-ml-8{
  margin-left: -2rem;
}

.-mt-9{
  margin-top: -2.25rem;
}

.-mr-9{
  margin-right: -2.25rem;
}

.-mb-9{
  margin-bottom: -2.25rem;
}

.-ml-9{
  margin-left: -2.25rem;
}

.-mt-10{
  margin-top: -2.5rem;
}

.-mr-10{
  margin-right: -2.5rem;
}

.-mb-10{
  margin-bottom: -2.5rem;
}

.-ml-10{
  margin-left: -2.5rem;
}

.-mt-11{
  margin-top: -2.75rem;
}

.-mr-11{
  margin-right: -2.75rem;
}

.-mb-11{
  margin-bottom: -2.75rem;
}

.-ml-11{
  margin-left: -2.75rem;
}

.-mt-12{
  margin-top: -3rem;
}

.-mr-12{
  margin-right: -3rem;
}

.-mb-12{
  margin-bottom: -3rem;
}

.-ml-12{
  margin-left: -3rem;
}

.-mt-14{
  margin-top: -3.5rem;
}

.-mr-14{
  margin-right: -3.5rem;
}

.-mb-14{
  margin-bottom: -3.5rem;
}

.-ml-14{
  margin-left: -3.5rem;
}

.-mt-15{
  margin-top: -3.75rem;
}

.-mr-15{
  margin-right: -3.75rem;
}

.-mb-15{
  margin-bottom: -3.75rem;
}

.-ml-15{
  margin-left: -3.75rem;
}

.-mt-16{
  margin-top: -4rem;
}

.-mr-16{
  margin-right: -4rem;
}

.-mb-16{
  margin-bottom: -4rem;
}

.-ml-16{
  margin-left: -4rem;
}

.-mt-18{
  margin-top: -4.5rem;
}

.-mr-18{
  margin-right: -4.5rem;
}

.-mb-18{
  margin-bottom: -4.5rem;
}

.-ml-18{
  margin-left: -4.5rem;
}

.-mt-20{
  margin-top: -5rem;
}

.-mr-20{
  margin-right: -5rem;
}

.-mb-20{
  margin-bottom: -5rem;
}

.-ml-20{
  margin-left: -5rem;
}

.-mt-22{
  margin-top: -5.5rem;
}

.-mr-22{
  margin-right: -5.5rem;
}

.-mb-22{
  margin-bottom: -5.5rem;
}

.-ml-22{
  margin-left: -5.5rem;
}

.-mt-23{
  margin-top: -5.75rem;
}

.-mr-23{
  margin-right: -5.75rem;
}

.-mb-23{
  margin-bottom: -5.75rem;
}

.-ml-23{
  margin-left: -5.75rem;
}

.-mt-24{
  margin-top: -6rem;
}

.-mr-24{
  margin-right: -6rem;
}

.-mb-24{
  margin-bottom: -6rem;
}

.-ml-24{
  margin-left: -6rem;
}

.-mt-25{
  margin-top: -6.25rem;
}

.-mr-25{
  margin-right: -6.25rem;
}

.-mb-25{
  margin-bottom: -6.25rem;
}

.-ml-25{
  margin-left: -6.25rem;
}

.-mt-26{
  margin-top: -6.5rem;
}

.-mr-26{
  margin-right: -6.5rem;
}

.-mb-26{
  margin-bottom: -6.5rem;
}

.-ml-26{
  margin-left: -6.5rem;
}

.-mt-28{
  margin-top: -7rem;
}

.-mr-28{
  margin-right: -7rem;
}

.-mb-28{
  margin-bottom: -7rem;
}

.-ml-28{
  margin-left: -7rem;
}

.-mt-30{
  margin-top: -7.5rem;
}

.-mr-30{
  margin-right: -7.5rem;
}

.-mb-30{
  margin-bottom: -7.5rem;
}

.-ml-30{
  margin-left: -7.5rem;
}

.-mt-32{
  margin-top: -8rem;
}

.-mr-32{
  margin-right: -8rem;
}

.-mb-32{
  margin-bottom: -8rem;
}

.-ml-32{
  margin-left: -8rem;
}

.-mt-34{
  margin-top: -8.5rem;
}

.-mr-34{
  margin-right: -8.5rem;
}

.-mb-34{
  margin-bottom: -8.5rem;
}

.-ml-34{
  margin-left: -8.5rem;
}

.-mt-40{
  margin-top: -10rem;
}

.-mr-40{
  margin-right: -10rem;
}

.-mb-40{
  margin-bottom: -10rem;
}

.-ml-40{
  margin-left: -10rem;
}

.-mt-42{
  margin-top: -10.5rem;
}

.-mr-42{
  margin-right: -10.5rem;
}

.-mb-42{
  margin-bottom: -10.5rem;
}

.-ml-42{
  margin-left: -10.5rem;
}

.-mt-44{
  margin-top: -11rem;
}

.-mr-44{
  margin-right: -11rem;
}

.-mb-44{
  margin-bottom: -11rem;
}

.-ml-44{
  margin-left: -11rem;
}

.-mt-48{
  margin-top: -12rem;
}

.-mr-48{
  margin-right: -12rem;
}

.-mb-48{
  margin-bottom: -12rem;
}

.-ml-48{
  margin-left: -12rem;
}

.-mt-52{
  margin-top: -13rem;
}

.-mr-52{
  margin-right: -13rem;
}

.-mb-52{
  margin-bottom: -13rem;
}

.-ml-52{
  margin-left: -13rem;
}

.-mt-54{
  margin-top: -13.5rem;
}

.-mr-54{
  margin-right: -13.5rem;
}

.-mb-54{
  margin-bottom: -13.5rem;
}

.-ml-54{
  margin-left: -13.5rem;
}

.-mt-56{
  margin-top: -14rem;
}

.-mr-56{
  margin-right: -14rem;
}

.-mb-56{
  margin-bottom: -14rem;
}

.-ml-56{
  margin-left: -14rem;
}

.-mt-60{
  margin-top: -15rem;
}

.-mr-60{
  margin-right: -15rem;
}

.-mb-60{
  margin-bottom: -15rem;
}

.-ml-60{
  margin-left: -15rem;
}

.-mt-64{
  margin-top: -16rem;
}

.-mr-64{
  margin-right: -16rem;
}

.-mb-64{
  margin-bottom: -16rem;
}

.-ml-64{
  margin-left: -16rem;
}

.-mt-68{
  margin-top: -17rem;
}

.-mr-68{
  margin-right: -17rem;
}

.-mb-68{
  margin-bottom: -17rem;
}

.-ml-68{
  margin-left: -17rem;
}

.-mt-72{
  margin-top: -18rem;
}

.-mr-72{
  margin-right: -18rem;
}

.-mb-72{
  margin-bottom: -18rem;
}

.-ml-72{
  margin-left: -18rem;
}

.-mt-74{
  margin-top: -18.5rem;
}

.-mr-74{
  margin-right: -18.5rem;
}

.-mb-74{
  margin-bottom: -18.5rem;
}

.-ml-74{
  margin-left: -18.5rem;
}

.-mt-76{
  margin-top: -19rem;
}

.-mr-76{
  margin-right: -19rem;
}

.-mb-76{
  margin-bottom: -19rem;
}

.-ml-76{
  margin-left: -19rem;
}

.-mt-78{
  margin-top: -19.5rem;
}

.-mr-78{
  margin-right: -19.5rem;
}

.-mb-78{
  margin-bottom: -19.5rem;
}

.-ml-78{
  margin-left: -19.5rem;
}

.-mt-80{
  margin-top: -20rem;
}

.-mr-80{
  margin-right: -20rem;
}

.-mb-80{
  margin-bottom: -20rem;
}

.-ml-80{
  margin-left: -20rem;
}

.-mt-82{
  margin-top: -20.5rem;
}

.-mr-82{
  margin-right: -20.5rem;
}

.-mb-82{
  margin-bottom: -20.5rem;
}

.-ml-82{
  margin-left: -20.5rem;
}

.-mt-84{
  margin-top: -21rem;
}

.-mr-84{
  margin-right: -21rem;
}

.-mb-84{
  margin-bottom: -21rem;
}

.-ml-84{
  margin-left: -21rem;
}

.-mt-88{
  margin-top: -22rem;
}

.-mr-88{
  margin-right: -22rem;
}

.-mb-88{
  margin-bottom: -22rem;
}

.-ml-88{
  margin-left: -22rem;
}

.-mt-92{
  margin-top: -23rem;
}

.-mr-92{
  margin-right: -23rem;
}

.-mb-92{
  margin-bottom: -23rem;
}

.-ml-92{
  margin-left: -23rem;
}

.-mt-96{
  margin-top: -24rem;
}

.-mr-96{
  margin-right: -24rem;
}

.-mb-96{
  margin-bottom: -24rem;
}

.-ml-96{
  margin-left: -24rem;
}

.-mt-98{
  margin-top: -24.5rem;
}

.-mr-98{
  margin-right: -24.5rem;
}

.-mb-98{
  margin-bottom: -24.5rem;
}

.-ml-98{
  margin-left: -24.5rem;
}

.-mt-100{
  margin-top: -25rem;
}

.-mr-100{
  margin-right: -25rem;
}

.-mb-100{
  margin-bottom: -25rem;
}

.-ml-100{
  margin-left: -25rem;
}

.-mt-104{
  margin-top: -26rem;
}

.-mr-104{
  margin-right: -26rem;
}

.-mb-104{
  margin-bottom: -26rem;
}

.-ml-104{
  margin-left: -26rem;
}

.-mt-112{
  margin-top: -28rem;
}

.-mr-112{
  margin-right: -28rem;
}

.-mb-112{
  margin-bottom: -28rem;
}

.-ml-112{
  margin-left: -28rem;
}

.-mt-124{
  margin-top: -31rem;
}

.-mr-124{
  margin-right: -31rem;
}

.-mb-124{
  margin-bottom: -31rem;
}

.-ml-124{
  margin-left: -31rem;
}

.-mt-128{
  margin-top: -32rem;
}

.-mr-128{
  margin-right: -32rem;
}

.-mb-128{
  margin-bottom: -32rem;
}

.-ml-128{
  margin-left: -32rem;
}

.-mt-140{
  margin-top: -35rem;
}

.-mr-140{
  margin-right: -35rem;
}

.-mb-140{
  margin-bottom: -35rem;
}

.-ml-140{
  margin-left: -35rem;
}

.-mt-152{
  margin-top: -38rem;
}

.-mr-152{
  margin-right: -38rem;
}

.-mb-152{
  margin-bottom: -38rem;
}

.-ml-152{
  margin-left: -38rem;
}

.-mt-160{
  margin-top: -40rem;
}

.-mr-160{
  margin-right: -40rem;
}

.-mb-160{
  margin-bottom: -40rem;
}

.-ml-160{
  margin-left: -40rem;
}

.-mt-162{
  margin-top: -41rem;
}

.-mr-162{
  margin-right: -41rem;
}

.-mb-162{
  margin-bottom: -41rem;
}

.-ml-162{
  margin-left: -41rem;
}

.-mt-192{
  margin-top: -48rem;
}

.-mr-192{
  margin-right: -48rem;
}

.-mb-192{
  margin-bottom: -48rem;
}

.-ml-192{
  margin-left: -48rem;
}

.-mt-208{
  margin-top: -52rem;
}

.-mr-208{
  margin-right: -52rem;
}

.-mb-208{
  margin-bottom: -52rem;
}

.-ml-208{
  margin-left: -52rem;
}

.-mt-224{
  margin-top: -56rem;
}

.-mr-224{
  margin-right: -56rem;
}

.-mb-224{
  margin-bottom: -56rem;
}

.-ml-224{
  margin-left: -56rem;
}

.-mt-256{
  margin-top: -64rem;
}

.-mr-256{
  margin-right: -64rem;
}

.-mb-256{
  margin-bottom: -64rem;
}

.-ml-256{
  margin-left: -64rem;
}

.-mt-px{
  margin-top: -1px;
}

.-mr-px{
  margin-right: -1px;
}

.-mb-px{
  margin-bottom: -1px;
}

.-ml-px{
  margin-left: -1px;
}

.first\\:m-0:first-child{
  margin: 0;
}

.first\\:m-1:first-child{
  margin: 0.25rem;
}

.first\\:m-2:first-child{
  margin: 0.5rem;
}

.first\\:m-3:first-child{
  margin: 0.75rem;
}

.first\\:m-4:first-child{
  margin: 1rem;
}

.first\\:m-5:first-child{
  margin: 1.25rem;
}

.first\\:m-6:first-child{
  margin: 1.5rem;
}

.first\\:m-7:first-child{
  margin: 1.75rem;
}

.first\\:m-8:first-child{
  margin: 2rem;
}

.first\\:m-9:first-child{
  margin: 2.25rem;
}

.first\\:m-10:first-child{
  margin: 2.5rem;
}

.first\\:m-11:first-child{
  margin: 2.75rem;
}

.first\\:m-12:first-child{
  margin: 3rem;
}

.first\\:m-14:first-child{
  margin: 3.5rem;
}

.first\\:m-15:first-child{
  margin: 3.75rem;
}

.first\\:m-16:first-child{
  margin: 4rem;
}

.first\\:m-18:first-child{
  margin: 4.5rem;
}

.first\\:m-20:first-child{
  margin: 5rem;
}

.first\\:m-22:first-child{
  margin: 5.5rem;
}

.first\\:m-23:first-child{
  margin: 5.75rem;
}

.first\\:m-24:first-child{
  margin: 6rem;
}

.first\\:m-25:first-child{
  margin: 6.25rem;
}

.first\\:m-26:first-child{
  margin: 6.5rem;
}

.first\\:m-28:first-child{
  margin: 7rem;
}

.first\\:m-30:first-child{
  margin: 7.5rem;
}

.first\\:m-32:first-child{
  margin: 8rem;
}

.first\\:m-34:first-child{
  margin: 8.5rem;
}

.first\\:m-40:first-child{
  margin: 10rem;
}

.first\\:m-42:first-child{
  margin: 10.5rem;
}

.first\\:m-44:first-child{
  margin: 11rem;
}

.first\\:m-48:first-child{
  margin: 12rem;
}

.first\\:m-52:first-child{
  margin: 13rem;
}

.first\\:m-54:first-child{
  margin: 13.5rem;
}

.first\\:m-56:first-child{
  margin: 14rem;
}

.first\\:m-60:first-child{
  margin: 15rem;
}

.first\\:m-64:first-child{
  margin: 16rem;
}

.first\\:m-68:first-child{
  margin: 17rem;
}

.first\\:m-72:first-child{
  margin: 18rem;
}

.first\\:m-74:first-child{
  margin: 18.5rem;
}

.first\\:m-76:first-child{
  margin: 19rem;
}

.first\\:m-78:first-child{
  margin: 19.5rem;
}

.first\\:m-80:first-child{
  margin: 20rem;
}

.first\\:m-82:first-child{
  margin: 20.5rem;
}

.first\\:m-84:first-child{
  margin: 21rem;
}

.first\\:m-88:first-child{
  margin: 22rem;
}

.first\\:m-92:first-child{
  margin: 23rem;
}

.first\\:m-96:first-child{
  margin: 24rem;
}

.first\\:m-98:first-child{
  margin: 24.5rem;
}

.first\\:m-100:first-child{
  margin: 25rem;
}

.first\\:m-104:first-child{
  margin: 26rem;
}

.first\\:m-112:first-child{
  margin: 28rem;
}

.first\\:m-124:first-child{
  margin: 31rem;
}

.first\\:m-128:first-child{
  margin: 32rem;
}

.first\\:m-140:first-child{
  margin: 35rem;
}

.first\\:m-152:first-child{
  margin: 38rem;
}

.first\\:m-160:first-child{
  margin: 40rem;
}

.first\\:m-162:first-child{
  margin: 41rem;
}

.first\\:m-192:first-child{
  margin: 48rem;
}

.first\\:m-208:first-child{
  margin: 52rem;
}

.first\\:m-224:first-child{
  margin: 56rem;
}

.first\\:m-256:first-child{
  margin: 64rem;
}

.first\\:m-auto:first-child{
  margin: auto;
}

.first\\:m-px:first-child{
  margin: 1px;
}

.first\\:-m-1:first-child{
  margin: -0.25rem;
}

.first\\:-m-2:first-child{
  margin: -0.5rem;
}

.first\\:-m-3:first-child{
  margin: -0.75rem;
}

.first\\:-m-4:first-child{
  margin: -1rem;
}

.first\\:-m-5:first-child{
  margin: -1.25rem;
}

.first\\:-m-6:first-child{
  margin: -1.5rem;
}

.first\\:-m-7:first-child{
  margin: -1.75rem;
}

.first\\:-m-8:first-child{
  margin: -2rem;
}

.first\\:-m-9:first-child{
  margin: -2.25rem;
}

.first\\:-m-10:first-child{
  margin: -2.5rem;
}

.first\\:-m-11:first-child{
  margin: -2.75rem;
}

.first\\:-m-12:first-child{
  margin: -3rem;
}

.first\\:-m-14:first-child{
  margin: -3.5rem;
}

.first\\:-m-15:first-child{
  margin: -3.75rem;
}

.first\\:-m-16:first-child{
  margin: -4rem;
}

.first\\:-m-18:first-child{
  margin: -4.5rem;
}

.first\\:-m-20:first-child{
  margin: -5rem;
}

.first\\:-m-22:first-child{
  margin: -5.5rem;
}

.first\\:-m-23:first-child{
  margin: -5.75rem;
}

.first\\:-m-24:first-child{
  margin: -6rem;
}

.first\\:-m-25:first-child{
  margin: -6.25rem;
}

.first\\:-m-26:first-child{
  margin: -6.5rem;
}

.first\\:-m-28:first-child{
  margin: -7rem;
}

.first\\:-m-30:first-child{
  margin: -7.5rem;
}

.first\\:-m-32:first-child{
  margin: -8rem;
}

.first\\:-m-34:first-child{
  margin: -8.5rem;
}

.first\\:-m-40:first-child{
  margin: -10rem;
}

.first\\:-m-42:first-child{
  margin: -10.5rem;
}

.first\\:-m-44:first-child{
  margin: -11rem;
}

.first\\:-m-48:first-child{
  margin: -12rem;
}

.first\\:-m-52:first-child{
  margin: -13rem;
}

.first\\:-m-54:first-child{
  margin: -13.5rem;
}

.first\\:-m-56:first-child{
  margin: -14rem;
}

.first\\:-m-60:first-child{
  margin: -15rem;
}

.first\\:-m-64:first-child{
  margin: -16rem;
}

.first\\:-m-68:first-child{
  margin: -17rem;
}

.first\\:-m-72:first-child{
  margin: -18rem;
}

.first\\:-m-74:first-child{
  margin: -18.5rem;
}

.first\\:-m-76:first-child{
  margin: -19rem;
}

.first\\:-m-78:first-child{
  margin: -19.5rem;
}

.first\\:-m-80:first-child{
  margin: -20rem;
}

.first\\:-m-82:first-child{
  margin: -20.5rem;
}

.first\\:-m-84:first-child{
  margin: -21rem;
}

.first\\:-m-88:first-child{
  margin: -22rem;
}

.first\\:-m-92:first-child{
  margin: -23rem;
}

.first\\:-m-96:first-child{
  margin: -24rem;
}

.first\\:-m-98:first-child{
  margin: -24.5rem;
}

.first\\:-m-100:first-child{
  margin: -25rem;
}

.first\\:-m-104:first-child{
  margin: -26rem;
}

.first\\:-m-112:first-child{
  margin: -28rem;
}

.first\\:-m-124:first-child{
  margin: -31rem;
}

.first\\:-m-128:first-child{
  margin: -32rem;
}

.first\\:-m-140:first-child{
  margin: -35rem;
}

.first\\:-m-152:first-child{
  margin: -38rem;
}

.first\\:-m-160:first-child{
  margin: -40rem;
}

.first\\:-m-162:first-child{
  margin: -41rem;
}

.first\\:-m-192:first-child{
  margin: -48rem;
}

.first\\:-m-208:first-child{
  margin: -52rem;
}

.first\\:-m-224:first-child{
  margin: -56rem;
}

.first\\:-m-256:first-child{
  margin: -64rem;
}

.first\\:-m-px:first-child{
  margin: -1px;
}

.first\\:my-0:first-child{
  margin-top: 0;
  margin-bottom: 0;
}

.first\\:mx-0:first-child{
  margin-left: 0;
  margin-right: 0;
}

.first\\:my-1:first-child{
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
}

.first\\:mx-1:first-child{
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.first\\:my-2:first-child{
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.first\\:mx-2:first-child{
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

.first\\:my-3:first-child{
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}

.first\\:mx-3:first-child{
  margin-left: 0.75rem;
  margin-right: 0.75rem;
}

.first\\:my-4:first-child{
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.first\\:mx-4:first-child{
  margin-left: 1rem;
  margin-right: 1rem;
}

.first\\:my-5:first-child{
  margin-top: 1.25rem;
  margin-bottom: 1.25rem;
}

.first\\:mx-5:first-child{
  margin-left: 1.25rem;
  margin-right: 1.25rem;
}

.first\\:my-6:first-child{
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}

.first\\:mx-6:first-child{
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}

.first\\:my-7:first-child{
  margin-top: 1.75rem;
  margin-bottom: 1.75rem;
}

.first\\:mx-7:first-child{
  margin-left: 1.75rem;
  margin-right: 1.75rem;
}

.first\\:my-8:first-child{
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.first\\:mx-8:first-child{
  margin-left: 2rem;
  margin-right: 2rem;
}

.first\\:my-9:first-child{
  margin-top: 2.25rem;
  margin-bottom: 2.25rem;
}

.first\\:mx-9:first-child{
  margin-left: 2.25rem;
  margin-right: 2.25rem;
}

.first\\:my-10:first-child{
  margin-top: 2.5rem;
  margin-bottom: 2.5rem;
}

.first\\:mx-10:first-child{
  margin-left: 2.5rem;
  margin-right: 2.5rem;
}

.first\\:my-11:first-child{
  margin-top: 2.75rem;
  margin-bottom: 2.75rem;
}

.first\\:mx-11:first-child{
  margin-left: 2.75rem;
  margin-right: 2.75rem;
}

.first\\:my-12:first-child{
  margin-top: 3rem;
  margin-bottom: 3rem;
}

.first\\:mx-12:first-child{
  margin-left: 3rem;
  margin-right: 3rem;
}

.first\\:my-14:first-child{
  margin-top: 3.5rem;
  margin-bottom: 3.5rem;
}

.first\\:mx-14:first-child{
  margin-left: 3.5rem;
  margin-right: 3.5rem;
}

.first\\:my-15:first-child{
  margin-top: 3.75rem;
  margin-bottom: 3.75rem;
}

.first\\:mx-15:first-child{
  margin-left: 3.75rem;
  margin-right: 3.75rem;
}

.first\\:my-16:first-child{
  margin-top: 4rem;
  margin-bottom: 4rem;
}

.first\\:mx-16:first-child{
  margin-left: 4rem;
  margin-right: 4rem;
}

.first\\:my-18:first-child{
  margin-top: 4.5rem;
  margin-bottom: 4.5rem;
}

.first\\:mx-18:first-child{
  margin-left: 4.5rem;
  margin-right: 4.5rem;
}

.first\\:my-20:first-child{
  margin-top: 5rem;
  margin-bottom: 5rem;
}

.first\\:mx-20:first-child{
  margin-left: 5rem;
  margin-right: 5rem;
}

.first\\:my-22:first-child{
  margin-top: 5.5rem;
  margin-bottom: 5.5rem;
}

.first\\:mx-22:first-child{
  margin-left: 5.5rem;
  margin-right: 5.5rem;
}

.first\\:my-23:first-child{
  margin-top: 5.75rem;
  margin-bottom: 5.75rem;
}

.first\\:mx-23:first-child{
  margin-left: 5.75rem;
  margin-right: 5.75rem;
}

.first\\:my-24:first-child{
  margin-top: 6rem;
  margin-bottom: 6rem;
}

.first\\:mx-24:first-child{
  margin-left: 6rem;
  margin-right: 6rem;
}

.first\\:my-25:first-child{
  margin-top: 6.25rem;
  margin-bottom: 6.25rem;
}

.first\\:mx-25:first-child{
  margin-left: 6.25rem;
  margin-right: 6.25rem;
}

.first\\:my-26:first-child{
  margin-top: 6.5rem;
  margin-bottom: 6.5rem;
}

.first\\:mx-26:first-child{
  margin-left: 6.5rem;
  margin-right: 6.5rem;
}

.first\\:my-28:first-child{
  margin-top: 7rem;
  margin-bottom: 7rem;
}

.first\\:mx-28:first-child{
  margin-left: 7rem;
  margin-right: 7rem;
}

.first\\:my-30:first-child{
  margin-top: 7.5rem;
  margin-bottom: 7.5rem;
}

.first\\:mx-30:first-child{
  margin-left: 7.5rem;
  margin-right: 7.5rem;
}

.first\\:my-32:first-child{
  margin-top: 8rem;
  margin-bottom: 8rem;
}

.first\\:mx-32:first-child{
  margin-left: 8rem;
  margin-right: 8rem;
}

.first\\:my-34:first-child{
  margin-top: 8.5rem;
  margin-bottom: 8.5rem;
}

.first\\:mx-34:first-child{
  margin-left: 8.5rem;
  margin-right: 8.5rem;
}

.first\\:my-40:first-child{
  margin-top: 10rem;
  margin-bottom: 10rem;
}

.first\\:mx-40:first-child{
  margin-left: 10rem;
  margin-right: 10rem;
}

.first\\:my-42:first-child{
  margin-top: 10.5rem;
  margin-bottom: 10.5rem;
}

.first\\:mx-42:first-child{
  margin-left: 10.5rem;
  margin-right: 10.5rem;
}

.first\\:my-44:first-child{
  margin-top: 11rem;
  margin-bottom: 11rem;
}

.first\\:mx-44:first-child{
  margin-left: 11rem;
  margin-right: 11rem;
}

.first\\:my-48:first-child{
  margin-top: 12rem;
  margin-bottom: 12rem;
}

.first\\:mx-48:first-child{
  margin-left: 12rem;
  margin-right: 12rem;
}

.first\\:my-52:first-child{
  margin-top: 13rem;
  margin-bottom: 13rem;
}

.first\\:mx-52:first-child{
  margin-left: 13rem;
  margin-right: 13rem;
}

.first\\:my-54:first-child{
  margin-top: 13.5rem;
  margin-bottom: 13.5rem;
}

.first\\:mx-54:first-child{
  margin-left: 13.5rem;
  margin-right: 13.5rem;
}

.first\\:my-56:first-child{
  margin-top: 14rem;
  margin-bottom: 14rem;
}

.first\\:mx-56:first-child{
  margin-left: 14rem;
  margin-right: 14rem;
}

.first\\:my-60:first-child{
  margin-top: 15rem;
  margin-bottom: 15rem;
}

.first\\:mx-60:first-child{
  margin-left: 15rem;
  margin-right: 15rem;
}

.first\\:my-64:first-child{
  margin-top: 16rem;
  margin-bottom: 16rem;
}

.first\\:mx-64:first-child{
  margin-left: 16rem;
  margin-right: 16rem;
}

.first\\:my-68:first-child{
  margin-top: 17rem;
  margin-bottom: 17rem;
}

.first\\:mx-68:first-child{
  margin-left: 17rem;
  margin-right: 17rem;
}

.first\\:my-72:first-child{
  margin-top: 18rem;
  margin-bottom: 18rem;
}

.first\\:mx-72:first-child{
  margin-left: 18rem;
  margin-right: 18rem;
}

.first\\:my-74:first-child{
  margin-top: 18.5rem;
  margin-bottom: 18.5rem;
}

.first\\:mx-74:first-child{
  margin-left: 18.5rem;
  margin-right: 18.5rem;
}

.first\\:my-76:first-child{
  margin-top: 19rem;
  margin-bottom: 19rem;
}

.first\\:mx-76:first-child{
  margin-left: 19rem;
  margin-right: 19rem;
}

.first\\:my-78:first-child{
  margin-top: 19.5rem;
  margin-bottom: 19.5rem;
}

.first\\:mx-78:first-child{
  margin-left: 19.5rem;
  margin-right: 19.5rem;
}

.first\\:my-80:first-child{
  margin-top: 20rem;
  margin-bottom: 20rem;
}

.first\\:mx-80:first-child{
  margin-left: 20rem;
  margin-right: 20rem;
}

.first\\:my-82:first-child{
  margin-top: 20.5rem;
  margin-bottom: 20.5rem;
}

.first\\:mx-82:first-child{
  margin-left: 20.5rem;
  margin-right: 20.5rem;
}

.first\\:my-84:first-child{
  margin-top: 21rem;
  margin-bottom: 21rem;
}

.first\\:mx-84:first-child{
  margin-left: 21rem;
  margin-right: 21rem;
}

.first\\:my-88:first-child{
  margin-top: 22rem;
  margin-bottom: 22rem;
}

.first\\:mx-88:first-child{
  margin-left: 22rem;
  margin-right: 22rem;
}

.first\\:my-92:first-child{
  margin-top: 23rem;
  margin-bottom: 23rem;
}

.first\\:mx-92:first-child{
  margin-left: 23rem;
  margin-right: 23rem;
}

.first\\:my-96:first-child{
  margin-top: 24rem;
  margin-bottom: 24rem;
}

.first\\:mx-96:first-child{
  margin-left: 24rem;
  margin-right: 24rem;
}

.first\\:my-98:first-child{
  margin-top: 24.5rem;
  margin-bottom: 24.5rem;
}

.first\\:mx-98:first-child{
  margin-left: 24.5rem;
  margin-right: 24.5rem;
}

.first\\:my-100:first-child{
  margin-top: 25rem;
  margin-bottom: 25rem;
}

.first\\:mx-100:first-child{
  margin-left: 25rem;
  margin-right: 25rem;
}

.first\\:my-104:first-child{
  margin-top: 26rem;
  margin-bottom: 26rem;
}

.first\\:mx-104:first-child{
  margin-left: 26rem;
  margin-right: 26rem;
}

.first\\:my-112:first-child{
  margin-top: 28rem;
  margin-bottom: 28rem;
}

.first\\:mx-112:first-child{
  margin-left: 28rem;
  margin-right: 28rem;
}

.first\\:my-124:first-child{
  margin-top: 31rem;
  margin-bottom: 31rem;
}

.first\\:mx-124:first-child{
  margin-left: 31rem;
  margin-right: 31rem;
}

.first\\:my-128:first-child{
  margin-top: 32rem;
  margin-bottom: 32rem;
}

.first\\:mx-128:first-child{
  margin-left: 32rem;
  margin-right: 32rem;
}

.first\\:my-140:first-child{
  margin-top: 35rem;
  margin-bottom: 35rem;
}

.first\\:mx-140:first-child{
  margin-left: 35rem;
  margin-right: 35rem;
}

.first\\:my-152:first-child{
  margin-top: 38rem;
  margin-bottom: 38rem;
}

.first\\:mx-152:first-child{
  margin-left: 38rem;
  margin-right: 38rem;
}

.first\\:my-160:first-child{
  margin-top: 40rem;
  margin-bottom: 40rem;
}

.first\\:mx-160:first-child{
  margin-left: 40rem;
  margin-right: 40rem;
}

.first\\:my-162:first-child{
  margin-top: 41rem;
  margin-bottom: 41rem;
}

.first\\:mx-162:first-child{
  margin-left: 41rem;
  margin-right: 41rem;
}

.first\\:my-192:first-child{
  margin-top: 48rem;
  margin-bottom: 48rem;
}

.first\\:mx-192:first-child{
  margin-left: 48rem;
  margin-right: 48rem;
}

.first\\:my-208:first-child{
  margin-top: 52rem;
  margin-bottom: 52rem;
}

.first\\:mx-208:first-child{
  margin-left: 52rem;
  margin-right: 52rem;
}

.first\\:my-224:first-child{
  margin-top: 56rem;
  margin-bottom: 56rem;
}

.first\\:mx-224:first-child{
  margin-left: 56rem;
  margin-right: 56rem;
}

.first\\:my-256:first-child{
  margin-top: 64rem;
  margin-bottom: 64rem;
}

.first\\:mx-256:first-child{
  margin-left: 64rem;
  margin-right: 64rem;
}

.first\\:my-auto:first-child{
  margin-top: auto;
  margin-bottom: auto;
}

.first\\:mx-auto:first-child{
  margin-left: auto;
  margin-right: auto;
}

.first\\:my-px:first-child{
  margin-top: 1px;
  margin-bottom: 1px;
}

.first\\:mx-px:first-child{
  margin-left: 1px;
  margin-right: 1px;
}

.first\\:-my-1:first-child{
  margin-top: -0.25rem;
  margin-bottom: -0.25rem;
}

.first\\:-mx-1:first-child{
  margin-left: -0.25rem;
  margin-right: -0.25rem;
}

.first\\:-my-2:first-child{
  margin-top: -0.5rem;
  margin-bottom: -0.5rem;
}

.first\\:-mx-2:first-child{
  margin-left: -0.5rem;
  margin-right: -0.5rem;
}

.first\\:-my-3:first-child{
  margin-top: -0.75rem;
  margin-bottom: -0.75rem;
}

.first\\:-mx-3:first-child{
  margin-left: -0.75rem;
  margin-right: -0.75rem;
}

.first\\:-my-4:first-child{
  margin-top: -1rem;
  margin-bottom: -1rem;
}

.first\\:-mx-4:first-child{
  margin-left: -1rem;
  margin-right: -1rem;
}

.first\\:-my-5:first-child{
  margin-top: -1.25rem;
  margin-bottom: -1.25rem;
}

.first\\:-mx-5:first-child{
  margin-left: -1.25rem;
  margin-right: -1.25rem;
}

.first\\:-my-6:first-child{
  margin-top: -1.5rem;
  margin-bottom: -1.5rem;
}

.first\\:-mx-6:first-child{
  margin-left: -1.5rem;
  margin-right: -1.5rem;
}

.first\\:-my-7:first-child{
  margin-top: -1.75rem;
  margin-bottom: -1.75rem;
}

.first\\:-mx-7:first-child{
  margin-left: -1.75rem;
  margin-right: -1.75rem;
}

.first\\:-my-8:first-child{
  margin-top: -2rem;
  margin-bottom: -2rem;
}

.first\\:-mx-8:first-child{
  margin-left: -2rem;
  margin-right: -2rem;
}

.first\\:-my-9:first-child{
  margin-top: -2.25rem;
  margin-bottom: -2.25rem;
}

.first\\:-mx-9:first-child{
  margin-left: -2.25rem;
  margin-right: -2.25rem;
}

.first\\:-my-10:first-child{
  margin-top: -2.5rem;
  margin-bottom: -2.5rem;
}

.first\\:-mx-10:first-child{
  margin-left: -2.5rem;
  margin-right: -2.5rem;
}

.first\\:-my-11:first-child{
  margin-top: -2.75rem;
  margin-bottom: -2.75rem;
}

.first\\:-mx-11:first-child{
  margin-left: -2.75rem;
  margin-right: -2.75rem;
}

.first\\:-my-12:first-child{
  margin-top: -3rem;
  margin-bottom: -3rem;
}

.first\\:-mx-12:first-child{
  margin-left: -3rem;
  margin-right: -3rem;
}

.first\\:-my-14:first-child{
  margin-top: -3.5rem;
  margin-bottom: -3.5rem;
}

.first\\:-mx-14:first-child{
  margin-left: -3.5rem;
  margin-right: -3.5rem;
}

.first\\:-my-15:first-child{
  margin-top: -3.75rem;
  margin-bottom: -3.75rem;
}

.first\\:-mx-15:first-child{
  margin-left: -3.75rem;
  margin-right: -3.75rem;
}

.first\\:-my-16:first-child{
  margin-top: -4rem;
  margin-bottom: -4rem;
}

.first\\:-mx-16:first-child{
  margin-left: -4rem;
  margin-right: -4rem;
}

.first\\:-my-18:first-child{
  margin-top: -4.5rem;
  margin-bottom: -4.5rem;
}

.first\\:-mx-18:first-child{
  margin-left: -4.5rem;
  margin-right: -4.5rem;
}

.first\\:-my-20:first-child{
  margin-top: -5rem;
  margin-bottom: -5rem;
}

.first\\:-mx-20:first-child{
  margin-left: -5rem;
  margin-right: -5rem;
}

.first\\:-my-22:first-child{
  margin-top: -5.5rem;
  margin-bottom: -5.5rem;
}

.first\\:-mx-22:first-child{
  margin-left: -5.5rem;
  margin-right: -5.5rem;
}

.first\\:-my-23:first-child{
  margin-top: -5.75rem;
  margin-bottom: -5.75rem;
}

.first\\:-mx-23:first-child{
  margin-left: -5.75rem;
  margin-right: -5.75rem;
}

.first\\:-my-24:first-child{
  margin-top: -6rem;
  margin-bottom: -6rem;
}

.first\\:-mx-24:first-child{
  margin-left: -6rem;
  margin-right: -6rem;
}

.first\\:-my-25:first-child{
  margin-top: -6.25rem;
  margin-bottom: -6.25rem;
}

.first\\:-mx-25:first-child{
  margin-left: -6.25rem;
  margin-right: -6.25rem;
}

.first\\:-my-26:first-child{
  margin-top: -6.5rem;
  margin-bottom: -6.5rem;
}

.first\\:-mx-26:first-child{
  margin-left: -6.5rem;
  margin-right: -6.5rem;
}

.first\\:-my-28:first-child{
  margin-top: -7rem;
  margin-bottom: -7rem;
}

.first\\:-mx-28:first-child{
  margin-left: -7rem;
  margin-right: -7rem;
}

.first\\:-my-30:first-child{
  margin-top: -7.5rem;
  margin-bottom: -7.5rem;
}

.first\\:-mx-30:first-child{
  margin-left: -7.5rem;
  margin-right: -7.5rem;
}

.first\\:-my-32:first-child{
  margin-top: -8rem;
  margin-bottom: -8rem;
}

.first\\:-mx-32:first-child{
  margin-left: -8rem;
  margin-right: -8rem;
}

.first\\:-my-34:first-child{
  margin-top: -8.5rem;
  margin-bottom: -8.5rem;
}

.first\\:-mx-34:first-child{
  margin-left: -8.5rem;
  margin-right: -8.5rem;
}

.first\\:-my-40:first-child{
  margin-top: -10rem;
  margin-bottom: -10rem;
}

.first\\:-mx-40:first-child{
  margin-left: -10rem;
  margin-right: -10rem;
}

.first\\:-my-42:first-child{
  margin-top: -10.5rem;
  margin-bottom: -10.5rem;
}

.first\\:-mx-42:first-child{
  margin-left: -10.5rem;
  margin-right: -10.5rem;
}

.first\\:-my-44:first-child{
  margin-top: -11rem;
  margin-bottom: -11rem;
}

.first\\:-mx-44:first-child{
  margin-left: -11rem;
  margin-right: -11rem;
}

.first\\:-my-48:first-child{
  margin-top: -12rem;
  margin-bottom: -12rem;
}

.first\\:-mx-48:first-child{
  margin-left: -12rem;
  margin-right: -12rem;
}

.first\\:-my-52:first-child{
  margin-top: -13rem;
  margin-bottom: -13rem;
}

.first\\:-mx-52:first-child{
  margin-left: -13rem;
  margin-right: -13rem;
}

.first\\:-my-54:first-child{
  margin-top: -13.5rem;
  margin-bottom: -13.5rem;
}

.first\\:-mx-54:first-child{
  margin-left: -13.5rem;
  margin-right: -13.5rem;
}

.first\\:-my-56:first-child{
  margin-top: -14rem;
  margin-bottom: -14rem;
}

.first\\:-mx-56:first-child{
  margin-left: -14rem;
  margin-right: -14rem;
}

.first\\:-my-60:first-child{
  margin-top: -15rem;
  margin-bottom: -15rem;
}

.first\\:-mx-60:first-child{
  margin-left: -15rem;
  margin-right: -15rem;
}

.first\\:-my-64:first-child{
  margin-top: -16rem;
  margin-bottom: -16rem;
}

.first\\:-mx-64:first-child{
  margin-left: -16rem;
  margin-right: -16rem;
}

.first\\:-my-68:first-child{
  margin-top: -17rem;
  margin-bottom: -17rem;
}

.first\\:-mx-68:first-child{
  margin-left: -17rem;
  margin-right: -17rem;
}

.first\\:-my-72:first-child{
  margin-top: -18rem;
  margin-bottom: -18rem;
}

.first\\:-mx-72:first-child{
  margin-left: -18rem;
  margin-right: -18rem;
}

.first\\:-my-74:first-child{
  margin-top: -18.5rem;
  margin-bottom: -18.5rem;
}

.first\\:-mx-74:first-child{
  margin-left: -18.5rem;
  margin-right: -18.5rem;
}

.first\\:-my-76:first-child{
  margin-top: -19rem;
  margin-bottom: -19rem;
}

.first\\:-mx-76:first-child{
  margin-left: -19rem;
  margin-right: -19rem;
}

.first\\:-my-78:first-child{
  margin-top: -19.5rem;
  margin-bottom: -19.5rem;
}

.first\\:-mx-78:first-child{
  margin-left: -19.5rem;
  margin-right: -19.5rem;
}

.first\\:-my-80:first-child{
  margin-top: -20rem;
  margin-bottom: -20rem;
}

.first\\:-mx-80:first-child{
  margin-left: -20rem;
  margin-right: -20rem;
}

.first\\:-my-82:first-child{
  margin-top: -20.5rem;
  margin-bottom: -20.5rem;
}

.first\\:-mx-82:first-child{
  margin-left: -20.5rem;
  margin-right: -20.5rem;
}

.first\\:-my-84:first-child{
  margin-top: -21rem;
  margin-bottom: -21rem;
}

.first\\:-mx-84:first-child{
  margin-left: -21rem;
  margin-right: -21rem;
}

.first\\:-my-88:first-child{
  margin-top: -22rem;
  margin-bottom: -22rem;
}

.first\\:-mx-88:first-child{
  margin-left: -22rem;
  margin-right: -22rem;
}

.first\\:-my-92:first-child{
  margin-top: -23rem;
  margin-bottom: -23rem;
}

.first\\:-mx-92:first-child{
  margin-left: -23rem;
  margin-right: -23rem;
}

.first\\:-my-96:first-child{
  margin-top: -24rem;
  margin-bottom: -24rem;
}

.first\\:-mx-96:first-child{
  margin-left: -24rem;
  margin-right: -24rem;
}

.first\\:-my-98:first-child{
  margin-top: -24.5rem;
  margin-bottom: -24.5rem;
}

.first\\:-mx-98:first-child{
  margin-left: -24.5rem;
  margin-right: -24.5rem;
}

.first\\:-my-100:first-child{
  margin-top: -25rem;
  margin-bottom: -25rem;
}

.first\\:-mx-100:first-child{
  margin-left: -25rem;
  margin-right: -25rem;
}

.first\\:-my-104:first-child{
  margin-top: -26rem;
  margin-bottom: -26rem;
}

.first\\:-mx-104:first-child{
  margin-left: -26rem;
  margin-right: -26rem;
}

.first\\:-my-112:first-child{
  margin-top: -28rem;
  margin-bottom: -28rem;
}

.first\\:-mx-112:first-child{
  margin-left: -28rem;
  margin-right: -28rem;
}

.first\\:-my-124:first-child{
  margin-top: -31rem;
  margin-bottom: -31rem;
}

.first\\:-mx-124:first-child{
  margin-left: -31rem;
  margin-right: -31rem;
}

.first\\:-my-128:first-child{
  margin-top: -32rem;
  margin-bottom: -32rem;
}

.first\\:-mx-128:first-child{
  margin-left: -32rem;
  margin-right: -32rem;
}

.first\\:-my-140:first-child{
  margin-top: -35rem;
  margin-bottom: -35rem;
}

.first\\:-mx-140:first-child{
  margin-left: -35rem;
  margin-right: -35rem;
}

.first\\:-my-152:first-child{
  margin-top: -38rem;
  margin-bottom: -38rem;
}

.first\\:-mx-152:first-child{
  margin-left: -38rem;
  margin-right: -38rem;
}

.first\\:-my-160:first-child{
  margin-top: -40rem;
  margin-bottom: -40rem;
}

.first\\:-mx-160:first-child{
  margin-left: -40rem;
  margin-right: -40rem;
}

.first\\:-my-162:first-child{
  margin-top: -41rem;
  margin-bottom: -41rem;
}

.first\\:-mx-162:first-child{
  margin-left: -41rem;
  margin-right: -41rem;
}

.first\\:-my-192:first-child{
  margin-top: -48rem;
  margin-bottom: -48rem;
}

.first\\:-mx-192:first-child{
  margin-left: -48rem;
  margin-right: -48rem;
}

.first\\:-my-208:first-child{
  margin-top: -52rem;
  margin-bottom: -52rem;
}

.first\\:-mx-208:first-child{
  margin-left: -52rem;
  margin-right: -52rem;
}

.first\\:-my-224:first-child{
  margin-top: -56rem;
  margin-bottom: -56rem;
}

.first\\:-mx-224:first-child{
  margin-left: -56rem;
  margin-right: -56rem;
}

.first\\:-my-256:first-child{
  margin-top: -64rem;
  margin-bottom: -64rem;
}

.first\\:-mx-256:first-child{
  margin-left: -64rem;
  margin-right: -64rem;
}

.first\\:-my-px:first-child{
  margin-top: -1px;
  margin-bottom: -1px;
}

.first\\:-mx-px:first-child{
  margin-left: -1px;
  margin-right: -1px;
}

.first\\:mt-0:first-child{
  margin-top: 0;
}

.first\\:mr-0:first-child{
  margin-right: 0;
}

.first\\:mb-0:first-child{
  margin-bottom: 0;
}

.first\\:ml-0:first-child{
  margin-left: 0;
}

.first\\:mt-1:first-child{
  margin-top: 0.25rem;
}

.first\\:mr-1:first-child{
  margin-right: 0.25rem;
}

.first\\:mb-1:first-child{
  margin-bottom: 0.25rem;
}

.first\\:ml-1:first-child{
  margin-left: 0.25rem;
}

.first\\:mt-2:first-child{
  margin-top: 0.5rem;
}

.first\\:mr-2:first-child{
  margin-right: 0.5rem;
}

.first\\:mb-2:first-child{
  margin-bottom: 0.5rem;
}

.first\\:ml-2:first-child{
  margin-left: 0.5rem;
}

.first\\:mt-3:first-child{
  margin-top: 0.75rem;
}

.first\\:mr-3:first-child{
  margin-right: 0.75rem;
}

.first\\:mb-3:first-child{
  margin-bottom: 0.75rem;
}

.first\\:ml-3:first-child{
  margin-left: 0.75rem;
}

.first\\:mt-4:first-child{
  margin-top: 1rem;
}

.first\\:mr-4:first-child{
  margin-right: 1rem;
}

.first\\:mb-4:first-child{
  margin-bottom: 1rem;
}

.first\\:ml-4:first-child{
  margin-left: 1rem;
}

.first\\:mt-5:first-child{
  margin-top: 1.25rem;
}

.first\\:mr-5:first-child{
  margin-right: 1.25rem;
}

.first\\:mb-5:first-child{
  margin-bottom: 1.25rem;
}

.first\\:ml-5:first-child{
  margin-left: 1.25rem;
}

.first\\:mt-6:first-child{
  margin-top: 1.5rem;
}

.first\\:mr-6:first-child{
  margin-right: 1.5rem;
}

.first\\:mb-6:first-child{
  margin-bottom: 1.5rem;
}

.first\\:ml-6:first-child{
  margin-left: 1.5rem;
}

.first\\:mt-7:first-child{
  margin-top: 1.75rem;
}

.first\\:mr-7:first-child{
  margin-right: 1.75rem;
}

.first\\:mb-7:first-child{
  margin-bottom: 1.75rem;
}

.first\\:ml-7:first-child{
  margin-left: 1.75rem;
}

.first\\:mt-8:first-child{
  margin-top: 2rem;
}

.first\\:mr-8:first-child{
  margin-right: 2rem;
}

.first\\:mb-8:first-child{
  margin-bottom: 2rem;
}

.first\\:ml-8:first-child{
  margin-left: 2rem;
}

.first\\:mt-9:first-child{
  margin-top: 2.25rem;
}

.first\\:mr-9:first-child{
  margin-right: 2.25rem;
}

.first\\:mb-9:first-child{
  margin-bottom: 2.25rem;
}

.first\\:ml-9:first-child{
  margin-left: 2.25rem;
}

.first\\:mt-10:first-child{
  margin-top: 2.5rem;
}

.first\\:mr-10:first-child{
  margin-right: 2.5rem;
}

.first\\:mb-10:first-child{
  margin-bottom: 2.5rem;
}

.first\\:ml-10:first-child{
  margin-left: 2.5rem;
}

.first\\:mt-11:first-child{
  margin-top: 2.75rem;
}

.first\\:mr-11:first-child{
  margin-right: 2.75rem;
}

.first\\:mb-11:first-child{
  margin-bottom: 2.75rem;
}

.first\\:ml-11:first-child{
  margin-left: 2.75rem;
}

.first\\:mt-12:first-child{
  margin-top: 3rem;
}

.first\\:mr-12:first-child{
  margin-right: 3rem;
}

.first\\:mb-12:first-child{
  margin-bottom: 3rem;
}

.first\\:ml-12:first-child{
  margin-left: 3rem;
}

.first\\:mt-14:first-child{
  margin-top: 3.5rem;
}

.first\\:mr-14:first-child{
  margin-right: 3.5rem;
}

.first\\:mb-14:first-child{
  margin-bottom: 3.5rem;
}

.first\\:ml-14:first-child{
  margin-left: 3.5rem;
}

.first\\:mt-15:first-child{
  margin-top: 3.75rem;
}

.first\\:mr-15:first-child{
  margin-right: 3.75rem;
}

.first\\:mb-15:first-child{
  margin-bottom: 3.75rem;
}

.first\\:ml-15:first-child{
  margin-left: 3.75rem;
}

.first\\:mt-16:first-child{
  margin-top: 4rem;
}

.first\\:mr-16:first-child{
  margin-right: 4rem;
}

.first\\:mb-16:first-child{
  margin-bottom: 4rem;
}

.first\\:ml-16:first-child{
  margin-left: 4rem;
}

.first\\:mt-18:first-child{
  margin-top: 4.5rem;
}

.first\\:mr-18:first-child{
  margin-right: 4.5rem;
}

.first\\:mb-18:first-child{
  margin-bottom: 4.5rem;
}

.first\\:ml-18:first-child{
  margin-left: 4.5rem;
}

.first\\:mt-20:first-child{
  margin-top: 5rem;
}

.first\\:mr-20:first-child{
  margin-right: 5rem;
}

.first\\:mb-20:first-child{
  margin-bottom: 5rem;
}

.first\\:ml-20:first-child{
  margin-left: 5rem;
}

.first\\:mt-22:first-child{
  margin-top: 5.5rem;
}

.first\\:mr-22:first-child{
  margin-right: 5.5rem;
}

.first\\:mb-22:first-child{
  margin-bottom: 5.5rem;
}

.first\\:ml-22:first-child{
  margin-left: 5.5rem;
}

.first\\:mt-23:first-child{
  margin-top: 5.75rem;
}

.first\\:mr-23:first-child{
  margin-right: 5.75rem;
}

.first\\:mb-23:first-child{
  margin-bottom: 5.75rem;
}

.first\\:ml-23:first-child{
  margin-left: 5.75rem;
}

.first\\:mt-24:first-child{
  margin-top: 6rem;
}

.first\\:mr-24:first-child{
  margin-right: 6rem;
}

.first\\:mb-24:first-child{
  margin-bottom: 6rem;
}

.first\\:ml-24:first-child{
  margin-left: 6rem;
}

.first\\:mt-25:first-child{
  margin-top: 6.25rem;
}

.first\\:mr-25:first-child{
  margin-right: 6.25rem;
}

.first\\:mb-25:first-child{
  margin-bottom: 6.25rem;
}

.first\\:ml-25:first-child{
  margin-left: 6.25rem;
}

.first\\:mt-26:first-child{
  margin-top: 6.5rem;
}

.first\\:mr-26:first-child{
  margin-right: 6.5rem;
}

.first\\:mb-26:first-child{
  margin-bottom: 6.5rem;
}

.first\\:ml-26:first-child{
  margin-left: 6.5rem;
}

.first\\:mt-28:first-child{
  margin-top: 7rem;
}

.first\\:mr-28:first-child{
  margin-right: 7rem;
}

.first\\:mb-28:first-child{
  margin-bottom: 7rem;
}

.first\\:ml-28:first-child{
  margin-left: 7rem;
}

.first\\:mt-30:first-child{
  margin-top: 7.5rem;
}

.first\\:mr-30:first-child{
  margin-right: 7.5rem;
}

.first\\:mb-30:first-child{
  margin-bottom: 7.5rem;
}

.first\\:ml-30:first-child{
  margin-left: 7.5rem;
}

.first\\:mt-32:first-child{
  margin-top: 8rem;
}

.first\\:mr-32:first-child{
  margin-right: 8rem;
}

.first\\:mb-32:first-child{
  margin-bottom: 8rem;
}

.first\\:ml-32:first-child{
  margin-left: 8rem;
}

.first\\:mt-34:first-child{
  margin-top: 8.5rem;
}

.first\\:mr-34:first-child{
  margin-right: 8.5rem;
}

.first\\:mb-34:first-child{
  margin-bottom: 8.5rem;
}

.first\\:ml-34:first-child{
  margin-left: 8.5rem;
}

.first\\:mt-40:first-child{
  margin-top: 10rem;
}

.first\\:mr-40:first-child{
  margin-right: 10rem;
}

.first\\:mb-40:first-child{
  margin-bottom: 10rem;
}

.first\\:ml-40:first-child{
  margin-left: 10rem;
}

.first\\:mt-42:first-child{
  margin-top: 10.5rem;
}

.first\\:mr-42:first-child{
  margin-right: 10.5rem;
}

.first\\:mb-42:first-child{
  margin-bottom: 10.5rem;
}

.first\\:ml-42:first-child{
  margin-left: 10.5rem;
}

.first\\:mt-44:first-child{
  margin-top: 11rem;
}

.first\\:mr-44:first-child{
  margin-right: 11rem;
}

.first\\:mb-44:first-child{
  margin-bottom: 11rem;
}

.first\\:ml-44:first-child{
  margin-left: 11rem;
}

.first\\:mt-48:first-child{
  margin-top: 12rem;
}

.first\\:mr-48:first-child{
  margin-right: 12rem;
}

.first\\:mb-48:first-child{
  margin-bottom: 12rem;
}

.first\\:ml-48:first-child{
  margin-left: 12rem;
}

.first\\:mt-52:first-child{
  margin-top: 13rem;
}

.first\\:mr-52:first-child{
  margin-right: 13rem;
}

.first\\:mb-52:first-child{
  margin-bottom: 13rem;
}

.first\\:ml-52:first-child{
  margin-left: 13rem;
}

.first\\:mt-54:first-child{
  margin-top: 13.5rem;
}

.first\\:mr-54:first-child{
  margin-right: 13.5rem;
}

.first\\:mb-54:first-child{
  margin-bottom: 13.5rem;
}

.first\\:ml-54:first-child{
  margin-left: 13.5rem;
}

.first\\:mt-56:first-child{
  margin-top: 14rem;
}

.first\\:mr-56:first-child{
  margin-right: 14rem;
}

.first\\:mb-56:first-child{
  margin-bottom: 14rem;
}

.first\\:ml-56:first-child{
  margin-left: 14rem;
}

.first\\:mt-60:first-child{
  margin-top: 15rem;
}

.first\\:mr-60:first-child{
  margin-right: 15rem;
}

.first\\:mb-60:first-child{
  margin-bottom: 15rem;
}

.first\\:ml-60:first-child{
  margin-left: 15rem;
}

.first\\:mt-64:first-child{
  margin-top: 16rem;
}

.first\\:mr-64:first-child{
  margin-right: 16rem;
}

.first\\:mb-64:first-child{
  margin-bottom: 16rem;
}

.first\\:ml-64:first-child{
  margin-left: 16rem;
}

.first\\:mt-68:first-child{
  margin-top: 17rem;
}

.first\\:mr-68:first-child{
  margin-right: 17rem;
}

.first\\:mb-68:first-child{
  margin-bottom: 17rem;
}

.first\\:ml-68:first-child{
  margin-left: 17rem;
}

.first\\:mt-72:first-child{
  margin-top: 18rem;
}

.first\\:mr-72:first-child{
  margin-right: 18rem;
}

.first\\:mb-72:first-child{
  margin-bottom: 18rem;
}

.first\\:ml-72:first-child{
  margin-left: 18rem;
}

.first\\:mt-74:first-child{
  margin-top: 18.5rem;
}

.first\\:mr-74:first-child{
  margin-right: 18.5rem;
}

.first\\:mb-74:first-child{
  margin-bottom: 18.5rem;
}

.first\\:ml-74:first-child{
  margin-left: 18.5rem;
}

.first\\:mt-76:first-child{
  margin-top: 19rem;
}

.first\\:mr-76:first-child{
  margin-right: 19rem;
}

.first\\:mb-76:first-child{
  margin-bottom: 19rem;
}

.first\\:ml-76:first-child{
  margin-left: 19rem;
}

.first\\:mt-78:first-child{
  margin-top: 19.5rem;
}

.first\\:mr-78:first-child{
  margin-right: 19.5rem;
}

.first\\:mb-78:first-child{
  margin-bottom: 19.5rem;
}

.first\\:ml-78:first-child{
  margin-left: 19.5rem;
}

.first\\:mt-80:first-child{
  margin-top: 20rem;
}

.first\\:mr-80:first-child{
  margin-right: 20rem;
}

.first\\:mb-80:first-child{
  margin-bottom: 20rem;
}

.first\\:ml-80:first-child{
  margin-left: 20rem;
}

.first\\:mt-82:first-child{
  margin-top: 20.5rem;
}

.first\\:mr-82:first-child{
  margin-right: 20.5rem;
}

.first\\:mb-82:first-child{
  margin-bottom: 20.5rem;
}

.first\\:ml-82:first-child{
  margin-left: 20.5rem;
}

.first\\:mt-84:first-child{
  margin-top: 21rem;
}

.first\\:mr-84:first-child{
  margin-right: 21rem;
}

.first\\:mb-84:first-child{
  margin-bottom: 21rem;
}

.first\\:ml-84:first-child{
  margin-left: 21rem;
}

.first\\:mt-88:first-child{
  margin-top: 22rem;
}

.first\\:mr-88:first-child{
  margin-right: 22rem;
}

.first\\:mb-88:first-child{
  margin-bottom: 22rem;
}

.first\\:ml-88:first-child{
  margin-left: 22rem;
}

.first\\:mt-92:first-child{
  margin-top: 23rem;
}

.first\\:mr-92:first-child{
  margin-right: 23rem;
}

.first\\:mb-92:first-child{
  margin-bottom: 23rem;
}

.first\\:ml-92:first-child{
  margin-left: 23rem;
}

.first\\:mt-96:first-child{
  margin-top: 24rem;
}

.first\\:mr-96:first-child{
  margin-right: 24rem;
}

.first\\:mb-96:first-child{
  margin-bottom: 24rem;
}

.first\\:ml-96:first-child{
  margin-left: 24rem;
}

.first\\:mt-98:first-child{
  margin-top: 24.5rem;
}

.first\\:mr-98:first-child{
  margin-right: 24.5rem;
}

.first\\:mb-98:first-child{
  margin-bottom: 24.5rem;
}

.first\\:ml-98:first-child{
  margin-left: 24.5rem;
}

.first\\:mt-100:first-child{
  margin-top: 25rem;
}

.first\\:mr-100:first-child{
  margin-right: 25rem;
}

.first\\:mb-100:first-child{
  margin-bottom: 25rem;
}

.first\\:ml-100:first-child{
  margin-left: 25rem;
}

.first\\:mt-104:first-child{
  margin-top: 26rem;
}

.first\\:mr-104:first-child{
  margin-right: 26rem;
}

.first\\:mb-104:first-child{
  margin-bottom: 26rem;
}

.first\\:ml-104:first-child{
  margin-left: 26rem;
}

.first\\:mt-112:first-child{
  margin-top: 28rem;
}

.first\\:mr-112:first-child{
  margin-right: 28rem;
}

.first\\:mb-112:first-child{
  margin-bottom: 28rem;
}

.first\\:ml-112:first-child{
  margin-left: 28rem;
}

.first\\:mt-124:first-child{
  margin-top: 31rem;
}

.first\\:mr-124:first-child{
  margin-right: 31rem;
}

.first\\:mb-124:first-child{
  margin-bottom: 31rem;
}

.first\\:ml-124:first-child{
  margin-left: 31rem;
}

.first\\:mt-128:first-child{
  margin-top: 32rem;
}

.first\\:mr-128:first-child{
  margin-right: 32rem;
}

.first\\:mb-128:first-child{
  margin-bottom: 32rem;
}

.first\\:ml-128:first-child{
  margin-left: 32rem;
}

.first\\:mt-140:first-child{
  margin-top: 35rem;
}

.first\\:mr-140:first-child{
  margin-right: 35rem;
}

.first\\:mb-140:first-child{
  margin-bottom: 35rem;
}

.first\\:ml-140:first-child{
  margin-left: 35rem;
}

.first\\:mt-152:first-child{
  margin-top: 38rem;
}

.first\\:mr-152:first-child{
  margin-right: 38rem;
}

.first\\:mb-152:first-child{
  margin-bottom: 38rem;
}

.first\\:ml-152:first-child{
  margin-left: 38rem;
}

.first\\:mt-160:first-child{
  margin-top: 40rem;
}

.first\\:mr-160:first-child{
  margin-right: 40rem;
}

.first\\:mb-160:first-child{
  margin-bottom: 40rem;
}

.first\\:ml-160:first-child{
  margin-left: 40rem;
}

.first\\:mt-162:first-child{
  margin-top: 41rem;
}

.first\\:mr-162:first-child{
  margin-right: 41rem;
}

.first\\:mb-162:first-child{
  margin-bottom: 41rem;
}

.first\\:ml-162:first-child{
  margin-left: 41rem;
}

.first\\:mt-192:first-child{
  margin-top: 48rem;
}

.first\\:mr-192:first-child{
  margin-right: 48rem;
}

.first\\:mb-192:first-child{
  margin-bottom: 48rem;
}

.first\\:ml-192:first-child{
  margin-left: 48rem;
}

.first\\:mt-208:first-child{
  margin-top: 52rem;
}

.first\\:mr-208:first-child{
  margin-right: 52rem;
}

.first\\:mb-208:first-child{
  margin-bottom: 52rem;
}

.first\\:ml-208:first-child{
  margin-left: 52rem;
}

.first\\:mt-224:first-child{
  margin-top: 56rem;
}

.first\\:mr-224:first-child{
  margin-right: 56rem;
}

.first\\:mb-224:first-child{
  margin-bottom: 56rem;
}

.first\\:ml-224:first-child{
  margin-left: 56rem;
}

.first\\:mt-256:first-child{
  margin-top: 64rem;
}

.first\\:mr-256:first-child{
  margin-right: 64rem;
}

.first\\:mb-256:first-child{
  margin-bottom: 64rem;
}

.first\\:ml-256:first-child{
  margin-left: 64rem;
}

.first\\:mt-auto:first-child{
  margin-top: auto;
}

.first\\:mr-auto:first-child{
  margin-right: auto;
}

.first\\:mb-auto:first-child{
  margin-bottom: auto;
}

.first\\:ml-auto:first-child{
  margin-left: auto;
}

.first\\:mt-px:first-child{
  margin-top: 1px;
}

.first\\:mr-px:first-child{
  margin-right: 1px;
}

.first\\:mb-px:first-child{
  margin-bottom: 1px;
}

.first\\:ml-px:first-child{
  margin-left: 1px;
}

.first\\:-mt-1:first-child{
  margin-top: -0.25rem;
}

.first\\:-mr-1:first-child{
  margin-right: -0.25rem;
}

.first\\:-mb-1:first-child{
  margin-bottom: -0.25rem;
}

.first\\:-ml-1:first-child{
  margin-left: -0.25rem;
}

.first\\:-mt-2:first-child{
  margin-top: -0.5rem;
}

.first\\:-mr-2:first-child{
  margin-right: -0.5rem;
}

.first\\:-mb-2:first-child{
  margin-bottom: -0.5rem;
}

.first\\:-ml-2:first-child{
  margin-left: -0.5rem;
}

.first\\:-mt-3:first-child{
  margin-top: -0.75rem;
}

.first\\:-mr-3:first-child{
  margin-right: -0.75rem;
}

.first\\:-mb-3:first-child{
  margin-bottom: -0.75rem;
}

.first\\:-ml-3:first-child{
  margin-left: -0.75rem;
}

.first\\:-mt-4:first-child{
  margin-top: -1rem;
}

.first\\:-mr-4:first-child{
  margin-right: -1rem;
}

.first\\:-mb-4:first-child{
  margin-bottom: -1rem;
}

.first\\:-ml-4:first-child{
  margin-left: -1rem;
}

.first\\:-mt-5:first-child{
  margin-top: -1.25rem;
}

.first\\:-mr-5:first-child{
  margin-right: -1.25rem;
}

.first\\:-mb-5:first-child{
  margin-bottom: -1.25rem;
}

.first\\:-ml-5:first-child{
  margin-left: -1.25rem;
}

.first\\:-mt-6:first-child{
  margin-top: -1.5rem;
}

.first\\:-mr-6:first-child{
  margin-right: -1.5rem;
}

.first\\:-mb-6:first-child{
  margin-bottom: -1.5rem;
}

.first\\:-ml-6:first-child{
  margin-left: -1.5rem;
}

.first\\:-mt-7:first-child{
  margin-top: -1.75rem;
}

.first\\:-mr-7:first-child{
  margin-right: -1.75rem;
}

.first\\:-mb-7:first-child{
  margin-bottom: -1.75rem;
}

.first\\:-ml-7:first-child{
  margin-left: -1.75rem;
}

.first\\:-mt-8:first-child{
  margin-top: -2rem;
}

.first\\:-mr-8:first-child{
  margin-right: -2rem;
}

.first\\:-mb-8:first-child{
  margin-bottom: -2rem;
}

.first\\:-ml-8:first-child{
  margin-left: -2rem;
}

.first\\:-mt-9:first-child{
  margin-top: -2.25rem;
}

.first\\:-mr-9:first-child{
  margin-right: -2.25rem;
}

.first\\:-mb-9:first-child{
  margin-bottom: -2.25rem;
}

.first\\:-ml-9:first-child{
  margin-left: -2.25rem;
}

.first\\:-mt-10:first-child{
  margin-top: -2.5rem;
}

.first\\:-mr-10:first-child{
  margin-right: -2.5rem;
}

.first\\:-mb-10:first-child{
  margin-bottom: -2.5rem;
}

.first\\:-ml-10:first-child{
  margin-left: -2.5rem;
}

.first\\:-mt-11:first-child{
  margin-top: -2.75rem;
}

.first\\:-mr-11:first-child{
  margin-right: -2.75rem;
}

.first\\:-mb-11:first-child{
  margin-bottom: -2.75rem;
}

.first\\:-ml-11:first-child{
  margin-left: -2.75rem;
}

.first\\:-mt-12:first-child{
  margin-top: -3rem;
}

.first\\:-mr-12:first-child{
  margin-right: -3rem;
}

.first\\:-mb-12:first-child{
  margin-bottom: -3rem;
}

.first\\:-ml-12:first-child{
  margin-left: -3rem;
}

.first\\:-mt-14:first-child{
  margin-top: -3.5rem;
}

.first\\:-mr-14:first-child{
  margin-right: -3.5rem;
}

.first\\:-mb-14:first-child{
  margin-bottom: -3.5rem;
}

.first\\:-ml-14:first-child{
  margin-left: -3.5rem;
}

.first\\:-mt-15:first-child{
  margin-top: -3.75rem;
}

.first\\:-mr-15:first-child{
  margin-right: -3.75rem;
}

.first\\:-mb-15:first-child{
  margin-bottom: -3.75rem;
}

.first\\:-ml-15:first-child{
  margin-left: -3.75rem;
}

.first\\:-mt-16:first-child{
  margin-top: -4rem;
}

.first\\:-mr-16:first-child{
  margin-right: -4rem;
}

.first\\:-mb-16:first-child{
  margin-bottom: -4rem;
}

.first\\:-ml-16:first-child{
  margin-left: -4rem;
}

.first\\:-mt-18:first-child{
  margin-top: -4.5rem;
}

.first\\:-mr-18:first-child{
  margin-right: -4.5rem;
}

.first\\:-mb-18:first-child{
  margin-bottom: -4.5rem;
}

.first\\:-ml-18:first-child{
  margin-left: -4.5rem;
}

.first\\:-mt-20:first-child{
  margin-top: -5rem;
}

.first\\:-mr-20:first-child{
  margin-right: -5rem;
}

.first\\:-mb-20:first-child{
  margin-bottom: -5rem;
}

.first\\:-ml-20:first-child{
  margin-left: -5rem;
}

.first\\:-mt-22:first-child{
  margin-top: -5.5rem;
}

.first\\:-mr-22:first-child{
  margin-right: -5.5rem;
}

.first\\:-mb-22:first-child{
  margin-bottom: -5.5rem;
}

.first\\:-ml-22:first-child{
  margin-left: -5.5rem;
}

.first\\:-mt-23:first-child{
  margin-top: -5.75rem;
}

.first\\:-mr-23:first-child{
  margin-right: -5.75rem;
}

.first\\:-mb-23:first-child{
  margin-bottom: -5.75rem;
}

.first\\:-ml-23:first-child{
  margin-left: -5.75rem;
}

.first\\:-mt-24:first-child{
  margin-top: -6rem;
}

.first\\:-mr-24:first-child{
  margin-right: -6rem;
}

.first\\:-mb-24:first-child{
  margin-bottom: -6rem;
}

.first\\:-ml-24:first-child{
  margin-left: -6rem;
}

.first\\:-mt-25:first-child{
  margin-top: -6.25rem;
}

.first\\:-mr-25:first-child{
  margin-right: -6.25rem;
}

.first\\:-mb-25:first-child{
  margin-bottom: -6.25rem;
}

.first\\:-ml-25:first-child{
  margin-left: -6.25rem;
}

.first\\:-mt-26:first-child{
  margin-top: -6.5rem;
}

.first\\:-mr-26:first-child{
  margin-right: -6.5rem;
}

.first\\:-mb-26:first-child{
  margin-bottom: -6.5rem;
}

.first\\:-ml-26:first-child{
  margin-left: -6.5rem;
}

.first\\:-mt-28:first-child{
  margin-top: -7rem;
}

.first\\:-mr-28:first-child{
  margin-right: -7rem;
}

.first\\:-mb-28:first-child{
  margin-bottom: -7rem;
}

.first\\:-ml-28:first-child{
  margin-left: -7rem;
}

.first\\:-mt-30:first-child{
  margin-top: -7.5rem;
}

.first\\:-mr-30:first-child{
  margin-right: -7.5rem;
}

.first\\:-mb-30:first-child{
  margin-bottom: -7.5rem;
}

.first\\:-ml-30:first-child{
  margin-left: -7.5rem;
}

.first\\:-mt-32:first-child{
  margin-top: -8rem;
}

.first\\:-mr-32:first-child{
  margin-right: -8rem;
}

.first\\:-mb-32:first-child{
  margin-bottom: -8rem;
}

.first\\:-ml-32:first-child{
  margin-left: -8rem;
}

.first\\:-mt-34:first-child{
  margin-top: -8.5rem;
}

.first\\:-mr-34:first-child{
  margin-right: -8.5rem;
}

.first\\:-mb-34:first-child{
  margin-bottom: -8.5rem;
}

.first\\:-ml-34:first-child{
  margin-left: -8.5rem;
}

.first\\:-mt-40:first-child{
  margin-top: -10rem;
}

.first\\:-mr-40:first-child{
  margin-right: -10rem;
}

.first\\:-mb-40:first-child{
  margin-bottom: -10rem;
}

.first\\:-ml-40:first-child{
  margin-left: -10rem;
}

.first\\:-mt-42:first-child{
  margin-top: -10.5rem;
}

.first\\:-mr-42:first-child{
  margin-right: -10.5rem;
}

.first\\:-mb-42:first-child{
  margin-bottom: -10.5rem;
}

.first\\:-ml-42:first-child{
  margin-left: -10.5rem;
}

.first\\:-mt-44:first-child{
  margin-top: -11rem;
}

.first\\:-mr-44:first-child{
  margin-right: -11rem;
}

.first\\:-mb-44:first-child{
  margin-bottom: -11rem;
}

.first\\:-ml-44:first-child{
  margin-left: -11rem;
}

.first\\:-mt-48:first-child{
  margin-top: -12rem;
}

.first\\:-mr-48:first-child{
  margin-right: -12rem;
}

.first\\:-mb-48:first-child{
  margin-bottom: -12rem;
}

.first\\:-ml-48:first-child{
  margin-left: -12rem;
}

.first\\:-mt-52:first-child{
  margin-top: -13rem;
}

.first\\:-mr-52:first-child{
  margin-right: -13rem;
}

.first\\:-mb-52:first-child{
  margin-bottom: -13rem;
}

.first\\:-ml-52:first-child{
  margin-left: -13rem;
}

.first\\:-mt-54:first-child{
  margin-top: -13.5rem;
}

.first\\:-mr-54:first-child{
  margin-right: -13.5rem;
}

.first\\:-mb-54:first-child{
  margin-bottom: -13.5rem;
}

.first\\:-ml-54:first-child{
  margin-left: -13.5rem;
}

.first\\:-mt-56:first-child{
  margin-top: -14rem;
}

.first\\:-mr-56:first-child{
  margin-right: -14rem;
}

.first\\:-mb-56:first-child{
  margin-bottom: -14rem;
}

.first\\:-ml-56:first-child{
  margin-left: -14rem;
}

.first\\:-mt-60:first-child{
  margin-top: -15rem;
}

.first\\:-mr-60:first-child{
  margin-right: -15rem;
}

.first\\:-mb-60:first-child{
  margin-bottom: -15rem;
}

.first\\:-ml-60:first-child{
  margin-left: -15rem;
}

.first\\:-mt-64:first-child{
  margin-top: -16rem;
}

.first\\:-mr-64:first-child{
  margin-right: -16rem;
}

.first\\:-mb-64:first-child{
  margin-bottom: -16rem;
}

.first\\:-ml-64:first-child{
  margin-left: -16rem;
}

.first\\:-mt-68:first-child{
  margin-top: -17rem;
}

.first\\:-mr-68:first-child{
  margin-right: -17rem;
}

.first\\:-mb-68:first-child{
  margin-bottom: -17rem;
}

.first\\:-ml-68:first-child{
  margin-left: -17rem;
}

.first\\:-mt-72:first-child{
  margin-top: -18rem;
}

.first\\:-mr-72:first-child{
  margin-right: -18rem;
}

.first\\:-mb-72:first-child{
  margin-bottom: -18rem;
}

.first\\:-ml-72:first-child{
  margin-left: -18rem;
}

.first\\:-mt-74:first-child{
  margin-top: -18.5rem;
}

.first\\:-mr-74:first-child{
  margin-right: -18.5rem;
}

.first\\:-mb-74:first-child{
  margin-bottom: -18.5rem;
}

.first\\:-ml-74:first-child{
  margin-left: -18.5rem;
}

.first\\:-mt-76:first-child{
  margin-top: -19rem;
}

.first\\:-mr-76:first-child{
  margin-right: -19rem;
}

.first\\:-mb-76:first-child{
  margin-bottom: -19rem;
}

.first\\:-ml-76:first-child{
  margin-left: -19rem;
}

.first\\:-mt-78:first-child{
  margin-top: -19.5rem;
}

.first\\:-mr-78:first-child{
  margin-right: -19.5rem;
}

.first\\:-mb-78:first-child{
  margin-bottom: -19.5rem;
}

.first\\:-ml-78:first-child{
  margin-left: -19.5rem;
}

.first\\:-mt-80:first-child{
  margin-top: -20rem;
}

.first\\:-mr-80:first-child{
  margin-right: -20rem;
}

.first\\:-mb-80:first-child{
  margin-bottom: -20rem;
}

.first\\:-ml-80:first-child{
  margin-left: -20rem;
}

.first\\:-mt-82:first-child{
  margin-top: -20.5rem;
}

.first\\:-mr-82:first-child{
  margin-right: -20.5rem;
}

.first\\:-mb-82:first-child{
  margin-bottom: -20.5rem;
}

.first\\:-ml-82:first-child{
  margin-left: -20.5rem;
}

.first\\:-mt-84:first-child{
  margin-top: -21rem;
}

.first\\:-mr-84:first-child{
  margin-right: -21rem;
}

.first\\:-mb-84:first-child{
  margin-bottom: -21rem;
}

.first\\:-ml-84:first-child{
  margin-left: -21rem;
}

.first\\:-mt-88:first-child{
  margin-top: -22rem;
}

.first\\:-mr-88:first-child{
  margin-right: -22rem;
}

.first\\:-mb-88:first-child{
  margin-bottom: -22rem;
}

.first\\:-ml-88:first-child{
  margin-left: -22rem;
}

.first\\:-mt-92:first-child{
  margin-top: -23rem;
}

.first\\:-mr-92:first-child{
  margin-right: -23rem;
}

.first\\:-mb-92:first-child{
  margin-bottom: -23rem;
}

.first\\:-ml-92:first-child{
  margin-left: -23rem;
}

.first\\:-mt-96:first-child{
  margin-top: -24rem;
}

.first\\:-mr-96:first-child{
  margin-right: -24rem;
}

.first\\:-mb-96:first-child{
  margin-bottom: -24rem;
}

.first\\:-ml-96:first-child{
  margin-left: -24rem;
}

.first\\:-mt-98:first-child{
  margin-top: -24.5rem;
}

.first\\:-mr-98:first-child{
  margin-right: -24.5rem;
}

.first\\:-mb-98:first-child{
  margin-bottom: -24.5rem;
}

.first\\:-ml-98:first-child{
  margin-left: -24.5rem;
}

.first\\:-mt-100:first-child{
  margin-top: -25rem;
}

.first\\:-mr-100:first-child{
  margin-right: -25rem;
}

.first\\:-mb-100:first-child{
  margin-bottom: -25rem;
}

.first\\:-ml-100:first-child{
  margin-left: -25rem;
}

.first\\:-mt-104:first-child{
  margin-top: -26rem;
}

.first\\:-mr-104:first-child{
  margin-right: -26rem;
}

.first\\:-mb-104:first-child{
  margin-bottom: -26rem;
}

.first\\:-ml-104:first-child{
  margin-left: -26rem;
}

.first\\:-mt-112:first-child{
  margin-top: -28rem;
}

.first\\:-mr-112:first-child{
  margin-right: -28rem;
}

.first\\:-mb-112:first-child{
  margin-bottom: -28rem;
}

.first\\:-ml-112:first-child{
  margin-left: -28rem;
}

.first\\:-mt-124:first-child{
  margin-top: -31rem;
}

.first\\:-mr-124:first-child{
  margin-right: -31rem;
}

.first\\:-mb-124:first-child{
  margin-bottom: -31rem;
}

.first\\:-ml-124:first-child{
  margin-left: -31rem;
}

.first\\:-mt-128:first-child{
  margin-top: -32rem;
}

.first\\:-mr-128:first-child{
  margin-right: -32rem;
}

.first\\:-mb-128:first-child{
  margin-bottom: -32rem;
}

.first\\:-ml-128:first-child{
  margin-left: -32rem;
}

.first\\:-mt-140:first-child{
  margin-top: -35rem;
}

.first\\:-mr-140:first-child{
  margin-right: -35rem;
}

.first\\:-mb-140:first-child{
  margin-bottom: -35rem;
}

.first\\:-ml-140:first-child{
  margin-left: -35rem;
}

.first\\:-mt-152:first-child{
  margin-top: -38rem;
}

.first\\:-mr-152:first-child{
  margin-right: -38rem;
}

.first\\:-mb-152:first-child{
  margin-bottom: -38rem;
}

.first\\:-ml-152:first-child{
  margin-left: -38rem;
}

.first\\:-mt-160:first-child{
  margin-top: -40rem;
}

.first\\:-mr-160:first-child{
  margin-right: -40rem;
}

.first\\:-mb-160:first-child{
  margin-bottom: -40rem;
}

.first\\:-ml-160:first-child{
  margin-left: -40rem;
}

.first\\:-mt-162:first-child{
  margin-top: -41rem;
}

.first\\:-mr-162:first-child{
  margin-right: -41rem;
}

.first\\:-mb-162:first-child{
  margin-bottom: -41rem;
}

.first\\:-ml-162:first-child{
  margin-left: -41rem;
}

.first\\:-mt-192:first-child{
  margin-top: -48rem;
}

.first\\:-mr-192:first-child{
  margin-right: -48rem;
}

.first\\:-mb-192:first-child{
  margin-bottom: -48rem;
}

.first\\:-ml-192:first-child{
  margin-left: -48rem;
}

.first\\:-mt-208:first-child{
  margin-top: -52rem;
}

.first\\:-mr-208:first-child{
  margin-right: -52rem;
}

.first\\:-mb-208:first-child{
  margin-bottom: -52rem;
}

.first\\:-ml-208:first-child{
  margin-left: -52rem;
}

.first\\:-mt-224:first-child{
  margin-top: -56rem;
}

.first\\:-mr-224:first-child{
  margin-right: -56rem;
}

.first\\:-mb-224:first-child{
  margin-bottom: -56rem;
}

.first\\:-ml-224:first-child{
  margin-left: -56rem;
}

.first\\:-mt-256:first-child{
  margin-top: -64rem;
}

.first\\:-mr-256:first-child{
  margin-right: -64rem;
}

.first\\:-mb-256:first-child{
  margin-bottom: -64rem;
}

.first\\:-ml-256:first-child{
  margin-left: -64rem;
}

.first\\:-mt-px:first-child{
  margin-top: -1px;
}

.first\\:-mr-px:first-child{
  margin-right: -1px;
}

.first\\:-mb-px:first-child{
  margin-bottom: -1px;
}

.first\\:-ml-px:first-child{
  margin-left: -1px;
}

.max-h-0{
  max-height: 0;
}

.max-h-1{
  max-height: 0.25rem;
}

.max-h-2{
  max-height: 0.5rem;
}

.max-h-3{
  max-height: 0.75rem;
}

.max-h-4{
  max-height: 1rem;
}

.max-h-5{
  max-height: 1.25rem;
}

.max-h-6{
  max-height: 1.5rem;
}

.max-h-7{
  max-height: 1.75rem;
}

.max-h-8{
  max-height: 2rem;
}

.max-h-9{
  max-height: 2.25rem;
}

.max-h-10{
  max-height: 2.5rem;
}

.max-h-11{
  max-height: 2.75rem;
}

.max-h-12{
  max-height: 3rem;
}

.max-h-14{
  max-height: 3.5rem;
}

.max-h-15{
  max-height: 3.75rem;
}

.max-h-16{
  max-height: 4rem;
}

.max-h-18{
  max-height: 4.5rem;
}

.max-h-20{
  max-height: 5rem;
}

.max-h-22{
  max-height: 5.5rem;
}

.max-h-23{
  max-height: 5.75rem;
}

.max-h-24{
  max-height: 6rem;
}

.max-h-25{
  max-height: 6.25rem;
}

.max-h-26{
  max-height: 6.5rem;
}

.max-h-28{
  max-height: 7rem;
}

.max-h-30{
  max-height: 7.5rem;
}

.max-h-32{
  max-height: 8rem;
}

.max-h-34{
  max-height: 8.5rem;
}

.max-h-40{
  max-height: 10rem;
}

.max-h-42{
  max-height: 10.5rem;
}

.max-h-44{
  max-height: 11rem;
}

.max-h-48{
  max-height: 12rem;
}

.max-h-52{
  max-height: 13rem;
}

.max-h-54{
  max-height: 13.5rem;
}

.max-h-56{
  max-height: 14rem;
}

.max-h-60{
  max-height: 15rem;
}

.max-h-64{
  max-height: 16rem;
}

.max-h-68{
  max-height: 17rem;
}

.max-h-72{
  max-height: 18rem;
}

.max-h-74{
  max-height: 18.5rem;
}

.max-h-76{
  max-height: 19rem;
}

.max-h-78{
  max-height: 19.5rem;
}

.max-h-80{
  max-height: 20rem;
}

.max-h-82{
  max-height: 20.5rem;
}

.max-h-84{
  max-height: 21rem;
}

.max-h-88{
  max-height: 22rem;
}

.max-h-92{
  max-height: 23rem;
}

.max-h-96{
  max-height: 24rem;
}

.max-h-98{
  max-height: 24.5rem;
}

.max-h-100{
  max-height: 25rem;
}

.max-h-104{
  max-height: 26rem;
}

.max-h-112{
  max-height: 28rem;
}

.max-h-124{
  max-height: 31rem;
}

.max-h-128{
  max-height: 32rem;
}

.max-h-140{
  max-height: 35rem;
}

.max-h-152{
  max-height: 38rem;
}

.max-h-160{
  max-height: 40rem;
}

.max-h-162{
  max-height: 41rem;
}

.max-h-192{
  max-height: 48rem;
}

.max-h-208{
  max-height: 52rem;
}

.max-h-224{
  max-height: 56rem;
}

.max-h-256{
  max-height: 64rem;
}

.max-h-px{
  max-height: 1px;
}

.max-h-full{
  max-height: 100%;
}

.max-h-screen{
  max-height: 100vh;
}

.max-w-0{
  max-width: 0;
}

.max-w-1{
  max-width: 0.25rem;
}

.max-w-2{
  max-width: 0.5rem;
}

.max-w-3{
  max-width: 0.75rem;
}

.max-w-4{
  max-width: 1rem;
}

.max-w-5{
  max-width: 1.25rem;
}

.max-w-6{
  max-width: 1.5rem;
}

.max-w-7{
  max-width: 1.75rem;
}

.max-w-8{
  max-width: 2rem;
}

.max-w-9{
  max-width: 2.25rem;
}

.max-w-10{
  max-width: 2.5rem;
}

.max-w-11{
  max-width: 2.75rem;
}

.max-w-12{
  max-width: 3rem;
}

.max-w-14{
  max-width: 3.5rem;
}

.max-w-15{
  max-width: 3.75rem;
}

.max-w-16{
  max-width: 4rem;
}

.max-w-18{
  max-width: 4.5rem;
}

.max-w-20{
  max-width: 5rem;
}

.max-w-22{
  max-width: 5.5rem;
}

.max-w-23{
  max-width: 5.75rem;
}

.max-w-24{
  max-width: 6rem;
}

.max-w-25{
  max-width: 6.25rem;
}

.max-w-26{
  max-width: 6.5rem;
}

.max-w-28{
  max-width: 7rem;
}

.max-w-30{
  max-width: 7.5rem;
}

.max-w-32{
  max-width: 8rem;
}

.max-w-34{
  max-width: 8.5rem;
}

.max-w-40{
  max-width: 10rem;
}

.max-w-42{
  max-width: 10.5rem;
}

.max-w-44{
  max-width: 11rem;
}

.max-w-48{
  max-width: 12rem;
}

.max-w-52{
  max-width: 13rem;
}

.max-w-54{
  max-width: 13.5rem;
}

.max-w-56{
  max-width: 14rem;
}

.max-w-60{
  max-width: 15rem;
}

.max-w-64{
  max-width: 16rem;
}

.max-w-68{
  max-width: 17rem;
}

.max-w-72{
  max-width: 18rem;
}

.max-w-74{
  max-width: 18.5rem;
}

.max-w-76{
  max-width: 19rem;
}

.max-w-78{
  max-width: 19.5rem;
}

.max-w-80{
  max-width: 20rem;
}

.max-w-82{
  max-width: 20.5rem;
}

.max-w-84{
  max-width: 21rem;
}

.max-w-88{
  max-width: 22rem;
}

.max-w-92{
  max-width: 23rem;
}

.max-w-96{
  max-width: 24rem;
}

.max-w-98{
  max-width: 24.5rem;
}

.max-w-100{
  max-width: 25rem;
}

.max-w-104{
  max-width: 26rem;
}

.max-w-112{
  max-width: 28rem;
}

.max-w-124{
  max-width: 31rem;
}

.max-w-128{
  max-width: 32rem;
}

.max-w-140{
  max-width: 35rem;
}

.max-w-152{
  max-width: 38rem;
}

.max-w-160{
  max-width: 40rem;
}

.max-w-162{
  max-width: 41rem;
}

.max-w-192{
  max-width: 48rem;
}

.max-w-208{
  max-width: 52rem;
}

.max-w-224{
  max-width: 56rem;
}

.max-w-256{
  max-width: 64rem;
}

.max-w-none{
  max-width: none;
}

.max-w-xs{
  max-width: 20rem;
}

.max-w-sm{
  max-width: 24rem;
}

.max-w-md{
  max-width: 28rem;
}

.max-w-lg{
  max-width: 32rem;
}

.max-w-xl{
  max-width: 36rem;
}

.max-w-2xl{
  max-width: 42rem;
}

.max-w-3xl{
  max-width: 48rem;
}

.max-w-4xl{
  max-width: 56rem;
}

.max-w-5xl{
  max-width: 64rem;
}

.max-w-6xl{
  max-width: 76rem;
}

.max-w-7xl{
  max-width: 92rem;
}

.max-w-8xl{
  max-width: 112rem;
}

.max-w-9xl{
  max-width: 130rem;
}

.max-w-full{
  max-width: 100%;
}

.max-w-px{
  max-width: 1px;
}

.min-h-0{
  min-height: 0;
}

.min-h-1{
  min-height: 0.25rem;
}

.min-h-2{
  min-height: 0.5rem;
}

.min-h-3{
  min-height: 0.75rem;
}

.min-h-4{
  min-height: 1rem;
}

.min-h-5{
  min-height: 1.25rem;
}

.min-h-6{
  min-height: 1.5rem;
}

.min-h-7{
  min-height: 1.75rem;
}

.min-h-8{
  min-height: 2rem;
}

.min-h-9{
  min-height: 2.25rem;
}

.min-h-10{
  min-height: 2.5rem;
}

.min-h-11{
  min-height: 2.75rem;
}

.min-h-12{
  min-height: 3rem;
}

.min-h-14{
  min-height: 3.5rem;
}

.min-h-15{
  min-height: 3.75rem;
}

.min-h-16{
  min-height: 4rem;
}

.min-h-18{
  min-height: 4.5rem;
}

.min-h-20{
  min-height: 5rem;
}

.min-h-22{
  min-height: 5.5rem;
}

.min-h-23{
  min-height: 5.75rem;
}

.min-h-24{
  min-height: 6rem;
}

.min-h-25{
  min-height: 6.25rem;
}

.min-h-26{
  min-height: 6.5rem;
}

.min-h-28{
  min-height: 7rem;
}

.min-h-30{
  min-height: 7.5rem;
}

.min-h-32{
  min-height: 8rem;
}

.min-h-34{
  min-height: 8.5rem;
}

.min-h-40{
  min-height: 10rem;
}

.min-h-42{
  min-height: 10.5rem;
}

.min-h-44{
  min-height: 11rem;
}

.min-h-48{
  min-height: 12rem;
}

.min-h-52{
  min-height: 13rem;
}

.min-h-54{
  min-height: 13.5rem;
}

.min-h-56{
  min-height: 14rem;
}

.min-h-60{
  min-height: 15rem;
}

.min-h-64{
  min-height: 16rem;
}

.min-h-68{
  min-height: 17rem;
}

.min-h-72{
  min-height: 18rem;
}

.min-h-74{
  min-height: 18.5rem;
}

.min-h-76{
  min-height: 19rem;
}

.min-h-78{
  min-height: 19.5rem;
}

.min-h-80{
  min-height: 20rem;
}

.min-h-82{
  min-height: 20.5rem;
}

.min-h-84{
  min-height: 21rem;
}

.min-h-88{
  min-height: 22rem;
}

.min-h-92{
  min-height: 23rem;
}

.min-h-96{
  min-height: 24rem;
}

.min-h-98{
  min-height: 24.5rem;
}

.min-h-100{
  min-height: 25rem;
}

.min-h-104{
  min-height: 26rem;
}

.min-h-112{
  min-height: 28rem;
}

.min-h-124{
  min-height: 31rem;
}

.min-h-128{
  min-height: 32rem;
}

.min-h-140{
  min-height: 35rem;
}

.min-h-152{
  min-height: 38rem;
}

.min-h-160{
  min-height: 40rem;
}

.min-h-162{
  min-height: 41rem;
}

.min-h-192{
  min-height: 48rem;
}

.min-h-208{
  min-height: 52rem;
}

.min-h-224{
  min-height: 56rem;
}

.min-h-256{
  min-height: 64rem;
}

.min-h-full{
  min-height: 100%;
}

.min-h-px{
  min-height: 1px;
}

.min-h-screen{
  min-height: 100vh;
}

.min-w-0{
  min-width: 0;
}

.min-w-1{
  min-width: 0.25rem;
}

.min-w-2{
  min-width: 0.5rem;
}

.min-w-3{
  min-width: 0.75rem;
}

.min-w-4{
  min-width: 1rem;
}

.min-w-5{
  min-width: 1.25rem;
}

.min-w-6{
  min-width: 1.5rem;
}

.min-w-7{
  min-width: 1.75rem;
}

.min-w-8{
  min-width: 2rem;
}

.min-w-9{
  min-width: 2.25rem;
}

.min-w-10{
  min-width: 2.5rem;
}

.min-w-11{
  min-width: 2.75rem;
}

.min-w-12{
  min-width: 3rem;
}

.min-w-14{
  min-width: 3.5rem;
}

.min-w-15{
  min-width: 3.75rem;
}

.min-w-16{
  min-width: 4rem;
}

.min-w-18{
  min-width: 4.5rem;
}

.min-w-20{
  min-width: 5rem;
}

.min-w-22{
  min-width: 5.5rem;
}

.min-w-23{
  min-width: 5.75rem;
}

.min-w-24{
  min-width: 6rem;
}

.min-w-25{
  min-width: 6.25rem;
}

.min-w-26{
  min-width: 6.5rem;
}

.min-w-28{
  min-width: 7rem;
}

.min-w-30{
  min-width: 7.5rem;
}

.min-w-32{
  min-width: 8rem;
}

.min-w-34{
  min-width: 8.5rem;
}

.min-w-40{
  min-width: 10rem;
}

.min-w-42{
  min-width: 10.5rem;
}

.min-w-44{
  min-width: 11rem;
}

.min-w-48{
  min-width: 12rem;
}

.min-w-52{
  min-width: 13rem;
}

.min-w-54{
  min-width: 13.5rem;
}

.min-w-56{
  min-width: 14rem;
}

.min-w-60{
  min-width: 15rem;
}

.min-w-64{
  min-width: 16rem;
}

.min-w-68{
  min-width: 17rem;
}

.min-w-72{
  min-width: 18rem;
}

.min-w-74{
  min-width: 18.5rem;
}

.min-w-76{
  min-width: 19rem;
}

.min-w-78{
  min-width: 19.5rem;
}

.min-w-80{
  min-width: 20rem;
}

.min-w-82{
  min-width: 20.5rem;
}

.min-w-84{
  min-width: 21rem;
}

.min-w-88{
  min-width: 22rem;
}

.min-w-92{
  min-width: 23rem;
}

.min-w-96{
  min-width: 24rem;
}

.min-w-98{
  min-width: 24.5rem;
}

.min-w-100{
  min-width: 25rem;
}

.min-w-104{
  min-width: 26rem;
}

.min-w-112{
  min-width: 28rem;
}

.min-w-124{
  min-width: 31rem;
}

.min-w-128{
  min-width: 32rem;
}

.min-w-140{
  min-width: 35rem;
}

.min-w-152{
  min-width: 38rem;
}

.min-w-160{
  min-width: 40rem;
}

.min-w-162{
  min-width: 41rem;
}

.min-w-192{
  min-width: 48rem;
}

.min-w-208{
  min-width: 52rem;
}

.min-w-224{
  min-width: 56rem;
}

.min-w-256{
  min-width: 64rem;
}

.min-w-px{
  min-width: 1px;
}

.min-w-full{
  min-width: 100%;
}

.object-contain{
  object-fit: contain;
}

.object-cover{
  object-fit: cover;
}

.object-fill{
  object-fit: fill;
}

.object-none{
  object-fit: none;
}

.object-scale-down{
  object-fit: scale-down;
}

.object-bottom{
  object-position: bottom;
}

.object-center{
  object-position: center;
}

.object-left{
  object-position: left;
}

.object-left-bottom{
  object-position: left bottom;
}

.object-left-top{
  object-position: left top;
}

.object-right{
  object-position: right;
}

.object-right-bottom{
  object-position: right bottom;
}

.object-right-top{
  object-position: right top;
}

.object-top{
  object-position: top;
}

.opacity-0{
  opacity: 0;
}

.opacity-25{
  opacity: .25;
}

.opacity-50{
  opacity: .5;
}

.opacity-75{
  opacity: .75;
}

.opacity-100{
  opacity: 1;
}

.outline-none{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.outline-white{
  outline: 2px dotted white;
  outline-offset: 2px;
}

.outline-black{
  outline: 2px dotted black;
  outline-offset: 2px;
}

.focus\\:outline-none:focus{
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:outline-white:focus{
  outline: 2px dotted white;
  outline-offset: 2px;
}

.focus\\:outline-black:focus{
  outline: 2px dotted black;
  outline-offset: 2px;
}

.overflow-auto{
  overflow: auto;
}

.overflow-hidden{
  overflow: hidden;
}

.overflow-visible{
  overflow: visible;
}

.overflow-scroll{
  overflow: scroll;
}

.overflow-x-auto{
  overflow-x: auto;
}

.overflow-y-auto{
  overflow-y: auto;
}

.overflow-x-hidden{
  overflow-x: hidden;
}

.overflow-y-hidden{
  overflow-y: hidden;
}

.overflow-x-visible{
  overflow-x: visible;
}

.overflow-y-visible{
  overflow-y: visible;
}

.overflow-x-scroll{
  overflow-x: scroll;
}

.overflow-y-scroll{
  overflow-y: scroll;
}

.scrolling-touch{
  -webkit-overflow-scrolling: touch;
}

.scrolling-auto{
  -webkit-overflow-scrolling: auto;
}

.overscroll-auto{
  overscroll-behavior: auto;
}

.overscroll-contain{
  overscroll-behavior: contain;
}

.overscroll-none{
  overscroll-behavior: none;
}

.overscroll-y-auto{
  overscroll-behavior-y: auto;
}

.overscroll-y-contain{
  overscroll-behavior-y: contain;
}

.overscroll-y-none{
  overscroll-behavior-y: none;
}

.overscroll-x-auto{
  overscroll-behavior-x: auto;
}

.overscroll-x-contain{
  overscroll-behavior-x: contain;
}

.overscroll-x-none{
  overscroll-behavior-x: none;
}

.p-0{
  padding: 0;
}

.p-1{
  padding: 0.25rem;
}

.p-2{
  padding: 0.5rem;
}

.p-3{
  padding: 0.75rem;
}

.p-4{
  padding: 1rem;
}

.p-5{
  padding: 1.25rem;
}

.p-6{
  padding: 1.5rem;
}

.p-7{
  padding: 1.75rem;
}

.p-8{
  padding: 2rem;
}

.p-9{
  padding: 2.25rem;
}

.p-10{
  padding: 2.5rem;
}

.p-11{
  padding: 2.75rem;
}

.p-12{
  padding: 3rem;
}

.p-14{
  padding: 3.5rem;
}

.p-15{
  padding: 3.75rem;
}

.p-16{
  padding: 4rem;
}

.p-18{
  padding: 4.5rem;
}

.p-20{
  padding: 5rem;
}

.p-22{
  padding: 5.5rem;
}

.p-23{
  padding: 5.75rem;
}

.p-24{
  padding: 6rem;
}

.p-25{
  padding: 6.25rem;
}

.p-26{
  padding: 6.5rem;
}

.p-28{
  padding: 7rem;
}

.p-30{
  padding: 7.5rem;
}

.p-32{
  padding: 8rem;
}

.p-34{
  padding: 8.5rem;
}

.p-40{
  padding: 10rem;
}

.p-42{
  padding: 10.5rem;
}

.p-44{
  padding: 11rem;
}

.p-48{
  padding: 12rem;
}

.p-52{
  padding: 13rem;
}

.p-54{
  padding: 13.5rem;
}

.p-56{
  padding: 14rem;
}

.p-60{
  padding: 15rem;
}

.p-64{
  padding: 16rem;
}

.p-68{
  padding: 17rem;
}

.p-72{
  padding: 18rem;
}

.p-74{
  padding: 18.5rem;
}

.p-76{
  padding: 19rem;
}

.p-78{
  padding: 19.5rem;
}

.p-80{
  padding: 20rem;
}

.p-82{
  padding: 20.5rem;
}

.p-84{
  padding: 21rem;
}

.p-88{
  padding: 22rem;
}

.p-92{
  padding: 23rem;
}

.p-96{
  padding: 24rem;
}

.p-98{
  padding: 24.5rem;
}

.p-100{
  padding: 25rem;
}

.p-104{
  padding: 26rem;
}

.p-112{
  padding: 28rem;
}

.p-124{
  padding: 31rem;
}

.p-128{
  padding: 32rem;
}

.p-140{
  padding: 35rem;
}

.p-152{
  padding: 38rem;
}

.p-160{
  padding: 40rem;
}

.p-162{
  padding: 41rem;
}

.p-192{
  padding: 48rem;
}

.p-208{
  padding: 52rem;
}

.p-224{
  padding: 56rem;
}

.p-256{
  padding: 64rem;
}

.p-px{
  padding: 1px;
}

.py-0{
  padding-top: 0;
  padding-bottom: 0;
}

.px-0{
  padding-left: 0;
  padding-right: 0;
}

.py-1{
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.px-1{
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.py-2{
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.px-2{
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.py-3{
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.px-3{
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.py-4{
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.px-4{
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-5{
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.px-5{
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.py-6{
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.px-6{
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.py-7{
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}

.px-7{
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}

.py-8{
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.px-8{
  padding-left: 2rem;
  padding-right: 2rem;
}

.py-9{
  padding-top: 2.25rem;
  padding-bottom: 2.25rem;
}

.px-9{
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}

.py-10{
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.px-10{
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.py-11{
  padding-top: 2.75rem;
  padding-bottom: 2.75rem;
}

.px-11{
  padding-left: 2.75rem;
  padding-right: 2.75rem;
}

.py-12{
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.px-12{
  padding-left: 3rem;
  padding-right: 3rem;
}

.py-14{
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}

.px-14{
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}

.py-15{
  padding-top: 3.75rem;
  padding-bottom: 3.75rem;
}

.px-15{
  padding-left: 3.75rem;
  padding-right: 3.75rem;
}

.py-16{
  padding-top: 4rem;
  padding-bottom: 4rem;
}

.px-16{
  padding-left: 4rem;
  padding-right: 4rem;
}

.py-18{
  padding-top: 4.5rem;
  padding-bottom: 4.5rem;
}

.px-18{
  padding-left: 4.5rem;
  padding-right: 4.5rem;
}

.py-20{
  padding-top: 5rem;
  padding-bottom: 5rem;
}

.px-20{
  padding-left: 5rem;
  padding-right: 5rem;
}

.py-22{
  padding-top: 5.5rem;
  padding-bottom: 5.5rem;
}

.px-22{
  padding-left: 5.5rem;
  padding-right: 5.5rem;
}

.py-23{
  padding-top: 5.75rem;
  padding-bottom: 5.75rem;
}

.px-23{
  padding-left: 5.75rem;
  padding-right: 5.75rem;
}

.py-24{
  padding-top: 6rem;
  padding-bottom: 6rem;
}

.px-24{
  padding-left: 6rem;
  padding-right: 6rem;
}

.py-25{
  padding-top: 6.25rem;
  padding-bottom: 6.25rem;
}

.px-25{
  padding-left: 6.25rem;
  padding-right: 6.25rem;
}

.py-26{
  padding-top: 6.5rem;
  padding-bottom: 6.5rem;
}

.px-26{
  padding-left: 6.5rem;
  padding-right: 6.5rem;
}

.py-28{
  padding-top: 7rem;
  padding-bottom: 7rem;
}

.px-28{
  padding-left: 7rem;
  padding-right: 7rem;
}

.py-30{
  padding-top: 7.5rem;
  padding-bottom: 7.5rem;
}

.px-30{
  padding-left: 7.5rem;
  padding-right: 7.5rem;
}

.py-32{
  padding-top: 8rem;
  padding-bottom: 8rem;
}

.px-32{
  padding-left: 8rem;
  padding-right: 8rem;
}

.py-34{
  padding-top: 8.5rem;
  padding-bottom: 8.5rem;
}

.px-34{
  padding-left: 8.5rem;
  padding-right: 8.5rem;
}

.py-40{
  padding-top: 10rem;
  padding-bottom: 10rem;
}

.px-40{
  padding-left: 10rem;
  padding-right: 10rem;
}

.py-42{
  padding-top: 10.5rem;
  padding-bottom: 10.5rem;
}

.px-42{
  padding-left: 10.5rem;
  padding-right: 10.5rem;
}

.py-44{
  padding-top: 11rem;
  padding-bottom: 11rem;
}

.px-44{
  padding-left: 11rem;
  padding-right: 11rem;
}

.py-48{
  padding-top: 12rem;
  padding-bottom: 12rem;
}

.px-48{
  padding-left: 12rem;
  padding-right: 12rem;
}

.py-52{
  padding-top: 13rem;
  padding-bottom: 13rem;
}

.px-52{
  padding-left: 13rem;
  padding-right: 13rem;
}

.py-54{
  padding-top: 13.5rem;
  padding-bottom: 13.5rem;
}

.px-54{
  padding-left: 13.5rem;
  padding-right: 13.5rem;
}

.py-56{
  padding-top: 14rem;
  padding-bottom: 14rem;
}

.px-56{
  padding-left: 14rem;
  padding-right: 14rem;
}

.py-60{
  padding-top: 15rem;
  padding-bottom: 15rem;
}

.px-60{
  padding-left: 15rem;
  padding-right: 15rem;
}

.py-64{
  padding-top: 16rem;
  padding-bottom: 16rem;
}

.px-64{
  padding-left: 16rem;
  padding-right: 16rem;
}

.py-68{
  padding-top: 17rem;
  padding-bottom: 17rem;
}

.px-68{
  padding-left: 17rem;
  padding-right: 17rem;
}

.py-72{
  padding-top: 18rem;
  padding-bottom: 18rem;
}

.px-72{
  padding-left: 18rem;
  padding-right: 18rem;
}

.py-74{
  padding-top: 18.5rem;
  padding-bottom: 18.5rem;
}

.px-74{
  padding-left: 18.5rem;
  padding-right: 18.5rem;
}

.py-76{
  padding-top: 19rem;
  padding-bottom: 19rem;
}

.px-76{
  padding-left: 19rem;
  padding-right: 19rem;
}

.py-78{
  padding-top: 19.5rem;
  padding-bottom: 19.5rem;
}

.px-78{
  padding-left: 19.5rem;
  padding-right: 19.5rem;
}

.py-80{
  padding-top: 20rem;
  padding-bottom: 20rem;
}

.px-80{
  padding-left: 20rem;
  padding-right: 20rem;
}

.py-82{
  padding-top: 20.5rem;
  padding-bottom: 20.5rem;
}

.px-82{
  padding-left: 20.5rem;
  padding-right: 20.5rem;
}

.py-84{
  padding-top: 21rem;
  padding-bottom: 21rem;
}

.px-84{
  padding-left: 21rem;
  padding-right: 21rem;
}

.py-88{
  padding-top: 22rem;
  padding-bottom: 22rem;
}

.px-88{
  padding-left: 22rem;
  padding-right: 22rem;
}

.py-92{
  padding-top: 23rem;
  padding-bottom: 23rem;
}

.px-92{
  padding-left: 23rem;
  padding-right: 23rem;
}

.py-96{
  padding-top: 24rem;
  padding-bottom: 24rem;
}

.px-96{
  padding-left: 24rem;
  padding-right: 24rem;
}

.py-98{
  padding-top: 24.5rem;
  padding-bottom: 24.5rem;
}

.px-98{
  padding-left: 24.5rem;
  padding-right: 24.5rem;
}

.py-100{
  padding-top: 25rem;
  padding-bottom: 25rem;
}

.px-100{
  padding-left: 25rem;
  padding-right: 25rem;
}

.py-104{
  padding-top: 26rem;
  padding-bottom: 26rem;
}

.px-104{
  padding-left: 26rem;
  padding-right: 26rem;
}

.py-112{
  padding-top: 28rem;
  padding-bottom: 28rem;
}

.px-112{
  padding-left: 28rem;
  padding-right: 28rem;
}

.py-124{
  padding-top: 31rem;
  padding-bottom: 31rem;
}

.px-124{
  padding-left: 31rem;
  padding-right: 31rem;
}

.py-128{
  padding-top: 32rem;
  padding-bottom: 32rem;
}

.px-128{
  padding-left: 32rem;
  padding-right: 32rem;
}

.py-140{
  padding-top: 35rem;
  padding-bottom: 35rem;
}

.px-140{
  padding-left: 35rem;
  padding-right: 35rem;
}

.py-152{
  padding-top: 38rem;
  padding-bottom: 38rem;
}

.px-152{
  padding-left: 38rem;
  padding-right: 38rem;
}

.py-160{
  padding-top: 40rem;
  padding-bottom: 40rem;
}

.px-160{
  padding-left: 40rem;
  padding-right: 40rem;
}

.py-162{
  padding-top: 41rem;
  padding-bottom: 41rem;
}

.px-162{
  padding-left: 41rem;
  padding-right: 41rem;
}

.py-192{
  padding-top: 48rem;
  padding-bottom: 48rem;
}

.px-192{
  padding-left: 48rem;
  padding-right: 48rem;
}

.py-208{
  padding-top: 52rem;
  padding-bottom: 52rem;
}

.px-208{
  padding-left: 52rem;
  padding-right: 52rem;
}

.py-224{
  padding-top: 56rem;
  padding-bottom: 56rem;
}

.px-224{
  padding-left: 56rem;
  padding-right: 56rem;
}

.py-256{
  padding-top: 64rem;
  padding-bottom: 64rem;
}

.px-256{
  padding-left: 64rem;
  padding-right: 64rem;
}

.py-px{
  padding-top: 1px;
  padding-bottom: 1px;
}

.px-px{
  padding-left: 1px;
  padding-right: 1px;
}

.pt-0{
  padding-top: 0;
}

.pr-0{
  padding-right: 0;
}

.pb-0{
  padding-bottom: 0;
}

.pl-0{
  padding-left: 0;
}

.pt-1{
  padding-top: 0.25rem;
}

.pr-1{
  padding-right: 0.25rem;
}

.pb-1{
  padding-bottom: 0.25rem;
}

.pl-1{
  padding-left: 0.25rem;
}

.pt-2{
  padding-top: 0.5rem;
}

.pr-2{
  padding-right: 0.5rem;
}

.pb-2{
  padding-bottom: 0.5rem;
}

.pl-2{
  padding-left: 0.5rem;
}

.pt-3{
  padding-top: 0.75rem;
}

.pr-3{
  padding-right: 0.75rem;
}

.pb-3{
  padding-bottom: 0.75rem;
}

.pl-3{
  padding-left: 0.75rem;
}

.pt-4{
  padding-top: 1rem;
}

.pr-4{
  padding-right: 1rem;
}

.pb-4{
  padding-bottom: 1rem;
}

.pl-4{
  padding-left: 1rem;
}

.pt-5{
  padding-top: 1.25rem;
}

.pr-5{
  padding-right: 1.25rem;
}

.pb-5{
  padding-bottom: 1.25rem;
}

.pl-5{
  padding-left: 1.25rem;
}

.pt-6{
  padding-top: 1.5rem;
}

.pr-6{
  padding-right: 1.5rem;
}

.pb-6{
  padding-bottom: 1.5rem;
}

.pl-6{
  padding-left: 1.5rem;
}

.pt-7{
  padding-top: 1.75rem;
}

.pr-7{
  padding-right: 1.75rem;
}

.pb-7{
  padding-bottom: 1.75rem;
}

.pl-7{
  padding-left: 1.75rem;
}

.pt-8{
  padding-top: 2rem;
}

.pr-8{
  padding-right: 2rem;
}

.pb-8{
  padding-bottom: 2rem;
}

.pl-8{
  padding-left: 2rem;
}

.pt-9{
  padding-top: 2.25rem;
}

.pr-9{
  padding-right: 2.25rem;
}

.pb-9{
  padding-bottom: 2.25rem;
}

.pl-9{
  padding-left: 2.25rem;
}

.pt-10{
  padding-top: 2.5rem;
}

.pr-10{
  padding-right: 2.5rem;
}

.pb-10{
  padding-bottom: 2.5rem;
}

.pl-10{
  padding-left: 2.5rem;
}

.pt-11{
  padding-top: 2.75rem;
}

.pr-11{
  padding-right: 2.75rem;
}

.pb-11{
  padding-bottom: 2.75rem;
}

.pl-11{
  padding-left: 2.75rem;
}

.pt-12{
  padding-top: 3rem;
}

.pr-12{
  padding-right: 3rem;
}

.pb-12{
  padding-bottom: 3rem;
}

.pl-12{
  padding-left: 3rem;
}

.pt-14{
  padding-top: 3.5rem;
}

.pr-14{
  padding-right: 3.5rem;
}

.pb-14{
  padding-bottom: 3.5rem;
}

.pl-14{
  padding-left: 3.5rem;
}

.pt-15{
  padding-top: 3.75rem;
}

.pr-15{
  padding-right: 3.75rem;
}

.pb-15{
  padding-bottom: 3.75rem;
}

.pl-15{
  padding-left: 3.75rem;
}

.pt-16{
  padding-top: 4rem;
}

.pr-16{
  padding-right: 4rem;
}

.pb-16{
  padding-bottom: 4rem;
}

.pl-16{
  padding-left: 4rem;
}

.pt-18{
  padding-top: 4.5rem;
}

.pr-18{
  padding-right: 4.5rem;
}

.pb-18{
  padding-bottom: 4.5rem;
}

.pl-18{
  padding-left: 4.5rem;
}

.pt-20{
  padding-top: 5rem;
}

.pr-20{
  padding-right: 5rem;
}

.pb-20{
  padding-bottom: 5rem;
}

.pl-20{
  padding-left: 5rem;
}

.pt-22{
  padding-top: 5.5rem;
}

.pr-22{
  padding-right: 5.5rem;
}

.pb-22{
  padding-bottom: 5.5rem;
}

.pl-22{
  padding-left: 5.5rem;
}

.pt-23{
  padding-top: 5.75rem;
}

.pr-23{
  padding-right: 5.75rem;
}

.pb-23{
  padding-bottom: 5.75rem;
}

.pl-23{
  padding-left: 5.75rem;
}

.pt-24{
  padding-top: 6rem;
}

.pr-24{
  padding-right: 6rem;
}

.pb-24{
  padding-bottom: 6rem;
}

.pl-24{
  padding-left: 6rem;
}

.pt-25{
  padding-top: 6.25rem;
}

.pr-25{
  padding-right: 6.25rem;
}

.pb-25{
  padding-bottom: 6.25rem;
}

.pl-25{
  padding-left: 6.25rem;
}

.pt-26{
  padding-top: 6.5rem;
}

.pr-26{
  padding-right: 6.5rem;
}

.pb-26{
  padding-bottom: 6.5rem;
}

.pl-26{
  padding-left: 6.5rem;
}

.pt-28{
  padding-top: 7rem;
}

.pr-28{
  padding-right: 7rem;
}

.pb-28{
  padding-bottom: 7rem;
}

.pl-28{
  padding-left: 7rem;
}

.pt-30{
  padding-top: 7.5rem;
}

.pr-30{
  padding-right: 7.5rem;
}

.pb-30{
  padding-bottom: 7.5rem;
}

.pl-30{
  padding-left: 7.5rem;
}

.pt-32{
  padding-top: 8rem;
}

.pr-32{
  padding-right: 8rem;
}

.pb-32{
  padding-bottom: 8rem;
}

.pl-32{
  padding-left: 8rem;
}

.pt-34{
  padding-top: 8.5rem;
}

.pr-34{
  padding-right: 8.5rem;
}

.pb-34{
  padding-bottom: 8.5rem;
}

.pl-34{
  padding-left: 8.5rem;
}

.pt-40{
  padding-top: 10rem;
}

.pr-40{
  padding-right: 10rem;
}

.pb-40{
  padding-bottom: 10rem;
}

.pl-40{
  padding-left: 10rem;
}

.pt-42{
  padding-top: 10.5rem;
}

.pr-42{
  padding-right: 10.5rem;
}

.pb-42{
  padding-bottom: 10.5rem;
}

.pl-42{
  padding-left: 10.5rem;
}

.pt-44{
  padding-top: 11rem;
}

.pr-44{
  padding-right: 11rem;
}

.pb-44{
  padding-bottom: 11rem;
}

.pl-44{
  padding-left: 11rem;
}

.pt-48{
  padding-top: 12rem;
}

.pr-48{
  padding-right: 12rem;
}

.pb-48{
  padding-bottom: 12rem;
}

.pl-48{
  padding-left: 12rem;
}

.pt-52{
  padding-top: 13rem;
}

.pr-52{
  padding-right: 13rem;
}

.pb-52{
  padding-bottom: 13rem;
}

.pl-52{
  padding-left: 13rem;
}

.pt-54{
  padding-top: 13.5rem;
}

.pr-54{
  padding-right: 13.5rem;
}

.pb-54{
  padding-bottom: 13.5rem;
}

.pl-54{
  padding-left: 13.5rem;
}

.pt-56{
  padding-top: 14rem;
}

.pr-56{
  padding-right: 14rem;
}

.pb-56{
  padding-bottom: 14rem;
}

.pl-56{
  padding-left: 14rem;
}

.pt-60{
  padding-top: 15rem;
}

.pr-60{
  padding-right: 15rem;
}

.pb-60{
  padding-bottom: 15rem;
}

.pl-60{
  padding-left: 15rem;
}

.pt-64{
  padding-top: 16rem;
}

.pr-64{
  padding-right: 16rem;
}

.pb-64{
  padding-bottom: 16rem;
}

.pl-64{
  padding-left: 16rem;
}

.pt-68{
  padding-top: 17rem;
}

.pr-68{
  padding-right: 17rem;
}

.pb-68{
  padding-bottom: 17rem;
}

.pl-68{
  padding-left: 17rem;
}

.pt-72{
  padding-top: 18rem;
}

.pr-72{
  padding-right: 18rem;
}

.pb-72{
  padding-bottom: 18rem;
}

.pl-72{
  padding-left: 18rem;
}

.pt-74{
  padding-top: 18.5rem;
}

.pr-74{
  padding-right: 18.5rem;
}

.pb-74{
  padding-bottom: 18.5rem;
}

.pl-74{
  padding-left: 18.5rem;
}

.pt-76{
  padding-top: 19rem;
}

.pr-76{
  padding-right: 19rem;
}

.pb-76{
  padding-bottom: 19rem;
}

.pl-76{
  padding-left: 19rem;
}

.pt-78{
  padding-top: 19.5rem;
}

.pr-78{
  padding-right: 19.5rem;
}

.pb-78{
  padding-bottom: 19.5rem;
}

.pl-78{
  padding-left: 19.5rem;
}

.pt-80{
  padding-top: 20rem;
}

.pr-80{
  padding-right: 20rem;
}

.pb-80{
  padding-bottom: 20rem;
}

.pl-80{
  padding-left: 20rem;
}

.pt-82{
  padding-top: 20.5rem;
}

.pr-82{
  padding-right: 20.5rem;
}

.pb-82{
  padding-bottom: 20.5rem;
}

.pl-82{
  padding-left: 20.5rem;
}

.pt-84{
  padding-top: 21rem;
}

.pr-84{
  padding-right: 21rem;
}

.pb-84{
  padding-bottom: 21rem;
}

.pl-84{
  padding-left: 21rem;
}

.pt-88{
  padding-top: 22rem;
}

.pr-88{
  padding-right: 22rem;
}

.pb-88{
  padding-bottom: 22rem;
}

.pl-88{
  padding-left: 22rem;
}

.pt-92{
  padding-top: 23rem;
}

.pr-92{
  padding-right: 23rem;
}

.pb-92{
  padding-bottom: 23rem;
}

.pl-92{
  padding-left: 23rem;
}

.pt-96{
  padding-top: 24rem;
}

.pr-96{
  padding-right: 24rem;
}

.pb-96{
  padding-bottom: 24rem;
}

.pl-96{
  padding-left: 24rem;
}

.pt-98{
  padding-top: 24.5rem;
}

.pr-98{
  padding-right: 24.5rem;
}

.pb-98{
  padding-bottom: 24.5rem;
}

.pl-98{
  padding-left: 24.5rem;
}

.pt-100{
  padding-top: 25rem;
}

.pr-100{
  padding-right: 25rem;
}

.pb-100{
  padding-bottom: 25rem;
}

.pl-100{
  padding-left: 25rem;
}

.pt-104{
  padding-top: 26rem;
}

.pr-104{
  padding-right: 26rem;
}

.pb-104{
  padding-bottom: 26rem;
}

.pl-104{
  padding-left: 26rem;
}

.pt-112{
  padding-top: 28rem;
}

.pr-112{
  padding-right: 28rem;
}

.pb-112{
  padding-bottom: 28rem;
}

.pl-112{
  padding-left: 28rem;
}

.pt-124{
  padding-top: 31rem;
}

.pr-124{
  padding-right: 31rem;
}

.pb-124{
  padding-bottom: 31rem;
}

.pl-124{
  padding-left: 31rem;
}

.pt-128{
  padding-top: 32rem;
}

.pr-128{
  padding-right: 32rem;
}

.pb-128{
  padding-bottom: 32rem;
}

.pl-128{
  padding-left: 32rem;
}

.pt-140{
  padding-top: 35rem;
}

.pr-140{
  padding-right: 35rem;
}

.pb-140{
  padding-bottom: 35rem;
}

.pl-140{
  padding-left: 35rem;
}

.pt-152{
  padding-top: 38rem;
}

.pr-152{
  padding-right: 38rem;
}

.pb-152{
  padding-bottom: 38rem;
}

.pl-152{
  padding-left: 38rem;
}

.pt-160{
  padding-top: 40rem;
}

.pr-160{
  padding-right: 40rem;
}

.pb-160{
  padding-bottom: 40rem;
}

.pl-160{
  padding-left: 40rem;
}

.pt-162{
  padding-top: 41rem;
}

.pr-162{
  padding-right: 41rem;
}

.pb-162{
  padding-bottom: 41rem;
}

.pl-162{
  padding-left: 41rem;
}

.pt-192{
  padding-top: 48rem;
}

.pr-192{
  padding-right: 48rem;
}

.pb-192{
  padding-bottom: 48rem;
}

.pl-192{
  padding-left: 48rem;
}

.pt-208{
  padding-top: 52rem;
}

.pr-208{
  padding-right: 52rem;
}

.pb-208{
  padding-bottom: 52rem;
}

.pl-208{
  padding-left: 52rem;
}

.pt-224{
  padding-top: 56rem;
}

.pr-224{
  padding-right: 56rem;
}

.pb-224{
  padding-bottom: 56rem;
}

.pl-224{
  padding-left: 56rem;
}

.pt-256{
  padding-top: 64rem;
}

.pr-256{
  padding-right: 64rem;
}

.pb-256{
  padding-bottom: 64rem;
}

.pl-256{
  padding-left: 64rem;
}

.pt-px{
  padding-top: 1px;
}

.pr-px{
  padding-right: 1px;
}

.pb-px{
  padding-bottom: 1px;
}

.pl-px{
  padding-left: 1px;
}

.odd\\:p-0:nth-child(odd){
  padding: 0;
}

.odd\\:p-1:nth-child(odd){
  padding: 0.25rem;
}

.odd\\:p-2:nth-child(odd){
  padding: 0.5rem;
}

.odd\\:p-3:nth-child(odd){
  padding: 0.75rem;
}

.odd\\:p-4:nth-child(odd){
  padding: 1rem;
}

.odd\\:p-5:nth-child(odd){
  padding: 1.25rem;
}

.odd\\:p-6:nth-child(odd){
  padding: 1.5rem;
}

.odd\\:p-7:nth-child(odd){
  padding: 1.75rem;
}

.odd\\:p-8:nth-child(odd){
  padding: 2rem;
}

.odd\\:p-9:nth-child(odd){
  padding: 2.25rem;
}

.odd\\:p-10:nth-child(odd){
  padding: 2.5rem;
}

.odd\\:p-11:nth-child(odd){
  padding: 2.75rem;
}

.odd\\:p-12:nth-child(odd){
  padding: 3rem;
}

.odd\\:p-14:nth-child(odd){
  padding: 3.5rem;
}

.odd\\:p-15:nth-child(odd){
  padding: 3.75rem;
}

.odd\\:p-16:nth-child(odd){
  padding: 4rem;
}

.odd\\:p-18:nth-child(odd){
  padding: 4.5rem;
}

.odd\\:p-20:nth-child(odd){
  padding: 5rem;
}

.odd\\:p-22:nth-child(odd){
  padding: 5.5rem;
}

.odd\\:p-23:nth-child(odd){
  padding: 5.75rem;
}

.odd\\:p-24:nth-child(odd){
  padding: 6rem;
}

.odd\\:p-25:nth-child(odd){
  padding: 6.25rem;
}

.odd\\:p-26:nth-child(odd){
  padding: 6.5rem;
}

.odd\\:p-28:nth-child(odd){
  padding: 7rem;
}

.odd\\:p-30:nth-child(odd){
  padding: 7.5rem;
}

.odd\\:p-32:nth-child(odd){
  padding: 8rem;
}

.odd\\:p-34:nth-child(odd){
  padding: 8.5rem;
}

.odd\\:p-40:nth-child(odd){
  padding: 10rem;
}

.odd\\:p-42:nth-child(odd){
  padding: 10.5rem;
}

.odd\\:p-44:nth-child(odd){
  padding: 11rem;
}

.odd\\:p-48:nth-child(odd){
  padding: 12rem;
}

.odd\\:p-52:nth-child(odd){
  padding: 13rem;
}

.odd\\:p-54:nth-child(odd){
  padding: 13.5rem;
}

.odd\\:p-56:nth-child(odd){
  padding: 14rem;
}

.odd\\:p-60:nth-child(odd){
  padding: 15rem;
}

.odd\\:p-64:nth-child(odd){
  padding: 16rem;
}

.odd\\:p-68:nth-child(odd){
  padding: 17rem;
}

.odd\\:p-72:nth-child(odd){
  padding: 18rem;
}

.odd\\:p-74:nth-child(odd){
  padding: 18.5rem;
}

.odd\\:p-76:nth-child(odd){
  padding: 19rem;
}

.odd\\:p-78:nth-child(odd){
  padding: 19.5rem;
}

.odd\\:p-80:nth-child(odd){
  padding: 20rem;
}

.odd\\:p-82:nth-child(odd){
  padding: 20.5rem;
}

.odd\\:p-84:nth-child(odd){
  padding: 21rem;
}

.odd\\:p-88:nth-child(odd){
  padding: 22rem;
}

.odd\\:p-92:nth-child(odd){
  padding: 23rem;
}

.odd\\:p-96:nth-child(odd){
  padding: 24rem;
}

.odd\\:p-98:nth-child(odd){
  padding: 24.5rem;
}

.odd\\:p-100:nth-child(odd){
  padding: 25rem;
}

.odd\\:p-104:nth-child(odd){
  padding: 26rem;
}

.odd\\:p-112:nth-child(odd){
  padding: 28rem;
}

.odd\\:p-124:nth-child(odd){
  padding: 31rem;
}

.odd\\:p-128:nth-child(odd){
  padding: 32rem;
}

.odd\\:p-140:nth-child(odd){
  padding: 35rem;
}

.odd\\:p-152:nth-child(odd){
  padding: 38rem;
}

.odd\\:p-160:nth-child(odd){
  padding: 40rem;
}

.odd\\:p-162:nth-child(odd){
  padding: 41rem;
}

.odd\\:p-192:nth-child(odd){
  padding: 48rem;
}

.odd\\:p-208:nth-child(odd){
  padding: 52rem;
}

.odd\\:p-224:nth-child(odd){
  padding: 56rem;
}

.odd\\:p-256:nth-child(odd){
  padding: 64rem;
}

.odd\\:p-px:nth-child(odd){
  padding: 1px;
}

.odd\\:py-0:nth-child(odd){
  padding-top: 0;
  padding-bottom: 0;
}

.odd\\:px-0:nth-child(odd){
  padding-left: 0;
  padding-right: 0;
}

.odd\\:py-1:nth-child(odd){
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.odd\\:px-1:nth-child(odd){
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.odd\\:py-2:nth-child(odd){
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.odd\\:px-2:nth-child(odd){
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.odd\\:py-3:nth-child(odd){
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.odd\\:px-3:nth-child(odd){
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.odd\\:py-4:nth-child(odd){
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.odd\\:px-4:nth-child(odd){
  padding-left: 1rem;
  padding-right: 1rem;
}

.odd\\:py-5:nth-child(odd){
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.odd\\:px-5:nth-child(odd){
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.odd\\:py-6:nth-child(odd){
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.odd\\:px-6:nth-child(odd){
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.odd\\:py-7:nth-child(odd){
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}

.odd\\:px-7:nth-child(odd){
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}

.odd\\:py-8:nth-child(odd){
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.odd\\:px-8:nth-child(odd){
  padding-left: 2rem;
  padding-right: 2rem;
}

.odd\\:py-9:nth-child(odd){
  padding-top: 2.25rem;
  padding-bottom: 2.25rem;
}

.odd\\:px-9:nth-child(odd){
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}

.odd\\:py-10:nth-child(odd){
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.odd\\:px-10:nth-child(odd){
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.odd\\:py-11:nth-child(odd){
  padding-top: 2.75rem;
  padding-bottom: 2.75rem;
}

.odd\\:px-11:nth-child(odd){
  padding-left: 2.75rem;
  padding-right: 2.75rem;
}

.odd\\:py-12:nth-child(odd){
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.odd\\:px-12:nth-child(odd){
  padding-left: 3rem;
  padding-right: 3rem;
}

.odd\\:py-14:nth-child(odd){
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}

.odd\\:px-14:nth-child(odd){
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}

.odd\\:py-15:nth-child(odd){
  padding-top: 3.75rem;
  padding-bottom: 3.75rem;
}

.odd\\:px-15:nth-child(odd){
  padding-left: 3.75rem;
  padding-right: 3.75rem;
}

.odd\\:py-16:nth-child(odd){
  padding-top: 4rem;
  padding-bottom: 4rem;
}

.odd\\:px-16:nth-child(odd){
  padding-left: 4rem;
  padding-right: 4rem;
}

.odd\\:py-18:nth-child(odd){
  padding-top: 4.5rem;
  padding-bottom: 4.5rem;
}

.odd\\:px-18:nth-child(odd){
  padding-left: 4.5rem;
  padding-right: 4.5rem;
}

.odd\\:py-20:nth-child(odd){
  padding-top: 5rem;
  padding-bottom: 5rem;
}

.odd\\:px-20:nth-child(odd){
  padding-left: 5rem;
  padding-right: 5rem;
}

.odd\\:py-22:nth-child(odd){
  padding-top: 5.5rem;
  padding-bottom: 5.5rem;
}

.odd\\:px-22:nth-child(odd){
  padding-left: 5.5rem;
  padding-right: 5.5rem;
}

.odd\\:py-23:nth-child(odd){
  padding-top: 5.75rem;
  padding-bottom: 5.75rem;
}

.odd\\:px-23:nth-child(odd){
  padding-left: 5.75rem;
  padding-right: 5.75rem;
}

.odd\\:py-24:nth-child(odd){
  padding-top: 6rem;
  padding-bottom: 6rem;
}

.odd\\:px-24:nth-child(odd){
  padding-left: 6rem;
  padding-right: 6rem;
}

.odd\\:py-25:nth-child(odd){
  padding-top: 6.25rem;
  padding-bottom: 6.25rem;
}

.odd\\:px-25:nth-child(odd){
  padding-left: 6.25rem;
  padding-right: 6.25rem;
}

.odd\\:py-26:nth-child(odd){
  padding-top: 6.5rem;
  padding-bottom: 6.5rem;
}

.odd\\:px-26:nth-child(odd){
  padding-left: 6.5rem;
  padding-right: 6.5rem;
}

.odd\\:py-28:nth-child(odd){
  padding-top: 7rem;
  padding-bottom: 7rem;
}

.odd\\:px-28:nth-child(odd){
  padding-left: 7rem;
  padding-right: 7rem;
}

.odd\\:py-30:nth-child(odd){
  padding-top: 7.5rem;
  padding-bottom: 7.5rem;
}

.odd\\:px-30:nth-child(odd){
  padding-left: 7.5rem;
  padding-right: 7.5rem;
}

.odd\\:py-32:nth-child(odd){
  padding-top: 8rem;
  padding-bottom: 8rem;
}

.odd\\:px-32:nth-child(odd){
  padding-left: 8rem;
  padding-right: 8rem;
}

.odd\\:py-34:nth-child(odd){
  padding-top: 8.5rem;
  padding-bottom: 8.5rem;
}

.odd\\:px-34:nth-child(odd){
  padding-left: 8.5rem;
  padding-right: 8.5rem;
}

.odd\\:py-40:nth-child(odd){
  padding-top: 10rem;
  padding-bottom: 10rem;
}

.odd\\:px-40:nth-child(odd){
  padding-left: 10rem;
  padding-right: 10rem;
}

.odd\\:py-42:nth-child(odd){
  padding-top: 10.5rem;
  padding-bottom: 10.5rem;
}

.odd\\:px-42:nth-child(odd){
  padding-left: 10.5rem;
  padding-right: 10.5rem;
}

.odd\\:py-44:nth-child(odd){
  padding-top: 11rem;
  padding-bottom: 11rem;
}

.odd\\:px-44:nth-child(odd){
  padding-left: 11rem;
  padding-right: 11rem;
}

.odd\\:py-48:nth-child(odd){
  padding-top: 12rem;
  padding-bottom: 12rem;
}

.odd\\:px-48:nth-child(odd){
  padding-left: 12rem;
  padding-right: 12rem;
}

.odd\\:py-52:nth-child(odd){
  padding-top: 13rem;
  padding-bottom: 13rem;
}

.odd\\:px-52:nth-child(odd){
  padding-left: 13rem;
  padding-right: 13rem;
}

.odd\\:py-54:nth-child(odd){
  padding-top: 13.5rem;
  padding-bottom: 13.5rem;
}

.odd\\:px-54:nth-child(odd){
  padding-left: 13.5rem;
  padding-right: 13.5rem;
}

.odd\\:py-56:nth-child(odd){
  padding-top: 14rem;
  padding-bottom: 14rem;
}

.odd\\:px-56:nth-child(odd){
  padding-left: 14rem;
  padding-right: 14rem;
}

.odd\\:py-60:nth-child(odd){
  padding-top: 15rem;
  padding-bottom: 15rem;
}

.odd\\:px-60:nth-child(odd){
  padding-left: 15rem;
  padding-right: 15rem;
}

.odd\\:py-64:nth-child(odd){
  padding-top: 16rem;
  padding-bottom: 16rem;
}

.odd\\:px-64:nth-child(odd){
  padding-left: 16rem;
  padding-right: 16rem;
}

.odd\\:py-68:nth-child(odd){
  padding-top: 17rem;
  padding-bottom: 17rem;
}

.odd\\:px-68:nth-child(odd){
  padding-left: 17rem;
  padding-right: 17rem;
}

.odd\\:py-72:nth-child(odd){
  padding-top: 18rem;
  padding-bottom: 18rem;
}

.odd\\:px-72:nth-child(odd){
  padding-left: 18rem;
  padding-right: 18rem;
}

.odd\\:py-74:nth-child(odd){
  padding-top: 18.5rem;
  padding-bottom: 18.5rem;
}

.odd\\:px-74:nth-child(odd){
  padding-left: 18.5rem;
  padding-right: 18.5rem;
}

.odd\\:py-76:nth-child(odd){
  padding-top: 19rem;
  padding-bottom: 19rem;
}

.odd\\:px-76:nth-child(odd){
  padding-left: 19rem;
  padding-right: 19rem;
}

.odd\\:py-78:nth-child(odd){
  padding-top: 19.5rem;
  padding-bottom: 19.5rem;
}

.odd\\:px-78:nth-child(odd){
  padding-left: 19.5rem;
  padding-right: 19.5rem;
}

.odd\\:py-80:nth-child(odd){
  padding-top: 20rem;
  padding-bottom: 20rem;
}

.odd\\:px-80:nth-child(odd){
  padding-left: 20rem;
  padding-right: 20rem;
}

.odd\\:py-82:nth-child(odd){
  padding-top: 20.5rem;
  padding-bottom: 20.5rem;
}

.odd\\:px-82:nth-child(odd){
  padding-left: 20.5rem;
  padding-right: 20.5rem;
}

.odd\\:py-84:nth-child(odd){
  padding-top: 21rem;
  padding-bottom: 21rem;
}

.odd\\:px-84:nth-child(odd){
  padding-left: 21rem;
  padding-right: 21rem;
}

.odd\\:py-88:nth-child(odd){
  padding-top: 22rem;
  padding-bottom: 22rem;
}

.odd\\:px-88:nth-child(odd){
  padding-left: 22rem;
  padding-right: 22rem;
}

.odd\\:py-92:nth-child(odd){
  padding-top: 23rem;
  padding-bottom: 23rem;
}

.odd\\:px-92:nth-child(odd){
  padding-left: 23rem;
  padding-right: 23rem;
}

.odd\\:py-96:nth-child(odd){
  padding-top: 24rem;
  padding-bottom: 24rem;
}

.odd\\:px-96:nth-child(odd){
  padding-left: 24rem;
  padding-right: 24rem;
}

.odd\\:py-98:nth-child(odd){
  padding-top: 24.5rem;
  padding-bottom: 24.5rem;
}

.odd\\:px-98:nth-child(odd){
  padding-left: 24.5rem;
  padding-right: 24.5rem;
}

.odd\\:py-100:nth-child(odd){
  padding-top: 25rem;
  padding-bottom: 25rem;
}

.odd\\:px-100:nth-child(odd){
  padding-left: 25rem;
  padding-right: 25rem;
}

.odd\\:py-104:nth-child(odd){
  padding-top: 26rem;
  padding-bottom: 26rem;
}

.odd\\:px-104:nth-child(odd){
  padding-left: 26rem;
  padding-right: 26rem;
}

.odd\\:py-112:nth-child(odd){
  padding-top: 28rem;
  padding-bottom: 28rem;
}

.odd\\:px-112:nth-child(odd){
  padding-left: 28rem;
  padding-right: 28rem;
}

.odd\\:py-124:nth-child(odd){
  padding-top: 31rem;
  padding-bottom: 31rem;
}

.odd\\:px-124:nth-child(odd){
  padding-left: 31rem;
  padding-right: 31rem;
}

.odd\\:py-128:nth-child(odd){
  padding-top: 32rem;
  padding-bottom: 32rem;
}

.odd\\:px-128:nth-child(odd){
  padding-left: 32rem;
  padding-right: 32rem;
}

.odd\\:py-140:nth-child(odd){
  padding-top: 35rem;
  padding-bottom: 35rem;
}

.odd\\:px-140:nth-child(odd){
  padding-left: 35rem;
  padding-right: 35rem;
}

.odd\\:py-152:nth-child(odd){
  padding-top: 38rem;
  padding-bottom: 38rem;
}

.odd\\:px-152:nth-child(odd){
  padding-left: 38rem;
  padding-right: 38rem;
}

.odd\\:py-160:nth-child(odd){
  padding-top: 40rem;
  padding-bottom: 40rem;
}

.odd\\:px-160:nth-child(odd){
  padding-left: 40rem;
  padding-right: 40rem;
}

.odd\\:py-162:nth-child(odd){
  padding-top: 41rem;
  padding-bottom: 41rem;
}

.odd\\:px-162:nth-child(odd){
  padding-left: 41rem;
  padding-right: 41rem;
}

.odd\\:py-192:nth-child(odd){
  padding-top: 48rem;
  padding-bottom: 48rem;
}

.odd\\:px-192:nth-child(odd){
  padding-left: 48rem;
  padding-right: 48rem;
}

.odd\\:py-208:nth-child(odd){
  padding-top: 52rem;
  padding-bottom: 52rem;
}

.odd\\:px-208:nth-child(odd){
  padding-left: 52rem;
  padding-right: 52rem;
}

.odd\\:py-224:nth-child(odd){
  padding-top: 56rem;
  padding-bottom: 56rem;
}

.odd\\:px-224:nth-child(odd){
  padding-left: 56rem;
  padding-right: 56rem;
}

.odd\\:py-256:nth-child(odd){
  padding-top: 64rem;
  padding-bottom: 64rem;
}

.odd\\:px-256:nth-child(odd){
  padding-left: 64rem;
  padding-right: 64rem;
}

.odd\\:py-px:nth-child(odd){
  padding-top: 1px;
  padding-bottom: 1px;
}

.odd\\:px-px:nth-child(odd){
  padding-left: 1px;
  padding-right: 1px;
}

.odd\\:pt-0:nth-child(odd){
  padding-top: 0;
}

.odd\\:pr-0:nth-child(odd){
  padding-right: 0;
}

.odd\\:pb-0:nth-child(odd){
  padding-bottom: 0;
}

.odd\\:pl-0:nth-child(odd){
  padding-left: 0;
}

.odd\\:pt-1:nth-child(odd){
  padding-top: 0.25rem;
}

.odd\\:pr-1:nth-child(odd){
  padding-right: 0.25rem;
}

.odd\\:pb-1:nth-child(odd){
  padding-bottom: 0.25rem;
}

.odd\\:pl-1:nth-child(odd){
  padding-left: 0.25rem;
}

.odd\\:pt-2:nth-child(odd){
  padding-top: 0.5rem;
}

.odd\\:pr-2:nth-child(odd){
  padding-right: 0.5rem;
}

.odd\\:pb-2:nth-child(odd){
  padding-bottom: 0.5rem;
}

.odd\\:pl-2:nth-child(odd){
  padding-left: 0.5rem;
}

.odd\\:pt-3:nth-child(odd){
  padding-top: 0.75rem;
}

.odd\\:pr-3:nth-child(odd){
  padding-right: 0.75rem;
}

.odd\\:pb-3:nth-child(odd){
  padding-bottom: 0.75rem;
}

.odd\\:pl-3:nth-child(odd){
  padding-left: 0.75rem;
}

.odd\\:pt-4:nth-child(odd){
  padding-top: 1rem;
}

.odd\\:pr-4:nth-child(odd){
  padding-right: 1rem;
}

.odd\\:pb-4:nth-child(odd){
  padding-bottom: 1rem;
}

.odd\\:pl-4:nth-child(odd){
  padding-left: 1rem;
}

.odd\\:pt-5:nth-child(odd){
  padding-top: 1.25rem;
}

.odd\\:pr-5:nth-child(odd){
  padding-right: 1.25rem;
}

.odd\\:pb-5:nth-child(odd){
  padding-bottom: 1.25rem;
}

.odd\\:pl-5:nth-child(odd){
  padding-left: 1.25rem;
}

.odd\\:pt-6:nth-child(odd){
  padding-top: 1.5rem;
}

.odd\\:pr-6:nth-child(odd){
  padding-right: 1.5rem;
}

.odd\\:pb-6:nth-child(odd){
  padding-bottom: 1.5rem;
}

.odd\\:pl-6:nth-child(odd){
  padding-left: 1.5rem;
}

.odd\\:pt-7:nth-child(odd){
  padding-top: 1.75rem;
}

.odd\\:pr-7:nth-child(odd){
  padding-right: 1.75rem;
}

.odd\\:pb-7:nth-child(odd){
  padding-bottom: 1.75rem;
}

.odd\\:pl-7:nth-child(odd){
  padding-left: 1.75rem;
}

.odd\\:pt-8:nth-child(odd){
  padding-top: 2rem;
}

.odd\\:pr-8:nth-child(odd){
  padding-right: 2rem;
}

.odd\\:pb-8:nth-child(odd){
  padding-bottom: 2rem;
}

.odd\\:pl-8:nth-child(odd){
  padding-left: 2rem;
}

.odd\\:pt-9:nth-child(odd){
  padding-top: 2.25rem;
}

.odd\\:pr-9:nth-child(odd){
  padding-right: 2.25rem;
}

.odd\\:pb-9:nth-child(odd){
  padding-bottom: 2.25rem;
}

.odd\\:pl-9:nth-child(odd){
  padding-left: 2.25rem;
}

.odd\\:pt-10:nth-child(odd){
  padding-top: 2.5rem;
}

.odd\\:pr-10:nth-child(odd){
  padding-right: 2.5rem;
}

.odd\\:pb-10:nth-child(odd){
  padding-bottom: 2.5rem;
}

.odd\\:pl-10:nth-child(odd){
  padding-left: 2.5rem;
}

.odd\\:pt-11:nth-child(odd){
  padding-top: 2.75rem;
}

.odd\\:pr-11:nth-child(odd){
  padding-right: 2.75rem;
}

.odd\\:pb-11:nth-child(odd){
  padding-bottom: 2.75rem;
}

.odd\\:pl-11:nth-child(odd){
  padding-left: 2.75rem;
}

.odd\\:pt-12:nth-child(odd){
  padding-top: 3rem;
}

.odd\\:pr-12:nth-child(odd){
  padding-right: 3rem;
}

.odd\\:pb-12:nth-child(odd){
  padding-bottom: 3rem;
}

.odd\\:pl-12:nth-child(odd){
  padding-left: 3rem;
}

.odd\\:pt-14:nth-child(odd){
  padding-top: 3.5rem;
}

.odd\\:pr-14:nth-child(odd){
  padding-right: 3.5rem;
}

.odd\\:pb-14:nth-child(odd){
  padding-bottom: 3.5rem;
}

.odd\\:pl-14:nth-child(odd){
  padding-left: 3.5rem;
}

.odd\\:pt-15:nth-child(odd){
  padding-top: 3.75rem;
}

.odd\\:pr-15:nth-child(odd){
  padding-right: 3.75rem;
}

.odd\\:pb-15:nth-child(odd){
  padding-bottom: 3.75rem;
}

.odd\\:pl-15:nth-child(odd){
  padding-left: 3.75rem;
}

.odd\\:pt-16:nth-child(odd){
  padding-top: 4rem;
}

.odd\\:pr-16:nth-child(odd){
  padding-right: 4rem;
}

.odd\\:pb-16:nth-child(odd){
  padding-bottom: 4rem;
}

.odd\\:pl-16:nth-child(odd){
  padding-left: 4rem;
}

.odd\\:pt-18:nth-child(odd){
  padding-top: 4.5rem;
}

.odd\\:pr-18:nth-child(odd){
  padding-right: 4.5rem;
}

.odd\\:pb-18:nth-child(odd){
  padding-bottom: 4.5rem;
}

.odd\\:pl-18:nth-child(odd){
  padding-left: 4.5rem;
}

.odd\\:pt-20:nth-child(odd){
  padding-top: 5rem;
}

.odd\\:pr-20:nth-child(odd){
  padding-right: 5rem;
}

.odd\\:pb-20:nth-child(odd){
  padding-bottom: 5rem;
}

.odd\\:pl-20:nth-child(odd){
  padding-left: 5rem;
}

.odd\\:pt-22:nth-child(odd){
  padding-top: 5.5rem;
}

.odd\\:pr-22:nth-child(odd){
  padding-right: 5.5rem;
}

.odd\\:pb-22:nth-child(odd){
  padding-bottom: 5.5rem;
}

.odd\\:pl-22:nth-child(odd){
  padding-left: 5.5rem;
}

.odd\\:pt-23:nth-child(odd){
  padding-top: 5.75rem;
}

.odd\\:pr-23:nth-child(odd){
  padding-right: 5.75rem;
}

.odd\\:pb-23:nth-child(odd){
  padding-bottom: 5.75rem;
}

.odd\\:pl-23:nth-child(odd){
  padding-left: 5.75rem;
}

.odd\\:pt-24:nth-child(odd){
  padding-top: 6rem;
}

.odd\\:pr-24:nth-child(odd){
  padding-right: 6rem;
}

.odd\\:pb-24:nth-child(odd){
  padding-bottom: 6rem;
}

.odd\\:pl-24:nth-child(odd){
  padding-left: 6rem;
}

.odd\\:pt-25:nth-child(odd){
  padding-top: 6.25rem;
}

.odd\\:pr-25:nth-child(odd){
  padding-right: 6.25rem;
}

.odd\\:pb-25:nth-child(odd){
  padding-bottom: 6.25rem;
}

.odd\\:pl-25:nth-child(odd){
  padding-left: 6.25rem;
}

.odd\\:pt-26:nth-child(odd){
  padding-top: 6.5rem;
}

.odd\\:pr-26:nth-child(odd){
  padding-right: 6.5rem;
}

.odd\\:pb-26:nth-child(odd){
  padding-bottom: 6.5rem;
}

.odd\\:pl-26:nth-child(odd){
  padding-left: 6.5rem;
}

.odd\\:pt-28:nth-child(odd){
  padding-top: 7rem;
}

.odd\\:pr-28:nth-child(odd){
  padding-right: 7rem;
}

.odd\\:pb-28:nth-child(odd){
  padding-bottom: 7rem;
}

.odd\\:pl-28:nth-child(odd){
  padding-left: 7rem;
}

.odd\\:pt-30:nth-child(odd){
  padding-top: 7.5rem;
}

.odd\\:pr-30:nth-child(odd){
  padding-right: 7.5rem;
}

.odd\\:pb-30:nth-child(odd){
  padding-bottom: 7.5rem;
}

.odd\\:pl-30:nth-child(odd){
  padding-left: 7.5rem;
}

.odd\\:pt-32:nth-child(odd){
  padding-top: 8rem;
}

.odd\\:pr-32:nth-child(odd){
  padding-right: 8rem;
}

.odd\\:pb-32:nth-child(odd){
  padding-bottom: 8rem;
}

.odd\\:pl-32:nth-child(odd){
  padding-left: 8rem;
}

.odd\\:pt-34:nth-child(odd){
  padding-top: 8.5rem;
}

.odd\\:pr-34:nth-child(odd){
  padding-right: 8.5rem;
}

.odd\\:pb-34:nth-child(odd){
  padding-bottom: 8.5rem;
}

.odd\\:pl-34:nth-child(odd){
  padding-left: 8.5rem;
}

.odd\\:pt-40:nth-child(odd){
  padding-top: 10rem;
}

.odd\\:pr-40:nth-child(odd){
  padding-right: 10rem;
}

.odd\\:pb-40:nth-child(odd){
  padding-bottom: 10rem;
}

.odd\\:pl-40:nth-child(odd){
  padding-left: 10rem;
}

.odd\\:pt-42:nth-child(odd){
  padding-top: 10.5rem;
}

.odd\\:pr-42:nth-child(odd){
  padding-right: 10.5rem;
}

.odd\\:pb-42:nth-child(odd){
  padding-bottom: 10.5rem;
}

.odd\\:pl-42:nth-child(odd){
  padding-left: 10.5rem;
}

.odd\\:pt-44:nth-child(odd){
  padding-top: 11rem;
}

.odd\\:pr-44:nth-child(odd){
  padding-right: 11rem;
}

.odd\\:pb-44:nth-child(odd){
  padding-bottom: 11rem;
}

.odd\\:pl-44:nth-child(odd){
  padding-left: 11rem;
}

.odd\\:pt-48:nth-child(odd){
  padding-top: 12rem;
}

.odd\\:pr-48:nth-child(odd){
  padding-right: 12rem;
}

.odd\\:pb-48:nth-child(odd){
  padding-bottom: 12rem;
}

.odd\\:pl-48:nth-child(odd){
  padding-left: 12rem;
}

.odd\\:pt-52:nth-child(odd){
  padding-top: 13rem;
}

.odd\\:pr-52:nth-child(odd){
  padding-right: 13rem;
}

.odd\\:pb-52:nth-child(odd){
  padding-bottom: 13rem;
}

.odd\\:pl-52:nth-child(odd){
  padding-left: 13rem;
}

.odd\\:pt-54:nth-child(odd){
  padding-top: 13.5rem;
}

.odd\\:pr-54:nth-child(odd){
  padding-right: 13.5rem;
}

.odd\\:pb-54:nth-child(odd){
  padding-bottom: 13.5rem;
}

.odd\\:pl-54:nth-child(odd){
  padding-left: 13.5rem;
}

.odd\\:pt-56:nth-child(odd){
  padding-top: 14rem;
}

.odd\\:pr-56:nth-child(odd){
  padding-right: 14rem;
}

.odd\\:pb-56:nth-child(odd){
  padding-bottom: 14rem;
}

.odd\\:pl-56:nth-child(odd){
  padding-left: 14rem;
}

.odd\\:pt-60:nth-child(odd){
  padding-top: 15rem;
}

.odd\\:pr-60:nth-child(odd){
  padding-right: 15rem;
}

.odd\\:pb-60:nth-child(odd){
  padding-bottom: 15rem;
}

.odd\\:pl-60:nth-child(odd){
  padding-left: 15rem;
}

.odd\\:pt-64:nth-child(odd){
  padding-top: 16rem;
}

.odd\\:pr-64:nth-child(odd){
  padding-right: 16rem;
}

.odd\\:pb-64:nth-child(odd){
  padding-bottom: 16rem;
}

.odd\\:pl-64:nth-child(odd){
  padding-left: 16rem;
}

.odd\\:pt-68:nth-child(odd){
  padding-top: 17rem;
}

.odd\\:pr-68:nth-child(odd){
  padding-right: 17rem;
}

.odd\\:pb-68:nth-child(odd){
  padding-bottom: 17rem;
}

.odd\\:pl-68:nth-child(odd){
  padding-left: 17rem;
}

.odd\\:pt-72:nth-child(odd){
  padding-top: 18rem;
}

.odd\\:pr-72:nth-child(odd){
  padding-right: 18rem;
}

.odd\\:pb-72:nth-child(odd){
  padding-bottom: 18rem;
}

.odd\\:pl-72:nth-child(odd){
  padding-left: 18rem;
}

.odd\\:pt-74:nth-child(odd){
  padding-top: 18.5rem;
}

.odd\\:pr-74:nth-child(odd){
  padding-right: 18.5rem;
}

.odd\\:pb-74:nth-child(odd){
  padding-bottom: 18.5rem;
}

.odd\\:pl-74:nth-child(odd){
  padding-left: 18.5rem;
}

.odd\\:pt-76:nth-child(odd){
  padding-top: 19rem;
}

.odd\\:pr-76:nth-child(odd){
  padding-right: 19rem;
}

.odd\\:pb-76:nth-child(odd){
  padding-bottom: 19rem;
}

.odd\\:pl-76:nth-child(odd){
  padding-left: 19rem;
}

.odd\\:pt-78:nth-child(odd){
  padding-top: 19.5rem;
}

.odd\\:pr-78:nth-child(odd){
  padding-right: 19.5rem;
}

.odd\\:pb-78:nth-child(odd){
  padding-bottom: 19.5rem;
}

.odd\\:pl-78:nth-child(odd){
  padding-left: 19.5rem;
}

.odd\\:pt-80:nth-child(odd){
  padding-top: 20rem;
}

.odd\\:pr-80:nth-child(odd){
  padding-right: 20rem;
}

.odd\\:pb-80:nth-child(odd){
  padding-bottom: 20rem;
}

.odd\\:pl-80:nth-child(odd){
  padding-left: 20rem;
}

.odd\\:pt-82:nth-child(odd){
  padding-top: 20.5rem;
}

.odd\\:pr-82:nth-child(odd){
  padding-right: 20.5rem;
}

.odd\\:pb-82:nth-child(odd){
  padding-bottom: 20.5rem;
}

.odd\\:pl-82:nth-child(odd){
  padding-left: 20.5rem;
}

.odd\\:pt-84:nth-child(odd){
  padding-top: 21rem;
}

.odd\\:pr-84:nth-child(odd){
  padding-right: 21rem;
}

.odd\\:pb-84:nth-child(odd){
  padding-bottom: 21rem;
}

.odd\\:pl-84:nth-child(odd){
  padding-left: 21rem;
}

.odd\\:pt-88:nth-child(odd){
  padding-top: 22rem;
}

.odd\\:pr-88:nth-child(odd){
  padding-right: 22rem;
}

.odd\\:pb-88:nth-child(odd){
  padding-bottom: 22rem;
}

.odd\\:pl-88:nth-child(odd){
  padding-left: 22rem;
}

.odd\\:pt-92:nth-child(odd){
  padding-top: 23rem;
}

.odd\\:pr-92:nth-child(odd){
  padding-right: 23rem;
}

.odd\\:pb-92:nth-child(odd){
  padding-bottom: 23rem;
}

.odd\\:pl-92:nth-child(odd){
  padding-left: 23rem;
}

.odd\\:pt-96:nth-child(odd){
  padding-top: 24rem;
}

.odd\\:pr-96:nth-child(odd){
  padding-right: 24rem;
}

.odd\\:pb-96:nth-child(odd){
  padding-bottom: 24rem;
}

.odd\\:pl-96:nth-child(odd){
  padding-left: 24rem;
}

.odd\\:pt-98:nth-child(odd){
  padding-top: 24.5rem;
}

.odd\\:pr-98:nth-child(odd){
  padding-right: 24.5rem;
}

.odd\\:pb-98:nth-child(odd){
  padding-bottom: 24.5rem;
}

.odd\\:pl-98:nth-child(odd){
  padding-left: 24.5rem;
}

.odd\\:pt-100:nth-child(odd){
  padding-top: 25rem;
}

.odd\\:pr-100:nth-child(odd){
  padding-right: 25rem;
}

.odd\\:pb-100:nth-child(odd){
  padding-bottom: 25rem;
}

.odd\\:pl-100:nth-child(odd){
  padding-left: 25rem;
}

.odd\\:pt-104:nth-child(odd){
  padding-top: 26rem;
}

.odd\\:pr-104:nth-child(odd){
  padding-right: 26rem;
}

.odd\\:pb-104:nth-child(odd){
  padding-bottom: 26rem;
}

.odd\\:pl-104:nth-child(odd){
  padding-left: 26rem;
}

.odd\\:pt-112:nth-child(odd){
  padding-top: 28rem;
}

.odd\\:pr-112:nth-child(odd){
  padding-right: 28rem;
}

.odd\\:pb-112:nth-child(odd){
  padding-bottom: 28rem;
}

.odd\\:pl-112:nth-child(odd){
  padding-left: 28rem;
}

.odd\\:pt-124:nth-child(odd){
  padding-top: 31rem;
}

.odd\\:pr-124:nth-child(odd){
  padding-right: 31rem;
}

.odd\\:pb-124:nth-child(odd){
  padding-bottom: 31rem;
}

.odd\\:pl-124:nth-child(odd){
  padding-left: 31rem;
}

.odd\\:pt-128:nth-child(odd){
  padding-top: 32rem;
}

.odd\\:pr-128:nth-child(odd){
  padding-right: 32rem;
}

.odd\\:pb-128:nth-child(odd){
  padding-bottom: 32rem;
}

.odd\\:pl-128:nth-child(odd){
  padding-left: 32rem;
}

.odd\\:pt-140:nth-child(odd){
  padding-top: 35rem;
}

.odd\\:pr-140:nth-child(odd){
  padding-right: 35rem;
}

.odd\\:pb-140:nth-child(odd){
  padding-bottom: 35rem;
}

.odd\\:pl-140:nth-child(odd){
  padding-left: 35rem;
}

.odd\\:pt-152:nth-child(odd){
  padding-top: 38rem;
}

.odd\\:pr-152:nth-child(odd){
  padding-right: 38rem;
}

.odd\\:pb-152:nth-child(odd){
  padding-bottom: 38rem;
}

.odd\\:pl-152:nth-child(odd){
  padding-left: 38rem;
}

.odd\\:pt-160:nth-child(odd){
  padding-top: 40rem;
}

.odd\\:pr-160:nth-child(odd){
  padding-right: 40rem;
}

.odd\\:pb-160:nth-child(odd){
  padding-bottom: 40rem;
}

.odd\\:pl-160:nth-child(odd){
  padding-left: 40rem;
}

.odd\\:pt-162:nth-child(odd){
  padding-top: 41rem;
}

.odd\\:pr-162:nth-child(odd){
  padding-right: 41rem;
}

.odd\\:pb-162:nth-child(odd){
  padding-bottom: 41rem;
}

.odd\\:pl-162:nth-child(odd){
  padding-left: 41rem;
}

.odd\\:pt-192:nth-child(odd){
  padding-top: 48rem;
}

.odd\\:pr-192:nth-child(odd){
  padding-right: 48rem;
}

.odd\\:pb-192:nth-child(odd){
  padding-bottom: 48rem;
}

.odd\\:pl-192:nth-child(odd){
  padding-left: 48rem;
}

.odd\\:pt-208:nth-child(odd){
  padding-top: 52rem;
}

.odd\\:pr-208:nth-child(odd){
  padding-right: 52rem;
}

.odd\\:pb-208:nth-child(odd){
  padding-bottom: 52rem;
}

.odd\\:pl-208:nth-child(odd){
  padding-left: 52rem;
}

.odd\\:pt-224:nth-child(odd){
  padding-top: 56rem;
}

.odd\\:pr-224:nth-child(odd){
  padding-right: 56rem;
}

.odd\\:pb-224:nth-child(odd){
  padding-bottom: 56rem;
}

.odd\\:pl-224:nth-child(odd){
  padding-left: 56rem;
}

.odd\\:pt-256:nth-child(odd){
  padding-top: 64rem;
}

.odd\\:pr-256:nth-child(odd){
  padding-right: 64rem;
}

.odd\\:pb-256:nth-child(odd){
  padding-bottom: 64rem;
}

.odd\\:pl-256:nth-child(odd){
  padding-left: 64rem;
}

.odd\\:pt-px:nth-child(odd){
  padding-top: 1px;
}

.odd\\:pr-px:nth-child(odd){
  padding-right: 1px;
}

.odd\\:pb-px:nth-child(odd){
  padding-bottom: 1px;
}

.odd\\:pl-px:nth-child(odd){
  padding-left: 1px;
}

.even\\:p-0:nth-child(even){
  padding: 0;
}

.even\\:p-1:nth-child(even){
  padding: 0.25rem;
}

.even\\:p-2:nth-child(even){
  padding: 0.5rem;
}

.even\\:p-3:nth-child(even){
  padding: 0.75rem;
}

.even\\:p-4:nth-child(even){
  padding: 1rem;
}

.even\\:p-5:nth-child(even){
  padding: 1.25rem;
}

.even\\:p-6:nth-child(even){
  padding: 1.5rem;
}

.even\\:p-7:nth-child(even){
  padding: 1.75rem;
}

.even\\:p-8:nth-child(even){
  padding: 2rem;
}

.even\\:p-9:nth-child(even){
  padding: 2.25rem;
}

.even\\:p-10:nth-child(even){
  padding: 2.5rem;
}

.even\\:p-11:nth-child(even){
  padding: 2.75rem;
}

.even\\:p-12:nth-child(even){
  padding: 3rem;
}

.even\\:p-14:nth-child(even){
  padding: 3.5rem;
}

.even\\:p-15:nth-child(even){
  padding: 3.75rem;
}

.even\\:p-16:nth-child(even){
  padding: 4rem;
}

.even\\:p-18:nth-child(even){
  padding: 4.5rem;
}

.even\\:p-20:nth-child(even){
  padding: 5rem;
}

.even\\:p-22:nth-child(even){
  padding: 5.5rem;
}

.even\\:p-23:nth-child(even){
  padding: 5.75rem;
}

.even\\:p-24:nth-child(even){
  padding: 6rem;
}

.even\\:p-25:nth-child(even){
  padding: 6.25rem;
}

.even\\:p-26:nth-child(even){
  padding: 6.5rem;
}

.even\\:p-28:nth-child(even){
  padding: 7rem;
}

.even\\:p-30:nth-child(even){
  padding: 7.5rem;
}

.even\\:p-32:nth-child(even){
  padding: 8rem;
}

.even\\:p-34:nth-child(even){
  padding: 8.5rem;
}

.even\\:p-40:nth-child(even){
  padding: 10rem;
}

.even\\:p-42:nth-child(even){
  padding: 10.5rem;
}

.even\\:p-44:nth-child(even){
  padding: 11rem;
}

.even\\:p-48:nth-child(even){
  padding: 12rem;
}

.even\\:p-52:nth-child(even){
  padding: 13rem;
}

.even\\:p-54:nth-child(even){
  padding: 13.5rem;
}

.even\\:p-56:nth-child(even){
  padding: 14rem;
}

.even\\:p-60:nth-child(even){
  padding: 15rem;
}

.even\\:p-64:nth-child(even){
  padding: 16rem;
}

.even\\:p-68:nth-child(even){
  padding: 17rem;
}

.even\\:p-72:nth-child(even){
  padding: 18rem;
}

.even\\:p-74:nth-child(even){
  padding: 18.5rem;
}

.even\\:p-76:nth-child(even){
  padding: 19rem;
}

.even\\:p-78:nth-child(even){
  padding: 19.5rem;
}

.even\\:p-80:nth-child(even){
  padding: 20rem;
}

.even\\:p-82:nth-child(even){
  padding: 20.5rem;
}

.even\\:p-84:nth-child(even){
  padding: 21rem;
}

.even\\:p-88:nth-child(even){
  padding: 22rem;
}

.even\\:p-92:nth-child(even){
  padding: 23rem;
}

.even\\:p-96:nth-child(even){
  padding: 24rem;
}

.even\\:p-98:nth-child(even){
  padding: 24.5rem;
}

.even\\:p-100:nth-child(even){
  padding: 25rem;
}

.even\\:p-104:nth-child(even){
  padding: 26rem;
}

.even\\:p-112:nth-child(even){
  padding: 28rem;
}

.even\\:p-124:nth-child(even){
  padding: 31rem;
}

.even\\:p-128:nth-child(even){
  padding: 32rem;
}

.even\\:p-140:nth-child(even){
  padding: 35rem;
}

.even\\:p-152:nth-child(even){
  padding: 38rem;
}

.even\\:p-160:nth-child(even){
  padding: 40rem;
}

.even\\:p-162:nth-child(even){
  padding: 41rem;
}

.even\\:p-192:nth-child(even){
  padding: 48rem;
}

.even\\:p-208:nth-child(even){
  padding: 52rem;
}

.even\\:p-224:nth-child(even){
  padding: 56rem;
}

.even\\:p-256:nth-child(even){
  padding: 64rem;
}

.even\\:p-px:nth-child(even){
  padding: 1px;
}

.even\\:py-0:nth-child(even){
  padding-top: 0;
  padding-bottom: 0;
}

.even\\:px-0:nth-child(even){
  padding-left: 0;
  padding-right: 0;
}

.even\\:py-1:nth-child(even){
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.even\\:px-1:nth-child(even){
  padding-left: 0.25rem;
  padding-right: 0.25rem;
}

.even\\:py-2:nth-child(even){
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.even\\:px-2:nth-child(even){
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.even\\:py-3:nth-child(even){
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.even\\:px-3:nth-child(even){
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}

.even\\:py-4:nth-child(even){
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.even\\:px-4:nth-child(even){
  padding-left: 1rem;
  padding-right: 1rem;
}

.even\\:py-5:nth-child(even){
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}

.even\\:px-5:nth-child(even){
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}

.even\\:py-6:nth-child(even){
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.even\\:px-6:nth-child(even){
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.even\\:py-7:nth-child(even){
  padding-top: 1.75rem;
  padding-bottom: 1.75rem;
}

.even\\:px-7:nth-child(even){
  padding-left: 1.75rem;
  padding-right: 1.75rem;
}

.even\\:py-8:nth-child(even){
  padding-top: 2rem;
  padding-bottom: 2rem;
}

.even\\:px-8:nth-child(even){
  padding-left: 2rem;
  padding-right: 2rem;
}

.even\\:py-9:nth-child(even){
  padding-top: 2.25rem;
  padding-bottom: 2.25rem;
}

.even\\:px-9:nth-child(even){
  padding-left: 2.25rem;
  padding-right: 2.25rem;
}

.even\\:py-10:nth-child(even){
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}

.even\\:px-10:nth-child(even){
  padding-left: 2.5rem;
  padding-right: 2.5rem;
}

.even\\:py-11:nth-child(even){
  padding-top: 2.75rem;
  padding-bottom: 2.75rem;
}

.even\\:px-11:nth-child(even){
  padding-left: 2.75rem;
  padding-right: 2.75rem;
}

.even\\:py-12:nth-child(even){
  padding-top: 3rem;
  padding-bottom: 3rem;
}

.even\\:px-12:nth-child(even){
  padding-left: 3rem;
  padding-right: 3rem;
}

.even\\:py-14:nth-child(even){
  padding-top: 3.5rem;
  padding-bottom: 3.5rem;
}

.even\\:px-14:nth-child(even){
  padding-left: 3.5rem;
  padding-right: 3.5rem;
}

.even\\:py-15:nth-child(even){
  padding-top: 3.75rem;
  padding-bottom: 3.75rem;
}

.even\\:px-15:nth-child(even){
  padding-left: 3.75rem;
  padding-right: 3.75rem;
}

.even\\:py-16:nth-child(even){
  padding-top: 4rem;
  padding-bottom: 4rem;
}

.even\\:px-16:nth-child(even){
  padding-left: 4rem;
  padding-right: 4rem;
}

.even\\:py-18:nth-child(even){
  padding-top: 4.5rem;
  padding-bottom: 4.5rem;
}

.even\\:px-18:nth-child(even){
  padding-left: 4.5rem;
  padding-right: 4.5rem;
}

.even\\:py-20:nth-child(even){
  padding-top: 5rem;
  padding-bottom: 5rem;
}

.even\\:px-20:nth-child(even){
  padding-left: 5rem;
  padding-right: 5rem;
}

.even\\:py-22:nth-child(even){
  padding-top: 5.5rem;
  padding-bottom: 5.5rem;
}

.even\\:px-22:nth-child(even){
  padding-left: 5.5rem;
  padding-right: 5.5rem;
}

.even\\:py-23:nth-child(even){
  padding-top: 5.75rem;
  padding-bottom: 5.75rem;
}

.even\\:px-23:nth-child(even){
  padding-left: 5.75rem;
  padding-right: 5.75rem;
}

.even\\:py-24:nth-child(even){
  padding-top: 6rem;
  padding-bottom: 6rem;
}

.even\\:px-24:nth-child(even){
  padding-left: 6rem;
  padding-right: 6rem;
}

.even\\:py-25:nth-child(even){
  padding-top: 6.25rem;
  padding-bottom: 6.25rem;
}

.even\\:px-25:nth-child(even){
  padding-left: 6.25rem;
  padding-right: 6.25rem;
}

.even\\:py-26:nth-child(even){
  padding-top: 6.5rem;
  padding-bottom: 6.5rem;
}

.even\\:px-26:nth-child(even){
  padding-left: 6.5rem;
  padding-right: 6.5rem;
}

.even\\:py-28:nth-child(even){
  padding-top: 7rem;
  padding-bottom: 7rem;
}

.even\\:px-28:nth-child(even){
  padding-left: 7rem;
  padding-right: 7rem;
}

.even\\:py-30:nth-child(even){
  padding-top: 7.5rem;
  padding-bottom: 7.5rem;
}

.even\\:px-30:nth-child(even){
  padding-left: 7.5rem;
  padding-right: 7.5rem;
}

.even\\:py-32:nth-child(even){
  padding-top: 8rem;
  padding-bottom: 8rem;
}

.even\\:px-32:nth-child(even){
  padding-left: 8rem;
  padding-right: 8rem;
}

.even\\:py-34:nth-child(even){
  padding-top: 8.5rem;
  padding-bottom: 8.5rem;
}

.even\\:px-34:nth-child(even){
  padding-left: 8.5rem;
  padding-right: 8.5rem;
}

.even\\:py-40:nth-child(even){
  padding-top: 10rem;
  padding-bottom: 10rem;
}

.even\\:px-40:nth-child(even){
  padding-left: 10rem;
  padding-right: 10rem;
}

.even\\:py-42:nth-child(even){
  padding-top: 10.5rem;
  padding-bottom: 10.5rem;
}

.even\\:px-42:nth-child(even){
  padding-left: 10.5rem;
  padding-right: 10.5rem;
}

.even\\:py-44:nth-child(even){
  padding-top: 11rem;
  padding-bottom: 11rem;
}

.even\\:px-44:nth-child(even){
  padding-left: 11rem;
  padding-right: 11rem;
}

.even\\:py-48:nth-child(even){
  padding-top: 12rem;
  padding-bottom: 12rem;
}

.even\\:px-48:nth-child(even){
  padding-left: 12rem;
  padding-right: 12rem;
}

.even\\:py-52:nth-child(even){
  padding-top: 13rem;
  padding-bottom: 13rem;
}

.even\\:px-52:nth-child(even){
  padding-left: 13rem;
  padding-right: 13rem;
}

.even\\:py-54:nth-child(even){
  padding-top: 13.5rem;
  padding-bottom: 13.5rem;
}

.even\\:px-54:nth-child(even){
  padding-left: 13.5rem;
  padding-right: 13.5rem;
}

.even\\:py-56:nth-child(even){
  padding-top: 14rem;
  padding-bottom: 14rem;
}

.even\\:px-56:nth-child(even){
  padding-left: 14rem;
  padding-right: 14rem;
}

.even\\:py-60:nth-child(even){
  padding-top: 15rem;
  padding-bottom: 15rem;
}

.even\\:px-60:nth-child(even){
  padding-left: 15rem;
  padding-right: 15rem;
}

.even\\:py-64:nth-child(even){
  padding-top: 16rem;
  padding-bottom: 16rem;
}

.even\\:px-64:nth-child(even){
  padding-left: 16rem;
  padding-right: 16rem;
}

.even\\:py-68:nth-child(even){
  padding-top: 17rem;
  padding-bottom: 17rem;
}

.even\\:px-68:nth-child(even){
  padding-left: 17rem;
  padding-right: 17rem;
}

.even\\:py-72:nth-child(even){
  padding-top: 18rem;
  padding-bottom: 18rem;
}

.even\\:px-72:nth-child(even){
  padding-left: 18rem;
  padding-right: 18rem;
}

.even\\:py-74:nth-child(even){
  padding-top: 18.5rem;
  padding-bottom: 18.5rem;
}

.even\\:px-74:nth-child(even){
  padding-left: 18.5rem;
  padding-right: 18.5rem;
}

.even\\:py-76:nth-child(even){
  padding-top: 19rem;
  padding-bottom: 19rem;
}

.even\\:px-76:nth-child(even){
  padding-left: 19rem;
  padding-right: 19rem;
}

.even\\:py-78:nth-child(even){
  padding-top: 19.5rem;
  padding-bottom: 19.5rem;
}

.even\\:px-78:nth-child(even){
  padding-left: 19.5rem;
  padding-right: 19.5rem;
}

.even\\:py-80:nth-child(even){
  padding-top: 20rem;
  padding-bottom: 20rem;
}

.even\\:px-80:nth-child(even){
  padding-left: 20rem;
  padding-right: 20rem;
}

.even\\:py-82:nth-child(even){
  padding-top: 20.5rem;
  padding-bottom: 20.5rem;
}

.even\\:px-82:nth-child(even){
  padding-left: 20.5rem;
  padding-right: 20.5rem;
}

.even\\:py-84:nth-child(even){
  padding-top: 21rem;
  padding-bottom: 21rem;
}

.even\\:px-84:nth-child(even){
  padding-left: 21rem;
  padding-right: 21rem;
}

.even\\:py-88:nth-child(even){
  padding-top: 22rem;
  padding-bottom: 22rem;
}

.even\\:px-88:nth-child(even){
  padding-left: 22rem;
  padding-right: 22rem;
}

.even\\:py-92:nth-child(even){
  padding-top: 23rem;
  padding-bottom: 23rem;
}

.even\\:px-92:nth-child(even){
  padding-left: 23rem;
  padding-right: 23rem;
}

.even\\:py-96:nth-child(even){
  padding-top: 24rem;
  padding-bottom: 24rem;
}

.even\\:px-96:nth-child(even){
  padding-left: 24rem;
  padding-right: 24rem;
}

.even\\:py-98:nth-child(even){
  padding-top: 24.5rem;
  padding-bottom: 24.5rem;
}

.even\\:px-98:nth-child(even){
  padding-left: 24.5rem;
  padding-right: 24.5rem;
}

.even\\:py-100:nth-child(even){
  padding-top: 25rem;
  padding-bottom: 25rem;
}

.even\\:px-100:nth-child(even){
  padding-left: 25rem;
  padding-right: 25rem;
}

.even\\:py-104:nth-child(even){
  padding-top: 26rem;
  padding-bottom: 26rem;
}

.even\\:px-104:nth-child(even){
  padding-left: 26rem;
  padding-right: 26rem;
}

.even\\:py-112:nth-child(even){
  padding-top: 28rem;
  padding-bottom: 28rem;
}

.even\\:px-112:nth-child(even){
  padding-left: 28rem;
  padding-right: 28rem;
}

.even\\:py-124:nth-child(even){
  padding-top: 31rem;
  padding-bottom: 31rem;
}

.even\\:px-124:nth-child(even){
  padding-left: 31rem;
  padding-right: 31rem;
}

.even\\:py-128:nth-child(even){
  padding-top: 32rem;
  padding-bottom: 32rem;
}

.even\\:px-128:nth-child(even){
  padding-left: 32rem;
  padding-right: 32rem;
}

.even\\:py-140:nth-child(even){
  padding-top: 35rem;
  padding-bottom: 35rem;
}

.even\\:px-140:nth-child(even){
  padding-left: 35rem;
  padding-right: 35rem;
}

.even\\:py-152:nth-child(even){
  padding-top: 38rem;
  padding-bottom: 38rem;
}

.even\\:px-152:nth-child(even){
  padding-left: 38rem;
  padding-right: 38rem;
}

.even\\:py-160:nth-child(even){
  padding-top: 40rem;
  padding-bottom: 40rem;
}

.even\\:px-160:nth-child(even){
  padding-left: 40rem;
  padding-right: 40rem;
}

.even\\:py-162:nth-child(even){
  padding-top: 41rem;
  padding-bottom: 41rem;
}

.even\\:px-162:nth-child(even){
  padding-left: 41rem;
  padding-right: 41rem;
}

.even\\:py-192:nth-child(even){
  padding-top: 48rem;
  padding-bottom: 48rem;
}

.even\\:px-192:nth-child(even){
  padding-left: 48rem;
  padding-right: 48rem;
}

.even\\:py-208:nth-child(even){
  padding-top: 52rem;
  padding-bottom: 52rem;
}

.even\\:px-208:nth-child(even){
  padding-left: 52rem;
  padding-right: 52rem;
}

.even\\:py-224:nth-child(even){
  padding-top: 56rem;
  padding-bottom: 56rem;
}

.even\\:px-224:nth-child(even){
  padding-left: 56rem;
  padding-right: 56rem;
}

.even\\:py-256:nth-child(even){
  padding-top: 64rem;
  padding-bottom: 64rem;
}

.even\\:px-256:nth-child(even){
  padding-left: 64rem;
  padding-right: 64rem;
}

.even\\:py-px:nth-child(even){
  padding-top: 1px;
  padding-bottom: 1px;
}

.even\\:px-px:nth-child(even){
  padding-left: 1px;
  padding-right: 1px;
}

.even\\:pt-0:nth-child(even){
  padding-top: 0;
}

.even\\:pr-0:nth-child(even){
  padding-right: 0;
}

.even\\:pb-0:nth-child(even){
  padding-bottom: 0;
}

.even\\:pl-0:nth-child(even){
  padding-left: 0;
}

.even\\:pt-1:nth-child(even){
  padding-top: 0.25rem;
}

.even\\:pr-1:nth-child(even){
  padding-right: 0.25rem;
}

.even\\:pb-1:nth-child(even){
  padding-bottom: 0.25rem;
}

.even\\:pl-1:nth-child(even){
  padding-left: 0.25rem;
}

.even\\:pt-2:nth-child(even){
  padding-top: 0.5rem;
}

.even\\:pr-2:nth-child(even){
  padding-right: 0.5rem;
}

.even\\:pb-2:nth-child(even){
  padding-bottom: 0.5rem;
}

.even\\:pl-2:nth-child(even){
  padding-left: 0.5rem;
}

.even\\:pt-3:nth-child(even){
  padding-top: 0.75rem;
}

.even\\:pr-3:nth-child(even){
  padding-right: 0.75rem;
}

.even\\:pb-3:nth-child(even){
  padding-bottom: 0.75rem;
}

.even\\:pl-3:nth-child(even){
  padding-left: 0.75rem;
}

.even\\:pt-4:nth-child(even){
  padding-top: 1rem;
}

.even\\:pr-4:nth-child(even){
  padding-right: 1rem;
}

.even\\:pb-4:nth-child(even){
  padding-bottom: 1rem;
}

.even\\:pl-4:nth-child(even){
  padding-left: 1rem;
}

.even\\:pt-5:nth-child(even){
  padding-top: 1.25rem;
}

.even\\:pr-5:nth-child(even){
  padding-right: 1.25rem;
}

.even\\:pb-5:nth-child(even){
  padding-bottom: 1.25rem;
}

.even\\:pl-5:nth-child(even){
  padding-left: 1.25rem;
}

.even\\:pt-6:nth-child(even){
  padding-top: 1.5rem;
}

.even\\:pr-6:nth-child(even){
  padding-right: 1.5rem;
}

.even\\:pb-6:nth-child(even){
  padding-bottom: 1.5rem;
}

.even\\:pl-6:nth-child(even){
  padding-left: 1.5rem;
}

.even\\:pt-7:nth-child(even){
  padding-top: 1.75rem;
}

.even\\:pr-7:nth-child(even){
  padding-right: 1.75rem;
}

.even\\:pb-7:nth-child(even){
  padding-bottom: 1.75rem;
}

.even\\:pl-7:nth-child(even){
  padding-left: 1.75rem;
}

.even\\:pt-8:nth-child(even){
  padding-top: 2rem;
}

.even\\:pr-8:nth-child(even){
  padding-right: 2rem;
}

.even\\:pb-8:nth-child(even){
  padding-bottom: 2rem;
}

.even\\:pl-8:nth-child(even){
  padding-left: 2rem;
}

.even\\:pt-9:nth-child(even){
  padding-top: 2.25rem;
}

.even\\:pr-9:nth-child(even){
  padding-right: 2.25rem;
}

.even\\:pb-9:nth-child(even){
  padding-bottom: 2.25rem;
}

.even\\:pl-9:nth-child(even){
  padding-left: 2.25rem;
}

.even\\:pt-10:nth-child(even){
  padding-top: 2.5rem;
}

.even\\:pr-10:nth-child(even){
  padding-right: 2.5rem;
}

.even\\:pb-10:nth-child(even){
  padding-bottom: 2.5rem;
}

.even\\:pl-10:nth-child(even){
  padding-left: 2.5rem;
}

.even\\:pt-11:nth-child(even){
  padding-top: 2.75rem;
}

.even\\:pr-11:nth-child(even){
  padding-right: 2.75rem;
}

.even\\:pb-11:nth-child(even){
  padding-bottom: 2.75rem;
}

.even\\:pl-11:nth-child(even){
  padding-left: 2.75rem;
}

.even\\:pt-12:nth-child(even){
  padding-top: 3rem;
}

.even\\:pr-12:nth-child(even){
  padding-right: 3rem;
}

.even\\:pb-12:nth-child(even){
  padding-bottom: 3rem;
}

.even\\:pl-12:nth-child(even){
  padding-left: 3rem;
}

.even\\:pt-14:nth-child(even){
  padding-top: 3.5rem;
}

.even\\:pr-14:nth-child(even){
  padding-right: 3.5rem;
}

.even\\:pb-14:nth-child(even){
  padding-bottom: 3.5rem;
}

.even\\:pl-14:nth-child(even){
  padding-left: 3.5rem;
}

.even\\:pt-15:nth-child(even){
  padding-top: 3.75rem;
}

.even\\:pr-15:nth-child(even){
  padding-right: 3.75rem;
}

.even\\:pb-15:nth-child(even){
  padding-bottom: 3.75rem;
}

.even\\:pl-15:nth-child(even){
  padding-left: 3.75rem;
}

.even\\:pt-16:nth-child(even){
  padding-top: 4rem;
}

.even\\:pr-16:nth-child(even){
  padding-right: 4rem;
}

.even\\:pb-16:nth-child(even){
  padding-bottom: 4rem;
}

.even\\:pl-16:nth-child(even){
  padding-left: 4rem;
}

.even\\:pt-18:nth-child(even){
  padding-top: 4.5rem;
}

.even\\:pr-18:nth-child(even){
  padding-right: 4.5rem;
}

.even\\:pb-18:nth-child(even){
  padding-bottom: 4.5rem;
}

.even\\:pl-18:nth-child(even){
  padding-left: 4.5rem;
}

.even\\:pt-20:nth-child(even){
  padding-top: 5rem;
}

.even\\:pr-20:nth-child(even){
  padding-right: 5rem;
}

.even\\:pb-20:nth-child(even){
  padding-bottom: 5rem;
}

.even\\:pl-20:nth-child(even){
  padding-left: 5rem;
}

.even\\:pt-22:nth-child(even){
  padding-top: 5.5rem;
}

.even\\:pr-22:nth-child(even){
  padding-right: 5.5rem;
}

.even\\:pb-22:nth-child(even){
  padding-bottom: 5.5rem;
}

.even\\:pl-22:nth-child(even){
  padding-left: 5.5rem;
}

.even\\:pt-23:nth-child(even){
  padding-top: 5.75rem;
}

.even\\:pr-23:nth-child(even){
  padding-right: 5.75rem;
}

.even\\:pb-23:nth-child(even){
  padding-bottom: 5.75rem;
}

.even\\:pl-23:nth-child(even){
  padding-left: 5.75rem;
}

.even\\:pt-24:nth-child(even){
  padding-top: 6rem;
}

.even\\:pr-24:nth-child(even){
  padding-right: 6rem;
}

.even\\:pb-24:nth-child(even){
  padding-bottom: 6rem;
}

.even\\:pl-24:nth-child(even){
  padding-left: 6rem;
}

.even\\:pt-25:nth-child(even){
  padding-top: 6.25rem;
}

.even\\:pr-25:nth-child(even){
  padding-right: 6.25rem;
}

.even\\:pb-25:nth-child(even){
  padding-bottom: 6.25rem;
}

.even\\:pl-25:nth-child(even){
  padding-left: 6.25rem;
}

.even\\:pt-26:nth-child(even){
  padding-top: 6.5rem;
}

.even\\:pr-26:nth-child(even){
  padding-right: 6.5rem;
}

.even\\:pb-26:nth-child(even){
  padding-bottom: 6.5rem;
}

.even\\:pl-26:nth-child(even){
  padding-left: 6.5rem;
}

.even\\:pt-28:nth-child(even){
  padding-top: 7rem;
}

.even\\:pr-28:nth-child(even){
  padding-right: 7rem;
}

.even\\:pb-28:nth-child(even){
  padding-bottom: 7rem;
}

.even\\:pl-28:nth-child(even){
  padding-left: 7rem;
}

.even\\:pt-30:nth-child(even){
  padding-top: 7.5rem;
}

.even\\:pr-30:nth-child(even){
  padding-right: 7.5rem;
}

.even\\:pb-30:nth-child(even){
  padding-bottom: 7.5rem;
}

.even\\:pl-30:nth-child(even){
  padding-left: 7.5rem;
}

.even\\:pt-32:nth-child(even){
  padding-top: 8rem;
}

.even\\:pr-32:nth-child(even){
  padding-right: 8rem;
}

.even\\:pb-32:nth-child(even){
  padding-bottom: 8rem;
}

.even\\:pl-32:nth-child(even){
  padding-left: 8rem;
}

.even\\:pt-34:nth-child(even){
  padding-top: 8.5rem;
}

.even\\:pr-34:nth-child(even){
  padding-right: 8.5rem;
}

.even\\:pb-34:nth-child(even){
  padding-bottom: 8.5rem;
}

.even\\:pl-34:nth-child(even){
  padding-left: 8.5rem;
}

.even\\:pt-40:nth-child(even){
  padding-top: 10rem;
}

.even\\:pr-40:nth-child(even){
  padding-right: 10rem;
}

.even\\:pb-40:nth-child(even){
  padding-bottom: 10rem;
}

.even\\:pl-40:nth-child(even){
  padding-left: 10rem;
}

.even\\:pt-42:nth-child(even){
  padding-top: 10.5rem;
}

.even\\:pr-42:nth-child(even){
  padding-right: 10.5rem;
}

.even\\:pb-42:nth-child(even){
  padding-bottom: 10.5rem;
}

.even\\:pl-42:nth-child(even){
  padding-left: 10.5rem;
}

.even\\:pt-44:nth-child(even){
  padding-top: 11rem;
}

.even\\:pr-44:nth-child(even){
  padding-right: 11rem;
}

.even\\:pb-44:nth-child(even){
  padding-bottom: 11rem;
}

.even\\:pl-44:nth-child(even){
  padding-left: 11rem;
}

.even\\:pt-48:nth-child(even){
  padding-top: 12rem;
}

.even\\:pr-48:nth-child(even){
  padding-right: 12rem;
}

.even\\:pb-48:nth-child(even){
  padding-bottom: 12rem;
}

.even\\:pl-48:nth-child(even){
  padding-left: 12rem;
}

.even\\:pt-52:nth-child(even){
  padding-top: 13rem;
}

.even\\:pr-52:nth-child(even){
  padding-right: 13rem;
}

.even\\:pb-52:nth-child(even){
  padding-bottom: 13rem;
}

.even\\:pl-52:nth-child(even){
  padding-left: 13rem;
}

.even\\:pt-54:nth-child(even){
  padding-top: 13.5rem;
}

.even\\:pr-54:nth-child(even){
  padding-right: 13.5rem;
}

.even\\:pb-54:nth-child(even){
  padding-bottom: 13.5rem;
}

.even\\:pl-54:nth-child(even){
  padding-left: 13.5rem;
}

.even\\:pt-56:nth-child(even){
  padding-top: 14rem;
}

.even\\:pr-56:nth-child(even){
  padding-right: 14rem;
}

.even\\:pb-56:nth-child(even){
  padding-bottom: 14rem;
}

.even\\:pl-56:nth-child(even){
  padding-left: 14rem;
}

.even\\:pt-60:nth-child(even){
  padding-top: 15rem;
}

.even\\:pr-60:nth-child(even){
  padding-right: 15rem;
}

.even\\:pb-60:nth-child(even){
  padding-bottom: 15rem;
}

.even\\:pl-60:nth-child(even){
  padding-left: 15rem;
}

.even\\:pt-64:nth-child(even){
  padding-top: 16rem;
}

.even\\:pr-64:nth-child(even){
  padding-right: 16rem;
}

.even\\:pb-64:nth-child(even){
  padding-bottom: 16rem;
}

.even\\:pl-64:nth-child(even){
  padding-left: 16rem;
}

.even\\:pt-68:nth-child(even){
  padding-top: 17rem;
}

.even\\:pr-68:nth-child(even){
  padding-right: 17rem;
}

.even\\:pb-68:nth-child(even){
  padding-bottom: 17rem;
}

.even\\:pl-68:nth-child(even){
  padding-left: 17rem;
}

.even\\:pt-72:nth-child(even){
  padding-top: 18rem;
}

.even\\:pr-72:nth-child(even){
  padding-right: 18rem;
}

.even\\:pb-72:nth-child(even){
  padding-bottom: 18rem;
}

.even\\:pl-72:nth-child(even){
  padding-left: 18rem;
}

.even\\:pt-74:nth-child(even){
  padding-top: 18.5rem;
}

.even\\:pr-74:nth-child(even){
  padding-right: 18.5rem;
}

.even\\:pb-74:nth-child(even){
  padding-bottom: 18.5rem;
}

.even\\:pl-74:nth-child(even){
  padding-left: 18.5rem;
}

.even\\:pt-76:nth-child(even){
  padding-top: 19rem;
}

.even\\:pr-76:nth-child(even){
  padding-right: 19rem;
}

.even\\:pb-76:nth-child(even){
  padding-bottom: 19rem;
}

.even\\:pl-76:nth-child(even){
  padding-left: 19rem;
}

.even\\:pt-78:nth-child(even){
  padding-top: 19.5rem;
}

.even\\:pr-78:nth-child(even){
  padding-right: 19.5rem;
}

.even\\:pb-78:nth-child(even){
  padding-bottom: 19.5rem;
}

.even\\:pl-78:nth-child(even){
  padding-left: 19.5rem;
}

.even\\:pt-80:nth-child(even){
  padding-top: 20rem;
}

.even\\:pr-80:nth-child(even){
  padding-right: 20rem;
}

.even\\:pb-80:nth-child(even){
  padding-bottom: 20rem;
}

.even\\:pl-80:nth-child(even){
  padding-left: 20rem;
}

.even\\:pt-82:nth-child(even){
  padding-top: 20.5rem;
}

.even\\:pr-82:nth-child(even){
  padding-right: 20.5rem;
}

.even\\:pb-82:nth-child(even){
  padding-bottom: 20.5rem;
}

.even\\:pl-82:nth-child(even){
  padding-left: 20.5rem;
}

.even\\:pt-84:nth-child(even){
  padding-top: 21rem;
}

.even\\:pr-84:nth-child(even){
  padding-right: 21rem;
}

.even\\:pb-84:nth-child(even){
  padding-bottom: 21rem;
}

.even\\:pl-84:nth-child(even){
  padding-left: 21rem;
}

.even\\:pt-88:nth-child(even){
  padding-top: 22rem;
}

.even\\:pr-88:nth-child(even){
  padding-right: 22rem;
}

.even\\:pb-88:nth-child(even){
  padding-bottom: 22rem;
}

.even\\:pl-88:nth-child(even){
  padding-left: 22rem;
}

.even\\:pt-92:nth-child(even){
  padding-top: 23rem;
}

.even\\:pr-92:nth-child(even){
  padding-right: 23rem;
}

.even\\:pb-92:nth-child(even){
  padding-bottom: 23rem;
}

.even\\:pl-92:nth-child(even){
  padding-left: 23rem;
}

.even\\:pt-96:nth-child(even){
  padding-top: 24rem;
}

.even\\:pr-96:nth-child(even){
  padding-right: 24rem;
}

.even\\:pb-96:nth-child(even){
  padding-bottom: 24rem;
}

.even\\:pl-96:nth-child(even){
  padding-left: 24rem;
}

.even\\:pt-98:nth-child(even){
  padding-top: 24.5rem;
}

.even\\:pr-98:nth-child(even){
  padding-right: 24.5rem;
}

.even\\:pb-98:nth-child(even){
  padding-bottom: 24.5rem;
}

.even\\:pl-98:nth-child(even){
  padding-left: 24.5rem;
}

.even\\:pt-100:nth-child(even){
  padding-top: 25rem;
}

.even\\:pr-100:nth-child(even){
  padding-right: 25rem;
}

.even\\:pb-100:nth-child(even){
  padding-bottom: 25rem;
}

.even\\:pl-100:nth-child(even){
  padding-left: 25rem;
}

.even\\:pt-104:nth-child(even){
  padding-top: 26rem;
}

.even\\:pr-104:nth-child(even){
  padding-right: 26rem;
}

.even\\:pb-104:nth-child(even){
  padding-bottom: 26rem;
}

.even\\:pl-104:nth-child(even){
  padding-left: 26rem;
}

.even\\:pt-112:nth-child(even){
  padding-top: 28rem;
}

.even\\:pr-112:nth-child(even){
  padding-right: 28rem;
}

.even\\:pb-112:nth-child(even){
  padding-bottom: 28rem;
}

.even\\:pl-112:nth-child(even){
  padding-left: 28rem;
}

.even\\:pt-124:nth-child(even){
  padding-top: 31rem;
}

.even\\:pr-124:nth-child(even){
  padding-right: 31rem;
}

.even\\:pb-124:nth-child(even){
  padding-bottom: 31rem;
}

.even\\:pl-124:nth-child(even){
  padding-left: 31rem;
}

.even\\:pt-128:nth-child(even){
  padding-top: 32rem;
}

.even\\:pr-128:nth-child(even){
  padding-right: 32rem;
}

.even\\:pb-128:nth-child(even){
  padding-bottom: 32rem;
}

.even\\:pl-128:nth-child(even){
  padding-left: 32rem;
}

.even\\:pt-140:nth-child(even){
  padding-top: 35rem;
}

.even\\:pr-140:nth-child(even){
  padding-right: 35rem;
}

.even\\:pb-140:nth-child(even){
  padding-bottom: 35rem;
}

.even\\:pl-140:nth-child(even){
  padding-left: 35rem;
}

.even\\:pt-152:nth-child(even){
  padding-top: 38rem;
}

.even\\:pr-152:nth-child(even){
  padding-right: 38rem;
}

.even\\:pb-152:nth-child(even){
  padding-bottom: 38rem;
}

.even\\:pl-152:nth-child(even){
  padding-left: 38rem;
}

.even\\:pt-160:nth-child(even){
  padding-top: 40rem;
}

.even\\:pr-160:nth-child(even){
  padding-right: 40rem;
}

.even\\:pb-160:nth-child(even){
  padding-bottom: 40rem;
}

.even\\:pl-160:nth-child(even){
  padding-left: 40rem;
}

.even\\:pt-162:nth-child(even){
  padding-top: 41rem;
}

.even\\:pr-162:nth-child(even){
  padding-right: 41rem;
}

.even\\:pb-162:nth-child(even){
  padding-bottom: 41rem;
}

.even\\:pl-162:nth-child(even){
  padding-left: 41rem;
}

.even\\:pt-192:nth-child(even){
  padding-top: 48rem;
}

.even\\:pr-192:nth-child(even){
  padding-right: 48rem;
}

.even\\:pb-192:nth-child(even){
  padding-bottom: 48rem;
}

.even\\:pl-192:nth-child(even){
  padding-left: 48rem;
}

.even\\:pt-208:nth-child(even){
  padding-top: 52rem;
}

.even\\:pr-208:nth-child(even){
  padding-right: 52rem;
}

.even\\:pb-208:nth-child(even){
  padding-bottom: 52rem;
}

.even\\:pl-208:nth-child(even){
  padding-left: 52rem;
}

.even\\:pt-224:nth-child(even){
  padding-top: 56rem;
}

.even\\:pr-224:nth-child(even){
  padding-right: 56rem;
}

.even\\:pb-224:nth-child(even){
  padding-bottom: 56rem;
}

.even\\:pl-224:nth-child(even){
  padding-left: 56rem;
}

.even\\:pt-256:nth-child(even){
  padding-top: 64rem;
}

.even\\:pr-256:nth-child(even){
  padding-right: 64rem;
}

.even\\:pb-256:nth-child(even){
  padding-bottom: 64rem;
}

.even\\:pl-256:nth-child(even){
  padding-left: 64rem;
}

.even\\:pt-px:nth-child(even){
  padding-top: 1px;
}

.even\\:pr-px:nth-child(even){
  padding-right: 1px;
}

.even\\:pb-px:nth-child(even){
  padding-bottom: 1px;
}

.even\\:pl-px:nth-child(even){
  padding-left: 1px;
}

.placeholder-transparent::placeholder{
  color: transparent;
}

.placeholder-focus::placeholder{
  color: rgba(4, 21, 39, 0.8);;
}

.placeholder-black::placeholder{
  --placeholder-opacity: 1;
  color: #000;
  color: rgba(0, 0, 0, var(--placeholder-opacity));
}

.placeholder-white::placeholder{
  --placeholder-opacity: 1;
  color: #fff;
  color: rgba(255, 255, 255, var(--placeholder-opacity));
}

.placeholder-primary::placeholder{
  --placeholder-opacity: 1;
  color: #37A4DC;
  color: rgba(55, 164, 220, var(--placeholder-opacity));
}

.placeholder-disabled::placeholder{
  --placeholder-opacity: 1;
  color: #BFBFBF;
  color: rgba(191, 191, 191, var(--placeholder-opacity));
}

.placeholder-translucent-60::placeholder{
  color: rgba(256, 256, 256, 0.6);
}

.placeholder-translucent-90::placeholder{
  color: rgba(256, 256, 256, 0.9);
}

.placeholder-green-200::placeholder{
  --placeholder-opacity: 1;
  color: #f4fcea;
  color: rgba(244, 252, 234, var(--placeholder-opacity));
}

.placeholder-green-400::placeholder{
  --placeholder-opacity: 1;
  color: #6CCA98;
  color: rgba(108, 202, 152, var(--placeholder-opacity));
}

.placeholder-green-500::placeholder{
  --placeholder-opacity: 1;
  color: #97E812;
  color: rgba(151, 232, 18, var(--placeholder-opacity));
}

.placeholder-green-600::placeholder{
  --placeholder-opacity: 1;
  color: #4f9112;
  color: rgba(79, 145, 18, var(--placeholder-opacity));
}

.placeholder-green-700::placeholder{
  --placeholder-opacity: 1;
  color: #3e7211;
  color: rgba(62, 114, 17, var(--placeholder-opacity));
}

.placeholder-green-400a50::placeholder{
  color: rgba(108,202,152,0.50196);
}

.placeholder-green-500a25::placeholder{
  color: rgba(151,232,18,0.09804);
}

.placeholder-yellow-200::placeholder{
  --placeholder-opacity: 1;
  color: #fff9eb;
  color: rgba(255, 249, 235, var(--placeholder-opacity));
}

.placeholder-yellow-300::placeholder{
  --placeholder-opacity: 1;
  color: #ffe9bd;
  color: rgba(255, 233, 189, var(--placeholder-opacity));
}

.placeholder-yellow-500::placeholder{
  --placeholder-opacity: 1;
  color: #FFC82C;
  color: rgba(255, 200, 44, var(--placeholder-opacity));
}

.placeholder-yellow-600::placeholder{
  --placeholder-opacity: 1;
  color: #F7931E;
  color: rgba(247, 147, 30, var(--placeholder-opacity));
}

.placeholder-yellow-700::placeholder{
  --placeholder-opacity: 1;
  color: #E1AD28;
  color: rgba(225, 173, 40, var(--placeholder-opacity));
}

.placeholder-yellow-300a66::placeholder{
  color: rgba(255,233,189,0.66667);
}

.placeholder-yellow-500a25::placeholder{
  color: rgba(255,200,44,0.09804);
}

.placeholder-orange-200::placeholder{
  --placeholder-opacity: 1;
  color: #fdf0ea;
  color: rgba(253, 240, 234, var(--placeholder-opacity));
}

.placeholder-orange-400::placeholder{
  --placeholder-opacity: 1;
  color: #f6c66f;
  color: rgba(246, 198, 111, var(--placeholder-opacity));
}

.placeholder-orange-500::placeholder{
  --placeholder-opacity: 1;
  color: #F07313;
  color: rgba(240, 115, 19, var(--placeholder-opacity));
}

.placeholder-orange-800::placeholder{
  --placeholder-opacity: 1;
  color: #db5d0c;
  color: rgba(219, 93, 12, var(--placeholder-opacity));
}

.placeholder-orange-900::placeholder{
  --placeholder-opacity: 1;
  color: #b86814;
  color: rgba(184, 104, 20, var(--placeholder-opacity));
}

.placeholder-orange-500a25::placeholder{
  color: rgba(240,115,23,0.09804);
}

.placeholder-red-100::placeholder{
  --placeholder-opacity: 1;
  color: #FEF5F5;
  color: rgba(254, 245, 245, var(--placeholder-opacity));
}

.placeholder-red-150::placeholder{
  --placeholder-opacity: 1;
  color: #ffe9e8;
  color: rgba(255, 233, 232, var(--placeholder-opacity));
}

.placeholder-red-200::placeholder{
  --placeholder-opacity: 1;
  color: #F8CECC;
  color: rgba(248, 206, 204, var(--placeholder-opacity));
}

.placeholder-red-300::placeholder{
  --placeholder-opacity: 1;
  color: #ff8585;
  color: rgba(255, 133, 133, var(--placeholder-opacity));
}

.placeholder-red-400::placeholder{
  --placeholder-opacity: 1;
  color: #ff3535;
  color: rgba(255, 53, 53, var(--placeholder-opacity));
}

.placeholder-red-500::placeholder{
  --placeholder-opacity: 1;
  color: #DD4746;
  color: rgba(221, 71, 70, var(--placeholder-opacity));
}

.placeholder-red-700::placeholder{
  --placeholder-opacity: 1;
  color: #A23C24;
  color: rgba(162, 60, 36, var(--placeholder-opacity));
}

.placeholder-gray-50::placeholder{
  --placeholder-opacity: 1;
  color: #F9F9F9;
  color: rgba(249, 249, 249, var(--placeholder-opacity));
}

.placeholder-gray-100::placeholder{
  --placeholder-opacity: 1;
  color: #F1F1F2;
  color: rgba(241, 241, 242, var(--placeholder-opacity));
}

.placeholder-gray-150::placeholder{
  --placeholder-opacity: 1;
  color: #e6e6e6;
  color: rgba(230, 230, 230, var(--placeholder-opacity));
}

.placeholder-gray-200::placeholder{
  --placeholder-opacity: 1;
  color: #E0E2E4;
  color: rgba(224, 226, 228, var(--placeholder-opacity));
}

.placeholder-gray-300::placeholder{
  --placeholder-opacity: 1;
  color: #BFBFBF;
  color: rgba(191, 191, 191, var(--placeholder-opacity));
}

.placeholder-gray-400::placeholder{
  color: rgba(114,114,114,0.8);
}

.placeholder-gray-425::placeholder{
  color: rgba(4, 21, 39, 0.8);
}

.placeholder-gray-450::placeholder{
  --placeholder-opacity: 1;
  color: #959595;
  color: rgba(149, 149, 149, var(--placeholder-opacity));
}

.placeholder-gray-500::placeholder{
  --placeholder-opacity: 1;
  color: #727272;
  color: rgba(114, 114, 114, var(--placeholder-opacity));
}

.placeholder-gray-600::placeholder{
  --placeholder-opacity: 1;
  color: #5a626b;
  color: rgba(90, 98, 107, var(--placeholder-opacity));
}

.placeholder-gray-625::placeholder{
  color: rgba(90,98,107,0.8);
}

.placeholder-gray-700::placeholder{
  --placeholder-opacity: 1;
  color: #464C59;
  color: rgba(70, 76, 89, var(--placeholder-opacity));
}

.placeholder-gray-800::placeholder{
  --placeholder-opacity: 1;
  color: #3c3b3b;
  color: rgba(60, 59, 59, var(--placeholder-opacity));
}

.placeholder-gray-200a50::placeholder{
  color: rgba(224, 226, 228, 0.5);
}

.placeholder-blue-50::placeholder{
  --placeholder-opacity: 1;
  color: #f2fbff;
  color: rgba(242, 251, 255, var(--placeholder-opacity));
}

.placeholder-blue-100::placeholder{
  --placeholder-opacity: 1;
  color: #EBF6FC;
  color: rgba(235, 246, 252, var(--placeholder-opacity));
}

.placeholder-blue-150::placeholder{
  --placeholder-opacity: 1;
  color: #E8EEF1;
  color: rgba(232, 238, 241, var(--placeholder-opacity));
}

.placeholder-blue-200::placeholder{
  --placeholder-opacity: 1;
  color: #CCE6F5;
  color: rgba(204, 230, 245, var(--placeholder-opacity));
}

.placeholder-blue-300::placeholder{
  --placeholder-opacity: 1;
  color: #73BFE7;
  color: rgba(115, 191, 231, var(--placeholder-opacity));
}

.placeholder-blue-400::placeholder{
  --placeholder-opacity: 1;
  color: #4BA4F7;
  color: rgba(75, 164, 247, var(--placeholder-opacity));
}

.placeholder-blue-500::placeholder{
  --placeholder-opacity: 1;
  color: #37A4DC;
  color: rgba(55, 164, 220, var(--placeholder-opacity));
}

.placeholder-blue-600::placeholder{
  --placeholder-opacity: 1;
  color: #6AA2D6;
  color: rgba(106, 162, 214, var(--placeholder-opacity));
}

.placeholder-blue-700::placeholder{
  --placeholder-opacity: 1;
  color: #456E9A;
  color: rgba(69, 110, 154, var(--placeholder-opacity));
}

.placeholder-blue-750::placeholder{
  --placeholder-opacity: 1;
  color: #5682AA;
  color: rgba(86, 130, 170, var(--placeholder-opacity));
}

.placeholder-blue-800::placeholder{
  --placeholder-opacity: 1;
  color: #1F4566;
  color: rgba(31, 69, 102, var(--placeholder-opacity));
}

.placeholder-blue-900::placeholder{
  --placeholder-opacity: 1;
  color: #183453;
  color: rgba(24, 52, 83, var(--placeholder-opacity));
}

.placeholder-blue-950::placeholder{
  --placeholder-opacity: 1;
  color: #041527;
  color: rgba(4, 21, 39, var(--placeholder-opacity));
}

.placeholder-blue-500a25::placeholder{
  color: rgba(55, 164, 220, 0.2);
}

.placeholder-blue-500a50::placeholder{
  color: rgba(55, 164, 220, 0.5);
}

.placeholder-blue-700a75::placeholder{
  --placeholder-opacity: 1;
  color: #3B648D;
  color: rgba(59, 100, 141, var(--placeholder-opacity));
}

.placeholder-blue-700a30::placeholder{
  --placeholder-opacity: 1;
  color: #2A5176;
  color: rgba(42, 81, 118, var(--placeholder-opacity));
}

.placeholder-blue-750a25::placeholder{
  color: rgba(86,130,170,0.09804);
}

.placeholder-blue-750a15::placeholder{
  color: rgba(86,130,170,0.05882);
}

.placeholder-blue-800a60::placeholder{
  color: rgba(31, 69, 102, 0.6);
}

.placeholder-programEditorTabColors-1::placeholder{
  --placeholder-opacity: 1;
  color: #3cacae;
  color: rgba(60, 172, 174, var(--placeholder-opacity));
}

.placeholder-programEditorTabColors-2::placeholder{
  --placeholder-opacity: 1;
  color: #8e346a;
  color: rgba(142, 52, 106, var(--placeholder-opacity));
}

.placeholder-programEditorTabColors-3::placeholder{
  --placeholder-opacity: 1;
  color: #ff72b7;
  color: rgba(255, 114, 183, var(--placeholder-opacity));
}

.placeholder-programEditorTabColors-4::placeholder{
  --placeholder-opacity: 1;
  color: #ce941c;
  color: rgba(206, 148, 28, var(--placeholder-opacity));
}

.placeholder-programEditorTabColors-5::placeholder{
  --placeholder-opacity: 1;
  color: #b973d9;
  color: rgba(185, 115, 217, var(--placeholder-opacity));
}

.placeholder-programEditorTabColors-6::placeholder{
  --placeholder-opacity: 1;
  color: #ff9082;
  color: rgba(255, 144, 130, var(--placeholder-opacity));
}

.placeholder-programEditorTabColors-1h::placeholder{
  --placeholder-opacity: 1;
  color: #d9f2f2;
  color: rgba(217, 242, 242, var(--placeholder-opacity));
}

.placeholder-programEditorTabColors-2h::placeholder{
  --placeholder-opacity: 1;
  color: #f1dae8;
  color: rgba(241, 218, 232, var(--placeholder-opacity));
}

.placeholder-programEditorTabColors-3h::placeholder{
  --placeholder-opacity: 1;
  color: #ffe6f2;
  color: rgba(255, 230, 242, var(--placeholder-opacity));
}

.placeholder-programEditorTabColors-4h::placeholder{
  --placeholder-opacity: 1;
  color: #f9ecd2;
  color: rgba(249, 236, 210, var(--placeholder-opacity));
}

.placeholder-programEditorTabColors-5h::placeholder{
  --placeholder-opacity: 1;
  color: #f5ebfa;
  color: rgba(245, 235, 250, var(--placeholder-opacity));
}

.placeholder-programEditorTabColors-6h::placeholder{
  --placeholder-opacity: 1;
  color: #ffe8e6;
  color: rgba(255, 232, 230, var(--placeholder-opacity));
}

.placeholder-programEditorPresetTabColors-1::placeholder{
  --placeholder-opacity: 1;
  color: #798fa3;
  color: rgba(121, 143, 163, var(--placeholder-opacity));
}

.placeholder-programEditorPresetTabColors-1h::placeholder{
  --placeholder-opacity: 1;
  color: #798fa3;
  color: rgba(121, 143, 163, var(--placeholder-opacity));
}

.placeholder-borgScaleColors-0::placeholder{
  --placeholder-opacity: 1;
  color: #c5d1ff;
  color: rgba(197, 209, 255, var(--placeholder-opacity));
}

.placeholder-borgScaleColors-1::placeholder{
  --placeholder-opacity: 1;
  color: #a0b5fc;
  color: rgba(160, 181, 252, var(--placeholder-opacity));
}

.placeholder-borgScaleColors-2::placeholder{
  --placeholder-opacity: 1;
  color: #7492ff;
  color: rgba(116, 146, 255, var(--placeholder-opacity));
}

.placeholder-borgScaleColors-3::placeholder{
  --placeholder-opacity: 1;
  color: #82bbf1;
  color: rgba(130, 187, 241, var(--placeholder-opacity));
}

.placeholder-borgScaleColors-4::placeholder{
  --placeholder-opacity: 1;
  color: #4ba4f7;
  color: rgba(75, 164, 247, var(--placeholder-opacity));
}

.placeholder-borgScaleColors-5::placeholder{
  --placeholder-opacity: 1;
  color: #9cdd57;
  color: rgba(156, 221, 87, var(--placeholder-opacity));
}

.placeholder-borgScaleColors-6::placeholder{
  --placeholder-opacity: 1;
  color: #68af00;
  color: rgba(104, 175, 0, var(--placeholder-opacity));
}

.placeholder-borgScaleColors-7::placeholder{
  --placeholder-opacity: 1;
  color: #f5e380;
  color: rgba(245, 227, 128, var(--placeholder-opacity));
}

.placeholder-borgScaleColors-8::placeholder{
  --placeholder-opacity: 1;
  color: #ffc246;
  color: rgba(255, 194, 70, var(--placeholder-opacity));
}

.placeholder-borgScaleColors-9::placeholder{
  --placeholder-opacity: 1;
  color: #ff782f;
  color: rgba(255, 120, 47, var(--placeholder-opacity));
}

.placeholder-borgScaleColors-10::placeholder{
  --placeholder-opacity: 1;
  color: #f25757;
  color: rgba(242, 87, 87, var(--placeholder-opacity));
}

.focus\\:placeholder-transparent:focus::placeholder{
  color: transparent;
}

.focus\\:placeholder-focus:focus::placeholder{
  color: rgba(4, 21, 39, 0.8);;
}

.focus\\:placeholder-black:focus::placeholder{
  --placeholder-opacity: 1;
  color: #000;
  color: rgba(0, 0, 0, var(--placeholder-opacity));
}

.focus\\:placeholder-white:focus::placeholder{
  --placeholder-opacity: 1;
  color: #fff;
  color: rgba(255, 255, 255, var(--placeholder-opacity));
}

.focus\\:placeholder-primary:focus::placeholder{
  --placeholder-opacity: 1;
  color: #37A4DC;
  color: rgba(55, 164, 220, var(--placeholder-opacity));
}

.focus\\:placeholder-disabled:focus::placeholder{
  --placeholder-opacity: 1;
  color: #BFBFBF;
  color: rgba(191, 191, 191, var(--placeholder-opacity));
}

.focus\\:placeholder-translucent-60:focus::placeholder{
  color: rgba(256, 256, 256, 0.6);
}

.focus\\:placeholder-translucent-90:focus::placeholder{
  color: rgba(256, 256, 256, 0.9);
}

.focus\\:placeholder-green-200:focus::placeholder{
  --placeholder-opacity: 1;
  color: #f4fcea;
  color: rgba(244, 252, 234, var(--placeholder-opacity));
}

.focus\\:placeholder-green-400:focus::placeholder{
  --placeholder-opacity: 1;
  color: #6CCA98;
  color: rgba(108, 202, 152, var(--placeholder-opacity));
}

.focus\\:placeholder-green-500:focus::placeholder{
  --placeholder-opacity: 1;
  color: #97E812;
  color: rgba(151, 232, 18, var(--placeholder-opacity));
}

.focus\\:placeholder-green-600:focus::placeholder{
  --placeholder-opacity: 1;
  color: #4f9112;
  color: rgba(79, 145, 18, var(--placeholder-opacity));
}

.focus\\:placeholder-green-700:focus::placeholder{
  --placeholder-opacity: 1;
  color: #3e7211;
  color: rgba(62, 114, 17, var(--placeholder-opacity));
}

.focus\\:placeholder-green-400a50:focus::placeholder{
  color: rgba(108,202,152,0.50196);
}

.focus\\:placeholder-green-500a25:focus::placeholder{
  color: rgba(151,232,18,0.09804);
}

.focus\\:placeholder-yellow-200:focus::placeholder{
  --placeholder-opacity: 1;
  color: #fff9eb;
  color: rgba(255, 249, 235, var(--placeholder-opacity));
}

.focus\\:placeholder-yellow-300:focus::placeholder{
  --placeholder-opacity: 1;
  color: #ffe9bd;
  color: rgba(255, 233, 189, var(--placeholder-opacity));
}

.focus\\:placeholder-yellow-500:focus::placeholder{
  --placeholder-opacity: 1;
  color: #FFC82C;
  color: rgba(255, 200, 44, var(--placeholder-opacity));
}

.focus\\:placeholder-yellow-600:focus::placeholder{
  --placeholder-opacity: 1;
  color: #F7931E;
  color: rgba(247, 147, 30, var(--placeholder-opacity));
}

.focus\\:placeholder-yellow-700:focus::placeholder{
  --placeholder-opacity: 1;
  color: #E1AD28;
  color: rgba(225, 173, 40, var(--placeholder-opacity));
}

.focus\\:placeholder-yellow-300a66:focus::placeholder{
  color: rgba(255,233,189,0.66667);
}

.focus\\:placeholder-yellow-500a25:focus::placeholder{
  color: rgba(255,200,44,0.09804);
}

.focus\\:placeholder-orange-200:focus::placeholder{
  --placeholder-opacity: 1;
  color: #fdf0ea;
  color: rgba(253, 240, 234, var(--placeholder-opacity));
}

.focus\\:placeholder-orange-400:focus::placeholder{
  --placeholder-opacity: 1;
  color: #f6c66f;
  color: rgba(246, 198, 111, var(--placeholder-opacity));
}

.focus\\:placeholder-orange-500:focus::placeholder{
  --placeholder-opacity: 1;
  color: #F07313;
  color: rgba(240, 115, 19, var(--placeholder-opacity));
}

.focus\\:placeholder-orange-800:focus::placeholder{
  --placeholder-opacity: 1;
  color: #db5d0c;
  color: rgba(219, 93, 12, var(--placeholder-opacity));
}

.focus\\:placeholder-orange-900:focus::placeholder{
  --placeholder-opacity: 1;
  color: #b86814;
  color: rgba(184, 104, 20, var(--placeholder-opacity));
}

.focus\\:placeholder-orange-500a25:focus::placeholder{
  color: rgba(240,115,23,0.09804);
}

.focus\\:placeholder-red-100:focus::placeholder{
  --placeholder-opacity: 1;
  color: #FEF5F5;
  color: rgba(254, 245, 245, var(--placeholder-opacity));
}

.focus\\:placeholder-red-150:focus::placeholder{
  --placeholder-opacity: 1;
  color: #ffe9e8;
  color: rgba(255, 233, 232, var(--placeholder-opacity));
}

.focus\\:placeholder-red-200:focus::placeholder{
  --placeholder-opacity: 1;
  color: #F8CECC;
  color: rgba(248, 206, 204, var(--placeholder-opacity));
}

.focus\\:placeholder-red-300:focus::placeholder{
  --placeholder-opacity: 1;
  color: #ff8585;
  color: rgba(255, 133, 133, var(--placeholder-opacity));
}

.focus\\:placeholder-red-400:focus::placeholder{
  --placeholder-opacity: 1;
  color: #ff3535;
  color: rgba(255, 53, 53, var(--placeholder-opacity));
}

.focus\\:placeholder-red-500:focus::placeholder{
  --placeholder-opacity: 1;
  color: #DD4746;
  color: rgba(221, 71, 70, var(--placeholder-opacity));
}

.focus\\:placeholder-red-700:focus::placeholder{
  --placeholder-opacity: 1;
  color: #A23C24;
  color: rgba(162, 60, 36, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-50:focus::placeholder{
  --placeholder-opacity: 1;
  color: #F9F9F9;
  color: rgba(249, 249, 249, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-100:focus::placeholder{
  --placeholder-opacity: 1;
  color: #F1F1F2;
  color: rgba(241, 241, 242, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-150:focus::placeholder{
  --placeholder-opacity: 1;
  color: #e6e6e6;
  color: rgba(230, 230, 230, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-200:focus::placeholder{
  --placeholder-opacity: 1;
  color: #E0E2E4;
  color: rgba(224, 226, 228, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-300:focus::placeholder{
  --placeholder-opacity: 1;
  color: #BFBFBF;
  color: rgba(191, 191, 191, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-400:focus::placeholder{
  color: rgba(114,114,114,0.8);
}

.focus\\:placeholder-gray-425:focus::placeholder{
  color: rgba(4, 21, 39, 0.8);
}

.focus\\:placeholder-gray-450:focus::placeholder{
  --placeholder-opacity: 1;
  color: #959595;
  color: rgba(149, 149, 149, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-500:focus::placeholder{
  --placeholder-opacity: 1;
  color: #727272;
  color: rgba(114, 114, 114, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-600:focus::placeholder{
  --placeholder-opacity: 1;
  color: #5a626b;
  color: rgba(90, 98, 107, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-625:focus::placeholder{
  color: rgba(90,98,107,0.8);
}

.focus\\:placeholder-gray-700:focus::placeholder{
  --placeholder-opacity: 1;
  color: #464C59;
  color: rgba(70, 76, 89, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-800:focus::placeholder{
  --placeholder-opacity: 1;
  color: #3c3b3b;
  color: rgba(60, 59, 59, var(--placeholder-opacity));
}

.focus\\:placeholder-gray-200a50:focus::placeholder{
  color: rgba(224, 226, 228, 0.5);
}

.focus\\:placeholder-blue-50:focus::placeholder{
  --placeholder-opacity: 1;
  color: #f2fbff;
  color: rgba(242, 251, 255, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-100:focus::placeholder{
  --placeholder-opacity: 1;
  color: #EBF6FC;
  color: rgba(235, 246, 252, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-150:focus::placeholder{
  --placeholder-opacity: 1;
  color: #E8EEF1;
  color: rgba(232, 238, 241, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-200:focus::placeholder{
  --placeholder-opacity: 1;
  color: #CCE6F5;
  color: rgba(204, 230, 245, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-300:focus::placeholder{
  --placeholder-opacity: 1;
  color: #73BFE7;
  color: rgba(115, 191, 231, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-400:focus::placeholder{
  --placeholder-opacity: 1;
  color: #4BA4F7;
  color: rgba(75, 164, 247, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-500:focus::placeholder{
  --placeholder-opacity: 1;
  color: #37A4DC;
  color: rgba(55, 164, 220, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-600:focus::placeholder{
  --placeholder-opacity: 1;
  color: #6AA2D6;
  color: rgba(106, 162, 214, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-700:focus::placeholder{
  --placeholder-opacity: 1;
  color: #456E9A;
  color: rgba(69, 110, 154, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-750:focus::placeholder{
  --placeholder-opacity: 1;
  color: #5682AA;
  color: rgba(86, 130, 170, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-800:focus::placeholder{
  --placeholder-opacity: 1;
  color: #1F4566;
  color: rgba(31, 69, 102, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-900:focus::placeholder{
  --placeholder-opacity: 1;
  color: #183453;
  color: rgba(24, 52, 83, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-950:focus::placeholder{
  --placeholder-opacity: 1;
  color: #041527;
  color: rgba(4, 21, 39, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-500a25:focus::placeholder{
  color: rgba(55, 164, 220, 0.2);
}

.focus\\:placeholder-blue-500a50:focus::placeholder{
  color: rgba(55, 164, 220, 0.5);
}

.focus\\:placeholder-blue-700a75:focus::placeholder{
  --placeholder-opacity: 1;
  color: #3B648D;
  color: rgba(59, 100, 141, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-700a30:focus::placeholder{
  --placeholder-opacity: 1;
  color: #2A5176;
  color: rgba(42, 81, 118, var(--placeholder-opacity));
}

.focus\\:placeholder-blue-750a25:focus::placeholder{
  color: rgba(86,130,170,0.09804);
}

.focus\\:placeholder-blue-750a15:focus::placeholder{
  color: rgba(86,130,170,0.05882);
}

.focus\\:placeholder-blue-800a60:focus::placeholder{
  color: rgba(31, 69, 102, 0.6);
}

.focus\\:placeholder-programEditorTabColors-1:focus::placeholder{
  --placeholder-opacity: 1;
  color: #3cacae;
  color: rgba(60, 172, 174, var(--placeholder-opacity));
}

.focus\\:placeholder-programEditorTabColors-2:focus::placeholder{
  --placeholder-opacity: 1;
  color: #8e346a;
  color: rgba(142, 52, 106, var(--placeholder-opacity));
}

.focus\\:placeholder-programEditorTabColors-3:focus::placeholder{
  --placeholder-opacity: 1;
  color: #ff72b7;
  color: rgba(255, 114, 183, var(--placeholder-opacity));
}

.focus\\:placeholder-programEditorTabColors-4:focus::placeholder{
  --placeholder-opacity: 1;
  color: #ce941c;
  color: rgba(206, 148, 28, var(--placeholder-opacity));
}

.focus\\:placeholder-programEditorTabColors-5:focus::placeholder{
  --placeholder-opacity: 1;
  color: #b973d9;
  color: rgba(185, 115, 217, var(--placeholder-opacity));
}

.focus\\:placeholder-programEditorTabColors-6:focus::placeholder{
  --placeholder-opacity: 1;
  color: #ff9082;
  color: rgba(255, 144, 130, var(--placeholder-opacity));
}

.focus\\:placeholder-programEditorTabColors-1h:focus::placeholder{
  --placeholder-opacity: 1;
  color: #d9f2f2;
  color: rgba(217, 242, 242, var(--placeholder-opacity));
}

.focus\\:placeholder-programEditorTabColors-2h:focus::placeholder{
  --placeholder-opacity: 1;
  color: #f1dae8;
  color: rgba(241, 218, 232, var(--placeholder-opacity));
}

.focus\\:placeholder-programEditorTabColors-3h:focus::placeholder{
  --placeholder-opacity: 1;
  color: #ffe6f2;
  color: rgba(255, 230, 242, var(--placeholder-opacity));
}

.focus\\:placeholder-programEditorTabColors-4h:focus::placeholder{
  --placeholder-opacity: 1;
  color: #f9ecd2;
  color: rgba(249, 236, 210, var(--placeholder-opacity));
}

.focus\\:placeholder-programEditorTabColors-5h:focus::placeholder{
  --placeholder-opacity: 1;
  color: #f5ebfa;
  color: rgba(245, 235, 250, var(--placeholder-opacity));
}

.focus\\:placeholder-programEditorTabColors-6h:focus::placeholder{
  --placeholder-opacity: 1;
  color: #ffe8e6;
  color: rgba(255, 232, 230, var(--placeholder-opacity));
}

.focus\\:placeholder-programEditorPresetTabColors-1:focus::placeholder{
  --placeholder-opacity: 1;
  color: #798fa3;
  color: rgba(121, 143, 163, var(--placeholder-opacity));
}

.focus\\:placeholder-programEditorPresetTabColors-1h:focus::placeholder{
  --placeholder-opacity: 1;
  color: #798fa3;
  color: rgba(121, 143, 163, var(--placeholder-opacity));
}

.focus\\:placeholder-borgScaleColors-0:focus::placeholder{
  --placeholder-opacity: 1;
  color: #c5d1ff;
  color: rgba(197, 209, 255, var(--placeholder-opacity));
}

.focus\\:placeholder-borgScaleColors-1:focus::placeholder{
  --placeholder-opacity: 1;
  color: #a0b5fc;
  color: rgba(160, 181, 252, var(--placeholder-opacity));
}

.focus\\:placeholder-borgScaleColors-2:focus::placeholder{
  --placeholder-opacity: 1;
  color: #7492ff;
  color: rgba(116, 146, 255, var(--placeholder-opacity));
}

.focus\\:placeholder-borgScaleColors-3:focus::placeholder{
  --placeholder-opacity: 1;
  color: #82bbf1;
  color: rgba(130, 187, 241, var(--placeholder-opacity));
}

.focus\\:placeholder-borgScaleColors-4:focus::placeholder{
  --placeholder-opacity: 1;
  color: #4ba4f7;
  color: rgba(75, 164, 247, var(--placeholder-opacity));
}

.focus\\:placeholder-borgScaleColors-5:focus::placeholder{
  --placeholder-opacity: 1;
  color: #9cdd57;
  color: rgba(156, 221, 87, var(--placeholder-opacity));
}

.focus\\:placeholder-borgScaleColors-6:focus::placeholder{
  --placeholder-opacity: 1;
  color: #68af00;
  color: rgba(104, 175, 0, var(--placeholder-opacity));
}

.focus\\:placeholder-borgScaleColors-7:focus::placeholder{
  --placeholder-opacity: 1;
  color: #f5e380;
  color: rgba(245, 227, 128, var(--placeholder-opacity));
}

.focus\\:placeholder-borgScaleColors-8:focus::placeholder{
  --placeholder-opacity: 1;
  color: #ffc246;
  color: rgba(255, 194, 70, var(--placeholder-opacity));
}

.focus\\:placeholder-borgScaleColors-9:focus::placeholder{
  --placeholder-opacity: 1;
  color: #ff782f;
  color: rgba(255, 120, 47, var(--placeholder-opacity));
}

.focus\\:placeholder-borgScaleColors-10:focus::placeholder{
  --placeholder-opacity: 1;
  color: #f25757;
  color: rgba(242, 87, 87, var(--placeholder-opacity));
}

.placeholder-opacity-0::placeholder{
  --placeholder-opacity: 0;
}

.placeholder-opacity-25::placeholder{
  --placeholder-opacity: .25;
}

.placeholder-opacity-50::placeholder{
  --placeholder-opacity: .5;
}

.placeholder-opacity-75::placeholder{
  --placeholder-opacity: .75;
}

.placeholder-opacity-100::placeholder{
  --placeholder-opacity: 1;
}

.focus\\:placeholder-opacity-0:focus::placeholder{
  --placeholder-opacity: 0;
}

.focus\\:placeholder-opacity-25:focus::placeholder{
  --placeholder-opacity: .25;
}

.focus\\:placeholder-opacity-50:focus::placeholder{
  --placeholder-opacity: .5;
}

.focus\\:placeholder-opacity-75:focus::placeholder{
  --placeholder-opacity: .75;
}

.focus\\:placeholder-opacity-100:focus::placeholder{
  --placeholder-opacity: 1;
}

.pointer-events-none{
  pointer-events: none;
}

.pointer-events-auto{
  pointer-events: auto;
}

.static{
  position: static;
}

.fixed{
  position: fixed;
}

.absolute{
  position: absolute;
}

.relative{
  position: relative;
}

.sticky{
  position: sticky;
}

.inset-0{
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.inset-auto{
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
}

.inset-y-0{
  top: 0;
  bottom: 0;
}

.inset-x-0{
  right: 0;
  left: 0;
}

.inset-y-auto{
  top: auto;
  bottom: auto;
}

.inset-x-auto{
  right: auto;
  left: auto;
}

.top-0{
  top: 0;
}

.right-0{
  right: 0;
}

.bottom-0{
  bottom: 0;
}

.left-0{
  left: 0;
}

.top-auto{
  top: auto;
}

.right-auto{
  right: auto;
}

.bottom-auto{
  bottom: auto;
}

.left-auto{
  left: auto;
}

.resize-none{
  resize: none;
}

.resize-y{
  resize: vertical;
}

.resize-x{
  resize: horizontal;
}

.resize{
  resize: both;
}

.shadow{
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
}

.shadow-overlaptop{
  box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
}

.shadow-overlapbottom{
  box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
}

.shadow-xs{
  box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
}

.shadow-sm{
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
}

.shadow-md{
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.shadow-lg{
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.shadow-xl{
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.shadow-2xl{
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.shadow-none{
  box-shadow: none;
}

.hover\\:shadow:hover{
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
}

.hover\\:shadow-overlaptop:hover{
  box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
}

.hover\\:shadow-overlapbottom:hover{
  box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
}

.hover\\:shadow-xs:hover{
  box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
}

.hover\\:shadow-sm:hover{
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
}

.hover\\:shadow-md:hover{
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.hover\\:shadow-lg:hover{
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.hover\\:shadow-xl:hover{
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.hover\\:shadow-2xl:hover{
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.hover\\:shadow-none:hover{
  box-shadow: none;
}

.focus\\:shadow:focus{
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
}

.focus\\:shadow-overlaptop:focus{
  box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
}

.focus\\:shadow-overlapbottom:focus{
  box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
}

.focus\\:shadow-xs:focus{
  box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
}

.focus\\:shadow-sm:focus{
  box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
}

.focus\\:shadow-md:focus{
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

.focus\\:shadow-lg:focus{
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
}

.focus\\:shadow-xl:focus{
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
}

.focus\\:shadow-2xl:focus{
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.focus\\:shadow-none:focus{
  box-shadow: none;
}

.fill-transparent{
  fill: transparent;
}

.fill-focus{
  fill: rgba(4, 21, 39, 0.8);;
}

.fill-black{
  fill: #000;
}

.fill-white{
  fill: #fff;
}

.fill-primary{
  fill: #37A4DC;
}

.fill-disabled{
  fill: #BFBFBF;
}

.fill-translucent-60{
  fill: rgba(256, 256, 256, 0.6);
}

.fill-translucent-90{
  fill: rgba(256, 256, 256, 0.9);
}

.fill-green-200{
  fill: #f4fcea;
}

.fill-green-400{
  fill: #6CCA98;
}

.fill-green-500{
  fill: #97E812;
}

.fill-green-600{
  fill: #4f9112;
}

.fill-green-700{
  fill: #3e7211;
}

.fill-green-400a50{
  fill: rgba(108,202,152,0.50196);
}

.fill-green-500a25{
  fill: rgba(151,232,18,0.09804);
}

.fill-yellow-200{
  fill: #fff9eb;
}

.fill-yellow-300{
  fill: #ffe9bd;
}

.fill-yellow-500{
  fill: #FFC82C;
}

.fill-yellow-600{
  fill: #F7931E;
}

.fill-yellow-700{
  fill: #E1AD28;
}

.fill-yellow-300a66{
  fill: rgba(255,233,189,0.66667);
}

.fill-yellow-500a25{
  fill: rgba(255,200,44,0.09804);
}

.fill-orange-200{
  fill: #fdf0ea;
}

.fill-orange-400{
  fill: #f6c66f;
}

.fill-orange-500{
  fill: #F07313;
}

.fill-orange-800{
  fill: #db5d0c;
}

.fill-orange-900{
  fill: #b86814;
}

.fill-orange-500a25{
  fill: rgba(240,115,23,0.09804);
}

.fill-red-100{
  fill: #FEF5F5;
}

.fill-red-150{
  fill: #ffe9e8;
}

.fill-red-200{
  fill: #F8CECC;
}

.fill-red-300{
  fill: #ff8585;
}

.fill-red-400{
  fill: #ff3535;
}

.fill-red-500{
  fill: #DD4746;
}

.fill-red-700{
  fill: #A23C24;
}

.fill-gray-50{
  fill: #F9F9F9;
}

.fill-gray-100{
  fill: #F1F1F2;
}

.fill-gray-150{
  fill: #e6e6e6;
}

.fill-gray-200{
  fill: #E0E2E4;
}

.fill-gray-300{
  fill: #BFBFBF;
}

.fill-gray-400{
  fill: rgba(114,114,114,0.8);
}

.fill-gray-425{
  fill: rgba(4, 21, 39, 0.8);
}

.fill-gray-450{
  fill: #959595;
}

.fill-gray-500{
  fill: #727272;
}

.fill-gray-600{
  fill: #5a626b;
}

.fill-gray-625{
  fill: rgba(90,98,107,0.8);
}

.fill-gray-700{
  fill: #464C59;
}

.fill-gray-800{
  fill: #3c3b3b;
}

.fill-gray-200a50{
  fill: rgba(224, 226, 228, 0.5);
}

.fill-blue-50{
  fill: #f2fbff;
}

.fill-blue-100{
  fill: #EBF6FC;
}

.fill-blue-150{
  fill: #E8EEF1;
}

.fill-blue-200{
  fill: #CCE6F5;
}

.fill-blue-300{
  fill: #73BFE7;
}

.fill-blue-400{
  fill: #4BA4F7;
}

.fill-blue-500{
  fill: #37A4DC;
}

.fill-blue-600{
  fill: #6AA2D6;
}

.fill-blue-700{
  fill: #456E9A;
}

.fill-blue-750{
  fill: #5682AA;
}

.fill-blue-800{
  fill: #1F4566;
}

.fill-blue-900{
  fill: #183453;
}

.fill-blue-950{
  fill: #041527;
}

.fill-blue-500a25{
  fill: rgba(55, 164, 220, 0.2);
}

.fill-blue-500a50{
  fill: rgba(55, 164, 220, 0.5);
}

.fill-blue-700a75{
  fill: #3B648D;
}

.fill-blue-700a30{
  fill: #2A5176;
}

.fill-blue-750a25{
  fill: rgba(86,130,170,0.09804);
}

.fill-blue-750a15{
  fill: rgba(86,130,170,0.05882);
}

.fill-blue-800a60{
  fill: rgba(31, 69, 102, 0.6);
}

.fill-programEditorTabColors-1{
  fill: #3cacae;
}

.fill-programEditorTabColors-2{
  fill: #8e346a;
}

.fill-programEditorTabColors-3{
  fill: #ff72b7;
}

.fill-programEditorTabColors-4{
  fill: #ce941c;
}

.fill-programEditorTabColors-5{
  fill: #b973d9;
}

.fill-programEditorTabColors-6{
  fill: #ff9082;
}

.fill-programEditorTabColors-1h{
  fill: #d9f2f2;
}

.fill-programEditorTabColors-2h{
  fill: #f1dae8;
}

.fill-programEditorTabColors-3h{
  fill: #ffe6f2;
}

.fill-programEditorTabColors-4h{
  fill: #f9ecd2;
}

.fill-programEditorTabColors-5h{
  fill: #f5ebfa;
}

.fill-programEditorTabColors-6h{
  fill: #ffe8e6;
}

.fill-programEditorPresetTabColors-1{
  fill: #798fa3;
}

.fill-programEditorPresetTabColors-1h{
  fill: #798fa3;
}

.fill-borgScaleColors-0{
  fill: #c5d1ff;
}

.fill-borgScaleColors-1{
  fill: #a0b5fc;
}

.fill-borgScaleColors-2{
  fill: #7492ff;
}

.fill-borgScaleColors-3{
  fill: #82bbf1;
}

.fill-borgScaleColors-4{
  fill: #4ba4f7;
}

.fill-borgScaleColors-5{
  fill: #9cdd57;
}

.fill-borgScaleColors-6{
  fill: #68af00;
}

.fill-borgScaleColors-7{
  fill: #f5e380;
}

.fill-borgScaleColors-8{
  fill: #ffc246;
}

.fill-borgScaleColors-9{
  fill: #ff782f;
}

.fill-borgScaleColors-10{
  fill: #f25757;
}

.fill-current{
  fill: currentColor;
}

.hover\\:fill-transparent:hover{
  fill: transparent;
}

.hover\\:fill-focus:hover{
  fill: rgba(4, 21, 39, 0.8);;
}

.hover\\:fill-black:hover{
  fill: #000;
}

.hover\\:fill-white:hover{
  fill: #fff;
}

.hover\\:fill-primary:hover{
  fill: #37A4DC;
}

.hover\\:fill-disabled:hover{
  fill: #BFBFBF;
}

.hover\\:fill-translucent-60:hover{
  fill: rgba(256, 256, 256, 0.6);
}

.hover\\:fill-translucent-90:hover{
  fill: rgba(256, 256, 256, 0.9);
}

.hover\\:fill-green-200:hover{
  fill: #f4fcea;
}

.hover\\:fill-green-400:hover{
  fill: #6CCA98;
}

.hover\\:fill-green-500:hover{
  fill: #97E812;
}

.hover\\:fill-green-600:hover{
  fill: #4f9112;
}

.hover\\:fill-green-700:hover{
  fill: #3e7211;
}

.hover\\:fill-green-400a50:hover{
  fill: rgba(108,202,152,0.50196);
}

.hover\\:fill-green-500a25:hover{
  fill: rgba(151,232,18,0.09804);
}

.hover\\:fill-yellow-200:hover{
  fill: #fff9eb;
}

.hover\\:fill-yellow-300:hover{
  fill: #ffe9bd;
}

.hover\\:fill-yellow-500:hover{
  fill: #FFC82C;
}

.hover\\:fill-yellow-600:hover{
  fill: #F7931E;
}

.hover\\:fill-yellow-700:hover{
  fill: #E1AD28;
}

.hover\\:fill-yellow-300a66:hover{
  fill: rgba(255,233,189,0.66667);
}

.hover\\:fill-yellow-500a25:hover{
  fill: rgba(255,200,44,0.09804);
}

.hover\\:fill-orange-200:hover{
  fill: #fdf0ea;
}

.hover\\:fill-orange-400:hover{
  fill: #f6c66f;
}

.hover\\:fill-orange-500:hover{
  fill: #F07313;
}

.hover\\:fill-orange-800:hover{
  fill: #db5d0c;
}

.hover\\:fill-orange-900:hover{
  fill: #b86814;
}

.hover\\:fill-orange-500a25:hover{
  fill: rgba(240,115,23,0.09804);
}

.hover\\:fill-red-100:hover{
  fill: #FEF5F5;
}

.hover\\:fill-red-150:hover{
  fill: #ffe9e8;
}

.hover\\:fill-red-200:hover{
  fill: #F8CECC;
}

.hover\\:fill-red-300:hover{
  fill: #ff8585;
}

.hover\\:fill-red-400:hover{
  fill: #ff3535;
}

.hover\\:fill-red-500:hover{
  fill: #DD4746;
}

.hover\\:fill-red-700:hover{
  fill: #A23C24;
}

.hover\\:fill-gray-50:hover{
  fill: #F9F9F9;
}

.hover\\:fill-gray-100:hover{
  fill: #F1F1F2;
}

.hover\\:fill-gray-150:hover{
  fill: #e6e6e6;
}

.hover\\:fill-gray-200:hover{
  fill: #E0E2E4;
}

.hover\\:fill-gray-300:hover{
  fill: #BFBFBF;
}

.hover\\:fill-gray-400:hover{
  fill: rgba(114,114,114,0.8);
}

.hover\\:fill-gray-425:hover{
  fill: rgba(4, 21, 39, 0.8);
}

.hover\\:fill-gray-450:hover{
  fill: #959595;
}

.hover\\:fill-gray-500:hover{
  fill: #727272;
}

.hover\\:fill-gray-600:hover{
  fill: #5a626b;
}

.hover\\:fill-gray-625:hover{
  fill: rgba(90,98,107,0.8);
}

.hover\\:fill-gray-700:hover{
  fill: #464C59;
}

.hover\\:fill-gray-800:hover{
  fill: #3c3b3b;
}

.hover\\:fill-gray-200a50:hover{
  fill: rgba(224, 226, 228, 0.5);
}

.hover\\:fill-blue-50:hover{
  fill: #f2fbff;
}

.hover\\:fill-blue-100:hover{
  fill: #EBF6FC;
}

.hover\\:fill-blue-150:hover{
  fill: #E8EEF1;
}

.hover\\:fill-blue-200:hover{
  fill: #CCE6F5;
}

.hover\\:fill-blue-300:hover{
  fill: #73BFE7;
}

.hover\\:fill-blue-400:hover{
  fill: #4BA4F7;
}

.hover\\:fill-blue-500:hover{
  fill: #37A4DC;
}

.hover\\:fill-blue-600:hover{
  fill: #6AA2D6;
}

.hover\\:fill-blue-700:hover{
  fill: #456E9A;
}

.hover\\:fill-blue-750:hover{
  fill: #5682AA;
}

.hover\\:fill-blue-800:hover{
  fill: #1F4566;
}

.hover\\:fill-blue-900:hover{
  fill: #183453;
}

.hover\\:fill-blue-950:hover{
  fill: #041527;
}

.hover\\:fill-blue-500a25:hover{
  fill: rgba(55, 164, 220, 0.2);
}

.hover\\:fill-blue-500a50:hover{
  fill: rgba(55, 164, 220, 0.5);
}

.hover\\:fill-blue-700a75:hover{
  fill: #3B648D;
}

.hover\\:fill-blue-700a30:hover{
  fill: #2A5176;
}

.hover\\:fill-blue-750a25:hover{
  fill: rgba(86,130,170,0.09804);
}

.hover\\:fill-blue-750a15:hover{
  fill: rgba(86,130,170,0.05882);
}

.hover\\:fill-blue-800a60:hover{
  fill: rgba(31, 69, 102, 0.6);
}

.hover\\:fill-programEditorTabColors-1:hover{
  fill: #3cacae;
}

.hover\\:fill-programEditorTabColors-2:hover{
  fill: #8e346a;
}

.hover\\:fill-programEditorTabColors-3:hover{
  fill: #ff72b7;
}

.hover\\:fill-programEditorTabColors-4:hover{
  fill: #ce941c;
}

.hover\\:fill-programEditorTabColors-5:hover{
  fill: #b973d9;
}

.hover\\:fill-programEditorTabColors-6:hover{
  fill: #ff9082;
}

.hover\\:fill-programEditorTabColors-1h:hover{
  fill: #d9f2f2;
}

.hover\\:fill-programEditorTabColors-2h:hover{
  fill: #f1dae8;
}

.hover\\:fill-programEditorTabColors-3h:hover{
  fill: #ffe6f2;
}

.hover\\:fill-programEditorTabColors-4h:hover{
  fill: #f9ecd2;
}

.hover\\:fill-programEditorTabColors-5h:hover{
  fill: #f5ebfa;
}

.hover\\:fill-programEditorTabColors-6h:hover{
  fill: #ffe8e6;
}

.hover\\:fill-programEditorPresetTabColors-1:hover{
  fill: #798fa3;
}

.hover\\:fill-programEditorPresetTabColors-1h:hover{
  fill: #798fa3;
}

.hover\\:fill-borgScaleColors-0:hover{
  fill: #c5d1ff;
}

.hover\\:fill-borgScaleColors-1:hover{
  fill: #a0b5fc;
}

.hover\\:fill-borgScaleColors-2:hover{
  fill: #7492ff;
}

.hover\\:fill-borgScaleColors-3:hover{
  fill: #82bbf1;
}

.hover\\:fill-borgScaleColors-4:hover{
  fill: #4ba4f7;
}

.hover\\:fill-borgScaleColors-5:hover{
  fill: #9cdd57;
}

.hover\\:fill-borgScaleColors-6:hover{
  fill: #68af00;
}

.hover\\:fill-borgScaleColors-7:hover{
  fill: #f5e380;
}

.hover\\:fill-borgScaleColors-8:hover{
  fill: #ffc246;
}

.hover\\:fill-borgScaleColors-9:hover{
  fill: #ff782f;
}

.hover\\:fill-borgScaleColors-10:hover{
  fill: #f25757;
}

.hover\\:fill-current:hover{
  fill: currentColor;
}

.focus\\:fill-transparent:focus{
  fill: transparent;
}

.focus\\:fill-focus:focus{
  fill: rgba(4, 21, 39, 0.8);;
}

.focus\\:fill-black:focus{
  fill: #000;
}

.focus\\:fill-white:focus{
  fill: #fff;
}

.focus\\:fill-primary:focus{
  fill: #37A4DC;
}

.focus\\:fill-disabled:focus{
  fill: #BFBFBF;
}

.focus\\:fill-translucent-60:focus{
  fill: rgba(256, 256, 256, 0.6);
}

.focus\\:fill-translucent-90:focus{
  fill: rgba(256, 256, 256, 0.9);
}

.focus\\:fill-green-200:focus{
  fill: #f4fcea;
}

.focus\\:fill-green-400:focus{
  fill: #6CCA98;
}

.focus\\:fill-green-500:focus{
  fill: #97E812;
}

.focus\\:fill-green-600:focus{
  fill: #4f9112;
}

.focus\\:fill-green-700:focus{
  fill: #3e7211;
}

.focus\\:fill-green-400a50:focus{
  fill: rgba(108,202,152,0.50196);
}

.focus\\:fill-green-500a25:focus{
  fill: rgba(151,232,18,0.09804);
}

.focus\\:fill-yellow-200:focus{
  fill: #fff9eb;
}

.focus\\:fill-yellow-300:focus{
  fill: #ffe9bd;
}

.focus\\:fill-yellow-500:focus{
  fill: #FFC82C;
}

.focus\\:fill-yellow-600:focus{
  fill: #F7931E;
}

.focus\\:fill-yellow-700:focus{
  fill: #E1AD28;
}

.focus\\:fill-yellow-300a66:focus{
  fill: rgba(255,233,189,0.66667);
}

.focus\\:fill-yellow-500a25:focus{
  fill: rgba(255,200,44,0.09804);
}

.focus\\:fill-orange-200:focus{
  fill: #fdf0ea;
}

.focus\\:fill-orange-400:focus{
  fill: #f6c66f;
}

.focus\\:fill-orange-500:focus{
  fill: #F07313;
}

.focus\\:fill-orange-800:focus{
  fill: #db5d0c;
}

.focus\\:fill-orange-900:focus{
  fill: #b86814;
}

.focus\\:fill-orange-500a25:focus{
  fill: rgba(240,115,23,0.09804);
}

.focus\\:fill-red-100:focus{
  fill: #FEF5F5;
}

.focus\\:fill-red-150:focus{
  fill: #ffe9e8;
}

.focus\\:fill-red-200:focus{
  fill: #F8CECC;
}

.focus\\:fill-red-300:focus{
  fill: #ff8585;
}

.focus\\:fill-red-400:focus{
  fill: #ff3535;
}

.focus\\:fill-red-500:focus{
  fill: #DD4746;
}

.focus\\:fill-red-700:focus{
  fill: #A23C24;
}

.focus\\:fill-gray-50:focus{
  fill: #F9F9F9;
}

.focus\\:fill-gray-100:focus{
  fill: #F1F1F2;
}

.focus\\:fill-gray-150:focus{
  fill: #e6e6e6;
}

.focus\\:fill-gray-200:focus{
  fill: #E0E2E4;
}

.focus\\:fill-gray-300:focus{
  fill: #BFBFBF;
}

.focus\\:fill-gray-400:focus{
  fill: rgba(114,114,114,0.8);
}

.focus\\:fill-gray-425:focus{
  fill: rgba(4, 21, 39, 0.8);
}

.focus\\:fill-gray-450:focus{
  fill: #959595;
}

.focus\\:fill-gray-500:focus{
  fill: #727272;
}

.focus\\:fill-gray-600:focus{
  fill: #5a626b;
}

.focus\\:fill-gray-625:focus{
  fill: rgba(90,98,107,0.8);
}

.focus\\:fill-gray-700:focus{
  fill: #464C59;
}

.focus\\:fill-gray-800:focus{
  fill: #3c3b3b;
}

.focus\\:fill-gray-200a50:focus{
  fill: rgba(224, 226, 228, 0.5);
}

.focus\\:fill-blue-50:focus{
  fill: #f2fbff;
}

.focus\\:fill-blue-100:focus{
  fill: #EBF6FC;
}

.focus\\:fill-blue-150:focus{
  fill: #E8EEF1;
}

.focus\\:fill-blue-200:focus{
  fill: #CCE6F5;
}

.focus\\:fill-blue-300:focus{
  fill: #73BFE7;
}

.focus\\:fill-blue-400:focus{
  fill: #4BA4F7;
}

.focus\\:fill-blue-500:focus{
  fill: #37A4DC;
}

.focus\\:fill-blue-600:focus{
  fill: #6AA2D6;
}

.focus\\:fill-blue-700:focus{
  fill: #456E9A;
}

.focus\\:fill-blue-750:focus{
  fill: #5682AA;
}

.focus\\:fill-blue-800:focus{
  fill: #1F4566;
}

.focus\\:fill-blue-900:focus{
  fill: #183453;
}

.focus\\:fill-blue-950:focus{
  fill: #041527;
}

.focus\\:fill-blue-500a25:focus{
  fill: rgba(55, 164, 220, 0.2);
}

.focus\\:fill-blue-500a50:focus{
  fill: rgba(55, 164, 220, 0.5);
}

.focus\\:fill-blue-700a75:focus{
  fill: #3B648D;
}

.focus\\:fill-blue-700a30:focus{
  fill: #2A5176;
}

.focus\\:fill-blue-750a25:focus{
  fill: rgba(86,130,170,0.09804);
}

.focus\\:fill-blue-750a15:focus{
  fill: rgba(86,130,170,0.05882);
}

.focus\\:fill-blue-800a60:focus{
  fill: rgba(31, 69, 102, 0.6);
}

.focus\\:fill-programEditorTabColors-1:focus{
  fill: #3cacae;
}

.focus\\:fill-programEditorTabColors-2:focus{
  fill: #8e346a;
}

.focus\\:fill-programEditorTabColors-3:focus{
  fill: #ff72b7;
}

.focus\\:fill-programEditorTabColors-4:focus{
  fill: #ce941c;
}

.focus\\:fill-programEditorTabColors-5:focus{
  fill: #b973d9;
}

.focus\\:fill-programEditorTabColors-6:focus{
  fill: #ff9082;
}

.focus\\:fill-programEditorTabColors-1h:focus{
  fill: #d9f2f2;
}

.focus\\:fill-programEditorTabColors-2h:focus{
  fill: #f1dae8;
}

.focus\\:fill-programEditorTabColors-3h:focus{
  fill: #ffe6f2;
}

.focus\\:fill-programEditorTabColors-4h:focus{
  fill: #f9ecd2;
}

.focus\\:fill-programEditorTabColors-5h:focus{
  fill: #f5ebfa;
}

.focus\\:fill-programEditorTabColors-6h:focus{
  fill: #ffe8e6;
}

.focus\\:fill-programEditorPresetTabColors-1:focus{
  fill: #798fa3;
}

.focus\\:fill-programEditorPresetTabColors-1h:focus{
  fill: #798fa3;
}

.focus\\:fill-borgScaleColors-0:focus{
  fill: #c5d1ff;
}

.focus\\:fill-borgScaleColors-1:focus{
  fill: #a0b5fc;
}

.focus\\:fill-borgScaleColors-2:focus{
  fill: #7492ff;
}

.focus\\:fill-borgScaleColors-3:focus{
  fill: #82bbf1;
}

.focus\\:fill-borgScaleColors-4:focus{
  fill: #4ba4f7;
}

.focus\\:fill-borgScaleColors-5:focus{
  fill: #9cdd57;
}

.focus\\:fill-borgScaleColors-6:focus{
  fill: #68af00;
}

.focus\\:fill-borgScaleColors-7:focus{
  fill: #f5e380;
}

.focus\\:fill-borgScaleColors-8:focus{
  fill: #ffc246;
}

.focus\\:fill-borgScaleColors-9:focus{
  fill: #ff782f;
}

.focus\\:fill-borgScaleColors-10:focus{
  fill: #f25757;
}

.focus\\:fill-current:focus{
  fill: currentColor;
}

.stroke-current{
  stroke: currentColor;
}

.stroke-0{
  stroke-width: 0;
}

.stroke-1{
  stroke-width: 1;
}

.stroke-2{
  stroke-width: 2;
}

.table-auto{
  table-layout: auto;
}

.table-fixed{
  table-layout: fixed;
}

.text-left{
  text-align: left;
}

.text-center{
  text-align: center;
}

.text-right{
  text-align: right;
}

.text-justify{
  text-align: justify;
}

.text-transparent{
  color: transparent;
}

.text-focus{
  color: rgba(4, 21, 39, 0.8);;
}

.text-black{
  --text-opacity: 1;
  color: #000;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--text-opacity));
}

.text-white{
  --text-opacity: 1;
  color: #fff;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--text-opacity));
}

.text-primary{
  --text-opacity: 1;
  color: #37A4DC;
  color: rgba(55, 164, 220, 1);
  color: rgba(55, 164, 220, var(--text-opacity));
}

.text-disabled{
  --text-opacity: 1;
  color: #BFBFBF;
  color: rgba(191, 191, 191, 1);
  color: rgba(191, 191, 191, var(--text-opacity));
}

.text-translucent-60{
  color: rgba(256, 256, 256, 0.6);
}

.text-translucent-90{
  color: rgba(256, 256, 256, 0.9);
}

.text-green-200{
  --text-opacity: 1;
  color: #f4fcea;
  color: rgba(244, 252, 234, 1);
  color: rgba(244, 252, 234, var(--text-opacity));
}

.text-green-400{
  --text-opacity: 1;
  color: #6CCA98;
  color: rgba(108, 202, 152, 1);
  color: rgba(108, 202, 152, var(--text-opacity));
}

.text-green-500{
  --text-opacity: 1;
  color: #97E812;
  color: rgba(151, 232, 18, 1);
  color: rgba(151, 232, 18, var(--text-opacity));
}

.text-green-600{
  --text-opacity: 1;
  color: #4f9112;
  color: rgba(79, 145, 18, 1);
  color: rgba(79, 145, 18, var(--text-opacity));
}

.text-green-700{
  --text-opacity: 1;
  color: #3e7211;
  color: rgba(62, 114, 17, 1);
  color: rgba(62, 114, 17, var(--text-opacity));
}

.text-green-400a50{
  color: rgba(108,202,152,0.50196);
}

.text-green-500a25{
  color: rgba(151,232,18,0.09804);
}

.text-yellow-200{
  --text-opacity: 1;
  color: #fff9eb;
  color: rgba(255, 249, 235, 1);
  color: rgba(255, 249, 235, var(--text-opacity));
}

.text-yellow-300{
  --text-opacity: 1;
  color: #ffe9bd;
  color: rgba(255, 233, 189, 1);
  color: rgba(255, 233, 189, var(--text-opacity));
}

.text-yellow-500{
  --text-opacity: 1;
  color: #FFC82C;
  color: rgba(255, 200, 44, 1);
  color: rgba(255, 200, 44, var(--text-opacity));
}

.text-yellow-600{
  --text-opacity: 1;
  color: #F7931E;
  color: rgba(247, 147, 30, 1);
  color: rgba(247, 147, 30, var(--text-opacity));
}

.text-yellow-700{
  --text-opacity: 1;
  color: #E1AD28;
  color: rgba(225, 173, 40, 1);
  color: rgba(225, 173, 40, var(--text-opacity));
}

.text-yellow-300a66{
  color: rgba(255,233,189,0.66667);
}

.text-yellow-500a25{
  color: rgba(255,200,44,0.09804);
}

.text-orange-200{
  --text-opacity: 1;
  color: #fdf0ea;
  color: rgba(253, 240, 234, 1);
  color: rgba(253, 240, 234, var(--text-opacity));
}

.text-orange-400{
  --text-opacity: 1;
  color: #f6c66f;
  color: rgba(246, 198, 111, 1);
  color: rgba(246, 198, 111, var(--text-opacity));
}

.text-orange-500{
  --text-opacity: 1;
  color: #F07313;
  color: rgba(240, 115, 19, 1);
  color: rgba(240, 115, 19, var(--text-opacity));
}

.text-orange-800{
  --text-opacity: 1;
  color: #db5d0c;
  color: rgba(219, 93, 12, 1);
  color: rgba(219, 93, 12, var(--text-opacity));
}

.text-orange-900{
  --text-opacity: 1;
  color: #b86814;
  color: rgba(184, 104, 20, 1);
  color: rgba(184, 104, 20, var(--text-opacity));
}

.text-orange-500a25{
  color: rgba(240,115,23,0.09804);
}

.text-red-100{
  --text-opacity: 1;
  color: #FEF5F5;
  color: rgba(254, 245, 245, 1);
  color: rgba(254, 245, 245, var(--text-opacity));
}

.text-red-150{
  --text-opacity: 1;
  color: #ffe9e8;
  color: rgba(255, 233, 232, 1);
  color: rgba(255, 233, 232, var(--text-opacity));
}

.text-red-200{
  --text-opacity: 1;
  color: #F8CECC;
  color: rgba(248, 206, 204, 1);
  color: rgba(248, 206, 204, var(--text-opacity));
}

.text-red-300{
  --text-opacity: 1;
  color: #ff8585;
  color: rgba(255, 133, 133, 1);
  color: rgba(255, 133, 133, var(--text-opacity));
}

.text-red-400{
  --text-opacity: 1;
  color: #ff3535;
  color: rgba(255, 53, 53, 1);
  color: rgba(255, 53, 53, var(--text-opacity));
}

.text-red-500{
  --text-opacity: 1;
  color: #DD4746;
  color: rgba(221, 71, 70, 1);
  color: rgba(221, 71, 70, var(--text-opacity));
}

.text-red-700{
  --text-opacity: 1;
  color: #A23C24;
  color: rgba(162, 60, 36, 1);
  color: rgba(162, 60, 36, var(--text-opacity));
}

.text-gray-50{
  --text-opacity: 1;
  color: #F9F9F9;
  color: rgba(249, 249, 249, 1);
  color: rgba(249, 249, 249, var(--text-opacity));
}

.text-gray-100{
  --text-opacity: 1;
  color: #F1F1F2;
  color: rgba(241, 241, 242, 1);
  color: rgba(241, 241, 242, var(--text-opacity));
}

.text-gray-150{
  --text-opacity: 1;
  color: #e6e6e6;
  color: rgba(230, 230, 230, 1);
  color: rgba(230, 230, 230, var(--text-opacity));
}

.text-gray-200{
  --text-opacity: 1;
  color: #E0E2E4;
  color: rgba(224, 226, 228, 1);
  color: rgba(224, 226, 228, var(--text-opacity));
}

.text-gray-300{
  --text-opacity: 1;
  color: #BFBFBF;
  color: rgba(191, 191, 191, 1);
  color: rgba(191, 191, 191, var(--text-opacity));
}

.text-gray-400{
  color: rgba(114,114,114,0.8);
}

.text-gray-425{
  color: rgba(4, 21, 39, 0.8);
}

.text-gray-450{
  --text-opacity: 1;
  color: #959595;
  color: rgba(149, 149, 149, 1);
  color: rgba(149, 149, 149, var(--text-opacity));
}

.text-gray-500{
  --text-opacity: 1;
  color: #727272;
  color: rgba(114, 114, 114, 1);
  color: rgba(114, 114, 114, var(--text-opacity));
}

.text-gray-600{
  --text-opacity: 1;
  color: #5a626b;
  color: rgba(90, 98, 107, 1);
  color: rgba(90, 98, 107, var(--text-opacity));
}

.text-gray-625{
  color: rgba(90,98,107,0.8);
}

.text-gray-700{
  --text-opacity: 1;
  color: #464C59;
  color: rgba(70, 76, 89, 1);
  color: rgba(70, 76, 89, var(--text-opacity));
}

.text-gray-800{
  --text-opacity: 1;
  color: #3c3b3b;
  color: rgba(60, 59, 59, 1);
  color: rgba(60, 59, 59, var(--text-opacity));
}

.text-gray-200a50{
  color: rgba(224, 226, 228, 0.5);
}

.text-blue-50{
  --text-opacity: 1;
  color: #f2fbff;
  color: rgba(242, 251, 255, 1);
  color: rgba(242, 251, 255, var(--text-opacity));
}

.text-blue-100{
  --text-opacity: 1;
  color: #EBF6FC;
  color: rgba(235, 246, 252, 1);
  color: rgba(235, 246, 252, var(--text-opacity));
}

.text-blue-150{
  --text-opacity: 1;
  color: #E8EEF1;
  color: rgba(232, 238, 241, 1);
  color: rgba(232, 238, 241, var(--text-opacity));
}

.text-blue-200{
  --text-opacity: 1;
  color: #CCE6F5;
  color: rgba(204, 230, 245, 1);
  color: rgba(204, 230, 245, var(--text-opacity));
}

.text-blue-300{
  --text-opacity: 1;
  color: #73BFE7;
  color: rgba(115, 191, 231, 1);
  color: rgba(115, 191, 231, var(--text-opacity));
}

.text-blue-400{
  --text-opacity: 1;
  color: #4BA4F7;
  color: rgba(75, 164, 247, 1);
  color: rgba(75, 164, 247, var(--text-opacity));
}

.text-blue-500{
  --text-opacity: 1;
  color: #37A4DC;
  color: rgba(55, 164, 220, 1);
  color: rgba(55, 164, 220, var(--text-opacity));
}

.text-blue-600{
  --text-opacity: 1;
  color: #6AA2D6;
  color: rgba(106, 162, 214, 1);
  color: rgba(106, 162, 214, var(--text-opacity));
}

.text-blue-700{
  --text-opacity: 1;
  color: #456E9A;
  color: rgba(69, 110, 154, 1);
  color: rgba(69, 110, 154, var(--text-opacity));
}

.text-blue-750{
  --text-opacity: 1;
  color: #5682AA;
  color: rgba(86, 130, 170, 1);
  color: rgba(86, 130, 170, var(--text-opacity));
}

.text-blue-800{
  --text-opacity: 1;
  color: #1F4566;
  color: rgba(31, 69, 102, 1);
  color: rgba(31, 69, 102, var(--text-opacity));
}

.text-blue-900{
  --text-opacity: 1;
  color: #183453;
  color: rgba(24, 52, 83, 1);
  color: rgba(24, 52, 83, var(--text-opacity));
}

.text-blue-950{
  --text-opacity: 1;
  color: #041527;
  color: rgba(4, 21, 39, 1);
  color: rgba(4, 21, 39, var(--text-opacity));
}

.text-blue-500a25{
  color: rgba(55, 164, 220, 0.2);
}

.text-blue-500a50{
  color: rgba(55, 164, 220, 0.5);
}

.text-blue-700a75{
  --text-opacity: 1;
  color: #3B648D;
  color: rgba(59, 100, 141, 1);
  color: rgba(59, 100, 141, var(--text-opacity));
}

.text-blue-700a30{
  --text-opacity: 1;
  color: #2A5176;
  color: rgba(42, 81, 118, 1);
  color: rgba(42, 81, 118, var(--text-opacity));
}

.text-blue-750a25{
  color: rgba(86,130,170,0.09804);
}

.text-blue-750a15{
  color: rgba(86,130,170,0.05882);
}

.text-blue-800a60{
  color: rgba(31, 69, 102, 0.6);
}

.text-programEditorTabColors-1{
  --text-opacity: 1;
  color: #3cacae;
  color: rgba(60, 172, 174, 1);
  color: rgba(60, 172, 174, var(--text-opacity));
}

.text-programEditorTabColors-2{
  --text-opacity: 1;
  color: #8e346a;
  color: rgba(142, 52, 106, 1);
  color: rgba(142, 52, 106, var(--text-opacity));
}

.text-programEditorTabColors-3{
  --text-opacity: 1;
  color: #ff72b7;
  color: rgba(255, 114, 183, 1);
  color: rgba(255, 114, 183, var(--text-opacity));
}

.text-programEditorTabColors-4{
  --text-opacity: 1;
  color: #ce941c;
  color: rgba(206, 148, 28, 1);
  color: rgba(206, 148, 28, var(--text-opacity));
}

.text-programEditorTabColors-5{
  --text-opacity: 1;
  color: #b973d9;
  color: rgba(185, 115, 217, 1);
  color: rgba(185, 115, 217, var(--text-opacity));
}

.text-programEditorTabColors-6{
  --text-opacity: 1;
  color: #ff9082;
  color: rgba(255, 144, 130, 1);
  color: rgba(255, 144, 130, var(--text-opacity));
}

.text-programEditorTabColors-1h{
  --text-opacity: 1;
  color: #d9f2f2;
  color: rgba(217, 242, 242, 1);
  color: rgba(217, 242, 242, var(--text-opacity));
}

.text-programEditorTabColors-2h{
  --text-opacity: 1;
  color: #f1dae8;
  color: rgba(241, 218, 232, 1);
  color: rgba(241, 218, 232, var(--text-opacity));
}

.text-programEditorTabColors-3h{
  --text-opacity: 1;
  color: #ffe6f2;
  color: rgba(255, 230, 242, 1);
  color: rgba(255, 230, 242, var(--text-opacity));
}

.text-programEditorTabColors-4h{
  --text-opacity: 1;
  color: #f9ecd2;
  color: rgba(249, 236, 210, 1);
  color: rgba(249, 236, 210, var(--text-opacity));
}

.text-programEditorTabColors-5h{
  --text-opacity: 1;
  color: #f5ebfa;
  color: rgba(245, 235, 250, 1);
  color: rgba(245, 235, 250, var(--text-opacity));
}

.text-programEditorTabColors-6h{
  --text-opacity: 1;
  color: #ffe8e6;
  color: rgba(255, 232, 230, 1);
  color: rgba(255, 232, 230, var(--text-opacity));
}

.text-programEditorPresetTabColors-1{
  --text-opacity: 1;
  color: #798fa3;
  color: rgba(121, 143, 163, 1);
  color: rgba(121, 143, 163, var(--text-opacity));
}

.text-programEditorPresetTabColors-1h{
  --text-opacity: 1;
  color: #798fa3;
  color: rgba(121, 143, 163, 1);
  color: rgba(121, 143, 163, var(--text-opacity));
}

.text-borgScaleColors-0{
  --text-opacity: 1;
  color: #c5d1ff;
  color: rgba(197, 209, 255, 1);
  color: rgba(197, 209, 255, var(--text-opacity));
}

.text-borgScaleColors-1{
  --text-opacity: 1;
  color: #a0b5fc;
  color: rgba(160, 181, 252, 1);
  color: rgba(160, 181, 252, var(--text-opacity));
}

.text-borgScaleColors-2{
  --text-opacity: 1;
  color: #7492ff;
  color: rgba(116, 146, 255, 1);
  color: rgba(116, 146, 255, var(--text-opacity));
}

.text-borgScaleColors-3{
  --text-opacity: 1;
  color: #82bbf1;
  color: rgba(130, 187, 241, 1);
  color: rgba(130, 187, 241, var(--text-opacity));
}

.text-borgScaleColors-4{
  --text-opacity: 1;
  color: #4ba4f7;
  color: rgba(75, 164, 247, 1);
  color: rgba(75, 164, 247, var(--text-opacity));
}

.text-borgScaleColors-5{
  --text-opacity: 1;
  color: #9cdd57;
  color: rgba(156, 221, 87, 1);
  color: rgba(156, 221, 87, var(--text-opacity));
}

.text-borgScaleColors-6{
  --text-opacity: 1;
  color: #68af00;
  color: rgba(104, 175, 0, 1);
  color: rgba(104, 175, 0, var(--text-opacity));
}

.text-borgScaleColors-7{
  --text-opacity: 1;
  color: #f5e380;
  color: rgba(245, 227, 128, 1);
  color: rgba(245, 227, 128, var(--text-opacity));
}

.text-borgScaleColors-8{
  --text-opacity: 1;
  color: #ffc246;
  color: rgba(255, 194, 70, 1);
  color: rgba(255, 194, 70, var(--text-opacity));
}

.text-borgScaleColors-9{
  --text-opacity: 1;
  color: #ff782f;
  color: rgba(255, 120, 47, 1);
  color: rgba(255, 120, 47, var(--text-opacity));
}

.text-borgScaleColors-10{
  --text-opacity: 1;
  color: #f25757;
  color: rgba(242, 87, 87, 1);
  color: rgba(242, 87, 87, var(--text-opacity));
}

.hover\\:text-transparent:hover{
  color: transparent;
}

.hover\\:text-focus:hover{
  color: rgba(4, 21, 39, 0.8);;
}

.hover\\:text-black:hover{
  --text-opacity: 1;
  color: #000;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--text-opacity));
}

.hover\\:text-white:hover{
  --text-opacity: 1;
  color: #fff;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--text-opacity));
}

.hover\\:text-primary:hover{
  --text-opacity: 1;
  color: #37A4DC;
  color: rgba(55, 164, 220, 1);
  color: rgba(55, 164, 220, var(--text-opacity));
}

.hover\\:text-disabled:hover{
  --text-opacity: 1;
  color: #BFBFBF;
  color: rgba(191, 191, 191, 1);
  color: rgba(191, 191, 191, var(--text-opacity));
}

.hover\\:text-translucent-60:hover{
  color: rgba(256, 256, 256, 0.6);
}

.hover\\:text-translucent-90:hover{
  color: rgba(256, 256, 256, 0.9);
}

.hover\\:text-green-200:hover{
  --text-opacity: 1;
  color: #f4fcea;
  color: rgba(244, 252, 234, 1);
  color: rgba(244, 252, 234, var(--text-opacity));
}

.hover\\:text-green-400:hover{
  --text-opacity: 1;
  color: #6CCA98;
  color: rgba(108, 202, 152, 1);
  color: rgba(108, 202, 152, var(--text-opacity));
}

.hover\\:text-green-500:hover{
  --text-opacity: 1;
  color: #97E812;
  color: rgba(151, 232, 18, 1);
  color: rgba(151, 232, 18, var(--text-opacity));
}

.hover\\:text-green-600:hover{
  --text-opacity: 1;
  color: #4f9112;
  color: rgba(79, 145, 18, 1);
  color: rgba(79, 145, 18, var(--text-opacity));
}

.hover\\:text-green-700:hover{
  --text-opacity: 1;
  color: #3e7211;
  color: rgba(62, 114, 17, 1);
  color: rgba(62, 114, 17, var(--text-opacity));
}

.hover\\:text-green-400a50:hover{
  color: rgba(108,202,152,0.50196);
}

.hover\\:text-green-500a25:hover{
  color: rgba(151,232,18,0.09804);
}

.hover\\:text-yellow-200:hover{
  --text-opacity: 1;
  color: #fff9eb;
  color: rgba(255, 249, 235, 1);
  color: rgba(255, 249, 235, var(--text-opacity));
}

.hover\\:text-yellow-300:hover{
  --text-opacity: 1;
  color: #ffe9bd;
  color: rgba(255, 233, 189, 1);
  color: rgba(255, 233, 189, var(--text-opacity));
}

.hover\\:text-yellow-500:hover{
  --text-opacity: 1;
  color: #FFC82C;
  color: rgba(255, 200, 44, 1);
  color: rgba(255, 200, 44, var(--text-opacity));
}

.hover\\:text-yellow-600:hover{
  --text-opacity: 1;
  color: #F7931E;
  color: rgba(247, 147, 30, 1);
  color: rgba(247, 147, 30, var(--text-opacity));
}

.hover\\:text-yellow-700:hover{
  --text-opacity: 1;
  color: #E1AD28;
  color: rgba(225, 173, 40, 1);
  color: rgba(225, 173, 40, var(--text-opacity));
}

.hover\\:text-yellow-300a66:hover{
  color: rgba(255,233,189,0.66667);
}

.hover\\:text-yellow-500a25:hover{
  color: rgba(255,200,44,0.09804);
}

.hover\\:text-orange-200:hover{
  --text-opacity: 1;
  color: #fdf0ea;
  color: rgba(253, 240, 234, 1);
  color: rgba(253, 240, 234, var(--text-opacity));
}

.hover\\:text-orange-400:hover{
  --text-opacity: 1;
  color: #f6c66f;
  color: rgba(246, 198, 111, 1);
  color: rgba(246, 198, 111, var(--text-opacity));
}

.hover\\:text-orange-500:hover{
  --text-opacity: 1;
  color: #F07313;
  color: rgba(240, 115, 19, 1);
  color: rgba(240, 115, 19, var(--text-opacity));
}

.hover\\:text-orange-800:hover{
  --text-opacity: 1;
  color: #db5d0c;
  color: rgba(219, 93, 12, 1);
  color: rgba(219, 93, 12, var(--text-opacity));
}

.hover\\:text-orange-900:hover{
  --text-opacity: 1;
  color: #b86814;
  color: rgba(184, 104, 20, 1);
  color: rgba(184, 104, 20, var(--text-opacity));
}

.hover\\:text-orange-500a25:hover{
  color: rgba(240,115,23,0.09804);
}

.hover\\:text-red-100:hover{
  --text-opacity: 1;
  color: #FEF5F5;
  color: rgba(254, 245, 245, 1);
  color: rgba(254, 245, 245, var(--text-opacity));
}

.hover\\:text-red-150:hover{
  --text-opacity: 1;
  color: #ffe9e8;
  color: rgba(255, 233, 232, 1);
  color: rgba(255, 233, 232, var(--text-opacity));
}

.hover\\:text-red-200:hover{
  --text-opacity: 1;
  color: #F8CECC;
  color: rgba(248, 206, 204, 1);
  color: rgba(248, 206, 204, var(--text-opacity));
}

.hover\\:text-red-300:hover{
  --text-opacity: 1;
  color: #ff8585;
  color: rgba(255, 133, 133, 1);
  color: rgba(255, 133, 133, var(--text-opacity));
}

.hover\\:text-red-400:hover{
  --text-opacity: 1;
  color: #ff3535;
  color: rgba(255, 53, 53, 1);
  color: rgba(255, 53, 53, var(--text-opacity));
}

.hover\\:text-red-500:hover{
  --text-opacity: 1;
  color: #DD4746;
  color: rgba(221, 71, 70, 1);
  color: rgba(221, 71, 70, var(--text-opacity));
}

.hover\\:text-red-700:hover{
  --text-opacity: 1;
  color: #A23C24;
  color: rgba(162, 60, 36, 1);
  color: rgba(162, 60, 36, var(--text-opacity));
}

.hover\\:text-gray-50:hover{
  --text-opacity: 1;
  color: #F9F9F9;
  color: rgba(249, 249, 249, 1);
  color: rgba(249, 249, 249, var(--text-opacity));
}

.hover\\:text-gray-100:hover{
  --text-opacity: 1;
  color: #F1F1F2;
  color: rgba(241, 241, 242, 1);
  color: rgba(241, 241, 242, var(--text-opacity));
}

.hover\\:text-gray-150:hover{
  --text-opacity: 1;
  color: #e6e6e6;
  color: rgba(230, 230, 230, 1);
  color: rgba(230, 230, 230, var(--text-opacity));
}

.hover\\:text-gray-200:hover{
  --text-opacity: 1;
  color: #E0E2E4;
  color: rgba(224, 226, 228, 1);
  color: rgba(224, 226, 228, var(--text-opacity));
}

.hover\\:text-gray-300:hover{
  --text-opacity: 1;
  color: #BFBFBF;
  color: rgba(191, 191, 191, 1);
  color: rgba(191, 191, 191, var(--text-opacity));
}

.hover\\:text-gray-400:hover{
  color: rgba(114,114,114,0.8);
}

.hover\\:text-gray-425:hover{
  color: rgba(4, 21, 39, 0.8);
}

.hover\\:text-gray-450:hover{
  --text-opacity: 1;
  color: #959595;
  color: rgba(149, 149, 149, 1);
  color: rgba(149, 149, 149, var(--text-opacity));
}

.hover\\:text-gray-500:hover{
  --text-opacity: 1;
  color: #727272;
  color: rgba(114, 114, 114, 1);
  color: rgba(114, 114, 114, var(--text-opacity));
}

.hover\\:text-gray-600:hover{
  --text-opacity: 1;
  color: #5a626b;
  color: rgba(90, 98, 107, 1);
  color: rgba(90, 98, 107, var(--text-opacity));
}

.hover\\:text-gray-625:hover{
  color: rgba(90,98,107,0.8);
}

.hover\\:text-gray-700:hover{
  --text-opacity: 1;
  color: #464C59;
  color: rgba(70, 76, 89, 1);
  color: rgba(70, 76, 89, var(--text-opacity));
}

.hover\\:text-gray-800:hover{
  --text-opacity: 1;
  color: #3c3b3b;
  color: rgba(60, 59, 59, 1);
  color: rgba(60, 59, 59, var(--text-opacity));
}

.hover\\:text-gray-200a50:hover{
  color: rgba(224, 226, 228, 0.5);
}

.hover\\:text-blue-50:hover{
  --text-opacity: 1;
  color: #f2fbff;
  color: rgba(242, 251, 255, 1);
  color: rgba(242, 251, 255, var(--text-opacity));
}

.hover\\:text-blue-100:hover{
  --text-opacity: 1;
  color: #EBF6FC;
  color: rgba(235, 246, 252, 1);
  color: rgba(235, 246, 252, var(--text-opacity));
}

.hover\\:text-blue-150:hover{
  --text-opacity: 1;
  color: #E8EEF1;
  color: rgba(232, 238, 241, 1);
  color: rgba(232, 238, 241, var(--text-opacity));
}

.hover\\:text-blue-200:hover{
  --text-opacity: 1;
  color: #CCE6F5;
  color: rgba(204, 230, 245, 1);
  color: rgba(204, 230, 245, var(--text-opacity));
}

.hover\\:text-blue-300:hover{
  --text-opacity: 1;
  color: #73BFE7;
  color: rgba(115, 191, 231, 1);
  color: rgba(115, 191, 231, var(--text-opacity));
}

.hover\\:text-blue-400:hover{
  --text-opacity: 1;
  color: #4BA4F7;
  color: rgba(75, 164, 247, 1);
  color: rgba(75, 164, 247, var(--text-opacity));
}

.hover\\:text-blue-500:hover{
  --text-opacity: 1;
  color: #37A4DC;
  color: rgba(55, 164, 220, 1);
  color: rgba(55, 164, 220, var(--text-opacity));
}

.hover\\:text-blue-600:hover{
  --text-opacity: 1;
  color: #6AA2D6;
  color: rgba(106, 162, 214, 1);
  color: rgba(106, 162, 214, var(--text-opacity));
}

.hover\\:text-blue-700:hover{
  --text-opacity: 1;
  color: #456E9A;
  color: rgba(69, 110, 154, 1);
  color: rgba(69, 110, 154, var(--text-opacity));
}

.hover\\:text-blue-750:hover{
  --text-opacity: 1;
  color: #5682AA;
  color: rgba(86, 130, 170, 1);
  color: rgba(86, 130, 170, var(--text-opacity));
}

.hover\\:text-blue-800:hover{
  --text-opacity: 1;
  color: #1F4566;
  color: rgba(31, 69, 102, 1);
  color: rgba(31, 69, 102, var(--text-opacity));
}

.hover\\:text-blue-900:hover{
  --text-opacity: 1;
  color: #183453;
  color: rgba(24, 52, 83, 1);
  color: rgba(24, 52, 83, var(--text-opacity));
}

.hover\\:text-blue-950:hover{
  --text-opacity: 1;
  color: #041527;
  color: rgba(4, 21, 39, 1);
  color: rgba(4, 21, 39, var(--text-opacity));
}

.hover\\:text-blue-500a25:hover{
  color: rgba(55, 164, 220, 0.2);
}

.hover\\:text-blue-500a50:hover{
  color: rgba(55, 164, 220, 0.5);
}

.hover\\:text-blue-700a75:hover{
  --text-opacity: 1;
  color: #3B648D;
  color: rgba(59, 100, 141, 1);
  color: rgba(59, 100, 141, var(--text-opacity));
}

.hover\\:text-blue-700a30:hover{
  --text-opacity: 1;
  color: #2A5176;
  color: rgba(42, 81, 118, 1);
  color: rgba(42, 81, 118, var(--text-opacity));
}

.hover\\:text-blue-750a25:hover{
  color: rgba(86,130,170,0.09804);
}

.hover\\:text-blue-750a15:hover{
  color: rgba(86,130,170,0.05882);
}

.hover\\:text-blue-800a60:hover{
  color: rgba(31, 69, 102, 0.6);
}

.hover\\:text-programEditorTabColors-1:hover{
  --text-opacity: 1;
  color: #3cacae;
  color: rgba(60, 172, 174, 1);
  color: rgba(60, 172, 174, var(--text-opacity));
}

.hover\\:text-programEditorTabColors-2:hover{
  --text-opacity: 1;
  color: #8e346a;
  color: rgba(142, 52, 106, 1);
  color: rgba(142, 52, 106, var(--text-opacity));
}

.hover\\:text-programEditorTabColors-3:hover{
  --text-opacity: 1;
  color: #ff72b7;
  color: rgba(255, 114, 183, 1);
  color: rgba(255, 114, 183, var(--text-opacity));
}

.hover\\:text-programEditorTabColors-4:hover{
  --text-opacity: 1;
  color: #ce941c;
  color: rgba(206, 148, 28, 1);
  color: rgba(206, 148, 28, var(--text-opacity));
}

.hover\\:text-programEditorTabColors-5:hover{
  --text-opacity: 1;
  color: #b973d9;
  color: rgba(185, 115, 217, 1);
  color: rgba(185, 115, 217, var(--text-opacity));
}

.hover\\:text-programEditorTabColors-6:hover{
  --text-opacity: 1;
  color: #ff9082;
  color: rgba(255, 144, 130, 1);
  color: rgba(255, 144, 130, var(--text-opacity));
}

.hover\\:text-programEditorTabColors-1h:hover{
  --text-opacity: 1;
  color: #d9f2f2;
  color: rgba(217, 242, 242, 1);
  color: rgba(217, 242, 242, var(--text-opacity));
}

.hover\\:text-programEditorTabColors-2h:hover{
  --text-opacity: 1;
  color: #f1dae8;
  color: rgba(241, 218, 232, 1);
  color: rgba(241, 218, 232, var(--text-opacity));
}

.hover\\:text-programEditorTabColors-3h:hover{
  --text-opacity: 1;
  color: #ffe6f2;
  color: rgba(255, 230, 242, 1);
  color: rgba(255, 230, 242, var(--text-opacity));
}

.hover\\:text-programEditorTabColors-4h:hover{
  --text-opacity: 1;
  color: #f9ecd2;
  color: rgba(249, 236, 210, 1);
  color: rgba(249, 236, 210, var(--text-opacity));
}

.hover\\:text-programEditorTabColors-5h:hover{
  --text-opacity: 1;
  color: #f5ebfa;
  color: rgba(245, 235, 250, 1);
  color: rgba(245, 235, 250, var(--text-opacity));
}

.hover\\:text-programEditorTabColors-6h:hover{
  --text-opacity: 1;
  color: #ffe8e6;
  color: rgba(255, 232, 230, 1);
  color: rgba(255, 232, 230, var(--text-opacity));
}

.hover\\:text-programEditorPresetTabColors-1:hover{
  --text-opacity: 1;
  color: #798fa3;
  color: rgba(121, 143, 163, 1);
  color: rgba(121, 143, 163, var(--text-opacity));
}

.hover\\:text-programEditorPresetTabColors-1h:hover{
  --text-opacity: 1;
  color: #798fa3;
  color: rgba(121, 143, 163, 1);
  color: rgba(121, 143, 163, var(--text-opacity));
}

.hover\\:text-borgScaleColors-0:hover{
  --text-opacity: 1;
  color: #c5d1ff;
  color: rgba(197, 209, 255, 1);
  color: rgba(197, 209, 255, var(--text-opacity));
}

.hover\\:text-borgScaleColors-1:hover{
  --text-opacity: 1;
  color: #a0b5fc;
  color: rgba(160, 181, 252, 1);
  color: rgba(160, 181, 252, var(--text-opacity));
}

.hover\\:text-borgScaleColors-2:hover{
  --text-opacity: 1;
  color: #7492ff;
  color: rgba(116, 146, 255, 1);
  color: rgba(116, 146, 255, var(--text-opacity));
}

.hover\\:text-borgScaleColors-3:hover{
  --text-opacity: 1;
  color: #82bbf1;
  color: rgba(130, 187, 241, 1);
  color: rgba(130, 187, 241, var(--text-opacity));
}

.hover\\:text-borgScaleColors-4:hover{
  --text-opacity: 1;
  color: #4ba4f7;
  color: rgba(75, 164, 247, 1);
  color: rgba(75, 164, 247, var(--text-opacity));
}

.hover\\:text-borgScaleColors-5:hover{
  --text-opacity: 1;
  color: #9cdd57;
  color: rgba(156, 221, 87, 1);
  color: rgba(156, 221, 87, var(--text-opacity));
}

.hover\\:text-borgScaleColors-6:hover{
  --text-opacity: 1;
  color: #68af00;
  color: rgba(104, 175, 0, 1);
  color: rgba(104, 175, 0, var(--text-opacity));
}

.hover\\:text-borgScaleColors-7:hover{
  --text-opacity: 1;
  color: #f5e380;
  color: rgba(245, 227, 128, 1);
  color: rgba(245, 227, 128, var(--text-opacity));
}

.hover\\:text-borgScaleColors-8:hover{
  --text-opacity: 1;
  color: #ffc246;
  color: rgba(255, 194, 70, 1);
  color: rgba(255, 194, 70, var(--text-opacity));
}

.hover\\:text-borgScaleColors-9:hover{
  --text-opacity: 1;
  color: #ff782f;
  color: rgba(255, 120, 47, 1);
  color: rgba(255, 120, 47, var(--text-opacity));
}

.hover\\:text-borgScaleColors-10:hover{
  --text-opacity: 1;
  color: #f25757;
  color: rgba(242, 87, 87, 1);
  color: rgba(242, 87, 87, var(--text-opacity));
}

.focus\\:text-transparent:focus{
  color: transparent;
}

.focus\\:text-focus:focus{
  color: rgba(4, 21, 39, 0.8);;
}

.focus\\:text-black:focus{
  --text-opacity: 1;
  color: #000;
  color: rgba(0, 0, 0, 1);
  color: rgba(0, 0, 0, var(--text-opacity));
}

.focus\\:text-white:focus{
  --text-opacity: 1;
  color: #fff;
  color: rgba(255, 255, 255, 1);
  color: rgba(255, 255, 255, var(--text-opacity));
}

.focus\\:text-primary:focus{
  --text-opacity: 1;
  color: #37A4DC;
  color: rgba(55, 164, 220, 1);
  color: rgba(55, 164, 220, var(--text-opacity));
}

.focus\\:text-disabled:focus{
  --text-opacity: 1;
  color: #BFBFBF;
  color: rgba(191, 191, 191, 1);
  color: rgba(191, 191, 191, var(--text-opacity));
}

.focus\\:text-translucent-60:focus{
  color: rgba(256, 256, 256, 0.6);
}

.focus\\:text-translucent-90:focus{
  color: rgba(256, 256, 256, 0.9);
}

.focus\\:text-green-200:focus{
  --text-opacity: 1;
  color: #f4fcea;
  color: rgba(244, 252, 234, 1);
  color: rgba(244, 252, 234, var(--text-opacity));
}

.focus\\:text-green-400:focus{
  --text-opacity: 1;
  color: #6CCA98;
  color: rgba(108, 202, 152, 1);
  color: rgba(108, 202, 152, var(--text-opacity));
}

.focus\\:text-green-500:focus{
  --text-opacity: 1;
  color: #97E812;
  color: rgba(151, 232, 18, 1);
  color: rgba(151, 232, 18, var(--text-opacity));
}

.focus\\:text-green-600:focus{
  --text-opacity: 1;
  color: #4f9112;
  color: rgba(79, 145, 18, 1);
  color: rgba(79, 145, 18, var(--text-opacity));
}

.focus\\:text-green-700:focus{
  --text-opacity: 1;
  color: #3e7211;
  color: rgba(62, 114, 17, 1);
  color: rgba(62, 114, 17, var(--text-opacity));
}

.focus\\:text-green-400a50:focus{
  color: rgba(108,202,152,0.50196);
}

.focus\\:text-green-500a25:focus{
  color: rgba(151,232,18,0.09804);
}

.focus\\:text-yellow-200:focus{
  --text-opacity: 1;
  color: #fff9eb;
  color: rgba(255, 249, 235, 1);
  color: rgba(255, 249, 235, var(--text-opacity));
}

.focus\\:text-yellow-300:focus{
  --text-opacity: 1;
  color: #ffe9bd;
  color: rgba(255, 233, 189, 1);
  color: rgba(255, 233, 189, var(--text-opacity));
}

.focus\\:text-yellow-500:focus{
  --text-opacity: 1;
  color: #FFC82C;
  color: rgba(255, 200, 44, 1);
  color: rgba(255, 200, 44, var(--text-opacity));
}

.focus\\:text-yellow-600:focus{
  --text-opacity: 1;
  color: #F7931E;
  color: rgba(247, 147, 30, 1);
  color: rgba(247, 147, 30, var(--text-opacity));
}

.focus\\:text-yellow-700:focus{
  --text-opacity: 1;
  color: #E1AD28;
  color: rgba(225, 173, 40, 1);
  color: rgba(225, 173, 40, var(--text-opacity));
}

.focus\\:text-yellow-300a66:focus{
  color: rgba(255,233,189,0.66667);
}

.focus\\:text-yellow-500a25:focus{
  color: rgba(255,200,44,0.09804);
}

.focus\\:text-orange-200:focus{
  --text-opacity: 1;
  color: #fdf0ea;
  color: rgba(253, 240, 234, 1);
  color: rgba(253, 240, 234, var(--text-opacity));
}

.focus\\:text-orange-400:focus{
  --text-opacity: 1;
  color: #f6c66f;
  color: rgba(246, 198, 111, 1);
  color: rgba(246, 198, 111, var(--text-opacity));
}

.focus\\:text-orange-500:focus{
  --text-opacity: 1;
  color: #F07313;
  color: rgba(240, 115, 19, 1);
  color: rgba(240, 115, 19, var(--text-opacity));
}

.focus\\:text-orange-800:focus{
  --text-opacity: 1;
  color: #db5d0c;
  color: rgba(219, 93, 12, 1);
  color: rgba(219, 93, 12, var(--text-opacity));
}

.focus\\:text-orange-900:focus{
  --text-opacity: 1;
  color: #b86814;
  color: rgba(184, 104, 20, 1);
  color: rgba(184, 104, 20, var(--text-opacity));
}

.focus\\:text-orange-500a25:focus{
  color: rgba(240,115,23,0.09804);
}

.focus\\:text-red-100:focus{
  --text-opacity: 1;
  color: #FEF5F5;
  color: rgba(254, 245, 245, 1);
  color: rgba(254, 245, 245, var(--text-opacity));
}

.focus\\:text-red-150:focus{
  --text-opacity: 1;
  color: #ffe9e8;
  color: rgba(255, 233, 232, 1);
  color: rgba(255, 233, 232, var(--text-opacity));
}

.focus\\:text-red-200:focus{
  --text-opacity: 1;
  color: #F8CECC;
  color: rgba(248, 206, 204, 1);
  color: rgba(248, 206, 204, var(--text-opacity));
}

.focus\\:text-red-300:focus{
  --text-opacity: 1;
  color: #ff8585;
  color: rgba(255, 133, 133, 1);
  color: rgba(255, 133, 133, var(--text-opacity));
}

.focus\\:text-red-400:focus{
  --text-opacity: 1;
  color: #ff3535;
  color: rgba(255, 53, 53, 1);
  color: rgba(255, 53, 53, var(--text-opacity));
}

.focus\\:text-red-500:focus{
  --text-opacity: 1;
  color: #DD4746;
  color: rgba(221, 71, 70, 1);
  color: rgba(221, 71, 70, var(--text-opacity));
}

.focus\\:text-red-700:focus{
  --text-opacity: 1;
  color: #A23C24;
  color: rgba(162, 60, 36, 1);
  color: rgba(162, 60, 36, var(--text-opacity));
}

.focus\\:text-gray-50:focus{
  --text-opacity: 1;
  color: #F9F9F9;
  color: rgba(249, 249, 249, 1);
  color: rgba(249, 249, 249, var(--text-opacity));
}

.focus\\:text-gray-100:focus{
  --text-opacity: 1;
  color: #F1F1F2;
  color: rgba(241, 241, 242, 1);
  color: rgba(241, 241, 242, var(--text-opacity));
}

.focus\\:text-gray-150:focus{
  --text-opacity: 1;
  color: #e6e6e6;
  color: rgba(230, 230, 230, 1);
  color: rgba(230, 230, 230, var(--text-opacity));
}

.focus\\:text-gray-200:focus{
  --text-opacity: 1;
  color: #E0E2E4;
  color: rgba(224, 226, 228, 1);
  color: rgba(224, 226, 228, var(--text-opacity));
}

.focus\\:text-gray-300:focus{
  --text-opacity: 1;
  color: #BFBFBF;
  color: rgba(191, 191, 191, 1);
  color: rgba(191, 191, 191, var(--text-opacity));
}

.focus\\:text-gray-400:focus{
  color: rgba(114,114,114,0.8);
}

.focus\\:text-gray-425:focus{
  color: rgba(4, 21, 39, 0.8);
}

.focus\\:text-gray-450:focus{
  --text-opacity: 1;
  color: #959595;
  color: rgba(149, 149, 149, 1);
  color: rgba(149, 149, 149, var(--text-opacity));
}

.focus\\:text-gray-500:focus{
  --text-opacity: 1;
  color: #727272;
  color: rgba(114, 114, 114, 1);
  color: rgba(114, 114, 114, var(--text-opacity));
}

.focus\\:text-gray-600:focus{
  --text-opacity: 1;
  color: #5a626b;
  color: rgba(90, 98, 107, 1);
  color: rgba(90, 98, 107, var(--text-opacity));
}

.focus\\:text-gray-625:focus{
  color: rgba(90,98,107,0.8);
}

.focus\\:text-gray-700:focus{
  --text-opacity: 1;
  color: #464C59;
  color: rgba(70, 76, 89, 1);
  color: rgba(70, 76, 89, var(--text-opacity));
}

.focus\\:text-gray-800:focus{
  --text-opacity: 1;
  color: #3c3b3b;
  color: rgba(60, 59, 59, 1);
  color: rgba(60, 59, 59, var(--text-opacity));
}

.focus\\:text-gray-200a50:focus{
  color: rgba(224, 226, 228, 0.5);
}

.focus\\:text-blue-50:focus{
  --text-opacity: 1;
  color: #f2fbff;
  color: rgba(242, 251, 255, 1);
  color: rgba(242, 251, 255, var(--text-opacity));
}

.focus\\:text-blue-100:focus{
  --text-opacity: 1;
  color: #EBF6FC;
  color: rgba(235, 246, 252, 1);
  color: rgba(235, 246, 252, var(--text-opacity));
}

.focus\\:text-blue-150:focus{
  --text-opacity: 1;
  color: #E8EEF1;
  color: rgba(232, 238, 241, 1);
  color: rgba(232, 238, 241, var(--text-opacity));
}

.focus\\:text-blue-200:focus{
  --text-opacity: 1;
  color: #CCE6F5;
  color: rgba(204, 230, 245, 1);
  color: rgba(204, 230, 245, var(--text-opacity));
}

.focus\\:text-blue-300:focus{
  --text-opacity: 1;
  color: #73BFE7;
  color: rgba(115, 191, 231, 1);
  color: rgba(115, 191, 231, var(--text-opacity));
}

.focus\\:text-blue-400:focus{
  --text-opacity: 1;
  color: #4BA4F7;
  color: rgba(75, 164, 247, 1);
  color: rgba(75, 164, 247, var(--text-opacity));
}

.focus\\:text-blue-500:focus{
  --text-opacity: 1;
  color: #37A4DC;
  color: rgba(55, 164, 220, 1);
  color: rgba(55, 164, 220, var(--text-opacity));
}

.focus\\:text-blue-600:focus{
  --text-opacity: 1;
  color: #6AA2D6;
  color: rgba(106, 162, 214, 1);
  color: rgba(106, 162, 214, var(--text-opacity));
}

.focus\\:text-blue-700:focus{
  --text-opacity: 1;
  color: #456E9A;
  color: rgba(69, 110, 154, 1);
  color: rgba(69, 110, 154, var(--text-opacity));
}

.focus\\:text-blue-750:focus{
  --text-opacity: 1;
  color: #5682AA;
  color: rgba(86, 130, 170, 1);
  color: rgba(86, 130, 170, var(--text-opacity));
}

.focus\\:text-blue-800:focus{
  --text-opacity: 1;
  color: #1F4566;
  color: rgba(31, 69, 102, 1);
  color: rgba(31, 69, 102, var(--text-opacity));
}

.focus\\:text-blue-900:focus{
  --text-opacity: 1;
  color: #183453;
  color: rgba(24, 52, 83, 1);
  color: rgba(24, 52, 83, var(--text-opacity));
}

.focus\\:text-blue-950:focus{
  --text-opacity: 1;
  color: #041527;
  color: rgba(4, 21, 39, 1);
  color: rgba(4, 21, 39, var(--text-opacity));
}

.focus\\:text-blue-500a25:focus{
  color: rgba(55, 164, 220, 0.2);
}

.focus\\:text-blue-500a50:focus{
  color: rgba(55, 164, 220, 0.5);
}

.focus\\:text-blue-700a75:focus{
  --text-opacity: 1;
  color: #3B648D;
  color: rgba(59, 100, 141, 1);
  color: rgba(59, 100, 141, var(--text-opacity));
}

.focus\\:text-blue-700a30:focus{
  --text-opacity: 1;
  color: #2A5176;
  color: rgba(42, 81, 118, 1);
  color: rgba(42, 81, 118, var(--text-opacity));
}

.focus\\:text-blue-750a25:focus{
  color: rgba(86,130,170,0.09804);
}

.focus\\:text-blue-750a15:focus{
  color: rgba(86,130,170,0.05882);
}

.focus\\:text-blue-800a60:focus{
  color: rgba(31, 69, 102, 0.6);
}

.focus\\:text-programEditorTabColors-1:focus{
  --text-opacity: 1;
  color: #3cacae;
  color: rgba(60, 172, 174, 1);
  color: rgba(60, 172, 174, var(--text-opacity));
}

.focus\\:text-programEditorTabColors-2:focus{
  --text-opacity: 1;
  color: #8e346a;
  color: rgba(142, 52, 106, 1);
  color: rgba(142, 52, 106, var(--text-opacity));
}

.focus\\:text-programEditorTabColors-3:focus{
  --text-opacity: 1;
  color: #ff72b7;
  color: rgba(255, 114, 183, 1);
  color: rgba(255, 114, 183, var(--text-opacity));
}

.focus\\:text-programEditorTabColors-4:focus{
  --text-opacity: 1;
  color: #ce941c;
  color: rgba(206, 148, 28, 1);
  color: rgba(206, 148, 28, var(--text-opacity));
}

.focus\\:text-programEditorTabColors-5:focus{
  --text-opacity: 1;
  color: #b973d9;
  color: rgba(185, 115, 217, 1);
  color: rgba(185, 115, 217, var(--text-opacity));
}

.focus\\:text-programEditorTabColors-6:focus{
  --text-opacity: 1;
  color: #ff9082;
  color: rgba(255, 144, 130, 1);
  color: rgba(255, 144, 130, var(--text-opacity));
}

.focus\\:text-programEditorTabColors-1h:focus{
  --text-opacity: 1;
  color: #d9f2f2;
  color: rgba(217, 242, 242, 1);
  color: rgba(217, 242, 242, var(--text-opacity));
}

.focus\\:text-programEditorTabColors-2h:focus{
  --text-opacity: 1;
  color: #f1dae8;
  color: rgba(241, 218, 232, 1);
  color: rgba(241, 218, 232, var(--text-opacity));
}

.focus\\:text-programEditorTabColors-3h:focus{
  --text-opacity: 1;
  color: #ffe6f2;
  color: rgba(255, 230, 242, 1);
  color: rgba(255, 230, 242, var(--text-opacity));
}

.focus\\:text-programEditorTabColors-4h:focus{
  --text-opacity: 1;
  color: #f9ecd2;
  color: rgba(249, 236, 210, 1);
  color: rgba(249, 236, 210, var(--text-opacity));
}

.focus\\:text-programEditorTabColors-5h:focus{
  --text-opacity: 1;
  color: #f5ebfa;
  color: rgba(245, 235, 250, 1);
  color: rgba(245, 235, 250, var(--text-opacity));
}

.focus\\:text-programEditorTabColors-6h:focus{
  --text-opacity: 1;
  color: #ffe8e6;
  color: rgba(255, 232, 230, 1);
  color: rgba(255, 232, 230, var(--text-opacity));
}

.focus\\:text-programEditorPresetTabColors-1:focus{
  --text-opacity: 1;
  color: #798fa3;
  color: rgba(121, 143, 163, 1);
  color: rgba(121, 143, 163, var(--text-opacity));
}

.focus\\:text-programEditorPresetTabColors-1h:focus{
  --text-opacity: 1;
  color: #798fa3;
  color: rgba(121, 143, 163, 1);
  color: rgba(121, 143, 163, var(--text-opacity));
}

.focus\\:text-borgScaleColors-0:focus{
  --text-opacity: 1;
  color: #c5d1ff;
  color: rgba(197, 209, 255, 1);
  color: rgba(197, 209, 255, var(--text-opacity));
}

.focus\\:text-borgScaleColors-1:focus{
  --text-opacity: 1;
  color: #a0b5fc;
  color: rgba(160, 181, 252, 1);
  color: rgba(160, 181, 252, var(--text-opacity));
}

.focus\\:text-borgScaleColors-2:focus{
  --text-opacity: 1;
  color: #7492ff;
  color: rgba(116, 146, 255, 1);
  color: rgba(116, 146, 255, var(--text-opacity));
}

.focus\\:text-borgScaleColors-3:focus{
  --text-opacity: 1;
  color: #82bbf1;
  color: rgba(130, 187, 241, 1);
  color: rgba(130, 187, 241, var(--text-opacity));
}

.focus\\:text-borgScaleColors-4:focus{
  --text-opacity: 1;
  color: #4ba4f7;
  color: rgba(75, 164, 247, 1);
  color: rgba(75, 164, 247, var(--text-opacity));
}

.focus\\:text-borgScaleColors-5:focus{
  --text-opacity: 1;
  color: #9cdd57;
  color: rgba(156, 221, 87, 1);
  color: rgba(156, 221, 87, var(--text-opacity));
}

.focus\\:text-borgScaleColors-6:focus{
  --text-opacity: 1;
  color: #68af00;
  color: rgba(104, 175, 0, 1);
  color: rgba(104, 175, 0, var(--text-opacity));
}

.focus\\:text-borgScaleColors-7:focus{
  --text-opacity: 1;
  color: #f5e380;
  color: rgba(245, 227, 128, 1);
  color: rgba(245, 227, 128, var(--text-opacity));
}

.focus\\:text-borgScaleColors-8:focus{
  --text-opacity: 1;
  color: #ffc246;
  color: rgba(255, 194, 70, 1);
  color: rgba(255, 194, 70, var(--text-opacity));
}

.focus\\:text-borgScaleColors-9:focus{
  --text-opacity: 1;
  color: #ff782f;
  color: rgba(255, 120, 47, 1);
  color: rgba(255, 120, 47, var(--text-opacity));
}

.focus\\:text-borgScaleColors-10:focus{
  --text-opacity: 1;
  color: #f25757;
  color: rgba(242, 87, 87, 1);
  color: rgba(242, 87, 87, var(--text-opacity));
}

.text-opacity-0{
  --text-opacity: 0;
}

.text-opacity-25{
  --text-opacity: .25;
}

.text-opacity-50{
  --text-opacity: .5;
}

.text-opacity-75{
  --text-opacity: .75;
}

.text-opacity-100{
  --text-opacity: 1;
}

.hover\\:text-opacity-0:hover{
  --text-opacity: 0;
}

.hover\\:text-opacity-25:hover{
  --text-opacity: .25;
}

.hover\\:text-opacity-50:hover{
  --text-opacity: .5;
}

.hover\\:text-opacity-75:hover{
  --text-opacity: .75;
}

.hover\\:text-opacity-100:hover{
  --text-opacity: 1;
}

.focus\\:text-opacity-0:focus{
  --text-opacity: 0;
}

.focus\\:text-opacity-25:focus{
  --text-opacity: .25;
}

.focus\\:text-opacity-50:focus{
  --text-opacity: .5;
}

.focus\\:text-opacity-75:focus{
  --text-opacity: .75;
}

.focus\\:text-opacity-100:focus{
  --text-opacity: 1;
}

.italic{
  font-style: italic;
}

.not-italic{
  font-style: normal;
}

.uppercase{
  text-transform: uppercase;
}

.lowercase{
  text-transform: lowercase;
}

.capitalize{
  text-transform: capitalize;
}

.normal-case{
  text-transform: none;
}

.underline{
  text-decoration: underline;
}

.line-through{
  text-decoration: line-through;
}

.no-underline{
  text-decoration: none;
}

.hover\\:underline:hover{
  text-decoration: underline;
}

.hover\\:line-through:hover{
  text-decoration: line-through;
}

.hover\\:no-underline:hover{
  text-decoration: none;
}

.focus\\:underline:focus{
  text-decoration: underline;
}

.focus\\:line-through:focus{
  text-decoration: line-through;
}

.focus\\:no-underline:focus{
  text-decoration: none;
}

.antialiased{
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.subpixel-antialiased{
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
}

.ordinal, .slashed-zero, .lining-nums, .oldstyle-nums, .proportional-nums, .tabular-nums, .diagonal-fractions, .stacked-fractions{
  --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);
  --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);
  --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);
  --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);
  --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);
  font-feature-settings: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
  font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
}

.normal-nums{
  font-feature-settings: normal;
  font-variant-numeric: normal;
}

.ordinal{
  --font-variant-numeric-ordinal: ordinal;
}

.slashed-zero{
  --font-variant-numeric-slashed-zero: slashed-zero;
}

.lining-nums{
  --font-variant-numeric-figure: lining-nums;
}

.oldstyle-nums{
  --font-variant-numeric-figure: oldstyle-nums;
}

.proportional-nums{
  --font-variant-numeric-spacing: proportional-nums;
}

.tabular-nums{
  --font-variant-numeric-spacing: tabular-nums;
}

.diagonal-fractions{
  --font-variant-numeric-fraction: diagonal-fractions;
}

.stacked-fractions{
  --font-variant-numeric-fraction: stacked-fractions;
}

.tracking-tight{
  letter-spacing: -0.025em;
}

.tracking-normal{
  letter-spacing: 0;
}

.tracking-wide{
  letter-spacing: 0.01em;
}

.tracking-wider{
  letter-spacing: 0.02em;
}

.tracking-widest{
  letter-spacing: 0.05em;
}

.select-none{
  -webkit-user-select: none;
          user-select: none;
}

.select-text{
  -webkit-user-select: text;
          user-select: text;
}

.select-all{
  -webkit-user-select: all;
          user-select: all;
}

.select-auto{
  -webkit-user-select: auto;
          user-select: auto;
}

.align-baseline{
  vertical-align: baseline;
}

.align-top{
  vertical-align: top;
}

.align-middle{
  vertical-align: middle;
}

.align-bottom{
  vertical-align: bottom;
}

.align-text-top{
  vertical-align: text-top;
}

.align-text-bottom{
  vertical-align: text-bottom;
}

.visible{
  visibility: visible;
}

.invisible{
  visibility: hidden;
}

.whitespace-normal{
  white-space: normal;
}

.whitespace-no-wrap{
  white-space: nowrap;
}

.whitespace-pre{
  white-space: pre;
}

.whitespace-pre-line{
  white-space: pre-line;
}

.whitespace-pre-wrap{
  white-space: pre-wrap;
}

.break-normal{
  word-wrap: normal;
  word-wrap: normal;
  word-break: normal;
}

.break-words{
  word-wrap: break-word;
  word-wrap: break-word;
}

.break-all{
  word-break: break-all;
}

.truncate{
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.w-0{
  width: 0;
}

.w-1{
  width: 0.25rem;
}

.w-2{
  width: 0.5rem;
}

.w-3{
  width: 0.75rem;
}

.w-4{
  width: 1rem;
}

.w-5{
  width: 1.25rem;
}

.w-6{
  width: 1.5rem;
}

.w-7{
  width: 1.75rem;
}

.w-8{
  width: 2rem;
}

.w-9{
  width: 2.25rem;
}

.w-10{
  width: 2.5rem;
}

.w-11{
  width: 2.75rem;
}

.w-12{
  width: 3rem;
}

.w-14{
  width: 3.5rem;
}

.w-15{
  width: 3.75rem;
}

.w-16{
  width: 4rem;
}

.w-18{
  width: 4.5rem;
}

.w-20{
  width: 5rem;
}

.w-22{
  width: 5.5rem;
}

.w-23{
  width: 5.75rem;
}

.w-24{
  width: 6rem;
}

.w-25{
  width: 6.25rem;
}

.w-26{
  width: 6.5rem;
}

.w-28{
  width: 7rem;
}

.w-30{
  width: 7.5rem;
}

.w-32{
  width: 8rem;
}

.w-34{
  width: 8.5rem;
}

.w-40{
  width: 10rem;
}

.w-42{
  width: 10.5rem;
}

.w-44{
  width: 11rem;
}

.w-48{
  width: 12rem;
}

.w-52{
  width: 13rem;
}

.w-54{
  width: 13.5rem;
}

.w-56{
  width: 14rem;
}

.w-60{
  width: 15rem;
}

.w-64{
  width: 16rem;
}

.w-68{
  width: 17rem;
}

.w-72{
  width: 18rem;
}

.w-74{
  width: 18.5rem;
}

.w-76{
  width: 19rem;
}

.w-78{
  width: 19.5rem;
}

.w-80{
  width: 20rem;
}

.w-82{
  width: 20.5rem;
}

.w-84{
  width: 21rem;
}

.w-88{
  width: 22rem;
}

.w-92{
  width: 23rem;
}

.w-96{
  width: 24rem;
}

.w-98{
  width: 24.5rem;
}

.w-100{
  width: 25rem;
}

.w-104{
  width: 26rem;
}

.w-112{
  width: 28rem;
}

.w-124{
  width: 31rem;
}

.w-128{
  width: 32rem;
}

.w-140{
  width: 35rem;
}

.w-152{
  width: 38rem;
}

.w-160{
  width: 40rem;
}

.w-162{
  width: 41rem;
}

.w-192{
  width: 48rem;
}

.w-208{
  width: 52rem;
}

.w-224{
  width: 56rem;
}

.w-256{
  width: 64rem;
}

.w-auto{
  width: auto;
}

.w-px{
  width: 1px;
}

.w-1\\/2{
  width: 50%;
}

.w-1\\/3{
  width: 33.33333%;
}

.w-2\\/3{
  width: 66.66667%;
}

.w-1\\/4{
  width: 25%;
}

.w-3\\/4{
  width: 75%;
}

.w-1\\/5{
  width: 20%;
}

.w-2\\/5{
  width: 40%;
}

.w-3\\/5{
  width: 60%;
}

.w-4\\/5{
  width: 80%;
}

.w-1\\/6{
  width: 16.66667%;
}

.w-5\\/6{
  width: 83.33333%;
}

.w-1\\/7{
  width: 14.285714285%;
}

.w-2\\/7{
  width: 28.571428571%;
}

.w-3\\/7{
  width: 42.85714285%;
}

.w-4\\/7{
  width: 57.14285714%;
}

.w-1\\/9{
  width: 11.1111%;
}

.w-9\\/10{
  width: 90%;
}

.w-full{
  width: 100%;
}

.w-screen{
  width: 100vw;
}

.w-max{
  width: max-content;
}

.z-0{
  z-index: 0;
}

.z-10{
  z-index: 10;
}

.z-20{
  z-index: 20;
}

.z-30{
  z-index: 30;
}

.z-40{
  z-index: 40;
}

.z-50{
  z-index: 50;
}

.z-auto{
  z-index: auto;
}

.gap-0{
  grid-gap: 0;
  gap: 0;
}

.gap-1{
  grid-gap: 0.25rem;
  gap: 0.25rem;
}

.gap-2{
  grid-gap: 0.5rem;
  gap: 0.5rem;
}

.gap-3{
  grid-gap: 0.75rem;
  gap: 0.75rem;
}

.gap-4{
  grid-gap: 1rem;
  gap: 1rem;
}

.gap-5{
  grid-gap: 1.25rem;
  gap: 1.25rem;
}

.gap-6{
  grid-gap: 1.5rem;
  gap: 1.5rem;
}

.gap-7{
  grid-gap: 1.75rem;
  gap: 1.75rem;
}

.gap-8{
  grid-gap: 2rem;
  gap: 2rem;
}

.gap-9{
  grid-gap: 2.25rem;
  gap: 2.25rem;
}

.gap-10{
  grid-gap: 2.5rem;
  gap: 2.5rem;
}

.gap-11{
  grid-gap: 2.75rem;
  gap: 2.75rem;
}

.gap-12{
  grid-gap: 3rem;
  gap: 3rem;
}

.gap-14{
  grid-gap: 3.5rem;
  gap: 3.5rem;
}

.gap-15{
  grid-gap: 3.75rem;
  gap: 3.75rem;
}

.gap-16{
  grid-gap: 4rem;
  gap: 4rem;
}

.gap-18{
  grid-gap: 4.5rem;
  gap: 4.5rem;
}

.gap-20{
  grid-gap: 5rem;
  gap: 5rem;
}

.gap-22{
  grid-gap: 5.5rem;
  gap: 5.5rem;
}

.gap-23{
  grid-gap: 5.75rem;
  gap: 5.75rem;
}

.gap-24{
  grid-gap: 6rem;
  gap: 6rem;
}

.gap-25{
  grid-gap: 6.25rem;
  gap: 6.25rem;
}

.gap-26{
  grid-gap: 6.5rem;
  gap: 6.5rem;
}

.gap-28{
  grid-gap: 7rem;
  gap: 7rem;
}

.gap-30{
  grid-gap: 7.5rem;
  gap: 7.5rem;
}

.gap-32{
  grid-gap: 8rem;
  gap: 8rem;
}

.gap-34{
  grid-gap: 8.5rem;
  gap: 8.5rem;
}

.gap-40{
  grid-gap: 10rem;
  gap: 10rem;
}

.gap-42{
  grid-gap: 10.5rem;
  gap: 10.5rem;
}

.gap-44{
  grid-gap: 11rem;
  gap: 11rem;
}

.gap-48{
  grid-gap: 12rem;
  gap: 12rem;
}

.gap-52{
  grid-gap: 13rem;
  gap: 13rem;
}

.gap-54{
  grid-gap: 13.5rem;
  gap: 13.5rem;
}

.gap-56{
  grid-gap: 14rem;
  gap: 14rem;
}

.gap-60{
  grid-gap: 15rem;
  gap: 15rem;
}

.gap-64{
  grid-gap: 16rem;
  gap: 16rem;
}

.gap-68{
  grid-gap: 17rem;
  gap: 17rem;
}

.gap-72{
  grid-gap: 18rem;
  gap: 18rem;
}

.gap-74{
  grid-gap: 18.5rem;
  gap: 18.5rem;
}

.gap-76{
  grid-gap: 19rem;
  gap: 19rem;
}

.gap-78{
  grid-gap: 19.5rem;
  gap: 19.5rem;
}

.gap-80{
  grid-gap: 20rem;
  gap: 20rem;
}

.gap-82{
  grid-gap: 20.5rem;
  gap: 20.5rem;
}

.gap-84{
  grid-gap: 21rem;
  gap: 21rem;
}

.gap-88{
  grid-gap: 22rem;
  gap: 22rem;
}

.gap-92{
  grid-gap: 23rem;
  gap: 23rem;
}

.gap-96{
  grid-gap: 24rem;
  gap: 24rem;
}

.gap-98{
  grid-gap: 24.5rem;
  gap: 24.5rem;
}

.gap-100{
  grid-gap: 25rem;
  gap: 25rem;
}

.gap-104{
  grid-gap: 26rem;
  gap: 26rem;
}

.gap-112{
  grid-gap: 28rem;
  gap: 28rem;
}

.gap-124{
  grid-gap: 31rem;
  gap: 31rem;
}

.gap-128{
  grid-gap: 32rem;
  gap: 32rem;
}

.gap-140{
  grid-gap: 35rem;
  gap: 35rem;
}

.gap-152{
  grid-gap: 38rem;
  gap: 38rem;
}

.gap-160{
  grid-gap: 40rem;
  gap: 40rem;
}

.gap-162{
  grid-gap: 41rem;
  gap: 41rem;
}

.gap-192{
  grid-gap: 48rem;
  gap: 48rem;
}

.gap-208{
  grid-gap: 52rem;
  gap: 52rem;
}

.gap-224{
  grid-gap: 56rem;
  gap: 56rem;
}

.gap-256{
  grid-gap: 64rem;
  gap: 64rem;
}

.gap-px{
  grid-gap: 1px;
  gap: 1px;
}

.gap-x-0{
  grid-column-gap: 0;
  -moz-column-gap: 0;
       column-gap: 0;
}

.gap-x-1{
  grid-column-gap: 0.25rem;
  -moz-column-gap: 0.25rem;
       column-gap: 0.25rem;
}

.gap-x-2{
  grid-column-gap: 0.5rem;
  -moz-column-gap: 0.5rem;
       column-gap: 0.5rem;
}

.gap-x-3{
  grid-column-gap: 0.75rem;
  -moz-column-gap: 0.75rem;
       column-gap: 0.75rem;
}

.gap-x-4{
  grid-column-gap: 1rem;
  -moz-column-gap: 1rem;
       column-gap: 1rem;
}

.gap-x-5{
  grid-column-gap: 1.25rem;
  -moz-column-gap: 1.25rem;
       column-gap: 1.25rem;
}

.gap-x-6{
  grid-column-gap: 1.5rem;
  -moz-column-gap: 1.5rem;
       column-gap: 1.5rem;
}

.gap-x-7{
  grid-column-gap: 1.75rem;
  -moz-column-gap: 1.75rem;
       column-gap: 1.75rem;
}

.gap-x-8{
  grid-column-gap: 2rem;
  -moz-column-gap: 2rem;
       column-gap: 2rem;
}

.gap-x-9{
  grid-column-gap: 2.25rem;
  -moz-column-gap: 2.25rem;
       column-gap: 2.25rem;
}

.gap-x-10{
  grid-column-gap: 2.5rem;
  -moz-column-gap: 2.5rem;
       column-gap: 2.5rem;
}

.gap-x-11{
  grid-column-gap: 2.75rem;
  -moz-column-gap: 2.75rem;
       column-gap: 2.75rem;
}

.gap-x-12{
  grid-column-gap: 3rem;
  -moz-column-gap: 3rem;
       column-gap: 3rem;
}

.gap-x-14{
  grid-column-gap: 3.5rem;
  -moz-column-gap: 3.5rem;
       column-gap: 3.5rem;
}

.gap-x-15{
  grid-column-gap: 3.75rem;
  -moz-column-gap: 3.75rem;
       column-gap: 3.75rem;
}

.gap-x-16{
  grid-column-gap: 4rem;
  -moz-column-gap: 4rem;
       column-gap: 4rem;
}

.gap-x-18{
  grid-column-gap: 4.5rem;
  -moz-column-gap: 4.5rem;
       column-gap: 4.5rem;
}

.gap-x-20{
  grid-column-gap: 5rem;
  -moz-column-gap: 5rem;
       column-gap: 5rem;
}

.gap-x-22{
  grid-column-gap: 5.5rem;
  -moz-column-gap: 5.5rem;
       column-gap: 5.5rem;
}

.gap-x-23{
  grid-column-gap: 5.75rem;
  -moz-column-gap: 5.75rem;
       column-gap: 5.75rem;
}

.gap-x-24{
  grid-column-gap: 6rem;
  -moz-column-gap: 6rem;
       column-gap: 6rem;
}

.gap-x-25{
  grid-column-gap: 6.25rem;
  -moz-column-gap: 6.25rem;
       column-gap: 6.25rem;
}

.gap-x-26{
  grid-column-gap: 6.5rem;
  -moz-column-gap: 6.5rem;
       column-gap: 6.5rem;
}

.gap-x-28{
  grid-column-gap: 7rem;
  -moz-column-gap: 7rem;
       column-gap: 7rem;
}

.gap-x-30{
  grid-column-gap: 7.5rem;
  -moz-column-gap: 7.5rem;
       column-gap: 7.5rem;
}

.gap-x-32{
  grid-column-gap: 8rem;
  -moz-column-gap: 8rem;
       column-gap: 8rem;
}

.gap-x-34{
  grid-column-gap: 8.5rem;
  -moz-column-gap: 8.5rem;
       column-gap: 8.5rem;
}

.gap-x-40{
  grid-column-gap: 10rem;
  -moz-column-gap: 10rem;
       column-gap: 10rem;
}

.gap-x-42{
  grid-column-gap: 10.5rem;
  -moz-column-gap: 10.5rem;
       column-gap: 10.5rem;
}

.gap-x-44{
  grid-column-gap: 11rem;
  -moz-column-gap: 11rem;
       column-gap: 11rem;
}

.gap-x-48{
  grid-column-gap: 12rem;
  -moz-column-gap: 12rem;
       column-gap: 12rem;
}

.gap-x-52{
  grid-column-gap: 13rem;
  -moz-column-gap: 13rem;
       column-gap: 13rem;
}

.gap-x-54{
  grid-column-gap: 13.5rem;
  -moz-column-gap: 13.5rem;
       column-gap: 13.5rem;
}

.gap-x-56{
  grid-column-gap: 14rem;
  -moz-column-gap: 14rem;
       column-gap: 14rem;
}

.gap-x-60{
  grid-column-gap: 15rem;
  -moz-column-gap: 15rem;
       column-gap: 15rem;
}

.gap-x-64{
  grid-column-gap: 16rem;
  -moz-column-gap: 16rem;
       column-gap: 16rem;
}

.gap-x-68{
  grid-column-gap: 17rem;
  -moz-column-gap: 17rem;
       column-gap: 17rem;
}

.gap-x-72{
  grid-column-gap: 18rem;
  -moz-column-gap: 18rem;
       column-gap: 18rem;
}

.gap-x-74{
  grid-column-gap: 18.5rem;
  -moz-column-gap: 18.5rem;
       column-gap: 18.5rem;
}

.gap-x-76{
  grid-column-gap: 19rem;
  -moz-column-gap: 19rem;
       column-gap: 19rem;
}

.gap-x-78{
  grid-column-gap: 19.5rem;
  -moz-column-gap: 19.5rem;
       column-gap: 19.5rem;
}

.gap-x-80{
  grid-column-gap: 20rem;
  -moz-column-gap: 20rem;
       column-gap: 20rem;
}

.gap-x-82{
  grid-column-gap: 20.5rem;
  -moz-column-gap: 20.5rem;
       column-gap: 20.5rem;
}

.gap-x-84{
  grid-column-gap: 21rem;
  -moz-column-gap: 21rem;
       column-gap: 21rem;
}

.gap-x-88{
  grid-column-gap: 22rem;
  -moz-column-gap: 22rem;
       column-gap: 22rem;
}

.gap-x-92{
  grid-column-gap: 23rem;
  -moz-column-gap: 23rem;
       column-gap: 23rem;
}

.gap-x-96{
  grid-column-gap: 24rem;
  -moz-column-gap: 24rem;
       column-gap: 24rem;
}

.gap-x-98{
  grid-column-gap: 24.5rem;
  -moz-column-gap: 24.5rem;
       column-gap: 24.5rem;
}

.gap-x-100{
  grid-column-gap: 25rem;
  -moz-column-gap: 25rem;
       column-gap: 25rem;
}

.gap-x-104{
  grid-column-gap: 26rem;
  -moz-column-gap: 26rem;
       column-gap: 26rem;
}

.gap-x-112{
  grid-column-gap: 28rem;
  -moz-column-gap: 28rem;
       column-gap: 28rem;
}

.gap-x-124{
  grid-column-gap: 31rem;
  -moz-column-gap: 31rem;
       column-gap: 31rem;
}

.gap-x-128{
  grid-column-gap: 32rem;
  -moz-column-gap: 32rem;
       column-gap: 32rem;
}

.gap-x-140{
  grid-column-gap: 35rem;
  -moz-column-gap: 35rem;
       column-gap: 35rem;
}

.gap-x-152{
  grid-column-gap: 38rem;
  -moz-column-gap: 38rem;
       column-gap: 38rem;
}

.gap-x-160{
  grid-column-gap: 40rem;
  -moz-column-gap: 40rem;
       column-gap: 40rem;
}

.gap-x-162{
  grid-column-gap: 41rem;
  -moz-column-gap: 41rem;
       column-gap: 41rem;
}

.gap-x-192{
  grid-column-gap: 48rem;
  -moz-column-gap: 48rem;
       column-gap: 48rem;
}

.gap-x-208{
  grid-column-gap: 52rem;
  -moz-column-gap: 52rem;
       column-gap: 52rem;
}

.gap-x-224{
  grid-column-gap: 56rem;
  -moz-column-gap: 56rem;
       column-gap: 56rem;
}

.gap-x-256{
  grid-column-gap: 64rem;
  -moz-column-gap: 64rem;
       column-gap: 64rem;
}

.gap-x-px{
  grid-column-gap: 1px;
  -moz-column-gap: 1px;
       column-gap: 1px;
}

.gap-y-0{
  grid-row-gap: 0;
  row-gap: 0;
}

.gap-y-1{
  grid-row-gap: 0.25rem;
  row-gap: 0.25rem;
}

.gap-y-2{
  grid-row-gap: 0.5rem;
  row-gap: 0.5rem;
}

.gap-y-3{
  grid-row-gap: 0.75rem;
  row-gap: 0.75rem;
}

.gap-y-4{
  grid-row-gap: 1rem;
  row-gap: 1rem;
}

.gap-y-5{
  grid-row-gap: 1.25rem;
  row-gap: 1.25rem;
}

.gap-y-6{
  grid-row-gap: 1.5rem;
  row-gap: 1.5rem;
}

.gap-y-7{
  grid-row-gap: 1.75rem;
  row-gap: 1.75rem;
}

.gap-y-8{
  grid-row-gap: 2rem;
  row-gap: 2rem;
}

.gap-y-9{
  grid-row-gap: 2.25rem;
  row-gap: 2.25rem;
}

.gap-y-10{
  grid-row-gap: 2.5rem;
  row-gap: 2.5rem;
}

.gap-y-11{
  grid-row-gap: 2.75rem;
  row-gap: 2.75rem;
}

.gap-y-12{
  grid-row-gap: 3rem;
  row-gap: 3rem;
}

.gap-y-14{
  grid-row-gap: 3.5rem;
  row-gap: 3.5rem;
}

.gap-y-15{
  grid-row-gap: 3.75rem;
  row-gap: 3.75rem;
}

.gap-y-16{
  grid-row-gap: 4rem;
  row-gap: 4rem;
}

.gap-y-18{
  grid-row-gap: 4.5rem;
  row-gap: 4.5rem;
}

.gap-y-20{
  grid-row-gap: 5rem;
  row-gap: 5rem;
}

.gap-y-22{
  grid-row-gap: 5.5rem;
  row-gap: 5.5rem;
}

.gap-y-23{
  grid-row-gap: 5.75rem;
  row-gap: 5.75rem;
}

.gap-y-24{
  grid-row-gap: 6rem;
  row-gap: 6rem;
}

.gap-y-25{
  grid-row-gap: 6.25rem;
  row-gap: 6.25rem;
}

.gap-y-26{
  grid-row-gap: 6.5rem;
  row-gap: 6.5rem;
}

.gap-y-28{
  grid-row-gap: 7rem;
  row-gap: 7rem;
}

.gap-y-30{
  grid-row-gap: 7.5rem;
  row-gap: 7.5rem;
}

.gap-y-32{
  grid-row-gap: 8rem;
  row-gap: 8rem;
}

.gap-y-34{
  grid-row-gap: 8.5rem;
  row-gap: 8.5rem;
}

.gap-y-40{
  grid-row-gap: 10rem;
  row-gap: 10rem;
}

.gap-y-42{
  grid-row-gap: 10.5rem;
  row-gap: 10.5rem;
}

.gap-y-44{
  grid-row-gap: 11rem;
  row-gap: 11rem;
}

.gap-y-48{
  grid-row-gap: 12rem;
  row-gap: 12rem;
}

.gap-y-52{
  grid-row-gap: 13rem;
  row-gap: 13rem;
}

.gap-y-54{
  grid-row-gap: 13.5rem;
  row-gap: 13.5rem;
}

.gap-y-56{
  grid-row-gap: 14rem;
  row-gap: 14rem;
}

.gap-y-60{
  grid-row-gap: 15rem;
  row-gap: 15rem;
}

.gap-y-64{
  grid-row-gap: 16rem;
  row-gap: 16rem;
}

.gap-y-68{
  grid-row-gap: 17rem;
  row-gap: 17rem;
}

.gap-y-72{
  grid-row-gap: 18rem;
  row-gap: 18rem;
}

.gap-y-74{
  grid-row-gap: 18.5rem;
  row-gap: 18.5rem;
}

.gap-y-76{
  grid-row-gap: 19rem;
  row-gap: 19rem;
}

.gap-y-78{
  grid-row-gap: 19.5rem;
  row-gap: 19.5rem;
}

.gap-y-80{
  grid-row-gap: 20rem;
  row-gap: 20rem;
}

.gap-y-82{
  grid-row-gap: 20.5rem;
  row-gap: 20.5rem;
}

.gap-y-84{
  grid-row-gap: 21rem;
  row-gap: 21rem;
}

.gap-y-88{
  grid-row-gap: 22rem;
  row-gap: 22rem;
}

.gap-y-92{
  grid-row-gap: 23rem;
  row-gap: 23rem;
}

.gap-y-96{
  grid-row-gap: 24rem;
  row-gap: 24rem;
}

.gap-y-98{
  grid-row-gap: 24.5rem;
  row-gap: 24.5rem;
}

.gap-y-100{
  grid-row-gap: 25rem;
  row-gap: 25rem;
}

.gap-y-104{
  grid-row-gap: 26rem;
  row-gap: 26rem;
}

.gap-y-112{
  grid-row-gap: 28rem;
  row-gap: 28rem;
}

.gap-y-124{
  grid-row-gap: 31rem;
  row-gap: 31rem;
}

.gap-y-128{
  grid-row-gap: 32rem;
  row-gap: 32rem;
}

.gap-y-140{
  grid-row-gap: 35rem;
  row-gap: 35rem;
}

.gap-y-152{
  grid-row-gap: 38rem;
  row-gap: 38rem;
}

.gap-y-160{
  grid-row-gap: 40rem;
  row-gap: 40rem;
}

.gap-y-162{
  grid-row-gap: 41rem;
  row-gap: 41rem;
}

.gap-y-192{
  grid-row-gap: 48rem;
  row-gap: 48rem;
}

.gap-y-208{
  grid-row-gap: 52rem;
  row-gap: 52rem;
}

.gap-y-224{
  grid-row-gap: 56rem;
  row-gap: 56rem;
}

.gap-y-256{
  grid-row-gap: 64rem;
  row-gap: 64rem;
}

.gap-y-px{
  grid-row-gap: 1px;
  row-gap: 1px;
}

.grid-flow-row{
  grid-auto-flow: row;
}

.grid-flow-col{
  grid-auto-flow: column;
}

.grid-flow-row-dense{
  grid-auto-flow: row dense;
}

.grid-flow-col-dense{
  grid-auto-flow: column dense;
}

.grid-cols-1{
  grid-template-columns: repeat(1, minmax(0, 1fr));
}

.grid-cols-2{
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.grid-cols-3{
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid-cols-4{
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.grid-cols-5{
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.grid-cols-6{
  grid-template-columns: repeat(6, minmax(0, 1fr));
}

.grid-cols-7{
  grid-template-columns: repeat(7, minmax(0, 1fr));
}

.grid-cols-8{
  grid-template-columns: repeat(8, minmax(0, 1fr));
}

.grid-cols-9{
  grid-template-columns: repeat(9, minmax(0, 1fr));
}

.grid-cols-10{
  grid-template-columns: repeat(10, minmax(0, 1fr));
}

.grid-cols-11{
  grid-template-columns: repeat(11, minmax(0, 1fr));
}

.grid-cols-12{
  grid-template-columns: repeat(12, minmax(0, 1fr));
}

.grid-cols-14{
  grid-template-columns: repeat(14, minmax(0, 1fr));
}

.grid-cols-none{
  grid-template-columns: none;
}

.auto-cols-auto{
  grid-auto-columns: auto;
}

.auto-cols-min{
  grid-auto-columns: min-content;
}

.auto-cols-max{
  grid-auto-columns: max-content;
}

.auto-cols-fr{
  grid-auto-columns: minmax(0, 1fr);
}

.col-auto{
  grid-column: auto;
}

.col-span-1{
  grid-column: span 1 / span 1;
}

.col-span-2{
  grid-column: span 2 / span 2;
}

.col-span-3{
  grid-column: span 3 / span 3;
}

.col-span-4{
  grid-column: span 4 / span 4;
}

.col-span-5{
  grid-column: span 5 / span 5;
}

.col-span-6{
  grid-column: span 6 / span 6;
}

.col-span-7{
  grid-column: span 7 / span 7;
}

.col-span-8{
  grid-column: span 8 / span 8;
}

.col-span-9{
  grid-column: span 9 / span 9;
}

.col-span-10{
  grid-column: span 10 / span 10;
}

.col-span-11{
  grid-column: span 11 / span 11;
}

.col-span-12{
  grid-column: span 12 / span 12;
}

.col-span-full{
  grid-column: 1 / -1;
}

.col-start-1{
  grid-column-start: 1;
}

.col-start-2{
  grid-column-start: 2;
}

.col-start-3{
  grid-column-start: 3;
}

.col-start-4{
  grid-column-start: 4;
}

.col-start-5{
  grid-column-start: 5;
}

.col-start-6{
  grid-column-start: 6;
}

.col-start-7{
  grid-column-start: 7;
}

.col-start-8{
  grid-column-start: 8;
}

.col-start-9{
  grid-column-start: 9;
}

.col-start-10{
  grid-column-start: 10;
}

.col-start-11{
  grid-column-start: 11;
}

.col-start-12{
  grid-column-start: 12;
}

.col-start-13{
  grid-column-start: 13;
}

.col-start-14{
  grid-column-start: 14;
}

.col-start-15{
  grid-column-start: 15;
}

.col-start-auto{
  grid-column-start: auto;
}

.col-end-1{
  grid-column-end: 1;
}

.col-end-2{
  grid-column-end: 2;
}

.col-end-3{
  grid-column-end: 3;
}

.col-end-4{
  grid-column-end: 4;
}

.col-end-5{
  grid-column-end: 5;
}

.col-end-6{
  grid-column-end: 6;
}

.col-end-7{
  grid-column-end: 7;
}

.col-end-8{
  grid-column-end: 8;
}

.col-end-9{
  grid-column-end: 9;
}

.col-end-10{
  grid-column-end: 10;
}

.col-end-11{
  grid-column-end: 11;
}

.col-end-12{
  grid-column-end: 12;
}

.col-end-13{
  grid-column-end: 13;
}

.col-end-14{
  grid-column-end: 14;
}

.col-end-15{
  grid-column-end: 15;
}

.col-end-auto{
  grid-column-end: auto;
}

.grid-rows-1{
  grid-template-rows: repeat(1, minmax(0, 1fr));
}

.grid-rows-2{
  grid-template-rows: repeat(2, minmax(0, 1fr));
}

.grid-rows-3{
  grid-template-rows: repeat(3, minmax(0, 1fr));
}

.grid-rows-4{
  grid-template-rows: repeat(4, minmax(0, 1fr));
}

.grid-rows-5{
  grid-template-rows: repeat(5, minmax(0, 1fr));
}

.grid-rows-6{
  grid-template-rows: repeat(6, minmax(0, 1fr));
}

.grid-rows-none{
  grid-template-rows: none;
}

.auto-rows-auto{
  grid-auto-rows: auto;
}

.auto-rows-min{
  grid-auto-rows: min-content;
}

.auto-rows-max{
  grid-auto-rows: max-content;
}

.auto-rows-fr{
  grid-auto-rows: minmax(0, 1fr);
}

.row-auto{
  grid-row: auto;
}

.row-span-1{
  grid-row: span 1 / span 1;
}

.row-span-2{
  grid-row: span 2 / span 2;
}

.row-span-3{
  grid-row: span 3 / span 3;
}

.row-span-4{
  grid-row: span 4 / span 4;
}

.row-span-5{
  grid-row: span 5 / span 5;
}

.row-span-6{
  grid-row: span 6 / span 6;
}

.row-span-full{
  grid-row: 1 / -1;
}

.row-start-1{
  grid-row-start: 1;
}

.row-start-2{
  grid-row-start: 2;
}

.row-start-3{
  grid-row-start: 3;
}

.row-start-4{
  grid-row-start: 4;
}

.row-start-5{
  grid-row-start: 5;
}

.row-start-6{
  grid-row-start: 6;
}

.row-start-7{
  grid-row-start: 7;
}

.row-start-auto{
  grid-row-start: auto;
}

.row-end-1{
  grid-row-end: 1;
}

.row-end-2{
  grid-row-end: 2;
}

.row-end-3{
  grid-row-end: 3;
}

.row-end-4{
  grid-row-end: 4;
}

.row-end-5{
  grid-row-end: 5;
}

.row-end-6{
  grid-row-end: 6;
}

.row-end-7{
  grid-row-end: 7;
}

.row-end-auto{
  grid-row-end: auto;
}

.transform{
  --transform-translate-x: 0;
  --transform-translate-y: 0;
  --transform-rotate: 0;
  --transform-skew-x: 0;
  --transform-skew-y: 0;
  --transform-scale-x: 1;
  --transform-scale-y: 1;
  transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
}

.transform-none{
  transform: none;
}

.origin-center{
  transform-origin: center;
}

.origin-top{
  transform-origin: top;
}

.origin-top-right{
  transform-origin: top right;
}

.origin-right{
  transform-origin: right;
}

.origin-bottom-right{
  transform-origin: bottom right;
}

.origin-bottom{
  transform-origin: bottom;
}

.origin-bottom-left{
  transform-origin: bottom left;
}

.origin-left{
  transform-origin: left;
}

.origin-top-left{
  transform-origin: top left;
}

.scale-0{
  --transform-scale-x: 0;
  --transform-scale-y: 0;
}

.scale-50{
  --transform-scale-x: .5;
  --transform-scale-y: .5;
}

.scale-75{
  --transform-scale-x: .75;
  --transform-scale-y: .75;
}

.scale-90{
  --transform-scale-x: .9;
  --transform-scale-y: .9;
}

.scale-95{
  --transform-scale-x: .95;
  --transform-scale-y: .95;
}

.scale-100{
  --transform-scale-x: 1;
  --transform-scale-y: 1;
}

.scale-105{
  --transform-scale-x: 1.05;
  --transform-scale-y: 1.05;
}

.scale-110{
  --transform-scale-x: 1.1;
  --transform-scale-y: 1.1;
}

.scale-125{
  --transform-scale-x: 1.25;
  --transform-scale-y: 1.25;
}

.scale-150{
  --transform-scale-x: 1.5;
  --transform-scale-y: 1.5;
}

.scale-x-0{
  --transform-scale-x: 0;
}

.scale-x-50{
  --transform-scale-x: .5;
}

.scale-x-75{
  --transform-scale-x: .75;
}

.scale-x-90{
  --transform-scale-x: .9;
}

.scale-x-95{
  --transform-scale-x: .95;
}

.scale-x-100{
  --transform-scale-x: 1;
}

.scale-x-105{
  --transform-scale-x: 1.05;
}

.scale-x-110{
  --transform-scale-x: 1.1;
}

.scale-x-125{
  --transform-scale-x: 1.25;
}

.scale-x-150{
  --transform-scale-x: 1.5;
}

.scale-y-0{
  --transform-scale-y: 0;
}

.scale-y-50{
  --transform-scale-y: .5;
}

.scale-y-75{
  --transform-scale-y: .75;
}

.scale-y-90{
  --transform-scale-y: .9;
}

.scale-y-95{
  --transform-scale-y: .95;
}

.scale-y-100{
  --transform-scale-y: 1;
}

.scale-y-105{
  --transform-scale-y: 1.05;
}

.scale-y-110{
  --transform-scale-y: 1.1;
}

.scale-y-125{
  --transform-scale-y: 1.25;
}

.scale-y-150{
  --transform-scale-y: 1.5;
}

.hover\\:scale-0:hover{
  --transform-scale-x: 0;
  --transform-scale-y: 0;
}

.hover\\:scale-50:hover{
  --transform-scale-x: .5;
  --transform-scale-y: .5;
}

.hover\\:scale-75:hover{
  --transform-scale-x: .75;
  --transform-scale-y: .75;
}

.hover\\:scale-90:hover{
  --transform-scale-x: .9;
  --transform-scale-y: .9;
}

.hover\\:scale-95:hover{
  --transform-scale-x: .95;
  --transform-scale-y: .95;
}

.hover\\:scale-100:hover{
  --transform-scale-x: 1;
  --transform-scale-y: 1;
}

.hover\\:scale-105:hover{
  --transform-scale-x: 1.05;
  --transform-scale-y: 1.05;
}

.hover\\:scale-110:hover{
  --transform-scale-x: 1.1;
  --transform-scale-y: 1.1;
}

.hover\\:scale-125:hover{
  --transform-scale-x: 1.25;
  --transform-scale-y: 1.25;
}

.hover\\:scale-150:hover{
  --transform-scale-x: 1.5;
  --transform-scale-y: 1.5;
}

.hover\\:scale-x-0:hover{
  --transform-scale-x: 0;
}

.hover\\:scale-x-50:hover{
  --transform-scale-x: .5;
}

.hover\\:scale-x-75:hover{
  --transform-scale-x: .75;
}

.hover\\:scale-x-90:hover{
  --transform-scale-x: .9;
}

.hover\\:scale-x-95:hover{
  --transform-scale-x: .95;
}

.hover\\:scale-x-100:hover{
  --transform-scale-x: 1;
}

.hover\\:scale-x-105:hover{
  --transform-scale-x: 1.05;
}

.hover\\:scale-x-110:hover{
  --transform-scale-x: 1.1;
}

.hover\\:scale-x-125:hover{
  --transform-scale-x: 1.25;
}

.hover\\:scale-x-150:hover{
  --transform-scale-x: 1.5;
}

.hover\\:scale-y-0:hover{
  --transform-scale-y: 0;
}

.hover\\:scale-y-50:hover{
  --transform-scale-y: .5;
}

.hover\\:scale-y-75:hover{
  --transform-scale-y: .75;
}

.hover\\:scale-y-90:hover{
  --transform-scale-y: .9;
}

.hover\\:scale-y-95:hover{
  --transform-scale-y: .95;
}

.hover\\:scale-y-100:hover{
  --transform-scale-y: 1;
}

.hover\\:scale-y-105:hover{
  --transform-scale-y: 1.05;
}

.hover\\:scale-y-110:hover{
  --transform-scale-y: 1.1;
}

.hover\\:scale-y-125:hover{
  --transform-scale-y: 1.25;
}

.hover\\:scale-y-150:hover{
  --transform-scale-y: 1.5;
}

.focus\\:scale-0:focus{
  --transform-scale-x: 0;
  --transform-scale-y: 0;
}

.focus\\:scale-50:focus{
  --transform-scale-x: .5;
  --transform-scale-y: .5;
}

.focus\\:scale-75:focus{
  --transform-scale-x: .75;
  --transform-scale-y: .75;
}

.focus\\:scale-90:focus{
  --transform-scale-x: .9;
  --transform-scale-y: .9;
}

.focus\\:scale-95:focus{
  --transform-scale-x: .95;
  --transform-scale-y: .95;
}

.focus\\:scale-100:focus{
  --transform-scale-x: 1;
  --transform-scale-y: 1;
}

.focus\\:scale-105:focus{
  --transform-scale-x: 1.05;
  --transform-scale-y: 1.05;
}

.focus\\:scale-110:focus{
  --transform-scale-x: 1.1;
  --transform-scale-y: 1.1;
}

.focus\\:scale-125:focus{
  --transform-scale-x: 1.25;
  --transform-scale-y: 1.25;
}

.focus\\:scale-150:focus{
  --transform-scale-x: 1.5;
  --transform-scale-y: 1.5;
}

.focus\\:scale-x-0:focus{
  --transform-scale-x: 0;
}

.focus\\:scale-x-50:focus{
  --transform-scale-x: .5;
}

.focus\\:scale-x-75:focus{
  --transform-scale-x: .75;
}

.focus\\:scale-x-90:focus{
  --transform-scale-x: .9;
}

.focus\\:scale-x-95:focus{
  --transform-scale-x: .95;
}

.focus\\:scale-x-100:focus{
  --transform-scale-x: 1;
}

.focus\\:scale-x-105:focus{
  --transform-scale-x: 1.05;
}

.focus\\:scale-x-110:focus{
  --transform-scale-x: 1.1;
}

.focus\\:scale-x-125:focus{
  --transform-scale-x: 1.25;
}

.focus\\:scale-x-150:focus{
  --transform-scale-x: 1.5;
}

.focus\\:scale-y-0:focus{
  --transform-scale-y: 0;
}

.focus\\:scale-y-50:focus{
  --transform-scale-y: .5;
}

.focus\\:scale-y-75:focus{
  --transform-scale-y: .75;
}

.focus\\:scale-y-90:focus{
  --transform-scale-y: .9;
}

.focus\\:scale-y-95:focus{
  --transform-scale-y: .95;
}

.focus\\:scale-y-100:focus{
  --transform-scale-y: 1;
}

.focus\\:scale-y-105:focus{
  --transform-scale-y: 1.05;
}

.focus\\:scale-y-110:focus{
  --transform-scale-y: 1.1;
}

.focus\\:scale-y-125:focus{
  --transform-scale-y: 1.25;
}

.focus\\:scale-y-150:focus{
  --transform-scale-y: 1.5;
}

.rotate-0{
  --transform-rotate: 0;
}

.rotate-1{
  --transform-rotate: 1deg;
}

.rotate-2{
  --transform-rotate: 2deg;
}

.rotate-3{
  --transform-rotate: 3deg;
}

.rotate-6{
  --transform-rotate: 6deg;
}

.rotate-12{
  --transform-rotate: 12deg;
}

.rotate-45{
  --transform-rotate: 45deg;
}

.rotate-90{
  --transform-rotate: 90deg;
}

.rotate-180{
  --transform-rotate: 180deg;
}

.-rotate-180{
  --transform-rotate: -180deg;
}

.-rotate-90{
  --transform-rotate: -90deg;
}

.-rotate-45{
  --transform-rotate: -45deg;
}

.-rotate-12{
  --transform-rotate: -12deg;
}

.-rotate-6{
  --transform-rotate: -6deg;
}

.-rotate-3{
  --transform-rotate: -3deg;
}

.-rotate-2{
  --transform-rotate: -2deg;
}

.-rotate-1{
  --transform-rotate: -1deg;
}

.hover\\:rotate-0:hover{
  --transform-rotate: 0;
}

.hover\\:rotate-1:hover{
  --transform-rotate: 1deg;
}

.hover\\:rotate-2:hover{
  --transform-rotate: 2deg;
}

.hover\\:rotate-3:hover{
  --transform-rotate: 3deg;
}

.hover\\:rotate-6:hover{
  --transform-rotate: 6deg;
}

.hover\\:rotate-12:hover{
  --transform-rotate: 12deg;
}

.hover\\:rotate-45:hover{
  --transform-rotate: 45deg;
}

.hover\\:rotate-90:hover{
  --transform-rotate: 90deg;
}

.hover\\:rotate-180:hover{
  --transform-rotate: 180deg;
}

.hover\\:-rotate-180:hover{
  --transform-rotate: -180deg;
}

.hover\\:-rotate-90:hover{
  --transform-rotate: -90deg;
}

.hover\\:-rotate-45:hover{
  --transform-rotate: -45deg;
}

.hover\\:-rotate-12:hover{
  --transform-rotate: -12deg;
}

.hover\\:-rotate-6:hover{
  --transform-rotate: -6deg;
}

.hover\\:-rotate-3:hover{
  --transform-rotate: -3deg;
}

.hover\\:-rotate-2:hover{
  --transform-rotate: -2deg;
}

.hover\\:-rotate-1:hover{
  --transform-rotate: -1deg;
}

.focus\\:rotate-0:focus{
  --transform-rotate: 0;
}

.focus\\:rotate-1:focus{
  --transform-rotate: 1deg;
}

.focus\\:rotate-2:focus{
  --transform-rotate: 2deg;
}

.focus\\:rotate-3:focus{
  --transform-rotate: 3deg;
}

.focus\\:rotate-6:focus{
  --transform-rotate: 6deg;
}

.focus\\:rotate-12:focus{
  --transform-rotate: 12deg;
}

.focus\\:rotate-45:focus{
  --transform-rotate: 45deg;
}

.focus\\:rotate-90:focus{
  --transform-rotate: 90deg;
}

.focus\\:rotate-180:focus{
  --transform-rotate: 180deg;
}

.focus\\:-rotate-180:focus{
  --transform-rotate: -180deg;
}

.focus\\:-rotate-90:focus{
  --transform-rotate: -90deg;
}

.focus\\:-rotate-45:focus{
  --transform-rotate: -45deg;
}

.focus\\:-rotate-12:focus{
  --transform-rotate: -12deg;
}

.focus\\:-rotate-6:focus{
  --transform-rotate: -6deg;
}

.focus\\:-rotate-3:focus{
  --transform-rotate: -3deg;
}

.focus\\:-rotate-2:focus{
  --transform-rotate: -2deg;
}

.focus\\:-rotate-1:focus{
  --transform-rotate: -1deg;
}

.translate-x-0{
  --transform-translate-x: 0;
}

.translate-x-1{
  --transform-translate-x: 0.25rem;
}

.translate-x-2{
  --transform-translate-x: 0.5rem;
}

.translate-x-3{
  --transform-translate-x: 0.75rem;
}

.translate-x-4{
  --transform-translate-x: 1rem;
}

.translate-x-5{
  --transform-translate-x: 1.25rem;
}

.translate-x-6{
  --transform-translate-x: 1.5rem;
}

.translate-x-7{
  --transform-translate-x: 1.75rem;
}

.translate-x-8{
  --transform-translate-x: 2rem;
}

.translate-x-9{
  --transform-translate-x: 2.25rem;
}

.translate-x-10{
  --transform-translate-x: 2.5rem;
}

.translate-x-11{
  --transform-translate-x: 2.75rem;
}

.translate-x-12{
  --transform-translate-x: 3rem;
}

.translate-x-14{
  --transform-translate-x: 3.5rem;
}

.translate-x-15{
  --transform-translate-x: 3.75rem;
}

.translate-x-16{
  --transform-translate-x: 4rem;
}

.translate-x-18{
  --transform-translate-x: 4.5rem;
}

.translate-x-20{
  --transform-translate-x: 5rem;
}

.translate-x-22{
  --transform-translate-x: 5.5rem;
}

.translate-x-23{
  --transform-translate-x: 5.75rem;
}

.translate-x-24{
  --transform-translate-x: 6rem;
}

.translate-x-25{
  --transform-translate-x: 6.25rem;
}

.translate-x-26{
  --transform-translate-x: 6.5rem;
}

.translate-x-28{
  --transform-translate-x: 7rem;
}

.translate-x-30{
  --transform-translate-x: 7.5rem;
}

.translate-x-32{
  --transform-translate-x: 8rem;
}

.translate-x-34{
  --transform-translate-x: 8.5rem;
}

.translate-x-40{
  --transform-translate-x: 10rem;
}

.translate-x-42{
  --transform-translate-x: 10.5rem;
}

.translate-x-44{
  --transform-translate-x: 11rem;
}

.translate-x-48{
  --transform-translate-x: 12rem;
}

.translate-x-52{
  --transform-translate-x: 13rem;
}

.translate-x-54{
  --transform-translate-x: 13.5rem;
}

.translate-x-56{
  --transform-translate-x: 14rem;
}

.translate-x-60{
  --transform-translate-x: 15rem;
}

.translate-x-64{
  --transform-translate-x: 16rem;
}

.translate-x-68{
  --transform-translate-x: 17rem;
}

.translate-x-72{
  --transform-translate-x: 18rem;
}

.translate-x-74{
  --transform-translate-x: 18.5rem;
}

.translate-x-76{
  --transform-translate-x: 19rem;
}

.translate-x-78{
  --transform-translate-x: 19.5rem;
}

.translate-x-80{
  --transform-translate-x: 20rem;
}

.translate-x-82{
  --transform-translate-x: 20.5rem;
}

.translate-x-84{
  --transform-translate-x: 21rem;
}

.translate-x-88{
  --transform-translate-x: 22rem;
}

.translate-x-92{
  --transform-translate-x: 23rem;
}

.translate-x-96{
  --transform-translate-x: 24rem;
}

.translate-x-98{
  --transform-translate-x: 24.5rem;
}

.translate-x-100{
  --transform-translate-x: 25rem;
}

.translate-x-104{
  --transform-translate-x: 26rem;
}

.translate-x-112{
  --transform-translate-x: 28rem;
}

.translate-x-124{
  --transform-translate-x: 31rem;
}

.translate-x-128{
  --transform-translate-x: 32rem;
}

.translate-x-140{
  --transform-translate-x: 35rem;
}

.translate-x-152{
  --transform-translate-x: 38rem;
}

.translate-x-160{
  --transform-translate-x: 40rem;
}

.translate-x-162{
  --transform-translate-x: 41rem;
}

.translate-x-192{
  --transform-translate-x: 48rem;
}

.translate-x-208{
  --transform-translate-x: 52rem;
}

.translate-x-224{
  --transform-translate-x: 56rem;
}

.translate-x-256{
  --transform-translate-x: 64rem;
}

.translate-x-px{
  --transform-translate-x: 1px;
}

.-translate-x-1{
  --transform-translate-x: -0.25rem;
}

.-translate-x-2{
  --transform-translate-x: -0.5rem;
}

.-translate-x-3{
  --transform-translate-x: -0.75rem;
}

.-translate-x-4{
  --transform-translate-x: -1rem;
}

.-translate-x-5{
  --transform-translate-x: -1.25rem;
}

.-translate-x-6{
  --transform-translate-x: -1.5rem;
}

.-translate-x-7{
  --transform-translate-x: -1.75rem;
}

.-translate-x-8{
  --transform-translate-x: -2rem;
}

.-translate-x-9{
  --transform-translate-x: -2.25rem;
}

.-translate-x-10{
  --transform-translate-x: -2.5rem;
}

.-translate-x-11{
  --transform-translate-x: -2.75rem;
}

.-translate-x-12{
  --transform-translate-x: -3rem;
}

.-translate-x-14{
  --transform-translate-x: -3.5rem;
}

.-translate-x-15{
  --transform-translate-x: -3.75rem;
}

.-translate-x-16{
  --transform-translate-x: -4rem;
}

.-translate-x-18{
  --transform-translate-x: -4.5rem;
}

.-translate-x-20{
  --transform-translate-x: -5rem;
}

.-translate-x-22{
  --transform-translate-x: -5.5rem;
}

.-translate-x-23{
  --transform-translate-x: -5.75rem;
}

.-translate-x-24{
  --transform-translate-x: -6rem;
}

.-translate-x-25{
  --transform-translate-x: -6.25rem;
}

.-translate-x-26{
  --transform-translate-x: -6.5rem;
}

.-translate-x-28{
  --transform-translate-x: -7rem;
}

.-translate-x-30{
  --transform-translate-x: -7.5rem;
}

.-translate-x-32{
  --transform-translate-x: -8rem;
}

.-translate-x-34{
  --transform-translate-x: -8.5rem;
}

.-translate-x-40{
  --transform-translate-x: -10rem;
}

.-translate-x-42{
  --transform-translate-x: -10.5rem;
}

.-translate-x-44{
  --transform-translate-x: -11rem;
}

.-translate-x-48{
  --transform-translate-x: -12rem;
}

.-translate-x-52{
  --transform-translate-x: -13rem;
}

.-translate-x-54{
  --transform-translate-x: -13.5rem;
}

.-translate-x-56{
  --transform-translate-x: -14rem;
}

.-translate-x-60{
  --transform-translate-x: -15rem;
}

.-translate-x-64{
  --transform-translate-x: -16rem;
}

.-translate-x-68{
  --transform-translate-x: -17rem;
}

.-translate-x-72{
  --transform-translate-x: -18rem;
}

.-translate-x-74{
  --transform-translate-x: -18.5rem;
}

.-translate-x-76{
  --transform-translate-x: -19rem;
}

.-translate-x-78{
  --transform-translate-x: -19.5rem;
}

.-translate-x-80{
  --transform-translate-x: -20rem;
}

.-translate-x-82{
  --transform-translate-x: -20.5rem;
}

.-translate-x-84{
  --transform-translate-x: -21rem;
}

.-translate-x-88{
  --transform-translate-x: -22rem;
}

.-translate-x-92{
  --transform-translate-x: -23rem;
}

.-translate-x-96{
  --transform-translate-x: -24rem;
}

.-translate-x-98{
  --transform-translate-x: -24.5rem;
}

.-translate-x-100{
  --transform-translate-x: -25rem;
}

.-translate-x-104{
  --transform-translate-x: -26rem;
}

.-translate-x-112{
  --transform-translate-x: -28rem;
}

.-translate-x-124{
  --transform-translate-x: -31rem;
}

.-translate-x-128{
  --transform-translate-x: -32rem;
}

.-translate-x-140{
  --transform-translate-x: -35rem;
}

.-translate-x-152{
  --transform-translate-x: -38rem;
}

.-translate-x-160{
  --transform-translate-x: -40rem;
}

.-translate-x-162{
  --transform-translate-x: -41rem;
}

.-translate-x-192{
  --transform-translate-x: -48rem;
}

.-translate-x-208{
  --transform-translate-x: -52rem;
}

.-translate-x-224{
  --transform-translate-x: -56rem;
}

.-translate-x-256{
  --transform-translate-x: -64rem;
}

.-translate-x-px{
  --transform-translate-x: -1px;
}

.-translate-x-full{
  --transform-translate-x: -100%;
}

.-translate-x-1\\/2{
  --transform-translate-x: -50%;
}

.translate-x-1\\/2{
  --transform-translate-x: 50%;
}

.translate-x-full{
  --transform-translate-x: 100%;
}

.translate-y-0{
  --transform-translate-y: 0;
}

.translate-y-1{
  --transform-translate-y: 0.25rem;
}

.translate-y-2{
  --transform-translate-y: 0.5rem;
}

.translate-y-3{
  --transform-translate-y: 0.75rem;
}

.translate-y-4{
  --transform-translate-y: 1rem;
}

.translate-y-5{
  --transform-translate-y: 1.25rem;
}

.translate-y-6{
  --transform-translate-y: 1.5rem;
}

.translate-y-7{
  --transform-translate-y: 1.75rem;
}

.translate-y-8{
  --transform-translate-y: 2rem;
}

.translate-y-9{
  --transform-translate-y: 2.25rem;
}

.translate-y-10{
  --transform-translate-y: 2.5rem;
}

.translate-y-11{
  --transform-translate-y: 2.75rem;
}

.translate-y-12{
  --transform-translate-y: 3rem;
}

.translate-y-14{
  --transform-translate-y: 3.5rem;
}

.translate-y-15{
  --transform-translate-y: 3.75rem;
}

.translate-y-16{
  --transform-translate-y: 4rem;
}

.translate-y-18{
  --transform-translate-y: 4.5rem;
}

.translate-y-20{
  --transform-translate-y: 5rem;
}

.translate-y-22{
  --transform-translate-y: 5.5rem;
}

.translate-y-23{
  --transform-translate-y: 5.75rem;
}

.translate-y-24{
  --transform-translate-y: 6rem;
}

.translate-y-25{
  --transform-translate-y: 6.25rem;
}

.translate-y-26{
  --transform-translate-y: 6.5rem;
}

.translate-y-28{
  --transform-translate-y: 7rem;
}

.translate-y-30{
  --transform-translate-y: 7.5rem;
}

.translate-y-32{
  --transform-translate-y: 8rem;
}

.translate-y-34{
  --transform-translate-y: 8.5rem;
}

.translate-y-40{
  --transform-translate-y: 10rem;
}

.translate-y-42{
  --transform-translate-y: 10.5rem;
}

.translate-y-44{
  --transform-translate-y: 11rem;
}

.translate-y-48{
  --transform-translate-y: 12rem;
}

.translate-y-52{
  --transform-translate-y: 13rem;
}

.translate-y-54{
  --transform-translate-y: 13.5rem;
}

.translate-y-56{
  --transform-translate-y: 14rem;
}

.translate-y-60{
  --transform-translate-y: 15rem;
}

.translate-y-64{
  --transform-translate-y: 16rem;
}

.translate-y-68{
  --transform-translate-y: 17rem;
}

.translate-y-72{
  --transform-translate-y: 18rem;
}

.translate-y-74{
  --transform-translate-y: 18.5rem;
}

.translate-y-76{
  --transform-translate-y: 19rem;
}

.translate-y-78{
  --transform-translate-y: 19.5rem;
}

.translate-y-80{
  --transform-translate-y: 20rem;
}

.translate-y-82{
  --transform-translate-y: 20.5rem;
}

.translate-y-84{
  --transform-translate-y: 21rem;
}

.translate-y-88{
  --transform-translate-y: 22rem;
}

.translate-y-92{
  --transform-translate-y: 23rem;
}

.translate-y-96{
  --transform-translate-y: 24rem;
}

.translate-y-98{
  --transform-translate-y: 24.5rem;
}

.translate-y-100{
  --transform-translate-y: 25rem;
}

.translate-y-104{
  --transform-translate-y: 26rem;
}

.translate-y-112{
  --transform-translate-y: 28rem;
}

.translate-y-124{
  --transform-translate-y: 31rem;
}

.translate-y-128{
  --transform-translate-y: 32rem;
}

.translate-y-140{
  --transform-translate-y: 35rem;
}

.translate-y-152{
  --transform-translate-y: 38rem;
}

.translate-y-160{
  --transform-translate-y: 40rem;
}

.translate-y-162{
  --transform-translate-y: 41rem;
}

.translate-y-192{
  --transform-translate-y: 48rem;
}

.translate-y-208{
  --transform-translate-y: 52rem;
}

.translate-y-224{
  --transform-translate-y: 56rem;
}

.translate-y-256{
  --transform-translate-y: 64rem;
}

.translate-y-px{
  --transform-translate-y: 1px;
}

.-translate-y-1{
  --transform-translate-y: -0.25rem;
}

.-translate-y-2{
  --transform-translate-y: -0.5rem;
}

.-translate-y-3{
  --transform-translate-y: -0.75rem;
}

.-translate-y-4{
  --transform-translate-y: -1rem;
}

.-translate-y-5{
  --transform-translate-y: -1.25rem;
}

.-translate-y-6{
  --transform-translate-y: -1.5rem;
}

.-translate-y-7{
  --transform-translate-y: -1.75rem;
}

.-translate-y-8{
  --transform-translate-y: -2rem;
}

.-translate-y-9{
  --transform-translate-y: -2.25rem;
}

.-translate-y-10{
  --transform-translate-y: -2.5rem;
}

.-translate-y-11{
  --transform-translate-y: -2.75rem;
}

.-translate-y-12{
  --transform-translate-y: -3rem;
}

.-translate-y-14{
  --transform-translate-y: -3.5rem;
}

.-translate-y-15{
  --transform-translate-y: -3.75rem;
}

.-translate-y-16{
  --transform-translate-y: -4rem;
}

.-translate-y-18{
  --transform-translate-y: -4.5rem;
}

.-translate-y-20{
  --transform-translate-y: -5rem;
}

.-translate-y-22{
  --transform-translate-y: -5.5rem;
}

.-translate-y-23{
  --transform-translate-y: -5.75rem;
}

.-translate-y-24{
  --transform-translate-y: -6rem;
}

.-translate-y-25{
  --transform-translate-y: -6.25rem;
}

.-translate-y-26{
  --transform-translate-y: -6.5rem;
}

.-translate-y-28{
  --transform-translate-y: -7rem;
}

.-translate-y-30{
  --transform-translate-y: -7.5rem;
}

.-translate-y-32{
  --transform-translate-y: -8rem;
}

.-translate-y-34{
  --transform-translate-y: -8.5rem;
}

.-translate-y-40{
  --transform-translate-y: -10rem;
}

.-translate-y-42{
  --transform-translate-y: -10.5rem;
}

.-translate-y-44{
  --transform-translate-y: -11rem;
}

.-translate-y-48{
  --transform-translate-y: -12rem;
}

.-translate-y-52{
  --transform-translate-y: -13rem;
}

.-translate-y-54{
  --transform-translate-y: -13.5rem;
}

.-translate-y-56{
  --transform-translate-y: -14rem;
}

.-translate-y-60{
  --transform-translate-y: -15rem;
}

.-translate-y-64{
  --transform-translate-y: -16rem;
}

.-translate-y-68{
  --transform-translate-y: -17rem;
}

.-translate-y-72{
  --transform-translate-y: -18rem;
}

.-translate-y-74{
  --transform-translate-y: -18.5rem;
}

.-translate-y-76{
  --transform-translate-y: -19rem;
}

.-translate-y-78{
  --transform-translate-y: -19.5rem;
}

.-translate-y-80{
  --transform-translate-y: -20rem;
}

.-translate-y-82{
  --transform-translate-y: -20.5rem;
}

.-translate-y-84{
  --transform-translate-y: -21rem;
}

.-translate-y-88{
  --transform-translate-y: -22rem;
}

.-translate-y-92{
  --transform-translate-y: -23rem;
}

.-translate-y-96{
  --transform-translate-y: -24rem;
}

.-translate-y-98{
  --transform-translate-y: -24.5rem;
}

.-translate-y-100{
  --transform-translate-y: -25rem;
}

.-translate-y-104{
  --transform-translate-y: -26rem;
}

.-translate-y-112{
  --transform-translate-y: -28rem;
}

.-translate-y-124{
  --transform-translate-y: -31rem;
}

.-translate-y-128{
  --transform-translate-y: -32rem;
}

.-translate-y-140{
  --transform-translate-y: -35rem;
}

.-translate-y-152{
  --transform-translate-y: -38rem;
}

.-translate-y-160{
  --transform-translate-y: -40rem;
}

.-translate-y-162{
  --transform-translate-y: -41rem;
}

.-translate-y-192{
  --transform-translate-y: -48rem;
}

.-translate-y-208{
  --transform-translate-y: -52rem;
}

.-translate-y-224{
  --transform-translate-y: -56rem;
}

.-translate-y-256{
  --transform-translate-y: -64rem;
}

.-translate-y-px{
  --transform-translate-y: -1px;
}

.-translate-y-full{
  --transform-translate-y: -100%;
}

.-translate-y-1\\/2{
  --transform-translate-y: -50%;
}

.translate-y-1\\/2{
  --transform-translate-y: 50%;
}

.translate-y-full{
  --transform-translate-y: 100%;
}

.hover\\:translate-x-0:hover{
  --transform-translate-x: 0;
}

.hover\\:translate-x-1:hover{
  --transform-translate-x: 0.25rem;
}

.hover\\:translate-x-2:hover{
  --transform-translate-x: 0.5rem;
}

.hover\\:translate-x-3:hover{
  --transform-translate-x: 0.75rem;
}

.hover\\:translate-x-4:hover{
  --transform-translate-x: 1rem;
}

.hover\\:translate-x-5:hover{
  --transform-translate-x: 1.25rem;
}

.hover\\:translate-x-6:hover{
  --transform-translate-x: 1.5rem;
}

.hover\\:translate-x-7:hover{
  --transform-translate-x: 1.75rem;
}

.hover\\:translate-x-8:hover{
  --transform-translate-x: 2rem;
}

.hover\\:translate-x-9:hover{
  --transform-translate-x: 2.25rem;
}

.hover\\:translate-x-10:hover{
  --transform-translate-x: 2.5rem;
}

.hover\\:translate-x-11:hover{
  --transform-translate-x: 2.75rem;
}

.hover\\:translate-x-12:hover{
  --transform-translate-x: 3rem;
}

.hover\\:translate-x-14:hover{
  --transform-translate-x: 3.5rem;
}

.hover\\:translate-x-15:hover{
  --transform-translate-x: 3.75rem;
}

.hover\\:translate-x-16:hover{
  --transform-translate-x: 4rem;
}

.hover\\:translate-x-18:hover{
  --transform-translate-x: 4.5rem;
}

.hover\\:translate-x-20:hover{
  --transform-translate-x: 5rem;
}

.hover\\:translate-x-22:hover{
  --transform-translate-x: 5.5rem;
}

.hover\\:translate-x-23:hover{
  --transform-translate-x: 5.75rem;
}

.hover\\:translate-x-24:hover{
  --transform-translate-x: 6rem;
}

.hover\\:translate-x-25:hover{
  --transform-translate-x: 6.25rem;
}

.hover\\:translate-x-26:hover{
  --transform-translate-x: 6.5rem;
}

.hover\\:translate-x-28:hover{
  --transform-translate-x: 7rem;
}

.hover\\:translate-x-30:hover{
  --transform-translate-x: 7.5rem;
}

.hover\\:translate-x-32:hover{
  --transform-translate-x: 8rem;
}

.hover\\:translate-x-34:hover{
  --transform-translate-x: 8.5rem;
}

.hover\\:translate-x-40:hover{
  --transform-translate-x: 10rem;
}

.hover\\:translate-x-42:hover{
  --transform-translate-x: 10.5rem;
}

.hover\\:translate-x-44:hover{
  --transform-translate-x: 11rem;
}

.hover\\:translate-x-48:hover{
  --transform-translate-x: 12rem;
}

.hover\\:translate-x-52:hover{
  --transform-translate-x: 13rem;
}

.hover\\:translate-x-54:hover{
  --transform-translate-x: 13.5rem;
}

.hover\\:translate-x-56:hover{
  --transform-translate-x: 14rem;
}

.hover\\:translate-x-60:hover{
  --transform-translate-x: 15rem;
}

.hover\\:translate-x-64:hover{
  --transform-translate-x: 16rem;
}

.hover\\:translate-x-68:hover{
  --transform-translate-x: 17rem;
}

.hover\\:translate-x-72:hover{
  --transform-translate-x: 18rem;
}

.hover\\:translate-x-74:hover{
  --transform-translate-x: 18.5rem;
}

.hover\\:translate-x-76:hover{
  --transform-translate-x: 19rem;
}

.hover\\:translate-x-78:hover{
  --transform-translate-x: 19.5rem;
}

.hover\\:translate-x-80:hover{
  --transform-translate-x: 20rem;
}

.hover\\:translate-x-82:hover{
  --transform-translate-x: 20.5rem;
}

.hover\\:translate-x-84:hover{
  --transform-translate-x: 21rem;
}

.hover\\:translate-x-88:hover{
  --transform-translate-x: 22rem;
}

.hover\\:translate-x-92:hover{
  --transform-translate-x: 23rem;
}

.hover\\:translate-x-96:hover{
  --transform-translate-x: 24rem;
}

.hover\\:translate-x-98:hover{
  --transform-translate-x: 24.5rem;
}

.hover\\:translate-x-100:hover{
  --transform-translate-x: 25rem;
}

.hover\\:translate-x-104:hover{
  --transform-translate-x: 26rem;
}

.hover\\:translate-x-112:hover{
  --transform-translate-x: 28rem;
}

.hover\\:translate-x-124:hover{
  --transform-translate-x: 31rem;
}

.hover\\:translate-x-128:hover{
  --transform-translate-x: 32rem;
}

.hover\\:translate-x-140:hover{
  --transform-translate-x: 35rem;
}

.hover\\:translate-x-152:hover{
  --transform-translate-x: 38rem;
}

.hover\\:translate-x-160:hover{
  --transform-translate-x: 40rem;
}

.hover\\:translate-x-162:hover{
  --transform-translate-x: 41rem;
}

.hover\\:translate-x-192:hover{
  --transform-translate-x: 48rem;
}

.hover\\:translate-x-208:hover{
  --transform-translate-x: 52rem;
}

.hover\\:translate-x-224:hover{
  --transform-translate-x: 56rem;
}

.hover\\:translate-x-256:hover{
  --transform-translate-x: 64rem;
}

.hover\\:translate-x-px:hover{
  --transform-translate-x: 1px;
}

.hover\\:-translate-x-1:hover{
  --transform-translate-x: -0.25rem;
}

.hover\\:-translate-x-2:hover{
  --transform-translate-x: -0.5rem;
}

.hover\\:-translate-x-3:hover{
  --transform-translate-x: -0.75rem;
}

.hover\\:-translate-x-4:hover{
  --transform-translate-x: -1rem;
}

.hover\\:-translate-x-5:hover{
  --transform-translate-x: -1.25rem;
}

.hover\\:-translate-x-6:hover{
  --transform-translate-x: -1.5rem;
}

.hover\\:-translate-x-7:hover{
  --transform-translate-x: -1.75rem;
}

.hover\\:-translate-x-8:hover{
  --transform-translate-x: -2rem;
}

.hover\\:-translate-x-9:hover{
  --transform-translate-x: -2.25rem;
}

.hover\\:-translate-x-10:hover{
  --transform-translate-x: -2.5rem;
}

.hover\\:-translate-x-11:hover{
  --transform-translate-x: -2.75rem;
}

.hover\\:-translate-x-12:hover{
  --transform-translate-x: -3rem;
}

.hover\\:-translate-x-14:hover{
  --transform-translate-x: -3.5rem;
}

.hover\\:-translate-x-15:hover{
  --transform-translate-x: -3.75rem;
}

.hover\\:-translate-x-16:hover{
  --transform-translate-x: -4rem;
}

.hover\\:-translate-x-18:hover{
  --transform-translate-x: -4.5rem;
}

.hover\\:-translate-x-20:hover{
  --transform-translate-x: -5rem;
}

.hover\\:-translate-x-22:hover{
  --transform-translate-x: -5.5rem;
}

.hover\\:-translate-x-23:hover{
  --transform-translate-x: -5.75rem;
}

.hover\\:-translate-x-24:hover{
  --transform-translate-x: -6rem;
}

.hover\\:-translate-x-25:hover{
  --transform-translate-x: -6.25rem;
}

.hover\\:-translate-x-26:hover{
  --transform-translate-x: -6.5rem;
}

.hover\\:-translate-x-28:hover{
  --transform-translate-x: -7rem;
}

.hover\\:-translate-x-30:hover{
  --transform-translate-x: -7.5rem;
}

.hover\\:-translate-x-32:hover{
  --transform-translate-x: -8rem;
}

.hover\\:-translate-x-34:hover{
  --transform-translate-x: -8.5rem;
}

.hover\\:-translate-x-40:hover{
  --transform-translate-x: -10rem;
}

.hover\\:-translate-x-42:hover{
  --transform-translate-x: -10.5rem;
}

.hover\\:-translate-x-44:hover{
  --transform-translate-x: -11rem;
}

.hover\\:-translate-x-48:hover{
  --transform-translate-x: -12rem;
}

.hover\\:-translate-x-52:hover{
  --transform-translate-x: -13rem;
}

.hover\\:-translate-x-54:hover{
  --transform-translate-x: -13.5rem;
}

.hover\\:-translate-x-56:hover{
  --transform-translate-x: -14rem;
}

.hover\\:-translate-x-60:hover{
  --transform-translate-x: -15rem;
}

.hover\\:-translate-x-64:hover{
  --transform-translate-x: -16rem;
}

.hover\\:-translate-x-68:hover{
  --transform-translate-x: -17rem;
}

.hover\\:-translate-x-72:hover{
  --transform-translate-x: -18rem;
}

.hover\\:-translate-x-74:hover{
  --transform-translate-x: -18.5rem;
}

.hover\\:-translate-x-76:hover{
  --transform-translate-x: -19rem;
}

.hover\\:-translate-x-78:hover{
  --transform-translate-x: -19.5rem;
}

.hover\\:-translate-x-80:hover{
  --transform-translate-x: -20rem;
}

.hover\\:-translate-x-82:hover{
  --transform-translate-x: -20.5rem;
}

.hover\\:-translate-x-84:hover{
  --transform-translate-x: -21rem;
}

.hover\\:-translate-x-88:hover{
  --transform-translate-x: -22rem;
}

.hover\\:-translate-x-92:hover{
  --transform-translate-x: -23rem;
}

.hover\\:-translate-x-96:hover{
  --transform-translate-x: -24rem;
}

.hover\\:-translate-x-98:hover{
  --transform-translate-x: -24.5rem;
}

.hover\\:-translate-x-100:hover{
  --transform-translate-x: -25rem;
}

.hover\\:-translate-x-104:hover{
  --transform-translate-x: -26rem;
}

.hover\\:-translate-x-112:hover{
  --transform-translate-x: -28rem;
}

.hover\\:-translate-x-124:hover{
  --transform-translate-x: -31rem;
}

.hover\\:-translate-x-128:hover{
  --transform-translate-x: -32rem;
}

.hover\\:-translate-x-140:hover{
  --transform-translate-x: -35rem;
}

.hover\\:-translate-x-152:hover{
  --transform-translate-x: -38rem;
}

.hover\\:-translate-x-160:hover{
  --transform-translate-x: -40rem;
}

.hover\\:-translate-x-162:hover{
  --transform-translate-x: -41rem;
}

.hover\\:-translate-x-192:hover{
  --transform-translate-x: -48rem;
}

.hover\\:-translate-x-208:hover{
  --transform-translate-x: -52rem;
}

.hover\\:-translate-x-224:hover{
  --transform-translate-x: -56rem;
}

.hover\\:-translate-x-256:hover{
  --transform-translate-x: -64rem;
}

.hover\\:-translate-x-px:hover{
  --transform-translate-x: -1px;
}

.hover\\:-translate-x-full:hover{
  --transform-translate-x: -100%;
}

.hover\\:-translate-x-1\\/2:hover{
  --transform-translate-x: -50%;
}

.hover\\:translate-x-1\\/2:hover{
  --transform-translate-x: 50%;
}

.hover\\:translate-x-full:hover{
  --transform-translate-x: 100%;
}

.hover\\:translate-y-0:hover{
  --transform-translate-y: 0;
}

.hover\\:translate-y-1:hover{
  --transform-translate-y: 0.25rem;
}

.hover\\:translate-y-2:hover{
  --transform-translate-y: 0.5rem;
}

.hover\\:translate-y-3:hover{
  --transform-translate-y: 0.75rem;
}

.hover\\:translate-y-4:hover{
  --transform-translate-y: 1rem;
}

.hover\\:translate-y-5:hover{
  --transform-translate-y: 1.25rem;
}

.hover\\:translate-y-6:hover{
  --transform-translate-y: 1.5rem;
}

.hover\\:translate-y-7:hover{
  --transform-translate-y: 1.75rem;
}

.hover\\:translate-y-8:hover{
  --transform-translate-y: 2rem;
}

.hover\\:translate-y-9:hover{
  --transform-translate-y: 2.25rem;
}

.hover\\:translate-y-10:hover{
  --transform-translate-y: 2.5rem;
}

.hover\\:translate-y-11:hover{
  --transform-translate-y: 2.75rem;
}

.hover\\:translate-y-12:hover{
  --transform-translate-y: 3rem;
}

.hover\\:translate-y-14:hover{
  --transform-translate-y: 3.5rem;
}

.hover\\:translate-y-15:hover{
  --transform-translate-y: 3.75rem;
}

.hover\\:translate-y-16:hover{
  --transform-translate-y: 4rem;
}

.hover\\:translate-y-18:hover{
  --transform-translate-y: 4.5rem;
}

.hover\\:translate-y-20:hover{
  --transform-translate-y: 5rem;
}

.hover\\:translate-y-22:hover{
  --transform-translate-y: 5.5rem;
}

.hover\\:translate-y-23:hover{
  --transform-translate-y: 5.75rem;
}

.hover\\:translate-y-24:hover{
  --transform-translate-y: 6rem;
}

.hover\\:translate-y-25:hover{
  --transform-translate-y: 6.25rem;
}

.hover\\:translate-y-26:hover{
  --transform-translate-y: 6.5rem;
}

.hover\\:translate-y-28:hover{
  --transform-translate-y: 7rem;
}

.hover\\:translate-y-30:hover{
  --transform-translate-y: 7.5rem;
}

.hover\\:translate-y-32:hover{
  --transform-translate-y: 8rem;
}

.hover\\:translate-y-34:hover{
  --transform-translate-y: 8.5rem;
}

.hover\\:translate-y-40:hover{
  --transform-translate-y: 10rem;
}

.hover\\:translate-y-42:hover{
  --transform-translate-y: 10.5rem;
}

.hover\\:translate-y-44:hover{
  --transform-translate-y: 11rem;
}

.hover\\:translate-y-48:hover{
  --transform-translate-y: 12rem;
}

.hover\\:translate-y-52:hover{
  --transform-translate-y: 13rem;
}

.hover\\:translate-y-54:hover{
  --transform-translate-y: 13.5rem;
}

.hover\\:translate-y-56:hover{
  --transform-translate-y: 14rem;
}

.hover\\:translate-y-60:hover{
  --transform-translate-y: 15rem;
}

.hover\\:translate-y-64:hover{
  --transform-translate-y: 16rem;
}

.hover\\:translate-y-68:hover{
  --transform-translate-y: 17rem;
}

.hover\\:translate-y-72:hover{
  --transform-translate-y: 18rem;
}

.hover\\:translate-y-74:hover{
  --transform-translate-y: 18.5rem;
}

.hover\\:translate-y-76:hover{
  --transform-translate-y: 19rem;
}

.hover\\:translate-y-78:hover{
  --transform-translate-y: 19.5rem;
}

.hover\\:translate-y-80:hover{
  --transform-translate-y: 20rem;
}

.hover\\:translate-y-82:hover{
  --transform-translate-y: 20.5rem;
}

.hover\\:translate-y-84:hover{
  --transform-translate-y: 21rem;
}

.hover\\:translate-y-88:hover{
  --transform-translate-y: 22rem;
}

.hover\\:translate-y-92:hover{
  --transform-translate-y: 23rem;
}

.hover\\:translate-y-96:hover{
  --transform-translate-y: 24rem;
}

.hover\\:translate-y-98:hover{
  --transform-translate-y: 24.5rem;
}

.hover\\:translate-y-100:hover{
  --transform-translate-y: 25rem;
}

.hover\\:translate-y-104:hover{
  --transform-translate-y: 26rem;
}

.hover\\:translate-y-112:hover{
  --transform-translate-y: 28rem;
}

.hover\\:translate-y-124:hover{
  --transform-translate-y: 31rem;
}

.hover\\:translate-y-128:hover{
  --transform-translate-y: 32rem;
}

.hover\\:translate-y-140:hover{
  --transform-translate-y: 35rem;
}

.hover\\:translate-y-152:hover{
  --transform-translate-y: 38rem;
}

.hover\\:translate-y-160:hover{
  --transform-translate-y: 40rem;
}

.hover\\:translate-y-162:hover{
  --transform-translate-y: 41rem;
}

.hover\\:translate-y-192:hover{
  --transform-translate-y: 48rem;
}

.hover\\:translate-y-208:hover{
  --transform-translate-y: 52rem;
}

.hover\\:translate-y-224:hover{
  --transform-translate-y: 56rem;
}

.hover\\:translate-y-256:hover{
  --transform-translate-y: 64rem;
}

.hover\\:translate-y-px:hover{
  --transform-translate-y: 1px;
}

.hover\\:-translate-y-1:hover{
  --transform-translate-y: -0.25rem;
}

.hover\\:-translate-y-2:hover{
  --transform-translate-y: -0.5rem;
}

.hover\\:-translate-y-3:hover{
  --transform-translate-y: -0.75rem;
}

.hover\\:-translate-y-4:hover{
  --transform-translate-y: -1rem;
}

.hover\\:-translate-y-5:hover{
  --transform-translate-y: -1.25rem;
}

.hover\\:-translate-y-6:hover{
  --transform-translate-y: -1.5rem;
}

.hover\\:-translate-y-7:hover{
  --transform-translate-y: -1.75rem;
}

.hover\\:-translate-y-8:hover{
  --transform-translate-y: -2rem;
}

.hover\\:-translate-y-9:hover{
  --transform-translate-y: -2.25rem;
}

.hover\\:-translate-y-10:hover{
  --transform-translate-y: -2.5rem;
}

.hover\\:-translate-y-11:hover{
  --transform-translate-y: -2.75rem;
}

.hover\\:-translate-y-12:hover{
  --transform-translate-y: -3rem;
}

.hover\\:-translate-y-14:hover{
  --transform-translate-y: -3.5rem;
}

.hover\\:-translate-y-15:hover{
  --transform-translate-y: -3.75rem;
}

.hover\\:-translate-y-16:hover{
  --transform-translate-y: -4rem;
}

.hover\\:-translate-y-18:hover{
  --transform-translate-y: -4.5rem;
}

.hover\\:-translate-y-20:hover{
  --transform-translate-y: -5rem;
}

.hover\\:-translate-y-22:hover{
  --transform-translate-y: -5.5rem;
}

.hover\\:-translate-y-23:hover{
  --transform-translate-y: -5.75rem;
}

.hover\\:-translate-y-24:hover{
  --transform-translate-y: -6rem;
}

.hover\\:-translate-y-25:hover{
  --transform-translate-y: -6.25rem;
}

.hover\\:-translate-y-26:hover{
  --transform-translate-y: -6.5rem;
}

.hover\\:-translate-y-28:hover{
  --transform-translate-y: -7rem;
}

.hover\\:-translate-y-30:hover{
  --transform-translate-y: -7.5rem;
}

.hover\\:-translate-y-32:hover{
  --transform-translate-y: -8rem;
}

.hover\\:-translate-y-34:hover{
  --transform-translate-y: -8.5rem;
}

.hover\\:-translate-y-40:hover{
  --transform-translate-y: -10rem;
}

.hover\\:-translate-y-42:hover{
  --transform-translate-y: -10.5rem;
}

.hover\\:-translate-y-44:hover{
  --transform-translate-y: -11rem;
}

.hover\\:-translate-y-48:hover{
  --transform-translate-y: -12rem;
}

.hover\\:-translate-y-52:hover{
  --transform-translate-y: -13rem;
}

.hover\\:-translate-y-54:hover{
  --transform-translate-y: -13.5rem;
}

.hover\\:-translate-y-56:hover{
  --transform-translate-y: -14rem;
}

.hover\\:-translate-y-60:hover{
  --transform-translate-y: -15rem;
}

.hover\\:-translate-y-64:hover{
  --transform-translate-y: -16rem;
}

.hover\\:-translate-y-68:hover{
  --transform-translate-y: -17rem;
}

.hover\\:-translate-y-72:hover{
  --transform-translate-y: -18rem;
}

.hover\\:-translate-y-74:hover{
  --transform-translate-y: -18.5rem;
}

.hover\\:-translate-y-76:hover{
  --transform-translate-y: -19rem;
}

.hover\\:-translate-y-78:hover{
  --transform-translate-y: -19.5rem;
}

.hover\\:-translate-y-80:hover{
  --transform-translate-y: -20rem;
}

.hover\\:-translate-y-82:hover{
  --transform-translate-y: -20.5rem;
}

.hover\\:-translate-y-84:hover{
  --transform-translate-y: -21rem;
}

.hover\\:-translate-y-88:hover{
  --transform-translate-y: -22rem;
}

.hover\\:-translate-y-92:hover{
  --transform-translate-y: -23rem;
}

.hover\\:-translate-y-96:hover{
  --transform-translate-y: -24rem;
}

.hover\\:-translate-y-98:hover{
  --transform-translate-y: -24.5rem;
}

.hover\\:-translate-y-100:hover{
  --transform-translate-y: -25rem;
}

.hover\\:-translate-y-104:hover{
  --transform-translate-y: -26rem;
}

.hover\\:-translate-y-112:hover{
  --transform-translate-y: -28rem;
}

.hover\\:-translate-y-124:hover{
  --transform-translate-y: -31rem;
}

.hover\\:-translate-y-128:hover{
  --transform-translate-y: -32rem;
}

.hover\\:-translate-y-140:hover{
  --transform-translate-y: -35rem;
}

.hover\\:-translate-y-152:hover{
  --transform-translate-y: -38rem;
}

.hover\\:-translate-y-160:hover{
  --transform-translate-y: -40rem;
}

.hover\\:-translate-y-162:hover{
  --transform-translate-y: -41rem;
}

.hover\\:-translate-y-192:hover{
  --transform-translate-y: -48rem;
}

.hover\\:-translate-y-208:hover{
  --transform-translate-y: -52rem;
}

.hover\\:-translate-y-224:hover{
  --transform-translate-y: -56rem;
}

.hover\\:-translate-y-256:hover{
  --transform-translate-y: -64rem;
}

.hover\\:-translate-y-px:hover{
  --transform-translate-y: -1px;
}

.hover\\:-translate-y-full:hover{
  --transform-translate-y: -100%;
}

.hover\\:-translate-y-1\\/2:hover{
  --transform-translate-y: -50%;
}

.hover\\:translate-y-1\\/2:hover{
  --transform-translate-y: 50%;
}

.hover\\:translate-y-full:hover{
  --transform-translate-y: 100%;
}

.focus\\:translate-x-0:focus{
  --transform-translate-x: 0;
}

.focus\\:translate-x-1:focus{
  --transform-translate-x: 0.25rem;
}

.focus\\:translate-x-2:focus{
  --transform-translate-x: 0.5rem;
}

.focus\\:translate-x-3:focus{
  --transform-translate-x: 0.75rem;
}

.focus\\:translate-x-4:focus{
  --transform-translate-x: 1rem;
}

.focus\\:translate-x-5:focus{
  --transform-translate-x: 1.25rem;
}

.focus\\:translate-x-6:focus{
  --transform-translate-x: 1.5rem;
}

.focus\\:translate-x-7:focus{
  --transform-translate-x: 1.75rem;
}

.focus\\:translate-x-8:focus{
  --transform-translate-x: 2rem;
}

.focus\\:translate-x-9:focus{
  --transform-translate-x: 2.25rem;
}

.focus\\:translate-x-10:focus{
  --transform-translate-x: 2.5rem;
}

.focus\\:translate-x-11:focus{
  --transform-translate-x: 2.75rem;
}

.focus\\:translate-x-12:focus{
  --transform-translate-x: 3rem;
}

.focus\\:translate-x-14:focus{
  --transform-translate-x: 3.5rem;
}

.focus\\:translate-x-15:focus{
  --transform-translate-x: 3.75rem;
}

.focus\\:translate-x-16:focus{
  --transform-translate-x: 4rem;
}

.focus\\:translate-x-18:focus{
  --transform-translate-x: 4.5rem;
}

.focus\\:translate-x-20:focus{
  --transform-translate-x: 5rem;
}

.focus\\:translate-x-22:focus{
  --transform-translate-x: 5.5rem;
}

.focus\\:translate-x-23:focus{
  --transform-translate-x: 5.75rem;
}

.focus\\:translate-x-24:focus{
  --transform-translate-x: 6rem;
}

.focus\\:translate-x-25:focus{
  --transform-translate-x: 6.25rem;
}

.focus\\:translate-x-26:focus{
  --transform-translate-x: 6.5rem;
}

.focus\\:translate-x-28:focus{
  --transform-translate-x: 7rem;
}

.focus\\:translate-x-30:focus{
  --transform-translate-x: 7.5rem;
}

.focus\\:translate-x-32:focus{
  --transform-translate-x: 8rem;
}

.focus\\:translate-x-34:focus{
  --transform-translate-x: 8.5rem;
}

.focus\\:translate-x-40:focus{
  --transform-translate-x: 10rem;
}

.focus\\:translate-x-42:focus{
  --transform-translate-x: 10.5rem;
}

.focus\\:translate-x-44:focus{
  --transform-translate-x: 11rem;
}

.focus\\:translate-x-48:focus{
  --transform-translate-x: 12rem;
}

.focus\\:translate-x-52:focus{
  --transform-translate-x: 13rem;
}

.focus\\:translate-x-54:focus{
  --transform-translate-x: 13.5rem;
}

.focus\\:translate-x-56:focus{
  --transform-translate-x: 14rem;
}

.focus\\:translate-x-60:focus{
  --transform-translate-x: 15rem;
}

.focus\\:translate-x-64:focus{
  --transform-translate-x: 16rem;
}

.focus\\:translate-x-68:focus{
  --transform-translate-x: 17rem;
}

.focus\\:translate-x-72:focus{
  --transform-translate-x: 18rem;
}

.focus\\:translate-x-74:focus{
  --transform-translate-x: 18.5rem;
}

.focus\\:translate-x-76:focus{
  --transform-translate-x: 19rem;
}

.focus\\:translate-x-78:focus{
  --transform-translate-x: 19.5rem;
}

.focus\\:translate-x-80:focus{
  --transform-translate-x: 20rem;
}

.focus\\:translate-x-82:focus{
  --transform-translate-x: 20.5rem;
}

.focus\\:translate-x-84:focus{
  --transform-translate-x: 21rem;
}

.focus\\:translate-x-88:focus{
  --transform-translate-x: 22rem;
}

.focus\\:translate-x-92:focus{
  --transform-translate-x: 23rem;
}

.focus\\:translate-x-96:focus{
  --transform-translate-x: 24rem;
}

.focus\\:translate-x-98:focus{
  --transform-translate-x: 24.5rem;
}

.focus\\:translate-x-100:focus{
  --transform-translate-x: 25rem;
}

.focus\\:translate-x-104:focus{
  --transform-translate-x: 26rem;
}

.focus\\:translate-x-112:focus{
  --transform-translate-x: 28rem;
}

.focus\\:translate-x-124:focus{
  --transform-translate-x: 31rem;
}

.focus\\:translate-x-128:focus{
  --transform-translate-x: 32rem;
}

.focus\\:translate-x-140:focus{
  --transform-translate-x: 35rem;
}

.focus\\:translate-x-152:focus{
  --transform-translate-x: 38rem;
}

.focus\\:translate-x-160:focus{
  --transform-translate-x: 40rem;
}

.focus\\:translate-x-162:focus{
  --transform-translate-x: 41rem;
}

.focus\\:translate-x-192:focus{
  --transform-translate-x: 48rem;
}

.focus\\:translate-x-208:focus{
  --transform-translate-x: 52rem;
}

.focus\\:translate-x-224:focus{
  --transform-translate-x: 56rem;
}

.focus\\:translate-x-256:focus{
  --transform-translate-x: 64rem;
}

.focus\\:translate-x-px:focus{
  --transform-translate-x: 1px;
}

.focus\\:-translate-x-1:focus{
  --transform-translate-x: -0.25rem;
}

.focus\\:-translate-x-2:focus{
  --transform-translate-x: -0.5rem;
}

.focus\\:-translate-x-3:focus{
  --transform-translate-x: -0.75rem;
}

.focus\\:-translate-x-4:focus{
  --transform-translate-x: -1rem;
}

.focus\\:-translate-x-5:focus{
  --transform-translate-x: -1.25rem;
}

.focus\\:-translate-x-6:focus{
  --transform-translate-x: -1.5rem;
}

.focus\\:-translate-x-7:focus{
  --transform-translate-x: -1.75rem;
}

.focus\\:-translate-x-8:focus{
  --transform-translate-x: -2rem;
}

.focus\\:-translate-x-9:focus{
  --transform-translate-x: -2.25rem;
}

.focus\\:-translate-x-10:focus{
  --transform-translate-x: -2.5rem;
}

.focus\\:-translate-x-11:focus{
  --transform-translate-x: -2.75rem;
}

.focus\\:-translate-x-12:focus{
  --transform-translate-x: -3rem;
}

.focus\\:-translate-x-14:focus{
  --transform-translate-x: -3.5rem;
}

.focus\\:-translate-x-15:focus{
  --transform-translate-x: -3.75rem;
}

.focus\\:-translate-x-16:focus{
  --transform-translate-x: -4rem;
}

.focus\\:-translate-x-18:focus{
  --transform-translate-x: -4.5rem;
}

.focus\\:-translate-x-20:focus{
  --transform-translate-x: -5rem;
}

.focus\\:-translate-x-22:focus{
  --transform-translate-x: -5.5rem;
}

.focus\\:-translate-x-23:focus{
  --transform-translate-x: -5.75rem;
}

.focus\\:-translate-x-24:focus{
  --transform-translate-x: -6rem;
}

.focus\\:-translate-x-25:focus{
  --transform-translate-x: -6.25rem;
}

.focus\\:-translate-x-26:focus{
  --transform-translate-x: -6.5rem;
}

.focus\\:-translate-x-28:focus{
  --transform-translate-x: -7rem;
}

.focus\\:-translate-x-30:focus{
  --transform-translate-x: -7.5rem;
}

.focus\\:-translate-x-32:focus{
  --transform-translate-x: -8rem;
}

.focus\\:-translate-x-34:focus{
  --transform-translate-x: -8.5rem;
}

.focus\\:-translate-x-40:focus{
  --transform-translate-x: -10rem;
}

.focus\\:-translate-x-42:focus{
  --transform-translate-x: -10.5rem;
}

.focus\\:-translate-x-44:focus{
  --transform-translate-x: -11rem;
}

.focus\\:-translate-x-48:focus{
  --transform-translate-x: -12rem;
}

.focus\\:-translate-x-52:focus{
  --transform-translate-x: -13rem;
}

.focus\\:-translate-x-54:focus{
  --transform-translate-x: -13.5rem;
}

.focus\\:-translate-x-56:focus{
  --transform-translate-x: -14rem;
}

.focus\\:-translate-x-60:focus{
  --transform-translate-x: -15rem;
}

.focus\\:-translate-x-64:focus{
  --transform-translate-x: -16rem;
}

.focus\\:-translate-x-68:focus{
  --transform-translate-x: -17rem;
}

.focus\\:-translate-x-72:focus{
  --transform-translate-x: -18rem;
}

.focus\\:-translate-x-74:focus{
  --transform-translate-x: -18.5rem;
}

.focus\\:-translate-x-76:focus{
  --transform-translate-x: -19rem;
}

.focus\\:-translate-x-78:focus{
  --transform-translate-x: -19.5rem;
}

.focus\\:-translate-x-80:focus{
  --transform-translate-x: -20rem;
}

.focus\\:-translate-x-82:focus{
  --transform-translate-x: -20.5rem;
}

.focus\\:-translate-x-84:focus{
  --transform-translate-x: -21rem;
}

.focus\\:-translate-x-88:focus{
  --transform-translate-x: -22rem;
}

.focus\\:-translate-x-92:focus{
  --transform-translate-x: -23rem;
}

.focus\\:-translate-x-96:focus{
  --transform-translate-x: -24rem;
}

.focus\\:-translate-x-98:focus{
  --transform-translate-x: -24.5rem;
}

.focus\\:-translate-x-100:focus{
  --transform-translate-x: -25rem;
}

.focus\\:-translate-x-104:focus{
  --transform-translate-x: -26rem;
}

.focus\\:-translate-x-112:focus{
  --transform-translate-x: -28rem;
}

.focus\\:-translate-x-124:focus{
  --transform-translate-x: -31rem;
}

.focus\\:-translate-x-128:focus{
  --transform-translate-x: -32rem;
}

.focus\\:-translate-x-140:focus{
  --transform-translate-x: -35rem;
}

.focus\\:-translate-x-152:focus{
  --transform-translate-x: -38rem;
}

.focus\\:-translate-x-160:focus{
  --transform-translate-x: -40rem;
}

.focus\\:-translate-x-162:focus{
  --transform-translate-x: -41rem;
}

.focus\\:-translate-x-192:focus{
  --transform-translate-x: -48rem;
}

.focus\\:-translate-x-208:focus{
  --transform-translate-x: -52rem;
}

.focus\\:-translate-x-224:focus{
  --transform-translate-x: -56rem;
}

.focus\\:-translate-x-256:focus{
  --transform-translate-x: -64rem;
}

.focus\\:-translate-x-px:focus{
  --transform-translate-x: -1px;
}

.focus\\:-translate-x-full:focus{
  --transform-translate-x: -100%;
}

.focus\\:-translate-x-1\\/2:focus{
  --transform-translate-x: -50%;
}

.focus\\:translate-x-1\\/2:focus{
  --transform-translate-x: 50%;
}

.focus\\:translate-x-full:focus{
  --transform-translate-x: 100%;
}

.focus\\:translate-y-0:focus{
  --transform-translate-y: 0;
}

.focus\\:translate-y-1:focus{
  --transform-translate-y: 0.25rem;
}

.focus\\:translate-y-2:focus{
  --transform-translate-y: 0.5rem;
}

.focus\\:translate-y-3:focus{
  --transform-translate-y: 0.75rem;
}

.focus\\:translate-y-4:focus{
  --transform-translate-y: 1rem;
}

.focus\\:translate-y-5:focus{
  --transform-translate-y: 1.25rem;
}

.focus\\:translate-y-6:focus{
  --transform-translate-y: 1.5rem;
}

.focus\\:translate-y-7:focus{
  --transform-translate-y: 1.75rem;
}

.focus\\:translate-y-8:focus{
  --transform-translate-y: 2rem;
}

.focus\\:translate-y-9:focus{
  --transform-translate-y: 2.25rem;
}

.focus\\:translate-y-10:focus{
  --transform-translate-y: 2.5rem;
}

.focus\\:translate-y-11:focus{
  --transform-translate-y: 2.75rem;
}

.focus\\:translate-y-12:focus{
  --transform-translate-y: 3rem;
}

.focus\\:translate-y-14:focus{
  --transform-translate-y: 3.5rem;
}

.focus\\:translate-y-15:focus{
  --transform-translate-y: 3.75rem;
}

.focus\\:translate-y-16:focus{
  --transform-translate-y: 4rem;
}

.focus\\:translate-y-18:focus{
  --transform-translate-y: 4.5rem;
}

.focus\\:translate-y-20:focus{
  --transform-translate-y: 5rem;
}

.focus\\:translate-y-22:focus{
  --transform-translate-y: 5.5rem;
}

.focus\\:translate-y-23:focus{
  --transform-translate-y: 5.75rem;
}

.focus\\:translate-y-24:focus{
  --transform-translate-y: 6rem;
}

.focus\\:translate-y-25:focus{
  --transform-translate-y: 6.25rem;
}

.focus\\:translate-y-26:focus{
  --transform-translate-y: 6.5rem;
}

.focus\\:translate-y-28:focus{
  --transform-translate-y: 7rem;
}

.focus\\:translate-y-30:focus{
  --transform-translate-y: 7.5rem;
}

.focus\\:translate-y-32:focus{
  --transform-translate-y: 8rem;
}

.focus\\:translate-y-34:focus{
  --transform-translate-y: 8.5rem;
}

.focus\\:translate-y-40:focus{
  --transform-translate-y: 10rem;
}

.focus\\:translate-y-42:focus{
  --transform-translate-y: 10.5rem;
}

.focus\\:translate-y-44:focus{
  --transform-translate-y: 11rem;
}

.focus\\:translate-y-48:focus{
  --transform-translate-y: 12rem;
}

.focus\\:translate-y-52:focus{
  --transform-translate-y: 13rem;
}

.focus\\:translate-y-54:focus{
  --transform-translate-y: 13.5rem;
}

.focus\\:translate-y-56:focus{
  --transform-translate-y: 14rem;
}

.focus\\:translate-y-60:focus{
  --transform-translate-y: 15rem;
}

.focus\\:translate-y-64:focus{
  --transform-translate-y: 16rem;
}

.focus\\:translate-y-68:focus{
  --transform-translate-y: 17rem;
}

.focus\\:translate-y-72:focus{
  --transform-translate-y: 18rem;
}

.focus\\:translate-y-74:focus{
  --transform-translate-y: 18.5rem;
}

.focus\\:translate-y-76:focus{
  --transform-translate-y: 19rem;
}

.focus\\:translate-y-78:focus{
  --transform-translate-y: 19.5rem;
}

.focus\\:translate-y-80:focus{
  --transform-translate-y: 20rem;
}

.focus\\:translate-y-82:focus{
  --transform-translate-y: 20.5rem;
}

.focus\\:translate-y-84:focus{
  --transform-translate-y: 21rem;
}

.focus\\:translate-y-88:focus{
  --transform-translate-y: 22rem;
}

.focus\\:translate-y-92:focus{
  --transform-translate-y: 23rem;
}

.focus\\:translate-y-96:focus{
  --transform-translate-y: 24rem;
}

.focus\\:translate-y-98:focus{
  --transform-translate-y: 24.5rem;
}

.focus\\:translate-y-100:focus{
  --transform-translate-y: 25rem;
}

.focus\\:translate-y-104:focus{
  --transform-translate-y: 26rem;
}

.focus\\:translate-y-112:focus{
  --transform-translate-y: 28rem;
}

.focus\\:translate-y-124:focus{
  --transform-translate-y: 31rem;
}

.focus\\:translate-y-128:focus{
  --transform-translate-y: 32rem;
}

.focus\\:translate-y-140:focus{
  --transform-translate-y: 35rem;
}

.focus\\:translate-y-152:focus{
  --transform-translate-y: 38rem;
}

.focus\\:translate-y-160:focus{
  --transform-translate-y: 40rem;
}

.focus\\:translate-y-162:focus{
  --transform-translate-y: 41rem;
}

.focus\\:translate-y-192:focus{
  --transform-translate-y: 48rem;
}

.focus\\:translate-y-208:focus{
  --transform-translate-y: 52rem;
}

.focus\\:translate-y-224:focus{
  --transform-translate-y: 56rem;
}

.focus\\:translate-y-256:focus{
  --transform-translate-y: 64rem;
}

.focus\\:translate-y-px:focus{
  --transform-translate-y: 1px;
}

.focus\\:-translate-y-1:focus{
  --transform-translate-y: -0.25rem;
}

.focus\\:-translate-y-2:focus{
  --transform-translate-y: -0.5rem;
}

.focus\\:-translate-y-3:focus{
  --transform-translate-y: -0.75rem;
}

.focus\\:-translate-y-4:focus{
  --transform-translate-y: -1rem;
}

.focus\\:-translate-y-5:focus{
  --transform-translate-y: -1.25rem;
}

.focus\\:-translate-y-6:focus{
  --transform-translate-y: -1.5rem;
}

.focus\\:-translate-y-7:focus{
  --transform-translate-y: -1.75rem;
}

.focus\\:-translate-y-8:focus{
  --transform-translate-y: -2rem;
}

.focus\\:-translate-y-9:focus{
  --transform-translate-y: -2.25rem;
}

.focus\\:-translate-y-10:focus{
  --transform-translate-y: -2.5rem;
}

.focus\\:-translate-y-11:focus{
  --transform-translate-y: -2.75rem;
}

.focus\\:-translate-y-12:focus{
  --transform-translate-y: -3rem;
}

.focus\\:-translate-y-14:focus{
  --transform-translate-y: -3.5rem;
}

.focus\\:-translate-y-15:focus{
  --transform-translate-y: -3.75rem;
}

.focus\\:-translate-y-16:focus{
  --transform-translate-y: -4rem;
}

.focus\\:-translate-y-18:focus{
  --transform-translate-y: -4.5rem;
}

.focus\\:-translate-y-20:focus{
  --transform-translate-y: -5rem;
}

.focus\\:-translate-y-22:focus{
  --transform-translate-y: -5.5rem;
}

.focus\\:-translate-y-23:focus{
  --transform-translate-y: -5.75rem;
}

.focus\\:-translate-y-24:focus{
  --transform-translate-y: -6rem;
}

.focus\\:-translate-y-25:focus{
  --transform-translate-y: -6.25rem;
}

.focus\\:-translate-y-26:focus{
  --transform-translate-y: -6.5rem;
}

.focus\\:-translate-y-28:focus{
  --transform-translate-y: -7rem;
}

.focus\\:-translate-y-30:focus{
  --transform-translate-y: -7.5rem;
}

.focus\\:-translate-y-32:focus{
  --transform-translate-y: -8rem;
}

.focus\\:-translate-y-34:focus{
  --transform-translate-y: -8.5rem;
}

.focus\\:-translate-y-40:focus{
  --transform-translate-y: -10rem;
}

.focus\\:-translate-y-42:focus{
  --transform-translate-y: -10.5rem;
}

.focus\\:-translate-y-44:focus{
  --transform-translate-y: -11rem;
}

.focus\\:-translate-y-48:focus{
  --transform-translate-y: -12rem;
}

.focus\\:-translate-y-52:focus{
  --transform-translate-y: -13rem;
}

.focus\\:-translate-y-54:focus{
  --transform-translate-y: -13.5rem;
}

.focus\\:-translate-y-56:focus{
  --transform-translate-y: -14rem;
}

.focus\\:-translate-y-60:focus{
  --transform-translate-y: -15rem;
}

.focus\\:-translate-y-64:focus{
  --transform-translate-y: -16rem;
}

.focus\\:-translate-y-68:focus{
  --transform-translate-y: -17rem;
}

.focus\\:-translate-y-72:focus{
  --transform-translate-y: -18rem;
}

.focus\\:-translate-y-74:focus{
  --transform-translate-y: -18.5rem;
}

.focus\\:-translate-y-76:focus{
  --transform-translate-y: -19rem;
}

.focus\\:-translate-y-78:focus{
  --transform-translate-y: -19.5rem;
}

.focus\\:-translate-y-80:focus{
  --transform-translate-y: -20rem;
}

.focus\\:-translate-y-82:focus{
  --transform-translate-y: -20.5rem;
}

.focus\\:-translate-y-84:focus{
  --transform-translate-y: -21rem;
}

.focus\\:-translate-y-88:focus{
  --transform-translate-y: -22rem;
}

.focus\\:-translate-y-92:focus{
  --transform-translate-y: -23rem;
}

.focus\\:-translate-y-96:focus{
  --transform-translate-y: -24rem;
}

.focus\\:-translate-y-98:focus{
  --transform-translate-y: -24.5rem;
}

.focus\\:-translate-y-100:focus{
  --transform-translate-y: -25rem;
}

.focus\\:-translate-y-104:focus{
  --transform-translate-y: -26rem;
}

.focus\\:-translate-y-112:focus{
  --transform-translate-y: -28rem;
}

.focus\\:-translate-y-124:focus{
  --transform-translate-y: -31rem;
}

.focus\\:-translate-y-128:focus{
  --transform-translate-y: -32rem;
}

.focus\\:-translate-y-140:focus{
  --transform-translate-y: -35rem;
}

.focus\\:-translate-y-152:focus{
  --transform-translate-y: -38rem;
}

.focus\\:-translate-y-160:focus{
  --transform-translate-y: -40rem;
}

.focus\\:-translate-y-162:focus{
  --transform-translate-y: -41rem;
}

.focus\\:-translate-y-192:focus{
  --transform-translate-y: -48rem;
}

.focus\\:-translate-y-208:focus{
  --transform-translate-y: -52rem;
}

.focus\\:-translate-y-224:focus{
  --transform-translate-y: -56rem;
}

.focus\\:-translate-y-256:focus{
  --transform-translate-y: -64rem;
}

.focus\\:-translate-y-px:focus{
  --transform-translate-y: -1px;
}

.focus\\:-translate-y-full:focus{
  --transform-translate-y: -100%;
}

.focus\\:-translate-y-1\\/2:focus{
  --transform-translate-y: -50%;
}

.focus\\:translate-y-1\\/2:focus{
  --transform-translate-y: 50%;
}

.focus\\:translate-y-full:focus{
  --transform-translate-y: 100%;
}

.skew-x-0{
  --transform-skew-x: 0;
}

.skew-x-1{
  --transform-skew-x: 1deg;
}

.skew-x-2{
  --transform-skew-x: 2deg;
}

.skew-x-3{
  --transform-skew-x: 3deg;
}

.skew-x-6{
  --transform-skew-x: 6deg;
}

.skew-x-12{
  --transform-skew-x: 12deg;
}

.-skew-x-12{
  --transform-skew-x: -12deg;
}

.-skew-x-6{
  --transform-skew-x: -6deg;
}

.-skew-x-3{
  --transform-skew-x: -3deg;
}

.-skew-x-2{
  --transform-skew-x: -2deg;
}

.-skew-x-1{
  --transform-skew-x: -1deg;
}

.skew-y-0{
  --transform-skew-y: 0;
}

.skew-y-1{
  --transform-skew-y: 1deg;
}

.skew-y-2{
  --transform-skew-y: 2deg;
}

.skew-y-3{
  --transform-skew-y: 3deg;
}

.skew-y-6{
  --transform-skew-y: 6deg;
}

.skew-y-12{
  --transform-skew-y: 12deg;
}

.-skew-y-12{
  --transform-skew-y: -12deg;
}

.-skew-y-6{
  --transform-skew-y: -6deg;
}

.-skew-y-3{
  --transform-skew-y: -3deg;
}

.-skew-y-2{
  --transform-skew-y: -2deg;
}

.-skew-y-1{
  --transform-skew-y: -1deg;
}

.hover\\:skew-x-0:hover{
  --transform-skew-x: 0;
}

.hover\\:skew-x-1:hover{
  --transform-skew-x: 1deg;
}

.hover\\:skew-x-2:hover{
  --transform-skew-x: 2deg;
}

.hover\\:skew-x-3:hover{
  --transform-skew-x: 3deg;
}

.hover\\:skew-x-6:hover{
  --transform-skew-x: 6deg;
}

.hover\\:skew-x-12:hover{
  --transform-skew-x: 12deg;
}

.hover\\:-skew-x-12:hover{
  --transform-skew-x: -12deg;
}

.hover\\:-skew-x-6:hover{
  --transform-skew-x: -6deg;
}

.hover\\:-skew-x-3:hover{
  --transform-skew-x: -3deg;
}

.hover\\:-skew-x-2:hover{
  --transform-skew-x: -2deg;
}

.hover\\:-skew-x-1:hover{
  --transform-skew-x: -1deg;
}

.hover\\:skew-y-0:hover{
  --transform-skew-y: 0;
}

.hover\\:skew-y-1:hover{
  --transform-skew-y: 1deg;
}

.hover\\:skew-y-2:hover{
  --transform-skew-y: 2deg;
}

.hover\\:skew-y-3:hover{
  --transform-skew-y: 3deg;
}

.hover\\:skew-y-6:hover{
  --transform-skew-y: 6deg;
}

.hover\\:skew-y-12:hover{
  --transform-skew-y: 12deg;
}

.hover\\:-skew-y-12:hover{
  --transform-skew-y: -12deg;
}

.hover\\:-skew-y-6:hover{
  --transform-skew-y: -6deg;
}

.hover\\:-skew-y-3:hover{
  --transform-skew-y: -3deg;
}

.hover\\:-skew-y-2:hover{
  --transform-skew-y: -2deg;
}

.hover\\:-skew-y-1:hover{
  --transform-skew-y: -1deg;
}

.focus\\:skew-x-0:focus{
  --transform-skew-x: 0;
}

.focus\\:skew-x-1:focus{
  --transform-skew-x: 1deg;
}

.focus\\:skew-x-2:focus{
  --transform-skew-x: 2deg;
}

.focus\\:skew-x-3:focus{
  --transform-skew-x: 3deg;
}

.focus\\:skew-x-6:focus{
  --transform-skew-x: 6deg;
}

.focus\\:skew-x-12:focus{
  --transform-skew-x: 12deg;
}

.focus\\:-skew-x-12:focus{
  --transform-skew-x: -12deg;
}

.focus\\:-skew-x-6:focus{
  --transform-skew-x: -6deg;
}

.focus\\:-skew-x-3:focus{
  --transform-skew-x: -3deg;
}

.focus\\:-skew-x-2:focus{
  --transform-skew-x: -2deg;
}

.focus\\:-skew-x-1:focus{
  --transform-skew-x: -1deg;
}

.focus\\:skew-y-0:focus{
  --transform-skew-y: 0;
}

.focus\\:skew-y-1:focus{
  --transform-skew-y: 1deg;
}

.focus\\:skew-y-2:focus{
  --transform-skew-y: 2deg;
}

.focus\\:skew-y-3:focus{
  --transform-skew-y: 3deg;
}

.focus\\:skew-y-6:focus{
  --transform-skew-y: 6deg;
}

.focus\\:skew-y-12:focus{
  --transform-skew-y: 12deg;
}

.focus\\:-skew-y-12:focus{
  --transform-skew-y: -12deg;
}

.focus\\:-skew-y-6:focus{
  --transform-skew-y: -6deg;
}

.focus\\:-skew-y-3:focus{
  --transform-skew-y: -3deg;
}

.focus\\:-skew-y-2:focus{
  --transform-skew-y: -2deg;
}

.focus\\:-skew-y-1:focus{
  --transform-skew-y: -1deg;
}

.transition-none{
  transition-property: none;
}

.transition-all{
  transition-property: all;
}

.transition{
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
}

.transition-colors{
  transition-property: background-color, border-color, color, fill, stroke;
}

.transition-opacity{
  transition-property: opacity;
}

.transition-shadow{
  transition-property: box-shadow;
}

.transition-transform{
  transition-property: transform;
}

.ease-linear{
  transition-timing-function: linear;
}

.ease-in{
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

.ease-out{
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}

.ease-in-out{
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.duration-75{
  transition-duration: 75ms;
}

.duration-100{
  transition-duration: 100ms;
}

.duration-150{
  transition-duration: 150ms;
}

.duration-200{
  transition-duration: 200ms;
}

.duration-300{
  transition-duration: 300ms;
}

.duration-500{
  transition-duration: 500ms;
}

.duration-700{
  transition-duration: 700ms;
}

.duration-1000{
  transition-duration: 1000ms;
}

.delay-75{
  transition-delay: 75ms;
}

.delay-100{
  transition-delay: 100ms;
}

.delay-150{
  transition-delay: 150ms;
}

.delay-200{
  transition-delay: 200ms;
}

.delay-300{
  transition-delay: 300ms;
}

.delay-500{
  transition-delay: 500ms;
}

.delay-700{
  transition-delay: 700ms;
}

.delay-1000{
  transition-delay: 1000ms;
}

@keyframes spin{
  to{
    transform: rotate(360deg);
  }
}

@keyframes ping{
  75%, 100%{
    transform: scale(2);
    opacity: 0;
  }
}

@keyframes pulse{
  50%{
    opacity: .5;
  }
}

@keyframes bounce{
  0%, 100%{
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8,0,1,1);
  }

  50%{
    transform: none;
    animation-timing-function: cubic-bezier(0,0,0.2,1);
  }
}

.animate-none{
  animation: none;
}

.animate-spin{
  animation: spin 1s linear infinite;
}

.animate-ping{
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}

.animate-pulse{
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.animate-bounce{
  animation: bounce 1s infinite;
}

[dir="ltr"] .ps-0{
  padding-left: 0;
}

[dir="rtl"] .ps-0{
  padding-right: 0;
}

[dir="ltr"] .pe-0{
  padding-right: 0;
}

[dir="rtl"] .pe-0{
  padding-left: 0;
}

[dir="ltr"] .ps-1{
  padding-left: 0.25rem;
}

[dir="rtl"] .ps-1{
  padding-right: 0.25rem;
}

[dir="ltr"] .pe-1{
  padding-right: 0.25rem;
}

[dir="rtl"] .pe-1{
  padding-left: 0.25rem;
}

[dir="ltr"] .ps-2{
  padding-left: 0.5rem;
}

[dir="rtl"] .ps-2{
  padding-right: 0.5rem;
}

[dir="ltr"] .pe-2{
  padding-right: 0.5rem;
}

[dir="rtl"] .pe-2{
  padding-left: 0.5rem;
}

[dir="ltr"] .ps-3{
  padding-left: 0.75rem;
}

[dir="rtl"] .ps-3{
  padding-right: 0.75rem;
}

[dir="ltr"] .pe-3{
  padding-right: 0.75rem;
}

[dir="rtl"] .pe-3{
  padding-left: 0.75rem;
}

[dir="ltr"] .ps-4{
  padding-left: 1rem;
}

[dir="rtl"] .ps-4{
  padding-right: 1rem;
}

[dir="ltr"] .pe-4{
  padding-right: 1rem;
}

[dir="rtl"] .pe-4{
  padding-left: 1rem;
}

[dir="ltr"] .ps-5{
  padding-left: 1.25rem;
}

[dir="rtl"] .ps-5{
  padding-right: 1.25rem;
}

[dir="ltr"] .pe-5{
  padding-right: 1.25rem;
}

[dir="rtl"] .pe-5{
  padding-left: 1.25rem;
}

[dir="ltr"] .ps-6{
  padding-left: 1.5rem;
}

[dir="rtl"] .ps-6{
  padding-right: 1.5rem;
}

[dir="ltr"] .pe-6{
  padding-right: 1.5rem;
}

[dir="rtl"] .pe-6{
  padding-left: 1.5rem;
}

[dir="ltr"] .ps-7{
  padding-left: 1.75rem;
}

[dir="rtl"] .ps-7{
  padding-right: 1.75rem;
}

[dir="ltr"] .pe-7{
  padding-right: 1.75rem;
}

[dir="rtl"] .pe-7{
  padding-left: 1.75rem;
}

[dir="ltr"] .ps-8{
  padding-left: 2rem;
}

[dir="rtl"] .ps-8{
  padding-right: 2rem;
}

[dir="ltr"] .pe-8{
  padding-right: 2rem;
}

[dir="rtl"] .pe-8{
  padding-left: 2rem;
}

[dir="ltr"] .ps-9{
  padding-left: 2.25rem;
}

[dir="rtl"] .ps-9{
  padding-right: 2.25rem;
}

[dir="ltr"] .pe-9{
  padding-right: 2.25rem;
}

[dir="rtl"] .pe-9{
  padding-left: 2.25rem;
}

[dir="ltr"] .ps-10{
  padding-left: 2.5rem;
}

[dir="rtl"] .ps-10{
  padding-right: 2.5rem;
}

[dir="ltr"] .pe-10{
  padding-right: 2.5rem;
}

[dir="rtl"] .pe-10{
  padding-left: 2.5rem;
}

[dir="ltr"] .ps-11{
  padding-left: 2.75rem;
}

[dir="rtl"] .ps-11{
  padding-right: 2.75rem;
}

[dir="ltr"] .pe-11{
  padding-right: 2.75rem;
}

[dir="rtl"] .pe-11{
  padding-left: 2.75rem;
}

[dir="ltr"] .ps-12{
  padding-left: 3rem;
}

[dir="rtl"] .ps-12{
  padding-right: 3rem;
}

[dir="ltr"] .pe-12{
  padding-right: 3rem;
}

[dir="rtl"] .pe-12{
  padding-left: 3rem;
}

[dir="ltr"] .ps-14{
  padding-left: 3.5rem;
}

[dir="rtl"] .ps-14{
  padding-right: 3.5rem;
}

[dir="ltr"] .pe-14{
  padding-right: 3.5rem;
}

[dir="rtl"] .pe-14{
  padding-left: 3.5rem;
}

[dir="ltr"] .ps-15{
  padding-left: 3.75rem;
}

[dir="rtl"] .ps-15{
  padding-right: 3.75rem;
}

[dir="ltr"] .pe-15{
  padding-right: 3.75rem;
}

[dir="rtl"] .pe-15{
  padding-left: 3.75rem;
}

[dir="ltr"] .ps-16{
  padding-left: 4rem;
}

[dir="rtl"] .ps-16{
  padding-right: 4rem;
}

[dir="ltr"] .pe-16{
  padding-right: 4rem;
}

[dir="rtl"] .pe-16{
  padding-left: 4rem;
}

[dir="ltr"] .ps-18{
  padding-left: 4.5rem;
}

[dir="rtl"] .ps-18{
  padding-right: 4.5rem;
}

[dir="ltr"] .pe-18{
  padding-right: 4.5rem;
}

[dir="rtl"] .pe-18{
  padding-left: 4.5rem;
}

[dir="ltr"] .ps-20{
  padding-left: 5rem;
}

[dir="rtl"] .ps-20{
  padding-right: 5rem;
}

[dir="ltr"] .pe-20{
  padding-right: 5rem;
}

[dir="rtl"] .pe-20{
  padding-left: 5rem;
}

[dir="ltr"] .ps-22{
  padding-left: 5.5rem;
}

[dir="rtl"] .ps-22{
  padding-right: 5.5rem;
}

[dir="ltr"] .pe-22{
  padding-right: 5.5rem;
}

[dir="rtl"] .pe-22{
  padding-left: 5.5rem;
}

[dir="ltr"] .ps-23{
  padding-left: 5.75rem;
}

[dir="rtl"] .ps-23{
  padding-right: 5.75rem;
}

[dir="ltr"] .pe-23{
  padding-right: 5.75rem;
}

[dir="rtl"] .pe-23{
  padding-left: 5.75rem;
}

[dir="ltr"] .ps-24{
  padding-left: 6rem;
}

[dir="rtl"] .ps-24{
  padding-right: 6rem;
}

[dir="ltr"] .pe-24{
  padding-right: 6rem;
}

[dir="rtl"] .pe-24{
  padding-left: 6rem;
}

[dir="ltr"] .ps-25{
  padding-left: 6.25rem;
}

[dir="rtl"] .ps-25{
  padding-right: 6.25rem;
}

[dir="ltr"] .pe-25{
  padding-right: 6.25rem;
}

[dir="rtl"] .pe-25{
  padding-left: 6.25rem;
}

[dir="ltr"] .ps-26{
  padding-left: 6.5rem;
}

[dir="rtl"] .ps-26{
  padding-right: 6.5rem;
}

[dir="ltr"] .pe-26{
  padding-right: 6.5rem;
}

[dir="rtl"] .pe-26{
  padding-left: 6.5rem;
}

[dir="ltr"] .ps-28{
  padding-left: 7rem;
}

[dir="rtl"] .ps-28{
  padding-right: 7rem;
}

[dir="ltr"] .pe-28{
  padding-right: 7rem;
}

[dir="rtl"] .pe-28{
  padding-left: 7rem;
}

[dir="ltr"] .ps-30{
  padding-left: 7.5rem;
}

[dir="rtl"] .ps-30{
  padding-right: 7.5rem;
}

[dir="ltr"] .pe-30{
  padding-right: 7.5rem;
}

[dir="rtl"] .pe-30{
  padding-left: 7.5rem;
}

[dir="ltr"] .ps-32{
  padding-left: 8rem;
}

[dir="rtl"] .ps-32{
  padding-right: 8rem;
}

[dir="ltr"] .pe-32{
  padding-right: 8rem;
}

[dir="rtl"] .pe-32{
  padding-left: 8rem;
}

[dir="ltr"] .ps-34{
  padding-left: 8.5rem;
}

[dir="rtl"] .ps-34{
  padding-right: 8.5rem;
}

[dir="ltr"] .pe-34{
  padding-right: 8.5rem;
}

[dir="rtl"] .pe-34{
  padding-left: 8.5rem;
}

[dir="ltr"] .ps-40{
  padding-left: 10rem;
}

[dir="rtl"] .ps-40{
  padding-right: 10rem;
}

[dir="ltr"] .pe-40{
  padding-right: 10rem;
}

[dir="rtl"] .pe-40{
  padding-left: 10rem;
}

[dir="ltr"] .ps-42{
  padding-left: 10.5rem;
}

[dir="rtl"] .ps-42{
  padding-right: 10.5rem;
}

[dir="ltr"] .pe-42{
  padding-right: 10.5rem;
}

[dir="rtl"] .pe-42{
  padding-left: 10.5rem;
}

[dir="ltr"] .ps-44{
  padding-left: 11rem;
}

[dir="rtl"] .ps-44{
  padding-right: 11rem;
}

[dir="ltr"] .pe-44{
  padding-right: 11rem;
}

[dir="rtl"] .pe-44{
  padding-left: 11rem;
}

[dir="ltr"] .ps-48{
  padding-left: 12rem;
}

[dir="rtl"] .ps-48{
  padding-right: 12rem;
}

[dir="ltr"] .pe-48{
  padding-right: 12rem;
}

[dir="rtl"] .pe-48{
  padding-left: 12rem;
}

[dir="ltr"] .ps-52{
  padding-left: 13rem;
}

[dir="rtl"] .ps-52{
  padding-right: 13rem;
}

[dir="ltr"] .pe-52{
  padding-right: 13rem;
}

[dir="rtl"] .pe-52{
  padding-left: 13rem;
}

[dir="ltr"] .ps-54{
  padding-left: 13.5rem;
}

[dir="rtl"] .ps-54{
  padding-right: 13.5rem;
}

[dir="ltr"] .pe-54{
  padding-right: 13.5rem;
}

[dir="rtl"] .pe-54{
  padding-left: 13.5rem;
}

[dir="ltr"] .ps-56{
  padding-left: 14rem;
}

[dir="rtl"] .ps-56{
  padding-right: 14rem;
}

[dir="ltr"] .pe-56{
  padding-right: 14rem;
}

[dir="rtl"] .pe-56{
  padding-left: 14rem;
}

[dir="ltr"] .ps-60{
  padding-left: 15rem;
}

[dir="rtl"] .ps-60{
  padding-right: 15rem;
}

[dir="ltr"] .pe-60{
  padding-right: 15rem;
}

[dir="rtl"] .pe-60{
  padding-left: 15rem;
}

[dir="ltr"] .ps-64{
  padding-left: 16rem;
}

[dir="rtl"] .ps-64{
  padding-right: 16rem;
}

[dir="ltr"] .pe-64{
  padding-right: 16rem;
}

[dir="rtl"] .pe-64{
  padding-left: 16rem;
}

[dir="ltr"] .ps-68{
  padding-left: 17rem;
}

[dir="rtl"] .ps-68{
  padding-right: 17rem;
}

[dir="ltr"] .pe-68{
  padding-right: 17rem;
}

[dir="rtl"] .pe-68{
  padding-left: 17rem;
}

[dir="ltr"] .ps-72{
  padding-left: 18rem;
}

[dir="rtl"] .ps-72{
  padding-right: 18rem;
}

[dir="ltr"] .pe-72{
  padding-right: 18rem;
}

[dir="rtl"] .pe-72{
  padding-left: 18rem;
}

[dir="ltr"] .ps-74{
  padding-left: 18.5rem;
}

[dir="rtl"] .ps-74{
  padding-right: 18.5rem;
}

[dir="ltr"] .pe-74{
  padding-right: 18.5rem;
}

[dir="rtl"] .pe-74{
  padding-left: 18.5rem;
}

[dir="ltr"] .ps-76{
  padding-left: 19rem;
}

[dir="rtl"] .ps-76{
  padding-right: 19rem;
}

[dir="ltr"] .pe-76{
  padding-right: 19rem;
}

[dir="rtl"] .pe-76{
  padding-left: 19rem;
}

[dir="ltr"] .ps-78{
  padding-left: 19.5rem;
}

[dir="rtl"] .ps-78{
  padding-right: 19.5rem;
}

[dir="ltr"] .pe-78{
  padding-right: 19.5rem;
}

[dir="rtl"] .pe-78{
  padding-left: 19.5rem;
}

[dir="ltr"] .ps-80{
  padding-left: 20rem;
}

[dir="rtl"] .ps-80{
  padding-right: 20rem;
}

[dir="ltr"] .pe-80{
  padding-right: 20rem;
}

[dir="rtl"] .pe-80{
  padding-left: 20rem;
}

[dir="ltr"] .ps-82{
  padding-left: 20.5rem;
}

[dir="rtl"] .ps-82{
  padding-right: 20.5rem;
}

[dir="ltr"] .pe-82{
  padding-right: 20.5rem;
}

[dir="rtl"] .pe-82{
  padding-left: 20.5rem;
}

[dir="ltr"] .ps-84{
  padding-left: 21rem;
}

[dir="rtl"] .ps-84{
  padding-right: 21rem;
}

[dir="ltr"] .pe-84{
  padding-right: 21rem;
}

[dir="rtl"] .pe-84{
  padding-left: 21rem;
}

[dir="ltr"] .ps-88{
  padding-left: 22rem;
}

[dir="rtl"] .ps-88{
  padding-right: 22rem;
}

[dir="ltr"] .pe-88{
  padding-right: 22rem;
}

[dir="rtl"] .pe-88{
  padding-left: 22rem;
}

[dir="ltr"] .ps-92{
  padding-left: 23rem;
}

[dir="rtl"] .ps-92{
  padding-right: 23rem;
}

[dir="ltr"] .pe-92{
  padding-right: 23rem;
}

[dir="rtl"] .pe-92{
  padding-left: 23rem;
}

[dir="ltr"] .ps-96{
  padding-left: 24rem;
}

[dir="rtl"] .ps-96{
  padding-right: 24rem;
}

[dir="ltr"] .pe-96{
  padding-right: 24rem;
}

[dir="rtl"] .pe-96{
  padding-left: 24rem;
}

[dir="ltr"] .ps-98{
  padding-left: 24.5rem;
}

[dir="rtl"] .ps-98{
  padding-right: 24.5rem;
}

[dir="ltr"] .pe-98{
  padding-right: 24.5rem;
}

[dir="rtl"] .pe-98{
  padding-left: 24.5rem;
}

[dir="ltr"] .ps-100{
  padding-left: 25rem;
}

[dir="rtl"] .ps-100{
  padding-right: 25rem;
}

[dir="ltr"] .pe-100{
  padding-right: 25rem;
}

[dir="rtl"] .pe-100{
  padding-left: 25rem;
}

[dir="ltr"] .ps-104{
  padding-left: 26rem;
}

[dir="rtl"] .ps-104{
  padding-right: 26rem;
}

[dir="ltr"] .pe-104{
  padding-right: 26rem;
}

[dir="rtl"] .pe-104{
  padding-left: 26rem;
}

[dir="ltr"] .ps-112{
  padding-left: 28rem;
}

[dir="rtl"] .ps-112{
  padding-right: 28rem;
}

[dir="ltr"] .pe-112{
  padding-right: 28rem;
}

[dir="rtl"] .pe-112{
  padding-left: 28rem;
}

[dir="ltr"] .ps-124{
  padding-left: 31rem;
}

[dir="rtl"] .ps-124{
  padding-right: 31rem;
}

[dir="ltr"] .pe-124{
  padding-right: 31rem;
}

[dir="rtl"] .pe-124{
  padding-left: 31rem;
}

[dir="ltr"] .ps-128{
  padding-left: 32rem;
}

[dir="rtl"] .ps-128{
  padding-right: 32rem;
}

[dir="ltr"] .pe-128{
  padding-right: 32rem;
}

[dir="rtl"] .pe-128{
  padding-left: 32rem;
}

[dir="ltr"] .ps-140{
  padding-left: 35rem;
}

[dir="rtl"] .ps-140{
  padding-right: 35rem;
}

[dir="ltr"] .pe-140{
  padding-right: 35rem;
}

[dir="rtl"] .pe-140{
  padding-left: 35rem;
}

[dir="ltr"] .ps-152{
  padding-left: 38rem;
}

[dir="rtl"] .ps-152{
  padding-right: 38rem;
}

[dir="ltr"] .pe-152{
  padding-right: 38rem;
}

[dir="rtl"] .pe-152{
  padding-left: 38rem;
}

[dir="ltr"] .ps-160{
  padding-left: 40rem;
}

[dir="rtl"] .ps-160{
  padding-right: 40rem;
}

[dir="ltr"] .pe-160{
  padding-right: 40rem;
}

[dir="rtl"] .pe-160{
  padding-left: 40rem;
}

[dir="ltr"] .ps-162{
  padding-left: 41rem;
}

[dir="rtl"] .ps-162{
  padding-right: 41rem;
}

[dir="ltr"] .pe-162{
  padding-right: 41rem;
}

[dir="rtl"] .pe-162{
  padding-left: 41rem;
}

[dir="ltr"] .ps-192{
  padding-left: 48rem;
}

[dir="rtl"] .ps-192{
  padding-right: 48rem;
}

[dir="ltr"] .pe-192{
  padding-right: 48rem;
}

[dir="rtl"] .pe-192{
  padding-left: 48rem;
}

[dir="ltr"] .ps-208{
  padding-left: 52rem;
}

[dir="rtl"] .ps-208{
  padding-right: 52rem;
}

[dir="ltr"] .pe-208{
  padding-right: 52rem;
}

[dir="rtl"] .pe-208{
  padding-left: 52rem;
}

[dir="ltr"] .ps-224{
  padding-left: 56rem;
}

[dir="rtl"] .ps-224{
  padding-right: 56rem;
}

[dir="ltr"] .pe-224{
  padding-right: 56rem;
}

[dir="rtl"] .pe-224{
  padding-left: 56rem;
}

[dir="ltr"] .ps-256{
  padding-left: 64rem;
}

[dir="rtl"] .ps-256{
  padding-right: 64rem;
}

[dir="ltr"] .pe-256{
  padding-right: 64rem;
}

[dir="rtl"] .pe-256{
  padding-left: 64rem;
}

[dir="ltr"] .ps-px{
  padding-left: 1px;
}

[dir="rtl"] .ps-px{
  padding-right: 1px;
}

[dir="ltr"] .pe-px{
  padding-right: 1px;
}

[dir="rtl"] .pe-px{
  padding-left: 1px;
}

[dir="ltr"] .odd\\:ps-0:nth-child(odd){
  padding-left: 0;
}

[dir="rtl"] .odd\\:ps-0:nth-child(odd){
  padding-right: 0;
}

[dir="ltr"] .odd\\:pe-0:nth-child(odd){
  padding-right: 0;
}

[dir="rtl"] .odd\\:pe-0:nth-child(odd){
  padding-left: 0;
}

[dir="ltr"] .odd\\:ps-1:nth-child(odd){
  padding-left: 0.25rem;
}

[dir="rtl"] .odd\\:ps-1:nth-child(odd){
  padding-right: 0.25rem;
}

[dir="ltr"] .odd\\:pe-1:nth-child(odd){
  padding-right: 0.25rem;
}

[dir="rtl"] .odd\\:pe-1:nth-child(odd){
  padding-left: 0.25rem;
}

[dir="ltr"] .odd\\:ps-2:nth-child(odd){
  padding-left: 0.5rem;
}

[dir="rtl"] .odd\\:ps-2:nth-child(odd){
  padding-right: 0.5rem;
}

[dir="ltr"] .odd\\:pe-2:nth-child(odd){
  padding-right: 0.5rem;
}

[dir="rtl"] .odd\\:pe-2:nth-child(odd){
  padding-left: 0.5rem;
}

[dir="ltr"] .odd\\:ps-3:nth-child(odd){
  padding-left: 0.75rem;
}

[dir="rtl"] .odd\\:ps-3:nth-child(odd){
  padding-right: 0.75rem;
}

[dir="ltr"] .odd\\:pe-3:nth-child(odd){
  padding-right: 0.75rem;
}

[dir="rtl"] .odd\\:pe-3:nth-child(odd){
  padding-left: 0.75rem;
}

[dir="ltr"] .odd\\:ps-4:nth-child(odd){
  padding-left: 1rem;
}

[dir="rtl"] .odd\\:ps-4:nth-child(odd){
  padding-right: 1rem;
}

[dir="ltr"] .odd\\:pe-4:nth-child(odd){
  padding-right: 1rem;
}

[dir="rtl"] .odd\\:pe-4:nth-child(odd){
  padding-left: 1rem;
}

[dir="ltr"] .odd\\:ps-5:nth-child(odd){
  padding-left: 1.25rem;
}

[dir="rtl"] .odd\\:ps-5:nth-child(odd){
  padding-right: 1.25rem;
}

[dir="ltr"] .odd\\:pe-5:nth-child(odd){
  padding-right: 1.25rem;
}

[dir="rtl"] .odd\\:pe-5:nth-child(odd){
  padding-left: 1.25rem;
}

[dir="ltr"] .odd\\:ps-6:nth-child(odd){
  padding-left: 1.5rem;
}

[dir="rtl"] .odd\\:ps-6:nth-child(odd){
  padding-right: 1.5rem;
}

[dir="ltr"] .odd\\:pe-6:nth-child(odd){
  padding-right: 1.5rem;
}

[dir="rtl"] .odd\\:pe-6:nth-child(odd){
  padding-left: 1.5rem;
}

[dir="ltr"] .odd\\:ps-7:nth-child(odd){
  padding-left: 1.75rem;
}

[dir="rtl"] .odd\\:ps-7:nth-child(odd){
  padding-right: 1.75rem;
}

[dir="ltr"] .odd\\:pe-7:nth-child(odd){
  padding-right: 1.75rem;
}

[dir="rtl"] .odd\\:pe-7:nth-child(odd){
  padding-left: 1.75rem;
}

[dir="ltr"] .odd\\:ps-8:nth-child(odd){
  padding-left: 2rem;
}

[dir="rtl"] .odd\\:ps-8:nth-child(odd){
  padding-right: 2rem;
}

[dir="ltr"] .odd\\:pe-8:nth-child(odd){
  padding-right: 2rem;
}

[dir="rtl"] .odd\\:pe-8:nth-child(odd){
  padding-left: 2rem;
}

[dir="ltr"] .odd\\:ps-9:nth-child(odd){
  padding-left: 2.25rem;
}

[dir="rtl"] .odd\\:ps-9:nth-child(odd){
  padding-right: 2.25rem;
}

[dir="ltr"] .odd\\:pe-9:nth-child(odd){
  padding-right: 2.25rem;
}

[dir="rtl"] .odd\\:pe-9:nth-child(odd){
  padding-left: 2.25rem;
}

[dir="ltr"] .odd\\:ps-10:nth-child(odd){
  padding-left: 2.5rem;
}

[dir="rtl"] .odd\\:ps-10:nth-child(odd){
  padding-right: 2.5rem;
}

[dir="ltr"] .odd\\:pe-10:nth-child(odd){
  padding-right: 2.5rem;
}

[dir="rtl"] .odd\\:pe-10:nth-child(odd){
  padding-left: 2.5rem;
}

[dir="ltr"] .odd\\:ps-11:nth-child(odd){
  padding-left: 2.75rem;
}

[dir="rtl"] .odd\\:ps-11:nth-child(odd){
  padding-right: 2.75rem;
}

[dir="ltr"] .odd\\:pe-11:nth-child(odd){
  padding-right: 2.75rem;
}

[dir="rtl"] .odd\\:pe-11:nth-child(odd){
  padding-left: 2.75rem;
}

[dir="ltr"] .odd\\:ps-12:nth-child(odd){
  padding-left: 3rem;
}

[dir="rtl"] .odd\\:ps-12:nth-child(odd){
  padding-right: 3rem;
}

[dir="ltr"] .odd\\:pe-12:nth-child(odd){
  padding-right: 3rem;
}

[dir="rtl"] .odd\\:pe-12:nth-child(odd){
  padding-left: 3rem;
}

[dir="ltr"] .odd\\:ps-14:nth-child(odd){
  padding-left: 3.5rem;
}

[dir="rtl"] .odd\\:ps-14:nth-child(odd){
  padding-right: 3.5rem;
}

[dir="ltr"] .odd\\:pe-14:nth-child(odd){
  padding-right: 3.5rem;
}

[dir="rtl"] .odd\\:pe-14:nth-child(odd){
  padding-left: 3.5rem;
}

[dir="ltr"] .odd\\:ps-15:nth-child(odd){
  padding-left: 3.75rem;
}

[dir="rtl"] .odd\\:ps-15:nth-child(odd){
  padding-right: 3.75rem;
}

[dir="ltr"] .odd\\:pe-15:nth-child(odd){
  padding-right: 3.75rem;
}

[dir="rtl"] .odd\\:pe-15:nth-child(odd){
  padding-left: 3.75rem;
}

[dir="ltr"] .odd\\:ps-16:nth-child(odd){
  padding-left: 4rem;
}

[dir="rtl"] .odd\\:ps-16:nth-child(odd){
  padding-right: 4rem;
}

[dir="ltr"] .odd\\:pe-16:nth-child(odd){
  padding-right: 4rem;
}

[dir="rtl"] .odd\\:pe-16:nth-child(odd){
  padding-left: 4rem;
}

[dir="ltr"] .odd\\:ps-18:nth-child(odd){
  padding-left: 4.5rem;
}

[dir="rtl"] .odd\\:ps-18:nth-child(odd){
  padding-right: 4.5rem;
}

[dir="ltr"] .odd\\:pe-18:nth-child(odd){
  padding-right: 4.5rem;
}

[dir="rtl"] .odd\\:pe-18:nth-child(odd){
  padding-left: 4.5rem;
}

[dir="ltr"] .odd\\:ps-20:nth-child(odd){
  padding-left: 5rem;
}

[dir="rtl"] .odd\\:ps-20:nth-child(odd){
  padding-right: 5rem;
}

[dir="ltr"] .odd\\:pe-20:nth-child(odd){
  padding-right: 5rem;
}

[dir="rtl"] .odd\\:pe-20:nth-child(odd){
  padding-left: 5rem;
}

[dir="ltr"] .odd\\:ps-22:nth-child(odd){
  padding-left: 5.5rem;
}

[dir="rtl"] .odd\\:ps-22:nth-child(odd){
  padding-right: 5.5rem;
}

[dir="ltr"] .odd\\:pe-22:nth-child(odd){
  padding-right: 5.5rem;
}

[dir="rtl"] .odd\\:pe-22:nth-child(odd){
  padding-left: 5.5rem;
}

[dir="ltr"] .odd\\:ps-23:nth-child(odd){
  padding-left: 5.75rem;
}

[dir="rtl"] .odd\\:ps-23:nth-child(odd){
  padding-right: 5.75rem;
}

[dir="ltr"] .odd\\:pe-23:nth-child(odd){
  padding-right: 5.75rem;
}

[dir="rtl"] .odd\\:pe-23:nth-child(odd){
  padding-left: 5.75rem;
}

[dir="ltr"] .odd\\:ps-24:nth-child(odd){
  padding-left: 6rem;
}

[dir="rtl"] .odd\\:ps-24:nth-child(odd){
  padding-right: 6rem;
}

[dir="ltr"] .odd\\:pe-24:nth-child(odd){
  padding-right: 6rem;
}

[dir="rtl"] .odd\\:pe-24:nth-child(odd){
  padding-left: 6rem;
}

[dir="ltr"] .odd\\:ps-25:nth-child(odd){
  padding-left: 6.25rem;
}

[dir="rtl"] .odd\\:ps-25:nth-child(odd){
  padding-right: 6.25rem;
}

[dir="ltr"] .odd\\:pe-25:nth-child(odd){
  padding-right: 6.25rem;
}

[dir="rtl"] .odd\\:pe-25:nth-child(odd){
  padding-left: 6.25rem;
}

[dir="ltr"] .odd\\:ps-26:nth-child(odd){
  padding-left: 6.5rem;
}

[dir="rtl"] .odd\\:ps-26:nth-child(odd){
  padding-right: 6.5rem;
}

[dir="ltr"] .odd\\:pe-26:nth-child(odd){
  padding-right: 6.5rem;
}

[dir="rtl"] .odd\\:pe-26:nth-child(odd){
  padding-left: 6.5rem;
}

[dir="ltr"] .odd\\:ps-28:nth-child(odd){
  padding-left: 7rem;
}

[dir="rtl"] .odd\\:ps-28:nth-child(odd){
  padding-right: 7rem;
}

[dir="ltr"] .odd\\:pe-28:nth-child(odd){
  padding-right: 7rem;
}

[dir="rtl"] .odd\\:pe-28:nth-child(odd){
  padding-left: 7rem;
}

[dir="ltr"] .odd\\:ps-30:nth-child(odd){
  padding-left: 7.5rem;
}

[dir="rtl"] .odd\\:ps-30:nth-child(odd){
  padding-right: 7.5rem;
}

[dir="ltr"] .odd\\:pe-30:nth-child(odd){
  padding-right: 7.5rem;
}

[dir="rtl"] .odd\\:pe-30:nth-child(odd){
  padding-left: 7.5rem;
}

[dir="ltr"] .odd\\:ps-32:nth-child(odd){
  padding-left: 8rem;
}

[dir="rtl"] .odd\\:ps-32:nth-child(odd){
  padding-right: 8rem;
}

[dir="ltr"] .odd\\:pe-32:nth-child(odd){
  padding-right: 8rem;
}

[dir="rtl"] .odd\\:pe-32:nth-child(odd){
  padding-left: 8rem;
}

[dir="ltr"] .odd\\:ps-34:nth-child(odd){
  padding-left: 8.5rem;
}

[dir="rtl"] .odd\\:ps-34:nth-child(odd){
  padding-right: 8.5rem;
}

[dir="ltr"] .odd\\:pe-34:nth-child(odd){
  padding-right: 8.5rem;
}

[dir="rtl"] .odd\\:pe-34:nth-child(odd){
  padding-left: 8.5rem;
}

[dir="ltr"] .odd\\:ps-40:nth-child(odd){
  padding-left: 10rem;
}

[dir="rtl"] .odd\\:ps-40:nth-child(odd){
  padding-right: 10rem;
}

[dir="ltr"] .odd\\:pe-40:nth-child(odd){
  padding-right: 10rem;
}

[dir="rtl"] .odd\\:pe-40:nth-child(odd){
  padding-left: 10rem;
}

[dir="ltr"] .odd\\:ps-42:nth-child(odd){
  padding-left: 10.5rem;
}

[dir="rtl"] .odd\\:ps-42:nth-child(odd){
  padding-right: 10.5rem;
}

[dir="ltr"] .odd\\:pe-42:nth-child(odd){
  padding-right: 10.5rem;
}

[dir="rtl"] .odd\\:pe-42:nth-child(odd){
  padding-left: 10.5rem;
}

[dir="ltr"] .odd\\:ps-44:nth-child(odd){
  padding-left: 11rem;
}

[dir="rtl"] .odd\\:ps-44:nth-child(odd){
  padding-right: 11rem;
}

[dir="ltr"] .odd\\:pe-44:nth-child(odd){
  padding-right: 11rem;
}

[dir="rtl"] .odd\\:pe-44:nth-child(odd){
  padding-left: 11rem;
}

[dir="ltr"] .odd\\:ps-48:nth-child(odd){
  padding-left: 12rem;
}

[dir="rtl"] .odd\\:ps-48:nth-child(odd){
  padding-right: 12rem;
}

[dir="ltr"] .odd\\:pe-48:nth-child(odd){
  padding-right: 12rem;
}

[dir="rtl"] .odd\\:pe-48:nth-child(odd){
  padding-left: 12rem;
}

[dir="ltr"] .odd\\:ps-52:nth-child(odd){
  padding-left: 13rem;
}

[dir="rtl"] .odd\\:ps-52:nth-child(odd){
  padding-right: 13rem;
}

[dir="ltr"] .odd\\:pe-52:nth-child(odd){
  padding-right: 13rem;
}

[dir="rtl"] .odd\\:pe-52:nth-child(odd){
  padding-left: 13rem;
}

[dir="ltr"] .odd\\:ps-54:nth-child(odd){
  padding-left: 13.5rem;
}

[dir="rtl"] .odd\\:ps-54:nth-child(odd){
  padding-right: 13.5rem;
}

[dir="ltr"] .odd\\:pe-54:nth-child(odd){
  padding-right: 13.5rem;
}

[dir="rtl"] .odd\\:pe-54:nth-child(odd){
  padding-left: 13.5rem;
}

[dir="ltr"] .odd\\:ps-56:nth-child(odd){
  padding-left: 14rem;
}

[dir="rtl"] .odd\\:ps-56:nth-child(odd){
  padding-right: 14rem;
}

[dir="ltr"] .odd\\:pe-56:nth-child(odd){
  padding-right: 14rem;
}

[dir="rtl"] .odd\\:pe-56:nth-child(odd){
  padding-left: 14rem;
}

[dir="ltr"] .odd\\:ps-60:nth-child(odd){
  padding-left: 15rem;
}

[dir="rtl"] .odd\\:ps-60:nth-child(odd){
  padding-right: 15rem;
}

[dir="ltr"] .odd\\:pe-60:nth-child(odd){
  padding-right: 15rem;
}

[dir="rtl"] .odd\\:pe-60:nth-child(odd){
  padding-left: 15rem;
}

[dir="ltr"] .odd\\:ps-64:nth-child(odd){
  padding-left: 16rem;
}

[dir="rtl"] .odd\\:ps-64:nth-child(odd){
  padding-right: 16rem;
}

[dir="ltr"] .odd\\:pe-64:nth-child(odd){
  padding-right: 16rem;
}

[dir="rtl"] .odd\\:pe-64:nth-child(odd){
  padding-left: 16rem;
}

[dir="ltr"] .odd\\:ps-68:nth-child(odd){
  padding-left: 17rem;
}

[dir="rtl"] .odd\\:ps-68:nth-child(odd){
  padding-right: 17rem;
}

[dir="ltr"] .odd\\:pe-68:nth-child(odd){
  padding-right: 17rem;
}

[dir="rtl"] .odd\\:pe-68:nth-child(odd){
  padding-left: 17rem;
}

[dir="ltr"] .odd\\:ps-72:nth-child(odd){
  padding-left: 18rem;
}

[dir="rtl"] .odd\\:ps-72:nth-child(odd){
  padding-right: 18rem;
}

[dir="ltr"] .odd\\:pe-72:nth-child(odd){
  padding-right: 18rem;
}

[dir="rtl"] .odd\\:pe-72:nth-child(odd){
  padding-left: 18rem;
}

[dir="ltr"] .odd\\:ps-74:nth-child(odd){
  padding-left: 18.5rem;
}

[dir="rtl"] .odd\\:ps-74:nth-child(odd){
  padding-right: 18.5rem;
}

[dir="ltr"] .odd\\:pe-74:nth-child(odd){
  padding-right: 18.5rem;
}

[dir="rtl"] .odd\\:pe-74:nth-child(odd){
  padding-left: 18.5rem;
}

[dir="ltr"] .odd\\:ps-76:nth-child(odd){
  padding-left: 19rem;
}

[dir="rtl"] .odd\\:ps-76:nth-child(odd){
  padding-right: 19rem;
}

[dir="ltr"] .odd\\:pe-76:nth-child(odd){
  padding-right: 19rem;
}

[dir="rtl"] .odd\\:pe-76:nth-child(odd){
  padding-left: 19rem;
}

[dir="ltr"] .odd\\:ps-78:nth-child(odd){
  padding-left: 19.5rem;
}

[dir="rtl"] .odd\\:ps-78:nth-child(odd){
  padding-right: 19.5rem;
}

[dir="ltr"] .odd\\:pe-78:nth-child(odd){
  padding-right: 19.5rem;
}

[dir="rtl"] .odd\\:pe-78:nth-child(odd){
  padding-left: 19.5rem;
}

[dir="ltr"] .odd\\:ps-80:nth-child(odd){
  padding-left: 20rem;
}

[dir="rtl"] .odd\\:ps-80:nth-child(odd){
  padding-right: 20rem;
}

[dir="ltr"] .odd\\:pe-80:nth-child(odd){
  padding-right: 20rem;
}

[dir="rtl"] .odd\\:pe-80:nth-child(odd){
  padding-left: 20rem;
}

[dir="ltr"] .odd\\:ps-82:nth-child(odd){
  padding-left: 20.5rem;
}

[dir="rtl"] .odd\\:ps-82:nth-child(odd){
  padding-right: 20.5rem;
}

[dir="ltr"] .odd\\:pe-82:nth-child(odd){
  padding-right: 20.5rem;
}

[dir="rtl"] .odd\\:pe-82:nth-child(odd){
  padding-left: 20.5rem;
}

[dir="ltr"] .odd\\:ps-84:nth-child(odd){
  padding-left: 21rem;
}

[dir="rtl"] .odd\\:ps-84:nth-child(odd){
  padding-right: 21rem;
}

[dir="ltr"] .odd\\:pe-84:nth-child(odd){
  padding-right: 21rem;
}

[dir="rtl"] .odd\\:pe-84:nth-child(odd){
  padding-left: 21rem;
}

[dir="ltr"] .odd\\:ps-88:nth-child(odd){
  padding-left: 22rem;
}

[dir="rtl"] .odd\\:ps-88:nth-child(odd){
  padding-right: 22rem;
}

[dir="ltr"] .odd\\:pe-88:nth-child(odd){
  padding-right: 22rem;
}

[dir="rtl"] .odd\\:pe-88:nth-child(odd){
  padding-left: 22rem;
}

[dir="ltr"] .odd\\:ps-92:nth-child(odd){
  padding-left: 23rem;
}

[dir="rtl"] .odd\\:ps-92:nth-child(odd){
  padding-right: 23rem;
}

[dir="ltr"] .odd\\:pe-92:nth-child(odd){
  padding-right: 23rem;
}

[dir="rtl"] .odd\\:pe-92:nth-child(odd){
  padding-left: 23rem;
}

[dir="ltr"] .odd\\:ps-96:nth-child(odd){
  padding-left: 24rem;
}

[dir="rtl"] .odd\\:ps-96:nth-child(odd){
  padding-right: 24rem;
}

[dir="ltr"] .odd\\:pe-96:nth-child(odd){
  padding-right: 24rem;
}

[dir="rtl"] .odd\\:pe-96:nth-child(odd){
  padding-left: 24rem;
}

[dir="ltr"] .odd\\:ps-98:nth-child(odd){
  padding-left: 24.5rem;
}

[dir="rtl"] .odd\\:ps-98:nth-child(odd){
  padding-right: 24.5rem;
}

[dir="ltr"] .odd\\:pe-98:nth-child(odd){
  padding-right: 24.5rem;
}

[dir="rtl"] .odd\\:pe-98:nth-child(odd){
  padding-left: 24.5rem;
}

[dir="ltr"] .odd\\:ps-100:nth-child(odd){
  padding-left: 25rem;
}

[dir="rtl"] .odd\\:ps-100:nth-child(odd){
  padding-right: 25rem;
}

[dir="ltr"] .odd\\:pe-100:nth-child(odd){
  padding-right: 25rem;
}

[dir="rtl"] .odd\\:pe-100:nth-child(odd){
  padding-left: 25rem;
}

[dir="ltr"] .odd\\:ps-104:nth-child(odd){
  padding-left: 26rem;
}

[dir="rtl"] .odd\\:ps-104:nth-child(odd){
  padding-right: 26rem;
}

[dir="ltr"] .odd\\:pe-104:nth-child(odd){
  padding-right: 26rem;
}

[dir="rtl"] .odd\\:pe-104:nth-child(odd){
  padding-left: 26rem;
}

[dir="ltr"] .odd\\:ps-112:nth-child(odd){
  padding-left: 28rem;
}

[dir="rtl"] .odd\\:ps-112:nth-child(odd){
  padding-right: 28rem;
}

[dir="ltr"] .odd\\:pe-112:nth-child(odd){
  padding-right: 28rem;
}

[dir="rtl"] .odd\\:pe-112:nth-child(odd){
  padding-left: 28rem;
}

[dir="ltr"] .odd\\:ps-124:nth-child(odd){
  padding-left: 31rem;
}

[dir="rtl"] .odd\\:ps-124:nth-child(odd){
  padding-right: 31rem;
}

[dir="ltr"] .odd\\:pe-124:nth-child(odd){
  padding-right: 31rem;
}

[dir="rtl"] .odd\\:pe-124:nth-child(odd){
  padding-left: 31rem;
}

[dir="ltr"] .odd\\:ps-128:nth-child(odd){
  padding-left: 32rem;
}

[dir="rtl"] .odd\\:ps-128:nth-child(odd){
  padding-right: 32rem;
}

[dir="ltr"] .odd\\:pe-128:nth-child(odd){
  padding-right: 32rem;
}

[dir="rtl"] .odd\\:pe-128:nth-child(odd){
  padding-left: 32rem;
}

[dir="ltr"] .odd\\:ps-140:nth-child(odd){
  padding-left: 35rem;
}

[dir="rtl"] .odd\\:ps-140:nth-child(odd){
  padding-right: 35rem;
}

[dir="ltr"] .odd\\:pe-140:nth-child(odd){
  padding-right: 35rem;
}

[dir="rtl"] .odd\\:pe-140:nth-child(odd){
  padding-left: 35rem;
}

[dir="ltr"] .odd\\:ps-152:nth-child(odd){
  padding-left: 38rem;
}

[dir="rtl"] .odd\\:ps-152:nth-child(odd){
  padding-right: 38rem;
}

[dir="ltr"] .odd\\:pe-152:nth-child(odd){
  padding-right: 38rem;
}

[dir="rtl"] .odd\\:pe-152:nth-child(odd){
  padding-left: 38rem;
}

[dir="ltr"] .odd\\:ps-160:nth-child(odd){
  padding-left: 40rem;
}

[dir="rtl"] .odd\\:ps-160:nth-child(odd){
  padding-right: 40rem;
}

[dir="ltr"] .odd\\:pe-160:nth-child(odd){
  padding-right: 40rem;
}

[dir="rtl"] .odd\\:pe-160:nth-child(odd){
  padding-left: 40rem;
}

[dir="ltr"] .odd\\:ps-162:nth-child(odd){
  padding-left: 41rem;
}

[dir="rtl"] .odd\\:ps-162:nth-child(odd){
  padding-right: 41rem;
}

[dir="ltr"] .odd\\:pe-162:nth-child(odd){
  padding-right: 41rem;
}

[dir="rtl"] .odd\\:pe-162:nth-child(odd){
  padding-left: 41rem;
}

[dir="ltr"] .odd\\:ps-192:nth-child(odd){
  padding-left: 48rem;
}

[dir="rtl"] .odd\\:ps-192:nth-child(odd){
  padding-right: 48rem;
}

[dir="ltr"] .odd\\:pe-192:nth-child(odd){
  padding-right: 48rem;
}

[dir="rtl"] .odd\\:pe-192:nth-child(odd){
  padding-left: 48rem;
}

[dir="ltr"] .odd\\:ps-208:nth-child(odd){
  padding-left: 52rem;
}

[dir="rtl"] .odd\\:ps-208:nth-child(odd){
  padding-right: 52rem;
}

[dir="ltr"] .odd\\:pe-208:nth-child(odd){
  padding-right: 52rem;
}

[dir="rtl"] .odd\\:pe-208:nth-child(odd){
  padding-left: 52rem;
}

[dir="ltr"] .odd\\:ps-224:nth-child(odd){
  padding-left: 56rem;
}

[dir="rtl"] .odd\\:ps-224:nth-child(odd){
  padding-right: 56rem;
}

[dir="ltr"] .odd\\:pe-224:nth-child(odd){
  padding-right: 56rem;
}

[dir="rtl"] .odd\\:pe-224:nth-child(odd){
  padding-left: 56rem;
}

[dir="ltr"] .odd\\:ps-256:nth-child(odd){
  padding-left: 64rem;
}

[dir="rtl"] .odd\\:ps-256:nth-child(odd){
  padding-right: 64rem;
}

[dir="ltr"] .odd\\:pe-256:nth-child(odd){
  padding-right: 64rem;
}

[dir="rtl"] .odd\\:pe-256:nth-child(odd){
  padding-left: 64rem;
}

[dir="ltr"] .odd\\:ps-px:nth-child(odd){
  padding-left: 1px;
}

[dir="rtl"] .odd\\:ps-px:nth-child(odd){
  padding-right: 1px;
}

[dir="ltr"] .odd\\:pe-px:nth-child(odd){
  padding-right: 1px;
}

[dir="rtl"] .odd\\:pe-px:nth-child(odd){
  padding-left: 1px;
}

[dir="ltr"] .even\\:ps-0:nth-child(even){
  padding-left: 0;
}

[dir="rtl"] .even\\:ps-0:nth-child(even){
  padding-right: 0;
}

[dir="ltr"] .even\\:pe-0:nth-child(even){
  padding-right: 0;
}

[dir="rtl"] .even\\:pe-0:nth-child(even){
  padding-left: 0;
}

[dir="ltr"] .even\\:ps-1:nth-child(even){
  padding-left: 0.25rem;
}

[dir="rtl"] .even\\:ps-1:nth-child(even){
  padding-right: 0.25rem;
}

[dir="ltr"] .even\\:pe-1:nth-child(even){
  padding-right: 0.25rem;
}

[dir="rtl"] .even\\:pe-1:nth-child(even){
  padding-left: 0.25rem;
}

[dir="ltr"] .even\\:ps-2:nth-child(even){
  padding-left: 0.5rem;
}

[dir="rtl"] .even\\:ps-2:nth-child(even){
  padding-right: 0.5rem;
}

[dir="ltr"] .even\\:pe-2:nth-child(even){
  padding-right: 0.5rem;
}

[dir="rtl"] .even\\:pe-2:nth-child(even){
  padding-left: 0.5rem;
}

[dir="ltr"] .even\\:ps-3:nth-child(even){
  padding-left: 0.75rem;
}

[dir="rtl"] .even\\:ps-3:nth-child(even){
  padding-right: 0.75rem;
}

[dir="ltr"] .even\\:pe-3:nth-child(even){
  padding-right: 0.75rem;
}

[dir="rtl"] .even\\:pe-3:nth-child(even){
  padding-left: 0.75rem;
}

[dir="ltr"] .even\\:ps-4:nth-child(even){
  padding-left: 1rem;
}

[dir="rtl"] .even\\:ps-4:nth-child(even){
  padding-right: 1rem;
}

[dir="ltr"] .even\\:pe-4:nth-child(even){
  padding-right: 1rem;
}

[dir="rtl"] .even\\:pe-4:nth-child(even){
  padding-left: 1rem;
}

[dir="ltr"] .even\\:ps-5:nth-child(even){
  padding-left: 1.25rem;
}

[dir="rtl"] .even\\:ps-5:nth-child(even){
  padding-right: 1.25rem;
}

[dir="ltr"] .even\\:pe-5:nth-child(even){
  padding-right: 1.25rem;
}

[dir="rtl"] .even\\:pe-5:nth-child(even){
  padding-left: 1.25rem;
}

[dir="ltr"] .even\\:ps-6:nth-child(even){
  padding-left: 1.5rem;
}

[dir="rtl"] .even\\:ps-6:nth-child(even){
  padding-right: 1.5rem;
}

[dir="ltr"] .even\\:pe-6:nth-child(even){
  padding-right: 1.5rem;
}

[dir="rtl"] .even\\:pe-6:nth-child(even){
  padding-left: 1.5rem;
}

[dir="ltr"] .even\\:ps-7:nth-child(even){
  padding-left: 1.75rem;
}

[dir="rtl"] .even\\:ps-7:nth-child(even){
  padding-right: 1.75rem;
}

[dir="ltr"] .even\\:pe-7:nth-child(even){
  padding-right: 1.75rem;
}

[dir="rtl"] .even\\:pe-7:nth-child(even){
  padding-left: 1.75rem;
}

[dir="ltr"] .even\\:ps-8:nth-child(even){
  padding-left: 2rem;
}

[dir="rtl"] .even\\:ps-8:nth-child(even){
  padding-right: 2rem;
}

[dir="ltr"] .even\\:pe-8:nth-child(even){
  padding-right: 2rem;
}

[dir="rtl"] .even\\:pe-8:nth-child(even){
  padding-left: 2rem;
}

[dir="ltr"] .even\\:ps-9:nth-child(even){
  padding-left: 2.25rem;
}

[dir="rtl"] .even\\:ps-9:nth-child(even){
  padding-right: 2.25rem;
}

[dir="ltr"] .even\\:pe-9:nth-child(even){
  padding-right: 2.25rem;
}

[dir="rtl"] .even\\:pe-9:nth-child(even){
  padding-left: 2.25rem;
}

[dir="ltr"] .even\\:ps-10:nth-child(even){
  padding-left: 2.5rem;
}

[dir="rtl"] .even\\:ps-10:nth-child(even){
  padding-right: 2.5rem;
}

[dir="ltr"] .even\\:pe-10:nth-child(even){
  padding-right: 2.5rem;
}

[dir="rtl"] .even\\:pe-10:nth-child(even){
  padding-left: 2.5rem;
}

[dir="ltr"] .even\\:ps-11:nth-child(even){
  padding-left: 2.75rem;
}

[dir="rtl"] .even\\:ps-11:nth-child(even){
  padding-right: 2.75rem;
}

[dir="ltr"] .even\\:pe-11:nth-child(even){
  padding-right: 2.75rem;
}

[dir="rtl"] .even\\:pe-11:nth-child(even){
  padding-left: 2.75rem;
}

[dir="ltr"] .even\\:ps-12:nth-child(even){
  padding-left: 3rem;
}

[dir="rtl"] .even\\:ps-12:nth-child(even){
  padding-right: 3rem;
}

[dir="ltr"] .even\\:pe-12:nth-child(even){
  padding-right: 3rem;
}

[dir="rtl"] .even\\:pe-12:nth-child(even){
  padding-left: 3rem;
}

[dir="ltr"] .even\\:ps-14:nth-child(even){
  padding-left: 3.5rem;
}

[dir="rtl"] .even\\:ps-14:nth-child(even){
  padding-right: 3.5rem;
}

[dir="ltr"] .even\\:pe-14:nth-child(even){
  padding-right: 3.5rem;
}

[dir="rtl"] .even\\:pe-14:nth-child(even){
  padding-left: 3.5rem;
}

[dir="ltr"] .even\\:ps-15:nth-child(even){
  padding-left: 3.75rem;
}

[dir="rtl"] .even\\:ps-15:nth-child(even){
  padding-right: 3.75rem;
}

[dir="ltr"] .even\\:pe-15:nth-child(even){
  padding-right: 3.75rem;
}

[dir="rtl"] .even\\:pe-15:nth-child(even){
  padding-left: 3.75rem;
}

[dir="ltr"] .even\\:ps-16:nth-child(even){
  padding-left: 4rem;
}

[dir="rtl"] .even\\:ps-16:nth-child(even){
  padding-right: 4rem;
}

[dir="ltr"] .even\\:pe-16:nth-child(even){
  padding-right: 4rem;
}

[dir="rtl"] .even\\:pe-16:nth-child(even){
  padding-left: 4rem;
}

[dir="ltr"] .even\\:ps-18:nth-child(even){
  padding-left: 4.5rem;
}

[dir="rtl"] .even\\:ps-18:nth-child(even){
  padding-right: 4.5rem;
}

[dir="ltr"] .even\\:pe-18:nth-child(even){
  padding-right: 4.5rem;
}

[dir="rtl"] .even\\:pe-18:nth-child(even){
  padding-left: 4.5rem;
}

[dir="ltr"] .even\\:ps-20:nth-child(even){
  padding-left: 5rem;
}

[dir="rtl"] .even\\:ps-20:nth-child(even){
  padding-right: 5rem;
}

[dir="ltr"] .even\\:pe-20:nth-child(even){
  padding-right: 5rem;
}

[dir="rtl"] .even\\:pe-20:nth-child(even){
  padding-left: 5rem;
}

[dir="ltr"] .even\\:ps-22:nth-child(even){
  padding-left: 5.5rem;
}

[dir="rtl"] .even\\:ps-22:nth-child(even){
  padding-right: 5.5rem;
}

[dir="ltr"] .even\\:pe-22:nth-child(even){
  padding-right: 5.5rem;
}

[dir="rtl"] .even\\:pe-22:nth-child(even){
  padding-left: 5.5rem;
}

[dir="ltr"] .even\\:ps-23:nth-child(even){
  padding-left: 5.75rem;
}

[dir="rtl"] .even\\:ps-23:nth-child(even){
  padding-right: 5.75rem;
}

[dir="ltr"] .even\\:pe-23:nth-child(even){
  padding-right: 5.75rem;
}

[dir="rtl"] .even\\:pe-23:nth-child(even){
  padding-left: 5.75rem;
}

[dir="ltr"] .even\\:ps-24:nth-child(even){
  padding-left: 6rem;
}

[dir="rtl"] .even\\:ps-24:nth-child(even){
  padding-right: 6rem;
}

[dir="ltr"] .even\\:pe-24:nth-child(even){
  padding-right: 6rem;
}

[dir="rtl"] .even\\:pe-24:nth-child(even){
  padding-left: 6rem;
}

[dir="ltr"] .even\\:ps-25:nth-child(even){
  padding-left: 6.25rem;
}

[dir="rtl"] .even\\:ps-25:nth-child(even){
  padding-right: 6.25rem;
}

[dir="ltr"] .even\\:pe-25:nth-child(even){
  padding-right: 6.25rem;
}

[dir="rtl"] .even\\:pe-25:nth-child(even){
  padding-left: 6.25rem;
}

[dir="ltr"] .even\\:ps-26:nth-child(even){
  padding-left: 6.5rem;
}

[dir="rtl"] .even\\:ps-26:nth-child(even){
  padding-right: 6.5rem;
}

[dir="ltr"] .even\\:pe-26:nth-child(even){
  padding-right: 6.5rem;
}

[dir="rtl"] .even\\:pe-26:nth-child(even){
  padding-left: 6.5rem;
}

[dir="ltr"] .even\\:ps-28:nth-child(even){
  padding-left: 7rem;
}

[dir="rtl"] .even\\:ps-28:nth-child(even){
  padding-right: 7rem;
}

[dir="ltr"] .even\\:pe-28:nth-child(even){
  padding-right: 7rem;
}

[dir="rtl"] .even\\:pe-28:nth-child(even){
  padding-left: 7rem;
}

[dir="ltr"] .even\\:ps-30:nth-child(even){
  padding-left: 7.5rem;
}

[dir="rtl"] .even\\:ps-30:nth-child(even){
  padding-right: 7.5rem;
}

[dir="ltr"] .even\\:pe-30:nth-child(even){
  padding-right: 7.5rem;
}

[dir="rtl"] .even\\:pe-30:nth-child(even){
  padding-left: 7.5rem;
}

[dir="ltr"] .even\\:ps-32:nth-child(even){
  padding-left: 8rem;
}

[dir="rtl"] .even\\:ps-32:nth-child(even){
  padding-right: 8rem;
}

[dir="ltr"] .even\\:pe-32:nth-child(even){
  padding-right: 8rem;
}

[dir="rtl"] .even\\:pe-32:nth-child(even){
  padding-left: 8rem;
}

[dir="ltr"] .even\\:ps-34:nth-child(even){
  padding-left: 8.5rem;
}

[dir="rtl"] .even\\:ps-34:nth-child(even){
  padding-right: 8.5rem;
}

[dir="ltr"] .even\\:pe-34:nth-child(even){
  padding-right: 8.5rem;
}

[dir="rtl"] .even\\:pe-34:nth-child(even){
  padding-left: 8.5rem;
}

[dir="ltr"] .even\\:ps-40:nth-child(even){
  padding-left: 10rem;
}

[dir="rtl"] .even\\:ps-40:nth-child(even){
  padding-right: 10rem;
}

[dir="ltr"] .even\\:pe-40:nth-child(even){
  padding-right: 10rem;
}

[dir="rtl"] .even\\:pe-40:nth-child(even){
  padding-left: 10rem;
}

[dir="ltr"] .even\\:ps-42:nth-child(even){
  padding-left: 10.5rem;
}

[dir="rtl"] .even\\:ps-42:nth-child(even){
  padding-right: 10.5rem;
}

[dir="ltr"] .even\\:pe-42:nth-child(even){
  padding-right: 10.5rem;
}

[dir="rtl"] .even\\:pe-42:nth-child(even){
  padding-left: 10.5rem;
}

[dir="ltr"] .even\\:ps-44:nth-child(even){
  padding-left: 11rem;
}

[dir="rtl"] .even\\:ps-44:nth-child(even){
  padding-right: 11rem;
}

[dir="ltr"] .even\\:pe-44:nth-child(even){
  padding-right: 11rem;
}

[dir="rtl"] .even\\:pe-44:nth-child(even){
  padding-left: 11rem;
}

[dir="ltr"] .even\\:ps-48:nth-child(even){
  padding-left: 12rem;
}

[dir="rtl"] .even\\:ps-48:nth-child(even){
  padding-right: 12rem;
}

[dir="ltr"] .even\\:pe-48:nth-child(even){
  padding-right: 12rem;
}

[dir="rtl"] .even\\:pe-48:nth-child(even){
  padding-left: 12rem;
}

[dir="ltr"] .even\\:ps-52:nth-child(even){
  padding-left: 13rem;
}

[dir="rtl"] .even\\:ps-52:nth-child(even){
  padding-right: 13rem;
}

[dir="ltr"] .even\\:pe-52:nth-child(even){
  padding-right: 13rem;
}

[dir="rtl"] .even\\:pe-52:nth-child(even){
  padding-left: 13rem;
}

[dir="ltr"] .even\\:ps-54:nth-child(even){
  padding-left: 13.5rem;
}

[dir="rtl"] .even\\:ps-54:nth-child(even){
  padding-right: 13.5rem;
}

[dir="ltr"] .even\\:pe-54:nth-child(even){
  padding-right: 13.5rem;
}

[dir="rtl"] .even\\:pe-54:nth-child(even){
  padding-left: 13.5rem;
}

[dir="ltr"] .even\\:ps-56:nth-child(even){
  padding-left: 14rem;
}

[dir="rtl"] .even\\:ps-56:nth-child(even){
  padding-right: 14rem;
}

[dir="ltr"] .even\\:pe-56:nth-child(even){
  padding-right: 14rem;
}

[dir="rtl"] .even\\:pe-56:nth-child(even){
  padding-left: 14rem;
}

[dir="ltr"] .even\\:ps-60:nth-child(even){
  padding-left: 15rem;
}

[dir="rtl"] .even\\:ps-60:nth-child(even){
  padding-right: 15rem;
}

[dir="ltr"] .even\\:pe-60:nth-child(even){
  padding-right: 15rem;
}

[dir="rtl"] .even\\:pe-60:nth-child(even){
  padding-left: 15rem;
}

[dir="ltr"] .even\\:ps-64:nth-child(even){
  padding-left: 16rem;
}

[dir="rtl"] .even\\:ps-64:nth-child(even){
  padding-right: 16rem;
}

[dir="ltr"] .even\\:pe-64:nth-child(even){
  padding-right: 16rem;
}

[dir="rtl"] .even\\:pe-64:nth-child(even){
  padding-left: 16rem;
}

[dir="ltr"] .even\\:ps-68:nth-child(even){
  padding-left: 17rem;
}

[dir="rtl"] .even\\:ps-68:nth-child(even){
  padding-right: 17rem;
}

[dir="ltr"] .even\\:pe-68:nth-child(even){
  padding-right: 17rem;
}

[dir="rtl"] .even\\:pe-68:nth-child(even){
  padding-left: 17rem;
}

[dir="ltr"] .even\\:ps-72:nth-child(even){
  padding-left: 18rem;
}

[dir="rtl"] .even\\:ps-72:nth-child(even){
  padding-right: 18rem;
}

[dir="ltr"] .even\\:pe-72:nth-child(even){
  padding-right: 18rem;
}

[dir="rtl"] .even\\:pe-72:nth-child(even){
  padding-left: 18rem;
}

[dir="ltr"] .even\\:ps-74:nth-child(even){
  padding-left: 18.5rem;
}

[dir="rtl"] .even\\:ps-74:nth-child(even){
  padding-right: 18.5rem;
}

[dir="ltr"] .even\\:pe-74:nth-child(even){
  padding-right: 18.5rem;
}

[dir="rtl"] .even\\:pe-74:nth-child(even){
  padding-left: 18.5rem;
}

[dir="ltr"] .even\\:ps-76:nth-child(even){
  padding-left: 19rem;
}

[dir="rtl"] .even\\:ps-76:nth-child(even){
  padding-right: 19rem;
}

[dir="ltr"] .even\\:pe-76:nth-child(even){
  padding-right: 19rem;
}

[dir="rtl"] .even\\:pe-76:nth-child(even){
  padding-left: 19rem;
}

[dir="ltr"] .even\\:ps-78:nth-child(even){
  padding-left: 19.5rem;
}

[dir="rtl"] .even\\:ps-78:nth-child(even){
  padding-right: 19.5rem;
}

[dir="ltr"] .even\\:pe-78:nth-child(even){
  padding-right: 19.5rem;
}

[dir="rtl"] .even\\:pe-78:nth-child(even){
  padding-left: 19.5rem;
}

[dir="ltr"] .even\\:ps-80:nth-child(even){
  padding-left: 20rem;
}

[dir="rtl"] .even\\:ps-80:nth-child(even){
  padding-right: 20rem;
}

[dir="ltr"] .even\\:pe-80:nth-child(even){
  padding-right: 20rem;
}

[dir="rtl"] .even\\:pe-80:nth-child(even){
  padding-left: 20rem;
}

[dir="ltr"] .even\\:ps-82:nth-child(even){
  padding-left: 20.5rem;
}

[dir="rtl"] .even\\:ps-82:nth-child(even){
  padding-right: 20.5rem;
}

[dir="ltr"] .even\\:pe-82:nth-child(even){
  padding-right: 20.5rem;
}

[dir="rtl"] .even\\:pe-82:nth-child(even){
  padding-left: 20.5rem;
}

[dir="ltr"] .even\\:ps-84:nth-child(even){
  padding-left: 21rem;
}

[dir="rtl"] .even\\:ps-84:nth-child(even){
  padding-right: 21rem;
}

[dir="ltr"] .even\\:pe-84:nth-child(even){
  padding-right: 21rem;
}

[dir="rtl"] .even\\:pe-84:nth-child(even){
  padding-left: 21rem;
}

[dir="ltr"] .even\\:ps-88:nth-child(even){
  padding-left: 22rem;
}

[dir="rtl"] .even\\:ps-88:nth-child(even){
  padding-right: 22rem;
}

[dir="ltr"] .even\\:pe-88:nth-child(even){
  padding-right: 22rem;
}

[dir="rtl"] .even\\:pe-88:nth-child(even){
  padding-left: 22rem;
}

[dir="ltr"] .even\\:ps-92:nth-child(even){
  padding-left: 23rem;
}

[dir="rtl"] .even\\:ps-92:nth-child(even){
  padding-right: 23rem;
}

[dir="ltr"] .even\\:pe-92:nth-child(even){
  padding-right: 23rem;
}

[dir="rtl"] .even\\:pe-92:nth-child(even){
  padding-left: 23rem;
}

[dir="ltr"] .even\\:ps-96:nth-child(even){
  padding-left: 24rem;
}

[dir="rtl"] .even\\:ps-96:nth-child(even){
  padding-right: 24rem;
}

[dir="ltr"] .even\\:pe-96:nth-child(even){
  padding-right: 24rem;
}

[dir="rtl"] .even\\:pe-96:nth-child(even){
  padding-left: 24rem;
}

[dir="ltr"] .even\\:ps-98:nth-child(even){
  padding-left: 24.5rem;
}

[dir="rtl"] .even\\:ps-98:nth-child(even){
  padding-right: 24.5rem;
}

[dir="ltr"] .even\\:pe-98:nth-child(even){
  padding-right: 24.5rem;
}

[dir="rtl"] .even\\:pe-98:nth-child(even){
  padding-left: 24.5rem;
}

[dir="ltr"] .even\\:ps-100:nth-child(even){
  padding-left: 25rem;
}

[dir="rtl"] .even\\:ps-100:nth-child(even){
  padding-right: 25rem;
}

[dir="ltr"] .even\\:pe-100:nth-child(even){
  padding-right: 25rem;
}

[dir="rtl"] .even\\:pe-100:nth-child(even){
  padding-left: 25rem;
}

[dir="ltr"] .even\\:ps-104:nth-child(even){
  padding-left: 26rem;
}

[dir="rtl"] .even\\:ps-104:nth-child(even){
  padding-right: 26rem;
}

[dir="ltr"] .even\\:pe-104:nth-child(even){
  padding-right: 26rem;
}

[dir="rtl"] .even\\:pe-104:nth-child(even){
  padding-left: 26rem;
}

[dir="ltr"] .even\\:ps-112:nth-child(even){
  padding-left: 28rem;
}

[dir="rtl"] .even\\:ps-112:nth-child(even){
  padding-right: 28rem;
}

[dir="ltr"] .even\\:pe-112:nth-child(even){
  padding-right: 28rem;
}

[dir="rtl"] .even\\:pe-112:nth-child(even){
  padding-left: 28rem;
}

[dir="ltr"] .even\\:ps-124:nth-child(even){
  padding-left: 31rem;
}

[dir="rtl"] .even\\:ps-124:nth-child(even){
  padding-right: 31rem;
}

[dir="ltr"] .even\\:pe-124:nth-child(even){
  padding-right: 31rem;
}

[dir="rtl"] .even\\:pe-124:nth-child(even){
  padding-left: 31rem;
}

[dir="ltr"] .even\\:ps-128:nth-child(even){
  padding-left: 32rem;
}

[dir="rtl"] .even\\:ps-128:nth-child(even){
  padding-right: 32rem;
}

[dir="ltr"] .even\\:pe-128:nth-child(even){
  padding-right: 32rem;
}

[dir="rtl"] .even\\:pe-128:nth-child(even){
  padding-left: 32rem;
}

[dir="ltr"] .even\\:ps-140:nth-child(even){
  padding-left: 35rem;
}

[dir="rtl"] .even\\:ps-140:nth-child(even){
  padding-right: 35rem;
}

[dir="ltr"] .even\\:pe-140:nth-child(even){
  padding-right: 35rem;
}

[dir="rtl"] .even\\:pe-140:nth-child(even){
  padding-left: 35rem;
}

[dir="ltr"] .even\\:ps-152:nth-child(even){
  padding-left: 38rem;
}

[dir="rtl"] .even\\:ps-152:nth-child(even){
  padding-right: 38rem;
}

[dir="ltr"] .even\\:pe-152:nth-child(even){
  padding-right: 38rem;
}

[dir="rtl"] .even\\:pe-152:nth-child(even){
  padding-left: 38rem;
}

[dir="ltr"] .even\\:ps-160:nth-child(even){
  padding-left: 40rem;
}

[dir="rtl"] .even\\:ps-160:nth-child(even){
  padding-right: 40rem;
}

[dir="ltr"] .even\\:pe-160:nth-child(even){
  padding-right: 40rem;
}

[dir="rtl"] .even\\:pe-160:nth-child(even){
  padding-left: 40rem;
}

[dir="ltr"] .even\\:ps-162:nth-child(even){
  padding-left: 41rem;
}

[dir="rtl"] .even\\:ps-162:nth-child(even){
  padding-right: 41rem;
}

[dir="ltr"] .even\\:pe-162:nth-child(even){
  padding-right: 41rem;
}

[dir="rtl"] .even\\:pe-162:nth-child(even){
  padding-left: 41rem;
}

[dir="ltr"] .even\\:ps-192:nth-child(even){
  padding-left: 48rem;
}

[dir="rtl"] .even\\:ps-192:nth-child(even){
  padding-right: 48rem;
}

[dir="ltr"] .even\\:pe-192:nth-child(even){
  padding-right: 48rem;
}

[dir="rtl"] .even\\:pe-192:nth-child(even){
  padding-left: 48rem;
}

[dir="ltr"] .even\\:ps-208:nth-child(even){
  padding-left: 52rem;
}

[dir="rtl"] .even\\:ps-208:nth-child(even){
  padding-right: 52rem;
}

[dir="ltr"] .even\\:pe-208:nth-child(even){
  padding-right: 52rem;
}

[dir="rtl"] .even\\:pe-208:nth-child(even){
  padding-left: 52rem;
}

[dir="ltr"] .even\\:ps-224:nth-child(even){
  padding-left: 56rem;
}

[dir="rtl"] .even\\:ps-224:nth-child(even){
  padding-right: 56rem;
}

[dir="ltr"] .even\\:pe-224:nth-child(even){
  padding-right: 56rem;
}

[dir="rtl"] .even\\:pe-224:nth-child(even){
  padding-left: 56rem;
}

[dir="ltr"] .even\\:ps-256:nth-child(even){
  padding-left: 64rem;
}

[dir="rtl"] .even\\:ps-256:nth-child(even){
  padding-right: 64rem;
}

[dir="ltr"] .even\\:pe-256:nth-child(even){
  padding-right: 64rem;
}

[dir="rtl"] .even\\:pe-256:nth-child(even){
  padding-left: 64rem;
}

[dir="ltr"] .even\\:ps-px:nth-child(even){
  padding-left: 1px;
}

[dir="rtl"] .even\\:ps-px:nth-child(even){
  padding-right: 1px;
}

[dir="ltr"] .even\\:pe-px:nth-child(even){
  padding-right: 1px;
}

[dir="rtl"] .even\\:pe-px:nth-child(even){
  padding-left: 1px;
}

[dir="ltr"] .ms-0{
  margin-left: 0;
}

[dir="rtl"] .ms-0{
  margin-right: 0;
}

[dir="ltr"] .me-0{
  margin-right: 0;
}

[dir="rtl"] .me-0{
  margin-left: 0;
}

[dir="ltr"] .ms-1{
  margin-left: 0.25rem;
}

[dir="rtl"] .ms-1{
  margin-right: 0.25rem;
}

[dir="ltr"] .me-1{
  margin-right: 0.25rem;
}

[dir="rtl"] .me-1{
  margin-left: 0.25rem;
}

[dir="ltr"] .ms-2{
  margin-left: 0.5rem;
}

[dir="rtl"] .ms-2{
  margin-right: 0.5rem;
}

[dir="ltr"] .me-2{
  margin-right: 0.5rem;
}

[dir="rtl"] .me-2{
  margin-left: 0.5rem;
}

[dir="ltr"] .ms-3{
  margin-left: 0.75rem;
}

[dir="rtl"] .ms-3{
  margin-right: 0.75rem;
}

[dir="ltr"] .me-3{
  margin-right: 0.75rem;
}

[dir="rtl"] .me-3{
  margin-left: 0.75rem;
}

[dir="ltr"] .ms-4{
  margin-left: 1rem;
}

[dir="rtl"] .ms-4{
  margin-right: 1rem;
}

[dir="ltr"] .me-4{
  margin-right: 1rem;
}

[dir="rtl"] .me-4{
  margin-left: 1rem;
}

[dir="ltr"] .ms-5{
  margin-left: 1.25rem;
}

[dir="rtl"] .ms-5{
  margin-right: 1.25rem;
}

[dir="ltr"] .me-5{
  margin-right: 1.25rem;
}

[dir="rtl"] .me-5{
  margin-left: 1.25rem;
}

[dir="ltr"] .ms-6{
  margin-left: 1.5rem;
}

[dir="rtl"] .ms-6{
  margin-right: 1.5rem;
}

[dir="ltr"] .me-6{
  margin-right: 1.5rem;
}

[dir="rtl"] .me-6{
  margin-left: 1.5rem;
}

[dir="ltr"] .ms-7{
  margin-left: 1.75rem;
}

[dir="rtl"] .ms-7{
  margin-right: 1.75rem;
}

[dir="ltr"] .me-7{
  margin-right: 1.75rem;
}

[dir="rtl"] .me-7{
  margin-left: 1.75rem;
}

[dir="ltr"] .ms-8{
  margin-left: 2rem;
}

[dir="rtl"] .ms-8{
  margin-right: 2rem;
}

[dir="ltr"] .me-8{
  margin-right: 2rem;
}

[dir="rtl"] .me-8{
  margin-left: 2rem;
}

[dir="ltr"] .ms-9{
  margin-left: 2.25rem;
}

[dir="rtl"] .ms-9{
  margin-right: 2.25rem;
}

[dir="ltr"] .me-9{
  margin-right: 2.25rem;
}

[dir="rtl"] .me-9{
  margin-left: 2.25rem;
}

[dir="ltr"] .ms-10{
  margin-left: 2.5rem;
}

[dir="rtl"] .ms-10{
  margin-right: 2.5rem;
}

[dir="ltr"] .me-10{
  margin-right: 2.5rem;
}

[dir="rtl"] .me-10{
  margin-left: 2.5rem;
}

[dir="ltr"] .ms-11{
  margin-left: 2.75rem;
}

[dir="rtl"] .ms-11{
  margin-right: 2.75rem;
}

[dir="ltr"] .me-11{
  margin-right: 2.75rem;
}

[dir="rtl"] .me-11{
  margin-left: 2.75rem;
}

[dir="ltr"] .ms-12{
  margin-left: 3rem;
}

[dir="rtl"] .ms-12{
  margin-right: 3rem;
}

[dir="ltr"] .me-12{
  margin-right: 3rem;
}

[dir="rtl"] .me-12{
  margin-left: 3rem;
}

[dir="ltr"] .ms-14{
  margin-left: 3.5rem;
}

[dir="rtl"] .ms-14{
  margin-right: 3.5rem;
}

[dir="ltr"] .me-14{
  margin-right: 3.5rem;
}

[dir="rtl"] .me-14{
  margin-left: 3.5rem;
}

[dir="ltr"] .ms-15{
  margin-left: 3.75rem;
}

[dir="rtl"] .ms-15{
  margin-right: 3.75rem;
}

[dir="ltr"] .me-15{
  margin-right: 3.75rem;
}

[dir="rtl"] .me-15{
  margin-left: 3.75rem;
}

[dir="ltr"] .ms-16{
  margin-left: 4rem;
}

[dir="rtl"] .ms-16{
  margin-right: 4rem;
}

[dir="ltr"] .me-16{
  margin-right: 4rem;
}

[dir="rtl"] .me-16{
  margin-left: 4rem;
}

[dir="ltr"] .ms-18{
  margin-left: 4.5rem;
}

[dir="rtl"] .ms-18{
  margin-right: 4.5rem;
}

[dir="ltr"] .me-18{
  margin-right: 4.5rem;
}

[dir="rtl"] .me-18{
  margin-left: 4.5rem;
}

[dir="ltr"] .ms-20{
  margin-left: 5rem;
}

[dir="rtl"] .ms-20{
  margin-right: 5rem;
}

[dir="ltr"] .me-20{
  margin-right: 5rem;
}

[dir="rtl"] .me-20{
  margin-left: 5rem;
}

[dir="ltr"] .ms-22{
  margin-left: 5.5rem;
}

[dir="rtl"] .ms-22{
  margin-right: 5.5rem;
}

[dir="ltr"] .me-22{
  margin-right: 5.5rem;
}

[dir="rtl"] .me-22{
  margin-left: 5.5rem;
}

[dir="ltr"] .ms-23{
  margin-left: 5.75rem;
}

[dir="rtl"] .ms-23{
  margin-right: 5.75rem;
}

[dir="ltr"] .me-23{
  margin-right: 5.75rem;
}

[dir="rtl"] .me-23{
  margin-left: 5.75rem;
}

[dir="ltr"] .ms-24{
  margin-left: 6rem;
}

[dir="rtl"] .ms-24{
  margin-right: 6rem;
}

[dir="ltr"] .me-24{
  margin-right: 6rem;
}

[dir="rtl"] .me-24{
  margin-left: 6rem;
}

[dir="ltr"] .ms-25{
  margin-left: 6.25rem;
}

[dir="rtl"] .ms-25{
  margin-right: 6.25rem;
}

[dir="ltr"] .me-25{
  margin-right: 6.25rem;
}

[dir="rtl"] .me-25{
  margin-left: 6.25rem;
}

[dir="ltr"] .ms-26{
  margin-left: 6.5rem;
}

[dir="rtl"] .ms-26{
  margin-right: 6.5rem;
}

[dir="ltr"] .me-26{
  margin-right: 6.5rem;
}

[dir="rtl"] .me-26{
  margin-left: 6.5rem;
}

[dir="ltr"] .ms-28{
  margin-left: 7rem;
}

[dir="rtl"] .ms-28{
  margin-right: 7rem;
}

[dir="ltr"] .me-28{
  margin-right: 7rem;
}

[dir="rtl"] .me-28{
  margin-left: 7rem;
}

[dir="ltr"] .ms-30{
  margin-left: 7.5rem;
}

[dir="rtl"] .ms-30{
  margin-right: 7.5rem;
}

[dir="ltr"] .me-30{
  margin-right: 7.5rem;
}

[dir="rtl"] .me-30{
  margin-left: 7.5rem;
}

[dir="ltr"] .ms-32{
  margin-left: 8rem;
}

[dir="rtl"] .ms-32{
  margin-right: 8rem;
}

[dir="ltr"] .me-32{
  margin-right: 8rem;
}

[dir="rtl"] .me-32{
  margin-left: 8rem;
}

[dir="ltr"] .ms-34{
  margin-left: 8.5rem;
}

[dir="rtl"] .ms-34{
  margin-right: 8.5rem;
}

[dir="ltr"] .me-34{
  margin-right: 8.5rem;
}

[dir="rtl"] .me-34{
  margin-left: 8.5rem;
}

[dir="ltr"] .ms-40{
  margin-left: 10rem;
}

[dir="rtl"] .ms-40{
  margin-right: 10rem;
}

[dir="ltr"] .me-40{
  margin-right: 10rem;
}

[dir="rtl"] .me-40{
  margin-left: 10rem;
}

[dir="ltr"] .ms-42{
  margin-left: 10.5rem;
}

[dir="rtl"] .ms-42{
  margin-right: 10.5rem;
}

[dir="ltr"] .me-42{
  margin-right: 10.5rem;
}

[dir="rtl"] .me-42{
  margin-left: 10.5rem;
}

[dir="ltr"] .ms-44{
  margin-left: 11rem;
}

[dir="rtl"] .ms-44{
  margin-right: 11rem;
}

[dir="ltr"] .me-44{
  margin-right: 11rem;
}

[dir="rtl"] .me-44{
  margin-left: 11rem;
}

[dir="ltr"] .ms-48{
  margin-left: 12rem;
}

[dir="rtl"] .ms-48{
  margin-right: 12rem;
}

[dir="ltr"] .me-48{
  margin-right: 12rem;
}

[dir="rtl"] .me-48{
  margin-left: 12rem;
}

[dir="ltr"] .ms-52{
  margin-left: 13rem;
}

[dir="rtl"] .ms-52{
  margin-right: 13rem;
}

[dir="ltr"] .me-52{
  margin-right: 13rem;
}

[dir="rtl"] .me-52{
  margin-left: 13rem;
}

[dir="ltr"] .ms-54{
  margin-left: 13.5rem;
}

[dir="rtl"] .ms-54{
  margin-right: 13.5rem;
}

[dir="ltr"] .me-54{
  margin-right: 13.5rem;
}

[dir="rtl"] .me-54{
  margin-left: 13.5rem;
}

[dir="ltr"] .ms-56{
  margin-left: 14rem;
}

[dir="rtl"] .ms-56{
  margin-right: 14rem;
}

[dir="ltr"] .me-56{
  margin-right: 14rem;
}

[dir="rtl"] .me-56{
  margin-left: 14rem;
}

[dir="ltr"] .ms-60{
  margin-left: 15rem;
}

[dir="rtl"] .ms-60{
  margin-right: 15rem;
}

[dir="ltr"] .me-60{
  margin-right: 15rem;
}

[dir="rtl"] .me-60{
  margin-left: 15rem;
}

[dir="ltr"] .ms-64{
  margin-left: 16rem;
}

[dir="rtl"] .ms-64{
  margin-right: 16rem;
}

[dir="ltr"] .me-64{
  margin-right: 16rem;
}

[dir="rtl"] .me-64{
  margin-left: 16rem;
}

[dir="ltr"] .ms-68{
  margin-left: 17rem;
}

[dir="rtl"] .ms-68{
  margin-right: 17rem;
}

[dir="ltr"] .me-68{
  margin-right: 17rem;
}

[dir="rtl"] .me-68{
  margin-left: 17rem;
}

[dir="ltr"] .ms-72{
  margin-left: 18rem;
}

[dir="rtl"] .ms-72{
  margin-right: 18rem;
}

[dir="ltr"] .me-72{
  margin-right: 18rem;
}

[dir="rtl"] .me-72{
  margin-left: 18rem;
}

[dir="ltr"] .ms-74{
  margin-left: 18.5rem;
}

[dir="rtl"] .ms-74{
  margin-right: 18.5rem;
}

[dir="ltr"] .me-74{
  margin-right: 18.5rem;
}

[dir="rtl"] .me-74{
  margin-left: 18.5rem;
}

[dir="ltr"] .ms-76{
  margin-left: 19rem;
}

[dir="rtl"] .ms-76{
  margin-right: 19rem;
}

[dir="ltr"] .me-76{
  margin-right: 19rem;
}

[dir="rtl"] .me-76{
  margin-left: 19rem;
}

[dir="ltr"] .ms-78{
  margin-left: 19.5rem;
}

[dir="rtl"] .ms-78{
  margin-right: 19.5rem;
}

[dir="ltr"] .me-78{
  margin-right: 19.5rem;
}

[dir="rtl"] .me-78{
  margin-left: 19.5rem;
}

[dir="ltr"] .ms-80{
  margin-left: 20rem;
}

[dir="rtl"] .ms-80{
  margin-right: 20rem;
}

[dir="ltr"] .me-80{
  margin-right: 20rem;
}

[dir="rtl"] .me-80{
  margin-left: 20rem;
}

[dir="ltr"] .ms-82{
  margin-left: 20.5rem;
}

[dir="rtl"] .ms-82{
  margin-right: 20.5rem;
}

[dir="ltr"] .me-82{
  margin-right: 20.5rem;
}

[dir="rtl"] .me-82{
  margin-left: 20.5rem;
}

[dir="ltr"] .ms-84{
  margin-left: 21rem;
}

[dir="rtl"] .ms-84{
  margin-right: 21rem;
}

[dir="ltr"] .me-84{
  margin-right: 21rem;
}

[dir="rtl"] .me-84{
  margin-left: 21rem;
}

[dir="ltr"] .ms-88{
  margin-left: 22rem;
}

[dir="rtl"] .ms-88{
  margin-right: 22rem;
}

[dir="ltr"] .me-88{
  margin-right: 22rem;
}

[dir="rtl"] .me-88{
  margin-left: 22rem;
}

[dir="ltr"] .ms-92{
  margin-left: 23rem;
}

[dir="rtl"] .ms-92{
  margin-right: 23rem;
}

[dir="ltr"] .me-92{
  margin-right: 23rem;
}

[dir="rtl"] .me-92{
  margin-left: 23rem;
}

[dir="ltr"] .ms-96{
  margin-left: 24rem;
}

[dir="rtl"] .ms-96{
  margin-right: 24rem;
}

[dir="ltr"] .me-96{
  margin-right: 24rem;
}

[dir="rtl"] .me-96{
  margin-left: 24rem;
}

[dir="ltr"] .ms-98{
  margin-left: 24.5rem;
}

[dir="rtl"] .ms-98{
  margin-right: 24.5rem;
}

[dir="ltr"] .me-98{
  margin-right: 24.5rem;
}

[dir="rtl"] .me-98{
  margin-left: 24.5rem;
}

[dir="ltr"] .ms-100{
  margin-left: 25rem;
}

[dir="rtl"] .ms-100{
  margin-right: 25rem;
}

[dir="ltr"] .me-100{
  margin-right: 25rem;
}

[dir="rtl"] .me-100{
  margin-left: 25rem;
}

[dir="ltr"] .ms-104{
  margin-left: 26rem;
}

[dir="rtl"] .ms-104{
  margin-right: 26rem;
}

[dir="ltr"] .me-104{
  margin-right: 26rem;
}

[dir="rtl"] .me-104{
  margin-left: 26rem;
}

[dir="ltr"] .ms-112{
  margin-left: 28rem;
}

[dir="rtl"] .ms-112{
  margin-right: 28rem;
}

[dir="ltr"] .me-112{
  margin-right: 28rem;
}

[dir="rtl"] .me-112{
  margin-left: 28rem;
}

[dir="ltr"] .ms-124{
  margin-left: 31rem;
}

[dir="rtl"] .ms-124{
  margin-right: 31rem;
}

[dir="ltr"] .me-124{
  margin-right: 31rem;
}

[dir="rtl"] .me-124{
  margin-left: 31rem;
}

[dir="ltr"] .ms-128{
  margin-left: 32rem;
}

[dir="rtl"] .ms-128{
  margin-right: 32rem;
}

[dir="ltr"] .me-128{
  margin-right: 32rem;
}

[dir="rtl"] .me-128{
  margin-left: 32rem;
}

[dir="ltr"] .ms-140{
  margin-left: 35rem;
}

[dir="rtl"] .ms-140{
  margin-right: 35rem;
}

[dir="ltr"] .me-140{
  margin-right: 35rem;
}

[dir="rtl"] .me-140{
  margin-left: 35rem;
}

[dir="ltr"] .ms-152{
  margin-left: 38rem;
}

[dir="rtl"] .ms-152{
  margin-right: 38rem;
}

[dir="ltr"] .me-152{
  margin-right: 38rem;
}

[dir="rtl"] .me-152{
  margin-left: 38rem;
}

[dir="ltr"] .ms-160{
  margin-left: 40rem;
}

[dir="rtl"] .ms-160{
  margin-right: 40rem;
}

[dir="ltr"] .me-160{
  margin-right: 40rem;
}

[dir="rtl"] .me-160{
  margin-left: 40rem;
}

[dir="ltr"] .ms-162{
  margin-left: 41rem;
}

[dir="rtl"] .ms-162{
  margin-right: 41rem;
}

[dir="ltr"] .me-162{
  margin-right: 41rem;
}

[dir="rtl"] .me-162{
  margin-left: 41rem;
}

[dir="ltr"] .ms-192{
  margin-left: 48rem;
}

[dir="rtl"] .ms-192{
  margin-right: 48rem;
}

[dir="ltr"] .me-192{
  margin-right: 48rem;
}

[dir="rtl"] .me-192{
  margin-left: 48rem;
}

[dir="ltr"] .ms-208{
  margin-left: 52rem;
}

[dir="rtl"] .ms-208{
  margin-right: 52rem;
}

[dir="ltr"] .me-208{
  margin-right: 52rem;
}

[dir="rtl"] .me-208{
  margin-left: 52rem;
}

[dir="ltr"] .ms-224{
  margin-left: 56rem;
}

[dir="rtl"] .ms-224{
  margin-right: 56rem;
}

[dir="ltr"] .me-224{
  margin-right: 56rem;
}

[dir="rtl"] .me-224{
  margin-left: 56rem;
}

[dir="ltr"] .ms-256{
  margin-left: 64rem;
}

[dir="rtl"] .ms-256{
  margin-right: 64rem;
}

[dir="ltr"] .me-256{
  margin-right: 64rem;
}

[dir="rtl"] .me-256{
  margin-left: 64rem;
}

[dir="ltr"] .ms-auto{
  margin-left: auto;
}

[dir="rtl"] .ms-auto{
  margin-right: auto;
}

[dir="ltr"] .me-auto{
  margin-right: auto;
}

[dir="rtl"] .me-auto{
  margin-left: auto;
}

[dir="ltr"] .ms-px{
  margin-left: 1px;
}

[dir="rtl"] .ms-px{
  margin-right: 1px;
}

[dir="ltr"] .me-px{
  margin-right: 1px;
}

[dir="rtl"] .me-px{
  margin-left: 1px;
}

[dir="ltr"] .-ms-1{
  margin-left: -0.25rem;
}

[dir="rtl"] .-ms-1{
  margin-right: -0.25rem;
}

[dir="ltr"] .-me-1{
  margin-right: -0.25rem;
}

[dir="rtl"] .-me-1{
  margin-left: -0.25rem;
}

[dir="ltr"] .-ms-2{
  margin-left: -0.5rem;
}

[dir="rtl"] .-ms-2{
  margin-right: -0.5rem;
}

[dir="ltr"] .-me-2{
  margin-right: -0.5rem;
}

[dir="rtl"] .-me-2{
  margin-left: -0.5rem;
}

[dir="ltr"] .-ms-3{
  margin-left: -0.75rem;
}

[dir="rtl"] .-ms-3{
  margin-right: -0.75rem;
}

[dir="ltr"] .-me-3{
  margin-right: -0.75rem;
}

[dir="rtl"] .-me-3{
  margin-left: -0.75rem;
}

[dir="ltr"] .-ms-4{
  margin-left: -1rem;
}

[dir="rtl"] .-ms-4{
  margin-right: -1rem;
}

[dir="ltr"] .-me-4{
  margin-right: -1rem;
}

[dir="rtl"] .-me-4{
  margin-left: -1rem;
}

[dir="ltr"] .-ms-5{
  margin-left: -1.25rem;
}

[dir="rtl"] .-ms-5{
  margin-right: -1.25rem;
}

[dir="ltr"] .-me-5{
  margin-right: -1.25rem;
}

[dir="rtl"] .-me-5{
  margin-left: -1.25rem;
}

[dir="ltr"] .-ms-6{
  margin-left: -1.5rem;
}

[dir="rtl"] .-ms-6{
  margin-right: -1.5rem;
}

[dir="ltr"] .-me-6{
  margin-right: -1.5rem;
}

[dir="rtl"] .-me-6{
  margin-left: -1.5rem;
}

[dir="ltr"] .-ms-7{
  margin-left: -1.75rem;
}

[dir="rtl"] .-ms-7{
  margin-right: -1.75rem;
}

[dir="ltr"] .-me-7{
  margin-right: -1.75rem;
}

[dir="rtl"] .-me-7{
  margin-left: -1.75rem;
}

[dir="ltr"] .-ms-8{
  margin-left: -2rem;
}

[dir="rtl"] .-ms-8{
  margin-right: -2rem;
}

[dir="ltr"] .-me-8{
  margin-right: -2rem;
}

[dir="rtl"] .-me-8{
  margin-left: -2rem;
}

[dir="ltr"] .-ms-9{
  margin-left: -2.25rem;
}

[dir="rtl"] .-ms-9{
  margin-right: -2.25rem;
}

[dir="ltr"] .-me-9{
  margin-right: -2.25rem;
}

[dir="rtl"] .-me-9{
  margin-left: -2.25rem;
}

[dir="ltr"] .-ms-10{
  margin-left: -2.5rem;
}

[dir="rtl"] .-ms-10{
  margin-right: -2.5rem;
}

[dir="ltr"] .-me-10{
  margin-right: -2.5rem;
}

[dir="rtl"] .-me-10{
  margin-left: -2.5rem;
}

[dir="ltr"] .-ms-11{
  margin-left: -2.75rem;
}

[dir="rtl"] .-ms-11{
  margin-right: -2.75rem;
}

[dir="ltr"] .-me-11{
  margin-right: -2.75rem;
}

[dir="rtl"] .-me-11{
  margin-left: -2.75rem;
}

[dir="ltr"] .-ms-12{
  margin-left: -3rem;
}

[dir="rtl"] .-ms-12{
  margin-right: -3rem;
}

[dir="ltr"] .-me-12{
  margin-right: -3rem;
}

[dir="rtl"] .-me-12{
  margin-left: -3rem;
}

[dir="ltr"] .-ms-14{
  margin-left: -3.5rem;
}

[dir="rtl"] .-ms-14{
  margin-right: -3.5rem;
}

[dir="ltr"] .-me-14{
  margin-right: -3.5rem;
}

[dir="rtl"] .-me-14{
  margin-left: -3.5rem;
}

[dir="ltr"] .-ms-15{
  margin-left: -3.75rem;
}

[dir="rtl"] .-ms-15{
  margin-right: -3.75rem;
}

[dir="ltr"] .-me-15{
  margin-right: -3.75rem;
}

[dir="rtl"] .-me-15{
  margin-left: -3.75rem;
}

[dir="ltr"] .-ms-16{
  margin-left: -4rem;
}

[dir="rtl"] .-ms-16{
  margin-right: -4rem;
}

[dir="ltr"] .-me-16{
  margin-right: -4rem;
}

[dir="rtl"] .-me-16{
  margin-left: -4rem;
}

[dir="ltr"] .-ms-18{
  margin-left: -4.5rem;
}

[dir="rtl"] .-ms-18{
  margin-right: -4.5rem;
}

[dir="ltr"] .-me-18{
  margin-right: -4.5rem;
}

[dir="rtl"] .-me-18{
  margin-left: -4.5rem;
}

[dir="ltr"] .-ms-20{
  margin-left: -5rem;
}

[dir="rtl"] .-ms-20{
  margin-right: -5rem;
}

[dir="ltr"] .-me-20{
  margin-right: -5rem;
}

[dir="rtl"] .-me-20{
  margin-left: -5rem;
}

[dir="ltr"] .-ms-22{
  margin-left: -5.5rem;
}

[dir="rtl"] .-ms-22{
  margin-right: -5.5rem;
}

[dir="ltr"] .-me-22{
  margin-right: -5.5rem;
}

[dir="rtl"] .-me-22{
  margin-left: -5.5rem;
}

[dir="ltr"] .-ms-23{
  margin-left: -5.75rem;
}

[dir="rtl"] .-ms-23{
  margin-right: -5.75rem;
}

[dir="ltr"] .-me-23{
  margin-right: -5.75rem;
}

[dir="rtl"] .-me-23{
  margin-left: -5.75rem;
}

[dir="ltr"] .-ms-24{
  margin-left: -6rem;
}

[dir="rtl"] .-ms-24{
  margin-right: -6rem;
}

[dir="ltr"] .-me-24{
  margin-right: -6rem;
}

[dir="rtl"] .-me-24{
  margin-left: -6rem;
}

[dir="ltr"] .-ms-25{
  margin-left: -6.25rem;
}

[dir="rtl"] .-ms-25{
  margin-right: -6.25rem;
}

[dir="ltr"] .-me-25{
  margin-right: -6.25rem;
}

[dir="rtl"] .-me-25{
  margin-left: -6.25rem;
}

[dir="ltr"] .-ms-26{
  margin-left: -6.5rem;
}

[dir="rtl"] .-ms-26{
  margin-right: -6.5rem;
}

[dir="ltr"] .-me-26{
  margin-right: -6.5rem;
}

[dir="rtl"] .-me-26{
  margin-left: -6.5rem;
}

[dir="ltr"] .-ms-28{
  margin-left: -7rem;
}

[dir="rtl"] .-ms-28{
  margin-right: -7rem;
}

[dir="ltr"] .-me-28{
  margin-right: -7rem;
}

[dir="rtl"] .-me-28{
  margin-left: -7rem;
}

[dir="ltr"] .-ms-30{
  margin-left: -7.5rem;
}

[dir="rtl"] .-ms-30{
  margin-right: -7.5rem;
}

[dir="ltr"] .-me-30{
  margin-right: -7.5rem;
}

[dir="rtl"] .-me-30{
  margin-left: -7.5rem;
}

[dir="ltr"] .-ms-32{
  margin-left: -8rem;
}

[dir="rtl"] .-ms-32{
  margin-right: -8rem;
}

[dir="ltr"] .-me-32{
  margin-right: -8rem;
}

[dir="rtl"] .-me-32{
  margin-left: -8rem;
}

[dir="ltr"] .-ms-34{
  margin-left: -8.5rem;
}

[dir="rtl"] .-ms-34{
  margin-right: -8.5rem;
}

[dir="ltr"] .-me-34{
  margin-right: -8.5rem;
}

[dir="rtl"] .-me-34{
  margin-left: -8.5rem;
}

[dir="ltr"] .-ms-40{
  margin-left: -10rem;
}

[dir="rtl"] .-ms-40{
  margin-right: -10rem;
}

[dir="ltr"] .-me-40{
  margin-right: -10rem;
}

[dir="rtl"] .-me-40{
  margin-left: -10rem;
}

[dir="ltr"] .-ms-42{
  margin-left: -10.5rem;
}

[dir="rtl"] .-ms-42{
  margin-right: -10.5rem;
}

[dir="ltr"] .-me-42{
  margin-right: -10.5rem;
}

[dir="rtl"] .-me-42{
  margin-left: -10.5rem;
}

[dir="ltr"] .-ms-44{
  margin-left: -11rem;
}

[dir="rtl"] .-ms-44{
  margin-right: -11rem;
}

[dir="ltr"] .-me-44{
  margin-right: -11rem;
}

[dir="rtl"] .-me-44{
  margin-left: -11rem;
}

[dir="ltr"] .-ms-48{
  margin-left: -12rem;
}

[dir="rtl"] .-ms-48{
  margin-right: -12rem;
}

[dir="ltr"] .-me-48{
  margin-right: -12rem;
}

[dir="rtl"] .-me-48{
  margin-left: -12rem;
}

[dir="ltr"] .-ms-52{
  margin-left: -13rem;
}

[dir="rtl"] .-ms-52{
  margin-right: -13rem;
}

[dir="ltr"] .-me-52{
  margin-right: -13rem;
}

[dir="rtl"] .-me-52{
  margin-left: -13rem;
}

[dir="ltr"] .-ms-54{
  margin-left: -13.5rem;
}

[dir="rtl"] .-ms-54{
  margin-right: -13.5rem;
}

[dir="ltr"] .-me-54{
  margin-right: -13.5rem;
}

[dir="rtl"] .-me-54{
  margin-left: -13.5rem;
}

[dir="ltr"] .-ms-56{
  margin-left: -14rem;
}

[dir="rtl"] .-ms-56{
  margin-right: -14rem;
}

[dir="ltr"] .-me-56{
  margin-right: -14rem;
}

[dir="rtl"] .-me-56{
  margin-left: -14rem;
}

[dir="ltr"] .-ms-60{
  margin-left: -15rem;
}

[dir="rtl"] .-ms-60{
  margin-right: -15rem;
}

[dir="ltr"] .-me-60{
  margin-right: -15rem;
}

[dir="rtl"] .-me-60{
  margin-left: -15rem;
}

[dir="ltr"] .-ms-64{
  margin-left: -16rem;
}

[dir="rtl"] .-ms-64{
  margin-right: -16rem;
}

[dir="ltr"] .-me-64{
  margin-right: -16rem;
}

[dir="rtl"] .-me-64{
  margin-left: -16rem;
}

[dir="ltr"] .-ms-68{
  margin-left: -17rem;
}

[dir="rtl"] .-ms-68{
  margin-right: -17rem;
}

[dir="ltr"] .-me-68{
  margin-right: -17rem;
}

[dir="rtl"] .-me-68{
  margin-left: -17rem;
}

[dir="ltr"] .-ms-72{
  margin-left: -18rem;
}

[dir="rtl"] .-ms-72{
  margin-right: -18rem;
}

[dir="ltr"] .-me-72{
  margin-right: -18rem;
}

[dir="rtl"] .-me-72{
  margin-left: -18rem;
}

[dir="ltr"] .-ms-74{
  margin-left: -18.5rem;
}

[dir="rtl"] .-ms-74{
  margin-right: -18.5rem;
}

[dir="ltr"] .-me-74{
  margin-right: -18.5rem;
}

[dir="rtl"] .-me-74{
  margin-left: -18.5rem;
}

[dir="ltr"] .-ms-76{
  margin-left: -19rem;
}

[dir="rtl"] .-ms-76{
  margin-right: -19rem;
}

[dir="ltr"] .-me-76{
  margin-right: -19rem;
}

[dir="rtl"] .-me-76{
  margin-left: -19rem;
}

[dir="ltr"] .-ms-78{
  margin-left: -19.5rem;
}

[dir="rtl"] .-ms-78{
  margin-right: -19.5rem;
}

[dir="ltr"] .-me-78{
  margin-right: -19.5rem;
}

[dir="rtl"] .-me-78{
  margin-left: -19.5rem;
}

[dir="ltr"] .-ms-80{
  margin-left: -20rem;
}

[dir="rtl"] .-ms-80{
  margin-right: -20rem;
}

[dir="ltr"] .-me-80{
  margin-right: -20rem;
}

[dir="rtl"] .-me-80{
  margin-left: -20rem;
}

[dir="ltr"] .-ms-82{
  margin-left: -20.5rem;
}

[dir="rtl"] .-ms-82{
  margin-right: -20.5rem;
}

[dir="ltr"] .-me-82{
  margin-right: -20.5rem;
}

[dir="rtl"] .-me-82{
  margin-left: -20.5rem;
}

[dir="ltr"] .-ms-84{
  margin-left: -21rem;
}

[dir="rtl"] .-ms-84{
  margin-right: -21rem;
}

[dir="ltr"] .-me-84{
  margin-right: -21rem;
}

[dir="rtl"] .-me-84{
  margin-left: -21rem;
}

[dir="ltr"] .-ms-88{
  margin-left: -22rem;
}

[dir="rtl"] .-ms-88{
  margin-right: -22rem;
}

[dir="ltr"] .-me-88{
  margin-right: -22rem;
}

[dir="rtl"] .-me-88{
  margin-left: -22rem;
}

[dir="ltr"] .-ms-92{
  margin-left: -23rem;
}

[dir="rtl"] .-ms-92{
  margin-right: -23rem;
}

[dir="ltr"] .-me-92{
  margin-right: -23rem;
}

[dir="rtl"] .-me-92{
  margin-left: -23rem;
}

[dir="ltr"] .-ms-96{
  margin-left: -24rem;
}

[dir="rtl"] .-ms-96{
  margin-right: -24rem;
}

[dir="ltr"] .-me-96{
  margin-right: -24rem;
}

[dir="rtl"] .-me-96{
  margin-left: -24rem;
}

[dir="ltr"] .-ms-98{
  margin-left: -24.5rem;
}

[dir="rtl"] .-ms-98{
  margin-right: -24.5rem;
}

[dir="ltr"] .-me-98{
  margin-right: -24.5rem;
}

[dir="rtl"] .-me-98{
  margin-left: -24.5rem;
}

[dir="ltr"] .-ms-100{
  margin-left: -25rem;
}

[dir="rtl"] .-ms-100{
  margin-right: -25rem;
}

[dir="ltr"] .-me-100{
  margin-right: -25rem;
}

[dir="rtl"] .-me-100{
  margin-left: -25rem;
}

[dir="ltr"] .-ms-104{
  margin-left: -26rem;
}

[dir="rtl"] .-ms-104{
  margin-right: -26rem;
}

[dir="ltr"] .-me-104{
  margin-right: -26rem;
}

[dir="rtl"] .-me-104{
  margin-left: -26rem;
}

[dir="ltr"] .-ms-112{
  margin-left: -28rem;
}

[dir="rtl"] .-ms-112{
  margin-right: -28rem;
}

[dir="ltr"] .-me-112{
  margin-right: -28rem;
}

[dir="rtl"] .-me-112{
  margin-left: -28rem;
}

[dir="ltr"] .-ms-124{
  margin-left: -31rem;
}

[dir="rtl"] .-ms-124{
  margin-right: -31rem;
}

[dir="ltr"] .-me-124{
  margin-right: -31rem;
}

[dir="rtl"] .-me-124{
  margin-left: -31rem;
}

[dir="ltr"] .-ms-128{
  margin-left: -32rem;
}

[dir="rtl"] .-ms-128{
  margin-right: -32rem;
}

[dir="ltr"] .-me-128{
  margin-right: -32rem;
}

[dir="rtl"] .-me-128{
  margin-left: -32rem;
}

[dir="ltr"] .-ms-140{
  margin-left: -35rem;
}

[dir="rtl"] .-ms-140{
  margin-right: -35rem;
}

[dir="ltr"] .-me-140{
  margin-right: -35rem;
}

[dir="rtl"] .-me-140{
  margin-left: -35rem;
}

[dir="ltr"] .-ms-152{
  margin-left: -38rem;
}

[dir="rtl"] .-ms-152{
  margin-right: -38rem;
}

[dir="ltr"] .-me-152{
  margin-right: -38rem;
}

[dir="rtl"] .-me-152{
  margin-left: -38rem;
}

[dir="ltr"] .-ms-160{
  margin-left: -40rem;
}

[dir="rtl"] .-ms-160{
  margin-right: -40rem;
}

[dir="ltr"] .-me-160{
  margin-right: -40rem;
}

[dir="rtl"] .-me-160{
  margin-left: -40rem;
}

[dir="ltr"] .-ms-162{
  margin-left: -41rem;
}

[dir="rtl"] .-ms-162{
  margin-right: -41rem;
}

[dir="ltr"] .-me-162{
  margin-right: -41rem;
}

[dir="rtl"] .-me-162{
  margin-left: -41rem;
}

[dir="ltr"] .-ms-192{
  margin-left: -48rem;
}

[dir="rtl"] .-ms-192{
  margin-right: -48rem;
}

[dir="ltr"] .-me-192{
  margin-right: -48rem;
}

[dir="rtl"] .-me-192{
  margin-left: -48rem;
}

[dir="ltr"] .-ms-208{
  margin-left: -52rem;
}

[dir="rtl"] .-ms-208{
  margin-right: -52rem;
}

[dir="ltr"] .-me-208{
  margin-right: -52rem;
}

[dir="rtl"] .-me-208{
  margin-left: -52rem;
}

[dir="ltr"] .-ms-224{
  margin-left: -56rem;
}

[dir="rtl"] .-ms-224{
  margin-right: -56rem;
}

[dir="ltr"] .-me-224{
  margin-right: -56rem;
}

[dir="rtl"] .-me-224{
  margin-left: -56rem;
}

[dir="ltr"] .-ms-256{
  margin-left: -64rem;
}

[dir="rtl"] .-ms-256{
  margin-right: -64rem;
}

[dir="ltr"] .-me-256{
  margin-right: -64rem;
}

[dir="rtl"] .-me-256{
  margin-left: -64rem;
}

[dir="ltr"] .-ms-px{
  margin-left: -1px;
}

[dir="rtl"] .-ms-px{
  margin-right: -1px;
}

[dir="ltr"] .-me-px{
  margin-right: -1px;
}

[dir="rtl"] .-me-px{
  margin-left: -1px;
}

[dir="ltr"] .first\\:ms-0:first-child{
  margin-left: 0;
}

[dir="rtl"] .first\\:ms-0:first-child{
  margin-right: 0;
}

[dir="ltr"] .first\\:me-0:first-child{
  margin-right: 0;
}

[dir="rtl"] .first\\:me-0:first-child{
  margin-left: 0;
}

[dir="ltr"] .first\\:ms-1:first-child{
  margin-left: 0.25rem;
}

[dir="rtl"] .first\\:ms-1:first-child{
  margin-right: 0.25rem;
}

[dir="ltr"] .first\\:me-1:first-child{
  margin-right: 0.25rem;
}

[dir="rtl"] .first\\:me-1:first-child{
  margin-left: 0.25rem;
}

[dir="ltr"] .first\\:ms-2:first-child{
  margin-left: 0.5rem;
}

[dir="rtl"] .first\\:ms-2:first-child{
  margin-right: 0.5rem;
}

[dir="ltr"] .first\\:me-2:first-child{
  margin-right: 0.5rem;
}

[dir="rtl"] .first\\:me-2:first-child{
  margin-left: 0.5rem;
}

[dir="ltr"] .first\\:ms-3:first-child{
  margin-left: 0.75rem;
}

[dir="rtl"] .first\\:ms-3:first-child{
  margin-right: 0.75rem;
}

[dir="ltr"] .first\\:me-3:first-child{
  margin-right: 0.75rem;
}

[dir="rtl"] .first\\:me-3:first-child{
  margin-left: 0.75rem;
}

[dir="ltr"] .first\\:ms-4:first-child{
  margin-left: 1rem;
}

[dir="rtl"] .first\\:ms-4:first-child{
  margin-right: 1rem;
}

[dir="ltr"] .first\\:me-4:first-child{
  margin-right: 1rem;
}

[dir="rtl"] .first\\:me-4:first-child{
  margin-left: 1rem;
}

[dir="ltr"] .first\\:ms-5:first-child{
  margin-left: 1.25rem;
}

[dir="rtl"] .first\\:ms-5:first-child{
  margin-right: 1.25rem;
}

[dir="ltr"] .first\\:me-5:first-child{
  margin-right: 1.25rem;
}

[dir="rtl"] .first\\:me-5:first-child{
  margin-left: 1.25rem;
}

[dir="ltr"] .first\\:ms-6:first-child{
  margin-left: 1.5rem;
}

[dir="rtl"] .first\\:ms-6:first-child{
  margin-right: 1.5rem;
}

[dir="ltr"] .first\\:me-6:first-child{
  margin-right: 1.5rem;
}

[dir="rtl"] .first\\:me-6:first-child{
  margin-left: 1.5rem;
}

[dir="ltr"] .first\\:ms-7:first-child{
  margin-left: 1.75rem;
}

[dir="rtl"] .first\\:ms-7:first-child{
  margin-right: 1.75rem;
}

[dir="ltr"] .first\\:me-7:first-child{
  margin-right: 1.75rem;
}

[dir="rtl"] .first\\:me-7:first-child{
  margin-left: 1.75rem;
}

[dir="ltr"] .first\\:ms-8:first-child{
  margin-left: 2rem;
}

[dir="rtl"] .first\\:ms-8:first-child{
  margin-right: 2rem;
}

[dir="ltr"] .first\\:me-8:first-child{
  margin-right: 2rem;
}

[dir="rtl"] .first\\:me-8:first-child{
  margin-left: 2rem;
}

[dir="ltr"] .first\\:ms-9:first-child{
  margin-left: 2.25rem;
}

[dir="rtl"] .first\\:ms-9:first-child{
  margin-right: 2.25rem;
}

[dir="ltr"] .first\\:me-9:first-child{
  margin-right: 2.25rem;
}

[dir="rtl"] .first\\:me-9:first-child{
  margin-left: 2.25rem;
}

[dir="ltr"] .first\\:ms-10:first-child{
  margin-left: 2.5rem;
}

[dir="rtl"] .first\\:ms-10:first-child{
  margin-right: 2.5rem;
}

[dir="ltr"] .first\\:me-10:first-child{
  margin-right: 2.5rem;
}

[dir="rtl"] .first\\:me-10:first-child{
  margin-left: 2.5rem;
}

[dir="ltr"] .first\\:ms-11:first-child{
  margin-left: 2.75rem;
}

[dir="rtl"] .first\\:ms-11:first-child{
  margin-right: 2.75rem;
}

[dir="ltr"] .first\\:me-11:first-child{
  margin-right: 2.75rem;
}

[dir="rtl"] .first\\:me-11:first-child{
  margin-left: 2.75rem;
}

[dir="ltr"] .first\\:ms-12:first-child{
  margin-left: 3rem;
}

[dir="rtl"] .first\\:ms-12:first-child{
  margin-right: 3rem;
}

[dir="ltr"] .first\\:me-12:first-child{
  margin-right: 3rem;
}

[dir="rtl"] .first\\:me-12:first-child{
  margin-left: 3rem;
}

[dir="ltr"] .first\\:ms-14:first-child{
  margin-left: 3.5rem;
}

[dir="rtl"] .first\\:ms-14:first-child{
  margin-right: 3.5rem;
}

[dir="ltr"] .first\\:me-14:first-child{
  margin-right: 3.5rem;
}

[dir="rtl"] .first\\:me-14:first-child{
  margin-left: 3.5rem;
}

[dir="ltr"] .first\\:ms-15:first-child{
  margin-left: 3.75rem;
}

[dir="rtl"] .first\\:ms-15:first-child{
  margin-right: 3.75rem;
}

[dir="ltr"] .first\\:me-15:first-child{
  margin-right: 3.75rem;
}

[dir="rtl"] .first\\:me-15:first-child{
  margin-left: 3.75rem;
}

[dir="ltr"] .first\\:ms-16:first-child{
  margin-left: 4rem;
}

[dir="rtl"] .first\\:ms-16:first-child{
  margin-right: 4rem;
}

[dir="ltr"] .first\\:me-16:first-child{
  margin-right: 4rem;
}

[dir="rtl"] .first\\:me-16:first-child{
  margin-left: 4rem;
}

[dir="ltr"] .first\\:ms-18:first-child{
  margin-left: 4.5rem;
}

[dir="rtl"] .first\\:ms-18:first-child{
  margin-right: 4.5rem;
}

[dir="ltr"] .first\\:me-18:first-child{
  margin-right: 4.5rem;
}

[dir="rtl"] .first\\:me-18:first-child{
  margin-left: 4.5rem;
}

[dir="ltr"] .first\\:ms-20:first-child{
  margin-left: 5rem;
}

[dir="rtl"] .first\\:ms-20:first-child{
  margin-right: 5rem;
}

[dir="ltr"] .first\\:me-20:first-child{
  margin-right: 5rem;
}

[dir="rtl"] .first\\:me-20:first-child{
  margin-left: 5rem;
}

[dir="ltr"] .first\\:ms-22:first-child{
  margin-left: 5.5rem;
}

[dir="rtl"] .first\\:ms-22:first-child{
  margin-right: 5.5rem;
}

[dir="ltr"] .first\\:me-22:first-child{
  margin-right: 5.5rem;
}

[dir="rtl"] .first\\:me-22:first-child{
  margin-left: 5.5rem;
}

[dir="ltr"] .first\\:ms-23:first-child{
  margin-left: 5.75rem;
}

[dir="rtl"] .first\\:ms-23:first-child{
  margin-right: 5.75rem;
}

[dir="ltr"] .first\\:me-23:first-child{
  margin-right: 5.75rem;
}

[dir="rtl"] .first\\:me-23:first-child{
  margin-left: 5.75rem;
}

[dir="ltr"] .first\\:ms-24:first-child{
  margin-left: 6rem;
}

[dir="rtl"] .first\\:ms-24:first-child{
  margin-right: 6rem;
}

[dir="ltr"] .first\\:me-24:first-child{
  margin-right: 6rem;
}

[dir="rtl"] .first\\:me-24:first-child{
  margin-left: 6rem;
}

[dir="ltr"] .first\\:ms-25:first-child{
  margin-left: 6.25rem;
}

[dir="rtl"] .first\\:ms-25:first-child{
  margin-right: 6.25rem;
}

[dir="ltr"] .first\\:me-25:first-child{
  margin-right: 6.25rem;
}

[dir="rtl"] .first\\:me-25:first-child{
  margin-left: 6.25rem;
}

[dir="ltr"] .first\\:ms-26:first-child{
  margin-left: 6.5rem;
}

[dir="rtl"] .first\\:ms-26:first-child{
  margin-right: 6.5rem;
}

[dir="ltr"] .first\\:me-26:first-child{
  margin-right: 6.5rem;
}

[dir="rtl"] .first\\:me-26:first-child{
  margin-left: 6.5rem;
}

[dir="ltr"] .first\\:ms-28:first-child{
  margin-left: 7rem;
}

[dir="rtl"] .first\\:ms-28:first-child{
  margin-right: 7rem;
}

[dir="ltr"] .first\\:me-28:first-child{
  margin-right: 7rem;
}

[dir="rtl"] .first\\:me-28:first-child{
  margin-left: 7rem;
}

[dir="ltr"] .first\\:ms-30:first-child{
  margin-left: 7.5rem;
}

[dir="rtl"] .first\\:ms-30:first-child{
  margin-right: 7.5rem;
}

[dir="ltr"] .first\\:me-30:first-child{
  margin-right: 7.5rem;
}

[dir="rtl"] .first\\:me-30:first-child{
  margin-left: 7.5rem;
}

[dir="ltr"] .first\\:ms-32:first-child{
  margin-left: 8rem;
}

[dir="rtl"] .first\\:ms-32:first-child{
  margin-right: 8rem;
}

[dir="ltr"] .first\\:me-32:first-child{
  margin-right: 8rem;
}

[dir="rtl"] .first\\:me-32:first-child{
  margin-left: 8rem;
}

[dir="ltr"] .first\\:ms-34:first-child{
  margin-left: 8.5rem;
}

[dir="rtl"] .first\\:ms-34:first-child{
  margin-right: 8.5rem;
}

[dir="ltr"] .first\\:me-34:first-child{
  margin-right: 8.5rem;
}

[dir="rtl"] .first\\:me-34:first-child{
  margin-left: 8.5rem;
}

[dir="ltr"] .first\\:ms-40:first-child{
  margin-left: 10rem;
}

[dir="rtl"] .first\\:ms-40:first-child{
  margin-right: 10rem;
}

[dir="ltr"] .first\\:me-40:first-child{
  margin-right: 10rem;
}

[dir="rtl"] .first\\:me-40:first-child{
  margin-left: 10rem;
}

[dir="ltr"] .first\\:ms-42:first-child{
  margin-left: 10.5rem;
}

[dir="rtl"] .first\\:ms-42:first-child{
  margin-right: 10.5rem;
}

[dir="ltr"] .first\\:me-42:first-child{
  margin-right: 10.5rem;
}

[dir="rtl"] .first\\:me-42:first-child{
  margin-left: 10.5rem;
}

[dir="ltr"] .first\\:ms-44:first-child{
  margin-left: 11rem;
}

[dir="rtl"] .first\\:ms-44:first-child{
  margin-right: 11rem;
}

[dir="ltr"] .first\\:me-44:first-child{
  margin-right: 11rem;
}

[dir="rtl"] .first\\:me-44:first-child{
  margin-left: 11rem;
}

[dir="ltr"] .first\\:ms-48:first-child{
  margin-left: 12rem;
}

[dir="rtl"] .first\\:ms-48:first-child{
  margin-right: 12rem;
}

[dir="ltr"] .first\\:me-48:first-child{
  margin-right: 12rem;
}

[dir="rtl"] .first\\:me-48:first-child{
  margin-left: 12rem;
}

[dir="ltr"] .first\\:ms-52:first-child{
  margin-left: 13rem;
}

[dir="rtl"] .first\\:ms-52:first-child{
  margin-right: 13rem;
}

[dir="ltr"] .first\\:me-52:first-child{
  margin-right: 13rem;
}

[dir="rtl"] .first\\:me-52:first-child{
  margin-left: 13rem;
}

[dir="ltr"] .first\\:ms-54:first-child{
  margin-left: 13.5rem;
}

[dir="rtl"] .first\\:ms-54:first-child{
  margin-right: 13.5rem;
}

[dir="ltr"] .first\\:me-54:first-child{
  margin-right: 13.5rem;
}

[dir="rtl"] .first\\:me-54:first-child{
  margin-left: 13.5rem;
}

[dir="ltr"] .first\\:ms-56:first-child{
  margin-left: 14rem;
}

[dir="rtl"] .first\\:ms-56:first-child{
  margin-right: 14rem;
}

[dir="ltr"] .first\\:me-56:first-child{
  margin-right: 14rem;
}

[dir="rtl"] .first\\:me-56:first-child{
  margin-left: 14rem;
}

[dir="ltr"] .first\\:ms-60:first-child{
  margin-left: 15rem;
}

[dir="rtl"] .first\\:ms-60:first-child{
  margin-right: 15rem;
}

[dir="ltr"] .first\\:me-60:first-child{
  margin-right: 15rem;
}

[dir="rtl"] .first\\:me-60:first-child{
  margin-left: 15rem;
}

[dir="ltr"] .first\\:ms-64:first-child{
  margin-left: 16rem;
}

[dir="rtl"] .first\\:ms-64:first-child{
  margin-right: 16rem;
}

[dir="ltr"] .first\\:me-64:first-child{
  margin-right: 16rem;
}

[dir="rtl"] .first\\:me-64:first-child{
  margin-left: 16rem;
}

[dir="ltr"] .first\\:ms-68:first-child{
  margin-left: 17rem;
}

[dir="rtl"] .first\\:ms-68:first-child{
  margin-right: 17rem;
}

[dir="ltr"] .first\\:me-68:first-child{
  margin-right: 17rem;
}

[dir="rtl"] .first\\:me-68:first-child{
  margin-left: 17rem;
}

[dir="ltr"] .first\\:ms-72:first-child{
  margin-left: 18rem;
}

[dir="rtl"] .first\\:ms-72:first-child{
  margin-right: 18rem;
}

[dir="ltr"] .first\\:me-72:first-child{
  margin-right: 18rem;
}

[dir="rtl"] .first\\:me-72:first-child{
  margin-left: 18rem;
}

[dir="ltr"] .first\\:ms-74:first-child{
  margin-left: 18.5rem;
}

[dir="rtl"] .first\\:ms-74:first-child{
  margin-right: 18.5rem;
}

[dir="ltr"] .first\\:me-74:first-child{
  margin-right: 18.5rem;
}

[dir="rtl"] .first\\:me-74:first-child{
  margin-left: 18.5rem;
}

[dir="ltr"] .first\\:ms-76:first-child{
  margin-left: 19rem;
}

[dir="rtl"] .first\\:ms-76:first-child{
  margin-right: 19rem;
}

[dir="ltr"] .first\\:me-76:first-child{
  margin-right: 19rem;
}

[dir="rtl"] .first\\:me-76:first-child{
  margin-left: 19rem;
}

[dir="ltr"] .first\\:ms-78:first-child{
  margin-left: 19.5rem;
}

[dir="rtl"] .first\\:ms-78:first-child{
  margin-right: 19.5rem;
}

[dir="ltr"] .first\\:me-78:first-child{
  margin-right: 19.5rem;
}

[dir="rtl"] .first\\:me-78:first-child{
  margin-left: 19.5rem;
}

[dir="ltr"] .first\\:ms-80:first-child{
  margin-left: 20rem;
}

[dir="rtl"] .first\\:ms-80:first-child{
  margin-right: 20rem;
}

[dir="ltr"] .first\\:me-80:first-child{
  margin-right: 20rem;
}

[dir="rtl"] .first\\:me-80:first-child{
  margin-left: 20rem;
}

[dir="ltr"] .first\\:ms-82:first-child{
  margin-left: 20.5rem;
}

[dir="rtl"] .first\\:ms-82:first-child{
  margin-right: 20.5rem;
}

[dir="ltr"] .first\\:me-82:first-child{
  margin-right: 20.5rem;
}

[dir="rtl"] .first\\:me-82:first-child{
  margin-left: 20.5rem;
}

[dir="ltr"] .first\\:ms-84:first-child{
  margin-left: 21rem;
}

[dir="rtl"] .first\\:ms-84:first-child{
  margin-right: 21rem;
}

[dir="ltr"] .first\\:me-84:first-child{
  margin-right: 21rem;
}

[dir="rtl"] .first\\:me-84:first-child{
  margin-left: 21rem;
}

[dir="ltr"] .first\\:ms-88:first-child{
  margin-left: 22rem;
}

[dir="rtl"] .first\\:ms-88:first-child{
  margin-right: 22rem;
}

[dir="ltr"] .first\\:me-88:first-child{
  margin-right: 22rem;
}

[dir="rtl"] .first\\:me-88:first-child{
  margin-left: 22rem;
}

[dir="ltr"] .first\\:ms-92:first-child{
  margin-left: 23rem;
}

[dir="rtl"] .first\\:ms-92:first-child{
  margin-right: 23rem;
}

[dir="ltr"] .first\\:me-92:first-child{
  margin-right: 23rem;
}

[dir="rtl"] .first\\:me-92:first-child{
  margin-left: 23rem;
}

[dir="ltr"] .first\\:ms-96:first-child{
  margin-left: 24rem;
}

[dir="rtl"] .first\\:ms-96:first-child{
  margin-right: 24rem;
}

[dir="ltr"] .first\\:me-96:first-child{
  margin-right: 24rem;
}

[dir="rtl"] .first\\:me-96:first-child{
  margin-left: 24rem;
}

[dir="ltr"] .first\\:ms-98:first-child{
  margin-left: 24.5rem;
}

[dir="rtl"] .first\\:ms-98:first-child{
  margin-right: 24.5rem;
}

[dir="ltr"] .first\\:me-98:first-child{
  margin-right: 24.5rem;
}

[dir="rtl"] .first\\:me-98:first-child{
  margin-left: 24.5rem;
}

[dir="ltr"] .first\\:ms-100:first-child{
  margin-left: 25rem;
}

[dir="rtl"] .first\\:ms-100:first-child{
  margin-right: 25rem;
}

[dir="ltr"] .first\\:me-100:first-child{
  margin-right: 25rem;
}

[dir="rtl"] .first\\:me-100:first-child{
  margin-left: 25rem;
}

[dir="ltr"] .first\\:ms-104:first-child{
  margin-left: 26rem;
}

[dir="rtl"] .first\\:ms-104:first-child{
  margin-right: 26rem;
}

[dir="ltr"] .first\\:me-104:first-child{
  margin-right: 26rem;
}

[dir="rtl"] .first\\:me-104:first-child{
  margin-left: 26rem;
}

[dir="ltr"] .first\\:ms-112:first-child{
  margin-left: 28rem;
}

[dir="rtl"] .first\\:ms-112:first-child{
  margin-right: 28rem;
}

[dir="ltr"] .first\\:me-112:first-child{
  margin-right: 28rem;
}

[dir="rtl"] .first\\:me-112:first-child{
  margin-left: 28rem;
}

[dir="ltr"] .first\\:ms-124:first-child{
  margin-left: 31rem;
}

[dir="rtl"] .first\\:ms-124:first-child{
  margin-right: 31rem;
}

[dir="ltr"] .first\\:me-124:first-child{
  margin-right: 31rem;
}

[dir="rtl"] .first\\:me-124:first-child{
  margin-left: 31rem;
}

[dir="ltr"] .first\\:ms-128:first-child{
  margin-left: 32rem;
}

[dir="rtl"] .first\\:ms-128:first-child{
  margin-right: 32rem;
}

[dir="ltr"] .first\\:me-128:first-child{
  margin-right: 32rem;
}

[dir="rtl"] .first\\:me-128:first-child{
  margin-left: 32rem;
}

[dir="ltr"] .first\\:ms-140:first-child{
  margin-left: 35rem;
}

[dir="rtl"] .first\\:ms-140:first-child{
  margin-right: 35rem;
}

[dir="ltr"] .first\\:me-140:first-child{
  margin-right: 35rem;
}

[dir="rtl"] .first\\:me-140:first-child{
  margin-left: 35rem;
}

[dir="ltr"] .first\\:ms-152:first-child{
  margin-left: 38rem;
}

[dir="rtl"] .first\\:ms-152:first-child{
  margin-right: 38rem;
}

[dir="ltr"] .first\\:me-152:first-child{
  margin-right: 38rem;
}

[dir="rtl"] .first\\:me-152:first-child{
  margin-left: 38rem;
}

[dir="ltr"] .first\\:ms-160:first-child{
  margin-left: 40rem;
}

[dir="rtl"] .first\\:ms-160:first-child{
  margin-right: 40rem;
}

[dir="ltr"] .first\\:me-160:first-child{
  margin-right: 40rem;
}

[dir="rtl"] .first\\:me-160:first-child{
  margin-left: 40rem;
}

[dir="ltr"] .first\\:ms-162:first-child{
  margin-left: 41rem;
}

[dir="rtl"] .first\\:ms-162:first-child{
  margin-right: 41rem;
}

[dir="ltr"] .first\\:me-162:first-child{
  margin-right: 41rem;
}

[dir="rtl"] .first\\:me-162:first-child{
  margin-left: 41rem;
}

[dir="ltr"] .first\\:ms-192:first-child{
  margin-left: 48rem;
}

[dir="rtl"] .first\\:ms-192:first-child{
  margin-right: 48rem;
}

[dir="ltr"] .first\\:me-192:first-child{
  margin-right: 48rem;
}

[dir="rtl"] .first\\:me-192:first-child{
  margin-left: 48rem;
}

[dir="ltr"] .first\\:ms-208:first-child{
  margin-left: 52rem;
}

[dir="rtl"] .first\\:ms-208:first-child{
  margin-right: 52rem;
}

[dir="ltr"] .first\\:me-208:first-child{
  margin-right: 52rem;
}

[dir="rtl"] .first\\:me-208:first-child{
  margin-left: 52rem;
}

[dir="ltr"] .first\\:ms-224:first-child{
  margin-left: 56rem;
}

[dir="rtl"] .first\\:ms-224:first-child{
  margin-right: 56rem;
}

[dir="ltr"] .first\\:me-224:first-child{
  margin-right: 56rem;
}

[dir="rtl"] .first\\:me-224:first-child{
  margin-left: 56rem;
}

[dir="ltr"] .first\\:ms-256:first-child{
  margin-left: 64rem;
}

[dir="rtl"] .first\\:ms-256:first-child{
  margin-right: 64rem;
}

[dir="ltr"] .first\\:me-256:first-child{
  margin-right: 64rem;
}

[dir="rtl"] .first\\:me-256:first-child{
  margin-left: 64rem;
}

[dir="ltr"] .first\\:ms-auto:first-child{
  margin-left: auto;
}

[dir="rtl"] .first\\:ms-auto:first-child{
  margin-right: auto;
}

[dir="ltr"] .first\\:me-auto:first-child{
  margin-right: auto;
}

[dir="rtl"] .first\\:me-auto:first-child{
  margin-left: auto;
}

[dir="ltr"] .first\\:ms-px:first-child{
  margin-left: 1px;
}

[dir="rtl"] .first\\:ms-px:first-child{
  margin-right: 1px;
}

[dir="ltr"] .first\\:me-px:first-child{
  margin-right: 1px;
}

[dir="rtl"] .first\\:me-px:first-child{
  margin-left: 1px;
}

[dir="ltr"] .first\\:-ms-1:first-child{
  margin-left: -0.25rem;
}

[dir="rtl"] .first\\:-ms-1:first-child{
  margin-right: -0.25rem;
}

[dir="ltr"] .first\\:-me-1:first-child{
  margin-right: -0.25rem;
}

[dir="rtl"] .first\\:-me-1:first-child{
  margin-left: -0.25rem;
}

[dir="ltr"] .first\\:-ms-2:first-child{
  margin-left: -0.5rem;
}

[dir="rtl"] .first\\:-ms-2:first-child{
  margin-right: -0.5rem;
}

[dir="ltr"] .first\\:-me-2:first-child{
  margin-right: -0.5rem;
}

[dir="rtl"] .first\\:-me-2:first-child{
  margin-left: -0.5rem;
}

[dir="ltr"] .first\\:-ms-3:first-child{
  margin-left: -0.75rem;
}

[dir="rtl"] .first\\:-ms-3:first-child{
  margin-right: -0.75rem;
}

[dir="ltr"] .first\\:-me-3:first-child{
  margin-right: -0.75rem;
}

[dir="rtl"] .first\\:-me-3:first-child{
  margin-left: -0.75rem;
}

[dir="ltr"] .first\\:-ms-4:first-child{
  margin-left: -1rem;
}

[dir="rtl"] .first\\:-ms-4:first-child{
  margin-right: -1rem;
}

[dir="ltr"] .first\\:-me-4:first-child{
  margin-right: -1rem;
}

[dir="rtl"] .first\\:-me-4:first-child{
  margin-left: -1rem;
}

[dir="ltr"] .first\\:-ms-5:first-child{
  margin-left: -1.25rem;
}

[dir="rtl"] .first\\:-ms-5:first-child{
  margin-right: -1.25rem;
}

[dir="ltr"] .first\\:-me-5:first-child{
  margin-right: -1.25rem;
}

[dir="rtl"] .first\\:-me-5:first-child{
  margin-left: -1.25rem;
}

[dir="ltr"] .first\\:-ms-6:first-child{
  margin-left: -1.5rem;
}

[dir="rtl"] .first\\:-ms-6:first-child{
  margin-right: -1.5rem;
}

[dir="ltr"] .first\\:-me-6:first-child{
  margin-right: -1.5rem;
}

[dir="rtl"] .first\\:-me-6:first-child{
  margin-left: -1.5rem;
}

[dir="ltr"] .first\\:-ms-7:first-child{
  margin-left: -1.75rem;
}

[dir="rtl"] .first\\:-ms-7:first-child{
  margin-right: -1.75rem;
}

[dir="ltr"] .first\\:-me-7:first-child{
  margin-right: -1.75rem;
}

[dir="rtl"] .first\\:-me-7:first-child{
  margin-left: -1.75rem;
}

[dir="ltr"] .first\\:-ms-8:first-child{
  margin-left: -2rem;
}

[dir="rtl"] .first\\:-ms-8:first-child{
  margin-right: -2rem;
}

[dir="ltr"] .first\\:-me-8:first-child{
  margin-right: -2rem;
}

[dir="rtl"] .first\\:-me-8:first-child{
  margin-left: -2rem;
}

[dir="ltr"] .first\\:-ms-9:first-child{
  margin-left: -2.25rem;
}

[dir="rtl"] .first\\:-ms-9:first-child{
  margin-right: -2.25rem;
}

[dir="ltr"] .first\\:-me-9:first-child{
  margin-right: -2.25rem;
}

[dir="rtl"] .first\\:-me-9:first-child{
  margin-left: -2.25rem;
}

[dir="ltr"] .first\\:-ms-10:first-child{
  margin-left: -2.5rem;
}

[dir="rtl"] .first\\:-ms-10:first-child{
  margin-right: -2.5rem;
}

[dir="ltr"] .first\\:-me-10:first-child{
  margin-right: -2.5rem;
}

[dir="rtl"] .first\\:-me-10:first-child{
  margin-left: -2.5rem;
}

[dir="ltr"] .first\\:-ms-11:first-child{
  margin-left: -2.75rem;
}

[dir="rtl"] .first\\:-ms-11:first-child{
  margin-right: -2.75rem;
}

[dir="ltr"] .first\\:-me-11:first-child{
  margin-right: -2.75rem;
}

[dir="rtl"] .first\\:-me-11:first-child{
  margin-left: -2.75rem;
}

[dir="ltr"] .first\\:-ms-12:first-child{
  margin-left: -3rem;
}

[dir="rtl"] .first\\:-ms-12:first-child{
  margin-right: -3rem;
}

[dir="ltr"] .first\\:-me-12:first-child{
  margin-right: -3rem;
}

[dir="rtl"] .first\\:-me-12:first-child{
  margin-left: -3rem;
}

[dir="ltr"] .first\\:-ms-14:first-child{
  margin-left: -3.5rem;
}

[dir="rtl"] .first\\:-ms-14:first-child{
  margin-right: -3.5rem;
}

[dir="ltr"] .first\\:-me-14:first-child{
  margin-right: -3.5rem;
}

[dir="rtl"] .first\\:-me-14:first-child{
  margin-left: -3.5rem;
}

[dir="ltr"] .first\\:-ms-15:first-child{
  margin-left: -3.75rem;
}

[dir="rtl"] .first\\:-ms-15:first-child{
  margin-right: -3.75rem;
}

[dir="ltr"] .first\\:-me-15:first-child{
  margin-right: -3.75rem;
}

[dir="rtl"] .first\\:-me-15:first-child{
  margin-left: -3.75rem;
}

[dir="ltr"] .first\\:-ms-16:first-child{
  margin-left: -4rem;
}

[dir="rtl"] .first\\:-ms-16:first-child{
  margin-right: -4rem;
}

[dir="ltr"] .first\\:-me-16:first-child{
  margin-right: -4rem;
}

[dir="rtl"] .first\\:-me-16:first-child{
  margin-left: -4rem;
}

[dir="ltr"] .first\\:-ms-18:first-child{
  margin-left: -4.5rem;
}

[dir="rtl"] .first\\:-ms-18:first-child{
  margin-right: -4.5rem;
}

[dir="ltr"] .first\\:-me-18:first-child{
  margin-right: -4.5rem;
}

[dir="rtl"] .first\\:-me-18:first-child{
  margin-left: -4.5rem;
}

[dir="ltr"] .first\\:-ms-20:first-child{
  margin-left: -5rem;
}

[dir="rtl"] .first\\:-ms-20:first-child{
  margin-right: -5rem;
}

[dir="ltr"] .first\\:-me-20:first-child{
  margin-right: -5rem;
}

[dir="rtl"] .first\\:-me-20:first-child{
  margin-left: -5rem;
}

[dir="ltr"] .first\\:-ms-22:first-child{
  margin-left: -5.5rem;
}

[dir="rtl"] .first\\:-ms-22:first-child{
  margin-right: -5.5rem;
}

[dir="ltr"] .first\\:-me-22:first-child{
  margin-right: -5.5rem;
}

[dir="rtl"] .first\\:-me-22:first-child{
  margin-left: -5.5rem;
}

[dir="ltr"] .first\\:-ms-23:first-child{
  margin-left: -5.75rem;
}

[dir="rtl"] .first\\:-ms-23:first-child{
  margin-right: -5.75rem;
}

[dir="ltr"] .first\\:-me-23:first-child{
  margin-right: -5.75rem;
}

[dir="rtl"] .first\\:-me-23:first-child{
  margin-left: -5.75rem;
}

[dir="ltr"] .first\\:-ms-24:first-child{
  margin-left: -6rem;
}

[dir="rtl"] .first\\:-ms-24:first-child{
  margin-right: -6rem;
}

[dir="ltr"] .first\\:-me-24:first-child{
  margin-right: -6rem;
}

[dir="rtl"] .first\\:-me-24:first-child{
  margin-left: -6rem;
}

[dir="ltr"] .first\\:-ms-25:first-child{
  margin-left: -6.25rem;
}

[dir="rtl"] .first\\:-ms-25:first-child{
  margin-right: -6.25rem;
}

[dir="ltr"] .first\\:-me-25:first-child{
  margin-right: -6.25rem;
}

[dir="rtl"] .first\\:-me-25:first-child{
  margin-left: -6.25rem;
}

[dir="ltr"] .first\\:-ms-26:first-child{
  margin-left: -6.5rem;
}

[dir="rtl"] .first\\:-ms-26:first-child{
  margin-right: -6.5rem;
}

[dir="ltr"] .first\\:-me-26:first-child{
  margin-right: -6.5rem;
}

[dir="rtl"] .first\\:-me-26:first-child{
  margin-left: -6.5rem;
}

[dir="ltr"] .first\\:-ms-28:first-child{
  margin-left: -7rem;
}

[dir="rtl"] .first\\:-ms-28:first-child{
  margin-right: -7rem;
}

[dir="ltr"] .first\\:-me-28:first-child{
  margin-right: -7rem;
}

[dir="rtl"] .first\\:-me-28:first-child{
  margin-left: -7rem;
}

[dir="ltr"] .first\\:-ms-30:first-child{
  margin-left: -7.5rem;
}

[dir="rtl"] .first\\:-ms-30:first-child{
  margin-right: -7.5rem;
}

[dir="ltr"] .first\\:-me-30:first-child{
  margin-right: -7.5rem;
}

[dir="rtl"] .first\\:-me-30:first-child{
  margin-left: -7.5rem;
}

[dir="ltr"] .first\\:-ms-32:first-child{
  margin-left: -8rem;
}

[dir="rtl"] .first\\:-ms-32:first-child{
  margin-right: -8rem;
}

[dir="ltr"] .first\\:-me-32:first-child{
  margin-right: -8rem;
}

[dir="rtl"] .first\\:-me-32:first-child{
  margin-left: -8rem;
}

[dir="ltr"] .first\\:-ms-34:first-child{
  margin-left: -8.5rem;
}

[dir="rtl"] .first\\:-ms-34:first-child{
  margin-right: -8.5rem;
}

[dir="ltr"] .first\\:-me-34:first-child{
  margin-right: -8.5rem;
}

[dir="rtl"] .first\\:-me-34:first-child{
  margin-left: -8.5rem;
}

[dir="ltr"] .first\\:-ms-40:first-child{
  margin-left: -10rem;
}

[dir="rtl"] .first\\:-ms-40:first-child{
  margin-right: -10rem;
}

[dir="ltr"] .first\\:-me-40:first-child{
  margin-right: -10rem;
}

[dir="rtl"] .first\\:-me-40:first-child{
  margin-left: -10rem;
}

[dir="ltr"] .first\\:-ms-42:first-child{
  margin-left: -10.5rem;
}

[dir="rtl"] .first\\:-ms-42:first-child{
  margin-right: -10.5rem;
}

[dir="ltr"] .first\\:-me-42:first-child{
  margin-right: -10.5rem;
}

[dir="rtl"] .first\\:-me-42:first-child{
  margin-left: -10.5rem;
}

[dir="ltr"] .first\\:-ms-44:first-child{
  margin-left: -11rem;
}

[dir="rtl"] .first\\:-ms-44:first-child{
  margin-right: -11rem;
}

[dir="ltr"] .first\\:-me-44:first-child{
  margin-right: -11rem;
}

[dir="rtl"] .first\\:-me-44:first-child{
  margin-left: -11rem;
}

[dir="ltr"] .first\\:-ms-48:first-child{
  margin-left: -12rem;
}

[dir="rtl"] .first\\:-ms-48:first-child{
  margin-right: -12rem;
}

[dir="ltr"] .first\\:-me-48:first-child{
  margin-right: -12rem;
}

[dir="rtl"] .first\\:-me-48:first-child{
  margin-left: -12rem;
}

[dir="ltr"] .first\\:-ms-52:first-child{
  margin-left: -13rem;
}

[dir="rtl"] .first\\:-ms-52:first-child{
  margin-right: -13rem;
}

[dir="ltr"] .first\\:-me-52:first-child{
  margin-right: -13rem;
}

[dir="rtl"] .first\\:-me-52:first-child{
  margin-left: -13rem;
}

[dir="ltr"] .first\\:-ms-54:first-child{
  margin-left: -13.5rem;
}

[dir="rtl"] .first\\:-ms-54:first-child{
  margin-right: -13.5rem;
}

[dir="ltr"] .first\\:-me-54:first-child{
  margin-right: -13.5rem;
}

[dir="rtl"] .first\\:-me-54:first-child{
  margin-left: -13.5rem;
}

[dir="ltr"] .first\\:-ms-56:first-child{
  margin-left: -14rem;
}

[dir="rtl"] .first\\:-ms-56:first-child{
  margin-right: -14rem;
}

[dir="ltr"] .first\\:-me-56:first-child{
  margin-right: -14rem;
}

[dir="rtl"] .first\\:-me-56:first-child{
  margin-left: -14rem;
}

[dir="ltr"] .first\\:-ms-60:first-child{
  margin-left: -15rem;
}

[dir="rtl"] .first\\:-ms-60:first-child{
  margin-right: -15rem;
}

[dir="ltr"] .first\\:-me-60:first-child{
  margin-right: -15rem;
}

[dir="rtl"] .first\\:-me-60:first-child{
  margin-left: -15rem;
}

[dir="ltr"] .first\\:-ms-64:first-child{
  margin-left: -16rem;
}

[dir="rtl"] .first\\:-ms-64:first-child{
  margin-right: -16rem;
}

[dir="ltr"] .first\\:-me-64:first-child{
  margin-right: -16rem;
}

[dir="rtl"] .first\\:-me-64:first-child{
  margin-left: -16rem;
}

[dir="ltr"] .first\\:-ms-68:first-child{
  margin-left: -17rem;
}

[dir="rtl"] .first\\:-ms-68:first-child{
  margin-right: -17rem;
}

[dir="ltr"] .first\\:-me-68:first-child{
  margin-right: -17rem;
}

[dir="rtl"] .first\\:-me-68:first-child{
  margin-left: -17rem;
}

[dir="ltr"] .first\\:-ms-72:first-child{
  margin-left: -18rem;
}

[dir="rtl"] .first\\:-ms-72:first-child{
  margin-right: -18rem;
}

[dir="ltr"] .first\\:-me-72:first-child{
  margin-right: -18rem;
}

[dir="rtl"] .first\\:-me-72:first-child{
  margin-left: -18rem;
}

[dir="ltr"] .first\\:-ms-74:first-child{
  margin-left: -18.5rem;
}

[dir="rtl"] .first\\:-ms-74:first-child{
  margin-right: -18.5rem;
}

[dir="ltr"] .first\\:-me-74:first-child{
  margin-right: -18.5rem;
}

[dir="rtl"] .first\\:-me-74:first-child{
  margin-left: -18.5rem;
}

[dir="ltr"] .first\\:-ms-76:first-child{
  margin-left: -19rem;
}

[dir="rtl"] .first\\:-ms-76:first-child{
  margin-right: -19rem;
}

[dir="ltr"] .first\\:-me-76:first-child{
  margin-right: -19rem;
}

[dir="rtl"] .first\\:-me-76:first-child{
  margin-left: -19rem;
}

[dir="ltr"] .first\\:-ms-78:first-child{
  margin-left: -19.5rem;
}

[dir="rtl"] .first\\:-ms-78:first-child{
  margin-right: -19.5rem;
}

[dir="ltr"] .first\\:-me-78:first-child{
  margin-right: -19.5rem;
}

[dir="rtl"] .first\\:-me-78:first-child{
  margin-left: -19.5rem;
}

[dir="ltr"] .first\\:-ms-80:first-child{
  margin-left: -20rem;
}

[dir="rtl"] .first\\:-ms-80:first-child{
  margin-right: -20rem;
}

[dir="ltr"] .first\\:-me-80:first-child{
  margin-right: -20rem;
}

[dir="rtl"] .first\\:-me-80:first-child{
  margin-left: -20rem;
}

[dir="ltr"] .first\\:-ms-82:first-child{
  margin-left: -20.5rem;
}

[dir="rtl"] .first\\:-ms-82:first-child{
  margin-right: -20.5rem;
}

[dir="ltr"] .first\\:-me-82:first-child{
  margin-right: -20.5rem;
}

[dir="rtl"] .first\\:-me-82:first-child{
  margin-left: -20.5rem;
}

[dir="ltr"] .first\\:-ms-84:first-child{
  margin-left: -21rem;
}

[dir="rtl"] .first\\:-ms-84:first-child{
  margin-right: -21rem;
}

[dir="ltr"] .first\\:-me-84:first-child{
  margin-right: -21rem;
}

[dir="rtl"] .first\\:-me-84:first-child{
  margin-left: -21rem;
}

[dir="ltr"] .first\\:-ms-88:first-child{
  margin-left: -22rem;
}

[dir="rtl"] .first\\:-ms-88:first-child{
  margin-right: -22rem;
}

[dir="ltr"] .first\\:-me-88:first-child{
  margin-right: -22rem;
}

[dir="rtl"] .first\\:-me-88:first-child{
  margin-left: -22rem;
}

[dir="ltr"] .first\\:-ms-92:first-child{
  margin-left: -23rem;
}

[dir="rtl"] .first\\:-ms-92:first-child{
  margin-right: -23rem;
}

[dir="ltr"] .first\\:-me-92:first-child{
  margin-right: -23rem;
}

[dir="rtl"] .first\\:-me-92:first-child{
  margin-left: -23rem;
}

[dir="ltr"] .first\\:-ms-96:first-child{
  margin-left: -24rem;
}

[dir="rtl"] .first\\:-ms-96:first-child{
  margin-right: -24rem;
}

[dir="ltr"] .first\\:-me-96:first-child{
  margin-right: -24rem;
}

[dir="rtl"] .first\\:-me-96:first-child{
  margin-left: -24rem;
}

[dir="ltr"] .first\\:-ms-98:first-child{
  margin-left: -24.5rem;
}

[dir="rtl"] .first\\:-ms-98:first-child{
  margin-right: -24.5rem;
}

[dir="ltr"] .first\\:-me-98:first-child{
  margin-right: -24.5rem;
}

[dir="rtl"] .first\\:-me-98:first-child{
  margin-left: -24.5rem;
}

[dir="ltr"] .first\\:-ms-100:first-child{
  margin-left: -25rem;
}

[dir="rtl"] .first\\:-ms-100:first-child{
  margin-right: -25rem;
}

[dir="ltr"] .first\\:-me-100:first-child{
  margin-right: -25rem;
}

[dir="rtl"] .first\\:-me-100:first-child{
  margin-left: -25rem;
}

[dir="ltr"] .first\\:-ms-104:first-child{
  margin-left: -26rem;
}

[dir="rtl"] .first\\:-ms-104:first-child{
  margin-right: -26rem;
}

[dir="ltr"] .first\\:-me-104:first-child{
  margin-right: -26rem;
}

[dir="rtl"] .first\\:-me-104:first-child{
  margin-left: -26rem;
}

[dir="ltr"] .first\\:-ms-112:first-child{
  margin-left: -28rem;
}

[dir="rtl"] .first\\:-ms-112:first-child{
  margin-right: -28rem;
}

[dir="ltr"] .first\\:-me-112:first-child{
  margin-right: -28rem;
}

[dir="rtl"] .first\\:-me-112:first-child{
  margin-left: -28rem;
}

[dir="ltr"] .first\\:-ms-124:first-child{
  margin-left: -31rem;
}

[dir="rtl"] .first\\:-ms-124:first-child{
  margin-right: -31rem;
}

[dir="ltr"] .first\\:-me-124:first-child{
  margin-right: -31rem;
}

[dir="rtl"] .first\\:-me-124:first-child{
  margin-left: -31rem;
}

[dir="ltr"] .first\\:-ms-128:first-child{
  margin-left: -32rem;
}

[dir="rtl"] .first\\:-ms-128:first-child{
  margin-right: -32rem;
}

[dir="ltr"] .first\\:-me-128:first-child{
  margin-right: -32rem;
}

[dir="rtl"] .first\\:-me-128:first-child{
  margin-left: -32rem;
}

[dir="ltr"] .first\\:-ms-140:first-child{
  margin-left: -35rem;
}

[dir="rtl"] .first\\:-ms-140:first-child{
  margin-right: -35rem;
}

[dir="ltr"] .first\\:-me-140:first-child{
  margin-right: -35rem;
}

[dir="rtl"] .first\\:-me-140:first-child{
  margin-left: -35rem;
}

[dir="ltr"] .first\\:-ms-152:first-child{
  margin-left: -38rem;
}

[dir="rtl"] .first\\:-ms-152:first-child{
  margin-right: -38rem;
}

[dir="ltr"] .first\\:-me-152:first-child{
  margin-right: -38rem;
}

[dir="rtl"] .first\\:-me-152:first-child{
  margin-left: -38rem;
}

[dir="ltr"] .first\\:-ms-160:first-child{
  margin-left: -40rem;
}

[dir="rtl"] .first\\:-ms-160:first-child{
  margin-right: -40rem;
}

[dir="ltr"] .first\\:-me-160:first-child{
  margin-right: -40rem;
}

[dir="rtl"] .first\\:-me-160:first-child{
  margin-left: -40rem;
}

[dir="ltr"] .first\\:-ms-162:first-child{
  margin-left: -41rem;
}

[dir="rtl"] .first\\:-ms-162:first-child{
  margin-right: -41rem;
}

[dir="ltr"] .first\\:-me-162:first-child{
  margin-right: -41rem;
}

[dir="rtl"] .first\\:-me-162:first-child{
  margin-left: -41rem;
}

[dir="ltr"] .first\\:-ms-192:first-child{
  margin-left: -48rem;
}

[dir="rtl"] .first\\:-ms-192:first-child{
  margin-right: -48rem;
}

[dir="ltr"] .first\\:-me-192:first-child{
  margin-right: -48rem;
}

[dir="rtl"] .first\\:-me-192:first-child{
  margin-left: -48rem;
}

[dir="ltr"] .first\\:-ms-208:first-child{
  margin-left: -52rem;
}

[dir="rtl"] .first\\:-ms-208:first-child{
  margin-right: -52rem;
}

[dir="ltr"] .first\\:-me-208:first-child{
  margin-right: -52rem;
}

[dir="rtl"] .first\\:-me-208:first-child{
  margin-left: -52rem;
}

[dir="ltr"] .first\\:-ms-224:first-child{
  margin-left: -56rem;
}

[dir="rtl"] .first\\:-ms-224:first-child{
  margin-right: -56rem;
}

[dir="ltr"] .first\\:-me-224:first-child{
  margin-right: -56rem;
}

[dir="rtl"] .first\\:-me-224:first-child{
  margin-left: -56rem;
}

[dir="ltr"] .first\\:-ms-256:first-child{
  margin-left: -64rem;
}

[dir="rtl"] .first\\:-ms-256:first-child{
  margin-right: -64rem;
}

[dir="ltr"] .first\\:-me-256:first-child{
  margin-right: -64rem;
}

[dir="rtl"] .first\\:-me-256:first-child{
  margin-left: -64rem;
}

[dir="ltr"] .first\\:-ms-px:first-child{
  margin-left: -1px;
}

[dir="rtl"] .first\\:-ms-px:first-child{
  margin-right: -1px;
}

[dir="ltr"] .first\\:-me-px:first-child{
  margin-right: -1px;
}

[dir="rtl"] .first\\:-me-px:first-child{
  margin-left: -1px;
}

[dir="rtl"] .start-0{
  right: 0;
}

[dir="rtl"] .end-0{
  left: 0;
}

[dir="ltr"] .end-0{
  right: 0;
}

[dir="ltr"] .start-0{
  left: 0;
}

[dir="rtl"] .start-auto{
  right: auto;
}

[dir="rtl"] .end-auto{
  left: auto;
}

[dir="ltr"] .end-auto{
  right: auto;
}

[dir="ltr"] .start-auto{
  left: auto;
}

[dir="ltr"] .rounded-e-none{
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

[dir="ltr"] .rounded-s-none{
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

[dir="rtl"] .rounded-e-none{
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

[dir="rtl"] .rounded-s-none{
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

[dir="ltr"] .rounded-e-sm{
  border-top-right-radius: .25rem;
  border-bottom-right-radius: .25rem;
}

[dir="ltr"] .rounded-s-sm{
  border-top-left-radius: .25rem;
  border-bottom-left-radius: .25rem;
}

[dir="rtl"] .rounded-e-sm{
  border-top-left-radius: .25rem;
  border-bottom-left-radius: .25rem;
}

[dir="rtl"] .rounded-s-sm{
  border-top-right-radius: .25rem;
  border-bottom-right-radius: .25rem;
}

[dir="ltr"] .rounded-e{
  border-top-right-radius: .375rem;
  border-bottom-right-radius: .375rem;
}

[dir="ltr"] .rounded-s{
  border-top-left-radius: .375rem;
  border-bottom-left-radius: .375rem;
}

[dir="rtl"] .rounded-e{
  border-top-left-radius: .375rem;
  border-bottom-left-radius: .375rem;
}

[dir="rtl"] .rounded-s{
  border-top-right-radius: .375rem;
  border-bottom-right-radius: .375rem;
}

[dir="ltr"] .rounded-e-lg{
  border-top-right-radius: .5rem;
  border-bottom-right-radius: .5rem;
}

[dir="ltr"] .rounded-s-lg{
  border-top-left-radius: .5rem;
  border-bottom-left-radius: .5rem;
}

[dir="rtl"] .rounded-e-lg{
  border-top-left-radius: .5rem;
  border-bottom-left-radius: .5rem;
}

[dir="rtl"] .rounded-s-lg{
  border-top-right-radius: .5rem;
  border-bottom-right-radius: .5rem;
}

[dir="ltr"] .rounded-e-xl{
  border-top-right-radius: .75rem;
  border-bottom-right-radius: .75rem;
}

[dir="ltr"] .rounded-s-xl{
  border-top-left-radius: .75rem;
  border-bottom-left-radius: .75rem;
}

[dir="rtl"] .rounded-e-xl{
  border-top-left-radius: .75rem;
  border-bottom-left-radius: .75rem;
}

[dir="rtl"] .rounded-s-xl{
  border-top-right-radius: .75rem;
  border-bottom-right-radius: .75rem;
}

[dir="ltr"] .rounded-e-full{
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}

[dir="ltr"] .rounded-s-full{
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}

[dir="rtl"] .rounded-e-full{
  border-top-left-radius: 9999px;
  border-bottom-left-radius: 9999px;
}

[dir="rtl"] .rounded-s-full{
  border-top-right-radius: 9999px;
  border-bottom-right-radius: 9999px;
}

[dir="ltr"] .rounded-ts-none{
  border-top-left-radius: 0;
}

[dir="ltr"] .rounded-te-none{
  border-top-right-radius: 0;
}

[dir="ltr"] .rounded-be-none{
  border-bottom-right-radius: 0;
}

[dir="ltr"] .rounded-bs-none{
  border-bottom-left-radius: 0;
}

[dir="rtl"] .rounded-te-none{
  border-top-left-radius: 0;
}

[dir="rtl"] .rounded-ts-none{
  border-top-right-radius: 0;
}

[dir="rtl"] .rounded-bs-none{
  border-bottom-right-radius: 0;
}

[dir="rtl"] .rounded-be-none{
  border-bottom-left-radius: 0;
}

[dir="ltr"] .rounded-ts-sm{
  border-top-left-radius: .25rem;
}

[dir="ltr"] .rounded-te-sm{
  border-top-right-radius: .25rem;
}

[dir="ltr"] .rounded-be-sm{
  border-bottom-right-radius: .25rem;
}

[dir="ltr"] .rounded-bs-sm{
  border-bottom-left-radius: .25rem;
}

[dir="rtl"] .rounded-te-sm{
  border-top-left-radius: .25rem;
}

[dir="rtl"] .rounded-ts-sm{
  border-top-right-radius: .25rem;
}

[dir="rtl"] .rounded-bs-sm{
  border-bottom-right-radius: .25rem;
}

[dir="rtl"] .rounded-be-sm{
  border-bottom-left-radius: .25rem;
}

[dir="ltr"] .rounded-ts{
  border-top-left-radius: .375rem;
}

[dir="ltr"] .rounded-te{
  border-top-right-radius: .375rem;
}

[dir="ltr"] .rounded-be{
  border-bottom-right-radius: .375rem;
}

[dir="ltr"] .rounded-bs{
  border-bottom-left-radius: .375rem;
}

[dir="rtl"] .rounded-te{
  border-top-left-radius: .375rem;
}

[dir="rtl"] .rounded-ts{
  border-top-right-radius: .375rem;
}

[dir="rtl"] .rounded-bs{
  border-bottom-right-radius: .375rem;
}

[dir="rtl"] .rounded-be{
  border-bottom-left-radius: .375rem;
}

[dir="ltr"] .rounded-ts-lg{
  border-top-left-radius: .5rem;
}

[dir="ltr"] .rounded-te-lg{
  border-top-right-radius: .5rem;
}

[dir="ltr"] .rounded-be-lg{
  border-bottom-right-radius: .5rem;
}

[dir="ltr"] .rounded-bs-lg{
  border-bottom-left-radius: .5rem;
}

[dir="rtl"] .rounded-te-lg{
  border-top-left-radius: .5rem;
}

[dir="rtl"] .rounded-ts-lg{
  border-top-right-radius: .5rem;
}

[dir="rtl"] .rounded-bs-lg{
  border-bottom-right-radius: .5rem;
}

[dir="rtl"] .rounded-be-lg{
  border-bottom-left-radius: .5rem;
}

[dir="ltr"] .rounded-ts-xl{
  border-top-left-radius: .75rem;
}

[dir="ltr"] .rounded-te-xl{
  border-top-right-radius: .75rem;
}

[dir="ltr"] .rounded-be-xl{
  border-bottom-right-radius: .75rem;
}

[dir="ltr"] .rounded-bs-xl{
  border-bottom-left-radius: .75rem;
}

[dir="rtl"] .rounded-te-xl{
  border-top-left-radius: .75rem;
}

[dir="rtl"] .rounded-ts-xl{
  border-top-right-radius: .75rem;
}

[dir="rtl"] .rounded-bs-xl{
  border-bottom-right-radius: .75rem;
}

[dir="rtl"] .rounded-be-xl{
  border-bottom-left-radius: .75rem;
}

[dir="ltr"] .rounded-ts-full{
  border-top-left-radius: 9999px;
}

[dir="ltr"] .rounded-te-full{
  border-top-right-radius: 9999px;
}

[dir="ltr"] .rounded-be-full{
  border-bottom-right-radius: 9999px;
}

[dir="ltr"] .rounded-bs-full{
  border-bottom-left-radius: 9999px;
}

[dir="rtl"] .rounded-te-full{
  border-top-left-radius: 9999px;
}

[dir="rtl"] .rounded-ts-full{
  border-top-right-radius: 9999px;
}

[dir="rtl"] .rounded-bs-full{
  border-bottom-right-radius: 9999px;
}

[dir="rtl"] .rounded-be-full{
  border-bottom-left-radius: 9999px;
}

[dir="ltr"] .clear-start{
  clear: left;
}

[dir="ltr"] .clear-end{
  clear: right;
}

[dir="rtl"] .clear-start{
  clear: right;
}

[dir="rtl"] .clear-end{
  clear: left;
}

[dir="rtl"] .float-start{
  float: right;
}

[dir="rtl"] .float-end{
  float: left;
}

[dir="ltr"] .float-end{
  float: right;
}

[dir="ltr"] .float-start{
  float: left;
}

[dir="ltr"] .border-e-0{
  border-right-width: 0;
}

[dir="rtl"] .border-e-0{
  border-left-width: 0;
}

[dir="ltr"] .border-s-0{
  border-left-width: 0;
}

[dir="rtl"] .border-s-0{
  border-right-width: 0;
}

[dir="ltr"] .border-e-2{
  border-right-width: 2px;
}

[dir="rtl"] .border-e-2{
  border-left-width: 2px;
}

[dir="ltr"] .border-s-2{
  border-left-width: 2px;
}

[dir="rtl"] .border-s-2{
  border-right-width: 2px;
}

[dir="ltr"] .border-e-3{
  border-right-width: 3px;
}

[dir="rtl"] .border-e-3{
  border-left-width: 3px;
}

[dir="ltr"] .border-s-3{
  border-left-width: 3px;
}

[dir="rtl"] .border-s-3{
  border-right-width: 3px;
}

[dir="ltr"] .border-e-4{
  border-right-width: 4px;
}

[dir="rtl"] .border-e-4{
  border-left-width: 4px;
}

[dir="ltr"] .border-s-4{
  border-left-width: 4px;
}

[dir="rtl"] .border-s-4{
  border-right-width: 4px;
}

[dir="ltr"] .border-e-5{
  border-right-width: 5px;
}

[dir="rtl"] .border-e-5{
  border-left-width: 5px;
}

[dir="ltr"] .border-s-5{
  border-left-width: 5px;
}

[dir="rtl"] .border-s-5{
  border-right-width: 5px;
}

[dir="ltr"] .border-e-6{
  border-right-width: 6px;
}

[dir="rtl"] .border-e-6{
  border-left-width: 6px;
}

[dir="ltr"] .border-s-6{
  border-left-width: 6px;
}

[dir="rtl"] .border-s-6{
  border-right-width: 6px;
}

[dir="ltr"] .border-e-8{
  border-right-width: 8px;
}

[dir="rtl"] .border-e-8{
  border-left-width: 8px;
}

[dir="ltr"] .border-s-8{
  border-left-width: 8px;
}

[dir="rtl"] .border-s-8{
  border-right-width: 8px;
}

[dir="ltr"] .border-e{
  border-right-width: 1px;
}

[dir="rtl"] .border-e{
  border-left-width: 1px;
}

[dir="ltr"] .border-s{
  border-left-width: 1px;
}

[dir="rtl"] .border-s{
  border-right-width: 1px;
}

[dir="ltr"] .first\\:border-e-0:first-child{
  border-right-width: 0;
}

[dir="rtl"] .first\\:border-e-0:first-child{
  border-left-width: 0;
}

[dir="ltr"] .first\\:border-s-0:first-child{
  border-left-width: 0;
}

[dir="rtl"] .first\\:border-s-0:first-child{
  border-right-width: 0;
}

[dir="ltr"] .first\\:border-e-2:first-child{
  border-right-width: 2px;
}

[dir="rtl"] .first\\:border-e-2:first-child{
  border-left-width: 2px;
}

[dir="ltr"] .first\\:border-s-2:first-child{
  border-left-width: 2px;
}

[dir="rtl"] .first\\:border-s-2:first-child{
  border-right-width: 2px;
}

[dir="ltr"] .first\\:border-e-3:first-child{
  border-right-width: 3px;
}

[dir="rtl"] .first\\:border-e-3:first-child{
  border-left-width: 3px;
}

[dir="ltr"] .first\\:border-s-3:first-child{
  border-left-width: 3px;
}

[dir="rtl"] .first\\:border-s-3:first-child{
  border-right-width: 3px;
}

[dir="ltr"] .first\\:border-e-4:first-child{
  border-right-width: 4px;
}

[dir="rtl"] .first\\:border-e-4:first-child{
  border-left-width: 4px;
}

[dir="ltr"] .first\\:border-s-4:first-child{
  border-left-width: 4px;
}

[dir="rtl"] .first\\:border-s-4:first-child{
  border-right-width: 4px;
}

[dir="ltr"] .first\\:border-e-5:first-child{
  border-right-width: 5px;
}

[dir="rtl"] .first\\:border-e-5:first-child{
  border-left-width: 5px;
}

[dir="ltr"] .first\\:border-s-5:first-child{
  border-left-width: 5px;
}

[dir="rtl"] .first\\:border-s-5:first-child{
  border-right-width: 5px;
}

[dir="ltr"] .first\\:border-e-6:first-child{
  border-right-width: 6px;
}

[dir="rtl"] .first\\:border-e-6:first-child{
  border-left-width: 6px;
}

[dir="ltr"] .first\\:border-s-6:first-child{
  border-left-width: 6px;
}

[dir="rtl"] .first\\:border-s-6:first-child{
  border-right-width: 6px;
}

[dir="ltr"] .first\\:border-e-8:first-child{
  border-right-width: 8px;
}

[dir="rtl"] .first\\:border-e-8:first-child{
  border-left-width: 8px;
}

[dir="ltr"] .first\\:border-s-8:first-child{
  border-left-width: 8px;
}

[dir="rtl"] .first\\:border-s-8:first-child{
  border-right-width: 8px;
}

[dir="ltr"] .first\\:border-e:first-child{
  border-right-width: 1px;
}

[dir="rtl"] .first\\:border-e:first-child{
  border-left-width: 1px;
}

[dir="ltr"] .first\\:border-s:first-child{
  border-left-width: 1px;
}

[dir="rtl"] .first\\:border-s:first-child{
  border-right-width: 1px;
}

[dir="rtl"] .text-start{
  text-align: right;
}

[dir="rtl"] .text-end{
  text-align: left;
}

[dir="ltr"] .text-end{
  text-align: right;
}

[dir="ltr"] .text-start{
  text-align: left;
}

[dir="ltr"] .origin-top-start{
  transform-origin: top left;
}

[dir="ltr"] .origin-top-end{
  transform-origin: top right;
}

[dir="ltr"] .origin-bottom-start{
  transform-origin: bottom left;
}

[dir="ltr"] .origin-bottom-end{
  transform-origin: bottom right;
}

[dir="ltr"] .origin-start{
  transform-origin: left;
}

[dir="ltr"] .origin-end{
  transform-origin: right;
}

[dir="rtl"] .origin-top-start{
  transform-origin: top right;
}

[dir="rtl"] .origin-top-end{
  transform-origin: top left;
}

[dir="rtl"] .origin-bottom-start{
  transform-origin: bottom right;
}

[dir="rtl"] .origin-bottom-end{
  transform-origin: bottom left;
}

[dir="rtl"] .origin-start{
  transform-origin: right;
}

[dir="rtl"] .origin-end{
  transform-origin: left;
}

[dir="ltr"] .space-s-0 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(0px * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-0 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(0px * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-0 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(0px * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(0px * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-0 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(0px * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(0px * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-0 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(0px * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-0 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(0px * (1 - var(--tw-space-s-reverse)));
}

.space-s-0 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-1 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(0.25rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-1 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(0.25rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-1 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(0.25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-1 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(0.25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-1 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-1 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-2 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(0.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-2 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(0.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-2 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(0.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-2 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(0.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-2 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-2 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-3 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(0.75rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-3 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(0.75rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-3 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-3 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(0.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-3 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-3 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-4 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(1rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-4 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(1rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-4 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(1rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(1rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-4 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(1rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(1rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-4 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(1rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-4 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(1rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-5 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(1.25rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-5 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(1.25rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-5 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(1.25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-5 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(1.25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-5 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-5 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-6 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(1.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-6 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(1.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-6 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-6 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(1.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-6 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-6 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-7 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(1.75rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-7 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(1.75rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-7 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(1.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-7 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(1.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-7 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-7 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-7 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-8 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(2rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-8 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(2rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-8 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(2rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(2rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-8 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(2rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(2rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-8 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(2rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-8 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(2rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-9 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(2.25rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-9 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(2.25rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-9 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(2.25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-9 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(2.25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-9 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-9 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-9 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-10 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(2.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-10 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(2.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-10 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(2.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-10 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(2.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-10 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-10 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-11 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(2.75rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-11 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(2.75rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-11 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(2.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-11 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(2.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-11 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-11 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-11 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-12 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(3rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-12 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(3rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-12 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(3rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(3rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-12 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(3rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(3rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-12 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(3rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-12 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(3rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-12 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-14 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(3.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-14 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(3.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-14 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(3.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-14 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(3.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-14 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-14 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-14 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-15 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(3.75rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-15 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(3.75rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-15 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(3.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-15 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(3.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-15 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-15 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-15 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-16 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(4rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-16 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(4rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-16 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(4rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(4rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-16 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(4rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(4rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-16 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(4rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-16 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(4rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-16 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-18 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(4.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-18 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(4.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-18 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(4.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-18 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(4.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-18 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-18 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-18 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-20 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-20 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-20 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-20 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-20 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-20 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(5rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-20 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-22 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(5.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-22 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(5.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-22 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(5.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-22 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(5.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-22 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-22 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-22 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-23 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(5.75rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-23 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(5.75rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-23 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(5.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-23 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(5.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-23 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-23 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-23 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-24 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(6rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-24 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(6rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-24 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(6rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(6rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-24 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(6rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(6rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-24 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(6rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-24 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(6rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-24 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-25 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(6.25rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-25 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(6.25rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-25 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(6.25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-25 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(6.25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-25 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-25 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-25 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-26 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(6.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-26 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(6.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-26 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(6.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-26 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(6.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-26 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-26 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-26 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-28 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(7rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-28 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(7rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-28 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(7rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(7rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-28 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(7rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(7rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-28 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(7rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-28 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(7rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-28 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-30 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(7.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-30 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(7.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-30 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(7.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-30 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(7.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-30 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-30 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-30 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-32 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(8rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-32 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(8rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-32 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(8rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(8rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-32 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(8rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(8rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-32 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(8rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-32 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(8rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-32 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-34 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(8.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-34 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(8.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-34 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(8.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-34 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(8.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-34 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-34 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-34 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-40 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(10rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-40 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(10rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-40 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(10rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(10rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-40 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(10rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(10rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-40 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(10rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-40 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(10rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-40 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-42 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(10.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-42 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(10.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-42 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(10.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-42 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(10.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-42 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-42 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-42 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-44 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(11rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-44 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(11rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-44 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(11rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(11rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-44 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(11rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(11rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-44 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(11rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-44 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(11rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-44 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-48 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(12rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-48 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(12rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-48 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(12rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(12rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-48 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(12rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(12rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-48 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(12rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-48 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(12rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-48 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-52 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(13rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-52 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(13rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-52 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(13rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(13rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-52 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(13rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(13rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-52 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(13rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-52 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(13rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-52 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-54 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(13.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-54 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(13.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-54 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(13.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-54 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(13.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-54 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-54 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-54 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-56 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(14rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-56 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(14rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-56 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(14rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(14rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-56 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(14rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(14rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-56 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(14rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-56 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(14rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-56 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-60 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(15rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-60 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(15rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-60 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(15rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(15rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-60 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(15rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(15rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-60 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(15rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-60 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(15rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-60 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-64 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(16rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-64 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(16rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-64 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(16rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(16rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-64 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(16rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(16rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-64 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(16rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-64 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(16rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-64 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-68 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(17rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-68 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(17rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-68 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(17rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(17rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-68 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(17rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(17rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-68 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(17rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-68 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(17rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-68 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-72 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(18rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-72 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(18rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-72 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(18rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(18rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-72 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(18rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(18rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-72 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(18rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-72 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(18rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-72 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-74 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(18.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-74 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(18.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-74 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(18.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-74 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(18.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-74 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-74 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-74 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-76 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(19rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-76 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(19rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-76 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(19rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(19rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-76 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(19rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(19rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-76 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(19rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-76 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(19rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-76 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-78 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(19.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-78 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(19.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-78 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(19.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-78 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(19.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-78 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-78 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-78 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-80 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(20rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-80 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(20rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-80 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(20rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(20rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-80 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(20rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(20rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-80 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(20rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-80 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(20rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-80 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-82 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(20.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-82 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(20.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-82 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(20.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-82 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(20.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-82 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-82 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-82 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-84 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(21rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-84 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(21rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-84 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(21rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(21rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-84 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(21rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(21rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-84 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(21rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-84 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(21rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-84 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-88 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(22rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-88 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(22rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-88 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(22rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(22rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-88 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(22rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(22rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-88 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(22rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-88 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(22rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-88 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-92 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(23rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-92 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(23rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-92 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(23rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(23rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-92 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(23rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(23rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-92 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(23rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-92 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(23rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-92 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-96 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(24rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-96 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(24rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-96 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(24rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(24rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-96 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(24rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(24rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-96 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(24rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-96 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(24rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-96 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-98 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(24.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-98 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(24.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-98 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(24.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-98 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(24.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-98 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-98 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-98 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-100 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(25rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-100 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(25rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-100 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(25rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-100 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(25rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-100 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(25rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-100 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(25rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-100 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-104 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(26rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-104 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(26rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-104 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(26rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(26rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-104 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(26rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(26rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-104 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(26rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-104 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(26rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-104 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-112 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(28rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-112 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(28rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-112 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(28rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(28rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-112 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(28rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(28rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-112 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(28rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-112 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(28rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-112 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-124 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(31rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-124 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(31rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-124 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(31rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(31rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-124 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(31rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(31rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-124 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(31rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-124 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(31rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-124 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-128 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(32rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-128 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(32rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-128 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(32rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(32rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-128 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(32rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(32rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-128 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(32rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-128 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(32rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-128 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-140 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(35rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-140 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(35rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-140 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(35rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(35rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-140 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(35rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(35rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-140 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(35rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-140 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(35rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-140 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-152 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(38rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-152 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(38rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-152 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(38rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(38rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-152 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(38rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(38rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-152 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(38rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-152 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(38rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-152 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-160 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(40rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-160 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(40rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-160 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(40rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(40rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-160 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(40rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(40rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-160 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(40rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-160 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(40rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-160 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-162 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(41rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-162 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(41rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-162 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(41rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(41rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-162 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(41rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(41rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-162 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(41rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-162 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(41rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-162 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-192 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(48rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-192 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(48rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-192 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(48rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(48rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-192 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(48rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(48rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-192 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(48rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-192 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(48rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-192 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-208 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(52rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-208 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(52rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-208 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(52rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(52rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-208 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(52rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(52rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-208 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(52rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-208 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(52rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-208 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-224 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(56rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-224 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(56rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-224 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(56rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(56rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-224 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(56rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(56rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-224 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(56rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-224 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(56rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-224 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-256 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(64rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-256 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(64rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-256 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(64rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(64rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-256 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(64rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(64rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-256 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(64rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-256 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(64rem * (1 - var(--tw-space-s-reverse)));
}

.space-s-256 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .space-s-px > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(1px * var(--tw-space-s-reverse));
}

[dir="rtl"] .space-s-px > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(1px * var(--tw-space-s-reverse));
}

[dir="ltr"] .space-s-px > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(1px * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(1px * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-px > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(1px * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(1px * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .space-s-px > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(1px * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .space-s-px > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(1px * (1 - var(--tw-space-s-reverse)));
}

.space-s-px > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-1 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-0.25rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-1 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-0.25rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-1 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-0.25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-1 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-0.25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-1 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-1 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-1 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-2 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-0.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-2 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-0.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-2 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-0.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-2 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-0.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-2 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-2 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-2 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-3 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-0.75rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-3 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-0.75rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-3 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-0.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-3 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-0.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-3 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-3 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-3 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-4 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-1rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-4 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-1rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-4 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-1rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-1rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-4 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-1rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-1rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-4 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-1rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-4 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-1rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-4 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-5 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-1.25rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-5 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-1.25rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-5 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-1.25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-5 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-1.25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-5 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-5 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-5 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-6 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-1.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-6 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-1.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-6 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-1.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-6 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-1.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-6 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-6 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-6 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-7 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-1.75rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-7 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-1.75rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-7 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-1.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-7 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-1.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-7 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-7 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-7 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-8 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-2rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-8 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-2rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-8 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-2rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-2rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-8 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-2rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-2rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-8 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-2rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-8 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-2rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-8 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-9 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-2.25rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-9 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-2.25rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-9 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-2.25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-9 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-2.25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-9 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-9 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-9 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-10 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-2.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-10 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-2.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-10 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-2.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-10 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-2.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-10 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-10 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-10 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-11 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-2.75rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-11 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-2.75rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-11 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-2.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-11 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-2.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-11 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-11 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-11 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-12 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-3rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-12 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-3rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-12 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-3rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-3rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-12 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-3rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-3rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-12 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-3rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-12 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-3rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-12 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-14 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-3.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-14 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-3.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-14 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-3.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-14 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-3.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-14 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-14 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-14 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-15 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-3.75rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-15 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-3.75rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-15 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-3.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-15 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-3.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-15 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-15 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-15 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-16 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-4rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-16 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-4rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-16 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-4rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-4rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-16 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-4rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-4rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-16 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-4rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-16 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-4rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-16 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-18 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-4.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-18 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-4.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-18 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-4.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-18 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-4.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-18 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-18 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-18 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-20 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-20 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-20 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-20 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-20 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-20 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-5rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-20 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-22 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-5.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-22 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-5.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-22 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-5.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-22 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-5.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-22 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-22 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-22 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-23 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-5.75rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-23 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-5.75rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-23 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-5.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-23 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-5.75rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-23 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-23 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-23 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-24 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-6rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-24 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-6rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-24 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-6rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-6rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-24 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-6rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-6rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-24 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-6rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-24 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-6rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-24 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-25 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-6.25rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-25 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-6.25rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-25 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-6.25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-25 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-6.25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-25 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-25 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-25 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-26 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-6.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-26 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-6.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-26 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-6.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-26 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-6.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-26 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-26 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-26 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-28 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-7rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-28 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-7rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-28 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-7rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-7rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-28 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-7rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-7rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-28 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-7rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-28 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-7rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-28 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-30 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-7.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-30 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-7.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-30 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-7.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-30 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-7.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-30 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-30 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-30 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-32 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-8rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-32 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-8rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-32 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-8rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-8rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-32 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-8rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-8rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-32 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-8rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-32 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-8rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-32 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-34 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-8.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-34 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-8.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-34 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-8.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-34 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-8.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-34 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-34 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-34 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-40 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-10rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-40 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-10rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-40 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-10rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-10rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-40 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-10rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-10rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-40 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-10rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-40 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-10rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-40 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-42 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-10.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-42 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-10.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-42 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-10.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-42 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-10.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-42 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-42 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-42 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-44 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-11rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-44 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-11rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-44 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-11rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-11rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-44 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-11rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-11rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-44 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-11rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-44 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-11rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-44 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-48 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-12rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-48 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-12rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-48 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-12rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-12rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-48 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-12rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-12rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-48 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-12rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-48 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-12rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-48 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-52 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-13rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-52 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-13rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-52 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-13rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-13rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-52 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-13rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-13rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-52 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-13rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-52 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-13rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-52 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-54 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-13.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-54 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-13.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-54 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-13.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-54 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-13.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-54 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-54 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-54 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-56 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-14rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-56 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-14rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-56 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-14rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-14rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-56 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-14rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-14rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-56 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-14rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-56 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-14rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-56 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-60 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-15rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-60 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-15rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-60 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-15rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-15rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-60 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-15rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-15rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-60 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-15rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-60 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-15rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-60 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-64 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-16rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-64 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-16rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-64 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-16rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-16rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-64 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-16rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-16rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-64 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-16rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-64 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-16rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-64 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-68 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-17rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-68 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-17rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-68 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-17rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-17rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-68 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-17rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-17rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-68 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-17rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-68 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-17rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-68 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-72 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-18rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-72 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-18rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-72 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-18rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-18rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-72 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-18rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-18rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-72 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-18rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-72 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-18rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-72 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-74 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-18.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-74 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-18.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-74 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-18.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-74 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-18.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-74 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-74 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-74 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-76 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-19rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-76 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-19rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-76 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-19rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-19rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-76 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-19rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-19rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-76 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-19rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-76 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-19rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-76 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-78 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-19.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-78 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-19.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-78 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-19.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-78 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-19.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-78 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-78 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-78 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-80 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-20rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-80 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-20rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-80 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-20rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-20rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-80 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-20rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-20rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-80 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-20rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-80 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-20rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-80 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-82 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-20.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-82 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-20.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-82 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-20.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-82 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-20.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-82 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-82 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-82 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-84 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-21rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-84 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-21rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-84 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-21rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-21rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-84 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-21rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-21rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-84 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-21rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-84 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-21rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-84 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-88 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-22rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-88 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-22rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-88 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-22rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-22rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-88 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-22rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-22rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-88 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-22rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-88 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-22rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-88 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-92 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-23rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-92 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-23rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-92 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-23rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-23rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-92 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-23rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-23rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-92 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-23rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-92 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-23rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-92 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-96 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-24rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-96 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-24rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-96 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-24rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-24rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-96 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-24rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-24rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-96 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-24rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-96 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-24rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-96 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-98 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-24.5rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-98 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-24.5rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-98 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-24.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-98 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-24.5rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-98 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-98 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-98 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-100 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-25rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-100 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-25rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-100 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-25rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-100 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-25rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-25rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-100 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-25rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-100 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-25rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-100 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-104 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-26rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-104 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-26rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-104 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-26rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-26rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-104 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-26rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-26rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-104 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-26rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-104 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-26rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-104 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-112 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-28rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-112 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-28rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-112 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-28rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-28rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-112 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-28rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-28rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-112 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-28rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-112 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-28rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-112 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-124 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-31rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-124 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-31rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-124 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-31rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-31rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-124 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-31rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-31rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-124 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-31rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-124 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-31rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-124 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-128 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-32rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-128 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-32rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-128 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-32rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-32rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-128 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-32rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-32rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-128 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-32rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-128 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-32rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-128 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-140 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-35rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-140 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-35rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-140 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-35rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-35rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-140 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-35rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-35rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-140 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-35rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-140 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-35rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-140 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-152 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-38rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-152 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-38rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-152 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-38rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-38rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-152 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-38rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-38rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-152 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-38rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-152 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-38rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-152 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-160 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-40rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-160 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-40rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-160 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-40rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-40rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-160 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-40rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-40rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-160 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-40rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-160 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-40rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-160 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-162 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-41rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-162 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-41rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-162 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-41rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-41rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-162 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-41rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-41rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-162 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-41rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-162 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-41rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-162 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-192 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-48rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-192 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-48rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-192 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-48rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-48rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-192 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-48rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-48rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-192 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-48rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-192 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-48rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-192 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-208 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-52rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-208 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-52rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-208 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-52rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-52rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-208 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-52rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-52rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-208 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-52rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-208 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-52rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-208 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-224 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-56rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-224 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-56rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-224 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-56rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-56rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-224 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-56rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-56rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-224 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-56rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-224 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-56rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-224 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-256 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-64rem * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-256 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-64rem * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-256 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-64rem * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-64rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-256 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-64rem * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-64rem * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-256 > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-64rem * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-256 > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-64rem * (1 - var(--tw-space-s-reverse)));
}

.-space-s-256 > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

[dir="ltr"] .-space-s-px > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-1px * var(--tw-space-s-reverse));
}

[dir="rtl"] .-space-s-px > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-1px * var(--tw-space-s-reverse));
}

[dir="ltr"] .-space-s-px > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-1px * (1 - var(--tw-space-s-reverse)));
  margin-left: calc(-1px * calc(1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-px > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-1px * (1 - var(--tw-space-s-reverse)));
  margin-right: calc(-1px * calc(1 - var(--tw-space-s-reverse)));
}

[dir="ltr"] .-space-s-px > :not([hidden]) ~ :not([hidden]){
  margin-left: calc(-1px * (1 - var(--tw-space-s-reverse)));
}

[dir="rtl"] .-space-s-px > :not([hidden]) ~ :not([hidden]){
  margin-right: calc(-1px * (1 - var(--tw-space-s-reverse)));
}

.-space-s-px > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 0;
}

.space-s-reverse > :not([hidden]) ~ :not([hidden]){
  --tw-space-s-reverse: 1;
}

[dir="ltr"] .divide-s-0 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(0px * var(--tw-divide-s-reverse));
}

[dir="rtl"] .divide-s-0 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(0px * var(--tw-divide-s-reverse));
}

[dir="ltr"] .divide-s-0 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(0px * (1 - var(--tw-divide-s-reverse)));
  border-left-width: calc(0px * calc(1 - var(--tw-divide-s-reverse)));
}

[dir="rtl"] .divide-s-0 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(0px * (1 - var(--tw-divide-s-reverse)));
  border-right-width: calc(0px * calc(1 - var(--tw-divide-s-reverse)));
}

[dir="ltr"] .divide-s-0 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(0px * (1 - var(--tw-divide-s-reverse)));
}

[dir="rtl"] .divide-s-0 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(0px * (1 - var(--tw-divide-s-reverse)));
}

.divide-s-0 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-s-reverse: 0;
}

[dir="ltr"] .divide-s-2 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(2px * var(--tw-divide-s-reverse));
}

[dir="rtl"] .divide-s-2 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(2px * var(--tw-divide-s-reverse));
}

[dir="ltr"] .divide-s-2 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(2px * (1 - var(--tw-divide-s-reverse)));
  border-left-width: calc(2px * calc(1 - var(--tw-divide-s-reverse)));
}

[dir="rtl"] .divide-s-2 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(2px * (1 - var(--tw-divide-s-reverse)));
  border-right-width: calc(2px * calc(1 - var(--tw-divide-s-reverse)));
}

[dir="ltr"] .divide-s-2 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(2px * (1 - var(--tw-divide-s-reverse)));
}

[dir="rtl"] .divide-s-2 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(2px * (1 - var(--tw-divide-s-reverse)));
}

.divide-s-2 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-s-reverse: 0;
}

[dir="ltr"] .divide-s-3 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(3px * var(--tw-divide-s-reverse));
}

[dir="rtl"] .divide-s-3 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(3px * var(--tw-divide-s-reverse));
}

[dir="ltr"] .divide-s-3 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(3px * (1 - var(--tw-divide-s-reverse)));
  border-left-width: calc(3px * calc(1 - var(--tw-divide-s-reverse)));
}

[dir="rtl"] .divide-s-3 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(3px * (1 - var(--tw-divide-s-reverse)));
  border-right-width: calc(3px * calc(1 - var(--tw-divide-s-reverse)));
}

[dir="ltr"] .divide-s-3 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(3px * (1 - var(--tw-divide-s-reverse)));
}

[dir="rtl"] .divide-s-3 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(3px * (1 - var(--tw-divide-s-reverse)));
}

.divide-s-3 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-s-reverse: 0;
}

[dir="ltr"] .divide-s-4 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(4px * var(--tw-divide-s-reverse));
}

[dir="rtl"] .divide-s-4 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(4px * var(--tw-divide-s-reverse));
}

[dir="ltr"] .divide-s-4 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(4px * (1 - var(--tw-divide-s-reverse)));
  border-left-width: calc(4px * calc(1 - var(--tw-divide-s-reverse)));
}

[dir="rtl"] .divide-s-4 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(4px * (1 - var(--tw-divide-s-reverse)));
  border-right-width: calc(4px * calc(1 - var(--tw-divide-s-reverse)));
}

[dir="ltr"] .divide-s-4 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(4px * (1 - var(--tw-divide-s-reverse)));
}

[dir="rtl"] .divide-s-4 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(4px * (1 - var(--tw-divide-s-reverse)));
}

.divide-s-4 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-s-reverse: 0;
}

[dir="ltr"] .divide-s-5 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(5px * var(--tw-divide-s-reverse));
}

[dir="rtl"] .divide-s-5 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(5px * var(--tw-divide-s-reverse));
}

[dir="ltr"] .divide-s-5 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(5px * (1 - var(--tw-divide-s-reverse)));
  border-left-width: calc(5px * calc(1 - var(--tw-divide-s-reverse)));
}

[dir="rtl"] .divide-s-5 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(5px * (1 - var(--tw-divide-s-reverse)));
  border-right-width: calc(5px * calc(1 - var(--tw-divide-s-reverse)));
}

[dir="ltr"] .divide-s-5 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(5px * (1 - var(--tw-divide-s-reverse)));
}

[dir="rtl"] .divide-s-5 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(5px * (1 - var(--tw-divide-s-reverse)));
}

.divide-s-5 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-s-reverse: 0;
}

[dir="ltr"] .divide-s-6 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(6px * var(--tw-divide-s-reverse));
}

[dir="rtl"] .divide-s-6 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(6px * var(--tw-divide-s-reverse));
}

[dir="ltr"] .divide-s-6 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(6px * (1 - var(--tw-divide-s-reverse)));
  border-left-width: calc(6px * calc(1 - var(--tw-divide-s-reverse)));
}

[dir="rtl"] .divide-s-6 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(6px * (1 - var(--tw-divide-s-reverse)));
  border-right-width: calc(6px * calc(1 - var(--tw-divide-s-reverse)));
}

[dir="ltr"] .divide-s-6 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(6px * (1 - var(--tw-divide-s-reverse)));
}

[dir="rtl"] .divide-s-6 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(6px * (1 - var(--tw-divide-s-reverse)));
}

.divide-s-6 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-s-reverse: 0;
}

[dir="ltr"] .divide-s-8 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(8px * var(--tw-divide-s-reverse));
}

[dir="rtl"] .divide-s-8 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(8px * var(--tw-divide-s-reverse));
}

[dir="ltr"] .divide-s-8 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(8px * (1 - var(--tw-divide-s-reverse)));
  border-left-width: calc(8px * calc(1 - var(--tw-divide-s-reverse)));
}

[dir="rtl"] .divide-s-8 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(8px * (1 - var(--tw-divide-s-reverse)));
  border-right-width: calc(8px * calc(1 - var(--tw-divide-s-reverse)));
}

[dir="ltr"] .divide-s-8 > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(8px * (1 - var(--tw-divide-s-reverse)));
}

[dir="rtl"] .divide-s-8 > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(8px * (1 - var(--tw-divide-s-reverse)));
}

.divide-s-8 > :not([hidden]) ~ :not([hidden]){
  --tw-divide-s-reverse: 0;
}

[dir="ltr"] .divide-s > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(1px * var(--tw-divide-s-reverse));
}

[dir="rtl"] .divide-s > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(1px * var(--tw-divide-s-reverse));
}

[dir="ltr"] .divide-s > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(1px * (1 - var(--tw-divide-s-reverse)));
  border-left-width: calc(1px * calc(1 - var(--tw-divide-s-reverse)));
}

[dir="rtl"] .divide-s > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(1px * (1 - var(--tw-divide-s-reverse)));
  border-right-width: calc(1px * calc(1 - var(--tw-divide-s-reverse)));
}

[dir="ltr"] .divide-s > :not([hidden]) ~ :not([hidden]){
  border-left-width: calc(1px * (1 - var(--tw-divide-s-reverse)));
}

[dir="rtl"] .divide-s > :not([hidden]) ~ :not([hidden]){
  border-right-width: calc(1px * (1 - var(--tw-divide-s-reverse)));
}

.divide-s > :not([hidden]) ~ :not([hidden]){
  --tw-divide-s-reverse: 0;
}

.divide-s-reverse > :not([hidden]) ~ :not([hidden]){
  --tw-divide-s-reverse: 1;
}

@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}

/*----------------------------------------*\\
  Visibility
\\*----------------------------------------*/

.is-hidden {
  position: absolute !important;
}

.is-hidden {
  height: 1px; width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px); /* IE6, IE7 */
  clip: rect(1px, 1px, 1px, 1px);
}

/*----------------------------------------*\\
  flags
\\*----------------------------------------*/

/* Obtained from: https://github.com/EducationLink/vue-tel-input/blob/master/src/assets/sprite.css - MIT License */

.vti__flag {
  width: 20px;
}

.vti__flag.be {
  width: 18px;
}

.vti__flag.ch {
  width: 15px;
}

.vti__flag.mc {
  width: 19px;
}

.vti__flag.ne {
  width: 18px;
}

.vti__flag.np {
  width: 13px;
}

.vti__flag.va {
  width: 15px;
}

@media only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx) {
  .vti__flag {
    background-size: 5630px 15px;
  }
}

.vti__flag.ac {
  height: 10px;
  background-position: 0px 0px;
}

.vti__flag.ad {
  height: 14px;
  background-position: -22px 0px;
}

.vti__flag.ae {
  height: 10px;
  background-position: -44px 0px;
}

.vti__flag.af {
  height: 14px;
  background-position: -66px 0px;
}

.vti__flag.ag {
  height: 14px;
  background-position: -88px 0px;
}

.vti__flag.ai {
  height: 10px;
  background-position: -110px 0px;
}

.vti__flag.al {
  height: 15px;
  background-position: -132px 0px;
}

.vti__flag.am {
  height: 10px;
  background-position: -154px 0px;
}

.vti__flag.ao {
  height: 14px;
  background-position: -176px 0px;
}

.vti__flag.aq {
  height: 14px;
  background-position: -198px 0px;
}

.vti__flag.ar {
  height: 13px;
  background-position: -220px 0px;
}

.vti__flag.as {
  height: 10px;
  background-position: -242px 0px;
}

.vti__flag.at {
  height: 14px;
  background-position: -264px 0px;
}

.vti__flag.au {
  height: 10px;
  background-position: -286px 0px;
}

.vti__flag.aw {
  height: 14px;
  background-position: -308px 0px;
}

.vti__flag.ax {
  height: 13px;
  background-position: -330px 0px;
}

.vti__flag.az {
  height: 10px;
  background-position: -352px 0px;
}

.vti__flag.ba {
  height: 10px;
  background-position: -374px 0px;
}

.vti__flag.bb {
  height: 14px;
  background-position: -396px 0px;
}

.vti__flag.bd {
  height: 12px;
  background-position: -418px 0px;
}

.vti__flag.be {
  height: 15px;
  background-position: -440px 0px;
}

.vti__flag.bf {
  height: 14px;
  background-position: -460px 0px;
}

.vti__flag.bg {
  height: 12px;
  background-position: -482px 0px;
}

.vti__flag.bh {
  height: 12px;
  background-position: -504px 0px;
}

.vti__flag.bi {
  height: 12px;
  background-position: -526px 0px;
}

.vti__flag.bj {
  height: 14px;
  background-position: -548px 0px;
}

.vti__flag.bl {
  height: 14px;
  background-position: -570px 0px;
}

.vti__flag.bm {
  height: 10px;
  background-position: -592px 0px;
}

.vti__flag.bn {
  height: 10px;
  background-position: -614px 0px;
}

.vti__flag.bo {
  height: 14px;
  background-position: -636px 0px;
}

.vti__flag.bq {
  height: 14px;
  background-position: -658px 0px;
}

.vti__flag.br {
  height: 14px;
  background-position: -680px 0px;
}

.vti__flag.bs {
  height: 10px;
  background-position: -702px 0px;
}

.vti__flag.bt {
  height: 14px;
  background-position: -724px 0px;
}

.vti__flag.bv {
  height: 15px;
  background-position: -746px 0px;
}

.vti__flag.bw {
  height: 14px;
  background-position: -768px 0px;
}

.vti__flag.by {
  height: 10px;
  background-position: -790px 0px;
}

.vti__flag.bz {
  height: 14px;
  background-position: -812px 0px;
}

.vti__flag.ca {
  height: 10px;
  background-position: -834px 0px;
}

.vti__flag.cc {
  height: 10px;
  background-position: -856px 0px;
}

.vti__flag.cd {
  height: 15px;
  background-position: -878px 0px;
}

.vti__flag.cf {
  height: 14px;
  background-position: -900px 0px;
}

.vti__flag.cg {
  height: 14px;
  background-position: -922px 0px;
}

.vti__flag.ch {
  height: 15px;
  background-position: -944px 0px;
}

.vti__flag.ci {
  height: 14px;
  background-position: -961px 0px;
}

.vti__flag.ck {
  height: 10px;
  background-position: -983px 0px;
}

.vti__flag.cl {
  height: 14px;
  background-position: -1005px 0px;
}

.vti__flag.cm {
  height: 14px;
  background-position: -1027px 0px;
}

.vti__flag.cn {
  height: 14px;
  background-position: -1049px 0px;
}

.vti__flag.co {
  height: 14px;
  background-position: -1071px 0px;
}

.vti__flag.cp {
  height: 14px;
  background-position: -1093px 0px;
}

.vti__flag.cr {
  height: 12px;
  background-position: -1115px 0px;
}

.vti__flag.cu {
  height: 10px;
  background-position: -1137px 0px;
}

.vti__flag.cv {
  height: 12px;
  background-position: -1159px 0px;
}

.vti__flag.cw {
  height: 14px;
  background-position: -1181px 0px;
}

.vti__flag.cx {
  height: 10px;
  background-position: -1203px 0px;
}

.vti__flag.cy {
  height: 14px;
  background-position: -1225px 0px;
}

.vti__flag.cz {
  height: 14px;
  background-position: -1247px 0px;
}

.vti__flag.de {
  height: 12px;
  background-position: -1269px 0px;
}

.vti__flag.dg {
  height: 10px;
  background-position: -1291px 0px;
}

.vti__flag.dj {
  height: 14px;
  background-position: -1313px 0px;
}

.vti__flag.dk {
  height: 15px;
  background-position: -1335px 0px;
}

.vti__flag.dm {
  height: 10px;
  background-position: -1357px 0px;
}

.vti__flag.do {
  height: 13px;
  background-position: -1379px 0px;
}

.vti__flag.dz {
  height: 14px;
  background-position: -1401px 0px;
}

.vti__flag.ea {
  height: 14px;
  background-position: -1423px 0px;
}

.vti__flag.ec {
  height: 14px;
  background-position: -1445px 0px;
}

.vti__flag.ee {
  height: 13px;
  background-position: -1467px 0px;
}

.vti__flag.eg {
  height: 14px;
  background-position: -1489px 0px;
}

.vti__flag.eh {
  height: 10px;
  background-position: -1511px 0px;
}

.vti__flag.er {
  height: 10px;
  background-position: -1533px 0px;
}

.vti__flag.es {
  height: 14px;
  background-position: -1555px 0px;
}

.vti__flag.et {
  height: 10px;
  background-position: -1577px 0px;
}

.vti__flag.eu {
  height: 14px;
  background-position: -1599px 0px;
}

.vti__flag.fi {
  height: 12px;
  background-position: -1621px 0px;
}

.vti__flag.fj {
  height: 10px;
  background-position: -1643px 0px;
}

.vti__flag.fk {
  height: 10px;
  background-position: -1665px 0px;
}

.vti__flag.fm {
  height: 11px;
  background-position: -1687px 0px;
}

.vti__flag.fo {
  height: 15px;
  background-position: -1709px 0px;
}

.vti__flag.fr {
  height: 14px;
  background-position: -1731px 0px;
}

.vti__flag.ga {
  height: 15px;
  background-position: -1753px 0px;
}

.vti__flag.gb {
  height: 10px;
  background-position: -1775px 0px;
}

.vti__flag.gd {
  height: 12px;
  background-position: -1797px 0px;
}

.vti__flag.ge {
  height: 14px;
  background-position: -1819px 0px;
}

.vti__flag.gf {
  height: 14px;
  background-position: -1841px 0px;
}

.vti__flag.gg {
  height: 14px;
  background-position: -1863px 0px;
}

.vti__flag.gh {
  height: 14px;
  background-position: -1885px 0px;
}

.vti__flag.gi {
  height: 10px;
  background-position: -1907px 0px;
}

.vti__flag.gl {
  height: 14px;
  background-position: -1929px 0px;
}

.vti__flag.gm {
  height: 14px;
  background-position: -1951px 0px;
}

.vti__flag.gn {
  height: 14px;
  background-position: -1973px 0px;
}

.vti__flag.gp {
  height: 14px;
  background-position: -1995px 0px;
}

.vti__flag.gq {
  height: 14px;
  background-position: -2017px 0px;
}

.vti__flag.gr {
  height: 14px;
  background-position: -2039px 0px;
}

.vti__flag.gs {
  height: 10px;
  background-position: -2061px 0px;
}

.vti__flag.gt {
  height: 13px;
  background-position: -2083px 0px;
}

.vti__flag.gu {
  height: 11px;
  background-position: -2105px 0px;
}

.vti__flag.gw {
  height: 10px;
  background-position: -2127px 0px;
}

.vti__flag.gy {
  height: 12px;
  background-position: -2149px 0px;
}

.vti__flag.hk {
  height: 14px;
  background-position: -2171px 0px;
}

.vti__flag.hm {
  height: 10px;
  background-position: -2193px 0px;
}

.vti__flag.hn {
  height: 10px;
  background-position: -2215px 0px;
}

.vti__flag.hr {
  height: 10px;
  background-position: -2237px 0px;
}

.vti__flag.ht {
  height: 12px;
  background-position: -2259px 0px;
}

.vti__flag.hu {
  height: 10px;
  background-position: -2281px 0px;
}

.vti__flag.ic {
  height: 14px;
  background-position: -2303px 0px;
}

.vti__flag.id {
  height: 14px;
  background-position: -2325px 0px;
}

.vti__flag.ie {
  height: 10px;
  background-position: -2347px 0px;
}

.vti__flag.il {
  height: 15px;
  background-position: -2369px 0px;
}

.vti__flag.im {
  height: 10px;
  background-position: -2391px 0px;
}

.vti__flag.in {
  height: 14px;
  background-position: -2413px 0px;
}

.vti__flag.io {
  height: 10px;
  background-position: -2435px 0px;
}

.vti__flag.iq {
  height: 14px;
  background-position: -2457px 0px;
}

.vti__flag.ir {
  height: 12px;
  background-position: -2479px 0px;
}

.vti__flag.is {
  height: 15px;
  background-position: -2501px 0px;
}

.vti__flag.it {
  height: 14px;
  background-position: -2523px 0px;
}

.vti__flag.je {
  height: 12px;
  background-position: -2545px 0px;
}

.vti__flag.jm {
  height: 10px;
  background-position: -2567px 0px;
}

.vti__flag.jo {
  height: 10px;
  background-position: -2589px 0px;
}

.vti__flag.jp {
  height: 14px;
  background-position: -2611px 0px;
}

.vti__flag.ke {
  height: 14px;
  background-position: -2633px 0px;
}

.vti__flag.kg {
  height: 12px;
  background-position: -2655px 0px;
}

.vti__flag.kh {
  height: 13px;
  background-position: -2677px 0px;
}

.vti__flag.ki {
  height: 10px;
  background-position: -2699px 0px;
}

.vti__flag.km {
  height: 12px;
  background-position: -2721px 0px;
}

.vti__flag.kn {
  height: 14px;
  background-position: -2743px 0px;
}

.vti__flag.kp {
  height: 10px;
  background-position: -2765px 0px;
}

.vti__flag.kr {
  height: 14px;
  background-position: -2787px 0px;
}

.vti__flag.kw {
  height: 10px;
  background-position: -2809px 0px;
}

.vti__flag.ky {
  height: 10px;
  background-position: -2831px 0px;
}

.vti__flag.kz {
  height: 10px;
  background-position: -2853px 0px;
}

.vti__flag.la {
  height: 14px;
  background-position: -2875px 0px;
}

.vti__flag.lb {
  height: 14px;
  background-position: -2897px 0px;
}

.vti__flag.lc {
  height: 10px;
  background-position: -2919px 0px;
}

.vti__flag.li {
  height: 12px;
  background-position: -2941px 0px;
}

.vti__flag.lk {
  height: 10px;
  background-position: -2963px 0px;
}

.vti__flag.lr {
  height: 11px;
  background-position: -2985px 0px;
}

.vti__flag.ls {
  height: 14px;
  background-position: -3007px 0px;
}

.vti__flag.lt {
  height: 12px;
  background-position: -3029px 0px;
}

.vti__flag.lu {
  height: 12px;
  background-position: -3051px 0px;
}

.vti__flag.lv {
  height: 10px;
  background-position: -3073px 0px;
}

.vti__flag.ly {
  height: 10px;
  background-position: -3095px 0px;
}

.vti__flag.ma {
  height: 14px;
  background-position: -3117px 0px;
}

.vti__flag.mc {
  height: 15px;
  background-position: -3139px 0px;
}

.vti__flag.md {
  height: 10px;
  background-position: -3160px 0px;
}

.vti__flag.me {
  height: 10px;
  background-position: -3182px 0px;
}

.vti__flag.mf {
  height: 14px;
  background-position: -3204px 0px;
}

.vti__flag.mg {
  height: 14px;
  background-position: -3226px 0px;
}

.vti__flag.mh {
  height: 11px;
  background-position: -3248px 0px;
}

.vti__flag.mk {
  height: 10px;
  background-position: -3270px 0px;
}

.vti__flag.ml {
  height: 14px;
  background-position: -3292px 0px;
}

.vti__flag.mm {
  height: 14px;
  background-position: -3314px 0px;
}

.vti__flag.mn {
  height: 10px;
  background-position: -3336px 0px;
}

.vti__flag.mo {
  height: 14px;
  background-position: -3358px 0px;
}

.vti__flag.mp {
  height: 10px;
  background-position: -3380px 0px;
}

.vti__flag.mq {
  height: 14px;
  background-position: -3402px 0px;
}

.vti__flag.mr {
  height: 14px;
  background-position: -3424px 0px;
}

.vti__flag.ms {
  height: 10px;
  background-position: -3446px 0px;
}

.vti__flag.mt {
  height: 14px;
  background-position: -3468px 0px;
}

.vti__flag.mu {
  height: 14px;
  background-position: -3490px 0px;
}

.vti__flag.mv {
  height: 14px;
  background-position: -3512px 0px;
}

.vti__flag.mw {
  height: 14px;
  background-position: -3534px 0px;
}

.vti__flag.mx {
  height: 12px;
  background-position: -3556px 0px;
}

.vti__flag.my {
  height: 10px;
  background-position: -3578px 0px;
}

.vti__flag.mz {
  height: 14px;
  background-position: -3600px 0px;
}

.vti__flag.na {
  height: 14px;
  background-position: -3622px 0px;
}

.vti__flag.nc {
  height: 10px;
  background-position: -3644px 0px;
}

.vti__flag.ne {
  height: 15px;
  background-position: -3666px 0px;
}

.vti__flag.nf {
  height: 10px;
  background-position: -3686px 0px;
}

.vti__flag.ng {
  height: 10px;
  background-position: -3708px 0px;
}

.vti__flag.ni {
  height: 12px;
  background-position: -3730px 0px;
}

.vti__flag.nl {
  height: 14px;
  background-position: -3752px 0px;
}

.vti__flag.no {
  height: 15px;
  background-position: -3774px 0px;
}

.vti__flag.np {
  height: 15px;
  background-position: -3796px 0px;
}

.vti__flag.nr {
  height: 10px;
  background-position: -3811px 0px;
}

.vti__flag.nu {
  height: 10px;
  background-position: -3833px 0px;
}

.vti__flag.nz {
  height: 10px;
  background-position: -3855px 0px;
}

.vti__flag.om {
  height: 10px;
  background-position: -3877px 0px;
}

.vti__flag.pa {
  height: 14px;
  background-position: -3899px 0px;
}

.vti__flag.pe {
  height: 14px;
  background-position: -3921px 0px;
}

.vti__flag.pf {
  height: 14px;
  background-position: -3943px 0px;
}

.vti__flag.pg {
  height: 15px;
  background-position: -3965px 0px;
}

.vti__flag.ph {
  height: 10px;
  background-position: -3987px 0px;
}

.vti__flag.pk {
  height: 14px;
  background-position: -4009px 0px;
}

.vti__flag.pl {
  height: 13px;
  background-position: -4031px 0px;
}

.vti__flag.pm {
  height: 14px;
  background-position: -4053px 0px;
}

.vti__flag.pn {
  height: 10px;
  background-position: -4075px 0px;
}

.vti__flag.pr {
  height: 14px;
  background-position: -4097px 0px;
}

.vti__flag.ps {
  height: 10px;
  background-position: -4119px 0px;
}

.vti__flag.pt {
  height: 14px;
  background-position: -4141px 0px;
}

.vti__flag.pw {
  height: 13px;
  background-position: -4163px 0px;
}

.vti__flag.py {
  height: 11px;
  background-position: -4185px 0px;
}

.vti__flag.qa {
  height: 8px;
  background-position: -4207px 0px;
}

.vti__flag.re {
  height: 14px;
  background-position: -4229px 0px;
}

.vti__flag.ro {
  height: 14px;
  background-position: -4251px 0px;
}

.vti__flag.rs {
  height: 14px;
  background-position: -4273px 0px;
}

.vti__flag.ru {
  height: 14px;
  background-position: -4295px 0px;
}

.vti__flag.rw {
  height: 14px;
  background-position: -4317px 0px;
}

.vti__flag.sa {
  height: 14px;
  background-position: -4339px 0px;
}

.vti__flag.sb {
  height: 10px;
  background-position: -4361px 0px;
}

.vti__flag.sc {
  height: 10px;
  background-position: -4383px 0px;
}

.vti__flag.sd {
  height: 10px;
  background-position: -4405px 0px;
}

.vti__flag.se {
  height: 13px;
  background-position: -4427px 0px;
}

.vti__flag.sg {
  height: 14px;
  background-position: -4449px 0px;
}

.vti__flag.sh {
  height: 10px;
  background-position: -4471px 0px;
}

.vti__flag.si {
  height: 10px;
  background-position: -4493px 0px;
}

.vti__flag.sj {
  height: 15px;
  background-position: -4515px 0px;
}

.vti__flag.sk {
  height: 14px;
  background-position: -4537px 0px;
}

.vti__flag.sl {
  height: 14px;
  background-position: -4559px 0px;
}

.vti__flag.sm {
  height: 15px;
  background-position: -4581px 0px;
}

.vti__flag.sn {
  height: 14px;
  background-position: -4603px 0px;
}

.vti__flag.so {
  height: 14px;
  background-position: -4625px 0px;
}

.vti__flag.sr {
  height: 14px;
  background-position: -4647px 0px;
}

.vti__flag.ss {
  height: 10px;
  background-position: -4669px 0px;
}

.vti__flag.st {
  height: 10px;
  background-position: -4691px 0px;
}

.vti__flag.sv {
  height: 12px;
  background-position: -4713px 0px;
}

.vti__flag.sx {
  height: 14px;
  background-position: -4735px 0px;
}

.vti__flag.sy {
  height: 14px;
  background-position: -4757px 0px;
}

.vti__flag.sz {
  height: 14px;
  background-position: -4779px 0px;
}

.vti__flag.ta {
  height: 10px;
  background-position: -4801px 0px;
}

.vti__flag.tc {
  height: 10px;
  background-position: -4823px 0px;
}

.vti__flag.td {
  height: 14px;
  background-position: -4845px 0px;
}

.vti__flag.tf {
  height: 14px;
  background-position: -4867px 0px;
}

.vti__flag.tg {
  height: 13px;
  background-position: -4889px 0px;
}

.vti__flag.th {
  height: 14px;
  background-position: -4911px 0px;
}

.vti__flag.tj {
  height: 10px;
  background-position: -4933px 0px;
}

.vti__flag.tk {
  height: 10px;
  background-position: -4955px 0px;
}

.vti__flag.tl {
  height: 10px;
  background-position: -4977px 0px;
}

.vti__flag.tm {
  height: 14px;
  background-position: -4999px 0px;
}

.vti__flag.tn {
  height: 14px;
  background-position: -5021px 0px;
}

.vti__flag.to {
  height: 10px;
  background-position: -5043px 0px;
}

.vti__flag.tr {
  height: 14px;
  background-position: -5065px 0px;
}

.vti__flag.tt {
  height: 12px;
  background-position: -5087px 0px;
}

.vti__flag.tv {
  height: 10px;
  background-position: -5109px 0px;
}

.vti__flag.tw {
  height: 14px;
  background-position: -5131px 0px;
}

.vti__flag.tz {
  height: 14px;
  background-position: -5153px 0px;
}

.vti__flag.ua {
  height: 14px;
  background-position: -5175px 0px;
}

.vti__flag.ug {
  height: 14px;
  background-position: -5197px 0px;
}

.vti__flag.um {
  height: 11px;
  background-position: -5219px 0px;
}

.vti__flag.us {
  height: 11px;
  background-position: -5241px 0px;
}

.vti__flag.uy {
  height: 14px;
  background-position: -5263px 0px;
}

.vti__flag.uz {
  height: 10px;
  background-position: -5285px 0px;
}

.vti__flag.va {
  height: 15px;
  background-position: -5307px 0px;
}

.vti__flag.vc {
  height: 14px;
  background-position: -5324px 0px;
}

.vti__flag.ve {
  height: 14px;
  background-position: -5346px 0px;
}

.vti__flag.vg {
  height: 10px;
  background-position: -5368px 0px;
}

.vti__flag.vi {
  height: 14px;
  background-position: -5390px 0px;
}

.vti__flag.vn {
  height: 14px;
  background-position: -5412px 0px;
}

.vti__flag.vu {
  height: 12px;
  background-position: -5434px 0px;
}

.vti__flag.wf {
  height: 14px;
  background-position: -5456px 0px;
}

.vti__flag.ws {
  height: 10px;
  background-position: -5478px 0px;
}

.vti__flag.xk {
  height: 15px;
  background-position: -5500px 0px;
}

.vti__flag.ye {
  height: 14px;
  background-position: -5522px 0px;
}

.vti__flag.yt {
  height: 14px;
  background-position: -5544px 0px;
}

.vti__flag.za {
  height: 14px;
  background-position: -5566px 0px;
}

.vti__flag.zm {
  height: 14px;
  background-position: -5588px 0px;
}

.vti__flag.zw {
  height: 10px;
  background-position: -5610px 0px;
}

.vti__flag {
  margin: 0;
  width: 20px;
  height: 15px;
  box-shadow: 0px 0px 1px 0px #888;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-repeat: no-repeat;
  background-color: #dbdbdb;
  background-position: 20px 0;
}

@media only screen and (min-device-pixel-ratio: 2), only screen and (min-resolution: 192dpi), only screen and (min-resolution: 2dppx) {
  .vti__flag {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  }
}

.vti__flag.np {
  background-color: transparent;
}

/*----------------------------------------*\\
  Border
\\*----------------------------------------*/

[dir="ltr"] .end-divider{
  border-right-width: 1px;
}

[dir="rtl"] .end-divider{
  border-left-width: 1px;
}

.end-divider {
  --border-opacity: 1;
  border-color: #BFBFBF;
  border-color: rgba(191, 191, 191, var(--border-opacity));
}

[dir="ltr"] .end-divider-gradient {
  border-right: 0.125rem;
  border-style: solid;
  border-image: linear-gradient(transparent, #bfbfbf, transparent) 1 100%; /* #BFBFBF: bg-gray-300 */
}

[dir="rtl"] .end-divider-gradient {
  border-left: 0.125rem;
  border-style: solid;
  border-image: linear-gradient(transparent, #bfbfbf, transparent) 1 100%; /* #BFBFBF: bg-gray-300 */
}

/*----------------------------------------*\\
  Scrollbar
\\*----------------------------------------*/

.scrollbar {
  /* Firefox */
  scrollbar-width: auto;
  scrollbar-color: #bfbfbf transparent;
  /* Chrome Safari */
}

.scrollbar::-webkit-scrollbar-thumb {
    background: #bfbfbf;
    border-radius: 1rem;
  }

.scrollbar {
  resize: none;
}

/*----------------------------------------*\\
  Disable user select
\\*----------------------------------------*/

.disable-select {
  user-select: none; /* supported by Chrome and Opera */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
}

/*----------------------------------------*\\
  Forces a display in ltr when rtl is by default
\\*----------------------------------------*/

[dir="rtl"] .forces-ltr-if-rtl {
  direction: ltr;
}

[dir="rtl"] .forces-ltr-align-if-rtl {
  direction: ltr;
  float: right;
}

@media (min-width: 640px){
  .sm\\:prose{
    color: #4a5568;
    max-width: 65ch;
  }

  .sm\\:prose [class~="lead"]{
    color: #4a5568;
    font-size: 1.25em;
    line-height: 1.6;
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .sm\\:prose a{
    color: #1a202c;
    text-decoration: underline;
  }

  .sm\\:prose strong{
    color: #1a202c;
    font-weight: 600;
  }

  .sm\\:prose ol{
    counter-reset: list-counter;
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .sm\\:prose ol > li{
    position: relative;
    counter-increment: list-counter;
    padding-left: 1.75em;
  }

  .sm\\:prose ol > li::before{
    content: ;
    position: absolute;
    font-weight: 400;
    color: #718096;
  }

  .sm\\:prose ul > li{
    position: relative;
    padding-left: 1.75em;
  }

  .sm\\:prose ul > li::before{
    content: "";
    position: absolute;
    background-color: #cbd5e0;
    border-radius: 50%;
    width: 0.375em;
    height: 0.375em;
    top: calc(0.875em - 0.1875em);
    left: 0.25em;
  }

  .sm\\:prose hr{
    border-color: #e2e8f0;
    border-top-width: 1px;
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .sm\\:prose blockquote{
    font-weight: 500;
    font-style: italic;
    color: #1a202c;
    border-left-width: 0.25rem;
    border-left-color: #e2e8f0;
    quotes: "\\201C""\\201D""\\2018""\\2019";
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1em;
  }

  .sm\\:prose blockquote p:first-of-type::before{
    content: open-quote;
  }

  .sm\\:prose blockquote p:last-of-type::after{
    content: close-quote;
  }

  .sm\\:prose h1{
    color: #1a202c;
    font-weight: 800;
    font-size: 2.25em;
    margin-top: 0;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }

  .sm\\:prose h2{
    color: #1a202c;
    font-weight: 700;
    font-size: 1.5em;
    margin-top: 2em;
    margin-bottom: 1em;
    line-height: 1.3333333;
  }

  .sm\\:prose h3{
    color: #1a202c;
    font-weight: 600;
    font-size: 1.25em;
    margin-top: 1.6em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }

  .sm\\:prose h4{
    color: #1a202c;
    font-weight: 600;
    margin-top: 1.5em;
    margin-bottom: 0.5em;
    line-height: 1.5;
  }

  .sm\\:prose figure figcaption{
    color: #718096;
    font-size: 0.875em;
    line-height: 1.4285714;
    margin-top: 0.8571429em;
  }

  .sm\\:prose code{
    color: #1a202c;
    font-weight: 600;
    font-size: 0.875em;
  }

  .sm\\:prose code::before{
    content: "\`";
  }

  .sm\\:prose code::after{
    content: "\`";
  }

  .sm\\:prose pre{
    color: #e2e8f0;
    background-color: #2d3748;
    overflow-x: auto;
    font-size: 0.875em;
    line-height: 1.7142857;
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
    border-radius: 0.375rem;
    padding-top: 0.8571429em;
    padding-right: 1.1428571em;
    padding-bottom: 0.8571429em;
    padding-left: 1.1428571em;
  }

  .sm\\:prose pre code{
    background-color: transparent;
    border-width: 0;
    border-radius: 0;
    padding: 0;
    font-weight: 400;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
  }

  .sm\\:prose pre code::before{
    content: "";
  }

  .sm\\:prose pre code::after{
    content: "";
  }

  .sm\\:prose table{
    width: 100%;
    table-layout: auto;
    text-align: left;
    margin-top: 2em;
    margin-bottom: 2em;
    font-size: 0.875em;
    line-height: 1.7142857;
  }

  .sm\\:prose thead{
    color: #1a202c;
    font-weight: 600;
    border-bottom-width: 1px;
    border-bottom-color: #cbd5e0;
  }

  .sm\\:prose thead th{
    vertical-align: bottom;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }

  .sm\\:prose tbody tr{
    border-bottom-width: 1px;
    border-bottom-color: #e2e8f0;
  }

  .sm\\:prose tbody tr:last-child{
    border-bottom-width: 0;
  }

  .sm\\:prose tbody td{
    vertical-align: top;
    padding-top: 0.5714286em;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }

  .sm\\:prose{
    font-size: 1rem;
    line-height: 1.75;
  }

  .sm\\:prose p{
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .sm\\:prose img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .sm\\:prose video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .sm\\:prose figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .sm\\:prose figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .sm\\:prose h2 code{
    font-size: 0.875em;
  }

  .sm\\:prose h3 code{
    font-size: 0.9em;
  }

  .sm\\:prose ul{
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .sm\\:prose li{
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .sm\\:prose ol > li:before{
    left: 0;
  }

  .sm\\:prose > ul > li p{
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }

  .sm\\:prose > ul > li > *:first-child{
    margin-top: 1.25em;
  }

  .sm\\:prose > ul > li > *:last-child{
    margin-bottom: 1.25em;
  }

  .sm\\:prose > ol > li > *:first-child{
    margin-top: 1.25em;
  }

  .sm\\:prose > ol > li > *:last-child{
    margin-bottom: 1.25em;
  }

  .sm\\:prose ul ul, .sm\\:prose ul ol, .sm\\:prose ol ul, .sm\\:prose ol ol{
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }

  .sm\\:prose hr + *{
    margin-top: 0;
  }

  .sm\\:prose h2 + *{
    margin-top: 0;
  }

  .sm\\:prose h3 + *{
    margin-top: 0;
  }

  .sm\\:prose h4 + *{
    margin-top: 0;
  }

  .sm\\:prose thead th:first-child{
    padding-left: 0;
  }

  .sm\\:prose thead th:last-child{
    padding-right: 0;
  }

  .sm\\:prose tbody td:first-child{
    padding-left: 0;
  }

  .sm\\:prose tbody td:last-child{
    padding-right: 0;
  }

  .sm\\:prose > :first-child{
    margin-top: 0;
  }

  .sm\\:prose > :last-child{
    margin-bottom: 0;
  }

  .sm\\:prose-sm{
    font-size: 0.875rem;
    line-height: 1.7142857;
  }

  .sm\\:prose-sm p{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .sm\\:prose-sm [class~="lead"]{
    font-size: 1.2857143em;
    line-height: 1.5555556;
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .sm\\:prose-sm blockquote{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
    padding-left: 1.1111111em;
  }

  .sm\\:prose-sm h1{
    font-size: 2.1428571em;
    margin-top: 0;
    margin-bottom: 0.8em;
    line-height: 1.2;
  }

  .sm\\:prose-sm h2{
    font-size: 1.4285714em;
    margin-top: 1.6em;
    margin-bottom: 0.8em;
    line-height: 1.4;
  }

  .sm\\:prose-sm h3{
    font-size: 1.2857143em;
    margin-top: 1.5555556em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }

  .sm\\:prose-sm h4{
    margin-top: 1.4285714em;
    margin-bottom: 0.5714286em;
    line-height: 1.4285714;
  }

  .sm\\:prose-sm img{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .sm\\:prose-sm video{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .sm\\:prose-sm figure{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .sm\\:prose-sm figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .sm\\:prose-sm figure figcaption{
    font-size: 0.8571429em;
    line-height: 1.3333333;
    margin-top: 0.6666667em;
  }

  .sm\\:prose-sm code{
    font-size: 0.8571429em;
  }

  .sm\\:prose-sm h2 code{
    font-size: 0.9em;
  }

  .sm\\:prose-sm h3 code{
    font-size: 0.8888889em;
  }

  .sm\\:prose-sm pre{
    font-size: 0.8571429em;
    line-height: 1.6666667;
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    border-radius: 0.25rem;
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .sm\\:prose-sm ol{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .sm\\:prose-sm ul{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .sm\\:prose-sm li{
    margin-top: 0.2857143em;
    margin-bottom: 0.2857143em;
  }

  .sm\\:prose-sm ol > li{
    padding-left: 1.5714286em;
  }

  .sm\\:prose-sm ol > li:before{
    left: 0;
  }

  .sm\\:prose-sm ul > li{
    padding-left: 1.5714286em;
  }

  .sm\\:prose-sm ul > li::before{
    height: 0.3571429em;
    width: 0.3571429em;
    top: calc(0.8571429em - 0.1785714em);
    left: 0.2142857em;
  }

  .sm\\:prose-sm > ul > li p{
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }

  .sm\\:prose-sm > ul > li > *:first-child{
    margin-top: 1.1428571em;
  }

  .sm\\:prose-sm > ul > li > *:last-child{
    margin-bottom: 1.1428571em;
  }

  .sm\\:prose-sm > ol > li > *:first-child{
    margin-top: 1.1428571em;
  }

  .sm\\:prose-sm > ol > li > *:last-child{
    margin-bottom: 1.1428571em;
  }

  .sm\\:prose-sm ul ul, .sm\\:prose-sm ul ol, .sm\\:prose-sm ol ul, .sm\\:prose-sm ol ol{
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }

  .sm\\:prose-sm hr{
    margin-top: 2.8571429em;
    margin-bottom: 2.8571429em;
  }

  .sm\\:prose-sm hr + *{
    margin-top: 0;
  }

  .sm\\:prose-sm h2 + *{
    margin-top: 0;
  }

  .sm\\:prose-sm h3 + *{
    margin-top: 0;
  }

  .sm\\:prose-sm h4 + *{
    margin-top: 0;
  }

  .sm\\:prose-sm table{
    font-size: 0.8571429em;
    line-height: 1.5;
  }

  .sm\\:prose-sm thead th{
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .sm\\:prose-sm thead th:first-child{
    padding-left: 0;
  }

  .sm\\:prose-sm thead th:last-child{
    padding-right: 0;
  }

  .sm\\:prose-sm tbody td{
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .sm\\:prose-sm tbody td:first-child{
    padding-left: 0;
  }

  .sm\\:prose-sm tbody td:last-child{
    padding-right: 0;
  }

  .sm\\:prose-sm > :first-child{
    margin-top: 0;
  }

  .sm\\:prose-sm > :last-child{
    margin-bottom: 0;
  }

  .sm\\:prose-lg{
    font-size: 1.125rem;
    line-height: 1.7777778;
  }

  .sm\\:prose-lg p{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .sm\\:prose-lg [class~="lead"]{
    font-size: 1.2222222em;
    line-height: 1.4545455;
    margin-top: 1.0909091em;
    margin-bottom: 1.0909091em;
  }

  .sm\\:prose-lg blockquote{
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    padding-left: 1em;
  }

  .sm\\:prose-lg h1{
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.8333333em;
    line-height: 1;
  }

  .sm\\:prose-lg h2{
    font-size: 1.6666667em;
    margin-top: 1.8666667em;
    margin-bottom: 1.0666667em;
    line-height: 1.3333333;
  }

  .sm\\:prose-lg h3{
    font-size: 1.3333333em;
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }

  .sm\\:prose-lg h4{
    margin-top: 1.7777778em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }

  .sm\\:prose-lg img{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .sm\\:prose-lg video{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .sm\\:prose-lg figure{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .sm\\:prose-lg figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .sm\\:prose-lg figure figcaption{
    font-size: 0.8888889em;
    line-height: 1.5;
    margin-top: 1em;
  }

  .sm\\:prose-lg code{
    font-size: 0.8888889em;
  }

  .sm\\:prose-lg h2 code{
    font-size: 0.8666667em;
  }

  .sm\\:prose-lg h3 code{
    font-size: 0.875em;
  }

  .sm\\:prose-lg pre{
    font-size: 0.8888889em;
    line-height: 1.75;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.375rem;
    padding-top: 1em;
    padding-right: 1.5em;
    padding-bottom: 1em;
    padding-left: 1.5em;
  }

  .sm\\:prose-lg ol{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .sm\\:prose-lg ul{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .sm\\:prose-lg li{
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }

  .sm\\:prose-lg ol > li{
    padding-left: 1.6666667em;
  }

  .sm\\:prose-lg ol > li:before{
    left: 0;
  }

  .sm\\:prose-lg ul > li{
    padding-left: 1.6666667em;
  }

  .sm\\:prose-lg ul > li::before{
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8888889em - 0.1666667em);
    left: 0.2222222em;
  }

  .sm\\:prose-lg > ul > li p{
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .sm\\:prose-lg > ul > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .sm\\:prose-lg > ul > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .sm\\:prose-lg > ol > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .sm\\:prose-lg > ol > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .sm\\:prose-lg ul ul, .sm\\:prose-lg ul ol, .sm\\:prose-lg ol ul, .sm\\:prose-lg ol ol{
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .sm\\:prose-lg hr{
    margin-top: 3.1111111em;
    margin-bottom: 3.1111111em;
  }

  .sm\\:prose-lg hr + *{
    margin-top: 0;
  }

  .sm\\:prose-lg h2 + *{
    margin-top: 0;
  }

  .sm\\:prose-lg h3 + *{
    margin-top: 0;
  }

  .sm\\:prose-lg h4 + *{
    margin-top: 0;
  }

  .sm\\:prose-lg table{
    font-size: 0.8888889em;
    line-height: 1.5;
  }

  .sm\\:prose-lg thead th{
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }

  .sm\\:prose-lg thead th:first-child{
    padding-left: 0;
  }

  .sm\\:prose-lg thead th:last-child{
    padding-right: 0;
  }

  .sm\\:prose-lg tbody td{
    padding-top: 0.75em;
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }

  .sm\\:prose-lg tbody td:first-child{
    padding-left: 0;
  }

  .sm\\:prose-lg tbody td:last-child{
    padding-right: 0;
  }

  .sm\\:prose-lg > :first-child{
    margin-top: 0;
  }

  .sm\\:prose-lg > :last-child{
    margin-bottom: 0;
  }

  .sm\\:prose-xl{
    font-size: 1.25rem;
    line-height: 1.8;
  }

  .sm\\:prose-xl p{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .sm\\:prose-xl [class~="lead"]{
    font-size: 1.2em;
    line-height: 1.5;
    margin-top: 1em;
    margin-bottom: 1em;
  }

  .sm\\:prose-xl blockquote{
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1.0666667em;
  }

  .sm\\:prose-xl h1{
    font-size: 2.8em;
    margin-top: 0;
    margin-bottom: 0.8571429em;
    line-height: 1;
  }

  .sm\\:prose-xl h2{
    font-size: 1.8em;
    margin-top: 1.5555556em;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }

  .sm\\:prose-xl h3{
    font-size: 1.5em;
    margin-top: 1.6em;
    margin-bottom: 0.6666667em;
    line-height: 1.3333333;
  }

  .sm\\:prose-xl h4{
    margin-top: 1.8em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }

  .sm\\:prose-xl img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .sm\\:prose-xl video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .sm\\:prose-xl figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .sm\\:prose-xl figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .sm\\:prose-xl figure figcaption{
    font-size: 0.9em;
    line-height: 1.5555556;
    margin-top: 1em;
  }

  .sm\\:prose-xl code{
    font-size: 0.9em;
  }

  .sm\\:prose-xl h2 code{
    font-size: 0.8611111em;
  }

  .sm\\:prose-xl h3 code{
    font-size: 0.9em;
  }

  .sm\\:prose-xl pre{
    font-size: 0.9em;
    line-height: 1.7777778;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.1111111em;
    padding-right: 1.3333333em;
    padding-bottom: 1.1111111em;
    padding-left: 1.3333333em;
  }

  .sm\\:prose-xl ol{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .sm\\:prose-xl ul{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .sm\\:prose-xl li{
    margin-top: 0.6em;
    margin-bottom: 0.6em;
  }

  .sm\\:prose-xl ol > li{
    padding-left: 1.8em;
  }

  .sm\\:prose-xl ol > li:before{
    left: 0;
  }

  .sm\\:prose-xl ul > li{
    padding-left: 1.8em;
  }

  .sm\\:prose-xl ul > li::before{
    width: 0.35em;
    height: 0.35em;
    top: calc(0.9em - 0.175em);
    left: 0.25em;
  }

  .sm\\:prose-xl > ul > li p{
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }

  .sm\\:prose-xl > ul > li > *:first-child{
    margin-top: 1.2em;
  }

  .sm\\:prose-xl > ul > li > *:last-child{
    margin-bottom: 1.2em;
  }

  .sm\\:prose-xl > ol > li > *:first-child{
    margin-top: 1.2em;
  }

  .sm\\:prose-xl > ol > li > *:last-child{
    margin-bottom: 1.2em;
  }

  .sm\\:prose-xl ul ul, .sm\\:prose-xl ul ol, .sm\\:prose-xl ol ul, .sm\\:prose-xl ol ol{
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }

  .sm\\:prose-xl hr{
    margin-top: 2.8em;
    margin-bottom: 2.8em;
  }

  .sm\\:prose-xl hr + *{
    margin-top: 0;
  }

  .sm\\:prose-xl h2 + *{
    margin-top: 0;
  }

  .sm\\:prose-xl h3 + *{
    margin-top: 0;
  }

  .sm\\:prose-xl h4 + *{
    margin-top: 0;
  }

  .sm\\:prose-xl table{
    font-size: 0.9em;
    line-height: 1.5555556;
  }

  .sm\\:prose-xl thead th{
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }

  .sm\\:prose-xl thead th:first-child{
    padding-left: 0;
  }

  .sm\\:prose-xl thead th:last-child{
    padding-right: 0;
  }

  .sm\\:prose-xl tbody td{
    padding-top: 0.8888889em;
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }

  .sm\\:prose-xl tbody td:first-child{
    padding-left: 0;
  }

  .sm\\:prose-xl tbody td:last-child{
    padding-right: 0;
  }

  .sm\\:prose-xl > :first-child{
    margin-top: 0;
  }

  .sm\\:prose-xl > :last-child{
    margin-bottom: 0;
  }

  .sm\\:prose-2xl{
    font-size: 1.5rem;
    line-height: 1.6666667;
  }

  .sm\\:prose-2xl p{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .sm\\:prose-2xl [class~="lead"]{
    font-size: 1.25em;
    line-height: 1.4666667;
    margin-top: 1.0666667em;
    margin-bottom: 1.0666667em;
  }

  .sm\\:prose-2xl blockquote{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
    padding-left: 1.1111111em;
  }

  .sm\\:prose-2xl h1{
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.875em;
    line-height: 1;
  }

  .sm\\:prose-2xl h2{
    font-size: 2em;
    margin-top: 1.5em;
    margin-bottom: 0.8333333em;
    line-height: 1.0833333;
  }

  .sm\\:prose-2xl h3{
    font-size: 1.5em;
    margin-top: 1.5555556em;
    margin-bottom: 0.6666667em;
    line-height: 1.2222222;
  }

  .sm\\:prose-2xl h4{
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }

  .sm\\:prose-2xl img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .sm\\:prose-2xl video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .sm\\:prose-2xl figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .sm\\:prose-2xl figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .sm\\:prose-2xl figure figcaption{
    font-size: 0.8333333em;
    line-height: 1.6;
    margin-top: 1em;
  }

  .sm\\:prose-2xl code{
    font-size: 0.8333333em;
  }

  .sm\\:prose-2xl h2 code{
    font-size: 0.875em;
  }

  .sm\\:prose-2xl h3 code{
    font-size: 0.8888889em;
  }

  .sm\\:prose-2xl pre{
    font-size: 0.8333333em;
    line-height: 1.8;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.2em;
    padding-right: 1.6em;
    padding-bottom: 1.2em;
    padding-left: 1.6em;
  }

  .sm\\:prose-2xl ol{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .sm\\:prose-2xl ul{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .sm\\:prose-2xl li{
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .sm\\:prose-2xl ol > li{
    padding-left: 1.6666667em;
  }

  .sm\\:prose-2xl ol > li:before{
    left: 0;
  }

  .sm\\:prose-2xl ul > li{
    padding-left: 1.6666667em;
  }

  .sm\\:prose-2xl ul > li::before{
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8333333em - 0.1666667em);
    left: 0.25em;
  }

  .sm\\:prose-2xl > ul > li p{
    margin-top: 0.8333333em;
    margin-bottom: 0.8333333em;
  }

  .sm\\:prose-2xl > ul > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .sm\\:prose-2xl > ul > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .sm\\:prose-2xl > ol > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .sm\\:prose-2xl > ol > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .sm\\:prose-2xl ul ul, .sm\\:prose-2xl ul ol, .sm\\:prose-2xl ol ul, .sm\\:prose-2xl ol ol{
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }

  .sm\\:prose-2xl hr{
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .sm\\:prose-2xl hr + *{
    margin-top: 0;
  }

  .sm\\:prose-2xl h2 + *{
    margin-top: 0;
  }

  .sm\\:prose-2xl h3 + *{
    margin-top: 0;
  }

  .sm\\:prose-2xl h4 + *{
    margin-top: 0;
  }

  .sm\\:prose-2xl table{
    font-size: 0.8333333em;
    line-height: 1.4;
  }

  .sm\\:prose-2xl thead th{
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }

  .sm\\:prose-2xl thead th:first-child{
    padding-left: 0;
  }

  .sm\\:prose-2xl thead th:last-child{
    padding-right: 0;
  }

  .sm\\:prose-2xl tbody td{
    padding-top: 0.8em;
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }

  .sm\\:prose-2xl tbody td:first-child{
    padding-left: 0;
  }

  .sm\\:prose-2xl tbody td:last-child{
    padding-right: 0;
  }

  .sm\\:prose-2xl > :first-child{
    margin-top: 0;
  }

  .sm\\:prose-2xl > :last-child{
    margin-bottom: 0;
  }

  .sm\\:space-y-0 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0px * (1 - var(--space-y-reverse)));
    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0px * var(--space-y-reverse));
  }

  .sm\\:space-x-0 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0px * var(--space-x-reverse));
    margin-left: calc(0px * (1 - var(--space-x-reverse)));
    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--space-y-reverse));
  }

  .sm\\:space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--space-x-reverse));
    margin-left: calc(0.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--space-x-reverse));
    margin-left: calc(0.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--space-y-reverse));
  }

  .sm\\:space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--space-x-reverse));
    margin-left: calc(0.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1rem * var(--space-y-reverse));
  }

  .sm\\:space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1rem * var(--space-x-reverse));
    margin-left: calc(1rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--space-y-reverse));
  }

  .sm\\:space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--space-x-reverse));
    margin-left: calc(1.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--space-x-reverse));
    margin-left: calc(1.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-7 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.75rem * var(--space-y-reverse));
  }

  .sm\\:space-x-7 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.75rem * var(--space-x-reverse));
    margin-left: calc(1.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2rem * var(--space-y-reverse));
  }

  .sm\\:space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2rem * var(--space-x-reverse));
    margin-left: calc(2rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-9 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.25rem * var(--space-y-reverse));
  }

  .sm\\:space-x-9 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.25rem * var(--space-x-reverse));
    margin-left: calc(2.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.5rem * var(--space-x-reverse));
    margin-left: calc(2.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-11 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.75rem * var(--space-y-reverse));
  }

  .sm\\:space-x-11 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.75rem * var(--space-x-reverse));
    margin-left: calc(2.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3rem * var(--space-y-reverse));
  }

  .sm\\:space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3rem * var(--space-x-reverse));
    margin-left: calc(3rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-14 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-14 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3.5rem * var(--space-x-reverse));
    margin-left: calc(3.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-15 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.75rem * var(--space-y-reverse));
  }

  .sm\\:space-x-15 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3.75rem * var(--space-x-reverse));
    margin-left: calc(3.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(4rem * (1 - var(--space-y-reverse)));
    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(4rem * var(--space-y-reverse));
  }

  .sm\\:space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(4rem * var(--space-x-reverse));
    margin-left: calc(4rem * (1 - var(--space-x-reverse)));
    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-18 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(4.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(4.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(4.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-18 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(4.5rem * var(--space-x-reverse));
    margin-left: calc(4.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(4.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5rem * var(--space-x-reverse));
    margin-left: calc(5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-22 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-22 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5.5rem * var(--space-x-reverse));
    margin-left: calc(5.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-23 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5.75rem * var(--space-y-reverse));
  }

  .sm\\:space-x-23 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5.75rem * var(--space-x-reverse));
    margin-left: calc(5.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5.75rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6rem * var(--space-y-reverse));
  }

  .sm\\:space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6rem * var(--space-x-reverse));
    margin-left: calc(6rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-25 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6.25rem * var(--space-y-reverse));
  }

  .sm\\:space-x-25 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6.25rem * var(--space-x-reverse));
    margin-left: calc(6.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6.25rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-26 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-26 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6.5rem * var(--space-x-reverse));
    margin-left: calc(6.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-28 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(7rem * (1 - var(--space-y-reverse)));
    margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(7rem * var(--space-y-reverse));
  }

  .sm\\:space-x-28 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(7rem * var(--space-x-reverse));
    margin-left: calc(7rem * (1 - var(--space-x-reverse)));
    margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-30 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(7.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(7.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(7.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-30 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(7.5rem * var(--space-x-reverse));
    margin-left: calc(7.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(7.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(8rem * (1 - var(--space-y-reverse)));
    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8rem * var(--space-y-reverse));
  }

  .sm\\:space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(8rem * var(--space-x-reverse));
    margin-left: calc(8rem * (1 - var(--space-x-reverse)));
    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-34 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(8.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(8.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-34 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(8.5rem * var(--space-x-reverse));
    margin-left: calc(8.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(8.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(10rem * (1 - var(--space-y-reverse)));
    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(10rem * var(--space-y-reverse));
  }

  .sm\\:space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(10rem * var(--space-x-reverse));
    margin-left: calc(10rem * (1 - var(--space-x-reverse)));
    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-42 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(10.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(10.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(10.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-42 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(10.5rem * var(--space-x-reverse));
    margin-left: calc(10.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(10.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-44 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(11rem * (1 - var(--space-y-reverse)));
    margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(11rem * var(--space-y-reverse));
  }

  .sm\\:space-x-44 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(11rem * var(--space-x-reverse));
    margin-left: calc(11rem * (1 - var(--space-x-reverse)));
    margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(12rem * (1 - var(--space-y-reverse)));
    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(12rem * var(--space-y-reverse));
  }

  .sm\\:space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(12rem * var(--space-x-reverse));
    margin-left: calc(12rem * (1 - var(--space-x-reverse)));
    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-52 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(13rem * (1 - var(--space-y-reverse)));
    margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(13rem * var(--space-y-reverse));
  }

  .sm\\:space-x-52 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(13rem * var(--space-x-reverse));
    margin-left: calc(13rem * (1 - var(--space-x-reverse)));
    margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-54 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(13.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(13.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(13.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-54 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(13.5rem * var(--space-x-reverse));
    margin-left: calc(13.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(13.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(14rem * (1 - var(--space-y-reverse)));
    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(14rem * var(--space-y-reverse));
  }

  .sm\\:space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(14rem * var(--space-x-reverse));
    margin-left: calc(14rem * (1 - var(--space-x-reverse)));
    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-60 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(15rem * (1 - var(--space-y-reverse)));
    margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(15rem * var(--space-y-reverse));
  }

  .sm\\:space-x-60 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(15rem * var(--space-x-reverse));
    margin-left: calc(15rem * (1 - var(--space-x-reverse)));
    margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(16rem * (1 - var(--space-y-reverse)));
    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16rem * var(--space-y-reverse));
  }

  .sm\\:space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(16rem * var(--space-x-reverse));
    margin-left: calc(16rem * (1 - var(--space-x-reverse)));
    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-68 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(17rem * (1 - var(--space-y-reverse)));
    margin-top: calc(17rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(17rem * var(--space-y-reverse));
  }

  .sm\\:space-x-68 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(17rem * var(--space-x-reverse));
    margin-left: calc(17rem * (1 - var(--space-x-reverse)));
    margin-left: calc(17rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-72 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(18rem * (1 - var(--space-y-reverse)));
    margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(18rem * var(--space-y-reverse));
  }

  .sm\\:space-x-72 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(18rem * var(--space-x-reverse));
    margin-left: calc(18rem * (1 - var(--space-x-reverse)));
    margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-74 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(18.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(18.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(18.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-74 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(18.5rem * var(--space-x-reverse));
    margin-left: calc(18.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(18.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-76 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(19rem * (1 - var(--space-y-reverse)));
    margin-top: calc(19rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(19rem * var(--space-y-reverse));
  }

  .sm\\:space-x-76 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(19rem * var(--space-x-reverse));
    margin-left: calc(19rem * (1 - var(--space-x-reverse)));
    margin-left: calc(19rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-78 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(19.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(19.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(19.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-78 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(19.5rem * var(--space-x-reverse));
    margin-left: calc(19.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(19.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-80 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(20rem * (1 - var(--space-y-reverse)));
    margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20rem * var(--space-y-reverse));
  }

  .sm\\:space-x-80 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(20rem * var(--space-x-reverse));
    margin-left: calc(20rem * (1 - var(--space-x-reverse)));
    margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-82 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(20.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(20.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-82 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(20.5rem * var(--space-x-reverse));
    margin-left: calc(20.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(20.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-84 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(21rem * (1 - var(--space-y-reverse)));
    margin-top: calc(21rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(21rem * var(--space-y-reverse));
  }

  .sm\\:space-x-84 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(21rem * var(--space-x-reverse));
    margin-left: calc(21rem * (1 - var(--space-x-reverse)));
    margin-left: calc(21rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-88 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(22rem * (1 - var(--space-y-reverse)));
    margin-top: calc(22rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(22rem * var(--space-y-reverse));
  }

  .sm\\:space-x-88 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(22rem * var(--space-x-reverse));
    margin-left: calc(22rem * (1 - var(--space-x-reverse)));
    margin-left: calc(22rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-92 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(23rem * (1 - var(--space-y-reverse)));
    margin-top: calc(23rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(23rem * var(--space-y-reverse));
  }

  .sm\\:space-x-92 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(23rem * var(--space-x-reverse));
    margin-left: calc(23rem * (1 - var(--space-x-reverse)));
    margin-left: calc(23rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-96 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(24rem * (1 - var(--space-y-reverse)));
    margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(24rem * var(--space-y-reverse));
  }

  .sm\\:space-x-96 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(24rem * var(--space-x-reverse));
    margin-left: calc(24rem * (1 - var(--space-x-reverse)));
    margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-98 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(24.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(24.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(24.5rem * var(--space-y-reverse));
  }

  .sm\\:space-x-98 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(24.5rem * var(--space-x-reverse));
    margin-left: calc(24.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(24.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-100 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(25rem * var(--space-y-reverse));
  }

  .sm\\:space-x-100 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(25rem * var(--space-x-reverse));
    margin-left: calc(25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(25rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-104 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(26rem * (1 - var(--space-y-reverse)));
    margin-top: calc(26rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(26rem * var(--space-y-reverse));
  }

  .sm\\:space-x-104 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(26rem * var(--space-x-reverse));
    margin-left: calc(26rem * (1 - var(--space-x-reverse)));
    margin-left: calc(26rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-112 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(28rem * (1 - var(--space-y-reverse)));
    margin-top: calc(28rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(28rem * var(--space-y-reverse));
  }

  .sm\\:space-x-112 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(28rem * var(--space-x-reverse));
    margin-left: calc(28rem * (1 - var(--space-x-reverse)));
    margin-left: calc(28rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-124 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(31rem * (1 - var(--space-y-reverse)));
    margin-top: calc(31rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(31rem * var(--space-y-reverse));
  }

  .sm\\:space-x-124 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(31rem * var(--space-x-reverse));
    margin-left: calc(31rem * (1 - var(--space-x-reverse)));
    margin-left: calc(31rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-128 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(32rem * (1 - var(--space-y-reverse)));
    margin-top: calc(32rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(32rem * var(--space-y-reverse));
  }

  .sm\\:space-x-128 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(32rem * var(--space-x-reverse));
    margin-left: calc(32rem * (1 - var(--space-x-reverse)));
    margin-left: calc(32rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-140 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(35rem * (1 - var(--space-y-reverse)));
    margin-top: calc(35rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(35rem * var(--space-y-reverse));
  }

  .sm\\:space-x-140 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(35rem * var(--space-x-reverse));
    margin-left: calc(35rem * (1 - var(--space-x-reverse)));
    margin-left: calc(35rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-152 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(38rem * (1 - var(--space-y-reverse)));
    margin-top: calc(38rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(38rem * var(--space-y-reverse));
  }

  .sm\\:space-x-152 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(38rem * var(--space-x-reverse));
    margin-left: calc(38rem * (1 - var(--space-x-reverse)));
    margin-left: calc(38rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-160 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(40rem * (1 - var(--space-y-reverse)));
    margin-top: calc(40rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(40rem * var(--space-y-reverse));
  }

  .sm\\:space-x-160 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(40rem * var(--space-x-reverse));
    margin-left: calc(40rem * (1 - var(--space-x-reverse)));
    margin-left: calc(40rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-162 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(41rem * (1 - var(--space-y-reverse)));
    margin-top: calc(41rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(41rem * var(--space-y-reverse));
  }

  .sm\\:space-x-162 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(41rem * var(--space-x-reverse));
    margin-left: calc(41rem * (1 - var(--space-x-reverse)));
    margin-left: calc(41rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-192 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(48rem * (1 - var(--space-y-reverse)));
    margin-top: calc(48rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(48rem * var(--space-y-reverse));
  }

  .sm\\:space-x-192 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(48rem * var(--space-x-reverse));
    margin-left: calc(48rem * (1 - var(--space-x-reverse)));
    margin-left: calc(48rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-208 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(52rem * (1 - var(--space-y-reverse)));
    margin-top: calc(52rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(52rem * var(--space-y-reverse));
  }

  .sm\\:space-x-208 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(52rem * var(--space-x-reverse));
    margin-left: calc(52rem * (1 - var(--space-x-reverse)));
    margin-left: calc(52rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-224 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(56rem * (1 - var(--space-y-reverse)));
    margin-top: calc(56rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(56rem * var(--space-y-reverse));
  }

  .sm\\:space-x-224 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(56rem * var(--space-x-reverse));
    margin-left: calc(56rem * (1 - var(--space-x-reverse)));
    margin-left: calc(56rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-256 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(64rem * (1 - var(--space-y-reverse)));
    margin-top: calc(64rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(64rem * var(--space-y-reverse));
  }

  .sm\\:space-x-256 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(64rem * var(--space-x-reverse));
    margin-left: calc(64rem * (1 - var(--space-x-reverse)));
    margin-left: calc(64rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1px * (1 - var(--space-y-reverse)));
    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1px * var(--space-y-reverse));
  }

  .sm\\:space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1px * var(--space-x-reverse));
    margin-left: calc(1px * (1 - var(--space-x-reverse)));
    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.25rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.25rem * var(--space-x-reverse));
    margin-left: calc(-0.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.5rem * var(--space-x-reverse));
    margin-left: calc(-0.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.75rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.75rem * var(--space-x-reverse));
    margin-left: calc(-0.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1rem * var(--space-x-reverse));
    margin-left: calc(-1rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.25rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.25rem * var(--space-x-reverse));
    margin-left: calc(-1.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.5rem * var(--space-x-reverse));
    margin-left: calc(-1.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-7 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.75rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-7 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.75rem * var(--space-x-reverse));
    margin-left: calc(-1.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2rem * var(--space-x-reverse));
    margin-left: calc(-2rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-9 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.25rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-9 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.25rem * var(--space-x-reverse));
    margin-left: calc(-2.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.5rem * var(--space-x-reverse));
    margin-left: calc(-2.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-11 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.75rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-11 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.75rem * var(--space-x-reverse));
    margin-left: calc(-2.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3rem * var(--space-x-reverse));
    margin-left: calc(-3rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-14 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-14 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3.5rem * var(--space-x-reverse));
    margin-left: calc(-3.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-15 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.75rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-15 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3.75rem * var(--space-x-reverse));
    margin-left: calc(-3.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-4rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-4rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-4rem * var(--space-x-reverse));
    margin-left: calc(-4rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-18 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-4.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-4.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-4.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-18 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-4.5rem * var(--space-x-reverse));
    margin-left: calc(-4.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-4.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5rem * var(--space-x-reverse));
    margin-left: calc(-5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-22 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-22 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5.5rem * var(--space-x-reverse));
    margin-left: calc(-5.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-23 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5.75rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-23 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5.75rem * var(--space-x-reverse));
    margin-left: calc(-5.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5.75rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6rem * var(--space-x-reverse));
    margin-left: calc(-6rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-25 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6.25rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-25 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6.25rem * var(--space-x-reverse));
    margin-left: calc(-6.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6.25rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-26 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-26 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6.5rem * var(--space-x-reverse));
    margin-left: calc(-6.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-28 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-7rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-7rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-28 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-7rem * var(--space-x-reverse));
    margin-left: calc(-7rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-30 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-7.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-7.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-7.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-30 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-7.5rem * var(--space-x-reverse));
    margin-left: calc(-7.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-7.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-8rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-8rem * var(--space-x-reverse));
    margin-left: calc(-8rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-34 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-8.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-8.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-34 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-8.5rem * var(--space-x-reverse));
    margin-left: calc(-8.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-8.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-10rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-10rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-10rem * var(--space-x-reverse));
    margin-left: calc(-10rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-42 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-10.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-10.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-10.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-42 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-10.5rem * var(--space-x-reverse));
    margin-left: calc(-10.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-10.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-44 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-11rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-11rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-44 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-11rem * var(--space-x-reverse));
    margin-left: calc(-11rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-12rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-12rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-12rem * var(--space-x-reverse));
    margin-left: calc(-12rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-52 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-13rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-13rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-52 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-13rem * var(--space-x-reverse));
    margin-left: calc(-13rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-54 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-13.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-13.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-13.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-54 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-13.5rem * var(--space-x-reverse));
    margin-left: calc(-13.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-13.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-14rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-14rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-14rem * var(--space-x-reverse));
    margin-left: calc(-14rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-60 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-15rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-15rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-60 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-15rem * var(--space-x-reverse));
    margin-left: calc(-15rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-16rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-16rem * var(--space-x-reverse));
    margin-left: calc(-16rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-68 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-17rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-17rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-17rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-68 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-17rem * var(--space-x-reverse));
    margin-left: calc(-17rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-17rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-72 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-18rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-18rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-72 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-18rem * var(--space-x-reverse));
    margin-left: calc(-18rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-74 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-18.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-18.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-18.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-74 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-18.5rem * var(--space-x-reverse));
    margin-left: calc(-18.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-18.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-76 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-19rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-19rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-19rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-76 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-19rem * var(--space-x-reverse));
    margin-left: calc(-19rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-19rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-78 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-19.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-19.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-19.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-78 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-19.5rem * var(--space-x-reverse));
    margin-left: calc(-19.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-19.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-80 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-20rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-80 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-20rem * var(--space-x-reverse));
    margin-left: calc(-20rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-82 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-20.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-20.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-82 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-20.5rem * var(--space-x-reverse));
    margin-left: calc(-20.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-20.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-84 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-21rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-21rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-21rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-84 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-21rem * var(--space-x-reverse));
    margin-left: calc(-21rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-21rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-88 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-22rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-22rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-22rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-88 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-22rem * var(--space-x-reverse));
    margin-left: calc(-22rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-22rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-92 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-23rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-23rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-23rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-92 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-23rem * var(--space-x-reverse));
    margin-left: calc(-23rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-23rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-96 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-24rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-24rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-96 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-24rem * var(--space-x-reverse));
    margin-left: calc(-24rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-98 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-24.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-24.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-24.5rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-98 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-24.5rem * var(--space-x-reverse));
    margin-left: calc(-24.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-24.5rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-100 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-25rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-100 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-25rem * var(--space-x-reverse));
    margin-left: calc(-25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-25rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-104 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-26rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-26rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-26rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-104 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-26rem * var(--space-x-reverse));
    margin-left: calc(-26rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-26rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-112 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-28rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-28rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-28rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-112 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-28rem * var(--space-x-reverse));
    margin-left: calc(-28rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-28rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-124 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-31rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-31rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-31rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-124 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-31rem * var(--space-x-reverse));
    margin-left: calc(-31rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-31rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-128 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-32rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-32rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-32rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-128 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-32rem * var(--space-x-reverse));
    margin-left: calc(-32rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-32rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-140 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-35rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-35rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-35rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-140 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-35rem * var(--space-x-reverse));
    margin-left: calc(-35rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-35rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-152 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-38rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-38rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-38rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-152 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-38rem * var(--space-x-reverse));
    margin-left: calc(-38rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-38rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-160 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-40rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-40rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-40rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-160 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-40rem * var(--space-x-reverse));
    margin-left: calc(-40rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-40rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-162 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-41rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-41rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-41rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-162 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-41rem * var(--space-x-reverse));
    margin-left: calc(-41rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-41rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-192 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-48rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-48rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-48rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-192 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-48rem * var(--space-x-reverse));
    margin-left: calc(-48rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-48rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-208 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-52rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-52rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-52rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-208 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-52rem * var(--space-x-reverse));
    margin-left: calc(-52rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-52rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-224 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-56rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-56rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-56rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-224 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-56rem * var(--space-x-reverse));
    margin-left: calc(-56rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-56rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-256 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-64rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-64rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-64rem * var(--space-y-reverse));
  }

  .sm\\:-space-x-256 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-64rem * var(--space-x-reverse));
    margin-left: calc(-64rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-64rem * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:-space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1px * (1 - var(--space-y-reverse)));
    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1px * var(--space-y-reverse));
  }

  .sm\\:-space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1px * var(--space-x-reverse));
    margin-left: calc(-1px * (1 - var(--space-x-reverse)));
    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));
  }

  .sm\\:space-y-reverse > :not(template) ~ :not(template){
    --space-y-reverse: 1;
  }

  .sm\\:space-x-reverse > :not(template) ~ :not(template){
    --space-x-reverse: 1;
  }

  .sm\\:divide-y-0 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(0px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(0px * var(--divide-y-reverse));
  }

  .sm\\:divide-x-0 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(0px * var(--divide-x-reverse));
    border-left-width: calc(0px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));
  }

  .sm\\:divide-y-2 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(2px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(2px * var(--divide-y-reverse));
  }

  .sm\\:divide-x-2 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(2px * var(--divide-x-reverse));
    border-left-width: calc(2px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));
  }

  .sm\\:divide-y-3 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(3px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(3px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(3px * var(--divide-y-reverse));
  }

  .sm\\:divide-x-3 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(3px * var(--divide-x-reverse));
    border-left-width: calc(3px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(3px * calc(1 - var(--divide-x-reverse)));
  }

  .sm\\:divide-y-4 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(4px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(4px * var(--divide-y-reverse));
  }

  .sm\\:divide-x-4 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(4px * var(--divide-x-reverse));
    border-left-width: calc(4px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));
  }

  .sm\\:divide-y-5 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(5px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(5px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(5px * var(--divide-y-reverse));
  }

  .sm\\:divide-x-5 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(5px * var(--divide-x-reverse));
    border-left-width: calc(5px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(5px * calc(1 - var(--divide-x-reverse)));
  }

  .sm\\:divide-y-6 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(6px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(6px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(6px * var(--divide-y-reverse));
  }

  .sm\\:divide-x-6 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(6px * var(--divide-x-reverse));
    border-left-width: calc(6px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(6px * calc(1 - var(--divide-x-reverse)));
  }

  .sm\\:divide-y-8 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(8px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(8px * var(--divide-y-reverse));
  }

  .sm\\:divide-x-8 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(8px * var(--divide-x-reverse));
    border-left-width: calc(8px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));
  }

  .sm\\:divide-y > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(1px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(1px * var(--divide-y-reverse));
  }

  .sm\\:divide-x > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(1px * var(--divide-x-reverse));
    border-left-width: calc(1px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));
  }

  .sm\\:divide-y-reverse > :not(template) ~ :not(template){
    --divide-y-reverse: 1;
  }

  .sm\\:divide-x-reverse > :not(template) ~ :not(template){
    --divide-x-reverse: 1;
  }

  .sm\\:divide-transparent > :not(template) ~ :not(template){
    border-color: transparent;
  }

  .sm\\:divide-focus > :not(template) ~ :not(template){
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .sm\\:divide-black > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--divide-opacity));
  }

  .sm\\:divide-white > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--divide-opacity));
  }

  .sm\\:divide-primary > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--divide-opacity));
  }

  .sm\\:divide-disabled > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--divide-opacity));
  }

  .sm\\:divide-translucent-60 > :not(template) ~ :not(template){
    border-color: rgba(256, 256, 256, 0.6);
  }

  .sm\\:divide-translucent-90 > :not(template) ~ :not(template){
    border-color: rgba(256, 256, 256, 0.9);
  }

  .sm\\:divide-green-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--divide-opacity));
  }

  .sm\\:divide-green-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--divide-opacity));
  }

  .sm\\:divide-green-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--divide-opacity));
  }

  .sm\\:divide-green-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--divide-opacity));
  }

  .sm\\:divide-green-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--divide-opacity));
  }

  .sm\\:divide-green-400a50 > :not(template) ~ :not(template){
    border-color: rgba(108,202,152,0.50196);
  }

  .sm\\:divide-green-500a25 > :not(template) ~ :not(template){
    border-color: rgba(151,232,18,0.09804);
  }

  .sm\\:divide-yellow-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--divide-opacity));
  }

  .sm\\:divide-yellow-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--divide-opacity));
  }

  .sm\\:divide-yellow-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--divide-opacity));
  }

  .sm\\:divide-yellow-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--divide-opacity));
  }

  .sm\\:divide-yellow-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--divide-opacity));
  }

  .sm\\:divide-yellow-300a66 > :not(template) ~ :not(template){
    border-color: rgba(255,233,189,0.66667);
  }

  .sm\\:divide-yellow-500a25 > :not(template) ~ :not(template){
    border-color: rgba(255,200,44,0.09804);
  }

  .sm\\:divide-orange-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--divide-opacity));
  }

  .sm\\:divide-orange-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--divide-opacity));
  }

  .sm\\:divide-orange-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--divide-opacity));
  }

  .sm\\:divide-orange-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--divide-opacity));
  }

  .sm\\:divide-orange-900 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--divide-opacity));
  }

  .sm\\:divide-orange-500a25 > :not(template) ~ :not(template){
    border-color: rgba(240,115,23,0.09804);
  }

  .sm\\:divide-red-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--divide-opacity));
  }

  .sm\\:divide-red-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--divide-opacity));
  }

  .sm\\:divide-red-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--divide-opacity));
  }

  .sm\\:divide-red-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--divide-opacity));
  }

  .sm\\:divide-red-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--divide-opacity));
  }

  .sm\\:divide-red-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--divide-opacity));
  }

  .sm\\:divide-red-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--divide-opacity));
  }

  .sm\\:divide-gray-50 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--divide-opacity));
  }

  .sm\\:divide-gray-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--divide-opacity));
  }

  .sm\\:divide-gray-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--divide-opacity));
  }

  .sm\\:divide-gray-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--divide-opacity));
  }

  .sm\\:divide-gray-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--divide-opacity));
  }

  .sm\\:divide-gray-400 > :not(template) ~ :not(template){
    border-color: rgba(114,114,114,0.8);
  }

  .sm\\:divide-gray-425 > :not(template) ~ :not(template){
    border-color: rgba(4, 21, 39, 0.8);
  }

  .sm\\:divide-gray-450 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--divide-opacity));
  }

  .sm\\:divide-gray-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--divide-opacity));
  }

  .sm\\:divide-gray-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--divide-opacity));
  }

  .sm\\:divide-gray-625 > :not(template) ~ :not(template){
    border-color: rgba(90,98,107,0.8);
  }

  .sm\\:divide-gray-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--divide-opacity));
  }

  .sm\\:divide-gray-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--divide-opacity));
  }

  .sm\\:divide-gray-200a50 > :not(template) ~ :not(template){
    border-color: rgba(224, 226, 228, 0.5);
  }

  .sm\\:divide-blue-50 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--divide-opacity));
  }

  .sm\\:divide-blue-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--divide-opacity));
  }

  .sm\\:divide-blue-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--divide-opacity));
  }

  .sm\\:divide-blue-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--divide-opacity));
  }

  .sm\\:divide-blue-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--divide-opacity));
  }

  .sm\\:divide-blue-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--divide-opacity));
  }

  .sm\\:divide-blue-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--divide-opacity));
  }

  .sm\\:divide-blue-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--divide-opacity));
  }

  .sm\\:divide-blue-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--divide-opacity));
  }

  .sm\\:divide-blue-750 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--divide-opacity));
  }

  .sm\\:divide-blue-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--divide-opacity));
  }

  .sm\\:divide-blue-900 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--divide-opacity));
  }

  .sm\\:divide-blue-950 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--divide-opacity));
  }

  .sm\\:divide-blue-500a25 > :not(template) ~ :not(template){
    border-color: rgba(55, 164, 220, 0.2);
  }

  .sm\\:divide-blue-500a50 > :not(template) ~ :not(template){
    border-color: rgba(55, 164, 220, 0.5);
  }

  .sm\\:divide-blue-700a75 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--divide-opacity));
  }

  .sm\\:divide-blue-700a30 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--divide-opacity));
  }

  .sm\\:divide-blue-750a25 > :not(template) ~ :not(template){
    border-color: rgba(86,130,170,0.09804);
  }

  .sm\\:divide-blue-750a15 > :not(template) ~ :not(template){
    border-color: rgba(86,130,170,0.05882);
  }

  .sm\\:divide-blue-800a60 > :not(template) ~ :not(template){
    border-color: rgba(31, 69, 102, 0.6);
  }

  .sm\\:divide-programEditorTabColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--divide-opacity));
  }

  .sm\\:divide-programEditorTabColors-2 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--divide-opacity));
  }

  .sm\\:divide-programEditorTabColors-3 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--divide-opacity));
  }

  .sm\\:divide-programEditorTabColors-4 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--divide-opacity));
  }

  .sm\\:divide-programEditorTabColors-5 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--divide-opacity));
  }

  .sm\\:divide-programEditorTabColors-6 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--divide-opacity));
  }

  .sm\\:divide-programEditorTabColors-1h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--divide-opacity));
  }

  .sm\\:divide-programEditorTabColors-2h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--divide-opacity));
  }

  .sm\\:divide-programEditorTabColors-3h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--divide-opacity));
  }

  .sm\\:divide-programEditorTabColors-4h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--divide-opacity));
  }

  .sm\\:divide-programEditorTabColors-5h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--divide-opacity));
  }

  .sm\\:divide-programEditorTabColors-6h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--divide-opacity));
  }

  .sm\\:divide-programEditorPresetTabColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--divide-opacity));
  }

  .sm\\:divide-programEditorPresetTabColors-1h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--divide-opacity));
  }

  .sm\\:divide-borgScaleColors-0 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--divide-opacity));
  }

  .sm\\:divide-borgScaleColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--divide-opacity));
  }

  .sm\\:divide-borgScaleColors-2 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--divide-opacity));
  }

  .sm\\:divide-borgScaleColors-3 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--divide-opacity));
  }

  .sm\\:divide-borgScaleColors-4 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--divide-opacity));
  }

  .sm\\:divide-borgScaleColors-5 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--divide-opacity));
  }

  .sm\\:divide-borgScaleColors-6 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--divide-opacity));
  }

  .sm\\:divide-borgScaleColors-7 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--divide-opacity));
  }

  .sm\\:divide-borgScaleColors-8 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--divide-opacity));
  }

  .sm\\:divide-borgScaleColors-9 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--divide-opacity));
  }

  .sm\\:divide-borgScaleColors-10 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--divide-opacity));
  }

  .sm\\:divide-solid > :not(template) ~ :not(template){
    border-style: solid;
  }

  .sm\\:divide-dashed > :not(template) ~ :not(template){
    border-style: dashed;
  }

  .sm\\:divide-dotted > :not(template) ~ :not(template){
    border-style: dotted;
  }

  .sm\\:divide-double > :not(template) ~ :not(template){
    border-style: double;
  }

  .sm\\:divide-none > :not(template) ~ :not(template){
    border-style: none;
  }

  .sm\\:divide-opacity-0 > :not(template) ~ :not(template){
    --divide-opacity: 0;
  }

  .sm\\:divide-opacity-25 > :not(template) ~ :not(template){
    --divide-opacity: .25;
  }

  .sm\\:divide-opacity-50 > :not(template) ~ :not(template){
    --divide-opacity: .5;
  }

  .sm\\:divide-opacity-75 > :not(template) ~ :not(template){
    --divide-opacity: .75;
  }

  .sm\\:divide-opacity-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
  }

  .sm\\:sr-only{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .sm\\:not-sr-only{
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .sm\\:focus\\:sr-only:focus{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .sm\\:focus\\:not-sr-only:focus{
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .sm\\:appearance-none{
    -webkit-appearance: none;
            appearance: none;
  }

  .sm\\:bg-fixed{
    background-attachment: fixed;
  }

  .sm\\:bg-local{
    background-attachment: local;
  }

  .sm\\:bg-scroll{
    background-attachment: scroll;
  }

  .sm\\:bg-clip-border{
    background-clip: border-box;
  }

  .sm\\:bg-clip-padding{
    background-clip: padding-box;
  }

  .sm\\:bg-clip-content{
    background-clip: content-box;
  }

  .sm\\:bg-clip-text{
    -webkit-background-clip: text;
            background-clip: text;
  }

  .sm\\:bg-transparent{
    background-color: transparent;
  }

  .sm\\:bg-focus{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .sm\\:bg-black{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .sm\\:bg-white{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .sm\\:bg-primary{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .sm\\:bg-disabled{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .sm\\:bg-translucent-60{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .sm\\:bg-translucent-90{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .sm\\:bg-green-200{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .sm\\:bg-green-400{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .sm\\:bg-green-500{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .sm\\:bg-green-600{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .sm\\:bg-green-700{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .sm\\:bg-green-400a50{
    background-color: rgba(108,202,152,0.50196);
  }

  .sm\\:bg-green-500a25{
    background-color: rgba(151,232,18,0.09804);
  }

  .sm\\:bg-yellow-200{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .sm\\:bg-yellow-300{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .sm\\:bg-yellow-500{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .sm\\:bg-yellow-600{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .sm\\:bg-yellow-700{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .sm\\:bg-yellow-300a66{
    background-color: rgba(255,233,189,0.66667);
  }

  .sm\\:bg-yellow-500a25{
    background-color: rgba(255,200,44,0.09804);
  }

  .sm\\:bg-orange-200{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .sm\\:bg-orange-400{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .sm\\:bg-orange-500{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .sm\\:bg-orange-800{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .sm\\:bg-orange-900{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .sm\\:bg-orange-500a25{
    background-color: rgba(240,115,23,0.09804);
  }

  .sm\\:bg-red-100{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .sm\\:bg-red-150{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .sm\\:bg-red-200{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .sm\\:bg-red-300{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .sm\\:bg-red-400{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .sm\\:bg-red-500{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .sm\\:bg-red-700{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .sm\\:bg-gray-50{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .sm\\:bg-gray-100{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .sm\\:bg-gray-150{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .sm\\:bg-gray-200{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .sm\\:bg-gray-300{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .sm\\:bg-gray-400{
    background-color: rgba(114,114,114,0.8);
  }

  .sm\\:bg-gray-425{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .sm\\:bg-gray-450{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .sm\\:bg-gray-500{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .sm\\:bg-gray-600{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .sm\\:bg-gray-625{
    background-color: rgba(90,98,107,0.8);
  }

  .sm\\:bg-gray-700{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .sm\\:bg-gray-800{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .sm\\:bg-gray-200a50{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .sm\\:bg-blue-50{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .sm\\:bg-blue-100{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .sm\\:bg-blue-150{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .sm\\:bg-blue-200{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .sm\\:bg-blue-300{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .sm\\:bg-blue-400{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .sm\\:bg-blue-500{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .sm\\:bg-blue-600{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .sm\\:bg-blue-700{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .sm\\:bg-blue-750{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .sm\\:bg-blue-800{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .sm\\:bg-blue-900{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .sm\\:bg-blue-950{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .sm\\:bg-blue-500a25{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .sm\\:bg-blue-500a50{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .sm\\:bg-blue-700a75{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .sm\\:bg-blue-700a30{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .sm\\:bg-blue-750a25{
    background-color: rgba(86,130,170,0.09804);
  }

  .sm\\:bg-blue-750a15{
    background-color: rgba(86,130,170,0.05882);
  }

  .sm\\:bg-blue-800a60{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .sm\\:bg-programEditorTabColors-1{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .sm\\:bg-programEditorTabColors-2{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .sm\\:bg-programEditorTabColors-3{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .sm\\:bg-programEditorTabColors-4{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .sm\\:bg-programEditorTabColors-5{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .sm\\:bg-programEditorTabColors-6{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .sm\\:bg-programEditorTabColors-1h{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .sm\\:bg-programEditorTabColors-2h{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .sm\\:bg-programEditorTabColors-3h{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .sm\\:bg-programEditorTabColors-4h{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .sm\\:bg-programEditorTabColors-5h{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .sm\\:bg-programEditorTabColors-6h{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .sm\\:bg-programEditorPresetTabColors-1{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .sm\\:bg-programEditorPresetTabColors-1h{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .sm\\:bg-borgScaleColors-0{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .sm\\:bg-borgScaleColors-1{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .sm\\:bg-borgScaleColors-2{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .sm\\:bg-borgScaleColors-3{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .sm\\:bg-borgScaleColors-4{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .sm\\:bg-borgScaleColors-5{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .sm\\:bg-borgScaleColors-6{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .sm\\:bg-borgScaleColors-7{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .sm\\:bg-borgScaleColors-8{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .sm\\:bg-borgScaleColors-9{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .sm\\:bg-borgScaleColors-10{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-transparent:hover{
    background-color: transparent;
  }

  .sm\\:hover\\:bg-focus:hover{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .sm\\:hover\\:bg-black:hover{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-white:hover{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-primary:hover{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-disabled:hover{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-translucent-60:hover{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .sm\\:hover\\:bg-translucent-90:hover{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .sm\\:hover\\:bg-green-200:hover{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-green-400:hover{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-green-500:hover{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-green-600:hover{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-green-700:hover{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-green-400a50:hover{
    background-color: rgba(108,202,152,0.50196);
  }

  .sm\\:hover\\:bg-green-500a25:hover{
    background-color: rgba(151,232,18,0.09804);
  }

  .sm\\:hover\\:bg-yellow-200:hover{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-yellow-300:hover{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-yellow-500:hover{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-yellow-600:hover{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-yellow-700:hover{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-yellow-300a66:hover{
    background-color: rgba(255,233,189,0.66667);
  }

  .sm\\:hover\\:bg-yellow-500a25:hover{
    background-color: rgba(255,200,44,0.09804);
  }

  .sm\\:hover\\:bg-orange-200:hover{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-orange-400:hover{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-orange-500:hover{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-orange-800:hover{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-orange-900:hover{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-orange-500a25:hover{
    background-color: rgba(240,115,23,0.09804);
  }

  .sm\\:hover\\:bg-red-100:hover{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-red-150:hover{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-red-200:hover{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-red-300:hover{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-red-400:hover{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-red-500:hover{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-red-700:hover{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-50:hover{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-100:hover{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-150:hover{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-200:hover{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-300:hover{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-400:hover{
    background-color: rgba(114,114,114,0.8);
  }

  .sm\\:hover\\:bg-gray-425:hover{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .sm\\:hover\\:bg-gray-450:hover{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-500:hover{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-600:hover{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-625:hover{
    background-color: rgba(90,98,107,0.8);
  }

  .sm\\:hover\\:bg-gray-700:hover{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-800:hover{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-gray-200a50:hover{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .sm\\:hover\\:bg-blue-50:hover{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-100:hover{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-150:hover{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-200:hover{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-300:hover{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-400:hover{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-500:hover{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-600:hover{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-700:hover{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-750:hover{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-800:hover{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-900:hover{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-950:hover{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-500a25:hover{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .sm\\:hover\\:bg-blue-500a50:hover{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .sm\\:hover\\:bg-blue-700a75:hover{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-700a30:hover{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-blue-750a25:hover{
    background-color: rgba(86,130,170,0.09804);
  }

  .sm\\:hover\\:bg-blue-750a15:hover{
    background-color: rgba(86,130,170,0.05882);
  }

  .sm\\:hover\\:bg-blue-800a60:hover{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .sm\\:hover\\:bg-programEditorTabColors-1:hover{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-programEditorTabColors-2:hover{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-programEditorTabColors-3:hover{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-programEditorTabColors-4:hover{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-programEditorTabColors-5:hover{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-programEditorTabColors-6:hover{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-programEditorTabColors-1h:hover{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-programEditorTabColors-2h:hover{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-programEditorTabColors-3h:hover{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-programEditorTabColors-4h:hover{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-programEditorTabColors-5h:hover{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-programEditorTabColors-6h:hover{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-programEditorPresetTabColors-1:hover{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-programEditorPresetTabColors-1h:hover{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-borgScaleColors-0:hover{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-borgScaleColors-1:hover{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-borgScaleColors-2:hover{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-borgScaleColors-3:hover{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-borgScaleColors-4:hover{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-borgScaleColors-5:hover{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-borgScaleColors-6:hover{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-borgScaleColors-7:hover{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-borgScaleColors-8:hover{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-borgScaleColors-9:hover{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .sm\\:hover\\:bg-borgScaleColors-10:hover{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-transparent:focus{
    background-color: transparent;
  }

  .sm\\:focus\\:bg-focus:focus{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .sm\\:focus\\:bg-black:focus{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-white:focus{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-primary:focus{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-disabled:focus{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-translucent-60:focus{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .sm\\:focus\\:bg-translucent-90:focus{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .sm\\:focus\\:bg-green-200:focus{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-green-400:focus{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-green-500:focus{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-green-600:focus{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-green-700:focus{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-green-400a50:focus{
    background-color: rgba(108,202,152,0.50196);
  }

  .sm\\:focus\\:bg-green-500a25:focus{
    background-color: rgba(151,232,18,0.09804);
  }

  .sm\\:focus\\:bg-yellow-200:focus{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-yellow-300:focus{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-yellow-500:focus{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-yellow-600:focus{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-yellow-700:focus{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-yellow-300a66:focus{
    background-color: rgba(255,233,189,0.66667);
  }

  .sm\\:focus\\:bg-yellow-500a25:focus{
    background-color: rgba(255,200,44,0.09804);
  }

  .sm\\:focus\\:bg-orange-200:focus{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-orange-400:focus{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-orange-500:focus{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-orange-800:focus{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-orange-900:focus{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-orange-500a25:focus{
    background-color: rgba(240,115,23,0.09804);
  }

  .sm\\:focus\\:bg-red-100:focus{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-red-150:focus{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-red-200:focus{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-red-300:focus{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-red-400:focus{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-red-500:focus{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-red-700:focus{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-50:focus{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-100:focus{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-150:focus{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-200:focus{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-300:focus{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-400:focus{
    background-color: rgba(114,114,114,0.8);
  }

  .sm\\:focus\\:bg-gray-425:focus{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .sm\\:focus\\:bg-gray-450:focus{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-500:focus{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-600:focus{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-625:focus{
    background-color: rgba(90,98,107,0.8);
  }

  .sm\\:focus\\:bg-gray-700:focus{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-800:focus{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-gray-200a50:focus{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .sm\\:focus\\:bg-blue-50:focus{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-100:focus{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-150:focus{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-200:focus{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-300:focus{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-400:focus{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-500:focus{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-600:focus{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-700:focus{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-750:focus{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-800:focus{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-900:focus{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-950:focus{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-500a25:focus{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .sm\\:focus\\:bg-blue-500a50:focus{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .sm\\:focus\\:bg-blue-700a75:focus{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-700a30:focus{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-blue-750a25:focus{
    background-color: rgba(86,130,170,0.09804);
  }

  .sm\\:focus\\:bg-blue-750a15:focus{
    background-color: rgba(86,130,170,0.05882);
  }

  .sm\\:focus\\:bg-blue-800a60:focus{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .sm\\:focus\\:bg-programEditorTabColors-1:focus{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-programEditorTabColors-2:focus{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-programEditorTabColors-3:focus{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-programEditorTabColors-4:focus{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-programEditorTabColors-5:focus{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-programEditorTabColors-6:focus{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-programEditorTabColors-1h:focus{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-programEditorTabColors-2h:focus{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-programEditorTabColors-3h:focus{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-programEditorTabColors-4h:focus{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-programEditorTabColors-5h:focus{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-programEditorTabColors-6h:focus{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-programEditorPresetTabColors-1:focus{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-programEditorPresetTabColors-1h:focus{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-borgScaleColors-0:focus{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-borgScaleColors-1:focus{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-borgScaleColors-2:focus{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-borgScaleColors-3:focus{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-borgScaleColors-4:focus{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-borgScaleColors-5:focus{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-borgScaleColors-6:focus{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-borgScaleColors-7:focus{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-borgScaleColors-8:focus{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-borgScaleColors-9:focus{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .sm\\:focus\\:bg-borgScaleColors-10:focus{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .sm\\:bg-none{
    background-image: none;
  }

  .sm\\:bg-gradient-to-t{
    background-image: linear-gradient(to top, var(--gradient-color-stops));
  }

  .sm\\:bg-gradient-to-tr{
    background-image: linear-gradient(to top right, var(--gradient-color-stops));
  }

  .sm\\:bg-gradient-to-r{
    background-image: linear-gradient(to right, var(--gradient-color-stops));
  }

  .sm\\:bg-gradient-to-br{
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
  }

  .sm\\:bg-gradient-to-b{
    background-image: linear-gradient(to bottom, var(--gradient-color-stops));
  }

  .sm\\:bg-gradient-to-bl{
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
  }

  .sm\\:bg-gradient-to-l{
    background-image: linear-gradient(to left, var(--gradient-color-stops));
  }

  .sm\\:bg-gradient-to-tl{
    background-image: linear-gradient(to top left, var(--gradient-color-stops));
  }

  .sm\\:from-transparent{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:from-focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:from-black{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:from-white{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:from-primary{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:from-disabled{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .sm\\:from-translucent-60{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:from-translucent-90{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:from-green-200{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .sm\\:from-green-400{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .sm\\:from-green-500{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .sm\\:from-green-600{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .sm\\:from-green-700{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .sm\\:from-green-400a50{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .sm\\:from-green-500a25{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .sm\\:from-yellow-200{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .sm\\:from-yellow-300{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .sm\\:from-yellow-500{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .sm\\:from-yellow-600{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .sm\\:from-yellow-700{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .sm\\:from-yellow-300a66{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .sm\\:from-yellow-500a25{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .sm\\:from-orange-200{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .sm\\:from-orange-400{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .sm\\:from-orange-500{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .sm\\:from-orange-800{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .sm\\:from-orange-900{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .sm\\:from-orange-500a25{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .sm\\:from-red-100{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .sm\\:from-red-150{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .sm\\:from-red-200{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .sm\\:from-red-300{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .sm\\:from-red-400{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .sm\\:from-red-500{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .sm\\:from-red-700{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .sm\\:from-gray-50{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .sm\\:from-gray-100{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .sm\\:from-gray-150{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .sm\\:from-gray-200{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .sm\\:from-gray-300{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .sm\\:from-gray-400{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .sm\\:from-gray-425{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .sm\\:from-gray-450{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .sm\\:from-gray-500{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .sm\\:from-gray-600{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .sm\\:from-gray-625{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .sm\\:from-gray-700{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .sm\\:from-gray-800{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .sm\\:from-gray-200a50{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .sm\\:from-blue-50{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .sm\\:from-blue-100{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .sm\\:from-blue-150{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .sm\\:from-blue-200{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .sm\\:from-blue-300{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .sm\\:from-blue-400{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .sm\\:from-blue-500{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:from-blue-600{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .sm\\:from-blue-700{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .sm\\:from-blue-750{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:from-blue-800{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .sm\\:from-blue-900{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .sm\\:from-blue-950{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .sm\\:from-blue-500a25{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:from-blue-500a50{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:from-blue-700a75{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .sm\\:from-blue-700a30{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .sm\\:from-blue-750a25{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:from-blue-750a15{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:from-blue-800a60{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .sm\\:from-programEditorTabColors-1{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .sm\\:from-programEditorTabColors-2{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .sm\\:from-programEditorTabColors-3{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .sm\\:from-programEditorTabColors-4{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .sm\\:from-programEditorTabColors-5{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .sm\\:from-programEditorTabColors-6{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .sm\\:from-programEditorTabColors-1h{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .sm\\:from-programEditorTabColors-2h{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .sm\\:from-programEditorTabColors-3h{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .sm\\:from-programEditorTabColors-4h{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .sm\\:from-programEditorTabColors-5h{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .sm\\:from-programEditorTabColors-6h{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .sm\\:from-programEditorPresetTabColors-1{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .sm\\:from-programEditorPresetTabColors-1h{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .sm\\:from-borgScaleColors-0{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .sm\\:from-borgScaleColors-1{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .sm\\:from-borgScaleColors-2{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .sm\\:from-borgScaleColors-3{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .sm\\:from-borgScaleColors-4{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .sm\\:from-borgScaleColors-5{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .sm\\:from-borgScaleColors-6{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .sm\\:from-borgScaleColors-7{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .sm\\:from-borgScaleColors-8{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .sm\\:from-borgScaleColors-9{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .sm\\:from-borgScaleColors-10{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .sm\\:via-transparent{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:via-focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:via-black{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:via-white{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:via-primary{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:via-disabled{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .sm\\:via-translucent-60{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:via-translucent-90{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:via-green-200{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .sm\\:via-green-400{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .sm\\:via-green-500{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .sm\\:via-green-600{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .sm\\:via-green-700{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .sm\\:via-green-400a50{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .sm\\:via-green-500a25{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .sm\\:via-yellow-200{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .sm\\:via-yellow-300{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .sm\\:via-yellow-500{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .sm\\:via-yellow-600{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .sm\\:via-yellow-700{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .sm\\:via-yellow-300a66{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .sm\\:via-yellow-500a25{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .sm\\:via-orange-200{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .sm\\:via-orange-400{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .sm\\:via-orange-500{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .sm\\:via-orange-800{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .sm\\:via-orange-900{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .sm\\:via-orange-500a25{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .sm\\:via-red-100{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .sm\\:via-red-150{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .sm\\:via-red-200{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .sm\\:via-red-300{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .sm\\:via-red-400{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .sm\\:via-red-500{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .sm\\:via-red-700{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .sm\\:via-gray-50{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .sm\\:via-gray-100{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .sm\\:via-gray-150{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .sm\\:via-gray-200{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .sm\\:via-gray-300{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .sm\\:via-gray-400{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .sm\\:via-gray-425{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .sm\\:via-gray-450{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .sm\\:via-gray-500{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .sm\\:via-gray-600{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .sm\\:via-gray-625{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .sm\\:via-gray-700{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .sm\\:via-gray-800{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .sm\\:via-gray-200a50{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .sm\\:via-blue-50{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .sm\\:via-blue-100{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .sm\\:via-blue-150{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .sm\\:via-blue-200{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .sm\\:via-blue-300{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .sm\\:via-blue-400{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .sm\\:via-blue-500{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:via-blue-600{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .sm\\:via-blue-700{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .sm\\:via-blue-750{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:via-blue-800{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .sm\\:via-blue-900{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .sm\\:via-blue-950{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .sm\\:via-blue-500a25{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:via-blue-500a50{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:via-blue-700a75{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .sm\\:via-blue-700a30{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .sm\\:via-blue-750a25{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:via-blue-750a15{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:via-blue-800a60{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .sm\\:via-programEditorTabColors-1{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .sm\\:via-programEditorTabColors-2{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .sm\\:via-programEditorTabColors-3{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .sm\\:via-programEditorTabColors-4{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .sm\\:via-programEditorTabColors-5{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .sm\\:via-programEditorTabColors-6{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .sm\\:via-programEditorTabColors-1h{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .sm\\:via-programEditorTabColors-2h{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .sm\\:via-programEditorTabColors-3h{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .sm\\:via-programEditorTabColors-4h{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .sm\\:via-programEditorTabColors-5h{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .sm\\:via-programEditorTabColors-6h{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .sm\\:via-programEditorPresetTabColors-1{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .sm\\:via-programEditorPresetTabColors-1h{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .sm\\:via-borgScaleColors-0{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .sm\\:via-borgScaleColors-1{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .sm\\:via-borgScaleColors-2{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .sm\\:via-borgScaleColors-3{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .sm\\:via-borgScaleColors-4{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .sm\\:via-borgScaleColors-5{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .sm\\:via-borgScaleColors-6{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .sm\\:via-borgScaleColors-7{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .sm\\:via-borgScaleColors-8{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .sm\\:via-borgScaleColors-9{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .sm\\:via-borgScaleColors-10{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .sm\\:to-transparent{
    --gradient-to-color: transparent;
  }

  .sm\\:to-focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .sm\\:to-black{
    --gradient-to-color: #000;
  }

  .sm\\:to-white{
    --gradient-to-color: #fff;
  }

  .sm\\:to-primary{
    --gradient-to-color: #37A4DC;
  }

  .sm\\:to-disabled{
    --gradient-to-color: #BFBFBF;
  }

  .sm\\:to-translucent-60{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .sm\\:to-translucent-90{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .sm\\:to-green-200{
    --gradient-to-color: #f4fcea;
  }

  .sm\\:to-green-400{
    --gradient-to-color: #6CCA98;
  }

  .sm\\:to-green-500{
    --gradient-to-color: #97E812;
  }

  .sm\\:to-green-600{
    --gradient-to-color: #4f9112;
  }

  .sm\\:to-green-700{
    --gradient-to-color: #3e7211;
  }

  .sm\\:to-green-400a50{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .sm\\:to-green-500a25{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .sm\\:to-yellow-200{
    --gradient-to-color: #fff9eb;
  }

  .sm\\:to-yellow-300{
    --gradient-to-color: #ffe9bd;
  }

  .sm\\:to-yellow-500{
    --gradient-to-color: #FFC82C;
  }

  .sm\\:to-yellow-600{
    --gradient-to-color: #F7931E;
  }

  .sm\\:to-yellow-700{
    --gradient-to-color: #E1AD28;
  }

  .sm\\:to-yellow-300a66{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .sm\\:to-yellow-500a25{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .sm\\:to-orange-200{
    --gradient-to-color: #fdf0ea;
  }

  .sm\\:to-orange-400{
    --gradient-to-color: #f6c66f;
  }

  .sm\\:to-orange-500{
    --gradient-to-color: #F07313;
  }

  .sm\\:to-orange-800{
    --gradient-to-color: #db5d0c;
  }

  .sm\\:to-orange-900{
    --gradient-to-color: #b86814;
  }

  .sm\\:to-orange-500a25{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .sm\\:to-red-100{
    --gradient-to-color: #FEF5F5;
  }

  .sm\\:to-red-150{
    --gradient-to-color: #ffe9e8;
  }

  .sm\\:to-red-200{
    --gradient-to-color: #F8CECC;
  }

  .sm\\:to-red-300{
    --gradient-to-color: #ff8585;
  }

  .sm\\:to-red-400{
    --gradient-to-color: #ff3535;
  }

  .sm\\:to-red-500{
    --gradient-to-color: #DD4746;
  }

  .sm\\:to-red-700{
    --gradient-to-color: #A23C24;
  }

  .sm\\:to-gray-50{
    --gradient-to-color: #F9F9F9;
  }

  .sm\\:to-gray-100{
    --gradient-to-color: #F1F1F2;
  }

  .sm\\:to-gray-150{
    --gradient-to-color: #e6e6e6;
  }

  .sm\\:to-gray-200{
    --gradient-to-color: #E0E2E4;
  }

  .sm\\:to-gray-300{
    --gradient-to-color: #BFBFBF;
  }

  .sm\\:to-gray-400{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .sm\\:to-gray-425{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .sm\\:to-gray-450{
    --gradient-to-color: #959595;
  }

  .sm\\:to-gray-500{
    --gradient-to-color: #727272;
  }

  .sm\\:to-gray-600{
    --gradient-to-color: #5a626b;
  }

  .sm\\:to-gray-625{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .sm\\:to-gray-700{
    --gradient-to-color: #464C59;
  }

  .sm\\:to-gray-800{
    --gradient-to-color: #3c3b3b;
  }

  .sm\\:to-gray-200a50{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .sm\\:to-blue-50{
    --gradient-to-color: #f2fbff;
  }

  .sm\\:to-blue-100{
    --gradient-to-color: #EBF6FC;
  }

  .sm\\:to-blue-150{
    --gradient-to-color: #E8EEF1;
  }

  .sm\\:to-blue-200{
    --gradient-to-color: #CCE6F5;
  }

  .sm\\:to-blue-300{
    --gradient-to-color: #73BFE7;
  }

  .sm\\:to-blue-400{
    --gradient-to-color: #4BA4F7;
  }

  .sm\\:to-blue-500{
    --gradient-to-color: #37A4DC;
  }

  .sm\\:to-blue-600{
    --gradient-to-color: #6AA2D6;
  }

  .sm\\:to-blue-700{
    --gradient-to-color: #456E9A;
  }

  .sm\\:to-blue-750{
    --gradient-to-color: #5682AA;
  }

  .sm\\:to-blue-800{
    --gradient-to-color: #1F4566;
  }

  .sm\\:to-blue-900{
    --gradient-to-color: #183453;
  }

  .sm\\:to-blue-950{
    --gradient-to-color: #041527;
  }

  .sm\\:to-blue-500a25{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .sm\\:to-blue-500a50{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .sm\\:to-blue-700a75{
    --gradient-to-color: #3B648D;
  }

  .sm\\:to-blue-700a30{
    --gradient-to-color: #2A5176;
  }

  .sm\\:to-blue-750a25{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .sm\\:to-blue-750a15{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .sm\\:to-blue-800a60{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .sm\\:to-programEditorTabColors-1{
    --gradient-to-color: #3cacae;
  }

  .sm\\:to-programEditorTabColors-2{
    --gradient-to-color: #8e346a;
  }

  .sm\\:to-programEditorTabColors-3{
    --gradient-to-color: #ff72b7;
  }

  .sm\\:to-programEditorTabColors-4{
    --gradient-to-color: #ce941c;
  }

  .sm\\:to-programEditorTabColors-5{
    --gradient-to-color: #b973d9;
  }

  .sm\\:to-programEditorTabColors-6{
    --gradient-to-color: #ff9082;
  }

  .sm\\:to-programEditorTabColors-1h{
    --gradient-to-color: #d9f2f2;
  }

  .sm\\:to-programEditorTabColors-2h{
    --gradient-to-color: #f1dae8;
  }

  .sm\\:to-programEditorTabColors-3h{
    --gradient-to-color: #ffe6f2;
  }

  .sm\\:to-programEditorTabColors-4h{
    --gradient-to-color: #f9ecd2;
  }

  .sm\\:to-programEditorTabColors-5h{
    --gradient-to-color: #f5ebfa;
  }

  .sm\\:to-programEditorTabColors-6h{
    --gradient-to-color: #ffe8e6;
  }

  .sm\\:to-programEditorPresetTabColors-1{
    --gradient-to-color: #798fa3;
  }

  .sm\\:to-programEditorPresetTabColors-1h{
    --gradient-to-color: #798fa3;
  }

  .sm\\:to-borgScaleColors-0{
    --gradient-to-color: #c5d1ff;
  }

  .sm\\:to-borgScaleColors-1{
    --gradient-to-color: #a0b5fc;
  }

  .sm\\:to-borgScaleColors-2{
    --gradient-to-color: #7492ff;
  }

  .sm\\:to-borgScaleColors-3{
    --gradient-to-color: #82bbf1;
  }

  .sm\\:to-borgScaleColors-4{
    --gradient-to-color: #4ba4f7;
  }

  .sm\\:to-borgScaleColors-5{
    --gradient-to-color: #9cdd57;
  }

  .sm\\:to-borgScaleColors-6{
    --gradient-to-color: #68af00;
  }

  .sm\\:to-borgScaleColors-7{
    --gradient-to-color: #f5e380;
  }

  .sm\\:to-borgScaleColors-8{
    --gradient-to-color: #ffc246;
  }

  .sm\\:to-borgScaleColors-9{
    --gradient-to-color: #ff782f;
  }

  .sm\\:to-borgScaleColors-10{
    --gradient-to-color: #f25757;
  }

  .sm\\:hover\\:from-transparent:hover{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:hover\\:from-focus:hover{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:hover\\:from-black:hover{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:hover\\:from-white:hover{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:hover\\:from-primary:hover{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:hover\\:from-disabled:hover{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .sm\\:hover\\:from-translucent-60:hover{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:hover\\:from-translucent-90:hover{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:hover\\:from-green-200:hover{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .sm\\:hover\\:from-green-400:hover{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .sm\\:hover\\:from-green-500:hover{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .sm\\:hover\\:from-green-600:hover{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .sm\\:hover\\:from-green-700:hover{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .sm\\:hover\\:from-green-400a50:hover{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .sm\\:hover\\:from-green-500a25:hover{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .sm\\:hover\\:from-yellow-200:hover{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .sm\\:hover\\:from-yellow-300:hover{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .sm\\:hover\\:from-yellow-500:hover{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .sm\\:hover\\:from-yellow-600:hover{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .sm\\:hover\\:from-yellow-700:hover{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .sm\\:hover\\:from-yellow-300a66:hover{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .sm\\:hover\\:from-yellow-500a25:hover{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .sm\\:hover\\:from-orange-200:hover{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .sm\\:hover\\:from-orange-400:hover{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .sm\\:hover\\:from-orange-500:hover{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .sm\\:hover\\:from-orange-800:hover{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .sm\\:hover\\:from-orange-900:hover{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .sm\\:hover\\:from-orange-500a25:hover{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .sm\\:hover\\:from-red-100:hover{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .sm\\:hover\\:from-red-150:hover{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .sm\\:hover\\:from-red-200:hover{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .sm\\:hover\\:from-red-300:hover{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .sm\\:hover\\:from-red-400:hover{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .sm\\:hover\\:from-red-500:hover{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .sm\\:hover\\:from-red-700:hover{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .sm\\:hover\\:from-gray-50:hover{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .sm\\:hover\\:from-gray-100:hover{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .sm\\:hover\\:from-gray-150:hover{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .sm\\:hover\\:from-gray-200:hover{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .sm\\:hover\\:from-gray-300:hover{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .sm\\:hover\\:from-gray-400:hover{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .sm\\:hover\\:from-gray-425:hover{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .sm\\:hover\\:from-gray-450:hover{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .sm\\:hover\\:from-gray-500:hover{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .sm\\:hover\\:from-gray-600:hover{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .sm\\:hover\\:from-gray-625:hover{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .sm\\:hover\\:from-gray-700:hover{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .sm\\:hover\\:from-gray-800:hover{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .sm\\:hover\\:from-gray-200a50:hover{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .sm\\:hover\\:from-blue-50:hover{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .sm\\:hover\\:from-blue-100:hover{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .sm\\:hover\\:from-blue-150:hover{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .sm\\:hover\\:from-blue-200:hover{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .sm\\:hover\\:from-blue-300:hover{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .sm\\:hover\\:from-blue-400:hover{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .sm\\:hover\\:from-blue-500:hover{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:hover\\:from-blue-600:hover{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .sm\\:hover\\:from-blue-700:hover{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .sm\\:hover\\:from-blue-750:hover{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:hover\\:from-blue-800:hover{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .sm\\:hover\\:from-blue-900:hover{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .sm\\:hover\\:from-blue-950:hover{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .sm\\:hover\\:from-blue-500a25:hover{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:hover\\:from-blue-500a50:hover{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:hover\\:from-blue-700a75:hover{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .sm\\:hover\\:from-blue-700a30:hover{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .sm\\:hover\\:from-blue-750a25:hover{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:hover\\:from-blue-750a15:hover{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:hover\\:from-blue-800a60:hover{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .sm\\:hover\\:from-programEditorTabColors-1:hover{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .sm\\:hover\\:from-programEditorTabColors-2:hover{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .sm\\:hover\\:from-programEditorTabColors-3:hover{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .sm\\:hover\\:from-programEditorTabColors-4:hover{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .sm\\:hover\\:from-programEditorTabColors-5:hover{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .sm\\:hover\\:from-programEditorTabColors-6:hover{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .sm\\:hover\\:from-programEditorTabColors-1h:hover{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .sm\\:hover\\:from-programEditorTabColors-2h:hover{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .sm\\:hover\\:from-programEditorTabColors-3h:hover{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .sm\\:hover\\:from-programEditorTabColors-4h:hover{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .sm\\:hover\\:from-programEditorTabColors-5h:hover{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .sm\\:hover\\:from-programEditorTabColors-6h:hover{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .sm\\:hover\\:from-programEditorPresetTabColors-1:hover{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .sm\\:hover\\:from-programEditorPresetTabColors-1h:hover{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .sm\\:hover\\:from-borgScaleColors-0:hover{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .sm\\:hover\\:from-borgScaleColors-1:hover{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .sm\\:hover\\:from-borgScaleColors-2:hover{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .sm\\:hover\\:from-borgScaleColors-3:hover{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .sm\\:hover\\:from-borgScaleColors-4:hover{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .sm\\:hover\\:from-borgScaleColors-5:hover{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .sm\\:hover\\:from-borgScaleColors-6:hover{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .sm\\:hover\\:from-borgScaleColors-7:hover{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .sm\\:hover\\:from-borgScaleColors-8:hover{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .sm\\:hover\\:from-borgScaleColors-9:hover{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .sm\\:hover\\:from-borgScaleColors-10:hover{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .sm\\:hover\\:via-transparent:hover{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:hover\\:via-focus:hover{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:hover\\:via-black:hover{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:hover\\:via-white:hover{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:hover\\:via-primary:hover{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:hover\\:via-disabled:hover{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .sm\\:hover\\:via-translucent-60:hover{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:hover\\:via-translucent-90:hover{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:hover\\:via-green-200:hover{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .sm\\:hover\\:via-green-400:hover{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .sm\\:hover\\:via-green-500:hover{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .sm\\:hover\\:via-green-600:hover{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .sm\\:hover\\:via-green-700:hover{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .sm\\:hover\\:via-green-400a50:hover{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .sm\\:hover\\:via-green-500a25:hover{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .sm\\:hover\\:via-yellow-200:hover{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .sm\\:hover\\:via-yellow-300:hover{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .sm\\:hover\\:via-yellow-500:hover{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .sm\\:hover\\:via-yellow-600:hover{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .sm\\:hover\\:via-yellow-700:hover{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .sm\\:hover\\:via-yellow-300a66:hover{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .sm\\:hover\\:via-yellow-500a25:hover{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .sm\\:hover\\:via-orange-200:hover{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .sm\\:hover\\:via-orange-400:hover{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .sm\\:hover\\:via-orange-500:hover{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .sm\\:hover\\:via-orange-800:hover{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .sm\\:hover\\:via-orange-900:hover{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .sm\\:hover\\:via-orange-500a25:hover{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .sm\\:hover\\:via-red-100:hover{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .sm\\:hover\\:via-red-150:hover{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .sm\\:hover\\:via-red-200:hover{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .sm\\:hover\\:via-red-300:hover{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .sm\\:hover\\:via-red-400:hover{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .sm\\:hover\\:via-red-500:hover{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .sm\\:hover\\:via-red-700:hover{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .sm\\:hover\\:via-gray-50:hover{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .sm\\:hover\\:via-gray-100:hover{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .sm\\:hover\\:via-gray-150:hover{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .sm\\:hover\\:via-gray-200:hover{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .sm\\:hover\\:via-gray-300:hover{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .sm\\:hover\\:via-gray-400:hover{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .sm\\:hover\\:via-gray-425:hover{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .sm\\:hover\\:via-gray-450:hover{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .sm\\:hover\\:via-gray-500:hover{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .sm\\:hover\\:via-gray-600:hover{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .sm\\:hover\\:via-gray-625:hover{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .sm\\:hover\\:via-gray-700:hover{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .sm\\:hover\\:via-gray-800:hover{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .sm\\:hover\\:via-gray-200a50:hover{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .sm\\:hover\\:via-blue-50:hover{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .sm\\:hover\\:via-blue-100:hover{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .sm\\:hover\\:via-blue-150:hover{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .sm\\:hover\\:via-blue-200:hover{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .sm\\:hover\\:via-blue-300:hover{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .sm\\:hover\\:via-blue-400:hover{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .sm\\:hover\\:via-blue-500:hover{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:hover\\:via-blue-600:hover{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .sm\\:hover\\:via-blue-700:hover{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .sm\\:hover\\:via-blue-750:hover{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:hover\\:via-blue-800:hover{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .sm\\:hover\\:via-blue-900:hover{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .sm\\:hover\\:via-blue-950:hover{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .sm\\:hover\\:via-blue-500a25:hover{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:hover\\:via-blue-500a50:hover{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:hover\\:via-blue-700a75:hover{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .sm\\:hover\\:via-blue-700a30:hover{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .sm\\:hover\\:via-blue-750a25:hover{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:hover\\:via-blue-750a15:hover{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:hover\\:via-blue-800a60:hover{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .sm\\:hover\\:via-programEditorTabColors-1:hover{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .sm\\:hover\\:via-programEditorTabColors-2:hover{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .sm\\:hover\\:via-programEditorTabColors-3:hover{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .sm\\:hover\\:via-programEditorTabColors-4:hover{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .sm\\:hover\\:via-programEditorTabColors-5:hover{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .sm\\:hover\\:via-programEditorTabColors-6:hover{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .sm\\:hover\\:via-programEditorTabColors-1h:hover{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .sm\\:hover\\:via-programEditorTabColors-2h:hover{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .sm\\:hover\\:via-programEditorTabColors-3h:hover{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .sm\\:hover\\:via-programEditorTabColors-4h:hover{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .sm\\:hover\\:via-programEditorTabColors-5h:hover{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .sm\\:hover\\:via-programEditorTabColors-6h:hover{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .sm\\:hover\\:via-programEditorPresetTabColors-1:hover{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .sm\\:hover\\:via-programEditorPresetTabColors-1h:hover{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .sm\\:hover\\:via-borgScaleColors-0:hover{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .sm\\:hover\\:via-borgScaleColors-1:hover{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .sm\\:hover\\:via-borgScaleColors-2:hover{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .sm\\:hover\\:via-borgScaleColors-3:hover{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .sm\\:hover\\:via-borgScaleColors-4:hover{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .sm\\:hover\\:via-borgScaleColors-5:hover{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .sm\\:hover\\:via-borgScaleColors-6:hover{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .sm\\:hover\\:via-borgScaleColors-7:hover{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .sm\\:hover\\:via-borgScaleColors-8:hover{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .sm\\:hover\\:via-borgScaleColors-9:hover{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .sm\\:hover\\:via-borgScaleColors-10:hover{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .sm\\:hover\\:to-transparent:hover{
    --gradient-to-color: transparent;
  }

  .sm\\:hover\\:to-focus:hover{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .sm\\:hover\\:to-black:hover{
    --gradient-to-color: #000;
  }

  .sm\\:hover\\:to-white:hover{
    --gradient-to-color: #fff;
  }

  .sm\\:hover\\:to-primary:hover{
    --gradient-to-color: #37A4DC;
  }

  .sm\\:hover\\:to-disabled:hover{
    --gradient-to-color: #BFBFBF;
  }

  .sm\\:hover\\:to-translucent-60:hover{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .sm\\:hover\\:to-translucent-90:hover{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .sm\\:hover\\:to-green-200:hover{
    --gradient-to-color: #f4fcea;
  }

  .sm\\:hover\\:to-green-400:hover{
    --gradient-to-color: #6CCA98;
  }

  .sm\\:hover\\:to-green-500:hover{
    --gradient-to-color: #97E812;
  }

  .sm\\:hover\\:to-green-600:hover{
    --gradient-to-color: #4f9112;
  }

  .sm\\:hover\\:to-green-700:hover{
    --gradient-to-color: #3e7211;
  }

  .sm\\:hover\\:to-green-400a50:hover{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .sm\\:hover\\:to-green-500a25:hover{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .sm\\:hover\\:to-yellow-200:hover{
    --gradient-to-color: #fff9eb;
  }

  .sm\\:hover\\:to-yellow-300:hover{
    --gradient-to-color: #ffe9bd;
  }

  .sm\\:hover\\:to-yellow-500:hover{
    --gradient-to-color: #FFC82C;
  }

  .sm\\:hover\\:to-yellow-600:hover{
    --gradient-to-color: #F7931E;
  }

  .sm\\:hover\\:to-yellow-700:hover{
    --gradient-to-color: #E1AD28;
  }

  .sm\\:hover\\:to-yellow-300a66:hover{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .sm\\:hover\\:to-yellow-500a25:hover{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .sm\\:hover\\:to-orange-200:hover{
    --gradient-to-color: #fdf0ea;
  }

  .sm\\:hover\\:to-orange-400:hover{
    --gradient-to-color: #f6c66f;
  }

  .sm\\:hover\\:to-orange-500:hover{
    --gradient-to-color: #F07313;
  }

  .sm\\:hover\\:to-orange-800:hover{
    --gradient-to-color: #db5d0c;
  }

  .sm\\:hover\\:to-orange-900:hover{
    --gradient-to-color: #b86814;
  }

  .sm\\:hover\\:to-orange-500a25:hover{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .sm\\:hover\\:to-red-100:hover{
    --gradient-to-color: #FEF5F5;
  }

  .sm\\:hover\\:to-red-150:hover{
    --gradient-to-color: #ffe9e8;
  }

  .sm\\:hover\\:to-red-200:hover{
    --gradient-to-color: #F8CECC;
  }

  .sm\\:hover\\:to-red-300:hover{
    --gradient-to-color: #ff8585;
  }

  .sm\\:hover\\:to-red-400:hover{
    --gradient-to-color: #ff3535;
  }

  .sm\\:hover\\:to-red-500:hover{
    --gradient-to-color: #DD4746;
  }

  .sm\\:hover\\:to-red-700:hover{
    --gradient-to-color: #A23C24;
  }

  .sm\\:hover\\:to-gray-50:hover{
    --gradient-to-color: #F9F9F9;
  }

  .sm\\:hover\\:to-gray-100:hover{
    --gradient-to-color: #F1F1F2;
  }

  .sm\\:hover\\:to-gray-150:hover{
    --gradient-to-color: #e6e6e6;
  }

  .sm\\:hover\\:to-gray-200:hover{
    --gradient-to-color: #E0E2E4;
  }

  .sm\\:hover\\:to-gray-300:hover{
    --gradient-to-color: #BFBFBF;
  }

  .sm\\:hover\\:to-gray-400:hover{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .sm\\:hover\\:to-gray-425:hover{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .sm\\:hover\\:to-gray-450:hover{
    --gradient-to-color: #959595;
  }

  .sm\\:hover\\:to-gray-500:hover{
    --gradient-to-color: #727272;
  }

  .sm\\:hover\\:to-gray-600:hover{
    --gradient-to-color: #5a626b;
  }

  .sm\\:hover\\:to-gray-625:hover{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .sm\\:hover\\:to-gray-700:hover{
    --gradient-to-color: #464C59;
  }

  .sm\\:hover\\:to-gray-800:hover{
    --gradient-to-color: #3c3b3b;
  }

  .sm\\:hover\\:to-gray-200a50:hover{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .sm\\:hover\\:to-blue-50:hover{
    --gradient-to-color: #f2fbff;
  }

  .sm\\:hover\\:to-blue-100:hover{
    --gradient-to-color: #EBF6FC;
  }

  .sm\\:hover\\:to-blue-150:hover{
    --gradient-to-color: #E8EEF1;
  }

  .sm\\:hover\\:to-blue-200:hover{
    --gradient-to-color: #CCE6F5;
  }

  .sm\\:hover\\:to-blue-300:hover{
    --gradient-to-color: #73BFE7;
  }

  .sm\\:hover\\:to-blue-400:hover{
    --gradient-to-color: #4BA4F7;
  }

  .sm\\:hover\\:to-blue-500:hover{
    --gradient-to-color: #37A4DC;
  }

  .sm\\:hover\\:to-blue-600:hover{
    --gradient-to-color: #6AA2D6;
  }

  .sm\\:hover\\:to-blue-700:hover{
    --gradient-to-color: #456E9A;
  }

  .sm\\:hover\\:to-blue-750:hover{
    --gradient-to-color: #5682AA;
  }

  .sm\\:hover\\:to-blue-800:hover{
    --gradient-to-color: #1F4566;
  }

  .sm\\:hover\\:to-blue-900:hover{
    --gradient-to-color: #183453;
  }

  .sm\\:hover\\:to-blue-950:hover{
    --gradient-to-color: #041527;
  }

  .sm\\:hover\\:to-blue-500a25:hover{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .sm\\:hover\\:to-blue-500a50:hover{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .sm\\:hover\\:to-blue-700a75:hover{
    --gradient-to-color: #3B648D;
  }

  .sm\\:hover\\:to-blue-700a30:hover{
    --gradient-to-color: #2A5176;
  }

  .sm\\:hover\\:to-blue-750a25:hover{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .sm\\:hover\\:to-blue-750a15:hover{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .sm\\:hover\\:to-blue-800a60:hover{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .sm\\:hover\\:to-programEditorTabColors-1:hover{
    --gradient-to-color: #3cacae;
  }

  .sm\\:hover\\:to-programEditorTabColors-2:hover{
    --gradient-to-color: #8e346a;
  }

  .sm\\:hover\\:to-programEditorTabColors-3:hover{
    --gradient-to-color: #ff72b7;
  }

  .sm\\:hover\\:to-programEditorTabColors-4:hover{
    --gradient-to-color: #ce941c;
  }

  .sm\\:hover\\:to-programEditorTabColors-5:hover{
    --gradient-to-color: #b973d9;
  }

  .sm\\:hover\\:to-programEditorTabColors-6:hover{
    --gradient-to-color: #ff9082;
  }

  .sm\\:hover\\:to-programEditorTabColors-1h:hover{
    --gradient-to-color: #d9f2f2;
  }

  .sm\\:hover\\:to-programEditorTabColors-2h:hover{
    --gradient-to-color: #f1dae8;
  }

  .sm\\:hover\\:to-programEditorTabColors-3h:hover{
    --gradient-to-color: #ffe6f2;
  }

  .sm\\:hover\\:to-programEditorTabColors-4h:hover{
    --gradient-to-color: #f9ecd2;
  }

  .sm\\:hover\\:to-programEditorTabColors-5h:hover{
    --gradient-to-color: #f5ebfa;
  }

  .sm\\:hover\\:to-programEditorTabColors-6h:hover{
    --gradient-to-color: #ffe8e6;
  }

  .sm\\:hover\\:to-programEditorPresetTabColors-1:hover{
    --gradient-to-color: #798fa3;
  }

  .sm\\:hover\\:to-programEditorPresetTabColors-1h:hover{
    --gradient-to-color: #798fa3;
  }

  .sm\\:hover\\:to-borgScaleColors-0:hover{
    --gradient-to-color: #c5d1ff;
  }

  .sm\\:hover\\:to-borgScaleColors-1:hover{
    --gradient-to-color: #a0b5fc;
  }

  .sm\\:hover\\:to-borgScaleColors-2:hover{
    --gradient-to-color: #7492ff;
  }

  .sm\\:hover\\:to-borgScaleColors-3:hover{
    --gradient-to-color: #82bbf1;
  }

  .sm\\:hover\\:to-borgScaleColors-4:hover{
    --gradient-to-color: #4ba4f7;
  }

  .sm\\:hover\\:to-borgScaleColors-5:hover{
    --gradient-to-color: #9cdd57;
  }

  .sm\\:hover\\:to-borgScaleColors-6:hover{
    --gradient-to-color: #68af00;
  }

  .sm\\:hover\\:to-borgScaleColors-7:hover{
    --gradient-to-color: #f5e380;
  }

  .sm\\:hover\\:to-borgScaleColors-8:hover{
    --gradient-to-color: #ffc246;
  }

  .sm\\:hover\\:to-borgScaleColors-9:hover{
    --gradient-to-color: #ff782f;
  }

  .sm\\:hover\\:to-borgScaleColors-10:hover{
    --gradient-to-color: #f25757;
  }

  .sm\\:focus\\:from-transparent:focus{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:focus\\:from-focus:focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:focus\\:from-black:focus{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:focus\\:from-white:focus{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:focus\\:from-primary:focus{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:focus\\:from-disabled:focus{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .sm\\:focus\\:from-translucent-60:focus{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:focus\\:from-translucent-90:focus{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:focus\\:from-green-200:focus{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .sm\\:focus\\:from-green-400:focus{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .sm\\:focus\\:from-green-500:focus{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .sm\\:focus\\:from-green-600:focus{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .sm\\:focus\\:from-green-700:focus{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .sm\\:focus\\:from-green-400a50:focus{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .sm\\:focus\\:from-green-500a25:focus{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .sm\\:focus\\:from-yellow-200:focus{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .sm\\:focus\\:from-yellow-300:focus{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .sm\\:focus\\:from-yellow-500:focus{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .sm\\:focus\\:from-yellow-600:focus{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .sm\\:focus\\:from-yellow-700:focus{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .sm\\:focus\\:from-yellow-300a66:focus{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .sm\\:focus\\:from-yellow-500a25:focus{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .sm\\:focus\\:from-orange-200:focus{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .sm\\:focus\\:from-orange-400:focus{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .sm\\:focus\\:from-orange-500:focus{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .sm\\:focus\\:from-orange-800:focus{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .sm\\:focus\\:from-orange-900:focus{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .sm\\:focus\\:from-orange-500a25:focus{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .sm\\:focus\\:from-red-100:focus{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .sm\\:focus\\:from-red-150:focus{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .sm\\:focus\\:from-red-200:focus{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .sm\\:focus\\:from-red-300:focus{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .sm\\:focus\\:from-red-400:focus{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .sm\\:focus\\:from-red-500:focus{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .sm\\:focus\\:from-red-700:focus{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .sm\\:focus\\:from-gray-50:focus{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .sm\\:focus\\:from-gray-100:focus{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .sm\\:focus\\:from-gray-150:focus{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .sm\\:focus\\:from-gray-200:focus{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .sm\\:focus\\:from-gray-300:focus{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .sm\\:focus\\:from-gray-400:focus{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .sm\\:focus\\:from-gray-425:focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .sm\\:focus\\:from-gray-450:focus{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .sm\\:focus\\:from-gray-500:focus{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .sm\\:focus\\:from-gray-600:focus{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .sm\\:focus\\:from-gray-625:focus{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .sm\\:focus\\:from-gray-700:focus{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .sm\\:focus\\:from-gray-800:focus{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .sm\\:focus\\:from-gray-200a50:focus{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .sm\\:focus\\:from-blue-50:focus{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .sm\\:focus\\:from-blue-100:focus{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .sm\\:focus\\:from-blue-150:focus{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .sm\\:focus\\:from-blue-200:focus{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .sm\\:focus\\:from-blue-300:focus{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .sm\\:focus\\:from-blue-400:focus{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .sm\\:focus\\:from-blue-500:focus{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:focus\\:from-blue-600:focus{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .sm\\:focus\\:from-blue-700:focus{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .sm\\:focus\\:from-blue-750:focus{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:focus\\:from-blue-800:focus{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .sm\\:focus\\:from-blue-900:focus{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .sm\\:focus\\:from-blue-950:focus{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .sm\\:focus\\:from-blue-500a25:focus{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:focus\\:from-blue-500a50:focus{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:focus\\:from-blue-700a75:focus{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .sm\\:focus\\:from-blue-700a30:focus{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .sm\\:focus\\:from-blue-750a25:focus{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:focus\\:from-blue-750a15:focus{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:focus\\:from-blue-800a60:focus{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .sm\\:focus\\:from-programEditorTabColors-1:focus{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .sm\\:focus\\:from-programEditorTabColors-2:focus{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .sm\\:focus\\:from-programEditorTabColors-3:focus{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .sm\\:focus\\:from-programEditorTabColors-4:focus{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .sm\\:focus\\:from-programEditorTabColors-5:focus{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .sm\\:focus\\:from-programEditorTabColors-6:focus{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .sm\\:focus\\:from-programEditorTabColors-1h:focus{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .sm\\:focus\\:from-programEditorTabColors-2h:focus{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .sm\\:focus\\:from-programEditorTabColors-3h:focus{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .sm\\:focus\\:from-programEditorTabColors-4h:focus{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .sm\\:focus\\:from-programEditorTabColors-5h:focus{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .sm\\:focus\\:from-programEditorTabColors-6h:focus{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .sm\\:focus\\:from-programEditorPresetTabColors-1:focus{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .sm\\:focus\\:from-programEditorPresetTabColors-1h:focus{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .sm\\:focus\\:from-borgScaleColors-0:focus{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .sm\\:focus\\:from-borgScaleColors-1:focus{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .sm\\:focus\\:from-borgScaleColors-2:focus{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .sm\\:focus\\:from-borgScaleColors-3:focus{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .sm\\:focus\\:from-borgScaleColors-4:focus{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .sm\\:focus\\:from-borgScaleColors-5:focus{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .sm\\:focus\\:from-borgScaleColors-6:focus{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .sm\\:focus\\:from-borgScaleColors-7:focus{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .sm\\:focus\\:from-borgScaleColors-8:focus{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .sm\\:focus\\:from-borgScaleColors-9:focus{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .sm\\:focus\\:from-borgScaleColors-10:focus{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .sm\\:focus\\:via-transparent:focus{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:focus\\:via-focus:focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:focus\\:via-black:focus{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .sm\\:focus\\:via-white:focus{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:focus\\:via-primary:focus{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:focus\\:via-disabled:focus{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .sm\\:focus\\:via-translucent-60:focus{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:focus\\:via-translucent-90:focus{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .sm\\:focus\\:via-green-200:focus{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .sm\\:focus\\:via-green-400:focus{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .sm\\:focus\\:via-green-500:focus{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .sm\\:focus\\:via-green-600:focus{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .sm\\:focus\\:via-green-700:focus{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .sm\\:focus\\:via-green-400a50:focus{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .sm\\:focus\\:via-green-500a25:focus{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .sm\\:focus\\:via-yellow-200:focus{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .sm\\:focus\\:via-yellow-300:focus{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .sm\\:focus\\:via-yellow-500:focus{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .sm\\:focus\\:via-yellow-600:focus{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .sm\\:focus\\:via-yellow-700:focus{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .sm\\:focus\\:via-yellow-300a66:focus{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .sm\\:focus\\:via-yellow-500a25:focus{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .sm\\:focus\\:via-orange-200:focus{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .sm\\:focus\\:via-orange-400:focus{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .sm\\:focus\\:via-orange-500:focus{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .sm\\:focus\\:via-orange-800:focus{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .sm\\:focus\\:via-orange-900:focus{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .sm\\:focus\\:via-orange-500a25:focus{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .sm\\:focus\\:via-red-100:focus{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .sm\\:focus\\:via-red-150:focus{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .sm\\:focus\\:via-red-200:focus{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .sm\\:focus\\:via-red-300:focus{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .sm\\:focus\\:via-red-400:focus{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .sm\\:focus\\:via-red-500:focus{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .sm\\:focus\\:via-red-700:focus{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .sm\\:focus\\:via-gray-50:focus{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .sm\\:focus\\:via-gray-100:focus{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .sm\\:focus\\:via-gray-150:focus{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .sm\\:focus\\:via-gray-200:focus{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .sm\\:focus\\:via-gray-300:focus{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .sm\\:focus\\:via-gray-400:focus{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .sm\\:focus\\:via-gray-425:focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .sm\\:focus\\:via-gray-450:focus{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .sm\\:focus\\:via-gray-500:focus{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .sm\\:focus\\:via-gray-600:focus{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .sm\\:focus\\:via-gray-625:focus{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .sm\\:focus\\:via-gray-700:focus{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .sm\\:focus\\:via-gray-800:focus{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .sm\\:focus\\:via-gray-200a50:focus{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .sm\\:focus\\:via-blue-50:focus{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .sm\\:focus\\:via-blue-100:focus{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .sm\\:focus\\:via-blue-150:focus{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .sm\\:focus\\:via-blue-200:focus{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .sm\\:focus\\:via-blue-300:focus{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .sm\\:focus\\:via-blue-400:focus{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .sm\\:focus\\:via-blue-500:focus{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:focus\\:via-blue-600:focus{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .sm\\:focus\\:via-blue-700:focus{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .sm\\:focus\\:via-blue-750:focus{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:focus\\:via-blue-800:focus{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .sm\\:focus\\:via-blue-900:focus{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .sm\\:focus\\:via-blue-950:focus{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .sm\\:focus\\:via-blue-500a25:focus{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:focus\\:via-blue-500a50:focus{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .sm\\:focus\\:via-blue-700a75:focus{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .sm\\:focus\\:via-blue-700a30:focus{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .sm\\:focus\\:via-blue-750a25:focus{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:focus\\:via-blue-750a15:focus{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .sm\\:focus\\:via-blue-800a60:focus{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .sm\\:focus\\:via-programEditorTabColors-1:focus{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .sm\\:focus\\:via-programEditorTabColors-2:focus{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .sm\\:focus\\:via-programEditorTabColors-3:focus{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .sm\\:focus\\:via-programEditorTabColors-4:focus{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .sm\\:focus\\:via-programEditorTabColors-5:focus{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .sm\\:focus\\:via-programEditorTabColors-6:focus{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .sm\\:focus\\:via-programEditorTabColors-1h:focus{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .sm\\:focus\\:via-programEditorTabColors-2h:focus{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .sm\\:focus\\:via-programEditorTabColors-3h:focus{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .sm\\:focus\\:via-programEditorTabColors-4h:focus{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .sm\\:focus\\:via-programEditorTabColors-5h:focus{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .sm\\:focus\\:via-programEditorTabColors-6h:focus{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .sm\\:focus\\:via-programEditorPresetTabColors-1:focus{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .sm\\:focus\\:via-programEditorPresetTabColors-1h:focus{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .sm\\:focus\\:via-borgScaleColors-0:focus{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .sm\\:focus\\:via-borgScaleColors-1:focus{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .sm\\:focus\\:via-borgScaleColors-2:focus{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .sm\\:focus\\:via-borgScaleColors-3:focus{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .sm\\:focus\\:via-borgScaleColors-4:focus{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .sm\\:focus\\:via-borgScaleColors-5:focus{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .sm\\:focus\\:via-borgScaleColors-6:focus{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .sm\\:focus\\:via-borgScaleColors-7:focus{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .sm\\:focus\\:via-borgScaleColors-8:focus{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .sm\\:focus\\:via-borgScaleColors-9:focus{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .sm\\:focus\\:via-borgScaleColors-10:focus{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .sm\\:focus\\:to-transparent:focus{
    --gradient-to-color: transparent;
  }

  .sm\\:focus\\:to-focus:focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .sm\\:focus\\:to-black:focus{
    --gradient-to-color: #000;
  }

  .sm\\:focus\\:to-white:focus{
    --gradient-to-color: #fff;
  }

  .sm\\:focus\\:to-primary:focus{
    --gradient-to-color: #37A4DC;
  }

  .sm\\:focus\\:to-disabled:focus{
    --gradient-to-color: #BFBFBF;
  }

  .sm\\:focus\\:to-translucent-60:focus{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .sm\\:focus\\:to-translucent-90:focus{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .sm\\:focus\\:to-green-200:focus{
    --gradient-to-color: #f4fcea;
  }

  .sm\\:focus\\:to-green-400:focus{
    --gradient-to-color: #6CCA98;
  }

  .sm\\:focus\\:to-green-500:focus{
    --gradient-to-color: #97E812;
  }

  .sm\\:focus\\:to-green-600:focus{
    --gradient-to-color: #4f9112;
  }

  .sm\\:focus\\:to-green-700:focus{
    --gradient-to-color: #3e7211;
  }

  .sm\\:focus\\:to-green-400a50:focus{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .sm\\:focus\\:to-green-500a25:focus{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .sm\\:focus\\:to-yellow-200:focus{
    --gradient-to-color: #fff9eb;
  }

  .sm\\:focus\\:to-yellow-300:focus{
    --gradient-to-color: #ffe9bd;
  }

  .sm\\:focus\\:to-yellow-500:focus{
    --gradient-to-color: #FFC82C;
  }

  .sm\\:focus\\:to-yellow-600:focus{
    --gradient-to-color: #F7931E;
  }

  .sm\\:focus\\:to-yellow-700:focus{
    --gradient-to-color: #E1AD28;
  }

  .sm\\:focus\\:to-yellow-300a66:focus{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .sm\\:focus\\:to-yellow-500a25:focus{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .sm\\:focus\\:to-orange-200:focus{
    --gradient-to-color: #fdf0ea;
  }

  .sm\\:focus\\:to-orange-400:focus{
    --gradient-to-color: #f6c66f;
  }

  .sm\\:focus\\:to-orange-500:focus{
    --gradient-to-color: #F07313;
  }

  .sm\\:focus\\:to-orange-800:focus{
    --gradient-to-color: #db5d0c;
  }

  .sm\\:focus\\:to-orange-900:focus{
    --gradient-to-color: #b86814;
  }

  .sm\\:focus\\:to-orange-500a25:focus{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .sm\\:focus\\:to-red-100:focus{
    --gradient-to-color: #FEF5F5;
  }

  .sm\\:focus\\:to-red-150:focus{
    --gradient-to-color: #ffe9e8;
  }

  .sm\\:focus\\:to-red-200:focus{
    --gradient-to-color: #F8CECC;
  }

  .sm\\:focus\\:to-red-300:focus{
    --gradient-to-color: #ff8585;
  }

  .sm\\:focus\\:to-red-400:focus{
    --gradient-to-color: #ff3535;
  }

  .sm\\:focus\\:to-red-500:focus{
    --gradient-to-color: #DD4746;
  }

  .sm\\:focus\\:to-red-700:focus{
    --gradient-to-color: #A23C24;
  }

  .sm\\:focus\\:to-gray-50:focus{
    --gradient-to-color: #F9F9F9;
  }

  .sm\\:focus\\:to-gray-100:focus{
    --gradient-to-color: #F1F1F2;
  }

  .sm\\:focus\\:to-gray-150:focus{
    --gradient-to-color: #e6e6e6;
  }

  .sm\\:focus\\:to-gray-200:focus{
    --gradient-to-color: #E0E2E4;
  }

  .sm\\:focus\\:to-gray-300:focus{
    --gradient-to-color: #BFBFBF;
  }

  .sm\\:focus\\:to-gray-400:focus{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .sm\\:focus\\:to-gray-425:focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .sm\\:focus\\:to-gray-450:focus{
    --gradient-to-color: #959595;
  }

  .sm\\:focus\\:to-gray-500:focus{
    --gradient-to-color: #727272;
  }

  .sm\\:focus\\:to-gray-600:focus{
    --gradient-to-color: #5a626b;
  }

  .sm\\:focus\\:to-gray-625:focus{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .sm\\:focus\\:to-gray-700:focus{
    --gradient-to-color: #464C59;
  }

  .sm\\:focus\\:to-gray-800:focus{
    --gradient-to-color: #3c3b3b;
  }

  .sm\\:focus\\:to-gray-200a50:focus{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .sm\\:focus\\:to-blue-50:focus{
    --gradient-to-color: #f2fbff;
  }

  .sm\\:focus\\:to-blue-100:focus{
    --gradient-to-color: #EBF6FC;
  }

  .sm\\:focus\\:to-blue-150:focus{
    --gradient-to-color: #E8EEF1;
  }

  .sm\\:focus\\:to-blue-200:focus{
    --gradient-to-color: #CCE6F5;
  }

  .sm\\:focus\\:to-blue-300:focus{
    --gradient-to-color: #73BFE7;
  }

  .sm\\:focus\\:to-blue-400:focus{
    --gradient-to-color: #4BA4F7;
  }

  .sm\\:focus\\:to-blue-500:focus{
    --gradient-to-color: #37A4DC;
  }

  .sm\\:focus\\:to-blue-600:focus{
    --gradient-to-color: #6AA2D6;
  }

  .sm\\:focus\\:to-blue-700:focus{
    --gradient-to-color: #456E9A;
  }

  .sm\\:focus\\:to-blue-750:focus{
    --gradient-to-color: #5682AA;
  }

  .sm\\:focus\\:to-blue-800:focus{
    --gradient-to-color: #1F4566;
  }

  .sm\\:focus\\:to-blue-900:focus{
    --gradient-to-color: #183453;
  }

  .sm\\:focus\\:to-blue-950:focus{
    --gradient-to-color: #041527;
  }

  .sm\\:focus\\:to-blue-500a25:focus{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .sm\\:focus\\:to-blue-500a50:focus{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .sm\\:focus\\:to-blue-700a75:focus{
    --gradient-to-color: #3B648D;
  }

  .sm\\:focus\\:to-blue-700a30:focus{
    --gradient-to-color: #2A5176;
  }

  .sm\\:focus\\:to-blue-750a25:focus{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .sm\\:focus\\:to-blue-750a15:focus{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .sm\\:focus\\:to-blue-800a60:focus{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .sm\\:focus\\:to-programEditorTabColors-1:focus{
    --gradient-to-color: #3cacae;
  }

  .sm\\:focus\\:to-programEditorTabColors-2:focus{
    --gradient-to-color: #8e346a;
  }

  .sm\\:focus\\:to-programEditorTabColors-3:focus{
    --gradient-to-color: #ff72b7;
  }

  .sm\\:focus\\:to-programEditorTabColors-4:focus{
    --gradient-to-color: #ce941c;
  }

  .sm\\:focus\\:to-programEditorTabColors-5:focus{
    --gradient-to-color: #b973d9;
  }

  .sm\\:focus\\:to-programEditorTabColors-6:focus{
    --gradient-to-color: #ff9082;
  }

  .sm\\:focus\\:to-programEditorTabColors-1h:focus{
    --gradient-to-color: #d9f2f2;
  }

  .sm\\:focus\\:to-programEditorTabColors-2h:focus{
    --gradient-to-color: #f1dae8;
  }

  .sm\\:focus\\:to-programEditorTabColors-3h:focus{
    --gradient-to-color: #ffe6f2;
  }

  .sm\\:focus\\:to-programEditorTabColors-4h:focus{
    --gradient-to-color: #f9ecd2;
  }

  .sm\\:focus\\:to-programEditorTabColors-5h:focus{
    --gradient-to-color: #f5ebfa;
  }

  .sm\\:focus\\:to-programEditorTabColors-6h:focus{
    --gradient-to-color: #ffe8e6;
  }

  .sm\\:focus\\:to-programEditorPresetTabColors-1:focus{
    --gradient-to-color: #798fa3;
  }

  .sm\\:focus\\:to-programEditorPresetTabColors-1h:focus{
    --gradient-to-color: #798fa3;
  }

  .sm\\:focus\\:to-borgScaleColors-0:focus{
    --gradient-to-color: #c5d1ff;
  }

  .sm\\:focus\\:to-borgScaleColors-1:focus{
    --gradient-to-color: #a0b5fc;
  }

  .sm\\:focus\\:to-borgScaleColors-2:focus{
    --gradient-to-color: #7492ff;
  }

  .sm\\:focus\\:to-borgScaleColors-3:focus{
    --gradient-to-color: #82bbf1;
  }

  .sm\\:focus\\:to-borgScaleColors-4:focus{
    --gradient-to-color: #4ba4f7;
  }

  .sm\\:focus\\:to-borgScaleColors-5:focus{
    --gradient-to-color: #9cdd57;
  }

  .sm\\:focus\\:to-borgScaleColors-6:focus{
    --gradient-to-color: #68af00;
  }

  .sm\\:focus\\:to-borgScaleColors-7:focus{
    --gradient-to-color: #f5e380;
  }

  .sm\\:focus\\:to-borgScaleColors-8:focus{
    --gradient-to-color: #ffc246;
  }

  .sm\\:focus\\:to-borgScaleColors-9:focus{
    --gradient-to-color: #ff782f;
  }

  .sm\\:focus\\:to-borgScaleColors-10:focus{
    --gradient-to-color: #f25757;
  }

  .sm\\:bg-opacity-0{
    --bg-opacity: 0;
  }

  .sm\\:bg-opacity-25{
    --bg-opacity: .25;
  }

  .sm\\:bg-opacity-50{
    --bg-opacity: .5;
  }

  .sm\\:bg-opacity-75{
    --bg-opacity: .75;
  }

  .sm\\:bg-opacity-100{
    --bg-opacity: 1;
  }

  .sm\\:hover\\:bg-opacity-0:hover{
    --bg-opacity: 0;
  }

  .sm\\:hover\\:bg-opacity-25:hover{
    --bg-opacity: .25;
  }

  .sm\\:hover\\:bg-opacity-50:hover{
    --bg-opacity: .5;
  }

  .sm\\:hover\\:bg-opacity-75:hover{
    --bg-opacity: .75;
  }

  .sm\\:hover\\:bg-opacity-100:hover{
    --bg-opacity: 1;
  }

  .sm\\:focus\\:bg-opacity-0:focus{
    --bg-opacity: 0;
  }

  .sm\\:focus\\:bg-opacity-25:focus{
    --bg-opacity: .25;
  }

  .sm\\:focus\\:bg-opacity-50:focus{
    --bg-opacity: .5;
  }

  .sm\\:focus\\:bg-opacity-75:focus{
    --bg-opacity: .75;
  }

  .sm\\:focus\\:bg-opacity-100:focus{
    --bg-opacity: 1;
  }

  .sm\\:bg-bottom{
    background-position: bottom;
  }

  .sm\\:bg-center{
    background-position: center;
  }

  .sm\\:bg-left{
    background-position: left;
  }

  .sm\\:bg-left-bottom{
    background-position: left bottom;
  }

  .sm\\:bg-left-top{
    background-position: left top;
  }

  .sm\\:bg-right{
    background-position: right;
  }

  .sm\\:bg-right-bottom{
    background-position: right bottom;
  }

  .sm\\:bg-right-top{
    background-position: right top;
  }

  .sm\\:bg-top{
    background-position: top;
  }

  .sm\\:bg-repeat{
    background-repeat: repeat;
  }

  .sm\\:bg-no-repeat{
    background-repeat: no-repeat;
  }

  .sm\\:bg-repeat-x{
    background-repeat: repeat-x;
  }

  .sm\\:bg-repeat-y{
    background-repeat: repeat-y;
  }

  .sm\\:bg-repeat-round{
    background-repeat: round;
  }

  .sm\\:bg-repeat-space{
    background-repeat: space;
  }

  .sm\\:bg-auto{
    background-size: auto;
  }

  .sm\\:bg-cover{
    background-size: cover;
  }

  .sm\\:bg-contain{
    background-size: contain;
  }

  .sm\\:border-transparent{
    border-color: transparent;
  }

  .sm\\:border-focus{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .sm\\:border-black{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .sm\\:border-white{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .sm\\:border-primary{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .sm\\:border-disabled{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .sm\\:border-translucent-60{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .sm\\:border-translucent-90{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .sm\\:border-green-200{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .sm\\:border-green-400{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .sm\\:border-green-500{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .sm\\:border-green-600{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .sm\\:border-green-700{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .sm\\:border-green-400a50{
    border-color: rgba(108,202,152,0.50196);
  }

  .sm\\:border-green-500a25{
    border-color: rgba(151,232,18,0.09804);
  }

  .sm\\:border-yellow-200{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .sm\\:border-yellow-300{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .sm\\:border-yellow-500{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .sm\\:border-yellow-600{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .sm\\:border-yellow-700{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .sm\\:border-yellow-300a66{
    border-color: rgba(255,233,189,0.66667);
  }

  .sm\\:border-yellow-500a25{
    border-color: rgba(255,200,44,0.09804);
  }

  .sm\\:border-orange-200{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .sm\\:border-orange-400{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .sm\\:border-orange-500{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .sm\\:border-orange-800{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .sm\\:border-orange-900{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .sm\\:border-orange-500a25{
    border-color: rgba(240,115,23,0.09804);
  }

  .sm\\:border-red-100{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .sm\\:border-red-150{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .sm\\:border-red-200{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .sm\\:border-red-300{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .sm\\:border-red-400{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .sm\\:border-red-500{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .sm\\:border-red-700{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .sm\\:border-gray-50{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .sm\\:border-gray-100{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .sm\\:border-gray-150{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .sm\\:border-gray-200{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .sm\\:border-gray-300{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .sm\\:border-gray-400{
    border-color: rgba(114,114,114,0.8);
  }

  .sm\\:border-gray-425{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .sm\\:border-gray-450{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .sm\\:border-gray-500{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .sm\\:border-gray-600{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .sm\\:border-gray-625{
    border-color: rgba(90,98,107,0.8);
  }

  .sm\\:border-gray-700{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .sm\\:border-gray-800{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .sm\\:border-gray-200a50{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .sm\\:border-blue-50{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .sm\\:border-blue-100{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .sm\\:border-blue-150{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .sm\\:border-blue-200{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .sm\\:border-blue-300{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .sm\\:border-blue-400{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .sm\\:border-blue-500{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .sm\\:border-blue-600{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .sm\\:border-blue-700{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .sm\\:border-blue-750{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .sm\\:border-blue-800{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .sm\\:border-blue-900{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .sm\\:border-blue-950{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .sm\\:border-blue-500a25{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .sm\\:border-blue-500a50{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .sm\\:border-blue-700a75{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .sm\\:border-blue-700a30{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .sm\\:border-blue-750a25{
    border-color: rgba(86,130,170,0.09804);
  }

  .sm\\:border-blue-750a15{
    border-color: rgba(86,130,170,0.05882);
  }

  .sm\\:border-blue-800a60{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .sm\\:border-programEditorTabColors-1{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .sm\\:border-programEditorTabColors-2{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .sm\\:border-programEditorTabColors-3{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .sm\\:border-programEditorTabColors-4{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .sm\\:border-programEditorTabColors-5{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .sm\\:border-programEditorTabColors-6{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .sm\\:border-programEditorTabColors-1h{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .sm\\:border-programEditorTabColors-2h{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .sm\\:border-programEditorTabColors-3h{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .sm\\:border-programEditorTabColors-4h{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .sm\\:border-programEditorTabColors-5h{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .sm\\:border-programEditorTabColors-6h{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .sm\\:border-programEditorPresetTabColors-1{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .sm\\:border-programEditorPresetTabColors-1h{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .sm\\:border-borgScaleColors-0{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .sm\\:border-borgScaleColors-1{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .sm\\:border-borgScaleColors-2{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .sm\\:border-borgScaleColors-3{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .sm\\:border-borgScaleColors-4{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .sm\\:border-borgScaleColors-5{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .sm\\:border-borgScaleColors-6{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .sm\\:border-borgScaleColors-7{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .sm\\:border-borgScaleColors-8{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .sm\\:border-borgScaleColors-9{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .sm\\:border-borgScaleColors-10{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .sm\\:hover\\:border-transparent:hover{
    border-color: transparent;
  }

  .sm\\:hover\\:border-focus:hover{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .sm\\:hover\\:border-black:hover{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .sm\\:hover\\:border-white:hover{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .sm\\:hover\\:border-primary:hover{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .sm\\:hover\\:border-disabled:hover{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .sm\\:hover\\:border-translucent-60:hover{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .sm\\:hover\\:border-translucent-90:hover{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .sm\\:hover\\:border-green-200:hover{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .sm\\:hover\\:border-green-400:hover{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .sm\\:hover\\:border-green-500:hover{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .sm\\:hover\\:border-green-600:hover{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .sm\\:hover\\:border-green-700:hover{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .sm\\:hover\\:border-green-400a50:hover{
    border-color: rgba(108,202,152,0.50196);
  }

  .sm\\:hover\\:border-green-500a25:hover{
    border-color: rgba(151,232,18,0.09804);
  }

  .sm\\:hover\\:border-yellow-200:hover{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .sm\\:hover\\:border-yellow-300:hover{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .sm\\:hover\\:border-yellow-500:hover{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .sm\\:hover\\:border-yellow-600:hover{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .sm\\:hover\\:border-yellow-700:hover{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .sm\\:hover\\:border-yellow-300a66:hover{
    border-color: rgba(255,233,189,0.66667);
  }

  .sm\\:hover\\:border-yellow-500a25:hover{
    border-color: rgba(255,200,44,0.09804);
  }

  .sm\\:hover\\:border-orange-200:hover{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .sm\\:hover\\:border-orange-400:hover{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .sm\\:hover\\:border-orange-500:hover{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .sm\\:hover\\:border-orange-800:hover{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .sm\\:hover\\:border-orange-900:hover{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .sm\\:hover\\:border-orange-500a25:hover{
    border-color: rgba(240,115,23,0.09804);
  }

  .sm\\:hover\\:border-red-100:hover{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .sm\\:hover\\:border-red-150:hover{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .sm\\:hover\\:border-red-200:hover{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .sm\\:hover\\:border-red-300:hover{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .sm\\:hover\\:border-red-400:hover{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .sm\\:hover\\:border-red-500:hover{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .sm\\:hover\\:border-red-700:hover{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-50:hover{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-100:hover{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-150:hover{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-200:hover{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-300:hover{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-400:hover{
    border-color: rgba(114,114,114,0.8);
  }

  .sm\\:hover\\:border-gray-425:hover{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .sm\\:hover\\:border-gray-450:hover{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-500:hover{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-600:hover{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-625:hover{
    border-color: rgba(90,98,107,0.8);
  }

  .sm\\:hover\\:border-gray-700:hover{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-800:hover{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .sm\\:hover\\:border-gray-200a50:hover{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .sm\\:hover\\:border-blue-50:hover{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-100:hover{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-150:hover{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-200:hover{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-300:hover{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-400:hover{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-500:hover{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-600:hover{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-700:hover{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-750:hover{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-800:hover{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-900:hover{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-950:hover{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-500a25:hover{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .sm\\:hover\\:border-blue-500a50:hover{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .sm\\:hover\\:border-blue-700a75:hover{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-700a30:hover{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .sm\\:hover\\:border-blue-750a25:hover{
    border-color: rgba(86,130,170,0.09804);
  }

  .sm\\:hover\\:border-blue-750a15:hover{
    border-color: rgba(86,130,170,0.05882);
  }

  .sm\\:hover\\:border-blue-800a60:hover{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .sm\\:hover\\:border-programEditorTabColors-1:hover{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .sm\\:hover\\:border-programEditorTabColors-2:hover{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .sm\\:hover\\:border-programEditorTabColors-3:hover{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .sm\\:hover\\:border-programEditorTabColors-4:hover{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .sm\\:hover\\:border-programEditorTabColors-5:hover{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .sm\\:hover\\:border-programEditorTabColors-6:hover{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .sm\\:hover\\:border-programEditorTabColors-1h:hover{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .sm\\:hover\\:border-programEditorTabColors-2h:hover{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .sm\\:hover\\:border-programEditorTabColors-3h:hover{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .sm\\:hover\\:border-programEditorTabColors-4h:hover{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .sm\\:hover\\:border-programEditorTabColors-5h:hover{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .sm\\:hover\\:border-programEditorTabColors-6h:hover{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .sm\\:hover\\:border-programEditorPresetTabColors-1:hover{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .sm\\:hover\\:border-programEditorPresetTabColors-1h:hover{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .sm\\:hover\\:border-borgScaleColors-0:hover{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .sm\\:hover\\:border-borgScaleColors-1:hover{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .sm\\:hover\\:border-borgScaleColors-2:hover{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .sm\\:hover\\:border-borgScaleColors-3:hover{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .sm\\:hover\\:border-borgScaleColors-4:hover{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .sm\\:hover\\:border-borgScaleColors-5:hover{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .sm\\:hover\\:border-borgScaleColors-6:hover{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .sm\\:hover\\:border-borgScaleColors-7:hover{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .sm\\:hover\\:border-borgScaleColors-8:hover{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .sm\\:hover\\:border-borgScaleColors-9:hover{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .sm\\:hover\\:border-borgScaleColors-10:hover{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .sm\\:focus\\:border-transparent:focus{
    border-color: transparent;
  }

  .sm\\:focus\\:border-focus:focus{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .sm\\:focus\\:border-black:focus{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .sm\\:focus\\:border-white:focus{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .sm\\:focus\\:border-primary:focus{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .sm\\:focus\\:border-disabled:focus{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .sm\\:focus\\:border-translucent-60:focus{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .sm\\:focus\\:border-translucent-90:focus{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .sm\\:focus\\:border-green-200:focus{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .sm\\:focus\\:border-green-400:focus{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .sm\\:focus\\:border-green-500:focus{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .sm\\:focus\\:border-green-600:focus{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .sm\\:focus\\:border-green-700:focus{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .sm\\:focus\\:border-green-400a50:focus{
    border-color: rgba(108,202,152,0.50196);
  }

  .sm\\:focus\\:border-green-500a25:focus{
    border-color: rgba(151,232,18,0.09804);
  }

  .sm\\:focus\\:border-yellow-200:focus{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .sm\\:focus\\:border-yellow-300:focus{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .sm\\:focus\\:border-yellow-500:focus{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .sm\\:focus\\:border-yellow-600:focus{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .sm\\:focus\\:border-yellow-700:focus{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .sm\\:focus\\:border-yellow-300a66:focus{
    border-color: rgba(255,233,189,0.66667);
  }

  .sm\\:focus\\:border-yellow-500a25:focus{
    border-color: rgba(255,200,44,0.09804);
  }

  .sm\\:focus\\:border-orange-200:focus{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .sm\\:focus\\:border-orange-400:focus{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .sm\\:focus\\:border-orange-500:focus{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .sm\\:focus\\:border-orange-800:focus{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .sm\\:focus\\:border-orange-900:focus{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .sm\\:focus\\:border-orange-500a25:focus{
    border-color: rgba(240,115,23,0.09804);
  }

  .sm\\:focus\\:border-red-100:focus{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .sm\\:focus\\:border-red-150:focus{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .sm\\:focus\\:border-red-200:focus{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .sm\\:focus\\:border-red-300:focus{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .sm\\:focus\\:border-red-400:focus{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .sm\\:focus\\:border-red-500:focus{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .sm\\:focus\\:border-red-700:focus{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-50:focus{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-100:focus{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-150:focus{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-200:focus{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-300:focus{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-400:focus{
    border-color: rgba(114,114,114,0.8);
  }

  .sm\\:focus\\:border-gray-425:focus{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .sm\\:focus\\:border-gray-450:focus{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-500:focus{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-600:focus{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-625:focus{
    border-color: rgba(90,98,107,0.8);
  }

  .sm\\:focus\\:border-gray-700:focus{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-800:focus{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .sm\\:focus\\:border-gray-200a50:focus{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .sm\\:focus\\:border-blue-50:focus{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-100:focus{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-150:focus{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-200:focus{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-300:focus{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-400:focus{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-500:focus{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-600:focus{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-700:focus{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-750:focus{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-800:focus{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-900:focus{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-950:focus{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-500a25:focus{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .sm\\:focus\\:border-blue-500a50:focus{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .sm\\:focus\\:border-blue-700a75:focus{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-700a30:focus{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .sm\\:focus\\:border-blue-750a25:focus{
    border-color: rgba(86,130,170,0.09804);
  }

  .sm\\:focus\\:border-blue-750a15:focus{
    border-color: rgba(86,130,170,0.05882);
  }

  .sm\\:focus\\:border-blue-800a60:focus{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .sm\\:focus\\:border-programEditorTabColors-1:focus{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .sm\\:focus\\:border-programEditorTabColors-2:focus{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .sm\\:focus\\:border-programEditorTabColors-3:focus{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .sm\\:focus\\:border-programEditorTabColors-4:focus{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .sm\\:focus\\:border-programEditorTabColors-5:focus{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .sm\\:focus\\:border-programEditorTabColors-6:focus{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .sm\\:focus\\:border-programEditorTabColors-1h:focus{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .sm\\:focus\\:border-programEditorTabColors-2h:focus{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .sm\\:focus\\:border-programEditorTabColors-3h:focus{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .sm\\:focus\\:border-programEditorTabColors-4h:focus{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .sm\\:focus\\:border-programEditorTabColors-5h:focus{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .sm\\:focus\\:border-programEditorTabColors-6h:focus{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .sm\\:focus\\:border-programEditorPresetTabColors-1:focus{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .sm\\:focus\\:border-programEditorPresetTabColors-1h:focus{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .sm\\:focus\\:border-borgScaleColors-0:focus{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .sm\\:focus\\:border-borgScaleColors-1:focus{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .sm\\:focus\\:border-borgScaleColors-2:focus{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .sm\\:focus\\:border-borgScaleColors-3:focus{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .sm\\:focus\\:border-borgScaleColors-4:focus{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .sm\\:focus\\:border-borgScaleColors-5:focus{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .sm\\:focus\\:border-borgScaleColors-6:focus{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .sm\\:focus\\:border-borgScaleColors-7:focus{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .sm\\:focus\\:border-borgScaleColors-8:focus{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .sm\\:focus\\:border-borgScaleColors-9:focus{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .sm\\:focus\\:border-borgScaleColors-10:focus{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .sm\\:border-opacity-0{
    --border-opacity: 0;
  }

  .sm\\:border-opacity-25{
    --border-opacity: .25;
  }

  .sm\\:border-opacity-50{
    --border-opacity: .5;
  }

  .sm\\:border-opacity-75{
    --border-opacity: .75;
  }

  .sm\\:border-opacity-100{
    --border-opacity: 1;
  }

  .sm\\:hover\\:border-opacity-0:hover{
    --border-opacity: 0;
  }

  .sm\\:hover\\:border-opacity-25:hover{
    --border-opacity: .25;
  }

  .sm\\:hover\\:border-opacity-50:hover{
    --border-opacity: .5;
  }

  .sm\\:hover\\:border-opacity-75:hover{
    --border-opacity: .75;
  }

  .sm\\:hover\\:border-opacity-100:hover{
    --border-opacity: 1;
  }

  .sm\\:focus\\:border-opacity-0:focus{
    --border-opacity: 0;
  }

  .sm\\:focus\\:border-opacity-25:focus{
    --border-opacity: .25;
  }

  .sm\\:focus\\:border-opacity-50:focus{
    --border-opacity: .5;
  }

  .sm\\:focus\\:border-opacity-75:focus{
    --border-opacity: .75;
  }

  .sm\\:focus\\:border-opacity-100:focus{
    --border-opacity: 1;
  }

  .sm\\:rounded-none{
    border-radius: 0;
  }

  .sm\\:rounded-sm{
    border-radius: .25rem;
  }

  .sm\\:rounded{
    border-radius: .375rem;
  }

  .sm\\:rounded-lg{
    border-radius: .5rem;
  }

  .sm\\:rounded-xl{
    border-radius: .75rem;
  }

  .sm\\:rounded-full{
    border-radius: 9999px;
  }

  .sm\\:rounded-t-none{
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .sm\\:rounded-r-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .sm\\:rounded-b-none{
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .sm\\:rounded-l-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .sm\\:rounded-t-sm{
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
  }

  .sm\\:rounded-r-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  .sm\\:rounded-b-sm{
    border-bottom-right-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  .sm\\:rounded-l-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  .sm\\:rounded-t{
    border-top-left-radius: .375rem;
    border-top-right-radius: .375rem;
  }

  .sm\\:rounded-r{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  .sm\\:rounded-b{
    border-bottom-right-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  .sm\\:rounded-l{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  .sm\\:rounded-t-lg{
    border-top-left-radius: .5rem;
    border-top-right-radius: .5rem;
  }

  .sm\\:rounded-r-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  .sm\\:rounded-b-lg{
    border-bottom-right-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  .sm\\:rounded-l-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  .sm\\:rounded-t-xl{
    border-top-left-radius: .75rem;
    border-top-right-radius: .75rem;
  }

  .sm\\:rounded-r-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  .sm\\:rounded-b-xl{
    border-bottom-right-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  .sm\\:rounded-l-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  .sm\\:rounded-t-full{
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }

  .sm\\:rounded-r-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  .sm\\:rounded-b-full{
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .sm\\:rounded-l-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .sm\\:rounded-tl-none{
    border-top-left-radius: 0;
  }

  .sm\\:rounded-tr-none{
    border-top-right-radius: 0;
  }

  .sm\\:rounded-br-none{
    border-bottom-right-radius: 0;
  }

  .sm\\:rounded-bl-none{
    border-bottom-left-radius: 0;
  }

  .sm\\:rounded-tl-sm{
    border-top-left-radius: .25rem;
  }

  .sm\\:rounded-tr-sm{
    border-top-right-radius: .25rem;
  }

  .sm\\:rounded-br-sm{
    border-bottom-right-radius: .25rem;
  }

  .sm\\:rounded-bl-sm{
    border-bottom-left-radius: .25rem;
  }

  .sm\\:rounded-tl{
    border-top-left-radius: .375rem;
  }

  .sm\\:rounded-tr{
    border-top-right-radius: .375rem;
  }

  .sm\\:rounded-br{
    border-bottom-right-radius: .375rem;
  }

  .sm\\:rounded-bl{
    border-bottom-left-radius: .375rem;
  }

  .sm\\:rounded-tl-lg{
    border-top-left-radius: .5rem;
  }

  .sm\\:rounded-tr-lg{
    border-top-right-radius: .5rem;
  }

  .sm\\:rounded-br-lg{
    border-bottom-right-radius: .5rem;
  }

  .sm\\:rounded-bl-lg{
    border-bottom-left-radius: .5rem;
  }

  .sm\\:rounded-tl-xl{
    border-top-left-radius: .75rem;
  }

  .sm\\:rounded-tr-xl{
    border-top-right-radius: .75rem;
  }

  .sm\\:rounded-br-xl{
    border-bottom-right-radius: .75rem;
  }

  .sm\\:rounded-bl-xl{
    border-bottom-left-radius: .75rem;
  }

  .sm\\:rounded-tl-full{
    border-top-left-radius: 9999px;
  }

  .sm\\:rounded-tr-full{
    border-top-right-radius: 9999px;
  }

  .sm\\:rounded-br-full{
    border-bottom-right-radius: 9999px;
  }

  .sm\\:rounded-bl-full{
    border-bottom-left-radius: 9999px;
  }

  .sm\\:border-solid{
    border-style: solid;
  }

  .sm\\:border-dashed{
    border-style: dashed;
  }

  .sm\\:border-dotted{
    border-style: dotted;
  }

  .sm\\:border-double{
    border-style: double;
  }

  .sm\\:border-none{
    border-style: none;
  }

  .sm\\:border-0{
    border-width: 0;
  }

  .sm\\:border-2{
    border-width: 2px;
  }

  .sm\\:border-3{
    border-width: 3px;
  }

  .sm\\:border-4{
    border-width: 4px;
  }

  .sm\\:border-5{
    border-width: 5px;
  }

  .sm\\:border-6{
    border-width: 6px;
  }

  .sm\\:border-8{
    border-width: 8px;
  }

  .sm\\:border{
    border-width: 1px;
  }

  .sm\\:border-t-0{
    border-top-width: 0;
  }

  .sm\\:border-r-0{
    border-right-width: 0;
  }

  .sm\\:border-b-0{
    border-bottom-width: 0;
  }

  .sm\\:border-l-0{
    border-left-width: 0;
  }

  .sm\\:border-t-2{
    border-top-width: 2px;
  }

  .sm\\:border-r-2{
    border-right-width: 2px;
  }

  .sm\\:border-b-2{
    border-bottom-width: 2px;
  }

  .sm\\:border-l-2{
    border-left-width: 2px;
  }

  .sm\\:border-t-3{
    border-top-width: 3px;
  }

  .sm\\:border-r-3{
    border-right-width: 3px;
  }

  .sm\\:border-b-3{
    border-bottom-width: 3px;
  }

  .sm\\:border-l-3{
    border-left-width: 3px;
  }

  .sm\\:border-t-4{
    border-top-width: 4px;
  }

  .sm\\:border-r-4{
    border-right-width: 4px;
  }

  .sm\\:border-b-4{
    border-bottom-width: 4px;
  }

  .sm\\:border-l-4{
    border-left-width: 4px;
  }

  .sm\\:border-t-5{
    border-top-width: 5px;
  }

  .sm\\:border-r-5{
    border-right-width: 5px;
  }

  .sm\\:border-b-5{
    border-bottom-width: 5px;
  }

  .sm\\:border-l-5{
    border-left-width: 5px;
  }

  .sm\\:border-t-6{
    border-top-width: 6px;
  }

  .sm\\:border-r-6{
    border-right-width: 6px;
  }

  .sm\\:border-b-6{
    border-bottom-width: 6px;
  }

  .sm\\:border-l-6{
    border-left-width: 6px;
  }

  .sm\\:border-t-8{
    border-top-width: 8px;
  }

  .sm\\:border-r-8{
    border-right-width: 8px;
  }

  .sm\\:border-b-8{
    border-bottom-width: 8px;
  }

  .sm\\:border-l-8{
    border-left-width: 8px;
  }

  .sm\\:border-t{
    border-top-width: 1px;
  }

  .sm\\:border-r{
    border-right-width: 1px;
  }

  .sm\\:border-b{
    border-bottom-width: 1px;
  }

  .sm\\:border-l{
    border-left-width: 1px;
  }

  .sm\\:first\\:border-0:first-child{
    border-width: 0;
  }

  .sm\\:first\\:border-2:first-child{
    border-width: 2px;
  }

  .sm\\:first\\:border-3:first-child{
    border-width: 3px;
  }

  .sm\\:first\\:border-4:first-child{
    border-width: 4px;
  }

  .sm\\:first\\:border-5:first-child{
    border-width: 5px;
  }

  .sm\\:first\\:border-6:first-child{
    border-width: 6px;
  }

  .sm\\:first\\:border-8:first-child{
    border-width: 8px;
  }

  .sm\\:first\\:border:first-child{
    border-width: 1px;
  }

  .sm\\:first\\:border-t-0:first-child{
    border-top-width: 0;
  }

  .sm\\:first\\:border-r-0:first-child{
    border-right-width: 0;
  }

  .sm\\:first\\:border-b-0:first-child{
    border-bottom-width: 0;
  }

  .sm\\:first\\:border-l-0:first-child{
    border-left-width: 0;
  }

  .sm\\:first\\:border-t-2:first-child{
    border-top-width: 2px;
  }

  .sm\\:first\\:border-r-2:first-child{
    border-right-width: 2px;
  }

  .sm\\:first\\:border-b-2:first-child{
    border-bottom-width: 2px;
  }

  .sm\\:first\\:border-l-2:first-child{
    border-left-width: 2px;
  }

  .sm\\:first\\:border-t-3:first-child{
    border-top-width: 3px;
  }

  .sm\\:first\\:border-r-3:first-child{
    border-right-width: 3px;
  }

  .sm\\:first\\:border-b-3:first-child{
    border-bottom-width: 3px;
  }

  .sm\\:first\\:border-l-3:first-child{
    border-left-width: 3px;
  }

  .sm\\:first\\:border-t-4:first-child{
    border-top-width: 4px;
  }

  .sm\\:first\\:border-r-4:first-child{
    border-right-width: 4px;
  }

  .sm\\:first\\:border-b-4:first-child{
    border-bottom-width: 4px;
  }

  .sm\\:first\\:border-l-4:first-child{
    border-left-width: 4px;
  }

  .sm\\:first\\:border-t-5:first-child{
    border-top-width: 5px;
  }

  .sm\\:first\\:border-r-5:first-child{
    border-right-width: 5px;
  }

  .sm\\:first\\:border-b-5:first-child{
    border-bottom-width: 5px;
  }

  .sm\\:first\\:border-l-5:first-child{
    border-left-width: 5px;
  }

  .sm\\:first\\:border-t-6:first-child{
    border-top-width: 6px;
  }

  .sm\\:first\\:border-r-6:first-child{
    border-right-width: 6px;
  }

  .sm\\:first\\:border-b-6:first-child{
    border-bottom-width: 6px;
  }

  .sm\\:first\\:border-l-6:first-child{
    border-left-width: 6px;
  }

  .sm\\:first\\:border-t-8:first-child{
    border-top-width: 8px;
  }

  .sm\\:first\\:border-r-8:first-child{
    border-right-width: 8px;
  }

  .sm\\:first\\:border-b-8:first-child{
    border-bottom-width: 8px;
  }

  .sm\\:first\\:border-l-8:first-child{
    border-left-width: 8px;
  }

  .sm\\:first\\:border-t:first-child{
    border-top-width: 1px;
  }

  .sm\\:first\\:border-r:first-child{
    border-right-width: 1px;
  }

  .sm\\:first\\:border-b:first-child{
    border-bottom-width: 1px;
  }

  .sm\\:first\\:border-l:first-child{
    border-left-width: 1px;
  }

  .sm\\:box-border{
    box-sizing: border-box;
  }

  .sm\\:box-content{
    box-sizing: content-box;
  }

  .sm\\:cursor-auto{
    cursor: auto;
  }

  .sm\\:cursor-default{
    cursor: default;
  }

  .sm\\:cursor-pointer{
    cursor: pointer;
  }

  .sm\\:cursor-wait{
    cursor: wait;
  }

  .sm\\:cursor-move{
    cursor: move;
  }

  .sm\\:cursor-not-allowed{
    cursor: not-allowed;
  }

  .sm\\:block{
    display: block;
  }

  .sm\\:inline-block{
    display: inline-block;
  }

  .sm\\:inline{
    display: inline;
  }

  .sm\\:flex{
    display: flex;
  }

  .sm\\:inline-flex{
    display: inline-flex;
  }

  .sm\\:table{
    display: table;
  }

  .sm\\:table-caption{
    display: table-caption;
  }

  .sm\\:table-cell{
    display: table-cell;
  }

  .sm\\:table-column{
    display: table-column;
  }

  .sm\\:table-column-group{
    display: table-column-group;
  }

  .sm\\:table-footer-group{
    display: table-footer-group;
  }

  .sm\\:table-header-group{
    display: table-header-group;
  }

  .sm\\:table-row-group{
    display: table-row-group;
  }

  .sm\\:table-row{
    display: table-row;
  }

  .sm\\:flow-root{
    display: flow-root;
  }

  .sm\\:grid{
    display: grid;
  }

  .sm\\:inline-grid{
    display: inline-grid;
  }

  .sm\\:contents{
    display: contents;
  }

  .sm\\:hidden{
    display: none;
  }

  .sm\\:flex-row{
    flex-direction: row;
  }

  .sm\\:flex-row-reverse{
    flex-direction: row-reverse;
  }

  .sm\\:flex-col{
    flex-direction: column;
  }

  .sm\\:flex-col-reverse{
    flex-direction: column-reverse;
  }

  .sm\\:flex-wrap{
    flex-wrap: wrap;
  }

  .sm\\:flex-wrap-reverse{
    flex-wrap: wrap-reverse;
  }

  .sm\\:flex-no-wrap{
    flex-wrap: nowrap;
  }

  .sm\\:place-items-auto{
    align-items: auto;
    justify-items: auto;
    place-items: auto;
  }

  .sm\\:place-items-start{
    align-items: start;
    justify-items: start;
    place-items: start;
  }

  .sm\\:place-items-end{
    align-items: end;
    justify-items: end;
    place-items: end;
  }

  .sm\\:place-items-center{
    align-items: center;
    justify-items: center;
    place-items: center;
  }

  .sm\\:place-items-stretch{
    align-items: stretch;
    justify-items: stretch;
    place-items: stretch;
  }

  .sm\\:place-content-center{
    align-content: center;
    justify-content: center;
    place-content: center;
  }

  .sm\\:place-content-start{
    align-content: start;
    justify-content: start;
    place-content: start;
  }

  .sm\\:place-content-end{
    align-content: end;
    justify-content: end;
    place-content: end;
  }

  .sm\\:place-content-between{
    align-content: space-between;
    justify-content: space-between;
    place-content: space-between;
  }

  .sm\\:place-content-around{
    align-content: space-around;
    justify-content: space-around;
    place-content: space-around;
  }

  .sm\\:place-content-evenly{
    align-content: space-evenly;
    justify-content: space-evenly;
    place-content: space-evenly;
  }

  .sm\\:place-content-stretch{
    align-content: stretch;
    justify-content: stretch;
    place-content: stretch;
  }

  .sm\\:place-self-auto{
    align-self: auto;
    justify-self: auto;
    place-self: auto;
  }

  .sm\\:place-self-start{
    align-self: start;
    justify-self: start;
    place-self: start;
  }

  .sm\\:place-self-end{
    align-self: end;
    justify-self: end;
    place-self: end;
  }

  .sm\\:place-self-center{
    align-self: center;
    justify-self: center;
    place-self: center;
  }

  .sm\\:place-self-stretch{
    align-self: stretch;
    justify-self: stretch;
    place-self: stretch;
  }

  .sm\\:items-start{
    align-items: flex-start;
  }

  .sm\\:items-end{
    align-items: flex-end;
  }

  .sm\\:items-center{
    align-items: center;
  }

  .sm\\:items-baseline{
    align-items: baseline;
  }

  .sm\\:items-stretch{
    align-items: stretch;
  }

  .sm\\:content-center{
    align-content: center;
  }

  .sm\\:content-start{
    align-content: flex-start;
  }

  .sm\\:content-end{
    align-content: flex-end;
  }

  .sm\\:content-between{
    align-content: space-between;
  }

  .sm\\:content-around{
    align-content: space-around;
  }

  .sm\\:content-evenly{
    align-content: space-evenly;
  }

  .sm\\:self-auto{
    align-self: auto;
  }

  .sm\\:self-start{
    align-self: flex-start;
  }

  .sm\\:self-end{
    align-self: flex-end;
  }

  .sm\\:self-center{
    align-self: center;
  }

  .sm\\:self-stretch{
    align-self: stretch;
  }

  .sm\\:justify-items-auto{
    justify-items: auto;
  }

  .sm\\:justify-items-start{
    justify-items: start;
  }

  .sm\\:justify-items-end{
    justify-items: end;
  }

  .sm\\:justify-items-center{
    justify-items: center;
  }

  .sm\\:justify-items-stretch{
    justify-items: stretch;
  }

  .sm\\:justify-start{
    justify-content: flex-start;
  }

  .sm\\:justify-end{
    justify-content: flex-end;
  }

  .sm\\:justify-center{
    justify-content: center;
  }

  .sm\\:justify-between{
    justify-content: space-between;
  }

  .sm\\:justify-around{
    justify-content: space-around;
  }

  .sm\\:justify-evenly{
    justify-content: space-evenly;
  }

  .sm\\:justify-self-auto{
    justify-self: auto;
  }

  .sm\\:justify-self-start{
    justify-self: start;
  }

  .sm\\:justify-self-end{
    justify-self: end;
  }

  .sm\\:justify-self-center{
    justify-self: center;
  }

  .sm\\:justify-self-stretch{
    justify-self: stretch;
  }

  .sm\\:flex-1{
    flex: 1 1 0%;
  }

  .sm\\:flex-auto{
    flex: 1 1 auto;
  }

  .sm\\:flex-initial{
    flex: 0 1 auto;
  }

  .sm\\:flex-none{
    flex: none;
  }

  .sm\\:flex-grow-0{
    flex-grow: 0;
  }

  .sm\\:flex-grow{
    flex-grow: 1;
  }

  .sm\\:flex-shrink-0{
    flex-shrink: 0;
  }

  .sm\\:flex-shrink{
    flex-shrink: 1;
  }

  .sm\\:order-1{
    order: 1;
  }

  .sm\\:order-2{
    order: 2;
  }

  .sm\\:order-3{
    order: 3;
  }

  .sm\\:order-4{
    order: 4;
  }

  .sm\\:order-5{
    order: 5;
  }

  .sm\\:order-6{
    order: 6;
  }

  .sm\\:order-7{
    order: 7;
  }

  .sm\\:order-8{
    order: 8;
  }

  .sm\\:order-9{
    order: 9;
  }

  .sm\\:order-10{
    order: 10;
  }

  .sm\\:order-11{
    order: 11;
  }

  .sm\\:order-12{
    order: 12;
  }

  .sm\\:order-first{
    order: -9999;
  }

  .sm\\:order-last{
    order: 9999;
  }

  .sm\\:order-none{
    order: 0;
  }

  .sm\\:float-right{
    float: right;
  }

  .sm\\:float-left{
    float: left;
  }

  .sm\\:float-none{
    float: none;
  }

  .sm\\:clearfix:after{
    content: "";
    display: table;
    clear: both;
  }

  .sm\\:clear-left{
    clear: left;
  }

  .sm\\:clear-right{
    clear: right;
  }

  .sm\\:clear-both{
    clear: both;
  }

  .sm\\:clear-none{
    clear: none;
  }

  .sm\\:font-sans{
    font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }

  .sm\\:font-serif{
    font-family: Georgia, Cambria, "Times New Roman", Times, serif;
  }

  .sm\\:font-mono{
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }

  .sm\\:font-light{
    font-weight: 100;
  }

  .sm\\:font-regular{
    font-weight: 400;
  }

  .sm\\:font-semibold{
    font-weight: 600;
  }

  .sm\\:font-bold{
    font-weight: 700;
  }

  .sm\\:hover\\:font-light:hover{
    font-weight: 100;
  }

  .sm\\:hover\\:font-regular:hover{
    font-weight: 400;
  }

  .sm\\:hover\\:font-semibold:hover{
    font-weight: 600;
  }

  .sm\\:hover\\:font-bold:hover{
    font-weight: 700;
  }

  .sm\\:focus\\:font-light:focus{
    font-weight: 100;
  }

  .sm\\:focus\\:font-regular:focus{
    font-weight: 400;
  }

  .sm\\:focus\\:font-semibold:focus{
    font-weight: 600;
  }

  .sm\\:focus\\:font-bold:focus{
    font-weight: 700;
  }

  .sm\\:h-0{
    height: 0;
  }

  .sm\\:h-1{
    height: 0.25rem;
  }

  .sm\\:h-2{
    height: 0.5rem;
  }

  .sm\\:h-3{
    height: 0.75rem;
  }

  .sm\\:h-4{
    height: 1rem;
  }

  .sm\\:h-5{
    height: 1.25rem;
  }

  .sm\\:h-6{
    height: 1.5rem;
  }

  .sm\\:h-7{
    height: 1.75rem;
  }

  .sm\\:h-8{
    height: 2rem;
  }

  .sm\\:h-9{
    height: 2.25rem;
  }

  .sm\\:h-10{
    height: 2.5rem;
  }

  .sm\\:h-11{
    height: 2.75rem;
  }

  .sm\\:h-12{
    height: 3rem;
  }

  .sm\\:h-14{
    height: 3.5rem;
  }

  .sm\\:h-15{
    height: 3.75rem;
  }

  .sm\\:h-16{
    height: 4rem;
  }

  .sm\\:h-18{
    height: 4.5rem;
  }

  .sm\\:h-20{
    height: 5rem;
  }

  .sm\\:h-22{
    height: 5.5rem;
  }

  .sm\\:h-23{
    height: 5.75rem;
  }

  .sm\\:h-24{
    height: 6rem;
  }

  .sm\\:h-25{
    height: 6.25rem;
  }

  .sm\\:h-26{
    height: 6.5rem;
  }

  .sm\\:h-28{
    height: 7rem;
  }

  .sm\\:h-30{
    height: 7.5rem;
  }

  .sm\\:h-32{
    height: 8rem;
  }

  .sm\\:h-34{
    height: 8.5rem;
  }

  .sm\\:h-40{
    height: 10rem;
  }

  .sm\\:h-42{
    height: 10.5rem;
  }

  .sm\\:h-44{
    height: 11rem;
  }

  .sm\\:h-48{
    height: 12rem;
  }

  .sm\\:h-52{
    height: 13rem;
  }

  .sm\\:h-54{
    height: 13.5rem;
  }

  .sm\\:h-56{
    height: 14rem;
  }

  .sm\\:h-60{
    height: 15rem;
  }

  .sm\\:h-64{
    height: 16rem;
  }

  .sm\\:h-68{
    height: 17rem;
  }

  .sm\\:h-72{
    height: 18rem;
  }

  .sm\\:h-74{
    height: 18.5rem;
  }

  .sm\\:h-76{
    height: 19rem;
  }

  .sm\\:h-78{
    height: 19.5rem;
  }

  .sm\\:h-80{
    height: 20rem;
  }

  .sm\\:h-82{
    height: 20.5rem;
  }

  .sm\\:h-84{
    height: 21rem;
  }

  .sm\\:h-88{
    height: 22rem;
  }

  .sm\\:h-92{
    height: 23rem;
  }

  .sm\\:h-96{
    height: 24rem;
  }

  .sm\\:h-98{
    height: 24.5rem;
  }

  .sm\\:h-100{
    height: 25rem;
  }

  .sm\\:h-104{
    height: 26rem;
  }

  .sm\\:h-112{
    height: 28rem;
  }

  .sm\\:h-124{
    height: 31rem;
  }

  .sm\\:h-128{
    height: 32rem;
  }

  .sm\\:h-140{
    height: 35rem;
  }

  .sm\\:h-152{
    height: 38rem;
  }

  .sm\\:h-160{
    height: 40rem;
  }

  .sm\\:h-162{
    height: 41rem;
  }

  .sm\\:h-192{
    height: 48rem;
  }

  .sm\\:h-208{
    height: 52rem;
  }

  .sm\\:h-224{
    height: 56rem;
  }

  .sm\\:h-256{
    height: 64rem;
  }

  .sm\\:h-auto{
    height: auto;
  }

  .sm\\:h-px{
    height: 1px;
  }

  .sm\\:h-full{
    height: 100%;
  }

  .sm\\:h-screen{
    height: 100vh;
  }

  .sm\\:text-xs{
    font-size: 0.74rem;
  }

  .sm\\:text-sm{
    font-size: 0.86rem;
  }

  .sm\\:text-base{
    font-size: 1rem;
  }

  .sm\\:text-lg{
    font-size: 1.15rem;
  }

  .sm\\:text-xl{
    font-size: 1.42rem;
  }

  .sm\\:text-2xl{
    font-size: 1.85rem;
  }

  .sm\\:text-3xl{
    font-size: 1.95rem;
  }

  .sm\\:text-4xl{
    font-size: 2.25rem;
  }

  .sm\\:text-5xl{
    font-size: 3rem;
  }

  .sm\\:text-6xl{
    font-size: 4rem;
  }

  .sm\\:text-7xl{
    font-size: 5rem;
  }

  .sm\\:leading-none{
    line-height: 1;
  }

  .sm\\:leading-tight{
    line-height: 1.2;
  }

  .sm\\:leading-snug{
    line-height: 1.3;
  }

  .sm\\:leading-normal{
    line-height: 1.4;
  }

  .sm\\:leading-relaxed{
    line-height: 1.6;
  }

  .sm\\:list-inside{
    list-style-position: inside;
  }

  .sm\\:list-outside{
    list-style-position: outside;
  }

  .sm\\:list-none{
    list-style-type: none;
  }

  .sm\\:list-disc{
    list-style-type: disc;
  }

  .sm\\:list-decimal{
    list-style-type: decimal;
  }

  .sm\\:m-0{
    margin: 0;
  }

  .sm\\:m-1{
    margin: 0.25rem;
  }

  .sm\\:m-2{
    margin: 0.5rem;
  }

  .sm\\:m-3{
    margin: 0.75rem;
  }

  .sm\\:m-4{
    margin: 1rem;
  }

  .sm\\:m-5{
    margin: 1.25rem;
  }

  .sm\\:m-6{
    margin: 1.5rem;
  }

  .sm\\:m-7{
    margin: 1.75rem;
  }

  .sm\\:m-8{
    margin: 2rem;
  }

  .sm\\:m-9{
    margin: 2.25rem;
  }

  .sm\\:m-10{
    margin: 2.5rem;
  }

  .sm\\:m-11{
    margin: 2.75rem;
  }

  .sm\\:m-12{
    margin: 3rem;
  }

  .sm\\:m-14{
    margin: 3.5rem;
  }

  .sm\\:m-15{
    margin: 3.75rem;
  }

  .sm\\:m-16{
    margin: 4rem;
  }

  .sm\\:m-18{
    margin: 4.5rem;
  }

  .sm\\:m-20{
    margin: 5rem;
  }

  .sm\\:m-22{
    margin: 5.5rem;
  }

  .sm\\:m-23{
    margin: 5.75rem;
  }

  .sm\\:m-24{
    margin: 6rem;
  }

  .sm\\:m-25{
    margin: 6.25rem;
  }

  .sm\\:m-26{
    margin: 6.5rem;
  }

  .sm\\:m-28{
    margin: 7rem;
  }

  .sm\\:m-30{
    margin: 7.5rem;
  }

  .sm\\:m-32{
    margin: 8rem;
  }

  .sm\\:m-34{
    margin: 8.5rem;
  }

  .sm\\:m-40{
    margin: 10rem;
  }

  .sm\\:m-42{
    margin: 10.5rem;
  }

  .sm\\:m-44{
    margin: 11rem;
  }

  .sm\\:m-48{
    margin: 12rem;
  }

  .sm\\:m-52{
    margin: 13rem;
  }

  .sm\\:m-54{
    margin: 13.5rem;
  }

  .sm\\:m-56{
    margin: 14rem;
  }

  .sm\\:m-60{
    margin: 15rem;
  }

  .sm\\:m-64{
    margin: 16rem;
  }

  .sm\\:m-68{
    margin: 17rem;
  }

  .sm\\:m-72{
    margin: 18rem;
  }

  .sm\\:m-74{
    margin: 18.5rem;
  }

  .sm\\:m-76{
    margin: 19rem;
  }

  .sm\\:m-78{
    margin: 19.5rem;
  }

  .sm\\:m-80{
    margin: 20rem;
  }

  .sm\\:m-82{
    margin: 20.5rem;
  }

  .sm\\:m-84{
    margin: 21rem;
  }

  .sm\\:m-88{
    margin: 22rem;
  }

  .sm\\:m-92{
    margin: 23rem;
  }

  .sm\\:m-96{
    margin: 24rem;
  }

  .sm\\:m-98{
    margin: 24.5rem;
  }

  .sm\\:m-100{
    margin: 25rem;
  }

  .sm\\:m-104{
    margin: 26rem;
  }

  .sm\\:m-112{
    margin: 28rem;
  }

  .sm\\:m-124{
    margin: 31rem;
  }

  .sm\\:m-128{
    margin: 32rem;
  }

  .sm\\:m-140{
    margin: 35rem;
  }

  .sm\\:m-152{
    margin: 38rem;
  }

  .sm\\:m-160{
    margin: 40rem;
  }

  .sm\\:m-162{
    margin: 41rem;
  }

  .sm\\:m-192{
    margin: 48rem;
  }

  .sm\\:m-208{
    margin: 52rem;
  }

  .sm\\:m-224{
    margin: 56rem;
  }

  .sm\\:m-256{
    margin: 64rem;
  }

  .sm\\:m-auto{
    margin: auto;
  }

  .sm\\:m-px{
    margin: 1px;
  }

  .sm\\:-m-1{
    margin: -0.25rem;
  }

  .sm\\:-m-2{
    margin: -0.5rem;
  }

  .sm\\:-m-3{
    margin: -0.75rem;
  }

  .sm\\:-m-4{
    margin: -1rem;
  }

  .sm\\:-m-5{
    margin: -1.25rem;
  }

  .sm\\:-m-6{
    margin: -1.5rem;
  }

  .sm\\:-m-7{
    margin: -1.75rem;
  }

  .sm\\:-m-8{
    margin: -2rem;
  }

  .sm\\:-m-9{
    margin: -2.25rem;
  }

  .sm\\:-m-10{
    margin: -2.5rem;
  }

  .sm\\:-m-11{
    margin: -2.75rem;
  }

  .sm\\:-m-12{
    margin: -3rem;
  }

  .sm\\:-m-14{
    margin: -3.5rem;
  }

  .sm\\:-m-15{
    margin: -3.75rem;
  }

  .sm\\:-m-16{
    margin: -4rem;
  }

  .sm\\:-m-18{
    margin: -4.5rem;
  }

  .sm\\:-m-20{
    margin: -5rem;
  }

  .sm\\:-m-22{
    margin: -5.5rem;
  }

  .sm\\:-m-23{
    margin: -5.75rem;
  }

  .sm\\:-m-24{
    margin: -6rem;
  }

  .sm\\:-m-25{
    margin: -6.25rem;
  }

  .sm\\:-m-26{
    margin: -6.5rem;
  }

  .sm\\:-m-28{
    margin: -7rem;
  }

  .sm\\:-m-30{
    margin: -7.5rem;
  }

  .sm\\:-m-32{
    margin: -8rem;
  }

  .sm\\:-m-34{
    margin: -8.5rem;
  }

  .sm\\:-m-40{
    margin: -10rem;
  }

  .sm\\:-m-42{
    margin: -10.5rem;
  }

  .sm\\:-m-44{
    margin: -11rem;
  }

  .sm\\:-m-48{
    margin: -12rem;
  }

  .sm\\:-m-52{
    margin: -13rem;
  }

  .sm\\:-m-54{
    margin: -13.5rem;
  }

  .sm\\:-m-56{
    margin: -14rem;
  }

  .sm\\:-m-60{
    margin: -15rem;
  }

  .sm\\:-m-64{
    margin: -16rem;
  }

  .sm\\:-m-68{
    margin: -17rem;
  }

  .sm\\:-m-72{
    margin: -18rem;
  }

  .sm\\:-m-74{
    margin: -18.5rem;
  }

  .sm\\:-m-76{
    margin: -19rem;
  }

  .sm\\:-m-78{
    margin: -19.5rem;
  }

  .sm\\:-m-80{
    margin: -20rem;
  }

  .sm\\:-m-82{
    margin: -20.5rem;
  }

  .sm\\:-m-84{
    margin: -21rem;
  }

  .sm\\:-m-88{
    margin: -22rem;
  }

  .sm\\:-m-92{
    margin: -23rem;
  }

  .sm\\:-m-96{
    margin: -24rem;
  }

  .sm\\:-m-98{
    margin: -24.5rem;
  }

  .sm\\:-m-100{
    margin: -25rem;
  }

  .sm\\:-m-104{
    margin: -26rem;
  }

  .sm\\:-m-112{
    margin: -28rem;
  }

  .sm\\:-m-124{
    margin: -31rem;
  }

  .sm\\:-m-128{
    margin: -32rem;
  }

  .sm\\:-m-140{
    margin: -35rem;
  }

  .sm\\:-m-152{
    margin: -38rem;
  }

  .sm\\:-m-160{
    margin: -40rem;
  }

  .sm\\:-m-162{
    margin: -41rem;
  }

  .sm\\:-m-192{
    margin: -48rem;
  }

  .sm\\:-m-208{
    margin: -52rem;
  }

  .sm\\:-m-224{
    margin: -56rem;
  }

  .sm\\:-m-256{
    margin: -64rem;
  }

  .sm\\:-m-px{
    margin: -1px;
  }

  .sm\\:my-0{
    margin-top: 0;
    margin-bottom: 0;
  }

  .sm\\:mx-0{
    margin-left: 0;
    margin-right: 0;
  }

  .sm\\:my-1{
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .sm\\:mx-1{
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .sm\\:my-2{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .sm\\:mx-2{
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .sm\\:my-3{
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .sm\\:mx-3{
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .sm\\:my-4{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .sm\\:mx-4{
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .sm\\:my-5{
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .sm\\:mx-5{
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .sm\\:my-6{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .sm\\:mx-6{
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .sm\\:my-7{
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }

  .sm\\:mx-7{
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }

  .sm\\:my-8{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .sm\\:mx-8{
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .sm\\:my-9{
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }

  .sm\\:mx-9{
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }

  .sm\\:my-10{
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .sm\\:mx-10{
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .sm\\:my-11{
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;
  }

  .sm\\:mx-11{
    margin-left: 2.75rem;
    margin-right: 2.75rem;
  }

  .sm\\:my-12{
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .sm\\:mx-12{
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .sm\\:my-14{
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
  }

  .sm\\:mx-14{
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }

  .sm\\:my-15{
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
  }

  .sm\\:mx-15{
    margin-left: 3.75rem;
    margin-right: 3.75rem;
  }

  .sm\\:my-16{
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .sm\\:mx-16{
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .sm\\:my-18{
    margin-top: 4.5rem;
    margin-bottom: 4.5rem;
  }

  .sm\\:mx-18{
    margin-left: 4.5rem;
    margin-right: 4.5rem;
  }

  .sm\\:my-20{
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .sm\\:mx-20{
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .sm\\:my-22{
    margin-top: 5.5rem;
    margin-bottom: 5.5rem;
  }

  .sm\\:mx-22{
    margin-left: 5.5rem;
    margin-right: 5.5rem;
  }

  .sm\\:my-23{
    margin-top: 5.75rem;
    margin-bottom: 5.75rem;
  }

  .sm\\:mx-23{
    margin-left: 5.75rem;
    margin-right: 5.75rem;
  }

  .sm\\:my-24{
    margin-top: 6rem;
    margin-bottom: 6rem;
  }

  .sm\\:mx-24{
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .sm\\:my-25{
    margin-top: 6.25rem;
    margin-bottom: 6.25rem;
  }

  .sm\\:mx-25{
    margin-left: 6.25rem;
    margin-right: 6.25rem;
  }

  .sm\\:my-26{
    margin-top: 6.5rem;
    margin-bottom: 6.5rem;
  }

  .sm\\:mx-26{
    margin-left: 6.5rem;
    margin-right: 6.5rem;
  }

  .sm\\:my-28{
    margin-top: 7rem;
    margin-bottom: 7rem;
  }

  .sm\\:mx-28{
    margin-left: 7rem;
    margin-right: 7rem;
  }

  .sm\\:my-30{
    margin-top: 7.5rem;
    margin-bottom: 7.5rem;
  }

  .sm\\:mx-30{
    margin-left: 7.5rem;
    margin-right: 7.5rem;
  }

  .sm\\:my-32{
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  .sm\\:mx-32{
    margin-left: 8rem;
    margin-right: 8rem;
  }

  .sm\\:my-34{
    margin-top: 8.5rem;
    margin-bottom: 8.5rem;
  }

  .sm\\:mx-34{
    margin-left: 8.5rem;
    margin-right: 8.5rem;
  }

  .sm\\:my-40{
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .sm\\:mx-40{
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .sm\\:my-42{
    margin-top: 10.5rem;
    margin-bottom: 10.5rem;
  }

  .sm\\:mx-42{
    margin-left: 10.5rem;
    margin-right: 10.5rem;
  }

  .sm\\:my-44{
    margin-top: 11rem;
    margin-bottom: 11rem;
  }

  .sm\\:mx-44{
    margin-left: 11rem;
    margin-right: 11rem;
  }

  .sm\\:my-48{
    margin-top: 12rem;
    margin-bottom: 12rem;
  }

  .sm\\:mx-48{
    margin-left: 12rem;
    margin-right: 12rem;
  }

  .sm\\:my-52{
    margin-top: 13rem;
    margin-bottom: 13rem;
  }

  .sm\\:mx-52{
    margin-left: 13rem;
    margin-right: 13rem;
  }

  .sm\\:my-54{
    margin-top: 13.5rem;
    margin-bottom: 13.5rem;
  }

  .sm\\:mx-54{
    margin-left: 13.5rem;
    margin-right: 13.5rem;
  }

  .sm\\:my-56{
    margin-top: 14rem;
    margin-bottom: 14rem;
  }

  .sm\\:mx-56{
    margin-left: 14rem;
    margin-right: 14rem;
  }

  .sm\\:my-60{
    margin-top: 15rem;
    margin-bottom: 15rem;
  }

  .sm\\:mx-60{
    margin-left: 15rem;
    margin-right: 15rem;
  }

  .sm\\:my-64{
    margin-top: 16rem;
    margin-bottom: 16rem;
  }

  .sm\\:mx-64{
    margin-left: 16rem;
    margin-right: 16rem;
  }

  .sm\\:my-68{
    margin-top: 17rem;
    margin-bottom: 17rem;
  }

  .sm\\:mx-68{
    margin-left: 17rem;
    margin-right: 17rem;
  }

  .sm\\:my-72{
    margin-top: 18rem;
    margin-bottom: 18rem;
  }

  .sm\\:mx-72{
    margin-left: 18rem;
    margin-right: 18rem;
  }

  .sm\\:my-74{
    margin-top: 18.5rem;
    margin-bottom: 18.5rem;
  }

  .sm\\:mx-74{
    margin-left: 18.5rem;
    margin-right: 18.5rem;
  }

  .sm\\:my-76{
    margin-top: 19rem;
    margin-bottom: 19rem;
  }

  .sm\\:mx-76{
    margin-left: 19rem;
    margin-right: 19rem;
  }

  .sm\\:my-78{
    margin-top: 19.5rem;
    margin-bottom: 19.5rem;
  }

  .sm\\:mx-78{
    margin-left: 19.5rem;
    margin-right: 19.5rem;
  }

  .sm\\:my-80{
    margin-top: 20rem;
    margin-bottom: 20rem;
  }

  .sm\\:mx-80{
    margin-left: 20rem;
    margin-right: 20rem;
  }

  .sm\\:my-82{
    margin-top: 20.5rem;
    margin-bottom: 20.5rem;
  }

  .sm\\:mx-82{
    margin-left: 20.5rem;
    margin-right: 20.5rem;
  }

  .sm\\:my-84{
    margin-top: 21rem;
    margin-bottom: 21rem;
  }

  .sm\\:mx-84{
    margin-left: 21rem;
    margin-right: 21rem;
  }

  .sm\\:my-88{
    margin-top: 22rem;
    margin-bottom: 22rem;
  }

  .sm\\:mx-88{
    margin-left: 22rem;
    margin-right: 22rem;
  }

  .sm\\:my-92{
    margin-top: 23rem;
    margin-bottom: 23rem;
  }

  .sm\\:mx-92{
    margin-left: 23rem;
    margin-right: 23rem;
  }

  .sm\\:my-96{
    margin-top: 24rem;
    margin-bottom: 24rem;
  }

  .sm\\:mx-96{
    margin-left: 24rem;
    margin-right: 24rem;
  }

  .sm\\:my-98{
    margin-top: 24.5rem;
    margin-bottom: 24.5rem;
  }

  .sm\\:mx-98{
    margin-left: 24.5rem;
    margin-right: 24.5rem;
  }

  .sm\\:my-100{
    margin-top: 25rem;
    margin-bottom: 25rem;
  }

  .sm\\:mx-100{
    margin-left: 25rem;
    margin-right: 25rem;
  }

  .sm\\:my-104{
    margin-top: 26rem;
    margin-bottom: 26rem;
  }

  .sm\\:mx-104{
    margin-left: 26rem;
    margin-right: 26rem;
  }

  .sm\\:my-112{
    margin-top: 28rem;
    margin-bottom: 28rem;
  }

  .sm\\:mx-112{
    margin-left: 28rem;
    margin-right: 28rem;
  }

  .sm\\:my-124{
    margin-top: 31rem;
    margin-bottom: 31rem;
  }

  .sm\\:mx-124{
    margin-left: 31rem;
    margin-right: 31rem;
  }

  .sm\\:my-128{
    margin-top: 32rem;
    margin-bottom: 32rem;
  }

  .sm\\:mx-128{
    margin-left: 32rem;
    margin-right: 32rem;
  }

  .sm\\:my-140{
    margin-top: 35rem;
    margin-bottom: 35rem;
  }

  .sm\\:mx-140{
    margin-left: 35rem;
    margin-right: 35rem;
  }

  .sm\\:my-152{
    margin-top: 38rem;
    margin-bottom: 38rem;
  }

  .sm\\:mx-152{
    margin-left: 38rem;
    margin-right: 38rem;
  }

  .sm\\:my-160{
    margin-top: 40rem;
    margin-bottom: 40rem;
  }

  .sm\\:mx-160{
    margin-left: 40rem;
    margin-right: 40rem;
  }

  .sm\\:my-162{
    margin-top: 41rem;
    margin-bottom: 41rem;
  }

  .sm\\:mx-162{
    margin-left: 41rem;
    margin-right: 41rem;
  }

  .sm\\:my-192{
    margin-top: 48rem;
    margin-bottom: 48rem;
  }

  .sm\\:mx-192{
    margin-left: 48rem;
    margin-right: 48rem;
  }

  .sm\\:my-208{
    margin-top: 52rem;
    margin-bottom: 52rem;
  }

  .sm\\:mx-208{
    margin-left: 52rem;
    margin-right: 52rem;
  }

  .sm\\:my-224{
    margin-top: 56rem;
    margin-bottom: 56rem;
  }

  .sm\\:mx-224{
    margin-left: 56rem;
    margin-right: 56rem;
  }

  .sm\\:my-256{
    margin-top: 64rem;
    margin-bottom: 64rem;
  }

  .sm\\:mx-256{
    margin-left: 64rem;
    margin-right: 64rem;
  }

  .sm\\:my-auto{
    margin-top: auto;
    margin-bottom: auto;
  }

  .sm\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:my-px{
    margin-top: 1px;
    margin-bottom: 1px;
  }

  .sm\\:mx-px{
    margin-left: 1px;
    margin-right: 1px;
  }

  .sm\\:-my-1{
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .sm\\:-mx-1{
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .sm\\:-my-2{
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }

  .sm\\:-mx-2{
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .sm\\:-my-3{
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }

  .sm\\:-mx-3{
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .sm\\:-my-4{
    margin-top: -1rem;
    margin-bottom: -1rem;
  }

  .sm\\:-mx-4{
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .sm\\:-my-5{
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }

  .sm\\:-mx-5{
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .sm\\:-my-6{
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }

  .sm\\:-mx-6{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .sm\\:-my-7{
    margin-top: -1.75rem;
    margin-bottom: -1.75rem;
  }

  .sm\\:-mx-7{
    margin-left: -1.75rem;
    margin-right: -1.75rem;
  }

  .sm\\:-my-8{
    margin-top: -2rem;
    margin-bottom: -2rem;
  }

  .sm\\:-mx-8{
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .sm\\:-my-9{
    margin-top: -2.25rem;
    margin-bottom: -2.25rem;
  }

  .sm\\:-mx-9{
    margin-left: -2.25rem;
    margin-right: -2.25rem;
  }

  .sm\\:-my-10{
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }

  .sm\\:-mx-10{
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .sm\\:-my-11{
    margin-top: -2.75rem;
    margin-bottom: -2.75rem;
  }

  .sm\\:-mx-11{
    margin-left: -2.75rem;
    margin-right: -2.75rem;
  }

  .sm\\:-my-12{
    margin-top: -3rem;
    margin-bottom: -3rem;
  }

  .sm\\:-mx-12{
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .sm\\:-my-14{
    margin-top: -3.5rem;
    margin-bottom: -3.5rem;
  }

  .sm\\:-mx-14{
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }

  .sm\\:-my-15{
    margin-top: -3.75rem;
    margin-bottom: -3.75rem;
  }

  .sm\\:-mx-15{
    margin-left: -3.75rem;
    margin-right: -3.75rem;
  }

  .sm\\:-my-16{
    margin-top: -4rem;
    margin-bottom: -4rem;
  }

  .sm\\:-mx-16{
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .sm\\:-my-18{
    margin-top: -4.5rem;
    margin-bottom: -4.5rem;
  }

  .sm\\:-mx-18{
    margin-left: -4.5rem;
    margin-right: -4.5rem;
  }

  .sm\\:-my-20{
    margin-top: -5rem;
    margin-bottom: -5rem;
  }

  .sm\\:-mx-20{
    margin-left: -5rem;
    margin-right: -5rem;
  }

  .sm\\:-my-22{
    margin-top: -5.5rem;
    margin-bottom: -5.5rem;
  }

  .sm\\:-mx-22{
    margin-left: -5.5rem;
    margin-right: -5.5rem;
  }

  .sm\\:-my-23{
    margin-top: -5.75rem;
    margin-bottom: -5.75rem;
  }

  .sm\\:-mx-23{
    margin-left: -5.75rem;
    margin-right: -5.75rem;
  }

  .sm\\:-my-24{
    margin-top: -6rem;
    margin-bottom: -6rem;
  }

  .sm\\:-mx-24{
    margin-left: -6rem;
    margin-right: -6rem;
  }

  .sm\\:-my-25{
    margin-top: -6.25rem;
    margin-bottom: -6.25rem;
  }

  .sm\\:-mx-25{
    margin-left: -6.25rem;
    margin-right: -6.25rem;
  }

  .sm\\:-my-26{
    margin-top: -6.5rem;
    margin-bottom: -6.5rem;
  }

  .sm\\:-mx-26{
    margin-left: -6.5rem;
    margin-right: -6.5rem;
  }

  .sm\\:-my-28{
    margin-top: -7rem;
    margin-bottom: -7rem;
  }

  .sm\\:-mx-28{
    margin-left: -7rem;
    margin-right: -7rem;
  }

  .sm\\:-my-30{
    margin-top: -7.5rem;
    margin-bottom: -7.5rem;
  }

  .sm\\:-mx-30{
    margin-left: -7.5rem;
    margin-right: -7.5rem;
  }

  .sm\\:-my-32{
    margin-top: -8rem;
    margin-bottom: -8rem;
  }

  .sm\\:-mx-32{
    margin-left: -8rem;
    margin-right: -8rem;
  }

  .sm\\:-my-34{
    margin-top: -8.5rem;
    margin-bottom: -8.5rem;
  }

  .sm\\:-mx-34{
    margin-left: -8.5rem;
    margin-right: -8.5rem;
  }

  .sm\\:-my-40{
    margin-top: -10rem;
    margin-bottom: -10rem;
  }

  .sm\\:-mx-40{
    margin-left: -10rem;
    margin-right: -10rem;
  }

  .sm\\:-my-42{
    margin-top: -10.5rem;
    margin-bottom: -10.5rem;
  }

  .sm\\:-mx-42{
    margin-left: -10.5rem;
    margin-right: -10.5rem;
  }

  .sm\\:-my-44{
    margin-top: -11rem;
    margin-bottom: -11rem;
  }

  .sm\\:-mx-44{
    margin-left: -11rem;
    margin-right: -11rem;
  }

  .sm\\:-my-48{
    margin-top: -12rem;
    margin-bottom: -12rem;
  }

  .sm\\:-mx-48{
    margin-left: -12rem;
    margin-right: -12rem;
  }

  .sm\\:-my-52{
    margin-top: -13rem;
    margin-bottom: -13rem;
  }

  .sm\\:-mx-52{
    margin-left: -13rem;
    margin-right: -13rem;
  }

  .sm\\:-my-54{
    margin-top: -13.5rem;
    margin-bottom: -13.5rem;
  }

  .sm\\:-mx-54{
    margin-left: -13.5rem;
    margin-right: -13.5rem;
  }

  .sm\\:-my-56{
    margin-top: -14rem;
    margin-bottom: -14rem;
  }

  .sm\\:-mx-56{
    margin-left: -14rem;
    margin-right: -14rem;
  }

  .sm\\:-my-60{
    margin-top: -15rem;
    margin-bottom: -15rem;
  }

  .sm\\:-mx-60{
    margin-left: -15rem;
    margin-right: -15rem;
  }

  .sm\\:-my-64{
    margin-top: -16rem;
    margin-bottom: -16rem;
  }

  .sm\\:-mx-64{
    margin-left: -16rem;
    margin-right: -16rem;
  }

  .sm\\:-my-68{
    margin-top: -17rem;
    margin-bottom: -17rem;
  }

  .sm\\:-mx-68{
    margin-left: -17rem;
    margin-right: -17rem;
  }

  .sm\\:-my-72{
    margin-top: -18rem;
    margin-bottom: -18rem;
  }

  .sm\\:-mx-72{
    margin-left: -18rem;
    margin-right: -18rem;
  }

  .sm\\:-my-74{
    margin-top: -18.5rem;
    margin-bottom: -18.5rem;
  }

  .sm\\:-mx-74{
    margin-left: -18.5rem;
    margin-right: -18.5rem;
  }

  .sm\\:-my-76{
    margin-top: -19rem;
    margin-bottom: -19rem;
  }

  .sm\\:-mx-76{
    margin-left: -19rem;
    margin-right: -19rem;
  }

  .sm\\:-my-78{
    margin-top: -19.5rem;
    margin-bottom: -19.5rem;
  }

  .sm\\:-mx-78{
    margin-left: -19.5rem;
    margin-right: -19.5rem;
  }

  .sm\\:-my-80{
    margin-top: -20rem;
    margin-bottom: -20rem;
  }

  .sm\\:-mx-80{
    margin-left: -20rem;
    margin-right: -20rem;
  }

  .sm\\:-my-82{
    margin-top: -20.5rem;
    margin-bottom: -20.5rem;
  }

  .sm\\:-mx-82{
    margin-left: -20.5rem;
    margin-right: -20.5rem;
  }

  .sm\\:-my-84{
    margin-top: -21rem;
    margin-bottom: -21rem;
  }

  .sm\\:-mx-84{
    margin-left: -21rem;
    margin-right: -21rem;
  }

  .sm\\:-my-88{
    margin-top: -22rem;
    margin-bottom: -22rem;
  }

  .sm\\:-mx-88{
    margin-left: -22rem;
    margin-right: -22rem;
  }

  .sm\\:-my-92{
    margin-top: -23rem;
    margin-bottom: -23rem;
  }

  .sm\\:-mx-92{
    margin-left: -23rem;
    margin-right: -23rem;
  }

  .sm\\:-my-96{
    margin-top: -24rem;
    margin-bottom: -24rem;
  }

  .sm\\:-mx-96{
    margin-left: -24rem;
    margin-right: -24rem;
  }

  .sm\\:-my-98{
    margin-top: -24.5rem;
    margin-bottom: -24.5rem;
  }

  .sm\\:-mx-98{
    margin-left: -24.5rem;
    margin-right: -24.5rem;
  }

  .sm\\:-my-100{
    margin-top: -25rem;
    margin-bottom: -25rem;
  }

  .sm\\:-mx-100{
    margin-left: -25rem;
    margin-right: -25rem;
  }

  .sm\\:-my-104{
    margin-top: -26rem;
    margin-bottom: -26rem;
  }

  .sm\\:-mx-104{
    margin-left: -26rem;
    margin-right: -26rem;
  }

  .sm\\:-my-112{
    margin-top: -28rem;
    margin-bottom: -28rem;
  }

  .sm\\:-mx-112{
    margin-left: -28rem;
    margin-right: -28rem;
  }

  .sm\\:-my-124{
    margin-top: -31rem;
    margin-bottom: -31rem;
  }

  .sm\\:-mx-124{
    margin-left: -31rem;
    margin-right: -31rem;
  }

  .sm\\:-my-128{
    margin-top: -32rem;
    margin-bottom: -32rem;
  }

  .sm\\:-mx-128{
    margin-left: -32rem;
    margin-right: -32rem;
  }

  .sm\\:-my-140{
    margin-top: -35rem;
    margin-bottom: -35rem;
  }

  .sm\\:-mx-140{
    margin-left: -35rem;
    margin-right: -35rem;
  }

  .sm\\:-my-152{
    margin-top: -38rem;
    margin-bottom: -38rem;
  }

  .sm\\:-mx-152{
    margin-left: -38rem;
    margin-right: -38rem;
  }

  .sm\\:-my-160{
    margin-top: -40rem;
    margin-bottom: -40rem;
  }

  .sm\\:-mx-160{
    margin-left: -40rem;
    margin-right: -40rem;
  }

  .sm\\:-my-162{
    margin-top: -41rem;
    margin-bottom: -41rem;
  }

  .sm\\:-mx-162{
    margin-left: -41rem;
    margin-right: -41rem;
  }

  .sm\\:-my-192{
    margin-top: -48rem;
    margin-bottom: -48rem;
  }

  .sm\\:-mx-192{
    margin-left: -48rem;
    margin-right: -48rem;
  }

  .sm\\:-my-208{
    margin-top: -52rem;
    margin-bottom: -52rem;
  }

  .sm\\:-mx-208{
    margin-left: -52rem;
    margin-right: -52rem;
  }

  .sm\\:-my-224{
    margin-top: -56rem;
    margin-bottom: -56rem;
  }

  .sm\\:-mx-224{
    margin-left: -56rem;
    margin-right: -56rem;
  }

  .sm\\:-my-256{
    margin-top: -64rem;
    margin-bottom: -64rem;
  }

  .sm\\:-mx-256{
    margin-left: -64rem;
    margin-right: -64rem;
  }

  .sm\\:-my-px{
    margin-top: -1px;
    margin-bottom: -1px;
  }

  .sm\\:-mx-px{
    margin-left: -1px;
    margin-right: -1px;
  }

  .sm\\:mt-0{
    margin-top: 0;
  }

  .sm\\:mr-0{
    margin-right: 0;
  }

  .sm\\:mb-0{
    margin-bottom: 0;
  }

  .sm\\:ml-0{
    margin-left: 0;
  }

  .sm\\:mt-1{
    margin-top: 0.25rem;
  }

  .sm\\:mr-1{
    margin-right: 0.25rem;
  }

  .sm\\:mb-1{
    margin-bottom: 0.25rem;
  }

  .sm\\:ml-1{
    margin-left: 0.25rem;
  }

  .sm\\:mt-2{
    margin-top: 0.5rem;
  }

  .sm\\:mr-2{
    margin-right: 0.5rem;
  }

  .sm\\:mb-2{
    margin-bottom: 0.5rem;
  }

  .sm\\:ml-2{
    margin-left: 0.5rem;
  }

  .sm\\:mt-3{
    margin-top: 0.75rem;
  }

  .sm\\:mr-3{
    margin-right: 0.75rem;
  }

  .sm\\:mb-3{
    margin-bottom: 0.75rem;
  }

  .sm\\:ml-3{
    margin-left: 0.75rem;
  }

  .sm\\:mt-4{
    margin-top: 1rem;
  }

  .sm\\:mr-4{
    margin-right: 1rem;
  }

  .sm\\:mb-4{
    margin-bottom: 1rem;
  }

  .sm\\:ml-4{
    margin-left: 1rem;
  }

  .sm\\:mt-5{
    margin-top: 1.25rem;
  }

  .sm\\:mr-5{
    margin-right: 1.25rem;
  }

  .sm\\:mb-5{
    margin-bottom: 1.25rem;
  }

  .sm\\:ml-5{
    margin-left: 1.25rem;
  }

  .sm\\:mt-6{
    margin-top: 1.5rem;
  }

  .sm\\:mr-6{
    margin-right: 1.5rem;
  }

  .sm\\:mb-6{
    margin-bottom: 1.5rem;
  }

  .sm\\:ml-6{
    margin-left: 1.5rem;
  }

  .sm\\:mt-7{
    margin-top: 1.75rem;
  }

  .sm\\:mr-7{
    margin-right: 1.75rem;
  }

  .sm\\:mb-7{
    margin-bottom: 1.75rem;
  }

  .sm\\:ml-7{
    margin-left: 1.75rem;
  }

  .sm\\:mt-8{
    margin-top: 2rem;
  }

  .sm\\:mr-8{
    margin-right: 2rem;
  }

  .sm\\:mb-8{
    margin-bottom: 2rem;
  }

  .sm\\:ml-8{
    margin-left: 2rem;
  }

  .sm\\:mt-9{
    margin-top: 2.25rem;
  }

  .sm\\:mr-9{
    margin-right: 2.25rem;
  }

  .sm\\:mb-9{
    margin-bottom: 2.25rem;
  }

  .sm\\:ml-9{
    margin-left: 2.25rem;
  }

  .sm\\:mt-10{
    margin-top: 2.5rem;
  }

  .sm\\:mr-10{
    margin-right: 2.5rem;
  }

  .sm\\:mb-10{
    margin-bottom: 2.5rem;
  }

  .sm\\:ml-10{
    margin-left: 2.5rem;
  }

  .sm\\:mt-11{
    margin-top: 2.75rem;
  }

  .sm\\:mr-11{
    margin-right: 2.75rem;
  }

  .sm\\:mb-11{
    margin-bottom: 2.75rem;
  }

  .sm\\:ml-11{
    margin-left: 2.75rem;
  }

  .sm\\:mt-12{
    margin-top: 3rem;
  }

  .sm\\:mr-12{
    margin-right: 3rem;
  }

  .sm\\:mb-12{
    margin-bottom: 3rem;
  }

  .sm\\:ml-12{
    margin-left: 3rem;
  }

  .sm\\:mt-14{
    margin-top: 3.5rem;
  }

  .sm\\:mr-14{
    margin-right: 3.5rem;
  }

  .sm\\:mb-14{
    margin-bottom: 3.5rem;
  }

  .sm\\:ml-14{
    margin-left: 3.5rem;
  }

  .sm\\:mt-15{
    margin-top: 3.75rem;
  }

  .sm\\:mr-15{
    margin-right: 3.75rem;
  }

  .sm\\:mb-15{
    margin-bottom: 3.75rem;
  }

  .sm\\:ml-15{
    margin-left: 3.75rem;
  }

  .sm\\:mt-16{
    margin-top: 4rem;
  }

  .sm\\:mr-16{
    margin-right: 4rem;
  }

  .sm\\:mb-16{
    margin-bottom: 4rem;
  }

  .sm\\:ml-16{
    margin-left: 4rem;
  }

  .sm\\:mt-18{
    margin-top: 4.5rem;
  }

  .sm\\:mr-18{
    margin-right: 4.5rem;
  }

  .sm\\:mb-18{
    margin-bottom: 4.5rem;
  }

  .sm\\:ml-18{
    margin-left: 4.5rem;
  }

  .sm\\:mt-20{
    margin-top: 5rem;
  }

  .sm\\:mr-20{
    margin-right: 5rem;
  }

  .sm\\:mb-20{
    margin-bottom: 5rem;
  }

  .sm\\:ml-20{
    margin-left: 5rem;
  }

  .sm\\:mt-22{
    margin-top: 5.5rem;
  }

  .sm\\:mr-22{
    margin-right: 5.5rem;
  }

  .sm\\:mb-22{
    margin-bottom: 5.5rem;
  }

  .sm\\:ml-22{
    margin-left: 5.5rem;
  }

  .sm\\:mt-23{
    margin-top: 5.75rem;
  }

  .sm\\:mr-23{
    margin-right: 5.75rem;
  }

  .sm\\:mb-23{
    margin-bottom: 5.75rem;
  }

  .sm\\:ml-23{
    margin-left: 5.75rem;
  }

  .sm\\:mt-24{
    margin-top: 6rem;
  }

  .sm\\:mr-24{
    margin-right: 6rem;
  }

  .sm\\:mb-24{
    margin-bottom: 6rem;
  }

  .sm\\:ml-24{
    margin-left: 6rem;
  }

  .sm\\:mt-25{
    margin-top: 6.25rem;
  }

  .sm\\:mr-25{
    margin-right: 6.25rem;
  }

  .sm\\:mb-25{
    margin-bottom: 6.25rem;
  }

  .sm\\:ml-25{
    margin-left: 6.25rem;
  }

  .sm\\:mt-26{
    margin-top: 6.5rem;
  }

  .sm\\:mr-26{
    margin-right: 6.5rem;
  }

  .sm\\:mb-26{
    margin-bottom: 6.5rem;
  }

  .sm\\:ml-26{
    margin-left: 6.5rem;
  }

  .sm\\:mt-28{
    margin-top: 7rem;
  }

  .sm\\:mr-28{
    margin-right: 7rem;
  }

  .sm\\:mb-28{
    margin-bottom: 7rem;
  }

  .sm\\:ml-28{
    margin-left: 7rem;
  }

  .sm\\:mt-30{
    margin-top: 7.5rem;
  }

  .sm\\:mr-30{
    margin-right: 7.5rem;
  }

  .sm\\:mb-30{
    margin-bottom: 7.5rem;
  }

  .sm\\:ml-30{
    margin-left: 7.5rem;
  }

  .sm\\:mt-32{
    margin-top: 8rem;
  }

  .sm\\:mr-32{
    margin-right: 8rem;
  }

  .sm\\:mb-32{
    margin-bottom: 8rem;
  }

  .sm\\:ml-32{
    margin-left: 8rem;
  }

  .sm\\:mt-34{
    margin-top: 8.5rem;
  }

  .sm\\:mr-34{
    margin-right: 8.5rem;
  }

  .sm\\:mb-34{
    margin-bottom: 8.5rem;
  }

  .sm\\:ml-34{
    margin-left: 8.5rem;
  }

  .sm\\:mt-40{
    margin-top: 10rem;
  }

  .sm\\:mr-40{
    margin-right: 10rem;
  }

  .sm\\:mb-40{
    margin-bottom: 10rem;
  }

  .sm\\:ml-40{
    margin-left: 10rem;
  }

  .sm\\:mt-42{
    margin-top: 10.5rem;
  }

  .sm\\:mr-42{
    margin-right: 10.5rem;
  }

  .sm\\:mb-42{
    margin-bottom: 10.5rem;
  }

  .sm\\:ml-42{
    margin-left: 10.5rem;
  }

  .sm\\:mt-44{
    margin-top: 11rem;
  }

  .sm\\:mr-44{
    margin-right: 11rem;
  }

  .sm\\:mb-44{
    margin-bottom: 11rem;
  }

  .sm\\:ml-44{
    margin-left: 11rem;
  }

  .sm\\:mt-48{
    margin-top: 12rem;
  }

  .sm\\:mr-48{
    margin-right: 12rem;
  }

  .sm\\:mb-48{
    margin-bottom: 12rem;
  }

  .sm\\:ml-48{
    margin-left: 12rem;
  }

  .sm\\:mt-52{
    margin-top: 13rem;
  }

  .sm\\:mr-52{
    margin-right: 13rem;
  }

  .sm\\:mb-52{
    margin-bottom: 13rem;
  }

  .sm\\:ml-52{
    margin-left: 13rem;
  }

  .sm\\:mt-54{
    margin-top: 13.5rem;
  }

  .sm\\:mr-54{
    margin-right: 13.5rem;
  }

  .sm\\:mb-54{
    margin-bottom: 13.5rem;
  }

  .sm\\:ml-54{
    margin-left: 13.5rem;
  }

  .sm\\:mt-56{
    margin-top: 14rem;
  }

  .sm\\:mr-56{
    margin-right: 14rem;
  }

  .sm\\:mb-56{
    margin-bottom: 14rem;
  }

  .sm\\:ml-56{
    margin-left: 14rem;
  }

  .sm\\:mt-60{
    margin-top: 15rem;
  }

  .sm\\:mr-60{
    margin-right: 15rem;
  }

  .sm\\:mb-60{
    margin-bottom: 15rem;
  }

  .sm\\:ml-60{
    margin-left: 15rem;
  }

  .sm\\:mt-64{
    margin-top: 16rem;
  }

  .sm\\:mr-64{
    margin-right: 16rem;
  }

  .sm\\:mb-64{
    margin-bottom: 16rem;
  }

  .sm\\:ml-64{
    margin-left: 16rem;
  }

  .sm\\:mt-68{
    margin-top: 17rem;
  }

  .sm\\:mr-68{
    margin-right: 17rem;
  }

  .sm\\:mb-68{
    margin-bottom: 17rem;
  }

  .sm\\:ml-68{
    margin-left: 17rem;
  }

  .sm\\:mt-72{
    margin-top: 18rem;
  }

  .sm\\:mr-72{
    margin-right: 18rem;
  }

  .sm\\:mb-72{
    margin-bottom: 18rem;
  }

  .sm\\:ml-72{
    margin-left: 18rem;
  }

  .sm\\:mt-74{
    margin-top: 18.5rem;
  }

  .sm\\:mr-74{
    margin-right: 18.5rem;
  }

  .sm\\:mb-74{
    margin-bottom: 18.5rem;
  }

  .sm\\:ml-74{
    margin-left: 18.5rem;
  }

  .sm\\:mt-76{
    margin-top: 19rem;
  }

  .sm\\:mr-76{
    margin-right: 19rem;
  }

  .sm\\:mb-76{
    margin-bottom: 19rem;
  }

  .sm\\:ml-76{
    margin-left: 19rem;
  }

  .sm\\:mt-78{
    margin-top: 19.5rem;
  }

  .sm\\:mr-78{
    margin-right: 19.5rem;
  }

  .sm\\:mb-78{
    margin-bottom: 19.5rem;
  }

  .sm\\:ml-78{
    margin-left: 19.5rem;
  }

  .sm\\:mt-80{
    margin-top: 20rem;
  }

  .sm\\:mr-80{
    margin-right: 20rem;
  }

  .sm\\:mb-80{
    margin-bottom: 20rem;
  }

  .sm\\:ml-80{
    margin-left: 20rem;
  }

  .sm\\:mt-82{
    margin-top: 20.5rem;
  }

  .sm\\:mr-82{
    margin-right: 20.5rem;
  }

  .sm\\:mb-82{
    margin-bottom: 20.5rem;
  }

  .sm\\:ml-82{
    margin-left: 20.5rem;
  }

  .sm\\:mt-84{
    margin-top: 21rem;
  }

  .sm\\:mr-84{
    margin-right: 21rem;
  }

  .sm\\:mb-84{
    margin-bottom: 21rem;
  }

  .sm\\:ml-84{
    margin-left: 21rem;
  }

  .sm\\:mt-88{
    margin-top: 22rem;
  }

  .sm\\:mr-88{
    margin-right: 22rem;
  }

  .sm\\:mb-88{
    margin-bottom: 22rem;
  }

  .sm\\:ml-88{
    margin-left: 22rem;
  }

  .sm\\:mt-92{
    margin-top: 23rem;
  }

  .sm\\:mr-92{
    margin-right: 23rem;
  }

  .sm\\:mb-92{
    margin-bottom: 23rem;
  }

  .sm\\:ml-92{
    margin-left: 23rem;
  }

  .sm\\:mt-96{
    margin-top: 24rem;
  }

  .sm\\:mr-96{
    margin-right: 24rem;
  }

  .sm\\:mb-96{
    margin-bottom: 24rem;
  }

  .sm\\:ml-96{
    margin-left: 24rem;
  }

  .sm\\:mt-98{
    margin-top: 24.5rem;
  }

  .sm\\:mr-98{
    margin-right: 24.5rem;
  }

  .sm\\:mb-98{
    margin-bottom: 24.5rem;
  }

  .sm\\:ml-98{
    margin-left: 24.5rem;
  }

  .sm\\:mt-100{
    margin-top: 25rem;
  }

  .sm\\:mr-100{
    margin-right: 25rem;
  }

  .sm\\:mb-100{
    margin-bottom: 25rem;
  }

  .sm\\:ml-100{
    margin-left: 25rem;
  }

  .sm\\:mt-104{
    margin-top: 26rem;
  }

  .sm\\:mr-104{
    margin-right: 26rem;
  }

  .sm\\:mb-104{
    margin-bottom: 26rem;
  }

  .sm\\:ml-104{
    margin-left: 26rem;
  }

  .sm\\:mt-112{
    margin-top: 28rem;
  }

  .sm\\:mr-112{
    margin-right: 28rem;
  }

  .sm\\:mb-112{
    margin-bottom: 28rem;
  }

  .sm\\:ml-112{
    margin-left: 28rem;
  }

  .sm\\:mt-124{
    margin-top: 31rem;
  }

  .sm\\:mr-124{
    margin-right: 31rem;
  }

  .sm\\:mb-124{
    margin-bottom: 31rem;
  }

  .sm\\:ml-124{
    margin-left: 31rem;
  }

  .sm\\:mt-128{
    margin-top: 32rem;
  }

  .sm\\:mr-128{
    margin-right: 32rem;
  }

  .sm\\:mb-128{
    margin-bottom: 32rem;
  }

  .sm\\:ml-128{
    margin-left: 32rem;
  }

  .sm\\:mt-140{
    margin-top: 35rem;
  }

  .sm\\:mr-140{
    margin-right: 35rem;
  }

  .sm\\:mb-140{
    margin-bottom: 35rem;
  }

  .sm\\:ml-140{
    margin-left: 35rem;
  }

  .sm\\:mt-152{
    margin-top: 38rem;
  }

  .sm\\:mr-152{
    margin-right: 38rem;
  }

  .sm\\:mb-152{
    margin-bottom: 38rem;
  }

  .sm\\:ml-152{
    margin-left: 38rem;
  }

  .sm\\:mt-160{
    margin-top: 40rem;
  }

  .sm\\:mr-160{
    margin-right: 40rem;
  }

  .sm\\:mb-160{
    margin-bottom: 40rem;
  }

  .sm\\:ml-160{
    margin-left: 40rem;
  }

  .sm\\:mt-162{
    margin-top: 41rem;
  }

  .sm\\:mr-162{
    margin-right: 41rem;
  }

  .sm\\:mb-162{
    margin-bottom: 41rem;
  }

  .sm\\:ml-162{
    margin-left: 41rem;
  }

  .sm\\:mt-192{
    margin-top: 48rem;
  }

  .sm\\:mr-192{
    margin-right: 48rem;
  }

  .sm\\:mb-192{
    margin-bottom: 48rem;
  }

  .sm\\:ml-192{
    margin-left: 48rem;
  }

  .sm\\:mt-208{
    margin-top: 52rem;
  }

  .sm\\:mr-208{
    margin-right: 52rem;
  }

  .sm\\:mb-208{
    margin-bottom: 52rem;
  }

  .sm\\:ml-208{
    margin-left: 52rem;
  }

  .sm\\:mt-224{
    margin-top: 56rem;
  }

  .sm\\:mr-224{
    margin-right: 56rem;
  }

  .sm\\:mb-224{
    margin-bottom: 56rem;
  }

  .sm\\:ml-224{
    margin-left: 56rem;
  }

  .sm\\:mt-256{
    margin-top: 64rem;
  }

  .sm\\:mr-256{
    margin-right: 64rem;
  }

  .sm\\:mb-256{
    margin-bottom: 64rem;
  }

  .sm\\:ml-256{
    margin-left: 64rem;
  }

  .sm\\:mt-auto{
    margin-top: auto;
  }

  .sm\\:mr-auto{
    margin-right: auto;
  }

  .sm\\:mb-auto{
    margin-bottom: auto;
  }

  .sm\\:ml-auto{
    margin-left: auto;
  }

  .sm\\:mt-px{
    margin-top: 1px;
  }

  .sm\\:mr-px{
    margin-right: 1px;
  }

  .sm\\:mb-px{
    margin-bottom: 1px;
  }

  .sm\\:ml-px{
    margin-left: 1px;
  }

  .sm\\:-mt-1{
    margin-top: -0.25rem;
  }

  .sm\\:-mr-1{
    margin-right: -0.25rem;
  }

  .sm\\:-mb-1{
    margin-bottom: -0.25rem;
  }

  .sm\\:-ml-1{
    margin-left: -0.25rem;
  }

  .sm\\:-mt-2{
    margin-top: -0.5rem;
  }

  .sm\\:-mr-2{
    margin-right: -0.5rem;
  }

  .sm\\:-mb-2{
    margin-bottom: -0.5rem;
  }

  .sm\\:-ml-2{
    margin-left: -0.5rem;
  }

  .sm\\:-mt-3{
    margin-top: -0.75rem;
  }

  .sm\\:-mr-3{
    margin-right: -0.75rem;
  }

  .sm\\:-mb-3{
    margin-bottom: -0.75rem;
  }

  .sm\\:-ml-3{
    margin-left: -0.75rem;
  }

  .sm\\:-mt-4{
    margin-top: -1rem;
  }

  .sm\\:-mr-4{
    margin-right: -1rem;
  }

  .sm\\:-mb-4{
    margin-bottom: -1rem;
  }

  .sm\\:-ml-4{
    margin-left: -1rem;
  }

  .sm\\:-mt-5{
    margin-top: -1.25rem;
  }

  .sm\\:-mr-5{
    margin-right: -1.25rem;
  }

  .sm\\:-mb-5{
    margin-bottom: -1.25rem;
  }

  .sm\\:-ml-5{
    margin-left: -1.25rem;
  }

  .sm\\:-mt-6{
    margin-top: -1.5rem;
  }

  .sm\\:-mr-6{
    margin-right: -1.5rem;
  }

  .sm\\:-mb-6{
    margin-bottom: -1.5rem;
  }

  .sm\\:-ml-6{
    margin-left: -1.5rem;
  }

  .sm\\:-mt-7{
    margin-top: -1.75rem;
  }

  .sm\\:-mr-7{
    margin-right: -1.75rem;
  }

  .sm\\:-mb-7{
    margin-bottom: -1.75rem;
  }

  .sm\\:-ml-7{
    margin-left: -1.75rem;
  }

  .sm\\:-mt-8{
    margin-top: -2rem;
  }

  .sm\\:-mr-8{
    margin-right: -2rem;
  }

  .sm\\:-mb-8{
    margin-bottom: -2rem;
  }

  .sm\\:-ml-8{
    margin-left: -2rem;
  }

  .sm\\:-mt-9{
    margin-top: -2.25rem;
  }

  .sm\\:-mr-9{
    margin-right: -2.25rem;
  }

  .sm\\:-mb-9{
    margin-bottom: -2.25rem;
  }

  .sm\\:-ml-9{
    margin-left: -2.25rem;
  }

  .sm\\:-mt-10{
    margin-top: -2.5rem;
  }

  .sm\\:-mr-10{
    margin-right: -2.5rem;
  }

  .sm\\:-mb-10{
    margin-bottom: -2.5rem;
  }

  .sm\\:-ml-10{
    margin-left: -2.5rem;
  }

  .sm\\:-mt-11{
    margin-top: -2.75rem;
  }

  .sm\\:-mr-11{
    margin-right: -2.75rem;
  }

  .sm\\:-mb-11{
    margin-bottom: -2.75rem;
  }

  .sm\\:-ml-11{
    margin-left: -2.75rem;
  }

  .sm\\:-mt-12{
    margin-top: -3rem;
  }

  .sm\\:-mr-12{
    margin-right: -3rem;
  }

  .sm\\:-mb-12{
    margin-bottom: -3rem;
  }

  .sm\\:-ml-12{
    margin-left: -3rem;
  }

  .sm\\:-mt-14{
    margin-top: -3.5rem;
  }

  .sm\\:-mr-14{
    margin-right: -3.5rem;
  }

  .sm\\:-mb-14{
    margin-bottom: -3.5rem;
  }

  .sm\\:-ml-14{
    margin-left: -3.5rem;
  }

  .sm\\:-mt-15{
    margin-top: -3.75rem;
  }

  .sm\\:-mr-15{
    margin-right: -3.75rem;
  }

  .sm\\:-mb-15{
    margin-bottom: -3.75rem;
  }

  .sm\\:-ml-15{
    margin-left: -3.75rem;
  }

  .sm\\:-mt-16{
    margin-top: -4rem;
  }

  .sm\\:-mr-16{
    margin-right: -4rem;
  }

  .sm\\:-mb-16{
    margin-bottom: -4rem;
  }

  .sm\\:-ml-16{
    margin-left: -4rem;
  }

  .sm\\:-mt-18{
    margin-top: -4.5rem;
  }

  .sm\\:-mr-18{
    margin-right: -4.5rem;
  }

  .sm\\:-mb-18{
    margin-bottom: -4.5rem;
  }

  .sm\\:-ml-18{
    margin-left: -4.5rem;
  }

  .sm\\:-mt-20{
    margin-top: -5rem;
  }

  .sm\\:-mr-20{
    margin-right: -5rem;
  }

  .sm\\:-mb-20{
    margin-bottom: -5rem;
  }

  .sm\\:-ml-20{
    margin-left: -5rem;
  }

  .sm\\:-mt-22{
    margin-top: -5.5rem;
  }

  .sm\\:-mr-22{
    margin-right: -5.5rem;
  }

  .sm\\:-mb-22{
    margin-bottom: -5.5rem;
  }

  .sm\\:-ml-22{
    margin-left: -5.5rem;
  }

  .sm\\:-mt-23{
    margin-top: -5.75rem;
  }

  .sm\\:-mr-23{
    margin-right: -5.75rem;
  }

  .sm\\:-mb-23{
    margin-bottom: -5.75rem;
  }

  .sm\\:-ml-23{
    margin-left: -5.75rem;
  }

  .sm\\:-mt-24{
    margin-top: -6rem;
  }

  .sm\\:-mr-24{
    margin-right: -6rem;
  }

  .sm\\:-mb-24{
    margin-bottom: -6rem;
  }

  .sm\\:-ml-24{
    margin-left: -6rem;
  }

  .sm\\:-mt-25{
    margin-top: -6.25rem;
  }

  .sm\\:-mr-25{
    margin-right: -6.25rem;
  }

  .sm\\:-mb-25{
    margin-bottom: -6.25rem;
  }

  .sm\\:-ml-25{
    margin-left: -6.25rem;
  }

  .sm\\:-mt-26{
    margin-top: -6.5rem;
  }

  .sm\\:-mr-26{
    margin-right: -6.5rem;
  }

  .sm\\:-mb-26{
    margin-bottom: -6.5rem;
  }

  .sm\\:-ml-26{
    margin-left: -6.5rem;
  }

  .sm\\:-mt-28{
    margin-top: -7rem;
  }

  .sm\\:-mr-28{
    margin-right: -7rem;
  }

  .sm\\:-mb-28{
    margin-bottom: -7rem;
  }

  .sm\\:-ml-28{
    margin-left: -7rem;
  }

  .sm\\:-mt-30{
    margin-top: -7.5rem;
  }

  .sm\\:-mr-30{
    margin-right: -7.5rem;
  }

  .sm\\:-mb-30{
    margin-bottom: -7.5rem;
  }

  .sm\\:-ml-30{
    margin-left: -7.5rem;
  }

  .sm\\:-mt-32{
    margin-top: -8rem;
  }

  .sm\\:-mr-32{
    margin-right: -8rem;
  }

  .sm\\:-mb-32{
    margin-bottom: -8rem;
  }

  .sm\\:-ml-32{
    margin-left: -8rem;
  }

  .sm\\:-mt-34{
    margin-top: -8.5rem;
  }

  .sm\\:-mr-34{
    margin-right: -8.5rem;
  }

  .sm\\:-mb-34{
    margin-bottom: -8.5rem;
  }

  .sm\\:-ml-34{
    margin-left: -8.5rem;
  }

  .sm\\:-mt-40{
    margin-top: -10rem;
  }

  .sm\\:-mr-40{
    margin-right: -10rem;
  }

  .sm\\:-mb-40{
    margin-bottom: -10rem;
  }

  .sm\\:-ml-40{
    margin-left: -10rem;
  }

  .sm\\:-mt-42{
    margin-top: -10.5rem;
  }

  .sm\\:-mr-42{
    margin-right: -10.5rem;
  }

  .sm\\:-mb-42{
    margin-bottom: -10.5rem;
  }

  .sm\\:-ml-42{
    margin-left: -10.5rem;
  }

  .sm\\:-mt-44{
    margin-top: -11rem;
  }

  .sm\\:-mr-44{
    margin-right: -11rem;
  }

  .sm\\:-mb-44{
    margin-bottom: -11rem;
  }

  .sm\\:-ml-44{
    margin-left: -11rem;
  }

  .sm\\:-mt-48{
    margin-top: -12rem;
  }

  .sm\\:-mr-48{
    margin-right: -12rem;
  }

  .sm\\:-mb-48{
    margin-bottom: -12rem;
  }

  .sm\\:-ml-48{
    margin-left: -12rem;
  }

  .sm\\:-mt-52{
    margin-top: -13rem;
  }

  .sm\\:-mr-52{
    margin-right: -13rem;
  }

  .sm\\:-mb-52{
    margin-bottom: -13rem;
  }

  .sm\\:-ml-52{
    margin-left: -13rem;
  }

  .sm\\:-mt-54{
    margin-top: -13.5rem;
  }

  .sm\\:-mr-54{
    margin-right: -13.5rem;
  }

  .sm\\:-mb-54{
    margin-bottom: -13.5rem;
  }

  .sm\\:-ml-54{
    margin-left: -13.5rem;
  }

  .sm\\:-mt-56{
    margin-top: -14rem;
  }

  .sm\\:-mr-56{
    margin-right: -14rem;
  }

  .sm\\:-mb-56{
    margin-bottom: -14rem;
  }

  .sm\\:-ml-56{
    margin-left: -14rem;
  }

  .sm\\:-mt-60{
    margin-top: -15rem;
  }

  .sm\\:-mr-60{
    margin-right: -15rem;
  }

  .sm\\:-mb-60{
    margin-bottom: -15rem;
  }

  .sm\\:-ml-60{
    margin-left: -15rem;
  }

  .sm\\:-mt-64{
    margin-top: -16rem;
  }

  .sm\\:-mr-64{
    margin-right: -16rem;
  }

  .sm\\:-mb-64{
    margin-bottom: -16rem;
  }

  .sm\\:-ml-64{
    margin-left: -16rem;
  }

  .sm\\:-mt-68{
    margin-top: -17rem;
  }

  .sm\\:-mr-68{
    margin-right: -17rem;
  }

  .sm\\:-mb-68{
    margin-bottom: -17rem;
  }

  .sm\\:-ml-68{
    margin-left: -17rem;
  }

  .sm\\:-mt-72{
    margin-top: -18rem;
  }

  .sm\\:-mr-72{
    margin-right: -18rem;
  }

  .sm\\:-mb-72{
    margin-bottom: -18rem;
  }

  .sm\\:-ml-72{
    margin-left: -18rem;
  }

  .sm\\:-mt-74{
    margin-top: -18.5rem;
  }

  .sm\\:-mr-74{
    margin-right: -18.5rem;
  }

  .sm\\:-mb-74{
    margin-bottom: -18.5rem;
  }

  .sm\\:-ml-74{
    margin-left: -18.5rem;
  }

  .sm\\:-mt-76{
    margin-top: -19rem;
  }

  .sm\\:-mr-76{
    margin-right: -19rem;
  }

  .sm\\:-mb-76{
    margin-bottom: -19rem;
  }

  .sm\\:-ml-76{
    margin-left: -19rem;
  }

  .sm\\:-mt-78{
    margin-top: -19.5rem;
  }

  .sm\\:-mr-78{
    margin-right: -19.5rem;
  }

  .sm\\:-mb-78{
    margin-bottom: -19.5rem;
  }

  .sm\\:-ml-78{
    margin-left: -19.5rem;
  }

  .sm\\:-mt-80{
    margin-top: -20rem;
  }

  .sm\\:-mr-80{
    margin-right: -20rem;
  }

  .sm\\:-mb-80{
    margin-bottom: -20rem;
  }

  .sm\\:-ml-80{
    margin-left: -20rem;
  }

  .sm\\:-mt-82{
    margin-top: -20.5rem;
  }

  .sm\\:-mr-82{
    margin-right: -20.5rem;
  }

  .sm\\:-mb-82{
    margin-bottom: -20.5rem;
  }

  .sm\\:-ml-82{
    margin-left: -20.5rem;
  }

  .sm\\:-mt-84{
    margin-top: -21rem;
  }

  .sm\\:-mr-84{
    margin-right: -21rem;
  }

  .sm\\:-mb-84{
    margin-bottom: -21rem;
  }

  .sm\\:-ml-84{
    margin-left: -21rem;
  }

  .sm\\:-mt-88{
    margin-top: -22rem;
  }

  .sm\\:-mr-88{
    margin-right: -22rem;
  }

  .sm\\:-mb-88{
    margin-bottom: -22rem;
  }

  .sm\\:-ml-88{
    margin-left: -22rem;
  }

  .sm\\:-mt-92{
    margin-top: -23rem;
  }

  .sm\\:-mr-92{
    margin-right: -23rem;
  }

  .sm\\:-mb-92{
    margin-bottom: -23rem;
  }

  .sm\\:-ml-92{
    margin-left: -23rem;
  }

  .sm\\:-mt-96{
    margin-top: -24rem;
  }

  .sm\\:-mr-96{
    margin-right: -24rem;
  }

  .sm\\:-mb-96{
    margin-bottom: -24rem;
  }

  .sm\\:-ml-96{
    margin-left: -24rem;
  }

  .sm\\:-mt-98{
    margin-top: -24.5rem;
  }

  .sm\\:-mr-98{
    margin-right: -24.5rem;
  }

  .sm\\:-mb-98{
    margin-bottom: -24.5rem;
  }

  .sm\\:-ml-98{
    margin-left: -24.5rem;
  }

  .sm\\:-mt-100{
    margin-top: -25rem;
  }

  .sm\\:-mr-100{
    margin-right: -25rem;
  }

  .sm\\:-mb-100{
    margin-bottom: -25rem;
  }

  .sm\\:-ml-100{
    margin-left: -25rem;
  }

  .sm\\:-mt-104{
    margin-top: -26rem;
  }

  .sm\\:-mr-104{
    margin-right: -26rem;
  }

  .sm\\:-mb-104{
    margin-bottom: -26rem;
  }

  .sm\\:-ml-104{
    margin-left: -26rem;
  }

  .sm\\:-mt-112{
    margin-top: -28rem;
  }

  .sm\\:-mr-112{
    margin-right: -28rem;
  }

  .sm\\:-mb-112{
    margin-bottom: -28rem;
  }

  .sm\\:-ml-112{
    margin-left: -28rem;
  }

  .sm\\:-mt-124{
    margin-top: -31rem;
  }

  .sm\\:-mr-124{
    margin-right: -31rem;
  }

  .sm\\:-mb-124{
    margin-bottom: -31rem;
  }

  .sm\\:-ml-124{
    margin-left: -31rem;
  }

  .sm\\:-mt-128{
    margin-top: -32rem;
  }

  .sm\\:-mr-128{
    margin-right: -32rem;
  }

  .sm\\:-mb-128{
    margin-bottom: -32rem;
  }

  .sm\\:-ml-128{
    margin-left: -32rem;
  }

  .sm\\:-mt-140{
    margin-top: -35rem;
  }

  .sm\\:-mr-140{
    margin-right: -35rem;
  }

  .sm\\:-mb-140{
    margin-bottom: -35rem;
  }

  .sm\\:-ml-140{
    margin-left: -35rem;
  }

  .sm\\:-mt-152{
    margin-top: -38rem;
  }

  .sm\\:-mr-152{
    margin-right: -38rem;
  }

  .sm\\:-mb-152{
    margin-bottom: -38rem;
  }

  .sm\\:-ml-152{
    margin-left: -38rem;
  }

  .sm\\:-mt-160{
    margin-top: -40rem;
  }

  .sm\\:-mr-160{
    margin-right: -40rem;
  }

  .sm\\:-mb-160{
    margin-bottom: -40rem;
  }

  .sm\\:-ml-160{
    margin-left: -40rem;
  }

  .sm\\:-mt-162{
    margin-top: -41rem;
  }

  .sm\\:-mr-162{
    margin-right: -41rem;
  }

  .sm\\:-mb-162{
    margin-bottom: -41rem;
  }

  .sm\\:-ml-162{
    margin-left: -41rem;
  }

  .sm\\:-mt-192{
    margin-top: -48rem;
  }

  .sm\\:-mr-192{
    margin-right: -48rem;
  }

  .sm\\:-mb-192{
    margin-bottom: -48rem;
  }

  .sm\\:-ml-192{
    margin-left: -48rem;
  }

  .sm\\:-mt-208{
    margin-top: -52rem;
  }

  .sm\\:-mr-208{
    margin-right: -52rem;
  }

  .sm\\:-mb-208{
    margin-bottom: -52rem;
  }

  .sm\\:-ml-208{
    margin-left: -52rem;
  }

  .sm\\:-mt-224{
    margin-top: -56rem;
  }

  .sm\\:-mr-224{
    margin-right: -56rem;
  }

  .sm\\:-mb-224{
    margin-bottom: -56rem;
  }

  .sm\\:-ml-224{
    margin-left: -56rem;
  }

  .sm\\:-mt-256{
    margin-top: -64rem;
  }

  .sm\\:-mr-256{
    margin-right: -64rem;
  }

  .sm\\:-mb-256{
    margin-bottom: -64rem;
  }

  .sm\\:-ml-256{
    margin-left: -64rem;
  }

  .sm\\:-mt-px{
    margin-top: -1px;
  }

  .sm\\:-mr-px{
    margin-right: -1px;
  }

  .sm\\:-mb-px{
    margin-bottom: -1px;
  }

  .sm\\:-ml-px{
    margin-left: -1px;
  }

  .sm\\:first\\:m-0:first-child{
    margin: 0;
  }

  .sm\\:first\\:m-1:first-child{
    margin: 0.25rem;
  }

  .sm\\:first\\:m-2:first-child{
    margin: 0.5rem;
  }

  .sm\\:first\\:m-3:first-child{
    margin: 0.75rem;
  }

  .sm\\:first\\:m-4:first-child{
    margin: 1rem;
  }

  .sm\\:first\\:m-5:first-child{
    margin: 1.25rem;
  }

  .sm\\:first\\:m-6:first-child{
    margin: 1.5rem;
  }

  .sm\\:first\\:m-7:first-child{
    margin: 1.75rem;
  }

  .sm\\:first\\:m-8:first-child{
    margin: 2rem;
  }

  .sm\\:first\\:m-9:first-child{
    margin: 2.25rem;
  }

  .sm\\:first\\:m-10:first-child{
    margin: 2.5rem;
  }

  .sm\\:first\\:m-11:first-child{
    margin: 2.75rem;
  }

  .sm\\:first\\:m-12:first-child{
    margin: 3rem;
  }

  .sm\\:first\\:m-14:first-child{
    margin: 3.5rem;
  }

  .sm\\:first\\:m-15:first-child{
    margin: 3.75rem;
  }

  .sm\\:first\\:m-16:first-child{
    margin: 4rem;
  }

  .sm\\:first\\:m-18:first-child{
    margin: 4.5rem;
  }

  .sm\\:first\\:m-20:first-child{
    margin: 5rem;
  }

  .sm\\:first\\:m-22:first-child{
    margin: 5.5rem;
  }

  .sm\\:first\\:m-23:first-child{
    margin: 5.75rem;
  }

  .sm\\:first\\:m-24:first-child{
    margin: 6rem;
  }

  .sm\\:first\\:m-25:first-child{
    margin: 6.25rem;
  }

  .sm\\:first\\:m-26:first-child{
    margin: 6.5rem;
  }

  .sm\\:first\\:m-28:first-child{
    margin: 7rem;
  }

  .sm\\:first\\:m-30:first-child{
    margin: 7.5rem;
  }

  .sm\\:first\\:m-32:first-child{
    margin: 8rem;
  }

  .sm\\:first\\:m-34:first-child{
    margin: 8.5rem;
  }

  .sm\\:first\\:m-40:first-child{
    margin: 10rem;
  }

  .sm\\:first\\:m-42:first-child{
    margin: 10.5rem;
  }

  .sm\\:first\\:m-44:first-child{
    margin: 11rem;
  }

  .sm\\:first\\:m-48:first-child{
    margin: 12rem;
  }

  .sm\\:first\\:m-52:first-child{
    margin: 13rem;
  }

  .sm\\:first\\:m-54:first-child{
    margin: 13.5rem;
  }

  .sm\\:first\\:m-56:first-child{
    margin: 14rem;
  }

  .sm\\:first\\:m-60:first-child{
    margin: 15rem;
  }

  .sm\\:first\\:m-64:first-child{
    margin: 16rem;
  }

  .sm\\:first\\:m-68:first-child{
    margin: 17rem;
  }

  .sm\\:first\\:m-72:first-child{
    margin: 18rem;
  }

  .sm\\:first\\:m-74:first-child{
    margin: 18.5rem;
  }

  .sm\\:first\\:m-76:first-child{
    margin: 19rem;
  }

  .sm\\:first\\:m-78:first-child{
    margin: 19.5rem;
  }

  .sm\\:first\\:m-80:first-child{
    margin: 20rem;
  }

  .sm\\:first\\:m-82:first-child{
    margin: 20.5rem;
  }

  .sm\\:first\\:m-84:first-child{
    margin: 21rem;
  }

  .sm\\:first\\:m-88:first-child{
    margin: 22rem;
  }

  .sm\\:first\\:m-92:first-child{
    margin: 23rem;
  }

  .sm\\:first\\:m-96:first-child{
    margin: 24rem;
  }

  .sm\\:first\\:m-98:first-child{
    margin: 24.5rem;
  }

  .sm\\:first\\:m-100:first-child{
    margin: 25rem;
  }

  .sm\\:first\\:m-104:first-child{
    margin: 26rem;
  }

  .sm\\:first\\:m-112:first-child{
    margin: 28rem;
  }

  .sm\\:first\\:m-124:first-child{
    margin: 31rem;
  }

  .sm\\:first\\:m-128:first-child{
    margin: 32rem;
  }

  .sm\\:first\\:m-140:first-child{
    margin: 35rem;
  }

  .sm\\:first\\:m-152:first-child{
    margin: 38rem;
  }

  .sm\\:first\\:m-160:first-child{
    margin: 40rem;
  }

  .sm\\:first\\:m-162:first-child{
    margin: 41rem;
  }

  .sm\\:first\\:m-192:first-child{
    margin: 48rem;
  }

  .sm\\:first\\:m-208:first-child{
    margin: 52rem;
  }

  .sm\\:first\\:m-224:first-child{
    margin: 56rem;
  }

  .sm\\:first\\:m-256:first-child{
    margin: 64rem;
  }

  .sm\\:first\\:m-auto:first-child{
    margin: auto;
  }

  .sm\\:first\\:m-px:first-child{
    margin: 1px;
  }

  .sm\\:first\\:-m-1:first-child{
    margin: -0.25rem;
  }

  .sm\\:first\\:-m-2:first-child{
    margin: -0.5rem;
  }

  .sm\\:first\\:-m-3:first-child{
    margin: -0.75rem;
  }

  .sm\\:first\\:-m-4:first-child{
    margin: -1rem;
  }

  .sm\\:first\\:-m-5:first-child{
    margin: -1.25rem;
  }

  .sm\\:first\\:-m-6:first-child{
    margin: -1.5rem;
  }

  .sm\\:first\\:-m-7:first-child{
    margin: -1.75rem;
  }

  .sm\\:first\\:-m-8:first-child{
    margin: -2rem;
  }

  .sm\\:first\\:-m-9:first-child{
    margin: -2.25rem;
  }

  .sm\\:first\\:-m-10:first-child{
    margin: -2.5rem;
  }

  .sm\\:first\\:-m-11:first-child{
    margin: -2.75rem;
  }

  .sm\\:first\\:-m-12:first-child{
    margin: -3rem;
  }

  .sm\\:first\\:-m-14:first-child{
    margin: -3.5rem;
  }

  .sm\\:first\\:-m-15:first-child{
    margin: -3.75rem;
  }

  .sm\\:first\\:-m-16:first-child{
    margin: -4rem;
  }

  .sm\\:first\\:-m-18:first-child{
    margin: -4.5rem;
  }

  .sm\\:first\\:-m-20:first-child{
    margin: -5rem;
  }

  .sm\\:first\\:-m-22:first-child{
    margin: -5.5rem;
  }

  .sm\\:first\\:-m-23:first-child{
    margin: -5.75rem;
  }

  .sm\\:first\\:-m-24:first-child{
    margin: -6rem;
  }

  .sm\\:first\\:-m-25:first-child{
    margin: -6.25rem;
  }

  .sm\\:first\\:-m-26:first-child{
    margin: -6.5rem;
  }

  .sm\\:first\\:-m-28:first-child{
    margin: -7rem;
  }

  .sm\\:first\\:-m-30:first-child{
    margin: -7.5rem;
  }

  .sm\\:first\\:-m-32:first-child{
    margin: -8rem;
  }

  .sm\\:first\\:-m-34:first-child{
    margin: -8.5rem;
  }

  .sm\\:first\\:-m-40:first-child{
    margin: -10rem;
  }

  .sm\\:first\\:-m-42:first-child{
    margin: -10.5rem;
  }

  .sm\\:first\\:-m-44:first-child{
    margin: -11rem;
  }

  .sm\\:first\\:-m-48:first-child{
    margin: -12rem;
  }

  .sm\\:first\\:-m-52:first-child{
    margin: -13rem;
  }

  .sm\\:first\\:-m-54:first-child{
    margin: -13.5rem;
  }

  .sm\\:first\\:-m-56:first-child{
    margin: -14rem;
  }

  .sm\\:first\\:-m-60:first-child{
    margin: -15rem;
  }

  .sm\\:first\\:-m-64:first-child{
    margin: -16rem;
  }

  .sm\\:first\\:-m-68:first-child{
    margin: -17rem;
  }

  .sm\\:first\\:-m-72:first-child{
    margin: -18rem;
  }

  .sm\\:first\\:-m-74:first-child{
    margin: -18.5rem;
  }

  .sm\\:first\\:-m-76:first-child{
    margin: -19rem;
  }

  .sm\\:first\\:-m-78:first-child{
    margin: -19.5rem;
  }

  .sm\\:first\\:-m-80:first-child{
    margin: -20rem;
  }

  .sm\\:first\\:-m-82:first-child{
    margin: -20.5rem;
  }

  .sm\\:first\\:-m-84:first-child{
    margin: -21rem;
  }

  .sm\\:first\\:-m-88:first-child{
    margin: -22rem;
  }

  .sm\\:first\\:-m-92:first-child{
    margin: -23rem;
  }

  .sm\\:first\\:-m-96:first-child{
    margin: -24rem;
  }

  .sm\\:first\\:-m-98:first-child{
    margin: -24.5rem;
  }

  .sm\\:first\\:-m-100:first-child{
    margin: -25rem;
  }

  .sm\\:first\\:-m-104:first-child{
    margin: -26rem;
  }

  .sm\\:first\\:-m-112:first-child{
    margin: -28rem;
  }

  .sm\\:first\\:-m-124:first-child{
    margin: -31rem;
  }

  .sm\\:first\\:-m-128:first-child{
    margin: -32rem;
  }

  .sm\\:first\\:-m-140:first-child{
    margin: -35rem;
  }

  .sm\\:first\\:-m-152:first-child{
    margin: -38rem;
  }

  .sm\\:first\\:-m-160:first-child{
    margin: -40rem;
  }

  .sm\\:first\\:-m-162:first-child{
    margin: -41rem;
  }

  .sm\\:first\\:-m-192:first-child{
    margin: -48rem;
  }

  .sm\\:first\\:-m-208:first-child{
    margin: -52rem;
  }

  .sm\\:first\\:-m-224:first-child{
    margin: -56rem;
  }

  .sm\\:first\\:-m-256:first-child{
    margin: -64rem;
  }

  .sm\\:first\\:-m-px:first-child{
    margin: -1px;
  }

  .sm\\:first\\:my-0:first-child{
    margin-top: 0;
    margin-bottom: 0;
  }

  .sm\\:first\\:mx-0:first-child{
    margin-left: 0;
    margin-right: 0;
  }

  .sm\\:first\\:my-1:first-child{
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .sm\\:first\\:mx-1:first-child{
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .sm\\:first\\:my-2:first-child{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .sm\\:first\\:mx-2:first-child{
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .sm\\:first\\:my-3:first-child{
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .sm\\:first\\:mx-3:first-child{
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .sm\\:first\\:my-4:first-child{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .sm\\:first\\:mx-4:first-child{
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .sm\\:first\\:my-5:first-child{
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .sm\\:first\\:mx-5:first-child{
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .sm\\:first\\:my-6:first-child{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .sm\\:first\\:mx-6:first-child{
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .sm\\:first\\:my-7:first-child{
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }

  .sm\\:first\\:mx-7:first-child{
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }

  .sm\\:first\\:my-8:first-child{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .sm\\:first\\:mx-8:first-child{
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .sm\\:first\\:my-9:first-child{
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }

  .sm\\:first\\:mx-9:first-child{
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }

  .sm\\:first\\:my-10:first-child{
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .sm\\:first\\:mx-10:first-child{
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .sm\\:first\\:my-11:first-child{
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;
  }

  .sm\\:first\\:mx-11:first-child{
    margin-left: 2.75rem;
    margin-right: 2.75rem;
  }

  .sm\\:first\\:my-12:first-child{
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .sm\\:first\\:mx-12:first-child{
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .sm\\:first\\:my-14:first-child{
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
  }

  .sm\\:first\\:mx-14:first-child{
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }

  .sm\\:first\\:my-15:first-child{
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
  }

  .sm\\:first\\:mx-15:first-child{
    margin-left: 3.75rem;
    margin-right: 3.75rem;
  }

  .sm\\:first\\:my-16:first-child{
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .sm\\:first\\:mx-16:first-child{
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .sm\\:first\\:my-18:first-child{
    margin-top: 4.5rem;
    margin-bottom: 4.5rem;
  }

  .sm\\:first\\:mx-18:first-child{
    margin-left: 4.5rem;
    margin-right: 4.5rem;
  }

  .sm\\:first\\:my-20:first-child{
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .sm\\:first\\:mx-20:first-child{
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .sm\\:first\\:my-22:first-child{
    margin-top: 5.5rem;
    margin-bottom: 5.5rem;
  }

  .sm\\:first\\:mx-22:first-child{
    margin-left: 5.5rem;
    margin-right: 5.5rem;
  }

  .sm\\:first\\:my-23:first-child{
    margin-top: 5.75rem;
    margin-bottom: 5.75rem;
  }

  .sm\\:first\\:mx-23:first-child{
    margin-left: 5.75rem;
    margin-right: 5.75rem;
  }

  .sm\\:first\\:my-24:first-child{
    margin-top: 6rem;
    margin-bottom: 6rem;
  }

  .sm\\:first\\:mx-24:first-child{
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .sm\\:first\\:my-25:first-child{
    margin-top: 6.25rem;
    margin-bottom: 6.25rem;
  }

  .sm\\:first\\:mx-25:first-child{
    margin-left: 6.25rem;
    margin-right: 6.25rem;
  }

  .sm\\:first\\:my-26:first-child{
    margin-top: 6.5rem;
    margin-bottom: 6.5rem;
  }

  .sm\\:first\\:mx-26:first-child{
    margin-left: 6.5rem;
    margin-right: 6.5rem;
  }

  .sm\\:first\\:my-28:first-child{
    margin-top: 7rem;
    margin-bottom: 7rem;
  }

  .sm\\:first\\:mx-28:first-child{
    margin-left: 7rem;
    margin-right: 7rem;
  }

  .sm\\:first\\:my-30:first-child{
    margin-top: 7.5rem;
    margin-bottom: 7.5rem;
  }

  .sm\\:first\\:mx-30:first-child{
    margin-left: 7.5rem;
    margin-right: 7.5rem;
  }

  .sm\\:first\\:my-32:first-child{
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  .sm\\:first\\:mx-32:first-child{
    margin-left: 8rem;
    margin-right: 8rem;
  }

  .sm\\:first\\:my-34:first-child{
    margin-top: 8.5rem;
    margin-bottom: 8.5rem;
  }

  .sm\\:first\\:mx-34:first-child{
    margin-left: 8.5rem;
    margin-right: 8.5rem;
  }

  .sm\\:first\\:my-40:first-child{
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .sm\\:first\\:mx-40:first-child{
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .sm\\:first\\:my-42:first-child{
    margin-top: 10.5rem;
    margin-bottom: 10.5rem;
  }

  .sm\\:first\\:mx-42:first-child{
    margin-left: 10.5rem;
    margin-right: 10.5rem;
  }

  .sm\\:first\\:my-44:first-child{
    margin-top: 11rem;
    margin-bottom: 11rem;
  }

  .sm\\:first\\:mx-44:first-child{
    margin-left: 11rem;
    margin-right: 11rem;
  }

  .sm\\:first\\:my-48:first-child{
    margin-top: 12rem;
    margin-bottom: 12rem;
  }

  .sm\\:first\\:mx-48:first-child{
    margin-left: 12rem;
    margin-right: 12rem;
  }

  .sm\\:first\\:my-52:first-child{
    margin-top: 13rem;
    margin-bottom: 13rem;
  }

  .sm\\:first\\:mx-52:first-child{
    margin-left: 13rem;
    margin-right: 13rem;
  }

  .sm\\:first\\:my-54:first-child{
    margin-top: 13.5rem;
    margin-bottom: 13.5rem;
  }

  .sm\\:first\\:mx-54:first-child{
    margin-left: 13.5rem;
    margin-right: 13.5rem;
  }

  .sm\\:first\\:my-56:first-child{
    margin-top: 14rem;
    margin-bottom: 14rem;
  }

  .sm\\:first\\:mx-56:first-child{
    margin-left: 14rem;
    margin-right: 14rem;
  }

  .sm\\:first\\:my-60:first-child{
    margin-top: 15rem;
    margin-bottom: 15rem;
  }

  .sm\\:first\\:mx-60:first-child{
    margin-left: 15rem;
    margin-right: 15rem;
  }

  .sm\\:first\\:my-64:first-child{
    margin-top: 16rem;
    margin-bottom: 16rem;
  }

  .sm\\:first\\:mx-64:first-child{
    margin-left: 16rem;
    margin-right: 16rem;
  }

  .sm\\:first\\:my-68:first-child{
    margin-top: 17rem;
    margin-bottom: 17rem;
  }

  .sm\\:first\\:mx-68:first-child{
    margin-left: 17rem;
    margin-right: 17rem;
  }

  .sm\\:first\\:my-72:first-child{
    margin-top: 18rem;
    margin-bottom: 18rem;
  }

  .sm\\:first\\:mx-72:first-child{
    margin-left: 18rem;
    margin-right: 18rem;
  }

  .sm\\:first\\:my-74:first-child{
    margin-top: 18.5rem;
    margin-bottom: 18.5rem;
  }

  .sm\\:first\\:mx-74:first-child{
    margin-left: 18.5rem;
    margin-right: 18.5rem;
  }

  .sm\\:first\\:my-76:first-child{
    margin-top: 19rem;
    margin-bottom: 19rem;
  }

  .sm\\:first\\:mx-76:first-child{
    margin-left: 19rem;
    margin-right: 19rem;
  }

  .sm\\:first\\:my-78:first-child{
    margin-top: 19.5rem;
    margin-bottom: 19.5rem;
  }

  .sm\\:first\\:mx-78:first-child{
    margin-left: 19.5rem;
    margin-right: 19.5rem;
  }

  .sm\\:first\\:my-80:first-child{
    margin-top: 20rem;
    margin-bottom: 20rem;
  }

  .sm\\:first\\:mx-80:first-child{
    margin-left: 20rem;
    margin-right: 20rem;
  }

  .sm\\:first\\:my-82:first-child{
    margin-top: 20.5rem;
    margin-bottom: 20.5rem;
  }

  .sm\\:first\\:mx-82:first-child{
    margin-left: 20.5rem;
    margin-right: 20.5rem;
  }

  .sm\\:first\\:my-84:first-child{
    margin-top: 21rem;
    margin-bottom: 21rem;
  }

  .sm\\:first\\:mx-84:first-child{
    margin-left: 21rem;
    margin-right: 21rem;
  }

  .sm\\:first\\:my-88:first-child{
    margin-top: 22rem;
    margin-bottom: 22rem;
  }

  .sm\\:first\\:mx-88:first-child{
    margin-left: 22rem;
    margin-right: 22rem;
  }

  .sm\\:first\\:my-92:first-child{
    margin-top: 23rem;
    margin-bottom: 23rem;
  }

  .sm\\:first\\:mx-92:first-child{
    margin-left: 23rem;
    margin-right: 23rem;
  }

  .sm\\:first\\:my-96:first-child{
    margin-top: 24rem;
    margin-bottom: 24rem;
  }

  .sm\\:first\\:mx-96:first-child{
    margin-left: 24rem;
    margin-right: 24rem;
  }

  .sm\\:first\\:my-98:first-child{
    margin-top: 24.5rem;
    margin-bottom: 24.5rem;
  }

  .sm\\:first\\:mx-98:first-child{
    margin-left: 24.5rem;
    margin-right: 24.5rem;
  }

  .sm\\:first\\:my-100:first-child{
    margin-top: 25rem;
    margin-bottom: 25rem;
  }

  .sm\\:first\\:mx-100:first-child{
    margin-left: 25rem;
    margin-right: 25rem;
  }

  .sm\\:first\\:my-104:first-child{
    margin-top: 26rem;
    margin-bottom: 26rem;
  }

  .sm\\:first\\:mx-104:first-child{
    margin-left: 26rem;
    margin-right: 26rem;
  }

  .sm\\:first\\:my-112:first-child{
    margin-top: 28rem;
    margin-bottom: 28rem;
  }

  .sm\\:first\\:mx-112:first-child{
    margin-left: 28rem;
    margin-right: 28rem;
  }

  .sm\\:first\\:my-124:first-child{
    margin-top: 31rem;
    margin-bottom: 31rem;
  }

  .sm\\:first\\:mx-124:first-child{
    margin-left: 31rem;
    margin-right: 31rem;
  }

  .sm\\:first\\:my-128:first-child{
    margin-top: 32rem;
    margin-bottom: 32rem;
  }

  .sm\\:first\\:mx-128:first-child{
    margin-left: 32rem;
    margin-right: 32rem;
  }

  .sm\\:first\\:my-140:first-child{
    margin-top: 35rem;
    margin-bottom: 35rem;
  }

  .sm\\:first\\:mx-140:first-child{
    margin-left: 35rem;
    margin-right: 35rem;
  }

  .sm\\:first\\:my-152:first-child{
    margin-top: 38rem;
    margin-bottom: 38rem;
  }

  .sm\\:first\\:mx-152:first-child{
    margin-left: 38rem;
    margin-right: 38rem;
  }

  .sm\\:first\\:my-160:first-child{
    margin-top: 40rem;
    margin-bottom: 40rem;
  }

  .sm\\:first\\:mx-160:first-child{
    margin-left: 40rem;
    margin-right: 40rem;
  }

  .sm\\:first\\:my-162:first-child{
    margin-top: 41rem;
    margin-bottom: 41rem;
  }

  .sm\\:first\\:mx-162:first-child{
    margin-left: 41rem;
    margin-right: 41rem;
  }

  .sm\\:first\\:my-192:first-child{
    margin-top: 48rem;
    margin-bottom: 48rem;
  }

  .sm\\:first\\:mx-192:first-child{
    margin-left: 48rem;
    margin-right: 48rem;
  }

  .sm\\:first\\:my-208:first-child{
    margin-top: 52rem;
    margin-bottom: 52rem;
  }

  .sm\\:first\\:mx-208:first-child{
    margin-left: 52rem;
    margin-right: 52rem;
  }

  .sm\\:first\\:my-224:first-child{
    margin-top: 56rem;
    margin-bottom: 56rem;
  }

  .sm\\:first\\:mx-224:first-child{
    margin-left: 56rem;
    margin-right: 56rem;
  }

  .sm\\:first\\:my-256:first-child{
    margin-top: 64rem;
    margin-bottom: 64rem;
  }

  .sm\\:first\\:mx-256:first-child{
    margin-left: 64rem;
    margin-right: 64rem;
  }

  .sm\\:first\\:my-auto:first-child{
    margin-top: auto;
    margin-bottom: auto;
  }

  .sm\\:first\\:mx-auto:first-child{
    margin-left: auto;
    margin-right: auto;
  }

  .sm\\:first\\:my-px:first-child{
    margin-top: 1px;
    margin-bottom: 1px;
  }

  .sm\\:first\\:mx-px:first-child{
    margin-left: 1px;
    margin-right: 1px;
  }

  .sm\\:first\\:-my-1:first-child{
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .sm\\:first\\:-mx-1:first-child{
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .sm\\:first\\:-my-2:first-child{
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }

  .sm\\:first\\:-mx-2:first-child{
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .sm\\:first\\:-my-3:first-child{
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }

  .sm\\:first\\:-mx-3:first-child{
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .sm\\:first\\:-my-4:first-child{
    margin-top: -1rem;
    margin-bottom: -1rem;
  }

  .sm\\:first\\:-mx-4:first-child{
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .sm\\:first\\:-my-5:first-child{
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }

  .sm\\:first\\:-mx-5:first-child{
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .sm\\:first\\:-my-6:first-child{
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }

  .sm\\:first\\:-mx-6:first-child{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .sm\\:first\\:-my-7:first-child{
    margin-top: -1.75rem;
    margin-bottom: -1.75rem;
  }

  .sm\\:first\\:-mx-7:first-child{
    margin-left: -1.75rem;
    margin-right: -1.75rem;
  }

  .sm\\:first\\:-my-8:first-child{
    margin-top: -2rem;
    margin-bottom: -2rem;
  }

  .sm\\:first\\:-mx-8:first-child{
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .sm\\:first\\:-my-9:first-child{
    margin-top: -2.25rem;
    margin-bottom: -2.25rem;
  }

  .sm\\:first\\:-mx-9:first-child{
    margin-left: -2.25rem;
    margin-right: -2.25rem;
  }

  .sm\\:first\\:-my-10:first-child{
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }

  .sm\\:first\\:-mx-10:first-child{
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .sm\\:first\\:-my-11:first-child{
    margin-top: -2.75rem;
    margin-bottom: -2.75rem;
  }

  .sm\\:first\\:-mx-11:first-child{
    margin-left: -2.75rem;
    margin-right: -2.75rem;
  }

  .sm\\:first\\:-my-12:first-child{
    margin-top: -3rem;
    margin-bottom: -3rem;
  }

  .sm\\:first\\:-mx-12:first-child{
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .sm\\:first\\:-my-14:first-child{
    margin-top: -3.5rem;
    margin-bottom: -3.5rem;
  }

  .sm\\:first\\:-mx-14:first-child{
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }

  .sm\\:first\\:-my-15:first-child{
    margin-top: -3.75rem;
    margin-bottom: -3.75rem;
  }

  .sm\\:first\\:-mx-15:first-child{
    margin-left: -3.75rem;
    margin-right: -3.75rem;
  }

  .sm\\:first\\:-my-16:first-child{
    margin-top: -4rem;
    margin-bottom: -4rem;
  }

  .sm\\:first\\:-mx-16:first-child{
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .sm\\:first\\:-my-18:first-child{
    margin-top: -4.5rem;
    margin-bottom: -4.5rem;
  }

  .sm\\:first\\:-mx-18:first-child{
    margin-left: -4.5rem;
    margin-right: -4.5rem;
  }

  .sm\\:first\\:-my-20:first-child{
    margin-top: -5rem;
    margin-bottom: -5rem;
  }

  .sm\\:first\\:-mx-20:first-child{
    margin-left: -5rem;
    margin-right: -5rem;
  }

  .sm\\:first\\:-my-22:first-child{
    margin-top: -5.5rem;
    margin-bottom: -5.5rem;
  }

  .sm\\:first\\:-mx-22:first-child{
    margin-left: -5.5rem;
    margin-right: -5.5rem;
  }

  .sm\\:first\\:-my-23:first-child{
    margin-top: -5.75rem;
    margin-bottom: -5.75rem;
  }

  .sm\\:first\\:-mx-23:first-child{
    margin-left: -5.75rem;
    margin-right: -5.75rem;
  }

  .sm\\:first\\:-my-24:first-child{
    margin-top: -6rem;
    margin-bottom: -6rem;
  }

  .sm\\:first\\:-mx-24:first-child{
    margin-left: -6rem;
    margin-right: -6rem;
  }

  .sm\\:first\\:-my-25:first-child{
    margin-top: -6.25rem;
    margin-bottom: -6.25rem;
  }

  .sm\\:first\\:-mx-25:first-child{
    margin-left: -6.25rem;
    margin-right: -6.25rem;
  }

  .sm\\:first\\:-my-26:first-child{
    margin-top: -6.5rem;
    margin-bottom: -6.5rem;
  }

  .sm\\:first\\:-mx-26:first-child{
    margin-left: -6.5rem;
    margin-right: -6.5rem;
  }

  .sm\\:first\\:-my-28:first-child{
    margin-top: -7rem;
    margin-bottom: -7rem;
  }

  .sm\\:first\\:-mx-28:first-child{
    margin-left: -7rem;
    margin-right: -7rem;
  }

  .sm\\:first\\:-my-30:first-child{
    margin-top: -7.5rem;
    margin-bottom: -7.5rem;
  }

  .sm\\:first\\:-mx-30:first-child{
    margin-left: -7.5rem;
    margin-right: -7.5rem;
  }

  .sm\\:first\\:-my-32:first-child{
    margin-top: -8rem;
    margin-bottom: -8rem;
  }

  .sm\\:first\\:-mx-32:first-child{
    margin-left: -8rem;
    margin-right: -8rem;
  }

  .sm\\:first\\:-my-34:first-child{
    margin-top: -8.5rem;
    margin-bottom: -8.5rem;
  }

  .sm\\:first\\:-mx-34:first-child{
    margin-left: -8.5rem;
    margin-right: -8.5rem;
  }

  .sm\\:first\\:-my-40:first-child{
    margin-top: -10rem;
    margin-bottom: -10rem;
  }

  .sm\\:first\\:-mx-40:first-child{
    margin-left: -10rem;
    margin-right: -10rem;
  }

  .sm\\:first\\:-my-42:first-child{
    margin-top: -10.5rem;
    margin-bottom: -10.5rem;
  }

  .sm\\:first\\:-mx-42:first-child{
    margin-left: -10.5rem;
    margin-right: -10.5rem;
  }

  .sm\\:first\\:-my-44:first-child{
    margin-top: -11rem;
    margin-bottom: -11rem;
  }

  .sm\\:first\\:-mx-44:first-child{
    margin-left: -11rem;
    margin-right: -11rem;
  }

  .sm\\:first\\:-my-48:first-child{
    margin-top: -12rem;
    margin-bottom: -12rem;
  }

  .sm\\:first\\:-mx-48:first-child{
    margin-left: -12rem;
    margin-right: -12rem;
  }

  .sm\\:first\\:-my-52:first-child{
    margin-top: -13rem;
    margin-bottom: -13rem;
  }

  .sm\\:first\\:-mx-52:first-child{
    margin-left: -13rem;
    margin-right: -13rem;
  }

  .sm\\:first\\:-my-54:first-child{
    margin-top: -13.5rem;
    margin-bottom: -13.5rem;
  }

  .sm\\:first\\:-mx-54:first-child{
    margin-left: -13.5rem;
    margin-right: -13.5rem;
  }

  .sm\\:first\\:-my-56:first-child{
    margin-top: -14rem;
    margin-bottom: -14rem;
  }

  .sm\\:first\\:-mx-56:first-child{
    margin-left: -14rem;
    margin-right: -14rem;
  }

  .sm\\:first\\:-my-60:first-child{
    margin-top: -15rem;
    margin-bottom: -15rem;
  }

  .sm\\:first\\:-mx-60:first-child{
    margin-left: -15rem;
    margin-right: -15rem;
  }

  .sm\\:first\\:-my-64:first-child{
    margin-top: -16rem;
    margin-bottom: -16rem;
  }

  .sm\\:first\\:-mx-64:first-child{
    margin-left: -16rem;
    margin-right: -16rem;
  }

  .sm\\:first\\:-my-68:first-child{
    margin-top: -17rem;
    margin-bottom: -17rem;
  }

  .sm\\:first\\:-mx-68:first-child{
    margin-left: -17rem;
    margin-right: -17rem;
  }

  .sm\\:first\\:-my-72:first-child{
    margin-top: -18rem;
    margin-bottom: -18rem;
  }

  .sm\\:first\\:-mx-72:first-child{
    margin-left: -18rem;
    margin-right: -18rem;
  }

  .sm\\:first\\:-my-74:first-child{
    margin-top: -18.5rem;
    margin-bottom: -18.5rem;
  }

  .sm\\:first\\:-mx-74:first-child{
    margin-left: -18.5rem;
    margin-right: -18.5rem;
  }

  .sm\\:first\\:-my-76:first-child{
    margin-top: -19rem;
    margin-bottom: -19rem;
  }

  .sm\\:first\\:-mx-76:first-child{
    margin-left: -19rem;
    margin-right: -19rem;
  }

  .sm\\:first\\:-my-78:first-child{
    margin-top: -19.5rem;
    margin-bottom: -19.5rem;
  }

  .sm\\:first\\:-mx-78:first-child{
    margin-left: -19.5rem;
    margin-right: -19.5rem;
  }

  .sm\\:first\\:-my-80:first-child{
    margin-top: -20rem;
    margin-bottom: -20rem;
  }

  .sm\\:first\\:-mx-80:first-child{
    margin-left: -20rem;
    margin-right: -20rem;
  }

  .sm\\:first\\:-my-82:first-child{
    margin-top: -20.5rem;
    margin-bottom: -20.5rem;
  }

  .sm\\:first\\:-mx-82:first-child{
    margin-left: -20.5rem;
    margin-right: -20.5rem;
  }

  .sm\\:first\\:-my-84:first-child{
    margin-top: -21rem;
    margin-bottom: -21rem;
  }

  .sm\\:first\\:-mx-84:first-child{
    margin-left: -21rem;
    margin-right: -21rem;
  }

  .sm\\:first\\:-my-88:first-child{
    margin-top: -22rem;
    margin-bottom: -22rem;
  }

  .sm\\:first\\:-mx-88:first-child{
    margin-left: -22rem;
    margin-right: -22rem;
  }

  .sm\\:first\\:-my-92:first-child{
    margin-top: -23rem;
    margin-bottom: -23rem;
  }

  .sm\\:first\\:-mx-92:first-child{
    margin-left: -23rem;
    margin-right: -23rem;
  }

  .sm\\:first\\:-my-96:first-child{
    margin-top: -24rem;
    margin-bottom: -24rem;
  }

  .sm\\:first\\:-mx-96:first-child{
    margin-left: -24rem;
    margin-right: -24rem;
  }

  .sm\\:first\\:-my-98:first-child{
    margin-top: -24.5rem;
    margin-bottom: -24.5rem;
  }

  .sm\\:first\\:-mx-98:first-child{
    margin-left: -24.5rem;
    margin-right: -24.5rem;
  }

  .sm\\:first\\:-my-100:first-child{
    margin-top: -25rem;
    margin-bottom: -25rem;
  }

  .sm\\:first\\:-mx-100:first-child{
    margin-left: -25rem;
    margin-right: -25rem;
  }

  .sm\\:first\\:-my-104:first-child{
    margin-top: -26rem;
    margin-bottom: -26rem;
  }

  .sm\\:first\\:-mx-104:first-child{
    margin-left: -26rem;
    margin-right: -26rem;
  }

  .sm\\:first\\:-my-112:first-child{
    margin-top: -28rem;
    margin-bottom: -28rem;
  }

  .sm\\:first\\:-mx-112:first-child{
    margin-left: -28rem;
    margin-right: -28rem;
  }

  .sm\\:first\\:-my-124:first-child{
    margin-top: -31rem;
    margin-bottom: -31rem;
  }

  .sm\\:first\\:-mx-124:first-child{
    margin-left: -31rem;
    margin-right: -31rem;
  }

  .sm\\:first\\:-my-128:first-child{
    margin-top: -32rem;
    margin-bottom: -32rem;
  }

  .sm\\:first\\:-mx-128:first-child{
    margin-left: -32rem;
    margin-right: -32rem;
  }

  .sm\\:first\\:-my-140:first-child{
    margin-top: -35rem;
    margin-bottom: -35rem;
  }

  .sm\\:first\\:-mx-140:first-child{
    margin-left: -35rem;
    margin-right: -35rem;
  }

  .sm\\:first\\:-my-152:first-child{
    margin-top: -38rem;
    margin-bottom: -38rem;
  }

  .sm\\:first\\:-mx-152:first-child{
    margin-left: -38rem;
    margin-right: -38rem;
  }

  .sm\\:first\\:-my-160:first-child{
    margin-top: -40rem;
    margin-bottom: -40rem;
  }

  .sm\\:first\\:-mx-160:first-child{
    margin-left: -40rem;
    margin-right: -40rem;
  }

  .sm\\:first\\:-my-162:first-child{
    margin-top: -41rem;
    margin-bottom: -41rem;
  }

  .sm\\:first\\:-mx-162:first-child{
    margin-left: -41rem;
    margin-right: -41rem;
  }

  .sm\\:first\\:-my-192:first-child{
    margin-top: -48rem;
    margin-bottom: -48rem;
  }

  .sm\\:first\\:-mx-192:first-child{
    margin-left: -48rem;
    margin-right: -48rem;
  }

  .sm\\:first\\:-my-208:first-child{
    margin-top: -52rem;
    margin-bottom: -52rem;
  }

  .sm\\:first\\:-mx-208:first-child{
    margin-left: -52rem;
    margin-right: -52rem;
  }

  .sm\\:first\\:-my-224:first-child{
    margin-top: -56rem;
    margin-bottom: -56rem;
  }

  .sm\\:first\\:-mx-224:first-child{
    margin-left: -56rem;
    margin-right: -56rem;
  }

  .sm\\:first\\:-my-256:first-child{
    margin-top: -64rem;
    margin-bottom: -64rem;
  }

  .sm\\:first\\:-mx-256:first-child{
    margin-left: -64rem;
    margin-right: -64rem;
  }

  .sm\\:first\\:-my-px:first-child{
    margin-top: -1px;
    margin-bottom: -1px;
  }

  .sm\\:first\\:-mx-px:first-child{
    margin-left: -1px;
    margin-right: -1px;
  }

  .sm\\:first\\:mt-0:first-child{
    margin-top: 0;
  }

  .sm\\:first\\:mr-0:first-child{
    margin-right: 0;
  }

  .sm\\:first\\:mb-0:first-child{
    margin-bottom: 0;
  }

  .sm\\:first\\:ml-0:first-child{
    margin-left: 0;
  }

  .sm\\:first\\:mt-1:first-child{
    margin-top: 0.25rem;
  }

  .sm\\:first\\:mr-1:first-child{
    margin-right: 0.25rem;
  }

  .sm\\:first\\:mb-1:first-child{
    margin-bottom: 0.25rem;
  }

  .sm\\:first\\:ml-1:first-child{
    margin-left: 0.25rem;
  }

  .sm\\:first\\:mt-2:first-child{
    margin-top: 0.5rem;
  }

  .sm\\:first\\:mr-2:first-child{
    margin-right: 0.5rem;
  }

  .sm\\:first\\:mb-2:first-child{
    margin-bottom: 0.5rem;
  }

  .sm\\:first\\:ml-2:first-child{
    margin-left: 0.5rem;
  }

  .sm\\:first\\:mt-3:first-child{
    margin-top: 0.75rem;
  }

  .sm\\:first\\:mr-3:first-child{
    margin-right: 0.75rem;
  }

  .sm\\:first\\:mb-3:first-child{
    margin-bottom: 0.75rem;
  }

  .sm\\:first\\:ml-3:first-child{
    margin-left: 0.75rem;
  }

  .sm\\:first\\:mt-4:first-child{
    margin-top: 1rem;
  }

  .sm\\:first\\:mr-4:first-child{
    margin-right: 1rem;
  }

  .sm\\:first\\:mb-4:first-child{
    margin-bottom: 1rem;
  }

  .sm\\:first\\:ml-4:first-child{
    margin-left: 1rem;
  }

  .sm\\:first\\:mt-5:first-child{
    margin-top: 1.25rem;
  }

  .sm\\:first\\:mr-5:first-child{
    margin-right: 1.25rem;
  }

  .sm\\:first\\:mb-5:first-child{
    margin-bottom: 1.25rem;
  }

  .sm\\:first\\:ml-5:first-child{
    margin-left: 1.25rem;
  }

  .sm\\:first\\:mt-6:first-child{
    margin-top: 1.5rem;
  }

  .sm\\:first\\:mr-6:first-child{
    margin-right: 1.5rem;
  }

  .sm\\:first\\:mb-6:first-child{
    margin-bottom: 1.5rem;
  }

  .sm\\:first\\:ml-6:first-child{
    margin-left: 1.5rem;
  }

  .sm\\:first\\:mt-7:first-child{
    margin-top: 1.75rem;
  }

  .sm\\:first\\:mr-7:first-child{
    margin-right: 1.75rem;
  }

  .sm\\:first\\:mb-7:first-child{
    margin-bottom: 1.75rem;
  }

  .sm\\:first\\:ml-7:first-child{
    margin-left: 1.75rem;
  }

  .sm\\:first\\:mt-8:first-child{
    margin-top: 2rem;
  }

  .sm\\:first\\:mr-8:first-child{
    margin-right: 2rem;
  }

  .sm\\:first\\:mb-8:first-child{
    margin-bottom: 2rem;
  }

  .sm\\:first\\:ml-8:first-child{
    margin-left: 2rem;
  }

  .sm\\:first\\:mt-9:first-child{
    margin-top: 2.25rem;
  }

  .sm\\:first\\:mr-9:first-child{
    margin-right: 2.25rem;
  }

  .sm\\:first\\:mb-9:first-child{
    margin-bottom: 2.25rem;
  }

  .sm\\:first\\:ml-9:first-child{
    margin-left: 2.25rem;
  }

  .sm\\:first\\:mt-10:first-child{
    margin-top: 2.5rem;
  }

  .sm\\:first\\:mr-10:first-child{
    margin-right: 2.5rem;
  }

  .sm\\:first\\:mb-10:first-child{
    margin-bottom: 2.5rem;
  }

  .sm\\:first\\:ml-10:first-child{
    margin-left: 2.5rem;
  }

  .sm\\:first\\:mt-11:first-child{
    margin-top: 2.75rem;
  }

  .sm\\:first\\:mr-11:first-child{
    margin-right: 2.75rem;
  }

  .sm\\:first\\:mb-11:first-child{
    margin-bottom: 2.75rem;
  }

  .sm\\:first\\:ml-11:first-child{
    margin-left: 2.75rem;
  }

  .sm\\:first\\:mt-12:first-child{
    margin-top: 3rem;
  }

  .sm\\:first\\:mr-12:first-child{
    margin-right: 3rem;
  }

  .sm\\:first\\:mb-12:first-child{
    margin-bottom: 3rem;
  }

  .sm\\:first\\:ml-12:first-child{
    margin-left: 3rem;
  }

  .sm\\:first\\:mt-14:first-child{
    margin-top: 3.5rem;
  }

  .sm\\:first\\:mr-14:first-child{
    margin-right: 3.5rem;
  }

  .sm\\:first\\:mb-14:first-child{
    margin-bottom: 3.5rem;
  }

  .sm\\:first\\:ml-14:first-child{
    margin-left: 3.5rem;
  }

  .sm\\:first\\:mt-15:first-child{
    margin-top: 3.75rem;
  }

  .sm\\:first\\:mr-15:first-child{
    margin-right: 3.75rem;
  }

  .sm\\:first\\:mb-15:first-child{
    margin-bottom: 3.75rem;
  }

  .sm\\:first\\:ml-15:first-child{
    margin-left: 3.75rem;
  }

  .sm\\:first\\:mt-16:first-child{
    margin-top: 4rem;
  }

  .sm\\:first\\:mr-16:first-child{
    margin-right: 4rem;
  }

  .sm\\:first\\:mb-16:first-child{
    margin-bottom: 4rem;
  }

  .sm\\:first\\:ml-16:first-child{
    margin-left: 4rem;
  }

  .sm\\:first\\:mt-18:first-child{
    margin-top: 4.5rem;
  }

  .sm\\:first\\:mr-18:first-child{
    margin-right: 4.5rem;
  }

  .sm\\:first\\:mb-18:first-child{
    margin-bottom: 4.5rem;
  }

  .sm\\:first\\:ml-18:first-child{
    margin-left: 4.5rem;
  }

  .sm\\:first\\:mt-20:first-child{
    margin-top: 5rem;
  }

  .sm\\:first\\:mr-20:first-child{
    margin-right: 5rem;
  }

  .sm\\:first\\:mb-20:first-child{
    margin-bottom: 5rem;
  }

  .sm\\:first\\:ml-20:first-child{
    margin-left: 5rem;
  }

  .sm\\:first\\:mt-22:first-child{
    margin-top: 5.5rem;
  }

  .sm\\:first\\:mr-22:first-child{
    margin-right: 5.5rem;
  }

  .sm\\:first\\:mb-22:first-child{
    margin-bottom: 5.5rem;
  }

  .sm\\:first\\:ml-22:first-child{
    margin-left: 5.5rem;
  }

  .sm\\:first\\:mt-23:first-child{
    margin-top: 5.75rem;
  }

  .sm\\:first\\:mr-23:first-child{
    margin-right: 5.75rem;
  }

  .sm\\:first\\:mb-23:first-child{
    margin-bottom: 5.75rem;
  }

  .sm\\:first\\:ml-23:first-child{
    margin-left: 5.75rem;
  }

  .sm\\:first\\:mt-24:first-child{
    margin-top: 6rem;
  }

  .sm\\:first\\:mr-24:first-child{
    margin-right: 6rem;
  }

  .sm\\:first\\:mb-24:first-child{
    margin-bottom: 6rem;
  }

  .sm\\:first\\:ml-24:first-child{
    margin-left: 6rem;
  }

  .sm\\:first\\:mt-25:first-child{
    margin-top: 6.25rem;
  }

  .sm\\:first\\:mr-25:first-child{
    margin-right: 6.25rem;
  }

  .sm\\:first\\:mb-25:first-child{
    margin-bottom: 6.25rem;
  }

  .sm\\:first\\:ml-25:first-child{
    margin-left: 6.25rem;
  }

  .sm\\:first\\:mt-26:first-child{
    margin-top: 6.5rem;
  }

  .sm\\:first\\:mr-26:first-child{
    margin-right: 6.5rem;
  }

  .sm\\:first\\:mb-26:first-child{
    margin-bottom: 6.5rem;
  }

  .sm\\:first\\:ml-26:first-child{
    margin-left: 6.5rem;
  }

  .sm\\:first\\:mt-28:first-child{
    margin-top: 7rem;
  }

  .sm\\:first\\:mr-28:first-child{
    margin-right: 7rem;
  }

  .sm\\:first\\:mb-28:first-child{
    margin-bottom: 7rem;
  }

  .sm\\:first\\:ml-28:first-child{
    margin-left: 7rem;
  }

  .sm\\:first\\:mt-30:first-child{
    margin-top: 7.5rem;
  }

  .sm\\:first\\:mr-30:first-child{
    margin-right: 7.5rem;
  }

  .sm\\:first\\:mb-30:first-child{
    margin-bottom: 7.5rem;
  }

  .sm\\:first\\:ml-30:first-child{
    margin-left: 7.5rem;
  }

  .sm\\:first\\:mt-32:first-child{
    margin-top: 8rem;
  }

  .sm\\:first\\:mr-32:first-child{
    margin-right: 8rem;
  }

  .sm\\:first\\:mb-32:first-child{
    margin-bottom: 8rem;
  }

  .sm\\:first\\:ml-32:first-child{
    margin-left: 8rem;
  }

  .sm\\:first\\:mt-34:first-child{
    margin-top: 8.5rem;
  }

  .sm\\:first\\:mr-34:first-child{
    margin-right: 8.5rem;
  }

  .sm\\:first\\:mb-34:first-child{
    margin-bottom: 8.5rem;
  }

  .sm\\:first\\:ml-34:first-child{
    margin-left: 8.5rem;
  }

  .sm\\:first\\:mt-40:first-child{
    margin-top: 10rem;
  }

  .sm\\:first\\:mr-40:first-child{
    margin-right: 10rem;
  }

  .sm\\:first\\:mb-40:first-child{
    margin-bottom: 10rem;
  }

  .sm\\:first\\:ml-40:first-child{
    margin-left: 10rem;
  }

  .sm\\:first\\:mt-42:first-child{
    margin-top: 10.5rem;
  }

  .sm\\:first\\:mr-42:first-child{
    margin-right: 10.5rem;
  }

  .sm\\:first\\:mb-42:first-child{
    margin-bottom: 10.5rem;
  }

  .sm\\:first\\:ml-42:first-child{
    margin-left: 10.5rem;
  }

  .sm\\:first\\:mt-44:first-child{
    margin-top: 11rem;
  }

  .sm\\:first\\:mr-44:first-child{
    margin-right: 11rem;
  }

  .sm\\:first\\:mb-44:first-child{
    margin-bottom: 11rem;
  }

  .sm\\:first\\:ml-44:first-child{
    margin-left: 11rem;
  }

  .sm\\:first\\:mt-48:first-child{
    margin-top: 12rem;
  }

  .sm\\:first\\:mr-48:first-child{
    margin-right: 12rem;
  }

  .sm\\:first\\:mb-48:first-child{
    margin-bottom: 12rem;
  }

  .sm\\:first\\:ml-48:first-child{
    margin-left: 12rem;
  }

  .sm\\:first\\:mt-52:first-child{
    margin-top: 13rem;
  }

  .sm\\:first\\:mr-52:first-child{
    margin-right: 13rem;
  }

  .sm\\:first\\:mb-52:first-child{
    margin-bottom: 13rem;
  }

  .sm\\:first\\:ml-52:first-child{
    margin-left: 13rem;
  }

  .sm\\:first\\:mt-54:first-child{
    margin-top: 13.5rem;
  }

  .sm\\:first\\:mr-54:first-child{
    margin-right: 13.5rem;
  }

  .sm\\:first\\:mb-54:first-child{
    margin-bottom: 13.5rem;
  }

  .sm\\:first\\:ml-54:first-child{
    margin-left: 13.5rem;
  }

  .sm\\:first\\:mt-56:first-child{
    margin-top: 14rem;
  }

  .sm\\:first\\:mr-56:first-child{
    margin-right: 14rem;
  }

  .sm\\:first\\:mb-56:first-child{
    margin-bottom: 14rem;
  }

  .sm\\:first\\:ml-56:first-child{
    margin-left: 14rem;
  }

  .sm\\:first\\:mt-60:first-child{
    margin-top: 15rem;
  }

  .sm\\:first\\:mr-60:first-child{
    margin-right: 15rem;
  }

  .sm\\:first\\:mb-60:first-child{
    margin-bottom: 15rem;
  }

  .sm\\:first\\:ml-60:first-child{
    margin-left: 15rem;
  }

  .sm\\:first\\:mt-64:first-child{
    margin-top: 16rem;
  }

  .sm\\:first\\:mr-64:first-child{
    margin-right: 16rem;
  }

  .sm\\:first\\:mb-64:first-child{
    margin-bottom: 16rem;
  }

  .sm\\:first\\:ml-64:first-child{
    margin-left: 16rem;
  }

  .sm\\:first\\:mt-68:first-child{
    margin-top: 17rem;
  }

  .sm\\:first\\:mr-68:first-child{
    margin-right: 17rem;
  }

  .sm\\:first\\:mb-68:first-child{
    margin-bottom: 17rem;
  }

  .sm\\:first\\:ml-68:first-child{
    margin-left: 17rem;
  }

  .sm\\:first\\:mt-72:first-child{
    margin-top: 18rem;
  }

  .sm\\:first\\:mr-72:first-child{
    margin-right: 18rem;
  }

  .sm\\:first\\:mb-72:first-child{
    margin-bottom: 18rem;
  }

  .sm\\:first\\:ml-72:first-child{
    margin-left: 18rem;
  }

  .sm\\:first\\:mt-74:first-child{
    margin-top: 18.5rem;
  }

  .sm\\:first\\:mr-74:first-child{
    margin-right: 18.5rem;
  }

  .sm\\:first\\:mb-74:first-child{
    margin-bottom: 18.5rem;
  }

  .sm\\:first\\:ml-74:first-child{
    margin-left: 18.5rem;
  }

  .sm\\:first\\:mt-76:first-child{
    margin-top: 19rem;
  }

  .sm\\:first\\:mr-76:first-child{
    margin-right: 19rem;
  }

  .sm\\:first\\:mb-76:first-child{
    margin-bottom: 19rem;
  }

  .sm\\:first\\:ml-76:first-child{
    margin-left: 19rem;
  }

  .sm\\:first\\:mt-78:first-child{
    margin-top: 19.5rem;
  }

  .sm\\:first\\:mr-78:first-child{
    margin-right: 19.5rem;
  }

  .sm\\:first\\:mb-78:first-child{
    margin-bottom: 19.5rem;
  }

  .sm\\:first\\:ml-78:first-child{
    margin-left: 19.5rem;
  }

  .sm\\:first\\:mt-80:first-child{
    margin-top: 20rem;
  }

  .sm\\:first\\:mr-80:first-child{
    margin-right: 20rem;
  }

  .sm\\:first\\:mb-80:first-child{
    margin-bottom: 20rem;
  }

  .sm\\:first\\:ml-80:first-child{
    margin-left: 20rem;
  }

  .sm\\:first\\:mt-82:first-child{
    margin-top: 20.5rem;
  }

  .sm\\:first\\:mr-82:first-child{
    margin-right: 20.5rem;
  }

  .sm\\:first\\:mb-82:first-child{
    margin-bottom: 20.5rem;
  }

  .sm\\:first\\:ml-82:first-child{
    margin-left: 20.5rem;
  }

  .sm\\:first\\:mt-84:first-child{
    margin-top: 21rem;
  }

  .sm\\:first\\:mr-84:first-child{
    margin-right: 21rem;
  }

  .sm\\:first\\:mb-84:first-child{
    margin-bottom: 21rem;
  }

  .sm\\:first\\:ml-84:first-child{
    margin-left: 21rem;
  }

  .sm\\:first\\:mt-88:first-child{
    margin-top: 22rem;
  }

  .sm\\:first\\:mr-88:first-child{
    margin-right: 22rem;
  }

  .sm\\:first\\:mb-88:first-child{
    margin-bottom: 22rem;
  }

  .sm\\:first\\:ml-88:first-child{
    margin-left: 22rem;
  }

  .sm\\:first\\:mt-92:first-child{
    margin-top: 23rem;
  }

  .sm\\:first\\:mr-92:first-child{
    margin-right: 23rem;
  }

  .sm\\:first\\:mb-92:first-child{
    margin-bottom: 23rem;
  }

  .sm\\:first\\:ml-92:first-child{
    margin-left: 23rem;
  }

  .sm\\:first\\:mt-96:first-child{
    margin-top: 24rem;
  }

  .sm\\:first\\:mr-96:first-child{
    margin-right: 24rem;
  }

  .sm\\:first\\:mb-96:first-child{
    margin-bottom: 24rem;
  }

  .sm\\:first\\:ml-96:first-child{
    margin-left: 24rem;
  }

  .sm\\:first\\:mt-98:first-child{
    margin-top: 24.5rem;
  }

  .sm\\:first\\:mr-98:first-child{
    margin-right: 24.5rem;
  }

  .sm\\:first\\:mb-98:first-child{
    margin-bottom: 24.5rem;
  }

  .sm\\:first\\:ml-98:first-child{
    margin-left: 24.5rem;
  }

  .sm\\:first\\:mt-100:first-child{
    margin-top: 25rem;
  }

  .sm\\:first\\:mr-100:first-child{
    margin-right: 25rem;
  }

  .sm\\:first\\:mb-100:first-child{
    margin-bottom: 25rem;
  }

  .sm\\:first\\:ml-100:first-child{
    margin-left: 25rem;
  }

  .sm\\:first\\:mt-104:first-child{
    margin-top: 26rem;
  }

  .sm\\:first\\:mr-104:first-child{
    margin-right: 26rem;
  }

  .sm\\:first\\:mb-104:first-child{
    margin-bottom: 26rem;
  }

  .sm\\:first\\:ml-104:first-child{
    margin-left: 26rem;
  }

  .sm\\:first\\:mt-112:first-child{
    margin-top: 28rem;
  }

  .sm\\:first\\:mr-112:first-child{
    margin-right: 28rem;
  }

  .sm\\:first\\:mb-112:first-child{
    margin-bottom: 28rem;
  }

  .sm\\:first\\:ml-112:first-child{
    margin-left: 28rem;
  }

  .sm\\:first\\:mt-124:first-child{
    margin-top: 31rem;
  }

  .sm\\:first\\:mr-124:first-child{
    margin-right: 31rem;
  }

  .sm\\:first\\:mb-124:first-child{
    margin-bottom: 31rem;
  }

  .sm\\:first\\:ml-124:first-child{
    margin-left: 31rem;
  }

  .sm\\:first\\:mt-128:first-child{
    margin-top: 32rem;
  }

  .sm\\:first\\:mr-128:first-child{
    margin-right: 32rem;
  }

  .sm\\:first\\:mb-128:first-child{
    margin-bottom: 32rem;
  }

  .sm\\:first\\:ml-128:first-child{
    margin-left: 32rem;
  }

  .sm\\:first\\:mt-140:first-child{
    margin-top: 35rem;
  }

  .sm\\:first\\:mr-140:first-child{
    margin-right: 35rem;
  }

  .sm\\:first\\:mb-140:first-child{
    margin-bottom: 35rem;
  }

  .sm\\:first\\:ml-140:first-child{
    margin-left: 35rem;
  }

  .sm\\:first\\:mt-152:first-child{
    margin-top: 38rem;
  }

  .sm\\:first\\:mr-152:first-child{
    margin-right: 38rem;
  }

  .sm\\:first\\:mb-152:first-child{
    margin-bottom: 38rem;
  }

  .sm\\:first\\:ml-152:first-child{
    margin-left: 38rem;
  }

  .sm\\:first\\:mt-160:first-child{
    margin-top: 40rem;
  }

  .sm\\:first\\:mr-160:first-child{
    margin-right: 40rem;
  }

  .sm\\:first\\:mb-160:first-child{
    margin-bottom: 40rem;
  }

  .sm\\:first\\:ml-160:first-child{
    margin-left: 40rem;
  }

  .sm\\:first\\:mt-162:first-child{
    margin-top: 41rem;
  }

  .sm\\:first\\:mr-162:first-child{
    margin-right: 41rem;
  }

  .sm\\:first\\:mb-162:first-child{
    margin-bottom: 41rem;
  }

  .sm\\:first\\:ml-162:first-child{
    margin-left: 41rem;
  }

  .sm\\:first\\:mt-192:first-child{
    margin-top: 48rem;
  }

  .sm\\:first\\:mr-192:first-child{
    margin-right: 48rem;
  }

  .sm\\:first\\:mb-192:first-child{
    margin-bottom: 48rem;
  }

  .sm\\:first\\:ml-192:first-child{
    margin-left: 48rem;
  }

  .sm\\:first\\:mt-208:first-child{
    margin-top: 52rem;
  }

  .sm\\:first\\:mr-208:first-child{
    margin-right: 52rem;
  }

  .sm\\:first\\:mb-208:first-child{
    margin-bottom: 52rem;
  }

  .sm\\:first\\:ml-208:first-child{
    margin-left: 52rem;
  }

  .sm\\:first\\:mt-224:first-child{
    margin-top: 56rem;
  }

  .sm\\:first\\:mr-224:first-child{
    margin-right: 56rem;
  }

  .sm\\:first\\:mb-224:first-child{
    margin-bottom: 56rem;
  }

  .sm\\:first\\:ml-224:first-child{
    margin-left: 56rem;
  }

  .sm\\:first\\:mt-256:first-child{
    margin-top: 64rem;
  }

  .sm\\:first\\:mr-256:first-child{
    margin-right: 64rem;
  }

  .sm\\:first\\:mb-256:first-child{
    margin-bottom: 64rem;
  }

  .sm\\:first\\:ml-256:first-child{
    margin-left: 64rem;
  }

  .sm\\:first\\:mt-auto:first-child{
    margin-top: auto;
  }

  .sm\\:first\\:mr-auto:first-child{
    margin-right: auto;
  }

  .sm\\:first\\:mb-auto:first-child{
    margin-bottom: auto;
  }

  .sm\\:first\\:ml-auto:first-child{
    margin-left: auto;
  }

  .sm\\:first\\:mt-px:first-child{
    margin-top: 1px;
  }

  .sm\\:first\\:mr-px:first-child{
    margin-right: 1px;
  }

  .sm\\:first\\:mb-px:first-child{
    margin-bottom: 1px;
  }

  .sm\\:first\\:ml-px:first-child{
    margin-left: 1px;
  }

  .sm\\:first\\:-mt-1:first-child{
    margin-top: -0.25rem;
  }

  .sm\\:first\\:-mr-1:first-child{
    margin-right: -0.25rem;
  }

  .sm\\:first\\:-mb-1:first-child{
    margin-bottom: -0.25rem;
  }

  .sm\\:first\\:-ml-1:first-child{
    margin-left: -0.25rem;
  }

  .sm\\:first\\:-mt-2:first-child{
    margin-top: -0.5rem;
  }

  .sm\\:first\\:-mr-2:first-child{
    margin-right: -0.5rem;
  }

  .sm\\:first\\:-mb-2:first-child{
    margin-bottom: -0.5rem;
  }

  .sm\\:first\\:-ml-2:first-child{
    margin-left: -0.5rem;
  }

  .sm\\:first\\:-mt-3:first-child{
    margin-top: -0.75rem;
  }

  .sm\\:first\\:-mr-3:first-child{
    margin-right: -0.75rem;
  }

  .sm\\:first\\:-mb-3:first-child{
    margin-bottom: -0.75rem;
  }

  .sm\\:first\\:-ml-3:first-child{
    margin-left: -0.75rem;
  }

  .sm\\:first\\:-mt-4:first-child{
    margin-top: -1rem;
  }

  .sm\\:first\\:-mr-4:first-child{
    margin-right: -1rem;
  }

  .sm\\:first\\:-mb-4:first-child{
    margin-bottom: -1rem;
  }

  .sm\\:first\\:-ml-4:first-child{
    margin-left: -1rem;
  }

  .sm\\:first\\:-mt-5:first-child{
    margin-top: -1.25rem;
  }

  .sm\\:first\\:-mr-5:first-child{
    margin-right: -1.25rem;
  }

  .sm\\:first\\:-mb-5:first-child{
    margin-bottom: -1.25rem;
  }

  .sm\\:first\\:-ml-5:first-child{
    margin-left: -1.25rem;
  }

  .sm\\:first\\:-mt-6:first-child{
    margin-top: -1.5rem;
  }

  .sm\\:first\\:-mr-6:first-child{
    margin-right: -1.5rem;
  }

  .sm\\:first\\:-mb-6:first-child{
    margin-bottom: -1.5rem;
  }

  .sm\\:first\\:-ml-6:first-child{
    margin-left: -1.5rem;
  }

  .sm\\:first\\:-mt-7:first-child{
    margin-top: -1.75rem;
  }

  .sm\\:first\\:-mr-7:first-child{
    margin-right: -1.75rem;
  }

  .sm\\:first\\:-mb-7:first-child{
    margin-bottom: -1.75rem;
  }

  .sm\\:first\\:-ml-7:first-child{
    margin-left: -1.75rem;
  }

  .sm\\:first\\:-mt-8:first-child{
    margin-top: -2rem;
  }

  .sm\\:first\\:-mr-8:first-child{
    margin-right: -2rem;
  }

  .sm\\:first\\:-mb-8:first-child{
    margin-bottom: -2rem;
  }

  .sm\\:first\\:-ml-8:first-child{
    margin-left: -2rem;
  }

  .sm\\:first\\:-mt-9:first-child{
    margin-top: -2.25rem;
  }

  .sm\\:first\\:-mr-9:first-child{
    margin-right: -2.25rem;
  }

  .sm\\:first\\:-mb-9:first-child{
    margin-bottom: -2.25rem;
  }

  .sm\\:first\\:-ml-9:first-child{
    margin-left: -2.25rem;
  }

  .sm\\:first\\:-mt-10:first-child{
    margin-top: -2.5rem;
  }

  .sm\\:first\\:-mr-10:first-child{
    margin-right: -2.5rem;
  }

  .sm\\:first\\:-mb-10:first-child{
    margin-bottom: -2.5rem;
  }

  .sm\\:first\\:-ml-10:first-child{
    margin-left: -2.5rem;
  }

  .sm\\:first\\:-mt-11:first-child{
    margin-top: -2.75rem;
  }

  .sm\\:first\\:-mr-11:first-child{
    margin-right: -2.75rem;
  }

  .sm\\:first\\:-mb-11:first-child{
    margin-bottom: -2.75rem;
  }

  .sm\\:first\\:-ml-11:first-child{
    margin-left: -2.75rem;
  }

  .sm\\:first\\:-mt-12:first-child{
    margin-top: -3rem;
  }

  .sm\\:first\\:-mr-12:first-child{
    margin-right: -3rem;
  }

  .sm\\:first\\:-mb-12:first-child{
    margin-bottom: -3rem;
  }

  .sm\\:first\\:-ml-12:first-child{
    margin-left: -3rem;
  }

  .sm\\:first\\:-mt-14:first-child{
    margin-top: -3.5rem;
  }

  .sm\\:first\\:-mr-14:first-child{
    margin-right: -3.5rem;
  }

  .sm\\:first\\:-mb-14:first-child{
    margin-bottom: -3.5rem;
  }

  .sm\\:first\\:-ml-14:first-child{
    margin-left: -3.5rem;
  }

  .sm\\:first\\:-mt-15:first-child{
    margin-top: -3.75rem;
  }

  .sm\\:first\\:-mr-15:first-child{
    margin-right: -3.75rem;
  }

  .sm\\:first\\:-mb-15:first-child{
    margin-bottom: -3.75rem;
  }

  .sm\\:first\\:-ml-15:first-child{
    margin-left: -3.75rem;
  }

  .sm\\:first\\:-mt-16:first-child{
    margin-top: -4rem;
  }

  .sm\\:first\\:-mr-16:first-child{
    margin-right: -4rem;
  }

  .sm\\:first\\:-mb-16:first-child{
    margin-bottom: -4rem;
  }

  .sm\\:first\\:-ml-16:first-child{
    margin-left: -4rem;
  }

  .sm\\:first\\:-mt-18:first-child{
    margin-top: -4.5rem;
  }

  .sm\\:first\\:-mr-18:first-child{
    margin-right: -4.5rem;
  }

  .sm\\:first\\:-mb-18:first-child{
    margin-bottom: -4.5rem;
  }

  .sm\\:first\\:-ml-18:first-child{
    margin-left: -4.5rem;
  }

  .sm\\:first\\:-mt-20:first-child{
    margin-top: -5rem;
  }

  .sm\\:first\\:-mr-20:first-child{
    margin-right: -5rem;
  }

  .sm\\:first\\:-mb-20:first-child{
    margin-bottom: -5rem;
  }

  .sm\\:first\\:-ml-20:first-child{
    margin-left: -5rem;
  }

  .sm\\:first\\:-mt-22:first-child{
    margin-top: -5.5rem;
  }

  .sm\\:first\\:-mr-22:first-child{
    margin-right: -5.5rem;
  }

  .sm\\:first\\:-mb-22:first-child{
    margin-bottom: -5.5rem;
  }

  .sm\\:first\\:-ml-22:first-child{
    margin-left: -5.5rem;
  }

  .sm\\:first\\:-mt-23:first-child{
    margin-top: -5.75rem;
  }

  .sm\\:first\\:-mr-23:first-child{
    margin-right: -5.75rem;
  }

  .sm\\:first\\:-mb-23:first-child{
    margin-bottom: -5.75rem;
  }

  .sm\\:first\\:-ml-23:first-child{
    margin-left: -5.75rem;
  }

  .sm\\:first\\:-mt-24:first-child{
    margin-top: -6rem;
  }

  .sm\\:first\\:-mr-24:first-child{
    margin-right: -6rem;
  }

  .sm\\:first\\:-mb-24:first-child{
    margin-bottom: -6rem;
  }

  .sm\\:first\\:-ml-24:first-child{
    margin-left: -6rem;
  }

  .sm\\:first\\:-mt-25:first-child{
    margin-top: -6.25rem;
  }

  .sm\\:first\\:-mr-25:first-child{
    margin-right: -6.25rem;
  }

  .sm\\:first\\:-mb-25:first-child{
    margin-bottom: -6.25rem;
  }

  .sm\\:first\\:-ml-25:first-child{
    margin-left: -6.25rem;
  }

  .sm\\:first\\:-mt-26:first-child{
    margin-top: -6.5rem;
  }

  .sm\\:first\\:-mr-26:first-child{
    margin-right: -6.5rem;
  }

  .sm\\:first\\:-mb-26:first-child{
    margin-bottom: -6.5rem;
  }

  .sm\\:first\\:-ml-26:first-child{
    margin-left: -6.5rem;
  }

  .sm\\:first\\:-mt-28:first-child{
    margin-top: -7rem;
  }

  .sm\\:first\\:-mr-28:first-child{
    margin-right: -7rem;
  }

  .sm\\:first\\:-mb-28:first-child{
    margin-bottom: -7rem;
  }

  .sm\\:first\\:-ml-28:first-child{
    margin-left: -7rem;
  }

  .sm\\:first\\:-mt-30:first-child{
    margin-top: -7.5rem;
  }

  .sm\\:first\\:-mr-30:first-child{
    margin-right: -7.5rem;
  }

  .sm\\:first\\:-mb-30:first-child{
    margin-bottom: -7.5rem;
  }

  .sm\\:first\\:-ml-30:first-child{
    margin-left: -7.5rem;
  }

  .sm\\:first\\:-mt-32:first-child{
    margin-top: -8rem;
  }

  .sm\\:first\\:-mr-32:first-child{
    margin-right: -8rem;
  }

  .sm\\:first\\:-mb-32:first-child{
    margin-bottom: -8rem;
  }

  .sm\\:first\\:-ml-32:first-child{
    margin-left: -8rem;
  }

  .sm\\:first\\:-mt-34:first-child{
    margin-top: -8.5rem;
  }

  .sm\\:first\\:-mr-34:first-child{
    margin-right: -8.5rem;
  }

  .sm\\:first\\:-mb-34:first-child{
    margin-bottom: -8.5rem;
  }

  .sm\\:first\\:-ml-34:first-child{
    margin-left: -8.5rem;
  }

  .sm\\:first\\:-mt-40:first-child{
    margin-top: -10rem;
  }

  .sm\\:first\\:-mr-40:first-child{
    margin-right: -10rem;
  }

  .sm\\:first\\:-mb-40:first-child{
    margin-bottom: -10rem;
  }

  .sm\\:first\\:-ml-40:first-child{
    margin-left: -10rem;
  }

  .sm\\:first\\:-mt-42:first-child{
    margin-top: -10.5rem;
  }

  .sm\\:first\\:-mr-42:first-child{
    margin-right: -10.5rem;
  }

  .sm\\:first\\:-mb-42:first-child{
    margin-bottom: -10.5rem;
  }

  .sm\\:first\\:-ml-42:first-child{
    margin-left: -10.5rem;
  }

  .sm\\:first\\:-mt-44:first-child{
    margin-top: -11rem;
  }

  .sm\\:first\\:-mr-44:first-child{
    margin-right: -11rem;
  }

  .sm\\:first\\:-mb-44:first-child{
    margin-bottom: -11rem;
  }

  .sm\\:first\\:-ml-44:first-child{
    margin-left: -11rem;
  }

  .sm\\:first\\:-mt-48:first-child{
    margin-top: -12rem;
  }

  .sm\\:first\\:-mr-48:first-child{
    margin-right: -12rem;
  }

  .sm\\:first\\:-mb-48:first-child{
    margin-bottom: -12rem;
  }

  .sm\\:first\\:-ml-48:first-child{
    margin-left: -12rem;
  }

  .sm\\:first\\:-mt-52:first-child{
    margin-top: -13rem;
  }

  .sm\\:first\\:-mr-52:first-child{
    margin-right: -13rem;
  }

  .sm\\:first\\:-mb-52:first-child{
    margin-bottom: -13rem;
  }

  .sm\\:first\\:-ml-52:first-child{
    margin-left: -13rem;
  }

  .sm\\:first\\:-mt-54:first-child{
    margin-top: -13.5rem;
  }

  .sm\\:first\\:-mr-54:first-child{
    margin-right: -13.5rem;
  }

  .sm\\:first\\:-mb-54:first-child{
    margin-bottom: -13.5rem;
  }

  .sm\\:first\\:-ml-54:first-child{
    margin-left: -13.5rem;
  }

  .sm\\:first\\:-mt-56:first-child{
    margin-top: -14rem;
  }

  .sm\\:first\\:-mr-56:first-child{
    margin-right: -14rem;
  }

  .sm\\:first\\:-mb-56:first-child{
    margin-bottom: -14rem;
  }

  .sm\\:first\\:-ml-56:first-child{
    margin-left: -14rem;
  }

  .sm\\:first\\:-mt-60:first-child{
    margin-top: -15rem;
  }

  .sm\\:first\\:-mr-60:first-child{
    margin-right: -15rem;
  }

  .sm\\:first\\:-mb-60:first-child{
    margin-bottom: -15rem;
  }

  .sm\\:first\\:-ml-60:first-child{
    margin-left: -15rem;
  }

  .sm\\:first\\:-mt-64:first-child{
    margin-top: -16rem;
  }

  .sm\\:first\\:-mr-64:first-child{
    margin-right: -16rem;
  }

  .sm\\:first\\:-mb-64:first-child{
    margin-bottom: -16rem;
  }

  .sm\\:first\\:-ml-64:first-child{
    margin-left: -16rem;
  }

  .sm\\:first\\:-mt-68:first-child{
    margin-top: -17rem;
  }

  .sm\\:first\\:-mr-68:first-child{
    margin-right: -17rem;
  }

  .sm\\:first\\:-mb-68:first-child{
    margin-bottom: -17rem;
  }

  .sm\\:first\\:-ml-68:first-child{
    margin-left: -17rem;
  }

  .sm\\:first\\:-mt-72:first-child{
    margin-top: -18rem;
  }

  .sm\\:first\\:-mr-72:first-child{
    margin-right: -18rem;
  }

  .sm\\:first\\:-mb-72:first-child{
    margin-bottom: -18rem;
  }

  .sm\\:first\\:-ml-72:first-child{
    margin-left: -18rem;
  }

  .sm\\:first\\:-mt-74:first-child{
    margin-top: -18.5rem;
  }

  .sm\\:first\\:-mr-74:first-child{
    margin-right: -18.5rem;
  }

  .sm\\:first\\:-mb-74:first-child{
    margin-bottom: -18.5rem;
  }

  .sm\\:first\\:-ml-74:first-child{
    margin-left: -18.5rem;
  }

  .sm\\:first\\:-mt-76:first-child{
    margin-top: -19rem;
  }

  .sm\\:first\\:-mr-76:first-child{
    margin-right: -19rem;
  }

  .sm\\:first\\:-mb-76:first-child{
    margin-bottom: -19rem;
  }

  .sm\\:first\\:-ml-76:first-child{
    margin-left: -19rem;
  }

  .sm\\:first\\:-mt-78:first-child{
    margin-top: -19.5rem;
  }

  .sm\\:first\\:-mr-78:first-child{
    margin-right: -19.5rem;
  }

  .sm\\:first\\:-mb-78:first-child{
    margin-bottom: -19.5rem;
  }

  .sm\\:first\\:-ml-78:first-child{
    margin-left: -19.5rem;
  }

  .sm\\:first\\:-mt-80:first-child{
    margin-top: -20rem;
  }

  .sm\\:first\\:-mr-80:first-child{
    margin-right: -20rem;
  }

  .sm\\:first\\:-mb-80:first-child{
    margin-bottom: -20rem;
  }

  .sm\\:first\\:-ml-80:first-child{
    margin-left: -20rem;
  }

  .sm\\:first\\:-mt-82:first-child{
    margin-top: -20.5rem;
  }

  .sm\\:first\\:-mr-82:first-child{
    margin-right: -20.5rem;
  }

  .sm\\:first\\:-mb-82:first-child{
    margin-bottom: -20.5rem;
  }

  .sm\\:first\\:-ml-82:first-child{
    margin-left: -20.5rem;
  }

  .sm\\:first\\:-mt-84:first-child{
    margin-top: -21rem;
  }

  .sm\\:first\\:-mr-84:first-child{
    margin-right: -21rem;
  }

  .sm\\:first\\:-mb-84:first-child{
    margin-bottom: -21rem;
  }

  .sm\\:first\\:-ml-84:first-child{
    margin-left: -21rem;
  }

  .sm\\:first\\:-mt-88:first-child{
    margin-top: -22rem;
  }

  .sm\\:first\\:-mr-88:first-child{
    margin-right: -22rem;
  }

  .sm\\:first\\:-mb-88:first-child{
    margin-bottom: -22rem;
  }

  .sm\\:first\\:-ml-88:first-child{
    margin-left: -22rem;
  }

  .sm\\:first\\:-mt-92:first-child{
    margin-top: -23rem;
  }

  .sm\\:first\\:-mr-92:first-child{
    margin-right: -23rem;
  }

  .sm\\:first\\:-mb-92:first-child{
    margin-bottom: -23rem;
  }

  .sm\\:first\\:-ml-92:first-child{
    margin-left: -23rem;
  }

  .sm\\:first\\:-mt-96:first-child{
    margin-top: -24rem;
  }

  .sm\\:first\\:-mr-96:first-child{
    margin-right: -24rem;
  }

  .sm\\:first\\:-mb-96:first-child{
    margin-bottom: -24rem;
  }

  .sm\\:first\\:-ml-96:first-child{
    margin-left: -24rem;
  }

  .sm\\:first\\:-mt-98:first-child{
    margin-top: -24.5rem;
  }

  .sm\\:first\\:-mr-98:first-child{
    margin-right: -24.5rem;
  }

  .sm\\:first\\:-mb-98:first-child{
    margin-bottom: -24.5rem;
  }

  .sm\\:first\\:-ml-98:first-child{
    margin-left: -24.5rem;
  }

  .sm\\:first\\:-mt-100:first-child{
    margin-top: -25rem;
  }

  .sm\\:first\\:-mr-100:first-child{
    margin-right: -25rem;
  }

  .sm\\:first\\:-mb-100:first-child{
    margin-bottom: -25rem;
  }

  .sm\\:first\\:-ml-100:first-child{
    margin-left: -25rem;
  }

  .sm\\:first\\:-mt-104:first-child{
    margin-top: -26rem;
  }

  .sm\\:first\\:-mr-104:first-child{
    margin-right: -26rem;
  }

  .sm\\:first\\:-mb-104:first-child{
    margin-bottom: -26rem;
  }

  .sm\\:first\\:-ml-104:first-child{
    margin-left: -26rem;
  }

  .sm\\:first\\:-mt-112:first-child{
    margin-top: -28rem;
  }

  .sm\\:first\\:-mr-112:first-child{
    margin-right: -28rem;
  }

  .sm\\:first\\:-mb-112:first-child{
    margin-bottom: -28rem;
  }

  .sm\\:first\\:-ml-112:first-child{
    margin-left: -28rem;
  }

  .sm\\:first\\:-mt-124:first-child{
    margin-top: -31rem;
  }

  .sm\\:first\\:-mr-124:first-child{
    margin-right: -31rem;
  }

  .sm\\:first\\:-mb-124:first-child{
    margin-bottom: -31rem;
  }

  .sm\\:first\\:-ml-124:first-child{
    margin-left: -31rem;
  }

  .sm\\:first\\:-mt-128:first-child{
    margin-top: -32rem;
  }

  .sm\\:first\\:-mr-128:first-child{
    margin-right: -32rem;
  }

  .sm\\:first\\:-mb-128:first-child{
    margin-bottom: -32rem;
  }

  .sm\\:first\\:-ml-128:first-child{
    margin-left: -32rem;
  }

  .sm\\:first\\:-mt-140:first-child{
    margin-top: -35rem;
  }

  .sm\\:first\\:-mr-140:first-child{
    margin-right: -35rem;
  }

  .sm\\:first\\:-mb-140:first-child{
    margin-bottom: -35rem;
  }

  .sm\\:first\\:-ml-140:first-child{
    margin-left: -35rem;
  }

  .sm\\:first\\:-mt-152:first-child{
    margin-top: -38rem;
  }

  .sm\\:first\\:-mr-152:first-child{
    margin-right: -38rem;
  }

  .sm\\:first\\:-mb-152:first-child{
    margin-bottom: -38rem;
  }

  .sm\\:first\\:-ml-152:first-child{
    margin-left: -38rem;
  }

  .sm\\:first\\:-mt-160:first-child{
    margin-top: -40rem;
  }

  .sm\\:first\\:-mr-160:first-child{
    margin-right: -40rem;
  }

  .sm\\:first\\:-mb-160:first-child{
    margin-bottom: -40rem;
  }

  .sm\\:first\\:-ml-160:first-child{
    margin-left: -40rem;
  }

  .sm\\:first\\:-mt-162:first-child{
    margin-top: -41rem;
  }

  .sm\\:first\\:-mr-162:first-child{
    margin-right: -41rem;
  }

  .sm\\:first\\:-mb-162:first-child{
    margin-bottom: -41rem;
  }

  .sm\\:first\\:-ml-162:first-child{
    margin-left: -41rem;
  }

  .sm\\:first\\:-mt-192:first-child{
    margin-top: -48rem;
  }

  .sm\\:first\\:-mr-192:first-child{
    margin-right: -48rem;
  }

  .sm\\:first\\:-mb-192:first-child{
    margin-bottom: -48rem;
  }

  .sm\\:first\\:-ml-192:first-child{
    margin-left: -48rem;
  }

  .sm\\:first\\:-mt-208:first-child{
    margin-top: -52rem;
  }

  .sm\\:first\\:-mr-208:first-child{
    margin-right: -52rem;
  }

  .sm\\:first\\:-mb-208:first-child{
    margin-bottom: -52rem;
  }

  .sm\\:first\\:-ml-208:first-child{
    margin-left: -52rem;
  }

  .sm\\:first\\:-mt-224:first-child{
    margin-top: -56rem;
  }

  .sm\\:first\\:-mr-224:first-child{
    margin-right: -56rem;
  }

  .sm\\:first\\:-mb-224:first-child{
    margin-bottom: -56rem;
  }

  .sm\\:first\\:-ml-224:first-child{
    margin-left: -56rem;
  }

  .sm\\:first\\:-mt-256:first-child{
    margin-top: -64rem;
  }

  .sm\\:first\\:-mr-256:first-child{
    margin-right: -64rem;
  }

  .sm\\:first\\:-mb-256:first-child{
    margin-bottom: -64rem;
  }

  .sm\\:first\\:-ml-256:first-child{
    margin-left: -64rem;
  }

  .sm\\:first\\:-mt-px:first-child{
    margin-top: -1px;
  }

  .sm\\:first\\:-mr-px:first-child{
    margin-right: -1px;
  }

  .sm\\:first\\:-mb-px:first-child{
    margin-bottom: -1px;
  }

  .sm\\:first\\:-ml-px:first-child{
    margin-left: -1px;
  }

  .sm\\:max-h-0{
    max-height: 0;
  }

  .sm\\:max-h-1{
    max-height: 0.25rem;
  }

  .sm\\:max-h-2{
    max-height: 0.5rem;
  }

  .sm\\:max-h-3{
    max-height: 0.75rem;
  }

  .sm\\:max-h-4{
    max-height: 1rem;
  }

  .sm\\:max-h-5{
    max-height: 1.25rem;
  }

  .sm\\:max-h-6{
    max-height: 1.5rem;
  }

  .sm\\:max-h-7{
    max-height: 1.75rem;
  }

  .sm\\:max-h-8{
    max-height: 2rem;
  }

  .sm\\:max-h-9{
    max-height: 2.25rem;
  }

  .sm\\:max-h-10{
    max-height: 2.5rem;
  }

  .sm\\:max-h-11{
    max-height: 2.75rem;
  }

  .sm\\:max-h-12{
    max-height: 3rem;
  }

  .sm\\:max-h-14{
    max-height: 3.5rem;
  }

  .sm\\:max-h-15{
    max-height: 3.75rem;
  }

  .sm\\:max-h-16{
    max-height: 4rem;
  }

  .sm\\:max-h-18{
    max-height: 4.5rem;
  }

  .sm\\:max-h-20{
    max-height: 5rem;
  }

  .sm\\:max-h-22{
    max-height: 5.5rem;
  }

  .sm\\:max-h-23{
    max-height: 5.75rem;
  }

  .sm\\:max-h-24{
    max-height: 6rem;
  }

  .sm\\:max-h-25{
    max-height: 6.25rem;
  }

  .sm\\:max-h-26{
    max-height: 6.5rem;
  }

  .sm\\:max-h-28{
    max-height: 7rem;
  }

  .sm\\:max-h-30{
    max-height: 7.5rem;
  }

  .sm\\:max-h-32{
    max-height: 8rem;
  }

  .sm\\:max-h-34{
    max-height: 8.5rem;
  }

  .sm\\:max-h-40{
    max-height: 10rem;
  }

  .sm\\:max-h-42{
    max-height: 10.5rem;
  }

  .sm\\:max-h-44{
    max-height: 11rem;
  }

  .sm\\:max-h-48{
    max-height: 12rem;
  }

  .sm\\:max-h-52{
    max-height: 13rem;
  }

  .sm\\:max-h-54{
    max-height: 13.5rem;
  }

  .sm\\:max-h-56{
    max-height: 14rem;
  }

  .sm\\:max-h-60{
    max-height: 15rem;
  }

  .sm\\:max-h-64{
    max-height: 16rem;
  }

  .sm\\:max-h-68{
    max-height: 17rem;
  }

  .sm\\:max-h-72{
    max-height: 18rem;
  }

  .sm\\:max-h-74{
    max-height: 18.5rem;
  }

  .sm\\:max-h-76{
    max-height: 19rem;
  }

  .sm\\:max-h-78{
    max-height: 19.5rem;
  }

  .sm\\:max-h-80{
    max-height: 20rem;
  }

  .sm\\:max-h-82{
    max-height: 20.5rem;
  }

  .sm\\:max-h-84{
    max-height: 21rem;
  }

  .sm\\:max-h-88{
    max-height: 22rem;
  }

  .sm\\:max-h-92{
    max-height: 23rem;
  }

  .sm\\:max-h-96{
    max-height: 24rem;
  }

  .sm\\:max-h-98{
    max-height: 24.5rem;
  }

  .sm\\:max-h-100{
    max-height: 25rem;
  }

  .sm\\:max-h-104{
    max-height: 26rem;
  }

  .sm\\:max-h-112{
    max-height: 28rem;
  }

  .sm\\:max-h-124{
    max-height: 31rem;
  }

  .sm\\:max-h-128{
    max-height: 32rem;
  }

  .sm\\:max-h-140{
    max-height: 35rem;
  }

  .sm\\:max-h-152{
    max-height: 38rem;
  }

  .sm\\:max-h-160{
    max-height: 40rem;
  }

  .sm\\:max-h-162{
    max-height: 41rem;
  }

  .sm\\:max-h-192{
    max-height: 48rem;
  }

  .sm\\:max-h-208{
    max-height: 52rem;
  }

  .sm\\:max-h-224{
    max-height: 56rem;
  }

  .sm\\:max-h-256{
    max-height: 64rem;
  }

  .sm\\:max-h-px{
    max-height: 1px;
  }

  .sm\\:max-h-full{
    max-height: 100%;
  }

  .sm\\:max-h-screen{
    max-height: 100vh;
  }

  .sm\\:max-w-0{
    max-width: 0;
  }

  .sm\\:max-w-1{
    max-width: 0.25rem;
  }

  .sm\\:max-w-2{
    max-width: 0.5rem;
  }

  .sm\\:max-w-3{
    max-width: 0.75rem;
  }

  .sm\\:max-w-4{
    max-width: 1rem;
  }

  .sm\\:max-w-5{
    max-width: 1.25rem;
  }

  .sm\\:max-w-6{
    max-width: 1.5rem;
  }

  .sm\\:max-w-7{
    max-width: 1.75rem;
  }

  .sm\\:max-w-8{
    max-width: 2rem;
  }

  .sm\\:max-w-9{
    max-width: 2.25rem;
  }

  .sm\\:max-w-10{
    max-width: 2.5rem;
  }

  .sm\\:max-w-11{
    max-width: 2.75rem;
  }

  .sm\\:max-w-12{
    max-width: 3rem;
  }

  .sm\\:max-w-14{
    max-width: 3.5rem;
  }

  .sm\\:max-w-15{
    max-width: 3.75rem;
  }

  .sm\\:max-w-16{
    max-width: 4rem;
  }

  .sm\\:max-w-18{
    max-width: 4.5rem;
  }

  .sm\\:max-w-20{
    max-width: 5rem;
  }

  .sm\\:max-w-22{
    max-width: 5.5rem;
  }

  .sm\\:max-w-23{
    max-width: 5.75rem;
  }

  .sm\\:max-w-24{
    max-width: 6rem;
  }

  .sm\\:max-w-25{
    max-width: 6.25rem;
  }

  .sm\\:max-w-26{
    max-width: 6.5rem;
  }

  .sm\\:max-w-28{
    max-width: 7rem;
  }

  .sm\\:max-w-30{
    max-width: 7.5rem;
  }

  .sm\\:max-w-32{
    max-width: 8rem;
  }

  .sm\\:max-w-34{
    max-width: 8.5rem;
  }

  .sm\\:max-w-40{
    max-width: 10rem;
  }

  .sm\\:max-w-42{
    max-width: 10.5rem;
  }

  .sm\\:max-w-44{
    max-width: 11rem;
  }

  .sm\\:max-w-48{
    max-width: 12rem;
  }

  .sm\\:max-w-52{
    max-width: 13rem;
  }

  .sm\\:max-w-54{
    max-width: 13.5rem;
  }

  .sm\\:max-w-56{
    max-width: 14rem;
  }

  .sm\\:max-w-60{
    max-width: 15rem;
  }

  .sm\\:max-w-64{
    max-width: 16rem;
  }

  .sm\\:max-w-68{
    max-width: 17rem;
  }

  .sm\\:max-w-72{
    max-width: 18rem;
  }

  .sm\\:max-w-74{
    max-width: 18.5rem;
  }

  .sm\\:max-w-76{
    max-width: 19rem;
  }

  .sm\\:max-w-78{
    max-width: 19.5rem;
  }

  .sm\\:max-w-80{
    max-width: 20rem;
  }

  .sm\\:max-w-82{
    max-width: 20.5rem;
  }

  .sm\\:max-w-84{
    max-width: 21rem;
  }

  .sm\\:max-w-88{
    max-width: 22rem;
  }

  .sm\\:max-w-92{
    max-width: 23rem;
  }

  .sm\\:max-w-96{
    max-width: 24rem;
  }

  .sm\\:max-w-98{
    max-width: 24.5rem;
  }

  .sm\\:max-w-100{
    max-width: 25rem;
  }

  .sm\\:max-w-104{
    max-width: 26rem;
  }

  .sm\\:max-w-112{
    max-width: 28rem;
  }

  .sm\\:max-w-124{
    max-width: 31rem;
  }

  .sm\\:max-w-128{
    max-width: 32rem;
  }

  .sm\\:max-w-140{
    max-width: 35rem;
  }

  .sm\\:max-w-152{
    max-width: 38rem;
  }

  .sm\\:max-w-160{
    max-width: 40rem;
  }

  .sm\\:max-w-162{
    max-width: 41rem;
  }

  .sm\\:max-w-192{
    max-width: 48rem;
  }

  .sm\\:max-w-208{
    max-width: 52rem;
  }

  .sm\\:max-w-224{
    max-width: 56rem;
  }

  .sm\\:max-w-256{
    max-width: 64rem;
  }

  .sm\\:max-w-none{
    max-width: none;
  }

  .sm\\:max-w-xs{
    max-width: 20rem;
  }

  .sm\\:max-w-sm{
    max-width: 24rem;
  }

  .sm\\:max-w-md{
    max-width: 28rem;
  }

  .sm\\:max-w-lg{
    max-width: 32rem;
  }

  .sm\\:max-w-xl{
    max-width: 36rem;
  }

  .sm\\:max-w-2xl{
    max-width: 42rem;
  }

  .sm\\:max-w-3xl{
    max-width: 48rem;
  }

  .sm\\:max-w-4xl{
    max-width: 56rem;
  }

  .sm\\:max-w-5xl{
    max-width: 64rem;
  }

  .sm\\:max-w-6xl{
    max-width: 76rem;
  }

  .sm\\:max-w-7xl{
    max-width: 92rem;
  }

  .sm\\:max-w-8xl{
    max-width: 112rem;
  }

  .sm\\:max-w-9xl{
    max-width: 130rem;
  }

  .sm\\:max-w-full{
    max-width: 100%;
  }

  .sm\\:max-w-px{
    max-width: 1px;
  }

  .sm\\:min-h-0{
    min-height: 0;
  }

  .sm\\:min-h-1{
    min-height: 0.25rem;
  }

  .sm\\:min-h-2{
    min-height: 0.5rem;
  }

  .sm\\:min-h-3{
    min-height: 0.75rem;
  }

  .sm\\:min-h-4{
    min-height: 1rem;
  }

  .sm\\:min-h-5{
    min-height: 1.25rem;
  }

  .sm\\:min-h-6{
    min-height: 1.5rem;
  }

  .sm\\:min-h-7{
    min-height: 1.75rem;
  }

  .sm\\:min-h-8{
    min-height: 2rem;
  }

  .sm\\:min-h-9{
    min-height: 2.25rem;
  }

  .sm\\:min-h-10{
    min-height: 2.5rem;
  }

  .sm\\:min-h-11{
    min-height: 2.75rem;
  }

  .sm\\:min-h-12{
    min-height: 3rem;
  }

  .sm\\:min-h-14{
    min-height: 3.5rem;
  }

  .sm\\:min-h-15{
    min-height: 3.75rem;
  }

  .sm\\:min-h-16{
    min-height: 4rem;
  }

  .sm\\:min-h-18{
    min-height: 4.5rem;
  }

  .sm\\:min-h-20{
    min-height: 5rem;
  }

  .sm\\:min-h-22{
    min-height: 5.5rem;
  }

  .sm\\:min-h-23{
    min-height: 5.75rem;
  }

  .sm\\:min-h-24{
    min-height: 6rem;
  }

  .sm\\:min-h-25{
    min-height: 6.25rem;
  }

  .sm\\:min-h-26{
    min-height: 6.5rem;
  }

  .sm\\:min-h-28{
    min-height: 7rem;
  }

  .sm\\:min-h-30{
    min-height: 7.5rem;
  }

  .sm\\:min-h-32{
    min-height: 8rem;
  }

  .sm\\:min-h-34{
    min-height: 8.5rem;
  }

  .sm\\:min-h-40{
    min-height: 10rem;
  }

  .sm\\:min-h-42{
    min-height: 10.5rem;
  }

  .sm\\:min-h-44{
    min-height: 11rem;
  }

  .sm\\:min-h-48{
    min-height: 12rem;
  }

  .sm\\:min-h-52{
    min-height: 13rem;
  }

  .sm\\:min-h-54{
    min-height: 13.5rem;
  }

  .sm\\:min-h-56{
    min-height: 14rem;
  }

  .sm\\:min-h-60{
    min-height: 15rem;
  }

  .sm\\:min-h-64{
    min-height: 16rem;
  }

  .sm\\:min-h-68{
    min-height: 17rem;
  }

  .sm\\:min-h-72{
    min-height: 18rem;
  }

  .sm\\:min-h-74{
    min-height: 18.5rem;
  }

  .sm\\:min-h-76{
    min-height: 19rem;
  }

  .sm\\:min-h-78{
    min-height: 19.5rem;
  }

  .sm\\:min-h-80{
    min-height: 20rem;
  }

  .sm\\:min-h-82{
    min-height: 20.5rem;
  }

  .sm\\:min-h-84{
    min-height: 21rem;
  }

  .sm\\:min-h-88{
    min-height: 22rem;
  }

  .sm\\:min-h-92{
    min-height: 23rem;
  }

  .sm\\:min-h-96{
    min-height: 24rem;
  }

  .sm\\:min-h-98{
    min-height: 24.5rem;
  }

  .sm\\:min-h-100{
    min-height: 25rem;
  }

  .sm\\:min-h-104{
    min-height: 26rem;
  }

  .sm\\:min-h-112{
    min-height: 28rem;
  }

  .sm\\:min-h-124{
    min-height: 31rem;
  }

  .sm\\:min-h-128{
    min-height: 32rem;
  }

  .sm\\:min-h-140{
    min-height: 35rem;
  }

  .sm\\:min-h-152{
    min-height: 38rem;
  }

  .sm\\:min-h-160{
    min-height: 40rem;
  }

  .sm\\:min-h-162{
    min-height: 41rem;
  }

  .sm\\:min-h-192{
    min-height: 48rem;
  }

  .sm\\:min-h-208{
    min-height: 52rem;
  }

  .sm\\:min-h-224{
    min-height: 56rem;
  }

  .sm\\:min-h-256{
    min-height: 64rem;
  }

  .sm\\:min-h-full{
    min-height: 100%;
  }

  .sm\\:min-h-px{
    min-height: 1px;
  }

  .sm\\:min-h-screen{
    min-height: 100vh;
  }

  .sm\\:min-w-0{
    min-width: 0;
  }

  .sm\\:min-w-1{
    min-width: 0.25rem;
  }

  .sm\\:min-w-2{
    min-width: 0.5rem;
  }

  .sm\\:min-w-3{
    min-width: 0.75rem;
  }

  .sm\\:min-w-4{
    min-width: 1rem;
  }

  .sm\\:min-w-5{
    min-width: 1.25rem;
  }

  .sm\\:min-w-6{
    min-width: 1.5rem;
  }

  .sm\\:min-w-7{
    min-width: 1.75rem;
  }

  .sm\\:min-w-8{
    min-width: 2rem;
  }

  .sm\\:min-w-9{
    min-width: 2.25rem;
  }

  .sm\\:min-w-10{
    min-width: 2.5rem;
  }

  .sm\\:min-w-11{
    min-width: 2.75rem;
  }

  .sm\\:min-w-12{
    min-width: 3rem;
  }

  .sm\\:min-w-14{
    min-width: 3.5rem;
  }

  .sm\\:min-w-15{
    min-width: 3.75rem;
  }

  .sm\\:min-w-16{
    min-width: 4rem;
  }

  .sm\\:min-w-18{
    min-width: 4.5rem;
  }

  .sm\\:min-w-20{
    min-width: 5rem;
  }

  .sm\\:min-w-22{
    min-width: 5.5rem;
  }

  .sm\\:min-w-23{
    min-width: 5.75rem;
  }

  .sm\\:min-w-24{
    min-width: 6rem;
  }

  .sm\\:min-w-25{
    min-width: 6.25rem;
  }

  .sm\\:min-w-26{
    min-width: 6.5rem;
  }

  .sm\\:min-w-28{
    min-width: 7rem;
  }

  .sm\\:min-w-30{
    min-width: 7.5rem;
  }

  .sm\\:min-w-32{
    min-width: 8rem;
  }

  .sm\\:min-w-34{
    min-width: 8.5rem;
  }

  .sm\\:min-w-40{
    min-width: 10rem;
  }

  .sm\\:min-w-42{
    min-width: 10.5rem;
  }

  .sm\\:min-w-44{
    min-width: 11rem;
  }

  .sm\\:min-w-48{
    min-width: 12rem;
  }

  .sm\\:min-w-52{
    min-width: 13rem;
  }

  .sm\\:min-w-54{
    min-width: 13.5rem;
  }

  .sm\\:min-w-56{
    min-width: 14rem;
  }

  .sm\\:min-w-60{
    min-width: 15rem;
  }

  .sm\\:min-w-64{
    min-width: 16rem;
  }

  .sm\\:min-w-68{
    min-width: 17rem;
  }

  .sm\\:min-w-72{
    min-width: 18rem;
  }

  .sm\\:min-w-74{
    min-width: 18.5rem;
  }

  .sm\\:min-w-76{
    min-width: 19rem;
  }

  .sm\\:min-w-78{
    min-width: 19.5rem;
  }

  .sm\\:min-w-80{
    min-width: 20rem;
  }

  .sm\\:min-w-82{
    min-width: 20.5rem;
  }

  .sm\\:min-w-84{
    min-width: 21rem;
  }

  .sm\\:min-w-88{
    min-width: 22rem;
  }

  .sm\\:min-w-92{
    min-width: 23rem;
  }

  .sm\\:min-w-96{
    min-width: 24rem;
  }

  .sm\\:min-w-98{
    min-width: 24.5rem;
  }

  .sm\\:min-w-100{
    min-width: 25rem;
  }

  .sm\\:min-w-104{
    min-width: 26rem;
  }

  .sm\\:min-w-112{
    min-width: 28rem;
  }

  .sm\\:min-w-124{
    min-width: 31rem;
  }

  .sm\\:min-w-128{
    min-width: 32rem;
  }

  .sm\\:min-w-140{
    min-width: 35rem;
  }

  .sm\\:min-w-152{
    min-width: 38rem;
  }

  .sm\\:min-w-160{
    min-width: 40rem;
  }

  .sm\\:min-w-162{
    min-width: 41rem;
  }

  .sm\\:min-w-192{
    min-width: 48rem;
  }

  .sm\\:min-w-208{
    min-width: 52rem;
  }

  .sm\\:min-w-224{
    min-width: 56rem;
  }

  .sm\\:min-w-256{
    min-width: 64rem;
  }

  .sm\\:min-w-px{
    min-width: 1px;
  }

  .sm\\:min-w-full{
    min-width: 100%;
  }

  .sm\\:object-contain{
    object-fit: contain;
  }

  .sm\\:object-cover{
    object-fit: cover;
  }

  .sm\\:object-fill{
    object-fit: fill;
  }

  .sm\\:object-none{
    object-fit: none;
  }

  .sm\\:object-scale-down{
    object-fit: scale-down;
  }

  .sm\\:object-bottom{
    object-position: bottom;
  }

  .sm\\:object-center{
    object-position: center;
  }

  .sm\\:object-left{
    object-position: left;
  }

  .sm\\:object-left-bottom{
    object-position: left bottom;
  }

  .sm\\:object-left-top{
    object-position: left top;
  }

  .sm\\:object-right{
    object-position: right;
  }

  .sm\\:object-right-bottom{
    object-position: right bottom;
  }

  .sm\\:object-right-top{
    object-position: right top;
  }

  .sm\\:object-top{
    object-position: top;
  }

  .sm\\:opacity-0{
    opacity: 0;
  }

  .sm\\:opacity-25{
    opacity: .25;
  }

  .sm\\:opacity-50{
    opacity: .5;
  }

  .sm\\:opacity-75{
    opacity: .75;
  }

  .sm\\:opacity-100{
    opacity: 1;
  }

  .sm\\:overflow-auto{
    overflow: auto;
  }

  .sm\\:overflow-hidden{
    overflow: hidden;
  }

  .sm\\:overflow-visible{
    overflow: visible;
  }

  .sm\\:overflow-scroll{
    overflow: scroll;
  }

  .sm\\:overflow-x-auto{
    overflow-x: auto;
  }

  .sm\\:overflow-y-auto{
    overflow-y: auto;
  }

  .sm\\:overflow-x-hidden{
    overflow-x: hidden;
  }

  .sm\\:overflow-y-hidden{
    overflow-y: hidden;
  }

  .sm\\:overflow-x-visible{
    overflow-x: visible;
  }

  .sm\\:overflow-y-visible{
    overflow-y: visible;
  }

  .sm\\:overflow-x-scroll{
    overflow-x: scroll;
  }

  .sm\\:overflow-y-scroll{
    overflow-y: scroll;
  }

  .sm\\:scrolling-touch{
    -webkit-overflow-scrolling: touch;
  }

  .sm\\:scrolling-auto{
    -webkit-overflow-scrolling: auto;
  }

  .sm\\:overscroll-auto{
    overscroll-behavior: auto;
  }

  .sm\\:overscroll-contain{
    overscroll-behavior: contain;
  }

  .sm\\:overscroll-none{
    overscroll-behavior: none;
  }

  .sm\\:overscroll-y-auto{
    overscroll-behavior-y: auto;
  }

  .sm\\:overscroll-y-contain{
    overscroll-behavior-y: contain;
  }

  .sm\\:overscroll-y-none{
    overscroll-behavior-y: none;
  }

  .sm\\:overscroll-x-auto{
    overscroll-behavior-x: auto;
  }

  .sm\\:overscroll-x-contain{
    overscroll-behavior-x: contain;
  }

  .sm\\:overscroll-x-none{
    overscroll-behavior-x: none;
  }

  .sm\\:p-0{
    padding: 0;
  }

  .sm\\:p-1{
    padding: 0.25rem;
  }

  .sm\\:p-2{
    padding: 0.5rem;
  }

  .sm\\:p-3{
    padding: 0.75rem;
  }

  .sm\\:p-4{
    padding: 1rem;
  }

  .sm\\:p-5{
    padding: 1.25rem;
  }

  .sm\\:p-6{
    padding: 1.5rem;
  }

  .sm\\:p-7{
    padding: 1.75rem;
  }

  .sm\\:p-8{
    padding: 2rem;
  }

  .sm\\:p-9{
    padding: 2.25rem;
  }

  .sm\\:p-10{
    padding: 2.5rem;
  }

  .sm\\:p-11{
    padding: 2.75rem;
  }

  .sm\\:p-12{
    padding: 3rem;
  }

  .sm\\:p-14{
    padding: 3.5rem;
  }

  .sm\\:p-15{
    padding: 3.75rem;
  }

  .sm\\:p-16{
    padding: 4rem;
  }

  .sm\\:p-18{
    padding: 4.5rem;
  }

  .sm\\:p-20{
    padding: 5rem;
  }

  .sm\\:p-22{
    padding: 5.5rem;
  }

  .sm\\:p-23{
    padding: 5.75rem;
  }

  .sm\\:p-24{
    padding: 6rem;
  }

  .sm\\:p-25{
    padding: 6.25rem;
  }

  .sm\\:p-26{
    padding: 6.5rem;
  }

  .sm\\:p-28{
    padding: 7rem;
  }

  .sm\\:p-30{
    padding: 7.5rem;
  }

  .sm\\:p-32{
    padding: 8rem;
  }

  .sm\\:p-34{
    padding: 8.5rem;
  }

  .sm\\:p-40{
    padding: 10rem;
  }

  .sm\\:p-42{
    padding: 10.5rem;
  }

  .sm\\:p-44{
    padding: 11rem;
  }

  .sm\\:p-48{
    padding: 12rem;
  }

  .sm\\:p-52{
    padding: 13rem;
  }

  .sm\\:p-54{
    padding: 13.5rem;
  }

  .sm\\:p-56{
    padding: 14rem;
  }

  .sm\\:p-60{
    padding: 15rem;
  }

  .sm\\:p-64{
    padding: 16rem;
  }

  .sm\\:p-68{
    padding: 17rem;
  }

  .sm\\:p-72{
    padding: 18rem;
  }

  .sm\\:p-74{
    padding: 18.5rem;
  }

  .sm\\:p-76{
    padding: 19rem;
  }

  .sm\\:p-78{
    padding: 19.5rem;
  }

  .sm\\:p-80{
    padding: 20rem;
  }

  .sm\\:p-82{
    padding: 20.5rem;
  }

  .sm\\:p-84{
    padding: 21rem;
  }

  .sm\\:p-88{
    padding: 22rem;
  }

  .sm\\:p-92{
    padding: 23rem;
  }

  .sm\\:p-96{
    padding: 24rem;
  }

  .sm\\:p-98{
    padding: 24.5rem;
  }

  .sm\\:p-100{
    padding: 25rem;
  }

  .sm\\:p-104{
    padding: 26rem;
  }

  .sm\\:p-112{
    padding: 28rem;
  }

  .sm\\:p-124{
    padding: 31rem;
  }

  .sm\\:p-128{
    padding: 32rem;
  }

  .sm\\:p-140{
    padding: 35rem;
  }

  .sm\\:p-152{
    padding: 38rem;
  }

  .sm\\:p-160{
    padding: 40rem;
  }

  .sm\\:p-162{
    padding: 41rem;
  }

  .sm\\:p-192{
    padding: 48rem;
  }

  .sm\\:p-208{
    padding: 52rem;
  }

  .sm\\:p-224{
    padding: 56rem;
  }

  .sm\\:p-256{
    padding: 64rem;
  }

  .sm\\:p-px{
    padding: 1px;
  }

  .sm\\:py-0{
    padding-top: 0;
    padding-bottom: 0;
  }

  .sm\\:px-0{
    padding-left: 0;
    padding-right: 0;
  }

  .sm\\:py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .sm\\:px-1{
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .sm\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:py-7{
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .sm\\:px-7{
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .sm\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:py-9{
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .sm\\:px-9{
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .sm\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .sm\\:py-11{
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .sm\\:px-11{
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .sm\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .sm\\:py-14{
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .sm\\:px-14{
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .sm\\:py-15{
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .sm\\:px-15{
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .sm\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .sm\\:px-16{
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .sm\\:py-18{
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .sm\\:px-18{
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .sm\\:py-20{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .sm\\:px-20{
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .sm\\:py-22{
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .sm\\:px-22{
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .sm\\:py-23{
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .sm\\:px-23{
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .sm\\:py-24{
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .sm\\:px-24{
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .sm\\:py-25{
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .sm\\:px-25{
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .sm\\:py-26{
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .sm\\:px-26{
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .sm\\:py-28{
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .sm\\:px-28{
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .sm\\:py-30{
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .sm\\:px-30{
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .sm\\:py-32{
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .sm\\:px-32{
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .sm\\:py-34{
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .sm\\:px-34{
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .sm\\:py-40{
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .sm\\:px-40{
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .sm\\:py-42{
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .sm\\:px-42{
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .sm\\:py-44{
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .sm\\:px-44{
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .sm\\:py-48{
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .sm\\:px-48{
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .sm\\:py-52{
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .sm\\:px-52{
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .sm\\:py-54{
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .sm\\:px-54{
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .sm\\:py-56{
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .sm\\:px-56{
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .sm\\:py-60{
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .sm\\:px-60{
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .sm\\:py-64{
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .sm\\:px-64{
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .sm\\:py-68{
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .sm\\:px-68{
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .sm\\:py-72{
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .sm\\:px-72{
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .sm\\:py-74{
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .sm\\:px-74{
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .sm\\:py-76{
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .sm\\:px-76{
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .sm\\:py-78{
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .sm\\:px-78{
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .sm\\:py-80{
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .sm\\:px-80{
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .sm\\:py-82{
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .sm\\:px-82{
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .sm\\:py-84{
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .sm\\:px-84{
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .sm\\:py-88{
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .sm\\:px-88{
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .sm\\:py-92{
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .sm\\:px-92{
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .sm\\:py-96{
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .sm\\:px-96{
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .sm\\:py-98{
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .sm\\:px-98{
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .sm\\:py-100{
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .sm\\:px-100{
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .sm\\:py-104{
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .sm\\:px-104{
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .sm\\:py-112{
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .sm\\:px-112{
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .sm\\:py-124{
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .sm\\:px-124{
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .sm\\:py-128{
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .sm\\:px-128{
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .sm\\:py-140{
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .sm\\:px-140{
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .sm\\:py-152{
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .sm\\:px-152{
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .sm\\:py-160{
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .sm\\:px-160{
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .sm\\:py-162{
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .sm\\:px-162{
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .sm\\:py-192{
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .sm\\:px-192{
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .sm\\:py-208{
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .sm\\:px-208{
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .sm\\:py-224{
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .sm\\:px-224{
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .sm\\:py-256{
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .sm\\:px-256{
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .sm\\:py-px{
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .sm\\:px-px{
    padding-left: 1px;
    padding-right: 1px;
  }

  .sm\\:pt-0{
    padding-top: 0;
  }

  .sm\\:pr-0{
    padding-right: 0;
  }

  .sm\\:pb-0{
    padding-bottom: 0;
  }

  .sm\\:pl-0{
    padding-left: 0;
  }

  .sm\\:pt-1{
    padding-top: 0.25rem;
  }

  .sm\\:pr-1{
    padding-right: 0.25rem;
  }

  .sm\\:pb-1{
    padding-bottom: 0.25rem;
  }

  .sm\\:pl-1{
    padding-left: 0.25rem;
  }

  .sm\\:pt-2{
    padding-top: 0.5rem;
  }

  .sm\\:pr-2{
    padding-right: 0.5rem;
  }

  .sm\\:pb-2{
    padding-bottom: 0.5rem;
  }

  .sm\\:pl-2{
    padding-left: 0.5rem;
  }

  .sm\\:pt-3{
    padding-top: 0.75rem;
  }

  .sm\\:pr-3{
    padding-right: 0.75rem;
  }

  .sm\\:pb-3{
    padding-bottom: 0.75rem;
  }

  .sm\\:pl-3{
    padding-left: 0.75rem;
  }

  .sm\\:pt-4{
    padding-top: 1rem;
  }

  .sm\\:pr-4{
    padding-right: 1rem;
  }

  .sm\\:pb-4{
    padding-bottom: 1rem;
  }

  .sm\\:pl-4{
    padding-left: 1rem;
  }

  .sm\\:pt-5{
    padding-top: 1.25rem;
  }

  .sm\\:pr-5{
    padding-right: 1.25rem;
  }

  .sm\\:pb-5{
    padding-bottom: 1.25rem;
  }

  .sm\\:pl-5{
    padding-left: 1.25rem;
  }

  .sm\\:pt-6{
    padding-top: 1.5rem;
  }

  .sm\\:pr-6{
    padding-right: 1.5rem;
  }

  .sm\\:pb-6{
    padding-bottom: 1.5rem;
  }

  .sm\\:pl-6{
    padding-left: 1.5rem;
  }

  .sm\\:pt-7{
    padding-top: 1.75rem;
  }

  .sm\\:pr-7{
    padding-right: 1.75rem;
  }

  .sm\\:pb-7{
    padding-bottom: 1.75rem;
  }

  .sm\\:pl-7{
    padding-left: 1.75rem;
  }

  .sm\\:pt-8{
    padding-top: 2rem;
  }

  .sm\\:pr-8{
    padding-right: 2rem;
  }

  .sm\\:pb-8{
    padding-bottom: 2rem;
  }

  .sm\\:pl-8{
    padding-left: 2rem;
  }

  .sm\\:pt-9{
    padding-top: 2.25rem;
  }

  .sm\\:pr-9{
    padding-right: 2.25rem;
  }

  .sm\\:pb-9{
    padding-bottom: 2.25rem;
  }

  .sm\\:pl-9{
    padding-left: 2.25rem;
  }

  .sm\\:pt-10{
    padding-top: 2.5rem;
  }

  .sm\\:pr-10{
    padding-right: 2.5rem;
  }

  .sm\\:pb-10{
    padding-bottom: 2.5rem;
  }

  .sm\\:pl-10{
    padding-left: 2.5rem;
  }

  .sm\\:pt-11{
    padding-top: 2.75rem;
  }

  .sm\\:pr-11{
    padding-right: 2.75rem;
  }

  .sm\\:pb-11{
    padding-bottom: 2.75rem;
  }

  .sm\\:pl-11{
    padding-left: 2.75rem;
  }

  .sm\\:pt-12{
    padding-top: 3rem;
  }

  .sm\\:pr-12{
    padding-right: 3rem;
  }

  .sm\\:pb-12{
    padding-bottom: 3rem;
  }

  .sm\\:pl-12{
    padding-left: 3rem;
  }

  .sm\\:pt-14{
    padding-top: 3.5rem;
  }

  .sm\\:pr-14{
    padding-right: 3.5rem;
  }

  .sm\\:pb-14{
    padding-bottom: 3.5rem;
  }

  .sm\\:pl-14{
    padding-left: 3.5rem;
  }

  .sm\\:pt-15{
    padding-top: 3.75rem;
  }

  .sm\\:pr-15{
    padding-right: 3.75rem;
  }

  .sm\\:pb-15{
    padding-bottom: 3.75rem;
  }

  .sm\\:pl-15{
    padding-left: 3.75rem;
  }

  .sm\\:pt-16{
    padding-top: 4rem;
  }

  .sm\\:pr-16{
    padding-right: 4rem;
  }

  .sm\\:pb-16{
    padding-bottom: 4rem;
  }

  .sm\\:pl-16{
    padding-left: 4rem;
  }

  .sm\\:pt-18{
    padding-top: 4.5rem;
  }

  .sm\\:pr-18{
    padding-right: 4.5rem;
  }

  .sm\\:pb-18{
    padding-bottom: 4.5rem;
  }

  .sm\\:pl-18{
    padding-left: 4.5rem;
  }

  .sm\\:pt-20{
    padding-top: 5rem;
  }

  .sm\\:pr-20{
    padding-right: 5rem;
  }

  .sm\\:pb-20{
    padding-bottom: 5rem;
  }

  .sm\\:pl-20{
    padding-left: 5rem;
  }

  .sm\\:pt-22{
    padding-top: 5.5rem;
  }

  .sm\\:pr-22{
    padding-right: 5.5rem;
  }

  .sm\\:pb-22{
    padding-bottom: 5.5rem;
  }

  .sm\\:pl-22{
    padding-left: 5.5rem;
  }

  .sm\\:pt-23{
    padding-top: 5.75rem;
  }

  .sm\\:pr-23{
    padding-right: 5.75rem;
  }

  .sm\\:pb-23{
    padding-bottom: 5.75rem;
  }

  .sm\\:pl-23{
    padding-left: 5.75rem;
  }

  .sm\\:pt-24{
    padding-top: 6rem;
  }

  .sm\\:pr-24{
    padding-right: 6rem;
  }

  .sm\\:pb-24{
    padding-bottom: 6rem;
  }

  .sm\\:pl-24{
    padding-left: 6rem;
  }

  .sm\\:pt-25{
    padding-top: 6.25rem;
  }

  .sm\\:pr-25{
    padding-right: 6.25rem;
  }

  .sm\\:pb-25{
    padding-bottom: 6.25rem;
  }

  .sm\\:pl-25{
    padding-left: 6.25rem;
  }

  .sm\\:pt-26{
    padding-top: 6.5rem;
  }

  .sm\\:pr-26{
    padding-right: 6.5rem;
  }

  .sm\\:pb-26{
    padding-bottom: 6.5rem;
  }

  .sm\\:pl-26{
    padding-left: 6.5rem;
  }

  .sm\\:pt-28{
    padding-top: 7rem;
  }

  .sm\\:pr-28{
    padding-right: 7rem;
  }

  .sm\\:pb-28{
    padding-bottom: 7rem;
  }

  .sm\\:pl-28{
    padding-left: 7rem;
  }

  .sm\\:pt-30{
    padding-top: 7.5rem;
  }

  .sm\\:pr-30{
    padding-right: 7.5rem;
  }

  .sm\\:pb-30{
    padding-bottom: 7.5rem;
  }

  .sm\\:pl-30{
    padding-left: 7.5rem;
  }

  .sm\\:pt-32{
    padding-top: 8rem;
  }

  .sm\\:pr-32{
    padding-right: 8rem;
  }

  .sm\\:pb-32{
    padding-bottom: 8rem;
  }

  .sm\\:pl-32{
    padding-left: 8rem;
  }

  .sm\\:pt-34{
    padding-top: 8.5rem;
  }

  .sm\\:pr-34{
    padding-right: 8.5rem;
  }

  .sm\\:pb-34{
    padding-bottom: 8.5rem;
  }

  .sm\\:pl-34{
    padding-left: 8.5rem;
  }

  .sm\\:pt-40{
    padding-top: 10rem;
  }

  .sm\\:pr-40{
    padding-right: 10rem;
  }

  .sm\\:pb-40{
    padding-bottom: 10rem;
  }

  .sm\\:pl-40{
    padding-left: 10rem;
  }

  .sm\\:pt-42{
    padding-top: 10.5rem;
  }

  .sm\\:pr-42{
    padding-right: 10.5rem;
  }

  .sm\\:pb-42{
    padding-bottom: 10.5rem;
  }

  .sm\\:pl-42{
    padding-left: 10.5rem;
  }

  .sm\\:pt-44{
    padding-top: 11rem;
  }

  .sm\\:pr-44{
    padding-right: 11rem;
  }

  .sm\\:pb-44{
    padding-bottom: 11rem;
  }

  .sm\\:pl-44{
    padding-left: 11rem;
  }

  .sm\\:pt-48{
    padding-top: 12rem;
  }

  .sm\\:pr-48{
    padding-right: 12rem;
  }

  .sm\\:pb-48{
    padding-bottom: 12rem;
  }

  .sm\\:pl-48{
    padding-left: 12rem;
  }

  .sm\\:pt-52{
    padding-top: 13rem;
  }

  .sm\\:pr-52{
    padding-right: 13rem;
  }

  .sm\\:pb-52{
    padding-bottom: 13rem;
  }

  .sm\\:pl-52{
    padding-left: 13rem;
  }

  .sm\\:pt-54{
    padding-top: 13.5rem;
  }

  .sm\\:pr-54{
    padding-right: 13.5rem;
  }

  .sm\\:pb-54{
    padding-bottom: 13.5rem;
  }

  .sm\\:pl-54{
    padding-left: 13.5rem;
  }

  .sm\\:pt-56{
    padding-top: 14rem;
  }

  .sm\\:pr-56{
    padding-right: 14rem;
  }

  .sm\\:pb-56{
    padding-bottom: 14rem;
  }

  .sm\\:pl-56{
    padding-left: 14rem;
  }

  .sm\\:pt-60{
    padding-top: 15rem;
  }

  .sm\\:pr-60{
    padding-right: 15rem;
  }

  .sm\\:pb-60{
    padding-bottom: 15rem;
  }

  .sm\\:pl-60{
    padding-left: 15rem;
  }

  .sm\\:pt-64{
    padding-top: 16rem;
  }

  .sm\\:pr-64{
    padding-right: 16rem;
  }

  .sm\\:pb-64{
    padding-bottom: 16rem;
  }

  .sm\\:pl-64{
    padding-left: 16rem;
  }

  .sm\\:pt-68{
    padding-top: 17rem;
  }

  .sm\\:pr-68{
    padding-right: 17rem;
  }

  .sm\\:pb-68{
    padding-bottom: 17rem;
  }

  .sm\\:pl-68{
    padding-left: 17rem;
  }

  .sm\\:pt-72{
    padding-top: 18rem;
  }

  .sm\\:pr-72{
    padding-right: 18rem;
  }

  .sm\\:pb-72{
    padding-bottom: 18rem;
  }

  .sm\\:pl-72{
    padding-left: 18rem;
  }

  .sm\\:pt-74{
    padding-top: 18.5rem;
  }

  .sm\\:pr-74{
    padding-right: 18.5rem;
  }

  .sm\\:pb-74{
    padding-bottom: 18.5rem;
  }

  .sm\\:pl-74{
    padding-left: 18.5rem;
  }

  .sm\\:pt-76{
    padding-top: 19rem;
  }

  .sm\\:pr-76{
    padding-right: 19rem;
  }

  .sm\\:pb-76{
    padding-bottom: 19rem;
  }

  .sm\\:pl-76{
    padding-left: 19rem;
  }

  .sm\\:pt-78{
    padding-top: 19.5rem;
  }

  .sm\\:pr-78{
    padding-right: 19.5rem;
  }

  .sm\\:pb-78{
    padding-bottom: 19.5rem;
  }

  .sm\\:pl-78{
    padding-left: 19.5rem;
  }

  .sm\\:pt-80{
    padding-top: 20rem;
  }

  .sm\\:pr-80{
    padding-right: 20rem;
  }

  .sm\\:pb-80{
    padding-bottom: 20rem;
  }

  .sm\\:pl-80{
    padding-left: 20rem;
  }

  .sm\\:pt-82{
    padding-top: 20.5rem;
  }

  .sm\\:pr-82{
    padding-right: 20.5rem;
  }

  .sm\\:pb-82{
    padding-bottom: 20.5rem;
  }

  .sm\\:pl-82{
    padding-left: 20.5rem;
  }

  .sm\\:pt-84{
    padding-top: 21rem;
  }

  .sm\\:pr-84{
    padding-right: 21rem;
  }

  .sm\\:pb-84{
    padding-bottom: 21rem;
  }

  .sm\\:pl-84{
    padding-left: 21rem;
  }

  .sm\\:pt-88{
    padding-top: 22rem;
  }

  .sm\\:pr-88{
    padding-right: 22rem;
  }

  .sm\\:pb-88{
    padding-bottom: 22rem;
  }

  .sm\\:pl-88{
    padding-left: 22rem;
  }

  .sm\\:pt-92{
    padding-top: 23rem;
  }

  .sm\\:pr-92{
    padding-right: 23rem;
  }

  .sm\\:pb-92{
    padding-bottom: 23rem;
  }

  .sm\\:pl-92{
    padding-left: 23rem;
  }

  .sm\\:pt-96{
    padding-top: 24rem;
  }

  .sm\\:pr-96{
    padding-right: 24rem;
  }

  .sm\\:pb-96{
    padding-bottom: 24rem;
  }

  .sm\\:pl-96{
    padding-left: 24rem;
  }

  .sm\\:pt-98{
    padding-top: 24.5rem;
  }

  .sm\\:pr-98{
    padding-right: 24.5rem;
  }

  .sm\\:pb-98{
    padding-bottom: 24.5rem;
  }

  .sm\\:pl-98{
    padding-left: 24.5rem;
  }

  .sm\\:pt-100{
    padding-top: 25rem;
  }

  .sm\\:pr-100{
    padding-right: 25rem;
  }

  .sm\\:pb-100{
    padding-bottom: 25rem;
  }

  .sm\\:pl-100{
    padding-left: 25rem;
  }

  .sm\\:pt-104{
    padding-top: 26rem;
  }

  .sm\\:pr-104{
    padding-right: 26rem;
  }

  .sm\\:pb-104{
    padding-bottom: 26rem;
  }

  .sm\\:pl-104{
    padding-left: 26rem;
  }

  .sm\\:pt-112{
    padding-top: 28rem;
  }

  .sm\\:pr-112{
    padding-right: 28rem;
  }

  .sm\\:pb-112{
    padding-bottom: 28rem;
  }

  .sm\\:pl-112{
    padding-left: 28rem;
  }

  .sm\\:pt-124{
    padding-top: 31rem;
  }

  .sm\\:pr-124{
    padding-right: 31rem;
  }

  .sm\\:pb-124{
    padding-bottom: 31rem;
  }

  .sm\\:pl-124{
    padding-left: 31rem;
  }

  .sm\\:pt-128{
    padding-top: 32rem;
  }

  .sm\\:pr-128{
    padding-right: 32rem;
  }

  .sm\\:pb-128{
    padding-bottom: 32rem;
  }

  .sm\\:pl-128{
    padding-left: 32rem;
  }

  .sm\\:pt-140{
    padding-top: 35rem;
  }

  .sm\\:pr-140{
    padding-right: 35rem;
  }

  .sm\\:pb-140{
    padding-bottom: 35rem;
  }

  .sm\\:pl-140{
    padding-left: 35rem;
  }

  .sm\\:pt-152{
    padding-top: 38rem;
  }

  .sm\\:pr-152{
    padding-right: 38rem;
  }

  .sm\\:pb-152{
    padding-bottom: 38rem;
  }

  .sm\\:pl-152{
    padding-left: 38rem;
  }

  .sm\\:pt-160{
    padding-top: 40rem;
  }

  .sm\\:pr-160{
    padding-right: 40rem;
  }

  .sm\\:pb-160{
    padding-bottom: 40rem;
  }

  .sm\\:pl-160{
    padding-left: 40rem;
  }

  .sm\\:pt-162{
    padding-top: 41rem;
  }

  .sm\\:pr-162{
    padding-right: 41rem;
  }

  .sm\\:pb-162{
    padding-bottom: 41rem;
  }

  .sm\\:pl-162{
    padding-left: 41rem;
  }

  .sm\\:pt-192{
    padding-top: 48rem;
  }

  .sm\\:pr-192{
    padding-right: 48rem;
  }

  .sm\\:pb-192{
    padding-bottom: 48rem;
  }

  .sm\\:pl-192{
    padding-left: 48rem;
  }

  .sm\\:pt-208{
    padding-top: 52rem;
  }

  .sm\\:pr-208{
    padding-right: 52rem;
  }

  .sm\\:pb-208{
    padding-bottom: 52rem;
  }

  .sm\\:pl-208{
    padding-left: 52rem;
  }

  .sm\\:pt-224{
    padding-top: 56rem;
  }

  .sm\\:pr-224{
    padding-right: 56rem;
  }

  .sm\\:pb-224{
    padding-bottom: 56rem;
  }

  .sm\\:pl-224{
    padding-left: 56rem;
  }

  .sm\\:pt-256{
    padding-top: 64rem;
  }

  .sm\\:pr-256{
    padding-right: 64rem;
  }

  .sm\\:pb-256{
    padding-bottom: 64rem;
  }

  .sm\\:pl-256{
    padding-left: 64rem;
  }

  .sm\\:pt-px{
    padding-top: 1px;
  }

  .sm\\:pr-px{
    padding-right: 1px;
  }

  .sm\\:pb-px{
    padding-bottom: 1px;
  }

  .sm\\:pl-px{
    padding-left: 1px;
  }

  .sm\\:odd\\:p-0:nth-child(odd){
    padding: 0;
  }

  .sm\\:odd\\:p-1:nth-child(odd){
    padding: 0.25rem;
  }

  .sm\\:odd\\:p-2:nth-child(odd){
    padding: 0.5rem;
  }

  .sm\\:odd\\:p-3:nth-child(odd){
    padding: 0.75rem;
  }

  .sm\\:odd\\:p-4:nth-child(odd){
    padding: 1rem;
  }

  .sm\\:odd\\:p-5:nth-child(odd){
    padding: 1.25rem;
  }

  .sm\\:odd\\:p-6:nth-child(odd){
    padding: 1.5rem;
  }

  .sm\\:odd\\:p-7:nth-child(odd){
    padding: 1.75rem;
  }

  .sm\\:odd\\:p-8:nth-child(odd){
    padding: 2rem;
  }

  .sm\\:odd\\:p-9:nth-child(odd){
    padding: 2.25rem;
  }

  .sm\\:odd\\:p-10:nth-child(odd){
    padding: 2.5rem;
  }

  .sm\\:odd\\:p-11:nth-child(odd){
    padding: 2.75rem;
  }

  .sm\\:odd\\:p-12:nth-child(odd){
    padding: 3rem;
  }

  .sm\\:odd\\:p-14:nth-child(odd){
    padding: 3.5rem;
  }

  .sm\\:odd\\:p-15:nth-child(odd){
    padding: 3.75rem;
  }

  .sm\\:odd\\:p-16:nth-child(odd){
    padding: 4rem;
  }

  .sm\\:odd\\:p-18:nth-child(odd){
    padding: 4.5rem;
  }

  .sm\\:odd\\:p-20:nth-child(odd){
    padding: 5rem;
  }

  .sm\\:odd\\:p-22:nth-child(odd){
    padding: 5.5rem;
  }

  .sm\\:odd\\:p-23:nth-child(odd){
    padding: 5.75rem;
  }

  .sm\\:odd\\:p-24:nth-child(odd){
    padding: 6rem;
  }

  .sm\\:odd\\:p-25:nth-child(odd){
    padding: 6.25rem;
  }

  .sm\\:odd\\:p-26:nth-child(odd){
    padding: 6.5rem;
  }

  .sm\\:odd\\:p-28:nth-child(odd){
    padding: 7rem;
  }

  .sm\\:odd\\:p-30:nth-child(odd){
    padding: 7.5rem;
  }

  .sm\\:odd\\:p-32:nth-child(odd){
    padding: 8rem;
  }

  .sm\\:odd\\:p-34:nth-child(odd){
    padding: 8.5rem;
  }

  .sm\\:odd\\:p-40:nth-child(odd){
    padding: 10rem;
  }

  .sm\\:odd\\:p-42:nth-child(odd){
    padding: 10.5rem;
  }

  .sm\\:odd\\:p-44:nth-child(odd){
    padding: 11rem;
  }

  .sm\\:odd\\:p-48:nth-child(odd){
    padding: 12rem;
  }

  .sm\\:odd\\:p-52:nth-child(odd){
    padding: 13rem;
  }

  .sm\\:odd\\:p-54:nth-child(odd){
    padding: 13.5rem;
  }

  .sm\\:odd\\:p-56:nth-child(odd){
    padding: 14rem;
  }

  .sm\\:odd\\:p-60:nth-child(odd){
    padding: 15rem;
  }

  .sm\\:odd\\:p-64:nth-child(odd){
    padding: 16rem;
  }

  .sm\\:odd\\:p-68:nth-child(odd){
    padding: 17rem;
  }

  .sm\\:odd\\:p-72:nth-child(odd){
    padding: 18rem;
  }

  .sm\\:odd\\:p-74:nth-child(odd){
    padding: 18.5rem;
  }

  .sm\\:odd\\:p-76:nth-child(odd){
    padding: 19rem;
  }

  .sm\\:odd\\:p-78:nth-child(odd){
    padding: 19.5rem;
  }

  .sm\\:odd\\:p-80:nth-child(odd){
    padding: 20rem;
  }

  .sm\\:odd\\:p-82:nth-child(odd){
    padding: 20.5rem;
  }

  .sm\\:odd\\:p-84:nth-child(odd){
    padding: 21rem;
  }

  .sm\\:odd\\:p-88:nth-child(odd){
    padding: 22rem;
  }

  .sm\\:odd\\:p-92:nth-child(odd){
    padding: 23rem;
  }

  .sm\\:odd\\:p-96:nth-child(odd){
    padding: 24rem;
  }

  .sm\\:odd\\:p-98:nth-child(odd){
    padding: 24.5rem;
  }

  .sm\\:odd\\:p-100:nth-child(odd){
    padding: 25rem;
  }

  .sm\\:odd\\:p-104:nth-child(odd){
    padding: 26rem;
  }

  .sm\\:odd\\:p-112:nth-child(odd){
    padding: 28rem;
  }

  .sm\\:odd\\:p-124:nth-child(odd){
    padding: 31rem;
  }

  .sm\\:odd\\:p-128:nth-child(odd){
    padding: 32rem;
  }

  .sm\\:odd\\:p-140:nth-child(odd){
    padding: 35rem;
  }

  .sm\\:odd\\:p-152:nth-child(odd){
    padding: 38rem;
  }

  .sm\\:odd\\:p-160:nth-child(odd){
    padding: 40rem;
  }

  .sm\\:odd\\:p-162:nth-child(odd){
    padding: 41rem;
  }

  .sm\\:odd\\:p-192:nth-child(odd){
    padding: 48rem;
  }

  .sm\\:odd\\:p-208:nth-child(odd){
    padding: 52rem;
  }

  .sm\\:odd\\:p-224:nth-child(odd){
    padding: 56rem;
  }

  .sm\\:odd\\:p-256:nth-child(odd){
    padding: 64rem;
  }

  .sm\\:odd\\:p-px:nth-child(odd){
    padding: 1px;
  }

  .sm\\:odd\\:py-0:nth-child(odd){
    padding-top: 0;
    padding-bottom: 0;
  }

  .sm\\:odd\\:px-0:nth-child(odd){
    padding-left: 0;
    padding-right: 0;
  }

  .sm\\:odd\\:py-1:nth-child(odd){
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .sm\\:odd\\:px-1:nth-child(odd){
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .sm\\:odd\\:py-2:nth-child(odd){
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:odd\\:px-2:nth-child(odd){
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:odd\\:py-3:nth-child(odd){
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:odd\\:px-3:nth-child(odd){
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:odd\\:py-4:nth-child(odd){
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:odd\\:px-4:nth-child(odd){
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:odd\\:py-5:nth-child(odd){
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:odd\\:px-5:nth-child(odd){
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:odd\\:py-6:nth-child(odd){
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:odd\\:px-6:nth-child(odd){
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:odd\\:py-7:nth-child(odd){
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .sm\\:odd\\:px-7:nth-child(odd){
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .sm\\:odd\\:py-8:nth-child(odd){
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:odd\\:px-8:nth-child(odd){
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:odd\\:py-9:nth-child(odd){
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .sm\\:odd\\:px-9:nth-child(odd){
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .sm\\:odd\\:py-10:nth-child(odd){
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:odd\\:px-10:nth-child(odd){
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .sm\\:odd\\:py-11:nth-child(odd){
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .sm\\:odd\\:px-11:nth-child(odd){
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .sm\\:odd\\:py-12:nth-child(odd){
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:odd\\:px-12:nth-child(odd){
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .sm\\:odd\\:py-14:nth-child(odd){
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .sm\\:odd\\:px-14:nth-child(odd){
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .sm\\:odd\\:py-15:nth-child(odd){
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .sm\\:odd\\:px-15:nth-child(odd){
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .sm\\:odd\\:py-16:nth-child(odd){
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .sm\\:odd\\:px-16:nth-child(odd){
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .sm\\:odd\\:py-18:nth-child(odd){
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .sm\\:odd\\:px-18:nth-child(odd){
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .sm\\:odd\\:py-20:nth-child(odd){
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .sm\\:odd\\:px-20:nth-child(odd){
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .sm\\:odd\\:py-22:nth-child(odd){
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .sm\\:odd\\:px-22:nth-child(odd){
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .sm\\:odd\\:py-23:nth-child(odd){
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .sm\\:odd\\:px-23:nth-child(odd){
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .sm\\:odd\\:py-24:nth-child(odd){
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .sm\\:odd\\:px-24:nth-child(odd){
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .sm\\:odd\\:py-25:nth-child(odd){
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .sm\\:odd\\:px-25:nth-child(odd){
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .sm\\:odd\\:py-26:nth-child(odd){
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .sm\\:odd\\:px-26:nth-child(odd){
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .sm\\:odd\\:py-28:nth-child(odd){
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .sm\\:odd\\:px-28:nth-child(odd){
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .sm\\:odd\\:py-30:nth-child(odd){
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .sm\\:odd\\:px-30:nth-child(odd){
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .sm\\:odd\\:py-32:nth-child(odd){
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .sm\\:odd\\:px-32:nth-child(odd){
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .sm\\:odd\\:py-34:nth-child(odd){
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .sm\\:odd\\:px-34:nth-child(odd){
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .sm\\:odd\\:py-40:nth-child(odd){
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .sm\\:odd\\:px-40:nth-child(odd){
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .sm\\:odd\\:py-42:nth-child(odd){
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .sm\\:odd\\:px-42:nth-child(odd){
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .sm\\:odd\\:py-44:nth-child(odd){
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .sm\\:odd\\:px-44:nth-child(odd){
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .sm\\:odd\\:py-48:nth-child(odd){
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .sm\\:odd\\:px-48:nth-child(odd){
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .sm\\:odd\\:py-52:nth-child(odd){
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .sm\\:odd\\:px-52:nth-child(odd){
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .sm\\:odd\\:py-54:nth-child(odd){
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .sm\\:odd\\:px-54:nth-child(odd){
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .sm\\:odd\\:py-56:nth-child(odd){
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .sm\\:odd\\:px-56:nth-child(odd){
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .sm\\:odd\\:py-60:nth-child(odd){
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .sm\\:odd\\:px-60:nth-child(odd){
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .sm\\:odd\\:py-64:nth-child(odd){
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .sm\\:odd\\:px-64:nth-child(odd){
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .sm\\:odd\\:py-68:nth-child(odd){
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .sm\\:odd\\:px-68:nth-child(odd){
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .sm\\:odd\\:py-72:nth-child(odd){
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .sm\\:odd\\:px-72:nth-child(odd){
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .sm\\:odd\\:py-74:nth-child(odd){
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .sm\\:odd\\:px-74:nth-child(odd){
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .sm\\:odd\\:py-76:nth-child(odd){
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .sm\\:odd\\:px-76:nth-child(odd){
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .sm\\:odd\\:py-78:nth-child(odd){
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .sm\\:odd\\:px-78:nth-child(odd){
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .sm\\:odd\\:py-80:nth-child(odd){
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .sm\\:odd\\:px-80:nth-child(odd){
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .sm\\:odd\\:py-82:nth-child(odd){
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .sm\\:odd\\:px-82:nth-child(odd){
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .sm\\:odd\\:py-84:nth-child(odd){
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .sm\\:odd\\:px-84:nth-child(odd){
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .sm\\:odd\\:py-88:nth-child(odd){
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .sm\\:odd\\:px-88:nth-child(odd){
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .sm\\:odd\\:py-92:nth-child(odd){
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .sm\\:odd\\:px-92:nth-child(odd){
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .sm\\:odd\\:py-96:nth-child(odd){
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .sm\\:odd\\:px-96:nth-child(odd){
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .sm\\:odd\\:py-98:nth-child(odd){
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .sm\\:odd\\:px-98:nth-child(odd){
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .sm\\:odd\\:py-100:nth-child(odd){
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .sm\\:odd\\:px-100:nth-child(odd){
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .sm\\:odd\\:py-104:nth-child(odd){
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .sm\\:odd\\:px-104:nth-child(odd){
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .sm\\:odd\\:py-112:nth-child(odd){
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .sm\\:odd\\:px-112:nth-child(odd){
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .sm\\:odd\\:py-124:nth-child(odd){
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .sm\\:odd\\:px-124:nth-child(odd){
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .sm\\:odd\\:py-128:nth-child(odd){
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .sm\\:odd\\:px-128:nth-child(odd){
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .sm\\:odd\\:py-140:nth-child(odd){
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .sm\\:odd\\:px-140:nth-child(odd){
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .sm\\:odd\\:py-152:nth-child(odd){
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .sm\\:odd\\:px-152:nth-child(odd){
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .sm\\:odd\\:py-160:nth-child(odd){
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .sm\\:odd\\:px-160:nth-child(odd){
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .sm\\:odd\\:py-162:nth-child(odd){
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .sm\\:odd\\:px-162:nth-child(odd){
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .sm\\:odd\\:py-192:nth-child(odd){
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .sm\\:odd\\:px-192:nth-child(odd){
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .sm\\:odd\\:py-208:nth-child(odd){
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .sm\\:odd\\:px-208:nth-child(odd){
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .sm\\:odd\\:py-224:nth-child(odd){
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .sm\\:odd\\:px-224:nth-child(odd){
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .sm\\:odd\\:py-256:nth-child(odd){
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .sm\\:odd\\:px-256:nth-child(odd){
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .sm\\:odd\\:py-px:nth-child(odd){
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .sm\\:odd\\:px-px:nth-child(odd){
    padding-left: 1px;
    padding-right: 1px;
  }

  .sm\\:odd\\:pt-0:nth-child(odd){
    padding-top: 0;
  }

  .sm\\:odd\\:pr-0:nth-child(odd){
    padding-right: 0;
  }

  .sm\\:odd\\:pb-0:nth-child(odd){
    padding-bottom: 0;
  }

  .sm\\:odd\\:pl-0:nth-child(odd){
    padding-left: 0;
  }

  .sm\\:odd\\:pt-1:nth-child(odd){
    padding-top: 0.25rem;
  }

  .sm\\:odd\\:pr-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  .sm\\:odd\\:pb-1:nth-child(odd){
    padding-bottom: 0.25rem;
  }

  .sm\\:odd\\:pl-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  .sm\\:odd\\:pt-2:nth-child(odd){
    padding-top: 0.5rem;
  }

  .sm\\:odd\\:pr-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  .sm\\:odd\\:pb-2:nth-child(odd){
    padding-bottom: 0.5rem;
  }

  .sm\\:odd\\:pl-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  .sm\\:odd\\:pt-3:nth-child(odd){
    padding-top: 0.75rem;
  }

  .sm\\:odd\\:pr-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  .sm\\:odd\\:pb-3:nth-child(odd){
    padding-bottom: 0.75rem;
  }

  .sm\\:odd\\:pl-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  .sm\\:odd\\:pt-4:nth-child(odd){
    padding-top: 1rem;
  }

  .sm\\:odd\\:pr-4:nth-child(odd){
    padding-right: 1rem;
  }

  .sm\\:odd\\:pb-4:nth-child(odd){
    padding-bottom: 1rem;
  }

  .sm\\:odd\\:pl-4:nth-child(odd){
    padding-left: 1rem;
  }

  .sm\\:odd\\:pt-5:nth-child(odd){
    padding-top: 1.25rem;
  }

  .sm\\:odd\\:pr-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  .sm\\:odd\\:pb-5:nth-child(odd){
    padding-bottom: 1.25rem;
  }

  .sm\\:odd\\:pl-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  .sm\\:odd\\:pt-6:nth-child(odd){
    padding-top: 1.5rem;
  }

  .sm\\:odd\\:pr-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  .sm\\:odd\\:pb-6:nth-child(odd){
    padding-bottom: 1.5rem;
  }

  .sm\\:odd\\:pl-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  .sm\\:odd\\:pt-7:nth-child(odd){
    padding-top: 1.75rem;
  }

  .sm\\:odd\\:pr-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  .sm\\:odd\\:pb-7:nth-child(odd){
    padding-bottom: 1.75rem;
  }

  .sm\\:odd\\:pl-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  .sm\\:odd\\:pt-8:nth-child(odd){
    padding-top: 2rem;
  }

  .sm\\:odd\\:pr-8:nth-child(odd){
    padding-right: 2rem;
  }

  .sm\\:odd\\:pb-8:nth-child(odd){
    padding-bottom: 2rem;
  }

  .sm\\:odd\\:pl-8:nth-child(odd){
    padding-left: 2rem;
  }

  .sm\\:odd\\:pt-9:nth-child(odd){
    padding-top: 2.25rem;
  }

  .sm\\:odd\\:pr-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  .sm\\:odd\\:pb-9:nth-child(odd){
    padding-bottom: 2.25rem;
  }

  .sm\\:odd\\:pl-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  .sm\\:odd\\:pt-10:nth-child(odd){
    padding-top: 2.5rem;
  }

  .sm\\:odd\\:pr-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  .sm\\:odd\\:pb-10:nth-child(odd){
    padding-bottom: 2.5rem;
  }

  .sm\\:odd\\:pl-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  .sm\\:odd\\:pt-11:nth-child(odd){
    padding-top: 2.75rem;
  }

  .sm\\:odd\\:pr-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  .sm\\:odd\\:pb-11:nth-child(odd){
    padding-bottom: 2.75rem;
  }

  .sm\\:odd\\:pl-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  .sm\\:odd\\:pt-12:nth-child(odd){
    padding-top: 3rem;
  }

  .sm\\:odd\\:pr-12:nth-child(odd){
    padding-right: 3rem;
  }

  .sm\\:odd\\:pb-12:nth-child(odd){
    padding-bottom: 3rem;
  }

  .sm\\:odd\\:pl-12:nth-child(odd){
    padding-left: 3rem;
  }

  .sm\\:odd\\:pt-14:nth-child(odd){
    padding-top: 3.5rem;
  }

  .sm\\:odd\\:pr-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  .sm\\:odd\\:pb-14:nth-child(odd){
    padding-bottom: 3.5rem;
  }

  .sm\\:odd\\:pl-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  .sm\\:odd\\:pt-15:nth-child(odd){
    padding-top: 3.75rem;
  }

  .sm\\:odd\\:pr-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  .sm\\:odd\\:pb-15:nth-child(odd){
    padding-bottom: 3.75rem;
  }

  .sm\\:odd\\:pl-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  .sm\\:odd\\:pt-16:nth-child(odd){
    padding-top: 4rem;
  }

  .sm\\:odd\\:pr-16:nth-child(odd){
    padding-right: 4rem;
  }

  .sm\\:odd\\:pb-16:nth-child(odd){
    padding-bottom: 4rem;
  }

  .sm\\:odd\\:pl-16:nth-child(odd){
    padding-left: 4rem;
  }

  .sm\\:odd\\:pt-18:nth-child(odd){
    padding-top: 4.5rem;
  }

  .sm\\:odd\\:pr-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  .sm\\:odd\\:pb-18:nth-child(odd){
    padding-bottom: 4.5rem;
  }

  .sm\\:odd\\:pl-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  .sm\\:odd\\:pt-20:nth-child(odd){
    padding-top: 5rem;
  }

  .sm\\:odd\\:pr-20:nth-child(odd){
    padding-right: 5rem;
  }

  .sm\\:odd\\:pb-20:nth-child(odd){
    padding-bottom: 5rem;
  }

  .sm\\:odd\\:pl-20:nth-child(odd){
    padding-left: 5rem;
  }

  .sm\\:odd\\:pt-22:nth-child(odd){
    padding-top: 5.5rem;
  }

  .sm\\:odd\\:pr-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  .sm\\:odd\\:pb-22:nth-child(odd){
    padding-bottom: 5.5rem;
  }

  .sm\\:odd\\:pl-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  .sm\\:odd\\:pt-23:nth-child(odd){
    padding-top: 5.75rem;
  }

  .sm\\:odd\\:pr-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  .sm\\:odd\\:pb-23:nth-child(odd){
    padding-bottom: 5.75rem;
  }

  .sm\\:odd\\:pl-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  .sm\\:odd\\:pt-24:nth-child(odd){
    padding-top: 6rem;
  }

  .sm\\:odd\\:pr-24:nth-child(odd){
    padding-right: 6rem;
  }

  .sm\\:odd\\:pb-24:nth-child(odd){
    padding-bottom: 6rem;
  }

  .sm\\:odd\\:pl-24:nth-child(odd){
    padding-left: 6rem;
  }

  .sm\\:odd\\:pt-25:nth-child(odd){
    padding-top: 6.25rem;
  }

  .sm\\:odd\\:pr-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  .sm\\:odd\\:pb-25:nth-child(odd){
    padding-bottom: 6.25rem;
  }

  .sm\\:odd\\:pl-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  .sm\\:odd\\:pt-26:nth-child(odd){
    padding-top: 6.5rem;
  }

  .sm\\:odd\\:pr-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  .sm\\:odd\\:pb-26:nth-child(odd){
    padding-bottom: 6.5rem;
  }

  .sm\\:odd\\:pl-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  .sm\\:odd\\:pt-28:nth-child(odd){
    padding-top: 7rem;
  }

  .sm\\:odd\\:pr-28:nth-child(odd){
    padding-right: 7rem;
  }

  .sm\\:odd\\:pb-28:nth-child(odd){
    padding-bottom: 7rem;
  }

  .sm\\:odd\\:pl-28:nth-child(odd){
    padding-left: 7rem;
  }

  .sm\\:odd\\:pt-30:nth-child(odd){
    padding-top: 7.5rem;
  }

  .sm\\:odd\\:pr-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  .sm\\:odd\\:pb-30:nth-child(odd){
    padding-bottom: 7.5rem;
  }

  .sm\\:odd\\:pl-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  .sm\\:odd\\:pt-32:nth-child(odd){
    padding-top: 8rem;
  }

  .sm\\:odd\\:pr-32:nth-child(odd){
    padding-right: 8rem;
  }

  .sm\\:odd\\:pb-32:nth-child(odd){
    padding-bottom: 8rem;
  }

  .sm\\:odd\\:pl-32:nth-child(odd){
    padding-left: 8rem;
  }

  .sm\\:odd\\:pt-34:nth-child(odd){
    padding-top: 8.5rem;
  }

  .sm\\:odd\\:pr-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  .sm\\:odd\\:pb-34:nth-child(odd){
    padding-bottom: 8.5rem;
  }

  .sm\\:odd\\:pl-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  .sm\\:odd\\:pt-40:nth-child(odd){
    padding-top: 10rem;
  }

  .sm\\:odd\\:pr-40:nth-child(odd){
    padding-right: 10rem;
  }

  .sm\\:odd\\:pb-40:nth-child(odd){
    padding-bottom: 10rem;
  }

  .sm\\:odd\\:pl-40:nth-child(odd){
    padding-left: 10rem;
  }

  .sm\\:odd\\:pt-42:nth-child(odd){
    padding-top: 10.5rem;
  }

  .sm\\:odd\\:pr-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  .sm\\:odd\\:pb-42:nth-child(odd){
    padding-bottom: 10.5rem;
  }

  .sm\\:odd\\:pl-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  .sm\\:odd\\:pt-44:nth-child(odd){
    padding-top: 11rem;
  }

  .sm\\:odd\\:pr-44:nth-child(odd){
    padding-right: 11rem;
  }

  .sm\\:odd\\:pb-44:nth-child(odd){
    padding-bottom: 11rem;
  }

  .sm\\:odd\\:pl-44:nth-child(odd){
    padding-left: 11rem;
  }

  .sm\\:odd\\:pt-48:nth-child(odd){
    padding-top: 12rem;
  }

  .sm\\:odd\\:pr-48:nth-child(odd){
    padding-right: 12rem;
  }

  .sm\\:odd\\:pb-48:nth-child(odd){
    padding-bottom: 12rem;
  }

  .sm\\:odd\\:pl-48:nth-child(odd){
    padding-left: 12rem;
  }

  .sm\\:odd\\:pt-52:nth-child(odd){
    padding-top: 13rem;
  }

  .sm\\:odd\\:pr-52:nth-child(odd){
    padding-right: 13rem;
  }

  .sm\\:odd\\:pb-52:nth-child(odd){
    padding-bottom: 13rem;
  }

  .sm\\:odd\\:pl-52:nth-child(odd){
    padding-left: 13rem;
  }

  .sm\\:odd\\:pt-54:nth-child(odd){
    padding-top: 13.5rem;
  }

  .sm\\:odd\\:pr-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  .sm\\:odd\\:pb-54:nth-child(odd){
    padding-bottom: 13.5rem;
  }

  .sm\\:odd\\:pl-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  .sm\\:odd\\:pt-56:nth-child(odd){
    padding-top: 14rem;
  }

  .sm\\:odd\\:pr-56:nth-child(odd){
    padding-right: 14rem;
  }

  .sm\\:odd\\:pb-56:nth-child(odd){
    padding-bottom: 14rem;
  }

  .sm\\:odd\\:pl-56:nth-child(odd){
    padding-left: 14rem;
  }

  .sm\\:odd\\:pt-60:nth-child(odd){
    padding-top: 15rem;
  }

  .sm\\:odd\\:pr-60:nth-child(odd){
    padding-right: 15rem;
  }

  .sm\\:odd\\:pb-60:nth-child(odd){
    padding-bottom: 15rem;
  }

  .sm\\:odd\\:pl-60:nth-child(odd){
    padding-left: 15rem;
  }

  .sm\\:odd\\:pt-64:nth-child(odd){
    padding-top: 16rem;
  }

  .sm\\:odd\\:pr-64:nth-child(odd){
    padding-right: 16rem;
  }

  .sm\\:odd\\:pb-64:nth-child(odd){
    padding-bottom: 16rem;
  }

  .sm\\:odd\\:pl-64:nth-child(odd){
    padding-left: 16rem;
  }

  .sm\\:odd\\:pt-68:nth-child(odd){
    padding-top: 17rem;
  }

  .sm\\:odd\\:pr-68:nth-child(odd){
    padding-right: 17rem;
  }

  .sm\\:odd\\:pb-68:nth-child(odd){
    padding-bottom: 17rem;
  }

  .sm\\:odd\\:pl-68:nth-child(odd){
    padding-left: 17rem;
  }

  .sm\\:odd\\:pt-72:nth-child(odd){
    padding-top: 18rem;
  }

  .sm\\:odd\\:pr-72:nth-child(odd){
    padding-right: 18rem;
  }

  .sm\\:odd\\:pb-72:nth-child(odd){
    padding-bottom: 18rem;
  }

  .sm\\:odd\\:pl-72:nth-child(odd){
    padding-left: 18rem;
  }

  .sm\\:odd\\:pt-74:nth-child(odd){
    padding-top: 18.5rem;
  }

  .sm\\:odd\\:pr-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  .sm\\:odd\\:pb-74:nth-child(odd){
    padding-bottom: 18.5rem;
  }

  .sm\\:odd\\:pl-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  .sm\\:odd\\:pt-76:nth-child(odd){
    padding-top: 19rem;
  }

  .sm\\:odd\\:pr-76:nth-child(odd){
    padding-right: 19rem;
  }

  .sm\\:odd\\:pb-76:nth-child(odd){
    padding-bottom: 19rem;
  }

  .sm\\:odd\\:pl-76:nth-child(odd){
    padding-left: 19rem;
  }

  .sm\\:odd\\:pt-78:nth-child(odd){
    padding-top: 19.5rem;
  }

  .sm\\:odd\\:pr-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  .sm\\:odd\\:pb-78:nth-child(odd){
    padding-bottom: 19.5rem;
  }

  .sm\\:odd\\:pl-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  .sm\\:odd\\:pt-80:nth-child(odd){
    padding-top: 20rem;
  }

  .sm\\:odd\\:pr-80:nth-child(odd){
    padding-right: 20rem;
  }

  .sm\\:odd\\:pb-80:nth-child(odd){
    padding-bottom: 20rem;
  }

  .sm\\:odd\\:pl-80:nth-child(odd){
    padding-left: 20rem;
  }

  .sm\\:odd\\:pt-82:nth-child(odd){
    padding-top: 20.5rem;
  }

  .sm\\:odd\\:pr-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  .sm\\:odd\\:pb-82:nth-child(odd){
    padding-bottom: 20.5rem;
  }

  .sm\\:odd\\:pl-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  .sm\\:odd\\:pt-84:nth-child(odd){
    padding-top: 21rem;
  }

  .sm\\:odd\\:pr-84:nth-child(odd){
    padding-right: 21rem;
  }

  .sm\\:odd\\:pb-84:nth-child(odd){
    padding-bottom: 21rem;
  }

  .sm\\:odd\\:pl-84:nth-child(odd){
    padding-left: 21rem;
  }

  .sm\\:odd\\:pt-88:nth-child(odd){
    padding-top: 22rem;
  }

  .sm\\:odd\\:pr-88:nth-child(odd){
    padding-right: 22rem;
  }

  .sm\\:odd\\:pb-88:nth-child(odd){
    padding-bottom: 22rem;
  }

  .sm\\:odd\\:pl-88:nth-child(odd){
    padding-left: 22rem;
  }

  .sm\\:odd\\:pt-92:nth-child(odd){
    padding-top: 23rem;
  }

  .sm\\:odd\\:pr-92:nth-child(odd){
    padding-right: 23rem;
  }

  .sm\\:odd\\:pb-92:nth-child(odd){
    padding-bottom: 23rem;
  }

  .sm\\:odd\\:pl-92:nth-child(odd){
    padding-left: 23rem;
  }

  .sm\\:odd\\:pt-96:nth-child(odd){
    padding-top: 24rem;
  }

  .sm\\:odd\\:pr-96:nth-child(odd){
    padding-right: 24rem;
  }

  .sm\\:odd\\:pb-96:nth-child(odd){
    padding-bottom: 24rem;
  }

  .sm\\:odd\\:pl-96:nth-child(odd){
    padding-left: 24rem;
  }

  .sm\\:odd\\:pt-98:nth-child(odd){
    padding-top: 24.5rem;
  }

  .sm\\:odd\\:pr-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  .sm\\:odd\\:pb-98:nth-child(odd){
    padding-bottom: 24.5rem;
  }

  .sm\\:odd\\:pl-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  .sm\\:odd\\:pt-100:nth-child(odd){
    padding-top: 25rem;
  }

  .sm\\:odd\\:pr-100:nth-child(odd){
    padding-right: 25rem;
  }

  .sm\\:odd\\:pb-100:nth-child(odd){
    padding-bottom: 25rem;
  }

  .sm\\:odd\\:pl-100:nth-child(odd){
    padding-left: 25rem;
  }

  .sm\\:odd\\:pt-104:nth-child(odd){
    padding-top: 26rem;
  }

  .sm\\:odd\\:pr-104:nth-child(odd){
    padding-right: 26rem;
  }

  .sm\\:odd\\:pb-104:nth-child(odd){
    padding-bottom: 26rem;
  }

  .sm\\:odd\\:pl-104:nth-child(odd){
    padding-left: 26rem;
  }

  .sm\\:odd\\:pt-112:nth-child(odd){
    padding-top: 28rem;
  }

  .sm\\:odd\\:pr-112:nth-child(odd){
    padding-right: 28rem;
  }

  .sm\\:odd\\:pb-112:nth-child(odd){
    padding-bottom: 28rem;
  }

  .sm\\:odd\\:pl-112:nth-child(odd){
    padding-left: 28rem;
  }

  .sm\\:odd\\:pt-124:nth-child(odd){
    padding-top: 31rem;
  }

  .sm\\:odd\\:pr-124:nth-child(odd){
    padding-right: 31rem;
  }

  .sm\\:odd\\:pb-124:nth-child(odd){
    padding-bottom: 31rem;
  }

  .sm\\:odd\\:pl-124:nth-child(odd){
    padding-left: 31rem;
  }

  .sm\\:odd\\:pt-128:nth-child(odd){
    padding-top: 32rem;
  }

  .sm\\:odd\\:pr-128:nth-child(odd){
    padding-right: 32rem;
  }

  .sm\\:odd\\:pb-128:nth-child(odd){
    padding-bottom: 32rem;
  }

  .sm\\:odd\\:pl-128:nth-child(odd){
    padding-left: 32rem;
  }

  .sm\\:odd\\:pt-140:nth-child(odd){
    padding-top: 35rem;
  }

  .sm\\:odd\\:pr-140:nth-child(odd){
    padding-right: 35rem;
  }

  .sm\\:odd\\:pb-140:nth-child(odd){
    padding-bottom: 35rem;
  }

  .sm\\:odd\\:pl-140:nth-child(odd){
    padding-left: 35rem;
  }

  .sm\\:odd\\:pt-152:nth-child(odd){
    padding-top: 38rem;
  }

  .sm\\:odd\\:pr-152:nth-child(odd){
    padding-right: 38rem;
  }

  .sm\\:odd\\:pb-152:nth-child(odd){
    padding-bottom: 38rem;
  }

  .sm\\:odd\\:pl-152:nth-child(odd){
    padding-left: 38rem;
  }

  .sm\\:odd\\:pt-160:nth-child(odd){
    padding-top: 40rem;
  }

  .sm\\:odd\\:pr-160:nth-child(odd){
    padding-right: 40rem;
  }

  .sm\\:odd\\:pb-160:nth-child(odd){
    padding-bottom: 40rem;
  }

  .sm\\:odd\\:pl-160:nth-child(odd){
    padding-left: 40rem;
  }

  .sm\\:odd\\:pt-162:nth-child(odd){
    padding-top: 41rem;
  }

  .sm\\:odd\\:pr-162:nth-child(odd){
    padding-right: 41rem;
  }

  .sm\\:odd\\:pb-162:nth-child(odd){
    padding-bottom: 41rem;
  }

  .sm\\:odd\\:pl-162:nth-child(odd){
    padding-left: 41rem;
  }

  .sm\\:odd\\:pt-192:nth-child(odd){
    padding-top: 48rem;
  }

  .sm\\:odd\\:pr-192:nth-child(odd){
    padding-right: 48rem;
  }

  .sm\\:odd\\:pb-192:nth-child(odd){
    padding-bottom: 48rem;
  }

  .sm\\:odd\\:pl-192:nth-child(odd){
    padding-left: 48rem;
  }

  .sm\\:odd\\:pt-208:nth-child(odd){
    padding-top: 52rem;
  }

  .sm\\:odd\\:pr-208:nth-child(odd){
    padding-right: 52rem;
  }

  .sm\\:odd\\:pb-208:nth-child(odd){
    padding-bottom: 52rem;
  }

  .sm\\:odd\\:pl-208:nth-child(odd){
    padding-left: 52rem;
  }

  .sm\\:odd\\:pt-224:nth-child(odd){
    padding-top: 56rem;
  }

  .sm\\:odd\\:pr-224:nth-child(odd){
    padding-right: 56rem;
  }

  .sm\\:odd\\:pb-224:nth-child(odd){
    padding-bottom: 56rem;
  }

  .sm\\:odd\\:pl-224:nth-child(odd){
    padding-left: 56rem;
  }

  .sm\\:odd\\:pt-256:nth-child(odd){
    padding-top: 64rem;
  }

  .sm\\:odd\\:pr-256:nth-child(odd){
    padding-right: 64rem;
  }

  .sm\\:odd\\:pb-256:nth-child(odd){
    padding-bottom: 64rem;
  }

  .sm\\:odd\\:pl-256:nth-child(odd){
    padding-left: 64rem;
  }

  .sm\\:odd\\:pt-px:nth-child(odd){
    padding-top: 1px;
  }

  .sm\\:odd\\:pr-px:nth-child(odd){
    padding-right: 1px;
  }

  .sm\\:odd\\:pb-px:nth-child(odd){
    padding-bottom: 1px;
  }

  .sm\\:odd\\:pl-px:nth-child(odd){
    padding-left: 1px;
  }

  .sm\\:even\\:p-0:nth-child(even){
    padding: 0;
  }

  .sm\\:even\\:p-1:nth-child(even){
    padding: 0.25rem;
  }

  .sm\\:even\\:p-2:nth-child(even){
    padding: 0.5rem;
  }

  .sm\\:even\\:p-3:nth-child(even){
    padding: 0.75rem;
  }

  .sm\\:even\\:p-4:nth-child(even){
    padding: 1rem;
  }

  .sm\\:even\\:p-5:nth-child(even){
    padding: 1.25rem;
  }

  .sm\\:even\\:p-6:nth-child(even){
    padding: 1.5rem;
  }

  .sm\\:even\\:p-7:nth-child(even){
    padding: 1.75rem;
  }

  .sm\\:even\\:p-8:nth-child(even){
    padding: 2rem;
  }

  .sm\\:even\\:p-9:nth-child(even){
    padding: 2.25rem;
  }

  .sm\\:even\\:p-10:nth-child(even){
    padding: 2.5rem;
  }

  .sm\\:even\\:p-11:nth-child(even){
    padding: 2.75rem;
  }

  .sm\\:even\\:p-12:nth-child(even){
    padding: 3rem;
  }

  .sm\\:even\\:p-14:nth-child(even){
    padding: 3.5rem;
  }

  .sm\\:even\\:p-15:nth-child(even){
    padding: 3.75rem;
  }

  .sm\\:even\\:p-16:nth-child(even){
    padding: 4rem;
  }

  .sm\\:even\\:p-18:nth-child(even){
    padding: 4.5rem;
  }

  .sm\\:even\\:p-20:nth-child(even){
    padding: 5rem;
  }

  .sm\\:even\\:p-22:nth-child(even){
    padding: 5.5rem;
  }

  .sm\\:even\\:p-23:nth-child(even){
    padding: 5.75rem;
  }

  .sm\\:even\\:p-24:nth-child(even){
    padding: 6rem;
  }

  .sm\\:even\\:p-25:nth-child(even){
    padding: 6.25rem;
  }

  .sm\\:even\\:p-26:nth-child(even){
    padding: 6.5rem;
  }

  .sm\\:even\\:p-28:nth-child(even){
    padding: 7rem;
  }

  .sm\\:even\\:p-30:nth-child(even){
    padding: 7.5rem;
  }

  .sm\\:even\\:p-32:nth-child(even){
    padding: 8rem;
  }

  .sm\\:even\\:p-34:nth-child(even){
    padding: 8.5rem;
  }

  .sm\\:even\\:p-40:nth-child(even){
    padding: 10rem;
  }

  .sm\\:even\\:p-42:nth-child(even){
    padding: 10.5rem;
  }

  .sm\\:even\\:p-44:nth-child(even){
    padding: 11rem;
  }

  .sm\\:even\\:p-48:nth-child(even){
    padding: 12rem;
  }

  .sm\\:even\\:p-52:nth-child(even){
    padding: 13rem;
  }

  .sm\\:even\\:p-54:nth-child(even){
    padding: 13.5rem;
  }

  .sm\\:even\\:p-56:nth-child(even){
    padding: 14rem;
  }

  .sm\\:even\\:p-60:nth-child(even){
    padding: 15rem;
  }

  .sm\\:even\\:p-64:nth-child(even){
    padding: 16rem;
  }

  .sm\\:even\\:p-68:nth-child(even){
    padding: 17rem;
  }

  .sm\\:even\\:p-72:nth-child(even){
    padding: 18rem;
  }

  .sm\\:even\\:p-74:nth-child(even){
    padding: 18.5rem;
  }

  .sm\\:even\\:p-76:nth-child(even){
    padding: 19rem;
  }

  .sm\\:even\\:p-78:nth-child(even){
    padding: 19.5rem;
  }

  .sm\\:even\\:p-80:nth-child(even){
    padding: 20rem;
  }

  .sm\\:even\\:p-82:nth-child(even){
    padding: 20.5rem;
  }

  .sm\\:even\\:p-84:nth-child(even){
    padding: 21rem;
  }

  .sm\\:even\\:p-88:nth-child(even){
    padding: 22rem;
  }

  .sm\\:even\\:p-92:nth-child(even){
    padding: 23rem;
  }

  .sm\\:even\\:p-96:nth-child(even){
    padding: 24rem;
  }

  .sm\\:even\\:p-98:nth-child(even){
    padding: 24.5rem;
  }

  .sm\\:even\\:p-100:nth-child(even){
    padding: 25rem;
  }

  .sm\\:even\\:p-104:nth-child(even){
    padding: 26rem;
  }

  .sm\\:even\\:p-112:nth-child(even){
    padding: 28rem;
  }

  .sm\\:even\\:p-124:nth-child(even){
    padding: 31rem;
  }

  .sm\\:even\\:p-128:nth-child(even){
    padding: 32rem;
  }

  .sm\\:even\\:p-140:nth-child(even){
    padding: 35rem;
  }

  .sm\\:even\\:p-152:nth-child(even){
    padding: 38rem;
  }

  .sm\\:even\\:p-160:nth-child(even){
    padding: 40rem;
  }

  .sm\\:even\\:p-162:nth-child(even){
    padding: 41rem;
  }

  .sm\\:even\\:p-192:nth-child(even){
    padding: 48rem;
  }

  .sm\\:even\\:p-208:nth-child(even){
    padding: 52rem;
  }

  .sm\\:even\\:p-224:nth-child(even){
    padding: 56rem;
  }

  .sm\\:even\\:p-256:nth-child(even){
    padding: 64rem;
  }

  .sm\\:even\\:p-px:nth-child(even){
    padding: 1px;
  }

  .sm\\:even\\:py-0:nth-child(even){
    padding-top: 0;
    padding-bottom: 0;
  }

  .sm\\:even\\:px-0:nth-child(even){
    padding-left: 0;
    padding-right: 0;
  }

  .sm\\:even\\:py-1:nth-child(even){
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .sm\\:even\\:px-1:nth-child(even){
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .sm\\:even\\:py-2:nth-child(even){
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .sm\\:even\\:px-2:nth-child(even){
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .sm\\:even\\:py-3:nth-child(even){
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .sm\\:even\\:px-3:nth-child(even){
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .sm\\:even\\:py-4:nth-child(even){
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .sm\\:even\\:px-4:nth-child(even){
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .sm\\:even\\:py-5:nth-child(even){
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .sm\\:even\\:px-5:nth-child(even){
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .sm\\:even\\:py-6:nth-child(even){
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .sm\\:even\\:px-6:nth-child(even){
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .sm\\:even\\:py-7:nth-child(even){
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .sm\\:even\\:px-7:nth-child(even){
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .sm\\:even\\:py-8:nth-child(even){
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .sm\\:even\\:px-8:nth-child(even){
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .sm\\:even\\:py-9:nth-child(even){
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .sm\\:even\\:px-9:nth-child(even){
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .sm\\:even\\:py-10:nth-child(even){
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .sm\\:even\\:px-10:nth-child(even){
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .sm\\:even\\:py-11:nth-child(even){
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .sm\\:even\\:px-11:nth-child(even){
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .sm\\:even\\:py-12:nth-child(even){
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .sm\\:even\\:px-12:nth-child(even){
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .sm\\:even\\:py-14:nth-child(even){
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .sm\\:even\\:px-14:nth-child(even){
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .sm\\:even\\:py-15:nth-child(even){
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .sm\\:even\\:px-15:nth-child(even){
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .sm\\:even\\:py-16:nth-child(even){
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .sm\\:even\\:px-16:nth-child(even){
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .sm\\:even\\:py-18:nth-child(even){
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .sm\\:even\\:px-18:nth-child(even){
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .sm\\:even\\:py-20:nth-child(even){
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .sm\\:even\\:px-20:nth-child(even){
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .sm\\:even\\:py-22:nth-child(even){
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .sm\\:even\\:px-22:nth-child(even){
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .sm\\:even\\:py-23:nth-child(even){
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .sm\\:even\\:px-23:nth-child(even){
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .sm\\:even\\:py-24:nth-child(even){
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .sm\\:even\\:px-24:nth-child(even){
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .sm\\:even\\:py-25:nth-child(even){
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .sm\\:even\\:px-25:nth-child(even){
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .sm\\:even\\:py-26:nth-child(even){
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .sm\\:even\\:px-26:nth-child(even){
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .sm\\:even\\:py-28:nth-child(even){
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .sm\\:even\\:px-28:nth-child(even){
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .sm\\:even\\:py-30:nth-child(even){
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .sm\\:even\\:px-30:nth-child(even){
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .sm\\:even\\:py-32:nth-child(even){
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .sm\\:even\\:px-32:nth-child(even){
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .sm\\:even\\:py-34:nth-child(even){
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .sm\\:even\\:px-34:nth-child(even){
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .sm\\:even\\:py-40:nth-child(even){
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .sm\\:even\\:px-40:nth-child(even){
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .sm\\:even\\:py-42:nth-child(even){
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .sm\\:even\\:px-42:nth-child(even){
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .sm\\:even\\:py-44:nth-child(even){
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .sm\\:even\\:px-44:nth-child(even){
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .sm\\:even\\:py-48:nth-child(even){
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .sm\\:even\\:px-48:nth-child(even){
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .sm\\:even\\:py-52:nth-child(even){
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .sm\\:even\\:px-52:nth-child(even){
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .sm\\:even\\:py-54:nth-child(even){
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .sm\\:even\\:px-54:nth-child(even){
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .sm\\:even\\:py-56:nth-child(even){
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .sm\\:even\\:px-56:nth-child(even){
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .sm\\:even\\:py-60:nth-child(even){
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .sm\\:even\\:px-60:nth-child(even){
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .sm\\:even\\:py-64:nth-child(even){
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .sm\\:even\\:px-64:nth-child(even){
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .sm\\:even\\:py-68:nth-child(even){
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .sm\\:even\\:px-68:nth-child(even){
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .sm\\:even\\:py-72:nth-child(even){
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .sm\\:even\\:px-72:nth-child(even){
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .sm\\:even\\:py-74:nth-child(even){
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .sm\\:even\\:px-74:nth-child(even){
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .sm\\:even\\:py-76:nth-child(even){
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .sm\\:even\\:px-76:nth-child(even){
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .sm\\:even\\:py-78:nth-child(even){
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .sm\\:even\\:px-78:nth-child(even){
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .sm\\:even\\:py-80:nth-child(even){
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .sm\\:even\\:px-80:nth-child(even){
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .sm\\:even\\:py-82:nth-child(even){
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .sm\\:even\\:px-82:nth-child(even){
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .sm\\:even\\:py-84:nth-child(even){
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .sm\\:even\\:px-84:nth-child(even){
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .sm\\:even\\:py-88:nth-child(even){
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .sm\\:even\\:px-88:nth-child(even){
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .sm\\:even\\:py-92:nth-child(even){
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .sm\\:even\\:px-92:nth-child(even){
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .sm\\:even\\:py-96:nth-child(even){
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .sm\\:even\\:px-96:nth-child(even){
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .sm\\:even\\:py-98:nth-child(even){
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .sm\\:even\\:px-98:nth-child(even){
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .sm\\:even\\:py-100:nth-child(even){
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .sm\\:even\\:px-100:nth-child(even){
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .sm\\:even\\:py-104:nth-child(even){
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .sm\\:even\\:px-104:nth-child(even){
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .sm\\:even\\:py-112:nth-child(even){
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .sm\\:even\\:px-112:nth-child(even){
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .sm\\:even\\:py-124:nth-child(even){
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .sm\\:even\\:px-124:nth-child(even){
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .sm\\:even\\:py-128:nth-child(even){
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .sm\\:even\\:px-128:nth-child(even){
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .sm\\:even\\:py-140:nth-child(even){
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .sm\\:even\\:px-140:nth-child(even){
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .sm\\:even\\:py-152:nth-child(even){
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .sm\\:even\\:px-152:nth-child(even){
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .sm\\:even\\:py-160:nth-child(even){
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .sm\\:even\\:px-160:nth-child(even){
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .sm\\:even\\:py-162:nth-child(even){
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .sm\\:even\\:px-162:nth-child(even){
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .sm\\:even\\:py-192:nth-child(even){
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .sm\\:even\\:px-192:nth-child(even){
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .sm\\:even\\:py-208:nth-child(even){
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .sm\\:even\\:px-208:nth-child(even){
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .sm\\:even\\:py-224:nth-child(even){
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .sm\\:even\\:px-224:nth-child(even){
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .sm\\:even\\:py-256:nth-child(even){
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .sm\\:even\\:px-256:nth-child(even){
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .sm\\:even\\:py-px:nth-child(even){
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .sm\\:even\\:px-px:nth-child(even){
    padding-left: 1px;
    padding-right: 1px;
  }

  .sm\\:even\\:pt-0:nth-child(even){
    padding-top: 0;
  }

  .sm\\:even\\:pr-0:nth-child(even){
    padding-right: 0;
  }

  .sm\\:even\\:pb-0:nth-child(even){
    padding-bottom: 0;
  }

  .sm\\:even\\:pl-0:nth-child(even){
    padding-left: 0;
  }

  .sm\\:even\\:pt-1:nth-child(even){
    padding-top: 0.25rem;
  }

  .sm\\:even\\:pr-1:nth-child(even){
    padding-right: 0.25rem;
  }

  .sm\\:even\\:pb-1:nth-child(even){
    padding-bottom: 0.25rem;
  }

  .sm\\:even\\:pl-1:nth-child(even){
    padding-left: 0.25rem;
  }

  .sm\\:even\\:pt-2:nth-child(even){
    padding-top: 0.5rem;
  }

  .sm\\:even\\:pr-2:nth-child(even){
    padding-right: 0.5rem;
  }

  .sm\\:even\\:pb-2:nth-child(even){
    padding-bottom: 0.5rem;
  }

  .sm\\:even\\:pl-2:nth-child(even){
    padding-left: 0.5rem;
  }

  .sm\\:even\\:pt-3:nth-child(even){
    padding-top: 0.75rem;
  }

  .sm\\:even\\:pr-3:nth-child(even){
    padding-right: 0.75rem;
  }

  .sm\\:even\\:pb-3:nth-child(even){
    padding-bottom: 0.75rem;
  }

  .sm\\:even\\:pl-3:nth-child(even){
    padding-left: 0.75rem;
  }

  .sm\\:even\\:pt-4:nth-child(even){
    padding-top: 1rem;
  }

  .sm\\:even\\:pr-4:nth-child(even){
    padding-right: 1rem;
  }

  .sm\\:even\\:pb-4:nth-child(even){
    padding-bottom: 1rem;
  }

  .sm\\:even\\:pl-4:nth-child(even){
    padding-left: 1rem;
  }

  .sm\\:even\\:pt-5:nth-child(even){
    padding-top: 1.25rem;
  }

  .sm\\:even\\:pr-5:nth-child(even){
    padding-right: 1.25rem;
  }

  .sm\\:even\\:pb-5:nth-child(even){
    padding-bottom: 1.25rem;
  }

  .sm\\:even\\:pl-5:nth-child(even){
    padding-left: 1.25rem;
  }

  .sm\\:even\\:pt-6:nth-child(even){
    padding-top: 1.5rem;
  }

  .sm\\:even\\:pr-6:nth-child(even){
    padding-right: 1.5rem;
  }

  .sm\\:even\\:pb-6:nth-child(even){
    padding-bottom: 1.5rem;
  }

  .sm\\:even\\:pl-6:nth-child(even){
    padding-left: 1.5rem;
  }

  .sm\\:even\\:pt-7:nth-child(even){
    padding-top: 1.75rem;
  }

  .sm\\:even\\:pr-7:nth-child(even){
    padding-right: 1.75rem;
  }

  .sm\\:even\\:pb-7:nth-child(even){
    padding-bottom: 1.75rem;
  }

  .sm\\:even\\:pl-7:nth-child(even){
    padding-left: 1.75rem;
  }

  .sm\\:even\\:pt-8:nth-child(even){
    padding-top: 2rem;
  }

  .sm\\:even\\:pr-8:nth-child(even){
    padding-right: 2rem;
  }

  .sm\\:even\\:pb-8:nth-child(even){
    padding-bottom: 2rem;
  }

  .sm\\:even\\:pl-8:nth-child(even){
    padding-left: 2rem;
  }

  .sm\\:even\\:pt-9:nth-child(even){
    padding-top: 2.25rem;
  }

  .sm\\:even\\:pr-9:nth-child(even){
    padding-right: 2.25rem;
  }

  .sm\\:even\\:pb-9:nth-child(even){
    padding-bottom: 2.25rem;
  }

  .sm\\:even\\:pl-9:nth-child(even){
    padding-left: 2.25rem;
  }

  .sm\\:even\\:pt-10:nth-child(even){
    padding-top: 2.5rem;
  }

  .sm\\:even\\:pr-10:nth-child(even){
    padding-right: 2.5rem;
  }

  .sm\\:even\\:pb-10:nth-child(even){
    padding-bottom: 2.5rem;
  }

  .sm\\:even\\:pl-10:nth-child(even){
    padding-left: 2.5rem;
  }

  .sm\\:even\\:pt-11:nth-child(even){
    padding-top: 2.75rem;
  }

  .sm\\:even\\:pr-11:nth-child(even){
    padding-right: 2.75rem;
  }

  .sm\\:even\\:pb-11:nth-child(even){
    padding-bottom: 2.75rem;
  }

  .sm\\:even\\:pl-11:nth-child(even){
    padding-left: 2.75rem;
  }

  .sm\\:even\\:pt-12:nth-child(even){
    padding-top: 3rem;
  }

  .sm\\:even\\:pr-12:nth-child(even){
    padding-right: 3rem;
  }

  .sm\\:even\\:pb-12:nth-child(even){
    padding-bottom: 3rem;
  }

  .sm\\:even\\:pl-12:nth-child(even){
    padding-left: 3rem;
  }

  .sm\\:even\\:pt-14:nth-child(even){
    padding-top: 3.5rem;
  }

  .sm\\:even\\:pr-14:nth-child(even){
    padding-right: 3.5rem;
  }

  .sm\\:even\\:pb-14:nth-child(even){
    padding-bottom: 3.5rem;
  }

  .sm\\:even\\:pl-14:nth-child(even){
    padding-left: 3.5rem;
  }

  .sm\\:even\\:pt-15:nth-child(even){
    padding-top: 3.75rem;
  }

  .sm\\:even\\:pr-15:nth-child(even){
    padding-right: 3.75rem;
  }

  .sm\\:even\\:pb-15:nth-child(even){
    padding-bottom: 3.75rem;
  }

  .sm\\:even\\:pl-15:nth-child(even){
    padding-left: 3.75rem;
  }

  .sm\\:even\\:pt-16:nth-child(even){
    padding-top: 4rem;
  }

  .sm\\:even\\:pr-16:nth-child(even){
    padding-right: 4rem;
  }

  .sm\\:even\\:pb-16:nth-child(even){
    padding-bottom: 4rem;
  }

  .sm\\:even\\:pl-16:nth-child(even){
    padding-left: 4rem;
  }

  .sm\\:even\\:pt-18:nth-child(even){
    padding-top: 4.5rem;
  }

  .sm\\:even\\:pr-18:nth-child(even){
    padding-right: 4.5rem;
  }

  .sm\\:even\\:pb-18:nth-child(even){
    padding-bottom: 4.5rem;
  }

  .sm\\:even\\:pl-18:nth-child(even){
    padding-left: 4.5rem;
  }

  .sm\\:even\\:pt-20:nth-child(even){
    padding-top: 5rem;
  }

  .sm\\:even\\:pr-20:nth-child(even){
    padding-right: 5rem;
  }

  .sm\\:even\\:pb-20:nth-child(even){
    padding-bottom: 5rem;
  }

  .sm\\:even\\:pl-20:nth-child(even){
    padding-left: 5rem;
  }

  .sm\\:even\\:pt-22:nth-child(even){
    padding-top: 5.5rem;
  }

  .sm\\:even\\:pr-22:nth-child(even){
    padding-right: 5.5rem;
  }

  .sm\\:even\\:pb-22:nth-child(even){
    padding-bottom: 5.5rem;
  }

  .sm\\:even\\:pl-22:nth-child(even){
    padding-left: 5.5rem;
  }

  .sm\\:even\\:pt-23:nth-child(even){
    padding-top: 5.75rem;
  }

  .sm\\:even\\:pr-23:nth-child(even){
    padding-right: 5.75rem;
  }

  .sm\\:even\\:pb-23:nth-child(even){
    padding-bottom: 5.75rem;
  }

  .sm\\:even\\:pl-23:nth-child(even){
    padding-left: 5.75rem;
  }

  .sm\\:even\\:pt-24:nth-child(even){
    padding-top: 6rem;
  }

  .sm\\:even\\:pr-24:nth-child(even){
    padding-right: 6rem;
  }

  .sm\\:even\\:pb-24:nth-child(even){
    padding-bottom: 6rem;
  }

  .sm\\:even\\:pl-24:nth-child(even){
    padding-left: 6rem;
  }

  .sm\\:even\\:pt-25:nth-child(even){
    padding-top: 6.25rem;
  }

  .sm\\:even\\:pr-25:nth-child(even){
    padding-right: 6.25rem;
  }

  .sm\\:even\\:pb-25:nth-child(even){
    padding-bottom: 6.25rem;
  }

  .sm\\:even\\:pl-25:nth-child(even){
    padding-left: 6.25rem;
  }

  .sm\\:even\\:pt-26:nth-child(even){
    padding-top: 6.5rem;
  }

  .sm\\:even\\:pr-26:nth-child(even){
    padding-right: 6.5rem;
  }

  .sm\\:even\\:pb-26:nth-child(even){
    padding-bottom: 6.5rem;
  }

  .sm\\:even\\:pl-26:nth-child(even){
    padding-left: 6.5rem;
  }

  .sm\\:even\\:pt-28:nth-child(even){
    padding-top: 7rem;
  }

  .sm\\:even\\:pr-28:nth-child(even){
    padding-right: 7rem;
  }

  .sm\\:even\\:pb-28:nth-child(even){
    padding-bottom: 7rem;
  }

  .sm\\:even\\:pl-28:nth-child(even){
    padding-left: 7rem;
  }

  .sm\\:even\\:pt-30:nth-child(even){
    padding-top: 7.5rem;
  }

  .sm\\:even\\:pr-30:nth-child(even){
    padding-right: 7.5rem;
  }

  .sm\\:even\\:pb-30:nth-child(even){
    padding-bottom: 7.5rem;
  }

  .sm\\:even\\:pl-30:nth-child(even){
    padding-left: 7.5rem;
  }

  .sm\\:even\\:pt-32:nth-child(even){
    padding-top: 8rem;
  }

  .sm\\:even\\:pr-32:nth-child(even){
    padding-right: 8rem;
  }

  .sm\\:even\\:pb-32:nth-child(even){
    padding-bottom: 8rem;
  }

  .sm\\:even\\:pl-32:nth-child(even){
    padding-left: 8rem;
  }

  .sm\\:even\\:pt-34:nth-child(even){
    padding-top: 8.5rem;
  }

  .sm\\:even\\:pr-34:nth-child(even){
    padding-right: 8.5rem;
  }

  .sm\\:even\\:pb-34:nth-child(even){
    padding-bottom: 8.5rem;
  }

  .sm\\:even\\:pl-34:nth-child(even){
    padding-left: 8.5rem;
  }

  .sm\\:even\\:pt-40:nth-child(even){
    padding-top: 10rem;
  }

  .sm\\:even\\:pr-40:nth-child(even){
    padding-right: 10rem;
  }

  .sm\\:even\\:pb-40:nth-child(even){
    padding-bottom: 10rem;
  }

  .sm\\:even\\:pl-40:nth-child(even){
    padding-left: 10rem;
  }

  .sm\\:even\\:pt-42:nth-child(even){
    padding-top: 10.5rem;
  }

  .sm\\:even\\:pr-42:nth-child(even){
    padding-right: 10.5rem;
  }

  .sm\\:even\\:pb-42:nth-child(even){
    padding-bottom: 10.5rem;
  }

  .sm\\:even\\:pl-42:nth-child(even){
    padding-left: 10.5rem;
  }

  .sm\\:even\\:pt-44:nth-child(even){
    padding-top: 11rem;
  }

  .sm\\:even\\:pr-44:nth-child(even){
    padding-right: 11rem;
  }

  .sm\\:even\\:pb-44:nth-child(even){
    padding-bottom: 11rem;
  }

  .sm\\:even\\:pl-44:nth-child(even){
    padding-left: 11rem;
  }

  .sm\\:even\\:pt-48:nth-child(even){
    padding-top: 12rem;
  }

  .sm\\:even\\:pr-48:nth-child(even){
    padding-right: 12rem;
  }

  .sm\\:even\\:pb-48:nth-child(even){
    padding-bottom: 12rem;
  }

  .sm\\:even\\:pl-48:nth-child(even){
    padding-left: 12rem;
  }

  .sm\\:even\\:pt-52:nth-child(even){
    padding-top: 13rem;
  }

  .sm\\:even\\:pr-52:nth-child(even){
    padding-right: 13rem;
  }

  .sm\\:even\\:pb-52:nth-child(even){
    padding-bottom: 13rem;
  }

  .sm\\:even\\:pl-52:nth-child(even){
    padding-left: 13rem;
  }

  .sm\\:even\\:pt-54:nth-child(even){
    padding-top: 13.5rem;
  }

  .sm\\:even\\:pr-54:nth-child(even){
    padding-right: 13.5rem;
  }

  .sm\\:even\\:pb-54:nth-child(even){
    padding-bottom: 13.5rem;
  }

  .sm\\:even\\:pl-54:nth-child(even){
    padding-left: 13.5rem;
  }

  .sm\\:even\\:pt-56:nth-child(even){
    padding-top: 14rem;
  }

  .sm\\:even\\:pr-56:nth-child(even){
    padding-right: 14rem;
  }

  .sm\\:even\\:pb-56:nth-child(even){
    padding-bottom: 14rem;
  }

  .sm\\:even\\:pl-56:nth-child(even){
    padding-left: 14rem;
  }

  .sm\\:even\\:pt-60:nth-child(even){
    padding-top: 15rem;
  }

  .sm\\:even\\:pr-60:nth-child(even){
    padding-right: 15rem;
  }

  .sm\\:even\\:pb-60:nth-child(even){
    padding-bottom: 15rem;
  }

  .sm\\:even\\:pl-60:nth-child(even){
    padding-left: 15rem;
  }

  .sm\\:even\\:pt-64:nth-child(even){
    padding-top: 16rem;
  }

  .sm\\:even\\:pr-64:nth-child(even){
    padding-right: 16rem;
  }

  .sm\\:even\\:pb-64:nth-child(even){
    padding-bottom: 16rem;
  }

  .sm\\:even\\:pl-64:nth-child(even){
    padding-left: 16rem;
  }

  .sm\\:even\\:pt-68:nth-child(even){
    padding-top: 17rem;
  }

  .sm\\:even\\:pr-68:nth-child(even){
    padding-right: 17rem;
  }

  .sm\\:even\\:pb-68:nth-child(even){
    padding-bottom: 17rem;
  }

  .sm\\:even\\:pl-68:nth-child(even){
    padding-left: 17rem;
  }

  .sm\\:even\\:pt-72:nth-child(even){
    padding-top: 18rem;
  }

  .sm\\:even\\:pr-72:nth-child(even){
    padding-right: 18rem;
  }

  .sm\\:even\\:pb-72:nth-child(even){
    padding-bottom: 18rem;
  }

  .sm\\:even\\:pl-72:nth-child(even){
    padding-left: 18rem;
  }

  .sm\\:even\\:pt-74:nth-child(even){
    padding-top: 18.5rem;
  }

  .sm\\:even\\:pr-74:nth-child(even){
    padding-right: 18.5rem;
  }

  .sm\\:even\\:pb-74:nth-child(even){
    padding-bottom: 18.5rem;
  }

  .sm\\:even\\:pl-74:nth-child(even){
    padding-left: 18.5rem;
  }

  .sm\\:even\\:pt-76:nth-child(even){
    padding-top: 19rem;
  }

  .sm\\:even\\:pr-76:nth-child(even){
    padding-right: 19rem;
  }

  .sm\\:even\\:pb-76:nth-child(even){
    padding-bottom: 19rem;
  }

  .sm\\:even\\:pl-76:nth-child(even){
    padding-left: 19rem;
  }

  .sm\\:even\\:pt-78:nth-child(even){
    padding-top: 19.5rem;
  }

  .sm\\:even\\:pr-78:nth-child(even){
    padding-right: 19.5rem;
  }

  .sm\\:even\\:pb-78:nth-child(even){
    padding-bottom: 19.5rem;
  }

  .sm\\:even\\:pl-78:nth-child(even){
    padding-left: 19.5rem;
  }

  .sm\\:even\\:pt-80:nth-child(even){
    padding-top: 20rem;
  }

  .sm\\:even\\:pr-80:nth-child(even){
    padding-right: 20rem;
  }

  .sm\\:even\\:pb-80:nth-child(even){
    padding-bottom: 20rem;
  }

  .sm\\:even\\:pl-80:nth-child(even){
    padding-left: 20rem;
  }

  .sm\\:even\\:pt-82:nth-child(even){
    padding-top: 20.5rem;
  }

  .sm\\:even\\:pr-82:nth-child(even){
    padding-right: 20.5rem;
  }

  .sm\\:even\\:pb-82:nth-child(even){
    padding-bottom: 20.5rem;
  }

  .sm\\:even\\:pl-82:nth-child(even){
    padding-left: 20.5rem;
  }

  .sm\\:even\\:pt-84:nth-child(even){
    padding-top: 21rem;
  }

  .sm\\:even\\:pr-84:nth-child(even){
    padding-right: 21rem;
  }

  .sm\\:even\\:pb-84:nth-child(even){
    padding-bottom: 21rem;
  }

  .sm\\:even\\:pl-84:nth-child(even){
    padding-left: 21rem;
  }

  .sm\\:even\\:pt-88:nth-child(even){
    padding-top: 22rem;
  }

  .sm\\:even\\:pr-88:nth-child(even){
    padding-right: 22rem;
  }

  .sm\\:even\\:pb-88:nth-child(even){
    padding-bottom: 22rem;
  }

  .sm\\:even\\:pl-88:nth-child(even){
    padding-left: 22rem;
  }

  .sm\\:even\\:pt-92:nth-child(even){
    padding-top: 23rem;
  }

  .sm\\:even\\:pr-92:nth-child(even){
    padding-right: 23rem;
  }

  .sm\\:even\\:pb-92:nth-child(even){
    padding-bottom: 23rem;
  }

  .sm\\:even\\:pl-92:nth-child(even){
    padding-left: 23rem;
  }

  .sm\\:even\\:pt-96:nth-child(even){
    padding-top: 24rem;
  }

  .sm\\:even\\:pr-96:nth-child(even){
    padding-right: 24rem;
  }

  .sm\\:even\\:pb-96:nth-child(even){
    padding-bottom: 24rem;
  }

  .sm\\:even\\:pl-96:nth-child(even){
    padding-left: 24rem;
  }

  .sm\\:even\\:pt-98:nth-child(even){
    padding-top: 24.5rem;
  }

  .sm\\:even\\:pr-98:nth-child(even){
    padding-right: 24.5rem;
  }

  .sm\\:even\\:pb-98:nth-child(even){
    padding-bottom: 24.5rem;
  }

  .sm\\:even\\:pl-98:nth-child(even){
    padding-left: 24.5rem;
  }

  .sm\\:even\\:pt-100:nth-child(even){
    padding-top: 25rem;
  }

  .sm\\:even\\:pr-100:nth-child(even){
    padding-right: 25rem;
  }

  .sm\\:even\\:pb-100:nth-child(even){
    padding-bottom: 25rem;
  }

  .sm\\:even\\:pl-100:nth-child(even){
    padding-left: 25rem;
  }

  .sm\\:even\\:pt-104:nth-child(even){
    padding-top: 26rem;
  }

  .sm\\:even\\:pr-104:nth-child(even){
    padding-right: 26rem;
  }

  .sm\\:even\\:pb-104:nth-child(even){
    padding-bottom: 26rem;
  }

  .sm\\:even\\:pl-104:nth-child(even){
    padding-left: 26rem;
  }

  .sm\\:even\\:pt-112:nth-child(even){
    padding-top: 28rem;
  }

  .sm\\:even\\:pr-112:nth-child(even){
    padding-right: 28rem;
  }

  .sm\\:even\\:pb-112:nth-child(even){
    padding-bottom: 28rem;
  }

  .sm\\:even\\:pl-112:nth-child(even){
    padding-left: 28rem;
  }

  .sm\\:even\\:pt-124:nth-child(even){
    padding-top: 31rem;
  }

  .sm\\:even\\:pr-124:nth-child(even){
    padding-right: 31rem;
  }

  .sm\\:even\\:pb-124:nth-child(even){
    padding-bottom: 31rem;
  }

  .sm\\:even\\:pl-124:nth-child(even){
    padding-left: 31rem;
  }

  .sm\\:even\\:pt-128:nth-child(even){
    padding-top: 32rem;
  }

  .sm\\:even\\:pr-128:nth-child(even){
    padding-right: 32rem;
  }

  .sm\\:even\\:pb-128:nth-child(even){
    padding-bottom: 32rem;
  }

  .sm\\:even\\:pl-128:nth-child(even){
    padding-left: 32rem;
  }

  .sm\\:even\\:pt-140:nth-child(even){
    padding-top: 35rem;
  }

  .sm\\:even\\:pr-140:nth-child(even){
    padding-right: 35rem;
  }

  .sm\\:even\\:pb-140:nth-child(even){
    padding-bottom: 35rem;
  }

  .sm\\:even\\:pl-140:nth-child(even){
    padding-left: 35rem;
  }

  .sm\\:even\\:pt-152:nth-child(even){
    padding-top: 38rem;
  }

  .sm\\:even\\:pr-152:nth-child(even){
    padding-right: 38rem;
  }

  .sm\\:even\\:pb-152:nth-child(even){
    padding-bottom: 38rem;
  }

  .sm\\:even\\:pl-152:nth-child(even){
    padding-left: 38rem;
  }

  .sm\\:even\\:pt-160:nth-child(even){
    padding-top: 40rem;
  }

  .sm\\:even\\:pr-160:nth-child(even){
    padding-right: 40rem;
  }

  .sm\\:even\\:pb-160:nth-child(even){
    padding-bottom: 40rem;
  }

  .sm\\:even\\:pl-160:nth-child(even){
    padding-left: 40rem;
  }

  .sm\\:even\\:pt-162:nth-child(even){
    padding-top: 41rem;
  }

  .sm\\:even\\:pr-162:nth-child(even){
    padding-right: 41rem;
  }

  .sm\\:even\\:pb-162:nth-child(even){
    padding-bottom: 41rem;
  }

  .sm\\:even\\:pl-162:nth-child(even){
    padding-left: 41rem;
  }

  .sm\\:even\\:pt-192:nth-child(even){
    padding-top: 48rem;
  }

  .sm\\:even\\:pr-192:nth-child(even){
    padding-right: 48rem;
  }

  .sm\\:even\\:pb-192:nth-child(even){
    padding-bottom: 48rem;
  }

  .sm\\:even\\:pl-192:nth-child(even){
    padding-left: 48rem;
  }

  .sm\\:even\\:pt-208:nth-child(even){
    padding-top: 52rem;
  }

  .sm\\:even\\:pr-208:nth-child(even){
    padding-right: 52rem;
  }

  .sm\\:even\\:pb-208:nth-child(even){
    padding-bottom: 52rem;
  }

  .sm\\:even\\:pl-208:nth-child(even){
    padding-left: 52rem;
  }

  .sm\\:even\\:pt-224:nth-child(even){
    padding-top: 56rem;
  }

  .sm\\:even\\:pr-224:nth-child(even){
    padding-right: 56rem;
  }

  .sm\\:even\\:pb-224:nth-child(even){
    padding-bottom: 56rem;
  }

  .sm\\:even\\:pl-224:nth-child(even){
    padding-left: 56rem;
  }

  .sm\\:even\\:pt-256:nth-child(even){
    padding-top: 64rem;
  }

  .sm\\:even\\:pr-256:nth-child(even){
    padding-right: 64rem;
  }

  .sm\\:even\\:pb-256:nth-child(even){
    padding-bottom: 64rem;
  }

  .sm\\:even\\:pl-256:nth-child(even){
    padding-left: 64rem;
  }

  .sm\\:even\\:pt-px:nth-child(even){
    padding-top: 1px;
  }

  .sm\\:even\\:pr-px:nth-child(even){
    padding-right: 1px;
  }

  .sm\\:even\\:pb-px:nth-child(even){
    padding-bottom: 1px;
  }

  .sm\\:even\\:pl-px:nth-child(even){
    padding-left: 1px;
  }

  .sm\\:placeholder-transparent::placeholder{
    color: transparent;
  }

  .sm\\:placeholder-focus::placeholder{
    color: rgba(4, 21, 39, 0.8);;
  }

  .sm\\:placeholder-black::placeholder{
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .sm\\:placeholder-white::placeholder{
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .sm\\:placeholder-primary::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .sm\\:placeholder-disabled::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .sm\\:placeholder-translucent-60::placeholder{
    color: rgba(256, 256, 256, 0.6);
  }

  .sm\\:placeholder-translucent-90::placeholder{
    color: rgba(256, 256, 256, 0.9);
  }

  .sm\\:placeholder-green-200::placeholder{
    --placeholder-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, var(--placeholder-opacity));
  }

  .sm\\:placeholder-green-400::placeholder{
    --placeholder-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, var(--placeholder-opacity));
  }

  .sm\\:placeholder-green-500::placeholder{
    --placeholder-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, var(--placeholder-opacity));
  }

  .sm\\:placeholder-green-600::placeholder{
    --placeholder-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, var(--placeholder-opacity));
  }

  .sm\\:placeholder-green-700::placeholder{
    --placeholder-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, var(--placeholder-opacity));
  }

  .sm\\:placeholder-green-400a50::placeholder{
    color: rgba(108,202,152,0.50196);
  }

  .sm\\:placeholder-green-500a25::placeholder{
    color: rgba(151,232,18,0.09804);
  }

  .sm\\:placeholder-yellow-200::placeholder{
    --placeholder-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, var(--placeholder-opacity));
  }

  .sm\\:placeholder-yellow-300::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, var(--placeholder-opacity));
  }

  .sm\\:placeholder-yellow-500::placeholder{
    --placeholder-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, var(--placeholder-opacity));
  }

  .sm\\:placeholder-yellow-600::placeholder{
    --placeholder-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, var(--placeholder-opacity));
  }

  .sm\\:placeholder-yellow-700::placeholder{
    --placeholder-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, var(--placeholder-opacity));
  }

  .sm\\:placeholder-yellow-300a66::placeholder{
    color: rgba(255,233,189,0.66667);
  }

  .sm\\:placeholder-yellow-500a25::placeholder{
    color: rgba(255,200,44,0.09804);
  }

  .sm\\:placeholder-orange-200::placeholder{
    --placeholder-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, var(--placeholder-opacity));
  }

  .sm\\:placeholder-orange-400::placeholder{
    --placeholder-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, var(--placeholder-opacity));
  }

  .sm\\:placeholder-orange-500::placeholder{
    --placeholder-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, var(--placeholder-opacity));
  }

  .sm\\:placeholder-orange-800::placeholder{
    --placeholder-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, var(--placeholder-opacity));
  }

  .sm\\:placeholder-orange-900::placeholder{
    --placeholder-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, var(--placeholder-opacity));
  }

  .sm\\:placeholder-orange-500a25::placeholder{
    color: rgba(240,115,23,0.09804);
  }

  .sm\\:placeholder-red-100::placeholder{
    --placeholder-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, var(--placeholder-opacity));
  }

  .sm\\:placeholder-red-150::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, var(--placeholder-opacity));
  }

  .sm\\:placeholder-red-200::placeholder{
    --placeholder-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, var(--placeholder-opacity));
  }

  .sm\\:placeholder-red-300::placeholder{
    --placeholder-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, var(--placeholder-opacity));
  }

  .sm\\:placeholder-red-400::placeholder{
    --placeholder-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, var(--placeholder-opacity));
  }

  .sm\\:placeholder-red-500::placeholder{
    --placeholder-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, var(--placeholder-opacity));
  }

  .sm\\:placeholder-red-700::placeholder{
    --placeholder-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-50::placeholder{
    --placeholder-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-100::placeholder{
    --placeholder-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-150::placeholder{
    --placeholder-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-200::placeholder{
    --placeholder-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-300::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-400::placeholder{
    color: rgba(114,114,114,0.8);
  }

  .sm\\:placeholder-gray-425::placeholder{
    color: rgba(4, 21, 39, 0.8);
  }

  .sm\\:placeholder-gray-450::placeholder{
    --placeholder-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-500::placeholder{
    --placeholder-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-600::placeholder{
    --placeholder-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-625::placeholder{
    color: rgba(90,98,107,0.8);
  }

  .sm\\:placeholder-gray-700::placeholder{
    --placeholder-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-800::placeholder{
    --placeholder-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, var(--placeholder-opacity));
  }

  .sm\\:placeholder-gray-200a50::placeholder{
    color: rgba(224, 226, 228, 0.5);
  }

  .sm\\:placeholder-blue-50::placeholder{
    --placeholder-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-100::placeholder{
    --placeholder-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-150::placeholder{
    --placeholder-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-200::placeholder{
    --placeholder-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-300::placeholder{
    --placeholder-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-400::placeholder{
    --placeholder-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-500::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-600::placeholder{
    --placeholder-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-700::placeholder{
    --placeholder-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-750::placeholder{
    --placeholder-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-800::placeholder{
    --placeholder-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-900::placeholder{
    --placeholder-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-950::placeholder{
    --placeholder-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-500a25::placeholder{
    color: rgba(55, 164, 220, 0.2);
  }

  .sm\\:placeholder-blue-500a50::placeholder{
    color: rgba(55, 164, 220, 0.5);
  }

  .sm\\:placeholder-blue-700a75::placeholder{
    --placeholder-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-700a30::placeholder{
    --placeholder-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, var(--placeholder-opacity));
  }

  .sm\\:placeholder-blue-750a25::placeholder{
    color: rgba(86,130,170,0.09804);
  }

  .sm\\:placeholder-blue-750a15::placeholder{
    color: rgba(86,130,170,0.05882);
  }

  .sm\\:placeholder-blue-800a60::placeholder{
    color: rgba(31, 69, 102, 0.6);
  }

  .sm\\:placeholder-programEditorTabColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, var(--placeholder-opacity));
  }

  .sm\\:placeholder-programEditorTabColors-2::placeholder{
    --placeholder-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, var(--placeholder-opacity));
  }

  .sm\\:placeholder-programEditorTabColors-3::placeholder{
    --placeholder-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, var(--placeholder-opacity));
  }

  .sm\\:placeholder-programEditorTabColors-4::placeholder{
    --placeholder-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, var(--placeholder-opacity));
  }

  .sm\\:placeholder-programEditorTabColors-5::placeholder{
    --placeholder-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, var(--placeholder-opacity));
  }

  .sm\\:placeholder-programEditorTabColors-6::placeholder{
    --placeholder-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, var(--placeholder-opacity));
  }

  .sm\\:placeholder-programEditorTabColors-1h::placeholder{
    --placeholder-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, var(--placeholder-opacity));
  }

  .sm\\:placeholder-programEditorTabColors-2h::placeholder{
    --placeholder-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, var(--placeholder-opacity));
  }

  .sm\\:placeholder-programEditorTabColors-3h::placeholder{
    --placeholder-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, var(--placeholder-opacity));
  }

  .sm\\:placeholder-programEditorTabColors-4h::placeholder{
    --placeholder-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, var(--placeholder-opacity));
  }

  .sm\\:placeholder-programEditorTabColors-5h::placeholder{
    --placeholder-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, var(--placeholder-opacity));
  }

  .sm\\:placeholder-programEditorTabColors-6h::placeholder{
    --placeholder-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, var(--placeholder-opacity));
  }

  .sm\\:placeholder-programEditorPresetTabColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .sm\\:placeholder-programEditorPresetTabColors-1h::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .sm\\:placeholder-borgScaleColors-0::placeholder{
    --placeholder-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, var(--placeholder-opacity));
  }

  .sm\\:placeholder-borgScaleColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, var(--placeholder-opacity));
  }

  .sm\\:placeholder-borgScaleColors-2::placeholder{
    --placeholder-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, var(--placeholder-opacity));
  }

  .sm\\:placeholder-borgScaleColors-3::placeholder{
    --placeholder-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, var(--placeholder-opacity));
  }

  .sm\\:placeholder-borgScaleColors-4::placeholder{
    --placeholder-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .sm\\:placeholder-borgScaleColors-5::placeholder{
    --placeholder-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, var(--placeholder-opacity));
  }

  .sm\\:placeholder-borgScaleColors-6::placeholder{
    --placeholder-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, var(--placeholder-opacity));
  }

  .sm\\:placeholder-borgScaleColors-7::placeholder{
    --placeholder-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, var(--placeholder-opacity));
  }

  .sm\\:placeholder-borgScaleColors-8::placeholder{
    --placeholder-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, var(--placeholder-opacity));
  }

  .sm\\:placeholder-borgScaleColors-9::placeholder{
    --placeholder-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, var(--placeholder-opacity));
  }

  .sm\\:placeholder-borgScaleColors-10::placeholder{
    --placeholder-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-transparent:focus::placeholder{
    color: transparent;
  }

  .sm\\:focus\\:placeholder-focus:focus::placeholder{
    color: rgba(4, 21, 39, 0.8);;
  }

  .sm\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-primary:focus::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-disabled:focus::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-translucent-60:focus::placeholder{
    color: rgba(256, 256, 256, 0.6);
  }

  .sm\\:focus\\:placeholder-translucent-90:focus::placeholder{
    color: rgba(256, 256, 256, 0.9);
  }

  .sm\\:focus\\:placeholder-green-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-green-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-green-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-green-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-green-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-green-400a50:focus::placeholder{
    color: rgba(108,202,152,0.50196);
  }

  .sm\\:focus\\:placeholder-green-500a25:focus::placeholder{
    color: rgba(151,232,18,0.09804);
  }

  .sm\\:focus\\:placeholder-yellow-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-yellow-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-yellow-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-yellow-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-yellow-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-yellow-300a66:focus::placeholder{
    color: rgba(255,233,189,0.66667);
  }

  .sm\\:focus\\:placeholder-yellow-500a25:focus::placeholder{
    color: rgba(255,200,44,0.09804);
  }

  .sm\\:focus\\:placeholder-orange-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-orange-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-orange-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-orange-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-orange-900:focus::placeholder{
    --placeholder-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-orange-500a25:focus::placeholder{
    color: rgba(240,115,23,0.09804);
  }

  .sm\\:focus\\:placeholder-red-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-red-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-red-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-red-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-red-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-red-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-red-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-50:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-400:focus::placeholder{
    color: rgba(114,114,114,0.8);
  }

  .sm\\:focus\\:placeholder-gray-425:focus::placeholder{
    color: rgba(4, 21, 39, 0.8);
  }

  .sm\\:focus\\:placeholder-gray-450:focus::placeholder{
    --placeholder-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-625:focus::placeholder{
    color: rgba(90,98,107,0.8);
  }

  .sm\\:focus\\:placeholder-gray-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-gray-200a50:focus::placeholder{
    color: rgba(224, 226, 228, 0.5);
  }

  .sm\\:focus\\:placeholder-blue-50:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-750:focus::placeholder{
    --placeholder-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-900:focus::placeholder{
    --placeholder-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-950:focus::placeholder{
    --placeholder-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-500a25:focus::placeholder{
    color: rgba(55, 164, 220, 0.2);
  }

  .sm\\:focus\\:placeholder-blue-500a50:focus::placeholder{
    color: rgba(55, 164, 220, 0.5);
  }

  .sm\\:focus\\:placeholder-blue-700a75:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-700a30:focus::placeholder{
    --placeholder-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-blue-750a25:focus::placeholder{
    color: rgba(86,130,170,0.09804);
  }

  .sm\\:focus\\:placeholder-blue-750a15:focus::placeholder{
    color: rgba(86,130,170,0.05882);
  }

  .sm\\:focus\\:placeholder-blue-800a60:focus::placeholder{
    color: rgba(31, 69, 102, 0.6);
  }

  .sm\\:focus\\:placeholder-programEditorTabColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-programEditorTabColors-2:focus::placeholder{
    --placeholder-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-programEditorTabColors-3:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-programEditorTabColors-4:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-programEditorTabColors-5:focus::placeholder{
    --placeholder-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-programEditorTabColors-6:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-programEditorTabColors-1h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-programEditorTabColors-2h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-programEditorTabColors-3h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-programEditorTabColors-4h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-programEditorTabColors-5h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-programEditorTabColors-6h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-programEditorPresetTabColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-programEditorPresetTabColors-1h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-borgScaleColors-0:focus::placeholder{
    --placeholder-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-borgScaleColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-borgScaleColors-2:focus::placeholder{
    --placeholder-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-borgScaleColors-3:focus::placeholder{
    --placeholder-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-borgScaleColors-4:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-borgScaleColors-5:focus::placeholder{
    --placeholder-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-borgScaleColors-6:focus::placeholder{
    --placeholder-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-borgScaleColors-7:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-borgScaleColors-8:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-borgScaleColors-9:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, var(--placeholder-opacity));
  }

  .sm\\:focus\\:placeholder-borgScaleColors-10:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, var(--placeholder-opacity));
  }

  .sm\\:placeholder-opacity-0::placeholder{
    --placeholder-opacity: 0;
  }

  .sm\\:placeholder-opacity-25::placeholder{
    --placeholder-opacity: .25;
  }

  .sm\\:placeholder-opacity-50::placeholder{
    --placeholder-opacity: .5;
  }

  .sm\\:placeholder-opacity-75::placeholder{
    --placeholder-opacity: .75;
  }

  .sm\\:placeholder-opacity-100::placeholder{
    --placeholder-opacity: 1;
  }

  .sm\\:focus\\:placeholder-opacity-0:focus::placeholder{
    --placeholder-opacity: 0;
  }

  .sm\\:focus\\:placeholder-opacity-25:focus::placeholder{
    --placeholder-opacity: .25;
  }

  .sm\\:focus\\:placeholder-opacity-50:focus::placeholder{
    --placeholder-opacity: .5;
  }

  .sm\\:focus\\:placeholder-opacity-75:focus::placeholder{
    --placeholder-opacity: .75;
  }

  .sm\\:focus\\:placeholder-opacity-100:focus::placeholder{
    --placeholder-opacity: 1;
  }

  .sm\\:pointer-events-none{
    pointer-events: none;
  }

  .sm\\:pointer-events-auto{
    pointer-events: auto;
  }

  .sm\\:static{
    position: static;
  }

  .sm\\:fixed{
    position: fixed;
  }

  .sm\\:absolute{
    position: absolute;
  }

  .sm\\:relative{
    position: relative;
  }

  .sm\\:sticky{
    position: sticky;
  }

  .sm\\:inset-0{
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .sm\\:inset-auto{
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }

  .sm\\:inset-y-0{
    top: 0;
    bottom: 0;
  }

  .sm\\:inset-x-0{
    right: 0;
    left: 0;
  }

  .sm\\:inset-y-auto{
    top: auto;
    bottom: auto;
  }

  .sm\\:inset-x-auto{
    right: auto;
    left: auto;
  }

  .sm\\:top-0{
    top: 0;
  }

  .sm\\:right-0{
    right: 0;
  }

  .sm\\:bottom-0{
    bottom: 0;
  }

  .sm\\:left-0{
    left: 0;
  }

  .sm\\:top-auto{
    top: auto;
  }

  .sm\\:right-auto{
    right: auto;
  }

  .sm\\:bottom-auto{
    bottom: auto;
  }

  .sm\\:left-auto{
    left: auto;
  }

  .sm\\:resize-none{
    resize: none;
  }

  .sm\\:resize-y{
    resize: vertical;
  }

  .sm\\:resize-x{
    resize: horizontal;
  }

  .sm\\:resize{
    resize: both;
  }

  .sm\\:shadow{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .sm\\:shadow-overlaptop{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .sm\\:shadow-overlapbottom{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .sm\\:shadow-xs{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .sm\\:shadow-sm{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .sm\\:shadow-md{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .sm\\:shadow-lg{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .sm\\:shadow-xl{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .sm\\:shadow-2xl{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .sm\\:shadow-none{
    box-shadow: none;
  }

  .sm\\:hover\\:shadow:hover{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .sm\\:hover\\:shadow-overlaptop:hover{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .sm\\:hover\\:shadow-overlapbottom:hover{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .sm\\:hover\\:shadow-xs:hover{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .sm\\:hover\\:shadow-sm:hover{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .sm\\:hover\\:shadow-md:hover{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .sm\\:hover\\:shadow-lg:hover{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .sm\\:hover\\:shadow-xl:hover{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .sm\\:hover\\:shadow-2xl:hover{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .sm\\:hover\\:shadow-none:hover{
    box-shadow: none;
  }

  .sm\\:focus\\:shadow:focus{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .sm\\:focus\\:shadow-overlaptop:focus{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .sm\\:focus\\:shadow-overlapbottom:focus{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .sm\\:focus\\:shadow-xs:focus{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .sm\\:focus\\:shadow-sm:focus{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .sm\\:focus\\:shadow-md:focus{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .sm\\:focus\\:shadow-lg:focus{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .sm\\:focus\\:shadow-xl:focus{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .sm\\:focus\\:shadow-2xl:focus{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .sm\\:focus\\:shadow-none:focus{
    box-shadow: none;
  }

  .sm\\:stroke-0{
    stroke-width: 0;
  }

  .sm\\:stroke-1{
    stroke-width: 1;
  }

  .sm\\:stroke-2{
    stroke-width: 2;
  }

  .sm\\:table-auto{
    table-layout: auto;
  }

  .sm\\:table-fixed{
    table-layout: fixed;
  }

  .sm\\:text-left{
    text-align: left;
  }

  .sm\\:text-center{
    text-align: center;
  }

  .sm\\:text-right{
    text-align: right;
  }

  .sm\\:text-justify{
    text-align: justify;
  }

  .sm\\:text-transparent{
    color: transparent;
  }

  .sm\\:text-focus{
    color: rgba(4, 21, 39, 0.8);;
  }

  .sm\\:text-black{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .sm\\:text-white{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .sm\\:text-primary{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .sm\\:text-disabled{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .sm\\:text-translucent-60{
    color: rgba(256, 256, 256, 0.6);
  }

  .sm\\:text-translucent-90{
    color: rgba(256, 256, 256, 0.9);
  }

  .sm\\:text-green-200{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .sm\\:text-green-400{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .sm\\:text-green-500{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .sm\\:text-green-600{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .sm\\:text-green-700{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .sm\\:text-green-400a50{
    color: rgba(108,202,152,0.50196);
  }

  .sm\\:text-green-500a25{
    color: rgba(151,232,18,0.09804);
  }

  .sm\\:text-yellow-200{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .sm\\:text-yellow-300{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .sm\\:text-yellow-500{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .sm\\:text-yellow-600{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .sm\\:text-yellow-700{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .sm\\:text-yellow-300a66{
    color: rgba(255,233,189,0.66667);
  }

  .sm\\:text-yellow-500a25{
    color: rgba(255,200,44,0.09804);
  }

  .sm\\:text-orange-200{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .sm\\:text-orange-400{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .sm\\:text-orange-500{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .sm\\:text-orange-800{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .sm\\:text-orange-900{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .sm\\:text-orange-500a25{
    color: rgba(240,115,23,0.09804);
  }

  .sm\\:text-red-100{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .sm\\:text-red-150{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .sm\\:text-red-200{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .sm\\:text-red-300{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .sm\\:text-red-400{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .sm\\:text-red-500{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .sm\\:text-red-700{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .sm\\:text-gray-50{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .sm\\:text-gray-100{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .sm\\:text-gray-150{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .sm\\:text-gray-200{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .sm\\:text-gray-300{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .sm\\:text-gray-400{
    color: rgba(114,114,114,0.8);
  }

  .sm\\:text-gray-425{
    color: rgba(4, 21, 39, 0.8);
  }

  .sm\\:text-gray-450{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .sm\\:text-gray-500{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .sm\\:text-gray-600{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .sm\\:text-gray-625{
    color: rgba(90,98,107,0.8);
  }

  .sm\\:text-gray-700{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .sm\\:text-gray-800{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .sm\\:text-gray-200a50{
    color: rgba(224, 226, 228, 0.5);
  }

  .sm\\:text-blue-50{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .sm\\:text-blue-100{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .sm\\:text-blue-150{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .sm\\:text-blue-200{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .sm\\:text-blue-300{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .sm\\:text-blue-400{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .sm\\:text-blue-500{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .sm\\:text-blue-600{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .sm\\:text-blue-700{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .sm\\:text-blue-750{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .sm\\:text-blue-800{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .sm\\:text-blue-900{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .sm\\:text-blue-950{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .sm\\:text-blue-500a25{
    color: rgba(55, 164, 220, 0.2);
  }

  .sm\\:text-blue-500a50{
    color: rgba(55, 164, 220, 0.5);
  }

  .sm\\:text-blue-700a75{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .sm\\:text-blue-700a30{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .sm\\:text-blue-750a25{
    color: rgba(86,130,170,0.09804);
  }

  .sm\\:text-blue-750a15{
    color: rgba(86,130,170,0.05882);
  }

  .sm\\:text-blue-800a60{
    color: rgba(31, 69, 102, 0.6);
  }

  .sm\\:text-programEditorTabColors-1{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .sm\\:text-programEditorTabColors-2{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .sm\\:text-programEditorTabColors-3{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .sm\\:text-programEditorTabColors-4{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .sm\\:text-programEditorTabColors-5{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .sm\\:text-programEditorTabColors-6{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .sm\\:text-programEditorTabColors-1h{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .sm\\:text-programEditorTabColors-2h{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .sm\\:text-programEditorTabColors-3h{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .sm\\:text-programEditorTabColors-4h{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .sm\\:text-programEditorTabColors-5h{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .sm\\:text-programEditorTabColors-6h{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .sm\\:text-programEditorPresetTabColors-1{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .sm\\:text-programEditorPresetTabColors-1h{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .sm\\:text-borgScaleColors-0{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .sm\\:text-borgScaleColors-1{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .sm\\:text-borgScaleColors-2{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .sm\\:text-borgScaleColors-3{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .sm\\:text-borgScaleColors-4{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .sm\\:text-borgScaleColors-5{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .sm\\:text-borgScaleColors-6{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .sm\\:text-borgScaleColors-7{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .sm\\:text-borgScaleColors-8{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .sm\\:text-borgScaleColors-9{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .sm\\:text-borgScaleColors-10{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .sm\\:hover\\:text-transparent:hover{
    color: transparent;
  }

  .sm\\:hover\\:text-focus:hover{
    color: rgba(4, 21, 39, 0.8);;
  }

  .sm\\:hover\\:text-black:hover{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .sm\\:hover\\:text-white:hover{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .sm\\:hover\\:text-primary:hover{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .sm\\:hover\\:text-disabled:hover{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .sm\\:hover\\:text-translucent-60:hover{
    color: rgba(256, 256, 256, 0.6);
  }

  .sm\\:hover\\:text-translucent-90:hover{
    color: rgba(256, 256, 256, 0.9);
  }

  .sm\\:hover\\:text-green-200:hover{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .sm\\:hover\\:text-green-400:hover{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .sm\\:hover\\:text-green-500:hover{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .sm\\:hover\\:text-green-600:hover{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .sm\\:hover\\:text-green-700:hover{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .sm\\:hover\\:text-green-400a50:hover{
    color: rgba(108,202,152,0.50196);
  }

  .sm\\:hover\\:text-green-500a25:hover{
    color: rgba(151,232,18,0.09804);
  }

  .sm\\:hover\\:text-yellow-200:hover{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .sm\\:hover\\:text-yellow-300:hover{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .sm\\:hover\\:text-yellow-500:hover{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .sm\\:hover\\:text-yellow-600:hover{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .sm\\:hover\\:text-yellow-700:hover{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .sm\\:hover\\:text-yellow-300a66:hover{
    color: rgba(255,233,189,0.66667);
  }

  .sm\\:hover\\:text-yellow-500a25:hover{
    color: rgba(255,200,44,0.09804);
  }

  .sm\\:hover\\:text-orange-200:hover{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .sm\\:hover\\:text-orange-400:hover{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .sm\\:hover\\:text-orange-500:hover{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .sm\\:hover\\:text-orange-800:hover{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .sm\\:hover\\:text-orange-900:hover{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .sm\\:hover\\:text-orange-500a25:hover{
    color: rgba(240,115,23,0.09804);
  }

  .sm\\:hover\\:text-red-100:hover{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .sm\\:hover\\:text-red-150:hover{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .sm\\:hover\\:text-red-200:hover{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .sm\\:hover\\:text-red-300:hover{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .sm\\:hover\\:text-red-400:hover{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .sm\\:hover\\:text-red-500:hover{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .sm\\:hover\\:text-red-700:hover{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .sm\\:hover\\:text-gray-50:hover{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .sm\\:hover\\:text-gray-100:hover{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .sm\\:hover\\:text-gray-150:hover{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .sm\\:hover\\:text-gray-200:hover{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .sm\\:hover\\:text-gray-300:hover{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .sm\\:hover\\:text-gray-400:hover{
    color: rgba(114,114,114,0.8);
  }

  .sm\\:hover\\:text-gray-425:hover{
    color: rgba(4, 21, 39, 0.8);
  }

  .sm\\:hover\\:text-gray-450:hover{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .sm\\:hover\\:text-gray-500:hover{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .sm\\:hover\\:text-gray-600:hover{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .sm\\:hover\\:text-gray-625:hover{
    color: rgba(90,98,107,0.8);
  }

  .sm\\:hover\\:text-gray-700:hover{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .sm\\:hover\\:text-gray-800:hover{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .sm\\:hover\\:text-gray-200a50:hover{
    color: rgba(224, 226, 228, 0.5);
  }

  .sm\\:hover\\:text-blue-50:hover{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .sm\\:hover\\:text-blue-100:hover{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .sm\\:hover\\:text-blue-150:hover{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .sm\\:hover\\:text-blue-200:hover{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .sm\\:hover\\:text-blue-300:hover{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .sm\\:hover\\:text-blue-400:hover{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .sm\\:hover\\:text-blue-500:hover{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .sm\\:hover\\:text-blue-600:hover{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .sm\\:hover\\:text-blue-700:hover{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .sm\\:hover\\:text-blue-750:hover{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .sm\\:hover\\:text-blue-800:hover{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .sm\\:hover\\:text-blue-900:hover{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .sm\\:hover\\:text-blue-950:hover{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .sm\\:hover\\:text-blue-500a25:hover{
    color: rgba(55, 164, 220, 0.2);
  }

  .sm\\:hover\\:text-blue-500a50:hover{
    color: rgba(55, 164, 220, 0.5);
  }

  .sm\\:hover\\:text-blue-700a75:hover{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .sm\\:hover\\:text-blue-700a30:hover{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .sm\\:hover\\:text-blue-750a25:hover{
    color: rgba(86,130,170,0.09804);
  }

  .sm\\:hover\\:text-blue-750a15:hover{
    color: rgba(86,130,170,0.05882);
  }

  .sm\\:hover\\:text-blue-800a60:hover{
    color: rgba(31, 69, 102, 0.6);
  }

  .sm\\:hover\\:text-programEditorTabColors-1:hover{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .sm\\:hover\\:text-programEditorTabColors-2:hover{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .sm\\:hover\\:text-programEditorTabColors-3:hover{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .sm\\:hover\\:text-programEditorTabColors-4:hover{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .sm\\:hover\\:text-programEditorTabColors-5:hover{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .sm\\:hover\\:text-programEditorTabColors-6:hover{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .sm\\:hover\\:text-programEditorTabColors-1h:hover{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .sm\\:hover\\:text-programEditorTabColors-2h:hover{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .sm\\:hover\\:text-programEditorTabColors-3h:hover{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .sm\\:hover\\:text-programEditorTabColors-4h:hover{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .sm\\:hover\\:text-programEditorTabColors-5h:hover{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .sm\\:hover\\:text-programEditorTabColors-6h:hover{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .sm\\:hover\\:text-programEditorPresetTabColors-1:hover{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .sm\\:hover\\:text-programEditorPresetTabColors-1h:hover{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .sm\\:hover\\:text-borgScaleColors-0:hover{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .sm\\:hover\\:text-borgScaleColors-1:hover{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .sm\\:hover\\:text-borgScaleColors-2:hover{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .sm\\:hover\\:text-borgScaleColors-3:hover{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .sm\\:hover\\:text-borgScaleColors-4:hover{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .sm\\:hover\\:text-borgScaleColors-5:hover{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .sm\\:hover\\:text-borgScaleColors-6:hover{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .sm\\:hover\\:text-borgScaleColors-7:hover{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .sm\\:hover\\:text-borgScaleColors-8:hover{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .sm\\:hover\\:text-borgScaleColors-9:hover{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .sm\\:hover\\:text-borgScaleColors-10:hover{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .sm\\:focus\\:text-transparent:focus{
    color: transparent;
  }

  .sm\\:focus\\:text-focus:focus{
    color: rgba(4, 21, 39, 0.8);;
  }

  .sm\\:focus\\:text-black:focus{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .sm\\:focus\\:text-white:focus{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .sm\\:focus\\:text-primary:focus{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .sm\\:focus\\:text-disabled:focus{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .sm\\:focus\\:text-translucent-60:focus{
    color: rgba(256, 256, 256, 0.6);
  }

  .sm\\:focus\\:text-translucent-90:focus{
    color: rgba(256, 256, 256, 0.9);
  }

  .sm\\:focus\\:text-green-200:focus{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .sm\\:focus\\:text-green-400:focus{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .sm\\:focus\\:text-green-500:focus{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .sm\\:focus\\:text-green-600:focus{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .sm\\:focus\\:text-green-700:focus{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .sm\\:focus\\:text-green-400a50:focus{
    color: rgba(108,202,152,0.50196);
  }

  .sm\\:focus\\:text-green-500a25:focus{
    color: rgba(151,232,18,0.09804);
  }

  .sm\\:focus\\:text-yellow-200:focus{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .sm\\:focus\\:text-yellow-300:focus{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .sm\\:focus\\:text-yellow-500:focus{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .sm\\:focus\\:text-yellow-600:focus{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .sm\\:focus\\:text-yellow-700:focus{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .sm\\:focus\\:text-yellow-300a66:focus{
    color: rgba(255,233,189,0.66667);
  }

  .sm\\:focus\\:text-yellow-500a25:focus{
    color: rgba(255,200,44,0.09804);
  }

  .sm\\:focus\\:text-orange-200:focus{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .sm\\:focus\\:text-orange-400:focus{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .sm\\:focus\\:text-orange-500:focus{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .sm\\:focus\\:text-orange-800:focus{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .sm\\:focus\\:text-orange-900:focus{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .sm\\:focus\\:text-orange-500a25:focus{
    color: rgba(240,115,23,0.09804);
  }

  .sm\\:focus\\:text-red-100:focus{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .sm\\:focus\\:text-red-150:focus{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .sm\\:focus\\:text-red-200:focus{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .sm\\:focus\\:text-red-300:focus{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .sm\\:focus\\:text-red-400:focus{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .sm\\:focus\\:text-red-500:focus{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .sm\\:focus\\:text-red-700:focus{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .sm\\:focus\\:text-gray-50:focus{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .sm\\:focus\\:text-gray-100:focus{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .sm\\:focus\\:text-gray-150:focus{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .sm\\:focus\\:text-gray-200:focus{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .sm\\:focus\\:text-gray-300:focus{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .sm\\:focus\\:text-gray-400:focus{
    color: rgba(114,114,114,0.8);
  }

  .sm\\:focus\\:text-gray-425:focus{
    color: rgba(4, 21, 39, 0.8);
  }

  .sm\\:focus\\:text-gray-450:focus{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .sm\\:focus\\:text-gray-500:focus{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .sm\\:focus\\:text-gray-600:focus{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .sm\\:focus\\:text-gray-625:focus{
    color: rgba(90,98,107,0.8);
  }

  .sm\\:focus\\:text-gray-700:focus{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .sm\\:focus\\:text-gray-800:focus{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .sm\\:focus\\:text-gray-200a50:focus{
    color: rgba(224, 226, 228, 0.5);
  }

  .sm\\:focus\\:text-blue-50:focus{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .sm\\:focus\\:text-blue-100:focus{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .sm\\:focus\\:text-blue-150:focus{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .sm\\:focus\\:text-blue-200:focus{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .sm\\:focus\\:text-blue-300:focus{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .sm\\:focus\\:text-blue-400:focus{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .sm\\:focus\\:text-blue-500:focus{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .sm\\:focus\\:text-blue-600:focus{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .sm\\:focus\\:text-blue-700:focus{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .sm\\:focus\\:text-blue-750:focus{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .sm\\:focus\\:text-blue-800:focus{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .sm\\:focus\\:text-blue-900:focus{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .sm\\:focus\\:text-blue-950:focus{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .sm\\:focus\\:text-blue-500a25:focus{
    color: rgba(55, 164, 220, 0.2);
  }

  .sm\\:focus\\:text-blue-500a50:focus{
    color: rgba(55, 164, 220, 0.5);
  }

  .sm\\:focus\\:text-blue-700a75:focus{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .sm\\:focus\\:text-blue-700a30:focus{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .sm\\:focus\\:text-blue-750a25:focus{
    color: rgba(86,130,170,0.09804);
  }

  .sm\\:focus\\:text-blue-750a15:focus{
    color: rgba(86,130,170,0.05882);
  }

  .sm\\:focus\\:text-blue-800a60:focus{
    color: rgba(31, 69, 102, 0.6);
  }

  .sm\\:focus\\:text-programEditorTabColors-1:focus{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .sm\\:focus\\:text-programEditorTabColors-2:focus{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .sm\\:focus\\:text-programEditorTabColors-3:focus{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .sm\\:focus\\:text-programEditorTabColors-4:focus{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .sm\\:focus\\:text-programEditorTabColors-5:focus{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .sm\\:focus\\:text-programEditorTabColors-6:focus{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .sm\\:focus\\:text-programEditorTabColors-1h:focus{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .sm\\:focus\\:text-programEditorTabColors-2h:focus{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .sm\\:focus\\:text-programEditorTabColors-3h:focus{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .sm\\:focus\\:text-programEditorTabColors-4h:focus{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .sm\\:focus\\:text-programEditorTabColors-5h:focus{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .sm\\:focus\\:text-programEditorTabColors-6h:focus{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .sm\\:focus\\:text-programEditorPresetTabColors-1:focus{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .sm\\:focus\\:text-programEditorPresetTabColors-1h:focus{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .sm\\:focus\\:text-borgScaleColors-0:focus{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .sm\\:focus\\:text-borgScaleColors-1:focus{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .sm\\:focus\\:text-borgScaleColors-2:focus{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .sm\\:focus\\:text-borgScaleColors-3:focus{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .sm\\:focus\\:text-borgScaleColors-4:focus{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .sm\\:focus\\:text-borgScaleColors-5:focus{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .sm\\:focus\\:text-borgScaleColors-6:focus{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .sm\\:focus\\:text-borgScaleColors-7:focus{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .sm\\:focus\\:text-borgScaleColors-8:focus{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .sm\\:focus\\:text-borgScaleColors-9:focus{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .sm\\:focus\\:text-borgScaleColors-10:focus{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .sm\\:text-opacity-0{
    --text-opacity: 0;
  }

  .sm\\:text-opacity-25{
    --text-opacity: .25;
  }

  .sm\\:text-opacity-50{
    --text-opacity: .5;
  }

  .sm\\:text-opacity-75{
    --text-opacity: .75;
  }

  .sm\\:text-opacity-100{
    --text-opacity: 1;
  }

  .sm\\:hover\\:text-opacity-0:hover{
    --text-opacity: 0;
  }

  .sm\\:hover\\:text-opacity-25:hover{
    --text-opacity: .25;
  }

  .sm\\:hover\\:text-opacity-50:hover{
    --text-opacity: .5;
  }

  .sm\\:hover\\:text-opacity-75:hover{
    --text-opacity: .75;
  }

  .sm\\:hover\\:text-opacity-100:hover{
    --text-opacity: 1;
  }

  .sm\\:focus\\:text-opacity-0:focus{
    --text-opacity: 0;
  }

  .sm\\:focus\\:text-opacity-25:focus{
    --text-opacity: .25;
  }

  .sm\\:focus\\:text-opacity-50:focus{
    --text-opacity: .5;
  }

  .sm\\:focus\\:text-opacity-75:focus{
    --text-opacity: .75;
  }

  .sm\\:focus\\:text-opacity-100:focus{
    --text-opacity: 1;
  }

  .sm\\:italic{
    font-style: italic;
  }

  .sm\\:not-italic{
    font-style: normal;
  }

  .sm\\:uppercase{
    text-transform: uppercase;
  }

  .sm\\:lowercase{
    text-transform: lowercase;
  }

  .sm\\:capitalize{
    text-transform: capitalize;
  }

  .sm\\:normal-case{
    text-transform: none;
  }

  .sm\\:underline{
    text-decoration: underline;
  }

  .sm\\:line-through{
    text-decoration: line-through;
  }

  .sm\\:no-underline{
    text-decoration: none;
  }

  .sm\\:hover\\:underline:hover{
    text-decoration: underline;
  }

  .sm\\:hover\\:line-through:hover{
    text-decoration: line-through;
  }

  .sm\\:hover\\:no-underline:hover{
    text-decoration: none;
  }

  .sm\\:focus\\:underline:focus{
    text-decoration: underline;
  }

  .sm\\:focus\\:line-through:focus{
    text-decoration: line-through;
  }

  .sm\\:focus\\:no-underline:focus{
    text-decoration: none;
  }

  .sm\\:antialiased{
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .sm\\:subpixel-antialiased{
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }

  .sm\\:ordinal, .sm\\:slashed-zero, .sm\\:lining-nums, .sm\\:oldstyle-nums, .sm\\:proportional-nums, .sm\\:tabular-nums, .sm\\:diagonal-fractions, .sm\\:stacked-fractions{
    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);
    font-feature-settings: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
  }

  .sm\\:normal-nums{
    font-feature-settings: normal;
    font-variant-numeric: normal;
  }

  .sm\\:ordinal{
    --font-variant-numeric-ordinal: ordinal;
  }

  .sm\\:slashed-zero{
    --font-variant-numeric-slashed-zero: slashed-zero;
  }

  .sm\\:lining-nums{
    --font-variant-numeric-figure: lining-nums;
  }

  .sm\\:oldstyle-nums{
    --font-variant-numeric-figure: oldstyle-nums;
  }

  .sm\\:proportional-nums{
    --font-variant-numeric-spacing: proportional-nums;
  }

  .sm\\:tabular-nums{
    --font-variant-numeric-spacing: tabular-nums;
  }

  .sm\\:diagonal-fractions{
    --font-variant-numeric-fraction: diagonal-fractions;
  }

  .sm\\:stacked-fractions{
    --font-variant-numeric-fraction: stacked-fractions;
  }

  .sm\\:tracking-tight{
    letter-spacing: -0.025em;
  }

  .sm\\:tracking-normal{
    letter-spacing: 0;
  }

  .sm\\:tracking-wide{
    letter-spacing: 0.01em;
  }

  .sm\\:tracking-wider{
    letter-spacing: 0.02em;
  }

  .sm\\:tracking-widest{
    letter-spacing: 0.05em;
  }

  .sm\\:select-none{
    -webkit-user-select: none;
            user-select: none;
  }

  .sm\\:select-text{
    -webkit-user-select: text;
            user-select: text;
  }

  .sm\\:select-all{
    -webkit-user-select: all;
            user-select: all;
  }

  .sm\\:select-auto{
    -webkit-user-select: auto;
            user-select: auto;
  }

  .sm\\:align-baseline{
    vertical-align: baseline;
  }

  .sm\\:align-top{
    vertical-align: top;
  }

  .sm\\:align-middle{
    vertical-align: middle;
  }

  .sm\\:align-bottom{
    vertical-align: bottom;
  }

  .sm\\:align-text-top{
    vertical-align: text-top;
  }

  .sm\\:align-text-bottom{
    vertical-align: text-bottom;
  }

  .sm\\:visible{
    visibility: visible;
  }

  .sm\\:invisible{
    visibility: hidden;
  }

  .sm\\:whitespace-normal{
    white-space: normal;
  }

  .sm\\:whitespace-no-wrap{
    white-space: nowrap;
  }

  .sm\\:whitespace-pre{
    white-space: pre;
  }

  .sm\\:whitespace-pre-line{
    white-space: pre-line;
  }

  .sm\\:whitespace-pre-wrap{
    white-space: pre-wrap;
  }

  .sm\\:break-normal{
    word-wrap: normal;
    word-wrap: normal;
    word-break: normal;
  }

  .sm\\:break-words{
    word-wrap: break-word;
    word-wrap: break-word;
  }

  .sm\\:break-all{
    word-break: break-all;
  }

  .sm\\:truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .sm\\:w-0{
    width: 0;
  }

  .sm\\:w-1{
    width: 0.25rem;
  }

  .sm\\:w-2{
    width: 0.5rem;
  }

  .sm\\:w-3{
    width: 0.75rem;
  }

  .sm\\:w-4{
    width: 1rem;
  }

  .sm\\:w-5{
    width: 1.25rem;
  }

  .sm\\:w-6{
    width: 1.5rem;
  }

  .sm\\:w-7{
    width: 1.75rem;
  }

  .sm\\:w-8{
    width: 2rem;
  }

  .sm\\:w-9{
    width: 2.25rem;
  }

  .sm\\:w-10{
    width: 2.5rem;
  }

  .sm\\:w-11{
    width: 2.75rem;
  }

  .sm\\:w-12{
    width: 3rem;
  }

  .sm\\:w-14{
    width: 3.5rem;
  }

  .sm\\:w-15{
    width: 3.75rem;
  }

  .sm\\:w-16{
    width: 4rem;
  }

  .sm\\:w-18{
    width: 4.5rem;
  }

  .sm\\:w-20{
    width: 5rem;
  }

  .sm\\:w-22{
    width: 5.5rem;
  }

  .sm\\:w-23{
    width: 5.75rem;
  }

  .sm\\:w-24{
    width: 6rem;
  }

  .sm\\:w-25{
    width: 6.25rem;
  }

  .sm\\:w-26{
    width: 6.5rem;
  }

  .sm\\:w-28{
    width: 7rem;
  }

  .sm\\:w-30{
    width: 7.5rem;
  }

  .sm\\:w-32{
    width: 8rem;
  }

  .sm\\:w-34{
    width: 8.5rem;
  }

  .sm\\:w-40{
    width: 10rem;
  }

  .sm\\:w-42{
    width: 10.5rem;
  }

  .sm\\:w-44{
    width: 11rem;
  }

  .sm\\:w-48{
    width: 12rem;
  }

  .sm\\:w-52{
    width: 13rem;
  }

  .sm\\:w-54{
    width: 13.5rem;
  }

  .sm\\:w-56{
    width: 14rem;
  }

  .sm\\:w-60{
    width: 15rem;
  }

  .sm\\:w-64{
    width: 16rem;
  }

  .sm\\:w-68{
    width: 17rem;
  }

  .sm\\:w-72{
    width: 18rem;
  }

  .sm\\:w-74{
    width: 18.5rem;
  }

  .sm\\:w-76{
    width: 19rem;
  }

  .sm\\:w-78{
    width: 19.5rem;
  }

  .sm\\:w-80{
    width: 20rem;
  }

  .sm\\:w-82{
    width: 20.5rem;
  }

  .sm\\:w-84{
    width: 21rem;
  }

  .sm\\:w-88{
    width: 22rem;
  }

  .sm\\:w-92{
    width: 23rem;
  }

  .sm\\:w-96{
    width: 24rem;
  }

  .sm\\:w-98{
    width: 24.5rem;
  }

  .sm\\:w-100{
    width: 25rem;
  }

  .sm\\:w-104{
    width: 26rem;
  }

  .sm\\:w-112{
    width: 28rem;
  }

  .sm\\:w-124{
    width: 31rem;
  }

  .sm\\:w-128{
    width: 32rem;
  }

  .sm\\:w-140{
    width: 35rem;
  }

  .sm\\:w-152{
    width: 38rem;
  }

  .sm\\:w-160{
    width: 40rem;
  }

  .sm\\:w-162{
    width: 41rem;
  }

  .sm\\:w-192{
    width: 48rem;
  }

  .sm\\:w-208{
    width: 52rem;
  }

  .sm\\:w-224{
    width: 56rem;
  }

  .sm\\:w-256{
    width: 64rem;
  }

  .sm\\:w-auto{
    width: auto;
  }

  .sm\\:w-px{
    width: 1px;
  }

  .sm\\:w-1\\/2{
    width: 50%;
  }

  .sm\\:w-1\\/3{
    width: 33.33333%;
  }

  .sm\\:w-2\\/3{
    width: 66.66667%;
  }

  .sm\\:w-1\\/4{
    width: 25%;
  }

  .sm\\:w-3\\/4{
    width: 75%;
  }

  .sm\\:w-1\\/5{
    width: 20%;
  }

  .sm\\:w-2\\/5{
    width: 40%;
  }

  .sm\\:w-3\\/5{
    width: 60%;
  }

  .sm\\:w-4\\/5{
    width: 80%;
  }

  .sm\\:w-1\\/6{
    width: 16.66667%;
  }

  .sm\\:w-5\\/6{
    width: 83.33333%;
  }

  .sm\\:w-1\\/7{
    width: 14.285714285%;
  }

  .sm\\:w-2\\/7{
    width: 28.571428571%;
  }

  .sm\\:w-3\\/7{
    width: 42.85714285%;
  }

  .sm\\:w-4\\/7{
    width: 57.14285714%;
  }

  .sm\\:w-1\\/9{
    width: 11.1111%;
  }

  .sm\\:w-9\\/10{
    width: 90%;
  }

  .sm\\:w-full{
    width: 100%;
  }

  .sm\\:w-screen{
    width: 100vw;
  }

  .sm\\:w-max{
    width: max-content;
  }

  .sm\\:z-0{
    z-index: 0;
  }

  .sm\\:z-10{
    z-index: 10;
  }

  .sm\\:z-20{
    z-index: 20;
  }

  .sm\\:z-30{
    z-index: 30;
  }

  .sm\\:z-40{
    z-index: 40;
  }

  .sm\\:z-50{
    z-index: 50;
  }

  .sm\\:z-auto{
    z-index: auto;
  }

  .sm\\:gap-0{
    grid-gap: 0;
    gap: 0;
  }

  .sm\\:gap-1{
    grid-gap: 0.25rem;
    gap: 0.25rem;
  }

  .sm\\:gap-2{
    grid-gap: 0.5rem;
    gap: 0.5rem;
  }

  .sm\\:gap-3{
    grid-gap: 0.75rem;
    gap: 0.75rem;
  }

  .sm\\:gap-4{
    grid-gap: 1rem;
    gap: 1rem;
  }

  .sm\\:gap-5{
    grid-gap: 1.25rem;
    gap: 1.25rem;
  }

  .sm\\:gap-6{
    grid-gap: 1.5rem;
    gap: 1.5rem;
  }

  .sm\\:gap-7{
    grid-gap: 1.75rem;
    gap: 1.75rem;
  }

  .sm\\:gap-8{
    grid-gap: 2rem;
    gap: 2rem;
  }

  .sm\\:gap-9{
    grid-gap: 2.25rem;
    gap: 2.25rem;
  }

  .sm\\:gap-10{
    grid-gap: 2.5rem;
    gap: 2.5rem;
  }

  .sm\\:gap-11{
    grid-gap: 2.75rem;
    gap: 2.75rem;
  }

  .sm\\:gap-12{
    grid-gap: 3rem;
    gap: 3rem;
  }

  .sm\\:gap-14{
    grid-gap: 3.5rem;
    gap: 3.5rem;
  }

  .sm\\:gap-15{
    grid-gap: 3.75rem;
    gap: 3.75rem;
  }

  .sm\\:gap-16{
    grid-gap: 4rem;
    gap: 4rem;
  }

  .sm\\:gap-18{
    grid-gap: 4.5rem;
    gap: 4.5rem;
  }

  .sm\\:gap-20{
    grid-gap: 5rem;
    gap: 5rem;
  }

  .sm\\:gap-22{
    grid-gap: 5.5rem;
    gap: 5.5rem;
  }

  .sm\\:gap-23{
    grid-gap: 5.75rem;
    gap: 5.75rem;
  }

  .sm\\:gap-24{
    grid-gap: 6rem;
    gap: 6rem;
  }

  .sm\\:gap-25{
    grid-gap: 6.25rem;
    gap: 6.25rem;
  }

  .sm\\:gap-26{
    grid-gap: 6.5rem;
    gap: 6.5rem;
  }

  .sm\\:gap-28{
    grid-gap: 7rem;
    gap: 7rem;
  }

  .sm\\:gap-30{
    grid-gap: 7.5rem;
    gap: 7.5rem;
  }

  .sm\\:gap-32{
    grid-gap: 8rem;
    gap: 8rem;
  }

  .sm\\:gap-34{
    grid-gap: 8.5rem;
    gap: 8.5rem;
  }

  .sm\\:gap-40{
    grid-gap: 10rem;
    gap: 10rem;
  }

  .sm\\:gap-42{
    grid-gap: 10.5rem;
    gap: 10.5rem;
  }

  .sm\\:gap-44{
    grid-gap: 11rem;
    gap: 11rem;
  }

  .sm\\:gap-48{
    grid-gap: 12rem;
    gap: 12rem;
  }

  .sm\\:gap-52{
    grid-gap: 13rem;
    gap: 13rem;
  }

  .sm\\:gap-54{
    grid-gap: 13.5rem;
    gap: 13.5rem;
  }

  .sm\\:gap-56{
    grid-gap: 14rem;
    gap: 14rem;
  }

  .sm\\:gap-60{
    grid-gap: 15rem;
    gap: 15rem;
  }

  .sm\\:gap-64{
    grid-gap: 16rem;
    gap: 16rem;
  }

  .sm\\:gap-68{
    grid-gap: 17rem;
    gap: 17rem;
  }

  .sm\\:gap-72{
    grid-gap: 18rem;
    gap: 18rem;
  }

  .sm\\:gap-74{
    grid-gap: 18.5rem;
    gap: 18.5rem;
  }

  .sm\\:gap-76{
    grid-gap: 19rem;
    gap: 19rem;
  }

  .sm\\:gap-78{
    grid-gap: 19.5rem;
    gap: 19.5rem;
  }

  .sm\\:gap-80{
    grid-gap: 20rem;
    gap: 20rem;
  }

  .sm\\:gap-82{
    grid-gap: 20.5rem;
    gap: 20.5rem;
  }

  .sm\\:gap-84{
    grid-gap: 21rem;
    gap: 21rem;
  }

  .sm\\:gap-88{
    grid-gap: 22rem;
    gap: 22rem;
  }

  .sm\\:gap-92{
    grid-gap: 23rem;
    gap: 23rem;
  }

  .sm\\:gap-96{
    grid-gap: 24rem;
    gap: 24rem;
  }

  .sm\\:gap-98{
    grid-gap: 24.5rem;
    gap: 24.5rem;
  }

  .sm\\:gap-100{
    grid-gap: 25rem;
    gap: 25rem;
  }

  .sm\\:gap-104{
    grid-gap: 26rem;
    gap: 26rem;
  }

  .sm\\:gap-112{
    grid-gap: 28rem;
    gap: 28rem;
  }

  .sm\\:gap-124{
    grid-gap: 31rem;
    gap: 31rem;
  }

  .sm\\:gap-128{
    grid-gap: 32rem;
    gap: 32rem;
  }

  .sm\\:gap-140{
    grid-gap: 35rem;
    gap: 35rem;
  }

  .sm\\:gap-152{
    grid-gap: 38rem;
    gap: 38rem;
  }

  .sm\\:gap-160{
    grid-gap: 40rem;
    gap: 40rem;
  }

  .sm\\:gap-162{
    grid-gap: 41rem;
    gap: 41rem;
  }

  .sm\\:gap-192{
    grid-gap: 48rem;
    gap: 48rem;
  }

  .sm\\:gap-208{
    grid-gap: 52rem;
    gap: 52rem;
  }

  .sm\\:gap-224{
    grid-gap: 56rem;
    gap: 56rem;
  }

  .sm\\:gap-256{
    grid-gap: 64rem;
    gap: 64rem;
  }

  .sm\\:gap-px{
    grid-gap: 1px;
    gap: 1px;
  }

  .sm\\:gap-x-0{
    grid-column-gap: 0;
    -moz-column-gap: 0;
         column-gap: 0;
  }

  .sm\\:gap-x-1{
    grid-column-gap: 0.25rem;
    -moz-column-gap: 0.25rem;
         column-gap: 0.25rem;
  }

  .sm\\:gap-x-2{
    grid-column-gap: 0.5rem;
    -moz-column-gap: 0.5rem;
         column-gap: 0.5rem;
  }

  .sm\\:gap-x-3{
    grid-column-gap: 0.75rem;
    -moz-column-gap: 0.75rem;
         column-gap: 0.75rem;
  }

  .sm\\:gap-x-4{
    grid-column-gap: 1rem;
    -moz-column-gap: 1rem;
         column-gap: 1rem;
  }

  .sm\\:gap-x-5{
    grid-column-gap: 1.25rem;
    -moz-column-gap: 1.25rem;
         column-gap: 1.25rem;
  }

  .sm\\:gap-x-6{
    grid-column-gap: 1.5rem;
    -moz-column-gap: 1.5rem;
         column-gap: 1.5rem;
  }

  .sm\\:gap-x-7{
    grid-column-gap: 1.75rem;
    -moz-column-gap: 1.75rem;
         column-gap: 1.75rem;
  }

  .sm\\:gap-x-8{
    grid-column-gap: 2rem;
    -moz-column-gap: 2rem;
         column-gap: 2rem;
  }

  .sm\\:gap-x-9{
    grid-column-gap: 2.25rem;
    -moz-column-gap: 2.25rem;
         column-gap: 2.25rem;
  }

  .sm\\:gap-x-10{
    grid-column-gap: 2.5rem;
    -moz-column-gap: 2.5rem;
         column-gap: 2.5rem;
  }

  .sm\\:gap-x-11{
    grid-column-gap: 2.75rem;
    -moz-column-gap: 2.75rem;
         column-gap: 2.75rem;
  }

  .sm\\:gap-x-12{
    grid-column-gap: 3rem;
    -moz-column-gap: 3rem;
         column-gap: 3rem;
  }

  .sm\\:gap-x-14{
    grid-column-gap: 3.5rem;
    -moz-column-gap: 3.5rem;
         column-gap: 3.5rem;
  }

  .sm\\:gap-x-15{
    grid-column-gap: 3.75rem;
    -moz-column-gap: 3.75rem;
         column-gap: 3.75rem;
  }

  .sm\\:gap-x-16{
    grid-column-gap: 4rem;
    -moz-column-gap: 4rem;
         column-gap: 4rem;
  }

  .sm\\:gap-x-18{
    grid-column-gap: 4.5rem;
    -moz-column-gap: 4.5rem;
         column-gap: 4.5rem;
  }

  .sm\\:gap-x-20{
    grid-column-gap: 5rem;
    -moz-column-gap: 5rem;
         column-gap: 5rem;
  }

  .sm\\:gap-x-22{
    grid-column-gap: 5.5rem;
    -moz-column-gap: 5.5rem;
         column-gap: 5.5rem;
  }

  .sm\\:gap-x-23{
    grid-column-gap: 5.75rem;
    -moz-column-gap: 5.75rem;
         column-gap: 5.75rem;
  }

  .sm\\:gap-x-24{
    grid-column-gap: 6rem;
    -moz-column-gap: 6rem;
         column-gap: 6rem;
  }

  .sm\\:gap-x-25{
    grid-column-gap: 6.25rem;
    -moz-column-gap: 6.25rem;
         column-gap: 6.25rem;
  }

  .sm\\:gap-x-26{
    grid-column-gap: 6.5rem;
    -moz-column-gap: 6.5rem;
         column-gap: 6.5rem;
  }

  .sm\\:gap-x-28{
    grid-column-gap: 7rem;
    -moz-column-gap: 7rem;
         column-gap: 7rem;
  }

  .sm\\:gap-x-30{
    grid-column-gap: 7.5rem;
    -moz-column-gap: 7.5rem;
         column-gap: 7.5rem;
  }

  .sm\\:gap-x-32{
    grid-column-gap: 8rem;
    -moz-column-gap: 8rem;
         column-gap: 8rem;
  }

  .sm\\:gap-x-34{
    grid-column-gap: 8.5rem;
    -moz-column-gap: 8.5rem;
         column-gap: 8.5rem;
  }

  .sm\\:gap-x-40{
    grid-column-gap: 10rem;
    -moz-column-gap: 10rem;
         column-gap: 10rem;
  }

  .sm\\:gap-x-42{
    grid-column-gap: 10.5rem;
    -moz-column-gap: 10.5rem;
         column-gap: 10.5rem;
  }

  .sm\\:gap-x-44{
    grid-column-gap: 11rem;
    -moz-column-gap: 11rem;
         column-gap: 11rem;
  }

  .sm\\:gap-x-48{
    grid-column-gap: 12rem;
    -moz-column-gap: 12rem;
         column-gap: 12rem;
  }

  .sm\\:gap-x-52{
    grid-column-gap: 13rem;
    -moz-column-gap: 13rem;
         column-gap: 13rem;
  }

  .sm\\:gap-x-54{
    grid-column-gap: 13.5rem;
    -moz-column-gap: 13.5rem;
         column-gap: 13.5rem;
  }

  .sm\\:gap-x-56{
    grid-column-gap: 14rem;
    -moz-column-gap: 14rem;
         column-gap: 14rem;
  }

  .sm\\:gap-x-60{
    grid-column-gap: 15rem;
    -moz-column-gap: 15rem;
         column-gap: 15rem;
  }

  .sm\\:gap-x-64{
    grid-column-gap: 16rem;
    -moz-column-gap: 16rem;
         column-gap: 16rem;
  }

  .sm\\:gap-x-68{
    grid-column-gap: 17rem;
    -moz-column-gap: 17rem;
         column-gap: 17rem;
  }

  .sm\\:gap-x-72{
    grid-column-gap: 18rem;
    -moz-column-gap: 18rem;
         column-gap: 18rem;
  }

  .sm\\:gap-x-74{
    grid-column-gap: 18.5rem;
    -moz-column-gap: 18.5rem;
         column-gap: 18.5rem;
  }

  .sm\\:gap-x-76{
    grid-column-gap: 19rem;
    -moz-column-gap: 19rem;
         column-gap: 19rem;
  }

  .sm\\:gap-x-78{
    grid-column-gap: 19.5rem;
    -moz-column-gap: 19.5rem;
         column-gap: 19.5rem;
  }

  .sm\\:gap-x-80{
    grid-column-gap: 20rem;
    -moz-column-gap: 20rem;
         column-gap: 20rem;
  }

  .sm\\:gap-x-82{
    grid-column-gap: 20.5rem;
    -moz-column-gap: 20.5rem;
         column-gap: 20.5rem;
  }

  .sm\\:gap-x-84{
    grid-column-gap: 21rem;
    -moz-column-gap: 21rem;
         column-gap: 21rem;
  }

  .sm\\:gap-x-88{
    grid-column-gap: 22rem;
    -moz-column-gap: 22rem;
         column-gap: 22rem;
  }

  .sm\\:gap-x-92{
    grid-column-gap: 23rem;
    -moz-column-gap: 23rem;
         column-gap: 23rem;
  }

  .sm\\:gap-x-96{
    grid-column-gap: 24rem;
    -moz-column-gap: 24rem;
         column-gap: 24rem;
  }

  .sm\\:gap-x-98{
    grid-column-gap: 24.5rem;
    -moz-column-gap: 24.5rem;
         column-gap: 24.5rem;
  }

  .sm\\:gap-x-100{
    grid-column-gap: 25rem;
    -moz-column-gap: 25rem;
         column-gap: 25rem;
  }

  .sm\\:gap-x-104{
    grid-column-gap: 26rem;
    -moz-column-gap: 26rem;
         column-gap: 26rem;
  }

  .sm\\:gap-x-112{
    grid-column-gap: 28rem;
    -moz-column-gap: 28rem;
         column-gap: 28rem;
  }

  .sm\\:gap-x-124{
    grid-column-gap: 31rem;
    -moz-column-gap: 31rem;
         column-gap: 31rem;
  }

  .sm\\:gap-x-128{
    grid-column-gap: 32rem;
    -moz-column-gap: 32rem;
         column-gap: 32rem;
  }

  .sm\\:gap-x-140{
    grid-column-gap: 35rem;
    -moz-column-gap: 35rem;
         column-gap: 35rem;
  }

  .sm\\:gap-x-152{
    grid-column-gap: 38rem;
    -moz-column-gap: 38rem;
         column-gap: 38rem;
  }

  .sm\\:gap-x-160{
    grid-column-gap: 40rem;
    -moz-column-gap: 40rem;
         column-gap: 40rem;
  }

  .sm\\:gap-x-162{
    grid-column-gap: 41rem;
    -moz-column-gap: 41rem;
         column-gap: 41rem;
  }

  .sm\\:gap-x-192{
    grid-column-gap: 48rem;
    -moz-column-gap: 48rem;
         column-gap: 48rem;
  }

  .sm\\:gap-x-208{
    grid-column-gap: 52rem;
    -moz-column-gap: 52rem;
         column-gap: 52rem;
  }

  .sm\\:gap-x-224{
    grid-column-gap: 56rem;
    -moz-column-gap: 56rem;
         column-gap: 56rem;
  }

  .sm\\:gap-x-256{
    grid-column-gap: 64rem;
    -moz-column-gap: 64rem;
         column-gap: 64rem;
  }

  .sm\\:gap-x-px{
    grid-column-gap: 1px;
    -moz-column-gap: 1px;
         column-gap: 1px;
  }

  .sm\\:gap-y-0{
    grid-row-gap: 0;
    row-gap: 0;
  }

  .sm\\:gap-y-1{
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }

  .sm\\:gap-y-2{
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }

  .sm\\:gap-y-3{
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }

  .sm\\:gap-y-4{
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }

  .sm\\:gap-y-5{
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }

  .sm\\:gap-y-6{
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }

  .sm\\:gap-y-7{
    grid-row-gap: 1.75rem;
    row-gap: 1.75rem;
  }

  .sm\\:gap-y-8{
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }

  .sm\\:gap-y-9{
    grid-row-gap: 2.25rem;
    row-gap: 2.25rem;
  }

  .sm\\:gap-y-10{
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }

  .sm\\:gap-y-11{
    grid-row-gap: 2.75rem;
    row-gap: 2.75rem;
  }

  .sm\\:gap-y-12{
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }

  .sm\\:gap-y-14{
    grid-row-gap: 3.5rem;
    row-gap: 3.5rem;
  }

  .sm\\:gap-y-15{
    grid-row-gap: 3.75rem;
    row-gap: 3.75rem;
  }

  .sm\\:gap-y-16{
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }

  .sm\\:gap-y-18{
    grid-row-gap: 4.5rem;
    row-gap: 4.5rem;
  }

  .sm\\:gap-y-20{
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }

  .sm\\:gap-y-22{
    grid-row-gap: 5.5rem;
    row-gap: 5.5rem;
  }

  .sm\\:gap-y-23{
    grid-row-gap: 5.75rem;
    row-gap: 5.75rem;
  }

  .sm\\:gap-y-24{
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }

  .sm\\:gap-y-25{
    grid-row-gap: 6.25rem;
    row-gap: 6.25rem;
  }

  .sm\\:gap-y-26{
    grid-row-gap: 6.5rem;
    row-gap: 6.5rem;
  }

  .sm\\:gap-y-28{
    grid-row-gap: 7rem;
    row-gap: 7rem;
  }

  .sm\\:gap-y-30{
    grid-row-gap: 7.5rem;
    row-gap: 7.5rem;
  }

  .sm\\:gap-y-32{
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }

  .sm\\:gap-y-34{
    grid-row-gap: 8.5rem;
    row-gap: 8.5rem;
  }

  .sm\\:gap-y-40{
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }

  .sm\\:gap-y-42{
    grid-row-gap: 10.5rem;
    row-gap: 10.5rem;
  }

  .sm\\:gap-y-44{
    grid-row-gap: 11rem;
    row-gap: 11rem;
  }

  .sm\\:gap-y-48{
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }

  .sm\\:gap-y-52{
    grid-row-gap: 13rem;
    row-gap: 13rem;
  }

  .sm\\:gap-y-54{
    grid-row-gap: 13.5rem;
    row-gap: 13.5rem;
  }

  .sm\\:gap-y-56{
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }

  .sm\\:gap-y-60{
    grid-row-gap: 15rem;
    row-gap: 15rem;
  }

  .sm\\:gap-y-64{
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }

  .sm\\:gap-y-68{
    grid-row-gap: 17rem;
    row-gap: 17rem;
  }

  .sm\\:gap-y-72{
    grid-row-gap: 18rem;
    row-gap: 18rem;
  }

  .sm\\:gap-y-74{
    grid-row-gap: 18.5rem;
    row-gap: 18.5rem;
  }

  .sm\\:gap-y-76{
    grid-row-gap: 19rem;
    row-gap: 19rem;
  }

  .sm\\:gap-y-78{
    grid-row-gap: 19.5rem;
    row-gap: 19.5rem;
  }

  .sm\\:gap-y-80{
    grid-row-gap: 20rem;
    row-gap: 20rem;
  }

  .sm\\:gap-y-82{
    grid-row-gap: 20.5rem;
    row-gap: 20.5rem;
  }

  .sm\\:gap-y-84{
    grid-row-gap: 21rem;
    row-gap: 21rem;
  }

  .sm\\:gap-y-88{
    grid-row-gap: 22rem;
    row-gap: 22rem;
  }

  .sm\\:gap-y-92{
    grid-row-gap: 23rem;
    row-gap: 23rem;
  }

  .sm\\:gap-y-96{
    grid-row-gap: 24rem;
    row-gap: 24rem;
  }

  .sm\\:gap-y-98{
    grid-row-gap: 24.5rem;
    row-gap: 24.5rem;
  }

  .sm\\:gap-y-100{
    grid-row-gap: 25rem;
    row-gap: 25rem;
  }

  .sm\\:gap-y-104{
    grid-row-gap: 26rem;
    row-gap: 26rem;
  }

  .sm\\:gap-y-112{
    grid-row-gap: 28rem;
    row-gap: 28rem;
  }

  .sm\\:gap-y-124{
    grid-row-gap: 31rem;
    row-gap: 31rem;
  }

  .sm\\:gap-y-128{
    grid-row-gap: 32rem;
    row-gap: 32rem;
  }

  .sm\\:gap-y-140{
    grid-row-gap: 35rem;
    row-gap: 35rem;
  }

  .sm\\:gap-y-152{
    grid-row-gap: 38rem;
    row-gap: 38rem;
  }

  .sm\\:gap-y-160{
    grid-row-gap: 40rem;
    row-gap: 40rem;
  }

  .sm\\:gap-y-162{
    grid-row-gap: 41rem;
    row-gap: 41rem;
  }

  .sm\\:gap-y-192{
    grid-row-gap: 48rem;
    row-gap: 48rem;
  }

  .sm\\:gap-y-208{
    grid-row-gap: 52rem;
    row-gap: 52rem;
  }

  .sm\\:gap-y-224{
    grid-row-gap: 56rem;
    row-gap: 56rem;
  }

  .sm\\:gap-y-256{
    grid-row-gap: 64rem;
    row-gap: 64rem;
  }

  .sm\\:gap-y-px{
    grid-row-gap: 1px;
    row-gap: 1px;
  }

  .sm\\:grid-flow-row{
    grid-auto-flow: row;
  }

  .sm\\:grid-flow-col{
    grid-auto-flow: column;
  }

  .sm\\:grid-flow-row-dense{
    grid-auto-flow: row dense;
  }

  .sm\\:grid-flow-col-dense{
    grid-auto-flow: column dense;
  }

  .sm\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .sm\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .sm\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .sm\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .sm\\:grid-cols-9{
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .sm\\:grid-cols-10{
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .sm\\:grid-cols-11{
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .sm\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .sm\\:grid-cols-14{
    grid-template-columns: repeat(14, minmax(0, 1fr));
  }

  .sm\\:grid-cols-none{
    grid-template-columns: none;
  }

  .sm\\:auto-cols-auto{
    grid-auto-columns: auto;
  }

  .sm\\:auto-cols-min{
    grid-auto-columns: min-content;
  }

  .sm\\:auto-cols-max{
    grid-auto-columns: max-content;
  }

  .sm\\:auto-cols-fr{
    grid-auto-columns: minmax(0, 1fr);
  }

  .sm\\:col-auto{
    grid-column: auto;
  }

  .sm\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .sm\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .sm\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .sm\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .sm\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .sm\\:col-span-6{
    grid-column: span 6 / span 6;
  }

  .sm\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .sm\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .sm\\:col-span-9{
    grid-column: span 9 / span 9;
  }

  .sm\\:col-span-10{
    grid-column: span 10 / span 10;
  }

  .sm\\:col-span-11{
    grid-column: span 11 / span 11;
  }

  .sm\\:col-span-12{
    grid-column: span 12 / span 12;
  }

  .sm\\:col-span-full{
    grid-column: 1 / -1;
  }

  .sm\\:col-start-1{
    grid-column-start: 1;
  }

  .sm\\:col-start-2{
    grid-column-start: 2;
  }

  .sm\\:col-start-3{
    grid-column-start: 3;
  }

  .sm\\:col-start-4{
    grid-column-start: 4;
  }

  .sm\\:col-start-5{
    grid-column-start: 5;
  }

  .sm\\:col-start-6{
    grid-column-start: 6;
  }

  .sm\\:col-start-7{
    grid-column-start: 7;
  }

  .sm\\:col-start-8{
    grid-column-start: 8;
  }

  .sm\\:col-start-9{
    grid-column-start: 9;
  }

  .sm\\:col-start-10{
    grid-column-start: 10;
  }

  .sm\\:col-start-11{
    grid-column-start: 11;
  }

  .sm\\:col-start-12{
    grid-column-start: 12;
  }

  .sm\\:col-start-13{
    grid-column-start: 13;
  }

  .sm\\:col-start-14{
    grid-column-start: 14;
  }

  .sm\\:col-start-15{
    grid-column-start: 15;
  }

  .sm\\:col-start-auto{
    grid-column-start: auto;
  }

  .sm\\:col-end-1{
    grid-column-end: 1;
  }

  .sm\\:col-end-2{
    grid-column-end: 2;
  }

  .sm\\:col-end-3{
    grid-column-end: 3;
  }

  .sm\\:col-end-4{
    grid-column-end: 4;
  }

  .sm\\:col-end-5{
    grid-column-end: 5;
  }

  .sm\\:col-end-6{
    grid-column-end: 6;
  }

  .sm\\:col-end-7{
    grid-column-end: 7;
  }

  .sm\\:col-end-8{
    grid-column-end: 8;
  }

  .sm\\:col-end-9{
    grid-column-end: 9;
  }

  .sm\\:col-end-10{
    grid-column-end: 10;
  }

  .sm\\:col-end-11{
    grid-column-end: 11;
  }

  .sm\\:col-end-12{
    grid-column-end: 12;
  }

  .sm\\:col-end-13{
    grid-column-end: 13;
  }

  .sm\\:col-end-14{
    grid-column-end: 14;
  }

  .sm\\:col-end-15{
    grid-column-end: 15;
  }

  .sm\\:col-end-auto{
    grid-column-end: auto;
  }

  .sm\\:grid-rows-1{
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .sm\\:grid-rows-2{
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-rows-3{
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }

  .sm\\:grid-rows-4{
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }

  .sm\\:grid-rows-5{
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }

  .sm\\:grid-rows-6{
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }

  .sm\\:grid-rows-none{
    grid-template-rows: none;
  }

  .sm\\:auto-rows-auto{
    grid-auto-rows: auto;
  }

  .sm\\:auto-rows-min{
    grid-auto-rows: min-content;
  }

  .sm\\:auto-rows-max{
    grid-auto-rows: max-content;
  }

  .sm\\:auto-rows-fr{
    grid-auto-rows: minmax(0, 1fr);
  }

  .sm\\:row-auto{
    grid-row: auto;
  }

  .sm\\:row-span-1{
    grid-row: span 1 / span 1;
  }

  .sm\\:row-span-2{
    grid-row: span 2 / span 2;
  }

  .sm\\:row-span-3{
    grid-row: span 3 / span 3;
  }

  .sm\\:row-span-4{
    grid-row: span 4 / span 4;
  }

  .sm\\:row-span-5{
    grid-row: span 5 / span 5;
  }

  .sm\\:row-span-6{
    grid-row: span 6 / span 6;
  }

  .sm\\:row-span-full{
    grid-row: 1 / -1;
  }

  .sm\\:row-start-1{
    grid-row-start: 1;
  }

  .sm\\:row-start-2{
    grid-row-start: 2;
  }

  .sm\\:row-start-3{
    grid-row-start: 3;
  }

  .sm\\:row-start-4{
    grid-row-start: 4;
  }

  .sm\\:row-start-5{
    grid-row-start: 5;
  }

  .sm\\:row-start-6{
    grid-row-start: 6;
  }

  .sm\\:row-start-7{
    grid-row-start: 7;
  }

  .sm\\:row-start-auto{
    grid-row-start: auto;
  }

  .sm\\:row-end-1{
    grid-row-end: 1;
  }

  .sm\\:row-end-2{
    grid-row-end: 2;
  }

  .sm\\:row-end-3{
    grid-row-end: 3;
  }

  .sm\\:row-end-4{
    grid-row-end: 4;
  }

  .sm\\:row-end-5{
    grid-row-end: 5;
  }

  .sm\\:row-end-6{
    grid-row-end: 6;
  }

  .sm\\:row-end-7{
    grid-row-end: 7;
  }

  .sm\\:row-end-auto{
    grid-row-end: auto;
  }

  .sm\\:transform{
    --transform-translate-x: 0;
    --transform-translate-y: 0;
    --transform-rotate: 0;
    --transform-skew-x: 0;
    --transform-skew-y: 0;
    --transform-scale-x: 1;
    --transform-scale-y: 1;
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
  }

  .sm\\:transform-none{
    transform: none;
  }

  .sm\\:origin-center{
    transform-origin: center;
  }

  .sm\\:origin-top{
    transform-origin: top;
  }

  .sm\\:origin-top-right{
    transform-origin: top right;
  }

  .sm\\:origin-right{
    transform-origin: right;
  }

  .sm\\:origin-bottom-right{
    transform-origin: bottom right;
  }

  .sm\\:origin-bottom{
    transform-origin: bottom;
  }

  .sm\\:origin-bottom-left{
    transform-origin: bottom left;
  }

  .sm\\:origin-left{
    transform-origin: left;
  }

  .sm\\:origin-top-left{
    transform-origin: top left;
  }

  .sm\\:scale-0{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .sm\\:scale-50{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .sm\\:scale-75{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .sm\\:scale-90{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .sm\\:scale-95{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .sm\\:scale-100{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .sm\\:scale-105{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .sm\\:scale-110{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .sm\\:scale-125{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .sm\\:scale-150{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .sm\\:scale-x-0{
    --transform-scale-x: 0;
  }

  .sm\\:scale-x-50{
    --transform-scale-x: .5;
  }

  .sm\\:scale-x-75{
    --transform-scale-x: .75;
  }

  .sm\\:scale-x-90{
    --transform-scale-x: .9;
  }

  .sm\\:scale-x-95{
    --transform-scale-x: .95;
  }

  .sm\\:scale-x-100{
    --transform-scale-x: 1;
  }

  .sm\\:scale-x-105{
    --transform-scale-x: 1.05;
  }

  .sm\\:scale-x-110{
    --transform-scale-x: 1.1;
  }

  .sm\\:scale-x-125{
    --transform-scale-x: 1.25;
  }

  .sm\\:scale-x-150{
    --transform-scale-x: 1.5;
  }

  .sm\\:scale-y-0{
    --transform-scale-y: 0;
  }

  .sm\\:scale-y-50{
    --transform-scale-y: .5;
  }

  .sm\\:scale-y-75{
    --transform-scale-y: .75;
  }

  .sm\\:scale-y-90{
    --transform-scale-y: .9;
  }

  .sm\\:scale-y-95{
    --transform-scale-y: .95;
  }

  .sm\\:scale-y-100{
    --transform-scale-y: 1;
  }

  .sm\\:scale-y-105{
    --transform-scale-y: 1.05;
  }

  .sm\\:scale-y-110{
    --transform-scale-y: 1.1;
  }

  .sm\\:scale-y-125{
    --transform-scale-y: 1.25;
  }

  .sm\\:scale-y-150{
    --transform-scale-y: 1.5;
  }

  .sm\\:hover\\:scale-0:hover{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .sm\\:hover\\:scale-50:hover{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .sm\\:hover\\:scale-75:hover{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .sm\\:hover\\:scale-90:hover{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .sm\\:hover\\:scale-95:hover{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .sm\\:hover\\:scale-100:hover{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .sm\\:hover\\:scale-105:hover{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .sm\\:hover\\:scale-110:hover{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .sm\\:hover\\:scale-125:hover{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .sm\\:hover\\:scale-150:hover{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .sm\\:hover\\:scale-x-0:hover{
    --transform-scale-x: 0;
  }

  .sm\\:hover\\:scale-x-50:hover{
    --transform-scale-x: .5;
  }

  .sm\\:hover\\:scale-x-75:hover{
    --transform-scale-x: .75;
  }

  .sm\\:hover\\:scale-x-90:hover{
    --transform-scale-x: .9;
  }

  .sm\\:hover\\:scale-x-95:hover{
    --transform-scale-x: .95;
  }

  .sm\\:hover\\:scale-x-100:hover{
    --transform-scale-x: 1;
  }

  .sm\\:hover\\:scale-x-105:hover{
    --transform-scale-x: 1.05;
  }

  .sm\\:hover\\:scale-x-110:hover{
    --transform-scale-x: 1.1;
  }

  .sm\\:hover\\:scale-x-125:hover{
    --transform-scale-x: 1.25;
  }

  .sm\\:hover\\:scale-x-150:hover{
    --transform-scale-x: 1.5;
  }

  .sm\\:hover\\:scale-y-0:hover{
    --transform-scale-y: 0;
  }

  .sm\\:hover\\:scale-y-50:hover{
    --transform-scale-y: .5;
  }

  .sm\\:hover\\:scale-y-75:hover{
    --transform-scale-y: .75;
  }

  .sm\\:hover\\:scale-y-90:hover{
    --transform-scale-y: .9;
  }

  .sm\\:hover\\:scale-y-95:hover{
    --transform-scale-y: .95;
  }

  .sm\\:hover\\:scale-y-100:hover{
    --transform-scale-y: 1;
  }

  .sm\\:hover\\:scale-y-105:hover{
    --transform-scale-y: 1.05;
  }

  .sm\\:hover\\:scale-y-110:hover{
    --transform-scale-y: 1.1;
  }

  .sm\\:hover\\:scale-y-125:hover{
    --transform-scale-y: 1.25;
  }

  .sm\\:hover\\:scale-y-150:hover{
    --transform-scale-y: 1.5;
  }

  .sm\\:focus\\:scale-0:focus{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .sm\\:focus\\:scale-50:focus{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .sm\\:focus\\:scale-75:focus{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .sm\\:focus\\:scale-90:focus{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .sm\\:focus\\:scale-95:focus{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .sm\\:focus\\:scale-100:focus{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .sm\\:focus\\:scale-105:focus{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .sm\\:focus\\:scale-110:focus{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .sm\\:focus\\:scale-125:focus{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .sm\\:focus\\:scale-150:focus{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .sm\\:focus\\:scale-x-0:focus{
    --transform-scale-x: 0;
  }

  .sm\\:focus\\:scale-x-50:focus{
    --transform-scale-x: .5;
  }

  .sm\\:focus\\:scale-x-75:focus{
    --transform-scale-x: .75;
  }

  .sm\\:focus\\:scale-x-90:focus{
    --transform-scale-x: .9;
  }

  .sm\\:focus\\:scale-x-95:focus{
    --transform-scale-x: .95;
  }

  .sm\\:focus\\:scale-x-100:focus{
    --transform-scale-x: 1;
  }

  .sm\\:focus\\:scale-x-105:focus{
    --transform-scale-x: 1.05;
  }

  .sm\\:focus\\:scale-x-110:focus{
    --transform-scale-x: 1.1;
  }

  .sm\\:focus\\:scale-x-125:focus{
    --transform-scale-x: 1.25;
  }

  .sm\\:focus\\:scale-x-150:focus{
    --transform-scale-x: 1.5;
  }

  .sm\\:focus\\:scale-y-0:focus{
    --transform-scale-y: 0;
  }

  .sm\\:focus\\:scale-y-50:focus{
    --transform-scale-y: .5;
  }

  .sm\\:focus\\:scale-y-75:focus{
    --transform-scale-y: .75;
  }

  .sm\\:focus\\:scale-y-90:focus{
    --transform-scale-y: .9;
  }

  .sm\\:focus\\:scale-y-95:focus{
    --transform-scale-y: .95;
  }

  .sm\\:focus\\:scale-y-100:focus{
    --transform-scale-y: 1;
  }

  .sm\\:focus\\:scale-y-105:focus{
    --transform-scale-y: 1.05;
  }

  .sm\\:focus\\:scale-y-110:focus{
    --transform-scale-y: 1.1;
  }

  .sm\\:focus\\:scale-y-125:focus{
    --transform-scale-y: 1.25;
  }

  .sm\\:focus\\:scale-y-150:focus{
    --transform-scale-y: 1.5;
  }

  .sm\\:rotate-0{
    --transform-rotate: 0;
  }

  .sm\\:rotate-1{
    --transform-rotate: 1deg;
  }

  .sm\\:rotate-2{
    --transform-rotate: 2deg;
  }

  .sm\\:rotate-3{
    --transform-rotate: 3deg;
  }

  .sm\\:rotate-6{
    --transform-rotate: 6deg;
  }

  .sm\\:rotate-12{
    --transform-rotate: 12deg;
  }

  .sm\\:rotate-45{
    --transform-rotate: 45deg;
  }

  .sm\\:rotate-90{
    --transform-rotate: 90deg;
  }

  .sm\\:rotate-180{
    --transform-rotate: 180deg;
  }

  .sm\\:-rotate-180{
    --transform-rotate: -180deg;
  }

  .sm\\:-rotate-90{
    --transform-rotate: -90deg;
  }

  .sm\\:-rotate-45{
    --transform-rotate: -45deg;
  }

  .sm\\:-rotate-12{
    --transform-rotate: -12deg;
  }

  .sm\\:-rotate-6{
    --transform-rotate: -6deg;
  }

  .sm\\:-rotate-3{
    --transform-rotate: -3deg;
  }

  .sm\\:-rotate-2{
    --transform-rotate: -2deg;
  }

  .sm\\:-rotate-1{
    --transform-rotate: -1deg;
  }

  .sm\\:hover\\:rotate-0:hover{
    --transform-rotate: 0;
  }

  .sm\\:hover\\:rotate-1:hover{
    --transform-rotate: 1deg;
  }

  .sm\\:hover\\:rotate-2:hover{
    --transform-rotate: 2deg;
  }

  .sm\\:hover\\:rotate-3:hover{
    --transform-rotate: 3deg;
  }

  .sm\\:hover\\:rotate-6:hover{
    --transform-rotate: 6deg;
  }

  .sm\\:hover\\:rotate-12:hover{
    --transform-rotate: 12deg;
  }

  .sm\\:hover\\:rotate-45:hover{
    --transform-rotate: 45deg;
  }

  .sm\\:hover\\:rotate-90:hover{
    --transform-rotate: 90deg;
  }

  .sm\\:hover\\:rotate-180:hover{
    --transform-rotate: 180deg;
  }

  .sm\\:hover\\:-rotate-180:hover{
    --transform-rotate: -180deg;
  }

  .sm\\:hover\\:-rotate-90:hover{
    --transform-rotate: -90deg;
  }

  .sm\\:hover\\:-rotate-45:hover{
    --transform-rotate: -45deg;
  }

  .sm\\:hover\\:-rotate-12:hover{
    --transform-rotate: -12deg;
  }

  .sm\\:hover\\:-rotate-6:hover{
    --transform-rotate: -6deg;
  }

  .sm\\:hover\\:-rotate-3:hover{
    --transform-rotate: -3deg;
  }

  .sm\\:hover\\:-rotate-2:hover{
    --transform-rotate: -2deg;
  }

  .sm\\:hover\\:-rotate-1:hover{
    --transform-rotate: -1deg;
  }

  .sm\\:focus\\:rotate-0:focus{
    --transform-rotate: 0;
  }

  .sm\\:focus\\:rotate-1:focus{
    --transform-rotate: 1deg;
  }

  .sm\\:focus\\:rotate-2:focus{
    --transform-rotate: 2deg;
  }

  .sm\\:focus\\:rotate-3:focus{
    --transform-rotate: 3deg;
  }

  .sm\\:focus\\:rotate-6:focus{
    --transform-rotate: 6deg;
  }

  .sm\\:focus\\:rotate-12:focus{
    --transform-rotate: 12deg;
  }

  .sm\\:focus\\:rotate-45:focus{
    --transform-rotate: 45deg;
  }

  .sm\\:focus\\:rotate-90:focus{
    --transform-rotate: 90deg;
  }

  .sm\\:focus\\:rotate-180:focus{
    --transform-rotate: 180deg;
  }

  .sm\\:focus\\:-rotate-180:focus{
    --transform-rotate: -180deg;
  }

  .sm\\:focus\\:-rotate-90:focus{
    --transform-rotate: -90deg;
  }

  .sm\\:focus\\:-rotate-45:focus{
    --transform-rotate: -45deg;
  }

  .sm\\:focus\\:-rotate-12:focus{
    --transform-rotate: -12deg;
  }

  .sm\\:focus\\:-rotate-6:focus{
    --transform-rotate: -6deg;
  }

  .sm\\:focus\\:-rotate-3:focus{
    --transform-rotate: -3deg;
  }

  .sm\\:focus\\:-rotate-2:focus{
    --transform-rotate: -2deg;
  }

  .sm\\:focus\\:-rotate-1:focus{
    --transform-rotate: -1deg;
  }

  .sm\\:translate-x-0{
    --transform-translate-x: 0;
  }

  .sm\\:translate-x-1{
    --transform-translate-x: 0.25rem;
  }

  .sm\\:translate-x-2{
    --transform-translate-x: 0.5rem;
  }

  .sm\\:translate-x-3{
    --transform-translate-x: 0.75rem;
  }

  .sm\\:translate-x-4{
    --transform-translate-x: 1rem;
  }

  .sm\\:translate-x-5{
    --transform-translate-x: 1.25rem;
  }

  .sm\\:translate-x-6{
    --transform-translate-x: 1.5rem;
  }

  .sm\\:translate-x-7{
    --transform-translate-x: 1.75rem;
  }

  .sm\\:translate-x-8{
    --transform-translate-x: 2rem;
  }

  .sm\\:translate-x-9{
    --transform-translate-x: 2.25rem;
  }

  .sm\\:translate-x-10{
    --transform-translate-x: 2.5rem;
  }

  .sm\\:translate-x-11{
    --transform-translate-x: 2.75rem;
  }

  .sm\\:translate-x-12{
    --transform-translate-x: 3rem;
  }

  .sm\\:translate-x-14{
    --transform-translate-x: 3.5rem;
  }

  .sm\\:translate-x-15{
    --transform-translate-x: 3.75rem;
  }

  .sm\\:translate-x-16{
    --transform-translate-x: 4rem;
  }

  .sm\\:translate-x-18{
    --transform-translate-x: 4.5rem;
  }

  .sm\\:translate-x-20{
    --transform-translate-x: 5rem;
  }

  .sm\\:translate-x-22{
    --transform-translate-x: 5.5rem;
  }

  .sm\\:translate-x-23{
    --transform-translate-x: 5.75rem;
  }

  .sm\\:translate-x-24{
    --transform-translate-x: 6rem;
  }

  .sm\\:translate-x-25{
    --transform-translate-x: 6.25rem;
  }

  .sm\\:translate-x-26{
    --transform-translate-x: 6.5rem;
  }

  .sm\\:translate-x-28{
    --transform-translate-x: 7rem;
  }

  .sm\\:translate-x-30{
    --transform-translate-x: 7.5rem;
  }

  .sm\\:translate-x-32{
    --transform-translate-x: 8rem;
  }

  .sm\\:translate-x-34{
    --transform-translate-x: 8.5rem;
  }

  .sm\\:translate-x-40{
    --transform-translate-x: 10rem;
  }

  .sm\\:translate-x-42{
    --transform-translate-x: 10.5rem;
  }

  .sm\\:translate-x-44{
    --transform-translate-x: 11rem;
  }

  .sm\\:translate-x-48{
    --transform-translate-x: 12rem;
  }

  .sm\\:translate-x-52{
    --transform-translate-x: 13rem;
  }

  .sm\\:translate-x-54{
    --transform-translate-x: 13.5rem;
  }

  .sm\\:translate-x-56{
    --transform-translate-x: 14rem;
  }

  .sm\\:translate-x-60{
    --transform-translate-x: 15rem;
  }

  .sm\\:translate-x-64{
    --transform-translate-x: 16rem;
  }

  .sm\\:translate-x-68{
    --transform-translate-x: 17rem;
  }

  .sm\\:translate-x-72{
    --transform-translate-x: 18rem;
  }

  .sm\\:translate-x-74{
    --transform-translate-x: 18.5rem;
  }

  .sm\\:translate-x-76{
    --transform-translate-x: 19rem;
  }

  .sm\\:translate-x-78{
    --transform-translate-x: 19.5rem;
  }

  .sm\\:translate-x-80{
    --transform-translate-x: 20rem;
  }

  .sm\\:translate-x-82{
    --transform-translate-x: 20.5rem;
  }

  .sm\\:translate-x-84{
    --transform-translate-x: 21rem;
  }

  .sm\\:translate-x-88{
    --transform-translate-x: 22rem;
  }

  .sm\\:translate-x-92{
    --transform-translate-x: 23rem;
  }

  .sm\\:translate-x-96{
    --transform-translate-x: 24rem;
  }

  .sm\\:translate-x-98{
    --transform-translate-x: 24.5rem;
  }

  .sm\\:translate-x-100{
    --transform-translate-x: 25rem;
  }

  .sm\\:translate-x-104{
    --transform-translate-x: 26rem;
  }

  .sm\\:translate-x-112{
    --transform-translate-x: 28rem;
  }

  .sm\\:translate-x-124{
    --transform-translate-x: 31rem;
  }

  .sm\\:translate-x-128{
    --transform-translate-x: 32rem;
  }

  .sm\\:translate-x-140{
    --transform-translate-x: 35rem;
  }

  .sm\\:translate-x-152{
    --transform-translate-x: 38rem;
  }

  .sm\\:translate-x-160{
    --transform-translate-x: 40rem;
  }

  .sm\\:translate-x-162{
    --transform-translate-x: 41rem;
  }

  .sm\\:translate-x-192{
    --transform-translate-x: 48rem;
  }

  .sm\\:translate-x-208{
    --transform-translate-x: 52rem;
  }

  .sm\\:translate-x-224{
    --transform-translate-x: 56rem;
  }

  .sm\\:translate-x-256{
    --transform-translate-x: 64rem;
  }

  .sm\\:translate-x-px{
    --transform-translate-x: 1px;
  }

  .sm\\:-translate-x-1{
    --transform-translate-x: -0.25rem;
  }

  .sm\\:-translate-x-2{
    --transform-translate-x: -0.5rem;
  }

  .sm\\:-translate-x-3{
    --transform-translate-x: -0.75rem;
  }

  .sm\\:-translate-x-4{
    --transform-translate-x: -1rem;
  }

  .sm\\:-translate-x-5{
    --transform-translate-x: -1.25rem;
  }

  .sm\\:-translate-x-6{
    --transform-translate-x: -1.5rem;
  }

  .sm\\:-translate-x-7{
    --transform-translate-x: -1.75rem;
  }

  .sm\\:-translate-x-8{
    --transform-translate-x: -2rem;
  }

  .sm\\:-translate-x-9{
    --transform-translate-x: -2.25rem;
  }

  .sm\\:-translate-x-10{
    --transform-translate-x: -2.5rem;
  }

  .sm\\:-translate-x-11{
    --transform-translate-x: -2.75rem;
  }

  .sm\\:-translate-x-12{
    --transform-translate-x: -3rem;
  }

  .sm\\:-translate-x-14{
    --transform-translate-x: -3.5rem;
  }

  .sm\\:-translate-x-15{
    --transform-translate-x: -3.75rem;
  }

  .sm\\:-translate-x-16{
    --transform-translate-x: -4rem;
  }

  .sm\\:-translate-x-18{
    --transform-translate-x: -4.5rem;
  }

  .sm\\:-translate-x-20{
    --transform-translate-x: -5rem;
  }

  .sm\\:-translate-x-22{
    --transform-translate-x: -5.5rem;
  }

  .sm\\:-translate-x-23{
    --transform-translate-x: -5.75rem;
  }

  .sm\\:-translate-x-24{
    --transform-translate-x: -6rem;
  }

  .sm\\:-translate-x-25{
    --transform-translate-x: -6.25rem;
  }

  .sm\\:-translate-x-26{
    --transform-translate-x: -6.5rem;
  }

  .sm\\:-translate-x-28{
    --transform-translate-x: -7rem;
  }

  .sm\\:-translate-x-30{
    --transform-translate-x: -7.5rem;
  }

  .sm\\:-translate-x-32{
    --transform-translate-x: -8rem;
  }

  .sm\\:-translate-x-34{
    --transform-translate-x: -8.5rem;
  }

  .sm\\:-translate-x-40{
    --transform-translate-x: -10rem;
  }

  .sm\\:-translate-x-42{
    --transform-translate-x: -10.5rem;
  }

  .sm\\:-translate-x-44{
    --transform-translate-x: -11rem;
  }

  .sm\\:-translate-x-48{
    --transform-translate-x: -12rem;
  }

  .sm\\:-translate-x-52{
    --transform-translate-x: -13rem;
  }

  .sm\\:-translate-x-54{
    --transform-translate-x: -13.5rem;
  }

  .sm\\:-translate-x-56{
    --transform-translate-x: -14rem;
  }

  .sm\\:-translate-x-60{
    --transform-translate-x: -15rem;
  }

  .sm\\:-translate-x-64{
    --transform-translate-x: -16rem;
  }

  .sm\\:-translate-x-68{
    --transform-translate-x: -17rem;
  }

  .sm\\:-translate-x-72{
    --transform-translate-x: -18rem;
  }

  .sm\\:-translate-x-74{
    --transform-translate-x: -18.5rem;
  }

  .sm\\:-translate-x-76{
    --transform-translate-x: -19rem;
  }

  .sm\\:-translate-x-78{
    --transform-translate-x: -19.5rem;
  }

  .sm\\:-translate-x-80{
    --transform-translate-x: -20rem;
  }

  .sm\\:-translate-x-82{
    --transform-translate-x: -20.5rem;
  }

  .sm\\:-translate-x-84{
    --transform-translate-x: -21rem;
  }

  .sm\\:-translate-x-88{
    --transform-translate-x: -22rem;
  }

  .sm\\:-translate-x-92{
    --transform-translate-x: -23rem;
  }

  .sm\\:-translate-x-96{
    --transform-translate-x: -24rem;
  }

  .sm\\:-translate-x-98{
    --transform-translate-x: -24.5rem;
  }

  .sm\\:-translate-x-100{
    --transform-translate-x: -25rem;
  }

  .sm\\:-translate-x-104{
    --transform-translate-x: -26rem;
  }

  .sm\\:-translate-x-112{
    --transform-translate-x: -28rem;
  }

  .sm\\:-translate-x-124{
    --transform-translate-x: -31rem;
  }

  .sm\\:-translate-x-128{
    --transform-translate-x: -32rem;
  }

  .sm\\:-translate-x-140{
    --transform-translate-x: -35rem;
  }

  .sm\\:-translate-x-152{
    --transform-translate-x: -38rem;
  }

  .sm\\:-translate-x-160{
    --transform-translate-x: -40rem;
  }

  .sm\\:-translate-x-162{
    --transform-translate-x: -41rem;
  }

  .sm\\:-translate-x-192{
    --transform-translate-x: -48rem;
  }

  .sm\\:-translate-x-208{
    --transform-translate-x: -52rem;
  }

  .sm\\:-translate-x-224{
    --transform-translate-x: -56rem;
  }

  .sm\\:-translate-x-256{
    --transform-translate-x: -64rem;
  }

  .sm\\:-translate-x-px{
    --transform-translate-x: -1px;
  }

  .sm\\:-translate-x-full{
    --transform-translate-x: -100%;
  }

  .sm\\:-translate-x-1\\/2{
    --transform-translate-x: -50%;
  }

  .sm\\:translate-x-1\\/2{
    --transform-translate-x: 50%;
  }

  .sm\\:translate-x-full{
    --transform-translate-x: 100%;
  }

  .sm\\:translate-y-0{
    --transform-translate-y: 0;
  }

  .sm\\:translate-y-1{
    --transform-translate-y: 0.25rem;
  }

  .sm\\:translate-y-2{
    --transform-translate-y: 0.5rem;
  }

  .sm\\:translate-y-3{
    --transform-translate-y: 0.75rem;
  }

  .sm\\:translate-y-4{
    --transform-translate-y: 1rem;
  }

  .sm\\:translate-y-5{
    --transform-translate-y: 1.25rem;
  }

  .sm\\:translate-y-6{
    --transform-translate-y: 1.5rem;
  }

  .sm\\:translate-y-7{
    --transform-translate-y: 1.75rem;
  }

  .sm\\:translate-y-8{
    --transform-translate-y: 2rem;
  }

  .sm\\:translate-y-9{
    --transform-translate-y: 2.25rem;
  }

  .sm\\:translate-y-10{
    --transform-translate-y: 2.5rem;
  }

  .sm\\:translate-y-11{
    --transform-translate-y: 2.75rem;
  }

  .sm\\:translate-y-12{
    --transform-translate-y: 3rem;
  }

  .sm\\:translate-y-14{
    --transform-translate-y: 3.5rem;
  }

  .sm\\:translate-y-15{
    --transform-translate-y: 3.75rem;
  }

  .sm\\:translate-y-16{
    --transform-translate-y: 4rem;
  }

  .sm\\:translate-y-18{
    --transform-translate-y: 4.5rem;
  }

  .sm\\:translate-y-20{
    --transform-translate-y: 5rem;
  }

  .sm\\:translate-y-22{
    --transform-translate-y: 5.5rem;
  }

  .sm\\:translate-y-23{
    --transform-translate-y: 5.75rem;
  }

  .sm\\:translate-y-24{
    --transform-translate-y: 6rem;
  }

  .sm\\:translate-y-25{
    --transform-translate-y: 6.25rem;
  }

  .sm\\:translate-y-26{
    --transform-translate-y: 6.5rem;
  }

  .sm\\:translate-y-28{
    --transform-translate-y: 7rem;
  }

  .sm\\:translate-y-30{
    --transform-translate-y: 7.5rem;
  }

  .sm\\:translate-y-32{
    --transform-translate-y: 8rem;
  }

  .sm\\:translate-y-34{
    --transform-translate-y: 8.5rem;
  }

  .sm\\:translate-y-40{
    --transform-translate-y: 10rem;
  }

  .sm\\:translate-y-42{
    --transform-translate-y: 10.5rem;
  }

  .sm\\:translate-y-44{
    --transform-translate-y: 11rem;
  }

  .sm\\:translate-y-48{
    --transform-translate-y: 12rem;
  }

  .sm\\:translate-y-52{
    --transform-translate-y: 13rem;
  }

  .sm\\:translate-y-54{
    --transform-translate-y: 13.5rem;
  }

  .sm\\:translate-y-56{
    --transform-translate-y: 14rem;
  }

  .sm\\:translate-y-60{
    --transform-translate-y: 15rem;
  }

  .sm\\:translate-y-64{
    --transform-translate-y: 16rem;
  }

  .sm\\:translate-y-68{
    --transform-translate-y: 17rem;
  }

  .sm\\:translate-y-72{
    --transform-translate-y: 18rem;
  }

  .sm\\:translate-y-74{
    --transform-translate-y: 18.5rem;
  }

  .sm\\:translate-y-76{
    --transform-translate-y: 19rem;
  }

  .sm\\:translate-y-78{
    --transform-translate-y: 19.5rem;
  }

  .sm\\:translate-y-80{
    --transform-translate-y: 20rem;
  }

  .sm\\:translate-y-82{
    --transform-translate-y: 20.5rem;
  }

  .sm\\:translate-y-84{
    --transform-translate-y: 21rem;
  }

  .sm\\:translate-y-88{
    --transform-translate-y: 22rem;
  }

  .sm\\:translate-y-92{
    --transform-translate-y: 23rem;
  }

  .sm\\:translate-y-96{
    --transform-translate-y: 24rem;
  }

  .sm\\:translate-y-98{
    --transform-translate-y: 24.5rem;
  }

  .sm\\:translate-y-100{
    --transform-translate-y: 25rem;
  }

  .sm\\:translate-y-104{
    --transform-translate-y: 26rem;
  }

  .sm\\:translate-y-112{
    --transform-translate-y: 28rem;
  }

  .sm\\:translate-y-124{
    --transform-translate-y: 31rem;
  }

  .sm\\:translate-y-128{
    --transform-translate-y: 32rem;
  }

  .sm\\:translate-y-140{
    --transform-translate-y: 35rem;
  }

  .sm\\:translate-y-152{
    --transform-translate-y: 38rem;
  }

  .sm\\:translate-y-160{
    --transform-translate-y: 40rem;
  }

  .sm\\:translate-y-162{
    --transform-translate-y: 41rem;
  }

  .sm\\:translate-y-192{
    --transform-translate-y: 48rem;
  }

  .sm\\:translate-y-208{
    --transform-translate-y: 52rem;
  }

  .sm\\:translate-y-224{
    --transform-translate-y: 56rem;
  }

  .sm\\:translate-y-256{
    --transform-translate-y: 64rem;
  }

  .sm\\:translate-y-px{
    --transform-translate-y: 1px;
  }

  .sm\\:-translate-y-1{
    --transform-translate-y: -0.25rem;
  }

  .sm\\:-translate-y-2{
    --transform-translate-y: -0.5rem;
  }

  .sm\\:-translate-y-3{
    --transform-translate-y: -0.75rem;
  }

  .sm\\:-translate-y-4{
    --transform-translate-y: -1rem;
  }

  .sm\\:-translate-y-5{
    --transform-translate-y: -1.25rem;
  }

  .sm\\:-translate-y-6{
    --transform-translate-y: -1.5rem;
  }

  .sm\\:-translate-y-7{
    --transform-translate-y: -1.75rem;
  }

  .sm\\:-translate-y-8{
    --transform-translate-y: -2rem;
  }

  .sm\\:-translate-y-9{
    --transform-translate-y: -2.25rem;
  }

  .sm\\:-translate-y-10{
    --transform-translate-y: -2.5rem;
  }

  .sm\\:-translate-y-11{
    --transform-translate-y: -2.75rem;
  }

  .sm\\:-translate-y-12{
    --transform-translate-y: -3rem;
  }

  .sm\\:-translate-y-14{
    --transform-translate-y: -3.5rem;
  }

  .sm\\:-translate-y-15{
    --transform-translate-y: -3.75rem;
  }

  .sm\\:-translate-y-16{
    --transform-translate-y: -4rem;
  }

  .sm\\:-translate-y-18{
    --transform-translate-y: -4.5rem;
  }

  .sm\\:-translate-y-20{
    --transform-translate-y: -5rem;
  }

  .sm\\:-translate-y-22{
    --transform-translate-y: -5.5rem;
  }

  .sm\\:-translate-y-23{
    --transform-translate-y: -5.75rem;
  }

  .sm\\:-translate-y-24{
    --transform-translate-y: -6rem;
  }

  .sm\\:-translate-y-25{
    --transform-translate-y: -6.25rem;
  }

  .sm\\:-translate-y-26{
    --transform-translate-y: -6.5rem;
  }

  .sm\\:-translate-y-28{
    --transform-translate-y: -7rem;
  }

  .sm\\:-translate-y-30{
    --transform-translate-y: -7.5rem;
  }

  .sm\\:-translate-y-32{
    --transform-translate-y: -8rem;
  }

  .sm\\:-translate-y-34{
    --transform-translate-y: -8.5rem;
  }

  .sm\\:-translate-y-40{
    --transform-translate-y: -10rem;
  }

  .sm\\:-translate-y-42{
    --transform-translate-y: -10.5rem;
  }

  .sm\\:-translate-y-44{
    --transform-translate-y: -11rem;
  }

  .sm\\:-translate-y-48{
    --transform-translate-y: -12rem;
  }

  .sm\\:-translate-y-52{
    --transform-translate-y: -13rem;
  }

  .sm\\:-translate-y-54{
    --transform-translate-y: -13.5rem;
  }

  .sm\\:-translate-y-56{
    --transform-translate-y: -14rem;
  }

  .sm\\:-translate-y-60{
    --transform-translate-y: -15rem;
  }

  .sm\\:-translate-y-64{
    --transform-translate-y: -16rem;
  }

  .sm\\:-translate-y-68{
    --transform-translate-y: -17rem;
  }

  .sm\\:-translate-y-72{
    --transform-translate-y: -18rem;
  }

  .sm\\:-translate-y-74{
    --transform-translate-y: -18.5rem;
  }

  .sm\\:-translate-y-76{
    --transform-translate-y: -19rem;
  }

  .sm\\:-translate-y-78{
    --transform-translate-y: -19.5rem;
  }

  .sm\\:-translate-y-80{
    --transform-translate-y: -20rem;
  }

  .sm\\:-translate-y-82{
    --transform-translate-y: -20.5rem;
  }

  .sm\\:-translate-y-84{
    --transform-translate-y: -21rem;
  }

  .sm\\:-translate-y-88{
    --transform-translate-y: -22rem;
  }

  .sm\\:-translate-y-92{
    --transform-translate-y: -23rem;
  }

  .sm\\:-translate-y-96{
    --transform-translate-y: -24rem;
  }

  .sm\\:-translate-y-98{
    --transform-translate-y: -24.5rem;
  }

  .sm\\:-translate-y-100{
    --transform-translate-y: -25rem;
  }

  .sm\\:-translate-y-104{
    --transform-translate-y: -26rem;
  }

  .sm\\:-translate-y-112{
    --transform-translate-y: -28rem;
  }

  .sm\\:-translate-y-124{
    --transform-translate-y: -31rem;
  }

  .sm\\:-translate-y-128{
    --transform-translate-y: -32rem;
  }

  .sm\\:-translate-y-140{
    --transform-translate-y: -35rem;
  }

  .sm\\:-translate-y-152{
    --transform-translate-y: -38rem;
  }

  .sm\\:-translate-y-160{
    --transform-translate-y: -40rem;
  }

  .sm\\:-translate-y-162{
    --transform-translate-y: -41rem;
  }

  .sm\\:-translate-y-192{
    --transform-translate-y: -48rem;
  }

  .sm\\:-translate-y-208{
    --transform-translate-y: -52rem;
  }

  .sm\\:-translate-y-224{
    --transform-translate-y: -56rem;
  }

  .sm\\:-translate-y-256{
    --transform-translate-y: -64rem;
  }

  .sm\\:-translate-y-px{
    --transform-translate-y: -1px;
  }

  .sm\\:-translate-y-full{
    --transform-translate-y: -100%;
  }

  .sm\\:-translate-y-1\\/2{
    --transform-translate-y: -50%;
  }

  .sm\\:translate-y-1\\/2{
    --transform-translate-y: 50%;
  }

  .sm\\:translate-y-full{
    --transform-translate-y: 100%;
  }

  .sm\\:hover\\:translate-x-0:hover{
    --transform-translate-x: 0;
  }

  .sm\\:hover\\:translate-x-1:hover{
    --transform-translate-x: 0.25rem;
  }

  .sm\\:hover\\:translate-x-2:hover{
    --transform-translate-x: 0.5rem;
  }

  .sm\\:hover\\:translate-x-3:hover{
    --transform-translate-x: 0.75rem;
  }

  .sm\\:hover\\:translate-x-4:hover{
    --transform-translate-x: 1rem;
  }

  .sm\\:hover\\:translate-x-5:hover{
    --transform-translate-x: 1.25rem;
  }

  .sm\\:hover\\:translate-x-6:hover{
    --transform-translate-x: 1.5rem;
  }

  .sm\\:hover\\:translate-x-7:hover{
    --transform-translate-x: 1.75rem;
  }

  .sm\\:hover\\:translate-x-8:hover{
    --transform-translate-x: 2rem;
  }

  .sm\\:hover\\:translate-x-9:hover{
    --transform-translate-x: 2.25rem;
  }

  .sm\\:hover\\:translate-x-10:hover{
    --transform-translate-x: 2.5rem;
  }

  .sm\\:hover\\:translate-x-11:hover{
    --transform-translate-x: 2.75rem;
  }

  .sm\\:hover\\:translate-x-12:hover{
    --transform-translate-x: 3rem;
  }

  .sm\\:hover\\:translate-x-14:hover{
    --transform-translate-x: 3.5rem;
  }

  .sm\\:hover\\:translate-x-15:hover{
    --transform-translate-x: 3.75rem;
  }

  .sm\\:hover\\:translate-x-16:hover{
    --transform-translate-x: 4rem;
  }

  .sm\\:hover\\:translate-x-18:hover{
    --transform-translate-x: 4.5rem;
  }

  .sm\\:hover\\:translate-x-20:hover{
    --transform-translate-x: 5rem;
  }

  .sm\\:hover\\:translate-x-22:hover{
    --transform-translate-x: 5.5rem;
  }

  .sm\\:hover\\:translate-x-23:hover{
    --transform-translate-x: 5.75rem;
  }

  .sm\\:hover\\:translate-x-24:hover{
    --transform-translate-x: 6rem;
  }

  .sm\\:hover\\:translate-x-25:hover{
    --transform-translate-x: 6.25rem;
  }

  .sm\\:hover\\:translate-x-26:hover{
    --transform-translate-x: 6.5rem;
  }

  .sm\\:hover\\:translate-x-28:hover{
    --transform-translate-x: 7rem;
  }

  .sm\\:hover\\:translate-x-30:hover{
    --transform-translate-x: 7.5rem;
  }

  .sm\\:hover\\:translate-x-32:hover{
    --transform-translate-x: 8rem;
  }

  .sm\\:hover\\:translate-x-34:hover{
    --transform-translate-x: 8.5rem;
  }

  .sm\\:hover\\:translate-x-40:hover{
    --transform-translate-x: 10rem;
  }

  .sm\\:hover\\:translate-x-42:hover{
    --transform-translate-x: 10.5rem;
  }

  .sm\\:hover\\:translate-x-44:hover{
    --transform-translate-x: 11rem;
  }

  .sm\\:hover\\:translate-x-48:hover{
    --transform-translate-x: 12rem;
  }

  .sm\\:hover\\:translate-x-52:hover{
    --transform-translate-x: 13rem;
  }

  .sm\\:hover\\:translate-x-54:hover{
    --transform-translate-x: 13.5rem;
  }

  .sm\\:hover\\:translate-x-56:hover{
    --transform-translate-x: 14rem;
  }

  .sm\\:hover\\:translate-x-60:hover{
    --transform-translate-x: 15rem;
  }

  .sm\\:hover\\:translate-x-64:hover{
    --transform-translate-x: 16rem;
  }

  .sm\\:hover\\:translate-x-68:hover{
    --transform-translate-x: 17rem;
  }

  .sm\\:hover\\:translate-x-72:hover{
    --transform-translate-x: 18rem;
  }

  .sm\\:hover\\:translate-x-74:hover{
    --transform-translate-x: 18.5rem;
  }

  .sm\\:hover\\:translate-x-76:hover{
    --transform-translate-x: 19rem;
  }

  .sm\\:hover\\:translate-x-78:hover{
    --transform-translate-x: 19.5rem;
  }

  .sm\\:hover\\:translate-x-80:hover{
    --transform-translate-x: 20rem;
  }

  .sm\\:hover\\:translate-x-82:hover{
    --transform-translate-x: 20.5rem;
  }

  .sm\\:hover\\:translate-x-84:hover{
    --transform-translate-x: 21rem;
  }

  .sm\\:hover\\:translate-x-88:hover{
    --transform-translate-x: 22rem;
  }

  .sm\\:hover\\:translate-x-92:hover{
    --transform-translate-x: 23rem;
  }

  .sm\\:hover\\:translate-x-96:hover{
    --transform-translate-x: 24rem;
  }

  .sm\\:hover\\:translate-x-98:hover{
    --transform-translate-x: 24.5rem;
  }

  .sm\\:hover\\:translate-x-100:hover{
    --transform-translate-x: 25rem;
  }

  .sm\\:hover\\:translate-x-104:hover{
    --transform-translate-x: 26rem;
  }

  .sm\\:hover\\:translate-x-112:hover{
    --transform-translate-x: 28rem;
  }

  .sm\\:hover\\:translate-x-124:hover{
    --transform-translate-x: 31rem;
  }

  .sm\\:hover\\:translate-x-128:hover{
    --transform-translate-x: 32rem;
  }

  .sm\\:hover\\:translate-x-140:hover{
    --transform-translate-x: 35rem;
  }

  .sm\\:hover\\:translate-x-152:hover{
    --transform-translate-x: 38rem;
  }

  .sm\\:hover\\:translate-x-160:hover{
    --transform-translate-x: 40rem;
  }

  .sm\\:hover\\:translate-x-162:hover{
    --transform-translate-x: 41rem;
  }

  .sm\\:hover\\:translate-x-192:hover{
    --transform-translate-x: 48rem;
  }

  .sm\\:hover\\:translate-x-208:hover{
    --transform-translate-x: 52rem;
  }

  .sm\\:hover\\:translate-x-224:hover{
    --transform-translate-x: 56rem;
  }

  .sm\\:hover\\:translate-x-256:hover{
    --transform-translate-x: 64rem;
  }

  .sm\\:hover\\:translate-x-px:hover{
    --transform-translate-x: 1px;
  }

  .sm\\:hover\\:-translate-x-1:hover{
    --transform-translate-x: -0.25rem;
  }

  .sm\\:hover\\:-translate-x-2:hover{
    --transform-translate-x: -0.5rem;
  }

  .sm\\:hover\\:-translate-x-3:hover{
    --transform-translate-x: -0.75rem;
  }

  .sm\\:hover\\:-translate-x-4:hover{
    --transform-translate-x: -1rem;
  }

  .sm\\:hover\\:-translate-x-5:hover{
    --transform-translate-x: -1.25rem;
  }

  .sm\\:hover\\:-translate-x-6:hover{
    --transform-translate-x: -1.5rem;
  }

  .sm\\:hover\\:-translate-x-7:hover{
    --transform-translate-x: -1.75rem;
  }

  .sm\\:hover\\:-translate-x-8:hover{
    --transform-translate-x: -2rem;
  }

  .sm\\:hover\\:-translate-x-9:hover{
    --transform-translate-x: -2.25rem;
  }

  .sm\\:hover\\:-translate-x-10:hover{
    --transform-translate-x: -2.5rem;
  }

  .sm\\:hover\\:-translate-x-11:hover{
    --transform-translate-x: -2.75rem;
  }

  .sm\\:hover\\:-translate-x-12:hover{
    --transform-translate-x: -3rem;
  }

  .sm\\:hover\\:-translate-x-14:hover{
    --transform-translate-x: -3.5rem;
  }

  .sm\\:hover\\:-translate-x-15:hover{
    --transform-translate-x: -3.75rem;
  }

  .sm\\:hover\\:-translate-x-16:hover{
    --transform-translate-x: -4rem;
  }

  .sm\\:hover\\:-translate-x-18:hover{
    --transform-translate-x: -4.5rem;
  }

  .sm\\:hover\\:-translate-x-20:hover{
    --transform-translate-x: -5rem;
  }

  .sm\\:hover\\:-translate-x-22:hover{
    --transform-translate-x: -5.5rem;
  }

  .sm\\:hover\\:-translate-x-23:hover{
    --transform-translate-x: -5.75rem;
  }

  .sm\\:hover\\:-translate-x-24:hover{
    --transform-translate-x: -6rem;
  }

  .sm\\:hover\\:-translate-x-25:hover{
    --transform-translate-x: -6.25rem;
  }

  .sm\\:hover\\:-translate-x-26:hover{
    --transform-translate-x: -6.5rem;
  }

  .sm\\:hover\\:-translate-x-28:hover{
    --transform-translate-x: -7rem;
  }

  .sm\\:hover\\:-translate-x-30:hover{
    --transform-translate-x: -7.5rem;
  }

  .sm\\:hover\\:-translate-x-32:hover{
    --transform-translate-x: -8rem;
  }

  .sm\\:hover\\:-translate-x-34:hover{
    --transform-translate-x: -8.5rem;
  }

  .sm\\:hover\\:-translate-x-40:hover{
    --transform-translate-x: -10rem;
  }

  .sm\\:hover\\:-translate-x-42:hover{
    --transform-translate-x: -10.5rem;
  }

  .sm\\:hover\\:-translate-x-44:hover{
    --transform-translate-x: -11rem;
  }

  .sm\\:hover\\:-translate-x-48:hover{
    --transform-translate-x: -12rem;
  }

  .sm\\:hover\\:-translate-x-52:hover{
    --transform-translate-x: -13rem;
  }

  .sm\\:hover\\:-translate-x-54:hover{
    --transform-translate-x: -13.5rem;
  }

  .sm\\:hover\\:-translate-x-56:hover{
    --transform-translate-x: -14rem;
  }

  .sm\\:hover\\:-translate-x-60:hover{
    --transform-translate-x: -15rem;
  }

  .sm\\:hover\\:-translate-x-64:hover{
    --transform-translate-x: -16rem;
  }

  .sm\\:hover\\:-translate-x-68:hover{
    --transform-translate-x: -17rem;
  }

  .sm\\:hover\\:-translate-x-72:hover{
    --transform-translate-x: -18rem;
  }

  .sm\\:hover\\:-translate-x-74:hover{
    --transform-translate-x: -18.5rem;
  }

  .sm\\:hover\\:-translate-x-76:hover{
    --transform-translate-x: -19rem;
  }

  .sm\\:hover\\:-translate-x-78:hover{
    --transform-translate-x: -19.5rem;
  }

  .sm\\:hover\\:-translate-x-80:hover{
    --transform-translate-x: -20rem;
  }

  .sm\\:hover\\:-translate-x-82:hover{
    --transform-translate-x: -20.5rem;
  }

  .sm\\:hover\\:-translate-x-84:hover{
    --transform-translate-x: -21rem;
  }

  .sm\\:hover\\:-translate-x-88:hover{
    --transform-translate-x: -22rem;
  }

  .sm\\:hover\\:-translate-x-92:hover{
    --transform-translate-x: -23rem;
  }

  .sm\\:hover\\:-translate-x-96:hover{
    --transform-translate-x: -24rem;
  }

  .sm\\:hover\\:-translate-x-98:hover{
    --transform-translate-x: -24.5rem;
  }

  .sm\\:hover\\:-translate-x-100:hover{
    --transform-translate-x: -25rem;
  }

  .sm\\:hover\\:-translate-x-104:hover{
    --transform-translate-x: -26rem;
  }

  .sm\\:hover\\:-translate-x-112:hover{
    --transform-translate-x: -28rem;
  }

  .sm\\:hover\\:-translate-x-124:hover{
    --transform-translate-x: -31rem;
  }

  .sm\\:hover\\:-translate-x-128:hover{
    --transform-translate-x: -32rem;
  }

  .sm\\:hover\\:-translate-x-140:hover{
    --transform-translate-x: -35rem;
  }

  .sm\\:hover\\:-translate-x-152:hover{
    --transform-translate-x: -38rem;
  }

  .sm\\:hover\\:-translate-x-160:hover{
    --transform-translate-x: -40rem;
  }

  .sm\\:hover\\:-translate-x-162:hover{
    --transform-translate-x: -41rem;
  }

  .sm\\:hover\\:-translate-x-192:hover{
    --transform-translate-x: -48rem;
  }

  .sm\\:hover\\:-translate-x-208:hover{
    --transform-translate-x: -52rem;
  }

  .sm\\:hover\\:-translate-x-224:hover{
    --transform-translate-x: -56rem;
  }

  .sm\\:hover\\:-translate-x-256:hover{
    --transform-translate-x: -64rem;
  }

  .sm\\:hover\\:-translate-x-px:hover{
    --transform-translate-x: -1px;
  }

  .sm\\:hover\\:-translate-x-full:hover{
    --transform-translate-x: -100%;
  }

  .sm\\:hover\\:-translate-x-1\\/2:hover{
    --transform-translate-x: -50%;
  }

  .sm\\:hover\\:translate-x-1\\/2:hover{
    --transform-translate-x: 50%;
  }

  .sm\\:hover\\:translate-x-full:hover{
    --transform-translate-x: 100%;
  }

  .sm\\:hover\\:translate-y-0:hover{
    --transform-translate-y: 0;
  }

  .sm\\:hover\\:translate-y-1:hover{
    --transform-translate-y: 0.25rem;
  }

  .sm\\:hover\\:translate-y-2:hover{
    --transform-translate-y: 0.5rem;
  }

  .sm\\:hover\\:translate-y-3:hover{
    --transform-translate-y: 0.75rem;
  }

  .sm\\:hover\\:translate-y-4:hover{
    --transform-translate-y: 1rem;
  }

  .sm\\:hover\\:translate-y-5:hover{
    --transform-translate-y: 1.25rem;
  }

  .sm\\:hover\\:translate-y-6:hover{
    --transform-translate-y: 1.5rem;
  }

  .sm\\:hover\\:translate-y-7:hover{
    --transform-translate-y: 1.75rem;
  }

  .sm\\:hover\\:translate-y-8:hover{
    --transform-translate-y: 2rem;
  }

  .sm\\:hover\\:translate-y-9:hover{
    --transform-translate-y: 2.25rem;
  }

  .sm\\:hover\\:translate-y-10:hover{
    --transform-translate-y: 2.5rem;
  }

  .sm\\:hover\\:translate-y-11:hover{
    --transform-translate-y: 2.75rem;
  }

  .sm\\:hover\\:translate-y-12:hover{
    --transform-translate-y: 3rem;
  }

  .sm\\:hover\\:translate-y-14:hover{
    --transform-translate-y: 3.5rem;
  }

  .sm\\:hover\\:translate-y-15:hover{
    --transform-translate-y: 3.75rem;
  }

  .sm\\:hover\\:translate-y-16:hover{
    --transform-translate-y: 4rem;
  }

  .sm\\:hover\\:translate-y-18:hover{
    --transform-translate-y: 4.5rem;
  }

  .sm\\:hover\\:translate-y-20:hover{
    --transform-translate-y: 5rem;
  }

  .sm\\:hover\\:translate-y-22:hover{
    --transform-translate-y: 5.5rem;
  }

  .sm\\:hover\\:translate-y-23:hover{
    --transform-translate-y: 5.75rem;
  }

  .sm\\:hover\\:translate-y-24:hover{
    --transform-translate-y: 6rem;
  }

  .sm\\:hover\\:translate-y-25:hover{
    --transform-translate-y: 6.25rem;
  }

  .sm\\:hover\\:translate-y-26:hover{
    --transform-translate-y: 6.5rem;
  }

  .sm\\:hover\\:translate-y-28:hover{
    --transform-translate-y: 7rem;
  }

  .sm\\:hover\\:translate-y-30:hover{
    --transform-translate-y: 7.5rem;
  }

  .sm\\:hover\\:translate-y-32:hover{
    --transform-translate-y: 8rem;
  }

  .sm\\:hover\\:translate-y-34:hover{
    --transform-translate-y: 8.5rem;
  }

  .sm\\:hover\\:translate-y-40:hover{
    --transform-translate-y: 10rem;
  }

  .sm\\:hover\\:translate-y-42:hover{
    --transform-translate-y: 10.5rem;
  }

  .sm\\:hover\\:translate-y-44:hover{
    --transform-translate-y: 11rem;
  }

  .sm\\:hover\\:translate-y-48:hover{
    --transform-translate-y: 12rem;
  }

  .sm\\:hover\\:translate-y-52:hover{
    --transform-translate-y: 13rem;
  }

  .sm\\:hover\\:translate-y-54:hover{
    --transform-translate-y: 13.5rem;
  }

  .sm\\:hover\\:translate-y-56:hover{
    --transform-translate-y: 14rem;
  }

  .sm\\:hover\\:translate-y-60:hover{
    --transform-translate-y: 15rem;
  }

  .sm\\:hover\\:translate-y-64:hover{
    --transform-translate-y: 16rem;
  }

  .sm\\:hover\\:translate-y-68:hover{
    --transform-translate-y: 17rem;
  }

  .sm\\:hover\\:translate-y-72:hover{
    --transform-translate-y: 18rem;
  }

  .sm\\:hover\\:translate-y-74:hover{
    --transform-translate-y: 18.5rem;
  }

  .sm\\:hover\\:translate-y-76:hover{
    --transform-translate-y: 19rem;
  }

  .sm\\:hover\\:translate-y-78:hover{
    --transform-translate-y: 19.5rem;
  }

  .sm\\:hover\\:translate-y-80:hover{
    --transform-translate-y: 20rem;
  }

  .sm\\:hover\\:translate-y-82:hover{
    --transform-translate-y: 20.5rem;
  }

  .sm\\:hover\\:translate-y-84:hover{
    --transform-translate-y: 21rem;
  }

  .sm\\:hover\\:translate-y-88:hover{
    --transform-translate-y: 22rem;
  }

  .sm\\:hover\\:translate-y-92:hover{
    --transform-translate-y: 23rem;
  }

  .sm\\:hover\\:translate-y-96:hover{
    --transform-translate-y: 24rem;
  }

  .sm\\:hover\\:translate-y-98:hover{
    --transform-translate-y: 24.5rem;
  }

  .sm\\:hover\\:translate-y-100:hover{
    --transform-translate-y: 25rem;
  }

  .sm\\:hover\\:translate-y-104:hover{
    --transform-translate-y: 26rem;
  }

  .sm\\:hover\\:translate-y-112:hover{
    --transform-translate-y: 28rem;
  }

  .sm\\:hover\\:translate-y-124:hover{
    --transform-translate-y: 31rem;
  }

  .sm\\:hover\\:translate-y-128:hover{
    --transform-translate-y: 32rem;
  }

  .sm\\:hover\\:translate-y-140:hover{
    --transform-translate-y: 35rem;
  }

  .sm\\:hover\\:translate-y-152:hover{
    --transform-translate-y: 38rem;
  }

  .sm\\:hover\\:translate-y-160:hover{
    --transform-translate-y: 40rem;
  }

  .sm\\:hover\\:translate-y-162:hover{
    --transform-translate-y: 41rem;
  }

  .sm\\:hover\\:translate-y-192:hover{
    --transform-translate-y: 48rem;
  }

  .sm\\:hover\\:translate-y-208:hover{
    --transform-translate-y: 52rem;
  }

  .sm\\:hover\\:translate-y-224:hover{
    --transform-translate-y: 56rem;
  }

  .sm\\:hover\\:translate-y-256:hover{
    --transform-translate-y: 64rem;
  }

  .sm\\:hover\\:translate-y-px:hover{
    --transform-translate-y: 1px;
  }

  .sm\\:hover\\:-translate-y-1:hover{
    --transform-translate-y: -0.25rem;
  }

  .sm\\:hover\\:-translate-y-2:hover{
    --transform-translate-y: -0.5rem;
  }

  .sm\\:hover\\:-translate-y-3:hover{
    --transform-translate-y: -0.75rem;
  }

  .sm\\:hover\\:-translate-y-4:hover{
    --transform-translate-y: -1rem;
  }

  .sm\\:hover\\:-translate-y-5:hover{
    --transform-translate-y: -1.25rem;
  }

  .sm\\:hover\\:-translate-y-6:hover{
    --transform-translate-y: -1.5rem;
  }

  .sm\\:hover\\:-translate-y-7:hover{
    --transform-translate-y: -1.75rem;
  }

  .sm\\:hover\\:-translate-y-8:hover{
    --transform-translate-y: -2rem;
  }

  .sm\\:hover\\:-translate-y-9:hover{
    --transform-translate-y: -2.25rem;
  }

  .sm\\:hover\\:-translate-y-10:hover{
    --transform-translate-y: -2.5rem;
  }

  .sm\\:hover\\:-translate-y-11:hover{
    --transform-translate-y: -2.75rem;
  }

  .sm\\:hover\\:-translate-y-12:hover{
    --transform-translate-y: -3rem;
  }

  .sm\\:hover\\:-translate-y-14:hover{
    --transform-translate-y: -3.5rem;
  }

  .sm\\:hover\\:-translate-y-15:hover{
    --transform-translate-y: -3.75rem;
  }

  .sm\\:hover\\:-translate-y-16:hover{
    --transform-translate-y: -4rem;
  }

  .sm\\:hover\\:-translate-y-18:hover{
    --transform-translate-y: -4.5rem;
  }

  .sm\\:hover\\:-translate-y-20:hover{
    --transform-translate-y: -5rem;
  }

  .sm\\:hover\\:-translate-y-22:hover{
    --transform-translate-y: -5.5rem;
  }

  .sm\\:hover\\:-translate-y-23:hover{
    --transform-translate-y: -5.75rem;
  }

  .sm\\:hover\\:-translate-y-24:hover{
    --transform-translate-y: -6rem;
  }

  .sm\\:hover\\:-translate-y-25:hover{
    --transform-translate-y: -6.25rem;
  }

  .sm\\:hover\\:-translate-y-26:hover{
    --transform-translate-y: -6.5rem;
  }

  .sm\\:hover\\:-translate-y-28:hover{
    --transform-translate-y: -7rem;
  }

  .sm\\:hover\\:-translate-y-30:hover{
    --transform-translate-y: -7.5rem;
  }

  .sm\\:hover\\:-translate-y-32:hover{
    --transform-translate-y: -8rem;
  }

  .sm\\:hover\\:-translate-y-34:hover{
    --transform-translate-y: -8.5rem;
  }

  .sm\\:hover\\:-translate-y-40:hover{
    --transform-translate-y: -10rem;
  }

  .sm\\:hover\\:-translate-y-42:hover{
    --transform-translate-y: -10.5rem;
  }

  .sm\\:hover\\:-translate-y-44:hover{
    --transform-translate-y: -11rem;
  }

  .sm\\:hover\\:-translate-y-48:hover{
    --transform-translate-y: -12rem;
  }

  .sm\\:hover\\:-translate-y-52:hover{
    --transform-translate-y: -13rem;
  }

  .sm\\:hover\\:-translate-y-54:hover{
    --transform-translate-y: -13.5rem;
  }

  .sm\\:hover\\:-translate-y-56:hover{
    --transform-translate-y: -14rem;
  }

  .sm\\:hover\\:-translate-y-60:hover{
    --transform-translate-y: -15rem;
  }

  .sm\\:hover\\:-translate-y-64:hover{
    --transform-translate-y: -16rem;
  }

  .sm\\:hover\\:-translate-y-68:hover{
    --transform-translate-y: -17rem;
  }

  .sm\\:hover\\:-translate-y-72:hover{
    --transform-translate-y: -18rem;
  }

  .sm\\:hover\\:-translate-y-74:hover{
    --transform-translate-y: -18.5rem;
  }

  .sm\\:hover\\:-translate-y-76:hover{
    --transform-translate-y: -19rem;
  }

  .sm\\:hover\\:-translate-y-78:hover{
    --transform-translate-y: -19.5rem;
  }

  .sm\\:hover\\:-translate-y-80:hover{
    --transform-translate-y: -20rem;
  }

  .sm\\:hover\\:-translate-y-82:hover{
    --transform-translate-y: -20.5rem;
  }

  .sm\\:hover\\:-translate-y-84:hover{
    --transform-translate-y: -21rem;
  }

  .sm\\:hover\\:-translate-y-88:hover{
    --transform-translate-y: -22rem;
  }

  .sm\\:hover\\:-translate-y-92:hover{
    --transform-translate-y: -23rem;
  }

  .sm\\:hover\\:-translate-y-96:hover{
    --transform-translate-y: -24rem;
  }

  .sm\\:hover\\:-translate-y-98:hover{
    --transform-translate-y: -24.5rem;
  }

  .sm\\:hover\\:-translate-y-100:hover{
    --transform-translate-y: -25rem;
  }

  .sm\\:hover\\:-translate-y-104:hover{
    --transform-translate-y: -26rem;
  }

  .sm\\:hover\\:-translate-y-112:hover{
    --transform-translate-y: -28rem;
  }

  .sm\\:hover\\:-translate-y-124:hover{
    --transform-translate-y: -31rem;
  }

  .sm\\:hover\\:-translate-y-128:hover{
    --transform-translate-y: -32rem;
  }

  .sm\\:hover\\:-translate-y-140:hover{
    --transform-translate-y: -35rem;
  }

  .sm\\:hover\\:-translate-y-152:hover{
    --transform-translate-y: -38rem;
  }

  .sm\\:hover\\:-translate-y-160:hover{
    --transform-translate-y: -40rem;
  }

  .sm\\:hover\\:-translate-y-162:hover{
    --transform-translate-y: -41rem;
  }

  .sm\\:hover\\:-translate-y-192:hover{
    --transform-translate-y: -48rem;
  }

  .sm\\:hover\\:-translate-y-208:hover{
    --transform-translate-y: -52rem;
  }

  .sm\\:hover\\:-translate-y-224:hover{
    --transform-translate-y: -56rem;
  }

  .sm\\:hover\\:-translate-y-256:hover{
    --transform-translate-y: -64rem;
  }

  .sm\\:hover\\:-translate-y-px:hover{
    --transform-translate-y: -1px;
  }

  .sm\\:hover\\:-translate-y-full:hover{
    --transform-translate-y: -100%;
  }

  .sm\\:hover\\:-translate-y-1\\/2:hover{
    --transform-translate-y: -50%;
  }

  .sm\\:hover\\:translate-y-1\\/2:hover{
    --transform-translate-y: 50%;
  }

  .sm\\:hover\\:translate-y-full:hover{
    --transform-translate-y: 100%;
  }

  .sm\\:focus\\:translate-x-0:focus{
    --transform-translate-x: 0;
  }

  .sm\\:focus\\:translate-x-1:focus{
    --transform-translate-x: 0.25rem;
  }

  .sm\\:focus\\:translate-x-2:focus{
    --transform-translate-x: 0.5rem;
  }

  .sm\\:focus\\:translate-x-3:focus{
    --transform-translate-x: 0.75rem;
  }

  .sm\\:focus\\:translate-x-4:focus{
    --transform-translate-x: 1rem;
  }

  .sm\\:focus\\:translate-x-5:focus{
    --transform-translate-x: 1.25rem;
  }

  .sm\\:focus\\:translate-x-6:focus{
    --transform-translate-x: 1.5rem;
  }

  .sm\\:focus\\:translate-x-7:focus{
    --transform-translate-x: 1.75rem;
  }

  .sm\\:focus\\:translate-x-8:focus{
    --transform-translate-x: 2rem;
  }

  .sm\\:focus\\:translate-x-9:focus{
    --transform-translate-x: 2.25rem;
  }

  .sm\\:focus\\:translate-x-10:focus{
    --transform-translate-x: 2.5rem;
  }

  .sm\\:focus\\:translate-x-11:focus{
    --transform-translate-x: 2.75rem;
  }

  .sm\\:focus\\:translate-x-12:focus{
    --transform-translate-x: 3rem;
  }

  .sm\\:focus\\:translate-x-14:focus{
    --transform-translate-x: 3.5rem;
  }

  .sm\\:focus\\:translate-x-15:focus{
    --transform-translate-x: 3.75rem;
  }

  .sm\\:focus\\:translate-x-16:focus{
    --transform-translate-x: 4rem;
  }

  .sm\\:focus\\:translate-x-18:focus{
    --transform-translate-x: 4.5rem;
  }

  .sm\\:focus\\:translate-x-20:focus{
    --transform-translate-x: 5rem;
  }

  .sm\\:focus\\:translate-x-22:focus{
    --transform-translate-x: 5.5rem;
  }

  .sm\\:focus\\:translate-x-23:focus{
    --transform-translate-x: 5.75rem;
  }

  .sm\\:focus\\:translate-x-24:focus{
    --transform-translate-x: 6rem;
  }

  .sm\\:focus\\:translate-x-25:focus{
    --transform-translate-x: 6.25rem;
  }

  .sm\\:focus\\:translate-x-26:focus{
    --transform-translate-x: 6.5rem;
  }

  .sm\\:focus\\:translate-x-28:focus{
    --transform-translate-x: 7rem;
  }

  .sm\\:focus\\:translate-x-30:focus{
    --transform-translate-x: 7.5rem;
  }

  .sm\\:focus\\:translate-x-32:focus{
    --transform-translate-x: 8rem;
  }

  .sm\\:focus\\:translate-x-34:focus{
    --transform-translate-x: 8.5rem;
  }

  .sm\\:focus\\:translate-x-40:focus{
    --transform-translate-x: 10rem;
  }

  .sm\\:focus\\:translate-x-42:focus{
    --transform-translate-x: 10.5rem;
  }

  .sm\\:focus\\:translate-x-44:focus{
    --transform-translate-x: 11rem;
  }

  .sm\\:focus\\:translate-x-48:focus{
    --transform-translate-x: 12rem;
  }

  .sm\\:focus\\:translate-x-52:focus{
    --transform-translate-x: 13rem;
  }

  .sm\\:focus\\:translate-x-54:focus{
    --transform-translate-x: 13.5rem;
  }

  .sm\\:focus\\:translate-x-56:focus{
    --transform-translate-x: 14rem;
  }

  .sm\\:focus\\:translate-x-60:focus{
    --transform-translate-x: 15rem;
  }

  .sm\\:focus\\:translate-x-64:focus{
    --transform-translate-x: 16rem;
  }

  .sm\\:focus\\:translate-x-68:focus{
    --transform-translate-x: 17rem;
  }

  .sm\\:focus\\:translate-x-72:focus{
    --transform-translate-x: 18rem;
  }

  .sm\\:focus\\:translate-x-74:focus{
    --transform-translate-x: 18.5rem;
  }

  .sm\\:focus\\:translate-x-76:focus{
    --transform-translate-x: 19rem;
  }

  .sm\\:focus\\:translate-x-78:focus{
    --transform-translate-x: 19.5rem;
  }

  .sm\\:focus\\:translate-x-80:focus{
    --transform-translate-x: 20rem;
  }

  .sm\\:focus\\:translate-x-82:focus{
    --transform-translate-x: 20.5rem;
  }

  .sm\\:focus\\:translate-x-84:focus{
    --transform-translate-x: 21rem;
  }

  .sm\\:focus\\:translate-x-88:focus{
    --transform-translate-x: 22rem;
  }

  .sm\\:focus\\:translate-x-92:focus{
    --transform-translate-x: 23rem;
  }

  .sm\\:focus\\:translate-x-96:focus{
    --transform-translate-x: 24rem;
  }

  .sm\\:focus\\:translate-x-98:focus{
    --transform-translate-x: 24.5rem;
  }

  .sm\\:focus\\:translate-x-100:focus{
    --transform-translate-x: 25rem;
  }

  .sm\\:focus\\:translate-x-104:focus{
    --transform-translate-x: 26rem;
  }

  .sm\\:focus\\:translate-x-112:focus{
    --transform-translate-x: 28rem;
  }

  .sm\\:focus\\:translate-x-124:focus{
    --transform-translate-x: 31rem;
  }

  .sm\\:focus\\:translate-x-128:focus{
    --transform-translate-x: 32rem;
  }

  .sm\\:focus\\:translate-x-140:focus{
    --transform-translate-x: 35rem;
  }

  .sm\\:focus\\:translate-x-152:focus{
    --transform-translate-x: 38rem;
  }

  .sm\\:focus\\:translate-x-160:focus{
    --transform-translate-x: 40rem;
  }

  .sm\\:focus\\:translate-x-162:focus{
    --transform-translate-x: 41rem;
  }

  .sm\\:focus\\:translate-x-192:focus{
    --transform-translate-x: 48rem;
  }

  .sm\\:focus\\:translate-x-208:focus{
    --transform-translate-x: 52rem;
  }

  .sm\\:focus\\:translate-x-224:focus{
    --transform-translate-x: 56rem;
  }

  .sm\\:focus\\:translate-x-256:focus{
    --transform-translate-x: 64rem;
  }

  .sm\\:focus\\:translate-x-px:focus{
    --transform-translate-x: 1px;
  }

  .sm\\:focus\\:-translate-x-1:focus{
    --transform-translate-x: -0.25rem;
  }

  .sm\\:focus\\:-translate-x-2:focus{
    --transform-translate-x: -0.5rem;
  }

  .sm\\:focus\\:-translate-x-3:focus{
    --transform-translate-x: -0.75rem;
  }

  .sm\\:focus\\:-translate-x-4:focus{
    --transform-translate-x: -1rem;
  }

  .sm\\:focus\\:-translate-x-5:focus{
    --transform-translate-x: -1.25rem;
  }

  .sm\\:focus\\:-translate-x-6:focus{
    --transform-translate-x: -1.5rem;
  }

  .sm\\:focus\\:-translate-x-7:focus{
    --transform-translate-x: -1.75rem;
  }

  .sm\\:focus\\:-translate-x-8:focus{
    --transform-translate-x: -2rem;
  }

  .sm\\:focus\\:-translate-x-9:focus{
    --transform-translate-x: -2.25rem;
  }

  .sm\\:focus\\:-translate-x-10:focus{
    --transform-translate-x: -2.5rem;
  }

  .sm\\:focus\\:-translate-x-11:focus{
    --transform-translate-x: -2.75rem;
  }

  .sm\\:focus\\:-translate-x-12:focus{
    --transform-translate-x: -3rem;
  }

  .sm\\:focus\\:-translate-x-14:focus{
    --transform-translate-x: -3.5rem;
  }

  .sm\\:focus\\:-translate-x-15:focus{
    --transform-translate-x: -3.75rem;
  }

  .sm\\:focus\\:-translate-x-16:focus{
    --transform-translate-x: -4rem;
  }

  .sm\\:focus\\:-translate-x-18:focus{
    --transform-translate-x: -4.5rem;
  }

  .sm\\:focus\\:-translate-x-20:focus{
    --transform-translate-x: -5rem;
  }

  .sm\\:focus\\:-translate-x-22:focus{
    --transform-translate-x: -5.5rem;
  }

  .sm\\:focus\\:-translate-x-23:focus{
    --transform-translate-x: -5.75rem;
  }

  .sm\\:focus\\:-translate-x-24:focus{
    --transform-translate-x: -6rem;
  }

  .sm\\:focus\\:-translate-x-25:focus{
    --transform-translate-x: -6.25rem;
  }

  .sm\\:focus\\:-translate-x-26:focus{
    --transform-translate-x: -6.5rem;
  }

  .sm\\:focus\\:-translate-x-28:focus{
    --transform-translate-x: -7rem;
  }

  .sm\\:focus\\:-translate-x-30:focus{
    --transform-translate-x: -7.5rem;
  }

  .sm\\:focus\\:-translate-x-32:focus{
    --transform-translate-x: -8rem;
  }

  .sm\\:focus\\:-translate-x-34:focus{
    --transform-translate-x: -8.5rem;
  }

  .sm\\:focus\\:-translate-x-40:focus{
    --transform-translate-x: -10rem;
  }

  .sm\\:focus\\:-translate-x-42:focus{
    --transform-translate-x: -10.5rem;
  }

  .sm\\:focus\\:-translate-x-44:focus{
    --transform-translate-x: -11rem;
  }

  .sm\\:focus\\:-translate-x-48:focus{
    --transform-translate-x: -12rem;
  }

  .sm\\:focus\\:-translate-x-52:focus{
    --transform-translate-x: -13rem;
  }

  .sm\\:focus\\:-translate-x-54:focus{
    --transform-translate-x: -13.5rem;
  }

  .sm\\:focus\\:-translate-x-56:focus{
    --transform-translate-x: -14rem;
  }

  .sm\\:focus\\:-translate-x-60:focus{
    --transform-translate-x: -15rem;
  }

  .sm\\:focus\\:-translate-x-64:focus{
    --transform-translate-x: -16rem;
  }

  .sm\\:focus\\:-translate-x-68:focus{
    --transform-translate-x: -17rem;
  }

  .sm\\:focus\\:-translate-x-72:focus{
    --transform-translate-x: -18rem;
  }

  .sm\\:focus\\:-translate-x-74:focus{
    --transform-translate-x: -18.5rem;
  }

  .sm\\:focus\\:-translate-x-76:focus{
    --transform-translate-x: -19rem;
  }

  .sm\\:focus\\:-translate-x-78:focus{
    --transform-translate-x: -19.5rem;
  }

  .sm\\:focus\\:-translate-x-80:focus{
    --transform-translate-x: -20rem;
  }

  .sm\\:focus\\:-translate-x-82:focus{
    --transform-translate-x: -20.5rem;
  }

  .sm\\:focus\\:-translate-x-84:focus{
    --transform-translate-x: -21rem;
  }

  .sm\\:focus\\:-translate-x-88:focus{
    --transform-translate-x: -22rem;
  }

  .sm\\:focus\\:-translate-x-92:focus{
    --transform-translate-x: -23rem;
  }

  .sm\\:focus\\:-translate-x-96:focus{
    --transform-translate-x: -24rem;
  }

  .sm\\:focus\\:-translate-x-98:focus{
    --transform-translate-x: -24.5rem;
  }

  .sm\\:focus\\:-translate-x-100:focus{
    --transform-translate-x: -25rem;
  }

  .sm\\:focus\\:-translate-x-104:focus{
    --transform-translate-x: -26rem;
  }

  .sm\\:focus\\:-translate-x-112:focus{
    --transform-translate-x: -28rem;
  }

  .sm\\:focus\\:-translate-x-124:focus{
    --transform-translate-x: -31rem;
  }

  .sm\\:focus\\:-translate-x-128:focus{
    --transform-translate-x: -32rem;
  }

  .sm\\:focus\\:-translate-x-140:focus{
    --transform-translate-x: -35rem;
  }

  .sm\\:focus\\:-translate-x-152:focus{
    --transform-translate-x: -38rem;
  }

  .sm\\:focus\\:-translate-x-160:focus{
    --transform-translate-x: -40rem;
  }

  .sm\\:focus\\:-translate-x-162:focus{
    --transform-translate-x: -41rem;
  }

  .sm\\:focus\\:-translate-x-192:focus{
    --transform-translate-x: -48rem;
  }

  .sm\\:focus\\:-translate-x-208:focus{
    --transform-translate-x: -52rem;
  }

  .sm\\:focus\\:-translate-x-224:focus{
    --transform-translate-x: -56rem;
  }

  .sm\\:focus\\:-translate-x-256:focus{
    --transform-translate-x: -64rem;
  }

  .sm\\:focus\\:-translate-x-px:focus{
    --transform-translate-x: -1px;
  }

  .sm\\:focus\\:-translate-x-full:focus{
    --transform-translate-x: -100%;
  }

  .sm\\:focus\\:-translate-x-1\\/2:focus{
    --transform-translate-x: -50%;
  }

  .sm\\:focus\\:translate-x-1\\/2:focus{
    --transform-translate-x: 50%;
  }

  .sm\\:focus\\:translate-x-full:focus{
    --transform-translate-x: 100%;
  }

  .sm\\:focus\\:translate-y-0:focus{
    --transform-translate-y: 0;
  }

  .sm\\:focus\\:translate-y-1:focus{
    --transform-translate-y: 0.25rem;
  }

  .sm\\:focus\\:translate-y-2:focus{
    --transform-translate-y: 0.5rem;
  }

  .sm\\:focus\\:translate-y-3:focus{
    --transform-translate-y: 0.75rem;
  }

  .sm\\:focus\\:translate-y-4:focus{
    --transform-translate-y: 1rem;
  }

  .sm\\:focus\\:translate-y-5:focus{
    --transform-translate-y: 1.25rem;
  }

  .sm\\:focus\\:translate-y-6:focus{
    --transform-translate-y: 1.5rem;
  }

  .sm\\:focus\\:translate-y-7:focus{
    --transform-translate-y: 1.75rem;
  }

  .sm\\:focus\\:translate-y-8:focus{
    --transform-translate-y: 2rem;
  }

  .sm\\:focus\\:translate-y-9:focus{
    --transform-translate-y: 2.25rem;
  }

  .sm\\:focus\\:translate-y-10:focus{
    --transform-translate-y: 2.5rem;
  }

  .sm\\:focus\\:translate-y-11:focus{
    --transform-translate-y: 2.75rem;
  }

  .sm\\:focus\\:translate-y-12:focus{
    --transform-translate-y: 3rem;
  }

  .sm\\:focus\\:translate-y-14:focus{
    --transform-translate-y: 3.5rem;
  }

  .sm\\:focus\\:translate-y-15:focus{
    --transform-translate-y: 3.75rem;
  }

  .sm\\:focus\\:translate-y-16:focus{
    --transform-translate-y: 4rem;
  }

  .sm\\:focus\\:translate-y-18:focus{
    --transform-translate-y: 4.5rem;
  }

  .sm\\:focus\\:translate-y-20:focus{
    --transform-translate-y: 5rem;
  }

  .sm\\:focus\\:translate-y-22:focus{
    --transform-translate-y: 5.5rem;
  }

  .sm\\:focus\\:translate-y-23:focus{
    --transform-translate-y: 5.75rem;
  }

  .sm\\:focus\\:translate-y-24:focus{
    --transform-translate-y: 6rem;
  }

  .sm\\:focus\\:translate-y-25:focus{
    --transform-translate-y: 6.25rem;
  }

  .sm\\:focus\\:translate-y-26:focus{
    --transform-translate-y: 6.5rem;
  }

  .sm\\:focus\\:translate-y-28:focus{
    --transform-translate-y: 7rem;
  }

  .sm\\:focus\\:translate-y-30:focus{
    --transform-translate-y: 7.5rem;
  }

  .sm\\:focus\\:translate-y-32:focus{
    --transform-translate-y: 8rem;
  }

  .sm\\:focus\\:translate-y-34:focus{
    --transform-translate-y: 8.5rem;
  }

  .sm\\:focus\\:translate-y-40:focus{
    --transform-translate-y: 10rem;
  }

  .sm\\:focus\\:translate-y-42:focus{
    --transform-translate-y: 10.5rem;
  }

  .sm\\:focus\\:translate-y-44:focus{
    --transform-translate-y: 11rem;
  }

  .sm\\:focus\\:translate-y-48:focus{
    --transform-translate-y: 12rem;
  }

  .sm\\:focus\\:translate-y-52:focus{
    --transform-translate-y: 13rem;
  }

  .sm\\:focus\\:translate-y-54:focus{
    --transform-translate-y: 13.5rem;
  }

  .sm\\:focus\\:translate-y-56:focus{
    --transform-translate-y: 14rem;
  }

  .sm\\:focus\\:translate-y-60:focus{
    --transform-translate-y: 15rem;
  }

  .sm\\:focus\\:translate-y-64:focus{
    --transform-translate-y: 16rem;
  }

  .sm\\:focus\\:translate-y-68:focus{
    --transform-translate-y: 17rem;
  }

  .sm\\:focus\\:translate-y-72:focus{
    --transform-translate-y: 18rem;
  }

  .sm\\:focus\\:translate-y-74:focus{
    --transform-translate-y: 18.5rem;
  }

  .sm\\:focus\\:translate-y-76:focus{
    --transform-translate-y: 19rem;
  }

  .sm\\:focus\\:translate-y-78:focus{
    --transform-translate-y: 19.5rem;
  }

  .sm\\:focus\\:translate-y-80:focus{
    --transform-translate-y: 20rem;
  }

  .sm\\:focus\\:translate-y-82:focus{
    --transform-translate-y: 20.5rem;
  }

  .sm\\:focus\\:translate-y-84:focus{
    --transform-translate-y: 21rem;
  }

  .sm\\:focus\\:translate-y-88:focus{
    --transform-translate-y: 22rem;
  }

  .sm\\:focus\\:translate-y-92:focus{
    --transform-translate-y: 23rem;
  }

  .sm\\:focus\\:translate-y-96:focus{
    --transform-translate-y: 24rem;
  }

  .sm\\:focus\\:translate-y-98:focus{
    --transform-translate-y: 24.5rem;
  }

  .sm\\:focus\\:translate-y-100:focus{
    --transform-translate-y: 25rem;
  }

  .sm\\:focus\\:translate-y-104:focus{
    --transform-translate-y: 26rem;
  }

  .sm\\:focus\\:translate-y-112:focus{
    --transform-translate-y: 28rem;
  }

  .sm\\:focus\\:translate-y-124:focus{
    --transform-translate-y: 31rem;
  }

  .sm\\:focus\\:translate-y-128:focus{
    --transform-translate-y: 32rem;
  }

  .sm\\:focus\\:translate-y-140:focus{
    --transform-translate-y: 35rem;
  }

  .sm\\:focus\\:translate-y-152:focus{
    --transform-translate-y: 38rem;
  }

  .sm\\:focus\\:translate-y-160:focus{
    --transform-translate-y: 40rem;
  }

  .sm\\:focus\\:translate-y-162:focus{
    --transform-translate-y: 41rem;
  }

  .sm\\:focus\\:translate-y-192:focus{
    --transform-translate-y: 48rem;
  }

  .sm\\:focus\\:translate-y-208:focus{
    --transform-translate-y: 52rem;
  }

  .sm\\:focus\\:translate-y-224:focus{
    --transform-translate-y: 56rem;
  }

  .sm\\:focus\\:translate-y-256:focus{
    --transform-translate-y: 64rem;
  }

  .sm\\:focus\\:translate-y-px:focus{
    --transform-translate-y: 1px;
  }

  .sm\\:focus\\:-translate-y-1:focus{
    --transform-translate-y: -0.25rem;
  }

  .sm\\:focus\\:-translate-y-2:focus{
    --transform-translate-y: -0.5rem;
  }

  .sm\\:focus\\:-translate-y-3:focus{
    --transform-translate-y: -0.75rem;
  }

  .sm\\:focus\\:-translate-y-4:focus{
    --transform-translate-y: -1rem;
  }

  .sm\\:focus\\:-translate-y-5:focus{
    --transform-translate-y: -1.25rem;
  }

  .sm\\:focus\\:-translate-y-6:focus{
    --transform-translate-y: -1.5rem;
  }

  .sm\\:focus\\:-translate-y-7:focus{
    --transform-translate-y: -1.75rem;
  }

  .sm\\:focus\\:-translate-y-8:focus{
    --transform-translate-y: -2rem;
  }

  .sm\\:focus\\:-translate-y-9:focus{
    --transform-translate-y: -2.25rem;
  }

  .sm\\:focus\\:-translate-y-10:focus{
    --transform-translate-y: -2.5rem;
  }

  .sm\\:focus\\:-translate-y-11:focus{
    --transform-translate-y: -2.75rem;
  }

  .sm\\:focus\\:-translate-y-12:focus{
    --transform-translate-y: -3rem;
  }

  .sm\\:focus\\:-translate-y-14:focus{
    --transform-translate-y: -3.5rem;
  }

  .sm\\:focus\\:-translate-y-15:focus{
    --transform-translate-y: -3.75rem;
  }

  .sm\\:focus\\:-translate-y-16:focus{
    --transform-translate-y: -4rem;
  }

  .sm\\:focus\\:-translate-y-18:focus{
    --transform-translate-y: -4.5rem;
  }

  .sm\\:focus\\:-translate-y-20:focus{
    --transform-translate-y: -5rem;
  }

  .sm\\:focus\\:-translate-y-22:focus{
    --transform-translate-y: -5.5rem;
  }

  .sm\\:focus\\:-translate-y-23:focus{
    --transform-translate-y: -5.75rem;
  }

  .sm\\:focus\\:-translate-y-24:focus{
    --transform-translate-y: -6rem;
  }

  .sm\\:focus\\:-translate-y-25:focus{
    --transform-translate-y: -6.25rem;
  }

  .sm\\:focus\\:-translate-y-26:focus{
    --transform-translate-y: -6.5rem;
  }

  .sm\\:focus\\:-translate-y-28:focus{
    --transform-translate-y: -7rem;
  }

  .sm\\:focus\\:-translate-y-30:focus{
    --transform-translate-y: -7.5rem;
  }

  .sm\\:focus\\:-translate-y-32:focus{
    --transform-translate-y: -8rem;
  }

  .sm\\:focus\\:-translate-y-34:focus{
    --transform-translate-y: -8.5rem;
  }

  .sm\\:focus\\:-translate-y-40:focus{
    --transform-translate-y: -10rem;
  }

  .sm\\:focus\\:-translate-y-42:focus{
    --transform-translate-y: -10.5rem;
  }

  .sm\\:focus\\:-translate-y-44:focus{
    --transform-translate-y: -11rem;
  }

  .sm\\:focus\\:-translate-y-48:focus{
    --transform-translate-y: -12rem;
  }

  .sm\\:focus\\:-translate-y-52:focus{
    --transform-translate-y: -13rem;
  }

  .sm\\:focus\\:-translate-y-54:focus{
    --transform-translate-y: -13.5rem;
  }

  .sm\\:focus\\:-translate-y-56:focus{
    --transform-translate-y: -14rem;
  }

  .sm\\:focus\\:-translate-y-60:focus{
    --transform-translate-y: -15rem;
  }

  .sm\\:focus\\:-translate-y-64:focus{
    --transform-translate-y: -16rem;
  }

  .sm\\:focus\\:-translate-y-68:focus{
    --transform-translate-y: -17rem;
  }

  .sm\\:focus\\:-translate-y-72:focus{
    --transform-translate-y: -18rem;
  }

  .sm\\:focus\\:-translate-y-74:focus{
    --transform-translate-y: -18.5rem;
  }

  .sm\\:focus\\:-translate-y-76:focus{
    --transform-translate-y: -19rem;
  }

  .sm\\:focus\\:-translate-y-78:focus{
    --transform-translate-y: -19.5rem;
  }

  .sm\\:focus\\:-translate-y-80:focus{
    --transform-translate-y: -20rem;
  }

  .sm\\:focus\\:-translate-y-82:focus{
    --transform-translate-y: -20.5rem;
  }

  .sm\\:focus\\:-translate-y-84:focus{
    --transform-translate-y: -21rem;
  }

  .sm\\:focus\\:-translate-y-88:focus{
    --transform-translate-y: -22rem;
  }

  .sm\\:focus\\:-translate-y-92:focus{
    --transform-translate-y: -23rem;
  }

  .sm\\:focus\\:-translate-y-96:focus{
    --transform-translate-y: -24rem;
  }

  .sm\\:focus\\:-translate-y-98:focus{
    --transform-translate-y: -24.5rem;
  }

  .sm\\:focus\\:-translate-y-100:focus{
    --transform-translate-y: -25rem;
  }

  .sm\\:focus\\:-translate-y-104:focus{
    --transform-translate-y: -26rem;
  }

  .sm\\:focus\\:-translate-y-112:focus{
    --transform-translate-y: -28rem;
  }

  .sm\\:focus\\:-translate-y-124:focus{
    --transform-translate-y: -31rem;
  }

  .sm\\:focus\\:-translate-y-128:focus{
    --transform-translate-y: -32rem;
  }

  .sm\\:focus\\:-translate-y-140:focus{
    --transform-translate-y: -35rem;
  }

  .sm\\:focus\\:-translate-y-152:focus{
    --transform-translate-y: -38rem;
  }

  .sm\\:focus\\:-translate-y-160:focus{
    --transform-translate-y: -40rem;
  }

  .sm\\:focus\\:-translate-y-162:focus{
    --transform-translate-y: -41rem;
  }

  .sm\\:focus\\:-translate-y-192:focus{
    --transform-translate-y: -48rem;
  }

  .sm\\:focus\\:-translate-y-208:focus{
    --transform-translate-y: -52rem;
  }

  .sm\\:focus\\:-translate-y-224:focus{
    --transform-translate-y: -56rem;
  }

  .sm\\:focus\\:-translate-y-256:focus{
    --transform-translate-y: -64rem;
  }

  .sm\\:focus\\:-translate-y-px:focus{
    --transform-translate-y: -1px;
  }

  .sm\\:focus\\:-translate-y-full:focus{
    --transform-translate-y: -100%;
  }

  .sm\\:focus\\:-translate-y-1\\/2:focus{
    --transform-translate-y: -50%;
  }

  .sm\\:focus\\:translate-y-1\\/2:focus{
    --transform-translate-y: 50%;
  }

  .sm\\:focus\\:translate-y-full:focus{
    --transform-translate-y: 100%;
  }

  .sm\\:skew-x-0{
    --transform-skew-x: 0;
  }

  .sm\\:skew-x-1{
    --transform-skew-x: 1deg;
  }

  .sm\\:skew-x-2{
    --transform-skew-x: 2deg;
  }

  .sm\\:skew-x-3{
    --transform-skew-x: 3deg;
  }

  .sm\\:skew-x-6{
    --transform-skew-x: 6deg;
  }

  .sm\\:skew-x-12{
    --transform-skew-x: 12deg;
  }

  .sm\\:-skew-x-12{
    --transform-skew-x: -12deg;
  }

  .sm\\:-skew-x-6{
    --transform-skew-x: -6deg;
  }

  .sm\\:-skew-x-3{
    --transform-skew-x: -3deg;
  }

  .sm\\:-skew-x-2{
    --transform-skew-x: -2deg;
  }

  .sm\\:-skew-x-1{
    --transform-skew-x: -1deg;
  }

  .sm\\:skew-y-0{
    --transform-skew-y: 0;
  }

  .sm\\:skew-y-1{
    --transform-skew-y: 1deg;
  }

  .sm\\:skew-y-2{
    --transform-skew-y: 2deg;
  }

  .sm\\:skew-y-3{
    --transform-skew-y: 3deg;
  }

  .sm\\:skew-y-6{
    --transform-skew-y: 6deg;
  }

  .sm\\:skew-y-12{
    --transform-skew-y: 12deg;
  }

  .sm\\:-skew-y-12{
    --transform-skew-y: -12deg;
  }

  .sm\\:-skew-y-6{
    --transform-skew-y: -6deg;
  }

  .sm\\:-skew-y-3{
    --transform-skew-y: -3deg;
  }

  .sm\\:-skew-y-2{
    --transform-skew-y: -2deg;
  }

  .sm\\:-skew-y-1{
    --transform-skew-y: -1deg;
  }

  .sm\\:hover\\:skew-x-0:hover{
    --transform-skew-x: 0;
  }

  .sm\\:hover\\:skew-x-1:hover{
    --transform-skew-x: 1deg;
  }

  .sm\\:hover\\:skew-x-2:hover{
    --transform-skew-x: 2deg;
  }

  .sm\\:hover\\:skew-x-3:hover{
    --transform-skew-x: 3deg;
  }

  .sm\\:hover\\:skew-x-6:hover{
    --transform-skew-x: 6deg;
  }

  .sm\\:hover\\:skew-x-12:hover{
    --transform-skew-x: 12deg;
  }

  .sm\\:hover\\:-skew-x-12:hover{
    --transform-skew-x: -12deg;
  }

  .sm\\:hover\\:-skew-x-6:hover{
    --transform-skew-x: -6deg;
  }

  .sm\\:hover\\:-skew-x-3:hover{
    --transform-skew-x: -3deg;
  }

  .sm\\:hover\\:-skew-x-2:hover{
    --transform-skew-x: -2deg;
  }

  .sm\\:hover\\:-skew-x-1:hover{
    --transform-skew-x: -1deg;
  }

  .sm\\:hover\\:skew-y-0:hover{
    --transform-skew-y: 0;
  }

  .sm\\:hover\\:skew-y-1:hover{
    --transform-skew-y: 1deg;
  }

  .sm\\:hover\\:skew-y-2:hover{
    --transform-skew-y: 2deg;
  }

  .sm\\:hover\\:skew-y-3:hover{
    --transform-skew-y: 3deg;
  }

  .sm\\:hover\\:skew-y-6:hover{
    --transform-skew-y: 6deg;
  }

  .sm\\:hover\\:skew-y-12:hover{
    --transform-skew-y: 12deg;
  }

  .sm\\:hover\\:-skew-y-12:hover{
    --transform-skew-y: -12deg;
  }

  .sm\\:hover\\:-skew-y-6:hover{
    --transform-skew-y: -6deg;
  }

  .sm\\:hover\\:-skew-y-3:hover{
    --transform-skew-y: -3deg;
  }

  .sm\\:hover\\:-skew-y-2:hover{
    --transform-skew-y: -2deg;
  }

  .sm\\:hover\\:-skew-y-1:hover{
    --transform-skew-y: -1deg;
  }

  .sm\\:focus\\:skew-x-0:focus{
    --transform-skew-x: 0;
  }

  .sm\\:focus\\:skew-x-1:focus{
    --transform-skew-x: 1deg;
  }

  .sm\\:focus\\:skew-x-2:focus{
    --transform-skew-x: 2deg;
  }

  .sm\\:focus\\:skew-x-3:focus{
    --transform-skew-x: 3deg;
  }

  .sm\\:focus\\:skew-x-6:focus{
    --transform-skew-x: 6deg;
  }

  .sm\\:focus\\:skew-x-12:focus{
    --transform-skew-x: 12deg;
  }

  .sm\\:focus\\:-skew-x-12:focus{
    --transform-skew-x: -12deg;
  }

  .sm\\:focus\\:-skew-x-6:focus{
    --transform-skew-x: -6deg;
  }

  .sm\\:focus\\:-skew-x-3:focus{
    --transform-skew-x: -3deg;
  }

  .sm\\:focus\\:-skew-x-2:focus{
    --transform-skew-x: -2deg;
  }

  .sm\\:focus\\:-skew-x-1:focus{
    --transform-skew-x: -1deg;
  }

  .sm\\:focus\\:skew-y-0:focus{
    --transform-skew-y: 0;
  }

  .sm\\:focus\\:skew-y-1:focus{
    --transform-skew-y: 1deg;
  }

  .sm\\:focus\\:skew-y-2:focus{
    --transform-skew-y: 2deg;
  }

  .sm\\:focus\\:skew-y-3:focus{
    --transform-skew-y: 3deg;
  }

  .sm\\:focus\\:skew-y-6:focus{
    --transform-skew-y: 6deg;
  }

  .sm\\:focus\\:skew-y-12:focus{
    --transform-skew-y: 12deg;
  }

  .sm\\:focus\\:-skew-y-12:focus{
    --transform-skew-y: -12deg;
  }

  .sm\\:focus\\:-skew-y-6:focus{
    --transform-skew-y: -6deg;
  }

  .sm\\:focus\\:-skew-y-3:focus{
    --transform-skew-y: -3deg;
  }

  .sm\\:focus\\:-skew-y-2:focus{
    --transform-skew-y: -2deg;
  }

  .sm\\:focus\\:-skew-y-1:focus{
    --transform-skew-y: -1deg;
  }

  .sm\\:transition-none{
    transition-property: none;
  }

  .sm\\:transition-all{
    transition-property: all;
  }

  .sm\\:transition{
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  }

  .sm\\:transition-colors{
    transition-property: background-color, border-color, color, fill, stroke;
  }

  .sm\\:transition-opacity{
    transition-property: opacity;
  }

  .sm\\:transition-shadow{
    transition-property: box-shadow;
  }

  .sm\\:transition-transform{
    transition-property: transform;
  }

  .sm\\:ease-linear{
    transition-timing-function: linear;
  }

  .sm\\:ease-in{
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  }

  .sm\\:ease-out{
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }

  .sm\\:ease-in-out{
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }

  .sm\\:duration-75{
    transition-duration: 75ms;
  }

  .sm\\:duration-100{
    transition-duration: 100ms;
  }

  .sm\\:duration-150{
    transition-duration: 150ms;
  }

  .sm\\:duration-200{
    transition-duration: 200ms;
  }

  .sm\\:duration-300{
    transition-duration: 300ms;
  }

  .sm\\:duration-500{
    transition-duration: 500ms;
  }

  .sm\\:duration-700{
    transition-duration: 700ms;
  }

  .sm\\:duration-1000{
    transition-duration: 1000ms;
  }

  .sm\\:delay-75{
    transition-delay: 75ms;
  }

  .sm\\:delay-100{
    transition-delay: 100ms;
  }

  .sm\\:delay-150{
    transition-delay: 150ms;
  }

  .sm\\:delay-200{
    transition-delay: 200ms;
  }

  .sm\\:delay-300{
    transition-delay: 300ms;
  }

  .sm\\:delay-500{
    transition-delay: 500ms;
  }

  .sm\\:delay-700{
    transition-delay: 700ms;
  }

  .sm\\:delay-1000{
    transition-delay: 1000ms;
  }

  .sm\\:animate-none{
    animation: none;
  }

  .sm\\:animate-spin{
    animation: spin 1s linear infinite;
  }

  .sm\\:animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }

  .sm\\:animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  .sm\\:animate-bounce{
    animation: bounce 1s infinite;
  }

  [dir="ltr"] .sm\\:ps-0{
    padding-left: 0;
  }

  [dir="rtl"] .sm\\:ps-0{
    padding-right: 0;
  }

  [dir="ltr"] .sm\\:pe-0{
    padding-right: 0;
  }

  [dir="rtl"] .sm\\:pe-0{
    padding-left: 0;
  }

  [dir="ltr"] .sm\\:ps-1{
    padding-left: 0.25rem;
  }

  [dir="rtl"] .sm\\:ps-1{
    padding-right: 0.25rem;
  }

  [dir="ltr"] .sm\\:pe-1{
    padding-right: 0.25rem;
  }

  [dir="rtl"] .sm\\:pe-1{
    padding-left: 0.25rem;
  }

  [dir="ltr"] .sm\\:ps-2{
    padding-left: 0.5rem;
  }

  [dir="rtl"] .sm\\:ps-2{
    padding-right: 0.5rem;
  }

  [dir="ltr"] .sm\\:pe-2{
    padding-right: 0.5rem;
  }

  [dir="rtl"] .sm\\:pe-2{
    padding-left: 0.5rem;
  }

  [dir="ltr"] .sm\\:ps-3{
    padding-left: 0.75rem;
  }

  [dir="rtl"] .sm\\:ps-3{
    padding-right: 0.75rem;
  }

  [dir="ltr"] .sm\\:pe-3{
    padding-right: 0.75rem;
  }

  [dir="rtl"] .sm\\:pe-3{
    padding-left: 0.75rem;
  }

  [dir="ltr"] .sm\\:ps-4{
    padding-left: 1rem;
  }

  [dir="rtl"] .sm\\:ps-4{
    padding-right: 1rem;
  }

  [dir="ltr"] .sm\\:pe-4{
    padding-right: 1rem;
  }

  [dir="rtl"] .sm\\:pe-4{
    padding-left: 1rem;
  }

  [dir="ltr"] .sm\\:ps-5{
    padding-left: 1.25rem;
  }

  [dir="rtl"] .sm\\:ps-5{
    padding-right: 1.25rem;
  }

  [dir="ltr"] .sm\\:pe-5{
    padding-right: 1.25rem;
  }

  [dir="rtl"] .sm\\:pe-5{
    padding-left: 1.25rem;
  }

  [dir="ltr"] .sm\\:ps-6{
    padding-left: 1.5rem;
  }

  [dir="rtl"] .sm\\:ps-6{
    padding-right: 1.5rem;
  }

  [dir="ltr"] .sm\\:pe-6{
    padding-right: 1.5rem;
  }

  [dir="rtl"] .sm\\:pe-6{
    padding-left: 1.5rem;
  }

  [dir="ltr"] .sm\\:ps-7{
    padding-left: 1.75rem;
  }

  [dir="rtl"] .sm\\:ps-7{
    padding-right: 1.75rem;
  }

  [dir="ltr"] .sm\\:pe-7{
    padding-right: 1.75rem;
  }

  [dir="rtl"] .sm\\:pe-7{
    padding-left: 1.75rem;
  }

  [dir="ltr"] .sm\\:ps-8{
    padding-left: 2rem;
  }

  [dir="rtl"] .sm\\:ps-8{
    padding-right: 2rem;
  }

  [dir="ltr"] .sm\\:pe-8{
    padding-right: 2rem;
  }

  [dir="rtl"] .sm\\:pe-8{
    padding-left: 2rem;
  }

  [dir="ltr"] .sm\\:ps-9{
    padding-left: 2.25rem;
  }

  [dir="rtl"] .sm\\:ps-9{
    padding-right: 2.25rem;
  }

  [dir="ltr"] .sm\\:pe-9{
    padding-right: 2.25rem;
  }

  [dir="rtl"] .sm\\:pe-9{
    padding-left: 2.25rem;
  }

  [dir="ltr"] .sm\\:ps-10{
    padding-left: 2.5rem;
  }

  [dir="rtl"] .sm\\:ps-10{
    padding-right: 2.5rem;
  }

  [dir="ltr"] .sm\\:pe-10{
    padding-right: 2.5rem;
  }

  [dir="rtl"] .sm\\:pe-10{
    padding-left: 2.5rem;
  }

  [dir="ltr"] .sm\\:ps-11{
    padding-left: 2.75rem;
  }

  [dir="rtl"] .sm\\:ps-11{
    padding-right: 2.75rem;
  }

  [dir="ltr"] .sm\\:pe-11{
    padding-right: 2.75rem;
  }

  [dir="rtl"] .sm\\:pe-11{
    padding-left: 2.75rem;
  }

  [dir="ltr"] .sm\\:ps-12{
    padding-left: 3rem;
  }

  [dir="rtl"] .sm\\:ps-12{
    padding-right: 3rem;
  }

  [dir="ltr"] .sm\\:pe-12{
    padding-right: 3rem;
  }

  [dir="rtl"] .sm\\:pe-12{
    padding-left: 3rem;
  }

  [dir="ltr"] .sm\\:ps-14{
    padding-left: 3.5rem;
  }

  [dir="rtl"] .sm\\:ps-14{
    padding-right: 3.5rem;
  }

  [dir="ltr"] .sm\\:pe-14{
    padding-right: 3.5rem;
  }

  [dir="rtl"] .sm\\:pe-14{
    padding-left: 3.5rem;
  }

  [dir="ltr"] .sm\\:ps-15{
    padding-left: 3.75rem;
  }

  [dir="rtl"] .sm\\:ps-15{
    padding-right: 3.75rem;
  }

  [dir="ltr"] .sm\\:pe-15{
    padding-right: 3.75rem;
  }

  [dir="rtl"] .sm\\:pe-15{
    padding-left: 3.75rem;
  }

  [dir="ltr"] .sm\\:ps-16{
    padding-left: 4rem;
  }

  [dir="rtl"] .sm\\:ps-16{
    padding-right: 4rem;
  }

  [dir="ltr"] .sm\\:pe-16{
    padding-right: 4rem;
  }

  [dir="rtl"] .sm\\:pe-16{
    padding-left: 4rem;
  }

  [dir="ltr"] .sm\\:ps-18{
    padding-left: 4.5rem;
  }

  [dir="rtl"] .sm\\:ps-18{
    padding-right: 4.5rem;
  }

  [dir="ltr"] .sm\\:pe-18{
    padding-right: 4.5rem;
  }

  [dir="rtl"] .sm\\:pe-18{
    padding-left: 4.5rem;
  }

  [dir="ltr"] .sm\\:ps-20{
    padding-left: 5rem;
  }

  [dir="rtl"] .sm\\:ps-20{
    padding-right: 5rem;
  }

  [dir="ltr"] .sm\\:pe-20{
    padding-right: 5rem;
  }

  [dir="rtl"] .sm\\:pe-20{
    padding-left: 5rem;
  }

  [dir="ltr"] .sm\\:ps-22{
    padding-left: 5.5rem;
  }

  [dir="rtl"] .sm\\:ps-22{
    padding-right: 5.5rem;
  }

  [dir="ltr"] .sm\\:pe-22{
    padding-right: 5.5rem;
  }

  [dir="rtl"] .sm\\:pe-22{
    padding-left: 5.5rem;
  }

  [dir="ltr"] .sm\\:ps-23{
    padding-left: 5.75rem;
  }

  [dir="rtl"] .sm\\:ps-23{
    padding-right: 5.75rem;
  }

  [dir="ltr"] .sm\\:pe-23{
    padding-right: 5.75rem;
  }

  [dir="rtl"] .sm\\:pe-23{
    padding-left: 5.75rem;
  }

  [dir="ltr"] .sm\\:ps-24{
    padding-left: 6rem;
  }

  [dir="rtl"] .sm\\:ps-24{
    padding-right: 6rem;
  }

  [dir="ltr"] .sm\\:pe-24{
    padding-right: 6rem;
  }

  [dir="rtl"] .sm\\:pe-24{
    padding-left: 6rem;
  }

  [dir="ltr"] .sm\\:ps-25{
    padding-left: 6.25rem;
  }

  [dir="rtl"] .sm\\:ps-25{
    padding-right: 6.25rem;
  }

  [dir="ltr"] .sm\\:pe-25{
    padding-right: 6.25rem;
  }

  [dir="rtl"] .sm\\:pe-25{
    padding-left: 6.25rem;
  }

  [dir="ltr"] .sm\\:ps-26{
    padding-left: 6.5rem;
  }

  [dir="rtl"] .sm\\:ps-26{
    padding-right: 6.5rem;
  }

  [dir="ltr"] .sm\\:pe-26{
    padding-right: 6.5rem;
  }

  [dir="rtl"] .sm\\:pe-26{
    padding-left: 6.5rem;
  }

  [dir="ltr"] .sm\\:ps-28{
    padding-left: 7rem;
  }

  [dir="rtl"] .sm\\:ps-28{
    padding-right: 7rem;
  }

  [dir="ltr"] .sm\\:pe-28{
    padding-right: 7rem;
  }

  [dir="rtl"] .sm\\:pe-28{
    padding-left: 7rem;
  }

  [dir="ltr"] .sm\\:ps-30{
    padding-left: 7.5rem;
  }

  [dir="rtl"] .sm\\:ps-30{
    padding-right: 7.5rem;
  }

  [dir="ltr"] .sm\\:pe-30{
    padding-right: 7.5rem;
  }

  [dir="rtl"] .sm\\:pe-30{
    padding-left: 7.5rem;
  }

  [dir="ltr"] .sm\\:ps-32{
    padding-left: 8rem;
  }

  [dir="rtl"] .sm\\:ps-32{
    padding-right: 8rem;
  }

  [dir="ltr"] .sm\\:pe-32{
    padding-right: 8rem;
  }

  [dir="rtl"] .sm\\:pe-32{
    padding-left: 8rem;
  }

  [dir="ltr"] .sm\\:ps-34{
    padding-left: 8.5rem;
  }

  [dir="rtl"] .sm\\:ps-34{
    padding-right: 8.5rem;
  }

  [dir="ltr"] .sm\\:pe-34{
    padding-right: 8.5rem;
  }

  [dir="rtl"] .sm\\:pe-34{
    padding-left: 8.5rem;
  }

  [dir="ltr"] .sm\\:ps-40{
    padding-left: 10rem;
  }

  [dir="rtl"] .sm\\:ps-40{
    padding-right: 10rem;
  }

  [dir="ltr"] .sm\\:pe-40{
    padding-right: 10rem;
  }

  [dir="rtl"] .sm\\:pe-40{
    padding-left: 10rem;
  }

  [dir="ltr"] .sm\\:ps-42{
    padding-left: 10.5rem;
  }

  [dir="rtl"] .sm\\:ps-42{
    padding-right: 10.5rem;
  }

  [dir="ltr"] .sm\\:pe-42{
    padding-right: 10.5rem;
  }

  [dir="rtl"] .sm\\:pe-42{
    padding-left: 10.5rem;
  }

  [dir="ltr"] .sm\\:ps-44{
    padding-left: 11rem;
  }

  [dir="rtl"] .sm\\:ps-44{
    padding-right: 11rem;
  }

  [dir="ltr"] .sm\\:pe-44{
    padding-right: 11rem;
  }

  [dir="rtl"] .sm\\:pe-44{
    padding-left: 11rem;
  }

  [dir="ltr"] .sm\\:ps-48{
    padding-left: 12rem;
  }

  [dir="rtl"] .sm\\:ps-48{
    padding-right: 12rem;
  }

  [dir="ltr"] .sm\\:pe-48{
    padding-right: 12rem;
  }

  [dir="rtl"] .sm\\:pe-48{
    padding-left: 12rem;
  }

  [dir="ltr"] .sm\\:ps-52{
    padding-left: 13rem;
  }

  [dir="rtl"] .sm\\:ps-52{
    padding-right: 13rem;
  }

  [dir="ltr"] .sm\\:pe-52{
    padding-right: 13rem;
  }

  [dir="rtl"] .sm\\:pe-52{
    padding-left: 13rem;
  }

  [dir="ltr"] .sm\\:ps-54{
    padding-left: 13.5rem;
  }

  [dir="rtl"] .sm\\:ps-54{
    padding-right: 13.5rem;
  }

  [dir="ltr"] .sm\\:pe-54{
    padding-right: 13.5rem;
  }

  [dir="rtl"] .sm\\:pe-54{
    padding-left: 13.5rem;
  }

  [dir="ltr"] .sm\\:ps-56{
    padding-left: 14rem;
  }

  [dir="rtl"] .sm\\:ps-56{
    padding-right: 14rem;
  }

  [dir="ltr"] .sm\\:pe-56{
    padding-right: 14rem;
  }

  [dir="rtl"] .sm\\:pe-56{
    padding-left: 14rem;
  }

  [dir="ltr"] .sm\\:ps-60{
    padding-left: 15rem;
  }

  [dir="rtl"] .sm\\:ps-60{
    padding-right: 15rem;
  }

  [dir="ltr"] .sm\\:pe-60{
    padding-right: 15rem;
  }

  [dir="rtl"] .sm\\:pe-60{
    padding-left: 15rem;
  }

  [dir="ltr"] .sm\\:ps-64{
    padding-left: 16rem;
  }

  [dir="rtl"] .sm\\:ps-64{
    padding-right: 16rem;
  }

  [dir="ltr"] .sm\\:pe-64{
    padding-right: 16rem;
  }

  [dir="rtl"] .sm\\:pe-64{
    padding-left: 16rem;
  }

  [dir="ltr"] .sm\\:ps-68{
    padding-left: 17rem;
  }

  [dir="rtl"] .sm\\:ps-68{
    padding-right: 17rem;
  }

  [dir="ltr"] .sm\\:pe-68{
    padding-right: 17rem;
  }

  [dir="rtl"] .sm\\:pe-68{
    padding-left: 17rem;
  }

  [dir="ltr"] .sm\\:ps-72{
    padding-left: 18rem;
  }

  [dir="rtl"] .sm\\:ps-72{
    padding-right: 18rem;
  }

  [dir="ltr"] .sm\\:pe-72{
    padding-right: 18rem;
  }

  [dir="rtl"] .sm\\:pe-72{
    padding-left: 18rem;
  }

  [dir="ltr"] .sm\\:ps-74{
    padding-left: 18.5rem;
  }

  [dir="rtl"] .sm\\:ps-74{
    padding-right: 18.5rem;
  }

  [dir="ltr"] .sm\\:pe-74{
    padding-right: 18.5rem;
  }

  [dir="rtl"] .sm\\:pe-74{
    padding-left: 18.5rem;
  }

  [dir="ltr"] .sm\\:ps-76{
    padding-left: 19rem;
  }

  [dir="rtl"] .sm\\:ps-76{
    padding-right: 19rem;
  }

  [dir="ltr"] .sm\\:pe-76{
    padding-right: 19rem;
  }

  [dir="rtl"] .sm\\:pe-76{
    padding-left: 19rem;
  }

  [dir="ltr"] .sm\\:ps-78{
    padding-left: 19.5rem;
  }

  [dir="rtl"] .sm\\:ps-78{
    padding-right: 19.5rem;
  }

  [dir="ltr"] .sm\\:pe-78{
    padding-right: 19.5rem;
  }

  [dir="rtl"] .sm\\:pe-78{
    padding-left: 19.5rem;
  }

  [dir="ltr"] .sm\\:ps-80{
    padding-left: 20rem;
  }

  [dir="rtl"] .sm\\:ps-80{
    padding-right: 20rem;
  }

  [dir="ltr"] .sm\\:pe-80{
    padding-right: 20rem;
  }

  [dir="rtl"] .sm\\:pe-80{
    padding-left: 20rem;
  }

  [dir="ltr"] .sm\\:ps-82{
    padding-left: 20.5rem;
  }

  [dir="rtl"] .sm\\:ps-82{
    padding-right: 20.5rem;
  }

  [dir="ltr"] .sm\\:pe-82{
    padding-right: 20.5rem;
  }

  [dir="rtl"] .sm\\:pe-82{
    padding-left: 20.5rem;
  }

  [dir="ltr"] .sm\\:ps-84{
    padding-left: 21rem;
  }

  [dir="rtl"] .sm\\:ps-84{
    padding-right: 21rem;
  }

  [dir="ltr"] .sm\\:pe-84{
    padding-right: 21rem;
  }

  [dir="rtl"] .sm\\:pe-84{
    padding-left: 21rem;
  }

  [dir="ltr"] .sm\\:ps-88{
    padding-left: 22rem;
  }

  [dir="rtl"] .sm\\:ps-88{
    padding-right: 22rem;
  }

  [dir="ltr"] .sm\\:pe-88{
    padding-right: 22rem;
  }

  [dir="rtl"] .sm\\:pe-88{
    padding-left: 22rem;
  }

  [dir="ltr"] .sm\\:ps-92{
    padding-left: 23rem;
  }

  [dir="rtl"] .sm\\:ps-92{
    padding-right: 23rem;
  }

  [dir="ltr"] .sm\\:pe-92{
    padding-right: 23rem;
  }

  [dir="rtl"] .sm\\:pe-92{
    padding-left: 23rem;
  }

  [dir="ltr"] .sm\\:ps-96{
    padding-left: 24rem;
  }

  [dir="rtl"] .sm\\:ps-96{
    padding-right: 24rem;
  }

  [dir="ltr"] .sm\\:pe-96{
    padding-right: 24rem;
  }

  [dir="rtl"] .sm\\:pe-96{
    padding-left: 24rem;
  }

  [dir="ltr"] .sm\\:ps-98{
    padding-left: 24.5rem;
  }

  [dir="rtl"] .sm\\:ps-98{
    padding-right: 24.5rem;
  }

  [dir="ltr"] .sm\\:pe-98{
    padding-right: 24.5rem;
  }

  [dir="rtl"] .sm\\:pe-98{
    padding-left: 24.5rem;
  }

  [dir="ltr"] .sm\\:ps-100{
    padding-left: 25rem;
  }

  [dir="rtl"] .sm\\:ps-100{
    padding-right: 25rem;
  }

  [dir="ltr"] .sm\\:pe-100{
    padding-right: 25rem;
  }

  [dir="rtl"] .sm\\:pe-100{
    padding-left: 25rem;
  }

  [dir="ltr"] .sm\\:ps-104{
    padding-left: 26rem;
  }

  [dir="rtl"] .sm\\:ps-104{
    padding-right: 26rem;
  }

  [dir="ltr"] .sm\\:pe-104{
    padding-right: 26rem;
  }

  [dir="rtl"] .sm\\:pe-104{
    padding-left: 26rem;
  }

  [dir="ltr"] .sm\\:ps-112{
    padding-left: 28rem;
  }

  [dir="rtl"] .sm\\:ps-112{
    padding-right: 28rem;
  }

  [dir="ltr"] .sm\\:pe-112{
    padding-right: 28rem;
  }

  [dir="rtl"] .sm\\:pe-112{
    padding-left: 28rem;
  }

  [dir="ltr"] .sm\\:ps-124{
    padding-left: 31rem;
  }

  [dir="rtl"] .sm\\:ps-124{
    padding-right: 31rem;
  }

  [dir="ltr"] .sm\\:pe-124{
    padding-right: 31rem;
  }

  [dir="rtl"] .sm\\:pe-124{
    padding-left: 31rem;
  }

  [dir="ltr"] .sm\\:ps-128{
    padding-left: 32rem;
  }

  [dir="rtl"] .sm\\:ps-128{
    padding-right: 32rem;
  }

  [dir="ltr"] .sm\\:pe-128{
    padding-right: 32rem;
  }

  [dir="rtl"] .sm\\:pe-128{
    padding-left: 32rem;
  }

  [dir="ltr"] .sm\\:ps-140{
    padding-left: 35rem;
  }

  [dir="rtl"] .sm\\:ps-140{
    padding-right: 35rem;
  }

  [dir="ltr"] .sm\\:pe-140{
    padding-right: 35rem;
  }

  [dir="rtl"] .sm\\:pe-140{
    padding-left: 35rem;
  }

  [dir="ltr"] .sm\\:ps-152{
    padding-left: 38rem;
  }

  [dir="rtl"] .sm\\:ps-152{
    padding-right: 38rem;
  }

  [dir="ltr"] .sm\\:pe-152{
    padding-right: 38rem;
  }

  [dir="rtl"] .sm\\:pe-152{
    padding-left: 38rem;
  }

  [dir="ltr"] .sm\\:ps-160{
    padding-left: 40rem;
  }

  [dir="rtl"] .sm\\:ps-160{
    padding-right: 40rem;
  }

  [dir="ltr"] .sm\\:pe-160{
    padding-right: 40rem;
  }

  [dir="rtl"] .sm\\:pe-160{
    padding-left: 40rem;
  }

  [dir="ltr"] .sm\\:ps-162{
    padding-left: 41rem;
  }

  [dir="rtl"] .sm\\:ps-162{
    padding-right: 41rem;
  }

  [dir="ltr"] .sm\\:pe-162{
    padding-right: 41rem;
  }

  [dir="rtl"] .sm\\:pe-162{
    padding-left: 41rem;
  }

  [dir="ltr"] .sm\\:ps-192{
    padding-left: 48rem;
  }

  [dir="rtl"] .sm\\:ps-192{
    padding-right: 48rem;
  }

  [dir="ltr"] .sm\\:pe-192{
    padding-right: 48rem;
  }

  [dir="rtl"] .sm\\:pe-192{
    padding-left: 48rem;
  }

  [dir="ltr"] .sm\\:ps-208{
    padding-left: 52rem;
  }

  [dir="rtl"] .sm\\:ps-208{
    padding-right: 52rem;
  }

  [dir="ltr"] .sm\\:pe-208{
    padding-right: 52rem;
  }

  [dir="rtl"] .sm\\:pe-208{
    padding-left: 52rem;
  }

  [dir="ltr"] .sm\\:ps-224{
    padding-left: 56rem;
  }

  [dir="rtl"] .sm\\:ps-224{
    padding-right: 56rem;
  }

  [dir="ltr"] .sm\\:pe-224{
    padding-right: 56rem;
  }

  [dir="rtl"] .sm\\:pe-224{
    padding-left: 56rem;
  }

  [dir="ltr"] .sm\\:ps-256{
    padding-left: 64rem;
  }

  [dir="rtl"] .sm\\:ps-256{
    padding-right: 64rem;
  }

  [dir="ltr"] .sm\\:pe-256{
    padding-right: 64rem;
  }

  [dir="rtl"] .sm\\:pe-256{
    padding-left: 64rem;
  }

  [dir="ltr"] .sm\\:ps-px{
    padding-left: 1px;
  }

  [dir="rtl"] .sm\\:ps-px{
    padding-right: 1px;
  }

  [dir="ltr"] .sm\\:pe-px{
    padding-right: 1px;
  }

  [dir="rtl"] .sm\\:pe-px{
    padding-left: 1px;
  }

  [dir="ltr"] .sm\\:odd\\:ps-0:nth-child(odd){
    padding-left: 0;
  }

  [dir="rtl"] .sm\\:odd\\:ps-0:nth-child(odd){
    padding-right: 0;
  }

  [dir="ltr"] .sm\\:odd\\:pe-0:nth-child(odd){
    padding-right: 0;
  }

  [dir="rtl"] .sm\\:odd\\:pe-0:nth-child(odd){
    padding-left: 0;
  }

  [dir="ltr"] .sm\\:odd\\:ps-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-4:nth-child(odd){
    padding-left: 1rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-4:nth-child(odd){
    padding-right: 1rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-4:nth-child(odd){
    padding-right: 1rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-4:nth-child(odd){
    padding-left: 1rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-8:nth-child(odd){
    padding-left: 2rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-8:nth-child(odd){
    padding-right: 2rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-8:nth-child(odd){
    padding-right: 2rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-8:nth-child(odd){
    padding-left: 2rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-12:nth-child(odd){
    padding-left: 3rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-12:nth-child(odd){
    padding-right: 3rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-12:nth-child(odd){
    padding-right: 3rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-12:nth-child(odd){
    padding-left: 3rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-16:nth-child(odd){
    padding-left: 4rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-16:nth-child(odd){
    padding-right: 4rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-16:nth-child(odd){
    padding-right: 4rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-16:nth-child(odd){
    padding-left: 4rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-20:nth-child(odd){
    padding-left: 5rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-20:nth-child(odd){
    padding-right: 5rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-20:nth-child(odd){
    padding-right: 5rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-20:nth-child(odd){
    padding-left: 5rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-24:nth-child(odd){
    padding-left: 6rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-24:nth-child(odd){
    padding-right: 6rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-24:nth-child(odd){
    padding-right: 6rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-24:nth-child(odd){
    padding-left: 6rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-28:nth-child(odd){
    padding-left: 7rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-28:nth-child(odd){
    padding-right: 7rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-28:nth-child(odd){
    padding-right: 7rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-28:nth-child(odd){
    padding-left: 7rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-32:nth-child(odd){
    padding-left: 8rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-32:nth-child(odd){
    padding-right: 8rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-32:nth-child(odd){
    padding-right: 8rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-32:nth-child(odd){
    padding-left: 8rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-40:nth-child(odd){
    padding-left: 10rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-40:nth-child(odd){
    padding-right: 10rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-40:nth-child(odd){
    padding-right: 10rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-40:nth-child(odd){
    padding-left: 10rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-44:nth-child(odd){
    padding-left: 11rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-44:nth-child(odd){
    padding-right: 11rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-44:nth-child(odd){
    padding-right: 11rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-44:nth-child(odd){
    padding-left: 11rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-48:nth-child(odd){
    padding-left: 12rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-48:nth-child(odd){
    padding-right: 12rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-48:nth-child(odd){
    padding-right: 12rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-48:nth-child(odd){
    padding-left: 12rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-52:nth-child(odd){
    padding-left: 13rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-52:nth-child(odd){
    padding-right: 13rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-52:nth-child(odd){
    padding-right: 13rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-52:nth-child(odd){
    padding-left: 13rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-56:nth-child(odd){
    padding-left: 14rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-56:nth-child(odd){
    padding-right: 14rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-56:nth-child(odd){
    padding-right: 14rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-56:nth-child(odd){
    padding-left: 14rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-60:nth-child(odd){
    padding-left: 15rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-60:nth-child(odd){
    padding-right: 15rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-60:nth-child(odd){
    padding-right: 15rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-60:nth-child(odd){
    padding-left: 15rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-64:nth-child(odd){
    padding-left: 16rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-64:nth-child(odd){
    padding-right: 16rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-64:nth-child(odd){
    padding-right: 16rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-64:nth-child(odd){
    padding-left: 16rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-68:nth-child(odd){
    padding-left: 17rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-68:nth-child(odd){
    padding-right: 17rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-68:nth-child(odd){
    padding-right: 17rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-68:nth-child(odd){
    padding-left: 17rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-72:nth-child(odd){
    padding-left: 18rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-72:nth-child(odd){
    padding-right: 18rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-72:nth-child(odd){
    padding-right: 18rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-72:nth-child(odd){
    padding-left: 18rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-76:nth-child(odd){
    padding-left: 19rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-76:nth-child(odd){
    padding-right: 19rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-76:nth-child(odd){
    padding-right: 19rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-76:nth-child(odd){
    padding-left: 19rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-80:nth-child(odd){
    padding-left: 20rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-80:nth-child(odd){
    padding-right: 20rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-80:nth-child(odd){
    padding-right: 20rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-80:nth-child(odd){
    padding-left: 20rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-84:nth-child(odd){
    padding-left: 21rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-84:nth-child(odd){
    padding-right: 21rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-84:nth-child(odd){
    padding-right: 21rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-84:nth-child(odd){
    padding-left: 21rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-88:nth-child(odd){
    padding-left: 22rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-88:nth-child(odd){
    padding-right: 22rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-88:nth-child(odd){
    padding-right: 22rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-88:nth-child(odd){
    padding-left: 22rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-92:nth-child(odd){
    padding-left: 23rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-92:nth-child(odd){
    padding-right: 23rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-92:nth-child(odd){
    padding-right: 23rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-92:nth-child(odd){
    padding-left: 23rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-96:nth-child(odd){
    padding-left: 24rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-96:nth-child(odd){
    padding-right: 24rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-96:nth-child(odd){
    padding-right: 24rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-96:nth-child(odd){
    padding-left: 24rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-100:nth-child(odd){
    padding-left: 25rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-100:nth-child(odd){
    padding-right: 25rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-100:nth-child(odd){
    padding-right: 25rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-100:nth-child(odd){
    padding-left: 25rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-104:nth-child(odd){
    padding-left: 26rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-104:nth-child(odd){
    padding-right: 26rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-104:nth-child(odd){
    padding-right: 26rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-104:nth-child(odd){
    padding-left: 26rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-112:nth-child(odd){
    padding-left: 28rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-112:nth-child(odd){
    padding-right: 28rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-112:nth-child(odd){
    padding-right: 28rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-112:nth-child(odd){
    padding-left: 28rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-124:nth-child(odd){
    padding-left: 31rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-124:nth-child(odd){
    padding-right: 31rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-124:nth-child(odd){
    padding-right: 31rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-124:nth-child(odd){
    padding-left: 31rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-128:nth-child(odd){
    padding-left: 32rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-128:nth-child(odd){
    padding-right: 32rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-128:nth-child(odd){
    padding-right: 32rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-128:nth-child(odd){
    padding-left: 32rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-140:nth-child(odd){
    padding-left: 35rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-140:nth-child(odd){
    padding-right: 35rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-140:nth-child(odd){
    padding-right: 35rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-140:nth-child(odd){
    padding-left: 35rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-152:nth-child(odd){
    padding-left: 38rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-152:nth-child(odd){
    padding-right: 38rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-152:nth-child(odd){
    padding-right: 38rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-152:nth-child(odd){
    padding-left: 38rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-160:nth-child(odd){
    padding-left: 40rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-160:nth-child(odd){
    padding-right: 40rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-160:nth-child(odd){
    padding-right: 40rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-160:nth-child(odd){
    padding-left: 40rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-162:nth-child(odd){
    padding-left: 41rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-162:nth-child(odd){
    padding-right: 41rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-162:nth-child(odd){
    padding-right: 41rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-162:nth-child(odd){
    padding-left: 41rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-192:nth-child(odd){
    padding-left: 48rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-192:nth-child(odd){
    padding-right: 48rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-192:nth-child(odd){
    padding-right: 48rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-192:nth-child(odd){
    padding-left: 48rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-208:nth-child(odd){
    padding-left: 52rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-208:nth-child(odd){
    padding-right: 52rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-208:nth-child(odd){
    padding-right: 52rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-208:nth-child(odd){
    padding-left: 52rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-224:nth-child(odd){
    padding-left: 56rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-224:nth-child(odd){
    padding-right: 56rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-224:nth-child(odd){
    padding-right: 56rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-224:nth-child(odd){
    padding-left: 56rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-256:nth-child(odd){
    padding-left: 64rem;
  }

  [dir="rtl"] .sm\\:odd\\:ps-256:nth-child(odd){
    padding-right: 64rem;
  }

  [dir="ltr"] .sm\\:odd\\:pe-256:nth-child(odd){
    padding-right: 64rem;
  }

  [dir="rtl"] .sm\\:odd\\:pe-256:nth-child(odd){
    padding-left: 64rem;
  }

  [dir="ltr"] .sm\\:odd\\:ps-px:nth-child(odd){
    padding-left: 1px;
  }

  [dir="rtl"] .sm\\:odd\\:ps-px:nth-child(odd){
    padding-right: 1px;
  }

  [dir="ltr"] .sm\\:odd\\:pe-px:nth-child(odd){
    padding-right: 1px;
  }

  [dir="rtl"] .sm\\:odd\\:pe-px:nth-child(odd){
    padding-left: 1px;
  }

  [dir="ltr"] .sm\\:even\\:ps-0:nth-child(even){
    padding-left: 0;
  }

  [dir="rtl"] .sm\\:even\\:ps-0:nth-child(even){
    padding-right: 0;
  }

  [dir="ltr"] .sm\\:even\\:pe-0:nth-child(even){
    padding-right: 0;
  }

  [dir="rtl"] .sm\\:even\\:pe-0:nth-child(even){
    padding-left: 0;
  }

  [dir="ltr"] .sm\\:even\\:ps-1:nth-child(even){
    padding-left: 0.25rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-1:nth-child(even){
    padding-right: 0.25rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-1:nth-child(even){
    padding-right: 0.25rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-1:nth-child(even){
    padding-left: 0.25rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-2:nth-child(even){
    padding-left: 0.5rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-2:nth-child(even){
    padding-right: 0.5rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-2:nth-child(even){
    padding-right: 0.5rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-2:nth-child(even){
    padding-left: 0.5rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-3:nth-child(even){
    padding-left: 0.75rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-3:nth-child(even){
    padding-right: 0.75rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-3:nth-child(even){
    padding-right: 0.75rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-3:nth-child(even){
    padding-left: 0.75rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-4:nth-child(even){
    padding-left: 1rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-4:nth-child(even){
    padding-right: 1rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-4:nth-child(even){
    padding-right: 1rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-4:nth-child(even){
    padding-left: 1rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-5:nth-child(even){
    padding-left: 1.25rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-5:nth-child(even){
    padding-right: 1.25rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-5:nth-child(even){
    padding-right: 1.25rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-5:nth-child(even){
    padding-left: 1.25rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-6:nth-child(even){
    padding-left: 1.5rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-6:nth-child(even){
    padding-right: 1.5rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-6:nth-child(even){
    padding-right: 1.5rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-6:nth-child(even){
    padding-left: 1.5rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-7:nth-child(even){
    padding-left: 1.75rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-7:nth-child(even){
    padding-right: 1.75rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-7:nth-child(even){
    padding-right: 1.75rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-7:nth-child(even){
    padding-left: 1.75rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-8:nth-child(even){
    padding-left: 2rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-8:nth-child(even){
    padding-right: 2rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-8:nth-child(even){
    padding-right: 2rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-8:nth-child(even){
    padding-left: 2rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-9:nth-child(even){
    padding-left: 2.25rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-9:nth-child(even){
    padding-right: 2.25rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-9:nth-child(even){
    padding-right: 2.25rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-9:nth-child(even){
    padding-left: 2.25rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-10:nth-child(even){
    padding-left: 2.5rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-10:nth-child(even){
    padding-right: 2.5rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-10:nth-child(even){
    padding-right: 2.5rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-10:nth-child(even){
    padding-left: 2.5rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-11:nth-child(even){
    padding-left: 2.75rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-11:nth-child(even){
    padding-right: 2.75rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-11:nth-child(even){
    padding-right: 2.75rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-11:nth-child(even){
    padding-left: 2.75rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-12:nth-child(even){
    padding-left: 3rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-12:nth-child(even){
    padding-right: 3rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-12:nth-child(even){
    padding-right: 3rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-12:nth-child(even){
    padding-left: 3rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-14:nth-child(even){
    padding-left: 3.5rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-14:nth-child(even){
    padding-right: 3.5rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-14:nth-child(even){
    padding-right: 3.5rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-14:nth-child(even){
    padding-left: 3.5rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-15:nth-child(even){
    padding-left: 3.75rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-15:nth-child(even){
    padding-right: 3.75rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-15:nth-child(even){
    padding-right: 3.75rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-15:nth-child(even){
    padding-left: 3.75rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-16:nth-child(even){
    padding-left: 4rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-16:nth-child(even){
    padding-right: 4rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-16:nth-child(even){
    padding-right: 4rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-16:nth-child(even){
    padding-left: 4rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-18:nth-child(even){
    padding-left: 4.5rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-18:nth-child(even){
    padding-right: 4.5rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-18:nth-child(even){
    padding-right: 4.5rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-18:nth-child(even){
    padding-left: 4.5rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-20:nth-child(even){
    padding-left: 5rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-20:nth-child(even){
    padding-right: 5rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-20:nth-child(even){
    padding-right: 5rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-20:nth-child(even){
    padding-left: 5rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-22:nth-child(even){
    padding-left: 5.5rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-22:nth-child(even){
    padding-right: 5.5rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-22:nth-child(even){
    padding-right: 5.5rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-22:nth-child(even){
    padding-left: 5.5rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-23:nth-child(even){
    padding-left: 5.75rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-23:nth-child(even){
    padding-right: 5.75rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-23:nth-child(even){
    padding-right: 5.75rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-23:nth-child(even){
    padding-left: 5.75rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-24:nth-child(even){
    padding-left: 6rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-24:nth-child(even){
    padding-right: 6rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-24:nth-child(even){
    padding-right: 6rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-24:nth-child(even){
    padding-left: 6rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-25:nth-child(even){
    padding-left: 6.25rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-25:nth-child(even){
    padding-right: 6.25rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-25:nth-child(even){
    padding-right: 6.25rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-25:nth-child(even){
    padding-left: 6.25rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-26:nth-child(even){
    padding-left: 6.5rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-26:nth-child(even){
    padding-right: 6.5rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-26:nth-child(even){
    padding-right: 6.5rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-26:nth-child(even){
    padding-left: 6.5rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-28:nth-child(even){
    padding-left: 7rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-28:nth-child(even){
    padding-right: 7rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-28:nth-child(even){
    padding-right: 7rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-28:nth-child(even){
    padding-left: 7rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-30:nth-child(even){
    padding-left: 7.5rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-30:nth-child(even){
    padding-right: 7.5rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-30:nth-child(even){
    padding-right: 7.5rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-30:nth-child(even){
    padding-left: 7.5rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-32:nth-child(even){
    padding-left: 8rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-32:nth-child(even){
    padding-right: 8rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-32:nth-child(even){
    padding-right: 8rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-32:nth-child(even){
    padding-left: 8rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-34:nth-child(even){
    padding-left: 8.5rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-34:nth-child(even){
    padding-right: 8.5rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-34:nth-child(even){
    padding-right: 8.5rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-34:nth-child(even){
    padding-left: 8.5rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-40:nth-child(even){
    padding-left: 10rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-40:nth-child(even){
    padding-right: 10rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-40:nth-child(even){
    padding-right: 10rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-40:nth-child(even){
    padding-left: 10rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-42:nth-child(even){
    padding-left: 10.5rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-42:nth-child(even){
    padding-right: 10.5rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-42:nth-child(even){
    padding-right: 10.5rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-42:nth-child(even){
    padding-left: 10.5rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-44:nth-child(even){
    padding-left: 11rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-44:nth-child(even){
    padding-right: 11rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-44:nth-child(even){
    padding-right: 11rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-44:nth-child(even){
    padding-left: 11rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-48:nth-child(even){
    padding-left: 12rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-48:nth-child(even){
    padding-right: 12rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-48:nth-child(even){
    padding-right: 12rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-48:nth-child(even){
    padding-left: 12rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-52:nth-child(even){
    padding-left: 13rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-52:nth-child(even){
    padding-right: 13rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-52:nth-child(even){
    padding-right: 13rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-52:nth-child(even){
    padding-left: 13rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-54:nth-child(even){
    padding-left: 13.5rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-54:nth-child(even){
    padding-right: 13.5rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-54:nth-child(even){
    padding-right: 13.5rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-54:nth-child(even){
    padding-left: 13.5rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-56:nth-child(even){
    padding-left: 14rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-56:nth-child(even){
    padding-right: 14rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-56:nth-child(even){
    padding-right: 14rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-56:nth-child(even){
    padding-left: 14rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-60:nth-child(even){
    padding-left: 15rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-60:nth-child(even){
    padding-right: 15rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-60:nth-child(even){
    padding-right: 15rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-60:nth-child(even){
    padding-left: 15rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-64:nth-child(even){
    padding-left: 16rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-64:nth-child(even){
    padding-right: 16rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-64:nth-child(even){
    padding-right: 16rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-64:nth-child(even){
    padding-left: 16rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-68:nth-child(even){
    padding-left: 17rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-68:nth-child(even){
    padding-right: 17rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-68:nth-child(even){
    padding-right: 17rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-68:nth-child(even){
    padding-left: 17rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-72:nth-child(even){
    padding-left: 18rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-72:nth-child(even){
    padding-right: 18rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-72:nth-child(even){
    padding-right: 18rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-72:nth-child(even){
    padding-left: 18rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-74:nth-child(even){
    padding-left: 18.5rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-74:nth-child(even){
    padding-right: 18.5rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-74:nth-child(even){
    padding-right: 18.5rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-74:nth-child(even){
    padding-left: 18.5rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-76:nth-child(even){
    padding-left: 19rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-76:nth-child(even){
    padding-right: 19rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-76:nth-child(even){
    padding-right: 19rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-76:nth-child(even){
    padding-left: 19rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-78:nth-child(even){
    padding-left: 19.5rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-78:nth-child(even){
    padding-right: 19.5rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-78:nth-child(even){
    padding-right: 19.5rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-78:nth-child(even){
    padding-left: 19.5rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-80:nth-child(even){
    padding-left: 20rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-80:nth-child(even){
    padding-right: 20rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-80:nth-child(even){
    padding-right: 20rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-80:nth-child(even){
    padding-left: 20rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-82:nth-child(even){
    padding-left: 20.5rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-82:nth-child(even){
    padding-right: 20.5rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-82:nth-child(even){
    padding-right: 20.5rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-82:nth-child(even){
    padding-left: 20.5rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-84:nth-child(even){
    padding-left: 21rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-84:nth-child(even){
    padding-right: 21rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-84:nth-child(even){
    padding-right: 21rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-84:nth-child(even){
    padding-left: 21rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-88:nth-child(even){
    padding-left: 22rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-88:nth-child(even){
    padding-right: 22rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-88:nth-child(even){
    padding-right: 22rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-88:nth-child(even){
    padding-left: 22rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-92:nth-child(even){
    padding-left: 23rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-92:nth-child(even){
    padding-right: 23rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-92:nth-child(even){
    padding-right: 23rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-92:nth-child(even){
    padding-left: 23rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-96:nth-child(even){
    padding-left: 24rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-96:nth-child(even){
    padding-right: 24rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-96:nth-child(even){
    padding-right: 24rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-96:nth-child(even){
    padding-left: 24rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-98:nth-child(even){
    padding-left: 24.5rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-98:nth-child(even){
    padding-right: 24.5rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-98:nth-child(even){
    padding-right: 24.5rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-98:nth-child(even){
    padding-left: 24.5rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-100:nth-child(even){
    padding-left: 25rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-100:nth-child(even){
    padding-right: 25rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-100:nth-child(even){
    padding-right: 25rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-100:nth-child(even){
    padding-left: 25rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-104:nth-child(even){
    padding-left: 26rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-104:nth-child(even){
    padding-right: 26rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-104:nth-child(even){
    padding-right: 26rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-104:nth-child(even){
    padding-left: 26rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-112:nth-child(even){
    padding-left: 28rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-112:nth-child(even){
    padding-right: 28rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-112:nth-child(even){
    padding-right: 28rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-112:nth-child(even){
    padding-left: 28rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-124:nth-child(even){
    padding-left: 31rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-124:nth-child(even){
    padding-right: 31rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-124:nth-child(even){
    padding-right: 31rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-124:nth-child(even){
    padding-left: 31rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-128:nth-child(even){
    padding-left: 32rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-128:nth-child(even){
    padding-right: 32rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-128:nth-child(even){
    padding-right: 32rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-128:nth-child(even){
    padding-left: 32rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-140:nth-child(even){
    padding-left: 35rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-140:nth-child(even){
    padding-right: 35rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-140:nth-child(even){
    padding-right: 35rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-140:nth-child(even){
    padding-left: 35rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-152:nth-child(even){
    padding-left: 38rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-152:nth-child(even){
    padding-right: 38rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-152:nth-child(even){
    padding-right: 38rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-152:nth-child(even){
    padding-left: 38rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-160:nth-child(even){
    padding-left: 40rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-160:nth-child(even){
    padding-right: 40rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-160:nth-child(even){
    padding-right: 40rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-160:nth-child(even){
    padding-left: 40rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-162:nth-child(even){
    padding-left: 41rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-162:nth-child(even){
    padding-right: 41rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-162:nth-child(even){
    padding-right: 41rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-162:nth-child(even){
    padding-left: 41rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-192:nth-child(even){
    padding-left: 48rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-192:nth-child(even){
    padding-right: 48rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-192:nth-child(even){
    padding-right: 48rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-192:nth-child(even){
    padding-left: 48rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-208:nth-child(even){
    padding-left: 52rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-208:nth-child(even){
    padding-right: 52rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-208:nth-child(even){
    padding-right: 52rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-208:nth-child(even){
    padding-left: 52rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-224:nth-child(even){
    padding-left: 56rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-224:nth-child(even){
    padding-right: 56rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-224:nth-child(even){
    padding-right: 56rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-224:nth-child(even){
    padding-left: 56rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-256:nth-child(even){
    padding-left: 64rem;
  }

  [dir="rtl"] .sm\\:even\\:ps-256:nth-child(even){
    padding-right: 64rem;
  }

  [dir="ltr"] .sm\\:even\\:pe-256:nth-child(even){
    padding-right: 64rem;
  }

  [dir="rtl"] .sm\\:even\\:pe-256:nth-child(even){
    padding-left: 64rem;
  }

  [dir="ltr"] .sm\\:even\\:ps-px:nth-child(even){
    padding-left: 1px;
  }

  [dir="rtl"] .sm\\:even\\:ps-px:nth-child(even){
    padding-right: 1px;
  }

  [dir="ltr"] .sm\\:even\\:pe-px:nth-child(even){
    padding-right: 1px;
  }

  [dir="rtl"] .sm\\:even\\:pe-px:nth-child(even){
    padding-left: 1px;
  }

  [dir="ltr"] .sm\\:ms-0{
    margin-left: 0;
  }

  [dir="rtl"] .sm\\:ms-0{
    margin-right: 0;
  }

  [dir="ltr"] .sm\\:me-0{
    margin-right: 0;
  }

  [dir="rtl"] .sm\\:me-0{
    margin-left: 0;
  }

  [dir="ltr"] .sm\\:ms-1{
    margin-left: 0.25rem;
  }

  [dir="rtl"] .sm\\:ms-1{
    margin-right: 0.25rem;
  }

  [dir="ltr"] .sm\\:me-1{
    margin-right: 0.25rem;
  }

  [dir="rtl"] .sm\\:me-1{
    margin-left: 0.25rem;
  }

  [dir="ltr"] .sm\\:ms-2{
    margin-left: 0.5rem;
  }

  [dir="rtl"] .sm\\:ms-2{
    margin-right: 0.5rem;
  }

  [dir="ltr"] .sm\\:me-2{
    margin-right: 0.5rem;
  }

  [dir="rtl"] .sm\\:me-2{
    margin-left: 0.5rem;
  }

  [dir="ltr"] .sm\\:ms-3{
    margin-left: 0.75rem;
  }

  [dir="rtl"] .sm\\:ms-3{
    margin-right: 0.75rem;
  }

  [dir="ltr"] .sm\\:me-3{
    margin-right: 0.75rem;
  }

  [dir="rtl"] .sm\\:me-3{
    margin-left: 0.75rem;
  }

  [dir="ltr"] .sm\\:ms-4{
    margin-left: 1rem;
  }

  [dir="rtl"] .sm\\:ms-4{
    margin-right: 1rem;
  }

  [dir="ltr"] .sm\\:me-4{
    margin-right: 1rem;
  }

  [dir="rtl"] .sm\\:me-4{
    margin-left: 1rem;
  }

  [dir="ltr"] .sm\\:ms-5{
    margin-left: 1.25rem;
  }

  [dir="rtl"] .sm\\:ms-5{
    margin-right: 1.25rem;
  }

  [dir="ltr"] .sm\\:me-5{
    margin-right: 1.25rem;
  }

  [dir="rtl"] .sm\\:me-5{
    margin-left: 1.25rem;
  }

  [dir="ltr"] .sm\\:ms-6{
    margin-left: 1.5rem;
  }

  [dir="rtl"] .sm\\:ms-6{
    margin-right: 1.5rem;
  }

  [dir="ltr"] .sm\\:me-6{
    margin-right: 1.5rem;
  }

  [dir="rtl"] .sm\\:me-6{
    margin-left: 1.5rem;
  }

  [dir="ltr"] .sm\\:ms-7{
    margin-left: 1.75rem;
  }

  [dir="rtl"] .sm\\:ms-7{
    margin-right: 1.75rem;
  }

  [dir="ltr"] .sm\\:me-7{
    margin-right: 1.75rem;
  }

  [dir="rtl"] .sm\\:me-7{
    margin-left: 1.75rem;
  }

  [dir="ltr"] .sm\\:ms-8{
    margin-left: 2rem;
  }

  [dir="rtl"] .sm\\:ms-8{
    margin-right: 2rem;
  }

  [dir="ltr"] .sm\\:me-8{
    margin-right: 2rem;
  }

  [dir="rtl"] .sm\\:me-8{
    margin-left: 2rem;
  }

  [dir="ltr"] .sm\\:ms-9{
    margin-left: 2.25rem;
  }

  [dir="rtl"] .sm\\:ms-9{
    margin-right: 2.25rem;
  }

  [dir="ltr"] .sm\\:me-9{
    margin-right: 2.25rem;
  }

  [dir="rtl"] .sm\\:me-9{
    margin-left: 2.25rem;
  }

  [dir="ltr"] .sm\\:ms-10{
    margin-left: 2.5rem;
  }

  [dir="rtl"] .sm\\:ms-10{
    margin-right: 2.5rem;
  }

  [dir="ltr"] .sm\\:me-10{
    margin-right: 2.5rem;
  }

  [dir="rtl"] .sm\\:me-10{
    margin-left: 2.5rem;
  }

  [dir="ltr"] .sm\\:ms-11{
    margin-left: 2.75rem;
  }

  [dir="rtl"] .sm\\:ms-11{
    margin-right: 2.75rem;
  }

  [dir="ltr"] .sm\\:me-11{
    margin-right: 2.75rem;
  }

  [dir="rtl"] .sm\\:me-11{
    margin-left: 2.75rem;
  }

  [dir="ltr"] .sm\\:ms-12{
    margin-left: 3rem;
  }

  [dir="rtl"] .sm\\:ms-12{
    margin-right: 3rem;
  }

  [dir="ltr"] .sm\\:me-12{
    margin-right: 3rem;
  }

  [dir="rtl"] .sm\\:me-12{
    margin-left: 3rem;
  }

  [dir="ltr"] .sm\\:ms-14{
    margin-left: 3.5rem;
  }

  [dir="rtl"] .sm\\:ms-14{
    margin-right: 3.5rem;
  }

  [dir="ltr"] .sm\\:me-14{
    margin-right: 3.5rem;
  }

  [dir="rtl"] .sm\\:me-14{
    margin-left: 3.5rem;
  }

  [dir="ltr"] .sm\\:ms-15{
    margin-left: 3.75rem;
  }

  [dir="rtl"] .sm\\:ms-15{
    margin-right: 3.75rem;
  }

  [dir="ltr"] .sm\\:me-15{
    margin-right: 3.75rem;
  }

  [dir="rtl"] .sm\\:me-15{
    margin-left: 3.75rem;
  }

  [dir="ltr"] .sm\\:ms-16{
    margin-left: 4rem;
  }

  [dir="rtl"] .sm\\:ms-16{
    margin-right: 4rem;
  }

  [dir="ltr"] .sm\\:me-16{
    margin-right: 4rem;
  }

  [dir="rtl"] .sm\\:me-16{
    margin-left: 4rem;
  }

  [dir="ltr"] .sm\\:ms-18{
    margin-left: 4.5rem;
  }

  [dir="rtl"] .sm\\:ms-18{
    margin-right: 4.5rem;
  }

  [dir="ltr"] .sm\\:me-18{
    margin-right: 4.5rem;
  }

  [dir="rtl"] .sm\\:me-18{
    margin-left: 4.5rem;
  }

  [dir="ltr"] .sm\\:ms-20{
    margin-left: 5rem;
  }

  [dir="rtl"] .sm\\:ms-20{
    margin-right: 5rem;
  }

  [dir="ltr"] .sm\\:me-20{
    margin-right: 5rem;
  }

  [dir="rtl"] .sm\\:me-20{
    margin-left: 5rem;
  }

  [dir="ltr"] .sm\\:ms-22{
    margin-left: 5.5rem;
  }

  [dir="rtl"] .sm\\:ms-22{
    margin-right: 5.5rem;
  }

  [dir="ltr"] .sm\\:me-22{
    margin-right: 5.5rem;
  }

  [dir="rtl"] .sm\\:me-22{
    margin-left: 5.5rem;
  }

  [dir="ltr"] .sm\\:ms-23{
    margin-left: 5.75rem;
  }

  [dir="rtl"] .sm\\:ms-23{
    margin-right: 5.75rem;
  }

  [dir="ltr"] .sm\\:me-23{
    margin-right: 5.75rem;
  }

  [dir="rtl"] .sm\\:me-23{
    margin-left: 5.75rem;
  }

  [dir="ltr"] .sm\\:ms-24{
    margin-left: 6rem;
  }

  [dir="rtl"] .sm\\:ms-24{
    margin-right: 6rem;
  }

  [dir="ltr"] .sm\\:me-24{
    margin-right: 6rem;
  }

  [dir="rtl"] .sm\\:me-24{
    margin-left: 6rem;
  }

  [dir="ltr"] .sm\\:ms-25{
    margin-left: 6.25rem;
  }

  [dir="rtl"] .sm\\:ms-25{
    margin-right: 6.25rem;
  }

  [dir="ltr"] .sm\\:me-25{
    margin-right: 6.25rem;
  }

  [dir="rtl"] .sm\\:me-25{
    margin-left: 6.25rem;
  }

  [dir="ltr"] .sm\\:ms-26{
    margin-left: 6.5rem;
  }

  [dir="rtl"] .sm\\:ms-26{
    margin-right: 6.5rem;
  }

  [dir="ltr"] .sm\\:me-26{
    margin-right: 6.5rem;
  }

  [dir="rtl"] .sm\\:me-26{
    margin-left: 6.5rem;
  }

  [dir="ltr"] .sm\\:ms-28{
    margin-left: 7rem;
  }

  [dir="rtl"] .sm\\:ms-28{
    margin-right: 7rem;
  }

  [dir="ltr"] .sm\\:me-28{
    margin-right: 7rem;
  }

  [dir="rtl"] .sm\\:me-28{
    margin-left: 7rem;
  }

  [dir="ltr"] .sm\\:ms-30{
    margin-left: 7.5rem;
  }

  [dir="rtl"] .sm\\:ms-30{
    margin-right: 7.5rem;
  }

  [dir="ltr"] .sm\\:me-30{
    margin-right: 7.5rem;
  }

  [dir="rtl"] .sm\\:me-30{
    margin-left: 7.5rem;
  }

  [dir="ltr"] .sm\\:ms-32{
    margin-left: 8rem;
  }

  [dir="rtl"] .sm\\:ms-32{
    margin-right: 8rem;
  }

  [dir="ltr"] .sm\\:me-32{
    margin-right: 8rem;
  }

  [dir="rtl"] .sm\\:me-32{
    margin-left: 8rem;
  }

  [dir="ltr"] .sm\\:ms-34{
    margin-left: 8.5rem;
  }

  [dir="rtl"] .sm\\:ms-34{
    margin-right: 8.5rem;
  }

  [dir="ltr"] .sm\\:me-34{
    margin-right: 8.5rem;
  }

  [dir="rtl"] .sm\\:me-34{
    margin-left: 8.5rem;
  }

  [dir="ltr"] .sm\\:ms-40{
    margin-left: 10rem;
  }

  [dir="rtl"] .sm\\:ms-40{
    margin-right: 10rem;
  }

  [dir="ltr"] .sm\\:me-40{
    margin-right: 10rem;
  }

  [dir="rtl"] .sm\\:me-40{
    margin-left: 10rem;
  }

  [dir="ltr"] .sm\\:ms-42{
    margin-left: 10.5rem;
  }

  [dir="rtl"] .sm\\:ms-42{
    margin-right: 10.5rem;
  }

  [dir="ltr"] .sm\\:me-42{
    margin-right: 10.5rem;
  }

  [dir="rtl"] .sm\\:me-42{
    margin-left: 10.5rem;
  }

  [dir="ltr"] .sm\\:ms-44{
    margin-left: 11rem;
  }

  [dir="rtl"] .sm\\:ms-44{
    margin-right: 11rem;
  }

  [dir="ltr"] .sm\\:me-44{
    margin-right: 11rem;
  }

  [dir="rtl"] .sm\\:me-44{
    margin-left: 11rem;
  }

  [dir="ltr"] .sm\\:ms-48{
    margin-left: 12rem;
  }

  [dir="rtl"] .sm\\:ms-48{
    margin-right: 12rem;
  }

  [dir="ltr"] .sm\\:me-48{
    margin-right: 12rem;
  }

  [dir="rtl"] .sm\\:me-48{
    margin-left: 12rem;
  }

  [dir="ltr"] .sm\\:ms-52{
    margin-left: 13rem;
  }

  [dir="rtl"] .sm\\:ms-52{
    margin-right: 13rem;
  }

  [dir="ltr"] .sm\\:me-52{
    margin-right: 13rem;
  }

  [dir="rtl"] .sm\\:me-52{
    margin-left: 13rem;
  }

  [dir="ltr"] .sm\\:ms-54{
    margin-left: 13.5rem;
  }

  [dir="rtl"] .sm\\:ms-54{
    margin-right: 13.5rem;
  }

  [dir="ltr"] .sm\\:me-54{
    margin-right: 13.5rem;
  }

  [dir="rtl"] .sm\\:me-54{
    margin-left: 13.5rem;
  }

  [dir="ltr"] .sm\\:ms-56{
    margin-left: 14rem;
  }

  [dir="rtl"] .sm\\:ms-56{
    margin-right: 14rem;
  }

  [dir="ltr"] .sm\\:me-56{
    margin-right: 14rem;
  }

  [dir="rtl"] .sm\\:me-56{
    margin-left: 14rem;
  }

  [dir="ltr"] .sm\\:ms-60{
    margin-left: 15rem;
  }

  [dir="rtl"] .sm\\:ms-60{
    margin-right: 15rem;
  }

  [dir="ltr"] .sm\\:me-60{
    margin-right: 15rem;
  }

  [dir="rtl"] .sm\\:me-60{
    margin-left: 15rem;
  }

  [dir="ltr"] .sm\\:ms-64{
    margin-left: 16rem;
  }

  [dir="rtl"] .sm\\:ms-64{
    margin-right: 16rem;
  }

  [dir="ltr"] .sm\\:me-64{
    margin-right: 16rem;
  }

  [dir="rtl"] .sm\\:me-64{
    margin-left: 16rem;
  }

  [dir="ltr"] .sm\\:ms-68{
    margin-left: 17rem;
  }

  [dir="rtl"] .sm\\:ms-68{
    margin-right: 17rem;
  }

  [dir="ltr"] .sm\\:me-68{
    margin-right: 17rem;
  }

  [dir="rtl"] .sm\\:me-68{
    margin-left: 17rem;
  }

  [dir="ltr"] .sm\\:ms-72{
    margin-left: 18rem;
  }

  [dir="rtl"] .sm\\:ms-72{
    margin-right: 18rem;
  }

  [dir="ltr"] .sm\\:me-72{
    margin-right: 18rem;
  }

  [dir="rtl"] .sm\\:me-72{
    margin-left: 18rem;
  }

  [dir="ltr"] .sm\\:ms-74{
    margin-left: 18.5rem;
  }

  [dir="rtl"] .sm\\:ms-74{
    margin-right: 18.5rem;
  }

  [dir="ltr"] .sm\\:me-74{
    margin-right: 18.5rem;
  }

  [dir="rtl"] .sm\\:me-74{
    margin-left: 18.5rem;
  }

  [dir="ltr"] .sm\\:ms-76{
    margin-left: 19rem;
  }

  [dir="rtl"] .sm\\:ms-76{
    margin-right: 19rem;
  }

  [dir="ltr"] .sm\\:me-76{
    margin-right: 19rem;
  }

  [dir="rtl"] .sm\\:me-76{
    margin-left: 19rem;
  }

  [dir="ltr"] .sm\\:ms-78{
    margin-left: 19.5rem;
  }

  [dir="rtl"] .sm\\:ms-78{
    margin-right: 19.5rem;
  }

  [dir="ltr"] .sm\\:me-78{
    margin-right: 19.5rem;
  }

  [dir="rtl"] .sm\\:me-78{
    margin-left: 19.5rem;
  }

  [dir="ltr"] .sm\\:ms-80{
    margin-left: 20rem;
  }

  [dir="rtl"] .sm\\:ms-80{
    margin-right: 20rem;
  }

  [dir="ltr"] .sm\\:me-80{
    margin-right: 20rem;
  }

  [dir="rtl"] .sm\\:me-80{
    margin-left: 20rem;
  }

  [dir="ltr"] .sm\\:ms-82{
    margin-left: 20.5rem;
  }

  [dir="rtl"] .sm\\:ms-82{
    margin-right: 20.5rem;
  }

  [dir="ltr"] .sm\\:me-82{
    margin-right: 20.5rem;
  }

  [dir="rtl"] .sm\\:me-82{
    margin-left: 20.5rem;
  }

  [dir="ltr"] .sm\\:ms-84{
    margin-left: 21rem;
  }

  [dir="rtl"] .sm\\:ms-84{
    margin-right: 21rem;
  }

  [dir="ltr"] .sm\\:me-84{
    margin-right: 21rem;
  }

  [dir="rtl"] .sm\\:me-84{
    margin-left: 21rem;
  }

  [dir="ltr"] .sm\\:ms-88{
    margin-left: 22rem;
  }

  [dir="rtl"] .sm\\:ms-88{
    margin-right: 22rem;
  }

  [dir="ltr"] .sm\\:me-88{
    margin-right: 22rem;
  }

  [dir="rtl"] .sm\\:me-88{
    margin-left: 22rem;
  }

  [dir="ltr"] .sm\\:ms-92{
    margin-left: 23rem;
  }

  [dir="rtl"] .sm\\:ms-92{
    margin-right: 23rem;
  }

  [dir="ltr"] .sm\\:me-92{
    margin-right: 23rem;
  }

  [dir="rtl"] .sm\\:me-92{
    margin-left: 23rem;
  }

  [dir="ltr"] .sm\\:ms-96{
    margin-left: 24rem;
  }

  [dir="rtl"] .sm\\:ms-96{
    margin-right: 24rem;
  }

  [dir="ltr"] .sm\\:me-96{
    margin-right: 24rem;
  }

  [dir="rtl"] .sm\\:me-96{
    margin-left: 24rem;
  }

  [dir="ltr"] .sm\\:ms-98{
    margin-left: 24.5rem;
  }

  [dir="rtl"] .sm\\:ms-98{
    margin-right: 24.5rem;
  }

  [dir="ltr"] .sm\\:me-98{
    margin-right: 24.5rem;
  }

  [dir="rtl"] .sm\\:me-98{
    margin-left: 24.5rem;
  }

  [dir="ltr"] .sm\\:ms-100{
    margin-left: 25rem;
  }

  [dir="rtl"] .sm\\:ms-100{
    margin-right: 25rem;
  }

  [dir="ltr"] .sm\\:me-100{
    margin-right: 25rem;
  }

  [dir="rtl"] .sm\\:me-100{
    margin-left: 25rem;
  }

  [dir="ltr"] .sm\\:ms-104{
    margin-left: 26rem;
  }

  [dir="rtl"] .sm\\:ms-104{
    margin-right: 26rem;
  }

  [dir="ltr"] .sm\\:me-104{
    margin-right: 26rem;
  }

  [dir="rtl"] .sm\\:me-104{
    margin-left: 26rem;
  }

  [dir="ltr"] .sm\\:ms-112{
    margin-left: 28rem;
  }

  [dir="rtl"] .sm\\:ms-112{
    margin-right: 28rem;
  }

  [dir="ltr"] .sm\\:me-112{
    margin-right: 28rem;
  }

  [dir="rtl"] .sm\\:me-112{
    margin-left: 28rem;
  }

  [dir="ltr"] .sm\\:ms-124{
    margin-left: 31rem;
  }

  [dir="rtl"] .sm\\:ms-124{
    margin-right: 31rem;
  }

  [dir="ltr"] .sm\\:me-124{
    margin-right: 31rem;
  }

  [dir="rtl"] .sm\\:me-124{
    margin-left: 31rem;
  }

  [dir="ltr"] .sm\\:ms-128{
    margin-left: 32rem;
  }

  [dir="rtl"] .sm\\:ms-128{
    margin-right: 32rem;
  }

  [dir="ltr"] .sm\\:me-128{
    margin-right: 32rem;
  }

  [dir="rtl"] .sm\\:me-128{
    margin-left: 32rem;
  }

  [dir="ltr"] .sm\\:ms-140{
    margin-left: 35rem;
  }

  [dir="rtl"] .sm\\:ms-140{
    margin-right: 35rem;
  }

  [dir="ltr"] .sm\\:me-140{
    margin-right: 35rem;
  }

  [dir="rtl"] .sm\\:me-140{
    margin-left: 35rem;
  }

  [dir="ltr"] .sm\\:ms-152{
    margin-left: 38rem;
  }

  [dir="rtl"] .sm\\:ms-152{
    margin-right: 38rem;
  }

  [dir="ltr"] .sm\\:me-152{
    margin-right: 38rem;
  }

  [dir="rtl"] .sm\\:me-152{
    margin-left: 38rem;
  }

  [dir="ltr"] .sm\\:ms-160{
    margin-left: 40rem;
  }

  [dir="rtl"] .sm\\:ms-160{
    margin-right: 40rem;
  }

  [dir="ltr"] .sm\\:me-160{
    margin-right: 40rem;
  }

  [dir="rtl"] .sm\\:me-160{
    margin-left: 40rem;
  }

  [dir="ltr"] .sm\\:ms-162{
    margin-left: 41rem;
  }

  [dir="rtl"] .sm\\:ms-162{
    margin-right: 41rem;
  }

  [dir="ltr"] .sm\\:me-162{
    margin-right: 41rem;
  }

  [dir="rtl"] .sm\\:me-162{
    margin-left: 41rem;
  }

  [dir="ltr"] .sm\\:ms-192{
    margin-left: 48rem;
  }

  [dir="rtl"] .sm\\:ms-192{
    margin-right: 48rem;
  }

  [dir="ltr"] .sm\\:me-192{
    margin-right: 48rem;
  }

  [dir="rtl"] .sm\\:me-192{
    margin-left: 48rem;
  }

  [dir="ltr"] .sm\\:ms-208{
    margin-left: 52rem;
  }

  [dir="rtl"] .sm\\:ms-208{
    margin-right: 52rem;
  }

  [dir="ltr"] .sm\\:me-208{
    margin-right: 52rem;
  }

  [dir="rtl"] .sm\\:me-208{
    margin-left: 52rem;
  }

  [dir="ltr"] .sm\\:ms-224{
    margin-left: 56rem;
  }

  [dir="rtl"] .sm\\:ms-224{
    margin-right: 56rem;
  }

  [dir="ltr"] .sm\\:me-224{
    margin-right: 56rem;
  }

  [dir="rtl"] .sm\\:me-224{
    margin-left: 56rem;
  }

  [dir="ltr"] .sm\\:ms-256{
    margin-left: 64rem;
  }

  [dir="rtl"] .sm\\:ms-256{
    margin-right: 64rem;
  }

  [dir="ltr"] .sm\\:me-256{
    margin-right: 64rem;
  }

  [dir="rtl"] .sm\\:me-256{
    margin-left: 64rem;
  }

  [dir="ltr"] .sm\\:ms-auto{
    margin-left: auto;
  }

  [dir="rtl"] .sm\\:ms-auto{
    margin-right: auto;
  }

  [dir="ltr"] .sm\\:me-auto{
    margin-right: auto;
  }

  [dir="rtl"] .sm\\:me-auto{
    margin-left: auto;
  }

  [dir="ltr"] .sm\\:ms-px{
    margin-left: 1px;
  }

  [dir="rtl"] .sm\\:ms-px{
    margin-right: 1px;
  }

  [dir="ltr"] .sm\\:me-px{
    margin-right: 1px;
  }

  [dir="rtl"] .sm\\:me-px{
    margin-left: 1px;
  }

  [dir="ltr"] .sm\\:-ms-1{
    margin-left: -0.25rem;
  }

  [dir="rtl"] .sm\\:-ms-1{
    margin-right: -0.25rem;
  }

  [dir="ltr"] .sm\\:-me-1{
    margin-right: -0.25rem;
  }

  [dir="rtl"] .sm\\:-me-1{
    margin-left: -0.25rem;
  }

  [dir="ltr"] .sm\\:-ms-2{
    margin-left: -0.5rem;
  }

  [dir="rtl"] .sm\\:-ms-2{
    margin-right: -0.5rem;
  }

  [dir="ltr"] .sm\\:-me-2{
    margin-right: -0.5rem;
  }

  [dir="rtl"] .sm\\:-me-2{
    margin-left: -0.5rem;
  }

  [dir="ltr"] .sm\\:-ms-3{
    margin-left: -0.75rem;
  }

  [dir="rtl"] .sm\\:-ms-3{
    margin-right: -0.75rem;
  }

  [dir="ltr"] .sm\\:-me-3{
    margin-right: -0.75rem;
  }

  [dir="rtl"] .sm\\:-me-3{
    margin-left: -0.75rem;
  }

  [dir="ltr"] .sm\\:-ms-4{
    margin-left: -1rem;
  }

  [dir="rtl"] .sm\\:-ms-4{
    margin-right: -1rem;
  }

  [dir="ltr"] .sm\\:-me-4{
    margin-right: -1rem;
  }

  [dir="rtl"] .sm\\:-me-4{
    margin-left: -1rem;
  }

  [dir="ltr"] .sm\\:-ms-5{
    margin-left: -1.25rem;
  }

  [dir="rtl"] .sm\\:-ms-5{
    margin-right: -1.25rem;
  }

  [dir="ltr"] .sm\\:-me-5{
    margin-right: -1.25rem;
  }

  [dir="rtl"] .sm\\:-me-5{
    margin-left: -1.25rem;
  }

  [dir="ltr"] .sm\\:-ms-6{
    margin-left: -1.5rem;
  }

  [dir="rtl"] .sm\\:-ms-6{
    margin-right: -1.5rem;
  }

  [dir="ltr"] .sm\\:-me-6{
    margin-right: -1.5rem;
  }

  [dir="rtl"] .sm\\:-me-6{
    margin-left: -1.5rem;
  }

  [dir="ltr"] .sm\\:-ms-7{
    margin-left: -1.75rem;
  }

  [dir="rtl"] .sm\\:-ms-7{
    margin-right: -1.75rem;
  }

  [dir="ltr"] .sm\\:-me-7{
    margin-right: -1.75rem;
  }

  [dir="rtl"] .sm\\:-me-7{
    margin-left: -1.75rem;
  }

  [dir="ltr"] .sm\\:-ms-8{
    margin-left: -2rem;
  }

  [dir="rtl"] .sm\\:-ms-8{
    margin-right: -2rem;
  }

  [dir="ltr"] .sm\\:-me-8{
    margin-right: -2rem;
  }

  [dir="rtl"] .sm\\:-me-8{
    margin-left: -2rem;
  }

  [dir="ltr"] .sm\\:-ms-9{
    margin-left: -2.25rem;
  }

  [dir="rtl"] .sm\\:-ms-9{
    margin-right: -2.25rem;
  }

  [dir="ltr"] .sm\\:-me-9{
    margin-right: -2.25rem;
  }

  [dir="rtl"] .sm\\:-me-9{
    margin-left: -2.25rem;
  }

  [dir="ltr"] .sm\\:-ms-10{
    margin-left: -2.5rem;
  }

  [dir="rtl"] .sm\\:-ms-10{
    margin-right: -2.5rem;
  }

  [dir="ltr"] .sm\\:-me-10{
    margin-right: -2.5rem;
  }

  [dir="rtl"] .sm\\:-me-10{
    margin-left: -2.5rem;
  }

  [dir="ltr"] .sm\\:-ms-11{
    margin-left: -2.75rem;
  }

  [dir="rtl"] .sm\\:-ms-11{
    margin-right: -2.75rem;
  }

  [dir="ltr"] .sm\\:-me-11{
    margin-right: -2.75rem;
  }

  [dir="rtl"] .sm\\:-me-11{
    margin-left: -2.75rem;
  }

  [dir="ltr"] .sm\\:-ms-12{
    margin-left: -3rem;
  }

  [dir="rtl"] .sm\\:-ms-12{
    margin-right: -3rem;
  }

  [dir="ltr"] .sm\\:-me-12{
    margin-right: -3rem;
  }

  [dir="rtl"] .sm\\:-me-12{
    margin-left: -3rem;
  }

  [dir="ltr"] .sm\\:-ms-14{
    margin-left: -3.5rem;
  }

  [dir="rtl"] .sm\\:-ms-14{
    margin-right: -3.5rem;
  }

  [dir="ltr"] .sm\\:-me-14{
    margin-right: -3.5rem;
  }

  [dir="rtl"] .sm\\:-me-14{
    margin-left: -3.5rem;
  }

  [dir="ltr"] .sm\\:-ms-15{
    margin-left: -3.75rem;
  }

  [dir="rtl"] .sm\\:-ms-15{
    margin-right: -3.75rem;
  }

  [dir="ltr"] .sm\\:-me-15{
    margin-right: -3.75rem;
  }

  [dir="rtl"] .sm\\:-me-15{
    margin-left: -3.75rem;
  }

  [dir="ltr"] .sm\\:-ms-16{
    margin-left: -4rem;
  }

  [dir="rtl"] .sm\\:-ms-16{
    margin-right: -4rem;
  }

  [dir="ltr"] .sm\\:-me-16{
    margin-right: -4rem;
  }

  [dir="rtl"] .sm\\:-me-16{
    margin-left: -4rem;
  }

  [dir="ltr"] .sm\\:-ms-18{
    margin-left: -4.5rem;
  }

  [dir="rtl"] .sm\\:-ms-18{
    margin-right: -4.5rem;
  }

  [dir="ltr"] .sm\\:-me-18{
    margin-right: -4.5rem;
  }

  [dir="rtl"] .sm\\:-me-18{
    margin-left: -4.5rem;
  }

  [dir="ltr"] .sm\\:-ms-20{
    margin-left: -5rem;
  }

  [dir="rtl"] .sm\\:-ms-20{
    margin-right: -5rem;
  }

  [dir="ltr"] .sm\\:-me-20{
    margin-right: -5rem;
  }

  [dir="rtl"] .sm\\:-me-20{
    margin-left: -5rem;
  }

  [dir="ltr"] .sm\\:-ms-22{
    margin-left: -5.5rem;
  }

  [dir="rtl"] .sm\\:-ms-22{
    margin-right: -5.5rem;
  }

  [dir="ltr"] .sm\\:-me-22{
    margin-right: -5.5rem;
  }

  [dir="rtl"] .sm\\:-me-22{
    margin-left: -5.5rem;
  }

  [dir="ltr"] .sm\\:-ms-23{
    margin-left: -5.75rem;
  }

  [dir="rtl"] .sm\\:-ms-23{
    margin-right: -5.75rem;
  }

  [dir="ltr"] .sm\\:-me-23{
    margin-right: -5.75rem;
  }

  [dir="rtl"] .sm\\:-me-23{
    margin-left: -5.75rem;
  }

  [dir="ltr"] .sm\\:-ms-24{
    margin-left: -6rem;
  }

  [dir="rtl"] .sm\\:-ms-24{
    margin-right: -6rem;
  }

  [dir="ltr"] .sm\\:-me-24{
    margin-right: -6rem;
  }

  [dir="rtl"] .sm\\:-me-24{
    margin-left: -6rem;
  }

  [dir="ltr"] .sm\\:-ms-25{
    margin-left: -6.25rem;
  }

  [dir="rtl"] .sm\\:-ms-25{
    margin-right: -6.25rem;
  }

  [dir="ltr"] .sm\\:-me-25{
    margin-right: -6.25rem;
  }

  [dir="rtl"] .sm\\:-me-25{
    margin-left: -6.25rem;
  }

  [dir="ltr"] .sm\\:-ms-26{
    margin-left: -6.5rem;
  }

  [dir="rtl"] .sm\\:-ms-26{
    margin-right: -6.5rem;
  }

  [dir="ltr"] .sm\\:-me-26{
    margin-right: -6.5rem;
  }

  [dir="rtl"] .sm\\:-me-26{
    margin-left: -6.5rem;
  }

  [dir="ltr"] .sm\\:-ms-28{
    margin-left: -7rem;
  }

  [dir="rtl"] .sm\\:-ms-28{
    margin-right: -7rem;
  }

  [dir="ltr"] .sm\\:-me-28{
    margin-right: -7rem;
  }

  [dir="rtl"] .sm\\:-me-28{
    margin-left: -7rem;
  }

  [dir="ltr"] .sm\\:-ms-30{
    margin-left: -7.5rem;
  }

  [dir="rtl"] .sm\\:-ms-30{
    margin-right: -7.5rem;
  }

  [dir="ltr"] .sm\\:-me-30{
    margin-right: -7.5rem;
  }

  [dir="rtl"] .sm\\:-me-30{
    margin-left: -7.5rem;
  }

  [dir="ltr"] .sm\\:-ms-32{
    margin-left: -8rem;
  }

  [dir="rtl"] .sm\\:-ms-32{
    margin-right: -8rem;
  }

  [dir="ltr"] .sm\\:-me-32{
    margin-right: -8rem;
  }

  [dir="rtl"] .sm\\:-me-32{
    margin-left: -8rem;
  }

  [dir="ltr"] .sm\\:-ms-34{
    margin-left: -8.5rem;
  }

  [dir="rtl"] .sm\\:-ms-34{
    margin-right: -8.5rem;
  }

  [dir="ltr"] .sm\\:-me-34{
    margin-right: -8.5rem;
  }

  [dir="rtl"] .sm\\:-me-34{
    margin-left: -8.5rem;
  }

  [dir="ltr"] .sm\\:-ms-40{
    margin-left: -10rem;
  }

  [dir="rtl"] .sm\\:-ms-40{
    margin-right: -10rem;
  }

  [dir="ltr"] .sm\\:-me-40{
    margin-right: -10rem;
  }

  [dir="rtl"] .sm\\:-me-40{
    margin-left: -10rem;
  }

  [dir="ltr"] .sm\\:-ms-42{
    margin-left: -10.5rem;
  }

  [dir="rtl"] .sm\\:-ms-42{
    margin-right: -10.5rem;
  }

  [dir="ltr"] .sm\\:-me-42{
    margin-right: -10.5rem;
  }

  [dir="rtl"] .sm\\:-me-42{
    margin-left: -10.5rem;
  }

  [dir="ltr"] .sm\\:-ms-44{
    margin-left: -11rem;
  }

  [dir="rtl"] .sm\\:-ms-44{
    margin-right: -11rem;
  }

  [dir="ltr"] .sm\\:-me-44{
    margin-right: -11rem;
  }

  [dir="rtl"] .sm\\:-me-44{
    margin-left: -11rem;
  }

  [dir="ltr"] .sm\\:-ms-48{
    margin-left: -12rem;
  }

  [dir="rtl"] .sm\\:-ms-48{
    margin-right: -12rem;
  }

  [dir="ltr"] .sm\\:-me-48{
    margin-right: -12rem;
  }

  [dir="rtl"] .sm\\:-me-48{
    margin-left: -12rem;
  }

  [dir="ltr"] .sm\\:-ms-52{
    margin-left: -13rem;
  }

  [dir="rtl"] .sm\\:-ms-52{
    margin-right: -13rem;
  }

  [dir="ltr"] .sm\\:-me-52{
    margin-right: -13rem;
  }

  [dir="rtl"] .sm\\:-me-52{
    margin-left: -13rem;
  }

  [dir="ltr"] .sm\\:-ms-54{
    margin-left: -13.5rem;
  }

  [dir="rtl"] .sm\\:-ms-54{
    margin-right: -13.5rem;
  }

  [dir="ltr"] .sm\\:-me-54{
    margin-right: -13.5rem;
  }

  [dir="rtl"] .sm\\:-me-54{
    margin-left: -13.5rem;
  }

  [dir="ltr"] .sm\\:-ms-56{
    margin-left: -14rem;
  }

  [dir="rtl"] .sm\\:-ms-56{
    margin-right: -14rem;
  }

  [dir="ltr"] .sm\\:-me-56{
    margin-right: -14rem;
  }

  [dir="rtl"] .sm\\:-me-56{
    margin-left: -14rem;
  }

  [dir="ltr"] .sm\\:-ms-60{
    margin-left: -15rem;
  }

  [dir="rtl"] .sm\\:-ms-60{
    margin-right: -15rem;
  }

  [dir="ltr"] .sm\\:-me-60{
    margin-right: -15rem;
  }

  [dir="rtl"] .sm\\:-me-60{
    margin-left: -15rem;
  }

  [dir="ltr"] .sm\\:-ms-64{
    margin-left: -16rem;
  }

  [dir="rtl"] .sm\\:-ms-64{
    margin-right: -16rem;
  }

  [dir="ltr"] .sm\\:-me-64{
    margin-right: -16rem;
  }

  [dir="rtl"] .sm\\:-me-64{
    margin-left: -16rem;
  }

  [dir="ltr"] .sm\\:-ms-68{
    margin-left: -17rem;
  }

  [dir="rtl"] .sm\\:-ms-68{
    margin-right: -17rem;
  }

  [dir="ltr"] .sm\\:-me-68{
    margin-right: -17rem;
  }

  [dir="rtl"] .sm\\:-me-68{
    margin-left: -17rem;
  }

  [dir="ltr"] .sm\\:-ms-72{
    margin-left: -18rem;
  }

  [dir="rtl"] .sm\\:-ms-72{
    margin-right: -18rem;
  }

  [dir="ltr"] .sm\\:-me-72{
    margin-right: -18rem;
  }

  [dir="rtl"] .sm\\:-me-72{
    margin-left: -18rem;
  }

  [dir="ltr"] .sm\\:-ms-74{
    margin-left: -18.5rem;
  }

  [dir="rtl"] .sm\\:-ms-74{
    margin-right: -18.5rem;
  }

  [dir="ltr"] .sm\\:-me-74{
    margin-right: -18.5rem;
  }

  [dir="rtl"] .sm\\:-me-74{
    margin-left: -18.5rem;
  }

  [dir="ltr"] .sm\\:-ms-76{
    margin-left: -19rem;
  }

  [dir="rtl"] .sm\\:-ms-76{
    margin-right: -19rem;
  }

  [dir="ltr"] .sm\\:-me-76{
    margin-right: -19rem;
  }

  [dir="rtl"] .sm\\:-me-76{
    margin-left: -19rem;
  }

  [dir="ltr"] .sm\\:-ms-78{
    margin-left: -19.5rem;
  }

  [dir="rtl"] .sm\\:-ms-78{
    margin-right: -19.5rem;
  }

  [dir="ltr"] .sm\\:-me-78{
    margin-right: -19.5rem;
  }

  [dir="rtl"] .sm\\:-me-78{
    margin-left: -19.5rem;
  }

  [dir="ltr"] .sm\\:-ms-80{
    margin-left: -20rem;
  }

  [dir="rtl"] .sm\\:-ms-80{
    margin-right: -20rem;
  }

  [dir="ltr"] .sm\\:-me-80{
    margin-right: -20rem;
  }

  [dir="rtl"] .sm\\:-me-80{
    margin-left: -20rem;
  }

  [dir="ltr"] .sm\\:-ms-82{
    margin-left: -20.5rem;
  }

  [dir="rtl"] .sm\\:-ms-82{
    margin-right: -20.5rem;
  }

  [dir="ltr"] .sm\\:-me-82{
    margin-right: -20.5rem;
  }

  [dir="rtl"] .sm\\:-me-82{
    margin-left: -20.5rem;
  }

  [dir="ltr"] .sm\\:-ms-84{
    margin-left: -21rem;
  }

  [dir="rtl"] .sm\\:-ms-84{
    margin-right: -21rem;
  }

  [dir="ltr"] .sm\\:-me-84{
    margin-right: -21rem;
  }

  [dir="rtl"] .sm\\:-me-84{
    margin-left: -21rem;
  }

  [dir="ltr"] .sm\\:-ms-88{
    margin-left: -22rem;
  }

  [dir="rtl"] .sm\\:-ms-88{
    margin-right: -22rem;
  }

  [dir="ltr"] .sm\\:-me-88{
    margin-right: -22rem;
  }

  [dir="rtl"] .sm\\:-me-88{
    margin-left: -22rem;
  }

  [dir="ltr"] .sm\\:-ms-92{
    margin-left: -23rem;
  }

  [dir="rtl"] .sm\\:-ms-92{
    margin-right: -23rem;
  }

  [dir="ltr"] .sm\\:-me-92{
    margin-right: -23rem;
  }

  [dir="rtl"] .sm\\:-me-92{
    margin-left: -23rem;
  }

  [dir="ltr"] .sm\\:-ms-96{
    margin-left: -24rem;
  }

  [dir="rtl"] .sm\\:-ms-96{
    margin-right: -24rem;
  }

  [dir="ltr"] .sm\\:-me-96{
    margin-right: -24rem;
  }

  [dir="rtl"] .sm\\:-me-96{
    margin-left: -24rem;
  }

  [dir="ltr"] .sm\\:-ms-98{
    margin-left: -24.5rem;
  }

  [dir="rtl"] .sm\\:-ms-98{
    margin-right: -24.5rem;
  }

  [dir="ltr"] .sm\\:-me-98{
    margin-right: -24.5rem;
  }

  [dir="rtl"] .sm\\:-me-98{
    margin-left: -24.5rem;
  }

  [dir="ltr"] .sm\\:-ms-100{
    margin-left: -25rem;
  }

  [dir="rtl"] .sm\\:-ms-100{
    margin-right: -25rem;
  }

  [dir="ltr"] .sm\\:-me-100{
    margin-right: -25rem;
  }

  [dir="rtl"] .sm\\:-me-100{
    margin-left: -25rem;
  }

  [dir="ltr"] .sm\\:-ms-104{
    margin-left: -26rem;
  }

  [dir="rtl"] .sm\\:-ms-104{
    margin-right: -26rem;
  }

  [dir="ltr"] .sm\\:-me-104{
    margin-right: -26rem;
  }

  [dir="rtl"] .sm\\:-me-104{
    margin-left: -26rem;
  }

  [dir="ltr"] .sm\\:-ms-112{
    margin-left: -28rem;
  }

  [dir="rtl"] .sm\\:-ms-112{
    margin-right: -28rem;
  }

  [dir="ltr"] .sm\\:-me-112{
    margin-right: -28rem;
  }

  [dir="rtl"] .sm\\:-me-112{
    margin-left: -28rem;
  }

  [dir="ltr"] .sm\\:-ms-124{
    margin-left: -31rem;
  }

  [dir="rtl"] .sm\\:-ms-124{
    margin-right: -31rem;
  }

  [dir="ltr"] .sm\\:-me-124{
    margin-right: -31rem;
  }

  [dir="rtl"] .sm\\:-me-124{
    margin-left: -31rem;
  }

  [dir="ltr"] .sm\\:-ms-128{
    margin-left: -32rem;
  }

  [dir="rtl"] .sm\\:-ms-128{
    margin-right: -32rem;
  }

  [dir="ltr"] .sm\\:-me-128{
    margin-right: -32rem;
  }

  [dir="rtl"] .sm\\:-me-128{
    margin-left: -32rem;
  }

  [dir="ltr"] .sm\\:-ms-140{
    margin-left: -35rem;
  }

  [dir="rtl"] .sm\\:-ms-140{
    margin-right: -35rem;
  }

  [dir="ltr"] .sm\\:-me-140{
    margin-right: -35rem;
  }

  [dir="rtl"] .sm\\:-me-140{
    margin-left: -35rem;
  }

  [dir="ltr"] .sm\\:-ms-152{
    margin-left: -38rem;
  }

  [dir="rtl"] .sm\\:-ms-152{
    margin-right: -38rem;
  }

  [dir="ltr"] .sm\\:-me-152{
    margin-right: -38rem;
  }

  [dir="rtl"] .sm\\:-me-152{
    margin-left: -38rem;
  }

  [dir="ltr"] .sm\\:-ms-160{
    margin-left: -40rem;
  }

  [dir="rtl"] .sm\\:-ms-160{
    margin-right: -40rem;
  }

  [dir="ltr"] .sm\\:-me-160{
    margin-right: -40rem;
  }

  [dir="rtl"] .sm\\:-me-160{
    margin-left: -40rem;
  }

  [dir="ltr"] .sm\\:-ms-162{
    margin-left: -41rem;
  }

  [dir="rtl"] .sm\\:-ms-162{
    margin-right: -41rem;
  }

  [dir="ltr"] .sm\\:-me-162{
    margin-right: -41rem;
  }

  [dir="rtl"] .sm\\:-me-162{
    margin-left: -41rem;
  }

  [dir="ltr"] .sm\\:-ms-192{
    margin-left: -48rem;
  }

  [dir="rtl"] .sm\\:-ms-192{
    margin-right: -48rem;
  }

  [dir="ltr"] .sm\\:-me-192{
    margin-right: -48rem;
  }

  [dir="rtl"] .sm\\:-me-192{
    margin-left: -48rem;
  }

  [dir="ltr"] .sm\\:-ms-208{
    margin-left: -52rem;
  }

  [dir="rtl"] .sm\\:-ms-208{
    margin-right: -52rem;
  }

  [dir="ltr"] .sm\\:-me-208{
    margin-right: -52rem;
  }

  [dir="rtl"] .sm\\:-me-208{
    margin-left: -52rem;
  }

  [dir="ltr"] .sm\\:-ms-224{
    margin-left: -56rem;
  }

  [dir="rtl"] .sm\\:-ms-224{
    margin-right: -56rem;
  }

  [dir="ltr"] .sm\\:-me-224{
    margin-right: -56rem;
  }

  [dir="rtl"] .sm\\:-me-224{
    margin-left: -56rem;
  }

  [dir="ltr"] .sm\\:-ms-256{
    margin-left: -64rem;
  }

  [dir="rtl"] .sm\\:-ms-256{
    margin-right: -64rem;
  }

  [dir="ltr"] .sm\\:-me-256{
    margin-right: -64rem;
  }

  [dir="rtl"] .sm\\:-me-256{
    margin-left: -64rem;
  }

  [dir="ltr"] .sm\\:-ms-px{
    margin-left: -1px;
  }

  [dir="rtl"] .sm\\:-ms-px{
    margin-right: -1px;
  }

  [dir="ltr"] .sm\\:-me-px{
    margin-right: -1px;
  }

  [dir="rtl"] .sm\\:-me-px{
    margin-left: -1px;
  }

  [dir="ltr"] .sm\\:first\\:ms-0:first-child{
    margin-left: 0;
  }

  [dir="rtl"] .sm\\:first\\:ms-0:first-child{
    margin-right: 0;
  }

  [dir="ltr"] .sm\\:first\\:me-0:first-child{
    margin-right: 0;
  }

  [dir="rtl"] .sm\\:first\\:me-0:first-child{
    margin-left: 0;
  }

  [dir="ltr"] .sm\\:first\\:ms-1:first-child{
    margin-left: 0.25rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-1:first-child{
    margin-right: 0.25rem;
  }

  [dir="ltr"] .sm\\:first\\:me-1:first-child{
    margin-right: 0.25rem;
  }

  [dir="rtl"] .sm\\:first\\:me-1:first-child{
    margin-left: 0.25rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-2:first-child{
    margin-left: 0.5rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-2:first-child{
    margin-right: 0.5rem;
  }

  [dir="ltr"] .sm\\:first\\:me-2:first-child{
    margin-right: 0.5rem;
  }

  [dir="rtl"] .sm\\:first\\:me-2:first-child{
    margin-left: 0.5rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-3:first-child{
    margin-left: 0.75rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-3:first-child{
    margin-right: 0.75rem;
  }

  [dir="ltr"] .sm\\:first\\:me-3:first-child{
    margin-right: 0.75rem;
  }

  [dir="rtl"] .sm\\:first\\:me-3:first-child{
    margin-left: 0.75rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-4:first-child{
    margin-left: 1rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-4:first-child{
    margin-right: 1rem;
  }

  [dir="ltr"] .sm\\:first\\:me-4:first-child{
    margin-right: 1rem;
  }

  [dir="rtl"] .sm\\:first\\:me-4:first-child{
    margin-left: 1rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-5:first-child{
    margin-left: 1.25rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-5:first-child{
    margin-right: 1.25rem;
  }

  [dir="ltr"] .sm\\:first\\:me-5:first-child{
    margin-right: 1.25rem;
  }

  [dir="rtl"] .sm\\:first\\:me-5:first-child{
    margin-left: 1.25rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-6:first-child{
    margin-left: 1.5rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-6:first-child{
    margin-right: 1.5rem;
  }

  [dir="ltr"] .sm\\:first\\:me-6:first-child{
    margin-right: 1.5rem;
  }

  [dir="rtl"] .sm\\:first\\:me-6:first-child{
    margin-left: 1.5rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-7:first-child{
    margin-left: 1.75rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-7:first-child{
    margin-right: 1.75rem;
  }

  [dir="ltr"] .sm\\:first\\:me-7:first-child{
    margin-right: 1.75rem;
  }

  [dir="rtl"] .sm\\:first\\:me-7:first-child{
    margin-left: 1.75rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-8:first-child{
    margin-left: 2rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-8:first-child{
    margin-right: 2rem;
  }

  [dir="ltr"] .sm\\:first\\:me-8:first-child{
    margin-right: 2rem;
  }

  [dir="rtl"] .sm\\:first\\:me-8:first-child{
    margin-left: 2rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-9:first-child{
    margin-left: 2.25rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-9:first-child{
    margin-right: 2.25rem;
  }

  [dir="ltr"] .sm\\:first\\:me-9:first-child{
    margin-right: 2.25rem;
  }

  [dir="rtl"] .sm\\:first\\:me-9:first-child{
    margin-left: 2.25rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-10:first-child{
    margin-left: 2.5rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-10:first-child{
    margin-right: 2.5rem;
  }

  [dir="ltr"] .sm\\:first\\:me-10:first-child{
    margin-right: 2.5rem;
  }

  [dir="rtl"] .sm\\:first\\:me-10:first-child{
    margin-left: 2.5rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-11:first-child{
    margin-left: 2.75rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-11:first-child{
    margin-right: 2.75rem;
  }

  [dir="ltr"] .sm\\:first\\:me-11:first-child{
    margin-right: 2.75rem;
  }

  [dir="rtl"] .sm\\:first\\:me-11:first-child{
    margin-left: 2.75rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-12:first-child{
    margin-left: 3rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-12:first-child{
    margin-right: 3rem;
  }

  [dir="ltr"] .sm\\:first\\:me-12:first-child{
    margin-right: 3rem;
  }

  [dir="rtl"] .sm\\:first\\:me-12:first-child{
    margin-left: 3rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-14:first-child{
    margin-left: 3.5rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-14:first-child{
    margin-right: 3.5rem;
  }

  [dir="ltr"] .sm\\:first\\:me-14:first-child{
    margin-right: 3.5rem;
  }

  [dir="rtl"] .sm\\:first\\:me-14:first-child{
    margin-left: 3.5rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-15:first-child{
    margin-left: 3.75rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-15:first-child{
    margin-right: 3.75rem;
  }

  [dir="ltr"] .sm\\:first\\:me-15:first-child{
    margin-right: 3.75rem;
  }

  [dir="rtl"] .sm\\:first\\:me-15:first-child{
    margin-left: 3.75rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-16:first-child{
    margin-left: 4rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-16:first-child{
    margin-right: 4rem;
  }

  [dir="ltr"] .sm\\:first\\:me-16:first-child{
    margin-right: 4rem;
  }

  [dir="rtl"] .sm\\:first\\:me-16:first-child{
    margin-left: 4rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-18:first-child{
    margin-left: 4.5rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-18:first-child{
    margin-right: 4.5rem;
  }

  [dir="ltr"] .sm\\:first\\:me-18:first-child{
    margin-right: 4.5rem;
  }

  [dir="rtl"] .sm\\:first\\:me-18:first-child{
    margin-left: 4.5rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-20:first-child{
    margin-left: 5rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-20:first-child{
    margin-right: 5rem;
  }

  [dir="ltr"] .sm\\:first\\:me-20:first-child{
    margin-right: 5rem;
  }

  [dir="rtl"] .sm\\:first\\:me-20:first-child{
    margin-left: 5rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-22:first-child{
    margin-left: 5.5rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-22:first-child{
    margin-right: 5.5rem;
  }

  [dir="ltr"] .sm\\:first\\:me-22:first-child{
    margin-right: 5.5rem;
  }

  [dir="rtl"] .sm\\:first\\:me-22:first-child{
    margin-left: 5.5rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-23:first-child{
    margin-left: 5.75rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-23:first-child{
    margin-right: 5.75rem;
  }

  [dir="ltr"] .sm\\:first\\:me-23:first-child{
    margin-right: 5.75rem;
  }

  [dir="rtl"] .sm\\:first\\:me-23:first-child{
    margin-left: 5.75rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-24:first-child{
    margin-left: 6rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-24:first-child{
    margin-right: 6rem;
  }

  [dir="ltr"] .sm\\:first\\:me-24:first-child{
    margin-right: 6rem;
  }

  [dir="rtl"] .sm\\:first\\:me-24:first-child{
    margin-left: 6rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-25:first-child{
    margin-left: 6.25rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-25:first-child{
    margin-right: 6.25rem;
  }

  [dir="ltr"] .sm\\:first\\:me-25:first-child{
    margin-right: 6.25rem;
  }

  [dir="rtl"] .sm\\:first\\:me-25:first-child{
    margin-left: 6.25rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-26:first-child{
    margin-left: 6.5rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-26:first-child{
    margin-right: 6.5rem;
  }

  [dir="ltr"] .sm\\:first\\:me-26:first-child{
    margin-right: 6.5rem;
  }

  [dir="rtl"] .sm\\:first\\:me-26:first-child{
    margin-left: 6.5rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-28:first-child{
    margin-left: 7rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-28:first-child{
    margin-right: 7rem;
  }

  [dir="ltr"] .sm\\:first\\:me-28:first-child{
    margin-right: 7rem;
  }

  [dir="rtl"] .sm\\:first\\:me-28:first-child{
    margin-left: 7rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-30:first-child{
    margin-left: 7.5rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-30:first-child{
    margin-right: 7.5rem;
  }

  [dir="ltr"] .sm\\:first\\:me-30:first-child{
    margin-right: 7.5rem;
  }

  [dir="rtl"] .sm\\:first\\:me-30:first-child{
    margin-left: 7.5rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-32:first-child{
    margin-left: 8rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-32:first-child{
    margin-right: 8rem;
  }

  [dir="ltr"] .sm\\:first\\:me-32:first-child{
    margin-right: 8rem;
  }

  [dir="rtl"] .sm\\:first\\:me-32:first-child{
    margin-left: 8rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-34:first-child{
    margin-left: 8.5rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-34:first-child{
    margin-right: 8.5rem;
  }

  [dir="ltr"] .sm\\:first\\:me-34:first-child{
    margin-right: 8.5rem;
  }

  [dir="rtl"] .sm\\:first\\:me-34:first-child{
    margin-left: 8.5rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-40:first-child{
    margin-left: 10rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-40:first-child{
    margin-right: 10rem;
  }

  [dir="ltr"] .sm\\:first\\:me-40:first-child{
    margin-right: 10rem;
  }

  [dir="rtl"] .sm\\:first\\:me-40:first-child{
    margin-left: 10rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-42:first-child{
    margin-left: 10.5rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-42:first-child{
    margin-right: 10.5rem;
  }

  [dir="ltr"] .sm\\:first\\:me-42:first-child{
    margin-right: 10.5rem;
  }

  [dir="rtl"] .sm\\:first\\:me-42:first-child{
    margin-left: 10.5rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-44:first-child{
    margin-left: 11rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-44:first-child{
    margin-right: 11rem;
  }

  [dir="ltr"] .sm\\:first\\:me-44:first-child{
    margin-right: 11rem;
  }

  [dir="rtl"] .sm\\:first\\:me-44:first-child{
    margin-left: 11rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-48:first-child{
    margin-left: 12rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-48:first-child{
    margin-right: 12rem;
  }

  [dir="ltr"] .sm\\:first\\:me-48:first-child{
    margin-right: 12rem;
  }

  [dir="rtl"] .sm\\:first\\:me-48:first-child{
    margin-left: 12rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-52:first-child{
    margin-left: 13rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-52:first-child{
    margin-right: 13rem;
  }

  [dir="ltr"] .sm\\:first\\:me-52:first-child{
    margin-right: 13rem;
  }

  [dir="rtl"] .sm\\:first\\:me-52:first-child{
    margin-left: 13rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-54:first-child{
    margin-left: 13.5rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-54:first-child{
    margin-right: 13.5rem;
  }

  [dir="ltr"] .sm\\:first\\:me-54:first-child{
    margin-right: 13.5rem;
  }

  [dir="rtl"] .sm\\:first\\:me-54:first-child{
    margin-left: 13.5rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-56:first-child{
    margin-left: 14rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-56:first-child{
    margin-right: 14rem;
  }

  [dir="ltr"] .sm\\:first\\:me-56:first-child{
    margin-right: 14rem;
  }

  [dir="rtl"] .sm\\:first\\:me-56:first-child{
    margin-left: 14rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-60:first-child{
    margin-left: 15rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-60:first-child{
    margin-right: 15rem;
  }

  [dir="ltr"] .sm\\:first\\:me-60:first-child{
    margin-right: 15rem;
  }

  [dir="rtl"] .sm\\:first\\:me-60:first-child{
    margin-left: 15rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-64:first-child{
    margin-left: 16rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-64:first-child{
    margin-right: 16rem;
  }

  [dir="ltr"] .sm\\:first\\:me-64:first-child{
    margin-right: 16rem;
  }

  [dir="rtl"] .sm\\:first\\:me-64:first-child{
    margin-left: 16rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-68:first-child{
    margin-left: 17rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-68:first-child{
    margin-right: 17rem;
  }

  [dir="ltr"] .sm\\:first\\:me-68:first-child{
    margin-right: 17rem;
  }

  [dir="rtl"] .sm\\:first\\:me-68:first-child{
    margin-left: 17rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-72:first-child{
    margin-left: 18rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-72:first-child{
    margin-right: 18rem;
  }

  [dir="ltr"] .sm\\:first\\:me-72:first-child{
    margin-right: 18rem;
  }

  [dir="rtl"] .sm\\:first\\:me-72:first-child{
    margin-left: 18rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-74:first-child{
    margin-left: 18.5rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-74:first-child{
    margin-right: 18.5rem;
  }

  [dir="ltr"] .sm\\:first\\:me-74:first-child{
    margin-right: 18.5rem;
  }

  [dir="rtl"] .sm\\:first\\:me-74:first-child{
    margin-left: 18.5rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-76:first-child{
    margin-left: 19rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-76:first-child{
    margin-right: 19rem;
  }

  [dir="ltr"] .sm\\:first\\:me-76:first-child{
    margin-right: 19rem;
  }

  [dir="rtl"] .sm\\:first\\:me-76:first-child{
    margin-left: 19rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-78:first-child{
    margin-left: 19.5rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-78:first-child{
    margin-right: 19.5rem;
  }

  [dir="ltr"] .sm\\:first\\:me-78:first-child{
    margin-right: 19.5rem;
  }

  [dir="rtl"] .sm\\:first\\:me-78:first-child{
    margin-left: 19.5rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-80:first-child{
    margin-left: 20rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-80:first-child{
    margin-right: 20rem;
  }

  [dir="ltr"] .sm\\:first\\:me-80:first-child{
    margin-right: 20rem;
  }

  [dir="rtl"] .sm\\:first\\:me-80:first-child{
    margin-left: 20rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-82:first-child{
    margin-left: 20.5rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-82:first-child{
    margin-right: 20.5rem;
  }

  [dir="ltr"] .sm\\:first\\:me-82:first-child{
    margin-right: 20.5rem;
  }

  [dir="rtl"] .sm\\:first\\:me-82:first-child{
    margin-left: 20.5rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-84:first-child{
    margin-left: 21rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-84:first-child{
    margin-right: 21rem;
  }

  [dir="ltr"] .sm\\:first\\:me-84:first-child{
    margin-right: 21rem;
  }

  [dir="rtl"] .sm\\:first\\:me-84:first-child{
    margin-left: 21rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-88:first-child{
    margin-left: 22rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-88:first-child{
    margin-right: 22rem;
  }

  [dir="ltr"] .sm\\:first\\:me-88:first-child{
    margin-right: 22rem;
  }

  [dir="rtl"] .sm\\:first\\:me-88:first-child{
    margin-left: 22rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-92:first-child{
    margin-left: 23rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-92:first-child{
    margin-right: 23rem;
  }

  [dir="ltr"] .sm\\:first\\:me-92:first-child{
    margin-right: 23rem;
  }

  [dir="rtl"] .sm\\:first\\:me-92:first-child{
    margin-left: 23rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-96:first-child{
    margin-left: 24rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-96:first-child{
    margin-right: 24rem;
  }

  [dir="ltr"] .sm\\:first\\:me-96:first-child{
    margin-right: 24rem;
  }

  [dir="rtl"] .sm\\:first\\:me-96:first-child{
    margin-left: 24rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-98:first-child{
    margin-left: 24.5rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-98:first-child{
    margin-right: 24.5rem;
  }

  [dir="ltr"] .sm\\:first\\:me-98:first-child{
    margin-right: 24.5rem;
  }

  [dir="rtl"] .sm\\:first\\:me-98:first-child{
    margin-left: 24.5rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-100:first-child{
    margin-left: 25rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-100:first-child{
    margin-right: 25rem;
  }

  [dir="ltr"] .sm\\:first\\:me-100:first-child{
    margin-right: 25rem;
  }

  [dir="rtl"] .sm\\:first\\:me-100:first-child{
    margin-left: 25rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-104:first-child{
    margin-left: 26rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-104:first-child{
    margin-right: 26rem;
  }

  [dir="ltr"] .sm\\:first\\:me-104:first-child{
    margin-right: 26rem;
  }

  [dir="rtl"] .sm\\:first\\:me-104:first-child{
    margin-left: 26rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-112:first-child{
    margin-left: 28rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-112:first-child{
    margin-right: 28rem;
  }

  [dir="ltr"] .sm\\:first\\:me-112:first-child{
    margin-right: 28rem;
  }

  [dir="rtl"] .sm\\:first\\:me-112:first-child{
    margin-left: 28rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-124:first-child{
    margin-left: 31rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-124:first-child{
    margin-right: 31rem;
  }

  [dir="ltr"] .sm\\:first\\:me-124:first-child{
    margin-right: 31rem;
  }

  [dir="rtl"] .sm\\:first\\:me-124:first-child{
    margin-left: 31rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-128:first-child{
    margin-left: 32rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-128:first-child{
    margin-right: 32rem;
  }

  [dir="ltr"] .sm\\:first\\:me-128:first-child{
    margin-right: 32rem;
  }

  [dir="rtl"] .sm\\:first\\:me-128:first-child{
    margin-left: 32rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-140:first-child{
    margin-left: 35rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-140:first-child{
    margin-right: 35rem;
  }

  [dir="ltr"] .sm\\:first\\:me-140:first-child{
    margin-right: 35rem;
  }

  [dir="rtl"] .sm\\:first\\:me-140:first-child{
    margin-left: 35rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-152:first-child{
    margin-left: 38rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-152:first-child{
    margin-right: 38rem;
  }

  [dir="ltr"] .sm\\:first\\:me-152:first-child{
    margin-right: 38rem;
  }

  [dir="rtl"] .sm\\:first\\:me-152:first-child{
    margin-left: 38rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-160:first-child{
    margin-left: 40rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-160:first-child{
    margin-right: 40rem;
  }

  [dir="ltr"] .sm\\:first\\:me-160:first-child{
    margin-right: 40rem;
  }

  [dir="rtl"] .sm\\:first\\:me-160:first-child{
    margin-left: 40rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-162:first-child{
    margin-left: 41rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-162:first-child{
    margin-right: 41rem;
  }

  [dir="ltr"] .sm\\:first\\:me-162:first-child{
    margin-right: 41rem;
  }

  [dir="rtl"] .sm\\:first\\:me-162:first-child{
    margin-left: 41rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-192:first-child{
    margin-left: 48rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-192:first-child{
    margin-right: 48rem;
  }

  [dir="ltr"] .sm\\:first\\:me-192:first-child{
    margin-right: 48rem;
  }

  [dir="rtl"] .sm\\:first\\:me-192:first-child{
    margin-left: 48rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-208:first-child{
    margin-left: 52rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-208:first-child{
    margin-right: 52rem;
  }

  [dir="ltr"] .sm\\:first\\:me-208:first-child{
    margin-right: 52rem;
  }

  [dir="rtl"] .sm\\:first\\:me-208:first-child{
    margin-left: 52rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-224:first-child{
    margin-left: 56rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-224:first-child{
    margin-right: 56rem;
  }

  [dir="ltr"] .sm\\:first\\:me-224:first-child{
    margin-right: 56rem;
  }

  [dir="rtl"] .sm\\:first\\:me-224:first-child{
    margin-left: 56rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-256:first-child{
    margin-left: 64rem;
  }

  [dir="rtl"] .sm\\:first\\:ms-256:first-child{
    margin-right: 64rem;
  }

  [dir="ltr"] .sm\\:first\\:me-256:first-child{
    margin-right: 64rem;
  }

  [dir="rtl"] .sm\\:first\\:me-256:first-child{
    margin-left: 64rem;
  }

  [dir="ltr"] .sm\\:first\\:ms-auto:first-child{
    margin-left: auto;
  }

  [dir="rtl"] .sm\\:first\\:ms-auto:first-child{
    margin-right: auto;
  }

  [dir="ltr"] .sm\\:first\\:me-auto:first-child{
    margin-right: auto;
  }

  [dir="rtl"] .sm\\:first\\:me-auto:first-child{
    margin-left: auto;
  }

  [dir="ltr"] .sm\\:first\\:ms-px:first-child{
    margin-left: 1px;
  }

  [dir="rtl"] .sm\\:first\\:ms-px:first-child{
    margin-right: 1px;
  }

  [dir="ltr"] .sm\\:first\\:me-px:first-child{
    margin-right: 1px;
  }

  [dir="rtl"] .sm\\:first\\:me-px:first-child{
    margin-left: 1px;
  }

  [dir="ltr"] .sm\\:first\\:-ms-1:first-child{
    margin-left: -0.25rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-1:first-child{
    margin-right: -0.25rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-1:first-child{
    margin-right: -0.25rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-1:first-child{
    margin-left: -0.25rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-2:first-child{
    margin-left: -0.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-2:first-child{
    margin-right: -0.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-2:first-child{
    margin-right: -0.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-2:first-child{
    margin-left: -0.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-3:first-child{
    margin-left: -0.75rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-3:first-child{
    margin-right: -0.75rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-3:first-child{
    margin-right: -0.75rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-3:first-child{
    margin-left: -0.75rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-4:first-child{
    margin-left: -1rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-4:first-child{
    margin-right: -1rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-4:first-child{
    margin-right: -1rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-4:first-child{
    margin-left: -1rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-5:first-child{
    margin-left: -1.25rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-5:first-child{
    margin-right: -1.25rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-5:first-child{
    margin-right: -1.25rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-5:first-child{
    margin-left: -1.25rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-6:first-child{
    margin-left: -1.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-6:first-child{
    margin-right: -1.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-6:first-child{
    margin-right: -1.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-6:first-child{
    margin-left: -1.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-7:first-child{
    margin-left: -1.75rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-7:first-child{
    margin-right: -1.75rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-7:first-child{
    margin-right: -1.75rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-7:first-child{
    margin-left: -1.75rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-8:first-child{
    margin-left: -2rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-8:first-child{
    margin-right: -2rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-8:first-child{
    margin-right: -2rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-8:first-child{
    margin-left: -2rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-9:first-child{
    margin-left: -2.25rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-9:first-child{
    margin-right: -2.25rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-9:first-child{
    margin-right: -2.25rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-9:first-child{
    margin-left: -2.25rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-10:first-child{
    margin-left: -2.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-10:first-child{
    margin-right: -2.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-10:first-child{
    margin-right: -2.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-10:first-child{
    margin-left: -2.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-11:first-child{
    margin-left: -2.75rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-11:first-child{
    margin-right: -2.75rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-11:first-child{
    margin-right: -2.75rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-11:first-child{
    margin-left: -2.75rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-12:first-child{
    margin-left: -3rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-12:first-child{
    margin-right: -3rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-12:first-child{
    margin-right: -3rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-12:first-child{
    margin-left: -3rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-14:first-child{
    margin-left: -3.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-14:first-child{
    margin-right: -3.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-14:first-child{
    margin-right: -3.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-14:first-child{
    margin-left: -3.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-15:first-child{
    margin-left: -3.75rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-15:first-child{
    margin-right: -3.75rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-15:first-child{
    margin-right: -3.75rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-15:first-child{
    margin-left: -3.75rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-16:first-child{
    margin-left: -4rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-16:first-child{
    margin-right: -4rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-16:first-child{
    margin-right: -4rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-16:first-child{
    margin-left: -4rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-18:first-child{
    margin-left: -4.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-18:first-child{
    margin-right: -4.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-18:first-child{
    margin-right: -4.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-18:first-child{
    margin-left: -4.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-20:first-child{
    margin-left: -5rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-20:first-child{
    margin-right: -5rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-20:first-child{
    margin-right: -5rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-20:first-child{
    margin-left: -5rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-22:first-child{
    margin-left: -5.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-22:first-child{
    margin-right: -5.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-22:first-child{
    margin-right: -5.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-22:first-child{
    margin-left: -5.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-23:first-child{
    margin-left: -5.75rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-23:first-child{
    margin-right: -5.75rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-23:first-child{
    margin-right: -5.75rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-23:first-child{
    margin-left: -5.75rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-24:first-child{
    margin-left: -6rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-24:first-child{
    margin-right: -6rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-24:first-child{
    margin-right: -6rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-24:first-child{
    margin-left: -6rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-25:first-child{
    margin-left: -6.25rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-25:first-child{
    margin-right: -6.25rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-25:first-child{
    margin-right: -6.25rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-25:first-child{
    margin-left: -6.25rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-26:first-child{
    margin-left: -6.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-26:first-child{
    margin-right: -6.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-26:first-child{
    margin-right: -6.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-26:first-child{
    margin-left: -6.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-28:first-child{
    margin-left: -7rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-28:first-child{
    margin-right: -7rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-28:first-child{
    margin-right: -7rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-28:first-child{
    margin-left: -7rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-30:first-child{
    margin-left: -7.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-30:first-child{
    margin-right: -7.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-30:first-child{
    margin-right: -7.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-30:first-child{
    margin-left: -7.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-32:first-child{
    margin-left: -8rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-32:first-child{
    margin-right: -8rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-32:first-child{
    margin-right: -8rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-32:first-child{
    margin-left: -8rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-34:first-child{
    margin-left: -8.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-34:first-child{
    margin-right: -8.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-34:first-child{
    margin-right: -8.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-34:first-child{
    margin-left: -8.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-40:first-child{
    margin-left: -10rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-40:first-child{
    margin-right: -10rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-40:first-child{
    margin-right: -10rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-40:first-child{
    margin-left: -10rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-42:first-child{
    margin-left: -10.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-42:first-child{
    margin-right: -10.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-42:first-child{
    margin-right: -10.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-42:first-child{
    margin-left: -10.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-44:first-child{
    margin-left: -11rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-44:first-child{
    margin-right: -11rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-44:first-child{
    margin-right: -11rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-44:first-child{
    margin-left: -11rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-48:first-child{
    margin-left: -12rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-48:first-child{
    margin-right: -12rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-48:first-child{
    margin-right: -12rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-48:first-child{
    margin-left: -12rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-52:first-child{
    margin-left: -13rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-52:first-child{
    margin-right: -13rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-52:first-child{
    margin-right: -13rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-52:first-child{
    margin-left: -13rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-54:first-child{
    margin-left: -13.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-54:first-child{
    margin-right: -13.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-54:first-child{
    margin-right: -13.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-54:first-child{
    margin-left: -13.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-56:first-child{
    margin-left: -14rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-56:first-child{
    margin-right: -14rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-56:first-child{
    margin-right: -14rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-56:first-child{
    margin-left: -14rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-60:first-child{
    margin-left: -15rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-60:first-child{
    margin-right: -15rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-60:first-child{
    margin-right: -15rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-60:first-child{
    margin-left: -15rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-64:first-child{
    margin-left: -16rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-64:first-child{
    margin-right: -16rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-64:first-child{
    margin-right: -16rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-64:first-child{
    margin-left: -16rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-68:first-child{
    margin-left: -17rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-68:first-child{
    margin-right: -17rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-68:first-child{
    margin-right: -17rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-68:first-child{
    margin-left: -17rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-72:first-child{
    margin-left: -18rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-72:first-child{
    margin-right: -18rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-72:first-child{
    margin-right: -18rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-72:first-child{
    margin-left: -18rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-74:first-child{
    margin-left: -18.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-74:first-child{
    margin-right: -18.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-74:first-child{
    margin-right: -18.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-74:first-child{
    margin-left: -18.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-76:first-child{
    margin-left: -19rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-76:first-child{
    margin-right: -19rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-76:first-child{
    margin-right: -19rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-76:first-child{
    margin-left: -19rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-78:first-child{
    margin-left: -19.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-78:first-child{
    margin-right: -19.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-78:first-child{
    margin-right: -19.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-78:first-child{
    margin-left: -19.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-80:first-child{
    margin-left: -20rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-80:first-child{
    margin-right: -20rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-80:first-child{
    margin-right: -20rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-80:first-child{
    margin-left: -20rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-82:first-child{
    margin-left: -20.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-82:first-child{
    margin-right: -20.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-82:first-child{
    margin-right: -20.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-82:first-child{
    margin-left: -20.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-84:first-child{
    margin-left: -21rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-84:first-child{
    margin-right: -21rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-84:first-child{
    margin-right: -21rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-84:first-child{
    margin-left: -21rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-88:first-child{
    margin-left: -22rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-88:first-child{
    margin-right: -22rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-88:first-child{
    margin-right: -22rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-88:first-child{
    margin-left: -22rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-92:first-child{
    margin-left: -23rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-92:first-child{
    margin-right: -23rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-92:first-child{
    margin-right: -23rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-92:first-child{
    margin-left: -23rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-96:first-child{
    margin-left: -24rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-96:first-child{
    margin-right: -24rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-96:first-child{
    margin-right: -24rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-96:first-child{
    margin-left: -24rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-98:first-child{
    margin-left: -24.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-98:first-child{
    margin-right: -24.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-98:first-child{
    margin-right: -24.5rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-98:first-child{
    margin-left: -24.5rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-100:first-child{
    margin-left: -25rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-100:first-child{
    margin-right: -25rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-100:first-child{
    margin-right: -25rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-100:first-child{
    margin-left: -25rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-104:first-child{
    margin-left: -26rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-104:first-child{
    margin-right: -26rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-104:first-child{
    margin-right: -26rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-104:first-child{
    margin-left: -26rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-112:first-child{
    margin-left: -28rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-112:first-child{
    margin-right: -28rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-112:first-child{
    margin-right: -28rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-112:first-child{
    margin-left: -28rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-124:first-child{
    margin-left: -31rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-124:first-child{
    margin-right: -31rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-124:first-child{
    margin-right: -31rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-124:first-child{
    margin-left: -31rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-128:first-child{
    margin-left: -32rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-128:first-child{
    margin-right: -32rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-128:first-child{
    margin-right: -32rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-128:first-child{
    margin-left: -32rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-140:first-child{
    margin-left: -35rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-140:first-child{
    margin-right: -35rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-140:first-child{
    margin-right: -35rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-140:first-child{
    margin-left: -35rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-152:first-child{
    margin-left: -38rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-152:first-child{
    margin-right: -38rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-152:first-child{
    margin-right: -38rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-152:first-child{
    margin-left: -38rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-160:first-child{
    margin-left: -40rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-160:first-child{
    margin-right: -40rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-160:first-child{
    margin-right: -40rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-160:first-child{
    margin-left: -40rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-162:first-child{
    margin-left: -41rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-162:first-child{
    margin-right: -41rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-162:first-child{
    margin-right: -41rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-162:first-child{
    margin-left: -41rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-192:first-child{
    margin-left: -48rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-192:first-child{
    margin-right: -48rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-192:first-child{
    margin-right: -48rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-192:first-child{
    margin-left: -48rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-208:first-child{
    margin-left: -52rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-208:first-child{
    margin-right: -52rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-208:first-child{
    margin-right: -52rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-208:first-child{
    margin-left: -52rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-224:first-child{
    margin-left: -56rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-224:first-child{
    margin-right: -56rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-224:first-child{
    margin-right: -56rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-224:first-child{
    margin-left: -56rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-256:first-child{
    margin-left: -64rem;
  }

  [dir="rtl"] .sm\\:first\\:-ms-256:first-child{
    margin-right: -64rem;
  }

  [dir="ltr"] .sm\\:first\\:-me-256:first-child{
    margin-right: -64rem;
  }

  [dir="rtl"] .sm\\:first\\:-me-256:first-child{
    margin-left: -64rem;
  }

  [dir="ltr"] .sm\\:first\\:-ms-px:first-child{
    margin-left: -1px;
  }

  [dir="rtl"] .sm\\:first\\:-ms-px:first-child{
    margin-right: -1px;
  }

  [dir="ltr"] .sm\\:first\\:-me-px:first-child{
    margin-right: -1px;
  }

  [dir="rtl"] .sm\\:first\\:-me-px:first-child{
    margin-left: -1px;
  }

  [dir="rtl"] .sm\\:start-0{
    right: 0;
  }

  [dir="rtl"] .sm\\:end-0{
    left: 0;
  }

  [dir="ltr"] .sm\\:end-0{
    right: 0;
  }

  [dir="ltr"] .sm\\:start-0{
    left: 0;
  }

  [dir="rtl"] .sm\\:start-auto{
    right: auto;
  }

  [dir="rtl"] .sm\\:end-auto{
    left: auto;
  }

  [dir="ltr"] .sm\\:end-auto{
    right: auto;
  }

  [dir="ltr"] .sm\\:start-auto{
    left: auto;
  }

  [dir="ltr"] .sm\\:rounded-e-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .sm\\:rounded-s-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .sm\\:rounded-e-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .sm\\:rounded-s-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .sm\\:rounded-e-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .sm\\:rounded-s-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .sm\\:rounded-e-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .sm\\:rounded-s-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .sm\\:rounded-e{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .sm\\:rounded-s{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .sm\\:rounded-e{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .sm\\:rounded-s{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .sm\\:rounded-e-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .sm\\:rounded-s-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .sm\\:rounded-e-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .sm\\:rounded-s-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .sm\\:rounded-e-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .sm\\:rounded-s-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .sm\\:rounded-e-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .sm\\:rounded-s-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .sm\\:rounded-e-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .sm\\:rounded-s-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .sm\\:rounded-e-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .sm\\:rounded-s-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .sm\\:rounded-ts-none{
    border-top-left-radius: 0;
  }

  [dir="ltr"] .sm\\:rounded-te-none{
    border-top-right-radius: 0;
  }

  [dir="ltr"] .sm\\:rounded-be-none{
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .sm\\:rounded-bs-none{
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .sm\\:rounded-te-none{
    border-top-left-radius: 0;
  }

  [dir="rtl"] .sm\\:rounded-ts-none{
    border-top-right-radius: 0;
  }

  [dir="rtl"] .sm\\:rounded-bs-none{
    border-bottom-right-radius: 0;
  }

  [dir="rtl"] .sm\\:rounded-be-none{
    border-bottom-left-radius: 0;
  }

  [dir="ltr"] .sm\\:rounded-ts-sm{
    border-top-left-radius: .25rem;
  }

  [dir="ltr"] .sm\\:rounded-te-sm{
    border-top-right-radius: .25rem;
  }

  [dir="ltr"] .sm\\:rounded-be-sm{
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .sm\\:rounded-bs-sm{
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .sm\\:rounded-te-sm{
    border-top-left-radius: .25rem;
  }

  [dir="rtl"] .sm\\:rounded-ts-sm{
    border-top-right-radius: .25rem;
  }

  [dir="rtl"] .sm\\:rounded-bs-sm{
    border-bottom-right-radius: .25rem;
  }

  [dir="rtl"] .sm\\:rounded-be-sm{
    border-bottom-left-radius: .25rem;
  }

  [dir="ltr"] .sm\\:rounded-ts{
    border-top-left-radius: .375rem;
  }

  [dir="ltr"] .sm\\:rounded-te{
    border-top-right-radius: .375rem;
  }

  [dir="ltr"] .sm\\:rounded-be{
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .sm\\:rounded-bs{
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .sm\\:rounded-te{
    border-top-left-radius: .375rem;
  }

  [dir="rtl"] .sm\\:rounded-ts{
    border-top-right-radius: .375rem;
  }

  [dir="rtl"] .sm\\:rounded-bs{
    border-bottom-right-radius: .375rem;
  }

  [dir="rtl"] .sm\\:rounded-be{
    border-bottom-left-radius: .375rem;
  }

  [dir="ltr"] .sm\\:rounded-ts-lg{
    border-top-left-radius: .5rem;
  }

  [dir="ltr"] .sm\\:rounded-te-lg{
    border-top-right-radius: .5rem;
  }

  [dir="ltr"] .sm\\:rounded-be-lg{
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .sm\\:rounded-bs-lg{
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .sm\\:rounded-te-lg{
    border-top-left-radius: .5rem;
  }

  [dir="rtl"] .sm\\:rounded-ts-lg{
    border-top-right-radius: .5rem;
  }

  [dir="rtl"] .sm\\:rounded-bs-lg{
    border-bottom-right-radius: .5rem;
  }

  [dir="rtl"] .sm\\:rounded-be-lg{
    border-bottom-left-radius: .5rem;
  }

  [dir="ltr"] .sm\\:rounded-ts-xl{
    border-top-left-radius: .75rem;
  }

  [dir="ltr"] .sm\\:rounded-te-xl{
    border-top-right-radius: .75rem;
  }

  [dir="ltr"] .sm\\:rounded-be-xl{
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .sm\\:rounded-bs-xl{
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .sm\\:rounded-te-xl{
    border-top-left-radius: .75rem;
  }

  [dir="rtl"] .sm\\:rounded-ts-xl{
    border-top-right-radius: .75rem;
  }

  [dir="rtl"] .sm\\:rounded-bs-xl{
    border-bottom-right-radius: .75rem;
  }

  [dir="rtl"] .sm\\:rounded-be-xl{
    border-bottom-left-radius: .75rem;
  }

  [dir="ltr"] .sm\\:rounded-ts-full{
    border-top-left-radius: 9999px;
  }

  [dir="ltr"] .sm\\:rounded-te-full{
    border-top-right-radius: 9999px;
  }

  [dir="ltr"] .sm\\:rounded-be-full{
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .sm\\:rounded-bs-full{
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .sm\\:rounded-te-full{
    border-top-left-radius: 9999px;
  }

  [dir="rtl"] .sm\\:rounded-ts-full{
    border-top-right-radius: 9999px;
  }

  [dir="rtl"] .sm\\:rounded-bs-full{
    border-bottom-right-radius: 9999px;
  }

  [dir="rtl"] .sm\\:rounded-be-full{
    border-bottom-left-radius: 9999px;
  }

  [dir="ltr"] .sm\\:clear-start{
    clear: left;
  }

  [dir="ltr"] .sm\\:clear-end{
    clear: right;
  }

  [dir="rtl"] .sm\\:clear-start{
    clear: right;
  }

  [dir="rtl"] .sm\\:clear-end{
    clear: left;
  }

  [dir="rtl"] .sm\\:float-start{
    float: right;
  }

  [dir="rtl"] .sm\\:float-end{
    float: left;
  }

  [dir="ltr"] .sm\\:float-end{
    float: right;
  }

  [dir="ltr"] .sm\\:float-start{
    float: left;
  }

  [dir="ltr"] .sm\\:border-e-0{
    border-right-width: 0;
  }

  [dir="rtl"] .sm\\:border-e-0{
    border-left-width: 0;
  }

  [dir="ltr"] .sm\\:border-s-0{
    border-left-width: 0;
  }

  [dir="rtl"] .sm\\:border-s-0{
    border-right-width: 0;
  }

  [dir="ltr"] .sm\\:border-e-2{
    border-right-width: 2px;
  }

  [dir="rtl"] .sm\\:border-e-2{
    border-left-width: 2px;
  }

  [dir="ltr"] .sm\\:border-s-2{
    border-left-width: 2px;
  }

  [dir="rtl"] .sm\\:border-s-2{
    border-right-width: 2px;
  }

  [dir="ltr"] .sm\\:border-e-3{
    border-right-width: 3px;
  }

  [dir="rtl"] .sm\\:border-e-3{
    border-left-width: 3px;
  }

  [dir="ltr"] .sm\\:border-s-3{
    border-left-width: 3px;
  }

  [dir="rtl"] .sm\\:border-s-3{
    border-right-width: 3px;
  }

  [dir="ltr"] .sm\\:border-e-4{
    border-right-width: 4px;
  }

  [dir="rtl"] .sm\\:border-e-4{
    border-left-width: 4px;
  }

  [dir="ltr"] .sm\\:border-s-4{
    border-left-width: 4px;
  }

  [dir="rtl"] .sm\\:border-s-4{
    border-right-width: 4px;
  }

  [dir="ltr"] .sm\\:border-e-5{
    border-right-width: 5px;
  }

  [dir="rtl"] .sm\\:border-e-5{
    border-left-width: 5px;
  }

  [dir="ltr"] .sm\\:border-s-5{
    border-left-width: 5px;
  }

  [dir="rtl"] .sm\\:border-s-5{
    border-right-width: 5px;
  }

  [dir="ltr"] .sm\\:border-e-6{
    border-right-width: 6px;
  }

  [dir="rtl"] .sm\\:border-e-6{
    border-left-width: 6px;
  }

  [dir="ltr"] .sm\\:border-s-6{
    border-left-width: 6px;
  }

  [dir="rtl"] .sm\\:border-s-6{
    border-right-width: 6px;
  }

  [dir="ltr"] .sm\\:border-e-8{
    border-right-width: 8px;
  }

  [dir="rtl"] .sm\\:border-e-8{
    border-left-width: 8px;
  }

  [dir="ltr"] .sm\\:border-s-8{
    border-left-width: 8px;
  }

  [dir="rtl"] .sm\\:border-s-8{
    border-right-width: 8px;
  }

  [dir="ltr"] .sm\\:border-e{
    border-right-width: 1px;
  }

  [dir="rtl"] .sm\\:border-e{
    border-left-width: 1px;
  }

  [dir="ltr"] .sm\\:border-s{
    border-left-width: 1px;
  }

  [dir="rtl"] .sm\\:border-s{
    border-right-width: 1px;
  }

  [dir="ltr"] .sm\\:first\\:border-e-0:first-child{
    border-right-width: 0;
  }

  [dir="rtl"] .sm\\:first\\:border-e-0:first-child{
    border-left-width: 0;
  }

  [dir="ltr"] .sm\\:first\\:border-s-0:first-child{
    border-left-width: 0;
  }

  [dir="rtl"] .sm\\:first\\:border-s-0:first-child{
    border-right-width: 0;
  }

  [dir="ltr"] .sm\\:first\\:border-e-2:first-child{
    border-right-width: 2px;
  }

  [dir="rtl"] .sm\\:first\\:border-e-2:first-child{
    border-left-width: 2px;
  }

  [dir="ltr"] .sm\\:first\\:border-s-2:first-child{
    border-left-width: 2px;
  }

  [dir="rtl"] .sm\\:first\\:border-s-2:first-child{
    border-right-width: 2px;
  }

  [dir="ltr"] .sm\\:first\\:border-e-3:first-child{
    border-right-width: 3px;
  }

  [dir="rtl"] .sm\\:first\\:border-e-3:first-child{
    border-left-width: 3px;
  }

  [dir="ltr"] .sm\\:first\\:border-s-3:first-child{
    border-left-width: 3px;
  }

  [dir="rtl"] .sm\\:first\\:border-s-3:first-child{
    border-right-width: 3px;
  }

  [dir="ltr"] .sm\\:first\\:border-e-4:first-child{
    border-right-width: 4px;
  }

  [dir="rtl"] .sm\\:first\\:border-e-4:first-child{
    border-left-width: 4px;
  }

  [dir="ltr"] .sm\\:first\\:border-s-4:first-child{
    border-left-width: 4px;
  }

  [dir="rtl"] .sm\\:first\\:border-s-4:first-child{
    border-right-width: 4px;
  }

  [dir="ltr"] .sm\\:first\\:border-e-5:first-child{
    border-right-width: 5px;
  }

  [dir="rtl"] .sm\\:first\\:border-e-5:first-child{
    border-left-width: 5px;
  }

  [dir="ltr"] .sm\\:first\\:border-s-5:first-child{
    border-left-width: 5px;
  }

  [dir="rtl"] .sm\\:first\\:border-s-5:first-child{
    border-right-width: 5px;
  }

  [dir="ltr"] .sm\\:first\\:border-e-6:first-child{
    border-right-width: 6px;
  }

  [dir="rtl"] .sm\\:first\\:border-e-6:first-child{
    border-left-width: 6px;
  }

  [dir="ltr"] .sm\\:first\\:border-s-6:first-child{
    border-left-width: 6px;
  }

  [dir="rtl"] .sm\\:first\\:border-s-6:first-child{
    border-right-width: 6px;
  }

  [dir="ltr"] .sm\\:first\\:border-e-8:first-child{
    border-right-width: 8px;
  }

  [dir="rtl"] .sm\\:first\\:border-e-8:first-child{
    border-left-width: 8px;
  }

  [dir="ltr"] .sm\\:first\\:border-s-8:first-child{
    border-left-width: 8px;
  }

  [dir="rtl"] .sm\\:first\\:border-s-8:first-child{
    border-right-width: 8px;
  }

  [dir="ltr"] .sm\\:first\\:border-e:first-child{
    border-right-width: 1px;
  }

  [dir="rtl"] .sm\\:first\\:border-e:first-child{
    border-left-width: 1px;
  }

  [dir="ltr"] .sm\\:first\\:border-s:first-child{
    border-left-width: 1px;
  }

  [dir="rtl"] .sm\\:first\\:border-s:first-child{
    border-right-width: 1px;
  }

  [dir="rtl"] .sm\\:text-start{
    text-align: right;
  }

  [dir="rtl"] .sm\\:text-end{
    text-align: left;
  }

  [dir="ltr"] .sm\\:text-end{
    text-align: right;
  }

  [dir="ltr"] .sm\\:text-start{
    text-align: left;
  }

  [dir="ltr"] .sm\\:origin-top-start{
    transform-origin: top left;
  }

  [dir="ltr"] .sm\\:origin-top-end{
    transform-origin: top right;
  }

  [dir="ltr"] .sm\\:origin-bottom-start{
    transform-origin: bottom left;
  }

  [dir="ltr"] .sm\\:origin-bottom-end{
    transform-origin: bottom right;
  }

  [dir="ltr"] .sm\\:origin-start{
    transform-origin: left;
  }

  [dir="ltr"] .sm\\:origin-end{
    transform-origin: right;
  }

  [dir="rtl"] .sm\\:origin-top-start{
    transform-origin: top right;
  }

  [dir="rtl"] .sm\\:origin-top-end{
    transform-origin: top left;
  }

  [dir="rtl"] .sm\\:origin-bottom-start{
    transform-origin: bottom right;
  }

  [dir="rtl"] .sm\\:origin-bottom-end{
    transform-origin: bottom left;
  }

  [dir="rtl"] .sm\\:origin-start{
    transform-origin: right;
  }

  [dir="rtl"] .sm\\:origin-end{
    transform-origin: left;
  }

  [dir="ltr"] .sm\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .sm\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .sm\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .sm\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .sm\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .sm\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * (1 - var(--tw-space-s-reverse)));
  }

  .sm\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  .sm\\:space-s-reverse > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 1;
  }
}

@media (min-width: 768px){
  .md\\:prose{
    color: #4a5568;
    max-width: 65ch;
  }

  .md\\:prose [class~="lead"]{
    color: #4a5568;
    font-size: 1.25em;
    line-height: 1.6;
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .md\\:prose a{
    color: #1a202c;
    text-decoration: underline;
  }

  .md\\:prose strong{
    color: #1a202c;
    font-weight: 600;
  }

  .md\\:prose ol{
    counter-reset: list-counter;
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .md\\:prose ol > li{
    position: relative;
    counter-increment: list-counter;
    padding-left: 1.75em;
  }

  .md\\:prose ol > li::before{
    content: ;
    position: absolute;
    font-weight: 400;
    color: #718096;
  }

  .md\\:prose ul > li{
    position: relative;
    padding-left: 1.75em;
  }

  .md\\:prose ul > li::before{
    content: "";
    position: absolute;
    background-color: #cbd5e0;
    border-radius: 50%;
    width: 0.375em;
    height: 0.375em;
    top: calc(0.875em - 0.1875em);
    left: 0.25em;
  }

  .md\\:prose hr{
    border-color: #e2e8f0;
    border-top-width: 1px;
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .md\\:prose blockquote{
    font-weight: 500;
    font-style: italic;
    color: #1a202c;
    border-left-width: 0.25rem;
    border-left-color: #e2e8f0;
    quotes: "\\201C""\\201D""\\2018""\\2019";
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1em;
  }

  .md\\:prose blockquote p:first-of-type::before{
    content: open-quote;
  }

  .md\\:prose blockquote p:last-of-type::after{
    content: close-quote;
  }

  .md\\:prose h1{
    color: #1a202c;
    font-weight: 800;
    font-size: 2.25em;
    margin-top: 0;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }

  .md\\:prose h2{
    color: #1a202c;
    font-weight: 700;
    font-size: 1.5em;
    margin-top: 2em;
    margin-bottom: 1em;
    line-height: 1.3333333;
  }

  .md\\:prose h3{
    color: #1a202c;
    font-weight: 600;
    font-size: 1.25em;
    margin-top: 1.6em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }

  .md\\:prose h4{
    color: #1a202c;
    font-weight: 600;
    margin-top: 1.5em;
    margin-bottom: 0.5em;
    line-height: 1.5;
  }

  .md\\:prose figure figcaption{
    color: #718096;
    font-size: 0.875em;
    line-height: 1.4285714;
    margin-top: 0.8571429em;
  }

  .md\\:prose code{
    color: #1a202c;
    font-weight: 600;
    font-size: 0.875em;
  }

  .md\\:prose code::before{
    content: "\`";
  }

  .md\\:prose code::after{
    content: "\`";
  }

  .md\\:prose pre{
    color: #e2e8f0;
    background-color: #2d3748;
    overflow-x: auto;
    font-size: 0.875em;
    line-height: 1.7142857;
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
    border-radius: 0.375rem;
    padding-top: 0.8571429em;
    padding-right: 1.1428571em;
    padding-bottom: 0.8571429em;
    padding-left: 1.1428571em;
  }

  .md\\:prose pre code{
    background-color: transparent;
    border-width: 0;
    border-radius: 0;
    padding: 0;
    font-weight: 400;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
  }

  .md\\:prose pre code::before{
    content: "";
  }

  .md\\:prose pre code::after{
    content: "";
  }

  .md\\:prose table{
    width: 100%;
    table-layout: auto;
    text-align: left;
    margin-top: 2em;
    margin-bottom: 2em;
    font-size: 0.875em;
    line-height: 1.7142857;
  }

  .md\\:prose thead{
    color: #1a202c;
    font-weight: 600;
    border-bottom-width: 1px;
    border-bottom-color: #cbd5e0;
  }

  .md\\:prose thead th{
    vertical-align: bottom;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }

  .md\\:prose tbody tr{
    border-bottom-width: 1px;
    border-bottom-color: #e2e8f0;
  }

  .md\\:prose tbody tr:last-child{
    border-bottom-width: 0;
  }

  .md\\:prose tbody td{
    vertical-align: top;
    padding-top: 0.5714286em;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }

  .md\\:prose{
    font-size: 1rem;
    line-height: 1.75;
  }

  .md\\:prose p{
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .md\\:prose img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .md\\:prose video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .md\\:prose figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .md\\:prose figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .md\\:prose h2 code{
    font-size: 0.875em;
  }

  .md\\:prose h3 code{
    font-size: 0.9em;
  }

  .md\\:prose ul{
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .md\\:prose li{
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .md\\:prose ol > li:before{
    left: 0;
  }

  .md\\:prose > ul > li p{
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }

  .md\\:prose > ul > li > *:first-child{
    margin-top: 1.25em;
  }

  .md\\:prose > ul > li > *:last-child{
    margin-bottom: 1.25em;
  }

  .md\\:prose > ol > li > *:first-child{
    margin-top: 1.25em;
  }

  .md\\:prose > ol > li > *:last-child{
    margin-bottom: 1.25em;
  }

  .md\\:prose ul ul, .md\\:prose ul ol, .md\\:prose ol ul, .md\\:prose ol ol{
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }

  .md\\:prose hr + *{
    margin-top: 0;
  }

  .md\\:prose h2 + *{
    margin-top: 0;
  }

  .md\\:prose h3 + *{
    margin-top: 0;
  }

  .md\\:prose h4 + *{
    margin-top: 0;
  }

  .md\\:prose thead th:first-child{
    padding-left: 0;
  }

  .md\\:prose thead th:last-child{
    padding-right: 0;
  }

  .md\\:prose tbody td:first-child{
    padding-left: 0;
  }

  .md\\:prose tbody td:last-child{
    padding-right: 0;
  }

  .md\\:prose > :first-child{
    margin-top: 0;
  }

  .md\\:prose > :last-child{
    margin-bottom: 0;
  }

  .md\\:prose-sm{
    font-size: 0.875rem;
    line-height: 1.7142857;
  }

  .md\\:prose-sm p{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .md\\:prose-sm [class~="lead"]{
    font-size: 1.2857143em;
    line-height: 1.5555556;
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .md\\:prose-sm blockquote{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
    padding-left: 1.1111111em;
  }

  .md\\:prose-sm h1{
    font-size: 2.1428571em;
    margin-top: 0;
    margin-bottom: 0.8em;
    line-height: 1.2;
  }

  .md\\:prose-sm h2{
    font-size: 1.4285714em;
    margin-top: 1.6em;
    margin-bottom: 0.8em;
    line-height: 1.4;
  }

  .md\\:prose-sm h3{
    font-size: 1.2857143em;
    margin-top: 1.5555556em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }

  .md\\:prose-sm h4{
    margin-top: 1.4285714em;
    margin-bottom: 0.5714286em;
    line-height: 1.4285714;
  }

  .md\\:prose-sm img{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .md\\:prose-sm video{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .md\\:prose-sm figure{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .md\\:prose-sm figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .md\\:prose-sm figure figcaption{
    font-size: 0.8571429em;
    line-height: 1.3333333;
    margin-top: 0.6666667em;
  }

  .md\\:prose-sm code{
    font-size: 0.8571429em;
  }

  .md\\:prose-sm h2 code{
    font-size: 0.9em;
  }

  .md\\:prose-sm h3 code{
    font-size: 0.8888889em;
  }

  .md\\:prose-sm pre{
    font-size: 0.8571429em;
    line-height: 1.6666667;
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    border-radius: 0.25rem;
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .md\\:prose-sm ol{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .md\\:prose-sm ul{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .md\\:prose-sm li{
    margin-top: 0.2857143em;
    margin-bottom: 0.2857143em;
  }

  .md\\:prose-sm ol > li{
    padding-left: 1.5714286em;
  }

  .md\\:prose-sm ol > li:before{
    left: 0;
  }

  .md\\:prose-sm ul > li{
    padding-left: 1.5714286em;
  }

  .md\\:prose-sm ul > li::before{
    height: 0.3571429em;
    width: 0.3571429em;
    top: calc(0.8571429em - 0.1785714em);
    left: 0.2142857em;
  }

  .md\\:prose-sm > ul > li p{
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }

  .md\\:prose-sm > ul > li > *:first-child{
    margin-top: 1.1428571em;
  }

  .md\\:prose-sm > ul > li > *:last-child{
    margin-bottom: 1.1428571em;
  }

  .md\\:prose-sm > ol > li > *:first-child{
    margin-top: 1.1428571em;
  }

  .md\\:prose-sm > ol > li > *:last-child{
    margin-bottom: 1.1428571em;
  }

  .md\\:prose-sm ul ul, .md\\:prose-sm ul ol, .md\\:prose-sm ol ul, .md\\:prose-sm ol ol{
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }

  .md\\:prose-sm hr{
    margin-top: 2.8571429em;
    margin-bottom: 2.8571429em;
  }

  .md\\:prose-sm hr + *{
    margin-top: 0;
  }

  .md\\:prose-sm h2 + *{
    margin-top: 0;
  }

  .md\\:prose-sm h3 + *{
    margin-top: 0;
  }

  .md\\:prose-sm h4 + *{
    margin-top: 0;
  }

  .md\\:prose-sm table{
    font-size: 0.8571429em;
    line-height: 1.5;
  }

  .md\\:prose-sm thead th{
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .md\\:prose-sm thead th:first-child{
    padding-left: 0;
  }

  .md\\:prose-sm thead th:last-child{
    padding-right: 0;
  }

  .md\\:prose-sm tbody td{
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .md\\:prose-sm tbody td:first-child{
    padding-left: 0;
  }

  .md\\:prose-sm tbody td:last-child{
    padding-right: 0;
  }

  .md\\:prose-sm > :first-child{
    margin-top: 0;
  }

  .md\\:prose-sm > :last-child{
    margin-bottom: 0;
  }

  .md\\:prose-lg{
    font-size: 1.125rem;
    line-height: 1.7777778;
  }

  .md\\:prose-lg p{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .md\\:prose-lg [class~="lead"]{
    font-size: 1.2222222em;
    line-height: 1.4545455;
    margin-top: 1.0909091em;
    margin-bottom: 1.0909091em;
  }

  .md\\:prose-lg blockquote{
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    padding-left: 1em;
  }

  .md\\:prose-lg h1{
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.8333333em;
    line-height: 1;
  }

  .md\\:prose-lg h2{
    font-size: 1.6666667em;
    margin-top: 1.8666667em;
    margin-bottom: 1.0666667em;
    line-height: 1.3333333;
  }

  .md\\:prose-lg h3{
    font-size: 1.3333333em;
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }

  .md\\:prose-lg h4{
    margin-top: 1.7777778em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }

  .md\\:prose-lg img{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .md\\:prose-lg video{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .md\\:prose-lg figure{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .md\\:prose-lg figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .md\\:prose-lg figure figcaption{
    font-size: 0.8888889em;
    line-height: 1.5;
    margin-top: 1em;
  }

  .md\\:prose-lg code{
    font-size: 0.8888889em;
  }

  .md\\:prose-lg h2 code{
    font-size: 0.8666667em;
  }

  .md\\:prose-lg h3 code{
    font-size: 0.875em;
  }

  .md\\:prose-lg pre{
    font-size: 0.8888889em;
    line-height: 1.75;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.375rem;
    padding-top: 1em;
    padding-right: 1.5em;
    padding-bottom: 1em;
    padding-left: 1.5em;
  }

  .md\\:prose-lg ol{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .md\\:prose-lg ul{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .md\\:prose-lg li{
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }

  .md\\:prose-lg ol > li{
    padding-left: 1.6666667em;
  }

  .md\\:prose-lg ol > li:before{
    left: 0;
  }

  .md\\:prose-lg ul > li{
    padding-left: 1.6666667em;
  }

  .md\\:prose-lg ul > li::before{
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8888889em - 0.1666667em);
    left: 0.2222222em;
  }

  .md\\:prose-lg > ul > li p{
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .md\\:prose-lg > ul > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .md\\:prose-lg > ul > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .md\\:prose-lg > ol > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .md\\:prose-lg > ol > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .md\\:prose-lg ul ul, .md\\:prose-lg ul ol, .md\\:prose-lg ol ul, .md\\:prose-lg ol ol{
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .md\\:prose-lg hr{
    margin-top: 3.1111111em;
    margin-bottom: 3.1111111em;
  }

  .md\\:prose-lg hr + *{
    margin-top: 0;
  }

  .md\\:prose-lg h2 + *{
    margin-top: 0;
  }

  .md\\:prose-lg h3 + *{
    margin-top: 0;
  }

  .md\\:prose-lg h4 + *{
    margin-top: 0;
  }

  .md\\:prose-lg table{
    font-size: 0.8888889em;
    line-height: 1.5;
  }

  .md\\:prose-lg thead th{
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }

  .md\\:prose-lg thead th:first-child{
    padding-left: 0;
  }

  .md\\:prose-lg thead th:last-child{
    padding-right: 0;
  }

  .md\\:prose-lg tbody td{
    padding-top: 0.75em;
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }

  .md\\:prose-lg tbody td:first-child{
    padding-left: 0;
  }

  .md\\:prose-lg tbody td:last-child{
    padding-right: 0;
  }

  .md\\:prose-lg > :first-child{
    margin-top: 0;
  }

  .md\\:prose-lg > :last-child{
    margin-bottom: 0;
  }

  .md\\:prose-xl{
    font-size: 1.25rem;
    line-height: 1.8;
  }

  .md\\:prose-xl p{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .md\\:prose-xl [class~="lead"]{
    font-size: 1.2em;
    line-height: 1.5;
    margin-top: 1em;
    margin-bottom: 1em;
  }

  .md\\:prose-xl blockquote{
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1.0666667em;
  }

  .md\\:prose-xl h1{
    font-size: 2.8em;
    margin-top: 0;
    margin-bottom: 0.8571429em;
    line-height: 1;
  }

  .md\\:prose-xl h2{
    font-size: 1.8em;
    margin-top: 1.5555556em;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }

  .md\\:prose-xl h3{
    font-size: 1.5em;
    margin-top: 1.6em;
    margin-bottom: 0.6666667em;
    line-height: 1.3333333;
  }

  .md\\:prose-xl h4{
    margin-top: 1.8em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }

  .md\\:prose-xl img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .md\\:prose-xl video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .md\\:prose-xl figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .md\\:prose-xl figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .md\\:prose-xl figure figcaption{
    font-size: 0.9em;
    line-height: 1.5555556;
    margin-top: 1em;
  }

  .md\\:prose-xl code{
    font-size: 0.9em;
  }

  .md\\:prose-xl h2 code{
    font-size: 0.8611111em;
  }

  .md\\:prose-xl h3 code{
    font-size: 0.9em;
  }

  .md\\:prose-xl pre{
    font-size: 0.9em;
    line-height: 1.7777778;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.1111111em;
    padding-right: 1.3333333em;
    padding-bottom: 1.1111111em;
    padding-left: 1.3333333em;
  }

  .md\\:prose-xl ol{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .md\\:prose-xl ul{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .md\\:prose-xl li{
    margin-top: 0.6em;
    margin-bottom: 0.6em;
  }

  .md\\:prose-xl ol > li{
    padding-left: 1.8em;
  }

  .md\\:prose-xl ol > li:before{
    left: 0;
  }

  .md\\:prose-xl ul > li{
    padding-left: 1.8em;
  }

  .md\\:prose-xl ul > li::before{
    width: 0.35em;
    height: 0.35em;
    top: calc(0.9em - 0.175em);
    left: 0.25em;
  }

  .md\\:prose-xl > ul > li p{
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }

  .md\\:prose-xl > ul > li > *:first-child{
    margin-top: 1.2em;
  }

  .md\\:prose-xl > ul > li > *:last-child{
    margin-bottom: 1.2em;
  }

  .md\\:prose-xl > ol > li > *:first-child{
    margin-top: 1.2em;
  }

  .md\\:prose-xl > ol > li > *:last-child{
    margin-bottom: 1.2em;
  }

  .md\\:prose-xl ul ul, .md\\:prose-xl ul ol, .md\\:prose-xl ol ul, .md\\:prose-xl ol ol{
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }

  .md\\:prose-xl hr{
    margin-top: 2.8em;
    margin-bottom: 2.8em;
  }

  .md\\:prose-xl hr + *{
    margin-top: 0;
  }

  .md\\:prose-xl h2 + *{
    margin-top: 0;
  }

  .md\\:prose-xl h3 + *{
    margin-top: 0;
  }

  .md\\:prose-xl h4 + *{
    margin-top: 0;
  }

  .md\\:prose-xl table{
    font-size: 0.9em;
    line-height: 1.5555556;
  }

  .md\\:prose-xl thead th{
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }

  .md\\:prose-xl thead th:first-child{
    padding-left: 0;
  }

  .md\\:prose-xl thead th:last-child{
    padding-right: 0;
  }

  .md\\:prose-xl tbody td{
    padding-top: 0.8888889em;
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }

  .md\\:prose-xl tbody td:first-child{
    padding-left: 0;
  }

  .md\\:prose-xl tbody td:last-child{
    padding-right: 0;
  }

  .md\\:prose-xl > :first-child{
    margin-top: 0;
  }

  .md\\:prose-xl > :last-child{
    margin-bottom: 0;
  }

  .md\\:prose-2xl{
    font-size: 1.5rem;
    line-height: 1.6666667;
  }

  .md\\:prose-2xl p{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .md\\:prose-2xl [class~="lead"]{
    font-size: 1.25em;
    line-height: 1.4666667;
    margin-top: 1.0666667em;
    margin-bottom: 1.0666667em;
  }

  .md\\:prose-2xl blockquote{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
    padding-left: 1.1111111em;
  }

  .md\\:prose-2xl h1{
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.875em;
    line-height: 1;
  }

  .md\\:prose-2xl h2{
    font-size: 2em;
    margin-top: 1.5em;
    margin-bottom: 0.8333333em;
    line-height: 1.0833333;
  }

  .md\\:prose-2xl h3{
    font-size: 1.5em;
    margin-top: 1.5555556em;
    margin-bottom: 0.6666667em;
    line-height: 1.2222222;
  }

  .md\\:prose-2xl h4{
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }

  .md\\:prose-2xl img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .md\\:prose-2xl video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .md\\:prose-2xl figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .md\\:prose-2xl figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .md\\:prose-2xl figure figcaption{
    font-size: 0.8333333em;
    line-height: 1.6;
    margin-top: 1em;
  }

  .md\\:prose-2xl code{
    font-size: 0.8333333em;
  }

  .md\\:prose-2xl h2 code{
    font-size: 0.875em;
  }

  .md\\:prose-2xl h3 code{
    font-size: 0.8888889em;
  }

  .md\\:prose-2xl pre{
    font-size: 0.8333333em;
    line-height: 1.8;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.2em;
    padding-right: 1.6em;
    padding-bottom: 1.2em;
    padding-left: 1.6em;
  }

  .md\\:prose-2xl ol{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .md\\:prose-2xl ul{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .md\\:prose-2xl li{
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .md\\:prose-2xl ol > li{
    padding-left: 1.6666667em;
  }

  .md\\:prose-2xl ol > li:before{
    left: 0;
  }

  .md\\:prose-2xl ul > li{
    padding-left: 1.6666667em;
  }

  .md\\:prose-2xl ul > li::before{
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8333333em - 0.1666667em);
    left: 0.25em;
  }

  .md\\:prose-2xl > ul > li p{
    margin-top: 0.8333333em;
    margin-bottom: 0.8333333em;
  }

  .md\\:prose-2xl > ul > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .md\\:prose-2xl > ul > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .md\\:prose-2xl > ol > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .md\\:prose-2xl > ol > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .md\\:prose-2xl ul ul, .md\\:prose-2xl ul ol, .md\\:prose-2xl ol ul, .md\\:prose-2xl ol ol{
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }

  .md\\:prose-2xl hr{
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .md\\:prose-2xl hr + *{
    margin-top: 0;
  }

  .md\\:prose-2xl h2 + *{
    margin-top: 0;
  }

  .md\\:prose-2xl h3 + *{
    margin-top: 0;
  }

  .md\\:prose-2xl h4 + *{
    margin-top: 0;
  }

  .md\\:prose-2xl table{
    font-size: 0.8333333em;
    line-height: 1.4;
  }

  .md\\:prose-2xl thead th{
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }

  .md\\:prose-2xl thead th:first-child{
    padding-left: 0;
  }

  .md\\:prose-2xl thead th:last-child{
    padding-right: 0;
  }

  .md\\:prose-2xl tbody td{
    padding-top: 0.8em;
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }

  .md\\:prose-2xl tbody td:first-child{
    padding-left: 0;
  }

  .md\\:prose-2xl tbody td:last-child{
    padding-right: 0;
  }

  .md\\:prose-2xl > :first-child{
    margin-top: 0;
  }

  .md\\:prose-2xl > :last-child{
    margin-bottom: 0;
  }

  .md\\:space-y-0 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0px * (1 - var(--space-y-reverse)));
    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0px * var(--space-y-reverse));
  }

  .md\\:space-x-0 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0px * var(--space-x-reverse));
    margin-left: calc(0px * (1 - var(--space-x-reverse)));
    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--space-y-reverse));
  }

  .md\\:space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--space-x-reverse));
    margin-left: calc(0.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--space-x-reverse));
    margin-left: calc(0.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--space-y-reverse));
  }

  .md\\:space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--space-x-reverse));
    margin-left: calc(0.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1rem * var(--space-y-reverse));
  }

  .md\\:space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1rem * var(--space-x-reverse));
    margin-left: calc(1rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--space-y-reverse));
  }

  .md\\:space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--space-x-reverse));
    margin-left: calc(1.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--space-x-reverse));
    margin-left: calc(1.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-7 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.75rem * var(--space-y-reverse));
  }

  .md\\:space-x-7 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.75rem * var(--space-x-reverse));
    margin-left: calc(1.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2rem * var(--space-y-reverse));
  }

  .md\\:space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2rem * var(--space-x-reverse));
    margin-left: calc(2rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-9 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.25rem * var(--space-y-reverse));
  }

  .md\\:space-x-9 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.25rem * var(--space-x-reverse));
    margin-left: calc(2.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.5rem * var(--space-x-reverse));
    margin-left: calc(2.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-11 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.75rem * var(--space-y-reverse));
  }

  .md\\:space-x-11 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.75rem * var(--space-x-reverse));
    margin-left: calc(2.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3rem * var(--space-y-reverse));
  }

  .md\\:space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3rem * var(--space-x-reverse));
    margin-left: calc(3rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-14 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-14 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3.5rem * var(--space-x-reverse));
    margin-left: calc(3.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-15 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.75rem * var(--space-y-reverse));
  }

  .md\\:space-x-15 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3.75rem * var(--space-x-reverse));
    margin-left: calc(3.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(4rem * (1 - var(--space-y-reverse)));
    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(4rem * var(--space-y-reverse));
  }

  .md\\:space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(4rem * var(--space-x-reverse));
    margin-left: calc(4rem * (1 - var(--space-x-reverse)));
    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-18 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(4.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(4.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(4.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-18 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(4.5rem * var(--space-x-reverse));
    margin-left: calc(4.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(4.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5rem * var(--space-y-reverse));
  }

  .md\\:space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5rem * var(--space-x-reverse));
    margin-left: calc(5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-22 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-22 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5.5rem * var(--space-x-reverse));
    margin-left: calc(5.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-23 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5.75rem * var(--space-y-reverse));
  }

  .md\\:space-x-23 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5.75rem * var(--space-x-reverse));
    margin-left: calc(5.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5.75rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6rem * var(--space-y-reverse));
  }

  .md\\:space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6rem * var(--space-x-reverse));
    margin-left: calc(6rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-25 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6.25rem * var(--space-y-reverse));
  }

  .md\\:space-x-25 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6.25rem * var(--space-x-reverse));
    margin-left: calc(6.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6.25rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-26 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-26 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6.5rem * var(--space-x-reverse));
    margin-left: calc(6.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-28 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(7rem * (1 - var(--space-y-reverse)));
    margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(7rem * var(--space-y-reverse));
  }

  .md\\:space-x-28 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(7rem * var(--space-x-reverse));
    margin-left: calc(7rem * (1 - var(--space-x-reverse)));
    margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-30 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(7.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(7.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(7.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-30 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(7.5rem * var(--space-x-reverse));
    margin-left: calc(7.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(7.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(8rem * (1 - var(--space-y-reverse)));
    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8rem * var(--space-y-reverse));
  }

  .md\\:space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(8rem * var(--space-x-reverse));
    margin-left: calc(8rem * (1 - var(--space-x-reverse)));
    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-34 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(8.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(8.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-34 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(8.5rem * var(--space-x-reverse));
    margin-left: calc(8.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(8.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(10rem * (1 - var(--space-y-reverse)));
    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(10rem * var(--space-y-reverse));
  }

  .md\\:space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(10rem * var(--space-x-reverse));
    margin-left: calc(10rem * (1 - var(--space-x-reverse)));
    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-42 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(10.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(10.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(10.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-42 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(10.5rem * var(--space-x-reverse));
    margin-left: calc(10.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(10.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-44 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(11rem * (1 - var(--space-y-reverse)));
    margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(11rem * var(--space-y-reverse));
  }

  .md\\:space-x-44 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(11rem * var(--space-x-reverse));
    margin-left: calc(11rem * (1 - var(--space-x-reverse)));
    margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(12rem * (1 - var(--space-y-reverse)));
    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(12rem * var(--space-y-reverse));
  }

  .md\\:space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(12rem * var(--space-x-reverse));
    margin-left: calc(12rem * (1 - var(--space-x-reverse)));
    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-52 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(13rem * (1 - var(--space-y-reverse)));
    margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(13rem * var(--space-y-reverse));
  }

  .md\\:space-x-52 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(13rem * var(--space-x-reverse));
    margin-left: calc(13rem * (1 - var(--space-x-reverse)));
    margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-54 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(13.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(13.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(13.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-54 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(13.5rem * var(--space-x-reverse));
    margin-left: calc(13.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(13.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(14rem * (1 - var(--space-y-reverse)));
    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(14rem * var(--space-y-reverse));
  }

  .md\\:space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(14rem * var(--space-x-reverse));
    margin-left: calc(14rem * (1 - var(--space-x-reverse)));
    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-60 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(15rem * (1 - var(--space-y-reverse)));
    margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(15rem * var(--space-y-reverse));
  }

  .md\\:space-x-60 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(15rem * var(--space-x-reverse));
    margin-left: calc(15rem * (1 - var(--space-x-reverse)));
    margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(16rem * (1 - var(--space-y-reverse)));
    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16rem * var(--space-y-reverse));
  }

  .md\\:space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(16rem * var(--space-x-reverse));
    margin-left: calc(16rem * (1 - var(--space-x-reverse)));
    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-68 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(17rem * (1 - var(--space-y-reverse)));
    margin-top: calc(17rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(17rem * var(--space-y-reverse));
  }

  .md\\:space-x-68 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(17rem * var(--space-x-reverse));
    margin-left: calc(17rem * (1 - var(--space-x-reverse)));
    margin-left: calc(17rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-72 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(18rem * (1 - var(--space-y-reverse)));
    margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(18rem * var(--space-y-reverse));
  }

  .md\\:space-x-72 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(18rem * var(--space-x-reverse));
    margin-left: calc(18rem * (1 - var(--space-x-reverse)));
    margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-74 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(18.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(18.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(18.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-74 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(18.5rem * var(--space-x-reverse));
    margin-left: calc(18.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(18.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-76 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(19rem * (1 - var(--space-y-reverse)));
    margin-top: calc(19rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(19rem * var(--space-y-reverse));
  }

  .md\\:space-x-76 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(19rem * var(--space-x-reverse));
    margin-left: calc(19rem * (1 - var(--space-x-reverse)));
    margin-left: calc(19rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-78 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(19.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(19.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(19.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-78 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(19.5rem * var(--space-x-reverse));
    margin-left: calc(19.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(19.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-80 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(20rem * (1 - var(--space-y-reverse)));
    margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20rem * var(--space-y-reverse));
  }

  .md\\:space-x-80 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(20rem * var(--space-x-reverse));
    margin-left: calc(20rem * (1 - var(--space-x-reverse)));
    margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-82 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(20.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(20.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-82 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(20.5rem * var(--space-x-reverse));
    margin-left: calc(20.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(20.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-84 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(21rem * (1 - var(--space-y-reverse)));
    margin-top: calc(21rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(21rem * var(--space-y-reverse));
  }

  .md\\:space-x-84 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(21rem * var(--space-x-reverse));
    margin-left: calc(21rem * (1 - var(--space-x-reverse)));
    margin-left: calc(21rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-88 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(22rem * (1 - var(--space-y-reverse)));
    margin-top: calc(22rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(22rem * var(--space-y-reverse));
  }

  .md\\:space-x-88 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(22rem * var(--space-x-reverse));
    margin-left: calc(22rem * (1 - var(--space-x-reverse)));
    margin-left: calc(22rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-92 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(23rem * (1 - var(--space-y-reverse)));
    margin-top: calc(23rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(23rem * var(--space-y-reverse));
  }

  .md\\:space-x-92 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(23rem * var(--space-x-reverse));
    margin-left: calc(23rem * (1 - var(--space-x-reverse)));
    margin-left: calc(23rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-96 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(24rem * (1 - var(--space-y-reverse)));
    margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(24rem * var(--space-y-reverse));
  }

  .md\\:space-x-96 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(24rem * var(--space-x-reverse));
    margin-left: calc(24rem * (1 - var(--space-x-reverse)));
    margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-98 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(24.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(24.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(24.5rem * var(--space-y-reverse));
  }

  .md\\:space-x-98 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(24.5rem * var(--space-x-reverse));
    margin-left: calc(24.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(24.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-100 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(25rem * var(--space-y-reverse));
  }

  .md\\:space-x-100 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(25rem * var(--space-x-reverse));
    margin-left: calc(25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(25rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-104 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(26rem * (1 - var(--space-y-reverse)));
    margin-top: calc(26rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(26rem * var(--space-y-reverse));
  }

  .md\\:space-x-104 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(26rem * var(--space-x-reverse));
    margin-left: calc(26rem * (1 - var(--space-x-reverse)));
    margin-left: calc(26rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-112 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(28rem * (1 - var(--space-y-reverse)));
    margin-top: calc(28rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(28rem * var(--space-y-reverse));
  }

  .md\\:space-x-112 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(28rem * var(--space-x-reverse));
    margin-left: calc(28rem * (1 - var(--space-x-reverse)));
    margin-left: calc(28rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-124 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(31rem * (1 - var(--space-y-reverse)));
    margin-top: calc(31rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(31rem * var(--space-y-reverse));
  }

  .md\\:space-x-124 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(31rem * var(--space-x-reverse));
    margin-left: calc(31rem * (1 - var(--space-x-reverse)));
    margin-left: calc(31rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-128 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(32rem * (1 - var(--space-y-reverse)));
    margin-top: calc(32rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(32rem * var(--space-y-reverse));
  }

  .md\\:space-x-128 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(32rem * var(--space-x-reverse));
    margin-left: calc(32rem * (1 - var(--space-x-reverse)));
    margin-left: calc(32rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-140 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(35rem * (1 - var(--space-y-reverse)));
    margin-top: calc(35rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(35rem * var(--space-y-reverse));
  }

  .md\\:space-x-140 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(35rem * var(--space-x-reverse));
    margin-left: calc(35rem * (1 - var(--space-x-reverse)));
    margin-left: calc(35rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-152 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(38rem * (1 - var(--space-y-reverse)));
    margin-top: calc(38rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(38rem * var(--space-y-reverse));
  }

  .md\\:space-x-152 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(38rem * var(--space-x-reverse));
    margin-left: calc(38rem * (1 - var(--space-x-reverse)));
    margin-left: calc(38rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-160 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(40rem * (1 - var(--space-y-reverse)));
    margin-top: calc(40rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(40rem * var(--space-y-reverse));
  }

  .md\\:space-x-160 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(40rem * var(--space-x-reverse));
    margin-left: calc(40rem * (1 - var(--space-x-reverse)));
    margin-left: calc(40rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-162 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(41rem * (1 - var(--space-y-reverse)));
    margin-top: calc(41rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(41rem * var(--space-y-reverse));
  }

  .md\\:space-x-162 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(41rem * var(--space-x-reverse));
    margin-left: calc(41rem * (1 - var(--space-x-reverse)));
    margin-left: calc(41rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-192 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(48rem * (1 - var(--space-y-reverse)));
    margin-top: calc(48rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(48rem * var(--space-y-reverse));
  }

  .md\\:space-x-192 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(48rem * var(--space-x-reverse));
    margin-left: calc(48rem * (1 - var(--space-x-reverse)));
    margin-left: calc(48rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-208 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(52rem * (1 - var(--space-y-reverse)));
    margin-top: calc(52rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(52rem * var(--space-y-reverse));
  }

  .md\\:space-x-208 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(52rem * var(--space-x-reverse));
    margin-left: calc(52rem * (1 - var(--space-x-reverse)));
    margin-left: calc(52rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-224 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(56rem * (1 - var(--space-y-reverse)));
    margin-top: calc(56rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(56rem * var(--space-y-reverse));
  }

  .md\\:space-x-224 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(56rem * var(--space-x-reverse));
    margin-left: calc(56rem * (1 - var(--space-x-reverse)));
    margin-left: calc(56rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-256 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(64rem * (1 - var(--space-y-reverse)));
    margin-top: calc(64rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(64rem * var(--space-y-reverse));
  }

  .md\\:space-x-256 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(64rem * var(--space-x-reverse));
    margin-left: calc(64rem * (1 - var(--space-x-reverse)));
    margin-left: calc(64rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1px * (1 - var(--space-y-reverse)));
    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1px * var(--space-y-reverse));
  }

  .md\\:space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1px * var(--space-x-reverse));
    margin-left: calc(1px * (1 - var(--space-x-reverse)));
    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.25rem * var(--space-y-reverse));
  }

  .md\\:-space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.25rem * var(--space-x-reverse));
    margin-left: calc(-0.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.5rem * var(--space-x-reverse));
    margin-left: calc(-0.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.75rem * var(--space-y-reverse));
  }

  .md\\:-space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.75rem * var(--space-x-reverse));
    margin-left: calc(-0.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1rem * var(--space-y-reverse));
  }

  .md\\:-space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1rem * var(--space-x-reverse));
    margin-left: calc(-1rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.25rem * var(--space-y-reverse));
  }

  .md\\:-space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.25rem * var(--space-x-reverse));
    margin-left: calc(-1.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.5rem * var(--space-x-reverse));
    margin-left: calc(-1.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-7 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.75rem * var(--space-y-reverse));
  }

  .md\\:-space-x-7 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.75rem * var(--space-x-reverse));
    margin-left: calc(-1.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2rem * var(--space-y-reverse));
  }

  .md\\:-space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2rem * var(--space-x-reverse));
    margin-left: calc(-2rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-9 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.25rem * var(--space-y-reverse));
  }

  .md\\:-space-x-9 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.25rem * var(--space-x-reverse));
    margin-left: calc(-2.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.5rem * var(--space-x-reverse));
    margin-left: calc(-2.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-11 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.75rem * var(--space-y-reverse));
  }

  .md\\:-space-x-11 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.75rem * var(--space-x-reverse));
    margin-left: calc(-2.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3rem * var(--space-y-reverse));
  }

  .md\\:-space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3rem * var(--space-x-reverse));
    margin-left: calc(-3rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-14 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-14 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3.5rem * var(--space-x-reverse));
    margin-left: calc(-3.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-15 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.75rem * var(--space-y-reverse));
  }

  .md\\:-space-x-15 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3.75rem * var(--space-x-reverse));
    margin-left: calc(-3.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-4rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-4rem * var(--space-y-reverse));
  }

  .md\\:-space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-4rem * var(--space-x-reverse));
    margin-left: calc(-4rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-18 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-4.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-4.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-4.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-18 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-4.5rem * var(--space-x-reverse));
    margin-left: calc(-4.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-4.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5rem * var(--space-x-reverse));
    margin-left: calc(-5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-22 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-22 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5.5rem * var(--space-x-reverse));
    margin-left: calc(-5.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-23 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5.75rem * var(--space-y-reverse));
  }

  .md\\:-space-x-23 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5.75rem * var(--space-x-reverse));
    margin-left: calc(-5.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5.75rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6rem * var(--space-y-reverse));
  }

  .md\\:-space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6rem * var(--space-x-reverse));
    margin-left: calc(-6rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-25 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6.25rem * var(--space-y-reverse));
  }

  .md\\:-space-x-25 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6.25rem * var(--space-x-reverse));
    margin-left: calc(-6.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6.25rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-26 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-26 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6.5rem * var(--space-x-reverse));
    margin-left: calc(-6.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-28 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-7rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-7rem * var(--space-y-reverse));
  }

  .md\\:-space-x-28 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-7rem * var(--space-x-reverse));
    margin-left: calc(-7rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-30 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-7.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-7.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-7.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-30 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-7.5rem * var(--space-x-reverse));
    margin-left: calc(-7.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-7.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-8rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8rem * var(--space-y-reverse));
  }

  .md\\:-space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-8rem * var(--space-x-reverse));
    margin-left: calc(-8rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-34 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-8.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-8.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-34 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-8.5rem * var(--space-x-reverse));
    margin-left: calc(-8.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-8.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-10rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-10rem * var(--space-y-reverse));
  }

  .md\\:-space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-10rem * var(--space-x-reverse));
    margin-left: calc(-10rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-42 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-10.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-10.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-10.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-42 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-10.5rem * var(--space-x-reverse));
    margin-left: calc(-10.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-10.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-44 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-11rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-11rem * var(--space-y-reverse));
  }

  .md\\:-space-x-44 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-11rem * var(--space-x-reverse));
    margin-left: calc(-11rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-12rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-12rem * var(--space-y-reverse));
  }

  .md\\:-space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-12rem * var(--space-x-reverse));
    margin-left: calc(-12rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-52 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-13rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-13rem * var(--space-y-reverse));
  }

  .md\\:-space-x-52 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-13rem * var(--space-x-reverse));
    margin-left: calc(-13rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-54 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-13.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-13.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-13.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-54 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-13.5rem * var(--space-x-reverse));
    margin-left: calc(-13.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-13.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-14rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-14rem * var(--space-y-reverse));
  }

  .md\\:-space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-14rem * var(--space-x-reverse));
    margin-left: calc(-14rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-60 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-15rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-15rem * var(--space-y-reverse));
  }

  .md\\:-space-x-60 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-15rem * var(--space-x-reverse));
    margin-left: calc(-15rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-16rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16rem * var(--space-y-reverse));
  }

  .md\\:-space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-16rem * var(--space-x-reverse));
    margin-left: calc(-16rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-68 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-17rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-17rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-17rem * var(--space-y-reverse));
  }

  .md\\:-space-x-68 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-17rem * var(--space-x-reverse));
    margin-left: calc(-17rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-17rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-72 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-18rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-18rem * var(--space-y-reverse));
  }

  .md\\:-space-x-72 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-18rem * var(--space-x-reverse));
    margin-left: calc(-18rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-74 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-18.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-18.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-18.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-74 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-18.5rem * var(--space-x-reverse));
    margin-left: calc(-18.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-18.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-76 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-19rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-19rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-19rem * var(--space-y-reverse));
  }

  .md\\:-space-x-76 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-19rem * var(--space-x-reverse));
    margin-left: calc(-19rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-19rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-78 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-19.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-19.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-19.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-78 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-19.5rem * var(--space-x-reverse));
    margin-left: calc(-19.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-19.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-80 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-20rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20rem * var(--space-y-reverse));
  }

  .md\\:-space-x-80 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-20rem * var(--space-x-reverse));
    margin-left: calc(-20rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-82 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-20.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-20.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-82 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-20.5rem * var(--space-x-reverse));
    margin-left: calc(-20.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-20.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-84 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-21rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-21rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-21rem * var(--space-y-reverse));
  }

  .md\\:-space-x-84 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-21rem * var(--space-x-reverse));
    margin-left: calc(-21rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-21rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-88 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-22rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-22rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-22rem * var(--space-y-reverse));
  }

  .md\\:-space-x-88 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-22rem * var(--space-x-reverse));
    margin-left: calc(-22rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-22rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-92 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-23rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-23rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-23rem * var(--space-y-reverse));
  }

  .md\\:-space-x-92 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-23rem * var(--space-x-reverse));
    margin-left: calc(-23rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-23rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-96 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-24rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-24rem * var(--space-y-reverse));
  }

  .md\\:-space-x-96 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-24rem * var(--space-x-reverse));
    margin-left: calc(-24rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-98 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-24.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-24.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-24.5rem * var(--space-y-reverse));
  }

  .md\\:-space-x-98 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-24.5rem * var(--space-x-reverse));
    margin-left: calc(-24.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-24.5rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-100 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-25rem * var(--space-y-reverse));
  }

  .md\\:-space-x-100 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-25rem * var(--space-x-reverse));
    margin-left: calc(-25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-25rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-104 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-26rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-26rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-26rem * var(--space-y-reverse));
  }

  .md\\:-space-x-104 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-26rem * var(--space-x-reverse));
    margin-left: calc(-26rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-26rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-112 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-28rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-28rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-28rem * var(--space-y-reverse));
  }

  .md\\:-space-x-112 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-28rem * var(--space-x-reverse));
    margin-left: calc(-28rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-28rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-124 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-31rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-31rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-31rem * var(--space-y-reverse));
  }

  .md\\:-space-x-124 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-31rem * var(--space-x-reverse));
    margin-left: calc(-31rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-31rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-128 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-32rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-32rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-32rem * var(--space-y-reverse));
  }

  .md\\:-space-x-128 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-32rem * var(--space-x-reverse));
    margin-left: calc(-32rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-32rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-140 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-35rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-35rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-35rem * var(--space-y-reverse));
  }

  .md\\:-space-x-140 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-35rem * var(--space-x-reverse));
    margin-left: calc(-35rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-35rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-152 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-38rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-38rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-38rem * var(--space-y-reverse));
  }

  .md\\:-space-x-152 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-38rem * var(--space-x-reverse));
    margin-left: calc(-38rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-38rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-160 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-40rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-40rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-40rem * var(--space-y-reverse));
  }

  .md\\:-space-x-160 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-40rem * var(--space-x-reverse));
    margin-left: calc(-40rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-40rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-162 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-41rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-41rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-41rem * var(--space-y-reverse));
  }

  .md\\:-space-x-162 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-41rem * var(--space-x-reverse));
    margin-left: calc(-41rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-41rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-192 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-48rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-48rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-48rem * var(--space-y-reverse));
  }

  .md\\:-space-x-192 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-48rem * var(--space-x-reverse));
    margin-left: calc(-48rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-48rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-208 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-52rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-52rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-52rem * var(--space-y-reverse));
  }

  .md\\:-space-x-208 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-52rem * var(--space-x-reverse));
    margin-left: calc(-52rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-52rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-224 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-56rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-56rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-56rem * var(--space-y-reverse));
  }

  .md\\:-space-x-224 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-56rem * var(--space-x-reverse));
    margin-left: calc(-56rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-56rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-256 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-64rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-64rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-64rem * var(--space-y-reverse));
  }

  .md\\:-space-x-256 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-64rem * var(--space-x-reverse));
    margin-left: calc(-64rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-64rem * calc(1 - var(--space-x-reverse)));
  }

  .md\\:-space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1px * (1 - var(--space-y-reverse)));
    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1px * var(--space-y-reverse));
  }

  .md\\:-space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1px * var(--space-x-reverse));
    margin-left: calc(-1px * (1 - var(--space-x-reverse)));
    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));
  }

  .md\\:space-y-reverse > :not(template) ~ :not(template){
    --space-y-reverse: 1;
  }

  .md\\:space-x-reverse > :not(template) ~ :not(template){
    --space-x-reverse: 1;
  }

  .md\\:divide-y-0 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(0px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(0px * var(--divide-y-reverse));
  }

  .md\\:divide-x-0 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(0px * var(--divide-x-reverse));
    border-left-width: calc(0px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));
  }

  .md\\:divide-y-2 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(2px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(2px * var(--divide-y-reverse));
  }

  .md\\:divide-x-2 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(2px * var(--divide-x-reverse));
    border-left-width: calc(2px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));
  }

  .md\\:divide-y-3 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(3px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(3px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(3px * var(--divide-y-reverse));
  }

  .md\\:divide-x-3 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(3px * var(--divide-x-reverse));
    border-left-width: calc(3px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(3px * calc(1 - var(--divide-x-reverse)));
  }

  .md\\:divide-y-4 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(4px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(4px * var(--divide-y-reverse));
  }

  .md\\:divide-x-4 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(4px * var(--divide-x-reverse));
    border-left-width: calc(4px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));
  }

  .md\\:divide-y-5 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(5px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(5px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(5px * var(--divide-y-reverse));
  }

  .md\\:divide-x-5 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(5px * var(--divide-x-reverse));
    border-left-width: calc(5px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(5px * calc(1 - var(--divide-x-reverse)));
  }

  .md\\:divide-y-6 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(6px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(6px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(6px * var(--divide-y-reverse));
  }

  .md\\:divide-x-6 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(6px * var(--divide-x-reverse));
    border-left-width: calc(6px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(6px * calc(1 - var(--divide-x-reverse)));
  }

  .md\\:divide-y-8 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(8px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(8px * var(--divide-y-reverse));
  }

  .md\\:divide-x-8 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(8px * var(--divide-x-reverse));
    border-left-width: calc(8px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));
  }

  .md\\:divide-y > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(1px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(1px * var(--divide-y-reverse));
  }

  .md\\:divide-x > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(1px * var(--divide-x-reverse));
    border-left-width: calc(1px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));
  }

  .md\\:divide-y-reverse > :not(template) ~ :not(template){
    --divide-y-reverse: 1;
  }

  .md\\:divide-x-reverse > :not(template) ~ :not(template){
    --divide-x-reverse: 1;
  }

  .md\\:divide-transparent > :not(template) ~ :not(template){
    border-color: transparent;
  }

  .md\\:divide-focus > :not(template) ~ :not(template){
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .md\\:divide-black > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--divide-opacity));
  }

  .md\\:divide-white > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--divide-opacity));
  }

  .md\\:divide-primary > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--divide-opacity));
  }

  .md\\:divide-disabled > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--divide-opacity));
  }

  .md\\:divide-translucent-60 > :not(template) ~ :not(template){
    border-color: rgba(256, 256, 256, 0.6);
  }

  .md\\:divide-translucent-90 > :not(template) ~ :not(template){
    border-color: rgba(256, 256, 256, 0.9);
  }

  .md\\:divide-green-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--divide-opacity));
  }

  .md\\:divide-green-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--divide-opacity));
  }

  .md\\:divide-green-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--divide-opacity));
  }

  .md\\:divide-green-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--divide-opacity));
  }

  .md\\:divide-green-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--divide-opacity));
  }

  .md\\:divide-green-400a50 > :not(template) ~ :not(template){
    border-color: rgba(108,202,152,0.50196);
  }

  .md\\:divide-green-500a25 > :not(template) ~ :not(template){
    border-color: rgba(151,232,18,0.09804);
  }

  .md\\:divide-yellow-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--divide-opacity));
  }

  .md\\:divide-yellow-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--divide-opacity));
  }

  .md\\:divide-yellow-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--divide-opacity));
  }

  .md\\:divide-yellow-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--divide-opacity));
  }

  .md\\:divide-yellow-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--divide-opacity));
  }

  .md\\:divide-yellow-300a66 > :not(template) ~ :not(template){
    border-color: rgba(255,233,189,0.66667);
  }

  .md\\:divide-yellow-500a25 > :not(template) ~ :not(template){
    border-color: rgba(255,200,44,0.09804);
  }

  .md\\:divide-orange-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--divide-opacity));
  }

  .md\\:divide-orange-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--divide-opacity));
  }

  .md\\:divide-orange-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--divide-opacity));
  }

  .md\\:divide-orange-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--divide-opacity));
  }

  .md\\:divide-orange-900 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--divide-opacity));
  }

  .md\\:divide-orange-500a25 > :not(template) ~ :not(template){
    border-color: rgba(240,115,23,0.09804);
  }

  .md\\:divide-red-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--divide-opacity));
  }

  .md\\:divide-red-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--divide-opacity));
  }

  .md\\:divide-red-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--divide-opacity));
  }

  .md\\:divide-red-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--divide-opacity));
  }

  .md\\:divide-red-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--divide-opacity));
  }

  .md\\:divide-red-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--divide-opacity));
  }

  .md\\:divide-red-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--divide-opacity));
  }

  .md\\:divide-gray-50 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--divide-opacity));
  }

  .md\\:divide-gray-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--divide-opacity));
  }

  .md\\:divide-gray-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--divide-opacity));
  }

  .md\\:divide-gray-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--divide-opacity));
  }

  .md\\:divide-gray-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--divide-opacity));
  }

  .md\\:divide-gray-400 > :not(template) ~ :not(template){
    border-color: rgba(114,114,114,0.8);
  }

  .md\\:divide-gray-425 > :not(template) ~ :not(template){
    border-color: rgba(4, 21, 39, 0.8);
  }

  .md\\:divide-gray-450 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--divide-opacity));
  }

  .md\\:divide-gray-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--divide-opacity));
  }

  .md\\:divide-gray-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--divide-opacity));
  }

  .md\\:divide-gray-625 > :not(template) ~ :not(template){
    border-color: rgba(90,98,107,0.8);
  }

  .md\\:divide-gray-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--divide-opacity));
  }

  .md\\:divide-gray-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--divide-opacity));
  }

  .md\\:divide-gray-200a50 > :not(template) ~ :not(template){
    border-color: rgba(224, 226, 228, 0.5);
  }

  .md\\:divide-blue-50 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--divide-opacity));
  }

  .md\\:divide-blue-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--divide-opacity));
  }

  .md\\:divide-blue-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--divide-opacity));
  }

  .md\\:divide-blue-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--divide-opacity));
  }

  .md\\:divide-blue-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--divide-opacity));
  }

  .md\\:divide-blue-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--divide-opacity));
  }

  .md\\:divide-blue-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--divide-opacity));
  }

  .md\\:divide-blue-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--divide-opacity));
  }

  .md\\:divide-blue-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--divide-opacity));
  }

  .md\\:divide-blue-750 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--divide-opacity));
  }

  .md\\:divide-blue-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--divide-opacity));
  }

  .md\\:divide-blue-900 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--divide-opacity));
  }

  .md\\:divide-blue-950 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--divide-opacity));
  }

  .md\\:divide-blue-500a25 > :not(template) ~ :not(template){
    border-color: rgba(55, 164, 220, 0.2);
  }

  .md\\:divide-blue-500a50 > :not(template) ~ :not(template){
    border-color: rgba(55, 164, 220, 0.5);
  }

  .md\\:divide-blue-700a75 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--divide-opacity));
  }

  .md\\:divide-blue-700a30 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--divide-opacity));
  }

  .md\\:divide-blue-750a25 > :not(template) ~ :not(template){
    border-color: rgba(86,130,170,0.09804);
  }

  .md\\:divide-blue-750a15 > :not(template) ~ :not(template){
    border-color: rgba(86,130,170,0.05882);
  }

  .md\\:divide-blue-800a60 > :not(template) ~ :not(template){
    border-color: rgba(31, 69, 102, 0.6);
  }

  .md\\:divide-programEditorTabColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--divide-opacity));
  }

  .md\\:divide-programEditorTabColors-2 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--divide-opacity));
  }

  .md\\:divide-programEditorTabColors-3 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--divide-opacity));
  }

  .md\\:divide-programEditorTabColors-4 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--divide-opacity));
  }

  .md\\:divide-programEditorTabColors-5 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--divide-opacity));
  }

  .md\\:divide-programEditorTabColors-6 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--divide-opacity));
  }

  .md\\:divide-programEditorTabColors-1h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--divide-opacity));
  }

  .md\\:divide-programEditorTabColors-2h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--divide-opacity));
  }

  .md\\:divide-programEditorTabColors-3h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--divide-opacity));
  }

  .md\\:divide-programEditorTabColors-4h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--divide-opacity));
  }

  .md\\:divide-programEditorTabColors-5h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--divide-opacity));
  }

  .md\\:divide-programEditorTabColors-6h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--divide-opacity));
  }

  .md\\:divide-programEditorPresetTabColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--divide-opacity));
  }

  .md\\:divide-programEditorPresetTabColors-1h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--divide-opacity));
  }

  .md\\:divide-borgScaleColors-0 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--divide-opacity));
  }

  .md\\:divide-borgScaleColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--divide-opacity));
  }

  .md\\:divide-borgScaleColors-2 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--divide-opacity));
  }

  .md\\:divide-borgScaleColors-3 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--divide-opacity));
  }

  .md\\:divide-borgScaleColors-4 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--divide-opacity));
  }

  .md\\:divide-borgScaleColors-5 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--divide-opacity));
  }

  .md\\:divide-borgScaleColors-6 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--divide-opacity));
  }

  .md\\:divide-borgScaleColors-7 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--divide-opacity));
  }

  .md\\:divide-borgScaleColors-8 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--divide-opacity));
  }

  .md\\:divide-borgScaleColors-9 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--divide-opacity));
  }

  .md\\:divide-borgScaleColors-10 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--divide-opacity));
  }

  .md\\:divide-solid > :not(template) ~ :not(template){
    border-style: solid;
  }

  .md\\:divide-dashed > :not(template) ~ :not(template){
    border-style: dashed;
  }

  .md\\:divide-dotted > :not(template) ~ :not(template){
    border-style: dotted;
  }

  .md\\:divide-double > :not(template) ~ :not(template){
    border-style: double;
  }

  .md\\:divide-none > :not(template) ~ :not(template){
    border-style: none;
  }

  .md\\:divide-opacity-0 > :not(template) ~ :not(template){
    --divide-opacity: 0;
  }

  .md\\:divide-opacity-25 > :not(template) ~ :not(template){
    --divide-opacity: .25;
  }

  .md\\:divide-opacity-50 > :not(template) ~ :not(template){
    --divide-opacity: .5;
  }

  .md\\:divide-opacity-75 > :not(template) ~ :not(template){
    --divide-opacity: .75;
  }

  .md\\:divide-opacity-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
  }

  .md\\:sr-only{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .md\\:not-sr-only{
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .md\\:focus\\:sr-only:focus{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .md\\:focus\\:not-sr-only:focus{
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .md\\:appearance-none{
    -webkit-appearance: none;
            appearance: none;
  }

  .md\\:bg-fixed{
    background-attachment: fixed;
  }

  .md\\:bg-local{
    background-attachment: local;
  }

  .md\\:bg-scroll{
    background-attachment: scroll;
  }

  .md\\:bg-clip-border{
    background-clip: border-box;
  }

  .md\\:bg-clip-padding{
    background-clip: padding-box;
  }

  .md\\:bg-clip-content{
    background-clip: content-box;
  }

  .md\\:bg-clip-text{
    -webkit-background-clip: text;
            background-clip: text;
  }

  .md\\:bg-transparent{
    background-color: transparent;
  }

  .md\\:bg-focus{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .md\\:bg-black{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .md\\:bg-white{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .md\\:bg-primary{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .md\\:bg-disabled{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .md\\:bg-translucent-60{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .md\\:bg-translucent-90{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .md\\:bg-green-200{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .md\\:bg-green-400{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .md\\:bg-green-500{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .md\\:bg-green-600{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .md\\:bg-green-700{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .md\\:bg-green-400a50{
    background-color: rgba(108,202,152,0.50196);
  }

  .md\\:bg-green-500a25{
    background-color: rgba(151,232,18,0.09804);
  }

  .md\\:bg-yellow-200{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .md\\:bg-yellow-300{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .md\\:bg-yellow-500{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .md\\:bg-yellow-600{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .md\\:bg-yellow-700{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .md\\:bg-yellow-300a66{
    background-color: rgba(255,233,189,0.66667);
  }

  .md\\:bg-yellow-500a25{
    background-color: rgba(255,200,44,0.09804);
  }

  .md\\:bg-orange-200{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .md\\:bg-orange-400{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .md\\:bg-orange-500{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .md\\:bg-orange-800{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .md\\:bg-orange-900{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .md\\:bg-orange-500a25{
    background-color: rgba(240,115,23,0.09804);
  }

  .md\\:bg-red-100{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .md\\:bg-red-150{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .md\\:bg-red-200{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .md\\:bg-red-300{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .md\\:bg-red-400{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .md\\:bg-red-500{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .md\\:bg-red-700{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .md\\:bg-gray-50{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .md\\:bg-gray-100{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .md\\:bg-gray-150{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .md\\:bg-gray-200{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .md\\:bg-gray-300{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .md\\:bg-gray-400{
    background-color: rgba(114,114,114,0.8);
  }

  .md\\:bg-gray-425{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .md\\:bg-gray-450{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .md\\:bg-gray-500{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .md\\:bg-gray-600{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .md\\:bg-gray-625{
    background-color: rgba(90,98,107,0.8);
  }

  .md\\:bg-gray-700{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .md\\:bg-gray-800{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .md\\:bg-gray-200a50{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .md\\:bg-blue-50{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .md\\:bg-blue-100{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .md\\:bg-blue-150{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .md\\:bg-blue-200{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .md\\:bg-blue-300{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .md\\:bg-blue-400{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .md\\:bg-blue-500{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .md\\:bg-blue-600{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .md\\:bg-blue-700{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .md\\:bg-blue-750{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .md\\:bg-blue-800{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .md\\:bg-blue-900{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .md\\:bg-blue-950{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .md\\:bg-blue-500a25{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .md\\:bg-blue-500a50{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .md\\:bg-blue-700a75{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .md\\:bg-blue-700a30{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .md\\:bg-blue-750a25{
    background-color: rgba(86,130,170,0.09804);
  }

  .md\\:bg-blue-750a15{
    background-color: rgba(86,130,170,0.05882);
  }

  .md\\:bg-blue-800a60{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .md\\:bg-programEditorTabColors-1{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .md\\:bg-programEditorTabColors-2{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .md\\:bg-programEditorTabColors-3{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .md\\:bg-programEditorTabColors-4{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .md\\:bg-programEditorTabColors-5{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .md\\:bg-programEditorTabColors-6{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .md\\:bg-programEditorTabColors-1h{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .md\\:bg-programEditorTabColors-2h{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .md\\:bg-programEditorTabColors-3h{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .md\\:bg-programEditorTabColors-4h{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .md\\:bg-programEditorTabColors-5h{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .md\\:bg-programEditorTabColors-6h{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .md\\:bg-programEditorPresetTabColors-1{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .md\\:bg-programEditorPresetTabColors-1h{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .md\\:bg-borgScaleColors-0{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .md\\:bg-borgScaleColors-1{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .md\\:bg-borgScaleColors-2{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .md\\:bg-borgScaleColors-3{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .md\\:bg-borgScaleColors-4{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .md\\:bg-borgScaleColors-5{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .md\\:bg-borgScaleColors-6{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .md\\:bg-borgScaleColors-7{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .md\\:bg-borgScaleColors-8{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .md\\:bg-borgScaleColors-9{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .md\\:bg-borgScaleColors-10{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .md\\:hover\\:bg-transparent:hover{
    background-color: transparent;
  }

  .md\\:hover\\:bg-focus:hover{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .md\\:hover\\:bg-black:hover{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .md\\:hover\\:bg-white:hover{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .md\\:hover\\:bg-primary:hover{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .md\\:hover\\:bg-disabled:hover{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .md\\:hover\\:bg-translucent-60:hover{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .md\\:hover\\:bg-translucent-90:hover{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .md\\:hover\\:bg-green-200:hover{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .md\\:hover\\:bg-green-400:hover{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .md\\:hover\\:bg-green-500:hover{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .md\\:hover\\:bg-green-600:hover{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .md\\:hover\\:bg-green-700:hover{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .md\\:hover\\:bg-green-400a50:hover{
    background-color: rgba(108,202,152,0.50196);
  }

  .md\\:hover\\:bg-green-500a25:hover{
    background-color: rgba(151,232,18,0.09804);
  }

  .md\\:hover\\:bg-yellow-200:hover{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .md\\:hover\\:bg-yellow-300:hover{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .md\\:hover\\:bg-yellow-500:hover{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .md\\:hover\\:bg-yellow-600:hover{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .md\\:hover\\:bg-yellow-700:hover{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .md\\:hover\\:bg-yellow-300a66:hover{
    background-color: rgba(255,233,189,0.66667);
  }

  .md\\:hover\\:bg-yellow-500a25:hover{
    background-color: rgba(255,200,44,0.09804);
  }

  .md\\:hover\\:bg-orange-200:hover{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .md\\:hover\\:bg-orange-400:hover{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .md\\:hover\\:bg-orange-500:hover{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .md\\:hover\\:bg-orange-800:hover{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .md\\:hover\\:bg-orange-900:hover{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .md\\:hover\\:bg-orange-500a25:hover{
    background-color: rgba(240,115,23,0.09804);
  }

  .md\\:hover\\:bg-red-100:hover{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .md\\:hover\\:bg-red-150:hover{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .md\\:hover\\:bg-red-200:hover{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .md\\:hover\\:bg-red-300:hover{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .md\\:hover\\:bg-red-400:hover{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .md\\:hover\\:bg-red-500:hover{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .md\\:hover\\:bg-red-700:hover{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-50:hover{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-100:hover{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-150:hover{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-200:hover{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-300:hover{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-400:hover{
    background-color: rgba(114,114,114,0.8);
  }

  .md\\:hover\\:bg-gray-425:hover{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .md\\:hover\\:bg-gray-450:hover{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-500:hover{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-600:hover{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-625:hover{
    background-color: rgba(90,98,107,0.8);
  }

  .md\\:hover\\:bg-gray-700:hover{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-800:hover{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .md\\:hover\\:bg-gray-200a50:hover{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .md\\:hover\\:bg-blue-50:hover{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-100:hover{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-150:hover{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-200:hover{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-300:hover{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-400:hover{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-500:hover{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-600:hover{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-700:hover{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-750:hover{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-800:hover{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-900:hover{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-950:hover{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-500a25:hover{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .md\\:hover\\:bg-blue-500a50:hover{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .md\\:hover\\:bg-blue-700a75:hover{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-700a30:hover{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .md\\:hover\\:bg-blue-750a25:hover{
    background-color: rgba(86,130,170,0.09804);
  }

  .md\\:hover\\:bg-blue-750a15:hover{
    background-color: rgba(86,130,170,0.05882);
  }

  .md\\:hover\\:bg-blue-800a60:hover{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .md\\:hover\\:bg-programEditorTabColors-1:hover{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .md\\:hover\\:bg-programEditorTabColors-2:hover{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .md\\:hover\\:bg-programEditorTabColors-3:hover{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .md\\:hover\\:bg-programEditorTabColors-4:hover{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .md\\:hover\\:bg-programEditorTabColors-5:hover{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .md\\:hover\\:bg-programEditorTabColors-6:hover{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .md\\:hover\\:bg-programEditorTabColors-1h:hover{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .md\\:hover\\:bg-programEditorTabColors-2h:hover{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .md\\:hover\\:bg-programEditorTabColors-3h:hover{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .md\\:hover\\:bg-programEditorTabColors-4h:hover{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .md\\:hover\\:bg-programEditorTabColors-5h:hover{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .md\\:hover\\:bg-programEditorTabColors-6h:hover{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .md\\:hover\\:bg-programEditorPresetTabColors-1:hover{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .md\\:hover\\:bg-programEditorPresetTabColors-1h:hover{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .md\\:hover\\:bg-borgScaleColors-0:hover{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .md\\:hover\\:bg-borgScaleColors-1:hover{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .md\\:hover\\:bg-borgScaleColors-2:hover{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .md\\:hover\\:bg-borgScaleColors-3:hover{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .md\\:hover\\:bg-borgScaleColors-4:hover{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .md\\:hover\\:bg-borgScaleColors-5:hover{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .md\\:hover\\:bg-borgScaleColors-6:hover{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .md\\:hover\\:bg-borgScaleColors-7:hover{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .md\\:hover\\:bg-borgScaleColors-8:hover{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .md\\:hover\\:bg-borgScaleColors-9:hover{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .md\\:hover\\:bg-borgScaleColors-10:hover{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .md\\:focus\\:bg-transparent:focus{
    background-color: transparent;
  }

  .md\\:focus\\:bg-focus:focus{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .md\\:focus\\:bg-black:focus{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .md\\:focus\\:bg-white:focus{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .md\\:focus\\:bg-primary:focus{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .md\\:focus\\:bg-disabled:focus{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .md\\:focus\\:bg-translucent-60:focus{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .md\\:focus\\:bg-translucent-90:focus{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .md\\:focus\\:bg-green-200:focus{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .md\\:focus\\:bg-green-400:focus{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .md\\:focus\\:bg-green-500:focus{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .md\\:focus\\:bg-green-600:focus{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .md\\:focus\\:bg-green-700:focus{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .md\\:focus\\:bg-green-400a50:focus{
    background-color: rgba(108,202,152,0.50196);
  }

  .md\\:focus\\:bg-green-500a25:focus{
    background-color: rgba(151,232,18,0.09804);
  }

  .md\\:focus\\:bg-yellow-200:focus{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .md\\:focus\\:bg-yellow-300:focus{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .md\\:focus\\:bg-yellow-500:focus{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .md\\:focus\\:bg-yellow-600:focus{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .md\\:focus\\:bg-yellow-700:focus{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .md\\:focus\\:bg-yellow-300a66:focus{
    background-color: rgba(255,233,189,0.66667);
  }

  .md\\:focus\\:bg-yellow-500a25:focus{
    background-color: rgba(255,200,44,0.09804);
  }

  .md\\:focus\\:bg-orange-200:focus{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .md\\:focus\\:bg-orange-400:focus{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .md\\:focus\\:bg-orange-500:focus{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .md\\:focus\\:bg-orange-800:focus{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .md\\:focus\\:bg-orange-900:focus{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .md\\:focus\\:bg-orange-500a25:focus{
    background-color: rgba(240,115,23,0.09804);
  }

  .md\\:focus\\:bg-red-100:focus{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .md\\:focus\\:bg-red-150:focus{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .md\\:focus\\:bg-red-200:focus{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .md\\:focus\\:bg-red-300:focus{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .md\\:focus\\:bg-red-400:focus{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .md\\:focus\\:bg-red-500:focus{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .md\\:focus\\:bg-red-700:focus{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-50:focus{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-100:focus{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-150:focus{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-200:focus{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-300:focus{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-400:focus{
    background-color: rgba(114,114,114,0.8);
  }

  .md\\:focus\\:bg-gray-425:focus{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .md\\:focus\\:bg-gray-450:focus{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-500:focus{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-600:focus{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-625:focus{
    background-color: rgba(90,98,107,0.8);
  }

  .md\\:focus\\:bg-gray-700:focus{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-800:focus{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .md\\:focus\\:bg-gray-200a50:focus{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .md\\:focus\\:bg-blue-50:focus{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-100:focus{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-150:focus{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-200:focus{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-300:focus{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-400:focus{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-500:focus{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-600:focus{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-700:focus{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-750:focus{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-800:focus{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-900:focus{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-950:focus{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-500a25:focus{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .md\\:focus\\:bg-blue-500a50:focus{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .md\\:focus\\:bg-blue-700a75:focus{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-700a30:focus{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .md\\:focus\\:bg-blue-750a25:focus{
    background-color: rgba(86,130,170,0.09804);
  }

  .md\\:focus\\:bg-blue-750a15:focus{
    background-color: rgba(86,130,170,0.05882);
  }

  .md\\:focus\\:bg-blue-800a60:focus{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .md\\:focus\\:bg-programEditorTabColors-1:focus{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .md\\:focus\\:bg-programEditorTabColors-2:focus{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .md\\:focus\\:bg-programEditorTabColors-3:focus{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .md\\:focus\\:bg-programEditorTabColors-4:focus{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .md\\:focus\\:bg-programEditorTabColors-5:focus{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .md\\:focus\\:bg-programEditorTabColors-6:focus{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .md\\:focus\\:bg-programEditorTabColors-1h:focus{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .md\\:focus\\:bg-programEditorTabColors-2h:focus{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .md\\:focus\\:bg-programEditorTabColors-3h:focus{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .md\\:focus\\:bg-programEditorTabColors-4h:focus{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .md\\:focus\\:bg-programEditorTabColors-5h:focus{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .md\\:focus\\:bg-programEditorTabColors-6h:focus{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .md\\:focus\\:bg-programEditorPresetTabColors-1:focus{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .md\\:focus\\:bg-programEditorPresetTabColors-1h:focus{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .md\\:focus\\:bg-borgScaleColors-0:focus{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .md\\:focus\\:bg-borgScaleColors-1:focus{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .md\\:focus\\:bg-borgScaleColors-2:focus{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .md\\:focus\\:bg-borgScaleColors-3:focus{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .md\\:focus\\:bg-borgScaleColors-4:focus{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .md\\:focus\\:bg-borgScaleColors-5:focus{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .md\\:focus\\:bg-borgScaleColors-6:focus{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .md\\:focus\\:bg-borgScaleColors-7:focus{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .md\\:focus\\:bg-borgScaleColors-8:focus{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .md\\:focus\\:bg-borgScaleColors-9:focus{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .md\\:focus\\:bg-borgScaleColors-10:focus{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .md\\:bg-none{
    background-image: none;
  }

  .md\\:bg-gradient-to-t{
    background-image: linear-gradient(to top, var(--gradient-color-stops));
  }

  .md\\:bg-gradient-to-tr{
    background-image: linear-gradient(to top right, var(--gradient-color-stops));
  }

  .md\\:bg-gradient-to-r{
    background-image: linear-gradient(to right, var(--gradient-color-stops));
  }

  .md\\:bg-gradient-to-br{
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
  }

  .md\\:bg-gradient-to-b{
    background-image: linear-gradient(to bottom, var(--gradient-color-stops));
  }

  .md\\:bg-gradient-to-bl{
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
  }

  .md\\:bg-gradient-to-l{
    background-image: linear-gradient(to left, var(--gradient-color-stops));
  }

  .md\\:bg-gradient-to-tl{
    background-image: linear-gradient(to top left, var(--gradient-color-stops));
  }

  .md\\:from-transparent{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:from-focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:from-black{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:from-white{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:from-primary{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:from-disabled{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .md\\:from-translucent-60{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:from-translucent-90{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:from-green-200{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .md\\:from-green-400{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .md\\:from-green-500{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .md\\:from-green-600{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .md\\:from-green-700{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .md\\:from-green-400a50{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .md\\:from-green-500a25{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .md\\:from-yellow-200{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .md\\:from-yellow-300{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .md\\:from-yellow-500{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .md\\:from-yellow-600{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .md\\:from-yellow-700{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .md\\:from-yellow-300a66{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .md\\:from-yellow-500a25{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .md\\:from-orange-200{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .md\\:from-orange-400{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .md\\:from-orange-500{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .md\\:from-orange-800{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .md\\:from-orange-900{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .md\\:from-orange-500a25{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .md\\:from-red-100{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .md\\:from-red-150{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .md\\:from-red-200{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .md\\:from-red-300{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .md\\:from-red-400{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .md\\:from-red-500{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .md\\:from-red-700{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .md\\:from-gray-50{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .md\\:from-gray-100{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .md\\:from-gray-150{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .md\\:from-gray-200{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .md\\:from-gray-300{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .md\\:from-gray-400{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .md\\:from-gray-425{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .md\\:from-gray-450{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .md\\:from-gray-500{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .md\\:from-gray-600{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .md\\:from-gray-625{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .md\\:from-gray-700{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .md\\:from-gray-800{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .md\\:from-gray-200a50{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .md\\:from-blue-50{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .md\\:from-blue-100{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .md\\:from-blue-150{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .md\\:from-blue-200{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .md\\:from-blue-300{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .md\\:from-blue-400{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .md\\:from-blue-500{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:from-blue-600{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .md\\:from-blue-700{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .md\\:from-blue-750{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:from-blue-800{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .md\\:from-blue-900{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .md\\:from-blue-950{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .md\\:from-blue-500a25{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:from-blue-500a50{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:from-blue-700a75{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .md\\:from-blue-700a30{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .md\\:from-blue-750a25{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:from-blue-750a15{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:from-blue-800a60{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .md\\:from-programEditorTabColors-1{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .md\\:from-programEditorTabColors-2{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .md\\:from-programEditorTabColors-3{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .md\\:from-programEditorTabColors-4{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .md\\:from-programEditorTabColors-5{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .md\\:from-programEditorTabColors-6{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .md\\:from-programEditorTabColors-1h{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .md\\:from-programEditorTabColors-2h{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .md\\:from-programEditorTabColors-3h{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .md\\:from-programEditorTabColors-4h{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .md\\:from-programEditorTabColors-5h{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .md\\:from-programEditorTabColors-6h{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .md\\:from-programEditorPresetTabColors-1{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .md\\:from-programEditorPresetTabColors-1h{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .md\\:from-borgScaleColors-0{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .md\\:from-borgScaleColors-1{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .md\\:from-borgScaleColors-2{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .md\\:from-borgScaleColors-3{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .md\\:from-borgScaleColors-4{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .md\\:from-borgScaleColors-5{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .md\\:from-borgScaleColors-6{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .md\\:from-borgScaleColors-7{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .md\\:from-borgScaleColors-8{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .md\\:from-borgScaleColors-9{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .md\\:from-borgScaleColors-10{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .md\\:via-transparent{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:via-focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:via-black{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:via-white{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:via-primary{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:via-disabled{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .md\\:via-translucent-60{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:via-translucent-90{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:via-green-200{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .md\\:via-green-400{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .md\\:via-green-500{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .md\\:via-green-600{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .md\\:via-green-700{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .md\\:via-green-400a50{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .md\\:via-green-500a25{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .md\\:via-yellow-200{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .md\\:via-yellow-300{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .md\\:via-yellow-500{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .md\\:via-yellow-600{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .md\\:via-yellow-700{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .md\\:via-yellow-300a66{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .md\\:via-yellow-500a25{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .md\\:via-orange-200{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .md\\:via-orange-400{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .md\\:via-orange-500{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .md\\:via-orange-800{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .md\\:via-orange-900{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .md\\:via-orange-500a25{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .md\\:via-red-100{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .md\\:via-red-150{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .md\\:via-red-200{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .md\\:via-red-300{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .md\\:via-red-400{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .md\\:via-red-500{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .md\\:via-red-700{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .md\\:via-gray-50{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .md\\:via-gray-100{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .md\\:via-gray-150{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .md\\:via-gray-200{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .md\\:via-gray-300{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .md\\:via-gray-400{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .md\\:via-gray-425{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .md\\:via-gray-450{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .md\\:via-gray-500{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .md\\:via-gray-600{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .md\\:via-gray-625{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .md\\:via-gray-700{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .md\\:via-gray-800{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .md\\:via-gray-200a50{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .md\\:via-blue-50{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .md\\:via-blue-100{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .md\\:via-blue-150{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .md\\:via-blue-200{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .md\\:via-blue-300{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .md\\:via-blue-400{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .md\\:via-blue-500{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:via-blue-600{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .md\\:via-blue-700{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .md\\:via-blue-750{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:via-blue-800{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .md\\:via-blue-900{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .md\\:via-blue-950{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .md\\:via-blue-500a25{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:via-blue-500a50{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:via-blue-700a75{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .md\\:via-blue-700a30{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .md\\:via-blue-750a25{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:via-blue-750a15{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:via-blue-800a60{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .md\\:via-programEditorTabColors-1{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .md\\:via-programEditorTabColors-2{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .md\\:via-programEditorTabColors-3{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .md\\:via-programEditorTabColors-4{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .md\\:via-programEditorTabColors-5{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .md\\:via-programEditorTabColors-6{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .md\\:via-programEditorTabColors-1h{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .md\\:via-programEditorTabColors-2h{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .md\\:via-programEditorTabColors-3h{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .md\\:via-programEditorTabColors-4h{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .md\\:via-programEditorTabColors-5h{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .md\\:via-programEditorTabColors-6h{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .md\\:via-programEditorPresetTabColors-1{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .md\\:via-programEditorPresetTabColors-1h{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .md\\:via-borgScaleColors-0{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .md\\:via-borgScaleColors-1{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .md\\:via-borgScaleColors-2{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .md\\:via-borgScaleColors-3{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .md\\:via-borgScaleColors-4{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .md\\:via-borgScaleColors-5{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .md\\:via-borgScaleColors-6{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .md\\:via-borgScaleColors-7{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .md\\:via-borgScaleColors-8{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .md\\:via-borgScaleColors-9{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .md\\:via-borgScaleColors-10{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .md\\:to-transparent{
    --gradient-to-color: transparent;
  }

  .md\\:to-focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .md\\:to-black{
    --gradient-to-color: #000;
  }

  .md\\:to-white{
    --gradient-to-color: #fff;
  }

  .md\\:to-primary{
    --gradient-to-color: #37A4DC;
  }

  .md\\:to-disabled{
    --gradient-to-color: #BFBFBF;
  }

  .md\\:to-translucent-60{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .md\\:to-translucent-90{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .md\\:to-green-200{
    --gradient-to-color: #f4fcea;
  }

  .md\\:to-green-400{
    --gradient-to-color: #6CCA98;
  }

  .md\\:to-green-500{
    --gradient-to-color: #97E812;
  }

  .md\\:to-green-600{
    --gradient-to-color: #4f9112;
  }

  .md\\:to-green-700{
    --gradient-to-color: #3e7211;
  }

  .md\\:to-green-400a50{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .md\\:to-green-500a25{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .md\\:to-yellow-200{
    --gradient-to-color: #fff9eb;
  }

  .md\\:to-yellow-300{
    --gradient-to-color: #ffe9bd;
  }

  .md\\:to-yellow-500{
    --gradient-to-color: #FFC82C;
  }

  .md\\:to-yellow-600{
    --gradient-to-color: #F7931E;
  }

  .md\\:to-yellow-700{
    --gradient-to-color: #E1AD28;
  }

  .md\\:to-yellow-300a66{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .md\\:to-yellow-500a25{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .md\\:to-orange-200{
    --gradient-to-color: #fdf0ea;
  }

  .md\\:to-orange-400{
    --gradient-to-color: #f6c66f;
  }

  .md\\:to-orange-500{
    --gradient-to-color: #F07313;
  }

  .md\\:to-orange-800{
    --gradient-to-color: #db5d0c;
  }

  .md\\:to-orange-900{
    --gradient-to-color: #b86814;
  }

  .md\\:to-orange-500a25{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .md\\:to-red-100{
    --gradient-to-color: #FEF5F5;
  }

  .md\\:to-red-150{
    --gradient-to-color: #ffe9e8;
  }

  .md\\:to-red-200{
    --gradient-to-color: #F8CECC;
  }

  .md\\:to-red-300{
    --gradient-to-color: #ff8585;
  }

  .md\\:to-red-400{
    --gradient-to-color: #ff3535;
  }

  .md\\:to-red-500{
    --gradient-to-color: #DD4746;
  }

  .md\\:to-red-700{
    --gradient-to-color: #A23C24;
  }

  .md\\:to-gray-50{
    --gradient-to-color: #F9F9F9;
  }

  .md\\:to-gray-100{
    --gradient-to-color: #F1F1F2;
  }

  .md\\:to-gray-150{
    --gradient-to-color: #e6e6e6;
  }

  .md\\:to-gray-200{
    --gradient-to-color: #E0E2E4;
  }

  .md\\:to-gray-300{
    --gradient-to-color: #BFBFBF;
  }

  .md\\:to-gray-400{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .md\\:to-gray-425{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .md\\:to-gray-450{
    --gradient-to-color: #959595;
  }

  .md\\:to-gray-500{
    --gradient-to-color: #727272;
  }

  .md\\:to-gray-600{
    --gradient-to-color: #5a626b;
  }

  .md\\:to-gray-625{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .md\\:to-gray-700{
    --gradient-to-color: #464C59;
  }

  .md\\:to-gray-800{
    --gradient-to-color: #3c3b3b;
  }

  .md\\:to-gray-200a50{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .md\\:to-blue-50{
    --gradient-to-color: #f2fbff;
  }

  .md\\:to-blue-100{
    --gradient-to-color: #EBF6FC;
  }

  .md\\:to-blue-150{
    --gradient-to-color: #E8EEF1;
  }

  .md\\:to-blue-200{
    --gradient-to-color: #CCE6F5;
  }

  .md\\:to-blue-300{
    --gradient-to-color: #73BFE7;
  }

  .md\\:to-blue-400{
    --gradient-to-color: #4BA4F7;
  }

  .md\\:to-blue-500{
    --gradient-to-color: #37A4DC;
  }

  .md\\:to-blue-600{
    --gradient-to-color: #6AA2D6;
  }

  .md\\:to-blue-700{
    --gradient-to-color: #456E9A;
  }

  .md\\:to-blue-750{
    --gradient-to-color: #5682AA;
  }

  .md\\:to-blue-800{
    --gradient-to-color: #1F4566;
  }

  .md\\:to-blue-900{
    --gradient-to-color: #183453;
  }

  .md\\:to-blue-950{
    --gradient-to-color: #041527;
  }

  .md\\:to-blue-500a25{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .md\\:to-blue-500a50{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .md\\:to-blue-700a75{
    --gradient-to-color: #3B648D;
  }

  .md\\:to-blue-700a30{
    --gradient-to-color: #2A5176;
  }

  .md\\:to-blue-750a25{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .md\\:to-blue-750a15{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .md\\:to-blue-800a60{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .md\\:to-programEditorTabColors-1{
    --gradient-to-color: #3cacae;
  }

  .md\\:to-programEditorTabColors-2{
    --gradient-to-color: #8e346a;
  }

  .md\\:to-programEditorTabColors-3{
    --gradient-to-color: #ff72b7;
  }

  .md\\:to-programEditorTabColors-4{
    --gradient-to-color: #ce941c;
  }

  .md\\:to-programEditorTabColors-5{
    --gradient-to-color: #b973d9;
  }

  .md\\:to-programEditorTabColors-6{
    --gradient-to-color: #ff9082;
  }

  .md\\:to-programEditorTabColors-1h{
    --gradient-to-color: #d9f2f2;
  }

  .md\\:to-programEditorTabColors-2h{
    --gradient-to-color: #f1dae8;
  }

  .md\\:to-programEditorTabColors-3h{
    --gradient-to-color: #ffe6f2;
  }

  .md\\:to-programEditorTabColors-4h{
    --gradient-to-color: #f9ecd2;
  }

  .md\\:to-programEditorTabColors-5h{
    --gradient-to-color: #f5ebfa;
  }

  .md\\:to-programEditorTabColors-6h{
    --gradient-to-color: #ffe8e6;
  }

  .md\\:to-programEditorPresetTabColors-1{
    --gradient-to-color: #798fa3;
  }

  .md\\:to-programEditorPresetTabColors-1h{
    --gradient-to-color: #798fa3;
  }

  .md\\:to-borgScaleColors-0{
    --gradient-to-color: #c5d1ff;
  }

  .md\\:to-borgScaleColors-1{
    --gradient-to-color: #a0b5fc;
  }

  .md\\:to-borgScaleColors-2{
    --gradient-to-color: #7492ff;
  }

  .md\\:to-borgScaleColors-3{
    --gradient-to-color: #82bbf1;
  }

  .md\\:to-borgScaleColors-4{
    --gradient-to-color: #4ba4f7;
  }

  .md\\:to-borgScaleColors-5{
    --gradient-to-color: #9cdd57;
  }

  .md\\:to-borgScaleColors-6{
    --gradient-to-color: #68af00;
  }

  .md\\:to-borgScaleColors-7{
    --gradient-to-color: #f5e380;
  }

  .md\\:to-borgScaleColors-8{
    --gradient-to-color: #ffc246;
  }

  .md\\:to-borgScaleColors-9{
    --gradient-to-color: #ff782f;
  }

  .md\\:to-borgScaleColors-10{
    --gradient-to-color: #f25757;
  }

  .md\\:hover\\:from-transparent:hover{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:hover\\:from-focus:hover{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:hover\\:from-black:hover{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:hover\\:from-white:hover{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:hover\\:from-primary:hover{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:hover\\:from-disabled:hover{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .md\\:hover\\:from-translucent-60:hover{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:hover\\:from-translucent-90:hover{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:hover\\:from-green-200:hover{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .md\\:hover\\:from-green-400:hover{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .md\\:hover\\:from-green-500:hover{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .md\\:hover\\:from-green-600:hover{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .md\\:hover\\:from-green-700:hover{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .md\\:hover\\:from-green-400a50:hover{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .md\\:hover\\:from-green-500a25:hover{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .md\\:hover\\:from-yellow-200:hover{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .md\\:hover\\:from-yellow-300:hover{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .md\\:hover\\:from-yellow-500:hover{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .md\\:hover\\:from-yellow-600:hover{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .md\\:hover\\:from-yellow-700:hover{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .md\\:hover\\:from-yellow-300a66:hover{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .md\\:hover\\:from-yellow-500a25:hover{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .md\\:hover\\:from-orange-200:hover{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .md\\:hover\\:from-orange-400:hover{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .md\\:hover\\:from-orange-500:hover{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .md\\:hover\\:from-orange-800:hover{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .md\\:hover\\:from-orange-900:hover{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .md\\:hover\\:from-orange-500a25:hover{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .md\\:hover\\:from-red-100:hover{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .md\\:hover\\:from-red-150:hover{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .md\\:hover\\:from-red-200:hover{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .md\\:hover\\:from-red-300:hover{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .md\\:hover\\:from-red-400:hover{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .md\\:hover\\:from-red-500:hover{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .md\\:hover\\:from-red-700:hover{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .md\\:hover\\:from-gray-50:hover{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .md\\:hover\\:from-gray-100:hover{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .md\\:hover\\:from-gray-150:hover{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .md\\:hover\\:from-gray-200:hover{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .md\\:hover\\:from-gray-300:hover{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .md\\:hover\\:from-gray-400:hover{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .md\\:hover\\:from-gray-425:hover{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .md\\:hover\\:from-gray-450:hover{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .md\\:hover\\:from-gray-500:hover{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .md\\:hover\\:from-gray-600:hover{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .md\\:hover\\:from-gray-625:hover{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .md\\:hover\\:from-gray-700:hover{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .md\\:hover\\:from-gray-800:hover{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .md\\:hover\\:from-gray-200a50:hover{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .md\\:hover\\:from-blue-50:hover{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .md\\:hover\\:from-blue-100:hover{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .md\\:hover\\:from-blue-150:hover{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .md\\:hover\\:from-blue-200:hover{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .md\\:hover\\:from-blue-300:hover{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .md\\:hover\\:from-blue-400:hover{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .md\\:hover\\:from-blue-500:hover{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:hover\\:from-blue-600:hover{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .md\\:hover\\:from-blue-700:hover{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .md\\:hover\\:from-blue-750:hover{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:hover\\:from-blue-800:hover{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .md\\:hover\\:from-blue-900:hover{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .md\\:hover\\:from-blue-950:hover{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .md\\:hover\\:from-blue-500a25:hover{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:hover\\:from-blue-500a50:hover{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:hover\\:from-blue-700a75:hover{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .md\\:hover\\:from-blue-700a30:hover{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .md\\:hover\\:from-blue-750a25:hover{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:hover\\:from-blue-750a15:hover{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:hover\\:from-blue-800a60:hover{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .md\\:hover\\:from-programEditorTabColors-1:hover{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .md\\:hover\\:from-programEditorTabColors-2:hover{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .md\\:hover\\:from-programEditorTabColors-3:hover{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .md\\:hover\\:from-programEditorTabColors-4:hover{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .md\\:hover\\:from-programEditorTabColors-5:hover{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .md\\:hover\\:from-programEditorTabColors-6:hover{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .md\\:hover\\:from-programEditorTabColors-1h:hover{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .md\\:hover\\:from-programEditorTabColors-2h:hover{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .md\\:hover\\:from-programEditorTabColors-3h:hover{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .md\\:hover\\:from-programEditorTabColors-4h:hover{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .md\\:hover\\:from-programEditorTabColors-5h:hover{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .md\\:hover\\:from-programEditorTabColors-6h:hover{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .md\\:hover\\:from-programEditorPresetTabColors-1:hover{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .md\\:hover\\:from-programEditorPresetTabColors-1h:hover{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .md\\:hover\\:from-borgScaleColors-0:hover{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .md\\:hover\\:from-borgScaleColors-1:hover{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .md\\:hover\\:from-borgScaleColors-2:hover{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .md\\:hover\\:from-borgScaleColors-3:hover{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .md\\:hover\\:from-borgScaleColors-4:hover{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .md\\:hover\\:from-borgScaleColors-5:hover{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .md\\:hover\\:from-borgScaleColors-6:hover{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .md\\:hover\\:from-borgScaleColors-7:hover{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .md\\:hover\\:from-borgScaleColors-8:hover{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .md\\:hover\\:from-borgScaleColors-9:hover{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .md\\:hover\\:from-borgScaleColors-10:hover{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .md\\:hover\\:via-transparent:hover{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:hover\\:via-focus:hover{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:hover\\:via-black:hover{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:hover\\:via-white:hover{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:hover\\:via-primary:hover{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:hover\\:via-disabled:hover{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .md\\:hover\\:via-translucent-60:hover{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:hover\\:via-translucent-90:hover{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:hover\\:via-green-200:hover{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .md\\:hover\\:via-green-400:hover{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .md\\:hover\\:via-green-500:hover{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .md\\:hover\\:via-green-600:hover{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .md\\:hover\\:via-green-700:hover{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .md\\:hover\\:via-green-400a50:hover{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .md\\:hover\\:via-green-500a25:hover{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .md\\:hover\\:via-yellow-200:hover{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .md\\:hover\\:via-yellow-300:hover{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .md\\:hover\\:via-yellow-500:hover{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .md\\:hover\\:via-yellow-600:hover{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .md\\:hover\\:via-yellow-700:hover{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .md\\:hover\\:via-yellow-300a66:hover{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .md\\:hover\\:via-yellow-500a25:hover{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .md\\:hover\\:via-orange-200:hover{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .md\\:hover\\:via-orange-400:hover{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .md\\:hover\\:via-orange-500:hover{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .md\\:hover\\:via-orange-800:hover{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .md\\:hover\\:via-orange-900:hover{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .md\\:hover\\:via-orange-500a25:hover{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .md\\:hover\\:via-red-100:hover{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .md\\:hover\\:via-red-150:hover{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .md\\:hover\\:via-red-200:hover{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .md\\:hover\\:via-red-300:hover{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .md\\:hover\\:via-red-400:hover{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .md\\:hover\\:via-red-500:hover{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .md\\:hover\\:via-red-700:hover{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .md\\:hover\\:via-gray-50:hover{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .md\\:hover\\:via-gray-100:hover{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .md\\:hover\\:via-gray-150:hover{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .md\\:hover\\:via-gray-200:hover{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .md\\:hover\\:via-gray-300:hover{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .md\\:hover\\:via-gray-400:hover{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .md\\:hover\\:via-gray-425:hover{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .md\\:hover\\:via-gray-450:hover{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .md\\:hover\\:via-gray-500:hover{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .md\\:hover\\:via-gray-600:hover{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .md\\:hover\\:via-gray-625:hover{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .md\\:hover\\:via-gray-700:hover{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .md\\:hover\\:via-gray-800:hover{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .md\\:hover\\:via-gray-200a50:hover{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .md\\:hover\\:via-blue-50:hover{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .md\\:hover\\:via-blue-100:hover{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .md\\:hover\\:via-blue-150:hover{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .md\\:hover\\:via-blue-200:hover{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .md\\:hover\\:via-blue-300:hover{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .md\\:hover\\:via-blue-400:hover{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .md\\:hover\\:via-blue-500:hover{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:hover\\:via-blue-600:hover{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .md\\:hover\\:via-blue-700:hover{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .md\\:hover\\:via-blue-750:hover{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:hover\\:via-blue-800:hover{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .md\\:hover\\:via-blue-900:hover{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .md\\:hover\\:via-blue-950:hover{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .md\\:hover\\:via-blue-500a25:hover{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:hover\\:via-blue-500a50:hover{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:hover\\:via-blue-700a75:hover{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .md\\:hover\\:via-blue-700a30:hover{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .md\\:hover\\:via-blue-750a25:hover{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:hover\\:via-blue-750a15:hover{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:hover\\:via-blue-800a60:hover{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .md\\:hover\\:via-programEditorTabColors-1:hover{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .md\\:hover\\:via-programEditorTabColors-2:hover{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .md\\:hover\\:via-programEditorTabColors-3:hover{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .md\\:hover\\:via-programEditorTabColors-4:hover{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .md\\:hover\\:via-programEditorTabColors-5:hover{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .md\\:hover\\:via-programEditorTabColors-6:hover{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .md\\:hover\\:via-programEditorTabColors-1h:hover{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .md\\:hover\\:via-programEditorTabColors-2h:hover{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .md\\:hover\\:via-programEditorTabColors-3h:hover{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .md\\:hover\\:via-programEditorTabColors-4h:hover{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .md\\:hover\\:via-programEditorTabColors-5h:hover{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .md\\:hover\\:via-programEditorTabColors-6h:hover{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .md\\:hover\\:via-programEditorPresetTabColors-1:hover{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .md\\:hover\\:via-programEditorPresetTabColors-1h:hover{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .md\\:hover\\:via-borgScaleColors-0:hover{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .md\\:hover\\:via-borgScaleColors-1:hover{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .md\\:hover\\:via-borgScaleColors-2:hover{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .md\\:hover\\:via-borgScaleColors-3:hover{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .md\\:hover\\:via-borgScaleColors-4:hover{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .md\\:hover\\:via-borgScaleColors-5:hover{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .md\\:hover\\:via-borgScaleColors-6:hover{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .md\\:hover\\:via-borgScaleColors-7:hover{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .md\\:hover\\:via-borgScaleColors-8:hover{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .md\\:hover\\:via-borgScaleColors-9:hover{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .md\\:hover\\:via-borgScaleColors-10:hover{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .md\\:hover\\:to-transparent:hover{
    --gradient-to-color: transparent;
  }

  .md\\:hover\\:to-focus:hover{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .md\\:hover\\:to-black:hover{
    --gradient-to-color: #000;
  }

  .md\\:hover\\:to-white:hover{
    --gradient-to-color: #fff;
  }

  .md\\:hover\\:to-primary:hover{
    --gradient-to-color: #37A4DC;
  }

  .md\\:hover\\:to-disabled:hover{
    --gradient-to-color: #BFBFBF;
  }

  .md\\:hover\\:to-translucent-60:hover{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .md\\:hover\\:to-translucent-90:hover{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .md\\:hover\\:to-green-200:hover{
    --gradient-to-color: #f4fcea;
  }

  .md\\:hover\\:to-green-400:hover{
    --gradient-to-color: #6CCA98;
  }

  .md\\:hover\\:to-green-500:hover{
    --gradient-to-color: #97E812;
  }

  .md\\:hover\\:to-green-600:hover{
    --gradient-to-color: #4f9112;
  }

  .md\\:hover\\:to-green-700:hover{
    --gradient-to-color: #3e7211;
  }

  .md\\:hover\\:to-green-400a50:hover{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .md\\:hover\\:to-green-500a25:hover{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .md\\:hover\\:to-yellow-200:hover{
    --gradient-to-color: #fff9eb;
  }

  .md\\:hover\\:to-yellow-300:hover{
    --gradient-to-color: #ffe9bd;
  }

  .md\\:hover\\:to-yellow-500:hover{
    --gradient-to-color: #FFC82C;
  }

  .md\\:hover\\:to-yellow-600:hover{
    --gradient-to-color: #F7931E;
  }

  .md\\:hover\\:to-yellow-700:hover{
    --gradient-to-color: #E1AD28;
  }

  .md\\:hover\\:to-yellow-300a66:hover{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .md\\:hover\\:to-yellow-500a25:hover{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .md\\:hover\\:to-orange-200:hover{
    --gradient-to-color: #fdf0ea;
  }

  .md\\:hover\\:to-orange-400:hover{
    --gradient-to-color: #f6c66f;
  }

  .md\\:hover\\:to-orange-500:hover{
    --gradient-to-color: #F07313;
  }

  .md\\:hover\\:to-orange-800:hover{
    --gradient-to-color: #db5d0c;
  }

  .md\\:hover\\:to-orange-900:hover{
    --gradient-to-color: #b86814;
  }

  .md\\:hover\\:to-orange-500a25:hover{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .md\\:hover\\:to-red-100:hover{
    --gradient-to-color: #FEF5F5;
  }

  .md\\:hover\\:to-red-150:hover{
    --gradient-to-color: #ffe9e8;
  }

  .md\\:hover\\:to-red-200:hover{
    --gradient-to-color: #F8CECC;
  }

  .md\\:hover\\:to-red-300:hover{
    --gradient-to-color: #ff8585;
  }

  .md\\:hover\\:to-red-400:hover{
    --gradient-to-color: #ff3535;
  }

  .md\\:hover\\:to-red-500:hover{
    --gradient-to-color: #DD4746;
  }

  .md\\:hover\\:to-red-700:hover{
    --gradient-to-color: #A23C24;
  }

  .md\\:hover\\:to-gray-50:hover{
    --gradient-to-color: #F9F9F9;
  }

  .md\\:hover\\:to-gray-100:hover{
    --gradient-to-color: #F1F1F2;
  }

  .md\\:hover\\:to-gray-150:hover{
    --gradient-to-color: #e6e6e6;
  }

  .md\\:hover\\:to-gray-200:hover{
    --gradient-to-color: #E0E2E4;
  }

  .md\\:hover\\:to-gray-300:hover{
    --gradient-to-color: #BFBFBF;
  }

  .md\\:hover\\:to-gray-400:hover{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .md\\:hover\\:to-gray-425:hover{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .md\\:hover\\:to-gray-450:hover{
    --gradient-to-color: #959595;
  }

  .md\\:hover\\:to-gray-500:hover{
    --gradient-to-color: #727272;
  }

  .md\\:hover\\:to-gray-600:hover{
    --gradient-to-color: #5a626b;
  }

  .md\\:hover\\:to-gray-625:hover{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .md\\:hover\\:to-gray-700:hover{
    --gradient-to-color: #464C59;
  }

  .md\\:hover\\:to-gray-800:hover{
    --gradient-to-color: #3c3b3b;
  }

  .md\\:hover\\:to-gray-200a50:hover{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .md\\:hover\\:to-blue-50:hover{
    --gradient-to-color: #f2fbff;
  }

  .md\\:hover\\:to-blue-100:hover{
    --gradient-to-color: #EBF6FC;
  }

  .md\\:hover\\:to-blue-150:hover{
    --gradient-to-color: #E8EEF1;
  }

  .md\\:hover\\:to-blue-200:hover{
    --gradient-to-color: #CCE6F5;
  }

  .md\\:hover\\:to-blue-300:hover{
    --gradient-to-color: #73BFE7;
  }

  .md\\:hover\\:to-blue-400:hover{
    --gradient-to-color: #4BA4F7;
  }

  .md\\:hover\\:to-blue-500:hover{
    --gradient-to-color: #37A4DC;
  }

  .md\\:hover\\:to-blue-600:hover{
    --gradient-to-color: #6AA2D6;
  }

  .md\\:hover\\:to-blue-700:hover{
    --gradient-to-color: #456E9A;
  }

  .md\\:hover\\:to-blue-750:hover{
    --gradient-to-color: #5682AA;
  }

  .md\\:hover\\:to-blue-800:hover{
    --gradient-to-color: #1F4566;
  }

  .md\\:hover\\:to-blue-900:hover{
    --gradient-to-color: #183453;
  }

  .md\\:hover\\:to-blue-950:hover{
    --gradient-to-color: #041527;
  }

  .md\\:hover\\:to-blue-500a25:hover{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .md\\:hover\\:to-blue-500a50:hover{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .md\\:hover\\:to-blue-700a75:hover{
    --gradient-to-color: #3B648D;
  }

  .md\\:hover\\:to-blue-700a30:hover{
    --gradient-to-color: #2A5176;
  }

  .md\\:hover\\:to-blue-750a25:hover{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .md\\:hover\\:to-blue-750a15:hover{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .md\\:hover\\:to-blue-800a60:hover{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .md\\:hover\\:to-programEditorTabColors-1:hover{
    --gradient-to-color: #3cacae;
  }

  .md\\:hover\\:to-programEditorTabColors-2:hover{
    --gradient-to-color: #8e346a;
  }

  .md\\:hover\\:to-programEditorTabColors-3:hover{
    --gradient-to-color: #ff72b7;
  }

  .md\\:hover\\:to-programEditorTabColors-4:hover{
    --gradient-to-color: #ce941c;
  }

  .md\\:hover\\:to-programEditorTabColors-5:hover{
    --gradient-to-color: #b973d9;
  }

  .md\\:hover\\:to-programEditorTabColors-6:hover{
    --gradient-to-color: #ff9082;
  }

  .md\\:hover\\:to-programEditorTabColors-1h:hover{
    --gradient-to-color: #d9f2f2;
  }

  .md\\:hover\\:to-programEditorTabColors-2h:hover{
    --gradient-to-color: #f1dae8;
  }

  .md\\:hover\\:to-programEditorTabColors-3h:hover{
    --gradient-to-color: #ffe6f2;
  }

  .md\\:hover\\:to-programEditorTabColors-4h:hover{
    --gradient-to-color: #f9ecd2;
  }

  .md\\:hover\\:to-programEditorTabColors-5h:hover{
    --gradient-to-color: #f5ebfa;
  }

  .md\\:hover\\:to-programEditorTabColors-6h:hover{
    --gradient-to-color: #ffe8e6;
  }

  .md\\:hover\\:to-programEditorPresetTabColors-1:hover{
    --gradient-to-color: #798fa3;
  }

  .md\\:hover\\:to-programEditorPresetTabColors-1h:hover{
    --gradient-to-color: #798fa3;
  }

  .md\\:hover\\:to-borgScaleColors-0:hover{
    --gradient-to-color: #c5d1ff;
  }

  .md\\:hover\\:to-borgScaleColors-1:hover{
    --gradient-to-color: #a0b5fc;
  }

  .md\\:hover\\:to-borgScaleColors-2:hover{
    --gradient-to-color: #7492ff;
  }

  .md\\:hover\\:to-borgScaleColors-3:hover{
    --gradient-to-color: #82bbf1;
  }

  .md\\:hover\\:to-borgScaleColors-4:hover{
    --gradient-to-color: #4ba4f7;
  }

  .md\\:hover\\:to-borgScaleColors-5:hover{
    --gradient-to-color: #9cdd57;
  }

  .md\\:hover\\:to-borgScaleColors-6:hover{
    --gradient-to-color: #68af00;
  }

  .md\\:hover\\:to-borgScaleColors-7:hover{
    --gradient-to-color: #f5e380;
  }

  .md\\:hover\\:to-borgScaleColors-8:hover{
    --gradient-to-color: #ffc246;
  }

  .md\\:hover\\:to-borgScaleColors-9:hover{
    --gradient-to-color: #ff782f;
  }

  .md\\:hover\\:to-borgScaleColors-10:hover{
    --gradient-to-color: #f25757;
  }

  .md\\:focus\\:from-transparent:focus{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:focus\\:from-focus:focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:focus\\:from-black:focus{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:focus\\:from-white:focus{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:focus\\:from-primary:focus{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:focus\\:from-disabled:focus{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .md\\:focus\\:from-translucent-60:focus{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:focus\\:from-translucent-90:focus{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:focus\\:from-green-200:focus{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .md\\:focus\\:from-green-400:focus{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .md\\:focus\\:from-green-500:focus{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .md\\:focus\\:from-green-600:focus{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .md\\:focus\\:from-green-700:focus{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .md\\:focus\\:from-green-400a50:focus{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .md\\:focus\\:from-green-500a25:focus{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .md\\:focus\\:from-yellow-200:focus{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .md\\:focus\\:from-yellow-300:focus{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .md\\:focus\\:from-yellow-500:focus{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .md\\:focus\\:from-yellow-600:focus{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .md\\:focus\\:from-yellow-700:focus{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .md\\:focus\\:from-yellow-300a66:focus{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .md\\:focus\\:from-yellow-500a25:focus{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .md\\:focus\\:from-orange-200:focus{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .md\\:focus\\:from-orange-400:focus{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .md\\:focus\\:from-orange-500:focus{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .md\\:focus\\:from-orange-800:focus{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .md\\:focus\\:from-orange-900:focus{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .md\\:focus\\:from-orange-500a25:focus{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .md\\:focus\\:from-red-100:focus{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .md\\:focus\\:from-red-150:focus{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .md\\:focus\\:from-red-200:focus{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .md\\:focus\\:from-red-300:focus{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .md\\:focus\\:from-red-400:focus{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .md\\:focus\\:from-red-500:focus{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .md\\:focus\\:from-red-700:focus{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .md\\:focus\\:from-gray-50:focus{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .md\\:focus\\:from-gray-100:focus{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .md\\:focus\\:from-gray-150:focus{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .md\\:focus\\:from-gray-200:focus{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .md\\:focus\\:from-gray-300:focus{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .md\\:focus\\:from-gray-400:focus{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .md\\:focus\\:from-gray-425:focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .md\\:focus\\:from-gray-450:focus{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .md\\:focus\\:from-gray-500:focus{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .md\\:focus\\:from-gray-600:focus{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .md\\:focus\\:from-gray-625:focus{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .md\\:focus\\:from-gray-700:focus{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .md\\:focus\\:from-gray-800:focus{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .md\\:focus\\:from-gray-200a50:focus{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .md\\:focus\\:from-blue-50:focus{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .md\\:focus\\:from-blue-100:focus{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .md\\:focus\\:from-blue-150:focus{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .md\\:focus\\:from-blue-200:focus{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .md\\:focus\\:from-blue-300:focus{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .md\\:focus\\:from-blue-400:focus{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .md\\:focus\\:from-blue-500:focus{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:focus\\:from-blue-600:focus{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .md\\:focus\\:from-blue-700:focus{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .md\\:focus\\:from-blue-750:focus{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:focus\\:from-blue-800:focus{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .md\\:focus\\:from-blue-900:focus{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .md\\:focus\\:from-blue-950:focus{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .md\\:focus\\:from-blue-500a25:focus{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:focus\\:from-blue-500a50:focus{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:focus\\:from-blue-700a75:focus{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .md\\:focus\\:from-blue-700a30:focus{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .md\\:focus\\:from-blue-750a25:focus{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:focus\\:from-blue-750a15:focus{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:focus\\:from-blue-800a60:focus{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .md\\:focus\\:from-programEditorTabColors-1:focus{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .md\\:focus\\:from-programEditorTabColors-2:focus{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .md\\:focus\\:from-programEditorTabColors-3:focus{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .md\\:focus\\:from-programEditorTabColors-4:focus{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .md\\:focus\\:from-programEditorTabColors-5:focus{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .md\\:focus\\:from-programEditorTabColors-6:focus{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .md\\:focus\\:from-programEditorTabColors-1h:focus{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .md\\:focus\\:from-programEditorTabColors-2h:focus{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .md\\:focus\\:from-programEditorTabColors-3h:focus{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .md\\:focus\\:from-programEditorTabColors-4h:focus{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .md\\:focus\\:from-programEditorTabColors-5h:focus{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .md\\:focus\\:from-programEditorTabColors-6h:focus{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .md\\:focus\\:from-programEditorPresetTabColors-1:focus{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .md\\:focus\\:from-programEditorPresetTabColors-1h:focus{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .md\\:focus\\:from-borgScaleColors-0:focus{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .md\\:focus\\:from-borgScaleColors-1:focus{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .md\\:focus\\:from-borgScaleColors-2:focus{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .md\\:focus\\:from-borgScaleColors-3:focus{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .md\\:focus\\:from-borgScaleColors-4:focus{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .md\\:focus\\:from-borgScaleColors-5:focus{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .md\\:focus\\:from-borgScaleColors-6:focus{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .md\\:focus\\:from-borgScaleColors-7:focus{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .md\\:focus\\:from-borgScaleColors-8:focus{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .md\\:focus\\:from-borgScaleColors-9:focus{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .md\\:focus\\:from-borgScaleColors-10:focus{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .md\\:focus\\:via-transparent:focus{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:focus\\:via-focus:focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:focus\\:via-black:focus{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .md\\:focus\\:via-white:focus{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:focus\\:via-primary:focus{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:focus\\:via-disabled:focus{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .md\\:focus\\:via-translucent-60:focus{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:focus\\:via-translucent-90:focus{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .md\\:focus\\:via-green-200:focus{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .md\\:focus\\:via-green-400:focus{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .md\\:focus\\:via-green-500:focus{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .md\\:focus\\:via-green-600:focus{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .md\\:focus\\:via-green-700:focus{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .md\\:focus\\:via-green-400a50:focus{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .md\\:focus\\:via-green-500a25:focus{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .md\\:focus\\:via-yellow-200:focus{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .md\\:focus\\:via-yellow-300:focus{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .md\\:focus\\:via-yellow-500:focus{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .md\\:focus\\:via-yellow-600:focus{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .md\\:focus\\:via-yellow-700:focus{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .md\\:focus\\:via-yellow-300a66:focus{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .md\\:focus\\:via-yellow-500a25:focus{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .md\\:focus\\:via-orange-200:focus{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .md\\:focus\\:via-orange-400:focus{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .md\\:focus\\:via-orange-500:focus{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .md\\:focus\\:via-orange-800:focus{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .md\\:focus\\:via-orange-900:focus{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .md\\:focus\\:via-orange-500a25:focus{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .md\\:focus\\:via-red-100:focus{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .md\\:focus\\:via-red-150:focus{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .md\\:focus\\:via-red-200:focus{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .md\\:focus\\:via-red-300:focus{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .md\\:focus\\:via-red-400:focus{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .md\\:focus\\:via-red-500:focus{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .md\\:focus\\:via-red-700:focus{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .md\\:focus\\:via-gray-50:focus{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .md\\:focus\\:via-gray-100:focus{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .md\\:focus\\:via-gray-150:focus{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .md\\:focus\\:via-gray-200:focus{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .md\\:focus\\:via-gray-300:focus{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .md\\:focus\\:via-gray-400:focus{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .md\\:focus\\:via-gray-425:focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .md\\:focus\\:via-gray-450:focus{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .md\\:focus\\:via-gray-500:focus{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .md\\:focus\\:via-gray-600:focus{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .md\\:focus\\:via-gray-625:focus{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .md\\:focus\\:via-gray-700:focus{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .md\\:focus\\:via-gray-800:focus{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .md\\:focus\\:via-gray-200a50:focus{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .md\\:focus\\:via-blue-50:focus{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .md\\:focus\\:via-blue-100:focus{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .md\\:focus\\:via-blue-150:focus{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .md\\:focus\\:via-blue-200:focus{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .md\\:focus\\:via-blue-300:focus{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .md\\:focus\\:via-blue-400:focus{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .md\\:focus\\:via-blue-500:focus{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:focus\\:via-blue-600:focus{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .md\\:focus\\:via-blue-700:focus{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .md\\:focus\\:via-blue-750:focus{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:focus\\:via-blue-800:focus{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .md\\:focus\\:via-blue-900:focus{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .md\\:focus\\:via-blue-950:focus{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .md\\:focus\\:via-blue-500a25:focus{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:focus\\:via-blue-500a50:focus{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .md\\:focus\\:via-blue-700a75:focus{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .md\\:focus\\:via-blue-700a30:focus{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .md\\:focus\\:via-blue-750a25:focus{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:focus\\:via-blue-750a15:focus{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .md\\:focus\\:via-blue-800a60:focus{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .md\\:focus\\:via-programEditorTabColors-1:focus{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .md\\:focus\\:via-programEditorTabColors-2:focus{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .md\\:focus\\:via-programEditorTabColors-3:focus{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .md\\:focus\\:via-programEditorTabColors-4:focus{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .md\\:focus\\:via-programEditorTabColors-5:focus{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .md\\:focus\\:via-programEditorTabColors-6:focus{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .md\\:focus\\:via-programEditorTabColors-1h:focus{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .md\\:focus\\:via-programEditorTabColors-2h:focus{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .md\\:focus\\:via-programEditorTabColors-3h:focus{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .md\\:focus\\:via-programEditorTabColors-4h:focus{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .md\\:focus\\:via-programEditorTabColors-5h:focus{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .md\\:focus\\:via-programEditorTabColors-6h:focus{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .md\\:focus\\:via-programEditorPresetTabColors-1:focus{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .md\\:focus\\:via-programEditorPresetTabColors-1h:focus{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .md\\:focus\\:via-borgScaleColors-0:focus{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .md\\:focus\\:via-borgScaleColors-1:focus{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .md\\:focus\\:via-borgScaleColors-2:focus{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .md\\:focus\\:via-borgScaleColors-3:focus{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .md\\:focus\\:via-borgScaleColors-4:focus{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .md\\:focus\\:via-borgScaleColors-5:focus{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .md\\:focus\\:via-borgScaleColors-6:focus{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .md\\:focus\\:via-borgScaleColors-7:focus{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .md\\:focus\\:via-borgScaleColors-8:focus{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .md\\:focus\\:via-borgScaleColors-9:focus{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .md\\:focus\\:via-borgScaleColors-10:focus{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .md\\:focus\\:to-transparent:focus{
    --gradient-to-color: transparent;
  }

  .md\\:focus\\:to-focus:focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .md\\:focus\\:to-black:focus{
    --gradient-to-color: #000;
  }

  .md\\:focus\\:to-white:focus{
    --gradient-to-color: #fff;
  }

  .md\\:focus\\:to-primary:focus{
    --gradient-to-color: #37A4DC;
  }

  .md\\:focus\\:to-disabled:focus{
    --gradient-to-color: #BFBFBF;
  }

  .md\\:focus\\:to-translucent-60:focus{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .md\\:focus\\:to-translucent-90:focus{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .md\\:focus\\:to-green-200:focus{
    --gradient-to-color: #f4fcea;
  }

  .md\\:focus\\:to-green-400:focus{
    --gradient-to-color: #6CCA98;
  }

  .md\\:focus\\:to-green-500:focus{
    --gradient-to-color: #97E812;
  }

  .md\\:focus\\:to-green-600:focus{
    --gradient-to-color: #4f9112;
  }

  .md\\:focus\\:to-green-700:focus{
    --gradient-to-color: #3e7211;
  }

  .md\\:focus\\:to-green-400a50:focus{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .md\\:focus\\:to-green-500a25:focus{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .md\\:focus\\:to-yellow-200:focus{
    --gradient-to-color: #fff9eb;
  }

  .md\\:focus\\:to-yellow-300:focus{
    --gradient-to-color: #ffe9bd;
  }

  .md\\:focus\\:to-yellow-500:focus{
    --gradient-to-color: #FFC82C;
  }

  .md\\:focus\\:to-yellow-600:focus{
    --gradient-to-color: #F7931E;
  }

  .md\\:focus\\:to-yellow-700:focus{
    --gradient-to-color: #E1AD28;
  }

  .md\\:focus\\:to-yellow-300a66:focus{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .md\\:focus\\:to-yellow-500a25:focus{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .md\\:focus\\:to-orange-200:focus{
    --gradient-to-color: #fdf0ea;
  }

  .md\\:focus\\:to-orange-400:focus{
    --gradient-to-color: #f6c66f;
  }

  .md\\:focus\\:to-orange-500:focus{
    --gradient-to-color: #F07313;
  }

  .md\\:focus\\:to-orange-800:focus{
    --gradient-to-color: #db5d0c;
  }

  .md\\:focus\\:to-orange-900:focus{
    --gradient-to-color: #b86814;
  }

  .md\\:focus\\:to-orange-500a25:focus{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .md\\:focus\\:to-red-100:focus{
    --gradient-to-color: #FEF5F5;
  }

  .md\\:focus\\:to-red-150:focus{
    --gradient-to-color: #ffe9e8;
  }

  .md\\:focus\\:to-red-200:focus{
    --gradient-to-color: #F8CECC;
  }

  .md\\:focus\\:to-red-300:focus{
    --gradient-to-color: #ff8585;
  }

  .md\\:focus\\:to-red-400:focus{
    --gradient-to-color: #ff3535;
  }

  .md\\:focus\\:to-red-500:focus{
    --gradient-to-color: #DD4746;
  }

  .md\\:focus\\:to-red-700:focus{
    --gradient-to-color: #A23C24;
  }

  .md\\:focus\\:to-gray-50:focus{
    --gradient-to-color: #F9F9F9;
  }

  .md\\:focus\\:to-gray-100:focus{
    --gradient-to-color: #F1F1F2;
  }

  .md\\:focus\\:to-gray-150:focus{
    --gradient-to-color: #e6e6e6;
  }

  .md\\:focus\\:to-gray-200:focus{
    --gradient-to-color: #E0E2E4;
  }

  .md\\:focus\\:to-gray-300:focus{
    --gradient-to-color: #BFBFBF;
  }

  .md\\:focus\\:to-gray-400:focus{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .md\\:focus\\:to-gray-425:focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .md\\:focus\\:to-gray-450:focus{
    --gradient-to-color: #959595;
  }

  .md\\:focus\\:to-gray-500:focus{
    --gradient-to-color: #727272;
  }

  .md\\:focus\\:to-gray-600:focus{
    --gradient-to-color: #5a626b;
  }

  .md\\:focus\\:to-gray-625:focus{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .md\\:focus\\:to-gray-700:focus{
    --gradient-to-color: #464C59;
  }

  .md\\:focus\\:to-gray-800:focus{
    --gradient-to-color: #3c3b3b;
  }

  .md\\:focus\\:to-gray-200a50:focus{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .md\\:focus\\:to-blue-50:focus{
    --gradient-to-color: #f2fbff;
  }

  .md\\:focus\\:to-blue-100:focus{
    --gradient-to-color: #EBF6FC;
  }

  .md\\:focus\\:to-blue-150:focus{
    --gradient-to-color: #E8EEF1;
  }

  .md\\:focus\\:to-blue-200:focus{
    --gradient-to-color: #CCE6F5;
  }

  .md\\:focus\\:to-blue-300:focus{
    --gradient-to-color: #73BFE7;
  }

  .md\\:focus\\:to-blue-400:focus{
    --gradient-to-color: #4BA4F7;
  }

  .md\\:focus\\:to-blue-500:focus{
    --gradient-to-color: #37A4DC;
  }

  .md\\:focus\\:to-blue-600:focus{
    --gradient-to-color: #6AA2D6;
  }

  .md\\:focus\\:to-blue-700:focus{
    --gradient-to-color: #456E9A;
  }

  .md\\:focus\\:to-blue-750:focus{
    --gradient-to-color: #5682AA;
  }

  .md\\:focus\\:to-blue-800:focus{
    --gradient-to-color: #1F4566;
  }

  .md\\:focus\\:to-blue-900:focus{
    --gradient-to-color: #183453;
  }

  .md\\:focus\\:to-blue-950:focus{
    --gradient-to-color: #041527;
  }

  .md\\:focus\\:to-blue-500a25:focus{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .md\\:focus\\:to-blue-500a50:focus{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .md\\:focus\\:to-blue-700a75:focus{
    --gradient-to-color: #3B648D;
  }

  .md\\:focus\\:to-blue-700a30:focus{
    --gradient-to-color: #2A5176;
  }

  .md\\:focus\\:to-blue-750a25:focus{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .md\\:focus\\:to-blue-750a15:focus{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .md\\:focus\\:to-blue-800a60:focus{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .md\\:focus\\:to-programEditorTabColors-1:focus{
    --gradient-to-color: #3cacae;
  }

  .md\\:focus\\:to-programEditorTabColors-2:focus{
    --gradient-to-color: #8e346a;
  }

  .md\\:focus\\:to-programEditorTabColors-3:focus{
    --gradient-to-color: #ff72b7;
  }

  .md\\:focus\\:to-programEditorTabColors-4:focus{
    --gradient-to-color: #ce941c;
  }

  .md\\:focus\\:to-programEditorTabColors-5:focus{
    --gradient-to-color: #b973d9;
  }

  .md\\:focus\\:to-programEditorTabColors-6:focus{
    --gradient-to-color: #ff9082;
  }

  .md\\:focus\\:to-programEditorTabColors-1h:focus{
    --gradient-to-color: #d9f2f2;
  }

  .md\\:focus\\:to-programEditorTabColors-2h:focus{
    --gradient-to-color: #f1dae8;
  }

  .md\\:focus\\:to-programEditorTabColors-3h:focus{
    --gradient-to-color: #ffe6f2;
  }

  .md\\:focus\\:to-programEditorTabColors-4h:focus{
    --gradient-to-color: #f9ecd2;
  }

  .md\\:focus\\:to-programEditorTabColors-5h:focus{
    --gradient-to-color: #f5ebfa;
  }

  .md\\:focus\\:to-programEditorTabColors-6h:focus{
    --gradient-to-color: #ffe8e6;
  }

  .md\\:focus\\:to-programEditorPresetTabColors-1:focus{
    --gradient-to-color: #798fa3;
  }

  .md\\:focus\\:to-programEditorPresetTabColors-1h:focus{
    --gradient-to-color: #798fa3;
  }

  .md\\:focus\\:to-borgScaleColors-0:focus{
    --gradient-to-color: #c5d1ff;
  }

  .md\\:focus\\:to-borgScaleColors-1:focus{
    --gradient-to-color: #a0b5fc;
  }

  .md\\:focus\\:to-borgScaleColors-2:focus{
    --gradient-to-color: #7492ff;
  }

  .md\\:focus\\:to-borgScaleColors-3:focus{
    --gradient-to-color: #82bbf1;
  }

  .md\\:focus\\:to-borgScaleColors-4:focus{
    --gradient-to-color: #4ba4f7;
  }

  .md\\:focus\\:to-borgScaleColors-5:focus{
    --gradient-to-color: #9cdd57;
  }

  .md\\:focus\\:to-borgScaleColors-6:focus{
    --gradient-to-color: #68af00;
  }

  .md\\:focus\\:to-borgScaleColors-7:focus{
    --gradient-to-color: #f5e380;
  }

  .md\\:focus\\:to-borgScaleColors-8:focus{
    --gradient-to-color: #ffc246;
  }

  .md\\:focus\\:to-borgScaleColors-9:focus{
    --gradient-to-color: #ff782f;
  }

  .md\\:focus\\:to-borgScaleColors-10:focus{
    --gradient-to-color: #f25757;
  }

  .md\\:bg-opacity-0{
    --bg-opacity: 0;
  }

  .md\\:bg-opacity-25{
    --bg-opacity: .25;
  }

  .md\\:bg-opacity-50{
    --bg-opacity: .5;
  }

  .md\\:bg-opacity-75{
    --bg-opacity: .75;
  }

  .md\\:bg-opacity-100{
    --bg-opacity: 1;
  }

  .md\\:hover\\:bg-opacity-0:hover{
    --bg-opacity: 0;
  }

  .md\\:hover\\:bg-opacity-25:hover{
    --bg-opacity: .25;
  }

  .md\\:hover\\:bg-opacity-50:hover{
    --bg-opacity: .5;
  }

  .md\\:hover\\:bg-opacity-75:hover{
    --bg-opacity: .75;
  }

  .md\\:hover\\:bg-opacity-100:hover{
    --bg-opacity: 1;
  }

  .md\\:focus\\:bg-opacity-0:focus{
    --bg-opacity: 0;
  }

  .md\\:focus\\:bg-opacity-25:focus{
    --bg-opacity: .25;
  }

  .md\\:focus\\:bg-opacity-50:focus{
    --bg-opacity: .5;
  }

  .md\\:focus\\:bg-opacity-75:focus{
    --bg-opacity: .75;
  }

  .md\\:focus\\:bg-opacity-100:focus{
    --bg-opacity: 1;
  }

  .md\\:bg-bottom{
    background-position: bottom;
  }

  .md\\:bg-center{
    background-position: center;
  }

  .md\\:bg-left{
    background-position: left;
  }

  .md\\:bg-left-bottom{
    background-position: left bottom;
  }

  .md\\:bg-left-top{
    background-position: left top;
  }

  .md\\:bg-right{
    background-position: right;
  }

  .md\\:bg-right-bottom{
    background-position: right bottom;
  }

  .md\\:bg-right-top{
    background-position: right top;
  }

  .md\\:bg-top{
    background-position: top;
  }

  .md\\:bg-repeat{
    background-repeat: repeat;
  }

  .md\\:bg-no-repeat{
    background-repeat: no-repeat;
  }

  .md\\:bg-repeat-x{
    background-repeat: repeat-x;
  }

  .md\\:bg-repeat-y{
    background-repeat: repeat-y;
  }

  .md\\:bg-repeat-round{
    background-repeat: round;
  }

  .md\\:bg-repeat-space{
    background-repeat: space;
  }

  .md\\:bg-auto{
    background-size: auto;
  }

  .md\\:bg-cover{
    background-size: cover;
  }

  .md\\:bg-contain{
    background-size: contain;
  }

  .md\\:border-transparent{
    border-color: transparent;
  }

  .md\\:border-focus{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .md\\:border-black{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .md\\:border-white{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .md\\:border-primary{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .md\\:border-disabled{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .md\\:border-translucent-60{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .md\\:border-translucent-90{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .md\\:border-green-200{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .md\\:border-green-400{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .md\\:border-green-500{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .md\\:border-green-600{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .md\\:border-green-700{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .md\\:border-green-400a50{
    border-color: rgba(108,202,152,0.50196);
  }

  .md\\:border-green-500a25{
    border-color: rgba(151,232,18,0.09804);
  }

  .md\\:border-yellow-200{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .md\\:border-yellow-300{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .md\\:border-yellow-500{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .md\\:border-yellow-600{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .md\\:border-yellow-700{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .md\\:border-yellow-300a66{
    border-color: rgba(255,233,189,0.66667);
  }

  .md\\:border-yellow-500a25{
    border-color: rgba(255,200,44,0.09804);
  }

  .md\\:border-orange-200{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .md\\:border-orange-400{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .md\\:border-orange-500{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .md\\:border-orange-800{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .md\\:border-orange-900{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .md\\:border-orange-500a25{
    border-color: rgba(240,115,23,0.09804);
  }

  .md\\:border-red-100{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .md\\:border-red-150{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .md\\:border-red-200{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .md\\:border-red-300{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .md\\:border-red-400{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .md\\:border-red-500{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .md\\:border-red-700{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .md\\:border-gray-50{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .md\\:border-gray-100{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .md\\:border-gray-150{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .md\\:border-gray-200{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .md\\:border-gray-300{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .md\\:border-gray-400{
    border-color: rgba(114,114,114,0.8);
  }

  .md\\:border-gray-425{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .md\\:border-gray-450{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .md\\:border-gray-500{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .md\\:border-gray-600{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .md\\:border-gray-625{
    border-color: rgba(90,98,107,0.8);
  }

  .md\\:border-gray-700{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .md\\:border-gray-800{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .md\\:border-gray-200a50{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .md\\:border-blue-50{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .md\\:border-blue-100{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .md\\:border-blue-150{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .md\\:border-blue-200{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .md\\:border-blue-300{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .md\\:border-blue-400{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .md\\:border-blue-500{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .md\\:border-blue-600{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .md\\:border-blue-700{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .md\\:border-blue-750{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .md\\:border-blue-800{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .md\\:border-blue-900{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .md\\:border-blue-950{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .md\\:border-blue-500a25{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .md\\:border-blue-500a50{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .md\\:border-blue-700a75{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .md\\:border-blue-700a30{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .md\\:border-blue-750a25{
    border-color: rgba(86,130,170,0.09804);
  }

  .md\\:border-blue-750a15{
    border-color: rgba(86,130,170,0.05882);
  }

  .md\\:border-blue-800a60{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .md\\:border-programEditorTabColors-1{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .md\\:border-programEditorTabColors-2{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .md\\:border-programEditorTabColors-3{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .md\\:border-programEditorTabColors-4{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .md\\:border-programEditorTabColors-5{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .md\\:border-programEditorTabColors-6{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .md\\:border-programEditorTabColors-1h{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .md\\:border-programEditorTabColors-2h{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .md\\:border-programEditorTabColors-3h{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .md\\:border-programEditorTabColors-4h{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .md\\:border-programEditorTabColors-5h{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .md\\:border-programEditorTabColors-6h{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .md\\:border-programEditorPresetTabColors-1{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .md\\:border-programEditorPresetTabColors-1h{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .md\\:border-borgScaleColors-0{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .md\\:border-borgScaleColors-1{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .md\\:border-borgScaleColors-2{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .md\\:border-borgScaleColors-3{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .md\\:border-borgScaleColors-4{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .md\\:border-borgScaleColors-5{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .md\\:border-borgScaleColors-6{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .md\\:border-borgScaleColors-7{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .md\\:border-borgScaleColors-8{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .md\\:border-borgScaleColors-9{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .md\\:border-borgScaleColors-10{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .md\\:hover\\:border-transparent:hover{
    border-color: transparent;
  }

  .md\\:hover\\:border-focus:hover{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .md\\:hover\\:border-black:hover{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .md\\:hover\\:border-white:hover{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .md\\:hover\\:border-primary:hover{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .md\\:hover\\:border-disabled:hover{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .md\\:hover\\:border-translucent-60:hover{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .md\\:hover\\:border-translucent-90:hover{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .md\\:hover\\:border-green-200:hover{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .md\\:hover\\:border-green-400:hover{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .md\\:hover\\:border-green-500:hover{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .md\\:hover\\:border-green-600:hover{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .md\\:hover\\:border-green-700:hover{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .md\\:hover\\:border-green-400a50:hover{
    border-color: rgba(108,202,152,0.50196);
  }

  .md\\:hover\\:border-green-500a25:hover{
    border-color: rgba(151,232,18,0.09804);
  }

  .md\\:hover\\:border-yellow-200:hover{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .md\\:hover\\:border-yellow-300:hover{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .md\\:hover\\:border-yellow-500:hover{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .md\\:hover\\:border-yellow-600:hover{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .md\\:hover\\:border-yellow-700:hover{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .md\\:hover\\:border-yellow-300a66:hover{
    border-color: rgba(255,233,189,0.66667);
  }

  .md\\:hover\\:border-yellow-500a25:hover{
    border-color: rgba(255,200,44,0.09804);
  }

  .md\\:hover\\:border-orange-200:hover{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .md\\:hover\\:border-orange-400:hover{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .md\\:hover\\:border-orange-500:hover{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .md\\:hover\\:border-orange-800:hover{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .md\\:hover\\:border-orange-900:hover{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .md\\:hover\\:border-orange-500a25:hover{
    border-color: rgba(240,115,23,0.09804);
  }

  .md\\:hover\\:border-red-100:hover{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .md\\:hover\\:border-red-150:hover{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .md\\:hover\\:border-red-200:hover{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .md\\:hover\\:border-red-300:hover{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .md\\:hover\\:border-red-400:hover{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .md\\:hover\\:border-red-500:hover{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .md\\:hover\\:border-red-700:hover{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-50:hover{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-100:hover{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-150:hover{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-200:hover{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-300:hover{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-400:hover{
    border-color: rgba(114,114,114,0.8);
  }

  .md\\:hover\\:border-gray-425:hover{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .md\\:hover\\:border-gray-450:hover{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-500:hover{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-600:hover{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-625:hover{
    border-color: rgba(90,98,107,0.8);
  }

  .md\\:hover\\:border-gray-700:hover{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-800:hover{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .md\\:hover\\:border-gray-200a50:hover{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .md\\:hover\\:border-blue-50:hover{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-100:hover{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-150:hover{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-200:hover{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-300:hover{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-400:hover{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-500:hover{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-600:hover{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-700:hover{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-750:hover{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-800:hover{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-900:hover{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-950:hover{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-500a25:hover{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .md\\:hover\\:border-blue-500a50:hover{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .md\\:hover\\:border-blue-700a75:hover{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-700a30:hover{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .md\\:hover\\:border-blue-750a25:hover{
    border-color: rgba(86,130,170,0.09804);
  }

  .md\\:hover\\:border-blue-750a15:hover{
    border-color: rgba(86,130,170,0.05882);
  }

  .md\\:hover\\:border-blue-800a60:hover{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .md\\:hover\\:border-programEditorTabColors-1:hover{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .md\\:hover\\:border-programEditorTabColors-2:hover{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .md\\:hover\\:border-programEditorTabColors-3:hover{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .md\\:hover\\:border-programEditorTabColors-4:hover{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .md\\:hover\\:border-programEditorTabColors-5:hover{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .md\\:hover\\:border-programEditorTabColors-6:hover{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .md\\:hover\\:border-programEditorTabColors-1h:hover{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .md\\:hover\\:border-programEditorTabColors-2h:hover{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .md\\:hover\\:border-programEditorTabColors-3h:hover{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .md\\:hover\\:border-programEditorTabColors-4h:hover{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .md\\:hover\\:border-programEditorTabColors-5h:hover{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .md\\:hover\\:border-programEditorTabColors-6h:hover{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .md\\:hover\\:border-programEditorPresetTabColors-1:hover{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .md\\:hover\\:border-programEditorPresetTabColors-1h:hover{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .md\\:hover\\:border-borgScaleColors-0:hover{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .md\\:hover\\:border-borgScaleColors-1:hover{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .md\\:hover\\:border-borgScaleColors-2:hover{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .md\\:hover\\:border-borgScaleColors-3:hover{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .md\\:hover\\:border-borgScaleColors-4:hover{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .md\\:hover\\:border-borgScaleColors-5:hover{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .md\\:hover\\:border-borgScaleColors-6:hover{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .md\\:hover\\:border-borgScaleColors-7:hover{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .md\\:hover\\:border-borgScaleColors-8:hover{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .md\\:hover\\:border-borgScaleColors-9:hover{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .md\\:hover\\:border-borgScaleColors-10:hover{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .md\\:focus\\:border-transparent:focus{
    border-color: transparent;
  }

  .md\\:focus\\:border-focus:focus{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .md\\:focus\\:border-black:focus{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .md\\:focus\\:border-white:focus{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .md\\:focus\\:border-primary:focus{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .md\\:focus\\:border-disabled:focus{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .md\\:focus\\:border-translucent-60:focus{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .md\\:focus\\:border-translucent-90:focus{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .md\\:focus\\:border-green-200:focus{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .md\\:focus\\:border-green-400:focus{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .md\\:focus\\:border-green-500:focus{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .md\\:focus\\:border-green-600:focus{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .md\\:focus\\:border-green-700:focus{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .md\\:focus\\:border-green-400a50:focus{
    border-color: rgba(108,202,152,0.50196);
  }

  .md\\:focus\\:border-green-500a25:focus{
    border-color: rgba(151,232,18,0.09804);
  }

  .md\\:focus\\:border-yellow-200:focus{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .md\\:focus\\:border-yellow-300:focus{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .md\\:focus\\:border-yellow-500:focus{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .md\\:focus\\:border-yellow-600:focus{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .md\\:focus\\:border-yellow-700:focus{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .md\\:focus\\:border-yellow-300a66:focus{
    border-color: rgba(255,233,189,0.66667);
  }

  .md\\:focus\\:border-yellow-500a25:focus{
    border-color: rgba(255,200,44,0.09804);
  }

  .md\\:focus\\:border-orange-200:focus{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .md\\:focus\\:border-orange-400:focus{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .md\\:focus\\:border-orange-500:focus{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .md\\:focus\\:border-orange-800:focus{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .md\\:focus\\:border-orange-900:focus{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .md\\:focus\\:border-orange-500a25:focus{
    border-color: rgba(240,115,23,0.09804);
  }

  .md\\:focus\\:border-red-100:focus{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .md\\:focus\\:border-red-150:focus{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .md\\:focus\\:border-red-200:focus{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .md\\:focus\\:border-red-300:focus{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .md\\:focus\\:border-red-400:focus{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .md\\:focus\\:border-red-500:focus{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .md\\:focus\\:border-red-700:focus{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-50:focus{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-100:focus{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-150:focus{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-200:focus{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-300:focus{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-400:focus{
    border-color: rgba(114,114,114,0.8);
  }

  .md\\:focus\\:border-gray-425:focus{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .md\\:focus\\:border-gray-450:focus{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-500:focus{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-600:focus{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-625:focus{
    border-color: rgba(90,98,107,0.8);
  }

  .md\\:focus\\:border-gray-700:focus{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-800:focus{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .md\\:focus\\:border-gray-200a50:focus{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .md\\:focus\\:border-blue-50:focus{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-100:focus{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-150:focus{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-200:focus{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-300:focus{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-400:focus{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-500:focus{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-600:focus{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-700:focus{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-750:focus{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-800:focus{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-900:focus{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-950:focus{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-500a25:focus{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .md\\:focus\\:border-blue-500a50:focus{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .md\\:focus\\:border-blue-700a75:focus{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-700a30:focus{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .md\\:focus\\:border-blue-750a25:focus{
    border-color: rgba(86,130,170,0.09804);
  }

  .md\\:focus\\:border-blue-750a15:focus{
    border-color: rgba(86,130,170,0.05882);
  }

  .md\\:focus\\:border-blue-800a60:focus{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .md\\:focus\\:border-programEditorTabColors-1:focus{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .md\\:focus\\:border-programEditorTabColors-2:focus{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .md\\:focus\\:border-programEditorTabColors-3:focus{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .md\\:focus\\:border-programEditorTabColors-4:focus{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .md\\:focus\\:border-programEditorTabColors-5:focus{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .md\\:focus\\:border-programEditorTabColors-6:focus{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .md\\:focus\\:border-programEditorTabColors-1h:focus{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .md\\:focus\\:border-programEditorTabColors-2h:focus{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .md\\:focus\\:border-programEditorTabColors-3h:focus{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .md\\:focus\\:border-programEditorTabColors-4h:focus{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .md\\:focus\\:border-programEditorTabColors-5h:focus{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .md\\:focus\\:border-programEditorTabColors-6h:focus{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .md\\:focus\\:border-programEditorPresetTabColors-1:focus{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .md\\:focus\\:border-programEditorPresetTabColors-1h:focus{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .md\\:focus\\:border-borgScaleColors-0:focus{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .md\\:focus\\:border-borgScaleColors-1:focus{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .md\\:focus\\:border-borgScaleColors-2:focus{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .md\\:focus\\:border-borgScaleColors-3:focus{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .md\\:focus\\:border-borgScaleColors-4:focus{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .md\\:focus\\:border-borgScaleColors-5:focus{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .md\\:focus\\:border-borgScaleColors-6:focus{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .md\\:focus\\:border-borgScaleColors-7:focus{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .md\\:focus\\:border-borgScaleColors-8:focus{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .md\\:focus\\:border-borgScaleColors-9:focus{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .md\\:focus\\:border-borgScaleColors-10:focus{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .md\\:border-opacity-0{
    --border-opacity: 0;
  }

  .md\\:border-opacity-25{
    --border-opacity: .25;
  }

  .md\\:border-opacity-50{
    --border-opacity: .5;
  }

  .md\\:border-opacity-75{
    --border-opacity: .75;
  }

  .md\\:border-opacity-100{
    --border-opacity: 1;
  }

  .md\\:hover\\:border-opacity-0:hover{
    --border-opacity: 0;
  }

  .md\\:hover\\:border-opacity-25:hover{
    --border-opacity: .25;
  }

  .md\\:hover\\:border-opacity-50:hover{
    --border-opacity: .5;
  }

  .md\\:hover\\:border-opacity-75:hover{
    --border-opacity: .75;
  }

  .md\\:hover\\:border-opacity-100:hover{
    --border-opacity: 1;
  }

  .md\\:focus\\:border-opacity-0:focus{
    --border-opacity: 0;
  }

  .md\\:focus\\:border-opacity-25:focus{
    --border-opacity: .25;
  }

  .md\\:focus\\:border-opacity-50:focus{
    --border-opacity: .5;
  }

  .md\\:focus\\:border-opacity-75:focus{
    --border-opacity: .75;
  }

  .md\\:focus\\:border-opacity-100:focus{
    --border-opacity: 1;
  }

  .md\\:rounded-none{
    border-radius: 0;
  }

  .md\\:rounded-sm{
    border-radius: .25rem;
  }

  .md\\:rounded{
    border-radius: .375rem;
  }

  .md\\:rounded-lg{
    border-radius: .5rem;
  }

  .md\\:rounded-xl{
    border-radius: .75rem;
  }

  .md\\:rounded-full{
    border-radius: 9999px;
  }

  .md\\:rounded-t-none{
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .md\\:rounded-r-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .md\\:rounded-b-none{
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .md\\:rounded-l-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .md\\:rounded-t-sm{
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
  }

  .md\\:rounded-r-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  .md\\:rounded-b-sm{
    border-bottom-right-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  .md\\:rounded-l-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  .md\\:rounded-t{
    border-top-left-radius: .375rem;
    border-top-right-radius: .375rem;
  }

  .md\\:rounded-r{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  .md\\:rounded-b{
    border-bottom-right-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  .md\\:rounded-l{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  .md\\:rounded-t-lg{
    border-top-left-radius: .5rem;
    border-top-right-radius: .5rem;
  }

  .md\\:rounded-r-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  .md\\:rounded-b-lg{
    border-bottom-right-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  .md\\:rounded-l-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  .md\\:rounded-t-xl{
    border-top-left-radius: .75rem;
    border-top-right-radius: .75rem;
  }

  .md\\:rounded-r-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  .md\\:rounded-b-xl{
    border-bottom-right-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  .md\\:rounded-l-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  .md\\:rounded-t-full{
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }

  .md\\:rounded-r-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  .md\\:rounded-b-full{
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .md\\:rounded-l-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .md\\:rounded-tl-none{
    border-top-left-radius: 0;
  }

  .md\\:rounded-tr-none{
    border-top-right-radius: 0;
  }

  .md\\:rounded-br-none{
    border-bottom-right-radius: 0;
  }

  .md\\:rounded-bl-none{
    border-bottom-left-radius: 0;
  }

  .md\\:rounded-tl-sm{
    border-top-left-radius: .25rem;
  }

  .md\\:rounded-tr-sm{
    border-top-right-radius: .25rem;
  }

  .md\\:rounded-br-sm{
    border-bottom-right-radius: .25rem;
  }

  .md\\:rounded-bl-sm{
    border-bottom-left-radius: .25rem;
  }

  .md\\:rounded-tl{
    border-top-left-radius: .375rem;
  }

  .md\\:rounded-tr{
    border-top-right-radius: .375rem;
  }

  .md\\:rounded-br{
    border-bottom-right-radius: .375rem;
  }

  .md\\:rounded-bl{
    border-bottom-left-radius: .375rem;
  }

  .md\\:rounded-tl-lg{
    border-top-left-radius: .5rem;
  }

  .md\\:rounded-tr-lg{
    border-top-right-radius: .5rem;
  }

  .md\\:rounded-br-lg{
    border-bottom-right-radius: .5rem;
  }

  .md\\:rounded-bl-lg{
    border-bottom-left-radius: .5rem;
  }

  .md\\:rounded-tl-xl{
    border-top-left-radius: .75rem;
  }

  .md\\:rounded-tr-xl{
    border-top-right-radius: .75rem;
  }

  .md\\:rounded-br-xl{
    border-bottom-right-radius: .75rem;
  }

  .md\\:rounded-bl-xl{
    border-bottom-left-radius: .75rem;
  }

  .md\\:rounded-tl-full{
    border-top-left-radius: 9999px;
  }

  .md\\:rounded-tr-full{
    border-top-right-radius: 9999px;
  }

  .md\\:rounded-br-full{
    border-bottom-right-radius: 9999px;
  }

  .md\\:rounded-bl-full{
    border-bottom-left-radius: 9999px;
  }

  .md\\:border-solid{
    border-style: solid;
  }

  .md\\:border-dashed{
    border-style: dashed;
  }

  .md\\:border-dotted{
    border-style: dotted;
  }

  .md\\:border-double{
    border-style: double;
  }

  .md\\:border-none{
    border-style: none;
  }

  .md\\:border-0{
    border-width: 0;
  }

  .md\\:border-2{
    border-width: 2px;
  }

  .md\\:border-3{
    border-width: 3px;
  }

  .md\\:border-4{
    border-width: 4px;
  }

  .md\\:border-5{
    border-width: 5px;
  }

  .md\\:border-6{
    border-width: 6px;
  }

  .md\\:border-8{
    border-width: 8px;
  }

  .md\\:border{
    border-width: 1px;
  }

  .md\\:border-t-0{
    border-top-width: 0;
  }

  .md\\:border-r-0{
    border-right-width: 0;
  }

  .md\\:border-b-0{
    border-bottom-width: 0;
  }

  .md\\:border-l-0{
    border-left-width: 0;
  }

  .md\\:border-t-2{
    border-top-width: 2px;
  }

  .md\\:border-r-2{
    border-right-width: 2px;
  }

  .md\\:border-b-2{
    border-bottom-width: 2px;
  }

  .md\\:border-l-2{
    border-left-width: 2px;
  }

  .md\\:border-t-3{
    border-top-width: 3px;
  }

  .md\\:border-r-3{
    border-right-width: 3px;
  }

  .md\\:border-b-3{
    border-bottom-width: 3px;
  }

  .md\\:border-l-3{
    border-left-width: 3px;
  }

  .md\\:border-t-4{
    border-top-width: 4px;
  }

  .md\\:border-r-4{
    border-right-width: 4px;
  }

  .md\\:border-b-4{
    border-bottom-width: 4px;
  }

  .md\\:border-l-4{
    border-left-width: 4px;
  }

  .md\\:border-t-5{
    border-top-width: 5px;
  }

  .md\\:border-r-5{
    border-right-width: 5px;
  }

  .md\\:border-b-5{
    border-bottom-width: 5px;
  }

  .md\\:border-l-5{
    border-left-width: 5px;
  }

  .md\\:border-t-6{
    border-top-width: 6px;
  }

  .md\\:border-r-6{
    border-right-width: 6px;
  }

  .md\\:border-b-6{
    border-bottom-width: 6px;
  }

  .md\\:border-l-6{
    border-left-width: 6px;
  }

  .md\\:border-t-8{
    border-top-width: 8px;
  }

  .md\\:border-r-8{
    border-right-width: 8px;
  }

  .md\\:border-b-8{
    border-bottom-width: 8px;
  }

  .md\\:border-l-8{
    border-left-width: 8px;
  }

  .md\\:border-t{
    border-top-width: 1px;
  }

  .md\\:border-r{
    border-right-width: 1px;
  }

  .md\\:border-b{
    border-bottom-width: 1px;
  }

  .md\\:border-l{
    border-left-width: 1px;
  }

  .md\\:first\\:border-0:first-child{
    border-width: 0;
  }

  .md\\:first\\:border-2:first-child{
    border-width: 2px;
  }

  .md\\:first\\:border-3:first-child{
    border-width: 3px;
  }

  .md\\:first\\:border-4:first-child{
    border-width: 4px;
  }

  .md\\:first\\:border-5:first-child{
    border-width: 5px;
  }

  .md\\:first\\:border-6:first-child{
    border-width: 6px;
  }

  .md\\:first\\:border-8:first-child{
    border-width: 8px;
  }

  .md\\:first\\:border:first-child{
    border-width: 1px;
  }

  .md\\:first\\:border-t-0:first-child{
    border-top-width: 0;
  }

  .md\\:first\\:border-r-0:first-child{
    border-right-width: 0;
  }

  .md\\:first\\:border-b-0:first-child{
    border-bottom-width: 0;
  }

  .md\\:first\\:border-l-0:first-child{
    border-left-width: 0;
  }

  .md\\:first\\:border-t-2:first-child{
    border-top-width: 2px;
  }

  .md\\:first\\:border-r-2:first-child{
    border-right-width: 2px;
  }

  .md\\:first\\:border-b-2:first-child{
    border-bottom-width: 2px;
  }

  .md\\:first\\:border-l-2:first-child{
    border-left-width: 2px;
  }

  .md\\:first\\:border-t-3:first-child{
    border-top-width: 3px;
  }

  .md\\:first\\:border-r-3:first-child{
    border-right-width: 3px;
  }

  .md\\:first\\:border-b-3:first-child{
    border-bottom-width: 3px;
  }

  .md\\:first\\:border-l-3:first-child{
    border-left-width: 3px;
  }

  .md\\:first\\:border-t-4:first-child{
    border-top-width: 4px;
  }

  .md\\:first\\:border-r-4:first-child{
    border-right-width: 4px;
  }

  .md\\:first\\:border-b-4:first-child{
    border-bottom-width: 4px;
  }

  .md\\:first\\:border-l-4:first-child{
    border-left-width: 4px;
  }

  .md\\:first\\:border-t-5:first-child{
    border-top-width: 5px;
  }

  .md\\:first\\:border-r-5:first-child{
    border-right-width: 5px;
  }

  .md\\:first\\:border-b-5:first-child{
    border-bottom-width: 5px;
  }

  .md\\:first\\:border-l-5:first-child{
    border-left-width: 5px;
  }

  .md\\:first\\:border-t-6:first-child{
    border-top-width: 6px;
  }

  .md\\:first\\:border-r-6:first-child{
    border-right-width: 6px;
  }

  .md\\:first\\:border-b-6:first-child{
    border-bottom-width: 6px;
  }

  .md\\:first\\:border-l-6:first-child{
    border-left-width: 6px;
  }

  .md\\:first\\:border-t-8:first-child{
    border-top-width: 8px;
  }

  .md\\:first\\:border-r-8:first-child{
    border-right-width: 8px;
  }

  .md\\:first\\:border-b-8:first-child{
    border-bottom-width: 8px;
  }

  .md\\:first\\:border-l-8:first-child{
    border-left-width: 8px;
  }

  .md\\:first\\:border-t:first-child{
    border-top-width: 1px;
  }

  .md\\:first\\:border-r:first-child{
    border-right-width: 1px;
  }

  .md\\:first\\:border-b:first-child{
    border-bottom-width: 1px;
  }

  .md\\:first\\:border-l:first-child{
    border-left-width: 1px;
  }

  .md\\:box-border{
    box-sizing: border-box;
  }

  .md\\:box-content{
    box-sizing: content-box;
  }

  .md\\:cursor-auto{
    cursor: auto;
  }

  .md\\:cursor-default{
    cursor: default;
  }

  .md\\:cursor-pointer{
    cursor: pointer;
  }

  .md\\:cursor-wait{
    cursor: wait;
  }

  .md\\:cursor-move{
    cursor: move;
  }

  .md\\:cursor-not-allowed{
    cursor: not-allowed;
  }

  .md\\:block{
    display: block;
  }

  .md\\:inline-block{
    display: inline-block;
  }

  .md\\:inline{
    display: inline;
  }

  .md\\:flex{
    display: flex;
  }

  .md\\:inline-flex{
    display: inline-flex;
  }

  .md\\:table{
    display: table;
  }

  .md\\:table-caption{
    display: table-caption;
  }

  .md\\:table-cell{
    display: table-cell;
  }

  .md\\:table-column{
    display: table-column;
  }

  .md\\:table-column-group{
    display: table-column-group;
  }

  .md\\:table-footer-group{
    display: table-footer-group;
  }

  .md\\:table-header-group{
    display: table-header-group;
  }

  .md\\:table-row-group{
    display: table-row-group;
  }

  .md\\:table-row{
    display: table-row;
  }

  .md\\:flow-root{
    display: flow-root;
  }

  .md\\:grid{
    display: grid;
  }

  .md\\:inline-grid{
    display: inline-grid;
  }

  .md\\:contents{
    display: contents;
  }

  .md\\:hidden{
    display: none;
  }

  .md\\:flex-row{
    flex-direction: row;
  }

  .md\\:flex-row-reverse{
    flex-direction: row-reverse;
  }

  .md\\:flex-col{
    flex-direction: column;
  }

  .md\\:flex-col-reverse{
    flex-direction: column-reverse;
  }

  .md\\:flex-wrap{
    flex-wrap: wrap;
  }

  .md\\:flex-wrap-reverse{
    flex-wrap: wrap-reverse;
  }

  .md\\:flex-no-wrap{
    flex-wrap: nowrap;
  }

  .md\\:place-items-auto{
    align-items: auto;
    justify-items: auto;
    place-items: auto;
  }

  .md\\:place-items-start{
    align-items: start;
    justify-items: start;
    place-items: start;
  }

  .md\\:place-items-end{
    align-items: end;
    justify-items: end;
    place-items: end;
  }

  .md\\:place-items-center{
    align-items: center;
    justify-items: center;
    place-items: center;
  }

  .md\\:place-items-stretch{
    align-items: stretch;
    justify-items: stretch;
    place-items: stretch;
  }

  .md\\:place-content-center{
    align-content: center;
    justify-content: center;
    place-content: center;
  }

  .md\\:place-content-start{
    align-content: start;
    justify-content: start;
    place-content: start;
  }

  .md\\:place-content-end{
    align-content: end;
    justify-content: end;
    place-content: end;
  }

  .md\\:place-content-between{
    align-content: space-between;
    justify-content: space-between;
    place-content: space-between;
  }

  .md\\:place-content-around{
    align-content: space-around;
    justify-content: space-around;
    place-content: space-around;
  }

  .md\\:place-content-evenly{
    align-content: space-evenly;
    justify-content: space-evenly;
    place-content: space-evenly;
  }

  .md\\:place-content-stretch{
    align-content: stretch;
    justify-content: stretch;
    place-content: stretch;
  }

  .md\\:place-self-auto{
    align-self: auto;
    justify-self: auto;
    place-self: auto;
  }

  .md\\:place-self-start{
    align-self: start;
    justify-self: start;
    place-self: start;
  }

  .md\\:place-self-end{
    align-self: end;
    justify-self: end;
    place-self: end;
  }

  .md\\:place-self-center{
    align-self: center;
    justify-self: center;
    place-self: center;
  }

  .md\\:place-self-stretch{
    align-self: stretch;
    justify-self: stretch;
    place-self: stretch;
  }

  .md\\:items-start{
    align-items: flex-start;
  }

  .md\\:items-end{
    align-items: flex-end;
  }

  .md\\:items-center{
    align-items: center;
  }

  .md\\:items-baseline{
    align-items: baseline;
  }

  .md\\:items-stretch{
    align-items: stretch;
  }

  .md\\:content-center{
    align-content: center;
  }

  .md\\:content-start{
    align-content: flex-start;
  }

  .md\\:content-end{
    align-content: flex-end;
  }

  .md\\:content-between{
    align-content: space-between;
  }

  .md\\:content-around{
    align-content: space-around;
  }

  .md\\:content-evenly{
    align-content: space-evenly;
  }

  .md\\:self-auto{
    align-self: auto;
  }

  .md\\:self-start{
    align-self: flex-start;
  }

  .md\\:self-end{
    align-self: flex-end;
  }

  .md\\:self-center{
    align-self: center;
  }

  .md\\:self-stretch{
    align-self: stretch;
  }

  .md\\:justify-items-auto{
    justify-items: auto;
  }

  .md\\:justify-items-start{
    justify-items: start;
  }

  .md\\:justify-items-end{
    justify-items: end;
  }

  .md\\:justify-items-center{
    justify-items: center;
  }

  .md\\:justify-items-stretch{
    justify-items: stretch;
  }

  .md\\:justify-start{
    justify-content: flex-start;
  }

  .md\\:justify-end{
    justify-content: flex-end;
  }

  .md\\:justify-center{
    justify-content: center;
  }

  .md\\:justify-between{
    justify-content: space-between;
  }

  .md\\:justify-around{
    justify-content: space-around;
  }

  .md\\:justify-evenly{
    justify-content: space-evenly;
  }

  .md\\:justify-self-auto{
    justify-self: auto;
  }

  .md\\:justify-self-start{
    justify-self: start;
  }

  .md\\:justify-self-end{
    justify-self: end;
  }

  .md\\:justify-self-center{
    justify-self: center;
  }

  .md\\:justify-self-stretch{
    justify-self: stretch;
  }

  .md\\:flex-1{
    flex: 1 1 0%;
  }

  .md\\:flex-auto{
    flex: 1 1 auto;
  }

  .md\\:flex-initial{
    flex: 0 1 auto;
  }

  .md\\:flex-none{
    flex: none;
  }

  .md\\:flex-grow-0{
    flex-grow: 0;
  }

  .md\\:flex-grow{
    flex-grow: 1;
  }

  .md\\:flex-shrink-0{
    flex-shrink: 0;
  }

  .md\\:flex-shrink{
    flex-shrink: 1;
  }

  .md\\:order-1{
    order: 1;
  }

  .md\\:order-2{
    order: 2;
  }

  .md\\:order-3{
    order: 3;
  }

  .md\\:order-4{
    order: 4;
  }

  .md\\:order-5{
    order: 5;
  }

  .md\\:order-6{
    order: 6;
  }

  .md\\:order-7{
    order: 7;
  }

  .md\\:order-8{
    order: 8;
  }

  .md\\:order-9{
    order: 9;
  }

  .md\\:order-10{
    order: 10;
  }

  .md\\:order-11{
    order: 11;
  }

  .md\\:order-12{
    order: 12;
  }

  .md\\:order-first{
    order: -9999;
  }

  .md\\:order-last{
    order: 9999;
  }

  .md\\:order-none{
    order: 0;
  }

  .md\\:float-right{
    float: right;
  }

  .md\\:float-left{
    float: left;
  }

  .md\\:float-none{
    float: none;
  }

  .md\\:clearfix:after{
    content: "";
    display: table;
    clear: both;
  }

  .md\\:clear-left{
    clear: left;
  }

  .md\\:clear-right{
    clear: right;
  }

  .md\\:clear-both{
    clear: both;
  }

  .md\\:clear-none{
    clear: none;
  }

  .md\\:font-sans{
    font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }

  .md\\:font-serif{
    font-family: Georgia, Cambria, "Times New Roman", Times, serif;
  }

  .md\\:font-mono{
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }

  .md\\:font-light{
    font-weight: 100;
  }

  .md\\:font-regular{
    font-weight: 400;
  }

  .md\\:font-semibold{
    font-weight: 600;
  }

  .md\\:font-bold{
    font-weight: 700;
  }

  .md\\:hover\\:font-light:hover{
    font-weight: 100;
  }

  .md\\:hover\\:font-regular:hover{
    font-weight: 400;
  }

  .md\\:hover\\:font-semibold:hover{
    font-weight: 600;
  }

  .md\\:hover\\:font-bold:hover{
    font-weight: 700;
  }

  .md\\:focus\\:font-light:focus{
    font-weight: 100;
  }

  .md\\:focus\\:font-regular:focus{
    font-weight: 400;
  }

  .md\\:focus\\:font-semibold:focus{
    font-weight: 600;
  }

  .md\\:focus\\:font-bold:focus{
    font-weight: 700;
  }

  .md\\:h-0{
    height: 0;
  }

  .md\\:h-1{
    height: 0.25rem;
  }

  .md\\:h-2{
    height: 0.5rem;
  }

  .md\\:h-3{
    height: 0.75rem;
  }

  .md\\:h-4{
    height: 1rem;
  }

  .md\\:h-5{
    height: 1.25rem;
  }

  .md\\:h-6{
    height: 1.5rem;
  }

  .md\\:h-7{
    height: 1.75rem;
  }

  .md\\:h-8{
    height: 2rem;
  }

  .md\\:h-9{
    height: 2.25rem;
  }

  .md\\:h-10{
    height: 2.5rem;
  }

  .md\\:h-11{
    height: 2.75rem;
  }

  .md\\:h-12{
    height: 3rem;
  }

  .md\\:h-14{
    height: 3.5rem;
  }

  .md\\:h-15{
    height: 3.75rem;
  }

  .md\\:h-16{
    height: 4rem;
  }

  .md\\:h-18{
    height: 4.5rem;
  }

  .md\\:h-20{
    height: 5rem;
  }

  .md\\:h-22{
    height: 5.5rem;
  }

  .md\\:h-23{
    height: 5.75rem;
  }

  .md\\:h-24{
    height: 6rem;
  }

  .md\\:h-25{
    height: 6.25rem;
  }

  .md\\:h-26{
    height: 6.5rem;
  }

  .md\\:h-28{
    height: 7rem;
  }

  .md\\:h-30{
    height: 7.5rem;
  }

  .md\\:h-32{
    height: 8rem;
  }

  .md\\:h-34{
    height: 8.5rem;
  }

  .md\\:h-40{
    height: 10rem;
  }

  .md\\:h-42{
    height: 10.5rem;
  }

  .md\\:h-44{
    height: 11rem;
  }

  .md\\:h-48{
    height: 12rem;
  }

  .md\\:h-52{
    height: 13rem;
  }

  .md\\:h-54{
    height: 13.5rem;
  }

  .md\\:h-56{
    height: 14rem;
  }

  .md\\:h-60{
    height: 15rem;
  }

  .md\\:h-64{
    height: 16rem;
  }

  .md\\:h-68{
    height: 17rem;
  }

  .md\\:h-72{
    height: 18rem;
  }

  .md\\:h-74{
    height: 18.5rem;
  }

  .md\\:h-76{
    height: 19rem;
  }

  .md\\:h-78{
    height: 19.5rem;
  }

  .md\\:h-80{
    height: 20rem;
  }

  .md\\:h-82{
    height: 20.5rem;
  }

  .md\\:h-84{
    height: 21rem;
  }

  .md\\:h-88{
    height: 22rem;
  }

  .md\\:h-92{
    height: 23rem;
  }

  .md\\:h-96{
    height: 24rem;
  }

  .md\\:h-98{
    height: 24.5rem;
  }

  .md\\:h-100{
    height: 25rem;
  }

  .md\\:h-104{
    height: 26rem;
  }

  .md\\:h-112{
    height: 28rem;
  }

  .md\\:h-124{
    height: 31rem;
  }

  .md\\:h-128{
    height: 32rem;
  }

  .md\\:h-140{
    height: 35rem;
  }

  .md\\:h-152{
    height: 38rem;
  }

  .md\\:h-160{
    height: 40rem;
  }

  .md\\:h-162{
    height: 41rem;
  }

  .md\\:h-192{
    height: 48rem;
  }

  .md\\:h-208{
    height: 52rem;
  }

  .md\\:h-224{
    height: 56rem;
  }

  .md\\:h-256{
    height: 64rem;
  }

  .md\\:h-auto{
    height: auto;
  }

  .md\\:h-px{
    height: 1px;
  }

  .md\\:h-full{
    height: 100%;
  }

  .md\\:h-screen{
    height: 100vh;
  }

  .md\\:text-xs{
    font-size: 0.74rem;
  }

  .md\\:text-sm{
    font-size: 0.86rem;
  }

  .md\\:text-base{
    font-size: 1rem;
  }

  .md\\:text-lg{
    font-size: 1.15rem;
  }

  .md\\:text-xl{
    font-size: 1.42rem;
  }

  .md\\:text-2xl{
    font-size: 1.85rem;
  }

  .md\\:text-3xl{
    font-size: 1.95rem;
  }

  .md\\:text-4xl{
    font-size: 2.25rem;
  }

  .md\\:text-5xl{
    font-size: 3rem;
  }

  .md\\:text-6xl{
    font-size: 4rem;
  }

  .md\\:text-7xl{
    font-size: 5rem;
  }

  .md\\:leading-none{
    line-height: 1;
  }

  .md\\:leading-tight{
    line-height: 1.2;
  }

  .md\\:leading-snug{
    line-height: 1.3;
  }

  .md\\:leading-normal{
    line-height: 1.4;
  }

  .md\\:leading-relaxed{
    line-height: 1.6;
  }

  .md\\:list-inside{
    list-style-position: inside;
  }

  .md\\:list-outside{
    list-style-position: outside;
  }

  .md\\:list-none{
    list-style-type: none;
  }

  .md\\:list-disc{
    list-style-type: disc;
  }

  .md\\:list-decimal{
    list-style-type: decimal;
  }

  .md\\:m-0{
    margin: 0;
  }

  .md\\:m-1{
    margin: 0.25rem;
  }

  .md\\:m-2{
    margin: 0.5rem;
  }

  .md\\:m-3{
    margin: 0.75rem;
  }

  .md\\:m-4{
    margin: 1rem;
  }

  .md\\:m-5{
    margin: 1.25rem;
  }

  .md\\:m-6{
    margin: 1.5rem;
  }

  .md\\:m-7{
    margin: 1.75rem;
  }

  .md\\:m-8{
    margin: 2rem;
  }

  .md\\:m-9{
    margin: 2.25rem;
  }

  .md\\:m-10{
    margin: 2.5rem;
  }

  .md\\:m-11{
    margin: 2.75rem;
  }

  .md\\:m-12{
    margin: 3rem;
  }

  .md\\:m-14{
    margin: 3.5rem;
  }

  .md\\:m-15{
    margin: 3.75rem;
  }

  .md\\:m-16{
    margin: 4rem;
  }

  .md\\:m-18{
    margin: 4.5rem;
  }

  .md\\:m-20{
    margin: 5rem;
  }

  .md\\:m-22{
    margin: 5.5rem;
  }

  .md\\:m-23{
    margin: 5.75rem;
  }

  .md\\:m-24{
    margin: 6rem;
  }

  .md\\:m-25{
    margin: 6.25rem;
  }

  .md\\:m-26{
    margin: 6.5rem;
  }

  .md\\:m-28{
    margin: 7rem;
  }

  .md\\:m-30{
    margin: 7.5rem;
  }

  .md\\:m-32{
    margin: 8rem;
  }

  .md\\:m-34{
    margin: 8.5rem;
  }

  .md\\:m-40{
    margin: 10rem;
  }

  .md\\:m-42{
    margin: 10.5rem;
  }

  .md\\:m-44{
    margin: 11rem;
  }

  .md\\:m-48{
    margin: 12rem;
  }

  .md\\:m-52{
    margin: 13rem;
  }

  .md\\:m-54{
    margin: 13.5rem;
  }

  .md\\:m-56{
    margin: 14rem;
  }

  .md\\:m-60{
    margin: 15rem;
  }

  .md\\:m-64{
    margin: 16rem;
  }

  .md\\:m-68{
    margin: 17rem;
  }

  .md\\:m-72{
    margin: 18rem;
  }

  .md\\:m-74{
    margin: 18.5rem;
  }

  .md\\:m-76{
    margin: 19rem;
  }

  .md\\:m-78{
    margin: 19.5rem;
  }

  .md\\:m-80{
    margin: 20rem;
  }

  .md\\:m-82{
    margin: 20.5rem;
  }

  .md\\:m-84{
    margin: 21rem;
  }

  .md\\:m-88{
    margin: 22rem;
  }

  .md\\:m-92{
    margin: 23rem;
  }

  .md\\:m-96{
    margin: 24rem;
  }

  .md\\:m-98{
    margin: 24.5rem;
  }

  .md\\:m-100{
    margin: 25rem;
  }

  .md\\:m-104{
    margin: 26rem;
  }

  .md\\:m-112{
    margin: 28rem;
  }

  .md\\:m-124{
    margin: 31rem;
  }

  .md\\:m-128{
    margin: 32rem;
  }

  .md\\:m-140{
    margin: 35rem;
  }

  .md\\:m-152{
    margin: 38rem;
  }

  .md\\:m-160{
    margin: 40rem;
  }

  .md\\:m-162{
    margin: 41rem;
  }

  .md\\:m-192{
    margin: 48rem;
  }

  .md\\:m-208{
    margin: 52rem;
  }

  .md\\:m-224{
    margin: 56rem;
  }

  .md\\:m-256{
    margin: 64rem;
  }

  .md\\:m-auto{
    margin: auto;
  }

  .md\\:m-px{
    margin: 1px;
  }

  .md\\:-m-1{
    margin: -0.25rem;
  }

  .md\\:-m-2{
    margin: -0.5rem;
  }

  .md\\:-m-3{
    margin: -0.75rem;
  }

  .md\\:-m-4{
    margin: -1rem;
  }

  .md\\:-m-5{
    margin: -1.25rem;
  }

  .md\\:-m-6{
    margin: -1.5rem;
  }

  .md\\:-m-7{
    margin: -1.75rem;
  }

  .md\\:-m-8{
    margin: -2rem;
  }

  .md\\:-m-9{
    margin: -2.25rem;
  }

  .md\\:-m-10{
    margin: -2.5rem;
  }

  .md\\:-m-11{
    margin: -2.75rem;
  }

  .md\\:-m-12{
    margin: -3rem;
  }

  .md\\:-m-14{
    margin: -3.5rem;
  }

  .md\\:-m-15{
    margin: -3.75rem;
  }

  .md\\:-m-16{
    margin: -4rem;
  }

  .md\\:-m-18{
    margin: -4.5rem;
  }

  .md\\:-m-20{
    margin: -5rem;
  }

  .md\\:-m-22{
    margin: -5.5rem;
  }

  .md\\:-m-23{
    margin: -5.75rem;
  }

  .md\\:-m-24{
    margin: -6rem;
  }

  .md\\:-m-25{
    margin: -6.25rem;
  }

  .md\\:-m-26{
    margin: -6.5rem;
  }

  .md\\:-m-28{
    margin: -7rem;
  }

  .md\\:-m-30{
    margin: -7.5rem;
  }

  .md\\:-m-32{
    margin: -8rem;
  }

  .md\\:-m-34{
    margin: -8.5rem;
  }

  .md\\:-m-40{
    margin: -10rem;
  }

  .md\\:-m-42{
    margin: -10.5rem;
  }

  .md\\:-m-44{
    margin: -11rem;
  }

  .md\\:-m-48{
    margin: -12rem;
  }

  .md\\:-m-52{
    margin: -13rem;
  }

  .md\\:-m-54{
    margin: -13.5rem;
  }

  .md\\:-m-56{
    margin: -14rem;
  }

  .md\\:-m-60{
    margin: -15rem;
  }

  .md\\:-m-64{
    margin: -16rem;
  }

  .md\\:-m-68{
    margin: -17rem;
  }

  .md\\:-m-72{
    margin: -18rem;
  }

  .md\\:-m-74{
    margin: -18.5rem;
  }

  .md\\:-m-76{
    margin: -19rem;
  }

  .md\\:-m-78{
    margin: -19.5rem;
  }

  .md\\:-m-80{
    margin: -20rem;
  }

  .md\\:-m-82{
    margin: -20.5rem;
  }

  .md\\:-m-84{
    margin: -21rem;
  }

  .md\\:-m-88{
    margin: -22rem;
  }

  .md\\:-m-92{
    margin: -23rem;
  }

  .md\\:-m-96{
    margin: -24rem;
  }

  .md\\:-m-98{
    margin: -24.5rem;
  }

  .md\\:-m-100{
    margin: -25rem;
  }

  .md\\:-m-104{
    margin: -26rem;
  }

  .md\\:-m-112{
    margin: -28rem;
  }

  .md\\:-m-124{
    margin: -31rem;
  }

  .md\\:-m-128{
    margin: -32rem;
  }

  .md\\:-m-140{
    margin: -35rem;
  }

  .md\\:-m-152{
    margin: -38rem;
  }

  .md\\:-m-160{
    margin: -40rem;
  }

  .md\\:-m-162{
    margin: -41rem;
  }

  .md\\:-m-192{
    margin: -48rem;
  }

  .md\\:-m-208{
    margin: -52rem;
  }

  .md\\:-m-224{
    margin: -56rem;
  }

  .md\\:-m-256{
    margin: -64rem;
  }

  .md\\:-m-px{
    margin: -1px;
  }

  .md\\:my-0{
    margin-top: 0;
    margin-bottom: 0;
  }

  .md\\:mx-0{
    margin-left: 0;
    margin-right: 0;
  }

  .md\\:my-1{
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .md\\:mx-1{
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .md\\:my-2{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .md\\:mx-2{
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .md\\:my-3{
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .md\\:mx-3{
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .md\\:my-4{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .md\\:mx-4{
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .md\\:my-5{
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .md\\:mx-5{
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .md\\:my-6{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .md\\:mx-6{
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .md\\:my-7{
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }

  .md\\:mx-7{
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }

  .md\\:my-8{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .md\\:mx-8{
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .md\\:my-9{
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }

  .md\\:mx-9{
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }

  .md\\:my-10{
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .md\\:mx-10{
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .md\\:my-11{
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;
  }

  .md\\:mx-11{
    margin-left: 2.75rem;
    margin-right: 2.75rem;
  }

  .md\\:my-12{
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .md\\:mx-12{
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .md\\:my-14{
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
  }

  .md\\:mx-14{
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }

  .md\\:my-15{
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
  }

  .md\\:mx-15{
    margin-left: 3.75rem;
    margin-right: 3.75rem;
  }

  .md\\:my-16{
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .md\\:mx-16{
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .md\\:my-18{
    margin-top: 4.5rem;
    margin-bottom: 4.5rem;
  }

  .md\\:mx-18{
    margin-left: 4.5rem;
    margin-right: 4.5rem;
  }

  .md\\:my-20{
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .md\\:mx-20{
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .md\\:my-22{
    margin-top: 5.5rem;
    margin-bottom: 5.5rem;
  }

  .md\\:mx-22{
    margin-left: 5.5rem;
    margin-right: 5.5rem;
  }

  .md\\:my-23{
    margin-top: 5.75rem;
    margin-bottom: 5.75rem;
  }

  .md\\:mx-23{
    margin-left: 5.75rem;
    margin-right: 5.75rem;
  }

  .md\\:my-24{
    margin-top: 6rem;
    margin-bottom: 6rem;
  }

  .md\\:mx-24{
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .md\\:my-25{
    margin-top: 6.25rem;
    margin-bottom: 6.25rem;
  }

  .md\\:mx-25{
    margin-left: 6.25rem;
    margin-right: 6.25rem;
  }

  .md\\:my-26{
    margin-top: 6.5rem;
    margin-bottom: 6.5rem;
  }

  .md\\:mx-26{
    margin-left: 6.5rem;
    margin-right: 6.5rem;
  }

  .md\\:my-28{
    margin-top: 7rem;
    margin-bottom: 7rem;
  }

  .md\\:mx-28{
    margin-left: 7rem;
    margin-right: 7rem;
  }

  .md\\:my-30{
    margin-top: 7.5rem;
    margin-bottom: 7.5rem;
  }

  .md\\:mx-30{
    margin-left: 7.5rem;
    margin-right: 7.5rem;
  }

  .md\\:my-32{
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  .md\\:mx-32{
    margin-left: 8rem;
    margin-right: 8rem;
  }

  .md\\:my-34{
    margin-top: 8.5rem;
    margin-bottom: 8.5rem;
  }

  .md\\:mx-34{
    margin-left: 8.5rem;
    margin-right: 8.5rem;
  }

  .md\\:my-40{
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .md\\:mx-40{
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .md\\:my-42{
    margin-top: 10.5rem;
    margin-bottom: 10.5rem;
  }

  .md\\:mx-42{
    margin-left: 10.5rem;
    margin-right: 10.5rem;
  }

  .md\\:my-44{
    margin-top: 11rem;
    margin-bottom: 11rem;
  }

  .md\\:mx-44{
    margin-left: 11rem;
    margin-right: 11rem;
  }

  .md\\:my-48{
    margin-top: 12rem;
    margin-bottom: 12rem;
  }

  .md\\:mx-48{
    margin-left: 12rem;
    margin-right: 12rem;
  }

  .md\\:my-52{
    margin-top: 13rem;
    margin-bottom: 13rem;
  }

  .md\\:mx-52{
    margin-left: 13rem;
    margin-right: 13rem;
  }

  .md\\:my-54{
    margin-top: 13.5rem;
    margin-bottom: 13.5rem;
  }

  .md\\:mx-54{
    margin-left: 13.5rem;
    margin-right: 13.5rem;
  }

  .md\\:my-56{
    margin-top: 14rem;
    margin-bottom: 14rem;
  }

  .md\\:mx-56{
    margin-left: 14rem;
    margin-right: 14rem;
  }

  .md\\:my-60{
    margin-top: 15rem;
    margin-bottom: 15rem;
  }

  .md\\:mx-60{
    margin-left: 15rem;
    margin-right: 15rem;
  }

  .md\\:my-64{
    margin-top: 16rem;
    margin-bottom: 16rem;
  }

  .md\\:mx-64{
    margin-left: 16rem;
    margin-right: 16rem;
  }

  .md\\:my-68{
    margin-top: 17rem;
    margin-bottom: 17rem;
  }

  .md\\:mx-68{
    margin-left: 17rem;
    margin-right: 17rem;
  }

  .md\\:my-72{
    margin-top: 18rem;
    margin-bottom: 18rem;
  }

  .md\\:mx-72{
    margin-left: 18rem;
    margin-right: 18rem;
  }

  .md\\:my-74{
    margin-top: 18.5rem;
    margin-bottom: 18.5rem;
  }

  .md\\:mx-74{
    margin-left: 18.5rem;
    margin-right: 18.5rem;
  }

  .md\\:my-76{
    margin-top: 19rem;
    margin-bottom: 19rem;
  }

  .md\\:mx-76{
    margin-left: 19rem;
    margin-right: 19rem;
  }

  .md\\:my-78{
    margin-top: 19.5rem;
    margin-bottom: 19.5rem;
  }

  .md\\:mx-78{
    margin-left: 19.5rem;
    margin-right: 19.5rem;
  }

  .md\\:my-80{
    margin-top: 20rem;
    margin-bottom: 20rem;
  }

  .md\\:mx-80{
    margin-left: 20rem;
    margin-right: 20rem;
  }

  .md\\:my-82{
    margin-top: 20.5rem;
    margin-bottom: 20.5rem;
  }

  .md\\:mx-82{
    margin-left: 20.5rem;
    margin-right: 20.5rem;
  }

  .md\\:my-84{
    margin-top: 21rem;
    margin-bottom: 21rem;
  }

  .md\\:mx-84{
    margin-left: 21rem;
    margin-right: 21rem;
  }

  .md\\:my-88{
    margin-top: 22rem;
    margin-bottom: 22rem;
  }

  .md\\:mx-88{
    margin-left: 22rem;
    margin-right: 22rem;
  }

  .md\\:my-92{
    margin-top: 23rem;
    margin-bottom: 23rem;
  }

  .md\\:mx-92{
    margin-left: 23rem;
    margin-right: 23rem;
  }

  .md\\:my-96{
    margin-top: 24rem;
    margin-bottom: 24rem;
  }

  .md\\:mx-96{
    margin-left: 24rem;
    margin-right: 24rem;
  }

  .md\\:my-98{
    margin-top: 24.5rem;
    margin-bottom: 24.5rem;
  }

  .md\\:mx-98{
    margin-left: 24.5rem;
    margin-right: 24.5rem;
  }

  .md\\:my-100{
    margin-top: 25rem;
    margin-bottom: 25rem;
  }

  .md\\:mx-100{
    margin-left: 25rem;
    margin-right: 25rem;
  }

  .md\\:my-104{
    margin-top: 26rem;
    margin-bottom: 26rem;
  }

  .md\\:mx-104{
    margin-left: 26rem;
    margin-right: 26rem;
  }

  .md\\:my-112{
    margin-top: 28rem;
    margin-bottom: 28rem;
  }

  .md\\:mx-112{
    margin-left: 28rem;
    margin-right: 28rem;
  }

  .md\\:my-124{
    margin-top: 31rem;
    margin-bottom: 31rem;
  }

  .md\\:mx-124{
    margin-left: 31rem;
    margin-right: 31rem;
  }

  .md\\:my-128{
    margin-top: 32rem;
    margin-bottom: 32rem;
  }

  .md\\:mx-128{
    margin-left: 32rem;
    margin-right: 32rem;
  }

  .md\\:my-140{
    margin-top: 35rem;
    margin-bottom: 35rem;
  }

  .md\\:mx-140{
    margin-left: 35rem;
    margin-right: 35rem;
  }

  .md\\:my-152{
    margin-top: 38rem;
    margin-bottom: 38rem;
  }

  .md\\:mx-152{
    margin-left: 38rem;
    margin-right: 38rem;
  }

  .md\\:my-160{
    margin-top: 40rem;
    margin-bottom: 40rem;
  }

  .md\\:mx-160{
    margin-left: 40rem;
    margin-right: 40rem;
  }

  .md\\:my-162{
    margin-top: 41rem;
    margin-bottom: 41rem;
  }

  .md\\:mx-162{
    margin-left: 41rem;
    margin-right: 41rem;
  }

  .md\\:my-192{
    margin-top: 48rem;
    margin-bottom: 48rem;
  }

  .md\\:mx-192{
    margin-left: 48rem;
    margin-right: 48rem;
  }

  .md\\:my-208{
    margin-top: 52rem;
    margin-bottom: 52rem;
  }

  .md\\:mx-208{
    margin-left: 52rem;
    margin-right: 52rem;
  }

  .md\\:my-224{
    margin-top: 56rem;
    margin-bottom: 56rem;
  }

  .md\\:mx-224{
    margin-left: 56rem;
    margin-right: 56rem;
  }

  .md\\:my-256{
    margin-top: 64rem;
    margin-bottom: 64rem;
  }

  .md\\:mx-256{
    margin-left: 64rem;
    margin-right: 64rem;
  }

  .md\\:my-auto{
    margin-top: auto;
    margin-bottom: auto;
  }

  .md\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }

  .md\\:my-px{
    margin-top: 1px;
    margin-bottom: 1px;
  }

  .md\\:mx-px{
    margin-left: 1px;
    margin-right: 1px;
  }

  .md\\:-my-1{
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .md\\:-mx-1{
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .md\\:-my-2{
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }

  .md\\:-mx-2{
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .md\\:-my-3{
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }

  .md\\:-mx-3{
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .md\\:-my-4{
    margin-top: -1rem;
    margin-bottom: -1rem;
  }

  .md\\:-mx-4{
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .md\\:-my-5{
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }

  .md\\:-mx-5{
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .md\\:-my-6{
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }

  .md\\:-mx-6{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .md\\:-my-7{
    margin-top: -1.75rem;
    margin-bottom: -1.75rem;
  }

  .md\\:-mx-7{
    margin-left: -1.75rem;
    margin-right: -1.75rem;
  }

  .md\\:-my-8{
    margin-top: -2rem;
    margin-bottom: -2rem;
  }

  .md\\:-mx-8{
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .md\\:-my-9{
    margin-top: -2.25rem;
    margin-bottom: -2.25rem;
  }

  .md\\:-mx-9{
    margin-left: -2.25rem;
    margin-right: -2.25rem;
  }

  .md\\:-my-10{
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }

  .md\\:-mx-10{
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .md\\:-my-11{
    margin-top: -2.75rem;
    margin-bottom: -2.75rem;
  }

  .md\\:-mx-11{
    margin-left: -2.75rem;
    margin-right: -2.75rem;
  }

  .md\\:-my-12{
    margin-top: -3rem;
    margin-bottom: -3rem;
  }

  .md\\:-mx-12{
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .md\\:-my-14{
    margin-top: -3.5rem;
    margin-bottom: -3.5rem;
  }

  .md\\:-mx-14{
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }

  .md\\:-my-15{
    margin-top: -3.75rem;
    margin-bottom: -3.75rem;
  }

  .md\\:-mx-15{
    margin-left: -3.75rem;
    margin-right: -3.75rem;
  }

  .md\\:-my-16{
    margin-top: -4rem;
    margin-bottom: -4rem;
  }

  .md\\:-mx-16{
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .md\\:-my-18{
    margin-top: -4.5rem;
    margin-bottom: -4.5rem;
  }

  .md\\:-mx-18{
    margin-left: -4.5rem;
    margin-right: -4.5rem;
  }

  .md\\:-my-20{
    margin-top: -5rem;
    margin-bottom: -5rem;
  }

  .md\\:-mx-20{
    margin-left: -5rem;
    margin-right: -5rem;
  }

  .md\\:-my-22{
    margin-top: -5.5rem;
    margin-bottom: -5.5rem;
  }

  .md\\:-mx-22{
    margin-left: -5.5rem;
    margin-right: -5.5rem;
  }

  .md\\:-my-23{
    margin-top: -5.75rem;
    margin-bottom: -5.75rem;
  }

  .md\\:-mx-23{
    margin-left: -5.75rem;
    margin-right: -5.75rem;
  }

  .md\\:-my-24{
    margin-top: -6rem;
    margin-bottom: -6rem;
  }

  .md\\:-mx-24{
    margin-left: -6rem;
    margin-right: -6rem;
  }

  .md\\:-my-25{
    margin-top: -6.25rem;
    margin-bottom: -6.25rem;
  }

  .md\\:-mx-25{
    margin-left: -6.25rem;
    margin-right: -6.25rem;
  }

  .md\\:-my-26{
    margin-top: -6.5rem;
    margin-bottom: -6.5rem;
  }

  .md\\:-mx-26{
    margin-left: -6.5rem;
    margin-right: -6.5rem;
  }

  .md\\:-my-28{
    margin-top: -7rem;
    margin-bottom: -7rem;
  }

  .md\\:-mx-28{
    margin-left: -7rem;
    margin-right: -7rem;
  }

  .md\\:-my-30{
    margin-top: -7.5rem;
    margin-bottom: -7.5rem;
  }

  .md\\:-mx-30{
    margin-left: -7.5rem;
    margin-right: -7.5rem;
  }

  .md\\:-my-32{
    margin-top: -8rem;
    margin-bottom: -8rem;
  }

  .md\\:-mx-32{
    margin-left: -8rem;
    margin-right: -8rem;
  }

  .md\\:-my-34{
    margin-top: -8.5rem;
    margin-bottom: -8.5rem;
  }

  .md\\:-mx-34{
    margin-left: -8.5rem;
    margin-right: -8.5rem;
  }

  .md\\:-my-40{
    margin-top: -10rem;
    margin-bottom: -10rem;
  }

  .md\\:-mx-40{
    margin-left: -10rem;
    margin-right: -10rem;
  }

  .md\\:-my-42{
    margin-top: -10.5rem;
    margin-bottom: -10.5rem;
  }

  .md\\:-mx-42{
    margin-left: -10.5rem;
    margin-right: -10.5rem;
  }

  .md\\:-my-44{
    margin-top: -11rem;
    margin-bottom: -11rem;
  }

  .md\\:-mx-44{
    margin-left: -11rem;
    margin-right: -11rem;
  }

  .md\\:-my-48{
    margin-top: -12rem;
    margin-bottom: -12rem;
  }

  .md\\:-mx-48{
    margin-left: -12rem;
    margin-right: -12rem;
  }

  .md\\:-my-52{
    margin-top: -13rem;
    margin-bottom: -13rem;
  }

  .md\\:-mx-52{
    margin-left: -13rem;
    margin-right: -13rem;
  }

  .md\\:-my-54{
    margin-top: -13.5rem;
    margin-bottom: -13.5rem;
  }

  .md\\:-mx-54{
    margin-left: -13.5rem;
    margin-right: -13.5rem;
  }

  .md\\:-my-56{
    margin-top: -14rem;
    margin-bottom: -14rem;
  }

  .md\\:-mx-56{
    margin-left: -14rem;
    margin-right: -14rem;
  }

  .md\\:-my-60{
    margin-top: -15rem;
    margin-bottom: -15rem;
  }

  .md\\:-mx-60{
    margin-left: -15rem;
    margin-right: -15rem;
  }

  .md\\:-my-64{
    margin-top: -16rem;
    margin-bottom: -16rem;
  }

  .md\\:-mx-64{
    margin-left: -16rem;
    margin-right: -16rem;
  }

  .md\\:-my-68{
    margin-top: -17rem;
    margin-bottom: -17rem;
  }

  .md\\:-mx-68{
    margin-left: -17rem;
    margin-right: -17rem;
  }

  .md\\:-my-72{
    margin-top: -18rem;
    margin-bottom: -18rem;
  }

  .md\\:-mx-72{
    margin-left: -18rem;
    margin-right: -18rem;
  }

  .md\\:-my-74{
    margin-top: -18.5rem;
    margin-bottom: -18.5rem;
  }

  .md\\:-mx-74{
    margin-left: -18.5rem;
    margin-right: -18.5rem;
  }

  .md\\:-my-76{
    margin-top: -19rem;
    margin-bottom: -19rem;
  }

  .md\\:-mx-76{
    margin-left: -19rem;
    margin-right: -19rem;
  }

  .md\\:-my-78{
    margin-top: -19.5rem;
    margin-bottom: -19.5rem;
  }

  .md\\:-mx-78{
    margin-left: -19.5rem;
    margin-right: -19.5rem;
  }

  .md\\:-my-80{
    margin-top: -20rem;
    margin-bottom: -20rem;
  }

  .md\\:-mx-80{
    margin-left: -20rem;
    margin-right: -20rem;
  }

  .md\\:-my-82{
    margin-top: -20.5rem;
    margin-bottom: -20.5rem;
  }

  .md\\:-mx-82{
    margin-left: -20.5rem;
    margin-right: -20.5rem;
  }

  .md\\:-my-84{
    margin-top: -21rem;
    margin-bottom: -21rem;
  }

  .md\\:-mx-84{
    margin-left: -21rem;
    margin-right: -21rem;
  }

  .md\\:-my-88{
    margin-top: -22rem;
    margin-bottom: -22rem;
  }

  .md\\:-mx-88{
    margin-left: -22rem;
    margin-right: -22rem;
  }

  .md\\:-my-92{
    margin-top: -23rem;
    margin-bottom: -23rem;
  }

  .md\\:-mx-92{
    margin-left: -23rem;
    margin-right: -23rem;
  }

  .md\\:-my-96{
    margin-top: -24rem;
    margin-bottom: -24rem;
  }

  .md\\:-mx-96{
    margin-left: -24rem;
    margin-right: -24rem;
  }

  .md\\:-my-98{
    margin-top: -24.5rem;
    margin-bottom: -24.5rem;
  }

  .md\\:-mx-98{
    margin-left: -24.5rem;
    margin-right: -24.5rem;
  }

  .md\\:-my-100{
    margin-top: -25rem;
    margin-bottom: -25rem;
  }

  .md\\:-mx-100{
    margin-left: -25rem;
    margin-right: -25rem;
  }

  .md\\:-my-104{
    margin-top: -26rem;
    margin-bottom: -26rem;
  }

  .md\\:-mx-104{
    margin-left: -26rem;
    margin-right: -26rem;
  }

  .md\\:-my-112{
    margin-top: -28rem;
    margin-bottom: -28rem;
  }

  .md\\:-mx-112{
    margin-left: -28rem;
    margin-right: -28rem;
  }

  .md\\:-my-124{
    margin-top: -31rem;
    margin-bottom: -31rem;
  }

  .md\\:-mx-124{
    margin-left: -31rem;
    margin-right: -31rem;
  }

  .md\\:-my-128{
    margin-top: -32rem;
    margin-bottom: -32rem;
  }

  .md\\:-mx-128{
    margin-left: -32rem;
    margin-right: -32rem;
  }

  .md\\:-my-140{
    margin-top: -35rem;
    margin-bottom: -35rem;
  }

  .md\\:-mx-140{
    margin-left: -35rem;
    margin-right: -35rem;
  }

  .md\\:-my-152{
    margin-top: -38rem;
    margin-bottom: -38rem;
  }

  .md\\:-mx-152{
    margin-left: -38rem;
    margin-right: -38rem;
  }

  .md\\:-my-160{
    margin-top: -40rem;
    margin-bottom: -40rem;
  }

  .md\\:-mx-160{
    margin-left: -40rem;
    margin-right: -40rem;
  }

  .md\\:-my-162{
    margin-top: -41rem;
    margin-bottom: -41rem;
  }

  .md\\:-mx-162{
    margin-left: -41rem;
    margin-right: -41rem;
  }

  .md\\:-my-192{
    margin-top: -48rem;
    margin-bottom: -48rem;
  }

  .md\\:-mx-192{
    margin-left: -48rem;
    margin-right: -48rem;
  }

  .md\\:-my-208{
    margin-top: -52rem;
    margin-bottom: -52rem;
  }

  .md\\:-mx-208{
    margin-left: -52rem;
    margin-right: -52rem;
  }

  .md\\:-my-224{
    margin-top: -56rem;
    margin-bottom: -56rem;
  }

  .md\\:-mx-224{
    margin-left: -56rem;
    margin-right: -56rem;
  }

  .md\\:-my-256{
    margin-top: -64rem;
    margin-bottom: -64rem;
  }

  .md\\:-mx-256{
    margin-left: -64rem;
    margin-right: -64rem;
  }

  .md\\:-my-px{
    margin-top: -1px;
    margin-bottom: -1px;
  }

  .md\\:-mx-px{
    margin-left: -1px;
    margin-right: -1px;
  }

  .md\\:mt-0{
    margin-top: 0;
  }

  .md\\:mr-0{
    margin-right: 0;
  }

  .md\\:mb-0{
    margin-bottom: 0;
  }

  .md\\:ml-0{
    margin-left: 0;
  }

  .md\\:mt-1{
    margin-top: 0.25rem;
  }

  .md\\:mr-1{
    margin-right: 0.25rem;
  }

  .md\\:mb-1{
    margin-bottom: 0.25rem;
  }

  .md\\:ml-1{
    margin-left: 0.25rem;
  }

  .md\\:mt-2{
    margin-top: 0.5rem;
  }

  .md\\:mr-2{
    margin-right: 0.5rem;
  }

  .md\\:mb-2{
    margin-bottom: 0.5rem;
  }

  .md\\:ml-2{
    margin-left: 0.5rem;
  }

  .md\\:mt-3{
    margin-top: 0.75rem;
  }

  .md\\:mr-3{
    margin-right: 0.75rem;
  }

  .md\\:mb-3{
    margin-bottom: 0.75rem;
  }

  .md\\:ml-3{
    margin-left: 0.75rem;
  }

  .md\\:mt-4{
    margin-top: 1rem;
  }

  .md\\:mr-4{
    margin-right: 1rem;
  }

  .md\\:mb-4{
    margin-bottom: 1rem;
  }

  .md\\:ml-4{
    margin-left: 1rem;
  }

  .md\\:mt-5{
    margin-top: 1.25rem;
  }

  .md\\:mr-5{
    margin-right: 1.25rem;
  }

  .md\\:mb-5{
    margin-bottom: 1.25rem;
  }

  .md\\:ml-5{
    margin-left: 1.25rem;
  }

  .md\\:mt-6{
    margin-top: 1.5rem;
  }

  .md\\:mr-6{
    margin-right: 1.5rem;
  }

  .md\\:mb-6{
    margin-bottom: 1.5rem;
  }

  .md\\:ml-6{
    margin-left: 1.5rem;
  }

  .md\\:mt-7{
    margin-top: 1.75rem;
  }

  .md\\:mr-7{
    margin-right: 1.75rem;
  }

  .md\\:mb-7{
    margin-bottom: 1.75rem;
  }

  .md\\:ml-7{
    margin-left: 1.75rem;
  }

  .md\\:mt-8{
    margin-top: 2rem;
  }

  .md\\:mr-8{
    margin-right: 2rem;
  }

  .md\\:mb-8{
    margin-bottom: 2rem;
  }

  .md\\:ml-8{
    margin-left: 2rem;
  }

  .md\\:mt-9{
    margin-top: 2.25rem;
  }

  .md\\:mr-9{
    margin-right: 2.25rem;
  }

  .md\\:mb-9{
    margin-bottom: 2.25rem;
  }

  .md\\:ml-9{
    margin-left: 2.25rem;
  }

  .md\\:mt-10{
    margin-top: 2.5rem;
  }

  .md\\:mr-10{
    margin-right: 2.5rem;
  }

  .md\\:mb-10{
    margin-bottom: 2.5rem;
  }

  .md\\:ml-10{
    margin-left: 2.5rem;
  }

  .md\\:mt-11{
    margin-top: 2.75rem;
  }

  .md\\:mr-11{
    margin-right: 2.75rem;
  }

  .md\\:mb-11{
    margin-bottom: 2.75rem;
  }

  .md\\:ml-11{
    margin-left: 2.75rem;
  }

  .md\\:mt-12{
    margin-top: 3rem;
  }

  .md\\:mr-12{
    margin-right: 3rem;
  }

  .md\\:mb-12{
    margin-bottom: 3rem;
  }

  .md\\:ml-12{
    margin-left: 3rem;
  }

  .md\\:mt-14{
    margin-top: 3.5rem;
  }

  .md\\:mr-14{
    margin-right: 3.5rem;
  }

  .md\\:mb-14{
    margin-bottom: 3.5rem;
  }

  .md\\:ml-14{
    margin-left: 3.5rem;
  }

  .md\\:mt-15{
    margin-top: 3.75rem;
  }

  .md\\:mr-15{
    margin-right: 3.75rem;
  }

  .md\\:mb-15{
    margin-bottom: 3.75rem;
  }

  .md\\:ml-15{
    margin-left: 3.75rem;
  }

  .md\\:mt-16{
    margin-top: 4rem;
  }

  .md\\:mr-16{
    margin-right: 4rem;
  }

  .md\\:mb-16{
    margin-bottom: 4rem;
  }

  .md\\:ml-16{
    margin-left: 4rem;
  }

  .md\\:mt-18{
    margin-top: 4.5rem;
  }

  .md\\:mr-18{
    margin-right: 4.5rem;
  }

  .md\\:mb-18{
    margin-bottom: 4.5rem;
  }

  .md\\:ml-18{
    margin-left: 4.5rem;
  }

  .md\\:mt-20{
    margin-top: 5rem;
  }

  .md\\:mr-20{
    margin-right: 5rem;
  }

  .md\\:mb-20{
    margin-bottom: 5rem;
  }

  .md\\:ml-20{
    margin-left: 5rem;
  }

  .md\\:mt-22{
    margin-top: 5.5rem;
  }

  .md\\:mr-22{
    margin-right: 5.5rem;
  }

  .md\\:mb-22{
    margin-bottom: 5.5rem;
  }

  .md\\:ml-22{
    margin-left: 5.5rem;
  }

  .md\\:mt-23{
    margin-top: 5.75rem;
  }

  .md\\:mr-23{
    margin-right: 5.75rem;
  }

  .md\\:mb-23{
    margin-bottom: 5.75rem;
  }

  .md\\:ml-23{
    margin-left: 5.75rem;
  }

  .md\\:mt-24{
    margin-top: 6rem;
  }

  .md\\:mr-24{
    margin-right: 6rem;
  }

  .md\\:mb-24{
    margin-bottom: 6rem;
  }

  .md\\:ml-24{
    margin-left: 6rem;
  }

  .md\\:mt-25{
    margin-top: 6.25rem;
  }

  .md\\:mr-25{
    margin-right: 6.25rem;
  }

  .md\\:mb-25{
    margin-bottom: 6.25rem;
  }

  .md\\:ml-25{
    margin-left: 6.25rem;
  }

  .md\\:mt-26{
    margin-top: 6.5rem;
  }

  .md\\:mr-26{
    margin-right: 6.5rem;
  }

  .md\\:mb-26{
    margin-bottom: 6.5rem;
  }

  .md\\:ml-26{
    margin-left: 6.5rem;
  }

  .md\\:mt-28{
    margin-top: 7rem;
  }

  .md\\:mr-28{
    margin-right: 7rem;
  }

  .md\\:mb-28{
    margin-bottom: 7rem;
  }

  .md\\:ml-28{
    margin-left: 7rem;
  }

  .md\\:mt-30{
    margin-top: 7.5rem;
  }

  .md\\:mr-30{
    margin-right: 7.5rem;
  }

  .md\\:mb-30{
    margin-bottom: 7.5rem;
  }

  .md\\:ml-30{
    margin-left: 7.5rem;
  }

  .md\\:mt-32{
    margin-top: 8rem;
  }

  .md\\:mr-32{
    margin-right: 8rem;
  }

  .md\\:mb-32{
    margin-bottom: 8rem;
  }

  .md\\:ml-32{
    margin-left: 8rem;
  }

  .md\\:mt-34{
    margin-top: 8.5rem;
  }

  .md\\:mr-34{
    margin-right: 8.5rem;
  }

  .md\\:mb-34{
    margin-bottom: 8.5rem;
  }

  .md\\:ml-34{
    margin-left: 8.5rem;
  }

  .md\\:mt-40{
    margin-top: 10rem;
  }

  .md\\:mr-40{
    margin-right: 10rem;
  }

  .md\\:mb-40{
    margin-bottom: 10rem;
  }

  .md\\:ml-40{
    margin-left: 10rem;
  }

  .md\\:mt-42{
    margin-top: 10.5rem;
  }

  .md\\:mr-42{
    margin-right: 10.5rem;
  }

  .md\\:mb-42{
    margin-bottom: 10.5rem;
  }

  .md\\:ml-42{
    margin-left: 10.5rem;
  }

  .md\\:mt-44{
    margin-top: 11rem;
  }

  .md\\:mr-44{
    margin-right: 11rem;
  }

  .md\\:mb-44{
    margin-bottom: 11rem;
  }

  .md\\:ml-44{
    margin-left: 11rem;
  }

  .md\\:mt-48{
    margin-top: 12rem;
  }

  .md\\:mr-48{
    margin-right: 12rem;
  }

  .md\\:mb-48{
    margin-bottom: 12rem;
  }

  .md\\:ml-48{
    margin-left: 12rem;
  }

  .md\\:mt-52{
    margin-top: 13rem;
  }

  .md\\:mr-52{
    margin-right: 13rem;
  }

  .md\\:mb-52{
    margin-bottom: 13rem;
  }

  .md\\:ml-52{
    margin-left: 13rem;
  }

  .md\\:mt-54{
    margin-top: 13.5rem;
  }

  .md\\:mr-54{
    margin-right: 13.5rem;
  }

  .md\\:mb-54{
    margin-bottom: 13.5rem;
  }

  .md\\:ml-54{
    margin-left: 13.5rem;
  }

  .md\\:mt-56{
    margin-top: 14rem;
  }

  .md\\:mr-56{
    margin-right: 14rem;
  }

  .md\\:mb-56{
    margin-bottom: 14rem;
  }

  .md\\:ml-56{
    margin-left: 14rem;
  }

  .md\\:mt-60{
    margin-top: 15rem;
  }

  .md\\:mr-60{
    margin-right: 15rem;
  }

  .md\\:mb-60{
    margin-bottom: 15rem;
  }

  .md\\:ml-60{
    margin-left: 15rem;
  }

  .md\\:mt-64{
    margin-top: 16rem;
  }

  .md\\:mr-64{
    margin-right: 16rem;
  }

  .md\\:mb-64{
    margin-bottom: 16rem;
  }

  .md\\:ml-64{
    margin-left: 16rem;
  }

  .md\\:mt-68{
    margin-top: 17rem;
  }

  .md\\:mr-68{
    margin-right: 17rem;
  }

  .md\\:mb-68{
    margin-bottom: 17rem;
  }

  .md\\:ml-68{
    margin-left: 17rem;
  }

  .md\\:mt-72{
    margin-top: 18rem;
  }

  .md\\:mr-72{
    margin-right: 18rem;
  }

  .md\\:mb-72{
    margin-bottom: 18rem;
  }

  .md\\:ml-72{
    margin-left: 18rem;
  }

  .md\\:mt-74{
    margin-top: 18.5rem;
  }

  .md\\:mr-74{
    margin-right: 18.5rem;
  }

  .md\\:mb-74{
    margin-bottom: 18.5rem;
  }

  .md\\:ml-74{
    margin-left: 18.5rem;
  }

  .md\\:mt-76{
    margin-top: 19rem;
  }

  .md\\:mr-76{
    margin-right: 19rem;
  }

  .md\\:mb-76{
    margin-bottom: 19rem;
  }

  .md\\:ml-76{
    margin-left: 19rem;
  }

  .md\\:mt-78{
    margin-top: 19.5rem;
  }

  .md\\:mr-78{
    margin-right: 19.5rem;
  }

  .md\\:mb-78{
    margin-bottom: 19.5rem;
  }

  .md\\:ml-78{
    margin-left: 19.5rem;
  }

  .md\\:mt-80{
    margin-top: 20rem;
  }

  .md\\:mr-80{
    margin-right: 20rem;
  }

  .md\\:mb-80{
    margin-bottom: 20rem;
  }

  .md\\:ml-80{
    margin-left: 20rem;
  }

  .md\\:mt-82{
    margin-top: 20.5rem;
  }

  .md\\:mr-82{
    margin-right: 20.5rem;
  }

  .md\\:mb-82{
    margin-bottom: 20.5rem;
  }

  .md\\:ml-82{
    margin-left: 20.5rem;
  }

  .md\\:mt-84{
    margin-top: 21rem;
  }

  .md\\:mr-84{
    margin-right: 21rem;
  }

  .md\\:mb-84{
    margin-bottom: 21rem;
  }

  .md\\:ml-84{
    margin-left: 21rem;
  }

  .md\\:mt-88{
    margin-top: 22rem;
  }

  .md\\:mr-88{
    margin-right: 22rem;
  }

  .md\\:mb-88{
    margin-bottom: 22rem;
  }

  .md\\:ml-88{
    margin-left: 22rem;
  }

  .md\\:mt-92{
    margin-top: 23rem;
  }

  .md\\:mr-92{
    margin-right: 23rem;
  }

  .md\\:mb-92{
    margin-bottom: 23rem;
  }

  .md\\:ml-92{
    margin-left: 23rem;
  }

  .md\\:mt-96{
    margin-top: 24rem;
  }

  .md\\:mr-96{
    margin-right: 24rem;
  }

  .md\\:mb-96{
    margin-bottom: 24rem;
  }

  .md\\:ml-96{
    margin-left: 24rem;
  }

  .md\\:mt-98{
    margin-top: 24.5rem;
  }

  .md\\:mr-98{
    margin-right: 24.5rem;
  }

  .md\\:mb-98{
    margin-bottom: 24.5rem;
  }

  .md\\:ml-98{
    margin-left: 24.5rem;
  }

  .md\\:mt-100{
    margin-top: 25rem;
  }

  .md\\:mr-100{
    margin-right: 25rem;
  }

  .md\\:mb-100{
    margin-bottom: 25rem;
  }

  .md\\:ml-100{
    margin-left: 25rem;
  }

  .md\\:mt-104{
    margin-top: 26rem;
  }

  .md\\:mr-104{
    margin-right: 26rem;
  }

  .md\\:mb-104{
    margin-bottom: 26rem;
  }

  .md\\:ml-104{
    margin-left: 26rem;
  }

  .md\\:mt-112{
    margin-top: 28rem;
  }

  .md\\:mr-112{
    margin-right: 28rem;
  }

  .md\\:mb-112{
    margin-bottom: 28rem;
  }

  .md\\:ml-112{
    margin-left: 28rem;
  }

  .md\\:mt-124{
    margin-top: 31rem;
  }

  .md\\:mr-124{
    margin-right: 31rem;
  }

  .md\\:mb-124{
    margin-bottom: 31rem;
  }

  .md\\:ml-124{
    margin-left: 31rem;
  }

  .md\\:mt-128{
    margin-top: 32rem;
  }

  .md\\:mr-128{
    margin-right: 32rem;
  }

  .md\\:mb-128{
    margin-bottom: 32rem;
  }

  .md\\:ml-128{
    margin-left: 32rem;
  }

  .md\\:mt-140{
    margin-top: 35rem;
  }

  .md\\:mr-140{
    margin-right: 35rem;
  }

  .md\\:mb-140{
    margin-bottom: 35rem;
  }

  .md\\:ml-140{
    margin-left: 35rem;
  }

  .md\\:mt-152{
    margin-top: 38rem;
  }

  .md\\:mr-152{
    margin-right: 38rem;
  }

  .md\\:mb-152{
    margin-bottom: 38rem;
  }

  .md\\:ml-152{
    margin-left: 38rem;
  }

  .md\\:mt-160{
    margin-top: 40rem;
  }

  .md\\:mr-160{
    margin-right: 40rem;
  }

  .md\\:mb-160{
    margin-bottom: 40rem;
  }

  .md\\:ml-160{
    margin-left: 40rem;
  }

  .md\\:mt-162{
    margin-top: 41rem;
  }

  .md\\:mr-162{
    margin-right: 41rem;
  }

  .md\\:mb-162{
    margin-bottom: 41rem;
  }

  .md\\:ml-162{
    margin-left: 41rem;
  }

  .md\\:mt-192{
    margin-top: 48rem;
  }

  .md\\:mr-192{
    margin-right: 48rem;
  }

  .md\\:mb-192{
    margin-bottom: 48rem;
  }

  .md\\:ml-192{
    margin-left: 48rem;
  }

  .md\\:mt-208{
    margin-top: 52rem;
  }

  .md\\:mr-208{
    margin-right: 52rem;
  }

  .md\\:mb-208{
    margin-bottom: 52rem;
  }

  .md\\:ml-208{
    margin-left: 52rem;
  }

  .md\\:mt-224{
    margin-top: 56rem;
  }

  .md\\:mr-224{
    margin-right: 56rem;
  }

  .md\\:mb-224{
    margin-bottom: 56rem;
  }

  .md\\:ml-224{
    margin-left: 56rem;
  }

  .md\\:mt-256{
    margin-top: 64rem;
  }

  .md\\:mr-256{
    margin-right: 64rem;
  }

  .md\\:mb-256{
    margin-bottom: 64rem;
  }

  .md\\:ml-256{
    margin-left: 64rem;
  }

  .md\\:mt-auto{
    margin-top: auto;
  }

  .md\\:mr-auto{
    margin-right: auto;
  }

  .md\\:mb-auto{
    margin-bottom: auto;
  }

  .md\\:ml-auto{
    margin-left: auto;
  }

  .md\\:mt-px{
    margin-top: 1px;
  }

  .md\\:mr-px{
    margin-right: 1px;
  }

  .md\\:mb-px{
    margin-bottom: 1px;
  }

  .md\\:ml-px{
    margin-left: 1px;
  }

  .md\\:-mt-1{
    margin-top: -0.25rem;
  }

  .md\\:-mr-1{
    margin-right: -0.25rem;
  }

  .md\\:-mb-1{
    margin-bottom: -0.25rem;
  }

  .md\\:-ml-1{
    margin-left: -0.25rem;
  }

  .md\\:-mt-2{
    margin-top: -0.5rem;
  }

  .md\\:-mr-2{
    margin-right: -0.5rem;
  }

  .md\\:-mb-2{
    margin-bottom: -0.5rem;
  }

  .md\\:-ml-2{
    margin-left: -0.5rem;
  }

  .md\\:-mt-3{
    margin-top: -0.75rem;
  }

  .md\\:-mr-3{
    margin-right: -0.75rem;
  }

  .md\\:-mb-3{
    margin-bottom: -0.75rem;
  }

  .md\\:-ml-3{
    margin-left: -0.75rem;
  }

  .md\\:-mt-4{
    margin-top: -1rem;
  }

  .md\\:-mr-4{
    margin-right: -1rem;
  }

  .md\\:-mb-4{
    margin-bottom: -1rem;
  }

  .md\\:-ml-4{
    margin-left: -1rem;
  }

  .md\\:-mt-5{
    margin-top: -1.25rem;
  }

  .md\\:-mr-5{
    margin-right: -1.25rem;
  }

  .md\\:-mb-5{
    margin-bottom: -1.25rem;
  }

  .md\\:-ml-5{
    margin-left: -1.25rem;
  }

  .md\\:-mt-6{
    margin-top: -1.5rem;
  }

  .md\\:-mr-6{
    margin-right: -1.5rem;
  }

  .md\\:-mb-6{
    margin-bottom: -1.5rem;
  }

  .md\\:-ml-6{
    margin-left: -1.5rem;
  }

  .md\\:-mt-7{
    margin-top: -1.75rem;
  }

  .md\\:-mr-7{
    margin-right: -1.75rem;
  }

  .md\\:-mb-7{
    margin-bottom: -1.75rem;
  }

  .md\\:-ml-7{
    margin-left: -1.75rem;
  }

  .md\\:-mt-8{
    margin-top: -2rem;
  }

  .md\\:-mr-8{
    margin-right: -2rem;
  }

  .md\\:-mb-8{
    margin-bottom: -2rem;
  }

  .md\\:-ml-8{
    margin-left: -2rem;
  }

  .md\\:-mt-9{
    margin-top: -2.25rem;
  }

  .md\\:-mr-9{
    margin-right: -2.25rem;
  }

  .md\\:-mb-9{
    margin-bottom: -2.25rem;
  }

  .md\\:-ml-9{
    margin-left: -2.25rem;
  }

  .md\\:-mt-10{
    margin-top: -2.5rem;
  }

  .md\\:-mr-10{
    margin-right: -2.5rem;
  }

  .md\\:-mb-10{
    margin-bottom: -2.5rem;
  }

  .md\\:-ml-10{
    margin-left: -2.5rem;
  }

  .md\\:-mt-11{
    margin-top: -2.75rem;
  }

  .md\\:-mr-11{
    margin-right: -2.75rem;
  }

  .md\\:-mb-11{
    margin-bottom: -2.75rem;
  }

  .md\\:-ml-11{
    margin-left: -2.75rem;
  }

  .md\\:-mt-12{
    margin-top: -3rem;
  }

  .md\\:-mr-12{
    margin-right: -3rem;
  }

  .md\\:-mb-12{
    margin-bottom: -3rem;
  }

  .md\\:-ml-12{
    margin-left: -3rem;
  }

  .md\\:-mt-14{
    margin-top: -3.5rem;
  }

  .md\\:-mr-14{
    margin-right: -3.5rem;
  }

  .md\\:-mb-14{
    margin-bottom: -3.5rem;
  }

  .md\\:-ml-14{
    margin-left: -3.5rem;
  }

  .md\\:-mt-15{
    margin-top: -3.75rem;
  }

  .md\\:-mr-15{
    margin-right: -3.75rem;
  }

  .md\\:-mb-15{
    margin-bottom: -3.75rem;
  }

  .md\\:-ml-15{
    margin-left: -3.75rem;
  }

  .md\\:-mt-16{
    margin-top: -4rem;
  }

  .md\\:-mr-16{
    margin-right: -4rem;
  }

  .md\\:-mb-16{
    margin-bottom: -4rem;
  }

  .md\\:-ml-16{
    margin-left: -4rem;
  }

  .md\\:-mt-18{
    margin-top: -4.5rem;
  }

  .md\\:-mr-18{
    margin-right: -4.5rem;
  }

  .md\\:-mb-18{
    margin-bottom: -4.5rem;
  }

  .md\\:-ml-18{
    margin-left: -4.5rem;
  }

  .md\\:-mt-20{
    margin-top: -5rem;
  }

  .md\\:-mr-20{
    margin-right: -5rem;
  }

  .md\\:-mb-20{
    margin-bottom: -5rem;
  }

  .md\\:-ml-20{
    margin-left: -5rem;
  }

  .md\\:-mt-22{
    margin-top: -5.5rem;
  }

  .md\\:-mr-22{
    margin-right: -5.5rem;
  }

  .md\\:-mb-22{
    margin-bottom: -5.5rem;
  }

  .md\\:-ml-22{
    margin-left: -5.5rem;
  }

  .md\\:-mt-23{
    margin-top: -5.75rem;
  }

  .md\\:-mr-23{
    margin-right: -5.75rem;
  }

  .md\\:-mb-23{
    margin-bottom: -5.75rem;
  }

  .md\\:-ml-23{
    margin-left: -5.75rem;
  }

  .md\\:-mt-24{
    margin-top: -6rem;
  }

  .md\\:-mr-24{
    margin-right: -6rem;
  }

  .md\\:-mb-24{
    margin-bottom: -6rem;
  }

  .md\\:-ml-24{
    margin-left: -6rem;
  }

  .md\\:-mt-25{
    margin-top: -6.25rem;
  }

  .md\\:-mr-25{
    margin-right: -6.25rem;
  }

  .md\\:-mb-25{
    margin-bottom: -6.25rem;
  }

  .md\\:-ml-25{
    margin-left: -6.25rem;
  }

  .md\\:-mt-26{
    margin-top: -6.5rem;
  }

  .md\\:-mr-26{
    margin-right: -6.5rem;
  }

  .md\\:-mb-26{
    margin-bottom: -6.5rem;
  }

  .md\\:-ml-26{
    margin-left: -6.5rem;
  }

  .md\\:-mt-28{
    margin-top: -7rem;
  }

  .md\\:-mr-28{
    margin-right: -7rem;
  }

  .md\\:-mb-28{
    margin-bottom: -7rem;
  }

  .md\\:-ml-28{
    margin-left: -7rem;
  }

  .md\\:-mt-30{
    margin-top: -7.5rem;
  }

  .md\\:-mr-30{
    margin-right: -7.5rem;
  }

  .md\\:-mb-30{
    margin-bottom: -7.5rem;
  }

  .md\\:-ml-30{
    margin-left: -7.5rem;
  }

  .md\\:-mt-32{
    margin-top: -8rem;
  }

  .md\\:-mr-32{
    margin-right: -8rem;
  }

  .md\\:-mb-32{
    margin-bottom: -8rem;
  }

  .md\\:-ml-32{
    margin-left: -8rem;
  }

  .md\\:-mt-34{
    margin-top: -8.5rem;
  }

  .md\\:-mr-34{
    margin-right: -8.5rem;
  }

  .md\\:-mb-34{
    margin-bottom: -8.5rem;
  }

  .md\\:-ml-34{
    margin-left: -8.5rem;
  }

  .md\\:-mt-40{
    margin-top: -10rem;
  }

  .md\\:-mr-40{
    margin-right: -10rem;
  }

  .md\\:-mb-40{
    margin-bottom: -10rem;
  }

  .md\\:-ml-40{
    margin-left: -10rem;
  }

  .md\\:-mt-42{
    margin-top: -10.5rem;
  }

  .md\\:-mr-42{
    margin-right: -10.5rem;
  }

  .md\\:-mb-42{
    margin-bottom: -10.5rem;
  }

  .md\\:-ml-42{
    margin-left: -10.5rem;
  }

  .md\\:-mt-44{
    margin-top: -11rem;
  }

  .md\\:-mr-44{
    margin-right: -11rem;
  }

  .md\\:-mb-44{
    margin-bottom: -11rem;
  }

  .md\\:-ml-44{
    margin-left: -11rem;
  }

  .md\\:-mt-48{
    margin-top: -12rem;
  }

  .md\\:-mr-48{
    margin-right: -12rem;
  }

  .md\\:-mb-48{
    margin-bottom: -12rem;
  }

  .md\\:-ml-48{
    margin-left: -12rem;
  }

  .md\\:-mt-52{
    margin-top: -13rem;
  }

  .md\\:-mr-52{
    margin-right: -13rem;
  }

  .md\\:-mb-52{
    margin-bottom: -13rem;
  }

  .md\\:-ml-52{
    margin-left: -13rem;
  }

  .md\\:-mt-54{
    margin-top: -13.5rem;
  }

  .md\\:-mr-54{
    margin-right: -13.5rem;
  }

  .md\\:-mb-54{
    margin-bottom: -13.5rem;
  }

  .md\\:-ml-54{
    margin-left: -13.5rem;
  }

  .md\\:-mt-56{
    margin-top: -14rem;
  }

  .md\\:-mr-56{
    margin-right: -14rem;
  }

  .md\\:-mb-56{
    margin-bottom: -14rem;
  }

  .md\\:-ml-56{
    margin-left: -14rem;
  }

  .md\\:-mt-60{
    margin-top: -15rem;
  }

  .md\\:-mr-60{
    margin-right: -15rem;
  }

  .md\\:-mb-60{
    margin-bottom: -15rem;
  }

  .md\\:-ml-60{
    margin-left: -15rem;
  }

  .md\\:-mt-64{
    margin-top: -16rem;
  }

  .md\\:-mr-64{
    margin-right: -16rem;
  }

  .md\\:-mb-64{
    margin-bottom: -16rem;
  }

  .md\\:-ml-64{
    margin-left: -16rem;
  }

  .md\\:-mt-68{
    margin-top: -17rem;
  }

  .md\\:-mr-68{
    margin-right: -17rem;
  }

  .md\\:-mb-68{
    margin-bottom: -17rem;
  }

  .md\\:-ml-68{
    margin-left: -17rem;
  }

  .md\\:-mt-72{
    margin-top: -18rem;
  }

  .md\\:-mr-72{
    margin-right: -18rem;
  }

  .md\\:-mb-72{
    margin-bottom: -18rem;
  }

  .md\\:-ml-72{
    margin-left: -18rem;
  }

  .md\\:-mt-74{
    margin-top: -18.5rem;
  }

  .md\\:-mr-74{
    margin-right: -18.5rem;
  }

  .md\\:-mb-74{
    margin-bottom: -18.5rem;
  }

  .md\\:-ml-74{
    margin-left: -18.5rem;
  }

  .md\\:-mt-76{
    margin-top: -19rem;
  }

  .md\\:-mr-76{
    margin-right: -19rem;
  }

  .md\\:-mb-76{
    margin-bottom: -19rem;
  }

  .md\\:-ml-76{
    margin-left: -19rem;
  }

  .md\\:-mt-78{
    margin-top: -19.5rem;
  }

  .md\\:-mr-78{
    margin-right: -19.5rem;
  }

  .md\\:-mb-78{
    margin-bottom: -19.5rem;
  }

  .md\\:-ml-78{
    margin-left: -19.5rem;
  }

  .md\\:-mt-80{
    margin-top: -20rem;
  }

  .md\\:-mr-80{
    margin-right: -20rem;
  }

  .md\\:-mb-80{
    margin-bottom: -20rem;
  }

  .md\\:-ml-80{
    margin-left: -20rem;
  }

  .md\\:-mt-82{
    margin-top: -20.5rem;
  }

  .md\\:-mr-82{
    margin-right: -20.5rem;
  }

  .md\\:-mb-82{
    margin-bottom: -20.5rem;
  }

  .md\\:-ml-82{
    margin-left: -20.5rem;
  }

  .md\\:-mt-84{
    margin-top: -21rem;
  }

  .md\\:-mr-84{
    margin-right: -21rem;
  }

  .md\\:-mb-84{
    margin-bottom: -21rem;
  }

  .md\\:-ml-84{
    margin-left: -21rem;
  }

  .md\\:-mt-88{
    margin-top: -22rem;
  }

  .md\\:-mr-88{
    margin-right: -22rem;
  }

  .md\\:-mb-88{
    margin-bottom: -22rem;
  }

  .md\\:-ml-88{
    margin-left: -22rem;
  }

  .md\\:-mt-92{
    margin-top: -23rem;
  }

  .md\\:-mr-92{
    margin-right: -23rem;
  }

  .md\\:-mb-92{
    margin-bottom: -23rem;
  }

  .md\\:-ml-92{
    margin-left: -23rem;
  }

  .md\\:-mt-96{
    margin-top: -24rem;
  }

  .md\\:-mr-96{
    margin-right: -24rem;
  }

  .md\\:-mb-96{
    margin-bottom: -24rem;
  }

  .md\\:-ml-96{
    margin-left: -24rem;
  }

  .md\\:-mt-98{
    margin-top: -24.5rem;
  }

  .md\\:-mr-98{
    margin-right: -24.5rem;
  }

  .md\\:-mb-98{
    margin-bottom: -24.5rem;
  }

  .md\\:-ml-98{
    margin-left: -24.5rem;
  }

  .md\\:-mt-100{
    margin-top: -25rem;
  }

  .md\\:-mr-100{
    margin-right: -25rem;
  }

  .md\\:-mb-100{
    margin-bottom: -25rem;
  }

  .md\\:-ml-100{
    margin-left: -25rem;
  }

  .md\\:-mt-104{
    margin-top: -26rem;
  }

  .md\\:-mr-104{
    margin-right: -26rem;
  }

  .md\\:-mb-104{
    margin-bottom: -26rem;
  }

  .md\\:-ml-104{
    margin-left: -26rem;
  }

  .md\\:-mt-112{
    margin-top: -28rem;
  }

  .md\\:-mr-112{
    margin-right: -28rem;
  }

  .md\\:-mb-112{
    margin-bottom: -28rem;
  }

  .md\\:-ml-112{
    margin-left: -28rem;
  }

  .md\\:-mt-124{
    margin-top: -31rem;
  }

  .md\\:-mr-124{
    margin-right: -31rem;
  }

  .md\\:-mb-124{
    margin-bottom: -31rem;
  }

  .md\\:-ml-124{
    margin-left: -31rem;
  }

  .md\\:-mt-128{
    margin-top: -32rem;
  }

  .md\\:-mr-128{
    margin-right: -32rem;
  }

  .md\\:-mb-128{
    margin-bottom: -32rem;
  }

  .md\\:-ml-128{
    margin-left: -32rem;
  }

  .md\\:-mt-140{
    margin-top: -35rem;
  }

  .md\\:-mr-140{
    margin-right: -35rem;
  }

  .md\\:-mb-140{
    margin-bottom: -35rem;
  }

  .md\\:-ml-140{
    margin-left: -35rem;
  }

  .md\\:-mt-152{
    margin-top: -38rem;
  }

  .md\\:-mr-152{
    margin-right: -38rem;
  }

  .md\\:-mb-152{
    margin-bottom: -38rem;
  }

  .md\\:-ml-152{
    margin-left: -38rem;
  }

  .md\\:-mt-160{
    margin-top: -40rem;
  }

  .md\\:-mr-160{
    margin-right: -40rem;
  }

  .md\\:-mb-160{
    margin-bottom: -40rem;
  }

  .md\\:-ml-160{
    margin-left: -40rem;
  }

  .md\\:-mt-162{
    margin-top: -41rem;
  }

  .md\\:-mr-162{
    margin-right: -41rem;
  }

  .md\\:-mb-162{
    margin-bottom: -41rem;
  }

  .md\\:-ml-162{
    margin-left: -41rem;
  }

  .md\\:-mt-192{
    margin-top: -48rem;
  }

  .md\\:-mr-192{
    margin-right: -48rem;
  }

  .md\\:-mb-192{
    margin-bottom: -48rem;
  }

  .md\\:-ml-192{
    margin-left: -48rem;
  }

  .md\\:-mt-208{
    margin-top: -52rem;
  }

  .md\\:-mr-208{
    margin-right: -52rem;
  }

  .md\\:-mb-208{
    margin-bottom: -52rem;
  }

  .md\\:-ml-208{
    margin-left: -52rem;
  }

  .md\\:-mt-224{
    margin-top: -56rem;
  }

  .md\\:-mr-224{
    margin-right: -56rem;
  }

  .md\\:-mb-224{
    margin-bottom: -56rem;
  }

  .md\\:-ml-224{
    margin-left: -56rem;
  }

  .md\\:-mt-256{
    margin-top: -64rem;
  }

  .md\\:-mr-256{
    margin-right: -64rem;
  }

  .md\\:-mb-256{
    margin-bottom: -64rem;
  }

  .md\\:-ml-256{
    margin-left: -64rem;
  }

  .md\\:-mt-px{
    margin-top: -1px;
  }

  .md\\:-mr-px{
    margin-right: -1px;
  }

  .md\\:-mb-px{
    margin-bottom: -1px;
  }

  .md\\:-ml-px{
    margin-left: -1px;
  }

  .md\\:first\\:m-0:first-child{
    margin: 0;
  }

  .md\\:first\\:m-1:first-child{
    margin: 0.25rem;
  }

  .md\\:first\\:m-2:first-child{
    margin: 0.5rem;
  }

  .md\\:first\\:m-3:first-child{
    margin: 0.75rem;
  }

  .md\\:first\\:m-4:first-child{
    margin: 1rem;
  }

  .md\\:first\\:m-5:first-child{
    margin: 1.25rem;
  }

  .md\\:first\\:m-6:first-child{
    margin: 1.5rem;
  }

  .md\\:first\\:m-7:first-child{
    margin: 1.75rem;
  }

  .md\\:first\\:m-8:first-child{
    margin: 2rem;
  }

  .md\\:first\\:m-9:first-child{
    margin: 2.25rem;
  }

  .md\\:first\\:m-10:first-child{
    margin: 2.5rem;
  }

  .md\\:first\\:m-11:first-child{
    margin: 2.75rem;
  }

  .md\\:first\\:m-12:first-child{
    margin: 3rem;
  }

  .md\\:first\\:m-14:first-child{
    margin: 3.5rem;
  }

  .md\\:first\\:m-15:first-child{
    margin: 3.75rem;
  }

  .md\\:first\\:m-16:first-child{
    margin: 4rem;
  }

  .md\\:first\\:m-18:first-child{
    margin: 4.5rem;
  }

  .md\\:first\\:m-20:first-child{
    margin: 5rem;
  }

  .md\\:first\\:m-22:first-child{
    margin: 5.5rem;
  }

  .md\\:first\\:m-23:first-child{
    margin: 5.75rem;
  }

  .md\\:first\\:m-24:first-child{
    margin: 6rem;
  }

  .md\\:first\\:m-25:first-child{
    margin: 6.25rem;
  }

  .md\\:first\\:m-26:first-child{
    margin: 6.5rem;
  }

  .md\\:first\\:m-28:first-child{
    margin: 7rem;
  }

  .md\\:first\\:m-30:first-child{
    margin: 7.5rem;
  }

  .md\\:first\\:m-32:first-child{
    margin: 8rem;
  }

  .md\\:first\\:m-34:first-child{
    margin: 8.5rem;
  }

  .md\\:first\\:m-40:first-child{
    margin: 10rem;
  }

  .md\\:first\\:m-42:first-child{
    margin: 10.5rem;
  }

  .md\\:first\\:m-44:first-child{
    margin: 11rem;
  }

  .md\\:first\\:m-48:first-child{
    margin: 12rem;
  }

  .md\\:first\\:m-52:first-child{
    margin: 13rem;
  }

  .md\\:first\\:m-54:first-child{
    margin: 13.5rem;
  }

  .md\\:first\\:m-56:first-child{
    margin: 14rem;
  }

  .md\\:first\\:m-60:first-child{
    margin: 15rem;
  }

  .md\\:first\\:m-64:first-child{
    margin: 16rem;
  }

  .md\\:first\\:m-68:first-child{
    margin: 17rem;
  }

  .md\\:first\\:m-72:first-child{
    margin: 18rem;
  }

  .md\\:first\\:m-74:first-child{
    margin: 18.5rem;
  }

  .md\\:first\\:m-76:first-child{
    margin: 19rem;
  }

  .md\\:first\\:m-78:first-child{
    margin: 19.5rem;
  }

  .md\\:first\\:m-80:first-child{
    margin: 20rem;
  }

  .md\\:first\\:m-82:first-child{
    margin: 20.5rem;
  }

  .md\\:first\\:m-84:first-child{
    margin: 21rem;
  }

  .md\\:first\\:m-88:first-child{
    margin: 22rem;
  }

  .md\\:first\\:m-92:first-child{
    margin: 23rem;
  }

  .md\\:first\\:m-96:first-child{
    margin: 24rem;
  }

  .md\\:first\\:m-98:first-child{
    margin: 24.5rem;
  }

  .md\\:first\\:m-100:first-child{
    margin: 25rem;
  }

  .md\\:first\\:m-104:first-child{
    margin: 26rem;
  }

  .md\\:first\\:m-112:first-child{
    margin: 28rem;
  }

  .md\\:first\\:m-124:first-child{
    margin: 31rem;
  }

  .md\\:first\\:m-128:first-child{
    margin: 32rem;
  }

  .md\\:first\\:m-140:first-child{
    margin: 35rem;
  }

  .md\\:first\\:m-152:first-child{
    margin: 38rem;
  }

  .md\\:first\\:m-160:first-child{
    margin: 40rem;
  }

  .md\\:first\\:m-162:first-child{
    margin: 41rem;
  }

  .md\\:first\\:m-192:first-child{
    margin: 48rem;
  }

  .md\\:first\\:m-208:first-child{
    margin: 52rem;
  }

  .md\\:first\\:m-224:first-child{
    margin: 56rem;
  }

  .md\\:first\\:m-256:first-child{
    margin: 64rem;
  }

  .md\\:first\\:m-auto:first-child{
    margin: auto;
  }

  .md\\:first\\:m-px:first-child{
    margin: 1px;
  }

  .md\\:first\\:-m-1:first-child{
    margin: -0.25rem;
  }

  .md\\:first\\:-m-2:first-child{
    margin: -0.5rem;
  }

  .md\\:first\\:-m-3:first-child{
    margin: -0.75rem;
  }

  .md\\:first\\:-m-4:first-child{
    margin: -1rem;
  }

  .md\\:first\\:-m-5:first-child{
    margin: -1.25rem;
  }

  .md\\:first\\:-m-6:first-child{
    margin: -1.5rem;
  }

  .md\\:first\\:-m-7:first-child{
    margin: -1.75rem;
  }

  .md\\:first\\:-m-8:first-child{
    margin: -2rem;
  }

  .md\\:first\\:-m-9:first-child{
    margin: -2.25rem;
  }

  .md\\:first\\:-m-10:first-child{
    margin: -2.5rem;
  }

  .md\\:first\\:-m-11:first-child{
    margin: -2.75rem;
  }

  .md\\:first\\:-m-12:first-child{
    margin: -3rem;
  }

  .md\\:first\\:-m-14:first-child{
    margin: -3.5rem;
  }

  .md\\:first\\:-m-15:first-child{
    margin: -3.75rem;
  }

  .md\\:first\\:-m-16:first-child{
    margin: -4rem;
  }

  .md\\:first\\:-m-18:first-child{
    margin: -4.5rem;
  }

  .md\\:first\\:-m-20:first-child{
    margin: -5rem;
  }

  .md\\:first\\:-m-22:first-child{
    margin: -5.5rem;
  }

  .md\\:first\\:-m-23:first-child{
    margin: -5.75rem;
  }

  .md\\:first\\:-m-24:first-child{
    margin: -6rem;
  }

  .md\\:first\\:-m-25:first-child{
    margin: -6.25rem;
  }

  .md\\:first\\:-m-26:first-child{
    margin: -6.5rem;
  }

  .md\\:first\\:-m-28:first-child{
    margin: -7rem;
  }

  .md\\:first\\:-m-30:first-child{
    margin: -7.5rem;
  }

  .md\\:first\\:-m-32:first-child{
    margin: -8rem;
  }

  .md\\:first\\:-m-34:first-child{
    margin: -8.5rem;
  }

  .md\\:first\\:-m-40:first-child{
    margin: -10rem;
  }

  .md\\:first\\:-m-42:first-child{
    margin: -10.5rem;
  }

  .md\\:first\\:-m-44:first-child{
    margin: -11rem;
  }

  .md\\:first\\:-m-48:first-child{
    margin: -12rem;
  }

  .md\\:first\\:-m-52:first-child{
    margin: -13rem;
  }

  .md\\:first\\:-m-54:first-child{
    margin: -13.5rem;
  }

  .md\\:first\\:-m-56:first-child{
    margin: -14rem;
  }

  .md\\:first\\:-m-60:first-child{
    margin: -15rem;
  }

  .md\\:first\\:-m-64:first-child{
    margin: -16rem;
  }

  .md\\:first\\:-m-68:first-child{
    margin: -17rem;
  }

  .md\\:first\\:-m-72:first-child{
    margin: -18rem;
  }

  .md\\:first\\:-m-74:first-child{
    margin: -18.5rem;
  }

  .md\\:first\\:-m-76:first-child{
    margin: -19rem;
  }

  .md\\:first\\:-m-78:first-child{
    margin: -19.5rem;
  }

  .md\\:first\\:-m-80:first-child{
    margin: -20rem;
  }

  .md\\:first\\:-m-82:first-child{
    margin: -20.5rem;
  }

  .md\\:first\\:-m-84:first-child{
    margin: -21rem;
  }

  .md\\:first\\:-m-88:first-child{
    margin: -22rem;
  }

  .md\\:first\\:-m-92:first-child{
    margin: -23rem;
  }

  .md\\:first\\:-m-96:first-child{
    margin: -24rem;
  }

  .md\\:first\\:-m-98:first-child{
    margin: -24.5rem;
  }

  .md\\:first\\:-m-100:first-child{
    margin: -25rem;
  }

  .md\\:first\\:-m-104:first-child{
    margin: -26rem;
  }

  .md\\:first\\:-m-112:first-child{
    margin: -28rem;
  }

  .md\\:first\\:-m-124:first-child{
    margin: -31rem;
  }

  .md\\:first\\:-m-128:first-child{
    margin: -32rem;
  }

  .md\\:first\\:-m-140:first-child{
    margin: -35rem;
  }

  .md\\:first\\:-m-152:first-child{
    margin: -38rem;
  }

  .md\\:first\\:-m-160:first-child{
    margin: -40rem;
  }

  .md\\:first\\:-m-162:first-child{
    margin: -41rem;
  }

  .md\\:first\\:-m-192:first-child{
    margin: -48rem;
  }

  .md\\:first\\:-m-208:first-child{
    margin: -52rem;
  }

  .md\\:first\\:-m-224:first-child{
    margin: -56rem;
  }

  .md\\:first\\:-m-256:first-child{
    margin: -64rem;
  }

  .md\\:first\\:-m-px:first-child{
    margin: -1px;
  }

  .md\\:first\\:my-0:first-child{
    margin-top: 0;
    margin-bottom: 0;
  }

  .md\\:first\\:mx-0:first-child{
    margin-left: 0;
    margin-right: 0;
  }

  .md\\:first\\:my-1:first-child{
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .md\\:first\\:mx-1:first-child{
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .md\\:first\\:my-2:first-child{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .md\\:first\\:mx-2:first-child{
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .md\\:first\\:my-3:first-child{
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .md\\:first\\:mx-3:first-child{
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .md\\:first\\:my-4:first-child{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .md\\:first\\:mx-4:first-child{
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .md\\:first\\:my-5:first-child{
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .md\\:first\\:mx-5:first-child{
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .md\\:first\\:my-6:first-child{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .md\\:first\\:mx-6:first-child{
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .md\\:first\\:my-7:first-child{
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }

  .md\\:first\\:mx-7:first-child{
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }

  .md\\:first\\:my-8:first-child{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .md\\:first\\:mx-8:first-child{
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .md\\:first\\:my-9:first-child{
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }

  .md\\:first\\:mx-9:first-child{
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }

  .md\\:first\\:my-10:first-child{
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .md\\:first\\:mx-10:first-child{
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .md\\:first\\:my-11:first-child{
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;
  }

  .md\\:first\\:mx-11:first-child{
    margin-left: 2.75rem;
    margin-right: 2.75rem;
  }

  .md\\:first\\:my-12:first-child{
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .md\\:first\\:mx-12:first-child{
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .md\\:first\\:my-14:first-child{
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
  }

  .md\\:first\\:mx-14:first-child{
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }

  .md\\:first\\:my-15:first-child{
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
  }

  .md\\:first\\:mx-15:first-child{
    margin-left: 3.75rem;
    margin-right: 3.75rem;
  }

  .md\\:first\\:my-16:first-child{
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .md\\:first\\:mx-16:first-child{
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .md\\:first\\:my-18:first-child{
    margin-top: 4.5rem;
    margin-bottom: 4.5rem;
  }

  .md\\:first\\:mx-18:first-child{
    margin-left: 4.5rem;
    margin-right: 4.5rem;
  }

  .md\\:first\\:my-20:first-child{
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .md\\:first\\:mx-20:first-child{
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .md\\:first\\:my-22:first-child{
    margin-top: 5.5rem;
    margin-bottom: 5.5rem;
  }

  .md\\:first\\:mx-22:first-child{
    margin-left: 5.5rem;
    margin-right: 5.5rem;
  }

  .md\\:first\\:my-23:first-child{
    margin-top: 5.75rem;
    margin-bottom: 5.75rem;
  }

  .md\\:first\\:mx-23:first-child{
    margin-left: 5.75rem;
    margin-right: 5.75rem;
  }

  .md\\:first\\:my-24:first-child{
    margin-top: 6rem;
    margin-bottom: 6rem;
  }

  .md\\:first\\:mx-24:first-child{
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .md\\:first\\:my-25:first-child{
    margin-top: 6.25rem;
    margin-bottom: 6.25rem;
  }

  .md\\:first\\:mx-25:first-child{
    margin-left: 6.25rem;
    margin-right: 6.25rem;
  }

  .md\\:first\\:my-26:first-child{
    margin-top: 6.5rem;
    margin-bottom: 6.5rem;
  }

  .md\\:first\\:mx-26:first-child{
    margin-left: 6.5rem;
    margin-right: 6.5rem;
  }

  .md\\:first\\:my-28:first-child{
    margin-top: 7rem;
    margin-bottom: 7rem;
  }

  .md\\:first\\:mx-28:first-child{
    margin-left: 7rem;
    margin-right: 7rem;
  }

  .md\\:first\\:my-30:first-child{
    margin-top: 7.5rem;
    margin-bottom: 7.5rem;
  }

  .md\\:first\\:mx-30:first-child{
    margin-left: 7.5rem;
    margin-right: 7.5rem;
  }

  .md\\:first\\:my-32:first-child{
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  .md\\:first\\:mx-32:first-child{
    margin-left: 8rem;
    margin-right: 8rem;
  }

  .md\\:first\\:my-34:first-child{
    margin-top: 8.5rem;
    margin-bottom: 8.5rem;
  }

  .md\\:first\\:mx-34:first-child{
    margin-left: 8.5rem;
    margin-right: 8.5rem;
  }

  .md\\:first\\:my-40:first-child{
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .md\\:first\\:mx-40:first-child{
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .md\\:first\\:my-42:first-child{
    margin-top: 10.5rem;
    margin-bottom: 10.5rem;
  }

  .md\\:first\\:mx-42:first-child{
    margin-left: 10.5rem;
    margin-right: 10.5rem;
  }

  .md\\:first\\:my-44:first-child{
    margin-top: 11rem;
    margin-bottom: 11rem;
  }

  .md\\:first\\:mx-44:first-child{
    margin-left: 11rem;
    margin-right: 11rem;
  }

  .md\\:first\\:my-48:first-child{
    margin-top: 12rem;
    margin-bottom: 12rem;
  }

  .md\\:first\\:mx-48:first-child{
    margin-left: 12rem;
    margin-right: 12rem;
  }

  .md\\:first\\:my-52:first-child{
    margin-top: 13rem;
    margin-bottom: 13rem;
  }

  .md\\:first\\:mx-52:first-child{
    margin-left: 13rem;
    margin-right: 13rem;
  }

  .md\\:first\\:my-54:first-child{
    margin-top: 13.5rem;
    margin-bottom: 13.5rem;
  }

  .md\\:first\\:mx-54:first-child{
    margin-left: 13.5rem;
    margin-right: 13.5rem;
  }

  .md\\:first\\:my-56:first-child{
    margin-top: 14rem;
    margin-bottom: 14rem;
  }

  .md\\:first\\:mx-56:first-child{
    margin-left: 14rem;
    margin-right: 14rem;
  }

  .md\\:first\\:my-60:first-child{
    margin-top: 15rem;
    margin-bottom: 15rem;
  }

  .md\\:first\\:mx-60:first-child{
    margin-left: 15rem;
    margin-right: 15rem;
  }

  .md\\:first\\:my-64:first-child{
    margin-top: 16rem;
    margin-bottom: 16rem;
  }

  .md\\:first\\:mx-64:first-child{
    margin-left: 16rem;
    margin-right: 16rem;
  }

  .md\\:first\\:my-68:first-child{
    margin-top: 17rem;
    margin-bottom: 17rem;
  }

  .md\\:first\\:mx-68:first-child{
    margin-left: 17rem;
    margin-right: 17rem;
  }

  .md\\:first\\:my-72:first-child{
    margin-top: 18rem;
    margin-bottom: 18rem;
  }

  .md\\:first\\:mx-72:first-child{
    margin-left: 18rem;
    margin-right: 18rem;
  }

  .md\\:first\\:my-74:first-child{
    margin-top: 18.5rem;
    margin-bottom: 18.5rem;
  }

  .md\\:first\\:mx-74:first-child{
    margin-left: 18.5rem;
    margin-right: 18.5rem;
  }

  .md\\:first\\:my-76:first-child{
    margin-top: 19rem;
    margin-bottom: 19rem;
  }

  .md\\:first\\:mx-76:first-child{
    margin-left: 19rem;
    margin-right: 19rem;
  }

  .md\\:first\\:my-78:first-child{
    margin-top: 19.5rem;
    margin-bottom: 19.5rem;
  }

  .md\\:first\\:mx-78:first-child{
    margin-left: 19.5rem;
    margin-right: 19.5rem;
  }

  .md\\:first\\:my-80:first-child{
    margin-top: 20rem;
    margin-bottom: 20rem;
  }

  .md\\:first\\:mx-80:first-child{
    margin-left: 20rem;
    margin-right: 20rem;
  }

  .md\\:first\\:my-82:first-child{
    margin-top: 20.5rem;
    margin-bottom: 20.5rem;
  }

  .md\\:first\\:mx-82:first-child{
    margin-left: 20.5rem;
    margin-right: 20.5rem;
  }

  .md\\:first\\:my-84:first-child{
    margin-top: 21rem;
    margin-bottom: 21rem;
  }

  .md\\:first\\:mx-84:first-child{
    margin-left: 21rem;
    margin-right: 21rem;
  }

  .md\\:first\\:my-88:first-child{
    margin-top: 22rem;
    margin-bottom: 22rem;
  }

  .md\\:first\\:mx-88:first-child{
    margin-left: 22rem;
    margin-right: 22rem;
  }

  .md\\:first\\:my-92:first-child{
    margin-top: 23rem;
    margin-bottom: 23rem;
  }

  .md\\:first\\:mx-92:first-child{
    margin-left: 23rem;
    margin-right: 23rem;
  }

  .md\\:first\\:my-96:first-child{
    margin-top: 24rem;
    margin-bottom: 24rem;
  }

  .md\\:first\\:mx-96:first-child{
    margin-left: 24rem;
    margin-right: 24rem;
  }

  .md\\:first\\:my-98:first-child{
    margin-top: 24.5rem;
    margin-bottom: 24.5rem;
  }

  .md\\:first\\:mx-98:first-child{
    margin-left: 24.5rem;
    margin-right: 24.5rem;
  }

  .md\\:first\\:my-100:first-child{
    margin-top: 25rem;
    margin-bottom: 25rem;
  }

  .md\\:first\\:mx-100:first-child{
    margin-left: 25rem;
    margin-right: 25rem;
  }

  .md\\:first\\:my-104:first-child{
    margin-top: 26rem;
    margin-bottom: 26rem;
  }

  .md\\:first\\:mx-104:first-child{
    margin-left: 26rem;
    margin-right: 26rem;
  }

  .md\\:first\\:my-112:first-child{
    margin-top: 28rem;
    margin-bottom: 28rem;
  }

  .md\\:first\\:mx-112:first-child{
    margin-left: 28rem;
    margin-right: 28rem;
  }

  .md\\:first\\:my-124:first-child{
    margin-top: 31rem;
    margin-bottom: 31rem;
  }

  .md\\:first\\:mx-124:first-child{
    margin-left: 31rem;
    margin-right: 31rem;
  }

  .md\\:first\\:my-128:first-child{
    margin-top: 32rem;
    margin-bottom: 32rem;
  }

  .md\\:first\\:mx-128:first-child{
    margin-left: 32rem;
    margin-right: 32rem;
  }

  .md\\:first\\:my-140:first-child{
    margin-top: 35rem;
    margin-bottom: 35rem;
  }

  .md\\:first\\:mx-140:first-child{
    margin-left: 35rem;
    margin-right: 35rem;
  }

  .md\\:first\\:my-152:first-child{
    margin-top: 38rem;
    margin-bottom: 38rem;
  }

  .md\\:first\\:mx-152:first-child{
    margin-left: 38rem;
    margin-right: 38rem;
  }

  .md\\:first\\:my-160:first-child{
    margin-top: 40rem;
    margin-bottom: 40rem;
  }

  .md\\:first\\:mx-160:first-child{
    margin-left: 40rem;
    margin-right: 40rem;
  }

  .md\\:first\\:my-162:first-child{
    margin-top: 41rem;
    margin-bottom: 41rem;
  }

  .md\\:first\\:mx-162:first-child{
    margin-left: 41rem;
    margin-right: 41rem;
  }

  .md\\:first\\:my-192:first-child{
    margin-top: 48rem;
    margin-bottom: 48rem;
  }

  .md\\:first\\:mx-192:first-child{
    margin-left: 48rem;
    margin-right: 48rem;
  }

  .md\\:first\\:my-208:first-child{
    margin-top: 52rem;
    margin-bottom: 52rem;
  }

  .md\\:first\\:mx-208:first-child{
    margin-left: 52rem;
    margin-right: 52rem;
  }

  .md\\:first\\:my-224:first-child{
    margin-top: 56rem;
    margin-bottom: 56rem;
  }

  .md\\:first\\:mx-224:first-child{
    margin-left: 56rem;
    margin-right: 56rem;
  }

  .md\\:first\\:my-256:first-child{
    margin-top: 64rem;
    margin-bottom: 64rem;
  }

  .md\\:first\\:mx-256:first-child{
    margin-left: 64rem;
    margin-right: 64rem;
  }

  .md\\:first\\:my-auto:first-child{
    margin-top: auto;
    margin-bottom: auto;
  }

  .md\\:first\\:mx-auto:first-child{
    margin-left: auto;
    margin-right: auto;
  }

  .md\\:first\\:my-px:first-child{
    margin-top: 1px;
    margin-bottom: 1px;
  }

  .md\\:first\\:mx-px:first-child{
    margin-left: 1px;
    margin-right: 1px;
  }

  .md\\:first\\:-my-1:first-child{
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .md\\:first\\:-mx-1:first-child{
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .md\\:first\\:-my-2:first-child{
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }

  .md\\:first\\:-mx-2:first-child{
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .md\\:first\\:-my-3:first-child{
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }

  .md\\:first\\:-mx-3:first-child{
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .md\\:first\\:-my-4:first-child{
    margin-top: -1rem;
    margin-bottom: -1rem;
  }

  .md\\:first\\:-mx-4:first-child{
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .md\\:first\\:-my-5:first-child{
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }

  .md\\:first\\:-mx-5:first-child{
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .md\\:first\\:-my-6:first-child{
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }

  .md\\:first\\:-mx-6:first-child{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .md\\:first\\:-my-7:first-child{
    margin-top: -1.75rem;
    margin-bottom: -1.75rem;
  }

  .md\\:first\\:-mx-7:first-child{
    margin-left: -1.75rem;
    margin-right: -1.75rem;
  }

  .md\\:first\\:-my-8:first-child{
    margin-top: -2rem;
    margin-bottom: -2rem;
  }

  .md\\:first\\:-mx-8:first-child{
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .md\\:first\\:-my-9:first-child{
    margin-top: -2.25rem;
    margin-bottom: -2.25rem;
  }

  .md\\:first\\:-mx-9:first-child{
    margin-left: -2.25rem;
    margin-right: -2.25rem;
  }

  .md\\:first\\:-my-10:first-child{
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }

  .md\\:first\\:-mx-10:first-child{
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .md\\:first\\:-my-11:first-child{
    margin-top: -2.75rem;
    margin-bottom: -2.75rem;
  }

  .md\\:first\\:-mx-11:first-child{
    margin-left: -2.75rem;
    margin-right: -2.75rem;
  }

  .md\\:first\\:-my-12:first-child{
    margin-top: -3rem;
    margin-bottom: -3rem;
  }

  .md\\:first\\:-mx-12:first-child{
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .md\\:first\\:-my-14:first-child{
    margin-top: -3.5rem;
    margin-bottom: -3.5rem;
  }

  .md\\:first\\:-mx-14:first-child{
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }

  .md\\:first\\:-my-15:first-child{
    margin-top: -3.75rem;
    margin-bottom: -3.75rem;
  }

  .md\\:first\\:-mx-15:first-child{
    margin-left: -3.75rem;
    margin-right: -3.75rem;
  }

  .md\\:first\\:-my-16:first-child{
    margin-top: -4rem;
    margin-bottom: -4rem;
  }

  .md\\:first\\:-mx-16:first-child{
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .md\\:first\\:-my-18:first-child{
    margin-top: -4.5rem;
    margin-bottom: -4.5rem;
  }

  .md\\:first\\:-mx-18:first-child{
    margin-left: -4.5rem;
    margin-right: -4.5rem;
  }

  .md\\:first\\:-my-20:first-child{
    margin-top: -5rem;
    margin-bottom: -5rem;
  }

  .md\\:first\\:-mx-20:first-child{
    margin-left: -5rem;
    margin-right: -5rem;
  }

  .md\\:first\\:-my-22:first-child{
    margin-top: -5.5rem;
    margin-bottom: -5.5rem;
  }

  .md\\:first\\:-mx-22:first-child{
    margin-left: -5.5rem;
    margin-right: -5.5rem;
  }

  .md\\:first\\:-my-23:first-child{
    margin-top: -5.75rem;
    margin-bottom: -5.75rem;
  }

  .md\\:first\\:-mx-23:first-child{
    margin-left: -5.75rem;
    margin-right: -5.75rem;
  }

  .md\\:first\\:-my-24:first-child{
    margin-top: -6rem;
    margin-bottom: -6rem;
  }

  .md\\:first\\:-mx-24:first-child{
    margin-left: -6rem;
    margin-right: -6rem;
  }

  .md\\:first\\:-my-25:first-child{
    margin-top: -6.25rem;
    margin-bottom: -6.25rem;
  }

  .md\\:first\\:-mx-25:first-child{
    margin-left: -6.25rem;
    margin-right: -6.25rem;
  }

  .md\\:first\\:-my-26:first-child{
    margin-top: -6.5rem;
    margin-bottom: -6.5rem;
  }

  .md\\:first\\:-mx-26:first-child{
    margin-left: -6.5rem;
    margin-right: -6.5rem;
  }

  .md\\:first\\:-my-28:first-child{
    margin-top: -7rem;
    margin-bottom: -7rem;
  }

  .md\\:first\\:-mx-28:first-child{
    margin-left: -7rem;
    margin-right: -7rem;
  }

  .md\\:first\\:-my-30:first-child{
    margin-top: -7.5rem;
    margin-bottom: -7.5rem;
  }

  .md\\:first\\:-mx-30:first-child{
    margin-left: -7.5rem;
    margin-right: -7.5rem;
  }

  .md\\:first\\:-my-32:first-child{
    margin-top: -8rem;
    margin-bottom: -8rem;
  }

  .md\\:first\\:-mx-32:first-child{
    margin-left: -8rem;
    margin-right: -8rem;
  }

  .md\\:first\\:-my-34:first-child{
    margin-top: -8.5rem;
    margin-bottom: -8.5rem;
  }

  .md\\:first\\:-mx-34:first-child{
    margin-left: -8.5rem;
    margin-right: -8.5rem;
  }

  .md\\:first\\:-my-40:first-child{
    margin-top: -10rem;
    margin-bottom: -10rem;
  }

  .md\\:first\\:-mx-40:first-child{
    margin-left: -10rem;
    margin-right: -10rem;
  }

  .md\\:first\\:-my-42:first-child{
    margin-top: -10.5rem;
    margin-bottom: -10.5rem;
  }

  .md\\:first\\:-mx-42:first-child{
    margin-left: -10.5rem;
    margin-right: -10.5rem;
  }

  .md\\:first\\:-my-44:first-child{
    margin-top: -11rem;
    margin-bottom: -11rem;
  }

  .md\\:first\\:-mx-44:first-child{
    margin-left: -11rem;
    margin-right: -11rem;
  }

  .md\\:first\\:-my-48:first-child{
    margin-top: -12rem;
    margin-bottom: -12rem;
  }

  .md\\:first\\:-mx-48:first-child{
    margin-left: -12rem;
    margin-right: -12rem;
  }

  .md\\:first\\:-my-52:first-child{
    margin-top: -13rem;
    margin-bottom: -13rem;
  }

  .md\\:first\\:-mx-52:first-child{
    margin-left: -13rem;
    margin-right: -13rem;
  }

  .md\\:first\\:-my-54:first-child{
    margin-top: -13.5rem;
    margin-bottom: -13.5rem;
  }

  .md\\:first\\:-mx-54:first-child{
    margin-left: -13.5rem;
    margin-right: -13.5rem;
  }

  .md\\:first\\:-my-56:first-child{
    margin-top: -14rem;
    margin-bottom: -14rem;
  }

  .md\\:first\\:-mx-56:first-child{
    margin-left: -14rem;
    margin-right: -14rem;
  }

  .md\\:first\\:-my-60:first-child{
    margin-top: -15rem;
    margin-bottom: -15rem;
  }

  .md\\:first\\:-mx-60:first-child{
    margin-left: -15rem;
    margin-right: -15rem;
  }

  .md\\:first\\:-my-64:first-child{
    margin-top: -16rem;
    margin-bottom: -16rem;
  }

  .md\\:first\\:-mx-64:first-child{
    margin-left: -16rem;
    margin-right: -16rem;
  }

  .md\\:first\\:-my-68:first-child{
    margin-top: -17rem;
    margin-bottom: -17rem;
  }

  .md\\:first\\:-mx-68:first-child{
    margin-left: -17rem;
    margin-right: -17rem;
  }

  .md\\:first\\:-my-72:first-child{
    margin-top: -18rem;
    margin-bottom: -18rem;
  }

  .md\\:first\\:-mx-72:first-child{
    margin-left: -18rem;
    margin-right: -18rem;
  }

  .md\\:first\\:-my-74:first-child{
    margin-top: -18.5rem;
    margin-bottom: -18.5rem;
  }

  .md\\:first\\:-mx-74:first-child{
    margin-left: -18.5rem;
    margin-right: -18.5rem;
  }

  .md\\:first\\:-my-76:first-child{
    margin-top: -19rem;
    margin-bottom: -19rem;
  }

  .md\\:first\\:-mx-76:first-child{
    margin-left: -19rem;
    margin-right: -19rem;
  }

  .md\\:first\\:-my-78:first-child{
    margin-top: -19.5rem;
    margin-bottom: -19.5rem;
  }

  .md\\:first\\:-mx-78:first-child{
    margin-left: -19.5rem;
    margin-right: -19.5rem;
  }

  .md\\:first\\:-my-80:first-child{
    margin-top: -20rem;
    margin-bottom: -20rem;
  }

  .md\\:first\\:-mx-80:first-child{
    margin-left: -20rem;
    margin-right: -20rem;
  }

  .md\\:first\\:-my-82:first-child{
    margin-top: -20.5rem;
    margin-bottom: -20.5rem;
  }

  .md\\:first\\:-mx-82:first-child{
    margin-left: -20.5rem;
    margin-right: -20.5rem;
  }

  .md\\:first\\:-my-84:first-child{
    margin-top: -21rem;
    margin-bottom: -21rem;
  }

  .md\\:first\\:-mx-84:first-child{
    margin-left: -21rem;
    margin-right: -21rem;
  }

  .md\\:first\\:-my-88:first-child{
    margin-top: -22rem;
    margin-bottom: -22rem;
  }

  .md\\:first\\:-mx-88:first-child{
    margin-left: -22rem;
    margin-right: -22rem;
  }

  .md\\:first\\:-my-92:first-child{
    margin-top: -23rem;
    margin-bottom: -23rem;
  }

  .md\\:first\\:-mx-92:first-child{
    margin-left: -23rem;
    margin-right: -23rem;
  }

  .md\\:first\\:-my-96:first-child{
    margin-top: -24rem;
    margin-bottom: -24rem;
  }

  .md\\:first\\:-mx-96:first-child{
    margin-left: -24rem;
    margin-right: -24rem;
  }

  .md\\:first\\:-my-98:first-child{
    margin-top: -24.5rem;
    margin-bottom: -24.5rem;
  }

  .md\\:first\\:-mx-98:first-child{
    margin-left: -24.5rem;
    margin-right: -24.5rem;
  }

  .md\\:first\\:-my-100:first-child{
    margin-top: -25rem;
    margin-bottom: -25rem;
  }

  .md\\:first\\:-mx-100:first-child{
    margin-left: -25rem;
    margin-right: -25rem;
  }

  .md\\:first\\:-my-104:first-child{
    margin-top: -26rem;
    margin-bottom: -26rem;
  }

  .md\\:first\\:-mx-104:first-child{
    margin-left: -26rem;
    margin-right: -26rem;
  }

  .md\\:first\\:-my-112:first-child{
    margin-top: -28rem;
    margin-bottom: -28rem;
  }

  .md\\:first\\:-mx-112:first-child{
    margin-left: -28rem;
    margin-right: -28rem;
  }

  .md\\:first\\:-my-124:first-child{
    margin-top: -31rem;
    margin-bottom: -31rem;
  }

  .md\\:first\\:-mx-124:first-child{
    margin-left: -31rem;
    margin-right: -31rem;
  }

  .md\\:first\\:-my-128:first-child{
    margin-top: -32rem;
    margin-bottom: -32rem;
  }

  .md\\:first\\:-mx-128:first-child{
    margin-left: -32rem;
    margin-right: -32rem;
  }

  .md\\:first\\:-my-140:first-child{
    margin-top: -35rem;
    margin-bottom: -35rem;
  }

  .md\\:first\\:-mx-140:first-child{
    margin-left: -35rem;
    margin-right: -35rem;
  }

  .md\\:first\\:-my-152:first-child{
    margin-top: -38rem;
    margin-bottom: -38rem;
  }

  .md\\:first\\:-mx-152:first-child{
    margin-left: -38rem;
    margin-right: -38rem;
  }

  .md\\:first\\:-my-160:first-child{
    margin-top: -40rem;
    margin-bottom: -40rem;
  }

  .md\\:first\\:-mx-160:first-child{
    margin-left: -40rem;
    margin-right: -40rem;
  }

  .md\\:first\\:-my-162:first-child{
    margin-top: -41rem;
    margin-bottom: -41rem;
  }

  .md\\:first\\:-mx-162:first-child{
    margin-left: -41rem;
    margin-right: -41rem;
  }

  .md\\:first\\:-my-192:first-child{
    margin-top: -48rem;
    margin-bottom: -48rem;
  }

  .md\\:first\\:-mx-192:first-child{
    margin-left: -48rem;
    margin-right: -48rem;
  }

  .md\\:first\\:-my-208:first-child{
    margin-top: -52rem;
    margin-bottom: -52rem;
  }

  .md\\:first\\:-mx-208:first-child{
    margin-left: -52rem;
    margin-right: -52rem;
  }

  .md\\:first\\:-my-224:first-child{
    margin-top: -56rem;
    margin-bottom: -56rem;
  }

  .md\\:first\\:-mx-224:first-child{
    margin-left: -56rem;
    margin-right: -56rem;
  }

  .md\\:first\\:-my-256:first-child{
    margin-top: -64rem;
    margin-bottom: -64rem;
  }

  .md\\:first\\:-mx-256:first-child{
    margin-left: -64rem;
    margin-right: -64rem;
  }

  .md\\:first\\:-my-px:first-child{
    margin-top: -1px;
    margin-bottom: -1px;
  }

  .md\\:first\\:-mx-px:first-child{
    margin-left: -1px;
    margin-right: -1px;
  }

  .md\\:first\\:mt-0:first-child{
    margin-top: 0;
  }

  .md\\:first\\:mr-0:first-child{
    margin-right: 0;
  }

  .md\\:first\\:mb-0:first-child{
    margin-bottom: 0;
  }

  .md\\:first\\:ml-0:first-child{
    margin-left: 0;
  }

  .md\\:first\\:mt-1:first-child{
    margin-top: 0.25rem;
  }

  .md\\:first\\:mr-1:first-child{
    margin-right: 0.25rem;
  }

  .md\\:first\\:mb-1:first-child{
    margin-bottom: 0.25rem;
  }

  .md\\:first\\:ml-1:first-child{
    margin-left: 0.25rem;
  }

  .md\\:first\\:mt-2:first-child{
    margin-top: 0.5rem;
  }

  .md\\:first\\:mr-2:first-child{
    margin-right: 0.5rem;
  }

  .md\\:first\\:mb-2:first-child{
    margin-bottom: 0.5rem;
  }

  .md\\:first\\:ml-2:first-child{
    margin-left: 0.5rem;
  }

  .md\\:first\\:mt-3:first-child{
    margin-top: 0.75rem;
  }

  .md\\:first\\:mr-3:first-child{
    margin-right: 0.75rem;
  }

  .md\\:first\\:mb-3:first-child{
    margin-bottom: 0.75rem;
  }

  .md\\:first\\:ml-3:first-child{
    margin-left: 0.75rem;
  }

  .md\\:first\\:mt-4:first-child{
    margin-top: 1rem;
  }

  .md\\:first\\:mr-4:first-child{
    margin-right: 1rem;
  }

  .md\\:first\\:mb-4:first-child{
    margin-bottom: 1rem;
  }

  .md\\:first\\:ml-4:first-child{
    margin-left: 1rem;
  }

  .md\\:first\\:mt-5:first-child{
    margin-top: 1.25rem;
  }

  .md\\:first\\:mr-5:first-child{
    margin-right: 1.25rem;
  }

  .md\\:first\\:mb-5:first-child{
    margin-bottom: 1.25rem;
  }

  .md\\:first\\:ml-5:first-child{
    margin-left: 1.25rem;
  }

  .md\\:first\\:mt-6:first-child{
    margin-top: 1.5rem;
  }

  .md\\:first\\:mr-6:first-child{
    margin-right: 1.5rem;
  }

  .md\\:first\\:mb-6:first-child{
    margin-bottom: 1.5rem;
  }

  .md\\:first\\:ml-6:first-child{
    margin-left: 1.5rem;
  }

  .md\\:first\\:mt-7:first-child{
    margin-top: 1.75rem;
  }

  .md\\:first\\:mr-7:first-child{
    margin-right: 1.75rem;
  }

  .md\\:first\\:mb-7:first-child{
    margin-bottom: 1.75rem;
  }

  .md\\:first\\:ml-7:first-child{
    margin-left: 1.75rem;
  }

  .md\\:first\\:mt-8:first-child{
    margin-top: 2rem;
  }

  .md\\:first\\:mr-8:first-child{
    margin-right: 2rem;
  }

  .md\\:first\\:mb-8:first-child{
    margin-bottom: 2rem;
  }

  .md\\:first\\:ml-8:first-child{
    margin-left: 2rem;
  }

  .md\\:first\\:mt-9:first-child{
    margin-top: 2.25rem;
  }

  .md\\:first\\:mr-9:first-child{
    margin-right: 2.25rem;
  }

  .md\\:first\\:mb-9:first-child{
    margin-bottom: 2.25rem;
  }

  .md\\:first\\:ml-9:first-child{
    margin-left: 2.25rem;
  }

  .md\\:first\\:mt-10:first-child{
    margin-top: 2.5rem;
  }

  .md\\:first\\:mr-10:first-child{
    margin-right: 2.5rem;
  }

  .md\\:first\\:mb-10:first-child{
    margin-bottom: 2.5rem;
  }

  .md\\:first\\:ml-10:first-child{
    margin-left: 2.5rem;
  }

  .md\\:first\\:mt-11:first-child{
    margin-top: 2.75rem;
  }

  .md\\:first\\:mr-11:first-child{
    margin-right: 2.75rem;
  }

  .md\\:first\\:mb-11:first-child{
    margin-bottom: 2.75rem;
  }

  .md\\:first\\:ml-11:first-child{
    margin-left: 2.75rem;
  }

  .md\\:first\\:mt-12:first-child{
    margin-top: 3rem;
  }

  .md\\:first\\:mr-12:first-child{
    margin-right: 3rem;
  }

  .md\\:first\\:mb-12:first-child{
    margin-bottom: 3rem;
  }

  .md\\:first\\:ml-12:first-child{
    margin-left: 3rem;
  }

  .md\\:first\\:mt-14:first-child{
    margin-top: 3.5rem;
  }

  .md\\:first\\:mr-14:first-child{
    margin-right: 3.5rem;
  }

  .md\\:first\\:mb-14:first-child{
    margin-bottom: 3.5rem;
  }

  .md\\:first\\:ml-14:first-child{
    margin-left: 3.5rem;
  }

  .md\\:first\\:mt-15:first-child{
    margin-top: 3.75rem;
  }

  .md\\:first\\:mr-15:first-child{
    margin-right: 3.75rem;
  }

  .md\\:first\\:mb-15:first-child{
    margin-bottom: 3.75rem;
  }

  .md\\:first\\:ml-15:first-child{
    margin-left: 3.75rem;
  }

  .md\\:first\\:mt-16:first-child{
    margin-top: 4rem;
  }

  .md\\:first\\:mr-16:first-child{
    margin-right: 4rem;
  }

  .md\\:first\\:mb-16:first-child{
    margin-bottom: 4rem;
  }

  .md\\:first\\:ml-16:first-child{
    margin-left: 4rem;
  }

  .md\\:first\\:mt-18:first-child{
    margin-top: 4.5rem;
  }

  .md\\:first\\:mr-18:first-child{
    margin-right: 4.5rem;
  }

  .md\\:first\\:mb-18:first-child{
    margin-bottom: 4.5rem;
  }

  .md\\:first\\:ml-18:first-child{
    margin-left: 4.5rem;
  }

  .md\\:first\\:mt-20:first-child{
    margin-top: 5rem;
  }

  .md\\:first\\:mr-20:first-child{
    margin-right: 5rem;
  }

  .md\\:first\\:mb-20:first-child{
    margin-bottom: 5rem;
  }

  .md\\:first\\:ml-20:first-child{
    margin-left: 5rem;
  }

  .md\\:first\\:mt-22:first-child{
    margin-top: 5.5rem;
  }

  .md\\:first\\:mr-22:first-child{
    margin-right: 5.5rem;
  }

  .md\\:first\\:mb-22:first-child{
    margin-bottom: 5.5rem;
  }

  .md\\:first\\:ml-22:first-child{
    margin-left: 5.5rem;
  }

  .md\\:first\\:mt-23:first-child{
    margin-top: 5.75rem;
  }

  .md\\:first\\:mr-23:first-child{
    margin-right: 5.75rem;
  }

  .md\\:first\\:mb-23:first-child{
    margin-bottom: 5.75rem;
  }

  .md\\:first\\:ml-23:first-child{
    margin-left: 5.75rem;
  }

  .md\\:first\\:mt-24:first-child{
    margin-top: 6rem;
  }

  .md\\:first\\:mr-24:first-child{
    margin-right: 6rem;
  }

  .md\\:first\\:mb-24:first-child{
    margin-bottom: 6rem;
  }

  .md\\:first\\:ml-24:first-child{
    margin-left: 6rem;
  }

  .md\\:first\\:mt-25:first-child{
    margin-top: 6.25rem;
  }

  .md\\:first\\:mr-25:first-child{
    margin-right: 6.25rem;
  }

  .md\\:first\\:mb-25:first-child{
    margin-bottom: 6.25rem;
  }

  .md\\:first\\:ml-25:first-child{
    margin-left: 6.25rem;
  }

  .md\\:first\\:mt-26:first-child{
    margin-top: 6.5rem;
  }

  .md\\:first\\:mr-26:first-child{
    margin-right: 6.5rem;
  }

  .md\\:first\\:mb-26:first-child{
    margin-bottom: 6.5rem;
  }

  .md\\:first\\:ml-26:first-child{
    margin-left: 6.5rem;
  }

  .md\\:first\\:mt-28:first-child{
    margin-top: 7rem;
  }

  .md\\:first\\:mr-28:first-child{
    margin-right: 7rem;
  }

  .md\\:first\\:mb-28:first-child{
    margin-bottom: 7rem;
  }

  .md\\:first\\:ml-28:first-child{
    margin-left: 7rem;
  }

  .md\\:first\\:mt-30:first-child{
    margin-top: 7.5rem;
  }

  .md\\:first\\:mr-30:first-child{
    margin-right: 7.5rem;
  }

  .md\\:first\\:mb-30:first-child{
    margin-bottom: 7.5rem;
  }

  .md\\:first\\:ml-30:first-child{
    margin-left: 7.5rem;
  }

  .md\\:first\\:mt-32:first-child{
    margin-top: 8rem;
  }

  .md\\:first\\:mr-32:first-child{
    margin-right: 8rem;
  }

  .md\\:first\\:mb-32:first-child{
    margin-bottom: 8rem;
  }

  .md\\:first\\:ml-32:first-child{
    margin-left: 8rem;
  }

  .md\\:first\\:mt-34:first-child{
    margin-top: 8.5rem;
  }

  .md\\:first\\:mr-34:first-child{
    margin-right: 8.5rem;
  }

  .md\\:first\\:mb-34:first-child{
    margin-bottom: 8.5rem;
  }

  .md\\:first\\:ml-34:first-child{
    margin-left: 8.5rem;
  }

  .md\\:first\\:mt-40:first-child{
    margin-top: 10rem;
  }

  .md\\:first\\:mr-40:first-child{
    margin-right: 10rem;
  }

  .md\\:first\\:mb-40:first-child{
    margin-bottom: 10rem;
  }

  .md\\:first\\:ml-40:first-child{
    margin-left: 10rem;
  }

  .md\\:first\\:mt-42:first-child{
    margin-top: 10.5rem;
  }

  .md\\:first\\:mr-42:first-child{
    margin-right: 10.5rem;
  }

  .md\\:first\\:mb-42:first-child{
    margin-bottom: 10.5rem;
  }

  .md\\:first\\:ml-42:first-child{
    margin-left: 10.5rem;
  }

  .md\\:first\\:mt-44:first-child{
    margin-top: 11rem;
  }

  .md\\:first\\:mr-44:first-child{
    margin-right: 11rem;
  }

  .md\\:first\\:mb-44:first-child{
    margin-bottom: 11rem;
  }

  .md\\:first\\:ml-44:first-child{
    margin-left: 11rem;
  }

  .md\\:first\\:mt-48:first-child{
    margin-top: 12rem;
  }

  .md\\:first\\:mr-48:first-child{
    margin-right: 12rem;
  }

  .md\\:first\\:mb-48:first-child{
    margin-bottom: 12rem;
  }

  .md\\:first\\:ml-48:first-child{
    margin-left: 12rem;
  }

  .md\\:first\\:mt-52:first-child{
    margin-top: 13rem;
  }

  .md\\:first\\:mr-52:first-child{
    margin-right: 13rem;
  }

  .md\\:first\\:mb-52:first-child{
    margin-bottom: 13rem;
  }

  .md\\:first\\:ml-52:first-child{
    margin-left: 13rem;
  }

  .md\\:first\\:mt-54:first-child{
    margin-top: 13.5rem;
  }

  .md\\:first\\:mr-54:first-child{
    margin-right: 13.5rem;
  }

  .md\\:first\\:mb-54:first-child{
    margin-bottom: 13.5rem;
  }

  .md\\:first\\:ml-54:first-child{
    margin-left: 13.5rem;
  }

  .md\\:first\\:mt-56:first-child{
    margin-top: 14rem;
  }

  .md\\:first\\:mr-56:first-child{
    margin-right: 14rem;
  }

  .md\\:first\\:mb-56:first-child{
    margin-bottom: 14rem;
  }

  .md\\:first\\:ml-56:first-child{
    margin-left: 14rem;
  }

  .md\\:first\\:mt-60:first-child{
    margin-top: 15rem;
  }

  .md\\:first\\:mr-60:first-child{
    margin-right: 15rem;
  }

  .md\\:first\\:mb-60:first-child{
    margin-bottom: 15rem;
  }

  .md\\:first\\:ml-60:first-child{
    margin-left: 15rem;
  }

  .md\\:first\\:mt-64:first-child{
    margin-top: 16rem;
  }

  .md\\:first\\:mr-64:first-child{
    margin-right: 16rem;
  }

  .md\\:first\\:mb-64:first-child{
    margin-bottom: 16rem;
  }

  .md\\:first\\:ml-64:first-child{
    margin-left: 16rem;
  }

  .md\\:first\\:mt-68:first-child{
    margin-top: 17rem;
  }

  .md\\:first\\:mr-68:first-child{
    margin-right: 17rem;
  }

  .md\\:first\\:mb-68:first-child{
    margin-bottom: 17rem;
  }

  .md\\:first\\:ml-68:first-child{
    margin-left: 17rem;
  }

  .md\\:first\\:mt-72:first-child{
    margin-top: 18rem;
  }

  .md\\:first\\:mr-72:first-child{
    margin-right: 18rem;
  }

  .md\\:first\\:mb-72:first-child{
    margin-bottom: 18rem;
  }

  .md\\:first\\:ml-72:first-child{
    margin-left: 18rem;
  }

  .md\\:first\\:mt-74:first-child{
    margin-top: 18.5rem;
  }

  .md\\:first\\:mr-74:first-child{
    margin-right: 18.5rem;
  }

  .md\\:first\\:mb-74:first-child{
    margin-bottom: 18.5rem;
  }

  .md\\:first\\:ml-74:first-child{
    margin-left: 18.5rem;
  }

  .md\\:first\\:mt-76:first-child{
    margin-top: 19rem;
  }

  .md\\:first\\:mr-76:first-child{
    margin-right: 19rem;
  }

  .md\\:first\\:mb-76:first-child{
    margin-bottom: 19rem;
  }

  .md\\:first\\:ml-76:first-child{
    margin-left: 19rem;
  }

  .md\\:first\\:mt-78:first-child{
    margin-top: 19.5rem;
  }

  .md\\:first\\:mr-78:first-child{
    margin-right: 19.5rem;
  }

  .md\\:first\\:mb-78:first-child{
    margin-bottom: 19.5rem;
  }

  .md\\:first\\:ml-78:first-child{
    margin-left: 19.5rem;
  }

  .md\\:first\\:mt-80:first-child{
    margin-top: 20rem;
  }

  .md\\:first\\:mr-80:first-child{
    margin-right: 20rem;
  }

  .md\\:first\\:mb-80:first-child{
    margin-bottom: 20rem;
  }

  .md\\:first\\:ml-80:first-child{
    margin-left: 20rem;
  }

  .md\\:first\\:mt-82:first-child{
    margin-top: 20.5rem;
  }

  .md\\:first\\:mr-82:first-child{
    margin-right: 20.5rem;
  }

  .md\\:first\\:mb-82:first-child{
    margin-bottom: 20.5rem;
  }

  .md\\:first\\:ml-82:first-child{
    margin-left: 20.5rem;
  }

  .md\\:first\\:mt-84:first-child{
    margin-top: 21rem;
  }

  .md\\:first\\:mr-84:first-child{
    margin-right: 21rem;
  }

  .md\\:first\\:mb-84:first-child{
    margin-bottom: 21rem;
  }

  .md\\:first\\:ml-84:first-child{
    margin-left: 21rem;
  }

  .md\\:first\\:mt-88:first-child{
    margin-top: 22rem;
  }

  .md\\:first\\:mr-88:first-child{
    margin-right: 22rem;
  }

  .md\\:first\\:mb-88:first-child{
    margin-bottom: 22rem;
  }

  .md\\:first\\:ml-88:first-child{
    margin-left: 22rem;
  }

  .md\\:first\\:mt-92:first-child{
    margin-top: 23rem;
  }

  .md\\:first\\:mr-92:first-child{
    margin-right: 23rem;
  }

  .md\\:first\\:mb-92:first-child{
    margin-bottom: 23rem;
  }

  .md\\:first\\:ml-92:first-child{
    margin-left: 23rem;
  }

  .md\\:first\\:mt-96:first-child{
    margin-top: 24rem;
  }

  .md\\:first\\:mr-96:first-child{
    margin-right: 24rem;
  }

  .md\\:first\\:mb-96:first-child{
    margin-bottom: 24rem;
  }

  .md\\:first\\:ml-96:first-child{
    margin-left: 24rem;
  }

  .md\\:first\\:mt-98:first-child{
    margin-top: 24.5rem;
  }

  .md\\:first\\:mr-98:first-child{
    margin-right: 24.5rem;
  }

  .md\\:first\\:mb-98:first-child{
    margin-bottom: 24.5rem;
  }

  .md\\:first\\:ml-98:first-child{
    margin-left: 24.5rem;
  }

  .md\\:first\\:mt-100:first-child{
    margin-top: 25rem;
  }

  .md\\:first\\:mr-100:first-child{
    margin-right: 25rem;
  }

  .md\\:first\\:mb-100:first-child{
    margin-bottom: 25rem;
  }

  .md\\:first\\:ml-100:first-child{
    margin-left: 25rem;
  }

  .md\\:first\\:mt-104:first-child{
    margin-top: 26rem;
  }

  .md\\:first\\:mr-104:first-child{
    margin-right: 26rem;
  }

  .md\\:first\\:mb-104:first-child{
    margin-bottom: 26rem;
  }

  .md\\:first\\:ml-104:first-child{
    margin-left: 26rem;
  }

  .md\\:first\\:mt-112:first-child{
    margin-top: 28rem;
  }

  .md\\:first\\:mr-112:first-child{
    margin-right: 28rem;
  }

  .md\\:first\\:mb-112:first-child{
    margin-bottom: 28rem;
  }

  .md\\:first\\:ml-112:first-child{
    margin-left: 28rem;
  }

  .md\\:first\\:mt-124:first-child{
    margin-top: 31rem;
  }

  .md\\:first\\:mr-124:first-child{
    margin-right: 31rem;
  }

  .md\\:first\\:mb-124:first-child{
    margin-bottom: 31rem;
  }

  .md\\:first\\:ml-124:first-child{
    margin-left: 31rem;
  }

  .md\\:first\\:mt-128:first-child{
    margin-top: 32rem;
  }

  .md\\:first\\:mr-128:first-child{
    margin-right: 32rem;
  }

  .md\\:first\\:mb-128:first-child{
    margin-bottom: 32rem;
  }

  .md\\:first\\:ml-128:first-child{
    margin-left: 32rem;
  }

  .md\\:first\\:mt-140:first-child{
    margin-top: 35rem;
  }

  .md\\:first\\:mr-140:first-child{
    margin-right: 35rem;
  }

  .md\\:first\\:mb-140:first-child{
    margin-bottom: 35rem;
  }

  .md\\:first\\:ml-140:first-child{
    margin-left: 35rem;
  }

  .md\\:first\\:mt-152:first-child{
    margin-top: 38rem;
  }

  .md\\:first\\:mr-152:first-child{
    margin-right: 38rem;
  }

  .md\\:first\\:mb-152:first-child{
    margin-bottom: 38rem;
  }

  .md\\:first\\:ml-152:first-child{
    margin-left: 38rem;
  }

  .md\\:first\\:mt-160:first-child{
    margin-top: 40rem;
  }

  .md\\:first\\:mr-160:first-child{
    margin-right: 40rem;
  }

  .md\\:first\\:mb-160:first-child{
    margin-bottom: 40rem;
  }

  .md\\:first\\:ml-160:first-child{
    margin-left: 40rem;
  }

  .md\\:first\\:mt-162:first-child{
    margin-top: 41rem;
  }

  .md\\:first\\:mr-162:first-child{
    margin-right: 41rem;
  }

  .md\\:first\\:mb-162:first-child{
    margin-bottom: 41rem;
  }

  .md\\:first\\:ml-162:first-child{
    margin-left: 41rem;
  }

  .md\\:first\\:mt-192:first-child{
    margin-top: 48rem;
  }

  .md\\:first\\:mr-192:first-child{
    margin-right: 48rem;
  }

  .md\\:first\\:mb-192:first-child{
    margin-bottom: 48rem;
  }

  .md\\:first\\:ml-192:first-child{
    margin-left: 48rem;
  }

  .md\\:first\\:mt-208:first-child{
    margin-top: 52rem;
  }

  .md\\:first\\:mr-208:first-child{
    margin-right: 52rem;
  }

  .md\\:first\\:mb-208:first-child{
    margin-bottom: 52rem;
  }

  .md\\:first\\:ml-208:first-child{
    margin-left: 52rem;
  }

  .md\\:first\\:mt-224:first-child{
    margin-top: 56rem;
  }

  .md\\:first\\:mr-224:first-child{
    margin-right: 56rem;
  }

  .md\\:first\\:mb-224:first-child{
    margin-bottom: 56rem;
  }

  .md\\:first\\:ml-224:first-child{
    margin-left: 56rem;
  }

  .md\\:first\\:mt-256:first-child{
    margin-top: 64rem;
  }

  .md\\:first\\:mr-256:first-child{
    margin-right: 64rem;
  }

  .md\\:first\\:mb-256:first-child{
    margin-bottom: 64rem;
  }

  .md\\:first\\:ml-256:first-child{
    margin-left: 64rem;
  }

  .md\\:first\\:mt-auto:first-child{
    margin-top: auto;
  }

  .md\\:first\\:mr-auto:first-child{
    margin-right: auto;
  }

  .md\\:first\\:mb-auto:first-child{
    margin-bottom: auto;
  }

  .md\\:first\\:ml-auto:first-child{
    margin-left: auto;
  }

  .md\\:first\\:mt-px:first-child{
    margin-top: 1px;
  }

  .md\\:first\\:mr-px:first-child{
    margin-right: 1px;
  }

  .md\\:first\\:mb-px:first-child{
    margin-bottom: 1px;
  }

  .md\\:first\\:ml-px:first-child{
    margin-left: 1px;
  }

  .md\\:first\\:-mt-1:first-child{
    margin-top: -0.25rem;
  }

  .md\\:first\\:-mr-1:first-child{
    margin-right: -0.25rem;
  }

  .md\\:first\\:-mb-1:first-child{
    margin-bottom: -0.25rem;
  }

  .md\\:first\\:-ml-1:first-child{
    margin-left: -0.25rem;
  }

  .md\\:first\\:-mt-2:first-child{
    margin-top: -0.5rem;
  }

  .md\\:first\\:-mr-2:first-child{
    margin-right: -0.5rem;
  }

  .md\\:first\\:-mb-2:first-child{
    margin-bottom: -0.5rem;
  }

  .md\\:first\\:-ml-2:first-child{
    margin-left: -0.5rem;
  }

  .md\\:first\\:-mt-3:first-child{
    margin-top: -0.75rem;
  }

  .md\\:first\\:-mr-3:first-child{
    margin-right: -0.75rem;
  }

  .md\\:first\\:-mb-3:first-child{
    margin-bottom: -0.75rem;
  }

  .md\\:first\\:-ml-3:first-child{
    margin-left: -0.75rem;
  }

  .md\\:first\\:-mt-4:first-child{
    margin-top: -1rem;
  }

  .md\\:first\\:-mr-4:first-child{
    margin-right: -1rem;
  }

  .md\\:first\\:-mb-4:first-child{
    margin-bottom: -1rem;
  }

  .md\\:first\\:-ml-4:first-child{
    margin-left: -1rem;
  }

  .md\\:first\\:-mt-5:first-child{
    margin-top: -1.25rem;
  }

  .md\\:first\\:-mr-5:first-child{
    margin-right: -1.25rem;
  }

  .md\\:first\\:-mb-5:first-child{
    margin-bottom: -1.25rem;
  }

  .md\\:first\\:-ml-5:first-child{
    margin-left: -1.25rem;
  }

  .md\\:first\\:-mt-6:first-child{
    margin-top: -1.5rem;
  }

  .md\\:first\\:-mr-6:first-child{
    margin-right: -1.5rem;
  }

  .md\\:first\\:-mb-6:first-child{
    margin-bottom: -1.5rem;
  }

  .md\\:first\\:-ml-6:first-child{
    margin-left: -1.5rem;
  }

  .md\\:first\\:-mt-7:first-child{
    margin-top: -1.75rem;
  }

  .md\\:first\\:-mr-7:first-child{
    margin-right: -1.75rem;
  }

  .md\\:first\\:-mb-7:first-child{
    margin-bottom: -1.75rem;
  }

  .md\\:first\\:-ml-7:first-child{
    margin-left: -1.75rem;
  }

  .md\\:first\\:-mt-8:first-child{
    margin-top: -2rem;
  }

  .md\\:first\\:-mr-8:first-child{
    margin-right: -2rem;
  }

  .md\\:first\\:-mb-8:first-child{
    margin-bottom: -2rem;
  }

  .md\\:first\\:-ml-8:first-child{
    margin-left: -2rem;
  }

  .md\\:first\\:-mt-9:first-child{
    margin-top: -2.25rem;
  }

  .md\\:first\\:-mr-9:first-child{
    margin-right: -2.25rem;
  }

  .md\\:first\\:-mb-9:first-child{
    margin-bottom: -2.25rem;
  }

  .md\\:first\\:-ml-9:first-child{
    margin-left: -2.25rem;
  }

  .md\\:first\\:-mt-10:first-child{
    margin-top: -2.5rem;
  }

  .md\\:first\\:-mr-10:first-child{
    margin-right: -2.5rem;
  }

  .md\\:first\\:-mb-10:first-child{
    margin-bottom: -2.5rem;
  }

  .md\\:first\\:-ml-10:first-child{
    margin-left: -2.5rem;
  }

  .md\\:first\\:-mt-11:first-child{
    margin-top: -2.75rem;
  }

  .md\\:first\\:-mr-11:first-child{
    margin-right: -2.75rem;
  }

  .md\\:first\\:-mb-11:first-child{
    margin-bottom: -2.75rem;
  }

  .md\\:first\\:-ml-11:first-child{
    margin-left: -2.75rem;
  }

  .md\\:first\\:-mt-12:first-child{
    margin-top: -3rem;
  }

  .md\\:first\\:-mr-12:first-child{
    margin-right: -3rem;
  }

  .md\\:first\\:-mb-12:first-child{
    margin-bottom: -3rem;
  }

  .md\\:first\\:-ml-12:first-child{
    margin-left: -3rem;
  }

  .md\\:first\\:-mt-14:first-child{
    margin-top: -3.5rem;
  }

  .md\\:first\\:-mr-14:first-child{
    margin-right: -3.5rem;
  }

  .md\\:first\\:-mb-14:first-child{
    margin-bottom: -3.5rem;
  }

  .md\\:first\\:-ml-14:first-child{
    margin-left: -3.5rem;
  }

  .md\\:first\\:-mt-15:first-child{
    margin-top: -3.75rem;
  }

  .md\\:first\\:-mr-15:first-child{
    margin-right: -3.75rem;
  }

  .md\\:first\\:-mb-15:first-child{
    margin-bottom: -3.75rem;
  }

  .md\\:first\\:-ml-15:first-child{
    margin-left: -3.75rem;
  }

  .md\\:first\\:-mt-16:first-child{
    margin-top: -4rem;
  }

  .md\\:first\\:-mr-16:first-child{
    margin-right: -4rem;
  }

  .md\\:first\\:-mb-16:first-child{
    margin-bottom: -4rem;
  }

  .md\\:first\\:-ml-16:first-child{
    margin-left: -4rem;
  }

  .md\\:first\\:-mt-18:first-child{
    margin-top: -4.5rem;
  }

  .md\\:first\\:-mr-18:first-child{
    margin-right: -4.5rem;
  }

  .md\\:first\\:-mb-18:first-child{
    margin-bottom: -4.5rem;
  }

  .md\\:first\\:-ml-18:first-child{
    margin-left: -4.5rem;
  }

  .md\\:first\\:-mt-20:first-child{
    margin-top: -5rem;
  }

  .md\\:first\\:-mr-20:first-child{
    margin-right: -5rem;
  }

  .md\\:first\\:-mb-20:first-child{
    margin-bottom: -5rem;
  }

  .md\\:first\\:-ml-20:first-child{
    margin-left: -5rem;
  }

  .md\\:first\\:-mt-22:first-child{
    margin-top: -5.5rem;
  }

  .md\\:first\\:-mr-22:first-child{
    margin-right: -5.5rem;
  }

  .md\\:first\\:-mb-22:first-child{
    margin-bottom: -5.5rem;
  }

  .md\\:first\\:-ml-22:first-child{
    margin-left: -5.5rem;
  }

  .md\\:first\\:-mt-23:first-child{
    margin-top: -5.75rem;
  }

  .md\\:first\\:-mr-23:first-child{
    margin-right: -5.75rem;
  }

  .md\\:first\\:-mb-23:first-child{
    margin-bottom: -5.75rem;
  }

  .md\\:first\\:-ml-23:first-child{
    margin-left: -5.75rem;
  }

  .md\\:first\\:-mt-24:first-child{
    margin-top: -6rem;
  }

  .md\\:first\\:-mr-24:first-child{
    margin-right: -6rem;
  }

  .md\\:first\\:-mb-24:first-child{
    margin-bottom: -6rem;
  }

  .md\\:first\\:-ml-24:first-child{
    margin-left: -6rem;
  }

  .md\\:first\\:-mt-25:first-child{
    margin-top: -6.25rem;
  }

  .md\\:first\\:-mr-25:first-child{
    margin-right: -6.25rem;
  }

  .md\\:first\\:-mb-25:first-child{
    margin-bottom: -6.25rem;
  }

  .md\\:first\\:-ml-25:first-child{
    margin-left: -6.25rem;
  }

  .md\\:first\\:-mt-26:first-child{
    margin-top: -6.5rem;
  }

  .md\\:first\\:-mr-26:first-child{
    margin-right: -6.5rem;
  }

  .md\\:first\\:-mb-26:first-child{
    margin-bottom: -6.5rem;
  }

  .md\\:first\\:-ml-26:first-child{
    margin-left: -6.5rem;
  }

  .md\\:first\\:-mt-28:first-child{
    margin-top: -7rem;
  }

  .md\\:first\\:-mr-28:first-child{
    margin-right: -7rem;
  }

  .md\\:first\\:-mb-28:first-child{
    margin-bottom: -7rem;
  }

  .md\\:first\\:-ml-28:first-child{
    margin-left: -7rem;
  }

  .md\\:first\\:-mt-30:first-child{
    margin-top: -7.5rem;
  }

  .md\\:first\\:-mr-30:first-child{
    margin-right: -7.5rem;
  }

  .md\\:first\\:-mb-30:first-child{
    margin-bottom: -7.5rem;
  }

  .md\\:first\\:-ml-30:first-child{
    margin-left: -7.5rem;
  }

  .md\\:first\\:-mt-32:first-child{
    margin-top: -8rem;
  }

  .md\\:first\\:-mr-32:first-child{
    margin-right: -8rem;
  }

  .md\\:first\\:-mb-32:first-child{
    margin-bottom: -8rem;
  }

  .md\\:first\\:-ml-32:first-child{
    margin-left: -8rem;
  }

  .md\\:first\\:-mt-34:first-child{
    margin-top: -8.5rem;
  }

  .md\\:first\\:-mr-34:first-child{
    margin-right: -8.5rem;
  }

  .md\\:first\\:-mb-34:first-child{
    margin-bottom: -8.5rem;
  }

  .md\\:first\\:-ml-34:first-child{
    margin-left: -8.5rem;
  }

  .md\\:first\\:-mt-40:first-child{
    margin-top: -10rem;
  }

  .md\\:first\\:-mr-40:first-child{
    margin-right: -10rem;
  }

  .md\\:first\\:-mb-40:first-child{
    margin-bottom: -10rem;
  }

  .md\\:first\\:-ml-40:first-child{
    margin-left: -10rem;
  }

  .md\\:first\\:-mt-42:first-child{
    margin-top: -10.5rem;
  }

  .md\\:first\\:-mr-42:first-child{
    margin-right: -10.5rem;
  }

  .md\\:first\\:-mb-42:first-child{
    margin-bottom: -10.5rem;
  }

  .md\\:first\\:-ml-42:first-child{
    margin-left: -10.5rem;
  }

  .md\\:first\\:-mt-44:first-child{
    margin-top: -11rem;
  }

  .md\\:first\\:-mr-44:first-child{
    margin-right: -11rem;
  }

  .md\\:first\\:-mb-44:first-child{
    margin-bottom: -11rem;
  }

  .md\\:first\\:-ml-44:first-child{
    margin-left: -11rem;
  }

  .md\\:first\\:-mt-48:first-child{
    margin-top: -12rem;
  }

  .md\\:first\\:-mr-48:first-child{
    margin-right: -12rem;
  }

  .md\\:first\\:-mb-48:first-child{
    margin-bottom: -12rem;
  }

  .md\\:first\\:-ml-48:first-child{
    margin-left: -12rem;
  }

  .md\\:first\\:-mt-52:first-child{
    margin-top: -13rem;
  }

  .md\\:first\\:-mr-52:first-child{
    margin-right: -13rem;
  }

  .md\\:first\\:-mb-52:first-child{
    margin-bottom: -13rem;
  }

  .md\\:first\\:-ml-52:first-child{
    margin-left: -13rem;
  }

  .md\\:first\\:-mt-54:first-child{
    margin-top: -13.5rem;
  }

  .md\\:first\\:-mr-54:first-child{
    margin-right: -13.5rem;
  }

  .md\\:first\\:-mb-54:first-child{
    margin-bottom: -13.5rem;
  }

  .md\\:first\\:-ml-54:first-child{
    margin-left: -13.5rem;
  }

  .md\\:first\\:-mt-56:first-child{
    margin-top: -14rem;
  }

  .md\\:first\\:-mr-56:first-child{
    margin-right: -14rem;
  }

  .md\\:first\\:-mb-56:first-child{
    margin-bottom: -14rem;
  }

  .md\\:first\\:-ml-56:first-child{
    margin-left: -14rem;
  }

  .md\\:first\\:-mt-60:first-child{
    margin-top: -15rem;
  }

  .md\\:first\\:-mr-60:first-child{
    margin-right: -15rem;
  }

  .md\\:first\\:-mb-60:first-child{
    margin-bottom: -15rem;
  }

  .md\\:first\\:-ml-60:first-child{
    margin-left: -15rem;
  }

  .md\\:first\\:-mt-64:first-child{
    margin-top: -16rem;
  }

  .md\\:first\\:-mr-64:first-child{
    margin-right: -16rem;
  }

  .md\\:first\\:-mb-64:first-child{
    margin-bottom: -16rem;
  }

  .md\\:first\\:-ml-64:first-child{
    margin-left: -16rem;
  }

  .md\\:first\\:-mt-68:first-child{
    margin-top: -17rem;
  }

  .md\\:first\\:-mr-68:first-child{
    margin-right: -17rem;
  }

  .md\\:first\\:-mb-68:first-child{
    margin-bottom: -17rem;
  }

  .md\\:first\\:-ml-68:first-child{
    margin-left: -17rem;
  }

  .md\\:first\\:-mt-72:first-child{
    margin-top: -18rem;
  }

  .md\\:first\\:-mr-72:first-child{
    margin-right: -18rem;
  }

  .md\\:first\\:-mb-72:first-child{
    margin-bottom: -18rem;
  }

  .md\\:first\\:-ml-72:first-child{
    margin-left: -18rem;
  }

  .md\\:first\\:-mt-74:first-child{
    margin-top: -18.5rem;
  }

  .md\\:first\\:-mr-74:first-child{
    margin-right: -18.5rem;
  }

  .md\\:first\\:-mb-74:first-child{
    margin-bottom: -18.5rem;
  }

  .md\\:first\\:-ml-74:first-child{
    margin-left: -18.5rem;
  }

  .md\\:first\\:-mt-76:first-child{
    margin-top: -19rem;
  }

  .md\\:first\\:-mr-76:first-child{
    margin-right: -19rem;
  }

  .md\\:first\\:-mb-76:first-child{
    margin-bottom: -19rem;
  }

  .md\\:first\\:-ml-76:first-child{
    margin-left: -19rem;
  }

  .md\\:first\\:-mt-78:first-child{
    margin-top: -19.5rem;
  }

  .md\\:first\\:-mr-78:first-child{
    margin-right: -19.5rem;
  }

  .md\\:first\\:-mb-78:first-child{
    margin-bottom: -19.5rem;
  }

  .md\\:first\\:-ml-78:first-child{
    margin-left: -19.5rem;
  }

  .md\\:first\\:-mt-80:first-child{
    margin-top: -20rem;
  }

  .md\\:first\\:-mr-80:first-child{
    margin-right: -20rem;
  }

  .md\\:first\\:-mb-80:first-child{
    margin-bottom: -20rem;
  }

  .md\\:first\\:-ml-80:first-child{
    margin-left: -20rem;
  }

  .md\\:first\\:-mt-82:first-child{
    margin-top: -20.5rem;
  }

  .md\\:first\\:-mr-82:first-child{
    margin-right: -20.5rem;
  }

  .md\\:first\\:-mb-82:first-child{
    margin-bottom: -20.5rem;
  }

  .md\\:first\\:-ml-82:first-child{
    margin-left: -20.5rem;
  }

  .md\\:first\\:-mt-84:first-child{
    margin-top: -21rem;
  }

  .md\\:first\\:-mr-84:first-child{
    margin-right: -21rem;
  }

  .md\\:first\\:-mb-84:first-child{
    margin-bottom: -21rem;
  }

  .md\\:first\\:-ml-84:first-child{
    margin-left: -21rem;
  }

  .md\\:first\\:-mt-88:first-child{
    margin-top: -22rem;
  }

  .md\\:first\\:-mr-88:first-child{
    margin-right: -22rem;
  }

  .md\\:first\\:-mb-88:first-child{
    margin-bottom: -22rem;
  }

  .md\\:first\\:-ml-88:first-child{
    margin-left: -22rem;
  }

  .md\\:first\\:-mt-92:first-child{
    margin-top: -23rem;
  }

  .md\\:first\\:-mr-92:first-child{
    margin-right: -23rem;
  }

  .md\\:first\\:-mb-92:first-child{
    margin-bottom: -23rem;
  }

  .md\\:first\\:-ml-92:first-child{
    margin-left: -23rem;
  }

  .md\\:first\\:-mt-96:first-child{
    margin-top: -24rem;
  }

  .md\\:first\\:-mr-96:first-child{
    margin-right: -24rem;
  }

  .md\\:first\\:-mb-96:first-child{
    margin-bottom: -24rem;
  }

  .md\\:first\\:-ml-96:first-child{
    margin-left: -24rem;
  }

  .md\\:first\\:-mt-98:first-child{
    margin-top: -24.5rem;
  }

  .md\\:first\\:-mr-98:first-child{
    margin-right: -24.5rem;
  }

  .md\\:first\\:-mb-98:first-child{
    margin-bottom: -24.5rem;
  }

  .md\\:first\\:-ml-98:first-child{
    margin-left: -24.5rem;
  }

  .md\\:first\\:-mt-100:first-child{
    margin-top: -25rem;
  }

  .md\\:first\\:-mr-100:first-child{
    margin-right: -25rem;
  }

  .md\\:first\\:-mb-100:first-child{
    margin-bottom: -25rem;
  }

  .md\\:first\\:-ml-100:first-child{
    margin-left: -25rem;
  }

  .md\\:first\\:-mt-104:first-child{
    margin-top: -26rem;
  }

  .md\\:first\\:-mr-104:first-child{
    margin-right: -26rem;
  }

  .md\\:first\\:-mb-104:first-child{
    margin-bottom: -26rem;
  }

  .md\\:first\\:-ml-104:first-child{
    margin-left: -26rem;
  }

  .md\\:first\\:-mt-112:first-child{
    margin-top: -28rem;
  }

  .md\\:first\\:-mr-112:first-child{
    margin-right: -28rem;
  }

  .md\\:first\\:-mb-112:first-child{
    margin-bottom: -28rem;
  }

  .md\\:first\\:-ml-112:first-child{
    margin-left: -28rem;
  }

  .md\\:first\\:-mt-124:first-child{
    margin-top: -31rem;
  }

  .md\\:first\\:-mr-124:first-child{
    margin-right: -31rem;
  }

  .md\\:first\\:-mb-124:first-child{
    margin-bottom: -31rem;
  }

  .md\\:first\\:-ml-124:first-child{
    margin-left: -31rem;
  }

  .md\\:first\\:-mt-128:first-child{
    margin-top: -32rem;
  }

  .md\\:first\\:-mr-128:first-child{
    margin-right: -32rem;
  }

  .md\\:first\\:-mb-128:first-child{
    margin-bottom: -32rem;
  }

  .md\\:first\\:-ml-128:first-child{
    margin-left: -32rem;
  }

  .md\\:first\\:-mt-140:first-child{
    margin-top: -35rem;
  }

  .md\\:first\\:-mr-140:first-child{
    margin-right: -35rem;
  }

  .md\\:first\\:-mb-140:first-child{
    margin-bottom: -35rem;
  }

  .md\\:first\\:-ml-140:first-child{
    margin-left: -35rem;
  }

  .md\\:first\\:-mt-152:first-child{
    margin-top: -38rem;
  }

  .md\\:first\\:-mr-152:first-child{
    margin-right: -38rem;
  }

  .md\\:first\\:-mb-152:first-child{
    margin-bottom: -38rem;
  }

  .md\\:first\\:-ml-152:first-child{
    margin-left: -38rem;
  }

  .md\\:first\\:-mt-160:first-child{
    margin-top: -40rem;
  }

  .md\\:first\\:-mr-160:first-child{
    margin-right: -40rem;
  }

  .md\\:first\\:-mb-160:first-child{
    margin-bottom: -40rem;
  }

  .md\\:first\\:-ml-160:first-child{
    margin-left: -40rem;
  }

  .md\\:first\\:-mt-162:first-child{
    margin-top: -41rem;
  }

  .md\\:first\\:-mr-162:first-child{
    margin-right: -41rem;
  }

  .md\\:first\\:-mb-162:first-child{
    margin-bottom: -41rem;
  }

  .md\\:first\\:-ml-162:first-child{
    margin-left: -41rem;
  }

  .md\\:first\\:-mt-192:first-child{
    margin-top: -48rem;
  }

  .md\\:first\\:-mr-192:first-child{
    margin-right: -48rem;
  }

  .md\\:first\\:-mb-192:first-child{
    margin-bottom: -48rem;
  }

  .md\\:first\\:-ml-192:first-child{
    margin-left: -48rem;
  }

  .md\\:first\\:-mt-208:first-child{
    margin-top: -52rem;
  }

  .md\\:first\\:-mr-208:first-child{
    margin-right: -52rem;
  }

  .md\\:first\\:-mb-208:first-child{
    margin-bottom: -52rem;
  }

  .md\\:first\\:-ml-208:first-child{
    margin-left: -52rem;
  }

  .md\\:first\\:-mt-224:first-child{
    margin-top: -56rem;
  }

  .md\\:first\\:-mr-224:first-child{
    margin-right: -56rem;
  }

  .md\\:first\\:-mb-224:first-child{
    margin-bottom: -56rem;
  }

  .md\\:first\\:-ml-224:first-child{
    margin-left: -56rem;
  }

  .md\\:first\\:-mt-256:first-child{
    margin-top: -64rem;
  }

  .md\\:first\\:-mr-256:first-child{
    margin-right: -64rem;
  }

  .md\\:first\\:-mb-256:first-child{
    margin-bottom: -64rem;
  }

  .md\\:first\\:-ml-256:first-child{
    margin-left: -64rem;
  }

  .md\\:first\\:-mt-px:first-child{
    margin-top: -1px;
  }

  .md\\:first\\:-mr-px:first-child{
    margin-right: -1px;
  }

  .md\\:first\\:-mb-px:first-child{
    margin-bottom: -1px;
  }

  .md\\:first\\:-ml-px:first-child{
    margin-left: -1px;
  }

  .md\\:max-h-0{
    max-height: 0;
  }

  .md\\:max-h-1{
    max-height: 0.25rem;
  }

  .md\\:max-h-2{
    max-height: 0.5rem;
  }

  .md\\:max-h-3{
    max-height: 0.75rem;
  }

  .md\\:max-h-4{
    max-height: 1rem;
  }

  .md\\:max-h-5{
    max-height: 1.25rem;
  }

  .md\\:max-h-6{
    max-height: 1.5rem;
  }

  .md\\:max-h-7{
    max-height: 1.75rem;
  }

  .md\\:max-h-8{
    max-height: 2rem;
  }

  .md\\:max-h-9{
    max-height: 2.25rem;
  }

  .md\\:max-h-10{
    max-height: 2.5rem;
  }

  .md\\:max-h-11{
    max-height: 2.75rem;
  }

  .md\\:max-h-12{
    max-height: 3rem;
  }

  .md\\:max-h-14{
    max-height: 3.5rem;
  }

  .md\\:max-h-15{
    max-height: 3.75rem;
  }

  .md\\:max-h-16{
    max-height: 4rem;
  }

  .md\\:max-h-18{
    max-height: 4.5rem;
  }

  .md\\:max-h-20{
    max-height: 5rem;
  }

  .md\\:max-h-22{
    max-height: 5.5rem;
  }

  .md\\:max-h-23{
    max-height: 5.75rem;
  }

  .md\\:max-h-24{
    max-height: 6rem;
  }

  .md\\:max-h-25{
    max-height: 6.25rem;
  }

  .md\\:max-h-26{
    max-height: 6.5rem;
  }

  .md\\:max-h-28{
    max-height: 7rem;
  }

  .md\\:max-h-30{
    max-height: 7.5rem;
  }

  .md\\:max-h-32{
    max-height: 8rem;
  }

  .md\\:max-h-34{
    max-height: 8.5rem;
  }

  .md\\:max-h-40{
    max-height: 10rem;
  }

  .md\\:max-h-42{
    max-height: 10.5rem;
  }

  .md\\:max-h-44{
    max-height: 11rem;
  }

  .md\\:max-h-48{
    max-height: 12rem;
  }

  .md\\:max-h-52{
    max-height: 13rem;
  }

  .md\\:max-h-54{
    max-height: 13.5rem;
  }

  .md\\:max-h-56{
    max-height: 14rem;
  }

  .md\\:max-h-60{
    max-height: 15rem;
  }

  .md\\:max-h-64{
    max-height: 16rem;
  }

  .md\\:max-h-68{
    max-height: 17rem;
  }

  .md\\:max-h-72{
    max-height: 18rem;
  }

  .md\\:max-h-74{
    max-height: 18.5rem;
  }

  .md\\:max-h-76{
    max-height: 19rem;
  }

  .md\\:max-h-78{
    max-height: 19.5rem;
  }

  .md\\:max-h-80{
    max-height: 20rem;
  }

  .md\\:max-h-82{
    max-height: 20.5rem;
  }

  .md\\:max-h-84{
    max-height: 21rem;
  }

  .md\\:max-h-88{
    max-height: 22rem;
  }

  .md\\:max-h-92{
    max-height: 23rem;
  }

  .md\\:max-h-96{
    max-height: 24rem;
  }

  .md\\:max-h-98{
    max-height: 24.5rem;
  }

  .md\\:max-h-100{
    max-height: 25rem;
  }

  .md\\:max-h-104{
    max-height: 26rem;
  }

  .md\\:max-h-112{
    max-height: 28rem;
  }

  .md\\:max-h-124{
    max-height: 31rem;
  }

  .md\\:max-h-128{
    max-height: 32rem;
  }

  .md\\:max-h-140{
    max-height: 35rem;
  }

  .md\\:max-h-152{
    max-height: 38rem;
  }

  .md\\:max-h-160{
    max-height: 40rem;
  }

  .md\\:max-h-162{
    max-height: 41rem;
  }

  .md\\:max-h-192{
    max-height: 48rem;
  }

  .md\\:max-h-208{
    max-height: 52rem;
  }

  .md\\:max-h-224{
    max-height: 56rem;
  }

  .md\\:max-h-256{
    max-height: 64rem;
  }

  .md\\:max-h-px{
    max-height: 1px;
  }

  .md\\:max-h-full{
    max-height: 100%;
  }

  .md\\:max-h-screen{
    max-height: 100vh;
  }

  .md\\:max-w-0{
    max-width: 0;
  }

  .md\\:max-w-1{
    max-width: 0.25rem;
  }

  .md\\:max-w-2{
    max-width: 0.5rem;
  }

  .md\\:max-w-3{
    max-width: 0.75rem;
  }

  .md\\:max-w-4{
    max-width: 1rem;
  }

  .md\\:max-w-5{
    max-width: 1.25rem;
  }

  .md\\:max-w-6{
    max-width: 1.5rem;
  }

  .md\\:max-w-7{
    max-width: 1.75rem;
  }

  .md\\:max-w-8{
    max-width: 2rem;
  }

  .md\\:max-w-9{
    max-width: 2.25rem;
  }

  .md\\:max-w-10{
    max-width: 2.5rem;
  }

  .md\\:max-w-11{
    max-width: 2.75rem;
  }

  .md\\:max-w-12{
    max-width: 3rem;
  }

  .md\\:max-w-14{
    max-width: 3.5rem;
  }

  .md\\:max-w-15{
    max-width: 3.75rem;
  }

  .md\\:max-w-16{
    max-width: 4rem;
  }

  .md\\:max-w-18{
    max-width: 4.5rem;
  }

  .md\\:max-w-20{
    max-width: 5rem;
  }

  .md\\:max-w-22{
    max-width: 5.5rem;
  }

  .md\\:max-w-23{
    max-width: 5.75rem;
  }

  .md\\:max-w-24{
    max-width: 6rem;
  }

  .md\\:max-w-25{
    max-width: 6.25rem;
  }

  .md\\:max-w-26{
    max-width: 6.5rem;
  }

  .md\\:max-w-28{
    max-width: 7rem;
  }

  .md\\:max-w-30{
    max-width: 7.5rem;
  }

  .md\\:max-w-32{
    max-width: 8rem;
  }

  .md\\:max-w-34{
    max-width: 8.5rem;
  }

  .md\\:max-w-40{
    max-width: 10rem;
  }

  .md\\:max-w-42{
    max-width: 10.5rem;
  }

  .md\\:max-w-44{
    max-width: 11rem;
  }

  .md\\:max-w-48{
    max-width: 12rem;
  }

  .md\\:max-w-52{
    max-width: 13rem;
  }

  .md\\:max-w-54{
    max-width: 13.5rem;
  }

  .md\\:max-w-56{
    max-width: 14rem;
  }

  .md\\:max-w-60{
    max-width: 15rem;
  }

  .md\\:max-w-64{
    max-width: 16rem;
  }

  .md\\:max-w-68{
    max-width: 17rem;
  }

  .md\\:max-w-72{
    max-width: 18rem;
  }

  .md\\:max-w-74{
    max-width: 18.5rem;
  }

  .md\\:max-w-76{
    max-width: 19rem;
  }

  .md\\:max-w-78{
    max-width: 19.5rem;
  }

  .md\\:max-w-80{
    max-width: 20rem;
  }

  .md\\:max-w-82{
    max-width: 20.5rem;
  }

  .md\\:max-w-84{
    max-width: 21rem;
  }

  .md\\:max-w-88{
    max-width: 22rem;
  }

  .md\\:max-w-92{
    max-width: 23rem;
  }

  .md\\:max-w-96{
    max-width: 24rem;
  }

  .md\\:max-w-98{
    max-width: 24.5rem;
  }

  .md\\:max-w-100{
    max-width: 25rem;
  }

  .md\\:max-w-104{
    max-width: 26rem;
  }

  .md\\:max-w-112{
    max-width: 28rem;
  }

  .md\\:max-w-124{
    max-width: 31rem;
  }

  .md\\:max-w-128{
    max-width: 32rem;
  }

  .md\\:max-w-140{
    max-width: 35rem;
  }

  .md\\:max-w-152{
    max-width: 38rem;
  }

  .md\\:max-w-160{
    max-width: 40rem;
  }

  .md\\:max-w-162{
    max-width: 41rem;
  }

  .md\\:max-w-192{
    max-width: 48rem;
  }

  .md\\:max-w-208{
    max-width: 52rem;
  }

  .md\\:max-w-224{
    max-width: 56rem;
  }

  .md\\:max-w-256{
    max-width: 64rem;
  }

  .md\\:max-w-none{
    max-width: none;
  }

  .md\\:max-w-xs{
    max-width: 20rem;
  }

  .md\\:max-w-sm{
    max-width: 24rem;
  }

  .md\\:max-w-md{
    max-width: 28rem;
  }

  .md\\:max-w-lg{
    max-width: 32rem;
  }

  .md\\:max-w-xl{
    max-width: 36rem;
  }

  .md\\:max-w-2xl{
    max-width: 42rem;
  }

  .md\\:max-w-3xl{
    max-width: 48rem;
  }

  .md\\:max-w-4xl{
    max-width: 56rem;
  }

  .md\\:max-w-5xl{
    max-width: 64rem;
  }

  .md\\:max-w-6xl{
    max-width: 76rem;
  }

  .md\\:max-w-7xl{
    max-width: 92rem;
  }

  .md\\:max-w-8xl{
    max-width: 112rem;
  }

  .md\\:max-w-9xl{
    max-width: 130rem;
  }

  .md\\:max-w-full{
    max-width: 100%;
  }

  .md\\:max-w-px{
    max-width: 1px;
  }

  .md\\:min-h-0{
    min-height: 0;
  }

  .md\\:min-h-1{
    min-height: 0.25rem;
  }

  .md\\:min-h-2{
    min-height: 0.5rem;
  }

  .md\\:min-h-3{
    min-height: 0.75rem;
  }

  .md\\:min-h-4{
    min-height: 1rem;
  }

  .md\\:min-h-5{
    min-height: 1.25rem;
  }

  .md\\:min-h-6{
    min-height: 1.5rem;
  }

  .md\\:min-h-7{
    min-height: 1.75rem;
  }

  .md\\:min-h-8{
    min-height: 2rem;
  }

  .md\\:min-h-9{
    min-height: 2.25rem;
  }

  .md\\:min-h-10{
    min-height: 2.5rem;
  }

  .md\\:min-h-11{
    min-height: 2.75rem;
  }

  .md\\:min-h-12{
    min-height: 3rem;
  }

  .md\\:min-h-14{
    min-height: 3.5rem;
  }

  .md\\:min-h-15{
    min-height: 3.75rem;
  }

  .md\\:min-h-16{
    min-height: 4rem;
  }

  .md\\:min-h-18{
    min-height: 4.5rem;
  }

  .md\\:min-h-20{
    min-height: 5rem;
  }

  .md\\:min-h-22{
    min-height: 5.5rem;
  }

  .md\\:min-h-23{
    min-height: 5.75rem;
  }

  .md\\:min-h-24{
    min-height: 6rem;
  }

  .md\\:min-h-25{
    min-height: 6.25rem;
  }

  .md\\:min-h-26{
    min-height: 6.5rem;
  }

  .md\\:min-h-28{
    min-height: 7rem;
  }

  .md\\:min-h-30{
    min-height: 7.5rem;
  }

  .md\\:min-h-32{
    min-height: 8rem;
  }

  .md\\:min-h-34{
    min-height: 8.5rem;
  }

  .md\\:min-h-40{
    min-height: 10rem;
  }

  .md\\:min-h-42{
    min-height: 10.5rem;
  }

  .md\\:min-h-44{
    min-height: 11rem;
  }

  .md\\:min-h-48{
    min-height: 12rem;
  }

  .md\\:min-h-52{
    min-height: 13rem;
  }

  .md\\:min-h-54{
    min-height: 13.5rem;
  }

  .md\\:min-h-56{
    min-height: 14rem;
  }

  .md\\:min-h-60{
    min-height: 15rem;
  }

  .md\\:min-h-64{
    min-height: 16rem;
  }

  .md\\:min-h-68{
    min-height: 17rem;
  }

  .md\\:min-h-72{
    min-height: 18rem;
  }

  .md\\:min-h-74{
    min-height: 18.5rem;
  }

  .md\\:min-h-76{
    min-height: 19rem;
  }

  .md\\:min-h-78{
    min-height: 19.5rem;
  }

  .md\\:min-h-80{
    min-height: 20rem;
  }

  .md\\:min-h-82{
    min-height: 20.5rem;
  }

  .md\\:min-h-84{
    min-height: 21rem;
  }

  .md\\:min-h-88{
    min-height: 22rem;
  }

  .md\\:min-h-92{
    min-height: 23rem;
  }

  .md\\:min-h-96{
    min-height: 24rem;
  }

  .md\\:min-h-98{
    min-height: 24.5rem;
  }

  .md\\:min-h-100{
    min-height: 25rem;
  }

  .md\\:min-h-104{
    min-height: 26rem;
  }

  .md\\:min-h-112{
    min-height: 28rem;
  }

  .md\\:min-h-124{
    min-height: 31rem;
  }

  .md\\:min-h-128{
    min-height: 32rem;
  }

  .md\\:min-h-140{
    min-height: 35rem;
  }

  .md\\:min-h-152{
    min-height: 38rem;
  }

  .md\\:min-h-160{
    min-height: 40rem;
  }

  .md\\:min-h-162{
    min-height: 41rem;
  }

  .md\\:min-h-192{
    min-height: 48rem;
  }

  .md\\:min-h-208{
    min-height: 52rem;
  }

  .md\\:min-h-224{
    min-height: 56rem;
  }

  .md\\:min-h-256{
    min-height: 64rem;
  }

  .md\\:min-h-full{
    min-height: 100%;
  }

  .md\\:min-h-px{
    min-height: 1px;
  }

  .md\\:min-h-screen{
    min-height: 100vh;
  }

  .md\\:min-w-0{
    min-width: 0;
  }

  .md\\:min-w-1{
    min-width: 0.25rem;
  }

  .md\\:min-w-2{
    min-width: 0.5rem;
  }

  .md\\:min-w-3{
    min-width: 0.75rem;
  }

  .md\\:min-w-4{
    min-width: 1rem;
  }

  .md\\:min-w-5{
    min-width: 1.25rem;
  }

  .md\\:min-w-6{
    min-width: 1.5rem;
  }

  .md\\:min-w-7{
    min-width: 1.75rem;
  }

  .md\\:min-w-8{
    min-width: 2rem;
  }

  .md\\:min-w-9{
    min-width: 2.25rem;
  }

  .md\\:min-w-10{
    min-width: 2.5rem;
  }

  .md\\:min-w-11{
    min-width: 2.75rem;
  }

  .md\\:min-w-12{
    min-width: 3rem;
  }

  .md\\:min-w-14{
    min-width: 3.5rem;
  }

  .md\\:min-w-15{
    min-width: 3.75rem;
  }

  .md\\:min-w-16{
    min-width: 4rem;
  }

  .md\\:min-w-18{
    min-width: 4.5rem;
  }

  .md\\:min-w-20{
    min-width: 5rem;
  }

  .md\\:min-w-22{
    min-width: 5.5rem;
  }

  .md\\:min-w-23{
    min-width: 5.75rem;
  }

  .md\\:min-w-24{
    min-width: 6rem;
  }

  .md\\:min-w-25{
    min-width: 6.25rem;
  }

  .md\\:min-w-26{
    min-width: 6.5rem;
  }

  .md\\:min-w-28{
    min-width: 7rem;
  }

  .md\\:min-w-30{
    min-width: 7.5rem;
  }

  .md\\:min-w-32{
    min-width: 8rem;
  }

  .md\\:min-w-34{
    min-width: 8.5rem;
  }

  .md\\:min-w-40{
    min-width: 10rem;
  }

  .md\\:min-w-42{
    min-width: 10.5rem;
  }

  .md\\:min-w-44{
    min-width: 11rem;
  }

  .md\\:min-w-48{
    min-width: 12rem;
  }

  .md\\:min-w-52{
    min-width: 13rem;
  }

  .md\\:min-w-54{
    min-width: 13.5rem;
  }

  .md\\:min-w-56{
    min-width: 14rem;
  }

  .md\\:min-w-60{
    min-width: 15rem;
  }

  .md\\:min-w-64{
    min-width: 16rem;
  }

  .md\\:min-w-68{
    min-width: 17rem;
  }

  .md\\:min-w-72{
    min-width: 18rem;
  }

  .md\\:min-w-74{
    min-width: 18.5rem;
  }

  .md\\:min-w-76{
    min-width: 19rem;
  }

  .md\\:min-w-78{
    min-width: 19.5rem;
  }

  .md\\:min-w-80{
    min-width: 20rem;
  }

  .md\\:min-w-82{
    min-width: 20.5rem;
  }

  .md\\:min-w-84{
    min-width: 21rem;
  }

  .md\\:min-w-88{
    min-width: 22rem;
  }

  .md\\:min-w-92{
    min-width: 23rem;
  }

  .md\\:min-w-96{
    min-width: 24rem;
  }

  .md\\:min-w-98{
    min-width: 24.5rem;
  }

  .md\\:min-w-100{
    min-width: 25rem;
  }

  .md\\:min-w-104{
    min-width: 26rem;
  }

  .md\\:min-w-112{
    min-width: 28rem;
  }

  .md\\:min-w-124{
    min-width: 31rem;
  }

  .md\\:min-w-128{
    min-width: 32rem;
  }

  .md\\:min-w-140{
    min-width: 35rem;
  }

  .md\\:min-w-152{
    min-width: 38rem;
  }

  .md\\:min-w-160{
    min-width: 40rem;
  }

  .md\\:min-w-162{
    min-width: 41rem;
  }

  .md\\:min-w-192{
    min-width: 48rem;
  }

  .md\\:min-w-208{
    min-width: 52rem;
  }

  .md\\:min-w-224{
    min-width: 56rem;
  }

  .md\\:min-w-256{
    min-width: 64rem;
  }

  .md\\:min-w-px{
    min-width: 1px;
  }

  .md\\:min-w-full{
    min-width: 100%;
  }

  .md\\:object-contain{
    object-fit: contain;
  }

  .md\\:object-cover{
    object-fit: cover;
  }

  .md\\:object-fill{
    object-fit: fill;
  }

  .md\\:object-none{
    object-fit: none;
  }

  .md\\:object-scale-down{
    object-fit: scale-down;
  }

  .md\\:object-bottom{
    object-position: bottom;
  }

  .md\\:object-center{
    object-position: center;
  }

  .md\\:object-left{
    object-position: left;
  }

  .md\\:object-left-bottom{
    object-position: left bottom;
  }

  .md\\:object-left-top{
    object-position: left top;
  }

  .md\\:object-right{
    object-position: right;
  }

  .md\\:object-right-bottom{
    object-position: right bottom;
  }

  .md\\:object-right-top{
    object-position: right top;
  }

  .md\\:object-top{
    object-position: top;
  }

  .md\\:opacity-0{
    opacity: 0;
  }

  .md\\:opacity-25{
    opacity: .25;
  }

  .md\\:opacity-50{
    opacity: .5;
  }

  .md\\:opacity-75{
    opacity: .75;
  }

  .md\\:opacity-100{
    opacity: 1;
  }

  .md\\:overflow-auto{
    overflow: auto;
  }

  .md\\:overflow-hidden{
    overflow: hidden;
  }

  .md\\:overflow-visible{
    overflow: visible;
  }

  .md\\:overflow-scroll{
    overflow: scroll;
  }

  .md\\:overflow-x-auto{
    overflow-x: auto;
  }

  .md\\:overflow-y-auto{
    overflow-y: auto;
  }

  .md\\:overflow-x-hidden{
    overflow-x: hidden;
  }

  .md\\:overflow-y-hidden{
    overflow-y: hidden;
  }

  .md\\:overflow-x-visible{
    overflow-x: visible;
  }

  .md\\:overflow-y-visible{
    overflow-y: visible;
  }

  .md\\:overflow-x-scroll{
    overflow-x: scroll;
  }

  .md\\:overflow-y-scroll{
    overflow-y: scroll;
  }

  .md\\:scrolling-touch{
    -webkit-overflow-scrolling: touch;
  }

  .md\\:scrolling-auto{
    -webkit-overflow-scrolling: auto;
  }

  .md\\:overscroll-auto{
    overscroll-behavior: auto;
  }

  .md\\:overscroll-contain{
    overscroll-behavior: contain;
  }

  .md\\:overscroll-none{
    overscroll-behavior: none;
  }

  .md\\:overscroll-y-auto{
    overscroll-behavior-y: auto;
  }

  .md\\:overscroll-y-contain{
    overscroll-behavior-y: contain;
  }

  .md\\:overscroll-y-none{
    overscroll-behavior-y: none;
  }

  .md\\:overscroll-x-auto{
    overscroll-behavior-x: auto;
  }

  .md\\:overscroll-x-contain{
    overscroll-behavior-x: contain;
  }

  .md\\:overscroll-x-none{
    overscroll-behavior-x: none;
  }

  .md\\:p-0{
    padding: 0;
  }

  .md\\:p-1{
    padding: 0.25rem;
  }

  .md\\:p-2{
    padding: 0.5rem;
  }

  .md\\:p-3{
    padding: 0.75rem;
  }

  .md\\:p-4{
    padding: 1rem;
  }

  .md\\:p-5{
    padding: 1.25rem;
  }

  .md\\:p-6{
    padding: 1.5rem;
  }

  .md\\:p-7{
    padding: 1.75rem;
  }

  .md\\:p-8{
    padding: 2rem;
  }

  .md\\:p-9{
    padding: 2.25rem;
  }

  .md\\:p-10{
    padding: 2.5rem;
  }

  .md\\:p-11{
    padding: 2.75rem;
  }

  .md\\:p-12{
    padding: 3rem;
  }

  .md\\:p-14{
    padding: 3.5rem;
  }

  .md\\:p-15{
    padding: 3.75rem;
  }

  .md\\:p-16{
    padding: 4rem;
  }

  .md\\:p-18{
    padding: 4.5rem;
  }

  .md\\:p-20{
    padding: 5rem;
  }

  .md\\:p-22{
    padding: 5.5rem;
  }

  .md\\:p-23{
    padding: 5.75rem;
  }

  .md\\:p-24{
    padding: 6rem;
  }

  .md\\:p-25{
    padding: 6.25rem;
  }

  .md\\:p-26{
    padding: 6.5rem;
  }

  .md\\:p-28{
    padding: 7rem;
  }

  .md\\:p-30{
    padding: 7.5rem;
  }

  .md\\:p-32{
    padding: 8rem;
  }

  .md\\:p-34{
    padding: 8.5rem;
  }

  .md\\:p-40{
    padding: 10rem;
  }

  .md\\:p-42{
    padding: 10.5rem;
  }

  .md\\:p-44{
    padding: 11rem;
  }

  .md\\:p-48{
    padding: 12rem;
  }

  .md\\:p-52{
    padding: 13rem;
  }

  .md\\:p-54{
    padding: 13.5rem;
  }

  .md\\:p-56{
    padding: 14rem;
  }

  .md\\:p-60{
    padding: 15rem;
  }

  .md\\:p-64{
    padding: 16rem;
  }

  .md\\:p-68{
    padding: 17rem;
  }

  .md\\:p-72{
    padding: 18rem;
  }

  .md\\:p-74{
    padding: 18.5rem;
  }

  .md\\:p-76{
    padding: 19rem;
  }

  .md\\:p-78{
    padding: 19.5rem;
  }

  .md\\:p-80{
    padding: 20rem;
  }

  .md\\:p-82{
    padding: 20.5rem;
  }

  .md\\:p-84{
    padding: 21rem;
  }

  .md\\:p-88{
    padding: 22rem;
  }

  .md\\:p-92{
    padding: 23rem;
  }

  .md\\:p-96{
    padding: 24rem;
  }

  .md\\:p-98{
    padding: 24.5rem;
  }

  .md\\:p-100{
    padding: 25rem;
  }

  .md\\:p-104{
    padding: 26rem;
  }

  .md\\:p-112{
    padding: 28rem;
  }

  .md\\:p-124{
    padding: 31rem;
  }

  .md\\:p-128{
    padding: 32rem;
  }

  .md\\:p-140{
    padding: 35rem;
  }

  .md\\:p-152{
    padding: 38rem;
  }

  .md\\:p-160{
    padding: 40rem;
  }

  .md\\:p-162{
    padding: 41rem;
  }

  .md\\:p-192{
    padding: 48rem;
  }

  .md\\:p-208{
    padding: 52rem;
  }

  .md\\:p-224{
    padding: 56rem;
  }

  .md\\:p-256{
    padding: 64rem;
  }

  .md\\:p-px{
    padding: 1px;
  }

  .md\\:py-0{
    padding-top: 0;
    padding-bottom: 0;
  }

  .md\\:px-0{
    padding-left: 0;
    padding-right: 0;
  }

  .md\\:py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .md\\:px-1{
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .md\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .md\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .md\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .md\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .md\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:py-7{
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .md\\:px-7{
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .md\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:py-9{
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .md\\:px-9{
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .md\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .md\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:py-11{
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .md\\:px-11{
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .md\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:py-14{
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .md\\:px-14{
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .md\\:py-15{
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .md\\:px-15{
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .md\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .md\\:px-16{
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .md\\:py-18{
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .md\\:px-18{
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .md\\:py-20{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .md\\:px-20{
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .md\\:py-22{
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .md\\:px-22{
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .md\\:py-23{
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .md\\:px-23{
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .md\\:py-24{
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .md\\:px-24{
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .md\\:py-25{
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .md\\:px-25{
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .md\\:py-26{
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .md\\:px-26{
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .md\\:py-28{
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .md\\:px-28{
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .md\\:py-30{
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .md\\:px-30{
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .md\\:py-32{
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .md\\:px-32{
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .md\\:py-34{
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .md\\:px-34{
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .md\\:py-40{
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .md\\:px-40{
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .md\\:py-42{
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .md\\:px-42{
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .md\\:py-44{
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .md\\:px-44{
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .md\\:py-48{
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .md\\:px-48{
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .md\\:py-52{
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .md\\:px-52{
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .md\\:py-54{
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .md\\:px-54{
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .md\\:py-56{
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .md\\:px-56{
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .md\\:py-60{
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .md\\:px-60{
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .md\\:py-64{
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .md\\:px-64{
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .md\\:py-68{
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .md\\:px-68{
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .md\\:py-72{
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .md\\:px-72{
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .md\\:py-74{
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .md\\:px-74{
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .md\\:py-76{
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .md\\:px-76{
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .md\\:py-78{
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .md\\:px-78{
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .md\\:py-80{
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .md\\:px-80{
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .md\\:py-82{
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .md\\:px-82{
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .md\\:py-84{
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .md\\:px-84{
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .md\\:py-88{
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .md\\:px-88{
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .md\\:py-92{
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .md\\:px-92{
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .md\\:py-96{
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .md\\:px-96{
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .md\\:py-98{
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .md\\:px-98{
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .md\\:py-100{
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .md\\:px-100{
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .md\\:py-104{
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .md\\:px-104{
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .md\\:py-112{
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .md\\:px-112{
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .md\\:py-124{
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .md\\:px-124{
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .md\\:py-128{
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .md\\:px-128{
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .md\\:py-140{
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .md\\:px-140{
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .md\\:py-152{
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .md\\:px-152{
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .md\\:py-160{
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .md\\:px-160{
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .md\\:py-162{
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .md\\:px-162{
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .md\\:py-192{
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .md\\:px-192{
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .md\\:py-208{
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .md\\:px-208{
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .md\\:py-224{
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .md\\:px-224{
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .md\\:py-256{
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .md\\:px-256{
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .md\\:py-px{
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .md\\:px-px{
    padding-left: 1px;
    padding-right: 1px;
  }

  .md\\:pt-0{
    padding-top: 0;
  }

  .md\\:pr-0{
    padding-right: 0;
  }

  .md\\:pb-0{
    padding-bottom: 0;
  }

  .md\\:pl-0{
    padding-left: 0;
  }

  .md\\:pt-1{
    padding-top: 0.25rem;
  }

  .md\\:pr-1{
    padding-right: 0.25rem;
  }

  .md\\:pb-1{
    padding-bottom: 0.25rem;
  }

  .md\\:pl-1{
    padding-left: 0.25rem;
  }

  .md\\:pt-2{
    padding-top: 0.5rem;
  }

  .md\\:pr-2{
    padding-right: 0.5rem;
  }

  .md\\:pb-2{
    padding-bottom: 0.5rem;
  }

  .md\\:pl-2{
    padding-left: 0.5rem;
  }

  .md\\:pt-3{
    padding-top: 0.75rem;
  }

  .md\\:pr-3{
    padding-right: 0.75rem;
  }

  .md\\:pb-3{
    padding-bottom: 0.75rem;
  }

  .md\\:pl-3{
    padding-left: 0.75rem;
  }

  .md\\:pt-4{
    padding-top: 1rem;
  }

  .md\\:pr-4{
    padding-right: 1rem;
  }

  .md\\:pb-4{
    padding-bottom: 1rem;
  }

  .md\\:pl-4{
    padding-left: 1rem;
  }

  .md\\:pt-5{
    padding-top: 1.25rem;
  }

  .md\\:pr-5{
    padding-right: 1.25rem;
  }

  .md\\:pb-5{
    padding-bottom: 1.25rem;
  }

  .md\\:pl-5{
    padding-left: 1.25rem;
  }

  .md\\:pt-6{
    padding-top: 1.5rem;
  }

  .md\\:pr-6{
    padding-right: 1.5rem;
  }

  .md\\:pb-6{
    padding-bottom: 1.5rem;
  }

  .md\\:pl-6{
    padding-left: 1.5rem;
  }

  .md\\:pt-7{
    padding-top: 1.75rem;
  }

  .md\\:pr-7{
    padding-right: 1.75rem;
  }

  .md\\:pb-7{
    padding-bottom: 1.75rem;
  }

  .md\\:pl-7{
    padding-left: 1.75rem;
  }

  .md\\:pt-8{
    padding-top: 2rem;
  }

  .md\\:pr-8{
    padding-right: 2rem;
  }

  .md\\:pb-8{
    padding-bottom: 2rem;
  }

  .md\\:pl-8{
    padding-left: 2rem;
  }

  .md\\:pt-9{
    padding-top: 2.25rem;
  }

  .md\\:pr-9{
    padding-right: 2.25rem;
  }

  .md\\:pb-9{
    padding-bottom: 2.25rem;
  }

  .md\\:pl-9{
    padding-left: 2.25rem;
  }

  .md\\:pt-10{
    padding-top: 2.5rem;
  }

  .md\\:pr-10{
    padding-right: 2.5rem;
  }

  .md\\:pb-10{
    padding-bottom: 2.5rem;
  }

  .md\\:pl-10{
    padding-left: 2.5rem;
  }

  .md\\:pt-11{
    padding-top: 2.75rem;
  }

  .md\\:pr-11{
    padding-right: 2.75rem;
  }

  .md\\:pb-11{
    padding-bottom: 2.75rem;
  }

  .md\\:pl-11{
    padding-left: 2.75rem;
  }

  .md\\:pt-12{
    padding-top: 3rem;
  }

  .md\\:pr-12{
    padding-right: 3rem;
  }

  .md\\:pb-12{
    padding-bottom: 3rem;
  }

  .md\\:pl-12{
    padding-left: 3rem;
  }

  .md\\:pt-14{
    padding-top: 3.5rem;
  }

  .md\\:pr-14{
    padding-right: 3.5rem;
  }

  .md\\:pb-14{
    padding-bottom: 3.5rem;
  }

  .md\\:pl-14{
    padding-left: 3.5rem;
  }

  .md\\:pt-15{
    padding-top: 3.75rem;
  }

  .md\\:pr-15{
    padding-right: 3.75rem;
  }

  .md\\:pb-15{
    padding-bottom: 3.75rem;
  }

  .md\\:pl-15{
    padding-left: 3.75rem;
  }

  .md\\:pt-16{
    padding-top: 4rem;
  }

  .md\\:pr-16{
    padding-right: 4rem;
  }

  .md\\:pb-16{
    padding-bottom: 4rem;
  }

  .md\\:pl-16{
    padding-left: 4rem;
  }

  .md\\:pt-18{
    padding-top: 4.5rem;
  }

  .md\\:pr-18{
    padding-right: 4.5rem;
  }

  .md\\:pb-18{
    padding-bottom: 4.5rem;
  }

  .md\\:pl-18{
    padding-left: 4.5rem;
  }

  .md\\:pt-20{
    padding-top: 5rem;
  }

  .md\\:pr-20{
    padding-right: 5rem;
  }

  .md\\:pb-20{
    padding-bottom: 5rem;
  }

  .md\\:pl-20{
    padding-left: 5rem;
  }

  .md\\:pt-22{
    padding-top: 5.5rem;
  }

  .md\\:pr-22{
    padding-right: 5.5rem;
  }

  .md\\:pb-22{
    padding-bottom: 5.5rem;
  }

  .md\\:pl-22{
    padding-left: 5.5rem;
  }

  .md\\:pt-23{
    padding-top: 5.75rem;
  }

  .md\\:pr-23{
    padding-right: 5.75rem;
  }

  .md\\:pb-23{
    padding-bottom: 5.75rem;
  }

  .md\\:pl-23{
    padding-left: 5.75rem;
  }

  .md\\:pt-24{
    padding-top: 6rem;
  }

  .md\\:pr-24{
    padding-right: 6rem;
  }

  .md\\:pb-24{
    padding-bottom: 6rem;
  }

  .md\\:pl-24{
    padding-left: 6rem;
  }

  .md\\:pt-25{
    padding-top: 6.25rem;
  }

  .md\\:pr-25{
    padding-right: 6.25rem;
  }

  .md\\:pb-25{
    padding-bottom: 6.25rem;
  }

  .md\\:pl-25{
    padding-left: 6.25rem;
  }

  .md\\:pt-26{
    padding-top: 6.5rem;
  }

  .md\\:pr-26{
    padding-right: 6.5rem;
  }

  .md\\:pb-26{
    padding-bottom: 6.5rem;
  }

  .md\\:pl-26{
    padding-left: 6.5rem;
  }

  .md\\:pt-28{
    padding-top: 7rem;
  }

  .md\\:pr-28{
    padding-right: 7rem;
  }

  .md\\:pb-28{
    padding-bottom: 7rem;
  }

  .md\\:pl-28{
    padding-left: 7rem;
  }

  .md\\:pt-30{
    padding-top: 7.5rem;
  }

  .md\\:pr-30{
    padding-right: 7.5rem;
  }

  .md\\:pb-30{
    padding-bottom: 7.5rem;
  }

  .md\\:pl-30{
    padding-left: 7.5rem;
  }

  .md\\:pt-32{
    padding-top: 8rem;
  }

  .md\\:pr-32{
    padding-right: 8rem;
  }

  .md\\:pb-32{
    padding-bottom: 8rem;
  }

  .md\\:pl-32{
    padding-left: 8rem;
  }

  .md\\:pt-34{
    padding-top: 8.5rem;
  }

  .md\\:pr-34{
    padding-right: 8.5rem;
  }

  .md\\:pb-34{
    padding-bottom: 8.5rem;
  }

  .md\\:pl-34{
    padding-left: 8.5rem;
  }

  .md\\:pt-40{
    padding-top: 10rem;
  }

  .md\\:pr-40{
    padding-right: 10rem;
  }

  .md\\:pb-40{
    padding-bottom: 10rem;
  }

  .md\\:pl-40{
    padding-left: 10rem;
  }

  .md\\:pt-42{
    padding-top: 10.5rem;
  }

  .md\\:pr-42{
    padding-right: 10.5rem;
  }

  .md\\:pb-42{
    padding-bottom: 10.5rem;
  }

  .md\\:pl-42{
    padding-left: 10.5rem;
  }

  .md\\:pt-44{
    padding-top: 11rem;
  }

  .md\\:pr-44{
    padding-right: 11rem;
  }

  .md\\:pb-44{
    padding-bottom: 11rem;
  }

  .md\\:pl-44{
    padding-left: 11rem;
  }

  .md\\:pt-48{
    padding-top: 12rem;
  }

  .md\\:pr-48{
    padding-right: 12rem;
  }

  .md\\:pb-48{
    padding-bottom: 12rem;
  }

  .md\\:pl-48{
    padding-left: 12rem;
  }

  .md\\:pt-52{
    padding-top: 13rem;
  }

  .md\\:pr-52{
    padding-right: 13rem;
  }

  .md\\:pb-52{
    padding-bottom: 13rem;
  }

  .md\\:pl-52{
    padding-left: 13rem;
  }

  .md\\:pt-54{
    padding-top: 13.5rem;
  }

  .md\\:pr-54{
    padding-right: 13.5rem;
  }

  .md\\:pb-54{
    padding-bottom: 13.5rem;
  }

  .md\\:pl-54{
    padding-left: 13.5rem;
  }

  .md\\:pt-56{
    padding-top: 14rem;
  }

  .md\\:pr-56{
    padding-right: 14rem;
  }

  .md\\:pb-56{
    padding-bottom: 14rem;
  }

  .md\\:pl-56{
    padding-left: 14rem;
  }

  .md\\:pt-60{
    padding-top: 15rem;
  }

  .md\\:pr-60{
    padding-right: 15rem;
  }

  .md\\:pb-60{
    padding-bottom: 15rem;
  }

  .md\\:pl-60{
    padding-left: 15rem;
  }

  .md\\:pt-64{
    padding-top: 16rem;
  }

  .md\\:pr-64{
    padding-right: 16rem;
  }

  .md\\:pb-64{
    padding-bottom: 16rem;
  }

  .md\\:pl-64{
    padding-left: 16rem;
  }

  .md\\:pt-68{
    padding-top: 17rem;
  }

  .md\\:pr-68{
    padding-right: 17rem;
  }

  .md\\:pb-68{
    padding-bottom: 17rem;
  }

  .md\\:pl-68{
    padding-left: 17rem;
  }

  .md\\:pt-72{
    padding-top: 18rem;
  }

  .md\\:pr-72{
    padding-right: 18rem;
  }

  .md\\:pb-72{
    padding-bottom: 18rem;
  }

  .md\\:pl-72{
    padding-left: 18rem;
  }

  .md\\:pt-74{
    padding-top: 18.5rem;
  }

  .md\\:pr-74{
    padding-right: 18.5rem;
  }

  .md\\:pb-74{
    padding-bottom: 18.5rem;
  }

  .md\\:pl-74{
    padding-left: 18.5rem;
  }

  .md\\:pt-76{
    padding-top: 19rem;
  }

  .md\\:pr-76{
    padding-right: 19rem;
  }

  .md\\:pb-76{
    padding-bottom: 19rem;
  }

  .md\\:pl-76{
    padding-left: 19rem;
  }

  .md\\:pt-78{
    padding-top: 19.5rem;
  }

  .md\\:pr-78{
    padding-right: 19.5rem;
  }

  .md\\:pb-78{
    padding-bottom: 19.5rem;
  }

  .md\\:pl-78{
    padding-left: 19.5rem;
  }

  .md\\:pt-80{
    padding-top: 20rem;
  }

  .md\\:pr-80{
    padding-right: 20rem;
  }

  .md\\:pb-80{
    padding-bottom: 20rem;
  }

  .md\\:pl-80{
    padding-left: 20rem;
  }

  .md\\:pt-82{
    padding-top: 20.5rem;
  }

  .md\\:pr-82{
    padding-right: 20.5rem;
  }

  .md\\:pb-82{
    padding-bottom: 20.5rem;
  }

  .md\\:pl-82{
    padding-left: 20.5rem;
  }

  .md\\:pt-84{
    padding-top: 21rem;
  }

  .md\\:pr-84{
    padding-right: 21rem;
  }

  .md\\:pb-84{
    padding-bottom: 21rem;
  }

  .md\\:pl-84{
    padding-left: 21rem;
  }

  .md\\:pt-88{
    padding-top: 22rem;
  }

  .md\\:pr-88{
    padding-right: 22rem;
  }

  .md\\:pb-88{
    padding-bottom: 22rem;
  }

  .md\\:pl-88{
    padding-left: 22rem;
  }

  .md\\:pt-92{
    padding-top: 23rem;
  }

  .md\\:pr-92{
    padding-right: 23rem;
  }

  .md\\:pb-92{
    padding-bottom: 23rem;
  }

  .md\\:pl-92{
    padding-left: 23rem;
  }

  .md\\:pt-96{
    padding-top: 24rem;
  }

  .md\\:pr-96{
    padding-right: 24rem;
  }

  .md\\:pb-96{
    padding-bottom: 24rem;
  }

  .md\\:pl-96{
    padding-left: 24rem;
  }

  .md\\:pt-98{
    padding-top: 24.5rem;
  }

  .md\\:pr-98{
    padding-right: 24.5rem;
  }

  .md\\:pb-98{
    padding-bottom: 24.5rem;
  }

  .md\\:pl-98{
    padding-left: 24.5rem;
  }

  .md\\:pt-100{
    padding-top: 25rem;
  }

  .md\\:pr-100{
    padding-right: 25rem;
  }

  .md\\:pb-100{
    padding-bottom: 25rem;
  }

  .md\\:pl-100{
    padding-left: 25rem;
  }

  .md\\:pt-104{
    padding-top: 26rem;
  }

  .md\\:pr-104{
    padding-right: 26rem;
  }

  .md\\:pb-104{
    padding-bottom: 26rem;
  }

  .md\\:pl-104{
    padding-left: 26rem;
  }

  .md\\:pt-112{
    padding-top: 28rem;
  }

  .md\\:pr-112{
    padding-right: 28rem;
  }

  .md\\:pb-112{
    padding-bottom: 28rem;
  }

  .md\\:pl-112{
    padding-left: 28rem;
  }

  .md\\:pt-124{
    padding-top: 31rem;
  }

  .md\\:pr-124{
    padding-right: 31rem;
  }

  .md\\:pb-124{
    padding-bottom: 31rem;
  }

  .md\\:pl-124{
    padding-left: 31rem;
  }

  .md\\:pt-128{
    padding-top: 32rem;
  }

  .md\\:pr-128{
    padding-right: 32rem;
  }

  .md\\:pb-128{
    padding-bottom: 32rem;
  }

  .md\\:pl-128{
    padding-left: 32rem;
  }

  .md\\:pt-140{
    padding-top: 35rem;
  }

  .md\\:pr-140{
    padding-right: 35rem;
  }

  .md\\:pb-140{
    padding-bottom: 35rem;
  }

  .md\\:pl-140{
    padding-left: 35rem;
  }

  .md\\:pt-152{
    padding-top: 38rem;
  }

  .md\\:pr-152{
    padding-right: 38rem;
  }

  .md\\:pb-152{
    padding-bottom: 38rem;
  }

  .md\\:pl-152{
    padding-left: 38rem;
  }

  .md\\:pt-160{
    padding-top: 40rem;
  }

  .md\\:pr-160{
    padding-right: 40rem;
  }

  .md\\:pb-160{
    padding-bottom: 40rem;
  }

  .md\\:pl-160{
    padding-left: 40rem;
  }

  .md\\:pt-162{
    padding-top: 41rem;
  }

  .md\\:pr-162{
    padding-right: 41rem;
  }

  .md\\:pb-162{
    padding-bottom: 41rem;
  }

  .md\\:pl-162{
    padding-left: 41rem;
  }

  .md\\:pt-192{
    padding-top: 48rem;
  }

  .md\\:pr-192{
    padding-right: 48rem;
  }

  .md\\:pb-192{
    padding-bottom: 48rem;
  }

  .md\\:pl-192{
    padding-left: 48rem;
  }

  .md\\:pt-208{
    padding-top: 52rem;
  }

  .md\\:pr-208{
    padding-right: 52rem;
  }

  .md\\:pb-208{
    padding-bottom: 52rem;
  }

  .md\\:pl-208{
    padding-left: 52rem;
  }

  .md\\:pt-224{
    padding-top: 56rem;
  }

  .md\\:pr-224{
    padding-right: 56rem;
  }

  .md\\:pb-224{
    padding-bottom: 56rem;
  }

  .md\\:pl-224{
    padding-left: 56rem;
  }

  .md\\:pt-256{
    padding-top: 64rem;
  }

  .md\\:pr-256{
    padding-right: 64rem;
  }

  .md\\:pb-256{
    padding-bottom: 64rem;
  }

  .md\\:pl-256{
    padding-left: 64rem;
  }

  .md\\:pt-px{
    padding-top: 1px;
  }

  .md\\:pr-px{
    padding-right: 1px;
  }

  .md\\:pb-px{
    padding-bottom: 1px;
  }

  .md\\:pl-px{
    padding-left: 1px;
  }

  .md\\:odd\\:p-0:nth-child(odd){
    padding: 0;
  }

  .md\\:odd\\:p-1:nth-child(odd){
    padding: 0.25rem;
  }

  .md\\:odd\\:p-2:nth-child(odd){
    padding: 0.5rem;
  }

  .md\\:odd\\:p-3:nth-child(odd){
    padding: 0.75rem;
  }

  .md\\:odd\\:p-4:nth-child(odd){
    padding: 1rem;
  }

  .md\\:odd\\:p-5:nth-child(odd){
    padding: 1.25rem;
  }

  .md\\:odd\\:p-6:nth-child(odd){
    padding: 1.5rem;
  }

  .md\\:odd\\:p-7:nth-child(odd){
    padding: 1.75rem;
  }

  .md\\:odd\\:p-8:nth-child(odd){
    padding: 2rem;
  }

  .md\\:odd\\:p-9:nth-child(odd){
    padding: 2.25rem;
  }

  .md\\:odd\\:p-10:nth-child(odd){
    padding: 2.5rem;
  }

  .md\\:odd\\:p-11:nth-child(odd){
    padding: 2.75rem;
  }

  .md\\:odd\\:p-12:nth-child(odd){
    padding: 3rem;
  }

  .md\\:odd\\:p-14:nth-child(odd){
    padding: 3.5rem;
  }

  .md\\:odd\\:p-15:nth-child(odd){
    padding: 3.75rem;
  }

  .md\\:odd\\:p-16:nth-child(odd){
    padding: 4rem;
  }

  .md\\:odd\\:p-18:nth-child(odd){
    padding: 4.5rem;
  }

  .md\\:odd\\:p-20:nth-child(odd){
    padding: 5rem;
  }

  .md\\:odd\\:p-22:nth-child(odd){
    padding: 5.5rem;
  }

  .md\\:odd\\:p-23:nth-child(odd){
    padding: 5.75rem;
  }

  .md\\:odd\\:p-24:nth-child(odd){
    padding: 6rem;
  }

  .md\\:odd\\:p-25:nth-child(odd){
    padding: 6.25rem;
  }

  .md\\:odd\\:p-26:nth-child(odd){
    padding: 6.5rem;
  }

  .md\\:odd\\:p-28:nth-child(odd){
    padding: 7rem;
  }

  .md\\:odd\\:p-30:nth-child(odd){
    padding: 7.5rem;
  }

  .md\\:odd\\:p-32:nth-child(odd){
    padding: 8rem;
  }

  .md\\:odd\\:p-34:nth-child(odd){
    padding: 8.5rem;
  }

  .md\\:odd\\:p-40:nth-child(odd){
    padding: 10rem;
  }

  .md\\:odd\\:p-42:nth-child(odd){
    padding: 10.5rem;
  }

  .md\\:odd\\:p-44:nth-child(odd){
    padding: 11rem;
  }

  .md\\:odd\\:p-48:nth-child(odd){
    padding: 12rem;
  }

  .md\\:odd\\:p-52:nth-child(odd){
    padding: 13rem;
  }

  .md\\:odd\\:p-54:nth-child(odd){
    padding: 13.5rem;
  }

  .md\\:odd\\:p-56:nth-child(odd){
    padding: 14rem;
  }

  .md\\:odd\\:p-60:nth-child(odd){
    padding: 15rem;
  }

  .md\\:odd\\:p-64:nth-child(odd){
    padding: 16rem;
  }

  .md\\:odd\\:p-68:nth-child(odd){
    padding: 17rem;
  }

  .md\\:odd\\:p-72:nth-child(odd){
    padding: 18rem;
  }

  .md\\:odd\\:p-74:nth-child(odd){
    padding: 18.5rem;
  }

  .md\\:odd\\:p-76:nth-child(odd){
    padding: 19rem;
  }

  .md\\:odd\\:p-78:nth-child(odd){
    padding: 19.5rem;
  }

  .md\\:odd\\:p-80:nth-child(odd){
    padding: 20rem;
  }

  .md\\:odd\\:p-82:nth-child(odd){
    padding: 20.5rem;
  }

  .md\\:odd\\:p-84:nth-child(odd){
    padding: 21rem;
  }

  .md\\:odd\\:p-88:nth-child(odd){
    padding: 22rem;
  }

  .md\\:odd\\:p-92:nth-child(odd){
    padding: 23rem;
  }

  .md\\:odd\\:p-96:nth-child(odd){
    padding: 24rem;
  }

  .md\\:odd\\:p-98:nth-child(odd){
    padding: 24.5rem;
  }

  .md\\:odd\\:p-100:nth-child(odd){
    padding: 25rem;
  }

  .md\\:odd\\:p-104:nth-child(odd){
    padding: 26rem;
  }

  .md\\:odd\\:p-112:nth-child(odd){
    padding: 28rem;
  }

  .md\\:odd\\:p-124:nth-child(odd){
    padding: 31rem;
  }

  .md\\:odd\\:p-128:nth-child(odd){
    padding: 32rem;
  }

  .md\\:odd\\:p-140:nth-child(odd){
    padding: 35rem;
  }

  .md\\:odd\\:p-152:nth-child(odd){
    padding: 38rem;
  }

  .md\\:odd\\:p-160:nth-child(odd){
    padding: 40rem;
  }

  .md\\:odd\\:p-162:nth-child(odd){
    padding: 41rem;
  }

  .md\\:odd\\:p-192:nth-child(odd){
    padding: 48rem;
  }

  .md\\:odd\\:p-208:nth-child(odd){
    padding: 52rem;
  }

  .md\\:odd\\:p-224:nth-child(odd){
    padding: 56rem;
  }

  .md\\:odd\\:p-256:nth-child(odd){
    padding: 64rem;
  }

  .md\\:odd\\:p-px:nth-child(odd){
    padding: 1px;
  }

  .md\\:odd\\:py-0:nth-child(odd){
    padding-top: 0;
    padding-bottom: 0;
  }

  .md\\:odd\\:px-0:nth-child(odd){
    padding-left: 0;
    padding-right: 0;
  }

  .md\\:odd\\:py-1:nth-child(odd){
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .md\\:odd\\:px-1:nth-child(odd){
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .md\\:odd\\:py-2:nth-child(odd){
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:odd\\:px-2:nth-child(odd){
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .md\\:odd\\:py-3:nth-child(odd){
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .md\\:odd\\:px-3:nth-child(odd){
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .md\\:odd\\:py-4:nth-child(odd){
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .md\\:odd\\:px-4:nth-child(odd){
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:odd\\:py-5:nth-child(odd){
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:odd\\:px-5:nth-child(odd){
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:odd\\:py-6:nth-child(odd){
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:odd\\:px-6:nth-child(odd){
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:odd\\:py-7:nth-child(odd){
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .md\\:odd\\:px-7:nth-child(odd){
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .md\\:odd\\:py-8:nth-child(odd){
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:odd\\:px-8:nth-child(odd){
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:odd\\:py-9:nth-child(odd){
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .md\\:odd\\:px-9:nth-child(odd){
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .md\\:odd\\:py-10:nth-child(odd){
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .md\\:odd\\:px-10:nth-child(odd){
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:odd\\:py-11:nth-child(odd){
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .md\\:odd\\:px-11:nth-child(odd){
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .md\\:odd\\:py-12:nth-child(odd){
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:odd\\:px-12:nth-child(odd){
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:odd\\:py-14:nth-child(odd){
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .md\\:odd\\:px-14:nth-child(odd){
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .md\\:odd\\:py-15:nth-child(odd){
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .md\\:odd\\:px-15:nth-child(odd){
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .md\\:odd\\:py-16:nth-child(odd){
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .md\\:odd\\:px-16:nth-child(odd){
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .md\\:odd\\:py-18:nth-child(odd){
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .md\\:odd\\:px-18:nth-child(odd){
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .md\\:odd\\:py-20:nth-child(odd){
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .md\\:odd\\:px-20:nth-child(odd){
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .md\\:odd\\:py-22:nth-child(odd){
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .md\\:odd\\:px-22:nth-child(odd){
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .md\\:odd\\:py-23:nth-child(odd){
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .md\\:odd\\:px-23:nth-child(odd){
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .md\\:odd\\:py-24:nth-child(odd){
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .md\\:odd\\:px-24:nth-child(odd){
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .md\\:odd\\:py-25:nth-child(odd){
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .md\\:odd\\:px-25:nth-child(odd){
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .md\\:odd\\:py-26:nth-child(odd){
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .md\\:odd\\:px-26:nth-child(odd){
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .md\\:odd\\:py-28:nth-child(odd){
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .md\\:odd\\:px-28:nth-child(odd){
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .md\\:odd\\:py-30:nth-child(odd){
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .md\\:odd\\:px-30:nth-child(odd){
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .md\\:odd\\:py-32:nth-child(odd){
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .md\\:odd\\:px-32:nth-child(odd){
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .md\\:odd\\:py-34:nth-child(odd){
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .md\\:odd\\:px-34:nth-child(odd){
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .md\\:odd\\:py-40:nth-child(odd){
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .md\\:odd\\:px-40:nth-child(odd){
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .md\\:odd\\:py-42:nth-child(odd){
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .md\\:odd\\:px-42:nth-child(odd){
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .md\\:odd\\:py-44:nth-child(odd){
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .md\\:odd\\:px-44:nth-child(odd){
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .md\\:odd\\:py-48:nth-child(odd){
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .md\\:odd\\:px-48:nth-child(odd){
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .md\\:odd\\:py-52:nth-child(odd){
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .md\\:odd\\:px-52:nth-child(odd){
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .md\\:odd\\:py-54:nth-child(odd){
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .md\\:odd\\:px-54:nth-child(odd){
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .md\\:odd\\:py-56:nth-child(odd){
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .md\\:odd\\:px-56:nth-child(odd){
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .md\\:odd\\:py-60:nth-child(odd){
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .md\\:odd\\:px-60:nth-child(odd){
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .md\\:odd\\:py-64:nth-child(odd){
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .md\\:odd\\:px-64:nth-child(odd){
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .md\\:odd\\:py-68:nth-child(odd){
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .md\\:odd\\:px-68:nth-child(odd){
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .md\\:odd\\:py-72:nth-child(odd){
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .md\\:odd\\:px-72:nth-child(odd){
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .md\\:odd\\:py-74:nth-child(odd){
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .md\\:odd\\:px-74:nth-child(odd){
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .md\\:odd\\:py-76:nth-child(odd){
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .md\\:odd\\:px-76:nth-child(odd){
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .md\\:odd\\:py-78:nth-child(odd){
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .md\\:odd\\:px-78:nth-child(odd){
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .md\\:odd\\:py-80:nth-child(odd){
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .md\\:odd\\:px-80:nth-child(odd){
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .md\\:odd\\:py-82:nth-child(odd){
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .md\\:odd\\:px-82:nth-child(odd){
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .md\\:odd\\:py-84:nth-child(odd){
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .md\\:odd\\:px-84:nth-child(odd){
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .md\\:odd\\:py-88:nth-child(odd){
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .md\\:odd\\:px-88:nth-child(odd){
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .md\\:odd\\:py-92:nth-child(odd){
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .md\\:odd\\:px-92:nth-child(odd){
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .md\\:odd\\:py-96:nth-child(odd){
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .md\\:odd\\:px-96:nth-child(odd){
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .md\\:odd\\:py-98:nth-child(odd){
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .md\\:odd\\:px-98:nth-child(odd){
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .md\\:odd\\:py-100:nth-child(odd){
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .md\\:odd\\:px-100:nth-child(odd){
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .md\\:odd\\:py-104:nth-child(odd){
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .md\\:odd\\:px-104:nth-child(odd){
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .md\\:odd\\:py-112:nth-child(odd){
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .md\\:odd\\:px-112:nth-child(odd){
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .md\\:odd\\:py-124:nth-child(odd){
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .md\\:odd\\:px-124:nth-child(odd){
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .md\\:odd\\:py-128:nth-child(odd){
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .md\\:odd\\:px-128:nth-child(odd){
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .md\\:odd\\:py-140:nth-child(odd){
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .md\\:odd\\:px-140:nth-child(odd){
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .md\\:odd\\:py-152:nth-child(odd){
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .md\\:odd\\:px-152:nth-child(odd){
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .md\\:odd\\:py-160:nth-child(odd){
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .md\\:odd\\:px-160:nth-child(odd){
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .md\\:odd\\:py-162:nth-child(odd){
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .md\\:odd\\:px-162:nth-child(odd){
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .md\\:odd\\:py-192:nth-child(odd){
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .md\\:odd\\:px-192:nth-child(odd){
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .md\\:odd\\:py-208:nth-child(odd){
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .md\\:odd\\:px-208:nth-child(odd){
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .md\\:odd\\:py-224:nth-child(odd){
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .md\\:odd\\:px-224:nth-child(odd){
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .md\\:odd\\:py-256:nth-child(odd){
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .md\\:odd\\:px-256:nth-child(odd){
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .md\\:odd\\:py-px:nth-child(odd){
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .md\\:odd\\:px-px:nth-child(odd){
    padding-left: 1px;
    padding-right: 1px;
  }

  .md\\:odd\\:pt-0:nth-child(odd){
    padding-top: 0;
  }

  .md\\:odd\\:pr-0:nth-child(odd){
    padding-right: 0;
  }

  .md\\:odd\\:pb-0:nth-child(odd){
    padding-bottom: 0;
  }

  .md\\:odd\\:pl-0:nth-child(odd){
    padding-left: 0;
  }

  .md\\:odd\\:pt-1:nth-child(odd){
    padding-top: 0.25rem;
  }

  .md\\:odd\\:pr-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  .md\\:odd\\:pb-1:nth-child(odd){
    padding-bottom: 0.25rem;
  }

  .md\\:odd\\:pl-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  .md\\:odd\\:pt-2:nth-child(odd){
    padding-top: 0.5rem;
  }

  .md\\:odd\\:pr-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  .md\\:odd\\:pb-2:nth-child(odd){
    padding-bottom: 0.5rem;
  }

  .md\\:odd\\:pl-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  .md\\:odd\\:pt-3:nth-child(odd){
    padding-top: 0.75rem;
  }

  .md\\:odd\\:pr-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  .md\\:odd\\:pb-3:nth-child(odd){
    padding-bottom: 0.75rem;
  }

  .md\\:odd\\:pl-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  .md\\:odd\\:pt-4:nth-child(odd){
    padding-top: 1rem;
  }

  .md\\:odd\\:pr-4:nth-child(odd){
    padding-right: 1rem;
  }

  .md\\:odd\\:pb-4:nth-child(odd){
    padding-bottom: 1rem;
  }

  .md\\:odd\\:pl-4:nth-child(odd){
    padding-left: 1rem;
  }

  .md\\:odd\\:pt-5:nth-child(odd){
    padding-top: 1.25rem;
  }

  .md\\:odd\\:pr-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  .md\\:odd\\:pb-5:nth-child(odd){
    padding-bottom: 1.25rem;
  }

  .md\\:odd\\:pl-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  .md\\:odd\\:pt-6:nth-child(odd){
    padding-top: 1.5rem;
  }

  .md\\:odd\\:pr-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  .md\\:odd\\:pb-6:nth-child(odd){
    padding-bottom: 1.5rem;
  }

  .md\\:odd\\:pl-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  .md\\:odd\\:pt-7:nth-child(odd){
    padding-top: 1.75rem;
  }

  .md\\:odd\\:pr-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  .md\\:odd\\:pb-7:nth-child(odd){
    padding-bottom: 1.75rem;
  }

  .md\\:odd\\:pl-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  .md\\:odd\\:pt-8:nth-child(odd){
    padding-top: 2rem;
  }

  .md\\:odd\\:pr-8:nth-child(odd){
    padding-right: 2rem;
  }

  .md\\:odd\\:pb-8:nth-child(odd){
    padding-bottom: 2rem;
  }

  .md\\:odd\\:pl-8:nth-child(odd){
    padding-left: 2rem;
  }

  .md\\:odd\\:pt-9:nth-child(odd){
    padding-top: 2.25rem;
  }

  .md\\:odd\\:pr-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  .md\\:odd\\:pb-9:nth-child(odd){
    padding-bottom: 2.25rem;
  }

  .md\\:odd\\:pl-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  .md\\:odd\\:pt-10:nth-child(odd){
    padding-top: 2.5rem;
  }

  .md\\:odd\\:pr-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  .md\\:odd\\:pb-10:nth-child(odd){
    padding-bottom: 2.5rem;
  }

  .md\\:odd\\:pl-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  .md\\:odd\\:pt-11:nth-child(odd){
    padding-top: 2.75rem;
  }

  .md\\:odd\\:pr-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  .md\\:odd\\:pb-11:nth-child(odd){
    padding-bottom: 2.75rem;
  }

  .md\\:odd\\:pl-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  .md\\:odd\\:pt-12:nth-child(odd){
    padding-top: 3rem;
  }

  .md\\:odd\\:pr-12:nth-child(odd){
    padding-right: 3rem;
  }

  .md\\:odd\\:pb-12:nth-child(odd){
    padding-bottom: 3rem;
  }

  .md\\:odd\\:pl-12:nth-child(odd){
    padding-left: 3rem;
  }

  .md\\:odd\\:pt-14:nth-child(odd){
    padding-top: 3.5rem;
  }

  .md\\:odd\\:pr-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  .md\\:odd\\:pb-14:nth-child(odd){
    padding-bottom: 3.5rem;
  }

  .md\\:odd\\:pl-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  .md\\:odd\\:pt-15:nth-child(odd){
    padding-top: 3.75rem;
  }

  .md\\:odd\\:pr-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  .md\\:odd\\:pb-15:nth-child(odd){
    padding-bottom: 3.75rem;
  }

  .md\\:odd\\:pl-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  .md\\:odd\\:pt-16:nth-child(odd){
    padding-top: 4rem;
  }

  .md\\:odd\\:pr-16:nth-child(odd){
    padding-right: 4rem;
  }

  .md\\:odd\\:pb-16:nth-child(odd){
    padding-bottom: 4rem;
  }

  .md\\:odd\\:pl-16:nth-child(odd){
    padding-left: 4rem;
  }

  .md\\:odd\\:pt-18:nth-child(odd){
    padding-top: 4.5rem;
  }

  .md\\:odd\\:pr-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  .md\\:odd\\:pb-18:nth-child(odd){
    padding-bottom: 4.5rem;
  }

  .md\\:odd\\:pl-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  .md\\:odd\\:pt-20:nth-child(odd){
    padding-top: 5rem;
  }

  .md\\:odd\\:pr-20:nth-child(odd){
    padding-right: 5rem;
  }

  .md\\:odd\\:pb-20:nth-child(odd){
    padding-bottom: 5rem;
  }

  .md\\:odd\\:pl-20:nth-child(odd){
    padding-left: 5rem;
  }

  .md\\:odd\\:pt-22:nth-child(odd){
    padding-top: 5.5rem;
  }

  .md\\:odd\\:pr-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  .md\\:odd\\:pb-22:nth-child(odd){
    padding-bottom: 5.5rem;
  }

  .md\\:odd\\:pl-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  .md\\:odd\\:pt-23:nth-child(odd){
    padding-top: 5.75rem;
  }

  .md\\:odd\\:pr-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  .md\\:odd\\:pb-23:nth-child(odd){
    padding-bottom: 5.75rem;
  }

  .md\\:odd\\:pl-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  .md\\:odd\\:pt-24:nth-child(odd){
    padding-top: 6rem;
  }

  .md\\:odd\\:pr-24:nth-child(odd){
    padding-right: 6rem;
  }

  .md\\:odd\\:pb-24:nth-child(odd){
    padding-bottom: 6rem;
  }

  .md\\:odd\\:pl-24:nth-child(odd){
    padding-left: 6rem;
  }

  .md\\:odd\\:pt-25:nth-child(odd){
    padding-top: 6.25rem;
  }

  .md\\:odd\\:pr-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  .md\\:odd\\:pb-25:nth-child(odd){
    padding-bottom: 6.25rem;
  }

  .md\\:odd\\:pl-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  .md\\:odd\\:pt-26:nth-child(odd){
    padding-top: 6.5rem;
  }

  .md\\:odd\\:pr-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  .md\\:odd\\:pb-26:nth-child(odd){
    padding-bottom: 6.5rem;
  }

  .md\\:odd\\:pl-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  .md\\:odd\\:pt-28:nth-child(odd){
    padding-top: 7rem;
  }

  .md\\:odd\\:pr-28:nth-child(odd){
    padding-right: 7rem;
  }

  .md\\:odd\\:pb-28:nth-child(odd){
    padding-bottom: 7rem;
  }

  .md\\:odd\\:pl-28:nth-child(odd){
    padding-left: 7rem;
  }

  .md\\:odd\\:pt-30:nth-child(odd){
    padding-top: 7.5rem;
  }

  .md\\:odd\\:pr-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  .md\\:odd\\:pb-30:nth-child(odd){
    padding-bottom: 7.5rem;
  }

  .md\\:odd\\:pl-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  .md\\:odd\\:pt-32:nth-child(odd){
    padding-top: 8rem;
  }

  .md\\:odd\\:pr-32:nth-child(odd){
    padding-right: 8rem;
  }

  .md\\:odd\\:pb-32:nth-child(odd){
    padding-bottom: 8rem;
  }

  .md\\:odd\\:pl-32:nth-child(odd){
    padding-left: 8rem;
  }

  .md\\:odd\\:pt-34:nth-child(odd){
    padding-top: 8.5rem;
  }

  .md\\:odd\\:pr-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  .md\\:odd\\:pb-34:nth-child(odd){
    padding-bottom: 8.5rem;
  }

  .md\\:odd\\:pl-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  .md\\:odd\\:pt-40:nth-child(odd){
    padding-top: 10rem;
  }

  .md\\:odd\\:pr-40:nth-child(odd){
    padding-right: 10rem;
  }

  .md\\:odd\\:pb-40:nth-child(odd){
    padding-bottom: 10rem;
  }

  .md\\:odd\\:pl-40:nth-child(odd){
    padding-left: 10rem;
  }

  .md\\:odd\\:pt-42:nth-child(odd){
    padding-top: 10.5rem;
  }

  .md\\:odd\\:pr-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  .md\\:odd\\:pb-42:nth-child(odd){
    padding-bottom: 10.5rem;
  }

  .md\\:odd\\:pl-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  .md\\:odd\\:pt-44:nth-child(odd){
    padding-top: 11rem;
  }

  .md\\:odd\\:pr-44:nth-child(odd){
    padding-right: 11rem;
  }

  .md\\:odd\\:pb-44:nth-child(odd){
    padding-bottom: 11rem;
  }

  .md\\:odd\\:pl-44:nth-child(odd){
    padding-left: 11rem;
  }

  .md\\:odd\\:pt-48:nth-child(odd){
    padding-top: 12rem;
  }

  .md\\:odd\\:pr-48:nth-child(odd){
    padding-right: 12rem;
  }

  .md\\:odd\\:pb-48:nth-child(odd){
    padding-bottom: 12rem;
  }

  .md\\:odd\\:pl-48:nth-child(odd){
    padding-left: 12rem;
  }

  .md\\:odd\\:pt-52:nth-child(odd){
    padding-top: 13rem;
  }

  .md\\:odd\\:pr-52:nth-child(odd){
    padding-right: 13rem;
  }

  .md\\:odd\\:pb-52:nth-child(odd){
    padding-bottom: 13rem;
  }

  .md\\:odd\\:pl-52:nth-child(odd){
    padding-left: 13rem;
  }

  .md\\:odd\\:pt-54:nth-child(odd){
    padding-top: 13.5rem;
  }

  .md\\:odd\\:pr-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  .md\\:odd\\:pb-54:nth-child(odd){
    padding-bottom: 13.5rem;
  }

  .md\\:odd\\:pl-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  .md\\:odd\\:pt-56:nth-child(odd){
    padding-top: 14rem;
  }

  .md\\:odd\\:pr-56:nth-child(odd){
    padding-right: 14rem;
  }

  .md\\:odd\\:pb-56:nth-child(odd){
    padding-bottom: 14rem;
  }

  .md\\:odd\\:pl-56:nth-child(odd){
    padding-left: 14rem;
  }

  .md\\:odd\\:pt-60:nth-child(odd){
    padding-top: 15rem;
  }

  .md\\:odd\\:pr-60:nth-child(odd){
    padding-right: 15rem;
  }

  .md\\:odd\\:pb-60:nth-child(odd){
    padding-bottom: 15rem;
  }

  .md\\:odd\\:pl-60:nth-child(odd){
    padding-left: 15rem;
  }

  .md\\:odd\\:pt-64:nth-child(odd){
    padding-top: 16rem;
  }

  .md\\:odd\\:pr-64:nth-child(odd){
    padding-right: 16rem;
  }

  .md\\:odd\\:pb-64:nth-child(odd){
    padding-bottom: 16rem;
  }

  .md\\:odd\\:pl-64:nth-child(odd){
    padding-left: 16rem;
  }

  .md\\:odd\\:pt-68:nth-child(odd){
    padding-top: 17rem;
  }

  .md\\:odd\\:pr-68:nth-child(odd){
    padding-right: 17rem;
  }

  .md\\:odd\\:pb-68:nth-child(odd){
    padding-bottom: 17rem;
  }

  .md\\:odd\\:pl-68:nth-child(odd){
    padding-left: 17rem;
  }

  .md\\:odd\\:pt-72:nth-child(odd){
    padding-top: 18rem;
  }

  .md\\:odd\\:pr-72:nth-child(odd){
    padding-right: 18rem;
  }

  .md\\:odd\\:pb-72:nth-child(odd){
    padding-bottom: 18rem;
  }

  .md\\:odd\\:pl-72:nth-child(odd){
    padding-left: 18rem;
  }

  .md\\:odd\\:pt-74:nth-child(odd){
    padding-top: 18.5rem;
  }

  .md\\:odd\\:pr-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  .md\\:odd\\:pb-74:nth-child(odd){
    padding-bottom: 18.5rem;
  }

  .md\\:odd\\:pl-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  .md\\:odd\\:pt-76:nth-child(odd){
    padding-top: 19rem;
  }

  .md\\:odd\\:pr-76:nth-child(odd){
    padding-right: 19rem;
  }

  .md\\:odd\\:pb-76:nth-child(odd){
    padding-bottom: 19rem;
  }

  .md\\:odd\\:pl-76:nth-child(odd){
    padding-left: 19rem;
  }

  .md\\:odd\\:pt-78:nth-child(odd){
    padding-top: 19.5rem;
  }

  .md\\:odd\\:pr-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  .md\\:odd\\:pb-78:nth-child(odd){
    padding-bottom: 19.5rem;
  }

  .md\\:odd\\:pl-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  .md\\:odd\\:pt-80:nth-child(odd){
    padding-top: 20rem;
  }

  .md\\:odd\\:pr-80:nth-child(odd){
    padding-right: 20rem;
  }

  .md\\:odd\\:pb-80:nth-child(odd){
    padding-bottom: 20rem;
  }

  .md\\:odd\\:pl-80:nth-child(odd){
    padding-left: 20rem;
  }

  .md\\:odd\\:pt-82:nth-child(odd){
    padding-top: 20.5rem;
  }

  .md\\:odd\\:pr-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  .md\\:odd\\:pb-82:nth-child(odd){
    padding-bottom: 20.5rem;
  }

  .md\\:odd\\:pl-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  .md\\:odd\\:pt-84:nth-child(odd){
    padding-top: 21rem;
  }

  .md\\:odd\\:pr-84:nth-child(odd){
    padding-right: 21rem;
  }

  .md\\:odd\\:pb-84:nth-child(odd){
    padding-bottom: 21rem;
  }

  .md\\:odd\\:pl-84:nth-child(odd){
    padding-left: 21rem;
  }

  .md\\:odd\\:pt-88:nth-child(odd){
    padding-top: 22rem;
  }

  .md\\:odd\\:pr-88:nth-child(odd){
    padding-right: 22rem;
  }

  .md\\:odd\\:pb-88:nth-child(odd){
    padding-bottom: 22rem;
  }

  .md\\:odd\\:pl-88:nth-child(odd){
    padding-left: 22rem;
  }

  .md\\:odd\\:pt-92:nth-child(odd){
    padding-top: 23rem;
  }

  .md\\:odd\\:pr-92:nth-child(odd){
    padding-right: 23rem;
  }

  .md\\:odd\\:pb-92:nth-child(odd){
    padding-bottom: 23rem;
  }

  .md\\:odd\\:pl-92:nth-child(odd){
    padding-left: 23rem;
  }

  .md\\:odd\\:pt-96:nth-child(odd){
    padding-top: 24rem;
  }

  .md\\:odd\\:pr-96:nth-child(odd){
    padding-right: 24rem;
  }

  .md\\:odd\\:pb-96:nth-child(odd){
    padding-bottom: 24rem;
  }

  .md\\:odd\\:pl-96:nth-child(odd){
    padding-left: 24rem;
  }

  .md\\:odd\\:pt-98:nth-child(odd){
    padding-top: 24.5rem;
  }

  .md\\:odd\\:pr-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  .md\\:odd\\:pb-98:nth-child(odd){
    padding-bottom: 24.5rem;
  }

  .md\\:odd\\:pl-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  .md\\:odd\\:pt-100:nth-child(odd){
    padding-top: 25rem;
  }

  .md\\:odd\\:pr-100:nth-child(odd){
    padding-right: 25rem;
  }

  .md\\:odd\\:pb-100:nth-child(odd){
    padding-bottom: 25rem;
  }

  .md\\:odd\\:pl-100:nth-child(odd){
    padding-left: 25rem;
  }

  .md\\:odd\\:pt-104:nth-child(odd){
    padding-top: 26rem;
  }

  .md\\:odd\\:pr-104:nth-child(odd){
    padding-right: 26rem;
  }

  .md\\:odd\\:pb-104:nth-child(odd){
    padding-bottom: 26rem;
  }

  .md\\:odd\\:pl-104:nth-child(odd){
    padding-left: 26rem;
  }

  .md\\:odd\\:pt-112:nth-child(odd){
    padding-top: 28rem;
  }

  .md\\:odd\\:pr-112:nth-child(odd){
    padding-right: 28rem;
  }

  .md\\:odd\\:pb-112:nth-child(odd){
    padding-bottom: 28rem;
  }

  .md\\:odd\\:pl-112:nth-child(odd){
    padding-left: 28rem;
  }

  .md\\:odd\\:pt-124:nth-child(odd){
    padding-top: 31rem;
  }

  .md\\:odd\\:pr-124:nth-child(odd){
    padding-right: 31rem;
  }

  .md\\:odd\\:pb-124:nth-child(odd){
    padding-bottom: 31rem;
  }

  .md\\:odd\\:pl-124:nth-child(odd){
    padding-left: 31rem;
  }

  .md\\:odd\\:pt-128:nth-child(odd){
    padding-top: 32rem;
  }

  .md\\:odd\\:pr-128:nth-child(odd){
    padding-right: 32rem;
  }

  .md\\:odd\\:pb-128:nth-child(odd){
    padding-bottom: 32rem;
  }

  .md\\:odd\\:pl-128:nth-child(odd){
    padding-left: 32rem;
  }

  .md\\:odd\\:pt-140:nth-child(odd){
    padding-top: 35rem;
  }

  .md\\:odd\\:pr-140:nth-child(odd){
    padding-right: 35rem;
  }

  .md\\:odd\\:pb-140:nth-child(odd){
    padding-bottom: 35rem;
  }

  .md\\:odd\\:pl-140:nth-child(odd){
    padding-left: 35rem;
  }

  .md\\:odd\\:pt-152:nth-child(odd){
    padding-top: 38rem;
  }

  .md\\:odd\\:pr-152:nth-child(odd){
    padding-right: 38rem;
  }

  .md\\:odd\\:pb-152:nth-child(odd){
    padding-bottom: 38rem;
  }

  .md\\:odd\\:pl-152:nth-child(odd){
    padding-left: 38rem;
  }

  .md\\:odd\\:pt-160:nth-child(odd){
    padding-top: 40rem;
  }

  .md\\:odd\\:pr-160:nth-child(odd){
    padding-right: 40rem;
  }

  .md\\:odd\\:pb-160:nth-child(odd){
    padding-bottom: 40rem;
  }

  .md\\:odd\\:pl-160:nth-child(odd){
    padding-left: 40rem;
  }

  .md\\:odd\\:pt-162:nth-child(odd){
    padding-top: 41rem;
  }

  .md\\:odd\\:pr-162:nth-child(odd){
    padding-right: 41rem;
  }

  .md\\:odd\\:pb-162:nth-child(odd){
    padding-bottom: 41rem;
  }

  .md\\:odd\\:pl-162:nth-child(odd){
    padding-left: 41rem;
  }

  .md\\:odd\\:pt-192:nth-child(odd){
    padding-top: 48rem;
  }

  .md\\:odd\\:pr-192:nth-child(odd){
    padding-right: 48rem;
  }

  .md\\:odd\\:pb-192:nth-child(odd){
    padding-bottom: 48rem;
  }

  .md\\:odd\\:pl-192:nth-child(odd){
    padding-left: 48rem;
  }

  .md\\:odd\\:pt-208:nth-child(odd){
    padding-top: 52rem;
  }

  .md\\:odd\\:pr-208:nth-child(odd){
    padding-right: 52rem;
  }

  .md\\:odd\\:pb-208:nth-child(odd){
    padding-bottom: 52rem;
  }

  .md\\:odd\\:pl-208:nth-child(odd){
    padding-left: 52rem;
  }

  .md\\:odd\\:pt-224:nth-child(odd){
    padding-top: 56rem;
  }

  .md\\:odd\\:pr-224:nth-child(odd){
    padding-right: 56rem;
  }

  .md\\:odd\\:pb-224:nth-child(odd){
    padding-bottom: 56rem;
  }

  .md\\:odd\\:pl-224:nth-child(odd){
    padding-left: 56rem;
  }

  .md\\:odd\\:pt-256:nth-child(odd){
    padding-top: 64rem;
  }

  .md\\:odd\\:pr-256:nth-child(odd){
    padding-right: 64rem;
  }

  .md\\:odd\\:pb-256:nth-child(odd){
    padding-bottom: 64rem;
  }

  .md\\:odd\\:pl-256:nth-child(odd){
    padding-left: 64rem;
  }

  .md\\:odd\\:pt-px:nth-child(odd){
    padding-top: 1px;
  }

  .md\\:odd\\:pr-px:nth-child(odd){
    padding-right: 1px;
  }

  .md\\:odd\\:pb-px:nth-child(odd){
    padding-bottom: 1px;
  }

  .md\\:odd\\:pl-px:nth-child(odd){
    padding-left: 1px;
  }

  .md\\:even\\:p-0:nth-child(even){
    padding: 0;
  }

  .md\\:even\\:p-1:nth-child(even){
    padding: 0.25rem;
  }

  .md\\:even\\:p-2:nth-child(even){
    padding: 0.5rem;
  }

  .md\\:even\\:p-3:nth-child(even){
    padding: 0.75rem;
  }

  .md\\:even\\:p-4:nth-child(even){
    padding: 1rem;
  }

  .md\\:even\\:p-5:nth-child(even){
    padding: 1.25rem;
  }

  .md\\:even\\:p-6:nth-child(even){
    padding: 1.5rem;
  }

  .md\\:even\\:p-7:nth-child(even){
    padding: 1.75rem;
  }

  .md\\:even\\:p-8:nth-child(even){
    padding: 2rem;
  }

  .md\\:even\\:p-9:nth-child(even){
    padding: 2.25rem;
  }

  .md\\:even\\:p-10:nth-child(even){
    padding: 2.5rem;
  }

  .md\\:even\\:p-11:nth-child(even){
    padding: 2.75rem;
  }

  .md\\:even\\:p-12:nth-child(even){
    padding: 3rem;
  }

  .md\\:even\\:p-14:nth-child(even){
    padding: 3.5rem;
  }

  .md\\:even\\:p-15:nth-child(even){
    padding: 3.75rem;
  }

  .md\\:even\\:p-16:nth-child(even){
    padding: 4rem;
  }

  .md\\:even\\:p-18:nth-child(even){
    padding: 4.5rem;
  }

  .md\\:even\\:p-20:nth-child(even){
    padding: 5rem;
  }

  .md\\:even\\:p-22:nth-child(even){
    padding: 5.5rem;
  }

  .md\\:even\\:p-23:nth-child(even){
    padding: 5.75rem;
  }

  .md\\:even\\:p-24:nth-child(even){
    padding: 6rem;
  }

  .md\\:even\\:p-25:nth-child(even){
    padding: 6.25rem;
  }

  .md\\:even\\:p-26:nth-child(even){
    padding: 6.5rem;
  }

  .md\\:even\\:p-28:nth-child(even){
    padding: 7rem;
  }

  .md\\:even\\:p-30:nth-child(even){
    padding: 7.5rem;
  }

  .md\\:even\\:p-32:nth-child(even){
    padding: 8rem;
  }

  .md\\:even\\:p-34:nth-child(even){
    padding: 8.5rem;
  }

  .md\\:even\\:p-40:nth-child(even){
    padding: 10rem;
  }

  .md\\:even\\:p-42:nth-child(even){
    padding: 10.5rem;
  }

  .md\\:even\\:p-44:nth-child(even){
    padding: 11rem;
  }

  .md\\:even\\:p-48:nth-child(even){
    padding: 12rem;
  }

  .md\\:even\\:p-52:nth-child(even){
    padding: 13rem;
  }

  .md\\:even\\:p-54:nth-child(even){
    padding: 13.5rem;
  }

  .md\\:even\\:p-56:nth-child(even){
    padding: 14rem;
  }

  .md\\:even\\:p-60:nth-child(even){
    padding: 15rem;
  }

  .md\\:even\\:p-64:nth-child(even){
    padding: 16rem;
  }

  .md\\:even\\:p-68:nth-child(even){
    padding: 17rem;
  }

  .md\\:even\\:p-72:nth-child(even){
    padding: 18rem;
  }

  .md\\:even\\:p-74:nth-child(even){
    padding: 18.5rem;
  }

  .md\\:even\\:p-76:nth-child(even){
    padding: 19rem;
  }

  .md\\:even\\:p-78:nth-child(even){
    padding: 19.5rem;
  }

  .md\\:even\\:p-80:nth-child(even){
    padding: 20rem;
  }

  .md\\:even\\:p-82:nth-child(even){
    padding: 20.5rem;
  }

  .md\\:even\\:p-84:nth-child(even){
    padding: 21rem;
  }

  .md\\:even\\:p-88:nth-child(even){
    padding: 22rem;
  }

  .md\\:even\\:p-92:nth-child(even){
    padding: 23rem;
  }

  .md\\:even\\:p-96:nth-child(even){
    padding: 24rem;
  }

  .md\\:even\\:p-98:nth-child(even){
    padding: 24.5rem;
  }

  .md\\:even\\:p-100:nth-child(even){
    padding: 25rem;
  }

  .md\\:even\\:p-104:nth-child(even){
    padding: 26rem;
  }

  .md\\:even\\:p-112:nth-child(even){
    padding: 28rem;
  }

  .md\\:even\\:p-124:nth-child(even){
    padding: 31rem;
  }

  .md\\:even\\:p-128:nth-child(even){
    padding: 32rem;
  }

  .md\\:even\\:p-140:nth-child(even){
    padding: 35rem;
  }

  .md\\:even\\:p-152:nth-child(even){
    padding: 38rem;
  }

  .md\\:even\\:p-160:nth-child(even){
    padding: 40rem;
  }

  .md\\:even\\:p-162:nth-child(even){
    padding: 41rem;
  }

  .md\\:even\\:p-192:nth-child(even){
    padding: 48rem;
  }

  .md\\:even\\:p-208:nth-child(even){
    padding: 52rem;
  }

  .md\\:even\\:p-224:nth-child(even){
    padding: 56rem;
  }

  .md\\:even\\:p-256:nth-child(even){
    padding: 64rem;
  }

  .md\\:even\\:p-px:nth-child(even){
    padding: 1px;
  }

  .md\\:even\\:py-0:nth-child(even){
    padding-top: 0;
    padding-bottom: 0;
  }

  .md\\:even\\:px-0:nth-child(even){
    padding-left: 0;
    padding-right: 0;
  }

  .md\\:even\\:py-1:nth-child(even){
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .md\\:even\\:px-1:nth-child(even){
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .md\\:even\\:py-2:nth-child(even){
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .md\\:even\\:px-2:nth-child(even){
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .md\\:even\\:py-3:nth-child(even){
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .md\\:even\\:px-3:nth-child(even){
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .md\\:even\\:py-4:nth-child(even){
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .md\\:even\\:px-4:nth-child(even){
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .md\\:even\\:py-5:nth-child(even){
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .md\\:even\\:px-5:nth-child(even){
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .md\\:even\\:py-6:nth-child(even){
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .md\\:even\\:px-6:nth-child(even){
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .md\\:even\\:py-7:nth-child(even){
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .md\\:even\\:px-7:nth-child(even){
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .md\\:even\\:py-8:nth-child(even){
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .md\\:even\\:px-8:nth-child(even){
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .md\\:even\\:py-9:nth-child(even){
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .md\\:even\\:px-9:nth-child(even){
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .md\\:even\\:py-10:nth-child(even){
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .md\\:even\\:px-10:nth-child(even){
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .md\\:even\\:py-11:nth-child(even){
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .md\\:even\\:px-11:nth-child(even){
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .md\\:even\\:py-12:nth-child(even){
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .md\\:even\\:px-12:nth-child(even){
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .md\\:even\\:py-14:nth-child(even){
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .md\\:even\\:px-14:nth-child(even){
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .md\\:even\\:py-15:nth-child(even){
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .md\\:even\\:px-15:nth-child(even){
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .md\\:even\\:py-16:nth-child(even){
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .md\\:even\\:px-16:nth-child(even){
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .md\\:even\\:py-18:nth-child(even){
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .md\\:even\\:px-18:nth-child(even){
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .md\\:even\\:py-20:nth-child(even){
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .md\\:even\\:px-20:nth-child(even){
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .md\\:even\\:py-22:nth-child(even){
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .md\\:even\\:px-22:nth-child(even){
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .md\\:even\\:py-23:nth-child(even){
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .md\\:even\\:px-23:nth-child(even){
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .md\\:even\\:py-24:nth-child(even){
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .md\\:even\\:px-24:nth-child(even){
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .md\\:even\\:py-25:nth-child(even){
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .md\\:even\\:px-25:nth-child(even){
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .md\\:even\\:py-26:nth-child(even){
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .md\\:even\\:px-26:nth-child(even){
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .md\\:even\\:py-28:nth-child(even){
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .md\\:even\\:px-28:nth-child(even){
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .md\\:even\\:py-30:nth-child(even){
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .md\\:even\\:px-30:nth-child(even){
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .md\\:even\\:py-32:nth-child(even){
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .md\\:even\\:px-32:nth-child(even){
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .md\\:even\\:py-34:nth-child(even){
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .md\\:even\\:px-34:nth-child(even){
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .md\\:even\\:py-40:nth-child(even){
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .md\\:even\\:px-40:nth-child(even){
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .md\\:even\\:py-42:nth-child(even){
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .md\\:even\\:px-42:nth-child(even){
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .md\\:even\\:py-44:nth-child(even){
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .md\\:even\\:px-44:nth-child(even){
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .md\\:even\\:py-48:nth-child(even){
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .md\\:even\\:px-48:nth-child(even){
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .md\\:even\\:py-52:nth-child(even){
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .md\\:even\\:px-52:nth-child(even){
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .md\\:even\\:py-54:nth-child(even){
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .md\\:even\\:px-54:nth-child(even){
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .md\\:even\\:py-56:nth-child(even){
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .md\\:even\\:px-56:nth-child(even){
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .md\\:even\\:py-60:nth-child(even){
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .md\\:even\\:px-60:nth-child(even){
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .md\\:even\\:py-64:nth-child(even){
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .md\\:even\\:px-64:nth-child(even){
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .md\\:even\\:py-68:nth-child(even){
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .md\\:even\\:px-68:nth-child(even){
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .md\\:even\\:py-72:nth-child(even){
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .md\\:even\\:px-72:nth-child(even){
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .md\\:even\\:py-74:nth-child(even){
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .md\\:even\\:px-74:nth-child(even){
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .md\\:even\\:py-76:nth-child(even){
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .md\\:even\\:px-76:nth-child(even){
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .md\\:even\\:py-78:nth-child(even){
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .md\\:even\\:px-78:nth-child(even){
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .md\\:even\\:py-80:nth-child(even){
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .md\\:even\\:px-80:nth-child(even){
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .md\\:even\\:py-82:nth-child(even){
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .md\\:even\\:px-82:nth-child(even){
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .md\\:even\\:py-84:nth-child(even){
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .md\\:even\\:px-84:nth-child(even){
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .md\\:even\\:py-88:nth-child(even){
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .md\\:even\\:px-88:nth-child(even){
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .md\\:even\\:py-92:nth-child(even){
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .md\\:even\\:px-92:nth-child(even){
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .md\\:even\\:py-96:nth-child(even){
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .md\\:even\\:px-96:nth-child(even){
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .md\\:even\\:py-98:nth-child(even){
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .md\\:even\\:px-98:nth-child(even){
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .md\\:even\\:py-100:nth-child(even){
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .md\\:even\\:px-100:nth-child(even){
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .md\\:even\\:py-104:nth-child(even){
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .md\\:even\\:px-104:nth-child(even){
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .md\\:even\\:py-112:nth-child(even){
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .md\\:even\\:px-112:nth-child(even){
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .md\\:even\\:py-124:nth-child(even){
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .md\\:even\\:px-124:nth-child(even){
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .md\\:even\\:py-128:nth-child(even){
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .md\\:even\\:px-128:nth-child(even){
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .md\\:even\\:py-140:nth-child(even){
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .md\\:even\\:px-140:nth-child(even){
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .md\\:even\\:py-152:nth-child(even){
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .md\\:even\\:px-152:nth-child(even){
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .md\\:even\\:py-160:nth-child(even){
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .md\\:even\\:px-160:nth-child(even){
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .md\\:even\\:py-162:nth-child(even){
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .md\\:even\\:px-162:nth-child(even){
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .md\\:even\\:py-192:nth-child(even){
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .md\\:even\\:px-192:nth-child(even){
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .md\\:even\\:py-208:nth-child(even){
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .md\\:even\\:px-208:nth-child(even){
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .md\\:even\\:py-224:nth-child(even){
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .md\\:even\\:px-224:nth-child(even){
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .md\\:even\\:py-256:nth-child(even){
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .md\\:even\\:px-256:nth-child(even){
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .md\\:even\\:py-px:nth-child(even){
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .md\\:even\\:px-px:nth-child(even){
    padding-left: 1px;
    padding-right: 1px;
  }

  .md\\:even\\:pt-0:nth-child(even){
    padding-top: 0;
  }

  .md\\:even\\:pr-0:nth-child(even){
    padding-right: 0;
  }

  .md\\:even\\:pb-0:nth-child(even){
    padding-bottom: 0;
  }

  .md\\:even\\:pl-0:nth-child(even){
    padding-left: 0;
  }

  .md\\:even\\:pt-1:nth-child(even){
    padding-top: 0.25rem;
  }

  .md\\:even\\:pr-1:nth-child(even){
    padding-right: 0.25rem;
  }

  .md\\:even\\:pb-1:nth-child(even){
    padding-bottom: 0.25rem;
  }

  .md\\:even\\:pl-1:nth-child(even){
    padding-left: 0.25rem;
  }

  .md\\:even\\:pt-2:nth-child(even){
    padding-top: 0.5rem;
  }

  .md\\:even\\:pr-2:nth-child(even){
    padding-right: 0.5rem;
  }

  .md\\:even\\:pb-2:nth-child(even){
    padding-bottom: 0.5rem;
  }

  .md\\:even\\:pl-2:nth-child(even){
    padding-left: 0.5rem;
  }

  .md\\:even\\:pt-3:nth-child(even){
    padding-top: 0.75rem;
  }

  .md\\:even\\:pr-3:nth-child(even){
    padding-right: 0.75rem;
  }

  .md\\:even\\:pb-3:nth-child(even){
    padding-bottom: 0.75rem;
  }

  .md\\:even\\:pl-3:nth-child(even){
    padding-left: 0.75rem;
  }

  .md\\:even\\:pt-4:nth-child(even){
    padding-top: 1rem;
  }

  .md\\:even\\:pr-4:nth-child(even){
    padding-right: 1rem;
  }

  .md\\:even\\:pb-4:nth-child(even){
    padding-bottom: 1rem;
  }

  .md\\:even\\:pl-4:nth-child(even){
    padding-left: 1rem;
  }

  .md\\:even\\:pt-5:nth-child(even){
    padding-top: 1.25rem;
  }

  .md\\:even\\:pr-5:nth-child(even){
    padding-right: 1.25rem;
  }

  .md\\:even\\:pb-5:nth-child(even){
    padding-bottom: 1.25rem;
  }

  .md\\:even\\:pl-5:nth-child(even){
    padding-left: 1.25rem;
  }

  .md\\:even\\:pt-6:nth-child(even){
    padding-top: 1.5rem;
  }

  .md\\:even\\:pr-6:nth-child(even){
    padding-right: 1.5rem;
  }

  .md\\:even\\:pb-6:nth-child(even){
    padding-bottom: 1.5rem;
  }

  .md\\:even\\:pl-6:nth-child(even){
    padding-left: 1.5rem;
  }

  .md\\:even\\:pt-7:nth-child(even){
    padding-top: 1.75rem;
  }

  .md\\:even\\:pr-7:nth-child(even){
    padding-right: 1.75rem;
  }

  .md\\:even\\:pb-7:nth-child(even){
    padding-bottom: 1.75rem;
  }

  .md\\:even\\:pl-7:nth-child(even){
    padding-left: 1.75rem;
  }

  .md\\:even\\:pt-8:nth-child(even){
    padding-top: 2rem;
  }

  .md\\:even\\:pr-8:nth-child(even){
    padding-right: 2rem;
  }

  .md\\:even\\:pb-8:nth-child(even){
    padding-bottom: 2rem;
  }

  .md\\:even\\:pl-8:nth-child(even){
    padding-left: 2rem;
  }

  .md\\:even\\:pt-9:nth-child(even){
    padding-top: 2.25rem;
  }

  .md\\:even\\:pr-9:nth-child(even){
    padding-right: 2.25rem;
  }

  .md\\:even\\:pb-9:nth-child(even){
    padding-bottom: 2.25rem;
  }

  .md\\:even\\:pl-9:nth-child(even){
    padding-left: 2.25rem;
  }

  .md\\:even\\:pt-10:nth-child(even){
    padding-top: 2.5rem;
  }

  .md\\:even\\:pr-10:nth-child(even){
    padding-right: 2.5rem;
  }

  .md\\:even\\:pb-10:nth-child(even){
    padding-bottom: 2.5rem;
  }

  .md\\:even\\:pl-10:nth-child(even){
    padding-left: 2.5rem;
  }

  .md\\:even\\:pt-11:nth-child(even){
    padding-top: 2.75rem;
  }

  .md\\:even\\:pr-11:nth-child(even){
    padding-right: 2.75rem;
  }

  .md\\:even\\:pb-11:nth-child(even){
    padding-bottom: 2.75rem;
  }

  .md\\:even\\:pl-11:nth-child(even){
    padding-left: 2.75rem;
  }

  .md\\:even\\:pt-12:nth-child(even){
    padding-top: 3rem;
  }

  .md\\:even\\:pr-12:nth-child(even){
    padding-right: 3rem;
  }

  .md\\:even\\:pb-12:nth-child(even){
    padding-bottom: 3rem;
  }

  .md\\:even\\:pl-12:nth-child(even){
    padding-left: 3rem;
  }

  .md\\:even\\:pt-14:nth-child(even){
    padding-top: 3.5rem;
  }

  .md\\:even\\:pr-14:nth-child(even){
    padding-right: 3.5rem;
  }

  .md\\:even\\:pb-14:nth-child(even){
    padding-bottom: 3.5rem;
  }

  .md\\:even\\:pl-14:nth-child(even){
    padding-left: 3.5rem;
  }

  .md\\:even\\:pt-15:nth-child(even){
    padding-top: 3.75rem;
  }

  .md\\:even\\:pr-15:nth-child(even){
    padding-right: 3.75rem;
  }

  .md\\:even\\:pb-15:nth-child(even){
    padding-bottom: 3.75rem;
  }

  .md\\:even\\:pl-15:nth-child(even){
    padding-left: 3.75rem;
  }

  .md\\:even\\:pt-16:nth-child(even){
    padding-top: 4rem;
  }

  .md\\:even\\:pr-16:nth-child(even){
    padding-right: 4rem;
  }

  .md\\:even\\:pb-16:nth-child(even){
    padding-bottom: 4rem;
  }

  .md\\:even\\:pl-16:nth-child(even){
    padding-left: 4rem;
  }

  .md\\:even\\:pt-18:nth-child(even){
    padding-top: 4.5rem;
  }

  .md\\:even\\:pr-18:nth-child(even){
    padding-right: 4.5rem;
  }

  .md\\:even\\:pb-18:nth-child(even){
    padding-bottom: 4.5rem;
  }

  .md\\:even\\:pl-18:nth-child(even){
    padding-left: 4.5rem;
  }

  .md\\:even\\:pt-20:nth-child(even){
    padding-top: 5rem;
  }

  .md\\:even\\:pr-20:nth-child(even){
    padding-right: 5rem;
  }

  .md\\:even\\:pb-20:nth-child(even){
    padding-bottom: 5rem;
  }

  .md\\:even\\:pl-20:nth-child(even){
    padding-left: 5rem;
  }

  .md\\:even\\:pt-22:nth-child(even){
    padding-top: 5.5rem;
  }

  .md\\:even\\:pr-22:nth-child(even){
    padding-right: 5.5rem;
  }

  .md\\:even\\:pb-22:nth-child(even){
    padding-bottom: 5.5rem;
  }

  .md\\:even\\:pl-22:nth-child(even){
    padding-left: 5.5rem;
  }

  .md\\:even\\:pt-23:nth-child(even){
    padding-top: 5.75rem;
  }

  .md\\:even\\:pr-23:nth-child(even){
    padding-right: 5.75rem;
  }

  .md\\:even\\:pb-23:nth-child(even){
    padding-bottom: 5.75rem;
  }

  .md\\:even\\:pl-23:nth-child(even){
    padding-left: 5.75rem;
  }

  .md\\:even\\:pt-24:nth-child(even){
    padding-top: 6rem;
  }

  .md\\:even\\:pr-24:nth-child(even){
    padding-right: 6rem;
  }

  .md\\:even\\:pb-24:nth-child(even){
    padding-bottom: 6rem;
  }

  .md\\:even\\:pl-24:nth-child(even){
    padding-left: 6rem;
  }

  .md\\:even\\:pt-25:nth-child(even){
    padding-top: 6.25rem;
  }

  .md\\:even\\:pr-25:nth-child(even){
    padding-right: 6.25rem;
  }

  .md\\:even\\:pb-25:nth-child(even){
    padding-bottom: 6.25rem;
  }

  .md\\:even\\:pl-25:nth-child(even){
    padding-left: 6.25rem;
  }

  .md\\:even\\:pt-26:nth-child(even){
    padding-top: 6.5rem;
  }

  .md\\:even\\:pr-26:nth-child(even){
    padding-right: 6.5rem;
  }

  .md\\:even\\:pb-26:nth-child(even){
    padding-bottom: 6.5rem;
  }

  .md\\:even\\:pl-26:nth-child(even){
    padding-left: 6.5rem;
  }

  .md\\:even\\:pt-28:nth-child(even){
    padding-top: 7rem;
  }

  .md\\:even\\:pr-28:nth-child(even){
    padding-right: 7rem;
  }

  .md\\:even\\:pb-28:nth-child(even){
    padding-bottom: 7rem;
  }

  .md\\:even\\:pl-28:nth-child(even){
    padding-left: 7rem;
  }

  .md\\:even\\:pt-30:nth-child(even){
    padding-top: 7.5rem;
  }

  .md\\:even\\:pr-30:nth-child(even){
    padding-right: 7.5rem;
  }

  .md\\:even\\:pb-30:nth-child(even){
    padding-bottom: 7.5rem;
  }

  .md\\:even\\:pl-30:nth-child(even){
    padding-left: 7.5rem;
  }

  .md\\:even\\:pt-32:nth-child(even){
    padding-top: 8rem;
  }

  .md\\:even\\:pr-32:nth-child(even){
    padding-right: 8rem;
  }

  .md\\:even\\:pb-32:nth-child(even){
    padding-bottom: 8rem;
  }

  .md\\:even\\:pl-32:nth-child(even){
    padding-left: 8rem;
  }

  .md\\:even\\:pt-34:nth-child(even){
    padding-top: 8.5rem;
  }

  .md\\:even\\:pr-34:nth-child(even){
    padding-right: 8.5rem;
  }

  .md\\:even\\:pb-34:nth-child(even){
    padding-bottom: 8.5rem;
  }

  .md\\:even\\:pl-34:nth-child(even){
    padding-left: 8.5rem;
  }

  .md\\:even\\:pt-40:nth-child(even){
    padding-top: 10rem;
  }

  .md\\:even\\:pr-40:nth-child(even){
    padding-right: 10rem;
  }

  .md\\:even\\:pb-40:nth-child(even){
    padding-bottom: 10rem;
  }

  .md\\:even\\:pl-40:nth-child(even){
    padding-left: 10rem;
  }

  .md\\:even\\:pt-42:nth-child(even){
    padding-top: 10.5rem;
  }

  .md\\:even\\:pr-42:nth-child(even){
    padding-right: 10.5rem;
  }

  .md\\:even\\:pb-42:nth-child(even){
    padding-bottom: 10.5rem;
  }

  .md\\:even\\:pl-42:nth-child(even){
    padding-left: 10.5rem;
  }

  .md\\:even\\:pt-44:nth-child(even){
    padding-top: 11rem;
  }

  .md\\:even\\:pr-44:nth-child(even){
    padding-right: 11rem;
  }

  .md\\:even\\:pb-44:nth-child(even){
    padding-bottom: 11rem;
  }

  .md\\:even\\:pl-44:nth-child(even){
    padding-left: 11rem;
  }

  .md\\:even\\:pt-48:nth-child(even){
    padding-top: 12rem;
  }

  .md\\:even\\:pr-48:nth-child(even){
    padding-right: 12rem;
  }

  .md\\:even\\:pb-48:nth-child(even){
    padding-bottom: 12rem;
  }

  .md\\:even\\:pl-48:nth-child(even){
    padding-left: 12rem;
  }

  .md\\:even\\:pt-52:nth-child(even){
    padding-top: 13rem;
  }

  .md\\:even\\:pr-52:nth-child(even){
    padding-right: 13rem;
  }

  .md\\:even\\:pb-52:nth-child(even){
    padding-bottom: 13rem;
  }

  .md\\:even\\:pl-52:nth-child(even){
    padding-left: 13rem;
  }

  .md\\:even\\:pt-54:nth-child(even){
    padding-top: 13.5rem;
  }

  .md\\:even\\:pr-54:nth-child(even){
    padding-right: 13.5rem;
  }

  .md\\:even\\:pb-54:nth-child(even){
    padding-bottom: 13.5rem;
  }

  .md\\:even\\:pl-54:nth-child(even){
    padding-left: 13.5rem;
  }

  .md\\:even\\:pt-56:nth-child(even){
    padding-top: 14rem;
  }

  .md\\:even\\:pr-56:nth-child(even){
    padding-right: 14rem;
  }

  .md\\:even\\:pb-56:nth-child(even){
    padding-bottom: 14rem;
  }

  .md\\:even\\:pl-56:nth-child(even){
    padding-left: 14rem;
  }

  .md\\:even\\:pt-60:nth-child(even){
    padding-top: 15rem;
  }

  .md\\:even\\:pr-60:nth-child(even){
    padding-right: 15rem;
  }

  .md\\:even\\:pb-60:nth-child(even){
    padding-bottom: 15rem;
  }

  .md\\:even\\:pl-60:nth-child(even){
    padding-left: 15rem;
  }

  .md\\:even\\:pt-64:nth-child(even){
    padding-top: 16rem;
  }

  .md\\:even\\:pr-64:nth-child(even){
    padding-right: 16rem;
  }

  .md\\:even\\:pb-64:nth-child(even){
    padding-bottom: 16rem;
  }

  .md\\:even\\:pl-64:nth-child(even){
    padding-left: 16rem;
  }

  .md\\:even\\:pt-68:nth-child(even){
    padding-top: 17rem;
  }

  .md\\:even\\:pr-68:nth-child(even){
    padding-right: 17rem;
  }

  .md\\:even\\:pb-68:nth-child(even){
    padding-bottom: 17rem;
  }

  .md\\:even\\:pl-68:nth-child(even){
    padding-left: 17rem;
  }

  .md\\:even\\:pt-72:nth-child(even){
    padding-top: 18rem;
  }

  .md\\:even\\:pr-72:nth-child(even){
    padding-right: 18rem;
  }

  .md\\:even\\:pb-72:nth-child(even){
    padding-bottom: 18rem;
  }

  .md\\:even\\:pl-72:nth-child(even){
    padding-left: 18rem;
  }

  .md\\:even\\:pt-74:nth-child(even){
    padding-top: 18.5rem;
  }

  .md\\:even\\:pr-74:nth-child(even){
    padding-right: 18.5rem;
  }

  .md\\:even\\:pb-74:nth-child(even){
    padding-bottom: 18.5rem;
  }

  .md\\:even\\:pl-74:nth-child(even){
    padding-left: 18.5rem;
  }

  .md\\:even\\:pt-76:nth-child(even){
    padding-top: 19rem;
  }

  .md\\:even\\:pr-76:nth-child(even){
    padding-right: 19rem;
  }

  .md\\:even\\:pb-76:nth-child(even){
    padding-bottom: 19rem;
  }

  .md\\:even\\:pl-76:nth-child(even){
    padding-left: 19rem;
  }

  .md\\:even\\:pt-78:nth-child(even){
    padding-top: 19.5rem;
  }

  .md\\:even\\:pr-78:nth-child(even){
    padding-right: 19.5rem;
  }

  .md\\:even\\:pb-78:nth-child(even){
    padding-bottom: 19.5rem;
  }

  .md\\:even\\:pl-78:nth-child(even){
    padding-left: 19.5rem;
  }

  .md\\:even\\:pt-80:nth-child(even){
    padding-top: 20rem;
  }

  .md\\:even\\:pr-80:nth-child(even){
    padding-right: 20rem;
  }

  .md\\:even\\:pb-80:nth-child(even){
    padding-bottom: 20rem;
  }

  .md\\:even\\:pl-80:nth-child(even){
    padding-left: 20rem;
  }

  .md\\:even\\:pt-82:nth-child(even){
    padding-top: 20.5rem;
  }

  .md\\:even\\:pr-82:nth-child(even){
    padding-right: 20.5rem;
  }

  .md\\:even\\:pb-82:nth-child(even){
    padding-bottom: 20.5rem;
  }

  .md\\:even\\:pl-82:nth-child(even){
    padding-left: 20.5rem;
  }

  .md\\:even\\:pt-84:nth-child(even){
    padding-top: 21rem;
  }

  .md\\:even\\:pr-84:nth-child(even){
    padding-right: 21rem;
  }

  .md\\:even\\:pb-84:nth-child(even){
    padding-bottom: 21rem;
  }

  .md\\:even\\:pl-84:nth-child(even){
    padding-left: 21rem;
  }

  .md\\:even\\:pt-88:nth-child(even){
    padding-top: 22rem;
  }

  .md\\:even\\:pr-88:nth-child(even){
    padding-right: 22rem;
  }

  .md\\:even\\:pb-88:nth-child(even){
    padding-bottom: 22rem;
  }

  .md\\:even\\:pl-88:nth-child(even){
    padding-left: 22rem;
  }

  .md\\:even\\:pt-92:nth-child(even){
    padding-top: 23rem;
  }

  .md\\:even\\:pr-92:nth-child(even){
    padding-right: 23rem;
  }

  .md\\:even\\:pb-92:nth-child(even){
    padding-bottom: 23rem;
  }

  .md\\:even\\:pl-92:nth-child(even){
    padding-left: 23rem;
  }

  .md\\:even\\:pt-96:nth-child(even){
    padding-top: 24rem;
  }

  .md\\:even\\:pr-96:nth-child(even){
    padding-right: 24rem;
  }

  .md\\:even\\:pb-96:nth-child(even){
    padding-bottom: 24rem;
  }

  .md\\:even\\:pl-96:nth-child(even){
    padding-left: 24rem;
  }

  .md\\:even\\:pt-98:nth-child(even){
    padding-top: 24.5rem;
  }

  .md\\:even\\:pr-98:nth-child(even){
    padding-right: 24.5rem;
  }

  .md\\:even\\:pb-98:nth-child(even){
    padding-bottom: 24.5rem;
  }

  .md\\:even\\:pl-98:nth-child(even){
    padding-left: 24.5rem;
  }

  .md\\:even\\:pt-100:nth-child(even){
    padding-top: 25rem;
  }

  .md\\:even\\:pr-100:nth-child(even){
    padding-right: 25rem;
  }

  .md\\:even\\:pb-100:nth-child(even){
    padding-bottom: 25rem;
  }

  .md\\:even\\:pl-100:nth-child(even){
    padding-left: 25rem;
  }

  .md\\:even\\:pt-104:nth-child(even){
    padding-top: 26rem;
  }

  .md\\:even\\:pr-104:nth-child(even){
    padding-right: 26rem;
  }

  .md\\:even\\:pb-104:nth-child(even){
    padding-bottom: 26rem;
  }

  .md\\:even\\:pl-104:nth-child(even){
    padding-left: 26rem;
  }

  .md\\:even\\:pt-112:nth-child(even){
    padding-top: 28rem;
  }

  .md\\:even\\:pr-112:nth-child(even){
    padding-right: 28rem;
  }

  .md\\:even\\:pb-112:nth-child(even){
    padding-bottom: 28rem;
  }

  .md\\:even\\:pl-112:nth-child(even){
    padding-left: 28rem;
  }

  .md\\:even\\:pt-124:nth-child(even){
    padding-top: 31rem;
  }

  .md\\:even\\:pr-124:nth-child(even){
    padding-right: 31rem;
  }

  .md\\:even\\:pb-124:nth-child(even){
    padding-bottom: 31rem;
  }

  .md\\:even\\:pl-124:nth-child(even){
    padding-left: 31rem;
  }

  .md\\:even\\:pt-128:nth-child(even){
    padding-top: 32rem;
  }

  .md\\:even\\:pr-128:nth-child(even){
    padding-right: 32rem;
  }

  .md\\:even\\:pb-128:nth-child(even){
    padding-bottom: 32rem;
  }

  .md\\:even\\:pl-128:nth-child(even){
    padding-left: 32rem;
  }

  .md\\:even\\:pt-140:nth-child(even){
    padding-top: 35rem;
  }

  .md\\:even\\:pr-140:nth-child(even){
    padding-right: 35rem;
  }

  .md\\:even\\:pb-140:nth-child(even){
    padding-bottom: 35rem;
  }

  .md\\:even\\:pl-140:nth-child(even){
    padding-left: 35rem;
  }

  .md\\:even\\:pt-152:nth-child(even){
    padding-top: 38rem;
  }

  .md\\:even\\:pr-152:nth-child(even){
    padding-right: 38rem;
  }

  .md\\:even\\:pb-152:nth-child(even){
    padding-bottom: 38rem;
  }

  .md\\:even\\:pl-152:nth-child(even){
    padding-left: 38rem;
  }

  .md\\:even\\:pt-160:nth-child(even){
    padding-top: 40rem;
  }

  .md\\:even\\:pr-160:nth-child(even){
    padding-right: 40rem;
  }

  .md\\:even\\:pb-160:nth-child(even){
    padding-bottom: 40rem;
  }

  .md\\:even\\:pl-160:nth-child(even){
    padding-left: 40rem;
  }

  .md\\:even\\:pt-162:nth-child(even){
    padding-top: 41rem;
  }

  .md\\:even\\:pr-162:nth-child(even){
    padding-right: 41rem;
  }

  .md\\:even\\:pb-162:nth-child(even){
    padding-bottom: 41rem;
  }

  .md\\:even\\:pl-162:nth-child(even){
    padding-left: 41rem;
  }

  .md\\:even\\:pt-192:nth-child(even){
    padding-top: 48rem;
  }

  .md\\:even\\:pr-192:nth-child(even){
    padding-right: 48rem;
  }

  .md\\:even\\:pb-192:nth-child(even){
    padding-bottom: 48rem;
  }

  .md\\:even\\:pl-192:nth-child(even){
    padding-left: 48rem;
  }

  .md\\:even\\:pt-208:nth-child(even){
    padding-top: 52rem;
  }

  .md\\:even\\:pr-208:nth-child(even){
    padding-right: 52rem;
  }

  .md\\:even\\:pb-208:nth-child(even){
    padding-bottom: 52rem;
  }

  .md\\:even\\:pl-208:nth-child(even){
    padding-left: 52rem;
  }

  .md\\:even\\:pt-224:nth-child(even){
    padding-top: 56rem;
  }

  .md\\:even\\:pr-224:nth-child(even){
    padding-right: 56rem;
  }

  .md\\:even\\:pb-224:nth-child(even){
    padding-bottom: 56rem;
  }

  .md\\:even\\:pl-224:nth-child(even){
    padding-left: 56rem;
  }

  .md\\:even\\:pt-256:nth-child(even){
    padding-top: 64rem;
  }

  .md\\:even\\:pr-256:nth-child(even){
    padding-right: 64rem;
  }

  .md\\:even\\:pb-256:nth-child(even){
    padding-bottom: 64rem;
  }

  .md\\:even\\:pl-256:nth-child(even){
    padding-left: 64rem;
  }

  .md\\:even\\:pt-px:nth-child(even){
    padding-top: 1px;
  }

  .md\\:even\\:pr-px:nth-child(even){
    padding-right: 1px;
  }

  .md\\:even\\:pb-px:nth-child(even){
    padding-bottom: 1px;
  }

  .md\\:even\\:pl-px:nth-child(even){
    padding-left: 1px;
  }

  .md\\:placeholder-transparent::placeholder{
    color: transparent;
  }

  .md\\:placeholder-focus::placeholder{
    color: rgba(4, 21, 39, 0.8);;
  }

  .md\\:placeholder-black::placeholder{
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .md\\:placeholder-white::placeholder{
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .md\\:placeholder-primary::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .md\\:placeholder-disabled::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .md\\:placeholder-translucent-60::placeholder{
    color: rgba(256, 256, 256, 0.6);
  }

  .md\\:placeholder-translucent-90::placeholder{
    color: rgba(256, 256, 256, 0.9);
  }

  .md\\:placeholder-green-200::placeholder{
    --placeholder-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, var(--placeholder-opacity));
  }

  .md\\:placeholder-green-400::placeholder{
    --placeholder-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, var(--placeholder-opacity));
  }

  .md\\:placeholder-green-500::placeholder{
    --placeholder-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, var(--placeholder-opacity));
  }

  .md\\:placeholder-green-600::placeholder{
    --placeholder-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, var(--placeholder-opacity));
  }

  .md\\:placeholder-green-700::placeholder{
    --placeholder-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, var(--placeholder-opacity));
  }

  .md\\:placeholder-green-400a50::placeholder{
    color: rgba(108,202,152,0.50196);
  }

  .md\\:placeholder-green-500a25::placeholder{
    color: rgba(151,232,18,0.09804);
  }

  .md\\:placeholder-yellow-200::placeholder{
    --placeholder-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, var(--placeholder-opacity));
  }

  .md\\:placeholder-yellow-300::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, var(--placeholder-opacity));
  }

  .md\\:placeholder-yellow-500::placeholder{
    --placeholder-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, var(--placeholder-opacity));
  }

  .md\\:placeholder-yellow-600::placeholder{
    --placeholder-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, var(--placeholder-opacity));
  }

  .md\\:placeholder-yellow-700::placeholder{
    --placeholder-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, var(--placeholder-opacity));
  }

  .md\\:placeholder-yellow-300a66::placeholder{
    color: rgba(255,233,189,0.66667);
  }

  .md\\:placeholder-yellow-500a25::placeholder{
    color: rgba(255,200,44,0.09804);
  }

  .md\\:placeholder-orange-200::placeholder{
    --placeholder-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, var(--placeholder-opacity));
  }

  .md\\:placeholder-orange-400::placeholder{
    --placeholder-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, var(--placeholder-opacity));
  }

  .md\\:placeholder-orange-500::placeholder{
    --placeholder-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, var(--placeholder-opacity));
  }

  .md\\:placeholder-orange-800::placeholder{
    --placeholder-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, var(--placeholder-opacity));
  }

  .md\\:placeholder-orange-900::placeholder{
    --placeholder-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, var(--placeholder-opacity));
  }

  .md\\:placeholder-orange-500a25::placeholder{
    color: rgba(240,115,23,0.09804);
  }

  .md\\:placeholder-red-100::placeholder{
    --placeholder-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, var(--placeholder-opacity));
  }

  .md\\:placeholder-red-150::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, var(--placeholder-opacity));
  }

  .md\\:placeholder-red-200::placeholder{
    --placeholder-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, var(--placeholder-opacity));
  }

  .md\\:placeholder-red-300::placeholder{
    --placeholder-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, var(--placeholder-opacity));
  }

  .md\\:placeholder-red-400::placeholder{
    --placeholder-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, var(--placeholder-opacity));
  }

  .md\\:placeholder-red-500::placeholder{
    --placeholder-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, var(--placeholder-opacity));
  }

  .md\\:placeholder-red-700::placeholder{
    --placeholder-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-50::placeholder{
    --placeholder-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-100::placeholder{
    --placeholder-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-150::placeholder{
    --placeholder-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-200::placeholder{
    --placeholder-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-300::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-400::placeholder{
    color: rgba(114,114,114,0.8);
  }

  .md\\:placeholder-gray-425::placeholder{
    color: rgba(4, 21, 39, 0.8);
  }

  .md\\:placeholder-gray-450::placeholder{
    --placeholder-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-500::placeholder{
    --placeholder-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-600::placeholder{
    --placeholder-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-625::placeholder{
    color: rgba(90,98,107,0.8);
  }

  .md\\:placeholder-gray-700::placeholder{
    --placeholder-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-800::placeholder{
    --placeholder-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, var(--placeholder-opacity));
  }

  .md\\:placeholder-gray-200a50::placeholder{
    color: rgba(224, 226, 228, 0.5);
  }

  .md\\:placeholder-blue-50::placeholder{
    --placeholder-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-100::placeholder{
    --placeholder-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-150::placeholder{
    --placeholder-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-200::placeholder{
    --placeholder-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-300::placeholder{
    --placeholder-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-400::placeholder{
    --placeholder-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-500::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-600::placeholder{
    --placeholder-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-700::placeholder{
    --placeholder-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-750::placeholder{
    --placeholder-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-800::placeholder{
    --placeholder-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-900::placeholder{
    --placeholder-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-950::placeholder{
    --placeholder-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-500a25::placeholder{
    color: rgba(55, 164, 220, 0.2);
  }

  .md\\:placeholder-blue-500a50::placeholder{
    color: rgba(55, 164, 220, 0.5);
  }

  .md\\:placeholder-blue-700a75::placeholder{
    --placeholder-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-700a30::placeholder{
    --placeholder-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, var(--placeholder-opacity));
  }

  .md\\:placeholder-blue-750a25::placeholder{
    color: rgba(86,130,170,0.09804);
  }

  .md\\:placeholder-blue-750a15::placeholder{
    color: rgba(86,130,170,0.05882);
  }

  .md\\:placeholder-blue-800a60::placeholder{
    color: rgba(31, 69, 102, 0.6);
  }

  .md\\:placeholder-programEditorTabColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, var(--placeholder-opacity));
  }

  .md\\:placeholder-programEditorTabColors-2::placeholder{
    --placeholder-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, var(--placeholder-opacity));
  }

  .md\\:placeholder-programEditorTabColors-3::placeholder{
    --placeholder-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, var(--placeholder-opacity));
  }

  .md\\:placeholder-programEditorTabColors-4::placeholder{
    --placeholder-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, var(--placeholder-opacity));
  }

  .md\\:placeholder-programEditorTabColors-5::placeholder{
    --placeholder-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, var(--placeholder-opacity));
  }

  .md\\:placeholder-programEditorTabColors-6::placeholder{
    --placeholder-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, var(--placeholder-opacity));
  }

  .md\\:placeholder-programEditorTabColors-1h::placeholder{
    --placeholder-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, var(--placeholder-opacity));
  }

  .md\\:placeholder-programEditorTabColors-2h::placeholder{
    --placeholder-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, var(--placeholder-opacity));
  }

  .md\\:placeholder-programEditorTabColors-3h::placeholder{
    --placeholder-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, var(--placeholder-opacity));
  }

  .md\\:placeholder-programEditorTabColors-4h::placeholder{
    --placeholder-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, var(--placeholder-opacity));
  }

  .md\\:placeholder-programEditorTabColors-5h::placeholder{
    --placeholder-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, var(--placeholder-opacity));
  }

  .md\\:placeholder-programEditorTabColors-6h::placeholder{
    --placeholder-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, var(--placeholder-opacity));
  }

  .md\\:placeholder-programEditorPresetTabColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .md\\:placeholder-programEditorPresetTabColors-1h::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .md\\:placeholder-borgScaleColors-0::placeholder{
    --placeholder-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, var(--placeholder-opacity));
  }

  .md\\:placeholder-borgScaleColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, var(--placeholder-opacity));
  }

  .md\\:placeholder-borgScaleColors-2::placeholder{
    --placeholder-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, var(--placeholder-opacity));
  }

  .md\\:placeholder-borgScaleColors-3::placeholder{
    --placeholder-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, var(--placeholder-opacity));
  }

  .md\\:placeholder-borgScaleColors-4::placeholder{
    --placeholder-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .md\\:placeholder-borgScaleColors-5::placeholder{
    --placeholder-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, var(--placeholder-opacity));
  }

  .md\\:placeholder-borgScaleColors-6::placeholder{
    --placeholder-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, var(--placeholder-opacity));
  }

  .md\\:placeholder-borgScaleColors-7::placeholder{
    --placeholder-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, var(--placeholder-opacity));
  }

  .md\\:placeholder-borgScaleColors-8::placeholder{
    --placeholder-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, var(--placeholder-opacity));
  }

  .md\\:placeholder-borgScaleColors-9::placeholder{
    --placeholder-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, var(--placeholder-opacity));
  }

  .md\\:placeholder-borgScaleColors-10::placeholder{
    --placeholder-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-transparent:focus::placeholder{
    color: transparent;
  }

  .md\\:focus\\:placeholder-focus:focus::placeholder{
    color: rgba(4, 21, 39, 0.8);;
  }

  .md\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-primary:focus::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-disabled:focus::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-translucent-60:focus::placeholder{
    color: rgba(256, 256, 256, 0.6);
  }

  .md\\:focus\\:placeholder-translucent-90:focus::placeholder{
    color: rgba(256, 256, 256, 0.9);
  }

  .md\\:focus\\:placeholder-green-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-green-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-green-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-green-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-green-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-green-400a50:focus::placeholder{
    color: rgba(108,202,152,0.50196);
  }

  .md\\:focus\\:placeholder-green-500a25:focus::placeholder{
    color: rgba(151,232,18,0.09804);
  }

  .md\\:focus\\:placeholder-yellow-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-yellow-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-yellow-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-yellow-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-yellow-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-yellow-300a66:focus::placeholder{
    color: rgba(255,233,189,0.66667);
  }

  .md\\:focus\\:placeholder-yellow-500a25:focus::placeholder{
    color: rgba(255,200,44,0.09804);
  }

  .md\\:focus\\:placeholder-orange-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-orange-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-orange-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-orange-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-orange-900:focus::placeholder{
    --placeholder-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-orange-500a25:focus::placeholder{
    color: rgba(240,115,23,0.09804);
  }

  .md\\:focus\\:placeholder-red-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-red-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-red-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-red-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-red-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-red-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-red-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-50:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-400:focus::placeholder{
    color: rgba(114,114,114,0.8);
  }

  .md\\:focus\\:placeholder-gray-425:focus::placeholder{
    color: rgba(4, 21, 39, 0.8);
  }

  .md\\:focus\\:placeholder-gray-450:focus::placeholder{
    --placeholder-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-625:focus::placeholder{
    color: rgba(90,98,107,0.8);
  }

  .md\\:focus\\:placeholder-gray-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-gray-200a50:focus::placeholder{
    color: rgba(224, 226, 228, 0.5);
  }

  .md\\:focus\\:placeholder-blue-50:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-750:focus::placeholder{
    --placeholder-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-900:focus::placeholder{
    --placeholder-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-950:focus::placeholder{
    --placeholder-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-500a25:focus::placeholder{
    color: rgba(55, 164, 220, 0.2);
  }

  .md\\:focus\\:placeholder-blue-500a50:focus::placeholder{
    color: rgba(55, 164, 220, 0.5);
  }

  .md\\:focus\\:placeholder-blue-700a75:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-700a30:focus::placeholder{
    --placeholder-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-blue-750a25:focus::placeholder{
    color: rgba(86,130,170,0.09804);
  }

  .md\\:focus\\:placeholder-blue-750a15:focus::placeholder{
    color: rgba(86,130,170,0.05882);
  }

  .md\\:focus\\:placeholder-blue-800a60:focus::placeholder{
    color: rgba(31, 69, 102, 0.6);
  }

  .md\\:focus\\:placeholder-programEditorTabColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-programEditorTabColors-2:focus::placeholder{
    --placeholder-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-programEditorTabColors-3:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-programEditorTabColors-4:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-programEditorTabColors-5:focus::placeholder{
    --placeholder-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-programEditorTabColors-6:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-programEditorTabColors-1h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-programEditorTabColors-2h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-programEditorTabColors-3h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-programEditorTabColors-4h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-programEditorTabColors-5h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-programEditorTabColors-6h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-programEditorPresetTabColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-programEditorPresetTabColors-1h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-borgScaleColors-0:focus::placeholder{
    --placeholder-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-borgScaleColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-borgScaleColors-2:focus::placeholder{
    --placeholder-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-borgScaleColors-3:focus::placeholder{
    --placeholder-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-borgScaleColors-4:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-borgScaleColors-5:focus::placeholder{
    --placeholder-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-borgScaleColors-6:focus::placeholder{
    --placeholder-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-borgScaleColors-7:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-borgScaleColors-8:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-borgScaleColors-9:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, var(--placeholder-opacity));
  }

  .md\\:focus\\:placeholder-borgScaleColors-10:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, var(--placeholder-opacity));
  }

  .md\\:placeholder-opacity-0::placeholder{
    --placeholder-opacity: 0;
  }

  .md\\:placeholder-opacity-25::placeholder{
    --placeholder-opacity: .25;
  }

  .md\\:placeholder-opacity-50::placeholder{
    --placeholder-opacity: .5;
  }

  .md\\:placeholder-opacity-75::placeholder{
    --placeholder-opacity: .75;
  }

  .md\\:placeholder-opacity-100::placeholder{
    --placeholder-opacity: 1;
  }

  .md\\:focus\\:placeholder-opacity-0:focus::placeholder{
    --placeholder-opacity: 0;
  }

  .md\\:focus\\:placeholder-opacity-25:focus::placeholder{
    --placeholder-opacity: .25;
  }

  .md\\:focus\\:placeholder-opacity-50:focus::placeholder{
    --placeholder-opacity: .5;
  }

  .md\\:focus\\:placeholder-opacity-75:focus::placeholder{
    --placeholder-opacity: .75;
  }

  .md\\:focus\\:placeholder-opacity-100:focus::placeholder{
    --placeholder-opacity: 1;
  }

  .md\\:pointer-events-none{
    pointer-events: none;
  }

  .md\\:pointer-events-auto{
    pointer-events: auto;
  }

  .md\\:static{
    position: static;
  }

  .md\\:fixed{
    position: fixed;
  }

  .md\\:absolute{
    position: absolute;
  }

  .md\\:relative{
    position: relative;
  }

  .md\\:sticky{
    position: sticky;
  }

  .md\\:inset-0{
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .md\\:inset-auto{
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }

  .md\\:inset-y-0{
    top: 0;
    bottom: 0;
  }

  .md\\:inset-x-0{
    right: 0;
    left: 0;
  }

  .md\\:inset-y-auto{
    top: auto;
    bottom: auto;
  }

  .md\\:inset-x-auto{
    right: auto;
    left: auto;
  }

  .md\\:top-0{
    top: 0;
  }

  .md\\:right-0{
    right: 0;
  }

  .md\\:bottom-0{
    bottom: 0;
  }

  .md\\:left-0{
    left: 0;
  }

  .md\\:top-auto{
    top: auto;
  }

  .md\\:right-auto{
    right: auto;
  }

  .md\\:bottom-auto{
    bottom: auto;
  }

  .md\\:left-auto{
    left: auto;
  }

  .md\\:resize-none{
    resize: none;
  }

  .md\\:resize-y{
    resize: vertical;
  }

  .md\\:resize-x{
    resize: horizontal;
  }

  .md\\:resize{
    resize: both;
  }

  .md\\:shadow{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .md\\:shadow-overlaptop{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .md\\:shadow-overlapbottom{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .md\\:shadow-xs{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .md\\:shadow-sm{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .md\\:shadow-md{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .md\\:shadow-lg{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .md\\:shadow-xl{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .md\\:shadow-2xl{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .md\\:shadow-none{
    box-shadow: none;
  }

  .md\\:hover\\:shadow:hover{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .md\\:hover\\:shadow-overlaptop:hover{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .md\\:hover\\:shadow-overlapbottom:hover{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .md\\:hover\\:shadow-xs:hover{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .md\\:hover\\:shadow-sm:hover{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .md\\:hover\\:shadow-md:hover{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .md\\:hover\\:shadow-lg:hover{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .md\\:hover\\:shadow-xl:hover{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .md\\:hover\\:shadow-2xl:hover{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .md\\:hover\\:shadow-none:hover{
    box-shadow: none;
  }

  .md\\:focus\\:shadow:focus{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .md\\:focus\\:shadow-overlaptop:focus{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .md\\:focus\\:shadow-overlapbottom:focus{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .md\\:focus\\:shadow-xs:focus{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .md\\:focus\\:shadow-sm:focus{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .md\\:focus\\:shadow-md:focus{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .md\\:focus\\:shadow-lg:focus{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .md\\:focus\\:shadow-xl:focus{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .md\\:focus\\:shadow-2xl:focus{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .md\\:focus\\:shadow-none:focus{
    box-shadow: none;
  }

  .md\\:stroke-0{
    stroke-width: 0;
  }

  .md\\:stroke-1{
    stroke-width: 1;
  }

  .md\\:stroke-2{
    stroke-width: 2;
  }

  .md\\:table-auto{
    table-layout: auto;
  }

  .md\\:table-fixed{
    table-layout: fixed;
  }

  .md\\:text-left{
    text-align: left;
  }

  .md\\:text-center{
    text-align: center;
  }

  .md\\:text-right{
    text-align: right;
  }

  .md\\:text-justify{
    text-align: justify;
  }

  .md\\:text-transparent{
    color: transparent;
  }

  .md\\:text-focus{
    color: rgba(4, 21, 39, 0.8);;
  }

  .md\\:text-black{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .md\\:text-white{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .md\\:text-primary{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .md\\:text-disabled{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .md\\:text-translucent-60{
    color: rgba(256, 256, 256, 0.6);
  }

  .md\\:text-translucent-90{
    color: rgba(256, 256, 256, 0.9);
  }

  .md\\:text-green-200{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .md\\:text-green-400{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .md\\:text-green-500{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .md\\:text-green-600{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .md\\:text-green-700{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .md\\:text-green-400a50{
    color: rgba(108,202,152,0.50196);
  }

  .md\\:text-green-500a25{
    color: rgba(151,232,18,0.09804);
  }

  .md\\:text-yellow-200{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .md\\:text-yellow-300{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .md\\:text-yellow-500{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .md\\:text-yellow-600{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .md\\:text-yellow-700{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .md\\:text-yellow-300a66{
    color: rgba(255,233,189,0.66667);
  }

  .md\\:text-yellow-500a25{
    color: rgba(255,200,44,0.09804);
  }

  .md\\:text-orange-200{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .md\\:text-orange-400{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .md\\:text-orange-500{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .md\\:text-orange-800{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .md\\:text-orange-900{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .md\\:text-orange-500a25{
    color: rgba(240,115,23,0.09804);
  }

  .md\\:text-red-100{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .md\\:text-red-150{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .md\\:text-red-200{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .md\\:text-red-300{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .md\\:text-red-400{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .md\\:text-red-500{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .md\\:text-red-700{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .md\\:text-gray-50{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .md\\:text-gray-100{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .md\\:text-gray-150{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .md\\:text-gray-200{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .md\\:text-gray-300{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .md\\:text-gray-400{
    color: rgba(114,114,114,0.8);
  }

  .md\\:text-gray-425{
    color: rgba(4, 21, 39, 0.8);
  }

  .md\\:text-gray-450{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .md\\:text-gray-500{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .md\\:text-gray-600{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .md\\:text-gray-625{
    color: rgba(90,98,107,0.8);
  }

  .md\\:text-gray-700{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .md\\:text-gray-800{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .md\\:text-gray-200a50{
    color: rgba(224, 226, 228, 0.5);
  }

  .md\\:text-blue-50{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .md\\:text-blue-100{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .md\\:text-blue-150{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .md\\:text-blue-200{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .md\\:text-blue-300{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .md\\:text-blue-400{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .md\\:text-blue-500{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .md\\:text-blue-600{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .md\\:text-blue-700{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .md\\:text-blue-750{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .md\\:text-blue-800{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .md\\:text-blue-900{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .md\\:text-blue-950{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .md\\:text-blue-500a25{
    color: rgba(55, 164, 220, 0.2);
  }

  .md\\:text-blue-500a50{
    color: rgba(55, 164, 220, 0.5);
  }

  .md\\:text-blue-700a75{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .md\\:text-blue-700a30{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .md\\:text-blue-750a25{
    color: rgba(86,130,170,0.09804);
  }

  .md\\:text-blue-750a15{
    color: rgba(86,130,170,0.05882);
  }

  .md\\:text-blue-800a60{
    color: rgba(31, 69, 102, 0.6);
  }

  .md\\:text-programEditorTabColors-1{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .md\\:text-programEditorTabColors-2{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .md\\:text-programEditorTabColors-3{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .md\\:text-programEditorTabColors-4{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .md\\:text-programEditorTabColors-5{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .md\\:text-programEditorTabColors-6{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .md\\:text-programEditorTabColors-1h{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .md\\:text-programEditorTabColors-2h{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .md\\:text-programEditorTabColors-3h{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .md\\:text-programEditorTabColors-4h{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .md\\:text-programEditorTabColors-5h{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .md\\:text-programEditorTabColors-6h{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .md\\:text-programEditorPresetTabColors-1{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .md\\:text-programEditorPresetTabColors-1h{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .md\\:text-borgScaleColors-0{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .md\\:text-borgScaleColors-1{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .md\\:text-borgScaleColors-2{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .md\\:text-borgScaleColors-3{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .md\\:text-borgScaleColors-4{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .md\\:text-borgScaleColors-5{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .md\\:text-borgScaleColors-6{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .md\\:text-borgScaleColors-7{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .md\\:text-borgScaleColors-8{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .md\\:text-borgScaleColors-9{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .md\\:text-borgScaleColors-10{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .md\\:hover\\:text-transparent:hover{
    color: transparent;
  }

  .md\\:hover\\:text-focus:hover{
    color: rgba(4, 21, 39, 0.8);;
  }

  .md\\:hover\\:text-black:hover{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .md\\:hover\\:text-white:hover{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .md\\:hover\\:text-primary:hover{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .md\\:hover\\:text-disabled:hover{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .md\\:hover\\:text-translucent-60:hover{
    color: rgba(256, 256, 256, 0.6);
  }

  .md\\:hover\\:text-translucent-90:hover{
    color: rgba(256, 256, 256, 0.9);
  }

  .md\\:hover\\:text-green-200:hover{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .md\\:hover\\:text-green-400:hover{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .md\\:hover\\:text-green-500:hover{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .md\\:hover\\:text-green-600:hover{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .md\\:hover\\:text-green-700:hover{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .md\\:hover\\:text-green-400a50:hover{
    color: rgba(108,202,152,0.50196);
  }

  .md\\:hover\\:text-green-500a25:hover{
    color: rgba(151,232,18,0.09804);
  }

  .md\\:hover\\:text-yellow-200:hover{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .md\\:hover\\:text-yellow-300:hover{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .md\\:hover\\:text-yellow-500:hover{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .md\\:hover\\:text-yellow-600:hover{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .md\\:hover\\:text-yellow-700:hover{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .md\\:hover\\:text-yellow-300a66:hover{
    color: rgba(255,233,189,0.66667);
  }

  .md\\:hover\\:text-yellow-500a25:hover{
    color: rgba(255,200,44,0.09804);
  }

  .md\\:hover\\:text-orange-200:hover{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .md\\:hover\\:text-orange-400:hover{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .md\\:hover\\:text-orange-500:hover{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .md\\:hover\\:text-orange-800:hover{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .md\\:hover\\:text-orange-900:hover{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .md\\:hover\\:text-orange-500a25:hover{
    color: rgba(240,115,23,0.09804);
  }

  .md\\:hover\\:text-red-100:hover{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .md\\:hover\\:text-red-150:hover{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .md\\:hover\\:text-red-200:hover{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .md\\:hover\\:text-red-300:hover{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .md\\:hover\\:text-red-400:hover{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .md\\:hover\\:text-red-500:hover{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .md\\:hover\\:text-red-700:hover{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .md\\:hover\\:text-gray-50:hover{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .md\\:hover\\:text-gray-100:hover{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .md\\:hover\\:text-gray-150:hover{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .md\\:hover\\:text-gray-200:hover{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .md\\:hover\\:text-gray-300:hover{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .md\\:hover\\:text-gray-400:hover{
    color: rgba(114,114,114,0.8);
  }

  .md\\:hover\\:text-gray-425:hover{
    color: rgba(4, 21, 39, 0.8);
  }

  .md\\:hover\\:text-gray-450:hover{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .md\\:hover\\:text-gray-500:hover{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .md\\:hover\\:text-gray-600:hover{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .md\\:hover\\:text-gray-625:hover{
    color: rgba(90,98,107,0.8);
  }

  .md\\:hover\\:text-gray-700:hover{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .md\\:hover\\:text-gray-800:hover{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .md\\:hover\\:text-gray-200a50:hover{
    color: rgba(224, 226, 228, 0.5);
  }

  .md\\:hover\\:text-blue-50:hover{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .md\\:hover\\:text-blue-100:hover{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .md\\:hover\\:text-blue-150:hover{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .md\\:hover\\:text-blue-200:hover{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .md\\:hover\\:text-blue-300:hover{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .md\\:hover\\:text-blue-400:hover{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .md\\:hover\\:text-blue-500:hover{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .md\\:hover\\:text-blue-600:hover{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .md\\:hover\\:text-blue-700:hover{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .md\\:hover\\:text-blue-750:hover{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .md\\:hover\\:text-blue-800:hover{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .md\\:hover\\:text-blue-900:hover{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .md\\:hover\\:text-blue-950:hover{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .md\\:hover\\:text-blue-500a25:hover{
    color: rgba(55, 164, 220, 0.2);
  }

  .md\\:hover\\:text-blue-500a50:hover{
    color: rgba(55, 164, 220, 0.5);
  }

  .md\\:hover\\:text-blue-700a75:hover{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .md\\:hover\\:text-blue-700a30:hover{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .md\\:hover\\:text-blue-750a25:hover{
    color: rgba(86,130,170,0.09804);
  }

  .md\\:hover\\:text-blue-750a15:hover{
    color: rgba(86,130,170,0.05882);
  }

  .md\\:hover\\:text-blue-800a60:hover{
    color: rgba(31, 69, 102, 0.6);
  }

  .md\\:hover\\:text-programEditorTabColors-1:hover{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .md\\:hover\\:text-programEditorTabColors-2:hover{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .md\\:hover\\:text-programEditorTabColors-3:hover{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .md\\:hover\\:text-programEditorTabColors-4:hover{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .md\\:hover\\:text-programEditorTabColors-5:hover{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .md\\:hover\\:text-programEditorTabColors-6:hover{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .md\\:hover\\:text-programEditorTabColors-1h:hover{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .md\\:hover\\:text-programEditorTabColors-2h:hover{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .md\\:hover\\:text-programEditorTabColors-3h:hover{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .md\\:hover\\:text-programEditorTabColors-4h:hover{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .md\\:hover\\:text-programEditorTabColors-5h:hover{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .md\\:hover\\:text-programEditorTabColors-6h:hover{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .md\\:hover\\:text-programEditorPresetTabColors-1:hover{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .md\\:hover\\:text-programEditorPresetTabColors-1h:hover{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .md\\:hover\\:text-borgScaleColors-0:hover{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .md\\:hover\\:text-borgScaleColors-1:hover{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .md\\:hover\\:text-borgScaleColors-2:hover{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .md\\:hover\\:text-borgScaleColors-3:hover{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .md\\:hover\\:text-borgScaleColors-4:hover{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .md\\:hover\\:text-borgScaleColors-5:hover{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .md\\:hover\\:text-borgScaleColors-6:hover{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .md\\:hover\\:text-borgScaleColors-7:hover{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .md\\:hover\\:text-borgScaleColors-8:hover{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .md\\:hover\\:text-borgScaleColors-9:hover{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .md\\:hover\\:text-borgScaleColors-10:hover{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .md\\:focus\\:text-transparent:focus{
    color: transparent;
  }

  .md\\:focus\\:text-focus:focus{
    color: rgba(4, 21, 39, 0.8);;
  }

  .md\\:focus\\:text-black:focus{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .md\\:focus\\:text-white:focus{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .md\\:focus\\:text-primary:focus{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .md\\:focus\\:text-disabled:focus{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .md\\:focus\\:text-translucent-60:focus{
    color: rgba(256, 256, 256, 0.6);
  }

  .md\\:focus\\:text-translucent-90:focus{
    color: rgba(256, 256, 256, 0.9);
  }

  .md\\:focus\\:text-green-200:focus{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .md\\:focus\\:text-green-400:focus{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .md\\:focus\\:text-green-500:focus{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .md\\:focus\\:text-green-600:focus{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .md\\:focus\\:text-green-700:focus{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .md\\:focus\\:text-green-400a50:focus{
    color: rgba(108,202,152,0.50196);
  }

  .md\\:focus\\:text-green-500a25:focus{
    color: rgba(151,232,18,0.09804);
  }

  .md\\:focus\\:text-yellow-200:focus{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .md\\:focus\\:text-yellow-300:focus{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .md\\:focus\\:text-yellow-500:focus{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .md\\:focus\\:text-yellow-600:focus{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .md\\:focus\\:text-yellow-700:focus{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .md\\:focus\\:text-yellow-300a66:focus{
    color: rgba(255,233,189,0.66667);
  }

  .md\\:focus\\:text-yellow-500a25:focus{
    color: rgba(255,200,44,0.09804);
  }

  .md\\:focus\\:text-orange-200:focus{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .md\\:focus\\:text-orange-400:focus{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .md\\:focus\\:text-orange-500:focus{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .md\\:focus\\:text-orange-800:focus{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .md\\:focus\\:text-orange-900:focus{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .md\\:focus\\:text-orange-500a25:focus{
    color: rgba(240,115,23,0.09804);
  }

  .md\\:focus\\:text-red-100:focus{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .md\\:focus\\:text-red-150:focus{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .md\\:focus\\:text-red-200:focus{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .md\\:focus\\:text-red-300:focus{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .md\\:focus\\:text-red-400:focus{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .md\\:focus\\:text-red-500:focus{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .md\\:focus\\:text-red-700:focus{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .md\\:focus\\:text-gray-50:focus{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .md\\:focus\\:text-gray-100:focus{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .md\\:focus\\:text-gray-150:focus{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .md\\:focus\\:text-gray-200:focus{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .md\\:focus\\:text-gray-300:focus{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .md\\:focus\\:text-gray-400:focus{
    color: rgba(114,114,114,0.8);
  }

  .md\\:focus\\:text-gray-425:focus{
    color: rgba(4, 21, 39, 0.8);
  }

  .md\\:focus\\:text-gray-450:focus{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .md\\:focus\\:text-gray-500:focus{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .md\\:focus\\:text-gray-600:focus{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .md\\:focus\\:text-gray-625:focus{
    color: rgba(90,98,107,0.8);
  }

  .md\\:focus\\:text-gray-700:focus{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .md\\:focus\\:text-gray-800:focus{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .md\\:focus\\:text-gray-200a50:focus{
    color: rgba(224, 226, 228, 0.5);
  }

  .md\\:focus\\:text-blue-50:focus{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .md\\:focus\\:text-blue-100:focus{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .md\\:focus\\:text-blue-150:focus{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .md\\:focus\\:text-blue-200:focus{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .md\\:focus\\:text-blue-300:focus{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .md\\:focus\\:text-blue-400:focus{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .md\\:focus\\:text-blue-500:focus{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .md\\:focus\\:text-blue-600:focus{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .md\\:focus\\:text-blue-700:focus{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .md\\:focus\\:text-blue-750:focus{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .md\\:focus\\:text-blue-800:focus{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .md\\:focus\\:text-blue-900:focus{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .md\\:focus\\:text-blue-950:focus{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .md\\:focus\\:text-blue-500a25:focus{
    color: rgba(55, 164, 220, 0.2);
  }

  .md\\:focus\\:text-blue-500a50:focus{
    color: rgba(55, 164, 220, 0.5);
  }

  .md\\:focus\\:text-blue-700a75:focus{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .md\\:focus\\:text-blue-700a30:focus{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .md\\:focus\\:text-blue-750a25:focus{
    color: rgba(86,130,170,0.09804);
  }

  .md\\:focus\\:text-blue-750a15:focus{
    color: rgba(86,130,170,0.05882);
  }

  .md\\:focus\\:text-blue-800a60:focus{
    color: rgba(31, 69, 102, 0.6);
  }

  .md\\:focus\\:text-programEditorTabColors-1:focus{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .md\\:focus\\:text-programEditorTabColors-2:focus{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .md\\:focus\\:text-programEditorTabColors-3:focus{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .md\\:focus\\:text-programEditorTabColors-4:focus{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .md\\:focus\\:text-programEditorTabColors-5:focus{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .md\\:focus\\:text-programEditorTabColors-6:focus{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .md\\:focus\\:text-programEditorTabColors-1h:focus{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .md\\:focus\\:text-programEditorTabColors-2h:focus{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .md\\:focus\\:text-programEditorTabColors-3h:focus{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .md\\:focus\\:text-programEditorTabColors-4h:focus{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .md\\:focus\\:text-programEditorTabColors-5h:focus{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .md\\:focus\\:text-programEditorTabColors-6h:focus{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .md\\:focus\\:text-programEditorPresetTabColors-1:focus{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .md\\:focus\\:text-programEditorPresetTabColors-1h:focus{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .md\\:focus\\:text-borgScaleColors-0:focus{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .md\\:focus\\:text-borgScaleColors-1:focus{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .md\\:focus\\:text-borgScaleColors-2:focus{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .md\\:focus\\:text-borgScaleColors-3:focus{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .md\\:focus\\:text-borgScaleColors-4:focus{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .md\\:focus\\:text-borgScaleColors-5:focus{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .md\\:focus\\:text-borgScaleColors-6:focus{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .md\\:focus\\:text-borgScaleColors-7:focus{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .md\\:focus\\:text-borgScaleColors-8:focus{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .md\\:focus\\:text-borgScaleColors-9:focus{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .md\\:focus\\:text-borgScaleColors-10:focus{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .md\\:text-opacity-0{
    --text-opacity: 0;
  }

  .md\\:text-opacity-25{
    --text-opacity: .25;
  }

  .md\\:text-opacity-50{
    --text-opacity: .5;
  }

  .md\\:text-opacity-75{
    --text-opacity: .75;
  }

  .md\\:text-opacity-100{
    --text-opacity: 1;
  }

  .md\\:hover\\:text-opacity-0:hover{
    --text-opacity: 0;
  }

  .md\\:hover\\:text-opacity-25:hover{
    --text-opacity: .25;
  }

  .md\\:hover\\:text-opacity-50:hover{
    --text-opacity: .5;
  }

  .md\\:hover\\:text-opacity-75:hover{
    --text-opacity: .75;
  }

  .md\\:hover\\:text-opacity-100:hover{
    --text-opacity: 1;
  }

  .md\\:focus\\:text-opacity-0:focus{
    --text-opacity: 0;
  }

  .md\\:focus\\:text-opacity-25:focus{
    --text-opacity: .25;
  }

  .md\\:focus\\:text-opacity-50:focus{
    --text-opacity: .5;
  }

  .md\\:focus\\:text-opacity-75:focus{
    --text-opacity: .75;
  }

  .md\\:focus\\:text-opacity-100:focus{
    --text-opacity: 1;
  }

  .md\\:italic{
    font-style: italic;
  }

  .md\\:not-italic{
    font-style: normal;
  }

  .md\\:uppercase{
    text-transform: uppercase;
  }

  .md\\:lowercase{
    text-transform: lowercase;
  }

  .md\\:capitalize{
    text-transform: capitalize;
  }

  .md\\:normal-case{
    text-transform: none;
  }

  .md\\:underline{
    text-decoration: underline;
  }

  .md\\:line-through{
    text-decoration: line-through;
  }

  .md\\:no-underline{
    text-decoration: none;
  }

  .md\\:hover\\:underline:hover{
    text-decoration: underline;
  }

  .md\\:hover\\:line-through:hover{
    text-decoration: line-through;
  }

  .md\\:hover\\:no-underline:hover{
    text-decoration: none;
  }

  .md\\:focus\\:underline:focus{
    text-decoration: underline;
  }

  .md\\:focus\\:line-through:focus{
    text-decoration: line-through;
  }

  .md\\:focus\\:no-underline:focus{
    text-decoration: none;
  }

  .md\\:antialiased{
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .md\\:subpixel-antialiased{
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }

  .md\\:ordinal, .md\\:slashed-zero, .md\\:lining-nums, .md\\:oldstyle-nums, .md\\:proportional-nums, .md\\:tabular-nums, .md\\:diagonal-fractions, .md\\:stacked-fractions{
    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);
    font-feature-settings: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
  }

  .md\\:normal-nums{
    font-feature-settings: normal;
    font-variant-numeric: normal;
  }

  .md\\:ordinal{
    --font-variant-numeric-ordinal: ordinal;
  }

  .md\\:slashed-zero{
    --font-variant-numeric-slashed-zero: slashed-zero;
  }

  .md\\:lining-nums{
    --font-variant-numeric-figure: lining-nums;
  }

  .md\\:oldstyle-nums{
    --font-variant-numeric-figure: oldstyle-nums;
  }

  .md\\:proportional-nums{
    --font-variant-numeric-spacing: proportional-nums;
  }

  .md\\:tabular-nums{
    --font-variant-numeric-spacing: tabular-nums;
  }

  .md\\:diagonal-fractions{
    --font-variant-numeric-fraction: diagonal-fractions;
  }

  .md\\:stacked-fractions{
    --font-variant-numeric-fraction: stacked-fractions;
  }

  .md\\:tracking-tight{
    letter-spacing: -0.025em;
  }

  .md\\:tracking-normal{
    letter-spacing: 0;
  }

  .md\\:tracking-wide{
    letter-spacing: 0.01em;
  }

  .md\\:tracking-wider{
    letter-spacing: 0.02em;
  }

  .md\\:tracking-widest{
    letter-spacing: 0.05em;
  }

  .md\\:select-none{
    -webkit-user-select: none;
            user-select: none;
  }

  .md\\:select-text{
    -webkit-user-select: text;
            user-select: text;
  }

  .md\\:select-all{
    -webkit-user-select: all;
            user-select: all;
  }

  .md\\:select-auto{
    -webkit-user-select: auto;
            user-select: auto;
  }

  .md\\:align-baseline{
    vertical-align: baseline;
  }

  .md\\:align-top{
    vertical-align: top;
  }

  .md\\:align-middle{
    vertical-align: middle;
  }

  .md\\:align-bottom{
    vertical-align: bottom;
  }

  .md\\:align-text-top{
    vertical-align: text-top;
  }

  .md\\:align-text-bottom{
    vertical-align: text-bottom;
  }

  .md\\:visible{
    visibility: visible;
  }

  .md\\:invisible{
    visibility: hidden;
  }

  .md\\:whitespace-normal{
    white-space: normal;
  }

  .md\\:whitespace-no-wrap{
    white-space: nowrap;
  }

  .md\\:whitespace-pre{
    white-space: pre;
  }

  .md\\:whitespace-pre-line{
    white-space: pre-line;
  }

  .md\\:whitespace-pre-wrap{
    white-space: pre-wrap;
  }

  .md\\:break-normal{
    word-wrap: normal;
    word-wrap: normal;
    word-break: normal;
  }

  .md\\:break-words{
    word-wrap: break-word;
    word-wrap: break-word;
  }

  .md\\:break-all{
    word-break: break-all;
  }

  .md\\:truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .md\\:w-0{
    width: 0;
  }

  .md\\:w-1{
    width: 0.25rem;
  }

  .md\\:w-2{
    width: 0.5rem;
  }

  .md\\:w-3{
    width: 0.75rem;
  }

  .md\\:w-4{
    width: 1rem;
  }

  .md\\:w-5{
    width: 1.25rem;
  }

  .md\\:w-6{
    width: 1.5rem;
  }

  .md\\:w-7{
    width: 1.75rem;
  }

  .md\\:w-8{
    width: 2rem;
  }

  .md\\:w-9{
    width: 2.25rem;
  }

  .md\\:w-10{
    width: 2.5rem;
  }

  .md\\:w-11{
    width: 2.75rem;
  }

  .md\\:w-12{
    width: 3rem;
  }

  .md\\:w-14{
    width: 3.5rem;
  }

  .md\\:w-15{
    width: 3.75rem;
  }

  .md\\:w-16{
    width: 4rem;
  }

  .md\\:w-18{
    width: 4.5rem;
  }

  .md\\:w-20{
    width: 5rem;
  }

  .md\\:w-22{
    width: 5.5rem;
  }

  .md\\:w-23{
    width: 5.75rem;
  }

  .md\\:w-24{
    width: 6rem;
  }

  .md\\:w-25{
    width: 6.25rem;
  }

  .md\\:w-26{
    width: 6.5rem;
  }

  .md\\:w-28{
    width: 7rem;
  }

  .md\\:w-30{
    width: 7.5rem;
  }

  .md\\:w-32{
    width: 8rem;
  }

  .md\\:w-34{
    width: 8.5rem;
  }

  .md\\:w-40{
    width: 10rem;
  }

  .md\\:w-42{
    width: 10.5rem;
  }

  .md\\:w-44{
    width: 11rem;
  }

  .md\\:w-48{
    width: 12rem;
  }

  .md\\:w-52{
    width: 13rem;
  }

  .md\\:w-54{
    width: 13.5rem;
  }

  .md\\:w-56{
    width: 14rem;
  }

  .md\\:w-60{
    width: 15rem;
  }

  .md\\:w-64{
    width: 16rem;
  }

  .md\\:w-68{
    width: 17rem;
  }

  .md\\:w-72{
    width: 18rem;
  }

  .md\\:w-74{
    width: 18.5rem;
  }

  .md\\:w-76{
    width: 19rem;
  }

  .md\\:w-78{
    width: 19.5rem;
  }

  .md\\:w-80{
    width: 20rem;
  }

  .md\\:w-82{
    width: 20.5rem;
  }

  .md\\:w-84{
    width: 21rem;
  }

  .md\\:w-88{
    width: 22rem;
  }

  .md\\:w-92{
    width: 23rem;
  }

  .md\\:w-96{
    width: 24rem;
  }

  .md\\:w-98{
    width: 24.5rem;
  }

  .md\\:w-100{
    width: 25rem;
  }

  .md\\:w-104{
    width: 26rem;
  }

  .md\\:w-112{
    width: 28rem;
  }

  .md\\:w-124{
    width: 31rem;
  }

  .md\\:w-128{
    width: 32rem;
  }

  .md\\:w-140{
    width: 35rem;
  }

  .md\\:w-152{
    width: 38rem;
  }

  .md\\:w-160{
    width: 40rem;
  }

  .md\\:w-162{
    width: 41rem;
  }

  .md\\:w-192{
    width: 48rem;
  }

  .md\\:w-208{
    width: 52rem;
  }

  .md\\:w-224{
    width: 56rem;
  }

  .md\\:w-256{
    width: 64rem;
  }

  .md\\:w-auto{
    width: auto;
  }

  .md\\:w-px{
    width: 1px;
  }

  .md\\:w-1\\/2{
    width: 50%;
  }

  .md\\:w-1\\/3{
    width: 33.33333%;
  }

  .md\\:w-2\\/3{
    width: 66.66667%;
  }

  .md\\:w-1\\/4{
    width: 25%;
  }

  .md\\:w-3\\/4{
    width: 75%;
  }

  .md\\:w-1\\/5{
    width: 20%;
  }

  .md\\:w-2\\/5{
    width: 40%;
  }

  .md\\:w-3\\/5{
    width: 60%;
  }

  .md\\:w-4\\/5{
    width: 80%;
  }

  .md\\:w-1\\/6{
    width: 16.66667%;
  }

  .md\\:w-5\\/6{
    width: 83.33333%;
  }

  .md\\:w-1\\/7{
    width: 14.285714285%;
  }

  .md\\:w-2\\/7{
    width: 28.571428571%;
  }

  .md\\:w-3\\/7{
    width: 42.85714285%;
  }

  .md\\:w-4\\/7{
    width: 57.14285714%;
  }

  .md\\:w-1\\/9{
    width: 11.1111%;
  }

  .md\\:w-9\\/10{
    width: 90%;
  }

  .md\\:w-full{
    width: 100%;
  }

  .md\\:w-screen{
    width: 100vw;
  }

  .md\\:w-max{
    width: max-content;
  }

  .md\\:z-0{
    z-index: 0;
  }

  .md\\:z-10{
    z-index: 10;
  }

  .md\\:z-20{
    z-index: 20;
  }

  .md\\:z-30{
    z-index: 30;
  }

  .md\\:z-40{
    z-index: 40;
  }

  .md\\:z-50{
    z-index: 50;
  }

  .md\\:z-auto{
    z-index: auto;
  }

  .md\\:gap-0{
    grid-gap: 0;
    gap: 0;
  }

  .md\\:gap-1{
    grid-gap: 0.25rem;
    gap: 0.25rem;
  }

  .md\\:gap-2{
    grid-gap: 0.5rem;
    gap: 0.5rem;
  }

  .md\\:gap-3{
    grid-gap: 0.75rem;
    gap: 0.75rem;
  }

  .md\\:gap-4{
    grid-gap: 1rem;
    gap: 1rem;
  }

  .md\\:gap-5{
    grid-gap: 1.25rem;
    gap: 1.25rem;
  }

  .md\\:gap-6{
    grid-gap: 1.5rem;
    gap: 1.5rem;
  }

  .md\\:gap-7{
    grid-gap: 1.75rem;
    gap: 1.75rem;
  }

  .md\\:gap-8{
    grid-gap: 2rem;
    gap: 2rem;
  }

  .md\\:gap-9{
    grid-gap: 2.25rem;
    gap: 2.25rem;
  }

  .md\\:gap-10{
    grid-gap: 2.5rem;
    gap: 2.5rem;
  }

  .md\\:gap-11{
    grid-gap: 2.75rem;
    gap: 2.75rem;
  }

  .md\\:gap-12{
    grid-gap: 3rem;
    gap: 3rem;
  }

  .md\\:gap-14{
    grid-gap: 3.5rem;
    gap: 3.5rem;
  }

  .md\\:gap-15{
    grid-gap: 3.75rem;
    gap: 3.75rem;
  }

  .md\\:gap-16{
    grid-gap: 4rem;
    gap: 4rem;
  }

  .md\\:gap-18{
    grid-gap: 4.5rem;
    gap: 4.5rem;
  }

  .md\\:gap-20{
    grid-gap: 5rem;
    gap: 5rem;
  }

  .md\\:gap-22{
    grid-gap: 5.5rem;
    gap: 5.5rem;
  }

  .md\\:gap-23{
    grid-gap: 5.75rem;
    gap: 5.75rem;
  }

  .md\\:gap-24{
    grid-gap: 6rem;
    gap: 6rem;
  }

  .md\\:gap-25{
    grid-gap: 6.25rem;
    gap: 6.25rem;
  }

  .md\\:gap-26{
    grid-gap: 6.5rem;
    gap: 6.5rem;
  }

  .md\\:gap-28{
    grid-gap: 7rem;
    gap: 7rem;
  }

  .md\\:gap-30{
    grid-gap: 7.5rem;
    gap: 7.5rem;
  }

  .md\\:gap-32{
    grid-gap: 8rem;
    gap: 8rem;
  }

  .md\\:gap-34{
    grid-gap: 8.5rem;
    gap: 8.5rem;
  }

  .md\\:gap-40{
    grid-gap: 10rem;
    gap: 10rem;
  }

  .md\\:gap-42{
    grid-gap: 10.5rem;
    gap: 10.5rem;
  }

  .md\\:gap-44{
    grid-gap: 11rem;
    gap: 11rem;
  }

  .md\\:gap-48{
    grid-gap: 12rem;
    gap: 12rem;
  }

  .md\\:gap-52{
    grid-gap: 13rem;
    gap: 13rem;
  }

  .md\\:gap-54{
    grid-gap: 13.5rem;
    gap: 13.5rem;
  }

  .md\\:gap-56{
    grid-gap: 14rem;
    gap: 14rem;
  }

  .md\\:gap-60{
    grid-gap: 15rem;
    gap: 15rem;
  }

  .md\\:gap-64{
    grid-gap: 16rem;
    gap: 16rem;
  }

  .md\\:gap-68{
    grid-gap: 17rem;
    gap: 17rem;
  }

  .md\\:gap-72{
    grid-gap: 18rem;
    gap: 18rem;
  }

  .md\\:gap-74{
    grid-gap: 18.5rem;
    gap: 18.5rem;
  }

  .md\\:gap-76{
    grid-gap: 19rem;
    gap: 19rem;
  }

  .md\\:gap-78{
    grid-gap: 19.5rem;
    gap: 19.5rem;
  }

  .md\\:gap-80{
    grid-gap: 20rem;
    gap: 20rem;
  }

  .md\\:gap-82{
    grid-gap: 20.5rem;
    gap: 20.5rem;
  }

  .md\\:gap-84{
    grid-gap: 21rem;
    gap: 21rem;
  }

  .md\\:gap-88{
    grid-gap: 22rem;
    gap: 22rem;
  }

  .md\\:gap-92{
    grid-gap: 23rem;
    gap: 23rem;
  }

  .md\\:gap-96{
    grid-gap: 24rem;
    gap: 24rem;
  }

  .md\\:gap-98{
    grid-gap: 24.5rem;
    gap: 24.5rem;
  }

  .md\\:gap-100{
    grid-gap: 25rem;
    gap: 25rem;
  }

  .md\\:gap-104{
    grid-gap: 26rem;
    gap: 26rem;
  }

  .md\\:gap-112{
    grid-gap: 28rem;
    gap: 28rem;
  }

  .md\\:gap-124{
    grid-gap: 31rem;
    gap: 31rem;
  }

  .md\\:gap-128{
    grid-gap: 32rem;
    gap: 32rem;
  }

  .md\\:gap-140{
    grid-gap: 35rem;
    gap: 35rem;
  }

  .md\\:gap-152{
    grid-gap: 38rem;
    gap: 38rem;
  }

  .md\\:gap-160{
    grid-gap: 40rem;
    gap: 40rem;
  }

  .md\\:gap-162{
    grid-gap: 41rem;
    gap: 41rem;
  }

  .md\\:gap-192{
    grid-gap: 48rem;
    gap: 48rem;
  }

  .md\\:gap-208{
    grid-gap: 52rem;
    gap: 52rem;
  }

  .md\\:gap-224{
    grid-gap: 56rem;
    gap: 56rem;
  }

  .md\\:gap-256{
    grid-gap: 64rem;
    gap: 64rem;
  }

  .md\\:gap-px{
    grid-gap: 1px;
    gap: 1px;
  }

  .md\\:gap-x-0{
    grid-column-gap: 0;
    -moz-column-gap: 0;
         column-gap: 0;
  }

  .md\\:gap-x-1{
    grid-column-gap: 0.25rem;
    -moz-column-gap: 0.25rem;
         column-gap: 0.25rem;
  }

  .md\\:gap-x-2{
    grid-column-gap: 0.5rem;
    -moz-column-gap: 0.5rem;
         column-gap: 0.5rem;
  }

  .md\\:gap-x-3{
    grid-column-gap: 0.75rem;
    -moz-column-gap: 0.75rem;
         column-gap: 0.75rem;
  }

  .md\\:gap-x-4{
    grid-column-gap: 1rem;
    -moz-column-gap: 1rem;
         column-gap: 1rem;
  }

  .md\\:gap-x-5{
    grid-column-gap: 1.25rem;
    -moz-column-gap: 1.25rem;
         column-gap: 1.25rem;
  }

  .md\\:gap-x-6{
    grid-column-gap: 1.5rem;
    -moz-column-gap: 1.5rem;
         column-gap: 1.5rem;
  }

  .md\\:gap-x-7{
    grid-column-gap: 1.75rem;
    -moz-column-gap: 1.75rem;
         column-gap: 1.75rem;
  }

  .md\\:gap-x-8{
    grid-column-gap: 2rem;
    -moz-column-gap: 2rem;
         column-gap: 2rem;
  }

  .md\\:gap-x-9{
    grid-column-gap: 2.25rem;
    -moz-column-gap: 2.25rem;
         column-gap: 2.25rem;
  }

  .md\\:gap-x-10{
    grid-column-gap: 2.5rem;
    -moz-column-gap: 2.5rem;
         column-gap: 2.5rem;
  }

  .md\\:gap-x-11{
    grid-column-gap: 2.75rem;
    -moz-column-gap: 2.75rem;
         column-gap: 2.75rem;
  }

  .md\\:gap-x-12{
    grid-column-gap: 3rem;
    -moz-column-gap: 3rem;
         column-gap: 3rem;
  }

  .md\\:gap-x-14{
    grid-column-gap: 3.5rem;
    -moz-column-gap: 3.5rem;
         column-gap: 3.5rem;
  }

  .md\\:gap-x-15{
    grid-column-gap: 3.75rem;
    -moz-column-gap: 3.75rem;
         column-gap: 3.75rem;
  }

  .md\\:gap-x-16{
    grid-column-gap: 4rem;
    -moz-column-gap: 4rem;
         column-gap: 4rem;
  }

  .md\\:gap-x-18{
    grid-column-gap: 4.5rem;
    -moz-column-gap: 4.5rem;
         column-gap: 4.5rem;
  }

  .md\\:gap-x-20{
    grid-column-gap: 5rem;
    -moz-column-gap: 5rem;
         column-gap: 5rem;
  }

  .md\\:gap-x-22{
    grid-column-gap: 5.5rem;
    -moz-column-gap: 5.5rem;
         column-gap: 5.5rem;
  }

  .md\\:gap-x-23{
    grid-column-gap: 5.75rem;
    -moz-column-gap: 5.75rem;
         column-gap: 5.75rem;
  }

  .md\\:gap-x-24{
    grid-column-gap: 6rem;
    -moz-column-gap: 6rem;
         column-gap: 6rem;
  }

  .md\\:gap-x-25{
    grid-column-gap: 6.25rem;
    -moz-column-gap: 6.25rem;
         column-gap: 6.25rem;
  }

  .md\\:gap-x-26{
    grid-column-gap: 6.5rem;
    -moz-column-gap: 6.5rem;
         column-gap: 6.5rem;
  }

  .md\\:gap-x-28{
    grid-column-gap: 7rem;
    -moz-column-gap: 7rem;
         column-gap: 7rem;
  }

  .md\\:gap-x-30{
    grid-column-gap: 7.5rem;
    -moz-column-gap: 7.5rem;
         column-gap: 7.5rem;
  }

  .md\\:gap-x-32{
    grid-column-gap: 8rem;
    -moz-column-gap: 8rem;
         column-gap: 8rem;
  }

  .md\\:gap-x-34{
    grid-column-gap: 8.5rem;
    -moz-column-gap: 8.5rem;
         column-gap: 8.5rem;
  }

  .md\\:gap-x-40{
    grid-column-gap: 10rem;
    -moz-column-gap: 10rem;
         column-gap: 10rem;
  }

  .md\\:gap-x-42{
    grid-column-gap: 10.5rem;
    -moz-column-gap: 10.5rem;
         column-gap: 10.5rem;
  }

  .md\\:gap-x-44{
    grid-column-gap: 11rem;
    -moz-column-gap: 11rem;
         column-gap: 11rem;
  }

  .md\\:gap-x-48{
    grid-column-gap: 12rem;
    -moz-column-gap: 12rem;
         column-gap: 12rem;
  }

  .md\\:gap-x-52{
    grid-column-gap: 13rem;
    -moz-column-gap: 13rem;
         column-gap: 13rem;
  }

  .md\\:gap-x-54{
    grid-column-gap: 13.5rem;
    -moz-column-gap: 13.5rem;
         column-gap: 13.5rem;
  }

  .md\\:gap-x-56{
    grid-column-gap: 14rem;
    -moz-column-gap: 14rem;
         column-gap: 14rem;
  }

  .md\\:gap-x-60{
    grid-column-gap: 15rem;
    -moz-column-gap: 15rem;
         column-gap: 15rem;
  }

  .md\\:gap-x-64{
    grid-column-gap: 16rem;
    -moz-column-gap: 16rem;
         column-gap: 16rem;
  }

  .md\\:gap-x-68{
    grid-column-gap: 17rem;
    -moz-column-gap: 17rem;
         column-gap: 17rem;
  }

  .md\\:gap-x-72{
    grid-column-gap: 18rem;
    -moz-column-gap: 18rem;
         column-gap: 18rem;
  }

  .md\\:gap-x-74{
    grid-column-gap: 18.5rem;
    -moz-column-gap: 18.5rem;
         column-gap: 18.5rem;
  }

  .md\\:gap-x-76{
    grid-column-gap: 19rem;
    -moz-column-gap: 19rem;
         column-gap: 19rem;
  }

  .md\\:gap-x-78{
    grid-column-gap: 19.5rem;
    -moz-column-gap: 19.5rem;
         column-gap: 19.5rem;
  }

  .md\\:gap-x-80{
    grid-column-gap: 20rem;
    -moz-column-gap: 20rem;
         column-gap: 20rem;
  }

  .md\\:gap-x-82{
    grid-column-gap: 20.5rem;
    -moz-column-gap: 20.5rem;
         column-gap: 20.5rem;
  }

  .md\\:gap-x-84{
    grid-column-gap: 21rem;
    -moz-column-gap: 21rem;
         column-gap: 21rem;
  }

  .md\\:gap-x-88{
    grid-column-gap: 22rem;
    -moz-column-gap: 22rem;
         column-gap: 22rem;
  }

  .md\\:gap-x-92{
    grid-column-gap: 23rem;
    -moz-column-gap: 23rem;
         column-gap: 23rem;
  }

  .md\\:gap-x-96{
    grid-column-gap: 24rem;
    -moz-column-gap: 24rem;
         column-gap: 24rem;
  }

  .md\\:gap-x-98{
    grid-column-gap: 24.5rem;
    -moz-column-gap: 24.5rem;
         column-gap: 24.5rem;
  }

  .md\\:gap-x-100{
    grid-column-gap: 25rem;
    -moz-column-gap: 25rem;
         column-gap: 25rem;
  }

  .md\\:gap-x-104{
    grid-column-gap: 26rem;
    -moz-column-gap: 26rem;
         column-gap: 26rem;
  }

  .md\\:gap-x-112{
    grid-column-gap: 28rem;
    -moz-column-gap: 28rem;
         column-gap: 28rem;
  }

  .md\\:gap-x-124{
    grid-column-gap: 31rem;
    -moz-column-gap: 31rem;
         column-gap: 31rem;
  }

  .md\\:gap-x-128{
    grid-column-gap: 32rem;
    -moz-column-gap: 32rem;
         column-gap: 32rem;
  }

  .md\\:gap-x-140{
    grid-column-gap: 35rem;
    -moz-column-gap: 35rem;
         column-gap: 35rem;
  }

  .md\\:gap-x-152{
    grid-column-gap: 38rem;
    -moz-column-gap: 38rem;
         column-gap: 38rem;
  }

  .md\\:gap-x-160{
    grid-column-gap: 40rem;
    -moz-column-gap: 40rem;
         column-gap: 40rem;
  }

  .md\\:gap-x-162{
    grid-column-gap: 41rem;
    -moz-column-gap: 41rem;
         column-gap: 41rem;
  }

  .md\\:gap-x-192{
    grid-column-gap: 48rem;
    -moz-column-gap: 48rem;
         column-gap: 48rem;
  }

  .md\\:gap-x-208{
    grid-column-gap: 52rem;
    -moz-column-gap: 52rem;
         column-gap: 52rem;
  }

  .md\\:gap-x-224{
    grid-column-gap: 56rem;
    -moz-column-gap: 56rem;
         column-gap: 56rem;
  }

  .md\\:gap-x-256{
    grid-column-gap: 64rem;
    -moz-column-gap: 64rem;
         column-gap: 64rem;
  }

  .md\\:gap-x-px{
    grid-column-gap: 1px;
    -moz-column-gap: 1px;
         column-gap: 1px;
  }

  .md\\:gap-y-0{
    grid-row-gap: 0;
    row-gap: 0;
  }

  .md\\:gap-y-1{
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }

  .md\\:gap-y-2{
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }

  .md\\:gap-y-3{
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }

  .md\\:gap-y-4{
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }

  .md\\:gap-y-5{
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }

  .md\\:gap-y-6{
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }

  .md\\:gap-y-7{
    grid-row-gap: 1.75rem;
    row-gap: 1.75rem;
  }

  .md\\:gap-y-8{
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }

  .md\\:gap-y-9{
    grid-row-gap: 2.25rem;
    row-gap: 2.25rem;
  }

  .md\\:gap-y-10{
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }

  .md\\:gap-y-11{
    grid-row-gap: 2.75rem;
    row-gap: 2.75rem;
  }

  .md\\:gap-y-12{
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }

  .md\\:gap-y-14{
    grid-row-gap: 3.5rem;
    row-gap: 3.5rem;
  }

  .md\\:gap-y-15{
    grid-row-gap: 3.75rem;
    row-gap: 3.75rem;
  }

  .md\\:gap-y-16{
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }

  .md\\:gap-y-18{
    grid-row-gap: 4.5rem;
    row-gap: 4.5rem;
  }

  .md\\:gap-y-20{
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }

  .md\\:gap-y-22{
    grid-row-gap: 5.5rem;
    row-gap: 5.5rem;
  }

  .md\\:gap-y-23{
    grid-row-gap: 5.75rem;
    row-gap: 5.75rem;
  }

  .md\\:gap-y-24{
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }

  .md\\:gap-y-25{
    grid-row-gap: 6.25rem;
    row-gap: 6.25rem;
  }

  .md\\:gap-y-26{
    grid-row-gap: 6.5rem;
    row-gap: 6.5rem;
  }

  .md\\:gap-y-28{
    grid-row-gap: 7rem;
    row-gap: 7rem;
  }

  .md\\:gap-y-30{
    grid-row-gap: 7.5rem;
    row-gap: 7.5rem;
  }

  .md\\:gap-y-32{
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }

  .md\\:gap-y-34{
    grid-row-gap: 8.5rem;
    row-gap: 8.5rem;
  }

  .md\\:gap-y-40{
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }

  .md\\:gap-y-42{
    grid-row-gap: 10.5rem;
    row-gap: 10.5rem;
  }

  .md\\:gap-y-44{
    grid-row-gap: 11rem;
    row-gap: 11rem;
  }

  .md\\:gap-y-48{
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }

  .md\\:gap-y-52{
    grid-row-gap: 13rem;
    row-gap: 13rem;
  }

  .md\\:gap-y-54{
    grid-row-gap: 13.5rem;
    row-gap: 13.5rem;
  }

  .md\\:gap-y-56{
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }

  .md\\:gap-y-60{
    grid-row-gap: 15rem;
    row-gap: 15rem;
  }

  .md\\:gap-y-64{
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }

  .md\\:gap-y-68{
    grid-row-gap: 17rem;
    row-gap: 17rem;
  }

  .md\\:gap-y-72{
    grid-row-gap: 18rem;
    row-gap: 18rem;
  }

  .md\\:gap-y-74{
    grid-row-gap: 18.5rem;
    row-gap: 18.5rem;
  }

  .md\\:gap-y-76{
    grid-row-gap: 19rem;
    row-gap: 19rem;
  }

  .md\\:gap-y-78{
    grid-row-gap: 19.5rem;
    row-gap: 19.5rem;
  }

  .md\\:gap-y-80{
    grid-row-gap: 20rem;
    row-gap: 20rem;
  }

  .md\\:gap-y-82{
    grid-row-gap: 20.5rem;
    row-gap: 20.5rem;
  }

  .md\\:gap-y-84{
    grid-row-gap: 21rem;
    row-gap: 21rem;
  }

  .md\\:gap-y-88{
    grid-row-gap: 22rem;
    row-gap: 22rem;
  }

  .md\\:gap-y-92{
    grid-row-gap: 23rem;
    row-gap: 23rem;
  }

  .md\\:gap-y-96{
    grid-row-gap: 24rem;
    row-gap: 24rem;
  }

  .md\\:gap-y-98{
    grid-row-gap: 24.5rem;
    row-gap: 24.5rem;
  }

  .md\\:gap-y-100{
    grid-row-gap: 25rem;
    row-gap: 25rem;
  }

  .md\\:gap-y-104{
    grid-row-gap: 26rem;
    row-gap: 26rem;
  }

  .md\\:gap-y-112{
    grid-row-gap: 28rem;
    row-gap: 28rem;
  }

  .md\\:gap-y-124{
    grid-row-gap: 31rem;
    row-gap: 31rem;
  }

  .md\\:gap-y-128{
    grid-row-gap: 32rem;
    row-gap: 32rem;
  }

  .md\\:gap-y-140{
    grid-row-gap: 35rem;
    row-gap: 35rem;
  }

  .md\\:gap-y-152{
    grid-row-gap: 38rem;
    row-gap: 38rem;
  }

  .md\\:gap-y-160{
    grid-row-gap: 40rem;
    row-gap: 40rem;
  }

  .md\\:gap-y-162{
    grid-row-gap: 41rem;
    row-gap: 41rem;
  }

  .md\\:gap-y-192{
    grid-row-gap: 48rem;
    row-gap: 48rem;
  }

  .md\\:gap-y-208{
    grid-row-gap: 52rem;
    row-gap: 52rem;
  }

  .md\\:gap-y-224{
    grid-row-gap: 56rem;
    row-gap: 56rem;
  }

  .md\\:gap-y-256{
    grid-row-gap: 64rem;
    row-gap: 64rem;
  }

  .md\\:gap-y-px{
    grid-row-gap: 1px;
    row-gap: 1px;
  }

  .md\\:grid-flow-row{
    grid-auto-flow: row;
  }

  .md\\:grid-flow-col{
    grid-auto-flow: column;
  }

  .md\\:grid-flow-row-dense{
    grid-auto-flow: row dense;
  }

  .md\\:grid-flow-col-dense{
    grid-auto-flow: column dense;
  }

  .md\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .md\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .md\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .md\\:grid-cols-9{
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .md\\:grid-cols-10{
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .md\\:grid-cols-11{
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .md\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .md\\:grid-cols-14{
    grid-template-columns: repeat(14, minmax(0, 1fr));
  }

  .md\\:grid-cols-none{
    grid-template-columns: none;
  }

  .md\\:auto-cols-auto{
    grid-auto-columns: auto;
  }

  .md\\:auto-cols-min{
    grid-auto-columns: min-content;
  }

  .md\\:auto-cols-max{
    grid-auto-columns: max-content;
  }

  .md\\:auto-cols-fr{
    grid-auto-columns: minmax(0, 1fr);
  }

  .md\\:col-auto{
    grid-column: auto;
  }

  .md\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .md\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .md\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .md\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .md\\:col-span-6{
    grid-column: span 6 / span 6;
  }

  .md\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .md\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .md\\:col-span-9{
    grid-column: span 9 / span 9;
  }

  .md\\:col-span-10{
    grid-column: span 10 / span 10;
  }

  .md\\:col-span-11{
    grid-column: span 11 / span 11;
  }

  .md\\:col-span-12{
    grid-column: span 12 / span 12;
  }

  .md\\:col-span-full{
    grid-column: 1 / -1;
  }

  .md\\:col-start-1{
    grid-column-start: 1;
  }

  .md\\:col-start-2{
    grid-column-start: 2;
  }

  .md\\:col-start-3{
    grid-column-start: 3;
  }

  .md\\:col-start-4{
    grid-column-start: 4;
  }

  .md\\:col-start-5{
    grid-column-start: 5;
  }

  .md\\:col-start-6{
    grid-column-start: 6;
  }

  .md\\:col-start-7{
    grid-column-start: 7;
  }

  .md\\:col-start-8{
    grid-column-start: 8;
  }

  .md\\:col-start-9{
    grid-column-start: 9;
  }

  .md\\:col-start-10{
    grid-column-start: 10;
  }

  .md\\:col-start-11{
    grid-column-start: 11;
  }

  .md\\:col-start-12{
    grid-column-start: 12;
  }

  .md\\:col-start-13{
    grid-column-start: 13;
  }

  .md\\:col-start-14{
    grid-column-start: 14;
  }

  .md\\:col-start-15{
    grid-column-start: 15;
  }

  .md\\:col-start-auto{
    grid-column-start: auto;
  }

  .md\\:col-end-1{
    grid-column-end: 1;
  }

  .md\\:col-end-2{
    grid-column-end: 2;
  }

  .md\\:col-end-3{
    grid-column-end: 3;
  }

  .md\\:col-end-4{
    grid-column-end: 4;
  }

  .md\\:col-end-5{
    grid-column-end: 5;
  }

  .md\\:col-end-6{
    grid-column-end: 6;
  }

  .md\\:col-end-7{
    grid-column-end: 7;
  }

  .md\\:col-end-8{
    grid-column-end: 8;
  }

  .md\\:col-end-9{
    grid-column-end: 9;
  }

  .md\\:col-end-10{
    grid-column-end: 10;
  }

  .md\\:col-end-11{
    grid-column-end: 11;
  }

  .md\\:col-end-12{
    grid-column-end: 12;
  }

  .md\\:col-end-13{
    grid-column-end: 13;
  }

  .md\\:col-end-14{
    grid-column-end: 14;
  }

  .md\\:col-end-15{
    grid-column-end: 15;
  }

  .md\\:col-end-auto{
    grid-column-end: auto;
  }

  .md\\:grid-rows-1{
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .md\\:grid-rows-2{
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-rows-3{
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-rows-4{
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-rows-5{
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }

  .md\\:grid-rows-6{
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }

  .md\\:grid-rows-none{
    grid-template-rows: none;
  }

  .md\\:auto-rows-auto{
    grid-auto-rows: auto;
  }

  .md\\:auto-rows-min{
    grid-auto-rows: min-content;
  }

  .md\\:auto-rows-max{
    grid-auto-rows: max-content;
  }

  .md\\:auto-rows-fr{
    grid-auto-rows: minmax(0, 1fr);
  }

  .md\\:row-auto{
    grid-row: auto;
  }

  .md\\:row-span-1{
    grid-row: span 1 / span 1;
  }

  .md\\:row-span-2{
    grid-row: span 2 / span 2;
  }

  .md\\:row-span-3{
    grid-row: span 3 / span 3;
  }

  .md\\:row-span-4{
    grid-row: span 4 / span 4;
  }

  .md\\:row-span-5{
    grid-row: span 5 / span 5;
  }

  .md\\:row-span-6{
    grid-row: span 6 / span 6;
  }

  .md\\:row-span-full{
    grid-row: 1 / -1;
  }

  .md\\:row-start-1{
    grid-row-start: 1;
  }

  .md\\:row-start-2{
    grid-row-start: 2;
  }

  .md\\:row-start-3{
    grid-row-start: 3;
  }

  .md\\:row-start-4{
    grid-row-start: 4;
  }

  .md\\:row-start-5{
    grid-row-start: 5;
  }

  .md\\:row-start-6{
    grid-row-start: 6;
  }

  .md\\:row-start-7{
    grid-row-start: 7;
  }

  .md\\:row-start-auto{
    grid-row-start: auto;
  }

  .md\\:row-end-1{
    grid-row-end: 1;
  }

  .md\\:row-end-2{
    grid-row-end: 2;
  }

  .md\\:row-end-3{
    grid-row-end: 3;
  }

  .md\\:row-end-4{
    grid-row-end: 4;
  }

  .md\\:row-end-5{
    grid-row-end: 5;
  }

  .md\\:row-end-6{
    grid-row-end: 6;
  }

  .md\\:row-end-7{
    grid-row-end: 7;
  }

  .md\\:row-end-auto{
    grid-row-end: auto;
  }

  .md\\:transform{
    --transform-translate-x: 0;
    --transform-translate-y: 0;
    --transform-rotate: 0;
    --transform-skew-x: 0;
    --transform-skew-y: 0;
    --transform-scale-x: 1;
    --transform-scale-y: 1;
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
  }

  .md\\:transform-none{
    transform: none;
  }

  .md\\:origin-center{
    transform-origin: center;
  }

  .md\\:origin-top{
    transform-origin: top;
  }

  .md\\:origin-top-right{
    transform-origin: top right;
  }

  .md\\:origin-right{
    transform-origin: right;
  }

  .md\\:origin-bottom-right{
    transform-origin: bottom right;
  }

  .md\\:origin-bottom{
    transform-origin: bottom;
  }

  .md\\:origin-bottom-left{
    transform-origin: bottom left;
  }

  .md\\:origin-left{
    transform-origin: left;
  }

  .md\\:origin-top-left{
    transform-origin: top left;
  }

  .md\\:scale-0{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .md\\:scale-50{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .md\\:scale-75{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .md\\:scale-90{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .md\\:scale-95{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .md\\:scale-100{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .md\\:scale-105{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .md\\:scale-110{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .md\\:scale-125{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .md\\:scale-150{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .md\\:scale-x-0{
    --transform-scale-x: 0;
  }

  .md\\:scale-x-50{
    --transform-scale-x: .5;
  }

  .md\\:scale-x-75{
    --transform-scale-x: .75;
  }

  .md\\:scale-x-90{
    --transform-scale-x: .9;
  }

  .md\\:scale-x-95{
    --transform-scale-x: .95;
  }

  .md\\:scale-x-100{
    --transform-scale-x: 1;
  }

  .md\\:scale-x-105{
    --transform-scale-x: 1.05;
  }

  .md\\:scale-x-110{
    --transform-scale-x: 1.1;
  }

  .md\\:scale-x-125{
    --transform-scale-x: 1.25;
  }

  .md\\:scale-x-150{
    --transform-scale-x: 1.5;
  }

  .md\\:scale-y-0{
    --transform-scale-y: 0;
  }

  .md\\:scale-y-50{
    --transform-scale-y: .5;
  }

  .md\\:scale-y-75{
    --transform-scale-y: .75;
  }

  .md\\:scale-y-90{
    --transform-scale-y: .9;
  }

  .md\\:scale-y-95{
    --transform-scale-y: .95;
  }

  .md\\:scale-y-100{
    --transform-scale-y: 1;
  }

  .md\\:scale-y-105{
    --transform-scale-y: 1.05;
  }

  .md\\:scale-y-110{
    --transform-scale-y: 1.1;
  }

  .md\\:scale-y-125{
    --transform-scale-y: 1.25;
  }

  .md\\:scale-y-150{
    --transform-scale-y: 1.5;
  }

  .md\\:hover\\:scale-0:hover{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .md\\:hover\\:scale-50:hover{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .md\\:hover\\:scale-75:hover{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .md\\:hover\\:scale-90:hover{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .md\\:hover\\:scale-95:hover{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .md\\:hover\\:scale-100:hover{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .md\\:hover\\:scale-105:hover{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .md\\:hover\\:scale-110:hover{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .md\\:hover\\:scale-125:hover{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .md\\:hover\\:scale-150:hover{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .md\\:hover\\:scale-x-0:hover{
    --transform-scale-x: 0;
  }

  .md\\:hover\\:scale-x-50:hover{
    --transform-scale-x: .5;
  }

  .md\\:hover\\:scale-x-75:hover{
    --transform-scale-x: .75;
  }

  .md\\:hover\\:scale-x-90:hover{
    --transform-scale-x: .9;
  }

  .md\\:hover\\:scale-x-95:hover{
    --transform-scale-x: .95;
  }

  .md\\:hover\\:scale-x-100:hover{
    --transform-scale-x: 1;
  }

  .md\\:hover\\:scale-x-105:hover{
    --transform-scale-x: 1.05;
  }

  .md\\:hover\\:scale-x-110:hover{
    --transform-scale-x: 1.1;
  }

  .md\\:hover\\:scale-x-125:hover{
    --transform-scale-x: 1.25;
  }

  .md\\:hover\\:scale-x-150:hover{
    --transform-scale-x: 1.5;
  }

  .md\\:hover\\:scale-y-0:hover{
    --transform-scale-y: 0;
  }

  .md\\:hover\\:scale-y-50:hover{
    --transform-scale-y: .5;
  }

  .md\\:hover\\:scale-y-75:hover{
    --transform-scale-y: .75;
  }

  .md\\:hover\\:scale-y-90:hover{
    --transform-scale-y: .9;
  }

  .md\\:hover\\:scale-y-95:hover{
    --transform-scale-y: .95;
  }

  .md\\:hover\\:scale-y-100:hover{
    --transform-scale-y: 1;
  }

  .md\\:hover\\:scale-y-105:hover{
    --transform-scale-y: 1.05;
  }

  .md\\:hover\\:scale-y-110:hover{
    --transform-scale-y: 1.1;
  }

  .md\\:hover\\:scale-y-125:hover{
    --transform-scale-y: 1.25;
  }

  .md\\:hover\\:scale-y-150:hover{
    --transform-scale-y: 1.5;
  }

  .md\\:focus\\:scale-0:focus{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .md\\:focus\\:scale-50:focus{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .md\\:focus\\:scale-75:focus{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .md\\:focus\\:scale-90:focus{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .md\\:focus\\:scale-95:focus{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .md\\:focus\\:scale-100:focus{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .md\\:focus\\:scale-105:focus{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .md\\:focus\\:scale-110:focus{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .md\\:focus\\:scale-125:focus{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .md\\:focus\\:scale-150:focus{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .md\\:focus\\:scale-x-0:focus{
    --transform-scale-x: 0;
  }

  .md\\:focus\\:scale-x-50:focus{
    --transform-scale-x: .5;
  }

  .md\\:focus\\:scale-x-75:focus{
    --transform-scale-x: .75;
  }

  .md\\:focus\\:scale-x-90:focus{
    --transform-scale-x: .9;
  }

  .md\\:focus\\:scale-x-95:focus{
    --transform-scale-x: .95;
  }

  .md\\:focus\\:scale-x-100:focus{
    --transform-scale-x: 1;
  }

  .md\\:focus\\:scale-x-105:focus{
    --transform-scale-x: 1.05;
  }

  .md\\:focus\\:scale-x-110:focus{
    --transform-scale-x: 1.1;
  }

  .md\\:focus\\:scale-x-125:focus{
    --transform-scale-x: 1.25;
  }

  .md\\:focus\\:scale-x-150:focus{
    --transform-scale-x: 1.5;
  }

  .md\\:focus\\:scale-y-0:focus{
    --transform-scale-y: 0;
  }

  .md\\:focus\\:scale-y-50:focus{
    --transform-scale-y: .5;
  }

  .md\\:focus\\:scale-y-75:focus{
    --transform-scale-y: .75;
  }

  .md\\:focus\\:scale-y-90:focus{
    --transform-scale-y: .9;
  }

  .md\\:focus\\:scale-y-95:focus{
    --transform-scale-y: .95;
  }

  .md\\:focus\\:scale-y-100:focus{
    --transform-scale-y: 1;
  }

  .md\\:focus\\:scale-y-105:focus{
    --transform-scale-y: 1.05;
  }

  .md\\:focus\\:scale-y-110:focus{
    --transform-scale-y: 1.1;
  }

  .md\\:focus\\:scale-y-125:focus{
    --transform-scale-y: 1.25;
  }

  .md\\:focus\\:scale-y-150:focus{
    --transform-scale-y: 1.5;
  }

  .md\\:rotate-0{
    --transform-rotate: 0;
  }

  .md\\:rotate-1{
    --transform-rotate: 1deg;
  }

  .md\\:rotate-2{
    --transform-rotate: 2deg;
  }

  .md\\:rotate-3{
    --transform-rotate: 3deg;
  }

  .md\\:rotate-6{
    --transform-rotate: 6deg;
  }

  .md\\:rotate-12{
    --transform-rotate: 12deg;
  }

  .md\\:rotate-45{
    --transform-rotate: 45deg;
  }

  .md\\:rotate-90{
    --transform-rotate: 90deg;
  }

  .md\\:rotate-180{
    --transform-rotate: 180deg;
  }

  .md\\:-rotate-180{
    --transform-rotate: -180deg;
  }

  .md\\:-rotate-90{
    --transform-rotate: -90deg;
  }

  .md\\:-rotate-45{
    --transform-rotate: -45deg;
  }

  .md\\:-rotate-12{
    --transform-rotate: -12deg;
  }

  .md\\:-rotate-6{
    --transform-rotate: -6deg;
  }

  .md\\:-rotate-3{
    --transform-rotate: -3deg;
  }

  .md\\:-rotate-2{
    --transform-rotate: -2deg;
  }

  .md\\:-rotate-1{
    --transform-rotate: -1deg;
  }

  .md\\:hover\\:rotate-0:hover{
    --transform-rotate: 0;
  }

  .md\\:hover\\:rotate-1:hover{
    --transform-rotate: 1deg;
  }

  .md\\:hover\\:rotate-2:hover{
    --transform-rotate: 2deg;
  }

  .md\\:hover\\:rotate-3:hover{
    --transform-rotate: 3deg;
  }

  .md\\:hover\\:rotate-6:hover{
    --transform-rotate: 6deg;
  }

  .md\\:hover\\:rotate-12:hover{
    --transform-rotate: 12deg;
  }

  .md\\:hover\\:rotate-45:hover{
    --transform-rotate: 45deg;
  }

  .md\\:hover\\:rotate-90:hover{
    --transform-rotate: 90deg;
  }

  .md\\:hover\\:rotate-180:hover{
    --transform-rotate: 180deg;
  }

  .md\\:hover\\:-rotate-180:hover{
    --transform-rotate: -180deg;
  }

  .md\\:hover\\:-rotate-90:hover{
    --transform-rotate: -90deg;
  }

  .md\\:hover\\:-rotate-45:hover{
    --transform-rotate: -45deg;
  }

  .md\\:hover\\:-rotate-12:hover{
    --transform-rotate: -12deg;
  }

  .md\\:hover\\:-rotate-6:hover{
    --transform-rotate: -6deg;
  }

  .md\\:hover\\:-rotate-3:hover{
    --transform-rotate: -3deg;
  }

  .md\\:hover\\:-rotate-2:hover{
    --transform-rotate: -2deg;
  }

  .md\\:hover\\:-rotate-1:hover{
    --transform-rotate: -1deg;
  }

  .md\\:focus\\:rotate-0:focus{
    --transform-rotate: 0;
  }

  .md\\:focus\\:rotate-1:focus{
    --transform-rotate: 1deg;
  }

  .md\\:focus\\:rotate-2:focus{
    --transform-rotate: 2deg;
  }

  .md\\:focus\\:rotate-3:focus{
    --transform-rotate: 3deg;
  }

  .md\\:focus\\:rotate-6:focus{
    --transform-rotate: 6deg;
  }

  .md\\:focus\\:rotate-12:focus{
    --transform-rotate: 12deg;
  }

  .md\\:focus\\:rotate-45:focus{
    --transform-rotate: 45deg;
  }

  .md\\:focus\\:rotate-90:focus{
    --transform-rotate: 90deg;
  }

  .md\\:focus\\:rotate-180:focus{
    --transform-rotate: 180deg;
  }

  .md\\:focus\\:-rotate-180:focus{
    --transform-rotate: -180deg;
  }

  .md\\:focus\\:-rotate-90:focus{
    --transform-rotate: -90deg;
  }

  .md\\:focus\\:-rotate-45:focus{
    --transform-rotate: -45deg;
  }

  .md\\:focus\\:-rotate-12:focus{
    --transform-rotate: -12deg;
  }

  .md\\:focus\\:-rotate-6:focus{
    --transform-rotate: -6deg;
  }

  .md\\:focus\\:-rotate-3:focus{
    --transform-rotate: -3deg;
  }

  .md\\:focus\\:-rotate-2:focus{
    --transform-rotate: -2deg;
  }

  .md\\:focus\\:-rotate-1:focus{
    --transform-rotate: -1deg;
  }

  .md\\:translate-x-0{
    --transform-translate-x: 0;
  }

  .md\\:translate-x-1{
    --transform-translate-x: 0.25rem;
  }

  .md\\:translate-x-2{
    --transform-translate-x: 0.5rem;
  }

  .md\\:translate-x-3{
    --transform-translate-x: 0.75rem;
  }

  .md\\:translate-x-4{
    --transform-translate-x: 1rem;
  }

  .md\\:translate-x-5{
    --transform-translate-x: 1.25rem;
  }

  .md\\:translate-x-6{
    --transform-translate-x: 1.5rem;
  }

  .md\\:translate-x-7{
    --transform-translate-x: 1.75rem;
  }

  .md\\:translate-x-8{
    --transform-translate-x: 2rem;
  }

  .md\\:translate-x-9{
    --transform-translate-x: 2.25rem;
  }

  .md\\:translate-x-10{
    --transform-translate-x: 2.5rem;
  }

  .md\\:translate-x-11{
    --transform-translate-x: 2.75rem;
  }

  .md\\:translate-x-12{
    --transform-translate-x: 3rem;
  }

  .md\\:translate-x-14{
    --transform-translate-x: 3.5rem;
  }

  .md\\:translate-x-15{
    --transform-translate-x: 3.75rem;
  }

  .md\\:translate-x-16{
    --transform-translate-x: 4rem;
  }

  .md\\:translate-x-18{
    --transform-translate-x: 4.5rem;
  }

  .md\\:translate-x-20{
    --transform-translate-x: 5rem;
  }

  .md\\:translate-x-22{
    --transform-translate-x: 5.5rem;
  }

  .md\\:translate-x-23{
    --transform-translate-x: 5.75rem;
  }

  .md\\:translate-x-24{
    --transform-translate-x: 6rem;
  }

  .md\\:translate-x-25{
    --transform-translate-x: 6.25rem;
  }

  .md\\:translate-x-26{
    --transform-translate-x: 6.5rem;
  }

  .md\\:translate-x-28{
    --transform-translate-x: 7rem;
  }

  .md\\:translate-x-30{
    --transform-translate-x: 7.5rem;
  }

  .md\\:translate-x-32{
    --transform-translate-x: 8rem;
  }

  .md\\:translate-x-34{
    --transform-translate-x: 8.5rem;
  }

  .md\\:translate-x-40{
    --transform-translate-x: 10rem;
  }

  .md\\:translate-x-42{
    --transform-translate-x: 10.5rem;
  }

  .md\\:translate-x-44{
    --transform-translate-x: 11rem;
  }

  .md\\:translate-x-48{
    --transform-translate-x: 12rem;
  }

  .md\\:translate-x-52{
    --transform-translate-x: 13rem;
  }

  .md\\:translate-x-54{
    --transform-translate-x: 13.5rem;
  }

  .md\\:translate-x-56{
    --transform-translate-x: 14rem;
  }

  .md\\:translate-x-60{
    --transform-translate-x: 15rem;
  }

  .md\\:translate-x-64{
    --transform-translate-x: 16rem;
  }

  .md\\:translate-x-68{
    --transform-translate-x: 17rem;
  }

  .md\\:translate-x-72{
    --transform-translate-x: 18rem;
  }

  .md\\:translate-x-74{
    --transform-translate-x: 18.5rem;
  }

  .md\\:translate-x-76{
    --transform-translate-x: 19rem;
  }

  .md\\:translate-x-78{
    --transform-translate-x: 19.5rem;
  }

  .md\\:translate-x-80{
    --transform-translate-x: 20rem;
  }

  .md\\:translate-x-82{
    --transform-translate-x: 20.5rem;
  }

  .md\\:translate-x-84{
    --transform-translate-x: 21rem;
  }

  .md\\:translate-x-88{
    --transform-translate-x: 22rem;
  }

  .md\\:translate-x-92{
    --transform-translate-x: 23rem;
  }

  .md\\:translate-x-96{
    --transform-translate-x: 24rem;
  }

  .md\\:translate-x-98{
    --transform-translate-x: 24.5rem;
  }

  .md\\:translate-x-100{
    --transform-translate-x: 25rem;
  }

  .md\\:translate-x-104{
    --transform-translate-x: 26rem;
  }

  .md\\:translate-x-112{
    --transform-translate-x: 28rem;
  }

  .md\\:translate-x-124{
    --transform-translate-x: 31rem;
  }

  .md\\:translate-x-128{
    --transform-translate-x: 32rem;
  }

  .md\\:translate-x-140{
    --transform-translate-x: 35rem;
  }

  .md\\:translate-x-152{
    --transform-translate-x: 38rem;
  }

  .md\\:translate-x-160{
    --transform-translate-x: 40rem;
  }

  .md\\:translate-x-162{
    --transform-translate-x: 41rem;
  }

  .md\\:translate-x-192{
    --transform-translate-x: 48rem;
  }

  .md\\:translate-x-208{
    --transform-translate-x: 52rem;
  }

  .md\\:translate-x-224{
    --transform-translate-x: 56rem;
  }

  .md\\:translate-x-256{
    --transform-translate-x: 64rem;
  }

  .md\\:translate-x-px{
    --transform-translate-x: 1px;
  }

  .md\\:-translate-x-1{
    --transform-translate-x: -0.25rem;
  }

  .md\\:-translate-x-2{
    --transform-translate-x: -0.5rem;
  }

  .md\\:-translate-x-3{
    --transform-translate-x: -0.75rem;
  }

  .md\\:-translate-x-4{
    --transform-translate-x: -1rem;
  }

  .md\\:-translate-x-5{
    --transform-translate-x: -1.25rem;
  }

  .md\\:-translate-x-6{
    --transform-translate-x: -1.5rem;
  }

  .md\\:-translate-x-7{
    --transform-translate-x: -1.75rem;
  }

  .md\\:-translate-x-8{
    --transform-translate-x: -2rem;
  }

  .md\\:-translate-x-9{
    --transform-translate-x: -2.25rem;
  }

  .md\\:-translate-x-10{
    --transform-translate-x: -2.5rem;
  }

  .md\\:-translate-x-11{
    --transform-translate-x: -2.75rem;
  }

  .md\\:-translate-x-12{
    --transform-translate-x: -3rem;
  }

  .md\\:-translate-x-14{
    --transform-translate-x: -3.5rem;
  }

  .md\\:-translate-x-15{
    --transform-translate-x: -3.75rem;
  }

  .md\\:-translate-x-16{
    --transform-translate-x: -4rem;
  }

  .md\\:-translate-x-18{
    --transform-translate-x: -4.5rem;
  }

  .md\\:-translate-x-20{
    --transform-translate-x: -5rem;
  }

  .md\\:-translate-x-22{
    --transform-translate-x: -5.5rem;
  }

  .md\\:-translate-x-23{
    --transform-translate-x: -5.75rem;
  }

  .md\\:-translate-x-24{
    --transform-translate-x: -6rem;
  }

  .md\\:-translate-x-25{
    --transform-translate-x: -6.25rem;
  }

  .md\\:-translate-x-26{
    --transform-translate-x: -6.5rem;
  }

  .md\\:-translate-x-28{
    --transform-translate-x: -7rem;
  }

  .md\\:-translate-x-30{
    --transform-translate-x: -7.5rem;
  }

  .md\\:-translate-x-32{
    --transform-translate-x: -8rem;
  }

  .md\\:-translate-x-34{
    --transform-translate-x: -8.5rem;
  }

  .md\\:-translate-x-40{
    --transform-translate-x: -10rem;
  }

  .md\\:-translate-x-42{
    --transform-translate-x: -10.5rem;
  }

  .md\\:-translate-x-44{
    --transform-translate-x: -11rem;
  }

  .md\\:-translate-x-48{
    --transform-translate-x: -12rem;
  }

  .md\\:-translate-x-52{
    --transform-translate-x: -13rem;
  }

  .md\\:-translate-x-54{
    --transform-translate-x: -13.5rem;
  }

  .md\\:-translate-x-56{
    --transform-translate-x: -14rem;
  }

  .md\\:-translate-x-60{
    --transform-translate-x: -15rem;
  }

  .md\\:-translate-x-64{
    --transform-translate-x: -16rem;
  }

  .md\\:-translate-x-68{
    --transform-translate-x: -17rem;
  }

  .md\\:-translate-x-72{
    --transform-translate-x: -18rem;
  }

  .md\\:-translate-x-74{
    --transform-translate-x: -18.5rem;
  }

  .md\\:-translate-x-76{
    --transform-translate-x: -19rem;
  }

  .md\\:-translate-x-78{
    --transform-translate-x: -19.5rem;
  }

  .md\\:-translate-x-80{
    --transform-translate-x: -20rem;
  }

  .md\\:-translate-x-82{
    --transform-translate-x: -20.5rem;
  }

  .md\\:-translate-x-84{
    --transform-translate-x: -21rem;
  }

  .md\\:-translate-x-88{
    --transform-translate-x: -22rem;
  }

  .md\\:-translate-x-92{
    --transform-translate-x: -23rem;
  }

  .md\\:-translate-x-96{
    --transform-translate-x: -24rem;
  }

  .md\\:-translate-x-98{
    --transform-translate-x: -24.5rem;
  }

  .md\\:-translate-x-100{
    --transform-translate-x: -25rem;
  }

  .md\\:-translate-x-104{
    --transform-translate-x: -26rem;
  }

  .md\\:-translate-x-112{
    --transform-translate-x: -28rem;
  }

  .md\\:-translate-x-124{
    --transform-translate-x: -31rem;
  }

  .md\\:-translate-x-128{
    --transform-translate-x: -32rem;
  }

  .md\\:-translate-x-140{
    --transform-translate-x: -35rem;
  }

  .md\\:-translate-x-152{
    --transform-translate-x: -38rem;
  }

  .md\\:-translate-x-160{
    --transform-translate-x: -40rem;
  }

  .md\\:-translate-x-162{
    --transform-translate-x: -41rem;
  }

  .md\\:-translate-x-192{
    --transform-translate-x: -48rem;
  }

  .md\\:-translate-x-208{
    --transform-translate-x: -52rem;
  }

  .md\\:-translate-x-224{
    --transform-translate-x: -56rem;
  }

  .md\\:-translate-x-256{
    --transform-translate-x: -64rem;
  }

  .md\\:-translate-x-px{
    --transform-translate-x: -1px;
  }

  .md\\:-translate-x-full{
    --transform-translate-x: -100%;
  }

  .md\\:-translate-x-1\\/2{
    --transform-translate-x: -50%;
  }

  .md\\:translate-x-1\\/2{
    --transform-translate-x: 50%;
  }

  .md\\:translate-x-full{
    --transform-translate-x: 100%;
  }

  .md\\:translate-y-0{
    --transform-translate-y: 0;
  }

  .md\\:translate-y-1{
    --transform-translate-y: 0.25rem;
  }

  .md\\:translate-y-2{
    --transform-translate-y: 0.5rem;
  }

  .md\\:translate-y-3{
    --transform-translate-y: 0.75rem;
  }

  .md\\:translate-y-4{
    --transform-translate-y: 1rem;
  }

  .md\\:translate-y-5{
    --transform-translate-y: 1.25rem;
  }

  .md\\:translate-y-6{
    --transform-translate-y: 1.5rem;
  }

  .md\\:translate-y-7{
    --transform-translate-y: 1.75rem;
  }

  .md\\:translate-y-8{
    --transform-translate-y: 2rem;
  }

  .md\\:translate-y-9{
    --transform-translate-y: 2.25rem;
  }

  .md\\:translate-y-10{
    --transform-translate-y: 2.5rem;
  }

  .md\\:translate-y-11{
    --transform-translate-y: 2.75rem;
  }

  .md\\:translate-y-12{
    --transform-translate-y: 3rem;
  }

  .md\\:translate-y-14{
    --transform-translate-y: 3.5rem;
  }

  .md\\:translate-y-15{
    --transform-translate-y: 3.75rem;
  }

  .md\\:translate-y-16{
    --transform-translate-y: 4rem;
  }

  .md\\:translate-y-18{
    --transform-translate-y: 4.5rem;
  }

  .md\\:translate-y-20{
    --transform-translate-y: 5rem;
  }

  .md\\:translate-y-22{
    --transform-translate-y: 5.5rem;
  }

  .md\\:translate-y-23{
    --transform-translate-y: 5.75rem;
  }

  .md\\:translate-y-24{
    --transform-translate-y: 6rem;
  }

  .md\\:translate-y-25{
    --transform-translate-y: 6.25rem;
  }

  .md\\:translate-y-26{
    --transform-translate-y: 6.5rem;
  }

  .md\\:translate-y-28{
    --transform-translate-y: 7rem;
  }

  .md\\:translate-y-30{
    --transform-translate-y: 7.5rem;
  }

  .md\\:translate-y-32{
    --transform-translate-y: 8rem;
  }

  .md\\:translate-y-34{
    --transform-translate-y: 8.5rem;
  }

  .md\\:translate-y-40{
    --transform-translate-y: 10rem;
  }

  .md\\:translate-y-42{
    --transform-translate-y: 10.5rem;
  }

  .md\\:translate-y-44{
    --transform-translate-y: 11rem;
  }

  .md\\:translate-y-48{
    --transform-translate-y: 12rem;
  }

  .md\\:translate-y-52{
    --transform-translate-y: 13rem;
  }

  .md\\:translate-y-54{
    --transform-translate-y: 13.5rem;
  }

  .md\\:translate-y-56{
    --transform-translate-y: 14rem;
  }

  .md\\:translate-y-60{
    --transform-translate-y: 15rem;
  }

  .md\\:translate-y-64{
    --transform-translate-y: 16rem;
  }

  .md\\:translate-y-68{
    --transform-translate-y: 17rem;
  }

  .md\\:translate-y-72{
    --transform-translate-y: 18rem;
  }

  .md\\:translate-y-74{
    --transform-translate-y: 18.5rem;
  }

  .md\\:translate-y-76{
    --transform-translate-y: 19rem;
  }

  .md\\:translate-y-78{
    --transform-translate-y: 19.5rem;
  }

  .md\\:translate-y-80{
    --transform-translate-y: 20rem;
  }

  .md\\:translate-y-82{
    --transform-translate-y: 20.5rem;
  }

  .md\\:translate-y-84{
    --transform-translate-y: 21rem;
  }

  .md\\:translate-y-88{
    --transform-translate-y: 22rem;
  }

  .md\\:translate-y-92{
    --transform-translate-y: 23rem;
  }

  .md\\:translate-y-96{
    --transform-translate-y: 24rem;
  }

  .md\\:translate-y-98{
    --transform-translate-y: 24.5rem;
  }

  .md\\:translate-y-100{
    --transform-translate-y: 25rem;
  }

  .md\\:translate-y-104{
    --transform-translate-y: 26rem;
  }

  .md\\:translate-y-112{
    --transform-translate-y: 28rem;
  }

  .md\\:translate-y-124{
    --transform-translate-y: 31rem;
  }

  .md\\:translate-y-128{
    --transform-translate-y: 32rem;
  }

  .md\\:translate-y-140{
    --transform-translate-y: 35rem;
  }

  .md\\:translate-y-152{
    --transform-translate-y: 38rem;
  }

  .md\\:translate-y-160{
    --transform-translate-y: 40rem;
  }

  .md\\:translate-y-162{
    --transform-translate-y: 41rem;
  }

  .md\\:translate-y-192{
    --transform-translate-y: 48rem;
  }

  .md\\:translate-y-208{
    --transform-translate-y: 52rem;
  }

  .md\\:translate-y-224{
    --transform-translate-y: 56rem;
  }

  .md\\:translate-y-256{
    --transform-translate-y: 64rem;
  }

  .md\\:translate-y-px{
    --transform-translate-y: 1px;
  }

  .md\\:-translate-y-1{
    --transform-translate-y: -0.25rem;
  }

  .md\\:-translate-y-2{
    --transform-translate-y: -0.5rem;
  }

  .md\\:-translate-y-3{
    --transform-translate-y: -0.75rem;
  }

  .md\\:-translate-y-4{
    --transform-translate-y: -1rem;
  }

  .md\\:-translate-y-5{
    --transform-translate-y: -1.25rem;
  }

  .md\\:-translate-y-6{
    --transform-translate-y: -1.5rem;
  }

  .md\\:-translate-y-7{
    --transform-translate-y: -1.75rem;
  }

  .md\\:-translate-y-8{
    --transform-translate-y: -2rem;
  }

  .md\\:-translate-y-9{
    --transform-translate-y: -2.25rem;
  }

  .md\\:-translate-y-10{
    --transform-translate-y: -2.5rem;
  }

  .md\\:-translate-y-11{
    --transform-translate-y: -2.75rem;
  }

  .md\\:-translate-y-12{
    --transform-translate-y: -3rem;
  }

  .md\\:-translate-y-14{
    --transform-translate-y: -3.5rem;
  }

  .md\\:-translate-y-15{
    --transform-translate-y: -3.75rem;
  }

  .md\\:-translate-y-16{
    --transform-translate-y: -4rem;
  }

  .md\\:-translate-y-18{
    --transform-translate-y: -4.5rem;
  }

  .md\\:-translate-y-20{
    --transform-translate-y: -5rem;
  }

  .md\\:-translate-y-22{
    --transform-translate-y: -5.5rem;
  }

  .md\\:-translate-y-23{
    --transform-translate-y: -5.75rem;
  }

  .md\\:-translate-y-24{
    --transform-translate-y: -6rem;
  }

  .md\\:-translate-y-25{
    --transform-translate-y: -6.25rem;
  }

  .md\\:-translate-y-26{
    --transform-translate-y: -6.5rem;
  }

  .md\\:-translate-y-28{
    --transform-translate-y: -7rem;
  }

  .md\\:-translate-y-30{
    --transform-translate-y: -7.5rem;
  }

  .md\\:-translate-y-32{
    --transform-translate-y: -8rem;
  }

  .md\\:-translate-y-34{
    --transform-translate-y: -8.5rem;
  }

  .md\\:-translate-y-40{
    --transform-translate-y: -10rem;
  }

  .md\\:-translate-y-42{
    --transform-translate-y: -10.5rem;
  }

  .md\\:-translate-y-44{
    --transform-translate-y: -11rem;
  }

  .md\\:-translate-y-48{
    --transform-translate-y: -12rem;
  }

  .md\\:-translate-y-52{
    --transform-translate-y: -13rem;
  }

  .md\\:-translate-y-54{
    --transform-translate-y: -13.5rem;
  }

  .md\\:-translate-y-56{
    --transform-translate-y: -14rem;
  }

  .md\\:-translate-y-60{
    --transform-translate-y: -15rem;
  }

  .md\\:-translate-y-64{
    --transform-translate-y: -16rem;
  }

  .md\\:-translate-y-68{
    --transform-translate-y: -17rem;
  }

  .md\\:-translate-y-72{
    --transform-translate-y: -18rem;
  }

  .md\\:-translate-y-74{
    --transform-translate-y: -18.5rem;
  }

  .md\\:-translate-y-76{
    --transform-translate-y: -19rem;
  }

  .md\\:-translate-y-78{
    --transform-translate-y: -19.5rem;
  }

  .md\\:-translate-y-80{
    --transform-translate-y: -20rem;
  }

  .md\\:-translate-y-82{
    --transform-translate-y: -20.5rem;
  }

  .md\\:-translate-y-84{
    --transform-translate-y: -21rem;
  }

  .md\\:-translate-y-88{
    --transform-translate-y: -22rem;
  }

  .md\\:-translate-y-92{
    --transform-translate-y: -23rem;
  }

  .md\\:-translate-y-96{
    --transform-translate-y: -24rem;
  }

  .md\\:-translate-y-98{
    --transform-translate-y: -24.5rem;
  }

  .md\\:-translate-y-100{
    --transform-translate-y: -25rem;
  }

  .md\\:-translate-y-104{
    --transform-translate-y: -26rem;
  }

  .md\\:-translate-y-112{
    --transform-translate-y: -28rem;
  }

  .md\\:-translate-y-124{
    --transform-translate-y: -31rem;
  }

  .md\\:-translate-y-128{
    --transform-translate-y: -32rem;
  }

  .md\\:-translate-y-140{
    --transform-translate-y: -35rem;
  }

  .md\\:-translate-y-152{
    --transform-translate-y: -38rem;
  }

  .md\\:-translate-y-160{
    --transform-translate-y: -40rem;
  }

  .md\\:-translate-y-162{
    --transform-translate-y: -41rem;
  }

  .md\\:-translate-y-192{
    --transform-translate-y: -48rem;
  }

  .md\\:-translate-y-208{
    --transform-translate-y: -52rem;
  }

  .md\\:-translate-y-224{
    --transform-translate-y: -56rem;
  }

  .md\\:-translate-y-256{
    --transform-translate-y: -64rem;
  }

  .md\\:-translate-y-px{
    --transform-translate-y: -1px;
  }

  .md\\:-translate-y-full{
    --transform-translate-y: -100%;
  }

  .md\\:-translate-y-1\\/2{
    --transform-translate-y: -50%;
  }

  .md\\:translate-y-1\\/2{
    --transform-translate-y: 50%;
  }

  .md\\:translate-y-full{
    --transform-translate-y: 100%;
  }

  .md\\:hover\\:translate-x-0:hover{
    --transform-translate-x: 0;
  }

  .md\\:hover\\:translate-x-1:hover{
    --transform-translate-x: 0.25rem;
  }

  .md\\:hover\\:translate-x-2:hover{
    --transform-translate-x: 0.5rem;
  }

  .md\\:hover\\:translate-x-3:hover{
    --transform-translate-x: 0.75rem;
  }

  .md\\:hover\\:translate-x-4:hover{
    --transform-translate-x: 1rem;
  }

  .md\\:hover\\:translate-x-5:hover{
    --transform-translate-x: 1.25rem;
  }

  .md\\:hover\\:translate-x-6:hover{
    --transform-translate-x: 1.5rem;
  }

  .md\\:hover\\:translate-x-7:hover{
    --transform-translate-x: 1.75rem;
  }

  .md\\:hover\\:translate-x-8:hover{
    --transform-translate-x: 2rem;
  }

  .md\\:hover\\:translate-x-9:hover{
    --transform-translate-x: 2.25rem;
  }

  .md\\:hover\\:translate-x-10:hover{
    --transform-translate-x: 2.5rem;
  }

  .md\\:hover\\:translate-x-11:hover{
    --transform-translate-x: 2.75rem;
  }

  .md\\:hover\\:translate-x-12:hover{
    --transform-translate-x: 3rem;
  }

  .md\\:hover\\:translate-x-14:hover{
    --transform-translate-x: 3.5rem;
  }

  .md\\:hover\\:translate-x-15:hover{
    --transform-translate-x: 3.75rem;
  }

  .md\\:hover\\:translate-x-16:hover{
    --transform-translate-x: 4rem;
  }

  .md\\:hover\\:translate-x-18:hover{
    --transform-translate-x: 4.5rem;
  }

  .md\\:hover\\:translate-x-20:hover{
    --transform-translate-x: 5rem;
  }

  .md\\:hover\\:translate-x-22:hover{
    --transform-translate-x: 5.5rem;
  }

  .md\\:hover\\:translate-x-23:hover{
    --transform-translate-x: 5.75rem;
  }

  .md\\:hover\\:translate-x-24:hover{
    --transform-translate-x: 6rem;
  }

  .md\\:hover\\:translate-x-25:hover{
    --transform-translate-x: 6.25rem;
  }

  .md\\:hover\\:translate-x-26:hover{
    --transform-translate-x: 6.5rem;
  }

  .md\\:hover\\:translate-x-28:hover{
    --transform-translate-x: 7rem;
  }

  .md\\:hover\\:translate-x-30:hover{
    --transform-translate-x: 7.5rem;
  }

  .md\\:hover\\:translate-x-32:hover{
    --transform-translate-x: 8rem;
  }

  .md\\:hover\\:translate-x-34:hover{
    --transform-translate-x: 8.5rem;
  }

  .md\\:hover\\:translate-x-40:hover{
    --transform-translate-x: 10rem;
  }

  .md\\:hover\\:translate-x-42:hover{
    --transform-translate-x: 10.5rem;
  }

  .md\\:hover\\:translate-x-44:hover{
    --transform-translate-x: 11rem;
  }

  .md\\:hover\\:translate-x-48:hover{
    --transform-translate-x: 12rem;
  }

  .md\\:hover\\:translate-x-52:hover{
    --transform-translate-x: 13rem;
  }

  .md\\:hover\\:translate-x-54:hover{
    --transform-translate-x: 13.5rem;
  }

  .md\\:hover\\:translate-x-56:hover{
    --transform-translate-x: 14rem;
  }

  .md\\:hover\\:translate-x-60:hover{
    --transform-translate-x: 15rem;
  }

  .md\\:hover\\:translate-x-64:hover{
    --transform-translate-x: 16rem;
  }

  .md\\:hover\\:translate-x-68:hover{
    --transform-translate-x: 17rem;
  }

  .md\\:hover\\:translate-x-72:hover{
    --transform-translate-x: 18rem;
  }

  .md\\:hover\\:translate-x-74:hover{
    --transform-translate-x: 18.5rem;
  }

  .md\\:hover\\:translate-x-76:hover{
    --transform-translate-x: 19rem;
  }

  .md\\:hover\\:translate-x-78:hover{
    --transform-translate-x: 19.5rem;
  }

  .md\\:hover\\:translate-x-80:hover{
    --transform-translate-x: 20rem;
  }

  .md\\:hover\\:translate-x-82:hover{
    --transform-translate-x: 20.5rem;
  }

  .md\\:hover\\:translate-x-84:hover{
    --transform-translate-x: 21rem;
  }

  .md\\:hover\\:translate-x-88:hover{
    --transform-translate-x: 22rem;
  }

  .md\\:hover\\:translate-x-92:hover{
    --transform-translate-x: 23rem;
  }

  .md\\:hover\\:translate-x-96:hover{
    --transform-translate-x: 24rem;
  }

  .md\\:hover\\:translate-x-98:hover{
    --transform-translate-x: 24.5rem;
  }

  .md\\:hover\\:translate-x-100:hover{
    --transform-translate-x: 25rem;
  }

  .md\\:hover\\:translate-x-104:hover{
    --transform-translate-x: 26rem;
  }

  .md\\:hover\\:translate-x-112:hover{
    --transform-translate-x: 28rem;
  }

  .md\\:hover\\:translate-x-124:hover{
    --transform-translate-x: 31rem;
  }

  .md\\:hover\\:translate-x-128:hover{
    --transform-translate-x: 32rem;
  }

  .md\\:hover\\:translate-x-140:hover{
    --transform-translate-x: 35rem;
  }

  .md\\:hover\\:translate-x-152:hover{
    --transform-translate-x: 38rem;
  }

  .md\\:hover\\:translate-x-160:hover{
    --transform-translate-x: 40rem;
  }

  .md\\:hover\\:translate-x-162:hover{
    --transform-translate-x: 41rem;
  }

  .md\\:hover\\:translate-x-192:hover{
    --transform-translate-x: 48rem;
  }

  .md\\:hover\\:translate-x-208:hover{
    --transform-translate-x: 52rem;
  }

  .md\\:hover\\:translate-x-224:hover{
    --transform-translate-x: 56rem;
  }

  .md\\:hover\\:translate-x-256:hover{
    --transform-translate-x: 64rem;
  }

  .md\\:hover\\:translate-x-px:hover{
    --transform-translate-x: 1px;
  }

  .md\\:hover\\:-translate-x-1:hover{
    --transform-translate-x: -0.25rem;
  }

  .md\\:hover\\:-translate-x-2:hover{
    --transform-translate-x: -0.5rem;
  }

  .md\\:hover\\:-translate-x-3:hover{
    --transform-translate-x: -0.75rem;
  }

  .md\\:hover\\:-translate-x-4:hover{
    --transform-translate-x: -1rem;
  }

  .md\\:hover\\:-translate-x-5:hover{
    --transform-translate-x: -1.25rem;
  }

  .md\\:hover\\:-translate-x-6:hover{
    --transform-translate-x: -1.5rem;
  }

  .md\\:hover\\:-translate-x-7:hover{
    --transform-translate-x: -1.75rem;
  }

  .md\\:hover\\:-translate-x-8:hover{
    --transform-translate-x: -2rem;
  }

  .md\\:hover\\:-translate-x-9:hover{
    --transform-translate-x: -2.25rem;
  }

  .md\\:hover\\:-translate-x-10:hover{
    --transform-translate-x: -2.5rem;
  }

  .md\\:hover\\:-translate-x-11:hover{
    --transform-translate-x: -2.75rem;
  }

  .md\\:hover\\:-translate-x-12:hover{
    --transform-translate-x: -3rem;
  }

  .md\\:hover\\:-translate-x-14:hover{
    --transform-translate-x: -3.5rem;
  }

  .md\\:hover\\:-translate-x-15:hover{
    --transform-translate-x: -3.75rem;
  }

  .md\\:hover\\:-translate-x-16:hover{
    --transform-translate-x: -4rem;
  }

  .md\\:hover\\:-translate-x-18:hover{
    --transform-translate-x: -4.5rem;
  }

  .md\\:hover\\:-translate-x-20:hover{
    --transform-translate-x: -5rem;
  }

  .md\\:hover\\:-translate-x-22:hover{
    --transform-translate-x: -5.5rem;
  }

  .md\\:hover\\:-translate-x-23:hover{
    --transform-translate-x: -5.75rem;
  }

  .md\\:hover\\:-translate-x-24:hover{
    --transform-translate-x: -6rem;
  }

  .md\\:hover\\:-translate-x-25:hover{
    --transform-translate-x: -6.25rem;
  }

  .md\\:hover\\:-translate-x-26:hover{
    --transform-translate-x: -6.5rem;
  }

  .md\\:hover\\:-translate-x-28:hover{
    --transform-translate-x: -7rem;
  }

  .md\\:hover\\:-translate-x-30:hover{
    --transform-translate-x: -7.5rem;
  }

  .md\\:hover\\:-translate-x-32:hover{
    --transform-translate-x: -8rem;
  }

  .md\\:hover\\:-translate-x-34:hover{
    --transform-translate-x: -8.5rem;
  }

  .md\\:hover\\:-translate-x-40:hover{
    --transform-translate-x: -10rem;
  }

  .md\\:hover\\:-translate-x-42:hover{
    --transform-translate-x: -10.5rem;
  }

  .md\\:hover\\:-translate-x-44:hover{
    --transform-translate-x: -11rem;
  }

  .md\\:hover\\:-translate-x-48:hover{
    --transform-translate-x: -12rem;
  }

  .md\\:hover\\:-translate-x-52:hover{
    --transform-translate-x: -13rem;
  }

  .md\\:hover\\:-translate-x-54:hover{
    --transform-translate-x: -13.5rem;
  }

  .md\\:hover\\:-translate-x-56:hover{
    --transform-translate-x: -14rem;
  }

  .md\\:hover\\:-translate-x-60:hover{
    --transform-translate-x: -15rem;
  }

  .md\\:hover\\:-translate-x-64:hover{
    --transform-translate-x: -16rem;
  }

  .md\\:hover\\:-translate-x-68:hover{
    --transform-translate-x: -17rem;
  }

  .md\\:hover\\:-translate-x-72:hover{
    --transform-translate-x: -18rem;
  }

  .md\\:hover\\:-translate-x-74:hover{
    --transform-translate-x: -18.5rem;
  }

  .md\\:hover\\:-translate-x-76:hover{
    --transform-translate-x: -19rem;
  }

  .md\\:hover\\:-translate-x-78:hover{
    --transform-translate-x: -19.5rem;
  }

  .md\\:hover\\:-translate-x-80:hover{
    --transform-translate-x: -20rem;
  }

  .md\\:hover\\:-translate-x-82:hover{
    --transform-translate-x: -20.5rem;
  }

  .md\\:hover\\:-translate-x-84:hover{
    --transform-translate-x: -21rem;
  }

  .md\\:hover\\:-translate-x-88:hover{
    --transform-translate-x: -22rem;
  }

  .md\\:hover\\:-translate-x-92:hover{
    --transform-translate-x: -23rem;
  }

  .md\\:hover\\:-translate-x-96:hover{
    --transform-translate-x: -24rem;
  }

  .md\\:hover\\:-translate-x-98:hover{
    --transform-translate-x: -24.5rem;
  }

  .md\\:hover\\:-translate-x-100:hover{
    --transform-translate-x: -25rem;
  }

  .md\\:hover\\:-translate-x-104:hover{
    --transform-translate-x: -26rem;
  }

  .md\\:hover\\:-translate-x-112:hover{
    --transform-translate-x: -28rem;
  }

  .md\\:hover\\:-translate-x-124:hover{
    --transform-translate-x: -31rem;
  }

  .md\\:hover\\:-translate-x-128:hover{
    --transform-translate-x: -32rem;
  }

  .md\\:hover\\:-translate-x-140:hover{
    --transform-translate-x: -35rem;
  }

  .md\\:hover\\:-translate-x-152:hover{
    --transform-translate-x: -38rem;
  }

  .md\\:hover\\:-translate-x-160:hover{
    --transform-translate-x: -40rem;
  }

  .md\\:hover\\:-translate-x-162:hover{
    --transform-translate-x: -41rem;
  }

  .md\\:hover\\:-translate-x-192:hover{
    --transform-translate-x: -48rem;
  }

  .md\\:hover\\:-translate-x-208:hover{
    --transform-translate-x: -52rem;
  }

  .md\\:hover\\:-translate-x-224:hover{
    --transform-translate-x: -56rem;
  }

  .md\\:hover\\:-translate-x-256:hover{
    --transform-translate-x: -64rem;
  }

  .md\\:hover\\:-translate-x-px:hover{
    --transform-translate-x: -1px;
  }

  .md\\:hover\\:-translate-x-full:hover{
    --transform-translate-x: -100%;
  }

  .md\\:hover\\:-translate-x-1\\/2:hover{
    --transform-translate-x: -50%;
  }

  .md\\:hover\\:translate-x-1\\/2:hover{
    --transform-translate-x: 50%;
  }

  .md\\:hover\\:translate-x-full:hover{
    --transform-translate-x: 100%;
  }

  .md\\:hover\\:translate-y-0:hover{
    --transform-translate-y: 0;
  }

  .md\\:hover\\:translate-y-1:hover{
    --transform-translate-y: 0.25rem;
  }

  .md\\:hover\\:translate-y-2:hover{
    --transform-translate-y: 0.5rem;
  }

  .md\\:hover\\:translate-y-3:hover{
    --transform-translate-y: 0.75rem;
  }

  .md\\:hover\\:translate-y-4:hover{
    --transform-translate-y: 1rem;
  }

  .md\\:hover\\:translate-y-5:hover{
    --transform-translate-y: 1.25rem;
  }

  .md\\:hover\\:translate-y-6:hover{
    --transform-translate-y: 1.5rem;
  }

  .md\\:hover\\:translate-y-7:hover{
    --transform-translate-y: 1.75rem;
  }

  .md\\:hover\\:translate-y-8:hover{
    --transform-translate-y: 2rem;
  }

  .md\\:hover\\:translate-y-9:hover{
    --transform-translate-y: 2.25rem;
  }

  .md\\:hover\\:translate-y-10:hover{
    --transform-translate-y: 2.5rem;
  }

  .md\\:hover\\:translate-y-11:hover{
    --transform-translate-y: 2.75rem;
  }

  .md\\:hover\\:translate-y-12:hover{
    --transform-translate-y: 3rem;
  }

  .md\\:hover\\:translate-y-14:hover{
    --transform-translate-y: 3.5rem;
  }

  .md\\:hover\\:translate-y-15:hover{
    --transform-translate-y: 3.75rem;
  }

  .md\\:hover\\:translate-y-16:hover{
    --transform-translate-y: 4rem;
  }

  .md\\:hover\\:translate-y-18:hover{
    --transform-translate-y: 4.5rem;
  }

  .md\\:hover\\:translate-y-20:hover{
    --transform-translate-y: 5rem;
  }

  .md\\:hover\\:translate-y-22:hover{
    --transform-translate-y: 5.5rem;
  }

  .md\\:hover\\:translate-y-23:hover{
    --transform-translate-y: 5.75rem;
  }

  .md\\:hover\\:translate-y-24:hover{
    --transform-translate-y: 6rem;
  }

  .md\\:hover\\:translate-y-25:hover{
    --transform-translate-y: 6.25rem;
  }

  .md\\:hover\\:translate-y-26:hover{
    --transform-translate-y: 6.5rem;
  }

  .md\\:hover\\:translate-y-28:hover{
    --transform-translate-y: 7rem;
  }

  .md\\:hover\\:translate-y-30:hover{
    --transform-translate-y: 7.5rem;
  }

  .md\\:hover\\:translate-y-32:hover{
    --transform-translate-y: 8rem;
  }

  .md\\:hover\\:translate-y-34:hover{
    --transform-translate-y: 8.5rem;
  }

  .md\\:hover\\:translate-y-40:hover{
    --transform-translate-y: 10rem;
  }

  .md\\:hover\\:translate-y-42:hover{
    --transform-translate-y: 10.5rem;
  }

  .md\\:hover\\:translate-y-44:hover{
    --transform-translate-y: 11rem;
  }

  .md\\:hover\\:translate-y-48:hover{
    --transform-translate-y: 12rem;
  }

  .md\\:hover\\:translate-y-52:hover{
    --transform-translate-y: 13rem;
  }

  .md\\:hover\\:translate-y-54:hover{
    --transform-translate-y: 13.5rem;
  }

  .md\\:hover\\:translate-y-56:hover{
    --transform-translate-y: 14rem;
  }

  .md\\:hover\\:translate-y-60:hover{
    --transform-translate-y: 15rem;
  }

  .md\\:hover\\:translate-y-64:hover{
    --transform-translate-y: 16rem;
  }

  .md\\:hover\\:translate-y-68:hover{
    --transform-translate-y: 17rem;
  }

  .md\\:hover\\:translate-y-72:hover{
    --transform-translate-y: 18rem;
  }

  .md\\:hover\\:translate-y-74:hover{
    --transform-translate-y: 18.5rem;
  }

  .md\\:hover\\:translate-y-76:hover{
    --transform-translate-y: 19rem;
  }

  .md\\:hover\\:translate-y-78:hover{
    --transform-translate-y: 19.5rem;
  }

  .md\\:hover\\:translate-y-80:hover{
    --transform-translate-y: 20rem;
  }

  .md\\:hover\\:translate-y-82:hover{
    --transform-translate-y: 20.5rem;
  }

  .md\\:hover\\:translate-y-84:hover{
    --transform-translate-y: 21rem;
  }

  .md\\:hover\\:translate-y-88:hover{
    --transform-translate-y: 22rem;
  }

  .md\\:hover\\:translate-y-92:hover{
    --transform-translate-y: 23rem;
  }

  .md\\:hover\\:translate-y-96:hover{
    --transform-translate-y: 24rem;
  }

  .md\\:hover\\:translate-y-98:hover{
    --transform-translate-y: 24.5rem;
  }

  .md\\:hover\\:translate-y-100:hover{
    --transform-translate-y: 25rem;
  }

  .md\\:hover\\:translate-y-104:hover{
    --transform-translate-y: 26rem;
  }

  .md\\:hover\\:translate-y-112:hover{
    --transform-translate-y: 28rem;
  }

  .md\\:hover\\:translate-y-124:hover{
    --transform-translate-y: 31rem;
  }

  .md\\:hover\\:translate-y-128:hover{
    --transform-translate-y: 32rem;
  }

  .md\\:hover\\:translate-y-140:hover{
    --transform-translate-y: 35rem;
  }

  .md\\:hover\\:translate-y-152:hover{
    --transform-translate-y: 38rem;
  }

  .md\\:hover\\:translate-y-160:hover{
    --transform-translate-y: 40rem;
  }

  .md\\:hover\\:translate-y-162:hover{
    --transform-translate-y: 41rem;
  }

  .md\\:hover\\:translate-y-192:hover{
    --transform-translate-y: 48rem;
  }

  .md\\:hover\\:translate-y-208:hover{
    --transform-translate-y: 52rem;
  }

  .md\\:hover\\:translate-y-224:hover{
    --transform-translate-y: 56rem;
  }

  .md\\:hover\\:translate-y-256:hover{
    --transform-translate-y: 64rem;
  }

  .md\\:hover\\:translate-y-px:hover{
    --transform-translate-y: 1px;
  }

  .md\\:hover\\:-translate-y-1:hover{
    --transform-translate-y: -0.25rem;
  }

  .md\\:hover\\:-translate-y-2:hover{
    --transform-translate-y: -0.5rem;
  }

  .md\\:hover\\:-translate-y-3:hover{
    --transform-translate-y: -0.75rem;
  }

  .md\\:hover\\:-translate-y-4:hover{
    --transform-translate-y: -1rem;
  }

  .md\\:hover\\:-translate-y-5:hover{
    --transform-translate-y: -1.25rem;
  }

  .md\\:hover\\:-translate-y-6:hover{
    --transform-translate-y: -1.5rem;
  }

  .md\\:hover\\:-translate-y-7:hover{
    --transform-translate-y: -1.75rem;
  }

  .md\\:hover\\:-translate-y-8:hover{
    --transform-translate-y: -2rem;
  }

  .md\\:hover\\:-translate-y-9:hover{
    --transform-translate-y: -2.25rem;
  }

  .md\\:hover\\:-translate-y-10:hover{
    --transform-translate-y: -2.5rem;
  }

  .md\\:hover\\:-translate-y-11:hover{
    --transform-translate-y: -2.75rem;
  }

  .md\\:hover\\:-translate-y-12:hover{
    --transform-translate-y: -3rem;
  }

  .md\\:hover\\:-translate-y-14:hover{
    --transform-translate-y: -3.5rem;
  }

  .md\\:hover\\:-translate-y-15:hover{
    --transform-translate-y: -3.75rem;
  }

  .md\\:hover\\:-translate-y-16:hover{
    --transform-translate-y: -4rem;
  }

  .md\\:hover\\:-translate-y-18:hover{
    --transform-translate-y: -4.5rem;
  }

  .md\\:hover\\:-translate-y-20:hover{
    --transform-translate-y: -5rem;
  }

  .md\\:hover\\:-translate-y-22:hover{
    --transform-translate-y: -5.5rem;
  }

  .md\\:hover\\:-translate-y-23:hover{
    --transform-translate-y: -5.75rem;
  }

  .md\\:hover\\:-translate-y-24:hover{
    --transform-translate-y: -6rem;
  }

  .md\\:hover\\:-translate-y-25:hover{
    --transform-translate-y: -6.25rem;
  }

  .md\\:hover\\:-translate-y-26:hover{
    --transform-translate-y: -6.5rem;
  }

  .md\\:hover\\:-translate-y-28:hover{
    --transform-translate-y: -7rem;
  }

  .md\\:hover\\:-translate-y-30:hover{
    --transform-translate-y: -7.5rem;
  }

  .md\\:hover\\:-translate-y-32:hover{
    --transform-translate-y: -8rem;
  }

  .md\\:hover\\:-translate-y-34:hover{
    --transform-translate-y: -8.5rem;
  }

  .md\\:hover\\:-translate-y-40:hover{
    --transform-translate-y: -10rem;
  }

  .md\\:hover\\:-translate-y-42:hover{
    --transform-translate-y: -10.5rem;
  }

  .md\\:hover\\:-translate-y-44:hover{
    --transform-translate-y: -11rem;
  }

  .md\\:hover\\:-translate-y-48:hover{
    --transform-translate-y: -12rem;
  }

  .md\\:hover\\:-translate-y-52:hover{
    --transform-translate-y: -13rem;
  }

  .md\\:hover\\:-translate-y-54:hover{
    --transform-translate-y: -13.5rem;
  }

  .md\\:hover\\:-translate-y-56:hover{
    --transform-translate-y: -14rem;
  }

  .md\\:hover\\:-translate-y-60:hover{
    --transform-translate-y: -15rem;
  }

  .md\\:hover\\:-translate-y-64:hover{
    --transform-translate-y: -16rem;
  }

  .md\\:hover\\:-translate-y-68:hover{
    --transform-translate-y: -17rem;
  }

  .md\\:hover\\:-translate-y-72:hover{
    --transform-translate-y: -18rem;
  }

  .md\\:hover\\:-translate-y-74:hover{
    --transform-translate-y: -18.5rem;
  }

  .md\\:hover\\:-translate-y-76:hover{
    --transform-translate-y: -19rem;
  }

  .md\\:hover\\:-translate-y-78:hover{
    --transform-translate-y: -19.5rem;
  }

  .md\\:hover\\:-translate-y-80:hover{
    --transform-translate-y: -20rem;
  }

  .md\\:hover\\:-translate-y-82:hover{
    --transform-translate-y: -20.5rem;
  }

  .md\\:hover\\:-translate-y-84:hover{
    --transform-translate-y: -21rem;
  }

  .md\\:hover\\:-translate-y-88:hover{
    --transform-translate-y: -22rem;
  }

  .md\\:hover\\:-translate-y-92:hover{
    --transform-translate-y: -23rem;
  }

  .md\\:hover\\:-translate-y-96:hover{
    --transform-translate-y: -24rem;
  }

  .md\\:hover\\:-translate-y-98:hover{
    --transform-translate-y: -24.5rem;
  }

  .md\\:hover\\:-translate-y-100:hover{
    --transform-translate-y: -25rem;
  }

  .md\\:hover\\:-translate-y-104:hover{
    --transform-translate-y: -26rem;
  }

  .md\\:hover\\:-translate-y-112:hover{
    --transform-translate-y: -28rem;
  }

  .md\\:hover\\:-translate-y-124:hover{
    --transform-translate-y: -31rem;
  }

  .md\\:hover\\:-translate-y-128:hover{
    --transform-translate-y: -32rem;
  }

  .md\\:hover\\:-translate-y-140:hover{
    --transform-translate-y: -35rem;
  }

  .md\\:hover\\:-translate-y-152:hover{
    --transform-translate-y: -38rem;
  }

  .md\\:hover\\:-translate-y-160:hover{
    --transform-translate-y: -40rem;
  }

  .md\\:hover\\:-translate-y-162:hover{
    --transform-translate-y: -41rem;
  }

  .md\\:hover\\:-translate-y-192:hover{
    --transform-translate-y: -48rem;
  }

  .md\\:hover\\:-translate-y-208:hover{
    --transform-translate-y: -52rem;
  }

  .md\\:hover\\:-translate-y-224:hover{
    --transform-translate-y: -56rem;
  }

  .md\\:hover\\:-translate-y-256:hover{
    --transform-translate-y: -64rem;
  }

  .md\\:hover\\:-translate-y-px:hover{
    --transform-translate-y: -1px;
  }

  .md\\:hover\\:-translate-y-full:hover{
    --transform-translate-y: -100%;
  }

  .md\\:hover\\:-translate-y-1\\/2:hover{
    --transform-translate-y: -50%;
  }

  .md\\:hover\\:translate-y-1\\/2:hover{
    --transform-translate-y: 50%;
  }

  .md\\:hover\\:translate-y-full:hover{
    --transform-translate-y: 100%;
  }

  .md\\:focus\\:translate-x-0:focus{
    --transform-translate-x: 0;
  }

  .md\\:focus\\:translate-x-1:focus{
    --transform-translate-x: 0.25rem;
  }

  .md\\:focus\\:translate-x-2:focus{
    --transform-translate-x: 0.5rem;
  }

  .md\\:focus\\:translate-x-3:focus{
    --transform-translate-x: 0.75rem;
  }

  .md\\:focus\\:translate-x-4:focus{
    --transform-translate-x: 1rem;
  }

  .md\\:focus\\:translate-x-5:focus{
    --transform-translate-x: 1.25rem;
  }

  .md\\:focus\\:translate-x-6:focus{
    --transform-translate-x: 1.5rem;
  }

  .md\\:focus\\:translate-x-7:focus{
    --transform-translate-x: 1.75rem;
  }

  .md\\:focus\\:translate-x-8:focus{
    --transform-translate-x: 2rem;
  }

  .md\\:focus\\:translate-x-9:focus{
    --transform-translate-x: 2.25rem;
  }

  .md\\:focus\\:translate-x-10:focus{
    --transform-translate-x: 2.5rem;
  }

  .md\\:focus\\:translate-x-11:focus{
    --transform-translate-x: 2.75rem;
  }

  .md\\:focus\\:translate-x-12:focus{
    --transform-translate-x: 3rem;
  }

  .md\\:focus\\:translate-x-14:focus{
    --transform-translate-x: 3.5rem;
  }

  .md\\:focus\\:translate-x-15:focus{
    --transform-translate-x: 3.75rem;
  }

  .md\\:focus\\:translate-x-16:focus{
    --transform-translate-x: 4rem;
  }

  .md\\:focus\\:translate-x-18:focus{
    --transform-translate-x: 4.5rem;
  }

  .md\\:focus\\:translate-x-20:focus{
    --transform-translate-x: 5rem;
  }

  .md\\:focus\\:translate-x-22:focus{
    --transform-translate-x: 5.5rem;
  }

  .md\\:focus\\:translate-x-23:focus{
    --transform-translate-x: 5.75rem;
  }

  .md\\:focus\\:translate-x-24:focus{
    --transform-translate-x: 6rem;
  }

  .md\\:focus\\:translate-x-25:focus{
    --transform-translate-x: 6.25rem;
  }

  .md\\:focus\\:translate-x-26:focus{
    --transform-translate-x: 6.5rem;
  }

  .md\\:focus\\:translate-x-28:focus{
    --transform-translate-x: 7rem;
  }

  .md\\:focus\\:translate-x-30:focus{
    --transform-translate-x: 7.5rem;
  }

  .md\\:focus\\:translate-x-32:focus{
    --transform-translate-x: 8rem;
  }

  .md\\:focus\\:translate-x-34:focus{
    --transform-translate-x: 8.5rem;
  }

  .md\\:focus\\:translate-x-40:focus{
    --transform-translate-x: 10rem;
  }

  .md\\:focus\\:translate-x-42:focus{
    --transform-translate-x: 10.5rem;
  }

  .md\\:focus\\:translate-x-44:focus{
    --transform-translate-x: 11rem;
  }

  .md\\:focus\\:translate-x-48:focus{
    --transform-translate-x: 12rem;
  }

  .md\\:focus\\:translate-x-52:focus{
    --transform-translate-x: 13rem;
  }

  .md\\:focus\\:translate-x-54:focus{
    --transform-translate-x: 13.5rem;
  }

  .md\\:focus\\:translate-x-56:focus{
    --transform-translate-x: 14rem;
  }

  .md\\:focus\\:translate-x-60:focus{
    --transform-translate-x: 15rem;
  }

  .md\\:focus\\:translate-x-64:focus{
    --transform-translate-x: 16rem;
  }

  .md\\:focus\\:translate-x-68:focus{
    --transform-translate-x: 17rem;
  }

  .md\\:focus\\:translate-x-72:focus{
    --transform-translate-x: 18rem;
  }

  .md\\:focus\\:translate-x-74:focus{
    --transform-translate-x: 18.5rem;
  }

  .md\\:focus\\:translate-x-76:focus{
    --transform-translate-x: 19rem;
  }

  .md\\:focus\\:translate-x-78:focus{
    --transform-translate-x: 19.5rem;
  }

  .md\\:focus\\:translate-x-80:focus{
    --transform-translate-x: 20rem;
  }

  .md\\:focus\\:translate-x-82:focus{
    --transform-translate-x: 20.5rem;
  }

  .md\\:focus\\:translate-x-84:focus{
    --transform-translate-x: 21rem;
  }

  .md\\:focus\\:translate-x-88:focus{
    --transform-translate-x: 22rem;
  }

  .md\\:focus\\:translate-x-92:focus{
    --transform-translate-x: 23rem;
  }

  .md\\:focus\\:translate-x-96:focus{
    --transform-translate-x: 24rem;
  }

  .md\\:focus\\:translate-x-98:focus{
    --transform-translate-x: 24.5rem;
  }

  .md\\:focus\\:translate-x-100:focus{
    --transform-translate-x: 25rem;
  }

  .md\\:focus\\:translate-x-104:focus{
    --transform-translate-x: 26rem;
  }

  .md\\:focus\\:translate-x-112:focus{
    --transform-translate-x: 28rem;
  }

  .md\\:focus\\:translate-x-124:focus{
    --transform-translate-x: 31rem;
  }

  .md\\:focus\\:translate-x-128:focus{
    --transform-translate-x: 32rem;
  }

  .md\\:focus\\:translate-x-140:focus{
    --transform-translate-x: 35rem;
  }

  .md\\:focus\\:translate-x-152:focus{
    --transform-translate-x: 38rem;
  }

  .md\\:focus\\:translate-x-160:focus{
    --transform-translate-x: 40rem;
  }

  .md\\:focus\\:translate-x-162:focus{
    --transform-translate-x: 41rem;
  }

  .md\\:focus\\:translate-x-192:focus{
    --transform-translate-x: 48rem;
  }

  .md\\:focus\\:translate-x-208:focus{
    --transform-translate-x: 52rem;
  }

  .md\\:focus\\:translate-x-224:focus{
    --transform-translate-x: 56rem;
  }

  .md\\:focus\\:translate-x-256:focus{
    --transform-translate-x: 64rem;
  }

  .md\\:focus\\:translate-x-px:focus{
    --transform-translate-x: 1px;
  }

  .md\\:focus\\:-translate-x-1:focus{
    --transform-translate-x: -0.25rem;
  }

  .md\\:focus\\:-translate-x-2:focus{
    --transform-translate-x: -0.5rem;
  }

  .md\\:focus\\:-translate-x-3:focus{
    --transform-translate-x: -0.75rem;
  }

  .md\\:focus\\:-translate-x-4:focus{
    --transform-translate-x: -1rem;
  }

  .md\\:focus\\:-translate-x-5:focus{
    --transform-translate-x: -1.25rem;
  }

  .md\\:focus\\:-translate-x-6:focus{
    --transform-translate-x: -1.5rem;
  }

  .md\\:focus\\:-translate-x-7:focus{
    --transform-translate-x: -1.75rem;
  }

  .md\\:focus\\:-translate-x-8:focus{
    --transform-translate-x: -2rem;
  }

  .md\\:focus\\:-translate-x-9:focus{
    --transform-translate-x: -2.25rem;
  }

  .md\\:focus\\:-translate-x-10:focus{
    --transform-translate-x: -2.5rem;
  }

  .md\\:focus\\:-translate-x-11:focus{
    --transform-translate-x: -2.75rem;
  }

  .md\\:focus\\:-translate-x-12:focus{
    --transform-translate-x: -3rem;
  }

  .md\\:focus\\:-translate-x-14:focus{
    --transform-translate-x: -3.5rem;
  }

  .md\\:focus\\:-translate-x-15:focus{
    --transform-translate-x: -3.75rem;
  }

  .md\\:focus\\:-translate-x-16:focus{
    --transform-translate-x: -4rem;
  }

  .md\\:focus\\:-translate-x-18:focus{
    --transform-translate-x: -4.5rem;
  }

  .md\\:focus\\:-translate-x-20:focus{
    --transform-translate-x: -5rem;
  }

  .md\\:focus\\:-translate-x-22:focus{
    --transform-translate-x: -5.5rem;
  }

  .md\\:focus\\:-translate-x-23:focus{
    --transform-translate-x: -5.75rem;
  }

  .md\\:focus\\:-translate-x-24:focus{
    --transform-translate-x: -6rem;
  }

  .md\\:focus\\:-translate-x-25:focus{
    --transform-translate-x: -6.25rem;
  }

  .md\\:focus\\:-translate-x-26:focus{
    --transform-translate-x: -6.5rem;
  }

  .md\\:focus\\:-translate-x-28:focus{
    --transform-translate-x: -7rem;
  }

  .md\\:focus\\:-translate-x-30:focus{
    --transform-translate-x: -7.5rem;
  }

  .md\\:focus\\:-translate-x-32:focus{
    --transform-translate-x: -8rem;
  }

  .md\\:focus\\:-translate-x-34:focus{
    --transform-translate-x: -8.5rem;
  }

  .md\\:focus\\:-translate-x-40:focus{
    --transform-translate-x: -10rem;
  }

  .md\\:focus\\:-translate-x-42:focus{
    --transform-translate-x: -10.5rem;
  }

  .md\\:focus\\:-translate-x-44:focus{
    --transform-translate-x: -11rem;
  }

  .md\\:focus\\:-translate-x-48:focus{
    --transform-translate-x: -12rem;
  }

  .md\\:focus\\:-translate-x-52:focus{
    --transform-translate-x: -13rem;
  }

  .md\\:focus\\:-translate-x-54:focus{
    --transform-translate-x: -13.5rem;
  }

  .md\\:focus\\:-translate-x-56:focus{
    --transform-translate-x: -14rem;
  }

  .md\\:focus\\:-translate-x-60:focus{
    --transform-translate-x: -15rem;
  }

  .md\\:focus\\:-translate-x-64:focus{
    --transform-translate-x: -16rem;
  }

  .md\\:focus\\:-translate-x-68:focus{
    --transform-translate-x: -17rem;
  }

  .md\\:focus\\:-translate-x-72:focus{
    --transform-translate-x: -18rem;
  }

  .md\\:focus\\:-translate-x-74:focus{
    --transform-translate-x: -18.5rem;
  }

  .md\\:focus\\:-translate-x-76:focus{
    --transform-translate-x: -19rem;
  }

  .md\\:focus\\:-translate-x-78:focus{
    --transform-translate-x: -19.5rem;
  }

  .md\\:focus\\:-translate-x-80:focus{
    --transform-translate-x: -20rem;
  }

  .md\\:focus\\:-translate-x-82:focus{
    --transform-translate-x: -20.5rem;
  }

  .md\\:focus\\:-translate-x-84:focus{
    --transform-translate-x: -21rem;
  }

  .md\\:focus\\:-translate-x-88:focus{
    --transform-translate-x: -22rem;
  }

  .md\\:focus\\:-translate-x-92:focus{
    --transform-translate-x: -23rem;
  }

  .md\\:focus\\:-translate-x-96:focus{
    --transform-translate-x: -24rem;
  }

  .md\\:focus\\:-translate-x-98:focus{
    --transform-translate-x: -24.5rem;
  }

  .md\\:focus\\:-translate-x-100:focus{
    --transform-translate-x: -25rem;
  }

  .md\\:focus\\:-translate-x-104:focus{
    --transform-translate-x: -26rem;
  }

  .md\\:focus\\:-translate-x-112:focus{
    --transform-translate-x: -28rem;
  }

  .md\\:focus\\:-translate-x-124:focus{
    --transform-translate-x: -31rem;
  }

  .md\\:focus\\:-translate-x-128:focus{
    --transform-translate-x: -32rem;
  }

  .md\\:focus\\:-translate-x-140:focus{
    --transform-translate-x: -35rem;
  }

  .md\\:focus\\:-translate-x-152:focus{
    --transform-translate-x: -38rem;
  }

  .md\\:focus\\:-translate-x-160:focus{
    --transform-translate-x: -40rem;
  }

  .md\\:focus\\:-translate-x-162:focus{
    --transform-translate-x: -41rem;
  }

  .md\\:focus\\:-translate-x-192:focus{
    --transform-translate-x: -48rem;
  }

  .md\\:focus\\:-translate-x-208:focus{
    --transform-translate-x: -52rem;
  }

  .md\\:focus\\:-translate-x-224:focus{
    --transform-translate-x: -56rem;
  }

  .md\\:focus\\:-translate-x-256:focus{
    --transform-translate-x: -64rem;
  }

  .md\\:focus\\:-translate-x-px:focus{
    --transform-translate-x: -1px;
  }

  .md\\:focus\\:-translate-x-full:focus{
    --transform-translate-x: -100%;
  }

  .md\\:focus\\:-translate-x-1\\/2:focus{
    --transform-translate-x: -50%;
  }

  .md\\:focus\\:translate-x-1\\/2:focus{
    --transform-translate-x: 50%;
  }

  .md\\:focus\\:translate-x-full:focus{
    --transform-translate-x: 100%;
  }

  .md\\:focus\\:translate-y-0:focus{
    --transform-translate-y: 0;
  }

  .md\\:focus\\:translate-y-1:focus{
    --transform-translate-y: 0.25rem;
  }

  .md\\:focus\\:translate-y-2:focus{
    --transform-translate-y: 0.5rem;
  }

  .md\\:focus\\:translate-y-3:focus{
    --transform-translate-y: 0.75rem;
  }

  .md\\:focus\\:translate-y-4:focus{
    --transform-translate-y: 1rem;
  }

  .md\\:focus\\:translate-y-5:focus{
    --transform-translate-y: 1.25rem;
  }

  .md\\:focus\\:translate-y-6:focus{
    --transform-translate-y: 1.5rem;
  }

  .md\\:focus\\:translate-y-7:focus{
    --transform-translate-y: 1.75rem;
  }

  .md\\:focus\\:translate-y-8:focus{
    --transform-translate-y: 2rem;
  }

  .md\\:focus\\:translate-y-9:focus{
    --transform-translate-y: 2.25rem;
  }

  .md\\:focus\\:translate-y-10:focus{
    --transform-translate-y: 2.5rem;
  }

  .md\\:focus\\:translate-y-11:focus{
    --transform-translate-y: 2.75rem;
  }

  .md\\:focus\\:translate-y-12:focus{
    --transform-translate-y: 3rem;
  }

  .md\\:focus\\:translate-y-14:focus{
    --transform-translate-y: 3.5rem;
  }

  .md\\:focus\\:translate-y-15:focus{
    --transform-translate-y: 3.75rem;
  }

  .md\\:focus\\:translate-y-16:focus{
    --transform-translate-y: 4rem;
  }

  .md\\:focus\\:translate-y-18:focus{
    --transform-translate-y: 4.5rem;
  }

  .md\\:focus\\:translate-y-20:focus{
    --transform-translate-y: 5rem;
  }

  .md\\:focus\\:translate-y-22:focus{
    --transform-translate-y: 5.5rem;
  }

  .md\\:focus\\:translate-y-23:focus{
    --transform-translate-y: 5.75rem;
  }

  .md\\:focus\\:translate-y-24:focus{
    --transform-translate-y: 6rem;
  }

  .md\\:focus\\:translate-y-25:focus{
    --transform-translate-y: 6.25rem;
  }

  .md\\:focus\\:translate-y-26:focus{
    --transform-translate-y: 6.5rem;
  }

  .md\\:focus\\:translate-y-28:focus{
    --transform-translate-y: 7rem;
  }

  .md\\:focus\\:translate-y-30:focus{
    --transform-translate-y: 7.5rem;
  }

  .md\\:focus\\:translate-y-32:focus{
    --transform-translate-y: 8rem;
  }

  .md\\:focus\\:translate-y-34:focus{
    --transform-translate-y: 8.5rem;
  }

  .md\\:focus\\:translate-y-40:focus{
    --transform-translate-y: 10rem;
  }

  .md\\:focus\\:translate-y-42:focus{
    --transform-translate-y: 10.5rem;
  }

  .md\\:focus\\:translate-y-44:focus{
    --transform-translate-y: 11rem;
  }

  .md\\:focus\\:translate-y-48:focus{
    --transform-translate-y: 12rem;
  }

  .md\\:focus\\:translate-y-52:focus{
    --transform-translate-y: 13rem;
  }

  .md\\:focus\\:translate-y-54:focus{
    --transform-translate-y: 13.5rem;
  }

  .md\\:focus\\:translate-y-56:focus{
    --transform-translate-y: 14rem;
  }

  .md\\:focus\\:translate-y-60:focus{
    --transform-translate-y: 15rem;
  }

  .md\\:focus\\:translate-y-64:focus{
    --transform-translate-y: 16rem;
  }

  .md\\:focus\\:translate-y-68:focus{
    --transform-translate-y: 17rem;
  }

  .md\\:focus\\:translate-y-72:focus{
    --transform-translate-y: 18rem;
  }

  .md\\:focus\\:translate-y-74:focus{
    --transform-translate-y: 18.5rem;
  }

  .md\\:focus\\:translate-y-76:focus{
    --transform-translate-y: 19rem;
  }

  .md\\:focus\\:translate-y-78:focus{
    --transform-translate-y: 19.5rem;
  }

  .md\\:focus\\:translate-y-80:focus{
    --transform-translate-y: 20rem;
  }

  .md\\:focus\\:translate-y-82:focus{
    --transform-translate-y: 20.5rem;
  }

  .md\\:focus\\:translate-y-84:focus{
    --transform-translate-y: 21rem;
  }

  .md\\:focus\\:translate-y-88:focus{
    --transform-translate-y: 22rem;
  }

  .md\\:focus\\:translate-y-92:focus{
    --transform-translate-y: 23rem;
  }

  .md\\:focus\\:translate-y-96:focus{
    --transform-translate-y: 24rem;
  }

  .md\\:focus\\:translate-y-98:focus{
    --transform-translate-y: 24.5rem;
  }

  .md\\:focus\\:translate-y-100:focus{
    --transform-translate-y: 25rem;
  }

  .md\\:focus\\:translate-y-104:focus{
    --transform-translate-y: 26rem;
  }

  .md\\:focus\\:translate-y-112:focus{
    --transform-translate-y: 28rem;
  }

  .md\\:focus\\:translate-y-124:focus{
    --transform-translate-y: 31rem;
  }

  .md\\:focus\\:translate-y-128:focus{
    --transform-translate-y: 32rem;
  }

  .md\\:focus\\:translate-y-140:focus{
    --transform-translate-y: 35rem;
  }

  .md\\:focus\\:translate-y-152:focus{
    --transform-translate-y: 38rem;
  }

  .md\\:focus\\:translate-y-160:focus{
    --transform-translate-y: 40rem;
  }

  .md\\:focus\\:translate-y-162:focus{
    --transform-translate-y: 41rem;
  }

  .md\\:focus\\:translate-y-192:focus{
    --transform-translate-y: 48rem;
  }

  .md\\:focus\\:translate-y-208:focus{
    --transform-translate-y: 52rem;
  }

  .md\\:focus\\:translate-y-224:focus{
    --transform-translate-y: 56rem;
  }

  .md\\:focus\\:translate-y-256:focus{
    --transform-translate-y: 64rem;
  }

  .md\\:focus\\:translate-y-px:focus{
    --transform-translate-y: 1px;
  }

  .md\\:focus\\:-translate-y-1:focus{
    --transform-translate-y: -0.25rem;
  }

  .md\\:focus\\:-translate-y-2:focus{
    --transform-translate-y: -0.5rem;
  }

  .md\\:focus\\:-translate-y-3:focus{
    --transform-translate-y: -0.75rem;
  }

  .md\\:focus\\:-translate-y-4:focus{
    --transform-translate-y: -1rem;
  }

  .md\\:focus\\:-translate-y-5:focus{
    --transform-translate-y: -1.25rem;
  }

  .md\\:focus\\:-translate-y-6:focus{
    --transform-translate-y: -1.5rem;
  }

  .md\\:focus\\:-translate-y-7:focus{
    --transform-translate-y: -1.75rem;
  }

  .md\\:focus\\:-translate-y-8:focus{
    --transform-translate-y: -2rem;
  }

  .md\\:focus\\:-translate-y-9:focus{
    --transform-translate-y: -2.25rem;
  }

  .md\\:focus\\:-translate-y-10:focus{
    --transform-translate-y: -2.5rem;
  }

  .md\\:focus\\:-translate-y-11:focus{
    --transform-translate-y: -2.75rem;
  }

  .md\\:focus\\:-translate-y-12:focus{
    --transform-translate-y: -3rem;
  }

  .md\\:focus\\:-translate-y-14:focus{
    --transform-translate-y: -3.5rem;
  }

  .md\\:focus\\:-translate-y-15:focus{
    --transform-translate-y: -3.75rem;
  }

  .md\\:focus\\:-translate-y-16:focus{
    --transform-translate-y: -4rem;
  }

  .md\\:focus\\:-translate-y-18:focus{
    --transform-translate-y: -4.5rem;
  }

  .md\\:focus\\:-translate-y-20:focus{
    --transform-translate-y: -5rem;
  }

  .md\\:focus\\:-translate-y-22:focus{
    --transform-translate-y: -5.5rem;
  }

  .md\\:focus\\:-translate-y-23:focus{
    --transform-translate-y: -5.75rem;
  }

  .md\\:focus\\:-translate-y-24:focus{
    --transform-translate-y: -6rem;
  }

  .md\\:focus\\:-translate-y-25:focus{
    --transform-translate-y: -6.25rem;
  }

  .md\\:focus\\:-translate-y-26:focus{
    --transform-translate-y: -6.5rem;
  }

  .md\\:focus\\:-translate-y-28:focus{
    --transform-translate-y: -7rem;
  }

  .md\\:focus\\:-translate-y-30:focus{
    --transform-translate-y: -7.5rem;
  }

  .md\\:focus\\:-translate-y-32:focus{
    --transform-translate-y: -8rem;
  }

  .md\\:focus\\:-translate-y-34:focus{
    --transform-translate-y: -8.5rem;
  }

  .md\\:focus\\:-translate-y-40:focus{
    --transform-translate-y: -10rem;
  }

  .md\\:focus\\:-translate-y-42:focus{
    --transform-translate-y: -10.5rem;
  }

  .md\\:focus\\:-translate-y-44:focus{
    --transform-translate-y: -11rem;
  }

  .md\\:focus\\:-translate-y-48:focus{
    --transform-translate-y: -12rem;
  }

  .md\\:focus\\:-translate-y-52:focus{
    --transform-translate-y: -13rem;
  }

  .md\\:focus\\:-translate-y-54:focus{
    --transform-translate-y: -13.5rem;
  }

  .md\\:focus\\:-translate-y-56:focus{
    --transform-translate-y: -14rem;
  }

  .md\\:focus\\:-translate-y-60:focus{
    --transform-translate-y: -15rem;
  }

  .md\\:focus\\:-translate-y-64:focus{
    --transform-translate-y: -16rem;
  }

  .md\\:focus\\:-translate-y-68:focus{
    --transform-translate-y: -17rem;
  }

  .md\\:focus\\:-translate-y-72:focus{
    --transform-translate-y: -18rem;
  }

  .md\\:focus\\:-translate-y-74:focus{
    --transform-translate-y: -18.5rem;
  }

  .md\\:focus\\:-translate-y-76:focus{
    --transform-translate-y: -19rem;
  }

  .md\\:focus\\:-translate-y-78:focus{
    --transform-translate-y: -19.5rem;
  }

  .md\\:focus\\:-translate-y-80:focus{
    --transform-translate-y: -20rem;
  }

  .md\\:focus\\:-translate-y-82:focus{
    --transform-translate-y: -20.5rem;
  }

  .md\\:focus\\:-translate-y-84:focus{
    --transform-translate-y: -21rem;
  }

  .md\\:focus\\:-translate-y-88:focus{
    --transform-translate-y: -22rem;
  }

  .md\\:focus\\:-translate-y-92:focus{
    --transform-translate-y: -23rem;
  }

  .md\\:focus\\:-translate-y-96:focus{
    --transform-translate-y: -24rem;
  }

  .md\\:focus\\:-translate-y-98:focus{
    --transform-translate-y: -24.5rem;
  }

  .md\\:focus\\:-translate-y-100:focus{
    --transform-translate-y: -25rem;
  }

  .md\\:focus\\:-translate-y-104:focus{
    --transform-translate-y: -26rem;
  }

  .md\\:focus\\:-translate-y-112:focus{
    --transform-translate-y: -28rem;
  }

  .md\\:focus\\:-translate-y-124:focus{
    --transform-translate-y: -31rem;
  }

  .md\\:focus\\:-translate-y-128:focus{
    --transform-translate-y: -32rem;
  }

  .md\\:focus\\:-translate-y-140:focus{
    --transform-translate-y: -35rem;
  }

  .md\\:focus\\:-translate-y-152:focus{
    --transform-translate-y: -38rem;
  }

  .md\\:focus\\:-translate-y-160:focus{
    --transform-translate-y: -40rem;
  }

  .md\\:focus\\:-translate-y-162:focus{
    --transform-translate-y: -41rem;
  }

  .md\\:focus\\:-translate-y-192:focus{
    --transform-translate-y: -48rem;
  }

  .md\\:focus\\:-translate-y-208:focus{
    --transform-translate-y: -52rem;
  }

  .md\\:focus\\:-translate-y-224:focus{
    --transform-translate-y: -56rem;
  }

  .md\\:focus\\:-translate-y-256:focus{
    --transform-translate-y: -64rem;
  }

  .md\\:focus\\:-translate-y-px:focus{
    --transform-translate-y: -1px;
  }

  .md\\:focus\\:-translate-y-full:focus{
    --transform-translate-y: -100%;
  }

  .md\\:focus\\:-translate-y-1\\/2:focus{
    --transform-translate-y: -50%;
  }

  .md\\:focus\\:translate-y-1\\/2:focus{
    --transform-translate-y: 50%;
  }

  .md\\:focus\\:translate-y-full:focus{
    --transform-translate-y: 100%;
  }

  .md\\:skew-x-0{
    --transform-skew-x: 0;
  }

  .md\\:skew-x-1{
    --transform-skew-x: 1deg;
  }

  .md\\:skew-x-2{
    --transform-skew-x: 2deg;
  }

  .md\\:skew-x-3{
    --transform-skew-x: 3deg;
  }

  .md\\:skew-x-6{
    --transform-skew-x: 6deg;
  }

  .md\\:skew-x-12{
    --transform-skew-x: 12deg;
  }

  .md\\:-skew-x-12{
    --transform-skew-x: -12deg;
  }

  .md\\:-skew-x-6{
    --transform-skew-x: -6deg;
  }

  .md\\:-skew-x-3{
    --transform-skew-x: -3deg;
  }

  .md\\:-skew-x-2{
    --transform-skew-x: -2deg;
  }

  .md\\:-skew-x-1{
    --transform-skew-x: -1deg;
  }

  .md\\:skew-y-0{
    --transform-skew-y: 0;
  }

  .md\\:skew-y-1{
    --transform-skew-y: 1deg;
  }

  .md\\:skew-y-2{
    --transform-skew-y: 2deg;
  }

  .md\\:skew-y-3{
    --transform-skew-y: 3deg;
  }

  .md\\:skew-y-6{
    --transform-skew-y: 6deg;
  }

  .md\\:skew-y-12{
    --transform-skew-y: 12deg;
  }

  .md\\:-skew-y-12{
    --transform-skew-y: -12deg;
  }

  .md\\:-skew-y-6{
    --transform-skew-y: -6deg;
  }

  .md\\:-skew-y-3{
    --transform-skew-y: -3deg;
  }

  .md\\:-skew-y-2{
    --transform-skew-y: -2deg;
  }

  .md\\:-skew-y-1{
    --transform-skew-y: -1deg;
  }

  .md\\:hover\\:skew-x-0:hover{
    --transform-skew-x: 0;
  }

  .md\\:hover\\:skew-x-1:hover{
    --transform-skew-x: 1deg;
  }

  .md\\:hover\\:skew-x-2:hover{
    --transform-skew-x: 2deg;
  }

  .md\\:hover\\:skew-x-3:hover{
    --transform-skew-x: 3deg;
  }

  .md\\:hover\\:skew-x-6:hover{
    --transform-skew-x: 6deg;
  }

  .md\\:hover\\:skew-x-12:hover{
    --transform-skew-x: 12deg;
  }

  .md\\:hover\\:-skew-x-12:hover{
    --transform-skew-x: -12deg;
  }

  .md\\:hover\\:-skew-x-6:hover{
    --transform-skew-x: -6deg;
  }

  .md\\:hover\\:-skew-x-3:hover{
    --transform-skew-x: -3deg;
  }

  .md\\:hover\\:-skew-x-2:hover{
    --transform-skew-x: -2deg;
  }

  .md\\:hover\\:-skew-x-1:hover{
    --transform-skew-x: -1deg;
  }

  .md\\:hover\\:skew-y-0:hover{
    --transform-skew-y: 0;
  }

  .md\\:hover\\:skew-y-1:hover{
    --transform-skew-y: 1deg;
  }

  .md\\:hover\\:skew-y-2:hover{
    --transform-skew-y: 2deg;
  }

  .md\\:hover\\:skew-y-3:hover{
    --transform-skew-y: 3deg;
  }

  .md\\:hover\\:skew-y-6:hover{
    --transform-skew-y: 6deg;
  }

  .md\\:hover\\:skew-y-12:hover{
    --transform-skew-y: 12deg;
  }

  .md\\:hover\\:-skew-y-12:hover{
    --transform-skew-y: -12deg;
  }

  .md\\:hover\\:-skew-y-6:hover{
    --transform-skew-y: -6deg;
  }

  .md\\:hover\\:-skew-y-3:hover{
    --transform-skew-y: -3deg;
  }

  .md\\:hover\\:-skew-y-2:hover{
    --transform-skew-y: -2deg;
  }

  .md\\:hover\\:-skew-y-1:hover{
    --transform-skew-y: -1deg;
  }

  .md\\:focus\\:skew-x-0:focus{
    --transform-skew-x: 0;
  }

  .md\\:focus\\:skew-x-1:focus{
    --transform-skew-x: 1deg;
  }

  .md\\:focus\\:skew-x-2:focus{
    --transform-skew-x: 2deg;
  }

  .md\\:focus\\:skew-x-3:focus{
    --transform-skew-x: 3deg;
  }

  .md\\:focus\\:skew-x-6:focus{
    --transform-skew-x: 6deg;
  }

  .md\\:focus\\:skew-x-12:focus{
    --transform-skew-x: 12deg;
  }

  .md\\:focus\\:-skew-x-12:focus{
    --transform-skew-x: -12deg;
  }

  .md\\:focus\\:-skew-x-6:focus{
    --transform-skew-x: -6deg;
  }

  .md\\:focus\\:-skew-x-3:focus{
    --transform-skew-x: -3deg;
  }

  .md\\:focus\\:-skew-x-2:focus{
    --transform-skew-x: -2deg;
  }

  .md\\:focus\\:-skew-x-1:focus{
    --transform-skew-x: -1deg;
  }

  .md\\:focus\\:skew-y-0:focus{
    --transform-skew-y: 0;
  }

  .md\\:focus\\:skew-y-1:focus{
    --transform-skew-y: 1deg;
  }

  .md\\:focus\\:skew-y-2:focus{
    --transform-skew-y: 2deg;
  }

  .md\\:focus\\:skew-y-3:focus{
    --transform-skew-y: 3deg;
  }

  .md\\:focus\\:skew-y-6:focus{
    --transform-skew-y: 6deg;
  }

  .md\\:focus\\:skew-y-12:focus{
    --transform-skew-y: 12deg;
  }

  .md\\:focus\\:-skew-y-12:focus{
    --transform-skew-y: -12deg;
  }

  .md\\:focus\\:-skew-y-6:focus{
    --transform-skew-y: -6deg;
  }

  .md\\:focus\\:-skew-y-3:focus{
    --transform-skew-y: -3deg;
  }

  .md\\:focus\\:-skew-y-2:focus{
    --transform-skew-y: -2deg;
  }

  .md\\:focus\\:-skew-y-1:focus{
    --transform-skew-y: -1deg;
  }

  .md\\:transition-none{
    transition-property: none;
  }

  .md\\:transition-all{
    transition-property: all;
  }

  .md\\:transition{
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  }

  .md\\:transition-colors{
    transition-property: background-color, border-color, color, fill, stroke;
  }

  .md\\:transition-opacity{
    transition-property: opacity;
  }

  .md\\:transition-shadow{
    transition-property: box-shadow;
  }

  .md\\:transition-transform{
    transition-property: transform;
  }

  .md\\:ease-linear{
    transition-timing-function: linear;
  }

  .md\\:ease-in{
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  }

  .md\\:ease-out{
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }

  .md\\:ease-in-out{
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }

  .md\\:duration-75{
    transition-duration: 75ms;
  }

  .md\\:duration-100{
    transition-duration: 100ms;
  }

  .md\\:duration-150{
    transition-duration: 150ms;
  }

  .md\\:duration-200{
    transition-duration: 200ms;
  }

  .md\\:duration-300{
    transition-duration: 300ms;
  }

  .md\\:duration-500{
    transition-duration: 500ms;
  }

  .md\\:duration-700{
    transition-duration: 700ms;
  }

  .md\\:duration-1000{
    transition-duration: 1000ms;
  }

  .md\\:delay-75{
    transition-delay: 75ms;
  }

  .md\\:delay-100{
    transition-delay: 100ms;
  }

  .md\\:delay-150{
    transition-delay: 150ms;
  }

  .md\\:delay-200{
    transition-delay: 200ms;
  }

  .md\\:delay-300{
    transition-delay: 300ms;
  }

  .md\\:delay-500{
    transition-delay: 500ms;
  }

  .md\\:delay-700{
    transition-delay: 700ms;
  }

  .md\\:delay-1000{
    transition-delay: 1000ms;
  }

  .md\\:animate-none{
    animation: none;
  }

  .md\\:animate-spin{
    animation: spin 1s linear infinite;
  }

  .md\\:animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }

  .md\\:animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  .md\\:animate-bounce{
    animation: bounce 1s infinite;
  }

  [dir="ltr"] .md\\:ps-0{
    padding-left: 0;
  }

  [dir="rtl"] .md\\:ps-0{
    padding-right: 0;
  }

  [dir="ltr"] .md\\:pe-0{
    padding-right: 0;
  }

  [dir="rtl"] .md\\:pe-0{
    padding-left: 0;
  }

  [dir="ltr"] .md\\:ps-1{
    padding-left: 0.25rem;
  }

  [dir="rtl"] .md\\:ps-1{
    padding-right: 0.25rem;
  }

  [dir="ltr"] .md\\:pe-1{
    padding-right: 0.25rem;
  }

  [dir="rtl"] .md\\:pe-1{
    padding-left: 0.25rem;
  }

  [dir="ltr"] .md\\:ps-2{
    padding-left: 0.5rem;
  }

  [dir="rtl"] .md\\:ps-2{
    padding-right: 0.5rem;
  }

  [dir="ltr"] .md\\:pe-2{
    padding-right: 0.5rem;
  }

  [dir="rtl"] .md\\:pe-2{
    padding-left: 0.5rem;
  }

  [dir="ltr"] .md\\:ps-3{
    padding-left: 0.75rem;
  }

  [dir="rtl"] .md\\:ps-3{
    padding-right: 0.75rem;
  }

  [dir="ltr"] .md\\:pe-3{
    padding-right: 0.75rem;
  }

  [dir="rtl"] .md\\:pe-3{
    padding-left: 0.75rem;
  }

  [dir="ltr"] .md\\:ps-4{
    padding-left: 1rem;
  }

  [dir="rtl"] .md\\:ps-4{
    padding-right: 1rem;
  }

  [dir="ltr"] .md\\:pe-4{
    padding-right: 1rem;
  }

  [dir="rtl"] .md\\:pe-4{
    padding-left: 1rem;
  }

  [dir="ltr"] .md\\:ps-5{
    padding-left: 1.25rem;
  }

  [dir="rtl"] .md\\:ps-5{
    padding-right: 1.25rem;
  }

  [dir="ltr"] .md\\:pe-5{
    padding-right: 1.25rem;
  }

  [dir="rtl"] .md\\:pe-5{
    padding-left: 1.25rem;
  }

  [dir="ltr"] .md\\:ps-6{
    padding-left: 1.5rem;
  }

  [dir="rtl"] .md\\:ps-6{
    padding-right: 1.5rem;
  }

  [dir="ltr"] .md\\:pe-6{
    padding-right: 1.5rem;
  }

  [dir="rtl"] .md\\:pe-6{
    padding-left: 1.5rem;
  }

  [dir="ltr"] .md\\:ps-7{
    padding-left: 1.75rem;
  }

  [dir="rtl"] .md\\:ps-7{
    padding-right: 1.75rem;
  }

  [dir="ltr"] .md\\:pe-7{
    padding-right: 1.75rem;
  }

  [dir="rtl"] .md\\:pe-7{
    padding-left: 1.75rem;
  }

  [dir="ltr"] .md\\:ps-8{
    padding-left: 2rem;
  }

  [dir="rtl"] .md\\:ps-8{
    padding-right: 2rem;
  }

  [dir="ltr"] .md\\:pe-8{
    padding-right: 2rem;
  }

  [dir="rtl"] .md\\:pe-8{
    padding-left: 2rem;
  }

  [dir="ltr"] .md\\:ps-9{
    padding-left: 2.25rem;
  }

  [dir="rtl"] .md\\:ps-9{
    padding-right: 2.25rem;
  }

  [dir="ltr"] .md\\:pe-9{
    padding-right: 2.25rem;
  }

  [dir="rtl"] .md\\:pe-9{
    padding-left: 2.25rem;
  }

  [dir="ltr"] .md\\:ps-10{
    padding-left: 2.5rem;
  }

  [dir="rtl"] .md\\:ps-10{
    padding-right: 2.5rem;
  }

  [dir="ltr"] .md\\:pe-10{
    padding-right: 2.5rem;
  }

  [dir="rtl"] .md\\:pe-10{
    padding-left: 2.5rem;
  }

  [dir="ltr"] .md\\:ps-11{
    padding-left: 2.75rem;
  }

  [dir="rtl"] .md\\:ps-11{
    padding-right: 2.75rem;
  }

  [dir="ltr"] .md\\:pe-11{
    padding-right: 2.75rem;
  }

  [dir="rtl"] .md\\:pe-11{
    padding-left: 2.75rem;
  }

  [dir="ltr"] .md\\:ps-12{
    padding-left: 3rem;
  }

  [dir="rtl"] .md\\:ps-12{
    padding-right: 3rem;
  }

  [dir="ltr"] .md\\:pe-12{
    padding-right: 3rem;
  }

  [dir="rtl"] .md\\:pe-12{
    padding-left: 3rem;
  }

  [dir="ltr"] .md\\:ps-14{
    padding-left: 3.5rem;
  }

  [dir="rtl"] .md\\:ps-14{
    padding-right: 3.5rem;
  }

  [dir="ltr"] .md\\:pe-14{
    padding-right: 3.5rem;
  }

  [dir="rtl"] .md\\:pe-14{
    padding-left: 3.5rem;
  }

  [dir="ltr"] .md\\:ps-15{
    padding-left: 3.75rem;
  }

  [dir="rtl"] .md\\:ps-15{
    padding-right: 3.75rem;
  }

  [dir="ltr"] .md\\:pe-15{
    padding-right: 3.75rem;
  }

  [dir="rtl"] .md\\:pe-15{
    padding-left: 3.75rem;
  }

  [dir="ltr"] .md\\:ps-16{
    padding-left: 4rem;
  }

  [dir="rtl"] .md\\:ps-16{
    padding-right: 4rem;
  }

  [dir="ltr"] .md\\:pe-16{
    padding-right: 4rem;
  }

  [dir="rtl"] .md\\:pe-16{
    padding-left: 4rem;
  }

  [dir="ltr"] .md\\:ps-18{
    padding-left: 4.5rem;
  }

  [dir="rtl"] .md\\:ps-18{
    padding-right: 4.5rem;
  }

  [dir="ltr"] .md\\:pe-18{
    padding-right: 4.5rem;
  }

  [dir="rtl"] .md\\:pe-18{
    padding-left: 4.5rem;
  }

  [dir="ltr"] .md\\:ps-20{
    padding-left: 5rem;
  }

  [dir="rtl"] .md\\:ps-20{
    padding-right: 5rem;
  }

  [dir="ltr"] .md\\:pe-20{
    padding-right: 5rem;
  }

  [dir="rtl"] .md\\:pe-20{
    padding-left: 5rem;
  }

  [dir="ltr"] .md\\:ps-22{
    padding-left: 5.5rem;
  }

  [dir="rtl"] .md\\:ps-22{
    padding-right: 5.5rem;
  }

  [dir="ltr"] .md\\:pe-22{
    padding-right: 5.5rem;
  }

  [dir="rtl"] .md\\:pe-22{
    padding-left: 5.5rem;
  }

  [dir="ltr"] .md\\:ps-23{
    padding-left: 5.75rem;
  }

  [dir="rtl"] .md\\:ps-23{
    padding-right: 5.75rem;
  }

  [dir="ltr"] .md\\:pe-23{
    padding-right: 5.75rem;
  }

  [dir="rtl"] .md\\:pe-23{
    padding-left: 5.75rem;
  }

  [dir="ltr"] .md\\:ps-24{
    padding-left: 6rem;
  }

  [dir="rtl"] .md\\:ps-24{
    padding-right: 6rem;
  }

  [dir="ltr"] .md\\:pe-24{
    padding-right: 6rem;
  }

  [dir="rtl"] .md\\:pe-24{
    padding-left: 6rem;
  }

  [dir="ltr"] .md\\:ps-25{
    padding-left: 6.25rem;
  }

  [dir="rtl"] .md\\:ps-25{
    padding-right: 6.25rem;
  }

  [dir="ltr"] .md\\:pe-25{
    padding-right: 6.25rem;
  }

  [dir="rtl"] .md\\:pe-25{
    padding-left: 6.25rem;
  }

  [dir="ltr"] .md\\:ps-26{
    padding-left: 6.5rem;
  }

  [dir="rtl"] .md\\:ps-26{
    padding-right: 6.5rem;
  }

  [dir="ltr"] .md\\:pe-26{
    padding-right: 6.5rem;
  }

  [dir="rtl"] .md\\:pe-26{
    padding-left: 6.5rem;
  }

  [dir="ltr"] .md\\:ps-28{
    padding-left: 7rem;
  }

  [dir="rtl"] .md\\:ps-28{
    padding-right: 7rem;
  }

  [dir="ltr"] .md\\:pe-28{
    padding-right: 7rem;
  }

  [dir="rtl"] .md\\:pe-28{
    padding-left: 7rem;
  }

  [dir="ltr"] .md\\:ps-30{
    padding-left: 7.5rem;
  }

  [dir="rtl"] .md\\:ps-30{
    padding-right: 7.5rem;
  }

  [dir="ltr"] .md\\:pe-30{
    padding-right: 7.5rem;
  }

  [dir="rtl"] .md\\:pe-30{
    padding-left: 7.5rem;
  }

  [dir="ltr"] .md\\:ps-32{
    padding-left: 8rem;
  }

  [dir="rtl"] .md\\:ps-32{
    padding-right: 8rem;
  }

  [dir="ltr"] .md\\:pe-32{
    padding-right: 8rem;
  }

  [dir="rtl"] .md\\:pe-32{
    padding-left: 8rem;
  }

  [dir="ltr"] .md\\:ps-34{
    padding-left: 8.5rem;
  }

  [dir="rtl"] .md\\:ps-34{
    padding-right: 8.5rem;
  }

  [dir="ltr"] .md\\:pe-34{
    padding-right: 8.5rem;
  }

  [dir="rtl"] .md\\:pe-34{
    padding-left: 8.5rem;
  }

  [dir="ltr"] .md\\:ps-40{
    padding-left: 10rem;
  }

  [dir="rtl"] .md\\:ps-40{
    padding-right: 10rem;
  }

  [dir="ltr"] .md\\:pe-40{
    padding-right: 10rem;
  }

  [dir="rtl"] .md\\:pe-40{
    padding-left: 10rem;
  }

  [dir="ltr"] .md\\:ps-42{
    padding-left: 10.5rem;
  }

  [dir="rtl"] .md\\:ps-42{
    padding-right: 10.5rem;
  }

  [dir="ltr"] .md\\:pe-42{
    padding-right: 10.5rem;
  }

  [dir="rtl"] .md\\:pe-42{
    padding-left: 10.5rem;
  }

  [dir="ltr"] .md\\:ps-44{
    padding-left: 11rem;
  }

  [dir="rtl"] .md\\:ps-44{
    padding-right: 11rem;
  }

  [dir="ltr"] .md\\:pe-44{
    padding-right: 11rem;
  }

  [dir="rtl"] .md\\:pe-44{
    padding-left: 11rem;
  }

  [dir="ltr"] .md\\:ps-48{
    padding-left: 12rem;
  }

  [dir="rtl"] .md\\:ps-48{
    padding-right: 12rem;
  }

  [dir="ltr"] .md\\:pe-48{
    padding-right: 12rem;
  }

  [dir="rtl"] .md\\:pe-48{
    padding-left: 12rem;
  }

  [dir="ltr"] .md\\:ps-52{
    padding-left: 13rem;
  }

  [dir="rtl"] .md\\:ps-52{
    padding-right: 13rem;
  }

  [dir="ltr"] .md\\:pe-52{
    padding-right: 13rem;
  }

  [dir="rtl"] .md\\:pe-52{
    padding-left: 13rem;
  }

  [dir="ltr"] .md\\:ps-54{
    padding-left: 13.5rem;
  }

  [dir="rtl"] .md\\:ps-54{
    padding-right: 13.5rem;
  }

  [dir="ltr"] .md\\:pe-54{
    padding-right: 13.5rem;
  }

  [dir="rtl"] .md\\:pe-54{
    padding-left: 13.5rem;
  }

  [dir="ltr"] .md\\:ps-56{
    padding-left: 14rem;
  }

  [dir="rtl"] .md\\:ps-56{
    padding-right: 14rem;
  }

  [dir="ltr"] .md\\:pe-56{
    padding-right: 14rem;
  }

  [dir="rtl"] .md\\:pe-56{
    padding-left: 14rem;
  }

  [dir="ltr"] .md\\:ps-60{
    padding-left: 15rem;
  }

  [dir="rtl"] .md\\:ps-60{
    padding-right: 15rem;
  }

  [dir="ltr"] .md\\:pe-60{
    padding-right: 15rem;
  }

  [dir="rtl"] .md\\:pe-60{
    padding-left: 15rem;
  }

  [dir="ltr"] .md\\:ps-64{
    padding-left: 16rem;
  }

  [dir="rtl"] .md\\:ps-64{
    padding-right: 16rem;
  }

  [dir="ltr"] .md\\:pe-64{
    padding-right: 16rem;
  }

  [dir="rtl"] .md\\:pe-64{
    padding-left: 16rem;
  }

  [dir="ltr"] .md\\:ps-68{
    padding-left: 17rem;
  }

  [dir="rtl"] .md\\:ps-68{
    padding-right: 17rem;
  }

  [dir="ltr"] .md\\:pe-68{
    padding-right: 17rem;
  }

  [dir="rtl"] .md\\:pe-68{
    padding-left: 17rem;
  }

  [dir="ltr"] .md\\:ps-72{
    padding-left: 18rem;
  }

  [dir="rtl"] .md\\:ps-72{
    padding-right: 18rem;
  }

  [dir="ltr"] .md\\:pe-72{
    padding-right: 18rem;
  }

  [dir="rtl"] .md\\:pe-72{
    padding-left: 18rem;
  }

  [dir="ltr"] .md\\:ps-74{
    padding-left: 18.5rem;
  }

  [dir="rtl"] .md\\:ps-74{
    padding-right: 18.5rem;
  }

  [dir="ltr"] .md\\:pe-74{
    padding-right: 18.5rem;
  }

  [dir="rtl"] .md\\:pe-74{
    padding-left: 18.5rem;
  }

  [dir="ltr"] .md\\:ps-76{
    padding-left: 19rem;
  }

  [dir="rtl"] .md\\:ps-76{
    padding-right: 19rem;
  }

  [dir="ltr"] .md\\:pe-76{
    padding-right: 19rem;
  }

  [dir="rtl"] .md\\:pe-76{
    padding-left: 19rem;
  }

  [dir="ltr"] .md\\:ps-78{
    padding-left: 19.5rem;
  }

  [dir="rtl"] .md\\:ps-78{
    padding-right: 19.5rem;
  }

  [dir="ltr"] .md\\:pe-78{
    padding-right: 19.5rem;
  }

  [dir="rtl"] .md\\:pe-78{
    padding-left: 19.5rem;
  }

  [dir="ltr"] .md\\:ps-80{
    padding-left: 20rem;
  }

  [dir="rtl"] .md\\:ps-80{
    padding-right: 20rem;
  }

  [dir="ltr"] .md\\:pe-80{
    padding-right: 20rem;
  }

  [dir="rtl"] .md\\:pe-80{
    padding-left: 20rem;
  }

  [dir="ltr"] .md\\:ps-82{
    padding-left: 20.5rem;
  }

  [dir="rtl"] .md\\:ps-82{
    padding-right: 20.5rem;
  }

  [dir="ltr"] .md\\:pe-82{
    padding-right: 20.5rem;
  }

  [dir="rtl"] .md\\:pe-82{
    padding-left: 20.5rem;
  }

  [dir="ltr"] .md\\:ps-84{
    padding-left: 21rem;
  }

  [dir="rtl"] .md\\:ps-84{
    padding-right: 21rem;
  }

  [dir="ltr"] .md\\:pe-84{
    padding-right: 21rem;
  }

  [dir="rtl"] .md\\:pe-84{
    padding-left: 21rem;
  }

  [dir="ltr"] .md\\:ps-88{
    padding-left: 22rem;
  }

  [dir="rtl"] .md\\:ps-88{
    padding-right: 22rem;
  }

  [dir="ltr"] .md\\:pe-88{
    padding-right: 22rem;
  }

  [dir="rtl"] .md\\:pe-88{
    padding-left: 22rem;
  }

  [dir="ltr"] .md\\:ps-92{
    padding-left: 23rem;
  }

  [dir="rtl"] .md\\:ps-92{
    padding-right: 23rem;
  }

  [dir="ltr"] .md\\:pe-92{
    padding-right: 23rem;
  }

  [dir="rtl"] .md\\:pe-92{
    padding-left: 23rem;
  }

  [dir="ltr"] .md\\:ps-96{
    padding-left: 24rem;
  }

  [dir="rtl"] .md\\:ps-96{
    padding-right: 24rem;
  }

  [dir="ltr"] .md\\:pe-96{
    padding-right: 24rem;
  }

  [dir="rtl"] .md\\:pe-96{
    padding-left: 24rem;
  }

  [dir="ltr"] .md\\:ps-98{
    padding-left: 24.5rem;
  }

  [dir="rtl"] .md\\:ps-98{
    padding-right: 24.5rem;
  }

  [dir="ltr"] .md\\:pe-98{
    padding-right: 24.5rem;
  }

  [dir="rtl"] .md\\:pe-98{
    padding-left: 24.5rem;
  }

  [dir="ltr"] .md\\:ps-100{
    padding-left: 25rem;
  }

  [dir="rtl"] .md\\:ps-100{
    padding-right: 25rem;
  }

  [dir="ltr"] .md\\:pe-100{
    padding-right: 25rem;
  }

  [dir="rtl"] .md\\:pe-100{
    padding-left: 25rem;
  }

  [dir="ltr"] .md\\:ps-104{
    padding-left: 26rem;
  }

  [dir="rtl"] .md\\:ps-104{
    padding-right: 26rem;
  }

  [dir="ltr"] .md\\:pe-104{
    padding-right: 26rem;
  }

  [dir="rtl"] .md\\:pe-104{
    padding-left: 26rem;
  }

  [dir="ltr"] .md\\:ps-112{
    padding-left: 28rem;
  }

  [dir="rtl"] .md\\:ps-112{
    padding-right: 28rem;
  }

  [dir="ltr"] .md\\:pe-112{
    padding-right: 28rem;
  }

  [dir="rtl"] .md\\:pe-112{
    padding-left: 28rem;
  }

  [dir="ltr"] .md\\:ps-124{
    padding-left: 31rem;
  }

  [dir="rtl"] .md\\:ps-124{
    padding-right: 31rem;
  }

  [dir="ltr"] .md\\:pe-124{
    padding-right: 31rem;
  }

  [dir="rtl"] .md\\:pe-124{
    padding-left: 31rem;
  }

  [dir="ltr"] .md\\:ps-128{
    padding-left: 32rem;
  }

  [dir="rtl"] .md\\:ps-128{
    padding-right: 32rem;
  }

  [dir="ltr"] .md\\:pe-128{
    padding-right: 32rem;
  }

  [dir="rtl"] .md\\:pe-128{
    padding-left: 32rem;
  }

  [dir="ltr"] .md\\:ps-140{
    padding-left: 35rem;
  }

  [dir="rtl"] .md\\:ps-140{
    padding-right: 35rem;
  }

  [dir="ltr"] .md\\:pe-140{
    padding-right: 35rem;
  }

  [dir="rtl"] .md\\:pe-140{
    padding-left: 35rem;
  }

  [dir="ltr"] .md\\:ps-152{
    padding-left: 38rem;
  }

  [dir="rtl"] .md\\:ps-152{
    padding-right: 38rem;
  }

  [dir="ltr"] .md\\:pe-152{
    padding-right: 38rem;
  }

  [dir="rtl"] .md\\:pe-152{
    padding-left: 38rem;
  }

  [dir="ltr"] .md\\:ps-160{
    padding-left: 40rem;
  }

  [dir="rtl"] .md\\:ps-160{
    padding-right: 40rem;
  }

  [dir="ltr"] .md\\:pe-160{
    padding-right: 40rem;
  }

  [dir="rtl"] .md\\:pe-160{
    padding-left: 40rem;
  }

  [dir="ltr"] .md\\:ps-162{
    padding-left: 41rem;
  }

  [dir="rtl"] .md\\:ps-162{
    padding-right: 41rem;
  }

  [dir="ltr"] .md\\:pe-162{
    padding-right: 41rem;
  }

  [dir="rtl"] .md\\:pe-162{
    padding-left: 41rem;
  }

  [dir="ltr"] .md\\:ps-192{
    padding-left: 48rem;
  }

  [dir="rtl"] .md\\:ps-192{
    padding-right: 48rem;
  }

  [dir="ltr"] .md\\:pe-192{
    padding-right: 48rem;
  }

  [dir="rtl"] .md\\:pe-192{
    padding-left: 48rem;
  }

  [dir="ltr"] .md\\:ps-208{
    padding-left: 52rem;
  }

  [dir="rtl"] .md\\:ps-208{
    padding-right: 52rem;
  }

  [dir="ltr"] .md\\:pe-208{
    padding-right: 52rem;
  }

  [dir="rtl"] .md\\:pe-208{
    padding-left: 52rem;
  }

  [dir="ltr"] .md\\:ps-224{
    padding-left: 56rem;
  }

  [dir="rtl"] .md\\:ps-224{
    padding-right: 56rem;
  }

  [dir="ltr"] .md\\:pe-224{
    padding-right: 56rem;
  }

  [dir="rtl"] .md\\:pe-224{
    padding-left: 56rem;
  }

  [dir="ltr"] .md\\:ps-256{
    padding-left: 64rem;
  }

  [dir="rtl"] .md\\:ps-256{
    padding-right: 64rem;
  }

  [dir="ltr"] .md\\:pe-256{
    padding-right: 64rem;
  }

  [dir="rtl"] .md\\:pe-256{
    padding-left: 64rem;
  }

  [dir="ltr"] .md\\:ps-px{
    padding-left: 1px;
  }

  [dir="rtl"] .md\\:ps-px{
    padding-right: 1px;
  }

  [dir="ltr"] .md\\:pe-px{
    padding-right: 1px;
  }

  [dir="rtl"] .md\\:pe-px{
    padding-left: 1px;
  }

  [dir="ltr"] .md\\:odd\\:ps-0:nth-child(odd){
    padding-left: 0;
  }

  [dir="rtl"] .md\\:odd\\:ps-0:nth-child(odd){
    padding-right: 0;
  }

  [dir="ltr"] .md\\:odd\\:pe-0:nth-child(odd){
    padding-right: 0;
  }

  [dir="rtl"] .md\\:odd\\:pe-0:nth-child(odd){
    padding-left: 0;
  }

  [dir="ltr"] .md\\:odd\\:ps-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-4:nth-child(odd){
    padding-left: 1rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-4:nth-child(odd){
    padding-right: 1rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-4:nth-child(odd){
    padding-right: 1rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-4:nth-child(odd){
    padding-left: 1rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-8:nth-child(odd){
    padding-left: 2rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-8:nth-child(odd){
    padding-right: 2rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-8:nth-child(odd){
    padding-right: 2rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-8:nth-child(odd){
    padding-left: 2rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-12:nth-child(odd){
    padding-left: 3rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-12:nth-child(odd){
    padding-right: 3rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-12:nth-child(odd){
    padding-right: 3rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-12:nth-child(odd){
    padding-left: 3rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-16:nth-child(odd){
    padding-left: 4rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-16:nth-child(odd){
    padding-right: 4rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-16:nth-child(odd){
    padding-right: 4rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-16:nth-child(odd){
    padding-left: 4rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-20:nth-child(odd){
    padding-left: 5rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-20:nth-child(odd){
    padding-right: 5rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-20:nth-child(odd){
    padding-right: 5rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-20:nth-child(odd){
    padding-left: 5rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-24:nth-child(odd){
    padding-left: 6rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-24:nth-child(odd){
    padding-right: 6rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-24:nth-child(odd){
    padding-right: 6rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-24:nth-child(odd){
    padding-left: 6rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-28:nth-child(odd){
    padding-left: 7rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-28:nth-child(odd){
    padding-right: 7rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-28:nth-child(odd){
    padding-right: 7rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-28:nth-child(odd){
    padding-left: 7rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-32:nth-child(odd){
    padding-left: 8rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-32:nth-child(odd){
    padding-right: 8rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-32:nth-child(odd){
    padding-right: 8rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-32:nth-child(odd){
    padding-left: 8rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-40:nth-child(odd){
    padding-left: 10rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-40:nth-child(odd){
    padding-right: 10rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-40:nth-child(odd){
    padding-right: 10rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-40:nth-child(odd){
    padding-left: 10rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-44:nth-child(odd){
    padding-left: 11rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-44:nth-child(odd){
    padding-right: 11rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-44:nth-child(odd){
    padding-right: 11rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-44:nth-child(odd){
    padding-left: 11rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-48:nth-child(odd){
    padding-left: 12rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-48:nth-child(odd){
    padding-right: 12rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-48:nth-child(odd){
    padding-right: 12rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-48:nth-child(odd){
    padding-left: 12rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-52:nth-child(odd){
    padding-left: 13rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-52:nth-child(odd){
    padding-right: 13rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-52:nth-child(odd){
    padding-right: 13rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-52:nth-child(odd){
    padding-left: 13rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-56:nth-child(odd){
    padding-left: 14rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-56:nth-child(odd){
    padding-right: 14rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-56:nth-child(odd){
    padding-right: 14rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-56:nth-child(odd){
    padding-left: 14rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-60:nth-child(odd){
    padding-left: 15rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-60:nth-child(odd){
    padding-right: 15rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-60:nth-child(odd){
    padding-right: 15rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-60:nth-child(odd){
    padding-left: 15rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-64:nth-child(odd){
    padding-left: 16rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-64:nth-child(odd){
    padding-right: 16rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-64:nth-child(odd){
    padding-right: 16rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-64:nth-child(odd){
    padding-left: 16rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-68:nth-child(odd){
    padding-left: 17rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-68:nth-child(odd){
    padding-right: 17rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-68:nth-child(odd){
    padding-right: 17rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-68:nth-child(odd){
    padding-left: 17rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-72:nth-child(odd){
    padding-left: 18rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-72:nth-child(odd){
    padding-right: 18rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-72:nth-child(odd){
    padding-right: 18rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-72:nth-child(odd){
    padding-left: 18rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-76:nth-child(odd){
    padding-left: 19rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-76:nth-child(odd){
    padding-right: 19rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-76:nth-child(odd){
    padding-right: 19rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-76:nth-child(odd){
    padding-left: 19rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-80:nth-child(odd){
    padding-left: 20rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-80:nth-child(odd){
    padding-right: 20rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-80:nth-child(odd){
    padding-right: 20rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-80:nth-child(odd){
    padding-left: 20rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-84:nth-child(odd){
    padding-left: 21rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-84:nth-child(odd){
    padding-right: 21rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-84:nth-child(odd){
    padding-right: 21rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-84:nth-child(odd){
    padding-left: 21rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-88:nth-child(odd){
    padding-left: 22rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-88:nth-child(odd){
    padding-right: 22rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-88:nth-child(odd){
    padding-right: 22rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-88:nth-child(odd){
    padding-left: 22rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-92:nth-child(odd){
    padding-left: 23rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-92:nth-child(odd){
    padding-right: 23rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-92:nth-child(odd){
    padding-right: 23rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-92:nth-child(odd){
    padding-left: 23rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-96:nth-child(odd){
    padding-left: 24rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-96:nth-child(odd){
    padding-right: 24rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-96:nth-child(odd){
    padding-right: 24rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-96:nth-child(odd){
    padding-left: 24rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-100:nth-child(odd){
    padding-left: 25rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-100:nth-child(odd){
    padding-right: 25rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-100:nth-child(odd){
    padding-right: 25rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-100:nth-child(odd){
    padding-left: 25rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-104:nth-child(odd){
    padding-left: 26rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-104:nth-child(odd){
    padding-right: 26rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-104:nth-child(odd){
    padding-right: 26rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-104:nth-child(odd){
    padding-left: 26rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-112:nth-child(odd){
    padding-left: 28rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-112:nth-child(odd){
    padding-right: 28rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-112:nth-child(odd){
    padding-right: 28rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-112:nth-child(odd){
    padding-left: 28rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-124:nth-child(odd){
    padding-left: 31rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-124:nth-child(odd){
    padding-right: 31rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-124:nth-child(odd){
    padding-right: 31rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-124:nth-child(odd){
    padding-left: 31rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-128:nth-child(odd){
    padding-left: 32rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-128:nth-child(odd){
    padding-right: 32rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-128:nth-child(odd){
    padding-right: 32rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-128:nth-child(odd){
    padding-left: 32rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-140:nth-child(odd){
    padding-left: 35rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-140:nth-child(odd){
    padding-right: 35rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-140:nth-child(odd){
    padding-right: 35rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-140:nth-child(odd){
    padding-left: 35rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-152:nth-child(odd){
    padding-left: 38rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-152:nth-child(odd){
    padding-right: 38rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-152:nth-child(odd){
    padding-right: 38rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-152:nth-child(odd){
    padding-left: 38rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-160:nth-child(odd){
    padding-left: 40rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-160:nth-child(odd){
    padding-right: 40rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-160:nth-child(odd){
    padding-right: 40rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-160:nth-child(odd){
    padding-left: 40rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-162:nth-child(odd){
    padding-left: 41rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-162:nth-child(odd){
    padding-right: 41rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-162:nth-child(odd){
    padding-right: 41rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-162:nth-child(odd){
    padding-left: 41rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-192:nth-child(odd){
    padding-left: 48rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-192:nth-child(odd){
    padding-right: 48rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-192:nth-child(odd){
    padding-right: 48rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-192:nth-child(odd){
    padding-left: 48rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-208:nth-child(odd){
    padding-left: 52rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-208:nth-child(odd){
    padding-right: 52rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-208:nth-child(odd){
    padding-right: 52rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-208:nth-child(odd){
    padding-left: 52rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-224:nth-child(odd){
    padding-left: 56rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-224:nth-child(odd){
    padding-right: 56rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-224:nth-child(odd){
    padding-right: 56rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-224:nth-child(odd){
    padding-left: 56rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-256:nth-child(odd){
    padding-left: 64rem;
  }

  [dir="rtl"] .md\\:odd\\:ps-256:nth-child(odd){
    padding-right: 64rem;
  }

  [dir="ltr"] .md\\:odd\\:pe-256:nth-child(odd){
    padding-right: 64rem;
  }

  [dir="rtl"] .md\\:odd\\:pe-256:nth-child(odd){
    padding-left: 64rem;
  }

  [dir="ltr"] .md\\:odd\\:ps-px:nth-child(odd){
    padding-left: 1px;
  }

  [dir="rtl"] .md\\:odd\\:ps-px:nth-child(odd){
    padding-right: 1px;
  }

  [dir="ltr"] .md\\:odd\\:pe-px:nth-child(odd){
    padding-right: 1px;
  }

  [dir="rtl"] .md\\:odd\\:pe-px:nth-child(odd){
    padding-left: 1px;
  }

  [dir="ltr"] .md\\:even\\:ps-0:nth-child(even){
    padding-left: 0;
  }

  [dir="rtl"] .md\\:even\\:ps-0:nth-child(even){
    padding-right: 0;
  }

  [dir="ltr"] .md\\:even\\:pe-0:nth-child(even){
    padding-right: 0;
  }

  [dir="rtl"] .md\\:even\\:pe-0:nth-child(even){
    padding-left: 0;
  }

  [dir="ltr"] .md\\:even\\:ps-1:nth-child(even){
    padding-left: 0.25rem;
  }

  [dir="rtl"] .md\\:even\\:ps-1:nth-child(even){
    padding-right: 0.25rem;
  }

  [dir="ltr"] .md\\:even\\:pe-1:nth-child(even){
    padding-right: 0.25rem;
  }

  [dir="rtl"] .md\\:even\\:pe-1:nth-child(even){
    padding-left: 0.25rem;
  }

  [dir="ltr"] .md\\:even\\:ps-2:nth-child(even){
    padding-left: 0.5rem;
  }

  [dir="rtl"] .md\\:even\\:ps-2:nth-child(even){
    padding-right: 0.5rem;
  }

  [dir="ltr"] .md\\:even\\:pe-2:nth-child(even){
    padding-right: 0.5rem;
  }

  [dir="rtl"] .md\\:even\\:pe-2:nth-child(even){
    padding-left: 0.5rem;
  }

  [dir="ltr"] .md\\:even\\:ps-3:nth-child(even){
    padding-left: 0.75rem;
  }

  [dir="rtl"] .md\\:even\\:ps-3:nth-child(even){
    padding-right: 0.75rem;
  }

  [dir="ltr"] .md\\:even\\:pe-3:nth-child(even){
    padding-right: 0.75rem;
  }

  [dir="rtl"] .md\\:even\\:pe-3:nth-child(even){
    padding-left: 0.75rem;
  }

  [dir="ltr"] .md\\:even\\:ps-4:nth-child(even){
    padding-left: 1rem;
  }

  [dir="rtl"] .md\\:even\\:ps-4:nth-child(even){
    padding-right: 1rem;
  }

  [dir="ltr"] .md\\:even\\:pe-4:nth-child(even){
    padding-right: 1rem;
  }

  [dir="rtl"] .md\\:even\\:pe-4:nth-child(even){
    padding-left: 1rem;
  }

  [dir="ltr"] .md\\:even\\:ps-5:nth-child(even){
    padding-left: 1.25rem;
  }

  [dir="rtl"] .md\\:even\\:ps-5:nth-child(even){
    padding-right: 1.25rem;
  }

  [dir="ltr"] .md\\:even\\:pe-5:nth-child(even){
    padding-right: 1.25rem;
  }

  [dir="rtl"] .md\\:even\\:pe-5:nth-child(even){
    padding-left: 1.25rem;
  }

  [dir="ltr"] .md\\:even\\:ps-6:nth-child(even){
    padding-left: 1.5rem;
  }

  [dir="rtl"] .md\\:even\\:ps-6:nth-child(even){
    padding-right: 1.5rem;
  }

  [dir="ltr"] .md\\:even\\:pe-6:nth-child(even){
    padding-right: 1.5rem;
  }

  [dir="rtl"] .md\\:even\\:pe-6:nth-child(even){
    padding-left: 1.5rem;
  }

  [dir="ltr"] .md\\:even\\:ps-7:nth-child(even){
    padding-left: 1.75rem;
  }

  [dir="rtl"] .md\\:even\\:ps-7:nth-child(even){
    padding-right: 1.75rem;
  }

  [dir="ltr"] .md\\:even\\:pe-7:nth-child(even){
    padding-right: 1.75rem;
  }

  [dir="rtl"] .md\\:even\\:pe-7:nth-child(even){
    padding-left: 1.75rem;
  }

  [dir="ltr"] .md\\:even\\:ps-8:nth-child(even){
    padding-left: 2rem;
  }

  [dir="rtl"] .md\\:even\\:ps-8:nth-child(even){
    padding-right: 2rem;
  }

  [dir="ltr"] .md\\:even\\:pe-8:nth-child(even){
    padding-right: 2rem;
  }

  [dir="rtl"] .md\\:even\\:pe-8:nth-child(even){
    padding-left: 2rem;
  }

  [dir="ltr"] .md\\:even\\:ps-9:nth-child(even){
    padding-left: 2.25rem;
  }

  [dir="rtl"] .md\\:even\\:ps-9:nth-child(even){
    padding-right: 2.25rem;
  }

  [dir="ltr"] .md\\:even\\:pe-9:nth-child(even){
    padding-right: 2.25rem;
  }

  [dir="rtl"] .md\\:even\\:pe-9:nth-child(even){
    padding-left: 2.25rem;
  }

  [dir="ltr"] .md\\:even\\:ps-10:nth-child(even){
    padding-left: 2.5rem;
  }

  [dir="rtl"] .md\\:even\\:ps-10:nth-child(even){
    padding-right: 2.5rem;
  }

  [dir="ltr"] .md\\:even\\:pe-10:nth-child(even){
    padding-right: 2.5rem;
  }

  [dir="rtl"] .md\\:even\\:pe-10:nth-child(even){
    padding-left: 2.5rem;
  }

  [dir="ltr"] .md\\:even\\:ps-11:nth-child(even){
    padding-left: 2.75rem;
  }

  [dir="rtl"] .md\\:even\\:ps-11:nth-child(even){
    padding-right: 2.75rem;
  }

  [dir="ltr"] .md\\:even\\:pe-11:nth-child(even){
    padding-right: 2.75rem;
  }

  [dir="rtl"] .md\\:even\\:pe-11:nth-child(even){
    padding-left: 2.75rem;
  }

  [dir="ltr"] .md\\:even\\:ps-12:nth-child(even){
    padding-left: 3rem;
  }

  [dir="rtl"] .md\\:even\\:ps-12:nth-child(even){
    padding-right: 3rem;
  }

  [dir="ltr"] .md\\:even\\:pe-12:nth-child(even){
    padding-right: 3rem;
  }

  [dir="rtl"] .md\\:even\\:pe-12:nth-child(even){
    padding-left: 3rem;
  }

  [dir="ltr"] .md\\:even\\:ps-14:nth-child(even){
    padding-left: 3.5rem;
  }

  [dir="rtl"] .md\\:even\\:ps-14:nth-child(even){
    padding-right: 3.5rem;
  }

  [dir="ltr"] .md\\:even\\:pe-14:nth-child(even){
    padding-right: 3.5rem;
  }

  [dir="rtl"] .md\\:even\\:pe-14:nth-child(even){
    padding-left: 3.5rem;
  }

  [dir="ltr"] .md\\:even\\:ps-15:nth-child(even){
    padding-left: 3.75rem;
  }

  [dir="rtl"] .md\\:even\\:ps-15:nth-child(even){
    padding-right: 3.75rem;
  }

  [dir="ltr"] .md\\:even\\:pe-15:nth-child(even){
    padding-right: 3.75rem;
  }

  [dir="rtl"] .md\\:even\\:pe-15:nth-child(even){
    padding-left: 3.75rem;
  }

  [dir="ltr"] .md\\:even\\:ps-16:nth-child(even){
    padding-left: 4rem;
  }

  [dir="rtl"] .md\\:even\\:ps-16:nth-child(even){
    padding-right: 4rem;
  }

  [dir="ltr"] .md\\:even\\:pe-16:nth-child(even){
    padding-right: 4rem;
  }

  [dir="rtl"] .md\\:even\\:pe-16:nth-child(even){
    padding-left: 4rem;
  }

  [dir="ltr"] .md\\:even\\:ps-18:nth-child(even){
    padding-left: 4.5rem;
  }

  [dir="rtl"] .md\\:even\\:ps-18:nth-child(even){
    padding-right: 4.5rem;
  }

  [dir="ltr"] .md\\:even\\:pe-18:nth-child(even){
    padding-right: 4.5rem;
  }

  [dir="rtl"] .md\\:even\\:pe-18:nth-child(even){
    padding-left: 4.5rem;
  }

  [dir="ltr"] .md\\:even\\:ps-20:nth-child(even){
    padding-left: 5rem;
  }

  [dir="rtl"] .md\\:even\\:ps-20:nth-child(even){
    padding-right: 5rem;
  }

  [dir="ltr"] .md\\:even\\:pe-20:nth-child(even){
    padding-right: 5rem;
  }

  [dir="rtl"] .md\\:even\\:pe-20:nth-child(even){
    padding-left: 5rem;
  }

  [dir="ltr"] .md\\:even\\:ps-22:nth-child(even){
    padding-left: 5.5rem;
  }

  [dir="rtl"] .md\\:even\\:ps-22:nth-child(even){
    padding-right: 5.5rem;
  }

  [dir="ltr"] .md\\:even\\:pe-22:nth-child(even){
    padding-right: 5.5rem;
  }

  [dir="rtl"] .md\\:even\\:pe-22:nth-child(even){
    padding-left: 5.5rem;
  }

  [dir="ltr"] .md\\:even\\:ps-23:nth-child(even){
    padding-left: 5.75rem;
  }

  [dir="rtl"] .md\\:even\\:ps-23:nth-child(even){
    padding-right: 5.75rem;
  }

  [dir="ltr"] .md\\:even\\:pe-23:nth-child(even){
    padding-right: 5.75rem;
  }

  [dir="rtl"] .md\\:even\\:pe-23:nth-child(even){
    padding-left: 5.75rem;
  }

  [dir="ltr"] .md\\:even\\:ps-24:nth-child(even){
    padding-left: 6rem;
  }

  [dir="rtl"] .md\\:even\\:ps-24:nth-child(even){
    padding-right: 6rem;
  }

  [dir="ltr"] .md\\:even\\:pe-24:nth-child(even){
    padding-right: 6rem;
  }

  [dir="rtl"] .md\\:even\\:pe-24:nth-child(even){
    padding-left: 6rem;
  }

  [dir="ltr"] .md\\:even\\:ps-25:nth-child(even){
    padding-left: 6.25rem;
  }

  [dir="rtl"] .md\\:even\\:ps-25:nth-child(even){
    padding-right: 6.25rem;
  }

  [dir="ltr"] .md\\:even\\:pe-25:nth-child(even){
    padding-right: 6.25rem;
  }

  [dir="rtl"] .md\\:even\\:pe-25:nth-child(even){
    padding-left: 6.25rem;
  }

  [dir="ltr"] .md\\:even\\:ps-26:nth-child(even){
    padding-left: 6.5rem;
  }

  [dir="rtl"] .md\\:even\\:ps-26:nth-child(even){
    padding-right: 6.5rem;
  }

  [dir="ltr"] .md\\:even\\:pe-26:nth-child(even){
    padding-right: 6.5rem;
  }

  [dir="rtl"] .md\\:even\\:pe-26:nth-child(even){
    padding-left: 6.5rem;
  }

  [dir="ltr"] .md\\:even\\:ps-28:nth-child(even){
    padding-left: 7rem;
  }

  [dir="rtl"] .md\\:even\\:ps-28:nth-child(even){
    padding-right: 7rem;
  }

  [dir="ltr"] .md\\:even\\:pe-28:nth-child(even){
    padding-right: 7rem;
  }

  [dir="rtl"] .md\\:even\\:pe-28:nth-child(even){
    padding-left: 7rem;
  }

  [dir="ltr"] .md\\:even\\:ps-30:nth-child(even){
    padding-left: 7.5rem;
  }

  [dir="rtl"] .md\\:even\\:ps-30:nth-child(even){
    padding-right: 7.5rem;
  }

  [dir="ltr"] .md\\:even\\:pe-30:nth-child(even){
    padding-right: 7.5rem;
  }

  [dir="rtl"] .md\\:even\\:pe-30:nth-child(even){
    padding-left: 7.5rem;
  }

  [dir="ltr"] .md\\:even\\:ps-32:nth-child(even){
    padding-left: 8rem;
  }

  [dir="rtl"] .md\\:even\\:ps-32:nth-child(even){
    padding-right: 8rem;
  }

  [dir="ltr"] .md\\:even\\:pe-32:nth-child(even){
    padding-right: 8rem;
  }

  [dir="rtl"] .md\\:even\\:pe-32:nth-child(even){
    padding-left: 8rem;
  }

  [dir="ltr"] .md\\:even\\:ps-34:nth-child(even){
    padding-left: 8.5rem;
  }

  [dir="rtl"] .md\\:even\\:ps-34:nth-child(even){
    padding-right: 8.5rem;
  }

  [dir="ltr"] .md\\:even\\:pe-34:nth-child(even){
    padding-right: 8.5rem;
  }

  [dir="rtl"] .md\\:even\\:pe-34:nth-child(even){
    padding-left: 8.5rem;
  }

  [dir="ltr"] .md\\:even\\:ps-40:nth-child(even){
    padding-left: 10rem;
  }

  [dir="rtl"] .md\\:even\\:ps-40:nth-child(even){
    padding-right: 10rem;
  }

  [dir="ltr"] .md\\:even\\:pe-40:nth-child(even){
    padding-right: 10rem;
  }

  [dir="rtl"] .md\\:even\\:pe-40:nth-child(even){
    padding-left: 10rem;
  }

  [dir="ltr"] .md\\:even\\:ps-42:nth-child(even){
    padding-left: 10.5rem;
  }

  [dir="rtl"] .md\\:even\\:ps-42:nth-child(even){
    padding-right: 10.5rem;
  }

  [dir="ltr"] .md\\:even\\:pe-42:nth-child(even){
    padding-right: 10.5rem;
  }

  [dir="rtl"] .md\\:even\\:pe-42:nth-child(even){
    padding-left: 10.5rem;
  }

  [dir="ltr"] .md\\:even\\:ps-44:nth-child(even){
    padding-left: 11rem;
  }

  [dir="rtl"] .md\\:even\\:ps-44:nth-child(even){
    padding-right: 11rem;
  }

  [dir="ltr"] .md\\:even\\:pe-44:nth-child(even){
    padding-right: 11rem;
  }

  [dir="rtl"] .md\\:even\\:pe-44:nth-child(even){
    padding-left: 11rem;
  }

  [dir="ltr"] .md\\:even\\:ps-48:nth-child(even){
    padding-left: 12rem;
  }

  [dir="rtl"] .md\\:even\\:ps-48:nth-child(even){
    padding-right: 12rem;
  }

  [dir="ltr"] .md\\:even\\:pe-48:nth-child(even){
    padding-right: 12rem;
  }

  [dir="rtl"] .md\\:even\\:pe-48:nth-child(even){
    padding-left: 12rem;
  }

  [dir="ltr"] .md\\:even\\:ps-52:nth-child(even){
    padding-left: 13rem;
  }

  [dir="rtl"] .md\\:even\\:ps-52:nth-child(even){
    padding-right: 13rem;
  }

  [dir="ltr"] .md\\:even\\:pe-52:nth-child(even){
    padding-right: 13rem;
  }

  [dir="rtl"] .md\\:even\\:pe-52:nth-child(even){
    padding-left: 13rem;
  }

  [dir="ltr"] .md\\:even\\:ps-54:nth-child(even){
    padding-left: 13.5rem;
  }

  [dir="rtl"] .md\\:even\\:ps-54:nth-child(even){
    padding-right: 13.5rem;
  }

  [dir="ltr"] .md\\:even\\:pe-54:nth-child(even){
    padding-right: 13.5rem;
  }

  [dir="rtl"] .md\\:even\\:pe-54:nth-child(even){
    padding-left: 13.5rem;
  }

  [dir="ltr"] .md\\:even\\:ps-56:nth-child(even){
    padding-left: 14rem;
  }

  [dir="rtl"] .md\\:even\\:ps-56:nth-child(even){
    padding-right: 14rem;
  }

  [dir="ltr"] .md\\:even\\:pe-56:nth-child(even){
    padding-right: 14rem;
  }

  [dir="rtl"] .md\\:even\\:pe-56:nth-child(even){
    padding-left: 14rem;
  }

  [dir="ltr"] .md\\:even\\:ps-60:nth-child(even){
    padding-left: 15rem;
  }

  [dir="rtl"] .md\\:even\\:ps-60:nth-child(even){
    padding-right: 15rem;
  }

  [dir="ltr"] .md\\:even\\:pe-60:nth-child(even){
    padding-right: 15rem;
  }

  [dir="rtl"] .md\\:even\\:pe-60:nth-child(even){
    padding-left: 15rem;
  }

  [dir="ltr"] .md\\:even\\:ps-64:nth-child(even){
    padding-left: 16rem;
  }

  [dir="rtl"] .md\\:even\\:ps-64:nth-child(even){
    padding-right: 16rem;
  }

  [dir="ltr"] .md\\:even\\:pe-64:nth-child(even){
    padding-right: 16rem;
  }

  [dir="rtl"] .md\\:even\\:pe-64:nth-child(even){
    padding-left: 16rem;
  }

  [dir="ltr"] .md\\:even\\:ps-68:nth-child(even){
    padding-left: 17rem;
  }

  [dir="rtl"] .md\\:even\\:ps-68:nth-child(even){
    padding-right: 17rem;
  }

  [dir="ltr"] .md\\:even\\:pe-68:nth-child(even){
    padding-right: 17rem;
  }

  [dir="rtl"] .md\\:even\\:pe-68:nth-child(even){
    padding-left: 17rem;
  }

  [dir="ltr"] .md\\:even\\:ps-72:nth-child(even){
    padding-left: 18rem;
  }

  [dir="rtl"] .md\\:even\\:ps-72:nth-child(even){
    padding-right: 18rem;
  }

  [dir="ltr"] .md\\:even\\:pe-72:nth-child(even){
    padding-right: 18rem;
  }

  [dir="rtl"] .md\\:even\\:pe-72:nth-child(even){
    padding-left: 18rem;
  }

  [dir="ltr"] .md\\:even\\:ps-74:nth-child(even){
    padding-left: 18.5rem;
  }

  [dir="rtl"] .md\\:even\\:ps-74:nth-child(even){
    padding-right: 18.5rem;
  }

  [dir="ltr"] .md\\:even\\:pe-74:nth-child(even){
    padding-right: 18.5rem;
  }

  [dir="rtl"] .md\\:even\\:pe-74:nth-child(even){
    padding-left: 18.5rem;
  }

  [dir="ltr"] .md\\:even\\:ps-76:nth-child(even){
    padding-left: 19rem;
  }

  [dir="rtl"] .md\\:even\\:ps-76:nth-child(even){
    padding-right: 19rem;
  }

  [dir="ltr"] .md\\:even\\:pe-76:nth-child(even){
    padding-right: 19rem;
  }

  [dir="rtl"] .md\\:even\\:pe-76:nth-child(even){
    padding-left: 19rem;
  }

  [dir="ltr"] .md\\:even\\:ps-78:nth-child(even){
    padding-left: 19.5rem;
  }

  [dir="rtl"] .md\\:even\\:ps-78:nth-child(even){
    padding-right: 19.5rem;
  }

  [dir="ltr"] .md\\:even\\:pe-78:nth-child(even){
    padding-right: 19.5rem;
  }

  [dir="rtl"] .md\\:even\\:pe-78:nth-child(even){
    padding-left: 19.5rem;
  }

  [dir="ltr"] .md\\:even\\:ps-80:nth-child(even){
    padding-left: 20rem;
  }

  [dir="rtl"] .md\\:even\\:ps-80:nth-child(even){
    padding-right: 20rem;
  }

  [dir="ltr"] .md\\:even\\:pe-80:nth-child(even){
    padding-right: 20rem;
  }

  [dir="rtl"] .md\\:even\\:pe-80:nth-child(even){
    padding-left: 20rem;
  }

  [dir="ltr"] .md\\:even\\:ps-82:nth-child(even){
    padding-left: 20.5rem;
  }

  [dir="rtl"] .md\\:even\\:ps-82:nth-child(even){
    padding-right: 20.5rem;
  }

  [dir="ltr"] .md\\:even\\:pe-82:nth-child(even){
    padding-right: 20.5rem;
  }

  [dir="rtl"] .md\\:even\\:pe-82:nth-child(even){
    padding-left: 20.5rem;
  }

  [dir="ltr"] .md\\:even\\:ps-84:nth-child(even){
    padding-left: 21rem;
  }

  [dir="rtl"] .md\\:even\\:ps-84:nth-child(even){
    padding-right: 21rem;
  }

  [dir="ltr"] .md\\:even\\:pe-84:nth-child(even){
    padding-right: 21rem;
  }

  [dir="rtl"] .md\\:even\\:pe-84:nth-child(even){
    padding-left: 21rem;
  }

  [dir="ltr"] .md\\:even\\:ps-88:nth-child(even){
    padding-left: 22rem;
  }

  [dir="rtl"] .md\\:even\\:ps-88:nth-child(even){
    padding-right: 22rem;
  }

  [dir="ltr"] .md\\:even\\:pe-88:nth-child(even){
    padding-right: 22rem;
  }

  [dir="rtl"] .md\\:even\\:pe-88:nth-child(even){
    padding-left: 22rem;
  }

  [dir="ltr"] .md\\:even\\:ps-92:nth-child(even){
    padding-left: 23rem;
  }

  [dir="rtl"] .md\\:even\\:ps-92:nth-child(even){
    padding-right: 23rem;
  }

  [dir="ltr"] .md\\:even\\:pe-92:nth-child(even){
    padding-right: 23rem;
  }

  [dir="rtl"] .md\\:even\\:pe-92:nth-child(even){
    padding-left: 23rem;
  }

  [dir="ltr"] .md\\:even\\:ps-96:nth-child(even){
    padding-left: 24rem;
  }

  [dir="rtl"] .md\\:even\\:ps-96:nth-child(even){
    padding-right: 24rem;
  }

  [dir="ltr"] .md\\:even\\:pe-96:nth-child(even){
    padding-right: 24rem;
  }

  [dir="rtl"] .md\\:even\\:pe-96:nth-child(even){
    padding-left: 24rem;
  }

  [dir="ltr"] .md\\:even\\:ps-98:nth-child(even){
    padding-left: 24.5rem;
  }

  [dir="rtl"] .md\\:even\\:ps-98:nth-child(even){
    padding-right: 24.5rem;
  }

  [dir="ltr"] .md\\:even\\:pe-98:nth-child(even){
    padding-right: 24.5rem;
  }

  [dir="rtl"] .md\\:even\\:pe-98:nth-child(even){
    padding-left: 24.5rem;
  }

  [dir="ltr"] .md\\:even\\:ps-100:nth-child(even){
    padding-left: 25rem;
  }

  [dir="rtl"] .md\\:even\\:ps-100:nth-child(even){
    padding-right: 25rem;
  }

  [dir="ltr"] .md\\:even\\:pe-100:nth-child(even){
    padding-right: 25rem;
  }

  [dir="rtl"] .md\\:even\\:pe-100:nth-child(even){
    padding-left: 25rem;
  }

  [dir="ltr"] .md\\:even\\:ps-104:nth-child(even){
    padding-left: 26rem;
  }

  [dir="rtl"] .md\\:even\\:ps-104:nth-child(even){
    padding-right: 26rem;
  }

  [dir="ltr"] .md\\:even\\:pe-104:nth-child(even){
    padding-right: 26rem;
  }

  [dir="rtl"] .md\\:even\\:pe-104:nth-child(even){
    padding-left: 26rem;
  }

  [dir="ltr"] .md\\:even\\:ps-112:nth-child(even){
    padding-left: 28rem;
  }

  [dir="rtl"] .md\\:even\\:ps-112:nth-child(even){
    padding-right: 28rem;
  }

  [dir="ltr"] .md\\:even\\:pe-112:nth-child(even){
    padding-right: 28rem;
  }

  [dir="rtl"] .md\\:even\\:pe-112:nth-child(even){
    padding-left: 28rem;
  }

  [dir="ltr"] .md\\:even\\:ps-124:nth-child(even){
    padding-left: 31rem;
  }

  [dir="rtl"] .md\\:even\\:ps-124:nth-child(even){
    padding-right: 31rem;
  }

  [dir="ltr"] .md\\:even\\:pe-124:nth-child(even){
    padding-right: 31rem;
  }

  [dir="rtl"] .md\\:even\\:pe-124:nth-child(even){
    padding-left: 31rem;
  }

  [dir="ltr"] .md\\:even\\:ps-128:nth-child(even){
    padding-left: 32rem;
  }

  [dir="rtl"] .md\\:even\\:ps-128:nth-child(even){
    padding-right: 32rem;
  }

  [dir="ltr"] .md\\:even\\:pe-128:nth-child(even){
    padding-right: 32rem;
  }

  [dir="rtl"] .md\\:even\\:pe-128:nth-child(even){
    padding-left: 32rem;
  }

  [dir="ltr"] .md\\:even\\:ps-140:nth-child(even){
    padding-left: 35rem;
  }

  [dir="rtl"] .md\\:even\\:ps-140:nth-child(even){
    padding-right: 35rem;
  }

  [dir="ltr"] .md\\:even\\:pe-140:nth-child(even){
    padding-right: 35rem;
  }

  [dir="rtl"] .md\\:even\\:pe-140:nth-child(even){
    padding-left: 35rem;
  }

  [dir="ltr"] .md\\:even\\:ps-152:nth-child(even){
    padding-left: 38rem;
  }

  [dir="rtl"] .md\\:even\\:ps-152:nth-child(even){
    padding-right: 38rem;
  }

  [dir="ltr"] .md\\:even\\:pe-152:nth-child(even){
    padding-right: 38rem;
  }

  [dir="rtl"] .md\\:even\\:pe-152:nth-child(even){
    padding-left: 38rem;
  }

  [dir="ltr"] .md\\:even\\:ps-160:nth-child(even){
    padding-left: 40rem;
  }

  [dir="rtl"] .md\\:even\\:ps-160:nth-child(even){
    padding-right: 40rem;
  }

  [dir="ltr"] .md\\:even\\:pe-160:nth-child(even){
    padding-right: 40rem;
  }

  [dir="rtl"] .md\\:even\\:pe-160:nth-child(even){
    padding-left: 40rem;
  }

  [dir="ltr"] .md\\:even\\:ps-162:nth-child(even){
    padding-left: 41rem;
  }

  [dir="rtl"] .md\\:even\\:ps-162:nth-child(even){
    padding-right: 41rem;
  }

  [dir="ltr"] .md\\:even\\:pe-162:nth-child(even){
    padding-right: 41rem;
  }

  [dir="rtl"] .md\\:even\\:pe-162:nth-child(even){
    padding-left: 41rem;
  }

  [dir="ltr"] .md\\:even\\:ps-192:nth-child(even){
    padding-left: 48rem;
  }

  [dir="rtl"] .md\\:even\\:ps-192:nth-child(even){
    padding-right: 48rem;
  }

  [dir="ltr"] .md\\:even\\:pe-192:nth-child(even){
    padding-right: 48rem;
  }

  [dir="rtl"] .md\\:even\\:pe-192:nth-child(even){
    padding-left: 48rem;
  }

  [dir="ltr"] .md\\:even\\:ps-208:nth-child(even){
    padding-left: 52rem;
  }

  [dir="rtl"] .md\\:even\\:ps-208:nth-child(even){
    padding-right: 52rem;
  }

  [dir="ltr"] .md\\:even\\:pe-208:nth-child(even){
    padding-right: 52rem;
  }

  [dir="rtl"] .md\\:even\\:pe-208:nth-child(even){
    padding-left: 52rem;
  }

  [dir="ltr"] .md\\:even\\:ps-224:nth-child(even){
    padding-left: 56rem;
  }

  [dir="rtl"] .md\\:even\\:ps-224:nth-child(even){
    padding-right: 56rem;
  }

  [dir="ltr"] .md\\:even\\:pe-224:nth-child(even){
    padding-right: 56rem;
  }

  [dir="rtl"] .md\\:even\\:pe-224:nth-child(even){
    padding-left: 56rem;
  }

  [dir="ltr"] .md\\:even\\:ps-256:nth-child(even){
    padding-left: 64rem;
  }

  [dir="rtl"] .md\\:even\\:ps-256:nth-child(even){
    padding-right: 64rem;
  }

  [dir="ltr"] .md\\:even\\:pe-256:nth-child(even){
    padding-right: 64rem;
  }

  [dir="rtl"] .md\\:even\\:pe-256:nth-child(even){
    padding-left: 64rem;
  }

  [dir="ltr"] .md\\:even\\:ps-px:nth-child(even){
    padding-left: 1px;
  }

  [dir="rtl"] .md\\:even\\:ps-px:nth-child(even){
    padding-right: 1px;
  }

  [dir="ltr"] .md\\:even\\:pe-px:nth-child(even){
    padding-right: 1px;
  }

  [dir="rtl"] .md\\:even\\:pe-px:nth-child(even){
    padding-left: 1px;
  }

  [dir="ltr"] .md\\:ms-0{
    margin-left: 0;
  }

  [dir="rtl"] .md\\:ms-0{
    margin-right: 0;
  }

  [dir="ltr"] .md\\:me-0{
    margin-right: 0;
  }

  [dir="rtl"] .md\\:me-0{
    margin-left: 0;
  }

  [dir="ltr"] .md\\:ms-1{
    margin-left: 0.25rem;
  }

  [dir="rtl"] .md\\:ms-1{
    margin-right: 0.25rem;
  }

  [dir="ltr"] .md\\:me-1{
    margin-right: 0.25rem;
  }

  [dir="rtl"] .md\\:me-1{
    margin-left: 0.25rem;
  }

  [dir="ltr"] .md\\:ms-2{
    margin-left: 0.5rem;
  }

  [dir="rtl"] .md\\:ms-2{
    margin-right: 0.5rem;
  }

  [dir="ltr"] .md\\:me-2{
    margin-right: 0.5rem;
  }

  [dir="rtl"] .md\\:me-2{
    margin-left: 0.5rem;
  }

  [dir="ltr"] .md\\:ms-3{
    margin-left: 0.75rem;
  }

  [dir="rtl"] .md\\:ms-3{
    margin-right: 0.75rem;
  }

  [dir="ltr"] .md\\:me-3{
    margin-right: 0.75rem;
  }

  [dir="rtl"] .md\\:me-3{
    margin-left: 0.75rem;
  }

  [dir="ltr"] .md\\:ms-4{
    margin-left: 1rem;
  }

  [dir="rtl"] .md\\:ms-4{
    margin-right: 1rem;
  }

  [dir="ltr"] .md\\:me-4{
    margin-right: 1rem;
  }

  [dir="rtl"] .md\\:me-4{
    margin-left: 1rem;
  }

  [dir="ltr"] .md\\:ms-5{
    margin-left: 1.25rem;
  }

  [dir="rtl"] .md\\:ms-5{
    margin-right: 1.25rem;
  }

  [dir="ltr"] .md\\:me-5{
    margin-right: 1.25rem;
  }

  [dir="rtl"] .md\\:me-5{
    margin-left: 1.25rem;
  }

  [dir="ltr"] .md\\:ms-6{
    margin-left: 1.5rem;
  }

  [dir="rtl"] .md\\:ms-6{
    margin-right: 1.5rem;
  }

  [dir="ltr"] .md\\:me-6{
    margin-right: 1.5rem;
  }

  [dir="rtl"] .md\\:me-6{
    margin-left: 1.5rem;
  }

  [dir="ltr"] .md\\:ms-7{
    margin-left: 1.75rem;
  }

  [dir="rtl"] .md\\:ms-7{
    margin-right: 1.75rem;
  }

  [dir="ltr"] .md\\:me-7{
    margin-right: 1.75rem;
  }

  [dir="rtl"] .md\\:me-7{
    margin-left: 1.75rem;
  }

  [dir="ltr"] .md\\:ms-8{
    margin-left: 2rem;
  }

  [dir="rtl"] .md\\:ms-8{
    margin-right: 2rem;
  }

  [dir="ltr"] .md\\:me-8{
    margin-right: 2rem;
  }

  [dir="rtl"] .md\\:me-8{
    margin-left: 2rem;
  }

  [dir="ltr"] .md\\:ms-9{
    margin-left: 2.25rem;
  }

  [dir="rtl"] .md\\:ms-9{
    margin-right: 2.25rem;
  }

  [dir="ltr"] .md\\:me-9{
    margin-right: 2.25rem;
  }

  [dir="rtl"] .md\\:me-9{
    margin-left: 2.25rem;
  }

  [dir="ltr"] .md\\:ms-10{
    margin-left: 2.5rem;
  }

  [dir="rtl"] .md\\:ms-10{
    margin-right: 2.5rem;
  }

  [dir="ltr"] .md\\:me-10{
    margin-right: 2.5rem;
  }

  [dir="rtl"] .md\\:me-10{
    margin-left: 2.5rem;
  }

  [dir="ltr"] .md\\:ms-11{
    margin-left: 2.75rem;
  }

  [dir="rtl"] .md\\:ms-11{
    margin-right: 2.75rem;
  }

  [dir="ltr"] .md\\:me-11{
    margin-right: 2.75rem;
  }

  [dir="rtl"] .md\\:me-11{
    margin-left: 2.75rem;
  }

  [dir="ltr"] .md\\:ms-12{
    margin-left: 3rem;
  }

  [dir="rtl"] .md\\:ms-12{
    margin-right: 3rem;
  }

  [dir="ltr"] .md\\:me-12{
    margin-right: 3rem;
  }

  [dir="rtl"] .md\\:me-12{
    margin-left: 3rem;
  }

  [dir="ltr"] .md\\:ms-14{
    margin-left: 3.5rem;
  }

  [dir="rtl"] .md\\:ms-14{
    margin-right: 3.5rem;
  }

  [dir="ltr"] .md\\:me-14{
    margin-right: 3.5rem;
  }

  [dir="rtl"] .md\\:me-14{
    margin-left: 3.5rem;
  }

  [dir="ltr"] .md\\:ms-15{
    margin-left: 3.75rem;
  }

  [dir="rtl"] .md\\:ms-15{
    margin-right: 3.75rem;
  }

  [dir="ltr"] .md\\:me-15{
    margin-right: 3.75rem;
  }

  [dir="rtl"] .md\\:me-15{
    margin-left: 3.75rem;
  }

  [dir="ltr"] .md\\:ms-16{
    margin-left: 4rem;
  }

  [dir="rtl"] .md\\:ms-16{
    margin-right: 4rem;
  }

  [dir="ltr"] .md\\:me-16{
    margin-right: 4rem;
  }

  [dir="rtl"] .md\\:me-16{
    margin-left: 4rem;
  }

  [dir="ltr"] .md\\:ms-18{
    margin-left: 4.5rem;
  }

  [dir="rtl"] .md\\:ms-18{
    margin-right: 4.5rem;
  }

  [dir="ltr"] .md\\:me-18{
    margin-right: 4.5rem;
  }

  [dir="rtl"] .md\\:me-18{
    margin-left: 4.5rem;
  }

  [dir="ltr"] .md\\:ms-20{
    margin-left: 5rem;
  }

  [dir="rtl"] .md\\:ms-20{
    margin-right: 5rem;
  }

  [dir="ltr"] .md\\:me-20{
    margin-right: 5rem;
  }

  [dir="rtl"] .md\\:me-20{
    margin-left: 5rem;
  }

  [dir="ltr"] .md\\:ms-22{
    margin-left: 5.5rem;
  }

  [dir="rtl"] .md\\:ms-22{
    margin-right: 5.5rem;
  }

  [dir="ltr"] .md\\:me-22{
    margin-right: 5.5rem;
  }

  [dir="rtl"] .md\\:me-22{
    margin-left: 5.5rem;
  }

  [dir="ltr"] .md\\:ms-23{
    margin-left: 5.75rem;
  }

  [dir="rtl"] .md\\:ms-23{
    margin-right: 5.75rem;
  }

  [dir="ltr"] .md\\:me-23{
    margin-right: 5.75rem;
  }

  [dir="rtl"] .md\\:me-23{
    margin-left: 5.75rem;
  }

  [dir="ltr"] .md\\:ms-24{
    margin-left: 6rem;
  }

  [dir="rtl"] .md\\:ms-24{
    margin-right: 6rem;
  }

  [dir="ltr"] .md\\:me-24{
    margin-right: 6rem;
  }

  [dir="rtl"] .md\\:me-24{
    margin-left: 6rem;
  }

  [dir="ltr"] .md\\:ms-25{
    margin-left: 6.25rem;
  }

  [dir="rtl"] .md\\:ms-25{
    margin-right: 6.25rem;
  }

  [dir="ltr"] .md\\:me-25{
    margin-right: 6.25rem;
  }

  [dir="rtl"] .md\\:me-25{
    margin-left: 6.25rem;
  }

  [dir="ltr"] .md\\:ms-26{
    margin-left: 6.5rem;
  }

  [dir="rtl"] .md\\:ms-26{
    margin-right: 6.5rem;
  }

  [dir="ltr"] .md\\:me-26{
    margin-right: 6.5rem;
  }

  [dir="rtl"] .md\\:me-26{
    margin-left: 6.5rem;
  }

  [dir="ltr"] .md\\:ms-28{
    margin-left: 7rem;
  }

  [dir="rtl"] .md\\:ms-28{
    margin-right: 7rem;
  }

  [dir="ltr"] .md\\:me-28{
    margin-right: 7rem;
  }

  [dir="rtl"] .md\\:me-28{
    margin-left: 7rem;
  }

  [dir="ltr"] .md\\:ms-30{
    margin-left: 7.5rem;
  }

  [dir="rtl"] .md\\:ms-30{
    margin-right: 7.5rem;
  }

  [dir="ltr"] .md\\:me-30{
    margin-right: 7.5rem;
  }

  [dir="rtl"] .md\\:me-30{
    margin-left: 7.5rem;
  }

  [dir="ltr"] .md\\:ms-32{
    margin-left: 8rem;
  }

  [dir="rtl"] .md\\:ms-32{
    margin-right: 8rem;
  }

  [dir="ltr"] .md\\:me-32{
    margin-right: 8rem;
  }

  [dir="rtl"] .md\\:me-32{
    margin-left: 8rem;
  }

  [dir="ltr"] .md\\:ms-34{
    margin-left: 8.5rem;
  }

  [dir="rtl"] .md\\:ms-34{
    margin-right: 8.5rem;
  }

  [dir="ltr"] .md\\:me-34{
    margin-right: 8.5rem;
  }

  [dir="rtl"] .md\\:me-34{
    margin-left: 8.5rem;
  }

  [dir="ltr"] .md\\:ms-40{
    margin-left: 10rem;
  }

  [dir="rtl"] .md\\:ms-40{
    margin-right: 10rem;
  }

  [dir="ltr"] .md\\:me-40{
    margin-right: 10rem;
  }

  [dir="rtl"] .md\\:me-40{
    margin-left: 10rem;
  }

  [dir="ltr"] .md\\:ms-42{
    margin-left: 10.5rem;
  }

  [dir="rtl"] .md\\:ms-42{
    margin-right: 10.5rem;
  }

  [dir="ltr"] .md\\:me-42{
    margin-right: 10.5rem;
  }

  [dir="rtl"] .md\\:me-42{
    margin-left: 10.5rem;
  }

  [dir="ltr"] .md\\:ms-44{
    margin-left: 11rem;
  }

  [dir="rtl"] .md\\:ms-44{
    margin-right: 11rem;
  }

  [dir="ltr"] .md\\:me-44{
    margin-right: 11rem;
  }

  [dir="rtl"] .md\\:me-44{
    margin-left: 11rem;
  }

  [dir="ltr"] .md\\:ms-48{
    margin-left: 12rem;
  }

  [dir="rtl"] .md\\:ms-48{
    margin-right: 12rem;
  }

  [dir="ltr"] .md\\:me-48{
    margin-right: 12rem;
  }

  [dir="rtl"] .md\\:me-48{
    margin-left: 12rem;
  }

  [dir="ltr"] .md\\:ms-52{
    margin-left: 13rem;
  }

  [dir="rtl"] .md\\:ms-52{
    margin-right: 13rem;
  }

  [dir="ltr"] .md\\:me-52{
    margin-right: 13rem;
  }

  [dir="rtl"] .md\\:me-52{
    margin-left: 13rem;
  }

  [dir="ltr"] .md\\:ms-54{
    margin-left: 13.5rem;
  }

  [dir="rtl"] .md\\:ms-54{
    margin-right: 13.5rem;
  }

  [dir="ltr"] .md\\:me-54{
    margin-right: 13.5rem;
  }

  [dir="rtl"] .md\\:me-54{
    margin-left: 13.5rem;
  }

  [dir="ltr"] .md\\:ms-56{
    margin-left: 14rem;
  }

  [dir="rtl"] .md\\:ms-56{
    margin-right: 14rem;
  }

  [dir="ltr"] .md\\:me-56{
    margin-right: 14rem;
  }

  [dir="rtl"] .md\\:me-56{
    margin-left: 14rem;
  }

  [dir="ltr"] .md\\:ms-60{
    margin-left: 15rem;
  }

  [dir="rtl"] .md\\:ms-60{
    margin-right: 15rem;
  }

  [dir="ltr"] .md\\:me-60{
    margin-right: 15rem;
  }

  [dir="rtl"] .md\\:me-60{
    margin-left: 15rem;
  }

  [dir="ltr"] .md\\:ms-64{
    margin-left: 16rem;
  }

  [dir="rtl"] .md\\:ms-64{
    margin-right: 16rem;
  }

  [dir="ltr"] .md\\:me-64{
    margin-right: 16rem;
  }

  [dir="rtl"] .md\\:me-64{
    margin-left: 16rem;
  }

  [dir="ltr"] .md\\:ms-68{
    margin-left: 17rem;
  }

  [dir="rtl"] .md\\:ms-68{
    margin-right: 17rem;
  }

  [dir="ltr"] .md\\:me-68{
    margin-right: 17rem;
  }

  [dir="rtl"] .md\\:me-68{
    margin-left: 17rem;
  }

  [dir="ltr"] .md\\:ms-72{
    margin-left: 18rem;
  }

  [dir="rtl"] .md\\:ms-72{
    margin-right: 18rem;
  }

  [dir="ltr"] .md\\:me-72{
    margin-right: 18rem;
  }

  [dir="rtl"] .md\\:me-72{
    margin-left: 18rem;
  }

  [dir="ltr"] .md\\:ms-74{
    margin-left: 18.5rem;
  }

  [dir="rtl"] .md\\:ms-74{
    margin-right: 18.5rem;
  }

  [dir="ltr"] .md\\:me-74{
    margin-right: 18.5rem;
  }

  [dir="rtl"] .md\\:me-74{
    margin-left: 18.5rem;
  }

  [dir="ltr"] .md\\:ms-76{
    margin-left: 19rem;
  }

  [dir="rtl"] .md\\:ms-76{
    margin-right: 19rem;
  }

  [dir="ltr"] .md\\:me-76{
    margin-right: 19rem;
  }

  [dir="rtl"] .md\\:me-76{
    margin-left: 19rem;
  }

  [dir="ltr"] .md\\:ms-78{
    margin-left: 19.5rem;
  }

  [dir="rtl"] .md\\:ms-78{
    margin-right: 19.5rem;
  }

  [dir="ltr"] .md\\:me-78{
    margin-right: 19.5rem;
  }

  [dir="rtl"] .md\\:me-78{
    margin-left: 19.5rem;
  }

  [dir="ltr"] .md\\:ms-80{
    margin-left: 20rem;
  }

  [dir="rtl"] .md\\:ms-80{
    margin-right: 20rem;
  }

  [dir="ltr"] .md\\:me-80{
    margin-right: 20rem;
  }

  [dir="rtl"] .md\\:me-80{
    margin-left: 20rem;
  }

  [dir="ltr"] .md\\:ms-82{
    margin-left: 20.5rem;
  }

  [dir="rtl"] .md\\:ms-82{
    margin-right: 20.5rem;
  }

  [dir="ltr"] .md\\:me-82{
    margin-right: 20.5rem;
  }

  [dir="rtl"] .md\\:me-82{
    margin-left: 20.5rem;
  }

  [dir="ltr"] .md\\:ms-84{
    margin-left: 21rem;
  }

  [dir="rtl"] .md\\:ms-84{
    margin-right: 21rem;
  }

  [dir="ltr"] .md\\:me-84{
    margin-right: 21rem;
  }

  [dir="rtl"] .md\\:me-84{
    margin-left: 21rem;
  }

  [dir="ltr"] .md\\:ms-88{
    margin-left: 22rem;
  }

  [dir="rtl"] .md\\:ms-88{
    margin-right: 22rem;
  }

  [dir="ltr"] .md\\:me-88{
    margin-right: 22rem;
  }

  [dir="rtl"] .md\\:me-88{
    margin-left: 22rem;
  }

  [dir="ltr"] .md\\:ms-92{
    margin-left: 23rem;
  }

  [dir="rtl"] .md\\:ms-92{
    margin-right: 23rem;
  }

  [dir="ltr"] .md\\:me-92{
    margin-right: 23rem;
  }

  [dir="rtl"] .md\\:me-92{
    margin-left: 23rem;
  }

  [dir="ltr"] .md\\:ms-96{
    margin-left: 24rem;
  }

  [dir="rtl"] .md\\:ms-96{
    margin-right: 24rem;
  }

  [dir="ltr"] .md\\:me-96{
    margin-right: 24rem;
  }

  [dir="rtl"] .md\\:me-96{
    margin-left: 24rem;
  }

  [dir="ltr"] .md\\:ms-98{
    margin-left: 24.5rem;
  }

  [dir="rtl"] .md\\:ms-98{
    margin-right: 24.5rem;
  }

  [dir="ltr"] .md\\:me-98{
    margin-right: 24.5rem;
  }

  [dir="rtl"] .md\\:me-98{
    margin-left: 24.5rem;
  }

  [dir="ltr"] .md\\:ms-100{
    margin-left: 25rem;
  }

  [dir="rtl"] .md\\:ms-100{
    margin-right: 25rem;
  }

  [dir="ltr"] .md\\:me-100{
    margin-right: 25rem;
  }

  [dir="rtl"] .md\\:me-100{
    margin-left: 25rem;
  }

  [dir="ltr"] .md\\:ms-104{
    margin-left: 26rem;
  }

  [dir="rtl"] .md\\:ms-104{
    margin-right: 26rem;
  }

  [dir="ltr"] .md\\:me-104{
    margin-right: 26rem;
  }

  [dir="rtl"] .md\\:me-104{
    margin-left: 26rem;
  }

  [dir="ltr"] .md\\:ms-112{
    margin-left: 28rem;
  }

  [dir="rtl"] .md\\:ms-112{
    margin-right: 28rem;
  }

  [dir="ltr"] .md\\:me-112{
    margin-right: 28rem;
  }

  [dir="rtl"] .md\\:me-112{
    margin-left: 28rem;
  }

  [dir="ltr"] .md\\:ms-124{
    margin-left: 31rem;
  }

  [dir="rtl"] .md\\:ms-124{
    margin-right: 31rem;
  }

  [dir="ltr"] .md\\:me-124{
    margin-right: 31rem;
  }

  [dir="rtl"] .md\\:me-124{
    margin-left: 31rem;
  }

  [dir="ltr"] .md\\:ms-128{
    margin-left: 32rem;
  }

  [dir="rtl"] .md\\:ms-128{
    margin-right: 32rem;
  }

  [dir="ltr"] .md\\:me-128{
    margin-right: 32rem;
  }

  [dir="rtl"] .md\\:me-128{
    margin-left: 32rem;
  }

  [dir="ltr"] .md\\:ms-140{
    margin-left: 35rem;
  }

  [dir="rtl"] .md\\:ms-140{
    margin-right: 35rem;
  }

  [dir="ltr"] .md\\:me-140{
    margin-right: 35rem;
  }

  [dir="rtl"] .md\\:me-140{
    margin-left: 35rem;
  }

  [dir="ltr"] .md\\:ms-152{
    margin-left: 38rem;
  }

  [dir="rtl"] .md\\:ms-152{
    margin-right: 38rem;
  }

  [dir="ltr"] .md\\:me-152{
    margin-right: 38rem;
  }

  [dir="rtl"] .md\\:me-152{
    margin-left: 38rem;
  }

  [dir="ltr"] .md\\:ms-160{
    margin-left: 40rem;
  }

  [dir="rtl"] .md\\:ms-160{
    margin-right: 40rem;
  }

  [dir="ltr"] .md\\:me-160{
    margin-right: 40rem;
  }

  [dir="rtl"] .md\\:me-160{
    margin-left: 40rem;
  }

  [dir="ltr"] .md\\:ms-162{
    margin-left: 41rem;
  }

  [dir="rtl"] .md\\:ms-162{
    margin-right: 41rem;
  }

  [dir="ltr"] .md\\:me-162{
    margin-right: 41rem;
  }

  [dir="rtl"] .md\\:me-162{
    margin-left: 41rem;
  }

  [dir="ltr"] .md\\:ms-192{
    margin-left: 48rem;
  }

  [dir="rtl"] .md\\:ms-192{
    margin-right: 48rem;
  }

  [dir="ltr"] .md\\:me-192{
    margin-right: 48rem;
  }

  [dir="rtl"] .md\\:me-192{
    margin-left: 48rem;
  }

  [dir="ltr"] .md\\:ms-208{
    margin-left: 52rem;
  }

  [dir="rtl"] .md\\:ms-208{
    margin-right: 52rem;
  }

  [dir="ltr"] .md\\:me-208{
    margin-right: 52rem;
  }

  [dir="rtl"] .md\\:me-208{
    margin-left: 52rem;
  }

  [dir="ltr"] .md\\:ms-224{
    margin-left: 56rem;
  }

  [dir="rtl"] .md\\:ms-224{
    margin-right: 56rem;
  }

  [dir="ltr"] .md\\:me-224{
    margin-right: 56rem;
  }

  [dir="rtl"] .md\\:me-224{
    margin-left: 56rem;
  }

  [dir="ltr"] .md\\:ms-256{
    margin-left: 64rem;
  }

  [dir="rtl"] .md\\:ms-256{
    margin-right: 64rem;
  }

  [dir="ltr"] .md\\:me-256{
    margin-right: 64rem;
  }

  [dir="rtl"] .md\\:me-256{
    margin-left: 64rem;
  }

  [dir="ltr"] .md\\:ms-auto{
    margin-left: auto;
  }

  [dir="rtl"] .md\\:ms-auto{
    margin-right: auto;
  }

  [dir="ltr"] .md\\:me-auto{
    margin-right: auto;
  }

  [dir="rtl"] .md\\:me-auto{
    margin-left: auto;
  }

  [dir="ltr"] .md\\:ms-px{
    margin-left: 1px;
  }

  [dir="rtl"] .md\\:ms-px{
    margin-right: 1px;
  }

  [dir="ltr"] .md\\:me-px{
    margin-right: 1px;
  }

  [dir="rtl"] .md\\:me-px{
    margin-left: 1px;
  }

  [dir="ltr"] .md\\:-ms-1{
    margin-left: -0.25rem;
  }

  [dir="rtl"] .md\\:-ms-1{
    margin-right: -0.25rem;
  }

  [dir="ltr"] .md\\:-me-1{
    margin-right: -0.25rem;
  }

  [dir="rtl"] .md\\:-me-1{
    margin-left: -0.25rem;
  }

  [dir="ltr"] .md\\:-ms-2{
    margin-left: -0.5rem;
  }

  [dir="rtl"] .md\\:-ms-2{
    margin-right: -0.5rem;
  }

  [dir="ltr"] .md\\:-me-2{
    margin-right: -0.5rem;
  }

  [dir="rtl"] .md\\:-me-2{
    margin-left: -0.5rem;
  }

  [dir="ltr"] .md\\:-ms-3{
    margin-left: -0.75rem;
  }

  [dir="rtl"] .md\\:-ms-3{
    margin-right: -0.75rem;
  }

  [dir="ltr"] .md\\:-me-3{
    margin-right: -0.75rem;
  }

  [dir="rtl"] .md\\:-me-3{
    margin-left: -0.75rem;
  }

  [dir="ltr"] .md\\:-ms-4{
    margin-left: -1rem;
  }

  [dir="rtl"] .md\\:-ms-4{
    margin-right: -1rem;
  }

  [dir="ltr"] .md\\:-me-4{
    margin-right: -1rem;
  }

  [dir="rtl"] .md\\:-me-4{
    margin-left: -1rem;
  }

  [dir="ltr"] .md\\:-ms-5{
    margin-left: -1.25rem;
  }

  [dir="rtl"] .md\\:-ms-5{
    margin-right: -1.25rem;
  }

  [dir="ltr"] .md\\:-me-5{
    margin-right: -1.25rem;
  }

  [dir="rtl"] .md\\:-me-5{
    margin-left: -1.25rem;
  }

  [dir="ltr"] .md\\:-ms-6{
    margin-left: -1.5rem;
  }

  [dir="rtl"] .md\\:-ms-6{
    margin-right: -1.5rem;
  }

  [dir="ltr"] .md\\:-me-6{
    margin-right: -1.5rem;
  }

  [dir="rtl"] .md\\:-me-6{
    margin-left: -1.5rem;
  }

  [dir="ltr"] .md\\:-ms-7{
    margin-left: -1.75rem;
  }

  [dir="rtl"] .md\\:-ms-7{
    margin-right: -1.75rem;
  }

  [dir="ltr"] .md\\:-me-7{
    margin-right: -1.75rem;
  }

  [dir="rtl"] .md\\:-me-7{
    margin-left: -1.75rem;
  }

  [dir="ltr"] .md\\:-ms-8{
    margin-left: -2rem;
  }

  [dir="rtl"] .md\\:-ms-8{
    margin-right: -2rem;
  }

  [dir="ltr"] .md\\:-me-8{
    margin-right: -2rem;
  }

  [dir="rtl"] .md\\:-me-8{
    margin-left: -2rem;
  }

  [dir="ltr"] .md\\:-ms-9{
    margin-left: -2.25rem;
  }

  [dir="rtl"] .md\\:-ms-9{
    margin-right: -2.25rem;
  }

  [dir="ltr"] .md\\:-me-9{
    margin-right: -2.25rem;
  }

  [dir="rtl"] .md\\:-me-9{
    margin-left: -2.25rem;
  }

  [dir="ltr"] .md\\:-ms-10{
    margin-left: -2.5rem;
  }

  [dir="rtl"] .md\\:-ms-10{
    margin-right: -2.5rem;
  }

  [dir="ltr"] .md\\:-me-10{
    margin-right: -2.5rem;
  }

  [dir="rtl"] .md\\:-me-10{
    margin-left: -2.5rem;
  }

  [dir="ltr"] .md\\:-ms-11{
    margin-left: -2.75rem;
  }

  [dir="rtl"] .md\\:-ms-11{
    margin-right: -2.75rem;
  }

  [dir="ltr"] .md\\:-me-11{
    margin-right: -2.75rem;
  }

  [dir="rtl"] .md\\:-me-11{
    margin-left: -2.75rem;
  }

  [dir="ltr"] .md\\:-ms-12{
    margin-left: -3rem;
  }

  [dir="rtl"] .md\\:-ms-12{
    margin-right: -3rem;
  }

  [dir="ltr"] .md\\:-me-12{
    margin-right: -3rem;
  }

  [dir="rtl"] .md\\:-me-12{
    margin-left: -3rem;
  }

  [dir="ltr"] .md\\:-ms-14{
    margin-left: -3.5rem;
  }

  [dir="rtl"] .md\\:-ms-14{
    margin-right: -3.5rem;
  }

  [dir="ltr"] .md\\:-me-14{
    margin-right: -3.5rem;
  }

  [dir="rtl"] .md\\:-me-14{
    margin-left: -3.5rem;
  }

  [dir="ltr"] .md\\:-ms-15{
    margin-left: -3.75rem;
  }

  [dir="rtl"] .md\\:-ms-15{
    margin-right: -3.75rem;
  }

  [dir="ltr"] .md\\:-me-15{
    margin-right: -3.75rem;
  }

  [dir="rtl"] .md\\:-me-15{
    margin-left: -3.75rem;
  }

  [dir="ltr"] .md\\:-ms-16{
    margin-left: -4rem;
  }

  [dir="rtl"] .md\\:-ms-16{
    margin-right: -4rem;
  }

  [dir="ltr"] .md\\:-me-16{
    margin-right: -4rem;
  }

  [dir="rtl"] .md\\:-me-16{
    margin-left: -4rem;
  }

  [dir="ltr"] .md\\:-ms-18{
    margin-left: -4.5rem;
  }

  [dir="rtl"] .md\\:-ms-18{
    margin-right: -4.5rem;
  }

  [dir="ltr"] .md\\:-me-18{
    margin-right: -4.5rem;
  }

  [dir="rtl"] .md\\:-me-18{
    margin-left: -4.5rem;
  }

  [dir="ltr"] .md\\:-ms-20{
    margin-left: -5rem;
  }

  [dir="rtl"] .md\\:-ms-20{
    margin-right: -5rem;
  }

  [dir="ltr"] .md\\:-me-20{
    margin-right: -5rem;
  }

  [dir="rtl"] .md\\:-me-20{
    margin-left: -5rem;
  }

  [dir="ltr"] .md\\:-ms-22{
    margin-left: -5.5rem;
  }

  [dir="rtl"] .md\\:-ms-22{
    margin-right: -5.5rem;
  }

  [dir="ltr"] .md\\:-me-22{
    margin-right: -5.5rem;
  }

  [dir="rtl"] .md\\:-me-22{
    margin-left: -5.5rem;
  }

  [dir="ltr"] .md\\:-ms-23{
    margin-left: -5.75rem;
  }

  [dir="rtl"] .md\\:-ms-23{
    margin-right: -5.75rem;
  }

  [dir="ltr"] .md\\:-me-23{
    margin-right: -5.75rem;
  }

  [dir="rtl"] .md\\:-me-23{
    margin-left: -5.75rem;
  }

  [dir="ltr"] .md\\:-ms-24{
    margin-left: -6rem;
  }

  [dir="rtl"] .md\\:-ms-24{
    margin-right: -6rem;
  }

  [dir="ltr"] .md\\:-me-24{
    margin-right: -6rem;
  }

  [dir="rtl"] .md\\:-me-24{
    margin-left: -6rem;
  }

  [dir="ltr"] .md\\:-ms-25{
    margin-left: -6.25rem;
  }

  [dir="rtl"] .md\\:-ms-25{
    margin-right: -6.25rem;
  }

  [dir="ltr"] .md\\:-me-25{
    margin-right: -6.25rem;
  }

  [dir="rtl"] .md\\:-me-25{
    margin-left: -6.25rem;
  }

  [dir="ltr"] .md\\:-ms-26{
    margin-left: -6.5rem;
  }

  [dir="rtl"] .md\\:-ms-26{
    margin-right: -6.5rem;
  }

  [dir="ltr"] .md\\:-me-26{
    margin-right: -6.5rem;
  }

  [dir="rtl"] .md\\:-me-26{
    margin-left: -6.5rem;
  }

  [dir="ltr"] .md\\:-ms-28{
    margin-left: -7rem;
  }

  [dir="rtl"] .md\\:-ms-28{
    margin-right: -7rem;
  }

  [dir="ltr"] .md\\:-me-28{
    margin-right: -7rem;
  }

  [dir="rtl"] .md\\:-me-28{
    margin-left: -7rem;
  }

  [dir="ltr"] .md\\:-ms-30{
    margin-left: -7.5rem;
  }

  [dir="rtl"] .md\\:-ms-30{
    margin-right: -7.5rem;
  }

  [dir="ltr"] .md\\:-me-30{
    margin-right: -7.5rem;
  }

  [dir="rtl"] .md\\:-me-30{
    margin-left: -7.5rem;
  }

  [dir="ltr"] .md\\:-ms-32{
    margin-left: -8rem;
  }

  [dir="rtl"] .md\\:-ms-32{
    margin-right: -8rem;
  }

  [dir="ltr"] .md\\:-me-32{
    margin-right: -8rem;
  }

  [dir="rtl"] .md\\:-me-32{
    margin-left: -8rem;
  }

  [dir="ltr"] .md\\:-ms-34{
    margin-left: -8.5rem;
  }

  [dir="rtl"] .md\\:-ms-34{
    margin-right: -8.5rem;
  }

  [dir="ltr"] .md\\:-me-34{
    margin-right: -8.5rem;
  }

  [dir="rtl"] .md\\:-me-34{
    margin-left: -8.5rem;
  }

  [dir="ltr"] .md\\:-ms-40{
    margin-left: -10rem;
  }

  [dir="rtl"] .md\\:-ms-40{
    margin-right: -10rem;
  }

  [dir="ltr"] .md\\:-me-40{
    margin-right: -10rem;
  }

  [dir="rtl"] .md\\:-me-40{
    margin-left: -10rem;
  }

  [dir="ltr"] .md\\:-ms-42{
    margin-left: -10.5rem;
  }

  [dir="rtl"] .md\\:-ms-42{
    margin-right: -10.5rem;
  }

  [dir="ltr"] .md\\:-me-42{
    margin-right: -10.5rem;
  }

  [dir="rtl"] .md\\:-me-42{
    margin-left: -10.5rem;
  }

  [dir="ltr"] .md\\:-ms-44{
    margin-left: -11rem;
  }

  [dir="rtl"] .md\\:-ms-44{
    margin-right: -11rem;
  }

  [dir="ltr"] .md\\:-me-44{
    margin-right: -11rem;
  }

  [dir="rtl"] .md\\:-me-44{
    margin-left: -11rem;
  }

  [dir="ltr"] .md\\:-ms-48{
    margin-left: -12rem;
  }

  [dir="rtl"] .md\\:-ms-48{
    margin-right: -12rem;
  }

  [dir="ltr"] .md\\:-me-48{
    margin-right: -12rem;
  }

  [dir="rtl"] .md\\:-me-48{
    margin-left: -12rem;
  }

  [dir="ltr"] .md\\:-ms-52{
    margin-left: -13rem;
  }

  [dir="rtl"] .md\\:-ms-52{
    margin-right: -13rem;
  }

  [dir="ltr"] .md\\:-me-52{
    margin-right: -13rem;
  }

  [dir="rtl"] .md\\:-me-52{
    margin-left: -13rem;
  }

  [dir="ltr"] .md\\:-ms-54{
    margin-left: -13.5rem;
  }

  [dir="rtl"] .md\\:-ms-54{
    margin-right: -13.5rem;
  }

  [dir="ltr"] .md\\:-me-54{
    margin-right: -13.5rem;
  }

  [dir="rtl"] .md\\:-me-54{
    margin-left: -13.5rem;
  }

  [dir="ltr"] .md\\:-ms-56{
    margin-left: -14rem;
  }

  [dir="rtl"] .md\\:-ms-56{
    margin-right: -14rem;
  }

  [dir="ltr"] .md\\:-me-56{
    margin-right: -14rem;
  }

  [dir="rtl"] .md\\:-me-56{
    margin-left: -14rem;
  }

  [dir="ltr"] .md\\:-ms-60{
    margin-left: -15rem;
  }

  [dir="rtl"] .md\\:-ms-60{
    margin-right: -15rem;
  }

  [dir="ltr"] .md\\:-me-60{
    margin-right: -15rem;
  }

  [dir="rtl"] .md\\:-me-60{
    margin-left: -15rem;
  }

  [dir="ltr"] .md\\:-ms-64{
    margin-left: -16rem;
  }

  [dir="rtl"] .md\\:-ms-64{
    margin-right: -16rem;
  }

  [dir="ltr"] .md\\:-me-64{
    margin-right: -16rem;
  }

  [dir="rtl"] .md\\:-me-64{
    margin-left: -16rem;
  }

  [dir="ltr"] .md\\:-ms-68{
    margin-left: -17rem;
  }

  [dir="rtl"] .md\\:-ms-68{
    margin-right: -17rem;
  }

  [dir="ltr"] .md\\:-me-68{
    margin-right: -17rem;
  }

  [dir="rtl"] .md\\:-me-68{
    margin-left: -17rem;
  }

  [dir="ltr"] .md\\:-ms-72{
    margin-left: -18rem;
  }

  [dir="rtl"] .md\\:-ms-72{
    margin-right: -18rem;
  }

  [dir="ltr"] .md\\:-me-72{
    margin-right: -18rem;
  }

  [dir="rtl"] .md\\:-me-72{
    margin-left: -18rem;
  }

  [dir="ltr"] .md\\:-ms-74{
    margin-left: -18.5rem;
  }

  [dir="rtl"] .md\\:-ms-74{
    margin-right: -18.5rem;
  }

  [dir="ltr"] .md\\:-me-74{
    margin-right: -18.5rem;
  }

  [dir="rtl"] .md\\:-me-74{
    margin-left: -18.5rem;
  }

  [dir="ltr"] .md\\:-ms-76{
    margin-left: -19rem;
  }

  [dir="rtl"] .md\\:-ms-76{
    margin-right: -19rem;
  }

  [dir="ltr"] .md\\:-me-76{
    margin-right: -19rem;
  }

  [dir="rtl"] .md\\:-me-76{
    margin-left: -19rem;
  }

  [dir="ltr"] .md\\:-ms-78{
    margin-left: -19.5rem;
  }

  [dir="rtl"] .md\\:-ms-78{
    margin-right: -19.5rem;
  }

  [dir="ltr"] .md\\:-me-78{
    margin-right: -19.5rem;
  }

  [dir="rtl"] .md\\:-me-78{
    margin-left: -19.5rem;
  }

  [dir="ltr"] .md\\:-ms-80{
    margin-left: -20rem;
  }

  [dir="rtl"] .md\\:-ms-80{
    margin-right: -20rem;
  }

  [dir="ltr"] .md\\:-me-80{
    margin-right: -20rem;
  }

  [dir="rtl"] .md\\:-me-80{
    margin-left: -20rem;
  }

  [dir="ltr"] .md\\:-ms-82{
    margin-left: -20.5rem;
  }

  [dir="rtl"] .md\\:-ms-82{
    margin-right: -20.5rem;
  }

  [dir="ltr"] .md\\:-me-82{
    margin-right: -20.5rem;
  }

  [dir="rtl"] .md\\:-me-82{
    margin-left: -20.5rem;
  }

  [dir="ltr"] .md\\:-ms-84{
    margin-left: -21rem;
  }

  [dir="rtl"] .md\\:-ms-84{
    margin-right: -21rem;
  }

  [dir="ltr"] .md\\:-me-84{
    margin-right: -21rem;
  }

  [dir="rtl"] .md\\:-me-84{
    margin-left: -21rem;
  }

  [dir="ltr"] .md\\:-ms-88{
    margin-left: -22rem;
  }

  [dir="rtl"] .md\\:-ms-88{
    margin-right: -22rem;
  }

  [dir="ltr"] .md\\:-me-88{
    margin-right: -22rem;
  }

  [dir="rtl"] .md\\:-me-88{
    margin-left: -22rem;
  }

  [dir="ltr"] .md\\:-ms-92{
    margin-left: -23rem;
  }

  [dir="rtl"] .md\\:-ms-92{
    margin-right: -23rem;
  }

  [dir="ltr"] .md\\:-me-92{
    margin-right: -23rem;
  }

  [dir="rtl"] .md\\:-me-92{
    margin-left: -23rem;
  }

  [dir="ltr"] .md\\:-ms-96{
    margin-left: -24rem;
  }

  [dir="rtl"] .md\\:-ms-96{
    margin-right: -24rem;
  }

  [dir="ltr"] .md\\:-me-96{
    margin-right: -24rem;
  }

  [dir="rtl"] .md\\:-me-96{
    margin-left: -24rem;
  }

  [dir="ltr"] .md\\:-ms-98{
    margin-left: -24.5rem;
  }

  [dir="rtl"] .md\\:-ms-98{
    margin-right: -24.5rem;
  }

  [dir="ltr"] .md\\:-me-98{
    margin-right: -24.5rem;
  }

  [dir="rtl"] .md\\:-me-98{
    margin-left: -24.5rem;
  }

  [dir="ltr"] .md\\:-ms-100{
    margin-left: -25rem;
  }

  [dir="rtl"] .md\\:-ms-100{
    margin-right: -25rem;
  }

  [dir="ltr"] .md\\:-me-100{
    margin-right: -25rem;
  }

  [dir="rtl"] .md\\:-me-100{
    margin-left: -25rem;
  }

  [dir="ltr"] .md\\:-ms-104{
    margin-left: -26rem;
  }

  [dir="rtl"] .md\\:-ms-104{
    margin-right: -26rem;
  }

  [dir="ltr"] .md\\:-me-104{
    margin-right: -26rem;
  }

  [dir="rtl"] .md\\:-me-104{
    margin-left: -26rem;
  }

  [dir="ltr"] .md\\:-ms-112{
    margin-left: -28rem;
  }

  [dir="rtl"] .md\\:-ms-112{
    margin-right: -28rem;
  }

  [dir="ltr"] .md\\:-me-112{
    margin-right: -28rem;
  }

  [dir="rtl"] .md\\:-me-112{
    margin-left: -28rem;
  }

  [dir="ltr"] .md\\:-ms-124{
    margin-left: -31rem;
  }

  [dir="rtl"] .md\\:-ms-124{
    margin-right: -31rem;
  }

  [dir="ltr"] .md\\:-me-124{
    margin-right: -31rem;
  }

  [dir="rtl"] .md\\:-me-124{
    margin-left: -31rem;
  }

  [dir="ltr"] .md\\:-ms-128{
    margin-left: -32rem;
  }

  [dir="rtl"] .md\\:-ms-128{
    margin-right: -32rem;
  }

  [dir="ltr"] .md\\:-me-128{
    margin-right: -32rem;
  }

  [dir="rtl"] .md\\:-me-128{
    margin-left: -32rem;
  }

  [dir="ltr"] .md\\:-ms-140{
    margin-left: -35rem;
  }

  [dir="rtl"] .md\\:-ms-140{
    margin-right: -35rem;
  }

  [dir="ltr"] .md\\:-me-140{
    margin-right: -35rem;
  }

  [dir="rtl"] .md\\:-me-140{
    margin-left: -35rem;
  }

  [dir="ltr"] .md\\:-ms-152{
    margin-left: -38rem;
  }

  [dir="rtl"] .md\\:-ms-152{
    margin-right: -38rem;
  }

  [dir="ltr"] .md\\:-me-152{
    margin-right: -38rem;
  }

  [dir="rtl"] .md\\:-me-152{
    margin-left: -38rem;
  }

  [dir="ltr"] .md\\:-ms-160{
    margin-left: -40rem;
  }

  [dir="rtl"] .md\\:-ms-160{
    margin-right: -40rem;
  }

  [dir="ltr"] .md\\:-me-160{
    margin-right: -40rem;
  }

  [dir="rtl"] .md\\:-me-160{
    margin-left: -40rem;
  }

  [dir="ltr"] .md\\:-ms-162{
    margin-left: -41rem;
  }

  [dir="rtl"] .md\\:-ms-162{
    margin-right: -41rem;
  }

  [dir="ltr"] .md\\:-me-162{
    margin-right: -41rem;
  }

  [dir="rtl"] .md\\:-me-162{
    margin-left: -41rem;
  }

  [dir="ltr"] .md\\:-ms-192{
    margin-left: -48rem;
  }

  [dir="rtl"] .md\\:-ms-192{
    margin-right: -48rem;
  }

  [dir="ltr"] .md\\:-me-192{
    margin-right: -48rem;
  }

  [dir="rtl"] .md\\:-me-192{
    margin-left: -48rem;
  }

  [dir="ltr"] .md\\:-ms-208{
    margin-left: -52rem;
  }

  [dir="rtl"] .md\\:-ms-208{
    margin-right: -52rem;
  }

  [dir="ltr"] .md\\:-me-208{
    margin-right: -52rem;
  }

  [dir="rtl"] .md\\:-me-208{
    margin-left: -52rem;
  }

  [dir="ltr"] .md\\:-ms-224{
    margin-left: -56rem;
  }

  [dir="rtl"] .md\\:-ms-224{
    margin-right: -56rem;
  }

  [dir="ltr"] .md\\:-me-224{
    margin-right: -56rem;
  }

  [dir="rtl"] .md\\:-me-224{
    margin-left: -56rem;
  }

  [dir="ltr"] .md\\:-ms-256{
    margin-left: -64rem;
  }

  [dir="rtl"] .md\\:-ms-256{
    margin-right: -64rem;
  }

  [dir="ltr"] .md\\:-me-256{
    margin-right: -64rem;
  }

  [dir="rtl"] .md\\:-me-256{
    margin-left: -64rem;
  }

  [dir="ltr"] .md\\:-ms-px{
    margin-left: -1px;
  }

  [dir="rtl"] .md\\:-ms-px{
    margin-right: -1px;
  }

  [dir="ltr"] .md\\:-me-px{
    margin-right: -1px;
  }

  [dir="rtl"] .md\\:-me-px{
    margin-left: -1px;
  }

  [dir="ltr"] .md\\:first\\:ms-0:first-child{
    margin-left: 0;
  }

  [dir="rtl"] .md\\:first\\:ms-0:first-child{
    margin-right: 0;
  }

  [dir="ltr"] .md\\:first\\:me-0:first-child{
    margin-right: 0;
  }

  [dir="rtl"] .md\\:first\\:me-0:first-child{
    margin-left: 0;
  }

  [dir="ltr"] .md\\:first\\:ms-1:first-child{
    margin-left: 0.25rem;
  }

  [dir="rtl"] .md\\:first\\:ms-1:first-child{
    margin-right: 0.25rem;
  }

  [dir="ltr"] .md\\:first\\:me-1:first-child{
    margin-right: 0.25rem;
  }

  [dir="rtl"] .md\\:first\\:me-1:first-child{
    margin-left: 0.25rem;
  }

  [dir="ltr"] .md\\:first\\:ms-2:first-child{
    margin-left: 0.5rem;
  }

  [dir="rtl"] .md\\:first\\:ms-2:first-child{
    margin-right: 0.5rem;
  }

  [dir="ltr"] .md\\:first\\:me-2:first-child{
    margin-right: 0.5rem;
  }

  [dir="rtl"] .md\\:first\\:me-2:first-child{
    margin-left: 0.5rem;
  }

  [dir="ltr"] .md\\:first\\:ms-3:first-child{
    margin-left: 0.75rem;
  }

  [dir="rtl"] .md\\:first\\:ms-3:first-child{
    margin-right: 0.75rem;
  }

  [dir="ltr"] .md\\:first\\:me-3:first-child{
    margin-right: 0.75rem;
  }

  [dir="rtl"] .md\\:first\\:me-3:first-child{
    margin-left: 0.75rem;
  }

  [dir="ltr"] .md\\:first\\:ms-4:first-child{
    margin-left: 1rem;
  }

  [dir="rtl"] .md\\:first\\:ms-4:first-child{
    margin-right: 1rem;
  }

  [dir="ltr"] .md\\:first\\:me-4:first-child{
    margin-right: 1rem;
  }

  [dir="rtl"] .md\\:first\\:me-4:first-child{
    margin-left: 1rem;
  }

  [dir="ltr"] .md\\:first\\:ms-5:first-child{
    margin-left: 1.25rem;
  }

  [dir="rtl"] .md\\:first\\:ms-5:first-child{
    margin-right: 1.25rem;
  }

  [dir="ltr"] .md\\:first\\:me-5:first-child{
    margin-right: 1.25rem;
  }

  [dir="rtl"] .md\\:first\\:me-5:first-child{
    margin-left: 1.25rem;
  }

  [dir="ltr"] .md\\:first\\:ms-6:first-child{
    margin-left: 1.5rem;
  }

  [dir="rtl"] .md\\:first\\:ms-6:first-child{
    margin-right: 1.5rem;
  }

  [dir="ltr"] .md\\:first\\:me-6:first-child{
    margin-right: 1.5rem;
  }

  [dir="rtl"] .md\\:first\\:me-6:first-child{
    margin-left: 1.5rem;
  }

  [dir="ltr"] .md\\:first\\:ms-7:first-child{
    margin-left: 1.75rem;
  }

  [dir="rtl"] .md\\:first\\:ms-7:first-child{
    margin-right: 1.75rem;
  }

  [dir="ltr"] .md\\:first\\:me-7:first-child{
    margin-right: 1.75rem;
  }

  [dir="rtl"] .md\\:first\\:me-7:first-child{
    margin-left: 1.75rem;
  }

  [dir="ltr"] .md\\:first\\:ms-8:first-child{
    margin-left: 2rem;
  }

  [dir="rtl"] .md\\:first\\:ms-8:first-child{
    margin-right: 2rem;
  }

  [dir="ltr"] .md\\:first\\:me-8:first-child{
    margin-right: 2rem;
  }

  [dir="rtl"] .md\\:first\\:me-8:first-child{
    margin-left: 2rem;
  }

  [dir="ltr"] .md\\:first\\:ms-9:first-child{
    margin-left: 2.25rem;
  }

  [dir="rtl"] .md\\:first\\:ms-9:first-child{
    margin-right: 2.25rem;
  }

  [dir="ltr"] .md\\:first\\:me-9:first-child{
    margin-right: 2.25rem;
  }

  [dir="rtl"] .md\\:first\\:me-9:first-child{
    margin-left: 2.25rem;
  }

  [dir="ltr"] .md\\:first\\:ms-10:first-child{
    margin-left: 2.5rem;
  }

  [dir="rtl"] .md\\:first\\:ms-10:first-child{
    margin-right: 2.5rem;
  }

  [dir="ltr"] .md\\:first\\:me-10:first-child{
    margin-right: 2.5rem;
  }

  [dir="rtl"] .md\\:first\\:me-10:first-child{
    margin-left: 2.5rem;
  }

  [dir="ltr"] .md\\:first\\:ms-11:first-child{
    margin-left: 2.75rem;
  }

  [dir="rtl"] .md\\:first\\:ms-11:first-child{
    margin-right: 2.75rem;
  }

  [dir="ltr"] .md\\:first\\:me-11:first-child{
    margin-right: 2.75rem;
  }

  [dir="rtl"] .md\\:first\\:me-11:first-child{
    margin-left: 2.75rem;
  }

  [dir="ltr"] .md\\:first\\:ms-12:first-child{
    margin-left: 3rem;
  }

  [dir="rtl"] .md\\:first\\:ms-12:first-child{
    margin-right: 3rem;
  }

  [dir="ltr"] .md\\:first\\:me-12:first-child{
    margin-right: 3rem;
  }

  [dir="rtl"] .md\\:first\\:me-12:first-child{
    margin-left: 3rem;
  }

  [dir="ltr"] .md\\:first\\:ms-14:first-child{
    margin-left: 3.5rem;
  }

  [dir="rtl"] .md\\:first\\:ms-14:first-child{
    margin-right: 3.5rem;
  }

  [dir="ltr"] .md\\:first\\:me-14:first-child{
    margin-right: 3.5rem;
  }

  [dir="rtl"] .md\\:first\\:me-14:first-child{
    margin-left: 3.5rem;
  }

  [dir="ltr"] .md\\:first\\:ms-15:first-child{
    margin-left: 3.75rem;
  }

  [dir="rtl"] .md\\:first\\:ms-15:first-child{
    margin-right: 3.75rem;
  }

  [dir="ltr"] .md\\:first\\:me-15:first-child{
    margin-right: 3.75rem;
  }

  [dir="rtl"] .md\\:first\\:me-15:first-child{
    margin-left: 3.75rem;
  }

  [dir="ltr"] .md\\:first\\:ms-16:first-child{
    margin-left: 4rem;
  }

  [dir="rtl"] .md\\:first\\:ms-16:first-child{
    margin-right: 4rem;
  }

  [dir="ltr"] .md\\:first\\:me-16:first-child{
    margin-right: 4rem;
  }

  [dir="rtl"] .md\\:first\\:me-16:first-child{
    margin-left: 4rem;
  }

  [dir="ltr"] .md\\:first\\:ms-18:first-child{
    margin-left: 4.5rem;
  }

  [dir="rtl"] .md\\:first\\:ms-18:first-child{
    margin-right: 4.5rem;
  }

  [dir="ltr"] .md\\:first\\:me-18:first-child{
    margin-right: 4.5rem;
  }

  [dir="rtl"] .md\\:first\\:me-18:first-child{
    margin-left: 4.5rem;
  }

  [dir="ltr"] .md\\:first\\:ms-20:first-child{
    margin-left: 5rem;
  }

  [dir="rtl"] .md\\:first\\:ms-20:first-child{
    margin-right: 5rem;
  }

  [dir="ltr"] .md\\:first\\:me-20:first-child{
    margin-right: 5rem;
  }

  [dir="rtl"] .md\\:first\\:me-20:first-child{
    margin-left: 5rem;
  }

  [dir="ltr"] .md\\:first\\:ms-22:first-child{
    margin-left: 5.5rem;
  }

  [dir="rtl"] .md\\:first\\:ms-22:first-child{
    margin-right: 5.5rem;
  }

  [dir="ltr"] .md\\:first\\:me-22:first-child{
    margin-right: 5.5rem;
  }

  [dir="rtl"] .md\\:first\\:me-22:first-child{
    margin-left: 5.5rem;
  }

  [dir="ltr"] .md\\:first\\:ms-23:first-child{
    margin-left: 5.75rem;
  }

  [dir="rtl"] .md\\:first\\:ms-23:first-child{
    margin-right: 5.75rem;
  }

  [dir="ltr"] .md\\:first\\:me-23:first-child{
    margin-right: 5.75rem;
  }

  [dir="rtl"] .md\\:first\\:me-23:first-child{
    margin-left: 5.75rem;
  }

  [dir="ltr"] .md\\:first\\:ms-24:first-child{
    margin-left: 6rem;
  }

  [dir="rtl"] .md\\:first\\:ms-24:first-child{
    margin-right: 6rem;
  }

  [dir="ltr"] .md\\:first\\:me-24:first-child{
    margin-right: 6rem;
  }

  [dir="rtl"] .md\\:first\\:me-24:first-child{
    margin-left: 6rem;
  }

  [dir="ltr"] .md\\:first\\:ms-25:first-child{
    margin-left: 6.25rem;
  }

  [dir="rtl"] .md\\:first\\:ms-25:first-child{
    margin-right: 6.25rem;
  }

  [dir="ltr"] .md\\:first\\:me-25:first-child{
    margin-right: 6.25rem;
  }

  [dir="rtl"] .md\\:first\\:me-25:first-child{
    margin-left: 6.25rem;
  }

  [dir="ltr"] .md\\:first\\:ms-26:first-child{
    margin-left: 6.5rem;
  }

  [dir="rtl"] .md\\:first\\:ms-26:first-child{
    margin-right: 6.5rem;
  }

  [dir="ltr"] .md\\:first\\:me-26:first-child{
    margin-right: 6.5rem;
  }

  [dir="rtl"] .md\\:first\\:me-26:first-child{
    margin-left: 6.5rem;
  }

  [dir="ltr"] .md\\:first\\:ms-28:first-child{
    margin-left: 7rem;
  }

  [dir="rtl"] .md\\:first\\:ms-28:first-child{
    margin-right: 7rem;
  }

  [dir="ltr"] .md\\:first\\:me-28:first-child{
    margin-right: 7rem;
  }

  [dir="rtl"] .md\\:first\\:me-28:first-child{
    margin-left: 7rem;
  }

  [dir="ltr"] .md\\:first\\:ms-30:first-child{
    margin-left: 7.5rem;
  }

  [dir="rtl"] .md\\:first\\:ms-30:first-child{
    margin-right: 7.5rem;
  }

  [dir="ltr"] .md\\:first\\:me-30:first-child{
    margin-right: 7.5rem;
  }

  [dir="rtl"] .md\\:first\\:me-30:first-child{
    margin-left: 7.5rem;
  }

  [dir="ltr"] .md\\:first\\:ms-32:first-child{
    margin-left: 8rem;
  }

  [dir="rtl"] .md\\:first\\:ms-32:first-child{
    margin-right: 8rem;
  }

  [dir="ltr"] .md\\:first\\:me-32:first-child{
    margin-right: 8rem;
  }

  [dir="rtl"] .md\\:first\\:me-32:first-child{
    margin-left: 8rem;
  }

  [dir="ltr"] .md\\:first\\:ms-34:first-child{
    margin-left: 8.5rem;
  }

  [dir="rtl"] .md\\:first\\:ms-34:first-child{
    margin-right: 8.5rem;
  }

  [dir="ltr"] .md\\:first\\:me-34:first-child{
    margin-right: 8.5rem;
  }

  [dir="rtl"] .md\\:first\\:me-34:first-child{
    margin-left: 8.5rem;
  }

  [dir="ltr"] .md\\:first\\:ms-40:first-child{
    margin-left: 10rem;
  }

  [dir="rtl"] .md\\:first\\:ms-40:first-child{
    margin-right: 10rem;
  }

  [dir="ltr"] .md\\:first\\:me-40:first-child{
    margin-right: 10rem;
  }

  [dir="rtl"] .md\\:first\\:me-40:first-child{
    margin-left: 10rem;
  }

  [dir="ltr"] .md\\:first\\:ms-42:first-child{
    margin-left: 10.5rem;
  }

  [dir="rtl"] .md\\:first\\:ms-42:first-child{
    margin-right: 10.5rem;
  }

  [dir="ltr"] .md\\:first\\:me-42:first-child{
    margin-right: 10.5rem;
  }

  [dir="rtl"] .md\\:first\\:me-42:first-child{
    margin-left: 10.5rem;
  }

  [dir="ltr"] .md\\:first\\:ms-44:first-child{
    margin-left: 11rem;
  }

  [dir="rtl"] .md\\:first\\:ms-44:first-child{
    margin-right: 11rem;
  }

  [dir="ltr"] .md\\:first\\:me-44:first-child{
    margin-right: 11rem;
  }

  [dir="rtl"] .md\\:first\\:me-44:first-child{
    margin-left: 11rem;
  }

  [dir="ltr"] .md\\:first\\:ms-48:first-child{
    margin-left: 12rem;
  }

  [dir="rtl"] .md\\:first\\:ms-48:first-child{
    margin-right: 12rem;
  }

  [dir="ltr"] .md\\:first\\:me-48:first-child{
    margin-right: 12rem;
  }

  [dir="rtl"] .md\\:first\\:me-48:first-child{
    margin-left: 12rem;
  }

  [dir="ltr"] .md\\:first\\:ms-52:first-child{
    margin-left: 13rem;
  }

  [dir="rtl"] .md\\:first\\:ms-52:first-child{
    margin-right: 13rem;
  }

  [dir="ltr"] .md\\:first\\:me-52:first-child{
    margin-right: 13rem;
  }

  [dir="rtl"] .md\\:first\\:me-52:first-child{
    margin-left: 13rem;
  }

  [dir="ltr"] .md\\:first\\:ms-54:first-child{
    margin-left: 13.5rem;
  }

  [dir="rtl"] .md\\:first\\:ms-54:first-child{
    margin-right: 13.5rem;
  }

  [dir="ltr"] .md\\:first\\:me-54:first-child{
    margin-right: 13.5rem;
  }

  [dir="rtl"] .md\\:first\\:me-54:first-child{
    margin-left: 13.5rem;
  }

  [dir="ltr"] .md\\:first\\:ms-56:first-child{
    margin-left: 14rem;
  }

  [dir="rtl"] .md\\:first\\:ms-56:first-child{
    margin-right: 14rem;
  }

  [dir="ltr"] .md\\:first\\:me-56:first-child{
    margin-right: 14rem;
  }

  [dir="rtl"] .md\\:first\\:me-56:first-child{
    margin-left: 14rem;
  }

  [dir="ltr"] .md\\:first\\:ms-60:first-child{
    margin-left: 15rem;
  }

  [dir="rtl"] .md\\:first\\:ms-60:first-child{
    margin-right: 15rem;
  }

  [dir="ltr"] .md\\:first\\:me-60:first-child{
    margin-right: 15rem;
  }

  [dir="rtl"] .md\\:first\\:me-60:first-child{
    margin-left: 15rem;
  }

  [dir="ltr"] .md\\:first\\:ms-64:first-child{
    margin-left: 16rem;
  }

  [dir="rtl"] .md\\:first\\:ms-64:first-child{
    margin-right: 16rem;
  }

  [dir="ltr"] .md\\:first\\:me-64:first-child{
    margin-right: 16rem;
  }

  [dir="rtl"] .md\\:first\\:me-64:first-child{
    margin-left: 16rem;
  }

  [dir="ltr"] .md\\:first\\:ms-68:first-child{
    margin-left: 17rem;
  }

  [dir="rtl"] .md\\:first\\:ms-68:first-child{
    margin-right: 17rem;
  }

  [dir="ltr"] .md\\:first\\:me-68:first-child{
    margin-right: 17rem;
  }

  [dir="rtl"] .md\\:first\\:me-68:first-child{
    margin-left: 17rem;
  }

  [dir="ltr"] .md\\:first\\:ms-72:first-child{
    margin-left: 18rem;
  }

  [dir="rtl"] .md\\:first\\:ms-72:first-child{
    margin-right: 18rem;
  }

  [dir="ltr"] .md\\:first\\:me-72:first-child{
    margin-right: 18rem;
  }

  [dir="rtl"] .md\\:first\\:me-72:first-child{
    margin-left: 18rem;
  }

  [dir="ltr"] .md\\:first\\:ms-74:first-child{
    margin-left: 18.5rem;
  }

  [dir="rtl"] .md\\:first\\:ms-74:first-child{
    margin-right: 18.5rem;
  }

  [dir="ltr"] .md\\:first\\:me-74:first-child{
    margin-right: 18.5rem;
  }

  [dir="rtl"] .md\\:first\\:me-74:first-child{
    margin-left: 18.5rem;
  }

  [dir="ltr"] .md\\:first\\:ms-76:first-child{
    margin-left: 19rem;
  }

  [dir="rtl"] .md\\:first\\:ms-76:first-child{
    margin-right: 19rem;
  }

  [dir="ltr"] .md\\:first\\:me-76:first-child{
    margin-right: 19rem;
  }

  [dir="rtl"] .md\\:first\\:me-76:first-child{
    margin-left: 19rem;
  }

  [dir="ltr"] .md\\:first\\:ms-78:first-child{
    margin-left: 19.5rem;
  }

  [dir="rtl"] .md\\:first\\:ms-78:first-child{
    margin-right: 19.5rem;
  }

  [dir="ltr"] .md\\:first\\:me-78:first-child{
    margin-right: 19.5rem;
  }

  [dir="rtl"] .md\\:first\\:me-78:first-child{
    margin-left: 19.5rem;
  }

  [dir="ltr"] .md\\:first\\:ms-80:first-child{
    margin-left: 20rem;
  }

  [dir="rtl"] .md\\:first\\:ms-80:first-child{
    margin-right: 20rem;
  }

  [dir="ltr"] .md\\:first\\:me-80:first-child{
    margin-right: 20rem;
  }

  [dir="rtl"] .md\\:first\\:me-80:first-child{
    margin-left: 20rem;
  }

  [dir="ltr"] .md\\:first\\:ms-82:first-child{
    margin-left: 20.5rem;
  }

  [dir="rtl"] .md\\:first\\:ms-82:first-child{
    margin-right: 20.5rem;
  }

  [dir="ltr"] .md\\:first\\:me-82:first-child{
    margin-right: 20.5rem;
  }

  [dir="rtl"] .md\\:first\\:me-82:first-child{
    margin-left: 20.5rem;
  }

  [dir="ltr"] .md\\:first\\:ms-84:first-child{
    margin-left: 21rem;
  }

  [dir="rtl"] .md\\:first\\:ms-84:first-child{
    margin-right: 21rem;
  }

  [dir="ltr"] .md\\:first\\:me-84:first-child{
    margin-right: 21rem;
  }

  [dir="rtl"] .md\\:first\\:me-84:first-child{
    margin-left: 21rem;
  }

  [dir="ltr"] .md\\:first\\:ms-88:first-child{
    margin-left: 22rem;
  }

  [dir="rtl"] .md\\:first\\:ms-88:first-child{
    margin-right: 22rem;
  }

  [dir="ltr"] .md\\:first\\:me-88:first-child{
    margin-right: 22rem;
  }

  [dir="rtl"] .md\\:first\\:me-88:first-child{
    margin-left: 22rem;
  }

  [dir="ltr"] .md\\:first\\:ms-92:first-child{
    margin-left: 23rem;
  }

  [dir="rtl"] .md\\:first\\:ms-92:first-child{
    margin-right: 23rem;
  }

  [dir="ltr"] .md\\:first\\:me-92:first-child{
    margin-right: 23rem;
  }

  [dir="rtl"] .md\\:first\\:me-92:first-child{
    margin-left: 23rem;
  }

  [dir="ltr"] .md\\:first\\:ms-96:first-child{
    margin-left: 24rem;
  }

  [dir="rtl"] .md\\:first\\:ms-96:first-child{
    margin-right: 24rem;
  }

  [dir="ltr"] .md\\:first\\:me-96:first-child{
    margin-right: 24rem;
  }

  [dir="rtl"] .md\\:first\\:me-96:first-child{
    margin-left: 24rem;
  }

  [dir="ltr"] .md\\:first\\:ms-98:first-child{
    margin-left: 24.5rem;
  }

  [dir="rtl"] .md\\:first\\:ms-98:first-child{
    margin-right: 24.5rem;
  }

  [dir="ltr"] .md\\:first\\:me-98:first-child{
    margin-right: 24.5rem;
  }

  [dir="rtl"] .md\\:first\\:me-98:first-child{
    margin-left: 24.5rem;
  }

  [dir="ltr"] .md\\:first\\:ms-100:first-child{
    margin-left: 25rem;
  }

  [dir="rtl"] .md\\:first\\:ms-100:first-child{
    margin-right: 25rem;
  }

  [dir="ltr"] .md\\:first\\:me-100:first-child{
    margin-right: 25rem;
  }

  [dir="rtl"] .md\\:first\\:me-100:first-child{
    margin-left: 25rem;
  }

  [dir="ltr"] .md\\:first\\:ms-104:first-child{
    margin-left: 26rem;
  }

  [dir="rtl"] .md\\:first\\:ms-104:first-child{
    margin-right: 26rem;
  }

  [dir="ltr"] .md\\:first\\:me-104:first-child{
    margin-right: 26rem;
  }

  [dir="rtl"] .md\\:first\\:me-104:first-child{
    margin-left: 26rem;
  }

  [dir="ltr"] .md\\:first\\:ms-112:first-child{
    margin-left: 28rem;
  }

  [dir="rtl"] .md\\:first\\:ms-112:first-child{
    margin-right: 28rem;
  }

  [dir="ltr"] .md\\:first\\:me-112:first-child{
    margin-right: 28rem;
  }

  [dir="rtl"] .md\\:first\\:me-112:first-child{
    margin-left: 28rem;
  }

  [dir="ltr"] .md\\:first\\:ms-124:first-child{
    margin-left: 31rem;
  }

  [dir="rtl"] .md\\:first\\:ms-124:first-child{
    margin-right: 31rem;
  }

  [dir="ltr"] .md\\:first\\:me-124:first-child{
    margin-right: 31rem;
  }

  [dir="rtl"] .md\\:first\\:me-124:first-child{
    margin-left: 31rem;
  }

  [dir="ltr"] .md\\:first\\:ms-128:first-child{
    margin-left: 32rem;
  }

  [dir="rtl"] .md\\:first\\:ms-128:first-child{
    margin-right: 32rem;
  }

  [dir="ltr"] .md\\:first\\:me-128:first-child{
    margin-right: 32rem;
  }

  [dir="rtl"] .md\\:first\\:me-128:first-child{
    margin-left: 32rem;
  }

  [dir="ltr"] .md\\:first\\:ms-140:first-child{
    margin-left: 35rem;
  }

  [dir="rtl"] .md\\:first\\:ms-140:first-child{
    margin-right: 35rem;
  }

  [dir="ltr"] .md\\:first\\:me-140:first-child{
    margin-right: 35rem;
  }

  [dir="rtl"] .md\\:first\\:me-140:first-child{
    margin-left: 35rem;
  }

  [dir="ltr"] .md\\:first\\:ms-152:first-child{
    margin-left: 38rem;
  }

  [dir="rtl"] .md\\:first\\:ms-152:first-child{
    margin-right: 38rem;
  }

  [dir="ltr"] .md\\:first\\:me-152:first-child{
    margin-right: 38rem;
  }

  [dir="rtl"] .md\\:first\\:me-152:first-child{
    margin-left: 38rem;
  }

  [dir="ltr"] .md\\:first\\:ms-160:first-child{
    margin-left: 40rem;
  }

  [dir="rtl"] .md\\:first\\:ms-160:first-child{
    margin-right: 40rem;
  }

  [dir="ltr"] .md\\:first\\:me-160:first-child{
    margin-right: 40rem;
  }

  [dir="rtl"] .md\\:first\\:me-160:first-child{
    margin-left: 40rem;
  }

  [dir="ltr"] .md\\:first\\:ms-162:first-child{
    margin-left: 41rem;
  }

  [dir="rtl"] .md\\:first\\:ms-162:first-child{
    margin-right: 41rem;
  }

  [dir="ltr"] .md\\:first\\:me-162:first-child{
    margin-right: 41rem;
  }

  [dir="rtl"] .md\\:first\\:me-162:first-child{
    margin-left: 41rem;
  }

  [dir="ltr"] .md\\:first\\:ms-192:first-child{
    margin-left: 48rem;
  }

  [dir="rtl"] .md\\:first\\:ms-192:first-child{
    margin-right: 48rem;
  }

  [dir="ltr"] .md\\:first\\:me-192:first-child{
    margin-right: 48rem;
  }

  [dir="rtl"] .md\\:first\\:me-192:first-child{
    margin-left: 48rem;
  }

  [dir="ltr"] .md\\:first\\:ms-208:first-child{
    margin-left: 52rem;
  }

  [dir="rtl"] .md\\:first\\:ms-208:first-child{
    margin-right: 52rem;
  }

  [dir="ltr"] .md\\:first\\:me-208:first-child{
    margin-right: 52rem;
  }

  [dir="rtl"] .md\\:first\\:me-208:first-child{
    margin-left: 52rem;
  }

  [dir="ltr"] .md\\:first\\:ms-224:first-child{
    margin-left: 56rem;
  }

  [dir="rtl"] .md\\:first\\:ms-224:first-child{
    margin-right: 56rem;
  }

  [dir="ltr"] .md\\:first\\:me-224:first-child{
    margin-right: 56rem;
  }

  [dir="rtl"] .md\\:first\\:me-224:first-child{
    margin-left: 56rem;
  }

  [dir="ltr"] .md\\:first\\:ms-256:first-child{
    margin-left: 64rem;
  }

  [dir="rtl"] .md\\:first\\:ms-256:first-child{
    margin-right: 64rem;
  }

  [dir="ltr"] .md\\:first\\:me-256:first-child{
    margin-right: 64rem;
  }

  [dir="rtl"] .md\\:first\\:me-256:first-child{
    margin-left: 64rem;
  }

  [dir="ltr"] .md\\:first\\:ms-auto:first-child{
    margin-left: auto;
  }

  [dir="rtl"] .md\\:first\\:ms-auto:first-child{
    margin-right: auto;
  }

  [dir="ltr"] .md\\:first\\:me-auto:first-child{
    margin-right: auto;
  }

  [dir="rtl"] .md\\:first\\:me-auto:first-child{
    margin-left: auto;
  }

  [dir="ltr"] .md\\:first\\:ms-px:first-child{
    margin-left: 1px;
  }

  [dir="rtl"] .md\\:first\\:ms-px:first-child{
    margin-right: 1px;
  }

  [dir="ltr"] .md\\:first\\:me-px:first-child{
    margin-right: 1px;
  }

  [dir="rtl"] .md\\:first\\:me-px:first-child{
    margin-left: 1px;
  }

  [dir="ltr"] .md\\:first\\:-ms-1:first-child{
    margin-left: -0.25rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-1:first-child{
    margin-right: -0.25rem;
  }

  [dir="ltr"] .md\\:first\\:-me-1:first-child{
    margin-right: -0.25rem;
  }

  [dir="rtl"] .md\\:first\\:-me-1:first-child{
    margin-left: -0.25rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-2:first-child{
    margin-left: -0.5rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-2:first-child{
    margin-right: -0.5rem;
  }

  [dir="ltr"] .md\\:first\\:-me-2:first-child{
    margin-right: -0.5rem;
  }

  [dir="rtl"] .md\\:first\\:-me-2:first-child{
    margin-left: -0.5rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-3:first-child{
    margin-left: -0.75rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-3:first-child{
    margin-right: -0.75rem;
  }

  [dir="ltr"] .md\\:first\\:-me-3:first-child{
    margin-right: -0.75rem;
  }

  [dir="rtl"] .md\\:first\\:-me-3:first-child{
    margin-left: -0.75rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-4:first-child{
    margin-left: -1rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-4:first-child{
    margin-right: -1rem;
  }

  [dir="ltr"] .md\\:first\\:-me-4:first-child{
    margin-right: -1rem;
  }

  [dir="rtl"] .md\\:first\\:-me-4:first-child{
    margin-left: -1rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-5:first-child{
    margin-left: -1.25rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-5:first-child{
    margin-right: -1.25rem;
  }

  [dir="ltr"] .md\\:first\\:-me-5:first-child{
    margin-right: -1.25rem;
  }

  [dir="rtl"] .md\\:first\\:-me-5:first-child{
    margin-left: -1.25rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-6:first-child{
    margin-left: -1.5rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-6:first-child{
    margin-right: -1.5rem;
  }

  [dir="ltr"] .md\\:first\\:-me-6:first-child{
    margin-right: -1.5rem;
  }

  [dir="rtl"] .md\\:first\\:-me-6:first-child{
    margin-left: -1.5rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-7:first-child{
    margin-left: -1.75rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-7:first-child{
    margin-right: -1.75rem;
  }

  [dir="ltr"] .md\\:first\\:-me-7:first-child{
    margin-right: -1.75rem;
  }

  [dir="rtl"] .md\\:first\\:-me-7:first-child{
    margin-left: -1.75rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-8:first-child{
    margin-left: -2rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-8:first-child{
    margin-right: -2rem;
  }

  [dir="ltr"] .md\\:first\\:-me-8:first-child{
    margin-right: -2rem;
  }

  [dir="rtl"] .md\\:first\\:-me-8:first-child{
    margin-left: -2rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-9:first-child{
    margin-left: -2.25rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-9:first-child{
    margin-right: -2.25rem;
  }

  [dir="ltr"] .md\\:first\\:-me-9:first-child{
    margin-right: -2.25rem;
  }

  [dir="rtl"] .md\\:first\\:-me-9:first-child{
    margin-left: -2.25rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-10:first-child{
    margin-left: -2.5rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-10:first-child{
    margin-right: -2.5rem;
  }

  [dir="ltr"] .md\\:first\\:-me-10:first-child{
    margin-right: -2.5rem;
  }

  [dir="rtl"] .md\\:first\\:-me-10:first-child{
    margin-left: -2.5rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-11:first-child{
    margin-left: -2.75rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-11:first-child{
    margin-right: -2.75rem;
  }

  [dir="ltr"] .md\\:first\\:-me-11:first-child{
    margin-right: -2.75rem;
  }

  [dir="rtl"] .md\\:first\\:-me-11:first-child{
    margin-left: -2.75rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-12:first-child{
    margin-left: -3rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-12:first-child{
    margin-right: -3rem;
  }

  [dir="ltr"] .md\\:first\\:-me-12:first-child{
    margin-right: -3rem;
  }

  [dir="rtl"] .md\\:first\\:-me-12:first-child{
    margin-left: -3rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-14:first-child{
    margin-left: -3.5rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-14:first-child{
    margin-right: -3.5rem;
  }

  [dir="ltr"] .md\\:first\\:-me-14:first-child{
    margin-right: -3.5rem;
  }

  [dir="rtl"] .md\\:first\\:-me-14:first-child{
    margin-left: -3.5rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-15:first-child{
    margin-left: -3.75rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-15:first-child{
    margin-right: -3.75rem;
  }

  [dir="ltr"] .md\\:first\\:-me-15:first-child{
    margin-right: -3.75rem;
  }

  [dir="rtl"] .md\\:first\\:-me-15:first-child{
    margin-left: -3.75rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-16:first-child{
    margin-left: -4rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-16:first-child{
    margin-right: -4rem;
  }

  [dir="ltr"] .md\\:first\\:-me-16:first-child{
    margin-right: -4rem;
  }

  [dir="rtl"] .md\\:first\\:-me-16:first-child{
    margin-left: -4rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-18:first-child{
    margin-left: -4.5rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-18:first-child{
    margin-right: -4.5rem;
  }

  [dir="ltr"] .md\\:first\\:-me-18:first-child{
    margin-right: -4.5rem;
  }

  [dir="rtl"] .md\\:first\\:-me-18:first-child{
    margin-left: -4.5rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-20:first-child{
    margin-left: -5rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-20:first-child{
    margin-right: -5rem;
  }

  [dir="ltr"] .md\\:first\\:-me-20:first-child{
    margin-right: -5rem;
  }

  [dir="rtl"] .md\\:first\\:-me-20:first-child{
    margin-left: -5rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-22:first-child{
    margin-left: -5.5rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-22:first-child{
    margin-right: -5.5rem;
  }

  [dir="ltr"] .md\\:first\\:-me-22:first-child{
    margin-right: -5.5rem;
  }

  [dir="rtl"] .md\\:first\\:-me-22:first-child{
    margin-left: -5.5rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-23:first-child{
    margin-left: -5.75rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-23:first-child{
    margin-right: -5.75rem;
  }

  [dir="ltr"] .md\\:first\\:-me-23:first-child{
    margin-right: -5.75rem;
  }

  [dir="rtl"] .md\\:first\\:-me-23:first-child{
    margin-left: -5.75rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-24:first-child{
    margin-left: -6rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-24:first-child{
    margin-right: -6rem;
  }

  [dir="ltr"] .md\\:first\\:-me-24:first-child{
    margin-right: -6rem;
  }

  [dir="rtl"] .md\\:first\\:-me-24:first-child{
    margin-left: -6rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-25:first-child{
    margin-left: -6.25rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-25:first-child{
    margin-right: -6.25rem;
  }

  [dir="ltr"] .md\\:first\\:-me-25:first-child{
    margin-right: -6.25rem;
  }

  [dir="rtl"] .md\\:first\\:-me-25:first-child{
    margin-left: -6.25rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-26:first-child{
    margin-left: -6.5rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-26:first-child{
    margin-right: -6.5rem;
  }

  [dir="ltr"] .md\\:first\\:-me-26:first-child{
    margin-right: -6.5rem;
  }

  [dir="rtl"] .md\\:first\\:-me-26:first-child{
    margin-left: -6.5rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-28:first-child{
    margin-left: -7rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-28:first-child{
    margin-right: -7rem;
  }

  [dir="ltr"] .md\\:first\\:-me-28:first-child{
    margin-right: -7rem;
  }

  [dir="rtl"] .md\\:first\\:-me-28:first-child{
    margin-left: -7rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-30:first-child{
    margin-left: -7.5rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-30:first-child{
    margin-right: -7.5rem;
  }

  [dir="ltr"] .md\\:first\\:-me-30:first-child{
    margin-right: -7.5rem;
  }

  [dir="rtl"] .md\\:first\\:-me-30:first-child{
    margin-left: -7.5rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-32:first-child{
    margin-left: -8rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-32:first-child{
    margin-right: -8rem;
  }

  [dir="ltr"] .md\\:first\\:-me-32:first-child{
    margin-right: -8rem;
  }

  [dir="rtl"] .md\\:first\\:-me-32:first-child{
    margin-left: -8rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-34:first-child{
    margin-left: -8.5rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-34:first-child{
    margin-right: -8.5rem;
  }

  [dir="ltr"] .md\\:first\\:-me-34:first-child{
    margin-right: -8.5rem;
  }

  [dir="rtl"] .md\\:first\\:-me-34:first-child{
    margin-left: -8.5rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-40:first-child{
    margin-left: -10rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-40:first-child{
    margin-right: -10rem;
  }

  [dir="ltr"] .md\\:first\\:-me-40:first-child{
    margin-right: -10rem;
  }

  [dir="rtl"] .md\\:first\\:-me-40:first-child{
    margin-left: -10rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-42:first-child{
    margin-left: -10.5rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-42:first-child{
    margin-right: -10.5rem;
  }

  [dir="ltr"] .md\\:first\\:-me-42:first-child{
    margin-right: -10.5rem;
  }

  [dir="rtl"] .md\\:first\\:-me-42:first-child{
    margin-left: -10.5rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-44:first-child{
    margin-left: -11rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-44:first-child{
    margin-right: -11rem;
  }

  [dir="ltr"] .md\\:first\\:-me-44:first-child{
    margin-right: -11rem;
  }

  [dir="rtl"] .md\\:first\\:-me-44:first-child{
    margin-left: -11rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-48:first-child{
    margin-left: -12rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-48:first-child{
    margin-right: -12rem;
  }

  [dir="ltr"] .md\\:first\\:-me-48:first-child{
    margin-right: -12rem;
  }

  [dir="rtl"] .md\\:first\\:-me-48:first-child{
    margin-left: -12rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-52:first-child{
    margin-left: -13rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-52:first-child{
    margin-right: -13rem;
  }

  [dir="ltr"] .md\\:first\\:-me-52:first-child{
    margin-right: -13rem;
  }

  [dir="rtl"] .md\\:first\\:-me-52:first-child{
    margin-left: -13rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-54:first-child{
    margin-left: -13.5rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-54:first-child{
    margin-right: -13.5rem;
  }

  [dir="ltr"] .md\\:first\\:-me-54:first-child{
    margin-right: -13.5rem;
  }

  [dir="rtl"] .md\\:first\\:-me-54:first-child{
    margin-left: -13.5rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-56:first-child{
    margin-left: -14rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-56:first-child{
    margin-right: -14rem;
  }

  [dir="ltr"] .md\\:first\\:-me-56:first-child{
    margin-right: -14rem;
  }

  [dir="rtl"] .md\\:first\\:-me-56:first-child{
    margin-left: -14rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-60:first-child{
    margin-left: -15rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-60:first-child{
    margin-right: -15rem;
  }

  [dir="ltr"] .md\\:first\\:-me-60:first-child{
    margin-right: -15rem;
  }

  [dir="rtl"] .md\\:first\\:-me-60:first-child{
    margin-left: -15rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-64:first-child{
    margin-left: -16rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-64:first-child{
    margin-right: -16rem;
  }

  [dir="ltr"] .md\\:first\\:-me-64:first-child{
    margin-right: -16rem;
  }

  [dir="rtl"] .md\\:first\\:-me-64:first-child{
    margin-left: -16rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-68:first-child{
    margin-left: -17rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-68:first-child{
    margin-right: -17rem;
  }

  [dir="ltr"] .md\\:first\\:-me-68:first-child{
    margin-right: -17rem;
  }

  [dir="rtl"] .md\\:first\\:-me-68:first-child{
    margin-left: -17rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-72:first-child{
    margin-left: -18rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-72:first-child{
    margin-right: -18rem;
  }

  [dir="ltr"] .md\\:first\\:-me-72:first-child{
    margin-right: -18rem;
  }

  [dir="rtl"] .md\\:first\\:-me-72:first-child{
    margin-left: -18rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-74:first-child{
    margin-left: -18.5rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-74:first-child{
    margin-right: -18.5rem;
  }

  [dir="ltr"] .md\\:first\\:-me-74:first-child{
    margin-right: -18.5rem;
  }

  [dir="rtl"] .md\\:first\\:-me-74:first-child{
    margin-left: -18.5rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-76:first-child{
    margin-left: -19rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-76:first-child{
    margin-right: -19rem;
  }

  [dir="ltr"] .md\\:first\\:-me-76:first-child{
    margin-right: -19rem;
  }

  [dir="rtl"] .md\\:first\\:-me-76:first-child{
    margin-left: -19rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-78:first-child{
    margin-left: -19.5rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-78:first-child{
    margin-right: -19.5rem;
  }

  [dir="ltr"] .md\\:first\\:-me-78:first-child{
    margin-right: -19.5rem;
  }

  [dir="rtl"] .md\\:first\\:-me-78:first-child{
    margin-left: -19.5rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-80:first-child{
    margin-left: -20rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-80:first-child{
    margin-right: -20rem;
  }

  [dir="ltr"] .md\\:first\\:-me-80:first-child{
    margin-right: -20rem;
  }

  [dir="rtl"] .md\\:first\\:-me-80:first-child{
    margin-left: -20rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-82:first-child{
    margin-left: -20.5rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-82:first-child{
    margin-right: -20.5rem;
  }

  [dir="ltr"] .md\\:first\\:-me-82:first-child{
    margin-right: -20.5rem;
  }

  [dir="rtl"] .md\\:first\\:-me-82:first-child{
    margin-left: -20.5rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-84:first-child{
    margin-left: -21rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-84:first-child{
    margin-right: -21rem;
  }

  [dir="ltr"] .md\\:first\\:-me-84:first-child{
    margin-right: -21rem;
  }

  [dir="rtl"] .md\\:first\\:-me-84:first-child{
    margin-left: -21rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-88:first-child{
    margin-left: -22rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-88:first-child{
    margin-right: -22rem;
  }

  [dir="ltr"] .md\\:first\\:-me-88:first-child{
    margin-right: -22rem;
  }

  [dir="rtl"] .md\\:first\\:-me-88:first-child{
    margin-left: -22rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-92:first-child{
    margin-left: -23rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-92:first-child{
    margin-right: -23rem;
  }

  [dir="ltr"] .md\\:first\\:-me-92:first-child{
    margin-right: -23rem;
  }

  [dir="rtl"] .md\\:first\\:-me-92:first-child{
    margin-left: -23rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-96:first-child{
    margin-left: -24rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-96:first-child{
    margin-right: -24rem;
  }

  [dir="ltr"] .md\\:first\\:-me-96:first-child{
    margin-right: -24rem;
  }

  [dir="rtl"] .md\\:first\\:-me-96:first-child{
    margin-left: -24rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-98:first-child{
    margin-left: -24.5rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-98:first-child{
    margin-right: -24.5rem;
  }

  [dir="ltr"] .md\\:first\\:-me-98:first-child{
    margin-right: -24.5rem;
  }

  [dir="rtl"] .md\\:first\\:-me-98:first-child{
    margin-left: -24.5rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-100:first-child{
    margin-left: -25rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-100:first-child{
    margin-right: -25rem;
  }

  [dir="ltr"] .md\\:first\\:-me-100:first-child{
    margin-right: -25rem;
  }

  [dir="rtl"] .md\\:first\\:-me-100:first-child{
    margin-left: -25rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-104:first-child{
    margin-left: -26rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-104:first-child{
    margin-right: -26rem;
  }

  [dir="ltr"] .md\\:first\\:-me-104:first-child{
    margin-right: -26rem;
  }

  [dir="rtl"] .md\\:first\\:-me-104:first-child{
    margin-left: -26rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-112:first-child{
    margin-left: -28rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-112:first-child{
    margin-right: -28rem;
  }

  [dir="ltr"] .md\\:first\\:-me-112:first-child{
    margin-right: -28rem;
  }

  [dir="rtl"] .md\\:first\\:-me-112:first-child{
    margin-left: -28rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-124:first-child{
    margin-left: -31rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-124:first-child{
    margin-right: -31rem;
  }

  [dir="ltr"] .md\\:first\\:-me-124:first-child{
    margin-right: -31rem;
  }

  [dir="rtl"] .md\\:first\\:-me-124:first-child{
    margin-left: -31rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-128:first-child{
    margin-left: -32rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-128:first-child{
    margin-right: -32rem;
  }

  [dir="ltr"] .md\\:first\\:-me-128:first-child{
    margin-right: -32rem;
  }

  [dir="rtl"] .md\\:first\\:-me-128:first-child{
    margin-left: -32rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-140:first-child{
    margin-left: -35rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-140:first-child{
    margin-right: -35rem;
  }

  [dir="ltr"] .md\\:first\\:-me-140:first-child{
    margin-right: -35rem;
  }

  [dir="rtl"] .md\\:first\\:-me-140:first-child{
    margin-left: -35rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-152:first-child{
    margin-left: -38rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-152:first-child{
    margin-right: -38rem;
  }

  [dir="ltr"] .md\\:first\\:-me-152:first-child{
    margin-right: -38rem;
  }

  [dir="rtl"] .md\\:first\\:-me-152:first-child{
    margin-left: -38rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-160:first-child{
    margin-left: -40rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-160:first-child{
    margin-right: -40rem;
  }

  [dir="ltr"] .md\\:first\\:-me-160:first-child{
    margin-right: -40rem;
  }

  [dir="rtl"] .md\\:first\\:-me-160:first-child{
    margin-left: -40rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-162:first-child{
    margin-left: -41rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-162:first-child{
    margin-right: -41rem;
  }

  [dir="ltr"] .md\\:first\\:-me-162:first-child{
    margin-right: -41rem;
  }

  [dir="rtl"] .md\\:first\\:-me-162:first-child{
    margin-left: -41rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-192:first-child{
    margin-left: -48rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-192:first-child{
    margin-right: -48rem;
  }

  [dir="ltr"] .md\\:first\\:-me-192:first-child{
    margin-right: -48rem;
  }

  [dir="rtl"] .md\\:first\\:-me-192:first-child{
    margin-left: -48rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-208:first-child{
    margin-left: -52rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-208:first-child{
    margin-right: -52rem;
  }

  [dir="ltr"] .md\\:first\\:-me-208:first-child{
    margin-right: -52rem;
  }

  [dir="rtl"] .md\\:first\\:-me-208:first-child{
    margin-left: -52rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-224:first-child{
    margin-left: -56rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-224:first-child{
    margin-right: -56rem;
  }

  [dir="ltr"] .md\\:first\\:-me-224:first-child{
    margin-right: -56rem;
  }

  [dir="rtl"] .md\\:first\\:-me-224:first-child{
    margin-left: -56rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-256:first-child{
    margin-left: -64rem;
  }

  [dir="rtl"] .md\\:first\\:-ms-256:first-child{
    margin-right: -64rem;
  }

  [dir="ltr"] .md\\:first\\:-me-256:first-child{
    margin-right: -64rem;
  }

  [dir="rtl"] .md\\:first\\:-me-256:first-child{
    margin-left: -64rem;
  }

  [dir="ltr"] .md\\:first\\:-ms-px:first-child{
    margin-left: -1px;
  }

  [dir="rtl"] .md\\:first\\:-ms-px:first-child{
    margin-right: -1px;
  }

  [dir="ltr"] .md\\:first\\:-me-px:first-child{
    margin-right: -1px;
  }

  [dir="rtl"] .md\\:first\\:-me-px:first-child{
    margin-left: -1px;
  }

  [dir="rtl"] .md\\:start-0{
    right: 0;
  }

  [dir="rtl"] .md\\:end-0{
    left: 0;
  }

  [dir="ltr"] .md\\:end-0{
    right: 0;
  }

  [dir="ltr"] .md\\:start-0{
    left: 0;
  }

  [dir="rtl"] .md\\:start-auto{
    right: auto;
  }

  [dir="rtl"] .md\\:end-auto{
    left: auto;
  }

  [dir="ltr"] .md\\:end-auto{
    right: auto;
  }

  [dir="ltr"] .md\\:start-auto{
    left: auto;
  }

  [dir="ltr"] .md\\:rounded-e-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .md\\:rounded-s-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .md\\:rounded-e-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .md\\:rounded-s-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .md\\:rounded-e-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .md\\:rounded-s-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .md\\:rounded-e-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .md\\:rounded-s-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .md\\:rounded-e{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .md\\:rounded-s{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .md\\:rounded-e{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .md\\:rounded-s{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .md\\:rounded-e-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .md\\:rounded-s-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .md\\:rounded-e-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .md\\:rounded-s-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .md\\:rounded-e-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .md\\:rounded-s-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .md\\:rounded-e-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .md\\:rounded-s-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .md\\:rounded-e-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .md\\:rounded-s-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .md\\:rounded-e-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .md\\:rounded-s-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .md\\:rounded-ts-none{
    border-top-left-radius: 0;
  }

  [dir="ltr"] .md\\:rounded-te-none{
    border-top-right-radius: 0;
  }

  [dir="ltr"] .md\\:rounded-be-none{
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .md\\:rounded-bs-none{
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .md\\:rounded-te-none{
    border-top-left-radius: 0;
  }

  [dir="rtl"] .md\\:rounded-ts-none{
    border-top-right-radius: 0;
  }

  [dir="rtl"] .md\\:rounded-bs-none{
    border-bottom-right-radius: 0;
  }

  [dir="rtl"] .md\\:rounded-be-none{
    border-bottom-left-radius: 0;
  }

  [dir="ltr"] .md\\:rounded-ts-sm{
    border-top-left-radius: .25rem;
  }

  [dir="ltr"] .md\\:rounded-te-sm{
    border-top-right-radius: .25rem;
  }

  [dir="ltr"] .md\\:rounded-be-sm{
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .md\\:rounded-bs-sm{
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .md\\:rounded-te-sm{
    border-top-left-radius: .25rem;
  }

  [dir="rtl"] .md\\:rounded-ts-sm{
    border-top-right-radius: .25rem;
  }

  [dir="rtl"] .md\\:rounded-bs-sm{
    border-bottom-right-radius: .25rem;
  }

  [dir="rtl"] .md\\:rounded-be-sm{
    border-bottom-left-radius: .25rem;
  }

  [dir="ltr"] .md\\:rounded-ts{
    border-top-left-radius: .375rem;
  }

  [dir="ltr"] .md\\:rounded-te{
    border-top-right-radius: .375rem;
  }

  [dir="ltr"] .md\\:rounded-be{
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .md\\:rounded-bs{
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .md\\:rounded-te{
    border-top-left-radius: .375rem;
  }

  [dir="rtl"] .md\\:rounded-ts{
    border-top-right-radius: .375rem;
  }

  [dir="rtl"] .md\\:rounded-bs{
    border-bottom-right-radius: .375rem;
  }

  [dir="rtl"] .md\\:rounded-be{
    border-bottom-left-radius: .375rem;
  }

  [dir="ltr"] .md\\:rounded-ts-lg{
    border-top-left-radius: .5rem;
  }

  [dir="ltr"] .md\\:rounded-te-lg{
    border-top-right-radius: .5rem;
  }

  [dir="ltr"] .md\\:rounded-be-lg{
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .md\\:rounded-bs-lg{
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .md\\:rounded-te-lg{
    border-top-left-radius: .5rem;
  }

  [dir="rtl"] .md\\:rounded-ts-lg{
    border-top-right-radius: .5rem;
  }

  [dir="rtl"] .md\\:rounded-bs-lg{
    border-bottom-right-radius: .5rem;
  }

  [dir="rtl"] .md\\:rounded-be-lg{
    border-bottom-left-radius: .5rem;
  }

  [dir="ltr"] .md\\:rounded-ts-xl{
    border-top-left-radius: .75rem;
  }

  [dir="ltr"] .md\\:rounded-te-xl{
    border-top-right-radius: .75rem;
  }

  [dir="ltr"] .md\\:rounded-be-xl{
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .md\\:rounded-bs-xl{
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .md\\:rounded-te-xl{
    border-top-left-radius: .75rem;
  }

  [dir="rtl"] .md\\:rounded-ts-xl{
    border-top-right-radius: .75rem;
  }

  [dir="rtl"] .md\\:rounded-bs-xl{
    border-bottom-right-radius: .75rem;
  }

  [dir="rtl"] .md\\:rounded-be-xl{
    border-bottom-left-radius: .75rem;
  }

  [dir="ltr"] .md\\:rounded-ts-full{
    border-top-left-radius: 9999px;
  }

  [dir="ltr"] .md\\:rounded-te-full{
    border-top-right-radius: 9999px;
  }

  [dir="ltr"] .md\\:rounded-be-full{
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .md\\:rounded-bs-full{
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .md\\:rounded-te-full{
    border-top-left-radius: 9999px;
  }

  [dir="rtl"] .md\\:rounded-ts-full{
    border-top-right-radius: 9999px;
  }

  [dir="rtl"] .md\\:rounded-bs-full{
    border-bottom-right-radius: 9999px;
  }

  [dir="rtl"] .md\\:rounded-be-full{
    border-bottom-left-radius: 9999px;
  }

  [dir="ltr"] .md\\:clear-start{
    clear: left;
  }

  [dir="ltr"] .md\\:clear-end{
    clear: right;
  }

  [dir="rtl"] .md\\:clear-start{
    clear: right;
  }

  [dir="rtl"] .md\\:clear-end{
    clear: left;
  }

  [dir="rtl"] .md\\:float-start{
    float: right;
  }

  [dir="rtl"] .md\\:float-end{
    float: left;
  }

  [dir="ltr"] .md\\:float-end{
    float: right;
  }

  [dir="ltr"] .md\\:float-start{
    float: left;
  }

  [dir="ltr"] .md\\:border-e-0{
    border-right-width: 0;
  }

  [dir="rtl"] .md\\:border-e-0{
    border-left-width: 0;
  }

  [dir="ltr"] .md\\:border-s-0{
    border-left-width: 0;
  }

  [dir="rtl"] .md\\:border-s-0{
    border-right-width: 0;
  }

  [dir="ltr"] .md\\:border-e-2{
    border-right-width: 2px;
  }

  [dir="rtl"] .md\\:border-e-2{
    border-left-width: 2px;
  }

  [dir="ltr"] .md\\:border-s-2{
    border-left-width: 2px;
  }

  [dir="rtl"] .md\\:border-s-2{
    border-right-width: 2px;
  }

  [dir="ltr"] .md\\:border-e-3{
    border-right-width: 3px;
  }

  [dir="rtl"] .md\\:border-e-3{
    border-left-width: 3px;
  }

  [dir="ltr"] .md\\:border-s-3{
    border-left-width: 3px;
  }

  [dir="rtl"] .md\\:border-s-3{
    border-right-width: 3px;
  }

  [dir="ltr"] .md\\:border-e-4{
    border-right-width: 4px;
  }

  [dir="rtl"] .md\\:border-e-4{
    border-left-width: 4px;
  }

  [dir="ltr"] .md\\:border-s-4{
    border-left-width: 4px;
  }

  [dir="rtl"] .md\\:border-s-4{
    border-right-width: 4px;
  }

  [dir="ltr"] .md\\:border-e-5{
    border-right-width: 5px;
  }

  [dir="rtl"] .md\\:border-e-5{
    border-left-width: 5px;
  }

  [dir="ltr"] .md\\:border-s-5{
    border-left-width: 5px;
  }

  [dir="rtl"] .md\\:border-s-5{
    border-right-width: 5px;
  }

  [dir="ltr"] .md\\:border-e-6{
    border-right-width: 6px;
  }

  [dir="rtl"] .md\\:border-e-6{
    border-left-width: 6px;
  }

  [dir="ltr"] .md\\:border-s-6{
    border-left-width: 6px;
  }

  [dir="rtl"] .md\\:border-s-6{
    border-right-width: 6px;
  }

  [dir="ltr"] .md\\:border-e-8{
    border-right-width: 8px;
  }

  [dir="rtl"] .md\\:border-e-8{
    border-left-width: 8px;
  }

  [dir="ltr"] .md\\:border-s-8{
    border-left-width: 8px;
  }

  [dir="rtl"] .md\\:border-s-8{
    border-right-width: 8px;
  }

  [dir="ltr"] .md\\:border-e{
    border-right-width: 1px;
  }

  [dir="rtl"] .md\\:border-e{
    border-left-width: 1px;
  }

  [dir="ltr"] .md\\:border-s{
    border-left-width: 1px;
  }

  [dir="rtl"] .md\\:border-s{
    border-right-width: 1px;
  }

  [dir="ltr"] .md\\:first\\:border-e-0:first-child{
    border-right-width: 0;
  }

  [dir="rtl"] .md\\:first\\:border-e-0:first-child{
    border-left-width: 0;
  }

  [dir="ltr"] .md\\:first\\:border-s-0:first-child{
    border-left-width: 0;
  }

  [dir="rtl"] .md\\:first\\:border-s-0:first-child{
    border-right-width: 0;
  }

  [dir="ltr"] .md\\:first\\:border-e-2:first-child{
    border-right-width: 2px;
  }

  [dir="rtl"] .md\\:first\\:border-e-2:first-child{
    border-left-width: 2px;
  }

  [dir="ltr"] .md\\:first\\:border-s-2:first-child{
    border-left-width: 2px;
  }

  [dir="rtl"] .md\\:first\\:border-s-2:first-child{
    border-right-width: 2px;
  }

  [dir="ltr"] .md\\:first\\:border-e-3:first-child{
    border-right-width: 3px;
  }

  [dir="rtl"] .md\\:first\\:border-e-3:first-child{
    border-left-width: 3px;
  }

  [dir="ltr"] .md\\:first\\:border-s-3:first-child{
    border-left-width: 3px;
  }

  [dir="rtl"] .md\\:first\\:border-s-3:first-child{
    border-right-width: 3px;
  }

  [dir="ltr"] .md\\:first\\:border-e-4:first-child{
    border-right-width: 4px;
  }

  [dir="rtl"] .md\\:first\\:border-e-4:first-child{
    border-left-width: 4px;
  }

  [dir="ltr"] .md\\:first\\:border-s-4:first-child{
    border-left-width: 4px;
  }

  [dir="rtl"] .md\\:first\\:border-s-4:first-child{
    border-right-width: 4px;
  }

  [dir="ltr"] .md\\:first\\:border-e-5:first-child{
    border-right-width: 5px;
  }

  [dir="rtl"] .md\\:first\\:border-e-5:first-child{
    border-left-width: 5px;
  }

  [dir="ltr"] .md\\:first\\:border-s-5:first-child{
    border-left-width: 5px;
  }

  [dir="rtl"] .md\\:first\\:border-s-5:first-child{
    border-right-width: 5px;
  }

  [dir="ltr"] .md\\:first\\:border-e-6:first-child{
    border-right-width: 6px;
  }

  [dir="rtl"] .md\\:first\\:border-e-6:first-child{
    border-left-width: 6px;
  }

  [dir="ltr"] .md\\:first\\:border-s-6:first-child{
    border-left-width: 6px;
  }

  [dir="rtl"] .md\\:first\\:border-s-6:first-child{
    border-right-width: 6px;
  }

  [dir="ltr"] .md\\:first\\:border-e-8:first-child{
    border-right-width: 8px;
  }

  [dir="rtl"] .md\\:first\\:border-e-8:first-child{
    border-left-width: 8px;
  }

  [dir="ltr"] .md\\:first\\:border-s-8:first-child{
    border-left-width: 8px;
  }

  [dir="rtl"] .md\\:first\\:border-s-8:first-child{
    border-right-width: 8px;
  }

  [dir="ltr"] .md\\:first\\:border-e:first-child{
    border-right-width: 1px;
  }

  [dir="rtl"] .md\\:first\\:border-e:first-child{
    border-left-width: 1px;
  }

  [dir="ltr"] .md\\:first\\:border-s:first-child{
    border-left-width: 1px;
  }

  [dir="rtl"] .md\\:first\\:border-s:first-child{
    border-right-width: 1px;
  }

  [dir="rtl"] .md\\:text-start{
    text-align: right;
  }

  [dir="rtl"] .md\\:text-end{
    text-align: left;
  }

  [dir="ltr"] .md\\:text-end{
    text-align: right;
  }

  [dir="ltr"] .md\\:text-start{
    text-align: left;
  }

  [dir="ltr"] .md\\:origin-top-start{
    transform-origin: top left;
  }

  [dir="ltr"] .md\\:origin-top-end{
    transform-origin: top right;
  }

  [dir="ltr"] .md\\:origin-bottom-start{
    transform-origin: bottom left;
  }

  [dir="ltr"] .md\\:origin-bottom-end{
    transform-origin: bottom right;
  }

  [dir="ltr"] .md\\:origin-start{
    transform-origin: left;
  }

  [dir="ltr"] .md\\:origin-end{
    transform-origin: right;
  }

  [dir="rtl"] .md\\:origin-top-start{
    transform-origin: top right;
  }

  [dir="rtl"] .md\\:origin-top-end{
    transform-origin: top left;
  }

  [dir="rtl"] .md\\:origin-bottom-start{
    transform-origin: bottom right;
  }

  [dir="rtl"] .md\\:origin-bottom-end{
    transform-origin: bottom left;
  }

  [dir="rtl"] .md\\:origin-start{
    transform-origin: right;
  }

  [dir="rtl"] .md\\:origin-end{
    transform-origin: left;
  }

  [dir="ltr"] .md\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .md\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .md\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .md\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .md\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .md\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * (1 - var(--tw-space-s-reverse)));
  }

  .md\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  .md\\:space-s-reverse > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 1;
  }
}

@media (min-width: 1024px){
  .lg\\:prose{
    color: #4a5568;
    max-width: 65ch;
  }

  .lg\\:prose [class~="lead"]{
    color: #4a5568;
    font-size: 1.25em;
    line-height: 1.6;
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .lg\\:prose a{
    color: #1a202c;
    text-decoration: underline;
  }

  .lg\\:prose strong{
    color: #1a202c;
    font-weight: 600;
  }

  .lg\\:prose ol{
    counter-reset: list-counter;
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .lg\\:prose ol > li{
    position: relative;
    counter-increment: list-counter;
    padding-left: 1.75em;
  }

  .lg\\:prose ol > li::before{
    content: ;
    position: absolute;
    font-weight: 400;
    color: #718096;
  }

  .lg\\:prose ul > li{
    position: relative;
    padding-left: 1.75em;
  }

  .lg\\:prose ul > li::before{
    content: "";
    position: absolute;
    background-color: #cbd5e0;
    border-radius: 50%;
    width: 0.375em;
    height: 0.375em;
    top: calc(0.875em - 0.1875em);
    left: 0.25em;
  }

  .lg\\:prose hr{
    border-color: #e2e8f0;
    border-top-width: 1px;
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .lg\\:prose blockquote{
    font-weight: 500;
    font-style: italic;
    color: #1a202c;
    border-left-width: 0.25rem;
    border-left-color: #e2e8f0;
    quotes: "\\201C""\\201D""\\2018""\\2019";
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1em;
  }

  .lg\\:prose blockquote p:first-of-type::before{
    content: open-quote;
  }

  .lg\\:prose blockquote p:last-of-type::after{
    content: close-quote;
  }

  .lg\\:prose h1{
    color: #1a202c;
    font-weight: 800;
    font-size: 2.25em;
    margin-top: 0;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }

  .lg\\:prose h2{
    color: #1a202c;
    font-weight: 700;
    font-size: 1.5em;
    margin-top: 2em;
    margin-bottom: 1em;
    line-height: 1.3333333;
  }

  .lg\\:prose h3{
    color: #1a202c;
    font-weight: 600;
    font-size: 1.25em;
    margin-top: 1.6em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }

  .lg\\:prose h4{
    color: #1a202c;
    font-weight: 600;
    margin-top: 1.5em;
    margin-bottom: 0.5em;
    line-height: 1.5;
  }

  .lg\\:prose figure figcaption{
    color: #718096;
    font-size: 0.875em;
    line-height: 1.4285714;
    margin-top: 0.8571429em;
  }

  .lg\\:prose code{
    color: #1a202c;
    font-weight: 600;
    font-size: 0.875em;
  }

  .lg\\:prose code::before{
    content: "\`";
  }

  .lg\\:prose code::after{
    content: "\`";
  }

  .lg\\:prose pre{
    color: #e2e8f0;
    background-color: #2d3748;
    overflow-x: auto;
    font-size: 0.875em;
    line-height: 1.7142857;
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
    border-radius: 0.375rem;
    padding-top: 0.8571429em;
    padding-right: 1.1428571em;
    padding-bottom: 0.8571429em;
    padding-left: 1.1428571em;
  }

  .lg\\:prose pre code{
    background-color: transparent;
    border-width: 0;
    border-radius: 0;
    padding: 0;
    font-weight: 400;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
  }

  .lg\\:prose pre code::before{
    content: "";
  }

  .lg\\:prose pre code::after{
    content: "";
  }

  .lg\\:prose table{
    width: 100%;
    table-layout: auto;
    text-align: left;
    margin-top: 2em;
    margin-bottom: 2em;
    font-size: 0.875em;
    line-height: 1.7142857;
  }

  .lg\\:prose thead{
    color: #1a202c;
    font-weight: 600;
    border-bottom-width: 1px;
    border-bottom-color: #cbd5e0;
  }

  .lg\\:prose thead th{
    vertical-align: bottom;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }

  .lg\\:prose tbody tr{
    border-bottom-width: 1px;
    border-bottom-color: #e2e8f0;
  }

  .lg\\:prose tbody tr:last-child{
    border-bottom-width: 0;
  }

  .lg\\:prose tbody td{
    vertical-align: top;
    padding-top: 0.5714286em;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }

  .lg\\:prose{
    font-size: 1rem;
    line-height: 1.75;
  }

  .lg\\:prose p{
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .lg\\:prose img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .lg\\:prose video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .lg\\:prose figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .lg\\:prose figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .lg\\:prose h2 code{
    font-size: 0.875em;
  }

  .lg\\:prose h3 code{
    font-size: 0.9em;
  }

  .lg\\:prose ul{
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .lg\\:prose li{
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .lg\\:prose ol > li:before{
    left: 0;
  }

  .lg\\:prose > ul > li p{
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }

  .lg\\:prose > ul > li > *:first-child{
    margin-top: 1.25em;
  }

  .lg\\:prose > ul > li > *:last-child{
    margin-bottom: 1.25em;
  }

  .lg\\:prose > ol > li > *:first-child{
    margin-top: 1.25em;
  }

  .lg\\:prose > ol > li > *:last-child{
    margin-bottom: 1.25em;
  }

  .lg\\:prose ul ul, .lg\\:prose ul ol, .lg\\:prose ol ul, .lg\\:prose ol ol{
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }

  .lg\\:prose hr + *{
    margin-top: 0;
  }

  .lg\\:prose h2 + *{
    margin-top: 0;
  }

  .lg\\:prose h3 + *{
    margin-top: 0;
  }

  .lg\\:prose h4 + *{
    margin-top: 0;
  }

  .lg\\:prose thead th:first-child{
    padding-left: 0;
  }

  .lg\\:prose thead th:last-child{
    padding-right: 0;
  }

  .lg\\:prose tbody td:first-child{
    padding-left: 0;
  }

  .lg\\:prose tbody td:last-child{
    padding-right: 0;
  }

  .lg\\:prose > :first-child{
    margin-top: 0;
  }

  .lg\\:prose > :last-child{
    margin-bottom: 0;
  }

  .lg\\:prose-sm{
    font-size: 0.875rem;
    line-height: 1.7142857;
  }

  .lg\\:prose-sm p{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .lg\\:prose-sm [class~="lead"]{
    font-size: 1.2857143em;
    line-height: 1.5555556;
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .lg\\:prose-sm blockquote{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
    padding-left: 1.1111111em;
  }

  .lg\\:prose-sm h1{
    font-size: 2.1428571em;
    margin-top: 0;
    margin-bottom: 0.8em;
    line-height: 1.2;
  }

  .lg\\:prose-sm h2{
    font-size: 1.4285714em;
    margin-top: 1.6em;
    margin-bottom: 0.8em;
    line-height: 1.4;
  }

  .lg\\:prose-sm h3{
    font-size: 1.2857143em;
    margin-top: 1.5555556em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }

  .lg\\:prose-sm h4{
    margin-top: 1.4285714em;
    margin-bottom: 0.5714286em;
    line-height: 1.4285714;
  }

  .lg\\:prose-sm img{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .lg\\:prose-sm video{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .lg\\:prose-sm figure{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .lg\\:prose-sm figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .lg\\:prose-sm figure figcaption{
    font-size: 0.8571429em;
    line-height: 1.3333333;
    margin-top: 0.6666667em;
  }

  .lg\\:prose-sm code{
    font-size: 0.8571429em;
  }

  .lg\\:prose-sm h2 code{
    font-size: 0.9em;
  }

  .lg\\:prose-sm h3 code{
    font-size: 0.8888889em;
  }

  .lg\\:prose-sm pre{
    font-size: 0.8571429em;
    line-height: 1.6666667;
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    border-radius: 0.25rem;
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .lg\\:prose-sm ol{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .lg\\:prose-sm ul{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .lg\\:prose-sm li{
    margin-top: 0.2857143em;
    margin-bottom: 0.2857143em;
  }

  .lg\\:prose-sm ol > li{
    padding-left: 1.5714286em;
  }

  .lg\\:prose-sm ol > li:before{
    left: 0;
  }

  .lg\\:prose-sm ul > li{
    padding-left: 1.5714286em;
  }

  .lg\\:prose-sm ul > li::before{
    height: 0.3571429em;
    width: 0.3571429em;
    top: calc(0.8571429em - 0.1785714em);
    left: 0.2142857em;
  }

  .lg\\:prose-sm > ul > li p{
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }

  .lg\\:prose-sm > ul > li > *:first-child{
    margin-top: 1.1428571em;
  }

  .lg\\:prose-sm > ul > li > *:last-child{
    margin-bottom: 1.1428571em;
  }

  .lg\\:prose-sm > ol > li > *:first-child{
    margin-top: 1.1428571em;
  }

  .lg\\:prose-sm > ol > li > *:last-child{
    margin-bottom: 1.1428571em;
  }

  .lg\\:prose-sm ul ul, .lg\\:prose-sm ul ol, .lg\\:prose-sm ol ul, .lg\\:prose-sm ol ol{
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }

  .lg\\:prose-sm hr{
    margin-top: 2.8571429em;
    margin-bottom: 2.8571429em;
  }

  .lg\\:prose-sm hr + *{
    margin-top: 0;
  }

  .lg\\:prose-sm h2 + *{
    margin-top: 0;
  }

  .lg\\:prose-sm h3 + *{
    margin-top: 0;
  }

  .lg\\:prose-sm h4 + *{
    margin-top: 0;
  }

  .lg\\:prose-sm table{
    font-size: 0.8571429em;
    line-height: 1.5;
  }

  .lg\\:prose-sm thead th{
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .lg\\:prose-sm thead th:first-child{
    padding-left: 0;
  }

  .lg\\:prose-sm thead th:last-child{
    padding-right: 0;
  }

  .lg\\:prose-sm tbody td{
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .lg\\:prose-sm tbody td:first-child{
    padding-left: 0;
  }

  .lg\\:prose-sm tbody td:last-child{
    padding-right: 0;
  }

  .lg\\:prose-sm > :first-child{
    margin-top: 0;
  }

  .lg\\:prose-sm > :last-child{
    margin-bottom: 0;
  }

  .lg\\:prose-lg{
    font-size: 1.125rem;
    line-height: 1.7777778;
  }

  .lg\\:prose-lg p{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .lg\\:prose-lg [class~="lead"]{
    font-size: 1.2222222em;
    line-height: 1.4545455;
    margin-top: 1.0909091em;
    margin-bottom: 1.0909091em;
  }

  .lg\\:prose-lg blockquote{
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    padding-left: 1em;
  }

  .lg\\:prose-lg h1{
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.8333333em;
    line-height: 1;
  }

  .lg\\:prose-lg h2{
    font-size: 1.6666667em;
    margin-top: 1.8666667em;
    margin-bottom: 1.0666667em;
    line-height: 1.3333333;
  }

  .lg\\:prose-lg h3{
    font-size: 1.3333333em;
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }

  .lg\\:prose-lg h4{
    margin-top: 1.7777778em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }

  .lg\\:prose-lg img{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .lg\\:prose-lg video{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .lg\\:prose-lg figure{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .lg\\:prose-lg figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .lg\\:prose-lg figure figcaption{
    font-size: 0.8888889em;
    line-height: 1.5;
    margin-top: 1em;
  }

  .lg\\:prose-lg code{
    font-size: 0.8888889em;
  }

  .lg\\:prose-lg h2 code{
    font-size: 0.8666667em;
  }

  .lg\\:prose-lg h3 code{
    font-size: 0.875em;
  }

  .lg\\:prose-lg pre{
    font-size: 0.8888889em;
    line-height: 1.75;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.375rem;
    padding-top: 1em;
    padding-right: 1.5em;
    padding-bottom: 1em;
    padding-left: 1.5em;
  }

  .lg\\:prose-lg ol{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .lg\\:prose-lg ul{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .lg\\:prose-lg li{
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }

  .lg\\:prose-lg ol > li{
    padding-left: 1.6666667em;
  }

  .lg\\:prose-lg ol > li:before{
    left: 0;
  }

  .lg\\:prose-lg ul > li{
    padding-left: 1.6666667em;
  }

  .lg\\:prose-lg ul > li::before{
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8888889em - 0.1666667em);
    left: 0.2222222em;
  }

  .lg\\:prose-lg > ul > li p{
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .lg\\:prose-lg > ul > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .lg\\:prose-lg > ul > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .lg\\:prose-lg > ol > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .lg\\:prose-lg > ol > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .lg\\:prose-lg ul ul, .lg\\:prose-lg ul ol, .lg\\:prose-lg ol ul, .lg\\:prose-lg ol ol{
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .lg\\:prose-lg hr{
    margin-top: 3.1111111em;
    margin-bottom: 3.1111111em;
  }

  .lg\\:prose-lg hr + *{
    margin-top: 0;
  }

  .lg\\:prose-lg h2 + *{
    margin-top: 0;
  }

  .lg\\:prose-lg h3 + *{
    margin-top: 0;
  }

  .lg\\:prose-lg h4 + *{
    margin-top: 0;
  }

  .lg\\:prose-lg table{
    font-size: 0.8888889em;
    line-height: 1.5;
  }

  .lg\\:prose-lg thead th{
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }

  .lg\\:prose-lg thead th:first-child{
    padding-left: 0;
  }

  .lg\\:prose-lg thead th:last-child{
    padding-right: 0;
  }

  .lg\\:prose-lg tbody td{
    padding-top: 0.75em;
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }

  .lg\\:prose-lg tbody td:first-child{
    padding-left: 0;
  }

  .lg\\:prose-lg tbody td:last-child{
    padding-right: 0;
  }

  .lg\\:prose-lg > :first-child{
    margin-top: 0;
  }

  .lg\\:prose-lg > :last-child{
    margin-bottom: 0;
  }

  .lg\\:prose-xl{
    font-size: 1.25rem;
    line-height: 1.8;
  }

  .lg\\:prose-xl p{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .lg\\:prose-xl [class~="lead"]{
    font-size: 1.2em;
    line-height: 1.5;
    margin-top: 1em;
    margin-bottom: 1em;
  }

  .lg\\:prose-xl blockquote{
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1.0666667em;
  }

  .lg\\:prose-xl h1{
    font-size: 2.8em;
    margin-top: 0;
    margin-bottom: 0.8571429em;
    line-height: 1;
  }

  .lg\\:prose-xl h2{
    font-size: 1.8em;
    margin-top: 1.5555556em;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }

  .lg\\:prose-xl h3{
    font-size: 1.5em;
    margin-top: 1.6em;
    margin-bottom: 0.6666667em;
    line-height: 1.3333333;
  }

  .lg\\:prose-xl h4{
    margin-top: 1.8em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }

  .lg\\:prose-xl img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .lg\\:prose-xl video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .lg\\:prose-xl figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .lg\\:prose-xl figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .lg\\:prose-xl figure figcaption{
    font-size: 0.9em;
    line-height: 1.5555556;
    margin-top: 1em;
  }

  .lg\\:prose-xl code{
    font-size: 0.9em;
  }

  .lg\\:prose-xl h2 code{
    font-size: 0.8611111em;
  }

  .lg\\:prose-xl h3 code{
    font-size: 0.9em;
  }

  .lg\\:prose-xl pre{
    font-size: 0.9em;
    line-height: 1.7777778;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.1111111em;
    padding-right: 1.3333333em;
    padding-bottom: 1.1111111em;
    padding-left: 1.3333333em;
  }

  .lg\\:prose-xl ol{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .lg\\:prose-xl ul{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .lg\\:prose-xl li{
    margin-top: 0.6em;
    margin-bottom: 0.6em;
  }

  .lg\\:prose-xl ol > li{
    padding-left: 1.8em;
  }

  .lg\\:prose-xl ol > li:before{
    left: 0;
  }

  .lg\\:prose-xl ul > li{
    padding-left: 1.8em;
  }

  .lg\\:prose-xl ul > li::before{
    width: 0.35em;
    height: 0.35em;
    top: calc(0.9em - 0.175em);
    left: 0.25em;
  }

  .lg\\:prose-xl > ul > li p{
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }

  .lg\\:prose-xl > ul > li > *:first-child{
    margin-top: 1.2em;
  }

  .lg\\:prose-xl > ul > li > *:last-child{
    margin-bottom: 1.2em;
  }

  .lg\\:prose-xl > ol > li > *:first-child{
    margin-top: 1.2em;
  }

  .lg\\:prose-xl > ol > li > *:last-child{
    margin-bottom: 1.2em;
  }

  .lg\\:prose-xl ul ul, .lg\\:prose-xl ul ol, .lg\\:prose-xl ol ul, .lg\\:prose-xl ol ol{
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }

  .lg\\:prose-xl hr{
    margin-top: 2.8em;
    margin-bottom: 2.8em;
  }

  .lg\\:prose-xl hr + *{
    margin-top: 0;
  }

  .lg\\:prose-xl h2 + *{
    margin-top: 0;
  }

  .lg\\:prose-xl h3 + *{
    margin-top: 0;
  }

  .lg\\:prose-xl h4 + *{
    margin-top: 0;
  }

  .lg\\:prose-xl table{
    font-size: 0.9em;
    line-height: 1.5555556;
  }

  .lg\\:prose-xl thead th{
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }

  .lg\\:prose-xl thead th:first-child{
    padding-left: 0;
  }

  .lg\\:prose-xl thead th:last-child{
    padding-right: 0;
  }

  .lg\\:prose-xl tbody td{
    padding-top: 0.8888889em;
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }

  .lg\\:prose-xl tbody td:first-child{
    padding-left: 0;
  }

  .lg\\:prose-xl tbody td:last-child{
    padding-right: 0;
  }

  .lg\\:prose-xl > :first-child{
    margin-top: 0;
  }

  .lg\\:prose-xl > :last-child{
    margin-bottom: 0;
  }

  .lg\\:prose-2xl{
    font-size: 1.5rem;
    line-height: 1.6666667;
  }

  .lg\\:prose-2xl p{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .lg\\:prose-2xl [class~="lead"]{
    font-size: 1.25em;
    line-height: 1.4666667;
    margin-top: 1.0666667em;
    margin-bottom: 1.0666667em;
  }

  .lg\\:prose-2xl blockquote{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
    padding-left: 1.1111111em;
  }

  .lg\\:prose-2xl h1{
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.875em;
    line-height: 1;
  }

  .lg\\:prose-2xl h2{
    font-size: 2em;
    margin-top: 1.5em;
    margin-bottom: 0.8333333em;
    line-height: 1.0833333;
  }

  .lg\\:prose-2xl h3{
    font-size: 1.5em;
    margin-top: 1.5555556em;
    margin-bottom: 0.6666667em;
    line-height: 1.2222222;
  }

  .lg\\:prose-2xl h4{
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }

  .lg\\:prose-2xl img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .lg\\:prose-2xl video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .lg\\:prose-2xl figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .lg\\:prose-2xl figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .lg\\:prose-2xl figure figcaption{
    font-size: 0.8333333em;
    line-height: 1.6;
    margin-top: 1em;
  }

  .lg\\:prose-2xl code{
    font-size: 0.8333333em;
  }

  .lg\\:prose-2xl h2 code{
    font-size: 0.875em;
  }

  .lg\\:prose-2xl h3 code{
    font-size: 0.8888889em;
  }

  .lg\\:prose-2xl pre{
    font-size: 0.8333333em;
    line-height: 1.8;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.2em;
    padding-right: 1.6em;
    padding-bottom: 1.2em;
    padding-left: 1.6em;
  }

  .lg\\:prose-2xl ol{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .lg\\:prose-2xl ul{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .lg\\:prose-2xl li{
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .lg\\:prose-2xl ol > li{
    padding-left: 1.6666667em;
  }

  .lg\\:prose-2xl ol > li:before{
    left: 0;
  }

  .lg\\:prose-2xl ul > li{
    padding-left: 1.6666667em;
  }

  .lg\\:prose-2xl ul > li::before{
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8333333em - 0.1666667em);
    left: 0.25em;
  }

  .lg\\:prose-2xl > ul > li p{
    margin-top: 0.8333333em;
    margin-bottom: 0.8333333em;
  }

  .lg\\:prose-2xl > ul > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .lg\\:prose-2xl > ul > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .lg\\:prose-2xl > ol > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .lg\\:prose-2xl > ol > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .lg\\:prose-2xl ul ul, .lg\\:prose-2xl ul ol, .lg\\:prose-2xl ol ul, .lg\\:prose-2xl ol ol{
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }

  .lg\\:prose-2xl hr{
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .lg\\:prose-2xl hr + *{
    margin-top: 0;
  }

  .lg\\:prose-2xl h2 + *{
    margin-top: 0;
  }

  .lg\\:prose-2xl h3 + *{
    margin-top: 0;
  }

  .lg\\:prose-2xl h4 + *{
    margin-top: 0;
  }

  .lg\\:prose-2xl table{
    font-size: 0.8333333em;
    line-height: 1.4;
  }

  .lg\\:prose-2xl thead th{
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }

  .lg\\:prose-2xl thead th:first-child{
    padding-left: 0;
  }

  .lg\\:prose-2xl thead th:last-child{
    padding-right: 0;
  }

  .lg\\:prose-2xl tbody td{
    padding-top: 0.8em;
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }

  .lg\\:prose-2xl tbody td:first-child{
    padding-left: 0;
  }

  .lg\\:prose-2xl tbody td:last-child{
    padding-right: 0;
  }

  .lg\\:prose-2xl > :first-child{
    margin-top: 0;
  }

  .lg\\:prose-2xl > :last-child{
    margin-bottom: 0;
  }

  .lg\\:space-y-0 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0px * (1 - var(--space-y-reverse)));
    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0px * var(--space-y-reverse));
  }

  .lg\\:space-x-0 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0px * var(--space-x-reverse));
    margin-left: calc(0px * (1 - var(--space-x-reverse)));
    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--space-y-reverse));
  }

  .lg\\:space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--space-x-reverse));
    margin-left: calc(0.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--space-x-reverse));
    margin-left: calc(0.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--space-y-reverse));
  }

  .lg\\:space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--space-x-reverse));
    margin-left: calc(0.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1rem * var(--space-y-reverse));
  }

  .lg\\:space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1rem * var(--space-x-reverse));
    margin-left: calc(1rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--space-y-reverse));
  }

  .lg\\:space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--space-x-reverse));
    margin-left: calc(1.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--space-x-reverse));
    margin-left: calc(1.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-7 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.75rem * var(--space-y-reverse));
  }

  .lg\\:space-x-7 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.75rem * var(--space-x-reverse));
    margin-left: calc(1.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2rem * var(--space-y-reverse));
  }

  .lg\\:space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2rem * var(--space-x-reverse));
    margin-left: calc(2rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-9 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.25rem * var(--space-y-reverse));
  }

  .lg\\:space-x-9 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.25rem * var(--space-x-reverse));
    margin-left: calc(2.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.5rem * var(--space-x-reverse));
    margin-left: calc(2.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-11 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.75rem * var(--space-y-reverse));
  }

  .lg\\:space-x-11 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.75rem * var(--space-x-reverse));
    margin-left: calc(2.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3rem * var(--space-y-reverse));
  }

  .lg\\:space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3rem * var(--space-x-reverse));
    margin-left: calc(3rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-14 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-14 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3.5rem * var(--space-x-reverse));
    margin-left: calc(3.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-15 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.75rem * var(--space-y-reverse));
  }

  .lg\\:space-x-15 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3.75rem * var(--space-x-reverse));
    margin-left: calc(3.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(4rem * (1 - var(--space-y-reverse)));
    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(4rem * var(--space-y-reverse));
  }

  .lg\\:space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(4rem * var(--space-x-reverse));
    margin-left: calc(4rem * (1 - var(--space-x-reverse)));
    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-18 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(4.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(4.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(4.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-18 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(4.5rem * var(--space-x-reverse));
    margin-left: calc(4.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(4.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5rem * var(--space-x-reverse));
    margin-left: calc(5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-22 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-22 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5.5rem * var(--space-x-reverse));
    margin-left: calc(5.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-23 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5.75rem * var(--space-y-reverse));
  }

  .lg\\:space-x-23 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5.75rem * var(--space-x-reverse));
    margin-left: calc(5.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5.75rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6rem * var(--space-y-reverse));
  }

  .lg\\:space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6rem * var(--space-x-reverse));
    margin-left: calc(6rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-25 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6.25rem * var(--space-y-reverse));
  }

  .lg\\:space-x-25 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6.25rem * var(--space-x-reverse));
    margin-left: calc(6.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6.25rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-26 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-26 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6.5rem * var(--space-x-reverse));
    margin-left: calc(6.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-28 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(7rem * (1 - var(--space-y-reverse)));
    margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(7rem * var(--space-y-reverse));
  }

  .lg\\:space-x-28 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(7rem * var(--space-x-reverse));
    margin-left: calc(7rem * (1 - var(--space-x-reverse)));
    margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-30 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(7.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(7.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(7.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-30 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(7.5rem * var(--space-x-reverse));
    margin-left: calc(7.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(7.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(8rem * (1 - var(--space-y-reverse)));
    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8rem * var(--space-y-reverse));
  }

  .lg\\:space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(8rem * var(--space-x-reverse));
    margin-left: calc(8rem * (1 - var(--space-x-reverse)));
    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-34 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(8.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(8.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-34 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(8.5rem * var(--space-x-reverse));
    margin-left: calc(8.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(8.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(10rem * (1 - var(--space-y-reverse)));
    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(10rem * var(--space-y-reverse));
  }

  .lg\\:space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(10rem * var(--space-x-reverse));
    margin-left: calc(10rem * (1 - var(--space-x-reverse)));
    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-42 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(10.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(10.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(10.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-42 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(10.5rem * var(--space-x-reverse));
    margin-left: calc(10.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(10.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-44 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(11rem * (1 - var(--space-y-reverse)));
    margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(11rem * var(--space-y-reverse));
  }

  .lg\\:space-x-44 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(11rem * var(--space-x-reverse));
    margin-left: calc(11rem * (1 - var(--space-x-reverse)));
    margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(12rem * (1 - var(--space-y-reverse)));
    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(12rem * var(--space-y-reverse));
  }

  .lg\\:space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(12rem * var(--space-x-reverse));
    margin-left: calc(12rem * (1 - var(--space-x-reverse)));
    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-52 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(13rem * (1 - var(--space-y-reverse)));
    margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(13rem * var(--space-y-reverse));
  }

  .lg\\:space-x-52 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(13rem * var(--space-x-reverse));
    margin-left: calc(13rem * (1 - var(--space-x-reverse)));
    margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-54 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(13.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(13.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(13.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-54 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(13.5rem * var(--space-x-reverse));
    margin-left: calc(13.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(13.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(14rem * (1 - var(--space-y-reverse)));
    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(14rem * var(--space-y-reverse));
  }

  .lg\\:space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(14rem * var(--space-x-reverse));
    margin-left: calc(14rem * (1 - var(--space-x-reverse)));
    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-60 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(15rem * (1 - var(--space-y-reverse)));
    margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(15rem * var(--space-y-reverse));
  }

  .lg\\:space-x-60 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(15rem * var(--space-x-reverse));
    margin-left: calc(15rem * (1 - var(--space-x-reverse)));
    margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(16rem * (1 - var(--space-y-reverse)));
    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16rem * var(--space-y-reverse));
  }

  .lg\\:space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(16rem * var(--space-x-reverse));
    margin-left: calc(16rem * (1 - var(--space-x-reverse)));
    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-68 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(17rem * (1 - var(--space-y-reverse)));
    margin-top: calc(17rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(17rem * var(--space-y-reverse));
  }

  .lg\\:space-x-68 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(17rem * var(--space-x-reverse));
    margin-left: calc(17rem * (1 - var(--space-x-reverse)));
    margin-left: calc(17rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-72 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(18rem * (1 - var(--space-y-reverse)));
    margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(18rem * var(--space-y-reverse));
  }

  .lg\\:space-x-72 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(18rem * var(--space-x-reverse));
    margin-left: calc(18rem * (1 - var(--space-x-reverse)));
    margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-74 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(18.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(18.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(18.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-74 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(18.5rem * var(--space-x-reverse));
    margin-left: calc(18.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(18.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-76 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(19rem * (1 - var(--space-y-reverse)));
    margin-top: calc(19rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(19rem * var(--space-y-reverse));
  }

  .lg\\:space-x-76 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(19rem * var(--space-x-reverse));
    margin-left: calc(19rem * (1 - var(--space-x-reverse)));
    margin-left: calc(19rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-78 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(19.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(19.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(19.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-78 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(19.5rem * var(--space-x-reverse));
    margin-left: calc(19.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(19.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-80 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(20rem * (1 - var(--space-y-reverse)));
    margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20rem * var(--space-y-reverse));
  }

  .lg\\:space-x-80 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(20rem * var(--space-x-reverse));
    margin-left: calc(20rem * (1 - var(--space-x-reverse)));
    margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-82 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(20.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(20.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-82 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(20.5rem * var(--space-x-reverse));
    margin-left: calc(20.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(20.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-84 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(21rem * (1 - var(--space-y-reverse)));
    margin-top: calc(21rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(21rem * var(--space-y-reverse));
  }

  .lg\\:space-x-84 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(21rem * var(--space-x-reverse));
    margin-left: calc(21rem * (1 - var(--space-x-reverse)));
    margin-left: calc(21rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-88 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(22rem * (1 - var(--space-y-reverse)));
    margin-top: calc(22rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(22rem * var(--space-y-reverse));
  }

  .lg\\:space-x-88 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(22rem * var(--space-x-reverse));
    margin-left: calc(22rem * (1 - var(--space-x-reverse)));
    margin-left: calc(22rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-92 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(23rem * (1 - var(--space-y-reverse)));
    margin-top: calc(23rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(23rem * var(--space-y-reverse));
  }

  .lg\\:space-x-92 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(23rem * var(--space-x-reverse));
    margin-left: calc(23rem * (1 - var(--space-x-reverse)));
    margin-left: calc(23rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-96 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(24rem * (1 - var(--space-y-reverse)));
    margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(24rem * var(--space-y-reverse));
  }

  .lg\\:space-x-96 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(24rem * var(--space-x-reverse));
    margin-left: calc(24rem * (1 - var(--space-x-reverse)));
    margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-98 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(24.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(24.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(24.5rem * var(--space-y-reverse));
  }

  .lg\\:space-x-98 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(24.5rem * var(--space-x-reverse));
    margin-left: calc(24.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(24.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-100 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(25rem * var(--space-y-reverse));
  }

  .lg\\:space-x-100 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(25rem * var(--space-x-reverse));
    margin-left: calc(25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(25rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-104 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(26rem * (1 - var(--space-y-reverse)));
    margin-top: calc(26rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(26rem * var(--space-y-reverse));
  }

  .lg\\:space-x-104 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(26rem * var(--space-x-reverse));
    margin-left: calc(26rem * (1 - var(--space-x-reverse)));
    margin-left: calc(26rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-112 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(28rem * (1 - var(--space-y-reverse)));
    margin-top: calc(28rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(28rem * var(--space-y-reverse));
  }

  .lg\\:space-x-112 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(28rem * var(--space-x-reverse));
    margin-left: calc(28rem * (1 - var(--space-x-reverse)));
    margin-left: calc(28rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-124 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(31rem * (1 - var(--space-y-reverse)));
    margin-top: calc(31rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(31rem * var(--space-y-reverse));
  }

  .lg\\:space-x-124 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(31rem * var(--space-x-reverse));
    margin-left: calc(31rem * (1 - var(--space-x-reverse)));
    margin-left: calc(31rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-128 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(32rem * (1 - var(--space-y-reverse)));
    margin-top: calc(32rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(32rem * var(--space-y-reverse));
  }

  .lg\\:space-x-128 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(32rem * var(--space-x-reverse));
    margin-left: calc(32rem * (1 - var(--space-x-reverse)));
    margin-left: calc(32rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-140 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(35rem * (1 - var(--space-y-reverse)));
    margin-top: calc(35rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(35rem * var(--space-y-reverse));
  }

  .lg\\:space-x-140 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(35rem * var(--space-x-reverse));
    margin-left: calc(35rem * (1 - var(--space-x-reverse)));
    margin-left: calc(35rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-152 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(38rem * (1 - var(--space-y-reverse)));
    margin-top: calc(38rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(38rem * var(--space-y-reverse));
  }

  .lg\\:space-x-152 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(38rem * var(--space-x-reverse));
    margin-left: calc(38rem * (1 - var(--space-x-reverse)));
    margin-left: calc(38rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-160 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(40rem * (1 - var(--space-y-reverse)));
    margin-top: calc(40rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(40rem * var(--space-y-reverse));
  }

  .lg\\:space-x-160 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(40rem * var(--space-x-reverse));
    margin-left: calc(40rem * (1 - var(--space-x-reverse)));
    margin-left: calc(40rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-162 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(41rem * (1 - var(--space-y-reverse)));
    margin-top: calc(41rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(41rem * var(--space-y-reverse));
  }

  .lg\\:space-x-162 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(41rem * var(--space-x-reverse));
    margin-left: calc(41rem * (1 - var(--space-x-reverse)));
    margin-left: calc(41rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-192 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(48rem * (1 - var(--space-y-reverse)));
    margin-top: calc(48rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(48rem * var(--space-y-reverse));
  }

  .lg\\:space-x-192 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(48rem * var(--space-x-reverse));
    margin-left: calc(48rem * (1 - var(--space-x-reverse)));
    margin-left: calc(48rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-208 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(52rem * (1 - var(--space-y-reverse)));
    margin-top: calc(52rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(52rem * var(--space-y-reverse));
  }

  .lg\\:space-x-208 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(52rem * var(--space-x-reverse));
    margin-left: calc(52rem * (1 - var(--space-x-reverse)));
    margin-left: calc(52rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-224 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(56rem * (1 - var(--space-y-reverse)));
    margin-top: calc(56rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(56rem * var(--space-y-reverse));
  }

  .lg\\:space-x-224 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(56rem * var(--space-x-reverse));
    margin-left: calc(56rem * (1 - var(--space-x-reverse)));
    margin-left: calc(56rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-256 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(64rem * (1 - var(--space-y-reverse)));
    margin-top: calc(64rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(64rem * var(--space-y-reverse));
  }

  .lg\\:space-x-256 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(64rem * var(--space-x-reverse));
    margin-left: calc(64rem * (1 - var(--space-x-reverse)));
    margin-left: calc(64rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1px * (1 - var(--space-y-reverse)));
    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1px * var(--space-y-reverse));
  }

  .lg\\:space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1px * var(--space-x-reverse));
    margin-left: calc(1px * (1 - var(--space-x-reverse)));
    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.25rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.25rem * var(--space-x-reverse));
    margin-left: calc(-0.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.5rem * var(--space-x-reverse));
    margin-left: calc(-0.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.75rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.75rem * var(--space-x-reverse));
    margin-left: calc(-0.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1rem * var(--space-x-reverse));
    margin-left: calc(-1rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.25rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.25rem * var(--space-x-reverse));
    margin-left: calc(-1.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.5rem * var(--space-x-reverse));
    margin-left: calc(-1.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-7 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.75rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-7 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.75rem * var(--space-x-reverse));
    margin-left: calc(-1.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2rem * var(--space-x-reverse));
    margin-left: calc(-2rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-9 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.25rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-9 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.25rem * var(--space-x-reverse));
    margin-left: calc(-2.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.5rem * var(--space-x-reverse));
    margin-left: calc(-2.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-11 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.75rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-11 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.75rem * var(--space-x-reverse));
    margin-left: calc(-2.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3rem * var(--space-x-reverse));
    margin-left: calc(-3rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-14 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-14 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3.5rem * var(--space-x-reverse));
    margin-left: calc(-3.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-15 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.75rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-15 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3.75rem * var(--space-x-reverse));
    margin-left: calc(-3.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-4rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-4rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-4rem * var(--space-x-reverse));
    margin-left: calc(-4rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-18 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-4.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-4.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-4.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-18 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-4.5rem * var(--space-x-reverse));
    margin-left: calc(-4.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-4.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5rem * var(--space-x-reverse));
    margin-left: calc(-5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-22 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-22 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5.5rem * var(--space-x-reverse));
    margin-left: calc(-5.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-23 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5.75rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-23 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5.75rem * var(--space-x-reverse));
    margin-left: calc(-5.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5.75rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6rem * var(--space-x-reverse));
    margin-left: calc(-6rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-25 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6.25rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-25 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6.25rem * var(--space-x-reverse));
    margin-left: calc(-6.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6.25rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-26 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-26 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6.5rem * var(--space-x-reverse));
    margin-left: calc(-6.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-28 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-7rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-7rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-28 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-7rem * var(--space-x-reverse));
    margin-left: calc(-7rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-30 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-7.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-7.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-7.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-30 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-7.5rem * var(--space-x-reverse));
    margin-left: calc(-7.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-7.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-8rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-8rem * var(--space-x-reverse));
    margin-left: calc(-8rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-34 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-8.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-8.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-34 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-8.5rem * var(--space-x-reverse));
    margin-left: calc(-8.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-8.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-10rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-10rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-10rem * var(--space-x-reverse));
    margin-left: calc(-10rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-42 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-10.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-10.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-10.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-42 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-10.5rem * var(--space-x-reverse));
    margin-left: calc(-10.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-10.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-44 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-11rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-11rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-44 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-11rem * var(--space-x-reverse));
    margin-left: calc(-11rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-12rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-12rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-12rem * var(--space-x-reverse));
    margin-left: calc(-12rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-52 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-13rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-13rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-52 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-13rem * var(--space-x-reverse));
    margin-left: calc(-13rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-54 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-13.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-13.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-13.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-54 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-13.5rem * var(--space-x-reverse));
    margin-left: calc(-13.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-13.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-14rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-14rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-14rem * var(--space-x-reverse));
    margin-left: calc(-14rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-60 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-15rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-15rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-60 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-15rem * var(--space-x-reverse));
    margin-left: calc(-15rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-16rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-16rem * var(--space-x-reverse));
    margin-left: calc(-16rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-68 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-17rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-17rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-17rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-68 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-17rem * var(--space-x-reverse));
    margin-left: calc(-17rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-17rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-72 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-18rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-18rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-72 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-18rem * var(--space-x-reverse));
    margin-left: calc(-18rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-74 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-18.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-18.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-18.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-74 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-18.5rem * var(--space-x-reverse));
    margin-left: calc(-18.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-18.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-76 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-19rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-19rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-19rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-76 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-19rem * var(--space-x-reverse));
    margin-left: calc(-19rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-19rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-78 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-19.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-19.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-19.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-78 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-19.5rem * var(--space-x-reverse));
    margin-left: calc(-19.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-19.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-80 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-20rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-80 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-20rem * var(--space-x-reverse));
    margin-left: calc(-20rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-82 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-20.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-20.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-82 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-20.5rem * var(--space-x-reverse));
    margin-left: calc(-20.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-20.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-84 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-21rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-21rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-21rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-84 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-21rem * var(--space-x-reverse));
    margin-left: calc(-21rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-21rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-88 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-22rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-22rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-22rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-88 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-22rem * var(--space-x-reverse));
    margin-left: calc(-22rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-22rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-92 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-23rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-23rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-23rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-92 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-23rem * var(--space-x-reverse));
    margin-left: calc(-23rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-23rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-96 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-24rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-24rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-96 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-24rem * var(--space-x-reverse));
    margin-left: calc(-24rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-98 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-24.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-24.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-24.5rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-98 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-24.5rem * var(--space-x-reverse));
    margin-left: calc(-24.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-24.5rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-100 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-25rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-100 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-25rem * var(--space-x-reverse));
    margin-left: calc(-25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-25rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-104 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-26rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-26rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-26rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-104 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-26rem * var(--space-x-reverse));
    margin-left: calc(-26rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-26rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-112 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-28rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-28rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-28rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-112 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-28rem * var(--space-x-reverse));
    margin-left: calc(-28rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-28rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-124 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-31rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-31rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-31rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-124 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-31rem * var(--space-x-reverse));
    margin-left: calc(-31rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-31rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-128 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-32rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-32rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-32rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-128 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-32rem * var(--space-x-reverse));
    margin-left: calc(-32rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-32rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-140 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-35rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-35rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-35rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-140 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-35rem * var(--space-x-reverse));
    margin-left: calc(-35rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-35rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-152 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-38rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-38rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-38rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-152 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-38rem * var(--space-x-reverse));
    margin-left: calc(-38rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-38rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-160 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-40rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-40rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-40rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-160 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-40rem * var(--space-x-reverse));
    margin-left: calc(-40rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-40rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-162 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-41rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-41rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-41rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-162 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-41rem * var(--space-x-reverse));
    margin-left: calc(-41rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-41rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-192 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-48rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-48rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-48rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-192 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-48rem * var(--space-x-reverse));
    margin-left: calc(-48rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-48rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-208 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-52rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-52rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-52rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-208 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-52rem * var(--space-x-reverse));
    margin-left: calc(-52rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-52rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-224 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-56rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-56rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-56rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-224 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-56rem * var(--space-x-reverse));
    margin-left: calc(-56rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-56rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-256 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-64rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-64rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-64rem * var(--space-y-reverse));
  }

  .lg\\:-space-x-256 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-64rem * var(--space-x-reverse));
    margin-left: calc(-64rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-64rem * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:-space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1px * (1 - var(--space-y-reverse)));
    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1px * var(--space-y-reverse));
  }

  .lg\\:-space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1px * var(--space-x-reverse));
    margin-left: calc(-1px * (1 - var(--space-x-reverse)));
    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));
  }

  .lg\\:space-y-reverse > :not(template) ~ :not(template){
    --space-y-reverse: 1;
  }

  .lg\\:space-x-reverse > :not(template) ~ :not(template){
    --space-x-reverse: 1;
  }

  .lg\\:divide-y-0 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(0px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(0px * var(--divide-y-reverse));
  }

  .lg\\:divide-x-0 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(0px * var(--divide-x-reverse));
    border-left-width: calc(0px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));
  }

  .lg\\:divide-y-2 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(2px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(2px * var(--divide-y-reverse));
  }

  .lg\\:divide-x-2 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(2px * var(--divide-x-reverse));
    border-left-width: calc(2px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));
  }

  .lg\\:divide-y-3 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(3px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(3px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(3px * var(--divide-y-reverse));
  }

  .lg\\:divide-x-3 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(3px * var(--divide-x-reverse));
    border-left-width: calc(3px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(3px * calc(1 - var(--divide-x-reverse)));
  }

  .lg\\:divide-y-4 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(4px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(4px * var(--divide-y-reverse));
  }

  .lg\\:divide-x-4 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(4px * var(--divide-x-reverse));
    border-left-width: calc(4px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));
  }

  .lg\\:divide-y-5 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(5px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(5px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(5px * var(--divide-y-reverse));
  }

  .lg\\:divide-x-5 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(5px * var(--divide-x-reverse));
    border-left-width: calc(5px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(5px * calc(1 - var(--divide-x-reverse)));
  }

  .lg\\:divide-y-6 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(6px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(6px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(6px * var(--divide-y-reverse));
  }

  .lg\\:divide-x-6 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(6px * var(--divide-x-reverse));
    border-left-width: calc(6px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(6px * calc(1 - var(--divide-x-reverse)));
  }

  .lg\\:divide-y-8 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(8px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(8px * var(--divide-y-reverse));
  }

  .lg\\:divide-x-8 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(8px * var(--divide-x-reverse));
    border-left-width: calc(8px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));
  }

  .lg\\:divide-y > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(1px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(1px * var(--divide-y-reverse));
  }

  .lg\\:divide-x > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(1px * var(--divide-x-reverse));
    border-left-width: calc(1px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));
  }

  .lg\\:divide-y-reverse > :not(template) ~ :not(template){
    --divide-y-reverse: 1;
  }

  .lg\\:divide-x-reverse > :not(template) ~ :not(template){
    --divide-x-reverse: 1;
  }

  .lg\\:divide-transparent > :not(template) ~ :not(template){
    border-color: transparent;
  }

  .lg\\:divide-focus > :not(template) ~ :not(template){
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .lg\\:divide-black > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--divide-opacity));
  }

  .lg\\:divide-white > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--divide-opacity));
  }

  .lg\\:divide-primary > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--divide-opacity));
  }

  .lg\\:divide-disabled > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--divide-opacity));
  }

  .lg\\:divide-translucent-60 > :not(template) ~ :not(template){
    border-color: rgba(256, 256, 256, 0.6);
  }

  .lg\\:divide-translucent-90 > :not(template) ~ :not(template){
    border-color: rgba(256, 256, 256, 0.9);
  }

  .lg\\:divide-green-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--divide-opacity));
  }

  .lg\\:divide-green-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--divide-opacity));
  }

  .lg\\:divide-green-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--divide-opacity));
  }

  .lg\\:divide-green-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--divide-opacity));
  }

  .lg\\:divide-green-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--divide-opacity));
  }

  .lg\\:divide-green-400a50 > :not(template) ~ :not(template){
    border-color: rgba(108,202,152,0.50196);
  }

  .lg\\:divide-green-500a25 > :not(template) ~ :not(template){
    border-color: rgba(151,232,18,0.09804);
  }

  .lg\\:divide-yellow-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--divide-opacity));
  }

  .lg\\:divide-yellow-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--divide-opacity));
  }

  .lg\\:divide-yellow-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--divide-opacity));
  }

  .lg\\:divide-yellow-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--divide-opacity));
  }

  .lg\\:divide-yellow-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--divide-opacity));
  }

  .lg\\:divide-yellow-300a66 > :not(template) ~ :not(template){
    border-color: rgba(255,233,189,0.66667);
  }

  .lg\\:divide-yellow-500a25 > :not(template) ~ :not(template){
    border-color: rgba(255,200,44,0.09804);
  }

  .lg\\:divide-orange-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--divide-opacity));
  }

  .lg\\:divide-orange-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--divide-opacity));
  }

  .lg\\:divide-orange-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--divide-opacity));
  }

  .lg\\:divide-orange-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--divide-opacity));
  }

  .lg\\:divide-orange-900 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--divide-opacity));
  }

  .lg\\:divide-orange-500a25 > :not(template) ~ :not(template){
    border-color: rgba(240,115,23,0.09804);
  }

  .lg\\:divide-red-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--divide-opacity));
  }

  .lg\\:divide-red-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--divide-opacity));
  }

  .lg\\:divide-red-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--divide-opacity));
  }

  .lg\\:divide-red-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--divide-opacity));
  }

  .lg\\:divide-red-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--divide-opacity));
  }

  .lg\\:divide-red-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--divide-opacity));
  }

  .lg\\:divide-red-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--divide-opacity));
  }

  .lg\\:divide-gray-50 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--divide-opacity));
  }

  .lg\\:divide-gray-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--divide-opacity));
  }

  .lg\\:divide-gray-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--divide-opacity));
  }

  .lg\\:divide-gray-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--divide-opacity));
  }

  .lg\\:divide-gray-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--divide-opacity));
  }

  .lg\\:divide-gray-400 > :not(template) ~ :not(template){
    border-color: rgba(114,114,114,0.8);
  }

  .lg\\:divide-gray-425 > :not(template) ~ :not(template){
    border-color: rgba(4, 21, 39, 0.8);
  }

  .lg\\:divide-gray-450 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--divide-opacity));
  }

  .lg\\:divide-gray-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--divide-opacity));
  }

  .lg\\:divide-gray-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--divide-opacity));
  }

  .lg\\:divide-gray-625 > :not(template) ~ :not(template){
    border-color: rgba(90,98,107,0.8);
  }

  .lg\\:divide-gray-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--divide-opacity));
  }

  .lg\\:divide-gray-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--divide-opacity));
  }

  .lg\\:divide-gray-200a50 > :not(template) ~ :not(template){
    border-color: rgba(224, 226, 228, 0.5);
  }

  .lg\\:divide-blue-50 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--divide-opacity));
  }

  .lg\\:divide-blue-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--divide-opacity));
  }

  .lg\\:divide-blue-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--divide-opacity));
  }

  .lg\\:divide-blue-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--divide-opacity));
  }

  .lg\\:divide-blue-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--divide-opacity));
  }

  .lg\\:divide-blue-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--divide-opacity));
  }

  .lg\\:divide-blue-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--divide-opacity));
  }

  .lg\\:divide-blue-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--divide-opacity));
  }

  .lg\\:divide-blue-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--divide-opacity));
  }

  .lg\\:divide-blue-750 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--divide-opacity));
  }

  .lg\\:divide-blue-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--divide-opacity));
  }

  .lg\\:divide-blue-900 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--divide-opacity));
  }

  .lg\\:divide-blue-950 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--divide-opacity));
  }

  .lg\\:divide-blue-500a25 > :not(template) ~ :not(template){
    border-color: rgba(55, 164, 220, 0.2);
  }

  .lg\\:divide-blue-500a50 > :not(template) ~ :not(template){
    border-color: rgba(55, 164, 220, 0.5);
  }

  .lg\\:divide-blue-700a75 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--divide-opacity));
  }

  .lg\\:divide-blue-700a30 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--divide-opacity));
  }

  .lg\\:divide-blue-750a25 > :not(template) ~ :not(template){
    border-color: rgba(86,130,170,0.09804);
  }

  .lg\\:divide-blue-750a15 > :not(template) ~ :not(template){
    border-color: rgba(86,130,170,0.05882);
  }

  .lg\\:divide-blue-800a60 > :not(template) ~ :not(template){
    border-color: rgba(31, 69, 102, 0.6);
  }

  .lg\\:divide-programEditorTabColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--divide-opacity));
  }

  .lg\\:divide-programEditorTabColors-2 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--divide-opacity));
  }

  .lg\\:divide-programEditorTabColors-3 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--divide-opacity));
  }

  .lg\\:divide-programEditorTabColors-4 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--divide-opacity));
  }

  .lg\\:divide-programEditorTabColors-5 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--divide-opacity));
  }

  .lg\\:divide-programEditorTabColors-6 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--divide-opacity));
  }

  .lg\\:divide-programEditorTabColors-1h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--divide-opacity));
  }

  .lg\\:divide-programEditorTabColors-2h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--divide-opacity));
  }

  .lg\\:divide-programEditorTabColors-3h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--divide-opacity));
  }

  .lg\\:divide-programEditorTabColors-4h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--divide-opacity));
  }

  .lg\\:divide-programEditorTabColors-5h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--divide-opacity));
  }

  .lg\\:divide-programEditorTabColors-6h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--divide-opacity));
  }

  .lg\\:divide-programEditorPresetTabColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--divide-opacity));
  }

  .lg\\:divide-programEditorPresetTabColors-1h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--divide-opacity));
  }

  .lg\\:divide-borgScaleColors-0 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--divide-opacity));
  }

  .lg\\:divide-borgScaleColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--divide-opacity));
  }

  .lg\\:divide-borgScaleColors-2 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--divide-opacity));
  }

  .lg\\:divide-borgScaleColors-3 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--divide-opacity));
  }

  .lg\\:divide-borgScaleColors-4 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--divide-opacity));
  }

  .lg\\:divide-borgScaleColors-5 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--divide-opacity));
  }

  .lg\\:divide-borgScaleColors-6 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--divide-opacity));
  }

  .lg\\:divide-borgScaleColors-7 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--divide-opacity));
  }

  .lg\\:divide-borgScaleColors-8 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--divide-opacity));
  }

  .lg\\:divide-borgScaleColors-9 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--divide-opacity));
  }

  .lg\\:divide-borgScaleColors-10 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--divide-opacity));
  }

  .lg\\:divide-solid > :not(template) ~ :not(template){
    border-style: solid;
  }

  .lg\\:divide-dashed > :not(template) ~ :not(template){
    border-style: dashed;
  }

  .lg\\:divide-dotted > :not(template) ~ :not(template){
    border-style: dotted;
  }

  .lg\\:divide-double > :not(template) ~ :not(template){
    border-style: double;
  }

  .lg\\:divide-none > :not(template) ~ :not(template){
    border-style: none;
  }

  .lg\\:divide-opacity-0 > :not(template) ~ :not(template){
    --divide-opacity: 0;
  }

  .lg\\:divide-opacity-25 > :not(template) ~ :not(template){
    --divide-opacity: .25;
  }

  .lg\\:divide-opacity-50 > :not(template) ~ :not(template){
    --divide-opacity: .5;
  }

  .lg\\:divide-opacity-75 > :not(template) ~ :not(template){
    --divide-opacity: .75;
  }

  .lg\\:divide-opacity-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
  }

  .lg\\:sr-only{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .lg\\:not-sr-only{
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .lg\\:focus\\:sr-only:focus{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .lg\\:focus\\:not-sr-only:focus{
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .lg\\:appearance-none{
    -webkit-appearance: none;
            appearance: none;
  }

  .lg\\:bg-fixed{
    background-attachment: fixed;
  }

  .lg\\:bg-local{
    background-attachment: local;
  }

  .lg\\:bg-scroll{
    background-attachment: scroll;
  }

  .lg\\:bg-clip-border{
    background-clip: border-box;
  }

  .lg\\:bg-clip-padding{
    background-clip: padding-box;
  }

  .lg\\:bg-clip-content{
    background-clip: content-box;
  }

  .lg\\:bg-clip-text{
    -webkit-background-clip: text;
            background-clip: text;
  }

  .lg\\:bg-transparent{
    background-color: transparent;
  }

  .lg\\:bg-focus{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .lg\\:bg-black{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .lg\\:bg-white{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .lg\\:bg-primary{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .lg\\:bg-disabled{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .lg\\:bg-translucent-60{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .lg\\:bg-translucent-90{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .lg\\:bg-green-200{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .lg\\:bg-green-400{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .lg\\:bg-green-500{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .lg\\:bg-green-600{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .lg\\:bg-green-700{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .lg\\:bg-green-400a50{
    background-color: rgba(108,202,152,0.50196);
  }

  .lg\\:bg-green-500a25{
    background-color: rgba(151,232,18,0.09804);
  }

  .lg\\:bg-yellow-200{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .lg\\:bg-yellow-300{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .lg\\:bg-yellow-500{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .lg\\:bg-yellow-600{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .lg\\:bg-yellow-700{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .lg\\:bg-yellow-300a66{
    background-color: rgba(255,233,189,0.66667);
  }

  .lg\\:bg-yellow-500a25{
    background-color: rgba(255,200,44,0.09804);
  }

  .lg\\:bg-orange-200{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .lg\\:bg-orange-400{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .lg\\:bg-orange-500{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .lg\\:bg-orange-800{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .lg\\:bg-orange-900{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .lg\\:bg-orange-500a25{
    background-color: rgba(240,115,23,0.09804);
  }

  .lg\\:bg-red-100{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .lg\\:bg-red-150{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .lg\\:bg-red-200{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .lg\\:bg-red-300{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .lg\\:bg-red-400{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .lg\\:bg-red-500{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .lg\\:bg-red-700{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .lg\\:bg-gray-50{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .lg\\:bg-gray-100{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .lg\\:bg-gray-150{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .lg\\:bg-gray-200{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .lg\\:bg-gray-300{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .lg\\:bg-gray-400{
    background-color: rgba(114,114,114,0.8);
  }

  .lg\\:bg-gray-425{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .lg\\:bg-gray-450{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .lg\\:bg-gray-500{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .lg\\:bg-gray-600{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .lg\\:bg-gray-625{
    background-color: rgba(90,98,107,0.8);
  }

  .lg\\:bg-gray-700{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .lg\\:bg-gray-800{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .lg\\:bg-gray-200a50{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .lg\\:bg-blue-50{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .lg\\:bg-blue-100{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .lg\\:bg-blue-150{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .lg\\:bg-blue-200{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .lg\\:bg-blue-300{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .lg\\:bg-blue-400{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .lg\\:bg-blue-500{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .lg\\:bg-blue-600{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .lg\\:bg-blue-700{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .lg\\:bg-blue-750{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .lg\\:bg-blue-800{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .lg\\:bg-blue-900{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .lg\\:bg-blue-950{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .lg\\:bg-blue-500a25{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .lg\\:bg-blue-500a50{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .lg\\:bg-blue-700a75{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .lg\\:bg-blue-700a30{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .lg\\:bg-blue-750a25{
    background-color: rgba(86,130,170,0.09804);
  }

  .lg\\:bg-blue-750a15{
    background-color: rgba(86,130,170,0.05882);
  }

  .lg\\:bg-blue-800a60{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .lg\\:bg-programEditorTabColors-1{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .lg\\:bg-programEditorTabColors-2{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .lg\\:bg-programEditorTabColors-3{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .lg\\:bg-programEditorTabColors-4{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .lg\\:bg-programEditorTabColors-5{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .lg\\:bg-programEditorTabColors-6{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .lg\\:bg-programEditorTabColors-1h{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .lg\\:bg-programEditorTabColors-2h{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .lg\\:bg-programEditorTabColors-3h{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .lg\\:bg-programEditorTabColors-4h{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .lg\\:bg-programEditorTabColors-5h{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .lg\\:bg-programEditorTabColors-6h{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .lg\\:bg-programEditorPresetTabColors-1{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .lg\\:bg-programEditorPresetTabColors-1h{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .lg\\:bg-borgScaleColors-0{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .lg\\:bg-borgScaleColors-1{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .lg\\:bg-borgScaleColors-2{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .lg\\:bg-borgScaleColors-3{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .lg\\:bg-borgScaleColors-4{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .lg\\:bg-borgScaleColors-5{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .lg\\:bg-borgScaleColors-6{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .lg\\:bg-borgScaleColors-7{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .lg\\:bg-borgScaleColors-8{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .lg\\:bg-borgScaleColors-9{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .lg\\:bg-borgScaleColors-10{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-transparent:hover{
    background-color: transparent;
  }

  .lg\\:hover\\:bg-focus:hover{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .lg\\:hover\\:bg-black:hover{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-white:hover{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-primary:hover{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-disabled:hover{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-translucent-60:hover{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .lg\\:hover\\:bg-translucent-90:hover{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .lg\\:hover\\:bg-green-200:hover{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-green-400:hover{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-green-500:hover{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-green-600:hover{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-green-700:hover{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-green-400a50:hover{
    background-color: rgba(108,202,152,0.50196);
  }

  .lg\\:hover\\:bg-green-500a25:hover{
    background-color: rgba(151,232,18,0.09804);
  }

  .lg\\:hover\\:bg-yellow-200:hover{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-yellow-300:hover{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-yellow-500:hover{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-yellow-600:hover{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-yellow-700:hover{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-yellow-300a66:hover{
    background-color: rgba(255,233,189,0.66667);
  }

  .lg\\:hover\\:bg-yellow-500a25:hover{
    background-color: rgba(255,200,44,0.09804);
  }

  .lg\\:hover\\:bg-orange-200:hover{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-orange-400:hover{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-orange-500:hover{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-orange-800:hover{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-orange-900:hover{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-orange-500a25:hover{
    background-color: rgba(240,115,23,0.09804);
  }

  .lg\\:hover\\:bg-red-100:hover{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-red-150:hover{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-red-200:hover{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-red-300:hover{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-red-400:hover{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-red-500:hover{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-red-700:hover{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-50:hover{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-100:hover{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-150:hover{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-200:hover{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-300:hover{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-400:hover{
    background-color: rgba(114,114,114,0.8);
  }

  .lg\\:hover\\:bg-gray-425:hover{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .lg\\:hover\\:bg-gray-450:hover{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-500:hover{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-600:hover{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-625:hover{
    background-color: rgba(90,98,107,0.8);
  }

  .lg\\:hover\\:bg-gray-700:hover{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-800:hover{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-gray-200a50:hover{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .lg\\:hover\\:bg-blue-50:hover{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-100:hover{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-150:hover{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-200:hover{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-300:hover{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-400:hover{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-500:hover{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-600:hover{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-700:hover{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-750:hover{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-800:hover{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-900:hover{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-950:hover{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-500a25:hover{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .lg\\:hover\\:bg-blue-500a50:hover{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .lg\\:hover\\:bg-blue-700a75:hover{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-700a30:hover{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-blue-750a25:hover{
    background-color: rgba(86,130,170,0.09804);
  }

  .lg\\:hover\\:bg-blue-750a15:hover{
    background-color: rgba(86,130,170,0.05882);
  }

  .lg\\:hover\\:bg-blue-800a60:hover{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .lg\\:hover\\:bg-programEditorTabColors-1:hover{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-programEditorTabColors-2:hover{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-programEditorTabColors-3:hover{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-programEditorTabColors-4:hover{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-programEditorTabColors-5:hover{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-programEditorTabColors-6:hover{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-programEditorTabColors-1h:hover{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-programEditorTabColors-2h:hover{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-programEditorTabColors-3h:hover{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-programEditorTabColors-4h:hover{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-programEditorTabColors-5h:hover{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-programEditorTabColors-6h:hover{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-programEditorPresetTabColors-1:hover{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-programEditorPresetTabColors-1h:hover{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-borgScaleColors-0:hover{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-borgScaleColors-1:hover{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-borgScaleColors-2:hover{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-borgScaleColors-3:hover{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-borgScaleColors-4:hover{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-borgScaleColors-5:hover{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-borgScaleColors-6:hover{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-borgScaleColors-7:hover{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-borgScaleColors-8:hover{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-borgScaleColors-9:hover{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .lg\\:hover\\:bg-borgScaleColors-10:hover{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-transparent:focus{
    background-color: transparent;
  }

  .lg\\:focus\\:bg-focus:focus{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .lg\\:focus\\:bg-black:focus{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-white:focus{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-primary:focus{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-disabled:focus{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-translucent-60:focus{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .lg\\:focus\\:bg-translucent-90:focus{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .lg\\:focus\\:bg-green-200:focus{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-green-400:focus{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-green-500:focus{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-green-600:focus{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-green-700:focus{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-green-400a50:focus{
    background-color: rgba(108,202,152,0.50196);
  }

  .lg\\:focus\\:bg-green-500a25:focus{
    background-color: rgba(151,232,18,0.09804);
  }

  .lg\\:focus\\:bg-yellow-200:focus{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-yellow-300:focus{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-yellow-500:focus{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-yellow-600:focus{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-yellow-700:focus{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-yellow-300a66:focus{
    background-color: rgba(255,233,189,0.66667);
  }

  .lg\\:focus\\:bg-yellow-500a25:focus{
    background-color: rgba(255,200,44,0.09804);
  }

  .lg\\:focus\\:bg-orange-200:focus{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-orange-400:focus{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-orange-500:focus{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-orange-800:focus{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-orange-900:focus{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-orange-500a25:focus{
    background-color: rgba(240,115,23,0.09804);
  }

  .lg\\:focus\\:bg-red-100:focus{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-red-150:focus{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-red-200:focus{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-red-300:focus{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-red-400:focus{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-red-500:focus{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-red-700:focus{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-50:focus{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-100:focus{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-150:focus{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-200:focus{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-300:focus{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-400:focus{
    background-color: rgba(114,114,114,0.8);
  }

  .lg\\:focus\\:bg-gray-425:focus{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .lg\\:focus\\:bg-gray-450:focus{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-500:focus{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-600:focus{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-625:focus{
    background-color: rgba(90,98,107,0.8);
  }

  .lg\\:focus\\:bg-gray-700:focus{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-800:focus{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-gray-200a50:focus{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .lg\\:focus\\:bg-blue-50:focus{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-100:focus{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-150:focus{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-200:focus{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-300:focus{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-400:focus{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-500:focus{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-600:focus{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-700:focus{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-750:focus{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-800:focus{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-900:focus{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-950:focus{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-500a25:focus{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .lg\\:focus\\:bg-blue-500a50:focus{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .lg\\:focus\\:bg-blue-700a75:focus{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-700a30:focus{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-blue-750a25:focus{
    background-color: rgba(86,130,170,0.09804);
  }

  .lg\\:focus\\:bg-blue-750a15:focus{
    background-color: rgba(86,130,170,0.05882);
  }

  .lg\\:focus\\:bg-blue-800a60:focus{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .lg\\:focus\\:bg-programEditorTabColors-1:focus{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-programEditorTabColors-2:focus{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-programEditorTabColors-3:focus{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-programEditorTabColors-4:focus{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-programEditorTabColors-5:focus{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-programEditorTabColors-6:focus{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-programEditorTabColors-1h:focus{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-programEditorTabColors-2h:focus{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-programEditorTabColors-3h:focus{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-programEditorTabColors-4h:focus{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-programEditorTabColors-5h:focus{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-programEditorTabColors-6h:focus{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-programEditorPresetTabColors-1:focus{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-programEditorPresetTabColors-1h:focus{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-borgScaleColors-0:focus{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-borgScaleColors-1:focus{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-borgScaleColors-2:focus{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-borgScaleColors-3:focus{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-borgScaleColors-4:focus{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-borgScaleColors-5:focus{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-borgScaleColors-6:focus{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-borgScaleColors-7:focus{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-borgScaleColors-8:focus{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-borgScaleColors-9:focus{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .lg\\:focus\\:bg-borgScaleColors-10:focus{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .lg\\:bg-none{
    background-image: none;
  }

  .lg\\:bg-gradient-to-t{
    background-image: linear-gradient(to top, var(--gradient-color-stops));
  }

  .lg\\:bg-gradient-to-tr{
    background-image: linear-gradient(to top right, var(--gradient-color-stops));
  }

  .lg\\:bg-gradient-to-r{
    background-image: linear-gradient(to right, var(--gradient-color-stops));
  }

  .lg\\:bg-gradient-to-br{
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
  }

  .lg\\:bg-gradient-to-b{
    background-image: linear-gradient(to bottom, var(--gradient-color-stops));
  }

  .lg\\:bg-gradient-to-bl{
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
  }

  .lg\\:bg-gradient-to-l{
    background-image: linear-gradient(to left, var(--gradient-color-stops));
  }

  .lg\\:bg-gradient-to-tl{
    background-image: linear-gradient(to top left, var(--gradient-color-stops));
  }

  .lg\\:from-transparent{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:from-focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:from-black{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:from-white{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:from-primary{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:from-disabled{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .lg\\:from-translucent-60{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:from-translucent-90{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:from-green-200{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .lg\\:from-green-400{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .lg\\:from-green-500{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .lg\\:from-green-600{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .lg\\:from-green-700{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .lg\\:from-green-400a50{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .lg\\:from-green-500a25{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .lg\\:from-yellow-200{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .lg\\:from-yellow-300{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .lg\\:from-yellow-500{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .lg\\:from-yellow-600{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .lg\\:from-yellow-700{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .lg\\:from-yellow-300a66{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .lg\\:from-yellow-500a25{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .lg\\:from-orange-200{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .lg\\:from-orange-400{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .lg\\:from-orange-500{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .lg\\:from-orange-800{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .lg\\:from-orange-900{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .lg\\:from-orange-500a25{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .lg\\:from-red-100{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .lg\\:from-red-150{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .lg\\:from-red-200{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .lg\\:from-red-300{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .lg\\:from-red-400{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .lg\\:from-red-500{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .lg\\:from-red-700{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .lg\\:from-gray-50{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .lg\\:from-gray-100{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .lg\\:from-gray-150{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .lg\\:from-gray-200{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .lg\\:from-gray-300{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .lg\\:from-gray-400{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .lg\\:from-gray-425{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .lg\\:from-gray-450{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .lg\\:from-gray-500{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .lg\\:from-gray-600{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .lg\\:from-gray-625{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .lg\\:from-gray-700{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .lg\\:from-gray-800{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .lg\\:from-gray-200a50{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .lg\\:from-blue-50{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .lg\\:from-blue-100{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .lg\\:from-blue-150{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .lg\\:from-blue-200{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .lg\\:from-blue-300{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .lg\\:from-blue-400{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .lg\\:from-blue-500{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:from-blue-600{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .lg\\:from-blue-700{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .lg\\:from-blue-750{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:from-blue-800{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .lg\\:from-blue-900{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .lg\\:from-blue-950{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .lg\\:from-blue-500a25{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:from-blue-500a50{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:from-blue-700a75{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .lg\\:from-blue-700a30{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .lg\\:from-blue-750a25{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:from-blue-750a15{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:from-blue-800a60{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .lg\\:from-programEditorTabColors-1{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .lg\\:from-programEditorTabColors-2{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .lg\\:from-programEditorTabColors-3{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .lg\\:from-programEditorTabColors-4{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .lg\\:from-programEditorTabColors-5{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .lg\\:from-programEditorTabColors-6{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .lg\\:from-programEditorTabColors-1h{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .lg\\:from-programEditorTabColors-2h{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .lg\\:from-programEditorTabColors-3h{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .lg\\:from-programEditorTabColors-4h{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .lg\\:from-programEditorTabColors-5h{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .lg\\:from-programEditorTabColors-6h{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .lg\\:from-programEditorPresetTabColors-1{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .lg\\:from-programEditorPresetTabColors-1h{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .lg\\:from-borgScaleColors-0{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .lg\\:from-borgScaleColors-1{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .lg\\:from-borgScaleColors-2{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .lg\\:from-borgScaleColors-3{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .lg\\:from-borgScaleColors-4{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .lg\\:from-borgScaleColors-5{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .lg\\:from-borgScaleColors-6{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .lg\\:from-borgScaleColors-7{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .lg\\:from-borgScaleColors-8{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .lg\\:from-borgScaleColors-9{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .lg\\:from-borgScaleColors-10{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .lg\\:via-transparent{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:via-focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:via-black{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:via-white{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:via-primary{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:via-disabled{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .lg\\:via-translucent-60{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:via-translucent-90{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:via-green-200{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .lg\\:via-green-400{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .lg\\:via-green-500{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .lg\\:via-green-600{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .lg\\:via-green-700{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .lg\\:via-green-400a50{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .lg\\:via-green-500a25{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .lg\\:via-yellow-200{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .lg\\:via-yellow-300{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .lg\\:via-yellow-500{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .lg\\:via-yellow-600{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .lg\\:via-yellow-700{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .lg\\:via-yellow-300a66{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .lg\\:via-yellow-500a25{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .lg\\:via-orange-200{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .lg\\:via-orange-400{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .lg\\:via-orange-500{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .lg\\:via-orange-800{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .lg\\:via-orange-900{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .lg\\:via-orange-500a25{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .lg\\:via-red-100{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .lg\\:via-red-150{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .lg\\:via-red-200{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .lg\\:via-red-300{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .lg\\:via-red-400{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .lg\\:via-red-500{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .lg\\:via-red-700{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .lg\\:via-gray-50{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .lg\\:via-gray-100{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .lg\\:via-gray-150{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .lg\\:via-gray-200{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .lg\\:via-gray-300{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .lg\\:via-gray-400{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .lg\\:via-gray-425{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .lg\\:via-gray-450{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .lg\\:via-gray-500{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .lg\\:via-gray-600{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .lg\\:via-gray-625{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .lg\\:via-gray-700{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .lg\\:via-gray-800{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .lg\\:via-gray-200a50{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .lg\\:via-blue-50{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .lg\\:via-blue-100{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .lg\\:via-blue-150{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .lg\\:via-blue-200{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .lg\\:via-blue-300{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .lg\\:via-blue-400{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .lg\\:via-blue-500{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:via-blue-600{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .lg\\:via-blue-700{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .lg\\:via-blue-750{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:via-blue-800{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .lg\\:via-blue-900{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .lg\\:via-blue-950{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .lg\\:via-blue-500a25{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:via-blue-500a50{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:via-blue-700a75{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .lg\\:via-blue-700a30{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .lg\\:via-blue-750a25{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:via-blue-750a15{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:via-blue-800a60{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .lg\\:via-programEditorTabColors-1{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .lg\\:via-programEditorTabColors-2{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .lg\\:via-programEditorTabColors-3{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .lg\\:via-programEditorTabColors-4{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .lg\\:via-programEditorTabColors-5{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .lg\\:via-programEditorTabColors-6{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .lg\\:via-programEditorTabColors-1h{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .lg\\:via-programEditorTabColors-2h{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .lg\\:via-programEditorTabColors-3h{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .lg\\:via-programEditorTabColors-4h{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .lg\\:via-programEditorTabColors-5h{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .lg\\:via-programEditorTabColors-6h{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .lg\\:via-programEditorPresetTabColors-1{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .lg\\:via-programEditorPresetTabColors-1h{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .lg\\:via-borgScaleColors-0{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .lg\\:via-borgScaleColors-1{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .lg\\:via-borgScaleColors-2{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .lg\\:via-borgScaleColors-3{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .lg\\:via-borgScaleColors-4{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .lg\\:via-borgScaleColors-5{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .lg\\:via-borgScaleColors-6{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .lg\\:via-borgScaleColors-7{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .lg\\:via-borgScaleColors-8{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .lg\\:via-borgScaleColors-9{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .lg\\:via-borgScaleColors-10{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .lg\\:to-transparent{
    --gradient-to-color: transparent;
  }

  .lg\\:to-focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .lg\\:to-black{
    --gradient-to-color: #000;
  }

  .lg\\:to-white{
    --gradient-to-color: #fff;
  }

  .lg\\:to-primary{
    --gradient-to-color: #37A4DC;
  }

  .lg\\:to-disabled{
    --gradient-to-color: #BFBFBF;
  }

  .lg\\:to-translucent-60{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .lg\\:to-translucent-90{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .lg\\:to-green-200{
    --gradient-to-color: #f4fcea;
  }

  .lg\\:to-green-400{
    --gradient-to-color: #6CCA98;
  }

  .lg\\:to-green-500{
    --gradient-to-color: #97E812;
  }

  .lg\\:to-green-600{
    --gradient-to-color: #4f9112;
  }

  .lg\\:to-green-700{
    --gradient-to-color: #3e7211;
  }

  .lg\\:to-green-400a50{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .lg\\:to-green-500a25{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .lg\\:to-yellow-200{
    --gradient-to-color: #fff9eb;
  }

  .lg\\:to-yellow-300{
    --gradient-to-color: #ffe9bd;
  }

  .lg\\:to-yellow-500{
    --gradient-to-color: #FFC82C;
  }

  .lg\\:to-yellow-600{
    --gradient-to-color: #F7931E;
  }

  .lg\\:to-yellow-700{
    --gradient-to-color: #E1AD28;
  }

  .lg\\:to-yellow-300a66{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .lg\\:to-yellow-500a25{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .lg\\:to-orange-200{
    --gradient-to-color: #fdf0ea;
  }

  .lg\\:to-orange-400{
    --gradient-to-color: #f6c66f;
  }

  .lg\\:to-orange-500{
    --gradient-to-color: #F07313;
  }

  .lg\\:to-orange-800{
    --gradient-to-color: #db5d0c;
  }

  .lg\\:to-orange-900{
    --gradient-to-color: #b86814;
  }

  .lg\\:to-orange-500a25{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .lg\\:to-red-100{
    --gradient-to-color: #FEF5F5;
  }

  .lg\\:to-red-150{
    --gradient-to-color: #ffe9e8;
  }

  .lg\\:to-red-200{
    --gradient-to-color: #F8CECC;
  }

  .lg\\:to-red-300{
    --gradient-to-color: #ff8585;
  }

  .lg\\:to-red-400{
    --gradient-to-color: #ff3535;
  }

  .lg\\:to-red-500{
    --gradient-to-color: #DD4746;
  }

  .lg\\:to-red-700{
    --gradient-to-color: #A23C24;
  }

  .lg\\:to-gray-50{
    --gradient-to-color: #F9F9F9;
  }

  .lg\\:to-gray-100{
    --gradient-to-color: #F1F1F2;
  }

  .lg\\:to-gray-150{
    --gradient-to-color: #e6e6e6;
  }

  .lg\\:to-gray-200{
    --gradient-to-color: #E0E2E4;
  }

  .lg\\:to-gray-300{
    --gradient-to-color: #BFBFBF;
  }

  .lg\\:to-gray-400{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .lg\\:to-gray-425{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .lg\\:to-gray-450{
    --gradient-to-color: #959595;
  }

  .lg\\:to-gray-500{
    --gradient-to-color: #727272;
  }

  .lg\\:to-gray-600{
    --gradient-to-color: #5a626b;
  }

  .lg\\:to-gray-625{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .lg\\:to-gray-700{
    --gradient-to-color: #464C59;
  }

  .lg\\:to-gray-800{
    --gradient-to-color: #3c3b3b;
  }

  .lg\\:to-gray-200a50{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .lg\\:to-blue-50{
    --gradient-to-color: #f2fbff;
  }

  .lg\\:to-blue-100{
    --gradient-to-color: #EBF6FC;
  }

  .lg\\:to-blue-150{
    --gradient-to-color: #E8EEF1;
  }

  .lg\\:to-blue-200{
    --gradient-to-color: #CCE6F5;
  }

  .lg\\:to-blue-300{
    --gradient-to-color: #73BFE7;
  }

  .lg\\:to-blue-400{
    --gradient-to-color: #4BA4F7;
  }

  .lg\\:to-blue-500{
    --gradient-to-color: #37A4DC;
  }

  .lg\\:to-blue-600{
    --gradient-to-color: #6AA2D6;
  }

  .lg\\:to-blue-700{
    --gradient-to-color: #456E9A;
  }

  .lg\\:to-blue-750{
    --gradient-to-color: #5682AA;
  }

  .lg\\:to-blue-800{
    --gradient-to-color: #1F4566;
  }

  .lg\\:to-blue-900{
    --gradient-to-color: #183453;
  }

  .lg\\:to-blue-950{
    --gradient-to-color: #041527;
  }

  .lg\\:to-blue-500a25{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .lg\\:to-blue-500a50{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .lg\\:to-blue-700a75{
    --gradient-to-color: #3B648D;
  }

  .lg\\:to-blue-700a30{
    --gradient-to-color: #2A5176;
  }

  .lg\\:to-blue-750a25{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .lg\\:to-blue-750a15{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .lg\\:to-blue-800a60{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .lg\\:to-programEditorTabColors-1{
    --gradient-to-color: #3cacae;
  }

  .lg\\:to-programEditorTabColors-2{
    --gradient-to-color: #8e346a;
  }

  .lg\\:to-programEditorTabColors-3{
    --gradient-to-color: #ff72b7;
  }

  .lg\\:to-programEditorTabColors-4{
    --gradient-to-color: #ce941c;
  }

  .lg\\:to-programEditorTabColors-5{
    --gradient-to-color: #b973d9;
  }

  .lg\\:to-programEditorTabColors-6{
    --gradient-to-color: #ff9082;
  }

  .lg\\:to-programEditorTabColors-1h{
    --gradient-to-color: #d9f2f2;
  }

  .lg\\:to-programEditorTabColors-2h{
    --gradient-to-color: #f1dae8;
  }

  .lg\\:to-programEditorTabColors-3h{
    --gradient-to-color: #ffe6f2;
  }

  .lg\\:to-programEditorTabColors-4h{
    --gradient-to-color: #f9ecd2;
  }

  .lg\\:to-programEditorTabColors-5h{
    --gradient-to-color: #f5ebfa;
  }

  .lg\\:to-programEditorTabColors-6h{
    --gradient-to-color: #ffe8e6;
  }

  .lg\\:to-programEditorPresetTabColors-1{
    --gradient-to-color: #798fa3;
  }

  .lg\\:to-programEditorPresetTabColors-1h{
    --gradient-to-color: #798fa3;
  }

  .lg\\:to-borgScaleColors-0{
    --gradient-to-color: #c5d1ff;
  }

  .lg\\:to-borgScaleColors-1{
    --gradient-to-color: #a0b5fc;
  }

  .lg\\:to-borgScaleColors-2{
    --gradient-to-color: #7492ff;
  }

  .lg\\:to-borgScaleColors-3{
    --gradient-to-color: #82bbf1;
  }

  .lg\\:to-borgScaleColors-4{
    --gradient-to-color: #4ba4f7;
  }

  .lg\\:to-borgScaleColors-5{
    --gradient-to-color: #9cdd57;
  }

  .lg\\:to-borgScaleColors-6{
    --gradient-to-color: #68af00;
  }

  .lg\\:to-borgScaleColors-7{
    --gradient-to-color: #f5e380;
  }

  .lg\\:to-borgScaleColors-8{
    --gradient-to-color: #ffc246;
  }

  .lg\\:to-borgScaleColors-9{
    --gradient-to-color: #ff782f;
  }

  .lg\\:to-borgScaleColors-10{
    --gradient-to-color: #f25757;
  }

  .lg\\:hover\\:from-transparent:hover{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:hover\\:from-focus:hover{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:hover\\:from-black:hover{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:hover\\:from-white:hover{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:hover\\:from-primary:hover{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:hover\\:from-disabled:hover{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .lg\\:hover\\:from-translucent-60:hover{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:hover\\:from-translucent-90:hover{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:hover\\:from-green-200:hover{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .lg\\:hover\\:from-green-400:hover{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .lg\\:hover\\:from-green-500:hover{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .lg\\:hover\\:from-green-600:hover{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .lg\\:hover\\:from-green-700:hover{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .lg\\:hover\\:from-green-400a50:hover{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .lg\\:hover\\:from-green-500a25:hover{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .lg\\:hover\\:from-yellow-200:hover{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .lg\\:hover\\:from-yellow-300:hover{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .lg\\:hover\\:from-yellow-500:hover{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .lg\\:hover\\:from-yellow-600:hover{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .lg\\:hover\\:from-yellow-700:hover{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .lg\\:hover\\:from-yellow-300a66:hover{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .lg\\:hover\\:from-yellow-500a25:hover{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .lg\\:hover\\:from-orange-200:hover{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .lg\\:hover\\:from-orange-400:hover{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .lg\\:hover\\:from-orange-500:hover{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .lg\\:hover\\:from-orange-800:hover{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .lg\\:hover\\:from-orange-900:hover{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .lg\\:hover\\:from-orange-500a25:hover{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .lg\\:hover\\:from-red-100:hover{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .lg\\:hover\\:from-red-150:hover{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .lg\\:hover\\:from-red-200:hover{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .lg\\:hover\\:from-red-300:hover{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .lg\\:hover\\:from-red-400:hover{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .lg\\:hover\\:from-red-500:hover{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .lg\\:hover\\:from-red-700:hover{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .lg\\:hover\\:from-gray-50:hover{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .lg\\:hover\\:from-gray-100:hover{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .lg\\:hover\\:from-gray-150:hover{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .lg\\:hover\\:from-gray-200:hover{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .lg\\:hover\\:from-gray-300:hover{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .lg\\:hover\\:from-gray-400:hover{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .lg\\:hover\\:from-gray-425:hover{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .lg\\:hover\\:from-gray-450:hover{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .lg\\:hover\\:from-gray-500:hover{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .lg\\:hover\\:from-gray-600:hover{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .lg\\:hover\\:from-gray-625:hover{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .lg\\:hover\\:from-gray-700:hover{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .lg\\:hover\\:from-gray-800:hover{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .lg\\:hover\\:from-gray-200a50:hover{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .lg\\:hover\\:from-blue-50:hover{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .lg\\:hover\\:from-blue-100:hover{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .lg\\:hover\\:from-blue-150:hover{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .lg\\:hover\\:from-blue-200:hover{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .lg\\:hover\\:from-blue-300:hover{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .lg\\:hover\\:from-blue-400:hover{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .lg\\:hover\\:from-blue-500:hover{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:hover\\:from-blue-600:hover{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .lg\\:hover\\:from-blue-700:hover{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .lg\\:hover\\:from-blue-750:hover{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:hover\\:from-blue-800:hover{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .lg\\:hover\\:from-blue-900:hover{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .lg\\:hover\\:from-blue-950:hover{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .lg\\:hover\\:from-blue-500a25:hover{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:hover\\:from-blue-500a50:hover{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:hover\\:from-blue-700a75:hover{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .lg\\:hover\\:from-blue-700a30:hover{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .lg\\:hover\\:from-blue-750a25:hover{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:hover\\:from-blue-750a15:hover{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:hover\\:from-blue-800a60:hover{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .lg\\:hover\\:from-programEditorTabColors-1:hover{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .lg\\:hover\\:from-programEditorTabColors-2:hover{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .lg\\:hover\\:from-programEditorTabColors-3:hover{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .lg\\:hover\\:from-programEditorTabColors-4:hover{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .lg\\:hover\\:from-programEditorTabColors-5:hover{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .lg\\:hover\\:from-programEditorTabColors-6:hover{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .lg\\:hover\\:from-programEditorTabColors-1h:hover{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .lg\\:hover\\:from-programEditorTabColors-2h:hover{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .lg\\:hover\\:from-programEditorTabColors-3h:hover{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .lg\\:hover\\:from-programEditorTabColors-4h:hover{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .lg\\:hover\\:from-programEditorTabColors-5h:hover{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .lg\\:hover\\:from-programEditorTabColors-6h:hover{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .lg\\:hover\\:from-programEditorPresetTabColors-1:hover{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .lg\\:hover\\:from-programEditorPresetTabColors-1h:hover{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .lg\\:hover\\:from-borgScaleColors-0:hover{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .lg\\:hover\\:from-borgScaleColors-1:hover{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .lg\\:hover\\:from-borgScaleColors-2:hover{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .lg\\:hover\\:from-borgScaleColors-3:hover{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .lg\\:hover\\:from-borgScaleColors-4:hover{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .lg\\:hover\\:from-borgScaleColors-5:hover{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .lg\\:hover\\:from-borgScaleColors-6:hover{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .lg\\:hover\\:from-borgScaleColors-7:hover{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .lg\\:hover\\:from-borgScaleColors-8:hover{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .lg\\:hover\\:from-borgScaleColors-9:hover{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .lg\\:hover\\:from-borgScaleColors-10:hover{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .lg\\:hover\\:via-transparent:hover{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:hover\\:via-focus:hover{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:hover\\:via-black:hover{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:hover\\:via-white:hover{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:hover\\:via-primary:hover{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:hover\\:via-disabled:hover{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .lg\\:hover\\:via-translucent-60:hover{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:hover\\:via-translucent-90:hover{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:hover\\:via-green-200:hover{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .lg\\:hover\\:via-green-400:hover{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .lg\\:hover\\:via-green-500:hover{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .lg\\:hover\\:via-green-600:hover{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .lg\\:hover\\:via-green-700:hover{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .lg\\:hover\\:via-green-400a50:hover{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .lg\\:hover\\:via-green-500a25:hover{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .lg\\:hover\\:via-yellow-200:hover{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .lg\\:hover\\:via-yellow-300:hover{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .lg\\:hover\\:via-yellow-500:hover{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .lg\\:hover\\:via-yellow-600:hover{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .lg\\:hover\\:via-yellow-700:hover{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .lg\\:hover\\:via-yellow-300a66:hover{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .lg\\:hover\\:via-yellow-500a25:hover{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .lg\\:hover\\:via-orange-200:hover{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .lg\\:hover\\:via-orange-400:hover{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .lg\\:hover\\:via-orange-500:hover{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .lg\\:hover\\:via-orange-800:hover{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .lg\\:hover\\:via-orange-900:hover{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .lg\\:hover\\:via-orange-500a25:hover{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .lg\\:hover\\:via-red-100:hover{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .lg\\:hover\\:via-red-150:hover{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .lg\\:hover\\:via-red-200:hover{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .lg\\:hover\\:via-red-300:hover{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .lg\\:hover\\:via-red-400:hover{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .lg\\:hover\\:via-red-500:hover{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .lg\\:hover\\:via-red-700:hover{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .lg\\:hover\\:via-gray-50:hover{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .lg\\:hover\\:via-gray-100:hover{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .lg\\:hover\\:via-gray-150:hover{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .lg\\:hover\\:via-gray-200:hover{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .lg\\:hover\\:via-gray-300:hover{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .lg\\:hover\\:via-gray-400:hover{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .lg\\:hover\\:via-gray-425:hover{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .lg\\:hover\\:via-gray-450:hover{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .lg\\:hover\\:via-gray-500:hover{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .lg\\:hover\\:via-gray-600:hover{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .lg\\:hover\\:via-gray-625:hover{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .lg\\:hover\\:via-gray-700:hover{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .lg\\:hover\\:via-gray-800:hover{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .lg\\:hover\\:via-gray-200a50:hover{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .lg\\:hover\\:via-blue-50:hover{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .lg\\:hover\\:via-blue-100:hover{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .lg\\:hover\\:via-blue-150:hover{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .lg\\:hover\\:via-blue-200:hover{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .lg\\:hover\\:via-blue-300:hover{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .lg\\:hover\\:via-blue-400:hover{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .lg\\:hover\\:via-blue-500:hover{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:hover\\:via-blue-600:hover{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .lg\\:hover\\:via-blue-700:hover{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .lg\\:hover\\:via-blue-750:hover{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:hover\\:via-blue-800:hover{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .lg\\:hover\\:via-blue-900:hover{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .lg\\:hover\\:via-blue-950:hover{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .lg\\:hover\\:via-blue-500a25:hover{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:hover\\:via-blue-500a50:hover{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:hover\\:via-blue-700a75:hover{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .lg\\:hover\\:via-blue-700a30:hover{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .lg\\:hover\\:via-blue-750a25:hover{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:hover\\:via-blue-750a15:hover{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:hover\\:via-blue-800a60:hover{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .lg\\:hover\\:via-programEditorTabColors-1:hover{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .lg\\:hover\\:via-programEditorTabColors-2:hover{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .lg\\:hover\\:via-programEditorTabColors-3:hover{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .lg\\:hover\\:via-programEditorTabColors-4:hover{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .lg\\:hover\\:via-programEditorTabColors-5:hover{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .lg\\:hover\\:via-programEditorTabColors-6:hover{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .lg\\:hover\\:via-programEditorTabColors-1h:hover{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .lg\\:hover\\:via-programEditorTabColors-2h:hover{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .lg\\:hover\\:via-programEditorTabColors-3h:hover{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .lg\\:hover\\:via-programEditorTabColors-4h:hover{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .lg\\:hover\\:via-programEditorTabColors-5h:hover{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .lg\\:hover\\:via-programEditorTabColors-6h:hover{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .lg\\:hover\\:via-programEditorPresetTabColors-1:hover{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .lg\\:hover\\:via-programEditorPresetTabColors-1h:hover{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .lg\\:hover\\:via-borgScaleColors-0:hover{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .lg\\:hover\\:via-borgScaleColors-1:hover{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .lg\\:hover\\:via-borgScaleColors-2:hover{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .lg\\:hover\\:via-borgScaleColors-3:hover{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .lg\\:hover\\:via-borgScaleColors-4:hover{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .lg\\:hover\\:via-borgScaleColors-5:hover{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .lg\\:hover\\:via-borgScaleColors-6:hover{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .lg\\:hover\\:via-borgScaleColors-7:hover{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .lg\\:hover\\:via-borgScaleColors-8:hover{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .lg\\:hover\\:via-borgScaleColors-9:hover{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .lg\\:hover\\:via-borgScaleColors-10:hover{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .lg\\:hover\\:to-transparent:hover{
    --gradient-to-color: transparent;
  }

  .lg\\:hover\\:to-focus:hover{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .lg\\:hover\\:to-black:hover{
    --gradient-to-color: #000;
  }

  .lg\\:hover\\:to-white:hover{
    --gradient-to-color: #fff;
  }

  .lg\\:hover\\:to-primary:hover{
    --gradient-to-color: #37A4DC;
  }

  .lg\\:hover\\:to-disabled:hover{
    --gradient-to-color: #BFBFBF;
  }

  .lg\\:hover\\:to-translucent-60:hover{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .lg\\:hover\\:to-translucent-90:hover{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .lg\\:hover\\:to-green-200:hover{
    --gradient-to-color: #f4fcea;
  }

  .lg\\:hover\\:to-green-400:hover{
    --gradient-to-color: #6CCA98;
  }

  .lg\\:hover\\:to-green-500:hover{
    --gradient-to-color: #97E812;
  }

  .lg\\:hover\\:to-green-600:hover{
    --gradient-to-color: #4f9112;
  }

  .lg\\:hover\\:to-green-700:hover{
    --gradient-to-color: #3e7211;
  }

  .lg\\:hover\\:to-green-400a50:hover{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .lg\\:hover\\:to-green-500a25:hover{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .lg\\:hover\\:to-yellow-200:hover{
    --gradient-to-color: #fff9eb;
  }

  .lg\\:hover\\:to-yellow-300:hover{
    --gradient-to-color: #ffe9bd;
  }

  .lg\\:hover\\:to-yellow-500:hover{
    --gradient-to-color: #FFC82C;
  }

  .lg\\:hover\\:to-yellow-600:hover{
    --gradient-to-color: #F7931E;
  }

  .lg\\:hover\\:to-yellow-700:hover{
    --gradient-to-color: #E1AD28;
  }

  .lg\\:hover\\:to-yellow-300a66:hover{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .lg\\:hover\\:to-yellow-500a25:hover{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .lg\\:hover\\:to-orange-200:hover{
    --gradient-to-color: #fdf0ea;
  }

  .lg\\:hover\\:to-orange-400:hover{
    --gradient-to-color: #f6c66f;
  }

  .lg\\:hover\\:to-orange-500:hover{
    --gradient-to-color: #F07313;
  }

  .lg\\:hover\\:to-orange-800:hover{
    --gradient-to-color: #db5d0c;
  }

  .lg\\:hover\\:to-orange-900:hover{
    --gradient-to-color: #b86814;
  }

  .lg\\:hover\\:to-orange-500a25:hover{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .lg\\:hover\\:to-red-100:hover{
    --gradient-to-color: #FEF5F5;
  }

  .lg\\:hover\\:to-red-150:hover{
    --gradient-to-color: #ffe9e8;
  }

  .lg\\:hover\\:to-red-200:hover{
    --gradient-to-color: #F8CECC;
  }

  .lg\\:hover\\:to-red-300:hover{
    --gradient-to-color: #ff8585;
  }

  .lg\\:hover\\:to-red-400:hover{
    --gradient-to-color: #ff3535;
  }

  .lg\\:hover\\:to-red-500:hover{
    --gradient-to-color: #DD4746;
  }

  .lg\\:hover\\:to-red-700:hover{
    --gradient-to-color: #A23C24;
  }

  .lg\\:hover\\:to-gray-50:hover{
    --gradient-to-color: #F9F9F9;
  }

  .lg\\:hover\\:to-gray-100:hover{
    --gradient-to-color: #F1F1F2;
  }

  .lg\\:hover\\:to-gray-150:hover{
    --gradient-to-color: #e6e6e6;
  }

  .lg\\:hover\\:to-gray-200:hover{
    --gradient-to-color: #E0E2E4;
  }

  .lg\\:hover\\:to-gray-300:hover{
    --gradient-to-color: #BFBFBF;
  }

  .lg\\:hover\\:to-gray-400:hover{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .lg\\:hover\\:to-gray-425:hover{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .lg\\:hover\\:to-gray-450:hover{
    --gradient-to-color: #959595;
  }

  .lg\\:hover\\:to-gray-500:hover{
    --gradient-to-color: #727272;
  }

  .lg\\:hover\\:to-gray-600:hover{
    --gradient-to-color: #5a626b;
  }

  .lg\\:hover\\:to-gray-625:hover{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .lg\\:hover\\:to-gray-700:hover{
    --gradient-to-color: #464C59;
  }

  .lg\\:hover\\:to-gray-800:hover{
    --gradient-to-color: #3c3b3b;
  }

  .lg\\:hover\\:to-gray-200a50:hover{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .lg\\:hover\\:to-blue-50:hover{
    --gradient-to-color: #f2fbff;
  }

  .lg\\:hover\\:to-blue-100:hover{
    --gradient-to-color: #EBF6FC;
  }

  .lg\\:hover\\:to-blue-150:hover{
    --gradient-to-color: #E8EEF1;
  }

  .lg\\:hover\\:to-blue-200:hover{
    --gradient-to-color: #CCE6F5;
  }

  .lg\\:hover\\:to-blue-300:hover{
    --gradient-to-color: #73BFE7;
  }

  .lg\\:hover\\:to-blue-400:hover{
    --gradient-to-color: #4BA4F7;
  }

  .lg\\:hover\\:to-blue-500:hover{
    --gradient-to-color: #37A4DC;
  }

  .lg\\:hover\\:to-blue-600:hover{
    --gradient-to-color: #6AA2D6;
  }

  .lg\\:hover\\:to-blue-700:hover{
    --gradient-to-color: #456E9A;
  }

  .lg\\:hover\\:to-blue-750:hover{
    --gradient-to-color: #5682AA;
  }

  .lg\\:hover\\:to-blue-800:hover{
    --gradient-to-color: #1F4566;
  }

  .lg\\:hover\\:to-blue-900:hover{
    --gradient-to-color: #183453;
  }

  .lg\\:hover\\:to-blue-950:hover{
    --gradient-to-color: #041527;
  }

  .lg\\:hover\\:to-blue-500a25:hover{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .lg\\:hover\\:to-blue-500a50:hover{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .lg\\:hover\\:to-blue-700a75:hover{
    --gradient-to-color: #3B648D;
  }

  .lg\\:hover\\:to-blue-700a30:hover{
    --gradient-to-color: #2A5176;
  }

  .lg\\:hover\\:to-blue-750a25:hover{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .lg\\:hover\\:to-blue-750a15:hover{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .lg\\:hover\\:to-blue-800a60:hover{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .lg\\:hover\\:to-programEditorTabColors-1:hover{
    --gradient-to-color: #3cacae;
  }

  .lg\\:hover\\:to-programEditorTabColors-2:hover{
    --gradient-to-color: #8e346a;
  }

  .lg\\:hover\\:to-programEditorTabColors-3:hover{
    --gradient-to-color: #ff72b7;
  }

  .lg\\:hover\\:to-programEditorTabColors-4:hover{
    --gradient-to-color: #ce941c;
  }

  .lg\\:hover\\:to-programEditorTabColors-5:hover{
    --gradient-to-color: #b973d9;
  }

  .lg\\:hover\\:to-programEditorTabColors-6:hover{
    --gradient-to-color: #ff9082;
  }

  .lg\\:hover\\:to-programEditorTabColors-1h:hover{
    --gradient-to-color: #d9f2f2;
  }

  .lg\\:hover\\:to-programEditorTabColors-2h:hover{
    --gradient-to-color: #f1dae8;
  }

  .lg\\:hover\\:to-programEditorTabColors-3h:hover{
    --gradient-to-color: #ffe6f2;
  }

  .lg\\:hover\\:to-programEditorTabColors-4h:hover{
    --gradient-to-color: #f9ecd2;
  }

  .lg\\:hover\\:to-programEditorTabColors-5h:hover{
    --gradient-to-color: #f5ebfa;
  }

  .lg\\:hover\\:to-programEditorTabColors-6h:hover{
    --gradient-to-color: #ffe8e6;
  }

  .lg\\:hover\\:to-programEditorPresetTabColors-1:hover{
    --gradient-to-color: #798fa3;
  }

  .lg\\:hover\\:to-programEditorPresetTabColors-1h:hover{
    --gradient-to-color: #798fa3;
  }

  .lg\\:hover\\:to-borgScaleColors-0:hover{
    --gradient-to-color: #c5d1ff;
  }

  .lg\\:hover\\:to-borgScaleColors-1:hover{
    --gradient-to-color: #a0b5fc;
  }

  .lg\\:hover\\:to-borgScaleColors-2:hover{
    --gradient-to-color: #7492ff;
  }

  .lg\\:hover\\:to-borgScaleColors-3:hover{
    --gradient-to-color: #82bbf1;
  }

  .lg\\:hover\\:to-borgScaleColors-4:hover{
    --gradient-to-color: #4ba4f7;
  }

  .lg\\:hover\\:to-borgScaleColors-5:hover{
    --gradient-to-color: #9cdd57;
  }

  .lg\\:hover\\:to-borgScaleColors-6:hover{
    --gradient-to-color: #68af00;
  }

  .lg\\:hover\\:to-borgScaleColors-7:hover{
    --gradient-to-color: #f5e380;
  }

  .lg\\:hover\\:to-borgScaleColors-8:hover{
    --gradient-to-color: #ffc246;
  }

  .lg\\:hover\\:to-borgScaleColors-9:hover{
    --gradient-to-color: #ff782f;
  }

  .lg\\:hover\\:to-borgScaleColors-10:hover{
    --gradient-to-color: #f25757;
  }

  .lg\\:focus\\:from-transparent:focus{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:focus\\:from-focus:focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:focus\\:from-black:focus{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:focus\\:from-white:focus{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:focus\\:from-primary:focus{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:focus\\:from-disabled:focus{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .lg\\:focus\\:from-translucent-60:focus{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:focus\\:from-translucent-90:focus{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:focus\\:from-green-200:focus{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .lg\\:focus\\:from-green-400:focus{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .lg\\:focus\\:from-green-500:focus{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .lg\\:focus\\:from-green-600:focus{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .lg\\:focus\\:from-green-700:focus{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .lg\\:focus\\:from-green-400a50:focus{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .lg\\:focus\\:from-green-500a25:focus{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .lg\\:focus\\:from-yellow-200:focus{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .lg\\:focus\\:from-yellow-300:focus{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .lg\\:focus\\:from-yellow-500:focus{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .lg\\:focus\\:from-yellow-600:focus{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .lg\\:focus\\:from-yellow-700:focus{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .lg\\:focus\\:from-yellow-300a66:focus{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .lg\\:focus\\:from-yellow-500a25:focus{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .lg\\:focus\\:from-orange-200:focus{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .lg\\:focus\\:from-orange-400:focus{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .lg\\:focus\\:from-orange-500:focus{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .lg\\:focus\\:from-orange-800:focus{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .lg\\:focus\\:from-orange-900:focus{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .lg\\:focus\\:from-orange-500a25:focus{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .lg\\:focus\\:from-red-100:focus{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .lg\\:focus\\:from-red-150:focus{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .lg\\:focus\\:from-red-200:focus{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .lg\\:focus\\:from-red-300:focus{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .lg\\:focus\\:from-red-400:focus{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .lg\\:focus\\:from-red-500:focus{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .lg\\:focus\\:from-red-700:focus{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .lg\\:focus\\:from-gray-50:focus{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .lg\\:focus\\:from-gray-100:focus{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .lg\\:focus\\:from-gray-150:focus{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .lg\\:focus\\:from-gray-200:focus{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .lg\\:focus\\:from-gray-300:focus{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .lg\\:focus\\:from-gray-400:focus{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .lg\\:focus\\:from-gray-425:focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .lg\\:focus\\:from-gray-450:focus{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .lg\\:focus\\:from-gray-500:focus{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .lg\\:focus\\:from-gray-600:focus{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .lg\\:focus\\:from-gray-625:focus{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .lg\\:focus\\:from-gray-700:focus{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .lg\\:focus\\:from-gray-800:focus{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .lg\\:focus\\:from-gray-200a50:focus{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .lg\\:focus\\:from-blue-50:focus{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .lg\\:focus\\:from-blue-100:focus{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .lg\\:focus\\:from-blue-150:focus{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .lg\\:focus\\:from-blue-200:focus{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .lg\\:focus\\:from-blue-300:focus{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .lg\\:focus\\:from-blue-400:focus{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .lg\\:focus\\:from-blue-500:focus{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:focus\\:from-blue-600:focus{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .lg\\:focus\\:from-blue-700:focus{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .lg\\:focus\\:from-blue-750:focus{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:focus\\:from-blue-800:focus{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .lg\\:focus\\:from-blue-900:focus{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .lg\\:focus\\:from-blue-950:focus{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .lg\\:focus\\:from-blue-500a25:focus{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:focus\\:from-blue-500a50:focus{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:focus\\:from-blue-700a75:focus{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .lg\\:focus\\:from-blue-700a30:focus{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .lg\\:focus\\:from-blue-750a25:focus{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:focus\\:from-blue-750a15:focus{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:focus\\:from-blue-800a60:focus{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .lg\\:focus\\:from-programEditorTabColors-1:focus{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .lg\\:focus\\:from-programEditorTabColors-2:focus{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .lg\\:focus\\:from-programEditorTabColors-3:focus{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .lg\\:focus\\:from-programEditorTabColors-4:focus{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .lg\\:focus\\:from-programEditorTabColors-5:focus{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .lg\\:focus\\:from-programEditorTabColors-6:focus{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .lg\\:focus\\:from-programEditorTabColors-1h:focus{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .lg\\:focus\\:from-programEditorTabColors-2h:focus{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .lg\\:focus\\:from-programEditorTabColors-3h:focus{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .lg\\:focus\\:from-programEditorTabColors-4h:focus{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .lg\\:focus\\:from-programEditorTabColors-5h:focus{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .lg\\:focus\\:from-programEditorTabColors-6h:focus{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .lg\\:focus\\:from-programEditorPresetTabColors-1:focus{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .lg\\:focus\\:from-programEditorPresetTabColors-1h:focus{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .lg\\:focus\\:from-borgScaleColors-0:focus{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .lg\\:focus\\:from-borgScaleColors-1:focus{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .lg\\:focus\\:from-borgScaleColors-2:focus{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .lg\\:focus\\:from-borgScaleColors-3:focus{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .lg\\:focus\\:from-borgScaleColors-4:focus{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .lg\\:focus\\:from-borgScaleColors-5:focus{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .lg\\:focus\\:from-borgScaleColors-6:focus{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .lg\\:focus\\:from-borgScaleColors-7:focus{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .lg\\:focus\\:from-borgScaleColors-8:focus{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .lg\\:focus\\:from-borgScaleColors-9:focus{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .lg\\:focus\\:from-borgScaleColors-10:focus{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .lg\\:focus\\:via-transparent:focus{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:focus\\:via-focus:focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:focus\\:via-black:focus{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .lg\\:focus\\:via-white:focus{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:focus\\:via-primary:focus{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:focus\\:via-disabled:focus{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .lg\\:focus\\:via-translucent-60:focus{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:focus\\:via-translucent-90:focus{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .lg\\:focus\\:via-green-200:focus{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .lg\\:focus\\:via-green-400:focus{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .lg\\:focus\\:via-green-500:focus{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .lg\\:focus\\:via-green-600:focus{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .lg\\:focus\\:via-green-700:focus{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .lg\\:focus\\:via-green-400a50:focus{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .lg\\:focus\\:via-green-500a25:focus{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .lg\\:focus\\:via-yellow-200:focus{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .lg\\:focus\\:via-yellow-300:focus{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .lg\\:focus\\:via-yellow-500:focus{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .lg\\:focus\\:via-yellow-600:focus{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .lg\\:focus\\:via-yellow-700:focus{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .lg\\:focus\\:via-yellow-300a66:focus{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .lg\\:focus\\:via-yellow-500a25:focus{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .lg\\:focus\\:via-orange-200:focus{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .lg\\:focus\\:via-orange-400:focus{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .lg\\:focus\\:via-orange-500:focus{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .lg\\:focus\\:via-orange-800:focus{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .lg\\:focus\\:via-orange-900:focus{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .lg\\:focus\\:via-orange-500a25:focus{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .lg\\:focus\\:via-red-100:focus{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .lg\\:focus\\:via-red-150:focus{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .lg\\:focus\\:via-red-200:focus{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .lg\\:focus\\:via-red-300:focus{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .lg\\:focus\\:via-red-400:focus{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .lg\\:focus\\:via-red-500:focus{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .lg\\:focus\\:via-red-700:focus{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .lg\\:focus\\:via-gray-50:focus{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .lg\\:focus\\:via-gray-100:focus{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .lg\\:focus\\:via-gray-150:focus{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .lg\\:focus\\:via-gray-200:focus{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .lg\\:focus\\:via-gray-300:focus{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .lg\\:focus\\:via-gray-400:focus{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .lg\\:focus\\:via-gray-425:focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .lg\\:focus\\:via-gray-450:focus{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .lg\\:focus\\:via-gray-500:focus{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .lg\\:focus\\:via-gray-600:focus{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .lg\\:focus\\:via-gray-625:focus{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .lg\\:focus\\:via-gray-700:focus{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .lg\\:focus\\:via-gray-800:focus{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .lg\\:focus\\:via-gray-200a50:focus{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .lg\\:focus\\:via-blue-50:focus{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .lg\\:focus\\:via-blue-100:focus{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .lg\\:focus\\:via-blue-150:focus{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .lg\\:focus\\:via-blue-200:focus{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .lg\\:focus\\:via-blue-300:focus{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .lg\\:focus\\:via-blue-400:focus{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .lg\\:focus\\:via-blue-500:focus{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:focus\\:via-blue-600:focus{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .lg\\:focus\\:via-blue-700:focus{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .lg\\:focus\\:via-blue-750:focus{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:focus\\:via-blue-800:focus{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .lg\\:focus\\:via-blue-900:focus{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .lg\\:focus\\:via-blue-950:focus{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .lg\\:focus\\:via-blue-500a25:focus{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:focus\\:via-blue-500a50:focus{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .lg\\:focus\\:via-blue-700a75:focus{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .lg\\:focus\\:via-blue-700a30:focus{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .lg\\:focus\\:via-blue-750a25:focus{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:focus\\:via-blue-750a15:focus{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .lg\\:focus\\:via-blue-800a60:focus{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .lg\\:focus\\:via-programEditorTabColors-1:focus{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .lg\\:focus\\:via-programEditorTabColors-2:focus{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .lg\\:focus\\:via-programEditorTabColors-3:focus{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .lg\\:focus\\:via-programEditorTabColors-4:focus{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .lg\\:focus\\:via-programEditorTabColors-5:focus{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .lg\\:focus\\:via-programEditorTabColors-6:focus{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .lg\\:focus\\:via-programEditorTabColors-1h:focus{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .lg\\:focus\\:via-programEditorTabColors-2h:focus{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .lg\\:focus\\:via-programEditorTabColors-3h:focus{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .lg\\:focus\\:via-programEditorTabColors-4h:focus{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .lg\\:focus\\:via-programEditorTabColors-5h:focus{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .lg\\:focus\\:via-programEditorTabColors-6h:focus{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .lg\\:focus\\:via-programEditorPresetTabColors-1:focus{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .lg\\:focus\\:via-programEditorPresetTabColors-1h:focus{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .lg\\:focus\\:via-borgScaleColors-0:focus{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .lg\\:focus\\:via-borgScaleColors-1:focus{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .lg\\:focus\\:via-borgScaleColors-2:focus{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .lg\\:focus\\:via-borgScaleColors-3:focus{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .lg\\:focus\\:via-borgScaleColors-4:focus{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .lg\\:focus\\:via-borgScaleColors-5:focus{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .lg\\:focus\\:via-borgScaleColors-6:focus{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .lg\\:focus\\:via-borgScaleColors-7:focus{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .lg\\:focus\\:via-borgScaleColors-8:focus{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .lg\\:focus\\:via-borgScaleColors-9:focus{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .lg\\:focus\\:via-borgScaleColors-10:focus{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .lg\\:focus\\:to-transparent:focus{
    --gradient-to-color: transparent;
  }

  .lg\\:focus\\:to-focus:focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .lg\\:focus\\:to-black:focus{
    --gradient-to-color: #000;
  }

  .lg\\:focus\\:to-white:focus{
    --gradient-to-color: #fff;
  }

  .lg\\:focus\\:to-primary:focus{
    --gradient-to-color: #37A4DC;
  }

  .lg\\:focus\\:to-disabled:focus{
    --gradient-to-color: #BFBFBF;
  }

  .lg\\:focus\\:to-translucent-60:focus{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .lg\\:focus\\:to-translucent-90:focus{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .lg\\:focus\\:to-green-200:focus{
    --gradient-to-color: #f4fcea;
  }

  .lg\\:focus\\:to-green-400:focus{
    --gradient-to-color: #6CCA98;
  }

  .lg\\:focus\\:to-green-500:focus{
    --gradient-to-color: #97E812;
  }

  .lg\\:focus\\:to-green-600:focus{
    --gradient-to-color: #4f9112;
  }

  .lg\\:focus\\:to-green-700:focus{
    --gradient-to-color: #3e7211;
  }

  .lg\\:focus\\:to-green-400a50:focus{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .lg\\:focus\\:to-green-500a25:focus{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .lg\\:focus\\:to-yellow-200:focus{
    --gradient-to-color: #fff9eb;
  }

  .lg\\:focus\\:to-yellow-300:focus{
    --gradient-to-color: #ffe9bd;
  }

  .lg\\:focus\\:to-yellow-500:focus{
    --gradient-to-color: #FFC82C;
  }

  .lg\\:focus\\:to-yellow-600:focus{
    --gradient-to-color: #F7931E;
  }

  .lg\\:focus\\:to-yellow-700:focus{
    --gradient-to-color: #E1AD28;
  }

  .lg\\:focus\\:to-yellow-300a66:focus{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .lg\\:focus\\:to-yellow-500a25:focus{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .lg\\:focus\\:to-orange-200:focus{
    --gradient-to-color: #fdf0ea;
  }

  .lg\\:focus\\:to-orange-400:focus{
    --gradient-to-color: #f6c66f;
  }

  .lg\\:focus\\:to-orange-500:focus{
    --gradient-to-color: #F07313;
  }

  .lg\\:focus\\:to-orange-800:focus{
    --gradient-to-color: #db5d0c;
  }

  .lg\\:focus\\:to-orange-900:focus{
    --gradient-to-color: #b86814;
  }

  .lg\\:focus\\:to-orange-500a25:focus{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .lg\\:focus\\:to-red-100:focus{
    --gradient-to-color: #FEF5F5;
  }

  .lg\\:focus\\:to-red-150:focus{
    --gradient-to-color: #ffe9e8;
  }

  .lg\\:focus\\:to-red-200:focus{
    --gradient-to-color: #F8CECC;
  }

  .lg\\:focus\\:to-red-300:focus{
    --gradient-to-color: #ff8585;
  }

  .lg\\:focus\\:to-red-400:focus{
    --gradient-to-color: #ff3535;
  }

  .lg\\:focus\\:to-red-500:focus{
    --gradient-to-color: #DD4746;
  }

  .lg\\:focus\\:to-red-700:focus{
    --gradient-to-color: #A23C24;
  }

  .lg\\:focus\\:to-gray-50:focus{
    --gradient-to-color: #F9F9F9;
  }

  .lg\\:focus\\:to-gray-100:focus{
    --gradient-to-color: #F1F1F2;
  }

  .lg\\:focus\\:to-gray-150:focus{
    --gradient-to-color: #e6e6e6;
  }

  .lg\\:focus\\:to-gray-200:focus{
    --gradient-to-color: #E0E2E4;
  }

  .lg\\:focus\\:to-gray-300:focus{
    --gradient-to-color: #BFBFBF;
  }

  .lg\\:focus\\:to-gray-400:focus{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .lg\\:focus\\:to-gray-425:focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .lg\\:focus\\:to-gray-450:focus{
    --gradient-to-color: #959595;
  }

  .lg\\:focus\\:to-gray-500:focus{
    --gradient-to-color: #727272;
  }

  .lg\\:focus\\:to-gray-600:focus{
    --gradient-to-color: #5a626b;
  }

  .lg\\:focus\\:to-gray-625:focus{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .lg\\:focus\\:to-gray-700:focus{
    --gradient-to-color: #464C59;
  }

  .lg\\:focus\\:to-gray-800:focus{
    --gradient-to-color: #3c3b3b;
  }

  .lg\\:focus\\:to-gray-200a50:focus{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .lg\\:focus\\:to-blue-50:focus{
    --gradient-to-color: #f2fbff;
  }

  .lg\\:focus\\:to-blue-100:focus{
    --gradient-to-color: #EBF6FC;
  }

  .lg\\:focus\\:to-blue-150:focus{
    --gradient-to-color: #E8EEF1;
  }

  .lg\\:focus\\:to-blue-200:focus{
    --gradient-to-color: #CCE6F5;
  }

  .lg\\:focus\\:to-blue-300:focus{
    --gradient-to-color: #73BFE7;
  }

  .lg\\:focus\\:to-blue-400:focus{
    --gradient-to-color: #4BA4F7;
  }

  .lg\\:focus\\:to-blue-500:focus{
    --gradient-to-color: #37A4DC;
  }

  .lg\\:focus\\:to-blue-600:focus{
    --gradient-to-color: #6AA2D6;
  }

  .lg\\:focus\\:to-blue-700:focus{
    --gradient-to-color: #456E9A;
  }

  .lg\\:focus\\:to-blue-750:focus{
    --gradient-to-color: #5682AA;
  }

  .lg\\:focus\\:to-blue-800:focus{
    --gradient-to-color: #1F4566;
  }

  .lg\\:focus\\:to-blue-900:focus{
    --gradient-to-color: #183453;
  }

  .lg\\:focus\\:to-blue-950:focus{
    --gradient-to-color: #041527;
  }

  .lg\\:focus\\:to-blue-500a25:focus{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .lg\\:focus\\:to-blue-500a50:focus{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .lg\\:focus\\:to-blue-700a75:focus{
    --gradient-to-color: #3B648D;
  }

  .lg\\:focus\\:to-blue-700a30:focus{
    --gradient-to-color: #2A5176;
  }

  .lg\\:focus\\:to-blue-750a25:focus{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .lg\\:focus\\:to-blue-750a15:focus{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .lg\\:focus\\:to-blue-800a60:focus{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .lg\\:focus\\:to-programEditorTabColors-1:focus{
    --gradient-to-color: #3cacae;
  }

  .lg\\:focus\\:to-programEditorTabColors-2:focus{
    --gradient-to-color: #8e346a;
  }

  .lg\\:focus\\:to-programEditorTabColors-3:focus{
    --gradient-to-color: #ff72b7;
  }

  .lg\\:focus\\:to-programEditorTabColors-4:focus{
    --gradient-to-color: #ce941c;
  }

  .lg\\:focus\\:to-programEditorTabColors-5:focus{
    --gradient-to-color: #b973d9;
  }

  .lg\\:focus\\:to-programEditorTabColors-6:focus{
    --gradient-to-color: #ff9082;
  }

  .lg\\:focus\\:to-programEditorTabColors-1h:focus{
    --gradient-to-color: #d9f2f2;
  }

  .lg\\:focus\\:to-programEditorTabColors-2h:focus{
    --gradient-to-color: #f1dae8;
  }

  .lg\\:focus\\:to-programEditorTabColors-3h:focus{
    --gradient-to-color: #ffe6f2;
  }

  .lg\\:focus\\:to-programEditorTabColors-4h:focus{
    --gradient-to-color: #f9ecd2;
  }

  .lg\\:focus\\:to-programEditorTabColors-5h:focus{
    --gradient-to-color: #f5ebfa;
  }

  .lg\\:focus\\:to-programEditorTabColors-6h:focus{
    --gradient-to-color: #ffe8e6;
  }

  .lg\\:focus\\:to-programEditorPresetTabColors-1:focus{
    --gradient-to-color: #798fa3;
  }

  .lg\\:focus\\:to-programEditorPresetTabColors-1h:focus{
    --gradient-to-color: #798fa3;
  }

  .lg\\:focus\\:to-borgScaleColors-0:focus{
    --gradient-to-color: #c5d1ff;
  }

  .lg\\:focus\\:to-borgScaleColors-1:focus{
    --gradient-to-color: #a0b5fc;
  }

  .lg\\:focus\\:to-borgScaleColors-2:focus{
    --gradient-to-color: #7492ff;
  }

  .lg\\:focus\\:to-borgScaleColors-3:focus{
    --gradient-to-color: #82bbf1;
  }

  .lg\\:focus\\:to-borgScaleColors-4:focus{
    --gradient-to-color: #4ba4f7;
  }

  .lg\\:focus\\:to-borgScaleColors-5:focus{
    --gradient-to-color: #9cdd57;
  }

  .lg\\:focus\\:to-borgScaleColors-6:focus{
    --gradient-to-color: #68af00;
  }

  .lg\\:focus\\:to-borgScaleColors-7:focus{
    --gradient-to-color: #f5e380;
  }

  .lg\\:focus\\:to-borgScaleColors-8:focus{
    --gradient-to-color: #ffc246;
  }

  .lg\\:focus\\:to-borgScaleColors-9:focus{
    --gradient-to-color: #ff782f;
  }

  .lg\\:focus\\:to-borgScaleColors-10:focus{
    --gradient-to-color: #f25757;
  }

  .lg\\:bg-opacity-0{
    --bg-opacity: 0;
  }

  .lg\\:bg-opacity-25{
    --bg-opacity: .25;
  }

  .lg\\:bg-opacity-50{
    --bg-opacity: .5;
  }

  .lg\\:bg-opacity-75{
    --bg-opacity: .75;
  }

  .lg\\:bg-opacity-100{
    --bg-opacity: 1;
  }

  .lg\\:hover\\:bg-opacity-0:hover{
    --bg-opacity: 0;
  }

  .lg\\:hover\\:bg-opacity-25:hover{
    --bg-opacity: .25;
  }

  .lg\\:hover\\:bg-opacity-50:hover{
    --bg-opacity: .5;
  }

  .lg\\:hover\\:bg-opacity-75:hover{
    --bg-opacity: .75;
  }

  .lg\\:hover\\:bg-opacity-100:hover{
    --bg-opacity: 1;
  }

  .lg\\:focus\\:bg-opacity-0:focus{
    --bg-opacity: 0;
  }

  .lg\\:focus\\:bg-opacity-25:focus{
    --bg-opacity: .25;
  }

  .lg\\:focus\\:bg-opacity-50:focus{
    --bg-opacity: .5;
  }

  .lg\\:focus\\:bg-opacity-75:focus{
    --bg-opacity: .75;
  }

  .lg\\:focus\\:bg-opacity-100:focus{
    --bg-opacity: 1;
  }

  .lg\\:bg-bottom{
    background-position: bottom;
  }

  .lg\\:bg-center{
    background-position: center;
  }

  .lg\\:bg-left{
    background-position: left;
  }

  .lg\\:bg-left-bottom{
    background-position: left bottom;
  }

  .lg\\:bg-left-top{
    background-position: left top;
  }

  .lg\\:bg-right{
    background-position: right;
  }

  .lg\\:bg-right-bottom{
    background-position: right bottom;
  }

  .lg\\:bg-right-top{
    background-position: right top;
  }

  .lg\\:bg-top{
    background-position: top;
  }

  .lg\\:bg-repeat{
    background-repeat: repeat;
  }

  .lg\\:bg-no-repeat{
    background-repeat: no-repeat;
  }

  .lg\\:bg-repeat-x{
    background-repeat: repeat-x;
  }

  .lg\\:bg-repeat-y{
    background-repeat: repeat-y;
  }

  .lg\\:bg-repeat-round{
    background-repeat: round;
  }

  .lg\\:bg-repeat-space{
    background-repeat: space;
  }

  .lg\\:bg-auto{
    background-size: auto;
  }

  .lg\\:bg-cover{
    background-size: cover;
  }

  .lg\\:bg-contain{
    background-size: contain;
  }

  .lg\\:border-transparent{
    border-color: transparent;
  }

  .lg\\:border-focus{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .lg\\:border-black{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .lg\\:border-white{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .lg\\:border-primary{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .lg\\:border-disabled{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .lg\\:border-translucent-60{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .lg\\:border-translucent-90{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .lg\\:border-green-200{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .lg\\:border-green-400{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .lg\\:border-green-500{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .lg\\:border-green-600{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .lg\\:border-green-700{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .lg\\:border-green-400a50{
    border-color: rgba(108,202,152,0.50196);
  }

  .lg\\:border-green-500a25{
    border-color: rgba(151,232,18,0.09804);
  }

  .lg\\:border-yellow-200{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .lg\\:border-yellow-300{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .lg\\:border-yellow-500{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .lg\\:border-yellow-600{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .lg\\:border-yellow-700{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .lg\\:border-yellow-300a66{
    border-color: rgba(255,233,189,0.66667);
  }

  .lg\\:border-yellow-500a25{
    border-color: rgba(255,200,44,0.09804);
  }

  .lg\\:border-orange-200{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .lg\\:border-orange-400{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .lg\\:border-orange-500{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .lg\\:border-orange-800{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .lg\\:border-orange-900{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .lg\\:border-orange-500a25{
    border-color: rgba(240,115,23,0.09804);
  }

  .lg\\:border-red-100{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .lg\\:border-red-150{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .lg\\:border-red-200{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .lg\\:border-red-300{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .lg\\:border-red-400{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .lg\\:border-red-500{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .lg\\:border-red-700{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .lg\\:border-gray-50{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .lg\\:border-gray-100{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .lg\\:border-gray-150{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .lg\\:border-gray-200{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .lg\\:border-gray-300{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .lg\\:border-gray-400{
    border-color: rgba(114,114,114,0.8);
  }

  .lg\\:border-gray-425{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .lg\\:border-gray-450{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .lg\\:border-gray-500{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .lg\\:border-gray-600{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .lg\\:border-gray-625{
    border-color: rgba(90,98,107,0.8);
  }

  .lg\\:border-gray-700{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .lg\\:border-gray-800{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .lg\\:border-gray-200a50{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .lg\\:border-blue-50{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .lg\\:border-blue-100{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .lg\\:border-blue-150{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .lg\\:border-blue-200{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .lg\\:border-blue-300{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .lg\\:border-blue-400{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .lg\\:border-blue-500{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .lg\\:border-blue-600{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .lg\\:border-blue-700{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .lg\\:border-blue-750{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .lg\\:border-blue-800{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .lg\\:border-blue-900{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .lg\\:border-blue-950{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .lg\\:border-blue-500a25{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .lg\\:border-blue-500a50{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .lg\\:border-blue-700a75{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .lg\\:border-blue-700a30{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .lg\\:border-blue-750a25{
    border-color: rgba(86,130,170,0.09804);
  }

  .lg\\:border-blue-750a15{
    border-color: rgba(86,130,170,0.05882);
  }

  .lg\\:border-blue-800a60{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .lg\\:border-programEditorTabColors-1{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .lg\\:border-programEditorTabColors-2{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .lg\\:border-programEditorTabColors-3{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .lg\\:border-programEditorTabColors-4{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .lg\\:border-programEditorTabColors-5{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .lg\\:border-programEditorTabColors-6{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .lg\\:border-programEditorTabColors-1h{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .lg\\:border-programEditorTabColors-2h{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .lg\\:border-programEditorTabColors-3h{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .lg\\:border-programEditorTabColors-4h{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .lg\\:border-programEditorTabColors-5h{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .lg\\:border-programEditorTabColors-6h{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .lg\\:border-programEditorPresetTabColors-1{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .lg\\:border-programEditorPresetTabColors-1h{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .lg\\:border-borgScaleColors-0{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .lg\\:border-borgScaleColors-1{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .lg\\:border-borgScaleColors-2{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .lg\\:border-borgScaleColors-3{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .lg\\:border-borgScaleColors-4{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .lg\\:border-borgScaleColors-5{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .lg\\:border-borgScaleColors-6{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .lg\\:border-borgScaleColors-7{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .lg\\:border-borgScaleColors-8{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .lg\\:border-borgScaleColors-9{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .lg\\:border-borgScaleColors-10{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .lg\\:hover\\:border-transparent:hover{
    border-color: transparent;
  }

  .lg\\:hover\\:border-focus:hover{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .lg\\:hover\\:border-black:hover{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .lg\\:hover\\:border-white:hover{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .lg\\:hover\\:border-primary:hover{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .lg\\:hover\\:border-disabled:hover{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .lg\\:hover\\:border-translucent-60:hover{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .lg\\:hover\\:border-translucent-90:hover{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .lg\\:hover\\:border-green-200:hover{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .lg\\:hover\\:border-green-400:hover{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .lg\\:hover\\:border-green-500:hover{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .lg\\:hover\\:border-green-600:hover{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .lg\\:hover\\:border-green-700:hover{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .lg\\:hover\\:border-green-400a50:hover{
    border-color: rgba(108,202,152,0.50196);
  }

  .lg\\:hover\\:border-green-500a25:hover{
    border-color: rgba(151,232,18,0.09804);
  }

  .lg\\:hover\\:border-yellow-200:hover{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .lg\\:hover\\:border-yellow-300:hover{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .lg\\:hover\\:border-yellow-500:hover{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .lg\\:hover\\:border-yellow-600:hover{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .lg\\:hover\\:border-yellow-700:hover{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .lg\\:hover\\:border-yellow-300a66:hover{
    border-color: rgba(255,233,189,0.66667);
  }

  .lg\\:hover\\:border-yellow-500a25:hover{
    border-color: rgba(255,200,44,0.09804);
  }

  .lg\\:hover\\:border-orange-200:hover{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .lg\\:hover\\:border-orange-400:hover{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .lg\\:hover\\:border-orange-500:hover{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .lg\\:hover\\:border-orange-800:hover{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .lg\\:hover\\:border-orange-900:hover{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .lg\\:hover\\:border-orange-500a25:hover{
    border-color: rgba(240,115,23,0.09804);
  }

  .lg\\:hover\\:border-red-100:hover{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .lg\\:hover\\:border-red-150:hover{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .lg\\:hover\\:border-red-200:hover{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .lg\\:hover\\:border-red-300:hover{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .lg\\:hover\\:border-red-400:hover{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .lg\\:hover\\:border-red-500:hover{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .lg\\:hover\\:border-red-700:hover{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-50:hover{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-100:hover{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-150:hover{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-200:hover{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-300:hover{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-400:hover{
    border-color: rgba(114,114,114,0.8);
  }

  .lg\\:hover\\:border-gray-425:hover{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .lg\\:hover\\:border-gray-450:hover{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-500:hover{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-600:hover{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-625:hover{
    border-color: rgba(90,98,107,0.8);
  }

  .lg\\:hover\\:border-gray-700:hover{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-800:hover{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .lg\\:hover\\:border-gray-200a50:hover{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .lg\\:hover\\:border-blue-50:hover{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-100:hover{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-150:hover{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-200:hover{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-300:hover{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-400:hover{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-500:hover{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-600:hover{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-700:hover{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-750:hover{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-800:hover{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-900:hover{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-950:hover{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-500a25:hover{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .lg\\:hover\\:border-blue-500a50:hover{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .lg\\:hover\\:border-blue-700a75:hover{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-700a30:hover{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .lg\\:hover\\:border-blue-750a25:hover{
    border-color: rgba(86,130,170,0.09804);
  }

  .lg\\:hover\\:border-blue-750a15:hover{
    border-color: rgba(86,130,170,0.05882);
  }

  .lg\\:hover\\:border-blue-800a60:hover{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .lg\\:hover\\:border-programEditorTabColors-1:hover{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .lg\\:hover\\:border-programEditorTabColors-2:hover{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .lg\\:hover\\:border-programEditorTabColors-3:hover{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .lg\\:hover\\:border-programEditorTabColors-4:hover{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .lg\\:hover\\:border-programEditorTabColors-5:hover{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .lg\\:hover\\:border-programEditorTabColors-6:hover{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .lg\\:hover\\:border-programEditorTabColors-1h:hover{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .lg\\:hover\\:border-programEditorTabColors-2h:hover{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .lg\\:hover\\:border-programEditorTabColors-3h:hover{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .lg\\:hover\\:border-programEditorTabColors-4h:hover{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .lg\\:hover\\:border-programEditorTabColors-5h:hover{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .lg\\:hover\\:border-programEditorTabColors-6h:hover{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .lg\\:hover\\:border-programEditorPresetTabColors-1:hover{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .lg\\:hover\\:border-programEditorPresetTabColors-1h:hover{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .lg\\:hover\\:border-borgScaleColors-0:hover{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .lg\\:hover\\:border-borgScaleColors-1:hover{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .lg\\:hover\\:border-borgScaleColors-2:hover{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .lg\\:hover\\:border-borgScaleColors-3:hover{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .lg\\:hover\\:border-borgScaleColors-4:hover{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .lg\\:hover\\:border-borgScaleColors-5:hover{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .lg\\:hover\\:border-borgScaleColors-6:hover{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .lg\\:hover\\:border-borgScaleColors-7:hover{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .lg\\:hover\\:border-borgScaleColors-8:hover{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .lg\\:hover\\:border-borgScaleColors-9:hover{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .lg\\:hover\\:border-borgScaleColors-10:hover{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .lg\\:focus\\:border-transparent:focus{
    border-color: transparent;
  }

  .lg\\:focus\\:border-focus:focus{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .lg\\:focus\\:border-black:focus{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .lg\\:focus\\:border-white:focus{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .lg\\:focus\\:border-primary:focus{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .lg\\:focus\\:border-disabled:focus{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .lg\\:focus\\:border-translucent-60:focus{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .lg\\:focus\\:border-translucent-90:focus{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .lg\\:focus\\:border-green-200:focus{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .lg\\:focus\\:border-green-400:focus{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .lg\\:focus\\:border-green-500:focus{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .lg\\:focus\\:border-green-600:focus{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .lg\\:focus\\:border-green-700:focus{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .lg\\:focus\\:border-green-400a50:focus{
    border-color: rgba(108,202,152,0.50196);
  }

  .lg\\:focus\\:border-green-500a25:focus{
    border-color: rgba(151,232,18,0.09804);
  }

  .lg\\:focus\\:border-yellow-200:focus{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .lg\\:focus\\:border-yellow-300:focus{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .lg\\:focus\\:border-yellow-500:focus{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .lg\\:focus\\:border-yellow-600:focus{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .lg\\:focus\\:border-yellow-700:focus{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .lg\\:focus\\:border-yellow-300a66:focus{
    border-color: rgba(255,233,189,0.66667);
  }

  .lg\\:focus\\:border-yellow-500a25:focus{
    border-color: rgba(255,200,44,0.09804);
  }

  .lg\\:focus\\:border-orange-200:focus{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .lg\\:focus\\:border-orange-400:focus{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .lg\\:focus\\:border-orange-500:focus{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .lg\\:focus\\:border-orange-800:focus{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .lg\\:focus\\:border-orange-900:focus{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .lg\\:focus\\:border-orange-500a25:focus{
    border-color: rgba(240,115,23,0.09804);
  }

  .lg\\:focus\\:border-red-100:focus{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .lg\\:focus\\:border-red-150:focus{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .lg\\:focus\\:border-red-200:focus{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .lg\\:focus\\:border-red-300:focus{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .lg\\:focus\\:border-red-400:focus{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .lg\\:focus\\:border-red-500:focus{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .lg\\:focus\\:border-red-700:focus{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-50:focus{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-100:focus{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-150:focus{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-200:focus{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-300:focus{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-400:focus{
    border-color: rgba(114,114,114,0.8);
  }

  .lg\\:focus\\:border-gray-425:focus{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .lg\\:focus\\:border-gray-450:focus{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-500:focus{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-600:focus{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-625:focus{
    border-color: rgba(90,98,107,0.8);
  }

  .lg\\:focus\\:border-gray-700:focus{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-800:focus{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .lg\\:focus\\:border-gray-200a50:focus{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .lg\\:focus\\:border-blue-50:focus{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-100:focus{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-150:focus{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-200:focus{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-300:focus{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-400:focus{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-500:focus{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-600:focus{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-700:focus{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-750:focus{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-800:focus{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-900:focus{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-950:focus{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-500a25:focus{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .lg\\:focus\\:border-blue-500a50:focus{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .lg\\:focus\\:border-blue-700a75:focus{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-700a30:focus{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .lg\\:focus\\:border-blue-750a25:focus{
    border-color: rgba(86,130,170,0.09804);
  }

  .lg\\:focus\\:border-blue-750a15:focus{
    border-color: rgba(86,130,170,0.05882);
  }

  .lg\\:focus\\:border-blue-800a60:focus{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .lg\\:focus\\:border-programEditorTabColors-1:focus{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .lg\\:focus\\:border-programEditorTabColors-2:focus{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .lg\\:focus\\:border-programEditorTabColors-3:focus{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .lg\\:focus\\:border-programEditorTabColors-4:focus{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .lg\\:focus\\:border-programEditorTabColors-5:focus{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .lg\\:focus\\:border-programEditorTabColors-6:focus{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .lg\\:focus\\:border-programEditorTabColors-1h:focus{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .lg\\:focus\\:border-programEditorTabColors-2h:focus{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .lg\\:focus\\:border-programEditorTabColors-3h:focus{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .lg\\:focus\\:border-programEditorTabColors-4h:focus{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .lg\\:focus\\:border-programEditorTabColors-5h:focus{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .lg\\:focus\\:border-programEditorTabColors-6h:focus{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .lg\\:focus\\:border-programEditorPresetTabColors-1:focus{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .lg\\:focus\\:border-programEditorPresetTabColors-1h:focus{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .lg\\:focus\\:border-borgScaleColors-0:focus{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .lg\\:focus\\:border-borgScaleColors-1:focus{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .lg\\:focus\\:border-borgScaleColors-2:focus{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .lg\\:focus\\:border-borgScaleColors-3:focus{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .lg\\:focus\\:border-borgScaleColors-4:focus{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .lg\\:focus\\:border-borgScaleColors-5:focus{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .lg\\:focus\\:border-borgScaleColors-6:focus{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .lg\\:focus\\:border-borgScaleColors-7:focus{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .lg\\:focus\\:border-borgScaleColors-8:focus{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .lg\\:focus\\:border-borgScaleColors-9:focus{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .lg\\:focus\\:border-borgScaleColors-10:focus{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .lg\\:border-opacity-0{
    --border-opacity: 0;
  }

  .lg\\:border-opacity-25{
    --border-opacity: .25;
  }

  .lg\\:border-opacity-50{
    --border-opacity: .5;
  }

  .lg\\:border-opacity-75{
    --border-opacity: .75;
  }

  .lg\\:border-opacity-100{
    --border-opacity: 1;
  }

  .lg\\:hover\\:border-opacity-0:hover{
    --border-opacity: 0;
  }

  .lg\\:hover\\:border-opacity-25:hover{
    --border-opacity: .25;
  }

  .lg\\:hover\\:border-opacity-50:hover{
    --border-opacity: .5;
  }

  .lg\\:hover\\:border-opacity-75:hover{
    --border-opacity: .75;
  }

  .lg\\:hover\\:border-opacity-100:hover{
    --border-opacity: 1;
  }

  .lg\\:focus\\:border-opacity-0:focus{
    --border-opacity: 0;
  }

  .lg\\:focus\\:border-opacity-25:focus{
    --border-opacity: .25;
  }

  .lg\\:focus\\:border-opacity-50:focus{
    --border-opacity: .5;
  }

  .lg\\:focus\\:border-opacity-75:focus{
    --border-opacity: .75;
  }

  .lg\\:focus\\:border-opacity-100:focus{
    --border-opacity: 1;
  }

  .lg\\:rounded-none{
    border-radius: 0;
  }

  .lg\\:rounded-sm{
    border-radius: .25rem;
  }

  .lg\\:rounded{
    border-radius: .375rem;
  }

  .lg\\:rounded-lg{
    border-radius: .5rem;
  }

  .lg\\:rounded-xl{
    border-radius: .75rem;
  }

  .lg\\:rounded-full{
    border-radius: 9999px;
  }

  .lg\\:rounded-t-none{
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .lg\\:rounded-r-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .lg\\:rounded-b-none{
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .lg\\:rounded-l-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .lg\\:rounded-t-sm{
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
  }

  .lg\\:rounded-r-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  .lg\\:rounded-b-sm{
    border-bottom-right-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  .lg\\:rounded-l-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  .lg\\:rounded-t{
    border-top-left-radius: .375rem;
    border-top-right-radius: .375rem;
  }

  .lg\\:rounded-r{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  .lg\\:rounded-b{
    border-bottom-right-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  .lg\\:rounded-l{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  .lg\\:rounded-t-lg{
    border-top-left-radius: .5rem;
    border-top-right-radius: .5rem;
  }

  .lg\\:rounded-r-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  .lg\\:rounded-b-lg{
    border-bottom-right-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  .lg\\:rounded-l-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  .lg\\:rounded-t-xl{
    border-top-left-radius: .75rem;
    border-top-right-radius: .75rem;
  }

  .lg\\:rounded-r-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  .lg\\:rounded-b-xl{
    border-bottom-right-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  .lg\\:rounded-l-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  .lg\\:rounded-t-full{
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }

  .lg\\:rounded-r-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  .lg\\:rounded-b-full{
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .lg\\:rounded-l-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .lg\\:rounded-tl-none{
    border-top-left-radius: 0;
  }

  .lg\\:rounded-tr-none{
    border-top-right-radius: 0;
  }

  .lg\\:rounded-br-none{
    border-bottom-right-radius: 0;
  }

  .lg\\:rounded-bl-none{
    border-bottom-left-radius: 0;
  }

  .lg\\:rounded-tl-sm{
    border-top-left-radius: .25rem;
  }

  .lg\\:rounded-tr-sm{
    border-top-right-radius: .25rem;
  }

  .lg\\:rounded-br-sm{
    border-bottom-right-radius: .25rem;
  }

  .lg\\:rounded-bl-sm{
    border-bottom-left-radius: .25rem;
  }

  .lg\\:rounded-tl{
    border-top-left-radius: .375rem;
  }

  .lg\\:rounded-tr{
    border-top-right-radius: .375rem;
  }

  .lg\\:rounded-br{
    border-bottom-right-radius: .375rem;
  }

  .lg\\:rounded-bl{
    border-bottom-left-radius: .375rem;
  }

  .lg\\:rounded-tl-lg{
    border-top-left-radius: .5rem;
  }

  .lg\\:rounded-tr-lg{
    border-top-right-radius: .5rem;
  }

  .lg\\:rounded-br-lg{
    border-bottom-right-radius: .5rem;
  }

  .lg\\:rounded-bl-lg{
    border-bottom-left-radius: .5rem;
  }

  .lg\\:rounded-tl-xl{
    border-top-left-radius: .75rem;
  }

  .lg\\:rounded-tr-xl{
    border-top-right-radius: .75rem;
  }

  .lg\\:rounded-br-xl{
    border-bottom-right-radius: .75rem;
  }

  .lg\\:rounded-bl-xl{
    border-bottom-left-radius: .75rem;
  }

  .lg\\:rounded-tl-full{
    border-top-left-radius: 9999px;
  }

  .lg\\:rounded-tr-full{
    border-top-right-radius: 9999px;
  }

  .lg\\:rounded-br-full{
    border-bottom-right-radius: 9999px;
  }

  .lg\\:rounded-bl-full{
    border-bottom-left-radius: 9999px;
  }

  .lg\\:border-solid{
    border-style: solid;
  }

  .lg\\:border-dashed{
    border-style: dashed;
  }

  .lg\\:border-dotted{
    border-style: dotted;
  }

  .lg\\:border-double{
    border-style: double;
  }

  .lg\\:border-none{
    border-style: none;
  }

  .lg\\:border-0{
    border-width: 0;
  }

  .lg\\:border-2{
    border-width: 2px;
  }

  .lg\\:border-3{
    border-width: 3px;
  }

  .lg\\:border-4{
    border-width: 4px;
  }

  .lg\\:border-5{
    border-width: 5px;
  }

  .lg\\:border-6{
    border-width: 6px;
  }

  .lg\\:border-8{
    border-width: 8px;
  }

  .lg\\:border{
    border-width: 1px;
  }

  .lg\\:border-t-0{
    border-top-width: 0;
  }

  .lg\\:border-r-0{
    border-right-width: 0;
  }

  .lg\\:border-b-0{
    border-bottom-width: 0;
  }

  .lg\\:border-l-0{
    border-left-width: 0;
  }

  .lg\\:border-t-2{
    border-top-width: 2px;
  }

  .lg\\:border-r-2{
    border-right-width: 2px;
  }

  .lg\\:border-b-2{
    border-bottom-width: 2px;
  }

  .lg\\:border-l-2{
    border-left-width: 2px;
  }

  .lg\\:border-t-3{
    border-top-width: 3px;
  }

  .lg\\:border-r-3{
    border-right-width: 3px;
  }

  .lg\\:border-b-3{
    border-bottom-width: 3px;
  }

  .lg\\:border-l-3{
    border-left-width: 3px;
  }

  .lg\\:border-t-4{
    border-top-width: 4px;
  }

  .lg\\:border-r-4{
    border-right-width: 4px;
  }

  .lg\\:border-b-4{
    border-bottom-width: 4px;
  }

  .lg\\:border-l-4{
    border-left-width: 4px;
  }

  .lg\\:border-t-5{
    border-top-width: 5px;
  }

  .lg\\:border-r-5{
    border-right-width: 5px;
  }

  .lg\\:border-b-5{
    border-bottom-width: 5px;
  }

  .lg\\:border-l-5{
    border-left-width: 5px;
  }

  .lg\\:border-t-6{
    border-top-width: 6px;
  }

  .lg\\:border-r-6{
    border-right-width: 6px;
  }

  .lg\\:border-b-6{
    border-bottom-width: 6px;
  }

  .lg\\:border-l-6{
    border-left-width: 6px;
  }

  .lg\\:border-t-8{
    border-top-width: 8px;
  }

  .lg\\:border-r-8{
    border-right-width: 8px;
  }

  .lg\\:border-b-8{
    border-bottom-width: 8px;
  }

  .lg\\:border-l-8{
    border-left-width: 8px;
  }

  .lg\\:border-t{
    border-top-width: 1px;
  }

  .lg\\:border-r{
    border-right-width: 1px;
  }

  .lg\\:border-b{
    border-bottom-width: 1px;
  }

  .lg\\:border-l{
    border-left-width: 1px;
  }

  .lg\\:first\\:border-0:first-child{
    border-width: 0;
  }

  .lg\\:first\\:border-2:first-child{
    border-width: 2px;
  }

  .lg\\:first\\:border-3:first-child{
    border-width: 3px;
  }

  .lg\\:first\\:border-4:first-child{
    border-width: 4px;
  }

  .lg\\:first\\:border-5:first-child{
    border-width: 5px;
  }

  .lg\\:first\\:border-6:first-child{
    border-width: 6px;
  }

  .lg\\:first\\:border-8:first-child{
    border-width: 8px;
  }

  .lg\\:first\\:border:first-child{
    border-width: 1px;
  }

  .lg\\:first\\:border-t-0:first-child{
    border-top-width: 0;
  }

  .lg\\:first\\:border-r-0:first-child{
    border-right-width: 0;
  }

  .lg\\:first\\:border-b-0:first-child{
    border-bottom-width: 0;
  }

  .lg\\:first\\:border-l-0:first-child{
    border-left-width: 0;
  }

  .lg\\:first\\:border-t-2:first-child{
    border-top-width: 2px;
  }

  .lg\\:first\\:border-r-2:first-child{
    border-right-width: 2px;
  }

  .lg\\:first\\:border-b-2:first-child{
    border-bottom-width: 2px;
  }

  .lg\\:first\\:border-l-2:first-child{
    border-left-width: 2px;
  }

  .lg\\:first\\:border-t-3:first-child{
    border-top-width: 3px;
  }

  .lg\\:first\\:border-r-3:first-child{
    border-right-width: 3px;
  }

  .lg\\:first\\:border-b-3:first-child{
    border-bottom-width: 3px;
  }

  .lg\\:first\\:border-l-3:first-child{
    border-left-width: 3px;
  }

  .lg\\:first\\:border-t-4:first-child{
    border-top-width: 4px;
  }

  .lg\\:first\\:border-r-4:first-child{
    border-right-width: 4px;
  }

  .lg\\:first\\:border-b-4:first-child{
    border-bottom-width: 4px;
  }

  .lg\\:first\\:border-l-4:first-child{
    border-left-width: 4px;
  }

  .lg\\:first\\:border-t-5:first-child{
    border-top-width: 5px;
  }

  .lg\\:first\\:border-r-5:first-child{
    border-right-width: 5px;
  }

  .lg\\:first\\:border-b-5:first-child{
    border-bottom-width: 5px;
  }

  .lg\\:first\\:border-l-5:first-child{
    border-left-width: 5px;
  }

  .lg\\:first\\:border-t-6:first-child{
    border-top-width: 6px;
  }

  .lg\\:first\\:border-r-6:first-child{
    border-right-width: 6px;
  }

  .lg\\:first\\:border-b-6:first-child{
    border-bottom-width: 6px;
  }

  .lg\\:first\\:border-l-6:first-child{
    border-left-width: 6px;
  }

  .lg\\:first\\:border-t-8:first-child{
    border-top-width: 8px;
  }

  .lg\\:first\\:border-r-8:first-child{
    border-right-width: 8px;
  }

  .lg\\:first\\:border-b-8:first-child{
    border-bottom-width: 8px;
  }

  .lg\\:first\\:border-l-8:first-child{
    border-left-width: 8px;
  }

  .lg\\:first\\:border-t:first-child{
    border-top-width: 1px;
  }

  .lg\\:first\\:border-r:first-child{
    border-right-width: 1px;
  }

  .lg\\:first\\:border-b:first-child{
    border-bottom-width: 1px;
  }

  .lg\\:first\\:border-l:first-child{
    border-left-width: 1px;
  }

  .lg\\:box-border{
    box-sizing: border-box;
  }

  .lg\\:box-content{
    box-sizing: content-box;
  }

  .lg\\:cursor-auto{
    cursor: auto;
  }

  .lg\\:cursor-default{
    cursor: default;
  }

  .lg\\:cursor-pointer{
    cursor: pointer;
  }

  .lg\\:cursor-wait{
    cursor: wait;
  }

  .lg\\:cursor-move{
    cursor: move;
  }

  .lg\\:cursor-not-allowed{
    cursor: not-allowed;
  }

  .lg\\:block{
    display: block;
  }

  .lg\\:inline-block{
    display: inline-block;
  }

  .lg\\:inline{
    display: inline;
  }

  .lg\\:flex{
    display: flex;
  }

  .lg\\:inline-flex{
    display: inline-flex;
  }

  .lg\\:table{
    display: table;
  }

  .lg\\:table-caption{
    display: table-caption;
  }

  .lg\\:table-cell{
    display: table-cell;
  }

  .lg\\:table-column{
    display: table-column;
  }

  .lg\\:table-column-group{
    display: table-column-group;
  }

  .lg\\:table-footer-group{
    display: table-footer-group;
  }

  .lg\\:table-header-group{
    display: table-header-group;
  }

  .lg\\:table-row-group{
    display: table-row-group;
  }

  .lg\\:table-row{
    display: table-row;
  }

  .lg\\:flow-root{
    display: flow-root;
  }

  .lg\\:grid{
    display: grid;
  }

  .lg\\:inline-grid{
    display: inline-grid;
  }

  .lg\\:contents{
    display: contents;
  }

  .lg\\:hidden{
    display: none;
  }

  .lg\\:flex-row{
    flex-direction: row;
  }

  .lg\\:flex-row-reverse{
    flex-direction: row-reverse;
  }

  .lg\\:flex-col{
    flex-direction: column;
  }

  .lg\\:flex-col-reverse{
    flex-direction: column-reverse;
  }

  .lg\\:flex-wrap{
    flex-wrap: wrap;
  }

  .lg\\:flex-wrap-reverse{
    flex-wrap: wrap-reverse;
  }

  .lg\\:flex-no-wrap{
    flex-wrap: nowrap;
  }

  .lg\\:place-items-auto{
    align-items: auto;
    justify-items: auto;
    place-items: auto;
  }

  .lg\\:place-items-start{
    align-items: start;
    justify-items: start;
    place-items: start;
  }

  .lg\\:place-items-end{
    align-items: end;
    justify-items: end;
    place-items: end;
  }

  .lg\\:place-items-center{
    align-items: center;
    justify-items: center;
    place-items: center;
  }

  .lg\\:place-items-stretch{
    align-items: stretch;
    justify-items: stretch;
    place-items: stretch;
  }

  .lg\\:place-content-center{
    align-content: center;
    justify-content: center;
    place-content: center;
  }

  .lg\\:place-content-start{
    align-content: start;
    justify-content: start;
    place-content: start;
  }

  .lg\\:place-content-end{
    align-content: end;
    justify-content: end;
    place-content: end;
  }

  .lg\\:place-content-between{
    align-content: space-between;
    justify-content: space-between;
    place-content: space-between;
  }

  .lg\\:place-content-around{
    align-content: space-around;
    justify-content: space-around;
    place-content: space-around;
  }

  .lg\\:place-content-evenly{
    align-content: space-evenly;
    justify-content: space-evenly;
    place-content: space-evenly;
  }

  .lg\\:place-content-stretch{
    align-content: stretch;
    justify-content: stretch;
    place-content: stretch;
  }

  .lg\\:place-self-auto{
    align-self: auto;
    justify-self: auto;
    place-self: auto;
  }

  .lg\\:place-self-start{
    align-self: start;
    justify-self: start;
    place-self: start;
  }

  .lg\\:place-self-end{
    align-self: end;
    justify-self: end;
    place-self: end;
  }

  .lg\\:place-self-center{
    align-self: center;
    justify-self: center;
    place-self: center;
  }

  .lg\\:place-self-stretch{
    align-self: stretch;
    justify-self: stretch;
    place-self: stretch;
  }

  .lg\\:items-start{
    align-items: flex-start;
  }

  .lg\\:items-end{
    align-items: flex-end;
  }

  .lg\\:items-center{
    align-items: center;
  }

  .lg\\:items-baseline{
    align-items: baseline;
  }

  .lg\\:items-stretch{
    align-items: stretch;
  }

  .lg\\:content-center{
    align-content: center;
  }

  .lg\\:content-start{
    align-content: flex-start;
  }

  .lg\\:content-end{
    align-content: flex-end;
  }

  .lg\\:content-between{
    align-content: space-between;
  }

  .lg\\:content-around{
    align-content: space-around;
  }

  .lg\\:content-evenly{
    align-content: space-evenly;
  }

  .lg\\:self-auto{
    align-self: auto;
  }

  .lg\\:self-start{
    align-self: flex-start;
  }

  .lg\\:self-end{
    align-self: flex-end;
  }

  .lg\\:self-center{
    align-self: center;
  }

  .lg\\:self-stretch{
    align-self: stretch;
  }

  .lg\\:justify-items-auto{
    justify-items: auto;
  }

  .lg\\:justify-items-start{
    justify-items: start;
  }

  .lg\\:justify-items-end{
    justify-items: end;
  }

  .lg\\:justify-items-center{
    justify-items: center;
  }

  .lg\\:justify-items-stretch{
    justify-items: stretch;
  }

  .lg\\:justify-start{
    justify-content: flex-start;
  }

  .lg\\:justify-end{
    justify-content: flex-end;
  }

  .lg\\:justify-center{
    justify-content: center;
  }

  .lg\\:justify-between{
    justify-content: space-between;
  }

  .lg\\:justify-around{
    justify-content: space-around;
  }

  .lg\\:justify-evenly{
    justify-content: space-evenly;
  }

  .lg\\:justify-self-auto{
    justify-self: auto;
  }

  .lg\\:justify-self-start{
    justify-self: start;
  }

  .lg\\:justify-self-end{
    justify-self: end;
  }

  .lg\\:justify-self-center{
    justify-self: center;
  }

  .lg\\:justify-self-stretch{
    justify-self: stretch;
  }

  .lg\\:flex-1{
    flex: 1 1 0%;
  }

  .lg\\:flex-auto{
    flex: 1 1 auto;
  }

  .lg\\:flex-initial{
    flex: 0 1 auto;
  }

  .lg\\:flex-none{
    flex: none;
  }

  .lg\\:flex-grow-0{
    flex-grow: 0;
  }

  .lg\\:flex-grow{
    flex-grow: 1;
  }

  .lg\\:flex-shrink-0{
    flex-shrink: 0;
  }

  .lg\\:flex-shrink{
    flex-shrink: 1;
  }

  .lg\\:order-1{
    order: 1;
  }

  .lg\\:order-2{
    order: 2;
  }

  .lg\\:order-3{
    order: 3;
  }

  .lg\\:order-4{
    order: 4;
  }

  .lg\\:order-5{
    order: 5;
  }

  .lg\\:order-6{
    order: 6;
  }

  .lg\\:order-7{
    order: 7;
  }

  .lg\\:order-8{
    order: 8;
  }

  .lg\\:order-9{
    order: 9;
  }

  .lg\\:order-10{
    order: 10;
  }

  .lg\\:order-11{
    order: 11;
  }

  .lg\\:order-12{
    order: 12;
  }

  .lg\\:order-first{
    order: -9999;
  }

  .lg\\:order-last{
    order: 9999;
  }

  .lg\\:order-none{
    order: 0;
  }

  .lg\\:float-right{
    float: right;
  }

  .lg\\:float-left{
    float: left;
  }

  .lg\\:float-none{
    float: none;
  }

  .lg\\:clearfix:after{
    content: "";
    display: table;
    clear: both;
  }

  .lg\\:clear-left{
    clear: left;
  }

  .lg\\:clear-right{
    clear: right;
  }

  .lg\\:clear-both{
    clear: both;
  }

  .lg\\:clear-none{
    clear: none;
  }

  .lg\\:font-sans{
    font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }

  .lg\\:font-serif{
    font-family: Georgia, Cambria, "Times New Roman", Times, serif;
  }

  .lg\\:font-mono{
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }

  .lg\\:font-light{
    font-weight: 100;
  }

  .lg\\:font-regular{
    font-weight: 400;
  }

  .lg\\:font-semibold{
    font-weight: 600;
  }

  .lg\\:font-bold{
    font-weight: 700;
  }

  .lg\\:hover\\:font-light:hover{
    font-weight: 100;
  }

  .lg\\:hover\\:font-regular:hover{
    font-weight: 400;
  }

  .lg\\:hover\\:font-semibold:hover{
    font-weight: 600;
  }

  .lg\\:hover\\:font-bold:hover{
    font-weight: 700;
  }

  .lg\\:focus\\:font-light:focus{
    font-weight: 100;
  }

  .lg\\:focus\\:font-regular:focus{
    font-weight: 400;
  }

  .lg\\:focus\\:font-semibold:focus{
    font-weight: 600;
  }

  .lg\\:focus\\:font-bold:focus{
    font-weight: 700;
  }

  .lg\\:h-0{
    height: 0;
  }

  .lg\\:h-1{
    height: 0.25rem;
  }

  .lg\\:h-2{
    height: 0.5rem;
  }

  .lg\\:h-3{
    height: 0.75rem;
  }

  .lg\\:h-4{
    height: 1rem;
  }

  .lg\\:h-5{
    height: 1.25rem;
  }

  .lg\\:h-6{
    height: 1.5rem;
  }

  .lg\\:h-7{
    height: 1.75rem;
  }

  .lg\\:h-8{
    height: 2rem;
  }

  .lg\\:h-9{
    height: 2.25rem;
  }

  .lg\\:h-10{
    height: 2.5rem;
  }

  .lg\\:h-11{
    height: 2.75rem;
  }

  .lg\\:h-12{
    height: 3rem;
  }

  .lg\\:h-14{
    height: 3.5rem;
  }

  .lg\\:h-15{
    height: 3.75rem;
  }

  .lg\\:h-16{
    height: 4rem;
  }

  .lg\\:h-18{
    height: 4.5rem;
  }

  .lg\\:h-20{
    height: 5rem;
  }

  .lg\\:h-22{
    height: 5.5rem;
  }

  .lg\\:h-23{
    height: 5.75rem;
  }

  .lg\\:h-24{
    height: 6rem;
  }

  .lg\\:h-25{
    height: 6.25rem;
  }

  .lg\\:h-26{
    height: 6.5rem;
  }

  .lg\\:h-28{
    height: 7rem;
  }

  .lg\\:h-30{
    height: 7.5rem;
  }

  .lg\\:h-32{
    height: 8rem;
  }

  .lg\\:h-34{
    height: 8.5rem;
  }

  .lg\\:h-40{
    height: 10rem;
  }

  .lg\\:h-42{
    height: 10.5rem;
  }

  .lg\\:h-44{
    height: 11rem;
  }

  .lg\\:h-48{
    height: 12rem;
  }

  .lg\\:h-52{
    height: 13rem;
  }

  .lg\\:h-54{
    height: 13.5rem;
  }

  .lg\\:h-56{
    height: 14rem;
  }

  .lg\\:h-60{
    height: 15rem;
  }

  .lg\\:h-64{
    height: 16rem;
  }

  .lg\\:h-68{
    height: 17rem;
  }

  .lg\\:h-72{
    height: 18rem;
  }

  .lg\\:h-74{
    height: 18.5rem;
  }

  .lg\\:h-76{
    height: 19rem;
  }

  .lg\\:h-78{
    height: 19.5rem;
  }

  .lg\\:h-80{
    height: 20rem;
  }

  .lg\\:h-82{
    height: 20.5rem;
  }

  .lg\\:h-84{
    height: 21rem;
  }

  .lg\\:h-88{
    height: 22rem;
  }

  .lg\\:h-92{
    height: 23rem;
  }

  .lg\\:h-96{
    height: 24rem;
  }

  .lg\\:h-98{
    height: 24.5rem;
  }

  .lg\\:h-100{
    height: 25rem;
  }

  .lg\\:h-104{
    height: 26rem;
  }

  .lg\\:h-112{
    height: 28rem;
  }

  .lg\\:h-124{
    height: 31rem;
  }

  .lg\\:h-128{
    height: 32rem;
  }

  .lg\\:h-140{
    height: 35rem;
  }

  .lg\\:h-152{
    height: 38rem;
  }

  .lg\\:h-160{
    height: 40rem;
  }

  .lg\\:h-162{
    height: 41rem;
  }

  .lg\\:h-192{
    height: 48rem;
  }

  .lg\\:h-208{
    height: 52rem;
  }

  .lg\\:h-224{
    height: 56rem;
  }

  .lg\\:h-256{
    height: 64rem;
  }

  .lg\\:h-auto{
    height: auto;
  }

  .lg\\:h-px{
    height: 1px;
  }

  .lg\\:h-full{
    height: 100%;
  }

  .lg\\:h-screen{
    height: 100vh;
  }

  .lg\\:text-xs{
    font-size: 0.74rem;
  }

  .lg\\:text-sm{
    font-size: 0.86rem;
  }

  .lg\\:text-base{
    font-size: 1rem;
  }

  .lg\\:text-lg{
    font-size: 1.15rem;
  }

  .lg\\:text-xl{
    font-size: 1.42rem;
  }

  .lg\\:text-2xl{
    font-size: 1.85rem;
  }

  .lg\\:text-3xl{
    font-size: 1.95rem;
  }

  .lg\\:text-4xl{
    font-size: 2.25rem;
  }

  .lg\\:text-5xl{
    font-size: 3rem;
  }

  .lg\\:text-6xl{
    font-size: 4rem;
  }

  .lg\\:text-7xl{
    font-size: 5rem;
  }

  .lg\\:leading-none{
    line-height: 1;
  }

  .lg\\:leading-tight{
    line-height: 1.2;
  }

  .lg\\:leading-snug{
    line-height: 1.3;
  }

  .lg\\:leading-normal{
    line-height: 1.4;
  }

  .lg\\:leading-relaxed{
    line-height: 1.6;
  }

  .lg\\:list-inside{
    list-style-position: inside;
  }

  .lg\\:list-outside{
    list-style-position: outside;
  }

  .lg\\:list-none{
    list-style-type: none;
  }

  .lg\\:list-disc{
    list-style-type: disc;
  }

  .lg\\:list-decimal{
    list-style-type: decimal;
  }

  .lg\\:m-0{
    margin: 0;
  }

  .lg\\:m-1{
    margin: 0.25rem;
  }

  .lg\\:m-2{
    margin: 0.5rem;
  }

  .lg\\:m-3{
    margin: 0.75rem;
  }

  .lg\\:m-4{
    margin: 1rem;
  }

  .lg\\:m-5{
    margin: 1.25rem;
  }

  .lg\\:m-6{
    margin: 1.5rem;
  }

  .lg\\:m-7{
    margin: 1.75rem;
  }

  .lg\\:m-8{
    margin: 2rem;
  }

  .lg\\:m-9{
    margin: 2.25rem;
  }

  .lg\\:m-10{
    margin: 2.5rem;
  }

  .lg\\:m-11{
    margin: 2.75rem;
  }

  .lg\\:m-12{
    margin: 3rem;
  }

  .lg\\:m-14{
    margin: 3.5rem;
  }

  .lg\\:m-15{
    margin: 3.75rem;
  }

  .lg\\:m-16{
    margin: 4rem;
  }

  .lg\\:m-18{
    margin: 4.5rem;
  }

  .lg\\:m-20{
    margin: 5rem;
  }

  .lg\\:m-22{
    margin: 5.5rem;
  }

  .lg\\:m-23{
    margin: 5.75rem;
  }

  .lg\\:m-24{
    margin: 6rem;
  }

  .lg\\:m-25{
    margin: 6.25rem;
  }

  .lg\\:m-26{
    margin: 6.5rem;
  }

  .lg\\:m-28{
    margin: 7rem;
  }

  .lg\\:m-30{
    margin: 7.5rem;
  }

  .lg\\:m-32{
    margin: 8rem;
  }

  .lg\\:m-34{
    margin: 8.5rem;
  }

  .lg\\:m-40{
    margin: 10rem;
  }

  .lg\\:m-42{
    margin: 10.5rem;
  }

  .lg\\:m-44{
    margin: 11rem;
  }

  .lg\\:m-48{
    margin: 12rem;
  }

  .lg\\:m-52{
    margin: 13rem;
  }

  .lg\\:m-54{
    margin: 13.5rem;
  }

  .lg\\:m-56{
    margin: 14rem;
  }

  .lg\\:m-60{
    margin: 15rem;
  }

  .lg\\:m-64{
    margin: 16rem;
  }

  .lg\\:m-68{
    margin: 17rem;
  }

  .lg\\:m-72{
    margin: 18rem;
  }

  .lg\\:m-74{
    margin: 18.5rem;
  }

  .lg\\:m-76{
    margin: 19rem;
  }

  .lg\\:m-78{
    margin: 19.5rem;
  }

  .lg\\:m-80{
    margin: 20rem;
  }

  .lg\\:m-82{
    margin: 20.5rem;
  }

  .lg\\:m-84{
    margin: 21rem;
  }

  .lg\\:m-88{
    margin: 22rem;
  }

  .lg\\:m-92{
    margin: 23rem;
  }

  .lg\\:m-96{
    margin: 24rem;
  }

  .lg\\:m-98{
    margin: 24.5rem;
  }

  .lg\\:m-100{
    margin: 25rem;
  }

  .lg\\:m-104{
    margin: 26rem;
  }

  .lg\\:m-112{
    margin: 28rem;
  }

  .lg\\:m-124{
    margin: 31rem;
  }

  .lg\\:m-128{
    margin: 32rem;
  }

  .lg\\:m-140{
    margin: 35rem;
  }

  .lg\\:m-152{
    margin: 38rem;
  }

  .lg\\:m-160{
    margin: 40rem;
  }

  .lg\\:m-162{
    margin: 41rem;
  }

  .lg\\:m-192{
    margin: 48rem;
  }

  .lg\\:m-208{
    margin: 52rem;
  }

  .lg\\:m-224{
    margin: 56rem;
  }

  .lg\\:m-256{
    margin: 64rem;
  }

  .lg\\:m-auto{
    margin: auto;
  }

  .lg\\:m-px{
    margin: 1px;
  }

  .lg\\:-m-1{
    margin: -0.25rem;
  }

  .lg\\:-m-2{
    margin: -0.5rem;
  }

  .lg\\:-m-3{
    margin: -0.75rem;
  }

  .lg\\:-m-4{
    margin: -1rem;
  }

  .lg\\:-m-5{
    margin: -1.25rem;
  }

  .lg\\:-m-6{
    margin: -1.5rem;
  }

  .lg\\:-m-7{
    margin: -1.75rem;
  }

  .lg\\:-m-8{
    margin: -2rem;
  }

  .lg\\:-m-9{
    margin: -2.25rem;
  }

  .lg\\:-m-10{
    margin: -2.5rem;
  }

  .lg\\:-m-11{
    margin: -2.75rem;
  }

  .lg\\:-m-12{
    margin: -3rem;
  }

  .lg\\:-m-14{
    margin: -3.5rem;
  }

  .lg\\:-m-15{
    margin: -3.75rem;
  }

  .lg\\:-m-16{
    margin: -4rem;
  }

  .lg\\:-m-18{
    margin: -4.5rem;
  }

  .lg\\:-m-20{
    margin: -5rem;
  }

  .lg\\:-m-22{
    margin: -5.5rem;
  }

  .lg\\:-m-23{
    margin: -5.75rem;
  }

  .lg\\:-m-24{
    margin: -6rem;
  }

  .lg\\:-m-25{
    margin: -6.25rem;
  }

  .lg\\:-m-26{
    margin: -6.5rem;
  }

  .lg\\:-m-28{
    margin: -7rem;
  }

  .lg\\:-m-30{
    margin: -7.5rem;
  }

  .lg\\:-m-32{
    margin: -8rem;
  }

  .lg\\:-m-34{
    margin: -8.5rem;
  }

  .lg\\:-m-40{
    margin: -10rem;
  }

  .lg\\:-m-42{
    margin: -10.5rem;
  }

  .lg\\:-m-44{
    margin: -11rem;
  }

  .lg\\:-m-48{
    margin: -12rem;
  }

  .lg\\:-m-52{
    margin: -13rem;
  }

  .lg\\:-m-54{
    margin: -13.5rem;
  }

  .lg\\:-m-56{
    margin: -14rem;
  }

  .lg\\:-m-60{
    margin: -15rem;
  }

  .lg\\:-m-64{
    margin: -16rem;
  }

  .lg\\:-m-68{
    margin: -17rem;
  }

  .lg\\:-m-72{
    margin: -18rem;
  }

  .lg\\:-m-74{
    margin: -18.5rem;
  }

  .lg\\:-m-76{
    margin: -19rem;
  }

  .lg\\:-m-78{
    margin: -19.5rem;
  }

  .lg\\:-m-80{
    margin: -20rem;
  }

  .lg\\:-m-82{
    margin: -20.5rem;
  }

  .lg\\:-m-84{
    margin: -21rem;
  }

  .lg\\:-m-88{
    margin: -22rem;
  }

  .lg\\:-m-92{
    margin: -23rem;
  }

  .lg\\:-m-96{
    margin: -24rem;
  }

  .lg\\:-m-98{
    margin: -24.5rem;
  }

  .lg\\:-m-100{
    margin: -25rem;
  }

  .lg\\:-m-104{
    margin: -26rem;
  }

  .lg\\:-m-112{
    margin: -28rem;
  }

  .lg\\:-m-124{
    margin: -31rem;
  }

  .lg\\:-m-128{
    margin: -32rem;
  }

  .lg\\:-m-140{
    margin: -35rem;
  }

  .lg\\:-m-152{
    margin: -38rem;
  }

  .lg\\:-m-160{
    margin: -40rem;
  }

  .lg\\:-m-162{
    margin: -41rem;
  }

  .lg\\:-m-192{
    margin: -48rem;
  }

  .lg\\:-m-208{
    margin: -52rem;
  }

  .lg\\:-m-224{
    margin: -56rem;
  }

  .lg\\:-m-256{
    margin: -64rem;
  }

  .lg\\:-m-px{
    margin: -1px;
  }

  .lg\\:my-0{
    margin-top: 0;
    margin-bottom: 0;
  }

  .lg\\:mx-0{
    margin-left: 0;
    margin-right: 0;
  }

  .lg\\:my-1{
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .lg\\:mx-1{
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .lg\\:my-2{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .lg\\:mx-2{
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .lg\\:my-3{
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .lg\\:mx-3{
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .lg\\:my-4{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .lg\\:mx-4{
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .lg\\:my-5{
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .lg\\:mx-5{
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .lg\\:my-6{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .lg\\:mx-6{
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .lg\\:my-7{
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }

  .lg\\:mx-7{
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }

  .lg\\:my-8{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .lg\\:mx-8{
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .lg\\:my-9{
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }

  .lg\\:mx-9{
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }

  .lg\\:my-10{
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .lg\\:mx-10{
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .lg\\:my-11{
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;
  }

  .lg\\:mx-11{
    margin-left: 2.75rem;
    margin-right: 2.75rem;
  }

  .lg\\:my-12{
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .lg\\:mx-12{
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .lg\\:my-14{
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
  }

  .lg\\:mx-14{
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }

  .lg\\:my-15{
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
  }

  .lg\\:mx-15{
    margin-left: 3.75rem;
    margin-right: 3.75rem;
  }

  .lg\\:my-16{
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .lg\\:mx-16{
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .lg\\:my-18{
    margin-top: 4.5rem;
    margin-bottom: 4.5rem;
  }

  .lg\\:mx-18{
    margin-left: 4.5rem;
    margin-right: 4.5rem;
  }

  .lg\\:my-20{
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .lg\\:mx-20{
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .lg\\:my-22{
    margin-top: 5.5rem;
    margin-bottom: 5.5rem;
  }

  .lg\\:mx-22{
    margin-left: 5.5rem;
    margin-right: 5.5rem;
  }

  .lg\\:my-23{
    margin-top: 5.75rem;
    margin-bottom: 5.75rem;
  }

  .lg\\:mx-23{
    margin-left: 5.75rem;
    margin-right: 5.75rem;
  }

  .lg\\:my-24{
    margin-top: 6rem;
    margin-bottom: 6rem;
  }

  .lg\\:mx-24{
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .lg\\:my-25{
    margin-top: 6.25rem;
    margin-bottom: 6.25rem;
  }

  .lg\\:mx-25{
    margin-left: 6.25rem;
    margin-right: 6.25rem;
  }

  .lg\\:my-26{
    margin-top: 6.5rem;
    margin-bottom: 6.5rem;
  }

  .lg\\:mx-26{
    margin-left: 6.5rem;
    margin-right: 6.5rem;
  }

  .lg\\:my-28{
    margin-top: 7rem;
    margin-bottom: 7rem;
  }

  .lg\\:mx-28{
    margin-left: 7rem;
    margin-right: 7rem;
  }

  .lg\\:my-30{
    margin-top: 7.5rem;
    margin-bottom: 7.5rem;
  }

  .lg\\:mx-30{
    margin-left: 7.5rem;
    margin-right: 7.5rem;
  }

  .lg\\:my-32{
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  .lg\\:mx-32{
    margin-left: 8rem;
    margin-right: 8rem;
  }

  .lg\\:my-34{
    margin-top: 8.5rem;
    margin-bottom: 8.5rem;
  }

  .lg\\:mx-34{
    margin-left: 8.5rem;
    margin-right: 8.5rem;
  }

  .lg\\:my-40{
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .lg\\:mx-40{
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .lg\\:my-42{
    margin-top: 10.5rem;
    margin-bottom: 10.5rem;
  }

  .lg\\:mx-42{
    margin-left: 10.5rem;
    margin-right: 10.5rem;
  }

  .lg\\:my-44{
    margin-top: 11rem;
    margin-bottom: 11rem;
  }

  .lg\\:mx-44{
    margin-left: 11rem;
    margin-right: 11rem;
  }

  .lg\\:my-48{
    margin-top: 12rem;
    margin-bottom: 12rem;
  }

  .lg\\:mx-48{
    margin-left: 12rem;
    margin-right: 12rem;
  }

  .lg\\:my-52{
    margin-top: 13rem;
    margin-bottom: 13rem;
  }

  .lg\\:mx-52{
    margin-left: 13rem;
    margin-right: 13rem;
  }

  .lg\\:my-54{
    margin-top: 13.5rem;
    margin-bottom: 13.5rem;
  }

  .lg\\:mx-54{
    margin-left: 13.5rem;
    margin-right: 13.5rem;
  }

  .lg\\:my-56{
    margin-top: 14rem;
    margin-bottom: 14rem;
  }

  .lg\\:mx-56{
    margin-left: 14rem;
    margin-right: 14rem;
  }

  .lg\\:my-60{
    margin-top: 15rem;
    margin-bottom: 15rem;
  }

  .lg\\:mx-60{
    margin-left: 15rem;
    margin-right: 15rem;
  }

  .lg\\:my-64{
    margin-top: 16rem;
    margin-bottom: 16rem;
  }

  .lg\\:mx-64{
    margin-left: 16rem;
    margin-right: 16rem;
  }

  .lg\\:my-68{
    margin-top: 17rem;
    margin-bottom: 17rem;
  }

  .lg\\:mx-68{
    margin-left: 17rem;
    margin-right: 17rem;
  }

  .lg\\:my-72{
    margin-top: 18rem;
    margin-bottom: 18rem;
  }

  .lg\\:mx-72{
    margin-left: 18rem;
    margin-right: 18rem;
  }

  .lg\\:my-74{
    margin-top: 18.5rem;
    margin-bottom: 18.5rem;
  }

  .lg\\:mx-74{
    margin-left: 18.5rem;
    margin-right: 18.5rem;
  }

  .lg\\:my-76{
    margin-top: 19rem;
    margin-bottom: 19rem;
  }

  .lg\\:mx-76{
    margin-left: 19rem;
    margin-right: 19rem;
  }

  .lg\\:my-78{
    margin-top: 19.5rem;
    margin-bottom: 19.5rem;
  }

  .lg\\:mx-78{
    margin-left: 19.5rem;
    margin-right: 19.5rem;
  }

  .lg\\:my-80{
    margin-top: 20rem;
    margin-bottom: 20rem;
  }

  .lg\\:mx-80{
    margin-left: 20rem;
    margin-right: 20rem;
  }

  .lg\\:my-82{
    margin-top: 20.5rem;
    margin-bottom: 20.5rem;
  }

  .lg\\:mx-82{
    margin-left: 20.5rem;
    margin-right: 20.5rem;
  }

  .lg\\:my-84{
    margin-top: 21rem;
    margin-bottom: 21rem;
  }

  .lg\\:mx-84{
    margin-left: 21rem;
    margin-right: 21rem;
  }

  .lg\\:my-88{
    margin-top: 22rem;
    margin-bottom: 22rem;
  }

  .lg\\:mx-88{
    margin-left: 22rem;
    margin-right: 22rem;
  }

  .lg\\:my-92{
    margin-top: 23rem;
    margin-bottom: 23rem;
  }

  .lg\\:mx-92{
    margin-left: 23rem;
    margin-right: 23rem;
  }

  .lg\\:my-96{
    margin-top: 24rem;
    margin-bottom: 24rem;
  }

  .lg\\:mx-96{
    margin-left: 24rem;
    margin-right: 24rem;
  }

  .lg\\:my-98{
    margin-top: 24.5rem;
    margin-bottom: 24.5rem;
  }

  .lg\\:mx-98{
    margin-left: 24.5rem;
    margin-right: 24.5rem;
  }

  .lg\\:my-100{
    margin-top: 25rem;
    margin-bottom: 25rem;
  }

  .lg\\:mx-100{
    margin-left: 25rem;
    margin-right: 25rem;
  }

  .lg\\:my-104{
    margin-top: 26rem;
    margin-bottom: 26rem;
  }

  .lg\\:mx-104{
    margin-left: 26rem;
    margin-right: 26rem;
  }

  .lg\\:my-112{
    margin-top: 28rem;
    margin-bottom: 28rem;
  }

  .lg\\:mx-112{
    margin-left: 28rem;
    margin-right: 28rem;
  }

  .lg\\:my-124{
    margin-top: 31rem;
    margin-bottom: 31rem;
  }

  .lg\\:mx-124{
    margin-left: 31rem;
    margin-right: 31rem;
  }

  .lg\\:my-128{
    margin-top: 32rem;
    margin-bottom: 32rem;
  }

  .lg\\:mx-128{
    margin-left: 32rem;
    margin-right: 32rem;
  }

  .lg\\:my-140{
    margin-top: 35rem;
    margin-bottom: 35rem;
  }

  .lg\\:mx-140{
    margin-left: 35rem;
    margin-right: 35rem;
  }

  .lg\\:my-152{
    margin-top: 38rem;
    margin-bottom: 38rem;
  }

  .lg\\:mx-152{
    margin-left: 38rem;
    margin-right: 38rem;
  }

  .lg\\:my-160{
    margin-top: 40rem;
    margin-bottom: 40rem;
  }

  .lg\\:mx-160{
    margin-left: 40rem;
    margin-right: 40rem;
  }

  .lg\\:my-162{
    margin-top: 41rem;
    margin-bottom: 41rem;
  }

  .lg\\:mx-162{
    margin-left: 41rem;
    margin-right: 41rem;
  }

  .lg\\:my-192{
    margin-top: 48rem;
    margin-bottom: 48rem;
  }

  .lg\\:mx-192{
    margin-left: 48rem;
    margin-right: 48rem;
  }

  .lg\\:my-208{
    margin-top: 52rem;
    margin-bottom: 52rem;
  }

  .lg\\:mx-208{
    margin-left: 52rem;
    margin-right: 52rem;
  }

  .lg\\:my-224{
    margin-top: 56rem;
    margin-bottom: 56rem;
  }

  .lg\\:mx-224{
    margin-left: 56rem;
    margin-right: 56rem;
  }

  .lg\\:my-256{
    margin-top: 64rem;
    margin-bottom: 64rem;
  }

  .lg\\:mx-256{
    margin-left: 64rem;
    margin-right: 64rem;
  }

  .lg\\:my-auto{
    margin-top: auto;
    margin-bottom: auto;
  }

  .lg\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }

  .lg\\:my-px{
    margin-top: 1px;
    margin-bottom: 1px;
  }

  .lg\\:mx-px{
    margin-left: 1px;
    margin-right: 1px;
  }

  .lg\\:-my-1{
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .lg\\:-mx-1{
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .lg\\:-my-2{
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }

  .lg\\:-mx-2{
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .lg\\:-my-3{
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }

  .lg\\:-mx-3{
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .lg\\:-my-4{
    margin-top: -1rem;
    margin-bottom: -1rem;
  }

  .lg\\:-mx-4{
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .lg\\:-my-5{
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }

  .lg\\:-mx-5{
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .lg\\:-my-6{
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }

  .lg\\:-mx-6{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .lg\\:-my-7{
    margin-top: -1.75rem;
    margin-bottom: -1.75rem;
  }

  .lg\\:-mx-7{
    margin-left: -1.75rem;
    margin-right: -1.75rem;
  }

  .lg\\:-my-8{
    margin-top: -2rem;
    margin-bottom: -2rem;
  }

  .lg\\:-mx-8{
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .lg\\:-my-9{
    margin-top: -2.25rem;
    margin-bottom: -2.25rem;
  }

  .lg\\:-mx-9{
    margin-left: -2.25rem;
    margin-right: -2.25rem;
  }

  .lg\\:-my-10{
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }

  .lg\\:-mx-10{
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .lg\\:-my-11{
    margin-top: -2.75rem;
    margin-bottom: -2.75rem;
  }

  .lg\\:-mx-11{
    margin-left: -2.75rem;
    margin-right: -2.75rem;
  }

  .lg\\:-my-12{
    margin-top: -3rem;
    margin-bottom: -3rem;
  }

  .lg\\:-mx-12{
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .lg\\:-my-14{
    margin-top: -3.5rem;
    margin-bottom: -3.5rem;
  }

  .lg\\:-mx-14{
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }

  .lg\\:-my-15{
    margin-top: -3.75rem;
    margin-bottom: -3.75rem;
  }

  .lg\\:-mx-15{
    margin-left: -3.75rem;
    margin-right: -3.75rem;
  }

  .lg\\:-my-16{
    margin-top: -4rem;
    margin-bottom: -4rem;
  }

  .lg\\:-mx-16{
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .lg\\:-my-18{
    margin-top: -4.5rem;
    margin-bottom: -4.5rem;
  }

  .lg\\:-mx-18{
    margin-left: -4.5rem;
    margin-right: -4.5rem;
  }

  .lg\\:-my-20{
    margin-top: -5rem;
    margin-bottom: -5rem;
  }

  .lg\\:-mx-20{
    margin-left: -5rem;
    margin-right: -5rem;
  }

  .lg\\:-my-22{
    margin-top: -5.5rem;
    margin-bottom: -5.5rem;
  }

  .lg\\:-mx-22{
    margin-left: -5.5rem;
    margin-right: -5.5rem;
  }

  .lg\\:-my-23{
    margin-top: -5.75rem;
    margin-bottom: -5.75rem;
  }

  .lg\\:-mx-23{
    margin-left: -5.75rem;
    margin-right: -5.75rem;
  }

  .lg\\:-my-24{
    margin-top: -6rem;
    margin-bottom: -6rem;
  }

  .lg\\:-mx-24{
    margin-left: -6rem;
    margin-right: -6rem;
  }

  .lg\\:-my-25{
    margin-top: -6.25rem;
    margin-bottom: -6.25rem;
  }

  .lg\\:-mx-25{
    margin-left: -6.25rem;
    margin-right: -6.25rem;
  }

  .lg\\:-my-26{
    margin-top: -6.5rem;
    margin-bottom: -6.5rem;
  }

  .lg\\:-mx-26{
    margin-left: -6.5rem;
    margin-right: -6.5rem;
  }

  .lg\\:-my-28{
    margin-top: -7rem;
    margin-bottom: -7rem;
  }

  .lg\\:-mx-28{
    margin-left: -7rem;
    margin-right: -7rem;
  }

  .lg\\:-my-30{
    margin-top: -7.5rem;
    margin-bottom: -7.5rem;
  }

  .lg\\:-mx-30{
    margin-left: -7.5rem;
    margin-right: -7.5rem;
  }

  .lg\\:-my-32{
    margin-top: -8rem;
    margin-bottom: -8rem;
  }

  .lg\\:-mx-32{
    margin-left: -8rem;
    margin-right: -8rem;
  }

  .lg\\:-my-34{
    margin-top: -8.5rem;
    margin-bottom: -8.5rem;
  }

  .lg\\:-mx-34{
    margin-left: -8.5rem;
    margin-right: -8.5rem;
  }

  .lg\\:-my-40{
    margin-top: -10rem;
    margin-bottom: -10rem;
  }

  .lg\\:-mx-40{
    margin-left: -10rem;
    margin-right: -10rem;
  }

  .lg\\:-my-42{
    margin-top: -10.5rem;
    margin-bottom: -10.5rem;
  }

  .lg\\:-mx-42{
    margin-left: -10.5rem;
    margin-right: -10.5rem;
  }

  .lg\\:-my-44{
    margin-top: -11rem;
    margin-bottom: -11rem;
  }

  .lg\\:-mx-44{
    margin-left: -11rem;
    margin-right: -11rem;
  }

  .lg\\:-my-48{
    margin-top: -12rem;
    margin-bottom: -12rem;
  }

  .lg\\:-mx-48{
    margin-left: -12rem;
    margin-right: -12rem;
  }

  .lg\\:-my-52{
    margin-top: -13rem;
    margin-bottom: -13rem;
  }

  .lg\\:-mx-52{
    margin-left: -13rem;
    margin-right: -13rem;
  }

  .lg\\:-my-54{
    margin-top: -13.5rem;
    margin-bottom: -13.5rem;
  }

  .lg\\:-mx-54{
    margin-left: -13.5rem;
    margin-right: -13.5rem;
  }

  .lg\\:-my-56{
    margin-top: -14rem;
    margin-bottom: -14rem;
  }

  .lg\\:-mx-56{
    margin-left: -14rem;
    margin-right: -14rem;
  }

  .lg\\:-my-60{
    margin-top: -15rem;
    margin-bottom: -15rem;
  }

  .lg\\:-mx-60{
    margin-left: -15rem;
    margin-right: -15rem;
  }

  .lg\\:-my-64{
    margin-top: -16rem;
    margin-bottom: -16rem;
  }

  .lg\\:-mx-64{
    margin-left: -16rem;
    margin-right: -16rem;
  }

  .lg\\:-my-68{
    margin-top: -17rem;
    margin-bottom: -17rem;
  }

  .lg\\:-mx-68{
    margin-left: -17rem;
    margin-right: -17rem;
  }

  .lg\\:-my-72{
    margin-top: -18rem;
    margin-bottom: -18rem;
  }

  .lg\\:-mx-72{
    margin-left: -18rem;
    margin-right: -18rem;
  }

  .lg\\:-my-74{
    margin-top: -18.5rem;
    margin-bottom: -18.5rem;
  }

  .lg\\:-mx-74{
    margin-left: -18.5rem;
    margin-right: -18.5rem;
  }

  .lg\\:-my-76{
    margin-top: -19rem;
    margin-bottom: -19rem;
  }

  .lg\\:-mx-76{
    margin-left: -19rem;
    margin-right: -19rem;
  }

  .lg\\:-my-78{
    margin-top: -19.5rem;
    margin-bottom: -19.5rem;
  }

  .lg\\:-mx-78{
    margin-left: -19.5rem;
    margin-right: -19.5rem;
  }

  .lg\\:-my-80{
    margin-top: -20rem;
    margin-bottom: -20rem;
  }

  .lg\\:-mx-80{
    margin-left: -20rem;
    margin-right: -20rem;
  }

  .lg\\:-my-82{
    margin-top: -20.5rem;
    margin-bottom: -20.5rem;
  }

  .lg\\:-mx-82{
    margin-left: -20.5rem;
    margin-right: -20.5rem;
  }

  .lg\\:-my-84{
    margin-top: -21rem;
    margin-bottom: -21rem;
  }

  .lg\\:-mx-84{
    margin-left: -21rem;
    margin-right: -21rem;
  }

  .lg\\:-my-88{
    margin-top: -22rem;
    margin-bottom: -22rem;
  }

  .lg\\:-mx-88{
    margin-left: -22rem;
    margin-right: -22rem;
  }

  .lg\\:-my-92{
    margin-top: -23rem;
    margin-bottom: -23rem;
  }

  .lg\\:-mx-92{
    margin-left: -23rem;
    margin-right: -23rem;
  }

  .lg\\:-my-96{
    margin-top: -24rem;
    margin-bottom: -24rem;
  }

  .lg\\:-mx-96{
    margin-left: -24rem;
    margin-right: -24rem;
  }

  .lg\\:-my-98{
    margin-top: -24.5rem;
    margin-bottom: -24.5rem;
  }

  .lg\\:-mx-98{
    margin-left: -24.5rem;
    margin-right: -24.5rem;
  }

  .lg\\:-my-100{
    margin-top: -25rem;
    margin-bottom: -25rem;
  }

  .lg\\:-mx-100{
    margin-left: -25rem;
    margin-right: -25rem;
  }

  .lg\\:-my-104{
    margin-top: -26rem;
    margin-bottom: -26rem;
  }

  .lg\\:-mx-104{
    margin-left: -26rem;
    margin-right: -26rem;
  }

  .lg\\:-my-112{
    margin-top: -28rem;
    margin-bottom: -28rem;
  }

  .lg\\:-mx-112{
    margin-left: -28rem;
    margin-right: -28rem;
  }

  .lg\\:-my-124{
    margin-top: -31rem;
    margin-bottom: -31rem;
  }

  .lg\\:-mx-124{
    margin-left: -31rem;
    margin-right: -31rem;
  }

  .lg\\:-my-128{
    margin-top: -32rem;
    margin-bottom: -32rem;
  }

  .lg\\:-mx-128{
    margin-left: -32rem;
    margin-right: -32rem;
  }

  .lg\\:-my-140{
    margin-top: -35rem;
    margin-bottom: -35rem;
  }

  .lg\\:-mx-140{
    margin-left: -35rem;
    margin-right: -35rem;
  }

  .lg\\:-my-152{
    margin-top: -38rem;
    margin-bottom: -38rem;
  }

  .lg\\:-mx-152{
    margin-left: -38rem;
    margin-right: -38rem;
  }

  .lg\\:-my-160{
    margin-top: -40rem;
    margin-bottom: -40rem;
  }

  .lg\\:-mx-160{
    margin-left: -40rem;
    margin-right: -40rem;
  }

  .lg\\:-my-162{
    margin-top: -41rem;
    margin-bottom: -41rem;
  }

  .lg\\:-mx-162{
    margin-left: -41rem;
    margin-right: -41rem;
  }

  .lg\\:-my-192{
    margin-top: -48rem;
    margin-bottom: -48rem;
  }

  .lg\\:-mx-192{
    margin-left: -48rem;
    margin-right: -48rem;
  }

  .lg\\:-my-208{
    margin-top: -52rem;
    margin-bottom: -52rem;
  }

  .lg\\:-mx-208{
    margin-left: -52rem;
    margin-right: -52rem;
  }

  .lg\\:-my-224{
    margin-top: -56rem;
    margin-bottom: -56rem;
  }

  .lg\\:-mx-224{
    margin-left: -56rem;
    margin-right: -56rem;
  }

  .lg\\:-my-256{
    margin-top: -64rem;
    margin-bottom: -64rem;
  }

  .lg\\:-mx-256{
    margin-left: -64rem;
    margin-right: -64rem;
  }

  .lg\\:-my-px{
    margin-top: -1px;
    margin-bottom: -1px;
  }

  .lg\\:-mx-px{
    margin-left: -1px;
    margin-right: -1px;
  }

  .lg\\:mt-0{
    margin-top: 0;
  }

  .lg\\:mr-0{
    margin-right: 0;
  }

  .lg\\:mb-0{
    margin-bottom: 0;
  }

  .lg\\:ml-0{
    margin-left: 0;
  }

  .lg\\:mt-1{
    margin-top: 0.25rem;
  }

  .lg\\:mr-1{
    margin-right: 0.25rem;
  }

  .lg\\:mb-1{
    margin-bottom: 0.25rem;
  }

  .lg\\:ml-1{
    margin-left: 0.25rem;
  }

  .lg\\:mt-2{
    margin-top: 0.5rem;
  }

  .lg\\:mr-2{
    margin-right: 0.5rem;
  }

  .lg\\:mb-2{
    margin-bottom: 0.5rem;
  }

  .lg\\:ml-2{
    margin-left: 0.5rem;
  }

  .lg\\:mt-3{
    margin-top: 0.75rem;
  }

  .lg\\:mr-3{
    margin-right: 0.75rem;
  }

  .lg\\:mb-3{
    margin-bottom: 0.75rem;
  }

  .lg\\:ml-3{
    margin-left: 0.75rem;
  }

  .lg\\:mt-4{
    margin-top: 1rem;
  }

  .lg\\:mr-4{
    margin-right: 1rem;
  }

  .lg\\:mb-4{
    margin-bottom: 1rem;
  }

  .lg\\:ml-4{
    margin-left: 1rem;
  }

  .lg\\:mt-5{
    margin-top: 1.25rem;
  }

  .lg\\:mr-5{
    margin-right: 1.25rem;
  }

  .lg\\:mb-5{
    margin-bottom: 1.25rem;
  }

  .lg\\:ml-5{
    margin-left: 1.25rem;
  }

  .lg\\:mt-6{
    margin-top: 1.5rem;
  }

  .lg\\:mr-6{
    margin-right: 1.5rem;
  }

  .lg\\:mb-6{
    margin-bottom: 1.5rem;
  }

  .lg\\:ml-6{
    margin-left: 1.5rem;
  }

  .lg\\:mt-7{
    margin-top: 1.75rem;
  }

  .lg\\:mr-7{
    margin-right: 1.75rem;
  }

  .lg\\:mb-7{
    margin-bottom: 1.75rem;
  }

  .lg\\:ml-7{
    margin-left: 1.75rem;
  }

  .lg\\:mt-8{
    margin-top: 2rem;
  }

  .lg\\:mr-8{
    margin-right: 2rem;
  }

  .lg\\:mb-8{
    margin-bottom: 2rem;
  }

  .lg\\:ml-8{
    margin-left: 2rem;
  }

  .lg\\:mt-9{
    margin-top: 2.25rem;
  }

  .lg\\:mr-9{
    margin-right: 2.25rem;
  }

  .lg\\:mb-9{
    margin-bottom: 2.25rem;
  }

  .lg\\:ml-9{
    margin-left: 2.25rem;
  }

  .lg\\:mt-10{
    margin-top: 2.5rem;
  }

  .lg\\:mr-10{
    margin-right: 2.5rem;
  }

  .lg\\:mb-10{
    margin-bottom: 2.5rem;
  }

  .lg\\:ml-10{
    margin-left: 2.5rem;
  }

  .lg\\:mt-11{
    margin-top: 2.75rem;
  }

  .lg\\:mr-11{
    margin-right: 2.75rem;
  }

  .lg\\:mb-11{
    margin-bottom: 2.75rem;
  }

  .lg\\:ml-11{
    margin-left: 2.75rem;
  }

  .lg\\:mt-12{
    margin-top: 3rem;
  }

  .lg\\:mr-12{
    margin-right: 3rem;
  }

  .lg\\:mb-12{
    margin-bottom: 3rem;
  }

  .lg\\:ml-12{
    margin-left: 3rem;
  }

  .lg\\:mt-14{
    margin-top: 3.5rem;
  }

  .lg\\:mr-14{
    margin-right: 3.5rem;
  }

  .lg\\:mb-14{
    margin-bottom: 3.5rem;
  }

  .lg\\:ml-14{
    margin-left: 3.5rem;
  }

  .lg\\:mt-15{
    margin-top: 3.75rem;
  }

  .lg\\:mr-15{
    margin-right: 3.75rem;
  }

  .lg\\:mb-15{
    margin-bottom: 3.75rem;
  }

  .lg\\:ml-15{
    margin-left: 3.75rem;
  }

  .lg\\:mt-16{
    margin-top: 4rem;
  }

  .lg\\:mr-16{
    margin-right: 4rem;
  }

  .lg\\:mb-16{
    margin-bottom: 4rem;
  }

  .lg\\:ml-16{
    margin-left: 4rem;
  }

  .lg\\:mt-18{
    margin-top: 4.5rem;
  }

  .lg\\:mr-18{
    margin-right: 4.5rem;
  }

  .lg\\:mb-18{
    margin-bottom: 4.5rem;
  }

  .lg\\:ml-18{
    margin-left: 4.5rem;
  }

  .lg\\:mt-20{
    margin-top: 5rem;
  }

  .lg\\:mr-20{
    margin-right: 5rem;
  }

  .lg\\:mb-20{
    margin-bottom: 5rem;
  }

  .lg\\:ml-20{
    margin-left: 5rem;
  }

  .lg\\:mt-22{
    margin-top: 5.5rem;
  }

  .lg\\:mr-22{
    margin-right: 5.5rem;
  }

  .lg\\:mb-22{
    margin-bottom: 5.5rem;
  }

  .lg\\:ml-22{
    margin-left: 5.5rem;
  }

  .lg\\:mt-23{
    margin-top: 5.75rem;
  }

  .lg\\:mr-23{
    margin-right: 5.75rem;
  }

  .lg\\:mb-23{
    margin-bottom: 5.75rem;
  }

  .lg\\:ml-23{
    margin-left: 5.75rem;
  }

  .lg\\:mt-24{
    margin-top: 6rem;
  }

  .lg\\:mr-24{
    margin-right: 6rem;
  }

  .lg\\:mb-24{
    margin-bottom: 6rem;
  }

  .lg\\:ml-24{
    margin-left: 6rem;
  }

  .lg\\:mt-25{
    margin-top: 6.25rem;
  }

  .lg\\:mr-25{
    margin-right: 6.25rem;
  }

  .lg\\:mb-25{
    margin-bottom: 6.25rem;
  }

  .lg\\:ml-25{
    margin-left: 6.25rem;
  }

  .lg\\:mt-26{
    margin-top: 6.5rem;
  }

  .lg\\:mr-26{
    margin-right: 6.5rem;
  }

  .lg\\:mb-26{
    margin-bottom: 6.5rem;
  }

  .lg\\:ml-26{
    margin-left: 6.5rem;
  }

  .lg\\:mt-28{
    margin-top: 7rem;
  }

  .lg\\:mr-28{
    margin-right: 7rem;
  }

  .lg\\:mb-28{
    margin-bottom: 7rem;
  }

  .lg\\:ml-28{
    margin-left: 7rem;
  }

  .lg\\:mt-30{
    margin-top: 7.5rem;
  }

  .lg\\:mr-30{
    margin-right: 7.5rem;
  }

  .lg\\:mb-30{
    margin-bottom: 7.5rem;
  }

  .lg\\:ml-30{
    margin-left: 7.5rem;
  }

  .lg\\:mt-32{
    margin-top: 8rem;
  }

  .lg\\:mr-32{
    margin-right: 8rem;
  }

  .lg\\:mb-32{
    margin-bottom: 8rem;
  }

  .lg\\:ml-32{
    margin-left: 8rem;
  }

  .lg\\:mt-34{
    margin-top: 8.5rem;
  }

  .lg\\:mr-34{
    margin-right: 8.5rem;
  }

  .lg\\:mb-34{
    margin-bottom: 8.5rem;
  }

  .lg\\:ml-34{
    margin-left: 8.5rem;
  }

  .lg\\:mt-40{
    margin-top: 10rem;
  }

  .lg\\:mr-40{
    margin-right: 10rem;
  }

  .lg\\:mb-40{
    margin-bottom: 10rem;
  }

  .lg\\:ml-40{
    margin-left: 10rem;
  }

  .lg\\:mt-42{
    margin-top: 10.5rem;
  }

  .lg\\:mr-42{
    margin-right: 10.5rem;
  }

  .lg\\:mb-42{
    margin-bottom: 10.5rem;
  }

  .lg\\:ml-42{
    margin-left: 10.5rem;
  }

  .lg\\:mt-44{
    margin-top: 11rem;
  }

  .lg\\:mr-44{
    margin-right: 11rem;
  }

  .lg\\:mb-44{
    margin-bottom: 11rem;
  }

  .lg\\:ml-44{
    margin-left: 11rem;
  }

  .lg\\:mt-48{
    margin-top: 12rem;
  }

  .lg\\:mr-48{
    margin-right: 12rem;
  }

  .lg\\:mb-48{
    margin-bottom: 12rem;
  }

  .lg\\:ml-48{
    margin-left: 12rem;
  }

  .lg\\:mt-52{
    margin-top: 13rem;
  }

  .lg\\:mr-52{
    margin-right: 13rem;
  }

  .lg\\:mb-52{
    margin-bottom: 13rem;
  }

  .lg\\:ml-52{
    margin-left: 13rem;
  }

  .lg\\:mt-54{
    margin-top: 13.5rem;
  }

  .lg\\:mr-54{
    margin-right: 13.5rem;
  }

  .lg\\:mb-54{
    margin-bottom: 13.5rem;
  }

  .lg\\:ml-54{
    margin-left: 13.5rem;
  }

  .lg\\:mt-56{
    margin-top: 14rem;
  }

  .lg\\:mr-56{
    margin-right: 14rem;
  }

  .lg\\:mb-56{
    margin-bottom: 14rem;
  }

  .lg\\:ml-56{
    margin-left: 14rem;
  }

  .lg\\:mt-60{
    margin-top: 15rem;
  }

  .lg\\:mr-60{
    margin-right: 15rem;
  }

  .lg\\:mb-60{
    margin-bottom: 15rem;
  }

  .lg\\:ml-60{
    margin-left: 15rem;
  }

  .lg\\:mt-64{
    margin-top: 16rem;
  }

  .lg\\:mr-64{
    margin-right: 16rem;
  }

  .lg\\:mb-64{
    margin-bottom: 16rem;
  }

  .lg\\:ml-64{
    margin-left: 16rem;
  }

  .lg\\:mt-68{
    margin-top: 17rem;
  }

  .lg\\:mr-68{
    margin-right: 17rem;
  }

  .lg\\:mb-68{
    margin-bottom: 17rem;
  }

  .lg\\:ml-68{
    margin-left: 17rem;
  }

  .lg\\:mt-72{
    margin-top: 18rem;
  }

  .lg\\:mr-72{
    margin-right: 18rem;
  }

  .lg\\:mb-72{
    margin-bottom: 18rem;
  }

  .lg\\:ml-72{
    margin-left: 18rem;
  }

  .lg\\:mt-74{
    margin-top: 18.5rem;
  }

  .lg\\:mr-74{
    margin-right: 18.5rem;
  }

  .lg\\:mb-74{
    margin-bottom: 18.5rem;
  }

  .lg\\:ml-74{
    margin-left: 18.5rem;
  }

  .lg\\:mt-76{
    margin-top: 19rem;
  }

  .lg\\:mr-76{
    margin-right: 19rem;
  }

  .lg\\:mb-76{
    margin-bottom: 19rem;
  }

  .lg\\:ml-76{
    margin-left: 19rem;
  }

  .lg\\:mt-78{
    margin-top: 19.5rem;
  }

  .lg\\:mr-78{
    margin-right: 19.5rem;
  }

  .lg\\:mb-78{
    margin-bottom: 19.5rem;
  }

  .lg\\:ml-78{
    margin-left: 19.5rem;
  }

  .lg\\:mt-80{
    margin-top: 20rem;
  }

  .lg\\:mr-80{
    margin-right: 20rem;
  }

  .lg\\:mb-80{
    margin-bottom: 20rem;
  }

  .lg\\:ml-80{
    margin-left: 20rem;
  }

  .lg\\:mt-82{
    margin-top: 20.5rem;
  }

  .lg\\:mr-82{
    margin-right: 20.5rem;
  }

  .lg\\:mb-82{
    margin-bottom: 20.5rem;
  }

  .lg\\:ml-82{
    margin-left: 20.5rem;
  }

  .lg\\:mt-84{
    margin-top: 21rem;
  }

  .lg\\:mr-84{
    margin-right: 21rem;
  }

  .lg\\:mb-84{
    margin-bottom: 21rem;
  }

  .lg\\:ml-84{
    margin-left: 21rem;
  }

  .lg\\:mt-88{
    margin-top: 22rem;
  }

  .lg\\:mr-88{
    margin-right: 22rem;
  }

  .lg\\:mb-88{
    margin-bottom: 22rem;
  }

  .lg\\:ml-88{
    margin-left: 22rem;
  }

  .lg\\:mt-92{
    margin-top: 23rem;
  }

  .lg\\:mr-92{
    margin-right: 23rem;
  }

  .lg\\:mb-92{
    margin-bottom: 23rem;
  }

  .lg\\:ml-92{
    margin-left: 23rem;
  }

  .lg\\:mt-96{
    margin-top: 24rem;
  }

  .lg\\:mr-96{
    margin-right: 24rem;
  }

  .lg\\:mb-96{
    margin-bottom: 24rem;
  }

  .lg\\:ml-96{
    margin-left: 24rem;
  }

  .lg\\:mt-98{
    margin-top: 24.5rem;
  }

  .lg\\:mr-98{
    margin-right: 24.5rem;
  }

  .lg\\:mb-98{
    margin-bottom: 24.5rem;
  }

  .lg\\:ml-98{
    margin-left: 24.5rem;
  }

  .lg\\:mt-100{
    margin-top: 25rem;
  }

  .lg\\:mr-100{
    margin-right: 25rem;
  }

  .lg\\:mb-100{
    margin-bottom: 25rem;
  }

  .lg\\:ml-100{
    margin-left: 25rem;
  }

  .lg\\:mt-104{
    margin-top: 26rem;
  }

  .lg\\:mr-104{
    margin-right: 26rem;
  }

  .lg\\:mb-104{
    margin-bottom: 26rem;
  }

  .lg\\:ml-104{
    margin-left: 26rem;
  }

  .lg\\:mt-112{
    margin-top: 28rem;
  }

  .lg\\:mr-112{
    margin-right: 28rem;
  }

  .lg\\:mb-112{
    margin-bottom: 28rem;
  }

  .lg\\:ml-112{
    margin-left: 28rem;
  }

  .lg\\:mt-124{
    margin-top: 31rem;
  }

  .lg\\:mr-124{
    margin-right: 31rem;
  }

  .lg\\:mb-124{
    margin-bottom: 31rem;
  }

  .lg\\:ml-124{
    margin-left: 31rem;
  }

  .lg\\:mt-128{
    margin-top: 32rem;
  }

  .lg\\:mr-128{
    margin-right: 32rem;
  }

  .lg\\:mb-128{
    margin-bottom: 32rem;
  }

  .lg\\:ml-128{
    margin-left: 32rem;
  }

  .lg\\:mt-140{
    margin-top: 35rem;
  }

  .lg\\:mr-140{
    margin-right: 35rem;
  }

  .lg\\:mb-140{
    margin-bottom: 35rem;
  }

  .lg\\:ml-140{
    margin-left: 35rem;
  }

  .lg\\:mt-152{
    margin-top: 38rem;
  }

  .lg\\:mr-152{
    margin-right: 38rem;
  }

  .lg\\:mb-152{
    margin-bottom: 38rem;
  }

  .lg\\:ml-152{
    margin-left: 38rem;
  }

  .lg\\:mt-160{
    margin-top: 40rem;
  }

  .lg\\:mr-160{
    margin-right: 40rem;
  }

  .lg\\:mb-160{
    margin-bottom: 40rem;
  }

  .lg\\:ml-160{
    margin-left: 40rem;
  }

  .lg\\:mt-162{
    margin-top: 41rem;
  }

  .lg\\:mr-162{
    margin-right: 41rem;
  }

  .lg\\:mb-162{
    margin-bottom: 41rem;
  }

  .lg\\:ml-162{
    margin-left: 41rem;
  }

  .lg\\:mt-192{
    margin-top: 48rem;
  }

  .lg\\:mr-192{
    margin-right: 48rem;
  }

  .lg\\:mb-192{
    margin-bottom: 48rem;
  }

  .lg\\:ml-192{
    margin-left: 48rem;
  }

  .lg\\:mt-208{
    margin-top: 52rem;
  }

  .lg\\:mr-208{
    margin-right: 52rem;
  }

  .lg\\:mb-208{
    margin-bottom: 52rem;
  }

  .lg\\:ml-208{
    margin-left: 52rem;
  }

  .lg\\:mt-224{
    margin-top: 56rem;
  }

  .lg\\:mr-224{
    margin-right: 56rem;
  }

  .lg\\:mb-224{
    margin-bottom: 56rem;
  }

  .lg\\:ml-224{
    margin-left: 56rem;
  }

  .lg\\:mt-256{
    margin-top: 64rem;
  }

  .lg\\:mr-256{
    margin-right: 64rem;
  }

  .lg\\:mb-256{
    margin-bottom: 64rem;
  }

  .lg\\:ml-256{
    margin-left: 64rem;
  }

  .lg\\:mt-auto{
    margin-top: auto;
  }

  .lg\\:mr-auto{
    margin-right: auto;
  }

  .lg\\:mb-auto{
    margin-bottom: auto;
  }

  .lg\\:ml-auto{
    margin-left: auto;
  }

  .lg\\:mt-px{
    margin-top: 1px;
  }

  .lg\\:mr-px{
    margin-right: 1px;
  }

  .lg\\:mb-px{
    margin-bottom: 1px;
  }

  .lg\\:ml-px{
    margin-left: 1px;
  }

  .lg\\:-mt-1{
    margin-top: -0.25rem;
  }

  .lg\\:-mr-1{
    margin-right: -0.25rem;
  }

  .lg\\:-mb-1{
    margin-bottom: -0.25rem;
  }

  .lg\\:-ml-1{
    margin-left: -0.25rem;
  }

  .lg\\:-mt-2{
    margin-top: -0.5rem;
  }

  .lg\\:-mr-2{
    margin-right: -0.5rem;
  }

  .lg\\:-mb-2{
    margin-bottom: -0.5rem;
  }

  .lg\\:-ml-2{
    margin-left: -0.5rem;
  }

  .lg\\:-mt-3{
    margin-top: -0.75rem;
  }

  .lg\\:-mr-3{
    margin-right: -0.75rem;
  }

  .lg\\:-mb-3{
    margin-bottom: -0.75rem;
  }

  .lg\\:-ml-3{
    margin-left: -0.75rem;
  }

  .lg\\:-mt-4{
    margin-top: -1rem;
  }

  .lg\\:-mr-4{
    margin-right: -1rem;
  }

  .lg\\:-mb-4{
    margin-bottom: -1rem;
  }

  .lg\\:-ml-4{
    margin-left: -1rem;
  }

  .lg\\:-mt-5{
    margin-top: -1.25rem;
  }

  .lg\\:-mr-5{
    margin-right: -1.25rem;
  }

  .lg\\:-mb-5{
    margin-bottom: -1.25rem;
  }

  .lg\\:-ml-5{
    margin-left: -1.25rem;
  }

  .lg\\:-mt-6{
    margin-top: -1.5rem;
  }

  .lg\\:-mr-6{
    margin-right: -1.5rem;
  }

  .lg\\:-mb-6{
    margin-bottom: -1.5rem;
  }

  .lg\\:-ml-6{
    margin-left: -1.5rem;
  }

  .lg\\:-mt-7{
    margin-top: -1.75rem;
  }

  .lg\\:-mr-7{
    margin-right: -1.75rem;
  }

  .lg\\:-mb-7{
    margin-bottom: -1.75rem;
  }

  .lg\\:-ml-7{
    margin-left: -1.75rem;
  }

  .lg\\:-mt-8{
    margin-top: -2rem;
  }

  .lg\\:-mr-8{
    margin-right: -2rem;
  }

  .lg\\:-mb-8{
    margin-bottom: -2rem;
  }

  .lg\\:-ml-8{
    margin-left: -2rem;
  }

  .lg\\:-mt-9{
    margin-top: -2.25rem;
  }

  .lg\\:-mr-9{
    margin-right: -2.25rem;
  }

  .lg\\:-mb-9{
    margin-bottom: -2.25rem;
  }

  .lg\\:-ml-9{
    margin-left: -2.25rem;
  }

  .lg\\:-mt-10{
    margin-top: -2.5rem;
  }

  .lg\\:-mr-10{
    margin-right: -2.5rem;
  }

  .lg\\:-mb-10{
    margin-bottom: -2.5rem;
  }

  .lg\\:-ml-10{
    margin-left: -2.5rem;
  }

  .lg\\:-mt-11{
    margin-top: -2.75rem;
  }

  .lg\\:-mr-11{
    margin-right: -2.75rem;
  }

  .lg\\:-mb-11{
    margin-bottom: -2.75rem;
  }

  .lg\\:-ml-11{
    margin-left: -2.75rem;
  }

  .lg\\:-mt-12{
    margin-top: -3rem;
  }

  .lg\\:-mr-12{
    margin-right: -3rem;
  }

  .lg\\:-mb-12{
    margin-bottom: -3rem;
  }

  .lg\\:-ml-12{
    margin-left: -3rem;
  }

  .lg\\:-mt-14{
    margin-top: -3.5rem;
  }

  .lg\\:-mr-14{
    margin-right: -3.5rem;
  }

  .lg\\:-mb-14{
    margin-bottom: -3.5rem;
  }

  .lg\\:-ml-14{
    margin-left: -3.5rem;
  }

  .lg\\:-mt-15{
    margin-top: -3.75rem;
  }

  .lg\\:-mr-15{
    margin-right: -3.75rem;
  }

  .lg\\:-mb-15{
    margin-bottom: -3.75rem;
  }

  .lg\\:-ml-15{
    margin-left: -3.75rem;
  }

  .lg\\:-mt-16{
    margin-top: -4rem;
  }

  .lg\\:-mr-16{
    margin-right: -4rem;
  }

  .lg\\:-mb-16{
    margin-bottom: -4rem;
  }

  .lg\\:-ml-16{
    margin-left: -4rem;
  }

  .lg\\:-mt-18{
    margin-top: -4.5rem;
  }

  .lg\\:-mr-18{
    margin-right: -4.5rem;
  }

  .lg\\:-mb-18{
    margin-bottom: -4.5rem;
  }

  .lg\\:-ml-18{
    margin-left: -4.5rem;
  }

  .lg\\:-mt-20{
    margin-top: -5rem;
  }

  .lg\\:-mr-20{
    margin-right: -5rem;
  }

  .lg\\:-mb-20{
    margin-bottom: -5rem;
  }

  .lg\\:-ml-20{
    margin-left: -5rem;
  }

  .lg\\:-mt-22{
    margin-top: -5.5rem;
  }

  .lg\\:-mr-22{
    margin-right: -5.5rem;
  }

  .lg\\:-mb-22{
    margin-bottom: -5.5rem;
  }

  .lg\\:-ml-22{
    margin-left: -5.5rem;
  }

  .lg\\:-mt-23{
    margin-top: -5.75rem;
  }

  .lg\\:-mr-23{
    margin-right: -5.75rem;
  }

  .lg\\:-mb-23{
    margin-bottom: -5.75rem;
  }

  .lg\\:-ml-23{
    margin-left: -5.75rem;
  }

  .lg\\:-mt-24{
    margin-top: -6rem;
  }

  .lg\\:-mr-24{
    margin-right: -6rem;
  }

  .lg\\:-mb-24{
    margin-bottom: -6rem;
  }

  .lg\\:-ml-24{
    margin-left: -6rem;
  }

  .lg\\:-mt-25{
    margin-top: -6.25rem;
  }

  .lg\\:-mr-25{
    margin-right: -6.25rem;
  }

  .lg\\:-mb-25{
    margin-bottom: -6.25rem;
  }

  .lg\\:-ml-25{
    margin-left: -6.25rem;
  }

  .lg\\:-mt-26{
    margin-top: -6.5rem;
  }

  .lg\\:-mr-26{
    margin-right: -6.5rem;
  }

  .lg\\:-mb-26{
    margin-bottom: -6.5rem;
  }

  .lg\\:-ml-26{
    margin-left: -6.5rem;
  }

  .lg\\:-mt-28{
    margin-top: -7rem;
  }

  .lg\\:-mr-28{
    margin-right: -7rem;
  }

  .lg\\:-mb-28{
    margin-bottom: -7rem;
  }

  .lg\\:-ml-28{
    margin-left: -7rem;
  }

  .lg\\:-mt-30{
    margin-top: -7.5rem;
  }

  .lg\\:-mr-30{
    margin-right: -7.5rem;
  }

  .lg\\:-mb-30{
    margin-bottom: -7.5rem;
  }

  .lg\\:-ml-30{
    margin-left: -7.5rem;
  }

  .lg\\:-mt-32{
    margin-top: -8rem;
  }

  .lg\\:-mr-32{
    margin-right: -8rem;
  }

  .lg\\:-mb-32{
    margin-bottom: -8rem;
  }

  .lg\\:-ml-32{
    margin-left: -8rem;
  }

  .lg\\:-mt-34{
    margin-top: -8.5rem;
  }

  .lg\\:-mr-34{
    margin-right: -8.5rem;
  }

  .lg\\:-mb-34{
    margin-bottom: -8.5rem;
  }

  .lg\\:-ml-34{
    margin-left: -8.5rem;
  }

  .lg\\:-mt-40{
    margin-top: -10rem;
  }

  .lg\\:-mr-40{
    margin-right: -10rem;
  }

  .lg\\:-mb-40{
    margin-bottom: -10rem;
  }

  .lg\\:-ml-40{
    margin-left: -10rem;
  }

  .lg\\:-mt-42{
    margin-top: -10.5rem;
  }

  .lg\\:-mr-42{
    margin-right: -10.5rem;
  }

  .lg\\:-mb-42{
    margin-bottom: -10.5rem;
  }

  .lg\\:-ml-42{
    margin-left: -10.5rem;
  }

  .lg\\:-mt-44{
    margin-top: -11rem;
  }

  .lg\\:-mr-44{
    margin-right: -11rem;
  }

  .lg\\:-mb-44{
    margin-bottom: -11rem;
  }

  .lg\\:-ml-44{
    margin-left: -11rem;
  }

  .lg\\:-mt-48{
    margin-top: -12rem;
  }

  .lg\\:-mr-48{
    margin-right: -12rem;
  }

  .lg\\:-mb-48{
    margin-bottom: -12rem;
  }

  .lg\\:-ml-48{
    margin-left: -12rem;
  }

  .lg\\:-mt-52{
    margin-top: -13rem;
  }

  .lg\\:-mr-52{
    margin-right: -13rem;
  }

  .lg\\:-mb-52{
    margin-bottom: -13rem;
  }

  .lg\\:-ml-52{
    margin-left: -13rem;
  }

  .lg\\:-mt-54{
    margin-top: -13.5rem;
  }

  .lg\\:-mr-54{
    margin-right: -13.5rem;
  }

  .lg\\:-mb-54{
    margin-bottom: -13.5rem;
  }

  .lg\\:-ml-54{
    margin-left: -13.5rem;
  }

  .lg\\:-mt-56{
    margin-top: -14rem;
  }

  .lg\\:-mr-56{
    margin-right: -14rem;
  }

  .lg\\:-mb-56{
    margin-bottom: -14rem;
  }

  .lg\\:-ml-56{
    margin-left: -14rem;
  }

  .lg\\:-mt-60{
    margin-top: -15rem;
  }

  .lg\\:-mr-60{
    margin-right: -15rem;
  }

  .lg\\:-mb-60{
    margin-bottom: -15rem;
  }

  .lg\\:-ml-60{
    margin-left: -15rem;
  }

  .lg\\:-mt-64{
    margin-top: -16rem;
  }

  .lg\\:-mr-64{
    margin-right: -16rem;
  }

  .lg\\:-mb-64{
    margin-bottom: -16rem;
  }

  .lg\\:-ml-64{
    margin-left: -16rem;
  }

  .lg\\:-mt-68{
    margin-top: -17rem;
  }

  .lg\\:-mr-68{
    margin-right: -17rem;
  }

  .lg\\:-mb-68{
    margin-bottom: -17rem;
  }

  .lg\\:-ml-68{
    margin-left: -17rem;
  }

  .lg\\:-mt-72{
    margin-top: -18rem;
  }

  .lg\\:-mr-72{
    margin-right: -18rem;
  }

  .lg\\:-mb-72{
    margin-bottom: -18rem;
  }

  .lg\\:-ml-72{
    margin-left: -18rem;
  }

  .lg\\:-mt-74{
    margin-top: -18.5rem;
  }

  .lg\\:-mr-74{
    margin-right: -18.5rem;
  }

  .lg\\:-mb-74{
    margin-bottom: -18.5rem;
  }

  .lg\\:-ml-74{
    margin-left: -18.5rem;
  }

  .lg\\:-mt-76{
    margin-top: -19rem;
  }

  .lg\\:-mr-76{
    margin-right: -19rem;
  }

  .lg\\:-mb-76{
    margin-bottom: -19rem;
  }

  .lg\\:-ml-76{
    margin-left: -19rem;
  }

  .lg\\:-mt-78{
    margin-top: -19.5rem;
  }

  .lg\\:-mr-78{
    margin-right: -19.5rem;
  }

  .lg\\:-mb-78{
    margin-bottom: -19.5rem;
  }

  .lg\\:-ml-78{
    margin-left: -19.5rem;
  }

  .lg\\:-mt-80{
    margin-top: -20rem;
  }

  .lg\\:-mr-80{
    margin-right: -20rem;
  }

  .lg\\:-mb-80{
    margin-bottom: -20rem;
  }

  .lg\\:-ml-80{
    margin-left: -20rem;
  }

  .lg\\:-mt-82{
    margin-top: -20.5rem;
  }

  .lg\\:-mr-82{
    margin-right: -20.5rem;
  }

  .lg\\:-mb-82{
    margin-bottom: -20.5rem;
  }

  .lg\\:-ml-82{
    margin-left: -20.5rem;
  }

  .lg\\:-mt-84{
    margin-top: -21rem;
  }

  .lg\\:-mr-84{
    margin-right: -21rem;
  }

  .lg\\:-mb-84{
    margin-bottom: -21rem;
  }

  .lg\\:-ml-84{
    margin-left: -21rem;
  }

  .lg\\:-mt-88{
    margin-top: -22rem;
  }

  .lg\\:-mr-88{
    margin-right: -22rem;
  }

  .lg\\:-mb-88{
    margin-bottom: -22rem;
  }

  .lg\\:-ml-88{
    margin-left: -22rem;
  }

  .lg\\:-mt-92{
    margin-top: -23rem;
  }

  .lg\\:-mr-92{
    margin-right: -23rem;
  }

  .lg\\:-mb-92{
    margin-bottom: -23rem;
  }

  .lg\\:-ml-92{
    margin-left: -23rem;
  }

  .lg\\:-mt-96{
    margin-top: -24rem;
  }

  .lg\\:-mr-96{
    margin-right: -24rem;
  }

  .lg\\:-mb-96{
    margin-bottom: -24rem;
  }

  .lg\\:-ml-96{
    margin-left: -24rem;
  }

  .lg\\:-mt-98{
    margin-top: -24.5rem;
  }

  .lg\\:-mr-98{
    margin-right: -24.5rem;
  }

  .lg\\:-mb-98{
    margin-bottom: -24.5rem;
  }

  .lg\\:-ml-98{
    margin-left: -24.5rem;
  }

  .lg\\:-mt-100{
    margin-top: -25rem;
  }

  .lg\\:-mr-100{
    margin-right: -25rem;
  }

  .lg\\:-mb-100{
    margin-bottom: -25rem;
  }

  .lg\\:-ml-100{
    margin-left: -25rem;
  }

  .lg\\:-mt-104{
    margin-top: -26rem;
  }

  .lg\\:-mr-104{
    margin-right: -26rem;
  }

  .lg\\:-mb-104{
    margin-bottom: -26rem;
  }

  .lg\\:-ml-104{
    margin-left: -26rem;
  }

  .lg\\:-mt-112{
    margin-top: -28rem;
  }

  .lg\\:-mr-112{
    margin-right: -28rem;
  }

  .lg\\:-mb-112{
    margin-bottom: -28rem;
  }

  .lg\\:-ml-112{
    margin-left: -28rem;
  }

  .lg\\:-mt-124{
    margin-top: -31rem;
  }

  .lg\\:-mr-124{
    margin-right: -31rem;
  }

  .lg\\:-mb-124{
    margin-bottom: -31rem;
  }

  .lg\\:-ml-124{
    margin-left: -31rem;
  }

  .lg\\:-mt-128{
    margin-top: -32rem;
  }

  .lg\\:-mr-128{
    margin-right: -32rem;
  }

  .lg\\:-mb-128{
    margin-bottom: -32rem;
  }

  .lg\\:-ml-128{
    margin-left: -32rem;
  }

  .lg\\:-mt-140{
    margin-top: -35rem;
  }

  .lg\\:-mr-140{
    margin-right: -35rem;
  }

  .lg\\:-mb-140{
    margin-bottom: -35rem;
  }

  .lg\\:-ml-140{
    margin-left: -35rem;
  }

  .lg\\:-mt-152{
    margin-top: -38rem;
  }

  .lg\\:-mr-152{
    margin-right: -38rem;
  }

  .lg\\:-mb-152{
    margin-bottom: -38rem;
  }

  .lg\\:-ml-152{
    margin-left: -38rem;
  }

  .lg\\:-mt-160{
    margin-top: -40rem;
  }

  .lg\\:-mr-160{
    margin-right: -40rem;
  }

  .lg\\:-mb-160{
    margin-bottom: -40rem;
  }

  .lg\\:-ml-160{
    margin-left: -40rem;
  }

  .lg\\:-mt-162{
    margin-top: -41rem;
  }

  .lg\\:-mr-162{
    margin-right: -41rem;
  }

  .lg\\:-mb-162{
    margin-bottom: -41rem;
  }

  .lg\\:-ml-162{
    margin-left: -41rem;
  }

  .lg\\:-mt-192{
    margin-top: -48rem;
  }

  .lg\\:-mr-192{
    margin-right: -48rem;
  }

  .lg\\:-mb-192{
    margin-bottom: -48rem;
  }

  .lg\\:-ml-192{
    margin-left: -48rem;
  }

  .lg\\:-mt-208{
    margin-top: -52rem;
  }

  .lg\\:-mr-208{
    margin-right: -52rem;
  }

  .lg\\:-mb-208{
    margin-bottom: -52rem;
  }

  .lg\\:-ml-208{
    margin-left: -52rem;
  }

  .lg\\:-mt-224{
    margin-top: -56rem;
  }

  .lg\\:-mr-224{
    margin-right: -56rem;
  }

  .lg\\:-mb-224{
    margin-bottom: -56rem;
  }

  .lg\\:-ml-224{
    margin-left: -56rem;
  }

  .lg\\:-mt-256{
    margin-top: -64rem;
  }

  .lg\\:-mr-256{
    margin-right: -64rem;
  }

  .lg\\:-mb-256{
    margin-bottom: -64rem;
  }

  .lg\\:-ml-256{
    margin-left: -64rem;
  }

  .lg\\:-mt-px{
    margin-top: -1px;
  }

  .lg\\:-mr-px{
    margin-right: -1px;
  }

  .lg\\:-mb-px{
    margin-bottom: -1px;
  }

  .lg\\:-ml-px{
    margin-left: -1px;
  }

  .lg\\:first\\:m-0:first-child{
    margin: 0;
  }

  .lg\\:first\\:m-1:first-child{
    margin: 0.25rem;
  }

  .lg\\:first\\:m-2:first-child{
    margin: 0.5rem;
  }

  .lg\\:first\\:m-3:first-child{
    margin: 0.75rem;
  }

  .lg\\:first\\:m-4:first-child{
    margin: 1rem;
  }

  .lg\\:first\\:m-5:first-child{
    margin: 1.25rem;
  }

  .lg\\:first\\:m-6:first-child{
    margin: 1.5rem;
  }

  .lg\\:first\\:m-7:first-child{
    margin: 1.75rem;
  }

  .lg\\:first\\:m-8:first-child{
    margin: 2rem;
  }

  .lg\\:first\\:m-9:first-child{
    margin: 2.25rem;
  }

  .lg\\:first\\:m-10:first-child{
    margin: 2.5rem;
  }

  .lg\\:first\\:m-11:first-child{
    margin: 2.75rem;
  }

  .lg\\:first\\:m-12:first-child{
    margin: 3rem;
  }

  .lg\\:first\\:m-14:first-child{
    margin: 3.5rem;
  }

  .lg\\:first\\:m-15:first-child{
    margin: 3.75rem;
  }

  .lg\\:first\\:m-16:first-child{
    margin: 4rem;
  }

  .lg\\:first\\:m-18:first-child{
    margin: 4.5rem;
  }

  .lg\\:first\\:m-20:first-child{
    margin: 5rem;
  }

  .lg\\:first\\:m-22:first-child{
    margin: 5.5rem;
  }

  .lg\\:first\\:m-23:first-child{
    margin: 5.75rem;
  }

  .lg\\:first\\:m-24:first-child{
    margin: 6rem;
  }

  .lg\\:first\\:m-25:first-child{
    margin: 6.25rem;
  }

  .lg\\:first\\:m-26:first-child{
    margin: 6.5rem;
  }

  .lg\\:first\\:m-28:first-child{
    margin: 7rem;
  }

  .lg\\:first\\:m-30:first-child{
    margin: 7.5rem;
  }

  .lg\\:first\\:m-32:first-child{
    margin: 8rem;
  }

  .lg\\:first\\:m-34:first-child{
    margin: 8.5rem;
  }

  .lg\\:first\\:m-40:first-child{
    margin: 10rem;
  }

  .lg\\:first\\:m-42:first-child{
    margin: 10.5rem;
  }

  .lg\\:first\\:m-44:first-child{
    margin: 11rem;
  }

  .lg\\:first\\:m-48:first-child{
    margin: 12rem;
  }

  .lg\\:first\\:m-52:first-child{
    margin: 13rem;
  }

  .lg\\:first\\:m-54:first-child{
    margin: 13.5rem;
  }

  .lg\\:first\\:m-56:first-child{
    margin: 14rem;
  }

  .lg\\:first\\:m-60:first-child{
    margin: 15rem;
  }

  .lg\\:first\\:m-64:first-child{
    margin: 16rem;
  }

  .lg\\:first\\:m-68:first-child{
    margin: 17rem;
  }

  .lg\\:first\\:m-72:first-child{
    margin: 18rem;
  }

  .lg\\:first\\:m-74:first-child{
    margin: 18.5rem;
  }

  .lg\\:first\\:m-76:first-child{
    margin: 19rem;
  }

  .lg\\:first\\:m-78:first-child{
    margin: 19.5rem;
  }

  .lg\\:first\\:m-80:first-child{
    margin: 20rem;
  }

  .lg\\:first\\:m-82:first-child{
    margin: 20.5rem;
  }

  .lg\\:first\\:m-84:first-child{
    margin: 21rem;
  }

  .lg\\:first\\:m-88:first-child{
    margin: 22rem;
  }

  .lg\\:first\\:m-92:first-child{
    margin: 23rem;
  }

  .lg\\:first\\:m-96:first-child{
    margin: 24rem;
  }

  .lg\\:first\\:m-98:first-child{
    margin: 24.5rem;
  }

  .lg\\:first\\:m-100:first-child{
    margin: 25rem;
  }

  .lg\\:first\\:m-104:first-child{
    margin: 26rem;
  }

  .lg\\:first\\:m-112:first-child{
    margin: 28rem;
  }

  .lg\\:first\\:m-124:first-child{
    margin: 31rem;
  }

  .lg\\:first\\:m-128:first-child{
    margin: 32rem;
  }

  .lg\\:first\\:m-140:first-child{
    margin: 35rem;
  }

  .lg\\:first\\:m-152:first-child{
    margin: 38rem;
  }

  .lg\\:first\\:m-160:first-child{
    margin: 40rem;
  }

  .lg\\:first\\:m-162:first-child{
    margin: 41rem;
  }

  .lg\\:first\\:m-192:first-child{
    margin: 48rem;
  }

  .lg\\:first\\:m-208:first-child{
    margin: 52rem;
  }

  .lg\\:first\\:m-224:first-child{
    margin: 56rem;
  }

  .lg\\:first\\:m-256:first-child{
    margin: 64rem;
  }

  .lg\\:first\\:m-auto:first-child{
    margin: auto;
  }

  .lg\\:first\\:m-px:first-child{
    margin: 1px;
  }

  .lg\\:first\\:-m-1:first-child{
    margin: -0.25rem;
  }

  .lg\\:first\\:-m-2:first-child{
    margin: -0.5rem;
  }

  .lg\\:first\\:-m-3:first-child{
    margin: -0.75rem;
  }

  .lg\\:first\\:-m-4:first-child{
    margin: -1rem;
  }

  .lg\\:first\\:-m-5:first-child{
    margin: -1.25rem;
  }

  .lg\\:first\\:-m-6:first-child{
    margin: -1.5rem;
  }

  .lg\\:first\\:-m-7:first-child{
    margin: -1.75rem;
  }

  .lg\\:first\\:-m-8:first-child{
    margin: -2rem;
  }

  .lg\\:first\\:-m-9:first-child{
    margin: -2.25rem;
  }

  .lg\\:first\\:-m-10:first-child{
    margin: -2.5rem;
  }

  .lg\\:first\\:-m-11:first-child{
    margin: -2.75rem;
  }

  .lg\\:first\\:-m-12:first-child{
    margin: -3rem;
  }

  .lg\\:first\\:-m-14:first-child{
    margin: -3.5rem;
  }

  .lg\\:first\\:-m-15:first-child{
    margin: -3.75rem;
  }

  .lg\\:first\\:-m-16:first-child{
    margin: -4rem;
  }

  .lg\\:first\\:-m-18:first-child{
    margin: -4.5rem;
  }

  .lg\\:first\\:-m-20:first-child{
    margin: -5rem;
  }

  .lg\\:first\\:-m-22:first-child{
    margin: -5.5rem;
  }

  .lg\\:first\\:-m-23:first-child{
    margin: -5.75rem;
  }

  .lg\\:first\\:-m-24:first-child{
    margin: -6rem;
  }

  .lg\\:first\\:-m-25:first-child{
    margin: -6.25rem;
  }

  .lg\\:first\\:-m-26:first-child{
    margin: -6.5rem;
  }

  .lg\\:first\\:-m-28:first-child{
    margin: -7rem;
  }

  .lg\\:first\\:-m-30:first-child{
    margin: -7.5rem;
  }

  .lg\\:first\\:-m-32:first-child{
    margin: -8rem;
  }

  .lg\\:first\\:-m-34:first-child{
    margin: -8.5rem;
  }

  .lg\\:first\\:-m-40:first-child{
    margin: -10rem;
  }

  .lg\\:first\\:-m-42:first-child{
    margin: -10.5rem;
  }

  .lg\\:first\\:-m-44:first-child{
    margin: -11rem;
  }

  .lg\\:first\\:-m-48:first-child{
    margin: -12rem;
  }

  .lg\\:first\\:-m-52:first-child{
    margin: -13rem;
  }

  .lg\\:first\\:-m-54:first-child{
    margin: -13.5rem;
  }

  .lg\\:first\\:-m-56:first-child{
    margin: -14rem;
  }

  .lg\\:first\\:-m-60:first-child{
    margin: -15rem;
  }

  .lg\\:first\\:-m-64:first-child{
    margin: -16rem;
  }

  .lg\\:first\\:-m-68:first-child{
    margin: -17rem;
  }

  .lg\\:first\\:-m-72:first-child{
    margin: -18rem;
  }

  .lg\\:first\\:-m-74:first-child{
    margin: -18.5rem;
  }

  .lg\\:first\\:-m-76:first-child{
    margin: -19rem;
  }

  .lg\\:first\\:-m-78:first-child{
    margin: -19.5rem;
  }

  .lg\\:first\\:-m-80:first-child{
    margin: -20rem;
  }

  .lg\\:first\\:-m-82:first-child{
    margin: -20.5rem;
  }

  .lg\\:first\\:-m-84:first-child{
    margin: -21rem;
  }

  .lg\\:first\\:-m-88:first-child{
    margin: -22rem;
  }

  .lg\\:first\\:-m-92:first-child{
    margin: -23rem;
  }

  .lg\\:first\\:-m-96:first-child{
    margin: -24rem;
  }

  .lg\\:first\\:-m-98:first-child{
    margin: -24.5rem;
  }

  .lg\\:first\\:-m-100:first-child{
    margin: -25rem;
  }

  .lg\\:first\\:-m-104:first-child{
    margin: -26rem;
  }

  .lg\\:first\\:-m-112:first-child{
    margin: -28rem;
  }

  .lg\\:first\\:-m-124:first-child{
    margin: -31rem;
  }

  .lg\\:first\\:-m-128:first-child{
    margin: -32rem;
  }

  .lg\\:first\\:-m-140:first-child{
    margin: -35rem;
  }

  .lg\\:first\\:-m-152:first-child{
    margin: -38rem;
  }

  .lg\\:first\\:-m-160:first-child{
    margin: -40rem;
  }

  .lg\\:first\\:-m-162:first-child{
    margin: -41rem;
  }

  .lg\\:first\\:-m-192:first-child{
    margin: -48rem;
  }

  .lg\\:first\\:-m-208:first-child{
    margin: -52rem;
  }

  .lg\\:first\\:-m-224:first-child{
    margin: -56rem;
  }

  .lg\\:first\\:-m-256:first-child{
    margin: -64rem;
  }

  .lg\\:first\\:-m-px:first-child{
    margin: -1px;
  }

  .lg\\:first\\:my-0:first-child{
    margin-top: 0;
    margin-bottom: 0;
  }

  .lg\\:first\\:mx-0:first-child{
    margin-left: 0;
    margin-right: 0;
  }

  .lg\\:first\\:my-1:first-child{
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .lg\\:first\\:mx-1:first-child{
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .lg\\:first\\:my-2:first-child{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .lg\\:first\\:mx-2:first-child{
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .lg\\:first\\:my-3:first-child{
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .lg\\:first\\:mx-3:first-child{
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .lg\\:first\\:my-4:first-child{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .lg\\:first\\:mx-4:first-child{
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .lg\\:first\\:my-5:first-child{
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .lg\\:first\\:mx-5:first-child{
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .lg\\:first\\:my-6:first-child{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .lg\\:first\\:mx-6:first-child{
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .lg\\:first\\:my-7:first-child{
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }

  .lg\\:first\\:mx-7:first-child{
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }

  .lg\\:first\\:my-8:first-child{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .lg\\:first\\:mx-8:first-child{
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .lg\\:first\\:my-9:first-child{
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }

  .lg\\:first\\:mx-9:first-child{
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }

  .lg\\:first\\:my-10:first-child{
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .lg\\:first\\:mx-10:first-child{
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .lg\\:first\\:my-11:first-child{
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;
  }

  .lg\\:first\\:mx-11:first-child{
    margin-left: 2.75rem;
    margin-right: 2.75rem;
  }

  .lg\\:first\\:my-12:first-child{
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .lg\\:first\\:mx-12:first-child{
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .lg\\:first\\:my-14:first-child{
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
  }

  .lg\\:first\\:mx-14:first-child{
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }

  .lg\\:first\\:my-15:first-child{
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
  }

  .lg\\:first\\:mx-15:first-child{
    margin-left: 3.75rem;
    margin-right: 3.75rem;
  }

  .lg\\:first\\:my-16:first-child{
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .lg\\:first\\:mx-16:first-child{
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .lg\\:first\\:my-18:first-child{
    margin-top: 4.5rem;
    margin-bottom: 4.5rem;
  }

  .lg\\:first\\:mx-18:first-child{
    margin-left: 4.5rem;
    margin-right: 4.5rem;
  }

  .lg\\:first\\:my-20:first-child{
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .lg\\:first\\:mx-20:first-child{
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .lg\\:first\\:my-22:first-child{
    margin-top: 5.5rem;
    margin-bottom: 5.5rem;
  }

  .lg\\:first\\:mx-22:first-child{
    margin-left: 5.5rem;
    margin-right: 5.5rem;
  }

  .lg\\:first\\:my-23:first-child{
    margin-top: 5.75rem;
    margin-bottom: 5.75rem;
  }

  .lg\\:first\\:mx-23:first-child{
    margin-left: 5.75rem;
    margin-right: 5.75rem;
  }

  .lg\\:first\\:my-24:first-child{
    margin-top: 6rem;
    margin-bottom: 6rem;
  }

  .lg\\:first\\:mx-24:first-child{
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .lg\\:first\\:my-25:first-child{
    margin-top: 6.25rem;
    margin-bottom: 6.25rem;
  }

  .lg\\:first\\:mx-25:first-child{
    margin-left: 6.25rem;
    margin-right: 6.25rem;
  }

  .lg\\:first\\:my-26:first-child{
    margin-top: 6.5rem;
    margin-bottom: 6.5rem;
  }

  .lg\\:first\\:mx-26:first-child{
    margin-left: 6.5rem;
    margin-right: 6.5rem;
  }

  .lg\\:first\\:my-28:first-child{
    margin-top: 7rem;
    margin-bottom: 7rem;
  }

  .lg\\:first\\:mx-28:first-child{
    margin-left: 7rem;
    margin-right: 7rem;
  }

  .lg\\:first\\:my-30:first-child{
    margin-top: 7.5rem;
    margin-bottom: 7.5rem;
  }

  .lg\\:first\\:mx-30:first-child{
    margin-left: 7.5rem;
    margin-right: 7.5rem;
  }

  .lg\\:first\\:my-32:first-child{
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  .lg\\:first\\:mx-32:first-child{
    margin-left: 8rem;
    margin-right: 8rem;
  }

  .lg\\:first\\:my-34:first-child{
    margin-top: 8.5rem;
    margin-bottom: 8.5rem;
  }

  .lg\\:first\\:mx-34:first-child{
    margin-left: 8.5rem;
    margin-right: 8.5rem;
  }

  .lg\\:first\\:my-40:first-child{
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .lg\\:first\\:mx-40:first-child{
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .lg\\:first\\:my-42:first-child{
    margin-top: 10.5rem;
    margin-bottom: 10.5rem;
  }

  .lg\\:first\\:mx-42:first-child{
    margin-left: 10.5rem;
    margin-right: 10.5rem;
  }

  .lg\\:first\\:my-44:first-child{
    margin-top: 11rem;
    margin-bottom: 11rem;
  }

  .lg\\:first\\:mx-44:first-child{
    margin-left: 11rem;
    margin-right: 11rem;
  }

  .lg\\:first\\:my-48:first-child{
    margin-top: 12rem;
    margin-bottom: 12rem;
  }

  .lg\\:first\\:mx-48:first-child{
    margin-left: 12rem;
    margin-right: 12rem;
  }

  .lg\\:first\\:my-52:first-child{
    margin-top: 13rem;
    margin-bottom: 13rem;
  }

  .lg\\:first\\:mx-52:first-child{
    margin-left: 13rem;
    margin-right: 13rem;
  }

  .lg\\:first\\:my-54:first-child{
    margin-top: 13.5rem;
    margin-bottom: 13.5rem;
  }

  .lg\\:first\\:mx-54:first-child{
    margin-left: 13.5rem;
    margin-right: 13.5rem;
  }

  .lg\\:first\\:my-56:first-child{
    margin-top: 14rem;
    margin-bottom: 14rem;
  }

  .lg\\:first\\:mx-56:first-child{
    margin-left: 14rem;
    margin-right: 14rem;
  }

  .lg\\:first\\:my-60:first-child{
    margin-top: 15rem;
    margin-bottom: 15rem;
  }

  .lg\\:first\\:mx-60:first-child{
    margin-left: 15rem;
    margin-right: 15rem;
  }

  .lg\\:first\\:my-64:first-child{
    margin-top: 16rem;
    margin-bottom: 16rem;
  }

  .lg\\:first\\:mx-64:first-child{
    margin-left: 16rem;
    margin-right: 16rem;
  }

  .lg\\:first\\:my-68:first-child{
    margin-top: 17rem;
    margin-bottom: 17rem;
  }

  .lg\\:first\\:mx-68:first-child{
    margin-left: 17rem;
    margin-right: 17rem;
  }

  .lg\\:first\\:my-72:first-child{
    margin-top: 18rem;
    margin-bottom: 18rem;
  }

  .lg\\:first\\:mx-72:first-child{
    margin-left: 18rem;
    margin-right: 18rem;
  }

  .lg\\:first\\:my-74:first-child{
    margin-top: 18.5rem;
    margin-bottom: 18.5rem;
  }

  .lg\\:first\\:mx-74:first-child{
    margin-left: 18.5rem;
    margin-right: 18.5rem;
  }

  .lg\\:first\\:my-76:first-child{
    margin-top: 19rem;
    margin-bottom: 19rem;
  }

  .lg\\:first\\:mx-76:first-child{
    margin-left: 19rem;
    margin-right: 19rem;
  }

  .lg\\:first\\:my-78:first-child{
    margin-top: 19.5rem;
    margin-bottom: 19.5rem;
  }

  .lg\\:first\\:mx-78:first-child{
    margin-left: 19.5rem;
    margin-right: 19.5rem;
  }

  .lg\\:first\\:my-80:first-child{
    margin-top: 20rem;
    margin-bottom: 20rem;
  }

  .lg\\:first\\:mx-80:first-child{
    margin-left: 20rem;
    margin-right: 20rem;
  }

  .lg\\:first\\:my-82:first-child{
    margin-top: 20.5rem;
    margin-bottom: 20.5rem;
  }

  .lg\\:first\\:mx-82:first-child{
    margin-left: 20.5rem;
    margin-right: 20.5rem;
  }

  .lg\\:first\\:my-84:first-child{
    margin-top: 21rem;
    margin-bottom: 21rem;
  }

  .lg\\:first\\:mx-84:first-child{
    margin-left: 21rem;
    margin-right: 21rem;
  }

  .lg\\:first\\:my-88:first-child{
    margin-top: 22rem;
    margin-bottom: 22rem;
  }

  .lg\\:first\\:mx-88:first-child{
    margin-left: 22rem;
    margin-right: 22rem;
  }

  .lg\\:first\\:my-92:first-child{
    margin-top: 23rem;
    margin-bottom: 23rem;
  }

  .lg\\:first\\:mx-92:first-child{
    margin-left: 23rem;
    margin-right: 23rem;
  }

  .lg\\:first\\:my-96:first-child{
    margin-top: 24rem;
    margin-bottom: 24rem;
  }

  .lg\\:first\\:mx-96:first-child{
    margin-left: 24rem;
    margin-right: 24rem;
  }

  .lg\\:first\\:my-98:first-child{
    margin-top: 24.5rem;
    margin-bottom: 24.5rem;
  }

  .lg\\:first\\:mx-98:first-child{
    margin-left: 24.5rem;
    margin-right: 24.5rem;
  }

  .lg\\:first\\:my-100:first-child{
    margin-top: 25rem;
    margin-bottom: 25rem;
  }

  .lg\\:first\\:mx-100:first-child{
    margin-left: 25rem;
    margin-right: 25rem;
  }

  .lg\\:first\\:my-104:first-child{
    margin-top: 26rem;
    margin-bottom: 26rem;
  }

  .lg\\:first\\:mx-104:first-child{
    margin-left: 26rem;
    margin-right: 26rem;
  }

  .lg\\:first\\:my-112:first-child{
    margin-top: 28rem;
    margin-bottom: 28rem;
  }

  .lg\\:first\\:mx-112:first-child{
    margin-left: 28rem;
    margin-right: 28rem;
  }

  .lg\\:first\\:my-124:first-child{
    margin-top: 31rem;
    margin-bottom: 31rem;
  }

  .lg\\:first\\:mx-124:first-child{
    margin-left: 31rem;
    margin-right: 31rem;
  }

  .lg\\:first\\:my-128:first-child{
    margin-top: 32rem;
    margin-bottom: 32rem;
  }

  .lg\\:first\\:mx-128:first-child{
    margin-left: 32rem;
    margin-right: 32rem;
  }

  .lg\\:first\\:my-140:first-child{
    margin-top: 35rem;
    margin-bottom: 35rem;
  }

  .lg\\:first\\:mx-140:first-child{
    margin-left: 35rem;
    margin-right: 35rem;
  }

  .lg\\:first\\:my-152:first-child{
    margin-top: 38rem;
    margin-bottom: 38rem;
  }

  .lg\\:first\\:mx-152:first-child{
    margin-left: 38rem;
    margin-right: 38rem;
  }

  .lg\\:first\\:my-160:first-child{
    margin-top: 40rem;
    margin-bottom: 40rem;
  }

  .lg\\:first\\:mx-160:first-child{
    margin-left: 40rem;
    margin-right: 40rem;
  }

  .lg\\:first\\:my-162:first-child{
    margin-top: 41rem;
    margin-bottom: 41rem;
  }

  .lg\\:first\\:mx-162:first-child{
    margin-left: 41rem;
    margin-right: 41rem;
  }

  .lg\\:first\\:my-192:first-child{
    margin-top: 48rem;
    margin-bottom: 48rem;
  }

  .lg\\:first\\:mx-192:first-child{
    margin-left: 48rem;
    margin-right: 48rem;
  }

  .lg\\:first\\:my-208:first-child{
    margin-top: 52rem;
    margin-bottom: 52rem;
  }

  .lg\\:first\\:mx-208:first-child{
    margin-left: 52rem;
    margin-right: 52rem;
  }

  .lg\\:first\\:my-224:first-child{
    margin-top: 56rem;
    margin-bottom: 56rem;
  }

  .lg\\:first\\:mx-224:first-child{
    margin-left: 56rem;
    margin-right: 56rem;
  }

  .lg\\:first\\:my-256:first-child{
    margin-top: 64rem;
    margin-bottom: 64rem;
  }

  .lg\\:first\\:mx-256:first-child{
    margin-left: 64rem;
    margin-right: 64rem;
  }

  .lg\\:first\\:my-auto:first-child{
    margin-top: auto;
    margin-bottom: auto;
  }

  .lg\\:first\\:mx-auto:first-child{
    margin-left: auto;
    margin-right: auto;
  }

  .lg\\:first\\:my-px:first-child{
    margin-top: 1px;
    margin-bottom: 1px;
  }

  .lg\\:first\\:mx-px:first-child{
    margin-left: 1px;
    margin-right: 1px;
  }

  .lg\\:first\\:-my-1:first-child{
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .lg\\:first\\:-mx-1:first-child{
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .lg\\:first\\:-my-2:first-child{
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }

  .lg\\:first\\:-mx-2:first-child{
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .lg\\:first\\:-my-3:first-child{
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }

  .lg\\:first\\:-mx-3:first-child{
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .lg\\:first\\:-my-4:first-child{
    margin-top: -1rem;
    margin-bottom: -1rem;
  }

  .lg\\:first\\:-mx-4:first-child{
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .lg\\:first\\:-my-5:first-child{
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }

  .lg\\:first\\:-mx-5:first-child{
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .lg\\:first\\:-my-6:first-child{
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }

  .lg\\:first\\:-mx-6:first-child{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .lg\\:first\\:-my-7:first-child{
    margin-top: -1.75rem;
    margin-bottom: -1.75rem;
  }

  .lg\\:first\\:-mx-7:first-child{
    margin-left: -1.75rem;
    margin-right: -1.75rem;
  }

  .lg\\:first\\:-my-8:first-child{
    margin-top: -2rem;
    margin-bottom: -2rem;
  }

  .lg\\:first\\:-mx-8:first-child{
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .lg\\:first\\:-my-9:first-child{
    margin-top: -2.25rem;
    margin-bottom: -2.25rem;
  }

  .lg\\:first\\:-mx-9:first-child{
    margin-left: -2.25rem;
    margin-right: -2.25rem;
  }

  .lg\\:first\\:-my-10:first-child{
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }

  .lg\\:first\\:-mx-10:first-child{
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .lg\\:first\\:-my-11:first-child{
    margin-top: -2.75rem;
    margin-bottom: -2.75rem;
  }

  .lg\\:first\\:-mx-11:first-child{
    margin-left: -2.75rem;
    margin-right: -2.75rem;
  }

  .lg\\:first\\:-my-12:first-child{
    margin-top: -3rem;
    margin-bottom: -3rem;
  }

  .lg\\:first\\:-mx-12:first-child{
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .lg\\:first\\:-my-14:first-child{
    margin-top: -3.5rem;
    margin-bottom: -3.5rem;
  }

  .lg\\:first\\:-mx-14:first-child{
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }

  .lg\\:first\\:-my-15:first-child{
    margin-top: -3.75rem;
    margin-bottom: -3.75rem;
  }

  .lg\\:first\\:-mx-15:first-child{
    margin-left: -3.75rem;
    margin-right: -3.75rem;
  }

  .lg\\:first\\:-my-16:first-child{
    margin-top: -4rem;
    margin-bottom: -4rem;
  }

  .lg\\:first\\:-mx-16:first-child{
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .lg\\:first\\:-my-18:first-child{
    margin-top: -4.5rem;
    margin-bottom: -4.5rem;
  }

  .lg\\:first\\:-mx-18:first-child{
    margin-left: -4.5rem;
    margin-right: -4.5rem;
  }

  .lg\\:first\\:-my-20:first-child{
    margin-top: -5rem;
    margin-bottom: -5rem;
  }

  .lg\\:first\\:-mx-20:first-child{
    margin-left: -5rem;
    margin-right: -5rem;
  }

  .lg\\:first\\:-my-22:first-child{
    margin-top: -5.5rem;
    margin-bottom: -5.5rem;
  }

  .lg\\:first\\:-mx-22:first-child{
    margin-left: -5.5rem;
    margin-right: -5.5rem;
  }

  .lg\\:first\\:-my-23:first-child{
    margin-top: -5.75rem;
    margin-bottom: -5.75rem;
  }

  .lg\\:first\\:-mx-23:first-child{
    margin-left: -5.75rem;
    margin-right: -5.75rem;
  }

  .lg\\:first\\:-my-24:first-child{
    margin-top: -6rem;
    margin-bottom: -6rem;
  }

  .lg\\:first\\:-mx-24:first-child{
    margin-left: -6rem;
    margin-right: -6rem;
  }

  .lg\\:first\\:-my-25:first-child{
    margin-top: -6.25rem;
    margin-bottom: -6.25rem;
  }

  .lg\\:first\\:-mx-25:first-child{
    margin-left: -6.25rem;
    margin-right: -6.25rem;
  }

  .lg\\:first\\:-my-26:first-child{
    margin-top: -6.5rem;
    margin-bottom: -6.5rem;
  }

  .lg\\:first\\:-mx-26:first-child{
    margin-left: -6.5rem;
    margin-right: -6.5rem;
  }

  .lg\\:first\\:-my-28:first-child{
    margin-top: -7rem;
    margin-bottom: -7rem;
  }

  .lg\\:first\\:-mx-28:first-child{
    margin-left: -7rem;
    margin-right: -7rem;
  }

  .lg\\:first\\:-my-30:first-child{
    margin-top: -7.5rem;
    margin-bottom: -7.5rem;
  }

  .lg\\:first\\:-mx-30:first-child{
    margin-left: -7.5rem;
    margin-right: -7.5rem;
  }

  .lg\\:first\\:-my-32:first-child{
    margin-top: -8rem;
    margin-bottom: -8rem;
  }

  .lg\\:first\\:-mx-32:first-child{
    margin-left: -8rem;
    margin-right: -8rem;
  }

  .lg\\:first\\:-my-34:first-child{
    margin-top: -8.5rem;
    margin-bottom: -8.5rem;
  }

  .lg\\:first\\:-mx-34:first-child{
    margin-left: -8.5rem;
    margin-right: -8.5rem;
  }

  .lg\\:first\\:-my-40:first-child{
    margin-top: -10rem;
    margin-bottom: -10rem;
  }

  .lg\\:first\\:-mx-40:first-child{
    margin-left: -10rem;
    margin-right: -10rem;
  }

  .lg\\:first\\:-my-42:first-child{
    margin-top: -10.5rem;
    margin-bottom: -10.5rem;
  }

  .lg\\:first\\:-mx-42:first-child{
    margin-left: -10.5rem;
    margin-right: -10.5rem;
  }

  .lg\\:first\\:-my-44:first-child{
    margin-top: -11rem;
    margin-bottom: -11rem;
  }

  .lg\\:first\\:-mx-44:first-child{
    margin-left: -11rem;
    margin-right: -11rem;
  }

  .lg\\:first\\:-my-48:first-child{
    margin-top: -12rem;
    margin-bottom: -12rem;
  }

  .lg\\:first\\:-mx-48:first-child{
    margin-left: -12rem;
    margin-right: -12rem;
  }

  .lg\\:first\\:-my-52:first-child{
    margin-top: -13rem;
    margin-bottom: -13rem;
  }

  .lg\\:first\\:-mx-52:first-child{
    margin-left: -13rem;
    margin-right: -13rem;
  }

  .lg\\:first\\:-my-54:first-child{
    margin-top: -13.5rem;
    margin-bottom: -13.5rem;
  }

  .lg\\:first\\:-mx-54:first-child{
    margin-left: -13.5rem;
    margin-right: -13.5rem;
  }

  .lg\\:first\\:-my-56:first-child{
    margin-top: -14rem;
    margin-bottom: -14rem;
  }

  .lg\\:first\\:-mx-56:first-child{
    margin-left: -14rem;
    margin-right: -14rem;
  }

  .lg\\:first\\:-my-60:first-child{
    margin-top: -15rem;
    margin-bottom: -15rem;
  }

  .lg\\:first\\:-mx-60:first-child{
    margin-left: -15rem;
    margin-right: -15rem;
  }

  .lg\\:first\\:-my-64:first-child{
    margin-top: -16rem;
    margin-bottom: -16rem;
  }

  .lg\\:first\\:-mx-64:first-child{
    margin-left: -16rem;
    margin-right: -16rem;
  }

  .lg\\:first\\:-my-68:first-child{
    margin-top: -17rem;
    margin-bottom: -17rem;
  }

  .lg\\:first\\:-mx-68:first-child{
    margin-left: -17rem;
    margin-right: -17rem;
  }

  .lg\\:first\\:-my-72:first-child{
    margin-top: -18rem;
    margin-bottom: -18rem;
  }

  .lg\\:first\\:-mx-72:first-child{
    margin-left: -18rem;
    margin-right: -18rem;
  }

  .lg\\:first\\:-my-74:first-child{
    margin-top: -18.5rem;
    margin-bottom: -18.5rem;
  }

  .lg\\:first\\:-mx-74:first-child{
    margin-left: -18.5rem;
    margin-right: -18.5rem;
  }

  .lg\\:first\\:-my-76:first-child{
    margin-top: -19rem;
    margin-bottom: -19rem;
  }

  .lg\\:first\\:-mx-76:first-child{
    margin-left: -19rem;
    margin-right: -19rem;
  }

  .lg\\:first\\:-my-78:first-child{
    margin-top: -19.5rem;
    margin-bottom: -19.5rem;
  }

  .lg\\:first\\:-mx-78:first-child{
    margin-left: -19.5rem;
    margin-right: -19.5rem;
  }

  .lg\\:first\\:-my-80:first-child{
    margin-top: -20rem;
    margin-bottom: -20rem;
  }

  .lg\\:first\\:-mx-80:first-child{
    margin-left: -20rem;
    margin-right: -20rem;
  }

  .lg\\:first\\:-my-82:first-child{
    margin-top: -20.5rem;
    margin-bottom: -20.5rem;
  }

  .lg\\:first\\:-mx-82:first-child{
    margin-left: -20.5rem;
    margin-right: -20.5rem;
  }

  .lg\\:first\\:-my-84:first-child{
    margin-top: -21rem;
    margin-bottom: -21rem;
  }

  .lg\\:first\\:-mx-84:first-child{
    margin-left: -21rem;
    margin-right: -21rem;
  }

  .lg\\:first\\:-my-88:first-child{
    margin-top: -22rem;
    margin-bottom: -22rem;
  }

  .lg\\:first\\:-mx-88:first-child{
    margin-left: -22rem;
    margin-right: -22rem;
  }

  .lg\\:first\\:-my-92:first-child{
    margin-top: -23rem;
    margin-bottom: -23rem;
  }

  .lg\\:first\\:-mx-92:first-child{
    margin-left: -23rem;
    margin-right: -23rem;
  }

  .lg\\:first\\:-my-96:first-child{
    margin-top: -24rem;
    margin-bottom: -24rem;
  }

  .lg\\:first\\:-mx-96:first-child{
    margin-left: -24rem;
    margin-right: -24rem;
  }

  .lg\\:first\\:-my-98:first-child{
    margin-top: -24.5rem;
    margin-bottom: -24.5rem;
  }

  .lg\\:first\\:-mx-98:first-child{
    margin-left: -24.5rem;
    margin-right: -24.5rem;
  }

  .lg\\:first\\:-my-100:first-child{
    margin-top: -25rem;
    margin-bottom: -25rem;
  }

  .lg\\:first\\:-mx-100:first-child{
    margin-left: -25rem;
    margin-right: -25rem;
  }

  .lg\\:first\\:-my-104:first-child{
    margin-top: -26rem;
    margin-bottom: -26rem;
  }

  .lg\\:first\\:-mx-104:first-child{
    margin-left: -26rem;
    margin-right: -26rem;
  }

  .lg\\:first\\:-my-112:first-child{
    margin-top: -28rem;
    margin-bottom: -28rem;
  }

  .lg\\:first\\:-mx-112:first-child{
    margin-left: -28rem;
    margin-right: -28rem;
  }

  .lg\\:first\\:-my-124:first-child{
    margin-top: -31rem;
    margin-bottom: -31rem;
  }

  .lg\\:first\\:-mx-124:first-child{
    margin-left: -31rem;
    margin-right: -31rem;
  }

  .lg\\:first\\:-my-128:first-child{
    margin-top: -32rem;
    margin-bottom: -32rem;
  }

  .lg\\:first\\:-mx-128:first-child{
    margin-left: -32rem;
    margin-right: -32rem;
  }

  .lg\\:first\\:-my-140:first-child{
    margin-top: -35rem;
    margin-bottom: -35rem;
  }

  .lg\\:first\\:-mx-140:first-child{
    margin-left: -35rem;
    margin-right: -35rem;
  }

  .lg\\:first\\:-my-152:first-child{
    margin-top: -38rem;
    margin-bottom: -38rem;
  }

  .lg\\:first\\:-mx-152:first-child{
    margin-left: -38rem;
    margin-right: -38rem;
  }

  .lg\\:first\\:-my-160:first-child{
    margin-top: -40rem;
    margin-bottom: -40rem;
  }

  .lg\\:first\\:-mx-160:first-child{
    margin-left: -40rem;
    margin-right: -40rem;
  }

  .lg\\:first\\:-my-162:first-child{
    margin-top: -41rem;
    margin-bottom: -41rem;
  }

  .lg\\:first\\:-mx-162:first-child{
    margin-left: -41rem;
    margin-right: -41rem;
  }

  .lg\\:first\\:-my-192:first-child{
    margin-top: -48rem;
    margin-bottom: -48rem;
  }

  .lg\\:first\\:-mx-192:first-child{
    margin-left: -48rem;
    margin-right: -48rem;
  }

  .lg\\:first\\:-my-208:first-child{
    margin-top: -52rem;
    margin-bottom: -52rem;
  }

  .lg\\:first\\:-mx-208:first-child{
    margin-left: -52rem;
    margin-right: -52rem;
  }

  .lg\\:first\\:-my-224:first-child{
    margin-top: -56rem;
    margin-bottom: -56rem;
  }

  .lg\\:first\\:-mx-224:first-child{
    margin-left: -56rem;
    margin-right: -56rem;
  }

  .lg\\:first\\:-my-256:first-child{
    margin-top: -64rem;
    margin-bottom: -64rem;
  }

  .lg\\:first\\:-mx-256:first-child{
    margin-left: -64rem;
    margin-right: -64rem;
  }

  .lg\\:first\\:-my-px:first-child{
    margin-top: -1px;
    margin-bottom: -1px;
  }

  .lg\\:first\\:-mx-px:first-child{
    margin-left: -1px;
    margin-right: -1px;
  }

  .lg\\:first\\:mt-0:first-child{
    margin-top: 0;
  }

  .lg\\:first\\:mr-0:first-child{
    margin-right: 0;
  }

  .lg\\:first\\:mb-0:first-child{
    margin-bottom: 0;
  }

  .lg\\:first\\:ml-0:first-child{
    margin-left: 0;
  }

  .lg\\:first\\:mt-1:first-child{
    margin-top: 0.25rem;
  }

  .lg\\:first\\:mr-1:first-child{
    margin-right: 0.25rem;
  }

  .lg\\:first\\:mb-1:first-child{
    margin-bottom: 0.25rem;
  }

  .lg\\:first\\:ml-1:first-child{
    margin-left: 0.25rem;
  }

  .lg\\:first\\:mt-2:first-child{
    margin-top: 0.5rem;
  }

  .lg\\:first\\:mr-2:first-child{
    margin-right: 0.5rem;
  }

  .lg\\:first\\:mb-2:first-child{
    margin-bottom: 0.5rem;
  }

  .lg\\:first\\:ml-2:first-child{
    margin-left: 0.5rem;
  }

  .lg\\:first\\:mt-3:first-child{
    margin-top: 0.75rem;
  }

  .lg\\:first\\:mr-3:first-child{
    margin-right: 0.75rem;
  }

  .lg\\:first\\:mb-3:first-child{
    margin-bottom: 0.75rem;
  }

  .lg\\:first\\:ml-3:first-child{
    margin-left: 0.75rem;
  }

  .lg\\:first\\:mt-4:first-child{
    margin-top: 1rem;
  }

  .lg\\:first\\:mr-4:first-child{
    margin-right: 1rem;
  }

  .lg\\:first\\:mb-4:first-child{
    margin-bottom: 1rem;
  }

  .lg\\:first\\:ml-4:first-child{
    margin-left: 1rem;
  }

  .lg\\:first\\:mt-5:first-child{
    margin-top: 1.25rem;
  }

  .lg\\:first\\:mr-5:first-child{
    margin-right: 1.25rem;
  }

  .lg\\:first\\:mb-5:first-child{
    margin-bottom: 1.25rem;
  }

  .lg\\:first\\:ml-5:first-child{
    margin-left: 1.25rem;
  }

  .lg\\:first\\:mt-6:first-child{
    margin-top: 1.5rem;
  }

  .lg\\:first\\:mr-6:first-child{
    margin-right: 1.5rem;
  }

  .lg\\:first\\:mb-6:first-child{
    margin-bottom: 1.5rem;
  }

  .lg\\:first\\:ml-6:first-child{
    margin-left: 1.5rem;
  }

  .lg\\:first\\:mt-7:first-child{
    margin-top: 1.75rem;
  }

  .lg\\:first\\:mr-7:first-child{
    margin-right: 1.75rem;
  }

  .lg\\:first\\:mb-7:first-child{
    margin-bottom: 1.75rem;
  }

  .lg\\:first\\:ml-7:first-child{
    margin-left: 1.75rem;
  }

  .lg\\:first\\:mt-8:first-child{
    margin-top: 2rem;
  }

  .lg\\:first\\:mr-8:first-child{
    margin-right: 2rem;
  }

  .lg\\:first\\:mb-8:first-child{
    margin-bottom: 2rem;
  }

  .lg\\:first\\:ml-8:first-child{
    margin-left: 2rem;
  }

  .lg\\:first\\:mt-9:first-child{
    margin-top: 2.25rem;
  }

  .lg\\:first\\:mr-9:first-child{
    margin-right: 2.25rem;
  }

  .lg\\:first\\:mb-9:first-child{
    margin-bottom: 2.25rem;
  }

  .lg\\:first\\:ml-9:first-child{
    margin-left: 2.25rem;
  }

  .lg\\:first\\:mt-10:first-child{
    margin-top: 2.5rem;
  }

  .lg\\:first\\:mr-10:first-child{
    margin-right: 2.5rem;
  }

  .lg\\:first\\:mb-10:first-child{
    margin-bottom: 2.5rem;
  }

  .lg\\:first\\:ml-10:first-child{
    margin-left: 2.5rem;
  }

  .lg\\:first\\:mt-11:first-child{
    margin-top: 2.75rem;
  }

  .lg\\:first\\:mr-11:first-child{
    margin-right: 2.75rem;
  }

  .lg\\:first\\:mb-11:first-child{
    margin-bottom: 2.75rem;
  }

  .lg\\:first\\:ml-11:first-child{
    margin-left: 2.75rem;
  }

  .lg\\:first\\:mt-12:first-child{
    margin-top: 3rem;
  }

  .lg\\:first\\:mr-12:first-child{
    margin-right: 3rem;
  }

  .lg\\:first\\:mb-12:first-child{
    margin-bottom: 3rem;
  }

  .lg\\:first\\:ml-12:first-child{
    margin-left: 3rem;
  }

  .lg\\:first\\:mt-14:first-child{
    margin-top: 3.5rem;
  }

  .lg\\:first\\:mr-14:first-child{
    margin-right: 3.5rem;
  }

  .lg\\:first\\:mb-14:first-child{
    margin-bottom: 3.5rem;
  }

  .lg\\:first\\:ml-14:first-child{
    margin-left: 3.5rem;
  }

  .lg\\:first\\:mt-15:first-child{
    margin-top: 3.75rem;
  }

  .lg\\:first\\:mr-15:first-child{
    margin-right: 3.75rem;
  }

  .lg\\:first\\:mb-15:first-child{
    margin-bottom: 3.75rem;
  }

  .lg\\:first\\:ml-15:first-child{
    margin-left: 3.75rem;
  }

  .lg\\:first\\:mt-16:first-child{
    margin-top: 4rem;
  }

  .lg\\:first\\:mr-16:first-child{
    margin-right: 4rem;
  }

  .lg\\:first\\:mb-16:first-child{
    margin-bottom: 4rem;
  }

  .lg\\:first\\:ml-16:first-child{
    margin-left: 4rem;
  }

  .lg\\:first\\:mt-18:first-child{
    margin-top: 4.5rem;
  }

  .lg\\:first\\:mr-18:first-child{
    margin-right: 4.5rem;
  }

  .lg\\:first\\:mb-18:first-child{
    margin-bottom: 4.5rem;
  }

  .lg\\:first\\:ml-18:first-child{
    margin-left: 4.5rem;
  }

  .lg\\:first\\:mt-20:first-child{
    margin-top: 5rem;
  }

  .lg\\:first\\:mr-20:first-child{
    margin-right: 5rem;
  }

  .lg\\:first\\:mb-20:first-child{
    margin-bottom: 5rem;
  }

  .lg\\:first\\:ml-20:first-child{
    margin-left: 5rem;
  }

  .lg\\:first\\:mt-22:first-child{
    margin-top: 5.5rem;
  }

  .lg\\:first\\:mr-22:first-child{
    margin-right: 5.5rem;
  }

  .lg\\:first\\:mb-22:first-child{
    margin-bottom: 5.5rem;
  }

  .lg\\:first\\:ml-22:first-child{
    margin-left: 5.5rem;
  }

  .lg\\:first\\:mt-23:first-child{
    margin-top: 5.75rem;
  }

  .lg\\:first\\:mr-23:first-child{
    margin-right: 5.75rem;
  }

  .lg\\:first\\:mb-23:first-child{
    margin-bottom: 5.75rem;
  }

  .lg\\:first\\:ml-23:first-child{
    margin-left: 5.75rem;
  }

  .lg\\:first\\:mt-24:first-child{
    margin-top: 6rem;
  }

  .lg\\:first\\:mr-24:first-child{
    margin-right: 6rem;
  }

  .lg\\:first\\:mb-24:first-child{
    margin-bottom: 6rem;
  }

  .lg\\:first\\:ml-24:first-child{
    margin-left: 6rem;
  }

  .lg\\:first\\:mt-25:first-child{
    margin-top: 6.25rem;
  }

  .lg\\:first\\:mr-25:first-child{
    margin-right: 6.25rem;
  }

  .lg\\:first\\:mb-25:first-child{
    margin-bottom: 6.25rem;
  }

  .lg\\:first\\:ml-25:first-child{
    margin-left: 6.25rem;
  }

  .lg\\:first\\:mt-26:first-child{
    margin-top: 6.5rem;
  }

  .lg\\:first\\:mr-26:first-child{
    margin-right: 6.5rem;
  }

  .lg\\:first\\:mb-26:first-child{
    margin-bottom: 6.5rem;
  }

  .lg\\:first\\:ml-26:first-child{
    margin-left: 6.5rem;
  }

  .lg\\:first\\:mt-28:first-child{
    margin-top: 7rem;
  }

  .lg\\:first\\:mr-28:first-child{
    margin-right: 7rem;
  }

  .lg\\:first\\:mb-28:first-child{
    margin-bottom: 7rem;
  }

  .lg\\:first\\:ml-28:first-child{
    margin-left: 7rem;
  }

  .lg\\:first\\:mt-30:first-child{
    margin-top: 7.5rem;
  }

  .lg\\:first\\:mr-30:first-child{
    margin-right: 7.5rem;
  }

  .lg\\:first\\:mb-30:first-child{
    margin-bottom: 7.5rem;
  }

  .lg\\:first\\:ml-30:first-child{
    margin-left: 7.5rem;
  }

  .lg\\:first\\:mt-32:first-child{
    margin-top: 8rem;
  }

  .lg\\:first\\:mr-32:first-child{
    margin-right: 8rem;
  }

  .lg\\:first\\:mb-32:first-child{
    margin-bottom: 8rem;
  }

  .lg\\:first\\:ml-32:first-child{
    margin-left: 8rem;
  }

  .lg\\:first\\:mt-34:first-child{
    margin-top: 8.5rem;
  }

  .lg\\:first\\:mr-34:first-child{
    margin-right: 8.5rem;
  }

  .lg\\:first\\:mb-34:first-child{
    margin-bottom: 8.5rem;
  }

  .lg\\:first\\:ml-34:first-child{
    margin-left: 8.5rem;
  }

  .lg\\:first\\:mt-40:first-child{
    margin-top: 10rem;
  }

  .lg\\:first\\:mr-40:first-child{
    margin-right: 10rem;
  }

  .lg\\:first\\:mb-40:first-child{
    margin-bottom: 10rem;
  }

  .lg\\:first\\:ml-40:first-child{
    margin-left: 10rem;
  }

  .lg\\:first\\:mt-42:first-child{
    margin-top: 10.5rem;
  }

  .lg\\:first\\:mr-42:first-child{
    margin-right: 10.5rem;
  }

  .lg\\:first\\:mb-42:first-child{
    margin-bottom: 10.5rem;
  }

  .lg\\:first\\:ml-42:first-child{
    margin-left: 10.5rem;
  }

  .lg\\:first\\:mt-44:first-child{
    margin-top: 11rem;
  }

  .lg\\:first\\:mr-44:first-child{
    margin-right: 11rem;
  }

  .lg\\:first\\:mb-44:first-child{
    margin-bottom: 11rem;
  }

  .lg\\:first\\:ml-44:first-child{
    margin-left: 11rem;
  }

  .lg\\:first\\:mt-48:first-child{
    margin-top: 12rem;
  }

  .lg\\:first\\:mr-48:first-child{
    margin-right: 12rem;
  }

  .lg\\:first\\:mb-48:first-child{
    margin-bottom: 12rem;
  }

  .lg\\:first\\:ml-48:first-child{
    margin-left: 12rem;
  }

  .lg\\:first\\:mt-52:first-child{
    margin-top: 13rem;
  }

  .lg\\:first\\:mr-52:first-child{
    margin-right: 13rem;
  }

  .lg\\:first\\:mb-52:first-child{
    margin-bottom: 13rem;
  }

  .lg\\:first\\:ml-52:first-child{
    margin-left: 13rem;
  }

  .lg\\:first\\:mt-54:first-child{
    margin-top: 13.5rem;
  }

  .lg\\:first\\:mr-54:first-child{
    margin-right: 13.5rem;
  }

  .lg\\:first\\:mb-54:first-child{
    margin-bottom: 13.5rem;
  }

  .lg\\:first\\:ml-54:first-child{
    margin-left: 13.5rem;
  }

  .lg\\:first\\:mt-56:first-child{
    margin-top: 14rem;
  }

  .lg\\:first\\:mr-56:first-child{
    margin-right: 14rem;
  }

  .lg\\:first\\:mb-56:first-child{
    margin-bottom: 14rem;
  }

  .lg\\:first\\:ml-56:first-child{
    margin-left: 14rem;
  }

  .lg\\:first\\:mt-60:first-child{
    margin-top: 15rem;
  }

  .lg\\:first\\:mr-60:first-child{
    margin-right: 15rem;
  }

  .lg\\:first\\:mb-60:first-child{
    margin-bottom: 15rem;
  }

  .lg\\:first\\:ml-60:first-child{
    margin-left: 15rem;
  }

  .lg\\:first\\:mt-64:first-child{
    margin-top: 16rem;
  }

  .lg\\:first\\:mr-64:first-child{
    margin-right: 16rem;
  }

  .lg\\:first\\:mb-64:first-child{
    margin-bottom: 16rem;
  }

  .lg\\:first\\:ml-64:first-child{
    margin-left: 16rem;
  }

  .lg\\:first\\:mt-68:first-child{
    margin-top: 17rem;
  }

  .lg\\:first\\:mr-68:first-child{
    margin-right: 17rem;
  }

  .lg\\:first\\:mb-68:first-child{
    margin-bottom: 17rem;
  }

  .lg\\:first\\:ml-68:first-child{
    margin-left: 17rem;
  }

  .lg\\:first\\:mt-72:first-child{
    margin-top: 18rem;
  }

  .lg\\:first\\:mr-72:first-child{
    margin-right: 18rem;
  }

  .lg\\:first\\:mb-72:first-child{
    margin-bottom: 18rem;
  }

  .lg\\:first\\:ml-72:first-child{
    margin-left: 18rem;
  }

  .lg\\:first\\:mt-74:first-child{
    margin-top: 18.5rem;
  }

  .lg\\:first\\:mr-74:first-child{
    margin-right: 18.5rem;
  }

  .lg\\:first\\:mb-74:first-child{
    margin-bottom: 18.5rem;
  }

  .lg\\:first\\:ml-74:first-child{
    margin-left: 18.5rem;
  }

  .lg\\:first\\:mt-76:first-child{
    margin-top: 19rem;
  }

  .lg\\:first\\:mr-76:first-child{
    margin-right: 19rem;
  }

  .lg\\:first\\:mb-76:first-child{
    margin-bottom: 19rem;
  }

  .lg\\:first\\:ml-76:first-child{
    margin-left: 19rem;
  }

  .lg\\:first\\:mt-78:first-child{
    margin-top: 19.5rem;
  }

  .lg\\:first\\:mr-78:first-child{
    margin-right: 19.5rem;
  }

  .lg\\:first\\:mb-78:first-child{
    margin-bottom: 19.5rem;
  }

  .lg\\:first\\:ml-78:first-child{
    margin-left: 19.5rem;
  }

  .lg\\:first\\:mt-80:first-child{
    margin-top: 20rem;
  }

  .lg\\:first\\:mr-80:first-child{
    margin-right: 20rem;
  }

  .lg\\:first\\:mb-80:first-child{
    margin-bottom: 20rem;
  }

  .lg\\:first\\:ml-80:first-child{
    margin-left: 20rem;
  }

  .lg\\:first\\:mt-82:first-child{
    margin-top: 20.5rem;
  }

  .lg\\:first\\:mr-82:first-child{
    margin-right: 20.5rem;
  }

  .lg\\:first\\:mb-82:first-child{
    margin-bottom: 20.5rem;
  }

  .lg\\:first\\:ml-82:first-child{
    margin-left: 20.5rem;
  }

  .lg\\:first\\:mt-84:first-child{
    margin-top: 21rem;
  }

  .lg\\:first\\:mr-84:first-child{
    margin-right: 21rem;
  }

  .lg\\:first\\:mb-84:first-child{
    margin-bottom: 21rem;
  }

  .lg\\:first\\:ml-84:first-child{
    margin-left: 21rem;
  }

  .lg\\:first\\:mt-88:first-child{
    margin-top: 22rem;
  }

  .lg\\:first\\:mr-88:first-child{
    margin-right: 22rem;
  }

  .lg\\:first\\:mb-88:first-child{
    margin-bottom: 22rem;
  }

  .lg\\:first\\:ml-88:first-child{
    margin-left: 22rem;
  }

  .lg\\:first\\:mt-92:first-child{
    margin-top: 23rem;
  }

  .lg\\:first\\:mr-92:first-child{
    margin-right: 23rem;
  }

  .lg\\:first\\:mb-92:first-child{
    margin-bottom: 23rem;
  }

  .lg\\:first\\:ml-92:first-child{
    margin-left: 23rem;
  }

  .lg\\:first\\:mt-96:first-child{
    margin-top: 24rem;
  }

  .lg\\:first\\:mr-96:first-child{
    margin-right: 24rem;
  }

  .lg\\:first\\:mb-96:first-child{
    margin-bottom: 24rem;
  }

  .lg\\:first\\:ml-96:first-child{
    margin-left: 24rem;
  }

  .lg\\:first\\:mt-98:first-child{
    margin-top: 24.5rem;
  }

  .lg\\:first\\:mr-98:first-child{
    margin-right: 24.5rem;
  }

  .lg\\:first\\:mb-98:first-child{
    margin-bottom: 24.5rem;
  }

  .lg\\:first\\:ml-98:first-child{
    margin-left: 24.5rem;
  }

  .lg\\:first\\:mt-100:first-child{
    margin-top: 25rem;
  }

  .lg\\:first\\:mr-100:first-child{
    margin-right: 25rem;
  }

  .lg\\:first\\:mb-100:first-child{
    margin-bottom: 25rem;
  }

  .lg\\:first\\:ml-100:first-child{
    margin-left: 25rem;
  }

  .lg\\:first\\:mt-104:first-child{
    margin-top: 26rem;
  }

  .lg\\:first\\:mr-104:first-child{
    margin-right: 26rem;
  }

  .lg\\:first\\:mb-104:first-child{
    margin-bottom: 26rem;
  }

  .lg\\:first\\:ml-104:first-child{
    margin-left: 26rem;
  }

  .lg\\:first\\:mt-112:first-child{
    margin-top: 28rem;
  }

  .lg\\:first\\:mr-112:first-child{
    margin-right: 28rem;
  }

  .lg\\:first\\:mb-112:first-child{
    margin-bottom: 28rem;
  }

  .lg\\:first\\:ml-112:first-child{
    margin-left: 28rem;
  }

  .lg\\:first\\:mt-124:first-child{
    margin-top: 31rem;
  }

  .lg\\:first\\:mr-124:first-child{
    margin-right: 31rem;
  }

  .lg\\:first\\:mb-124:first-child{
    margin-bottom: 31rem;
  }

  .lg\\:first\\:ml-124:first-child{
    margin-left: 31rem;
  }

  .lg\\:first\\:mt-128:first-child{
    margin-top: 32rem;
  }

  .lg\\:first\\:mr-128:first-child{
    margin-right: 32rem;
  }

  .lg\\:first\\:mb-128:first-child{
    margin-bottom: 32rem;
  }

  .lg\\:first\\:ml-128:first-child{
    margin-left: 32rem;
  }

  .lg\\:first\\:mt-140:first-child{
    margin-top: 35rem;
  }

  .lg\\:first\\:mr-140:first-child{
    margin-right: 35rem;
  }

  .lg\\:first\\:mb-140:first-child{
    margin-bottom: 35rem;
  }

  .lg\\:first\\:ml-140:first-child{
    margin-left: 35rem;
  }

  .lg\\:first\\:mt-152:first-child{
    margin-top: 38rem;
  }

  .lg\\:first\\:mr-152:first-child{
    margin-right: 38rem;
  }

  .lg\\:first\\:mb-152:first-child{
    margin-bottom: 38rem;
  }

  .lg\\:first\\:ml-152:first-child{
    margin-left: 38rem;
  }

  .lg\\:first\\:mt-160:first-child{
    margin-top: 40rem;
  }

  .lg\\:first\\:mr-160:first-child{
    margin-right: 40rem;
  }

  .lg\\:first\\:mb-160:first-child{
    margin-bottom: 40rem;
  }

  .lg\\:first\\:ml-160:first-child{
    margin-left: 40rem;
  }

  .lg\\:first\\:mt-162:first-child{
    margin-top: 41rem;
  }

  .lg\\:first\\:mr-162:first-child{
    margin-right: 41rem;
  }

  .lg\\:first\\:mb-162:first-child{
    margin-bottom: 41rem;
  }

  .lg\\:first\\:ml-162:first-child{
    margin-left: 41rem;
  }

  .lg\\:first\\:mt-192:first-child{
    margin-top: 48rem;
  }

  .lg\\:first\\:mr-192:first-child{
    margin-right: 48rem;
  }

  .lg\\:first\\:mb-192:first-child{
    margin-bottom: 48rem;
  }

  .lg\\:first\\:ml-192:first-child{
    margin-left: 48rem;
  }

  .lg\\:first\\:mt-208:first-child{
    margin-top: 52rem;
  }

  .lg\\:first\\:mr-208:first-child{
    margin-right: 52rem;
  }

  .lg\\:first\\:mb-208:first-child{
    margin-bottom: 52rem;
  }

  .lg\\:first\\:ml-208:first-child{
    margin-left: 52rem;
  }

  .lg\\:first\\:mt-224:first-child{
    margin-top: 56rem;
  }

  .lg\\:first\\:mr-224:first-child{
    margin-right: 56rem;
  }

  .lg\\:first\\:mb-224:first-child{
    margin-bottom: 56rem;
  }

  .lg\\:first\\:ml-224:first-child{
    margin-left: 56rem;
  }

  .lg\\:first\\:mt-256:first-child{
    margin-top: 64rem;
  }

  .lg\\:first\\:mr-256:first-child{
    margin-right: 64rem;
  }

  .lg\\:first\\:mb-256:first-child{
    margin-bottom: 64rem;
  }

  .lg\\:first\\:ml-256:first-child{
    margin-left: 64rem;
  }

  .lg\\:first\\:mt-auto:first-child{
    margin-top: auto;
  }

  .lg\\:first\\:mr-auto:first-child{
    margin-right: auto;
  }

  .lg\\:first\\:mb-auto:first-child{
    margin-bottom: auto;
  }

  .lg\\:first\\:ml-auto:first-child{
    margin-left: auto;
  }

  .lg\\:first\\:mt-px:first-child{
    margin-top: 1px;
  }

  .lg\\:first\\:mr-px:first-child{
    margin-right: 1px;
  }

  .lg\\:first\\:mb-px:first-child{
    margin-bottom: 1px;
  }

  .lg\\:first\\:ml-px:first-child{
    margin-left: 1px;
  }

  .lg\\:first\\:-mt-1:first-child{
    margin-top: -0.25rem;
  }

  .lg\\:first\\:-mr-1:first-child{
    margin-right: -0.25rem;
  }

  .lg\\:first\\:-mb-1:first-child{
    margin-bottom: -0.25rem;
  }

  .lg\\:first\\:-ml-1:first-child{
    margin-left: -0.25rem;
  }

  .lg\\:first\\:-mt-2:first-child{
    margin-top: -0.5rem;
  }

  .lg\\:first\\:-mr-2:first-child{
    margin-right: -0.5rem;
  }

  .lg\\:first\\:-mb-2:first-child{
    margin-bottom: -0.5rem;
  }

  .lg\\:first\\:-ml-2:first-child{
    margin-left: -0.5rem;
  }

  .lg\\:first\\:-mt-3:first-child{
    margin-top: -0.75rem;
  }

  .lg\\:first\\:-mr-3:first-child{
    margin-right: -0.75rem;
  }

  .lg\\:first\\:-mb-3:first-child{
    margin-bottom: -0.75rem;
  }

  .lg\\:first\\:-ml-3:first-child{
    margin-left: -0.75rem;
  }

  .lg\\:first\\:-mt-4:first-child{
    margin-top: -1rem;
  }

  .lg\\:first\\:-mr-4:first-child{
    margin-right: -1rem;
  }

  .lg\\:first\\:-mb-4:first-child{
    margin-bottom: -1rem;
  }

  .lg\\:first\\:-ml-4:first-child{
    margin-left: -1rem;
  }

  .lg\\:first\\:-mt-5:first-child{
    margin-top: -1.25rem;
  }

  .lg\\:first\\:-mr-5:first-child{
    margin-right: -1.25rem;
  }

  .lg\\:first\\:-mb-5:first-child{
    margin-bottom: -1.25rem;
  }

  .lg\\:first\\:-ml-5:first-child{
    margin-left: -1.25rem;
  }

  .lg\\:first\\:-mt-6:first-child{
    margin-top: -1.5rem;
  }

  .lg\\:first\\:-mr-6:first-child{
    margin-right: -1.5rem;
  }

  .lg\\:first\\:-mb-6:first-child{
    margin-bottom: -1.5rem;
  }

  .lg\\:first\\:-ml-6:first-child{
    margin-left: -1.5rem;
  }

  .lg\\:first\\:-mt-7:first-child{
    margin-top: -1.75rem;
  }

  .lg\\:first\\:-mr-7:first-child{
    margin-right: -1.75rem;
  }

  .lg\\:first\\:-mb-7:first-child{
    margin-bottom: -1.75rem;
  }

  .lg\\:first\\:-ml-7:first-child{
    margin-left: -1.75rem;
  }

  .lg\\:first\\:-mt-8:first-child{
    margin-top: -2rem;
  }

  .lg\\:first\\:-mr-8:first-child{
    margin-right: -2rem;
  }

  .lg\\:first\\:-mb-8:first-child{
    margin-bottom: -2rem;
  }

  .lg\\:first\\:-ml-8:first-child{
    margin-left: -2rem;
  }

  .lg\\:first\\:-mt-9:first-child{
    margin-top: -2.25rem;
  }

  .lg\\:first\\:-mr-9:first-child{
    margin-right: -2.25rem;
  }

  .lg\\:first\\:-mb-9:first-child{
    margin-bottom: -2.25rem;
  }

  .lg\\:first\\:-ml-9:first-child{
    margin-left: -2.25rem;
  }

  .lg\\:first\\:-mt-10:first-child{
    margin-top: -2.5rem;
  }

  .lg\\:first\\:-mr-10:first-child{
    margin-right: -2.5rem;
  }

  .lg\\:first\\:-mb-10:first-child{
    margin-bottom: -2.5rem;
  }

  .lg\\:first\\:-ml-10:first-child{
    margin-left: -2.5rem;
  }

  .lg\\:first\\:-mt-11:first-child{
    margin-top: -2.75rem;
  }

  .lg\\:first\\:-mr-11:first-child{
    margin-right: -2.75rem;
  }

  .lg\\:first\\:-mb-11:first-child{
    margin-bottom: -2.75rem;
  }

  .lg\\:first\\:-ml-11:first-child{
    margin-left: -2.75rem;
  }

  .lg\\:first\\:-mt-12:first-child{
    margin-top: -3rem;
  }

  .lg\\:first\\:-mr-12:first-child{
    margin-right: -3rem;
  }

  .lg\\:first\\:-mb-12:first-child{
    margin-bottom: -3rem;
  }

  .lg\\:first\\:-ml-12:first-child{
    margin-left: -3rem;
  }

  .lg\\:first\\:-mt-14:first-child{
    margin-top: -3.5rem;
  }

  .lg\\:first\\:-mr-14:first-child{
    margin-right: -3.5rem;
  }

  .lg\\:first\\:-mb-14:first-child{
    margin-bottom: -3.5rem;
  }

  .lg\\:first\\:-ml-14:first-child{
    margin-left: -3.5rem;
  }

  .lg\\:first\\:-mt-15:first-child{
    margin-top: -3.75rem;
  }

  .lg\\:first\\:-mr-15:first-child{
    margin-right: -3.75rem;
  }

  .lg\\:first\\:-mb-15:first-child{
    margin-bottom: -3.75rem;
  }

  .lg\\:first\\:-ml-15:first-child{
    margin-left: -3.75rem;
  }

  .lg\\:first\\:-mt-16:first-child{
    margin-top: -4rem;
  }

  .lg\\:first\\:-mr-16:first-child{
    margin-right: -4rem;
  }

  .lg\\:first\\:-mb-16:first-child{
    margin-bottom: -4rem;
  }

  .lg\\:first\\:-ml-16:first-child{
    margin-left: -4rem;
  }

  .lg\\:first\\:-mt-18:first-child{
    margin-top: -4.5rem;
  }

  .lg\\:first\\:-mr-18:first-child{
    margin-right: -4.5rem;
  }

  .lg\\:first\\:-mb-18:first-child{
    margin-bottom: -4.5rem;
  }

  .lg\\:first\\:-ml-18:first-child{
    margin-left: -4.5rem;
  }

  .lg\\:first\\:-mt-20:first-child{
    margin-top: -5rem;
  }

  .lg\\:first\\:-mr-20:first-child{
    margin-right: -5rem;
  }

  .lg\\:first\\:-mb-20:first-child{
    margin-bottom: -5rem;
  }

  .lg\\:first\\:-ml-20:first-child{
    margin-left: -5rem;
  }

  .lg\\:first\\:-mt-22:first-child{
    margin-top: -5.5rem;
  }

  .lg\\:first\\:-mr-22:first-child{
    margin-right: -5.5rem;
  }

  .lg\\:first\\:-mb-22:first-child{
    margin-bottom: -5.5rem;
  }

  .lg\\:first\\:-ml-22:first-child{
    margin-left: -5.5rem;
  }

  .lg\\:first\\:-mt-23:first-child{
    margin-top: -5.75rem;
  }

  .lg\\:first\\:-mr-23:first-child{
    margin-right: -5.75rem;
  }

  .lg\\:first\\:-mb-23:first-child{
    margin-bottom: -5.75rem;
  }

  .lg\\:first\\:-ml-23:first-child{
    margin-left: -5.75rem;
  }

  .lg\\:first\\:-mt-24:first-child{
    margin-top: -6rem;
  }

  .lg\\:first\\:-mr-24:first-child{
    margin-right: -6rem;
  }

  .lg\\:first\\:-mb-24:first-child{
    margin-bottom: -6rem;
  }

  .lg\\:first\\:-ml-24:first-child{
    margin-left: -6rem;
  }

  .lg\\:first\\:-mt-25:first-child{
    margin-top: -6.25rem;
  }

  .lg\\:first\\:-mr-25:first-child{
    margin-right: -6.25rem;
  }

  .lg\\:first\\:-mb-25:first-child{
    margin-bottom: -6.25rem;
  }

  .lg\\:first\\:-ml-25:first-child{
    margin-left: -6.25rem;
  }

  .lg\\:first\\:-mt-26:first-child{
    margin-top: -6.5rem;
  }

  .lg\\:first\\:-mr-26:first-child{
    margin-right: -6.5rem;
  }

  .lg\\:first\\:-mb-26:first-child{
    margin-bottom: -6.5rem;
  }

  .lg\\:first\\:-ml-26:first-child{
    margin-left: -6.5rem;
  }

  .lg\\:first\\:-mt-28:first-child{
    margin-top: -7rem;
  }

  .lg\\:first\\:-mr-28:first-child{
    margin-right: -7rem;
  }

  .lg\\:first\\:-mb-28:first-child{
    margin-bottom: -7rem;
  }

  .lg\\:first\\:-ml-28:first-child{
    margin-left: -7rem;
  }

  .lg\\:first\\:-mt-30:first-child{
    margin-top: -7.5rem;
  }

  .lg\\:first\\:-mr-30:first-child{
    margin-right: -7.5rem;
  }

  .lg\\:first\\:-mb-30:first-child{
    margin-bottom: -7.5rem;
  }

  .lg\\:first\\:-ml-30:first-child{
    margin-left: -7.5rem;
  }

  .lg\\:first\\:-mt-32:first-child{
    margin-top: -8rem;
  }

  .lg\\:first\\:-mr-32:first-child{
    margin-right: -8rem;
  }

  .lg\\:first\\:-mb-32:first-child{
    margin-bottom: -8rem;
  }

  .lg\\:first\\:-ml-32:first-child{
    margin-left: -8rem;
  }

  .lg\\:first\\:-mt-34:first-child{
    margin-top: -8.5rem;
  }

  .lg\\:first\\:-mr-34:first-child{
    margin-right: -8.5rem;
  }

  .lg\\:first\\:-mb-34:first-child{
    margin-bottom: -8.5rem;
  }

  .lg\\:first\\:-ml-34:first-child{
    margin-left: -8.5rem;
  }

  .lg\\:first\\:-mt-40:first-child{
    margin-top: -10rem;
  }

  .lg\\:first\\:-mr-40:first-child{
    margin-right: -10rem;
  }

  .lg\\:first\\:-mb-40:first-child{
    margin-bottom: -10rem;
  }

  .lg\\:first\\:-ml-40:first-child{
    margin-left: -10rem;
  }

  .lg\\:first\\:-mt-42:first-child{
    margin-top: -10.5rem;
  }

  .lg\\:first\\:-mr-42:first-child{
    margin-right: -10.5rem;
  }

  .lg\\:first\\:-mb-42:first-child{
    margin-bottom: -10.5rem;
  }

  .lg\\:first\\:-ml-42:first-child{
    margin-left: -10.5rem;
  }

  .lg\\:first\\:-mt-44:first-child{
    margin-top: -11rem;
  }

  .lg\\:first\\:-mr-44:first-child{
    margin-right: -11rem;
  }

  .lg\\:first\\:-mb-44:first-child{
    margin-bottom: -11rem;
  }

  .lg\\:first\\:-ml-44:first-child{
    margin-left: -11rem;
  }

  .lg\\:first\\:-mt-48:first-child{
    margin-top: -12rem;
  }

  .lg\\:first\\:-mr-48:first-child{
    margin-right: -12rem;
  }

  .lg\\:first\\:-mb-48:first-child{
    margin-bottom: -12rem;
  }

  .lg\\:first\\:-ml-48:first-child{
    margin-left: -12rem;
  }

  .lg\\:first\\:-mt-52:first-child{
    margin-top: -13rem;
  }

  .lg\\:first\\:-mr-52:first-child{
    margin-right: -13rem;
  }

  .lg\\:first\\:-mb-52:first-child{
    margin-bottom: -13rem;
  }

  .lg\\:first\\:-ml-52:first-child{
    margin-left: -13rem;
  }

  .lg\\:first\\:-mt-54:first-child{
    margin-top: -13.5rem;
  }

  .lg\\:first\\:-mr-54:first-child{
    margin-right: -13.5rem;
  }

  .lg\\:first\\:-mb-54:first-child{
    margin-bottom: -13.5rem;
  }

  .lg\\:first\\:-ml-54:first-child{
    margin-left: -13.5rem;
  }

  .lg\\:first\\:-mt-56:first-child{
    margin-top: -14rem;
  }

  .lg\\:first\\:-mr-56:first-child{
    margin-right: -14rem;
  }

  .lg\\:first\\:-mb-56:first-child{
    margin-bottom: -14rem;
  }

  .lg\\:first\\:-ml-56:first-child{
    margin-left: -14rem;
  }

  .lg\\:first\\:-mt-60:first-child{
    margin-top: -15rem;
  }

  .lg\\:first\\:-mr-60:first-child{
    margin-right: -15rem;
  }

  .lg\\:first\\:-mb-60:first-child{
    margin-bottom: -15rem;
  }

  .lg\\:first\\:-ml-60:first-child{
    margin-left: -15rem;
  }

  .lg\\:first\\:-mt-64:first-child{
    margin-top: -16rem;
  }

  .lg\\:first\\:-mr-64:first-child{
    margin-right: -16rem;
  }

  .lg\\:first\\:-mb-64:first-child{
    margin-bottom: -16rem;
  }

  .lg\\:first\\:-ml-64:first-child{
    margin-left: -16rem;
  }

  .lg\\:first\\:-mt-68:first-child{
    margin-top: -17rem;
  }

  .lg\\:first\\:-mr-68:first-child{
    margin-right: -17rem;
  }

  .lg\\:first\\:-mb-68:first-child{
    margin-bottom: -17rem;
  }

  .lg\\:first\\:-ml-68:first-child{
    margin-left: -17rem;
  }

  .lg\\:first\\:-mt-72:first-child{
    margin-top: -18rem;
  }

  .lg\\:first\\:-mr-72:first-child{
    margin-right: -18rem;
  }

  .lg\\:first\\:-mb-72:first-child{
    margin-bottom: -18rem;
  }

  .lg\\:first\\:-ml-72:first-child{
    margin-left: -18rem;
  }

  .lg\\:first\\:-mt-74:first-child{
    margin-top: -18.5rem;
  }

  .lg\\:first\\:-mr-74:first-child{
    margin-right: -18.5rem;
  }

  .lg\\:first\\:-mb-74:first-child{
    margin-bottom: -18.5rem;
  }

  .lg\\:first\\:-ml-74:first-child{
    margin-left: -18.5rem;
  }

  .lg\\:first\\:-mt-76:first-child{
    margin-top: -19rem;
  }

  .lg\\:first\\:-mr-76:first-child{
    margin-right: -19rem;
  }

  .lg\\:first\\:-mb-76:first-child{
    margin-bottom: -19rem;
  }

  .lg\\:first\\:-ml-76:first-child{
    margin-left: -19rem;
  }

  .lg\\:first\\:-mt-78:first-child{
    margin-top: -19.5rem;
  }

  .lg\\:first\\:-mr-78:first-child{
    margin-right: -19.5rem;
  }

  .lg\\:first\\:-mb-78:first-child{
    margin-bottom: -19.5rem;
  }

  .lg\\:first\\:-ml-78:first-child{
    margin-left: -19.5rem;
  }

  .lg\\:first\\:-mt-80:first-child{
    margin-top: -20rem;
  }

  .lg\\:first\\:-mr-80:first-child{
    margin-right: -20rem;
  }

  .lg\\:first\\:-mb-80:first-child{
    margin-bottom: -20rem;
  }

  .lg\\:first\\:-ml-80:first-child{
    margin-left: -20rem;
  }

  .lg\\:first\\:-mt-82:first-child{
    margin-top: -20.5rem;
  }

  .lg\\:first\\:-mr-82:first-child{
    margin-right: -20.5rem;
  }

  .lg\\:first\\:-mb-82:first-child{
    margin-bottom: -20.5rem;
  }

  .lg\\:first\\:-ml-82:first-child{
    margin-left: -20.5rem;
  }

  .lg\\:first\\:-mt-84:first-child{
    margin-top: -21rem;
  }

  .lg\\:first\\:-mr-84:first-child{
    margin-right: -21rem;
  }

  .lg\\:first\\:-mb-84:first-child{
    margin-bottom: -21rem;
  }

  .lg\\:first\\:-ml-84:first-child{
    margin-left: -21rem;
  }

  .lg\\:first\\:-mt-88:first-child{
    margin-top: -22rem;
  }

  .lg\\:first\\:-mr-88:first-child{
    margin-right: -22rem;
  }

  .lg\\:first\\:-mb-88:first-child{
    margin-bottom: -22rem;
  }

  .lg\\:first\\:-ml-88:first-child{
    margin-left: -22rem;
  }

  .lg\\:first\\:-mt-92:first-child{
    margin-top: -23rem;
  }

  .lg\\:first\\:-mr-92:first-child{
    margin-right: -23rem;
  }

  .lg\\:first\\:-mb-92:first-child{
    margin-bottom: -23rem;
  }

  .lg\\:first\\:-ml-92:first-child{
    margin-left: -23rem;
  }

  .lg\\:first\\:-mt-96:first-child{
    margin-top: -24rem;
  }

  .lg\\:first\\:-mr-96:first-child{
    margin-right: -24rem;
  }

  .lg\\:first\\:-mb-96:first-child{
    margin-bottom: -24rem;
  }

  .lg\\:first\\:-ml-96:first-child{
    margin-left: -24rem;
  }

  .lg\\:first\\:-mt-98:first-child{
    margin-top: -24.5rem;
  }

  .lg\\:first\\:-mr-98:first-child{
    margin-right: -24.5rem;
  }

  .lg\\:first\\:-mb-98:first-child{
    margin-bottom: -24.5rem;
  }

  .lg\\:first\\:-ml-98:first-child{
    margin-left: -24.5rem;
  }

  .lg\\:first\\:-mt-100:first-child{
    margin-top: -25rem;
  }

  .lg\\:first\\:-mr-100:first-child{
    margin-right: -25rem;
  }

  .lg\\:first\\:-mb-100:first-child{
    margin-bottom: -25rem;
  }

  .lg\\:first\\:-ml-100:first-child{
    margin-left: -25rem;
  }

  .lg\\:first\\:-mt-104:first-child{
    margin-top: -26rem;
  }

  .lg\\:first\\:-mr-104:first-child{
    margin-right: -26rem;
  }

  .lg\\:first\\:-mb-104:first-child{
    margin-bottom: -26rem;
  }

  .lg\\:first\\:-ml-104:first-child{
    margin-left: -26rem;
  }

  .lg\\:first\\:-mt-112:first-child{
    margin-top: -28rem;
  }

  .lg\\:first\\:-mr-112:first-child{
    margin-right: -28rem;
  }

  .lg\\:first\\:-mb-112:first-child{
    margin-bottom: -28rem;
  }

  .lg\\:first\\:-ml-112:first-child{
    margin-left: -28rem;
  }

  .lg\\:first\\:-mt-124:first-child{
    margin-top: -31rem;
  }

  .lg\\:first\\:-mr-124:first-child{
    margin-right: -31rem;
  }

  .lg\\:first\\:-mb-124:first-child{
    margin-bottom: -31rem;
  }

  .lg\\:first\\:-ml-124:first-child{
    margin-left: -31rem;
  }

  .lg\\:first\\:-mt-128:first-child{
    margin-top: -32rem;
  }

  .lg\\:first\\:-mr-128:first-child{
    margin-right: -32rem;
  }

  .lg\\:first\\:-mb-128:first-child{
    margin-bottom: -32rem;
  }

  .lg\\:first\\:-ml-128:first-child{
    margin-left: -32rem;
  }

  .lg\\:first\\:-mt-140:first-child{
    margin-top: -35rem;
  }

  .lg\\:first\\:-mr-140:first-child{
    margin-right: -35rem;
  }

  .lg\\:first\\:-mb-140:first-child{
    margin-bottom: -35rem;
  }

  .lg\\:first\\:-ml-140:first-child{
    margin-left: -35rem;
  }

  .lg\\:first\\:-mt-152:first-child{
    margin-top: -38rem;
  }

  .lg\\:first\\:-mr-152:first-child{
    margin-right: -38rem;
  }

  .lg\\:first\\:-mb-152:first-child{
    margin-bottom: -38rem;
  }

  .lg\\:first\\:-ml-152:first-child{
    margin-left: -38rem;
  }

  .lg\\:first\\:-mt-160:first-child{
    margin-top: -40rem;
  }

  .lg\\:first\\:-mr-160:first-child{
    margin-right: -40rem;
  }

  .lg\\:first\\:-mb-160:first-child{
    margin-bottom: -40rem;
  }

  .lg\\:first\\:-ml-160:first-child{
    margin-left: -40rem;
  }

  .lg\\:first\\:-mt-162:first-child{
    margin-top: -41rem;
  }

  .lg\\:first\\:-mr-162:first-child{
    margin-right: -41rem;
  }

  .lg\\:first\\:-mb-162:first-child{
    margin-bottom: -41rem;
  }

  .lg\\:first\\:-ml-162:first-child{
    margin-left: -41rem;
  }

  .lg\\:first\\:-mt-192:first-child{
    margin-top: -48rem;
  }

  .lg\\:first\\:-mr-192:first-child{
    margin-right: -48rem;
  }

  .lg\\:first\\:-mb-192:first-child{
    margin-bottom: -48rem;
  }

  .lg\\:first\\:-ml-192:first-child{
    margin-left: -48rem;
  }

  .lg\\:first\\:-mt-208:first-child{
    margin-top: -52rem;
  }

  .lg\\:first\\:-mr-208:first-child{
    margin-right: -52rem;
  }

  .lg\\:first\\:-mb-208:first-child{
    margin-bottom: -52rem;
  }

  .lg\\:first\\:-ml-208:first-child{
    margin-left: -52rem;
  }

  .lg\\:first\\:-mt-224:first-child{
    margin-top: -56rem;
  }

  .lg\\:first\\:-mr-224:first-child{
    margin-right: -56rem;
  }

  .lg\\:first\\:-mb-224:first-child{
    margin-bottom: -56rem;
  }

  .lg\\:first\\:-ml-224:first-child{
    margin-left: -56rem;
  }

  .lg\\:first\\:-mt-256:first-child{
    margin-top: -64rem;
  }

  .lg\\:first\\:-mr-256:first-child{
    margin-right: -64rem;
  }

  .lg\\:first\\:-mb-256:first-child{
    margin-bottom: -64rem;
  }

  .lg\\:first\\:-ml-256:first-child{
    margin-left: -64rem;
  }

  .lg\\:first\\:-mt-px:first-child{
    margin-top: -1px;
  }

  .lg\\:first\\:-mr-px:first-child{
    margin-right: -1px;
  }

  .lg\\:first\\:-mb-px:first-child{
    margin-bottom: -1px;
  }

  .lg\\:first\\:-ml-px:first-child{
    margin-left: -1px;
  }

  .lg\\:max-h-0{
    max-height: 0;
  }

  .lg\\:max-h-1{
    max-height: 0.25rem;
  }

  .lg\\:max-h-2{
    max-height: 0.5rem;
  }

  .lg\\:max-h-3{
    max-height: 0.75rem;
  }

  .lg\\:max-h-4{
    max-height: 1rem;
  }

  .lg\\:max-h-5{
    max-height: 1.25rem;
  }

  .lg\\:max-h-6{
    max-height: 1.5rem;
  }

  .lg\\:max-h-7{
    max-height: 1.75rem;
  }

  .lg\\:max-h-8{
    max-height: 2rem;
  }

  .lg\\:max-h-9{
    max-height: 2.25rem;
  }

  .lg\\:max-h-10{
    max-height: 2.5rem;
  }

  .lg\\:max-h-11{
    max-height: 2.75rem;
  }

  .lg\\:max-h-12{
    max-height: 3rem;
  }

  .lg\\:max-h-14{
    max-height: 3.5rem;
  }

  .lg\\:max-h-15{
    max-height: 3.75rem;
  }

  .lg\\:max-h-16{
    max-height: 4rem;
  }

  .lg\\:max-h-18{
    max-height: 4.5rem;
  }

  .lg\\:max-h-20{
    max-height: 5rem;
  }

  .lg\\:max-h-22{
    max-height: 5.5rem;
  }

  .lg\\:max-h-23{
    max-height: 5.75rem;
  }

  .lg\\:max-h-24{
    max-height: 6rem;
  }

  .lg\\:max-h-25{
    max-height: 6.25rem;
  }

  .lg\\:max-h-26{
    max-height: 6.5rem;
  }

  .lg\\:max-h-28{
    max-height: 7rem;
  }

  .lg\\:max-h-30{
    max-height: 7.5rem;
  }

  .lg\\:max-h-32{
    max-height: 8rem;
  }

  .lg\\:max-h-34{
    max-height: 8.5rem;
  }

  .lg\\:max-h-40{
    max-height: 10rem;
  }

  .lg\\:max-h-42{
    max-height: 10.5rem;
  }

  .lg\\:max-h-44{
    max-height: 11rem;
  }

  .lg\\:max-h-48{
    max-height: 12rem;
  }

  .lg\\:max-h-52{
    max-height: 13rem;
  }

  .lg\\:max-h-54{
    max-height: 13.5rem;
  }

  .lg\\:max-h-56{
    max-height: 14rem;
  }

  .lg\\:max-h-60{
    max-height: 15rem;
  }

  .lg\\:max-h-64{
    max-height: 16rem;
  }

  .lg\\:max-h-68{
    max-height: 17rem;
  }

  .lg\\:max-h-72{
    max-height: 18rem;
  }

  .lg\\:max-h-74{
    max-height: 18.5rem;
  }

  .lg\\:max-h-76{
    max-height: 19rem;
  }

  .lg\\:max-h-78{
    max-height: 19.5rem;
  }

  .lg\\:max-h-80{
    max-height: 20rem;
  }

  .lg\\:max-h-82{
    max-height: 20.5rem;
  }

  .lg\\:max-h-84{
    max-height: 21rem;
  }

  .lg\\:max-h-88{
    max-height: 22rem;
  }

  .lg\\:max-h-92{
    max-height: 23rem;
  }

  .lg\\:max-h-96{
    max-height: 24rem;
  }

  .lg\\:max-h-98{
    max-height: 24.5rem;
  }

  .lg\\:max-h-100{
    max-height: 25rem;
  }

  .lg\\:max-h-104{
    max-height: 26rem;
  }

  .lg\\:max-h-112{
    max-height: 28rem;
  }

  .lg\\:max-h-124{
    max-height: 31rem;
  }

  .lg\\:max-h-128{
    max-height: 32rem;
  }

  .lg\\:max-h-140{
    max-height: 35rem;
  }

  .lg\\:max-h-152{
    max-height: 38rem;
  }

  .lg\\:max-h-160{
    max-height: 40rem;
  }

  .lg\\:max-h-162{
    max-height: 41rem;
  }

  .lg\\:max-h-192{
    max-height: 48rem;
  }

  .lg\\:max-h-208{
    max-height: 52rem;
  }

  .lg\\:max-h-224{
    max-height: 56rem;
  }

  .lg\\:max-h-256{
    max-height: 64rem;
  }

  .lg\\:max-h-px{
    max-height: 1px;
  }

  .lg\\:max-h-full{
    max-height: 100%;
  }

  .lg\\:max-h-screen{
    max-height: 100vh;
  }

  .lg\\:max-w-0{
    max-width: 0;
  }

  .lg\\:max-w-1{
    max-width: 0.25rem;
  }

  .lg\\:max-w-2{
    max-width: 0.5rem;
  }

  .lg\\:max-w-3{
    max-width: 0.75rem;
  }

  .lg\\:max-w-4{
    max-width: 1rem;
  }

  .lg\\:max-w-5{
    max-width: 1.25rem;
  }

  .lg\\:max-w-6{
    max-width: 1.5rem;
  }

  .lg\\:max-w-7{
    max-width: 1.75rem;
  }

  .lg\\:max-w-8{
    max-width: 2rem;
  }

  .lg\\:max-w-9{
    max-width: 2.25rem;
  }

  .lg\\:max-w-10{
    max-width: 2.5rem;
  }

  .lg\\:max-w-11{
    max-width: 2.75rem;
  }

  .lg\\:max-w-12{
    max-width: 3rem;
  }

  .lg\\:max-w-14{
    max-width: 3.5rem;
  }

  .lg\\:max-w-15{
    max-width: 3.75rem;
  }

  .lg\\:max-w-16{
    max-width: 4rem;
  }

  .lg\\:max-w-18{
    max-width: 4.5rem;
  }

  .lg\\:max-w-20{
    max-width: 5rem;
  }

  .lg\\:max-w-22{
    max-width: 5.5rem;
  }

  .lg\\:max-w-23{
    max-width: 5.75rem;
  }

  .lg\\:max-w-24{
    max-width: 6rem;
  }

  .lg\\:max-w-25{
    max-width: 6.25rem;
  }

  .lg\\:max-w-26{
    max-width: 6.5rem;
  }

  .lg\\:max-w-28{
    max-width: 7rem;
  }

  .lg\\:max-w-30{
    max-width: 7.5rem;
  }

  .lg\\:max-w-32{
    max-width: 8rem;
  }

  .lg\\:max-w-34{
    max-width: 8.5rem;
  }

  .lg\\:max-w-40{
    max-width: 10rem;
  }

  .lg\\:max-w-42{
    max-width: 10.5rem;
  }

  .lg\\:max-w-44{
    max-width: 11rem;
  }

  .lg\\:max-w-48{
    max-width: 12rem;
  }

  .lg\\:max-w-52{
    max-width: 13rem;
  }

  .lg\\:max-w-54{
    max-width: 13.5rem;
  }

  .lg\\:max-w-56{
    max-width: 14rem;
  }

  .lg\\:max-w-60{
    max-width: 15rem;
  }

  .lg\\:max-w-64{
    max-width: 16rem;
  }

  .lg\\:max-w-68{
    max-width: 17rem;
  }

  .lg\\:max-w-72{
    max-width: 18rem;
  }

  .lg\\:max-w-74{
    max-width: 18.5rem;
  }

  .lg\\:max-w-76{
    max-width: 19rem;
  }

  .lg\\:max-w-78{
    max-width: 19.5rem;
  }

  .lg\\:max-w-80{
    max-width: 20rem;
  }

  .lg\\:max-w-82{
    max-width: 20.5rem;
  }

  .lg\\:max-w-84{
    max-width: 21rem;
  }

  .lg\\:max-w-88{
    max-width: 22rem;
  }

  .lg\\:max-w-92{
    max-width: 23rem;
  }

  .lg\\:max-w-96{
    max-width: 24rem;
  }

  .lg\\:max-w-98{
    max-width: 24.5rem;
  }

  .lg\\:max-w-100{
    max-width: 25rem;
  }

  .lg\\:max-w-104{
    max-width: 26rem;
  }

  .lg\\:max-w-112{
    max-width: 28rem;
  }

  .lg\\:max-w-124{
    max-width: 31rem;
  }

  .lg\\:max-w-128{
    max-width: 32rem;
  }

  .lg\\:max-w-140{
    max-width: 35rem;
  }

  .lg\\:max-w-152{
    max-width: 38rem;
  }

  .lg\\:max-w-160{
    max-width: 40rem;
  }

  .lg\\:max-w-162{
    max-width: 41rem;
  }

  .lg\\:max-w-192{
    max-width: 48rem;
  }

  .lg\\:max-w-208{
    max-width: 52rem;
  }

  .lg\\:max-w-224{
    max-width: 56rem;
  }

  .lg\\:max-w-256{
    max-width: 64rem;
  }

  .lg\\:max-w-none{
    max-width: none;
  }

  .lg\\:max-w-xs{
    max-width: 20rem;
  }

  .lg\\:max-w-sm{
    max-width: 24rem;
  }

  .lg\\:max-w-md{
    max-width: 28rem;
  }

  .lg\\:max-w-lg{
    max-width: 32rem;
  }

  .lg\\:max-w-xl{
    max-width: 36rem;
  }

  .lg\\:max-w-2xl{
    max-width: 42rem;
  }

  .lg\\:max-w-3xl{
    max-width: 48rem;
  }

  .lg\\:max-w-4xl{
    max-width: 56rem;
  }

  .lg\\:max-w-5xl{
    max-width: 64rem;
  }

  .lg\\:max-w-6xl{
    max-width: 76rem;
  }

  .lg\\:max-w-7xl{
    max-width: 92rem;
  }

  .lg\\:max-w-8xl{
    max-width: 112rem;
  }

  .lg\\:max-w-9xl{
    max-width: 130rem;
  }

  .lg\\:max-w-full{
    max-width: 100%;
  }

  .lg\\:max-w-px{
    max-width: 1px;
  }

  .lg\\:min-h-0{
    min-height: 0;
  }

  .lg\\:min-h-1{
    min-height: 0.25rem;
  }

  .lg\\:min-h-2{
    min-height: 0.5rem;
  }

  .lg\\:min-h-3{
    min-height: 0.75rem;
  }

  .lg\\:min-h-4{
    min-height: 1rem;
  }

  .lg\\:min-h-5{
    min-height: 1.25rem;
  }

  .lg\\:min-h-6{
    min-height: 1.5rem;
  }

  .lg\\:min-h-7{
    min-height: 1.75rem;
  }

  .lg\\:min-h-8{
    min-height: 2rem;
  }

  .lg\\:min-h-9{
    min-height: 2.25rem;
  }

  .lg\\:min-h-10{
    min-height: 2.5rem;
  }

  .lg\\:min-h-11{
    min-height: 2.75rem;
  }

  .lg\\:min-h-12{
    min-height: 3rem;
  }

  .lg\\:min-h-14{
    min-height: 3.5rem;
  }

  .lg\\:min-h-15{
    min-height: 3.75rem;
  }

  .lg\\:min-h-16{
    min-height: 4rem;
  }

  .lg\\:min-h-18{
    min-height: 4.5rem;
  }

  .lg\\:min-h-20{
    min-height: 5rem;
  }

  .lg\\:min-h-22{
    min-height: 5.5rem;
  }

  .lg\\:min-h-23{
    min-height: 5.75rem;
  }

  .lg\\:min-h-24{
    min-height: 6rem;
  }

  .lg\\:min-h-25{
    min-height: 6.25rem;
  }

  .lg\\:min-h-26{
    min-height: 6.5rem;
  }

  .lg\\:min-h-28{
    min-height: 7rem;
  }

  .lg\\:min-h-30{
    min-height: 7.5rem;
  }

  .lg\\:min-h-32{
    min-height: 8rem;
  }

  .lg\\:min-h-34{
    min-height: 8.5rem;
  }

  .lg\\:min-h-40{
    min-height: 10rem;
  }

  .lg\\:min-h-42{
    min-height: 10.5rem;
  }

  .lg\\:min-h-44{
    min-height: 11rem;
  }

  .lg\\:min-h-48{
    min-height: 12rem;
  }

  .lg\\:min-h-52{
    min-height: 13rem;
  }

  .lg\\:min-h-54{
    min-height: 13.5rem;
  }

  .lg\\:min-h-56{
    min-height: 14rem;
  }

  .lg\\:min-h-60{
    min-height: 15rem;
  }

  .lg\\:min-h-64{
    min-height: 16rem;
  }

  .lg\\:min-h-68{
    min-height: 17rem;
  }

  .lg\\:min-h-72{
    min-height: 18rem;
  }

  .lg\\:min-h-74{
    min-height: 18.5rem;
  }

  .lg\\:min-h-76{
    min-height: 19rem;
  }

  .lg\\:min-h-78{
    min-height: 19.5rem;
  }

  .lg\\:min-h-80{
    min-height: 20rem;
  }

  .lg\\:min-h-82{
    min-height: 20.5rem;
  }

  .lg\\:min-h-84{
    min-height: 21rem;
  }

  .lg\\:min-h-88{
    min-height: 22rem;
  }

  .lg\\:min-h-92{
    min-height: 23rem;
  }

  .lg\\:min-h-96{
    min-height: 24rem;
  }

  .lg\\:min-h-98{
    min-height: 24.5rem;
  }

  .lg\\:min-h-100{
    min-height: 25rem;
  }

  .lg\\:min-h-104{
    min-height: 26rem;
  }

  .lg\\:min-h-112{
    min-height: 28rem;
  }

  .lg\\:min-h-124{
    min-height: 31rem;
  }

  .lg\\:min-h-128{
    min-height: 32rem;
  }

  .lg\\:min-h-140{
    min-height: 35rem;
  }

  .lg\\:min-h-152{
    min-height: 38rem;
  }

  .lg\\:min-h-160{
    min-height: 40rem;
  }

  .lg\\:min-h-162{
    min-height: 41rem;
  }

  .lg\\:min-h-192{
    min-height: 48rem;
  }

  .lg\\:min-h-208{
    min-height: 52rem;
  }

  .lg\\:min-h-224{
    min-height: 56rem;
  }

  .lg\\:min-h-256{
    min-height: 64rem;
  }

  .lg\\:min-h-full{
    min-height: 100%;
  }

  .lg\\:min-h-px{
    min-height: 1px;
  }

  .lg\\:min-h-screen{
    min-height: 100vh;
  }

  .lg\\:min-w-0{
    min-width: 0;
  }

  .lg\\:min-w-1{
    min-width: 0.25rem;
  }

  .lg\\:min-w-2{
    min-width: 0.5rem;
  }

  .lg\\:min-w-3{
    min-width: 0.75rem;
  }

  .lg\\:min-w-4{
    min-width: 1rem;
  }

  .lg\\:min-w-5{
    min-width: 1.25rem;
  }

  .lg\\:min-w-6{
    min-width: 1.5rem;
  }

  .lg\\:min-w-7{
    min-width: 1.75rem;
  }

  .lg\\:min-w-8{
    min-width: 2rem;
  }

  .lg\\:min-w-9{
    min-width: 2.25rem;
  }

  .lg\\:min-w-10{
    min-width: 2.5rem;
  }

  .lg\\:min-w-11{
    min-width: 2.75rem;
  }

  .lg\\:min-w-12{
    min-width: 3rem;
  }

  .lg\\:min-w-14{
    min-width: 3.5rem;
  }

  .lg\\:min-w-15{
    min-width: 3.75rem;
  }

  .lg\\:min-w-16{
    min-width: 4rem;
  }

  .lg\\:min-w-18{
    min-width: 4.5rem;
  }

  .lg\\:min-w-20{
    min-width: 5rem;
  }

  .lg\\:min-w-22{
    min-width: 5.5rem;
  }

  .lg\\:min-w-23{
    min-width: 5.75rem;
  }

  .lg\\:min-w-24{
    min-width: 6rem;
  }

  .lg\\:min-w-25{
    min-width: 6.25rem;
  }

  .lg\\:min-w-26{
    min-width: 6.5rem;
  }

  .lg\\:min-w-28{
    min-width: 7rem;
  }

  .lg\\:min-w-30{
    min-width: 7.5rem;
  }

  .lg\\:min-w-32{
    min-width: 8rem;
  }

  .lg\\:min-w-34{
    min-width: 8.5rem;
  }

  .lg\\:min-w-40{
    min-width: 10rem;
  }

  .lg\\:min-w-42{
    min-width: 10.5rem;
  }

  .lg\\:min-w-44{
    min-width: 11rem;
  }

  .lg\\:min-w-48{
    min-width: 12rem;
  }

  .lg\\:min-w-52{
    min-width: 13rem;
  }

  .lg\\:min-w-54{
    min-width: 13.5rem;
  }

  .lg\\:min-w-56{
    min-width: 14rem;
  }

  .lg\\:min-w-60{
    min-width: 15rem;
  }

  .lg\\:min-w-64{
    min-width: 16rem;
  }

  .lg\\:min-w-68{
    min-width: 17rem;
  }

  .lg\\:min-w-72{
    min-width: 18rem;
  }

  .lg\\:min-w-74{
    min-width: 18.5rem;
  }

  .lg\\:min-w-76{
    min-width: 19rem;
  }

  .lg\\:min-w-78{
    min-width: 19.5rem;
  }

  .lg\\:min-w-80{
    min-width: 20rem;
  }

  .lg\\:min-w-82{
    min-width: 20.5rem;
  }

  .lg\\:min-w-84{
    min-width: 21rem;
  }

  .lg\\:min-w-88{
    min-width: 22rem;
  }

  .lg\\:min-w-92{
    min-width: 23rem;
  }

  .lg\\:min-w-96{
    min-width: 24rem;
  }

  .lg\\:min-w-98{
    min-width: 24.5rem;
  }

  .lg\\:min-w-100{
    min-width: 25rem;
  }

  .lg\\:min-w-104{
    min-width: 26rem;
  }

  .lg\\:min-w-112{
    min-width: 28rem;
  }

  .lg\\:min-w-124{
    min-width: 31rem;
  }

  .lg\\:min-w-128{
    min-width: 32rem;
  }

  .lg\\:min-w-140{
    min-width: 35rem;
  }

  .lg\\:min-w-152{
    min-width: 38rem;
  }

  .lg\\:min-w-160{
    min-width: 40rem;
  }

  .lg\\:min-w-162{
    min-width: 41rem;
  }

  .lg\\:min-w-192{
    min-width: 48rem;
  }

  .lg\\:min-w-208{
    min-width: 52rem;
  }

  .lg\\:min-w-224{
    min-width: 56rem;
  }

  .lg\\:min-w-256{
    min-width: 64rem;
  }

  .lg\\:min-w-px{
    min-width: 1px;
  }

  .lg\\:min-w-full{
    min-width: 100%;
  }

  .lg\\:object-contain{
    object-fit: contain;
  }

  .lg\\:object-cover{
    object-fit: cover;
  }

  .lg\\:object-fill{
    object-fit: fill;
  }

  .lg\\:object-none{
    object-fit: none;
  }

  .lg\\:object-scale-down{
    object-fit: scale-down;
  }

  .lg\\:object-bottom{
    object-position: bottom;
  }

  .lg\\:object-center{
    object-position: center;
  }

  .lg\\:object-left{
    object-position: left;
  }

  .lg\\:object-left-bottom{
    object-position: left bottom;
  }

  .lg\\:object-left-top{
    object-position: left top;
  }

  .lg\\:object-right{
    object-position: right;
  }

  .lg\\:object-right-bottom{
    object-position: right bottom;
  }

  .lg\\:object-right-top{
    object-position: right top;
  }

  .lg\\:object-top{
    object-position: top;
  }

  .lg\\:opacity-0{
    opacity: 0;
  }

  .lg\\:opacity-25{
    opacity: .25;
  }

  .lg\\:opacity-50{
    opacity: .5;
  }

  .lg\\:opacity-75{
    opacity: .75;
  }

  .lg\\:opacity-100{
    opacity: 1;
  }

  .lg\\:overflow-auto{
    overflow: auto;
  }

  .lg\\:overflow-hidden{
    overflow: hidden;
  }

  .lg\\:overflow-visible{
    overflow: visible;
  }

  .lg\\:overflow-scroll{
    overflow: scroll;
  }

  .lg\\:overflow-x-auto{
    overflow-x: auto;
  }

  .lg\\:overflow-y-auto{
    overflow-y: auto;
  }

  .lg\\:overflow-x-hidden{
    overflow-x: hidden;
  }

  .lg\\:overflow-y-hidden{
    overflow-y: hidden;
  }

  .lg\\:overflow-x-visible{
    overflow-x: visible;
  }

  .lg\\:overflow-y-visible{
    overflow-y: visible;
  }

  .lg\\:overflow-x-scroll{
    overflow-x: scroll;
  }

  .lg\\:overflow-y-scroll{
    overflow-y: scroll;
  }

  .lg\\:scrolling-touch{
    -webkit-overflow-scrolling: touch;
  }

  .lg\\:scrolling-auto{
    -webkit-overflow-scrolling: auto;
  }

  .lg\\:overscroll-auto{
    overscroll-behavior: auto;
  }

  .lg\\:overscroll-contain{
    overscroll-behavior: contain;
  }

  .lg\\:overscroll-none{
    overscroll-behavior: none;
  }

  .lg\\:overscroll-y-auto{
    overscroll-behavior-y: auto;
  }

  .lg\\:overscroll-y-contain{
    overscroll-behavior-y: contain;
  }

  .lg\\:overscroll-y-none{
    overscroll-behavior-y: none;
  }

  .lg\\:overscroll-x-auto{
    overscroll-behavior-x: auto;
  }

  .lg\\:overscroll-x-contain{
    overscroll-behavior-x: contain;
  }

  .lg\\:overscroll-x-none{
    overscroll-behavior-x: none;
  }

  .lg\\:p-0{
    padding: 0;
  }

  .lg\\:p-1{
    padding: 0.25rem;
  }

  .lg\\:p-2{
    padding: 0.5rem;
  }

  .lg\\:p-3{
    padding: 0.75rem;
  }

  .lg\\:p-4{
    padding: 1rem;
  }

  .lg\\:p-5{
    padding: 1.25rem;
  }

  .lg\\:p-6{
    padding: 1.5rem;
  }

  .lg\\:p-7{
    padding: 1.75rem;
  }

  .lg\\:p-8{
    padding: 2rem;
  }

  .lg\\:p-9{
    padding: 2.25rem;
  }

  .lg\\:p-10{
    padding: 2.5rem;
  }

  .lg\\:p-11{
    padding: 2.75rem;
  }

  .lg\\:p-12{
    padding: 3rem;
  }

  .lg\\:p-14{
    padding: 3.5rem;
  }

  .lg\\:p-15{
    padding: 3.75rem;
  }

  .lg\\:p-16{
    padding: 4rem;
  }

  .lg\\:p-18{
    padding: 4.5rem;
  }

  .lg\\:p-20{
    padding: 5rem;
  }

  .lg\\:p-22{
    padding: 5.5rem;
  }

  .lg\\:p-23{
    padding: 5.75rem;
  }

  .lg\\:p-24{
    padding: 6rem;
  }

  .lg\\:p-25{
    padding: 6.25rem;
  }

  .lg\\:p-26{
    padding: 6.5rem;
  }

  .lg\\:p-28{
    padding: 7rem;
  }

  .lg\\:p-30{
    padding: 7.5rem;
  }

  .lg\\:p-32{
    padding: 8rem;
  }

  .lg\\:p-34{
    padding: 8.5rem;
  }

  .lg\\:p-40{
    padding: 10rem;
  }

  .lg\\:p-42{
    padding: 10.5rem;
  }

  .lg\\:p-44{
    padding: 11rem;
  }

  .lg\\:p-48{
    padding: 12rem;
  }

  .lg\\:p-52{
    padding: 13rem;
  }

  .lg\\:p-54{
    padding: 13.5rem;
  }

  .lg\\:p-56{
    padding: 14rem;
  }

  .lg\\:p-60{
    padding: 15rem;
  }

  .lg\\:p-64{
    padding: 16rem;
  }

  .lg\\:p-68{
    padding: 17rem;
  }

  .lg\\:p-72{
    padding: 18rem;
  }

  .lg\\:p-74{
    padding: 18.5rem;
  }

  .lg\\:p-76{
    padding: 19rem;
  }

  .lg\\:p-78{
    padding: 19.5rem;
  }

  .lg\\:p-80{
    padding: 20rem;
  }

  .lg\\:p-82{
    padding: 20.5rem;
  }

  .lg\\:p-84{
    padding: 21rem;
  }

  .lg\\:p-88{
    padding: 22rem;
  }

  .lg\\:p-92{
    padding: 23rem;
  }

  .lg\\:p-96{
    padding: 24rem;
  }

  .lg\\:p-98{
    padding: 24.5rem;
  }

  .lg\\:p-100{
    padding: 25rem;
  }

  .lg\\:p-104{
    padding: 26rem;
  }

  .lg\\:p-112{
    padding: 28rem;
  }

  .lg\\:p-124{
    padding: 31rem;
  }

  .lg\\:p-128{
    padding: 32rem;
  }

  .lg\\:p-140{
    padding: 35rem;
  }

  .lg\\:p-152{
    padding: 38rem;
  }

  .lg\\:p-160{
    padding: 40rem;
  }

  .lg\\:p-162{
    padding: 41rem;
  }

  .lg\\:p-192{
    padding: 48rem;
  }

  .lg\\:p-208{
    padding: 52rem;
  }

  .lg\\:p-224{
    padding: 56rem;
  }

  .lg\\:p-256{
    padding: 64rem;
  }

  .lg\\:p-px{
    padding: 1px;
  }

  .lg\\:py-0{
    padding-top: 0;
    padding-bottom: 0;
  }

  .lg\\:px-0{
    padding-left: 0;
    padding-right: 0;
  }

  .lg\\:py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .lg\\:px-1{
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .lg\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .lg\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .lg\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .lg\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .lg\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .lg\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .lg\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .lg\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .lg\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:py-7{
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .lg\\:px-7{
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .lg\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .lg\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:py-9{
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .lg\\:px-9{
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .lg\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .lg\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:py-11{
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .lg\\:px-11{
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .lg\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .lg\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:py-14{
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .lg\\:px-14{
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .lg\\:py-15{
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .lg\\:px-15{
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .lg\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .lg\\:px-16{
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .lg\\:py-18{
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .lg\\:px-18{
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .lg\\:py-20{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .lg\\:px-20{
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .lg\\:py-22{
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .lg\\:px-22{
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .lg\\:py-23{
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .lg\\:px-23{
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .lg\\:py-24{
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .lg\\:px-24{
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .lg\\:py-25{
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .lg\\:px-25{
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .lg\\:py-26{
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .lg\\:px-26{
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .lg\\:py-28{
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .lg\\:px-28{
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .lg\\:py-30{
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .lg\\:px-30{
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .lg\\:py-32{
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .lg\\:px-32{
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .lg\\:py-34{
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .lg\\:px-34{
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .lg\\:py-40{
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .lg\\:px-40{
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .lg\\:py-42{
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .lg\\:px-42{
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .lg\\:py-44{
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .lg\\:px-44{
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .lg\\:py-48{
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .lg\\:px-48{
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .lg\\:py-52{
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .lg\\:px-52{
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .lg\\:py-54{
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .lg\\:px-54{
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .lg\\:py-56{
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .lg\\:px-56{
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .lg\\:py-60{
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .lg\\:px-60{
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .lg\\:py-64{
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .lg\\:px-64{
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .lg\\:py-68{
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .lg\\:px-68{
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .lg\\:py-72{
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .lg\\:px-72{
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .lg\\:py-74{
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .lg\\:px-74{
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .lg\\:py-76{
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .lg\\:px-76{
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .lg\\:py-78{
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .lg\\:px-78{
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .lg\\:py-80{
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .lg\\:px-80{
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .lg\\:py-82{
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .lg\\:px-82{
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .lg\\:py-84{
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .lg\\:px-84{
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .lg\\:py-88{
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .lg\\:px-88{
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .lg\\:py-92{
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .lg\\:px-92{
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .lg\\:py-96{
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .lg\\:px-96{
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .lg\\:py-98{
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .lg\\:px-98{
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .lg\\:py-100{
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .lg\\:px-100{
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .lg\\:py-104{
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .lg\\:px-104{
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .lg\\:py-112{
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .lg\\:px-112{
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .lg\\:py-124{
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .lg\\:px-124{
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .lg\\:py-128{
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .lg\\:px-128{
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .lg\\:py-140{
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .lg\\:px-140{
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .lg\\:py-152{
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .lg\\:px-152{
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .lg\\:py-160{
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .lg\\:px-160{
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .lg\\:py-162{
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .lg\\:px-162{
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .lg\\:py-192{
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .lg\\:px-192{
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .lg\\:py-208{
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .lg\\:px-208{
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .lg\\:py-224{
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .lg\\:px-224{
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .lg\\:py-256{
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .lg\\:px-256{
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .lg\\:py-px{
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .lg\\:px-px{
    padding-left: 1px;
    padding-right: 1px;
  }

  .lg\\:pt-0{
    padding-top: 0;
  }

  .lg\\:pr-0{
    padding-right: 0;
  }

  .lg\\:pb-0{
    padding-bottom: 0;
  }

  .lg\\:pl-0{
    padding-left: 0;
  }

  .lg\\:pt-1{
    padding-top: 0.25rem;
  }

  .lg\\:pr-1{
    padding-right: 0.25rem;
  }

  .lg\\:pb-1{
    padding-bottom: 0.25rem;
  }

  .lg\\:pl-1{
    padding-left: 0.25rem;
  }

  .lg\\:pt-2{
    padding-top: 0.5rem;
  }

  .lg\\:pr-2{
    padding-right: 0.5rem;
  }

  .lg\\:pb-2{
    padding-bottom: 0.5rem;
  }

  .lg\\:pl-2{
    padding-left: 0.5rem;
  }

  .lg\\:pt-3{
    padding-top: 0.75rem;
  }

  .lg\\:pr-3{
    padding-right: 0.75rem;
  }

  .lg\\:pb-3{
    padding-bottom: 0.75rem;
  }

  .lg\\:pl-3{
    padding-left: 0.75rem;
  }

  .lg\\:pt-4{
    padding-top: 1rem;
  }

  .lg\\:pr-4{
    padding-right: 1rem;
  }

  .lg\\:pb-4{
    padding-bottom: 1rem;
  }

  .lg\\:pl-4{
    padding-left: 1rem;
  }

  .lg\\:pt-5{
    padding-top: 1.25rem;
  }

  .lg\\:pr-5{
    padding-right: 1.25rem;
  }

  .lg\\:pb-5{
    padding-bottom: 1.25rem;
  }

  .lg\\:pl-5{
    padding-left: 1.25rem;
  }

  .lg\\:pt-6{
    padding-top: 1.5rem;
  }

  .lg\\:pr-6{
    padding-right: 1.5rem;
  }

  .lg\\:pb-6{
    padding-bottom: 1.5rem;
  }

  .lg\\:pl-6{
    padding-left: 1.5rem;
  }

  .lg\\:pt-7{
    padding-top: 1.75rem;
  }

  .lg\\:pr-7{
    padding-right: 1.75rem;
  }

  .lg\\:pb-7{
    padding-bottom: 1.75rem;
  }

  .lg\\:pl-7{
    padding-left: 1.75rem;
  }

  .lg\\:pt-8{
    padding-top: 2rem;
  }

  .lg\\:pr-8{
    padding-right: 2rem;
  }

  .lg\\:pb-8{
    padding-bottom: 2rem;
  }

  .lg\\:pl-8{
    padding-left: 2rem;
  }

  .lg\\:pt-9{
    padding-top: 2.25rem;
  }

  .lg\\:pr-9{
    padding-right: 2.25rem;
  }

  .lg\\:pb-9{
    padding-bottom: 2.25rem;
  }

  .lg\\:pl-9{
    padding-left: 2.25rem;
  }

  .lg\\:pt-10{
    padding-top: 2.5rem;
  }

  .lg\\:pr-10{
    padding-right: 2.5rem;
  }

  .lg\\:pb-10{
    padding-bottom: 2.5rem;
  }

  .lg\\:pl-10{
    padding-left: 2.5rem;
  }

  .lg\\:pt-11{
    padding-top: 2.75rem;
  }

  .lg\\:pr-11{
    padding-right: 2.75rem;
  }

  .lg\\:pb-11{
    padding-bottom: 2.75rem;
  }

  .lg\\:pl-11{
    padding-left: 2.75rem;
  }

  .lg\\:pt-12{
    padding-top: 3rem;
  }

  .lg\\:pr-12{
    padding-right: 3rem;
  }

  .lg\\:pb-12{
    padding-bottom: 3rem;
  }

  .lg\\:pl-12{
    padding-left: 3rem;
  }

  .lg\\:pt-14{
    padding-top: 3.5rem;
  }

  .lg\\:pr-14{
    padding-right: 3.5rem;
  }

  .lg\\:pb-14{
    padding-bottom: 3.5rem;
  }

  .lg\\:pl-14{
    padding-left: 3.5rem;
  }

  .lg\\:pt-15{
    padding-top: 3.75rem;
  }

  .lg\\:pr-15{
    padding-right: 3.75rem;
  }

  .lg\\:pb-15{
    padding-bottom: 3.75rem;
  }

  .lg\\:pl-15{
    padding-left: 3.75rem;
  }

  .lg\\:pt-16{
    padding-top: 4rem;
  }

  .lg\\:pr-16{
    padding-right: 4rem;
  }

  .lg\\:pb-16{
    padding-bottom: 4rem;
  }

  .lg\\:pl-16{
    padding-left: 4rem;
  }

  .lg\\:pt-18{
    padding-top: 4.5rem;
  }

  .lg\\:pr-18{
    padding-right: 4.5rem;
  }

  .lg\\:pb-18{
    padding-bottom: 4.5rem;
  }

  .lg\\:pl-18{
    padding-left: 4.5rem;
  }

  .lg\\:pt-20{
    padding-top: 5rem;
  }

  .lg\\:pr-20{
    padding-right: 5rem;
  }

  .lg\\:pb-20{
    padding-bottom: 5rem;
  }

  .lg\\:pl-20{
    padding-left: 5rem;
  }

  .lg\\:pt-22{
    padding-top: 5.5rem;
  }

  .lg\\:pr-22{
    padding-right: 5.5rem;
  }

  .lg\\:pb-22{
    padding-bottom: 5.5rem;
  }

  .lg\\:pl-22{
    padding-left: 5.5rem;
  }

  .lg\\:pt-23{
    padding-top: 5.75rem;
  }

  .lg\\:pr-23{
    padding-right: 5.75rem;
  }

  .lg\\:pb-23{
    padding-bottom: 5.75rem;
  }

  .lg\\:pl-23{
    padding-left: 5.75rem;
  }

  .lg\\:pt-24{
    padding-top: 6rem;
  }

  .lg\\:pr-24{
    padding-right: 6rem;
  }

  .lg\\:pb-24{
    padding-bottom: 6rem;
  }

  .lg\\:pl-24{
    padding-left: 6rem;
  }

  .lg\\:pt-25{
    padding-top: 6.25rem;
  }

  .lg\\:pr-25{
    padding-right: 6.25rem;
  }

  .lg\\:pb-25{
    padding-bottom: 6.25rem;
  }

  .lg\\:pl-25{
    padding-left: 6.25rem;
  }

  .lg\\:pt-26{
    padding-top: 6.5rem;
  }

  .lg\\:pr-26{
    padding-right: 6.5rem;
  }

  .lg\\:pb-26{
    padding-bottom: 6.5rem;
  }

  .lg\\:pl-26{
    padding-left: 6.5rem;
  }

  .lg\\:pt-28{
    padding-top: 7rem;
  }

  .lg\\:pr-28{
    padding-right: 7rem;
  }

  .lg\\:pb-28{
    padding-bottom: 7rem;
  }

  .lg\\:pl-28{
    padding-left: 7rem;
  }

  .lg\\:pt-30{
    padding-top: 7.5rem;
  }

  .lg\\:pr-30{
    padding-right: 7.5rem;
  }

  .lg\\:pb-30{
    padding-bottom: 7.5rem;
  }

  .lg\\:pl-30{
    padding-left: 7.5rem;
  }

  .lg\\:pt-32{
    padding-top: 8rem;
  }

  .lg\\:pr-32{
    padding-right: 8rem;
  }

  .lg\\:pb-32{
    padding-bottom: 8rem;
  }

  .lg\\:pl-32{
    padding-left: 8rem;
  }

  .lg\\:pt-34{
    padding-top: 8.5rem;
  }

  .lg\\:pr-34{
    padding-right: 8.5rem;
  }

  .lg\\:pb-34{
    padding-bottom: 8.5rem;
  }

  .lg\\:pl-34{
    padding-left: 8.5rem;
  }

  .lg\\:pt-40{
    padding-top: 10rem;
  }

  .lg\\:pr-40{
    padding-right: 10rem;
  }

  .lg\\:pb-40{
    padding-bottom: 10rem;
  }

  .lg\\:pl-40{
    padding-left: 10rem;
  }

  .lg\\:pt-42{
    padding-top: 10.5rem;
  }

  .lg\\:pr-42{
    padding-right: 10.5rem;
  }

  .lg\\:pb-42{
    padding-bottom: 10.5rem;
  }

  .lg\\:pl-42{
    padding-left: 10.5rem;
  }

  .lg\\:pt-44{
    padding-top: 11rem;
  }

  .lg\\:pr-44{
    padding-right: 11rem;
  }

  .lg\\:pb-44{
    padding-bottom: 11rem;
  }

  .lg\\:pl-44{
    padding-left: 11rem;
  }

  .lg\\:pt-48{
    padding-top: 12rem;
  }

  .lg\\:pr-48{
    padding-right: 12rem;
  }

  .lg\\:pb-48{
    padding-bottom: 12rem;
  }

  .lg\\:pl-48{
    padding-left: 12rem;
  }

  .lg\\:pt-52{
    padding-top: 13rem;
  }

  .lg\\:pr-52{
    padding-right: 13rem;
  }

  .lg\\:pb-52{
    padding-bottom: 13rem;
  }

  .lg\\:pl-52{
    padding-left: 13rem;
  }

  .lg\\:pt-54{
    padding-top: 13.5rem;
  }

  .lg\\:pr-54{
    padding-right: 13.5rem;
  }

  .lg\\:pb-54{
    padding-bottom: 13.5rem;
  }

  .lg\\:pl-54{
    padding-left: 13.5rem;
  }

  .lg\\:pt-56{
    padding-top: 14rem;
  }

  .lg\\:pr-56{
    padding-right: 14rem;
  }

  .lg\\:pb-56{
    padding-bottom: 14rem;
  }

  .lg\\:pl-56{
    padding-left: 14rem;
  }

  .lg\\:pt-60{
    padding-top: 15rem;
  }

  .lg\\:pr-60{
    padding-right: 15rem;
  }

  .lg\\:pb-60{
    padding-bottom: 15rem;
  }

  .lg\\:pl-60{
    padding-left: 15rem;
  }

  .lg\\:pt-64{
    padding-top: 16rem;
  }

  .lg\\:pr-64{
    padding-right: 16rem;
  }

  .lg\\:pb-64{
    padding-bottom: 16rem;
  }

  .lg\\:pl-64{
    padding-left: 16rem;
  }

  .lg\\:pt-68{
    padding-top: 17rem;
  }

  .lg\\:pr-68{
    padding-right: 17rem;
  }

  .lg\\:pb-68{
    padding-bottom: 17rem;
  }

  .lg\\:pl-68{
    padding-left: 17rem;
  }

  .lg\\:pt-72{
    padding-top: 18rem;
  }

  .lg\\:pr-72{
    padding-right: 18rem;
  }

  .lg\\:pb-72{
    padding-bottom: 18rem;
  }

  .lg\\:pl-72{
    padding-left: 18rem;
  }

  .lg\\:pt-74{
    padding-top: 18.5rem;
  }

  .lg\\:pr-74{
    padding-right: 18.5rem;
  }

  .lg\\:pb-74{
    padding-bottom: 18.5rem;
  }

  .lg\\:pl-74{
    padding-left: 18.5rem;
  }

  .lg\\:pt-76{
    padding-top: 19rem;
  }

  .lg\\:pr-76{
    padding-right: 19rem;
  }

  .lg\\:pb-76{
    padding-bottom: 19rem;
  }

  .lg\\:pl-76{
    padding-left: 19rem;
  }

  .lg\\:pt-78{
    padding-top: 19.5rem;
  }

  .lg\\:pr-78{
    padding-right: 19.5rem;
  }

  .lg\\:pb-78{
    padding-bottom: 19.5rem;
  }

  .lg\\:pl-78{
    padding-left: 19.5rem;
  }

  .lg\\:pt-80{
    padding-top: 20rem;
  }

  .lg\\:pr-80{
    padding-right: 20rem;
  }

  .lg\\:pb-80{
    padding-bottom: 20rem;
  }

  .lg\\:pl-80{
    padding-left: 20rem;
  }

  .lg\\:pt-82{
    padding-top: 20.5rem;
  }

  .lg\\:pr-82{
    padding-right: 20.5rem;
  }

  .lg\\:pb-82{
    padding-bottom: 20.5rem;
  }

  .lg\\:pl-82{
    padding-left: 20.5rem;
  }

  .lg\\:pt-84{
    padding-top: 21rem;
  }

  .lg\\:pr-84{
    padding-right: 21rem;
  }

  .lg\\:pb-84{
    padding-bottom: 21rem;
  }

  .lg\\:pl-84{
    padding-left: 21rem;
  }

  .lg\\:pt-88{
    padding-top: 22rem;
  }

  .lg\\:pr-88{
    padding-right: 22rem;
  }

  .lg\\:pb-88{
    padding-bottom: 22rem;
  }

  .lg\\:pl-88{
    padding-left: 22rem;
  }

  .lg\\:pt-92{
    padding-top: 23rem;
  }

  .lg\\:pr-92{
    padding-right: 23rem;
  }

  .lg\\:pb-92{
    padding-bottom: 23rem;
  }

  .lg\\:pl-92{
    padding-left: 23rem;
  }

  .lg\\:pt-96{
    padding-top: 24rem;
  }

  .lg\\:pr-96{
    padding-right: 24rem;
  }

  .lg\\:pb-96{
    padding-bottom: 24rem;
  }

  .lg\\:pl-96{
    padding-left: 24rem;
  }

  .lg\\:pt-98{
    padding-top: 24.5rem;
  }

  .lg\\:pr-98{
    padding-right: 24.5rem;
  }

  .lg\\:pb-98{
    padding-bottom: 24.5rem;
  }

  .lg\\:pl-98{
    padding-left: 24.5rem;
  }

  .lg\\:pt-100{
    padding-top: 25rem;
  }

  .lg\\:pr-100{
    padding-right: 25rem;
  }

  .lg\\:pb-100{
    padding-bottom: 25rem;
  }

  .lg\\:pl-100{
    padding-left: 25rem;
  }

  .lg\\:pt-104{
    padding-top: 26rem;
  }

  .lg\\:pr-104{
    padding-right: 26rem;
  }

  .lg\\:pb-104{
    padding-bottom: 26rem;
  }

  .lg\\:pl-104{
    padding-left: 26rem;
  }

  .lg\\:pt-112{
    padding-top: 28rem;
  }

  .lg\\:pr-112{
    padding-right: 28rem;
  }

  .lg\\:pb-112{
    padding-bottom: 28rem;
  }

  .lg\\:pl-112{
    padding-left: 28rem;
  }

  .lg\\:pt-124{
    padding-top: 31rem;
  }

  .lg\\:pr-124{
    padding-right: 31rem;
  }

  .lg\\:pb-124{
    padding-bottom: 31rem;
  }

  .lg\\:pl-124{
    padding-left: 31rem;
  }

  .lg\\:pt-128{
    padding-top: 32rem;
  }

  .lg\\:pr-128{
    padding-right: 32rem;
  }

  .lg\\:pb-128{
    padding-bottom: 32rem;
  }

  .lg\\:pl-128{
    padding-left: 32rem;
  }

  .lg\\:pt-140{
    padding-top: 35rem;
  }

  .lg\\:pr-140{
    padding-right: 35rem;
  }

  .lg\\:pb-140{
    padding-bottom: 35rem;
  }

  .lg\\:pl-140{
    padding-left: 35rem;
  }

  .lg\\:pt-152{
    padding-top: 38rem;
  }

  .lg\\:pr-152{
    padding-right: 38rem;
  }

  .lg\\:pb-152{
    padding-bottom: 38rem;
  }

  .lg\\:pl-152{
    padding-left: 38rem;
  }

  .lg\\:pt-160{
    padding-top: 40rem;
  }

  .lg\\:pr-160{
    padding-right: 40rem;
  }

  .lg\\:pb-160{
    padding-bottom: 40rem;
  }

  .lg\\:pl-160{
    padding-left: 40rem;
  }

  .lg\\:pt-162{
    padding-top: 41rem;
  }

  .lg\\:pr-162{
    padding-right: 41rem;
  }

  .lg\\:pb-162{
    padding-bottom: 41rem;
  }

  .lg\\:pl-162{
    padding-left: 41rem;
  }

  .lg\\:pt-192{
    padding-top: 48rem;
  }

  .lg\\:pr-192{
    padding-right: 48rem;
  }

  .lg\\:pb-192{
    padding-bottom: 48rem;
  }

  .lg\\:pl-192{
    padding-left: 48rem;
  }

  .lg\\:pt-208{
    padding-top: 52rem;
  }

  .lg\\:pr-208{
    padding-right: 52rem;
  }

  .lg\\:pb-208{
    padding-bottom: 52rem;
  }

  .lg\\:pl-208{
    padding-left: 52rem;
  }

  .lg\\:pt-224{
    padding-top: 56rem;
  }

  .lg\\:pr-224{
    padding-right: 56rem;
  }

  .lg\\:pb-224{
    padding-bottom: 56rem;
  }

  .lg\\:pl-224{
    padding-left: 56rem;
  }

  .lg\\:pt-256{
    padding-top: 64rem;
  }

  .lg\\:pr-256{
    padding-right: 64rem;
  }

  .lg\\:pb-256{
    padding-bottom: 64rem;
  }

  .lg\\:pl-256{
    padding-left: 64rem;
  }

  .lg\\:pt-px{
    padding-top: 1px;
  }

  .lg\\:pr-px{
    padding-right: 1px;
  }

  .lg\\:pb-px{
    padding-bottom: 1px;
  }

  .lg\\:pl-px{
    padding-left: 1px;
  }

  .lg\\:odd\\:p-0:nth-child(odd){
    padding: 0;
  }

  .lg\\:odd\\:p-1:nth-child(odd){
    padding: 0.25rem;
  }

  .lg\\:odd\\:p-2:nth-child(odd){
    padding: 0.5rem;
  }

  .lg\\:odd\\:p-3:nth-child(odd){
    padding: 0.75rem;
  }

  .lg\\:odd\\:p-4:nth-child(odd){
    padding: 1rem;
  }

  .lg\\:odd\\:p-5:nth-child(odd){
    padding: 1.25rem;
  }

  .lg\\:odd\\:p-6:nth-child(odd){
    padding: 1.5rem;
  }

  .lg\\:odd\\:p-7:nth-child(odd){
    padding: 1.75rem;
  }

  .lg\\:odd\\:p-8:nth-child(odd){
    padding: 2rem;
  }

  .lg\\:odd\\:p-9:nth-child(odd){
    padding: 2.25rem;
  }

  .lg\\:odd\\:p-10:nth-child(odd){
    padding: 2.5rem;
  }

  .lg\\:odd\\:p-11:nth-child(odd){
    padding: 2.75rem;
  }

  .lg\\:odd\\:p-12:nth-child(odd){
    padding: 3rem;
  }

  .lg\\:odd\\:p-14:nth-child(odd){
    padding: 3.5rem;
  }

  .lg\\:odd\\:p-15:nth-child(odd){
    padding: 3.75rem;
  }

  .lg\\:odd\\:p-16:nth-child(odd){
    padding: 4rem;
  }

  .lg\\:odd\\:p-18:nth-child(odd){
    padding: 4.5rem;
  }

  .lg\\:odd\\:p-20:nth-child(odd){
    padding: 5rem;
  }

  .lg\\:odd\\:p-22:nth-child(odd){
    padding: 5.5rem;
  }

  .lg\\:odd\\:p-23:nth-child(odd){
    padding: 5.75rem;
  }

  .lg\\:odd\\:p-24:nth-child(odd){
    padding: 6rem;
  }

  .lg\\:odd\\:p-25:nth-child(odd){
    padding: 6.25rem;
  }

  .lg\\:odd\\:p-26:nth-child(odd){
    padding: 6.5rem;
  }

  .lg\\:odd\\:p-28:nth-child(odd){
    padding: 7rem;
  }

  .lg\\:odd\\:p-30:nth-child(odd){
    padding: 7.5rem;
  }

  .lg\\:odd\\:p-32:nth-child(odd){
    padding: 8rem;
  }

  .lg\\:odd\\:p-34:nth-child(odd){
    padding: 8.5rem;
  }

  .lg\\:odd\\:p-40:nth-child(odd){
    padding: 10rem;
  }

  .lg\\:odd\\:p-42:nth-child(odd){
    padding: 10.5rem;
  }

  .lg\\:odd\\:p-44:nth-child(odd){
    padding: 11rem;
  }

  .lg\\:odd\\:p-48:nth-child(odd){
    padding: 12rem;
  }

  .lg\\:odd\\:p-52:nth-child(odd){
    padding: 13rem;
  }

  .lg\\:odd\\:p-54:nth-child(odd){
    padding: 13.5rem;
  }

  .lg\\:odd\\:p-56:nth-child(odd){
    padding: 14rem;
  }

  .lg\\:odd\\:p-60:nth-child(odd){
    padding: 15rem;
  }

  .lg\\:odd\\:p-64:nth-child(odd){
    padding: 16rem;
  }

  .lg\\:odd\\:p-68:nth-child(odd){
    padding: 17rem;
  }

  .lg\\:odd\\:p-72:nth-child(odd){
    padding: 18rem;
  }

  .lg\\:odd\\:p-74:nth-child(odd){
    padding: 18.5rem;
  }

  .lg\\:odd\\:p-76:nth-child(odd){
    padding: 19rem;
  }

  .lg\\:odd\\:p-78:nth-child(odd){
    padding: 19.5rem;
  }

  .lg\\:odd\\:p-80:nth-child(odd){
    padding: 20rem;
  }

  .lg\\:odd\\:p-82:nth-child(odd){
    padding: 20.5rem;
  }

  .lg\\:odd\\:p-84:nth-child(odd){
    padding: 21rem;
  }

  .lg\\:odd\\:p-88:nth-child(odd){
    padding: 22rem;
  }

  .lg\\:odd\\:p-92:nth-child(odd){
    padding: 23rem;
  }

  .lg\\:odd\\:p-96:nth-child(odd){
    padding: 24rem;
  }

  .lg\\:odd\\:p-98:nth-child(odd){
    padding: 24.5rem;
  }

  .lg\\:odd\\:p-100:nth-child(odd){
    padding: 25rem;
  }

  .lg\\:odd\\:p-104:nth-child(odd){
    padding: 26rem;
  }

  .lg\\:odd\\:p-112:nth-child(odd){
    padding: 28rem;
  }

  .lg\\:odd\\:p-124:nth-child(odd){
    padding: 31rem;
  }

  .lg\\:odd\\:p-128:nth-child(odd){
    padding: 32rem;
  }

  .lg\\:odd\\:p-140:nth-child(odd){
    padding: 35rem;
  }

  .lg\\:odd\\:p-152:nth-child(odd){
    padding: 38rem;
  }

  .lg\\:odd\\:p-160:nth-child(odd){
    padding: 40rem;
  }

  .lg\\:odd\\:p-162:nth-child(odd){
    padding: 41rem;
  }

  .lg\\:odd\\:p-192:nth-child(odd){
    padding: 48rem;
  }

  .lg\\:odd\\:p-208:nth-child(odd){
    padding: 52rem;
  }

  .lg\\:odd\\:p-224:nth-child(odd){
    padding: 56rem;
  }

  .lg\\:odd\\:p-256:nth-child(odd){
    padding: 64rem;
  }

  .lg\\:odd\\:p-px:nth-child(odd){
    padding: 1px;
  }

  .lg\\:odd\\:py-0:nth-child(odd){
    padding-top: 0;
    padding-bottom: 0;
  }

  .lg\\:odd\\:px-0:nth-child(odd){
    padding-left: 0;
    padding-right: 0;
  }

  .lg\\:odd\\:py-1:nth-child(odd){
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .lg\\:odd\\:px-1:nth-child(odd){
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .lg\\:odd\\:py-2:nth-child(odd){
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .lg\\:odd\\:px-2:nth-child(odd){
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .lg\\:odd\\:py-3:nth-child(odd){
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .lg\\:odd\\:px-3:nth-child(odd){
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .lg\\:odd\\:py-4:nth-child(odd){
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .lg\\:odd\\:px-4:nth-child(odd){
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:odd\\:py-5:nth-child(odd){
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .lg\\:odd\\:px-5:nth-child(odd){
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .lg\\:odd\\:py-6:nth-child(odd){
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .lg\\:odd\\:px-6:nth-child(odd){
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:odd\\:py-7:nth-child(odd){
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .lg\\:odd\\:px-7:nth-child(odd){
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .lg\\:odd\\:py-8:nth-child(odd){
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .lg\\:odd\\:px-8:nth-child(odd){
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:odd\\:py-9:nth-child(odd){
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .lg\\:odd\\:px-9:nth-child(odd){
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .lg\\:odd\\:py-10:nth-child(odd){
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .lg\\:odd\\:px-10:nth-child(odd){
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:odd\\:py-11:nth-child(odd){
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .lg\\:odd\\:px-11:nth-child(odd){
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .lg\\:odd\\:py-12:nth-child(odd){
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .lg\\:odd\\:px-12:nth-child(odd){
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:odd\\:py-14:nth-child(odd){
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .lg\\:odd\\:px-14:nth-child(odd){
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .lg\\:odd\\:py-15:nth-child(odd){
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .lg\\:odd\\:px-15:nth-child(odd){
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .lg\\:odd\\:py-16:nth-child(odd){
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .lg\\:odd\\:px-16:nth-child(odd){
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .lg\\:odd\\:py-18:nth-child(odd){
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .lg\\:odd\\:px-18:nth-child(odd){
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .lg\\:odd\\:py-20:nth-child(odd){
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .lg\\:odd\\:px-20:nth-child(odd){
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .lg\\:odd\\:py-22:nth-child(odd){
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .lg\\:odd\\:px-22:nth-child(odd){
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .lg\\:odd\\:py-23:nth-child(odd){
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .lg\\:odd\\:px-23:nth-child(odd){
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .lg\\:odd\\:py-24:nth-child(odd){
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .lg\\:odd\\:px-24:nth-child(odd){
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .lg\\:odd\\:py-25:nth-child(odd){
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .lg\\:odd\\:px-25:nth-child(odd){
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .lg\\:odd\\:py-26:nth-child(odd){
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .lg\\:odd\\:px-26:nth-child(odd){
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .lg\\:odd\\:py-28:nth-child(odd){
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .lg\\:odd\\:px-28:nth-child(odd){
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .lg\\:odd\\:py-30:nth-child(odd){
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .lg\\:odd\\:px-30:nth-child(odd){
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .lg\\:odd\\:py-32:nth-child(odd){
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .lg\\:odd\\:px-32:nth-child(odd){
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .lg\\:odd\\:py-34:nth-child(odd){
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .lg\\:odd\\:px-34:nth-child(odd){
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .lg\\:odd\\:py-40:nth-child(odd){
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .lg\\:odd\\:px-40:nth-child(odd){
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .lg\\:odd\\:py-42:nth-child(odd){
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .lg\\:odd\\:px-42:nth-child(odd){
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .lg\\:odd\\:py-44:nth-child(odd){
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .lg\\:odd\\:px-44:nth-child(odd){
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .lg\\:odd\\:py-48:nth-child(odd){
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .lg\\:odd\\:px-48:nth-child(odd){
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .lg\\:odd\\:py-52:nth-child(odd){
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .lg\\:odd\\:px-52:nth-child(odd){
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .lg\\:odd\\:py-54:nth-child(odd){
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .lg\\:odd\\:px-54:nth-child(odd){
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .lg\\:odd\\:py-56:nth-child(odd){
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .lg\\:odd\\:px-56:nth-child(odd){
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .lg\\:odd\\:py-60:nth-child(odd){
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .lg\\:odd\\:px-60:nth-child(odd){
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .lg\\:odd\\:py-64:nth-child(odd){
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .lg\\:odd\\:px-64:nth-child(odd){
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .lg\\:odd\\:py-68:nth-child(odd){
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .lg\\:odd\\:px-68:nth-child(odd){
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .lg\\:odd\\:py-72:nth-child(odd){
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .lg\\:odd\\:px-72:nth-child(odd){
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .lg\\:odd\\:py-74:nth-child(odd){
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .lg\\:odd\\:px-74:nth-child(odd){
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .lg\\:odd\\:py-76:nth-child(odd){
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .lg\\:odd\\:px-76:nth-child(odd){
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .lg\\:odd\\:py-78:nth-child(odd){
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .lg\\:odd\\:px-78:nth-child(odd){
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .lg\\:odd\\:py-80:nth-child(odd){
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .lg\\:odd\\:px-80:nth-child(odd){
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .lg\\:odd\\:py-82:nth-child(odd){
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .lg\\:odd\\:px-82:nth-child(odd){
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .lg\\:odd\\:py-84:nth-child(odd){
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .lg\\:odd\\:px-84:nth-child(odd){
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .lg\\:odd\\:py-88:nth-child(odd){
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .lg\\:odd\\:px-88:nth-child(odd){
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .lg\\:odd\\:py-92:nth-child(odd){
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .lg\\:odd\\:px-92:nth-child(odd){
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .lg\\:odd\\:py-96:nth-child(odd){
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .lg\\:odd\\:px-96:nth-child(odd){
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .lg\\:odd\\:py-98:nth-child(odd){
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .lg\\:odd\\:px-98:nth-child(odd){
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .lg\\:odd\\:py-100:nth-child(odd){
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .lg\\:odd\\:px-100:nth-child(odd){
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .lg\\:odd\\:py-104:nth-child(odd){
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .lg\\:odd\\:px-104:nth-child(odd){
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .lg\\:odd\\:py-112:nth-child(odd){
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .lg\\:odd\\:px-112:nth-child(odd){
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .lg\\:odd\\:py-124:nth-child(odd){
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .lg\\:odd\\:px-124:nth-child(odd){
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .lg\\:odd\\:py-128:nth-child(odd){
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .lg\\:odd\\:px-128:nth-child(odd){
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .lg\\:odd\\:py-140:nth-child(odd){
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .lg\\:odd\\:px-140:nth-child(odd){
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .lg\\:odd\\:py-152:nth-child(odd){
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .lg\\:odd\\:px-152:nth-child(odd){
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .lg\\:odd\\:py-160:nth-child(odd){
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .lg\\:odd\\:px-160:nth-child(odd){
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .lg\\:odd\\:py-162:nth-child(odd){
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .lg\\:odd\\:px-162:nth-child(odd){
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .lg\\:odd\\:py-192:nth-child(odd){
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .lg\\:odd\\:px-192:nth-child(odd){
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .lg\\:odd\\:py-208:nth-child(odd){
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .lg\\:odd\\:px-208:nth-child(odd){
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .lg\\:odd\\:py-224:nth-child(odd){
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .lg\\:odd\\:px-224:nth-child(odd){
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .lg\\:odd\\:py-256:nth-child(odd){
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .lg\\:odd\\:px-256:nth-child(odd){
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .lg\\:odd\\:py-px:nth-child(odd){
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .lg\\:odd\\:px-px:nth-child(odd){
    padding-left: 1px;
    padding-right: 1px;
  }

  .lg\\:odd\\:pt-0:nth-child(odd){
    padding-top: 0;
  }

  .lg\\:odd\\:pr-0:nth-child(odd){
    padding-right: 0;
  }

  .lg\\:odd\\:pb-0:nth-child(odd){
    padding-bottom: 0;
  }

  .lg\\:odd\\:pl-0:nth-child(odd){
    padding-left: 0;
  }

  .lg\\:odd\\:pt-1:nth-child(odd){
    padding-top: 0.25rem;
  }

  .lg\\:odd\\:pr-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  .lg\\:odd\\:pb-1:nth-child(odd){
    padding-bottom: 0.25rem;
  }

  .lg\\:odd\\:pl-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  .lg\\:odd\\:pt-2:nth-child(odd){
    padding-top: 0.5rem;
  }

  .lg\\:odd\\:pr-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  .lg\\:odd\\:pb-2:nth-child(odd){
    padding-bottom: 0.5rem;
  }

  .lg\\:odd\\:pl-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  .lg\\:odd\\:pt-3:nth-child(odd){
    padding-top: 0.75rem;
  }

  .lg\\:odd\\:pr-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  .lg\\:odd\\:pb-3:nth-child(odd){
    padding-bottom: 0.75rem;
  }

  .lg\\:odd\\:pl-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  .lg\\:odd\\:pt-4:nth-child(odd){
    padding-top: 1rem;
  }

  .lg\\:odd\\:pr-4:nth-child(odd){
    padding-right: 1rem;
  }

  .lg\\:odd\\:pb-4:nth-child(odd){
    padding-bottom: 1rem;
  }

  .lg\\:odd\\:pl-4:nth-child(odd){
    padding-left: 1rem;
  }

  .lg\\:odd\\:pt-5:nth-child(odd){
    padding-top: 1.25rem;
  }

  .lg\\:odd\\:pr-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  .lg\\:odd\\:pb-5:nth-child(odd){
    padding-bottom: 1.25rem;
  }

  .lg\\:odd\\:pl-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  .lg\\:odd\\:pt-6:nth-child(odd){
    padding-top: 1.5rem;
  }

  .lg\\:odd\\:pr-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  .lg\\:odd\\:pb-6:nth-child(odd){
    padding-bottom: 1.5rem;
  }

  .lg\\:odd\\:pl-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  .lg\\:odd\\:pt-7:nth-child(odd){
    padding-top: 1.75rem;
  }

  .lg\\:odd\\:pr-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  .lg\\:odd\\:pb-7:nth-child(odd){
    padding-bottom: 1.75rem;
  }

  .lg\\:odd\\:pl-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  .lg\\:odd\\:pt-8:nth-child(odd){
    padding-top: 2rem;
  }

  .lg\\:odd\\:pr-8:nth-child(odd){
    padding-right: 2rem;
  }

  .lg\\:odd\\:pb-8:nth-child(odd){
    padding-bottom: 2rem;
  }

  .lg\\:odd\\:pl-8:nth-child(odd){
    padding-left: 2rem;
  }

  .lg\\:odd\\:pt-9:nth-child(odd){
    padding-top: 2.25rem;
  }

  .lg\\:odd\\:pr-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  .lg\\:odd\\:pb-9:nth-child(odd){
    padding-bottom: 2.25rem;
  }

  .lg\\:odd\\:pl-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  .lg\\:odd\\:pt-10:nth-child(odd){
    padding-top: 2.5rem;
  }

  .lg\\:odd\\:pr-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  .lg\\:odd\\:pb-10:nth-child(odd){
    padding-bottom: 2.5rem;
  }

  .lg\\:odd\\:pl-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  .lg\\:odd\\:pt-11:nth-child(odd){
    padding-top: 2.75rem;
  }

  .lg\\:odd\\:pr-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  .lg\\:odd\\:pb-11:nth-child(odd){
    padding-bottom: 2.75rem;
  }

  .lg\\:odd\\:pl-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  .lg\\:odd\\:pt-12:nth-child(odd){
    padding-top: 3rem;
  }

  .lg\\:odd\\:pr-12:nth-child(odd){
    padding-right: 3rem;
  }

  .lg\\:odd\\:pb-12:nth-child(odd){
    padding-bottom: 3rem;
  }

  .lg\\:odd\\:pl-12:nth-child(odd){
    padding-left: 3rem;
  }

  .lg\\:odd\\:pt-14:nth-child(odd){
    padding-top: 3.5rem;
  }

  .lg\\:odd\\:pr-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  .lg\\:odd\\:pb-14:nth-child(odd){
    padding-bottom: 3.5rem;
  }

  .lg\\:odd\\:pl-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  .lg\\:odd\\:pt-15:nth-child(odd){
    padding-top: 3.75rem;
  }

  .lg\\:odd\\:pr-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  .lg\\:odd\\:pb-15:nth-child(odd){
    padding-bottom: 3.75rem;
  }

  .lg\\:odd\\:pl-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  .lg\\:odd\\:pt-16:nth-child(odd){
    padding-top: 4rem;
  }

  .lg\\:odd\\:pr-16:nth-child(odd){
    padding-right: 4rem;
  }

  .lg\\:odd\\:pb-16:nth-child(odd){
    padding-bottom: 4rem;
  }

  .lg\\:odd\\:pl-16:nth-child(odd){
    padding-left: 4rem;
  }

  .lg\\:odd\\:pt-18:nth-child(odd){
    padding-top: 4.5rem;
  }

  .lg\\:odd\\:pr-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  .lg\\:odd\\:pb-18:nth-child(odd){
    padding-bottom: 4.5rem;
  }

  .lg\\:odd\\:pl-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  .lg\\:odd\\:pt-20:nth-child(odd){
    padding-top: 5rem;
  }

  .lg\\:odd\\:pr-20:nth-child(odd){
    padding-right: 5rem;
  }

  .lg\\:odd\\:pb-20:nth-child(odd){
    padding-bottom: 5rem;
  }

  .lg\\:odd\\:pl-20:nth-child(odd){
    padding-left: 5rem;
  }

  .lg\\:odd\\:pt-22:nth-child(odd){
    padding-top: 5.5rem;
  }

  .lg\\:odd\\:pr-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  .lg\\:odd\\:pb-22:nth-child(odd){
    padding-bottom: 5.5rem;
  }

  .lg\\:odd\\:pl-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  .lg\\:odd\\:pt-23:nth-child(odd){
    padding-top: 5.75rem;
  }

  .lg\\:odd\\:pr-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  .lg\\:odd\\:pb-23:nth-child(odd){
    padding-bottom: 5.75rem;
  }

  .lg\\:odd\\:pl-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  .lg\\:odd\\:pt-24:nth-child(odd){
    padding-top: 6rem;
  }

  .lg\\:odd\\:pr-24:nth-child(odd){
    padding-right: 6rem;
  }

  .lg\\:odd\\:pb-24:nth-child(odd){
    padding-bottom: 6rem;
  }

  .lg\\:odd\\:pl-24:nth-child(odd){
    padding-left: 6rem;
  }

  .lg\\:odd\\:pt-25:nth-child(odd){
    padding-top: 6.25rem;
  }

  .lg\\:odd\\:pr-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  .lg\\:odd\\:pb-25:nth-child(odd){
    padding-bottom: 6.25rem;
  }

  .lg\\:odd\\:pl-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  .lg\\:odd\\:pt-26:nth-child(odd){
    padding-top: 6.5rem;
  }

  .lg\\:odd\\:pr-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  .lg\\:odd\\:pb-26:nth-child(odd){
    padding-bottom: 6.5rem;
  }

  .lg\\:odd\\:pl-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  .lg\\:odd\\:pt-28:nth-child(odd){
    padding-top: 7rem;
  }

  .lg\\:odd\\:pr-28:nth-child(odd){
    padding-right: 7rem;
  }

  .lg\\:odd\\:pb-28:nth-child(odd){
    padding-bottom: 7rem;
  }

  .lg\\:odd\\:pl-28:nth-child(odd){
    padding-left: 7rem;
  }

  .lg\\:odd\\:pt-30:nth-child(odd){
    padding-top: 7.5rem;
  }

  .lg\\:odd\\:pr-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  .lg\\:odd\\:pb-30:nth-child(odd){
    padding-bottom: 7.5rem;
  }

  .lg\\:odd\\:pl-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  .lg\\:odd\\:pt-32:nth-child(odd){
    padding-top: 8rem;
  }

  .lg\\:odd\\:pr-32:nth-child(odd){
    padding-right: 8rem;
  }

  .lg\\:odd\\:pb-32:nth-child(odd){
    padding-bottom: 8rem;
  }

  .lg\\:odd\\:pl-32:nth-child(odd){
    padding-left: 8rem;
  }

  .lg\\:odd\\:pt-34:nth-child(odd){
    padding-top: 8.5rem;
  }

  .lg\\:odd\\:pr-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  .lg\\:odd\\:pb-34:nth-child(odd){
    padding-bottom: 8.5rem;
  }

  .lg\\:odd\\:pl-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  .lg\\:odd\\:pt-40:nth-child(odd){
    padding-top: 10rem;
  }

  .lg\\:odd\\:pr-40:nth-child(odd){
    padding-right: 10rem;
  }

  .lg\\:odd\\:pb-40:nth-child(odd){
    padding-bottom: 10rem;
  }

  .lg\\:odd\\:pl-40:nth-child(odd){
    padding-left: 10rem;
  }

  .lg\\:odd\\:pt-42:nth-child(odd){
    padding-top: 10.5rem;
  }

  .lg\\:odd\\:pr-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  .lg\\:odd\\:pb-42:nth-child(odd){
    padding-bottom: 10.5rem;
  }

  .lg\\:odd\\:pl-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  .lg\\:odd\\:pt-44:nth-child(odd){
    padding-top: 11rem;
  }

  .lg\\:odd\\:pr-44:nth-child(odd){
    padding-right: 11rem;
  }

  .lg\\:odd\\:pb-44:nth-child(odd){
    padding-bottom: 11rem;
  }

  .lg\\:odd\\:pl-44:nth-child(odd){
    padding-left: 11rem;
  }

  .lg\\:odd\\:pt-48:nth-child(odd){
    padding-top: 12rem;
  }

  .lg\\:odd\\:pr-48:nth-child(odd){
    padding-right: 12rem;
  }

  .lg\\:odd\\:pb-48:nth-child(odd){
    padding-bottom: 12rem;
  }

  .lg\\:odd\\:pl-48:nth-child(odd){
    padding-left: 12rem;
  }

  .lg\\:odd\\:pt-52:nth-child(odd){
    padding-top: 13rem;
  }

  .lg\\:odd\\:pr-52:nth-child(odd){
    padding-right: 13rem;
  }

  .lg\\:odd\\:pb-52:nth-child(odd){
    padding-bottom: 13rem;
  }

  .lg\\:odd\\:pl-52:nth-child(odd){
    padding-left: 13rem;
  }

  .lg\\:odd\\:pt-54:nth-child(odd){
    padding-top: 13.5rem;
  }

  .lg\\:odd\\:pr-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  .lg\\:odd\\:pb-54:nth-child(odd){
    padding-bottom: 13.5rem;
  }

  .lg\\:odd\\:pl-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  .lg\\:odd\\:pt-56:nth-child(odd){
    padding-top: 14rem;
  }

  .lg\\:odd\\:pr-56:nth-child(odd){
    padding-right: 14rem;
  }

  .lg\\:odd\\:pb-56:nth-child(odd){
    padding-bottom: 14rem;
  }

  .lg\\:odd\\:pl-56:nth-child(odd){
    padding-left: 14rem;
  }

  .lg\\:odd\\:pt-60:nth-child(odd){
    padding-top: 15rem;
  }

  .lg\\:odd\\:pr-60:nth-child(odd){
    padding-right: 15rem;
  }

  .lg\\:odd\\:pb-60:nth-child(odd){
    padding-bottom: 15rem;
  }

  .lg\\:odd\\:pl-60:nth-child(odd){
    padding-left: 15rem;
  }

  .lg\\:odd\\:pt-64:nth-child(odd){
    padding-top: 16rem;
  }

  .lg\\:odd\\:pr-64:nth-child(odd){
    padding-right: 16rem;
  }

  .lg\\:odd\\:pb-64:nth-child(odd){
    padding-bottom: 16rem;
  }

  .lg\\:odd\\:pl-64:nth-child(odd){
    padding-left: 16rem;
  }

  .lg\\:odd\\:pt-68:nth-child(odd){
    padding-top: 17rem;
  }

  .lg\\:odd\\:pr-68:nth-child(odd){
    padding-right: 17rem;
  }

  .lg\\:odd\\:pb-68:nth-child(odd){
    padding-bottom: 17rem;
  }

  .lg\\:odd\\:pl-68:nth-child(odd){
    padding-left: 17rem;
  }

  .lg\\:odd\\:pt-72:nth-child(odd){
    padding-top: 18rem;
  }

  .lg\\:odd\\:pr-72:nth-child(odd){
    padding-right: 18rem;
  }

  .lg\\:odd\\:pb-72:nth-child(odd){
    padding-bottom: 18rem;
  }

  .lg\\:odd\\:pl-72:nth-child(odd){
    padding-left: 18rem;
  }

  .lg\\:odd\\:pt-74:nth-child(odd){
    padding-top: 18.5rem;
  }

  .lg\\:odd\\:pr-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  .lg\\:odd\\:pb-74:nth-child(odd){
    padding-bottom: 18.5rem;
  }

  .lg\\:odd\\:pl-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  .lg\\:odd\\:pt-76:nth-child(odd){
    padding-top: 19rem;
  }

  .lg\\:odd\\:pr-76:nth-child(odd){
    padding-right: 19rem;
  }

  .lg\\:odd\\:pb-76:nth-child(odd){
    padding-bottom: 19rem;
  }

  .lg\\:odd\\:pl-76:nth-child(odd){
    padding-left: 19rem;
  }

  .lg\\:odd\\:pt-78:nth-child(odd){
    padding-top: 19.5rem;
  }

  .lg\\:odd\\:pr-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  .lg\\:odd\\:pb-78:nth-child(odd){
    padding-bottom: 19.5rem;
  }

  .lg\\:odd\\:pl-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  .lg\\:odd\\:pt-80:nth-child(odd){
    padding-top: 20rem;
  }

  .lg\\:odd\\:pr-80:nth-child(odd){
    padding-right: 20rem;
  }

  .lg\\:odd\\:pb-80:nth-child(odd){
    padding-bottom: 20rem;
  }

  .lg\\:odd\\:pl-80:nth-child(odd){
    padding-left: 20rem;
  }

  .lg\\:odd\\:pt-82:nth-child(odd){
    padding-top: 20.5rem;
  }

  .lg\\:odd\\:pr-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  .lg\\:odd\\:pb-82:nth-child(odd){
    padding-bottom: 20.5rem;
  }

  .lg\\:odd\\:pl-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  .lg\\:odd\\:pt-84:nth-child(odd){
    padding-top: 21rem;
  }

  .lg\\:odd\\:pr-84:nth-child(odd){
    padding-right: 21rem;
  }

  .lg\\:odd\\:pb-84:nth-child(odd){
    padding-bottom: 21rem;
  }

  .lg\\:odd\\:pl-84:nth-child(odd){
    padding-left: 21rem;
  }

  .lg\\:odd\\:pt-88:nth-child(odd){
    padding-top: 22rem;
  }

  .lg\\:odd\\:pr-88:nth-child(odd){
    padding-right: 22rem;
  }

  .lg\\:odd\\:pb-88:nth-child(odd){
    padding-bottom: 22rem;
  }

  .lg\\:odd\\:pl-88:nth-child(odd){
    padding-left: 22rem;
  }

  .lg\\:odd\\:pt-92:nth-child(odd){
    padding-top: 23rem;
  }

  .lg\\:odd\\:pr-92:nth-child(odd){
    padding-right: 23rem;
  }

  .lg\\:odd\\:pb-92:nth-child(odd){
    padding-bottom: 23rem;
  }

  .lg\\:odd\\:pl-92:nth-child(odd){
    padding-left: 23rem;
  }

  .lg\\:odd\\:pt-96:nth-child(odd){
    padding-top: 24rem;
  }

  .lg\\:odd\\:pr-96:nth-child(odd){
    padding-right: 24rem;
  }

  .lg\\:odd\\:pb-96:nth-child(odd){
    padding-bottom: 24rem;
  }

  .lg\\:odd\\:pl-96:nth-child(odd){
    padding-left: 24rem;
  }

  .lg\\:odd\\:pt-98:nth-child(odd){
    padding-top: 24.5rem;
  }

  .lg\\:odd\\:pr-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  .lg\\:odd\\:pb-98:nth-child(odd){
    padding-bottom: 24.5rem;
  }

  .lg\\:odd\\:pl-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  .lg\\:odd\\:pt-100:nth-child(odd){
    padding-top: 25rem;
  }

  .lg\\:odd\\:pr-100:nth-child(odd){
    padding-right: 25rem;
  }

  .lg\\:odd\\:pb-100:nth-child(odd){
    padding-bottom: 25rem;
  }

  .lg\\:odd\\:pl-100:nth-child(odd){
    padding-left: 25rem;
  }

  .lg\\:odd\\:pt-104:nth-child(odd){
    padding-top: 26rem;
  }

  .lg\\:odd\\:pr-104:nth-child(odd){
    padding-right: 26rem;
  }

  .lg\\:odd\\:pb-104:nth-child(odd){
    padding-bottom: 26rem;
  }

  .lg\\:odd\\:pl-104:nth-child(odd){
    padding-left: 26rem;
  }

  .lg\\:odd\\:pt-112:nth-child(odd){
    padding-top: 28rem;
  }

  .lg\\:odd\\:pr-112:nth-child(odd){
    padding-right: 28rem;
  }

  .lg\\:odd\\:pb-112:nth-child(odd){
    padding-bottom: 28rem;
  }

  .lg\\:odd\\:pl-112:nth-child(odd){
    padding-left: 28rem;
  }

  .lg\\:odd\\:pt-124:nth-child(odd){
    padding-top: 31rem;
  }

  .lg\\:odd\\:pr-124:nth-child(odd){
    padding-right: 31rem;
  }

  .lg\\:odd\\:pb-124:nth-child(odd){
    padding-bottom: 31rem;
  }

  .lg\\:odd\\:pl-124:nth-child(odd){
    padding-left: 31rem;
  }

  .lg\\:odd\\:pt-128:nth-child(odd){
    padding-top: 32rem;
  }

  .lg\\:odd\\:pr-128:nth-child(odd){
    padding-right: 32rem;
  }

  .lg\\:odd\\:pb-128:nth-child(odd){
    padding-bottom: 32rem;
  }

  .lg\\:odd\\:pl-128:nth-child(odd){
    padding-left: 32rem;
  }

  .lg\\:odd\\:pt-140:nth-child(odd){
    padding-top: 35rem;
  }

  .lg\\:odd\\:pr-140:nth-child(odd){
    padding-right: 35rem;
  }

  .lg\\:odd\\:pb-140:nth-child(odd){
    padding-bottom: 35rem;
  }

  .lg\\:odd\\:pl-140:nth-child(odd){
    padding-left: 35rem;
  }

  .lg\\:odd\\:pt-152:nth-child(odd){
    padding-top: 38rem;
  }

  .lg\\:odd\\:pr-152:nth-child(odd){
    padding-right: 38rem;
  }

  .lg\\:odd\\:pb-152:nth-child(odd){
    padding-bottom: 38rem;
  }

  .lg\\:odd\\:pl-152:nth-child(odd){
    padding-left: 38rem;
  }

  .lg\\:odd\\:pt-160:nth-child(odd){
    padding-top: 40rem;
  }

  .lg\\:odd\\:pr-160:nth-child(odd){
    padding-right: 40rem;
  }

  .lg\\:odd\\:pb-160:nth-child(odd){
    padding-bottom: 40rem;
  }

  .lg\\:odd\\:pl-160:nth-child(odd){
    padding-left: 40rem;
  }

  .lg\\:odd\\:pt-162:nth-child(odd){
    padding-top: 41rem;
  }

  .lg\\:odd\\:pr-162:nth-child(odd){
    padding-right: 41rem;
  }

  .lg\\:odd\\:pb-162:nth-child(odd){
    padding-bottom: 41rem;
  }

  .lg\\:odd\\:pl-162:nth-child(odd){
    padding-left: 41rem;
  }

  .lg\\:odd\\:pt-192:nth-child(odd){
    padding-top: 48rem;
  }

  .lg\\:odd\\:pr-192:nth-child(odd){
    padding-right: 48rem;
  }

  .lg\\:odd\\:pb-192:nth-child(odd){
    padding-bottom: 48rem;
  }

  .lg\\:odd\\:pl-192:nth-child(odd){
    padding-left: 48rem;
  }

  .lg\\:odd\\:pt-208:nth-child(odd){
    padding-top: 52rem;
  }

  .lg\\:odd\\:pr-208:nth-child(odd){
    padding-right: 52rem;
  }

  .lg\\:odd\\:pb-208:nth-child(odd){
    padding-bottom: 52rem;
  }

  .lg\\:odd\\:pl-208:nth-child(odd){
    padding-left: 52rem;
  }

  .lg\\:odd\\:pt-224:nth-child(odd){
    padding-top: 56rem;
  }

  .lg\\:odd\\:pr-224:nth-child(odd){
    padding-right: 56rem;
  }

  .lg\\:odd\\:pb-224:nth-child(odd){
    padding-bottom: 56rem;
  }

  .lg\\:odd\\:pl-224:nth-child(odd){
    padding-left: 56rem;
  }

  .lg\\:odd\\:pt-256:nth-child(odd){
    padding-top: 64rem;
  }

  .lg\\:odd\\:pr-256:nth-child(odd){
    padding-right: 64rem;
  }

  .lg\\:odd\\:pb-256:nth-child(odd){
    padding-bottom: 64rem;
  }

  .lg\\:odd\\:pl-256:nth-child(odd){
    padding-left: 64rem;
  }

  .lg\\:odd\\:pt-px:nth-child(odd){
    padding-top: 1px;
  }

  .lg\\:odd\\:pr-px:nth-child(odd){
    padding-right: 1px;
  }

  .lg\\:odd\\:pb-px:nth-child(odd){
    padding-bottom: 1px;
  }

  .lg\\:odd\\:pl-px:nth-child(odd){
    padding-left: 1px;
  }

  .lg\\:even\\:p-0:nth-child(even){
    padding: 0;
  }

  .lg\\:even\\:p-1:nth-child(even){
    padding: 0.25rem;
  }

  .lg\\:even\\:p-2:nth-child(even){
    padding: 0.5rem;
  }

  .lg\\:even\\:p-3:nth-child(even){
    padding: 0.75rem;
  }

  .lg\\:even\\:p-4:nth-child(even){
    padding: 1rem;
  }

  .lg\\:even\\:p-5:nth-child(even){
    padding: 1.25rem;
  }

  .lg\\:even\\:p-6:nth-child(even){
    padding: 1.5rem;
  }

  .lg\\:even\\:p-7:nth-child(even){
    padding: 1.75rem;
  }

  .lg\\:even\\:p-8:nth-child(even){
    padding: 2rem;
  }

  .lg\\:even\\:p-9:nth-child(even){
    padding: 2.25rem;
  }

  .lg\\:even\\:p-10:nth-child(even){
    padding: 2.5rem;
  }

  .lg\\:even\\:p-11:nth-child(even){
    padding: 2.75rem;
  }

  .lg\\:even\\:p-12:nth-child(even){
    padding: 3rem;
  }

  .lg\\:even\\:p-14:nth-child(even){
    padding: 3.5rem;
  }

  .lg\\:even\\:p-15:nth-child(even){
    padding: 3.75rem;
  }

  .lg\\:even\\:p-16:nth-child(even){
    padding: 4rem;
  }

  .lg\\:even\\:p-18:nth-child(even){
    padding: 4.5rem;
  }

  .lg\\:even\\:p-20:nth-child(even){
    padding: 5rem;
  }

  .lg\\:even\\:p-22:nth-child(even){
    padding: 5.5rem;
  }

  .lg\\:even\\:p-23:nth-child(even){
    padding: 5.75rem;
  }

  .lg\\:even\\:p-24:nth-child(even){
    padding: 6rem;
  }

  .lg\\:even\\:p-25:nth-child(even){
    padding: 6.25rem;
  }

  .lg\\:even\\:p-26:nth-child(even){
    padding: 6.5rem;
  }

  .lg\\:even\\:p-28:nth-child(even){
    padding: 7rem;
  }

  .lg\\:even\\:p-30:nth-child(even){
    padding: 7.5rem;
  }

  .lg\\:even\\:p-32:nth-child(even){
    padding: 8rem;
  }

  .lg\\:even\\:p-34:nth-child(even){
    padding: 8.5rem;
  }

  .lg\\:even\\:p-40:nth-child(even){
    padding: 10rem;
  }

  .lg\\:even\\:p-42:nth-child(even){
    padding: 10.5rem;
  }

  .lg\\:even\\:p-44:nth-child(even){
    padding: 11rem;
  }

  .lg\\:even\\:p-48:nth-child(even){
    padding: 12rem;
  }

  .lg\\:even\\:p-52:nth-child(even){
    padding: 13rem;
  }

  .lg\\:even\\:p-54:nth-child(even){
    padding: 13.5rem;
  }

  .lg\\:even\\:p-56:nth-child(even){
    padding: 14rem;
  }

  .lg\\:even\\:p-60:nth-child(even){
    padding: 15rem;
  }

  .lg\\:even\\:p-64:nth-child(even){
    padding: 16rem;
  }

  .lg\\:even\\:p-68:nth-child(even){
    padding: 17rem;
  }

  .lg\\:even\\:p-72:nth-child(even){
    padding: 18rem;
  }

  .lg\\:even\\:p-74:nth-child(even){
    padding: 18.5rem;
  }

  .lg\\:even\\:p-76:nth-child(even){
    padding: 19rem;
  }

  .lg\\:even\\:p-78:nth-child(even){
    padding: 19.5rem;
  }

  .lg\\:even\\:p-80:nth-child(even){
    padding: 20rem;
  }

  .lg\\:even\\:p-82:nth-child(even){
    padding: 20.5rem;
  }

  .lg\\:even\\:p-84:nth-child(even){
    padding: 21rem;
  }

  .lg\\:even\\:p-88:nth-child(even){
    padding: 22rem;
  }

  .lg\\:even\\:p-92:nth-child(even){
    padding: 23rem;
  }

  .lg\\:even\\:p-96:nth-child(even){
    padding: 24rem;
  }

  .lg\\:even\\:p-98:nth-child(even){
    padding: 24.5rem;
  }

  .lg\\:even\\:p-100:nth-child(even){
    padding: 25rem;
  }

  .lg\\:even\\:p-104:nth-child(even){
    padding: 26rem;
  }

  .lg\\:even\\:p-112:nth-child(even){
    padding: 28rem;
  }

  .lg\\:even\\:p-124:nth-child(even){
    padding: 31rem;
  }

  .lg\\:even\\:p-128:nth-child(even){
    padding: 32rem;
  }

  .lg\\:even\\:p-140:nth-child(even){
    padding: 35rem;
  }

  .lg\\:even\\:p-152:nth-child(even){
    padding: 38rem;
  }

  .lg\\:even\\:p-160:nth-child(even){
    padding: 40rem;
  }

  .lg\\:even\\:p-162:nth-child(even){
    padding: 41rem;
  }

  .lg\\:even\\:p-192:nth-child(even){
    padding: 48rem;
  }

  .lg\\:even\\:p-208:nth-child(even){
    padding: 52rem;
  }

  .lg\\:even\\:p-224:nth-child(even){
    padding: 56rem;
  }

  .lg\\:even\\:p-256:nth-child(even){
    padding: 64rem;
  }

  .lg\\:even\\:p-px:nth-child(even){
    padding: 1px;
  }

  .lg\\:even\\:py-0:nth-child(even){
    padding-top: 0;
    padding-bottom: 0;
  }

  .lg\\:even\\:px-0:nth-child(even){
    padding-left: 0;
    padding-right: 0;
  }

  .lg\\:even\\:py-1:nth-child(even){
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .lg\\:even\\:px-1:nth-child(even){
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .lg\\:even\\:py-2:nth-child(even){
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .lg\\:even\\:px-2:nth-child(even){
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .lg\\:even\\:py-3:nth-child(even){
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .lg\\:even\\:px-3:nth-child(even){
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .lg\\:even\\:py-4:nth-child(even){
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .lg\\:even\\:px-4:nth-child(even){
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .lg\\:even\\:py-5:nth-child(even){
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .lg\\:even\\:px-5:nth-child(even){
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .lg\\:even\\:py-6:nth-child(even){
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .lg\\:even\\:px-6:nth-child(even){
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .lg\\:even\\:py-7:nth-child(even){
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .lg\\:even\\:px-7:nth-child(even){
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .lg\\:even\\:py-8:nth-child(even){
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .lg\\:even\\:px-8:nth-child(even){
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .lg\\:even\\:py-9:nth-child(even){
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .lg\\:even\\:px-9:nth-child(even){
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .lg\\:even\\:py-10:nth-child(even){
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .lg\\:even\\:px-10:nth-child(even){
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .lg\\:even\\:py-11:nth-child(even){
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .lg\\:even\\:px-11:nth-child(even){
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .lg\\:even\\:py-12:nth-child(even){
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .lg\\:even\\:px-12:nth-child(even){
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .lg\\:even\\:py-14:nth-child(even){
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .lg\\:even\\:px-14:nth-child(even){
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .lg\\:even\\:py-15:nth-child(even){
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .lg\\:even\\:px-15:nth-child(even){
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .lg\\:even\\:py-16:nth-child(even){
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .lg\\:even\\:px-16:nth-child(even){
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .lg\\:even\\:py-18:nth-child(even){
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .lg\\:even\\:px-18:nth-child(even){
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .lg\\:even\\:py-20:nth-child(even){
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .lg\\:even\\:px-20:nth-child(even){
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .lg\\:even\\:py-22:nth-child(even){
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .lg\\:even\\:px-22:nth-child(even){
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .lg\\:even\\:py-23:nth-child(even){
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .lg\\:even\\:px-23:nth-child(even){
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .lg\\:even\\:py-24:nth-child(even){
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .lg\\:even\\:px-24:nth-child(even){
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .lg\\:even\\:py-25:nth-child(even){
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .lg\\:even\\:px-25:nth-child(even){
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .lg\\:even\\:py-26:nth-child(even){
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .lg\\:even\\:px-26:nth-child(even){
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .lg\\:even\\:py-28:nth-child(even){
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .lg\\:even\\:px-28:nth-child(even){
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .lg\\:even\\:py-30:nth-child(even){
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .lg\\:even\\:px-30:nth-child(even){
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .lg\\:even\\:py-32:nth-child(even){
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .lg\\:even\\:px-32:nth-child(even){
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .lg\\:even\\:py-34:nth-child(even){
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .lg\\:even\\:px-34:nth-child(even){
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .lg\\:even\\:py-40:nth-child(even){
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .lg\\:even\\:px-40:nth-child(even){
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .lg\\:even\\:py-42:nth-child(even){
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .lg\\:even\\:px-42:nth-child(even){
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .lg\\:even\\:py-44:nth-child(even){
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .lg\\:even\\:px-44:nth-child(even){
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .lg\\:even\\:py-48:nth-child(even){
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .lg\\:even\\:px-48:nth-child(even){
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .lg\\:even\\:py-52:nth-child(even){
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .lg\\:even\\:px-52:nth-child(even){
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .lg\\:even\\:py-54:nth-child(even){
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .lg\\:even\\:px-54:nth-child(even){
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .lg\\:even\\:py-56:nth-child(even){
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .lg\\:even\\:px-56:nth-child(even){
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .lg\\:even\\:py-60:nth-child(even){
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .lg\\:even\\:px-60:nth-child(even){
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .lg\\:even\\:py-64:nth-child(even){
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .lg\\:even\\:px-64:nth-child(even){
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .lg\\:even\\:py-68:nth-child(even){
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .lg\\:even\\:px-68:nth-child(even){
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .lg\\:even\\:py-72:nth-child(even){
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .lg\\:even\\:px-72:nth-child(even){
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .lg\\:even\\:py-74:nth-child(even){
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .lg\\:even\\:px-74:nth-child(even){
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .lg\\:even\\:py-76:nth-child(even){
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .lg\\:even\\:px-76:nth-child(even){
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .lg\\:even\\:py-78:nth-child(even){
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .lg\\:even\\:px-78:nth-child(even){
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .lg\\:even\\:py-80:nth-child(even){
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .lg\\:even\\:px-80:nth-child(even){
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .lg\\:even\\:py-82:nth-child(even){
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .lg\\:even\\:px-82:nth-child(even){
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .lg\\:even\\:py-84:nth-child(even){
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .lg\\:even\\:px-84:nth-child(even){
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .lg\\:even\\:py-88:nth-child(even){
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .lg\\:even\\:px-88:nth-child(even){
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .lg\\:even\\:py-92:nth-child(even){
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .lg\\:even\\:px-92:nth-child(even){
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .lg\\:even\\:py-96:nth-child(even){
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .lg\\:even\\:px-96:nth-child(even){
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .lg\\:even\\:py-98:nth-child(even){
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .lg\\:even\\:px-98:nth-child(even){
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .lg\\:even\\:py-100:nth-child(even){
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .lg\\:even\\:px-100:nth-child(even){
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .lg\\:even\\:py-104:nth-child(even){
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .lg\\:even\\:px-104:nth-child(even){
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .lg\\:even\\:py-112:nth-child(even){
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .lg\\:even\\:px-112:nth-child(even){
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .lg\\:even\\:py-124:nth-child(even){
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .lg\\:even\\:px-124:nth-child(even){
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .lg\\:even\\:py-128:nth-child(even){
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .lg\\:even\\:px-128:nth-child(even){
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .lg\\:even\\:py-140:nth-child(even){
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .lg\\:even\\:px-140:nth-child(even){
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .lg\\:even\\:py-152:nth-child(even){
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .lg\\:even\\:px-152:nth-child(even){
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .lg\\:even\\:py-160:nth-child(even){
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .lg\\:even\\:px-160:nth-child(even){
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .lg\\:even\\:py-162:nth-child(even){
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .lg\\:even\\:px-162:nth-child(even){
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .lg\\:even\\:py-192:nth-child(even){
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .lg\\:even\\:px-192:nth-child(even){
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .lg\\:even\\:py-208:nth-child(even){
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .lg\\:even\\:px-208:nth-child(even){
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .lg\\:even\\:py-224:nth-child(even){
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .lg\\:even\\:px-224:nth-child(even){
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .lg\\:even\\:py-256:nth-child(even){
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .lg\\:even\\:px-256:nth-child(even){
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .lg\\:even\\:py-px:nth-child(even){
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .lg\\:even\\:px-px:nth-child(even){
    padding-left: 1px;
    padding-right: 1px;
  }

  .lg\\:even\\:pt-0:nth-child(even){
    padding-top: 0;
  }

  .lg\\:even\\:pr-0:nth-child(even){
    padding-right: 0;
  }

  .lg\\:even\\:pb-0:nth-child(even){
    padding-bottom: 0;
  }

  .lg\\:even\\:pl-0:nth-child(even){
    padding-left: 0;
  }

  .lg\\:even\\:pt-1:nth-child(even){
    padding-top: 0.25rem;
  }

  .lg\\:even\\:pr-1:nth-child(even){
    padding-right: 0.25rem;
  }

  .lg\\:even\\:pb-1:nth-child(even){
    padding-bottom: 0.25rem;
  }

  .lg\\:even\\:pl-1:nth-child(even){
    padding-left: 0.25rem;
  }

  .lg\\:even\\:pt-2:nth-child(even){
    padding-top: 0.5rem;
  }

  .lg\\:even\\:pr-2:nth-child(even){
    padding-right: 0.5rem;
  }

  .lg\\:even\\:pb-2:nth-child(even){
    padding-bottom: 0.5rem;
  }

  .lg\\:even\\:pl-2:nth-child(even){
    padding-left: 0.5rem;
  }

  .lg\\:even\\:pt-3:nth-child(even){
    padding-top: 0.75rem;
  }

  .lg\\:even\\:pr-3:nth-child(even){
    padding-right: 0.75rem;
  }

  .lg\\:even\\:pb-3:nth-child(even){
    padding-bottom: 0.75rem;
  }

  .lg\\:even\\:pl-3:nth-child(even){
    padding-left: 0.75rem;
  }

  .lg\\:even\\:pt-4:nth-child(even){
    padding-top: 1rem;
  }

  .lg\\:even\\:pr-4:nth-child(even){
    padding-right: 1rem;
  }

  .lg\\:even\\:pb-4:nth-child(even){
    padding-bottom: 1rem;
  }

  .lg\\:even\\:pl-4:nth-child(even){
    padding-left: 1rem;
  }

  .lg\\:even\\:pt-5:nth-child(even){
    padding-top: 1.25rem;
  }

  .lg\\:even\\:pr-5:nth-child(even){
    padding-right: 1.25rem;
  }

  .lg\\:even\\:pb-5:nth-child(even){
    padding-bottom: 1.25rem;
  }

  .lg\\:even\\:pl-5:nth-child(even){
    padding-left: 1.25rem;
  }

  .lg\\:even\\:pt-6:nth-child(even){
    padding-top: 1.5rem;
  }

  .lg\\:even\\:pr-6:nth-child(even){
    padding-right: 1.5rem;
  }

  .lg\\:even\\:pb-6:nth-child(even){
    padding-bottom: 1.5rem;
  }

  .lg\\:even\\:pl-6:nth-child(even){
    padding-left: 1.5rem;
  }

  .lg\\:even\\:pt-7:nth-child(even){
    padding-top: 1.75rem;
  }

  .lg\\:even\\:pr-7:nth-child(even){
    padding-right: 1.75rem;
  }

  .lg\\:even\\:pb-7:nth-child(even){
    padding-bottom: 1.75rem;
  }

  .lg\\:even\\:pl-7:nth-child(even){
    padding-left: 1.75rem;
  }

  .lg\\:even\\:pt-8:nth-child(even){
    padding-top: 2rem;
  }

  .lg\\:even\\:pr-8:nth-child(even){
    padding-right: 2rem;
  }

  .lg\\:even\\:pb-8:nth-child(even){
    padding-bottom: 2rem;
  }

  .lg\\:even\\:pl-8:nth-child(even){
    padding-left: 2rem;
  }

  .lg\\:even\\:pt-9:nth-child(even){
    padding-top: 2.25rem;
  }

  .lg\\:even\\:pr-9:nth-child(even){
    padding-right: 2.25rem;
  }

  .lg\\:even\\:pb-9:nth-child(even){
    padding-bottom: 2.25rem;
  }

  .lg\\:even\\:pl-9:nth-child(even){
    padding-left: 2.25rem;
  }

  .lg\\:even\\:pt-10:nth-child(even){
    padding-top: 2.5rem;
  }

  .lg\\:even\\:pr-10:nth-child(even){
    padding-right: 2.5rem;
  }

  .lg\\:even\\:pb-10:nth-child(even){
    padding-bottom: 2.5rem;
  }

  .lg\\:even\\:pl-10:nth-child(even){
    padding-left: 2.5rem;
  }

  .lg\\:even\\:pt-11:nth-child(even){
    padding-top: 2.75rem;
  }

  .lg\\:even\\:pr-11:nth-child(even){
    padding-right: 2.75rem;
  }

  .lg\\:even\\:pb-11:nth-child(even){
    padding-bottom: 2.75rem;
  }

  .lg\\:even\\:pl-11:nth-child(even){
    padding-left: 2.75rem;
  }

  .lg\\:even\\:pt-12:nth-child(even){
    padding-top: 3rem;
  }

  .lg\\:even\\:pr-12:nth-child(even){
    padding-right: 3rem;
  }

  .lg\\:even\\:pb-12:nth-child(even){
    padding-bottom: 3rem;
  }

  .lg\\:even\\:pl-12:nth-child(even){
    padding-left: 3rem;
  }

  .lg\\:even\\:pt-14:nth-child(even){
    padding-top: 3.5rem;
  }

  .lg\\:even\\:pr-14:nth-child(even){
    padding-right: 3.5rem;
  }

  .lg\\:even\\:pb-14:nth-child(even){
    padding-bottom: 3.5rem;
  }

  .lg\\:even\\:pl-14:nth-child(even){
    padding-left: 3.5rem;
  }

  .lg\\:even\\:pt-15:nth-child(even){
    padding-top: 3.75rem;
  }

  .lg\\:even\\:pr-15:nth-child(even){
    padding-right: 3.75rem;
  }

  .lg\\:even\\:pb-15:nth-child(even){
    padding-bottom: 3.75rem;
  }

  .lg\\:even\\:pl-15:nth-child(even){
    padding-left: 3.75rem;
  }

  .lg\\:even\\:pt-16:nth-child(even){
    padding-top: 4rem;
  }

  .lg\\:even\\:pr-16:nth-child(even){
    padding-right: 4rem;
  }

  .lg\\:even\\:pb-16:nth-child(even){
    padding-bottom: 4rem;
  }

  .lg\\:even\\:pl-16:nth-child(even){
    padding-left: 4rem;
  }

  .lg\\:even\\:pt-18:nth-child(even){
    padding-top: 4.5rem;
  }

  .lg\\:even\\:pr-18:nth-child(even){
    padding-right: 4.5rem;
  }

  .lg\\:even\\:pb-18:nth-child(even){
    padding-bottom: 4.5rem;
  }

  .lg\\:even\\:pl-18:nth-child(even){
    padding-left: 4.5rem;
  }

  .lg\\:even\\:pt-20:nth-child(even){
    padding-top: 5rem;
  }

  .lg\\:even\\:pr-20:nth-child(even){
    padding-right: 5rem;
  }

  .lg\\:even\\:pb-20:nth-child(even){
    padding-bottom: 5rem;
  }

  .lg\\:even\\:pl-20:nth-child(even){
    padding-left: 5rem;
  }

  .lg\\:even\\:pt-22:nth-child(even){
    padding-top: 5.5rem;
  }

  .lg\\:even\\:pr-22:nth-child(even){
    padding-right: 5.5rem;
  }

  .lg\\:even\\:pb-22:nth-child(even){
    padding-bottom: 5.5rem;
  }

  .lg\\:even\\:pl-22:nth-child(even){
    padding-left: 5.5rem;
  }

  .lg\\:even\\:pt-23:nth-child(even){
    padding-top: 5.75rem;
  }

  .lg\\:even\\:pr-23:nth-child(even){
    padding-right: 5.75rem;
  }

  .lg\\:even\\:pb-23:nth-child(even){
    padding-bottom: 5.75rem;
  }

  .lg\\:even\\:pl-23:nth-child(even){
    padding-left: 5.75rem;
  }

  .lg\\:even\\:pt-24:nth-child(even){
    padding-top: 6rem;
  }

  .lg\\:even\\:pr-24:nth-child(even){
    padding-right: 6rem;
  }

  .lg\\:even\\:pb-24:nth-child(even){
    padding-bottom: 6rem;
  }

  .lg\\:even\\:pl-24:nth-child(even){
    padding-left: 6rem;
  }

  .lg\\:even\\:pt-25:nth-child(even){
    padding-top: 6.25rem;
  }

  .lg\\:even\\:pr-25:nth-child(even){
    padding-right: 6.25rem;
  }

  .lg\\:even\\:pb-25:nth-child(even){
    padding-bottom: 6.25rem;
  }

  .lg\\:even\\:pl-25:nth-child(even){
    padding-left: 6.25rem;
  }

  .lg\\:even\\:pt-26:nth-child(even){
    padding-top: 6.5rem;
  }

  .lg\\:even\\:pr-26:nth-child(even){
    padding-right: 6.5rem;
  }

  .lg\\:even\\:pb-26:nth-child(even){
    padding-bottom: 6.5rem;
  }

  .lg\\:even\\:pl-26:nth-child(even){
    padding-left: 6.5rem;
  }

  .lg\\:even\\:pt-28:nth-child(even){
    padding-top: 7rem;
  }

  .lg\\:even\\:pr-28:nth-child(even){
    padding-right: 7rem;
  }

  .lg\\:even\\:pb-28:nth-child(even){
    padding-bottom: 7rem;
  }

  .lg\\:even\\:pl-28:nth-child(even){
    padding-left: 7rem;
  }

  .lg\\:even\\:pt-30:nth-child(even){
    padding-top: 7.5rem;
  }

  .lg\\:even\\:pr-30:nth-child(even){
    padding-right: 7.5rem;
  }

  .lg\\:even\\:pb-30:nth-child(even){
    padding-bottom: 7.5rem;
  }

  .lg\\:even\\:pl-30:nth-child(even){
    padding-left: 7.5rem;
  }

  .lg\\:even\\:pt-32:nth-child(even){
    padding-top: 8rem;
  }

  .lg\\:even\\:pr-32:nth-child(even){
    padding-right: 8rem;
  }

  .lg\\:even\\:pb-32:nth-child(even){
    padding-bottom: 8rem;
  }

  .lg\\:even\\:pl-32:nth-child(even){
    padding-left: 8rem;
  }

  .lg\\:even\\:pt-34:nth-child(even){
    padding-top: 8.5rem;
  }

  .lg\\:even\\:pr-34:nth-child(even){
    padding-right: 8.5rem;
  }

  .lg\\:even\\:pb-34:nth-child(even){
    padding-bottom: 8.5rem;
  }

  .lg\\:even\\:pl-34:nth-child(even){
    padding-left: 8.5rem;
  }

  .lg\\:even\\:pt-40:nth-child(even){
    padding-top: 10rem;
  }

  .lg\\:even\\:pr-40:nth-child(even){
    padding-right: 10rem;
  }

  .lg\\:even\\:pb-40:nth-child(even){
    padding-bottom: 10rem;
  }

  .lg\\:even\\:pl-40:nth-child(even){
    padding-left: 10rem;
  }

  .lg\\:even\\:pt-42:nth-child(even){
    padding-top: 10.5rem;
  }

  .lg\\:even\\:pr-42:nth-child(even){
    padding-right: 10.5rem;
  }

  .lg\\:even\\:pb-42:nth-child(even){
    padding-bottom: 10.5rem;
  }

  .lg\\:even\\:pl-42:nth-child(even){
    padding-left: 10.5rem;
  }

  .lg\\:even\\:pt-44:nth-child(even){
    padding-top: 11rem;
  }

  .lg\\:even\\:pr-44:nth-child(even){
    padding-right: 11rem;
  }

  .lg\\:even\\:pb-44:nth-child(even){
    padding-bottom: 11rem;
  }

  .lg\\:even\\:pl-44:nth-child(even){
    padding-left: 11rem;
  }

  .lg\\:even\\:pt-48:nth-child(even){
    padding-top: 12rem;
  }

  .lg\\:even\\:pr-48:nth-child(even){
    padding-right: 12rem;
  }

  .lg\\:even\\:pb-48:nth-child(even){
    padding-bottom: 12rem;
  }

  .lg\\:even\\:pl-48:nth-child(even){
    padding-left: 12rem;
  }

  .lg\\:even\\:pt-52:nth-child(even){
    padding-top: 13rem;
  }

  .lg\\:even\\:pr-52:nth-child(even){
    padding-right: 13rem;
  }

  .lg\\:even\\:pb-52:nth-child(even){
    padding-bottom: 13rem;
  }

  .lg\\:even\\:pl-52:nth-child(even){
    padding-left: 13rem;
  }

  .lg\\:even\\:pt-54:nth-child(even){
    padding-top: 13.5rem;
  }

  .lg\\:even\\:pr-54:nth-child(even){
    padding-right: 13.5rem;
  }

  .lg\\:even\\:pb-54:nth-child(even){
    padding-bottom: 13.5rem;
  }

  .lg\\:even\\:pl-54:nth-child(even){
    padding-left: 13.5rem;
  }

  .lg\\:even\\:pt-56:nth-child(even){
    padding-top: 14rem;
  }

  .lg\\:even\\:pr-56:nth-child(even){
    padding-right: 14rem;
  }

  .lg\\:even\\:pb-56:nth-child(even){
    padding-bottom: 14rem;
  }

  .lg\\:even\\:pl-56:nth-child(even){
    padding-left: 14rem;
  }

  .lg\\:even\\:pt-60:nth-child(even){
    padding-top: 15rem;
  }

  .lg\\:even\\:pr-60:nth-child(even){
    padding-right: 15rem;
  }

  .lg\\:even\\:pb-60:nth-child(even){
    padding-bottom: 15rem;
  }

  .lg\\:even\\:pl-60:nth-child(even){
    padding-left: 15rem;
  }

  .lg\\:even\\:pt-64:nth-child(even){
    padding-top: 16rem;
  }

  .lg\\:even\\:pr-64:nth-child(even){
    padding-right: 16rem;
  }

  .lg\\:even\\:pb-64:nth-child(even){
    padding-bottom: 16rem;
  }

  .lg\\:even\\:pl-64:nth-child(even){
    padding-left: 16rem;
  }

  .lg\\:even\\:pt-68:nth-child(even){
    padding-top: 17rem;
  }

  .lg\\:even\\:pr-68:nth-child(even){
    padding-right: 17rem;
  }

  .lg\\:even\\:pb-68:nth-child(even){
    padding-bottom: 17rem;
  }

  .lg\\:even\\:pl-68:nth-child(even){
    padding-left: 17rem;
  }

  .lg\\:even\\:pt-72:nth-child(even){
    padding-top: 18rem;
  }

  .lg\\:even\\:pr-72:nth-child(even){
    padding-right: 18rem;
  }

  .lg\\:even\\:pb-72:nth-child(even){
    padding-bottom: 18rem;
  }

  .lg\\:even\\:pl-72:nth-child(even){
    padding-left: 18rem;
  }

  .lg\\:even\\:pt-74:nth-child(even){
    padding-top: 18.5rem;
  }

  .lg\\:even\\:pr-74:nth-child(even){
    padding-right: 18.5rem;
  }

  .lg\\:even\\:pb-74:nth-child(even){
    padding-bottom: 18.5rem;
  }

  .lg\\:even\\:pl-74:nth-child(even){
    padding-left: 18.5rem;
  }

  .lg\\:even\\:pt-76:nth-child(even){
    padding-top: 19rem;
  }

  .lg\\:even\\:pr-76:nth-child(even){
    padding-right: 19rem;
  }

  .lg\\:even\\:pb-76:nth-child(even){
    padding-bottom: 19rem;
  }

  .lg\\:even\\:pl-76:nth-child(even){
    padding-left: 19rem;
  }

  .lg\\:even\\:pt-78:nth-child(even){
    padding-top: 19.5rem;
  }

  .lg\\:even\\:pr-78:nth-child(even){
    padding-right: 19.5rem;
  }

  .lg\\:even\\:pb-78:nth-child(even){
    padding-bottom: 19.5rem;
  }

  .lg\\:even\\:pl-78:nth-child(even){
    padding-left: 19.5rem;
  }

  .lg\\:even\\:pt-80:nth-child(even){
    padding-top: 20rem;
  }

  .lg\\:even\\:pr-80:nth-child(even){
    padding-right: 20rem;
  }

  .lg\\:even\\:pb-80:nth-child(even){
    padding-bottom: 20rem;
  }

  .lg\\:even\\:pl-80:nth-child(even){
    padding-left: 20rem;
  }

  .lg\\:even\\:pt-82:nth-child(even){
    padding-top: 20.5rem;
  }

  .lg\\:even\\:pr-82:nth-child(even){
    padding-right: 20.5rem;
  }

  .lg\\:even\\:pb-82:nth-child(even){
    padding-bottom: 20.5rem;
  }

  .lg\\:even\\:pl-82:nth-child(even){
    padding-left: 20.5rem;
  }

  .lg\\:even\\:pt-84:nth-child(even){
    padding-top: 21rem;
  }

  .lg\\:even\\:pr-84:nth-child(even){
    padding-right: 21rem;
  }

  .lg\\:even\\:pb-84:nth-child(even){
    padding-bottom: 21rem;
  }

  .lg\\:even\\:pl-84:nth-child(even){
    padding-left: 21rem;
  }

  .lg\\:even\\:pt-88:nth-child(even){
    padding-top: 22rem;
  }

  .lg\\:even\\:pr-88:nth-child(even){
    padding-right: 22rem;
  }

  .lg\\:even\\:pb-88:nth-child(even){
    padding-bottom: 22rem;
  }

  .lg\\:even\\:pl-88:nth-child(even){
    padding-left: 22rem;
  }

  .lg\\:even\\:pt-92:nth-child(even){
    padding-top: 23rem;
  }

  .lg\\:even\\:pr-92:nth-child(even){
    padding-right: 23rem;
  }

  .lg\\:even\\:pb-92:nth-child(even){
    padding-bottom: 23rem;
  }

  .lg\\:even\\:pl-92:nth-child(even){
    padding-left: 23rem;
  }

  .lg\\:even\\:pt-96:nth-child(even){
    padding-top: 24rem;
  }

  .lg\\:even\\:pr-96:nth-child(even){
    padding-right: 24rem;
  }

  .lg\\:even\\:pb-96:nth-child(even){
    padding-bottom: 24rem;
  }

  .lg\\:even\\:pl-96:nth-child(even){
    padding-left: 24rem;
  }

  .lg\\:even\\:pt-98:nth-child(even){
    padding-top: 24.5rem;
  }

  .lg\\:even\\:pr-98:nth-child(even){
    padding-right: 24.5rem;
  }

  .lg\\:even\\:pb-98:nth-child(even){
    padding-bottom: 24.5rem;
  }

  .lg\\:even\\:pl-98:nth-child(even){
    padding-left: 24.5rem;
  }

  .lg\\:even\\:pt-100:nth-child(even){
    padding-top: 25rem;
  }

  .lg\\:even\\:pr-100:nth-child(even){
    padding-right: 25rem;
  }

  .lg\\:even\\:pb-100:nth-child(even){
    padding-bottom: 25rem;
  }

  .lg\\:even\\:pl-100:nth-child(even){
    padding-left: 25rem;
  }

  .lg\\:even\\:pt-104:nth-child(even){
    padding-top: 26rem;
  }

  .lg\\:even\\:pr-104:nth-child(even){
    padding-right: 26rem;
  }

  .lg\\:even\\:pb-104:nth-child(even){
    padding-bottom: 26rem;
  }

  .lg\\:even\\:pl-104:nth-child(even){
    padding-left: 26rem;
  }

  .lg\\:even\\:pt-112:nth-child(even){
    padding-top: 28rem;
  }

  .lg\\:even\\:pr-112:nth-child(even){
    padding-right: 28rem;
  }

  .lg\\:even\\:pb-112:nth-child(even){
    padding-bottom: 28rem;
  }

  .lg\\:even\\:pl-112:nth-child(even){
    padding-left: 28rem;
  }

  .lg\\:even\\:pt-124:nth-child(even){
    padding-top: 31rem;
  }

  .lg\\:even\\:pr-124:nth-child(even){
    padding-right: 31rem;
  }

  .lg\\:even\\:pb-124:nth-child(even){
    padding-bottom: 31rem;
  }

  .lg\\:even\\:pl-124:nth-child(even){
    padding-left: 31rem;
  }

  .lg\\:even\\:pt-128:nth-child(even){
    padding-top: 32rem;
  }

  .lg\\:even\\:pr-128:nth-child(even){
    padding-right: 32rem;
  }

  .lg\\:even\\:pb-128:nth-child(even){
    padding-bottom: 32rem;
  }

  .lg\\:even\\:pl-128:nth-child(even){
    padding-left: 32rem;
  }

  .lg\\:even\\:pt-140:nth-child(even){
    padding-top: 35rem;
  }

  .lg\\:even\\:pr-140:nth-child(even){
    padding-right: 35rem;
  }

  .lg\\:even\\:pb-140:nth-child(even){
    padding-bottom: 35rem;
  }

  .lg\\:even\\:pl-140:nth-child(even){
    padding-left: 35rem;
  }

  .lg\\:even\\:pt-152:nth-child(even){
    padding-top: 38rem;
  }

  .lg\\:even\\:pr-152:nth-child(even){
    padding-right: 38rem;
  }

  .lg\\:even\\:pb-152:nth-child(even){
    padding-bottom: 38rem;
  }

  .lg\\:even\\:pl-152:nth-child(even){
    padding-left: 38rem;
  }

  .lg\\:even\\:pt-160:nth-child(even){
    padding-top: 40rem;
  }

  .lg\\:even\\:pr-160:nth-child(even){
    padding-right: 40rem;
  }

  .lg\\:even\\:pb-160:nth-child(even){
    padding-bottom: 40rem;
  }

  .lg\\:even\\:pl-160:nth-child(even){
    padding-left: 40rem;
  }

  .lg\\:even\\:pt-162:nth-child(even){
    padding-top: 41rem;
  }

  .lg\\:even\\:pr-162:nth-child(even){
    padding-right: 41rem;
  }

  .lg\\:even\\:pb-162:nth-child(even){
    padding-bottom: 41rem;
  }

  .lg\\:even\\:pl-162:nth-child(even){
    padding-left: 41rem;
  }

  .lg\\:even\\:pt-192:nth-child(even){
    padding-top: 48rem;
  }

  .lg\\:even\\:pr-192:nth-child(even){
    padding-right: 48rem;
  }

  .lg\\:even\\:pb-192:nth-child(even){
    padding-bottom: 48rem;
  }

  .lg\\:even\\:pl-192:nth-child(even){
    padding-left: 48rem;
  }

  .lg\\:even\\:pt-208:nth-child(even){
    padding-top: 52rem;
  }

  .lg\\:even\\:pr-208:nth-child(even){
    padding-right: 52rem;
  }

  .lg\\:even\\:pb-208:nth-child(even){
    padding-bottom: 52rem;
  }

  .lg\\:even\\:pl-208:nth-child(even){
    padding-left: 52rem;
  }

  .lg\\:even\\:pt-224:nth-child(even){
    padding-top: 56rem;
  }

  .lg\\:even\\:pr-224:nth-child(even){
    padding-right: 56rem;
  }

  .lg\\:even\\:pb-224:nth-child(even){
    padding-bottom: 56rem;
  }

  .lg\\:even\\:pl-224:nth-child(even){
    padding-left: 56rem;
  }

  .lg\\:even\\:pt-256:nth-child(even){
    padding-top: 64rem;
  }

  .lg\\:even\\:pr-256:nth-child(even){
    padding-right: 64rem;
  }

  .lg\\:even\\:pb-256:nth-child(even){
    padding-bottom: 64rem;
  }

  .lg\\:even\\:pl-256:nth-child(even){
    padding-left: 64rem;
  }

  .lg\\:even\\:pt-px:nth-child(even){
    padding-top: 1px;
  }

  .lg\\:even\\:pr-px:nth-child(even){
    padding-right: 1px;
  }

  .lg\\:even\\:pb-px:nth-child(even){
    padding-bottom: 1px;
  }

  .lg\\:even\\:pl-px:nth-child(even){
    padding-left: 1px;
  }

  .lg\\:placeholder-transparent::placeholder{
    color: transparent;
  }

  .lg\\:placeholder-focus::placeholder{
    color: rgba(4, 21, 39, 0.8);;
  }

  .lg\\:placeholder-black::placeholder{
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .lg\\:placeholder-white::placeholder{
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .lg\\:placeholder-primary::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .lg\\:placeholder-disabled::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .lg\\:placeholder-translucent-60::placeholder{
    color: rgba(256, 256, 256, 0.6);
  }

  .lg\\:placeholder-translucent-90::placeholder{
    color: rgba(256, 256, 256, 0.9);
  }

  .lg\\:placeholder-green-200::placeholder{
    --placeholder-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, var(--placeholder-opacity));
  }

  .lg\\:placeholder-green-400::placeholder{
    --placeholder-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, var(--placeholder-opacity));
  }

  .lg\\:placeholder-green-500::placeholder{
    --placeholder-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, var(--placeholder-opacity));
  }

  .lg\\:placeholder-green-600::placeholder{
    --placeholder-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, var(--placeholder-opacity));
  }

  .lg\\:placeholder-green-700::placeholder{
    --placeholder-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, var(--placeholder-opacity));
  }

  .lg\\:placeholder-green-400a50::placeholder{
    color: rgba(108,202,152,0.50196);
  }

  .lg\\:placeholder-green-500a25::placeholder{
    color: rgba(151,232,18,0.09804);
  }

  .lg\\:placeholder-yellow-200::placeholder{
    --placeholder-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, var(--placeholder-opacity));
  }

  .lg\\:placeholder-yellow-300::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, var(--placeholder-opacity));
  }

  .lg\\:placeholder-yellow-500::placeholder{
    --placeholder-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, var(--placeholder-opacity));
  }

  .lg\\:placeholder-yellow-600::placeholder{
    --placeholder-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, var(--placeholder-opacity));
  }

  .lg\\:placeholder-yellow-700::placeholder{
    --placeholder-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, var(--placeholder-opacity));
  }

  .lg\\:placeholder-yellow-300a66::placeholder{
    color: rgba(255,233,189,0.66667);
  }

  .lg\\:placeholder-yellow-500a25::placeholder{
    color: rgba(255,200,44,0.09804);
  }

  .lg\\:placeholder-orange-200::placeholder{
    --placeholder-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, var(--placeholder-opacity));
  }

  .lg\\:placeholder-orange-400::placeholder{
    --placeholder-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, var(--placeholder-opacity));
  }

  .lg\\:placeholder-orange-500::placeholder{
    --placeholder-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, var(--placeholder-opacity));
  }

  .lg\\:placeholder-orange-800::placeholder{
    --placeholder-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, var(--placeholder-opacity));
  }

  .lg\\:placeholder-orange-900::placeholder{
    --placeholder-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, var(--placeholder-opacity));
  }

  .lg\\:placeholder-orange-500a25::placeholder{
    color: rgba(240,115,23,0.09804);
  }

  .lg\\:placeholder-red-100::placeholder{
    --placeholder-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, var(--placeholder-opacity));
  }

  .lg\\:placeholder-red-150::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, var(--placeholder-opacity));
  }

  .lg\\:placeholder-red-200::placeholder{
    --placeholder-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, var(--placeholder-opacity));
  }

  .lg\\:placeholder-red-300::placeholder{
    --placeholder-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, var(--placeholder-opacity));
  }

  .lg\\:placeholder-red-400::placeholder{
    --placeholder-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, var(--placeholder-opacity));
  }

  .lg\\:placeholder-red-500::placeholder{
    --placeholder-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, var(--placeholder-opacity));
  }

  .lg\\:placeholder-red-700::placeholder{
    --placeholder-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-50::placeholder{
    --placeholder-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-100::placeholder{
    --placeholder-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-150::placeholder{
    --placeholder-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-200::placeholder{
    --placeholder-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-300::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-400::placeholder{
    color: rgba(114,114,114,0.8);
  }

  .lg\\:placeholder-gray-425::placeholder{
    color: rgba(4, 21, 39, 0.8);
  }

  .lg\\:placeholder-gray-450::placeholder{
    --placeholder-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-500::placeholder{
    --placeholder-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-600::placeholder{
    --placeholder-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-625::placeholder{
    color: rgba(90,98,107,0.8);
  }

  .lg\\:placeholder-gray-700::placeholder{
    --placeholder-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-800::placeholder{
    --placeholder-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, var(--placeholder-opacity));
  }

  .lg\\:placeholder-gray-200a50::placeholder{
    color: rgba(224, 226, 228, 0.5);
  }

  .lg\\:placeholder-blue-50::placeholder{
    --placeholder-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-100::placeholder{
    --placeholder-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-150::placeholder{
    --placeholder-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-200::placeholder{
    --placeholder-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-300::placeholder{
    --placeholder-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-400::placeholder{
    --placeholder-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-500::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-600::placeholder{
    --placeholder-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-700::placeholder{
    --placeholder-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-750::placeholder{
    --placeholder-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-800::placeholder{
    --placeholder-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-900::placeholder{
    --placeholder-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-950::placeholder{
    --placeholder-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-500a25::placeholder{
    color: rgba(55, 164, 220, 0.2);
  }

  .lg\\:placeholder-blue-500a50::placeholder{
    color: rgba(55, 164, 220, 0.5);
  }

  .lg\\:placeholder-blue-700a75::placeholder{
    --placeholder-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-700a30::placeholder{
    --placeholder-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, var(--placeholder-opacity));
  }

  .lg\\:placeholder-blue-750a25::placeholder{
    color: rgba(86,130,170,0.09804);
  }

  .lg\\:placeholder-blue-750a15::placeholder{
    color: rgba(86,130,170,0.05882);
  }

  .lg\\:placeholder-blue-800a60::placeholder{
    color: rgba(31, 69, 102, 0.6);
  }

  .lg\\:placeholder-programEditorTabColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, var(--placeholder-opacity));
  }

  .lg\\:placeholder-programEditorTabColors-2::placeholder{
    --placeholder-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, var(--placeholder-opacity));
  }

  .lg\\:placeholder-programEditorTabColors-3::placeholder{
    --placeholder-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, var(--placeholder-opacity));
  }

  .lg\\:placeholder-programEditorTabColors-4::placeholder{
    --placeholder-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, var(--placeholder-opacity));
  }

  .lg\\:placeholder-programEditorTabColors-5::placeholder{
    --placeholder-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, var(--placeholder-opacity));
  }

  .lg\\:placeholder-programEditorTabColors-6::placeholder{
    --placeholder-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, var(--placeholder-opacity));
  }

  .lg\\:placeholder-programEditorTabColors-1h::placeholder{
    --placeholder-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, var(--placeholder-opacity));
  }

  .lg\\:placeholder-programEditorTabColors-2h::placeholder{
    --placeholder-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, var(--placeholder-opacity));
  }

  .lg\\:placeholder-programEditorTabColors-3h::placeholder{
    --placeholder-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, var(--placeholder-opacity));
  }

  .lg\\:placeholder-programEditorTabColors-4h::placeholder{
    --placeholder-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, var(--placeholder-opacity));
  }

  .lg\\:placeholder-programEditorTabColors-5h::placeholder{
    --placeholder-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, var(--placeholder-opacity));
  }

  .lg\\:placeholder-programEditorTabColors-6h::placeholder{
    --placeholder-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, var(--placeholder-opacity));
  }

  .lg\\:placeholder-programEditorPresetTabColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .lg\\:placeholder-programEditorPresetTabColors-1h::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .lg\\:placeholder-borgScaleColors-0::placeholder{
    --placeholder-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, var(--placeholder-opacity));
  }

  .lg\\:placeholder-borgScaleColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, var(--placeholder-opacity));
  }

  .lg\\:placeholder-borgScaleColors-2::placeholder{
    --placeholder-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, var(--placeholder-opacity));
  }

  .lg\\:placeholder-borgScaleColors-3::placeholder{
    --placeholder-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, var(--placeholder-opacity));
  }

  .lg\\:placeholder-borgScaleColors-4::placeholder{
    --placeholder-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .lg\\:placeholder-borgScaleColors-5::placeholder{
    --placeholder-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, var(--placeholder-opacity));
  }

  .lg\\:placeholder-borgScaleColors-6::placeholder{
    --placeholder-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, var(--placeholder-opacity));
  }

  .lg\\:placeholder-borgScaleColors-7::placeholder{
    --placeholder-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, var(--placeholder-opacity));
  }

  .lg\\:placeholder-borgScaleColors-8::placeholder{
    --placeholder-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, var(--placeholder-opacity));
  }

  .lg\\:placeholder-borgScaleColors-9::placeholder{
    --placeholder-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, var(--placeholder-opacity));
  }

  .lg\\:placeholder-borgScaleColors-10::placeholder{
    --placeholder-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-transparent:focus::placeholder{
    color: transparent;
  }

  .lg\\:focus\\:placeholder-focus:focus::placeholder{
    color: rgba(4, 21, 39, 0.8);;
  }

  .lg\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-primary:focus::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-disabled:focus::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-translucent-60:focus::placeholder{
    color: rgba(256, 256, 256, 0.6);
  }

  .lg\\:focus\\:placeholder-translucent-90:focus::placeholder{
    color: rgba(256, 256, 256, 0.9);
  }

  .lg\\:focus\\:placeholder-green-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-green-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-green-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-green-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-green-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-green-400a50:focus::placeholder{
    color: rgba(108,202,152,0.50196);
  }

  .lg\\:focus\\:placeholder-green-500a25:focus::placeholder{
    color: rgba(151,232,18,0.09804);
  }

  .lg\\:focus\\:placeholder-yellow-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-yellow-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-yellow-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-yellow-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-yellow-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-yellow-300a66:focus::placeholder{
    color: rgba(255,233,189,0.66667);
  }

  .lg\\:focus\\:placeholder-yellow-500a25:focus::placeholder{
    color: rgba(255,200,44,0.09804);
  }

  .lg\\:focus\\:placeholder-orange-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-orange-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-orange-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-orange-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-orange-900:focus::placeholder{
    --placeholder-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-orange-500a25:focus::placeholder{
    color: rgba(240,115,23,0.09804);
  }

  .lg\\:focus\\:placeholder-red-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-red-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-red-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-red-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-red-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-red-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-red-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-50:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-400:focus::placeholder{
    color: rgba(114,114,114,0.8);
  }

  .lg\\:focus\\:placeholder-gray-425:focus::placeholder{
    color: rgba(4, 21, 39, 0.8);
  }

  .lg\\:focus\\:placeholder-gray-450:focus::placeholder{
    --placeholder-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-625:focus::placeholder{
    color: rgba(90,98,107,0.8);
  }

  .lg\\:focus\\:placeholder-gray-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-gray-200a50:focus::placeholder{
    color: rgba(224, 226, 228, 0.5);
  }

  .lg\\:focus\\:placeholder-blue-50:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-750:focus::placeholder{
    --placeholder-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-900:focus::placeholder{
    --placeholder-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-950:focus::placeholder{
    --placeholder-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-500a25:focus::placeholder{
    color: rgba(55, 164, 220, 0.2);
  }

  .lg\\:focus\\:placeholder-blue-500a50:focus::placeholder{
    color: rgba(55, 164, 220, 0.5);
  }

  .lg\\:focus\\:placeholder-blue-700a75:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-700a30:focus::placeholder{
    --placeholder-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-blue-750a25:focus::placeholder{
    color: rgba(86,130,170,0.09804);
  }

  .lg\\:focus\\:placeholder-blue-750a15:focus::placeholder{
    color: rgba(86,130,170,0.05882);
  }

  .lg\\:focus\\:placeholder-blue-800a60:focus::placeholder{
    color: rgba(31, 69, 102, 0.6);
  }

  .lg\\:focus\\:placeholder-programEditorTabColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-programEditorTabColors-2:focus::placeholder{
    --placeholder-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-programEditorTabColors-3:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-programEditorTabColors-4:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-programEditorTabColors-5:focus::placeholder{
    --placeholder-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-programEditorTabColors-6:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-programEditorTabColors-1h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-programEditorTabColors-2h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-programEditorTabColors-3h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-programEditorTabColors-4h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-programEditorTabColors-5h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-programEditorTabColors-6h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-programEditorPresetTabColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-programEditorPresetTabColors-1h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-borgScaleColors-0:focus::placeholder{
    --placeholder-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-borgScaleColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-borgScaleColors-2:focus::placeholder{
    --placeholder-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-borgScaleColors-3:focus::placeholder{
    --placeholder-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-borgScaleColors-4:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-borgScaleColors-5:focus::placeholder{
    --placeholder-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-borgScaleColors-6:focus::placeholder{
    --placeholder-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-borgScaleColors-7:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-borgScaleColors-8:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-borgScaleColors-9:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, var(--placeholder-opacity));
  }

  .lg\\:focus\\:placeholder-borgScaleColors-10:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, var(--placeholder-opacity));
  }

  .lg\\:placeholder-opacity-0::placeholder{
    --placeholder-opacity: 0;
  }

  .lg\\:placeholder-opacity-25::placeholder{
    --placeholder-opacity: .25;
  }

  .lg\\:placeholder-opacity-50::placeholder{
    --placeholder-opacity: .5;
  }

  .lg\\:placeholder-opacity-75::placeholder{
    --placeholder-opacity: .75;
  }

  .lg\\:placeholder-opacity-100::placeholder{
    --placeholder-opacity: 1;
  }

  .lg\\:focus\\:placeholder-opacity-0:focus::placeholder{
    --placeholder-opacity: 0;
  }

  .lg\\:focus\\:placeholder-opacity-25:focus::placeholder{
    --placeholder-opacity: .25;
  }

  .lg\\:focus\\:placeholder-opacity-50:focus::placeholder{
    --placeholder-opacity: .5;
  }

  .lg\\:focus\\:placeholder-opacity-75:focus::placeholder{
    --placeholder-opacity: .75;
  }

  .lg\\:focus\\:placeholder-opacity-100:focus::placeholder{
    --placeholder-opacity: 1;
  }

  .lg\\:pointer-events-none{
    pointer-events: none;
  }

  .lg\\:pointer-events-auto{
    pointer-events: auto;
  }

  .lg\\:static{
    position: static;
  }

  .lg\\:fixed{
    position: fixed;
  }

  .lg\\:absolute{
    position: absolute;
  }

  .lg\\:relative{
    position: relative;
  }

  .lg\\:sticky{
    position: sticky;
  }

  .lg\\:inset-0{
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .lg\\:inset-auto{
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }

  .lg\\:inset-y-0{
    top: 0;
    bottom: 0;
  }

  .lg\\:inset-x-0{
    right: 0;
    left: 0;
  }

  .lg\\:inset-y-auto{
    top: auto;
    bottom: auto;
  }

  .lg\\:inset-x-auto{
    right: auto;
    left: auto;
  }

  .lg\\:top-0{
    top: 0;
  }

  .lg\\:right-0{
    right: 0;
  }

  .lg\\:bottom-0{
    bottom: 0;
  }

  .lg\\:left-0{
    left: 0;
  }

  .lg\\:top-auto{
    top: auto;
  }

  .lg\\:right-auto{
    right: auto;
  }

  .lg\\:bottom-auto{
    bottom: auto;
  }

  .lg\\:left-auto{
    left: auto;
  }

  .lg\\:resize-none{
    resize: none;
  }

  .lg\\:resize-y{
    resize: vertical;
  }

  .lg\\:resize-x{
    resize: horizontal;
  }

  .lg\\:resize{
    resize: both;
  }

  .lg\\:shadow{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .lg\\:shadow-overlaptop{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .lg\\:shadow-overlapbottom{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .lg\\:shadow-xs{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .lg\\:shadow-sm{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .lg\\:shadow-md{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .lg\\:shadow-lg{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .lg\\:shadow-xl{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .lg\\:shadow-2xl{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .lg\\:shadow-none{
    box-shadow: none;
  }

  .lg\\:hover\\:shadow:hover{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .lg\\:hover\\:shadow-overlaptop:hover{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .lg\\:hover\\:shadow-overlapbottom:hover{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .lg\\:hover\\:shadow-xs:hover{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .lg\\:hover\\:shadow-sm:hover{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .lg\\:hover\\:shadow-md:hover{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .lg\\:hover\\:shadow-lg:hover{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .lg\\:hover\\:shadow-xl:hover{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .lg\\:hover\\:shadow-2xl:hover{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .lg\\:hover\\:shadow-none:hover{
    box-shadow: none;
  }

  .lg\\:focus\\:shadow:focus{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .lg\\:focus\\:shadow-overlaptop:focus{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .lg\\:focus\\:shadow-overlapbottom:focus{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .lg\\:focus\\:shadow-xs:focus{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .lg\\:focus\\:shadow-sm:focus{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .lg\\:focus\\:shadow-md:focus{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .lg\\:focus\\:shadow-lg:focus{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .lg\\:focus\\:shadow-xl:focus{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .lg\\:focus\\:shadow-2xl:focus{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .lg\\:focus\\:shadow-none:focus{
    box-shadow: none;
  }

  .lg\\:stroke-0{
    stroke-width: 0;
  }

  .lg\\:stroke-1{
    stroke-width: 1;
  }

  .lg\\:stroke-2{
    stroke-width: 2;
  }

  .lg\\:table-auto{
    table-layout: auto;
  }

  .lg\\:table-fixed{
    table-layout: fixed;
  }

  .lg\\:text-left{
    text-align: left;
  }

  .lg\\:text-center{
    text-align: center;
  }

  .lg\\:text-right{
    text-align: right;
  }

  .lg\\:text-justify{
    text-align: justify;
  }

  .lg\\:text-transparent{
    color: transparent;
  }

  .lg\\:text-focus{
    color: rgba(4, 21, 39, 0.8);;
  }

  .lg\\:text-black{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .lg\\:text-white{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .lg\\:text-primary{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .lg\\:text-disabled{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .lg\\:text-translucent-60{
    color: rgba(256, 256, 256, 0.6);
  }

  .lg\\:text-translucent-90{
    color: rgba(256, 256, 256, 0.9);
  }

  .lg\\:text-green-200{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .lg\\:text-green-400{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .lg\\:text-green-500{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .lg\\:text-green-600{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .lg\\:text-green-700{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .lg\\:text-green-400a50{
    color: rgba(108,202,152,0.50196);
  }

  .lg\\:text-green-500a25{
    color: rgba(151,232,18,0.09804);
  }

  .lg\\:text-yellow-200{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .lg\\:text-yellow-300{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .lg\\:text-yellow-500{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .lg\\:text-yellow-600{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .lg\\:text-yellow-700{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .lg\\:text-yellow-300a66{
    color: rgba(255,233,189,0.66667);
  }

  .lg\\:text-yellow-500a25{
    color: rgba(255,200,44,0.09804);
  }

  .lg\\:text-orange-200{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .lg\\:text-orange-400{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .lg\\:text-orange-500{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .lg\\:text-orange-800{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .lg\\:text-orange-900{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .lg\\:text-orange-500a25{
    color: rgba(240,115,23,0.09804);
  }

  .lg\\:text-red-100{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .lg\\:text-red-150{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .lg\\:text-red-200{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .lg\\:text-red-300{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .lg\\:text-red-400{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .lg\\:text-red-500{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .lg\\:text-red-700{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .lg\\:text-gray-50{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .lg\\:text-gray-100{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .lg\\:text-gray-150{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .lg\\:text-gray-200{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .lg\\:text-gray-300{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .lg\\:text-gray-400{
    color: rgba(114,114,114,0.8);
  }

  .lg\\:text-gray-425{
    color: rgba(4, 21, 39, 0.8);
  }

  .lg\\:text-gray-450{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .lg\\:text-gray-500{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .lg\\:text-gray-600{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .lg\\:text-gray-625{
    color: rgba(90,98,107,0.8);
  }

  .lg\\:text-gray-700{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .lg\\:text-gray-800{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .lg\\:text-gray-200a50{
    color: rgba(224, 226, 228, 0.5);
  }

  .lg\\:text-blue-50{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .lg\\:text-blue-100{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .lg\\:text-blue-150{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .lg\\:text-blue-200{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .lg\\:text-blue-300{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .lg\\:text-blue-400{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .lg\\:text-blue-500{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .lg\\:text-blue-600{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .lg\\:text-blue-700{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .lg\\:text-blue-750{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .lg\\:text-blue-800{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .lg\\:text-blue-900{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .lg\\:text-blue-950{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .lg\\:text-blue-500a25{
    color: rgba(55, 164, 220, 0.2);
  }

  .lg\\:text-blue-500a50{
    color: rgba(55, 164, 220, 0.5);
  }

  .lg\\:text-blue-700a75{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .lg\\:text-blue-700a30{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .lg\\:text-blue-750a25{
    color: rgba(86,130,170,0.09804);
  }

  .lg\\:text-blue-750a15{
    color: rgba(86,130,170,0.05882);
  }

  .lg\\:text-blue-800a60{
    color: rgba(31, 69, 102, 0.6);
  }

  .lg\\:text-programEditorTabColors-1{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .lg\\:text-programEditorTabColors-2{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .lg\\:text-programEditorTabColors-3{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .lg\\:text-programEditorTabColors-4{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .lg\\:text-programEditorTabColors-5{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .lg\\:text-programEditorTabColors-6{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .lg\\:text-programEditorTabColors-1h{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .lg\\:text-programEditorTabColors-2h{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .lg\\:text-programEditorTabColors-3h{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .lg\\:text-programEditorTabColors-4h{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .lg\\:text-programEditorTabColors-5h{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .lg\\:text-programEditorTabColors-6h{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .lg\\:text-programEditorPresetTabColors-1{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .lg\\:text-programEditorPresetTabColors-1h{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .lg\\:text-borgScaleColors-0{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .lg\\:text-borgScaleColors-1{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .lg\\:text-borgScaleColors-2{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .lg\\:text-borgScaleColors-3{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .lg\\:text-borgScaleColors-4{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .lg\\:text-borgScaleColors-5{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .lg\\:text-borgScaleColors-6{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .lg\\:text-borgScaleColors-7{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .lg\\:text-borgScaleColors-8{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .lg\\:text-borgScaleColors-9{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .lg\\:text-borgScaleColors-10{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .lg\\:hover\\:text-transparent:hover{
    color: transparent;
  }

  .lg\\:hover\\:text-focus:hover{
    color: rgba(4, 21, 39, 0.8);;
  }

  .lg\\:hover\\:text-black:hover{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .lg\\:hover\\:text-white:hover{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .lg\\:hover\\:text-primary:hover{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .lg\\:hover\\:text-disabled:hover{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .lg\\:hover\\:text-translucent-60:hover{
    color: rgba(256, 256, 256, 0.6);
  }

  .lg\\:hover\\:text-translucent-90:hover{
    color: rgba(256, 256, 256, 0.9);
  }

  .lg\\:hover\\:text-green-200:hover{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .lg\\:hover\\:text-green-400:hover{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .lg\\:hover\\:text-green-500:hover{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .lg\\:hover\\:text-green-600:hover{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .lg\\:hover\\:text-green-700:hover{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .lg\\:hover\\:text-green-400a50:hover{
    color: rgba(108,202,152,0.50196);
  }

  .lg\\:hover\\:text-green-500a25:hover{
    color: rgba(151,232,18,0.09804);
  }

  .lg\\:hover\\:text-yellow-200:hover{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .lg\\:hover\\:text-yellow-300:hover{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .lg\\:hover\\:text-yellow-500:hover{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .lg\\:hover\\:text-yellow-600:hover{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .lg\\:hover\\:text-yellow-700:hover{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .lg\\:hover\\:text-yellow-300a66:hover{
    color: rgba(255,233,189,0.66667);
  }

  .lg\\:hover\\:text-yellow-500a25:hover{
    color: rgba(255,200,44,0.09804);
  }

  .lg\\:hover\\:text-orange-200:hover{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .lg\\:hover\\:text-orange-400:hover{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .lg\\:hover\\:text-orange-500:hover{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .lg\\:hover\\:text-orange-800:hover{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .lg\\:hover\\:text-orange-900:hover{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .lg\\:hover\\:text-orange-500a25:hover{
    color: rgba(240,115,23,0.09804);
  }

  .lg\\:hover\\:text-red-100:hover{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .lg\\:hover\\:text-red-150:hover{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .lg\\:hover\\:text-red-200:hover{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .lg\\:hover\\:text-red-300:hover{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .lg\\:hover\\:text-red-400:hover{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .lg\\:hover\\:text-red-500:hover{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .lg\\:hover\\:text-red-700:hover{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .lg\\:hover\\:text-gray-50:hover{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .lg\\:hover\\:text-gray-100:hover{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .lg\\:hover\\:text-gray-150:hover{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .lg\\:hover\\:text-gray-200:hover{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .lg\\:hover\\:text-gray-300:hover{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .lg\\:hover\\:text-gray-400:hover{
    color: rgba(114,114,114,0.8);
  }

  .lg\\:hover\\:text-gray-425:hover{
    color: rgba(4, 21, 39, 0.8);
  }

  .lg\\:hover\\:text-gray-450:hover{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .lg\\:hover\\:text-gray-500:hover{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .lg\\:hover\\:text-gray-600:hover{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .lg\\:hover\\:text-gray-625:hover{
    color: rgba(90,98,107,0.8);
  }

  .lg\\:hover\\:text-gray-700:hover{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .lg\\:hover\\:text-gray-800:hover{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .lg\\:hover\\:text-gray-200a50:hover{
    color: rgba(224, 226, 228, 0.5);
  }

  .lg\\:hover\\:text-blue-50:hover{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .lg\\:hover\\:text-blue-100:hover{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .lg\\:hover\\:text-blue-150:hover{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .lg\\:hover\\:text-blue-200:hover{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .lg\\:hover\\:text-blue-300:hover{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .lg\\:hover\\:text-blue-400:hover{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .lg\\:hover\\:text-blue-500:hover{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .lg\\:hover\\:text-blue-600:hover{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .lg\\:hover\\:text-blue-700:hover{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .lg\\:hover\\:text-blue-750:hover{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .lg\\:hover\\:text-blue-800:hover{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .lg\\:hover\\:text-blue-900:hover{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .lg\\:hover\\:text-blue-950:hover{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .lg\\:hover\\:text-blue-500a25:hover{
    color: rgba(55, 164, 220, 0.2);
  }

  .lg\\:hover\\:text-blue-500a50:hover{
    color: rgba(55, 164, 220, 0.5);
  }

  .lg\\:hover\\:text-blue-700a75:hover{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .lg\\:hover\\:text-blue-700a30:hover{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .lg\\:hover\\:text-blue-750a25:hover{
    color: rgba(86,130,170,0.09804);
  }

  .lg\\:hover\\:text-blue-750a15:hover{
    color: rgba(86,130,170,0.05882);
  }

  .lg\\:hover\\:text-blue-800a60:hover{
    color: rgba(31, 69, 102, 0.6);
  }

  .lg\\:hover\\:text-programEditorTabColors-1:hover{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .lg\\:hover\\:text-programEditorTabColors-2:hover{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .lg\\:hover\\:text-programEditorTabColors-3:hover{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .lg\\:hover\\:text-programEditorTabColors-4:hover{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .lg\\:hover\\:text-programEditorTabColors-5:hover{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .lg\\:hover\\:text-programEditorTabColors-6:hover{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .lg\\:hover\\:text-programEditorTabColors-1h:hover{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .lg\\:hover\\:text-programEditorTabColors-2h:hover{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .lg\\:hover\\:text-programEditorTabColors-3h:hover{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .lg\\:hover\\:text-programEditorTabColors-4h:hover{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .lg\\:hover\\:text-programEditorTabColors-5h:hover{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .lg\\:hover\\:text-programEditorTabColors-6h:hover{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .lg\\:hover\\:text-programEditorPresetTabColors-1:hover{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .lg\\:hover\\:text-programEditorPresetTabColors-1h:hover{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .lg\\:hover\\:text-borgScaleColors-0:hover{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .lg\\:hover\\:text-borgScaleColors-1:hover{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .lg\\:hover\\:text-borgScaleColors-2:hover{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .lg\\:hover\\:text-borgScaleColors-3:hover{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .lg\\:hover\\:text-borgScaleColors-4:hover{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .lg\\:hover\\:text-borgScaleColors-5:hover{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .lg\\:hover\\:text-borgScaleColors-6:hover{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .lg\\:hover\\:text-borgScaleColors-7:hover{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .lg\\:hover\\:text-borgScaleColors-8:hover{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .lg\\:hover\\:text-borgScaleColors-9:hover{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .lg\\:hover\\:text-borgScaleColors-10:hover{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .lg\\:focus\\:text-transparent:focus{
    color: transparent;
  }

  .lg\\:focus\\:text-focus:focus{
    color: rgba(4, 21, 39, 0.8);;
  }

  .lg\\:focus\\:text-black:focus{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .lg\\:focus\\:text-white:focus{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .lg\\:focus\\:text-primary:focus{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .lg\\:focus\\:text-disabled:focus{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .lg\\:focus\\:text-translucent-60:focus{
    color: rgba(256, 256, 256, 0.6);
  }

  .lg\\:focus\\:text-translucent-90:focus{
    color: rgba(256, 256, 256, 0.9);
  }

  .lg\\:focus\\:text-green-200:focus{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .lg\\:focus\\:text-green-400:focus{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .lg\\:focus\\:text-green-500:focus{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .lg\\:focus\\:text-green-600:focus{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .lg\\:focus\\:text-green-700:focus{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .lg\\:focus\\:text-green-400a50:focus{
    color: rgba(108,202,152,0.50196);
  }

  .lg\\:focus\\:text-green-500a25:focus{
    color: rgba(151,232,18,0.09804);
  }

  .lg\\:focus\\:text-yellow-200:focus{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .lg\\:focus\\:text-yellow-300:focus{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .lg\\:focus\\:text-yellow-500:focus{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .lg\\:focus\\:text-yellow-600:focus{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .lg\\:focus\\:text-yellow-700:focus{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .lg\\:focus\\:text-yellow-300a66:focus{
    color: rgba(255,233,189,0.66667);
  }

  .lg\\:focus\\:text-yellow-500a25:focus{
    color: rgba(255,200,44,0.09804);
  }

  .lg\\:focus\\:text-orange-200:focus{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .lg\\:focus\\:text-orange-400:focus{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .lg\\:focus\\:text-orange-500:focus{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .lg\\:focus\\:text-orange-800:focus{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .lg\\:focus\\:text-orange-900:focus{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .lg\\:focus\\:text-orange-500a25:focus{
    color: rgba(240,115,23,0.09804);
  }

  .lg\\:focus\\:text-red-100:focus{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .lg\\:focus\\:text-red-150:focus{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .lg\\:focus\\:text-red-200:focus{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .lg\\:focus\\:text-red-300:focus{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .lg\\:focus\\:text-red-400:focus{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .lg\\:focus\\:text-red-500:focus{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .lg\\:focus\\:text-red-700:focus{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .lg\\:focus\\:text-gray-50:focus{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .lg\\:focus\\:text-gray-100:focus{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .lg\\:focus\\:text-gray-150:focus{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .lg\\:focus\\:text-gray-200:focus{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .lg\\:focus\\:text-gray-300:focus{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .lg\\:focus\\:text-gray-400:focus{
    color: rgba(114,114,114,0.8);
  }

  .lg\\:focus\\:text-gray-425:focus{
    color: rgba(4, 21, 39, 0.8);
  }

  .lg\\:focus\\:text-gray-450:focus{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .lg\\:focus\\:text-gray-500:focus{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .lg\\:focus\\:text-gray-600:focus{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .lg\\:focus\\:text-gray-625:focus{
    color: rgba(90,98,107,0.8);
  }

  .lg\\:focus\\:text-gray-700:focus{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .lg\\:focus\\:text-gray-800:focus{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .lg\\:focus\\:text-gray-200a50:focus{
    color: rgba(224, 226, 228, 0.5);
  }

  .lg\\:focus\\:text-blue-50:focus{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .lg\\:focus\\:text-blue-100:focus{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .lg\\:focus\\:text-blue-150:focus{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .lg\\:focus\\:text-blue-200:focus{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .lg\\:focus\\:text-blue-300:focus{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .lg\\:focus\\:text-blue-400:focus{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .lg\\:focus\\:text-blue-500:focus{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .lg\\:focus\\:text-blue-600:focus{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .lg\\:focus\\:text-blue-700:focus{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .lg\\:focus\\:text-blue-750:focus{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .lg\\:focus\\:text-blue-800:focus{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .lg\\:focus\\:text-blue-900:focus{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .lg\\:focus\\:text-blue-950:focus{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .lg\\:focus\\:text-blue-500a25:focus{
    color: rgba(55, 164, 220, 0.2);
  }

  .lg\\:focus\\:text-blue-500a50:focus{
    color: rgba(55, 164, 220, 0.5);
  }

  .lg\\:focus\\:text-blue-700a75:focus{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .lg\\:focus\\:text-blue-700a30:focus{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .lg\\:focus\\:text-blue-750a25:focus{
    color: rgba(86,130,170,0.09804);
  }

  .lg\\:focus\\:text-blue-750a15:focus{
    color: rgba(86,130,170,0.05882);
  }

  .lg\\:focus\\:text-blue-800a60:focus{
    color: rgba(31, 69, 102, 0.6);
  }

  .lg\\:focus\\:text-programEditorTabColors-1:focus{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .lg\\:focus\\:text-programEditorTabColors-2:focus{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .lg\\:focus\\:text-programEditorTabColors-3:focus{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .lg\\:focus\\:text-programEditorTabColors-4:focus{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .lg\\:focus\\:text-programEditorTabColors-5:focus{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .lg\\:focus\\:text-programEditorTabColors-6:focus{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .lg\\:focus\\:text-programEditorTabColors-1h:focus{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .lg\\:focus\\:text-programEditorTabColors-2h:focus{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .lg\\:focus\\:text-programEditorTabColors-3h:focus{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .lg\\:focus\\:text-programEditorTabColors-4h:focus{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .lg\\:focus\\:text-programEditorTabColors-5h:focus{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .lg\\:focus\\:text-programEditorTabColors-6h:focus{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .lg\\:focus\\:text-programEditorPresetTabColors-1:focus{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .lg\\:focus\\:text-programEditorPresetTabColors-1h:focus{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .lg\\:focus\\:text-borgScaleColors-0:focus{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .lg\\:focus\\:text-borgScaleColors-1:focus{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .lg\\:focus\\:text-borgScaleColors-2:focus{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .lg\\:focus\\:text-borgScaleColors-3:focus{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .lg\\:focus\\:text-borgScaleColors-4:focus{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .lg\\:focus\\:text-borgScaleColors-5:focus{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .lg\\:focus\\:text-borgScaleColors-6:focus{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .lg\\:focus\\:text-borgScaleColors-7:focus{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .lg\\:focus\\:text-borgScaleColors-8:focus{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .lg\\:focus\\:text-borgScaleColors-9:focus{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .lg\\:focus\\:text-borgScaleColors-10:focus{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .lg\\:text-opacity-0{
    --text-opacity: 0;
  }

  .lg\\:text-opacity-25{
    --text-opacity: .25;
  }

  .lg\\:text-opacity-50{
    --text-opacity: .5;
  }

  .lg\\:text-opacity-75{
    --text-opacity: .75;
  }

  .lg\\:text-opacity-100{
    --text-opacity: 1;
  }

  .lg\\:hover\\:text-opacity-0:hover{
    --text-opacity: 0;
  }

  .lg\\:hover\\:text-opacity-25:hover{
    --text-opacity: .25;
  }

  .lg\\:hover\\:text-opacity-50:hover{
    --text-opacity: .5;
  }

  .lg\\:hover\\:text-opacity-75:hover{
    --text-opacity: .75;
  }

  .lg\\:hover\\:text-opacity-100:hover{
    --text-opacity: 1;
  }

  .lg\\:focus\\:text-opacity-0:focus{
    --text-opacity: 0;
  }

  .lg\\:focus\\:text-opacity-25:focus{
    --text-opacity: .25;
  }

  .lg\\:focus\\:text-opacity-50:focus{
    --text-opacity: .5;
  }

  .lg\\:focus\\:text-opacity-75:focus{
    --text-opacity: .75;
  }

  .lg\\:focus\\:text-opacity-100:focus{
    --text-opacity: 1;
  }

  .lg\\:italic{
    font-style: italic;
  }

  .lg\\:not-italic{
    font-style: normal;
  }

  .lg\\:uppercase{
    text-transform: uppercase;
  }

  .lg\\:lowercase{
    text-transform: lowercase;
  }

  .lg\\:capitalize{
    text-transform: capitalize;
  }

  .lg\\:normal-case{
    text-transform: none;
  }

  .lg\\:underline{
    text-decoration: underline;
  }

  .lg\\:line-through{
    text-decoration: line-through;
  }

  .lg\\:no-underline{
    text-decoration: none;
  }

  .lg\\:hover\\:underline:hover{
    text-decoration: underline;
  }

  .lg\\:hover\\:line-through:hover{
    text-decoration: line-through;
  }

  .lg\\:hover\\:no-underline:hover{
    text-decoration: none;
  }

  .lg\\:focus\\:underline:focus{
    text-decoration: underline;
  }

  .lg\\:focus\\:line-through:focus{
    text-decoration: line-through;
  }

  .lg\\:focus\\:no-underline:focus{
    text-decoration: none;
  }

  .lg\\:antialiased{
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .lg\\:subpixel-antialiased{
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }

  .lg\\:ordinal, .lg\\:slashed-zero, .lg\\:lining-nums, .lg\\:oldstyle-nums, .lg\\:proportional-nums, .lg\\:tabular-nums, .lg\\:diagonal-fractions, .lg\\:stacked-fractions{
    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);
    font-feature-settings: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
  }

  .lg\\:normal-nums{
    font-feature-settings: normal;
    font-variant-numeric: normal;
  }

  .lg\\:ordinal{
    --font-variant-numeric-ordinal: ordinal;
  }

  .lg\\:slashed-zero{
    --font-variant-numeric-slashed-zero: slashed-zero;
  }

  .lg\\:lining-nums{
    --font-variant-numeric-figure: lining-nums;
  }

  .lg\\:oldstyle-nums{
    --font-variant-numeric-figure: oldstyle-nums;
  }

  .lg\\:proportional-nums{
    --font-variant-numeric-spacing: proportional-nums;
  }

  .lg\\:tabular-nums{
    --font-variant-numeric-spacing: tabular-nums;
  }

  .lg\\:diagonal-fractions{
    --font-variant-numeric-fraction: diagonal-fractions;
  }

  .lg\\:stacked-fractions{
    --font-variant-numeric-fraction: stacked-fractions;
  }

  .lg\\:tracking-tight{
    letter-spacing: -0.025em;
  }

  .lg\\:tracking-normal{
    letter-spacing: 0;
  }

  .lg\\:tracking-wide{
    letter-spacing: 0.01em;
  }

  .lg\\:tracking-wider{
    letter-spacing: 0.02em;
  }

  .lg\\:tracking-widest{
    letter-spacing: 0.05em;
  }

  .lg\\:select-none{
    -webkit-user-select: none;
            user-select: none;
  }

  .lg\\:select-text{
    -webkit-user-select: text;
            user-select: text;
  }

  .lg\\:select-all{
    -webkit-user-select: all;
            user-select: all;
  }

  .lg\\:select-auto{
    -webkit-user-select: auto;
            user-select: auto;
  }

  .lg\\:align-baseline{
    vertical-align: baseline;
  }

  .lg\\:align-top{
    vertical-align: top;
  }

  .lg\\:align-middle{
    vertical-align: middle;
  }

  .lg\\:align-bottom{
    vertical-align: bottom;
  }

  .lg\\:align-text-top{
    vertical-align: text-top;
  }

  .lg\\:align-text-bottom{
    vertical-align: text-bottom;
  }

  .lg\\:visible{
    visibility: visible;
  }

  .lg\\:invisible{
    visibility: hidden;
  }

  .lg\\:whitespace-normal{
    white-space: normal;
  }

  .lg\\:whitespace-no-wrap{
    white-space: nowrap;
  }

  .lg\\:whitespace-pre{
    white-space: pre;
  }

  .lg\\:whitespace-pre-line{
    white-space: pre-line;
  }

  .lg\\:whitespace-pre-wrap{
    white-space: pre-wrap;
  }

  .lg\\:break-normal{
    word-wrap: normal;
    word-wrap: normal;
    word-break: normal;
  }

  .lg\\:break-words{
    word-wrap: break-word;
    word-wrap: break-word;
  }

  .lg\\:break-all{
    word-break: break-all;
  }

  .lg\\:truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .lg\\:w-0{
    width: 0;
  }

  .lg\\:w-1{
    width: 0.25rem;
  }

  .lg\\:w-2{
    width: 0.5rem;
  }

  .lg\\:w-3{
    width: 0.75rem;
  }

  .lg\\:w-4{
    width: 1rem;
  }

  .lg\\:w-5{
    width: 1.25rem;
  }

  .lg\\:w-6{
    width: 1.5rem;
  }

  .lg\\:w-7{
    width: 1.75rem;
  }

  .lg\\:w-8{
    width: 2rem;
  }

  .lg\\:w-9{
    width: 2.25rem;
  }

  .lg\\:w-10{
    width: 2.5rem;
  }

  .lg\\:w-11{
    width: 2.75rem;
  }

  .lg\\:w-12{
    width: 3rem;
  }

  .lg\\:w-14{
    width: 3.5rem;
  }

  .lg\\:w-15{
    width: 3.75rem;
  }

  .lg\\:w-16{
    width: 4rem;
  }

  .lg\\:w-18{
    width: 4.5rem;
  }

  .lg\\:w-20{
    width: 5rem;
  }

  .lg\\:w-22{
    width: 5.5rem;
  }

  .lg\\:w-23{
    width: 5.75rem;
  }

  .lg\\:w-24{
    width: 6rem;
  }

  .lg\\:w-25{
    width: 6.25rem;
  }

  .lg\\:w-26{
    width: 6.5rem;
  }

  .lg\\:w-28{
    width: 7rem;
  }

  .lg\\:w-30{
    width: 7.5rem;
  }

  .lg\\:w-32{
    width: 8rem;
  }

  .lg\\:w-34{
    width: 8.5rem;
  }

  .lg\\:w-40{
    width: 10rem;
  }

  .lg\\:w-42{
    width: 10.5rem;
  }

  .lg\\:w-44{
    width: 11rem;
  }

  .lg\\:w-48{
    width: 12rem;
  }

  .lg\\:w-52{
    width: 13rem;
  }

  .lg\\:w-54{
    width: 13.5rem;
  }

  .lg\\:w-56{
    width: 14rem;
  }

  .lg\\:w-60{
    width: 15rem;
  }

  .lg\\:w-64{
    width: 16rem;
  }

  .lg\\:w-68{
    width: 17rem;
  }

  .lg\\:w-72{
    width: 18rem;
  }

  .lg\\:w-74{
    width: 18.5rem;
  }

  .lg\\:w-76{
    width: 19rem;
  }

  .lg\\:w-78{
    width: 19.5rem;
  }

  .lg\\:w-80{
    width: 20rem;
  }

  .lg\\:w-82{
    width: 20.5rem;
  }

  .lg\\:w-84{
    width: 21rem;
  }

  .lg\\:w-88{
    width: 22rem;
  }

  .lg\\:w-92{
    width: 23rem;
  }

  .lg\\:w-96{
    width: 24rem;
  }

  .lg\\:w-98{
    width: 24.5rem;
  }

  .lg\\:w-100{
    width: 25rem;
  }

  .lg\\:w-104{
    width: 26rem;
  }

  .lg\\:w-112{
    width: 28rem;
  }

  .lg\\:w-124{
    width: 31rem;
  }

  .lg\\:w-128{
    width: 32rem;
  }

  .lg\\:w-140{
    width: 35rem;
  }

  .lg\\:w-152{
    width: 38rem;
  }

  .lg\\:w-160{
    width: 40rem;
  }

  .lg\\:w-162{
    width: 41rem;
  }

  .lg\\:w-192{
    width: 48rem;
  }

  .lg\\:w-208{
    width: 52rem;
  }

  .lg\\:w-224{
    width: 56rem;
  }

  .lg\\:w-256{
    width: 64rem;
  }

  .lg\\:w-auto{
    width: auto;
  }

  .lg\\:w-px{
    width: 1px;
  }

  .lg\\:w-1\\/2{
    width: 50%;
  }

  .lg\\:w-1\\/3{
    width: 33.33333%;
  }

  .lg\\:w-2\\/3{
    width: 66.66667%;
  }

  .lg\\:w-1\\/4{
    width: 25%;
  }

  .lg\\:w-3\\/4{
    width: 75%;
  }

  .lg\\:w-1\\/5{
    width: 20%;
  }

  .lg\\:w-2\\/5{
    width: 40%;
  }

  .lg\\:w-3\\/5{
    width: 60%;
  }

  .lg\\:w-4\\/5{
    width: 80%;
  }

  .lg\\:w-1\\/6{
    width: 16.66667%;
  }

  .lg\\:w-5\\/6{
    width: 83.33333%;
  }

  .lg\\:w-1\\/7{
    width: 14.285714285%;
  }

  .lg\\:w-2\\/7{
    width: 28.571428571%;
  }

  .lg\\:w-3\\/7{
    width: 42.85714285%;
  }

  .lg\\:w-4\\/7{
    width: 57.14285714%;
  }

  .lg\\:w-1\\/9{
    width: 11.1111%;
  }

  .lg\\:w-9\\/10{
    width: 90%;
  }

  .lg\\:w-full{
    width: 100%;
  }

  .lg\\:w-screen{
    width: 100vw;
  }

  .lg\\:w-max{
    width: max-content;
  }

  .lg\\:z-0{
    z-index: 0;
  }

  .lg\\:z-10{
    z-index: 10;
  }

  .lg\\:z-20{
    z-index: 20;
  }

  .lg\\:z-30{
    z-index: 30;
  }

  .lg\\:z-40{
    z-index: 40;
  }

  .lg\\:z-50{
    z-index: 50;
  }

  .lg\\:z-auto{
    z-index: auto;
  }

  .lg\\:gap-0{
    grid-gap: 0;
    gap: 0;
  }

  .lg\\:gap-1{
    grid-gap: 0.25rem;
    gap: 0.25rem;
  }

  .lg\\:gap-2{
    grid-gap: 0.5rem;
    gap: 0.5rem;
  }

  .lg\\:gap-3{
    grid-gap: 0.75rem;
    gap: 0.75rem;
  }

  .lg\\:gap-4{
    grid-gap: 1rem;
    gap: 1rem;
  }

  .lg\\:gap-5{
    grid-gap: 1.25rem;
    gap: 1.25rem;
  }

  .lg\\:gap-6{
    grid-gap: 1.5rem;
    gap: 1.5rem;
  }

  .lg\\:gap-7{
    grid-gap: 1.75rem;
    gap: 1.75rem;
  }

  .lg\\:gap-8{
    grid-gap: 2rem;
    gap: 2rem;
  }

  .lg\\:gap-9{
    grid-gap: 2.25rem;
    gap: 2.25rem;
  }

  .lg\\:gap-10{
    grid-gap: 2.5rem;
    gap: 2.5rem;
  }

  .lg\\:gap-11{
    grid-gap: 2.75rem;
    gap: 2.75rem;
  }

  .lg\\:gap-12{
    grid-gap: 3rem;
    gap: 3rem;
  }

  .lg\\:gap-14{
    grid-gap: 3.5rem;
    gap: 3.5rem;
  }

  .lg\\:gap-15{
    grid-gap: 3.75rem;
    gap: 3.75rem;
  }

  .lg\\:gap-16{
    grid-gap: 4rem;
    gap: 4rem;
  }

  .lg\\:gap-18{
    grid-gap: 4.5rem;
    gap: 4.5rem;
  }

  .lg\\:gap-20{
    grid-gap: 5rem;
    gap: 5rem;
  }

  .lg\\:gap-22{
    grid-gap: 5.5rem;
    gap: 5.5rem;
  }

  .lg\\:gap-23{
    grid-gap: 5.75rem;
    gap: 5.75rem;
  }

  .lg\\:gap-24{
    grid-gap: 6rem;
    gap: 6rem;
  }

  .lg\\:gap-25{
    grid-gap: 6.25rem;
    gap: 6.25rem;
  }

  .lg\\:gap-26{
    grid-gap: 6.5rem;
    gap: 6.5rem;
  }

  .lg\\:gap-28{
    grid-gap: 7rem;
    gap: 7rem;
  }

  .lg\\:gap-30{
    grid-gap: 7.5rem;
    gap: 7.5rem;
  }

  .lg\\:gap-32{
    grid-gap: 8rem;
    gap: 8rem;
  }

  .lg\\:gap-34{
    grid-gap: 8.5rem;
    gap: 8.5rem;
  }

  .lg\\:gap-40{
    grid-gap: 10rem;
    gap: 10rem;
  }

  .lg\\:gap-42{
    grid-gap: 10.5rem;
    gap: 10.5rem;
  }

  .lg\\:gap-44{
    grid-gap: 11rem;
    gap: 11rem;
  }

  .lg\\:gap-48{
    grid-gap: 12rem;
    gap: 12rem;
  }

  .lg\\:gap-52{
    grid-gap: 13rem;
    gap: 13rem;
  }

  .lg\\:gap-54{
    grid-gap: 13.5rem;
    gap: 13.5rem;
  }

  .lg\\:gap-56{
    grid-gap: 14rem;
    gap: 14rem;
  }

  .lg\\:gap-60{
    grid-gap: 15rem;
    gap: 15rem;
  }

  .lg\\:gap-64{
    grid-gap: 16rem;
    gap: 16rem;
  }

  .lg\\:gap-68{
    grid-gap: 17rem;
    gap: 17rem;
  }

  .lg\\:gap-72{
    grid-gap: 18rem;
    gap: 18rem;
  }

  .lg\\:gap-74{
    grid-gap: 18.5rem;
    gap: 18.5rem;
  }

  .lg\\:gap-76{
    grid-gap: 19rem;
    gap: 19rem;
  }

  .lg\\:gap-78{
    grid-gap: 19.5rem;
    gap: 19.5rem;
  }

  .lg\\:gap-80{
    grid-gap: 20rem;
    gap: 20rem;
  }

  .lg\\:gap-82{
    grid-gap: 20.5rem;
    gap: 20.5rem;
  }

  .lg\\:gap-84{
    grid-gap: 21rem;
    gap: 21rem;
  }

  .lg\\:gap-88{
    grid-gap: 22rem;
    gap: 22rem;
  }

  .lg\\:gap-92{
    grid-gap: 23rem;
    gap: 23rem;
  }

  .lg\\:gap-96{
    grid-gap: 24rem;
    gap: 24rem;
  }

  .lg\\:gap-98{
    grid-gap: 24.5rem;
    gap: 24.5rem;
  }

  .lg\\:gap-100{
    grid-gap: 25rem;
    gap: 25rem;
  }

  .lg\\:gap-104{
    grid-gap: 26rem;
    gap: 26rem;
  }

  .lg\\:gap-112{
    grid-gap: 28rem;
    gap: 28rem;
  }

  .lg\\:gap-124{
    grid-gap: 31rem;
    gap: 31rem;
  }

  .lg\\:gap-128{
    grid-gap: 32rem;
    gap: 32rem;
  }

  .lg\\:gap-140{
    grid-gap: 35rem;
    gap: 35rem;
  }

  .lg\\:gap-152{
    grid-gap: 38rem;
    gap: 38rem;
  }

  .lg\\:gap-160{
    grid-gap: 40rem;
    gap: 40rem;
  }

  .lg\\:gap-162{
    grid-gap: 41rem;
    gap: 41rem;
  }

  .lg\\:gap-192{
    grid-gap: 48rem;
    gap: 48rem;
  }

  .lg\\:gap-208{
    grid-gap: 52rem;
    gap: 52rem;
  }

  .lg\\:gap-224{
    grid-gap: 56rem;
    gap: 56rem;
  }

  .lg\\:gap-256{
    grid-gap: 64rem;
    gap: 64rem;
  }

  .lg\\:gap-px{
    grid-gap: 1px;
    gap: 1px;
  }

  .lg\\:gap-x-0{
    grid-column-gap: 0;
    -moz-column-gap: 0;
         column-gap: 0;
  }

  .lg\\:gap-x-1{
    grid-column-gap: 0.25rem;
    -moz-column-gap: 0.25rem;
         column-gap: 0.25rem;
  }

  .lg\\:gap-x-2{
    grid-column-gap: 0.5rem;
    -moz-column-gap: 0.5rem;
         column-gap: 0.5rem;
  }

  .lg\\:gap-x-3{
    grid-column-gap: 0.75rem;
    -moz-column-gap: 0.75rem;
         column-gap: 0.75rem;
  }

  .lg\\:gap-x-4{
    grid-column-gap: 1rem;
    -moz-column-gap: 1rem;
         column-gap: 1rem;
  }

  .lg\\:gap-x-5{
    grid-column-gap: 1.25rem;
    -moz-column-gap: 1.25rem;
         column-gap: 1.25rem;
  }

  .lg\\:gap-x-6{
    grid-column-gap: 1.5rem;
    -moz-column-gap: 1.5rem;
         column-gap: 1.5rem;
  }

  .lg\\:gap-x-7{
    grid-column-gap: 1.75rem;
    -moz-column-gap: 1.75rem;
         column-gap: 1.75rem;
  }

  .lg\\:gap-x-8{
    grid-column-gap: 2rem;
    -moz-column-gap: 2rem;
         column-gap: 2rem;
  }

  .lg\\:gap-x-9{
    grid-column-gap: 2.25rem;
    -moz-column-gap: 2.25rem;
         column-gap: 2.25rem;
  }

  .lg\\:gap-x-10{
    grid-column-gap: 2.5rem;
    -moz-column-gap: 2.5rem;
         column-gap: 2.5rem;
  }

  .lg\\:gap-x-11{
    grid-column-gap: 2.75rem;
    -moz-column-gap: 2.75rem;
         column-gap: 2.75rem;
  }

  .lg\\:gap-x-12{
    grid-column-gap: 3rem;
    -moz-column-gap: 3rem;
         column-gap: 3rem;
  }

  .lg\\:gap-x-14{
    grid-column-gap: 3.5rem;
    -moz-column-gap: 3.5rem;
         column-gap: 3.5rem;
  }

  .lg\\:gap-x-15{
    grid-column-gap: 3.75rem;
    -moz-column-gap: 3.75rem;
         column-gap: 3.75rem;
  }

  .lg\\:gap-x-16{
    grid-column-gap: 4rem;
    -moz-column-gap: 4rem;
         column-gap: 4rem;
  }

  .lg\\:gap-x-18{
    grid-column-gap: 4.5rem;
    -moz-column-gap: 4.5rem;
         column-gap: 4.5rem;
  }

  .lg\\:gap-x-20{
    grid-column-gap: 5rem;
    -moz-column-gap: 5rem;
         column-gap: 5rem;
  }

  .lg\\:gap-x-22{
    grid-column-gap: 5.5rem;
    -moz-column-gap: 5.5rem;
         column-gap: 5.5rem;
  }

  .lg\\:gap-x-23{
    grid-column-gap: 5.75rem;
    -moz-column-gap: 5.75rem;
         column-gap: 5.75rem;
  }

  .lg\\:gap-x-24{
    grid-column-gap: 6rem;
    -moz-column-gap: 6rem;
         column-gap: 6rem;
  }

  .lg\\:gap-x-25{
    grid-column-gap: 6.25rem;
    -moz-column-gap: 6.25rem;
         column-gap: 6.25rem;
  }

  .lg\\:gap-x-26{
    grid-column-gap: 6.5rem;
    -moz-column-gap: 6.5rem;
         column-gap: 6.5rem;
  }

  .lg\\:gap-x-28{
    grid-column-gap: 7rem;
    -moz-column-gap: 7rem;
         column-gap: 7rem;
  }

  .lg\\:gap-x-30{
    grid-column-gap: 7.5rem;
    -moz-column-gap: 7.5rem;
         column-gap: 7.5rem;
  }

  .lg\\:gap-x-32{
    grid-column-gap: 8rem;
    -moz-column-gap: 8rem;
         column-gap: 8rem;
  }

  .lg\\:gap-x-34{
    grid-column-gap: 8.5rem;
    -moz-column-gap: 8.5rem;
         column-gap: 8.5rem;
  }

  .lg\\:gap-x-40{
    grid-column-gap: 10rem;
    -moz-column-gap: 10rem;
         column-gap: 10rem;
  }

  .lg\\:gap-x-42{
    grid-column-gap: 10.5rem;
    -moz-column-gap: 10.5rem;
         column-gap: 10.5rem;
  }

  .lg\\:gap-x-44{
    grid-column-gap: 11rem;
    -moz-column-gap: 11rem;
         column-gap: 11rem;
  }

  .lg\\:gap-x-48{
    grid-column-gap: 12rem;
    -moz-column-gap: 12rem;
         column-gap: 12rem;
  }

  .lg\\:gap-x-52{
    grid-column-gap: 13rem;
    -moz-column-gap: 13rem;
         column-gap: 13rem;
  }

  .lg\\:gap-x-54{
    grid-column-gap: 13.5rem;
    -moz-column-gap: 13.5rem;
         column-gap: 13.5rem;
  }

  .lg\\:gap-x-56{
    grid-column-gap: 14rem;
    -moz-column-gap: 14rem;
         column-gap: 14rem;
  }

  .lg\\:gap-x-60{
    grid-column-gap: 15rem;
    -moz-column-gap: 15rem;
         column-gap: 15rem;
  }

  .lg\\:gap-x-64{
    grid-column-gap: 16rem;
    -moz-column-gap: 16rem;
         column-gap: 16rem;
  }

  .lg\\:gap-x-68{
    grid-column-gap: 17rem;
    -moz-column-gap: 17rem;
         column-gap: 17rem;
  }

  .lg\\:gap-x-72{
    grid-column-gap: 18rem;
    -moz-column-gap: 18rem;
         column-gap: 18rem;
  }

  .lg\\:gap-x-74{
    grid-column-gap: 18.5rem;
    -moz-column-gap: 18.5rem;
         column-gap: 18.5rem;
  }

  .lg\\:gap-x-76{
    grid-column-gap: 19rem;
    -moz-column-gap: 19rem;
         column-gap: 19rem;
  }

  .lg\\:gap-x-78{
    grid-column-gap: 19.5rem;
    -moz-column-gap: 19.5rem;
         column-gap: 19.5rem;
  }

  .lg\\:gap-x-80{
    grid-column-gap: 20rem;
    -moz-column-gap: 20rem;
         column-gap: 20rem;
  }

  .lg\\:gap-x-82{
    grid-column-gap: 20.5rem;
    -moz-column-gap: 20.5rem;
         column-gap: 20.5rem;
  }

  .lg\\:gap-x-84{
    grid-column-gap: 21rem;
    -moz-column-gap: 21rem;
         column-gap: 21rem;
  }

  .lg\\:gap-x-88{
    grid-column-gap: 22rem;
    -moz-column-gap: 22rem;
         column-gap: 22rem;
  }

  .lg\\:gap-x-92{
    grid-column-gap: 23rem;
    -moz-column-gap: 23rem;
         column-gap: 23rem;
  }

  .lg\\:gap-x-96{
    grid-column-gap: 24rem;
    -moz-column-gap: 24rem;
         column-gap: 24rem;
  }

  .lg\\:gap-x-98{
    grid-column-gap: 24.5rem;
    -moz-column-gap: 24.5rem;
         column-gap: 24.5rem;
  }

  .lg\\:gap-x-100{
    grid-column-gap: 25rem;
    -moz-column-gap: 25rem;
         column-gap: 25rem;
  }

  .lg\\:gap-x-104{
    grid-column-gap: 26rem;
    -moz-column-gap: 26rem;
         column-gap: 26rem;
  }

  .lg\\:gap-x-112{
    grid-column-gap: 28rem;
    -moz-column-gap: 28rem;
         column-gap: 28rem;
  }

  .lg\\:gap-x-124{
    grid-column-gap: 31rem;
    -moz-column-gap: 31rem;
         column-gap: 31rem;
  }

  .lg\\:gap-x-128{
    grid-column-gap: 32rem;
    -moz-column-gap: 32rem;
         column-gap: 32rem;
  }

  .lg\\:gap-x-140{
    grid-column-gap: 35rem;
    -moz-column-gap: 35rem;
         column-gap: 35rem;
  }

  .lg\\:gap-x-152{
    grid-column-gap: 38rem;
    -moz-column-gap: 38rem;
         column-gap: 38rem;
  }

  .lg\\:gap-x-160{
    grid-column-gap: 40rem;
    -moz-column-gap: 40rem;
         column-gap: 40rem;
  }

  .lg\\:gap-x-162{
    grid-column-gap: 41rem;
    -moz-column-gap: 41rem;
         column-gap: 41rem;
  }

  .lg\\:gap-x-192{
    grid-column-gap: 48rem;
    -moz-column-gap: 48rem;
         column-gap: 48rem;
  }

  .lg\\:gap-x-208{
    grid-column-gap: 52rem;
    -moz-column-gap: 52rem;
         column-gap: 52rem;
  }

  .lg\\:gap-x-224{
    grid-column-gap: 56rem;
    -moz-column-gap: 56rem;
         column-gap: 56rem;
  }

  .lg\\:gap-x-256{
    grid-column-gap: 64rem;
    -moz-column-gap: 64rem;
         column-gap: 64rem;
  }

  .lg\\:gap-x-px{
    grid-column-gap: 1px;
    -moz-column-gap: 1px;
         column-gap: 1px;
  }

  .lg\\:gap-y-0{
    grid-row-gap: 0;
    row-gap: 0;
  }

  .lg\\:gap-y-1{
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }

  .lg\\:gap-y-2{
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }

  .lg\\:gap-y-3{
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }

  .lg\\:gap-y-4{
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }

  .lg\\:gap-y-5{
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }

  .lg\\:gap-y-6{
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }

  .lg\\:gap-y-7{
    grid-row-gap: 1.75rem;
    row-gap: 1.75rem;
  }

  .lg\\:gap-y-8{
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }

  .lg\\:gap-y-9{
    grid-row-gap: 2.25rem;
    row-gap: 2.25rem;
  }

  .lg\\:gap-y-10{
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }

  .lg\\:gap-y-11{
    grid-row-gap: 2.75rem;
    row-gap: 2.75rem;
  }

  .lg\\:gap-y-12{
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }

  .lg\\:gap-y-14{
    grid-row-gap: 3.5rem;
    row-gap: 3.5rem;
  }

  .lg\\:gap-y-15{
    grid-row-gap: 3.75rem;
    row-gap: 3.75rem;
  }

  .lg\\:gap-y-16{
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }

  .lg\\:gap-y-18{
    grid-row-gap: 4.5rem;
    row-gap: 4.5rem;
  }

  .lg\\:gap-y-20{
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }

  .lg\\:gap-y-22{
    grid-row-gap: 5.5rem;
    row-gap: 5.5rem;
  }

  .lg\\:gap-y-23{
    grid-row-gap: 5.75rem;
    row-gap: 5.75rem;
  }

  .lg\\:gap-y-24{
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }

  .lg\\:gap-y-25{
    grid-row-gap: 6.25rem;
    row-gap: 6.25rem;
  }

  .lg\\:gap-y-26{
    grid-row-gap: 6.5rem;
    row-gap: 6.5rem;
  }

  .lg\\:gap-y-28{
    grid-row-gap: 7rem;
    row-gap: 7rem;
  }

  .lg\\:gap-y-30{
    grid-row-gap: 7.5rem;
    row-gap: 7.5rem;
  }

  .lg\\:gap-y-32{
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }

  .lg\\:gap-y-34{
    grid-row-gap: 8.5rem;
    row-gap: 8.5rem;
  }

  .lg\\:gap-y-40{
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }

  .lg\\:gap-y-42{
    grid-row-gap: 10.5rem;
    row-gap: 10.5rem;
  }

  .lg\\:gap-y-44{
    grid-row-gap: 11rem;
    row-gap: 11rem;
  }

  .lg\\:gap-y-48{
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }

  .lg\\:gap-y-52{
    grid-row-gap: 13rem;
    row-gap: 13rem;
  }

  .lg\\:gap-y-54{
    grid-row-gap: 13.5rem;
    row-gap: 13.5rem;
  }

  .lg\\:gap-y-56{
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }

  .lg\\:gap-y-60{
    grid-row-gap: 15rem;
    row-gap: 15rem;
  }

  .lg\\:gap-y-64{
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }

  .lg\\:gap-y-68{
    grid-row-gap: 17rem;
    row-gap: 17rem;
  }

  .lg\\:gap-y-72{
    grid-row-gap: 18rem;
    row-gap: 18rem;
  }

  .lg\\:gap-y-74{
    grid-row-gap: 18.5rem;
    row-gap: 18.5rem;
  }

  .lg\\:gap-y-76{
    grid-row-gap: 19rem;
    row-gap: 19rem;
  }

  .lg\\:gap-y-78{
    grid-row-gap: 19.5rem;
    row-gap: 19.5rem;
  }

  .lg\\:gap-y-80{
    grid-row-gap: 20rem;
    row-gap: 20rem;
  }

  .lg\\:gap-y-82{
    grid-row-gap: 20.5rem;
    row-gap: 20.5rem;
  }

  .lg\\:gap-y-84{
    grid-row-gap: 21rem;
    row-gap: 21rem;
  }

  .lg\\:gap-y-88{
    grid-row-gap: 22rem;
    row-gap: 22rem;
  }

  .lg\\:gap-y-92{
    grid-row-gap: 23rem;
    row-gap: 23rem;
  }

  .lg\\:gap-y-96{
    grid-row-gap: 24rem;
    row-gap: 24rem;
  }

  .lg\\:gap-y-98{
    grid-row-gap: 24.5rem;
    row-gap: 24.5rem;
  }

  .lg\\:gap-y-100{
    grid-row-gap: 25rem;
    row-gap: 25rem;
  }

  .lg\\:gap-y-104{
    grid-row-gap: 26rem;
    row-gap: 26rem;
  }

  .lg\\:gap-y-112{
    grid-row-gap: 28rem;
    row-gap: 28rem;
  }

  .lg\\:gap-y-124{
    grid-row-gap: 31rem;
    row-gap: 31rem;
  }

  .lg\\:gap-y-128{
    grid-row-gap: 32rem;
    row-gap: 32rem;
  }

  .lg\\:gap-y-140{
    grid-row-gap: 35rem;
    row-gap: 35rem;
  }

  .lg\\:gap-y-152{
    grid-row-gap: 38rem;
    row-gap: 38rem;
  }

  .lg\\:gap-y-160{
    grid-row-gap: 40rem;
    row-gap: 40rem;
  }

  .lg\\:gap-y-162{
    grid-row-gap: 41rem;
    row-gap: 41rem;
  }

  .lg\\:gap-y-192{
    grid-row-gap: 48rem;
    row-gap: 48rem;
  }

  .lg\\:gap-y-208{
    grid-row-gap: 52rem;
    row-gap: 52rem;
  }

  .lg\\:gap-y-224{
    grid-row-gap: 56rem;
    row-gap: 56rem;
  }

  .lg\\:gap-y-256{
    grid-row-gap: 64rem;
    row-gap: 64rem;
  }

  .lg\\:gap-y-px{
    grid-row-gap: 1px;
    row-gap: 1px;
  }

  .lg\\:grid-flow-row{
    grid-auto-flow: row;
  }

  .lg\\:grid-flow-col{
    grid-auto-flow: column;
  }

  .lg\\:grid-flow-row-dense{
    grid-auto-flow: row dense;
  }

  .lg\\:grid-flow-col-dense{
    grid-auto-flow: column dense;
  }

  .lg\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .lg\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .lg\\:grid-cols-9{
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .lg\\:grid-cols-10{
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .lg\\:grid-cols-11{
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .lg\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-14{
    grid-template-columns: repeat(14, minmax(0, 1fr));
  }

  .lg\\:grid-cols-none{
    grid-template-columns: none;
  }

  .lg\\:auto-cols-auto{
    grid-auto-columns: auto;
  }

  .lg\\:auto-cols-min{
    grid-auto-columns: min-content;
  }

  .lg\\:auto-cols-max{
    grid-auto-columns: max-content;
  }

  .lg\\:auto-cols-fr{
    grid-auto-columns: minmax(0, 1fr);
  }

  .lg\\:col-auto{
    grid-column: auto;
  }

  .lg\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .lg\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .lg\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .lg\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-6{
    grid-column: span 6 / span 6;
  }

  .lg\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .lg\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .lg\\:col-span-9{
    grid-column: span 9 / span 9;
  }

  .lg\\:col-span-10{
    grid-column: span 10 / span 10;
  }

  .lg\\:col-span-11{
    grid-column: span 11 / span 11;
  }

  .lg\\:col-span-12{
    grid-column: span 12 / span 12;
  }

  .lg\\:col-span-full{
    grid-column: 1 / -1;
  }

  .lg\\:col-start-1{
    grid-column-start: 1;
  }

  .lg\\:col-start-2{
    grid-column-start: 2;
  }

  .lg\\:col-start-3{
    grid-column-start: 3;
  }

  .lg\\:col-start-4{
    grid-column-start: 4;
  }

  .lg\\:col-start-5{
    grid-column-start: 5;
  }

  .lg\\:col-start-6{
    grid-column-start: 6;
  }

  .lg\\:col-start-7{
    grid-column-start: 7;
  }

  .lg\\:col-start-8{
    grid-column-start: 8;
  }

  .lg\\:col-start-9{
    grid-column-start: 9;
  }

  .lg\\:col-start-10{
    grid-column-start: 10;
  }

  .lg\\:col-start-11{
    grid-column-start: 11;
  }

  .lg\\:col-start-12{
    grid-column-start: 12;
  }

  .lg\\:col-start-13{
    grid-column-start: 13;
  }

  .lg\\:col-start-14{
    grid-column-start: 14;
  }

  .lg\\:col-start-15{
    grid-column-start: 15;
  }

  .lg\\:col-start-auto{
    grid-column-start: auto;
  }

  .lg\\:col-end-1{
    grid-column-end: 1;
  }

  .lg\\:col-end-2{
    grid-column-end: 2;
  }

  .lg\\:col-end-3{
    grid-column-end: 3;
  }

  .lg\\:col-end-4{
    grid-column-end: 4;
  }

  .lg\\:col-end-5{
    grid-column-end: 5;
  }

  .lg\\:col-end-6{
    grid-column-end: 6;
  }

  .lg\\:col-end-7{
    grid-column-end: 7;
  }

  .lg\\:col-end-8{
    grid-column-end: 8;
  }

  .lg\\:col-end-9{
    grid-column-end: 9;
  }

  .lg\\:col-end-10{
    grid-column-end: 10;
  }

  .lg\\:col-end-11{
    grid-column-end: 11;
  }

  .lg\\:col-end-12{
    grid-column-end: 12;
  }

  .lg\\:col-end-13{
    grid-column-end: 13;
  }

  .lg\\:col-end-14{
    grid-column-end: 14;
  }

  .lg\\:col-end-15{
    grid-column-end: 15;
  }

  .lg\\:col-end-auto{
    grid-column-end: auto;
  }

  .lg\\:grid-rows-1{
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .lg\\:grid-rows-2{
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-rows-3{
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-rows-4{
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-rows-5{
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }

  .lg\\:grid-rows-6{
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }

  .lg\\:grid-rows-none{
    grid-template-rows: none;
  }

  .lg\\:auto-rows-auto{
    grid-auto-rows: auto;
  }

  .lg\\:auto-rows-min{
    grid-auto-rows: min-content;
  }

  .lg\\:auto-rows-max{
    grid-auto-rows: max-content;
  }

  .lg\\:auto-rows-fr{
    grid-auto-rows: minmax(0, 1fr);
  }

  .lg\\:row-auto{
    grid-row: auto;
  }

  .lg\\:row-span-1{
    grid-row: span 1 / span 1;
  }

  .lg\\:row-span-2{
    grid-row: span 2 / span 2;
  }

  .lg\\:row-span-3{
    grid-row: span 3 / span 3;
  }

  .lg\\:row-span-4{
    grid-row: span 4 / span 4;
  }

  .lg\\:row-span-5{
    grid-row: span 5 / span 5;
  }

  .lg\\:row-span-6{
    grid-row: span 6 / span 6;
  }

  .lg\\:row-span-full{
    grid-row: 1 / -1;
  }

  .lg\\:row-start-1{
    grid-row-start: 1;
  }

  .lg\\:row-start-2{
    grid-row-start: 2;
  }

  .lg\\:row-start-3{
    grid-row-start: 3;
  }

  .lg\\:row-start-4{
    grid-row-start: 4;
  }

  .lg\\:row-start-5{
    grid-row-start: 5;
  }

  .lg\\:row-start-6{
    grid-row-start: 6;
  }

  .lg\\:row-start-7{
    grid-row-start: 7;
  }

  .lg\\:row-start-auto{
    grid-row-start: auto;
  }

  .lg\\:row-end-1{
    grid-row-end: 1;
  }

  .lg\\:row-end-2{
    grid-row-end: 2;
  }

  .lg\\:row-end-3{
    grid-row-end: 3;
  }

  .lg\\:row-end-4{
    grid-row-end: 4;
  }

  .lg\\:row-end-5{
    grid-row-end: 5;
  }

  .lg\\:row-end-6{
    grid-row-end: 6;
  }

  .lg\\:row-end-7{
    grid-row-end: 7;
  }

  .lg\\:row-end-auto{
    grid-row-end: auto;
  }

  .lg\\:transform{
    --transform-translate-x: 0;
    --transform-translate-y: 0;
    --transform-rotate: 0;
    --transform-skew-x: 0;
    --transform-skew-y: 0;
    --transform-scale-x: 1;
    --transform-scale-y: 1;
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
  }

  .lg\\:transform-none{
    transform: none;
  }

  .lg\\:origin-center{
    transform-origin: center;
  }

  .lg\\:origin-top{
    transform-origin: top;
  }

  .lg\\:origin-top-right{
    transform-origin: top right;
  }

  .lg\\:origin-right{
    transform-origin: right;
  }

  .lg\\:origin-bottom-right{
    transform-origin: bottom right;
  }

  .lg\\:origin-bottom{
    transform-origin: bottom;
  }

  .lg\\:origin-bottom-left{
    transform-origin: bottom left;
  }

  .lg\\:origin-left{
    transform-origin: left;
  }

  .lg\\:origin-top-left{
    transform-origin: top left;
  }

  .lg\\:scale-0{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .lg\\:scale-50{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .lg\\:scale-75{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .lg\\:scale-90{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .lg\\:scale-95{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .lg\\:scale-100{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .lg\\:scale-105{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .lg\\:scale-110{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .lg\\:scale-125{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .lg\\:scale-150{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .lg\\:scale-x-0{
    --transform-scale-x: 0;
  }

  .lg\\:scale-x-50{
    --transform-scale-x: .5;
  }

  .lg\\:scale-x-75{
    --transform-scale-x: .75;
  }

  .lg\\:scale-x-90{
    --transform-scale-x: .9;
  }

  .lg\\:scale-x-95{
    --transform-scale-x: .95;
  }

  .lg\\:scale-x-100{
    --transform-scale-x: 1;
  }

  .lg\\:scale-x-105{
    --transform-scale-x: 1.05;
  }

  .lg\\:scale-x-110{
    --transform-scale-x: 1.1;
  }

  .lg\\:scale-x-125{
    --transform-scale-x: 1.25;
  }

  .lg\\:scale-x-150{
    --transform-scale-x: 1.5;
  }

  .lg\\:scale-y-0{
    --transform-scale-y: 0;
  }

  .lg\\:scale-y-50{
    --transform-scale-y: .5;
  }

  .lg\\:scale-y-75{
    --transform-scale-y: .75;
  }

  .lg\\:scale-y-90{
    --transform-scale-y: .9;
  }

  .lg\\:scale-y-95{
    --transform-scale-y: .95;
  }

  .lg\\:scale-y-100{
    --transform-scale-y: 1;
  }

  .lg\\:scale-y-105{
    --transform-scale-y: 1.05;
  }

  .lg\\:scale-y-110{
    --transform-scale-y: 1.1;
  }

  .lg\\:scale-y-125{
    --transform-scale-y: 1.25;
  }

  .lg\\:scale-y-150{
    --transform-scale-y: 1.5;
  }

  .lg\\:hover\\:scale-0:hover{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .lg\\:hover\\:scale-50:hover{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .lg\\:hover\\:scale-75:hover{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .lg\\:hover\\:scale-90:hover{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .lg\\:hover\\:scale-95:hover{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .lg\\:hover\\:scale-100:hover{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .lg\\:hover\\:scale-105:hover{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .lg\\:hover\\:scale-110:hover{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .lg\\:hover\\:scale-125:hover{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .lg\\:hover\\:scale-150:hover{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .lg\\:hover\\:scale-x-0:hover{
    --transform-scale-x: 0;
  }

  .lg\\:hover\\:scale-x-50:hover{
    --transform-scale-x: .5;
  }

  .lg\\:hover\\:scale-x-75:hover{
    --transform-scale-x: .75;
  }

  .lg\\:hover\\:scale-x-90:hover{
    --transform-scale-x: .9;
  }

  .lg\\:hover\\:scale-x-95:hover{
    --transform-scale-x: .95;
  }

  .lg\\:hover\\:scale-x-100:hover{
    --transform-scale-x: 1;
  }

  .lg\\:hover\\:scale-x-105:hover{
    --transform-scale-x: 1.05;
  }

  .lg\\:hover\\:scale-x-110:hover{
    --transform-scale-x: 1.1;
  }

  .lg\\:hover\\:scale-x-125:hover{
    --transform-scale-x: 1.25;
  }

  .lg\\:hover\\:scale-x-150:hover{
    --transform-scale-x: 1.5;
  }

  .lg\\:hover\\:scale-y-0:hover{
    --transform-scale-y: 0;
  }

  .lg\\:hover\\:scale-y-50:hover{
    --transform-scale-y: .5;
  }

  .lg\\:hover\\:scale-y-75:hover{
    --transform-scale-y: .75;
  }

  .lg\\:hover\\:scale-y-90:hover{
    --transform-scale-y: .9;
  }

  .lg\\:hover\\:scale-y-95:hover{
    --transform-scale-y: .95;
  }

  .lg\\:hover\\:scale-y-100:hover{
    --transform-scale-y: 1;
  }

  .lg\\:hover\\:scale-y-105:hover{
    --transform-scale-y: 1.05;
  }

  .lg\\:hover\\:scale-y-110:hover{
    --transform-scale-y: 1.1;
  }

  .lg\\:hover\\:scale-y-125:hover{
    --transform-scale-y: 1.25;
  }

  .lg\\:hover\\:scale-y-150:hover{
    --transform-scale-y: 1.5;
  }

  .lg\\:focus\\:scale-0:focus{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .lg\\:focus\\:scale-50:focus{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .lg\\:focus\\:scale-75:focus{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .lg\\:focus\\:scale-90:focus{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .lg\\:focus\\:scale-95:focus{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .lg\\:focus\\:scale-100:focus{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .lg\\:focus\\:scale-105:focus{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .lg\\:focus\\:scale-110:focus{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .lg\\:focus\\:scale-125:focus{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .lg\\:focus\\:scale-150:focus{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .lg\\:focus\\:scale-x-0:focus{
    --transform-scale-x: 0;
  }

  .lg\\:focus\\:scale-x-50:focus{
    --transform-scale-x: .5;
  }

  .lg\\:focus\\:scale-x-75:focus{
    --transform-scale-x: .75;
  }

  .lg\\:focus\\:scale-x-90:focus{
    --transform-scale-x: .9;
  }

  .lg\\:focus\\:scale-x-95:focus{
    --transform-scale-x: .95;
  }

  .lg\\:focus\\:scale-x-100:focus{
    --transform-scale-x: 1;
  }

  .lg\\:focus\\:scale-x-105:focus{
    --transform-scale-x: 1.05;
  }

  .lg\\:focus\\:scale-x-110:focus{
    --transform-scale-x: 1.1;
  }

  .lg\\:focus\\:scale-x-125:focus{
    --transform-scale-x: 1.25;
  }

  .lg\\:focus\\:scale-x-150:focus{
    --transform-scale-x: 1.5;
  }

  .lg\\:focus\\:scale-y-0:focus{
    --transform-scale-y: 0;
  }

  .lg\\:focus\\:scale-y-50:focus{
    --transform-scale-y: .5;
  }

  .lg\\:focus\\:scale-y-75:focus{
    --transform-scale-y: .75;
  }

  .lg\\:focus\\:scale-y-90:focus{
    --transform-scale-y: .9;
  }

  .lg\\:focus\\:scale-y-95:focus{
    --transform-scale-y: .95;
  }

  .lg\\:focus\\:scale-y-100:focus{
    --transform-scale-y: 1;
  }

  .lg\\:focus\\:scale-y-105:focus{
    --transform-scale-y: 1.05;
  }

  .lg\\:focus\\:scale-y-110:focus{
    --transform-scale-y: 1.1;
  }

  .lg\\:focus\\:scale-y-125:focus{
    --transform-scale-y: 1.25;
  }

  .lg\\:focus\\:scale-y-150:focus{
    --transform-scale-y: 1.5;
  }

  .lg\\:rotate-0{
    --transform-rotate: 0;
  }

  .lg\\:rotate-1{
    --transform-rotate: 1deg;
  }

  .lg\\:rotate-2{
    --transform-rotate: 2deg;
  }

  .lg\\:rotate-3{
    --transform-rotate: 3deg;
  }

  .lg\\:rotate-6{
    --transform-rotate: 6deg;
  }

  .lg\\:rotate-12{
    --transform-rotate: 12deg;
  }

  .lg\\:rotate-45{
    --transform-rotate: 45deg;
  }

  .lg\\:rotate-90{
    --transform-rotate: 90deg;
  }

  .lg\\:rotate-180{
    --transform-rotate: 180deg;
  }

  .lg\\:-rotate-180{
    --transform-rotate: -180deg;
  }

  .lg\\:-rotate-90{
    --transform-rotate: -90deg;
  }

  .lg\\:-rotate-45{
    --transform-rotate: -45deg;
  }

  .lg\\:-rotate-12{
    --transform-rotate: -12deg;
  }

  .lg\\:-rotate-6{
    --transform-rotate: -6deg;
  }

  .lg\\:-rotate-3{
    --transform-rotate: -3deg;
  }

  .lg\\:-rotate-2{
    --transform-rotate: -2deg;
  }

  .lg\\:-rotate-1{
    --transform-rotate: -1deg;
  }

  .lg\\:hover\\:rotate-0:hover{
    --transform-rotate: 0;
  }

  .lg\\:hover\\:rotate-1:hover{
    --transform-rotate: 1deg;
  }

  .lg\\:hover\\:rotate-2:hover{
    --transform-rotate: 2deg;
  }

  .lg\\:hover\\:rotate-3:hover{
    --transform-rotate: 3deg;
  }

  .lg\\:hover\\:rotate-6:hover{
    --transform-rotate: 6deg;
  }

  .lg\\:hover\\:rotate-12:hover{
    --transform-rotate: 12deg;
  }

  .lg\\:hover\\:rotate-45:hover{
    --transform-rotate: 45deg;
  }

  .lg\\:hover\\:rotate-90:hover{
    --transform-rotate: 90deg;
  }

  .lg\\:hover\\:rotate-180:hover{
    --transform-rotate: 180deg;
  }

  .lg\\:hover\\:-rotate-180:hover{
    --transform-rotate: -180deg;
  }

  .lg\\:hover\\:-rotate-90:hover{
    --transform-rotate: -90deg;
  }

  .lg\\:hover\\:-rotate-45:hover{
    --transform-rotate: -45deg;
  }

  .lg\\:hover\\:-rotate-12:hover{
    --transform-rotate: -12deg;
  }

  .lg\\:hover\\:-rotate-6:hover{
    --transform-rotate: -6deg;
  }

  .lg\\:hover\\:-rotate-3:hover{
    --transform-rotate: -3deg;
  }

  .lg\\:hover\\:-rotate-2:hover{
    --transform-rotate: -2deg;
  }

  .lg\\:hover\\:-rotate-1:hover{
    --transform-rotate: -1deg;
  }

  .lg\\:focus\\:rotate-0:focus{
    --transform-rotate: 0;
  }

  .lg\\:focus\\:rotate-1:focus{
    --transform-rotate: 1deg;
  }

  .lg\\:focus\\:rotate-2:focus{
    --transform-rotate: 2deg;
  }

  .lg\\:focus\\:rotate-3:focus{
    --transform-rotate: 3deg;
  }

  .lg\\:focus\\:rotate-6:focus{
    --transform-rotate: 6deg;
  }

  .lg\\:focus\\:rotate-12:focus{
    --transform-rotate: 12deg;
  }

  .lg\\:focus\\:rotate-45:focus{
    --transform-rotate: 45deg;
  }

  .lg\\:focus\\:rotate-90:focus{
    --transform-rotate: 90deg;
  }

  .lg\\:focus\\:rotate-180:focus{
    --transform-rotate: 180deg;
  }

  .lg\\:focus\\:-rotate-180:focus{
    --transform-rotate: -180deg;
  }

  .lg\\:focus\\:-rotate-90:focus{
    --transform-rotate: -90deg;
  }

  .lg\\:focus\\:-rotate-45:focus{
    --transform-rotate: -45deg;
  }

  .lg\\:focus\\:-rotate-12:focus{
    --transform-rotate: -12deg;
  }

  .lg\\:focus\\:-rotate-6:focus{
    --transform-rotate: -6deg;
  }

  .lg\\:focus\\:-rotate-3:focus{
    --transform-rotate: -3deg;
  }

  .lg\\:focus\\:-rotate-2:focus{
    --transform-rotate: -2deg;
  }

  .lg\\:focus\\:-rotate-1:focus{
    --transform-rotate: -1deg;
  }

  .lg\\:translate-x-0{
    --transform-translate-x: 0;
  }

  .lg\\:translate-x-1{
    --transform-translate-x: 0.25rem;
  }

  .lg\\:translate-x-2{
    --transform-translate-x: 0.5rem;
  }

  .lg\\:translate-x-3{
    --transform-translate-x: 0.75rem;
  }

  .lg\\:translate-x-4{
    --transform-translate-x: 1rem;
  }

  .lg\\:translate-x-5{
    --transform-translate-x: 1.25rem;
  }

  .lg\\:translate-x-6{
    --transform-translate-x: 1.5rem;
  }

  .lg\\:translate-x-7{
    --transform-translate-x: 1.75rem;
  }

  .lg\\:translate-x-8{
    --transform-translate-x: 2rem;
  }

  .lg\\:translate-x-9{
    --transform-translate-x: 2.25rem;
  }

  .lg\\:translate-x-10{
    --transform-translate-x: 2.5rem;
  }

  .lg\\:translate-x-11{
    --transform-translate-x: 2.75rem;
  }

  .lg\\:translate-x-12{
    --transform-translate-x: 3rem;
  }

  .lg\\:translate-x-14{
    --transform-translate-x: 3.5rem;
  }

  .lg\\:translate-x-15{
    --transform-translate-x: 3.75rem;
  }

  .lg\\:translate-x-16{
    --transform-translate-x: 4rem;
  }

  .lg\\:translate-x-18{
    --transform-translate-x: 4.5rem;
  }

  .lg\\:translate-x-20{
    --transform-translate-x: 5rem;
  }

  .lg\\:translate-x-22{
    --transform-translate-x: 5.5rem;
  }

  .lg\\:translate-x-23{
    --transform-translate-x: 5.75rem;
  }

  .lg\\:translate-x-24{
    --transform-translate-x: 6rem;
  }

  .lg\\:translate-x-25{
    --transform-translate-x: 6.25rem;
  }

  .lg\\:translate-x-26{
    --transform-translate-x: 6.5rem;
  }

  .lg\\:translate-x-28{
    --transform-translate-x: 7rem;
  }

  .lg\\:translate-x-30{
    --transform-translate-x: 7.5rem;
  }

  .lg\\:translate-x-32{
    --transform-translate-x: 8rem;
  }

  .lg\\:translate-x-34{
    --transform-translate-x: 8.5rem;
  }

  .lg\\:translate-x-40{
    --transform-translate-x: 10rem;
  }

  .lg\\:translate-x-42{
    --transform-translate-x: 10.5rem;
  }

  .lg\\:translate-x-44{
    --transform-translate-x: 11rem;
  }

  .lg\\:translate-x-48{
    --transform-translate-x: 12rem;
  }

  .lg\\:translate-x-52{
    --transform-translate-x: 13rem;
  }

  .lg\\:translate-x-54{
    --transform-translate-x: 13.5rem;
  }

  .lg\\:translate-x-56{
    --transform-translate-x: 14rem;
  }

  .lg\\:translate-x-60{
    --transform-translate-x: 15rem;
  }

  .lg\\:translate-x-64{
    --transform-translate-x: 16rem;
  }

  .lg\\:translate-x-68{
    --transform-translate-x: 17rem;
  }

  .lg\\:translate-x-72{
    --transform-translate-x: 18rem;
  }

  .lg\\:translate-x-74{
    --transform-translate-x: 18.5rem;
  }

  .lg\\:translate-x-76{
    --transform-translate-x: 19rem;
  }

  .lg\\:translate-x-78{
    --transform-translate-x: 19.5rem;
  }

  .lg\\:translate-x-80{
    --transform-translate-x: 20rem;
  }

  .lg\\:translate-x-82{
    --transform-translate-x: 20.5rem;
  }

  .lg\\:translate-x-84{
    --transform-translate-x: 21rem;
  }

  .lg\\:translate-x-88{
    --transform-translate-x: 22rem;
  }

  .lg\\:translate-x-92{
    --transform-translate-x: 23rem;
  }

  .lg\\:translate-x-96{
    --transform-translate-x: 24rem;
  }

  .lg\\:translate-x-98{
    --transform-translate-x: 24.5rem;
  }

  .lg\\:translate-x-100{
    --transform-translate-x: 25rem;
  }

  .lg\\:translate-x-104{
    --transform-translate-x: 26rem;
  }

  .lg\\:translate-x-112{
    --transform-translate-x: 28rem;
  }

  .lg\\:translate-x-124{
    --transform-translate-x: 31rem;
  }

  .lg\\:translate-x-128{
    --transform-translate-x: 32rem;
  }

  .lg\\:translate-x-140{
    --transform-translate-x: 35rem;
  }

  .lg\\:translate-x-152{
    --transform-translate-x: 38rem;
  }

  .lg\\:translate-x-160{
    --transform-translate-x: 40rem;
  }

  .lg\\:translate-x-162{
    --transform-translate-x: 41rem;
  }

  .lg\\:translate-x-192{
    --transform-translate-x: 48rem;
  }

  .lg\\:translate-x-208{
    --transform-translate-x: 52rem;
  }

  .lg\\:translate-x-224{
    --transform-translate-x: 56rem;
  }

  .lg\\:translate-x-256{
    --transform-translate-x: 64rem;
  }

  .lg\\:translate-x-px{
    --transform-translate-x: 1px;
  }

  .lg\\:-translate-x-1{
    --transform-translate-x: -0.25rem;
  }

  .lg\\:-translate-x-2{
    --transform-translate-x: -0.5rem;
  }

  .lg\\:-translate-x-3{
    --transform-translate-x: -0.75rem;
  }

  .lg\\:-translate-x-4{
    --transform-translate-x: -1rem;
  }

  .lg\\:-translate-x-5{
    --transform-translate-x: -1.25rem;
  }

  .lg\\:-translate-x-6{
    --transform-translate-x: -1.5rem;
  }

  .lg\\:-translate-x-7{
    --transform-translate-x: -1.75rem;
  }

  .lg\\:-translate-x-8{
    --transform-translate-x: -2rem;
  }

  .lg\\:-translate-x-9{
    --transform-translate-x: -2.25rem;
  }

  .lg\\:-translate-x-10{
    --transform-translate-x: -2.5rem;
  }

  .lg\\:-translate-x-11{
    --transform-translate-x: -2.75rem;
  }

  .lg\\:-translate-x-12{
    --transform-translate-x: -3rem;
  }

  .lg\\:-translate-x-14{
    --transform-translate-x: -3.5rem;
  }

  .lg\\:-translate-x-15{
    --transform-translate-x: -3.75rem;
  }

  .lg\\:-translate-x-16{
    --transform-translate-x: -4rem;
  }

  .lg\\:-translate-x-18{
    --transform-translate-x: -4.5rem;
  }

  .lg\\:-translate-x-20{
    --transform-translate-x: -5rem;
  }

  .lg\\:-translate-x-22{
    --transform-translate-x: -5.5rem;
  }

  .lg\\:-translate-x-23{
    --transform-translate-x: -5.75rem;
  }

  .lg\\:-translate-x-24{
    --transform-translate-x: -6rem;
  }

  .lg\\:-translate-x-25{
    --transform-translate-x: -6.25rem;
  }

  .lg\\:-translate-x-26{
    --transform-translate-x: -6.5rem;
  }

  .lg\\:-translate-x-28{
    --transform-translate-x: -7rem;
  }

  .lg\\:-translate-x-30{
    --transform-translate-x: -7.5rem;
  }

  .lg\\:-translate-x-32{
    --transform-translate-x: -8rem;
  }

  .lg\\:-translate-x-34{
    --transform-translate-x: -8.5rem;
  }

  .lg\\:-translate-x-40{
    --transform-translate-x: -10rem;
  }

  .lg\\:-translate-x-42{
    --transform-translate-x: -10.5rem;
  }

  .lg\\:-translate-x-44{
    --transform-translate-x: -11rem;
  }

  .lg\\:-translate-x-48{
    --transform-translate-x: -12rem;
  }

  .lg\\:-translate-x-52{
    --transform-translate-x: -13rem;
  }

  .lg\\:-translate-x-54{
    --transform-translate-x: -13.5rem;
  }

  .lg\\:-translate-x-56{
    --transform-translate-x: -14rem;
  }

  .lg\\:-translate-x-60{
    --transform-translate-x: -15rem;
  }

  .lg\\:-translate-x-64{
    --transform-translate-x: -16rem;
  }

  .lg\\:-translate-x-68{
    --transform-translate-x: -17rem;
  }

  .lg\\:-translate-x-72{
    --transform-translate-x: -18rem;
  }

  .lg\\:-translate-x-74{
    --transform-translate-x: -18.5rem;
  }

  .lg\\:-translate-x-76{
    --transform-translate-x: -19rem;
  }

  .lg\\:-translate-x-78{
    --transform-translate-x: -19.5rem;
  }

  .lg\\:-translate-x-80{
    --transform-translate-x: -20rem;
  }

  .lg\\:-translate-x-82{
    --transform-translate-x: -20.5rem;
  }

  .lg\\:-translate-x-84{
    --transform-translate-x: -21rem;
  }

  .lg\\:-translate-x-88{
    --transform-translate-x: -22rem;
  }

  .lg\\:-translate-x-92{
    --transform-translate-x: -23rem;
  }

  .lg\\:-translate-x-96{
    --transform-translate-x: -24rem;
  }

  .lg\\:-translate-x-98{
    --transform-translate-x: -24.5rem;
  }

  .lg\\:-translate-x-100{
    --transform-translate-x: -25rem;
  }

  .lg\\:-translate-x-104{
    --transform-translate-x: -26rem;
  }

  .lg\\:-translate-x-112{
    --transform-translate-x: -28rem;
  }

  .lg\\:-translate-x-124{
    --transform-translate-x: -31rem;
  }

  .lg\\:-translate-x-128{
    --transform-translate-x: -32rem;
  }

  .lg\\:-translate-x-140{
    --transform-translate-x: -35rem;
  }

  .lg\\:-translate-x-152{
    --transform-translate-x: -38rem;
  }

  .lg\\:-translate-x-160{
    --transform-translate-x: -40rem;
  }

  .lg\\:-translate-x-162{
    --transform-translate-x: -41rem;
  }

  .lg\\:-translate-x-192{
    --transform-translate-x: -48rem;
  }

  .lg\\:-translate-x-208{
    --transform-translate-x: -52rem;
  }

  .lg\\:-translate-x-224{
    --transform-translate-x: -56rem;
  }

  .lg\\:-translate-x-256{
    --transform-translate-x: -64rem;
  }

  .lg\\:-translate-x-px{
    --transform-translate-x: -1px;
  }

  .lg\\:-translate-x-full{
    --transform-translate-x: -100%;
  }

  .lg\\:-translate-x-1\\/2{
    --transform-translate-x: -50%;
  }

  .lg\\:translate-x-1\\/2{
    --transform-translate-x: 50%;
  }

  .lg\\:translate-x-full{
    --transform-translate-x: 100%;
  }

  .lg\\:translate-y-0{
    --transform-translate-y: 0;
  }

  .lg\\:translate-y-1{
    --transform-translate-y: 0.25rem;
  }

  .lg\\:translate-y-2{
    --transform-translate-y: 0.5rem;
  }

  .lg\\:translate-y-3{
    --transform-translate-y: 0.75rem;
  }

  .lg\\:translate-y-4{
    --transform-translate-y: 1rem;
  }

  .lg\\:translate-y-5{
    --transform-translate-y: 1.25rem;
  }

  .lg\\:translate-y-6{
    --transform-translate-y: 1.5rem;
  }

  .lg\\:translate-y-7{
    --transform-translate-y: 1.75rem;
  }

  .lg\\:translate-y-8{
    --transform-translate-y: 2rem;
  }

  .lg\\:translate-y-9{
    --transform-translate-y: 2.25rem;
  }

  .lg\\:translate-y-10{
    --transform-translate-y: 2.5rem;
  }

  .lg\\:translate-y-11{
    --transform-translate-y: 2.75rem;
  }

  .lg\\:translate-y-12{
    --transform-translate-y: 3rem;
  }

  .lg\\:translate-y-14{
    --transform-translate-y: 3.5rem;
  }

  .lg\\:translate-y-15{
    --transform-translate-y: 3.75rem;
  }

  .lg\\:translate-y-16{
    --transform-translate-y: 4rem;
  }

  .lg\\:translate-y-18{
    --transform-translate-y: 4.5rem;
  }

  .lg\\:translate-y-20{
    --transform-translate-y: 5rem;
  }

  .lg\\:translate-y-22{
    --transform-translate-y: 5.5rem;
  }

  .lg\\:translate-y-23{
    --transform-translate-y: 5.75rem;
  }

  .lg\\:translate-y-24{
    --transform-translate-y: 6rem;
  }

  .lg\\:translate-y-25{
    --transform-translate-y: 6.25rem;
  }

  .lg\\:translate-y-26{
    --transform-translate-y: 6.5rem;
  }

  .lg\\:translate-y-28{
    --transform-translate-y: 7rem;
  }

  .lg\\:translate-y-30{
    --transform-translate-y: 7.5rem;
  }

  .lg\\:translate-y-32{
    --transform-translate-y: 8rem;
  }

  .lg\\:translate-y-34{
    --transform-translate-y: 8.5rem;
  }

  .lg\\:translate-y-40{
    --transform-translate-y: 10rem;
  }

  .lg\\:translate-y-42{
    --transform-translate-y: 10.5rem;
  }

  .lg\\:translate-y-44{
    --transform-translate-y: 11rem;
  }

  .lg\\:translate-y-48{
    --transform-translate-y: 12rem;
  }

  .lg\\:translate-y-52{
    --transform-translate-y: 13rem;
  }

  .lg\\:translate-y-54{
    --transform-translate-y: 13.5rem;
  }

  .lg\\:translate-y-56{
    --transform-translate-y: 14rem;
  }

  .lg\\:translate-y-60{
    --transform-translate-y: 15rem;
  }

  .lg\\:translate-y-64{
    --transform-translate-y: 16rem;
  }

  .lg\\:translate-y-68{
    --transform-translate-y: 17rem;
  }

  .lg\\:translate-y-72{
    --transform-translate-y: 18rem;
  }

  .lg\\:translate-y-74{
    --transform-translate-y: 18.5rem;
  }

  .lg\\:translate-y-76{
    --transform-translate-y: 19rem;
  }

  .lg\\:translate-y-78{
    --transform-translate-y: 19.5rem;
  }

  .lg\\:translate-y-80{
    --transform-translate-y: 20rem;
  }

  .lg\\:translate-y-82{
    --transform-translate-y: 20.5rem;
  }

  .lg\\:translate-y-84{
    --transform-translate-y: 21rem;
  }

  .lg\\:translate-y-88{
    --transform-translate-y: 22rem;
  }

  .lg\\:translate-y-92{
    --transform-translate-y: 23rem;
  }

  .lg\\:translate-y-96{
    --transform-translate-y: 24rem;
  }

  .lg\\:translate-y-98{
    --transform-translate-y: 24.5rem;
  }

  .lg\\:translate-y-100{
    --transform-translate-y: 25rem;
  }

  .lg\\:translate-y-104{
    --transform-translate-y: 26rem;
  }

  .lg\\:translate-y-112{
    --transform-translate-y: 28rem;
  }

  .lg\\:translate-y-124{
    --transform-translate-y: 31rem;
  }

  .lg\\:translate-y-128{
    --transform-translate-y: 32rem;
  }

  .lg\\:translate-y-140{
    --transform-translate-y: 35rem;
  }

  .lg\\:translate-y-152{
    --transform-translate-y: 38rem;
  }

  .lg\\:translate-y-160{
    --transform-translate-y: 40rem;
  }

  .lg\\:translate-y-162{
    --transform-translate-y: 41rem;
  }

  .lg\\:translate-y-192{
    --transform-translate-y: 48rem;
  }

  .lg\\:translate-y-208{
    --transform-translate-y: 52rem;
  }

  .lg\\:translate-y-224{
    --transform-translate-y: 56rem;
  }

  .lg\\:translate-y-256{
    --transform-translate-y: 64rem;
  }

  .lg\\:translate-y-px{
    --transform-translate-y: 1px;
  }

  .lg\\:-translate-y-1{
    --transform-translate-y: -0.25rem;
  }

  .lg\\:-translate-y-2{
    --transform-translate-y: -0.5rem;
  }

  .lg\\:-translate-y-3{
    --transform-translate-y: -0.75rem;
  }

  .lg\\:-translate-y-4{
    --transform-translate-y: -1rem;
  }

  .lg\\:-translate-y-5{
    --transform-translate-y: -1.25rem;
  }

  .lg\\:-translate-y-6{
    --transform-translate-y: -1.5rem;
  }

  .lg\\:-translate-y-7{
    --transform-translate-y: -1.75rem;
  }

  .lg\\:-translate-y-8{
    --transform-translate-y: -2rem;
  }

  .lg\\:-translate-y-9{
    --transform-translate-y: -2.25rem;
  }

  .lg\\:-translate-y-10{
    --transform-translate-y: -2.5rem;
  }

  .lg\\:-translate-y-11{
    --transform-translate-y: -2.75rem;
  }

  .lg\\:-translate-y-12{
    --transform-translate-y: -3rem;
  }

  .lg\\:-translate-y-14{
    --transform-translate-y: -3.5rem;
  }

  .lg\\:-translate-y-15{
    --transform-translate-y: -3.75rem;
  }

  .lg\\:-translate-y-16{
    --transform-translate-y: -4rem;
  }

  .lg\\:-translate-y-18{
    --transform-translate-y: -4.5rem;
  }

  .lg\\:-translate-y-20{
    --transform-translate-y: -5rem;
  }

  .lg\\:-translate-y-22{
    --transform-translate-y: -5.5rem;
  }

  .lg\\:-translate-y-23{
    --transform-translate-y: -5.75rem;
  }

  .lg\\:-translate-y-24{
    --transform-translate-y: -6rem;
  }

  .lg\\:-translate-y-25{
    --transform-translate-y: -6.25rem;
  }

  .lg\\:-translate-y-26{
    --transform-translate-y: -6.5rem;
  }

  .lg\\:-translate-y-28{
    --transform-translate-y: -7rem;
  }

  .lg\\:-translate-y-30{
    --transform-translate-y: -7.5rem;
  }

  .lg\\:-translate-y-32{
    --transform-translate-y: -8rem;
  }

  .lg\\:-translate-y-34{
    --transform-translate-y: -8.5rem;
  }

  .lg\\:-translate-y-40{
    --transform-translate-y: -10rem;
  }

  .lg\\:-translate-y-42{
    --transform-translate-y: -10.5rem;
  }

  .lg\\:-translate-y-44{
    --transform-translate-y: -11rem;
  }

  .lg\\:-translate-y-48{
    --transform-translate-y: -12rem;
  }

  .lg\\:-translate-y-52{
    --transform-translate-y: -13rem;
  }

  .lg\\:-translate-y-54{
    --transform-translate-y: -13.5rem;
  }

  .lg\\:-translate-y-56{
    --transform-translate-y: -14rem;
  }

  .lg\\:-translate-y-60{
    --transform-translate-y: -15rem;
  }

  .lg\\:-translate-y-64{
    --transform-translate-y: -16rem;
  }

  .lg\\:-translate-y-68{
    --transform-translate-y: -17rem;
  }

  .lg\\:-translate-y-72{
    --transform-translate-y: -18rem;
  }

  .lg\\:-translate-y-74{
    --transform-translate-y: -18.5rem;
  }

  .lg\\:-translate-y-76{
    --transform-translate-y: -19rem;
  }

  .lg\\:-translate-y-78{
    --transform-translate-y: -19.5rem;
  }

  .lg\\:-translate-y-80{
    --transform-translate-y: -20rem;
  }

  .lg\\:-translate-y-82{
    --transform-translate-y: -20.5rem;
  }

  .lg\\:-translate-y-84{
    --transform-translate-y: -21rem;
  }

  .lg\\:-translate-y-88{
    --transform-translate-y: -22rem;
  }

  .lg\\:-translate-y-92{
    --transform-translate-y: -23rem;
  }

  .lg\\:-translate-y-96{
    --transform-translate-y: -24rem;
  }

  .lg\\:-translate-y-98{
    --transform-translate-y: -24.5rem;
  }

  .lg\\:-translate-y-100{
    --transform-translate-y: -25rem;
  }

  .lg\\:-translate-y-104{
    --transform-translate-y: -26rem;
  }

  .lg\\:-translate-y-112{
    --transform-translate-y: -28rem;
  }

  .lg\\:-translate-y-124{
    --transform-translate-y: -31rem;
  }

  .lg\\:-translate-y-128{
    --transform-translate-y: -32rem;
  }

  .lg\\:-translate-y-140{
    --transform-translate-y: -35rem;
  }

  .lg\\:-translate-y-152{
    --transform-translate-y: -38rem;
  }

  .lg\\:-translate-y-160{
    --transform-translate-y: -40rem;
  }

  .lg\\:-translate-y-162{
    --transform-translate-y: -41rem;
  }

  .lg\\:-translate-y-192{
    --transform-translate-y: -48rem;
  }

  .lg\\:-translate-y-208{
    --transform-translate-y: -52rem;
  }

  .lg\\:-translate-y-224{
    --transform-translate-y: -56rem;
  }

  .lg\\:-translate-y-256{
    --transform-translate-y: -64rem;
  }

  .lg\\:-translate-y-px{
    --transform-translate-y: -1px;
  }

  .lg\\:-translate-y-full{
    --transform-translate-y: -100%;
  }

  .lg\\:-translate-y-1\\/2{
    --transform-translate-y: -50%;
  }

  .lg\\:translate-y-1\\/2{
    --transform-translate-y: 50%;
  }

  .lg\\:translate-y-full{
    --transform-translate-y: 100%;
  }

  .lg\\:hover\\:translate-x-0:hover{
    --transform-translate-x: 0;
  }

  .lg\\:hover\\:translate-x-1:hover{
    --transform-translate-x: 0.25rem;
  }

  .lg\\:hover\\:translate-x-2:hover{
    --transform-translate-x: 0.5rem;
  }

  .lg\\:hover\\:translate-x-3:hover{
    --transform-translate-x: 0.75rem;
  }

  .lg\\:hover\\:translate-x-4:hover{
    --transform-translate-x: 1rem;
  }

  .lg\\:hover\\:translate-x-5:hover{
    --transform-translate-x: 1.25rem;
  }

  .lg\\:hover\\:translate-x-6:hover{
    --transform-translate-x: 1.5rem;
  }

  .lg\\:hover\\:translate-x-7:hover{
    --transform-translate-x: 1.75rem;
  }

  .lg\\:hover\\:translate-x-8:hover{
    --transform-translate-x: 2rem;
  }

  .lg\\:hover\\:translate-x-9:hover{
    --transform-translate-x: 2.25rem;
  }

  .lg\\:hover\\:translate-x-10:hover{
    --transform-translate-x: 2.5rem;
  }

  .lg\\:hover\\:translate-x-11:hover{
    --transform-translate-x: 2.75rem;
  }

  .lg\\:hover\\:translate-x-12:hover{
    --transform-translate-x: 3rem;
  }

  .lg\\:hover\\:translate-x-14:hover{
    --transform-translate-x: 3.5rem;
  }

  .lg\\:hover\\:translate-x-15:hover{
    --transform-translate-x: 3.75rem;
  }

  .lg\\:hover\\:translate-x-16:hover{
    --transform-translate-x: 4rem;
  }

  .lg\\:hover\\:translate-x-18:hover{
    --transform-translate-x: 4.5rem;
  }

  .lg\\:hover\\:translate-x-20:hover{
    --transform-translate-x: 5rem;
  }

  .lg\\:hover\\:translate-x-22:hover{
    --transform-translate-x: 5.5rem;
  }

  .lg\\:hover\\:translate-x-23:hover{
    --transform-translate-x: 5.75rem;
  }

  .lg\\:hover\\:translate-x-24:hover{
    --transform-translate-x: 6rem;
  }

  .lg\\:hover\\:translate-x-25:hover{
    --transform-translate-x: 6.25rem;
  }

  .lg\\:hover\\:translate-x-26:hover{
    --transform-translate-x: 6.5rem;
  }

  .lg\\:hover\\:translate-x-28:hover{
    --transform-translate-x: 7rem;
  }

  .lg\\:hover\\:translate-x-30:hover{
    --transform-translate-x: 7.5rem;
  }

  .lg\\:hover\\:translate-x-32:hover{
    --transform-translate-x: 8rem;
  }

  .lg\\:hover\\:translate-x-34:hover{
    --transform-translate-x: 8.5rem;
  }

  .lg\\:hover\\:translate-x-40:hover{
    --transform-translate-x: 10rem;
  }

  .lg\\:hover\\:translate-x-42:hover{
    --transform-translate-x: 10.5rem;
  }

  .lg\\:hover\\:translate-x-44:hover{
    --transform-translate-x: 11rem;
  }

  .lg\\:hover\\:translate-x-48:hover{
    --transform-translate-x: 12rem;
  }

  .lg\\:hover\\:translate-x-52:hover{
    --transform-translate-x: 13rem;
  }

  .lg\\:hover\\:translate-x-54:hover{
    --transform-translate-x: 13.5rem;
  }

  .lg\\:hover\\:translate-x-56:hover{
    --transform-translate-x: 14rem;
  }

  .lg\\:hover\\:translate-x-60:hover{
    --transform-translate-x: 15rem;
  }

  .lg\\:hover\\:translate-x-64:hover{
    --transform-translate-x: 16rem;
  }

  .lg\\:hover\\:translate-x-68:hover{
    --transform-translate-x: 17rem;
  }

  .lg\\:hover\\:translate-x-72:hover{
    --transform-translate-x: 18rem;
  }

  .lg\\:hover\\:translate-x-74:hover{
    --transform-translate-x: 18.5rem;
  }

  .lg\\:hover\\:translate-x-76:hover{
    --transform-translate-x: 19rem;
  }

  .lg\\:hover\\:translate-x-78:hover{
    --transform-translate-x: 19.5rem;
  }

  .lg\\:hover\\:translate-x-80:hover{
    --transform-translate-x: 20rem;
  }

  .lg\\:hover\\:translate-x-82:hover{
    --transform-translate-x: 20.5rem;
  }

  .lg\\:hover\\:translate-x-84:hover{
    --transform-translate-x: 21rem;
  }

  .lg\\:hover\\:translate-x-88:hover{
    --transform-translate-x: 22rem;
  }

  .lg\\:hover\\:translate-x-92:hover{
    --transform-translate-x: 23rem;
  }

  .lg\\:hover\\:translate-x-96:hover{
    --transform-translate-x: 24rem;
  }

  .lg\\:hover\\:translate-x-98:hover{
    --transform-translate-x: 24.5rem;
  }

  .lg\\:hover\\:translate-x-100:hover{
    --transform-translate-x: 25rem;
  }

  .lg\\:hover\\:translate-x-104:hover{
    --transform-translate-x: 26rem;
  }

  .lg\\:hover\\:translate-x-112:hover{
    --transform-translate-x: 28rem;
  }

  .lg\\:hover\\:translate-x-124:hover{
    --transform-translate-x: 31rem;
  }

  .lg\\:hover\\:translate-x-128:hover{
    --transform-translate-x: 32rem;
  }

  .lg\\:hover\\:translate-x-140:hover{
    --transform-translate-x: 35rem;
  }

  .lg\\:hover\\:translate-x-152:hover{
    --transform-translate-x: 38rem;
  }

  .lg\\:hover\\:translate-x-160:hover{
    --transform-translate-x: 40rem;
  }

  .lg\\:hover\\:translate-x-162:hover{
    --transform-translate-x: 41rem;
  }

  .lg\\:hover\\:translate-x-192:hover{
    --transform-translate-x: 48rem;
  }

  .lg\\:hover\\:translate-x-208:hover{
    --transform-translate-x: 52rem;
  }

  .lg\\:hover\\:translate-x-224:hover{
    --transform-translate-x: 56rem;
  }

  .lg\\:hover\\:translate-x-256:hover{
    --transform-translate-x: 64rem;
  }

  .lg\\:hover\\:translate-x-px:hover{
    --transform-translate-x: 1px;
  }

  .lg\\:hover\\:-translate-x-1:hover{
    --transform-translate-x: -0.25rem;
  }

  .lg\\:hover\\:-translate-x-2:hover{
    --transform-translate-x: -0.5rem;
  }

  .lg\\:hover\\:-translate-x-3:hover{
    --transform-translate-x: -0.75rem;
  }

  .lg\\:hover\\:-translate-x-4:hover{
    --transform-translate-x: -1rem;
  }

  .lg\\:hover\\:-translate-x-5:hover{
    --transform-translate-x: -1.25rem;
  }

  .lg\\:hover\\:-translate-x-6:hover{
    --transform-translate-x: -1.5rem;
  }

  .lg\\:hover\\:-translate-x-7:hover{
    --transform-translate-x: -1.75rem;
  }

  .lg\\:hover\\:-translate-x-8:hover{
    --transform-translate-x: -2rem;
  }

  .lg\\:hover\\:-translate-x-9:hover{
    --transform-translate-x: -2.25rem;
  }

  .lg\\:hover\\:-translate-x-10:hover{
    --transform-translate-x: -2.5rem;
  }

  .lg\\:hover\\:-translate-x-11:hover{
    --transform-translate-x: -2.75rem;
  }

  .lg\\:hover\\:-translate-x-12:hover{
    --transform-translate-x: -3rem;
  }

  .lg\\:hover\\:-translate-x-14:hover{
    --transform-translate-x: -3.5rem;
  }

  .lg\\:hover\\:-translate-x-15:hover{
    --transform-translate-x: -3.75rem;
  }

  .lg\\:hover\\:-translate-x-16:hover{
    --transform-translate-x: -4rem;
  }

  .lg\\:hover\\:-translate-x-18:hover{
    --transform-translate-x: -4.5rem;
  }

  .lg\\:hover\\:-translate-x-20:hover{
    --transform-translate-x: -5rem;
  }

  .lg\\:hover\\:-translate-x-22:hover{
    --transform-translate-x: -5.5rem;
  }

  .lg\\:hover\\:-translate-x-23:hover{
    --transform-translate-x: -5.75rem;
  }

  .lg\\:hover\\:-translate-x-24:hover{
    --transform-translate-x: -6rem;
  }

  .lg\\:hover\\:-translate-x-25:hover{
    --transform-translate-x: -6.25rem;
  }

  .lg\\:hover\\:-translate-x-26:hover{
    --transform-translate-x: -6.5rem;
  }

  .lg\\:hover\\:-translate-x-28:hover{
    --transform-translate-x: -7rem;
  }

  .lg\\:hover\\:-translate-x-30:hover{
    --transform-translate-x: -7.5rem;
  }

  .lg\\:hover\\:-translate-x-32:hover{
    --transform-translate-x: -8rem;
  }

  .lg\\:hover\\:-translate-x-34:hover{
    --transform-translate-x: -8.5rem;
  }

  .lg\\:hover\\:-translate-x-40:hover{
    --transform-translate-x: -10rem;
  }

  .lg\\:hover\\:-translate-x-42:hover{
    --transform-translate-x: -10.5rem;
  }

  .lg\\:hover\\:-translate-x-44:hover{
    --transform-translate-x: -11rem;
  }

  .lg\\:hover\\:-translate-x-48:hover{
    --transform-translate-x: -12rem;
  }

  .lg\\:hover\\:-translate-x-52:hover{
    --transform-translate-x: -13rem;
  }

  .lg\\:hover\\:-translate-x-54:hover{
    --transform-translate-x: -13.5rem;
  }

  .lg\\:hover\\:-translate-x-56:hover{
    --transform-translate-x: -14rem;
  }

  .lg\\:hover\\:-translate-x-60:hover{
    --transform-translate-x: -15rem;
  }

  .lg\\:hover\\:-translate-x-64:hover{
    --transform-translate-x: -16rem;
  }

  .lg\\:hover\\:-translate-x-68:hover{
    --transform-translate-x: -17rem;
  }

  .lg\\:hover\\:-translate-x-72:hover{
    --transform-translate-x: -18rem;
  }

  .lg\\:hover\\:-translate-x-74:hover{
    --transform-translate-x: -18.5rem;
  }

  .lg\\:hover\\:-translate-x-76:hover{
    --transform-translate-x: -19rem;
  }

  .lg\\:hover\\:-translate-x-78:hover{
    --transform-translate-x: -19.5rem;
  }

  .lg\\:hover\\:-translate-x-80:hover{
    --transform-translate-x: -20rem;
  }

  .lg\\:hover\\:-translate-x-82:hover{
    --transform-translate-x: -20.5rem;
  }

  .lg\\:hover\\:-translate-x-84:hover{
    --transform-translate-x: -21rem;
  }

  .lg\\:hover\\:-translate-x-88:hover{
    --transform-translate-x: -22rem;
  }

  .lg\\:hover\\:-translate-x-92:hover{
    --transform-translate-x: -23rem;
  }

  .lg\\:hover\\:-translate-x-96:hover{
    --transform-translate-x: -24rem;
  }

  .lg\\:hover\\:-translate-x-98:hover{
    --transform-translate-x: -24.5rem;
  }

  .lg\\:hover\\:-translate-x-100:hover{
    --transform-translate-x: -25rem;
  }

  .lg\\:hover\\:-translate-x-104:hover{
    --transform-translate-x: -26rem;
  }

  .lg\\:hover\\:-translate-x-112:hover{
    --transform-translate-x: -28rem;
  }

  .lg\\:hover\\:-translate-x-124:hover{
    --transform-translate-x: -31rem;
  }

  .lg\\:hover\\:-translate-x-128:hover{
    --transform-translate-x: -32rem;
  }

  .lg\\:hover\\:-translate-x-140:hover{
    --transform-translate-x: -35rem;
  }

  .lg\\:hover\\:-translate-x-152:hover{
    --transform-translate-x: -38rem;
  }

  .lg\\:hover\\:-translate-x-160:hover{
    --transform-translate-x: -40rem;
  }

  .lg\\:hover\\:-translate-x-162:hover{
    --transform-translate-x: -41rem;
  }

  .lg\\:hover\\:-translate-x-192:hover{
    --transform-translate-x: -48rem;
  }

  .lg\\:hover\\:-translate-x-208:hover{
    --transform-translate-x: -52rem;
  }

  .lg\\:hover\\:-translate-x-224:hover{
    --transform-translate-x: -56rem;
  }

  .lg\\:hover\\:-translate-x-256:hover{
    --transform-translate-x: -64rem;
  }

  .lg\\:hover\\:-translate-x-px:hover{
    --transform-translate-x: -1px;
  }

  .lg\\:hover\\:-translate-x-full:hover{
    --transform-translate-x: -100%;
  }

  .lg\\:hover\\:-translate-x-1\\/2:hover{
    --transform-translate-x: -50%;
  }

  .lg\\:hover\\:translate-x-1\\/2:hover{
    --transform-translate-x: 50%;
  }

  .lg\\:hover\\:translate-x-full:hover{
    --transform-translate-x: 100%;
  }

  .lg\\:hover\\:translate-y-0:hover{
    --transform-translate-y: 0;
  }

  .lg\\:hover\\:translate-y-1:hover{
    --transform-translate-y: 0.25rem;
  }

  .lg\\:hover\\:translate-y-2:hover{
    --transform-translate-y: 0.5rem;
  }

  .lg\\:hover\\:translate-y-3:hover{
    --transform-translate-y: 0.75rem;
  }

  .lg\\:hover\\:translate-y-4:hover{
    --transform-translate-y: 1rem;
  }

  .lg\\:hover\\:translate-y-5:hover{
    --transform-translate-y: 1.25rem;
  }

  .lg\\:hover\\:translate-y-6:hover{
    --transform-translate-y: 1.5rem;
  }

  .lg\\:hover\\:translate-y-7:hover{
    --transform-translate-y: 1.75rem;
  }

  .lg\\:hover\\:translate-y-8:hover{
    --transform-translate-y: 2rem;
  }

  .lg\\:hover\\:translate-y-9:hover{
    --transform-translate-y: 2.25rem;
  }

  .lg\\:hover\\:translate-y-10:hover{
    --transform-translate-y: 2.5rem;
  }

  .lg\\:hover\\:translate-y-11:hover{
    --transform-translate-y: 2.75rem;
  }

  .lg\\:hover\\:translate-y-12:hover{
    --transform-translate-y: 3rem;
  }

  .lg\\:hover\\:translate-y-14:hover{
    --transform-translate-y: 3.5rem;
  }

  .lg\\:hover\\:translate-y-15:hover{
    --transform-translate-y: 3.75rem;
  }

  .lg\\:hover\\:translate-y-16:hover{
    --transform-translate-y: 4rem;
  }

  .lg\\:hover\\:translate-y-18:hover{
    --transform-translate-y: 4.5rem;
  }

  .lg\\:hover\\:translate-y-20:hover{
    --transform-translate-y: 5rem;
  }

  .lg\\:hover\\:translate-y-22:hover{
    --transform-translate-y: 5.5rem;
  }

  .lg\\:hover\\:translate-y-23:hover{
    --transform-translate-y: 5.75rem;
  }

  .lg\\:hover\\:translate-y-24:hover{
    --transform-translate-y: 6rem;
  }

  .lg\\:hover\\:translate-y-25:hover{
    --transform-translate-y: 6.25rem;
  }

  .lg\\:hover\\:translate-y-26:hover{
    --transform-translate-y: 6.5rem;
  }

  .lg\\:hover\\:translate-y-28:hover{
    --transform-translate-y: 7rem;
  }

  .lg\\:hover\\:translate-y-30:hover{
    --transform-translate-y: 7.5rem;
  }

  .lg\\:hover\\:translate-y-32:hover{
    --transform-translate-y: 8rem;
  }

  .lg\\:hover\\:translate-y-34:hover{
    --transform-translate-y: 8.5rem;
  }

  .lg\\:hover\\:translate-y-40:hover{
    --transform-translate-y: 10rem;
  }

  .lg\\:hover\\:translate-y-42:hover{
    --transform-translate-y: 10.5rem;
  }

  .lg\\:hover\\:translate-y-44:hover{
    --transform-translate-y: 11rem;
  }

  .lg\\:hover\\:translate-y-48:hover{
    --transform-translate-y: 12rem;
  }

  .lg\\:hover\\:translate-y-52:hover{
    --transform-translate-y: 13rem;
  }

  .lg\\:hover\\:translate-y-54:hover{
    --transform-translate-y: 13.5rem;
  }

  .lg\\:hover\\:translate-y-56:hover{
    --transform-translate-y: 14rem;
  }

  .lg\\:hover\\:translate-y-60:hover{
    --transform-translate-y: 15rem;
  }

  .lg\\:hover\\:translate-y-64:hover{
    --transform-translate-y: 16rem;
  }

  .lg\\:hover\\:translate-y-68:hover{
    --transform-translate-y: 17rem;
  }

  .lg\\:hover\\:translate-y-72:hover{
    --transform-translate-y: 18rem;
  }

  .lg\\:hover\\:translate-y-74:hover{
    --transform-translate-y: 18.5rem;
  }

  .lg\\:hover\\:translate-y-76:hover{
    --transform-translate-y: 19rem;
  }

  .lg\\:hover\\:translate-y-78:hover{
    --transform-translate-y: 19.5rem;
  }

  .lg\\:hover\\:translate-y-80:hover{
    --transform-translate-y: 20rem;
  }

  .lg\\:hover\\:translate-y-82:hover{
    --transform-translate-y: 20.5rem;
  }

  .lg\\:hover\\:translate-y-84:hover{
    --transform-translate-y: 21rem;
  }

  .lg\\:hover\\:translate-y-88:hover{
    --transform-translate-y: 22rem;
  }

  .lg\\:hover\\:translate-y-92:hover{
    --transform-translate-y: 23rem;
  }

  .lg\\:hover\\:translate-y-96:hover{
    --transform-translate-y: 24rem;
  }

  .lg\\:hover\\:translate-y-98:hover{
    --transform-translate-y: 24.5rem;
  }

  .lg\\:hover\\:translate-y-100:hover{
    --transform-translate-y: 25rem;
  }

  .lg\\:hover\\:translate-y-104:hover{
    --transform-translate-y: 26rem;
  }

  .lg\\:hover\\:translate-y-112:hover{
    --transform-translate-y: 28rem;
  }

  .lg\\:hover\\:translate-y-124:hover{
    --transform-translate-y: 31rem;
  }

  .lg\\:hover\\:translate-y-128:hover{
    --transform-translate-y: 32rem;
  }

  .lg\\:hover\\:translate-y-140:hover{
    --transform-translate-y: 35rem;
  }

  .lg\\:hover\\:translate-y-152:hover{
    --transform-translate-y: 38rem;
  }

  .lg\\:hover\\:translate-y-160:hover{
    --transform-translate-y: 40rem;
  }

  .lg\\:hover\\:translate-y-162:hover{
    --transform-translate-y: 41rem;
  }

  .lg\\:hover\\:translate-y-192:hover{
    --transform-translate-y: 48rem;
  }

  .lg\\:hover\\:translate-y-208:hover{
    --transform-translate-y: 52rem;
  }

  .lg\\:hover\\:translate-y-224:hover{
    --transform-translate-y: 56rem;
  }

  .lg\\:hover\\:translate-y-256:hover{
    --transform-translate-y: 64rem;
  }

  .lg\\:hover\\:translate-y-px:hover{
    --transform-translate-y: 1px;
  }

  .lg\\:hover\\:-translate-y-1:hover{
    --transform-translate-y: -0.25rem;
  }

  .lg\\:hover\\:-translate-y-2:hover{
    --transform-translate-y: -0.5rem;
  }

  .lg\\:hover\\:-translate-y-3:hover{
    --transform-translate-y: -0.75rem;
  }

  .lg\\:hover\\:-translate-y-4:hover{
    --transform-translate-y: -1rem;
  }

  .lg\\:hover\\:-translate-y-5:hover{
    --transform-translate-y: -1.25rem;
  }

  .lg\\:hover\\:-translate-y-6:hover{
    --transform-translate-y: -1.5rem;
  }

  .lg\\:hover\\:-translate-y-7:hover{
    --transform-translate-y: -1.75rem;
  }

  .lg\\:hover\\:-translate-y-8:hover{
    --transform-translate-y: -2rem;
  }

  .lg\\:hover\\:-translate-y-9:hover{
    --transform-translate-y: -2.25rem;
  }

  .lg\\:hover\\:-translate-y-10:hover{
    --transform-translate-y: -2.5rem;
  }

  .lg\\:hover\\:-translate-y-11:hover{
    --transform-translate-y: -2.75rem;
  }

  .lg\\:hover\\:-translate-y-12:hover{
    --transform-translate-y: -3rem;
  }

  .lg\\:hover\\:-translate-y-14:hover{
    --transform-translate-y: -3.5rem;
  }

  .lg\\:hover\\:-translate-y-15:hover{
    --transform-translate-y: -3.75rem;
  }

  .lg\\:hover\\:-translate-y-16:hover{
    --transform-translate-y: -4rem;
  }

  .lg\\:hover\\:-translate-y-18:hover{
    --transform-translate-y: -4.5rem;
  }

  .lg\\:hover\\:-translate-y-20:hover{
    --transform-translate-y: -5rem;
  }

  .lg\\:hover\\:-translate-y-22:hover{
    --transform-translate-y: -5.5rem;
  }

  .lg\\:hover\\:-translate-y-23:hover{
    --transform-translate-y: -5.75rem;
  }

  .lg\\:hover\\:-translate-y-24:hover{
    --transform-translate-y: -6rem;
  }

  .lg\\:hover\\:-translate-y-25:hover{
    --transform-translate-y: -6.25rem;
  }

  .lg\\:hover\\:-translate-y-26:hover{
    --transform-translate-y: -6.5rem;
  }

  .lg\\:hover\\:-translate-y-28:hover{
    --transform-translate-y: -7rem;
  }

  .lg\\:hover\\:-translate-y-30:hover{
    --transform-translate-y: -7.5rem;
  }

  .lg\\:hover\\:-translate-y-32:hover{
    --transform-translate-y: -8rem;
  }

  .lg\\:hover\\:-translate-y-34:hover{
    --transform-translate-y: -8.5rem;
  }

  .lg\\:hover\\:-translate-y-40:hover{
    --transform-translate-y: -10rem;
  }

  .lg\\:hover\\:-translate-y-42:hover{
    --transform-translate-y: -10.5rem;
  }

  .lg\\:hover\\:-translate-y-44:hover{
    --transform-translate-y: -11rem;
  }

  .lg\\:hover\\:-translate-y-48:hover{
    --transform-translate-y: -12rem;
  }

  .lg\\:hover\\:-translate-y-52:hover{
    --transform-translate-y: -13rem;
  }

  .lg\\:hover\\:-translate-y-54:hover{
    --transform-translate-y: -13.5rem;
  }

  .lg\\:hover\\:-translate-y-56:hover{
    --transform-translate-y: -14rem;
  }

  .lg\\:hover\\:-translate-y-60:hover{
    --transform-translate-y: -15rem;
  }

  .lg\\:hover\\:-translate-y-64:hover{
    --transform-translate-y: -16rem;
  }

  .lg\\:hover\\:-translate-y-68:hover{
    --transform-translate-y: -17rem;
  }

  .lg\\:hover\\:-translate-y-72:hover{
    --transform-translate-y: -18rem;
  }

  .lg\\:hover\\:-translate-y-74:hover{
    --transform-translate-y: -18.5rem;
  }

  .lg\\:hover\\:-translate-y-76:hover{
    --transform-translate-y: -19rem;
  }

  .lg\\:hover\\:-translate-y-78:hover{
    --transform-translate-y: -19.5rem;
  }

  .lg\\:hover\\:-translate-y-80:hover{
    --transform-translate-y: -20rem;
  }

  .lg\\:hover\\:-translate-y-82:hover{
    --transform-translate-y: -20.5rem;
  }

  .lg\\:hover\\:-translate-y-84:hover{
    --transform-translate-y: -21rem;
  }

  .lg\\:hover\\:-translate-y-88:hover{
    --transform-translate-y: -22rem;
  }

  .lg\\:hover\\:-translate-y-92:hover{
    --transform-translate-y: -23rem;
  }

  .lg\\:hover\\:-translate-y-96:hover{
    --transform-translate-y: -24rem;
  }

  .lg\\:hover\\:-translate-y-98:hover{
    --transform-translate-y: -24.5rem;
  }

  .lg\\:hover\\:-translate-y-100:hover{
    --transform-translate-y: -25rem;
  }

  .lg\\:hover\\:-translate-y-104:hover{
    --transform-translate-y: -26rem;
  }

  .lg\\:hover\\:-translate-y-112:hover{
    --transform-translate-y: -28rem;
  }

  .lg\\:hover\\:-translate-y-124:hover{
    --transform-translate-y: -31rem;
  }

  .lg\\:hover\\:-translate-y-128:hover{
    --transform-translate-y: -32rem;
  }

  .lg\\:hover\\:-translate-y-140:hover{
    --transform-translate-y: -35rem;
  }

  .lg\\:hover\\:-translate-y-152:hover{
    --transform-translate-y: -38rem;
  }

  .lg\\:hover\\:-translate-y-160:hover{
    --transform-translate-y: -40rem;
  }

  .lg\\:hover\\:-translate-y-162:hover{
    --transform-translate-y: -41rem;
  }

  .lg\\:hover\\:-translate-y-192:hover{
    --transform-translate-y: -48rem;
  }

  .lg\\:hover\\:-translate-y-208:hover{
    --transform-translate-y: -52rem;
  }

  .lg\\:hover\\:-translate-y-224:hover{
    --transform-translate-y: -56rem;
  }

  .lg\\:hover\\:-translate-y-256:hover{
    --transform-translate-y: -64rem;
  }

  .lg\\:hover\\:-translate-y-px:hover{
    --transform-translate-y: -1px;
  }

  .lg\\:hover\\:-translate-y-full:hover{
    --transform-translate-y: -100%;
  }

  .lg\\:hover\\:-translate-y-1\\/2:hover{
    --transform-translate-y: -50%;
  }

  .lg\\:hover\\:translate-y-1\\/2:hover{
    --transform-translate-y: 50%;
  }

  .lg\\:hover\\:translate-y-full:hover{
    --transform-translate-y: 100%;
  }

  .lg\\:focus\\:translate-x-0:focus{
    --transform-translate-x: 0;
  }

  .lg\\:focus\\:translate-x-1:focus{
    --transform-translate-x: 0.25rem;
  }

  .lg\\:focus\\:translate-x-2:focus{
    --transform-translate-x: 0.5rem;
  }

  .lg\\:focus\\:translate-x-3:focus{
    --transform-translate-x: 0.75rem;
  }

  .lg\\:focus\\:translate-x-4:focus{
    --transform-translate-x: 1rem;
  }

  .lg\\:focus\\:translate-x-5:focus{
    --transform-translate-x: 1.25rem;
  }

  .lg\\:focus\\:translate-x-6:focus{
    --transform-translate-x: 1.5rem;
  }

  .lg\\:focus\\:translate-x-7:focus{
    --transform-translate-x: 1.75rem;
  }

  .lg\\:focus\\:translate-x-8:focus{
    --transform-translate-x: 2rem;
  }

  .lg\\:focus\\:translate-x-9:focus{
    --transform-translate-x: 2.25rem;
  }

  .lg\\:focus\\:translate-x-10:focus{
    --transform-translate-x: 2.5rem;
  }

  .lg\\:focus\\:translate-x-11:focus{
    --transform-translate-x: 2.75rem;
  }

  .lg\\:focus\\:translate-x-12:focus{
    --transform-translate-x: 3rem;
  }

  .lg\\:focus\\:translate-x-14:focus{
    --transform-translate-x: 3.5rem;
  }

  .lg\\:focus\\:translate-x-15:focus{
    --transform-translate-x: 3.75rem;
  }

  .lg\\:focus\\:translate-x-16:focus{
    --transform-translate-x: 4rem;
  }

  .lg\\:focus\\:translate-x-18:focus{
    --transform-translate-x: 4.5rem;
  }

  .lg\\:focus\\:translate-x-20:focus{
    --transform-translate-x: 5rem;
  }

  .lg\\:focus\\:translate-x-22:focus{
    --transform-translate-x: 5.5rem;
  }

  .lg\\:focus\\:translate-x-23:focus{
    --transform-translate-x: 5.75rem;
  }

  .lg\\:focus\\:translate-x-24:focus{
    --transform-translate-x: 6rem;
  }

  .lg\\:focus\\:translate-x-25:focus{
    --transform-translate-x: 6.25rem;
  }

  .lg\\:focus\\:translate-x-26:focus{
    --transform-translate-x: 6.5rem;
  }

  .lg\\:focus\\:translate-x-28:focus{
    --transform-translate-x: 7rem;
  }

  .lg\\:focus\\:translate-x-30:focus{
    --transform-translate-x: 7.5rem;
  }

  .lg\\:focus\\:translate-x-32:focus{
    --transform-translate-x: 8rem;
  }

  .lg\\:focus\\:translate-x-34:focus{
    --transform-translate-x: 8.5rem;
  }

  .lg\\:focus\\:translate-x-40:focus{
    --transform-translate-x: 10rem;
  }

  .lg\\:focus\\:translate-x-42:focus{
    --transform-translate-x: 10.5rem;
  }

  .lg\\:focus\\:translate-x-44:focus{
    --transform-translate-x: 11rem;
  }

  .lg\\:focus\\:translate-x-48:focus{
    --transform-translate-x: 12rem;
  }

  .lg\\:focus\\:translate-x-52:focus{
    --transform-translate-x: 13rem;
  }

  .lg\\:focus\\:translate-x-54:focus{
    --transform-translate-x: 13.5rem;
  }

  .lg\\:focus\\:translate-x-56:focus{
    --transform-translate-x: 14rem;
  }

  .lg\\:focus\\:translate-x-60:focus{
    --transform-translate-x: 15rem;
  }

  .lg\\:focus\\:translate-x-64:focus{
    --transform-translate-x: 16rem;
  }

  .lg\\:focus\\:translate-x-68:focus{
    --transform-translate-x: 17rem;
  }

  .lg\\:focus\\:translate-x-72:focus{
    --transform-translate-x: 18rem;
  }

  .lg\\:focus\\:translate-x-74:focus{
    --transform-translate-x: 18.5rem;
  }

  .lg\\:focus\\:translate-x-76:focus{
    --transform-translate-x: 19rem;
  }

  .lg\\:focus\\:translate-x-78:focus{
    --transform-translate-x: 19.5rem;
  }

  .lg\\:focus\\:translate-x-80:focus{
    --transform-translate-x: 20rem;
  }

  .lg\\:focus\\:translate-x-82:focus{
    --transform-translate-x: 20.5rem;
  }

  .lg\\:focus\\:translate-x-84:focus{
    --transform-translate-x: 21rem;
  }

  .lg\\:focus\\:translate-x-88:focus{
    --transform-translate-x: 22rem;
  }

  .lg\\:focus\\:translate-x-92:focus{
    --transform-translate-x: 23rem;
  }

  .lg\\:focus\\:translate-x-96:focus{
    --transform-translate-x: 24rem;
  }

  .lg\\:focus\\:translate-x-98:focus{
    --transform-translate-x: 24.5rem;
  }

  .lg\\:focus\\:translate-x-100:focus{
    --transform-translate-x: 25rem;
  }

  .lg\\:focus\\:translate-x-104:focus{
    --transform-translate-x: 26rem;
  }

  .lg\\:focus\\:translate-x-112:focus{
    --transform-translate-x: 28rem;
  }

  .lg\\:focus\\:translate-x-124:focus{
    --transform-translate-x: 31rem;
  }

  .lg\\:focus\\:translate-x-128:focus{
    --transform-translate-x: 32rem;
  }

  .lg\\:focus\\:translate-x-140:focus{
    --transform-translate-x: 35rem;
  }

  .lg\\:focus\\:translate-x-152:focus{
    --transform-translate-x: 38rem;
  }

  .lg\\:focus\\:translate-x-160:focus{
    --transform-translate-x: 40rem;
  }

  .lg\\:focus\\:translate-x-162:focus{
    --transform-translate-x: 41rem;
  }

  .lg\\:focus\\:translate-x-192:focus{
    --transform-translate-x: 48rem;
  }

  .lg\\:focus\\:translate-x-208:focus{
    --transform-translate-x: 52rem;
  }

  .lg\\:focus\\:translate-x-224:focus{
    --transform-translate-x: 56rem;
  }

  .lg\\:focus\\:translate-x-256:focus{
    --transform-translate-x: 64rem;
  }

  .lg\\:focus\\:translate-x-px:focus{
    --transform-translate-x: 1px;
  }

  .lg\\:focus\\:-translate-x-1:focus{
    --transform-translate-x: -0.25rem;
  }

  .lg\\:focus\\:-translate-x-2:focus{
    --transform-translate-x: -0.5rem;
  }

  .lg\\:focus\\:-translate-x-3:focus{
    --transform-translate-x: -0.75rem;
  }

  .lg\\:focus\\:-translate-x-4:focus{
    --transform-translate-x: -1rem;
  }

  .lg\\:focus\\:-translate-x-5:focus{
    --transform-translate-x: -1.25rem;
  }

  .lg\\:focus\\:-translate-x-6:focus{
    --transform-translate-x: -1.5rem;
  }

  .lg\\:focus\\:-translate-x-7:focus{
    --transform-translate-x: -1.75rem;
  }

  .lg\\:focus\\:-translate-x-8:focus{
    --transform-translate-x: -2rem;
  }

  .lg\\:focus\\:-translate-x-9:focus{
    --transform-translate-x: -2.25rem;
  }

  .lg\\:focus\\:-translate-x-10:focus{
    --transform-translate-x: -2.5rem;
  }

  .lg\\:focus\\:-translate-x-11:focus{
    --transform-translate-x: -2.75rem;
  }

  .lg\\:focus\\:-translate-x-12:focus{
    --transform-translate-x: -3rem;
  }

  .lg\\:focus\\:-translate-x-14:focus{
    --transform-translate-x: -3.5rem;
  }

  .lg\\:focus\\:-translate-x-15:focus{
    --transform-translate-x: -3.75rem;
  }

  .lg\\:focus\\:-translate-x-16:focus{
    --transform-translate-x: -4rem;
  }

  .lg\\:focus\\:-translate-x-18:focus{
    --transform-translate-x: -4.5rem;
  }

  .lg\\:focus\\:-translate-x-20:focus{
    --transform-translate-x: -5rem;
  }

  .lg\\:focus\\:-translate-x-22:focus{
    --transform-translate-x: -5.5rem;
  }

  .lg\\:focus\\:-translate-x-23:focus{
    --transform-translate-x: -5.75rem;
  }

  .lg\\:focus\\:-translate-x-24:focus{
    --transform-translate-x: -6rem;
  }

  .lg\\:focus\\:-translate-x-25:focus{
    --transform-translate-x: -6.25rem;
  }

  .lg\\:focus\\:-translate-x-26:focus{
    --transform-translate-x: -6.5rem;
  }

  .lg\\:focus\\:-translate-x-28:focus{
    --transform-translate-x: -7rem;
  }

  .lg\\:focus\\:-translate-x-30:focus{
    --transform-translate-x: -7.5rem;
  }

  .lg\\:focus\\:-translate-x-32:focus{
    --transform-translate-x: -8rem;
  }

  .lg\\:focus\\:-translate-x-34:focus{
    --transform-translate-x: -8.5rem;
  }

  .lg\\:focus\\:-translate-x-40:focus{
    --transform-translate-x: -10rem;
  }

  .lg\\:focus\\:-translate-x-42:focus{
    --transform-translate-x: -10.5rem;
  }

  .lg\\:focus\\:-translate-x-44:focus{
    --transform-translate-x: -11rem;
  }

  .lg\\:focus\\:-translate-x-48:focus{
    --transform-translate-x: -12rem;
  }

  .lg\\:focus\\:-translate-x-52:focus{
    --transform-translate-x: -13rem;
  }

  .lg\\:focus\\:-translate-x-54:focus{
    --transform-translate-x: -13.5rem;
  }

  .lg\\:focus\\:-translate-x-56:focus{
    --transform-translate-x: -14rem;
  }

  .lg\\:focus\\:-translate-x-60:focus{
    --transform-translate-x: -15rem;
  }

  .lg\\:focus\\:-translate-x-64:focus{
    --transform-translate-x: -16rem;
  }

  .lg\\:focus\\:-translate-x-68:focus{
    --transform-translate-x: -17rem;
  }

  .lg\\:focus\\:-translate-x-72:focus{
    --transform-translate-x: -18rem;
  }

  .lg\\:focus\\:-translate-x-74:focus{
    --transform-translate-x: -18.5rem;
  }

  .lg\\:focus\\:-translate-x-76:focus{
    --transform-translate-x: -19rem;
  }

  .lg\\:focus\\:-translate-x-78:focus{
    --transform-translate-x: -19.5rem;
  }

  .lg\\:focus\\:-translate-x-80:focus{
    --transform-translate-x: -20rem;
  }

  .lg\\:focus\\:-translate-x-82:focus{
    --transform-translate-x: -20.5rem;
  }

  .lg\\:focus\\:-translate-x-84:focus{
    --transform-translate-x: -21rem;
  }

  .lg\\:focus\\:-translate-x-88:focus{
    --transform-translate-x: -22rem;
  }

  .lg\\:focus\\:-translate-x-92:focus{
    --transform-translate-x: -23rem;
  }

  .lg\\:focus\\:-translate-x-96:focus{
    --transform-translate-x: -24rem;
  }

  .lg\\:focus\\:-translate-x-98:focus{
    --transform-translate-x: -24.5rem;
  }

  .lg\\:focus\\:-translate-x-100:focus{
    --transform-translate-x: -25rem;
  }

  .lg\\:focus\\:-translate-x-104:focus{
    --transform-translate-x: -26rem;
  }

  .lg\\:focus\\:-translate-x-112:focus{
    --transform-translate-x: -28rem;
  }

  .lg\\:focus\\:-translate-x-124:focus{
    --transform-translate-x: -31rem;
  }

  .lg\\:focus\\:-translate-x-128:focus{
    --transform-translate-x: -32rem;
  }

  .lg\\:focus\\:-translate-x-140:focus{
    --transform-translate-x: -35rem;
  }

  .lg\\:focus\\:-translate-x-152:focus{
    --transform-translate-x: -38rem;
  }

  .lg\\:focus\\:-translate-x-160:focus{
    --transform-translate-x: -40rem;
  }

  .lg\\:focus\\:-translate-x-162:focus{
    --transform-translate-x: -41rem;
  }

  .lg\\:focus\\:-translate-x-192:focus{
    --transform-translate-x: -48rem;
  }

  .lg\\:focus\\:-translate-x-208:focus{
    --transform-translate-x: -52rem;
  }

  .lg\\:focus\\:-translate-x-224:focus{
    --transform-translate-x: -56rem;
  }

  .lg\\:focus\\:-translate-x-256:focus{
    --transform-translate-x: -64rem;
  }

  .lg\\:focus\\:-translate-x-px:focus{
    --transform-translate-x: -1px;
  }

  .lg\\:focus\\:-translate-x-full:focus{
    --transform-translate-x: -100%;
  }

  .lg\\:focus\\:-translate-x-1\\/2:focus{
    --transform-translate-x: -50%;
  }

  .lg\\:focus\\:translate-x-1\\/2:focus{
    --transform-translate-x: 50%;
  }

  .lg\\:focus\\:translate-x-full:focus{
    --transform-translate-x: 100%;
  }

  .lg\\:focus\\:translate-y-0:focus{
    --transform-translate-y: 0;
  }

  .lg\\:focus\\:translate-y-1:focus{
    --transform-translate-y: 0.25rem;
  }

  .lg\\:focus\\:translate-y-2:focus{
    --transform-translate-y: 0.5rem;
  }

  .lg\\:focus\\:translate-y-3:focus{
    --transform-translate-y: 0.75rem;
  }

  .lg\\:focus\\:translate-y-4:focus{
    --transform-translate-y: 1rem;
  }

  .lg\\:focus\\:translate-y-5:focus{
    --transform-translate-y: 1.25rem;
  }

  .lg\\:focus\\:translate-y-6:focus{
    --transform-translate-y: 1.5rem;
  }

  .lg\\:focus\\:translate-y-7:focus{
    --transform-translate-y: 1.75rem;
  }

  .lg\\:focus\\:translate-y-8:focus{
    --transform-translate-y: 2rem;
  }

  .lg\\:focus\\:translate-y-9:focus{
    --transform-translate-y: 2.25rem;
  }

  .lg\\:focus\\:translate-y-10:focus{
    --transform-translate-y: 2.5rem;
  }

  .lg\\:focus\\:translate-y-11:focus{
    --transform-translate-y: 2.75rem;
  }

  .lg\\:focus\\:translate-y-12:focus{
    --transform-translate-y: 3rem;
  }

  .lg\\:focus\\:translate-y-14:focus{
    --transform-translate-y: 3.5rem;
  }

  .lg\\:focus\\:translate-y-15:focus{
    --transform-translate-y: 3.75rem;
  }

  .lg\\:focus\\:translate-y-16:focus{
    --transform-translate-y: 4rem;
  }

  .lg\\:focus\\:translate-y-18:focus{
    --transform-translate-y: 4.5rem;
  }

  .lg\\:focus\\:translate-y-20:focus{
    --transform-translate-y: 5rem;
  }

  .lg\\:focus\\:translate-y-22:focus{
    --transform-translate-y: 5.5rem;
  }

  .lg\\:focus\\:translate-y-23:focus{
    --transform-translate-y: 5.75rem;
  }

  .lg\\:focus\\:translate-y-24:focus{
    --transform-translate-y: 6rem;
  }

  .lg\\:focus\\:translate-y-25:focus{
    --transform-translate-y: 6.25rem;
  }

  .lg\\:focus\\:translate-y-26:focus{
    --transform-translate-y: 6.5rem;
  }

  .lg\\:focus\\:translate-y-28:focus{
    --transform-translate-y: 7rem;
  }

  .lg\\:focus\\:translate-y-30:focus{
    --transform-translate-y: 7.5rem;
  }

  .lg\\:focus\\:translate-y-32:focus{
    --transform-translate-y: 8rem;
  }

  .lg\\:focus\\:translate-y-34:focus{
    --transform-translate-y: 8.5rem;
  }

  .lg\\:focus\\:translate-y-40:focus{
    --transform-translate-y: 10rem;
  }

  .lg\\:focus\\:translate-y-42:focus{
    --transform-translate-y: 10.5rem;
  }

  .lg\\:focus\\:translate-y-44:focus{
    --transform-translate-y: 11rem;
  }

  .lg\\:focus\\:translate-y-48:focus{
    --transform-translate-y: 12rem;
  }

  .lg\\:focus\\:translate-y-52:focus{
    --transform-translate-y: 13rem;
  }

  .lg\\:focus\\:translate-y-54:focus{
    --transform-translate-y: 13.5rem;
  }

  .lg\\:focus\\:translate-y-56:focus{
    --transform-translate-y: 14rem;
  }

  .lg\\:focus\\:translate-y-60:focus{
    --transform-translate-y: 15rem;
  }

  .lg\\:focus\\:translate-y-64:focus{
    --transform-translate-y: 16rem;
  }

  .lg\\:focus\\:translate-y-68:focus{
    --transform-translate-y: 17rem;
  }

  .lg\\:focus\\:translate-y-72:focus{
    --transform-translate-y: 18rem;
  }

  .lg\\:focus\\:translate-y-74:focus{
    --transform-translate-y: 18.5rem;
  }

  .lg\\:focus\\:translate-y-76:focus{
    --transform-translate-y: 19rem;
  }

  .lg\\:focus\\:translate-y-78:focus{
    --transform-translate-y: 19.5rem;
  }

  .lg\\:focus\\:translate-y-80:focus{
    --transform-translate-y: 20rem;
  }

  .lg\\:focus\\:translate-y-82:focus{
    --transform-translate-y: 20.5rem;
  }

  .lg\\:focus\\:translate-y-84:focus{
    --transform-translate-y: 21rem;
  }

  .lg\\:focus\\:translate-y-88:focus{
    --transform-translate-y: 22rem;
  }

  .lg\\:focus\\:translate-y-92:focus{
    --transform-translate-y: 23rem;
  }

  .lg\\:focus\\:translate-y-96:focus{
    --transform-translate-y: 24rem;
  }

  .lg\\:focus\\:translate-y-98:focus{
    --transform-translate-y: 24.5rem;
  }

  .lg\\:focus\\:translate-y-100:focus{
    --transform-translate-y: 25rem;
  }

  .lg\\:focus\\:translate-y-104:focus{
    --transform-translate-y: 26rem;
  }

  .lg\\:focus\\:translate-y-112:focus{
    --transform-translate-y: 28rem;
  }

  .lg\\:focus\\:translate-y-124:focus{
    --transform-translate-y: 31rem;
  }

  .lg\\:focus\\:translate-y-128:focus{
    --transform-translate-y: 32rem;
  }

  .lg\\:focus\\:translate-y-140:focus{
    --transform-translate-y: 35rem;
  }

  .lg\\:focus\\:translate-y-152:focus{
    --transform-translate-y: 38rem;
  }

  .lg\\:focus\\:translate-y-160:focus{
    --transform-translate-y: 40rem;
  }

  .lg\\:focus\\:translate-y-162:focus{
    --transform-translate-y: 41rem;
  }

  .lg\\:focus\\:translate-y-192:focus{
    --transform-translate-y: 48rem;
  }

  .lg\\:focus\\:translate-y-208:focus{
    --transform-translate-y: 52rem;
  }

  .lg\\:focus\\:translate-y-224:focus{
    --transform-translate-y: 56rem;
  }

  .lg\\:focus\\:translate-y-256:focus{
    --transform-translate-y: 64rem;
  }

  .lg\\:focus\\:translate-y-px:focus{
    --transform-translate-y: 1px;
  }

  .lg\\:focus\\:-translate-y-1:focus{
    --transform-translate-y: -0.25rem;
  }

  .lg\\:focus\\:-translate-y-2:focus{
    --transform-translate-y: -0.5rem;
  }

  .lg\\:focus\\:-translate-y-3:focus{
    --transform-translate-y: -0.75rem;
  }

  .lg\\:focus\\:-translate-y-4:focus{
    --transform-translate-y: -1rem;
  }

  .lg\\:focus\\:-translate-y-5:focus{
    --transform-translate-y: -1.25rem;
  }

  .lg\\:focus\\:-translate-y-6:focus{
    --transform-translate-y: -1.5rem;
  }

  .lg\\:focus\\:-translate-y-7:focus{
    --transform-translate-y: -1.75rem;
  }

  .lg\\:focus\\:-translate-y-8:focus{
    --transform-translate-y: -2rem;
  }

  .lg\\:focus\\:-translate-y-9:focus{
    --transform-translate-y: -2.25rem;
  }

  .lg\\:focus\\:-translate-y-10:focus{
    --transform-translate-y: -2.5rem;
  }

  .lg\\:focus\\:-translate-y-11:focus{
    --transform-translate-y: -2.75rem;
  }

  .lg\\:focus\\:-translate-y-12:focus{
    --transform-translate-y: -3rem;
  }

  .lg\\:focus\\:-translate-y-14:focus{
    --transform-translate-y: -3.5rem;
  }

  .lg\\:focus\\:-translate-y-15:focus{
    --transform-translate-y: -3.75rem;
  }

  .lg\\:focus\\:-translate-y-16:focus{
    --transform-translate-y: -4rem;
  }

  .lg\\:focus\\:-translate-y-18:focus{
    --transform-translate-y: -4.5rem;
  }

  .lg\\:focus\\:-translate-y-20:focus{
    --transform-translate-y: -5rem;
  }

  .lg\\:focus\\:-translate-y-22:focus{
    --transform-translate-y: -5.5rem;
  }

  .lg\\:focus\\:-translate-y-23:focus{
    --transform-translate-y: -5.75rem;
  }

  .lg\\:focus\\:-translate-y-24:focus{
    --transform-translate-y: -6rem;
  }

  .lg\\:focus\\:-translate-y-25:focus{
    --transform-translate-y: -6.25rem;
  }

  .lg\\:focus\\:-translate-y-26:focus{
    --transform-translate-y: -6.5rem;
  }

  .lg\\:focus\\:-translate-y-28:focus{
    --transform-translate-y: -7rem;
  }

  .lg\\:focus\\:-translate-y-30:focus{
    --transform-translate-y: -7.5rem;
  }

  .lg\\:focus\\:-translate-y-32:focus{
    --transform-translate-y: -8rem;
  }

  .lg\\:focus\\:-translate-y-34:focus{
    --transform-translate-y: -8.5rem;
  }

  .lg\\:focus\\:-translate-y-40:focus{
    --transform-translate-y: -10rem;
  }

  .lg\\:focus\\:-translate-y-42:focus{
    --transform-translate-y: -10.5rem;
  }

  .lg\\:focus\\:-translate-y-44:focus{
    --transform-translate-y: -11rem;
  }

  .lg\\:focus\\:-translate-y-48:focus{
    --transform-translate-y: -12rem;
  }

  .lg\\:focus\\:-translate-y-52:focus{
    --transform-translate-y: -13rem;
  }

  .lg\\:focus\\:-translate-y-54:focus{
    --transform-translate-y: -13.5rem;
  }

  .lg\\:focus\\:-translate-y-56:focus{
    --transform-translate-y: -14rem;
  }

  .lg\\:focus\\:-translate-y-60:focus{
    --transform-translate-y: -15rem;
  }

  .lg\\:focus\\:-translate-y-64:focus{
    --transform-translate-y: -16rem;
  }

  .lg\\:focus\\:-translate-y-68:focus{
    --transform-translate-y: -17rem;
  }

  .lg\\:focus\\:-translate-y-72:focus{
    --transform-translate-y: -18rem;
  }

  .lg\\:focus\\:-translate-y-74:focus{
    --transform-translate-y: -18.5rem;
  }

  .lg\\:focus\\:-translate-y-76:focus{
    --transform-translate-y: -19rem;
  }

  .lg\\:focus\\:-translate-y-78:focus{
    --transform-translate-y: -19.5rem;
  }

  .lg\\:focus\\:-translate-y-80:focus{
    --transform-translate-y: -20rem;
  }

  .lg\\:focus\\:-translate-y-82:focus{
    --transform-translate-y: -20.5rem;
  }

  .lg\\:focus\\:-translate-y-84:focus{
    --transform-translate-y: -21rem;
  }

  .lg\\:focus\\:-translate-y-88:focus{
    --transform-translate-y: -22rem;
  }

  .lg\\:focus\\:-translate-y-92:focus{
    --transform-translate-y: -23rem;
  }

  .lg\\:focus\\:-translate-y-96:focus{
    --transform-translate-y: -24rem;
  }

  .lg\\:focus\\:-translate-y-98:focus{
    --transform-translate-y: -24.5rem;
  }

  .lg\\:focus\\:-translate-y-100:focus{
    --transform-translate-y: -25rem;
  }

  .lg\\:focus\\:-translate-y-104:focus{
    --transform-translate-y: -26rem;
  }

  .lg\\:focus\\:-translate-y-112:focus{
    --transform-translate-y: -28rem;
  }

  .lg\\:focus\\:-translate-y-124:focus{
    --transform-translate-y: -31rem;
  }

  .lg\\:focus\\:-translate-y-128:focus{
    --transform-translate-y: -32rem;
  }

  .lg\\:focus\\:-translate-y-140:focus{
    --transform-translate-y: -35rem;
  }

  .lg\\:focus\\:-translate-y-152:focus{
    --transform-translate-y: -38rem;
  }

  .lg\\:focus\\:-translate-y-160:focus{
    --transform-translate-y: -40rem;
  }

  .lg\\:focus\\:-translate-y-162:focus{
    --transform-translate-y: -41rem;
  }

  .lg\\:focus\\:-translate-y-192:focus{
    --transform-translate-y: -48rem;
  }

  .lg\\:focus\\:-translate-y-208:focus{
    --transform-translate-y: -52rem;
  }

  .lg\\:focus\\:-translate-y-224:focus{
    --transform-translate-y: -56rem;
  }

  .lg\\:focus\\:-translate-y-256:focus{
    --transform-translate-y: -64rem;
  }

  .lg\\:focus\\:-translate-y-px:focus{
    --transform-translate-y: -1px;
  }

  .lg\\:focus\\:-translate-y-full:focus{
    --transform-translate-y: -100%;
  }

  .lg\\:focus\\:-translate-y-1\\/2:focus{
    --transform-translate-y: -50%;
  }

  .lg\\:focus\\:translate-y-1\\/2:focus{
    --transform-translate-y: 50%;
  }

  .lg\\:focus\\:translate-y-full:focus{
    --transform-translate-y: 100%;
  }

  .lg\\:skew-x-0{
    --transform-skew-x: 0;
  }

  .lg\\:skew-x-1{
    --transform-skew-x: 1deg;
  }

  .lg\\:skew-x-2{
    --transform-skew-x: 2deg;
  }

  .lg\\:skew-x-3{
    --transform-skew-x: 3deg;
  }

  .lg\\:skew-x-6{
    --transform-skew-x: 6deg;
  }

  .lg\\:skew-x-12{
    --transform-skew-x: 12deg;
  }

  .lg\\:-skew-x-12{
    --transform-skew-x: -12deg;
  }

  .lg\\:-skew-x-6{
    --transform-skew-x: -6deg;
  }

  .lg\\:-skew-x-3{
    --transform-skew-x: -3deg;
  }

  .lg\\:-skew-x-2{
    --transform-skew-x: -2deg;
  }

  .lg\\:-skew-x-1{
    --transform-skew-x: -1deg;
  }

  .lg\\:skew-y-0{
    --transform-skew-y: 0;
  }

  .lg\\:skew-y-1{
    --transform-skew-y: 1deg;
  }

  .lg\\:skew-y-2{
    --transform-skew-y: 2deg;
  }

  .lg\\:skew-y-3{
    --transform-skew-y: 3deg;
  }

  .lg\\:skew-y-6{
    --transform-skew-y: 6deg;
  }

  .lg\\:skew-y-12{
    --transform-skew-y: 12deg;
  }

  .lg\\:-skew-y-12{
    --transform-skew-y: -12deg;
  }

  .lg\\:-skew-y-6{
    --transform-skew-y: -6deg;
  }

  .lg\\:-skew-y-3{
    --transform-skew-y: -3deg;
  }

  .lg\\:-skew-y-2{
    --transform-skew-y: -2deg;
  }

  .lg\\:-skew-y-1{
    --transform-skew-y: -1deg;
  }

  .lg\\:hover\\:skew-x-0:hover{
    --transform-skew-x: 0;
  }

  .lg\\:hover\\:skew-x-1:hover{
    --transform-skew-x: 1deg;
  }

  .lg\\:hover\\:skew-x-2:hover{
    --transform-skew-x: 2deg;
  }

  .lg\\:hover\\:skew-x-3:hover{
    --transform-skew-x: 3deg;
  }

  .lg\\:hover\\:skew-x-6:hover{
    --transform-skew-x: 6deg;
  }

  .lg\\:hover\\:skew-x-12:hover{
    --transform-skew-x: 12deg;
  }

  .lg\\:hover\\:-skew-x-12:hover{
    --transform-skew-x: -12deg;
  }

  .lg\\:hover\\:-skew-x-6:hover{
    --transform-skew-x: -6deg;
  }

  .lg\\:hover\\:-skew-x-3:hover{
    --transform-skew-x: -3deg;
  }

  .lg\\:hover\\:-skew-x-2:hover{
    --transform-skew-x: -2deg;
  }

  .lg\\:hover\\:-skew-x-1:hover{
    --transform-skew-x: -1deg;
  }

  .lg\\:hover\\:skew-y-0:hover{
    --transform-skew-y: 0;
  }

  .lg\\:hover\\:skew-y-1:hover{
    --transform-skew-y: 1deg;
  }

  .lg\\:hover\\:skew-y-2:hover{
    --transform-skew-y: 2deg;
  }

  .lg\\:hover\\:skew-y-3:hover{
    --transform-skew-y: 3deg;
  }

  .lg\\:hover\\:skew-y-6:hover{
    --transform-skew-y: 6deg;
  }

  .lg\\:hover\\:skew-y-12:hover{
    --transform-skew-y: 12deg;
  }

  .lg\\:hover\\:-skew-y-12:hover{
    --transform-skew-y: -12deg;
  }

  .lg\\:hover\\:-skew-y-6:hover{
    --transform-skew-y: -6deg;
  }

  .lg\\:hover\\:-skew-y-3:hover{
    --transform-skew-y: -3deg;
  }

  .lg\\:hover\\:-skew-y-2:hover{
    --transform-skew-y: -2deg;
  }

  .lg\\:hover\\:-skew-y-1:hover{
    --transform-skew-y: -1deg;
  }

  .lg\\:focus\\:skew-x-0:focus{
    --transform-skew-x: 0;
  }

  .lg\\:focus\\:skew-x-1:focus{
    --transform-skew-x: 1deg;
  }

  .lg\\:focus\\:skew-x-2:focus{
    --transform-skew-x: 2deg;
  }

  .lg\\:focus\\:skew-x-3:focus{
    --transform-skew-x: 3deg;
  }

  .lg\\:focus\\:skew-x-6:focus{
    --transform-skew-x: 6deg;
  }

  .lg\\:focus\\:skew-x-12:focus{
    --transform-skew-x: 12deg;
  }

  .lg\\:focus\\:-skew-x-12:focus{
    --transform-skew-x: -12deg;
  }

  .lg\\:focus\\:-skew-x-6:focus{
    --transform-skew-x: -6deg;
  }

  .lg\\:focus\\:-skew-x-3:focus{
    --transform-skew-x: -3deg;
  }

  .lg\\:focus\\:-skew-x-2:focus{
    --transform-skew-x: -2deg;
  }

  .lg\\:focus\\:-skew-x-1:focus{
    --transform-skew-x: -1deg;
  }

  .lg\\:focus\\:skew-y-0:focus{
    --transform-skew-y: 0;
  }

  .lg\\:focus\\:skew-y-1:focus{
    --transform-skew-y: 1deg;
  }

  .lg\\:focus\\:skew-y-2:focus{
    --transform-skew-y: 2deg;
  }

  .lg\\:focus\\:skew-y-3:focus{
    --transform-skew-y: 3deg;
  }

  .lg\\:focus\\:skew-y-6:focus{
    --transform-skew-y: 6deg;
  }

  .lg\\:focus\\:skew-y-12:focus{
    --transform-skew-y: 12deg;
  }

  .lg\\:focus\\:-skew-y-12:focus{
    --transform-skew-y: -12deg;
  }

  .lg\\:focus\\:-skew-y-6:focus{
    --transform-skew-y: -6deg;
  }

  .lg\\:focus\\:-skew-y-3:focus{
    --transform-skew-y: -3deg;
  }

  .lg\\:focus\\:-skew-y-2:focus{
    --transform-skew-y: -2deg;
  }

  .lg\\:focus\\:-skew-y-1:focus{
    --transform-skew-y: -1deg;
  }

  .lg\\:transition-none{
    transition-property: none;
  }

  .lg\\:transition-all{
    transition-property: all;
  }

  .lg\\:transition{
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  }

  .lg\\:transition-colors{
    transition-property: background-color, border-color, color, fill, stroke;
  }

  .lg\\:transition-opacity{
    transition-property: opacity;
  }

  .lg\\:transition-shadow{
    transition-property: box-shadow;
  }

  .lg\\:transition-transform{
    transition-property: transform;
  }

  .lg\\:ease-linear{
    transition-timing-function: linear;
  }

  .lg\\:ease-in{
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  }

  .lg\\:ease-out{
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }

  .lg\\:ease-in-out{
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }

  .lg\\:duration-75{
    transition-duration: 75ms;
  }

  .lg\\:duration-100{
    transition-duration: 100ms;
  }

  .lg\\:duration-150{
    transition-duration: 150ms;
  }

  .lg\\:duration-200{
    transition-duration: 200ms;
  }

  .lg\\:duration-300{
    transition-duration: 300ms;
  }

  .lg\\:duration-500{
    transition-duration: 500ms;
  }

  .lg\\:duration-700{
    transition-duration: 700ms;
  }

  .lg\\:duration-1000{
    transition-duration: 1000ms;
  }

  .lg\\:delay-75{
    transition-delay: 75ms;
  }

  .lg\\:delay-100{
    transition-delay: 100ms;
  }

  .lg\\:delay-150{
    transition-delay: 150ms;
  }

  .lg\\:delay-200{
    transition-delay: 200ms;
  }

  .lg\\:delay-300{
    transition-delay: 300ms;
  }

  .lg\\:delay-500{
    transition-delay: 500ms;
  }

  .lg\\:delay-700{
    transition-delay: 700ms;
  }

  .lg\\:delay-1000{
    transition-delay: 1000ms;
  }

  .lg\\:animate-none{
    animation: none;
  }

  .lg\\:animate-spin{
    animation: spin 1s linear infinite;
  }

  .lg\\:animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }

  .lg\\:animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  .lg\\:animate-bounce{
    animation: bounce 1s infinite;
  }

  [dir="ltr"] .lg\\:ps-0{
    padding-left: 0;
  }

  [dir="rtl"] .lg\\:ps-0{
    padding-right: 0;
  }

  [dir="ltr"] .lg\\:pe-0{
    padding-right: 0;
  }

  [dir="rtl"] .lg\\:pe-0{
    padding-left: 0;
  }

  [dir="ltr"] .lg\\:ps-1{
    padding-left: 0.25rem;
  }

  [dir="rtl"] .lg\\:ps-1{
    padding-right: 0.25rem;
  }

  [dir="ltr"] .lg\\:pe-1{
    padding-right: 0.25rem;
  }

  [dir="rtl"] .lg\\:pe-1{
    padding-left: 0.25rem;
  }

  [dir="ltr"] .lg\\:ps-2{
    padding-left: 0.5rem;
  }

  [dir="rtl"] .lg\\:ps-2{
    padding-right: 0.5rem;
  }

  [dir="ltr"] .lg\\:pe-2{
    padding-right: 0.5rem;
  }

  [dir="rtl"] .lg\\:pe-2{
    padding-left: 0.5rem;
  }

  [dir="ltr"] .lg\\:ps-3{
    padding-left: 0.75rem;
  }

  [dir="rtl"] .lg\\:ps-3{
    padding-right: 0.75rem;
  }

  [dir="ltr"] .lg\\:pe-3{
    padding-right: 0.75rem;
  }

  [dir="rtl"] .lg\\:pe-3{
    padding-left: 0.75rem;
  }

  [dir="ltr"] .lg\\:ps-4{
    padding-left: 1rem;
  }

  [dir="rtl"] .lg\\:ps-4{
    padding-right: 1rem;
  }

  [dir="ltr"] .lg\\:pe-4{
    padding-right: 1rem;
  }

  [dir="rtl"] .lg\\:pe-4{
    padding-left: 1rem;
  }

  [dir="ltr"] .lg\\:ps-5{
    padding-left: 1.25rem;
  }

  [dir="rtl"] .lg\\:ps-5{
    padding-right: 1.25rem;
  }

  [dir="ltr"] .lg\\:pe-5{
    padding-right: 1.25rem;
  }

  [dir="rtl"] .lg\\:pe-5{
    padding-left: 1.25rem;
  }

  [dir="ltr"] .lg\\:ps-6{
    padding-left: 1.5rem;
  }

  [dir="rtl"] .lg\\:ps-6{
    padding-right: 1.5rem;
  }

  [dir="ltr"] .lg\\:pe-6{
    padding-right: 1.5rem;
  }

  [dir="rtl"] .lg\\:pe-6{
    padding-left: 1.5rem;
  }

  [dir="ltr"] .lg\\:ps-7{
    padding-left: 1.75rem;
  }

  [dir="rtl"] .lg\\:ps-7{
    padding-right: 1.75rem;
  }

  [dir="ltr"] .lg\\:pe-7{
    padding-right: 1.75rem;
  }

  [dir="rtl"] .lg\\:pe-7{
    padding-left: 1.75rem;
  }

  [dir="ltr"] .lg\\:ps-8{
    padding-left: 2rem;
  }

  [dir="rtl"] .lg\\:ps-8{
    padding-right: 2rem;
  }

  [dir="ltr"] .lg\\:pe-8{
    padding-right: 2rem;
  }

  [dir="rtl"] .lg\\:pe-8{
    padding-left: 2rem;
  }

  [dir="ltr"] .lg\\:ps-9{
    padding-left: 2.25rem;
  }

  [dir="rtl"] .lg\\:ps-9{
    padding-right: 2.25rem;
  }

  [dir="ltr"] .lg\\:pe-9{
    padding-right: 2.25rem;
  }

  [dir="rtl"] .lg\\:pe-9{
    padding-left: 2.25rem;
  }

  [dir="ltr"] .lg\\:ps-10{
    padding-left: 2.5rem;
  }

  [dir="rtl"] .lg\\:ps-10{
    padding-right: 2.5rem;
  }

  [dir="ltr"] .lg\\:pe-10{
    padding-right: 2.5rem;
  }

  [dir="rtl"] .lg\\:pe-10{
    padding-left: 2.5rem;
  }

  [dir="ltr"] .lg\\:ps-11{
    padding-left: 2.75rem;
  }

  [dir="rtl"] .lg\\:ps-11{
    padding-right: 2.75rem;
  }

  [dir="ltr"] .lg\\:pe-11{
    padding-right: 2.75rem;
  }

  [dir="rtl"] .lg\\:pe-11{
    padding-left: 2.75rem;
  }

  [dir="ltr"] .lg\\:ps-12{
    padding-left: 3rem;
  }

  [dir="rtl"] .lg\\:ps-12{
    padding-right: 3rem;
  }

  [dir="ltr"] .lg\\:pe-12{
    padding-right: 3rem;
  }

  [dir="rtl"] .lg\\:pe-12{
    padding-left: 3rem;
  }

  [dir="ltr"] .lg\\:ps-14{
    padding-left: 3.5rem;
  }

  [dir="rtl"] .lg\\:ps-14{
    padding-right: 3.5rem;
  }

  [dir="ltr"] .lg\\:pe-14{
    padding-right: 3.5rem;
  }

  [dir="rtl"] .lg\\:pe-14{
    padding-left: 3.5rem;
  }

  [dir="ltr"] .lg\\:ps-15{
    padding-left: 3.75rem;
  }

  [dir="rtl"] .lg\\:ps-15{
    padding-right: 3.75rem;
  }

  [dir="ltr"] .lg\\:pe-15{
    padding-right: 3.75rem;
  }

  [dir="rtl"] .lg\\:pe-15{
    padding-left: 3.75rem;
  }

  [dir="ltr"] .lg\\:ps-16{
    padding-left: 4rem;
  }

  [dir="rtl"] .lg\\:ps-16{
    padding-right: 4rem;
  }

  [dir="ltr"] .lg\\:pe-16{
    padding-right: 4rem;
  }

  [dir="rtl"] .lg\\:pe-16{
    padding-left: 4rem;
  }

  [dir="ltr"] .lg\\:ps-18{
    padding-left: 4.5rem;
  }

  [dir="rtl"] .lg\\:ps-18{
    padding-right: 4.5rem;
  }

  [dir="ltr"] .lg\\:pe-18{
    padding-right: 4.5rem;
  }

  [dir="rtl"] .lg\\:pe-18{
    padding-left: 4.5rem;
  }

  [dir="ltr"] .lg\\:ps-20{
    padding-left: 5rem;
  }

  [dir="rtl"] .lg\\:ps-20{
    padding-right: 5rem;
  }

  [dir="ltr"] .lg\\:pe-20{
    padding-right: 5rem;
  }

  [dir="rtl"] .lg\\:pe-20{
    padding-left: 5rem;
  }

  [dir="ltr"] .lg\\:ps-22{
    padding-left: 5.5rem;
  }

  [dir="rtl"] .lg\\:ps-22{
    padding-right: 5.5rem;
  }

  [dir="ltr"] .lg\\:pe-22{
    padding-right: 5.5rem;
  }

  [dir="rtl"] .lg\\:pe-22{
    padding-left: 5.5rem;
  }

  [dir="ltr"] .lg\\:ps-23{
    padding-left: 5.75rem;
  }

  [dir="rtl"] .lg\\:ps-23{
    padding-right: 5.75rem;
  }

  [dir="ltr"] .lg\\:pe-23{
    padding-right: 5.75rem;
  }

  [dir="rtl"] .lg\\:pe-23{
    padding-left: 5.75rem;
  }

  [dir="ltr"] .lg\\:ps-24{
    padding-left: 6rem;
  }

  [dir="rtl"] .lg\\:ps-24{
    padding-right: 6rem;
  }

  [dir="ltr"] .lg\\:pe-24{
    padding-right: 6rem;
  }

  [dir="rtl"] .lg\\:pe-24{
    padding-left: 6rem;
  }

  [dir="ltr"] .lg\\:ps-25{
    padding-left: 6.25rem;
  }

  [dir="rtl"] .lg\\:ps-25{
    padding-right: 6.25rem;
  }

  [dir="ltr"] .lg\\:pe-25{
    padding-right: 6.25rem;
  }

  [dir="rtl"] .lg\\:pe-25{
    padding-left: 6.25rem;
  }

  [dir="ltr"] .lg\\:ps-26{
    padding-left: 6.5rem;
  }

  [dir="rtl"] .lg\\:ps-26{
    padding-right: 6.5rem;
  }

  [dir="ltr"] .lg\\:pe-26{
    padding-right: 6.5rem;
  }

  [dir="rtl"] .lg\\:pe-26{
    padding-left: 6.5rem;
  }

  [dir="ltr"] .lg\\:ps-28{
    padding-left: 7rem;
  }

  [dir="rtl"] .lg\\:ps-28{
    padding-right: 7rem;
  }

  [dir="ltr"] .lg\\:pe-28{
    padding-right: 7rem;
  }

  [dir="rtl"] .lg\\:pe-28{
    padding-left: 7rem;
  }

  [dir="ltr"] .lg\\:ps-30{
    padding-left: 7.5rem;
  }

  [dir="rtl"] .lg\\:ps-30{
    padding-right: 7.5rem;
  }

  [dir="ltr"] .lg\\:pe-30{
    padding-right: 7.5rem;
  }

  [dir="rtl"] .lg\\:pe-30{
    padding-left: 7.5rem;
  }

  [dir="ltr"] .lg\\:ps-32{
    padding-left: 8rem;
  }

  [dir="rtl"] .lg\\:ps-32{
    padding-right: 8rem;
  }

  [dir="ltr"] .lg\\:pe-32{
    padding-right: 8rem;
  }

  [dir="rtl"] .lg\\:pe-32{
    padding-left: 8rem;
  }

  [dir="ltr"] .lg\\:ps-34{
    padding-left: 8.5rem;
  }

  [dir="rtl"] .lg\\:ps-34{
    padding-right: 8.5rem;
  }

  [dir="ltr"] .lg\\:pe-34{
    padding-right: 8.5rem;
  }

  [dir="rtl"] .lg\\:pe-34{
    padding-left: 8.5rem;
  }

  [dir="ltr"] .lg\\:ps-40{
    padding-left: 10rem;
  }

  [dir="rtl"] .lg\\:ps-40{
    padding-right: 10rem;
  }

  [dir="ltr"] .lg\\:pe-40{
    padding-right: 10rem;
  }

  [dir="rtl"] .lg\\:pe-40{
    padding-left: 10rem;
  }

  [dir="ltr"] .lg\\:ps-42{
    padding-left: 10.5rem;
  }

  [dir="rtl"] .lg\\:ps-42{
    padding-right: 10.5rem;
  }

  [dir="ltr"] .lg\\:pe-42{
    padding-right: 10.5rem;
  }

  [dir="rtl"] .lg\\:pe-42{
    padding-left: 10.5rem;
  }

  [dir="ltr"] .lg\\:ps-44{
    padding-left: 11rem;
  }

  [dir="rtl"] .lg\\:ps-44{
    padding-right: 11rem;
  }

  [dir="ltr"] .lg\\:pe-44{
    padding-right: 11rem;
  }

  [dir="rtl"] .lg\\:pe-44{
    padding-left: 11rem;
  }

  [dir="ltr"] .lg\\:ps-48{
    padding-left: 12rem;
  }

  [dir="rtl"] .lg\\:ps-48{
    padding-right: 12rem;
  }

  [dir="ltr"] .lg\\:pe-48{
    padding-right: 12rem;
  }

  [dir="rtl"] .lg\\:pe-48{
    padding-left: 12rem;
  }

  [dir="ltr"] .lg\\:ps-52{
    padding-left: 13rem;
  }

  [dir="rtl"] .lg\\:ps-52{
    padding-right: 13rem;
  }

  [dir="ltr"] .lg\\:pe-52{
    padding-right: 13rem;
  }

  [dir="rtl"] .lg\\:pe-52{
    padding-left: 13rem;
  }

  [dir="ltr"] .lg\\:ps-54{
    padding-left: 13.5rem;
  }

  [dir="rtl"] .lg\\:ps-54{
    padding-right: 13.5rem;
  }

  [dir="ltr"] .lg\\:pe-54{
    padding-right: 13.5rem;
  }

  [dir="rtl"] .lg\\:pe-54{
    padding-left: 13.5rem;
  }

  [dir="ltr"] .lg\\:ps-56{
    padding-left: 14rem;
  }

  [dir="rtl"] .lg\\:ps-56{
    padding-right: 14rem;
  }

  [dir="ltr"] .lg\\:pe-56{
    padding-right: 14rem;
  }

  [dir="rtl"] .lg\\:pe-56{
    padding-left: 14rem;
  }

  [dir="ltr"] .lg\\:ps-60{
    padding-left: 15rem;
  }

  [dir="rtl"] .lg\\:ps-60{
    padding-right: 15rem;
  }

  [dir="ltr"] .lg\\:pe-60{
    padding-right: 15rem;
  }

  [dir="rtl"] .lg\\:pe-60{
    padding-left: 15rem;
  }

  [dir="ltr"] .lg\\:ps-64{
    padding-left: 16rem;
  }

  [dir="rtl"] .lg\\:ps-64{
    padding-right: 16rem;
  }

  [dir="ltr"] .lg\\:pe-64{
    padding-right: 16rem;
  }

  [dir="rtl"] .lg\\:pe-64{
    padding-left: 16rem;
  }

  [dir="ltr"] .lg\\:ps-68{
    padding-left: 17rem;
  }

  [dir="rtl"] .lg\\:ps-68{
    padding-right: 17rem;
  }

  [dir="ltr"] .lg\\:pe-68{
    padding-right: 17rem;
  }

  [dir="rtl"] .lg\\:pe-68{
    padding-left: 17rem;
  }

  [dir="ltr"] .lg\\:ps-72{
    padding-left: 18rem;
  }

  [dir="rtl"] .lg\\:ps-72{
    padding-right: 18rem;
  }

  [dir="ltr"] .lg\\:pe-72{
    padding-right: 18rem;
  }

  [dir="rtl"] .lg\\:pe-72{
    padding-left: 18rem;
  }

  [dir="ltr"] .lg\\:ps-74{
    padding-left: 18.5rem;
  }

  [dir="rtl"] .lg\\:ps-74{
    padding-right: 18.5rem;
  }

  [dir="ltr"] .lg\\:pe-74{
    padding-right: 18.5rem;
  }

  [dir="rtl"] .lg\\:pe-74{
    padding-left: 18.5rem;
  }

  [dir="ltr"] .lg\\:ps-76{
    padding-left: 19rem;
  }

  [dir="rtl"] .lg\\:ps-76{
    padding-right: 19rem;
  }

  [dir="ltr"] .lg\\:pe-76{
    padding-right: 19rem;
  }

  [dir="rtl"] .lg\\:pe-76{
    padding-left: 19rem;
  }

  [dir="ltr"] .lg\\:ps-78{
    padding-left: 19.5rem;
  }

  [dir="rtl"] .lg\\:ps-78{
    padding-right: 19.5rem;
  }

  [dir="ltr"] .lg\\:pe-78{
    padding-right: 19.5rem;
  }

  [dir="rtl"] .lg\\:pe-78{
    padding-left: 19.5rem;
  }

  [dir="ltr"] .lg\\:ps-80{
    padding-left: 20rem;
  }

  [dir="rtl"] .lg\\:ps-80{
    padding-right: 20rem;
  }

  [dir="ltr"] .lg\\:pe-80{
    padding-right: 20rem;
  }

  [dir="rtl"] .lg\\:pe-80{
    padding-left: 20rem;
  }

  [dir="ltr"] .lg\\:ps-82{
    padding-left: 20.5rem;
  }

  [dir="rtl"] .lg\\:ps-82{
    padding-right: 20.5rem;
  }

  [dir="ltr"] .lg\\:pe-82{
    padding-right: 20.5rem;
  }

  [dir="rtl"] .lg\\:pe-82{
    padding-left: 20.5rem;
  }

  [dir="ltr"] .lg\\:ps-84{
    padding-left: 21rem;
  }

  [dir="rtl"] .lg\\:ps-84{
    padding-right: 21rem;
  }

  [dir="ltr"] .lg\\:pe-84{
    padding-right: 21rem;
  }

  [dir="rtl"] .lg\\:pe-84{
    padding-left: 21rem;
  }

  [dir="ltr"] .lg\\:ps-88{
    padding-left: 22rem;
  }

  [dir="rtl"] .lg\\:ps-88{
    padding-right: 22rem;
  }

  [dir="ltr"] .lg\\:pe-88{
    padding-right: 22rem;
  }

  [dir="rtl"] .lg\\:pe-88{
    padding-left: 22rem;
  }

  [dir="ltr"] .lg\\:ps-92{
    padding-left: 23rem;
  }

  [dir="rtl"] .lg\\:ps-92{
    padding-right: 23rem;
  }

  [dir="ltr"] .lg\\:pe-92{
    padding-right: 23rem;
  }

  [dir="rtl"] .lg\\:pe-92{
    padding-left: 23rem;
  }

  [dir="ltr"] .lg\\:ps-96{
    padding-left: 24rem;
  }

  [dir="rtl"] .lg\\:ps-96{
    padding-right: 24rem;
  }

  [dir="ltr"] .lg\\:pe-96{
    padding-right: 24rem;
  }

  [dir="rtl"] .lg\\:pe-96{
    padding-left: 24rem;
  }

  [dir="ltr"] .lg\\:ps-98{
    padding-left: 24.5rem;
  }

  [dir="rtl"] .lg\\:ps-98{
    padding-right: 24.5rem;
  }

  [dir="ltr"] .lg\\:pe-98{
    padding-right: 24.5rem;
  }

  [dir="rtl"] .lg\\:pe-98{
    padding-left: 24.5rem;
  }

  [dir="ltr"] .lg\\:ps-100{
    padding-left: 25rem;
  }

  [dir="rtl"] .lg\\:ps-100{
    padding-right: 25rem;
  }

  [dir="ltr"] .lg\\:pe-100{
    padding-right: 25rem;
  }

  [dir="rtl"] .lg\\:pe-100{
    padding-left: 25rem;
  }

  [dir="ltr"] .lg\\:ps-104{
    padding-left: 26rem;
  }

  [dir="rtl"] .lg\\:ps-104{
    padding-right: 26rem;
  }

  [dir="ltr"] .lg\\:pe-104{
    padding-right: 26rem;
  }

  [dir="rtl"] .lg\\:pe-104{
    padding-left: 26rem;
  }

  [dir="ltr"] .lg\\:ps-112{
    padding-left: 28rem;
  }

  [dir="rtl"] .lg\\:ps-112{
    padding-right: 28rem;
  }

  [dir="ltr"] .lg\\:pe-112{
    padding-right: 28rem;
  }

  [dir="rtl"] .lg\\:pe-112{
    padding-left: 28rem;
  }

  [dir="ltr"] .lg\\:ps-124{
    padding-left: 31rem;
  }

  [dir="rtl"] .lg\\:ps-124{
    padding-right: 31rem;
  }

  [dir="ltr"] .lg\\:pe-124{
    padding-right: 31rem;
  }

  [dir="rtl"] .lg\\:pe-124{
    padding-left: 31rem;
  }

  [dir="ltr"] .lg\\:ps-128{
    padding-left: 32rem;
  }

  [dir="rtl"] .lg\\:ps-128{
    padding-right: 32rem;
  }

  [dir="ltr"] .lg\\:pe-128{
    padding-right: 32rem;
  }

  [dir="rtl"] .lg\\:pe-128{
    padding-left: 32rem;
  }

  [dir="ltr"] .lg\\:ps-140{
    padding-left: 35rem;
  }

  [dir="rtl"] .lg\\:ps-140{
    padding-right: 35rem;
  }

  [dir="ltr"] .lg\\:pe-140{
    padding-right: 35rem;
  }

  [dir="rtl"] .lg\\:pe-140{
    padding-left: 35rem;
  }

  [dir="ltr"] .lg\\:ps-152{
    padding-left: 38rem;
  }

  [dir="rtl"] .lg\\:ps-152{
    padding-right: 38rem;
  }

  [dir="ltr"] .lg\\:pe-152{
    padding-right: 38rem;
  }

  [dir="rtl"] .lg\\:pe-152{
    padding-left: 38rem;
  }

  [dir="ltr"] .lg\\:ps-160{
    padding-left: 40rem;
  }

  [dir="rtl"] .lg\\:ps-160{
    padding-right: 40rem;
  }

  [dir="ltr"] .lg\\:pe-160{
    padding-right: 40rem;
  }

  [dir="rtl"] .lg\\:pe-160{
    padding-left: 40rem;
  }

  [dir="ltr"] .lg\\:ps-162{
    padding-left: 41rem;
  }

  [dir="rtl"] .lg\\:ps-162{
    padding-right: 41rem;
  }

  [dir="ltr"] .lg\\:pe-162{
    padding-right: 41rem;
  }

  [dir="rtl"] .lg\\:pe-162{
    padding-left: 41rem;
  }

  [dir="ltr"] .lg\\:ps-192{
    padding-left: 48rem;
  }

  [dir="rtl"] .lg\\:ps-192{
    padding-right: 48rem;
  }

  [dir="ltr"] .lg\\:pe-192{
    padding-right: 48rem;
  }

  [dir="rtl"] .lg\\:pe-192{
    padding-left: 48rem;
  }

  [dir="ltr"] .lg\\:ps-208{
    padding-left: 52rem;
  }

  [dir="rtl"] .lg\\:ps-208{
    padding-right: 52rem;
  }

  [dir="ltr"] .lg\\:pe-208{
    padding-right: 52rem;
  }

  [dir="rtl"] .lg\\:pe-208{
    padding-left: 52rem;
  }

  [dir="ltr"] .lg\\:ps-224{
    padding-left: 56rem;
  }

  [dir="rtl"] .lg\\:ps-224{
    padding-right: 56rem;
  }

  [dir="ltr"] .lg\\:pe-224{
    padding-right: 56rem;
  }

  [dir="rtl"] .lg\\:pe-224{
    padding-left: 56rem;
  }

  [dir="ltr"] .lg\\:ps-256{
    padding-left: 64rem;
  }

  [dir="rtl"] .lg\\:ps-256{
    padding-right: 64rem;
  }

  [dir="ltr"] .lg\\:pe-256{
    padding-right: 64rem;
  }

  [dir="rtl"] .lg\\:pe-256{
    padding-left: 64rem;
  }

  [dir="ltr"] .lg\\:ps-px{
    padding-left: 1px;
  }

  [dir="rtl"] .lg\\:ps-px{
    padding-right: 1px;
  }

  [dir="ltr"] .lg\\:pe-px{
    padding-right: 1px;
  }

  [dir="rtl"] .lg\\:pe-px{
    padding-left: 1px;
  }

  [dir="ltr"] .lg\\:odd\\:ps-0:nth-child(odd){
    padding-left: 0;
  }

  [dir="rtl"] .lg\\:odd\\:ps-0:nth-child(odd){
    padding-right: 0;
  }

  [dir="ltr"] .lg\\:odd\\:pe-0:nth-child(odd){
    padding-right: 0;
  }

  [dir="rtl"] .lg\\:odd\\:pe-0:nth-child(odd){
    padding-left: 0;
  }

  [dir="ltr"] .lg\\:odd\\:ps-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-4:nth-child(odd){
    padding-left: 1rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-4:nth-child(odd){
    padding-right: 1rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-4:nth-child(odd){
    padding-right: 1rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-4:nth-child(odd){
    padding-left: 1rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-8:nth-child(odd){
    padding-left: 2rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-8:nth-child(odd){
    padding-right: 2rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-8:nth-child(odd){
    padding-right: 2rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-8:nth-child(odd){
    padding-left: 2rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-12:nth-child(odd){
    padding-left: 3rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-12:nth-child(odd){
    padding-right: 3rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-12:nth-child(odd){
    padding-right: 3rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-12:nth-child(odd){
    padding-left: 3rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-16:nth-child(odd){
    padding-left: 4rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-16:nth-child(odd){
    padding-right: 4rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-16:nth-child(odd){
    padding-right: 4rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-16:nth-child(odd){
    padding-left: 4rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-20:nth-child(odd){
    padding-left: 5rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-20:nth-child(odd){
    padding-right: 5rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-20:nth-child(odd){
    padding-right: 5rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-20:nth-child(odd){
    padding-left: 5rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-24:nth-child(odd){
    padding-left: 6rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-24:nth-child(odd){
    padding-right: 6rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-24:nth-child(odd){
    padding-right: 6rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-24:nth-child(odd){
    padding-left: 6rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-28:nth-child(odd){
    padding-left: 7rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-28:nth-child(odd){
    padding-right: 7rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-28:nth-child(odd){
    padding-right: 7rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-28:nth-child(odd){
    padding-left: 7rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-32:nth-child(odd){
    padding-left: 8rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-32:nth-child(odd){
    padding-right: 8rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-32:nth-child(odd){
    padding-right: 8rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-32:nth-child(odd){
    padding-left: 8rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-40:nth-child(odd){
    padding-left: 10rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-40:nth-child(odd){
    padding-right: 10rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-40:nth-child(odd){
    padding-right: 10rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-40:nth-child(odd){
    padding-left: 10rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-44:nth-child(odd){
    padding-left: 11rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-44:nth-child(odd){
    padding-right: 11rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-44:nth-child(odd){
    padding-right: 11rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-44:nth-child(odd){
    padding-left: 11rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-48:nth-child(odd){
    padding-left: 12rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-48:nth-child(odd){
    padding-right: 12rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-48:nth-child(odd){
    padding-right: 12rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-48:nth-child(odd){
    padding-left: 12rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-52:nth-child(odd){
    padding-left: 13rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-52:nth-child(odd){
    padding-right: 13rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-52:nth-child(odd){
    padding-right: 13rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-52:nth-child(odd){
    padding-left: 13rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-56:nth-child(odd){
    padding-left: 14rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-56:nth-child(odd){
    padding-right: 14rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-56:nth-child(odd){
    padding-right: 14rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-56:nth-child(odd){
    padding-left: 14rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-60:nth-child(odd){
    padding-left: 15rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-60:nth-child(odd){
    padding-right: 15rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-60:nth-child(odd){
    padding-right: 15rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-60:nth-child(odd){
    padding-left: 15rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-64:nth-child(odd){
    padding-left: 16rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-64:nth-child(odd){
    padding-right: 16rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-64:nth-child(odd){
    padding-right: 16rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-64:nth-child(odd){
    padding-left: 16rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-68:nth-child(odd){
    padding-left: 17rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-68:nth-child(odd){
    padding-right: 17rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-68:nth-child(odd){
    padding-right: 17rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-68:nth-child(odd){
    padding-left: 17rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-72:nth-child(odd){
    padding-left: 18rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-72:nth-child(odd){
    padding-right: 18rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-72:nth-child(odd){
    padding-right: 18rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-72:nth-child(odd){
    padding-left: 18rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-76:nth-child(odd){
    padding-left: 19rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-76:nth-child(odd){
    padding-right: 19rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-76:nth-child(odd){
    padding-right: 19rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-76:nth-child(odd){
    padding-left: 19rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-80:nth-child(odd){
    padding-left: 20rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-80:nth-child(odd){
    padding-right: 20rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-80:nth-child(odd){
    padding-right: 20rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-80:nth-child(odd){
    padding-left: 20rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-84:nth-child(odd){
    padding-left: 21rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-84:nth-child(odd){
    padding-right: 21rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-84:nth-child(odd){
    padding-right: 21rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-84:nth-child(odd){
    padding-left: 21rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-88:nth-child(odd){
    padding-left: 22rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-88:nth-child(odd){
    padding-right: 22rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-88:nth-child(odd){
    padding-right: 22rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-88:nth-child(odd){
    padding-left: 22rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-92:nth-child(odd){
    padding-left: 23rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-92:nth-child(odd){
    padding-right: 23rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-92:nth-child(odd){
    padding-right: 23rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-92:nth-child(odd){
    padding-left: 23rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-96:nth-child(odd){
    padding-left: 24rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-96:nth-child(odd){
    padding-right: 24rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-96:nth-child(odd){
    padding-right: 24rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-96:nth-child(odd){
    padding-left: 24rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-100:nth-child(odd){
    padding-left: 25rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-100:nth-child(odd){
    padding-right: 25rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-100:nth-child(odd){
    padding-right: 25rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-100:nth-child(odd){
    padding-left: 25rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-104:nth-child(odd){
    padding-left: 26rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-104:nth-child(odd){
    padding-right: 26rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-104:nth-child(odd){
    padding-right: 26rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-104:nth-child(odd){
    padding-left: 26rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-112:nth-child(odd){
    padding-left: 28rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-112:nth-child(odd){
    padding-right: 28rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-112:nth-child(odd){
    padding-right: 28rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-112:nth-child(odd){
    padding-left: 28rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-124:nth-child(odd){
    padding-left: 31rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-124:nth-child(odd){
    padding-right: 31rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-124:nth-child(odd){
    padding-right: 31rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-124:nth-child(odd){
    padding-left: 31rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-128:nth-child(odd){
    padding-left: 32rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-128:nth-child(odd){
    padding-right: 32rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-128:nth-child(odd){
    padding-right: 32rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-128:nth-child(odd){
    padding-left: 32rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-140:nth-child(odd){
    padding-left: 35rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-140:nth-child(odd){
    padding-right: 35rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-140:nth-child(odd){
    padding-right: 35rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-140:nth-child(odd){
    padding-left: 35rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-152:nth-child(odd){
    padding-left: 38rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-152:nth-child(odd){
    padding-right: 38rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-152:nth-child(odd){
    padding-right: 38rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-152:nth-child(odd){
    padding-left: 38rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-160:nth-child(odd){
    padding-left: 40rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-160:nth-child(odd){
    padding-right: 40rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-160:nth-child(odd){
    padding-right: 40rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-160:nth-child(odd){
    padding-left: 40rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-162:nth-child(odd){
    padding-left: 41rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-162:nth-child(odd){
    padding-right: 41rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-162:nth-child(odd){
    padding-right: 41rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-162:nth-child(odd){
    padding-left: 41rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-192:nth-child(odd){
    padding-left: 48rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-192:nth-child(odd){
    padding-right: 48rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-192:nth-child(odd){
    padding-right: 48rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-192:nth-child(odd){
    padding-left: 48rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-208:nth-child(odd){
    padding-left: 52rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-208:nth-child(odd){
    padding-right: 52rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-208:nth-child(odd){
    padding-right: 52rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-208:nth-child(odd){
    padding-left: 52rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-224:nth-child(odd){
    padding-left: 56rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-224:nth-child(odd){
    padding-right: 56rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-224:nth-child(odd){
    padding-right: 56rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-224:nth-child(odd){
    padding-left: 56rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-256:nth-child(odd){
    padding-left: 64rem;
  }

  [dir="rtl"] .lg\\:odd\\:ps-256:nth-child(odd){
    padding-right: 64rem;
  }

  [dir="ltr"] .lg\\:odd\\:pe-256:nth-child(odd){
    padding-right: 64rem;
  }

  [dir="rtl"] .lg\\:odd\\:pe-256:nth-child(odd){
    padding-left: 64rem;
  }

  [dir="ltr"] .lg\\:odd\\:ps-px:nth-child(odd){
    padding-left: 1px;
  }

  [dir="rtl"] .lg\\:odd\\:ps-px:nth-child(odd){
    padding-right: 1px;
  }

  [dir="ltr"] .lg\\:odd\\:pe-px:nth-child(odd){
    padding-right: 1px;
  }

  [dir="rtl"] .lg\\:odd\\:pe-px:nth-child(odd){
    padding-left: 1px;
  }

  [dir="ltr"] .lg\\:even\\:ps-0:nth-child(even){
    padding-left: 0;
  }

  [dir="rtl"] .lg\\:even\\:ps-0:nth-child(even){
    padding-right: 0;
  }

  [dir="ltr"] .lg\\:even\\:pe-0:nth-child(even){
    padding-right: 0;
  }

  [dir="rtl"] .lg\\:even\\:pe-0:nth-child(even){
    padding-left: 0;
  }

  [dir="ltr"] .lg\\:even\\:ps-1:nth-child(even){
    padding-left: 0.25rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-1:nth-child(even){
    padding-right: 0.25rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-1:nth-child(even){
    padding-right: 0.25rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-1:nth-child(even){
    padding-left: 0.25rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-2:nth-child(even){
    padding-left: 0.5rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-2:nth-child(even){
    padding-right: 0.5rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-2:nth-child(even){
    padding-right: 0.5rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-2:nth-child(even){
    padding-left: 0.5rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-3:nth-child(even){
    padding-left: 0.75rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-3:nth-child(even){
    padding-right: 0.75rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-3:nth-child(even){
    padding-right: 0.75rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-3:nth-child(even){
    padding-left: 0.75rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-4:nth-child(even){
    padding-left: 1rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-4:nth-child(even){
    padding-right: 1rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-4:nth-child(even){
    padding-right: 1rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-4:nth-child(even){
    padding-left: 1rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-5:nth-child(even){
    padding-left: 1.25rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-5:nth-child(even){
    padding-right: 1.25rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-5:nth-child(even){
    padding-right: 1.25rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-5:nth-child(even){
    padding-left: 1.25rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-6:nth-child(even){
    padding-left: 1.5rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-6:nth-child(even){
    padding-right: 1.5rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-6:nth-child(even){
    padding-right: 1.5rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-6:nth-child(even){
    padding-left: 1.5rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-7:nth-child(even){
    padding-left: 1.75rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-7:nth-child(even){
    padding-right: 1.75rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-7:nth-child(even){
    padding-right: 1.75rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-7:nth-child(even){
    padding-left: 1.75rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-8:nth-child(even){
    padding-left: 2rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-8:nth-child(even){
    padding-right: 2rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-8:nth-child(even){
    padding-right: 2rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-8:nth-child(even){
    padding-left: 2rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-9:nth-child(even){
    padding-left: 2.25rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-9:nth-child(even){
    padding-right: 2.25rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-9:nth-child(even){
    padding-right: 2.25rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-9:nth-child(even){
    padding-left: 2.25rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-10:nth-child(even){
    padding-left: 2.5rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-10:nth-child(even){
    padding-right: 2.5rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-10:nth-child(even){
    padding-right: 2.5rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-10:nth-child(even){
    padding-left: 2.5rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-11:nth-child(even){
    padding-left: 2.75rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-11:nth-child(even){
    padding-right: 2.75rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-11:nth-child(even){
    padding-right: 2.75rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-11:nth-child(even){
    padding-left: 2.75rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-12:nth-child(even){
    padding-left: 3rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-12:nth-child(even){
    padding-right: 3rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-12:nth-child(even){
    padding-right: 3rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-12:nth-child(even){
    padding-left: 3rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-14:nth-child(even){
    padding-left: 3.5rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-14:nth-child(even){
    padding-right: 3.5rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-14:nth-child(even){
    padding-right: 3.5rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-14:nth-child(even){
    padding-left: 3.5rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-15:nth-child(even){
    padding-left: 3.75rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-15:nth-child(even){
    padding-right: 3.75rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-15:nth-child(even){
    padding-right: 3.75rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-15:nth-child(even){
    padding-left: 3.75rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-16:nth-child(even){
    padding-left: 4rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-16:nth-child(even){
    padding-right: 4rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-16:nth-child(even){
    padding-right: 4rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-16:nth-child(even){
    padding-left: 4rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-18:nth-child(even){
    padding-left: 4.5rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-18:nth-child(even){
    padding-right: 4.5rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-18:nth-child(even){
    padding-right: 4.5rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-18:nth-child(even){
    padding-left: 4.5rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-20:nth-child(even){
    padding-left: 5rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-20:nth-child(even){
    padding-right: 5rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-20:nth-child(even){
    padding-right: 5rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-20:nth-child(even){
    padding-left: 5rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-22:nth-child(even){
    padding-left: 5.5rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-22:nth-child(even){
    padding-right: 5.5rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-22:nth-child(even){
    padding-right: 5.5rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-22:nth-child(even){
    padding-left: 5.5rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-23:nth-child(even){
    padding-left: 5.75rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-23:nth-child(even){
    padding-right: 5.75rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-23:nth-child(even){
    padding-right: 5.75rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-23:nth-child(even){
    padding-left: 5.75rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-24:nth-child(even){
    padding-left: 6rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-24:nth-child(even){
    padding-right: 6rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-24:nth-child(even){
    padding-right: 6rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-24:nth-child(even){
    padding-left: 6rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-25:nth-child(even){
    padding-left: 6.25rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-25:nth-child(even){
    padding-right: 6.25rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-25:nth-child(even){
    padding-right: 6.25rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-25:nth-child(even){
    padding-left: 6.25rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-26:nth-child(even){
    padding-left: 6.5rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-26:nth-child(even){
    padding-right: 6.5rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-26:nth-child(even){
    padding-right: 6.5rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-26:nth-child(even){
    padding-left: 6.5rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-28:nth-child(even){
    padding-left: 7rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-28:nth-child(even){
    padding-right: 7rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-28:nth-child(even){
    padding-right: 7rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-28:nth-child(even){
    padding-left: 7rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-30:nth-child(even){
    padding-left: 7.5rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-30:nth-child(even){
    padding-right: 7.5rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-30:nth-child(even){
    padding-right: 7.5rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-30:nth-child(even){
    padding-left: 7.5rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-32:nth-child(even){
    padding-left: 8rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-32:nth-child(even){
    padding-right: 8rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-32:nth-child(even){
    padding-right: 8rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-32:nth-child(even){
    padding-left: 8rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-34:nth-child(even){
    padding-left: 8.5rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-34:nth-child(even){
    padding-right: 8.5rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-34:nth-child(even){
    padding-right: 8.5rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-34:nth-child(even){
    padding-left: 8.5rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-40:nth-child(even){
    padding-left: 10rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-40:nth-child(even){
    padding-right: 10rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-40:nth-child(even){
    padding-right: 10rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-40:nth-child(even){
    padding-left: 10rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-42:nth-child(even){
    padding-left: 10.5rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-42:nth-child(even){
    padding-right: 10.5rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-42:nth-child(even){
    padding-right: 10.5rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-42:nth-child(even){
    padding-left: 10.5rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-44:nth-child(even){
    padding-left: 11rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-44:nth-child(even){
    padding-right: 11rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-44:nth-child(even){
    padding-right: 11rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-44:nth-child(even){
    padding-left: 11rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-48:nth-child(even){
    padding-left: 12rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-48:nth-child(even){
    padding-right: 12rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-48:nth-child(even){
    padding-right: 12rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-48:nth-child(even){
    padding-left: 12rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-52:nth-child(even){
    padding-left: 13rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-52:nth-child(even){
    padding-right: 13rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-52:nth-child(even){
    padding-right: 13rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-52:nth-child(even){
    padding-left: 13rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-54:nth-child(even){
    padding-left: 13.5rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-54:nth-child(even){
    padding-right: 13.5rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-54:nth-child(even){
    padding-right: 13.5rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-54:nth-child(even){
    padding-left: 13.5rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-56:nth-child(even){
    padding-left: 14rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-56:nth-child(even){
    padding-right: 14rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-56:nth-child(even){
    padding-right: 14rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-56:nth-child(even){
    padding-left: 14rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-60:nth-child(even){
    padding-left: 15rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-60:nth-child(even){
    padding-right: 15rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-60:nth-child(even){
    padding-right: 15rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-60:nth-child(even){
    padding-left: 15rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-64:nth-child(even){
    padding-left: 16rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-64:nth-child(even){
    padding-right: 16rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-64:nth-child(even){
    padding-right: 16rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-64:nth-child(even){
    padding-left: 16rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-68:nth-child(even){
    padding-left: 17rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-68:nth-child(even){
    padding-right: 17rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-68:nth-child(even){
    padding-right: 17rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-68:nth-child(even){
    padding-left: 17rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-72:nth-child(even){
    padding-left: 18rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-72:nth-child(even){
    padding-right: 18rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-72:nth-child(even){
    padding-right: 18rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-72:nth-child(even){
    padding-left: 18rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-74:nth-child(even){
    padding-left: 18.5rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-74:nth-child(even){
    padding-right: 18.5rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-74:nth-child(even){
    padding-right: 18.5rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-74:nth-child(even){
    padding-left: 18.5rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-76:nth-child(even){
    padding-left: 19rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-76:nth-child(even){
    padding-right: 19rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-76:nth-child(even){
    padding-right: 19rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-76:nth-child(even){
    padding-left: 19rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-78:nth-child(even){
    padding-left: 19.5rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-78:nth-child(even){
    padding-right: 19.5rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-78:nth-child(even){
    padding-right: 19.5rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-78:nth-child(even){
    padding-left: 19.5rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-80:nth-child(even){
    padding-left: 20rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-80:nth-child(even){
    padding-right: 20rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-80:nth-child(even){
    padding-right: 20rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-80:nth-child(even){
    padding-left: 20rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-82:nth-child(even){
    padding-left: 20.5rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-82:nth-child(even){
    padding-right: 20.5rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-82:nth-child(even){
    padding-right: 20.5rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-82:nth-child(even){
    padding-left: 20.5rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-84:nth-child(even){
    padding-left: 21rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-84:nth-child(even){
    padding-right: 21rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-84:nth-child(even){
    padding-right: 21rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-84:nth-child(even){
    padding-left: 21rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-88:nth-child(even){
    padding-left: 22rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-88:nth-child(even){
    padding-right: 22rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-88:nth-child(even){
    padding-right: 22rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-88:nth-child(even){
    padding-left: 22rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-92:nth-child(even){
    padding-left: 23rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-92:nth-child(even){
    padding-right: 23rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-92:nth-child(even){
    padding-right: 23rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-92:nth-child(even){
    padding-left: 23rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-96:nth-child(even){
    padding-left: 24rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-96:nth-child(even){
    padding-right: 24rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-96:nth-child(even){
    padding-right: 24rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-96:nth-child(even){
    padding-left: 24rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-98:nth-child(even){
    padding-left: 24.5rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-98:nth-child(even){
    padding-right: 24.5rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-98:nth-child(even){
    padding-right: 24.5rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-98:nth-child(even){
    padding-left: 24.5rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-100:nth-child(even){
    padding-left: 25rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-100:nth-child(even){
    padding-right: 25rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-100:nth-child(even){
    padding-right: 25rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-100:nth-child(even){
    padding-left: 25rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-104:nth-child(even){
    padding-left: 26rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-104:nth-child(even){
    padding-right: 26rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-104:nth-child(even){
    padding-right: 26rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-104:nth-child(even){
    padding-left: 26rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-112:nth-child(even){
    padding-left: 28rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-112:nth-child(even){
    padding-right: 28rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-112:nth-child(even){
    padding-right: 28rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-112:nth-child(even){
    padding-left: 28rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-124:nth-child(even){
    padding-left: 31rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-124:nth-child(even){
    padding-right: 31rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-124:nth-child(even){
    padding-right: 31rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-124:nth-child(even){
    padding-left: 31rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-128:nth-child(even){
    padding-left: 32rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-128:nth-child(even){
    padding-right: 32rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-128:nth-child(even){
    padding-right: 32rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-128:nth-child(even){
    padding-left: 32rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-140:nth-child(even){
    padding-left: 35rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-140:nth-child(even){
    padding-right: 35rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-140:nth-child(even){
    padding-right: 35rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-140:nth-child(even){
    padding-left: 35rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-152:nth-child(even){
    padding-left: 38rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-152:nth-child(even){
    padding-right: 38rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-152:nth-child(even){
    padding-right: 38rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-152:nth-child(even){
    padding-left: 38rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-160:nth-child(even){
    padding-left: 40rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-160:nth-child(even){
    padding-right: 40rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-160:nth-child(even){
    padding-right: 40rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-160:nth-child(even){
    padding-left: 40rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-162:nth-child(even){
    padding-left: 41rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-162:nth-child(even){
    padding-right: 41rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-162:nth-child(even){
    padding-right: 41rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-162:nth-child(even){
    padding-left: 41rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-192:nth-child(even){
    padding-left: 48rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-192:nth-child(even){
    padding-right: 48rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-192:nth-child(even){
    padding-right: 48rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-192:nth-child(even){
    padding-left: 48rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-208:nth-child(even){
    padding-left: 52rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-208:nth-child(even){
    padding-right: 52rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-208:nth-child(even){
    padding-right: 52rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-208:nth-child(even){
    padding-left: 52rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-224:nth-child(even){
    padding-left: 56rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-224:nth-child(even){
    padding-right: 56rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-224:nth-child(even){
    padding-right: 56rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-224:nth-child(even){
    padding-left: 56rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-256:nth-child(even){
    padding-left: 64rem;
  }

  [dir="rtl"] .lg\\:even\\:ps-256:nth-child(even){
    padding-right: 64rem;
  }

  [dir="ltr"] .lg\\:even\\:pe-256:nth-child(even){
    padding-right: 64rem;
  }

  [dir="rtl"] .lg\\:even\\:pe-256:nth-child(even){
    padding-left: 64rem;
  }

  [dir="ltr"] .lg\\:even\\:ps-px:nth-child(even){
    padding-left: 1px;
  }

  [dir="rtl"] .lg\\:even\\:ps-px:nth-child(even){
    padding-right: 1px;
  }

  [dir="ltr"] .lg\\:even\\:pe-px:nth-child(even){
    padding-right: 1px;
  }

  [dir="rtl"] .lg\\:even\\:pe-px:nth-child(even){
    padding-left: 1px;
  }

  [dir="ltr"] .lg\\:ms-0{
    margin-left: 0;
  }

  [dir="rtl"] .lg\\:ms-0{
    margin-right: 0;
  }

  [dir="ltr"] .lg\\:me-0{
    margin-right: 0;
  }

  [dir="rtl"] .lg\\:me-0{
    margin-left: 0;
  }

  [dir="ltr"] .lg\\:ms-1{
    margin-left: 0.25rem;
  }

  [dir="rtl"] .lg\\:ms-1{
    margin-right: 0.25rem;
  }

  [dir="ltr"] .lg\\:me-1{
    margin-right: 0.25rem;
  }

  [dir="rtl"] .lg\\:me-1{
    margin-left: 0.25rem;
  }

  [dir="ltr"] .lg\\:ms-2{
    margin-left: 0.5rem;
  }

  [dir="rtl"] .lg\\:ms-2{
    margin-right: 0.5rem;
  }

  [dir="ltr"] .lg\\:me-2{
    margin-right: 0.5rem;
  }

  [dir="rtl"] .lg\\:me-2{
    margin-left: 0.5rem;
  }

  [dir="ltr"] .lg\\:ms-3{
    margin-left: 0.75rem;
  }

  [dir="rtl"] .lg\\:ms-3{
    margin-right: 0.75rem;
  }

  [dir="ltr"] .lg\\:me-3{
    margin-right: 0.75rem;
  }

  [dir="rtl"] .lg\\:me-3{
    margin-left: 0.75rem;
  }

  [dir="ltr"] .lg\\:ms-4{
    margin-left: 1rem;
  }

  [dir="rtl"] .lg\\:ms-4{
    margin-right: 1rem;
  }

  [dir="ltr"] .lg\\:me-4{
    margin-right: 1rem;
  }

  [dir="rtl"] .lg\\:me-4{
    margin-left: 1rem;
  }

  [dir="ltr"] .lg\\:ms-5{
    margin-left: 1.25rem;
  }

  [dir="rtl"] .lg\\:ms-5{
    margin-right: 1.25rem;
  }

  [dir="ltr"] .lg\\:me-5{
    margin-right: 1.25rem;
  }

  [dir="rtl"] .lg\\:me-5{
    margin-left: 1.25rem;
  }

  [dir="ltr"] .lg\\:ms-6{
    margin-left: 1.5rem;
  }

  [dir="rtl"] .lg\\:ms-6{
    margin-right: 1.5rem;
  }

  [dir="ltr"] .lg\\:me-6{
    margin-right: 1.5rem;
  }

  [dir="rtl"] .lg\\:me-6{
    margin-left: 1.5rem;
  }

  [dir="ltr"] .lg\\:ms-7{
    margin-left: 1.75rem;
  }

  [dir="rtl"] .lg\\:ms-7{
    margin-right: 1.75rem;
  }

  [dir="ltr"] .lg\\:me-7{
    margin-right: 1.75rem;
  }

  [dir="rtl"] .lg\\:me-7{
    margin-left: 1.75rem;
  }

  [dir="ltr"] .lg\\:ms-8{
    margin-left: 2rem;
  }

  [dir="rtl"] .lg\\:ms-8{
    margin-right: 2rem;
  }

  [dir="ltr"] .lg\\:me-8{
    margin-right: 2rem;
  }

  [dir="rtl"] .lg\\:me-8{
    margin-left: 2rem;
  }

  [dir="ltr"] .lg\\:ms-9{
    margin-left: 2.25rem;
  }

  [dir="rtl"] .lg\\:ms-9{
    margin-right: 2.25rem;
  }

  [dir="ltr"] .lg\\:me-9{
    margin-right: 2.25rem;
  }

  [dir="rtl"] .lg\\:me-9{
    margin-left: 2.25rem;
  }

  [dir="ltr"] .lg\\:ms-10{
    margin-left: 2.5rem;
  }

  [dir="rtl"] .lg\\:ms-10{
    margin-right: 2.5rem;
  }

  [dir="ltr"] .lg\\:me-10{
    margin-right: 2.5rem;
  }

  [dir="rtl"] .lg\\:me-10{
    margin-left: 2.5rem;
  }

  [dir="ltr"] .lg\\:ms-11{
    margin-left: 2.75rem;
  }

  [dir="rtl"] .lg\\:ms-11{
    margin-right: 2.75rem;
  }

  [dir="ltr"] .lg\\:me-11{
    margin-right: 2.75rem;
  }

  [dir="rtl"] .lg\\:me-11{
    margin-left: 2.75rem;
  }

  [dir="ltr"] .lg\\:ms-12{
    margin-left: 3rem;
  }

  [dir="rtl"] .lg\\:ms-12{
    margin-right: 3rem;
  }

  [dir="ltr"] .lg\\:me-12{
    margin-right: 3rem;
  }

  [dir="rtl"] .lg\\:me-12{
    margin-left: 3rem;
  }

  [dir="ltr"] .lg\\:ms-14{
    margin-left: 3.5rem;
  }

  [dir="rtl"] .lg\\:ms-14{
    margin-right: 3.5rem;
  }

  [dir="ltr"] .lg\\:me-14{
    margin-right: 3.5rem;
  }

  [dir="rtl"] .lg\\:me-14{
    margin-left: 3.5rem;
  }

  [dir="ltr"] .lg\\:ms-15{
    margin-left: 3.75rem;
  }

  [dir="rtl"] .lg\\:ms-15{
    margin-right: 3.75rem;
  }

  [dir="ltr"] .lg\\:me-15{
    margin-right: 3.75rem;
  }

  [dir="rtl"] .lg\\:me-15{
    margin-left: 3.75rem;
  }

  [dir="ltr"] .lg\\:ms-16{
    margin-left: 4rem;
  }

  [dir="rtl"] .lg\\:ms-16{
    margin-right: 4rem;
  }

  [dir="ltr"] .lg\\:me-16{
    margin-right: 4rem;
  }

  [dir="rtl"] .lg\\:me-16{
    margin-left: 4rem;
  }

  [dir="ltr"] .lg\\:ms-18{
    margin-left: 4.5rem;
  }

  [dir="rtl"] .lg\\:ms-18{
    margin-right: 4.5rem;
  }

  [dir="ltr"] .lg\\:me-18{
    margin-right: 4.5rem;
  }

  [dir="rtl"] .lg\\:me-18{
    margin-left: 4.5rem;
  }

  [dir="ltr"] .lg\\:ms-20{
    margin-left: 5rem;
  }

  [dir="rtl"] .lg\\:ms-20{
    margin-right: 5rem;
  }

  [dir="ltr"] .lg\\:me-20{
    margin-right: 5rem;
  }

  [dir="rtl"] .lg\\:me-20{
    margin-left: 5rem;
  }

  [dir="ltr"] .lg\\:ms-22{
    margin-left: 5.5rem;
  }

  [dir="rtl"] .lg\\:ms-22{
    margin-right: 5.5rem;
  }

  [dir="ltr"] .lg\\:me-22{
    margin-right: 5.5rem;
  }

  [dir="rtl"] .lg\\:me-22{
    margin-left: 5.5rem;
  }

  [dir="ltr"] .lg\\:ms-23{
    margin-left: 5.75rem;
  }

  [dir="rtl"] .lg\\:ms-23{
    margin-right: 5.75rem;
  }

  [dir="ltr"] .lg\\:me-23{
    margin-right: 5.75rem;
  }

  [dir="rtl"] .lg\\:me-23{
    margin-left: 5.75rem;
  }

  [dir="ltr"] .lg\\:ms-24{
    margin-left: 6rem;
  }

  [dir="rtl"] .lg\\:ms-24{
    margin-right: 6rem;
  }

  [dir="ltr"] .lg\\:me-24{
    margin-right: 6rem;
  }

  [dir="rtl"] .lg\\:me-24{
    margin-left: 6rem;
  }

  [dir="ltr"] .lg\\:ms-25{
    margin-left: 6.25rem;
  }

  [dir="rtl"] .lg\\:ms-25{
    margin-right: 6.25rem;
  }

  [dir="ltr"] .lg\\:me-25{
    margin-right: 6.25rem;
  }

  [dir="rtl"] .lg\\:me-25{
    margin-left: 6.25rem;
  }

  [dir="ltr"] .lg\\:ms-26{
    margin-left: 6.5rem;
  }

  [dir="rtl"] .lg\\:ms-26{
    margin-right: 6.5rem;
  }

  [dir="ltr"] .lg\\:me-26{
    margin-right: 6.5rem;
  }

  [dir="rtl"] .lg\\:me-26{
    margin-left: 6.5rem;
  }

  [dir="ltr"] .lg\\:ms-28{
    margin-left: 7rem;
  }

  [dir="rtl"] .lg\\:ms-28{
    margin-right: 7rem;
  }

  [dir="ltr"] .lg\\:me-28{
    margin-right: 7rem;
  }

  [dir="rtl"] .lg\\:me-28{
    margin-left: 7rem;
  }

  [dir="ltr"] .lg\\:ms-30{
    margin-left: 7.5rem;
  }

  [dir="rtl"] .lg\\:ms-30{
    margin-right: 7.5rem;
  }

  [dir="ltr"] .lg\\:me-30{
    margin-right: 7.5rem;
  }

  [dir="rtl"] .lg\\:me-30{
    margin-left: 7.5rem;
  }

  [dir="ltr"] .lg\\:ms-32{
    margin-left: 8rem;
  }

  [dir="rtl"] .lg\\:ms-32{
    margin-right: 8rem;
  }

  [dir="ltr"] .lg\\:me-32{
    margin-right: 8rem;
  }

  [dir="rtl"] .lg\\:me-32{
    margin-left: 8rem;
  }

  [dir="ltr"] .lg\\:ms-34{
    margin-left: 8.5rem;
  }

  [dir="rtl"] .lg\\:ms-34{
    margin-right: 8.5rem;
  }

  [dir="ltr"] .lg\\:me-34{
    margin-right: 8.5rem;
  }

  [dir="rtl"] .lg\\:me-34{
    margin-left: 8.5rem;
  }

  [dir="ltr"] .lg\\:ms-40{
    margin-left: 10rem;
  }

  [dir="rtl"] .lg\\:ms-40{
    margin-right: 10rem;
  }

  [dir="ltr"] .lg\\:me-40{
    margin-right: 10rem;
  }

  [dir="rtl"] .lg\\:me-40{
    margin-left: 10rem;
  }

  [dir="ltr"] .lg\\:ms-42{
    margin-left: 10.5rem;
  }

  [dir="rtl"] .lg\\:ms-42{
    margin-right: 10.5rem;
  }

  [dir="ltr"] .lg\\:me-42{
    margin-right: 10.5rem;
  }

  [dir="rtl"] .lg\\:me-42{
    margin-left: 10.5rem;
  }

  [dir="ltr"] .lg\\:ms-44{
    margin-left: 11rem;
  }

  [dir="rtl"] .lg\\:ms-44{
    margin-right: 11rem;
  }

  [dir="ltr"] .lg\\:me-44{
    margin-right: 11rem;
  }

  [dir="rtl"] .lg\\:me-44{
    margin-left: 11rem;
  }

  [dir="ltr"] .lg\\:ms-48{
    margin-left: 12rem;
  }

  [dir="rtl"] .lg\\:ms-48{
    margin-right: 12rem;
  }

  [dir="ltr"] .lg\\:me-48{
    margin-right: 12rem;
  }

  [dir="rtl"] .lg\\:me-48{
    margin-left: 12rem;
  }

  [dir="ltr"] .lg\\:ms-52{
    margin-left: 13rem;
  }

  [dir="rtl"] .lg\\:ms-52{
    margin-right: 13rem;
  }

  [dir="ltr"] .lg\\:me-52{
    margin-right: 13rem;
  }

  [dir="rtl"] .lg\\:me-52{
    margin-left: 13rem;
  }

  [dir="ltr"] .lg\\:ms-54{
    margin-left: 13.5rem;
  }

  [dir="rtl"] .lg\\:ms-54{
    margin-right: 13.5rem;
  }

  [dir="ltr"] .lg\\:me-54{
    margin-right: 13.5rem;
  }

  [dir="rtl"] .lg\\:me-54{
    margin-left: 13.5rem;
  }

  [dir="ltr"] .lg\\:ms-56{
    margin-left: 14rem;
  }

  [dir="rtl"] .lg\\:ms-56{
    margin-right: 14rem;
  }

  [dir="ltr"] .lg\\:me-56{
    margin-right: 14rem;
  }

  [dir="rtl"] .lg\\:me-56{
    margin-left: 14rem;
  }

  [dir="ltr"] .lg\\:ms-60{
    margin-left: 15rem;
  }

  [dir="rtl"] .lg\\:ms-60{
    margin-right: 15rem;
  }

  [dir="ltr"] .lg\\:me-60{
    margin-right: 15rem;
  }

  [dir="rtl"] .lg\\:me-60{
    margin-left: 15rem;
  }

  [dir="ltr"] .lg\\:ms-64{
    margin-left: 16rem;
  }

  [dir="rtl"] .lg\\:ms-64{
    margin-right: 16rem;
  }

  [dir="ltr"] .lg\\:me-64{
    margin-right: 16rem;
  }

  [dir="rtl"] .lg\\:me-64{
    margin-left: 16rem;
  }

  [dir="ltr"] .lg\\:ms-68{
    margin-left: 17rem;
  }

  [dir="rtl"] .lg\\:ms-68{
    margin-right: 17rem;
  }

  [dir="ltr"] .lg\\:me-68{
    margin-right: 17rem;
  }

  [dir="rtl"] .lg\\:me-68{
    margin-left: 17rem;
  }

  [dir="ltr"] .lg\\:ms-72{
    margin-left: 18rem;
  }

  [dir="rtl"] .lg\\:ms-72{
    margin-right: 18rem;
  }

  [dir="ltr"] .lg\\:me-72{
    margin-right: 18rem;
  }

  [dir="rtl"] .lg\\:me-72{
    margin-left: 18rem;
  }

  [dir="ltr"] .lg\\:ms-74{
    margin-left: 18.5rem;
  }

  [dir="rtl"] .lg\\:ms-74{
    margin-right: 18.5rem;
  }

  [dir="ltr"] .lg\\:me-74{
    margin-right: 18.5rem;
  }

  [dir="rtl"] .lg\\:me-74{
    margin-left: 18.5rem;
  }

  [dir="ltr"] .lg\\:ms-76{
    margin-left: 19rem;
  }

  [dir="rtl"] .lg\\:ms-76{
    margin-right: 19rem;
  }

  [dir="ltr"] .lg\\:me-76{
    margin-right: 19rem;
  }

  [dir="rtl"] .lg\\:me-76{
    margin-left: 19rem;
  }

  [dir="ltr"] .lg\\:ms-78{
    margin-left: 19.5rem;
  }

  [dir="rtl"] .lg\\:ms-78{
    margin-right: 19.5rem;
  }

  [dir="ltr"] .lg\\:me-78{
    margin-right: 19.5rem;
  }

  [dir="rtl"] .lg\\:me-78{
    margin-left: 19.5rem;
  }

  [dir="ltr"] .lg\\:ms-80{
    margin-left: 20rem;
  }

  [dir="rtl"] .lg\\:ms-80{
    margin-right: 20rem;
  }

  [dir="ltr"] .lg\\:me-80{
    margin-right: 20rem;
  }

  [dir="rtl"] .lg\\:me-80{
    margin-left: 20rem;
  }

  [dir="ltr"] .lg\\:ms-82{
    margin-left: 20.5rem;
  }

  [dir="rtl"] .lg\\:ms-82{
    margin-right: 20.5rem;
  }

  [dir="ltr"] .lg\\:me-82{
    margin-right: 20.5rem;
  }

  [dir="rtl"] .lg\\:me-82{
    margin-left: 20.5rem;
  }

  [dir="ltr"] .lg\\:ms-84{
    margin-left: 21rem;
  }

  [dir="rtl"] .lg\\:ms-84{
    margin-right: 21rem;
  }

  [dir="ltr"] .lg\\:me-84{
    margin-right: 21rem;
  }

  [dir="rtl"] .lg\\:me-84{
    margin-left: 21rem;
  }

  [dir="ltr"] .lg\\:ms-88{
    margin-left: 22rem;
  }

  [dir="rtl"] .lg\\:ms-88{
    margin-right: 22rem;
  }

  [dir="ltr"] .lg\\:me-88{
    margin-right: 22rem;
  }

  [dir="rtl"] .lg\\:me-88{
    margin-left: 22rem;
  }

  [dir="ltr"] .lg\\:ms-92{
    margin-left: 23rem;
  }

  [dir="rtl"] .lg\\:ms-92{
    margin-right: 23rem;
  }

  [dir="ltr"] .lg\\:me-92{
    margin-right: 23rem;
  }

  [dir="rtl"] .lg\\:me-92{
    margin-left: 23rem;
  }

  [dir="ltr"] .lg\\:ms-96{
    margin-left: 24rem;
  }

  [dir="rtl"] .lg\\:ms-96{
    margin-right: 24rem;
  }

  [dir="ltr"] .lg\\:me-96{
    margin-right: 24rem;
  }

  [dir="rtl"] .lg\\:me-96{
    margin-left: 24rem;
  }

  [dir="ltr"] .lg\\:ms-98{
    margin-left: 24.5rem;
  }

  [dir="rtl"] .lg\\:ms-98{
    margin-right: 24.5rem;
  }

  [dir="ltr"] .lg\\:me-98{
    margin-right: 24.5rem;
  }

  [dir="rtl"] .lg\\:me-98{
    margin-left: 24.5rem;
  }

  [dir="ltr"] .lg\\:ms-100{
    margin-left: 25rem;
  }

  [dir="rtl"] .lg\\:ms-100{
    margin-right: 25rem;
  }

  [dir="ltr"] .lg\\:me-100{
    margin-right: 25rem;
  }

  [dir="rtl"] .lg\\:me-100{
    margin-left: 25rem;
  }

  [dir="ltr"] .lg\\:ms-104{
    margin-left: 26rem;
  }

  [dir="rtl"] .lg\\:ms-104{
    margin-right: 26rem;
  }

  [dir="ltr"] .lg\\:me-104{
    margin-right: 26rem;
  }

  [dir="rtl"] .lg\\:me-104{
    margin-left: 26rem;
  }

  [dir="ltr"] .lg\\:ms-112{
    margin-left: 28rem;
  }

  [dir="rtl"] .lg\\:ms-112{
    margin-right: 28rem;
  }

  [dir="ltr"] .lg\\:me-112{
    margin-right: 28rem;
  }

  [dir="rtl"] .lg\\:me-112{
    margin-left: 28rem;
  }

  [dir="ltr"] .lg\\:ms-124{
    margin-left: 31rem;
  }

  [dir="rtl"] .lg\\:ms-124{
    margin-right: 31rem;
  }

  [dir="ltr"] .lg\\:me-124{
    margin-right: 31rem;
  }

  [dir="rtl"] .lg\\:me-124{
    margin-left: 31rem;
  }

  [dir="ltr"] .lg\\:ms-128{
    margin-left: 32rem;
  }

  [dir="rtl"] .lg\\:ms-128{
    margin-right: 32rem;
  }

  [dir="ltr"] .lg\\:me-128{
    margin-right: 32rem;
  }

  [dir="rtl"] .lg\\:me-128{
    margin-left: 32rem;
  }

  [dir="ltr"] .lg\\:ms-140{
    margin-left: 35rem;
  }

  [dir="rtl"] .lg\\:ms-140{
    margin-right: 35rem;
  }

  [dir="ltr"] .lg\\:me-140{
    margin-right: 35rem;
  }

  [dir="rtl"] .lg\\:me-140{
    margin-left: 35rem;
  }

  [dir="ltr"] .lg\\:ms-152{
    margin-left: 38rem;
  }

  [dir="rtl"] .lg\\:ms-152{
    margin-right: 38rem;
  }

  [dir="ltr"] .lg\\:me-152{
    margin-right: 38rem;
  }

  [dir="rtl"] .lg\\:me-152{
    margin-left: 38rem;
  }

  [dir="ltr"] .lg\\:ms-160{
    margin-left: 40rem;
  }

  [dir="rtl"] .lg\\:ms-160{
    margin-right: 40rem;
  }

  [dir="ltr"] .lg\\:me-160{
    margin-right: 40rem;
  }

  [dir="rtl"] .lg\\:me-160{
    margin-left: 40rem;
  }

  [dir="ltr"] .lg\\:ms-162{
    margin-left: 41rem;
  }

  [dir="rtl"] .lg\\:ms-162{
    margin-right: 41rem;
  }

  [dir="ltr"] .lg\\:me-162{
    margin-right: 41rem;
  }

  [dir="rtl"] .lg\\:me-162{
    margin-left: 41rem;
  }

  [dir="ltr"] .lg\\:ms-192{
    margin-left: 48rem;
  }

  [dir="rtl"] .lg\\:ms-192{
    margin-right: 48rem;
  }

  [dir="ltr"] .lg\\:me-192{
    margin-right: 48rem;
  }

  [dir="rtl"] .lg\\:me-192{
    margin-left: 48rem;
  }

  [dir="ltr"] .lg\\:ms-208{
    margin-left: 52rem;
  }

  [dir="rtl"] .lg\\:ms-208{
    margin-right: 52rem;
  }

  [dir="ltr"] .lg\\:me-208{
    margin-right: 52rem;
  }

  [dir="rtl"] .lg\\:me-208{
    margin-left: 52rem;
  }

  [dir="ltr"] .lg\\:ms-224{
    margin-left: 56rem;
  }

  [dir="rtl"] .lg\\:ms-224{
    margin-right: 56rem;
  }

  [dir="ltr"] .lg\\:me-224{
    margin-right: 56rem;
  }

  [dir="rtl"] .lg\\:me-224{
    margin-left: 56rem;
  }

  [dir="ltr"] .lg\\:ms-256{
    margin-left: 64rem;
  }

  [dir="rtl"] .lg\\:ms-256{
    margin-right: 64rem;
  }

  [dir="ltr"] .lg\\:me-256{
    margin-right: 64rem;
  }

  [dir="rtl"] .lg\\:me-256{
    margin-left: 64rem;
  }

  [dir="ltr"] .lg\\:ms-auto{
    margin-left: auto;
  }

  [dir="rtl"] .lg\\:ms-auto{
    margin-right: auto;
  }

  [dir="ltr"] .lg\\:me-auto{
    margin-right: auto;
  }

  [dir="rtl"] .lg\\:me-auto{
    margin-left: auto;
  }

  [dir="ltr"] .lg\\:ms-px{
    margin-left: 1px;
  }

  [dir="rtl"] .lg\\:ms-px{
    margin-right: 1px;
  }

  [dir="ltr"] .lg\\:me-px{
    margin-right: 1px;
  }

  [dir="rtl"] .lg\\:me-px{
    margin-left: 1px;
  }

  [dir="ltr"] .lg\\:-ms-1{
    margin-left: -0.25rem;
  }

  [dir="rtl"] .lg\\:-ms-1{
    margin-right: -0.25rem;
  }

  [dir="ltr"] .lg\\:-me-1{
    margin-right: -0.25rem;
  }

  [dir="rtl"] .lg\\:-me-1{
    margin-left: -0.25rem;
  }

  [dir="ltr"] .lg\\:-ms-2{
    margin-left: -0.5rem;
  }

  [dir="rtl"] .lg\\:-ms-2{
    margin-right: -0.5rem;
  }

  [dir="ltr"] .lg\\:-me-2{
    margin-right: -0.5rem;
  }

  [dir="rtl"] .lg\\:-me-2{
    margin-left: -0.5rem;
  }

  [dir="ltr"] .lg\\:-ms-3{
    margin-left: -0.75rem;
  }

  [dir="rtl"] .lg\\:-ms-3{
    margin-right: -0.75rem;
  }

  [dir="ltr"] .lg\\:-me-3{
    margin-right: -0.75rem;
  }

  [dir="rtl"] .lg\\:-me-3{
    margin-left: -0.75rem;
  }

  [dir="ltr"] .lg\\:-ms-4{
    margin-left: -1rem;
  }

  [dir="rtl"] .lg\\:-ms-4{
    margin-right: -1rem;
  }

  [dir="ltr"] .lg\\:-me-4{
    margin-right: -1rem;
  }

  [dir="rtl"] .lg\\:-me-4{
    margin-left: -1rem;
  }

  [dir="ltr"] .lg\\:-ms-5{
    margin-left: -1.25rem;
  }

  [dir="rtl"] .lg\\:-ms-5{
    margin-right: -1.25rem;
  }

  [dir="ltr"] .lg\\:-me-5{
    margin-right: -1.25rem;
  }

  [dir="rtl"] .lg\\:-me-5{
    margin-left: -1.25rem;
  }

  [dir="ltr"] .lg\\:-ms-6{
    margin-left: -1.5rem;
  }

  [dir="rtl"] .lg\\:-ms-6{
    margin-right: -1.5rem;
  }

  [dir="ltr"] .lg\\:-me-6{
    margin-right: -1.5rem;
  }

  [dir="rtl"] .lg\\:-me-6{
    margin-left: -1.5rem;
  }

  [dir="ltr"] .lg\\:-ms-7{
    margin-left: -1.75rem;
  }

  [dir="rtl"] .lg\\:-ms-7{
    margin-right: -1.75rem;
  }

  [dir="ltr"] .lg\\:-me-7{
    margin-right: -1.75rem;
  }

  [dir="rtl"] .lg\\:-me-7{
    margin-left: -1.75rem;
  }

  [dir="ltr"] .lg\\:-ms-8{
    margin-left: -2rem;
  }

  [dir="rtl"] .lg\\:-ms-8{
    margin-right: -2rem;
  }

  [dir="ltr"] .lg\\:-me-8{
    margin-right: -2rem;
  }

  [dir="rtl"] .lg\\:-me-8{
    margin-left: -2rem;
  }

  [dir="ltr"] .lg\\:-ms-9{
    margin-left: -2.25rem;
  }

  [dir="rtl"] .lg\\:-ms-9{
    margin-right: -2.25rem;
  }

  [dir="ltr"] .lg\\:-me-9{
    margin-right: -2.25rem;
  }

  [dir="rtl"] .lg\\:-me-9{
    margin-left: -2.25rem;
  }

  [dir="ltr"] .lg\\:-ms-10{
    margin-left: -2.5rem;
  }

  [dir="rtl"] .lg\\:-ms-10{
    margin-right: -2.5rem;
  }

  [dir="ltr"] .lg\\:-me-10{
    margin-right: -2.5rem;
  }

  [dir="rtl"] .lg\\:-me-10{
    margin-left: -2.5rem;
  }

  [dir="ltr"] .lg\\:-ms-11{
    margin-left: -2.75rem;
  }

  [dir="rtl"] .lg\\:-ms-11{
    margin-right: -2.75rem;
  }

  [dir="ltr"] .lg\\:-me-11{
    margin-right: -2.75rem;
  }

  [dir="rtl"] .lg\\:-me-11{
    margin-left: -2.75rem;
  }

  [dir="ltr"] .lg\\:-ms-12{
    margin-left: -3rem;
  }

  [dir="rtl"] .lg\\:-ms-12{
    margin-right: -3rem;
  }

  [dir="ltr"] .lg\\:-me-12{
    margin-right: -3rem;
  }

  [dir="rtl"] .lg\\:-me-12{
    margin-left: -3rem;
  }

  [dir="ltr"] .lg\\:-ms-14{
    margin-left: -3.5rem;
  }

  [dir="rtl"] .lg\\:-ms-14{
    margin-right: -3.5rem;
  }

  [dir="ltr"] .lg\\:-me-14{
    margin-right: -3.5rem;
  }

  [dir="rtl"] .lg\\:-me-14{
    margin-left: -3.5rem;
  }

  [dir="ltr"] .lg\\:-ms-15{
    margin-left: -3.75rem;
  }

  [dir="rtl"] .lg\\:-ms-15{
    margin-right: -3.75rem;
  }

  [dir="ltr"] .lg\\:-me-15{
    margin-right: -3.75rem;
  }

  [dir="rtl"] .lg\\:-me-15{
    margin-left: -3.75rem;
  }

  [dir="ltr"] .lg\\:-ms-16{
    margin-left: -4rem;
  }

  [dir="rtl"] .lg\\:-ms-16{
    margin-right: -4rem;
  }

  [dir="ltr"] .lg\\:-me-16{
    margin-right: -4rem;
  }

  [dir="rtl"] .lg\\:-me-16{
    margin-left: -4rem;
  }

  [dir="ltr"] .lg\\:-ms-18{
    margin-left: -4.5rem;
  }

  [dir="rtl"] .lg\\:-ms-18{
    margin-right: -4.5rem;
  }

  [dir="ltr"] .lg\\:-me-18{
    margin-right: -4.5rem;
  }

  [dir="rtl"] .lg\\:-me-18{
    margin-left: -4.5rem;
  }

  [dir="ltr"] .lg\\:-ms-20{
    margin-left: -5rem;
  }

  [dir="rtl"] .lg\\:-ms-20{
    margin-right: -5rem;
  }

  [dir="ltr"] .lg\\:-me-20{
    margin-right: -5rem;
  }

  [dir="rtl"] .lg\\:-me-20{
    margin-left: -5rem;
  }

  [dir="ltr"] .lg\\:-ms-22{
    margin-left: -5.5rem;
  }

  [dir="rtl"] .lg\\:-ms-22{
    margin-right: -5.5rem;
  }

  [dir="ltr"] .lg\\:-me-22{
    margin-right: -5.5rem;
  }

  [dir="rtl"] .lg\\:-me-22{
    margin-left: -5.5rem;
  }

  [dir="ltr"] .lg\\:-ms-23{
    margin-left: -5.75rem;
  }

  [dir="rtl"] .lg\\:-ms-23{
    margin-right: -5.75rem;
  }

  [dir="ltr"] .lg\\:-me-23{
    margin-right: -5.75rem;
  }

  [dir="rtl"] .lg\\:-me-23{
    margin-left: -5.75rem;
  }

  [dir="ltr"] .lg\\:-ms-24{
    margin-left: -6rem;
  }

  [dir="rtl"] .lg\\:-ms-24{
    margin-right: -6rem;
  }

  [dir="ltr"] .lg\\:-me-24{
    margin-right: -6rem;
  }

  [dir="rtl"] .lg\\:-me-24{
    margin-left: -6rem;
  }

  [dir="ltr"] .lg\\:-ms-25{
    margin-left: -6.25rem;
  }

  [dir="rtl"] .lg\\:-ms-25{
    margin-right: -6.25rem;
  }

  [dir="ltr"] .lg\\:-me-25{
    margin-right: -6.25rem;
  }

  [dir="rtl"] .lg\\:-me-25{
    margin-left: -6.25rem;
  }

  [dir="ltr"] .lg\\:-ms-26{
    margin-left: -6.5rem;
  }

  [dir="rtl"] .lg\\:-ms-26{
    margin-right: -6.5rem;
  }

  [dir="ltr"] .lg\\:-me-26{
    margin-right: -6.5rem;
  }

  [dir="rtl"] .lg\\:-me-26{
    margin-left: -6.5rem;
  }

  [dir="ltr"] .lg\\:-ms-28{
    margin-left: -7rem;
  }

  [dir="rtl"] .lg\\:-ms-28{
    margin-right: -7rem;
  }

  [dir="ltr"] .lg\\:-me-28{
    margin-right: -7rem;
  }

  [dir="rtl"] .lg\\:-me-28{
    margin-left: -7rem;
  }

  [dir="ltr"] .lg\\:-ms-30{
    margin-left: -7.5rem;
  }

  [dir="rtl"] .lg\\:-ms-30{
    margin-right: -7.5rem;
  }

  [dir="ltr"] .lg\\:-me-30{
    margin-right: -7.5rem;
  }

  [dir="rtl"] .lg\\:-me-30{
    margin-left: -7.5rem;
  }

  [dir="ltr"] .lg\\:-ms-32{
    margin-left: -8rem;
  }

  [dir="rtl"] .lg\\:-ms-32{
    margin-right: -8rem;
  }

  [dir="ltr"] .lg\\:-me-32{
    margin-right: -8rem;
  }

  [dir="rtl"] .lg\\:-me-32{
    margin-left: -8rem;
  }

  [dir="ltr"] .lg\\:-ms-34{
    margin-left: -8.5rem;
  }

  [dir="rtl"] .lg\\:-ms-34{
    margin-right: -8.5rem;
  }

  [dir="ltr"] .lg\\:-me-34{
    margin-right: -8.5rem;
  }

  [dir="rtl"] .lg\\:-me-34{
    margin-left: -8.5rem;
  }

  [dir="ltr"] .lg\\:-ms-40{
    margin-left: -10rem;
  }

  [dir="rtl"] .lg\\:-ms-40{
    margin-right: -10rem;
  }

  [dir="ltr"] .lg\\:-me-40{
    margin-right: -10rem;
  }

  [dir="rtl"] .lg\\:-me-40{
    margin-left: -10rem;
  }

  [dir="ltr"] .lg\\:-ms-42{
    margin-left: -10.5rem;
  }

  [dir="rtl"] .lg\\:-ms-42{
    margin-right: -10.5rem;
  }

  [dir="ltr"] .lg\\:-me-42{
    margin-right: -10.5rem;
  }

  [dir="rtl"] .lg\\:-me-42{
    margin-left: -10.5rem;
  }

  [dir="ltr"] .lg\\:-ms-44{
    margin-left: -11rem;
  }

  [dir="rtl"] .lg\\:-ms-44{
    margin-right: -11rem;
  }

  [dir="ltr"] .lg\\:-me-44{
    margin-right: -11rem;
  }

  [dir="rtl"] .lg\\:-me-44{
    margin-left: -11rem;
  }

  [dir="ltr"] .lg\\:-ms-48{
    margin-left: -12rem;
  }

  [dir="rtl"] .lg\\:-ms-48{
    margin-right: -12rem;
  }

  [dir="ltr"] .lg\\:-me-48{
    margin-right: -12rem;
  }

  [dir="rtl"] .lg\\:-me-48{
    margin-left: -12rem;
  }

  [dir="ltr"] .lg\\:-ms-52{
    margin-left: -13rem;
  }

  [dir="rtl"] .lg\\:-ms-52{
    margin-right: -13rem;
  }

  [dir="ltr"] .lg\\:-me-52{
    margin-right: -13rem;
  }

  [dir="rtl"] .lg\\:-me-52{
    margin-left: -13rem;
  }

  [dir="ltr"] .lg\\:-ms-54{
    margin-left: -13.5rem;
  }

  [dir="rtl"] .lg\\:-ms-54{
    margin-right: -13.5rem;
  }

  [dir="ltr"] .lg\\:-me-54{
    margin-right: -13.5rem;
  }

  [dir="rtl"] .lg\\:-me-54{
    margin-left: -13.5rem;
  }

  [dir="ltr"] .lg\\:-ms-56{
    margin-left: -14rem;
  }

  [dir="rtl"] .lg\\:-ms-56{
    margin-right: -14rem;
  }

  [dir="ltr"] .lg\\:-me-56{
    margin-right: -14rem;
  }

  [dir="rtl"] .lg\\:-me-56{
    margin-left: -14rem;
  }

  [dir="ltr"] .lg\\:-ms-60{
    margin-left: -15rem;
  }

  [dir="rtl"] .lg\\:-ms-60{
    margin-right: -15rem;
  }

  [dir="ltr"] .lg\\:-me-60{
    margin-right: -15rem;
  }

  [dir="rtl"] .lg\\:-me-60{
    margin-left: -15rem;
  }

  [dir="ltr"] .lg\\:-ms-64{
    margin-left: -16rem;
  }

  [dir="rtl"] .lg\\:-ms-64{
    margin-right: -16rem;
  }

  [dir="ltr"] .lg\\:-me-64{
    margin-right: -16rem;
  }

  [dir="rtl"] .lg\\:-me-64{
    margin-left: -16rem;
  }

  [dir="ltr"] .lg\\:-ms-68{
    margin-left: -17rem;
  }

  [dir="rtl"] .lg\\:-ms-68{
    margin-right: -17rem;
  }

  [dir="ltr"] .lg\\:-me-68{
    margin-right: -17rem;
  }

  [dir="rtl"] .lg\\:-me-68{
    margin-left: -17rem;
  }

  [dir="ltr"] .lg\\:-ms-72{
    margin-left: -18rem;
  }

  [dir="rtl"] .lg\\:-ms-72{
    margin-right: -18rem;
  }

  [dir="ltr"] .lg\\:-me-72{
    margin-right: -18rem;
  }

  [dir="rtl"] .lg\\:-me-72{
    margin-left: -18rem;
  }

  [dir="ltr"] .lg\\:-ms-74{
    margin-left: -18.5rem;
  }

  [dir="rtl"] .lg\\:-ms-74{
    margin-right: -18.5rem;
  }

  [dir="ltr"] .lg\\:-me-74{
    margin-right: -18.5rem;
  }

  [dir="rtl"] .lg\\:-me-74{
    margin-left: -18.5rem;
  }

  [dir="ltr"] .lg\\:-ms-76{
    margin-left: -19rem;
  }

  [dir="rtl"] .lg\\:-ms-76{
    margin-right: -19rem;
  }

  [dir="ltr"] .lg\\:-me-76{
    margin-right: -19rem;
  }

  [dir="rtl"] .lg\\:-me-76{
    margin-left: -19rem;
  }

  [dir="ltr"] .lg\\:-ms-78{
    margin-left: -19.5rem;
  }

  [dir="rtl"] .lg\\:-ms-78{
    margin-right: -19.5rem;
  }

  [dir="ltr"] .lg\\:-me-78{
    margin-right: -19.5rem;
  }

  [dir="rtl"] .lg\\:-me-78{
    margin-left: -19.5rem;
  }

  [dir="ltr"] .lg\\:-ms-80{
    margin-left: -20rem;
  }

  [dir="rtl"] .lg\\:-ms-80{
    margin-right: -20rem;
  }

  [dir="ltr"] .lg\\:-me-80{
    margin-right: -20rem;
  }

  [dir="rtl"] .lg\\:-me-80{
    margin-left: -20rem;
  }

  [dir="ltr"] .lg\\:-ms-82{
    margin-left: -20.5rem;
  }

  [dir="rtl"] .lg\\:-ms-82{
    margin-right: -20.5rem;
  }

  [dir="ltr"] .lg\\:-me-82{
    margin-right: -20.5rem;
  }

  [dir="rtl"] .lg\\:-me-82{
    margin-left: -20.5rem;
  }

  [dir="ltr"] .lg\\:-ms-84{
    margin-left: -21rem;
  }

  [dir="rtl"] .lg\\:-ms-84{
    margin-right: -21rem;
  }

  [dir="ltr"] .lg\\:-me-84{
    margin-right: -21rem;
  }

  [dir="rtl"] .lg\\:-me-84{
    margin-left: -21rem;
  }

  [dir="ltr"] .lg\\:-ms-88{
    margin-left: -22rem;
  }

  [dir="rtl"] .lg\\:-ms-88{
    margin-right: -22rem;
  }

  [dir="ltr"] .lg\\:-me-88{
    margin-right: -22rem;
  }

  [dir="rtl"] .lg\\:-me-88{
    margin-left: -22rem;
  }

  [dir="ltr"] .lg\\:-ms-92{
    margin-left: -23rem;
  }

  [dir="rtl"] .lg\\:-ms-92{
    margin-right: -23rem;
  }

  [dir="ltr"] .lg\\:-me-92{
    margin-right: -23rem;
  }

  [dir="rtl"] .lg\\:-me-92{
    margin-left: -23rem;
  }

  [dir="ltr"] .lg\\:-ms-96{
    margin-left: -24rem;
  }

  [dir="rtl"] .lg\\:-ms-96{
    margin-right: -24rem;
  }

  [dir="ltr"] .lg\\:-me-96{
    margin-right: -24rem;
  }

  [dir="rtl"] .lg\\:-me-96{
    margin-left: -24rem;
  }

  [dir="ltr"] .lg\\:-ms-98{
    margin-left: -24.5rem;
  }

  [dir="rtl"] .lg\\:-ms-98{
    margin-right: -24.5rem;
  }

  [dir="ltr"] .lg\\:-me-98{
    margin-right: -24.5rem;
  }

  [dir="rtl"] .lg\\:-me-98{
    margin-left: -24.5rem;
  }

  [dir="ltr"] .lg\\:-ms-100{
    margin-left: -25rem;
  }

  [dir="rtl"] .lg\\:-ms-100{
    margin-right: -25rem;
  }

  [dir="ltr"] .lg\\:-me-100{
    margin-right: -25rem;
  }

  [dir="rtl"] .lg\\:-me-100{
    margin-left: -25rem;
  }

  [dir="ltr"] .lg\\:-ms-104{
    margin-left: -26rem;
  }

  [dir="rtl"] .lg\\:-ms-104{
    margin-right: -26rem;
  }

  [dir="ltr"] .lg\\:-me-104{
    margin-right: -26rem;
  }

  [dir="rtl"] .lg\\:-me-104{
    margin-left: -26rem;
  }

  [dir="ltr"] .lg\\:-ms-112{
    margin-left: -28rem;
  }

  [dir="rtl"] .lg\\:-ms-112{
    margin-right: -28rem;
  }

  [dir="ltr"] .lg\\:-me-112{
    margin-right: -28rem;
  }

  [dir="rtl"] .lg\\:-me-112{
    margin-left: -28rem;
  }

  [dir="ltr"] .lg\\:-ms-124{
    margin-left: -31rem;
  }

  [dir="rtl"] .lg\\:-ms-124{
    margin-right: -31rem;
  }

  [dir="ltr"] .lg\\:-me-124{
    margin-right: -31rem;
  }

  [dir="rtl"] .lg\\:-me-124{
    margin-left: -31rem;
  }

  [dir="ltr"] .lg\\:-ms-128{
    margin-left: -32rem;
  }

  [dir="rtl"] .lg\\:-ms-128{
    margin-right: -32rem;
  }

  [dir="ltr"] .lg\\:-me-128{
    margin-right: -32rem;
  }

  [dir="rtl"] .lg\\:-me-128{
    margin-left: -32rem;
  }

  [dir="ltr"] .lg\\:-ms-140{
    margin-left: -35rem;
  }

  [dir="rtl"] .lg\\:-ms-140{
    margin-right: -35rem;
  }

  [dir="ltr"] .lg\\:-me-140{
    margin-right: -35rem;
  }

  [dir="rtl"] .lg\\:-me-140{
    margin-left: -35rem;
  }

  [dir="ltr"] .lg\\:-ms-152{
    margin-left: -38rem;
  }

  [dir="rtl"] .lg\\:-ms-152{
    margin-right: -38rem;
  }

  [dir="ltr"] .lg\\:-me-152{
    margin-right: -38rem;
  }

  [dir="rtl"] .lg\\:-me-152{
    margin-left: -38rem;
  }

  [dir="ltr"] .lg\\:-ms-160{
    margin-left: -40rem;
  }

  [dir="rtl"] .lg\\:-ms-160{
    margin-right: -40rem;
  }

  [dir="ltr"] .lg\\:-me-160{
    margin-right: -40rem;
  }

  [dir="rtl"] .lg\\:-me-160{
    margin-left: -40rem;
  }

  [dir="ltr"] .lg\\:-ms-162{
    margin-left: -41rem;
  }

  [dir="rtl"] .lg\\:-ms-162{
    margin-right: -41rem;
  }

  [dir="ltr"] .lg\\:-me-162{
    margin-right: -41rem;
  }

  [dir="rtl"] .lg\\:-me-162{
    margin-left: -41rem;
  }

  [dir="ltr"] .lg\\:-ms-192{
    margin-left: -48rem;
  }

  [dir="rtl"] .lg\\:-ms-192{
    margin-right: -48rem;
  }

  [dir="ltr"] .lg\\:-me-192{
    margin-right: -48rem;
  }

  [dir="rtl"] .lg\\:-me-192{
    margin-left: -48rem;
  }

  [dir="ltr"] .lg\\:-ms-208{
    margin-left: -52rem;
  }

  [dir="rtl"] .lg\\:-ms-208{
    margin-right: -52rem;
  }

  [dir="ltr"] .lg\\:-me-208{
    margin-right: -52rem;
  }

  [dir="rtl"] .lg\\:-me-208{
    margin-left: -52rem;
  }

  [dir="ltr"] .lg\\:-ms-224{
    margin-left: -56rem;
  }

  [dir="rtl"] .lg\\:-ms-224{
    margin-right: -56rem;
  }

  [dir="ltr"] .lg\\:-me-224{
    margin-right: -56rem;
  }

  [dir="rtl"] .lg\\:-me-224{
    margin-left: -56rem;
  }

  [dir="ltr"] .lg\\:-ms-256{
    margin-left: -64rem;
  }

  [dir="rtl"] .lg\\:-ms-256{
    margin-right: -64rem;
  }

  [dir="ltr"] .lg\\:-me-256{
    margin-right: -64rem;
  }

  [dir="rtl"] .lg\\:-me-256{
    margin-left: -64rem;
  }

  [dir="ltr"] .lg\\:-ms-px{
    margin-left: -1px;
  }

  [dir="rtl"] .lg\\:-ms-px{
    margin-right: -1px;
  }

  [dir="ltr"] .lg\\:-me-px{
    margin-right: -1px;
  }

  [dir="rtl"] .lg\\:-me-px{
    margin-left: -1px;
  }

  [dir="ltr"] .lg\\:first\\:ms-0:first-child{
    margin-left: 0;
  }

  [dir="rtl"] .lg\\:first\\:ms-0:first-child{
    margin-right: 0;
  }

  [dir="ltr"] .lg\\:first\\:me-0:first-child{
    margin-right: 0;
  }

  [dir="rtl"] .lg\\:first\\:me-0:first-child{
    margin-left: 0;
  }

  [dir="ltr"] .lg\\:first\\:ms-1:first-child{
    margin-left: 0.25rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-1:first-child{
    margin-right: 0.25rem;
  }

  [dir="ltr"] .lg\\:first\\:me-1:first-child{
    margin-right: 0.25rem;
  }

  [dir="rtl"] .lg\\:first\\:me-1:first-child{
    margin-left: 0.25rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-2:first-child{
    margin-left: 0.5rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-2:first-child{
    margin-right: 0.5rem;
  }

  [dir="ltr"] .lg\\:first\\:me-2:first-child{
    margin-right: 0.5rem;
  }

  [dir="rtl"] .lg\\:first\\:me-2:first-child{
    margin-left: 0.5rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-3:first-child{
    margin-left: 0.75rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-3:first-child{
    margin-right: 0.75rem;
  }

  [dir="ltr"] .lg\\:first\\:me-3:first-child{
    margin-right: 0.75rem;
  }

  [dir="rtl"] .lg\\:first\\:me-3:first-child{
    margin-left: 0.75rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-4:first-child{
    margin-left: 1rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-4:first-child{
    margin-right: 1rem;
  }

  [dir="ltr"] .lg\\:first\\:me-4:first-child{
    margin-right: 1rem;
  }

  [dir="rtl"] .lg\\:first\\:me-4:first-child{
    margin-left: 1rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-5:first-child{
    margin-left: 1.25rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-5:first-child{
    margin-right: 1.25rem;
  }

  [dir="ltr"] .lg\\:first\\:me-5:first-child{
    margin-right: 1.25rem;
  }

  [dir="rtl"] .lg\\:first\\:me-5:first-child{
    margin-left: 1.25rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-6:first-child{
    margin-left: 1.5rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-6:first-child{
    margin-right: 1.5rem;
  }

  [dir="ltr"] .lg\\:first\\:me-6:first-child{
    margin-right: 1.5rem;
  }

  [dir="rtl"] .lg\\:first\\:me-6:first-child{
    margin-left: 1.5rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-7:first-child{
    margin-left: 1.75rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-7:first-child{
    margin-right: 1.75rem;
  }

  [dir="ltr"] .lg\\:first\\:me-7:first-child{
    margin-right: 1.75rem;
  }

  [dir="rtl"] .lg\\:first\\:me-7:first-child{
    margin-left: 1.75rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-8:first-child{
    margin-left: 2rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-8:first-child{
    margin-right: 2rem;
  }

  [dir="ltr"] .lg\\:first\\:me-8:first-child{
    margin-right: 2rem;
  }

  [dir="rtl"] .lg\\:first\\:me-8:first-child{
    margin-left: 2rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-9:first-child{
    margin-left: 2.25rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-9:first-child{
    margin-right: 2.25rem;
  }

  [dir="ltr"] .lg\\:first\\:me-9:first-child{
    margin-right: 2.25rem;
  }

  [dir="rtl"] .lg\\:first\\:me-9:first-child{
    margin-left: 2.25rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-10:first-child{
    margin-left: 2.5rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-10:first-child{
    margin-right: 2.5rem;
  }

  [dir="ltr"] .lg\\:first\\:me-10:first-child{
    margin-right: 2.5rem;
  }

  [dir="rtl"] .lg\\:first\\:me-10:first-child{
    margin-left: 2.5rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-11:first-child{
    margin-left: 2.75rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-11:first-child{
    margin-right: 2.75rem;
  }

  [dir="ltr"] .lg\\:first\\:me-11:first-child{
    margin-right: 2.75rem;
  }

  [dir="rtl"] .lg\\:first\\:me-11:first-child{
    margin-left: 2.75rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-12:first-child{
    margin-left: 3rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-12:first-child{
    margin-right: 3rem;
  }

  [dir="ltr"] .lg\\:first\\:me-12:first-child{
    margin-right: 3rem;
  }

  [dir="rtl"] .lg\\:first\\:me-12:first-child{
    margin-left: 3rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-14:first-child{
    margin-left: 3.5rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-14:first-child{
    margin-right: 3.5rem;
  }

  [dir="ltr"] .lg\\:first\\:me-14:first-child{
    margin-right: 3.5rem;
  }

  [dir="rtl"] .lg\\:first\\:me-14:first-child{
    margin-left: 3.5rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-15:first-child{
    margin-left: 3.75rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-15:first-child{
    margin-right: 3.75rem;
  }

  [dir="ltr"] .lg\\:first\\:me-15:first-child{
    margin-right: 3.75rem;
  }

  [dir="rtl"] .lg\\:first\\:me-15:first-child{
    margin-left: 3.75rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-16:first-child{
    margin-left: 4rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-16:first-child{
    margin-right: 4rem;
  }

  [dir="ltr"] .lg\\:first\\:me-16:first-child{
    margin-right: 4rem;
  }

  [dir="rtl"] .lg\\:first\\:me-16:first-child{
    margin-left: 4rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-18:first-child{
    margin-left: 4.5rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-18:first-child{
    margin-right: 4.5rem;
  }

  [dir="ltr"] .lg\\:first\\:me-18:first-child{
    margin-right: 4.5rem;
  }

  [dir="rtl"] .lg\\:first\\:me-18:first-child{
    margin-left: 4.5rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-20:first-child{
    margin-left: 5rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-20:first-child{
    margin-right: 5rem;
  }

  [dir="ltr"] .lg\\:first\\:me-20:first-child{
    margin-right: 5rem;
  }

  [dir="rtl"] .lg\\:first\\:me-20:first-child{
    margin-left: 5rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-22:first-child{
    margin-left: 5.5rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-22:first-child{
    margin-right: 5.5rem;
  }

  [dir="ltr"] .lg\\:first\\:me-22:first-child{
    margin-right: 5.5rem;
  }

  [dir="rtl"] .lg\\:first\\:me-22:first-child{
    margin-left: 5.5rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-23:first-child{
    margin-left: 5.75rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-23:first-child{
    margin-right: 5.75rem;
  }

  [dir="ltr"] .lg\\:first\\:me-23:first-child{
    margin-right: 5.75rem;
  }

  [dir="rtl"] .lg\\:first\\:me-23:first-child{
    margin-left: 5.75rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-24:first-child{
    margin-left: 6rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-24:first-child{
    margin-right: 6rem;
  }

  [dir="ltr"] .lg\\:first\\:me-24:first-child{
    margin-right: 6rem;
  }

  [dir="rtl"] .lg\\:first\\:me-24:first-child{
    margin-left: 6rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-25:first-child{
    margin-left: 6.25rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-25:first-child{
    margin-right: 6.25rem;
  }

  [dir="ltr"] .lg\\:first\\:me-25:first-child{
    margin-right: 6.25rem;
  }

  [dir="rtl"] .lg\\:first\\:me-25:first-child{
    margin-left: 6.25rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-26:first-child{
    margin-left: 6.5rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-26:first-child{
    margin-right: 6.5rem;
  }

  [dir="ltr"] .lg\\:first\\:me-26:first-child{
    margin-right: 6.5rem;
  }

  [dir="rtl"] .lg\\:first\\:me-26:first-child{
    margin-left: 6.5rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-28:first-child{
    margin-left: 7rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-28:first-child{
    margin-right: 7rem;
  }

  [dir="ltr"] .lg\\:first\\:me-28:first-child{
    margin-right: 7rem;
  }

  [dir="rtl"] .lg\\:first\\:me-28:first-child{
    margin-left: 7rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-30:first-child{
    margin-left: 7.5rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-30:first-child{
    margin-right: 7.5rem;
  }

  [dir="ltr"] .lg\\:first\\:me-30:first-child{
    margin-right: 7.5rem;
  }

  [dir="rtl"] .lg\\:first\\:me-30:first-child{
    margin-left: 7.5rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-32:first-child{
    margin-left: 8rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-32:first-child{
    margin-right: 8rem;
  }

  [dir="ltr"] .lg\\:first\\:me-32:first-child{
    margin-right: 8rem;
  }

  [dir="rtl"] .lg\\:first\\:me-32:first-child{
    margin-left: 8rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-34:first-child{
    margin-left: 8.5rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-34:first-child{
    margin-right: 8.5rem;
  }

  [dir="ltr"] .lg\\:first\\:me-34:first-child{
    margin-right: 8.5rem;
  }

  [dir="rtl"] .lg\\:first\\:me-34:first-child{
    margin-left: 8.5rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-40:first-child{
    margin-left: 10rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-40:first-child{
    margin-right: 10rem;
  }

  [dir="ltr"] .lg\\:first\\:me-40:first-child{
    margin-right: 10rem;
  }

  [dir="rtl"] .lg\\:first\\:me-40:first-child{
    margin-left: 10rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-42:first-child{
    margin-left: 10.5rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-42:first-child{
    margin-right: 10.5rem;
  }

  [dir="ltr"] .lg\\:first\\:me-42:first-child{
    margin-right: 10.5rem;
  }

  [dir="rtl"] .lg\\:first\\:me-42:first-child{
    margin-left: 10.5rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-44:first-child{
    margin-left: 11rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-44:first-child{
    margin-right: 11rem;
  }

  [dir="ltr"] .lg\\:first\\:me-44:first-child{
    margin-right: 11rem;
  }

  [dir="rtl"] .lg\\:first\\:me-44:first-child{
    margin-left: 11rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-48:first-child{
    margin-left: 12rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-48:first-child{
    margin-right: 12rem;
  }

  [dir="ltr"] .lg\\:first\\:me-48:first-child{
    margin-right: 12rem;
  }

  [dir="rtl"] .lg\\:first\\:me-48:first-child{
    margin-left: 12rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-52:first-child{
    margin-left: 13rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-52:first-child{
    margin-right: 13rem;
  }

  [dir="ltr"] .lg\\:first\\:me-52:first-child{
    margin-right: 13rem;
  }

  [dir="rtl"] .lg\\:first\\:me-52:first-child{
    margin-left: 13rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-54:first-child{
    margin-left: 13.5rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-54:first-child{
    margin-right: 13.5rem;
  }

  [dir="ltr"] .lg\\:first\\:me-54:first-child{
    margin-right: 13.5rem;
  }

  [dir="rtl"] .lg\\:first\\:me-54:first-child{
    margin-left: 13.5rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-56:first-child{
    margin-left: 14rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-56:first-child{
    margin-right: 14rem;
  }

  [dir="ltr"] .lg\\:first\\:me-56:first-child{
    margin-right: 14rem;
  }

  [dir="rtl"] .lg\\:first\\:me-56:first-child{
    margin-left: 14rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-60:first-child{
    margin-left: 15rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-60:first-child{
    margin-right: 15rem;
  }

  [dir="ltr"] .lg\\:first\\:me-60:first-child{
    margin-right: 15rem;
  }

  [dir="rtl"] .lg\\:first\\:me-60:first-child{
    margin-left: 15rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-64:first-child{
    margin-left: 16rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-64:first-child{
    margin-right: 16rem;
  }

  [dir="ltr"] .lg\\:first\\:me-64:first-child{
    margin-right: 16rem;
  }

  [dir="rtl"] .lg\\:first\\:me-64:first-child{
    margin-left: 16rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-68:first-child{
    margin-left: 17rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-68:first-child{
    margin-right: 17rem;
  }

  [dir="ltr"] .lg\\:first\\:me-68:first-child{
    margin-right: 17rem;
  }

  [dir="rtl"] .lg\\:first\\:me-68:first-child{
    margin-left: 17rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-72:first-child{
    margin-left: 18rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-72:first-child{
    margin-right: 18rem;
  }

  [dir="ltr"] .lg\\:first\\:me-72:first-child{
    margin-right: 18rem;
  }

  [dir="rtl"] .lg\\:first\\:me-72:first-child{
    margin-left: 18rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-74:first-child{
    margin-left: 18.5rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-74:first-child{
    margin-right: 18.5rem;
  }

  [dir="ltr"] .lg\\:first\\:me-74:first-child{
    margin-right: 18.5rem;
  }

  [dir="rtl"] .lg\\:first\\:me-74:first-child{
    margin-left: 18.5rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-76:first-child{
    margin-left: 19rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-76:first-child{
    margin-right: 19rem;
  }

  [dir="ltr"] .lg\\:first\\:me-76:first-child{
    margin-right: 19rem;
  }

  [dir="rtl"] .lg\\:first\\:me-76:first-child{
    margin-left: 19rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-78:first-child{
    margin-left: 19.5rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-78:first-child{
    margin-right: 19.5rem;
  }

  [dir="ltr"] .lg\\:first\\:me-78:first-child{
    margin-right: 19.5rem;
  }

  [dir="rtl"] .lg\\:first\\:me-78:first-child{
    margin-left: 19.5rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-80:first-child{
    margin-left: 20rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-80:first-child{
    margin-right: 20rem;
  }

  [dir="ltr"] .lg\\:first\\:me-80:first-child{
    margin-right: 20rem;
  }

  [dir="rtl"] .lg\\:first\\:me-80:first-child{
    margin-left: 20rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-82:first-child{
    margin-left: 20.5rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-82:first-child{
    margin-right: 20.5rem;
  }

  [dir="ltr"] .lg\\:first\\:me-82:first-child{
    margin-right: 20.5rem;
  }

  [dir="rtl"] .lg\\:first\\:me-82:first-child{
    margin-left: 20.5rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-84:first-child{
    margin-left: 21rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-84:first-child{
    margin-right: 21rem;
  }

  [dir="ltr"] .lg\\:first\\:me-84:first-child{
    margin-right: 21rem;
  }

  [dir="rtl"] .lg\\:first\\:me-84:first-child{
    margin-left: 21rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-88:first-child{
    margin-left: 22rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-88:first-child{
    margin-right: 22rem;
  }

  [dir="ltr"] .lg\\:first\\:me-88:first-child{
    margin-right: 22rem;
  }

  [dir="rtl"] .lg\\:first\\:me-88:first-child{
    margin-left: 22rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-92:first-child{
    margin-left: 23rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-92:first-child{
    margin-right: 23rem;
  }

  [dir="ltr"] .lg\\:first\\:me-92:first-child{
    margin-right: 23rem;
  }

  [dir="rtl"] .lg\\:first\\:me-92:first-child{
    margin-left: 23rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-96:first-child{
    margin-left: 24rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-96:first-child{
    margin-right: 24rem;
  }

  [dir="ltr"] .lg\\:first\\:me-96:first-child{
    margin-right: 24rem;
  }

  [dir="rtl"] .lg\\:first\\:me-96:first-child{
    margin-left: 24rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-98:first-child{
    margin-left: 24.5rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-98:first-child{
    margin-right: 24.5rem;
  }

  [dir="ltr"] .lg\\:first\\:me-98:first-child{
    margin-right: 24.5rem;
  }

  [dir="rtl"] .lg\\:first\\:me-98:first-child{
    margin-left: 24.5rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-100:first-child{
    margin-left: 25rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-100:first-child{
    margin-right: 25rem;
  }

  [dir="ltr"] .lg\\:first\\:me-100:first-child{
    margin-right: 25rem;
  }

  [dir="rtl"] .lg\\:first\\:me-100:first-child{
    margin-left: 25rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-104:first-child{
    margin-left: 26rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-104:first-child{
    margin-right: 26rem;
  }

  [dir="ltr"] .lg\\:first\\:me-104:first-child{
    margin-right: 26rem;
  }

  [dir="rtl"] .lg\\:first\\:me-104:first-child{
    margin-left: 26rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-112:first-child{
    margin-left: 28rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-112:first-child{
    margin-right: 28rem;
  }

  [dir="ltr"] .lg\\:first\\:me-112:first-child{
    margin-right: 28rem;
  }

  [dir="rtl"] .lg\\:first\\:me-112:first-child{
    margin-left: 28rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-124:first-child{
    margin-left: 31rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-124:first-child{
    margin-right: 31rem;
  }

  [dir="ltr"] .lg\\:first\\:me-124:first-child{
    margin-right: 31rem;
  }

  [dir="rtl"] .lg\\:first\\:me-124:first-child{
    margin-left: 31rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-128:first-child{
    margin-left: 32rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-128:first-child{
    margin-right: 32rem;
  }

  [dir="ltr"] .lg\\:first\\:me-128:first-child{
    margin-right: 32rem;
  }

  [dir="rtl"] .lg\\:first\\:me-128:first-child{
    margin-left: 32rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-140:first-child{
    margin-left: 35rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-140:first-child{
    margin-right: 35rem;
  }

  [dir="ltr"] .lg\\:first\\:me-140:first-child{
    margin-right: 35rem;
  }

  [dir="rtl"] .lg\\:first\\:me-140:first-child{
    margin-left: 35rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-152:first-child{
    margin-left: 38rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-152:first-child{
    margin-right: 38rem;
  }

  [dir="ltr"] .lg\\:first\\:me-152:first-child{
    margin-right: 38rem;
  }

  [dir="rtl"] .lg\\:first\\:me-152:first-child{
    margin-left: 38rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-160:first-child{
    margin-left: 40rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-160:first-child{
    margin-right: 40rem;
  }

  [dir="ltr"] .lg\\:first\\:me-160:first-child{
    margin-right: 40rem;
  }

  [dir="rtl"] .lg\\:first\\:me-160:first-child{
    margin-left: 40rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-162:first-child{
    margin-left: 41rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-162:first-child{
    margin-right: 41rem;
  }

  [dir="ltr"] .lg\\:first\\:me-162:first-child{
    margin-right: 41rem;
  }

  [dir="rtl"] .lg\\:first\\:me-162:first-child{
    margin-left: 41rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-192:first-child{
    margin-left: 48rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-192:first-child{
    margin-right: 48rem;
  }

  [dir="ltr"] .lg\\:first\\:me-192:first-child{
    margin-right: 48rem;
  }

  [dir="rtl"] .lg\\:first\\:me-192:first-child{
    margin-left: 48rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-208:first-child{
    margin-left: 52rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-208:first-child{
    margin-right: 52rem;
  }

  [dir="ltr"] .lg\\:first\\:me-208:first-child{
    margin-right: 52rem;
  }

  [dir="rtl"] .lg\\:first\\:me-208:first-child{
    margin-left: 52rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-224:first-child{
    margin-left: 56rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-224:first-child{
    margin-right: 56rem;
  }

  [dir="ltr"] .lg\\:first\\:me-224:first-child{
    margin-right: 56rem;
  }

  [dir="rtl"] .lg\\:first\\:me-224:first-child{
    margin-left: 56rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-256:first-child{
    margin-left: 64rem;
  }

  [dir="rtl"] .lg\\:first\\:ms-256:first-child{
    margin-right: 64rem;
  }

  [dir="ltr"] .lg\\:first\\:me-256:first-child{
    margin-right: 64rem;
  }

  [dir="rtl"] .lg\\:first\\:me-256:first-child{
    margin-left: 64rem;
  }

  [dir="ltr"] .lg\\:first\\:ms-auto:first-child{
    margin-left: auto;
  }

  [dir="rtl"] .lg\\:first\\:ms-auto:first-child{
    margin-right: auto;
  }

  [dir="ltr"] .lg\\:first\\:me-auto:first-child{
    margin-right: auto;
  }

  [dir="rtl"] .lg\\:first\\:me-auto:first-child{
    margin-left: auto;
  }

  [dir="ltr"] .lg\\:first\\:ms-px:first-child{
    margin-left: 1px;
  }

  [dir="rtl"] .lg\\:first\\:ms-px:first-child{
    margin-right: 1px;
  }

  [dir="ltr"] .lg\\:first\\:me-px:first-child{
    margin-right: 1px;
  }

  [dir="rtl"] .lg\\:first\\:me-px:first-child{
    margin-left: 1px;
  }

  [dir="ltr"] .lg\\:first\\:-ms-1:first-child{
    margin-left: -0.25rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-1:first-child{
    margin-right: -0.25rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-1:first-child{
    margin-right: -0.25rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-1:first-child{
    margin-left: -0.25rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-2:first-child{
    margin-left: -0.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-2:first-child{
    margin-right: -0.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-2:first-child{
    margin-right: -0.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-2:first-child{
    margin-left: -0.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-3:first-child{
    margin-left: -0.75rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-3:first-child{
    margin-right: -0.75rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-3:first-child{
    margin-right: -0.75rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-3:first-child{
    margin-left: -0.75rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-4:first-child{
    margin-left: -1rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-4:first-child{
    margin-right: -1rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-4:first-child{
    margin-right: -1rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-4:first-child{
    margin-left: -1rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-5:first-child{
    margin-left: -1.25rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-5:first-child{
    margin-right: -1.25rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-5:first-child{
    margin-right: -1.25rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-5:first-child{
    margin-left: -1.25rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-6:first-child{
    margin-left: -1.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-6:first-child{
    margin-right: -1.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-6:first-child{
    margin-right: -1.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-6:first-child{
    margin-left: -1.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-7:first-child{
    margin-left: -1.75rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-7:first-child{
    margin-right: -1.75rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-7:first-child{
    margin-right: -1.75rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-7:first-child{
    margin-left: -1.75rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-8:first-child{
    margin-left: -2rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-8:first-child{
    margin-right: -2rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-8:first-child{
    margin-right: -2rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-8:first-child{
    margin-left: -2rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-9:first-child{
    margin-left: -2.25rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-9:first-child{
    margin-right: -2.25rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-9:first-child{
    margin-right: -2.25rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-9:first-child{
    margin-left: -2.25rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-10:first-child{
    margin-left: -2.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-10:first-child{
    margin-right: -2.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-10:first-child{
    margin-right: -2.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-10:first-child{
    margin-left: -2.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-11:first-child{
    margin-left: -2.75rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-11:first-child{
    margin-right: -2.75rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-11:first-child{
    margin-right: -2.75rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-11:first-child{
    margin-left: -2.75rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-12:first-child{
    margin-left: -3rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-12:first-child{
    margin-right: -3rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-12:first-child{
    margin-right: -3rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-12:first-child{
    margin-left: -3rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-14:first-child{
    margin-left: -3.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-14:first-child{
    margin-right: -3.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-14:first-child{
    margin-right: -3.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-14:first-child{
    margin-left: -3.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-15:first-child{
    margin-left: -3.75rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-15:first-child{
    margin-right: -3.75rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-15:first-child{
    margin-right: -3.75rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-15:first-child{
    margin-left: -3.75rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-16:first-child{
    margin-left: -4rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-16:first-child{
    margin-right: -4rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-16:first-child{
    margin-right: -4rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-16:first-child{
    margin-left: -4rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-18:first-child{
    margin-left: -4.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-18:first-child{
    margin-right: -4.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-18:first-child{
    margin-right: -4.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-18:first-child{
    margin-left: -4.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-20:first-child{
    margin-left: -5rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-20:first-child{
    margin-right: -5rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-20:first-child{
    margin-right: -5rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-20:first-child{
    margin-left: -5rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-22:first-child{
    margin-left: -5.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-22:first-child{
    margin-right: -5.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-22:first-child{
    margin-right: -5.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-22:first-child{
    margin-left: -5.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-23:first-child{
    margin-left: -5.75rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-23:first-child{
    margin-right: -5.75rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-23:first-child{
    margin-right: -5.75rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-23:first-child{
    margin-left: -5.75rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-24:first-child{
    margin-left: -6rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-24:first-child{
    margin-right: -6rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-24:first-child{
    margin-right: -6rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-24:first-child{
    margin-left: -6rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-25:first-child{
    margin-left: -6.25rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-25:first-child{
    margin-right: -6.25rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-25:first-child{
    margin-right: -6.25rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-25:first-child{
    margin-left: -6.25rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-26:first-child{
    margin-left: -6.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-26:first-child{
    margin-right: -6.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-26:first-child{
    margin-right: -6.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-26:first-child{
    margin-left: -6.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-28:first-child{
    margin-left: -7rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-28:first-child{
    margin-right: -7rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-28:first-child{
    margin-right: -7rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-28:first-child{
    margin-left: -7rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-30:first-child{
    margin-left: -7.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-30:first-child{
    margin-right: -7.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-30:first-child{
    margin-right: -7.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-30:first-child{
    margin-left: -7.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-32:first-child{
    margin-left: -8rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-32:first-child{
    margin-right: -8rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-32:first-child{
    margin-right: -8rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-32:first-child{
    margin-left: -8rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-34:first-child{
    margin-left: -8.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-34:first-child{
    margin-right: -8.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-34:first-child{
    margin-right: -8.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-34:first-child{
    margin-left: -8.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-40:first-child{
    margin-left: -10rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-40:first-child{
    margin-right: -10rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-40:first-child{
    margin-right: -10rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-40:first-child{
    margin-left: -10rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-42:first-child{
    margin-left: -10.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-42:first-child{
    margin-right: -10.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-42:first-child{
    margin-right: -10.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-42:first-child{
    margin-left: -10.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-44:first-child{
    margin-left: -11rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-44:first-child{
    margin-right: -11rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-44:first-child{
    margin-right: -11rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-44:first-child{
    margin-left: -11rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-48:first-child{
    margin-left: -12rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-48:first-child{
    margin-right: -12rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-48:first-child{
    margin-right: -12rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-48:first-child{
    margin-left: -12rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-52:first-child{
    margin-left: -13rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-52:first-child{
    margin-right: -13rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-52:first-child{
    margin-right: -13rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-52:first-child{
    margin-left: -13rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-54:first-child{
    margin-left: -13.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-54:first-child{
    margin-right: -13.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-54:first-child{
    margin-right: -13.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-54:first-child{
    margin-left: -13.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-56:first-child{
    margin-left: -14rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-56:first-child{
    margin-right: -14rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-56:first-child{
    margin-right: -14rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-56:first-child{
    margin-left: -14rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-60:first-child{
    margin-left: -15rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-60:first-child{
    margin-right: -15rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-60:first-child{
    margin-right: -15rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-60:first-child{
    margin-left: -15rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-64:first-child{
    margin-left: -16rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-64:first-child{
    margin-right: -16rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-64:first-child{
    margin-right: -16rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-64:first-child{
    margin-left: -16rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-68:first-child{
    margin-left: -17rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-68:first-child{
    margin-right: -17rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-68:first-child{
    margin-right: -17rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-68:first-child{
    margin-left: -17rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-72:first-child{
    margin-left: -18rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-72:first-child{
    margin-right: -18rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-72:first-child{
    margin-right: -18rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-72:first-child{
    margin-left: -18rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-74:first-child{
    margin-left: -18.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-74:first-child{
    margin-right: -18.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-74:first-child{
    margin-right: -18.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-74:first-child{
    margin-left: -18.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-76:first-child{
    margin-left: -19rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-76:first-child{
    margin-right: -19rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-76:first-child{
    margin-right: -19rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-76:first-child{
    margin-left: -19rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-78:first-child{
    margin-left: -19.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-78:first-child{
    margin-right: -19.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-78:first-child{
    margin-right: -19.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-78:first-child{
    margin-left: -19.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-80:first-child{
    margin-left: -20rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-80:first-child{
    margin-right: -20rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-80:first-child{
    margin-right: -20rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-80:first-child{
    margin-left: -20rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-82:first-child{
    margin-left: -20.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-82:first-child{
    margin-right: -20.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-82:first-child{
    margin-right: -20.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-82:first-child{
    margin-left: -20.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-84:first-child{
    margin-left: -21rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-84:first-child{
    margin-right: -21rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-84:first-child{
    margin-right: -21rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-84:first-child{
    margin-left: -21rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-88:first-child{
    margin-left: -22rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-88:first-child{
    margin-right: -22rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-88:first-child{
    margin-right: -22rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-88:first-child{
    margin-left: -22rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-92:first-child{
    margin-left: -23rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-92:first-child{
    margin-right: -23rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-92:first-child{
    margin-right: -23rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-92:first-child{
    margin-left: -23rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-96:first-child{
    margin-left: -24rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-96:first-child{
    margin-right: -24rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-96:first-child{
    margin-right: -24rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-96:first-child{
    margin-left: -24rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-98:first-child{
    margin-left: -24.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-98:first-child{
    margin-right: -24.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-98:first-child{
    margin-right: -24.5rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-98:first-child{
    margin-left: -24.5rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-100:first-child{
    margin-left: -25rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-100:first-child{
    margin-right: -25rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-100:first-child{
    margin-right: -25rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-100:first-child{
    margin-left: -25rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-104:first-child{
    margin-left: -26rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-104:first-child{
    margin-right: -26rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-104:first-child{
    margin-right: -26rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-104:first-child{
    margin-left: -26rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-112:first-child{
    margin-left: -28rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-112:first-child{
    margin-right: -28rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-112:first-child{
    margin-right: -28rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-112:first-child{
    margin-left: -28rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-124:first-child{
    margin-left: -31rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-124:first-child{
    margin-right: -31rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-124:first-child{
    margin-right: -31rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-124:first-child{
    margin-left: -31rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-128:first-child{
    margin-left: -32rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-128:first-child{
    margin-right: -32rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-128:first-child{
    margin-right: -32rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-128:first-child{
    margin-left: -32rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-140:first-child{
    margin-left: -35rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-140:first-child{
    margin-right: -35rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-140:first-child{
    margin-right: -35rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-140:first-child{
    margin-left: -35rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-152:first-child{
    margin-left: -38rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-152:first-child{
    margin-right: -38rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-152:first-child{
    margin-right: -38rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-152:first-child{
    margin-left: -38rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-160:first-child{
    margin-left: -40rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-160:first-child{
    margin-right: -40rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-160:first-child{
    margin-right: -40rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-160:first-child{
    margin-left: -40rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-162:first-child{
    margin-left: -41rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-162:first-child{
    margin-right: -41rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-162:first-child{
    margin-right: -41rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-162:first-child{
    margin-left: -41rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-192:first-child{
    margin-left: -48rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-192:first-child{
    margin-right: -48rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-192:first-child{
    margin-right: -48rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-192:first-child{
    margin-left: -48rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-208:first-child{
    margin-left: -52rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-208:first-child{
    margin-right: -52rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-208:first-child{
    margin-right: -52rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-208:first-child{
    margin-left: -52rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-224:first-child{
    margin-left: -56rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-224:first-child{
    margin-right: -56rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-224:first-child{
    margin-right: -56rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-224:first-child{
    margin-left: -56rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-256:first-child{
    margin-left: -64rem;
  }

  [dir="rtl"] .lg\\:first\\:-ms-256:first-child{
    margin-right: -64rem;
  }

  [dir="ltr"] .lg\\:first\\:-me-256:first-child{
    margin-right: -64rem;
  }

  [dir="rtl"] .lg\\:first\\:-me-256:first-child{
    margin-left: -64rem;
  }

  [dir="ltr"] .lg\\:first\\:-ms-px:first-child{
    margin-left: -1px;
  }

  [dir="rtl"] .lg\\:first\\:-ms-px:first-child{
    margin-right: -1px;
  }

  [dir="ltr"] .lg\\:first\\:-me-px:first-child{
    margin-right: -1px;
  }

  [dir="rtl"] .lg\\:first\\:-me-px:first-child{
    margin-left: -1px;
  }

  [dir="rtl"] .lg\\:start-0{
    right: 0;
  }

  [dir="rtl"] .lg\\:end-0{
    left: 0;
  }

  [dir="ltr"] .lg\\:end-0{
    right: 0;
  }

  [dir="ltr"] .lg\\:start-0{
    left: 0;
  }

  [dir="rtl"] .lg\\:start-auto{
    right: auto;
  }

  [dir="rtl"] .lg\\:end-auto{
    left: auto;
  }

  [dir="ltr"] .lg\\:end-auto{
    right: auto;
  }

  [dir="ltr"] .lg\\:start-auto{
    left: auto;
  }

  [dir="ltr"] .lg\\:rounded-e-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .lg\\:rounded-s-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .lg\\:rounded-e-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .lg\\:rounded-s-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .lg\\:rounded-e-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .lg\\:rounded-s-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .lg\\:rounded-e-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .lg\\:rounded-s-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .lg\\:rounded-e{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .lg\\:rounded-s{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .lg\\:rounded-e{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .lg\\:rounded-s{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .lg\\:rounded-e-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .lg\\:rounded-s-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .lg\\:rounded-e-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .lg\\:rounded-s-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .lg\\:rounded-e-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .lg\\:rounded-s-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .lg\\:rounded-e-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .lg\\:rounded-s-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .lg\\:rounded-e-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .lg\\:rounded-s-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .lg\\:rounded-e-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .lg\\:rounded-s-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .lg\\:rounded-ts-none{
    border-top-left-radius: 0;
  }

  [dir="ltr"] .lg\\:rounded-te-none{
    border-top-right-radius: 0;
  }

  [dir="ltr"] .lg\\:rounded-be-none{
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .lg\\:rounded-bs-none{
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .lg\\:rounded-te-none{
    border-top-left-radius: 0;
  }

  [dir="rtl"] .lg\\:rounded-ts-none{
    border-top-right-radius: 0;
  }

  [dir="rtl"] .lg\\:rounded-bs-none{
    border-bottom-right-radius: 0;
  }

  [dir="rtl"] .lg\\:rounded-be-none{
    border-bottom-left-radius: 0;
  }

  [dir="ltr"] .lg\\:rounded-ts-sm{
    border-top-left-radius: .25rem;
  }

  [dir="ltr"] .lg\\:rounded-te-sm{
    border-top-right-radius: .25rem;
  }

  [dir="ltr"] .lg\\:rounded-be-sm{
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .lg\\:rounded-bs-sm{
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .lg\\:rounded-te-sm{
    border-top-left-radius: .25rem;
  }

  [dir="rtl"] .lg\\:rounded-ts-sm{
    border-top-right-radius: .25rem;
  }

  [dir="rtl"] .lg\\:rounded-bs-sm{
    border-bottom-right-radius: .25rem;
  }

  [dir="rtl"] .lg\\:rounded-be-sm{
    border-bottom-left-radius: .25rem;
  }

  [dir="ltr"] .lg\\:rounded-ts{
    border-top-left-radius: .375rem;
  }

  [dir="ltr"] .lg\\:rounded-te{
    border-top-right-radius: .375rem;
  }

  [dir="ltr"] .lg\\:rounded-be{
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .lg\\:rounded-bs{
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .lg\\:rounded-te{
    border-top-left-radius: .375rem;
  }

  [dir="rtl"] .lg\\:rounded-ts{
    border-top-right-radius: .375rem;
  }

  [dir="rtl"] .lg\\:rounded-bs{
    border-bottom-right-radius: .375rem;
  }

  [dir="rtl"] .lg\\:rounded-be{
    border-bottom-left-radius: .375rem;
  }

  [dir="ltr"] .lg\\:rounded-ts-lg{
    border-top-left-radius: .5rem;
  }

  [dir="ltr"] .lg\\:rounded-te-lg{
    border-top-right-radius: .5rem;
  }

  [dir="ltr"] .lg\\:rounded-be-lg{
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .lg\\:rounded-bs-lg{
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .lg\\:rounded-te-lg{
    border-top-left-radius: .5rem;
  }

  [dir="rtl"] .lg\\:rounded-ts-lg{
    border-top-right-radius: .5rem;
  }

  [dir="rtl"] .lg\\:rounded-bs-lg{
    border-bottom-right-radius: .5rem;
  }

  [dir="rtl"] .lg\\:rounded-be-lg{
    border-bottom-left-radius: .5rem;
  }

  [dir="ltr"] .lg\\:rounded-ts-xl{
    border-top-left-radius: .75rem;
  }

  [dir="ltr"] .lg\\:rounded-te-xl{
    border-top-right-radius: .75rem;
  }

  [dir="ltr"] .lg\\:rounded-be-xl{
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .lg\\:rounded-bs-xl{
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .lg\\:rounded-te-xl{
    border-top-left-radius: .75rem;
  }

  [dir="rtl"] .lg\\:rounded-ts-xl{
    border-top-right-radius: .75rem;
  }

  [dir="rtl"] .lg\\:rounded-bs-xl{
    border-bottom-right-radius: .75rem;
  }

  [dir="rtl"] .lg\\:rounded-be-xl{
    border-bottom-left-radius: .75rem;
  }

  [dir="ltr"] .lg\\:rounded-ts-full{
    border-top-left-radius: 9999px;
  }

  [dir="ltr"] .lg\\:rounded-te-full{
    border-top-right-radius: 9999px;
  }

  [dir="ltr"] .lg\\:rounded-be-full{
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .lg\\:rounded-bs-full{
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .lg\\:rounded-te-full{
    border-top-left-radius: 9999px;
  }

  [dir="rtl"] .lg\\:rounded-ts-full{
    border-top-right-radius: 9999px;
  }

  [dir="rtl"] .lg\\:rounded-bs-full{
    border-bottom-right-radius: 9999px;
  }

  [dir="rtl"] .lg\\:rounded-be-full{
    border-bottom-left-radius: 9999px;
  }

  [dir="ltr"] .lg\\:clear-start{
    clear: left;
  }

  [dir="ltr"] .lg\\:clear-end{
    clear: right;
  }

  [dir="rtl"] .lg\\:clear-start{
    clear: right;
  }

  [dir="rtl"] .lg\\:clear-end{
    clear: left;
  }

  [dir="rtl"] .lg\\:float-start{
    float: right;
  }

  [dir="rtl"] .lg\\:float-end{
    float: left;
  }

  [dir="ltr"] .lg\\:float-end{
    float: right;
  }

  [dir="ltr"] .lg\\:float-start{
    float: left;
  }

  [dir="ltr"] .lg\\:border-e-0{
    border-right-width: 0;
  }

  [dir="rtl"] .lg\\:border-e-0{
    border-left-width: 0;
  }

  [dir="ltr"] .lg\\:border-s-0{
    border-left-width: 0;
  }

  [dir="rtl"] .lg\\:border-s-0{
    border-right-width: 0;
  }

  [dir="ltr"] .lg\\:border-e-2{
    border-right-width: 2px;
  }

  [dir="rtl"] .lg\\:border-e-2{
    border-left-width: 2px;
  }

  [dir="ltr"] .lg\\:border-s-2{
    border-left-width: 2px;
  }

  [dir="rtl"] .lg\\:border-s-2{
    border-right-width: 2px;
  }

  [dir="ltr"] .lg\\:border-e-3{
    border-right-width: 3px;
  }

  [dir="rtl"] .lg\\:border-e-3{
    border-left-width: 3px;
  }

  [dir="ltr"] .lg\\:border-s-3{
    border-left-width: 3px;
  }

  [dir="rtl"] .lg\\:border-s-3{
    border-right-width: 3px;
  }

  [dir="ltr"] .lg\\:border-e-4{
    border-right-width: 4px;
  }

  [dir="rtl"] .lg\\:border-e-4{
    border-left-width: 4px;
  }

  [dir="ltr"] .lg\\:border-s-4{
    border-left-width: 4px;
  }

  [dir="rtl"] .lg\\:border-s-4{
    border-right-width: 4px;
  }

  [dir="ltr"] .lg\\:border-e-5{
    border-right-width: 5px;
  }

  [dir="rtl"] .lg\\:border-e-5{
    border-left-width: 5px;
  }

  [dir="ltr"] .lg\\:border-s-5{
    border-left-width: 5px;
  }

  [dir="rtl"] .lg\\:border-s-5{
    border-right-width: 5px;
  }

  [dir="ltr"] .lg\\:border-e-6{
    border-right-width: 6px;
  }

  [dir="rtl"] .lg\\:border-e-6{
    border-left-width: 6px;
  }

  [dir="ltr"] .lg\\:border-s-6{
    border-left-width: 6px;
  }

  [dir="rtl"] .lg\\:border-s-6{
    border-right-width: 6px;
  }

  [dir="ltr"] .lg\\:border-e-8{
    border-right-width: 8px;
  }

  [dir="rtl"] .lg\\:border-e-8{
    border-left-width: 8px;
  }

  [dir="ltr"] .lg\\:border-s-8{
    border-left-width: 8px;
  }

  [dir="rtl"] .lg\\:border-s-8{
    border-right-width: 8px;
  }

  [dir="ltr"] .lg\\:border-e{
    border-right-width: 1px;
  }

  [dir="rtl"] .lg\\:border-e{
    border-left-width: 1px;
  }

  [dir="ltr"] .lg\\:border-s{
    border-left-width: 1px;
  }

  [dir="rtl"] .lg\\:border-s{
    border-right-width: 1px;
  }

  [dir="ltr"] .lg\\:first\\:border-e-0:first-child{
    border-right-width: 0;
  }

  [dir="rtl"] .lg\\:first\\:border-e-0:first-child{
    border-left-width: 0;
  }

  [dir="ltr"] .lg\\:first\\:border-s-0:first-child{
    border-left-width: 0;
  }

  [dir="rtl"] .lg\\:first\\:border-s-0:first-child{
    border-right-width: 0;
  }

  [dir="ltr"] .lg\\:first\\:border-e-2:first-child{
    border-right-width: 2px;
  }

  [dir="rtl"] .lg\\:first\\:border-e-2:first-child{
    border-left-width: 2px;
  }

  [dir="ltr"] .lg\\:first\\:border-s-2:first-child{
    border-left-width: 2px;
  }

  [dir="rtl"] .lg\\:first\\:border-s-2:first-child{
    border-right-width: 2px;
  }

  [dir="ltr"] .lg\\:first\\:border-e-3:first-child{
    border-right-width: 3px;
  }

  [dir="rtl"] .lg\\:first\\:border-e-3:first-child{
    border-left-width: 3px;
  }

  [dir="ltr"] .lg\\:first\\:border-s-3:first-child{
    border-left-width: 3px;
  }

  [dir="rtl"] .lg\\:first\\:border-s-3:first-child{
    border-right-width: 3px;
  }

  [dir="ltr"] .lg\\:first\\:border-e-4:first-child{
    border-right-width: 4px;
  }

  [dir="rtl"] .lg\\:first\\:border-e-4:first-child{
    border-left-width: 4px;
  }

  [dir="ltr"] .lg\\:first\\:border-s-4:first-child{
    border-left-width: 4px;
  }

  [dir="rtl"] .lg\\:first\\:border-s-4:first-child{
    border-right-width: 4px;
  }

  [dir="ltr"] .lg\\:first\\:border-e-5:first-child{
    border-right-width: 5px;
  }

  [dir="rtl"] .lg\\:first\\:border-e-5:first-child{
    border-left-width: 5px;
  }

  [dir="ltr"] .lg\\:first\\:border-s-5:first-child{
    border-left-width: 5px;
  }

  [dir="rtl"] .lg\\:first\\:border-s-5:first-child{
    border-right-width: 5px;
  }

  [dir="ltr"] .lg\\:first\\:border-e-6:first-child{
    border-right-width: 6px;
  }

  [dir="rtl"] .lg\\:first\\:border-e-6:first-child{
    border-left-width: 6px;
  }

  [dir="ltr"] .lg\\:first\\:border-s-6:first-child{
    border-left-width: 6px;
  }

  [dir="rtl"] .lg\\:first\\:border-s-6:first-child{
    border-right-width: 6px;
  }

  [dir="ltr"] .lg\\:first\\:border-e-8:first-child{
    border-right-width: 8px;
  }

  [dir="rtl"] .lg\\:first\\:border-e-8:first-child{
    border-left-width: 8px;
  }

  [dir="ltr"] .lg\\:first\\:border-s-8:first-child{
    border-left-width: 8px;
  }

  [dir="rtl"] .lg\\:first\\:border-s-8:first-child{
    border-right-width: 8px;
  }

  [dir="ltr"] .lg\\:first\\:border-e:first-child{
    border-right-width: 1px;
  }

  [dir="rtl"] .lg\\:first\\:border-e:first-child{
    border-left-width: 1px;
  }

  [dir="ltr"] .lg\\:first\\:border-s:first-child{
    border-left-width: 1px;
  }

  [dir="rtl"] .lg\\:first\\:border-s:first-child{
    border-right-width: 1px;
  }

  [dir="rtl"] .lg\\:text-start{
    text-align: right;
  }

  [dir="rtl"] .lg\\:text-end{
    text-align: left;
  }

  [dir="ltr"] .lg\\:text-end{
    text-align: right;
  }

  [dir="ltr"] .lg\\:text-start{
    text-align: left;
  }

  [dir="ltr"] .lg\\:origin-top-start{
    transform-origin: top left;
  }

  [dir="ltr"] .lg\\:origin-top-end{
    transform-origin: top right;
  }

  [dir="ltr"] .lg\\:origin-bottom-start{
    transform-origin: bottom left;
  }

  [dir="ltr"] .lg\\:origin-bottom-end{
    transform-origin: bottom right;
  }

  [dir="ltr"] .lg\\:origin-start{
    transform-origin: left;
  }

  [dir="ltr"] .lg\\:origin-end{
    transform-origin: right;
  }

  [dir="rtl"] .lg\\:origin-top-start{
    transform-origin: top right;
  }

  [dir="rtl"] .lg\\:origin-top-end{
    transform-origin: top left;
  }

  [dir="rtl"] .lg\\:origin-bottom-start{
    transform-origin: bottom right;
  }

  [dir="rtl"] .lg\\:origin-bottom-end{
    transform-origin: bottom left;
  }

  [dir="rtl"] .lg\\:origin-start{
    transform-origin: right;
  }

  [dir="rtl"] .lg\\:origin-end{
    transform-origin: left;
  }

  [dir="ltr"] .lg\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .lg\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .lg\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .lg\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .lg\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .lg\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * (1 - var(--tw-space-s-reverse)));
  }

  .lg\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  .lg\\:space-s-reverse > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 1;
  }
}

@media (min-width: 1280px){
  .xl\\:prose{
    color: #4a5568;
    max-width: 65ch;
  }

  .xl\\:prose [class~="lead"]{
    color: #4a5568;
    font-size: 1.25em;
    line-height: 1.6;
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .xl\\:prose a{
    color: #1a202c;
    text-decoration: underline;
  }

  .xl\\:prose strong{
    color: #1a202c;
    font-weight: 600;
  }

  .xl\\:prose ol{
    counter-reset: list-counter;
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .xl\\:prose ol > li{
    position: relative;
    counter-increment: list-counter;
    padding-left: 1.75em;
  }

  .xl\\:prose ol > li::before{
    content: ;
    position: absolute;
    font-weight: 400;
    color: #718096;
  }

  .xl\\:prose ul > li{
    position: relative;
    padding-left: 1.75em;
  }

  .xl\\:prose ul > li::before{
    content: "";
    position: absolute;
    background-color: #cbd5e0;
    border-radius: 50%;
    width: 0.375em;
    height: 0.375em;
    top: calc(0.875em - 0.1875em);
    left: 0.25em;
  }

  .xl\\:prose hr{
    border-color: #e2e8f0;
    border-top-width: 1px;
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .xl\\:prose blockquote{
    font-weight: 500;
    font-style: italic;
    color: #1a202c;
    border-left-width: 0.25rem;
    border-left-color: #e2e8f0;
    quotes: "\\201C""\\201D""\\2018""\\2019";
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1em;
  }

  .xl\\:prose blockquote p:first-of-type::before{
    content: open-quote;
  }

  .xl\\:prose blockquote p:last-of-type::after{
    content: close-quote;
  }

  .xl\\:prose h1{
    color: #1a202c;
    font-weight: 800;
    font-size: 2.25em;
    margin-top: 0;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }

  .xl\\:prose h2{
    color: #1a202c;
    font-weight: 700;
    font-size: 1.5em;
    margin-top: 2em;
    margin-bottom: 1em;
    line-height: 1.3333333;
  }

  .xl\\:prose h3{
    color: #1a202c;
    font-weight: 600;
    font-size: 1.25em;
    margin-top: 1.6em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }

  .xl\\:prose h4{
    color: #1a202c;
    font-weight: 600;
    margin-top: 1.5em;
    margin-bottom: 0.5em;
    line-height: 1.5;
  }

  .xl\\:prose figure figcaption{
    color: #718096;
    font-size: 0.875em;
    line-height: 1.4285714;
    margin-top: 0.8571429em;
  }

  .xl\\:prose code{
    color: #1a202c;
    font-weight: 600;
    font-size: 0.875em;
  }

  .xl\\:prose code::before{
    content: "\`";
  }

  .xl\\:prose code::after{
    content: "\`";
  }

  .xl\\:prose pre{
    color: #e2e8f0;
    background-color: #2d3748;
    overflow-x: auto;
    font-size: 0.875em;
    line-height: 1.7142857;
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
    border-radius: 0.375rem;
    padding-top: 0.8571429em;
    padding-right: 1.1428571em;
    padding-bottom: 0.8571429em;
    padding-left: 1.1428571em;
  }

  .xl\\:prose pre code{
    background-color: transparent;
    border-width: 0;
    border-radius: 0;
    padding: 0;
    font-weight: 400;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
  }

  .xl\\:prose pre code::before{
    content: "";
  }

  .xl\\:prose pre code::after{
    content: "";
  }

  .xl\\:prose table{
    width: 100%;
    table-layout: auto;
    text-align: left;
    margin-top: 2em;
    margin-bottom: 2em;
    font-size: 0.875em;
    line-height: 1.7142857;
  }

  .xl\\:prose thead{
    color: #1a202c;
    font-weight: 600;
    border-bottom-width: 1px;
    border-bottom-color: #cbd5e0;
  }

  .xl\\:prose thead th{
    vertical-align: bottom;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }

  .xl\\:prose tbody tr{
    border-bottom-width: 1px;
    border-bottom-color: #e2e8f0;
  }

  .xl\\:prose tbody tr:last-child{
    border-bottom-width: 0;
  }

  .xl\\:prose tbody td{
    vertical-align: top;
    padding-top: 0.5714286em;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }

  .xl\\:prose{
    font-size: 1rem;
    line-height: 1.75;
  }

  .xl\\:prose p{
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .xl\\:prose img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .xl\\:prose video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .xl\\:prose figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .xl\\:prose figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .xl\\:prose h2 code{
    font-size: 0.875em;
  }

  .xl\\:prose h3 code{
    font-size: 0.9em;
  }

  .xl\\:prose ul{
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .xl\\:prose li{
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .xl\\:prose ol > li:before{
    left: 0;
  }

  .xl\\:prose > ul > li p{
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }

  .xl\\:prose > ul > li > *:first-child{
    margin-top: 1.25em;
  }

  .xl\\:prose > ul > li > *:last-child{
    margin-bottom: 1.25em;
  }

  .xl\\:prose > ol > li > *:first-child{
    margin-top: 1.25em;
  }

  .xl\\:prose > ol > li > *:last-child{
    margin-bottom: 1.25em;
  }

  .xl\\:prose ul ul, .xl\\:prose ul ol, .xl\\:prose ol ul, .xl\\:prose ol ol{
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }

  .xl\\:prose hr + *{
    margin-top: 0;
  }

  .xl\\:prose h2 + *{
    margin-top: 0;
  }

  .xl\\:prose h3 + *{
    margin-top: 0;
  }

  .xl\\:prose h4 + *{
    margin-top: 0;
  }

  .xl\\:prose thead th:first-child{
    padding-left: 0;
  }

  .xl\\:prose thead th:last-child{
    padding-right: 0;
  }

  .xl\\:prose tbody td:first-child{
    padding-left: 0;
  }

  .xl\\:prose tbody td:last-child{
    padding-right: 0;
  }

  .xl\\:prose > :first-child{
    margin-top: 0;
  }

  .xl\\:prose > :last-child{
    margin-bottom: 0;
  }

  .xl\\:prose-sm{
    font-size: 0.875rem;
    line-height: 1.7142857;
  }

  .xl\\:prose-sm p{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .xl\\:prose-sm [class~="lead"]{
    font-size: 1.2857143em;
    line-height: 1.5555556;
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .xl\\:prose-sm blockquote{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
    padding-left: 1.1111111em;
  }

  .xl\\:prose-sm h1{
    font-size: 2.1428571em;
    margin-top: 0;
    margin-bottom: 0.8em;
    line-height: 1.2;
  }

  .xl\\:prose-sm h2{
    font-size: 1.4285714em;
    margin-top: 1.6em;
    margin-bottom: 0.8em;
    line-height: 1.4;
  }

  .xl\\:prose-sm h3{
    font-size: 1.2857143em;
    margin-top: 1.5555556em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }

  .xl\\:prose-sm h4{
    margin-top: 1.4285714em;
    margin-bottom: 0.5714286em;
    line-height: 1.4285714;
  }

  .xl\\:prose-sm img{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .xl\\:prose-sm video{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .xl\\:prose-sm figure{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .xl\\:prose-sm figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .xl\\:prose-sm figure figcaption{
    font-size: 0.8571429em;
    line-height: 1.3333333;
    margin-top: 0.6666667em;
  }

  .xl\\:prose-sm code{
    font-size: 0.8571429em;
  }

  .xl\\:prose-sm h2 code{
    font-size: 0.9em;
  }

  .xl\\:prose-sm h3 code{
    font-size: 0.8888889em;
  }

  .xl\\:prose-sm pre{
    font-size: 0.8571429em;
    line-height: 1.6666667;
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    border-radius: 0.25rem;
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .xl\\:prose-sm ol{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .xl\\:prose-sm ul{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .xl\\:prose-sm li{
    margin-top: 0.2857143em;
    margin-bottom: 0.2857143em;
  }

  .xl\\:prose-sm ol > li{
    padding-left: 1.5714286em;
  }

  .xl\\:prose-sm ol > li:before{
    left: 0;
  }

  .xl\\:prose-sm ul > li{
    padding-left: 1.5714286em;
  }

  .xl\\:prose-sm ul > li::before{
    height: 0.3571429em;
    width: 0.3571429em;
    top: calc(0.8571429em - 0.1785714em);
    left: 0.2142857em;
  }

  .xl\\:prose-sm > ul > li p{
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }

  .xl\\:prose-sm > ul > li > *:first-child{
    margin-top: 1.1428571em;
  }

  .xl\\:prose-sm > ul > li > *:last-child{
    margin-bottom: 1.1428571em;
  }

  .xl\\:prose-sm > ol > li > *:first-child{
    margin-top: 1.1428571em;
  }

  .xl\\:prose-sm > ol > li > *:last-child{
    margin-bottom: 1.1428571em;
  }

  .xl\\:prose-sm ul ul, .xl\\:prose-sm ul ol, .xl\\:prose-sm ol ul, .xl\\:prose-sm ol ol{
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }

  .xl\\:prose-sm hr{
    margin-top: 2.8571429em;
    margin-bottom: 2.8571429em;
  }

  .xl\\:prose-sm hr + *{
    margin-top: 0;
  }

  .xl\\:prose-sm h2 + *{
    margin-top: 0;
  }

  .xl\\:prose-sm h3 + *{
    margin-top: 0;
  }

  .xl\\:prose-sm h4 + *{
    margin-top: 0;
  }

  .xl\\:prose-sm table{
    font-size: 0.8571429em;
    line-height: 1.5;
  }

  .xl\\:prose-sm thead th{
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .xl\\:prose-sm thead th:first-child{
    padding-left: 0;
  }

  .xl\\:prose-sm thead th:last-child{
    padding-right: 0;
  }

  .xl\\:prose-sm tbody td{
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .xl\\:prose-sm tbody td:first-child{
    padding-left: 0;
  }

  .xl\\:prose-sm tbody td:last-child{
    padding-right: 0;
  }

  .xl\\:prose-sm > :first-child{
    margin-top: 0;
  }

  .xl\\:prose-sm > :last-child{
    margin-bottom: 0;
  }

  .xl\\:prose-lg{
    font-size: 1.125rem;
    line-height: 1.7777778;
  }

  .xl\\:prose-lg p{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .xl\\:prose-lg [class~="lead"]{
    font-size: 1.2222222em;
    line-height: 1.4545455;
    margin-top: 1.0909091em;
    margin-bottom: 1.0909091em;
  }

  .xl\\:prose-lg blockquote{
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    padding-left: 1em;
  }

  .xl\\:prose-lg h1{
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.8333333em;
    line-height: 1;
  }

  .xl\\:prose-lg h2{
    font-size: 1.6666667em;
    margin-top: 1.8666667em;
    margin-bottom: 1.0666667em;
    line-height: 1.3333333;
  }

  .xl\\:prose-lg h3{
    font-size: 1.3333333em;
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }

  .xl\\:prose-lg h4{
    margin-top: 1.7777778em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }

  .xl\\:prose-lg img{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .xl\\:prose-lg video{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .xl\\:prose-lg figure{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .xl\\:prose-lg figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .xl\\:prose-lg figure figcaption{
    font-size: 0.8888889em;
    line-height: 1.5;
    margin-top: 1em;
  }

  .xl\\:prose-lg code{
    font-size: 0.8888889em;
  }

  .xl\\:prose-lg h2 code{
    font-size: 0.8666667em;
  }

  .xl\\:prose-lg h3 code{
    font-size: 0.875em;
  }

  .xl\\:prose-lg pre{
    font-size: 0.8888889em;
    line-height: 1.75;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.375rem;
    padding-top: 1em;
    padding-right: 1.5em;
    padding-bottom: 1em;
    padding-left: 1.5em;
  }

  .xl\\:prose-lg ol{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .xl\\:prose-lg ul{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .xl\\:prose-lg li{
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }

  .xl\\:prose-lg ol > li{
    padding-left: 1.6666667em;
  }

  .xl\\:prose-lg ol > li:before{
    left: 0;
  }

  .xl\\:prose-lg ul > li{
    padding-left: 1.6666667em;
  }

  .xl\\:prose-lg ul > li::before{
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8888889em - 0.1666667em);
    left: 0.2222222em;
  }

  .xl\\:prose-lg > ul > li p{
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .xl\\:prose-lg > ul > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .xl\\:prose-lg > ul > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .xl\\:prose-lg > ol > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .xl\\:prose-lg > ol > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .xl\\:prose-lg ul ul, .xl\\:prose-lg ul ol, .xl\\:prose-lg ol ul, .xl\\:prose-lg ol ol{
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .xl\\:prose-lg hr{
    margin-top: 3.1111111em;
    margin-bottom: 3.1111111em;
  }

  .xl\\:prose-lg hr + *{
    margin-top: 0;
  }

  .xl\\:prose-lg h2 + *{
    margin-top: 0;
  }

  .xl\\:prose-lg h3 + *{
    margin-top: 0;
  }

  .xl\\:prose-lg h4 + *{
    margin-top: 0;
  }

  .xl\\:prose-lg table{
    font-size: 0.8888889em;
    line-height: 1.5;
  }

  .xl\\:prose-lg thead th{
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }

  .xl\\:prose-lg thead th:first-child{
    padding-left: 0;
  }

  .xl\\:prose-lg thead th:last-child{
    padding-right: 0;
  }

  .xl\\:prose-lg tbody td{
    padding-top: 0.75em;
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }

  .xl\\:prose-lg tbody td:first-child{
    padding-left: 0;
  }

  .xl\\:prose-lg tbody td:last-child{
    padding-right: 0;
  }

  .xl\\:prose-lg > :first-child{
    margin-top: 0;
  }

  .xl\\:prose-lg > :last-child{
    margin-bottom: 0;
  }

  .xl\\:prose-xl{
    font-size: 1.25rem;
    line-height: 1.8;
  }

  .xl\\:prose-xl p{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .xl\\:prose-xl [class~="lead"]{
    font-size: 1.2em;
    line-height: 1.5;
    margin-top: 1em;
    margin-bottom: 1em;
  }

  .xl\\:prose-xl blockquote{
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1.0666667em;
  }

  .xl\\:prose-xl h1{
    font-size: 2.8em;
    margin-top: 0;
    margin-bottom: 0.8571429em;
    line-height: 1;
  }

  .xl\\:prose-xl h2{
    font-size: 1.8em;
    margin-top: 1.5555556em;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }

  .xl\\:prose-xl h3{
    font-size: 1.5em;
    margin-top: 1.6em;
    margin-bottom: 0.6666667em;
    line-height: 1.3333333;
  }

  .xl\\:prose-xl h4{
    margin-top: 1.8em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }

  .xl\\:prose-xl img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .xl\\:prose-xl video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .xl\\:prose-xl figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .xl\\:prose-xl figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .xl\\:prose-xl figure figcaption{
    font-size: 0.9em;
    line-height: 1.5555556;
    margin-top: 1em;
  }

  .xl\\:prose-xl code{
    font-size: 0.9em;
  }

  .xl\\:prose-xl h2 code{
    font-size: 0.8611111em;
  }

  .xl\\:prose-xl h3 code{
    font-size: 0.9em;
  }

  .xl\\:prose-xl pre{
    font-size: 0.9em;
    line-height: 1.7777778;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.1111111em;
    padding-right: 1.3333333em;
    padding-bottom: 1.1111111em;
    padding-left: 1.3333333em;
  }

  .xl\\:prose-xl ol{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .xl\\:prose-xl ul{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .xl\\:prose-xl li{
    margin-top: 0.6em;
    margin-bottom: 0.6em;
  }

  .xl\\:prose-xl ol > li{
    padding-left: 1.8em;
  }

  .xl\\:prose-xl ol > li:before{
    left: 0;
  }

  .xl\\:prose-xl ul > li{
    padding-left: 1.8em;
  }

  .xl\\:prose-xl ul > li::before{
    width: 0.35em;
    height: 0.35em;
    top: calc(0.9em - 0.175em);
    left: 0.25em;
  }

  .xl\\:prose-xl > ul > li p{
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }

  .xl\\:prose-xl > ul > li > *:first-child{
    margin-top: 1.2em;
  }

  .xl\\:prose-xl > ul > li > *:last-child{
    margin-bottom: 1.2em;
  }

  .xl\\:prose-xl > ol > li > *:first-child{
    margin-top: 1.2em;
  }

  .xl\\:prose-xl > ol > li > *:last-child{
    margin-bottom: 1.2em;
  }

  .xl\\:prose-xl ul ul, .xl\\:prose-xl ul ol, .xl\\:prose-xl ol ul, .xl\\:prose-xl ol ol{
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }

  .xl\\:prose-xl hr{
    margin-top: 2.8em;
    margin-bottom: 2.8em;
  }

  .xl\\:prose-xl hr + *{
    margin-top: 0;
  }

  .xl\\:prose-xl h2 + *{
    margin-top: 0;
  }

  .xl\\:prose-xl h3 + *{
    margin-top: 0;
  }

  .xl\\:prose-xl h4 + *{
    margin-top: 0;
  }

  .xl\\:prose-xl table{
    font-size: 0.9em;
    line-height: 1.5555556;
  }

  .xl\\:prose-xl thead th{
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }

  .xl\\:prose-xl thead th:first-child{
    padding-left: 0;
  }

  .xl\\:prose-xl thead th:last-child{
    padding-right: 0;
  }

  .xl\\:prose-xl tbody td{
    padding-top: 0.8888889em;
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }

  .xl\\:prose-xl tbody td:first-child{
    padding-left: 0;
  }

  .xl\\:prose-xl tbody td:last-child{
    padding-right: 0;
  }

  .xl\\:prose-xl > :first-child{
    margin-top: 0;
  }

  .xl\\:prose-xl > :last-child{
    margin-bottom: 0;
  }

  .xl\\:prose-2xl{
    font-size: 1.5rem;
    line-height: 1.6666667;
  }

  .xl\\:prose-2xl p{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .xl\\:prose-2xl [class~="lead"]{
    font-size: 1.25em;
    line-height: 1.4666667;
    margin-top: 1.0666667em;
    margin-bottom: 1.0666667em;
  }

  .xl\\:prose-2xl blockquote{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
    padding-left: 1.1111111em;
  }

  .xl\\:prose-2xl h1{
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.875em;
    line-height: 1;
  }

  .xl\\:prose-2xl h2{
    font-size: 2em;
    margin-top: 1.5em;
    margin-bottom: 0.8333333em;
    line-height: 1.0833333;
  }

  .xl\\:prose-2xl h3{
    font-size: 1.5em;
    margin-top: 1.5555556em;
    margin-bottom: 0.6666667em;
    line-height: 1.2222222;
  }

  .xl\\:prose-2xl h4{
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }

  .xl\\:prose-2xl img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .xl\\:prose-2xl video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .xl\\:prose-2xl figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .xl\\:prose-2xl figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .xl\\:prose-2xl figure figcaption{
    font-size: 0.8333333em;
    line-height: 1.6;
    margin-top: 1em;
  }

  .xl\\:prose-2xl code{
    font-size: 0.8333333em;
  }

  .xl\\:prose-2xl h2 code{
    font-size: 0.875em;
  }

  .xl\\:prose-2xl h3 code{
    font-size: 0.8888889em;
  }

  .xl\\:prose-2xl pre{
    font-size: 0.8333333em;
    line-height: 1.8;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.2em;
    padding-right: 1.6em;
    padding-bottom: 1.2em;
    padding-left: 1.6em;
  }

  .xl\\:prose-2xl ol{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .xl\\:prose-2xl ul{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .xl\\:prose-2xl li{
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .xl\\:prose-2xl ol > li{
    padding-left: 1.6666667em;
  }

  .xl\\:prose-2xl ol > li:before{
    left: 0;
  }

  .xl\\:prose-2xl ul > li{
    padding-left: 1.6666667em;
  }

  .xl\\:prose-2xl ul > li::before{
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8333333em - 0.1666667em);
    left: 0.25em;
  }

  .xl\\:prose-2xl > ul > li p{
    margin-top: 0.8333333em;
    margin-bottom: 0.8333333em;
  }

  .xl\\:prose-2xl > ul > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .xl\\:prose-2xl > ul > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .xl\\:prose-2xl > ol > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .xl\\:prose-2xl > ol > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .xl\\:prose-2xl ul ul, .xl\\:prose-2xl ul ol, .xl\\:prose-2xl ol ul, .xl\\:prose-2xl ol ol{
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }

  .xl\\:prose-2xl hr{
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .xl\\:prose-2xl hr + *{
    margin-top: 0;
  }

  .xl\\:prose-2xl h2 + *{
    margin-top: 0;
  }

  .xl\\:prose-2xl h3 + *{
    margin-top: 0;
  }

  .xl\\:prose-2xl h4 + *{
    margin-top: 0;
  }

  .xl\\:prose-2xl table{
    font-size: 0.8333333em;
    line-height: 1.4;
  }

  .xl\\:prose-2xl thead th{
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }

  .xl\\:prose-2xl thead th:first-child{
    padding-left: 0;
  }

  .xl\\:prose-2xl thead th:last-child{
    padding-right: 0;
  }

  .xl\\:prose-2xl tbody td{
    padding-top: 0.8em;
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }

  .xl\\:prose-2xl tbody td:first-child{
    padding-left: 0;
  }

  .xl\\:prose-2xl tbody td:last-child{
    padding-right: 0;
  }

  .xl\\:prose-2xl > :first-child{
    margin-top: 0;
  }

  .xl\\:prose-2xl > :last-child{
    margin-bottom: 0;
  }

  .xl\\:space-y-0 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0px * (1 - var(--space-y-reverse)));
    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0px * var(--space-y-reverse));
  }

  .xl\\:space-x-0 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0px * var(--space-x-reverse));
    margin-left: calc(0px * (1 - var(--space-x-reverse)));
    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--space-y-reverse));
  }

  .xl\\:space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--space-x-reverse));
    margin-left: calc(0.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--space-x-reverse));
    margin-left: calc(0.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--space-y-reverse));
  }

  .xl\\:space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--space-x-reverse));
    margin-left: calc(0.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1rem * var(--space-y-reverse));
  }

  .xl\\:space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1rem * var(--space-x-reverse));
    margin-left: calc(1rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--space-y-reverse));
  }

  .xl\\:space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--space-x-reverse));
    margin-left: calc(1.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--space-x-reverse));
    margin-left: calc(1.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-7 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.75rem * var(--space-y-reverse));
  }

  .xl\\:space-x-7 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.75rem * var(--space-x-reverse));
    margin-left: calc(1.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2rem * var(--space-y-reverse));
  }

  .xl\\:space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2rem * var(--space-x-reverse));
    margin-left: calc(2rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-9 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.25rem * var(--space-y-reverse));
  }

  .xl\\:space-x-9 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.25rem * var(--space-x-reverse));
    margin-left: calc(2.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.5rem * var(--space-x-reverse));
    margin-left: calc(2.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-11 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.75rem * var(--space-y-reverse));
  }

  .xl\\:space-x-11 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.75rem * var(--space-x-reverse));
    margin-left: calc(2.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3rem * var(--space-y-reverse));
  }

  .xl\\:space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3rem * var(--space-x-reverse));
    margin-left: calc(3rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-14 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-14 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3.5rem * var(--space-x-reverse));
    margin-left: calc(3.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-15 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.75rem * var(--space-y-reverse));
  }

  .xl\\:space-x-15 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3.75rem * var(--space-x-reverse));
    margin-left: calc(3.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(4rem * (1 - var(--space-y-reverse)));
    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(4rem * var(--space-y-reverse));
  }

  .xl\\:space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(4rem * var(--space-x-reverse));
    margin-left: calc(4rem * (1 - var(--space-x-reverse)));
    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-18 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(4.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(4.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(4.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-18 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(4.5rem * var(--space-x-reverse));
    margin-left: calc(4.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(4.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5rem * var(--space-x-reverse));
    margin-left: calc(5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-22 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-22 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5.5rem * var(--space-x-reverse));
    margin-left: calc(5.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-23 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5.75rem * var(--space-y-reverse));
  }

  .xl\\:space-x-23 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5.75rem * var(--space-x-reverse));
    margin-left: calc(5.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5.75rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6rem * var(--space-y-reverse));
  }

  .xl\\:space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6rem * var(--space-x-reverse));
    margin-left: calc(6rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-25 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6.25rem * var(--space-y-reverse));
  }

  .xl\\:space-x-25 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6.25rem * var(--space-x-reverse));
    margin-left: calc(6.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6.25rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-26 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-26 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6.5rem * var(--space-x-reverse));
    margin-left: calc(6.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-28 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(7rem * (1 - var(--space-y-reverse)));
    margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(7rem * var(--space-y-reverse));
  }

  .xl\\:space-x-28 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(7rem * var(--space-x-reverse));
    margin-left: calc(7rem * (1 - var(--space-x-reverse)));
    margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-30 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(7.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(7.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(7.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-30 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(7.5rem * var(--space-x-reverse));
    margin-left: calc(7.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(7.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(8rem * (1 - var(--space-y-reverse)));
    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8rem * var(--space-y-reverse));
  }

  .xl\\:space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(8rem * var(--space-x-reverse));
    margin-left: calc(8rem * (1 - var(--space-x-reverse)));
    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-34 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(8.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(8.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-34 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(8.5rem * var(--space-x-reverse));
    margin-left: calc(8.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(8.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(10rem * (1 - var(--space-y-reverse)));
    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(10rem * var(--space-y-reverse));
  }

  .xl\\:space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(10rem * var(--space-x-reverse));
    margin-left: calc(10rem * (1 - var(--space-x-reverse)));
    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-42 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(10.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(10.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(10.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-42 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(10.5rem * var(--space-x-reverse));
    margin-left: calc(10.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(10.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-44 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(11rem * (1 - var(--space-y-reverse)));
    margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(11rem * var(--space-y-reverse));
  }

  .xl\\:space-x-44 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(11rem * var(--space-x-reverse));
    margin-left: calc(11rem * (1 - var(--space-x-reverse)));
    margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(12rem * (1 - var(--space-y-reverse)));
    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(12rem * var(--space-y-reverse));
  }

  .xl\\:space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(12rem * var(--space-x-reverse));
    margin-left: calc(12rem * (1 - var(--space-x-reverse)));
    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-52 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(13rem * (1 - var(--space-y-reverse)));
    margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(13rem * var(--space-y-reverse));
  }

  .xl\\:space-x-52 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(13rem * var(--space-x-reverse));
    margin-left: calc(13rem * (1 - var(--space-x-reverse)));
    margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-54 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(13.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(13.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(13.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-54 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(13.5rem * var(--space-x-reverse));
    margin-left: calc(13.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(13.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(14rem * (1 - var(--space-y-reverse)));
    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(14rem * var(--space-y-reverse));
  }

  .xl\\:space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(14rem * var(--space-x-reverse));
    margin-left: calc(14rem * (1 - var(--space-x-reverse)));
    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-60 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(15rem * (1 - var(--space-y-reverse)));
    margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(15rem * var(--space-y-reverse));
  }

  .xl\\:space-x-60 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(15rem * var(--space-x-reverse));
    margin-left: calc(15rem * (1 - var(--space-x-reverse)));
    margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(16rem * (1 - var(--space-y-reverse)));
    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16rem * var(--space-y-reverse));
  }

  .xl\\:space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(16rem * var(--space-x-reverse));
    margin-left: calc(16rem * (1 - var(--space-x-reverse)));
    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-68 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(17rem * (1 - var(--space-y-reverse)));
    margin-top: calc(17rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(17rem * var(--space-y-reverse));
  }

  .xl\\:space-x-68 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(17rem * var(--space-x-reverse));
    margin-left: calc(17rem * (1 - var(--space-x-reverse)));
    margin-left: calc(17rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-72 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(18rem * (1 - var(--space-y-reverse)));
    margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(18rem * var(--space-y-reverse));
  }

  .xl\\:space-x-72 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(18rem * var(--space-x-reverse));
    margin-left: calc(18rem * (1 - var(--space-x-reverse)));
    margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-74 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(18.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(18.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(18.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-74 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(18.5rem * var(--space-x-reverse));
    margin-left: calc(18.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(18.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-76 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(19rem * (1 - var(--space-y-reverse)));
    margin-top: calc(19rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(19rem * var(--space-y-reverse));
  }

  .xl\\:space-x-76 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(19rem * var(--space-x-reverse));
    margin-left: calc(19rem * (1 - var(--space-x-reverse)));
    margin-left: calc(19rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-78 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(19.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(19.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(19.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-78 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(19.5rem * var(--space-x-reverse));
    margin-left: calc(19.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(19.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-80 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(20rem * (1 - var(--space-y-reverse)));
    margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20rem * var(--space-y-reverse));
  }

  .xl\\:space-x-80 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(20rem * var(--space-x-reverse));
    margin-left: calc(20rem * (1 - var(--space-x-reverse)));
    margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-82 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(20.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(20.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-82 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(20.5rem * var(--space-x-reverse));
    margin-left: calc(20.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(20.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-84 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(21rem * (1 - var(--space-y-reverse)));
    margin-top: calc(21rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(21rem * var(--space-y-reverse));
  }

  .xl\\:space-x-84 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(21rem * var(--space-x-reverse));
    margin-left: calc(21rem * (1 - var(--space-x-reverse)));
    margin-left: calc(21rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-88 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(22rem * (1 - var(--space-y-reverse)));
    margin-top: calc(22rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(22rem * var(--space-y-reverse));
  }

  .xl\\:space-x-88 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(22rem * var(--space-x-reverse));
    margin-left: calc(22rem * (1 - var(--space-x-reverse)));
    margin-left: calc(22rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-92 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(23rem * (1 - var(--space-y-reverse)));
    margin-top: calc(23rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(23rem * var(--space-y-reverse));
  }

  .xl\\:space-x-92 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(23rem * var(--space-x-reverse));
    margin-left: calc(23rem * (1 - var(--space-x-reverse)));
    margin-left: calc(23rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-96 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(24rem * (1 - var(--space-y-reverse)));
    margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(24rem * var(--space-y-reverse));
  }

  .xl\\:space-x-96 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(24rem * var(--space-x-reverse));
    margin-left: calc(24rem * (1 - var(--space-x-reverse)));
    margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-98 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(24.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(24.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(24.5rem * var(--space-y-reverse));
  }

  .xl\\:space-x-98 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(24.5rem * var(--space-x-reverse));
    margin-left: calc(24.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(24.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-100 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(25rem * var(--space-y-reverse));
  }

  .xl\\:space-x-100 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(25rem * var(--space-x-reverse));
    margin-left: calc(25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(25rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-104 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(26rem * (1 - var(--space-y-reverse)));
    margin-top: calc(26rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(26rem * var(--space-y-reverse));
  }

  .xl\\:space-x-104 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(26rem * var(--space-x-reverse));
    margin-left: calc(26rem * (1 - var(--space-x-reverse)));
    margin-left: calc(26rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-112 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(28rem * (1 - var(--space-y-reverse)));
    margin-top: calc(28rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(28rem * var(--space-y-reverse));
  }

  .xl\\:space-x-112 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(28rem * var(--space-x-reverse));
    margin-left: calc(28rem * (1 - var(--space-x-reverse)));
    margin-left: calc(28rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-124 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(31rem * (1 - var(--space-y-reverse)));
    margin-top: calc(31rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(31rem * var(--space-y-reverse));
  }

  .xl\\:space-x-124 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(31rem * var(--space-x-reverse));
    margin-left: calc(31rem * (1 - var(--space-x-reverse)));
    margin-left: calc(31rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-128 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(32rem * (1 - var(--space-y-reverse)));
    margin-top: calc(32rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(32rem * var(--space-y-reverse));
  }

  .xl\\:space-x-128 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(32rem * var(--space-x-reverse));
    margin-left: calc(32rem * (1 - var(--space-x-reverse)));
    margin-left: calc(32rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-140 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(35rem * (1 - var(--space-y-reverse)));
    margin-top: calc(35rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(35rem * var(--space-y-reverse));
  }

  .xl\\:space-x-140 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(35rem * var(--space-x-reverse));
    margin-left: calc(35rem * (1 - var(--space-x-reverse)));
    margin-left: calc(35rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-152 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(38rem * (1 - var(--space-y-reverse)));
    margin-top: calc(38rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(38rem * var(--space-y-reverse));
  }

  .xl\\:space-x-152 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(38rem * var(--space-x-reverse));
    margin-left: calc(38rem * (1 - var(--space-x-reverse)));
    margin-left: calc(38rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-160 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(40rem * (1 - var(--space-y-reverse)));
    margin-top: calc(40rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(40rem * var(--space-y-reverse));
  }

  .xl\\:space-x-160 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(40rem * var(--space-x-reverse));
    margin-left: calc(40rem * (1 - var(--space-x-reverse)));
    margin-left: calc(40rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-162 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(41rem * (1 - var(--space-y-reverse)));
    margin-top: calc(41rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(41rem * var(--space-y-reverse));
  }

  .xl\\:space-x-162 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(41rem * var(--space-x-reverse));
    margin-left: calc(41rem * (1 - var(--space-x-reverse)));
    margin-left: calc(41rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-192 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(48rem * (1 - var(--space-y-reverse)));
    margin-top: calc(48rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(48rem * var(--space-y-reverse));
  }

  .xl\\:space-x-192 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(48rem * var(--space-x-reverse));
    margin-left: calc(48rem * (1 - var(--space-x-reverse)));
    margin-left: calc(48rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-208 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(52rem * (1 - var(--space-y-reverse)));
    margin-top: calc(52rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(52rem * var(--space-y-reverse));
  }

  .xl\\:space-x-208 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(52rem * var(--space-x-reverse));
    margin-left: calc(52rem * (1 - var(--space-x-reverse)));
    margin-left: calc(52rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-224 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(56rem * (1 - var(--space-y-reverse)));
    margin-top: calc(56rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(56rem * var(--space-y-reverse));
  }

  .xl\\:space-x-224 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(56rem * var(--space-x-reverse));
    margin-left: calc(56rem * (1 - var(--space-x-reverse)));
    margin-left: calc(56rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-256 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(64rem * (1 - var(--space-y-reverse)));
    margin-top: calc(64rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(64rem * var(--space-y-reverse));
  }

  .xl\\:space-x-256 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(64rem * var(--space-x-reverse));
    margin-left: calc(64rem * (1 - var(--space-x-reverse)));
    margin-left: calc(64rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1px * (1 - var(--space-y-reverse)));
    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1px * var(--space-y-reverse));
  }

  .xl\\:space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1px * var(--space-x-reverse));
    margin-left: calc(1px * (1 - var(--space-x-reverse)));
    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.25rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.25rem * var(--space-x-reverse));
    margin-left: calc(-0.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.5rem * var(--space-x-reverse));
    margin-left: calc(-0.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.75rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.75rem * var(--space-x-reverse));
    margin-left: calc(-0.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1rem * var(--space-x-reverse));
    margin-left: calc(-1rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.25rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.25rem * var(--space-x-reverse));
    margin-left: calc(-1.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.5rem * var(--space-x-reverse));
    margin-left: calc(-1.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-7 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.75rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-7 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.75rem * var(--space-x-reverse));
    margin-left: calc(-1.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2rem * var(--space-x-reverse));
    margin-left: calc(-2rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-9 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.25rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-9 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.25rem * var(--space-x-reverse));
    margin-left: calc(-2.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.5rem * var(--space-x-reverse));
    margin-left: calc(-2.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-11 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.75rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-11 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.75rem * var(--space-x-reverse));
    margin-left: calc(-2.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3rem * var(--space-x-reverse));
    margin-left: calc(-3rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-14 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-14 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3.5rem * var(--space-x-reverse));
    margin-left: calc(-3.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-15 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.75rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-15 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3.75rem * var(--space-x-reverse));
    margin-left: calc(-3.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-4rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-4rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-4rem * var(--space-x-reverse));
    margin-left: calc(-4rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-18 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-4.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-4.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-4.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-18 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-4.5rem * var(--space-x-reverse));
    margin-left: calc(-4.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-4.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5rem * var(--space-x-reverse));
    margin-left: calc(-5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-22 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-22 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5.5rem * var(--space-x-reverse));
    margin-left: calc(-5.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-23 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5.75rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-23 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5.75rem * var(--space-x-reverse));
    margin-left: calc(-5.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5.75rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6rem * var(--space-x-reverse));
    margin-left: calc(-6rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-25 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6.25rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-25 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6.25rem * var(--space-x-reverse));
    margin-left: calc(-6.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6.25rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-26 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-26 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6.5rem * var(--space-x-reverse));
    margin-left: calc(-6.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-28 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-7rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-7rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-28 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-7rem * var(--space-x-reverse));
    margin-left: calc(-7rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-30 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-7.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-7.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-7.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-30 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-7.5rem * var(--space-x-reverse));
    margin-left: calc(-7.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-7.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-8rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-8rem * var(--space-x-reverse));
    margin-left: calc(-8rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-34 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-8.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-8.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-34 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-8.5rem * var(--space-x-reverse));
    margin-left: calc(-8.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-8.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-10rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-10rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-10rem * var(--space-x-reverse));
    margin-left: calc(-10rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-42 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-10.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-10.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-10.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-42 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-10.5rem * var(--space-x-reverse));
    margin-left: calc(-10.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-10.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-44 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-11rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-11rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-44 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-11rem * var(--space-x-reverse));
    margin-left: calc(-11rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-12rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-12rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-12rem * var(--space-x-reverse));
    margin-left: calc(-12rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-52 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-13rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-13rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-52 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-13rem * var(--space-x-reverse));
    margin-left: calc(-13rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-54 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-13.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-13.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-13.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-54 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-13.5rem * var(--space-x-reverse));
    margin-left: calc(-13.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-13.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-14rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-14rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-14rem * var(--space-x-reverse));
    margin-left: calc(-14rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-60 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-15rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-15rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-60 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-15rem * var(--space-x-reverse));
    margin-left: calc(-15rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-16rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-16rem * var(--space-x-reverse));
    margin-left: calc(-16rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-68 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-17rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-17rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-17rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-68 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-17rem * var(--space-x-reverse));
    margin-left: calc(-17rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-17rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-72 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-18rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-18rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-72 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-18rem * var(--space-x-reverse));
    margin-left: calc(-18rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-74 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-18.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-18.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-18.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-74 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-18.5rem * var(--space-x-reverse));
    margin-left: calc(-18.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-18.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-76 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-19rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-19rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-19rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-76 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-19rem * var(--space-x-reverse));
    margin-left: calc(-19rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-19rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-78 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-19.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-19.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-19.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-78 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-19.5rem * var(--space-x-reverse));
    margin-left: calc(-19.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-19.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-80 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-20rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-80 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-20rem * var(--space-x-reverse));
    margin-left: calc(-20rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-82 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-20.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-20.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-82 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-20.5rem * var(--space-x-reverse));
    margin-left: calc(-20.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-20.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-84 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-21rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-21rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-21rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-84 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-21rem * var(--space-x-reverse));
    margin-left: calc(-21rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-21rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-88 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-22rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-22rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-22rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-88 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-22rem * var(--space-x-reverse));
    margin-left: calc(-22rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-22rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-92 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-23rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-23rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-23rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-92 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-23rem * var(--space-x-reverse));
    margin-left: calc(-23rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-23rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-96 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-24rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-24rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-96 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-24rem * var(--space-x-reverse));
    margin-left: calc(-24rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-98 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-24.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-24.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-24.5rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-98 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-24.5rem * var(--space-x-reverse));
    margin-left: calc(-24.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-24.5rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-100 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-25rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-100 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-25rem * var(--space-x-reverse));
    margin-left: calc(-25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-25rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-104 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-26rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-26rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-26rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-104 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-26rem * var(--space-x-reverse));
    margin-left: calc(-26rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-26rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-112 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-28rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-28rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-28rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-112 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-28rem * var(--space-x-reverse));
    margin-left: calc(-28rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-28rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-124 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-31rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-31rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-31rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-124 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-31rem * var(--space-x-reverse));
    margin-left: calc(-31rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-31rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-128 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-32rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-32rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-32rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-128 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-32rem * var(--space-x-reverse));
    margin-left: calc(-32rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-32rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-140 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-35rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-35rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-35rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-140 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-35rem * var(--space-x-reverse));
    margin-left: calc(-35rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-35rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-152 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-38rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-38rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-38rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-152 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-38rem * var(--space-x-reverse));
    margin-left: calc(-38rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-38rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-160 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-40rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-40rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-40rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-160 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-40rem * var(--space-x-reverse));
    margin-left: calc(-40rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-40rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-162 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-41rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-41rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-41rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-162 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-41rem * var(--space-x-reverse));
    margin-left: calc(-41rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-41rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-192 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-48rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-48rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-48rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-192 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-48rem * var(--space-x-reverse));
    margin-left: calc(-48rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-48rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-208 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-52rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-52rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-52rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-208 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-52rem * var(--space-x-reverse));
    margin-left: calc(-52rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-52rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-224 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-56rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-56rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-56rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-224 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-56rem * var(--space-x-reverse));
    margin-left: calc(-56rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-56rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-256 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-64rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-64rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-64rem * var(--space-y-reverse));
  }

  .xl\\:-space-x-256 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-64rem * var(--space-x-reverse));
    margin-left: calc(-64rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-64rem * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:-space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1px * (1 - var(--space-y-reverse)));
    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1px * var(--space-y-reverse));
  }

  .xl\\:-space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1px * var(--space-x-reverse));
    margin-left: calc(-1px * (1 - var(--space-x-reverse)));
    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));
  }

  .xl\\:space-y-reverse > :not(template) ~ :not(template){
    --space-y-reverse: 1;
  }

  .xl\\:space-x-reverse > :not(template) ~ :not(template){
    --space-x-reverse: 1;
  }

  .xl\\:divide-y-0 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(0px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(0px * var(--divide-y-reverse));
  }

  .xl\\:divide-x-0 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(0px * var(--divide-x-reverse));
    border-left-width: calc(0px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));
  }

  .xl\\:divide-y-2 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(2px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(2px * var(--divide-y-reverse));
  }

  .xl\\:divide-x-2 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(2px * var(--divide-x-reverse));
    border-left-width: calc(2px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));
  }

  .xl\\:divide-y-3 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(3px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(3px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(3px * var(--divide-y-reverse));
  }

  .xl\\:divide-x-3 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(3px * var(--divide-x-reverse));
    border-left-width: calc(3px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(3px * calc(1 - var(--divide-x-reverse)));
  }

  .xl\\:divide-y-4 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(4px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(4px * var(--divide-y-reverse));
  }

  .xl\\:divide-x-4 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(4px * var(--divide-x-reverse));
    border-left-width: calc(4px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));
  }

  .xl\\:divide-y-5 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(5px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(5px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(5px * var(--divide-y-reverse));
  }

  .xl\\:divide-x-5 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(5px * var(--divide-x-reverse));
    border-left-width: calc(5px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(5px * calc(1 - var(--divide-x-reverse)));
  }

  .xl\\:divide-y-6 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(6px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(6px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(6px * var(--divide-y-reverse));
  }

  .xl\\:divide-x-6 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(6px * var(--divide-x-reverse));
    border-left-width: calc(6px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(6px * calc(1 - var(--divide-x-reverse)));
  }

  .xl\\:divide-y-8 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(8px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(8px * var(--divide-y-reverse));
  }

  .xl\\:divide-x-8 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(8px * var(--divide-x-reverse));
    border-left-width: calc(8px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));
  }

  .xl\\:divide-y > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(1px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(1px * var(--divide-y-reverse));
  }

  .xl\\:divide-x > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(1px * var(--divide-x-reverse));
    border-left-width: calc(1px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));
  }

  .xl\\:divide-y-reverse > :not(template) ~ :not(template){
    --divide-y-reverse: 1;
  }

  .xl\\:divide-x-reverse > :not(template) ~ :not(template){
    --divide-x-reverse: 1;
  }

  .xl\\:divide-transparent > :not(template) ~ :not(template){
    border-color: transparent;
  }

  .xl\\:divide-focus > :not(template) ~ :not(template){
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .xl\\:divide-black > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--divide-opacity));
  }

  .xl\\:divide-white > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--divide-opacity));
  }

  .xl\\:divide-primary > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--divide-opacity));
  }

  .xl\\:divide-disabled > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--divide-opacity));
  }

  .xl\\:divide-translucent-60 > :not(template) ~ :not(template){
    border-color: rgba(256, 256, 256, 0.6);
  }

  .xl\\:divide-translucent-90 > :not(template) ~ :not(template){
    border-color: rgba(256, 256, 256, 0.9);
  }

  .xl\\:divide-green-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--divide-opacity));
  }

  .xl\\:divide-green-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--divide-opacity));
  }

  .xl\\:divide-green-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--divide-opacity));
  }

  .xl\\:divide-green-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--divide-opacity));
  }

  .xl\\:divide-green-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--divide-opacity));
  }

  .xl\\:divide-green-400a50 > :not(template) ~ :not(template){
    border-color: rgba(108,202,152,0.50196);
  }

  .xl\\:divide-green-500a25 > :not(template) ~ :not(template){
    border-color: rgba(151,232,18,0.09804);
  }

  .xl\\:divide-yellow-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--divide-opacity));
  }

  .xl\\:divide-yellow-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--divide-opacity));
  }

  .xl\\:divide-yellow-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--divide-opacity));
  }

  .xl\\:divide-yellow-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--divide-opacity));
  }

  .xl\\:divide-yellow-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--divide-opacity));
  }

  .xl\\:divide-yellow-300a66 > :not(template) ~ :not(template){
    border-color: rgba(255,233,189,0.66667);
  }

  .xl\\:divide-yellow-500a25 > :not(template) ~ :not(template){
    border-color: rgba(255,200,44,0.09804);
  }

  .xl\\:divide-orange-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--divide-opacity));
  }

  .xl\\:divide-orange-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--divide-opacity));
  }

  .xl\\:divide-orange-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--divide-opacity));
  }

  .xl\\:divide-orange-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--divide-opacity));
  }

  .xl\\:divide-orange-900 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--divide-opacity));
  }

  .xl\\:divide-orange-500a25 > :not(template) ~ :not(template){
    border-color: rgba(240,115,23,0.09804);
  }

  .xl\\:divide-red-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--divide-opacity));
  }

  .xl\\:divide-red-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--divide-opacity));
  }

  .xl\\:divide-red-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--divide-opacity));
  }

  .xl\\:divide-red-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--divide-opacity));
  }

  .xl\\:divide-red-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--divide-opacity));
  }

  .xl\\:divide-red-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--divide-opacity));
  }

  .xl\\:divide-red-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--divide-opacity));
  }

  .xl\\:divide-gray-50 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--divide-opacity));
  }

  .xl\\:divide-gray-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--divide-opacity));
  }

  .xl\\:divide-gray-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--divide-opacity));
  }

  .xl\\:divide-gray-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--divide-opacity));
  }

  .xl\\:divide-gray-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--divide-opacity));
  }

  .xl\\:divide-gray-400 > :not(template) ~ :not(template){
    border-color: rgba(114,114,114,0.8);
  }

  .xl\\:divide-gray-425 > :not(template) ~ :not(template){
    border-color: rgba(4, 21, 39, 0.8);
  }

  .xl\\:divide-gray-450 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--divide-opacity));
  }

  .xl\\:divide-gray-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--divide-opacity));
  }

  .xl\\:divide-gray-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--divide-opacity));
  }

  .xl\\:divide-gray-625 > :not(template) ~ :not(template){
    border-color: rgba(90,98,107,0.8);
  }

  .xl\\:divide-gray-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--divide-opacity));
  }

  .xl\\:divide-gray-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--divide-opacity));
  }

  .xl\\:divide-gray-200a50 > :not(template) ~ :not(template){
    border-color: rgba(224, 226, 228, 0.5);
  }

  .xl\\:divide-blue-50 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--divide-opacity));
  }

  .xl\\:divide-blue-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--divide-opacity));
  }

  .xl\\:divide-blue-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--divide-opacity));
  }

  .xl\\:divide-blue-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--divide-opacity));
  }

  .xl\\:divide-blue-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--divide-opacity));
  }

  .xl\\:divide-blue-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--divide-opacity));
  }

  .xl\\:divide-blue-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--divide-opacity));
  }

  .xl\\:divide-blue-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--divide-opacity));
  }

  .xl\\:divide-blue-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--divide-opacity));
  }

  .xl\\:divide-blue-750 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--divide-opacity));
  }

  .xl\\:divide-blue-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--divide-opacity));
  }

  .xl\\:divide-blue-900 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--divide-opacity));
  }

  .xl\\:divide-blue-950 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--divide-opacity));
  }

  .xl\\:divide-blue-500a25 > :not(template) ~ :not(template){
    border-color: rgba(55, 164, 220, 0.2);
  }

  .xl\\:divide-blue-500a50 > :not(template) ~ :not(template){
    border-color: rgba(55, 164, 220, 0.5);
  }

  .xl\\:divide-blue-700a75 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--divide-opacity));
  }

  .xl\\:divide-blue-700a30 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--divide-opacity));
  }

  .xl\\:divide-blue-750a25 > :not(template) ~ :not(template){
    border-color: rgba(86,130,170,0.09804);
  }

  .xl\\:divide-blue-750a15 > :not(template) ~ :not(template){
    border-color: rgba(86,130,170,0.05882);
  }

  .xl\\:divide-blue-800a60 > :not(template) ~ :not(template){
    border-color: rgba(31, 69, 102, 0.6);
  }

  .xl\\:divide-programEditorTabColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--divide-opacity));
  }

  .xl\\:divide-programEditorTabColors-2 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--divide-opacity));
  }

  .xl\\:divide-programEditorTabColors-3 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--divide-opacity));
  }

  .xl\\:divide-programEditorTabColors-4 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--divide-opacity));
  }

  .xl\\:divide-programEditorTabColors-5 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--divide-opacity));
  }

  .xl\\:divide-programEditorTabColors-6 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--divide-opacity));
  }

  .xl\\:divide-programEditorTabColors-1h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--divide-opacity));
  }

  .xl\\:divide-programEditorTabColors-2h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--divide-opacity));
  }

  .xl\\:divide-programEditorTabColors-3h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--divide-opacity));
  }

  .xl\\:divide-programEditorTabColors-4h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--divide-opacity));
  }

  .xl\\:divide-programEditorTabColors-5h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--divide-opacity));
  }

  .xl\\:divide-programEditorTabColors-6h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--divide-opacity));
  }

  .xl\\:divide-programEditorPresetTabColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--divide-opacity));
  }

  .xl\\:divide-programEditorPresetTabColors-1h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--divide-opacity));
  }

  .xl\\:divide-borgScaleColors-0 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--divide-opacity));
  }

  .xl\\:divide-borgScaleColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--divide-opacity));
  }

  .xl\\:divide-borgScaleColors-2 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--divide-opacity));
  }

  .xl\\:divide-borgScaleColors-3 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--divide-opacity));
  }

  .xl\\:divide-borgScaleColors-4 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--divide-opacity));
  }

  .xl\\:divide-borgScaleColors-5 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--divide-opacity));
  }

  .xl\\:divide-borgScaleColors-6 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--divide-opacity));
  }

  .xl\\:divide-borgScaleColors-7 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--divide-opacity));
  }

  .xl\\:divide-borgScaleColors-8 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--divide-opacity));
  }

  .xl\\:divide-borgScaleColors-9 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--divide-opacity));
  }

  .xl\\:divide-borgScaleColors-10 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--divide-opacity));
  }

  .xl\\:divide-solid > :not(template) ~ :not(template){
    border-style: solid;
  }

  .xl\\:divide-dashed > :not(template) ~ :not(template){
    border-style: dashed;
  }

  .xl\\:divide-dotted > :not(template) ~ :not(template){
    border-style: dotted;
  }

  .xl\\:divide-double > :not(template) ~ :not(template){
    border-style: double;
  }

  .xl\\:divide-none > :not(template) ~ :not(template){
    border-style: none;
  }

  .xl\\:divide-opacity-0 > :not(template) ~ :not(template){
    --divide-opacity: 0;
  }

  .xl\\:divide-opacity-25 > :not(template) ~ :not(template){
    --divide-opacity: .25;
  }

  .xl\\:divide-opacity-50 > :not(template) ~ :not(template){
    --divide-opacity: .5;
  }

  .xl\\:divide-opacity-75 > :not(template) ~ :not(template){
    --divide-opacity: .75;
  }

  .xl\\:divide-opacity-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
  }

  .xl\\:sr-only{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .xl\\:not-sr-only{
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .xl\\:focus\\:sr-only:focus{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .xl\\:focus\\:not-sr-only:focus{
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .xl\\:appearance-none{
    -webkit-appearance: none;
            appearance: none;
  }

  .xl\\:bg-fixed{
    background-attachment: fixed;
  }

  .xl\\:bg-local{
    background-attachment: local;
  }

  .xl\\:bg-scroll{
    background-attachment: scroll;
  }

  .xl\\:bg-clip-border{
    background-clip: border-box;
  }

  .xl\\:bg-clip-padding{
    background-clip: padding-box;
  }

  .xl\\:bg-clip-content{
    background-clip: content-box;
  }

  .xl\\:bg-clip-text{
    -webkit-background-clip: text;
            background-clip: text;
  }

  .xl\\:bg-transparent{
    background-color: transparent;
  }

  .xl\\:bg-focus{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .xl\\:bg-black{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .xl\\:bg-white{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .xl\\:bg-primary{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .xl\\:bg-disabled{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .xl\\:bg-translucent-60{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .xl\\:bg-translucent-90{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .xl\\:bg-green-200{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .xl\\:bg-green-400{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .xl\\:bg-green-500{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .xl\\:bg-green-600{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .xl\\:bg-green-700{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .xl\\:bg-green-400a50{
    background-color: rgba(108,202,152,0.50196);
  }

  .xl\\:bg-green-500a25{
    background-color: rgba(151,232,18,0.09804);
  }

  .xl\\:bg-yellow-200{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .xl\\:bg-yellow-300{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .xl\\:bg-yellow-500{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .xl\\:bg-yellow-600{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .xl\\:bg-yellow-700{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .xl\\:bg-yellow-300a66{
    background-color: rgba(255,233,189,0.66667);
  }

  .xl\\:bg-yellow-500a25{
    background-color: rgba(255,200,44,0.09804);
  }

  .xl\\:bg-orange-200{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .xl\\:bg-orange-400{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .xl\\:bg-orange-500{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .xl\\:bg-orange-800{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .xl\\:bg-orange-900{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .xl\\:bg-orange-500a25{
    background-color: rgba(240,115,23,0.09804);
  }

  .xl\\:bg-red-100{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .xl\\:bg-red-150{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .xl\\:bg-red-200{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .xl\\:bg-red-300{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .xl\\:bg-red-400{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .xl\\:bg-red-500{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .xl\\:bg-red-700{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .xl\\:bg-gray-50{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .xl\\:bg-gray-100{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .xl\\:bg-gray-150{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .xl\\:bg-gray-200{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .xl\\:bg-gray-300{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .xl\\:bg-gray-400{
    background-color: rgba(114,114,114,0.8);
  }

  .xl\\:bg-gray-425{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .xl\\:bg-gray-450{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .xl\\:bg-gray-500{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .xl\\:bg-gray-600{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .xl\\:bg-gray-625{
    background-color: rgba(90,98,107,0.8);
  }

  .xl\\:bg-gray-700{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .xl\\:bg-gray-800{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .xl\\:bg-gray-200a50{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .xl\\:bg-blue-50{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .xl\\:bg-blue-100{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .xl\\:bg-blue-150{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .xl\\:bg-blue-200{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .xl\\:bg-blue-300{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .xl\\:bg-blue-400{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .xl\\:bg-blue-500{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .xl\\:bg-blue-600{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .xl\\:bg-blue-700{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .xl\\:bg-blue-750{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .xl\\:bg-blue-800{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .xl\\:bg-blue-900{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .xl\\:bg-blue-950{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .xl\\:bg-blue-500a25{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .xl\\:bg-blue-500a50{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .xl\\:bg-blue-700a75{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .xl\\:bg-blue-700a30{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .xl\\:bg-blue-750a25{
    background-color: rgba(86,130,170,0.09804);
  }

  .xl\\:bg-blue-750a15{
    background-color: rgba(86,130,170,0.05882);
  }

  .xl\\:bg-blue-800a60{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .xl\\:bg-programEditorTabColors-1{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .xl\\:bg-programEditorTabColors-2{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .xl\\:bg-programEditorTabColors-3{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .xl\\:bg-programEditorTabColors-4{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .xl\\:bg-programEditorTabColors-5{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .xl\\:bg-programEditorTabColors-6{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .xl\\:bg-programEditorTabColors-1h{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .xl\\:bg-programEditorTabColors-2h{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .xl\\:bg-programEditorTabColors-3h{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .xl\\:bg-programEditorTabColors-4h{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .xl\\:bg-programEditorTabColors-5h{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .xl\\:bg-programEditorTabColors-6h{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .xl\\:bg-programEditorPresetTabColors-1{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .xl\\:bg-programEditorPresetTabColors-1h{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .xl\\:bg-borgScaleColors-0{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .xl\\:bg-borgScaleColors-1{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .xl\\:bg-borgScaleColors-2{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .xl\\:bg-borgScaleColors-3{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .xl\\:bg-borgScaleColors-4{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .xl\\:bg-borgScaleColors-5{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .xl\\:bg-borgScaleColors-6{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .xl\\:bg-borgScaleColors-7{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .xl\\:bg-borgScaleColors-8{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .xl\\:bg-borgScaleColors-9{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .xl\\:bg-borgScaleColors-10{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-transparent:hover{
    background-color: transparent;
  }

  .xl\\:hover\\:bg-focus:hover{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .xl\\:hover\\:bg-black:hover{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-white:hover{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-primary:hover{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-disabled:hover{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-translucent-60:hover{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .xl\\:hover\\:bg-translucent-90:hover{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .xl\\:hover\\:bg-green-200:hover{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-green-400:hover{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-green-500:hover{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-green-600:hover{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-green-700:hover{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-green-400a50:hover{
    background-color: rgba(108,202,152,0.50196);
  }

  .xl\\:hover\\:bg-green-500a25:hover{
    background-color: rgba(151,232,18,0.09804);
  }

  .xl\\:hover\\:bg-yellow-200:hover{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-yellow-300:hover{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-yellow-500:hover{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-yellow-600:hover{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-yellow-700:hover{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-yellow-300a66:hover{
    background-color: rgba(255,233,189,0.66667);
  }

  .xl\\:hover\\:bg-yellow-500a25:hover{
    background-color: rgba(255,200,44,0.09804);
  }

  .xl\\:hover\\:bg-orange-200:hover{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-orange-400:hover{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-orange-500:hover{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-orange-800:hover{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-orange-900:hover{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-orange-500a25:hover{
    background-color: rgba(240,115,23,0.09804);
  }

  .xl\\:hover\\:bg-red-100:hover{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-red-150:hover{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-red-200:hover{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-red-300:hover{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-red-400:hover{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-red-500:hover{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-red-700:hover{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-50:hover{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-100:hover{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-150:hover{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-200:hover{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-300:hover{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-400:hover{
    background-color: rgba(114,114,114,0.8);
  }

  .xl\\:hover\\:bg-gray-425:hover{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .xl\\:hover\\:bg-gray-450:hover{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-500:hover{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-600:hover{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-625:hover{
    background-color: rgba(90,98,107,0.8);
  }

  .xl\\:hover\\:bg-gray-700:hover{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-800:hover{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-gray-200a50:hover{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .xl\\:hover\\:bg-blue-50:hover{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-100:hover{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-150:hover{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-200:hover{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-300:hover{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-400:hover{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-500:hover{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-600:hover{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-700:hover{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-750:hover{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-800:hover{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-900:hover{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-950:hover{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-500a25:hover{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .xl\\:hover\\:bg-blue-500a50:hover{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .xl\\:hover\\:bg-blue-700a75:hover{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-700a30:hover{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-blue-750a25:hover{
    background-color: rgba(86,130,170,0.09804);
  }

  .xl\\:hover\\:bg-blue-750a15:hover{
    background-color: rgba(86,130,170,0.05882);
  }

  .xl\\:hover\\:bg-blue-800a60:hover{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .xl\\:hover\\:bg-programEditorTabColors-1:hover{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-programEditorTabColors-2:hover{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-programEditorTabColors-3:hover{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-programEditorTabColors-4:hover{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-programEditorTabColors-5:hover{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-programEditorTabColors-6:hover{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-programEditorTabColors-1h:hover{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-programEditorTabColors-2h:hover{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-programEditorTabColors-3h:hover{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-programEditorTabColors-4h:hover{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-programEditorTabColors-5h:hover{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-programEditorTabColors-6h:hover{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-programEditorPresetTabColors-1:hover{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-programEditorPresetTabColors-1h:hover{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-borgScaleColors-0:hover{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-borgScaleColors-1:hover{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-borgScaleColors-2:hover{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-borgScaleColors-3:hover{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-borgScaleColors-4:hover{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-borgScaleColors-5:hover{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-borgScaleColors-6:hover{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-borgScaleColors-7:hover{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-borgScaleColors-8:hover{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-borgScaleColors-9:hover{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .xl\\:hover\\:bg-borgScaleColors-10:hover{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-transparent:focus{
    background-color: transparent;
  }

  .xl\\:focus\\:bg-focus:focus{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .xl\\:focus\\:bg-black:focus{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-white:focus{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-primary:focus{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-disabled:focus{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-translucent-60:focus{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .xl\\:focus\\:bg-translucent-90:focus{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .xl\\:focus\\:bg-green-200:focus{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-green-400:focus{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-green-500:focus{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-green-600:focus{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-green-700:focus{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-green-400a50:focus{
    background-color: rgba(108,202,152,0.50196);
  }

  .xl\\:focus\\:bg-green-500a25:focus{
    background-color: rgba(151,232,18,0.09804);
  }

  .xl\\:focus\\:bg-yellow-200:focus{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-yellow-300:focus{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-yellow-500:focus{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-yellow-600:focus{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-yellow-700:focus{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-yellow-300a66:focus{
    background-color: rgba(255,233,189,0.66667);
  }

  .xl\\:focus\\:bg-yellow-500a25:focus{
    background-color: rgba(255,200,44,0.09804);
  }

  .xl\\:focus\\:bg-orange-200:focus{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-orange-400:focus{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-orange-500:focus{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-orange-800:focus{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-orange-900:focus{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-orange-500a25:focus{
    background-color: rgba(240,115,23,0.09804);
  }

  .xl\\:focus\\:bg-red-100:focus{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-red-150:focus{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-red-200:focus{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-red-300:focus{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-red-400:focus{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-red-500:focus{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-red-700:focus{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-50:focus{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-100:focus{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-150:focus{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-200:focus{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-300:focus{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-400:focus{
    background-color: rgba(114,114,114,0.8);
  }

  .xl\\:focus\\:bg-gray-425:focus{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .xl\\:focus\\:bg-gray-450:focus{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-500:focus{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-600:focus{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-625:focus{
    background-color: rgba(90,98,107,0.8);
  }

  .xl\\:focus\\:bg-gray-700:focus{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-800:focus{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-gray-200a50:focus{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .xl\\:focus\\:bg-blue-50:focus{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-100:focus{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-150:focus{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-200:focus{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-300:focus{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-400:focus{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-500:focus{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-600:focus{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-700:focus{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-750:focus{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-800:focus{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-900:focus{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-950:focus{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-500a25:focus{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .xl\\:focus\\:bg-blue-500a50:focus{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .xl\\:focus\\:bg-blue-700a75:focus{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-700a30:focus{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-blue-750a25:focus{
    background-color: rgba(86,130,170,0.09804);
  }

  .xl\\:focus\\:bg-blue-750a15:focus{
    background-color: rgba(86,130,170,0.05882);
  }

  .xl\\:focus\\:bg-blue-800a60:focus{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .xl\\:focus\\:bg-programEditorTabColors-1:focus{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-programEditorTabColors-2:focus{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-programEditorTabColors-3:focus{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-programEditorTabColors-4:focus{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-programEditorTabColors-5:focus{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-programEditorTabColors-6:focus{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-programEditorTabColors-1h:focus{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-programEditorTabColors-2h:focus{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-programEditorTabColors-3h:focus{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-programEditorTabColors-4h:focus{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-programEditorTabColors-5h:focus{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-programEditorTabColors-6h:focus{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-programEditorPresetTabColors-1:focus{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-programEditorPresetTabColors-1h:focus{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-borgScaleColors-0:focus{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-borgScaleColors-1:focus{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-borgScaleColors-2:focus{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-borgScaleColors-3:focus{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-borgScaleColors-4:focus{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-borgScaleColors-5:focus{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-borgScaleColors-6:focus{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-borgScaleColors-7:focus{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-borgScaleColors-8:focus{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-borgScaleColors-9:focus{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .xl\\:focus\\:bg-borgScaleColors-10:focus{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .xl\\:bg-none{
    background-image: none;
  }

  .xl\\:bg-gradient-to-t{
    background-image: linear-gradient(to top, var(--gradient-color-stops));
  }

  .xl\\:bg-gradient-to-tr{
    background-image: linear-gradient(to top right, var(--gradient-color-stops));
  }

  .xl\\:bg-gradient-to-r{
    background-image: linear-gradient(to right, var(--gradient-color-stops));
  }

  .xl\\:bg-gradient-to-br{
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
  }

  .xl\\:bg-gradient-to-b{
    background-image: linear-gradient(to bottom, var(--gradient-color-stops));
  }

  .xl\\:bg-gradient-to-bl{
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
  }

  .xl\\:bg-gradient-to-l{
    background-image: linear-gradient(to left, var(--gradient-color-stops));
  }

  .xl\\:bg-gradient-to-tl{
    background-image: linear-gradient(to top left, var(--gradient-color-stops));
  }

  .xl\\:from-transparent{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:from-focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:from-black{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:from-white{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:from-primary{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:from-disabled{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .xl\\:from-translucent-60{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:from-translucent-90{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:from-green-200{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .xl\\:from-green-400{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .xl\\:from-green-500{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .xl\\:from-green-600{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .xl\\:from-green-700{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .xl\\:from-green-400a50{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .xl\\:from-green-500a25{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .xl\\:from-yellow-200{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .xl\\:from-yellow-300{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .xl\\:from-yellow-500{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .xl\\:from-yellow-600{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .xl\\:from-yellow-700{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .xl\\:from-yellow-300a66{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .xl\\:from-yellow-500a25{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .xl\\:from-orange-200{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .xl\\:from-orange-400{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .xl\\:from-orange-500{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .xl\\:from-orange-800{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .xl\\:from-orange-900{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .xl\\:from-orange-500a25{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .xl\\:from-red-100{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .xl\\:from-red-150{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .xl\\:from-red-200{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .xl\\:from-red-300{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .xl\\:from-red-400{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .xl\\:from-red-500{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .xl\\:from-red-700{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .xl\\:from-gray-50{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .xl\\:from-gray-100{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .xl\\:from-gray-150{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .xl\\:from-gray-200{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .xl\\:from-gray-300{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .xl\\:from-gray-400{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .xl\\:from-gray-425{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .xl\\:from-gray-450{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .xl\\:from-gray-500{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .xl\\:from-gray-600{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .xl\\:from-gray-625{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .xl\\:from-gray-700{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .xl\\:from-gray-800{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .xl\\:from-gray-200a50{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .xl\\:from-blue-50{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .xl\\:from-blue-100{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .xl\\:from-blue-150{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .xl\\:from-blue-200{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .xl\\:from-blue-300{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .xl\\:from-blue-400{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .xl\\:from-blue-500{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:from-blue-600{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .xl\\:from-blue-700{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .xl\\:from-blue-750{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:from-blue-800{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .xl\\:from-blue-900{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .xl\\:from-blue-950{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .xl\\:from-blue-500a25{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:from-blue-500a50{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:from-blue-700a75{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .xl\\:from-blue-700a30{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .xl\\:from-blue-750a25{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:from-blue-750a15{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:from-blue-800a60{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .xl\\:from-programEditorTabColors-1{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .xl\\:from-programEditorTabColors-2{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .xl\\:from-programEditorTabColors-3{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .xl\\:from-programEditorTabColors-4{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .xl\\:from-programEditorTabColors-5{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .xl\\:from-programEditorTabColors-6{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .xl\\:from-programEditorTabColors-1h{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .xl\\:from-programEditorTabColors-2h{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .xl\\:from-programEditorTabColors-3h{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .xl\\:from-programEditorTabColors-4h{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .xl\\:from-programEditorTabColors-5h{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .xl\\:from-programEditorTabColors-6h{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .xl\\:from-programEditorPresetTabColors-1{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .xl\\:from-programEditorPresetTabColors-1h{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .xl\\:from-borgScaleColors-0{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .xl\\:from-borgScaleColors-1{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .xl\\:from-borgScaleColors-2{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .xl\\:from-borgScaleColors-3{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .xl\\:from-borgScaleColors-4{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .xl\\:from-borgScaleColors-5{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .xl\\:from-borgScaleColors-6{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .xl\\:from-borgScaleColors-7{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .xl\\:from-borgScaleColors-8{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .xl\\:from-borgScaleColors-9{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .xl\\:from-borgScaleColors-10{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .xl\\:via-transparent{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:via-focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:via-black{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:via-white{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:via-primary{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:via-disabled{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .xl\\:via-translucent-60{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:via-translucent-90{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:via-green-200{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .xl\\:via-green-400{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .xl\\:via-green-500{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .xl\\:via-green-600{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .xl\\:via-green-700{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .xl\\:via-green-400a50{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .xl\\:via-green-500a25{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .xl\\:via-yellow-200{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .xl\\:via-yellow-300{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .xl\\:via-yellow-500{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .xl\\:via-yellow-600{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .xl\\:via-yellow-700{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .xl\\:via-yellow-300a66{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .xl\\:via-yellow-500a25{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .xl\\:via-orange-200{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .xl\\:via-orange-400{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .xl\\:via-orange-500{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .xl\\:via-orange-800{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .xl\\:via-orange-900{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .xl\\:via-orange-500a25{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .xl\\:via-red-100{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .xl\\:via-red-150{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .xl\\:via-red-200{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .xl\\:via-red-300{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .xl\\:via-red-400{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .xl\\:via-red-500{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .xl\\:via-red-700{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .xl\\:via-gray-50{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .xl\\:via-gray-100{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .xl\\:via-gray-150{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .xl\\:via-gray-200{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .xl\\:via-gray-300{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .xl\\:via-gray-400{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .xl\\:via-gray-425{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .xl\\:via-gray-450{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .xl\\:via-gray-500{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .xl\\:via-gray-600{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .xl\\:via-gray-625{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .xl\\:via-gray-700{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .xl\\:via-gray-800{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .xl\\:via-gray-200a50{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .xl\\:via-blue-50{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .xl\\:via-blue-100{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .xl\\:via-blue-150{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .xl\\:via-blue-200{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .xl\\:via-blue-300{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .xl\\:via-blue-400{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .xl\\:via-blue-500{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:via-blue-600{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .xl\\:via-blue-700{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .xl\\:via-blue-750{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:via-blue-800{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .xl\\:via-blue-900{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .xl\\:via-blue-950{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .xl\\:via-blue-500a25{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:via-blue-500a50{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:via-blue-700a75{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .xl\\:via-blue-700a30{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .xl\\:via-blue-750a25{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:via-blue-750a15{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:via-blue-800a60{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .xl\\:via-programEditorTabColors-1{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .xl\\:via-programEditorTabColors-2{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .xl\\:via-programEditorTabColors-3{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .xl\\:via-programEditorTabColors-4{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .xl\\:via-programEditorTabColors-5{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .xl\\:via-programEditorTabColors-6{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .xl\\:via-programEditorTabColors-1h{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .xl\\:via-programEditorTabColors-2h{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .xl\\:via-programEditorTabColors-3h{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .xl\\:via-programEditorTabColors-4h{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .xl\\:via-programEditorTabColors-5h{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .xl\\:via-programEditorTabColors-6h{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .xl\\:via-programEditorPresetTabColors-1{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .xl\\:via-programEditorPresetTabColors-1h{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .xl\\:via-borgScaleColors-0{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .xl\\:via-borgScaleColors-1{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .xl\\:via-borgScaleColors-2{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .xl\\:via-borgScaleColors-3{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .xl\\:via-borgScaleColors-4{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .xl\\:via-borgScaleColors-5{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .xl\\:via-borgScaleColors-6{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .xl\\:via-borgScaleColors-7{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .xl\\:via-borgScaleColors-8{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .xl\\:via-borgScaleColors-9{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .xl\\:via-borgScaleColors-10{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .xl\\:to-transparent{
    --gradient-to-color: transparent;
  }

  .xl\\:to-focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .xl\\:to-black{
    --gradient-to-color: #000;
  }

  .xl\\:to-white{
    --gradient-to-color: #fff;
  }

  .xl\\:to-primary{
    --gradient-to-color: #37A4DC;
  }

  .xl\\:to-disabled{
    --gradient-to-color: #BFBFBF;
  }

  .xl\\:to-translucent-60{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .xl\\:to-translucent-90{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .xl\\:to-green-200{
    --gradient-to-color: #f4fcea;
  }

  .xl\\:to-green-400{
    --gradient-to-color: #6CCA98;
  }

  .xl\\:to-green-500{
    --gradient-to-color: #97E812;
  }

  .xl\\:to-green-600{
    --gradient-to-color: #4f9112;
  }

  .xl\\:to-green-700{
    --gradient-to-color: #3e7211;
  }

  .xl\\:to-green-400a50{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .xl\\:to-green-500a25{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .xl\\:to-yellow-200{
    --gradient-to-color: #fff9eb;
  }

  .xl\\:to-yellow-300{
    --gradient-to-color: #ffe9bd;
  }

  .xl\\:to-yellow-500{
    --gradient-to-color: #FFC82C;
  }

  .xl\\:to-yellow-600{
    --gradient-to-color: #F7931E;
  }

  .xl\\:to-yellow-700{
    --gradient-to-color: #E1AD28;
  }

  .xl\\:to-yellow-300a66{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .xl\\:to-yellow-500a25{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .xl\\:to-orange-200{
    --gradient-to-color: #fdf0ea;
  }

  .xl\\:to-orange-400{
    --gradient-to-color: #f6c66f;
  }

  .xl\\:to-orange-500{
    --gradient-to-color: #F07313;
  }

  .xl\\:to-orange-800{
    --gradient-to-color: #db5d0c;
  }

  .xl\\:to-orange-900{
    --gradient-to-color: #b86814;
  }

  .xl\\:to-orange-500a25{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .xl\\:to-red-100{
    --gradient-to-color: #FEF5F5;
  }

  .xl\\:to-red-150{
    --gradient-to-color: #ffe9e8;
  }

  .xl\\:to-red-200{
    --gradient-to-color: #F8CECC;
  }

  .xl\\:to-red-300{
    --gradient-to-color: #ff8585;
  }

  .xl\\:to-red-400{
    --gradient-to-color: #ff3535;
  }

  .xl\\:to-red-500{
    --gradient-to-color: #DD4746;
  }

  .xl\\:to-red-700{
    --gradient-to-color: #A23C24;
  }

  .xl\\:to-gray-50{
    --gradient-to-color: #F9F9F9;
  }

  .xl\\:to-gray-100{
    --gradient-to-color: #F1F1F2;
  }

  .xl\\:to-gray-150{
    --gradient-to-color: #e6e6e6;
  }

  .xl\\:to-gray-200{
    --gradient-to-color: #E0E2E4;
  }

  .xl\\:to-gray-300{
    --gradient-to-color: #BFBFBF;
  }

  .xl\\:to-gray-400{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .xl\\:to-gray-425{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .xl\\:to-gray-450{
    --gradient-to-color: #959595;
  }

  .xl\\:to-gray-500{
    --gradient-to-color: #727272;
  }

  .xl\\:to-gray-600{
    --gradient-to-color: #5a626b;
  }

  .xl\\:to-gray-625{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .xl\\:to-gray-700{
    --gradient-to-color: #464C59;
  }

  .xl\\:to-gray-800{
    --gradient-to-color: #3c3b3b;
  }

  .xl\\:to-gray-200a50{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .xl\\:to-blue-50{
    --gradient-to-color: #f2fbff;
  }

  .xl\\:to-blue-100{
    --gradient-to-color: #EBF6FC;
  }

  .xl\\:to-blue-150{
    --gradient-to-color: #E8EEF1;
  }

  .xl\\:to-blue-200{
    --gradient-to-color: #CCE6F5;
  }

  .xl\\:to-blue-300{
    --gradient-to-color: #73BFE7;
  }

  .xl\\:to-blue-400{
    --gradient-to-color: #4BA4F7;
  }

  .xl\\:to-blue-500{
    --gradient-to-color: #37A4DC;
  }

  .xl\\:to-blue-600{
    --gradient-to-color: #6AA2D6;
  }

  .xl\\:to-blue-700{
    --gradient-to-color: #456E9A;
  }

  .xl\\:to-blue-750{
    --gradient-to-color: #5682AA;
  }

  .xl\\:to-blue-800{
    --gradient-to-color: #1F4566;
  }

  .xl\\:to-blue-900{
    --gradient-to-color: #183453;
  }

  .xl\\:to-blue-950{
    --gradient-to-color: #041527;
  }

  .xl\\:to-blue-500a25{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .xl\\:to-blue-500a50{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .xl\\:to-blue-700a75{
    --gradient-to-color: #3B648D;
  }

  .xl\\:to-blue-700a30{
    --gradient-to-color: #2A5176;
  }

  .xl\\:to-blue-750a25{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .xl\\:to-blue-750a15{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .xl\\:to-blue-800a60{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .xl\\:to-programEditorTabColors-1{
    --gradient-to-color: #3cacae;
  }

  .xl\\:to-programEditorTabColors-2{
    --gradient-to-color: #8e346a;
  }

  .xl\\:to-programEditorTabColors-3{
    --gradient-to-color: #ff72b7;
  }

  .xl\\:to-programEditorTabColors-4{
    --gradient-to-color: #ce941c;
  }

  .xl\\:to-programEditorTabColors-5{
    --gradient-to-color: #b973d9;
  }

  .xl\\:to-programEditorTabColors-6{
    --gradient-to-color: #ff9082;
  }

  .xl\\:to-programEditorTabColors-1h{
    --gradient-to-color: #d9f2f2;
  }

  .xl\\:to-programEditorTabColors-2h{
    --gradient-to-color: #f1dae8;
  }

  .xl\\:to-programEditorTabColors-3h{
    --gradient-to-color: #ffe6f2;
  }

  .xl\\:to-programEditorTabColors-4h{
    --gradient-to-color: #f9ecd2;
  }

  .xl\\:to-programEditorTabColors-5h{
    --gradient-to-color: #f5ebfa;
  }

  .xl\\:to-programEditorTabColors-6h{
    --gradient-to-color: #ffe8e6;
  }

  .xl\\:to-programEditorPresetTabColors-1{
    --gradient-to-color: #798fa3;
  }

  .xl\\:to-programEditorPresetTabColors-1h{
    --gradient-to-color: #798fa3;
  }

  .xl\\:to-borgScaleColors-0{
    --gradient-to-color: #c5d1ff;
  }

  .xl\\:to-borgScaleColors-1{
    --gradient-to-color: #a0b5fc;
  }

  .xl\\:to-borgScaleColors-2{
    --gradient-to-color: #7492ff;
  }

  .xl\\:to-borgScaleColors-3{
    --gradient-to-color: #82bbf1;
  }

  .xl\\:to-borgScaleColors-4{
    --gradient-to-color: #4ba4f7;
  }

  .xl\\:to-borgScaleColors-5{
    --gradient-to-color: #9cdd57;
  }

  .xl\\:to-borgScaleColors-6{
    --gradient-to-color: #68af00;
  }

  .xl\\:to-borgScaleColors-7{
    --gradient-to-color: #f5e380;
  }

  .xl\\:to-borgScaleColors-8{
    --gradient-to-color: #ffc246;
  }

  .xl\\:to-borgScaleColors-9{
    --gradient-to-color: #ff782f;
  }

  .xl\\:to-borgScaleColors-10{
    --gradient-to-color: #f25757;
  }

  .xl\\:hover\\:from-transparent:hover{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:hover\\:from-focus:hover{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:hover\\:from-black:hover{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:hover\\:from-white:hover{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:hover\\:from-primary:hover{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:hover\\:from-disabled:hover{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .xl\\:hover\\:from-translucent-60:hover{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:hover\\:from-translucent-90:hover{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:hover\\:from-green-200:hover{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .xl\\:hover\\:from-green-400:hover{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .xl\\:hover\\:from-green-500:hover{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .xl\\:hover\\:from-green-600:hover{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .xl\\:hover\\:from-green-700:hover{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .xl\\:hover\\:from-green-400a50:hover{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .xl\\:hover\\:from-green-500a25:hover{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .xl\\:hover\\:from-yellow-200:hover{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .xl\\:hover\\:from-yellow-300:hover{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .xl\\:hover\\:from-yellow-500:hover{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .xl\\:hover\\:from-yellow-600:hover{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .xl\\:hover\\:from-yellow-700:hover{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .xl\\:hover\\:from-yellow-300a66:hover{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .xl\\:hover\\:from-yellow-500a25:hover{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .xl\\:hover\\:from-orange-200:hover{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .xl\\:hover\\:from-orange-400:hover{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .xl\\:hover\\:from-orange-500:hover{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .xl\\:hover\\:from-orange-800:hover{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .xl\\:hover\\:from-orange-900:hover{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .xl\\:hover\\:from-orange-500a25:hover{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .xl\\:hover\\:from-red-100:hover{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .xl\\:hover\\:from-red-150:hover{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .xl\\:hover\\:from-red-200:hover{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .xl\\:hover\\:from-red-300:hover{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .xl\\:hover\\:from-red-400:hover{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .xl\\:hover\\:from-red-500:hover{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .xl\\:hover\\:from-red-700:hover{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .xl\\:hover\\:from-gray-50:hover{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .xl\\:hover\\:from-gray-100:hover{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .xl\\:hover\\:from-gray-150:hover{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .xl\\:hover\\:from-gray-200:hover{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .xl\\:hover\\:from-gray-300:hover{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .xl\\:hover\\:from-gray-400:hover{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .xl\\:hover\\:from-gray-425:hover{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .xl\\:hover\\:from-gray-450:hover{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .xl\\:hover\\:from-gray-500:hover{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .xl\\:hover\\:from-gray-600:hover{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .xl\\:hover\\:from-gray-625:hover{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .xl\\:hover\\:from-gray-700:hover{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .xl\\:hover\\:from-gray-800:hover{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .xl\\:hover\\:from-gray-200a50:hover{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .xl\\:hover\\:from-blue-50:hover{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .xl\\:hover\\:from-blue-100:hover{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .xl\\:hover\\:from-blue-150:hover{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .xl\\:hover\\:from-blue-200:hover{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .xl\\:hover\\:from-blue-300:hover{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .xl\\:hover\\:from-blue-400:hover{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .xl\\:hover\\:from-blue-500:hover{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:hover\\:from-blue-600:hover{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .xl\\:hover\\:from-blue-700:hover{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .xl\\:hover\\:from-blue-750:hover{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:hover\\:from-blue-800:hover{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .xl\\:hover\\:from-blue-900:hover{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .xl\\:hover\\:from-blue-950:hover{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .xl\\:hover\\:from-blue-500a25:hover{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:hover\\:from-blue-500a50:hover{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:hover\\:from-blue-700a75:hover{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .xl\\:hover\\:from-blue-700a30:hover{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .xl\\:hover\\:from-blue-750a25:hover{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:hover\\:from-blue-750a15:hover{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:hover\\:from-blue-800a60:hover{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .xl\\:hover\\:from-programEditorTabColors-1:hover{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .xl\\:hover\\:from-programEditorTabColors-2:hover{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .xl\\:hover\\:from-programEditorTabColors-3:hover{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .xl\\:hover\\:from-programEditorTabColors-4:hover{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .xl\\:hover\\:from-programEditorTabColors-5:hover{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .xl\\:hover\\:from-programEditorTabColors-6:hover{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .xl\\:hover\\:from-programEditorTabColors-1h:hover{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .xl\\:hover\\:from-programEditorTabColors-2h:hover{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .xl\\:hover\\:from-programEditorTabColors-3h:hover{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .xl\\:hover\\:from-programEditorTabColors-4h:hover{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .xl\\:hover\\:from-programEditorTabColors-5h:hover{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .xl\\:hover\\:from-programEditorTabColors-6h:hover{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .xl\\:hover\\:from-programEditorPresetTabColors-1:hover{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .xl\\:hover\\:from-programEditorPresetTabColors-1h:hover{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .xl\\:hover\\:from-borgScaleColors-0:hover{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .xl\\:hover\\:from-borgScaleColors-1:hover{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .xl\\:hover\\:from-borgScaleColors-2:hover{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .xl\\:hover\\:from-borgScaleColors-3:hover{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .xl\\:hover\\:from-borgScaleColors-4:hover{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .xl\\:hover\\:from-borgScaleColors-5:hover{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .xl\\:hover\\:from-borgScaleColors-6:hover{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .xl\\:hover\\:from-borgScaleColors-7:hover{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .xl\\:hover\\:from-borgScaleColors-8:hover{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .xl\\:hover\\:from-borgScaleColors-9:hover{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .xl\\:hover\\:from-borgScaleColors-10:hover{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .xl\\:hover\\:via-transparent:hover{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:hover\\:via-focus:hover{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:hover\\:via-black:hover{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:hover\\:via-white:hover{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:hover\\:via-primary:hover{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:hover\\:via-disabled:hover{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .xl\\:hover\\:via-translucent-60:hover{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:hover\\:via-translucent-90:hover{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:hover\\:via-green-200:hover{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .xl\\:hover\\:via-green-400:hover{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .xl\\:hover\\:via-green-500:hover{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .xl\\:hover\\:via-green-600:hover{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .xl\\:hover\\:via-green-700:hover{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .xl\\:hover\\:via-green-400a50:hover{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .xl\\:hover\\:via-green-500a25:hover{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .xl\\:hover\\:via-yellow-200:hover{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .xl\\:hover\\:via-yellow-300:hover{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .xl\\:hover\\:via-yellow-500:hover{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .xl\\:hover\\:via-yellow-600:hover{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .xl\\:hover\\:via-yellow-700:hover{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .xl\\:hover\\:via-yellow-300a66:hover{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .xl\\:hover\\:via-yellow-500a25:hover{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .xl\\:hover\\:via-orange-200:hover{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .xl\\:hover\\:via-orange-400:hover{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .xl\\:hover\\:via-orange-500:hover{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .xl\\:hover\\:via-orange-800:hover{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .xl\\:hover\\:via-orange-900:hover{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .xl\\:hover\\:via-orange-500a25:hover{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .xl\\:hover\\:via-red-100:hover{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .xl\\:hover\\:via-red-150:hover{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .xl\\:hover\\:via-red-200:hover{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .xl\\:hover\\:via-red-300:hover{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .xl\\:hover\\:via-red-400:hover{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .xl\\:hover\\:via-red-500:hover{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .xl\\:hover\\:via-red-700:hover{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .xl\\:hover\\:via-gray-50:hover{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .xl\\:hover\\:via-gray-100:hover{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .xl\\:hover\\:via-gray-150:hover{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .xl\\:hover\\:via-gray-200:hover{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .xl\\:hover\\:via-gray-300:hover{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .xl\\:hover\\:via-gray-400:hover{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .xl\\:hover\\:via-gray-425:hover{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .xl\\:hover\\:via-gray-450:hover{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .xl\\:hover\\:via-gray-500:hover{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .xl\\:hover\\:via-gray-600:hover{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .xl\\:hover\\:via-gray-625:hover{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .xl\\:hover\\:via-gray-700:hover{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .xl\\:hover\\:via-gray-800:hover{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .xl\\:hover\\:via-gray-200a50:hover{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .xl\\:hover\\:via-blue-50:hover{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .xl\\:hover\\:via-blue-100:hover{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .xl\\:hover\\:via-blue-150:hover{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .xl\\:hover\\:via-blue-200:hover{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .xl\\:hover\\:via-blue-300:hover{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .xl\\:hover\\:via-blue-400:hover{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .xl\\:hover\\:via-blue-500:hover{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:hover\\:via-blue-600:hover{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .xl\\:hover\\:via-blue-700:hover{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .xl\\:hover\\:via-blue-750:hover{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:hover\\:via-blue-800:hover{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .xl\\:hover\\:via-blue-900:hover{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .xl\\:hover\\:via-blue-950:hover{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .xl\\:hover\\:via-blue-500a25:hover{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:hover\\:via-blue-500a50:hover{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:hover\\:via-blue-700a75:hover{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .xl\\:hover\\:via-blue-700a30:hover{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .xl\\:hover\\:via-blue-750a25:hover{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:hover\\:via-blue-750a15:hover{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:hover\\:via-blue-800a60:hover{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .xl\\:hover\\:via-programEditorTabColors-1:hover{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .xl\\:hover\\:via-programEditorTabColors-2:hover{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .xl\\:hover\\:via-programEditorTabColors-3:hover{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .xl\\:hover\\:via-programEditorTabColors-4:hover{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .xl\\:hover\\:via-programEditorTabColors-5:hover{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .xl\\:hover\\:via-programEditorTabColors-6:hover{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .xl\\:hover\\:via-programEditorTabColors-1h:hover{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .xl\\:hover\\:via-programEditorTabColors-2h:hover{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .xl\\:hover\\:via-programEditorTabColors-3h:hover{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .xl\\:hover\\:via-programEditorTabColors-4h:hover{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .xl\\:hover\\:via-programEditorTabColors-5h:hover{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .xl\\:hover\\:via-programEditorTabColors-6h:hover{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .xl\\:hover\\:via-programEditorPresetTabColors-1:hover{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .xl\\:hover\\:via-programEditorPresetTabColors-1h:hover{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .xl\\:hover\\:via-borgScaleColors-0:hover{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .xl\\:hover\\:via-borgScaleColors-1:hover{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .xl\\:hover\\:via-borgScaleColors-2:hover{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .xl\\:hover\\:via-borgScaleColors-3:hover{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .xl\\:hover\\:via-borgScaleColors-4:hover{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .xl\\:hover\\:via-borgScaleColors-5:hover{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .xl\\:hover\\:via-borgScaleColors-6:hover{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .xl\\:hover\\:via-borgScaleColors-7:hover{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .xl\\:hover\\:via-borgScaleColors-8:hover{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .xl\\:hover\\:via-borgScaleColors-9:hover{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .xl\\:hover\\:via-borgScaleColors-10:hover{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .xl\\:hover\\:to-transparent:hover{
    --gradient-to-color: transparent;
  }

  .xl\\:hover\\:to-focus:hover{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .xl\\:hover\\:to-black:hover{
    --gradient-to-color: #000;
  }

  .xl\\:hover\\:to-white:hover{
    --gradient-to-color: #fff;
  }

  .xl\\:hover\\:to-primary:hover{
    --gradient-to-color: #37A4DC;
  }

  .xl\\:hover\\:to-disabled:hover{
    --gradient-to-color: #BFBFBF;
  }

  .xl\\:hover\\:to-translucent-60:hover{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .xl\\:hover\\:to-translucent-90:hover{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .xl\\:hover\\:to-green-200:hover{
    --gradient-to-color: #f4fcea;
  }

  .xl\\:hover\\:to-green-400:hover{
    --gradient-to-color: #6CCA98;
  }

  .xl\\:hover\\:to-green-500:hover{
    --gradient-to-color: #97E812;
  }

  .xl\\:hover\\:to-green-600:hover{
    --gradient-to-color: #4f9112;
  }

  .xl\\:hover\\:to-green-700:hover{
    --gradient-to-color: #3e7211;
  }

  .xl\\:hover\\:to-green-400a50:hover{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .xl\\:hover\\:to-green-500a25:hover{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .xl\\:hover\\:to-yellow-200:hover{
    --gradient-to-color: #fff9eb;
  }

  .xl\\:hover\\:to-yellow-300:hover{
    --gradient-to-color: #ffe9bd;
  }

  .xl\\:hover\\:to-yellow-500:hover{
    --gradient-to-color: #FFC82C;
  }

  .xl\\:hover\\:to-yellow-600:hover{
    --gradient-to-color: #F7931E;
  }

  .xl\\:hover\\:to-yellow-700:hover{
    --gradient-to-color: #E1AD28;
  }

  .xl\\:hover\\:to-yellow-300a66:hover{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .xl\\:hover\\:to-yellow-500a25:hover{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .xl\\:hover\\:to-orange-200:hover{
    --gradient-to-color: #fdf0ea;
  }

  .xl\\:hover\\:to-orange-400:hover{
    --gradient-to-color: #f6c66f;
  }

  .xl\\:hover\\:to-orange-500:hover{
    --gradient-to-color: #F07313;
  }

  .xl\\:hover\\:to-orange-800:hover{
    --gradient-to-color: #db5d0c;
  }

  .xl\\:hover\\:to-orange-900:hover{
    --gradient-to-color: #b86814;
  }

  .xl\\:hover\\:to-orange-500a25:hover{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .xl\\:hover\\:to-red-100:hover{
    --gradient-to-color: #FEF5F5;
  }

  .xl\\:hover\\:to-red-150:hover{
    --gradient-to-color: #ffe9e8;
  }

  .xl\\:hover\\:to-red-200:hover{
    --gradient-to-color: #F8CECC;
  }

  .xl\\:hover\\:to-red-300:hover{
    --gradient-to-color: #ff8585;
  }

  .xl\\:hover\\:to-red-400:hover{
    --gradient-to-color: #ff3535;
  }

  .xl\\:hover\\:to-red-500:hover{
    --gradient-to-color: #DD4746;
  }

  .xl\\:hover\\:to-red-700:hover{
    --gradient-to-color: #A23C24;
  }

  .xl\\:hover\\:to-gray-50:hover{
    --gradient-to-color: #F9F9F9;
  }

  .xl\\:hover\\:to-gray-100:hover{
    --gradient-to-color: #F1F1F2;
  }

  .xl\\:hover\\:to-gray-150:hover{
    --gradient-to-color: #e6e6e6;
  }

  .xl\\:hover\\:to-gray-200:hover{
    --gradient-to-color: #E0E2E4;
  }

  .xl\\:hover\\:to-gray-300:hover{
    --gradient-to-color: #BFBFBF;
  }

  .xl\\:hover\\:to-gray-400:hover{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .xl\\:hover\\:to-gray-425:hover{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .xl\\:hover\\:to-gray-450:hover{
    --gradient-to-color: #959595;
  }

  .xl\\:hover\\:to-gray-500:hover{
    --gradient-to-color: #727272;
  }

  .xl\\:hover\\:to-gray-600:hover{
    --gradient-to-color: #5a626b;
  }

  .xl\\:hover\\:to-gray-625:hover{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .xl\\:hover\\:to-gray-700:hover{
    --gradient-to-color: #464C59;
  }

  .xl\\:hover\\:to-gray-800:hover{
    --gradient-to-color: #3c3b3b;
  }

  .xl\\:hover\\:to-gray-200a50:hover{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .xl\\:hover\\:to-blue-50:hover{
    --gradient-to-color: #f2fbff;
  }

  .xl\\:hover\\:to-blue-100:hover{
    --gradient-to-color: #EBF6FC;
  }

  .xl\\:hover\\:to-blue-150:hover{
    --gradient-to-color: #E8EEF1;
  }

  .xl\\:hover\\:to-blue-200:hover{
    --gradient-to-color: #CCE6F5;
  }

  .xl\\:hover\\:to-blue-300:hover{
    --gradient-to-color: #73BFE7;
  }

  .xl\\:hover\\:to-blue-400:hover{
    --gradient-to-color: #4BA4F7;
  }

  .xl\\:hover\\:to-blue-500:hover{
    --gradient-to-color: #37A4DC;
  }

  .xl\\:hover\\:to-blue-600:hover{
    --gradient-to-color: #6AA2D6;
  }

  .xl\\:hover\\:to-blue-700:hover{
    --gradient-to-color: #456E9A;
  }

  .xl\\:hover\\:to-blue-750:hover{
    --gradient-to-color: #5682AA;
  }

  .xl\\:hover\\:to-blue-800:hover{
    --gradient-to-color: #1F4566;
  }

  .xl\\:hover\\:to-blue-900:hover{
    --gradient-to-color: #183453;
  }

  .xl\\:hover\\:to-blue-950:hover{
    --gradient-to-color: #041527;
  }

  .xl\\:hover\\:to-blue-500a25:hover{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .xl\\:hover\\:to-blue-500a50:hover{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .xl\\:hover\\:to-blue-700a75:hover{
    --gradient-to-color: #3B648D;
  }

  .xl\\:hover\\:to-blue-700a30:hover{
    --gradient-to-color: #2A5176;
  }

  .xl\\:hover\\:to-blue-750a25:hover{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .xl\\:hover\\:to-blue-750a15:hover{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .xl\\:hover\\:to-blue-800a60:hover{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .xl\\:hover\\:to-programEditorTabColors-1:hover{
    --gradient-to-color: #3cacae;
  }

  .xl\\:hover\\:to-programEditorTabColors-2:hover{
    --gradient-to-color: #8e346a;
  }

  .xl\\:hover\\:to-programEditorTabColors-3:hover{
    --gradient-to-color: #ff72b7;
  }

  .xl\\:hover\\:to-programEditorTabColors-4:hover{
    --gradient-to-color: #ce941c;
  }

  .xl\\:hover\\:to-programEditorTabColors-5:hover{
    --gradient-to-color: #b973d9;
  }

  .xl\\:hover\\:to-programEditorTabColors-6:hover{
    --gradient-to-color: #ff9082;
  }

  .xl\\:hover\\:to-programEditorTabColors-1h:hover{
    --gradient-to-color: #d9f2f2;
  }

  .xl\\:hover\\:to-programEditorTabColors-2h:hover{
    --gradient-to-color: #f1dae8;
  }

  .xl\\:hover\\:to-programEditorTabColors-3h:hover{
    --gradient-to-color: #ffe6f2;
  }

  .xl\\:hover\\:to-programEditorTabColors-4h:hover{
    --gradient-to-color: #f9ecd2;
  }

  .xl\\:hover\\:to-programEditorTabColors-5h:hover{
    --gradient-to-color: #f5ebfa;
  }

  .xl\\:hover\\:to-programEditorTabColors-6h:hover{
    --gradient-to-color: #ffe8e6;
  }

  .xl\\:hover\\:to-programEditorPresetTabColors-1:hover{
    --gradient-to-color: #798fa3;
  }

  .xl\\:hover\\:to-programEditorPresetTabColors-1h:hover{
    --gradient-to-color: #798fa3;
  }

  .xl\\:hover\\:to-borgScaleColors-0:hover{
    --gradient-to-color: #c5d1ff;
  }

  .xl\\:hover\\:to-borgScaleColors-1:hover{
    --gradient-to-color: #a0b5fc;
  }

  .xl\\:hover\\:to-borgScaleColors-2:hover{
    --gradient-to-color: #7492ff;
  }

  .xl\\:hover\\:to-borgScaleColors-3:hover{
    --gradient-to-color: #82bbf1;
  }

  .xl\\:hover\\:to-borgScaleColors-4:hover{
    --gradient-to-color: #4ba4f7;
  }

  .xl\\:hover\\:to-borgScaleColors-5:hover{
    --gradient-to-color: #9cdd57;
  }

  .xl\\:hover\\:to-borgScaleColors-6:hover{
    --gradient-to-color: #68af00;
  }

  .xl\\:hover\\:to-borgScaleColors-7:hover{
    --gradient-to-color: #f5e380;
  }

  .xl\\:hover\\:to-borgScaleColors-8:hover{
    --gradient-to-color: #ffc246;
  }

  .xl\\:hover\\:to-borgScaleColors-9:hover{
    --gradient-to-color: #ff782f;
  }

  .xl\\:hover\\:to-borgScaleColors-10:hover{
    --gradient-to-color: #f25757;
  }

  .xl\\:focus\\:from-transparent:focus{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:focus\\:from-focus:focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:focus\\:from-black:focus{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:focus\\:from-white:focus{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:focus\\:from-primary:focus{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:focus\\:from-disabled:focus{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .xl\\:focus\\:from-translucent-60:focus{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:focus\\:from-translucent-90:focus{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:focus\\:from-green-200:focus{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .xl\\:focus\\:from-green-400:focus{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .xl\\:focus\\:from-green-500:focus{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .xl\\:focus\\:from-green-600:focus{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .xl\\:focus\\:from-green-700:focus{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .xl\\:focus\\:from-green-400a50:focus{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .xl\\:focus\\:from-green-500a25:focus{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .xl\\:focus\\:from-yellow-200:focus{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .xl\\:focus\\:from-yellow-300:focus{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .xl\\:focus\\:from-yellow-500:focus{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .xl\\:focus\\:from-yellow-600:focus{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .xl\\:focus\\:from-yellow-700:focus{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .xl\\:focus\\:from-yellow-300a66:focus{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .xl\\:focus\\:from-yellow-500a25:focus{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .xl\\:focus\\:from-orange-200:focus{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .xl\\:focus\\:from-orange-400:focus{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .xl\\:focus\\:from-orange-500:focus{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .xl\\:focus\\:from-orange-800:focus{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .xl\\:focus\\:from-orange-900:focus{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .xl\\:focus\\:from-orange-500a25:focus{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .xl\\:focus\\:from-red-100:focus{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .xl\\:focus\\:from-red-150:focus{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .xl\\:focus\\:from-red-200:focus{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .xl\\:focus\\:from-red-300:focus{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .xl\\:focus\\:from-red-400:focus{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .xl\\:focus\\:from-red-500:focus{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .xl\\:focus\\:from-red-700:focus{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .xl\\:focus\\:from-gray-50:focus{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .xl\\:focus\\:from-gray-100:focus{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .xl\\:focus\\:from-gray-150:focus{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .xl\\:focus\\:from-gray-200:focus{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .xl\\:focus\\:from-gray-300:focus{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .xl\\:focus\\:from-gray-400:focus{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .xl\\:focus\\:from-gray-425:focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .xl\\:focus\\:from-gray-450:focus{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .xl\\:focus\\:from-gray-500:focus{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .xl\\:focus\\:from-gray-600:focus{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .xl\\:focus\\:from-gray-625:focus{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .xl\\:focus\\:from-gray-700:focus{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .xl\\:focus\\:from-gray-800:focus{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .xl\\:focus\\:from-gray-200a50:focus{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .xl\\:focus\\:from-blue-50:focus{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .xl\\:focus\\:from-blue-100:focus{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .xl\\:focus\\:from-blue-150:focus{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .xl\\:focus\\:from-blue-200:focus{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .xl\\:focus\\:from-blue-300:focus{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .xl\\:focus\\:from-blue-400:focus{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .xl\\:focus\\:from-blue-500:focus{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:focus\\:from-blue-600:focus{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .xl\\:focus\\:from-blue-700:focus{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .xl\\:focus\\:from-blue-750:focus{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:focus\\:from-blue-800:focus{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .xl\\:focus\\:from-blue-900:focus{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .xl\\:focus\\:from-blue-950:focus{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .xl\\:focus\\:from-blue-500a25:focus{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:focus\\:from-blue-500a50:focus{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:focus\\:from-blue-700a75:focus{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .xl\\:focus\\:from-blue-700a30:focus{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .xl\\:focus\\:from-blue-750a25:focus{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:focus\\:from-blue-750a15:focus{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:focus\\:from-blue-800a60:focus{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .xl\\:focus\\:from-programEditorTabColors-1:focus{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .xl\\:focus\\:from-programEditorTabColors-2:focus{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .xl\\:focus\\:from-programEditorTabColors-3:focus{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .xl\\:focus\\:from-programEditorTabColors-4:focus{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .xl\\:focus\\:from-programEditorTabColors-5:focus{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .xl\\:focus\\:from-programEditorTabColors-6:focus{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .xl\\:focus\\:from-programEditorTabColors-1h:focus{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .xl\\:focus\\:from-programEditorTabColors-2h:focus{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .xl\\:focus\\:from-programEditorTabColors-3h:focus{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .xl\\:focus\\:from-programEditorTabColors-4h:focus{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .xl\\:focus\\:from-programEditorTabColors-5h:focus{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .xl\\:focus\\:from-programEditorTabColors-6h:focus{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .xl\\:focus\\:from-programEditorPresetTabColors-1:focus{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .xl\\:focus\\:from-programEditorPresetTabColors-1h:focus{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .xl\\:focus\\:from-borgScaleColors-0:focus{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .xl\\:focus\\:from-borgScaleColors-1:focus{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .xl\\:focus\\:from-borgScaleColors-2:focus{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .xl\\:focus\\:from-borgScaleColors-3:focus{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .xl\\:focus\\:from-borgScaleColors-4:focus{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .xl\\:focus\\:from-borgScaleColors-5:focus{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .xl\\:focus\\:from-borgScaleColors-6:focus{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .xl\\:focus\\:from-borgScaleColors-7:focus{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .xl\\:focus\\:from-borgScaleColors-8:focus{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .xl\\:focus\\:from-borgScaleColors-9:focus{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .xl\\:focus\\:from-borgScaleColors-10:focus{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .xl\\:focus\\:via-transparent:focus{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:focus\\:via-focus:focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:focus\\:via-black:focus{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .xl\\:focus\\:via-white:focus{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:focus\\:via-primary:focus{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:focus\\:via-disabled:focus{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .xl\\:focus\\:via-translucent-60:focus{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:focus\\:via-translucent-90:focus{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .xl\\:focus\\:via-green-200:focus{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .xl\\:focus\\:via-green-400:focus{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .xl\\:focus\\:via-green-500:focus{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .xl\\:focus\\:via-green-600:focus{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .xl\\:focus\\:via-green-700:focus{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .xl\\:focus\\:via-green-400a50:focus{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .xl\\:focus\\:via-green-500a25:focus{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .xl\\:focus\\:via-yellow-200:focus{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .xl\\:focus\\:via-yellow-300:focus{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .xl\\:focus\\:via-yellow-500:focus{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .xl\\:focus\\:via-yellow-600:focus{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .xl\\:focus\\:via-yellow-700:focus{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .xl\\:focus\\:via-yellow-300a66:focus{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .xl\\:focus\\:via-yellow-500a25:focus{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .xl\\:focus\\:via-orange-200:focus{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .xl\\:focus\\:via-orange-400:focus{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .xl\\:focus\\:via-orange-500:focus{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .xl\\:focus\\:via-orange-800:focus{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .xl\\:focus\\:via-orange-900:focus{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .xl\\:focus\\:via-orange-500a25:focus{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .xl\\:focus\\:via-red-100:focus{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .xl\\:focus\\:via-red-150:focus{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .xl\\:focus\\:via-red-200:focus{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .xl\\:focus\\:via-red-300:focus{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .xl\\:focus\\:via-red-400:focus{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .xl\\:focus\\:via-red-500:focus{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .xl\\:focus\\:via-red-700:focus{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .xl\\:focus\\:via-gray-50:focus{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .xl\\:focus\\:via-gray-100:focus{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .xl\\:focus\\:via-gray-150:focus{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .xl\\:focus\\:via-gray-200:focus{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .xl\\:focus\\:via-gray-300:focus{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .xl\\:focus\\:via-gray-400:focus{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .xl\\:focus\\:via-gray-425:focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .xl\\:focus\\:via-gray-450:focus{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .xl\\:focus\\:via-gray-500:focus{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .xl\\:focus\\:via-gray-600:focus{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .xl\\:focus\\:via-gray-625:focus{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .xl\\:focus\\:via-gray-700:focus{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .xl\\:focus\\:via-gray-800:focus{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .xl\\:focus\\:via-gray-200a50:focus{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .xl\\:focus\\:via-blue-50:focus{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .xl\\:focus\\:via-blue-100:focus{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .xl\\:focus\\:via-blue-150:focus{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .xl\\:focus\\:via-blue-200:focus{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .xl\\:focus\\:via-blue-300:focus{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .xl\\:focus\\:via-blue-400:focus{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .xl\\:focus\\:via-blue-500:focus{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:focus\\:via-blue-600:focus{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .xl\\:focus\\:via-blue-700:focus{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .xl\\:focus\\:via-blue-750:focus{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:focus\\:via-blue-800:focus{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .xl\\:focus\\:via-blue-900:focus{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .xl\\:focus\\:via-blue-950:focus{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .xl\\:focus\\:via-blue-500a25:focus{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:focus\\:via-blue-500a50:focus{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .xl\\:focus\\:via-blue-700a75:focus{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .xl\\:focus\\:via-blue-700a30:focus{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .xl\\:focus\\:via-blue-750a25:focus{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:focus\\:via-blue-750a15:focus{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .xl\\:focus\\:via-blue-800a60:focus{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .xl\\:focus\\:via-programEditorTabColors-1:focus{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .xl\\:focus\\:via-programEditorTabColors-2:focus{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .xl\\:focus\\:via-programEditorTabColors-3:focus{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .xl\\:focus\\:via-programEditorTabColors-4:focus{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .xl\\:focus\\:via-programEditorTabColors-5:focus{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .xl\\:focus\\:via-programEditorTabColors-6:focus{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .xl\\:focus\\:via-programEditorTabColors-1h:focus{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .xl\\:focus\\:via-programEditorTabColors-2h:focus{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .xl\\:focus\\:via-programEditorTabColors-3h:focus{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .xl\\:focus\\:via-programEditorTabColors-4h:focus{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .xl\\:focus\\:via-programEditorTabColors-5h:focus{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .xl\\:focus\\:via-programEditorTabColors-6h:focus{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .xl\\:focus\\:via-programEditorPresetTabColors-1:focus{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .xl\\:focus\\:via-programEditorPresetTabColors-1h:focus{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .xl\\:focus\\:via-borgScaleColors-0:focus{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .xl\\:focus\\:via-borgScaleColors-1:focus{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .xl\\:focus\\:via-borgScaleColors-2:focus{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .xl\\:focus\\:via-borgScaleColors-3:focus{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .xl\\:focus\\:via-borgScaleColors-4:focus{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .xl\\:focus\\:via-borgScaleColors-5:focus{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .xl\\:focus\\:via-borgScaleColors-6:focus{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .xl\\:focus\\:via-borgScaleColors-7:focus{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .xl\\:focus\\:via-borgScaleColors-8:focus{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .xl\\:focus\\:via-borgScaleColors-9:focus{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .xl\\:focus\\:via-borgScaleColors-10:focus{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .xl\\:focus\\:to-transparent:focus{
    --gradient-to-color: transparent;
  }

  .xl\\:focus\\:to-focus:focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .xl\\:focus\\:to-black:focus{
    --gradient-to-color: #000;
  }

  .xl\\:focus\\:to-white:focus{
    --gradient-to-color: #fff;
  }

  .xl\\:focus\\:to-primary:focus{
    --gradient-to-color: #37A4DC;
  }

  .xl\\:focus\\:to-disabled:focus{
    --gradient-to-color: #BFBFBF;
  }

  .xl\\:focus\\:to-translucent-60:focus{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .xl\\:focus\\:to-translucent-90:focus{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .xl\\:focus\\:to-green-200:focus{
    --gradient-to-color: #f4fcea;
  }

  .xl\\:focus\\:to-green-400:focus{
    --gradient-to-color: #6CCA98;
  }

  .xl\\:focus\\:to-green-500:focus{
    --gradient-to-color: #97E812;
  }

  .xl\\:focus\\:to-green-600:focus{
    --gradient-to-color: #4f9112;
  }

  .xl\\:focus\\:to-green-700:focus{
    --gradient-to-color: #3e7211;
  }

  .xl\\:focus\\:to-green-400a50:focus{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .xl\\:focus\\:to-green-500a25:focus{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .xl\\:focus\\:to-yellow-200:focus{
    --gradient-to-color: #fff9eb;
  }

  .xl\\:focus\\:to-yellow-300:focus{
    --gradient-to-color: #ffe9bd;
  }

  .xl\\:focus\\:to-yellow-500:focus{
    --gradient-to-color: #FFC82C;
  }

  .xl\\:focus\\:to-yellow-600:focus{
    --gradient-to-color: #F7931E;
  }

  .xl\\:focus\\:to-yellow-700:focus{
    --gradient-to-color: #E1AD28;
  }

  .xl\\:focus\\:to-yellow-300a66:focus{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .xl\\:focus\\:to-yellow-500a25:focus{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .xl\\:focus\\:to-orange-200:focus{
    --gradient-to-color: #fdf0ea;
  }

  .xl\\:focus\\:to-orange-400:focus{
    --gradient-to-color: #f6c66f;
  }

  .xl\\:focus\\:to-orange-500:focus{
    --gradient-to-color: #F07313;
  }

  .xl\\:focus\\:to-orange-800:focus{
    --gradient-to-color: #db5d0c;
  }

  .xl\\:focus\\:to-orange-900:focus{
    --gradient-to-color: #b86814;
  }

  .xl\\:focus\\:to-orange-500a25:focus{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .xl\\:focus\\:to-red-100:focus{
    --gradient-to-color: #FEF5F5;
  }

  .xl\\:focus\\:to-red-150:focus{
    --gradient-to-color: #ffe9e8;
  }

  .xl\\:focus\\:to-red-200:focus{
    --gradient-to-color: #F8CECC;
  }

  .xl\\:focus\\:to-red-300:focus{
    --gradient-to-color: #ff8585;
  }

  .xl\\:focus\\:to-red-400:focus{
    --gradient-to-color: #ff3535;
  }

  .xl\\:focus\\:to-red-500:focus{
    --gradient-to-color: #DD4746;
  }

  .xl\\:focus\\:to-red-700:focus{
    --gradient-to-color: #A23C24;
  }

  .xl\\:focus\\:to-gray-50:focus{
    --gradient-to-color: #F9F9F9;
  }

  .xl\\:focus\\:to-gray-100:focus{
    --gradient-to-color: #F1F1F2;
  }

  .xl\\:focus\\:to-gray-150:focus{
    --gradient-to-color: #e6e6e6;
  }

  .xl\\:focus\\:to-gray-200:focus{
    --gradient-to-color: #E0E2E4;
  }

  .xl\\:focus\\:to-gray-300:focus{
    --gradient-to-color: #BFBFBF;
  }

  .xl\\:focus\\:to-gray-400:focus{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .xl\\:focus\\:to-gray-425:focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .xl\\:focus\\:to-gray-450:focus{
    --gradient-to-color: #959595;
  }

  .xl\\:focus\\:to-gray-500:focus{
    --gradient-to-color: #727272;
  }

  .xl\\:focus\\:to-gray-600:focus{
    --gradient-to-color: #5a626b;
  }

  .xl\\:focus\\:to-gray-625:focus{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .xl\\:focus\\:to-gray-700:focus{
    --gradient-to-color: #464C59;
  }

  .xl\\:focus\\:to-gray-800:focus{
    --gradient-to-color: #3c3b3b;
  }

  .xl\\:focus\\:to-gray-200a50:focus{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .xl\\:focus\\:to-blue-50:focus{
    --gradient-to-color: #f2fbff;
  }

  .xl\\:focus\\:to-blue-100:focus{
    --gradient-to-color: #EBF6FC;
  }

  .xl\\:focus\\:to-blue-150:focus{
    --gradient-to-color: #E8EEF1;
  }

  .xl\\:focus\\:to-blue-200:focus{
    --gradient-to-color: #CCE6F5;
  }

  .xl\\:focus\\:to-blue-300:focus{
    --gradient-to-color: #73BFE7;
  }

  .xl\\:focus\\:to-blue-400:focus{
    --gradient-to-color: #4BA4F7;
  }

  .xl\\:focus\\:to-blue-500:focus{
    --gradient-to-color: #37A4DC;
  }

  .xl\\:focus\\:to-blue-600:focus{
    --gradient-to-color: #6AA2D6;
  }

  .xl\\:focus\\:to-blue-700:focus{
    --gradient-to-color: #456E9A;
  }

  .xl\\:focus\\:to-blue-750:focus{
    --gradient-to-color: #5682AA;
  }

  .xl\\:focus\\:to-blue-800:focus{
    --gradient-to-color: #1F4566;
  }

  .xl\\:focus\\:to-blue-900:focus{
    --gradient-to-color: #183453;
  }

  .xl\\:focus\\:to-blue-950:focus{
    --gradient-to-color: #041527;
  }

  .xl\\:focus\\:to-blue-500a25:focus{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .xl\\:focus\\:to-blue-500a50:focus{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .xl\\:focus\\:to-blue-700a75:focus{
    --gradient-to-color: #3B648D;
  }

  .xl\\:focus\\:to-blue-700a30:focus{
    --gradient-to-color: #2A5176;
  }

  .xl\\:focus\\:to-blue-750a25:focus{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .xl\\:focus\\:to-blue-750a15:focus{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .xl\\:focus\\:to-blue-800a60:focus{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .xl\\:focus\\:to-programEditorTabColors-1:focus{
    --gradient-to-color: #3cacae;
  }

  .xl\\:focus\\:to-programEditorTabColors-2:focus{
    --gradient-to-color: #8e346a;
  }

  .xl\\:focus\\:to-programEditorTabColors-3:focus{
    --gradient-to-color: #ff72b7;
  }

  .xl\\:focus\\:to-programEditorTabColors-4:focus{
    --gradient-to-color: #ce941c;
  }

  .xl\\:focus\\:to-programEditorTabColors-5:focus{
    --gradient-to-color: #b973d9;
  }

  .xl\\:focus\\:to-programEditorTabColors-6:focus{
    --gradient-to-color: #ff9082;
  }

  .xl\\:focus\\:to-programEditorTabColors-1h:focus{
    --gradient-to-color: #d9f2f2;
  }

  .xl\\:focus\\:to-programEditorTabColors-2h:focus{
    --gradient-to-color: #f1dae8;
  }

  .xl\\:focus\\:to-programEditorTabColors-3h:focus{
    --gradient-to-color: #ffe6f2;
  }

  .xl\\:focus\\:to-programEditorTabColors-4h:focus{
    --gradient-to-color: #f9ecd2;
  }

  .xl\\:focus\\:to-programEditorTabColors-5h:focus{
    --gradient-to-color: #f5ebfa;
  }

  .xl\\:focus\\:to-programEditorTabColors-6h:focus{
    --gradient-to-color: #ffe8e6;
  }

  .xl\\:focus\\:to-programEditorPresetTabColors-1:focus{
    --gradient-to-color: #798fa3;
  }

  .xl\\:focus\\:to-programEditorPresetTabColors-1h:focus{
    --gradient-to-color: #798fa3;
  }

  .xl\\:focus\\:to-borgScaleColors-0:focus{
    --gradient-to-color: #c5d1ff;
  }

  .xl\\:focus\\:to-borgScaleColors-1:focus{
    --gradient-to-color: #a0b5fc;
  }

  .xl\\:focus\\:to-borgScaleColors-2:focus{
    --gradient-to-color: #7492ff;
  }

  .xl\\:focus\\:to-borgScaleColors-3:focus{
    --gradient-to-color: #82bbf1;
  }

  .xl\\:focus\\:to-borgScaleColors-4:focus{
    --gradient-to-color: #4ba4f7;
  }

  .xl\\:focus\\:to-borgScaleColors-5:focus{
    --gradient-to-color: #9cdd57;
  }

  .xl\\:focus\\:to-borgScaleColors-6:focus{
    --gradient-to-color: #68af00;
  }

  .xl\\:focus\\:to-borgScaleColors-7:focus{
    --gradient-to-color: #f5e380;
  }

  .xl\\:focus\\:to-borgScaleColors-8:focus{
    --gradient-to-color: #ffc246;
  }

  .xl\\:focus\\:to-borgScaleColors-9:focus{
    --gradient-to-color: #ff782f;
  }

  .xl\\:focus\\:to-borgScaleColors-10:focus{
    --gradient-to-color: #f25757;
  }

  .xl\\:bg-opacity-0{
    --bg-opacity: 0;
  }

  .xl\\:bg-opacity-25{
    --bg-opacity: .25;
  }

  .xl\\:bg-opacity-50{
    --bg-opacity: .5;
  }

  .xl\\:bg-opacity-75{
    --bg-opacity: .75;
  }

  .xl\\:bg-opacity-100{
    --bg-opacity: 1;
  }

  .xl\\:hover\\:bg-opacity-0:hover{
    --bg-opacity: 0;
  }

  .xl\\:hover\\:bg-opacity-25:hover{
    --bg-opacity: .25;
  }

  .xl\\:hover\\:bg-opacity-50:hover{
    --bg-opacity: .5;
  }

  .xl\\:hover\\:bg-opacity-75:hover{
    --bg-opacity: .75;
  }

  .xl\\:hover\\:bg-opacity-100:hover{
    --bg-opacity: 1;
  }

  .xl\\:focus\\:bg-opacity-0:focus{
    --bg-opacity: 0;
  }

  .xl\\:focus\\:bg-opacity-25:focus{
    --bg-opacity: .25;
  }

  .xl\\:focus\\:bg-opacity-50:focus{
    --bg-opacity: .5;
  }

  .xl\\:focus\\:bg-opacity-75:focus{
    --bg-opacity: .75;
  }

  .xl\\:focus\\:bg-opacity-100:focus{
    --bg-opacity: 1;
  }

  .xl\\:bg-bottom{
    background-position: bottom;
  }

  .xl\\:bg-center{
    background-position: center;
  }

  .xl\\:bg-left{
    background-position: left;
  }

  .xl\\:bg-left-bottom{
    background-position: left bottom;
  }

  .xl\\:bg-left-top{
    background-position: left top;
  }

  .xl\\:bg-right{
    background-position: right;
  }

  .xl\\:bg-right-bottom{
    background-position: right bottom;
  }

  .xl\\:bg-right-top{
    background-position: right top;
  }

  .xl\\:bg-top{
    background-position: top;
  }

  .xl\\:bg-repeat{
    background-repeat: repeat;
  }

  .xl\\:bg-no-repeat{
    background-repeat: no-repeat;
  }

  .xl\\:bg-repeat-x{
    background-repeat: repeat-x;
  }

  .xl\\:bg-repeat-y{
    background-repeat: repeat-y;
  }

  .xl\\:bg-repeat-round{
    background-repeat: round;
  }

  .xl\\:bg-repeat-space{
    background-repeat: space;
  }

  .xl\\:bg-auto{
    background-size: auto;
  }

  .xl\\:bg-cover{
    background-size: cover;
  }

  .xl\\:bg-contain{
    background-size: contain;
  }

  .xl\\:border-transparent{
    border-color: transparent;
  }

  .xl\\:border-focus{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .xl\\:border-black{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .xl\\:border-white{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .xl\\:border-primary{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .xl\\:border-disabled{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .xl\\:border-translucent-60{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .xl\\:border-translucent-90{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .xl\\:border-green-200{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .xl\\:border-green-400{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .xl\\:border-green-500{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .xl\\:border-green-600{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .xl\\:border-green-700{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .xl\\:border-green-400a50{
    border-color: rgba(108,202,152,0.50196);
  }

  .xl\\:border-green-500a25{
    border-color: rgba(151,232,18,0.09804);
  }

  .xl\\:border-yellow-200{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .xl\\:border-yellow-300{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .xl\\:border-yellow-500{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .xl\\:border-yellow-600{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .xl\\:border-yellow-700{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .xl\\:border-yellow-300a66{
    border-color: rgba(255,233,189,0.66667);
  }

  .xl\\:border-yellow-500a25{
    border-color: rgba(255,200,44,0.09804);
  }

  .xl\\:border-orange-200{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .xl\\:border-orange-400{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .xl\\:border-orange-500{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .xl\\:border-orange-800{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .xl\\:border-orange-900{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .xl\\:border-orange-500a25{
    border-color: rgba(240,115,23,0.09804);
  }

  .xl\\:border-red-100{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .xl\\:border-red-150{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .xl\\:border-red-200{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .xl\\:border-red-300{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .xl\\:border-red-400{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .xl\\:border-red-500{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .xl\\:border-red-700{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .xl\\:border-gray-50{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .xl\\:border-gray-100{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .xl\\:border-gray-150{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .xl\\:border-gray-200{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .xl\\:border-gray-300{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .xl\\:border-gray-400{
    border-color: rgba(114,114,114,0.8);
  }

  .xl\\:border-gray-425{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .xl\\:border-gray-450{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .xl\\:border-gray-500{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .xl\\:border-gray-600{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .xl\\:border-gray-625{
    border-color: rgba(90,98,107,0.8);
  }

  .xl\\:border-gray-700{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .xl\\:border-gray-800{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .xl\\:border-gray-200a50{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .xl\\:border-blue-50{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .xl\\:border-blue-100{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .xl\\:border-blue-150{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .xl\\:border-blue-200{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .xl\\:border-blue-300{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .xl\\:border-blue-400{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .xl\\:border-blue-500{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .xl\\:border-blue-600{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .xl\\:border-blue-700{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .xl\\:border-blue-750{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .xl\\:border-blue-800{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .xl\\:border-blue-900{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .xl\\:border-blue-950{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .xl\\:border-blue-500a25{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .xl\\:border-blue-500a50{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .xl\\:border-blue-700a75{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .xl\\:border-blue-700a30{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .xl\\:border-blue-750a25{
    border-color: rgba(86,130,170,0.09804);
  }

  .xl\\:border-blue-750a15{
    border-color: rgba(86,130,170,0.05882);
  }

  .xl\\:border-blue-800a60{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .xl\\:border-programEditorTabColors-1{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .xl\\:border-programEditorTabColors-2{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .xl\\:border-programEditorTabColors-3{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .xl\\:border-programEditorTabColors-4{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .xl\\:border-programEditorTabColors-5{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .xl\\:border-programEditorTabColors-6{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .xl\\:border-programEditorTabColors-1h{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .xl\\:border-programEditorTabColors-2h{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .xl\\:border-programEditorTabColors-3h{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .xl\\:border-programEditorTabColors-4h{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .xl\\:border-programEditorTabColors-5h{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .xl\\:border-programEditorTabColors-6h{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .xl\\:border-programEditorPresetTabColors-1{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .xl\\:border-programEditorPresetTabColors-1h{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .xl\\:border-borgScaleColors-0{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .xl\\:border-borgScaleColors-1{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .xl\\:border-borgScaleColors-2{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .xl\\:border-borgScaleColors-3{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .xl\\:border-borgScaleColors-4{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .xl\\:border-borgScaleColors-5{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .xl\\:border-borgScaleColors-6{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .xl\\:border-borgScaleColors-7{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .xl\\:border-borgScaleColors-8{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .xl\\:border-borgScaleColors-9{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .xl\\:border-borgScaleColors-10{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .xl\\:hover\\:border-transparent:hover{
    border-color: transparent;
  }

  .xl\\:hover\\:border-focus:hover{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .xl\\:hover\\:border-black:hover{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .xl\\:hover\\:border-white:hover{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .xl\\:hover\\:border-primary:hover{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .xl\\:hover\\:border-disabled:hover{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .xl\\:hover\\:border-translucent-60:hover{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .xl\\:hover\\:border-translucent-90:hover{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .xl\\:hover\\:border-green-200:hover{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .xl\\:hover\\:border-green-400:hover{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .xl\\:hover\\:border-green-500:hover{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .xl\\:hover\\:border-green-600:hover{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .xl\\:hover\\:border-green-700:hover{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .xl\\:hover\\:border-green-400a50:hover{
    border-color: rgba(108,202,152,0.50196);
  }

  .xl\\:hover\\:border-green-500a25:hover{
    border-color: rgba(151,232,18,0.09804);
  }

  .xl\\:hover\\:border-yellow-200:hover{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .xl\\:hover\\:border-yellow-300:hover{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .xl\\:hover\\:border-yellow-500:hover{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .xl\\:hover\\:border-yellow-600:hover{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .xl\\:hover\\:border-yellow-700:hover{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .xl\\:hover\\:border-yellow-300a66:hover{
    border-color: rgba(255,233,189,0.66667);
  }

  .xl\\:hover\\:border-yellow-500a25:hover{
    border-color: rgba(255,200,44,0.09804);
  }

  .xl\\:hover\\:border-orange-200:hover{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .xl\\:hover\\:border-orange-400:hover{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .xl\\:hover\\:border-orange-500:hover{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .xl\\:hover\\:border-orange-800:hover{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .xl\\:hover\\:border-orange-900:hover{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .xl\\:hover\\:border-orange-500a25:hover{
    border-color: rgba(240,115,23,0.09804);
  }

  .xl\\:hover\\:border-red-100:hover{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .xl\\:hover\\:border-red-150:hover{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .xl\\:hover\\:border-red-200:hover{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .xl\\:hover\\:border-red-300:hover{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .xl\\:hover\\:border-red-400:hover{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .xl\\:hover\\:border-red-500:hover{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .xl\\:hover\\:border-red-700:hover{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-50:hover{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-100:hover{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-150:hover{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-200:hover{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-300:hover{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-400:hover{
    border-color: rgba(114,114,114,0.8);
  }

  .xl\\:hover\\:border-gray-425:hover{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .xl\\:hover\\:border-gray-450:hover{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-500:hover{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-600:hover{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-625:hover{
    border-color: rgba(90,98,107,0.8);
  }

  .xl\\:hover\\:border-gray-700:hover{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-800:hover{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .xl\\:hover\\:border-gray-200a50:hover{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .xl\\:hover\\:border-blue-50:hover{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-100:hover{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-150:hover{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-200:hover{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-300:hover{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-400:hover{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-500:hover{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-600:hover{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-700:hover{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-750:hover{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-800:hover{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-900:hover{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-950:hover{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-500a25:hover{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .xl\\:hover\\:border-blue-500a50:hover{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .xl\\:hover\\:border-blue-700a75:hover{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-700a30:hover{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .xl\\:hover\\:border-blue-750a25:hover{
    border-color: rgba(86,130,170,0.09804);
  }

  .xl\\:hover\\:border-blue-750a15:hover{
    border-color: rgba(86,130,170,0.05882);
  }

  .xl\\:hover\\:border-blue-800a60:hover{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .xl\\:hover\\:border-programEditorTabColors-1:hover{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .xl\\:hover\\:border-programEditorTabColors-2:hover{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .xl\\:hover\\:border-programEditorTabColors-3:hover{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .xl\\:hover\\:border-programEditorTabColors-4:hover{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .xl\\:hover\\:border-programEditorTabColors-5:hover{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .xl\\:hover\\:border-programEditorTabColors-6:hover{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .xl\\:hover\\:border-programEditorTabColors-1h:hover{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .xl\\:hover\\:border-programEditorTabColors-2h:hover{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .xl\\:hover\\:border-programEditorTabColors-3h:hover{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .xl\\:hover\\:border-programEditorTabColors-4h:hover{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .xl\\:hover\\:border-programEditorTabColors-5h:hover{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .xl\\:hover\\:border-programEditorTabColors-6h:hover{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .xl\\:hover\\:border-programEditorPresetTabColors-1:hover{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .xl\\:hover\\:border-programEditorPresetTabColors-1h:hover{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .xl\\:hover\\:border-borgScaleColors-0:hover{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .xl\\:hover\\:border-borgScaleColors-1:hover{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .xl\\:hover\\:border-borgScaleColors-2:hover{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .xl\\:hover\\:border-borgScaleColors-3:hover{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .xl\\:hover\\:border-borgScaleColors-4:hover{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .xl\\:hover\\:border-borgScaleColors-5:hover{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .xl\\:hover\\:border-borgScaleColors-6:hover{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .xl\\:hover\\:border-borgScaleColors-7:hover{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .xl\\:hover\\:border-borgScaleColors-8:hover{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .xl\\:hover\\:border-borgScaleColors-9:hover{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .xl\\:hover\\:border-borgScaleColors-10:hover{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .xl\\:focus\\:border-transparent:focus{
    border-color: transparent;
  }

  .xl\\:focus\\:border-focus:focus{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .xl\\:focus\\:border-black:focus{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .xl\\:focus\\:border-white:focus{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .xl\\:focus\\:border-primary:focus{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .xl\\:focus\\:border-disabled:focus{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .xl\\:focus\\:border-translucent-60:focus{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .xl\\:focus\\:border-translucent-90:focus{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .xl\\:focus\\:border-green-200:focus{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .xl\\:focus\\:border-green-400:focus{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .xl\\:focus\\:border-green-500:focus{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .xl\\:focus\\:border-green-600:focus{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .xl\\:focus\\:border-green-700:focus{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .xl\\:focus\\:border-green-400a50:focus{
    border-color: rgba(108,202,152,0.50196);
  }

  .xl\\:focus\\:border-green-500a25:focus{
    border-color: rgba(151,232,18,0.09804);
  }

  .xl\\:focus\\:border-yellow-200:focus{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .xl\\:focus\\:border-yellow-300:focus{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .xl\\:focus\\:border-yellow-500:focus{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .xl\\:focus\\:border-yellow-600:focus{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .xl\\:focus\\:border-yellow-700:focus{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .xl\\:focus\\:border-yellow-300a66:focus{
    border-color: rgba(255,233,189,0.66667);
  }

  .xl\\:focus\\:border-yellow-500a25:focus{
    border-color: rgba(255,200,44,0.09804);
  }

  .xl\\:focus\\:border-orange-200:focus{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .xl\\:focus\\:border-orange-400:focus{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .xl\\:focus\\:border-orange-500:focus{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .xl\\:focus\\:border-orange-800:focus{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .xl\\:focus\\:border-orange-900:focus{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .xl\\:focus\\:border-orange-500a25:focus{
    border-color: rgba(240,115,23,0.09804);
  }

  .xl\\:focus\\:border-red-100:focus{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .xl\\:focus\\:border-red-150:focus{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .xl\\:focus\\:border-red-200:focus{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .xl\\:focus\\:border-red-300:focus{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .xl\\:focus\\:border-red-400:focus{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .xl\\:focus\\:border-red-500:focus{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .xl\\:focus\\:border-red-700:focus{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-50:focus{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-100:focus{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-150:focus{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-200:focus{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-300:focus{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-400:focus{
    border-color: rgba(114,114,114,0.8);
  }

  .xl\\:focus\\:border-gray-425:focus{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .xl\\:focus\\:border-gray-450:focus{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-500:focus{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-600:focus{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-625:focus{
    border-color: rgba(90,98,107,0.8);
  }

  .xl\\:focus\\:border-gray-700:focus{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-800:focus{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .xl\\:focus\\:border-gray-200a50:focus{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .xl\\:focus\\:border-blue-50:focus{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-100:focus{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-150:focus{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-200:focus{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-300:focus{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-400:focus{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-500:focus{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-600:focus{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-700:focus{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-750:focus{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-800:focus{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-900:focus{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-950:focus{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-500a25:focus{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .xl\\:focus\\:border-blue-500a50:focus{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .xl\\:focus\\:border-blue-700a75:focus{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-700a30:focus{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .xl\\:focus\\:border-blue-750a25:focus{
    border-color: rgba(86,130,170,0.09804);
  }

  .xl\\:focus\\:border-blue-750a15:focus{
    border-color: rgba(86,130,170,0.05882);
  }

  .xl\\:focus\\:border-blue-800a60:focus{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .xl\\:focus\\:border-programEditorTabColors-1:focus{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .xl\\:focus\\:border-programEditorTabColors-2:focus{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .xl\\:focus\\:border-programEditorTabColors-3:focus{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .xl\\:focus\\:border-programEditorTabColors-4:focus{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .xl\\:focus\\:border-programEditorTabColors-5:focus{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .xl\\:focus\\:border-programEditorTabColors-6:focus{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .xl\\:focus\\:border-programEditorTabColors-1h:focus{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .xl\\:focus\\:border-programEditorTabColors-2h:focus{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .xl\\:focus\\:border-programEditorTabColors-3h:focus{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .xl\\:focus\\:border-programEditorTabColors-4h:focus{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .xl\\:focus\\:border-programEditorTabColors-5h:focus{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .xl\\:focus\\:border-programEditorTabColors-6h:focus{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .xl\\:focus\\:border-programEditorPresetTabColors-1:focus{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .xl\\:focus\\:border-programEditorPresetTabColors-1h:focus{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .xl\\:focus\\:border-borgScaleColors-0:focus{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .xl\\:focus\\:border-borgScaleColors-1:focus{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .xl\\:focus\\:border-borgScaleColors-2:focus{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .xl\\:focus\\:border-borgScaleColors-3:focus{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .xl\\:focus\\:border-borgScaleColors-4:focus{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .xl\\:focus\\:border-borgScaleColors-5:focus{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .xl\\:focus\\:border-borgScaleColors-6:focus{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .xl\\:focus\\:border-borgScaleColors-7:focus{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .xl\\:focus\\:border-borgScaleColors-8:focus{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .xl\\:focus\\:border-borgScaleColors-9:focus{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .xl\\:focus\\:border-borgScaleColors-10:focus{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .xl\\:border-opacity-0{
    --border-opacity: 0;
  }

  .xl\\:border-opacity-25{
    --border-opacity: .25;
  }

  .xl\\:border-opacity-50{
    --border-opacity: .5;
  }

  .xl\\:border-opacity-75{
    --border-opacity: .75;
  }

  .xl\\:border-opacity-100{
    --border-opacity: 1;
  }

  .xl\\:hover\\:border-opacity-0:hover{
    --border-opacity: 0;
  }

  .xl\\:hover\\:border-opacity-25:hover{
    --border-opacity: .25;
  }

  .xl\\:hover\\:border-opacity-50:hover{
    --border-opacity: .5;
  }

  .xl\\:hover\\:border-opacity-75:hover{
    --border-opacity: .75;
  }

  .xl\\:hover\\:border-opacity-100:hover{
    --border-opacity: 1;
  }

  .xl\\:focus\\:border-opacity-0:focus{
    --border-opacity: 0;
  }

  .xl\\:focus\\:border-opacity-25:focus{
    --border-opacity: .25;
  }

  .xl\\:focus\\:border-opacity-50:focus{
    --border-opacity: .5;
  }

  .xl\\:focus\\:border-opacity-75:focus{
    --border-opacity: .75;
  }

  .xl\\:focus\\:border-opacity-100:focus{
    --border-opacity: 1;
  }

  .xl\\:rounded-none{
    border-radius: 0;
  }

  .xl\\:rounded-sm{
    border-radius: .25rem;
  }

  .xl\\:rounded{
    border-radius: .375rem;
  }

  .xl\\:rounded-lg{
    border-radius: .5rem;
  }

  .xl\\:rounded-xl{
    border-radius: .75rem;
  }

  .xl\\:rounded-full{
    border-radius: 9999px;
  }

  .xl\\:rounded-t-none{
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .xl\\:rounded-r-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .xl\\:rounded-b-none{
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .xl\\:rounded-l-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .xl\\:rounded-t-sm{
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
  }

  .xl\\:rounded-r-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  .xl\\:rounded-b-sm{
    border-bottom-right-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  .xl\\:rounded-l-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  .xl\\:rounded-t{
    border-top-left-radius: .375rem;
    border-top-right-radius: .375rem;
  }

  .xl\\:rounded-r{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  .xl\\:rounded-b{
    border-bottom-right-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  .xl\\:rounded-l{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  .xl\\:rounded-t-lg{
    border-top-left-radius: .5rem;
    border-top-right-radius: .5rem;
  }

  .xl\\:rounded-r-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  .xl\\:rounded-b-lg{
    border-bottom-right-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  .xl\\:rounded-l-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  .xl\\:rounded-t-xl{
    border-top-left-radius: .75rem;
    border-top-right-radius: .75rem;
  }

  .xl\\:rounded-r-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  .xl\\:rounded-b-xl{
    border-bottom-right-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  .xl\\:rounded-l-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  .xl\\:rounded-t-full{
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }

  .xl\\:rounded-r-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  .xl\\:rounded-b-full{
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .xl\\:rounded-l-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .xl\\:rounded-tl-none{
    border-top-left-radius: 0;
  }

  .xl\\:rounded-tr-none{
    border-top-right-radius: 0;
  }

  .xl\\:rounded-br-none{
    border-bottom-right-radius: 0;
  }

  .xl\\:rounded-bl-none{
    border-bottom-left-radius: 0;
  }

  .xl\\:rounded-tl-sm{
    border-top-left-radius: .25rem;
  }

  .xl\\:rounded-tr-sm{
    border-top-right-radius: .25rem;
  }

  .xl\\:rounded-br-sm{
    border-bottom-right-radius: .25rem;
  }

  .xl\\:rounded-bl-sm{
    border-bottom-left-radius: .25rem;
  }

  .xl\\:rounded-tl{
    border-top-left-radius: .375rem;
  }

  .xl\\:rounded-tr{
    border-top-right-radius: .375rem;
  }

  .xl\\:rounded-br{
    border-bottom-right-radius: .375rem;
  }

  .xl\\:rounded-bl{
    border-bottom-left-radius: .375rem;
  }

  .xl\\:rounded-tl-lg{
    border-top-left-radius: .5rem;
  }

  .xl\\:rounded-tr-lg{
    border-top-right-radius: .5rem;
  }

  .xl\\:rounded-br-lg{
    border-bottom-right-radius: .5rem;
  }

  .xl\\:rounded-bl-lg{
    border-bottom-left-radius: .5rem;
  }

  .xl\\:rounded-tl-xl{
    border-top-left-radius: .75rem;
  }

  .xl\\:rounded-tr-xl{
    border-top-right-radius: .75rem;
  }

  .xl\\:rounded-br-xl{
    border-bottom-right-radius: .75rem;
  }

  .xl\\:rounded-bl-xl{
    border-bottom-left-radius: .75rem;
  }

  .xl\\:rounded-tl-full{
    border-top-left-radius: 9999px;
  }

  .xl\\:rounded-tr-full{
    border-top-right-radius: 9999px;
  }

  .xl\\:rounded-br-full{
    border-bottom-right-radius: 9999px;
  }

  .xl\\:rounded-bl-full{
    border-bottom-left-radius: 9999px;
  }

  .xl\\:border-solid{
    border-style: solid;
  }

  .xl\\:border-dashed{
    border-style: dashed;
  }

  .xl\\:border-dotted{
    border-style: dotted;
  }

  .xl\\:border-double{
    border-style: double;
  }

  .xl\\:border-none{
    border-style: none;
  }

  .xl\\:border-0{
    border-width: 0;
  }

  .xl\\:border-2{
    border-width: 2px;
  }

  .xl\\:border-3{
    border-width: 3px;
  }

  .xl\\:border-4{
    border-width: 4px;
  }

  .xl\\:border-5{
    border-width: 5px;
  }

  .xl\\:border-6{
    border-width: 6px;
  }

  .xl\\:border-8{
    border-width: 8px;
  }

  .xl\\:border{
    border-width: 1px;
  }

  .xl\\:border-t-0{
    border-top-width: 0;
  }

  .xl\\:border-r-0{
    border-right-width: 0;
  }

  .xl\\:border-b-0{
    border-bottom-width: 0;
  }

  .xl\\:border-l-0{
    border-left-width: 0;
  }

  .xl\\:border-t-2{
    border-top-width: 2px;
  }

  .xl\\:border-r-2{
    border-right-width: 2px;
  }

  .xl\\:border-b-2{
    border-bottom-width: 2px;
  }

  .xl\\:border-l-2{
    border-left-width: 2px;
  }

  .xl\\:border-t-3{
    border-top-width: 3px;
  }

  .xl\\:border-r-3{
    border-right-width: 3px;
  }

  .xl\\:border-b-3{
    border-bottom-width: 3px;
  }

  .xl\\:border-l-3{
    border-left-width: 3px;
  }

  .xl\\:border-t-4{
    border-top-width: 4px;
  }

  .xl\\:border-r-4{
    border-right-width: 4px;
  }

  .xl\\:border-b-4{
    border-bottom-width: 4px;
  }

  .xl\\:border-l-4{
    border-left-width: 4px;
  }

  .xl\\:border-t-5{
    border-top-width: 5px;
  }

  .xl\\:border-r-5{
    border-right-width: 5px;
  }

  .xl\\:border-b-5{
    border-bottom-width: 5px;
  }

  .xl\\:border-l-5{
    border-left-width: 5px;
  }

  .xl\\:border-t-6{
    border-top-width: 6px;
  }

  .xl\\:border-r-6{
    border-right-width: 6px;
  }

  .xl\\:border-b-6{
    border-bottom-width: 6px;
  }

  .xl\\:border-l-6{
    border-left-width: 6px;
  }

  .xl\\:border-t-8{
    border-top-width: 8px;
  }

  .xl\\:border-r-8{
    border-right-width: 8px;
  }

  .xl\\:border-b-8{
    border-bottom-width: 8px;
  }

  .xl\\:border-l-8{
    border-left-width: 8px;
  }

  .xl\\:border-t{
    border-top-width: 1px;
  }

  .xl\\:border-r{
    border-right-width: 1px;
  }

  .xl\\:border-b{
    border-bottom-width: 1px;
  }

  .xl\\:border-l{
    border-left-width: 1px;
  }

  .xl\\:first\\:border-0:first-child{
    border-width: 0;
  }

  .xl\\:first\\:border-2:first-child{
    border-width: 2px;
  }

  .xl\\:first\\:border-3:first-child{
    border-width: 3px;
  }

  .xl\\:first\\:border-4:first-child{
    border-width: 4px;
  }

  .xl\\:first\\:border-5:first-child{
    border-width: 5px;
  }

  .xl\\:first\\:border-6:first-child{
    border-width: 6px;
  }

  .xl\\:first\\:border-8:first-child{
    border-width: 8px;
  }

  .xl\\:first\\:border:first-child{
    border-width: 1px;
  }

  .xl\\:first\\:border-t-0:first-child{
    border-top-width: 0;
  }

  .xl\\:first\\:border-r-0:first-child{
    border-right-width: 0;
  }

  .xl\\:first\\:border-b-0:first-child{
    border-bottom-width: 0;
  }

  .xl\\:first\\:border-l-0:first-child{
    border-left-width: 0;
  }

  .xl\\:first\\:border-t-2:first-child{
    border-top-width: 2px;
  }

  .xl\\:first\\:border-r-2:first-child{
    border-right-width: 2px;
  }

  .xl\\:first\\:border-b-2:first-child{
    border-bottom-width: 2px;
  }

  .xl\\:first\\:border-l-2:first-child{
    border-left-width: 2px;
  }

  .xl\\:first\\:border-t-3:first-child{
    border-top-width: 3px;
  }

  .xl\\:first\\:border-r-3:first-child{
    border-right-width: 3px;
  }

  .xl\\:first\\:border-b-3:first-child{
    border-bottom-width: 3px;
  }

  .xl\\:first\\:border-l-3:first-child{
    border-left-width: 3px;
  }

  .xl\\:first\\:border-t-4:first-child{
    border-top-width: 4px;
  }

  .xl\\:first\\:border-r-4:first-child{
    border-right-width: 4px;
  }

  .xl\\:first\\:border-b-4:first-child{
    border-bottom-width: 4px;
  }

  .xl\\:first\\:border-l-4:first-child{
    border-left-width: 4px;
  }

  .xl\\:first\\:border-t-5:first-child{
    border-top-width: 5px;
  }

  .xl\\:first\\:border-r-5:first-child{
    border-right-width: 5px;
  }

  .xl\\:first\\:border-b-5:first-child{
    border-bottom-width: 5px;
  }

  .xl\\:first\\:border-l-5:first-child{
    border-left-width: 5px;
  }

  .xl\\:first\\:border-t-6:first-child{
    border-top-width: 6px;
  }

  .xl\\:first\\:border-r-6:first-child{
    border-right-width: 6px;
  }

  .xl\\:first\\:border-b-6:first-child{
    border-bottom-width: 6px;
  }

  .xl\\:first\\:border-l-6:first-child{
    border-left-width: 6px;
  }

  .xl\\:first\\:border-t-8:first-child{
    border-top-width: 8px;
  }

  .xl\\:first\\:border-r-8:first-child{
    border-right-width: 8px;
  }

  .xl\\:first\\:border-b-8:first-child{
    border-bottom-width: 8px;
  }

  .xl\\:first\\:border-l-8:first-child{
    border-left-width: 8px;
  }

  .xl\\:first\\:border-t:first-child{
    border-top-width: 1px;
  }

  .xl\\:first\\:border-r:first-child{
    border-right-width: 1px;
  }

  .xl\\:first\\:border-b:first-child{
    border-bottom-width: 1px;
  }

  .xl\\:first\\:border-l:first-child{
    border-left-width: 1px;
  }

  .xl\\:box-border{
    box-sizing: border-box;
  }

  .xl\\:box-content{
    box-sizing: content-box;
  }

  .xl\\:cursor-auto{
    cursor: auto;
  }

  .xl\\:cursor-default{
    cursor: default;
  }

  .xl\\:cursor-pointer{
    cursor: pointer;
  }

  .xl\\:cursor-wait{
    cursor: wait;
  }

  .xl\\:cursor-move{
    cursor: move;
  }

  .xl\\:cursor-not-allowed{
    cursor: not-allowed;
  }

  .xl\\:block{
    display: block;
  }

  .xl\\:inline-block{
    display: inline-block;
  }

  .xl\\:inline{
    display: inline;
  }

  .xl\\:flex{
    display: flex;
  }

  .xl\\:inline-flex{
    display: inline-flex;
  }

  .xl\\:table{
    display: table;
  }

  .xl\\:table-caption{
    display: table-caption;
  }

  .xl\\:table-cell{
    display: table-cell;
  }

  .xl\\:table-column{
    display: table-column;
  }

  .xl\\:table-column-group{
    display: table-column-group;
  }

  .xl\\:table-footer-group{
    display: table-footer-group;
  }

  .xl\\:table-header-group{
    display: table-header-group;
  }

  .xl\\:table-row-group{
    display: table-row-group;
  }

  .xl\\:table-row{
    display: table-row;
  }

  .xl\\:flow-root{
    display: flow-root;
  }

  .xl\\:grid{
    display: grid;
  }

  .xl\\:inline-grid{
    display: inline-grid;
  }

  .xl\\:contents{
    display: contents;
  }

  .xl\\:hidden{
    display: none;
  }

  .xl\\:flex-row{
    flex-direction: row;
  }

  .xl\\:flex-row-reverse{
    flex-direction: row-reverse;
  }

  .xl\\:flex-col{
    flex-direction: column;
  }

  .xl\\:flex-col-reverse{
    flex-direction: column-reverse;
  }

  .xl\\:flex-wrap{
    flex-wrap: wrap;
  }

  .xl\\:flex-wrap-reverse{
    flex-wrap: wrap-reverse;
  }

  .xl\\:flex-no-wrap{
    flex-wrap: nowrap;
  }

  .xl\\:place-items-auto{
    align-items: auto;
    justify-items: auto;
    place-items: auto;
  }

  .xl\\:place-items-start{
    align-items: start;
    justify-items: start;
    place-items: start;
  }

  .xl\\:place-items-end{
    align-items: end;
    justify-items: end;
    place-items: end;
  }

  .xl\\:place-items-center{
    align-items: center;
    justify-items: center;
    place-items: center;
  }

  .xl\\:place-items-stretch{
    align-items: stretch;
    justify-items: stretch;
    place-items: stretch;
  }

  .xl\\:place-content-center{
    align-content: center;
    justify-content: center;
    place-content: center;
  }

  .xl\\:place-content-start{
    align-content: start;
    justify-content: start;
    place-content: start;
  }

  .xl\\:place-content-end{
    align-content: end;
    justify-content: end;
    place-content: end;
  }

  .xl\\:place-content-between{
    align-content: space-between;
    justify-content: space-between;
    place-content: space-between;
  }

  .xl\\:place-content-around{
    align-content: space-around;
    justify-content: space-around;
    place-content: space-around;
  }

  .xl\\:place-content-evenly{
    align-content: space-evenly;
    justify-content: space-evenly;
    place-content: space-evenly;
  }

  .xl\\:place-content-stretch{
    align-content: stretch;
    justify-content: stretch;
    place-content: stretch;
  }

  .xl\\:place-self-auto{
    align-self: auto;
    justify-self: auto;
    place-self: auto;
  }

  .xl\\:place-self-start{
    align-self: start;
    justify-self: start;
    place-self: start;
  }

  .xl\\:place-self-end{
    align-self: end;
    justify-self: end;
    place-self: end;
  }

  .xl\\:place-self-center{
    align-self: center;
    justify-self: center;
    place-self: center;
  }

  .xl\\:place-self-stretch{
    align-self: stretch;
    justify-self: stretch;
    place-self: stretch;
  }

  .xl\\:items-start{
    align-items: flex-start;
  }

  .xl\\:items-end{
    align-items: flex-end;
  }

  .xl\\:items-center{
    align-items: center;
  }

  .xl\\:items-baseline{
    align-items: baseline;
  }

  .xl\\:items-stretch{
    align-items: stretch;
  }

  .xl\\:content-center{
    align-content: center;
  }

  .xl\\:content-start{
    align-content: flex-start;
  }

  .xl\\:content-end{
    align-content: flex-end;
  }

  .xl\\:content-between{
    align-content: space-between;
  }

  .xl\\:content-around{
    align-content: space-around;
  }

  .xl\\:content-evenly{
    align-content: space-evenly;
  }

  .xl\\:self-auto{
    align-self: auto;
  }

  .xl\\:self-start{
    align-self: flex-start;
  }

  .xl\\:self-end{
    align-self: flex-end;
  }

  .xl\\:self-center{
    align-self: center;
  }

  .xl\\:self-stretch{
    align-self: stretch;
  }

  .xl\\:justify-items-auto{
    justify-items: auto;
  }

  .xl\\:justify-items-start{
    justify-items: start;
  }

  .xl\\:justify-items-end{
    justify-items: end;
  }

  .xl\\:justify-items-center{
    justify-items: center;
  }

  .xl\\:justify-items-stretch{
    justify-items: stretch;
  }

  .xl\\:justify-start{
    justify-content: flex-start;
  }

  .xl\\:justify-end{
    justify-content: flex-end;
  }

  .xl\\:justify-center{
    justify-content: center;
  }

  .xl\\:justify-between{
    justify-content: space-between;
  }

  .xl\\:justify-around{
    justify-content: space-around;
  }

  .xl\\:justify-evenly{
    justify-content: space-evenly;
  }

  .xl\\:justify-self-auto{
    justify-self: auto;
  }

  .xl\\:justify-self-start{
    justify-self: start;
  }

  .xl\\:justify-self-end{
    justify-self: end;
  }

  .xl\\:justify-self-center{
    justify-self: center;
  }

  .xl\\:justify-self-stretch{
    justify-self: stretch;
  }

  .xl\\:flex-1{
    flex: 1 1 0%;
  }

  .xl\\:flex-auto{
    flex: 1 1 auto;
  }

  .xl\\:flex-initial{
    flex: 0 1 auto;
  }

  .xl\\:flex-none{
    flex: none;
  }

  .xl\\:flex-grow-0{
    flex-grow: 0;
  }

  .xl\\:flex-grow{
    flex-grow: 1;
  }

  .xl\\:flex-shrink-0{
    flex-shrink: 0;
  }

  .xl\\:flex-shrink{
    flex-shrink: 1;
  }

  .xl\\:order-1{
    order: 1;
  }

  .xl\\:order-2{
    order: 2;
  }

  .xl\\:order-3{
    order: 3;
  }

  .xl\\:order-4{
    order: 4;
  }

  .xl\\:order-5{
    order: 5;
  }

  .xl\\:order-6{
    order: 6;
  }

  .xl\\:order-7{
    order: 7;
  }

  .xl\\:order-8{
    order: 8;
  }

  .xl\\:order-9{
    order: 9;
  }

  .xl\\:order-10{
    order: 10;
  }

  .xl\\:order-11{
    order: 11;
  }

  .xl\\:order-12{
    order: 12;
  }

  .xl\\:order-first{
    order: -9999;
  }

  .xl\\:order-last{
    order: 9999;
  }

  .xl\\:order-none{
    order: 0;
  }

  .xl\\:float-right{
    float: right;
  }

  .xl\\:float-left{
    float: left;
  }

  .xl\\:float-none{
    float: none;
  }

  .xl\\:clearfix:after{
    content: "";
    display: table;
    clear: both;
  }

  .xl\\:clear-left{
    clear: left;
  }

  .xl\\:clear-right{
    clear: right;
  }

  .xl\\:clear-both{
    clear: both;
  }

  .xl\\:clear-none{
    clear: none;
  }

  .xl\\:font-sans{
    font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }

  .xl\\:font-serif{
    font-family: Georgia, Cambria, "Times New Roman", Times, serif;
  }

  .xl\\:font-mono{
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }

  .xl\\:font-light{
    font-weight: 100;
  }

  .xl\\:font-regular{
    font-weight: 400;
  }

  .xl\\:font-semibold{
    font-weight: 600;
  }

  .xl\\:font-bold{
    font-weight: 700;
  }

  .xl\\:hover\\:font-light:hover{
    font-weight: 100;
  }

  .xl\\:hover\\:font-regular:hover{
    font-weight: 400;
  }

  .xl\\:hover\\:font-semibold:hover{
    font-weight: 600;
  }

  .xl\\:hover\\:font-bold:hover{
    font-weight: 700;
  }

  .xl\\:focus\\:font-light:focus{
    font-weight: 100;
  }

  .xl\\:focus\\:font-regular:focus{
    font-weight: 400;
  }

  .xl\\:focus\\:font-semibold:focus{
    font-weight: 600;
  }

  .xl\\:focus\\:font-bold:focus{
    font-weight: 700;
  }

  .xl\\:h-0{
    height: 0;
  }

  .xl\\:h-1{
    height: 0.25rem;
  }

  .xl\\:h-2{
    height: 0.5rem;
  }

  .xl\\:h-3{
    height: 0.75rem;
  }

  .xl\\:h-4{
    height: 1rem;
  }

  .xl\\:h-5{
    height: 1.25rem;
  }

  .xl\\:h-6{
    height: 1.5rem;
  }

  .xl\\:h-7{
    height: 1.75rem;
  }

  .xl\\:h-8{
    height: 2rem;
  }

  .xl\\:h-9{
    height: 2.25rem;
  }

  .xl\\:h-10{
    height: 2.5rem;
  }

  .xl\\:h-11{
    height: 2.75rem;
  }

  .xl\\:h-12{
    height: 3rem;
  }

  .xl\\:h-14{
    height: 3.5rem;
  }

  .xl\\:h-15{
    height: 3.75rem;
  }

  .xl\\:h-16{
    height: 4rem;
  }

  .xl\\:h-18{
    height: 4.5rem;
  }

  .xl\\:h-20{
    height: 5rem;
  }

  .xl\\:h-22{
    height: 5.5rem;
  }

  .xl\\:h-23{
    height: 5.75rem;
  }

  .xl\\:h-24{
    height: 6rem;
  }

  .xl\\:h-25{
    height: 6.25rem;
  }

  .xl\\:h-26{
    height: 6.5rem;
  }

  .xl\\:h-28{
    height: 7rem;
  }

  .xl\\:h-30{
    height: 7.5rem;
  }

  .xl\\:h-32{
    height: 8rem;
  }

  .xl\\:h-34{
    height: 8.5rem;
  }

  .xl\\:h-40{
    height: 10rem;
  }

  .xl\\:h-42{
    height: 10.5rem;
  }

  .xl\\:h-44{
    height: 11rem;
  }

  .xl\\:h-48{
    height: 12rem;
  }

  .xl\\:h-52{
    height: 13rem;
  }

  .xl\\:h-54{
    height: 13.5rem;
  }

  .xl\\:h-56{
    height: 14rem;
  }

  .xl\\:h-60{
    height: 15rem;
  }

  .xl\\:h-64{
    height: 16rem;
  }

  .xl\\:h-68{
    height: 17rem;
  }

  .xl\\:h-72{
    height: 18rem;
  }

  .xl\\:h-74{
    height: 18.5rem;
  }

  .xl\\:h-76{
    height: 19rem;
  }

  .xl\\:h-78{
    height: 19.5rem;
  }

  .xl\\:h-80{
    height: 20rem;
  }

  .xl\\:h-82{
    height: 20.5rem;
  }

  .xl\\:h-84{
    height: 21rem;
  }

  .xl\\:h-88{
    height: 22rem;
  }

  .xl\\:h-92{
    height: 23rem;
  }

  .xl\\:h-96{
    height: 24rem;
  }

  .xl\\:h-98{
    height: 24.5rem;
  }

  .xl\\:h-100{
    height: 25rem;
  }

  .xl\\:h-104{
    height: 26rem;
  }

  .xl\\:h-112{
    height: 28rem;
  }

  .xl\\:h-124{
    height: 31rem;
  }

  .xl\\:h-128{
    height: 32rem;
  }

  .xl\\:h-140{
    height: 35rem;
  }

  .xl\\:h-152{
    height: 38rem;
  }

  .xl\\:h-160{
    height: 40rem;
  }

  .xl\\:h-162{
    height: 41rem;
  }

  .xl\\:h-192{
    height: 48rem;
  }

  .xl\\:h-208{
    height: 52rem;
  }

  .xl\\:h-224{
    height: 56rem;
  }

  .xl\\:h-256{
    height: 64rem;
  }

  .xl\\:h-auto{
    height: auto;
  }

  .xl\\:h-px{
    height: 1px;
  }

  .xl\\:h-full{
    height: 100%;
  }

  .xl\\:h-screen{
    height: 100vh;
  }

  .xl\\:text-xs{
    font-size: 0.74rem;
  }

  .xl\\:text-sm{
    font-size: 0.86rem;
  }

  .xl\\:text-base{
    font-size: 1rem;
  }

  .xl\\:text-lg{
    font-size: 1.15rem;
  }

  .xl\\:text-xl{
    font-size: 1.42rem;
  }

  .xl\\:text-2xl{
    font-size: 1.85rem;
  }

  .xl\\:text-3xl{
    font-size: 1.95rem;
  }

  .xl\\:text-4xl{
    font-size: 2.25rem;
  }

  .xl\\:text-5xl{
    font-size: 3rem;
  }

  .xl\\:text-6xl{
    font-size: 4rem;
  }

  .xl\\:text-7xl{
    font-size: 5rem;
  }

  .xl\\:leading-none{
    line-height: 1;
  }

  .xl\\:leading-tight{
    line-height: 1.2;
  }

  .xl\\:leading-snug{
    line-height: 1.3;
  }

  .xl\\:leading-normal{
    line-height: 1.4;
  }

  .xl\\:leading-relaxed{
    line-height: 1.6;
  }

  .xl\\:list-inside{
    list-style-position: inside;
  }

  .xl\\:list-outside{
    list-style-position: outside;
  }

  .xl\\:list-none{
    list-style-type: none;
  }

  .xl\\:list-disc{
    list-style-type: disc;
  }

  .xl\\:list-decimal{
    list-style-type: decimal;
  }

  .xl\\:m-0{
    margin: 0;
  }

  .xl\\:m-1{
    margin: 0.25rem;
  }

  .xl\\:m-2{
    margin: 0.5rem;
  }

  .xl\\:m-3{
    margin: 0.75rem;
  }

  .xl\\:m-4{
    margin: 1rem;
  }

  .xl\\:m-5{
    margin: 1.25rem;
  }

  .xl\\:m-6{
    margin: 1.5rem;
  }

  .xl\\:m-7{
    margin: 1.75rem;
  }

  .xl\\:m-8{
    margin: 2rem;
  }

  .xl\\:m-9{
    margin: 2.25rem;
  }

  .xl\\:m-10{
    margin: 2.5rem;
  }

  .xl\\:m-11{
    margin: 2.75rem;
  }

  .xl\\:m-12{
    margin: 3rem;
  }

  .xl\\:m-14{
    margin: 3.5rem;
  }

  .xl\\:m-15{
    margin: 3.75rem;
  }

  .xl\\:m-16{
    margin: 4rem;
  }

  .xl\\:m-18{
    margin: 4.5rem;
  }

  .xl\\:m-20{
    margin: 5rem;
  }

  .xl\\:m-22{
    margin: 5.5rem;
  }

  .xl\\:m-23{
    margin: 5.75rem;
  }

  .xl\\:m-24{
    margin: 6rem;
  }

  .xl\\:m-25{
    margin: 6.25rem;
  }

  .xl\\:m-26{
    margin: 6.5rem;
  }

  .xl\\:m-28{
    margin: 7rem;
  }

  .xl\\:m-30{
    margin: 7.5rem;
  }

  .xl\\:m-32{
    margin: 8rem;
  }

  .xl\\:m-34{
    margin: 8.5rem;
  }

  .xl\\:m-40{
    margin: 10rem;
  }

  .xl\\:m-42{
    margin: 10.5rem;
  }

  .xl\\:m-44{
    margin: 11rem;
  }

  .xl\\:m-48{
    margin: 12rem;
  }

  .xl\\:m-52{
    margin: 13rem;
  }

  .xl\\:m-54{
    margin: 13.5rem;
  }

  .xl\\:m-56{
    margin: 14rem;
  }

  .xl\\:m-60{
    margin: 15rem;
  }

  .xl\\:m-64{
    margin: 16rem;
  }

  .xl\\:m-68{
    margin: 17rem;
  }

  .xl\\:m-72{
    margin: 18rem;
  }

  .xl\\:m-74{
    margin: 18.5rem;
  }

  .xl\\:m-76{
    margin: 19rem;
  }

  .xl\\:m-78{
    margin: 19.5rem;
  }

  .xl\\:m-80{
    margin: 20rem;
  }

  .xl\\:m-82{
    margin: 20.5rem;
  }

  .xl\\:m-84{
    margin: 21rem;
  }

  .xl\\:m-88{
    margin: 22rem;
  }

  .xl\\:m-92{
    margin: 23rem;
  }

  .xl\\:m-96{
    margin: 24rem;
  }

  .xl\\:m-98{
    margin: 24.5rem;
  }

  .xl\\:m-100{
    margin: 25rem;
  }

  .xl\\:m-104{
    margin: 26rem;
  }

  .xl\\:m-112{
    margin: 28rem;
  }

  .xl\\:m-124{
    margin: 31rem;
  }

  .xl\\:m-128{
    margin: 32rem;
  }

  .xl\\:m-140{
    margin: 35rem;
  }

  .xl\\:m-152{
    margin: 38rem;
  }

  .xl\\:m-160{
    margin: 40rem;
  }

  .xl\\:m-162{
    margin: 41rem;
  }

  .xl\\:m-192{
    margin: 48rem;
  }

  .xl\\:m-208{
    margin: 52rem;
  }

  .xl\\:m-224{
    margin: 56rem;
  }

  .xl\\:m-256{
    margin: 64rem;
  }

  .xl\\:m-auto{
    margin: auto;
  }

  .xl\\:m-px{
    margin: 1px;
  }

  .xl\\:-m-1{
    margin: -0.25rem;
  }

  .xl\\:-m-2{
    margin: -0.5rem;
  }

  .xl\\:-m-3{
    margin: -0.75rem;
  }

  .xl\\:-m-4{
    margin: -1rem;
  }

  .xl\\:-m-5{
    margin: -1.25rem;
  }

  .xl\\:-m-6{
    margin: -1.5rem;
  }

  .xl\\:-m-7{
    margin: -1.75rem;
  }

  .xl\\:-m-8{
    margin: -2rem;
  }

  .xl\\:-m-9{
    margin: -2.25rem;
  }

  .xl\\:-m-10{
    margin: -2.5rem;
  }

  .xl\\:-m-11{
    margin: -2.75rem;
  }

  .xl\\:-m-12{
    margin: -3rem;
  }

  .xl\\:-m-14{
    margin: -3.5rem;
  }

  .xl\\:-m-15{
    margin: -3.75rem;
  }

  .xl\\:-m-16{
    margin: -4rem;
  }

  .xl\\:-m-18{
    margin: -4.5rem;
  }

  .xl\\:-m-20{
    margin: -5rem;
  }

  .xl\\:-m-22{
    margin: -5.5rem;
  }

  .xl\\:-m-23{
    margin: -5.75rem;
  }

  .xl\\:-m-24{
    margin: -6rem;
  }

  .xl\\:-m-25{
    margin: -6.25rem;
  }

  .xl\\:-m-26{
    margin: -6.5rem;
  }

  .xl\\:-m-28{
    margin: -7rem;
  }

  .xl\\:-m-30{
    margin: -7.5rem;
  }

  .xl\\:-m-32{
    margin: -8rem;
  }

  .xl\\:-m-34{
    margin: -8.5rem;
  }

  .xl\\:-m-40{
    margin: -10rem;
  }

  .xl\\:-m-42{
    margin: -10.5rem;
  }

  .xl\\:-m-44{
    margin: -11rem;
  }

  .xl\\:-m-48{
    margin: -12rem;
  }

  .xl\\:-m-52{
    margin: -13rem;
  }

  .xl\\:-m-54{
    margin: -13.5rem;
  }

  .xl\\:-m-56{
    margin: -14rem;
  }

  .xl\\:-m-60{
    margin: -15rem;
  }

  .xl\\:-m-64{
    margin: -16rem;
  }

  .xl\\:-m-68{
    margin: -17rem;
  }

  .xl\\:-m-72{
    margin: -18rem;
  }

  .xl\\:-m-74{
    margin: -18.5rem;
  }

  .xl\\:-m-76{
    margin: -19rem;
  }

  .xl\\:-m-78{
    margin: -19.5rem;
  }

  .xl\\:-m-80{
    margin: -20rem;
  }

  .xl\\:-m-82{
    margin: -20.5rem;
  }

  .xl\\:-m-84{
    margin: -21rem;
  }

  .xl\\:-m-88{
    margin: -22rem;
  }

  .xl\\:-m-92{
    margin: -23rem;
  }

  .xl\\:-m-96{
    margin: -24rem;
  }

  .xl\\:-m-98{
    margin: -24.5rem;
  }

  .xl\\:-m-100{
    margin: -25rem;
  }

  .xl\\:-m-104{
    margin: -26rem;
  }

  .xl\\:-m-112{
    margin: -28rem;
  }

  .xl\\:-m-124{
    margin: -31rem;
  }

  .xl\\:-m-128{
    margin: -32rem;
  }

  .xl\\:-m-140{
    margin: -35rem;
  }

  .xl\\:-m-152{
    margin: -38rem;
  }

  .xl\\:-m-160{
    margin: -40rem;
  }

  .xl\\:-m-162{
    margin: -41rem;
  }

  .xl\\:-m-192{
    margin: -48rem;
  }

  .xl\\:-m-208{
    margin: -52rem;
  }

  .xl\\:-m-224{
    margin: -56rem;
  }

  .xl\\:-m-256{
    margin: -64rem;
  }

  .xl\\:-m-px{
    margin: -1px;
  }

  .xl\\:my-0{
    margin-top: 0;
    margin-bottom: 0;
  }

  .xl\\:mx-0{
    margin-left: 0;
    margin-right: 0;
  }

  .xl\\:my-1{
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .xl\\:mx-1{
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .xl\\:my-2{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .xl\\:mx-2{
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .xl\\:my-3{
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .xl\\:mx-3{
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .xl\\:my-4{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .xl\\:mx-4{
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .xl\\:my-5{
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .xl\\:mx-5{
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .xl\\:my-6{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .xl\\:mx-6{
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .xl\\:my-7{
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }

  .xl\\:mx-7{
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }

  .xl\\:my-8{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .xl\\:mx-8{
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .xl\\:my-9{
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }

  .xl\\:mx-9{
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }

  .xl\\:my-10{
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .xl\\:mx-10{
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .xl\\:my-11{
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;
  }

  .xl\\:mx-11{
    margin-left: 2.75rem;
    margin-right: 2.75rem;
  }

  .xl\\:my-12{
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .xl\\:mx-12{
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .xl\\:my-14{
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
  }

  .xl\\:mx-14{
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }

  .xl\\:my-15{
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
  }

  .xl\\:mx-15{
    margin-left: 3.75rem;
    margin-right: 3.75rem;
  }

  .xl\\:my-16{
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .xl\\:mx-16{
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .xl\\:my-18{
    margin-top: 4.5rem;
    margin-bottom: 4.5rem;
  }

  .xl\\:mx-18{
    margin-left: 4.5rem;
    margin-right: 4.5rem;
  }

  .xl\\:my-20{
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .xl\\:mx-20{
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .xl\\:my-22{
    margin-top: 5.5rem;
    margin-bottom: 5.5rem;
  }

  .xl\\:mx-22{
    margin-left: 5.5rem;
    margin-right: 5.5rem;
  }

  .xl\\:my-23{
    margin-top: 5.75rem;
    margin-bottom: 5.75rem;
  }

  .xl\\:mx-23{
    margin-left: 5.75rem;
    margin-right: 5.75rem;
  }

  .xl\\:my-24{
    margin-top: 6rem;
    margin-bottom: 6rem;
  }

  .xl\\:mx-24{
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .xl\\:my-25{
    margin-top: 6.25rem;
    margin-bottom: 6.25rem;
  }

  .xl\\:mx-25{
    margin-left: 6.25rem;
    margin-right: 6.25rem;
  }

  .xl\\:my-26{
    margin-top: 6.5rem;
    margin-bottom: 6.5rem;
  }

  .xl\\:mx-26{
    margin-left: 6.5rem;
    margin-right: 6.5rem;
  }

  .xl\\:my-28{
    margin-top: 7rem;
    margin-bottom: 7rem;
  }

  .xl\\:mx-28{
    margin-left: 7rem;
    margin-right: 7rem;
  }

  .xl\\:my-30{
    margin-top: 7.5rem;
    margin-bottom: 7.5rem;
  }

  .xl\\:mx-30{
    margin-left: 7.5rem;
    margin-right: 7.5rem;
  }

  .xl\\:my-32{
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  .xl\\:mx-32{
    margin-left: 8rem;
    margin-right: 8rem;
  }

  .xl\\:my-34{
    margin-top: 8.5rem;
    margin-bottom: 8.5rem;
  }

  .xl\\:mx-34{
    margin-left: 8.5rem;
    margin-right: 8.5rem;
  }

  .xl\\:my-40{
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .xl\\:mx-40{
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .xl\\:my-42{
    margin-top: 10.5rem;
    margin-bottom: 10.5rem;
  }

  .xl\\:mx-42{
    margin-left: 10.5rem;
    margin-right: 10.5rem;
  }

  .xl\\:my-44{
    margin-top: 11rem;
    margin-bottom: 11rem;
  }

  .xl\\:mx-44{
    margin-left: 11rem;
    margin-right: 11rem;
  }

  .xl\\:my-48{
    margin-top: 12rem;
    margin-bottom: 12rem;
  }

  .xl\\:mx-48{
    margin-left: 12rem;
    margin-right: 12rem;
  }

  .xl\\:my-52{
    margin-top: 13rem;
    margin-bottom: 13rem;
  }

  .xl\\:mx-52{
    margin-left: 13rem;
    margin-right: 13rem;
  }

  .xl\\:my-54{
    margin-top: 13.5rem;
    margin-bottom: 13.5rem;
  }

  .xl\\:mx-54{
    margin-left: 13.5rem;
    margin-right: 13.5rem;
  }

  .xl\\:my-56{
    margin-top: 14rem;
    margin-bottom: 14rem;
  }

  .xl\\:mx-56{
    margin-left: 14rem;
    margin-right: 14rem;
  }

  .xl\\:my-60{
    margin-top: 15rem;
    margin-bottom: 15rem;
  }

  .xl\\:mx-60{
    margin-left: 15rem;
    margin-right: 15rem;
  }

  .xl\\:my-64{
    margin-top: 16rem;
    margin-bottom: 16rem;
  }

  .xl\\:mx-64{
    margin-left: 16rem;
    margin-right: 16rem;
  }

  .xl\\:my-68{
    margin-top: 17rem;
    margin-bottom: 17rem;
  }

  .xl\\:mx-68{
    margin-left: 17rem;
    margin-right: 17rem;
  }

  .xl\\:my-72{
    margin-top: 18rem;
    margin-bottom: 18rem;
  }

  .xl\\:mx-72{
    margin-left: 18rem;
    margin-right: 18rem;
  }

  .xl\\:my-74{
    margin-top: 18.5rem;
    margin-bottom: 18.5rem;
  }

  .xl\\:mx-74{
    margin-left: 18.5rem;
    margin-right: 18.5rem;
  }

  .xl\\:my-76{
    margin-top: 19rem;
    margin-bottom: 19rem;
  }

  .xl\\:mx-76{
    margin-left: 19rem;
    margin-right: 19rem;
  }

  .xl\\:my-78{
    margin-top: 19.5rem;
    margin-bottom: 19.5rem;
  }

  .xl\\:mx-78{
    margin-left: 19.5rem;
    margin-right: 19.5rem;
  }

  .xl\\:my-80{
    margin-top: 20rem;
    margin-bottom: 20rem;
  }

  .xl\\:mx-80{
    margin-left: 20rem;
    margin-right: 20rem;
  }

  .xl\\:my-82{
    margin-top: 20.5rem;
    margin-bottom: 20.5rem;
  }

  .xl\\:mx-82{
    margin-left: 20.5rem;
    margin-right: 20.5rem;
  }

  .xl\\:my-84{
    margin-top: 21rem;
    margin-bottom: 21rem;
  }

  .xl\\:mx-84{
    margin-left: 21rem;
    margin-right: 21rem;
  }

  .xl\\:my-88{
    margin-top: 22rem;
    margin-bottom: 22rem;
  }

  .xl\\:mx-88{
    margin-left: 22rem;
    margin-right: 22rem;
  }

  .xl\\:my-92{
    margin-top: 23rem;
    margin-bottom: 23rem;
  }

  .xl\\:mx-92{
    margin-left: 23rem;
    margin-right: 23rem;
  }

  .xl\\:my-96{
    margin-top: 24rem;
    margin-bottom: 24rem;
  }

  .xl\\:mx-96{
    margin-left: 24rem;
    margin-right: 24rem;
  }

  .xl\\:my-98{
    margin-top: 24.5rem;
    margin-bottom: 24.5rem;
  }

  .xl\\:mx-98{
    margin-left: 24.5rem;
    margin-right: 24.5rem;
  }

  .xl\\:my-100{
    margin-top: 25rem;
    margin-bottom: 25rem;
  }

  .xl\\:mx-100{
    margin-left: 25rem;
    margin-right: 25rem;
  }

  .xl\\:my-104{
    margin-top: 26rem;
    margin-bottom: 26rem;
  }

  .xl\\:mx-104{
    margin-left: 26rem;
    margin-right: 26rem;
  }

  .xl\\:my-112{
    margin-top: 28rem;
    margin-bottom: 28rem;
  }

  .xl\\:mx-112{
    margin-left: 28rem;
    margin-right: 28rem;
  }

  .xl\\:my-124{
    margin-top: 31rem;
    margin-bottom: 31rem;
  }

  .xl\\:mx-124{
    margin-left: 31rem;
    margin-right: 31rem;
  }

  .xl\\:my-128{
    margin-top: 32rem;
    margin-bottom: 32rem;
  }

  .xl\\:mx-128{
    margin-left: 32rem;
    margin-right: 32rem;
  }

  .xl\\:my-140{
    margin-top: 35rem;
    margin-bottom: 35rem;
  }

  .xl\\:mx-140{
    margin-left: 35rem;
    margin-right: 35rem;
  }

  .xl\\:my-152{
    margin-top: 38rem;
    margin-bottom: 38rem;
  }

  .xl\\:mx-152{
    margin-left: 38rem;
    margin-right: 38rem;
  }

  .xl\\:my-160{
    margin-top: 40rem;
    margin-bottom: 40rem;
  }

  .xl\\:mx-160{
    margin-left: 40rem;
    margin-right: 40rem;
  }

  .xl\\:my-162{
    margin-top: 41rem;
    margin-bottom: 41rem;
  }

  .xl\\:mx-162{
    margin-left: 41rem;
    margin-right: 41rem;
  }

  .xl\\:my-192{
    margin-top: 48rem;
    margin-bottom: 48rem;
  }

  .xl\\:mx-192{
    margin-left: 48rem;
    margin-right: 48rem;
  }

  .xl\\:my-208{
    margin-top: 52rem;
    margin-bottom: 52rem;
  }

  .xl\\:mx-208{
    margin-left: 52rem;
    margin-right: 52rem;
  }

  .xl\\:my-224{
    margin-top: 56rem;
    margin-bottom: 56rem;
  }

  .xl\\:mx-224{
    margin-left: 56rem;
    margin-right: 56rem;
  }

  .xl\\:my-256{
    margin-top: 64rem;
    margin-bottom: 64rem;
  }

  .xl\\:mx-256{
    margin-left: 64rem;
    margin-right: 64rem;
  }

  .xl\\:my-auto{
    margin-top: auto;
    margin-bottom: auto;
  }

  .xl\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }

  .xl\\:my-px{
    margin-top: 1px;
    margin-bottom: 1px;
  }

  .xl\\:mx-px{
    margin-left: 1px;
    margin-right: 1px;
  }

  .xl\\:-my-1{
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .xl\\:-mx-1{
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .xl\\:-my-2{
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }

  .xl\\:-mx-2{
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .xl\\:-my-3{
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }

  .xl\\:-mx-3{
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .xl\\:-my-4{
    margin-top: -1rem;
    margin-bottom: -1rem;
  }

  .xl\\:-mx-4{
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .xl\\:-my-5{
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }

  .xl\\:-mx-5{
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .xl\\:-my-6{
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }

  .xl\\:-mx-6{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .xl\\:-my-7{
    margin-top: -1.75rem;
    margin-bottom: -1.75rem;
  }

  .xl\\:-mx-7{
    margin-left: -1.75rem;
    margin-right: -1.75rem;
  }

  .xl\\:-my-8{
    margin-top: -2rem;
    margin-bottom: -2rem;
  }

  .xl\\:-mx-8{
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .xl\\:-my-9{
    margin-top: -2.25rem;
    margin-bottom: -2.25rem;
  }

  .xl\\:-mx-9{
    margin-left: -2.25rem;
    margin-right: -2.25rem;
  }

  .xl\\:-my-10{
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }

  .xl\\:-mx-10{
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .xl\\:-my-11{
    margin-top: -2.75rem;
    margin-bottom: -2.75rem;
  }

  .xl\\:-mx-11{
    margin-left: -2.75rem;
    margin-right: -2.75rem;
  }

  .xl\\:-my-12{
    margin-top: -3rem;
    margin-bottom: -3rem;
  }

  .xl\\:-mx-12{
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .xl\\:-my-14{
    margin-top: -3.5rem;
    margin-bottom: -3.5rem;
  }

  .xl\\:-mx-14{
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }

  .xl\\:-my-15{
    margin-top: -3.75rem;
    margin-bottom: -3.75rem;
  }

  .xl\\:-mx-15{
    margin-left: -3.75rem;
    margin-right: -3.75rem;
  }

  .xl\\:-my-16{
    margin-top: -4rem;
    margin-bottom: -4rem;
  }

  .xl\\:-mx-16{
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .xl\\:-my-18{
    margin-top: -4.5rem;
    margin-bottom: -4.5rem;
  }

  .xl\\:-mx-18{
    margin-left: -4.5rem;
    margin-right: -4.5rem;
  }

  .xl\\:-my-20{
    margin-top: -5rem;
    margin-bottom: -5rem;
  }

  .xl\\:-mx-20{
    margin-left: -5rem;
    margin-right: -5rem;
  }

  .xl\\:-my-22{
    margin-top: -5.5rem;
    margin-bottom: -5.5rem;
  }

  .xl\\:-mx-22{
    margin-left: -5.5rem;
    margin-right: -5.5rem;
  }

  .xl\\:-my-23{
    margin-top: -5.75rem;
    margin-bottom: -5.75rem;
  }

  .xl\\:-mx-23{
    margin-left: -5.75rem;
    margin-right: -5.75rem;
  }

  .xl\\:-my-24{
    margin-top: -6rem;
    margin-bottom: -6rem;
  }

  .xl\\:-mx-24{
    margin-left: -6rem;
    margin-right: -6rem;
  }

  .xl\\:-my-25{
    margin-top: -6.25rem;
    margin-bottom: -6.25rem;
  }

  .xl\\:-mx-25{
    margin-left: -6.25rem;
    margin-right: -6.25rem;
  }

  .xl\\:-my-26{
    margin-top: -6.5rem;
    margin-bottom: -6.5rem;
  }

  .xl\\:-mx-26{
    margin-left: -6.5rem;
    margin-right: -6.5rem;
  }

  .xl\\:-my-28{
    margin-top: -7rem;
    margin-bottom: -7rem;
  }

  .xl\\:-mx-28{
    margin-left: -7rem;
    margin-right: -7rem;
  }

  .xl\\:-my-30{
    margin-top: -7.5rem;
    margin-bottom: -7.5rem;
  }

  .xl\\:-mx-30{
    margin-left: -7.5rem;
    margin-right: -7.5rem;
  }

  .xl\\:-my-32{
    margin-top: -8rem;
    margin-bottom: -8rem;
  }

  .xl\\:-mx-32{
    margin-left: -8rem;
    margin-right: -8rem;
  }

  .xl\\:-my-34{
    margin-top: -8.5rem;
    margin-bottom: -8.5rem;
  }

  .xl\\:-mx-34{
    margin-left: -8.5rem;
    margin-right: -8.5rem;
  }

  .xl\\:-my-40{
    margin-top: -10rem;
    margin-bottom: -10rem;
  }

  .xl\\:-mx-40{
    margin-left: -10rem;
    margin-right: -10rem;
  }

  .xl\\:-my-42{
    margin-top: -10.5rem;
    margin-bottom: -10.5rem;
  }

  .xl\\:-mx-42{
    margin-left: -10.5rem;
    margin-right: -10.5rem;
  }

  .xl\\:-my-44{
    margin-top: -11rem;
    margin-bottom: -11rem;
  }

  .xl\\:-mx-44{
    margin-left: -11rem;
    margin-right: -11rem;
  }

  .xl\\:-my-48{
    margin-top: -12rem;
    margin-bottom: -12rem;
  }

  .xl\\:-mx-48{
    margin-left: -12rem;
    margin-right: -12rem;
  }

  .xl\\:-my-52{
    margin-top: -13rem;
    margin-bottom: -13rem;
  }

  .xl\\:-mx-52{
    margin-left: -13rem;
    margin-right: -13rem;
  }

  .xl\\:-my-54{
    margin-top: -13.5rem;
    margin-bottom: -13.5rem;
  }

  .xl\\:-mx-54{
    margin-left: -13.5rem;
    margin-right: -13.5rem;
  }

  .xl\\:-my-56{
    margin-top: -14rem;
    margin-bottom: -14rem;
  }

  .xl\\:-mx-56{
    margin-left: -14rem;
    margin-right: -14rem;
  }

  .xl\\:-my-60{
    margin-top: -15rem;
    margin-bottom: -15rem;
  }

  .xl\\:-mx-60{
    margin-left: -15rem;
    margin-right: -15rem;
  }

  .xl\\:-my-64{
    margin-top: -16rem;
    margin-bottom: -16rem;
  }

  .xl\\:-mx-64{
    margin-left: -16rem;
    margin-right: -16rem;
  }

  .xl\\:-my-68{
    margin-top: -17rem;
    margin-bottom: -17rem;
  }

  .xl\\:-mx-68{
    margin-left: -17rem;
    margin-right: -17rem;
  }

  .xl\\:-my-72{
    margin-top: -18rem;
    margin-bottom: -18rem;
  }

  .xl\\:-mx-72{
    margin-left: -18rem;
    margin-right: -18rem;
  }

  .xl\\:-my-74{
    margin-top: -18.5rem;
    margin-bottom: -18.5rem;
  }

  .xl\\:-mx-74{
    margin-left: -18.5rem;
    margin-right: -18.5rem;
  }

  .xl\\:-my-76{
    margin-top: -19rem;
    margin-bottom: -19rem;
  }

  .xl\\:-mx-76{
    margin-left: -19rem;
    margin-right: -19rem;
  }

  .xl\\:-my-78{
    margin-top: -19.5rem;
    margin-bottom: -19.5rem;
  }

  .xl\\:-mx-78{
    margin-left: -19.5rem;
    margin-right: -19.5rem;
  }

  .xl\\:-my-80{
    margin-top: -20rem;
    margin-bottom: -20rem;
  }

  .xl\\:-mx-80{
    margin-left: -20rem;
    margin-right: -20rem;
  }

  .xl\\:-my-82{
    margin-top: -20.5rem;
    margin-bottom: -20.5rem;
  }

  .xl\\:-mx-82{
    margin-left: -20.5rem;
    margin-right: -20.5rem;
  }

  .xl\\:-my-84{
    margin-top: -21rem;
    margin-bottom: -21rem;
  }

  .xl\\:-mx-84{
    margin-left: -21rem;
    margin-right: -21rem;
  }

  .xl\\:-my-88{
    margin-top: -22rem;
    margin-bottom: -22rem;
  }

  .xl\\:-mx-88{
    margin-left: -22rem;
    margin-right: -22rem;
  }

  .xl\\:-my-92{
    margin-top: -23rem;
    margin-bottom: -23rem;
  }

  .xl\\:-mx-92{
    margin-left: -23rem;
    margin-right: -23rem;
  }

  .xl\\:-my-96{
    margin-top: -24rem;
    margin-bottom: -24rem;
  }

  .xl\\:-mx-96{
    margin-left: -24rem;
    margin-right: -24rem;
  }

  .xl\\:-my-98{
    margin-top: -24.5rem;
    margin-bottom: -24.5rem;
  }

  .xl\\:-mx-98{
    margin-left: -24.5rem;
    margin-right: -24.5rem;
  }

  .xl\\:-my-100{
    margin-top: -25rem;
    margin-bottom: -25rem;
  }

  .xl\\:-mx-100{
    margin-left: -25rem;
    margin-right: -25rem;
  }

  .xl\\:-my-104{
    margin-top: -26rem;
    margin-bottom: -26rem;
  }

  .xl\\:-mx-104{
    margin-left: -26rem;
    margin-right: -26rem;
  }

  .xl\\:-my-112{
    margin-top: -28rem;
    margin-bottom: -28rem;
  }

  .xl\\:-mx-112{
    margin-left: -28rem;
    margin-right: -28rem;
  }

  .xl\\:-my-124{
    margin-top: -31rem;
    margin-bottom: -31rem;
  }

  .xl\\:-mx-124{
    margin-left: -31rem;
    margin-right: -31rem;
  }

  .xl\\:-my-128{
    margin-top: -32rem;
    margin-bottom: -32rem;
  }

  .xl\\:-mx-128{
    margin-left: -32rem;
    margin-right: -32rem;
  }

  .xl\\:-my-140{
    margin-top: -35rem;
    margin-bottom: -35rem;
  }

  .xl\\:-mx-140{
    margin-left: -35rem;
    margin-right: -35rem;
  }

  .xl\\:-my-152{
    margin-top: -38rem;
    margin-bottom: -38rem;
  }

  .xl\\:-mx-152{
    margin-left: -38rem;
    margin-right: -38rem;
  }

  .xl\\:-my-160{
    margin-top: -40rem;
    margin-bottom: -40rem;
  }

  .xl\\:-mx-160{
    margin-left: -40rem;
    margin-right: -40rem;
  }

  .xl\\:-my-162{
    margin-top: -41rem;
    margin-bottom: -41rem;
  }

  .xl\\:-mx-162{
    margin-left: -41rem;
    margin-right: -41rem;
  }

  .xl\\:-my-192{
    margin-top: -48rem;
    margin-bottom: -48rem;
  }

  .xl\\:-mx-192{
    margin-left: -48rem;
    margin-right: -48rem;
  }

  .xl\\:-my-208{
    margin-top: -52rem;
    margin-bottom: -52rem;
  }

  .xl\\:-mx-208{
    margin-left: -52rem;
    margin-right: -52rem;
  }

  .xl\\:-my-224{
    margin-top: -56rem;
    margin-bottom: -56rem;
  }

  .xl\\:-mx-224{
    margin-left: -56rem;
    margin-right: -56rem;
  }

  .xl\\:-my-256{
    margin-top: -64rem;
    margin-bottom: -64rem;
  }

  .xl\\:-mx-256{
    margin-left: -64rem;
    margin-right: -64rem;
  }

  .xl\\:-my-px{
    margin-top: -1px;
    margin-bottom: -1px;
  }

  .xl\\:-mx-px{
    margin-left: -1px;
    margin-right: -1px;
  }

  .xl\\:mt-0{
    margin-top: 0;
  }

  .xl\\:mr-0{
    margin-right: 0;
  }

  .xl\\:mb-0{
    margin-bottom: 0;
  }

  .xl\\:ml-0{
    margin-left: 0;
  }

  .xl\\:mt-1{
    margin-top: 0.25rem;
  }

  .xl\\:mr-1{
    margin-right: 0.25rem;
  }

  .xl\\:mb-1{
    margin-bottom: 0.25rem;
  }

  .xl\\:ml-1{
    margin-left: 0.25rem;
  }

  .xl\\:mt-2{
    margin-top: 0.5rem;
  }

  .xl\\:mr-2{
    margin-right: 0.5rem;
  }

  .xl\\:mb-2{
    margin-bottom: 0.5rem;
  }

  .xl\\:ml-2{
    margin-left: 0.5rem;
  }

  .xl\\:mt-3{
    margin-top: 0.75rem;
  }

  .xl\\:mr-3{
    margin-right: 0.75rem;
  }

  .xl\\:mb-3{
    margin-bottom: 0.75rem;
  }

  .xl\\:ml-3{
    margin-left: 0.75rem;
  }

  .xl\\:mt-4{
    margin-top: 1rem;
  }

  .xl\\:mr-4{
    margin-right: 1rem;
  }

  .xl\\:mb-4{
    margin-bottom: 1rem;
  }

  .xl\\:ml-4{
    margin-left: 1rem;
  }

  .xl\\:mt-5{
    margin-top: 1.25rem;
  }

  .xl\\:mr-5{
    margin-right: 1.25rem;
  }

  .xl\\:mb-5{
    margin-bottom: 1.25rem;
  }

  .xl\\:ml-5{
    margin-left: 1.25rem;
  }

  .xl\\:mt-6{
    margin-top: 1.5rem;
  }

  .xl\\:mr-6{
    margin-right: 1.5rem;
  }

  .xl\\:mb-6{
    margin-bottom: 1.5rem;
  }

  .xl\\:ml-6{
    margin-left: 1.5rem;
  }

  .xl\\:mt-7{
    margin-top: 1.75rem;
  }

  .xl\\:mr-7{
    margin-right: 1.75rem;
  }

  .xl\\:mb-7{
    margin-bottom: 1.75rem;
  }

  .xl\\:ml-7{
    margin-left: 1.75rem;
  }

  .xl\\:mt-8{
    margin-top: 2rem;
  }

  .xl\\:mr-8{
    margin-right: 2rem;
  }

  .xl\\:mb-8{
    margin-bottom: 2rem;
  }

  .xl\\:ml-8{
    margin-left: 2rem;
  }

  .xl\\:mt-9{
    margin-top: 2.25rem;
  }

  .xl\\:mr-9{
    margin-right: 2.25rem;
  }

  .xl\\:mb-9{
    margin-bottom: 2.25rem;
  }

  .xl\\:ml-9{
    margin-left: 2.25rem;
  }

  .xl\\:mt-10{
    margin-top: 2.5rem;
  }

  .xl\\:mr-10{
    margin-right: 2.5rem;
  }

  .xl\\:mb-10{
    margin-bottom: 2.5rem;
  }

  .xl\\:ml-10{
    margin-left: 2.5rem;
  }

  .xl\\:mt-11{
    margin-top: 2.75rem;
  }

  .xl\\:mr-11{
    margin-right: 2.75rem;
  }

  .xl\\:mb-11{
    margin-bottom: 2.75rem;
  }

  .xl\\:ml-11{
    margin-left: 2.75rem;
  }

  .xl\\:mt-12{
    margin-top: 3rem;
  }

  .xl\\:mr-12{
    margin-right: 3rem;
  }

  .xl\\:mb-12{
    margin-bottom: 3rem;
  }

  .xl\\:ml-12{
    margin-left: 3rem;
  }

  .xl\\:mt-14{
    margin-top: 3.5rem;
  }

  .xl\\:mr-14{
    margin-right: 3.5rem;
  }

  .xl\\:mb-14{
    margin-bottom: 3.5rem;
  }

  .xl\\:ml-14{
    margin-left: 3.5rem;
  }

  .xl\\:mt-15{
    margin-top: 3.75rem;
  }

  .xl\\:mr-15{
    margin-right: 3.75rem;
  }

  .xl\\:mb-15{
    margin-bottom: 3.75rem;
  }

  .xl\\:ml-15{
    margin-left: 3.75rem;
  }

  .xl\\:mt-16{
    margin-top: 4rem;
  }

  .xl\\:mr-16{
    margin-right: 4rem;
  }

  .xl\\:mb-16{
    margin-bottom: 4rem;
  }

  .xl\\:ml-16{
    margin-left: 4rem;
  }

  .xl\\:mt-18{
    margin-top: 4.5rem;
  }

  .xl\\:mr-18{
    margin-right: 4.5rem;
  }

  .xl\\:mb-18{
    margin-bottom: 4.5rem;
  }

  .xl\\:ml-18{
    margin-left: 4.5rem;
  }

  .xl\\:mt-20{
    margin-top: 5rem;
  }

  .xl\\:mr-20{
    margin-right: 5rem;
  }

  .xl\\:mb-20{
    margin-bottom: 5rem;
  }

  .xl\\:ml-20{
    margin-left: 5rem;
  }

  .xl\\:mt-22{
    margin-top: 5.5rem;
  }

  .xl\\:mr-22{
    margin-right: 5.5rem;
  }

  .xl\\:mb-22{
    margin-bottom: 5.5rem;
  }

  .xl\\:ml-22{
    margin-left: 5.5rem;
  }

  .xl\\:mt-23{
    margin-top: 5.75rem;
  }

  .xl\\:mr-23{
    margin-right: 5.75rem;
  }

  .xl\\:mb-23{
    margin-bottom: 5.75rem;
  }

  .xl\\:ml-23{
    margin-left: 5.75rem;
  }

  .xl\\:mt-24{
    margin-top: 6rem;
  }

  .xl\\:mr-24{
    margin-right: 6rem;
  }

  .xl\\:mb-24{
    margin-bottom: 6rem;
  }

  .xl\\:ml-24{
    margin-left: 6rem;
  }

  .xl\\:mt-25{
    margin-top: 6.25rem;
  }

  .xl\\:mr-25{
    margin-right: 6.25rem;
  }

  .xl\\:mb-25{
    margin-bottom: 6.25rem;
  }

  .xl\\:ml-25{
    margin-left: 6.25rem;
  }

  .xl\\:mt-26{
    margin-top: 6.5rem;
  }

  .xl\\:mr-26{
    margin-right: 6.5rem;
  }

  .xl\\:mb-26{
    margin-bottom: 6.5rem;
  }

  .xl\\:ml-26{
    margin-left: 6.5rem;
  }

  .xl\\:mt-28{
    margin-top: 7rem;
  }

  .xl\\:mr-28{
    margin-right: 7rem;
  }

  .xl\\:mb-28{
    margin-bottom: 7rem;
  }

  .xl\\:ml-28{
    margin-left: 7rem;
  }

  .xl\\:mt-30{
    margin-top: 7.5rem;
  }

  .xl\\:mr-30{
    margin-right: 7.5rem;
  }

  .xl\\:mb-30{
    margin-bottom: 7.5rem;
  }

  .xl\\:ml-30{
    margin-left: 7.5rem;
  }

  .xl\\:mt-32{
    margin-top: 8rem;
  }

  .xl\\:mr-32{
    margin-right: 8rem;
  }

  .xl\\:mb-32{
    margin-bottom: 8rem;
  }

  .xl\\:ml-32{
    margin-left: 8rem;
  }

  .xl\\:mt-34{
    margin-top: 8.5rem;
  }

  .xl\\:mr-34{
    margin-right: 8.5rem;
  }

  .xl\\:mb-34{
    margin-bottom: 8.5rem;
  }

  .xl\\:ml-34{
    margin-left: 8.5rem;
  }

  .xl\\:mt-40{
    margin-top: 10rem;
  }

  .xl\\:mr-40{
    margin-right: 10rem;
  }

  .xl\\:mb-40{
    margin-bottom: 10rem;
  }

  .xl\\:ml-40{
    margin-left: 10rem;
  }

  .xl\\:mt-42{
    margin-top: 10.5rem;
  }

  .xl\\:mr-42{
    margin-right: 10.5rem;
  }

  .xl\\:mb-42{
    margin-bottom: 10.5rem;
  }

  .xl\\:ml-42{
    margin-left: 10.5rem;
  }

  .xl\\:mt-44{
    margin-top: 11rem;
  }

  .xl\\:mr-44{
    margin-right: 11rem;
  }

  .xl\\:mb-44{
    margin-bottom: 11rem;
  }

  .xl\\:ml-44{
    margin-left: 11rem;
  }

  .xl\\:mt-48{
    margin-top: 12rem;
  }

  .xl\\:mr-48{
    margin-right: 12rem;
  }

  .xl\\:mb-48{
    margin-bottom: 12rem;
  }

  .xl\\:ml-48{
    margin-left: 12rem;
  }

  .xl\\:mt-52{
    margin-top: 13rem;
  }

  .xl\\:mr-52{
    margin-right: 13rem;
  }

  .xl\\:mb-52{
    margin-bottom: 13rem;
  }

  .xl\\:ml-52{
    margin-left: 13rem;
  }

  .xl\\:mt-54{
    margin-top: 13.5rem;
  }

  .xl\\:mr-54{
    margin-right: 13.5rem;
  }

  .xl\\:mb-54{
    margin-bottom: 13.5rem;
  }

  .xl\\:ml-54{
    margin-left: 13.5rem;
  }

  .xl\\:mt-56{
    margin-top: 14rem;
  }

  .xl\\:mr-56{
    margin-right: 14rem;
  }

  .xl\\:mb-56{
    margin-bottom: 14rem;
  }

  .xl\\:ml-56{
    margin-left: 14rem;
  }

  .xl\\:mt-60{
    margin-top: 15rem;
  }

  .xl\\:mr-60{
    margin-right: 15rem;
  }

  .xl\\:mb-60{
    margin-bottom: 15rem;
  }

  .xl\\:ml-60{
    margin-left: 15rem;
  }

  .xl\\:mt-64{
    margin-top: 16rem;
  }

  .xl\\:mr-64{
    margin-right: 16rem;
  }

  .xl\\:mb-64{
    margin-bottom: 16rem;
  }

  .xl\\:ml-64{
    margin-left: 16rem;
  }

  .xl\\:mt-68{
    margin-top: 17rem;
  }

  .xl\\:mr-68{
    margin-right: 17rem;
  }

  .xl\\:mb-68{
    margin-bottom: 17rem;
  }

  .xl\\:ml-68{
    margin-left: 17rem;
  }

  .xl\\:mt-72{
    margin-top: 18rem;
  }

  .xl\\:mr-72{
    margin-right: 18rem;
  }

  .xl\\:mb-72{
    margin-bottom: 18rem;
  }

  .xl\\:ml-72{
    margin-left: 18rem;
  }

  .xl\\:mt-74{
    margin-top: 18.5rem;
  }

  .xl\\:mr-74{
    margin-right: 18.5rem;
  }

  .xl\\:mb-74{
    margin-bottom: 18.5rem;
  }

  .xl\\:ml-74{
    margin-left: 18.5rem;
  }

  .xl\\:mt-76{
    margin-top: 19rem;
  }

  .xl\\:mr-76{
    margin-right: 19rem;
  }

  .xl\\:mb-76{
    margin-bottom: 19rem;
  }

  .xl\\:ml-76{
    margin-left: 19rem;
  }

  .xl\\:mt-78{
    margin-top: 19.5rem;
  }

  .xl\\:mr-78{
    margin-right: 19.5rem;
  }

  .xl\\:mb-78{
    margin-bottom: 19.5rem;
  }

  .xl\\:ml-78{
    margin-left: 19.5rem;
  }

  .xl\\:mt-80{
    margin-top: 20rem;
  }

  .xl\\:mr-80{
    margin-right: 20rem;
  }

  .xl\\:mb-80{
    margin-bottom: 20rem;
  }

  .xl\\:ml-80{
    margin-left: 20rem;
  }

  .xl\\:mt-82{
    margin-top: 20.5rem;
  }

  .xl\\:mr-82{
    margin-right: 20.5rem;
  }

  .xl\\:mb-82{
    margin-bottom: 20.5rem;
  }

  .xl\\:ml-82{
    margin-left: 20.5rem;
  }

  .xl\\:mt-84{
    margin-top: 21rem;
  }

  .xl\\:mr-84{
    margin-right: 21rem;
  }

  .xl\\:mb-84{
    margin-bottom: 21rem;
  }

  .xl\\:ml-84{
    margin-left: 21rem;
  }

  .xl\\:mt-88{
    margin-top: 22rem;
  }

  .xl\\:mr-88{
    margin-right: 22rem;
  }

  .xl\\:mb-88{
    margin-bottom: 22rem;
  }

  .xl\\:ml-88{
    margin-left: 22rem;
  }

  .xl\\:mt-92{
    margin-top: 23rem;
  }

  .xl\\:mr-92{
    margin-right: 23rem;
  }

  .xl\\:mb-92{
    margin-bottom: 23rem;
  }

  .xl\\:ml-92{
    margin-left: 23rem;
  }

  .xl\\:mt-96{
    margin-top: 24rem;
  }

  .xl\\:mr-96{
    margin-right: 24rem;
  }

  .xl\\:mb-96{
    margin-bottom: 24rem;
  }

  .xl\\:ml-96{
    margin-left: 24rem;
  }

  .xl\\:mt-98{
    margin-top: 24.5rem;
  }

  .xl\\:mr-98{
    margin-right: 24.5rem;
  }

  .xl\\:mb-98{
    margin-bottom: 24.5rem;
  }

  .xl\\:ml-98{
    margin-left: 24.5rem;
  }

  .xl\\:mt-100{
    margin-top: 25rem;
  }

  .xl\\:mr-100{
    margin-right: 25rem;
  }

  .xl\\:mb-100{
    margin-bottom: 25rem;
  }

  .xl\\:ml-100{
    margin-left: 25rem;
  }

  .xl\\:mt-104{
    margin-top: 26rem;
  }

  .xl\\:mr-104{
    margin-right: 26rem;
  }

  .xl\\:mb-104{
    margin-bottom: 26rem;
  }

  .xl\\:ml-104{
    margin-left: 26rem;
  }

  .xl\\:mt-112{
    margin-top: 28rem;
  }

  .xl\\:mr-112{
    margin-right: 28rem;
  }

  .xl\\:mb-112{
    margin-bottom: 28rem;
  }

  .xl\\:ml-112{
    margin-left: 28rem;
  }

  .xl\\:mt-124{
    margin-top: 31rem;
  }

  .xl\\:mr-124{
    margin-right: 31rem;
  }

  .xl\\:mb-124{
    margin-bottom: 31rem;
  }

  .xl\\:ml-124{
    margin-left: 31rem;
  }

  .xl\\:mt-128{
    margin-top: 32rem;
  }

  .xl\\:mr-128{
    margin-right: 32rem;
  }

  .xl\\:mb-128{
    margin-bottom: 32rem;
  }

  .xl\\:ml-128{
    margin-left: 32rem;
  }

  .xl\\:mt-140{
    margin-top: 35rem;
  }

  .xl\\:mr-140{
    margin-right: 35rem;
  }

  .xl\\:mb-140{
    margin-bottom: 35rem;
  }

  .xl\\:ml-140{
    margin-left: 35rem;
  }

  .xl\\:mt-152{
    margin-top: 38rem;
  }

  .xl\\:mr-152{
    margin-right: 38rem;
  }

  .xl\\:mb-152{
    margin-bottom: 38rem;
  }

  .xl\\:ml-152{
    margin-left: 38rem;
  }

  .xl\\:mt-160{
    margin-top: 40rem;
  }

  .xl\\:mr-160{
    margin-right: 40rem;
  }

  .xl\\:mb-160{
    margin-bottom: 40rem;
  }

  .xl\\:ml-160{
    margin-left: 40rem;
  }

  .xl\\:mt-162{
    margin-top: 41rem;
  }

  .xl\\:mr-162{
    margin-right: 41rem;
  }

  .xl\\:mb-162{
    margin-bottom: 41rem;
  }

  .xl\\:ml-162{
    margin-left: 41rem;
  }

  .xl\\:mt-192{
    margin-top: 48rem;
  }

  .xl\\:mr-192{
    margin-right: 48rem;
  }

  .xl\\:mb-192{
    margin-bottom: 48rem;
  }

  .xl\\:ml-192{
    margin-left: 48rem;
  }

  .xl\\:mt-208{
    margin-top: 52rem;
  }

  .xl\\:mr-208{
    margin-right: 52rem;
  }

  .xl\\:mb-208{
    margin-bottom: 52rem;
  }

  .xl\\:ml-208{
    margin-left: 52rem;
  }

  .xl\\:mt-224{
    margin-top: 56rem;
  }

  .xl\\:mr-224{
    margin-right: 56rem;
  }

  .xl\\:mb-224{
    margin-bottom: 56rem;
  }

  .xl\\:ml-224{
    margin-left: 56rem;
  }

  .xl\\:mt-256{
    margin-top: 64rem;
  }

  .xl\\:mr-256{
    margin-right: 64rem;
  }

  .xl\\:mb-256{
    margin-bottom: 64rem;
  }

  .xl\\:ml-256{
    margin-left: 64rem;
  }

  .xl\\:mt-auto{
    margin-top: auto;
  }

  .xl\\:mr-auto{
    margin-right: auto;
  }

  .xl\\:mb-auto{
    margin-bottom: auto;
  }

  .xl\\:ml-auto{
    margin-left: auto;
  }

  .xl\\:mt-px{
    margin-top: 1px;
  }

  .xl\\:mr-px{
    margin-right: 1px;
  }

  .xl\\:mb-px{
    margin-bottom: 1px;
  }

  .xl\\:ml-px{
    margin-left: 1px;
  }

  .xl\\:-mt-1{
    margin-top: -0.25rem;
  }

  .xl\\:-mr-1{
    margin-right: -0.25rem;
  }

  .xl\\:-mb-1{
    margin-bottom: -0.25rem;
  }

  .xl\\:-ml-1{
    margin-left: -0.25rem;
  }

  .xl\\:-mt-2{
    margin-top: -0.5rem;
  }

  .xl\\:-mr-2{
    margin-right: -0.5rem;
  }

  .xl\\:-mb-2{
    margin-bottom: -0.5rem;
  }

  .xl\\:-ml-2{
    margin-left: -0.5rem;
  }

  .xl\\:-mt-3{
    margin-top: -0.75rem;
  }

  .xl\\:-mr-3{
    margin-right: -0.75rem;
  }

  .xl\\:-mb-3{
    margin-bottom: -0.75rem;
  }

  .xl\\:-ml-3{
    margin-left: -0.75rem;
  }

  .xl\\:-mt-4{
    margin-top: -1rem;
  }

  .xl\\:-mr-4{
    margin-right: -1rem;
  }

  .xl\\:-mb-4{
    margin-bottom: -1rem;
  }

  .xl\\:-ml-4{
    margin-left: -1rem;
  }

  .xl\\:-mt-5{
    margin-top: -1.25rem;
  }

  .xl\\:-mr-5{
    margin-right: -1.25rem;
  }

  .xl\\:-mb-5{
    margin-bottom: -1.25rem;
  }

  .xl\\:-ml-5{
    margin-left: -1.25rem;
  }

  .xl\\:-mt-6{
    margin-top: -1.5rem;
  }

  .xl\\:-mr-6{
    margin-right: -1.5rem;
  }

  .xl\\:-mb-6{
    margin-bottom: -1.5rem;
  }

  .xl\\:-ml-6{
    margin-left: -1.5rem;
  }

  .xl\\:-mt-7{
    margin-top: -1.75rem;
  }

  .xl\\:-mr-7{
    margin-right: -1.75rem;
  }

  .xl\\:-mb-7{
    margin-bottom: -1.75rem;
  }

  .xl\\:-ml-7{
    margin-left: -1.75rem;
  }

  .xl\\:-mt-8{
    margin-top: -2rem;
  }

  .xl\\:-mr-8{
    margin-right: -2rem;
  }

  .xl\\:-mb-8{
    margin-bottom: -2rem;
  }

  .xl\\:-ml-8{
    margin-left: -2rem;
  }

  .xl\\:-mt-9{
    margin-top: -2.25rem;
  }

  .xl\\:-mr-9{
    margin-right: -2.25rem;
  }

  .xl\\:-mb-9{
    margin-bottom: -2.25rem;
  }

  .xl\\:-ml-9{
    margin-left: -2.25rem;
  }

  .xl\\:-mt-10{
    margin-top: -2.5rem;
  }

  .xl\\:-mr-10{
    margin-right: -2.5rem;
  }

  .xl\\:-mb-10{
    margin-bottom: -2.5rem;
  }

  .xl\\:-ml-10{
    margin-left: -2.5rem;
  }

  .xl\\:-mt-11{
    margin-top: -2.75rem;
  }

  .xl\\:-mr-11{
    margin-right: -2.75rem;
  }

  .xl\\:-mb-11{
    margin-bottom: -2.75rem;
  }

  .xl\\:-ml-11{
    margin-left: -2.75rem;
  }

  .xl\\:-mt-12{
    margin-top: -3rem;
  }

  .xl\\:-mr-12{
    margin-right: -3rem;
  }

  .xl\\:-mb-12{
    margin-bottom: -3rem;
  }

  .xl\\:-ml-12{
    margin-left: -3rem;
  }

  .xl\\:-mt-14{
    margin-top: -3.5rem;
  }

  .xl\\:-mr-14{
    margin-right: -3.5rem;
  }

  .xl\\:-mb-14{
    margin-bottom: -3.5rem;
  }

  .xl\\:-ml-14{
    margin-left: -3.5rem;
  }

  .xl\\:-mt-15{
    margin-top: -3.75rem;
  }

  .xl\\:-mr-15{
    margin-right: -3.75rem;
  }

  .xl\\:-mb-15{
    margin-bottom: -3.75rem;
  }

  .xl\\:-ml-15{
    margin-left: -3.75rem;
  }

  .xl\\:-mt-16{
    margin-top: -4rem;
  }

  .xl\\:-mr-16{
    margin-right: -4rem;
  }

  .xl\\:-mb-16{
    margin-bottom: -4rem;
  }

  .xl\\:-ml-16{
    margin-left: -4rem;
  }

  .xl\\:-mt-18{
    margin-top: -4.5rem;
  }

  .xl\\:-mr-18{
    margin-right: -4.5rem;
  }

  .xl\\:-mb-18{
    margin-bottom: -4.5rem;
  }

  .xl\\:-ml-18{
    margin-left: -4.5rem;
  }

  .xl\\:-mt-20{
    margin-top: -5rem;
  }

  .xl\\:-mr-20{
    margin-right: -5rem;
  }

  .xl\\:-mb-20{
    margin-bottom: -5rem;
  }

  .xl\\:-ml-20{
    margin-left: -5rem;
  }

  .xl\\:-mt-22{
    margin-top: -5.5rem;
  }

  .xl\\:-mr-22{
    margin-right: -5.5rem;
  }

  .xl\\:-mb-22{
    margin-bottom: -5.5rem;
  }

  .xl\\:-ml-22{
    margin-left: -5.5rem;
  }

  .xl\\:-mt-23{
    margin-top: -5.75rem;
  }

  .xl\\:-mr-23{
    margin-right: -5.75rem;
  }

  .xl\\:-mb-23{
    margin-bottom: -5.75rem;
  }

  .xl\\:-ml-23{
    margin-left: -5.75rem;
  }

  .xl\\:-mt-24{
    margin-top: -6rem;
  }

  .xl\\:-mr-24{
    margin-right: -6rem;
  }

  .xl\\:-mb-24{
    margin-bottom: -6rem;
  }

  .xl\\:-ml-24{
    margin-left: -6rem;
  }

  .xl\\:-mt-25{
    margin-top: -6.25rem;
  }

  .xl\\:-mr-25{
    margin-right: -6.25rem;
  }

  .xl\\:-mb-25{
    margin-bottom: -6.25rem;
  }

  .xl\\:-ml-25{
    margin-left: -6.25rem;
  }

  .xl\\:-mt-26{
    margin-top: -6.5rem;
  }

  .xl\\:-mr-26{
    margin-right: -6.5rem;
  }

  .xl\\:-mb-26{
    margin-bottom: -6.5rem;
  }

  .xl\\:-ml-26{
    margin-left: -6.5rem;
  }

  .xl\\:-mt-28{
    margin-top: -7rem;
  }

  .xl\\:-mr-28{
    margin-right: -7rem;
  }

  .xl\\:-mb-28{
    margin-bottom: -7rem;
  }

  .xl\\:-ml-28{
    margin-left: -7rem;
  }

  .xl\\:-mt-30{
    margin-top: -7.5rem;
  }

  .xl\\:-mr-30{
    margin-right: -7.5rem;
  }

  .xl\\:-mb-30{
    margin-bottom: -7.5rem;
  }

  .xl\\:-ml-30{
    margin-left: -7.5rem;
  }

  .xl\\:-mt-32{
    margin-top: -8rem;
  }

  .xl\\:-mr-32{
    margin-right: -8rem;
  }

  .xl\\:-mb-32{
    margin-bottom: -8rem;
  }

  .xl\\:-ml-32{
    margin-left: -8rem;
  }

  .xl\\:-mt-34{
    margin-top: -8.5rem;
  }

  .xl\\:-mr-34{
    margin-right: -8.5rem;
  }

  .xl\\:-mb-34{
    margin-bottom: -8.5rem;
  }

  .xl\\:-ml-34{
    margin-left: -8.5rem;
  }

  .xl\\:-mt-40{
    margin-top: -10rem;
  }

  .xl\\:-mr-40{
    margin-right: -10rem;
  }

  .xl\\:-mb-40{
    margin-bottom: -10rem;
  }

  .xl\\:-ml-40{
    margin-left: -10rem;
  }

  .xl\\:-mt-42{
    margin-top: -10.5rem;
  }

  .xl\\:-mr-42{
    margin-right: -10.5rem;
  }

  .xl\\:-mb-42{
    margin-bottom: -10.5rem;
  }

  .xl\\:-ml-42{
    margin-left: -10.5rem;
  }

  .xl\\:-mt-44{
    margin-top: -11rem;
  }

  .xl\\:-mr-44{
    margin-right: -11rem;
  }

  .xl\\:-mb-44{
    margin-bottom: -11rem;
  }

  .xl\\:-ml-44{
    margin-left: -11rem;
  }

  .xl\\:-mt-48{
    margin-top: -12rem;
  }

  .xl\\:-mr-48{
    margin-right: -12rem;
  }

  .xl\\:-mb-48{
    margin-bottom: -12rem;
  }

  .xl\\:-ml-48{
    margin-left: -12rem;
  }

  .xl\\:-mt-52{
    margin-top: -13rem;
  }

  .xl\\:-mr-52{
    margin-right: -13rem;
  }

  .xl\\:-mb-52{
    margin-bottom: -13rem;
  }

  .xl\\:-ml-52{
    margin-left: -13rem;
  }

  .xl\\:-mt-54{
    margin-top: -13.5rem;
  }

  .xl\\:-mr-54{
    margin-right: -13.5rem;
  }

  .xl\\:-mb-54{
    margin-bottom: -13.5rem;
  }

  .xl\\:-ml-54{
    margin-left: -13.5rem;
  }

  .xl\\:-mt-56{
    margin-top: -14rem;
  }

  .xl\\:-mr-56{
    margin-right: -14rem;
  }

  .xl\\:-mb-56{
    margin-bottom: -14rem;
  }

  .xl\\:-ml-56{
    margin-left: -14rem;
  }

  .xl\\:-mt-60{
    margin-top: -15rem;
  }

  .xl\\:-mr-60{
    margin-right: -15rem;
  }

  .xl\\:-mb-60{
    margin-bottom: -15rem;
  }

  .xl\\:-ml-60{
    margin-left: -15rem;
  }

  .xl\\:-mt-64{
    margin-top: -16rem;
  }

  .xl\\:-mr-64{
    margin-right: -16rem;
  }

  .xl\\:-mb-64{
    margin-bottom: -16rem;
  }

  .xl\\:-ml-64{
    margin-left: -16rem;
  }

  .xl\\:-mt-68{
    margin-top: -17rem;
  }

  .xl\\:-mr-68{
    margin-right: -17rem;
  }

  .xl\\:-mb-68{
    margin-bottom: -17rem;
  }

  .xl\\:-ml-68{
    margin-left: -17rem;
  }

  .xl\\:-mt-72{
    margin-top: -18rem;
  }

  .xl\\:-mr-72{
    margin-right: -18rem;
  }

  .xl\\:-mb-72{
    margin-bottom: -18rem;
  }

  .xl\\:-ml-72{
    margin-left: -18rem;
  }

  .xl\\:-mt-74{
    margin-top: -18.5rem;
  }

  .xl\\:-mr-74{
    margin-right: -18.5rem;
  }

  .xl\\:-mb-74{
    margin-bottom: -18.5rem;
  }

  .xl\\:-ml-74{
    margin-left: -18.5rem;
  }

  .xl\\:-mt-76{
    margin-top: -19rem;
  }

  .xl\\:-mr-76{
    margin-right: -19rem;
  }

  .xl\\:-mb-76{
    margin-bottom: -19rem;
  }

  .xl\\:-ml-76{
    margin-left: -19rem;
  }

  .xl\\:-mt-78{
    margin-top: -19.5rem;
  }

  .xl\\:-mr-78{
    margin-right: -19.5rem;
  }

  .xl\\:-mb-78{
    margin-bottom: -19.5rem;
  }

  .xl\\:-ml-78{
    margin-left: -19.5rem;
  }

  .xl\\:-mt-80{
    margin-top: -20rem;
  }

  .xl\\:-mr-80{
    margin-right: -20rem;
  }

  .xl\\:-mb-80{
    margin-bottom: -20rem;
  }

  .xl\\:-ml-80{
    margin-left: -20rem;
  }

  .xl\\:-mt-82{
    margin-top: -20.5rem;
  }

  .xl\\:-mr-82{
    margin-right: -20.5rem;
  }

  .xl\\:-mb-82{
    margin-bottom: -20.5rem;
  }

  .xl\\:-ml-82{
    margin-left: -20.5rem;
  }

  .xl\\:-mt-84{
    margin-top: -21rem;
  }

  .xl\\:-mr-84{
    margin-right: -21rem;
  }

  .xl\\:-mb-84{
    margin-bottom: -21rem;
  }

  .xl\\:-ml-84{
    margin-left: -21rem;
  }

  .xl\\:-mt-88{
    margin-top: -22rem;
  }

  .xl\\:-mr-88{
    margin-right: -22rem;
  }

  .xl\\:-mb-88{
    margin-bottom: -22rem;
  }

  .xl\\:-ml-88{
    margin-left: -22rem;
  }

  .xl\\:-mt-92{
    margin-top: -23rem;
  }

  .xl\\:-mr-92{
    margin-right: -23rem;
  }

  .xl\\:-mb-92{
    margin-bottom: -23rem;
  }

  .xl\\:-ml-92{
    margin-left: -23rem;
  }

  .xl\\:-mt-96{
    margin-top: -24rem;
  }

  .xl\\:-mr-96{
    margin-right: -24rem;
  }

  .xl\\:-mb-96{
    margin-bottom: -24rem;
  }

  .xl\\:-ml-96{
    margin-left: -24rem;
  }

  .xl\\:-mt-98{
    margin-top: -24.5rem;
  }

  .xl\\:-mr-98{
    margin-right: -24.5rem;
  }

  .xl\\:-mb-98{
    margin-bottom: -24.5rem;
  }

  .xl\\:-ml-98{
    margin-left: -24.5rem;
  }

  .xl\\:-mt-100{
    margin-top: -25rem;
  }

  .xl\\:-mr-100{
    margin-right: -25rem;
  }

  .xl\\:-mb-100{
    margin-bottom: -25rem;
  }

  .xl\\:-ml-100{
    margin-left: -25rem;
  }

  .xl\\:-mt-104{
    margin-top: -26rem;
  }

  .xl\\:-mr-104{
    margin-right: -26rem;
  }

  .xl\\:-mb-104{
    margin-bottom: -26rem;
  }

  .xl\\:-ml-104{
    margin-left: -26rem;
  }

  .xl\\:-mt-112{
    margin-top: -28rem;
  }

  .xl\\:-mr-112{
    margin-right: -28rem;
  }

  .xl\\:-mb-112{
    margin-bottom: -28rem;
  }

  .xl\\:-ml-112{
    margin-left: -28rem;
  }

  .xl\\:-mt-124{
    margin-top: -31rem;
  }

  .xl\\:-mr-124{
    margin-right: -31rem;
  }

  .xl\\:-mb-124{
    margin-bottom: -31rem;
  }

  .xl\\:-ml-124{
    margin-left: -31rem;
  }

  .xl\\:-mt-128{
    margin-top: -32rem;
  }

  .xl\\:-mr-128{
    margin-right: -32rem;
  }

  .xl\\:-mb-128{
    margin-bottom: -32rem;
  }

  .xl\\:-ml-128{
    margin-left: -32rem;
  }

  .xl\\:-mt-140{
    margin-top: -35rem;
  }

  .xl\\:-mr-140{
    margin-right: -35rem;
  }

  .xl\\:-mb-140{
    margin-bottom: -35rem;
  }

  .xl\\:-ml-140{
    margin-left: -35rem;
  }

  .xl\\:-mt-152{
    margin-top: -38rem;
  }

  .xl\\:-mr-152{
    margin-right: -38rem;
  }

  .xl\\:-mb-152{
    margin-bottom: -38rem;
  }

  .xl\\:-ml-152{
    margin-left: -38rem;
  }

  .xl\\:-mt-160{
    margin-top: -40rem;
  }

  .xl\\:-mr-160{
    margin-right: -40rem;
  }

  .xl\\:-mb-160{
    margin-bottom: -40rem;
  }

  .xl\\:-ml-160{
    margin-left: -40rem;
  }

  .xl\\:-mt-162{
    margin-top: -41rem;
  }

  .xl\\:-mr-162{
    margin-right: -41rem;
  }

  .xl\\:-mb-162{
    margin-bottom: -41rem;
  }

  .xl\\:-ml-162{
    margin-left: -41rem;
  }

  .xl\\:-mt-192{
    margin-top: -48rem;
  }

  .xl\\:-mr-192{
    margin-right: -48rem;
  }

  .xl\\:-mb-192{
    margin-bottom: -48rem;
  }

  .xl\\:-ml-192{
    margin-left: -48rem;
  }

  .xl\\:-mt-208{
    margin-top: -52rem;
  }

  .xl\\:-mr-208{
    margin-right: -52rem;
  }

  .xl\\:-mb-208{
    margin-bottom: -52rem;
  }

  .xl\\:-ml-208{
    margin-left: -52rem;
  }

  .xl\\:-mt-224{
    margin-top: -56rem;
  }

  .xl\\:-mr-224{
    margin-right: -56rem;
  }

  .xl\\:-mb-224{
    margin-bottom: -56rem;
  }

  .xl\\:-ml-224{
    margin-left: -56rem;
  }

  .xl\\:-mt-256{
    margin-top: -64rem;
  }

  .xl\\:-mr-256{
    margin-right: -64rem;
  }

  .xl\\:-mb-256{
    margin-bottom: -64rem;
  }

  .xl\\:-ml-256{
    margin-left: -64rem;
  }

  .xl\\:-mt-px{
    margin-top: -1px;
  }

  .xl\\:-mr-px{
    margin-right: -1px;
  }

  .xl\\:-mb-px{
    margin-bottom: -1px;
  }

  .xl\\:-ml-px{
    margin-left: -1px;
  }

  .xl\\:first\\:m-0:first-child{
    margin: 0;
  }

  .xl\\:first\\:m-1:first-child{
    margin: 0.25rem;
  }

  .xl\\:first\\:m-2:first-child{
    margin: 0.5rem;
  }

  .xl\\:first\\:m-3:first-child{
    margin: 0.75rem;
  }

  .xl\\:first\\:m-4:first-child{
    margin: 1rem;
  }

  .xl\\:first\\:m-5:first-child{
    margin: 1.25rem;
  }

  .xl\\:first\\:m-6:first-child{
    margin: 1.5rem;
  }

  .xl\\:first\\:m-7:first-child{
    margin: 1.75rem;
  }

  .xl\\:first\\:m-8:first-child{
    margin: 2rem;
  }

  .xl\\:first\\:m-9:first-child{
    margin: 2.25rem;
  }

  .xl\\:first\\:m-10:first-child{
    margin: 2.5rem;
  }

  .xl\\:first\\:m-11:first-child{
    margin: 2.75rem;
  }

  .xl\\:first\\:m-12:first-child{
    margin: 3rem;
  }

  .xl\\:first\\:m-14:first-child{
    margin: 3.5rem;
  }

  .xl\\:first\\:m-15:first-child{
    margin: 3.75rem;
  }

  .xl\\:first\\:m-16:first-child{
    margin: 4rem;
  }

  .xl\\:first\\:m-18:first-child{
    margin: 4.5rem;
  }

  .xl\\:first\\:m-20:first-child{
    margin: 5rem;
  }

  .xl\\:first\\:m-22:first-child{
    margin: 5.5rem;
  }

  .xl\\:first\\:m-23:first-child{
    margin: 5.75rem;
  }

  .xl\\:first\\:m-24:first-child{
    margin: 6rem;
  }

  .xl\\:first\\:m-25:first-child{
    margin: 6.25rem;
  }

  .xl\\:first\\:m-26:first-child{
    margin: 6.5rem;
  }

  .xl\\:first\\:m-28:first-child{
    margin: 7rem;
  }

  .xl\\:first\\:m-30:first-child{
    margin: 7.5rem;
  }

  .xl\\:first\\:m-32:first-child{
    margin: 8rem;
  }

  .xl\\:first\\:m-34:first-child{
    margin: 8.5rem;
  }

  .xl\\:first\\:m-40:first-child{
    margin: 10rem;
  }

  .xl\\:first\\:m-42:first-child{
    margin: 10.5rem;
  }

  .xl\\:first\\:m-44:first-child{
    margin: 11rem;
  }

  .xl\\:first\\:m-48:first-child{
    margin: 12rem;
  }

  .xl\\:first\\:m-52:first-child{
    margin: 13rem;
  }

  .xl\\:first\\:m-54:first-child{
    margin: 13.5rem;
  }

  .xl\\:first\\:m-56:first-child{
    margin: 14rem;
  }

  .xl\\:first\\:m-60:first-child{
    margin: 15rem;
  }

  .xl\\:first\\:m-64:first-child{
    margin: 16rem;
  }

  .xl\\:first\\:m-68:first-child{
    margin: 17rem;
  }

  .xl\\:first\\:m-72:first-child{
    margin: 18rem;
  }

  .xl\\:first\\:m-74:first-child{
    margin: 18.5rem;
  }

  .xl\\:first\\:m-76:first-child{
    margin: 19rem;
  }

  .xl\\:first\\:m-78:first-child{
    margin: 19.5rem;
  }

  .xl\\:first\\:m-80:first-child{
    margin: 20rem;
  }

  .xl\\:first\\:m-82:first-child{
    margin: 20.5rem;
  }

  .xl\\:first\\:m-84:first-child{
    margin: 21rem;
  }

  .xl\\:first\\:m-88:first-child{
    margin: 22rem;
  }

  .xl\\:first\\:m-92:first-child{
    margin: 23rem;
  }

  .xl\\:first\\:m-96:first-child{
    margin: 24rem;
  }

  .xl\\:first\\:m-98:first-child{
    margin: 24.5rem;
  }

  .xl\\:first\\:m-100:first-child{
    margin: 25rem;
  }

  .xl\\:first\\:m-104:first-child{
    margin: 26rem;
  }

  .xl\\:first\\:m-112:first-child{
    margin: 28rem;
  }

  .xl\\:first\\:m-124:first-child{
    margin: 31rem;
  }

  .xl\\:first\\:m-128:first-child{
    margin: 32rem;
  }

  .xl\\:first\\:m-140:first-child{
    margin: 35rem;
  }

  .xl\\:first\\:m-152:first-child{
    margin: 38rem;
  }

  .xl\\:first\\:m-160:first-child{
    margin: 40rem;
  }

  .xl\\:first\\:m-162:first-child{
    margin: 41rem;
  }

  .xl\\:first\\:m-192:first-child{
    margin: 48rem;
  }

  .xl\\:first\\:m-208:first-child{
    margin: 52rem;
  }

  .xl\\:first\\:m-224:first-child{
    margin: 56rem;
  }

  .xl\\:first\\:m-256:first-child{
    margin: 64rem;
  }

  .xl\\:first\\:m-auto:first-child{
    margin: auto;
  }

  .xl\\:first\\:m-px:first-child{
    margin: 1px;
  }

  .xl\\:first\\:-m-1:first-child{
    margin: -0.25rem;
  }

  .xl\\:first\\:-m-2:first-child{
    margin: -0.5rem;
  }

  .xl\\:first\\:-m-3:first-child{
    margin: -0.75rem;
  }

  .xl\\:first\\:-m-4:first-child{
    margin: -1rem;
  }

  .xl\\:first\\:-m-5:first-child{
    margin: -1.25rem;
  }

  .xl\\:first\\:-m-6:first-child{
    margin: -1.5rem;
  }

  .xl\\:first\\:-m-7:first-child{
    margin: -1.75rem;
  }

  .xl\\:first\\:-m-8:first-child{
    margin: -2rem;
  }

  .xl\\:first\\:-m-9:first-child{
    margin: -2.25rem;
  }

  .xl\\:first\\:-m-10:first-child{
    margin: -2.5rem;
  }

  .xl\\:first\\:-m-11:first-child{
    margin: -2.75rem;
  }

  .xl\\:first\\:-m-12:first-child{
    margin: -3rem;
  }

  .xl\\:first\\:-m-14:first-child{
    margin: -3.5rem;
  }

  .xl\\:first\\:-m-15:first-child{
    margin: -3.75rem;
  }

  .xl\\:first\\:-m-16:first-child{
    margin: -4rem;
  }

  .xl\\:first\\:-m-18:first-child{
    margin: -4.5rem;
  }

  .xl\\:first\\:-m-20:first-child{
    margin: -5rem;
  }

  .xl\\:first\\:-m-22:first-child{
    margin: -5.5rem;
  }

  .xl\\:first\\:-m-23:first-child{
    margin: -5.75rem;
  }

  .xl\\:first\\:-m-24:first-child{
    margin: -6rem;
  }

  .xl\\:first\\:-m-25:first-child{
    margin: -6.25rem;
  }

  .xl\\:first\\:-m-26:first-child{
    margin: -6.5rem;
  }

  .xl\\:first\\:-m-28:first-child{
    margin: -7rem;
  }

  .xl\\:first\\:-m-30:first-child{
    margin: -7.5rem;
  }

  .xl\\:first\\:-m-32:first-child{
    margin: -8rem;
  }

  .xl\\:first\\:-m-34:first-child{
    margin: -8.5rem;
  }

  .xl\\:first\\:-m-40:first-child{
    margin: -10rem;
  }

  .xl\\:first\\:-m-42:first-child{
    margin: -10.5rem;
  }

  .xl\\:first\\:-m-44:first-child{
    margin: -11rem;
  }

  .xl\\:first\\:-m-48:first-child{
    margin: -12rem;
  }

  .xl\\:first\\:-m-52:first-child{
    margin: -13rem;
  }

  .xl\\:first\\:-m-54:first-child{
    margin: -13.5rem;
  }

  .xl\\:first\\:-m-56:first-child{
    margin: -14rem;
  }

  .xl\\:first\\:-m-60:first-child{
    margin: -15rem;
  }

  .xl\\:first\\:-m-64:first-child{
    margin: -16rem;
  }

  .xl\\:first\\:-m-68:first-child{
    margin: -17rem;
  }

  .xl\\:first\\:-m-72:first-child{
    margin: -18rem;
  }

  .xl\\:first\\:-m-74:first-child{
    margin: -18.5rem;
  }

  .xl\\:first\\:-m-76:first-child{
    margin: -19rem;
  }

  .xl\\:first\\:-m-78:first-child{
    margin: -19.5rem;
  }

  .xl\\:first\\:-m-80:first-child{
    margin: -20rem;
  }

  .xl\\:first\\:-m-82:first-child{
    margin: -20.5rem;
  }

  .xl\\:first\\:-m-84:first-child{
    margin: -21rem;
  }

  .xl\\:first\\:-m-88:first-child{
    margin: -22rem;
  }

  .xl\\:first\\:-m-92:first-child{
    margin: -23rem;
  }

  .xl\\:first\\:-m-96:first-child{
    margin: -24rem;
  }

  .xl\\:first\\:-m-98:first-child{
    margin: -24.5rem;
  }

  .xl\\:first\\:-m-100:first-child{
    margin: -25rem;
  }

  .xl\\:first\\:-m-104:first-child{
    margin: -26rem;
  }

  .xl\\:first\\:-m-112:first-child{
    margin: -28rem;
  }

  .xl\\:first\\:-m-124:first-child{
    margin: -31rem;
  }

  .xl\\:first\\:-m-128:first-child{
    margin: -32rem;
  }

  .xl\\:first\\:-m-140:first-child{
    margin: -35rem;
  }

  .xl\\:first\\:-m-152:first-child{
    margin: -38rem;
  }

  .xl\\:first\\:-m-160:first-child{
    margin: -40rem;
  }

  .xl\\:first\\:-m-162:first-child{
    margin: -41rem;
  }

  .xl\\:first\\:-m-192:first-child{
    margin: -48rem;
  }

  .xl\\:first\\:-m-208:first-child{
    margin: -52rem;
  }

  .xl\\:first\\:-m-224:first-child{
    margin: -56rem;
  }

  .xl\\:first\\:-m-256:first-child{
    margin: -64rem;
  }

  .xl\\:first\\:-m-px:first-child{
    margin: -1px;
  }

  .xl\\:first\\:my-0:first-child{
    margin-top: 0;
    margin-bottom: 0;
  }

  .xl\\:first\\:mx-0:first-child{
    margin-left: 0;
    margin-right: 0;
  }

  .xl\\:first\\:my-1:first-child{
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .xl\\:first\\:mx-1:first-child{
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .xl\\:first\\:my-2:first-child{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .xl\\:first\\:mx-2:first-child{
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .xl\\:first\\:my-3:first-child{
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .xl\\:first\\:mx-3:first-child{
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .xl\\:first\\:my-4:first-child{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .xl\\:first\\:mx-4:first-child{
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .xl\\:first\\:my-5:first-child{
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .xl\\:first\\:mx-5:first-child{
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .xl\\:first\\:my-6:first-child{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .xl\\:first\\:mx-6:first-child{
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .xl\\:first\\:my-7:first-child{
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }

  .xl\\:first\\:mx-7:first-child{
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }

  .xl\\:first\\:my-8:first-child{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .xl\\:first\\:mx-8:first-child{
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .xl\\:first\\:my-9:first-child{
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }

  .xl\\:first\\:mx-9:first-child{
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }

  .xl\\:first\\:my-10:first-child{
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .xl\\:first\\:mx-10:first-child{
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .xl\\:first\\:my-11:first-child{
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;
  }

  .xl\\:first\\:mx-11:first-child{
    margin-left: 2.75rem;
    margin-right: 2.75rem;
  }

  .xl\\:first\\:my-12:first-child{
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .xl\\:first\\:mx-12:first-child{
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .xl\\:first\\:my-14:first-child{
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
  }

  .xl\\:first\\:mx-14:first-child{
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }

  .xl\\:first\\:my-15:first-child{
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
  }

  .xl\\:first\\:mx-15:first-child{
    margin-left: 3.75rem;
    margin-right: 3.75rem;
  }

  .xl\\:first\\:my-16:first-child{
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .xl\\:first\\:mx-16:first-child{
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .xl\\:first\\:my-18:first-child{
    margin-top: 4.5rem;
    margin-bottom: 4.5rem;
  }

  .xl\\:first\\:mx-18:first-child{
    margin-left: 4.5rem;
    margin-right: 4.5rem;
  }

  .xl\\:first\\:my-20:first-child{
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .xl\\:first\\:mx-20:first-child{
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .xl\\:first\\:my-22:first-child{
    margin-top: 5.5rem;
    margin-bottom: 5.5rem;
  }

  .xl\\:first\\:mx-22:first-child{
    margin-left: 5.5rem;
    margin-right: 5.5rem;
  }

  .xl\\:first\\:my-23:first-child{
    margin-top: 5.75rem;
    margin-bottom: 5.75rem;
  }

  .xl\\:first\\:mx-23:first-child{
    margin-left: 5.75rem;
    margin-right: 5.75rem;
  }

  .xl\\:first\\:my-24:first-child{
    margin-top: 6rem;
    margin-bottom: 6rem;
  }

  .xl\\:first\\:mx-24:first-child{
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .xl\\:first\\:my-25:first-child{
    margin-top: 6.25rem;
    margin-bottom: 6.25rem;
  }

  .xl\\:first\\:mx-25:first-child{
    margin-left: 6.25rem;
    margin-right: 6.25rem;
  }

  .xl\\:first\\:my-26:first-child{
    margin-top: 6.5rem;
    margin-bottom: 6.5rem;
  }

  .xl\\:first\\:mx-26:first-child{
    margin-left: 6.5rem;
    margin-right: 6.5rem;
  }

  .xl\\:first\\:my-28:first-child{
    margin-top: 7rem;
    margin-bottom: 7rem;
  }

  .xl\\:first\\:mx-28:first-child{
    margin-left: 7rem;
    margin-right: 7rem;
  }

  .xl\\:first\\:my-30:first-child{
    margin-top: 7.5rem;
    margin-bottom: 7.5rem;
  }

  .xl\\:first\\:mx-30:first-child{
    margin-left: 7.5rem;
    margin-right: 7.5rem;
  }

  .xl\\:first\\:my-32:first-child{
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  .xl\\:first\\:mx-32:first-child{
    margin-left: 8rem;
    margin-right: 8rem;
  }

  .xl\\:first\\:my-34:first-child{
    margin-top: 8.5rem;
    margin-bottom: 8.5rem;
  }

  .xl\\:first\\:mx-34:first-child{
    margin-left: 8.5rem;
    margin-right: 8.5rem;
  }

  .xl\\:first\\:my-40:first-child{
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .xl\\:first\\:mx-40:first-child{
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .xl\\:first\\:my-42:first-child{
    margin-top: 10.5rem;
    margin-bottom: 10.5rem;
  }

  .xl\\:first\\:mx-42:first-child{
    margin-left: 10.5rem;
    margin-right: 10.5rem;
  }

  .xl\\:first\\:my-44:first-child{
    margin-top: 11rem;
    margin-bottom: 11rem;
  }

  .xl\\:first\\:mx-44:first-child{
    margin-left: 11rem;
    margin-right: 11rem;
  }

  .xl\\:first\\:my-48:first-child{
    margin-top: 12rem;
    margin-bottom: 12rem;
  }

  .xl\\:first\\:mx-48:first-child{
    margin-left: 12rem;
    margin-right: 12rem;
  }

  .xl\\:first\\:my-52:first-child{
    margin-top: 13rem;
    margin-bottom: 13rem;
  }

  .xl\\:first\\:mx-52:first-child{
    margin-left: 13rem;
    margin-right: 13rem;
  }

  .xl\\:first\\:my-54:first-child{
    margin-top: 13.5rem;
    margin-bottom: 13.5rem;
  }

  .xl\\:first\\:mx-54:first-child{
    margin-left: 13.5rem;
    margin-right: 13.5rem;
  }

  .xl\\:first\\:my-56:first-child{
    margin-top: 14rem;
    margin-bottom: 14rem;
  }

  .xl\\:first\\:mx-56:first-child{
    margin-left: 14rem;
    margin-right: 14rem;
  }

  .xl\\:first\\:my-60:first-child{
    margin-top: 15rem;
    margin-bottom: 15rem;
  }

  .xl\\:first\\:mx-60:first-child{
    margin-left: 15rem;
    margin-right: 15rem;
  }

  .xl\\:first\\:my-64:first-child{
    margin-top: 16rem;
    margin-bottom: 16rem;
  }

  .xl\\:first\\:mx-64:first-child{
    margin-left: 16rem;
    margin-right: 16rem;
  }

  .xl\\:first\\:my-68:first-child{
    margin-top: 17rem;
    margin-bottom: 17rem;
  }

  .xl\\:first\\:mx-68:first-child{
    margin-left: 17rem;
    margin-right: 17rem;
  }

  .xl\\:first\\:my-72:first-child{
    margin-top: 18rem;
    margin-bottom: 18rem;
  }

  .xl\\:first\\:mx-72:first-child{
    margin-left: 18rem;
    margin-right: 18rem;
  }

  .xl\\:first\\:my-74:first-child{
    margin-top: 18.5rem;
    margin-bottom: 18.5rem;
  }

  .xl\\:first\\:mx-74:first-child{
    margin-left: 18.5rem;
    margin-right: 18.5rem;
  }

  .xl\\:first\\:my-76:first-child{
    margin-top: 19rem;
    margin-bottom: 19rem;
  }

  .xl\\:first\\:mx-76:first-child{
    margin-left: 19rem;
    margin-right: 19rem;
  }

  .xl\\:first\\:my-78:first-child{
    margin-top: 19.5rem;
    margin-bottom: 19.5rem;
  }

  .xl\\:first\\:mx-78:first-child{
    margin-left: 19.5rem;
    margin-right: 19.5rem;
  }

  .xl\\:first\\:my-80:first-child{
    margin-top: 20rem;
    margin-bottom: 20rem;
  }

  .xl\\:first\\:mx-80:first-child{
    margin-left: 20rem;
    margin-right: 20rem;
  }

  .xl\\:first\\:my-82:first-child{
    margin-top: 20.5rem;
    margin-bottom: 20.5rem;
  }

  .xl\\:first\\:mx-82:first-child{
    margin-left: 20.5rem;
    margin-right: 20.5rem;
  }

  .xl\\:first\\:my-84:first-child{
    margin-top: 21rem;
    margin-bottom: 21rem;
  }

  .xl\\:first\\:mx-84:first-child{
    margin-left: 21rem;
    margin-right: 21rem;
  }

  .xl\\:first\\:my-88:first-child{
    margin-top: 22rem;
    margin-bottom: 22rem;
  }

  .xl\\:first\\:mx-88:first-child{
    margin-left: 22rem;
    margin-right: 22rem;
  }

  .xl\\:first\\:my-92:first-child{
    margin-top: 23rem;
    margin-bottom: 23rem;
  }

  .xl\\:first\\:mx-92:first-child{
    margin-left: 23rem;
    margin-right: 23rem;
  }

  .xl\\:first\\:my-96:first-child{
    margin-top: 24rem;
    margin-bottom: 24rem;
  }

  .xl\\:first\\:mx-96:first-child{
    margin-left: 24rem;
    margin-right: 24rem;
  }

  .xl\\:first\\:my-98:first-child{
    margin-top: 24.5rem;
    margin-bottom: 24.5rem;
  }

  .xl\\:first\\:mx-98:first-child{
    margin-left: 24.5rem;
    margin-right: 24.5rem;
  }

  .xl\\:first\\:my-100:first-child{
    margin-top: 25rem;
    margin-bottom: 25rem;
  }

  .xl\\:first\\:mx-100:first-child{
    margin-left: 25rem;
    margin-right: 25rem;
  }

  .xl\\:first\\:my-104:first-child{
    margin-top: 26rem;
    margin-bottom: 26rem;
  }

  .xl\\:first\\:mx-104:first-child{
    margin-left: 26rem;
    margin-right: 26rem;
  }

  .xl\\:first\\:my-112:first-child{
    margin-top: 28rem;
    margin-bottom: 28rem;
  }

  .xl\\:first\\:mx-112:first-child{
    margin-left: 28rem;
    margin-right: 28rem;
  }

  .xl\\:first\\:my-124:first-child{
    margin-top: 31rem;
    margin-bottom: 31rem;
  }

  .xl\\:first\\:mx-124:first-child{
    margin-left: 31rem;
    margin-right: 31rem;
  }

  .xl\\:first\\:my-128:first-child{
    margin-top: 32rem;
    margin-bottom: 32rem;
  }

  .xl\\:first\\:mx-128:first-child{
    margin-left: 32rem;
    margin-right: 32rem;
  }

  .xl\\:first\\:my-140:first-child{
    margin-top: 35rem;
    margin-bottom: 35rem;
  }

  .xl\\:first\\:mx-140:first-child{
    margin-left: 35rem;
    margin-right: 35rem;
  }

  .xl\\:first\\:my-152:first-child{
    margin-top: 38rem;
    margin-bottom: 38rem;
  }

  .xl\\:first\\:mx-152:first-child{
    margin-left: 38rem;
    margin-right: 38rem;
  }

  .xl\\:first\\:my-160:first-child{
    margin-top: 40rem;
    margin-bottom: 40rem;
  }

  .xl\\:first\\:mx-160:first-child{
    margin-left: 40rem;
    margin-right: 40rem;
  }

  .xl\\:first\\:my-162:first-child{
    margin-top: 41rem;
    margin-bottom: 41rem;
  }

  .xl\\:first\\:mx-162:first-child{
    margin-left: 41rem;
    margin-right: 41rem;
  }

  .xl\\:first\\:my-192:first-child{
    margin-top: 48rem;
    margin-bottom: 48rem;
  }

  .xl\\:first\\:mx-192:first-child{
    margin-left: 48rem;
    margin-right: 48rem;
  }

  .xl\\:first\\:my-208:first-child{
    margin-top: 52rem;
    margin-bottom: 52rem;
  }

  .xl\\:first\\:mx-208:first-child{
    margin-left: 52rem;
    margin-right: 52rem;
  }

  .xl\\:first\\:my-224:first-child{
    margin-top: 56rem;
    margin-bottom: 56rem;
  }

  .xl\\:first\\:mx-224:first-child{
    margin-left: 56rem;
    margin-right: 56rem;
  }

  .xl\\:first\\:my-256:first-child{
    margin-top: 64rem;
    margin-bottom: 64rem;
  }

  .xl\\:first\\:mx-256:first-child{
    margin-left: 64rem;
    margin-right: 64rem;
  }

  .xl\\:first\\:my-auto:first-child{
    margin-top: auto;
    margin-bottom: auto;
  }

  .xl\\:first\\:mx-auto:first-child{
    margin-left: auto;
    margin-right: auto;
  }

  .xl\\:first\\:my-px:first-child{
    margin-top: 1px;
    margin-bottom: 1px;
  }

  .xl\\:first\\:mx-px:first-child{
    margin-left: 1px;
    margin-right: 1px;
  }

  .xl\\:first\\:-my-1:first-child{
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .xl\\:first\\:-mx-1:first-child{
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .xl\\:first\\:-my-2:first-child{
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }

  .xl\\:first\\:-mx-2:first-child{
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .xl\\:first\\:-my-3:first-child{
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }

  .xl\\:first\\:-mx-3:first-child{
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .xl\\:first\\:-my-4:first-child{
    margin-top: -1rem;
    margin-bottom: -1rem;
  }

  .xl\\:first\\:-mx-4:first-child{
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .xl\\:first\\:-my-5:first-child{
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }

  .xl\\:first\\:-mx-5:first-child{
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .xl\\:first\\:-my-6:first-child{
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }

  .xl\\:first\\:-mx-6:first-child{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .xl\\:first\\:-my-7:first-child{
    margin-top: -1.75rem;
    margin-bottom: -1.75rem;
  }

  .xl\\:first\\:-mx-7:first-child{
    margin-left: -1.75rem;
    margin-right: -1.75rem;
  }

  .xl\\:first\\:-my-8:first-child{
    margin-top: -2rem;
    margin-bottom: -2rem;
  }

  .xl\\:first\\:-mx-8:first-child{
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .xl\\:first\\:-my-9:first-child{
    margin-top: -2.25rem;
    margin-bottom: -2.25rem;
  }

  .xl\\:first\\:-mx-9:first-child{
    margin-left: -2.25rem;
    margin-right: -2.25rem;
  }

  .xl\\:first\\:-my-10:first-child{
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }

  .xl\\:first\\:-mx-10:first-child{
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .xl\\:first\\:-my-11:first-child{
    margin-top: -2.75rem;
    margin-bottom: -2.75rem;
  }

  .xl\\:first\\:-mx-11:first-child{
    margin-left: -2.75rem;
    margin-right: -2.75rem;
  }

  .xl\\:first\\:-my-12:first-child{
    margin-top: -3rem;
    margin-bottom: -3rem;
  }

  .xl\\:first\\:-mx-12:first-child{
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .xl\\:first\\:-my-14:first-child{
    margin-top: -3.5rem;
    margin-bottom: -3.5rem;
  }

  .xl\\:first\\:-mx-14:first-child{
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }

  .xl\\:first\\:-my-15:first-child{
    margin-top: -3.75rem;
    margin-bottom: -3.75rem;
  }

  .xl\\:first\\:-mx-15:first-child{
    margin-left: -3.75rem;
    margin-right: -3.75rem;
  }

  .xl\\:first\\:-my-16:first-child{
    margin-top: -4rem;
    margin-bottom: -4rem;
  }

  .xl\\:first\\:-mx-16:first-child{
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .xl\\:first\\:-my-18:first-child{
    margin-top: -4.5rem;
    margin-bottom: -4.5rem;
  }

  .xl\\:first\\:-mx-18:first-child{
    margin-left: -4.5rem;
    margin-right: -4.5rem;
  }

  .xl\\:first\\:-my-20:first-child{
    margin-top: -5rem;
    margin-bottom: -5rem;
  }

  .xl\\:first\\:-mx-20:first-child{
    margin-left: -5rem;
    margin-right: -5rem;
  }

  .xl\\:first\\:-my-22:first-child{
    margin-top: -5.5rem;
    margin-bottom: -5.5rem;
  }

  .xl\\:first\\:-mx-22:first-child{
    margin-left: -5.5rem;
    margin-right: -5.5rem;
  }

  .xl\\:first\\:-my-23:first-child{
    margin-top: -5.75rem;
    margin-bottom: -5.75rem;
  }

  .xl\\:first\\:-mx-23:first-child{
    margin-left: -5.75rem;
    margin-right: -5.75rem;
  }

  .xl\\:first\\:-my-24:first-child{
    margin-top: -6rem;
    margin-bottom: -6rem;
  }

  .xl\\:first\\:-mx-24:first-child{
    margin-left: -6rem;
    margin-right: -6rem;
  }

  .xl\\:first\\:-my-25:first-child{
    margin-top: -6.25rem;
    margin-bottom: -6.25rem;
  }

  .xl\\:first\\:-mx-25:first-child{
    margin-left: -6.25rem;
    margin-right: -6.25rem;
  }

  .xl\\:first\\:-my-26:first-child{
    margin-top: -6.5rem;
    margin-bottom: -6.5rem;
  }

  .xl\\:first\\:-mx-26:first-child{
    margin-left: -6.5rem;
    margin-right: -6.5rem;
  }

  .xl\\:first\\:-my-28:first-child{
    margin-top: -7rem;
    margin-bottom: -7rem;
  }

  .xl\\:first\\:-mx-28:first-child{
    margin-left: -7rem;
    margin-right: -7rem;
  }

  .xl\\:first\\:-my-30:first-child{
    margin-top: -7.5rem;
    margin-bottom: -7.5rem;
  }

  .xl\\:first\\:-mx-30:first-child{
    margin-left: -7.5rem;
    margin-right: -7.5rem;
  }

  .xl\\:first\\:-my-32:first-child{
    margin-top: -8rem;
    margin-bottom: -8rem;
  }

  .xl\\:first\\:-mx-32:first-child{
    margin-left: -8rem;
    margin-right: -8rem;
  }

  .xl\\:first\\:-my-34:first-child{
    margin-top: -8.5rem;
    margin-bottom: -8.5rem;
  }

  .xl\\:first\\:-mx-34:first-child{
    margin-left: -8.5rem;
    margin-right: -8.5rem;
  }

  .xl\\:first\\:-my-40:first-child{
    margin-top: -10rem;
    margin-bottom: -10rem;
  }

  .xl\\:first\\:-mx-40:first-child{
    margin-left: -10rem;
    margin-right: -10rem;
  }

  .xl\\:first\\:-my-42:first-child{
    margin-top: -10.5rem;
    margin-bottom: -10.5rem;
  }

  .xl\\:first\\:-mx-42:first-child{
    margin-left: -10.5rem;
    margin-right: -10.5rem;
  }

  .xl\\:first\\:-my-44:first-child{
    margin-top: -11rem;
    margin-bottom: -11rem;
  }

  .xl\\:first\\:-mx-44:first-child{
    margin-left: -11rem;
    margin-right: -11rem;
  }

  .xl\\:first\\:-my-48:first-child{
    margin-top: -12rem;
    margin-bottom: -12rem;
  }

  .xl\\:first\\:-mx-48:first-child{
    margin-left: -12rem;
    margin-right: -12rem;
  }

  .xl\\:first\\:-my-52:first-child{
    margin-top: -13rem;
    margin-bottom: -13rem;
  }

  .xl\\:first\\:-mx-52:first-child{
    margin-left: -13rem;
    margin-right: -13rem;
  }

  .xl\\:first\\:-my-54:first-child{
    margin-top: -13.5rem;
    margin-bottom: -13.5rem;
  }

  .xl\\:first\\:-mx-54:first-child{
    margin-left: -13.5rem;
    margin-right: -13.5rem;
  }

  .xl\\:first\\:-my-56:first-child{
    margin-top: -14rem;
    margin-bottom: -14rem;
  }

  .xl\\:first\\:-mx-56:first-child{
    margin-left: -14rem;
    margin-right: -14rem;
  }

  .xl\\:first\\:-my-60:first-child{
    margin-top: -15rem;
    margin-bottom: -15rem;
  }

  .xl\\:first\\:-mx-60:first-child{
    margin-left: -15rem;
    margin-right: -15rem;
  }

  .xl\\:first\\:-my-64:first-child{
    margin-top: -16rem;
    margin-bottom: -16rem;
  }

  .xl\\:first\\:-mx-64:first-child{
    margin-left: -16rem;
    margin-right: -16rem;
  }

  .xl\\:first\\:-my-68:first-child{
    margin-top: -17rem;
    margin-bottom: -17rem;
  }

  .xl\\:first\\:-mx-68:first-child{
    margin-left: -17rem;
    margin-right: -17rem;
  }

  .xl\\:first\\:-my-72:first-child{
    margin-top: -18rem;
    margin-bottom: -18rem;
  }

  .xl\\:first\\:-mx-72:first-child{
    margin-left: -18rem;
    margin-right: -18rem;
  }

  .xl\\:first\\:-my-74:first-child{
    margin-top: -18.5rem;
    margin-bottom: -18.5rem;
  }

  .xl\\:first\\:-mx-74:first-child{
    margin-left: -18.5rem;
    margin-right: -18.5rem;
  }

  .xl\\:first\\:-my-76:first-child{
    margin-top: -19rem;
    margin-bottom: -19rem;
  }

  .xl\\:first\\:-mx-76:first-child{
    margin-left: -19rem;
    margin-right: -19rem;
  }

  .xl\\:first\\:-my-78:first-child{
    margin-top: -19.5rem;
    margin-bottom: -19.5rem;
  }

  .xl\\:first\\:-mx-78:first-child{
    margin-left: -19.5rem;
    margin-right: -19.5rem;
  }

  .xl\\:first\\:-my-80:first-child{
    margin-top: -20rem;
    margin-bottom: -20rem;
  }

  .xl\\:first\\:-mx-80:first-child{
    margin-left: -20rem;
    margin-right: -20rem;
  }

  .xl\\:first\\:-my-82:first-child{
    margin-top: -20.5rem;
    margin-bottom: -20.5rem;
  }

  .xl\\:first\\:-mx-82:first-child{
    margin-left: -20.5rem;
    margin-right: -20.5rem;
  }

  .xl\\:first\\:-my-84:first-child{
    margin-top: -21rem;
    margin-bottom: -21rem;
  }

  .xl\\:first\\:-mx-84:first-child{
    margin-left: -21rem;
    margin-right: -21rem;
  }

  .xl\\:first\\:-my-88:first-child{
    margin-top: -22rem;
    margin-bottom: -22rem;
  }

  .xl\\:first\\:-mx-88:first-child{
    margin-left: -22rem;
    margin-right: -22rem;
  }

  .xl\\:first\\:-my-92:first-child{
    margin-top: -23rem;
    margin-bottom: -23rem;
  }

  .xl\\:first\\:-mx-92:first-child{
    margin-left: -23rem;
    margin-right: -23rem;
  }

  .xl\\:first\\:-my-96:first-child{
    margin-top: -24rem;
    margin-bottom: -24rem;
  }

  .xl\\:first\\:-mx-96:first-child{
    margin-left: -24rem;
    margin-right: -24rem;
  }

  .xl\\:first\\:-my-98:first-child{
    margin-top: -24.5rem;
    margin-bottom: -24.5rem;
  }

  .xl\\:first\\:-mx-98:first-child{
    margin-left: -24.5rem;
    margin-right: -24.5rem;
  }

  .xl\\:first\\:-my-100:first-child{
    margin-top: -25rem;
    margin-bottom: -25rem;
  }

  .xl\\:first\\:-mx-100:first-child{
    margin-left: -25rem;
    margin-right: -25rem;
  }

  .xl\\:first\\:-my-104:first-child{
    margin-top: -26rem;
    margin-bottom: -26rem;
  }

  .xl\\:first\\:-mx-104:first-child{
    margin-left: -26rem;
    margin-right: -26rem;
  }

  .xl\\:first\\:-my-112:first-child{
    margin-top: -28rem;
    margin-bottom: -28rem;
  }

  .xl\\:first\\:-mx-112:first-child{
    margin-left: -28rem;
    margin-right: -28rem;
  }

  .xl\\:first\\:-my-124:first-child{
    margin-top: -31rem;
    margin-bottom: -31rem;
  }

  .xl\\:first\\:-mx-124:first-child{
    margin-left: -31rem;
    margin-right: -31rem;
  }

  .xl\\:first\\:-my-128:first-child{
    margin-top: -32rem;
    margin-bottom: -32rem;
  }

  .xl\\:first\\:-mx-128:first-child{
    margin-left: -32rem;
    margin-right: -32rem;
  }

  .xl\\:first\\:-my-140:first-child{
    margin-top: -35rem;
    margin-bottom: -35rem;
  }

  .xl\\:first\\:-mx-140:first-child{
    margin-left: -35rem;
    margin-right: -35rem;
  }

  .xl\\:first\\:-my-152:first-child{
    margin-top: -38rem;
    margin-bottom: -38rem;
  }

  .xl\\:first\\:-mx-152:first-child{
    margin-left: -38rem;
    margin-right: -38rem;
  }

  .xl\\:first\\:-my-160:first-child{
    margin-top: -40rem;
    margin-bottom: -40rem;
  }

  .xl\\:first\\:-mx-160:first-child{
    margin-left: -40rem;
    margin-right: -40rem;
  }

  .xl\\:first\\:-my-162:first-child{
    margin-top: -41rem;
    margin-bottom: -41rem;
  }

  .xl\\:first\\:-mx-162:first-child{
    margin-left: -41rem;
    margin-right: -41rem;
  }

  .xl\\:first\\:-my-192:first-child{
    margin-top: -48rem;
    margin-bottom: -48rem;
  }

  .xl\\:first\\:-mx-192:first-child{
    margin-left: -48rem;
    margin-right: -48rem;
  }

  .xl\\:first\\:-my-208:first-child{
    margin-top: -52rem;
    margin-bottom: -52rem;
  }

  .xl\\:first\\:-mx-208:first-child{
    margin-left: -52rem;
    margin-right: -52rem;
  }

  .xl\\:first\\:-my-224:first-child{
    margin-top: -56rem;
    margin-bottom: -56rem;
  }

  .xl\\:first\\:-mx-224:first-child{
    margin-left: -56rem;
    margin-right: -56rem;
  }

  .xl\\:first\\:-my-256:first-child{
    margin-top: -64rem;
    margin-bottom: -64rem;
  }

  .xl\\:first\\:-mx-256:first-child{
    margin-left: -64rem;
    margin-right: -64rem;
  }

  .xl\\:first\\:-my-px:first-child{
    margin-top: -1px;
    margin-bottom: -1px;
  }

  .xl\\:first\\:-mx-px:first-child{
    margin-left: -1px;
    margin-right: -1px;
  }

  .xl\\:first\\:mt-0:first-child{
    margin-top: 0;
  }

  .xl\\:first\\:mr-0:first-child{
    margin-right: 0;
  }

  .xl\\:first\\:mb-0:first-child{
    margin-bottom: 0;
  }

  .xl\\:first\\:ml-0:first-child{
    margin-left: 0;
  }

  .xl\\:first\\:mt-1:first-child{
    margin-top: 0.25rem;
  }

  .xl\\:first\\:mr-1:first-child{
    margin-right: 0.25rem;
  }

  .xl\\:first\\:mb-1:first-child{
    margin-bottom: 0.25rem;
  }

  .xl\\:first\\:ml-1:first-child{
    margin-left: 0.25rem;
  }

  .xl\\:first\\:mt-2:first-child{
    margin-top: 0.5rem;
  }

  .xl\\:first\\:mr-2:first-child{
    margin-right: 0.5rem;
  }

  .xl\\:first\\:mb-2:first-child{
    margin-bottom: 0.5rem;
  }

  .xl\\:first\\:ml-2:first-child{
    margin-left: 0.5rem;
  }

  .xl\\:first\\:mt-3:first-child{
    margin-top: 0.75rem;
  }

  .xl\\:first\\:mr-3:first-child{
    margin-right: 0.75rem;
  }

  .xl\\:first\\:mb-3:first-child{
    margin-bottom: 0.75rem;
  }

  .xl\\:first\\:ml-3:first-child{
    margin-left: 0.75rem;
  }

  .xl\\:first\\:mt-4:first-child{
    margin-top: 1rem;
  }

  .xl\\:first\\:mr-4:first-child{
    margin-right: 1rem;
  }

  .xl\\:first\\:mb-4:first-child{
    margin-bottom: 1rem;
  }

  .xl\\:first\\:ml-4:first-child{
    margin-left: 1rem;
  }

  .xl\\:first\\:mt-5:first-child{
    margin-top: 1.25rem;
  }

  .xl\\:first\\:mr-5:first-child{
    margin-right: 1.25rem;
  }

  .xl\\:first\\:mb-5:first-child{
    margin-bottom: 1.25rem;
  }

  .xl\\:first\\:ml-5:first-child{
    margin-left: 1.25rem;
  }

  .xl\\:first\\:mt-6:first-child{
    margin-top: 1.5rem;
  }

  .xl\\:first\\:mr-6:first-child{
    margin-right: 1.5rem;
  }

  .xl\\:first\\:mb-6:first-child{
    margin-bottom: 1.5rem;
  }

  .xl\\:first\\:ml-6:first-child{
    margin-left: 1.5rem;
  }

  .xl\\:first\\:mt-7:first-child{
    margin-top: 1.75rem;
  }

  .xl\\:first\\:mr-7:first-child{
    margin-right: 1.75rem;
  }

  .xl\\:first\\:mb-7:first-child{
    margin-bottom: 1.75rem;
  }

  .xl\\:first\\:ml-7:first-child{
    margin-left: 1.75rem;
  }

  .xl\\:first\\:mt-8:first-child{
    margin-top: 2rem;
  }

  .xl\\:first\\:mr-8:first-child{
    margin-right: 2rem;
  }

  .xl\\:first\\:mb-8:first-child{
    margin-bottom: 2rem;
  }

  .xl\\:first\\:ml-8:first-child{
    margin-left: 2rem;
  }

  .xl\\:first\\:mt-9:first-child{
    margin-top: 2.25rem;
  }

  .xl\\:first\\:mr-9:first-child{
    margin-right: 2.25rem;
  }

  .xl\\:first\\:mb-9:first-child{
    margin-bottom: 2.25rem;
  }

  .xl\\:first\\:ml-9:first-child{
    margin-left: 2.25rem;
  }

  .xl\\:first\\:mt-10:first-child{
    margin-top: 2.5rem;
  }

  .xl\\:first\\:mr-10:first-child{
    margin-right: 2.5rem;
  }

  .xl\\:first\\:mb-10:first-child{
    margin-bottom: 2.5rem;
  }

  .xl\\:first\\:ml-10:first-child{
    margin-left: 2.5rem;
  }

  .xl\\:first\\:mt-11:first-child{
    margin-top: 2.75rem;
  }

  .xl\\:first\\:mr-11:first-child{
    margin-right: 2.75rem;
  }

  .xl\\:first\\:mb-11:first-child{
    margin-bottom: 2.75rem;
  }

  .xl\\:first\\:ml-11:first-child{
    margin-left: 2.75rem;
  }

  .xl\\:first\\:mt-12:first-child{
    margin-top: 3rem;
  }

  .xl\\:first\\:mr-12:first-child{
    margin-right: 3rem;
  }

  .xl\\:first\\:mb-12:first-child{
    margin-bottom: 3rem;
  }

  .xl\\:first\\:ml-12:first-child{
    margin-left: 3rem;
  }

  .xl\\:first\\:mt-14:first-child{
    margin-top: 3.5rem;
  }

  .xl\\:first\\:mr-14:first-child{
    margin-right: 3.5rem;
  }

  .xl\\:first\\:mb-14:first-child{
    margin-bottom: 3.5rem;
  }

  .xl\\:first\\:ml-14:first-child{
    margin-left: 3.5rem;
  }

  .xl\\:first\\:mt-15:first-child{
    margin-top: 3.75rem;
  }

  .xl\\:first\\:mr-15:first-child{
    margin-right: 3.75rem;
  }

  .xl\\:first\\:mb-15:first-child{
    margin-bottom: 3.75rem;
  }

  .xl\\:first\\:ml-15:first-child{
    margin-left: 3.75rem;
  }

  .xl\\:first\\:mt-16:first-child{
    margin-top: 4rem;
  }

  .xl\\:first\\:mr-16:first-child{
    margin-right: 4rem;
  }

  .xl\\:first\\:mb-16:first-child{
    margin-bottom: 4rem;
  }

  .xl\\:first\\:ml-16:first-child{
    margin-left: 4rem;
  }

  .xl\\:first\\:mt-18:first-child{
    margin-top: 4.5rem;
  }

  .xl\\:first\\:mr-18:first-child{
    margin-right: 4.5rem;
  }

  .xl\\:first\\:mb-18:first-child{
    margin-bottom: 4.5rem;
  }

  .xl\\:first\\:ml-18:first-child{
    margin-left: 4.5rem;
  }

  .xl\\:first\\:mt-20:first-child{
    margin-top: 5rem;
  }

  .xl\\:first\\:mr-20:first-child{
    margin-right: 5rem;
  }

  .xl\\:first\\:mb-20:first-child{
    margin-bottom: 5rem;
  }

  .xl\\:first\\:ml-20:first-child{
    margin-left: 5rem;
  }

  .xl\\:first\\:mt-22:first-child{
    margin-top: 5.5rem;
  }

  .xl\\:first\\:mr-22:first-child{
    margin-right: 5.5rem;
  }

  .xl\\:first\\:mb-22:first-child{
    margin-bottom: 5.5rem;
  }

  .xl\\:first\\:ml-22:first-child{
    margin-left: 5.5rem;
  }

  .xl\\:first\\:mt-23:first-child{
    margin-top: 5.75rem;
  }

  .xl\\:first\\:mr-23:first-child{
    margin-right: 5.75rem;
  }

  .xl\\:first\\:mb-23:first-child{
    margin-bottom: 5.75rem;
  }

  .xl\\:first\\:ml-23:first-child{
    margin-left: 5.75rem;
  }

  .xl\\:first\\:mt-24:first-child{
    margin-top: 6rem;
  }

  .xl\\:first\\:mr-24:first-child{
    margin-right: 6rem;
  }

  .xl\\:first\\:mb-24:first-child{
    margin-bottom: 6rem;
  }

  .xl\\:first\\:ml-24:first-child{
    margin-left: 6rem;
  }

  .xl\\:first\\:mt-25:first-child{
    margin-top: 6.25rem;
  }

  .xl\\:first\\:mr-25:first-child{
    margin-right: 6.25rem;
  }

  .xl\\:first\\:mb-25:first-child{
    margin-bottom: 6.25rem;
  }

  .xl\\:first\\:ml-25:first-child{
    margin-left: 6.25rem;
  }

  .xl\\:first\\:mt-26:first-child{
    margin-top: 6.5rem;
  }

  .xl\\:first\\:mr-26:first-child{
    margin-right: 6.5rem;
  }

  .xl\\:first\\:mb-26:first-child{
    margin-bottom: 6.5rem;
  }

  .xl\\:first\\:ml-26:first-child{
    margin-left: 6.5rem;
  }

  .xl\\:first\\:mt-28:first-child{
    margin-top: 7rem;
  }

  .xl\\:first\\:mr-28:first-child{
    margin-right: 7rem;
  }

  .xl\\:first\\:mb-28:first-child{
    margin-bottom: 7rem;
  }

  .xl\\:first\\:ml-28:first-child{
    margin-left: 7rem;
  }

  .xl\\:first\\:mt-30:first-child{
    margin-top: 7.5rem;
  }

  .xl\\:first\\:mr-30:first-child{
    margin-right: 7.5rem;
  }

  .xl\\:first\\:mb-30:first-child{
    margin-bottom: 7.5rem;
  }

  .xl\\:first\\:ml-30:first-child{
    margin-left: 7.5rem;
  }

  .xl\\:first\\:mt-32:first-child{
    margin-top: 8rem;
  }

  .xl\\:first\\:mr-32:first-child{
    margin-right: 8rem;
  }

  .xl\\:first\\:mb-32:first-child{
    margin-bottom: 8rem;
  }

  .xl\\:first\\:ml-32:first-child{
    margin-left: 8rem;
  }

  .xl\\:first\\:mt-34:first-child{
    margin-top: 8.5rem;
  }

  .xl\\:first\\:mr-34:first-child{
    margin-right: 8.5rem;
  }

  .xl\\:first\\:mb-34:first-child{
    margin-bottom: 8.5rem;
  }

  .xl\\:first\\:ml-34:first-child{
    margin-left: 8.5rem;
  }

  .xl\\:first\\:mt-40:first-child{
    margin-top: 10rem;
  }

  .xl\\:first\\:mr-40:first-child{
    margin-right: 10rem;
  }

  .xl\\:first\\:mb-40:first-child{
    margin-bottom: 10rem;
  }

  .xl\\:first\\:ml-40:first-child{
    margin-left: 10rem;
  }

  .xl\\:first\\:mt-42:first-child{
    margin-top: 10.5rem;
  }

  .xl\\:first\\:mr-42:first-child{
    margin-right: 10.5rem;
  }

  .xl\\:first\\:mb-42:first-child{
    margin-bottom: 10.5rem;
  }

  .xl\\:first\\:ml-42:first-child{
    margin-left: 10.5rem;
  }

  .xl\\:first\\:mt-44:first-child{
    margin-top: 11rem;
  }

  .xl\\:first\\:mr-44:first-child{
    margin-right: 11rem;
  }

  .xl\\:first\\:mb-44:first-child{
    margin-bottom: 11rem;
  }

  .xl\\:first\\:ml-44:first-child{
    margin-left: 11rem;
  }

  .xl\\:first\\:mt-48:first-child{
    margin-top: 12rem;
  }

  .xl\\:first\\:mr-48:first-child{
    margin-right: 12rem;
  }

  .xl\\:first\\:mb-48:first-child{
    margin-bottom: 12rem;
  }

  .xl\\:first\\:ml-48:first-child{
    margin-left: 12rem;
  }

  .xl\\:first\\:mt-52:first-child{
    margin-top: 13rem;
  }

  .xl\\:first\\:mr-52:first-child{
    margin-right: 13rem;
  }

  .xl\\:first\\:mb-52:first-child{
    margin-bottom: 13rem;
  }

  .xl\\:first\\:ml-52:first-child{
    margin-left: 13rem;
  }

  .xl\\:first\\:mt-54:first-child{
    margin-top: 13.5rem;
  }

  .xl\\:first\\:mr-54:first-child{
    margin-right: 13.5rem;
  }

  .xl\\:first\\:mb-54:first-child{
    margin-bottom: 13.5rem;
  }

  .xl\\:first\\:ml-54:first-child{
    margin-left: 13.5rem;
  }

  .xl\\:first\\:mt-56:first-child{
    margin-top: 14rem;
  }

  .xl\\:first\\:mr-56:first-child{
    margin-right: 14rem;
  }

  .xl\\:first\\:mb-56:first-child{
    margin-bottom: 14rem;
  }

  .xl\\:first\\:ml-56:first-child{
    margin-left: 14rem;
  }

  .xl\\:first\\:mt-60:first-child{
    margin-top: 15rem;
  }

  .xl\\:first\\:mr-60:first-child{
    margin-right: 15rem;
  }

  .xl\\:first\\:mb-60:first-child{
    margin-bottom: 15rem;
  }

  .xl\\:first\\:ml-60:first-child{
    margin-left: 15rem;
  }

  .xl\\:first\\:mt-64:first-child{
    margin-top: 16rem;
  }

  .xl\\:first\\:mr-64:first-child{
    margin-right: 16rem;
  }

  .xl\\:first\\:mb-64:first-child{
    margin-bottom: 16rem;
  }

  .xl\\:first\\:ml-64:first-child{
    margin-left: 16rem;
  }

  .xl\\:first\\:mt-68:first-child{
    margin-top: 17rem;
  }

  .xl\\:first\\:mr-68:first-child{
    margin-right: 17rem;
  }

  .xl\\:first\\:mb-68:first-child{
    margin-bottom: 17rem;
  }

  .xl\\:first\\:ml-68:first-child{
    margin-left: 17rem;
  }

  .xl\\:first\\:mt-72:first-child{
    margin-top: 18rem;
  }

  .xl\\:first\\:mr-72:first-child{
    margin-right: 18rem;
  }

  .xl\\:first\\:mb-72:first-child{
    margin-bottom: 18rem;
  }

  .xl\\:first\\:ml-72:first-child{
    margin-left: 18rem;
  }

  .xl\\:first\\:mt-74:first-child{
    margin-top: 18.5rem;
  }

  .xl\\:first\\:mr-74:first-child{
    margin-right: 18.5rem;
  }

  .xl\\:first\\:mb-74:first-child{
    margin-bottom: 18.5rem;
  }

  .xl\\:first\\:ml-74:first-child{
    margin-left: 18.5rem;
  }

  .xl\\:first\\:mt-76:first-child{
    margin-top: 19rem;
  }

  .xl\\:first\\:mr-76:first-child{
    margin-right: 19rem;
  }

  .xl\\:first\\:mb-76:first-child{
    margin-bottom: 19rem;
  }

  .xl\\:first\\:ml-76:first-child{
    margin-left: 19rem;
  }

  .xl\\:first\\:mt-78:first-child{
    margin-top: 19.5rem;
  }

  .xl\\:first\\:mr-78:first-child{
    margin-right: 19.5rem;
  }

  .xl\\:first\\:mb-78:first-child{
    margin-bottom: 19.5rem;
  }

  .xl\\:first\\:ml-78:first-child{
    margin-left: 19.5rem;
  }

  .xl\\:first\\:mt-80:first-child{
    margin-top: 20rem;
  }

  .xl\\:first\\:mr-80:first-child{
    margin-right: 20rem;
  }

  .xl\\:first\\:mb-80:first-child{
    margin-bottom: 20rem;
  }

  .xl\\:first\\:ml-80:first-child{
    margin-left: 20rem;
  }

  .xl\\:first\\:mt-82:first-child{
    margin-top: 20.5rem;
  }

  .xl\\:first\\:mr-82:first-child{
    margin-right: 20.5rem;
  }

  .xl\\:first\\:mb-82:first-child{
    margin-bottom: 20.5rem;
  }

  .xl\\:first\\:ml-82:first-child{
    margin-left: 20.5rem;
  }

  .xl\\:first\\:mt-84:first-child{
    margin-top: 21rem;
  }

  .xl\\:first\\:mr-84:first-child{
    margin-right: 21rem;
  }

  .xl\\:first\\:mb-84:first-child{
    margin-bottom: 21rem;
  }

  .xl\\:first\\:ml-84:first-child{
    margin-left: 21rem;
  }

  .xl\\:first\\:mt-88:first-child{
    margin-top: 22rem;
  }

  .xl\\:first\\:mr-88:first-child{
    margin-right: 22rem;
  }

  .xl\\:first\\:mb-88:first-child{
    margin-bottom: 22rem;
  }

  .xl\\:first\\:ml-88:first-child{
    margin-left: 22rem;
  }

  .xl\\:first\\:mt-92:first-child{
    margin-top: 23rem;
  }

  .xl\\:first\\:mr-92:first-child{
    margin-right: 23rem;
  }

  .xl\\:first\\:mb-92:first-child{
    margin-bottom: 23rem;
  }

  .xl\\:first\\:ml-92:first-child{
    margin-left: 23rem;
  }

  .xl\\:first\\:mt-96:first-child{
    margin-top: 24rem;
  }

  .xl\\:first\\:mr-96:first-child{
    margin-right: 24rem;
  }

  .xl\\:first\\:mb-96:first-child{
    margin-bottom: 24rem;
  }

  .xl\\:first\\:ml-96:first-child{
    margin-left: 24rem;
  }

  .xl\\:first\\:mt-98:first-child{
    margin-top: 24.5rem;
  }

  .xl\\:first\\:mr-98:first-child{
    margin-right: 24.5rem;
  }

  .xl\\:first\\:mb-98:first-child{
    margin-bottom: 24.5rem;
  }

  .xl\\:first\\:ml-98:first-child{
    margin-left: 24.5rem;
  }

  .xl\\:first\\:mt-100:first-child{
    margin-top: 25rem;
  }

  .xl\\:first\\:mr-100:first-child{
    margin-right: 25rem;
  }

  .xl\\:first\\:mb-100:first-child{
    margin-bottom: 25rem;
  }

  .xl\\:first\\:ml-100:first-child{
    margin-left: 25rem;
  }

  .xl\\:first\\:mt-104:first-child{
    margin-top: 26rem;
  }

  .xl\\:first\\:mr-104:first-child{
    margin-right: 26rem;
  }

  .xl\\:first\\:mb-104:first-child{
    margin-bottom: 26rem;
  }

  .xl\\:first\\:ml-104:first-child{
    margin-left: 26rem;
  }

  .xl\\:first\\:mt-112:first-child{
    margin-top: 28rem;
  }

  .xl\\:first\\:mr-112:first-child{
    margin-right: 28rem;
  }

  .xl\\:first\\:mb-112:first-child{
    margin-bottom: 28rem;
  }

  .xl\\:first\\:ml-112:first-child{
    margin-left: 28rem;
  }

  .xl\\:first\\:mt-124:first-child{
    margin-top: 31rem;
  }

  .xl\\:first\\:mr-124:first-child{
    margin-right: 31rem;
  }

  .xl\\:first\\:mb-124:first-child{
    margin-bottom: 31rem;
  }

  .xl\\:first\\:ml-124:first-child{
    margin-left: 31rem;
  }

  .xl\\:first\\:mt-128:first-child{
    margin-top: 32rem;
  }

  .xl\\:first\\:mr-128:first-child{
    margin-right: 32rem;
  }

  .xl\\:first\\:mb-128:first-child{
    margin-bottom: 32rem;
  }

  .xl\\:first\\:ml-128:first-child{
    margin-left: 32rem;
  }

  .xl\\:first\\:mt-140:first-child{
    margin-top: 35rem;
  }

  .xl\\:first\\:mr-140:first-child{
    margin-right: 35rem;
  }

  .xl\\:first\\:mb-140:first-child{
    margin-bottom: 35rem;
  }

  .xl\\:first\\:ml-140:first-child{
    margin-left: 35rem;
  }

  .xl\\:first\\:mt-152:first-child{
    margin-top: 38rem;
  }

  .xl\\:first\\:mr-152:first-child{
    margin-right: 38rem;
  }

  .xl\\:first\\:mb-152:first-child{
    margin-bottom: 38rem;
  }

  .xl\\:first\\:ml-152:first-child{
    margin-left: 38rem;
  }

  .xl\\:first\\:mt-160:first-child{
    margin-top: 40rem;
  }

  .xl\\:first\\:mr-160:first-child{
    margin-right: 40rem;
  }

  .xl\\:first\\:mb-160:first-child{
    margin-bottom: 40rem;
  }

  .xl\\:first\\:ml-160:first-child{
    margin-left: 40rem;
  }

  .xl\\:first\\:mt-162:first-child{
    margin-top: 41rem;
  }

  .xl\\:first\\:mr-162:first-child{
    margin-right: 41rem;
  }

  .xl\\:first\\:mb-162:first-child{
    margin-bottom: 41rem;
  }

  .xl\\:first\\:ml-162:first-child{
    margin-left: 41rem;
  }

  .xl\\:first\\:mt-192:first-child{
    margin-top: 48rem;
  }

  .xl\\:first\\:mr-192:first-child{
    margin-right: 48rem;
  }

  .xl\\:first\\:mb-192:first-child{
    margin-bottom: 48rem;
  }

  .xl\\:first\\:ml-192:first-child{
    margin-left: 48rem;
  }

  .xl\\:first\\:mt-208:first-child{
    margin-top: 52rem;
  }

  .xl\\:first\\:mr-208:first-child{
    margin-right: 52rem;
  }

  .xl\\:first\\:mb-208:first-child{
    margin-bottom: 52rem;
  }

  .xl\\:first\\:ml-208:first-child{
    margin-left: 52rem;
  }

  .xl\\:first\\:mt-224:first-child{
    margin-top: 56rem;
  }

  .xl\\:first\\:mr-224:first-child{
    margin-right: 56rem;
  }

  .xl\\:first\\:mb-224:first-child{
    margin-bottom: 56rem;
  }

  .xl\\:first\\:ml-224:first-child{
    margin-left: 56rem;
  }

  .xl\\:first\\:mt-256:first-child{
    margin-top: 64rem;
  }

  .xl\\:first\\:mr-256:first-child{
    margin-right: 64rem;
  }

  .xl\\:first\\:mb-256:first-child{
    margin-bottom: 64rem;
  }

  .xl\\:first\\:ml-256:first-child{
    margin-left: 64rem;
  }

  .xl\\:first\\:mt-auto:first-child{
    margin-top: auto;
  }

  .xl\\:first\\:mr-auto:first-child{
    margin-right: auto;
  }

  .xl\\:first\\:mb-auto:first-child{
    margin-bottom: auto;
  }

  .xl\\:first\\:ml-auto:first-child{
    margin-left: auto;
  }

  .xl\\:first\\:mt-px:first-child{
    margin-top: 1px;
  }

  .xl\\:first\\:mr-px:first-child{
    margin-right: 1px;
  }

  .xl\\:first\\:mb-px:first-child{
    margin-bottom: 1px;
  }

  .xl\\:first\\:ml-px:first-child{
    margin-left: 1px;
  }

  .xl\\:first\\:-mt-1:first-child{
    margin-top: -0.25rem;
  }

  .xl\\:first\\:-mr-1:first-child{
    margin-right: -0.25rem;
  }

  .xl\\:first\\:-mb-1:first-child{
    margin-bottom: -0.25rem;
  }

  .xl\\:first\\:-ml-1:first-child{
    margin-left: -0.25rem;
  }

  .xl\\:first\\:-mt-2:first-child{
    margin-top: -0.5rem;
  }

  .xl\\:first\\:-mr-2:first-child{
    margin-right: -0.5rem;
  }

  .xl\\:first\\:-mb-2:first-child{
    margin-bottom: -0.5rem;
  }

  .xl\\:first\\:-ml-2:first-child{
    margin-left: -0.5rem;
  }

  .xl\\:first\\:-mt-3:first-child{
    margin-top: -0.75rem;
  }

  .xl\\:first\\:-mr-3:first-child{
    margin-right: -0.75rem;
  }

  .xl\\:first\\:-mb-3:first-child{
    margin-bottom: -0.75rem;
  }

  .xl\\:first\\:-ml-3:first-child{
    margin-left: -0.75rem;
  }

  .xl\\:first\\:-mt-4:first-child{
    margin-top: -1rem;
  }

  .xl\\:first\\:-mr-4:first-child{
    margin-right: -1rem;
  }

  .xl\\:first\\:-mb-4:first-child{
    margin-bottom: -1rem;
  }

  .xl\\:first\\:-ml-4:first-child{
    margin-left: -1rem;
  }

  .xl\\:first\\:-mt-5:first-child{
    margin-top: -1.25rem;
  }

  .xl\\:first\\:-mr-5:first-child{
    margin-right: -1.25rem;
  }

  .xl\\:first\\:-mb-5:first-child{
    margin-bottom: -1.25rem;
  }

  .xl\\:first\\:-ml-5:first-child{
    margin-left: -1.25rem;
  }

  .xl\\:first\\:-mt-6:first-child{
    margin-top: -1.5rem;
  }

  .xl\\:first\\:-mr-6:first-child{
    margin-right: -1.5rem;
  }

  .xl\\:first\\:-mb-6:first-child{
    margin-bottom: -1.5rem;
  }

  .xl\\:first\\:-ml-6:first-child{
    margin-left: -1.5rem;
  }

  .xl\\:first\\:-mt-7:first-child{
    margin-top: -1.75rem;
  }

  .xl\\:first\\:-mr-7:first-child{
    margin-right: -1.75rem;
  }

  .xl\\:first\\:-mb-7:first-child{
    margin-bottom: -1.75rem;
  }

  .xl\\:first\\:-ml-7:first-child{
    margin-left: -1.75rem;
  }

  .xl\\:first\\:-mt-8:first-child{
    margin-top: -2rem;
  }

  .xl\\:first\\:-mr-8:first-child{
    margin-right: -2rem;
  }

  .xl\\:first\\:-mb-8:first-child{
    margin-bottom: -2rem;
  }

  .xl\\:first\\:-ml-8:first-child{
    margin-left: -2rem;
  }

  .xl\\:first\\:-mt-9:first-child{
    margin-top: -2.25rem;
  }

  .xl\\:first\\:-mr-9:first-child{
    margin-right: -2.25rem;
  }

  .xl\\:first\\:-mb-9:first-child{
    margin-bottom: -2.25rem;
  }

  .xl\\:first\\:-ml-9:first-child{
    margin-left: -2.25rem;
  }

  .xl\\:first\\:-mt-10:first-child{
    margin-top: -2.5rem;
  }

  .xl\\:first\\:-mr-10:first-child{
    margin-right: -2.5rem;
  }

  .xl\\:first\\:-mb-10:first-child{
    margin-bottom: -2.5rem;
  }

  .xl\\:first\\:-ml-10:first-child{
    margin-left: -2.5rem;
  }

  .xl\\:first\\:-mt-11:first-child{
    margin-top: -2.75rem;
  }

  .xl\\:first\\:-mr-11:first-child{
    margin-right: -2.75rem;
  }

  .xl\\:first\\:-mb-11:first-child{
    margin-bottom: -2.75rem;
  }

  .xl\\:first\\:-ml-11:first-child{
    margin-left: -2.75rem;
  }

  .xl\\:first\\:-mt-12:first-child{
    margin-top: -3rem;
  }

  .xl\\:first\\:-mr-12:first-child{
    margin-right: -3rem;
  }

  .xl\\:first\\:-mb-12:first-child{
    margin-bottom: -3rem;
  }

  .xl\\:first\\:-ml-12:first-child{
    margin-left: -3rem;
  }

  .xl\\:first\\:-mt-14:first-child{
    margin-top: -3.5rem;
  }

  .xl\\:first\\:-mr-14:first-child{
    margin-right: -3.5rem;
  }

  .xl\\:first\\:-mb-14:first-child{
    margin-bottom: -3.5rem;
  }

  .xl\\:first\\:-ml-14:first-child{
    margin-left: -3.5rem;
  }

  .xl\\:first\\:-mt-15:first-child{
    margin-top: -3.75rem;
  }

  .xl\\:first\\:-mr-15:first-child{
    margin-right: -3.75rem;
  }

  .xl\\:first\\:-mb-15:first-child{
    margin-bottom: -3.75rem;
  }

  .xl\\:first\\:-ml-15:first-child{
    margin-left: -3.75rem;
  }

  .xl\\:first\\:-mt-16:first-child{
    margin-top: -4rem;
  }

  .xl\\:first\\:-mr-16:first-child{
    margin-right: -4rem;
  }

  .xl\\:first\\:-mb-16:first-child{
    margin-bottom: -4rem;
  }

  .xl\\:first\\:-ml-16:first-child{
    margin-left: -4rem;
  }

  .xl\\:first\\:-mt-18:first-child{
    margin-top: -4.5rem;
  }

  .xl\\:first\\:-mr-18:first-child{
    margin-right: -4.5rem;
  }

  .xl\\:first\\:-mb-18:first-child{
    margin-bottom: -4.5rem;
  }

  .xl\\:first\\:-ml-18:first-child{
    margin-left: -4.5rem;
  }

  .xl\\:first\\:-mt-20:first-child{
    margin-top: -5rem;
  }

  .xl\\:first\\:-mr-20:first-child{
    margin-right: -5rem;
  }

  .xl\\:first\\:-mb-20:first-child{
    margin-bottom: -5rem;
  }

  .xl\\:first\\:-ml-20:first-child{
    margin-left: -5rem;
  }

  .xl\\:first\\:-mt-22:first-child{
    margin-top: -5.5rem;
  }

  .xl\\:first\\:-mr-22:first-child{
    margin-right: -5.5rem;
  }

  .xl\\:first\\:-mb-22:first-child{
    margin-bottom: -5.5rem;
  }

  .xl\\:first\\:-ml-22:first-child{
    margin-left: -5.5rem;
  }

  .xl\\:first\\:-mt-23:first-child{
    margin-top: -5.75rem;
  }

  .xl\\:first\\:-mr-23:first-child{
    margin-right: -5.75rem;
  }

  .xl\\:first\\:-mb-23:first-child{
    margin-bottom: -5.75rem;
  }

  .xl\\:first\\:-ml-23:first-child{
    margin-left: -5.75rem;
  }

  .xl\\:first\\:-mt-24:first-child{
    margin-top: -6rem;
  }

  .xl\\:first\\:-mr-24:first-child{
    margin-right: -6rem;
  }

  .xl\\:first\\:-mb-24:first-child{
    margin-bottom: -6rem;
  }

  .xl\\:first\\:-ml-24:first-child{
    margin-left: -6rem;
  }

  .xl\\:first\\:-mt-25:first-child{
    margin-top: -6.25rem;
  }

  .xl\\:first\\:-mr-25:first-child{
    margin-right: -6.25rem;
  }

  .xl\\:first\\:-mb-25:first-child{
    margin-bottom: -6.25rem;
  }

  .xl\\:first\\:-ml-25:first-child{
    margin-left: -6.25rem;
  }

  .xl\\:first\\:-mt-26:first-child{
    margin-top: -6.5rem;
  }

  .xl\\:first\\:-mr-26:first-child{
    margin-right: -6.5rem;
  }

  .xl\\:first\\:-mb-26:first-child{
    margin-bottom: -6.5rem;
  }

  .xl\\:first\\:-ml-26:first-child{
    margin-left: -6.5rem;
  }

  .xl\\:first\\:-mt-28:first-child{
    margin-top: -7rem;
  }

  .xl\\:first\\:-mr-28:first-child{
    margin-right: -7rem;
  }

  .xl\\:first\\:-mb-28:first-child{
    margin-bottom: -7rem;
  }

  .xl\\:first\\:-ml-28:first-child{
    margin-left: -7rem;
  }

  .xl\\:first\\:-mt-30:first-child{
    margin-top: -7.5rem;
  }

  .xl\\:first\\:-mr-30:first-child{
    margin-right: -7.5rem;
  }

  .xl\\:first\\:-mb-30:first-child{
    margin-bottom: -7.5rem;
  }

  .xl\\:first\\:-ml-30:first-child{
    margin-left: -7.5rem;
  }

  .xl\\:first\\:-mt-32:first-child{
    margin-top: -8rem;
  }

  .xl\\:first\\:-mr-32:first-child{
    margin-right: -8rem;
  }

  .xl\\:first\\:-mb-32:first-child{
    margin-bottom: -8rem;
  }

  .xl\\:first\\:-ml-32:first-child{
    margin-left: -8rem;
  }

  .xl\\:first\\:-mt-34:first-child{
    margin-top: -8.5rem;
  }

  .xl\\:first\\:-mr-34:first-child{
    margin-right: -8.5rem;
  }

  .xl\\:first\\:-mb-34:first-child{
    margin-bottom: -8.5rem;
  }

  .xl\\:first\\:-ml-34:first-child{
    margin-left: -8.5rem;
  }

  .xl\\:first\\:-mt-40:first-child{
    margin-top: -10rem;
  }

  .xl\\:first\\:-mr-40:first-child{
    margin-right: -10rem;
  }

  .xl\\:first\\:-mb-40:first-child{
    margin-bottom: -10rem;
  }

  .xl\\:first\\:-ml-40:first-child{
    margin-left: -10rem;
  }

  .xl\\:first\\:-mt-42:first-child{
    margin-top: -10.5rem;
  }

  .xl\\:first\\:-mr-42:first-child{
    margin-right: -10.5rem;
  }

  .xl\\:first\\:-mb-42:first-child{
    margin-bottom: -10.5rem;
  }

  .xl\\:first\\:-ml-42:first-child{
    margin-left: -10.5rem;
  }

  .xl\\:first\\:-mt-44:first-child{
    margin-top: -11rem;
  }

  .xl\\:first\\:-mr-44:first-child{
    margin-right: -11rem;
  }

  .xl\\:first\\:-mb-44:first-child{
    margin-bottom: -11rem;
  }

  .xl\\:first\\:-ml-44:first-child{
    margin-left: -11rem;
  }

  .xl\\:first\\:-mt-48:first-child{
    margin-top: -12rem;
  }

  .xl\\:first\\:-mr-48:first-child{
    margin-right: -12rem;
  }

  .xl\\:first\\:-mb-48:first-child{
    margin-bottom: -12rem;
  }

  .xl\\:first\\:-ml-48:first-child{
    margin-left: -12rem;
  }

  .xl\\:first\\:-mt-52:first-child{
    margin-top: -13rem;
  }

  .xl\\:first\\:-mr-52:first-child{
    margin-right: -13rem;
  }

  .xl\\:first\\:-mb-52:first-child{
    margin-bottom: -13rem;
  }

  .xl\\:first\\:-ml-52:first-child{
    margin-left: -13rem;
  }

  .xl\\:first\\:-mt-54:first-child{
    margin-top: -13.5rem;
  }

  .xl\\:first\\:-mr-54:first-child{
    margin-right: -13.5rem;
  }

  .xl\\:first\\:-mb-54:first-child{
    margin-bottom: -13.5rem;
  }

  .xl\\:first\\:-ml-54:first-child{
    margin-left: -13.5rem;
  }

  .xl\\:first\\:-mt-56:first-child{
    margin-top: -14rem;
  }

  .xl\\:first\\:-mr-56:first-child{
    margin-right: -14rem;
  }

  .xl\\:first\\:-mb-56:first-child{
    margin-bottom: -14rem;
  }

  .xl\\:first\\:-ml-56:first-child{
    margin-left: -14rem;
  }

  .xl\\:first\\:-mt-60:first-child{
    margin-top: -15rem;
  }

  .xl\\:first\\:-mr-60:first-child{
    margin-right: -15rem;
  }

  .xl\\:first\\:-mb-60:first-child{
    margin-bottom: -15rem;
  }

  .xl\\:first\\:-ml-60:first-child{
    margin-left: -15rem;
  }

  .xl\\:first\\:-mt-64:first-child{
    margin-top: -16rem;
  }

  .xl\\:first\\:-mr-64:first-child{
    margin-right: -16rem;
  }

  .xl\\:first\\:-mb-64:first-child{
    margin-bottom: -16rem;
  }

  .xl\\:first\\:-ml-64:first-child{
    margin-left: -16rem;
  }

  .xl\\:first\\:-mt-68:first-child{
    margin-top: -17rem;
  }

  .xl\\:first\\:-mr-68:first-child{
    margin-right: -17rem;
  }

  .xl\\:first\\:-mb-68:first-child{
    margin-bottom: -17rem;
  }

  .xl\\:first\\:-ml-68:first-child{
    margin-left: -17rem;
  }

  .xl\\:first\\:-mt-72:first-child{
    margin-top: -18rem;
  }

  .xl\\:first\\:-mr-72:first-child{
    margin-right: -18rem;
  }

  .xl\\:first\\:-mb-72:first-child{
    margin-bottom: -18rem;
  }

  .xl\\:first\\:-ml-72:first-child{
    margin-left: -18rem;
  }

  .xl\\:first\\:-mt-74:first-child{
    margin-top: -18.5rem;
  }

  .xl\\:first\\:-mr-74:first-child{
    margin-right: -18.5rem;
  }

  .xl\\:first\\:-mb-74:first-child{
    margin-bottom: -18.5rem;
  }

  .xl\\:first\\:-ml-74:first-child{
    margin-left: -18.5rem;
  }

  .xl\\:first\\:-mt-76:first-child{
    margin-top: -19rem;
  }

  .xl\\:first\\:-mr-76:first-child{
    margin-right: -19rem;
  }

  .xl\\:first\\:-mb-76:first-child{
    margin-bottom: -19rem;
  }

  .xl\\:first\\:-ml-76:first-child{
    margin-left: -19rem;
  }

  .xl\\:first\\:-mt-78:first-child{
    margin-top: -19.5rem;
  }

  .xl\\:first\\:-mr-78:first-child{
    margin-right: -19.5rem;
  }

  .xl\\:first\\:-mb-78:first-child{
    margin-bottom: -19.5rem;
  }

  .xl\\:first\\:-ml-78:first-child{
    margin-left: -19.5rem;
  }

  .xl\\:first\\:-mt-80:first-child{
    margin-top: -20rem;
  }

  .xl\\:first\\:-mr-80:first-child{
    margin-right: -20rem;
  }

  .xl\\:first\\:-mb-80:first-child{
    margin-bottom: -20rem;
  }

  .xl\\:first\\:-ml-80:first-child{
    margin-left: -20rem;
  }

  .xl\\:first\\:-mt-82:first-child{
    margin-top: -20.5rem;
  }

  .xl\\:first\\:-mr-82:first-child{
    margin-right: -20.5rem;
  }

  .xl\\:first\\:-mb-82:first-child{
    margin-bottom: -20.5rem;
  }

  .xl\\:first\\:-ml-82:first-child{
    margin-left: -20.5rem;
  }

  .xl\\:first\\:-mt-84:first-child{
    margin-top: -21rem;
  }

  .xl\\:first\\:-mr-84:first-child{
    margin-right: -21rem;
  }

  .xl\\:first\\:-mb-84:first-child{
    margin-bottom: -21rem;
  }

  .xl\\:first\\:-ml-84:first-child{
    margin-left: -21rem;
  }

  .xl\\:first\\:-mt-88:first-child{
    margin-top: -22rem;
  }

  .xl\\:first\\:-mr-88:first-child{
    margin-right: -22rem;
  }

  .xl\\:first\\:-mb-88:first-child{
    margin-bottom: -22rem;
  }

  .xl\\:first\\:-ml-88:first-child{
    margin-left: -22rem;
  }

  .xl\\:first\\:-mt-92:first-child{
    margin-top: -23rem;
  }

  .xl\\:first\\:-mr-92:first-child{
    margin-right: -23rem;
  }

  .xl\\:first\\:-mb-92:first-child{
    margin-bottom: -23rem;
  }

  .xl\\:first\\:-ml-92:first-child{
    margin-left: -23rem;
  }

  .xl\\:first\\:-mt-96:first-child{
    margin-top: -24rem;
  }

  .xl\\:first\\:-mr-96:first-child{
    margin-right: -24rem;
  }

  .xl\\:first\\:-mb-96:first-child{
    margin-bottom: -24rem;
  }

  .xl\\:first\\:-ml-96:first-child{
    margin-left: -24rem;
  }

  .xl\\:first\\:-mt-98:first-child{
    margin-top: -24.5rem;
  }

  .xl\\:first\\:-mr-98:first-child{
    margin-right: -24.5rem;
  }

  .xl\\:first\\:-mb-98:first-child{
    margin-bottom: -24.5rem;
  }

  .xl\\:first\\:-ml-98:first-child{
    margin-left: -24.5rem;
  }

  .xl\\:first\\:-mt-100:first-child{
    margin-top: -25rem;
  }

  .xl\\:first\\:-mr-100:first-child{
    margin-right: -25rem;
  }

  .xl\\:first\\:-mb-100:first-child{
    margin-bottom: -25rem;
  }

  .xl\\:first\\:-ml-100:first-child{
    margin-left: -25rem;
  }

  .xl\\:first\\:-mt-104:first-child{
    margin-top: -26rem;
  }

  .xl\\:first\\:-mr-104:first-child{
    margin-right: -26rem;
  }

  .xl\\:first\\:-mb-104:first-child{
    margin-bottom: -26rem;
  }

  .xl\\:first\\:-ml-104:first-child{
    margin-left: -26rem;
  }

  .xl\\:first\\:-mt-112:first-child{
    margin-top: -28rem;
  }

  .xl\\:first\\:-mr-112:first-child{
    margin-right: -28rem;
  }

  .xl\\:first\\:-mb-112:first-child{
    margin-bottom: -28rem;
  }

  .xl\\:first\\:-ml-112:first-child{
    margin-left: -28rem;
  }

  .xl\\:first\\:-mt-124:first-child{
    margin-top: -31rem;
  }

  .xl\\:first\\:-mr-124:first-child{
    margin-right: -31rem;
  }

  .xl\\:first\\:-mb-124:first-child{
    margin-bottom: -31rem;
  }

  .xl\\:first\\:-ml-124:first-child{
    margin-left: -31rem;
  }

  .xl\\:first\\:-mt-128:first-child{
    margin-top: -32rem;
  }

  .xl\\:first\\:-mr-128:first-child{
    margin-right: -32rem;
  }

  .xl\\:first\\:-mb-128:first-child{
    margin-bottom: -32rem;
  }

  .xl\\:first\\:-ml-128:first-child{
    margin-left: -32rem;
  }

  .xl\\:first\\:-mt-140:first-child{
    margin-top: -35rem;
  }

  .xl\\:first\\:-mr-140:first-child{
    margin-right: -35rem;
  }

  .xl\\:first\\:-mb-140:first-child{
    margin-bottom: -35rem;
  }

  .xl\\:first\\:-ml-140:first-child{
    margin-left: -35rem;
  }

  .xl\\:first\\:-mt-152:first-child{
    margin-top: -38rem;
  }

  .xl\\:first\\:-mr-152:first-child{
    margin-right: -38rem;
  }

  .xl\\:first\\:-mb-152:first-child{
    margin-bottom: -38rem;
  }

  .xl\\:first\\:-ml-152:first-child{
    margin-left: -38rem;
  }

  .xl\\:first\\:-mt-160:first-child{
    margin-top: -40rem;
  }

  .xl\\:first\\:-mr-160:first-child{
    margin-right: -40rem;
  }

  .xl\\:first\\:-mb-160:first-child{
    margin-bottom: -40rem;
  }

  .xl\\:first\\:-ml-160:first-child{
    margin-left: -40rem;
  }

  .xl\\:first\\:-mt-162:first-child{
    margin-top: -41rem;
  }

  .xl\\:first\\:-mr-162:first-child{
    margin-right: -41rem;
  }

  .xl\\:first\\:-mb-162:first-child{
    margin-bottom: -41rem;
  }

  .xl\\:first\\:-ml-162:first-child{
    margin-left: -41rem;
  }

  .xl\\:first\\:-mt-192:first-child{
    margin-top: -48rem;
  }

  .xl\\:first\\:-mr-192:first-child{
    margin-right: -48rem;
  }

  .xl\\:first\\:-mb-192:first-child{
    margin-bottom: -48rem;
  }

  .xl\\:first\\:-ml-192:first-child{
    margin-left: -48rem;
  }

  .xl\\:first\\:-mt-208:first-child{
    margin-top: -52rem;
  }

  .xl\\:first\\:-mr-208:first-child{
    margin-right: -52rem;
  }

  .xl\\:first\\:-mb-208:first-child{
    margin-bottom: -52rem;
  }

  .xl\\:first\\:-ml-208:first-child{
    margin-left: -52rem;
  }

  .xl\\:first\\:-mt-224:first-child{
    margin-top: -56rem;
  }

  .xl\\:first\\:-mr-224:first-child{
    margin-right: -56rem;
  }

  .xl\\:first\\:-mb-224:first-child{
    margin-bottom: -56rem;
  }

  .xl\\:first\\:-ml-224:first-child{
    margin-left: -56rem;
  }

  .xl\\:first\\:-mt-256:first-child{
    margin-top: -64rem;
  }

  .xl\\:first\\:-mr-256:first-child{
    margin-right: -64rem;
  }

  .xl\\:first\\:-mb-256:first-child{
    margin-bottom: -64rem;
  }

  .xl\\:first\\:-ml-256:first-child{
    margin-left: -64rem;
  }

  .xl\\:first\\:-mt-px:first-child{
    margin-top: -1px;
  }

  .xl\\:first\\:-mr-px:first-child{
    margin-right: -1px;
  }

  .xl\\:first\\:-mb-px:first-child{
    margin-bottom: -1px;
  }

  .xl\\:first\\:-ml-px:first-child{
    margin-left: -1px;
  }

  .xl\\:max-h-0{
    max-height: 0;
  }

  .xl\\:max-h-1{
    max-height: 0.25rem;
  }

  .xl\\:max-h-2{
    max-height: 0.5rem;
  }

  .xl\\:max-h-3{
    max-height: 0.75rem;
  }

  .xl\\:max-h-4{
    max-height: 1rem;
  }

  .xl\\:max-h-5{
    max-height: 1.25rem;
  }

  .xl\\:max-h-6{
    max-height: 1.5rem;
  }

  .xl\\:max-h-7{
    max-height: 1.75rem;
  }

  .xl\\:max-h-8{
    max-height: 2rem;
  }

  .xl\\:max-h-9{
    max-height: 2.25rem;
  }

  .xl\\:max-h-10{
    max-height: 2.5rem;
  }

  .xl\\:max-h-11{
    max-height: 2.75rem;
  }

  .xl\\:max-h-12{
    max-height: 3rem;
  }

  .xl\\:max-h-14{
    max-height: 3.5rem;
  }

  .xl\\:max-h-15{
    max-height: 3.75rem;
  }

  .xl\\:max-h-16{
    max-height: 4rem;
  }

  .xl\\:max-h-18{
    max-height: 4.5rem;
  }

  .xl\\:max-h-20{
    max-height: 5rem;
  }

  .xl\\:max-h-22{
    max-height: 5.5rem;
  }

  .xl\\:max-h-23{
    max-height: 5.75rem;
  }

  .xl\\:max-h-24{
    max-height: 6rem;
  }

  .xl\\:max-h-25{
    max-height: 6.25rem;
  }

  .xl\\:max-h-26{
    max-height: 6.5rem;
  }

  .xl\\:max-h-28{
    max-height: 7rem;
  }

  .xl\\:max-h-30{
    max-height: 7.5rem;
  }

  .xl\\:max-h-32{
    max-height: 8rem;
  }

  .xl\\:max-h-34{
    max-height: 8.5rem;
  }

  .xl\\:max-h-40{
    max-height: 10rem;
  }

  .xl\\:max-h-42{
    max-height: 10.5rem;
  }

  .xl\\:max-h-44{
    max-height: 11rem;
  }

  .xl\\:max-h-48{
    max-height: 12rem;
  }

  .xl\\:max-h-52{
    max-height: 13rem;
  }

  .xl\\:max-h-54{
    max-height: 13.5rem;
  }

  .xl\\:max-h-56{
    max-height: 14rem;
  }

  .xl\\:max-h-60{
    max-height: 15rem;
  }

  .xl\\:max-h-64{
    max-height: 16rem;
  }

  .xl\\:max-h-68{
    max-height: 17rem;
  }

  .xl\\:max-h-72{
    max-height: 18rem;
  }

  .xl\\:max-h-74{
    max-height: 18.5rem;
  }

  .xl\\:max-h-76{
    max-height: 19rem;
  }

  .xl\\:max-h-78{
    max-height: 19.5rem;
  }

  .xl\\:max-h-80{
    max-height: 20rem;
  }

  .xl\\:max-h-82{
    max-height: 20.5rem;
  }

  .xl\\:max-h-84{
    max-height: 21rem;
  }

  .xl\\:max-h-88{
    max-height: 22rem;
  }

  .xl\\:max-h-92{
    max-height: 23rem;
  }

  .xl\\:max-h-96{
    max-height: 24rem;
  }

  .xl\\:max-h-98{
    max-height: 24.5rem;
  }

  .xl\\:max-h-100{
    max-height: 25rem;
  }

  .xl\\:max-h-104{
    max-height: 26rem;
  }

  .xl\\:max-h-112{
    max-height: 28rem;
  }

  .xl\\:max-h-124{
    max-height: 31rem;
  }

  .xl\\:max-h-128{
    max-height: 32rem;
  }

  .xl\\:max-h-140{
    max-height: 35rem;
  }

  .xl\\:max-h-152{
    max-height: 38rem;
  }

  .xl\\:max-h-160{
    max-height: 40rem;
  }

  .xl\\:max-h-162{
    max-height: 41rem;
  }

  .xl\\:max-h-192{
    max-height: 48rem;
  }

  .xl\\:max-h-208{
    max-height: 52rem;
  }

  .xl\\:max-h-224{
    max-height: 56rem;
  }

  .xl\\:max-h-256{
    max-height: 64rem;
  }

  .xl\\:max-h-px{
    max-height: 1px;
  }

  .xl\\:max-h-full{
    max-height: 100%;
  }

  .xl\\:max-h-screen{
    max-height: 100vh;
  }

  .xl\\:max-w-0{
    max-width: 0;
  }

  .xl\\:max-w-1{
    max-width: 0.25rem;
  }

  .xl\\:max-w-2{
    max-width: 0.5rem;
  }

  .xl\\:max-w-3{
    max-width: 0.75rem;
  }

  .xl\\:max-w-4{
    max-width: 1rem;
  }

  .xl\\:max-w-5{
    max-width: 1.25rem;
  }

  .xl\\:max-w-6{
    max-width: 1.5rem;
  }

  .xl\\:max-w-7{
    max-width: 1.75rem;
  }

  .xl\\:max-w-8{
    max-width: 2rem;
  }

  .xl\\:max-w-9{
    max-width: 2.25rem;
  }

  .xl\\:max-w-10{
    max-width: 2.5rem;
  }

  .xl\\:max-w-11{
    max-width: 2.75rem;
  }

  .xl\\:max-w-12{
    max-width: 3rem;
  }

  .xl\\:max-w-14{
    max-width: 3.5rem;
  }

  .xl\\:max-w-15{
    max-width: 3.75rem;
  }

  .xl\\:max-w-16{
    max-width: 4rem;
  }

  .xl\\:max-w-18{
    max-width: 4.5rem;
  }

  .xl\\:max-w-20{
    max-width: 5rem;
  }

  .xl\\:max-w-22{
    max-width: 5.5rem;
  }

  .xl\\:max-w-23{
    max-width: 5.75rem;
  }

  .xl\\:max-w-24{
    max-width: 6rem;
  }

  .xl\\:max-w-25{
    max-width: 6.25rem;
  }

  .xl\\:max-w-26{
    max-width: 6.5rem;
  }

  .xl\\:max-w-28{
    max-width: 7rem;
  }

  .xl\\:max-w-30{
    max-width: 7.5rem;
  }

  .xl\\:max-w-32{
    max-width: 8rem;
  }

  .xl\\:max-w-34{
    max-width: 8.5rem;
  }

  .xl\\:max-w-40{
    max-width: 10rem;
  }

  .xl\\:max-w-42{
    max-width: 10.5rem;
  }

  .xl\\:max-w-44{
    max-width: 11rem;
  }

  .xl\\:max-w-48{
    max-width: 12rem;
  }

  .xl\\:max-w-52{
    max-width: 13rem;
  }

  .xl\\:max-w-54{
    max-width: 13.5rem;
  }

  .xl\\:max-w-56{
    max-width: 14rem;
  }

  .xl\\:max-w-60{
    max-width: 15rem;
  }

  .xl\\:max-w-64{
    max-width: 16rem;
  }

  .xl\\:max-w-68{
    max-width: 17rem;
  }

  .xl\\:max-w-72{
    max-width: 18rem;
  }

  .xl\\:max-w-74{
    max-width: 18.5rem;
  }

  .xl\\:max-w-76{
    max-width: 19rem;
  }

  .xl\\:max-w-78{
    max-width: 19.5rem;
  }

  .xl\\:max-w-80{
    max-width: 20rem;
  }

  .xl\\:max-w-82{
    max-width: 20.5rem;
  }

  .xl\\:max-w-84{
    max-width: 21rem;
  }

  .xl\\:max-w-88{
    max-width: 22rem;
  }

  .xl\\:max-w-92{
    max-width: 23rem;
  }

  .xl\\:max-w-96{
    max-width: 24rem;
  }

  .xl\\:max-w-98{
    max-width: 24.5rem;
  }

  .xl\\:max-w-100{
    max-width: 25rem;
  }

  .xl\\:max-w-104{
    max-width: 26rem;
  }

  .xl\\:max-w-112{
    max-width: 28rem;
  }

  .xl\\:max-w-124{
    max-width: 31rem;
  }

  .xl\\:max-w-128{
    max-width: 32rem;
  }

  .xl\\:max-w-140{
    max-width: 35rem;
  }

  .xl\\:max-w-152{
    max-width: 38rem;
  }

  .xl\\:max-w-160{
    max-width: 40rem;
  }

  .xl\\:max-w-162{
    max-width: 41rem;
  }

  .xl\\:max-w-192{
    max-width: 48rem;
  }

  .xl\\:max-w-208{
    max-width: 52rem;
  }

  .xl\\:max-w-224{
    max-width: 56rem;
  }

  .xl\\:max-w-256{
    max-width: 64rem;
  }

  .xl\\:max-w-none{
    max-width: none;
  }

  .xl\\:max-w-xs{
    max-width: 20rem;
  }

  .xl\\:max-w-sm{
    max-width: 24rem;
  }

  .xl\\:max-w-md{
    max-width: 28rem;
  }

  .xl\\:max-w-lg{
    max-width: 32rem;
  }

  .xl\\:max-w-xl{
    max-width: 36rem;
  }

  .xl\\:max-w-2xl{
    max-width: 42rem;
  }

  .xl\\:max-w-3xl{
    max-width: 48rem;
  }

  .xl\\:max-w-4xl{
    max-width: 56rem;
  }

  .xl\\:max-w-5xl{
    max-width: 64rem;
  }

  .xl\\:max-w-6xl{
    max-width: 76rem;
  }

  .xl\\:max-w-7xl{
    max-width: 92rem;
  }

  .xl\\:max-w-8xl{
    max-width: 112rem;
  }

  .xl\\:max-w-9xl{
    max-width: 130rem;
  }

  .xl\\:max-w-full{
    max-width: 100%;
  }

  .xl\\:max-w-px{
    max-width: 1px;
  }

  .xl\\:min-h-0{
    min-height: 0;
  }

  .xl\\:min-h-1{
    min-height: 0.25rem;
  }

  .xl\\:min-h-2{
    min-height: 0.5rem;
  }

  .xl\\:min-h-3{
    min-height: 0.75rem;
  }

  .xl\\:min-h-4{
    min-height: 1rem;
  }

  .xl\\:min-h-5{
    min-height: 1.25rem;
  }

  .xl\\:min-h-6{
    min-height: 1.5rem;
  }

  .xl\\:min-h-7{
    min-height: 1.75rem;
  }

  .xl\\:min-h-8{
    min-height: 2rem;
  }

  .xl\\:min-h-9{
    min-height: 2.25rem;
  }

  .xl\\:min-h-10{
    min-height: 2.5rem;
  }

  .xl\\:min-h-11{
    min-height: 2.75rem;
  }

  .xl\\:min-h-12{
    min-height: 3rem;
  }

  .xl\\:min-h-14{
    min-height: 3.5rem;
  }

  .xl\\:min-h-15{
    min-height: 3.75rem;
  }

  .xl\\:min-h-16{
    min-height: 4rem;
  }

  .xl\\:min-h-18{
    min-height: 4.5rem;
  }

  .xl\\:min-h-20{
    min-height: 5rem;
  }

  .xl\\:min-h-22{
    min-height: 5.5rem;
  }

  .xl\\:min-h-23{
    min-height: 5.75rem;
  }

  .xl\\:min-h-24{
    min-height: 6rem;
  }

  .xl\\:min-h-25{
    min-height: 6.25rem;
  }

  .xl\\:min-h-26{
    min-height: 6.5rem;
  }

  .xl\\:min-h-28{
    min-height: 7rem;
  }

  .xl\\:min-h-30{
    min-height: 7.5rem;
  }

  .xl\\:min-h-32{
    min-height: 8rem;
  }

  .xl\\:min-h-34{
    min-height: 8.5rem;
  }

  .xl\\:min-h-40{
    min-height: 10rem;
  }

  .xl\\:min-h-42{
    min-height: 10.5rem;
  }

  .xl\\:min-h-44{
    min-height: 11rem;
  }

  .xl\\:min-h-48{
    min-height: 12rem;
  }

  .xl\\:min-h-52{
    min-height: 13rem;
  }

  .xl\\:min-h-54{
    min-height: 13.5rem;
  }

  .xl\\:min-h-56{
    min-height: 14rem;
  }

  .xl\\:min-h-60{
    min-height: 15rem;
  }

  .xl\\:min-h-64{
    min-height: 16rem;
  }

  .xl\\:min-h-68{
    min-height: 17rem;
  }

  .xl\\:min-h-72{
    min-height: 18rem;
  }

  .xl\\:min-h-74{
    min-height: 18.5rem;
  }

  .xl\\:min-h-76{
    min-height: 19rem;
  }

  .xl\\:min-h-78{
    min-height: 19.5rem;
  }

  .xl\\:min-h-80{
    min-height: 20rem;
  }

  .xl\\:min-h-82{
    min-height: 20.5rem;
  }

  .xl\\:min-h-84{
    min-height: 21rem;
  }

  .xl\\:min-h-88{
    min-height: 22rem;
  }

  .xl\\:min-h-92{
    min-height: 23rem;
  }

  .xl\\:min-h-96{
    min-height: 24rem;
  }

  .xl\\:min-h-98{
    min-height: 24.5rem;
  }

  .xl\\:min-h-100{
    min-height: 25rem;
  }

  .xl\\:min-h-104{
    min-height: 26rem;
  }

  .xl\\:min-h-112{
    min-height: 28rem;
  }

  .xl\\:min-h-124{
    min-height: 31rem;
  }

  .xl\\:min-h-128{
    min-height: 32rem;
  }

  .xl\\:min-h-140{
    min-height: 35rem;
  }

  .xl\\:min-h-152{
    min-height: 38rem;
  }

  .xl\\:min-h-160{
    min-height: 40rem;
  }

  .xl\\:min-h-162{
    min-height: 41rem;
  }

  .xl\\:min-h-192{
    min-height: 48rem;
  }

  .xl\\:min-h-208{
    min-height: 52rem;
  }

  .xl\\:min-h-224{
    min-height: 56rem;
  }

  .xl\\:min-h-256{
    min-height: 64rem;
  }

  .xl\\:min-h-full{
    min-height: 100%;
  }

  .xl\\:min-h-px{
    min-height: 1px;
  }

  .xl\\:min-h-screen{
    min-height: 100vh;
  }

  .xl\\:min-w-0{
    min-width: 0;
  }

  .xl\\:min-w-1{
    min-width: 0.25rem;
  }

  .xl\\:min-w-2{
    min-width: 0.5rem;
  }

  .xl\\:min-w-3{
    min-width: 0.75rem;
  }

  .xl\\:min-w-4{
    min-width: 1rem;
  }

  .xl\\:min-w-5{
    min-width: 1.25rem;
  }

  .xl\\:min-w-6{
    min-width: 1.5rem;
  }

  .xl\\:min-w-7{
    min-width: 1.75rem;
  }

  .xl\\:min-w-8{
    min-width: 2rem;
  }

  .xl\\:min-w-9{
    min-width: 2.25rem;
  }

  .xl\\:min-w-10{
    min-width: 2.5rem;
  }

  .xl\\:min-w-11{
    min-width: 2.75rem;
  }

  .xl\\:min-w-12{
    min-width: 3rem;
  }

  .xl\\:min-w-14{
    min-width: 3.5rem;
  }

  .xl\\:min-w-15{
    min-width: 3.75rem;
  }

  .xl\\:min-w-16{
    min-width: 4rem;
  }

  .xl\\:min-w-18{
    min-width: 4.5rem;
  }

  .xl\\:min-w-20{
    min-width: 5rem;
  }

  .xl\\:min-w-22{
    min-width: 5.5rem;
  }

  .xl\\:min-w-23{
    min-width: 5.75rem;
  }

  .xl\\:min-w-24{
    min-width: 6rem;
  }

  .xl\\:min-w-25{
    min-width: 6.25rem;
  }

  .xl\\:min-w-26{
    min-width: 6.5rem;
  }

  .xl\\:min-w-28{
    min-width: 7rem;
  }

  .xl\\:min-w-30{
    min-width: 7.5rem;
  }

  .xl\\:min-w-32{
    min-width: 8rem;
  }

  .xl\\:min-w-34{
    min-width: 8.5rem;
  }

  .xl\\:min-w-40{
    min-width: 10rem;
  }

  .xl\\:min-w-42{
    min-width: 10.5rem;
  }

  .xl\\:min-w-44{
    min-width: 11rem;
  }

  .xl\\:min-w-48{
    min-width: 12rem;
  }

  .xl\\:min-w-52{
    min-width: 13rem;
  }

  .xl\\:min-w-54{
    min-width: 13.5rem;
  }

  .xl\\:min-w-56{
    min-width: 14rem;
  }

  .xl\\:min-w-60{
    min-width: 15rem;
  }

  .xl\\:min-w-64{
    min-width: 16rem;
  }

  .xl\\:min-w-68{
    min-width: 17rem;
  }

  .xl\\:min-w-72{
    min-width: 18rem;
  }

  .xl\\:min-w-74{
    min-width: 18.5rem;
  }

  .xl\\:min-w-76{
    min-width: 19rem;
  }

  .xl\\:min-w-78{
    min-width: 19.5rem;
  }

  .xl\\:min-w-80{
    min-width: 20rem;
  }

  .xl\\:min-w-82{
    min-width: 20.5rem;
  }

  .xl\\:min-w-84{
    min-width: 21rem;
  }

  .xl\\:min-w-88{
    min-width: 22rem;
  }

  .xl\\:min-w-92{
    min-width: 23rem;
  }

  .xl\\:min-w-96{
    min-width: 24rem;
  }

  .xl\\:min-w-98{
    min-width: 24.5rem;
  }

  .xl\\:min-w-100{
    min-width: 25rem;
  }

  .xl\\:min-w-104{
    min-width: 26rem;
  }

  .xl\\:min-w-112{
    min-width: 28rem;
  }

  .xl\\:min-w-124{
    min-width: 31rem;
  }

  .xl\\:min-w-128{
    min-width: 32rem;
  }

  .xl\\:min-w-140{
    min-width: 35rem;
  }

  .xl\\:min-w-152{
    min-width: 38rem;
  }

  .xl\\:min-w-160{
    min-width: 40rem;
  }

  .xl\\:min-w-162{
    min-width: 41rem;
  }

  .xl\\:min-w-192{
    min-width: 48rem;
  }

  .xl\\:min-w-208{
    min-width: 52rem;
  }

  .xl\\:min-w-224{
    min-width: 56rem;
  }

  .xl\\:min-w-256{
    min-width: 64rem;
  }

  .xl\\:min-w-px{
    min-width: 1px;
  }

  .xl\\:min-w-full{
    min-width: 100%;
  }

  .xl\\:object-contain{
    object-fit: contain;
  }

  .xl\\:object-cover{
    object-fit: cover;
  }

  .xl\\:object-fill{
    object-fit: fill;
  }

  .xl\\:object-none{
    object-fit: none;
  }

  .xl\\:object-scale-down{
    object-fit: scale-down;
  }

  .xl\\:object-bottom{
    object-position: bottom;
  }

  .xl\\:object-center{
    object-position: center;
  }

  .xl\\:object-left{
    object-position: left;
  }

  .xl\\:object-left-bottom{
    object-position: left bottom;
  }

  .xl\\:object-left-top{
    object-position: left top;
  }

  .xl\\:object-right{
    object-position: right;
  }

  .xl\\:object-right-bottom{
    object-position: right bottom;
  }

  .xl\\:object-right-top{
    object-position: right top;
  }

  .xl\\:object-top{
    object-position: top;
  }

  .xl\\:opacity-0{
    opacity: 0;
  }

  .xl\\:opacity-25{
    opacity: .25;
  }

  .xl\\:opacity-50{
    opacity: .5;
  }

  .xl\\:opacity-75{
    opacity: .75;
  }

  .xl\\:opacity-100{
    opacity: 1;
  }

  .xl\\:overflow-auto{
    overflow: auto;
  }

  .xl\\:overflow-hidden{
    overflow: hidden;
  }

  .xl\\:overflow-visible{
    overflow: visible;
  }

  .xl\\:overflow-scroll{
    overflow: scroll;
  }

  .xl\\:overflow-x-auto{
    overflow-x: auto;
  }

  .xl\\:overflow-y-auto{
    overflow-y: auto;
  }

  .xl\\:overflow-x-hidden{
    overflow-x: hidden;
  }

  .xl\\:overflow-y-hidden{
    overflow-y: hidden;
  }

  .xl\\:overflow-x-visible{
    overflow-x: visible;
  }

  .xl\\:overflow-y-visible{
    overflow-y: visible;
  }

  .xl\\:overflow-x-scroll{
    overflow-x: scroll;
  }

  .xl\\:overflow-y-scroll{
    overflow-y: scroll;
  }

  .xl\\:scrolling-touch{
    -webkit-overflow-scrolling: touch;
  }

  .xl\\:scrolling-auto{
    -webkit-overflow-scrolling: auto;
  }

  .xl\\:overscroll-auto{
    overscroll-behavior: auto;
  }

  .xl\\:overscroll-contain{
    overscroll-behavior: contain;
  }

  .xl\\:overscroll-none{
    overscroll-behavior: none;
  }

  .xl\\:overscroll-y-auto{
    overscroll-behavior-y: auto;
  }

  .xl\\:overscroll-y-contain{
    overscroll-behavior-y: contain;
  }

  .xl\\:overscroll-y-none{
    overscroll-behavior-y: none;
  }

  .xl\\:overscroll-x-auto{
    overscroll-behavior-x: auto;
  }

  .xl\\:overscroll-x-contain{
    overscroll-behavior-x: contain;
  }

  .xl\\:overscroll-x-none{
    overscroll-behavior-x: none;
  }

  .xl\\:p-0{
    padding: 0;
  }

  .xl\\:p-1{
    padding: 0.25rem;
  }

  .xl\\:p-2{
    padding: 0.5rem;
  }

  .xl\\:p-3{
    padding: 0.75rem;
  }

  .xl\\:p-4{
    padding: 1rem;
  }

  .xl\\:p-5{
    padding: 1.25rem;
  }

  .xl\\:p-6{
    padding: 1.5rem;
  }

  .xl\\:p-7{
    padding: 1.75rem;
  }

  .xl\\:p-8{
    padding: 2rem;
  }

  .xl\\:p-9{
    padding: 2.25rem;
  }

  .xl\\:p-10{
    padding: 2.5rem;
  }

  .xl\\:p-11{
    padding: 2.75rem;
  }

  .xl\\:p-12{
    padding: 3rem;
  }

  .xl\\:p-14{
    padding: 3.5rem;
  }

  .xl\\:p-15{
    padding: 3.75rem;
  }

  .xl\\:p-16{
    padding: 4rem;
  }

  .xl\\:p-18{
    padding: 4.5rem;
  }

  .xl\\:p-20{
    padding: 5rem;
  }

  .xl\\:p-22{
    padding: 5.5rem;
  }

  .xl\\:p-23{
    padding: 5.75rem;
  }

  .xl\\:p-24{
    padding: 6rem;
  }

  .xl\\:p-25{
    padding: 6.25rem;
  }

  .xl\\:p-26{
    padding: 6.5rem;
  }

  .xl\\:p-28{
    padding: 7rem;
  }

  .xl\\:p-30{
    padding: 7.5rem;
  }

  .xl\\:p-32{
    padding: 8rem;
  }

  .xl\\:p-34{
    padding: 8.5rem;
  }

  .xl\\:p-40{
    padding: 10rem;
  }

  .xl\\:p-42{
    padding: 10.5rem;
  }

  .xl\\:p-44{
    padding: 11rem;
  }

  .xl\\:p-48{
    padding: 12rem;
  }

  .xl\\:p-52{
    padding: 13rem;
  }

  .xl\\:p-54{
    padding: 13.5rem;
  }

  .xl\\:p-56{
    padding: 14rem;
  }

  .xl\\:p-60{
    padding: 15rem;
  }

  .xl\\:p-64{
    padding: 16rem;
  }

  .xl\\:p-68{
    padding: 17rem;
  }

  .xl\\:p-72{
    padding: 18rem;
  }

  .xl\\:p-74{
    padding: 18.5rem;
  }

  .xl\\:p-76{
    padding: 19rem;
  }

  .xl\\:p-78{
    padding: 19.5rem;
  }

  .xl\\:p-80{
    padding: 20rem;
  }

  .xl\\:p-82{
    padding: 20.5rem;
  }

  .xl\\:p-84{
    padding: 21rem;
  }

  .xl\\:p-88{
    padding: 22rem;
  }

  .xl\\:p-92{
    padding: 23rem;
  }

  .xl\\:p-96{
    padding: 24rem;
  }

  .xl\\:p-98{
    padding: 24.5rem;
  }

  .xl\\:p-100{
    padding: 25rem;
  }

  .xl\\:p-104{
    padding: 26rem;
  }

  .xl\\:p-112{
    padding: 28rem;
  }

  .xl\\:p-124{
    padding: 31rem;
  }

  .xl\\:p-128{
    padding: 32rem;
  }

  .xl\\:p-140{
    padding: 35rem;
  }

  .xl\\:p-152{
    padding: 38rem;
  }

  .xl\\:p-160{
    padding: 40rem;
  }

  .xl\\:p-162{
    padding: 41rem;
  }

  .xl\\:p-192{
    padding: 48rem;
  }

  .xl\\:p-208{
    padding: 52rem;
  }

  .xl\\:p-224{
    padding: 56rem;
  }

  .xl\\:p-256{
    padding: 64rem;
  }

  .xl\\:p-px{
    padding: 1px;
  }

  .xl\\:py-0{
    padding-top: 0;
    padding-bottom: 0;
  }

  .xl\\:px-0{
    padding-left: 0;
    padding-right: 0;
  }

  .xl\\:py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .xl\\:px-1{
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .xl\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .xl\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .xl\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .xl\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .xl\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .xl\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .xl\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .xl\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .xl\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .xl\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .xl\\:py-7{
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .xl\\:px-7{
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .xl\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .xl\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .xl\\:py-9{
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .xl\\:px-9{
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .xl\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .xl\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .xl\\:py-11{
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .xl\\:px-11{
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .xl\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .xl\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .xl\\:py-14{
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .xl\\:px-14{
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .xl\\:py-15{
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .xl\\:px-15{
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .xl\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .xl\\:px-16{
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .xl\\:py-18{
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .xl\\:px-18{
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .xl\\:py-20{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .xl\\:px-20{
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .xl\\:py-22{
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .xl\\:px-22{
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .xl\\:py-23{
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .xl\\:px-23{
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .xl\\:py-24{
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .xl\\:px-24{
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .xl\\:py-25{
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .xl\\:px-25{
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .xl\\:py-26{
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .xl\\:px-26{
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .xl\\:py-28{
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .xl\\:px-28{
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .xl\\:py-30{
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .xl\\:px-30{
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .xl\\:py-32{
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .xl\\:px-32{
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .xl\\:py-34{
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .xl\\:px-34{
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .xl\\:py-40{
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .xl\\:px-40{
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .xl\\:py-42{
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .xl\\:px-42{
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .xl\\:py-44{
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .xl\\:px-44{
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .xl\\:py-48{
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .xl\\:px-48{
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .xl\\:py-52{
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .xl\\:px-52{
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .xl\\:py-54{
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .xl\\:px-54{
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .xl\\:py-56{
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .xl\\:px-56{
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .xl\\:py-60{
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .xl\\:px-60{
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .xl\\:py-64{
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .xl\\:px-64{
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .xl\\:py-68{
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .xl\\:px-68{
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .xl\\:py-72{
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .xl\\:px-72{
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .xl\\:py-74{
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .xl\\:px-74{
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .xl\\:py-76{
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .xl\\:px-76{
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .xl\\:py-78{
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .xl\\:px-78{
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .xl\\:py-80{
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .xl\\:px-80{
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .xl\\:py-82{
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .xl\\:px-82{
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .xl\\:py-84{
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .xl\\:px-84{
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .xl\\:py-88{
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .xl\\:px-88{
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .xl\\:py-92{
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .xl\\:px-92{
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .xl\\:py-96{
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .xl\\:px-96{
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .xl\\:py-98{
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .xl\\:px-98{
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .xl\\:py-100{
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .xl\\:px-100{
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .xl\\:py-104{
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .xl\\:px-104{
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .xl\\:py-112{
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .xl\\:px-112{
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .xl\\:py-124{
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .xl\\:px-124{
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .xl\\:py-128{
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .xl\\:px-128{
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .xl\\:py-140{
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .xl\\:px-140{
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .xl\\:py-152{
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .xl\\:px-152{
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .xl\\:py-160{
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .xl\\:px-160{
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .xl\\:py-162{
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .xl\\:px-162{
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .xl\\:py-192{
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .xl\\:px-192{
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .xl\\:py-208{
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .xl\\:px-208{
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .xl\\:py-224{
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .xl\\:px-224{
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .xl\\:py-256{
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .xl\\:px-256{
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .xl\\:py-px{
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .xl\\:px-px{
    padding-left: 1px;
    padding-right: 1px;
  }

  .xl\\:pt-0{
    padding-top: 0;
  }

  .xl\\:pr-0{
    padding-right: 0;
  }

  .xl\\:pb-0{
    padding-bottom: 0;
  }

  .xl\\:pl-0{
    padding-left: 0;
  }

  .xl\\:pt-1{
    padding-top: 0.25rem;
  }

  .xl\\:pr-1{
    padding-right: 0.25rem;
  }

  .xl\\:pb-1{
    padding-bottom: 0.25rem;
  }

  .xl\\:pl-1{
    padding-left: 0.25rem;
  }

  .xl\\:pt-2{
    padding-top: 0.5rem;
  }

  .xl\\:pr-2{
    padding-right: 0.5rem;
  }

  .xl\\:pb-2{
    padding-bottom: 0.5rem;
  }

  .xl\\:pl-2{
    padding-left: 0.5rem;
  }

  .xl\\:pt-3{
    padding-top: 0.75rem;
  }

  .xl\\:pr-3{
    padding-right: 0.75rem;
  }

  .xl\\:pb-3{
    padding-bottom: 0.75rem;
  }

  .xl\\:pl-3{
    padding-left: 0.75rem;
  }

  .xl\\:pt-4{
    padding-top: 1rem;
  }

  .xl\\:pr-4{
    padding-right: 1rem;
  }

  .xl\\:pb-4{
    padding-bottom: 1rem;
  }

  .xl\\:pl-4{
    padding-left: 1rem;
  }

  .xl\\:pt-5{
    padding-top: 1.25rem;
  }

  .xl\\:pr-5{
    padding-right: 1.25rem;
  }

  .xl\\:pb-5{
    padding-bottom: 1.25rem;
  }

  .xl\\:pl-5{
    padding-left: 1.25rem;
  }

  .xl\\:pt-6{
    padding-top: 1.5rem;
  }

  .xl\\:pr-6{
    padding-right: 1.5rem;
  }

  .xl\\:pb-6{
    padding-bottom: 1.5rem;
  }

  .xl\\:pl-6{
    padding-left: 1.5rem;
  }

  .xl\\:pt-7{
    padding-top: 1.75rem;
  }

  .xl\\:pr-7{
    padding-right: 1.75rem;
  }

  .xl\\:pb-7{
    padding-bottom: 1.75rem;
  }

  .xl\\:pl-7{
    padding-left: 1.75rem;
  }

  .xl\\:pt-8{
    padding-top: 2rem;
  }

  .xl\\:pr-8{
    padding-right: 2rem;
  }

  .xl\\:pb-8{
    padding-bottom: 2rem;
  }

  .xl\\:pl-8{
    padding-left: 2rem;
  }

  .xl\\:pt-9{
    padding-top: 2.25rem;
  }

  .xl\\:pr-9{
    padding-right: 2.25rem;
  }

  .xl\\:pb-9{
    padding-bottom: 2.25rem;
  }

  .xl\\:pl-9{
    padding-left: 2.25rem;
  }

  .xl\\:pt-10{
    padding-top: 2.5rem;
  }

  .xl\\:pr-10{
    padding-right: 2.5rem;
  }

  .xl\\:pb-10{
    padding-bottom: 2.5rem;
  }

  .xl\\:pl-10{
    padding-left: 2.5rem;
  }

  .xl\\:pt-11{
    padding-top: 2.75rem;
  }

  .xl\\:pr-11{
    padding-right: 2.75rem;
  }

  .xl\\:pb-11{
    padding-bottom: 2.75rem;
  }

  .xl\\:pl-11{
    padding-left: 2.75rem;
  }

  .xl\\:pt-12{
    padding-top: 3rem;
  }

  .xl\\:pr-12{
    padding-right: 3rem;
  }

  .xl\\:pb-12{
    padding-bottom: 3rem;
  }

  .xl\\:pl-12{
    padding-left: 3rem;
  }

  .xl\\:pt-14{
    padding-top: 3.5rem;
  }

  .xl\\:pr-14{
    padding-right: 3.5rem;
  }

  .xl\\:pb-14{
    padding-bottom: 3.5rem;
  }

  .xl\\:pl-14{
    padding-left: 3.5rem;
  }

  .xl\\:pt-15{
    padding-top: 3.75rem;
  }

  .xl\\:pr-15{
    padding-right: 3.75rem;
  }

  .xl\\:pb-15{
    padding-bottom: 3.75rem;
  }

  .xl\\:pl-15{
    padding-left: 3.75rem;
  }

  .xl\\:pt-16{
    padding-top: 4rem;
  }

  .xl\\:pr-16{
    padding-right: 4rem;
  }

  .xl\\:pb-16{
    padding-bottom: 4rem;
  }

  .xl\\:pl-16{
    padding-left: 4rem;
  }

  .xl\\:pt-18{
    padding-top: 4.5rem;
  }

  .xl\\:pr-18{
    padding-right: 4.5rem;
  }

  .xl\\:pb-18{
    padding-bottom: 4.5rem;
  }

  .xl\\:pl-18{
    padding-left: 4.5rem;
  }

  .xl\\:pt-20{
    padding-top: 5rem;
  }

  .xl\\:pr-20{
    padding-right: 5rem;
  }

  .xl\\:pb-20{
    padding-bottom: 5rem;
  }

  .xl\\:pl-20{
    padding-left: 5rem;
  }

  .xl\\:pt-22{
    padding-top: 5.5rem;
  }

  .xl\\:pr-22{
    padding-right: 5.5rem;
  }

  .xl\\:pb-22{
    padding-bottom: 5.5rem;
  }

  .xl\\:pl-22{
    padding-left: 5.5rem;
  }

  .xl\\:pt-23{
    padding-top: 5.75rem;
  }

  .xl\\:pr-23{
    padding-right: 5.75rem;
  }

  .xl\\:pb-23{
    padding-bottom: 5.75rem;
  }

  .xl\\:pl-23{
    padding-left: 5.75rem;
  }

  .xl\\:pt-24{
    padding-top: 6rem;
  }

  .xl\\:pr-24{
    padding-right: 6rem;
  }

  .xl\\:pb-24{
    padding-bottom: 6rem;
  }

  .xl\\:pl-24{
    padding-left: 6rem;
  }

  .xl\\:pt-25{
    padding-top: 6.25rem;
  }

  .xl\\:pr-25{
    padding-right: 6.25rem;
  }

  .xl\\:pb-25{
    padding-bottom: 6.25rem;
  }

  .xl\\:pl-25{
    padding-left: 6.25rem;
  }

  .xl\\:pt-26{
    padding-top: 6.5rem;
  }

  .xl\\:pr-26{
    padding-right: 6.5rem;
  }

  .xl\\:pb-26{
    padding-bottom: 6.5rem;
  }

  .xl\\:pl-26{
    padding-left: 6.5rem;
  }

  .xl\\:pt-28{
    padding-top: 7rem;
  }

  .xl\\:pr-28{
    padding-right: 7rem;
  }

  .xl\\:pb-28{
    padding-bottom: 7rem;
  }

  .xl\\:pl-28{
    padding-left: 7rem;
  }

  .xl\\:pt-30{
    padding-top: 7.5rem;
  }

  .xl\\:pr-30{
    padding-right: 7.5rem;
  }

  .xl\\:pb-30{
    padding-bottom: 7.5rem;
  }

  .xl\\:pl-30{
    padding-left: 7.5rem;
  }

  .xl\\:pt-32{
    padding-top: 8rem;
  }

  .xl\\:pr-32{
    padding-right: 8rem;
  }

  .xl\\:pb-32{
    padding-bottom: 8rem;
  }

  .xl\\:pl-32{
    padding-left: 8rem;
  }

  .xl\\:pt-34{
    padding-top: 8.5rem;
  }

  .xl\\:pr-34{
    padding-right: 8.5rem;
  }

  .xl\\:pb-34{
    padding-bottom: 8.5rem;
  }

  .xl\\:pl-34{
    padding-left: 8.5rem;
  }

  .xl\\:pt-40{
    padding-top: 10rem;
  }

  .xl\\:pr-40{
    padding-right: 10rem;
  }

  .xl\\:pb-40{
    padding-bottom: 10rem;
  }

  .xl\\:pl-40{
    padding-left: 10rem;
  }

  .xl\\:pt-42{
    padding-top: 10.5rem;
  }

  .xl\\:pr-42{
    padding-right: 10.5rem;
  }

  .xl\\:pb-42{
    padding-bottom: 10.5rem;
  }

  .xl\\:pl-42{
    padding-left: 10.5rem;
  }

  .xl\\:pt-44{
    padding-top: 11rem;
  }

  .xl\\:pr-44{
    padding-right: 11rem;
  }

  .xl\\:pb-44{
    padding-bottom: 11rem;
  }

  .xl\\:pl-44{
    padding-left: 11rem;
  }

  .xl\\:pt-48{
    padding-top: 12rem;
  }

  .xl\\:pr-48{
    padding-right: 12rem;
  }

  .xl\\:pb-48{
    padding-bottom: 12rem;
  }

  .xl\\:pl-48{
    padding-left: 12rem;
  }

  .xl\\:pt-52{
    padding-top: 13rem;
  }

  .xl\\:pr-52{
    padding-right: 13rem;
  }

  .xl\\:pb-52{
    padding-bottom: 13rem;
  }

  .xl\\:pl-52{
    padding-left: 13rem;
  }

  .xl\\:pt-54{
    padding-top: 13.5rem;
  }

  .xl\\:pr-54{
    padding-right: 13.5rem;
  }

  .xl\\:pb-54{
    padding-bottom: 13.5rem;
  }

  .xl\\:pl-54{
    padding-left: 13.5rem;
  }

  .xl\\:pt-56{
    padding-top: 14rem;
  }

  .xl\\:pr-56{
    padding-right: 14rem;
  }

  .xl\\:pb-56{
    padding-bottom: 14rem;
  }

  .xl\\:pl-56{
    padding-left: 14rem;
  }

  .xl\\:pt-60{
    padding-top: 15rem;
  }

  .xl\\:pr-60{
    padding-right: 15rem;
  }

  .xl\\:pb-60{
    padding-bottom: 15rem;
  }

  .xl\\:pl-60{
    padding-left: 15rem;
  }

  .xl\\:pt-64{
    padding-top: 16rem;
  }

  .xl\\:pr-64{
    padding-right: 16rem;
  }

  .xl\\:pb-64{
    padding-bottom: 16rem;
  }

  .xl\\:pl-64{
    padding-left: 16rem;
  }

  .xl\\:pt-68{
    padding-top: 17rem;
  }

  .xl\\:pr-68{
    padding-right: 17rem;
  }

  .xl\\:pb-68{
    padding-bottom: 17rem;
  }

  .xl\\:pl-68{
    padding-left: 17rem;
  }

  .xl\\:pt-72{
    padding-top: 18rem;
  }

  .xl\\:pr-72{
    padding-right: 18rem;
  }

  .xl\\:pb-72{
    padding-bottom: 18rem;
  }

  .xl\\:pl-72{
    padding-left: 18rem;
  }

  .xl\\:pt-74{
    padding-top: 18.5rem;
  }

  .xl\\:pr-74{
    padding-right: 18.5rem;
  }

  .xl\\:pb-74{
    padding-bottom: 18.5rem;
  }

  .xl\\:pl-74{
    padding-left: 18.5rem;
  }

  .xl\\:pt-76{
    padding-top: 19rem;
  }

  .xl\\:pr-76{
    padding-right: 19rem;
  }

  .xl\\:pb-76{
    padding-bottom: 19rem;
  }

  .xl\\:pl-76{
    padding-left: 19rem;
  }

  .xl\\:pt-78{
    padding-top: 19.5rem;
  }

  .xl\\:pr-78{
    padding-right: 19.5rem;
  }

  .xl\\:pb-78{
    padding-bottom: 19.5rem;
  }

  .xl\\:pl-78{
    padding-left: 19.5rem;
  }

  .xl\\:pt-80{
    padding-top: 20rem;
  }

  .xl\\:pr-80{
    padding-right: 20rem;
  }

  .xl\\:pb-80{
    padding-bottom: 20rem;
  }

  .xl\\:pl-80{
    padding-left: 20rem;
  }

  .xl\\:pt-82{
    padding-top: 20.5rem;
  }

  .xl\\:pr-82{
    padding-right: 20.5rem;
  }

  .xl\\:pb-82{
    padding-bottom: 20.5rem;
  }

  .xl\\:pl-82{
    padding-left: 20.5rem;
  }

  .xl\\:pt-84{
    padding-top: 21rem;
  }

  .xl\\:pr-84{
    padding-right: 21rem;
  }

  .xl\\:pb-84{
    padding-bottom: 21rem;
  }

  .xl\\:pl-84{
    padding-left: 21rem;
  }

  .xl\\:pt-88{
    padding-top: 22rem;
  }

  .xl\\:pr-88{
    padding-right: 22rem;
  }

  .xl\\:pb-88{
    padding-bottom: 22rem;
  }

  .xl\\:pl-88{
    padding-left: 22rem;
  }

  .xl\\:pt-92{
    padding-top: 23rem;
  }

  .xl\\:pr-92{
    padding-right: 23rem;
  }

  .xl\\:pb-92{
    padding-bottom: 23rem;
  }

  .xl\\:pl-92{
    padding-left: 23rem;
  }

  .xl\\:pt-96{
    padding-top: 24rem;
  }

  .xl\\:pr-96{
    padding-right: 24rem;
  }

  .xl\\:pb-96{
    padding-bottom: 24rem;
  }

  .xl\\:pl-96{
    padding-left: 24rem;
  }

  .xl\\:pt-98{
    padding-top: 24.5rem;
  }

  .xl\\:pr-98{
    padding-right: 24.5rem;
  }

  .xl\\:pb-98{
    padding-bottom: 24.5rem;
  }

  .xl\\:pl-98{
    padding-left: 24.5rem;
  }

  .xl\\:pt-100{
    padding-top: 25rem;
  }

  .xl\\:pr-100{
    padding-right: 25rem;
  }

  .xl\\:pb-100{
    padding-bottom: 25rem;
  }

  .xl\\:pl-100{
    padding-left: 25rem;
  }

  .xl\\:pt-104{
    padding-top: 26rem;
  }

  .xl\\:pr-104{
    padding-right: 26rem;
  }

  .xl\\:pb-104{
    padding-bottom: 26rem;
  }

  .xl\\:pl-104{
    padding-left: 26rem;
  }

  .xl\\:pt-112{
    padding-top: 28rem;
  }

  .xl\\:pr-112{
    padding-right: 28rem;
  }

  .xl\\:pb-112{
    padding-bottom: 28rem;
  }

  .xl\\:pl-112{
    padding-left: 28rem;
  }

  .xl\\:pt-124{
    padding-top: 31rem;
  }

  .xl\\:pr-124{
    padding-right: 31rem;
  }

  .xl\\:pb-124{
    padding-bottom: 31rem;
  }

  .xl\\:pl-124{
    padding-left: 31rem;
  }

  .xl\\:pt-128{
    padding-top: 32rem;
  }

  .xl\\:pr-128{
    padding-right: 32rem;
  }

  .xl\\:pb-128{
    padding-bottom: 32rem;
  }

  .xl\\:pl-128{
    padding-left: 32rem;
  }

  .xl\\:pt-140{
    padding-top: 35rem;
  }

  .xl\\:pr-140{
    padding-right: 35rem;
  }

  .xl\\:pb-140{
    padding-bottom: 35rem;
  }

  .xl\\:pl-140{
    padding-left: 35rem;
  }

  .xl\\:pt-152{
    padding-top: 38rem;
  }

  .xl\\:pr-152{
    padding-right: 38rem;
  }

  .xl\\:pb-152{
    padding-bottom: 38rem;
  }

  .xl\\:pl-152{
    padding-left: 38rem;
  }

  .xl\\:pt-160{
    padding-top: 40rem;
  }

  .xl\\:pr-160{
    padding-right: 40rem;
  }

  .xl\\:pb-160{
    padding-bottom: 40rem;
  }

  .xl\\:pl-160{
    padding-left: 40rem;
  }

  .xl\\:pt-162{
    padding-top: 41rem;
  }

  .xl\\:pr-162{
    padding-right: 41rem;
  }

  .xl\\:pb-162{
    padding-bottom: 41rem;
  }

  .xl\\:pl-162{
    padding-left: 41rem;
  }

  .xl\\:pt-192{
    padding-top: 48rem;
  }

  .xl\\:pr-192{
    padding-right: 48rem;
  }

  .xl\\:pb-192{
    padding-bottom: 48rem;
  }

  .xl\\:pl-192{
    padding-left: 48rem;
  }

  .xl\\:pt-208{
    padding-top: 52rem;
  }

  .xl\\:pr-208{
    padding-right: 52rem;
  }

  .xl\\:pb-208{
    padding-bottom: 52rem;
  }

  .xl\\:pl-208{
    padding-left: 52rem;
  }

  .xl\\:pt-224{
    padding-top: 56rem;
  }

  .xl\\:pr-224{
    padding-right: 56rem;
  }

  .xl\\:pb-224{
    padding-bottom: 56rem;
  }

  .xl\\:pl-224{
    padding-left: 56rem;
  }

  .xl\\:pt-256{
    padding-top: 64rem;
  }

  .xl\\:pr-256{
    padding-right: 64rem;
  }

  .xl\\:pb-256{
    padding-bottom: 64rem;
  }

  .xl\\:pl-256{
    padding-left: 64rem;
  }

  .xl\\:pt-px{
    padding-top: 1px;
  }

  .xl\\:pr-px{
    padding-right: 1px;
  }

  .xl\\:pb-px{
    padding-bottom: 1px;
  }

  .xl\\:pl-px{
    padding-left: 1px;
  }

  .xl\\:odd\\:p-0:nth-child(odd){
    padding: 0;
  }

  .xl\\:odd\\:p-1:nth-child(odd){
    padding: 0.25rem;
  }

  .xl\\:odd\\:p-2:nth-child(odd){
    padding: 0.5rem;
  }

  .xl\\:odd\\:p-3:nth-child(odd){
    padding: 0.75rem;
  }

  .xl\\:odd\\:p-4:nth-child(odd){
    padding: 1rem;
  }

  .xl\\:odd\\:p-5:nth-child(odd){
    padding: 1.25rem;
  }

  .xl\\:odd\\:p-6:nth-child(odd){
    padding: 1.5rem;
  }

  .xl\\:odd\\:p-7:nth-child(odd){
    padding: 1.75rem;
  }

  .xl\\:odd\\:p-8:nth-child(odd){
    padding: 2rem;
  }

  .xl\\:odd\\:p-9:nth-child(odd){
    padding: 2.25rem;
  }

  .xl\\:odd\\:p-10:nth-child(odd){
    padding: 2.5rem;
  }

  .xl\\:odd\\:p-11:nth-child(odd){
    padding: 2.75rem;
  }

  .xl\\:odd\\:p-12:nth-child(odd){
    padding: 3rem;
  }

  .xl\\:odd\\:p-14:nth-child(odd){
    padding: 3.5rem;
  }

  .xl\\:odd\\:p-15:nth-child(odd){
    padding: 3.75rem;
  }

  .xl\\:odd\\:p-16:nth-child(odd){
    padding: 4rem;
  }

  .xl\\:odd\\:p-18:nth-child(odd){
    padding: 4.5rem;
  }

  .xl\\:odd\\:p-20:nth-child(odd){
    padding: 5rem;
  }

  .xl\\:odd\\:p-22:nth-child(odd){
    padding: 5.5rem;
  }

  .xl\\:odd\\:p-23:nth-child(odd){
    padding: 5.75rem;
  }

  .xl\\:odd\\:p-24:nth-child(odd){
    padding: 6rem;
  }

  .xl\\:odd\\:p-25:nth-child(odd){
    padding: 6.25rem;
  }

  .xl\\:odd\\:p-26:nth-child(odd){
    padding: 6.5rem;
  }

  .xl\\:odd\\:p-28:nth-child(odd){
    padding: 7rem;
  }

  .xl\\:odd\\:p-30:nth-child(odd){
    padding: 7.5rem;
  }

  .xl\\:odd\\:p-32:nth-child(odd){
    padding: 8rem;
  }

  .xl\\:odd\\:p-34:nth-child(odd){
    padding: 8.5rem;
  }

  .xl\\:odd\\:p-40:nth-child(odd){
    padding: 10rem;
  }

  .xl\\:odd\\:p-42:nth-child(odd){
    padding: 10.5rem;
  }

  .xl\\:odd\\:p-44:nth-child(odd){
    padding: 11rem;
  }

  .xl\\:odd\\:p-48:nth-child(odd){
    padding: 12rem;
  }

  .xl\\:odd\\:p-52:nth-child(odd){
    padding: 13rem;
  }

  .xl\\:odd\\:p-54:nth-child(odd){
    padding: 13.5rem;
  }

  .xl\\:odd\\:p-56:nth-child(odd){
    padding: 14rem;
  }

  .xl\\:odd\\:p-60:nth-child(odd){
    padding: 15rem;
  }

  .xl\\:odd\\:p-64:nth-child(odd){
    padding: 16rem;
  }

  .xl\\:odd\\:p-68:nth-child(odd){
    padding: 17rem;
  }

  .xl\\:odd\\:p-72:nth-child(odd){
    padding: 18rem;
  }

  .xl\\:odd\\:p-74:nth-child(odd){
    padding: 18.5rem;
  }

  .xl\\:odd\\:p-76:nth-child(odd){
    padding: 19rem;
  }

  .xl\\:odd\\:p-78:nth-child(odd){
    padding: 19.5rem;
  }

  .xl\\:odd\\:p-80:nth-child(odd){
    padding: 20rem;
  }

  .xl\\:odd\\:p-82:nth-child(odd){
    padding: 20.5rem;
  }

  .xl\\:odd\\:p-84:nth-child(odd){
    padding: 21rem;
  }

  .xl\\:odd\\:p-88:nth-child(odd){
    padding: 22rem;
  }

  .xl\\:odd\\:p-92:nth-child(odd){
    padding: 23rem;
  }

  .xl\\:odd\\:p-96:nth-child(odd){
    padding: 24rem;
  }

  .xl\\:odd\\:p-98:nth-child(odd){
    padding: 24.5rem;
  }

  .xl\\:odd\\:p-100:nth-child(odd){
    padding: 25rem;
  }

  .xl\\:odd\\:p-104:nth-child(odd){
    padding: 26rem;
  }

  .xl\\:odd\\:p-112:nth-child(odd){
    padding: 28rem;
  }

  .xl\\:odd\\:p-124:nth-child(odd){
    padding: 31rem;
  }

  .xl\\:odd\\:p-128:nth-child(odd){
    padding: 32rem;
  }

  .xl\\:odd\\:p-140:nth-child(odd){
    padding: 35rem;
  }

  .xl\\:odd\\:p-152:nth-child(odd){
    padding: 38rem;
  }

  .xl\\:odd\\:p-160:nth-child(odd){
    padding: 40rem;
  }

  .xl\\:odd\\:p-162:nth-child(odd){
    padding: 41rem;
  }

  .xl\\:odd\\:p-192:nth-child(odd){
    padding: 48rem;
  }

  .xl\\:odd\\:p-208:nth-child(odd){
    padding: 52rem;
  }

  .xl\\:odd\\:p-224:nth-child(odd){
    padding: 56rem;
  }

  .xl\\:odd\\:p-256:nth-child(odd){
    padding: 64rem;
  }

  .xl\\:odd\\:p-px:nth-child(odd){
    padding: 1px;
  }

  .xl\\:odd\\:py-0:nth-child(odd){
    padding-top: 0;
    padding-bottom: 0;
  }

  .xl\\:odd\\:px-0:nth-child(odd){
    padding-left: 0;
    padding-right: 0;
  }

  .xl\\:odd\\:py-1:nth-child(odd){
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .xl\\:odd\\:px-1:nth-child(odd){
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .xl\\:odd\\:py-2:nth-child(odd){
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .xl\\:odd\\:px-2:nth-child(odd){
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .xl\\:odd\\:py-3:nth-child(odd){
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .xl\\:odd\\:px-3:nth-child(odd){
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .xl\\:odd\\:py-4:nth-child(odd){
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .xl\\:odd\\:px-4:nth-child(odd){
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .xl\\:odd\\:py-5:nth-child(odd){
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .xl\\:odd\\:px-5:nth-child(odd){
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .xl\\:odd\\:py-6:nth-child(odd){
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .xl\\:odd\\:px-6:nth-child(odd){
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .xl\\:odd\\:py-7:nth-child(odd){
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .xl\\:odd\\:px-7:nth-child(odd){
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .xl\\:odd\\:py-8:nth-child(odd){
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .xl\\:odd\\:px-8:nth-child(odd){
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .xl\\:odd\\:py-9:nth-child(odd){
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .xl\\:odd\\:px-9:nth-child(odd){
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .xl\\:odd\\:py-10:nth-child(odd){
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .xl\\:odd\\:px-10:nth-child(odd){
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .xl\\:odd\\:py-11:nth-child(odd){
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .xl\\:odd\\:px-11:nth-child(odd){
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .xl\\:odd\\:py-12:nth-child(odd){
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .xl\\:odd\\:px-12:nth-child(odd){
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .xl\\:odd\\:py-14:nth-child(odd){
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .xl\\:odd\\:px-14:nth-child(odd){
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .xl\\:odd\\:py-15:nth-child(odd){
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .xl\\:odd\\:px-15:nth-child(odd){
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .xl\\:odd\\:py-16:nth-child(odd){
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .xl\\:odd\\:px-16:nth-child(odd){
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .xl\\:odd\\:py-18:nth-child(odd){
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .xl\\:odd\\:px-18:nth-child(odd){
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .xl\\:odd\\:py-20:nth-child(odd){
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .xl\\:odd\\:px-20:nth-child(odd){
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .xl\\:odd\\:py-22:nth-child(odd){
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .xl\\:odd\\:px-22:nth-child(odd){
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .xl\\:odd\\:py-23:nth-child(odd){
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .xl\\:odd\\:px-23:nth-child(odd){
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .xl\\:odd\\:py-24:nth-child(odd){
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .xl\\:odd\\:px-24:nth-child(odd){
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .xl\\:odd\\:py-25:nth-child(odd){
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .xl\\:odd\\:px-25:nth-child(odd){
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .xl\\:odd\\:py-26:nth-child(odd){
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .xl\\:odd\\:px-26:nth-child(odd){
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .xl\\:odd\\:py-28:nth-child(odd){
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .xl\\:odd\\:px-28:nth-child(odd){
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .xl\\:odd\\:py-30:nth-child(odd){
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .xl\\:odd\\:px-30:nth-child(odd){
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .xl\\:odd\\:py-32:nth-child(odd){
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .xl\\:odd\\:px-32:nth-child(odd){
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .xl\\:odd\\:py-34:nth-child(odd){
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .xl\\:odd\\:px-34:nth-child(odd){
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .xl\\:odd\\:py-40:nth-child(odd){
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .xl\\:odd\\:px-40:nth-child(odd){
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .xl\\:odd\\:py-42:nth-child(odd){
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .xl\\:odd\\:px-42:nth-child(odd){
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .xl\\:odd\\:py-44:nth-child(odd){
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .xl\\:odd\\:px-44:nth-child(odd){
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .xl\\:odd\\:py-48:nth-child(odd){
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .xl\\:odd\\:px-48:nth-child(odd){
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .xl\\:odd\\:py-52:nth-child(odd){
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .xl\\:odd\\:px-52:nth-child(odd){
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .xl\\:odd\\:py-54:nth-child(odd){
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .xl\\:odd\\:px-54:nth-child(odd){
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .xl\\:odd\\:py-56:nth-child(odd){
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .xl\\:odd\\:px-56:nth-child(odd){
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .xl\\:odd\\:py-60:nth-child(odd){
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .xl\\:odd\\:px-60:nth-child(odd){
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .xl\\:odd\\:py-64:nth-child(odd){
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .xl\\:odd\\:px-64:nth-child(odd){
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .xl\\:odd\\:py-68:nth-child(odd){
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .xl\\:odd\\:px-68:nth-child(odd){
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .xl\\:odd\\:py-72:nth-child(odd){
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .xl\\:odd\\:px-72:nth-child(odd){
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .xl\\:odd\\:py-74:nth-child(odd){
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .xl\\:odd\\:px-74:nth-child(odd){
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .xl\\:odd\\:py-76:nth-child(odd){
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .xl\\:odd\\:px-76:nth-child(odd){
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .xl\\:odd\\:py-78:nth-child(odd){
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .xl\\:odd\\:px-78:nth-child(odd){
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .xl\\:odd\\:py-80:nth-child(odd){
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .xl\\:odd\\:px-80:nth-child(odd){
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .xl\\:odd\\:py-82:nth-child(odd){
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .xl\\:odd\\:px-82:nth-child(odd){
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .xl\\:odd\\:py-84:nth-child(odd){
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .xl\\:odd\\:px-84:nth-child(odd){
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .xl\\:odd\\:py-88:nth-child(odd){
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .xl\\:odd\\:px-88:nth-child(odd){
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .xl\\:odd\\:py-92:nth-child(odd){
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .xl\\:odd\\:px-92:nth-child(odd){
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .xl\\:odd\\:py-96:nth-child(odd){
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .xl\\:odd\\:px-96:nth-child(odd){
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .xl\\:odd\\:py-98:nth-child(odd){
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .xl\\:odd\\:px-98:nth-child(odd){
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .xl\\:odd\\:py-100:nth-child(odd){
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .xl\\:odd\\:px-100:nth-child(odd){
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .xl\\:odd\\:py-104:nth-child(odd){
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .xl\\:odd\\:px-104:nth-child(odd){
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .xl\\:odd\\:py-112:nth-child(odd){
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .xl\\:odd\\:px-112:nth-child(odd){
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .xl\\:odd\\:py-124:nth-child(odd){
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .xl\\:odd\\:px-124:nth-child(odd){
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .xl\\:odd\\:py-128:nth-child(odd){
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .xl\\:odd\\:px-128:nth-child(odd){
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .xl\\:odd\\:py-140:nth-child(odd){
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .xl\\:odd\\:px-140:nth-child(odd){
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .xl\\:odd\\:py-152:nth-child(odd){
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .xl\\:odd\\:px-152:nth-child(odd){
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .xl\\:odd\\:py-160:nth-child(odd){
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .xl\\:odd\\:px-160:nth-child(odd){
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .xl\\:odd\\:py-162:nth-child(odd){
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .xl\\:odd\\:px-162:nth-child(odd){
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .xl\\:odd\\:py-192:nth-child(odd){
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .xl\\:odd\\:px-192:nth-child(odd){
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .xl\\:odd\\:py-208:nth-child(odd){
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .xl\\:odd\\:px-208:nth-child(odd){
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .xl\\:odd\\:py-224:nth-child(odd){
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .xl\\:odd\\:px-224:nth-child(odd){
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .xl\\:odd\\:py-256:nth-child(odd){
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .xl\\:odd\\:px-256:nth-child(odd){
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .xl\\:odd\\:py-px:nth-child(odd){
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .xl\\:odd\\:px-px:nth-child(odd){
    padding-left: 1px;
    padding-right: 1px;
  }

  .xl\\:odd\\:pt-0:nth-child(odd){
    padding-top: 0;
  }

  .xl\\:odd\\:pr-0:nth-child(odd){
    padding-right: 0;
  }

  .xl\\:odd\\:pb-0:nth-child(odd){
    padding-bottom: 0;
  }

  .xl\\:odd\\:pl-0:nth-child(odd){
    padding-left: 0;
  }

  .xl\\:odd\\:pt-1:nth-child(odd){
    padding-top: 0.25rem;
  }

  .xl\\:odd\\:pr-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  .xl\\:odd\\:pb-1:nth-child(odd){
    padding-bottom: 0.25rem;
  }

  .xl\\:odd\\:pl-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  .xl\\:odd\\:pt-2:nth-child(odd){
    padding-top: 0.5rem;
  }

  .xl\\:odd\\:pr-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  .xl\\:odd\\:pb-2:nth-child(odd){
    padding-bottom: 0.5rem;
  }

  .xl\\:odd\\:pl-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  .xl\\:odd\\:pt-3:nth-child(odd){
    padding-top: 0.75rem;
  }

  .xl\\:odd\\:pr-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  .xl\\:odd\\:pb-3:nth-child(odd){
    padding-bottom: 0.75rem;
  }

  .xl\\:odd\\:pl-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  .xl\\:odd\\:pt-4:nth-child(odd){
    padding-top: 1rem;
  }

  .xl\\:odd\\:pr-4:nth-child(odd){
    padding-right: 1rem;
  }

  .xl\\:odd\\:pb-4:nth-child(odd){
    padding-bottom: 1rem;
  }

  .xl\\:odd\\:pl-4:nth-child(odd){
    padding-left: 1rem;
  }

  .xl\\:odd\\:pt-5:nth-child(odd){
    padding-top: 1.25rem;
  }

  .xl\\:odd\\:pr-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  .xl\\:odd\\:pb-5:nth-child(odd){
    padding-bottom: 1.25rem;
  }

  .xl\\:odd\\:pl-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  .xl\\:odd\\:pt-6:nth-child(odd){
    padding-top: 1.5rem;
  }

  .xl\\:odd\\:pr-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  .xl\\:odd\\:pb-6:nth-child(odd){
    padding-bottom: 1.5rem;
  }

  .xl\\:odd\\:pl-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  .xl\\:odd\\:pt-7:nth-child(odd){
    padding-top: 1.75rem;
  }

  .xl\\:odd\\:pr-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  .xl\\:odd\\:pb-7:nth-child(odd){
    padding-bottom: 1.75rem;
  }

  .xl\\:odd\\:pl-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  .xl\\:odd\\:pt-8:nth-child(odd){
    padding-top: 2rem;
  }

  .xl\\:odd\\:pr-8:nth-child(odd){
    padding-right: 2rem;
  }

  .xl\\:odd\\:pb-8:nth-child(odd){
    padding-bottom: 2rem;
  }

  .xl\\:odd\\:pl-8:nth-child(odd){
    padding-left: 2rem;
  }

  .xl\\:odd\\:pt-9:nth-child(odd){
    padding-top: 2.25rem;
  }

  .xl\\:odd\\:pr-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  .xl\\:odd\\:pb-9:nth-child(odd){
    padding-bottom: 2.25rem;
  }

  .xl\\:odd\\:pl-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  .xl\\:odd\\:pt-10:nth-child(odd){
    padding-top: 2.5rem;
  }

  .xl\\:odd\\:pr-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  .xl\\:odd\\:pb-10:nth-child(odd){
    padding-bottom: 2.5rem;
  }

  .xl\\:odd\\:pl-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  .xl\\:odd\\:pt-11:nth-child(odd){
    padding-top: 2.75rem;
  }

  .xl\\:odd\\:pr-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  .xl\\:odd\\:pb-11:nth-child(odd){
    padding-bottom: 2.75rem;
  }

  .xl\\:odd\\:pl-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  .xl\\:odd\\:pt-12:nth-child(odd){
    padding-top: 3rem;
  }

  .xl\\:odd\\:pr-12:nth-child(odd){
    padding-right: 3rem;
  }

  .xl\\:odd\\:pb-12:nth-child(odd){
    padding-bottom: 3rem;
  }

  .xl\\:odd\\:pl-12:nth-child(odd){
    padding-left: 3rem;
  }

  .xl\\:odd\\:pt-14:nth-child(odd){
    padding-top: 3.5rem;
  }

  .xl\\:odd\\:pr-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  .xl\\:odd\\:pb-14:nth-child(odd){
    padding-bottom: 3.5rem;
  }

  .xl\\:odd\\:pl-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  .xl\\:odd\\:pt-15:nth-child(odd){
    padding-top: 3.75rem;
  }

  .xl\\:odd\\:pr-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  .xl\\:odd\\:pb-15:nth-child(odd){
    padding-bottom: 3.75rem;
  }

  .xl\\:odd\\:pl-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  .xl\\:odd\\:pt-16:nth-child(odd){
    padding-top: 4rem;
  }

  .xl\\:odd\\:pr-16:nth-child(odd){
    padding-right: 4rem;
  }

  .xl\\:odd\\:pb-16:nth-child(odd){
    padding-bottom: 4rem;
  }

  .xl\\:odd\\:pl-16:nth-child(odd){
    padding-left: 4rem;
  }

  .xl\\:odd\\:pt-18:nth-child(odd){
    padding-top: 4.5rem;
  }

  .xl\\:odd\\:pr-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  .xl\\:odd\\:pb-18:nth-child(odd){
    padding-bottom: 4.5rem;
  }

  .xl\\:odd\\:pl-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  .xl\\:odd\\:pt-20:nth-child(odd){
    padding-top: 5rem;
  }

  .xl\\:odd\\:pr-20:nth-child(odd){
    padding-right: 5rem;
  }

  .xl\\:odd\\:pb-20:nth-child(odd){
    padding-bottom: 5rem;
  }

  .xl\\:odd\\:pl-20:nth-child(odd){
    padding-left: 5rem;
  }

  .xl\\:odd\\:pt-22:nth-child(odd){
    padding-top: 5.5rem;
  }

  .xl\\:odd\\:pr-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  .xl\\:odd\\:pb-22:nth-child(odd){
    padding-bottom: 5.5rem;
  }

  .xl\\:odd\\:pl-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  .xl\\:odd\\:pt-23:nth-child(odd){
    padding-top: 5.75rem;
  }

  .xl\\:odd\\:pr-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  .xl\\:odd\\:pb-23:nth-child(odd){
    padding-bottom: 5.75rem;
  }

  .xl\\:odd\\:pl-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  .xl\\:odd\\:pt-24:nth-child(odd){
    padding-top: 6rem;
  }

  .xl\\:odd\\:pr-24:nth-child(odd){
    padding-right: 6rem;
  }

  .xl\\:odd\\:pb-24:nth-child(odd){
    padding-bottom: 6rem;
  }

  .xl\\:odd\\:pl-24:nth-child(odd){
    padding-left: 6rem;
  }

  .xl\\:odd\\:pt-25:nth-child(odd){
    padding-top: 6.25rem;
  }

  .xl\\:odd\\:pr-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  .xl\\:odd\\:pb-25:nth-child(odd){
    padding-bottom: 6.25rem;
  }

  .xl\\:odd\\:pl-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  .xl\\:odd\\:pt-26:nth-child(odd){
    padding-top: 6.5rem;
  }

  .xl\\:odd\\:pr-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  .xl\\:odd\\:pb-26:nth-child(odd){
    padding-bottom: 6.5rem;
  }

  .xl\\:odd\\:pl-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  .xl\\:odd\\:pt-28:nth-child(odd){
    padding-top: 7rem;
  }

  .xl\\:odd\\:pr-28:nth-child(odd){
    padding-right: 7rem;
  }

  .xl\\:odd\\:pb-28:nth-child(odd){
    padding-bottom: 7rem;
  }

  .xl\\:odd\\:pl-28:nth-child(odd){
    padding-left: 7rem;
  }

  .xl\\:odd\\:pt-30:nth-child(odd){
    padding-top: 7.5rem;
  }

  .xl\\:odd\\:pr-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  .xl\\:odd\\:pb-30:nth-child(odd){
    padding-bottom: 7.5rem;
  }

  .xl\\:odd\\:pl-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  .xl\\:odd\\:pt-32:nth-child(odd){
    padding-top: 8rem;
  }

  .xl\\:odd\\:pr-32:nth-child(odd){
    padding-right: 8rem;
  }

  .xl\\:odd\\:pb-32:nth-child(odd){
    padding-bottom: 8rem;
  }

  .xl\\:odd\\:pl-32:nth-child(odd){
    padding-left: 8rem;
  }

  .xl\\:odd\\:pt-34:nth-child(odd){
    padding-top: 8.5rem;
  }

  .xl\\:odd\\:pr-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  .xl\\:odd\\:pb-34:nth-child(odd){
    padding-bottom: 8.5rem;
  }

  .xl\\:odd\\:pl-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  .xl\\:odd\\:pt-40:nth-child(odd){
    padding-top: 10rem;
  }

  .xl\\:odd\\:pr-40:nth-child(odd){
    padding-right: 10rem;
  }

  .xl\\:odd\\:pb-40:nth-child(odd){
    padding-bottom: 10rem;
  }

  .xl\\:odd\\:pl-40:nth-child(odd){
    padding-left: 10rem;
  }

  .xl\\:odd\\:pt-42:nth-child(odd){
    padding-top: 10.5rem;
  }

  .xl\\:odd\\:pr-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  .xl\\:odd\\:pb-42:nth-child(odd){
    padding-bottom: 10.5rem;
  }

  .xl\\:odd\\:pl-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  .xl\\:odd\\:pt-44:nth-child(odd){
    padding-top: 11rem;
  }

  .xl\\:odd\\:pr-44:nth-child(odd){
    padding-right: 11rem;
  }

  .xl\\:odd\\:pb-44:nth-child(odd){
    padding-bottom: 11rem;
  }

  .xl\\:odd\\:pl-44:nth-child(odd){
    padding-left: 11rem;
  }

  .xl\\:odd\\:pt-48:nth-child(odd){
    padding-top: 12rem;
  }

  .xl\\:odd\\:pr-48:nth-child(odd){
    padding-right: 12rem;
  }

  .xl\\:odd\\:pb-48:nth-child(odd){
    padding-bottom: 12rem;
  }

  .xl\\:odd\\:pl-48:nth-child(odd){
    padding-left: 12rem;
  }

  .xl\\:odd\\:pt-52:nth-child(odd){
    padding-top: 13rem;
  }

  .xl\\:odd\\:pr-52:nth-child(odd){
    padding-right: 13rem;
  }

  .xl\\:odd\\:pb-52:nth-child(odd){
    padding-bottom: 13rem;
  }

  .xl\\:odd\\:pl-52:nth-child(odd){
    padding-left: 13rem;
  }

  .xl\\:odd\\:pt-54:nth-child(odd){
    padding-top: 13.5rem;
  }

  .xl\\:odd\\:pr-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  .xl\\:odd\\:pb-54:nth-child(odd){
    padding-bottom: 13.5rem;
  }

  .xl\\:odd\\:pl-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  .xl\\:odd\\:pt-56:nth-child(odd){
    padding-top: 14rem;
  }

  .xl\\:odd\\:pr-56:nth-child(odd){
    padding-right: 14rem;
  }

  .xl\\:odd\\:pb-56:nth-child(odd){
    padding-bottom: 14rem;
  }

  .xl\\:odd\\:pl-56:nth-child(odd){
    padding-left: 14rem;
  }

  .xl\\:odd\\:pt-60:nth-child(odd){
    padding-top: 15rem;
  }

  .xl\\:odd\\:pr-60:nth-child(odd){
    padding-right: 15rem;
  }

  .xl\\:odd\\:pb-60:nth-child(odd){
    padding-bottom: 15rem;
  }

  .xl\\:odd\\:pl-60:nth-child(odd){
    padding-left: 15rem;
  }

  .xl\\:odd\\:pt-64:nth-child(odd){
    padding-top: 16rem;
  }

  .xl\\:odd\\:pr-64:nth-child(odd){
    padding-right: 16rem;
  }

  .xl\\:odd\\:pb-64:nth-child(odd){
    padding-bottom: 16rem;
  }

  .xl\\:odd\\:pl-64:nth-child(odd){
    padding-left: 16rem;
  }

  .xl\\:odd\\:pt-68:nth-child(odd){
    padding-top: 17rem;
  }

  .xl\\:odd\\:pr-68:nth-child(odd){
    padding-right: 17rem;
  }

  .xl\\:odd\\:pb-68:nth-child(odd){
    padding-bottom: 17rem;
  }

  .xl\\:odd\\:pl-68:nth-child(odd){
    padding-left: 17rem;
  }

  .xl\\:odd\\:pt-72:nth-child(odd){
    padding-top: 18rem;
  }

  .xl\\:odd\\:pr-72:nth-child(odd){
    padding-right: 18rem;
  }

  .xl\\:odd\\:pb-72:nth-child(odd){
    padding-bottom: 18rem;
  }

  .xl\\:odd\\:pl-72:nth-child(odd){
    padding-left: 18rem;
  }

  .xl\\:odd\\:pt-74:nth-child(odd){
    padding-top: 18.5rem;
  }

  .xl\\:odd\\:pr-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  .xl\\:odd\\:pb-74:nth-child(odd){
    padding-bottom: 18.5rem;
  }

  .xl\\:odd\\:pl-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  .xl\\:odd\\:pt-76:nth-child(odd){
    padding-top: 19rem;
  }

  .xl\\:odd\\:pr-76:nth-child(odd){
    padding-right: 19rem;
  }

  .xl\\:odd\\:pb-76:nth-child(odd){
    padding-bottom: 19rem;
  }

  .xl\\:odd\\:pl-76:nth-child(odd){
    padding-left: 19rem;
  }

  .xl\\:odd\\:pt-78:nth-child(odd){
    padding-top: 19.5rem;
  }

  .xl\\:odd\\:pr-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  .xl\\:odd\\:pb-78:nth-child(odd){
    padding-bottom: 19.5rem;
  }

  .xl\\:odd\\:pl-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  .xl\\:odd\\:pt-80:nth-child(odd){
    padding-top: 20rem;
  }

  .xl\\:odd\\:pr-80:nth-child(odd){
    padding-right: 20rem;
  }

  .xl\\:odd\\:pb-80:nth-child(odd){
    padding-bottom: 20rem;
  }

  .xl\\:odd\\:pl-80:nth-child(odd){
    padding-left: 20rem;
  }

  .xl\\:odd\\:pt-82:nth-child(odd){
    padding-top: 20.5rem;
  }

  .xl\\:odd\\:pr-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  .xl\\:odd\\:pb-82:nth-child(odd){
    padding-bottom: 20.5rem;
  }

  .xl\\:odd\\:pl-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  .xl\\:odd\\:pt-84:nth-child(odd){
    padding-top: 21rem;
  }

  .xl\\:odd\\:pr-84:nth-child(odd){
    padding-right: 21rem;
  }

  .xl\\:odd\\:pb-84:nth-child(odd){
    padding-bottom: 21rem;
  }

  .xl\\:odd\\:pl-84:nth-child(odd){
    padding-left: 21rem;
  }

  .xl\\:odd\\:pt-88:nth-child(odd){
    padding-top: 22rem;
  }

  .xl\\:odd\\:pr-88:nth-child(odd){
    padding-right: 22rem;
  }

  .xl\\:odd\\:pb-88:nth-child(odd){
    padding-bottom: 22rem;
  }

  .xl\\:odd\\:pl-88:nth-child(odd){
    padding-left: 22rem;
  }

  .xl\\:odd\\:pt-92:nth-child(odd){
    padding-top: 23rem;
  }

  .xl\\:odd\\:pr-92:nth-child(odd){
    padding-right: 23rem;
  }

  .xl\\:odd\\:pb-92:nth-child(odd){
    padding-bottom: 23rem;
  }

  .xl\\:odd\\:pl-92:nth-child(odd){
    padding-left: 23rem;
  }

  .xl\\:odd\\:pt-96:nth-child(odd){
    padding-top: 24rem;
  }

  .xl\\:odd\\:pr-96:nth-child(odd){
    padding-right: 24rem;
  }

  .xl\\:odd\\:pb-96:nth-child(odd){
    padding-bottom: 24rem;
  }

  .xl\\:odd\\:pl-96:nth-child(odd){
    padding-left: 24rem;
  }

  .xl\\:odd\\:pt-98:nth-child(odd){
    padding-top: 24.5rem;
  }

  .xl\\:odd\\:pr-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  .xl\\:odd\\:pb-98:nth-child(odd){
    padding-bottom: 24.5rem;
  }

  .xl\\:odd\\:pl-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  .xl\\:odd\\:pt-100:nth-child(odd){
    padding-top: 25rem;
  }

  .xl\\:odd\\:pr-100:nth-child(odd){
    padding-right: 25rem;
  }

  .xl\\:odd\\:pb-100:nth-child(odd){
    padding-bottom: 25rem;
  }

  .xl\\:odd\\:pl-100:nth-child(odd){
    padding-left: 25rem;
  }

  .xl\\:odd\\:pt-104:nth-child(odd){
    padding-top: 26rem;
  }

  .xl\\:odd\\:pr-104:nth-child(odd){
    padding-right: 26rem;
  }

  .xl\\:odd\\:pb-104:nth-child(odd){
    padding-bottom: 26rem;
  }

  .xl\\:odd\\:pl-104:nth-child(odd){
    padding-left: 26rem;
  }

  .xl\\:odd\\:pt-112:nth-child(odd){
    padding-top: 28rem;
  }

  .xl\\:odd\\:pr-112:nth-child(odd){
    padding-right: 28rem;
  }

  .xl\\:odd\\:pb-112:nth-child(odd){
    padding-bottom: 28rem;
  }

  .xl\\:odd\\:pl-112:nth-child(odd){
    padding-left: 28rem;
  }

  .xl\\:odd\\:pt-124:nth-child(odd){
    padding-top: 31rem;
  }

  .xl\\:odd\\:pr-124:nth-child(odd){
    padding-right: 31rem;
  }

  .xl\\:odd\\:pb-124:nth-child(odd){
    padding-bottom: 31rem;
  }

  .xl\\:odd\\:pl-124:nth-child(odd){
    padding-left: 31rem;
  }

  .xl\\:odd\\:pt-128:nth-child(odd){
    padding-top: 32rem;
  }

  .xl\\:odd\\:pr-128:nth-child(odd){
    padding-right: 32rem;
  }

  .xl\\:odd\\:pb-128:nth-child(odd){
    padding-bottom: 32rem;
  }

  .xl\\:odd\\:pl-128:nth-child(odd){
    padding-left: 32rem;
  }

  .xl\\:odd\\:pt-140:nth-child(odd){
    padding-top: 35rem;
  }

  .xl\\:odd\\:pr-140:nth-child(odd){
    padding-right: 35rem;
  }

  .xl\\:odd\\:pb-140:nth-child(odd){
    padding-bottom: 35rem;
  }

  .xl\\:odd\\:pl-140:nth-child(odd){
    padding-left: 35rem;
  }

  .xl\\:odd\\:pt-152:nth-child(odd){
    padding-top: 38rem;
  }

  .xl\\:odd\\:pr-152:nth-child(odd){
    padding-right: 38rem;
  }

  .xl\\:odd\\:pb-152:nth-child(odd){
    padding-bottom: 38rem;
  }

  .xl\\:odd\\:pl-152:nth-child(odd){
    padding-left: 38rem;
  }

  .xl\\:odd\\:pt-160:nth-child(odd){
    padding-top: 40rem;
  }

  .xl\\:odd\\:pr-160:nth-child(odd){
    padding-right: 40rem;
  }

  .xl\\:odd\\:pb-160:nth-child(odd){
    padding-bottom: 40rem;
  }

  .xl\\:odd\\:pl-160:nth-child(odd){
    padding-left: 40rem;
  }

  .xl\\:odd\\:pt-162:nth-child(odd){
    padding-top: 41rem;
  }

  .xl\\:odd\\:pr-162:nth-child(odd){
    padding-right: 41rem;
  }

  .xl\\:odd\\:pb-162:nth-child(odd){
    padding-bottom: 41rem;
  }

  .xl\\:odd\\:pl-162:nth-child(odd){
    padding-left: 41rem;
  }

  .xl\\:odd\\:pt-192:nth-child(odd){
    padding-top: 48rem;
  }

  .xl\\:odd\\:pr-192:nth-child(odd){
    padding-right: 48rem;
  }

  .xl\\:odd\\:pb-192:nth-child(odd){
    padding-bottom: 48rem;
  }

  .xl\\:odd\\:pl-192:nth-child(odd){
    padding-left: 48rem;
  }

  .xl\\:odd\\:pt-208:nth-child(odd){
    padding-top: 52rem;
  }

  .xl\\:odd\\:pr-208:nth-child(odd){
    padding-right: 52rem;
  }

  .xl\\:odd\\:pb-208:nth-child(odd){
    padding-bottom: 52rem;
  }

  .xl\\:odd\\:pl-208:nth-child(odd){
    padding-left: 52rem;
  }

  .xl\\:odd\\:pt-224:nth-child(odd){
    padding-top: 56rem;
  }

  .xl\\:odd\\:pr-224:nth-child(odd){
    padding-right: 56rem;
  }

  .xl\\:odd\\:pb-224:nth-child(odd){
    padding-bottom: 56rem;
  }

  .xl\\:odd\\:pl-224:nth-child(odd){
    padding-left: 56rem;
  }

  .xl\\:odd\\:pt-256:nth-child(odd){
    padding-top: 64rem;
  }

  .xl\\:odd\\:pr-256:nth-child(odd){
    padding-right: 64rem;
  }

  .xl\\:odd\\:pb-256:nth-child(odd){
    padding-bottom: 64rem;
  }

  .xl\\:odd\\:pl-256:nth-child(odd){
    padding-left: 64rem;
  }

  .xl\\:odd\\:pt-px:nth-child(odd){
    padding-top: 1px;
  }

  .xl\\:odd\\:pr-px:nth-child(odd){
    padding-right: 1px;
  }

  .xl\\:odd\\:pb-px:nth-child(odd){
    padding-bottom: 1px;
  }

  .xl\\:odd\\:pl-px:nth-child(odd){
    padding-left: 1px;
  }

  .xl\\:even\\:p-0:nth-child(even){
    padding: 0;
  }

  .xl\\:even\\:p-1:nth-child(even){
    padding: 0.25rem;
  }

  .xl\\:even\\:p-2:nth-child(even){
    padding: 0.5rem;
  }

  .xl\\:even\\:p-3:nth-child(even){
    padding: 0.75rem;
  }

  .xl\\:even\\:p-4:nth-child(even){
    padding: 1rem;
  }

  .xl\\:even\\:p-5:nth-child(even){
    padding: 1.25rem;
  }

  .xl\\:even\\:p-6:nth-child(even){
    padding: 1.5rem;
  }

  .xl\\:even\\:p-7:nth-child(even){
    padding: 1.75rem;
  }

  .xl\\:even\\:p-8:nth-child(even){
    padding: 2rem;
  }

  .xl\\:even\\:p-9:nth-child(even){
    padding: 2.25rem;
  }

  .xl\\:even\\:p-10:nth-child(even){
    padding: 2.5rem;
  }

  .xl\\:even\\:p-11:nth-child(even){
    padding: 2.75rem;
  }

  .xl\\:even\\:p-12:nth-child(even){
    padding: 3rem;
  }

  .xl\\:even\\:p-14:nth-child(even){
    padding: 3.5rem;
  }

  .xl\\:even\\:p-15:nth-child(even){
    padding: 3.75rem;
  }

  .xl\\:even\\:p-16:nth-child(even){
    padding: 4rem;
  }

  .xl\\:even\\:p-18:nth-child(even){
    padding: 4.5rem;
  }

  .xl\\:even\\:p-20:nth-child(even){
    padding: 5rem;
  }

  .xl\\:even\\:p-22:nth-child(even){
    padding: 5.5rem;
  }

  .xl\\:even\\:p-23:nth-child(even){
    padding: 5.75rem;
  }

  .xl\\:even\\:p-24:nth-child(even){
    padding: 6rem;
  }

  .xl\\:even\\:p-25:nth-child(even){
    padding: 6.25rem;
  }

  .xl\\:even\\:p-26:nth-child(even){
    padding: 6.5rem;
  }

  .xl\\:even\\:p-28:nth-child(even){
    padding: 7rem;
  }

  .xl\\:even\\:p-30:nth-child(even){
    padding: 7.5rem;
  }

  .xl\\:even\\:p-32:nth-child(even){
    padding: 8rem;
  }

  .xl\\:even\\:p-34:nth-child(even){
    padding: 8.5rem;
  }

  .xl\\:even\\:p-40:nth-child(even){
    padding: 10rem;
  }

  .xl\\:even\\:p-42:nth-child(even){
    padding: 10.5rem;
  }

  .xl\\:even\\:p-44:nth-child(even){
    padding: 11rem;
  }

  .xl\\:even\\:p-48:nth-child(even){
    padding: 12rem;
  }

  .xl\\:even\\:p-52:nth-child(even){
    padding: 13rem;
  }

  .xl\\:even\\:p-54:nth-child(even){
    padding: 13.5rem;
  }

  .xl\\:even\\:p-56:nth-child(even){
    padding: 14rem;
  }

  .xl\\:even\\:p-60:nth-child(even){
    padding: 15rem;
  }

  .xl\\:even\\:p-64:nth-child(even){
    padding: 16rem;
  }

  .xl\\:even\\:p-68:nth-child(even){
    padding: 17rem;
  }

  .xl\\:even\\:p-72:nth-child(even){
    padding: 18rem;
  }

  .xl\\:even\\:p-74:nth-child(even){
    padding: 18.5rem;
  }

  .xl\\:even\\:p-76:nth-child(even){
    padding: 19rem;
  }

  .xl\\:even\\:p-78:nth-child(even){
    padding: 19.5rem;
  }

  .xl\\:even\\:p-80:nth-child(even){
    padding: 20rem;
  }

  .xl\\:even\\:p-82:nth-child(even){
    padding: 20.5rem;
  }

  .xl\\:even\\:p-84:nth-child(even){
    padding: 21rem;
  }

  .xl\\:even\\:p-88:nth-child(even){
    padding: 22rem;
  }

  .xl\\:even\\:p-92:nth-child(even){
    padding: 23rem;
  }

  .xl\\:even\\:p-96:nth-child(even){
    padding: 24rem;
  }

  .xl\\:even\\:p-98:nth-child(even){
    padding: 24.5rem;
  }

  .xl\\:even\\:p-100:nth-child(even){
    padding: 25rem;
  }

  .xl\\:even\\:p-104:nth-child(even){
    padding: 26rem;
  }

  .xl\\:even\\:p-112:nth-child(even){
    padding: 28rem;
  }

  .xl\\:even\\:p-124:nth-child(even){
    padding: 31rem;
  }

  .xl\\:even\\:p-128:nth-child(even){
    padding: 32rem;
  }

  .xl\\:even\\:p-140:nth-child(even){
    padding: 35rem;
  }

  .xl\\:even\\:p-152:nth-child(even){
    padding: 38rem;
  }

  .xl\\:even\\:p-160:nth-child(even){
    padding: 40rem;
  }

  .xl\\:even\\:p-162:nth-child(even){
    padding: 41rem;
  }

  .xl\\:even\\:p-192:nth-child(even){
    padding: 48rem;
  }

  .xl\\:even\\:p-208:nth-child(even){
    padding: 52rem;
  }

  .xl\\:even\\:p-224:nth-child(even){
    padding: 56rem;
  }

  .xl\\:even\\:p-256:nth-child(even){
    padding: 64rem;
  }

  .xl\\:even\\:p-px:nth-child(even){
    padding: 1px;
  }

  .xl\\:even\\:py-0:nth-child(even){
    padding-top: 0;
    padding-bottom: 0;
  }

  .xl\\:even\\:px-0:nth-child(even){
    padding-left: 0;
    padding-right: 0;
  }

  .xl\\:even\\:py-1:nth-child(even){
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .xl\\:even\\:px-1:nth-child(even){
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .xl\\:even\\:py-2:nth-child(even){
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .xl\\:even\\:px-2:nth-child(even){
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .xl\\:even\\:py-3:nth-child(even){
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .xl\\:even\\:px-3:nth-child(even){
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .xl\\:even\\:py-4:nth-child(even){
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .xl\\:even\\:px-4:nth-child(even){
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .xl\\:even\\:py-5:nth-child(even){
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .xl\\:even\\:px-5:nth-child(even){
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .xl\\:even\\:py-6:nth-child(even){
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .xl\\:even\\:px-6:nth-child(even){
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .xl\\:even\\:py-7:nth-child(even){
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .xl\\:even\\:px-7:nth-child(even){
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .xl\\:even\\:py-8:nth-child(even){
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .xl\\:even\\:px-8:nth-child(even){
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .xl\\:even\\:py-9:nth-child(even){
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .xl\\:even\\:px-9:nth-child(even){
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .xl\\:even\\:py-10:nth-child(even){
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .xl\\:even\\:px-10:nth-child(even){
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .xl\\:even\\:py-11:nth-child(even){
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .xl\\:even\\:px-11:nth-child(even){
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .xl\\:even\\:py-12:nth-child(even){
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .xl\\:even\\:px-12:nth-child(even){
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .xl\\:even\\:py-14:nth-child(even){
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .xl\\:even\\:px-14:nth-child(even){
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .xl\\:even\\:py-15:nth-child(even){
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .xl\\:even\\:px-15:nth-child(even){
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .xl\\:even\\:py-16:nth-child(even){
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .xl\\:even\\:px-16:nth-child(even){
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .xl\\:even\\:py-18:nth-child(even){
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .xl\\:even\\:px-18:nth-child(even){
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .xl\\:even\\:py-20:nth-child(even){
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .xl\\:even\\:px-20:nth-child(even){
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .xl\\:even\\:py-22:nth-child(even){
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .xl\\:even\\:px-22:nth-child(even){
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .xl\\:even\\:py-23:nth-child(even){
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .xl\\:even\\:px-23:nth-child(even){
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .xl\\:even\\:py-24:nth-child(even){
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .xl\\:even\\:px-24:nth-child(even){
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .xl\\:even\\:py-25:nth-child(even){
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .xl\\:even\\:px-25:nth-child(even){
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .xl\\:even\\:py-26:nth-child(even){
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .xl\\:even\\:px-26:nth-child(even){
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .xl\\:even\\:py-28:nth-child(even){
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .xl\\:even\\:px-28:nth-child(even){
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .xl\\:even\\:py-30:nth-child(even){
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .xl\\:even\\:px-30:nth-child(even){
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .xl\\:even\\:py-32:nth-child(even){
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .xl\\:even\\:px-32:nth-child(even){
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .xl\\:even\\:py-34:nth-child(even){
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .xl\\:even\\:px-34:nth-child(even){
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .xl\\:even\\:py-40:nth-child(even){
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .xl\\:even\\:px-40:nth-child(even){
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .xl\\:even\\:py-42:nth-child(even){
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .xl\\:even\\:px-42:nth-child(even){
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .xl\\:even\\:py-44:nth-child(even){
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .xl\\:even\\:px-44:nth-child(even){
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .xl\\:even\\:py-48:nth-child(even){
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .xl\\:even\\:px-48:nth-child(even){
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .xl\\:even\\:py-52:nth-child(even){
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .xl\\:even\\:px-52:nth-child(even){
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .xl\\:even\\:py-54:nth-child(even){
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .xl\\:even\\:px-54:nth-child(even){
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .xl\\:even\\:py-56:nth-child(even){
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .xl\\:even\\:px-56:nth-child(even){
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .xl\\:even\\:py-60:nth-child(even){
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .xl\\:even\\:px-60:nth-child(even){
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .xl\\:even\\:py-64:nth-child(even){
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .xl\\:even\\:px-64:nth-child(even){
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .xl\\:even\\:py-68:nth-child(even){
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .xl\\:even\\:px-68:nth-child(even){
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .xl\\:even\\:py-72:nth-child(even){
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .xl\\:even\\:px-72:nth-child(even){
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .xl\\:even\\:py-74:nth-child(even){
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .xl\\:even\\:px-74:nth-child(even){
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .xl\\:even\\:py-76:nth-child(even){
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .xl\\:even\\:px-76:nth-child(even){
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .xl\\:even\\:py-78:nth-child(even){
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .xl\\:even\\:px-78:nth-child(even){
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .xl\\:even\\:py-80:nth-child(even){
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .xl\\:even\\:px-80:nth-child(even){
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .xl\\:even\\:py-82:nth-child(even){
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .xl\\:even\\:px-82:nth-child(even){
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .xl\\:even\\:py-84:nth-child(even){
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .xl\\:even\\:px-84:nth-child(even){
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .xl\\:even\\:py-88:nth-child(even){
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .xl\\:even\\:px-88:nth-child(even){
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .xl\\:even\\:py-92:nth-child(even){
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .xl\\:even\\:px-92:nth-child(even){
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .xl\\:even\\:py-96:nth-child(even){
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .xl\\:even\\:px-96:nth-child(even){
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .xl\\:even\\:py-98:nth-child(even){
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .xl\\:even\\:px-98:nth-child(even){
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .xl\\:even\\:py-100:nth-child(even){
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .xl\\:even\\:px-100:nth-child(even){
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .xl\\:even\\:py-104:nth-child(even){
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .xl\\:even\\:px-104:nth-child(even){
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .xl\\:even\\:py-112:nth-child(even){
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .xl\\:even\\:px-112:nth-child(even){
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .xl\\:even\\:py-124:nth-child(even){
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .xl\\:even\\:px-124:nth-child(even){
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .xl\\:even\\:py-128:nth-child(even){
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .xl\\:even\\:px-128:nth-child(even){
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .xl\\:even\\:py-140:nth-child(even){
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .xl\\:even\\:px-140:nth-child(even){
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .xl\\:even\\:py-152:nth-child(even){
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .xl\\:even\\:px-152:nth-child(even){
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .xl\\:even\\:py-160:nth-child(even){
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .xl\\:even\\:px-160:nth-child(even){
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .xl\\:even\\:py-162:nth-child(even){
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .xl\\:even\\:px-162:nth-child(even){
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .xl\\:even\\:py-192:nth-child(even){
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .xl\\:even\\:px-192:nth-child(even){
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .xl\\:even\\:py-208:nth-child(even){
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .xl\\:even\\:px-208:nth-child(even){
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .xl\\:even\\:py-224:nth-child(even){
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .xl\\:even\\:px-224:nth-child(even){
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .xl\\:even\\:py-256:nth-child(even){
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .xl\\:even\\:px-256:nth-child(even){
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .xl\\:even\\:py-px:nth-child(even){
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .xl\\:even\\:px-px:nth-child(even){
    padding-left: 1px;
    padding-right: 1px;
  }

  .xl\\:even\\:pt-0:nth-child(even){
    padding-top: 0;
  }

  .xl\\:even\\:pr-0:nth-child(even){
    padding-right: 0;
  }

  .xl\\:even\\:pb-0:nth-child(even){
    padding-bottom: 0;
  }

  .xl\\:even\\:pl-0:nth-child(even){
    padding-left: 0;
  }

  .xl\\:even\\:pt-1:nth-child(even){
    padding-top: 0.25rem;
  }

  .xl\\:even\\:pr-1:nth-child(even){
    padding-right: 0.25rem;
  }

  .xl\\:even\\:pb-1:nth-child(even){
    padding-bottom: 0.25rem;
  }

  .xl\\:even\\:pl-1:nth-child(even){
    padding-left: 0.25rem;
  }

  .xl\\:even\\:pt-2:nth-child(even){
    padding-top: 0.5rem;
  }

  .xl\\:even\\:pr-2:nth-child(even){
    padding-right: 0.5rem;
  }

  .xl\\:even\\:pb-2:nth-child(even){
    padding-bottom: 0.5rem;
  }

  .xl\\:even\\:pl-2:nth-child(even){
    padding-left: 0.5rem;
  }

  .xl\\:even\\:pt-3:nth-child(even){
    padding-top: 0.75rem;
  }

  .xl\\:even\\:pr-3:nth-child(even){
    padding-right: 0.75rem;
  }

  .xl\\:even\\:pb-3:nth-child(even){
    padding-bottom: 0.75rem;
  }

  .xl\\:even\\:pl-3:nth-child(even){
    padding-left: 0.75rem;
  }

  .xl\\:even\\:pt-4:nth-child(even){
    padding-top: 1rem;
  }

  .xl\\:even\\:pr-4:nth-child(even){
    padding-right: 1rem;
  }

  .xl\\:even\\:pb-4:nth-child(even){
    padding-bottom: 1rem;
  }

  .xl\\:even\\:pl-4:nth-child(even){
    padding-left: 1rem;
  }

  .xl\\:even\\:pt-5:nth-child(even){
    padding-top: 1.25rem;
  }

  .xl\\:even\\:pr-5:nth-child(even){
    padding-right: 1.25rem;
  }

  .xl\\:even\\:pb-5:nth-child(even){
    padding-bottom: 1.25rem;
  }

  .xl\\:even\\:pl-5:nth-child(even){
    padding-left: 1.25rem;
  }

  .xl\\:even\\:pt-6:nth-child(even){
    padding-top: 1.5rem;
  }

  .xl\\:even\\:pr-6:nth-child(even){
    padding-right: 1.5rem;
  }

  .xl\\:even\\:pb-6:nth-child(even){
    padding-bottom: 1.5rem;
  }

  .xl\\:even\\:pl-6:nth-child(even){
    padding-left: 1.5rem;
  }

  .xl\\:even\\:pt-7:nth-child(even){
    padding-top: 1.75rem;
  }

  .xl\\:even\\:pr-7:nth-child(even){
    padding-right: 1.75rem;
  }

  .xl\\:even\\:pb-7:nth-child(even){
    padding-bottom: 1.75rem;
  }

  .xl\\:even\\:pl-7:nth-child(even){
    padding-left: 1.75rem;
  }

  .xl\\:even\\:pt-8:nth-child(even){
    padding-top: 2rem;
  }

  .xl\\:even\\:pr-8:nth-child(even){
    padding-right: 2rem;
  }

  .xl\\:even\\:pb-8:nth-child(even){
    padding-bottom: 2rem;
  }

  .xl\\:even\\:pl-8:nth-child(even){
    padding-left: 2rem;
  }

  .xl\\:even\\:pt-9:nth-child(even){
    padding-top: 2.25rem;
  }

  .xl\\:even\\:pr-9:nth-child(even){
    padding-right: 2.25rem;
  }

  .xl\\:even\\:pb-9:nth-child(even){
    padding-bottom: 2.25rem;
  }

  .xl\\:even\\:pl-9:nth-child(even){
    padding-left: 2.25rem;
  }

  .xl\\:even\\:pt-10:nth-child(even){
    padding-top: 2.5rem;
  }

  .xl\\:even\\:pr-10:nth-child(even){
    padding-right: 2.5rem;
  }

  .xl\\:even\\:pb-10:nth-child(even){
    padding-bottom: 2.5rem;
  }

  .xl\\:even\\:pl-10:nth-child(even){
    padding-left: 2.5rem;
  }

  .xl\\:even\\:pt-11:nth-child(even){
    padding-top: 2.75rem;
  }

  .xl\\:even\\:pr-11:nth-child(even){
    padding-right: 2.75rem;
  }

  .xl\\:even\\:pb-11:nth-child(even){
    padding-bottom: 2.75rem;
  }

  .xl\\:even\\:pl-11:nth-child(even){
    padding-left: 2.75rem;
  }

  .xl\\:even\\:pt-12:nth-child(even){
    padding-top: 3rem;
  }

  .xl\\:even\\:pr-12:nth-child(even){
    padding-right: 3rem;
  }

  .xl\\:even\\:pb-12:nth-child(even){
    padding-bottom: 3rem;
  }

  .xl\\:even\\:pl-12:nth-child(even){
    padding-left: 3rem;
  }

  .xl\\:even\\:pt-14:nth-child(even){
    padding-top: 3.5rem;
  }

  .xl\\:even\\:pr-14:nth-child(even){
    padding-right: 3.5rem;
  }

  .xl\\:even\\:pb-14:nth-child(even){
    padding-bottom: 3.5rem;
  }

  .xl\\:even\\:pl-14:nth-child(even){
    padding-left: 3.5rem;
  }

  .xl\\:even\\:pt-15:nth-child(even){
    padding-top: 3.75rem;
  }

  .xl\\:even\\:pr-15:nth-child(even){
    padding-right: 3.75rem;
  }

  .xl\\:even\\:pb-15:nth-child(even){
    padding-bottom: 3.75rem;
  }

  .xl\\:even\\:pl-15:nth-child(even){
    padding-left: 3.75rem;
  }

  .xl\\:even\\:pt-16:nth-child(even){
    padding-top: 4rem;
  }

  .xl\\:even\\:pr-16:nth-child(even){
    padding-right: 4rem;
  }

  .xl\\:even\\:pb-16:nth-child(even){
    padding-bottom: 4rem;
  }

  .xl\\:even\\:pl-16:nth-child(even){
    padding-left: 4rem;
  }

  .xl\\:even\\:pt-18:nth-child(even){
    padding-top: 4.5rem;
  }

  .xl\\:even\\:pr-18:nth-child(even){
    padding-right: 4.5rem;
  }

  .xl\\:even\\:pb-18:nth-child(even){
    padding-bottom: 4.5rem;
  }

  .xl\\:even\\:pl-18:nth-child(even){
    padding-left: 4.5rem;
  }

  .xl\\:even\\:pt-20:nth-child(even){
    padding-top: 5rem;
  }

  .xl\\:even\\:pr-20:nth-child(even){
    padding-right: 5rem;
  }

  .xl\\:even\\:pb-20:nth-child(even){
    padding-bottom: 5rem;
  }

  .xl\\:even\\:pl-20:nth-child(even){
    padding-left: 5rem;
  }

  .xl\\:even\\:pt-22:nth-child(even){
    padding-top: 5.5rem;
  }

  .xl\\:even\\:pr-22:nth-child(even){
    padding-right: 5.5rem;
  }

  .xl\\:even\\:pb-22:nth-child(even){
    padding-bottom: 5.5rem;
  }

  .xl\\:even\\:pl-22:nth-child(even){
    padding-left: 5.5rem;
  }

  .xl\\:even\\:pt-23:nth-child(even){
    padding-top: 5.75rem;
  }

  .xl\\:even\\:pr-23:nth-child(even){
    padding-right: 5.75rem;
  }

  .xl\\:even\\:pb-23:nth-child(even){
    padding-bottom: 5.75rem;
  }

  .xl\\:even\\:pl-23:nth-child(even){
    padding-left: 5.75rem;
  }

  .xl\\:even\\:pt-24:nth-child(even){
    padding-top: 6rem;
  }

  .xl\\:even\\:pr-24:nth-child(even){
    padding-right: 6rem;
  }

  .xl\\:even\\:pb-24:nth-child(even){
    padding-bottom: 6rem;
  }

  .xl\\:even\\:pl-24:nth-child(even){
    padding-left: 6rem;
  }

  .xl\\:even\\:pt-25:nth-child(even){
    padding-top: 6.25rem;
  }

  .xl\\:even\\:pr-25:nth-child(even){
    padding-right: 6.25rem;
  }

  .xl\\:even\\:pb-25:nth-child(even){
    padding-bottom: 6.25rem;
  }

  .xl\\:even\\:pl-25:nth-child(even){
    padding-left: 6.25rem;
  }

  .xl\\:even\\:pt-26:nth-child(even){
    padding-top: 6.5rem;
  }

  .xl\\:even\\:pr-26:nth-child(even){
    padding-right: 6.5rem;
  }

  .xl\\:even\\:pb-26:nth-child(even){
    padding-bottom: 6.5rem;
  }

  .xl\\:even\\:pl-26:nth-child(even){
    padding-left: 6.5rem;
  }

  .xl\\:even\\:pt-28:nth-child(even){
    padding-top: 7rem;
  }

  .xl\\:even\\:pr-28:nth-child(even){
    padding-right: 7rem;
  }

  .xl\\:even\\:pb-28:nth-child(even){
    padding-bottom: 7rem;
  }

  .xl\\:even\\:pl-28:nth-child(even){
    padding-left: 7rem;
  }

  .xl\\:even\\:pt-30:nth-child(even){
    padding-top: 7.5rem;
  }

  .xl\\:even\\:pr-30:nth-child(even){
    padding-right: 7.5rem;
  }

  .xl\\:even\\:pb-30:nth-child(even){
    padding-bottom: 7.5rem;
  }

  .xl\\:even\\:pl-30:nth-child(even){
    padding-left: 7.5rem;
  }

  .xl\\:even\\:pt-32:nth-child(even){
    padding-top: 8rem;
  }

  .xl\\:even\\:pr-32:nth-child(even){
    padding-right: 8rem;
  }

  .xl\\:even\\:pb-32:nth-child(even){
    padding-bottom: 8rem;
  }

  .xl\\:even\\:pl-32:nth-child(even){
    padding-left: 8rem;
  }

  .xl\\:even\\:pt-34:nth-child(even){
    padding-top: 8.5rem;
  }

  .xl\\:even\\:pr-34:nth-child(even){
    padding-right: 8.5rem;
  }

  .xl\\:even\\:pb-34:nth-child(even){
    padding-bottom: 8.5rem;
  }

  .xl\\:even\\:pl-34:nth-child(even){
    padding-left: 8.5rem;
  }

  .xl\\:even\\:pt-40:nth-child(even){
    padding-top: 10rem;
  }

  .xl\\:even\\:pr-40:nth-child(even){
    padding-right: 10rem;
  }

  .xl\\:even\\:pb-40:nth-child(even){
    padding-bottom: 10rem;
  }

  .xl\\:even\\:pl-40:nth-child(even){
    padding-left: 10rem;
  }

  .xl\\:even\\:pt-42:nth-child(even){
    padding-top: 10.5rem;
  }

  .xl\\:even\\:pr-42:nth-child(even){
    padding-right: 10.5rem;
  }

  .xl\\:even\\:pb-42:nth-child(even){
    padding-bottom: 10.5rem;
  }

  .xl\\:even\\:pl-42:nth-child(even){
    padding-left: 10.5rem;
  }

  .xl\\:even\\:pt-44:nth-child(even){
    padding-top: 11rem;
  }

  .xl\\:even\\:pr-44:nth-child(even){
    padding-right: 11rem;
  }

  .xl\\:even\\:pb-44:nth-child(even){
    padding-bottom: 11rem;
  }

  .xl\\:even\\:pl-44:nth-child(even){
    padding-left: 11rem;
  }

  .xl\\:even\\:pt-48:nth-child(even){
    padding-top: 12rem;
  }

  .xl\\:even\\:pr-48:nth-child(even){
    padding-right: 12rem;
  }

  .xl\\:even\\:pb-48:nth-child(even){
    padding-bottom: 12rem;
  }

  .xl\\:even\\:pl-48:nth-child(even){
    padding-left: 12rem;
  }

  .xl\\:even\\:pt-52:nth-child(even){
    padding-top: 13rem;
  }

  .xl\\:even\\:pr-52:nth-child(even){
    padding-right: 13rem;
  }

  .xl\\:even\\:pb-52:nth-child(even){
    padding-bottom: 13rem;
  }

  .xl\\:even\\:pl-52:nth-child(even){
    padding-left: 13rem;
  }

  .xl\\:even\\:pt-54:nth-child(even){
    padding-top: 13.5rem;
  }

  .xl\\:even\\:pr-54:nth-child(even){
    padding-right: 13.5rem;
  }

  .xl\\:even\\:pb-54:nth-child(even){
    padding-bottom: 13.5rem;
  }

  .xl\\:even\\:pl-54:nth-child(even){
    padding-left: 13.5rem;
  }

  .xl\\:even\\:pt-56:nth-child(even){
    padding-top: 14rem;
  }

  .xl\\:even\\:pr-56:nth-child(even){
    padding-right: 14rem;
  }

  .xl\\:even\\:pb-56:nth-child(even){
    padding-bottom: 14rem;
  }

  .xl\\:even\\:pl-56:nth-child(even){
    padding-left: 14rem;
  }

  .xl\\:even\\:pt-60:nth-child(even){
    padding-top: 15rem;
  }

  .xl\\:even\\:pr-60:nth-child(even){
    padding-right: 15rem;
  }

  .xl\\:even\\:pb-60:nth-child(even){
    padding-bottom: 15rem;
  }

  .xl\\:even\\:pl-60:nth-child(even){
    padding-left: 15rem;
  }

  .xl\\:even\\:pt-64:nth-child(even){
    padding-top: 16rem;
  }

  .xl\\:even\\:pr-64:nth-child(even){
    padding-right: 16rem;
  }

  .xl\\:even\\:pb-64:nth-child(even){
    padding-bottom: 16rem;
  }

  .xl\\:even\\:pl-64:nth-child(even){
    padding-left: 16rem;
  }

  .xl\\:even\\:pt-68:nth-child(even){
    padding-top: 17rem;
  }

  .xl\\:even\\:pr-68:nth-child(even){
    padding-right: 17rem;
  }

  .xl\\:even\\:pb-68:nth-child(even){
    padding-bottom: 17rem;
  }

  .xl\\:even\\:pl-68:nth-child(even){
    padding-left: 17rem;
  }

  .xl\\:even\\:pt-72:nth-child(even){
    padding-top: 18rem;
  }

  .xl\\:even\\:pr-72:nth-child(even){
    padding-right: 18rem;
  }

  .xl\\:even\\:pb-72:nth-child(even){
    padding-bottom: 18rem;
  }

  .xl\\:even\\:pl-72:nth-child(even){
    padding-left: 18rem;
  }

  .xl\\:even\\:pt-74:nth-child(even){
    padding-top: 18.5rem;
  }

  .xl\\:even\\:pr-74:nth-child(even){
    padding-right: 18.5rem;
  }

  .xl\\:even\\:pb-74:nth-child(even){
    padding-bottom: 18.5rem;
  }

  .xl\\:even\\:pl-74:nth-child(even){
    padding-left: 18.5rem;
  }

  .xl\\:even\\:pt-76:nth-child(even){
    padding-top: 19rem;
  }

  .xl\\:even\\:pr-76:nth-child(even){
    padding-right: 19rem;
  }

  .xl\\:even\\:pb-76:nth-child(even){
    padding-bottom: 19rem;
  }

  .xl\\:even\\:pl-76:nth-child(even){
    padding-left: 19rem;
  }

  .xl\\:even\\:pt-78:nth-child(even){
    padding-top: 19.5rem;
  }

  .xl\\:even\\:pr-78:nth-child(even){
    padding-right: 19.5rem;
  }

  .xl\\:even\\:pb-78:nth-child(even){
    padding-bottom: 19.5rem;
  }

  .xl\\:even\\:pl-78:nth-child(even){
    padding-left: 19.5rem;
  }

  .xl\\:even\\:pt-80:nth-child(even){
    padding-top: 20rem;
  }

  .xl\\:even\\:pr-80:nth-child(even){
    padding-right: 20rem;
  }

  .xl\\:even\\:pb-80:nth-child(even){
    padding-bottom: 20rem;
  }

  .xl\\:even\\:pl-80:nth-child(even){
    padding-left: 20rem;
  }

  .xl\\:even\\:pt-82:nth-child(even){
    padding-top: 20.5rem;
  }

  .xl\\:even\\:pr-82:nth-child(even){
    padding-right: 20.5rem;
  }

  .xl\\:even\\:pb-82:nth-child(even){
    padding-bottom: 20.5rem;
  }

  .xl\\:even\\:pl-82:nth-child(even){
    padding-left: 20.5rem;
  }

  .xl\\:even\\:pt-84:nth-child(even){
    padding-top: 21rem;
  }

  .xl\\:even\\:pr-84:nth-child(even){
    padding-right: 21rem;
  }

  .xl\\:even\\:pb-84:nth-child(even){
    padding-bottom: 21rem;
  }

  .xl\\:even\\:pl-84:nth-child(even){
    padding-left: 21rem;
  }

  .xl\\:even\\:pt-88:nth-child(even){
    padding-top: 22rem;
  }

  .xl\\:even\\:pr-88:nth-child(even){
    padding-right: 22rem;
  }

  .xl\\:even\\:pb-88:nth-child(even){
    padding-bottom: 22rem;
  }

  .xl\\:even\\:pl-88:nth-child(even){
    padding-left: 22rem;
  }

  .xl\\:even\\:pt-92:nth-child(even){
    padding-top: 23rem;
  }

  .xl\\:even\\:pr-92:nth-child(even){
    padding-right: 23rem;
  }

  .xl\\:even\\:pb-92:nth-child(even){
    padding-bottom: 23rem;
  }

  .xl\\:even\\:pl-92:nth-child(even){
    padding-left: 23rem;
  }

  .xl\\:even\\:pt-96:nth-child(even){
    padding-top: 24rem;
  }

  .xl\\:even\\:pr-96:nth-child(even){
    padding-right: 24rem;
  }

  .xl\\:even\\:pb-96:nth-child(even){
    padding-bottom: 24rem;
  }

  .xl\\:even\\:pl-96:nth-child(even){
    padding-left: 24rem;
  }

  .xl\\:even\\:pt-98:nth-child(even){
    padding-top: 24.5rem;
  }

  .xl\\:even\\:pr-98:nth-child(even){
    padding-right: 24.5rem;
  }

  .xl\\:even\\:pb-98:nth-child(even){
    padding-bottom: 24.5rem;
  }

  .xl\\:even\\:pl-98:nth-child(even){
    padding-left: 24.5rem;
  }

  .xl\\:even\\:pt-100:nth-child(even){
    padding-top: 25rem;
  }

  .xl\\:even\\:pr-100:nth-child(even){
    padding-right: 25rem;
  }

  .xl\\:even\\:pb-100:nth-child(even){
    padding-bottom: 25rem;
  }

  .xl\\:even\\:pl-100:nth-child(even){
    padding-left: 25rem;
  }

  .xl\\:even\\:pt-104:nth-child(even){
    padding-top: 26rem;
  }

  .xl\\:even\\:pr-104:nth-child(even){
    padding-right: 26rem;
  }

  .xl\\:even\\:pb-104:nth-child(even){
    padding-bottom: 26rem;
  }

  .xl\\:even\\:pl-104:nth-child(even){
    padding-left: 26rem;
  }

  .xl\\:even\\:pt-112:nth-child(even){
    padding-top: 28rem;
  }

  .xl\\:even\\:pr-112:nth-child(even){
    padding-right: 28rem;
  }

  .xl\\:even\\:pb-112:nth-child(even){
    padding-bottom: 28rem;
  }

  .xl\\:even\\:pl-112:nth-child(even){
    padding-left: 28rem;
  }

  .xl\\:even\\:pt-124:nth-child(even){
    padding-top: 31rem;
  }

  .xl\\:even\\:pr-124:nth-child(even){
    padding-right: 31rem;
  }

  .xl\\:even\\:pb-124:nth-child(even){
    padding-bottom: 31rem;
  }

  .xl\\:even\\:pl-124:nth-child(even){
    padding-left: 31rem;
  }

  .xl\\:even\\:pt-128:nth-child(even){
    padding-top: 32rem;
  }

  .xl\\:even\\:pr-128:nth-child(even){
    padding-right: 32rem;
  }

  .xl\\:even\\:pb-128:nth-child(even){
    padding-bottom: 32rem;
  }

  .xl\\:even\\:pl-128:nth-child(even){
    padding-left: 32rem;
  }

  .xl\\:even\\:pt-140:nth-child(even){
    padding-top: 35rem;
  }

  .xl\\:even\\:pr-140:nth-child(even){
    padding-right: 35rem;
  }

  .xl\\:even\\:pb-140:nth-child(even){
    padding-bottom: 35rem;
  }

  .xl\\:even\\:pl-140:nth-child(even){
    padding-left: 35rem;
  }

  .xl\\:even\\:pt-152:nth-child(even){
    padding-top: 38rem;
  }

  .xl\\:even\\:pr-152:nth-child(even){
    padding-right: 38rem;
  }

  .xl\\:even\\:pb-152:nth-child(even){
    padding-bottom: 38rem;
  }

  .xl\\:even\\:pl-152:nth-child(even){
    padding-left: 38rem;
  }

  .xl\\:even\\:pt-160:nth-child(even){
    padding-top: 40rem;
  }

  .xl\\:even\\:pr-160:nth-child(even){
    padding-right: 40rem;
  }

  .xl\\:even\\:pb-160:nth-child(even){
    padding-bottom: 40rem;
  }

  .xl\\:even\\:pl-160:nth-child(even){
    padding-left: 40rem;
  }

  .xl\\:even\\:pt-162:nth-child(even){
    padding-top: 41rem;
  }

  .xl\\:even\\:pr-162:nth-child(even){
    padding-right: 41rem;
  }

  .xl\\:even\\:pb-162:nth-child(even){
    padding-bottom: 41rem;
  }

  .xl\\:even\\:pl-162:nth-child(even){
    padding-left: 41rem;
  }

  .xl\\:even\\:pt-192:nth-child(even){
    padding-top: 48rem;
  }

  .xl\\:even\\:pr-192:nth-child(even){
    padding-right: 48rem;
  }

  .xl\\:even\\:pb-192:nth-child(even){
    padding-bottom: 48rem;
  }

  .xl\\:even\\:pl-192:nth-child(even){
    padding-left: 48rem;
  }

  .xl\\:even\\:pt-208:nth-child(even){
    padding-top: 52rem;
  }

  .xl\\:even\\:pr-208:nth-child(even){
    padding-right: 52rem;
  }

  .xl\\:even\\:pb-208:nth-child(even){
    padding-bottom: 52rem;
  }

  .xl\\:even\\:pl-208:nth-child(even){
    padding-left: 52rem;
  }

  .xl\\:even\\:pt-224:nth-child(even){
    padding-top: 56rem;
  }

  .xl\\:even\\:pr-224:nth-child(even){
    padding-right: 56rem;
  }

  .xl\\:even\\:pb-224:nth-child(even){
    padding-bottom: 56rem;
  }

  .xl\\:even\\:pl-224:nth-child(even){
    padding-left: 56rem;
  }

  .xl\\:even\\:pt-256:nth-child(even){
    padding-top: 64rem;
  }

  .xl\\:even\\:pr-256:nth-child(even){
    padding-right: 64rem;
  }

  .xl\\:even\\:pb-256:nth-child(even){
    padding-bottom: 64rem;
  }

  .xl\\:even\\:pl-256:nth-child(even){
    padding-left: 64rem;
  }

  .xl\\:even\\:pt-px:nth-child(even){
    padding-top: 1px;
  }

  .xl\\:even\\:pr-px:nth-child(even){
    padding-right: 1px;
  }

  .xl\\:even\\:pb-px:nth-child(even){
    padding-bottom: 1px;
  }

  .xl\\:even\\:pl-px:nth-child(even){
    padding-left: 1px;
  }

  .xl\\:placeholder-transparent::placeholder{
    color: transparent;
  }

  .xl\\:placeholder-focus::placeholder{
    color: rgba(4, 21, 39, 0.8);;
  }

  .xl\\:placeholder-black::placeholder{
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .xl\\:placeholder-white::placeholder{
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .xl\\:placeholder-primary::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .xl\\:placeholder-disabled::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .xl\\:placeholder-translucent-60::placeholder{
    color: rgba(256, 256, 256, 0.6);
  }

  .xl\\:placeholder-translucent-90::placeholder{
    color: rgba(256, 256, 256, 0.9);
  }

  .xl\\:placeholder-green-200::placeholder{
    --placeholder-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, var(--placeholder-opacity));
  }

  .xl\\:placeholder-green-400::placeholder{
    --placeholder-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, var(--placeholder-opacity));
  }

  .xl\\:placeholder-green-500::placeholder{
    --placeholder-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, var(--placeholder-opacity));
  }

  .xl\\:placeholder-green-600::placeholder{
    --placeholder-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, var(--placeholder-opacity));
  }

  .xl\\:placeholder-green-700::placeholder{
    --placeholder-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, var(--placeholder-opacity));
  }

  .xl\\:placeholder-green-400a50::placeholder{
    color: rgba(108,202,152,0.50196);
  }

  .xl\\:placeholder-green-500a25::placeholder{
    color: rgba(151,232,18,0.09804);
  }

  .xl\\:placeholder-yellow-200::placeholder{
    --placeholder-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, var(--placeholder-opacity));
  }

  .xl\\:placeholder-yellow-300::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, var(--placeholder-opacity));
  }

  .xl\\:placeholder-yellow-500::placeholder{
    --placeholder-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, var(--placeholder-opacity));
  }

  .xl\\:placeholder-yellow-600::placeholder{
    --placeholder-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, var(--placeholder-opacity));
  }

  .xl\\:placeholder-yellow-700::placeholder{
    --placeholder-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, var(--placeholder-opacity));
  }

  .xl\\:placeholder-yellow-300a66::placeholder{
    color: rgba(255,233,189,0.66667);
  }

  .xl\\:placeholder-yellow-500a25::placeholder{
    color: rgba(255,200,44,0.09804);
  }

  .xl\\:placeholder-orange-200::placeholder{
    --placeholder-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, var(--placeholder-opacity));
  }

  .xl\\:placeholder-orange-400::placeholder{
    --placeholder-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, var(--placeholder-opacity));
  }

  .xl\\:placeholder-orange-500::placeholder{
    --placeholder-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, var(--placeholder-opacity));
  }

  .xl\\:placeholder-orange-800::placeholder{
    --placeholder-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, var(--placeholder-opacity));
  }

  .xl\\:placeholder-orange-900::placeholder{
    --placeholder-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, var(--placeholder-opacity));
  }

  .xl\\:placeholder-orange-500a25::placeholder{
    color: rgba(240,115,23,0.09804);
  }

  .xl\\:placeholder-red-100::placeholder{
    --placeholder-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, var(--placeholder-opacity));
  }

  .xl\\:placeholder-red-150::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, var(--placeholder-opacity));
  }

  .xl\\:placeholder-red-200::placeholder{
    --placeholder-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, var(--placeholder-opacity));
  }

  .xl\\:placeholder-red-300::placeholder{
    --placeholder-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, var(--placeholder-opacity));
  }

  .xl\\:placeholder-red-400::placeholder{
    --placeholder-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, var(--placeholder-opacity));
  }

  .xl\\:placeholder-red-500::placeholder{
    --placeholder-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, var(--placeholder-opacity));
  }

  .xl\\:placeholder-red-700::placeholder{
    --placeholder-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-50::placeholder{
    --placeholder-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-100::placeholder{
    --placeholder-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-150::placeholder{
    --placeholder-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-200::placeholder{
    --placeholder-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-300::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-400::placeholder{
    color: rgba(114,114,114,0.8);
  }

  .xl\\:placeholder-gray-425::placeholder{
    color: rgba(4, 21, 39, 0.8);
  }

  .xl\\:placeholder-gray-450::placeholder{
    --placeholder-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-500::placeholder{
    --placeholder-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-600::placeholder{
    --placeholder-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-625::placeholder{
    color: rgba(90,98,107,0.8);
  }

  .xl\\:placeholder-gray-700::placeholder{
    --placeholder-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-800::placeholder{
    --placeholder-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, var(--placeholder-opacity));
  }

  .xl\\:placeholder-gray-200a50::placeholder{
    color: rgba(224, 226, 228, 0.5);
  }

  .xl\\:placeholder-blue-50::placeholder{
    --placeholder-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-100::placeholder{
    --placeholder-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-150::placeholder{
    --placeholder-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-200::placeholder{
    --placeholder-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-300::placeholder{
    --placeholder-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-400::placeholder{
    --placeholder-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-500::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-600::placeholder{
    --placeholder-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-700::placeholder{
    --placeholder-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-750::placeholder{
    --placeholder-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-800::placeholder{
    --placeholder-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-900::placeholder{
    --placeholder-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-950::placeholder{
    --placeholder-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-500a25::placeholder{
    color: rgba(55, 164, 220, 0.2);
  }

  .xl\\:placeholder-blue-500a50::placeholder{
    color: rgba(55, 164, 220, 0.5);
  }

  .xl\\:placeholder-blue-700a75::placeholder{
    --placeholder-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-700a30::placeholder{
    --placeholder-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, var(--placeholder-opacity));
  }

  .xl\\:placeholder-blue-750a25::placeholder{
    color: rgba(86,130,170,0.09804);
  }

  .xl\\:placeholder-blue-750a15::placeholder{
    color: rgba(86,130,170,0.05882);
  }

  .xl\\:placeholder-blue-800a60::placeholder{
    color: rgba(31, 69, 102, 0.6);
  }

  .xl\\:placeholder-programEditorTabColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, var(--placeholder-opacity));
  }

  .xl\\:placeholder-programEditorTabColors-2::placeholder{
    --placeholder-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, var(--placeholder-opacity));
  }

  .xl\\:placeholder-programEditorTabColors-3::placeholder{
    --placeholder-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, var(--placeholder-opacity));
  }

  .xl\\:placeholder-programEditorTabColors-4::placeholder{
    --placeholder-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, var(--placeholder-opacity));
  }

  .xl\\:placeholder-programEditorTabColors-5::placeholder{
    --placeholder-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, var(--placeholder-opacity));
  }

  .xl\\:placeholder-programEditorTabColors-6::placeholder{
    --placeholder-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, var(--placeholder-opacity));
  }

  .xl\\:placeholder-programEditorTabColors-1h::placeholder{
    --placeholder-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, var(--placeholder-opacity));
  }

  .xl\\:placeholder-programEditorTabColors-2h::placeholder{
    --placeholder-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, var(--placeholder-opacity));
  }

  .xl\\:placeholder-programEditorTabColors-3h::placeholder{
    --placeholder-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, var(--placeholder-opacity));
  }

  .xl\\:placeholder-programEditorTabColors-4h::placeholder{
    --placeholder-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, var(--placeholder-opacity));
  }

  .xl\\:placeholder-programEditorTabColors-5h::placeholder{
    --placeholder-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, var(--placeholder-opacity));
  }

  .xl\\:placeholder-programEditorTabColors-6h::placeholder{
    --placeholder-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, var(--placeholder-opacity));
  }

  .xl\\:placeholder-programEditorPresetTabColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .xl\\:placeholder-programEditorPresetTabColors-1h::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .xl\\:placeholder-borgScaleColors-0::placeholder{
    --placeholder-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, var(--placeholder-opacity));
  }

  .xl\\:placeholder-borgScaleColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, var(--placeholder-opacity));
  }

  .xl\\:placeholder-borgScaleColors-2::placeholder{
    --placeholder-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, var(--placeholder-opacity));
  }

  .xl\\:placeholder-borgScaleColors-3::placeholder{
    --placeholder-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, var(--placeholder-opacity));
  }

  .xl\\:placeholder-borgScaleColors-4::placeholder{
    --placeholder-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .xl\\:placeholder-borgScaleColors-5::placeholder{
    --placeholder-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, var(--placeholder-opacity));
  }

  .xl\\:placeholder-borgScaleColors-6::placeholder{
    --placeholder-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, var(--placeholder-opacity));
  }

  .xl\\:placeholder-borgScaleColors-7::placeholder{
    --placeholder-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, var(--placeholder-opacity));
  }

  .xl\\:placeholder-borgScaleColors-8::placeholder{
    --placeholder-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, var(--placeholder-opacity));
  }

  .xl\\:placeholder-borgScaleColors-9::placeholder{
    --placeholder-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, var(--placeholder-opacity));
  }

  .xl\\:placeholder-borgScaleColors-10::placeholder{
    --placeholder-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-transparent:focus::placeholder{
    color: transparent;
  }

  .xl\\:focus\\:placeholder-focus:focus::placeholder{
    color: rgba(4, 21, 39, 0.8);;
  }

  .xl\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-primary:focus::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-disabled:focus::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-translucent-60:focus::placeholder{
    color: rgba(256, 256, 256, 0.6);
  }

  .xl\\:focus\\:placeholder-translucent-90:focus::placeholder{
    color: rgba(256, 256, 256, 0.9);
  }

  .xl\\:focus\\:placeholder-green-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-green-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-green-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-green-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-green-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-green-400a50:focus::placeholder{
    color: rgba(108,202,152,0.50196);
  }

  .xl\\:focus\\:placeholder-green-500a25:focus::placeholder{
    color: rgba(151,232,18,0.09804);
  }

  .xl\\:focus\\:placeholder-yellow-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-yellow-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-yellow-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-yellow-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-yellow-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-yellow-300a66:focus::placeholder{
    color: rgba(255,233,189,0.66667);
  }

  .xl\\:focus\\:placeholder-yellow-500a25:focus::placeholder{
    color: rgba(255,200,44,0.09804);
  }

  .xl\\:focus\\:placeholder-orange-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-orange-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-orange-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-orange-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-orange-900:focus::placeholder{
    --placeholder-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-orange-500a25:focus::placeholder{
    color: rgba(240,115,23,0.09804);
  }

  .xl\\:focus\\:placeholder-red-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-red-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-red-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-red-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-red-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-red-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-red-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-50:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-400:focus::placeholder{
    color: rgba(114,114,114,0.8);
  }

  .xl\\:focus\\:placeholder-gray-425:focus::placeholder{
    color: rgba(4, 21, 39, 0.8);
  }

  .xl\\:focus\\:placeholder-gray-450:focus::placeholder{
    --placeholder-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-625:focus::placeholder{
    color: rgba(90,98,107,0.8);
  }

  .xl\\:focus\\:placeholder-gray-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-gray-200a50:focus::placeholder{
    color: rgba(224, 226, 228, 0.5);
  }

  .xl\\:focus\\:placeholder-blue-50:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-750:focus::placeholder{
    --placeholder-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-900:focus::placeholder{
    --placeholder-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-950:focus::placeholder{
    --placeholder-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-500a25:focus::placeholder{
    color: rgba(55, 164, 220, 0.2);
  }

  .xl\\:focus\\:placeholder-blue-500a50:focus::placeholder{
    color: rgba(55, 164, 220, 0.5);
  }

  .xl\\:focus\\:placeholder-blue-700a75:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-700a30:focus::placeholder{
    --placeholder-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-blue-750a25:focus::placeholder{
    color: rgba(86,130,170,0.09804);
  }

  .xl\\:focus\\:placeholder-blue-750a15:focus::placeholder{
    color: rgba(86,130,170,0.05882);
  }

  .xl\\:focus\\:placeholder-blue-800a60:focus::placeholder{
    color: rgba(31, 69, 102, 0.6);
  }

  .xl\\:focus\\:placeholder-programEditorTabColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-programEditorTabColors-2:focus::placeholder{
    --placeholder-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-programEditorTabColors-3:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-programEditorTabColors-4:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-programEditorTabColors-5:focus::placeholder{
    --placeholder-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-programEditorTabColors-6:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-programEditorTabColors-1h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-programEditorTabColors-2h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-programEditorTabColors-3h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-programEditorTabColors-4h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-programEditorTabColors-5h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-programEditorTabColors-6h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-programEditorPresetTabColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-programEditorPresetTabColors-1h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-borgScaleColors-0:focus::placeholder{
    --placeholder-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-borgScaleColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-borgScaleColors-2:focus::placeholder{
    --placeholder-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-borgScaleColors-3:focus::placeholder{
    --placeholder-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-borgScaleColors-4:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-borgScaleColors-5:focus::placeholder{
    --placeholder-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-borgScaleColors-6:focus::placeholder{
    --placeholder-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-borgScaleColors-7:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-borgScaleColors-8:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-borgScaleColors-9:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, var(--placeholder-opacity));
  }

  .xl\\:focus\\:placeholder-borgScaleColors-10:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, var(--placeholder-opacity));
  }

  .xl\\:placeholder-opacity-0::placeholder{
    --placeholder-opacity: 0;
  }

  .xl\\:placeholder-opacity-25::placeholder{
    --placeholder-opacity: .25;
  }

  .xl\\:placeholder-opacity-50::placeholder{
    --placeholder-opacity: .5;
  }

  .xl\\:placeholder-opacity-75::placeholder{
    --placeholder-opacity: .75;
  }

  .xl\\:placeholder-opacity-100::placeholder{
    --placeholder-opacity: 1;
  }

  .xl\\:focus\\:placeholder-opacity-0:focus::placeholder{
    --placeholder-opacity: 0;
  }

  .xl\\:focus\\:placeholder-opacity-25:focus::placeholder{
    --placeholder-opacity: .25;
  }

  .xl\\:focus\\:placeholder-opacity-50:focus::placeholder{
    --placeholder-opacity: .5;
  }

  .xl\\:focus\\:placeholder-opacity-75:focus::placeholder{
    --placeholder-opacity: .75;
  }

  .xl\\:focus\\:placeholder-opacity-100:focus::placeholder{
    --placeholder-opacity: 1;
  }

  .xl\\:pointer-events-none{
    pointer-events: none;
  }

  .xl\\:pointer-events-auto{
    pointer-events: auto;
  }

  .xl\\:static{
    position: static;
  }

  .xl\\:fixed{
    position: fixed;
  }

  .xl\\:absolute{
    position: absolute;
  }

  .xl\\:relative{
    position: relative;
  }

  .xl\\:sticky{
    position: sticky;
  }

  .xl\\:inset-0{
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .xl\\:inset-auto{
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }

  .xl\\:inset-y-0{
    top: 0;
    bottom: 0;
  }

  .xl\\:inset-x-0{
    right: 0;
    left: 0;
  }

  .xl\\:inset-y-auto{
    top: auto;
    bottom: auto;
  }

  .xl\\:inset-x-auto{
    right: auto;
    left: auto;
  }

  .xl\\:top-0{
    top: 0;
  }

  .xl\\:right-0{
    right: 0;
  }

  .xl\\:bottom-0{
    bottom: 0;
  }

  .xl\\:left-0{
    left: 0;
  }

  .xl\\:top-auto{
    top: auto;
  }

  .xl\\:right-auto{
    right: auto;
  }

  .xl\\:bottom-auto{
    bottom: auto;
  }

  .xl\\:left-auto{
    left: auto;
  }

  .xl\\:resize-none{
    resize: none;
  }

  .xl\\:resize-y{
    resize: vertical;
  }

  .xl\\:resize-x{
    resize: horizontal;
  }

  .xl\\:resize{
    resize: both;
  }

  .xl\\:shadow{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .xl\\:shadow-overlaptop{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .xl\\:shadow-overlapbottom{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .xl\\:shadow-xs{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .xl\\:shadow-sm{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .xl\\:shadow-md{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .xl\\:shadow-lg{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .xl\\:shadow-xl{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .xl\\:shadow-2xl{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .xl\\:shadow-none{
    box-shadow: none;
  }

  .xl\\:hover\\:shadow:hover{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .xl\\:hover\\:shadow-overlaptop:hover{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .xl\\:hover\\:shadow-overlapbottom:hover{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .xl\\:hover\\:shadow-xs:hover{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .xl\\:hover\\:shadow-sm:hover{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .xl\\:hover\\:shadow-md:hover{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .xl\\:hover\\:shadow-lg:hover{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .xl\\:hover\\:shadow-xl:hover{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .xl\\:hover\\:shadow-2xl:hover{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .xl\\:hover\\:shadow-none:hover{
    box-shadow: none;
  }

  .xl\\:focus\\:shadow:focus{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .xl\\:focus\\:shadow-overlaptop:focus{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .xl\\:focus\\:shadow-overlapbottom:focus{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .xl\\:focus\\:shadow-xs:focus{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .xl\\:focus\\:shadow-sm:focus{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .xl\\:focus\\:shadow-md:focus{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .xl\\:focus\\:shadow-lg:focus{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .xl\\:focus\\:shadow-xl:focus{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .xl\\:focus\\:shadow-2xl:focus{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .xl\\:focus\\:shadow-none:focus{
    box-shadow: none;
  }

  .xl\\:stroke-0{
    stroke-width: 0;
  }

  .xl\\:stroke-1{
    stroke-width: 1;
  }

  .xl\\:stroke-2{
    stroke-width: 2;
  }

  .xl\\:table-auto{
    table-layout: auto;
  }

  .xl\\:table-fixed{
    table-layout: fixed;
  }

  .xl\\:text-left{
    text-align: left;
  }

  .xl\\:text-center{
    text-align: center;
  }

  .xl\\:text-right{
    text-align: right;
  }

  .xl\\:text-justify{
    text-align: justify;
  }

  .xl\\:text-transparent{
    color: transparent;
  }

  .xl\\:text-focus{
    color: rgba(4, 21, 39, 0.8);;
  }

  .xl\\:text-black{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .xl\\:text-white{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .xl\\:text-primary{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .xl\\:text-disabled{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .xl\\:text-translucent-60{
    color: rgba(256, 256, 256, 0.6);
  }

  .xl\\:text-translucent-90{
    color: rgba(256, 256, 256, 0.9);
  }

  .xl\\:text-green-200{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .xl\\:text-green-400{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .xl\\:text-green-500{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .xl\\:text-green-600{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .xl\\:text-green-700{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .xl\\:text-green-400a50{
    color: rgba(108,202,152,0.50196);
  }

  .xl\\:text-green-500a25{
    color: rgba(151,232,18,0.09804);
  }

  .xl\\:text-yellow-200{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .xl\\:text-yellow-300{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .xl\\:text-yellow-500{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .xl\\:text-yellow-600{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .xl\\:text-yellow-700{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .xl\\:text-yellow-300a66{
    color: rgba(255,233,189,0.66667);
  }

  .xl\\:text-yellow-500a25{
    color: rgba(255,200,44,0.09804);
  }

  .xl\\:text-orange-200{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .xl\\:text-orange-400{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .xl\\:text-orange-500{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .xl\\:text-orange-800{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .xl\\:text-orange-900{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .xl\\:text-orange-500a25{
    color: rgba(240,115,23,0.09804);
  }

  .xl\\:text-red-100{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .xl\\:text-red-150{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .xl\\:text-red-200{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .xl\\:text-red-300{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .xl\\:text-red-400{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .xl\\:text-red-500{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .xl\\:text-red-700{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .xl\\:text-gray-50{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .xl\\:text-gray-100{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .xl\\:text-gray-150{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .xl\\:text-gray-200{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .xl\\:text-gray-300{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .xl\\:text-gray-400{
    color: rgba(114,114,114,0.8);
  }

  .xl\\:text-gray-425{
    color: rgba(4, 21, 39, 0.8);
  }

  .xl\\:text-gray-450{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .xl\\:text-gray-500{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .xl\\:text-gray-600{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .xl\\:text-gray-625{
    color: rgba(90,98,107,0.8);
  }

  .xl\\:text-gray-700{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .xl\\:text-gray-800{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .xl\\:text-gray-200a50{
    color: rgba(224, 226, 228, 0.5);
  }

  .xl\\:text-blue-50{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .xl\\:text-blue-100{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .xl\\:text-blue-150{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .xl\\:text-blue-200{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .xl\\:text-blue-300{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .xl\\:text-blue-400{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .xl\\:text-blue-500{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .xl\\:text-blue-600{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .xl\\:text-blue-700{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .xl\\:text-blue-750{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .xl\\:text-blue-800{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .xl\\:text-blue-900{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .xl\\:text-blue-950{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .xl\\:text-blue-500a25{
    color: rgba(55, 164, 220, 0.2);
  }

  .xl\\:text-blue-500a50{
    color: rgba(55, 164, 220, 0.5);
  }

  .xl\\:text-blue-700a75{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .xl\\:text-blue-700a30{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .xl\\:text-blue-750a25{
    color: rgba(86,130,170,0.09804);
  }

  .xl\\:text-blue-750a15{
    color: rgba(86,130,170,0.05882);
  }

  .xl\\:text-blue-800a60{
    color: rgba(31, 69, 102, 0.6);
  }

  .xl\\:text-programEditorTabColors-1{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .xl\\:text-programEditorTabColors-2{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .xl\\:text-programEditorTabColors-3{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .xl\\:text-programEditorTabColors-4{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .xl\\:text-programEditorTabColors-5{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .xl\\:text-programEditorTabColors-6{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .xl\\:text-programEditorTabColors-1h{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .xl\\:text-programEditorTabColors-2h{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .xl\\:text-programEditorTabColors-3h{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .xl\\:text-programEditorTabColors-4h{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .xl\\:text-programEditorTabColors-5h{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .xl\\:text-programEditorTabColors-6h{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .xl\\:text-programEditorPresetTabColors-1{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .xl\\:text-programEditorPresetTabColors-1h{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .xl\\:text-borgScaleColors-0{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .xl\\:text-borgScaleColors-1{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .xl\\:text-borgScaleColors-2{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .xl\\:text-borgScaleColors-3{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .xl\\:text-borgScaleColors-4{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .xl\\:text-borgScaleColors-5{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .xl\\:text-borgScaleColors-6{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .xl\\:text-borgScaleColors-7{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .xl\\:text-borgScaleColors-8{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .xl\\:text-borgScaleColors-9{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .xl\\:text-borgScaleColors-10{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .xl\\:hover\\:text-transparent:hover{
    color: transparent;
  }

  .xl\\:hover\\:text-focus:hover{
    color: rgba(4, 21, 39, 0.8);;
  }

  .xl\\:hover\\:text-black:hover{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .xl\\:hover\\:text-white:hover{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .xl\\:hover\\:text-primary:hover{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .xl\\:hover\\:text-disabled:hover{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .xl\\:hover\\:text-translucent-60:hover{
    color: rgba(256, 256, 256, 0.6);
  }

  .xl\\:hover\\:text-translucent-90:hover{
    color: rgba(256, 256, 256, 0.9);
  }

  .xl\\:hover\\:text-green-200:hover{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .xl\\:hover\\:text-green-400:hover{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .xl\\:hover\\:text-green-500:hover{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .xl\\:hover\\:text-green-600:hover{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .xl\\:hover\\:text-green-700:hover{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .xl\\:hover\\:text-green-400a50:hover{
    color: rgba(108,202,152,0.50196);
  }

  .xl\\:hover\\:text-green-500a25:hover{
    color: rgba(151,232,18,0.09804);
  }

  .xl\\:hover\\:text-yellow-200:hover{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .xl\\:hover\\:text-yellow-300:hover{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .xl\\:hover\\:text-yellow-500:hover{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .xl\\:hover\\:text-yellow-600:hover{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .xl\\:hover\\:text-yellow-700:hover{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .xl\\:hover\\:text-yellow-300a66:hover{
    color: rgba(255,233,189,0.66667);
  }

  .xl\\:hover\\:text-yellow-500a25:hover{
    color: rgba(255,200,44,0.09804);
  }

  .xl\\:hover\\:text-orange-200:hover{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .xl\\:hover\\:text-orange-400:hover{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .xl\\:hover\\:text-orange-500:hover{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .xl\\:hover\\:text-orange-800:hover{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .xl\\:hover\\:text-orange-900:hover{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .xl\\:hover\\:text-orange-500a25:hover{
    color: rgba(240,115,23,0.09804);
  }

  .xl\\:hover\\:text-red-100:hover{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .xl\\:hover\\:text-red-150:hover{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .xl\\:hover\\:text-red-200:hover{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .xl\\:hover\\:text-red-300:hover{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .xl\\:hover\\:text-red-400:hover{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .xl\\:hover\\:text-red-500:hover{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .xl\\:hover\\:text-red-700:hover{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .xl\\:hover\\:text-gray-50:hover{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .xl\\:hover\\:text-gray-100:hover{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .xl\\:hover\\:text-gray-150:hover{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .xl\\:hover\\:text-gray-200:hover{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .xl\\:hover\\:text-gray-300:hover{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .xl\\:hover\\:text-gray-400:hover{
    color: rgba(114,114,114,0.8);
  }

  .xl\\:hover\\:text-gray-425:hover{
    color: rgba(4, 21, 39, 0.8);
  }

  .xl\\:hover\\:text-gray-450:hover{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .xl\\:hover\\:text-gray-500:hover{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .xl\\:hover\\:text-gray-600:hover{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .xl\\:hover\\:text-gray-625:hover{
    color: rgba(90,98,107,0.8);
  }

  .xl\\:hover\\:text-gray-700:hover{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .xl\\:hover\\:text-gray-800:hover{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .xl\\:hover\\:text-gray-200a50:hover{
    color: rgba(224, 226, 228, 0.5);
  }

  .xl\\:hover\\:text-blue-50:hover{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .xl\\:hover\\:text-blue-100:hover{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .xl\\:hover\\:text-blue-150:hover{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .xl\\:hover\\:text-blue-200:hover{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .xl\\:hover\\:text-blue-300:hover{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .xl\\:hover\\:text-blue-400:hover{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .xl\\:hover\\:text-blue-500:hover{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .xl\\:hover\\:text-blue-600:hover{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .xl\\:hover\\:text-blue-700:hover{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .xl\\:hover\\:text-blue-750:hover{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .xl\\:hover\\:text-blue-800:hover{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .xl\\:hover\\:text-blue-900:hover{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .xl\\:hover\\:text-blue-950:hover{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .xl\\:hover\\:text-blue-500a25:hover{
    color: rgba(55, 164, 220, 0.2);
  }

  .xl\\:hover\\:text-blue-500a50:hover{
    color: rgba(55, 164, 220, 0.5);
  }

  .xl\\:hover\\:text-blue-700a75:hover{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .xl\\:hover\\:text-blue-700a30:hover{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .xl\\:hover\\:text-blue-750a25:hover{
    color: rgba(86,130,170,0.09804);
  }

  .xl\\:hover\\:text-blue-750a15:hover{
    color: rgba(86,130,170,0.05882);
  }

  .xl\\:hover\\:text-blue-800a60:hover{
    color: rgba(31, 69, 102, 0.6);
  }

  .xl\\:hover\\:text-programEditorTabColors-1:hover{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .xl\\:hover\\:text-programEditorTabColors-2:hover{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .xl\\:hover\\:text-programEditorTabColors-3:hover{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .xl\\:hover\\:text-programEditorTabColors-4:hover{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .xl\\:hover\\:text-programEditorTabColors-5:hover{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .xl\\:hover\\:text-programEditorTabColors-6:hover{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .xl\\:hover\\:text-programEditorTabColors-1h:hover{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .xl\\:hover\\:text-programEditorTabColors-2h:hover{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .xl\\:hover\\:text-programEditorTabColors-3h:hover{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .xl\\:hover\\:text-programEditorTabColors-4h:hover{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .xl\\:hover\\:text-programEditorTabColors-5h:hover{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .xl\\:hover\\:text-programEditorTabColors-6h:hover{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .xl\\:hover\\:text-programEditorPresetTabColors-1:hover{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .xl\\:hover\\:text-programEditorPresetTabColors-1h:hover{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .xl\\:hover\\:text-borgScaleColors-0:hover{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .xl\\:hover\\:text-borgScaleColors-1:hover{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .xl\\:hover\\:text-borgScaleColors-2:hover{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .xl\\:hover\\:text-borgScaleColors-3:hover{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .xl\\:hover\\:text-borgScaleColors-4:hover{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .xl\\:hover\\:text-borgScaleColors-5:hover{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .xl\\:hover\\:text-borgScaleColors-6:hover{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .xl\\:hover\\:text-borgScaleColors-7:hover{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .xl\\:hover\\:text-borgScaleColors-8:hover{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .xl\\:hover\\:text-borgScaleColors-9:hover{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .xl\\:hover\\:text-borgScaleColors-10:hover{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .xl\\:focus\\:text-transparent:focus{
    color: transparent;
  }

  .xl\\:focus\\:text-focus:focus{
    color: rgba(4, 21, 39, 0.8);;
  }

  .xl\\:focus\\:text-black:focus{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .xl\\:focus\\:text-white:focus{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .xl\\:focus\\:text-primary:focus{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .xl\\:focus\\:text-disabled:focus{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .xl\\:focus\\:text-translucent-60:focus{
    color: rgba(256, 256, 256, 0.6);
  }

  .xl\\:focus\\:text-translucent-90:focus{
    color: rgba(256, 256, 256, 0.9);
  }

  .xl\\:focus\\:text-green-200:focus{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .xl\\:focus\\:text-green-400:focus{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .xl\\:focus\\:text-green-500:focus{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .xl\\:focus\\:text-green-600:focus{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .xl\\:focus\\:text-green-700:focus{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .xl\\:focus\\:text-green-400a50:focus{
    color: rgba(108,202,152,0.50196);
  }

  .xl\\:focus\\:text-green-500a25:focus{
    color: rgba(151,232,18,0.09804);
  }

  .xl\\:focus\\:text-yellow-200:focus{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .xl\\:focus\\:text-yellow-300:focus{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .xl\\:focus\\:text-yellow-500:focus{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .xl\\:focus\\:text-yellow-600:focus{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .xl\\:focus\\:text-yellow-700:focus{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .xl\\:focus\\:text-yellow-300a66:focus{
    color: rgba(255,233,189,0.66667);
  }

  .xl\\:focus\\:text-yellow-500a25:focus{
    color: rgba(255,200,44,0.09804);
  }

  .xl\\:focus\\:text-orange-200:focus{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .xl\\:focus\\:text-orange-400:focus{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .xl\\:focus\\:text-orange-500:focus{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .xl\\:focus\\:text-orange-800:focus{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .xl\\:focus\\:text-orange-900:focus{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .xl\\:focus\\:text-orange-500a25:focus{
    color: rgba(240,115,23,0.09804);
  }

  .xl\\:focus\\:text-red-100:focus{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .xl\\:focus\\:text-red-150:focus{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .xl\\:focus\\:text-red-200:focus{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .xl\\:focus\\:text-red-300:focus{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .xl\\:focus\\:text-red-400:focus{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .xl\\:focus\\:text-red-500:focus{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .xl\\:focus\\:text-red-700:focus{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .xl\\:focus\\:text-gray-50:focus{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .xl\\:focus\\:text-gray-100:focus{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .xl\\:focus\\:text-gray-150:focus{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .xl\\:focus\\:text-gray-200:focus{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .xl\\:focus\\:text-gray-300:focus{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .xl\\:focus\\:text-gray-400:focus{
    color: rgba(114,114,114,0.8);
  }

  .xl\\:focus\\:text-gray-425:focus{
    color: rgba(4, 21, 39, 0.8);
  }

  .xl\\:focus\\:text-gray-450:focus{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .xl\\:focus\\:text-gray-500:focus{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .xl\\:focus\\:text-gray-600:focus{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .xl\\:focus\\:text-gray-625:focus{
    color: rgba(90,98,107,0.8);
  }

  .xl\\:focus\\:text-gray-700:focus{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .xl\\:focus\\:text-gray-800:focus{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .xl\\:focus\\:text-gray-200a50:focus{
    color: rgba(224, 226, 228, 0.5);
  }

  .xl\\:focus\\:text-blue-50:focus{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .xl\\:focus\\:text-blue-100:focus{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .xl\\:focus\\:text-blue-150:focus{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .xl\\:focus\\:text-blue-200:focus{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .xl\\:focus\\:text-blue-300:focus{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .xl\\:focus\\:text-blue-400:focus{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .xl\\:focus\\:text-blue-500:focus{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .xl\\:focus\\:text-blue-600:focus{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .xl\\:focus\\:text-blue-700:focus{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .xl\\:focus\\:text-blue-750:focus{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .xl\\:focus\\:text-blue-800:focus{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .xl\\:focus\\:text-blue-900:focus{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .xl\\:focus\\:text-blue-950:focus{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .xl\\:focus\\:text-blue-500a25:focus{
    color: rgba(55, 164, 220, 0.2);
  }

  .xl\\:focus\\:text-blue-500a50:focus{
    color: rgba(55, 164, 220, 0.5);
  }

  .xl\\:focus\\:text-blue-700a75:focus{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .xl\\:focus\\:text-blue-700a30:focus{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .xl\\:focus\\:text-blue-750a25:focus{
    color: rgba(86,130,170,0.09804);
  }

  .xl\\:focus\\:text-blue-750a15:focus{
    color: rgba(86,130,170,0.05882);
  }

  .xl\\:focus\\:text-blue-800a60:focus{
    color: rgba(31, 69, 102, 0.6);
  }

  .xl\\:focus\\:text-programEditorTabColors-1:focus{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .xl\\:focus\\:text-programEditorTabColors-2:focus{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .xl\\:focus\\:text-programEditorTabColors-3:focus{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .xl\\:focus\\:text-programEditorTabColors-4:focus{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .xl\\:focus\\:text-programEditorTabColors-5:focus{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .xl\\:focus\\:text-programEditorTabColors-6:focus{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .xl\\:focus\\:text-programEditorTabColors-1h:focus{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .xl\\:focus\\:text-programEditorTabColors-2h:focus{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .xl\\:focus\\:text-programEditorTabColors-3h:focus{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .xl\\:focus\\:text-programEditorTabColors-4h:focus{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .xl\\:focus\\:text-programEditorTabColors-5h:focus{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .xl\\:focus\\:text-programEditorTabColors-6h:focus{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .xl\\:focus\\:text-programEditorPresetTabColors-1:focus{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .xl\\:focus\\:text-programEditorPresetTabColors-1h:focus{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .xl\\:focus\\:text-borgScaleColors-0:focus{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .xl\\:focus\\:text-borgScaleColors-1:focus{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .xl\\:focus\\:text-borgScaleColors-2:focus{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .xl\\:focus\\:text-borgScaleColors-3:focus{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .xl\\:focus\\:text-borgScaleColors-4:focus{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .xl\\:focus\\:text-borgScaleColors-5:focus{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .xl\\:focus\\:text-borgScaleColors-6:focus{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .xl\\:focus\\:text-borgScaleColors-7:focus{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .xl\\:focus\\:text-borgScaleColors-8:focus{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .xl\\:focus\\:text-borgScaleColors-9:focus{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .xl\\:focus\\:text-borgScaleColors-10:focus{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .xl\\:text-opacity-0{
    --text-opacity: 0;
  }

  .xl\\:text-opacity-25{
    --text-opacity: .25;
  }

  .xl\\:text-opacity-50{
    --text-opacity: .5;
  }

  .xl\\:text-opacity-75{
    --text-opacity: .75;
  }

  .xl\\:text-opacity-100{
    --text-opacity: 1;
  }

  .xl\\:hover\\:text-opacity-0:hover{
    --text-opacity: 0;
  }

  .xl\\:hover\\:text-opacity-25:hover{
    --text-opacity: .25;
  }

  .xl\\:hover\\:text-opacity-50:hover{
    --text-opacity: .5;
  }

  .xl\\:hover\\:text-opacity-75:hover{
    --text-opacity: .75;
  }

  .xl\\:hover\\:text-opacity-100:hover{
    --text-opacity: 1;
  }

  .xl\\:focus\\:text-opacity-0:focus{
    --text-opacity: 0;
  }

  .xl\\:focus\\:text-opacity-25:focus{
    --text-opacity: .25;
  }

  .xl\\:focus\\:text-opacity-50:focus{
    --text-opacity: .5;
  }

  .xl\\:focus\\:text-opacity-75:focus{
    --text-opacity: .75;
  }

  .xl\\:focus\\:text-opacity-100:focus{
    --text-opacity: 1;
  }

  .xl\\:italic{
    font-style: italic;
  }

  .xl\\:not-italic{
    font-style: normal;
  }

  .xl\\:uppercase{
    text-transform: uppercase;
  }

  .xl\\:lowercase{
    text-transform: lowercase;
  }

  .xl\\:capitalize{
    text-transform: capitalize;
  }

  .xl\\:normal-case{
    text-transform: none;
  }

  .xl\\:underline{
    text-decoration: underline;
  }

  .xl\\:line-through{
    text-decoration: line-through;
  }

  .xl\\:no-underline{
    text-decoration: none;
  }

  .xl\\:hover\\:underline:hover{
    text-decoration: underline;
  }

  .xl\\:hover\\:line-through:hover{
    text-decoration: line-through;
  }

  .xl\\:hover\\:no-underline:hover{
    text-decoration: none;
  }

  .xl\\:focus\\:underline:focus{
    text-decoration: underline;
  }

  .xl\\:focus\\:line-through:focus{
    text-decoration: line-through;
  }

  .xl\\:focus\\:no-underline:focus{
    text-decoration: none;
  }

  .xl\\:antialiased{
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .xl\\:subpixel-antialiased{
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }

  .xl\\:ordinal, .xl\\:slashed-zero, .xl\\:lining-nums, .xl\\:oldstyle-nums, .xl\\:proportional-nums, .xl\\:tabular-nums, .xl\\:diagonal-fractions, .xl\\:stacked-fractions{
    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);
    font-feature-settings: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
  }

  .xl\\:normal-nums{
    font-feature-settings: normal;
    font-variant-numeric: normal;
  }

  .xl\\:ordinal{
    --font-variant-numeric-ordinal: ordinal;
  }

  .xl\\:slashed-zero{
    --font-variant-numeric-slashed-zero: slashed-zero;
  }

  .xl\\:lining-nums{
    --font-variant-numeric-figure: lining-nums;
  }

  .xl\\:oldstyle-nums{
    --font-variant-numeric-figure: oldstyle-nums;
  }

  .xl\\:proportional-nums{
    --font-variant-numeric-spacing: proportional-nums;
  }

  .xl\\:tabular-nums{
    --font-variant-numeric-spacing: tabular-nums;
  }

  .xl\\:diagonal-fractions{
    --font-variant-numeric-fraction: diagonal-fractions;
  }

  .xl\\:stacked-fractions{
    --font-variant-numeric-fraction: stacked-fractions;
  }

  .xl\\:tracking-tight{
    letter-spacing: -0.025em;
  }

  .xl\\:tracking-normal{
    letter-spacing: 0;
  }

  .xl\\:tracking-wide{
    letter-spacing: 0.01em;
  }

  .xl\\:tracking-wider{
    letter-spacing: 0.02em;
  }

  .xl\\:tracking-widest{
    letter-spacing: 0.05em;
  }

  .xl\\:select-none{
    -webkit-user-select: none;
            user-select: none;
  }

  .xl\\:select-text{
    -webkit-user-select: text;
            user-select: text;
  }

  .xl\\:select-all{
    -webkit-user-select: all;
            user-select: all;
  }

  .xl\\:select-auto{
    -webkit-user-select: auto;
            user-select: auto;
  }

  .xl\\:align-baseline{
    vertical-align: baseline;
  }

  .xl\\:align-top{
    vertical-align: top;
  }

  .xl\\:align-middle{
    vertical-align: middle;
  }

  .xl\\:align-bottom{
    vertical-align: bottom;
  }

  .xl\\:align-text-top{
    vertical-align: text-top;
  }

  .xl\\:align-text-bottom{
    vertical-align: text-bottom;
  }

  .xl\\:visible{
    visibility: visible;
  }

  .xl\\:invisible{
    visibility: hidden;
  }

  .xl\\:whitespace-normal{
    white-space: normal;
  }

  .xl\\:whitespace-no-wrap{
    white-space: nowrap;
  }

  .xl\\:whitespace-pre{
    white-space: pre;
  }

  .xl\\:whitespace-pre-line{
    white-space: pre-line;
  }

  .xl\\:whitespace-pre-wrap{
    white-space: pre-wrap;
  }

  .xl\\:break-normal{
    word-wrap: normal;
    word-wrap: normal;
    word-break: normal;
  }

  .xl\\:break-words{
    word-wrap: break-word;
    word-wrap: break-word;
  }

  .xl\\:break-all{
    word-break: break-all;
  }

  .xl\\:truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .xl\\:w-0{
    width: 0;
  }

  .xl\\:w-1{
    width: 0.25rem;
  }

  .xl\\:w-2{
    width: 0.5rem;
  }

  .xl\\:w-3{
    width: 0.75rem;
  }

  .xl\\:w-4{
    width: 1rem;
  }

  .xl\\:w-5{
    width: 1.25rem;
  }

  .xl\\:w-6{
    width: 1.5rem;
  }

  .xl\\:w-7{
    width: 1.75rem;
  }

  .xl\\:w-8{
    width: 2rem;
  }

  .xl\\:w-9{
    width: 2.25rem;
  }

  .xl\\:w-10{
    width: 2.5rem;
  }

  .xl\\:w-11{
    width: 2.75rem;
  }

  .xl\\:w-12{
    width: 3rem;
  }

  .xl\\:w-14{
    width: 3.5rem;
  }

  .xl\\:w-15{
    width: 3.75rem;
  }

  .xl\\:w-16{
    width: 4rem;
  }

  .xl\\:w-18{
    width: 4.5rem;
  }

  .xl\\:w-20{
    width: 5rem;
  }

  .xl\\:w-22{
    width: 5.5rem;
  }

  .xl\\:w-23{
    width: 5.75rem;
  }

  .xl\\:w-24{
    width: 6rem;
  }

  .xl\\:w-25{
    width: 6.25rem;
  }

  .xl\\:w-26{
    width: 6.5rem;
  }

  .xl\\:w-28{
    width: 7rem;
  }

  .xl\\:w-30{
    width: 7.5rem;
  }

  .xl\\:w-32{
    width: 8rem;
  }

  .xl\\:w-34{
    width: 8.5rem;
  }

  .xl\\:w-40{
    width: 10rem;
  }

  .xl\\:w-42{
    width: 10.5rem;
  }

  .xl\\:w-44{
    width: 11rem;
  }

  .xl\\:w-48{
    width: 12rem;
  }

  .xl\\:w-52{
    width: 13rem;
  }

  .xl\\:w-54{
    width: 13.5rem;
  }

  .xl\\:w-56{
    width: 14rem;
  }

  .xl\\:w-60{
    width: 15rem;
  }

  .xl\\:w-64{
    width: 16rem;
  }

  .xl\\:w-68{
    width: 17rem;
  }

  .xl\\:w-72{
    width: 18rem;
  }

  .xl\\:w-74{
    width: 18.5rem;
  }

  .xl\\:w-76{
    width: 19rem;
  }

  .xl\\:w-78{
    width: 19.5rem;
  }

  .xl\\:w-80{
    width: 20rem;
  }

  .xl\\:w-82{
    width: 20.5rem;
  }

  .xl\\:w-84{
    width: 21rem;
  }

  .xl\\:w-88{
    width: 22rem;
  }

  .xl\\:w-92{
    width: 23rem;
  }

  .xl\\:w-96{
    width: 24rem;
  }

  .xl\\:w-98{
    width: 24.5rem;
  }

  .xl\\:w-100{
    width: 25rem;
  }

  .xl\\:w-104{
    width: 26rem;
  }

  .xl\\:w-112{
    width: 28rem;
  }

  .xl\\:w-124{
    width: 31rem;
  }

  .xl\\:w-128{
    width: 32rem;
  }

  .xl\\:w-140{
    width: 35rem;
  }

  .xl\\:w-152{
    width: 38rem;
  }

  .xl\\:w-160{
    width: 40rem;
  }

  .xl\\:w-162{
    width: 41rem;
  }

  .xl\\:w-192{
    width: 48rem;
  }

  .xl\\:w-208{
    width: 52rem;
  }

  .xl\\:w-224{
    width: 56rem;
  }

  .xl\\:w-256{
    width: 64rem;
  }

  .xl\\:w-auto{
    width: auto;
  }

  .xl\\:w-px{
    width: 1px;
  }

  .xl\\:w-1\\/2{
    width: 50%;
  }

  .xl\\:w-1\\/3{
    width: 33.33333%;
  }

  .xl\\:w-2\\/3{
    width: 66.66667%;
  }

  .xl\\:w-1\\/4{
    width: 25%;
  }

  .xl\\:w-3\\/4{
    width: 75%;
  }

  .xl\\:w-1\\/5{
    width: 20%;
  }

  .xl\\:w-2\\/5{
    width: 40%;
  }

  .xl\\:w-3\\/5{
    width: 60%;
  }

  .xl\\:w-4\\/5{
    width: 80%;
  }

  .xl\\:w-1\\/6{
    width: 16.66667%;
  }

  .xl\\:w-5\\/6{
    width: 83.33333%;
  }

  .xl\\:w-1\\/7{
    width: 14.285714285%;
  }

  .xl\\:w-2\\/7{
    width: 28.571428571%;
  }

  .xl\\:w-3\\/7{
    width: 42.85714285%;
  }

  .xl\\:w-4\\/7{
    width: 57.14285714%;
  }

  .xl\\:w-1\\/9{
    width: 11.1111%;
  }

  .xl\\:w-9\\/10{
    width: 90%;
  }

  .xl\\:w-full{
    width: 100%;
  }

  .xl\\:w-screen{
    width: 100vw;
  }

  .xl\\:w-max{
    width: max-content;
  }

  .xl\\:z-0{
    z-index: 0;
  }

  .xl\\:z-10{
    z-index: 10;
  }

  .xl\\:z-20{
    z-index: 20;
  }

  .xl\\:z-30{
    z-index: 30;
  }

  .xl\\:z-40{
    z-index: 40;
  }

  .xl\\:z-50{
    z-index: 50;
  }

  .xl\\:z-auto{
    z-index: auto;
  }

  .xl\\:gap-0{
    grid-gap: 0;
    gap: 0;
  }

  .xl\\:gap-1{
    grid-gap: 0.25rem;
    gap: 0.25rem;
  }

  .xl\\:gap-2{
    grid-gap: 0.5rem;
    gap: 0.5rem;
  }

  .xl\\:gap-3{
    grid-gap: 0.75rem;
    gap: 0.75rem;
  }

  .xl\\:gap-4{
    grid-gap: 1rem;
    gap: 1rem;
  }

  .xl\\:gap-5{
    grid-gap: 1.25rem;
    gap: 1.25rem;
  }

  .xl\\:gap-6{
    grid-gap: 1.5rem;
    gap: 1.5rem;
  }

  .xl\\:gap-7{
    grid-gap: 1.75rem;
    gap: 1.75rem;
  }

  .xl\\:gap-8{
    grid-gap: 2rem;
    gap: 2rem;
  }

  .xl\\:gap-9{
    grid-gap: 2.25rem;
    gap: 2.25rem;
  }

  .xl\\:gap-10{
    grid-gap: 2.5rem;
    gap: 2.5rem;
  }

  .xl\\:gap-11{
    grid-gap: 2.75rem;
    gap: 2.75rem;
  }

  .xl\\:gap-12{
    grid-gap: 3rem;
    gap: 3rem;
  }

  .xl\\:gap-14{
    grid-gap: 3.5rem;
    gap: 3.5rem;
  }

  .xl\\:gap-15{
    grid-gap: 3.75rem;
    gap: 3.75rem;
  }

  .xl\\:gap-16{
    grid-gap: 4rem;
    gap: 4rem;
  }

  .xl\\:gap-18{
    grid-gap: 4.5rem;
    gap: 4.5rem;
  }

  .xl\\:gap-20{
    grid-gap: 5rem;
    gap: 5rem;
  }

  .xl\\:gap-22{
    grid-gap: 5.5rem;
    gap: 5.5rem;
  }

  .xl\\:gap-23{
    grid-gap: 5.75rem;
    gap: 5.75rem;
  }

  .xl\\:gap-24{
    grid-gap: 6rem;
    gap: 6rem;
  }

  .xl\\:gap-25{
    grid-gap: 6.25rem;
    gap: 6.25rem;
  }

  .xl\\:gap-26{
    grid-gap: 6.5rem;
    gap: 6.5rem;
  }

  .xl\\:gap-28{
    grid-gap: 7rem;
    gap: 7rem;
  }

  .xl\\:gap-30{
    grid-gap: 7.5rem;
    gap: 7.5rem;
  }

  .xl\\:gap-32{
    grid-gap: 8rem;
    gap: 8rem;
  }

  .xl\\:gap-34{
    grid-gap: 8.5rem;
    gap: 8.5rem;
  }

  .xl\\:gap-40{
    grid-gap: 10rem;
    gap: 10rem;
  }

  .xl\\:gap-42{
    grid-gap: 10.5rem;
    gap: 10.5rem;
  }

  .xl\\:gap-44{
    grid-gap: 11rem;
    gap: 11rem;
  }

  .xl\\:gap-48{
    grid-gap: 12rem;
    gap: 12rem;
  }

  .xl\\:gap-52{
    grid-gap: 13rem;
    gap: 13rem;
  }

  .xl\\:gap-54{
    grid-gap: 13.5rem;
    gap: 13.5rem;
  }

  .xl\\:gap-56{
    grid-gap: 14rem;
    gap: 14rem;
  }

  .xl\\:gap-60{
    grid-gap: 15rem;
    gap: 15rem;
  }

  .xl\\:gap-64{
    grid-gap: 16rem;
    gap: 16rem;
  }

  .xl\\:gap-68{
    grid-gap: 17rem;
    gap: 17rem;
  }

  .xl\\:gap-72{
    grid-gap: 18rem;
    gap: 18rem;
  }

  .xl\\:gap-74{
    grid-gap: 18.5rem;
    gap: 18.5rem;
  }

  .xl\\:gap-76{
    grid-gap: 19rem;
    gap: 19rem;
  }

  .xl\\:gap-78{
    grid-gap: 19.5rem;
    gap: 19.5rem;
  }

  .xl\\:gap-80{
    grid-gap: 20rem;
    gap: 20rem;
  }

  .xl\\:gap-82{
    grid-gap: 20.5rem;
    gap: 20.5rem;
  }

  .xl\\:gap-84{
    grid-gap: 21rem;
    gap: 21rem;
  }

  .xl\\:gap-88{
    grid-gap: 22rem;
    gap: 22rem;
  }

  .xl\\:gap-92{
    grid-gap: 23rem;
    gap: 23rem;
  }

  .xl\\:gap-96{
    grid-gap: 24rem;
    gap: 24rem;
  }

  .xl\\:gap-98{
    grid-gap: 24.5rem;
    gap: 24.5rem;
  }

  .xl\\:gap-100{
    grid-gap: 25rem;
    gap: 25rem;
  }

  .xl\\:gap-104{
    grid-gap: 26rem;
    gap: 26rem;
  }

  .xl\\:gap-112{
    grid-gap: 28rem;
    gap: 28rem;
  }

  .xl\\:gap-124{
    grid-gap: 31rem;
    gap: 31rem;
  }

  .xl\\:gap-128{
    grid-gap: 32rem;
    gap: 32rem;
  }

  .xl\\:gap-140{
    grid-gap: 35rem;
    gap: 35rem;
  }

  .xl\\:gap-152{
    grid-gap: 38rem;
    gap: 38rem;
  }

  .xl\\:gap-160{
    grid-gap: 40rem;
    gap: 40rem;
  }

  .xl\\:gap-162{
    grid-gap: 41rem;
    gap: 41rem;
  }

  .xl\\:gap-192{
    grid-gap: 48rem;
    gap: 48rem;
  }

  .xl\\:gap-208{
    grid-gap: 52rem;
    gap: 52rem;
  }

  .xl\\:gap-224{
    grid-gap: 56rem;
    gap: 56rem;
  }

  .xl\\:gap-256{
    grid-gap: 64rem;
    gap: 64rem;
  }

  .xl\\:gap-px{
    grid-gap: 1px;
    gap: 1px;
  }

  .xl\\:gap-x-0{
    grid-column-gap: 0;
    -moz-column-gap: 0;
         column-gap: 0;
  }

  .xl\\:gap-x-1{
    grid-column-gap: 0.25rem;
    -moz-column-gap: 0.25rem;
         column-gap: 0.25rem;
  }

  .xl\\:gap-x-2{
    grid-column-gap: 0.5rem;
    -moz-column-gap: 0.5rem;
         column-gap: 0.5rem;
  }

  .xl\\:gap-x-3{
    grid-column-gap: 0.75rem;
    -moz-column-gap: 0.75rem;
         column-gap: 0.75rem;
  }

  .xl\\:gap-x-4{
    grid-column-gap: 1rem;
    -moz-column-gap: 1rem;
         column-gap: 1rem;
  }

  .xl\\:gap-x-5{
    grid-column-gap: 1.25rem;
    -moz-column-gap: 1.25rem;
         column-gap: 1.25rem;
  }

  .xl\\:gap-x-6{
    grid-column-gap: 1.5rem;
    -moz-column-gap: 1.5rem;
         column-gap: 1.5rem;
  }

  .xl\\:gap-x-7{
    grid-column-gap: 1.75rem;
    -moz-column-gap: 1.75rem;
         column-gap: 1.75rem;
  }

  .xl\\:gap-x-8{
    grid-column-gap: 2rem;
    -moz-column-gap: 2rem;
         column-gap: 2rem;
  }

  .xl\\:gap-x-9{
    grid-column-gap: 2.25rem;
    -moz-column-gap: 2.25rem;
         column-gap: 2.25rem;
  }

  .xl\\:gap-x-10{
    grid-column-gap: 2.5rem;
    -moz-column-gap: 2.5rem;
         column-gap: 2.5rem;
  }

  .xl\\:gap-x-11{
    grid-column-gap: 2.75rem;
    -moz-column-gap: 2.75rem;
         column-gap: 2.75rem;
  }

  .xl\\:gap-x-12{
    grid-column-gap: 3rem;
    -moz-column-gap: 3rem;
         column-gap: 3rem;
  }

  .xl\\:gap-x-14{
    grid-column-gap: 3.5rem;
    -moz-column-gap: 3.5rem;
         column-gap: 3.5rem;
  }

  .xl\\:gap-x-15{
    grid-column-gap: 3.75rem;
    -moz-column-gap: 3.75rem;
         column-gap: 3.75rem;
  }

  .xl\\:gap-x-16{
    grid-column-gap: 4rem;
    -moz-column-gap: 4rem;
         column-gap: 4rem;
  }

  .xl\\:gap-x-18{
    grid-column-gap: 4.5rem;
    -moz-column-gap: 4.5rem;
         column-gap: 4.5rem;
  }

  .xl\\:gap-x-20{
    grid-column-gap: 5rem;
    -moz-column-gap: 5rem;
         column-gap: 5rem;
  }

  .xl\\:gap-x-22{
    grid-column-gap: 5.5rem;
    -moz-column-gap: 5.5rem;
         column-gap: 5.5rem;
  }

  .xl\\:gap-x-23{
    grid-column-gap: 5.75rem;
    -moz-column-gap: 5.75rem;
         column-gap: 5.75rem;
  }

  .xl\\:gap-x-24{
    grid-column-gap: 6rem;
    -moz-column-gap: 6rem;
         column-gap: 6rem;
  }

  .xl\\:gap-x-25{
    grid-column-gap: 6.25rem;
    -moz-column-gap: 6.25rem;
         column-gap: 6.25rem;
  }

  .xl\\:gap-x-26{
    grid-column-gap: 6.5rem;
    -moz-column-gap: 6.5rem;
         column-gap: 6.5rem;
  }

  .xl\\:gap-x-28{
    grid-column-gap: 7rem;
    -moz-column-gap: 7rem;
         column-gap: 7rem;
  }

  .xl\\:gap-x-30{
    grid-column-gap: 7.5rem;
    -moz-column-gap: 7.5rem;
         column-gap: 7.5rem;
  }

  .xl\\:gap-x-32{
    grid-column-gap: 8rem;
    -moz-column-gap: 8rem;
         column-gap: 8rem;
  }

  .xl\\:gap-x-34{
    grid-column-gap: 8.5rem;
    -moz-column-gap: 8.5rem;
         column-gap: 8.5rem;
  }

  .xl\\:gap-x-40{
    grid-column-gap: 10rem;
    -moz-column-gap: 10rem;
         column-gap: 10rem;
  }

  .xl\\:gap-x-42{
    grid-column-gap: 10.5rem;
    -moz-column-gap: 10.5rem;
         column-gap: 10.5rem;
  }

  .xl\\:gap-x-44{
    grid-column-gap: 11rem;
    -moz-column-gap: 11rem;
         column-gap: 11rem;
  }

  .xl\\:gap-x-48{
    grid-column-gap: 12rem;
    -moz-column-gap: 12rem;
         column-gap: 12rem;
  }

  .xl\\:gap-x-52{
    grid-column-gap: 13rem;
    -moz-column-gap: 13rem;
         column-gap: 13rem;
  }

  .xl\\:gap-x-54{
    grid-column-gap: 13.5rem;
    -moz-column-gap: 13.5rem;
         column-gap: 13.5rem;
  }

  .xl\\:gap-x-56{
    grid-column-gap: 14rem;
    -moz-column-gap: 14rem;
         column-gap: 14rem;
  }

  .xl\\:gap-x-60{
    grid-column-gap: 15rem;
    -moz-column-gap: 15rem;
         column-gap: 15rem;
  }

  .xl\\:gap-x-64{
    grid-column-gap: 16rem;
    -moz-column-gap: 16rem;
         column-gap: 16rem;
  }

  .xl\\:gap-x-68{
    grid-column-gap: 17rem;
    -moz-column-gap: 17rem;
         column-gap: 17rem;
  }

  .xl\\:gap-x-72{
    grid-column-gap: 18rem;
    -moz-column-gap: 18rem;
         column-gap: 18rem;
  }

  .xl\\:gap-x-74{
    grid-column-gap: 18.5rem;
    -moz-column-gap: 18.5rem;
         column-gap: 18.5rem;
  }

  .xl\\:gap-x-76{
    grid-column-gap: 19rem;
    -moz-column-gap: 19rem;
         column-gap: 19rem;
  }

  .xl\\:gap-x-78{
    grid-column-gap: 19.5rem;
    -moz-column-gap: 19.5rem;
         column-gap: 19.5rem;
  }

  .xl\\:gap-x-80{
    grid-column-gap: 20rem;
    -moz-column-gap: 20rem;
         column-gap: 20rem;
  }

  .xl\\:gap-x-82{
    grid-column-gap: 20.5rem;
    -moz-column-gap: 20.5rem;
         column-gap: 20.5rem;
  }

  .xl\\:gap-x-84{
    grid-column-gap: 21rem;
    -moz-column-gap: 21rem;
         column-gap: 21rem;
  }

  .xl\\:gap-x-88{
    grid-column-gap: 22rem;
    -moz-column-gap: 22rem;
         column-gap: 22rem;
  }

  .xl\\:gap-x-92{
    grid-column-gap: 23rem;
    -moz-column-gap: 23rem;
         column-gap: 23rem;
  }

  .xl\\:gap-x-96{
    grid-column-gap: 24rem;
    -moz-column-gap: 24rem;
         column-gap: 24rem;
  }

  .xl\\:gap-x-98{
    grid-column-gap: 24.5rem;
    -moz-column-gap: 24.5rem;
         column-gap: 24.5rem;
  }

  .xl\\:gap-x-100{
    grid-column-gap: 25rem;
    -moz-column-gap: 25rem;
         column-gap: 25rem;
  }

  .xl\\:gap-x-104{
    grid-column-gap: 26rem;
    -moz-column-gap: 26rem;
         column-gap: 26rem;
  }

  .xl\\:gap-x-112{
    grid-column-gap: 28rem;
    -moz-column-gap: 28rem;
         column-gap: 28rem;
  }

  .xl\\:gap-x-124{
    grid-column-gap: 31rem;
    -moz-column-gap: 31rem;
         column-gap: 31rem;
  }

  .xl\\:gap-x-128{
    grid-column-gap: 32rem;
    -moz-column-gap: 32rem;
         column-gap: 32rem;
  }

  .xl\\:gap-x-140{
    grid-column-gap: 35rem;
    -moz-column-gap: 35rem;
         column-gap: 35rem;
  }

  .xl\\:gap-x-152{
    grid-column-gap: 38rem;
    -moz-column-gap: 38rem;
         column-gap: 38rem;
  }

  .xl\\:gap-x-160{
    grid-column-gap: 40rem;
    -moz-column-gap: 40rem;
         column-gap: 40rem;
  }

  .xl\\:gap-x-162{
    grid-column-gap: 41rem;
    -moz-column-gap: 41rem;
         column-gap: 41rem;
  }

  .xl\\:gap-x-192{
    grid-column-gap: 48rem;
    -moz-column-gap: 48rem;
         column-gap: 48rem;
  }

  .xl\\:gap-x-208{
    grid-column-gap: 52rem;
    -moz-column-gap: 52rem;
         column-gap: 52rem;
  }

  .xl\\:gap-x-224{
    grid-column-gap: 56rem;
    -moz-column-gap: 56rem;
         column-gap: 56rem;
  }

  .xl\\:gap-x-256{
    grid-column-gap: 64rem;
    -moz-column-gap: 64rem;
         column-gap: 64rem;
  }

  .xl\\:gap-x-px{
    grid-column-gap: 1px;
    -moz-column-gap: 1px;
         column-gap: 1px;
  }

  .xl\\:gap-y-0{
    grid-row-gap: 0;
    row-gap: 0;
  }

  .xl\\:gap-y-1{
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }

  .xl\\:gap-y-2{
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }

  .xl\\:gap-y-3{
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }

  .xl\\:gap-y-4{
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }

  .xl\\:gap-y-5{
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }

  .xl\\:gap-y-6{
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }

  .xl\\:gap-y-7{
    grid-row-gap: 1.75rem;
    row-gap: 1.75rem;
  }

  .xl\\:gap-y-8{
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }

  .xl\\:gap-y-9{
    grid-row-gap: 2.25rem;
    row-gap: 2.25rem;
  }

  .xl\\:gap-y-10{
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }

  .xl\\:gap-y-11{
    grid-row-gap: 2.75rem;
    row-gap: 2.75rem;
  }

  .xl\\:gap-y-12{
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }

  .xl\\:gap-y-14{
    grid-row-gap: 3.5rem;
    row-gap: 3.5rem;
  }

  .xl\\:gap-y-15{
    grid-row-gap: 3.75rem;
    row-gap: 3.75rem;
  }

  .xl\\:gap-y-16{
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }

  .xl\\:gap-y-18{
    grid-row-gap: 4.5rem;
    row-gap: 4.5rem;
  }

  .xl\\:gap-y-20{
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }

  .xl\\:gap-y-22{
    grid-row-gap: 5.5rem;
    row-gap: 5.5rem;
  }

  .xl\\:gap-y-23{
    grid-row-gap: 5.75rem;
    row-gap: 5.75rem;
  }

  .xl\\:gap-y-24{
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }

  .xl\\:gap-y-25{
    grid-row-gap: 6.25rem;
    row-gap: 6.25rem;
  }

  .xl\\:gap-y-26{
    grid-row-gap: 6.5rem;
    row-gap: 6.5rem;
  }

  .xl\\:gap-y-28{
    grid-row-gap: 7rem;
    row-gap: 7rem;
  }

  .xl\\:gap-y-30{
    grid-row-gap: 7.5rem;
    row-gap: 7.5rem;
  }

  .xl\\:gap-y-32{
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }

  .xl\\:gap-y-34{
    grid-row-gap: 8.5rem;
    row-gap: 8.5rem;
  }

  .xl\\:gap-y-40{
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }

  .xl\\:gap-y-42{
    grid-row-gap: 10.5rem;
    row-gap: 10.5rem;
  }

  .xl\\:gap-y-44{
    grid-row-gap: 11rem;
    row-gap: 11rem;
  }

  .xl\\:gap-y-48{
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }

  .xl\\:gap-y-52{
    grid-row-gap: 13rem;
    row-gap: 13rem;
  }

  .xl\\:gap-y-54{
    grid-row-gap: 13.5rem;
    row-gap: 13.5rem;
  }

  .xl\\:gap-y-56{
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }

  .xl\\:gap-y-60{
    grid-row-gap: 15rem;
    row-gap: 15rem;
  }

  .xl\\:gap-y-64{
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }

  .xl\\:gap-y-68{
    grid-row-gap: 17rem;
    row-gap: 17rem;
  }

  .xl\\:gap-y-72{
    grid-row-gap: 18rem;
    row-gap: 18rem;
  }

  .xl\\:gap-y-74{
    grid-row-gap: 18.5rem;
    row-gap: 18.5rem;
  }

  .xl\\:gap-y-76{
    grid-row-gap: 19rem;
    row-gap: 19rem;
  }

  .xl\\:gap-y-78{
    grid-row-gap: 19.5rem;
    row-gap: 19.5rem;
  }

  .xl\\:gap-y-80{
    grid-row-gap: 20rem;
    row-gap: 20rem;
  }

  .xl\\:gap-y-82{
    grid-row-gap: 20.5rem;
    row-gap: 20.5rem;
  }

  .xl\\:gap-y-84{
    grid-row-gap: 21rem;
    row-gap: 21rem;
  }

  .xl\\:gap-y-88{
    grid-row-gap: 22rem;
    row-gap: 22rem;
  }

  .xl\\:gap-y-92{
    grid-row-gap: 23rem;
    row-gap: 23rem;
  }

  .xl\\:gap-y-96{
    grid-row-gap: 24rem;
    row-gap: 24rem;
  }

  .xl\\:gap-y-98{
    grid-row-gap: 24.5rem;
    row-gap: 24.5rem;
  }

  .xl\\:gap-y-100{
    grid-row-gap: 25rem;
    row-gap: 25rem;
  }

  .xl\\:gap-y-104{
    grid-row-gap: 26rem;
    row-gap: 26rem;
  }

  .xl\\:gap-y-112{
    grid-row-gap: 28rem;
    row-gap: 28rem;
  }

  .xl\\:gap-y-124{
    grid-row-gap: 31rem;
    row-gap: 31rem;
  }

  .xl\\:gap-y-128{
    grid-row-gap: 32rem;
    row-gap: 32rem;
  }

  .xl\\:gap-y-140{
    grid-row-gap: 35rem;
    row-gap: 35rem;
  }

  .xl\\:gap-y-152{
    grid-row-gap: 38rem;
    row-gap: 38rem;
  }

  .xl\\:gap-y-160{
    grid-row-gap: 40rem;
    row-gap: 40rem;
  }

  .xl\\:gap-y-162{
    grid-row-gap: 41rem;
    row-gap: 41rem;
  }

  .xl\\:gap-y-192{
    grid-row-gap: 48rem;
    row-gap: 48rem;
  }

  .xl\\:gap-y-208{
    grid-row-gap: 52rem;
    row-gap: 52rem;
  }

  .xl\\:gap-y-224{
    grid-row-gap: 56rem;
    row-gap: 56rem;
  }

  .xl\\:gap-y-256{
    grid-row-gap: 64rem;
    row-gap: 64rem;
  }

  .xl\\:gap-y-px{
    grid-row-gap: 1px;
    row-gap: 1px;
  }

  .xl\\:grid-flow-row{
    grid-auto-flow: row;
  }

  .xl\\:grid-flow-col{
    grid-auto-flow: column;
  }

  .xl\\:grid-flow-row-dense{
    grid-auto-flow: row dense;
  }

  .xl\\:grid-flow-col-dense{
    grid-auto-flow: column dense;
  }

  .xl\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .xl\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .xl\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .xl\\:grid-cols-9{
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .xl\\:grid-cols-10{
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .xl\\:grid-cols-11{
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .xl\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .xl\\:grid-cols-14{
    grid-template-columns: repeat(14, minmax(0, 1fr));
  }

  .xl\\:grid-cols-none{
    grid-template-columns: none;
  }

  .xl\\:auto-cols-auto{
    grid-auto-columns: auto;
  }

  .xl\\:auto-cols-min{
    grid-auto-columns: min-content;
  }

  .xl\\:auto-cols-max{
    grid-auto-columns: max-content;
  }

  .xl\\:auto-cols-fr{
    grid-auto-columns: minmax(0, 1fr);
  }

  .xl\\:col-auto{
    grid-column: auto;
  }

  .xl\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .xl\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .xl\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .xl\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .xl\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .xl\\:col-span-6{
    grid-column: span 6 / span 6;
  }

  .xl\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .xl\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .xl\\:col-span-9{
    grid-column: span 9 / span 9;
  }

  .xl\\:col-span-10{
    grid-column: span 10 / span 10;
  }

  .xl\\:col-span-11{
    grid-column: span 11 / span 11;
  }

  .xl\\:col-span-12{
    grid-column: span 12 / span 12;
  }

  .xl\\:col-span-full{
    grid-column: 1 / -1;
  }

  .xl\\:col-start-1{
    grid-column-start: 1;
  }

  .xl\\:col-start-2{
    grid-column-start: 2;
  }

  .xl\\:col-start-3{
    grid-column-start: 3;
  }

  .xl\\:col-start-4{
    grid-column-start: 4;
  }

  .xl\\:col-start-5{
    grid-column-start: 5;
  }

  .xl\\:col-start-6{
    grid-column-start: 6;
  }

  .xl\\:col-start-7{
    grid-column-start: 7;
  }

  .xl\\:col-start-8{
    grid-column-start: 8;
  }

  .xl\\:col-start-9{
    grid-column-start: 9;
  }

  .xl\\:col-start-10{
    grid-column-start: 10;
  }

  .xl\\:col-start-11{
    grid-column-start: 11;
  }

  .xl\\:col-start-12{
    grid-column-start: 12;
  }

  .xl\\:col-start-13{
    grid-column-start: 13;
  }

  .xl\\:col-start-14{
    grid-column-start: 14;
  }

  .xl\\:col-start-15{
    grid-column-start: 15;
  }

  .xl\\:col-start-auto{
    grid-column-start: auto;
  }

  .xl\\:col-end-1{
    grid-column-end: 1;
  }

  .xl\\:col-end-2{
    grid-column-end: 2;
  }

  .xl\\:col-end-3{
    grid-column-end: 3;
  }

  .xl\\:col-end-4{
    grid-column-end: 4;
  }

  .xl\\:col-end-5{
    grid-column-end: 5;
  }

  .xl\\:col-end-6{
    grid-column-end: 6;
  }

  .xl\\:col-end-7{
    grid-column-end: 7;
  }

  .xl\\:col-end-8{
    grid-column-end: 8;
  }

  .xl\\:col-end-9{
    grid-column-end: 9;
  }

  .xl\\:col-end-10{
    grid-column-end: 10;
  }

  .xl\\:col-end-11{
    grid-column-end: 11;
  }

  .xl\\:col-end-12{
    grid-column-end: 12;
  }

  .xl\\:col-end-13{
    grid-column-end: 13;
  }

  .xl\\:col-end-14{
    grid-column-end: 14;
  }

  .xl\\:col-end-15{
    grid-column-end: 15;
  }

  .xl\\:col-end-auto{
    grid-column-end: auto;
  }

  .xl\\:grid-rows-1{
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .xl\\:grid-rows-2{
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-rows-3{
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-rows-4{
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-rows-5{
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }

  .xl\\:grid-rows-6{
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }

  .xl\\:grid-rows-none{
    grid-template-rows: none;
  }

  .xl\\:auto-rows-auto{
    grid-auto-rows: auto;
  }

  .xl\\:auto-rows-min{
    grid-auto-rows: min-content;
  }

  .xl\\:auto-rows-max{
    grid-auto-rows: max-content;
  }

  .xl\\:auto-rows-fr{
    grid-auto-rows: minmax(0, 1fr);
  }

  .xl\\:row-auto{
    grid-row: auto;
  }

  .xl\\:row-span-1{
    grid-row: span 1 / span 1;
  }

  .xl\\:row-span-2{
    grid-row: span 2 / span 2;
  }

  .xl\\:row-span-3{
    grid-row: span 3 / span 3;
  }

  .xl\\:row-span-4{
    grid-row: span 4 / span 4;
  }

  .xl\\:row-span-5{
    grid-row: span 5 / span 5;
  }

  .xl\\:row-span-6{
    grid-row: span 6 / span 6;
  }

  .xl\\:row-span-full{
    grid-row: 1 / -1;
  }

  .xl\\:row-start-1{
    grid-row-start: 1;
  }

  .xl\\:row-start-2{
    grid-row-start: 2;
  }

  .xl\\:row-start-3{
    grid-row-start: 3;
  }

  .xl\\:row-start-4{
    grid-row-start: 4;
  }

  .xl\\:row-start-5{
    grid-row-start: 5;
  }

  .xl\\:row-start-6{
    grid-row-start: 6;
  }

  .xl\\:row-start-7{
    grid-row-start: 7;
  }

  .xl\\:row-start-auto{
    grid-row-start: auto;
  }

  .xl\\:row-end-1{
    grid-row-end: 1;
  }

  .xl\\:row-end-2{
    grid-row-end: 2;
  }

  .xl\\:row-end-3{
    grid-row-end: 3;
  }

  .xl\\:row-end-4{
    grid-row-end: 4;
  }

  .xl\\:row-end-5{
    grid-row-end: 5;
  }

  .xl\\:row-end-6{
    grid-row-end: 6;
  }

  .xl\\:row-end-7{
    grid-row-end: 7;
  }

  .xl\\:row-end-auto{
    grid-row-end: auto;
  }

  .xl\\:transform{
    --transform-translate-x: 0;
    --transform-translate-y: 0;
    --transform-rotate: 0;
    --transform-skew-x: 0;
    --transform-skew-y: 0;
    --transform-scale-x: 1;
    --transform-scale-y: 1;
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
  }

  .xl\\:transform-none{
    transform: none;
  }

  .xl\\:origin-center{
    transform-origin: center;
  }

  .xl\\:origin-top{
    transform-origin: top;
  }

  .xl\\:origin-top-right{
    transform-origin: top right;
  }

  .xl\\:origin-right{
    transform-origin: right;
  }

  .xl\\:origin-bottom-right{
    transform-origin: bottom right;
  }

  .xl\\:origin-bottom{
    transform-origin: bottom;
  }

  .xl\\:origin-bottom-left{
    transform-origin: bottom left;
  }

  .xl\\:origin-left{
    transform-origin: left;
  }

  .xl\\:origin-top-left{
    transform-origin: top left;
  }

  .xl\\:scale-0{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .xl\\:scale-50{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .xl\\:scale-75{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .xl\\:scale-90{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .xl\\:scale-95{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .xl\\:scale-100{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .xl\\:scale-105{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .xl\\:scale-110{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .xl\\:scale-125{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .xl\\:scale-150{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .xl\\:scale-x-0{
    --transform-scale-x: 0;
  }

  .xl\\:scale-x-50{
    --transform-scale-x: .5;
  }

  .xl\\:scale-x-75{
    --transform-scale-x: .75;
  }

  .xl\\:scale-x-90{
    --transform-scale-x: .9;
  }

  .xl\\:scale-x-95{
    --transform-scale-x: .95;
  }

  .xl\\:scale-x-100{
    --transform-scale-x: 1;
  }

  .xl\\:scale-x-105{
    --transform-scale-x: 1.05;
  }

  .xl\\:scale-x-110{
    --transform-scale-x: 1.1;
  }

  .xl\\:scale-x-125{
    --transform-scale-x: 1.25;
  }

  .xl\\:scale-x-150{
    --transform-scale-x: 1.5;
  }

  .xl\\:scale-y-0{
    --transform-scale-y: 0;
  }

  .xl\\:scale-y-50{
    --transform-scale-y: .5;
  }

  .xl\\:scale-y-75{
    --transform-scale-y: .75;
  }

  .xl\\:scale-y-90{
    --transform-scale-y: .9;
  }

  .xl\\:scale-y-95{
    --transform-scale-y: .95;
  }

  .xl\\:scale-y-100{
    --transform-scale-y: 1;
  }

  .xl\\:scale-y-105{
    --transform-scale-y: 1.05;
  }

  .xl\\:scale-y-110{
    --transform-scale-y: 1.1;
  }

  .xl\\:scale-y-125{
    --transform-scale-y: 1.25;
  }

  .xl\\:scale-y-150{
    --transform-scale-y: 1.5;
  }

  .xl\\:hover\\:scale-0:hover{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .xl\\:hover\\:scale-50:hover{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .xl\\:hover\\:scale-75:hover{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .xl\\:hover\\:scale-90:hover{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .xl\\:hover\\:scale-95:hover{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .xl\\:hover\\:scale-100:hover{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .xl\\:hover\\:scale-105:hover{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .xl\\:hover\\:scale-110:hover{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .xl\\:hover\\:scale-125:hover{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .xl\\:hover\\:scale-150:hover{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .xl\\:hover\\:scale-x-0:hover{
    --transform-scale-x: 0;
  }

  .xl\\:hover\\:scale-x-50:hover{
    --transform-scale-x: .5;
  }

  .xl\\:hover\\:scale-x-75:hover{
    --transform-scale-x: .75;
  }

  .xl\\:hover\\:scale-x-90:hover{
    --transform-scale-x: .9;
  }

  .xl\\:hover\\:scale-x-95:hover{
    --transform-scale-x: .95;
  }

  .xl\\:hover\\:scale-x-100:hover{
    --transform-scale-x: 1;
  }

  .xl\\:hover\\:scale-x-105:hover{
    --transform-scale-x: 1.05;
  }

  .xl\\:hover\\:scale-x-110:hover{
    --transform-scale-x: 1.1;
  }

  .xl\\:hover\\:scale-x-125:hover{
    --transform-scale-x: 1.25;
  }

  .xl\\:hover\\:scale-x-150:hover{
    --transform-scale-x: 1.5;
  }

  .xl\\:hover\\:scale-y-0:hover{
    --transform-scale-y: 0;
  }

  .xl\\:hover\\:scale-y-50:hover{
    --transform-scale-y: .5;
  }

  .xl\\:hover\\:scale-y-75:hover{
    --transform-scale-y: .75;
  }

  .xl\\:hover\\:scale-y-90:hover{
    --transform-scale-y: .9;
  }

  .xl\\:hover\\:scale-y-95:hover{
    --transform-scale-y: .95;
  }

  .xl\\:hover\\:scale-y-100:hover{
    --transform-scale-y: 1;
  }

  .xl\\:hover\\:scale-y-105:hover{
    --transform-scale-y: 1.05;
  }

  .xl\\:hover\\:scale-y-110:hover{
    --transform-scale-y: 1.1;
  }

  .xl\\:hover\\:scale-y-125:hover{
    --transform-scale-y: 1.25;
  }

  .xl\\:hover\\:scale-y-150:hover{
    --transform-scale-y: 1.5;
  }

  .xl\\:focus\\:scale-0:focus{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .xl\\:focus\\:scale-50:focus{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .xl\\:focus\\:scale-75:focus{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .xl\\:focus\\:scale-90:focus{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .xl\\:focus\\:scale-95:focus{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .xl\\:focus\\:scale-100:focus{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .xl\\:focus\\:scale-105:focus{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .xl\\:focus\\:scale-110:focus{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .xl\\:focus\\:scale-125:focus{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .xl\\:focus\\:scale-150:focus{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .xl\\:focus\\:scale-x-0:focus{
    --transform-scale-x: 0;
  }

  .xl\\:focus\\:scale-x-50:focus{
    --transform-scale-x: .5;
  }

  .xl\\:focus\\:scale-x-75:focus{
    --transform-scale-x: .75;
  }

  .xl\\:focus\\:scale-x-90:focus{
    --transform-scale-x: .9;
  }

  .xl\\:focus\\:scale-x-95:focus{
    --transform-scale-x: .95;
  }

  .xl\\:focus\\:scale-x-100:focus{
    --transform-scale-x: 1;
  }

  .xl\\:focus\\:scale-x-105:focus{
    --transform-scale-x: 1.05;
  }

  .xl\\:focus\\:scale-x-110:focus{
    --transform-scale-x: 1.1;
  }

  .xl\\:focus\\:scale-x-125:focus{
    --transform-scale-x: 1.25;
  }

  .xl\\:focus\\:scale-x-150:focus{
    --transform-scale-x: 1.5;
  }

  .xl\\:focus\\:scale-y-0:focus{
    --transform-scale-y: 0;
  }

  .xl\\:focus\\:scale-y-50:focus{
    --transform-scale-y: .5;
  }

  .xl\\:focus\\:scale-y-75:focus{
    --transform-scale-y: .75;
  }

  .xl\\:focus\\:scale-y-90:focus{
    --transform-scale-y: .9;
  }

  .xl\\:focus\\:scale-y-95:focus{
    --transform-scale-y: .95;
  }

  .xl\\:focus\\:scale-y-100:focus{
    --transform-scale-y: 1;
  }

  .xl\\:focus\\:scale-y-105:focus{
    --transform-scale-y: 1.05;
  }

  .xl\\:focus\\:scale-y-110:focus{
    --transform-scale-y: 1.1;
  }

  .xl\\:focus\\:scale-y-125:focus{
    --transform-scale-y: 1.25;
  }

  .xl\\:focus\\:scale-y-150:focus{
    --transform-scale-y: 1.5;
  }

  .xl\\:rotate-0{
    --transform-rotate: 0;
  }

  .xl\\:rotate-1{
    --transform-rotate: 1deg;
  }

  .xl\\:rotate-2{
    --transform-rotate: 2deg;
  }

  .xl\\:rotate-3{
    --transform-rotate: 3deg;
  }

  .xl\\:rotate-6{
    --transform-rotate: 6deg;
  }

  .xl\\:rotate-12{
    --transform-rotate: 12deg;
  }

  .xl\\:rotate-45{
    --transform-rotate: 45deg;
  }

  .xl\\:rotate-90{
    --transform-rotate: 90deg;
  }

  .xl\\:rotate-180{
    --transform-rotate: 180deg;
  }

  .xl\\:-rotate-180{
    --transform-rotate: -180deg;
  }

  .xl\\:-rotate-90{
    --transform-rotate: -90deg;
  }

  .xl\\:-rotate-45{
    --transform-rotate: -45deg;
  }

  .xl\\:-rotate-12{
    --transform-rotate: -12deg;
  }

  .xl\\:-rotate-6{
    --transform-rotate: -6deg;
  }

  .xl\\:-rotate-3{
    --transform-rotate: -3deg;
  }

  .xl\\:-rotate-2{
    --transform-rotate: -2deg;
  }

  .xl\\:-rotate-1{
    --transform-rotate: -1deg;
  }

  .xl\\:hover\\:rotate-0:hover{
    --transform-rotate: 0;
  }

  .xl\\:hover\\:rotate-1:hover{
    --transform-rotate: 1deg;
  }

  .xl\\:hover\\:rotate-2:hover{
    --transform-rotate: 2deg;
  }

  .xl\\:hover\\:rotate-3:hover{
    --transform-rotate: 3deg;
  }

  .xl\\:hover\\:rotate-6:hover{
    --transform-rotate: 6deg;
  }

  .xl\\:hover\\:rotate-12:hover{
    --transform-rotate: 12deg;
  }

  .xl\\:hover\\:rotate-45:hover{
    --transform-rotate: 45deg;
  }

  .xl\\:hover\\:rotate-90:hover{
    --transform-rotate: 90deg;
  }

  .xl\\:hover\\:rotate-180:hover{
    --transform-rotate: 180deg;
  }

  .xl\\:hover\\:-rotate-180:hover{
    --transform-rotate: -180deg;
  }

  .xl\\:hover\\:-rotate-90:hover{
    --transform-rotate: -90deg;
  }

  .xl\\:hover\\:-rotate-45:hover{
    --transform-rotate: -45deg;
  }

  .xl\\:hover\\:-rotate-12:hover{
    --transform-rotate: -12deg;
  }

  .xl\\:hover\\:-rotate-6:hover{
    --transform-rotate: -6deg;
  }

  .xl\\:hover\\:-rotate-3:hover{
    --transform-rotate: -3deg;
  }

  .xl\\:hover\\:-rotate-2:hover{
    --transform-rotate: -2deg;
  }

  .xl\\:hover\\:-rotate-1:hover{
    --transform-rotate: -1deg;
  }

  .xl\\:focus\\:rotate-0:focus{
    --transform-rotate: 0;
  }

  .xl\\:focus\\:rotate-1:focus{
    --transform-rotate: 1deg;
  }

  .xl\\:focus\\:rotate-2:focus{
    --transform-rotate: 2deg;
  }

  .xl\\:focus\\:rotate-3:focus{
    --transform-rotate: 3deg;
  }

  .xl\\:focus\\:rotate-6:focus{
    --transform-rotate: 6deg;
  }

  .xl\\:focus\\:rotate-12:focus{
    --transform-rotate: 12deg;
  }

  .xl\\:focus\\:rotate-45:focus{
    --transform-rotate: 45deg;
  }

  .xl\\:focus\\:rotate-90:focus{
    --transform-rotate: 90deg;
  }

  .xl\\:focus\\:rotate-180:focus{
    --transform-rotate: 180deg;
  }

  .xl\\:focus\\:-rotate-180:focus{
    --transform-rotate: -180deg;
  }

  .xl\\:focus\\:-rotate-90:focus{
    --transform-rotate: -90deg;
  }

  .xl\\:focus\\:-rotate-45:focus{
    --transform-rotate: -45deg;
  }

  .xl\\:focus\\:-rotate-12:focus{
    --transform-rotate: -12deg;
  }

  .xl\\:focus\\:-rotate-6:focus{
    --transform-rotate: -6deg;
  }

  .xl\\:focus\\:-rotate-3:focus{
    --transform-rotate: -3deg;
  }

  .xl\\:focus\\:-rotate-2:focus{
    --transform-rotate: -2deg;
  }

  .xl\\:focus\\:-rotate-1:focus{
    --transform-rotate: -1deg;
  }

  .xl\\:translate-x-0{
    --transform-translate-x: 0;
  }

  .xl\\:translate-x-1{
    --transform-translate-x: 0.25rem;
  }

  .xl\\:translate-x-2{
    --transform-translate-x: 0.5rem;
  }

  .xl\\:translate-x-3{
    --transform-translate-x: 0.75rem;
  }

  .xl\\:translate-x-4{
    --transform-translate-x: 1rem;
  }

  .xl\\:translate-x-5{
    --transform-translate-x: 1.25rem;
  }

  .xl\\:translate-x-6{
    --transform-translate-x: 1.5rem;
  }

  .xl\\:translate-x-7{
    --transform-translate-x: 1.75rem;
  }

  .xl\\:translate-x-8{
    --transform-translate-x: 2rem;
  }

  .xl\\:translate-x-9{
    --transform-translate-x: 2.25rem;
  }

  .xl\\:translate-x-10{
    --transform-translate-x: 2.5rem;
  }

  .xl\\:translate-x-11{
    --transform-translate-x: 2.75rem;
  }

  .xl\\:translate-x-12{
    --transform-translate-x: 3rem;
  }

  .xl\\:translate-x-14{
    --transform-translate-x: 3.5rem;
  }

  .xl\\:translate-x-15{
    --transform-translate-x: 3.75rem;
  }

  .xl\\:translate-x-16{
    --transform-translate-x: 4rem;
  }

  .xl\\:translate-x-18{
    --transform-translate-x: 4.5rem;
  }

  .xl\\:translate-x-20{
    --transform-translate-x: 5rem;
  }

  .xl\\:translate-x-22{
    --transform-translate-x: 5.5rem;
  }

  .xl\\:translate-x-23{
    --transform-translate-x: 5.75rem;
  }

  .xl\\:translate-x-24{
    --transform-translate-x: 6rem;
  }

  .xl\\:translate-x-25{
    --transform-translate-x: 6.25rem;
  }

  .xl\\:translate-x-26{
    --transform-translate-x: 6.5rem;
  }

  .xl\\:translate-x-28{
    --transform-translate-x: 7rem;
  }

  .xl\\:translate-x-30{
    --transform-translate-x: 7.5rem;
  }

  .xl\\:translate-x-32{
    --transform-translate-x: 8rem;
  }

  .xl\\:translate-x-34{
    --transform-translate-x: 8.5rem;
  }

  .xl\\:translate-x-40{
    --transform-translate-x: 10rem;
  }

  .xl\\:translate-x-42{
    --transform-translate-x: 10.5rem;
  }

  .xl\\:translate-x-44{
    --transform-translate-x: 11rem;
  }

  .xl\\:translate-x-48{
    --transform-translate-x: 12rem;
  }

  .xl\\:translate-x-52{
    --transform-translate-x: 13rem;
  }

  .xl\\:translate-x-54{
    --transform-translate-x: 13.5rem;
  }

  .xl\\:translate-x-56{
    --transform-translate-x: 14rem;
  }

  .xl\\:translate-x-60{
    --transform-translate-x: 15rem;
  }

  .xl\\:translate-x-64{
    --transform-translate-x: 16rem;
  }

  .xl\\:translate-x-68{
    --transform-translate-x: 17rem;
  }

  .xl\\:translate-x-72{
    --transform-translate-x: 18rem;
  }

  .xl\\:translate-x-74{
    --transform-translate-x: 18.5rem;
  }

  .xl\\:translate-x-76{
    --transform-translate-x: 19rem;
  }

  .xl\\:translate-x-78{
    --transform-translate-x: 19.5rem;
  }

  .xl\\:translate-x-80{
    --transform-translate-x: 20rem;
  }

  .xl\\:translate-x-82{
    --transform-translate-x: 20.5rem;
  }

  .xl\\:translate-x-84{
    --transform-translate-x: 21rem;
  }

  .xl\\:translate-x-88{
    --transform-translate-x: 22rem;
  }

  .xl\\:translate-x-92{
    --transform-translate-x: 23rem;
  }

  .xl\\:translate-x-96{
    --transform-translate-x: 24rem;
  }

  .xl\\:translate-x-98{
    --transform-translate-x: 24.5rem;
  }

  .xl\\:translate-x-100{
    --transform-translate-x: 25rem;
  }

  .xl\\:translate-x-104{
    --transform-translate-x: 26rem;
  }

  .xl\\:translate-x-112{
    --transform-translate-x: 28rem;
  }

  .xl\\:translate-x-124{
    --transform-translate-x: 31rem;
  }

  .xl\\:translate-x-128{
    --transform-translate-x: 32rem;
  }

  .xl\\:translate-x-140{
    --transform-translate-x: 35rem;
  }

  .xl\\:translate-x-152{
    --transform-translate-x: 38rem;
  }

  .xl\\:translate-x-160{
    --transform-translate-x: 40rem;
  }

  .xl\\:translate-x-162{
    --transform-translate-x: 41rem;
  }

  .xl\\:translate-x-192{
    --transform-translate-x: 48rem;
  }

  .xl\\:translate-x-208{
    --transform-translate-x: 52rem;
  }

  .xl\\:translate-x-224{
    --transform-translate-x: 56rem;
  }

  .xl\\:translate-x-256{
    --transform-translate-x: 64rem;
  }

  .xl\\:translate-x-px{
    --transform-translate-x: 1px;
  }

  .xl\\:-translate-x-1{
    --transform-translate-x: -0.25rem;
  }

  .xl\\:-translate-x-2{
    --transform-translate-x: -0.5rem;
  }

  .xl\\:-translate-x-3{
    --transform-translate-x: -0.75rem;
  }

  .xl\\:-translate-x-4{
    --transform-translate-x: -1rem;
  }

  .xl\\:-translate-x-5{
    --transform-translate-x: -1.25rem;
  }

  .xl\\:-translate-x-6{
    --transform-translate-x: -1.5rem;
  }

  .xl\\:-translate-x-7{
    --transform-translate-x: -1.75rem;
  }

  .xl\\:-translate-x-8{
    --transform-translate-x: -2rem;
  }

  .xl\\:-translate-x-9{
    --transform-translate-x: -2.25rem;
  }

  .xl\\:-translate-x-10{
    --transform-translate-x: -2.5rem;
  }

  .xl\\:-translate-x-11{
    --transform-translate-x: -2.75rem;
  }

  .xl\\:-translate-x-12{
    --transform-translate-x: -3rem;
  }

  .xl\\:-translate-x-14{
    --transform-translate-x: -3.5rem;
  }

  .xl\\:-translate-x-15{
    --transform-translate-x: -3.75rem;
  }

  .xl\\:-translate-x-16{
    --transform-translate-x: -4rem;
  }

  .xl\\:-translate-x-18{
    --transform-translate-x: -4.5rem;
  }

  .xl\\:-translate-x-20{
    --transform-translate-x: -5rem;
  }

  .xl\\:-translate-x-22{
    --transform-translate-x: -5.5rem;
  }

  .xl\\:-translate-x-23{
    --transform-translate-x: -5.75rem;
  }

  .xl\\:-translate-x-24{
    --transform-translate-x: -6rem;
  }

  .xl\\:-translate-x-25{
    --transform-translate-x: -6.25rem;
  }

  .xl\\:-translate-x-26{
    --transform-translate-x: -6.5rem;
  }

  .xl\\:-translate-x-28{
    --transform-translate-x: -7rem;
  }

  .xl\\:-translate-x-30{
    --transform-translate-x: -7.5rem;
  }

  .xl\\:-translate-x-32{
    --transform-translate-x: -8rem;
  }

  .xl\\:-translate-x-34{
    --transform-translate-x: -8.5rem;
  }

  .xl\\:-translate-x-40{
    --transform-translate-x: -10rem;
  }

  .xl\\:-translate-x-42{
    --transform-translate-x: -10.5rem;
  }

  .xl\\:-translate-x-44{
    --transform-translate-x: -11rem;
  }

  .xl\\:-translate-x-48{
    --transform-translate-x: -12rem;
  }

  .xl\\:-translate-x-52{
    --transform-translate-x: -13rem;
  }

  .xl\\:-translate-x-54{
    --transform-translate-x: -13.5rem;
  }

  .xl\\:-translate-x-56{
    --transform-translate-x: -14rem;
  }

  .xl\\:-translate-x-60{
    --transform-translate-x: -15rem;
  }

  .xl\\:-translate-x-64{
    --transform-translate-x: -16rem;
  }

  .xl\\:-translate-x-68{
    --transform-translate-x: -17rem;
  }

  .xl\\:-translate-x-72{
    --transform-translate-x: -18rem;
  }

  .xl\\:-translate-x-74{
    --transform-translate-x: -18.5rem;
  }

  .xl\\:-translate-x-76{
    --transform-translate-x: -19rem;
  }

  .xl\\:-translate-x-78{
    --transform-translate-x: -19.5rem;
  }

  .xl\\:-translate-x-80{
    --transform-translate-x: -20rem;
  }

  .xl\\:-translate-x-82{
    --transform-translate-x: -20.5rem;
  }

  .xl\\:-translate-x-84{
    --transform-translate-x: -21rem;
  }

  .xl\\:-translate-x-88{
    --transform-translate-x: -22rem;
  }

  .xl\\:-translate-x-92{
    --transform-translate-x: -23rem;
  }

  .xl\\:-translate-x-96{
    --transform-translate-x: -24rem;
  }

  .xl\\:-translate-x-98{
    --transform-translate-x: -24.5rem;
  }

  .xl\\:-translate-x-100{
    --transform-translate-x: -25rem;
  }

  .xl\\:-translate-x-104{
    --transform-translate-x: -26rem;
  }

  .xl\\:-translate-x-112{
    --transform-translate-x: -28rem;
  }

  .xl\\:-translate-x-124{
    --transform-translate-x: -31rem;
  }

  .xl\\:-translate-x-128{
    --transform-translate-x: -32rem;
  }

  .xl\\:-translate-x-140{
    --transform-translate-x: -35rem;
  }

  .xl\\:-translate-x-152{
    --transform-translate-x: -38rem;
  }

  .xl\\:-translate-x-160{
    --transform-translate-x: -40rem;
  }

  .xl\\:-translate-x-162{
    --transform-translate-x: -41rem;
  }

  .xl\\:-translate-x-192{
    --transform-translate-x: -48rem;
  }

  .xl\\:-translate-x-208{
    --transform-translate-x: -52rem;
  }

  .xl\\:-translate-x-224{
    --transform-translate-x: -56rem;
  }

  .xl\\:-translate-x-256{
    --transform-translate-x: -64rem;
  }

  .xl\\:-translate-x-px{
    --transform-translate-x: -1px;
  }

  .xl\\:-translate-x-full{
    --transform-translate-x: -100%;
  }

  .xl\\:-translate-x-1\\/2{
    --transform-translate-x: -50%;
  }

  .xl\\:translate-x-1\\/2{
    --transform-translate-x: 50%;
  }

  .xl\\:translate-x-full{
    --transform-translate-x: 100%;
  }

  .xl\\:translate-y-0{
    --transform-translate-y: 0;
  }

  .xl\\:translate-y-1{
    --transform-translate-y: 0.25rem;
  }

  .xl\\:translate-y-2{
    --transform-translate-y: 0.5rem;
  }

  .xl\\:translate-y-3{
    --transform-translate-y: 0.75rem;
  }

  .xl\\:translate-y-4{
    --transform-translate-y: 1rem;
  }

  .xl\\:translate-y-5{
    --transform-translate-y: 1.25rem;
  }

  .xl\\:translate-y-6{
    --transform-translate-y: 1.5rem;
  }

  .xl\\:translate-y-7{
    --transform-translate-y: 1.75rem;
  }

  .xl\\:translate-y-8{
    --transform-translate-y: 2rem;
  }

  .xl\\:translate-y-9{
    --transform-translate-y: 2.25rem;
  }

  .xl\\:translate-y-10{
    --transform-translate-y: 2.5rem;
  }

  .xl\\:translate-y-11{
    --transform-translate-y: 2.75rem;
  }

  .xl\\:translate-y-12{
    --transform-translate-y: 3rem;
  }

  .xl\\:translate-y-14{
    --transform-translate-y: 3.5rem;
  }

  .xl\\:translate-y-15{
    --transform-translate-y: 3.75rem;
  }

  .xl\\:translate-y-16{
    --transform-translate-y: 4rem;
  }

  .xl\\:translate-y-18{
    --transform-translate-y: 4.5rem;
  }

  .xl\\:translate-y-20{
    --transform-translate-y: 5rem;
  }

  .xl\\:translate-y-22{
    --transform-translate-y: 5.5rem;
  }

  .xl\\:translate-y-23{
    --transform-translate-y: 5.75rem;
  }

  .xl\\:translate-y-24{
    --transform-translate-y: 6rem;
  }

  .xl\\:translate-y-25{
    --transform-translate-y: 6.25rem;
  }

  .xl\\:translate-y-26{
    --transform-translate-y: 6.5rem;
  }

  .xl\\:translate-y-28{
    --transform-translate-y: 7rem;
  }

  .xl\\:translate-y-30{
    --transform-translate-y: 7.5rem;
  }

  .xl\\:translate-y-32{
    --transform-translate-y: 8rem;
  }

  .xl\\:translate-y-34{
    --transform-translate-y: 8.5rem;
  }

  .xl\\:translate-y-40{
    --transform-translate-y: 10rem;
  }

  .xl\\:translate-y-42{
    --transform-translate-y: 10.5rem;
  }

  .xl\\:translate-y-44{
    --transform-translate-y: 11rem;
  }

  .xl\\:translate-y-48{
    --transform-translate-y: 12rem;
  }

  .xl\\:translate-y-52{
    --transform-translate-y: 13rem;
  }

  .xl\\:translate-y-54{
    --transform-translate-y: 13.5rem;
  }

  .xl\\:translate-y-56{
    --transform-translate-y: 14rem;
  }

  .xl\\:translate-y-60{
    --transform-translate-y: 15rem;
  }

  .xl\\:translate-y-64{
    --transform-translate-y: 16rem;
  }

  .xl\\:translate-y-68{
    --transform-translate-y: 17rem;
  }

  .xl\\:translate-y-72{
    --transform-translate-y: 18rem;
  }

  .xl\\:translate-y-74{
    --transform-translate-y: 18.5rem;
  }

  .xl\\:translate-y-76{
    --transform-translate-y: 19rem;
  }

  .xl\\:translate-y-78{
    --transform-translate-y: 19.5rem;
  }

  .xl\\:translate-y-80{
    --transform-translate-y: 20rem;
  }

  .xl\\:translate-y-82{
    --transform-translate-y: 20.5rem;
  }

  .xl\\:translate-y-84{
    --transform-translate-y: 21rem;
  }

  .xl\\:translate-y-88{
    --transform-translate-y: 22rem;
  }

  .xl\\:translate-y-92{
    --transform-translate-y: 23rem;
  }

  .xl\\:translate-y-96{
    --transform-translate-y: 24rem;
  }

  .xl\\:translate-y-98{
    --transform-translate-y: 24.5rem;
  }

  .xl\\:translate-y-100{
    --transform-translate-y: 25rem;
  }

  .xl\\:translate-y-104{
    --transform-translate-y: 26rem;
  }

  .xl\\:translate-y-112{
    --transform-translate-y: 28rem;
  }

  .xl\\:translate-y-124{
    --transform-translate-y: 31rem;
  }

  .xl\\:translate-y-128{
    --transform-translate-y: 32rem;
  }

  .xl\\:translate-y-140{
    --transform-translate-y: 35rem;
  }

  .xl\\:translate-y-152{
    --transform-translate-y: 38rem;
  }

  .xl\\:translate-y-160{
    --transform-translate-y: 40rem;
  }

  .xl\\:translate-y-162{
    --transform-translate-y: 41rem;
  }

  .xl\\:translate-y-192{
    --transform-translate-y: 48rem;
  }

  .xl\\:translate-y-208{
    --transform-translate-y: 52rem;
  }

  .xl\\:translate-y-224{
    --transform-translate-y: 56rem;
  }

  .xl\\:translate-y-256{
    --transform-translate-y: 64rem;
  }

  .xl\\:translate-y-px{
    --transform-translate-y: 1px;
  }

  .xl\\:-translate-y-1{
    --transform-translate-y: -0.25rem;
  }

  .xl\\:-translate-y-2{
    --transform-translate-y: -0.5rem;
  }

  .xl\\:-translate-y-3{
    --transform-translate-y: -0.75rem;
  }

  .xl\\:-translate-y-4{
    --transform-translate-y: -1rem;
  }

  .xl\\:-translate-y-5{
    --transform-translate-y: -1.25rem;
  }

  .xl\\:-translate-y-6{
    --transform-translate-y: -1.5rem;
  }

  .xl\\:-translate-y-7{
    --transform-translate-y: -1.75rem;
  }

  .xl\\:-translate-y-8{
    --transform-translate-y: -2rem;
  }

  .xl\\:-translate-y-9{
    --transform-translate-y: -2.25rem;
  }

  .xl\\:-translate-y-10{
    --transform-translate-y: -2.5rem;
  }

  .xl\\:-translate-y-11{
    --transform-translate-y: -2.75rem;
  }

  .xl\\:-translate-y-12{
    --transform-translate-y: -3rem;
  }

  .xl\\:-translate-y-14{
    --transform-translate-y: -3.5rem;
  }

  .xl\\:-translate-y-15{
    --transform-translate-y: -3.75rem;
  }

  .xl\\:-translate-y-16{
    --transform-translate-y: -4rem;
  }

  .xl\\:-translate-y-18{
    --transform-translate-y: -4.5rem;
  }

  .xl\\:-translate-y-20{
    --transform-translate-y: -5rem;
  }

  .xl\\:-translate-y-22{
    --transform-translate-y: -5.5rem;
  }

  .xl\\:-translate-y-23{
    --transform-translate-y: -5.75rem;
  }

  .xl\\:-translate-y-24{
    --transform-translate-y: -6rem;
  }

  .xl\\:-translate-y-25{
    --transform-translate-y: -6.25rem;
  }

  .xl\\:-translate-y-26{
    --transform-translate-y: -6.5rem;
  }

  .xl\\:-translate-y-28{
    --transform-translate-y: -7rem;
  }

  .xl\\:-translate-y-30{
    --transform-translate-y: -7.5rem;
  }

  .xl\\:-translate-y-32{
    --transform-translate-y: -8rem;
  }

  .xl\\:-translate-y-34{
    --transform-translate-y: -8.5rem;
  }

  .xl\\:-translate-y-40{
    --transform-translate-y: -10rem;
  }

  .xl\\:-translate-y-42{
    --transform-translate-y: -10.5rem;
  }

  .xl\\:-translate-y-44{
    --transform-translate-y: -11rem;
  }

  .xl\\:-translate-y-48{
    --transform-translate-y: -12rem;
  }

  .xl\\:-translate-y-52{
    --transform-translate-y: -13rem;
  }

  .xl\\:-translate-y-54{
    --transform-translate-y: -13.5rem;
  }

  .xl\\:-translate-y-56{
    --transform-translate-y: -14rem;
  }

  .xl\\:-translate-y-60{
    --transform-translate-y: -15rem;
  }

  .xl\\:-translate-y-64{
    --transform-translate-y: -16rem;
  }

  .xl\\:-translate-y-68{
    --transform-translate-y: -17rem;
  }

  .xl\\:-translate-y-72{
    --transform-translate-y: -18rem;
  }

  .xl\\:-translate-y-74{
    --transform-translate-y: -18.5rem;
  }

  .xl\\:-translate-y-76{
    --transform-translate-y: -19rem;
  }

  .xl\\:-translate-y-78{
    --transform-translate-y: -19.5rem;
  }

  .xl\\:-translate-y-80{
    --transform-translate-y: -20rem;
  }

  .xl\\:-translate-y-82{
    --transform-translate-y: -20.5rem;
  }

  .xl\\:-translate-y-84{
    --transform-translate-y: -21rem;
  }

  .xl\\:-translate-y-88{
    --transform-translate-y: -22rem;
  }

  .xl\\:-translate-y-92{
    --transform-translate-y: -23rem;
  }

  .xl\\:-translate-y-96{
    --transform-translate-y: -24rem;
  }

  .xl\\:-translate-y-98{
    --transform-translate-y: -24.5rem;
  }

  .xl\\:-translate-y-100{
    --transform-translate-y: -25rem;
  }

  .xl\\:-translate-y-104{
    --transform-translate-y: -26rem;
  }

  .xl\\:-translate-y-112{
    --transform-translate-y: -28rem;
  }

  .xl\\:-translate-y-124{
    --transform-translate-y: -31rem;
  }

  .xl\\:-translate-y-128{
    --transform-translate-y: -32rem;
  }

  .xl\\:-translate-y-140{
    --transform-translate-y: -35rem;
  }

  .xl\\:-translate-y-152{
    --transform-translate-y: -38rem;
  }

  .xl\\:-translate-y-160{
    --transform-translate-y: -40rem;
  }

  .xl\\:-translate-y-162{
    --transform-translate-y: -41rem;
  }

  .xl\\:-translate-y-192{
    --transform-translate-y: -48rem;
  }

  .xl\\:-translate-y-208{
    --transform-translate-y: -52rem;
  }

  .xl\\:-translate-y-224{
    --transform-translate-y: -56rem;
  }

  .xl\\:-translate-y-256{
    --transform-translate-y: -64rem;
  }

  .xl\\:-translate-y-px{
    --transform-translate-y: -1px;
  }

  .xl\\:-translate-y-full{
    --transform-translate-y: -100%;
  }

  .xl\\:-translate-y-1\\/2{
    --transform-translate-y: -50%;
  }

  .xl\\:translate-y-1\\/2{
    --transform-translate-y: 50%;
  }

  .xl\\:translate-y-full{
    --transform-translate-y: 100%;
  }

  .xl\\:hover\\:translate-x-0:hover{
    --transform-translate-x: 0;
  }

  .xl\\:hover\\:translate-x-1:hover{
    --transform-translate-x: 0.25rem;
  }

  .xl\\:hover\\:translate-x-2:hover{
    --transform-translate-x: 0.5rem;
  }

  .xl\\:hover\\:translate-x-3:hover{
    --transform-translate-x: 0.75rem;
  }

  .xl\\:hover\\:translate-x-4:hover{
    --transform-translate-x: 1rem;
  }

  .xl\\:hover\\:translate-x-5:hover{
    --transform-translate-x: 1.25rem;
  }

  .xl\\:hover\\:translate-x-6:hover{
    --transform-translate-x: 1.5rem;
  }

  .xl\\:hover\\:translate-x-7:hover{
    --transform-translate-x: 1.75rem;
  }

  .xl\\:hover\\:translate-x-8:hover{
    --transform-translate-x: 2rem;
  }

  .xl\\:hover\\:translate-x-9:hover{
    --transform-translate-x: 2.25rem;
  }

  .xl\\:hover\\:translate-x-10:hover{
    --transform-translate-x: 2.5rem;
  }

  .xl\\:hover\\:translate-x-11:hover{
    --transform-translate-x: 2.75rem;
  }

  .xl\\:hover\\:translate-x-12:hover{
    --transform-translate-x: 3rem;
  }

  .xl\\:hover\\:translate-x-14:hover{
    --transform-translate-x: 3.5rem;
  }

  .xl\\:hover\\:translate-x-15:hover{
    --transform-translate-x: 3.75rem;
  }

  .xl\\:hover\\:translate-x-16:hover{
    --transform-translate-x: 4rem;
  }

  .xl\\:hover\\:translate-x-18:hover{
    --transform-translate-x: 4.5rem;
  }

  .xl\\:hover\\:translate-x-20:hover{
    --transform-translate-x: 5rem;
  }

  .xl\\:hover\\:translate-x-22:hover{
    --transform-translate-x: 5.5rem;
  }

  .xl\\:hover\\:translate-x-23:hover{
    --transform-translate-x: 5.75rem;
  }

  .xl\\:hover\\:translate-x-24:hover{
    --transform-translate-x: 6rem;
  }

  .xl\\:hover\\:translate-x-25:hover{
    --transform-translate-x: 6.25rem;
  }

  .xl\\:hover\\:translate-x-26:hover{
    --transform-translate-x: 6.5rem;
  }

  .xl\\:hover\\:translate-x-28:hover{
    --transform-translate-x: 7rem;
  }

  .xl\\:hover\\:translate-x-30:hover{
    --transform-translate-x: 7.5rem;
  }

  .xl\\:hover\\:translate-x-32:hover{
    --transform-translate-x: 8rem;
  }

  .xl\\:hover\\:translate-x-34:hover{
    --transform-translate-x: 8.5rem;
  }

  .xl\\:hover\\:translate-x-40:hover{
    --transform-translate-x: 10rem;
  }

  .xl\\:hover\\:translate-x-42:hover{
    --transform-translate-x: 10.5rem;
  }

  .xl\\:hover\\:translate-x-44:hover{
    --transform-translate-x: 11rem;
  }

  .xl\\:hover\\:translate-x-48:hover{
    --transform-translate-x: 12rem;
  }

  .xl\\:hover\\:translate-x-52:hover{
    --transform-translate-x: 13rem;
  }

  .xl\\:hover\\:translate-x-54:hover{
    --transform-translate-x: 13.5rem;
  }

  .xl\\:hover\\:translate-x-56:hover{
    --transform-translate-x: 14rem;
  }

  .xl\\:hover\\:translate-x-60:hover{
    --transform-translate-x: 15rem;
  }

  .xl\\:hover\\:translate-x-64:hover{
    --transform-translate-x: 16rem;
  }

  .xl\\:hover\\:translate-x-68:hover{
    --transform-translate-x: 17rem;
  }

  .xl\\:hover\\:translate-x-72:hover{
    --transform-translate-x: 18rem;
  }

  .xl\\:hover\\:translate-x-74:hover{
    --transform-translate-x: 18.5rem;
  }

  .xl\\:hover\\:translate-x-76:hover{
    --transform-translate-x: 19rem;
  }

  .xl\\:hover\\:translate-x-78:hover{
    --transform-translate-x: 19.5rem;
  }

  .xl\\:hover\\:translate-x-80:hover{
    --transform-translate-x: 20rem;
  }

  .xl\\:hover\\:translate-x-82:hover{
    --transform-translate-x: 20.5rem;
  }

  .xl\\:hover\\:translate-x-84:hover{
    --transform-translate-x: 21rem;
  }

  .xl\\:hover\\:translate-x-88:hover{
    --transform-translate-x: 22rem;
  }

  .xl\\:hover\\:translate-x-92:hover{
    --transform-translate-x: 23rem;
  }

  .xl\\:hover\\:translate-x-96:hover{
    --transform-translate-x: 24rem;
  }

  .xl\\:hover\\:translate-x-98:hover{
    --transform-translate-x: 24.5rem;
  }

  .xl\\:hover\\:translate-x-100:hover{
    --transform-translate-x: 25rem;
  }

  .xl\\:hover\\:translate-x-104:hover{
    --transform-translate-x: 26rem;
  }

  .xl\\:hover\\:translate-x-112:hover{
    --transform-translate-x: 28rem;
  }

  .xl\\:hover\\:translate-x-124:hover{
    --transform-translate-x: 31rem;
  }

  .xl\\:hover\\:translate-x-128:hover{
    --transform-translate-x: 32rem;
  }

  .xl\\:hover\\:translate-x-140:hover{
    --transform-translate-x: 35rem;
  }

  .xl\\:hover\\:translate-x-152:hover{
    --transform-translate-x: 38rem;
  }

  .xl\\:hover\\:translate-x-160:hover{
    --transform-translate-x: 40rem;
  }

  .xl\\:hover\\:translate-x-162:hover{
    --transform-translate-x: 41rem;
  }

  .xl\\:hover\\:translate-x-192:hover{
    --transform-translate-x: 48rem;
  }

  .xl\\:hover\\:translate-x-208:hover{
    --transform-translate-x: 52rem;
  }

  .xl\\:hover\\:translate-x-224:hover{
    --transform-translate-x: 56rem;
  }

  .xl\\:hover\\:translate-x-256:hover{
    --transform-translate-x: 64rem;
  }

  .xl\\:hover\\:translate-x-px:hover{
    --transform-translate-x: 1px;
  }

  .xl\\:hover\\:-translate-x-1:hover{
    --transform-translate-x: -0.25rem;
  }

  .xl\\:hover\\:-translate-x-2:hover{
    --transform-translate-x: -0.5rem;
  }

  .xl\\:hover\\:-translate-x-3:hover{
    --transform-translate-x: -0.75rem;
  }

  .xl\\:hover\\:-translate-x-4:hover{
    --transform-translate-x: -1rem;
  }

  .xl\\:hover\\:-translate-x-5:hover{
    --transform-translate-x: -1.25rem;
  }

  .xl\\:hover\\:-translate-x-6:hover{
    --transform-translate-x: -1.5rem;
  }

  .xl\\:hover\\:-translate-x-7:hover{
    --transform-translate-x: -1.75rem;
  }

  .xl\\:hover\\:-translate-x-8:hover{
    --transform-translate-x: -2rem;
  }

  .xl\\:hover\\:-translate-x-9:hover{
    --transform-translate-x: -2.25rem;
  }

  .xl\\:hover\\:-translate-x-10:hover{
    --transform-translate-x: -2.5rem;
  }

  .xl\\:hover\\:-translate-x-11:hover{
    --transform-translate-x: -2.75rem;
  }

  .xl\\:hover\\:-translate-x-12:hover{
    --transform-translate-x: -3rem;
  }

  .xl\\:hover\\:-translate-x-14:hover{
    --transform-translate-x: -3.5rem;
  }

  .xl\\:hover\\:-translate-x-15:hover{
    --transform-translate-x: -3.75rem;
  }

  .xl\\:hover\\:-translate-x-16:hover{
    --transform-translate-x: -4rem;
  }

  .xl\\:hover\\:-translate-x-18:hover{
    --transform-translate-x: -4.5rem;
  }

  .xl\\:hover\\:-translate-x-20:hover{
    --transform-translate-x: -5rem;
  }

  .xl\\:hover\\:-translate-x-22:hover{
    --transform-translate-x: -5.5rem;
  }

  .xl\\:hover\\:-translate-x-23:hover{
    --transform-translate-x: -5.75rem;
  }

  .xl\\:hover\\:-translate-x-24:hover{
    --transform-translate-x: -6rem;
  }

  .xl\\:hover\\:-translate-x-25:hover{
    --transform-translate-x: -6.25rem;
  }

  .xl\\:hover\\:-translate-x-26:hover{
    --transform-translate-x: -6.5rem;
  }

  .xl\\:hover\\:-translate-x-28:hover{
    --transform-translate-x: -7rem;
  }

  .xl\\:hover\\:-translate-x-30:hover{
    --transform-translate-x: -7.5rem;
  }

  .xl\\:hover\\:-translate-x-32:hover{
    --transform-translate-x: -8rem;
  }

  .xl\\:hover\\:-translate-x-34:hover{
    --transform-translate-x: -8.5rem;
  }

  .xl\\:hover\\:-translate-x-40:hover{
    --transform-translate-x: -10rem;
  }

  .xl\\:hover\\:-translate-x-42:hover{
    --transform-translate-x: -10.5rem;
  }

  .xl\\:hover\\:-translate-x-44:hover{
    --transform-translate-x: -11rem;
  }

  .xl\\:hover\\:-translate-x-48:hover{
    --transform-translate-x: -12rem;
  }

  .xl\\:hover\\:-translate-x-52:hover{
    --transform-translate-x: -13rem;
  }

  .xl\\:hover\\:-translate-x-54:hover{
    --transform-translate-x: -13.5rem;
  }

  .xl\\:hover\\:-translate-x-56:hover{
    --transform-translate-x: -14rem;
  }

  .xl\\:hover\\:-translate-x-60:hover{
    --transform-translate-x: -15rem;
  }

  .xl\\:hover\\:-translate-x-64:hover{
    --transform-translate-x: -16rem;
  }

  .xl\\:hover\\:-translate-x-68:hover{
    --transform-translate-x: -17rem;
  }

  .xl\\:hover\\:-translate-x-72:hover{
    --transform-translate-x: -18rem;
  }

  .xl\\:hover\\:-translate-x-74:hover{
    --transform-translate-x: -18.5rem;
  }

  .xl\\:hover\\:-translate-x-76:hover{
    --transform-translate-x: -19rem;
  }

  .xl\\:hover\\:-translate-x-78:hover{
    --transform-translate-x: -19.5rem;
  }

  .xl\\:hover\\:-translate-x-80:hover{
    --transform-translate-x: -20rem;
  }

  .xl\\:hover\\:-translate-x-82:hover{
    --transform-translate-x: -20.5rem;
  }

  .xl\\:hover\\:-translate-x-84:hover{
    --transform-translate-x: -21rem;
  }

  .xl\\:hover\\:-translate-x-88:hover{
    --transform-translate-x: -22rem;
  }

  .xl\\:hover\\:-translate-x-92:hover{
    --transform-translate-x: -23rem;
  }

  .xl\\:hover\\:-translate-x-96:hover{
    --transform-translate-x: -24rem;
  }

  .xl\\:hover\\:-translate-x-98:hover{
    --transform-translate-x: -24.5rem;
  }

  .xl\\:hover\\:-translate-x-100:hover{
    --transform-translate-x: -25rem;
  }

  .xl\\:hover\\:-translate-x-104:hover{
    --transform-translate-x: -26rem;
  }

  .xl\\:hover\\:-translate-x-112:hover{
    --transform-translate-x: -28rem;
  }

  .xl\\:hover\\:-translate-x-124:hover{
    --transform-translate-x: -31rem;
  }

  .xl\\:hover\\:-translate-x-128:hover{
    --transform-translate-x: -32rem;
  }

  .xl\\:hover\\:-translate-x-140:hover{
    --transform-translate-x: -35rem;
  }

  .xl\\:hover\\:-translate-x-152:hover{
    --transform-translate-x: -38rem;
  }

  .xl\\:hover\\:-translate-x-160:hover{
    --transform-translate-x: -40rem;
  }

  .xl\\:hover\\:-translate-x-162:hover{
    --transform-translate-x: -41rem;
  }

  .xl\\:hover\\:-translate-x-192:hover{
    --transform-translate-x: -48rem;
  }

  .xl\\:hover\\:-translate-x-208:hover{
    --transform-translate-x: -52rem;
  }

  .xl\\:hover\\:-translate-x-224:hover{
    --transform-translate-x: -56rem;
  }

  .xl\\:hover\\:-translate-x-256:hover{
    --transform-translate-x: -64rem;
  }

  .xl\\:hover\\:-translate-x-px:hover{
    --transform-translate-x: -1px;
  }

  .xl\\:hover\\:-translate-x-full:hover{
    --transform-translate-x: -100%;
  }

  .xl\\:hover\\:-translate-x-1\\/2:hover{
    --transform-translate-x: -50%;
  }

  .xl\\:hover\\:translate-x-1\\/2:hover{
    --transform-translate-x: 50%;
  }

  .xl\\:hover\\:translate-x-full:hover{
    --transform-translate-x: 100%;
  }

  .xl\\:hover\\:translate-y-0:hover{
    --transform-translate-y: 0;
  }

  .xl\\:hover\\:translate-y-1:hover{
    --transform-translate-y: 0.25rem;
  }

  .xl\\:hover\\:translate-y-2:hover{
    --transform-translate-y: 0.5rem;
  }

  .xl\\:hover\\:translate-y-3:hover{
    --transform-translate-y: 0.75rem;
  }

  .xl\\:hover\\:translate-y-4:hover{
    --transform-translate-y: 1rem;
  }

  .xl\\:hover\\:translate-y-5:hover{
    --transform-translate-y: 1.25rem;
  }

  .xl\\:hover\\:translate-y-6:hover{
    --transform-translate-y: 1.5rem;
  }

  .xl\\:hover\\:translate-y-7:hover{
    --transform-translate-y: 1.75rem;
  }

  .xl\\:hover\\:translate-y-8:hover{
    --transform-translate-y: 2rem;
  }

  .xl\\:hover\\:translate-y-9:hover{
    --transform-translate-y: 2.25rem;
  }

  .xl\\:hover\\:translate-y-10:hover{
    --transform-translate-y: 2.5rem;
  }

  .xl\\:hover\\:translate-y-11:hover{
    --transform-translate-y: 2.75rem;
  }

  .xl\\:hover\\:translate-y-12:hover{
    --transform-translate-y: 3rem;
  }

  .xl\\:hover\\:translate-y-14:hover{
    --transform-translate-y: 3.5rem;
  }

  .xl\\:hover\\:translate-y-15:hover{
    --transform-translate-y: 3.75rem;
  }

  .xl\\:hover\\:translate-y-16:hover{
    --transform-translate-y: 4rem;
  }

  .xl\\:hover\\:translate-y-18:hover{
    --transform-translate-y: 4.5rem;
  }

  .xl\\:hover\\:translate-y-20:hover{
    --transform-translate-y: 5rem;
  }

  .xl\\:hover\\:translate-y-22:hover{
    --transform-translate-y: 5.5rem;
  }

  .xl\\:hover\\:translate-y-23:hover{
    --transform-translate-y: 5.75rem;
  }

  .xl\\:hover\\:translate-y-24:hover{
    --transform-translate-y: 6rem;
  }

  .xl\\:hover\\:translate-y-25:hover{
    --transform-translate-y: 6.25rem;
  }

  .xl\\:hover\\:translate-y-26:hover{
    --transform-translate-y: 6.5rem;
  }

  .xl\\:hover\\:translate-y-28:hover{
    --transform-translate-y: 7rem;
  }

  .xl\\:hover\\:translate-y-30:hover{
    --transform-translate-y: 7.5rem;
  }

  .xl\\:hover\\:translate-y-32:hover{
    --transform-translate-y: 8rem;
  }

  .xl\\:hover\\:translate-y-34:hover{
    --transform-translate-y: 8.5rem;
  }

  .xl\\:hover\\:translate-y-40:hover{
    --transform-translate-y: 10rem;
  }

  .xl\\:hover\\:translate-y-42:hover{
    --transform-translate-y: 10.5rem;
  }

  .xl\\:hover\\:translate-y-44:hover{
    --transform-translate-y: 11rem;
  }

  .xl\\:hover\\:translate-y-48:hover{
    --transform-translate-y: 12rem;
  }

  .xl\\:hover\\:translate-y-52:hover{
    --transform-translate-y: 13rem;
  }

  .xl\\:hover\\:translate-y-54:hover{
    --transform-translate-y: 13.5rem;
  }

  .xl\\:hover\\:translate-y-56:hover{
    --transform-translate-y: 14rem;
  }

  .xl\\:hover\\:translate-y-60:hover{
    --transform-translate-y: 15rem;
  }

  .xl\\:hover\\:translate-y-64:hover{
    --transform-translate-y: 16rem;
  }

  .xl\\:hover\\:translate-y-68:hover{
    --transform-translate-y: 17rem;
  }

  .xl\\:hover\\:translate-y-72:hover{
    --transform-translate-y: 18rem;
  }

  .xl\\:hover\\:translate-y-74:hover{
    --transform-translate-y: 18.5rem;
  }

  .xl\\:hover\\:translate-y-76:hover{
    --transform-translate-y: 19rem;
  }

  .xl\\:hover\\:translate-y-78:hover{
    --transform-translate-y: 19.5rem;
  }

  .xl\\:hover\\:translate-y-80:hover{
    --transform-translate-y: 20rem;
  }

  .xl\\:hover\\:translate-y-82:hover{
    --transform-translate-y: 20.5rem;
  }

  .xl\\:hover\\:translate-y-84:hover{
    --transform-translate-y: 21rem;
  }

  .xl\\:hover\\:translate-y-88:hover{
    --transform-translate-y: 22rem;
  }

  .xl\\:hover\\:translate-y-92:hover{
    --transform-translate-y: 23rem;
  }

  .xl\\:hover\\:translate-y-96:hover{
    --transform-translate-y: 24rem;
  }

  .xl\\:hover\\:translate-y-98:hover{
    --transform-translate-y: 24.5rem;
  }

  .xl\\:hover\\:translate-y-100:hover{
    --transform-translate-y: 25rem;
  }

  .xl\\:hover\\:translate-y-104:hover{
    --transform-translate-y: 26rem;
  }

  .xl\\:hover\\:translate-y-112:hover{
    --transform-translate-y: 28rem;
  }

  .xl\\:hover\\:translate-y-124:hover{
    --transform-translate-y: 31rem;
  }

  .xl\\:hover\\:translate-y-128:hover{
    --transform-translate-y: 32rem;
  }

  .xl\\:hover\\:translate-y-140:hover{
    --transform-translate-y: 35rem;
  }

  .xl\\:hover\\:translate-y-152:hover{
    --transform-translate-y: 38rem;
  }

  .xl\\:hover\\:translate-y-160:hover{
    --transform-translate-y: 40rem;
  }

  .xl\\:hover\\:translate-y-162:hover{
    --transform-translate-y: 41rem;
  }

  .xl\\:hover\\:translate-y-192:hover{
    --transform-translate-y: 48rem;
  }

  .xl\\:hover\\:translate-y-208:hover{
    --transform-translate-y: 52rem;
  }

  .xl\\:hover\\:translate-y-224:hover{
    --transform-translate-y: 56rem;
  }

  .xl\\:hover\\:translate-y-256:hover{
    --transform-translate-y: 64rem;
  }

  .xl\\:hover\\:translate-y-px:hover{
    --transform-translate-y: 1px;
  }

  .xl\\:hover\\:-translate-y-1:hover{
    --transform-translate-y: -0.25rem;
  }

  .xl\\:hover\\:-translate-y-2:hover{
    --transform-translate-y: -0.5rem;
  }

  .xl\\:hover\\:-translate-y-3:hover{
    --transform-translate-y: -0.75rem;
  }

  .xl\\:hover\\:-translate-y-4:hover{
    --transform-translate-y: -1rem;
  }

  .xl\\:hover\\:-translate-y-5:hover{
    --transform-translate-y: -1.25rem;
  }

  .xl\\:hover\\:-translate-y-6:hover{
    --transform-translate-y: -1.5rem;
  }

  .xl\\:hover\\:-translate-y-7:hover{
    --transform-translate-y: -1.75rem;
  }

  .xl\\:hover\\:-translate-y-8:hover{
    --transform-translate-y: -2rem;
  }

  .xl\\:hover\\:-translate-y-9:hover{
    --transform-translate-y: -2.25rem;
  }

  .xl\\:hover\\:-translate-y-10:hover{
    --transform-translate-y: -2.5rem;
  }

  .xl\\:hover\\:-translate-y-11:hover{
    --transform-translate-y: -2.75rem;
  }

  .xl\\:hover\\:-translate-y-12:hover{
    --transform-translate-y: -3rem;
  }

  .xl\\:hover\\:-translate-y-14:hover{
    --transform-translate-y: -3.5rem;
  }

  .xl\\:hover\\:-translate-y-15:hover{
    --transform-translate-y: -3.75rem;
  }

  .xl\\:hover\\:-translate-y-16:hover{
    --transform-translate-y: -4rem;
  }

  .xl\\:hover\\:-translate-y-18:hover{
    --transform-translate-y: -4.5rem;
  }

  .xl\\:hover\\:-translate-y-20:hover{
    --transform-translate-y: -5rem;
  }

  .xl\\:hover\\:-translate-y-22:hover{
    --transform-translate-y: -5.5rem;
  }

  .xl\\:hover\\:-translate-y-23:hover{
    --transform-translate-y: -5.75rem;
  }

  .xl\\:hover\\:-translate-y-24:hover{
    --transform-translate-y: -6rem;
  }

  .xl\\:hover\\:-translate-y-25:hover{
    --transform-translate-y: -6.25rem;
  }

  .xl\\:hover\\:-translate-y-26:hover{
    --transform-translate-y: -6.5rem;
  }

  .xl\\:hover\\:-translate-y-28:hover{
    --transform-translate-y: -7rem;
  }

  .xl\\:hover\\:-translate-y-30:hover{
    --transform-translate-y: -7.5rem;
  }

  .xl\\:hover\\:-translate-y-32:hover{
    --transform-translate-y: -8rem;
  }

  .xl\\:hover\\:-translate-y-34:hover{
    --transform-translate-y: -8.5rem;
  }

  .xl\\:hover\\:-translate-y-40:hover{
    --transform-translate-y: -10rem;
  }

  .xl\\:hover\\:-translate-y-42:hover{
    --transform-translate-y: -10.5rem;
  }

  .xl\\:hover\\:-translate-y-44:hover{
    --transform-translate-y: -11rem;
  }

  .xl\\:hover\\:-translate-y-48:hover{
    --transform-translate-y: -12rem;
  }

  .xl\\:hover\\:-translate-y-52:hover{
    --transform-translate-y: -13rem;
  }

  .xl\\:hover\\:-translate-y-54:hover{
    --transform-translate-y: -13.5rem;
  }

  .xl\\:hover\\:-translate-y-56:hover{
    --transform-translate-y: -14rem;
  }

  .xl\\:hover\\:-translate-y-60:hover{
    --transform-translate-y: -15rem;
  }

  .xl\\:hover\\:-translate-y-64:hover{
    --transform-translate-y: -16rem;
  }

  .xl\\:hover\\:-translate-y-68:hover{
    --transform-translate-y: -17rem;
  }

  .xl\\:hover\\:-translate-y-72:hover{
    --transform-translate-y: -18rem;
  }

  .xl\\:hover\\:-translate-y-74:hover{
    --transform-translate-y: -18.5rem;
  }

  .xl\\:hover\\:-translate-y-76:hover{
    --transform-translate-y: -19rem;
  }

  .xl\\:hover\\:-translate-y-78:hover{
    --transform-translate-y: -19.5rem;
  }

  .xl\\:hover\\:-translate-y-80:hover{
    --transform-translate-y: -20rem;
  }

  .xl\\:hover\\:-translate-y-82:hover{
    --transform-translate-y: -20.5rem;
  }

  .xl\\:hover\\:-translate-y-84:hover{
    --transform-translate-y: -21rem;
  }

  .xl\\:hover\\:-translate-y-88:hover{
    --transform-translate-y: -22rem;
  }

  .xl\\:hover\\:-translate-y-92:hover{
    --transform-translate-y: -23rem;
  }

  .xl\\:hover\\:-translate-y-96:hover{
    --transform-translate-y: -24rem;
  }

  .xl\\:hover\\:-translate-y-98:hover{
    --transform-translate-y: -24.5rem;
  }

  .xl\\:hover\\:-translate-y-100:hover{
    --transform-translate-y: -25rem;
  }

  .xl\\:hover\\:-translate-y-104:hover{
    --transform-translate-y: -26rem;
  }

  .xl\\:hover\\:-translate-y-112:hover{
    --transform-translate-y: -28rem;
  }

  .xl\\:hover\\:-translate-y-124:hover{
    --transform-translate-y: -31rem;
  }

  .xl\\:hover\\:-translate-y-128:hover{
    --transform-translate-y: -32rem;
  }

  .xl\\:hover\\:-translate-y-140:hover{
    --transform-translate-y: -35rem;
  }

  .xl\\:hover\\:-translate-y-152:hover{
    --transform-translate-y: -38rem;
  }

  .xl\\:hover\\:-translate-y-160:hover{
    --transform-translate-y: -40rem;
  }

  .xl\\:hover\\:-translate-y-162:hover{
    --transform-translate-y: -41rem;
  }

  .xl\\:hover\\:-translate-y-192:hover{
    --transform-translate-y: -48rem;
  }

  .xl\\:hover\\:-translate-y-208:hover{
    --transform-translate-y: -52rem;
  }

  .xl\\:hover\\:-translate-y-224:hover{
    --transform-translate-y: -56rem;
  }

  .xl\\:hover\\:-translate-y-256:hover{
    --transform-translate-y: -64rem;
  }

  .xl\\:hover\\:-translate-y-px:hover{
    --transform-translate-y: -1px;
  }

  .xl\\:hover\\:-translate-y-full:hover{
    --transform-translate-y: -100%;
  }

  .xl\\:hover\\:-translate-y-1\\/2:hover{
    --transform-translate-y: -50%;
  }

  .xl\\:hover\\:translate-y-1\\/2:hover{
    --transform-translate-y: 50%;
  }

  .xl\\:hover\\:translate-y-full:hover{
    --transform-translate-y: 100%;
  }

  .xl\\:focus\\:translate-x-0:focus{
    --transform-translate-x: 0;
  }

  .xl\\:focus\\:translate-x-1:focus{
    --transform-translate-x: 0.25rem;
  }

  .xl\\:focus\\:translate-x-2:focus{
    --transform-translate-x: 0.5rem;
  }

  .xl\\:focus\\:translate-x-3:focus{
    --transform-translate-x: 0.75rem;
  }

  .xl\\:focus\\:translate-x-4:focus{
    --transform-translate-x: 1rem;
  }

  .xl\\:focus\\:translate-x-5:focus{
    --transform-translate-x: 1.25rem;
  }

  .xl\\:focus\\:translate-x-6:focus{
    --transform-translate-x: 1.5rem;
  }

  .xl\\:focus\\:translate-x-7:focus{
    --transform-translate-x: 1.75rem;
  }

  .xl\\:focus\\:translate-x-8:focus{
    --transform-translate-x: 2rem;
  }

  .xl\\:focus\\:translate-x-9:focus{
    --transform-translate-x: 2.25rem;
  }

  .xl\\:focus\\:translate-x-10:focus{
    --transform-translate-x: 2.5rem;
  }

  .xl\\:focus\\:translate-x-11:focus{
    --transform-translate-x: 2.75rem;
  }

  .xl\\:focus\\:translate-x-12:focus{
    --transform-translate-x: 3rem;
  }

  .xl\\:focus\\:translate-x-14:focus{
    --transform-translate-x: 3.5rem;
  }

  .xl\\:focus\\:translate-x-15:focus{
    --transform-translate-x: 3.75rem;
  }

  .xl\\:focus\\:translate-x-16:focus{
    --transform-translate-x: 4rem;
  }

  .xl\\:focus\\:translate-x-18:focus{
    --transform-translate-x: 4.5rem;
  }

  .xl\\:focus\\:translate-x-20:focus{
    --transform-translate-x: 5rem;
  }

  .xl\\:focus\\:translate-x-22:focus{
    --transform-translate-x: 5.5rem;
  }

  .xl\\:focus\\:translate-x-23:focus{
    --transform-translate-x: 5.75rem;
  }

  .xl\\:focus\\:translate-x-24:focus{
    --transform-translate-x: 6rem;
  }

  .xl\\:focus\\:translate-x-25:focus{
    --transform-translate-x: 6.25rem;
  }

  .xl\\:focus\\:translate-x-26:focus{
    --transform-translate-x: 6.5rem;
  }

  .xl\\:focus\\:translate-x-28:focus{
    --transform-translate-x: 7rem;
  }

  .xl\\:focus\\:translate-x-30:focus{
    --transform-translate-x: 7.5rem;
  }

  .xl\\:focus\\:translate-x-32:focus{
    --transform-translate-x: 8rem;
  }

  .xl\\:focus\\:translate-x-34:focus{
    --transform-translate-x: 8.5rem;
  }

  .xl\\:focus\\:translate-x-40:focus{
    --transform-translate-x: 10rem;
  }

  .xl\\:focus\\:translate-x-42:focus{
    --transform-translate-x: 10.5rem;
  }

  .xl\\:focus\\:translate-x-44:focus{
    --transform-translate-x: 11rem;
  }

  .xl\\:focus\\:translate-x-48:focus{
    --transform-translate-x: 12rem;
  }

  .xl\\:focus\\:translate-x-52:focus{
    --transform-translate-x: 13rem;
  }

  .xl\\:focus\\:translate-x-54:focus{
    --transform-translate-x: 13.5rem;
  }

  .xl\\:focus\\:translate-x-56:focus{
    --transform-translate-x: 14rem;
  }

  .xl\\:focus\\:translate-x-60:focus{
    --transform-translate-x: 15rem;
  }

  .xl\\:focus\\:translate-x-64:focus{
    --transform-translate-x: 16rem;
  }

  .xl\\:focus\\:translate-x-68:focus{
    --transform-translate-x: 17rem;
  }

  .xl\\:focus\\:translate-x-72:focus{
    --transform-translate-x: 18rem;
  }

  .xl\\:focus\\:translate-x-74:focus{
    --transform-translate-x: 18.5rem;
  }

  .xl\\:focus\\:translate-x-76:focus{
    --transform-translate-x: 19rem;
  }

  .xl\\:focus\\:translate-x-78:focus{
    --transform-translate-x: 19.5rem;
  }

  .xl\\:focus\\:translate-x-80:focus{
    --transform-translate-x: 20rem;
  }

  .xl\\:focus\\:translate-x-82:focus{
    --transform-translate-x: 20.5rem;
  }

  .xl\\:focus\\:translate-x-84:focus{
    --transform-translate-x: 21rem;
  }

  .xl\\:focus\\:translate-x-88:focus{
    --transform-translate-x: 22rem;
  }

  .xl\\:focus\\:translate-x-92:focus{
    --transform-translate-x: 23rem;
  }

  .xl\\:focus\\:translate-x-96:focus{
    --transform-translate-x: 24rem;
  }

  .xl\\:focus\\:translate-x-98:focus{
    --transform-translate-x: 24.5rem;
  }

  .xl\\:focus\\:translate-x-100:focus{
    --transform-translate-x: 25rem;
  }

  .xl\\:focus\\:translate-x-104:focus{
    --transform-translate-x: 26rem;
  }

  .xl\\:focus\\:translate-x-112:focus{
    --transform-translate-x: 28rem;
  }

  .xl\\:focus\\:translate-x-124:focus{
    --transform-translate-x: 31rem;
  }

  .xl\\:focus\\:translate-x-128:focus{
    --transform-translate-x: 32rem;
  }

  .xl\\:focus\\:translate-x-140:focus{
    --transform-translate-x: 35rem;
  }

  .xl\\:focus\\:translate-x-152:focus{
    --transform-translate-x: 38rem;
  }

  .xl\\:focus\\:translate-x-160:focus{
    --transform-translate-x: 40rem;
  }

  .xl\\:focus\\:translate-x-162:focus{
    --transform-translate-x: 41rem;
  }

  .xl\\:focus\\:translate-x-192:focus{
    --transform-translate-x: 48rem;
  }

  .xl\\:focus\\:translate-x-208:focus{
    --transform-translate-x: 52rem;
  }

  .xl\\:focus\\:translate-x-224:focus{
    --transform-translate-x: 56rem;
  }

  .xl\\:focus\\:translate-x-256:focus{
    --transform-translate-x: 64rem;
  }

  .xl\\:focus\\:translate-x-px:focus{
    --transform-translate-x: 1px;
  }

  .xl\\:focus\\:-translate-x-1:focus{
    --transform-translate-x: -0.25rem;
  }

  .xl\\:focus\\:-translate-x-2:focus{
    --transform-translate-x: -0.5rem;
  }

  .xl\\:focus\\:-translate-x-3:focus{
    --transform-translate-x: -0.75rem;
  }

  .xl\\:focus\\:-translate-x-4:focus{
    --transform-translate-x: -1rem;
  }

  .xl\\:focus\\:-translate-x-5:focus{
    --transform-translate-x: -1.25rem;
  }

  .xl\\:focus\\:-translate-x-6:focus{
    --transform-translate-x: -1.5rem;
  }

  .xl\\:focus\\:-translate-x-7:focus{
    --transform-translate-x: -1.75rem;
  }

  .xl\\:focus\\:-translate-x-8:focus{
    --transform-translate-x: -2rem;
  }

  .xl\\:focus\\:-translate-x-9:focus{
    --transform-translate-x: -2.25rem;
  }

  .xl\\:focus\\:-translate-x-10:focus{
    --transform-translate-x: -2.5rem;
  }

  .xl\\:focus\\:-translate-x-11:focus{
    --transform-translate-x: -2.75rem;
  }

  .xl\\:focus\\:-translate-x-12:focus{
    --transform-translate-x: -3rem;
  }

  .xl\\:focus\\:-translate-x-14:focus{
    --transform-translate-x: -3.5rem;
  }

  .xl\\:focus\\:-translate-x-15:focus{
    --transform-translate-x: -3.75rem;
  }

  .xl\\:focus\\:-translate-x-16:focus{
    --transform-translate-x: -4rem;
  }

  .xl\\:focus\\:-translate-x-18:focus{
    --transform-translate-x: -4.5rem;
  }

  .xl\\:focus\\:-translate-x-20:focus{
    --transform-translate-x: -5rem;
  }

  .xl\\:focus\\:-translate-x-22:focus{
    --transform-translate-x: -5.5rem;
  }

  .xl\\:focus\\:-translate-x-23:focus{
    --transform-translate-x: -5.75rem;
  }

  .xl\\:focus\\:-translate-x-24:focus{
    --transform-translate-x: -6rem;
  }

  .xl\\:focus\\:-translate-x-25:focus{
    --transform-translate-x: -6.25rem;
  }

  .xl\\:focus\\:-translate-x-26:focus{
    --transform-translate-x: -6.5rem;
  }

  .xl\\:focus\\:-translate-x-28:focus{
    --transform-translate-x: -7rem;
  }

  .xl\\:focus\\:-translate-x-30:focus{
    --transform-translate-x: -7.5rem;
  }

  .xl\\:focus\\:-translate-x-32:focus{
    --transform-translate-x: -8rem;
  }

  .xl\\:focus\\:-translate-x-34:focus{
    --transform-translate-x: -8.5rem;
  }

  .xl\\:focus\\:-translate-x-40:focus{
    --transform-translate-x: -10rem;
  }

  .xl\\:focus\\:-translate-x-42:focus{
    --transform-translate-x: -10.5rem;
  }

  .xl\\:focus\\:-translate-x-44:focus{
    --transform-translate-x: -11rem;
  }

  .xl\\:focus\\:-translate-x-48:focus{
    --transform-translate-x: -12rem;
  }

  .xl\\:focus\\:-translate-x-52:focus{
    --transform-translate-x: -13rem;
  }

  .xl\\:focus\\:-translate-x-54:focus{
    --transform-translate-x: -13.5rem;
  }

  .xl\\:focus\\:-translate-x-56:focus{
    --transform-translate-x: -14rem;
  }

  .xl\\:focus\\:-translate-x-60:focus{
    --transform-translate-x: -15rem;
  }

  .xl\\:focus\\:-translate-x-64:focus{
    --transform-translate-x: -16rem;
  }

  .xl\\:focus\\:-translate-x-68:focus{
    --transform-translate-x: -17rem;
  }

  .xl\\:focus\\:-translate-x-72:focus{
    --transform-translate-x: -18rem;
  }

  .xl\\:focus\\:-translate-x-74:focus{
    --transform-translate-x: -18.5rem;
  }

  .xl\\:focus\\:-translate-x-76:focus{
    --transform-translate-x: -19rem;
  }

  .xl\\:focus\\:-translate-x-78:focus{
    --transform-translate-x: -19.5rem;
  }

  .xl\\:focus\\:-translate-x-80:focus{
    --transform-translate-x: -20rem;
  }

  .xl\\:focus\\:-translate-x-82:focus{
    --transform-translate-x: -20.5rem;
  }

  .xl\\:focus\\:-translate-x-84:focus{
    --transform-translate-x: -21rem;
  }

  .xl\\:focus\\:-translate-x-88:focus{
    --transform-translate-x: -22rem;
  }

  .xl\\:focus\\:-translate-x-92:focus{
    --transform-translate-x: -23rem;
  }

  .xl\\:focus\\:-translate-x-96:focus{
    --transform-translate-x: -24rem;
  }

  .xl\\:focus\\:-translate-x-98:focus{
    --transform-translate-x: -24.5rem;
  }

  .xl\\:focus\\:-translate-x-100:focus{
    --transform-translate-x: -25rem;
  }

  .xl\\:focus\\:-translate-x-104:focus{
    --transform-translate-x: -26rem;
  }

  .xl\\:focus\\:-translate-x-112:focus{
    --transform-translate-x: -28rem;
  }

  .xl\\:focus\\:-translate-x-124:focus{
    --transform-translate-x: -31rem;
  }

  .xl\\:focus\\:-translate-x-128:focus{
    --transform-translate-x: -32rem;
  }

  .xl\\:focus\\:-translate-x-140:focus{
    --transform-translate-x: -35rem;
  }

  .xl\\:focus\\:-translate-x-152:focus{
    --transform-translate-x: -38rem;
  }

  .xl\\:focus\\:-translate-x-160:focus{
    --transform-translate-x: -40rem;
  }

  .xl\\:focus\\:-translate-x-162:focus{
    --transform-translate-x: -41rem;
  }

  .xl\\:focus\\:-translate-x-192:focus{
    --transform-translate-x: -48rem;
  }

  .xl\\:focus\\:-translate-x-208:focus{
    --transform-translate-x: -52rem;
  }

  .xl\\:focus\\:-translate-x-224:focus{
    --transform-translate-x: -56rem;
  }

  .xl\\:focus\\:-translate-x-256:focus{
    --transform-translate-x: -64rem;
  }

  .xl\\:focus\\:-translate-x-px:focus{
    --transform-translate-x: -1px;
  }

  .xl\\:focus\\:-translate-x-full:focus{
    --transform-translate-x: -100%;
  }

  .xl\\:focus\\:-translate-x-1\\/2:focus{
    --transform-translate-x: -50%;
  }

  .xl\\:focus\\:translate-x-1\\/2:focus{
    --transform-translate-x: 50%;
  }

  .xl\\:focus\\:translate-x-full:focus{
    --transform-translate-x: 100%;
  }

  .xl\\:focus\\:translate-y-0:focus{
    --transform-translate-y: 0;
  }

  .xl\\:focus\\:translate-y-1:focus{
    --transform-translate-y: 0.25rem;
  }

  .xl\\:focus\\:translate-y-2:focus{
    --transform-translate-y: 0.5rem;
  }

  .xl\\:focus\\:translate-y-3:focus{
    --transform-translate-y: 0.75rem;
  }

  .xl\\:focus\\:translate-y-4:focus{
    --transform-translate-y: 1rem;
  }

  .xl\\:focus\\:translate-y-5:focus{
    --transform-translate-y: 1.25rem;
  }

  .xl\\:focus\\:translate-y-6:focus{
    --transform-translate-y: 1.5rem;
  }

  .xl\\:focus\\:translate-y-7:focus{
    --transform-translate-y: 1.75rem;
  }

  .xl\\:focus\\:translate-y-8:focus{
    --transform-translate-y: 2rem;
  }

  .xl\\:focus\\:translate-y-9:focus{
    --transform-translate-y: 2.25rem;
  }

  .xl\\:focus\\:translate-y-10:focus{
    --transform-translate-y: 2.5rem;
  }

  .xl\\:focus\\:translate-y-11:focus{
    --transform-translate-y: 2.75rem;
  }

  .xl\\:focus\\:translate-y-12:focus{
    --transform-translate-y: 3rem;
  }

  .xl\\:focus\\:translate-y-14:focus{
    --transform-translate-y: 3.5rem;
  }

  .xl\\:focus\\:translate-y-15:focus{
    --transform-translate-y: 3.75rem;
  }

  .xl\\:focus\\:translate-y-16:focus{
    --transform-translate-y: 4rem;
  }

  .xl\\:focus\\:translate-y-18:focus{
    --transform-translate-y: 4.5rem;
  }

  .xl\\:focus\\:translate-y-20:focus{
    --transform-translate-y: 5rem;
  }

  .xl\\:focus\\:translate-y-22:focus{
    --transform-translate-y: 5.5rem;
  }

  .xl\\:focus\\:translate-y-23:focus{
    --transform-translate-y: 5.75rem;
  }

  .xl\\:focus\\:translate-y-24:focus{
    --transform-translate-y: 6rem;
  }

  .xl\\:focus\\:translate-y-25:focus{
    --transform-translate-y: 6.25rem;
  }

  .xl\\:focus\\:translate-y-26:focus{
    --transform-translate-y: 6.5rem;
  }

  .xl\\:focus\\:translate-y-28:focus{
    --transform-translate-y: 7rem;
  }

  .xl\\:focus\\:translate-y-30:focus{
    --transform-translate-y: 7.5rem;
  }

  .xl\\:focus\\:translate-y-32:focus{
    --transform-translate-y: 8rem;
  }

  .xl\\:focus\\:translate-y-34:focus{
    --transform-translate-y: 8.5rem;
  }

  .xl\\:focus\\:translate-y-40:focus{
    --transform-translate-y: 10rem;
  }

  .xl\\:focus\\:translate-y-42:focus{
    --transform-translate-y: 10.5rem;
  }

  .xl\\:focus\\:translate-y-44:focus{
    --transform-translate-y: 11rem;
  }

  .xl\\:focus\\:translate-y-48:focus{
    --transform-translate-y: 12rem;
  }

  .xl\\:focus\\:translate-y-52:focus{
    --transform-translate-y: 13rem;
  }

  .xl\\:focus\\:translate-y-54:focus{
    --transform-translate-y: 13.5rem;
  }

  .xl\\:focus\\:translate-y-56:focus{
    --transform-translate-y: 14rem;
  }

  .xl\\:focus\\:translate-y-60:focus{
    --transform-translate-y: 15rem;
  }

  .xl\\:focus\\:translate-y-64:focus{
    --transform-translate-y: 16rem;
  }

  .xl\\:focus\\:translate-y-68:focus{
    --transform-translate-y: 17rem;
  }

  .xl\\:focus\\:translate-y-72:focus{
    --transform-translate-y: 18rem;
  }

  .xl\\:focus\\:translate-y-74:focus{
    --transform-translate-y: 18.5rem;
  }

  .xl\\:focus\\:translate-y-76:focus{
    --transform-translate-y: 19rem;
  }

  .xl\\:focus\\:translate-y-78:focus{
    --transform-translate-y: 19.5rem;
  }

  .xl\\:focus\\:translate-y-80:focus{
    --transform-translate-y: 20rem;
  }

  .xl\\:focus\\:translate-y-82:focus{
    --transform-translate-y: 20.5rem;
  }

  .xl\\:focus\\:translate-y-84:focus{
    --transform-translate-y: 21rem;
  }

  .xl\\:focus\\:translate-y-88:focus{
    --transform-translate-y: 22rem;
  }

  .xl\\:focus\\:translate-y-92:focus{
    --transform-translate-y: 23rem;
  }

  .xl\\:focus\\:translate-y-96:focus{
    --transform-translate-y: 24rem;
  }

  .xl\\:focus\\:translate-y-98:focus{
    --transform-translate-y: 24.5rem;
  }

  .xl\\:focus\\:translate-y-100:focus{
    --transform-translate-y: 25rem;
  }

  .xl\\:focus\\:translate-y-104:focus{
    --transform-translate-y: 26rem;
  }

  .xl\\:focus\\:translate-y-112:focus{
    --transform-translate-y: 28rem;
  }

  .xl\\:focus\\:translate-y-124:focus{
    --transform-translate-y: 31rem;
  }

  .xl\\:focus\\:translate-y-128:focus{
    --transform-translate-y: 32rem;
  }

  .xl\\:focus\\:translate-y-140:focus{
    --transform-translate-y: 35rem;
  }

  .xl\\:focus\\:translate-y-152:focus{
    --transform-translate-y: 38rem;
  }

  .xl\\:focus\\:translate-y-160:focus{
    --transform-translate-y: 40rem;
  }

  .xl\\:focus\\:translate-y-162:focus{
    --transform-translate-y: 41rem;
  }

  .xl\\:focus\\:translate-y-192:focus{
    --transform-translate-y: 48rem;
  }

  .xl\\:focus\\:translate-y-208:focus{
    --transform-translate-y: 52rem;
  }

  .xl\\:focus\\:translate-y-224:focus{
    --transform-translate-y: 56rem;
  }

  .xl\\:focus\\:translate-y-256:focus{
    --transform-translate-y: 64rem;
  }

  .xl\\:focus\\:translate-y-px:focus{
    --transform-translate-y: 1px;
  }

  .xl\\:focus\\:-translate-y-1:focus{
    --transform-translate-y: -0.25rem;
  }

  .xl\\:focus\\:-translate-y-2:focus{
    --transform-translate-y: -0.5rem;
  }

  .xl\\:focus\\:-translate-y-3:focus{
    --transform-translate-y: -0.75rem;
  }

  .xl\\:focus\\:-translate-y-4:focus{
    --transform-translate-y: -1rem;
  }

  .xl\\:focus\\:-translate-y-5:focus{
    --transform-translate-y: -1.25rem;
  }

  .xl\\:focus\\:-translate-y-6:focus{
    --transform-translate-y: -1.5rem;
  }

  .xl\\:focus\\:-translate-y-7:focus{
    --transform-translate-y: -1.75rem;
  }

  .xl\\:focus\\:-translate-y-8:focus{
    --transform-translate-y: -2rem;
  }

  .xl\\:focus\\:-translate-y-9:focus{
    --transform-translate-y: -2.25rem;
  }

  .xl\\:focus\\:-translate-y-10:focus{
    --transform-translate-y: -2.5rem;
  }

  .xl\\:focus\\:-translate-y-11:focus{
    --transform-translate-y: -2.75rem;
  }

  .xl\\:focus\\:-translate-y-12:focus{
    --transform-translate-y: -3rem;
  }

  .xl\\:focus\\:-translate-y-14:focus{
    --transform-translate-y: -3.5rem;
  }

  .xl\\:focus\\:-translate-y-15:focus{
    --transform-translate-y: -3.75rem;
  }

  .xl\\:focus\\:-translate-y-16:focus{
    --transform-translate-y: -4rem;
  }

  .xl\\:focus\\:-translate-y-18:focus{
    --transform-translate-y: -4.5rem;
  }

  .xl\\:focus\\:-translate-y-20:focus{
    --transform-translate-y: -5rem;
  }

  .xl\\:focus\\:-translate-y-22:focus{
    --transform-translate-y: -5.5rem;
  }

  .xl\\:focus\\:-translate-y-23:focus{
    --transform-translate-y: -5.75rem;
  }

  .xl\\:focus\\:-translate-y-24:focus{
    --transform-translate-y: -6rem;
  }

  .xl\\:focus\\:-translate-y-25:focus{
    --transform-translate-y: -6.25rem;
  }

  .xl\\:focus\\:-translate-y-26:focus{
    --transform-translate-y: -6.5rem;
  }

  .xl\\:focus\\:-translate-y-28:focus{
    --transform-translate-y: -7rem;
  }

  .xl\\:focus\\:-translate-y-30:focus{
    --transform-translate-y: -7.5rem;
  }

  .xl\\:focus\\:-translate-y-32:focus{
    --transform-translate-y: -8rem;
  }

  .xl\\:focus\\:-translate-y-34:focus{
    --transform-translate-y: -8.5rem;
  }

  .xl\\:focus\\:-translate-y-40:focus{
    --transform-translate-y: -10rem;
  }

  .xl\\:focus\\:-translate-y-42:focus{
    --transform-translate-y: -10.5rem;
  }

  .xl\\:focus\\:-translate-y-44:focus{
    --transform-translate-y: -11rem;
  }

  .xl\\:focus\\:-translate-y-48:focus{
    --transform-translate-y: -12rem;
  }

  .xl\\:focus\\:-translate-y-52:focus{
    --transform-translate-y: -13rem;
  }

  .xl\\:focus\\:-translate-y-54:focus{
    --transform-translate-y: -13.5rem;
  }

  .xl\\:focus\\:-translate-y-56:focus{
    --transform-translate-y: -14rem;
  }

  .xl\\:focus\\:-translate-y-60:focus{
    --transform-translate-y: -15rem;
  }

  .xl\\:focus\\:-translate-y-64:focus{
    --transform-translate-y: -16rem;
  }

  .xl\\:focus\\:-translate-y-68:focus{
    --transform-translate-y: -17rem;
  }

  .xl\\:focus\\:-translate-y-72:focus{
    --transform-translate-y: -18rem;
  }

  .xl\\:focus\\:-translate-y-74:focus{
    --transform-translate-y: -18.5rem;
  }

  .xl\\:focus\\:-translate-y-76:focus{
    --transform-translate-y: -19rem;
  }

  .xl\\:focus\\:-translate-y-78:focus{
    --transform-translate-y: -19.5rem;
  }

  .xl\\:focus\\:-translate-y-80:focus{
    --transform-translate-y: -20rem;
  }

  .xl\\:focus\\:-translate-y-82:focus{
    --transform-translate-y: -20.5rem;
  }

  .xl\\:focus\\:-translate-y-84:focus{
    --transform-translate-y: -21rem;
  }

  .xl\\:focus\\:-translate-y-88:focus{
    --transform-translate-y: -22rem;
  }

  .xl\\:focus\\:-translate-y-92:focus{
    --transform-translate-y: -23rem;
  }

  .xl\\:focus\\:-translate-y-96:focus{
    --transform-translate-y: -24rem;
  }

  .xl\\:focus\\:-translate-y-98:focus{
    --transform-translate-y: -24.5rem;
  }

  .xl\\:focus\\:-translate-y-100:focus{
    --transform-translate-y: -25rem;
  }

  .xl\\:focus\\:-translate-y-104:focus{
    --transform-translate-y: -26rem;
  }

  .xl\\:focus\\:-translate-y-112:focus{
    --transform-translate-y: -28rem;
  }

  .xl\\:focus\\:-translate-y-124:focus{
    --transform-translate-y: -31rem;
  }

  .xl\\:focus\\:-translate-y-128:focus{
    --transform-translate-y: -32rem;
  }

  .xl\\:focus\\:-translate-y-140:focus{
    --transform-translate-y: -35rem;
  }

  .xl\\:focus\\:-translate-y-152:focus{
    --transform-translate-y: -38rem;
  }

  .xl\\:focus\\:-translate-y-160:focus{
    --transform-translate-y: -40rem;
  }

  .xl\\:focus\\:-translate-y-162:focus{
    --transform-translate-y: -41rem;
  }

  .xl\\:focus\\:-translate-y-192:focus{
    --transform-translate-y: -48rem;
  }

  .xl\\:focus\\:-translate-y-208:focus{
    --transform-translate-y: -52rem;
  }

  .xl\\:focus\\:-translate-y-224:focus{
    --transform-translate-y: -56rem;
  }

  .xl\\:focus\\:-translate-y-256:focus{
    --transform-translate-y: -64rem;
  }

  .xl\\:focus\\:-translate-y-px:focus{
    --transform-translate-y: -1px;
  }

  .xl\\:focus\\:-translate-y-full:focus{
    --transform-translate-y: -100%;
  }

  .xl\\:focus\\:-translate-y-1\\/2:focus{
    --transform-translate-y: -50%;
  }

  .xl\\:focus\\:translate-y-1\\/2:focus{
    --transform-translate-y: 50%;
  }

  .xl\\:focus\\:translate-y-full:focus{
    --transform-translate-y: 100%;
  }

  .xl\\:skew-x-0{
    --transform-skew-x: 0;
  }

  .xl\\:skew-x-1{
    --transform-skew-x: 1deg;
  }

  .xl\\:skew-x-2{
    --transform-skew-x: 2deg;
  }

  .xl\\:skew-x-3{
    --transform-skew-x: 3deg;
  }

  .xl\\:skew-x-6{
    --transform-skew-x: 6deg;
  }

  .xl\\:skew-x-12{
    --transform-skew-x: 12deg;
  }

  .xl\\:-skew-x-12{
    --transform-skew-x: -12deg;
  }

  .xl\\:-skew-x-6{
    --transform-skew-x: -6deg;
  }

  .xl\\:-skew-x-3{
    --transform-skew-x: -3deg;
  }

  .xl\\:-skew-x-2{
    --transform-skew-x: -2deg;
  }

  .xl\\:-skew-x-1{
    --transform-skew-x: -1deg;
  }

  .xl\\:skew-y-0{
    --transform-skew-y: 0;
  }

  .xl\\:skew-y-1{
    --transform-skew-y: 1deg;
  }

  .xl\\:skew-y-2{
    --transform-skew-y: 2deg;
  }

  .xl\\:skew-y-3{
    --transform-skew-y: 3deg;
  }

  .xl\\:skew-y-6{
    --transform-skew-y: 6deg;
  }

  .xl\\:skew-y-12{
    --transform-skew-y: 12deg;
  }

  .xl\\:-skew-y-12{
    --transform-skew-y: -12deg;
  }

  .xl\\:-skew-y-6{
    --transform-skew-y: -6deg;
  }

  .xl\\:-skew-y-3{
    --transform-skew-y: -3deg;
  }

  .xl\\:-skew-y-2{
    --transform-skew-y: -2deg;
  }

  .xl\\:-skew-y-1{
    --transform-skew-y: -1deg;
  }

  .xl\\:hover\\:skew-x-0:hover{
    --transform-skew-x: 0;
  }

  .xl\\:hover\\:skew-x-1:hover{
    --transform-skew-x: 1deg;
  }

  .xl\\:hover\\:skew-x-2:hover{
    --transform-skew-x: 2deg;
  }

  .xl\\:hover\\:skew-x-3:hover{
    --transform-skew-x: 3deg;
  }

  .xl\\:hover\\:skew-x-6:hover{
    --transform-skew-x: 6deg;
  }

  .xl\\:hover\\:skew-x-12:hover{
    --transform-skew-x: 12deg;
  }

  .xl\\:hover\\:-skew-x-12:hover{
    --transform-skew-x: -12deg;
  }

  .xl\\:hover\\:-skew-x-6:hover{
    --transform-skew-x: -6deg;
  }

  .xl\\:hover\\:-skew-x-3:hover{
    --transform-skew-x: -3deg;
  }

  .xl\\:hover\\:-skew-x-2:hover{
    --transform-skew-x: -2deg;
  }

  .xl\\:hover\\:-skew-x-1:hover{
    --transform-skew-x: -1deg;
  }

  .xl\\:hover\\:skew-y-0:hover{
    --transform-skew-y: 0;
  }

  .xl\\:hover\\:skew-y-1:hover{
    --transform-skew-y: 1deg;
  }

  .xl\\:hover\\:skew-y-2:hover{
    --transform-skew-y: 2deg;
  }

  .xl\\:hover\\:skew-y-3:hover{
    --transform-skew-y: 3deg;
  }

  .xl\\:hover\\:skew-y-6:hover{
    --transform-skew-y: 6deg;
  }

  .xl\\:hover\\:skew-y-12:hover{
    --transform-skew-y: 12deg;
  }

  .xl\\:hover\\:-skew-y-12:hover{
    --transform-skew-y: -12deg;
  }

  .xl\\:hover\\:-skew-y-6:hover{
    --transform-skew-y: -6deg;
  }

  .xl\\:hover\\:-skew-y-3:hover{
    --transform-skew-y: -3deg;
  }

  .xl\\:hover\\:-skew-y-2:hover{
    --transform-skew-y: -2deg;
  }

  .xl\\:hover\\:-skew-y-1:hover{
    --transform-skew-y: -1deg;
  }

  .xl\\:focus\\:skew-x-0:focus{
    --transform-skew-x: 0;
  }

  .xl\\:focus\\:skew-x-1:focus{
    --transform-skew-x: 1deg;
  }

  .xl\\:focus\\:skew-x-2:focus{
    --transform-skew-x: 2deg;
  }

  .xl\\:focus\\:skew-x-3:focus{
    --transform-skew-x: 3deg;
  }

  .xl\\:focus\\:skew-x-6:focus{
    --transform-skew-x: 6deg;
  }

  .xl\\:focus\\:skew-x-12:focus{
    --transform-skew-x: 12deg;
  }

  .xl\\:focus\\:-skew-x-12:focus{
    --transform-skew-x: -12deg;
  }

  .xl\\:focus\\:-skew-x-6:focus{
    --transform-skew-x: -6deg;
  }

  .xl\\:focus\\:-skew-x-3:focus{
    --transform-skew-x: -3deg;
  }

  .xl\\:focus\\:-skew-x-2:focus{
    --transform-skew-x: -2deg;
  }

  .xl\\:focus\\:-skew-x-1:focus{
    --transform-skew-x: -1deg;
  }

  .xl\\:focus\\:skew-y-0:focus{
    --transform-skew-y: 0;
  }

  .xl\\:focus\\:skew-y-1:focus{
    --transform-skew-y: 1deg;
  }

  .xl\\:focus\\:skew-y-2:focus{
    --transform-skew-y: 2deg;
  }

  .xl\\:focus\\:skew-y-3:focus{
    --transform-skew-y: 3deg;
  }

  .xl\\:focus\\:skew-y-6:focus{
    --transform-skew-y: 6deg;
  }

  .xl\\:focus\\:skew-y-12:focus{
    --transform-skew-y: 12deg;
  }

  .xl\\:focus\\:-skew-y-12:focus{
    --transform-skew-y: -12deg;
  }

  .xl\\:focus\\:-skew-y-6:focus{
    --transform-skew-y: -6deg;
  }

  .xl\\:focus\\:-skew-y-3:focus{
    --transform-skew-y: -3deg;
  }

  .xl\\:focus\\:-skew-y-2:focus{
    --transform-skew-y: -2deg;
  }

  .xl\\:focus\\:-skew-y-1:focus{
    --transform-skew-y: -1deg;
  }

  .xl\\:transition-none{
    transition-property: none;
  }

  .xl\\:transition-all{
    transition-property: all;
  }

  .xl\\:transition{
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  }

  .xl\\:transition-colors{
    transition-property: background-color, border-color, color, fill, stroke;
  }

  .xl\\:transition-opacity{
    transition-property: opacity;
  }

  .xl\\:transition-shadow{
    transition-property: box-shadow;
  }

  .xl\\:transition-transform{
    transition-property: transform;
  }

  .xl\\:ease-linear{
    transition-timing-function: linear;
  }

  .xl\\:ease-in{
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  }

  .xl\\:ease-out{
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }

  .xl\\:ease-in-out{
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }

  .xl\\:duration-75{
    transition-duration: 75ms;
  }

  .xl\\:duration-100{
    transition-duration: 100ms;
  }

  .xl\\:duration-150{
    transition-duration: 150ms;
  }

  .xl\\:duration-200{
    transition-duration: 200ms;
  }

  .xl\\:duration-300{
    transition-duration: 300ms;
  }

  .xl\\:duration-500{
    transition-duration: 500ms;
  }

  .xl\\:duration-700{
    transition-duration: 700ms;
  }

  .xl\\:duration-1000{
    transition-duration: 1000ms;
  }

  .xl\\:delay-75{
    transition-delay: 75ms;
  }

  .xl\\:delay-100{
    transition-delay: 100ms;
  }

  .xl\\:delay-150{
    transition-delay: 150ms;
  }

  .xl\\:delay-200{
    transition-delay: 200ms;
  }

  .xl\\:delay-300{
    transition-delay: 300ms;
  }

  .xl\\:delay-500{
    transition-delay: 500ms;
  }

  .xl\\:delay-700{
    transition-delay: 700ms;
  }

  .xl\\:delay-1000{
    transition-delay: 1000ms;
  }

  .xl\\:animate-none{
    animation: none;
  }

  .xl\\:animate-spin{
    animation: spin 1s linear infinite;
  }

  .xl\\:animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }

  .xl\\:animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  .xl\\:animate-bounce{
    animation: bounce 1s infinite;
  }

  [dir="ltr"] .xl\\:ps-0{
    padding-left: 0;
  }

  [dir="rtl"] .xl\\:ps-0{
    padding-right: 0;
  }

  [dir="ltr"] .xl\\:pe-0{
    padding-right: 0;
  }

  [dir="rtl"] .xl\\:pe-0{
    padding-left: 0;
  }

  [dir="ltr"] .xl\\:ps-1{
    padding-left: 0.25rem;
  }

  [dir="rtl"] .xl\\:ps-1{
    padding-right: 0.25rem;
  }

  [dir="ltr"] .xl\\:pe-1{
    padding-right: 0.25rem;
  }

  [dir="rtl"] .xl\\:pe-1{
    padding-left: 0.25rem;
  }

  [dir="ltr"] .xl\\:ps-2{
    padding-left: 0.5rem;
  }

  [dir="rtl"] .xl\\:ps-2{
    padding-right: 0.5rem;
  }

  [dir="ltr"] .xl\\:pe-2{
    padding-right: 0.5rem;
  }

  [dir="rtl"] .xl\\:pe-2{
    padding-left: 0.5rem;
  }

  [dir="ltr"] .xl\\:ps-3{
    padding-left: 0.75rem;
  }

  [dir="rtl"] .xl\\:ps-3{
    padding-right: 0.75rem;
  }

  [dir="ltr"] .xl\\:pe-3{
    padding-right: 0.75rem;
  }

  [dir="rtl"] .xl\\:pe-3{
    padding-left: 0.75rem;
  }

  [dir="ltr"] .xl\\:ps-4{
    padding-left: 1rem;
  }

  [dir="rtl"] .xl\\:ps-4{
    padding-right: 1rem;
  }

  [dir="ltr"] .xl\\:pe-4{
    padding-right: 1rem;
  }

  [dir="rtl"] .xl\\:pe-4{
    padding-left: 1rem;
  }

  [dir="ltr"] .xl\\:ps-5{
    padding-left: 1.25rem;
  }

  [dir="rtl"] .xl\\:ps-5{
    padding-right: 1.25rem;
  }

  [dir="ltr"] .xl\\:pe-5{
    padding-right: 1.25rem;
  }

  [dir="rtl"] .xl\\:pe-5{
    padding-left: 1.25rem;
  }

  [dir="ltr"] .xl\\:ps-6{
    padding-left: 1.5rem;
  }

  [dir="rtl"] .xl\\:ps-6{
    padding-right: 1.5rem;
  }

  [dir="ltr"] .xl\\:pe-6{
    padding-right: 1.5rem;
  }

  [dir="rtl"] .xl\\:pe-6{
    padding-left: 1.5rem;
  }

  [dir="ltr"] .xl\\:ps-7{
    padding-left: 1.75rem;
  }

  [dir="rtl"] .xl\\:ps-7{
    padding-right: 1.75rem;
  }

  [dir="ltr"] .xl\\:pe-7{
    padding-right: 1.75rem;
  }

  [dir="rtl"] .xl\\:pe-7{
    padding-left: 1.75rem;
  }

  [dir="ltr"] .xl\\:ps-8{
    padding-left: 2rem;
  }

  [dir="rtl"] .xl\\:ps-8{
    padding-right: 2rem;
  }

  [dir="ltr"] .xl\\:pe-8{
    padding-right: 2rem;
  }

  [dir="rtl"] .xl\\:pe-8{
    padding-left: 2rem;
  }

  [dir="ltr"] .xl\\:ps-9{
    padding-left: 2.25rem;
  }

  [dir="rtl"] .xl\\:ps-9{
    padding-right: 2.25rem;
  }

  [dir="ltr"] .xl\\:pe-9{
    padding-right: 2.25rem;
  }

  [dir="rtl"] .xl\\:pe-9{
    padding-left: 2.25rem;
  }

  [dir="ltr"] .xl\\:ps-10{
    padding-left: 2.5rem;
  }

  [dir="rtl"] .xl\\:ps-10{
    padding-right: 2.5rem;
  }

  [dir="ltr"] .xl\\:pe-10{
    padding-right: 2.5rem;
  }

  [dir="rtl"] .xl\\:pe-10{
    padding-left: 2.5rem;
  }

  [dir="ltr"] .xl\\:ps-11{
    padding-left: 2.75rem;
  }

  [dir="rtl"] .xl\\:ps-11{
    padding-right: 2.75rem;
  }

  [dir="ltr"] .xl\\:pe-11{
    padding-right: 2.75rem;
  }

  [dir="rtl"] .xl\\:pe-11{
    padding-left: 2.75rem;
  }

  [dir="ltr"] .xl\\:ps-12{
    padding-left: 3rem;
  }

  [dir="rtl"] .xl\\:ps-12{
    padding-right: 3rem;
  }

  [dir="ltr"] .xl\\:pe-12{
    padding-right: 3rem;
  }

  [dir="rtl"] .xl\\:pe-12{
    padding-left: 3rem;
  }

  [dir="ltr"] .xl\\:ps-14{
    padding-left: 3.5rem;
  }

  [dir="rtl"] .xl\\:ps-14{
    padding-right: 3.5rem;
  }

  [dir="ltr"] .xl\\:pe-14{
    padding-right: 3.5rem;
  }

  [dir="rtl"] .xl\\:pe-14{
    padding-left: 3.5rem;
  }

  [dir="ltr"] .xl\\:ps-15{
    padding-left: 3.75rem;
  }

  [dir="rtl"] .xl\\:ps-15{
    padding-right: 3.75rem;
  }

  [dir="ltr"] .xl\\:pe-15{
    padding-right: 3.75rem;
  }

  [dir="rtl"] .xl\\:pe-15{
    padding-left: 3.75rem;
  }

  [dir="ltr"] .xl\\:ps-16{
    padding-left: 4rem;
  }

  [dir="rtl"] .xl\\:ps-16{
    padding-right: 4rem;
  }

  [dir="ltr"] .xl\\:pe-16{
    padding-right: 4rem;
  }

  [dir="rtl"] .xl\\:pe-16{
    padding-left: 4rem;
  }

  [dir="ltr"] .xl\\:ps-18{
    padding-left: 4.5rem;
  }

  [dir="rtl"] .xl\\:ps-18{
    padding-right: 4.5rem;
  }

  [dir="ltr"] .xl\\:pe-18{
    padding-right: 4.5rem;
  }

  [dir="rtl"] .xl\\:pe-18{
    padding-left: 4.5rem;
  }

  [dir="ltr"] .xl\\:ps-20{
    padding-left: 5rem;
  }

  [dir="rtl"] .xl\\:ps-20{
    padding-right: 5rem;
  }

  [dir="ltr"] .xl\\:pe-20{
    padding-right: 5rem;
  }

  [dir="rtl"] .xl\\:pe-20{
    padding-left: 5rem;
  }

  [dir="ltr"] .xl\\:ps-22{
    padding-left: 5.5rem;
  }

  [dir="rtl"] .xl\\:ps-22{
    padding-right: 5.5rem;
  }

  [dir="ltr"] .xl\\:pe-22{
    padding-right: 5.5rem;
  }

  [dir="rtl"] .xl\\:pe-22{
    padding-left: 5.5rem;
  }

  [dir="ltr"] .xl\\:ps-23{
    padding-left: 5.75rem;
  }

  [dir="rtl"] .xl\\:ps-23{
    padding-right: 5.75rem;
  }

  [dir="ltr"] .xl\\:pe-23{
    padding-right: 5.75rem;
  }

  [dir="rtl"] .xl\\:pe-23{
    padding-left: 5.75rem;
  }

  [dir="ltr"] .xl\\:ps-24{
    padding-left: 6rem;
  }

  [dir="rtl"] .xl\\:ps-24{
    padding-right: 6rem;
  }

  [dir="ltr"] .xl\\:pe-24{
    padding-right: 6rem;
  }

  [dir="rtl"] .xl\\:pe-24{
    padding-left: 6rem;
  }

  [dir="ltr"] .xl\\:ps-25{
    padding-left: 6.25rem;
  }

  [dir="rtl"] .xl\\:ps-25{
    padding-right: 6.25rem;
  }

  [dir="ltr"] .xl\\:pe-25{
    padding-right: 6.25rem;
  }

  [dir="rtl"] .xl\\:pe-25{
    padding-left: 6.25rem;
  }

  [dir="ltr"] .xl\\:ps-26{
    padding-left: 6.5rem;
  }

  [dir="rtl"] .xl\\:ps-26{
    padding-right: 6.5rem;
  }

  [dir="ltr"] .xl\\:pe-26{
    padding-right: 6.5rem;
  }

  [dir="rtl"] .xl\\:pe-26{
    padding-left: 6.5rem;
  }

  [dir="ltr"] .xl\\:ps-28{
    padding-left: 7rem;
  }

  [dir="rtl"] .xl\\:ps-28{
    padding-right: 7rem;
  }

  [dir="ltr"] .xl\\:pe-28{
    padding-right: 7rem;
  }

  [dir="rtl"] .xl\\:pe-28{
    padding-left: 7rem;
  }

  [dir="ltr"] .xl\\:ps-30{
    padding-left: 7.5rem;
  }

  [dir="rtl"] .xl\\:ps-30{
    padding-right: 7.5rem;
  }

  [dir="ltr"] .xl\\:pe-30{
    padding-right: 7.5rem;
  }

  [dir="rtl"] .xl\\:pe-30{
    padding-left: 7.5rem;
  }

  [dir="ltr"] .xl\\:ps-32{
    padding-left: 8rem;
  }

  [dir="rtl"] .xl\\:ps-32{
    padding-right: 8rem;
  }

  [dir="ltr"] .xl\\:pe-32{
    padding-right: 8rem;
  }

  [dir="rtl"] .xl\\:pe-32{
    padding-left: 8rem;
  }

  [dir="ltr"] .xl\\:ps-34{
    padding-left: 8.5rem;
  }

  [dir="rtl"] .xl\\:ps-34{
    padding-right: 8.5rem;
  }

  [dir="ltr"] .xl\\:pe-34{
    padding-right: 8.5rem;
  }

  [dir="rtl"] .xl\\:pe-34{
    padding-left: 8.5rem;
  }

  [dir="ltr"] .xl\\:ps-40{
    padding-left: 10rem;
  }

  [dir="rtl"] .xl\\:ps-40{
    padding-right: 10rem;
  }

  [dir="ltr"] .xl\\:pe-40{
    padding-right: 10rem;
  }

  [dir="rtl"] .xl\\:pe-40{
    padding-left: 10rem;
  }

  [dir="ltr"] .xl\\:ps-42{
    padding-left: 10.5rem;
  }

  [dir="rtl"] .xl\\:ps-42{
    padding-right: 10.5rem;
  }

  [dir="ltr"] .xl\\:pe-42{
    padding-right: 10.5rem;
  }

  [dir="rtl"] .xl\\:pe-42{
    padding-left: 10.5rem;
  }

  [dir="ltr"] .xl\\:ps-44{
    padding-left: 11rem;
  }

  [dir="rtl"] .xl\\:ps-44{
    padding-right: 11rem;
  }

  [dir="ltr"] .xl\\:pe-44{
    padding-right: 11rem;
  }

  [dir="rtl"] .xl\\:pe-44{
    padding-left: 11rem;
  }

  [dir="ltr"] .xl\\:ps-48{
    padding-left: 12rem;
  }

  [dir="rtl"] .xl\\:ps-48{
    padding-right: 12rem;
  }

  [dir="ltr"] .xl\\:pe-48{
    padding-right: 12rem;
  }

  [dir="rtl"] .xl\\:pe-48{
    padding-left: 12rem;
  }

  [dir="ltr"] .xl\\:ps-52{
    padding-left: 13rem;
  }

  [dir="rtl"] .xl\\:ps-52{
    padding-right: 13rem;
  }

  [dir="ltr"] .xl\\:pe-52{
    padding-right: 13rem;
  }

  [dir="rtl"] .xl\\:pe-52{
    padding-left: 13rem;
  }

  [dir="ltr"] .xl\\:ps-54{
    padding-left: 13.5rem;
  }

  [dir="rtl"] .xl\\:ps-54{
    padding-right: 13.5rem;
  }

  [dir="ltr"] .xl\\:pe-54{
    padding-right: 13.5rem;
  }

  [dir="rtl"] .xl\\:pe-54{
    padding-left: 13.5rem;
  }

  [dir="ltr"] .xl\\:ps-56{
    padding-left: 14rem;
  }

  [dir="rtl"] .xl\\:ps-56{
    padding-right: 14rem;
  }

  [dir="ltr"] .xl\\:pe-56{
    padding-right: 14rem;
  }

  [dir="rtl"] .xl\\:pe-56{
    padding-left: 14rem;
  }

  [dir="ltr"] .xl\\:ps-60{
    padding-left: 15rem;
  }

  [dir="rtl"] .xl\\:ps-60{
    padding-right: 15rem;
  }

  [dir="ltr"] .xl\\:pe-60{
    padding-right: 15rem;
  }

  [dir="rtl"] .xl\\:pe-60{
    padding-left: 15rem;
  }

  [dir="ltr"] .xl\\:ps-64{
    padding-left: 16rem;
  }

  [dir="rtl"] .xl\\:ps-64{
    padding-right: 16rem;
  }

  [dir="ltr"] .xl\\:pe-64{
    padding-right: 16rem;
  }

  [dir="rtl"] .xl\\:pe-64{
    padding-left: 16rem;
  }

  [dir="ltr"] .xl\\:ps-68{
    padding-left: 17rem;
  }

  [dir="rtl"] .xl\\:ps-68{
    padding-right: 17rem;
  }

  [dir="ltr"] .xl\\:pe-68{
    padding-right: 17rem;
  }

  [dir="rtl"] .xl\\:pe-68{
    padding-left: 17rem;
  }

  [dir="ltr"] .xl\\:ps-72{
    padding-left: 18rem;
  }

  [dir="rtl"] .xl\\:ps-72{
    padding-right: 18rem;
  }

  [dir="ltr"] .xl\\:pe-72{
    padding-right: 18rem;
  }

  [dir="rtl"] .xl\\:pe-72{
    padding-left: 18rem;
  }

  [dir="ltr"] .xl\\:ps-74{
    padding-left: 18.5rem;
  }

  [dir="rtl"] .xl\\:ps-74{
    padding-right: 18.5rem;
  }

  [dir="ltr"] .xl\\:pe-74{
    padding-right: 18.5rem;
  }

  [dir="rtl"] .xl\\:pe-74{
    padding-left: 18.5rem;
  }

  [dir="ltr"] .xl\\:ps-76{
    padding-left: 19rem;
  }

  [dir="rtl"] .xl\\:ps-76{
    padding-right: 19rem;
  }

  [dir="ltr"] .xl\\:pe-76{
    padding-right: 19rem;
  }

  [dir="rtl"] .xl\\:pe-76{
    padding-left: 19rem;
  }

  [dir="ltr"] .xl\\:ps-78{
    padding-left: 19.5rem;
  }

  [dir="rtl"] .xl\\:ps-78{
    padding-right: 19.5rem;
  }

  [dir="ltr"] .xl\\:pe-78{
    padding-right: 19.5rem;
  }

  [dir="rtl"] .xl\\:pe-78{
    padding-left: 19.5rem;
  }

  [dir="ltr"] .xl\\:ps-80{
    padding-left: 20rem;
  }

  [dir="rtl"] .xl\\:ps-80{
    padding-right: 20rem;
  }

  [dir="ltr"] .xl\\:pe-80{
    padding-right: 20rem;
  }

  [dir="rtl"] .xl\\:pe-80{
    padding-left: 20rem;
  }

  [dir="ltr"] .xl\\:ps-82{
    padding-left: 20.5rem;
  }

  [dir="rtl"] .xl\\:ps-82{
    padding-right: 20.5rem;
  }

  [dir="ltr"] .xl\\:pe-82{
    padding-right: 20.5rem;
  }

  [dir="rtl"] .xl\\:pe-82{
    padding-left: 20.5rem;
  }

  [dir="ltr"] .xl\\:ps-84{
    padding-left: 21rem;
  }

  [dir="rtl"] .xl\\:ps-84{
    padding-right: 21rem;
  }

  [dir="ltr"] .xl\\:pe-84{
    padding-right: 21rem;
  }

  [dir="rtl"] .xl\\:pe-84{
    padding-left: 21rem;
  }

  [dir="ltr"] .xl\\:ps-88{
    padding-left: 22rem;
  }

  [dir="rtl"] .xl\\:ps-88{
    padding-right: 22rem;
  }

  [dir="ltr"] .xl\\:pe-88{
    padding-right: 22rem;
  }

  [dir="rtl"] .xl\\:pe-88{
    padding-left: 22rem;
  }

  [dir="ltr"] .xl\\:ps-92{
    padding-left: 23rem;
  }

  [dir="rtl"] .xl\\:ps-92{
    padding-right: 23rem;
  }

  [dir="ltr"] .xl\\:pe-92{
    padding-right: 23rem;
  }

  [dir="rtl"] .xl\\:pe-92{
    padding-left: 23rem;
  }

  [dir="ltr"] .xl\\:ps-96{
    padding-left: 24rem;
  }

  [dir="rtl"] .xl\\:ps-96{
    padding-right: 24rem;
  }

  [dir="ltr"] .xl\\:pe-96{
    padding-right: 24rem;
  }

  [dir="rtl"] .xl\\:pe-96{
    padding-left: 24rem;
  }

  [dir="ltr"] .xl\\:ps-98{
    padding-left: 24.5rem;
  }

  [dir="rtl"] .xl\\:ps-98{
    padding-right: 24.5rem;
  }

  [dir="ltr"] .xl\\:pe-98{
    padding-right: 24.5rem;
  }

  [dir="rtl"] .xl\\:pe-98{
    padding-left: 24.5rem;
  }

  [dir="ltr"] .xl\\:ps-100{
    padding-left: 25rem;
  }

  [dir="rtl"] .xl\\:ps-100{
    padding-right: 25rem;
  }

  [dir="ltr"] .xl\\:pe-100{
    padding-right: 25rem;
  }

  [dir="rtl"] .xl\\:pe-100{
    padding-left: 25rem;
  }

  [dir="ltr"] .xl\\:ps-104{
    padding-left: 26rem;
  }

  [dir="rtl"] .xl\\:ps-104{
    padding-right: 26rem;
  }

  [dir="ltr"] .xl\\:pe-104{
    padding-right: 26rem;
  }

  [dir="rtl"] .xl\\:pe-104{
    padding-left: 26rem;
  }

  [dir="ltr"] .xl\\:ps-112{
    padding-left: 28rem;
  }

  [dir="rtl"] .xl\\:ps-112{
    padding-right: 28rem;
  }

  [dir="ltr"] .xl\\:pe-112{
    padding-right: 28rem;
  }

  [dir="rtl"] .xl\\:pe-112{
    padding-left: 28rem;
  }

  [dir="ltr"] .xl\\:ps-124{
    padding-left: 31rem;
  }

  [dir="rtl"] .xl\\:ps-124{
    padding-right: 31rem;
  }

  [dir="ltr"] .xl\\:pe-124{
    padding-right: 31rem;
  }

  [dir="rtl"] .xl\\:pe-124{
    padding-left: 31rem;
  }

  [dir="ltr"] .xl\\:ps-128{
    padding-left: 32rem;
  }

  [dir="rtl"] .xl\\:ps-128{
    padding-right: 32rem;
  }

  [dir="ltr"] .xl\\:pe-128{
    padding-right: 32rem;
  }

  [dir="rtl"] .xl\\:pe-128{
    padding-left: 32rem;
  }

  [dir="ltr"] .xl\\:ps-140{
    padding-left: 35rem;
  }

  [dir="rtl"] .xl\\:ps-140{
    padding-right: 35rem;
  }

  [dir="ltr"] .xl\\:pe-140{
    padding-right: 35rem;
  }

  [dir="rtl"] .xl\\:pe-140{
    padding-left: 35rem;
  }

  [dir="ltr"] .xl\\:ps-152{
    padding-left: 38rem;
  }

  [dir="rtl"] .xl\\:ps-152{
    padding-right: 38rem;
  }

  [dir="ltr"] .xl\\:pe-152{
    padding-right: 38rem;
  }

  [dir="rtl"] .xl\\:pe-152{
    padding-left: 38rem;
  }

  [dir="ltr"] .xl\\:ps-160{
    padding-left: 40rem;
  }

  [dir="rtl"] .xl\\:ps-160{
    padding-right: 40rem;
  }

  [dir="ltr"] .xl\\:pe-160{
    padding-right: 40rem;
  }

  [dir="rtl"] .xl\\:pe-160{
    padding-left: 40rem;
  }

  [dir="ltr"] .xl\\:ps-162{
    padding-left: 41rem;
  }

  [dir="rtl"] .xl\\:ps-162{
    padding-right: 41rem;
  }

  [dir="ltr"] .xl\\:pe-162{
    padding-right: 41rem;
  }

  [dir="rtl"] .xl\\:pe-162{
    padding-left: 41rem;
  }

  [dir="ltr"] .xl\\:ps-192{
    padding-left: 48rem;
  }

  [dir="rtl"] .xl\\:ps-192{
    padding-right: 48rem;
  }

  [dir="ltr"] .xl\\:pe-192{
    padding-right: 48rem;
  }

  [dir="rtl"] .xl\\:pe-192{
    padding-left: 48rem;
  }

  [dir="ltr"] .xl\\:ps-208{
    padding-left: 52rem;
  }

  [dir="rtl"] .xl\\:ps-208{
    padding-right: 52rem;
  }

  [dir="ltr"] .xl\\:pe-208{
    padding-right: 52rem;
  }

  [dir="rtl"] .xl\\:pe-208{
    padding-left: 52rem;
  }

  [dir="ltr"] .xl\\:ps-224{
    padding-left: 56rem;
  }

  [dir="rtl"] .xl\\:ps-224{
    padding-right: 56rem;
  }

  [dir="ltr"] .xl\\:pe-224{
    padding-right: 56rem;
  }

  [dir="rtl"] .xl\\:pe-224{
    padding-left: 56rem;
  }

  [dir="ltr"] .xl\\:ps-256{
    padding-left: 64rem;
  }

  [dir="rtl"] .xl\\:ps-256{
    padding-right: 64rem;
  }

  [dir="ltr"] .xl\\:pe-256{
    padding-right: 64rem;
  }

  [dir="rtl"] .xl\\:pe-256{
    padding-left: 64rem;
  }

  [dir="ltr"] .xl\\:ps-px{
    padding-left: 1px;
  }

  [dir="rtl"] .xl\\:ps-px{
    padding-right: 1px;
  }

  [dir="ltr"] .xl\\:pe-px{
    padding-right: 1px;
  }

  [dir="rtl"] .xl\\:pe-px{
    padding-left: 1px;
  }

  [dir="ltr"] .xl\\:odd\\:ps-0:nth-child(odd){
    padding-left: 0;
  }

  [dir="rtl"] .xl\\:odd\\:ps-0:nth-child(odd){
    padding-right: 0;
  }

  [dir="ltr"] .xl\\:odd\\:pe-0:nth-child(odd){
    padding-right: 0;
  }

  [dir="rtl"] .xl\\:odd\\:pe-0:nth-child(odd){
    padding-left: 0;
  }

  [dir="ltr"] .xl\\:odd\\:ps-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-4:nth-child(odd){
    padding-left: 1rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-4:nth-child(odd){
    padding-right: 1rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-4:nth-child(odd){
    padding-right: 1rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-4:nth-child(odd){
    padding-left: 1rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-8:nth-child(odd){
    padding-left: 2rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-8:nth-child(odd){
    padding-right: 2rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-8:nth-child(odd){
    padding-right: 2rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-8:nth-child(odd){
    padding-left: 2rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-12:nth-child(odd){
    padding-left: 3rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-12:nth-child(odd){
    padding-right: 3rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-12:nth-child(odd){
    padding-right: 3rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-12:nth-child(odd){
    padding-left: 3rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-16:nth-child(odd){
    padding-left: 4rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-16:nth-child(odd){
    padding-right: 4rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-16:nth-child(odd){
    padding-right: 4rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-16:nth-child(odd){
    padding-left: 4rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-20:nth-child(odd){
    padding-left: 5rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-20:nth-child(odd){
    padding-right: 5rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-20:nth-child(odd){
    padding-right: 5rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-20:nth-child(odd){
    padding-left: 5rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-24:nth-child(odd){
    padding-left: 6rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-24:nth-child(odd){
    padding-right: 6rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-24:nth-child(odd){
    padding-right: 6rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-24:nth-child(odd){
    padding-left: 6rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-28:nth-child(odd){
    padding-left: 7rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-28:nth-child(odd){
    padding-right: 7rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-28:nth-child(odd){
    padding-right: 7rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-28:nth-child(odd){
    padding-left: 7rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-32:nth-child(odd){
    padding-left: 8rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-32:nth-child(odd){
    padding-right: 8rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-32:nth-child(odd){
    padding-right: 8rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-32:nth-child(odd){
    padding-left: 8rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-40:nth-child(odd){
    padding-left: 10rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-40:nth-child(odd){
    padding-right: 10rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-40:nth-child(odd){
    padding-right: 10rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-40:nth-child(odd){
    padding-left: 10rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-44:nth-child(odd){
    padding-left: 11rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-44:nth-child(odd){
    padding-right: 11rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-44:nth-child(odd){
    padding-right: 11rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-44:nth-child(odd){
    padding-left: 11rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-48:nth-child(odd){
    padding-left: 12rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-48:nth-child(odd){
    padding-right: 12rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-48:nth-child(odd){
    padding-right: 12rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-48:nth-child(odd){
    padding-left: 12rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-52:nth-child(odd){
    padding-left: 13rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-52:nth-child(odd){
    padding-right: 13rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-52:nth-child(odd){
    padding-right: 13rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-52:nth-child(odd){
    padding-left: 13rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-56:nth-child(odd){
    padding-left: 14rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-56:nth-child(odd){
    padding-right: 14rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-56:nth-child(odd){
    padding-right: 14rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-56:nth-child(odd){
    padding-left: 14rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-60:nth-child(odd){
    padding-left: 15rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-60:nth-child(odd){
    padding-right: 15rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-60:nth-child(odd){
    padding-right: 15rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-60:nth-child(odd){
    padding-left: 15rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-64:nth-child(odd){
    padding-left: 16rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-64:nth-child(odd){
    padding-right: 16rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-64:nth-child(odd){
    padding-right: 16rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-64:nth-child(odd){
    padding-left: 16rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-68:nth-child(odd){
    padding-left: 17rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-68:nth-child(odd){
    padding-right: 17rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-68:nth-child(odd){
    padding-right: 17rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-68:nth-child(odd){
    padding-left: 17rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-72:nth-child(odd){
    padding-left: 18rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-72:nth-child(odd){
    padding-right: 18rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-72:nth-child(odd){
    padding-right: 18rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-72:nth-child(odd){
    padding-left: 18rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-76:nth-child(odd){
    padding-left: 19rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-76:nth-child(odd){
    padding-right: 19rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-76:nth-child(odd){
    padding-right: 19rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-76:nth-child(odd){
    padding-left: 19rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-80:nth-child(odd){
    padding-left: 20rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-80:nth-child(odd){
    padding-right: 20rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-80:nth-child(odd){
    padding-right: 20rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-80:nth-child(odd){
    padding-left: 20rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-84:nth-child(odd){
    padding-left: 21rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-84:nth-child(odd){
    padding-right: 21rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-84:nth-child(odd){
    padding-right: 21rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-84:nth-child(odd){
    padding-left: 21rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-88:nth-child(odd){
    padding-left: 22rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-88:nth-child(odd){
    padding-right: 22rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-88:nth-child(odd){
    padding-right: 22rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-88:nth-child(odd){
    padding-left: 22rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-92:nth-child(odd){
    padding-left: 23rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-92:nth-child(odd){
    padding-right: 23rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-92:nth-child(odd){
    padding-right: 23rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-92:nth-child(odd){
    padding-left: 23rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-96:nth-child(odd){
    padding-left: 24rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-96:nth-child(odd){
    padding-right: 24rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-96:nth-child(odd){
    padding-right: 24rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-96:nth-child(odd){
    padding-left: 24rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-100:nth-child(odd){
    padding-left: 25rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-100:nth-child(odd){
    padding-right: 25rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-100:nth-child(odd){
    padding-right: 25rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-100:nth-child(odd){
    padding-left: 25rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-104:nth-child(odd){
    padding-left: 26rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-104:nth-child(odd){
    padding-right: 26rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-104:nth-child(odd){
    padding-right: 26rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-104:nth-child(odd){
    padding-left: 26rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-112:nth-child(odd){
    padding-left: 28rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-112:nth-child(odd){
    padding-right: 28rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-112:nth-child(odd){
    padding-right: 28rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-112:nth-child(odd){
    padding-left: 28rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-124:nth-child(odd){
    padding-left: 31rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-124:nth-child(odd){
    padding-right: 31rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-124:nth-child(odd){
    padding-right: 31rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-124:nth-child(odd){
    padding-left: 31rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-128:nth-child(odd){
    padding-left: 32rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-128:nth-child(odd){
    padding-right: 32rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-128:nth-child(odd){
    padding-right: 32rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-128:nth-child(odd){
    padding-left: 32rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-140:nth-child(odd){
    padding-left: 35rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-140:nth-child(odd){
    padding-right: 35rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-140:nth-child(odd){
    padding-right: 35rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-140:nth-child(odd){
    padding-left: 35rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-152:nth-child(odd){
    padding-left: 38rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-152:nth-child(odd){
    padding-right: 38rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-152:nth-child(odd){
    padding-right: 38rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-152:nth-child(odd){
    padding-left: 38rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-160:nth-child(odd){
    padding-left: 40rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-160:nth-child(odd){
    padding-right: 40rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-160:nth-child(odd){
    padding-right: 40rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-160:nth-child(odd){
    padding-left: 40rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-162:nth-child(odd){
    padding-left: 41rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-162:nth-child(odd){
    padding-right: 41rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-162:nth-child(odd){
    padding-right: 41rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-162:nth-child(odd){
    padding-left: 41rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-192:nth-child(odd){
    padding-left: 48rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-192:nth-child(odd){
    padding-right: 48rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-192:nth-child(odd){
    padding-right: 48rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-192:nth-child(odd){
    padding-left: 48rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-208:nth-child(odd){
    padding-left: 52rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-208:nth-child(odd){
    padding-right: 52rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-208:nth-child(odd){
    padding-right: 52rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-208:nth-child(odd){
    padding-left: 52rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-224:nth-child(odd){
    padding-left: 56rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-224:nth-child(odd){
    padding-right: 56rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-224:nth-child(odd){
    padding-right: 56rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-224:nth-child(odd){
    padding-left: 56rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-256:nth-child(odd){
    padding-left: 64rem;
  }

  [dir="rtl"] .xl\\:odd\\:ps-256:nth-child(odd){
    padding-right: 64rem;
  }

  [dir="ltr"] .xl\\:odd\\:pe-256:nth-child(odd){
    padding-right: 64rem;
  }

  [dir="rtl"] .xl\\:odd\\:pe-256:nth-child(odd){
    padding-left: 64rem;
  }

  [dir="ltr"] .xl\\:odd\\:ps-px:nth-child(odd){
    padding-left: 1px;
  }

  [dir="rtl"] .xl\\:odd\\:ps-px:nth-child(odd){
    padding-right: 1px;
  }

  [dir="ltr"] .xl\\:odd\\:pe-px:nth-child(odd){
    padding-right: 1px;
  }

  [dir="rtl"] .xl\\:odd\\:pe-px:nth-child(odd){
    padding-left: 1px;
  }

  [dir="ltr"] .xl\\:even\\:ps-0:nth-child(even){
    padding-left: 0;
  }

  [dir="rtl"] .xl\\:even\\:ps-0:nth-child(even){
    padding-right: 0;
  }

  [dir="ltr"] .xl\\:even\\:pe-0:nth-child(even){
    padding-right: 0;
  }

  [dir="rtl"] .xl\\:even\\:pe-0:nth-child(even){
    padding-left: 0;
  }

  [dir="ltr"] .xl\\:even\\:ps-1:nth-child(even){
    padding-left: 0.25rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-1:nth-child(even){
    padding-right: 0.25rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-1:nth-child(even){
    padding-right: 0.25rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-1:nth-child(even){
    padding-left: 0.25rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-2:nth-child(even){
    padding-left: 0.5rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-2:nth-child(even){
    padding-right: 0.5rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-2:nth-child(even){
    padding-right: 0.5rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-2:nth-child(even){
    padding-left: 0.5rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-3:nth-child(even){
    padding-left: 0.75rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-3:nth-child(even){
    padding-right: 0.75rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-3:nth-child(even){
    padding-right: 0.75rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-3:nth-child(even){
    padding-left: 0.75rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-4:nth-child(even){
    padding-left: 1rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-4:nth-child(even){
    padding-right: 1rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-4:nth-child(even){
    padding-right: 1rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-4:nth-child(even){
    padding-left: 1rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-5:nth-child(even){
    padding-left: 1.25rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-5:nth-child(even){
    padding-right: 1.25rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-5:nth-child(even){
    padding-right: 1.25rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-5:nth-child(even){
    padding-left: 1.25rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-6:nth-child(even){
    padding-left: 1.5rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-6:nth-child(even){
    padding-right: 1.5rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-6:nth-child(even){
    padding-right: 1.5rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-6:nth-child(even){
    padding-left: 1.5rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-7:nth-child(even){
    padding-left: 1.75rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-7:nth-child(even){
    padding-right: 1.75rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-7:nth-child(even){
    padding-right: 1.75rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-7:nth-child(even){
    padding-left: 1.75rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-8:nth-child(even){
    padding-left: 2rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-8:nth-child(even){
    padding-right: 2rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-8:nth-child(even){
    padding-right: 2rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-8:nth-child(even){
    padding-left: 2rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-9:nth-child(even){
    padding-left: 2.25rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-9:nth-child(even){
    padding-right: 2.25rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-9:nth-child(even){
    padding-right: 2.25rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-9:nth-child(even){
    padding-left: 2.25rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-10:nth-child(even){
    padding-left: 2.5rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-10:nth-child(even){
    padding-right: 2.5rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-10:nth-child(even){
    padding-right: 2.5rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-10:nth-child(even){
    padding-left: 2.5rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-11:nth-child(even){
    padding-left: 2.75rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-11:nth-child(even){
    padding-right: 2.75rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-11:nth-child(even){
    padding-right: 2.75rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-11:nth-child(even){
    padding-left: 2.75rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-12:nth-child(even){
    padding-left: 3rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-12:nth-child(even){
    padding-right: 3rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-12:nth-child(even){
    padding-right: 3rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-12:nth-child(even){
    padding-left: 3rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-14:nth-child(even){
    padding-left: 3.5rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-14:nth-child(even){
    padding-right: 3.5rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-14:nth-child(even){
    padding-right: 3.5rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-14:nth-child(even){
    padding-left: 3.5rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-15:nth-child(even){
    padding-left: 3.75rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-15:nth-child(even){
    padding-right: 3.75rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-15:nth-child(even){
    padding-right: 3.75rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-15:nth-child(even){
    padding-left: 3.75rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-16:nth-child(even){
    padding-left: 4rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-16:nth-child(even){
    padding-right: 4rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-16:nth-child(even){
    padding-right: 4rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-16:nth-child(even){
    padding-left: 4rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-18:nth-child(even){
    padding-left: 4.5rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-18:nth-child(even){
    padding-right: 4.5rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-18:nth-child(even){
    padding-right: 4.5rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-18:nth-child(even){
    padding-left: 4.5rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-20:nth-child(even){
    padding-left: 5rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-20:nth-child(even){
    padding-right: 5rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-20:nth-child(even){
    padding-right: 5rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-20:nth-child(even){
    padding-left: 5rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-22:nth-child(even){
    padding-left: 5.5rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-22:nth-child(even){
    padding-right: 5.5rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-22:nth-child(even){
    padding-right: 5.5rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-22:nth-child(even){
    padding-left: 5.5rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-23:nth-child(even){
    padding-left: 5.75rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-23:nth-child(even){
    padding-right: 5.75rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-23:nth-child(even){
    padding-right: 5.75rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-23:nth-child(even){
    padding-left: 5.75rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-24:nth-child(even){
    padding-left: 6rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-24:nth-child(even){
    padding-right: 6rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-24:nth-child(even){
    padding-right: 6rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-24:nth-child(even){
    padding-left: 6rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-25:nth-child(even){
    padding-left: 6.25rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-25:nth-child(even){
    padding-right: 6.25rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-25:nth-child(even){
    padding-right: 6.25rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-25:nth-child(even){
    padding-left: 6.25rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-26:nth-child(even){
    padding-left: 6.5rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-26:nth-child(even){
    padding-right: 6.5rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-26:nth-child(even){
    padding-right: 6.5rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-26:nth-child(even){
    padding-left: 6.5rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-28:nth-child(even){
    padding-left: 7rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-28:nth-child(even){
    padding-right: 7rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-28:nth-child(even){
    padding-right: 7rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-28:nth-child(even){
    padding-left: 7rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-30:nth-child(even){
    padding-left: 7.5rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-30:nth-child(even){
    padding-right: 7.5rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-30:nth-child(even){
    padding-right: 7.5rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-30:nth-child(even){
    padding-left: 7.5rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-32:nth-child(even){
    padding-left: 8rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-32:nth-child(even){
    padding-right: 8rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-32:nth-child(even){
    padding-right: 8rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-32:nth-child(even){
    padding-left: 8rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-34:nth-child(even){
    padding-left: 8.5rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-34:nth-child(even){
    padding-right: 8.5rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-34:nth-child(even){
    padding-right: 8.5rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-34:nth-child(even){
    padding-left: 8.5rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-40:nth-child(even){
    padding-left: 10rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-40:nth-child(even){
    padding-right: 10rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-40:nth-child(even){
    padding-right: 10rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-40:nth-child(even){
    padding-left: 10rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-42:nth-child(even){
    padding-left: 10.5rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-42:nth-child(even){
    padding-right: 10.5rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-42:nth-child(even){
    padding-right: 10.5rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-42:nth-child(even){
    padding-left: 10.5rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-44:nth-child(even){
    padding-left: 11rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-44:nth-child(even){
    padding-right: 11rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-44:nth-child(even){
    padding-right: 11rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-44:nth-child(even){
    padding-left: 11rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-48:nth-child(even){
    padding-left: 12rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-48:nth-child(even){
    padding-right: 12rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-48:nth-child(even){
    padding-right: 12rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-48:nth-child(even){
    padding-left: 12rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-52:nth-child(even){
    padding-left: 13rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-52:nth-child(even){
    padding-right: 13rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-52:nth-child(even){
    padding-right: 13rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-52:nth-child(even){
    padding-left: 13rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-54:nth-child(even){
    padding-left: 13.5rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-54:nth-child(even){
    padding-right: 13.5rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-54:nth-child(even){
    padding-right: 13.5rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-54:nth-child(even){
    padding-left: 13.5rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-56:nth-child(even){
    padding-left: 14rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-56:nth-child(even){
    padding-right: 14rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-56:nth-child(even){
    padding-right: 14rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-56:nth-child(even){
    padding-left: 14rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-60:nth-child(even){
    padding-left: 15rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-60:nth-child(even){
    padding-right: 15rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-60:nth-child(even){
    padding-right: 15rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-60:nth-child(even){
    padding-left: 15rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-64:nth-child(even){
    padding-left: 16rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-64:nth-child(even){
    padding-right: 16rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-64:nth-child(even){
    padding-right: 16rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-64:nth-child(even){
    padding-left: 16rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-68:nth-child(even){
    padding-left: 17rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-68:nth-child(even){
    padding-right: 17rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-68:nth-child(even){
    padding-right: 17rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-68:nth-child(even){
    padding-left: 17rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-72:nth-child(even){
    padding-left: 18rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-72:nth-child(even){
    padding-right: 18rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-72:nth-child(even){
    padding-right: 18rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-72:nth-child(even){
    padding-left: 18rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-74:nth-child(even){
    padding-left: 18.5rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-74:nth-child(even){
    padding-right: 18.5rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-74:nth-child(even){
    padding-right: 18.5rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-74:nth-child(even){
    padding-left: 18.5rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-76:nth-child(even){
    padding-left: 19rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-76:nth-child(even){
    padding-right: 19rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-76:nth-child(even){
    padding-right: 19rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-76:nth-child(even){
    padding-left: 19rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-78:nth-child(even){
    padding-left: 19.5rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-78:nth-child(even){
    padding-right: 19.5rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-78:nth-child(even){
    padding-right: 19.5rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-78:nth-child(even){
    padding-left: 19.5rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-80:nth-child(even){
    padding-left: 20rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-80:nth-child(even){
    padding-right: 20rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-80:nth-child(even){
    padding-right: 20rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-80:nth-child(even){
    padding-left: 20rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-82:nth-child(even){
    padding-left: 20.5rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-82:nth-child(even){
    padding-right: 20.5rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-82:nth-child(even){
    padding-right: 20.5rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-82:nth-child(even){
    padding-left: 20.5rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-84:nth-child(even){
    padding-left: 21rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-84:nth-child(even){
    padding-right: 21rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-84:nth-child(even){
    padding-right: 21rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-84:nth-child(even){
    padding-left: 21rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-88:nth-child(even){
    padding-left: 22rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-88:nth-child(even){
    padding-right: 22rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-88:nth-child(even){
    padding-right: 22rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-88:nth-child(even){
    padding-left: 22rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-92:nth-child(even){
    padding-left: 23rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-92:nth-child(even){
    padding-right: 23rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-92:nth-child(even){
    padding-right: 23rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-92:nth-child(even){
    padding-left: 23rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-96:nth-child(even){
    padding-left: 24rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-96:nth-child(even){
    padding-right: 24rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-96:nth-child(even){
    padding-right: 24rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-96:nth-child(even){
    padding-left: 24rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-98:nth-child(even){
    padding-left: 24.5rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-98:nth-child(even){
    padding-right: 24.5rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-98:nth-child(even){
    padding-right: 24.5rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-98:nth-child(even){
    padding-left: 24.5rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-100:nth-child(even){
    padding-left: 25rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-100:nth-child(even){
    padding-right: 25rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-100:nth-child(even){
    padding-right: 25rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-100:nth-child(even){
    padding-left: 25rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-104:nth-child(even){
    padding-left: 26rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-104:nth-child(even){
    padding-right: 26rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-104:nth-child(even){
    padding-right: 26rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-104:nth-child(even){
    padding-left: 26rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-112:nth-child(even){
    padding-left: 28rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-112:nth-child(even){
    padding-right: 28rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-112:nth-child(even){
    padding-right: 28rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-112:nth-child(even){
    padding-left: 28rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-124:nth-child(even){
    padding-left: 31rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-124:nth-child(even){
    padding-right: 31rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-124:nth-child(even){
    padding-right: 31rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-124:nth-child(even){
    padding-left: 31rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-128:nth-child(even){
    padding-left: 32rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-128:nth-child(even){
    padding-right: 32rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-128:nth-child(even){
    padding-right: 32rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-128:nth-child(even){
    padding-left: 32rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-140:nth-child(even){
    padding-left: 35rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-140:nth-child(even){
    padding-right: 35rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-140:nth-child(even){
    padding-right: 35rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-140:nth-child(even){
    padding-left: 35rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-152:nth-child(even){
    padding-left: 38rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-152:nth-child(even){
    padding-right: 38rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-152:nth-child(even){
    padding-right: 38rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-152:nth-child(even){
    padding-left: 38rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-160:nth-child(even){
    padding-left: 40rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-160:nth-child(even){
    padding-right: 40rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-160:nth-child(even){
    padding-right: 40rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-160:nth-child(even){
    padding-left: 40rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-162:nth-child(even){
    padding-left: 41rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-162:nth-child(even){
    padding-right: 41rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-162:nth-child(even){
    padding-right: 41rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-162:nth-child(even){
    padding-left: 41rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-192:nth-child(even){
    padding-left: 48rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-192:nth-child(even){
    padding-right: 48rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-192:nth-child(even){
    padding-right: 48rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-192:nth-child(even){
    padding-left: 48rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-208:nth-child(even){
    padding-left: 52rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-208:nth-child(even){
    padding-right: 52rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-208:nth-child(even){
    padding-right: 52rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-208:nth-child(even){
    padding-left: 52rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-224:nth-child(even){
    padding-left: 56rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-224:nth-child(even){
    padding-right: 56rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-224:nth-child(even){
    padding-right: 56rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-224:nth-child(even){
    padding-left: 56rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-256:nth-child(even){
    padding-left: 64rem;
  }

  [dir="rtl"] .xl\\:even\\:ps-256:nth-child(even){
    padding-right: 64rem;
  }

  [dir="ltr"] .xl\\:even\\:pe-256:nth-child(even){
    padding-right: 64rem;
  }

  [dir="rtl"] .xl\\:even\\:pe-256:nth-child(even){
    padding-left: 64rem;
  }

  [dir="ltr"] .xl\\:even\\:ps-px:nth-child(even){
    padding-left: 1px;
  }

  [dir="rtl"] .xl\\:even\\:ps-px:nth-child(even){
    padding-right: 1px;
  }

  [dir="ltr"] .xl\\:even\\:pe-px:nth-child(even){
    padding-right: 1px;
  }

  [dir="rtl"] .xl\\:even\\:pe-px:nth-child(even){
    padding-left: 1px;
  }

  [dir="ltr"] .xl\\:ms-0{
    margin-left: 0;
  }

  [dir="rtl"] .xl\\:ms-0{
    margin-right: 0;
  }

  [dir="ltr"] .xl\\:me-0{
    margin-right: 0;
  }

  [dir="rtl"] .xl\\:me-0{
    margin-left: 0;
  }

  [dir="ltr"] .xl\\:ms-1{
    margin-left: 0.25rem;
  }

  [dir="rtl"] .xl\\:ms-1{
    margin-right: 0.25rem;
  }

  [dir="ltr"] .xl\\:me-1{
    margin-right: 0.25rem;
  }

  [dir="rtl"] .xl\\:me-1{
    margin-left: 0.25rem;
  }

  [dir="ltr"] .xl\\:ms-2{
    margin-left: 0.5rem;
  }

  [dir="rtl"] .xl\\:ms-2{
    margin-right: 0.5rem;
  }

  [dir="ltr"] .xl\\:me-2{
    margin-right: 0.5rem;
  }

  [dir="rtl"] .xl\\:me-2{
    margin-left: 0.5rem;
  }

  [dir="ltr"] .xl\\:ms-3{
    margin-left: 0.75rem;
  }

  [dir="rtl"] .xl\\:ms-3{
    margin-right: 0.75rem;
  }

  [dir="ltr"] .xl\\:me-3{
    margin-right: 0.75rem;
  }

  [dir="rtl"] .xl\\:me-3{
    margin-left: 0.75rem;
  }

  [dir="ltr"] .xl\\:ms-4{
    margin-left: 1rem;
  }

  [dir="rtl"] .xl\\:ms-4{
    margin-right: 1rem;
  }

  [dir="ltr"] .xl\\:me-4{
    margin-right: 1rem;
  }

  [dir="rtl"] .xl\\:me-4{
    margin-left: 1rem;
  }

  [dir="ltr"] .xl\\:ms-5{
    margin-left: 1.25rem;
  }

  [dir="rtl"] .xl\\:ms-5{
    margin-right: 1.25rem;
  }

  [dir="ltr"] .xl\\:me-5{
    margin-right: 1.25rem;
  }

  [dir="rtl"] .xl\\:me-5{
    margin-left: 1.25rem;
  }

  [dir="ltr"] .xl\\:ms-6{
    margin-left: 1.5rem;
  }

  [dir="rtl"] .xl\\:ms-6{
    margin-right: 1.5rem;
  }

  [dir="ltr"] .xl\\:me-6{
    margin-right: 1.5rem;
  }

  [dir="rtl"] .xl\\:me-6{
    margin-left: 1.5rem;
  }

  [dir="ltr"] .xl\\:ms-7{
    margin-left: 1.75rem;
  }

  [dir="rtl"] .xl\\:ms-7{
    margin-right: 1.75rem;
  }

  [dir="ltr"] .xl\\:me-7{
    margin-right: 1.75rem;
  }

  [dir="rtl"] .xl\\:me-7{
    margin-left: 1.75rem;
  }

  [dir="ltr"] .xl\\:ms-8{
    margin-left: 2rem;
  }

  [dir="rtl"] .xl\\:ms-8{
    margin-right: 2rem;
  }

  [dir="ltr"] .xl\\:me-8{
    margin-right: 2rem;
  }

  [dir="rtl"] .xl\\:me-8{
    margin-left: 2rem;
  }

  [dir="ltr"] .xl\\:ms-9{
    margin-left: 2.25rem;
  }

  [dir="rtl"] .xl\\:ms-9{
    margin-right: 2.25rem;
  }

  [dir="ltr"] .xl\\:me-9{
    margin-right: 2.25rem;
  }

  [dir="rtl"] .xl\\:me-9{
    margin-left: 2.25rem;
  }

  [dir="ltr"] .xl\\:ms-10{
    margin-left: 2.5rem;
  }

  [dir="rtl"] .xl\\:ms-10{
    margin-right: 2.5rem;
  }

  [dir="ltr"] .xl\\:me-10{
    margin-right: 2.5rem;
  }

  [dir="rtl"] .xl\\:me-10{
    margin-left: 2.5rem;
  }

  [dir="ltr"] .xl\\:ms-11{
    margin-left: 2.75rem;
  }

  [dir="rtl"] .xl\\:ms-11{
    margin-right: 2.75rem;
  }

  [dir="ltr"] .xl\\:me-11{
    margin-right: 2.75rem;
  }

  [dir="rtl"] .xl\\:me-11{
    margin-left: 2.75rem;
  }

  [dir="ltr"] .xl\\:ms-12{
    margin-left: 3rem;
  }

  [dir="rtl"] .xl\\:ms-12{
    margin-right: 3rem;
  }

  [dir="ltr"] .xl\\:me-12{
    margin-right: 3rem;
  }

  [dir="rtl"] .xl\\:me-12{
    margin-left: 3rem;
  }

  [dir="ltr"] .xl\\:ms-14{
    margin-left: 3.5rem;
  }

  [dir="rtl"] .xl\\:ms-14{
    margin-right: 3.5rem;
  }

  [dir="ltr"] .xl\\:me-14{
    margin-right: 3.5rem;
  }

  [dir="rtl"] .xl\\:me-14{
    margin-left: 3.5rem;
  }

  [dir="ltr"] .xl\\:ms-15{
    margin-left: 3.75rem;
  }

  [dir="rtl"] .xl\\:ms-15{
    margin-right: 3.75rem;
  }

  [dir="ltr"] .xl\\:me-15{
    margin-right: 3.75rem;
  }

  [dir="rtl"] .xl\\:me-15{
    margin-left: 3.75rem;
  }

  [dir="ltr"] .xl\\:ms-16{
    margin-left: 4rem;
  }

  [dir="rtl"] .xl\\:ms-16{
    margin-right: 4rem;
  }

  [dir="ltr"] .xl\\:me-16{
    margin-right: 4rem;
  }

  [dir="rtl"] .xl\\:me-16{
    margin-left: 4rem;
  }

  [dir="ltr"] .xl\\:ms-18{
    margin-left: 4.5rem;
  }

  [dir="rtl"] .xl\\:ms-18{
    margin-right: 4.5rem;
  }

  [dir="ltr"] .xl\\:me-18{
    margin-right: 4.5rem;
  }

  [dir="rtl"] .xl\\:me-18{
    margin-left: 4.5rem;
  }

  [dir="ltr"] .xl\\:ms-20{
    margin-left: 5rem;
  }

  [dir="rtl"] .xl\\:ms-20{
    margin-right: 5rem;
  }

  [dir="ltr"] .xl\\:me-20{
    margin-right: 5rem;
  }

  [dir="rtl"] .xl\\:me-20{
    margin-left: 5rem;
  }

  [dir="ltr"] .xl\\:ms-22{
    margin-left: 5.5rem;
  }

  [dir="rtl"] .xl\\:ms-22{
    margin-right: 5.5rem;
  }

  [dir="ltr"] .xl\\:me-22{
    margin-right: 5.5rem;
  }

  [dir="rtl"] .xl\\:me-22{
    margin-left: 5.5rem;
  }

  [dir="ltr"] .xl\\:ms-23{
    margin-left: 5.75rem;
  }

  [dir="rtl"] .xl\\:ms-23{
    margin-right: 5.75rem;
  }

  [dir="ltr"] .xl\\:me-23{
    margin-right: 5.75rem;
  }

  [dir="rtl"] .xl\\:me-23{
    margin-left: 5.75rem;
  }

  [dir="ltr"] .xl\\:ms-24{
    margin-left: 6rem;
  }

  [dir="rtl"] .xl\\:ms-24{
    margin-right: 6rem;
  }

  [dir="ltr"] .xl\\:me-24{
    margin-right: 6rem;
  }

  [dir="rtl"] .xl\\:me-24{
    margin-left: 6rem;
  }

  [dir="ltr"] .xl\\:ms-25{
    margin-left: 6.25rem;
  }

  [dir="rtl"] .xl\\:ms-25{
    margin-right: 6.25rem;
  }

  [dir="ltr"] .xl\\:me-25{
    margin-right: 6.25rem;
  }

  [dir="rtl"] .xl\\:me-25{
    margin-left: 6.25rem;
  }

  [dir="ltr"] .xl\\:ms-26{
    margin-left: 6.5rem;
  }

  [dir="rtl"] .xl\\:ms-26{
    margin-right: 6.5rem;
  }

  [dir="ltr"] .xl\\:me-26{
    margin-right: 6.5rem;
  }

  [dir="rtl"] .xl\\:me-26{
    margin-left: 6.5rem;
  }

  [dir="ltr"] .xl\\:ms-28{
    margin-left: 7rem;
  }

  [dir="rtl"] .xl\\:ms-28{
    margin-right: 7rem;
  }

  [dir="ltr"] .xl\\:me-28{
    margin-right: 7rem;
  }

  [dir="rtl"] .xl\\:me-28{
    margin-left: 7rem;
  }

  [dir="ltr"] .xl\\:ms-30{
    margin-left: 7.5rem;
  }

  [dir="rtl"] .xl\\:ms-30{
    margin-right: 7.5rem;
  }

  [dir="ltr"] .xl\\:me-30{
    margin-right: 7.5rem;
  }

  [dir="rtl"] .xl\\:me-30{
    margin-left: 7.5rem;
  }

  [dir="ltr"] .xl\\:ms-32{
    margin-left: 8rem;
  }

  [dir="rtl"] .xl\\:ms-32{
    margin-right: 8rem;
  }

  [dir="ltr"] .xl\\:me-32{
    margin-right: 8rem;
  }

  [dir="rtl"] .xl\\:me-32{
    margin-left: 8rem;
  }

  [dir="ltr"] .xl\\:ms-34{
    margin-left: 8.5rem;
  }

  [dir="rtl"] .xl\\:ms-34{
    margin-right: 8.5rem;
  }

  [dir="ltr"] .xl\\:me-34{
    margin-right: 8.5rem;
  }

  [dir="rtl"] .xl\\:me-34{
    margin-left: 8.5rem;
  }

  [dir="ltr"] .xl\\:ms-40{
    margin-left: 10rem;
  }

  [dir="rtl"] .xl\\:ms-40{
    margin-right: 10rem;
  }

  [dir="ltr"] .xl\\:me-40{
    margin-right: 10rem;
  }

  [dir="rtl"] .xl\\:me-40{
    margin-left: 10rem;
  }

  [dir="ltr"] .xl\\:ms-42{
    margin-left: 10.5rem;
  }

  [dir="rtl"] .xl\\:ms-42{
    margin-right: 10.5rem;
  }

  [dir="ltr"] .xl\\:me-42{
    margin-right: 10.5rem;
  }

  [dir="rtl"] .xl\\:me-42{
    margin-left: 10.5rem;
  }

  [dir="ltr"] .xl\\:ms-44{
    margin-left: 11rem;
  }

  [dir="rtl"] .xl\\:ms-44{
    margin-right: 11rem;
  }

  [dir="ltr"] .xl\\:me-44{
    margin-right: 11rem;
  }

  [dir="rtl"] .xl\\:me-44{
    margin-left: 11rem;
  }

  [dir="ltr"] .xl\\:ms-48{
    margin-left: 12rem;
  }

  [dir="rtl"] .xl\\:ms-48{
    margin-right: 12rem;
  }

  [dir="ltr"] .xl\\:me-48{
    margin-right: 12rem;
  }

  [dir="rtl"] .xl\\:me-48{
    margin-left: 12rem;
  }

  [dir="ltr"] .xl\\:ms-52{
    margin-left: 13rem;
  }

  [dir="rtl"] .xl\\:ms-52{
    margin-right: 13rem;
  }

  [dir="ltr"] .xl\\:me-52{
    margin-right: 13rem;
  }

  [dir="rtl"] .xl\\:me-52{
    margin-left: 13rem;
  }

  [dir="ltr"] .xl\\:ms-54{
    margin-left: 13.5rem;
  }

  [dir="rtl"] .xl\\:ms-54{
    margin-right: 13.5rem;
  }

  [dir="ltr"] .xl\\:me-54{
    margin-right: 13.5rem;
  }

  [dir="rtl"] .xl\\:me-54{
    margin-left: 13.5rem;
  }

  [dir="ltr"] .xl\\:ms-56{
    margin-left: 14rem;
  }

  [dir="rtl"] .xl\\:ms-56{
    margin-right: 14rem;
  }

  [dir="ltr"] .xl\\:me-56{
    margin-right: 14rem;
  }

  [dir="rtl"] .xl\\:me-56{
    margin-left: 14rem;
  }

  [dir="ltr"] .xl\\:ms-60{
    margin-left: 15rem;
  }

  [dir="rtl"] .xl\\:ms-60{
    margin-right: 15rem;
  }

  [dir="ltr"] .xl\\:me-60{
    margin-right: 15rem;
  }

  [dir="rtl"] .xl\\:me-60{
    margin-left: 15rem;
  }

  [dir="ltr"] .xl\\:ms-64{
    margin-left: 16rem;
  }

  [dir="rtl"] .xl\\:ms-64{
    margin-right: 16rem;
  }

  [dir="ltr"] .xl\\:me-64{
    margin-right: 16rem;
  }

  [dir="rtl"] .xl\\:me-64{
    margin-left: 16rem;
  }

  [dir="ltr"] .xl\\:ms-68{
    margin-left: 17rem;
  }

  [dir="rtl"] .xl\\:ms-68{
    margin-right: 17rem;
  }

  [dir="ltr"] .xl\\:me-68{
    margin-right: 17rem;
  }

  [dir="rtl"] .xl\\:me-68{
    margin-left: 17rem;
  }

  [dir="ltr"] .xl\\:ms-72{
    margin-left: 18rem;
  }

  [dir="rtl"] .xl\\:ms-72{
    margin-right: 18rem;
  }

  [dir="ltr"] .xl\\:me-72{
    margin-right: 18rem;
  }

  [dir="rtl"] .xl\\:me-72{
    margin-left: 18rem;
  }

  [dir="ltr"] .xl\\:ms-74{
    margin-left: 18.5rem;
  }

  [dir="rtl"] .xl\\:ms-74{
    margin-right: 18.5rem;
  }

  [dir="ltr"] .xl\\:me-74{
    margin-right: 18.5rem;
  }

  [dir="rtl"] .xl\\:me-74{
    margin-left: 18.5rem;
  }

  [dir="ltr"] .xl\\:ms-76{
    margin-left: 19rem;
  }

  [dir="rtl"] .xl\\:ms-76{
    margin-right: 19rem;
  }

  [dir="ltr"] .xl\\:me-76{
    margin-right: 19rem;
  }

  [dir="rtl"] .xl\\:me-76{
    margin-left: 19rem;
  }

  [dir="ltr"] .xl\\:ms-78{
    margin-left: 19.5rem;
  }

  [dir="rtl"] .xl\\:ms-78{
    margin-right: 19.5rem;
  }

  [dir="ltr"] .xl\\:me-78{
    margin-right: 19.5rem;
  }

  [dir="rtl"] .xl\\:me-78{
    margin-left: 19.5rem;
  }

  [dir="ltr"] .xl\\:ms-80{
    margin-left: 20rem;
  }

  [dir="rtl"] .xl\\:ms-80{
    margin-right: 20rem;
  }

  [dir="ltr"] .xl\\:me-80{
    margin-right: 20rem;
  }

  [dir="rtl"] .xl\\:me-80{
    margin-left: 20rem;
  }

  [dir="ltr"] .xl\\:ms-82{
    margin-left: 20.5rem;
  }

  [dir="rtl"] .xl\\:ms-82{
    margin-right: 20.5rem;
  }

  [dir="ltr"] .xl\\:me-82{
    margin-right: 20.5rem;
  }

  [dir="rtl"] .xl\\:me-82{
    margin-left: 20.5rem;
  }

  [dir="ltr"] .xl\\:ms-84{
    margin-left: 21rem;
  }

  [dir="rtl"] .xl\\:ms-84{
    margin-right: 21rem;
  }

  [dir="ltr"] .xl\\:me-84{
    margin-right: 21rem;
  }

  [dir="rtl"] .xl\\:me-84{
    margin-left: 21rem;
  }

  [dir="ltr"] .xl\\:ms-88{
    margin-left: 22rem;
  }

  [dir="rtl"] .xl\\:ms-88{
    margin-right: 22rem;
  }

  [dir="ltr"] .xl\\:me-88{
    margin-right: 22rem;
  }

  [dir="rtl"] .xl\\:me-88{
    margin-left: 22rem;
  }

  [dir="ltr"] .xl\\:ms-92{
    margin-left: 23rem;
  }

  [dir="rtl"] .xl\\:ms-92{
    margin-right: 23rem;
  }

  [dir="ltr"] .xl\\:me-92{
    margin-right: 23rem;
  }

  [dir="rtl"] .xl\\:me-92{
    margin-left: 23rem;
  }

  [dir="ltr"] .xl\\:ms-96{
    margin-left: 24rem;
  }

  [dir="rtl"] .xl\\:ms-96{
    margin-right: 24rem;
  }

  [dir="ltr"] .xl\\:me-96{
    margin-right: 24rem;
  }

  [dir="rtl"] .xl\\:me-96{
    margin-left: 24rem;
  }

  [dir="ltr"] .xl\\:ms-98{
    margin-left: 24.5rem;
  }

  [dir="rtl"] .xl\\:ms-98{
    margin-right: 24.5rem;
  }

  [dir="ltr"] .xl\\:me-98{
    margin-right: 24.5rem;
  }

  [dir="rtl"] .xl\\:me-98{
    margin-left: 24.5rem;
  }

  [dir="ltr"] .xl\\:ms-100{
    margin-left: 25rem;
  }

  [dir="rtl"] .xl\\:ms-100{
    margin-right: 25rem;
  }

  [dir="ltr"] .xl\\:me-100{
    margin-right: 25rem;
  }

  [dir="rtl"] .xl\\:me-100{
    margin-left: 25rem;
  }

  [dir="ltr"] .xl\\:ms-104{
    margin-left: 26rem;
  }

  [dir="rtl"] .xl\\:ms-104{
    margin-right: 26rem;
  }

  [dir="ltr"] .xl\\:me-104{
    margin-right: 26rem;
  }

  [dir="rtl"] .xl\\:me-104{
    margin-left: 26rem;
  }

  [dir="ltr"] .xl\\:ms-112{
    margin-left: 28rem;
  }

  [dir="rtl"] .xl\\:ms-112{
    margin-right: 28rem;
  }

  [dir="ltr"] .xl\\:me-112{
    margin-right: 28rem;
  }

  [dir="rtl"] .xl\\:me-112{
    margin-left: 28rem;
  }

  [dir="ltr"] .xl\\:ms-124{
    margin-left: 31rem;
  }

  [dir="rtl"] .xl\\:ms-124{
    margin-right: 31rem;
  }

  [dir="ltr"] .xl\\:me-124{
    margin-right: 31rem;
  }

  [dir="rtl"] .xl\\:me-124{
    margin-left: 31rem;
  }

  [dir="ltr"] .xl\\:ms-128{
    margin-left: 32rem;
  }

  [dir="rtl"] .xl\\:ms-128{
    margin-right: 32rem;
  }

  [dir="ltr"] .xl\\:me-128{
    margin-right: 32rem;
  }

  [dir="rtl"] .xl\\:me-128{
    margin-left: 32rem;
  }

  [dir="ltr"] .xl\\:ms-140{
    margin-left: 35rem;
  }

  [dir="rtl"] .xl\\:ms-140{
    margin-right: 35rem;
  }

  [dir="ltr"] .xl\\:me-140{
    margin-right: 35rem;
  }

  [dir="rtl"] .xl\\:me-140{
    margin-left: 35rem;
  }

  [dir="ltr"] .xl\\:ms-152{
    margin-left: 38rem;
  }

  [dir="rtl"] .xl\\:ms-152{
    margin-right: 38rem;
  }

  [dir="ltr"] .xl\\:me-152{
    margin-right: 38rem;
  }

  [dir="rtl"] .xl\\:me-152{
    margin-left: 38rem;
  }

  [dir="ltr"] .xl\\:ms-160{
    margin-left: 40rem;
  }

  [dir="rtl"] .xl\\:ms-160{
    margin-right: 40rem;
  }

  [dir="ltr"] .xl\\:me-160{
    margin-right: 40rem;
  }

  [dir="rtl"] .xl\\:me-160{
    margin-left: 40rem;
  }

  [dir="ltr"] .xl\\:ms-162{
    margin-left: 41rem;
  }

  [dir="rtl"] .xl\\:ms-162{
    margin-right: 41rem;
  }

  [dir="ltr"] .xl\\:me-162{
    margin-right: 41rem;
  }

  [dir="rtl"] .xl\\:me-162{
    margin-left: 41rem;
  }

  [dir="ltr"] .xl\\:ms-192{
    margin-left: 48rem;
  }

  [dir="rtl"] .xl\\:ms-192{
    margin-right: 48rem;
  }

  [dir="ltr"] .xl\\:me-192{
    margin-right: 48rem;
  }

  [dir="rtl"] .xl\\:me-192{
    margin-left: 48rem;
  }

  [dir="ltr"] .xl\\:ms-208{
    margin-left: 52rem;
  }

  [dir="rtl"] .xl\\:ms-208{
    margin-right: 52rem;
  }

  [dir="ltr"] .xl\\:me-208{
    margin-right: 52rem;
  }

  [dir="rtl"] .xl\\:me-208{
    margin-left: 52rem;
  }

  [dir="ltr"] .xl\\:ms-224{
    margin-left: 56rem;
  }

  [dir="rtl"] .xl\\:ms-224{
    margin-right: 56rem;
  }

  [dir="ltr"] .xl\\:me-224{
    margin-right: 56rem;
  }

  [dir="rtl"] .xl\\:me-224{
    margin-left: 56rem;
  }

  [dir="ltr"] .xl\\:ms-256{
    margin-left: 64rem;
  }

  [dir="rtl"] .xl\\:ms-256{
    margin-right: 64rem;
  }

  [dir="ltr"] .xl\\:me-256{
    margin-right: 64rem;
  }

  [dir="rtl"] .xl\\:me-256{
    margin-left: 64rem;
  }

  [dir="ltr"] .xl\\:ms-auto{
    margin-left: auto;
  }

  [dir="rtl"] .xl\\:ms-auto{
    margin-right: auto;
  }

  [dir="ltr"] .xl\\:me-auto{
    margin-right: auto;
  }

  [dir="rtl"] .xl\\:me-auto{
    margin-left: auto;
  }

  [dir="ltr"] .xl\\:ms-px{
    margin-left: 1px;
  }

  [dir="rtl"] .xl\\:ms-px{
    margin-right: 1px;
  }

  [dir="ltr"] .xl\\:me-px{
    margin-right: 1px;
  }

  [dir="rtl"] .xl\\:me-px{
    margin-left: 1px;
  }

  [dir="ltr"] .xl\\:-ms-1{
    margin-left: -0.25rem;
  }

  [dir="rtl"] .xl\\:-ms-1{
    margin-right: -0.25rem;
  }

  [dir="ltr"] .xl\\:-me-1{
    margin-right: -0.25rem;
  }

  [dir="rtl"] .xl\\:-me-1{
    margin-left: -0.25rem;
  }

  [dir="ltr"] .xl\\:-ms-2{
    margin-left: -0.5rem;
  }

  [dir="rtl"] .xl\\:-ms-2{
    margin-right: -0.5rem;
  }

  [dir="ltr"] .xl\\:-me-2{
    margin-right: -0.5rem;
  }

  [dir="rtl"] .xl\\:-me-2{
    margin-left: -0.5rem;
  }

  [dir="ltr"] .xl\\:-ms-3{
    margin-left: -0.75rem;
  }

  [dir="rtl"] .xl\\:-ms-3{
    margin-right: -0.75rem;
  }

  [dir="ltr"] .xl\\:-me-3{
    margin-right: -0.75rem;
  }

  [dir="rtl"] .xl\\:-me-3{
    margin-left: -0.75rem;
  }

  [dir="ltr"] .xl\\:-ms-4{
    margin-left: -1rem;
  }

  [dir="rtl"] .xl\\:-ms-4{
    margin-right: -1rem;
  }

  [dir="ltr"] .xl\\:-me-4{
    margin-right: -1rem;
  }

  [dir="rtl"] .xl\\:-me-4{
    margin-left: -1rem;
  }

  [dir="ltr"] .xl\\:-ms-5{
    margin-left: -1.25rem;
  }

  [dir="rtl"] .xl\\:-ms-5{
    margin-right: -1.25rem;
  }

  [dir="ltr"] .xl\\:-me-5{
    margin-right: -1.25rem;
  }

  [dir="rtl"] .xl\\:-me-5{
    margin-left: -1.25rem;
  }

  [dir="ltr"] .xl\\:-ms-6{
    margin-left: -1.5rem;
  }

  [dir="rtl"] .xl\\:-ms-6{
    margin-right: -1.5rem;
  }

  [dir="ltr"] .xl\\:-me-6{
    margin-right: -1.5rem;
  }

  [dir="rtl"] .xl\\:-me-6{
    margin-left: -1.5rem;
  }

  [dir="ltr"] .xl\\:-ms-7{
    margin-left: -1.75rem;
  }

  [dir="rtl"] .xl\\:-ms-7{
    margin-right: -1.75rem;
  }

  [dir="ltr"] .xl\\:-me-7{
    margin-right: -1.75rem;
  }

  [dir="rtl"] .xl\\:-me-7{
    margin-left: -1.75rem;
  }

  [dir="ltr"] .xl\\:-ms-8{
    margin-left: -2rem;
  }

  [dir="rtl"] .xl\\:-ms-8{
    margin-right: -2rem;
  }

  [dir="ltr"] .xl\\:-me-8{
    margin-right: -2rem;
  }

  [dir="rtl"] .xl\\:-me-8{
    margin-left: -2rem;
  }

  [dir="ltr"] .xl\\:-ms-9{
    margin-left: -2.25rem;
  }

  [dir="rtl"] .xl\\:-ms-9{
    margin-right: -2.25rem;
  }

  [dir="ltr"] .xl\\:-me-9{
    margin-right: -2.25rem;
  }

  [dir="rtl"] .xl\\:-me-9{
    margin-left: -2.25rem;
  }

  [dir="ltr"] .xl\\:-ms-10{
    margin-left: -2.5rem;
  }

  [dir="rtl"] .xl\\:-ms-10{
    margin-right: -2.5rem;
  }

  [dir="ltr"] .xl\\:-me-10{
    margin-right: -2.5rem;
  }

  [dir="rtl"] .xl\\:-me-10{
    margin-left: -2.5rem;
  }

  [dir="ltr"] .xl\\:-ms-11{
    margin-left: -2.75rem;
  }

  [dir="rtl"] .xl\\:-ms-11{
    margin-right: -2.75rem;
  }

  [dir="ltr"] .xl\\:-me-11{
    margin-right: -2.75rem;
  }

  [dir="rtl"] .xl\\:-me-11{
    margin-left: -2.75rem;
  }

  [dir="ltr"] .xl\\:-ms-12{
    margin-left: -3rem;
  }

  [dir="rtl"] .xl\\:-ms-12{
    margin-right: -3rem;
  }

  [dir="ltr"] .xl\\:-me-12{
    margin-right: -3rem;
  }

  [dir="rtl"] .xl\\:-me-12{
    margin-left: -3rem;
  }

  [dir="ltr"] .xl\\:-ms-14{
    margin-left: -3.5rem;
  }

  [dir="rtl"] .xl\\:-ms-14{
    margin-right: -3.5rem;
  }

  [dir="ltr"] .xl\\:-me-14{
    margin-right: -3.5rem;
  }

  [dir="rtl"] .xl\\:-me-14{
    margin-left: -3.5rem;
  }

  [dir="ltr"] .xl\\:-ms-15{
    margin-left: -3.75rem;
  }

  [dir="rtl"] .xl\\:-ms-15{
    margin-right: -3.75rem;
  }

  [dir="ltr"] .xl\\:-me-15{
    margin-right: -3.75rem;
  }

  [dir="rtl"] .xl\\:-me-15{
    margin-left: -3.75rem;
  }

  [dir="ltr"] .xl\\:-ms-16{
    margin-left: -4rem;
  }

  [dir="rtl"] .xl\\:-ms-16{
    margin-right: -4rem;
  }

  [dir="ltr"] .xl\\:-me-16{
    margin-right: -4rem;
  }

  [dir="rtl"] .xl\\:-me-16{
    margin-left: -4rem;
  }

  [dir="ltr"] .xl\\:-ms-18{
    margin-left: -4.5rem;
  }

  [dir="rtl"] .xl\\:-ms-18{
    margin-right: -4.5rem;
  }

  [dir="ltr"] .xl\\:-me-18{
    margin-right: -4.5rem;
  }

  [dir="rtl"] .xl\\:-me-18{
    margin-left: -4.5rem;
  }

  [dir="ltr"] .xl\\:-ms-20{
    margin-left: -5rem;
  }

  [dir="rtl"] .xl\\:-ms-20{
    margin-right: -5rem;
  }

  [dir="ltr"] .xl\\:-me-20{
    margin-right: -5rem;
  }

  [dir="rtl"] .xl\\:-me-20{
    margin-left: -5rem;
  }

  [dir="ltr"] .xl\\:-ms-22{
    margin-left: -5.5rem;
  }

  [dir="rtl"] .xl\\:-ms-22{
    margin-right: -5.5rem;
  }

  [dir="ltr"] .xl\\:-me-22{
    margin-right: -5.5rem;
  }

  [dir="rtl"] .xl\\:-me-22{
    margin-left: -5.5rem;
  }

  [dir="ltr"] .xl\\:-ms-23{
    margin-left: -5.75rem;
  }

  [dir="rtl"] .xl\\:-ms-23{
    margin-right: -5.75rem;
  }

  [dir="ltr"] .xl\\:-me-23{
    margin-right: -5.75rem;
  }

  [dir="rtl"] .xl\\:-me-23{
    margin-left: -5.75rem;
  }

  [dir="ltr"] .xl\\:-ms-24{
    margin-left: -6rem;
  }

  [dir="rtl"] .xl\\:-ms-24{
    margin-right: -6rem;
  }

  [dir="ltr"] .xl\\:-me-24{
    margin-right: -6rem;
  }

  [dir="rtl"] .xl\\:-me-24{
    margin-left: -6rem;
  }

  [dir="ltr"] .xl\\:-ms-25{
    margin-left: -6.25rem;
  }

  [dir="rtl"] .xl\\:-ms-25{
    margin-right: -6.25rem;
  }

  [dir="ltr"] .xl\\:-me-25{
    margin-right: -6.25rem;
  }

  [dir="rtl"] .xl\\:-me-25{
    margin-left: -6.25rem;
  }

  [dir="ltr"] .xl\\:-ms-26{
    margin-left: -6.5rem;
  }

  [dir="rtl"] .xl\\:-ms-26{
    margin-right: -6.5rem;
  }

  [dir="ltr"] .xl\\:-me-26{
    margin-right: -6.5rem;
  }

  [dir="rtl"] .xl\\:-me-26{
    margin-left: -6.5rem;
  }

  [dir="ltr"] .xl\\:-ms-28{
    margin-left: -7rem;
  }

  [dir="rtl"] .xl\\:-ms-28{
    margin-right: -7rem;
  }

  [dir="ltr"] .xl\\:-me-28{
    margin-right: -7rem;
  }

  [dir="rtl"] .xl\\:-me-28{
    margin-left: -7rem;
  }

  [dir="ltr"] .xl\\:-ms-30{
    margin-left: -7.5rem;
  }

  [dir="rtl"] .xl\\:-ms-30{
    margin-right: -7.5rem;
  }

  [dir="ltr"] .xl\\:-me-30{
    margin-right: -7.5rem;
  }

  [dir="rtl"] .xl\\:-me-30{
    margin-left: -7.5rem;
  }

  [dir="ltr"] .xl\\:-ms-32{
    margin-left: -8rem;
  }

  [dir="rtl"] .xl\\:-ms-32{
    margin-right: -8rem;
  }

  [dir="ltr"] .xl\\:-me-32{
    margin-right: -8rem;
  }

  [dir="rtl"] .xl\\:-me-32{
    margin-left: -8rem;
  }

  [dir="ltr"] .xl\\:-ms-34{
    margin-left: -8.5rem;
  }

  [dir="rtl"] .xl\\:-ms-34{
    margin-right: -8.5rem;
  }

  [dir="ltr"] .xl\\:-me-34{
    margin-right: -8.5rem;
  }

  [dir="rtl"] .xl\\:-me-34{
    margin-left: -8.5rem;
  }

  [dir="ltr"] .xl\\:-ms-40{
    margin-left: -10rem;
  }

  [dir="rtl"] .xl\\:-ms-40{
    margin-right: -10rem;
  }

  [dir="ltr"] .xl\\:-me-40{
    margin-right: -10rem;
  }

  [dir="rtl"] .xl\\:-me-40{
    margin-left: -10rem;
  }

  [dir="ltr"] .xl\\:-ms-42{
    margin-left: -10.5rem;
  }

  [dir="rtl"] .xl\\:-ms-42{
    margin-right: -10.5rem;
  }

  [dir="ltr"] .xl\\:-me-42{
    margin-right: -10.5rem;
  }

  [dir="rtl"] .xl\\:-me-42{
    margin-left: -10.5rem;
  }

  [dir="ltr"] .xl\\:-ms-44{
    margin-left: -11rem;
  }

  [dir="rtl"] .xl\\:-ms-44{
    margin-right: -11rem;
  }

  [dir="ltr"] .xl\\:-me-44{
    margin-right: -11rem;
  }

  [dir="rtl"] .xl\\:-me-44{
    margin-left: -11rem;
  }

  [dir="ltr"] .xl\\:-ms-48{
    margin-left: -12rem;
  }

  [dir="rtl"] .xl\\:-ms-48{
    margin-right: -12rem;
  }

  [dir="ltr"] .xl\\:-me-48{
    margin-right: -12rem;
  }

  [dir="rtl"] .xl\\:-me-48{
    margin-left: -12rem;
  }

  [dir="ltr"] .xl\\:-ms-52{
    margin-left: -13rem;
  }

  [dir="rtl"] .xl\\:-ms-52{
    margin-right: -13rem;
  }

  [dir="ltr"] .xl\\:-me-52{
    margin-right: -13rem;
  }

  [dir="rtl"] .xl\\:-me-52{
    margin-left: -13rem;
  }

  [dir="ltr"] .xl\\:-ms-54{
    margin-left: -13.5rem;
  }

  [dir="rtl"] .xl\\:-ms-54{
    margin-right: -13.5rem;
  }

  [dir="ltr"] .xl\\:-me-54{
    margin-right: -13.5rem;
  }

  [dir="rtl"] .xl\\:-me-54{
    margin-left: -13.5rem;
  }

  [dir="ltr"] .xl\\:-ms-56{
    margin-left: -14rem;
  }

  [dir="rtl"] .xl\\:-ms-56{
    margin-right: -14rem;
  }

  [dir="ltr"] .xl\\:-me-56{
    margin-right: -14rem;
  }

  [dir="rtl"] .xl\\:-me-56{
    margin-left: -14rem;
  }

  [dir="ltr"] .xl\\:-ms-60{
    margin-left: -15rem;
  }

  [dir="rtl"] .xl\\:-ms-60{
    margin-right: -15rem;
  }

  [dir="ltr"] .xl\\:-me-60{
    margin-right: -15rem;
  }

  [dir="rtl"] .xl\\:-me-60{
    margin-left: -15rem;
  }

  [dir="ltr"] .xl\\:-ms-64{
    margin-left: -16rem;
  }

  [dir="rtl"] .xl\\:-ms-64{
    margin-right: -16rem;
  }

  [dir="ltr"] .xl\\:-me-64{
    margin-right: -16rem;
  }

  [dir="rtl"] .xl\\:-me-64{
    margin-left: -16rem;
  }

  [dir="ltr"] .xl\\:-ms-68{
    margin-left: -17rem;
  }

  [dir="rtl"] .xl\\:-ms-68{
    margin-right: -17rem;
  }

  [dir="ltr"] .xl\\:-me-68{
    margin-right: -17rem;
  }

  [dir="rtl"] .xl\\:-me-68{
    margin-left: -17rem;
  }

  [dir="ltr"] .xl\\:-ms-72{
    margin-left: -18rem;
  }

  [dir="rtl"] .xl\\:-ms-72{
    margin-right: -18rem;
  }

  [dir="ltr"] .xl\\:-me-72{
    margin-right: -18rem;
  }

  [dir="rtl"] .xl\\:-me-72{
    margin-left: -18rem;
  }

  [dir="ltr"] .xl\\:-ms-74{
    margin-left: -18.5rem;
  }

  [dir="rtl"] .xl\\:-ms-74{
    margin-right: -18.5rem;
  }

  [dir="ltr"] .xl\\:-me-74{
    margin-right: -18.5rem;
  }

  [dir="rtl"] .xl\\:-me-74{
    margin-left: -18.5rem;
  }

  [dir="ltr"] .xl\\:-ms-76{
    margin-left: -19rem;
  }

  [dir="rtl"] .xl\\:-ms-76{
    margin-right: -19rem;
  }

  [dir="ltr"] .xl\\:-me-76{
    margin-right: -19rem;
  }

  [dir="rtl"] .xl\\:-me-76{
    margin-left: -19rem;
  }

  [dir="ltr"] .xl\\:-ms-78{
    margin-left: -19.5rem;
  }

  [dir="rtl"] .xl\\:-ms-78{
    margin-right: -19.5rem;
  }

  [dir="ltr"] .xl\\:-me-78{
    margin-right: -19.5rem;
  }

  [dir="rtl"] .xl\\:-me-78{
    margin-left: -19.5rem;
  }

  [dir="ltr"] .xl\\:-ms-80{
    margin-left: -20rem;
  }

  [dir="rtl"] .xl\\:-ms-80{
    margin-right: -20rem;
  }

  [dir="ltr"] .xl\\:-me-80{
    margin-right: -20rem;
  }

  [dir="rtl"] .xl\\:-me-80{
    margin-left: -20rem;
  }

  [dir="ltr"] .xl\\:-ms-82{
    margin-left: -20.5rem;
  }

  [dir="rtl"] .xl\\:-ms-82{
    margin-right: -20.5rem;
  }

  [dir="ltr"] .xl\\:-me-82{
    margin-right: -20.5rem;
  }

  [dir="rtl"] .xl\\:-me-82{
    margin-left: -20.5rem;
  }

  [dir="ltr"] .xl\\:-ms-84{
    margin-left: -21rem;
  }

  [dir="rtl"] .xl\\:-ms-84{
    margin-right: -21rem;
  }

  [dir="ltr"] .xl\\:-me-84{
    margin-right: -21rem;
  }

  [dir="rtl"] .xl\\:-me-84{
    margin-left: -21rem;
  }

  [dir="ltr"] .xl\\:-ms-88{
    margin-left: -22rem;
  }

  [dir="rtl"] .xl\\:-ms-88{
    margin-right: -22rem;
  }

  [dir="ltr"] .xl\\:-me-88{
    margin-right: -22rem;
  }

  [dir="rtl"] .xl\\:-me-88{
    margin-left: -22rem;
  }

  [dir="ltr"] .xl\\:-ms-92{
    margin-left: -23rem;
  }

  [dir="rtl"] .xl\\:-ms-92{
    margin-right: -23rem;
  }

  [dir="ltr"] .xl\\:-me-92{
    margin-right: -23rem;
  }

  [dir="rtl"] .xl\\:-me-92{
    margin-left: -23rem;
  }

  [dir="ltr"] .xl\\:-ms-96{
    margin-left: -24rem;
  }

  [dir="rtl"] .xl\\:-ms-96{
    margin-right: -24rem;
  }

  [dir="ltr"] .xl\\:-me-96{
    margin-right: -24rem;
  }

  [dir="rtl"] .xl\\:-me-96{
    margin-left: -24rem;
  }

  [dir="ltr"] .xl\\:-ms-98{
    margin-left: -24.5rem;
  }

  [dir="rtl"] .xl\\:-ms-98{
    margin-right: -24.5rem;
  }

  [dir="ltr"] .xl\\:-me-98{
    margin-right: -24.5rem;
  }

  [dir="rtl"] .xl\\:-me-98{
    margin-left: -24.5rem;
  }

  [dir="ltr"] .xl\\:-ms-100{
    margin-left: -25rem;
  }

  [dir="rtl"] .xl\\:-ms-100{
    margin-right: -25rem;
  }

  [dir="ltr"] .xl\\:-me-100{
    margin-right: -25rem;
  }

  [dir="rtl"] .xl\\:-me-100{
    margin-left: -25rem;
  }

  [dir="ltr"] .xl\\:-ms-104{
    margin-left: -26rem;
  }

  [dir="rtl"] .xl\\:-ms-104{
    margin-right: -26rem;
  }

  [dir="ltr"] .xl\\:-me-104{
    margin-right: -26rem;
  }

  [dir="rtl"] .xl\\:-me-104{
    margin-left: -26rem;
  }

  [dir="ltr"] .xl\\:-ms-112{
    margin-left: -28rem;
  }

  [dir="rtl"] .xl\\:-ms-112{
    margin-right: -28rem;
  }

  [dir="ltr"] .xl\\:-me-112{
    margin-right: -28rem;
  }

  [dir="rtl"] .xl\\:-me-112{
    margin-left: -28rem;
  }

  [dir="ltr"] .xl\\:-ms-124{
    margin-left: -31rem;
  }

  [dir="rtl"] .xl\\:-ms-124{
    margin-right: -31rem;
  }

  [dir="ltr"] .xl\\:-me-124{
    margin-right: -31rem;
  }

  [dir="rtl"] .xl\\:-me-124{
    margin-left: -31rem;
  }

  [dir="ltr"] .xl\\:-ms-128{
    margin-left: -32rem;
  }

  [dir="rtl"] .xl\\:-ms-128{
    margin-right: -32rem;
  }

  [dir="ltr"] .xl\\:-me-128{
    margin-right: -32rem;
  }

  [dir="rtl"] .xl\\:-me-128{
    margin-left: -32rem;
  }

  [dir="ltr"] .xl\\:-ms-140{
    margin-left: -35rem;
  }

  [dir="rtl"] .xl\\:-ms-140{
    margin-right: -35rem;
  }

  [dir="ltr"] .xl\\:-me-140{
    margin-right: -35rem;
  }

  [dir="rtl"] .xl\\:-me-140{
    margin-left: -35rem;
  }

  [dir="ltr"] .xl\\:-ms-152{
    margin-left: -38rem;
  }

  [dir="rtl"] .xl\\:-ms-152{
    margin-right: -38rem;
  }

  [dir="ltr"] .xl\\:-me-152{
    margin-right: -38rem;
  }

  [dir="rtl"] .xl\\:-me-152{
    margin-left: -38rem;
  }

  [dir="ltr"] .xl\\:-ms-160{
    margin-left: -40rem;
  }

  [dir="rtl"] .xl\\:-ms-160{
    margin-right: -40rem;
  }

  [dir="ltr"] .xl\\:-me-160{
    margin-right: -40rem;
  }

  [dir="rtl"] .xl\\:-me-160{
    margin-left: -40rem;
  }

  [dir="ltr"] .xl\\:-ms-162{
    margin-left: -41rem;
  }

  [dir="rtl"] .xl\\:-ms-162{
    margin-right: -41rem;
  }

  [dir="ltr"] .xl\\:-me-162{
    margin-right: -41rem;
  }

  [dir="rtl"] .xl\\:-me-162{
    margin-left: -41rem;
  }

  [dir="ltr"] .xl\\:-ms-192{
    margin-left: -48rem;
  }

  [dir="rtl"] .xl\\:-ms-192{
    margin-right: -48rem;
  }

  [dir="ltr"] .xl\\:-me-192{
    margin-right: -48rem;
  }

  [dir="rtl"] .xl\\:-me-192{
    margin-left: -48rem;
  }

  [dir="ltr"] .xl\\:-ms-208{
    margin-left: -52rem;
  }

  [dir="rtl"] .xl\\:-ms-208{
    margin-right: -52rem;
  }

  [dir="ltr"] .xl\\:-me-208{
    margin-right: -52rem;
  }

  [dir="rtl"] .xl\\:-me-208{
    margin-left: -52rem;
  }

  [dir="ltr"] .xl\\:-ms-224{
    margin-left: -56rem;
  }

  [dir="rtl"] .xl\\:-ms-224{
    margin-right: -56rem;
  }

  [dir="ltr"] .xl\\:-me-224{
    margin-right: -56rem;
  }

  [dir="rtl"] .xl\\:-me-224{
    margin-left: -56rem;
  }

  [dir="ltr"] .xl\\:-ms-256{
    margin-left: -64rem;
  }

  [dir="rtl"] .xl\\:-ms-256{
    margin-right: -64rem;
  }

  [dir="ltr"] .xl\\:-me-256{
    margin-right: -64rem;
  }

  [dir="rtl"] .xl\\:-me-256{
    margin-left: -64rem;
  }

  [dir="ltr"] .xl\\:-ms-px{
    margin-left: -1px;
  }

  [dir="rtl"] .xl\\:-ms-px{
    margin-right: -1px;
  }

  [dir="ltr"] .xl\\:-me-px{
    margin-right: -1px;
  }

  [dir="rtl"] .xl\\:-me-px{
    margin-left: -1px;
  }

  [dir="ltr"] .xl\\:first\\:ms-0:first-child{
    margin-left: 0;
  }

  [dir="rtl"] .xl\\:first\\:ms-0:first-child{
    margin-right: 0;
  }

  [dir="ltr"] .xl\\:first\\:me-0:first-child{
    margin-right: 0;
  }

  [dir="rtl"] .xl\\:first\\:me-0:first-child{
    margin-left: 0;
  }

  [dir="ltr"] .xl\\:first\\:ms-1:first-child{
    margin-left: 0.25rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-1:first-child{
    margin-right: 0.25rem;
  }

  [dir="ltr"] .xl\\:first\\:me-1:first-child{
    margin-right: 0.25rem;
  }

  [dir="rtl"] .xl\\:first\\:me-1:first-child{
    margin-left: 0.25rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-2:first-child{
    margin-left: 0.5rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-2:first-child{
    margin-right: 0.5rem;
  }

  [dir="ltr"] .xl\\:first\\:me-2:first-child{
    margin-right: 0.5rem;
  }

  [dir="rtl"] .xl\\:first\\:me-2:first-child{
    margin-left: 0.5rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-3:first-child{
    margin-left: 0.75rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-3:first-child{
    margin-right: 0.75rem;
  }

  [dir="ltr"] .xl\\:first\\:me-3:first-child{
    margin-right: 0.75rem;
  }

  [dir="rtl"] .xl\\:first\\:me-3:first-child{
    margin-left: 0.75rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-4:first-child{
    margin-left: 1rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-4:first-child{
    margin-right: 1rem;
  }

  [dir="ltr"] .xl\\:first\\:me-4:first-child{
    margin-right: 1rem;
  }

  [dir="rtl"] .xl\\:first\\:me-4:first-child{
    margin-left: 1rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-5:first-child{
    margin-left: 1.25rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-5:first-child{
    margin-right: 1.25rem;
  }

  [dir="ltr"] .xl\\:first\\:me-5:first-child{
    margin-right: 1.25rem;
  }

  [dir="rtl"] .xl\\:first\\:me-5:first-child{
    margin-left: 1.25rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-6:first-child{
    margin-left: 1.5rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-6:first-child{
    margin-right: 1.5rem;
  }

  [dir="ltr"] .xl\\:first\\:me-6:first-child{
    margin-right: 1.5rem;
  }

  [dir="rtl"] .xl\\:first\\:me-6:first-child{
    margin-left: 1.5rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-7:first-child{
    margin-left: 1.75rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-7:first-child{
    margin-right: 1.75rem;
  }

  [dir="ltr"] .xl\\:first\\:me-7:first-child{
    margin-right: 1.75rem;
  }

  [dir="rtl"] .xl\\:first\\:me-7:first-child{
    margin-left: 1.75rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-8:first-child{
    margin-left: 2rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-8:first-child{
    margin-right: 2rem;
  }

  [dir="ltr"] .xl\\:first\\:me-8:first-child{
    margin-right: 2rem;
  }

  [dir="rtl"] .xl\\:first\\:me-8:first-child{
    margin-left: 2rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-9:first-child{
    margin-left: 2.25rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-9:first-child{
    margin-right: 2.25rem;
  }

  [dir="ltr"] .xl\\:first\\:me-9:first-child{
    margin-right: 2.25rem;
  }

  [dir="rtl"] .xl\\:first\\:me-9:first-child{
    margin-left: 2.25rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-10:first-child{
    margin-left: 2.5rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-10:first-child{
    margin-right: 2.5rem;
  }

  [dir="ltr"] .xl\\:first\\:me-10:first-child{
    margin-right: 2.5rem;
  }

  [dir="rtl"] .xl\\:first\\:me-10:first-child{
    margin-left: 2.5rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-11:first-child{
    margin-left: 2.75rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-11:first-child{
    margin-right: 2.75rem;
  }

  [dir="ltr"] .xl\\:first\\:me-11:first-child{
    margin-right: 2.75rem;
  }

  [dir="rtl"] .xl\\:first\\:me-11:first-child{
    margin-left: 2.75rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-12:first-child{
    margin-left: 3rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-12:first-child{
    margin-right: 3rem;
  }

  [dir="ltr"] .xl\\:first\\:me-12:first-child{
    margin-right: 3rem;
  }

  [dir="rtl"] .xl\\:first\\:me-12:first-child{
    margin-left: 3rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-14:first-child{
    margin-left: 3.5rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-14:first-child{
    margin-right: 3.5rem;
  }

  [dir="ltr"] .xl\\:first\\:me-14:first-child{
    margin-right: 3.5rem;
  }

  [dir="rtl"] .xl\\:first\\:me-14:first-child{
    margin-left: 3.5rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-15:first-child{
    margin-left: 3.75rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-15:first-child{
    margin-right: 3.75rem;
  }

  [dir="ltr"] .xl\\:first\\:me-15:first-child{
    margin-right: 3.75rem;
  }

  [dir="rtl"] .xl\\:first\\:me-15:first-child{
    margin-left: 3.75rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-16:first-child{
    margin-left: 4rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-16:first-child{
    margin-right: 4rem;
  }

  [dir="ltr"] .xl\\:first\\:me-16:first-child{
    margin-right: 4rem;
  }

  [dir="rtl"] .xl\\:first\\:me-16:first-child{
    margin-left: 4rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-18:first-child{
    margin-left: 4.5rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-18:first-child{
    margin-right: 4.5rem;
  }

  [dir="ltr"] .xl\\:first\\:me-18:first-child{
    margin-right: 4.5rem;
  }

  [dir="rtl"] .xl\\:first\\:me-18:first-child{
    margin-left: 4.5rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-20:first-child{
    margin-left: 5rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-20:first-child{
    margin-right: 5rem;
  }

  [dir="ltr"] .xl\\:first\\:me-20:first-child{
    margin-right: 5rem;
  }

  [dir="rtl"] .xl\\:first\\:me-20:first-child{
    margin-left: 5rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-22:first-child{
    margin-left: 5.5rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-22:first-child{
    margin-right: 5.5rem;
  }

  [dir="ltr"] .xl\\:first\\:me-22:first-child{
    margin-right: 5.5rem;
  }

  [dir="rtl"] .xl\\:first\\:me-22:first-child{
    margin-left: 5.5rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-23:first-child{
    margin-left: 5.75rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-23:first-child{
    margin-right: 5.75rem;
  }

  [dir="ltr"] .xl\\:first\\:me-23:first-child{
    margin-right: 5.75rem;
  }

  [dir="rtl"] .xl\\:first\\:me-23:first-child{
    margin-left: 5.75rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-24:first-child{
    margin-left: 6rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-24:first-child{
    margin-right: 6rem;
  }

  [dir="ltr"] .xl\\:first\\:me-24:first-child{
    margin-right: 6rem;
  }

  [dir="rtl"] .xl\\:first\\:me-24:first-child{
    margin-left: 6rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-25:first-child{
    margin-left: 6.25rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-25:first-child{
    margin-right: 6.25rem;
  }

  [dir="ltr"] .xl\\:first\\:me-25:first-child{
    margin-right: 6.25rem;
  }

  [dir="rtl"] .xl\\:first\\:me-25:first-child{
    margin-left: 6.25rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-26:first-child{
    margin-left: 6.5rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-26:first-child{
    margin-right: 6.5rem;
  }

  [dir="ltr"] .xl\\:first\\:me-26:first-child{
    margin-right: 6.5rem;
  }

  [dir="rtl"] .xl\\:first\\:me-26:first-child{
    margin-left: 6.5rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-28:first-child{
    margin-left: 7rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-28:first-child{
    margin-right: 7rem;
  }

  [dir="ltr"] .xl\\:first\\:me-28:first-child{
    margin-right: 7rem;
  }

  [dir="rtl"] .xl\\:first\\:me-28:first-child{
    margin-left: 7rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-30:first-child{
    margin-left: 7.5rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-30:first-child{
    margin-right: 7.5rem;
  }

  [dir="ltr"] .xl\\:first\\:me-30:first-child{
    margin-right: 7.5rem;
  }

  [dir="rtl"] .xl\\:first\\:me-30:first-child{
    margin-left: 7.5rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-32:first-child{
    margin-left: 8rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-32:first-child{
    margin-right: 8rem;
  }

  [dir="ltr"] .xl\\:first\\:me-32:first-child{
    margin-right: 8rem;
  }

  [dir="rtl"] .xl\\:first\\:me-32:first-child{
    margin-left: 8rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-34:first-child{
    margin-left: 8.5rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-34:first-child{
    margin-right: 8.5rem;
  }

  [dir="ltr"] .xl\\:first\\:me-34:first-child{
    margin-right: 8.5rem;
  }

  [dir="rtl"] .xl\\:first\\:me-34:first-child{
    margin-left: 8.5rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-40:first-child{
    margin-left: 10rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-40:first-child{
    margin-right: 10rem;
  }

  [dir="ltr"] .xl\\:first\\:me-40:first-child{
    margin-right: 10rem;
  }

  [dir="rtl"] .xl\\:first\\:me-40:first-child{
    margin-left: 10rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-42:first-child{
    margin-left: 10.5rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-42:first-child{
    margin-right: 10.5rem;
  }

  [dir="ltr"] .xl\\:first\\:me-42:first-child{
    margin-right: 10.5rem;
  }

  [dir="rtl"] .xl\\:first\\:me-42:first-child{
    margin-left: 10.5rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-44:first-child{
    margin-left: 11rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-44:first-child{
    margin-right: 11rem;
  }

  [dir="ltr"] .xl\\:first\\:me-44:first-child{
    margin-right: 11rem;
  }

  [dir="rtl"] .xl\\:first\\:me-44:first-child{
    margin-left: 11rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-48:first-child{
    margin-left: 12rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-48:first-child{
    margin-right: 12rem;
  }

  [dir="ltr"] .xl\\:first\\:me-48:first-child{
    margin-right: 12rem;
  }

  [dir="rtl"] .xl\\:first\\:me-48:first-child{
    margin-left: 12rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-52:first-child{
    margin-left: 13rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-52:first-child{
    margin-right: 13rem;
  }

  [dir="ltr"] .xl\\:first\\:me-52:first-child{
    margin-right: 13rem;
  }

  [dir="rtl"] .xl\\:first\\:me-52:first-child{
    margin-left: 13rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-54:first-child{
    margin-left: 13.5rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-54:first-child{
    margin-right: 13.5rem;
  }

  [dir="ltr"] .xl\\:first\\:me-54:first-child{
    margin-right: 13.5rem;
  }

  [dir="rtl"] .xl\\:first\\:me-54:first-child{
    margin-left: 13.5rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-56:first-child{
    margin-left: 14rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-56:first-child{
    margin-right: 14rem;
  }

  [dir="ltr"] .xl\\:first\\:me-56:first-child{
    margin-right: 14rem;
  }

  [dir="rtl"] .xl\\:first\\:me-56:first-child{
    margin-left: 14rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-60:first-child{
    margin-left: 15rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-60:first-child{
    margin-right: 15rem;
  }

  [dir="ltr"] .xl\\:first\\:me-60:first-child{
    margin-right: 15rem;
  }

  [dir="rtl"] .xl\\:first\\:me-60:first-child{
    margin-left: 15rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-64:first-child{
    margin-left: 16rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-64:first-child{
    margin-right: 16rem;
  }

  [dir="ltr"] .xl\\:first\\:me-64:first-child{
    margin-right: 16rem;
  }

  [dir="rtl"] .xl\\:first\\:me-64:first-child{
    margin-left: 16rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-68:first-child{
    margin-left: 17rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-68:first-child{
    margin-right: 17rem;
  }

  [dir="ltr"] .xl\\:first\\:me-68:first-child{
    margin-right: 17rem;
  }

  [dir="rtl"] .xl\\:first\\:me-68:first-child{
    margin-left: 17rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-72:first-child{
    margin-left: 18rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-72:first-child{
    margin-right: 18rem;
  }

  [dir="ltr"] .xl\\:first\\:me-72:first-child{
    margin-right: 18rem;
  }

  [dir="rtl"] .xl\\:first\\:me-72:first-child{
    margin-left: 18rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-74:first-child{
    margin-left: 18.5rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-74:first-child{
    margin-right: 18.5rem;
  }

  [dir="ltr"] .xl\\:first\\:me-74:first-child{
    margin-right: 18.5rem;
  }

  [dir="rtl"] .xl\\:first\\:me-74:first-child{
    margin-left: 18.5rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-76:first-child{
    margin-left: 19rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-76:first-child{
    margin-right: 19rem;
  }

  [dir="ltr"] .xl\\:first\\:me-76:first-child{
    margin-right: 19rem;
  }

  [dir="rtl"] .xl\\:first\\:me-76:first-child{
    margin-left: 19rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-78:first-child{
    margin-left: 19.5rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-78:first-child{
    margin-right: 19.5rem;
  }

  [dir="ltr"] .xl\\:first\\:me-78:first-child{
    margin-right: 19.5rem;
  }

  [dir="rtl"] .xl\\:first\\:me-78:first-child{
    margin-left: 19.5rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-80:first-child{
    margin-left: 20rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-80:first-child{
    margin-right: 20rem;
  }

  [dir="ltr"] .xl\\:first\\:me-80:first-child{
    margin-right: 20rem;
  }

  [dir="rtl"] .xl\\:first\\:me-80:first-child{
    margin-left: 20rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-82:first-child{
    margin-left: 20.5rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-82:first-child{
    margin-right: 20.5rem;
  }

  [dir="ltr"] .xl\\:first\\:me-82:first-child{
    margin-right: 20.5rem;
  }

  [dir="rtl"] .xl\\:first\\:me-82:first-child{
    margin-left: 20.5rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-84:first-child{
    margin-left: 21rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-84:first-child{
    margin-right: 21rem;
  }

  [dir="ltr"] .xl\\:first\\:me-84:first-child{
    margin-right: 21rem;
  }

  [dir="rtl"] .xl\\:first\\:me-84:first-child{
    margin-left: 21rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-88:first-child{
    margin-left: 22rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-88:first-child{
    margin-right: 22rem;
  }

  [dir="ltr"] .xl\\:first\\:me-88:first-child{
    margin-right: 22rem;
  }

  [dir="rtl"] .xl\\:first\\:me-88:first-child{
    margin-left: 22rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-92:first-child{
    margin-left: 23rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-92:first-child{
    margin-right: 23rem;
  }

  [dir="ltr"] .xl\\:first\\:me-92:first-child{
    margin-right: 23rem;
  }

  [dir="rtl"] .xl\\:first\\:me-92:first-child{
    margin-left: 23rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-96:first-child{
    margin-left: 24rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-96:first-child{
    margin-right: 24rem;
  }

  [dir="ltr"] .xl\\:first\\:me-96:first-child{
    margin-right: 24rem;
  }

  [dir="rtl"] .xl\\:first\\:me-96:first-child{
    margin-left: 24rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-98:first-child{
    margin-left: 24.5rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-98:first-child{
    margin-right: 24.5rem;
  }

  [dir="ltr"] .xl\\:first\\:me-98:first-child{
    margin-right: 24.5rem;
  }

  [dir="rtl"] .xl\\:first\\:me-98:first-child{
    margin-left: 24.5rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-100:first-child{
    margin-left: 25rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-100:first-child{
    margin-right: 25rem;
  }

  [dir="ltr"] .xl\\:first\\:me-100:first-child{
    margin-right: 25rem;
  }

  [dir="rtl"] .xl\\:first\\:me-100:first-child{
    margin-left: 25rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-104:first-child{
    margin-left: 26rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-104:first-child{
    margin-right: 26rem;
  }

  [dir="ltr"] .xl\\:first\\:me-104:first-child{
    margin-right: 26rem;
  }

  [dir="rtl"] .xl\\:first\\:me-104:first-child{
    margin-left: 26rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-112:first-child{
    margin-left: 28rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-112:first-child{
    margin-right: 28rem;
  }

  [dir="ltr"] .xl\\:first\\:me-112:first-child{
    margin-right: 28rem;
  }

  [dir="rtl"] .xl\\:first\\:me-112:first-child{
    margin-left: 28rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-124:first-child{
    margin-left: 31rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-124:first-child{
    margin-right: 31rem;
  }

  [dir="ltr"] .xl\\:first\\:me-124:first-child{
    margin-right: 31rem;
  }

  [dir="rtl"] .xl\\:first\\:me-124:first-child{
    margin-left: 31rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-128:first-child{
    margin-left: 32rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-128:first-child{
    margin-right: 32rem;
  }

  [dir="ltr"] .xl\\:first\\:me-128:first-child{
    margin-right: 32rem;
  }

  [dir="rtl"] .xl\\:first\\:me-128:first-child{
    margin-left: 32rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-140:first-child{
    margin-left: 35rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-140:first-child{
    margin-right: 35rem;
  }

  [dir="ltr"] .xl\\:first\\:me-140:first-child{
    margin-right: 35rem;
  }

  [dir="rtl"] .xl\\:first\\:me-140:first-child{
    margin-left: 35rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-152:first-child{
    margin-left: 38rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-152:first-child{
    margin-right: 38rem;
  }

  [dir="ltr"] .xl\\:first\\:me-152:first-child{
    margin-right: 38rem;
  }

  [dir="rtl"] .xl\\:first\\:me-152:first-child{
    margin-left: 38rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-160:first-child{
    margin-left: 40rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-160:first-child{
    margin-right: 40rem;
  }

  [dir="ltr"] .xl\\:first\\:me-160:first-child{
    margin-right: 40rem;
  }

  [dir="rtl"] .xl\\:first\\:me-160:first-child{
    margin-left: 40rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-162:first-child{
    margin-left: 41rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-162:first-child{
    margin-right: 41rem;
  }

  [dir="ltr"] .xl\\:first\\:me-162:first-child{
    margin-right: 41rem;
  }

  [dir="rtl"] .xl\\:first\\:me-162:first-child{
    margin-left: 41rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-192:first-child{
    margin-left: 48rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-192:first-child{
    margin-right: 48rem;
  }

  [dir="ltr"] .xl\\:first\\:me-192:first-child{
    margin-right: 48rem;
  }

  [dir="rtl"] .xl\\:first\\:me-192:first-child{
    margin-left: 48rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-208:first-child{
    margin-left: 52rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-208:first-child{
    margin-right: 52rem;
  }

  [dir="ltr"] .xl\\:first\\:me-208:first-child{
    margin-right: 52rem;
  }

  [dir="rtl"] .xl\\:first\\:me-208:first-child{
    margin-left: 52rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-224:first-child{
    margin-left: 56rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-224:first-child{
    margin-right: 56rem;
  }

  [dir="ltr"] .xl\\:first\\:me-224:first-child{
    margin-right: 56rem;
  }

  [dir="rtl"] .xl\\:first\\:me-224:first-child{
    margin-left: 56rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-256:first-child{
    margin-left: 64rem;
  }

  [dir="rtl"] .xl\\:first\\:ms-256:first-child{
    margin-right: 64rem;
  }

  [dir="ltr"] .xl\\:first\\:me-256:first-child{
    margin-right: 64rem;
  }

  [dir="rtl"] .xl\\:first\\:me-256:first-child{
    margin-left: 64rem;
  }

  [dir="ltr"] .xl\\:first\\:ms-auto:first-child{
    margin-left: auto;
  }

  [dir="rtl"] .xl\\:first\\:ms-auto:first-child{
    margin-right: auto;
  }

  [dir="ltr"] .xl\\:first\\:me-auto:first-child{
    margin-right: auto;
  }

  [dir="rtl"] .xl\\:first\\:me-auto:first-child{
    margin-left: auto;
  }

  [dir="ltr"] .xl\\:first\\:ms-px:first-child{
    margin-left: 1px;
  }

  [dir="rtl"] .xl\\:first\\:ms-px:first-child{
    margin-right: 1px;
  }

  [dir="ltr"] .xl\\:first\\:me-px:first-child{
    margin-right: 1px;
  }

  [dir="rtl"] .xl\\:first\\:me-px:first-child{
    margin-left: 1px;
  }

  [dir="ltr"] .xl\\:first\\:-ms-1:first-child{
    margin-left: -0.25rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-1:first-child{
    margin-right: -0.25rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-1:first-child{
    margin-right: -0.25rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-1:first-child{
    margin-left: -0.25rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-2:first-child{
    margin-left: -0.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-2:first-child{
    margin-right: -0.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-2:first-child{
    margin-right: -0.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-2:first-child{
    margin-left: -0.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-3:first-child{
    margin-left: -0.75rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-3:first-child{
    margin-right: -0.75rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-3:first-child{
    margin-right: -0.75rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-3:first-child{
    margin-left: -0.75rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-4:first-child{
    margin-left: -1rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-4:first-child{
    margin-right: -1rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-4:first-child{
    margin-right: -1rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-4:first-child{
    margin-left: -1rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-5:first-child{
    margin-left: -1.25rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-5:first-child{
    margin-right: -1.25rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-5:first-child{
    margin-right: -1.25rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-5:first-child{
    margin-left: -1.25rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-6:first-child{
    margin-left: -1.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-6:first-child{
    margin-right: -1.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-6:first-child{
    margin-right: -1.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-6:first-child{
    margin-left: -1.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-7:first-child{
    margin-left: -1.75rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-7:first-child{
    margin-right: -1.75rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-7:first-child{
    margin-right: -1.75rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-7:first-child{
    margin-left: -1.75rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-8:first-child{
    margin-left: -2rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-8:first-child{
    margin-right: -2rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-8:first-child{
    margin-right: -2rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-8:first-child{
    margin-left: -2rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-9:first-child{
    margin-left: -2.25rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-9:first-child{
    margin-right: -2.25rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-9:first-child{
    margin-right: -2.25rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-9:first-child{
    margin-left: -2.25rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-10:first-child{
    margin-left: -2.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-10:first-child{
    margin-right: -2.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-10:first-child{
    margin-right: -2.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-10:first-child{
    margin-left: -2.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-11:first-child{
    margin-left: -2.75rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-11:first-child{
    margin-right: -2.75rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-11:first-child{
    margin-right: -2.75rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-11:first-child{
    margin-left: -2.75rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-12:first-child{
    margin-left: -3rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-12:first-child{
    margin-right: -3rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-12:first-child{
    margin-right: -3rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-12:first-child{
    margin-left: -3rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-14:first-child{
    margin-left: -3.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-14:first-child{
    margin-right: -3.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-14:first-child{
    margin-right: -3.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-14:first-child{
    margin-left: -3.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-15:first-child{
    margin-left: -3.75rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-15:first-child{
    margin-right: -3.75rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-15:first-child{
    margin-right: -3.75rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-15:first-child{
    margin-left: -3.75rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-16:first-child{
    margin-left: -4rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-16:first-child{
    margin-right: -4rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-16:first-child{
    margin-right: -4rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-16:first-child{
    margin-left: -4rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-18:first-child{
    margin-left: -4.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-18:first-child{
    margin-right: -4.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-18:first-child{
    margin-right: -4.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-18:first-child{
    margin-left: -4.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-20:first-child{
    margin-left: -5rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-20:first-child{
    margin-right: -5rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-20:first-child{
    margin-right: -5rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-20:first-child{
    margin-left: -5rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-22:first-child{
    margin-left: -5.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-22:first-child{
    margin-right: -5.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-22:first-child{
    margin-right: -5.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-22:first-child{
    margin-left: -5.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-23:first-child{
    margin-left: -5.75rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-23:first-child{
    margin-right: -5.75rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-23:first-child{
    margin-right: -5.75rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-23:first-child{
    margin-left: -5.75rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-24:first-child{
    margin-left: -6rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-24:first-child{
    margin-right: -6rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-24:first-child{
    margin-right: -6rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-24:first-child{
    margin-left: -6rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-25:first-child{
    margin-left: -6.25rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-25:first-child{
    margin-right: -6.25rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-25:first-child{
    margin-right: -6.25rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-25:first-child{
    margin-left: -6.25rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-26:first-child{
    margin-left: -6.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-26:first-child{
    margin-right: -6.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-26:first-child{
    margin-right: -6.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-26:first-child{
    margin-left: -6.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-28:first-child{
    margin-left: -7rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-28:first-child{
    margin-right: -7rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-28:first-child{
    margin-right: -7rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-28:first-child{
    margin-left: -7rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-30:first-child{
    margin-left: -7.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-30:first-child{
    margin-right: -7.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-30:first-child{
    margin-right: -7.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-30:first-child{
    margin-left: -7.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-32:first-child{
    margin-left: -8rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-32:first-child{
    margin-right: -8rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-32:first-child{
    margin-right: -8rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-32:first-child{
    margin-left: -8rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-34:first-child{
    margin-left: -8.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-34:first-child{
    margin-right: -8.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-34:first-child{
    margin-right: -8.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-34:first-child{
    margin-left: -8.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-40:first-child{
    margin-left: -10rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-40:first-child{
    margin-right: -10rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-40:first-child{
    margin-right: -10rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-40:first-child{
    margin-left: -10rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-42:first-child{
    margin-left: -10.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-42:first-child{
    margin-right: -10.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-42:first-child{
    margin-right: -10.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-42:first-child{
    margin-left: -10.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-44:first-child{
    margin-left: -11rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-44:first-child{
    margin-right: -11rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-44:first-child{
    margin-right: -11rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-44:first-child{
    margin-left: -11rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-48:first-child{
    margin-left: -12rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-48:first-child{
    margin-right: -12rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-48:first-child{
    margin-right: -12rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-48:first-child{
    margin-left: -12rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-52:first-child{
    margin-left: -13rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-52:first-child{
    margin-right: -13rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-52:first-child{
    margin-right: -13rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-52:first-child{
    margin-left: -13rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-54:first-child{
    margin-left: -13.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-54:first-child{
    margin-right: -13.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-54:first-child{
    margin-right: -13.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-54:first-child{
    margin-left: -13.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-56:first-child{
    margin-left: -14rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-56:first-child{
    margin-right: -14rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-56:first-child{
    margin-right: -14rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-56:first-child{
    margin-left: -14rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-60:first-child{
    margin-left: -15rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-60:first-child{
    margin-right: -15rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-60:first-child{
    margin-right: -15rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-60:first-child{
    margin-left: -15rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-64:first-child{
    margin-left: -16rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-64:first-child{
    margin-right: -16rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-64:first-child{
    margin-right: -16rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-64:first-child{
    margin-left: -16rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-68:first-child{
    margin-left: -17rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-68:first-child{
    margin-right: -17rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-68:first-child{
    margin-right: -17rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-68:first-child{
    margin-left: -17rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-72:first-child{
    margin-left: -18rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-72:first-child{
    margin-right: -18rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-72:first-child{
    margin-right: -18rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-72:first-child{
    margin-left: -18rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-74:first-child{
    margin-left: -18.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-74:first-child{
    margin-right: -18.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-74:first-child{
    margin-right: -18.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-74:first-child{
    margin-left: -18.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-76:first-child{
    margin-left: -19rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-76:first-child{
    margin-right: -19rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-76:first-child{
    margin-right: -19rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-76:first-child{
    margin-left: -19rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-78:first-child{
    margin-left: -19.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-78:first-child{
    margin-right: -19.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-78:first-child{
    margin-right: -19.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-78:first-child{
    margin-left: -19.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-80:first-child{
    margin-left: -20rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-80:first-child{
    margin-right: -20rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-80:first-child{
    margin-right: -20rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-80:first-child{
    margin-left: -20rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-82:first-child{
    margin-left: -20.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-82:first-child{
    margin-right: -20.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-82:first-child{
    margin-right: -20.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-82:first-child{
    margin-left: -20.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-84:first-child{
    margin-left: -21rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-84:first-child{
    margin-right: -21rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-84:first-child{
    margin-right: -21rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-84:first-child{
    margin-left: -21rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-88:first-child{
    margin-left: -22rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-88:first-child{
    margin-right: -22rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-88:first-child{
    margin-right: -22rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-88:first-child{
    margin-left: -22rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-92:first-child{
    margin-left: -23rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-92:first-child{
    margin-right: -23rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-92:first-child{
    margin-right: -23rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-92:first-child{
    margin-left: -23rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-96:first-child{
    margin-left: -24rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-96:first-child{
    margin-right: -24rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-96:first-child{
    margin-right: -24rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-96:first-child{
    margin-left: -24rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-98:first-child{
    margin-left: -24.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-98:first-child{
    margin-right: -24.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-98:first-child{
    margin-right: -24.5rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-98:first-child{
    margin-left: -24.5rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-100:first-child{
    margin-left: -25rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-100:first-child{
    margin-right: -25rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-100:first-child{
    margin-right: -25rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-100:first-child{
    margin-left: -25rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-104:first-child{
    margin-left: -26rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-104:first-child{
    margin-right: -26rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-104:first-child{
    margin-right: -26rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-104:first-child{
    margin-left: -26rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-112:first-child{
    margin-left: -28rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-112:first-child{
    margin-right: -28rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-112:first-child{
    margin-right: -28rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-112:first-child{
    margin-left: -28rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-124:first-child{
    margin-left: -31rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-124:first-child{
    margin-right: -31rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-124:first-child{
    margin-right: -31rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-124:first-child{
    margin-left: -31rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-128:first-child{
    margin-left: -32rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-128:first-child{
    margin-right: -32rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-128:first-child{
    margin-right: -32rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-128:first-child{
    margin-left: -32rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-140:first-child{
    margin-left: -35rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-140:first-child{
    margin-right: -35rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-140:first-child{
    margin-right: -35rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-140:first-child{
    margin-left: -35rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-152:first-child{
    margin-left: -38rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-152:first-child{
    margin-right: -38rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-152:first-child{
    margin-right: -38rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-152:first-child{
    margin-left: -38rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-160:first-child{
    margin-left: -40rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-160:first-child{
    margin-right: -40rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-160:first-child{
    margin-right: -40rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-160:first-child{
    margin-left: -40rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-162:first-child{
    margin-left: -41rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-162:first-child{
    margin-right: -41rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-162:first-child{
    margin-right: -41rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-162:first-child{
    margin-left: -41rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-192:first-child{
    margin-left: -48rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-192:first-child{
    margin-right: -48rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-192:first-child{
    margin-right: -48rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-192:first-child{
    margin-left: -48rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-208:first-child{
    margin-left: -52rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-208:first-child{
    margin-right: -52rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-208:first-child{
    margin-right: -52rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-208:first-child{
    margin-left: -52rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-224:first-child{
    margin-left: -56rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-224:first-child{
    margin-right: -56rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-224:first-child{
    margin-right: -56rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-224:first-child{
    margin-left: -56rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-256:first-child{
    margin-left: -64rem;
  }

  [dir="rtl"] .xl\\:first\\:-ms-256:first-child{
    margin-right: -64rem;
  }

  [dir="ltr"] .xl\\:first\\:-me-256:first-child{
    margin-right: -64rem;
  }

  [dir="rtl"] .xl\\:first\\:-me-256:first-child{
    margin-left: -64rem;
  }

  [dir="ltr"] .xl\\:first\\:-ms-px:first-child{
    margin-left: -1px;
  }

  [dir="rtl"] .xl\\:first\\:-ms-px:first-child{
    margin-right: -1px;
  }

  [dir="ltr"] .xl\\:first\\:-me-px:first-child{
    margin-right: -1px;
  }

  [dir="rtl"] .xl\\:first\\:-me-px:first-child{
    margin-left: -1px;
  }

  [dir="rtl"] .xl\\:start-0{
    right: 0;
  }

  [dir="rtl"] .xl\\:end-0{
    left: 0;
  }

  [dir="ltr"] .xl\\:end-0{
    right: 0;
  }

  [dir="ltr"] .xl\\:start-0{
    left: 0;
  }

  [dir="rtl"] .xl\\:start-auto{
    right: auto;
  }

  [dir="rtl"] .xl\\:end-auto{
    left: auto;
  }

  [dir="ltr"] .xl\\:end-auto{
    right: auto;
  }

  [dir="ltr"] .xl\\:start-auto{
    left: auto;
  }

  [dir="ltr"] .xl\\:rounded-e-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .xl\\:rounded-s-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .xl\\:rounded-e-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .xl\\:rounded-s-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .xl\\:rounded-e-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .xl\\:rounded-s-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .xl\\:rounded-e-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .xl\\:rounded-s-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .xl\\:rounded-e{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .xl\\:rounded-s{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .xl\\:rounded-e{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .xl\\:rounded-s{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .xl\\:rounded-e-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .xl\\:rounded-s-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .xl\\:rounded-e-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .xl\\:rounded-s-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .xl\\:rounded-e-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .xl\\:rounded-s-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .xl\\:rounded-e-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .xl\\:rounded-s-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .xl\\:rounded-e-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .xl\\:rounded-s-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .xl\\:rounded-e-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .xl\\:rounded-s-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .xl\\:rounded-ts-none{
    border-top-left-radius: 0;
  }

  [dir="ltr"] .xl\\:rounded-te-none{
    border-top-right-radius: 0;
  }

  [dir="ltr"] .xl\\:rounded-be-none{
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .xl\\:rounded-bs-none{
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .xl\\:rounded-te-none{
    border-top-left-radius: 0;
  }

  [dir="rtl"] .xl\\:rounded-ts-none{
    border-top-right-radius: 0;
  }

  [dir="rtl"] .xl\\:rounded-bs-none{
    border-bottom-right-radius: 0;
  }

  [dir="rtl"] .xl\\:rounded-be-none{
    border-bottom-left-radius: 0;
  }

  [dir="ltr"] .xl\\:rounded-ts-sm{
    border-top-left-radius: .25rem;
  }

  [dir="ltr"] .xl\\:rounded-te-sm{
    border-top-right-radius: .25rem;
  }

  [dir="ltr"] .xl\\:rounded-be-sm{
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .xl\\:rounded-bs-sm{
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .xl\\:rounded-te-sm{
    border-top-left-radius: .25rem;
  }

  [dir="rtl"] .xl\\:rounded-ts-sm{
    border-top-right-radius: .25rem;
  }

  [dir="rtl"] .xl\\:rounded-bs-sm{
    border-bottom-right-radius: .25rem;
  }

  [dir="rtl"] .xl\\:rounded-be-sm{
    border-bottom-left-radius: .25rem;
  }

  [dir="ltr"] .xl\\:rounded-ts{
    border-top-left-radius: .375rem;
  }

  [dir="ltr"] .xl\\:rounded-te{
    border-top-right-radius: .375rem;
  }

  [dir="ltr"] .xl\\:rounded-be{
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .xl\\:rounded-bs{
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .xl\\:rounded-te{
    border-top-left-radius: .375rem;
  }

  [dir="rtl"] .xl\\:rounded-ts{
    border-top-right-radius: .375rem;
  }

  [dir="rtl"] .xl\\:rounded-bs{
    border-bottom-right-radius: .375rem;
  }

  [dir="rtl"] .xl\\:rounded-be{
    border-bottom-left-radius: .375rem;
  }

  [dir="ltr"] .xl\\:rounded-ts-lg{
    border-top-left-radius: .5rem;
  }

  [dir="ltr"] .xl\\:rounded-te-lg{
    border-top-right-radius: .5rem;
  }

  [dir="ltr"] .xl\\:rounded-be-lg{
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .xl\\:rounded-bs-lg{
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .xl\\:rounded-te-lg{
    border-top-left-radius: .5rem;
  }

  [dir="rtl"] .xl\\:rounded-ts-lg{
    border-top-right-radius: .5rem;
  }

  [dir="rtl"] .xl\\:rounded-bs-lg{
    border-bottom-right-radius: .5rem;
  }

  [dir="rtl"] .xl\\:rounded-be-lg{
    border-bottom-left-radius: .5rem;
  }

  [dir="ltr"] .xl\\:rounded-ts-xl{
    border-top-left-radius: .75rem;
  }

  [dir="ltr"] .xl\\:rounded-te-xl{
    border-top-right-radius: .75rem;
  }

  [dir="ltr"] .xl\\:rounded-be-xl{
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .xl\\:rounded-bs-xl{
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .xl\\:rounded-te-xl{
    border-top-left-radius: .75rem;
  }

  [dir="rtl"] .xl\\:rounded-ts-xl{
    border-top-right-radius: .75rem;
  }

  [dir="rtl"] .xl\\:rounded-bs-xl{
    border-bottom-right-radius: .75rem;
  }

  [dir="rtl"] .xl\\:rounded-be-xl{
    border-bottom-left-radius: .75rem;
  }

  [dir="ltr"] .xl\\:rounded-ts-full{
    border-top-left-radius: 9999px;
  }

  [dir="ltr"] .xl\\:rounded-te-full{
    border-top-right-radius: 9999px;
  }

  [dir="ltr"] .xl\\:rounded-be-full{
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .xl\\:rounded-bs-full{
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .xl\\:rounded-te-full{
    border-top-left-radius: 9999px;
  }

  [dir="rtl"] .xl\\:rounded-ts-full{
    border-top-right-radius: 9999px;
  }

  [dir="rtl"] .xl\\:rounded-bs-full{
    border-bottom-right-radius: 9999px;
  }

  [dir="rtl"] .xl\\:rounded-be-full{
    border-bottom-left-radius: 9999px;
  }

  [dir="ltr"] .xl\\:clear-start{
    clear: left;
  }

  [dir="ltr"] .xl\\:clear-end{
    clear: right;
  }

  [dir="rtl"] .xl\\:clear-start{
    clear: right;
  }

  [dir="rtl"] .xl\\:clear-end{
    clear: left;
  }

  [dir="rtl"] .xl\\:float-start{
    float: right;
  }

  [dir="rtl"] .xl\\:float-end{
    float: left;
  }

  [dir="ltr"] .xl\\:float-end{
    float: right;
  }

  [dir="ltr"] .xl\\:float-start{
    float: left;
  }

  [dir="ltr"] .xl\\:border-e-0{
    border-right-width: 0;
  }

  [dir="rtl"] .xl\\:border-e-0{
    border-left-width: 0;
  }

  [dir="ltr"] .xl\\:border-s-0{
    border-left-width: 0;
  }

  [dir="rtl"] .xl\\:border-s-0{
    border-right-width: 0;
  }

  [dir="ltr"] .xl\\:border-e-2{
    border-right-width: 2px;
  }

  [dir="rtl"] .xl\\:border-e-2{
    border-left-width: 2px;
  }

  [dir="ltr"] .xl\\:border-s-2{
    border-left-width: 2px;
  }

  [dir="rtl"] .xl\\:border-s-2{
    border-right-width: 2px;
  }

  [dir="ltr"] .xl\\:border-e-3{
    border-right-width: 3px;
  }

  [dir="rtl"] .xl\\:border-e-3{
    border-left-width: 3px;
  }

  [dir="ltr"] .xl\\:border-s-3{
    border-left-width: 3px;
  }

  [dir="rtl"] .xl\\:border-s-3{
    border-right-width: 3px;
  }

  [dir="ltr"] .xl\\:border-e-4{
    border-right-width: 4px;
  }

  [dir="rtl"] .xl\\:border-e-4{
    border-left-width: 4px;
  }

  [dir="ltr"] .xl\\:border-s-4{
    border-left-width: 4px;
  }

  [dir="rtl"] .xl\\:border-s-4{
    border-right-width: 4px;
  }

  [dir="ltr"] .xl\\:border-e-5{
    border-right-width: 5px;
  }

  [dir="rtl"] .xl\\:border-e-5{
    border-left-width: 5px;
  }

  [dir="ltr"] .xl\\:border-s-5{
    border-left-width: 5px;
  }

  [dir="rtl"] .xl\\:border-s-5{
    border-right-width: 5px;
  }

  [dir="ltr"] .xl\\:border-e-6{
    border-right-width: 6px;
  }

  [dir="rtl"] .xl\\:border-e-6{
    border-left-width: 6px;
  }

  [dir="ltr"] .xl\\:border-s-6{
    border-left-width: 6px;
  }

  [dir="rtl"] .xl\\:border-s-6{
    border-right-width: 6px;
  }

  [dir="ltr"] .xl\\:border-e-8{
    border-right-width: 8px;
  }

  [dir="rtl"] .xl\\:border-e-8{
    border-left-width: 8px;
  }

  [dir="ltr"] .xl\\:border-s-8{
    border-left-width: 8px;
  }

  [dir="rtl"] .xl\\:border-s-8{
    border-right-width: 8px;
  }

  [dir="ltr"] .xl\\:border-e{
    border-right-width: 1px;
  }

  [dir="rtl"] .xl\\:border-e{
    border-left-width: 1px;
  }

  [dir="ltr"] .xl\\:border-s{
    border-left-width: 1px;
  }

  [dir="rtl"] .xl\\:border-s{
    border-right-width: 1px;
  }

  [dir="ltr"] .xl\\:first\\:border-e-0:first-child{
    border-right-width: 0;
  }

  [dir="rtl"] .xl\\:first\\:border-e-0:first-child{
    border-left-width: 0;
  }

  [dir="ltr"] .xl\\:first\\:border-s-0:first-child{
    border-left-width: 0;
  }

  [dir="rtl"] .xl\\:first\\:border-s-0:first-child{
    border-right-width: 0;
  }

  [dir="ltr"] .xl\\:first\\:border-e-2:first-child{
    border-right-width: 2px;
  }

  [dir="rtl"] .xl\\:first\\:border-e-2:first-child{
    border-left-width: 2px;
  }

  [dir="ltr"] .xl\\:first\\:border-s-2:first-child{
    border-left-width: 2px;
  }

  [dir="rtl"] .xl\\:first\\:border-s-2:first-child{
    border-right-width: 2px;
  }

  [dir="ltr"] .xl\\:first\\:border-e-3:first-child{
    border-right-width: 3px;
  }

  [dir="rtl"] .xl\\:first\\:border-e-3:first-child{
    border-left-width: 3px;
  }

  [dir="ltr"] .xl\\:first\\:border-s-3:first-child{
    border-left-width: 3px;
  }

  [dir="rtl"] .xl\\:first\\:border-s-3:first-child{
    border-right-width: 3px;
  }

  [dir="ltr"] .xl\\:first\\:border-e-4:first-child{
    border-right-width: 4px;
  }

  [dir="rtl"] .xl\\:first\\:border-e-4:first-child{
    border-left-width: 4px;
  }

  [dir="ltr"] .xl\\:first\\:border-s-4:first-child{
    border-left-width: 4px;
  }

  [dir="rtl"] .xl\\:first\\:border-s-4:first-child{
    border-right-width: 4px;
  }

  [dir="ltr"] .xl\\:first\\:border-e-5:first-child{
    border-right-width: 5px;
  }

  [dir="rtl"] .xl\\:first\\:border-e-5:first-child{
    border-left-width: 5px;
  }

  [dir="ltr"] .xl\\:first\\:border-s-5:first-child{
    border-left-width: 5px;
  }

  [dir="rtl"] .xl\\:first\\:border-s-5:first-child{
    border-right-width: 5px;
  }

  [dir="ltr"] .xl\\:first\\:border-e-6:first-child{
    border-right-width: 6px;
  }

  [dir="rtl"] .xl\\:first\\:border-e-6:first-child{
    border-left-width: 6px;
  }

  [dir="ltr"] .xl\\:first\\:border-s-6:first-child{
    border-left-width: 6px;
  }

  [dir="rtl"] .xl\\:first\\:border-s-6:first-child{
    border-right-width: 6px;
  }

  [dir="ltr"] .xl\\:first\\:border-e-8:first-child{
    border-right-width: 8px;
  }

  [dir="rtl"] .xl\\:first\\:border-e-8:first-child{
    border-left-width: 8px;
  }

  [dir="ltr"] .xl\\:first\\:border-s-8:first-child{
    border-left-width: 8px;
  }

  [dir="rtl"] .xl\\:first\\:border-s-8:first-child{
    border-right-width: 8px;
  }

  [dir="ltr"] .xl\\:first\\:border-e:first-child{
    border-right-width: 1px;
  }

  [dir="rtl"] .xl\\:first\\:border-e:first-child{
    border-left-width: 1px;
  }

  [dir="ltr"] .xl\\:first\\:border-s:first-child{
    border-left-width: 1px;
  }

  [dir="rtl"] .xl\\:first\\:border-s:first-child{
    border-right-width: 1px;
  }

  [dir="rtl"] .xl\\:text-start{
    text-align: right;
  }

  [dir="rtl"] .xl\\:text-end{
    text-align: left;
  }

  [dir="ltr"] .xl\\:text-end{
    text-align: right;
  }

  [dir="ltr"] .xl\\:text-start{
    text-align: left;
  }

  [dir="ltr"] .xl\\:origin-top-start{
    transform-origin: top left;
  }

  [dir="ltr"] .xl\\:origin-top-end{
    transform-origin: top right;
  }

  [dir="ltr"] .xl\\:origin-bottom-start{
    transform-origin: bottom left;
  }

  [dir="ltr"] .xl\\:origin-bottom-end{
    transform-origin: bottom right;
  }

  [dir="ltr"] .xl\\:origin-start{
    transform-origin: left;
  }

  [dir="ltr"] .xl\\:origin-end{
    transform-origin: right;
  }

  [dir="rtl"] .xl\\:origin-top-start{
    transform-origin: top right;
  }

  [dir="rtl"] .xl\\:origin-top-end{
    transform-origin: top left;
  }

  [dir="rtl"] .xl\\:origin-bottom-start{
    transform-origin: bottom right;
  }

  [dir="rtl"] .xl\\:origin-bottom-end{
    transform-origin: bottom left;
  }

  [dir="rtl"] .xl\\:origin-start{
    transform-origin: right;
  }

  [dir="rtl"] .xl\\:origin-end{
    transform-origin: left;
  }

  [dir="ltr"] .xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * (1 - var(--tw-space-s-reverse)));
  }

  .xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  .xl\\:space-s-reverse > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 1;
  }
}

@media (min-width: 1536px){
  .\\32xl\\:prose{
    color: #4a5568;
    max-width: 65ch;
  }

  .\\32xl\\:prose [class~="lead"]{
    color: #4a5568;
    font-size: 1.25em;
    line-height: 1.6;
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .\\32xl\\:prose a{
    color: #1a202c;
    text-decoration: underline;
  }

  .\\32xl\\:prose strong{
    color: #1a202c;
    font-weight: 600;
  }

  .\\32xl\\:prose ol{
    counter-reset: list-counter;
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .\\32xl\\:prose ol > li{
    position: relative;
    counter-increment: list-counter;
    padding-left: 1.75em;
  }

  .\\32xl\\:prose ol > li::before{
    content: ;
    position: absolute;
    font-weight: 400;
    color: #718096;
  }

  .\\32xl\\:prose ul > li{
    position: relative;
    padding-left: 1.75em;
  }

  .\\32xl\\:prose ul > li::before{
    content: "";
    position: absolute;
    background-color: #cbd5e0;
    border-radius: 50%;
    width: 0.375em;
    height: 0.375em;
    top: calc(0.875em - 0.1875em);
    left: 0.25em;
  }

  .\\32xl\\:prose hr{
    border-color: #e2e8f0;
    border-top-width: 1px;
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .\\32xl\\:prose blockquote{
    font-weight: 500;
    font-style: italic;
    color: #1a202c;
    border-left-width: 0.25rem;
    border-left-color: #e2e8f0;
    quotes: "\\201C""\\201D""\\2018""\\2019";
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1em;
  }

  .\\32xl\\:prose blockquote p:first-of-type::before{
    content: open-quote;
  }

  .\\32xl\\:prose blockquote p:last-of-type::after{
    content: close-quote;
  }

  .\\32xl\\:prose h1{
    color: #1a202c;
    font-weight: 800;
    font-size: 2.25em;
    margin-top: 0;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }

  .\\32xl\\:prose h2{
    color: #1a202c;
    font-weight: 700;
    font-size: 1.5em;
    margin-top: 2em;
    margin-bottom: 1em;
    line-height: 1.3333333;
  }

  .\\32xl\\:prose h3{
    color: #1a202c;
    font-weight: 600;
    font-size: 1.25em;
    margin-top: 1.6em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }

  .\\32xl\\:prose h4{
    color: #1a202c;
    font-weight: 600;
    margin-top: 1.5em;
    margin-bottom: 0.5em;
    line-height: 1.5;
  }

  .\\32xl\\:prose figure figcaption{
    color: #718096;
    font-size: 0.875em;
    line-height: 1.4285714;
    margin-top: 0.8571429em;
  }

  .\\32xl\\:prose code{
    color: #1a202c;
    font-weight: 600;
    font-size: 0.875em;
  }

  .\\32xl\\:prose code::before{
    content: "\`";
  }

  .\\32xl\\:prose code::after{
    content: "\`";
  }

  .\\32xl\\:prose pre{
    color: #e2e8f0;
    background-color: #2d3748;
    overflow-x: auto;
    font-size: 0.875em;
    line-height: 1.7142857;
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
    border-radius: 0.375rem;
    padding-top: 0.8571429em;
    padding-right: 1.1428571em;
    padding-bottom: 0.8571429em;
    padding-left: 1.1428571em;
  }

  .\\32xl\\:prose pre code{
    background-color: transparent;
    border-width: 0;
    border-radius: 0;
    padding: 0;
    font-weight: 400;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
  }

  .\\32xl\\:prose pre code::before{
    content: "";
  }

  .\\32xl\\:prose pre code::after{
    content: "";
  }

  .\\32xl\\:prose table{
    width: 100%;
    table-layout: auto;
    text-align: left;
    margin-top: 2em;
    margin-bottom: 2em;
    font-size: 0.875em;
    line-height: 1.7142857;
  }

  .\\32xl\\:prose thead{
    color: #1a202c;
    font-weight: 600;
    border-bottom-width: 1px;
    border-bottom-color: #cbd5e0;
  }

  .\\32xl\\:prose thead th{
    vertical-align: bottom;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }

  .\\32xl\\:prose tbody tr{
    border-bottom-width: 1px;
    border-bottom-color: #e2e8f0;
  }

  .\\32xl\\:prose tbody tr:last-child{
    border-bottom-width: 0;
  }

  .\\32xl\\:prose tbody td{
    vertical-align: top;
    padding-top: 0.5714286em;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }

  .\\32xl\\:prose{
    font-size: 1rem;
    line-height: 1.75;
  }

  .\\32xl\\:prose p{
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .\\32xl\\:prose img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\32xl\\:prose video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\32xl\\:prose figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\32xl\\:prose figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .\\32xl\\:prose h2 code{
    font-size: 0.875em;
  }

  .\\32xl\\:prose h3 code{
    font-size: 0.9em;
  }

  .\\32xl\\:prose ul{
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .\\32xl\\:prose li{
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .\\32xl\\:prose ol > li:before{
    left: 0;
  }

  .\\32xl\\:prose > ul > li p{
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }

  .\\32xl\\:prose > ul > li > *:first-child{
    margin-top: 1.25em;
  }

  .\\32xl\\:prose > ul > li > *:last-child{
    margin-bottom: 1.25em;
  }

  .\\32xl\\:prose > ol > li > *:first-child{
    margin-top: 1.25em;
  }

  .\\32xl\\:prose > ol > li > *:last-child{
    margin-bottom: 1.25em;
  }

  .\\32xl\\:prose ul ul, .\\32xl\\:prose ul ol, .\\32xl\\:prose ol ul, .\\32xl\\:prose ol ol{
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }

  .\\32xl\\:prose hr + *{
    margin-top: 0;
  }

  .\\32xl\\:prose h2 + *{
    margin-top: 0;
  }

  .\\32xl\\:prose h3 + *{
    margin-top: 0;
  }

  .\\32xl\\:prose h4 + *{
    margin-top: 0;
  }

  .\\32xl\\:prose thead th:first-child{
    padding-left: 0;
  }

  .\\32xl\\:prose thead th:last-child{
    padding-right: 0;
  }

  .\\32xl\\:prose tbody td:first-child{
    padding-left: 0;
  }

  .\\32xl\\:prose tbody td:last-child{
    padding-right: 0;
  }

  .\\32xl\\:prose > :first-child{
    margin-top: 0;
  }

  .\\32xl\\:prose > :last-child{
    margin-bottom: 0;
  }

  .\\32xl\\:prose-sm{
    font-size: 0.875rem;
    line-height: 1.7142857;
  }

  .\\32xl\\:prose-sm p{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .\\32xl\\:prose-sm [class~="lead"]{
    font-size: 1.2857143em;
    line-height: 1.5555556;
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .\\32xl\\:prose-sm blockquote{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
    padding-left: 1.1111111em;
  }

  .\\32xl\\:prose-sm h1{
    font-size: 2.1428571em;
    margin-top: 0;
    margin-bottom: 0.8em;
    line-height: 1.2;
  }

  .\\32xl\\:prose-sm h2{
    font-size: 1.4285714em;
    margin-top: 1.6em;
    margin-bottom: 0.8em;
    line-height: 1.4;
  }

  .\\32xl\\:prose-sm h3{
    font-size: 1.2857143em;
    margin-top: 1.5555556em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }

  .\\32xl\\:prose-sm h4{
    margin-top: 1.4285714em;
    margin-bottom: 0.5714286em;
    line-height: 1.4285714;
  }

  .\\32xl\\:prose-sm img{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .\\32xl\\:prose-sm video{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .\\32xl\\:prose-sm figure{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .\\32xl\\:prose-sm figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .\\32xl\\:prose-sm figure figcaption{
    font-size: 0.8571429em;
    line-height: 1.3333333;
    margin-top: 0.6666667em;
  }

  .\\32xl\\:prose-sm code{
    font-size: 0.8571429em;
  }

  .\\32xl\\:prose-sm h2 code{
    font-size: 0.9em;
  }

  .\\32xl\\:prose-sm h3 code{
    font-size: 0.8888889em;
  }

  .\\32xl\\:prose-sm pre{
    font-size: 0.8571429em;
    line-height: 1.6666667;
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    border-radius: 0.25rem;
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .\\32xl\\:prose-sm ol{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .\\32xl\\:prose-sm ul{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .\\32xl\\:prose-sm li{
    margin-top: 0.2857143em;
    margin-bottom: 0.2857143em;
  }

  .\\32xl\\:prose-sm ol > li{
    padding-left: 1.5714286em;
  }

  .\\32xl\\:prose-sm ol > li:before{
    left: 0;
  }

  .\\32xl\\:prose-sm ul > li{
    padding-left: 1.5714286em;
  }

  .\\32xl\\:prose-sm ul > li::before{
    height: 0.3571429em;
    width: 0.3571429em;
    top: calc(0.8571429em - 0.1785714em);
    left: 0.2142857em;
  }

  .\\32xl\\:prose-sm > ul > li p{
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }

  .\\32xl\\:prose-sm > ul > li > *:first-child{
    margin-top: 1.1428571em;
  }

  .\\32xl\\:prose-sm > ul > li > *:last-child{
    margin-bottom: 1.1428571em;
  }

  .\\32xl\\:prose-sm > ol > li > *:first-child{
    margin-top: 1.1428571em;
  }

  .\\32xl\\:prose-sm > ol > li > *:last-child{
    margin-bottom: 1.1428571em;
  }

  .\\32xl\\:prose-sm ul ul, .\\32xl\\:prose-sm ul ol, .\\32xl\\:prose-sm ol ul, .\\32xl\\:prose-sm ol ol{
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }

  .\\32xl\\:prose-sm hr{
    margin-top: 2.8571429em;
    margin-bottom: 2.8571429em;
  }

  .\\32xl\\:prose-sm hr + *{
    margin-top: 0;
  }

  .\\32xl\\:prose-sm h2 + *{
    margin-top: 0;
  }

  .\\32xl\\:prose-sm h3 + *{
    margin-top: 0;
  }

  .\\32xl\\:prose-sm h4 + *{
    margin-top: 0;
  }

  .\\32xl\\:prose-sm table{
    font-size: 0.8571429em;
    line-height: 1.5;
  }

  .\\32xl\\:prose-sm thead th{
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .\\32xl\\:prose-sm thead th:first-child{
    padding-left: 0;
  }

  .\\32xl\\:prose-sm thead th:last-child{
    padding-right: 0;
  }

  .\\32xl\\:prose-sm tbody td{
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .\\32xl\\:prose-sm tbody td:first-child{
    padding-left: 0;
  }

  .\\32xl\\:prose-sm tbody td:last-child{
    padding-right: 0;
  }

  .\\32xl\\:prose-sm > :first-child{
    margin-top: 0;
  }

  .\\32xl\\:prose-sm > :last-child{
    margin-bottom: 0;
  }

  .\\32xl\\:prose-lg{
    font-size: 1.125rem;
    line-height: 1.7777778;
  }

  .\\32xl\\:prose-lg p{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .\\32xl\\:prose-lg [class~="lead"]{
    font-size: 1.2222222em;
    line-height: 1.4545455;
    margin-top: 1.0909091em;
    margin-bottom: 1.0909091em;
  }

  .\\32xl\\:prose-lg blockquote{
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    padding-left: 1em;
  }

  .\\32xl\\:prose-lg h1{
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.8333333em;
    line-height: 1;
  }

  .\\32xl\\:prose-lg h2{
    font-size: 1.6666667em;
    margin-top: 1.8666667em;
    margin-bottom: 1.0666667em;
    line-height: 1.3333333;
  }

  .\\32xl\\:prose-lg h3{
    font-size: 1.3333333em;
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }

  .\\32xl\\:prose-lg h4{
    margin-top: 1.7777778em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }

  .\\32xl\\:prose-lg img{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .\\32xl\\:prose-lg video{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .\\32xl\\:prose-lg figure{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .\\32xl\\:prose-lg figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .\\32xl\\:prose-lg figure figcaption{
    font-size: 0.8888889em;
    line-height: 1.5;
    margin-top: 1em;
  }

  .\\32xl\\:prose-lg code{
    font-size: 0.8888889em;
  }

  .\\32xl\\:prose-lg h2 code{
    font-size: 0.8666667em;
  }

  .\\32xl\\:prose-lg h3 code{
    font-size: 0.875em;
  }

  .\\32xl\\:prose-lg pre{
    font-size: 0.8888889em;
    line-height: 1.75;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.375rem;
    padding-top: 1em;
    padding-right: 1.5em;
    padding-bottom: 1em;
    padding-left: 1.5em;
  }

  .\\32xl\\:prose-lg ol{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .\\32xl\\:prose-lg ul{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .\\32xl\\:prose-lg li{
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }

  .\\32xl\\:prose-lg ol > li{
    padding-left: 1.6666667em;
  }

  .\\32xl\\:prose-lg ol > li:before{
    left: 0;
  }

  .\\32xl\\:prose-lg ul > li{
    padding-left: 1.6666667em;
  }

  .\\32xl\\:prose-lg ul > li::before{
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8888889em - 0.1666667em);
    left: 0.2222222em;
  }

  .\\32xl\\:prose-lg > ul > li p{
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .\\32xl\\:prose-lg > ul > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .\\32xl\\:prose-lg > ul > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .\\32xl\\:prose-lg > ol > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .\\32xl\\:prose-lg > ol > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .\\32xl\\:prose-lg ul ul, .\\32xl\\:prose-lg ul ol, .\\32xl\\:prose-lg ol ul, .\\32xl\\:prose-lg ol ol{
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .\\32xl\\:prose-lg hr{
    margin-top: 3.1111111em;
    margin-bottom: 3.1111111em;
  }

  .\\32xl\\:prose-lg hr + *{
    margin-top: 0;
  }

  .\\32xl\\:prose-lg h2 + *{
    margin-top: 0;
  }

  .\\32xl\\:prose-lg h3 + *{
    margin-top: 0;
  }

  .\\32xl\\:prose-lg h4 + *{
    margin-top: 0;
  }

  .\\32xl\\:prose-lg table{
    font-size: 0.8888889em;
    line-height: 1.5;
  }

  .\\32xl\\:prose-lg thead th{
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }

  .\\32xl\\:prose-lg thead th:first-child{
    padding-left: 0;
  }

  .\\32xl\\:prose-lg thead th:last-child{
    padding-right: 0;
  }

  .\\32xl\\:prose-lg tbody td{
    padding-top: 0.75em;
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }

  .\\32xl\\:prose-lg tbody td:first-child{
    padding-left: 0;
  }

  .\\32xl\\:prose-lg tbody td:last-child{
    padding-right: 0;
  }

  .\\32xl\\:prose-lg > :first-child{
    margin-top: 0;
  }

  .\\32xl\\:prose-lg > :last-child{
    margin-bottom: 0;
  }

  .\\32xl\\:prose-xl{
    font-size: 1.25rem;
    line-height: 1.8;
  }

  .\\32xl\\:prose-xl p{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .\\32xl\\:prose-xl [class~="lead"]{
    font-size: 1.2em;
    line-height: 1.5;
    margin-top: 1em;
    margin-bottom: 1em;
  }

  .\\32xl\\:prose-xl blockquote{
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1.0666667em;
  }

  .\\32xl\\:prose-xl h1{
    font-size: 2.8em;
    margin-top: 0;
    margin-bottom: 0.8571429em;
    line-height: 1;
  }

  .\\32xl\\:prose-xl h2{
    font-size: 1.8em;
    margin-top: 1.5555556em;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }

  .\\32xl\\:prose-xl h3{
    font-size: 1.5em;
    margin-top: 1.6em;
    margin-bottom: 0.6666667em;
    line-height: 1.3333333;
  }

  .\\32xl\\:prose-xl h4{
    margin-top: 1.8em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }

  .\\32xl\\:prose-xl img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\32xl\\:prose-xl video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\32xl\\:prose-xl figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\32xl\\:prose-xl figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .\\32xl\\:prose-xl figure figcaption{
    font-size: 0.9em;
    line-height: 1.5555556;
    margin-top: 1em;
  }

  .\\32xl\\:prose-xl code{
    font-size: 0.9em;
  }

  .\\32xl\\:prose-xl h2 code{
    font-size: 0.8611111em;
  }

  .\\32xl\\:prose-xl h3 code{
    font-size: 0.9em;
  }

  .\\32xl\\:prose-xl pre{
    font-size: 0.9em;
    line-height: 1.7777778;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.1111111em;
    padding-right: 1.3333333em;
    padding-bottom: 1.1111111em;
    padding-left: 1.3333333em;
  }

  .\\32xl\\:prose-xl ol{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .\\32xl\\:prose-xl ul{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .\\32xl\\:prose-xl li{
    margin-top: 0.6em;
    margin-bottom: 0.6em;
  }

  .\\32xl\\:prose-xl ol > li{
    padding-left: 1.8em;
  }

  .\\32xl\\:prose-xl ol > li:before{
    left: 0;
  }

  .\\32xl\\:prose-xl ul > li{
    padding-left: 1.8em;
  }

  .\\32xl\\:prose-xl ul > li::before{
    width: 0.35em;
    height: 0.35em;
    top: calc(0.9em - 0.175em);
    left: 0.25em;
  }

  .\\32xl\\:prose-xl > ul > li p{
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }

  .\\32xl\\:prose-xl > ul > li > *:first-child{
    margin-top: 1.2em;
  }

  .\\32xl\\:prose-xl > ul > li > *:last-child{
    margin-bottom: 1.2em;
  }

  .\\32xl\\:prose-xl > ol > li > *:first-child{
    margin-top: 1.2em;
  }

  .\\32xl\\:prose-xl > ol > li > *:last-child{
    margin-bottom: 1.2em;
  }

  .\\32xl\\:prose-xl ul ul, .\\32xl\\:prose-xl ul ol, .\\32xl\\:prose-xl ol ul, .\\32xl\\:prose-xl ol ol{
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }

  .\\32xl\\:prose-xl hr{
    margin-top: 2.8em;
    margin-bottom: 2.8em;
  }

  .\\32xl\\:prose-xl hr + *{
    margin-top: 0;
  }

  .\\32xl\\:prose-xl h2 + *{
    margin-top: 0;
  }

  .\\32xl\\:prose-xl h3 + *{
    margin-top: 0;
  }

  .\\32xl\\:prose-xl h4 + *{
    margin-top: 0;
  }

  .\\32xl\\:prose-xl table{
    font-size: 0.9em;
    line-height: 1.5555556;
  }

  .\\32xl\\:prose-xl thead th{
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }

  .\\32xl\\:prose-xl thead th:first-child{
    padding-left: 0;
  }

  .\\32xl\\:prose-xl thead th:last-child{
    padding-right: 0;
  }

  .\\32xl\\:prose-xl tbody td{
    padding-top: 0.8888889em;
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }

  .\\32xl\\:prose-xl tbody td:first-child{
    padding-left: 0;
  }

  .\\32xl\\:prose-xl tbody td:last-child{
    padding-right: 0;
  }

  .\\32xl\\:prose-xl > :first-child{
    margin-top: 0;
  }

  .\\32xl\\:prose-xl > :last-child{
    margin-bottom: 0;
  }

  .\\32xl\\:prose-2xl{
    font-size: 1.5rem;
    line-height: 1.6666667;
  }

  .\\32xl\\:prose-2xl p{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .\\32xl\\:prose-2xl [class~="lead"]{
    font-size: 1.25em;
    line-height: 1.4666667;
    margin-top: 1.0666667em;
    margin-bottom: 1.0666667em;
  }

  .\\32xl\\:prose-2xl blockquote{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
    padding-left: 1.1111111em;
  }

  .\\32xl\\:prose-2xl h1{
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.875em;
    line-height: 1;
  }

  .\\32xl\\:prose-2xl h2{
    font-size: 2em;
    margin-top: 1.5em;
    margin-bottom: 0.8333333em;
    line-height: 1.0833333;
  }

  .\\32xl\\:prose-2xl h3{
    font-size: 1.5em;
    margin-top: 1.5555556em;
    margin-bottom: 0.6666667em;
    line-height: 1.2222222;
  }

  .\\32xl\\:prose-2xl h4{
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }

  .\\32xl\\:prose-2xl img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\32xl\\:prose-2xl video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\32xl\\:prose-2xl figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\32xl\\:prose-2xl figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .\\32xl\\:prose-2xl figure figcaption{
    font-size: 0.8333333em;
    line-height: 1.6;
    margin-top: 1em;
  }

  .\\32xl\\:prose-2xl code{
    font-size: 0.8333333em;
  }

  .\\32xl\\:prose-2xl h2 code{
    font-size: 0.875em;
  }

  .\\32xl\\:prose-2xl h3 code{
    font-size: 0.8888889em;
  }

  .\\32xl\\:prose-2xl pre{
    font-size: 0.8333333em;
    line-height: 1.8;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.2em;
    padding-right: 1.6em;
    padding-bottom: 1.2em;
    padding-left: 1.6em;
  }

  .\\32xl\\:prose-2xl ol{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .\\32xl\\:prose-2xl ul{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .\\32xl\\:prose-2xl li{
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .\\32xl\\:prose-2xl ol > li{
    padding-left: 1.6666667em;
  }

  .\\32xl\\:prose-2xl ol > li:before{
    left: 0;
  }

  .\\32xl\\:prose-2xl ul > li{
    padding-left: 1.6666667em;
  }

  .\\32xl\\:prose-2xl ul > li::before{
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8333333em - 0.1666667em);
    left: 0.25em;
  }

  .\\32xl\\:prose-2xl > ul > li p{
    margin-top: 0.8333333em;
    margin-bottom: 0.8333333em;
  }

  .\\32xl\\:prose-2xl > ul > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .\\32xl\\:prose-2xl > ul > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .\\32xl\\:prose-2xl > ol > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .\\32xl\\:prose-2xl > ol > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .\\32xl\\:prose-2xl ul ul, .\\32xl\\:prose-2xl ul ol, .\\32xl\\:prose-2xl ol ul, .\\32xl\\:prose-2xl ol ol{
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }

  .\\32xl\\:prose-2xl hr{
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .\\32xl\\:prose-2xl hr + *{
    margin-top: 0;
  }

  .\\32xl\\:prose-2xl h2 + *{
    margin-top: 0;
  }

  .\\32xl\\:prose-2xl h3 + *{
    margin-top: 0;
  }

  .\\32xl\\:prose-2xl h4 + *{
    margin-top: 0;
  }

  .\\32xl\\:prose-2xl table{
    font-size: 0.8333333em;
    line-height: 1.4;
  }

  .\\32xl\\:prose-2xl thead th{
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }

  .\\32xl\\:prose-2xl thead th:first-child{
    padding-left: 0;
  }

  .\\32xl\\:prose-2xl thead th:last-child{
    padding-right: 0;
  }

  .\\32xl\\:prose-2xl tbody td{
    padding-top: 0.8em;
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }

  .\\32xl\\:prose-2xl tbody td:first-child{
    padding-left: 0;
  }

  .\\32xl\\:prose-2xl tbody td:last-child{
    padding-right: 0;
  }

  .\\32xl\\:prose-2xl > :first-child{
    margin-top: 0;
  }

  .\\32xl\\:prose-2xl > :last-child{
    margin-bottom: 0;
  }

  .\\32xl\\:space-y-0 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0px * (1 - var(--space-y-reverse)));
    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0px * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-0 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0px * var(--space-x-reverse));
    margin-left: calc(0px * (1 - var(--space-x-reverse)));
    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--space-x-reverse));
    margin-left: calc(0.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--space-x-reverse));
    margin-left: calc(0.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--space-x-reverse));
    margin-left: calc(0.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1rem * var(--space-x-reverse));
    margin-left: calc(1rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--space-x-reverse));
    margin-left: calc(1.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--space-x-reverse));
    margin-left: calc(1.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-7 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.75rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-7 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.75rem * var(--space-x-reverse));
    margin-left: calc(1.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2rem * var(--space-x-reverse));
    margin-left: calc(2rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-9 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.25rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-9 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.25rem * var(--space-x-reverse));
    margin-left: calc(2.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.5rem * var(--space-x-reverse));
    margin-left: calc(2.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-11 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.75rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-11 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.75rem * var(--space-x-reverse));
    margin-left: calc(2.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3rem * var(--space-x-reverse));
    margin-left: calc(3rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-14 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-14 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3.5rem * var(--space-x-reverse));
    margin-left: calc(3.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-15 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.75rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-15 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3.75rem * var(--space-x-reverse));
    margin-left: calc(3.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(4rem * (1 - var(--space-y-reverse)));
    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(4rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(4rem * var(--space-x-reverse));
    margin-left: calc(4rem * (1 - var(--space-x-reverse)));
    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-18 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(4.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(4.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(4.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-18 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(4.5rem * var(--space-x-reverse));
    margin-left: calc(4.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(4.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5rem * var(--space-x-reverse));
    margin-left: calc(5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-22 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-22 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5.5rem * var(--space-x-reverse));
    margin-left: calc(5.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-23 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5.75rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-23 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5.75rem * var(--space-x-reverse));
    margin-left: calc(5.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6rem * var(--space-x-reverse));
    margin-left: calc(6rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-25 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6.25rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-25 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6.25rem * var(--space-x-reverse));
    margin-left: calc(6.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6.25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-26 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-26 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6.5rem * var(--space-x-reverse));
    margin-left: calc(6.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-28 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(7rem * (1 - var(--space-y-reverse)));
    margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(7rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-28 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(7rem * var(--space-x-reverse));
    margin-left: calc(7rem * (1 - var(--space-x-reverse)));
    margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-30 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(7.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(7.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(7.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-30 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(7.5rem * var(--space-x-reverse));
    margin-left: calc(7.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(7.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(8rem * (1 - var(--space-y-reverse)));
    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(8rem * var(--space-x-reverse));
    margin-left: calc(8rem * (1 - var(--space-x-reverse)));
    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-34 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(8.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(8.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-34 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(8.5rem * var(--space-x-reverse));
    margin-left: calc(8.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(8.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(10rem * (1 - var(--space-y-reverse)));
    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(10rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(10rem * var(--space-x-reverse));
    margin-left: calc(10rem * (1 - var(--space-x-reverse)));
    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-42 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(10.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(10.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(10.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-42 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(10.5rem * var(--space-x-reverse));
    margin-left: calc(10.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(10.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-44 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(11rem * (1 - var(--space-y-reverse)));
    margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(11rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-44 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(11rem * var(--space-x-reverse));
    margin-left: calc(11rem * (1 - var(--space-x-reverse)));
    margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(12rem * (1 - var(--space-y-reverse)));
    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(12rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(12rem * var(--space-x-reverse));
    margin-left: calc(12rem * (1 - var(--space-x-reverse)));
    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-52 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(13rem * (1 - var(--space-y-reverse)));
    margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(13rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-52 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(13rem * var(--space-x-reverse));
    margin-left: calc(13rem * (1 - var(--space-x-reverse)));
    margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-54 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(13.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(13.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(13.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-54 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(13.5rem * var(--space-x-reverse));
    margin-left: calc(13.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(13.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(14rem * (1 - var(--space-y-reverse)));
    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(14rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(14rem * var(--space-x-reverse));
    margin-left: calc(14rem * (1 - var(--space-x-reverse)));
    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-60 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(15rem * (1 - var(--space-y-reverse)));
    margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(15rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-60 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(15rem * var(--space-x-reverse));
    margin-left: calc(15rem * (1 - var(--space-x-reverse)));
    margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(16rem * (1 - var(--space-y-reverse)));
    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(16rem * var(--space-x-reverse));
    margin-left: calc(16rem * (1 - var(--space-x-reverse)));
    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-68 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(17rem * (1 - var(--space-y-reverse)));
    margin-top: calc(17rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(17rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-68 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(17rem * var(--space-x-reverse));
    margin-left: calc(17rem * (1 - var(--space-x-reverse)));
    margin-left: calc(17rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-72 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(18rem * (1 - var(--space-y-reverse)));
    margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(18rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-72 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(18rem * var(--space-x-reverse));
    margin-left: calc(18rem * (1 - var(--space-x-reverse)));
    margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-74 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(18.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(18.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(18.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-74 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(18.5rem * var(--space-x-reverse));
    margin-left: calc(18.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(18.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-76 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(19rem * (1 - var(--space-y-reverse)));
    margin-top: calc(19rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(19rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-76 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(19rem * var(--space-x-reverse));
    margin-left: calc(19rem * (1 - var(--space-x-reverse)));
    margin-left: calc(19rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-78 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(19.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(19.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(19.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-78 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(19.5rem * var(--space-x-reverse));
    margin-left: calc(19.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(19.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-80 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(20rem * (1 - var(--space-y-reverse)));
    margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-80 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(20rem * var(--space-x-reverse));
    margin-left: calc(20rem * (1 - var(--space-x-reverse)));
    margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-82 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(20.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(20.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-82 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(20.5rem * var(--space-x-reverse));
    margin-left: calc(20.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(20.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-84 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(21rem * (1 - var(--space-y-reverse)));
    margin-top: calc(21rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(21rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-84 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(21rem * var(--space-x-reverse));
    margin-left: calc(21rem * (1 - var(--space-x-reverse)));
    margin-left: calc(21rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-88 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(22rem * (1 - var(--space-y-reverse)));
    margin-top: calc(22rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(22rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-88 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(22rem * var(--space-x-reverse));
    margin-left: calc(22rem * (1 - var(--space-x-reverse)));
    margin-left: calc(22rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-92 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(23rem * (1 - var(--space-y-reverse)));
    margin-top: calc(23rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(23rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-92 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(23rem * var(--space-x-reverse));
    margin-left: calc(23rem * (1 - var(--space-x-reverse)));
    margin-left: calc(23rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-96 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(24rem * (1 - var(--space-y-reverse)));
    margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(24rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-96 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(24rem * var(--space-x-reverse));
    margin-left: calc(24rem * (1 - var(--space-x-reverse)));
    margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-98 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(24.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(24.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(24.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-98 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(24.5rem * var(--space-x-reverse));
    margin-left: calc(24.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(24.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-100 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(25rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-100 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(25rem * var(--space-x-reverse));
    margin-left: calc(25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-104 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(26rem * (1 - var(--space-y-reverse)));
    margin-top: calc(26rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(26rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-104 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(26rem * var(--space-x-reverse));
    margin-left: calc(26rem * (1 - var(--space-x-reverse)));
    margin-left: calc(26rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-112 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(28rem * (1 - var(--space-y-reverse)));
    margin-top: calc(28rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(28rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-112 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(28rem * var(--space-x-reverse));
    margin-left: calc(28rem * (1 - var(--space-x-reverse)));
    margin-left: calc(28rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-124 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(31rem * (1 - var(--space-y-reverse)));
    margin-top: calc(31rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(31rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-124 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(31rem * var(--space-x-reverse));
    margin-left: calc(31rem * (1 - var(--space-x-reverse)));
    margin-left: calc(31rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-128 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(32rem * (1 - var(--space-y-reverse)));
    margin-top: calc(32rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(32rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-128 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(32rem * var(--space-x-reverse));
    margin-left: calc(32rem * (1 - var(--space-x-reverse)));
    margin-left: calc(32rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-140 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(35rem * (1 - var(--space-y-reverse)));
    margin-top: calc(35rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(35rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-140 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(35rem * var(--space-x-reverse));
    margin-left: calc(35rem * (1 - var(--space-x-reverse)));
    margin-left: calc(35rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-152 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(38rem * (1 - var(--space-y-reverse)));
    margin-top: calc(38rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(38rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-152 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(38rem * var(--space-x-reverse));
    margin-left: calc(38rem * (1 - var(--space-x-reverse)));
    margin-left: calc(38rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-160 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(40rem * (1 - var(--space-y-reverse)));
    margin-top: calc(40rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(40rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-160 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(40rem * var(--space-x-reverse));
    margin-left: calc(40rem * (1 - var(--space-x-reverse)));
    margin-left: calc(40rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-162 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(41rem * (1 - var(--space-y-reverse)));
    margin-top: calc(41rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(41rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-162 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(41rem * var(--space-x-reverse));
    margin-left: calc(41rem * (1 - var(--space-x-reverse)));
    margin-left: calc(41rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-192 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(48rem * (1 - var(--space-y-reverse)));
    margin-top: calc(48rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(48rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-192 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(48rem * var(--space-x-reverse));
    margin-left: calc(48rem * (1 - var(--space-x-reverse)));
    margin-left: calc(48rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-208 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(52rem * (1 - var(--space-y-reverse)));
    margin-top: calc(52rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(52rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-208 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(52rem * var(--space-x-reverse));
    margin-left: calc(52rem * (1 - var(--space-x-reverse)));
    margin-left: calc(52rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-224 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(56rem * (1 - var(--space-y-reverse)));
    margin-top: calc(56rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(56rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-224 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(56rem * var(--space-x-reverse));
    margin-left: calc(56rem * (1 - var(--space-x-reverse)));
    margin-left: calc(56rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-256 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(64rem * (1 - var(--space-y-reverse)));
    margin-top: calc(64rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(64rem * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-256 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(64rem * var(--space-x-reverse));
    margin-left: calc(64rem * (1 - var(--space-x-reverse)));
    margin-left: calc(64rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1px * (1 - var(--space-y-reverse)));
    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1px * var(--space-y-reverse));
  }

  .\\32xl\\:space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1px * var(--space-x-reverse));
    margin-left: calc(1px * (1 - var(--space-x-reverse)));
    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.25rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.25rem * var(--space-x-reverse));
    margin-left: calc(-0.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.5rem * var(--space-x-reverse));
    margin-left: calc(-0.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.75rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.75rem * var(--space-x-reverse));
    margin-left: calc(-0.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1rem * var(--space-x-reverse));
    margin-left: calc(-1rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.25rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.25rem * var(--space-x-reverse));
    margin-left: calc(-1.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.5rem * var(--space-x-reverse));
    margin-left: calc(-1.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-7 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.75rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-7 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.75rem * var(--space-x-reverse));
    margin-left: calc(-1.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2rem * var(--space-x-reverse));
    margin-left: calc(-2rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-9 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.25rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-9 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.25rem * var(--space-x-reverse));
    margin-left: calc(-2.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.5rem * var(--space-x-reverse));
    margin-left: calc(-2.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-11 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.75rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-11 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.75rem * var(--space-x-reverse));
    margin-left: calc(-2.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3rem * var(--space-x-reverse));
    margin-left: calc(-3rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-14 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-14 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3.5rem * var(--space-x-reverse));
    margin-left: calc(-3.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-15 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.75rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-15 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3.75rem * var(--space-x-reverse));
    margin-left: calc(-3.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-4rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-4rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-4rem * var(--space-x-reverse));
    margin-left: calc(-4rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-18 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-4.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-4.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-4.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-18 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-4.5rem * var(--space-x-reverse));
    margin-left: calc(-4.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-4.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5rem * var(--space-x-reverse));
    margin-left: calc(-5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-22 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-22 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5.5rem * var(--space-x-reverse));
    margin-left: calc(-5.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-23 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5.75rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-23 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5.75rem * var(--space-x-reverse));
    margin-left: calc(-5.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6rem * var(--space-x-reverse));
    margin-left: calc(-6rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-25 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6.25rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-25 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6.25rem * var(--space-x-reverse));
    margin-left: calc(-6.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6.25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-26 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-26 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6.5rem * var(--space-x-reverse));
    margin-left: calc(-6.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-28 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-7rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-7rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-28 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-7rem * var(--space-x-reverse));
    margin-left: calc(-7rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-30 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-7.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-7.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-7.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-30 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-7.5rem * var(--space-x-reverse));
    margin-left: calc(-7.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-7.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-8rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-8rem * var(--space-x-reverse));
    margin-left: calc(-8rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-34 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-8.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-8.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-34 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-8.5rem * var(--space-x-reverse));
    margin-left: calc(-8.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-8.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-10rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-10rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-10rem * var(--space-x-reverse));
    margin-left: calc(-10rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-42 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-10.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-10.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-10.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-42 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-10.5rem * var(--space-x-reverse));
    margin-left: calc(-10.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-10.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-44 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-11rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-11rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-44 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-11rem * var(--space-x-reverse));
    margin-left: calc(-11rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-12rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-12rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-12rem * var(--space-x-reverse));
    margin-left: calc(-12rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-52 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-13rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-13rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-52 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-13rem * var(--space-x-reverse));
    margin-left: calc(-13rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-54 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-13.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-13.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-13.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-54 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-13.5rem * var(--space-x-reverse));
    margin-left: calc(-13.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-13.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-14rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-14rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-14rem * var(--space-x-reverse));
    margin-left: calc(-14rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-60 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-15rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-15rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-60 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-15rem * var(--space-x-reverse));
    margin-left: calc(-15rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-16rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-16rem * var(--space-x-reverse));
    margin-left: calc(-16rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-68 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-17rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-17rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-17rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-68 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-17rem * var(--space-x-reverse));
    margin-left: calc(-17rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-17rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-72 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-18rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-18rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-72 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-18rem * var(--space-x-reverse));
    margin-left: calc(-18rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-74 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-18.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-18.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-18.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-74 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-18.5rem * var(--space-x-reverse));
    margin-left: calc(-18.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-18.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-76 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-19rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-19rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-19rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-76 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-19rem * var(--space-x-reverse));
    margin-left: calc(-19rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-19rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-78 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-19.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-19.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-19.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-78 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-19.5rem * var(--space-x-reverse));
    margin-left: calc(-19.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-19.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-80 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-20rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-80 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-20rem * var(--space-x-reverse));
    margin-left: calc(-20rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-82 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-20.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-20.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-82 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-20.5rem * var(--space-x-reverse));
    margin-left: calc(-20.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-20.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-84 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-21rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-21rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-21rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-84 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-21rem * var(--space-x-reverse));
    margin-left: calc(-21rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-21rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-88 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-22rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-22rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-22rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-88 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-22rem * var(--space-x-reverse));
    margin-left: calc(-22rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-22rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-92 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-23rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-23rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-23rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-92 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-23rem * var(--space-x-reverse));
    margin-left: calc(-23rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-23rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-96 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-24rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-24rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-96 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-24rem * var(--space-x-reverse));
    margin-left: calc(-24rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-98 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-24.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-24.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-24.5rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-98 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-24.5rem * var(--space-x-reverse));
    margin-left: calc(-24.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-24.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-100 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-25rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-100 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-25rem * var(--space-x-reverse));
    margin-left: calc(-25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-104 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-26rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-26rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-26rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-104 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-26rem * var(--space-x-reverse));
    margin-left: calc(-26rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-26rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-112 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-28rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-28rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-28rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-112 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-28rem * var(--space-x-reverse));
    margin-left: calc(-28rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-28rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-124 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-31rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-31rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-31rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-124 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-31rem * var(--space-x-reverse));
    margin-left: calc(-31rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-31rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-128 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-32rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-32rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-32rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-128 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-32rem * var(--space-x-reverse));
    margin-left: calc(-32rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-32rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-140 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-35rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-35rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-35rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-140 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-35rem * var(--space-x-reverse));
    margin-left: calc(-35rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-35rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-152 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-38rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-38rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-38rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-152 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-38rem * var(--space-x-reverse));
    margin-left: calc(-38rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-38rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-160 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-40rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-40rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-40rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-160 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-40rem * var(--space-x-reverse));
    margin-left: calc(-40rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-40rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-162 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-41rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-41rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-41rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-162 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-41rem * var(--space-x-reverse));
    margin-left: calc(-41rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-41rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-192 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-48rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-48rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-48rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-192 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-48rem * var(--space-x-reverse));
    margin-left: calc(-48rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-48rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-208 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-52rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-52rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-52rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-208 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-52rem * var(--space-x-reverse));
    margin-left: calc(-52rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-52rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-224 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-56rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-56rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-56rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-224 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-56rem * var(--space-x-reverse));
    margin-left: calc(-56rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-56rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-256 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-64rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-64rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-64rem * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-256 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-64rem * var(--space-x-reverse));
    margin-left: calc(-64rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-64rem * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:-space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1px * (1 - var(--space-y-reverse)));
    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1px * var(--space-y-reverse));
  }

  .\\32xl\\:-space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1px * var(--space-x-reverse));
    margin-left: calc(-1px * (1 - var(--space-x-reverse)));
    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));
  }

  .\\32xl\\:space-y-reverse > :not(template) ~ :not(template){
    --space-y-reverse: 1;
  }

  .\\32xl\\:space-x-reverse > :not(template) ~ :not(template){
    --space-x-reverse: 1;
  }

  .\\32xl\\:divide-y-0 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(0px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(0px * var(--divide-y-reverse));
  }

  .\\32xl\\:divide-x-0 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(0px * var(--divide-x-reverse));
    border-left-width: calc(0px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));
  }

  .\\32xl\\:divide-y-2 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(2px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(2px * var(--divide-y-reverse));
  }

  .\\32xl\\:divide-x-2 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(2px * var(--divide-x-reverse));
    border-left-width: calc(2px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));
  }

  .\\32xl\\:divide-y-3 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(3px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(3px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(3px * var(--divide-y-reverse));
  }

  .\\32xl\\:divide-x-3 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(3px * var(--divide-x-reverse));
    border-left-width: calc(3px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(3px * calc(1 - var(--divide-x-reverse)));
  }

  .\\32xl\\:divide-y-4 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(4px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(4px * var(--divide-y-reverse));
  }

  .\\32xl\\:divide-x-4 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(4px * var(--divide-x-reverse));
    border-left-width: calc(4px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));
  }

  .\\32xl\\:divide-y-5 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(5px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(5px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(5px * var(--divide-y-reverse));
  }

  .\\32xl\\:divide-x-5 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(5px * var(--divide-x-reverse));
    border-left-width: calc(5px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(5px * calc(1 - var(--divide-x-reverse)));
  }

  .\\32xl\\:divide-y-6 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(6px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(6px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(6px * var(--divide-y-reverse));
  }

  .\\32xl\\:divide-x-6 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(6px * var(--divide-x-reverse));
    border-left-width: calc(6px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(6px * calc(1 - var(--divide-x-reverse)));
  }

  .\\32xl\\:divide-y-8 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(8px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(8px * var(--divide-y-reverse));
  }

  .\\32xl\\:divide-x-8 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(8px * var(--divide-x-reverse));
    border-left-width: calc(8px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));
  }

  .\\32xl\\:divide-y > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(1px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(1px * var(--divide-y-reverse));
  }

  .\\32xl\\:divide-x > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(1px * var(--divide-x-reverse));
    border-left-width: calc(1px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));
  }

  .\\32xl\\:divide-y-reverse > :not(template) ~ :not(template){
    --divide-y-reverse: 1;
  }

  .\\32xl\\:divide-x-reverse > :not(template) ~ :not(template){
    --divide-x-reverse: 1;
  }

  .\\32xl\\:divide-transparent > :not(template) ~ :not(template){
    border-color: transparent;
  }

  .\\32xl\\:divide-focus > :not(template) ~ :not(template){
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .\\32xl\\:divide-black > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--divide-opacity));
  }

  .\\32xl\\:divide-white > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--divide-opacity));
  }

  .\\32xl\\:divide-primary > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--divide-opacity));
  }

  .\\32xl\\:divide-disabled > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--divide-opacity));
  }

  .\\32xl\\:divide-translucent-60 > :not(template) ~ :not(template){
    border-color: rgba(256, 256, 256, 0.6);
  }

  .\\32xl\\:divide-translucent-90 > :not(template) ~ :not(template){
    border-color: rgba(256, 256, 256, 0.9);
  }

  .\\32xl\\:divide-green-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--divide-opacity));
  }

  .\\32xl\\:divide-green-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--divide-opacity));
  }

  .\\32xl\\:divide-green-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--divide-opacity));
  }

  .\\32xl\\:divide-green-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--divide-opacity));
  }

  .\\32xl\\:divide-green-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--divide-opacity));
  }

  .\\32xl\\:divide-green-400a50 > :not(template) ~ :not(template){
    border-color: rgba(108,202,152,0.50196);
  }

  .\\32xl\\:divide-green-500a25 > :not(template) ~ :not(template){
    border-color: rgba(151,232,18,0.09804);
  }

  .\\32xl\\:divide-yellow-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--divide-opacity));
  }

  .\\32xl\\:divide-yellow-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--divide-opacity));
  }

  .\\32xl\\:divide-yellow-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--divide-opacity));
  }

  .\\32xl\\:divide-yellow-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--divide-opacity));
  }

  .\\32xl\\:divide-yellow-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--divide-opacity));
  }

  .\\32xl\\:divide-yellow-300a66 > :not(template) ~ :not(template){
    border-color: rgba(255,233,189,0.66667);
  }

  .\\32xl\\:divide-yellow-500a25 > :not(template) ~ :not(template){
    border-color: rgba(255,200,44,0.09804);
  }

  .\\32xl\\:divide-orange-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--divide-opacity));
  }

  .\\32xl\\:divide-orange-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--divide-opacity));
  }

  .\\32xl\\:divide-orange-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--divide-opacity));
  }

  .\\32xl\\:divide-orange-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--divide-opacity));
  }

  .\\32xl\\:divide-orange-900 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--divide-opacity));
  }

  .\\32xl\\:divide-orange-500a25 > :not(template) ~ :not(template){
    border-color: rgba(240,115,23,0.09804);
  }

  .\\32xl\\:divide-red-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--divide-opacity));
  }

  .\\32xl\\:divide-red-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--divide-opacity));
  }

  .\\32xl\\:divide-red-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--divide-opacity));
  }

  .\\32xl\\:divide-red-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--divide-opacity));
  }

  .\\32xl\\:divide-red-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--divide-opacity));
  }

  .\\32xl\\:divide-red-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--divide-opacity));
  }

  .\\32xl\\:divide-red-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--divide-opacity));
  }

  .\\32xl\\:divide-gray-50 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--divide-opacity));
  }

  .\\32xl\\:divide-gray-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--divide-opacity));
  }

  .\\32xl\\:divide-gray-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--divide-opacity));
  }

  .\\32xl\\:divide-gray-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--divide-opacity));
  }

  .\\32xl\\:divide-gray-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--divide-opacity));
  }

  .\\32xl\\:divide-gray-400 > :not(template) ~ :not(template){
    border-color: rgba(114,114,114,0.8);
  }

  .\\32xl\\:divide-gray-425 > :not(template) ~ :not(template){
    border-color: rgba(4, 21, 39, 0.8);
  }

  .\\32xl\\:divide-gray-450 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--divide-opacity));
  }

  .\\32xl\\:divide-gray-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--divide-opacity));
  }

  .\\32xl\\:divide-gray-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--divide-opacity));
  }

  .\\32xl\\:divide-gray-625 > :not(template) ~ :not(template){
    border-color: rgba(90,98,107,0.8);
  }

  .\\32xl\\:divide-gray-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--divide-opacity));
  }

  .\\32xl\\:divide-gray-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--divide-opacity));
  }

  .\\32xl\\:divide-gray-200a50 > :not(template) ~ :not(template){
    border-color: rgba(224, 226, 228, 0.5);
  }

  .\\32xl\\:divide-blue-50 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--divide-opacity));
  }

  .\\32xl\\:divide-blue-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--divide-opacity));
  }

  .\\32xl\\:divide-blue-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--divide-opacity));
  }

  .\\32xl\\:divide-blue-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--divide-opacity));
  }

  .\\32xl\\:divide-blue-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--divide-opacity));
  }

  .\\32xl\\:divide-blue-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--divide-opacity));
  }

  .\\32xl\\:divide-blue-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--divide-opacity));
  }

  .\\32xl\\:divide-blue-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--divide-opacity));
  }

  .\\32xl\\:divide-blue-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--divide-opacity));
  }

  .\\32xl\\:divide-blue-750 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--divide-opacity));
  }

  .\\32xl\\:divide-blue-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--divide-opacity));
  }

  .\\32xl\\:divide-blue-900 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--divide-opacity));
  }

  .\\32xl\\:divide-blue-950 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--divide-opacity));
  }

  .\\32xl\\:divide-blue-500a25 > :not(template) ~ :not(template){
    border-color: rgba(55, 164, 220, 0.2);
  }

  .\\32xl\\:divide-blue-500a50 > :not(template) ~ :not(template){
    border-color: rgba(55, 164, 220, 0.5);
  }

  .\\32xl\\:divide-blue-700a75 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--divide-opacity));
  }

  .\\32xl\\:divide-blue-700a30 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--divide-opacity));
  }

  .\\32xl\\:divide-blue-750a25 > :not(template) ~ :not(template){
    border-color: rgba(86,130,170,0.09804);
  }

  .\\32xl\\:divide-blue-750a15 > :not(template) ~ :not(template){
    border-color: rgba(86,130,170,0.05882);
  }

  .\\32xl\\:divide-blue-800a60 > :not(template) ~ :not(template){
    border-color: rgba(31, 69, 102, 0.6);
  }

  .\\32xl\\:divide-programEditorTabColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--divide-opacity));
  }

  .\\32xl\\:divide-programEditorTabColors-2 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--divide-opacity));
  }

  .\\32xl\\:divide-programEditorTabColors-3 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--divide-opacity));
  }

  .\\32xl\\:divide-programEditorTabColors-4 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--divide-opacity));
  }

  .\\32xl\\:divide-programEditorTabColors-5 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--divide-opacity));
  }

  .\\32xl\\:divide-programEditorTabColors-6 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--divide-opacity));
  }

  .\\32xl\\:divide-programEditorTabColors-1h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--divide-opacity));
  }

  .\\32xl\\:divide-programEditorTabColors-2h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--divide-opacity));
  }

  .\\32xl\\:divide-programEditorTabColors-3h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--divide-opacity));
  }

  .\\32xl\\:divide-programEditorTabColors-4h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--divide-opacity));
  }

  .\\32xl\\:divide-programEditorTabColors-5h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--divide-opacity));
  }

  .\\32xl\\:divide-programEditorTabColors-6h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--divide-opacity));
  }

  .\\32xl\\:divide-programEditorPresetTabColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--divide-opacity));
  }

  .\\32xl\\:divide-programEditorPresetTabColors-1h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--divide-opacity));
  }

  .\\32xl\\:divide-borgScaleColors-0 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--divide-opacity));
  }

  .\\32xl\\:divide-borgScaleColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--divide-opacity));
  }

  .\\32xl\\:divide-borgScaleColors-2 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--divide-opacity));
  }

  .\\32xl\\:divide-borgScaleColors-3 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--divide-opacity));
  }

  .\\32xl\\:divide-borgScaleColors-4 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--divide-opacity));
  }

  .\\32xl\\:divide-borgScaleColors-5 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--divide-opacity));
  }

  .\\32xl\\:divide-borgScaleColors-6 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--divide-opacity));
  }

  .\\32xl\\:divide-borgScaleColors-7 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--divide-opacity));
  }

  .\\32xl\\:divide-borgScaleColors-8 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--divide-opacity));
  }

  .\\32xl\\:divide-borgScaleColors-9 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--divide-opacity));
  }

  .\\32xl\\:divide-borgScaleColors-10 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--divide-opacity));
  }

  .\\32xl\\:divide-solid > :not(template) ~ :not(template){
    border-style: solid;
  }

  .\\32xl\\:divide-dashed > :not(template) ~ :not(template){
    border-style: dashed;
  }

  .\\32xl\\:divide-dotted > :not(template) ~ :not(template){
    border-style: dotted;
  }

  .\\32xl\\:divide-double > :not(template) ~ :not(template){
    border-style: double;
  }

  .\\32xl\\:divide-none > :not(template) ~ :not(template){
    border-style: none;
  }

  .\\32xl\\:divide-opacity-0 > :not(template) ~ :not(template){
    --divide-opacity: 0;
  }

  .\\32xl\\:divide-opacity-25 > :not(template) ~ :not(template){
    --divide-opacity: .25;
  }

  .\\32xl\\:divide-opacity-50 > :not(template) ~ :not(template){
    --divide-opacity: .5;
  }

  .\\32xl\\:divide-opacity-75 > :not(template) ~ :not(template){
    --divide-opacity: .75;
  }

  .\\32xl\\:divide-opacity-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
  }

  .\\32xl\\:sr-only{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .\\32xl\\:not-sr-only{
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .\\32xl\\:focus\\:sr-only:focus{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .\\32xl\\:focus\\:not-sr-only:focus{
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .\\32xl\\:appearance-none{
    -webkit-appearance: none;
            appearance: none;
  }

  .\\32xl\\:bg-fixed{
    background-attachment: fixed;
  }

  .\\32xl\\:bg-local{
    background-attachment: local;
  }

  .\\32xl\\:bg-scroll{
    background-attachment: scroll;
  }

  .\\32xl\\:bg-clip-border{
    background-clip: border-box;
  }

  .\\32xl\\:bg-clip-padding{
    background-clip: padding-box;
  }

  .\\32xl\\:bg-clip-content{
    background-clip: content-box;
  }

  .\\32xl\\:bg-clip-text{
    -webkit-background-clip: text;
            background-clip: text;
  }

  .\\32xl\\:bg-transparent{
    background-color: transparent;
  }

  .\\32xl\\:bg-focus{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .\\32xl\\:bg-black{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .\\32xl\\:bg-white{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .\\32xl\\:bg-primary{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .\\32xl\\:bg-disabled{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .\\32xl\\:bg-translucent-60{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .\\32xl\\:bg-translucent-90{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .\\32xl\\:bg-green-200{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .\\32xl\\:bg-green-400{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .\\32xl\\:bg-green-500{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .\\32xl\\:bg-green-600{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .\\32xl\\:bg-green-700{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .\\32xl\\:bg-green-400a50{
    background-color: rgba(108,202,152,0.50196);
  }

  .\\32xl\\:bg-green-500a25{
    background-color: rgba(151,232,18,0.09804);
  }

  .\\32xl\\:bg-yellow-200{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .\\32xl\\:bg-yellow-300{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .\\32xl\\:bg-yellow-500{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .\\32xl\\:bg-yellow-600{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .\\32xl\\:bg-yellow-700{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .\\32xl\\:bg-yellow-300a66{
    background-color: rgba(255,233,189,0.66667);
  }

  .\\32xl\\:bg-yellow-500a25{
    background-color: rgba(255,200,44,0.09804);
  }

  .\\32xl\\:bg-orange-200{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .\\32xl\\:bg-orange-400{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .\\32xl\\:bg-orange-500{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .\\32xl\\:bg-orange-800{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .\\32xl\\:bg-orange-900{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .\\32xl\\:bg-orange-500a25{
    background-color: rgba(240,115,23,0.09804);
  }

  .\\32xl\\:bg-red-100{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .\\32xl\\:bg-red-150{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .\\32xl\\:bg-red-200{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .\\32xl\\:bg-red-300{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .\\32xl\\:bg-red-400{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .\\32xl\\:bg-red-500{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .\\32xl\\:bg-red-700{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .\\32xl\\:bg-gray-50{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .\\32xl\\:bg-gray-100{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .\\32xl\\:bg-gray-150{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .\\32xl\\:bg-gray-200{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .\\32xl\\:bg-gray-300{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .\\32xl\\:bg-gray-400{
    background-color: rgba(114,114,114,0.8);
  }

  .\\32xl\\:bg-gray-425{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .\\32xl\\:bg-gray-450{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .\\32xl\\:bg-gray-500{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .\\32xl\\:bg-gray-600{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .\\32xl\\:bg-gray-625{
    background-color: rgba(90,98,107,0.8);
  }

  .\\32xl\\:bg-gray-700{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .\\32xl\\:bg-gray-800{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .\\32xl\\:bg-gray-200a50{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .\\32xl\\:bg-blue-50{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .\\32xl\\:bg-blue-100{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .\\32xl\\:bg-blue-150{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .\\32xl\\:bg-blue-200{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .\\32xl\\:bg-blue-300{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .\\32xl\\:bg-blue-400{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .\\32xl\\:bg-blue-500{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .\\32xl\\:bg-blue-600{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .\\32xl\\:bg-blue-700{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .\\32xl\\:bg-blue-750{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .\\32xl\\:bg-blue-800{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .\\32xl\\:bg-blue-900{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .\\32xl\\:bg-blue-950{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .\\32xl\\:bg-blue-500a25{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .\\32xl\\:bg-blue-500a50{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .\\32xl\\:bg-blue-700a75{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .\\32xl\\:bg-blue-700a30{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .\\32xl\\:bg-blue-750a25{
    background-color: rgba(86,130,170,0.09804);
  }

  .\\32xl\\:bg-blue-750a15{
    background-color: rgba(86,130,170,0.05882);
  }

  .\\32xl\\:bg-blue-800a60{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .\\32xl\\:bg-programEditorTabColors-1{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .\\32xl\\:bg-programEditorTabColors-2{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .\\32xl\\:bg-programEditorTabColors-3{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .\\32xl\\:bg-programEditorTabColors-4{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .\\32xl\\:bg-programEditorTabColors-5{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .\\32xl\\:bg-programEditorTabColors-6{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .\\32xl\\:bg-programEditorTabColors-1h{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .\\32xl\\:bg-programEditorTabColors-2h{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .\\32xl\\:bg-programEditorTabColors-3h{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .\\32xl\\:bg-programEditorTabColors-4h{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .\\32xl\\:bg-programEditorTabColors-5h{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .\\32xl\\:bg-programEditorTabColors-6h{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .\\32xl\\:bg-programEditorPresetTabColors-1{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .\\32xl\\:bg-programEditorPresetTabColors-1h{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .\\32xl\\:bg-borgScaleColors-0{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .\\32xl\\:bg-borgScaleColors-1{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .\\32xl\\:bg-borgScaleColors-2{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .\\32xl\\:bg-borgScaleColors-3{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .\\32xl\\:bg-borgScaleColors-4{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .\\32xl\\:bg-borgScaleColors-5{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .\\32xl\\:bg-borgScaleColors-6{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .\\32xl\\:bg-borgScaleColors-7{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .\\32xl\\:bg-borgScaleColors-8{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .\\32xl\\:bg-borgScaleColors-9{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .\\32xl\\:bg-borgScaleColors-10{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-transparent:hover{
    background-color: transparent;
  }

  .\\32xl\\:hover\\:bg-focus:hover{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .\\32xl\\:hover\\:bg-black:hover{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-white:hover{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-primary:hover{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-disabled:hover{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-translucent-60:hover{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .\\32xl\\:hover\\:bg-translucent-90:hover{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .\\32xl\\:hover\\:bg-green-200:hover{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-green-400:hover{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-green-500:hover{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-green-600:hover{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-green-700:hover{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-green-400a50:hover{
    background-color: rgba(108,202,152,0.50196);
  }

  .\\32xl\\:hover\\:bg-green-500a25:hover{
    background-color: rgba(151,232,18,0.09804);
  }

  .\\32xl\\:hover\\:bg-yellow-200:hover{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-yellow-300:hover{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-yellow-500:hover{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-yellow-600:hover{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-yellow-700:hover{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-yellow-300a66:hover{
    background-color: rgba(255,233,189,0.66667);
  }

  .\\32xl\\:hover\\:bg-yellow-500a25:hover{
    background-color: rgba(255,200,44,0.09804);
  }

  .\\32xl\\:hover\\:bg-orange-200:hover{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-orange-400:hover{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-orange-500:hover{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-orange-800:hover{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-orange-900:hover{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-orange-500a25:hover{
    background-color: rgba(240,115,23,0.09804);
  }

  .\\32xl\\:hover\\:bg-red-100:hover{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-red-150:hover{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-red-200:hover{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-red-300:hover{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-red-400:hover{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-red-500:hover{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-red-700:hover{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-gray-50:hover{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-gray-100:hover{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-gray-150:hover{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-gray-200:hover{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-gray-300:hover{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-gray-400:hover{
    background-color: rgba(114,114,114,0.8);
  }

  .\\32xl\\:hover\\:bg-gray-425:hover{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .\\32xl\\:hover\\:bg-gray-450:hover{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-gray-500:hover{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-gray-600:hover{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-gray-625:hover{
    background-color: rgba(90,98,107,0.8);
  }

  .\\32xl\\:hover\\:bg-gray-700:hover{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-gray-800:hover{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-gray-200a50:hover{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .\\32xl\\:hover\\:bg-blue-50:hover{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-blue-100:hover{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-blue-150:hover{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-blue-200:hover{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-blue-300:hover{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-blue-400:hover{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-blue-500:hover{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-blue-600:hover{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-blue-700:hover{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-blue-750:hover{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-blue-800:hover{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-blue-900:hover{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-blue-950:hover{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-blue-500a25:hover{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .\\32xl\\:hover\\:bg-blue-500a50:hover{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .\\32xl\\:hover\\:bg-blue-700a75:hover{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-blue-700a30:hover{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-blue-750a25:hover{
    background-color: rgba(86,130,170,0.09804);
  }

  .\\32xl\\:hover\\:bg-blue-750a15:hover{
    background-color: rgba(86,130,170,0.05882);
  }

  .\\32xl\\:hover\\:bg-blue-800a60:hover{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .\\32xl\\:hover\\:bg-programEditorTabColors-1:hover{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-programEditorTabColors-2:hover{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-programEditorTabColors-3:hover{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-programEditorTabColors-4:hover{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-programEditorTabColors-5:hover{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-programEditorTabColors-6:hover{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-programEditorTabColors-1h:hover{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-programEditorTabColors-2h:hover{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-programEditorTabColors-3h:hover{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-programEditorTabColors-4h:hover{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-programEditorTabColors-5h:hover{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-programEditorTabColors-6h:hover{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-programEditorPresetTabColors-1:hover{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-programEditorPresetTabColors-1h:hover{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-borgScaleColors-0:hover{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-borgScaleColors-1:hover{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-borgScaleColors-2:hover{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-borgScaleColors-3:hover{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-borgScaleColors-4:hover{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-borgScaleColors-5:hover{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-borgScaleColors-6:hover{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-borgScaleColors-7:hover{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-borgScaleColors-8:hover{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-borgScaleColors-9:hover{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .\\32xl\\:hover\\:bg-borgScaleColors-10:hover{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-transparent:focus{
    background-color: transparent;
  }

  .\\32xl\\:focus\\:bg-focus:focus{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .\\32xl\\:focus\\:bg-black:focus{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-white:focus{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-primary:focus{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-disabled:focus{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-translucent-60:focus{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .\\32xl\\:focus\\:bg-translucent-90:focus{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .\\32xl\\:focus\\:bg-green-200:focus{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-green-400:focus{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-green-500:focus{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-green-600:focus{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-green-700:focus{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-green-400a50:focus{
    background-color: rgba(108,202,152,0.50196);
  }

  .\\32xl\\:focus\\:bg-green-500a25:focus{
    background-color: rgba(151,232,18,0.09804);
  }

  .\\32xl\\:focus\\:bg-yellow-200:focus{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-yellow-300:focus{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-yellow-500:focus{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-yellow-600:focus{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-yellow-700:focus{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-yellow-300a66:focus{
    background-color: rgba(255,233,189,0.66667);
  }

  .\\32xl\\:focus\\:bg-yellow-500a25:focus{
    background-color: rgba(255,200,44,0.09804);
  }

  .\\32xl\\:focus\\:bg-orange-200:focus{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-orange-400:focus{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-orange-500:focus{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-orange-800:focus{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-orange-900:focus{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-orange-500a25:focus{
    background-color: rgba(240,115,23,0.09804);
  }

  .\\32xl\\:focus\\:bg-red-100:focus{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-red-150:focus{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-red-200:focus{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-red-300:focus{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-red-400:focus{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-red-500:focus{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-red-700:focus{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-gray-50:focus{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-gray-100:focus{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-gray-150:focus{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-gray-200:focus{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-gray-300:focus{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-gray-400:focus{
    background-color: rgba(114,114,114,0.8);
  }

  .\\32xl\\:focus\\:bg-gray-425:focus{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .\\32xl\\:focus\\:bg-gray-450:focus{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-gray-500:focus{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-gray-600:focus{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-gray-625:focus{
    background-color: rgba(90,98,107,0.8);
  }

  .\\32xl\\:focus\\:bg-gray-700:focus{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-gray-800:focus{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-gray-200a50:focus{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .\\32xl\\:focus\\:bg-blue-50:focus{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-blue-100:focus{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-blue-150:focus{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-blue-200:focus{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-blue-300:focus{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-blue-400:focus{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-blue-500:focus{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-blue-600:focus{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-blue-700:focus{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-blue-750:focus{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-blue-800:focus{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-blue-900:focus{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-blue-950:focus{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-blue-500a25:focus{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .\\32xl\\:focus\\:bg-blue-500a50:focus{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .\\32xl\\:focus\\:bg-blue-700a75:focus{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-blue-700a30:focus{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-blue-750a25:focus{
    background-color: rgba(86,130,170,0.09804);
  }

  .\\32xl\\:focus\\:bg-blue-750a15:focus{
    background-color: rgba(86,130,170,0.05882);
  }

  .\\32xl\\:focus\\:bg-blue-800a60:focus{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .\\32xl\\:focus\\:bg-programEditorTabColors-1:focus{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-programEditorTabColors-2:focus{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-programEditorTabColors-3:focus{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-programEditorTabColors-4:focus{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-programEditorTabColors-5:focus{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-programEditorTabColors-6:focus{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-programEditorTabColors-1h:focus{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-programEditorTabColors-2h:focus{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-programEditorTabColors-3h:focus{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-programEditorTabColors-4h:focus{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-programEditorTabColors-5h:focus{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-programEditorTabColors-6h:focus{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-programEditorPresetTabColors-1:focus{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-programEditorPresetTabColors-1h:focus{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-borgScaleColors-0:focus{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-borgScaleColors-1:focus{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-borgScaleColors-2:focus{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-borgScaleColors-3:focus{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-borgScaleColors-4:focus{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-borgScaleColors-5:focus{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-borgScaleColors-6:focus{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-borgScaleColors-7:focus{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-borgScaleColors-8:focus{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-borgScaleColors-9:focus{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .\\32xl\\:focus\\:bg-borgScaleColors-10:focus{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .\\32xl\\:bg-none{
    background-image: none;
  }

  .\\32xl\\:bg-gradient-to-t{
    background-image: linear-gradient(to top, var(--gradient-color-stops));
  }

  .\\32xl\\:bg-gradient-to-tr{
    background-image: linear-gradient(to top right, var(--gradient-color-stops));
  }

  .\\32xl\\:bg-gradient-to-r{
    background-image: linear-gradient(to right, var(--gradient-color-stops));
  }

  .\\32xl\\:bg-gradient-to-br{
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
  }

  .\\32xl\\:bg-gradient-to-b{
    background-image: linear-gradient(to bottom, var(--gradient-color-stops));
  }

  .\\32xl\\:bg-gradient-to-bl{
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
  }

  .\\32xl\\:bg-gradient-to-l{
    background-image: linear-gradient(to left, var(--gradient-color-stops));
  }

  .\\32xl\\:bg-gradient-to-tl{
    background-image: linear-gradient(to top left, var(--gradient-color-stops));
  }

  .\\32xl\\:from-transparent{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\32xl\\:from-focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:from-black{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\32xl\\:from-white{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:from-primary{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:from-disabled{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\32xl\\:from-translucent-60{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:from-translucent-90{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:from-green-200{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .\\32xl\\:from-green-400{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\32xl\\:from-green-500{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\32xl\\:from-green-600{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .\\32xl\\:from-green-700{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .\\32xl\\:from-green-400a50{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\32xl\\:from-green-500a25{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\32xl\\:from-yellow-200{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .\\32xl\\:from-yellow-300{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\32xl\\:from-yellow-500{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\32xl\\:from-yellow-600{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .\\32xl\\:from-yellow-700{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .\\32xl\\:from-yellow-300a66{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\32xl\\:from-yellow-500a25{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\32xl\\:from-orange-200{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .\\32xl\\:from-orange-400{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .\\32xl\\:from-orange-500{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .\\32xl\\:from-orange-800{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .\\32xl\\:from-orange-900{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .\\32xl\\:from-orange-500a25{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .\\32xl\\:from-red-100{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .\\32xl\\:from-red-150{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .\\32xl\\:from-red-200{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .\\32xl\\:from-red-300{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .\\32xl\\:from-red-400{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .\\32xl\\:from-red-500{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .\\32xl\\:from-red-700{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .\\32xl\\:from-gray-50{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .\\32xl\\:from-gray-100{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .\\32xl\\:from-gray-150{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .\\32xl\\:from-gray-200{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\32xl\\:from-gray-300{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\32xl\\:from-gray-400{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\32xl\\:from-gray-425{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\32xl\\:from-gray-450{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .\\32xl\\:from-gray-500{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\32xl\\:from-gray-600{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\32xl\\:from-gray-625{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\32xl\\:from-gray-700{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .\\32xl\\:from-gray-800{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .\\32xl\\:from-gray-200a50{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\32xl\\:from-blue-50{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .\\32xl\\:from-blue-100{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .\\32xl\\:from-blue-150{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .\\32xl\\:from-blue-200{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .\\32xl\\:from-blue-300{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .\\32xl\\:from-blue-400{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\32xl\\:from-blue-500{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:from-blue-600{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .\\32xl\\:from-blue-700{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .\\32xl\\:from-blue-750{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:from-blue-800{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\32xl\\:from-blue-900{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .\\32xl\\:from-blue-950{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\32xl\\:from-blue-500a25{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:from-blue-500a50{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:from-blue-700a75{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .\\32xl\\:from-blue-700a30{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .\\32xl\\:from-blue-750a25{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:from-blue-750a15{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:from-blue-800a60{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\32xl\\:from-programEditorTabColors-1{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .\\32xl\\:from-programEditorTabColors-2{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .\\32xl\\:from-programEditorTabColors-3{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .\\32xl\\:from-programEditorTabColors-4{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .\\32xl\\:from-programEditorTabColors-5{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .\\32xl\\:from-programEditorTabColors-6{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .\\32xl\\:from-programEditorTabColors-1h{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .\\32xl\\:from-programEditorTabColors-2h{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .\\32xl\\:from-programEditorTabColors-3h{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .\\32xl\\:from-programEditorTabColors-4h{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .\\32xl\\:from-programEditorTabColors-5h{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .\\32xl\\:from-programEditorTabColors-6h{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .\\32xl\\:from-programEditorPresetTabColors-1{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\32xl\\:from-programEditorPresetTabColors-1h{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\32xl\\:from-borgScaleColors-0{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .\\32xl\\:from-borgScaleColors-1{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .\\32xl\\:from-borgScaleColors-2{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .\\32xl\\:from-borgScaleColors-3{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .\\32xl\\:from-borgScaleColors-4{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\32xl\\:from-borgScaleColors-5{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .\\32xl\\:from-borgScaleColors-6{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .\\32xl\\:from-borgScaleColors-7{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .\\32xl\\:from-borgScaleColors-8{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .\\32xl\\:from-borgScaleColors-9{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .\\32xl\\:from-borgScaleColors-10{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .\\32xl\\:via-transparent{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\32xl\\:via-focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:via-black{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\32xl\\:via-white{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:via-primary{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:via-disabled{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\32xl\\:via-translucent-60{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:via-translucent-90{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:via-green-200{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .\\32xl\\:via-green-400{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\32xl\\:via-green-500{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\32xl\\:via-green-600{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .\\32xl\\:via-green-700{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .\\32xl\\:via-green-400a50{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\32xl\\:via-green-500a25{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\32xl\\:via-yellow-200{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .\\32xl\\:via-yellow-300{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\32xl\\:via-yellow-500{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\32xl\\:via-yellow-600{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .\\32xl\\:via-yellow-700{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .\\32xl\\:via-yellow-300a66{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\32xl\\:via-yellow-500a25{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\32xl\\:via-orange-200{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .\\32xl\\:via-orange-400{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .\\32xl\\:via-orange-500{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .\\32xl\\:via-orange-800{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .\\32xl\\:via-orange-900{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .\\32xl\\:via-orange-500a25{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .\\32xl\\:via-red-100{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .\\32xl\\:via-red-150{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .\\32xl\\:via-red-200{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .\\32xl\\:via-red-300{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .\\32xl\\:via-red-400{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .\\32xl\\:via-red-500{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .\\32xl\\:via-red-700{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .\\32xl\\:via-gray-50{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .\\32xl\\:via-gray-100{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .\\32xl\\:via-gray-150{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .\\32xl\\:via-gray-200{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\32xl\\:via-gray-300{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\32xl\\:via-gray-400{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\32xl\\:via-gray-425{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\32xl\\:via-gray-450{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .\\32xl\\:via-gray-500{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\32xl\\:via-gray-600{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\32xl\\:via-gray-625{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\32xl\\:via-gray-700{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .\\32xl\\:via-gray-800{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .\\32xl\\:via-gray-200a50{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\32xl\\:via-blue-50{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .\\32xl\\:via-blue-100{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .\\32xl\\:via-blue-150{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .\\32xl\\:via-blue-200{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .\\32xl\\:via-blue-300{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .\\32xl\\:via-blue-400{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\32xl\\:via-blue-500{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:via-blue-600{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .\\32xl\\:via-blue-700{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .\\32xl\\:via-blue-750{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:via-blue-800{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\32xl\\:via-blue-900{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .\\32xl\\:via-blue-950{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\32xl\\:via-blue-500a25{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:via-blue-500a50{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:via-blue-700a75{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .\\32xl\\:via-blue-700a30{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .\\32xl\\:via-blue-750a25{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:via-blue-750a15{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:via-blue-800a60{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\32xl\\:via-programEditorTabColors-1{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .\\32xl\\:via-programEditorTabColors-2{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .\\32xl\\:via-programEditorTabColors-3{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .\\32xl\\:via-programEditorTabColors-4{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .\\32xl\\:via-programEditorTabColors-5{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .\\32xl\\:via-programEditorTabColors-6{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .\\32xl\\:via-programEditorTabColors-1h{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .\\32xl\\:via-programEditorTabColors-2h{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .\\32xl\\:via-programEditorTabColors-3h{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .\\32xl\\:via-programEditorTabColors-4h{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .\\32xl\\:via-programEditorTabColors-5h{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .\\32xl\\:via-programEditorTabColors-6h{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .\\32xl\\:via-programEditorPresetTabColors-1{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\32xl\\:via-programEditorPresetTabColors-1h{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\32xl\\:via-borgScaleColors-0{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .\\32xl\\:via-borgScaleColors-1{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .\\32xl\\:via-borgScaleColors-2{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .\\32xl\\:via-borgScaleColors-3{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .\\32xl\\:via-borgScaleColors-4{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\32xl\\:via-borgScaleColors-5{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .\\32xl\\:via-borgScaleColors-6{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .\\32xl\\:via-borgScaleColors-7{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .\\32xl\\:via-borgScaleColors-8{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .\\32xl\\:via-borgScaleColors-9{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .\\32xl\\:via-borgScaleColors-10{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .\\32xl\\:to-transparent{
    --gradient-to-color: transparent;
  }

  .\\32xl\\:to-focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .\\32xl\\:to-black{
    --gradient-to-color: #000;
  }

  .\\32xl\\:to-white{
    --gradient-to-color: #fff;
  }

  .\\32xl\\:to-primary{
    --gradient-to-color: #37A4DC;
  }

  .\\32xl\\:to-disabled{
    --gradient-to-color: #BFBFBF;
  }

  .\\32xl\\:to-translucent-60{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .\\32xl\\:to-translucent-90{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .\\32xl\\:to-green-200{
    --gradient-to-color: #f4fcea;
  }

  .\\32xl\\:to-green-400{
    --gradient-to-color: #6CCA98;
  }

  .\\32xl\\:to-green-500{
    --gradient-to-color: #97E812;
  }

  .\\32xl\\:to-green-600{
    --gradient-to-color: #4f9112;
  }

  .\\32xl\\:to-green-700{
    --gradient-to-color: #3e7211;
  }

  .\\32xl\\:to-green-400a50{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .\\32xl\\:to-green-500a25{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .\\32xl\\:to-yellow-200{
    --gradient-to-color: #fff9eb;
  }

  .\\32xl\\:to-yellow-300{
    --gradient-to-color: #ffe9bd;
  }

  .\\32xl\\:to-yellow-500{
    --gradient-to-color: #FFC82C;
  }

  .\\32xl\\:to-yellow-600{
    --gradient-to-color: #F7931E;
  }

  .\\32xl\\:to-yellow-700{
    --gradient-to-color: #E1AD28;
  }

  .\\32xl\\:to-yellow-300a66{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .\\32xl\\:to-yellow-500a25{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .\\32xl\\:to-orange-200{
    --gradient-to-color: #fdf0ea;
  }

  .\\32xl\\:to-orange-400{
    --gradient-to-color: #f6c66f;
  }

  .\\32xl\\:to-orange-500{
    --gradient-to-color: #F07313;
  }

  .\\32xl\\:to-orange-800{
    --gradient-to-color: #db5d0c;
  }

  .\\32xl\\:to-orange-900{
    --gradient-to-color: #b86814;
  }

  .\\32xl\\:to-orange-500a25{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .\\32xl\\:to-red-100{
    --gradient-to-color: #FEF5F5;
  }

  .\\32xl\\:to-red-150{
    --gradient-to-color: #ffe9e8;
  }

  .\\32xl\\:to-red-200{
    --gradient-to-color: #F8CECC;
  }

  .\\32xl\\:to-red-300{
    --gradient-to-color: #ff8585;
  }

  .\\32xl\\:to-red-400{
    --gradient-to-color: #ff3535;
  }

  .\\32xl\\:to-red-500{
    --gradient-to-color: #DD4746;
  }

  .\\32xl\\:to-red-700{
    --gradient-to-color: #A23C24;
  }

  .\\32xl\\:to-gray-50{
    --gradient-to-color: #F9F9F9;
  }

  .\\32xl\\:to-gray-100{
    --gradient-to-color: #F1F1F2;
  }

  .\\32xl\\:to-gray-150{
    --gradient-to-color: #e6e6e6;
  }

  .\\32xl\\:to-gray-200{
    --gradient-to-color: #E0E2E4;
  }

  .\\32xl\\:to-gray-300{
    --gradient-to-color: #BFBFBF;
  }

  .\\32xl\\:to-gray-400{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .\\32xl\\:to-gray-425{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .\\32xl\\:to-gray-450{
    --gradient-to-color: #959595;
  }

  .\\32xl\\:to-gray-500{
    --gradient-to-color: #727272;
  }

  .\\32xl\\:to-gray-600{
    --gradient-to-color: #5a626b;
  }

  .\\32xl\\:to-gray-625{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .\\32xl\\:to-gray-700{
    --gradient-to-color: #464C59;
  }

  .\\32xl\\:to-gray-800{
    --gradient-to-color: #3c3b3b;
  }

  .\\32xl\\:to-gray-200a50{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .\\32xl\\:to-blue-50{
    --gradient-to-color: #f2fbff;
  }

  .\\32xl\\:to-blue-100{
    --gradient-to-color: #EBF6FC;
  }

  .\\32xl\\:to-blue-150{
    --gradient-to-color: #E8EEF1;
  }

  .\\32xl\\:to-blue-200{
    --gradient-to-color: #CCE6F5;
  }

  .\\32xl\\:to-blue-300{
    --gradient-to-color: #73BFE7;
  }

  .\\32xl\\:to-blue-400{
    --gradient-to-color: #4BA4F7;
  }

  .\\32xl\\:to-blue-500{
    --gradient-to-color: #37A4DC;
  }

  .\\32xl\\:to-blue-600{
    --gradient-to-color: #6AA2D6;
  }

  .\\32xl\\:to-blue-700{
    --gradient-to-color: #456E9A;
  }

  .\\32xl\\:to-blue-750{
    --gradient-to-color: #5682AA;
  }

  .\\32xl\\:to-blue-800{
    --gradient-to-color: #1F4566;
  }

  .\\32xl\\:to-blue-900{
    --gradient-to-color: #183453;
  }

  .\\32xl\\:to-blue-950{
    --gradient-to-color: #041527;
  }

  .\\32xl\\:to-blue-500a25{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .\\32xl\\:to-blue-500a50{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .\\32xl\\:to-blue-700a75{
    --gradient-to-color: #3B648D;
  }

  .\\32xl\\:to-blue-700a30{
    --gradient-to-color: #2A5176;
  }

  .\\32xl\\:to-blue-750a25{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .\\32xl\\:to-blue-750a15{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .\\32xl\\:to-blue-800a60{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .\\32xl\\:to-programEditorTabColors-1{
    --gradient-to-color: #3cacae;
  }

  .\\32xl\\:to-programEditorTabColors-2{
    --gradient-to-color: #8e346a;
  }

  .\\32xl\\:to-programEditorTabColors-3{
    --gradient-to-color: #ff72b7;
  }

  .\\32xl\\:to-programEditorTabColors-4{
    --gradient-to-color: #ce941c;
  }

  .\\32xl\\:to-programEditorTabColors-5{
    --gradient-to-color: #b973d9;
  }

  .\\32xl\\:to-programEditorTabColors-6{
    --gradient-to-color: #ff9082;
  }

  .\\32xl\\:to-programEditorTabColors-1h{
    --gradient-to-color: #d9f2f2;
  }

  .\\32xl\\:to-programEditorTabColors-2h{
    --gradient-to-color: #f1dae8;
  }

  .\\32xl\\:to-programEditorTabColors-3h{
    --gradient-to-color: #ffe6f2;
  }

  .\\32xl\\:to-programEditorTabColors-4h{
    --gradient-to-color: #f9ecd2;
  }

  .\\32xl\\:to-programEditorTabColors-5h{
    --gradient-to-color: #f5ebfa;
  }

  .\\32xl\\:to-programEditorTabColors-6h{
    --gradient-to-color: #ffe8e6;
  }

  .\\32xl\\:to-programEditorPresetTabColors-1{
    --gradient-to-color: #798fa3;
  }

  .\\32xl\\:to-programEditorPresetTabColors-1h{
    --gradient-to-color: #798fa3;
  }

  .\\32xl\\:to-borgScaleColors-0{
    --gradient-to-color: #c5d1ff;
  }

  .\\32xl\\:to-borgScaleColors-1{
    --gradient-to-color: #a0b5fc;
  }

  .\\32xl\\:to-borgScaleColors-2{
    --gradient-to-color: #7492ff;
  }

  .\\32xl\\:to-borgScaleColors-3{
    --gradient-to-color: #82bbf1;
  }

  .\\32xl\\:to-borgScaleColors-4{
    --gradient-to-color: #4ba4f7;
  }

  .\\32xl\\:to-borgScaleColors-5{
    --gradient-to-color: #9cdd57;
  }

  .\\32xl\\:to-borgScaleColors-6{
    --gradient-to-color: #68af00;
  }

  .\\32xl\\:to-borgScaleColors-7{
    --gradient-to-color: #f5e380;
  }

  .\\32xl\\:to-borgScaleColors-8{
    --gradient-to-color: #ffc246;
  }

  .\\32xl\\:to-borgScaleColors-9{
    --gradient-to-color: #ff782f;
  }

  .\\32xl\\:to-borgScaleColors-10{
    --gradient-to-color: #f25757;
  }

  .\\32xl\\:hover\\:from-transparent:hover{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\32xl\\:hover\\:from-focus:hover{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:hover\\:from-black:hover{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\32xl\\:hover\\:from-white:hover{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:hover\\:from-primary:hover{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:hover\\:from-disabled:hover{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\32xl\\:hover\\:from-translucent-60:hover{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:hover\\:from-translucent-90:hover{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:hover\\:from-green-200:hover{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .\\32xl\\:hover\\:from-green-400:hover{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\32xl\\:hover\\:from-green-500:hover{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\32xl\\:hover\\:from-green-600:hover{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .\\32xl\\:hover\\:from-green-700:hover{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .\\32xl\\:hover\\:from-green-400a50:hover{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\32xl\\:hover\\:from-green-500a25:hover{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\32xl\\:hover\\:from-yellow-200:hover{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .\\32xl\\:hover\\:from-yellow-300:hover{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\32xl\\:hover\\:from-yellow-500:hover{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\32xl\\:hover\\:from-yellow-600:hover{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .\\32xl\\:hover\\:from-yellow-700:hover{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .\\32xl\\:hover\\:from-yellow-300a66:hover{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\32xl\\:hover\\:from-yellow-500a25:hover{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\32xl\\:hover\\:from-orange-200:hover{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .\\32xl\\:hover\\:from-orange-400:hover{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .\\32xl\\:hover\\:from-orange-500:hover{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .\\32xl\\:hover\\:from-orange-800:hover{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .\\32xl\\:hover\\:from-orange-900:hover{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .\\32xl\\:hover\\:from-orange-500a25:hover{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .\\32xl\\:hover\\:from-red-100:hover{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .\\32xl\\:hover\\:from-red-150:hover{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .\\32xl\\:hover\\:from-red-200:hover{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .\\32xl\\:hover\\:from-red-300:hover{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .\\32xl\\:hover\\:from-red-400:hover{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .\\32xl\\:hover\\:from-red-500:hover{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .\\32xl\\:hover\\:from-red-700:hover{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .\\32xl\\:hover\\:from-gray-50:hover{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .\\32xl\\:hover\\:from-gray-100:hover{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .\\32xl\\:hover\\:from-gray-150:hover{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .\\32xl\\:hover\\:from-gray-200:hover{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\32xl\\:hover\\:from-gray-300:hover{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\32xl\\:hover\\:from-gray-400:hover{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\32xl\\:hover\\:from-gray-425:hover{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\32xl\\:hover\\:from-gray-450:hover{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .\\32xl\\:hover\\:from-gray-500:hover{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\32xl\\:hover\\:from-gray-600:hover{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\32xl\\:hover\\:from-gray-625:hover{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\32xl\\:hover\\:from-gray-700:hover{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .\\32xl\\:hover\\:from-gray-800:hover{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .\\32xl\\:hover\\:from-gray-200a50:hover{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\32xl\\:hover\\:from-blue-50:hover{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .\\32xl\\:hover\\:from-blue-100:hover{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .\\32xl\\:hover\\:from-blue-150:hover{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .\\32xl\\:hover\\:from-blue-200:hover{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .\\32xl\\:hover\\:from-blue-300:hover{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .\\32xl\\:hover\\:from-blue-400:hover{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\32xl\\:hover\\:from-blue-500:hover{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:hover\\:from-blue-600:hover{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .\\32xl\\:hover\\:from-blue-700:hover{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .\\32xl\\:hover\\:from-blue-750:hover{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:hover\\:from-blue-800:hover{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\32xl\\:hover\\:from-blue-900:hover{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .\\32xl\\:hover\\:from-blue-950:hover{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\32xl\\:hover\\:from-blue-500a25:hover{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:hover\\:from-blue-500a50:hover{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:hover\\:from-blue-700a75:hover{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .\\32xl\\:hover\\:from-blue-700a30:hover{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .\\32xl\\:hover\\:from-blue-750a25:hover{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:hover\\:from-blue-750a15:hover{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:hover\\:from-blue-800a60:hover{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\32xl\\:hover\\:from-programEditorTabColors-1:hover{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .\\32xl\\:hover\\:from-programEditorTabColors-2:hover{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .\\32xl\\:hover\\:from-programEditorTabColors-3:hover{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .\\32xl\\:hover\\:from-programEditorTabColors-4:hover{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .\\32xl\\:hover\\:from-programEditorTabColors-5:hover{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .\\32xl\\:hover\\:from-programEditorTabColors-6:hover{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .\\32xl\\:hover\\:from-programEditorTabColors-1h:hover{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .\\32xl\\:hover\\:from-programEditorTabColors-2h:hover{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .\\32xl\\:hover\\:from-programEditorTabColors-3h:hover{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .\\32xl\\:hover\\:from-programEditorTabColors-4h:hover{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .\\32xl\\:hover\\:from-programEditorTabColors-5h:hover{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .\\32xl\\:hover\\:from-programEditorTabColors-6h:hover{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .\\32xl\\:hover\\:from-programEditorPresetTabColors-1:hover{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\32xl\\:hover\\:from-programEditorPresetTabColors-1h:hover{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\32xl\\:hover\\:from-borgScaleColors-0:hover{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .\\32xl\\:hover\\:from-borgScaleColors-1:hover{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .\\32xl\\:hover\\:from-borgScaleColors-2:hover{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .\\32xl\\:hover\\:from-borgScaleColors-3:hover{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .\\32xl\\:hover\\:from-borgScaleColors-4:hover{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\32xl\\:hover\\:from-borgScaleColors-5:hover{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .\\32xl\\:hover\\:from-borgScaleColors-6:hover{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .\\32xl\\:hover\\:from-borgScaleColors-7:hover{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .\\32xl\\:hover\\:from-borgScaleColors-8:hover{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .\\32xl\\:hover\\:from-borgScaleColors-9:hover{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .\\32xl\\:hover\\:from-borgScaleColors-10:hover{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .\\32xl\\:hover\\:via-transparent:hover{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\32xl\\:hover\\:via-focus:hover{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:hover\\:via-black:hover{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\32xl\\:hover\\:via-white:hover{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:hover\\:via-primary:hover{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:hover\\:via-disabled:hover{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\32xl\\:hover\\:via-translucent-60:hover{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:hover\\:via-translucent-90:hover{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:hover\\:via-green-200:hover{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .\\32xl\\:hover\\:via-green-400:hover{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\32xl\\:hover\\:via-green-500:hover{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\32xl\\:hover\\:via-green-600:hover{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .\\32xl\\:hover\\:via-green-700:hover{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .\\32xl\\:hover\\:via-green-400a50:hover{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\32xl\\:hover\\:via-green-500a25:hover{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\32xl\\:hover\\:via-yellow-200:hover{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .\\32xl\\:hover\\:via-yellow-300:hover{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\32xl\\:hover\\:via-yellow-500:hover{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\32xl\\:hover\\:via-yellow-600:hover{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .\\32xl\\:hover\\:via-yellow-700:hover{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .\\32xl\\:hover\\:via-yellow-300a66:hover{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\32xl\\:hover\\:via-yellow-500a25:hover{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\32xl\\:hover\\:via-orange-200:hover{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .\\32xl\\:hover\\:via-orange-400:hover{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .\\32xl\\:hover\\:via-orange-500:hover{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .\\32xl\\:hover\\:via-orange-800:hover{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .\\32xl\\:hover\\:via-orange-900:hover{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .\\32xl\\:hover\\:via-orange-500a25:hover{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .\\32xl\\:hover\\:via-red-100:hover{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .\\32xl\\:hover\\:via-red-150:hover{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .\\32xl\\:hover\\:via-red-200:hover{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .\\32xl\\:hover\\:via-red-300:hover{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .\\32xl\\:hover\\:via-red-400:hover{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .\\32xl\\:hover\\:via-red-500:hover{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .\\32xl\\:hover\\:via-red-700:hover{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .\\32xl\\:hover\\:via-gray-50:hover{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .\\32xl\\:hover\\:via-gray-100:hover{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .\\32xl\\:hover\\:via-gray-150:hover{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .\\32xl\\:hover\\:via-gray-200:hover{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\32xl\\:hover\\:via-gray-300:hover{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\32xl\\:hover\\:via-gray-400:hover{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\32xl\\:hover\\:via-gray-425:hover{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\32xl\\:hover\\:via-gray-450:hover{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .\\32xl\\:hover\\:via-gray-500:hover{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\32xl\\:hover\\:via-gray-600:hover{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\32xl\\:hover\\:via-gray-625:hover{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\32xl\\:hover\\:via-gray-700:hover{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .\\32xl\\:hover\\:via-gray-800:hover{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .\\32xl\\:hover\\:via-gray-200a50:hover{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\32xl\\:hover\\:via-blue-50:hover{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .\\32xl\\:hover\\:via-blue-100:hover{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .\\32xl\\:hover\\:via-blue-150:hover{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .\\32xl\\:hover\\:via-blue-200:hover{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .\\32xl\\:hover\\:via-blue-300:hover{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .\\32xl\\:hover\\:via-blue-400:hover{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\32xl\\:hover\\:via-blue-500:hover{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:hover\\:via-blue-600:hover{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .\\32xl\\:hover\\:via-blue-700:hover{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .\\32xl\\:hover\\:via-blue-750:hover{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:hover\\:via-blue-800:hover{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\32xl\\:hover\\:via-blue-900:hover{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .\\32xl\\:hover\\:via-blue-950:hover{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\32xl\\:hover\\:via-blue-500a25:hover{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:hover\\:via-blue-500a50:hover{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:hover\\:via-blue-700a75:hover{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .\\32xl\\:hover\\:via-blue-700a30:hover{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .\\32xl\\:hover\\:via-blue-750a25:hover{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:hover\\:via-blue-750a15:hover{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:hover\\:via-blue-800a60:hover{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\32xl\\:hover\\:via-programEditorTabColors-1:hover{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .\\32xl\\:hover\\:via-programEditorTabColors-2:hover{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .\\32xl\\:hover\\:via-programEditorTabColors-3:hover{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .\\32xl\\:hover\\:via-programEditorTabColors-4:hover{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .\\32xl\\:hover\\:via-programEditorTabColors-5:hover{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .\\32xl\\:hover\\:via-programEditorTabColors-6:hover{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .\\32xl\\:hover\\:via-programEditorTabColors-1h:hover{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .\\32xl\\:hover\\:via-programEditorTabColors-2h:hover{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .\\32xl\\:hover\\:via-programEditorTabColors-3h:hover{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .\\32xl\\:hover\\:via-programEditorTabColors-4h:hover{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .\\32xl\\:hover\\:via-programEditorTabColors-5h:hover{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .\\32xl\\:hover\\:via-programEditorTabColors-6h:hover{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .\\32xl\\:hover\\:via-programEditorPresetTabColors-1:hover{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\32xl\\:hover\\:via-programEditorPresetTabColors-1h:hover{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\32xl\\:hover\\:via-borgScaleColors-0:hover{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .\\32xl\\:hover\\:via-borgScaleColors-1:hover{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .\\32xl\\:hover\\:via-borgScaleColors-2:hover{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .\\32xl\\:hover\\:via-borgScaleColors-3:hover{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .\\32xl\\:hover\\:via-borgScaleColors-4:hover{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\32xl\\:hover\\:via-borgScaleColors-5:hover{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .\\32xl\\:hover\\:via-borgScaleColors-6:hover{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .\\32xl\\:hover\\:via-borgScaleColors-7:hover{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .\\32xl\\:hover\\:via-borgScaleColors-8:hover{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .\\32xl\\:hover\\:via-borgScaleColors-9:hover{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .\\32xl\\:hover\\:via-borgScaleColors-10:hover{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .\\32xl\\:hover\\:to-transparent:hover{
    --gradient-to-color: transparent;
  }

  .\\32xl\\:hover\\:to-focus:hover{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .\\32xl\\:hover\\:to-black:hover{
    --gradient-to-color: #000;
  }

  .\\32xl\\:hover\\:to-white:hover{
    --gradient-to-color: #fff;
  }

  .\\32xl\\:hover\\:to-primary:hover{
    --gradient-to-color: #37A4DC;
  }

  .\\32xl\\:hover\\:to-disabled:hover{
    --gradient-to-color: #BFBFBF;
  }

  .\\32xl\\:hover\\:to-translucent-60:hover{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .\\32xl\\:hover\\:to-translucent-90:hover{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .\\32xl\\:hover\\:to-green-200:hover{
    --gradient-to-color: #f4fcea;
  }

  .\\32xl\\:hover\\:to-green-400:hover{
    --gradient-to-color: #6CCA98;
  }

  .\\32xl\\:hover\\:to-green-500:hover{
    --gradient-to-color: #97E812;
  }

  .\\32xl\\:hover\\:to-green-600:hover{
    --gradient-to-color: #4f9112;
  }

  .\\32xl\\:hover\\:to-green-700:hover{
    --gradient-to-color: #3e7211;
  }

  .\\32xl\\:hover\\:to-green-400a50:hover{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .\\32xl\\:hover\\:to-green-500a25:hover{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .\\32xl\\:hover\\:to-yellow-200:hover{
    --gradient-to-color: #fff9eb;
  }

  .\\32xl\\:hover\\:to-yellow-300:hover{
    --gradient-to-color: #ffe9bd;
  }

  .\\32xl\\:hover\\:to-yellow-500:hover{
    --gradient-to-color: #FFC82C;
  }

  .\\32xl\\:hover\\:to-yellow-600:hover{
    --gradient-to-color: #F7931E;
  }

  .\\32xl\\:hover\\:to-yellow-700:hover{
    --gradient-to-color: #E1AD28;
  }

  .\\32xl\\:hover\\:to-yellow-300a66:hover{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .\\32xl\\:hover\\:to-yellow-500a25:hover{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .\\32xl\\:hover\\:to-orange-200:hover{
    --gradient-to-color: #fdf0ea;
  }

  .\\32xl\\:hover\\:to-orange-400:hover{
    --gradient-to-color: #f6c66f;
  }

  .\\32xl\\:hover\\:to-orange-500:hover{
    --gradient-to-color: #F07313;
  }

  .\\32xl\\:hover\\:to-orange-800:hover{
    --gradient-to-color: #db5d0c;
  }

  .\\32xl\\:hover\\:to-orange-900:hover{
    --gradient-to-color: #b86814;
  }

  .\\32xl\\:hover\\:to-orange-500a25:hover{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .\\32xl\\:hover\\:to-red-100:hover{
    --gradient-to-color: #FEF5F5;
  }

  .\\32xl\\:hover\\:to-red-150:hover{
    --gradient-to-color: #ffe9e8;
  }

  .\\32xl\\:hover\\:to-red-200:hover{
    --gradient-to-color: #F8CECC;
  }

  .\\32xl\\:hover\\:to-red-300:hover{
    --gradient-to-color: #ff8585;
  }

  .\\32xl\\:hover\\:to-red-400:hover{
    --gradient-to-color: #ff3535;
  }

  .\\32xl\\:hover\\:to-red-500:hover{
    --gradient-to-color: #DD4746;
  }

  .\\32xl\\:hover\\:to-red-700:hover{
    --gradient-to-color: #A23C24;
  }

  .\\32xl\\:hover\\:to-gray-50:hover{
    --gradient-to-color: #F9F9F9;
  }

  .\\32xl\\:hover\\:to-gray-100:hover{
    --gradient-to-color: #F1F1F2;
  }

  .\\32xl\\:hover\\:to-gray-150:hover{
    --gradient-to-color: #e6e6e6;
  }

  .\\32xl\\:hover\\:to-gray-200:hover{
    --gradient-to-color: #E0E2E4;
  }

  .\\32xl\\:hover\\:to-gray-300:hover{
    --gradient-to-color: #BFBFBF;
  }

  .\\32xl\\:hover\\:to-gray-400:hover{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .\\32xl\\:hover\\:to-gray-425:hover{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .\\32xl\\:hover\\:to-gray-450:hover{
    --gradient-to-color: #959595;
  }

  .\\32xl\\:hover\\:to-gray-500:hover{
    --gradient-to-color: #727272;
  }

  .\\32xl\\:hover\\:to-gray-600:hover{
    --gradient-to-color: #5a626b;
  }

  .\\32xl\\:hover\\:to-gray-625:hover{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .\\32xl\\:hover\\:to-gray-700:hover{
    --gradient-to-color: #464C59;
  }

  .\\32xl\\:hover\\:to-gray-800:hover{
    --gradient-to-color: #3c3b3b;
  }

  .\\32xl\\:hover\\:to-gray-200a50:hover{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .\\32xl\\:hover\\:to-blue-50:hover{
    --gradient-to-color: #f2fbff;
  }

  .\\32xl\\:hover\\:to-blue-100:hover{
    --gradient-to-color: #EBF6FC;
  }

  .\\32xl\\:hover\\:to-blue-150:hover{
    --gradient-to-color: #E8EEF1;
  }

  .\\32xl\\:hover\\:to-blue-200:hover{
    --gradient-to-color: #CCE6F5;
  }

  .\\32xl\\:hover\\:to-blue-300:hover{
    --gradient-to-color: #73BFE7;
  }

  .\\32xl\\:hover\\:to-blue-400:hover{
    --gradient-to-color: #4BA4F7;
  }

  .\\32xl\\:hover\\:to-blue-500:hover{
    --gradient-to-color: #37A4DC;
  }

  .\\32xl\\:hover\\:to-blue-600:hover{
    --gradient-to-color: #6AA2D6;
  }

  .\\32xl\\:hover\\:to-blue-700:hover{
    --gradient-to-color: #456E9A;
  }

  .\\32xl\\:hover\\:to-blue-750:hover{
    --gradient-to-color: #5682AA;
  }

  .\\32xl\\:hover\\:to-blue-800:hover{
    --gradient-to-color: #1F4566;
  }

  .\\32xl\\:hover\\:to-blue-900:hover{
    --gradient-to-color: #183453;
  }

  .\\32xl\\:hover\\:to-blue-950:hover{
    --gradient-to-color: #041527;
  }

  .\\32xl\\:hover\\:to-blue-500a25:hover{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .\\32xl\\:hover\\:to-blue-500a50:hover{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .\\32xl\\:hover\\:to-blue-700a75:hover{
    --gradient-to-color: #3B648D;
  }

  .\\32xl\\:hover\\:to-blue-700a30:hover{
    --gradient-to-color: #2A5176;
  }

  .\\32xl\\:hover\\:to-blue-750a25:hover{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .\\32xl\\:hover\\:to-blue-750a15:hover{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .\\32xl\\:hover\\:to-blue-800a60:hover{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .\\32xl\\:hover\\:to-programEditorTabColors-1:hover{
    --gradient-to-color: #3cacae;
  }

  .\\32xl\\:hover\\:to-programEditorTabColors-2:hover{
    --gradient-to-color: #8e346a;
  }

  .\\32xl\\:hover\\:to-programEditorTabColors-3:hover{
    --gradient-to-color: #ff72b7;
  }

  .\\32xl\\:hover\\:to-programEditorTabColors-4:hover{
    --gradient-to-color: #ce941c;
  }

  .\\32xl\\:hover\\:to-programEditorTabColors-5:hover{
    --gradient-to-color: #b973d9;
  }

  .\\32xl\\:hover\\:to-programEditorTabColors-6:hover{
    --gradient-to-color: #ff9082;
  }

  .\\32xl\\:hover\\:to-programEditorTabColors-1h:hover{
    --gradient-to-color: #d9f2f2;
  }

  .\\32xl\\:hover\\:to-programEditorTabColors-2h:hover{
    --gradient-to-color: #f1dae8;
  }

  .\\32xl\\:hover\\:to-programEditorTabColors-3h:hover{
    --gradient-to-color: #ffe6f2;
  }

  .\\32xl\\:hover\\:to-programEditorTabColors-4h:hover{
    --gradient-to-color: #f9ecd2;
  }

  .\\32xl\\:hover\\:to-programEditorTabColors-5h:hover{
    --gradient-to-color: #f5ebfa;
  }

  .\\32xl\\:hover\\:to-programEditorTabColors-6h:hover{
    --gradient-to-color: #ffe8e6;
  }

  .\\32xl\\:hover\\:to-programEditorPresetTabColors-1:hover{
    --gradient-to-color: #798fa3;
  }

  .\\32xl\\:hover\\:to-programEditorPresetTabColors-1h:hover{
    --gradient-to-color: #798fa3;
  }

  .\\32xl\\:hover\\:to-borgScaleColors-0:hover{
    --gradient-to-color: #c5d1ff;
  }

  .\\32xl\\:hover\\:to-borgScaleColors-1:hover{
    --gradient-to-color: #a0b5fc;
  }

  .\\32xl\\:hover\\:to-borgScaleColors-2:hover{
    --gradient-to-color: #7492ff;
  }

  .\\32xl\\:hover\\:to-borgScaleColors-3:hover{
    --gradient-to-color: #82bbf1;
  }

  .\\32xl\\:hover\\:to-borgScaleColors-4:hover{
    --gradient-to-color: #4ba4f7;
  }

  .\\32xl\\:hover\\:to-borgScaleColors-5:hover{
    --gradient-to-color: #9cdd57;
  }

  .\\32xl\\:hover\\:to-borgScaleColors-6:hover{
    --gradient-to-color: #68af00;
  }

  .\\32xl\\:hover\\:to-borgScaleColors-7:hover{
    --gradient-to-color: #f5e380;
  }

  .\\32xl\\:hover\\:to-borgScaleColors-8:hover{
    --gradient-to-color: #ffc246;
  }

  .\\32xl\\:hover\\:to-borgScaleColors-9:hover{
    --gradient-to-color: #ff782f;
  }

  .\\32xl\\:hover\\:to-borgScaleColors-10:hover{
    --gradient-to-color: #f25757;
  }

  .\\32xl\\:focus\\:from-transparent:focus{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\32xl\\:focus\\:from-focus:focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:focus\\:from-black:focus{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\32xl\\:focus\\:from-white:focus{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:focus\\:from-primary:focus{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:focus\\:from-disabled:focus{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\32xl\\:focus\\:from-translucent-60:focus{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:focus\\:from-translucent-90:focus{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:focus\\:from-green-200:focus{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .\\32xl\\:focus\\:from-green-400:focus{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\32xl\\:focus\\:from-green-500:focus{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\32xl\\:focus\\:from-green-600:focus{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .\\32xl\\:focus\\:from-green-700:focus{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .\\32xl\\:focus\\:from-green-400a50:focus{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\32xl\\:focus\\:from-green-500a25:focus{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\32xl\\:focus\\:from-yellow-200:focus{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .\\32xl\\:focus\\:from-yellow-300:focus{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\32xl\\:focus\\:from-yellow-500:focus{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\32xl\\:focus\\:from-yellow-600:focus{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .\\32xl\\:focus\\:from-yellow-700:focus{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .\\32xl\\:focus\\:from-yellow-300a66:focus{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\32xl\\:focus\\:from-yellow-500a25:focus{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\32xl\\:focus\\:from-orange-200:focus{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .\\32xl\\:focus\\:from-orange-400:focus{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .\\32xl\\:focus\\:from-orange-500:focus{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .\\32xl\\:focus\\:from-orange-800:focus{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .\\32xl\\:focus\\:from-orange-900:focus{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .\\32xl\\:focus\\:from-orange-500a25:focus{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .\\32xl\\:focus\\:from-red-100:focus{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .\\32xl\\:focus\\:from-red-150:focus{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .\\32xl\\:focus\\:from-red-200:focus{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .\\32xl\\:focus\\:from-red-300:focus{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .\\32xl\\:focus\\:from-red-400:focus{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .\\32xl\\:focus\\:from-red-500:focus{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .\\32xl\\:focus\\:from-red-700:focus{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .\\32xl\\:focus\\:from-gray-50:focus{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .\\32xl\\:focus\\:from-gray-100:focus{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .\\32xl\\:focus\\:from-gray-150:focus{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .\\32xl\\:focus\\:from-gray-200:focus{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\32xl\\:focus\\:from-gray-300:focus{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\32xl\\:focus\\:from-gray-400:focus{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\32xl\\:focus\\:from-gray-425:focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\32xl\\:focus\\:from-gray-450:focus{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .\\32xl\\:focus\\:from-gray-500:focus{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\32xl\\:focus\\:from-gray-600:focus{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\32xl\\:focus\\:from-gray-625:focus{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\32xl\\:focus\\:from-gray-700:focus{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .\\32xl\\:focus\\:from-gray-800:focus{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .\\32xl\\:focus\\:from-gray-200a50:focus{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\32xl\\:focus\\:from-blue-50:focus{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .\\32xl\\:focus\\:from-blue-100:focus{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .\\32xl\\:focus\\:from-blue-150:focus{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .\\32xl\\:focus\\:from-blue-200:focus{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .\\32xl\\:focus\\:from-blue-300:focus{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .\\32xl\\:focus\\:from-blue-400:focus{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\32xl\\:focus\\:from-blue-500:focus{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:focus\\:from-blue-600:focus{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .\\32xl\\:focus\\:from-blue-700:focus{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .\\32xl\\:focus\\:from-blue-750:focus{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:focus\\:from-blue-800:focus{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\32xl\\:focus\\:from-blue-900:focus{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .\\32xl\\:focus\\:from-blue-950:focus{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\32xl\\:focus\\:from-blue-500a25:focus{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:focus\\:from-blue-500a50:focus{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:focus\\:from-blue-700a75:focus{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .\\32xl\\:focus\\:from-blue-700a30:focus{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .\\32xl\\:focus\\:from-blue-750a25:focus{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:focus\\:from-blue-750a15:focus{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:focus\\:from-blue-800a60:focus{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\32xl\\:focus\\:from-programEditorTabColors-1:focus{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .\\32xl\\:focus\\:from-programEditorTabColors-2:focus{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .\\32xl\\:focus\\:from-programEditorTabColors-3:focus{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .\\32xl\\:focus\\:from-programEditorTabColors-4:focus{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .\\32xl\\:focus\\:from-programEditorTabColors-5:focus{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .\\32xl\\:focus\\:from-programEditorTabColors-6:focus{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .\\32xl\\:focus\\:from-programEditorTabColors-1h:focus{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .\\32xl\\:focus\\:from-programEditorTabColors-2h:focus{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .\\32xl\\:focus\\:from-programEditorTabColors-3h:focus{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .\\32xl\\:focus\\:from-programEditorTabColors-4h:focus{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .\\32xl\\:focus\\:from-programEditorTabColors-5h:focus{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .\\32xl\\:focus\\:from-programEditorTabColors-6h:focus{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .\\32xl\\:focus\\:from-programEditorPresetTabColors-1:focus{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\32xl\\:focus\\:from-programEditorPresetTabColors-1h:focus{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\32xl\\:focus\\:from-borgScaleColors-0:focus{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .\\32xl\\:focus\\:from-borgScaleColors-1:focus{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .\\32xl\\:focus\\:from-borgScaleColors-2:focus{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .\\32xl\\:focus\\:from-borgScaleColors-3:focus{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .\\32xl\\:focus\\:from-borgScaleColors-4:focus{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\32xl\\:focus\\:from-borgScaleColors-5:focus{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .\\32xl\\:focus\\:from-borgScaleColors-6:focus{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .\\32xl\\:focus\\:from-borgScaleColors-7:focus{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .\\32xl\\:focus\\:from-borgScaleColors-8:focus{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .\\32xl\\:focus\\:from-borgScaleColors-9:focus{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .\\32xl\\:focus\\:from-borgScaleColors-10:focus{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .\\32xl\\:focus\\:via-transparent:focus{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\32xl\\:focus\\:via-focus:focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:focus\\:via-black:focus{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\32xl\\:focus\\:via-white:focus{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:focus\\:via-primary:focus{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:focus\\:via-disabled:focus{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\32xl\\:focus\\:via-translucent-60:focus{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:focus\\:via-translucent-90:focus{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\32xl\\:focus\\:via-green-200:focus{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .\\32xl\\:focus\\:via-green-400:focus{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\32xl\\:focus\\:via-green-500:focus{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\32xl\\:focus\\:via-green-600:focus{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .\\32xl\\:focus\\:via-green-700:focus{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .\\32xl\\:focus\\:via-green-400a50:focus{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\32xl\\:focus\\:via-green-500a25:focus{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\32xl\\:focus\\:via-yellow-200:focus{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .\\32xl\\:focus\\:via-yellow-300:focus{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\32xl\\:focus\\:via-yellow-500:focus{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\32xl\\:focus\\:via-yellow-600:focus{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .\\32xl\\:focus\\:via-yellow-700:focus{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .\\32xl\\:focus\\:via-yellow-300a66:focus{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\32xl\\:focus\\:via-yellow-500a25:focus{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\32xl\\:focus\\:via-orange-200:focus{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .\\32xl\\:focus\\:via-orange-400:focus{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .\\32xl\\:focus\\:via-orange-500:focus{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .\\32xl\\:focus\\:via-orange-800:focus{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .\\32xl\\:focus\\:via-orange-900:focus{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .\\32xl\\:focus\\:via-orange-500a25:focus{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .\\32xl\\:focus\\:via-red-100:focus{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .\\32xl\\:focus\\:via-red-150:focus{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .\\32xl\\:focus\\:via-red-200:focus{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .\\32xl\\:focus\\:via-red-300:focus{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .\\32xl\\:focus\\:via-red-400:focus{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .\\32xl\\:focus\\:via-red-500:focus{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .\\32xl\\:focus\\:via-red-700:focus{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .\\32xl\\:focus\\:via-gray-50:focus{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .\\32xl\\:focus\\:via-gray-100:focus{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .\\32xl\\:focus\\:via-gray-150:focus{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .\\32xl\\:focus\\:via-gray-200:focus{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\32xl\\:focus\\:via-gray-300:focus{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\32xl\\:focus\\:via-gray-400:focus{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\32xl\\:focus\\:via-gray-425:focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\32xl\\:focus\\:via-gray-450:focus{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .\\32xl\\:focus\\:via-gray-500:focus{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\32xl\\:focus\\:via-gray-600:focus{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\32xl\\:focus\\:via-gray-625:focus{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\32xl\\:focus\\:via-gray-700:focus{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .\\32xl\\:focus\\:via-gray-800:focus{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .\\32xl\\:focus\\:via-gray-200a50:focus{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\32xl\\:focus\\:via-blue-50:focus{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .\\32xl\\:focus\\:via-blue-100:focus{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .\\32xl\\:focus\\:via-blue-150:focus{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .\\32xl\\:focus\\:via-blue-200:focus{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .\\32xl\\:focus\\:via-blue-300:focus{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .\\32xl\\:focus\\:via-blue-400:focus{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\32xl\\:focus\\:via-blue-500:focus{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:focus\\:via-blue-600:focus{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .\\32xl\\:focus\\:via-blue-700:focus{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .\\32xl\\:focus\\:via-blue-750:focus{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:focus\\:via-blue-800:focus{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\32xl\\:focus\\:via-blue-900:focus{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .\\32xl\\:focus\\:via-blue-950:focus{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\32xl\\:focus\\:via-blue-500a25:focus{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:focus\\:via-blue-500a50:focus{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\32xl\\:focus\\:via-blue-700a75:focus{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .\\32xl\\:focus\\:via-blue-700a30:focus{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .\\32xl\\:focus\\:via-blue-750a25:focus{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:focus\\:via-blue-750a15:focus{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\32xl\\:focus\\:via-blue-800a60:focus{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\32xl\\:focus\\:via-programEditorTabColors-1:focus{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .\\32xl\\:focus\\:via-programEditorTabColors-2:focus{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .\\32xl\\:focus\\:via-programEditorTabColors-3:focus{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .\\32xl\\:focus\\:via-programEditorTabColors-4:focus{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .\\32xl\\:focus\\:via-programEditorTabColors-5:focus{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .\\32xl\\:focus\\:via-programEditorTabColors-6:focus{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .\\32xl\\:focus\\:via-programEditorTabColors-1h:focus{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .\\32xl\\:focus\\:via-programEditorTabColors-2h:focus{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .\\32xl\\:focus\\:via-programEditorTabColors-3h:focus{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .\\32xl\\:focus\\:via-programEditorTabColors-4h:focus{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .\\32xl\\:focus\\:via-programEditorTabColors-5h:focus{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .\\32xl\\:focus\\:via-programEditorTabColors-6h:focus{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .\\32xl\\:focus\\:via-programEditorPresetTabColors-1:focus{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\32xl\\:focus\\:via-programEditorPresetTabColors-1h:focus{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\32xl\\:focus\\:via-borgScaleColors-0:focus{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .\\32xl\\:focus\\:via-borgScaleColors-1:focus{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .\\32xl\\:focus\\:via-borgScaleColors-2:focus{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .\\32xl\\:focus\\:via-borgScaleColors-3:focus{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .\\32xl\\:focus\\:via-borgScaleColors-4:focus{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\32xl\\:focus\\:via-borgScaleColors-5:focus{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .\\32xl\\:focus\\:via-borgScaleColors-6:focus{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .\\32xl\\:focus\\:via-borgScaleColors-7:focus{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .\\32xl\\:focus\\:via-borgScaleColors-8:focus{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .\\32xl\\:focus\\:via-borgScaleColors-9:focus{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .\\32xl\\:focus\\:via-borgScaleColors-10:focus{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .\\32xl\\:focus\\:to-transparent:focus{
    --gradient-to-color: transparent;
  }

  .\\32xl\\:focus\\:to-focus:focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .\\32xl\\:focus\\:to-black:focus{
    --gradient-to-color: #000;
  }

  .\\32xl\\:focus\\:to-white:focus{
    --gradient-to-color: #fff;
  }

  .\\32xl\\:focus\\:to-primary:focus{
    --gradient-to-color: #37A4DC;
  }

  .\\32xl\\:focus\\:to-disabled:focus{
    --gradient-to-color: #BFBFBF;
  }

  .\\32xl\\:focus\\:to-translucent-60:focus{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .\\32xl\\:focus\\:to-translucent-90:focus{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .\\32xl\\:focus\\:to-green-200:focus{
    --gradient-to-color: #f4fcea;
  }

  .\\32xl\\:focus\\:to-green-400:focus{
    --gradient-to-color: #6CCA98;
  }

  .\\32xl\\:focus\\:to-green-500:focus{
    --gradient-to-color: #97E812;
  }

  .\\32xl\\:focus\\:to-green-600:focus{
    --gradient-to-color: #4f9112;
  }

  .\\32xl\\:focus\\:to-green-700:focus{
    --gradient-to-color: #3e7211;
  }

  .\\32xl\\:focus\\:to-green-400a50:focus{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .\\32xl\\:focus\\:to-green-500a25:focus{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .\\32xl\\:focus\\:to-yellow-200:focus{
    --gradient-to-color: #fff9eb;
  }

  .\\32xl\\:focus\\:to-yellow-300:focus{
    --gradient-to-color: #ffe9bd;
  }

  .\\32xl\\:focus\\:to-yellow-500:focus{
    --gradient-to-color: #FFC82C;
  }

  .\\32xl\\:focus\\:to-yellow-600:focus{
    --gradient-to-color: #F7931E;
  }

  .\\32xl\\:focus\\:to-yellow-700:focus{
    --gradient-to-color: #E1AD28;
  }

  .\\32xl\\:focus\\:to-yellow-300a66:focus{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .\\32xl\\:focus\\:to-yellow-500a25:focus{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .\\32xl\\:focus\\:to-orange-200:focus{
    --gradient-to-color: #fdf0ea;
  }

  .\\32xl\\:focus\\:to-orange-400:focus{
    --gradient-to-color: #f6c66f;
  }

  .\\32xl\\:focus\\:to-orange-500:focus{
    --gradient-to-color: #F07313;
  }

  .\\32xl\\:focus\\:to-orange-800:focus{
    --gradient-to-color: #db5d0c;
  }

  .\\32xl\\:focus\\:to-orange-900:focus{
    --gradient-to-color: #b86814;
  }

  .\\32xl\\:focus\\:to-orange-500a25:focus{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .\\32xl\\:focus\\:to-red-100:focus{
    --gradient-to-color: #FEF5F5;
  }

  .\\32xl\\:focus\\:to-red-150:focus{
    --gradient-to-color: #ffe9e8;
  }

  .\\32xl\\:focus\\:to-red-200:focus{
    --gradient-to-color: #F8CECC;
  }

  .\\32xl\\:focus\\:to-red-300:focus{
    --gradient-to-color: #ff8585;
  }

  .\\32xl\\:focus\\:to-red-400:focus{
    --gradient-to-color: #ff3535;
  }

  .\\32xl\\:focus\\:to-red-500:focus{
    --gradient-to-color: #DD4746;
  }

  .\\32xl\\:focus\\:to-red-700:focus{
    --gradient-to-color: #A23C24;
  }

  .\\32xl\\:focus\\:to-gray-50:focus{
    --gradient-to-color: #F9F9F9;
  }

  .\\32xl\\:focus\\:to-gray-100:focus{
    --gradient-to-color: #F1F1F2;
  }

  .\\32xl\\:focus\\:to-gray-150:focus{
    --gradient-to-color: #e6e6e6;
  }

  .\\32xl\\:focus\\:to-gray-200:focus{
    --gradient-to-color: #E0E2E4;
  }

  .\\32xl\\:focus\\:to-gray-300:focus{
    --gradient-to-color: #BFBFBF;
  }

  .\\32xl\\:focus\\:to-gray-400:focus{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .\\32xl\\:focus\\:to-gray-425:focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .\\32xl\\:focus\\:to-gray-450:focus{
    --gradient-to-color: #959595;
  }

  .\\32xl\\:focus\\:to-gray-500:focus{
    --gradient-to-color: #727272;
  }

  .\\32xl\\:focus\\:to-gray-600:focus{
    --gradient-to-color: #5a626b;
  }

  .\\32xl\\:focus\\:to-gray-625:focus{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .\\32xl\\:focus\\:to-gray-700:focus{
    --gradient-to-color: #464C59;
  }

  .\\32xl\\:focus\\:to-gray-800:focus{
    --gradient-to-color: #3c3b3b;
  }

  .\\32xl\\:focus\\:to-gray-200a50:focus{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .\\32xl\\:focus\\:to-blue-50:focus{
    --gradient-to-color: #f2fbff;
  }

  .\\32xl\\:focus\\:to-blue-100:focus{
    --gradient-to-color: #EBF6FC;
  }

  .\\32xl\\:focus\\:to-blue-150:focus{
    --gradient-to-color: #E8EEF1;
  }

  .\\32xl\\:focus\\:to-blue-200:focus{
    --gradient-to-color: #CCE6F5;
  }

  .\\32xl\\:focus\\:to-blue-300:focus{
    --gradient-to-color: #73BFE7;
  }

  .\\32xl\\:focus\\:to-blue-400:focus{
    --gradient-to-color: #4BA4F7;
  }

  .\\32xl\\:focus\\:to-blue-500:focus{
    --gradient-to-color: #37A4DC;
  }

  .\\32xl\\:focus\\:to-blue-600:focus{
    --gradient-to-color: #6AA2D6;
  }

  .\\32xl\\:focus\\:to-blue-700:focus{
    --gradient-to-color: #456E9A;
  }

  .\\32xl\\:focus\\:to-blue-750:focus{
    --gradient-to-color: #5682AA;
  }

  .\\32xl\\:focus\\:to-blue-800:focus{
    --gradient-to-color: #1F4566;
  }

  .\\32xl\\:focus\\:to-blue-900:focus{
    --gradient-to-color: #183453;
  }

  .\\32xl\\:focus\\:to-blue-950:focus{
    --gradient-to-color: #041527;
  }

  .\\32xl\\:focus\\:to-blue-500a25:focus{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .\\32xl\\:focus\\:to-blue-500a50:focus{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .\\32xl\\:focus\\:to-blue-700a75:focus{
    --gradient-to-color: #3B648D;
  }

  .\\32xl\\:focus\\:to-blue-700a30:focus{
    --gradient-to-color: #2A5176;
  }

  .\\32xl\\:focus\\:to-blue-750a25:focus{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .\\32xl\\:focus\\:to-blue-750a15:focus{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .\\32xl\\:focus\\:to-blue-800a60:focus{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .\\32xl\\:focus\\:to-programEditorTabColors-1:focus{
    --gradient-to-color: #3cacae;
  }

  .\\32xl\\:focus\\:to-programEditorTabColors-2:focus{
    --gradient-to-color: #8e346a;
  }

  .\\32xl\\:focus\\:to-programEditorTabColors-3:focus{
    --gradient-to-color: #ff72b7;
  }

  .\\32xl\\:focus\\:to-programEditorTabColors-4:focus{
    --gradient-to-color: #ce941c;
  }

  .\\32xl\\:focus\\:to-programEditorTabColors-5:focus{
    --gradient-to-color: #b973d9;
  }

  .\\32xl\\:focus\\:to-programEditorTabColors-6:focus{
    --gradient-to-color: #ff9082;
  }

  .\\32xl\\:focus\\:to-programEditorTabColors-1h:focus{
    --gradient-to-color: #d9f2f2;
  }

  .\\32xl\\:focus\\:to-programEditorTabColors-2h:focus{
    --gradient-to-color: #f1dae8;
  }

  .\\32xl\\:focus\\:to-programEditorTabColors-3h:focus{
    --gradient-to-color: #ffe6f2;
  }

  .\\32xl\\:focus\\:to-programEditorTabColors-4h:focus{
    --gradient-to-color: #f9ecd2;
  }

  .\\32xl\\:focus\\:to-programEditorTabColors-5h:focus{
    --gradient-to-color: #f5ebfa;
  }

  .\\32xl\\:focus\\:to-programEditorTabColors-6h:focus{
    --gradient-to-color: #ffe8e6;
  }

  .\\32xl\\:focus\\:to-programEditorPresetTabColors-1:focus{
    --gradient-to-color: #798fa3;
  }

  .\\32xl\\:focus\\:to-programEditorPresetTabColors-1h:focus{
    --gradient-to-color: #798fa3;
  }

  .\\32xl\\:focus\\:to-borgScaleColors-0:focus{
    --gradient-to-color: #c5d1ff;
  }

  .\\32xl\\:focus\\:to-borgScaleColors-1:focus{
    --gradient-to-color: #a0b5fc;
  }

  .\\32xl\\:focus\\:to-borgScaleColors-2:focus{
    --gradient-to-color: #7492ff;
  }

  .\\32xl\\:focus\\:to-borgScaleColors-3:focus{
    --gradient-to-color: #82bbf1;
  }

  .\\32xl\\:focus\\:to-borgScaleColors-4:focus{
    --gradient-to-color: #4ba4f7;
  }

  .\\32xl\\:focus\\:to-borgScaleColors-5:focus{
    --gradient-to-color: #9cdd57;
  }

  .\\32xl\\:focus\\:to-borgScaleColors-6:focus{
    --gradient-to-color: #68af00;
  }

  .\\32xl\\:focus\\:to-borgScaleColors-7:focus{
    --gradient-to-color: #f5e380;
  }

  .\\32xl\\:focus\\:to-borgScaleColors-8:focus{
    --gradient-to-color: #ffc246;
  }

  .\\32xl\\:focus\\:to-borgScaleColors-9:focus{
    --gradient-to-color: #ff782f;
  }

  .\\32xl\\:focus\\:to-borgScaleColors-10:focus{
    --gradient-to-color: #f25757;
  }

  .\\32xl\\:bg-opacity-0{
    --bg-opacity: 0;
  }

  .\\32xl\\:bg-opacity-25{
    --bg-opacity: .25;
  }

  .\\32xl\\:bg-opacity-50{
    --bg-opacity: .5;
  }

  .\\32xl\\:bg-opacity-75{
    --bg-opacity: .75;
  }

  .\\32xl\\:bg-opacity-100{
    --bg-opacity: 1;
  }

  .\\32xl\\:hover\\:bg-opacity-0:hover{
    --bg-opacity: 0;
  }

  .\\32xl\\:hover\\:bg-opacity-25:hover{
    --bg-opacity: .25;
  }

  .\\32xl\\:hover\\:bg-opacity-50:hover{
    --bg-opacity: .5;
  }

  .\\32xl\\:hover\\:bg-opacity-75:hover{
    --bg-opacity: .75;
  }

  .\\32xl\\:hover\\:bg-opacity-100:hover{
    --bg-opacity: 1;
  }

  .\\32xl\\:focus\\:bg-opacity-0:focus{
    --bg-opacity: 0;
  }

  .\\32xl\\:focus\\:bg-opacity-25:focus{
    --bg-opacity: .25;
  }

  .\\32xl\\:focus\\:bg-opacity-50:focus{
    --bg-opacity: .5;
  }

  .\\32xl\\:focus\\:bg-opacity-75:focus{
    --bg-opacity: .75;
  }

  .\\32xl\\:focus\\:bg-opacity-100:focus{
    --bg-opacity: 1;
  }

  .\\32xl\\:bg-bottom{
    background-position: bottom;
  }

  .\\32xl\\:bg-center{
    background-position: center;
  }

  .\\32xl\\:bg-left{
    background-position: left;
  }

  .\\32xl\\:bg-left-bottom{
    background-position: left bottom;
  }

  .\\32xl\\:bg-left-top{
    background-position: left top;
  }

  .\\32xl\\:bg-right{
    background-position: right;
  }

  .\\32xl\\:bg-right-bottom{
    background-position: right bottom;
  }

  .\\32xl\\:bg-right-top{
    background-position: right top;
  }

  .\\32xl\\:bg-top{
    background-position: top;
  }

  .\\32xl\\:bg-repeat{
    background-repeat: repeat;
  }

  .\\32xl\\:bg-no-repeat{
    background-repeat: no-repeat;
  }

  .\\32xl\\:bg-repeat-x{
    background-repeat: repeat-x;
  }

  .\\32xl\\:bg-repeat-y{
    background-repeat: repeat-y;
  }

  .\\32xl\\:bg-repeat-round{
    background-repeat: round;
  }

  .\\32xl\\:bg-repeat-space{
    background-repeat: space;
  }

  .\\32xl\\:bg-auto{
    background-size: auto;
  }

  .\\32xl\\:bg-cover{
    background-size: cover;
  }

  .\\32xl\\:bg-contain{
    background-size: contain;
  }

  .\\32xl\\:border-transparent{
    border-color: transparent;
  }

  .\\32xl\\:border-focus{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .\\32xl\\:border-black{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .\\32xl\\:border-white{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .\\32xl\\:border-primary{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .\\32xl\\:border-disabled{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .\\32xl\\:border-translucent-60{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .\\32xl\\:border-translucent-90{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .\\32xl\\:border-green-200{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .\\32xl\\:border-green-400{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .\\32xl\\:border-green-500{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .\\32xl\\:border-green-600{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .\\32xl\\:border-green-700{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .\\32xl\\:border-green-400a50{
    border-color: rgba(108,202,152,0.50196);
  }

  .\\32xl\\:border-green-500a25{
    border-color: rgba(151,232,18,0.09804);
  }

  .\\32xl\\:border-yellow-200{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .\\32xl\\:border-yellow-300{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .\\32xl\\:border-yellow-500{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .\\32xl\\:border-yellow-600{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .\\32xl\\:border-yellow-700{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .\\32xl\\:border-yellow-300a66{
    border-color: rgba(255,233,189,0.66667);
  }

  .\\32xl\\:border-yellow-500a25{
    border-color: rgba(255,200,44,0.09804);
  }

  .\\32xl\\:border-orange-200{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .\\32xl\\:border-orange-400{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .\\32xl\\:border-orange-500{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .\\32xl\\:border-orange-800{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .\\32xl\\:border-orange-900{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .\\32xl\\:border-orange-500a25{
    border-color: rgba(240,115,23,0.09804);
  }

  .\\32xl\\:border-red-100{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .\\32xl\\:border-red-150{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .\\32xl\\:border-red-200{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .\\32xl\\:border-red-300{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .\\32xl\\:border-red-400{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .\\32xl\\:border-red-500{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .\\32xl\\:border-red-700{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .\\32xl\\:border-gray-50{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .\\32xl\\:border-gray-100{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .\\32xl\\:border-gray-150{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .\\32xl\\:border-gray-200{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .\\32xl\\:border-gray-300{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .\\32xl\\:border-gray-400{
    border-color: rgba(114,114,114,0.8);
  }

  .\\32xl\\:border-gray-425{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .\\32xl\\:border-gray-450{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .\\32xl\\:border-gray-500{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .\\32xl\\:border-gray-600{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .\\32xl\\:border-gray-625{
    border-color: rgba(90,98,107,0.8);
  }

  .\\32xl\\:border-gray-700{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .\\32xl\\:border-gray-800{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .\\32xl\\:border-gray-200a50{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .\\32xl\\:border-blue-50{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .\\32xl\\:border-blue-100{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .\\32xl\\:border-blue-150{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .\\32xl\\:border-blue-200{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .\\32xl\\:border-blue-300{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .\\32xl\\:border-blue-400{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .\\32xl\\:border-blue-500{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .\\32xl\\:border-blue-600{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .\\32xl\\:border-blue-700{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .\\32xl\\:border-blue-750{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .\\32xl\\:border-blue-800{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .\\32xl\\:border-blue-900{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .\\32xl\\:border-blue-950{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .\\32xl\\:border-blue-500a25{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .\\32xl\\:border-blue-500a50{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .\\32xl\\:border-blue-700a75{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .\\32xl\\:border-blue-700a30{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .\\32xl\\:border-blue-750a25{
    border-color: rgba(86,130,170,0.09804);
  }

  .\\32xl\\:border-blue-750a15{
    border-color: rgba(86,130,170,0.05882);
  }

  .\\32xl\\:border-blue-800a60{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .\\32xl\\:border-programEditorTabColors-1{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .\\32xl\\:border-programEditorTabColors-2{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .\\32xl\\:border-programEditorTabColors-3{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .\\32xl\\:border-programEditorTabColors-4{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .\\32xl\\:border-programEditorTabColors-5{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .\\32xl\\:border-programEditorTabColors-6{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .\\32xl\\:border-programEditorTabColors-1h{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .\\32xl\\:border-programEditorTabColors-2h{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .\\32xl\\:border-programEditorTabColors-3h{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .\\32xl\\:border-programEditorTabColors-4h{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .\\32xl\\:border-programEditorTabColors-5h{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .\\32xl\\:border-programEditorTabColors-6h{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .\\32xl\\:border-programEditorPresetTabColors-1{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .\\32xl\\:border-programEditorPresetTabColors-1h{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .\\32xl\\:border-borgScaleColors-0{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .\\32xl\\:border-borgScaleColors-1{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .\\32xl\\:border-borgScaleColors-2{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .\\32xl\\:border-borgScaleColors-3{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .\\32xl\\:border-borgScaleColors-4{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .\\32xl\\:border-borgScaleColors-5{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .\\32xl\\:border-borgScaleColors-6{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .\\32xl\\:border-borgScaleColors-7{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .\\32xl\\:border-borgScaleColors-8{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .\\32xl\\:border-borgScaleColors-9{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .\\32xl\\:border-borgScaleColors-10{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-transparent:hover{
    border-color: transparent;
  }

  .\\32xl\\:hover\\:border-focus:hover{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .\\32xl\\:hover\\:border-black:hover{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-white:hover{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-primary:hover{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-disabled:hover{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-translucent-60:hover{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .\\32xl\\:hover\\:border-translucent-90:hover{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .\\32xl\\:hover\\:border-green-200:hover{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-green-400:hover{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-green-500:hover{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-green-600:hover{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-green-700:hover{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-green-400a50:hover{
    border-color: rgba(108,202,152,0.50196);
  }

  .\\32xl\\:hover\\:border-green-500a25:hover{
    border-color: rgba(151,232,18,0.09804);
  }

  .\\32xl\\:hover\\:border-yellow-200:hover{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-yellow-300:hover{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-yellow-500:hover{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-yellow-600:hover{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-yellow-700:hover{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-yellow-300a66:hover{
    border-color: rgba(255,233,189,0.66667);
  }

  .\\32xl\\:hover\\:border-yellow-500a25:hover{
    border-color: rgba(255,200,44,0.09804);
  }

  .\\32xl\\:hover\\:border-orange-200:hover{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-orange-400:hover{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-orange-500:hover{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-orange-800:hover{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-orange-900:hover{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-orange-500a25:hover{
    border-color: rgba(240,115,23,0.09804);
  }

  .\\32xl\\:hover\\:border-red-100:hover{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-red-150:hover{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-red-200:hover{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-red-300:hover{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-red-400:hover{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-red-500:hover{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-red-700:hover{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-gray-50:hover{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-gray-100:hover{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-gray-150:hover{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-gray-200:hover{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-gray-300:hover{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-gray-400:hover{
    border-color: rgba(114,114,114,0.8);
  }

  .\\32xl\\:hover\\:border-gray-425:hover{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .\\32xl\\:hover\\:border-gray-450:hover{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-gray-500:hover{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-gray-600:hover{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-gray-625:hover{
    border-color: rgba(90,98,107,0.8);
  }

  .\\32xl\\:hover\\:border-gray-700:hover{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-gray-800:hover{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-gray-200a50:hover{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .\\32xl\\:hover\\:border-blue-50:hover{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-blue-100:hover{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-blue-150:hover{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-blue-200:hover{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-blue-300:hover{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-blue-400:hover{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-blue-500:hover{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-blue-600:hover{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-blue-700:hover{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-blue-750:hover{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-blue-800:hover{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-blue-900:hover{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-blue-950:hover{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-blue-500a25:hover{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .\\32xl\\:hover\\:border-blue-500a50:hover{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .\\32xl\\:hover\\:border-blue-700a75:hover{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-blue-700a30:hover{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-blue-750a25:hover{
    border-color: rgba(86,130,170,0.09804);
  }

  .\\32xl\\:hover\\:border-blue-750a15:hover{
    border-color: rgba(86,130,170,0.05882);
  }

  .\\32xl\\:hover\\:border-blue-800a60:hover{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .\\32xl\\:hover\\:border-programEditorTabColors-1:hover{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-programEditorTabColors-2:hover{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-programEditorTabColors-3:hover{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-programEditorTabColors-4:hover{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-programEditorTabColors-5:hover{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-programEditorTabColors-6:hover{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-programEditorTabColors-1h:hover{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-programEditorTabColors-2h:hover{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-programEditorTabColors-3h:hover{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-programEditorTabColors-4h:hover{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-programEditorTabColors-5h:hover{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-programEditorTabColors-6h:hover{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-programEditorPresetTabColors-1:hover{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-programEditorPresetTabColors-1h:hover{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-borgScaleColors-0:hover{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-borgScaleColors-1:hover{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-borgScaleColors-2:hover{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-borgScaleColors-3:hover{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-borgScaleColors-4:hover{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-borgScaleColors-5:hover{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-borgScaleColors-6:hover{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-borgScaleColors-7:hover{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-borgScaleColors-8:hover{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-borgScaleColors-9:hover{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .\\32xl\\:hover\\:border-borgScaleColors-10:hover{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-transparent:focus{
    border-color: transparent;
  }

  .\\32xl\\:focus\\:border-focus:focus{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .\\32xl\\:focus\\:border-black:focus{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-white:focus{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-primary:focus{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-disabled:focus{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-translucent-60:focus{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .\\32xl\\:focus\\:border-translucent-90:focus{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .\\32xl\\:focus\\:border-green-200:focus{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-green-400:focus{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-green-500:focus{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-green-600:focus{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-green-700:focus{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-green-400a50:focus{
    border-color: rgba(108,202,152,0.50196);
  }

  .\\32xl\\:focus\\:border-green-500a25:focus{
    border-color: rgba(151,232,18,0.09804);
  }

  .\\32xl\\:focus\\:border-yellow-200:focus{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-yellow-300:focus{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-yellow-500:focus{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-yellow-600:focus{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-yellow-700:focus{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-yellow-300a66:focus{
    border-color: rgba(255,233,189,0.66667);
  }

  .\\32xl\\:focus\\:border-yellow-500a25:focus{
    border-color: rgba(255,200,44,0.09804);
  }

  .\\32xl\\:focus\\:border-orange-200:focus{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-orange-400:focus{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-orange-500:focus{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-orange-800:focus{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-orange-900:focus{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-orange-500a25:focus{
    border-color: rgba(240,115,23,0.09804);
  }

  .\\32xl\\:focus\\:border-red-100:focus{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-red-150:focus{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-red-200:focus{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-red-300:focus{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-red-400:focus{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-red-500:focus{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-red-700:focus{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-gray-50:focus{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-gray-100:focus{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-gray-150:focus{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-gray-200:focus{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-gray-300:focus{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-gray-400:focus{
    border-color: rgba(114,114,114,0.8);
  }

  .\\32xl\\:focus\\:border-gray-425:focus{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .\\32xl\\:focus\\:border-gray-450:focus{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-gray-500:focus{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-gray-600:focus{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-gray-625:focus{
    border-color: rgba(90,98,107,0.8);
  }

  .\\32xl\\:focus\\:border-gray-700:focus{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-gray-800:focus{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-gray-200a50:focus{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .\\32xl\\:focus\\:border-blue-50:focus{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-blue-100:focus{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-blue-150:focus{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-blue-200:focus{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-blue-300:focus{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-blue-400:focus{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-blue-500:focus{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-blue-600:focus{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-blue-700:focus{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-blue-750:focus{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-blue-800:focus{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-blue-900:focus{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-blue-950:focus{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-blue-500a25:focus{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .\\32xl\\:focus\\:border-blue-500a50:focus{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .\\32xl\\:focus\\:border-blue-700a75:focus{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-blue-700a30:focus{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-blue-750a25:focus{
    border-color: rgba(86,130,170,0.09804);
  }

  .\\32xl\\:focus\\:border-blue-750a15:focus{
    border-color: rgba(86,130,170,0.05882);
  }

  .\\32xl\\:focus\\:border-blue-800a60:focus{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .\\32xl\\:focus\\:border-programEditorTabColors-1:focus{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-programEditorTabColors-2:focus{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-programEditorTabColors-3:focus{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-programEditorTabColors-4:focus{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-programEditorTabColors-5:focus{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-programEditorTabColors-6:focus{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-programEditorTabColors-1h:focus{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-programEditorTabColors-2h:focus{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-programEditorTabColors-3h:focus{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-programEditorTabColors-4h:focus{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-programEditorTabColors-5h:focus{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-programEditorTabColors-6h:focus{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-programEditorPresetTabColors-1:focus{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-programEditorPresetTabColors-1h:focus{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-borgScaleColors-0:focus{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-borgScaleColors-1:focus{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-borgScaleColors-2:focus{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-borgScaleColors-3:focus{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-borgScaleColors-4:focus{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-borgScaleColors-5:focus{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-borgScaleColors-6:focus{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-borgScaleColors-7:focus{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-borgScaleColors-8:focus{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-borgScaleColors-9:focus{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .\\32xl\\:focus\\:border-borgScaleColors-10:focus{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .\\32xl\\:border-opacity-0{
    --border-opacity: 0;
  }

  .\\32xl\\:border-opacity-25{
    --border-opacity: .25;
  }

  .\\32xl\\:border-opacity-50{
    --border-opacity: .5;
  }

  .\\32xl\\:border-opacity-75{
    --border-opacity: .75;
  }

  .\\32xl\\:border-opacity-100{
    --border-opacity: 1;
  }

  .\\32xl\\:hover\\:border-opacity-0:hover{
    --border-opacity: 0;
  }

  .\\32xl\\:hover\\:border-opacity-25:hover{
    --border-opacity: .25;
  }

  .\\32xl\\:hover\\:border-opacity-50:hover{
    --border-opacity: .5;
  }

  .\\32xl\\:hover\\:border-opacity-75:hover{
    --border-opacity: .75;
  }

  .\\32xl\\:hover\\:border-opacity-100:hover{
    --border-opacity: 1;
  }

  .\\32xl\\:focus\\:border-opacity-0:focus{
    --border-opacity: 0;
  }

  .\\32xl\\:focus\\:border-opacity-25:focus{
    --border-opacity: .25;
  }

  .\\32xl\\:focus\\:border-opacity-50:focus{
    --border-opacity: .5;
  }

  .\\32xl\\:focus\\:border-opacity-75:focus{
    --border-opacity: .75;
  }

  .\\32xl\\:focus\\:border-opacity-100:focus{
    --border-opacity: 1;
  }

  .\\32xl\\:rounded-none{
    border-radius: 0;
  }

  .\\32xl\\:rounded-sm{
    border-radius: .25rem;
  }

  .\\32xl\\:rounded{
    border-radius: .375rem;
  }

  .\\32xl\\:rounded-lg{
    border-radius: .5rem;
  }

  .\\32xl\\:rounded-xl{
    border-radius: .75rem;
  }

  .\\32xl\\:rounded-full{
    border-radius: 9999px;
  }

  .\\32xl\\:rounded-t-none{
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .\\32xl\\:rounded-r-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .\\32xl\\:rounded-b-none{
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .\\32xl\\:rounded-l-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .\\32xl\\:rounded-t-sm{
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
  }

  .\\32xl\\:rounded-r-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  .\\32xl\\:rounded-b-sm{
    border-bottom-right-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  .\\32xl\\:rounded-l-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  .\\32xl\\:rounded-t{
    border-top-left-radius: .375rem;
    border-top-right-radius: .375rem;
  }

  .\\32xl\\:rounded-r{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  .\\32xl\\:rounded-b{
    border-bottom-right-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  .\\32xl\\:rounded-l{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  .\\32xl\\:rounded-t-lg{
    border-top-left-radius: .5rem;
    border-top-right-radius: .5rem;
  }

  .\\32xl\\:rounded-r-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  .\\32xl\\:rounded-b-lg{
    border-bottom-right-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  .\\32xl\\:rounded-l-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  .\\32xl\\:rounded-t-xl{
    border-top-left-radius: .75rem;
    border-top-right-radius: .75rem;
  }

  .\\32xl\\:rounded-r-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  .\\32xl\\:rounded-b-xl{
    border-bottom-right-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  .\\32xl\\:rounded-l-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  .\\32xl\\:rounded-t-full{
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }

  .\\32xl\\:rounded-r-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  .\\32xl\\:rounded-b-full{
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .\\32xl\\:rounded-l-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .\\32xl\\:rounded-tl-none{
    border-top-left-radius: 0;
  }

  .\\32xl\\:rounded-tr-none{
    border-top-right-radius: 0;
  }

  .\\32xl\\:rounded-br-none{
    border-bottom-right-radius: 0;
  }

  .\\32xl\\:rounded-bl-none{
    border-bottom-left-radius: 0;
  }

  .\\32xl\\:rounded-tl-sm{
    border-top-left-radius: .25rem;
  }

  .\\32xl\\:rounded-tr-sm{
    border-top-right-radius: .25rem;
  }

  .\\32xl\\:rounded-br-sm{
    border-bottom-right-radius: .25rem;
  }

  .\\32xl\\:rounded-bl-sm{
    border-bottom-left-radius: .25rem;
  }

  .\\32xl\\:rounded-tl{
    border-top-left-radius: .375rem;
  }

  .\\32xl\\:rounded-tr{
    border-top-right-radius: .375rem;
  }

  .\\32xl\\:rounded-br{
    border-bottom-right-radius: .375rem;
  }

  .\\32xl\\:rounded-bl{
    border-bottom-left-radius: .375rem;
  }

  .\\32xl\\:rounded-tl-lg{
    border-top-left-radius: .5rem;
  }

  .\\32xl\\:rounded-tr-lg{
    border-top-right-radius: .5rem;
  }

  .\\32xl\\:rounded-br-lg{
    border-bottom-right-radius: .5rem;
  }

  .\\32xl\\:rounded-bl-lg{
    border-bottom-left-radius: .5rem;
  }

  .\\32xl\\:rounded-tl-xl{
    border-top-left-radius: .75rem;
  }

  .\\32xl\\:rounded-tr-xl{
    border-top-right-radius: .75rem;
  }

  .\\32xl\\:rounded-br-xl{
    border-bottom-right-radius: .75rem;
  }

  .\\32xl\\:rounded-bl-xl{
    border-bottom-left-radius: .75rem;
  }

  .\\32xl\\:rounded-tl-full{
    border-top-left-radius: 9999px;
  }

  .\\32xl\\:rounded-tr-full{
    border-top-right-radius: 9999px;
  }

  .\\32xl\\:rounded-br-full{
    border-bottom-right-radius: 9999px;
  }

  .\\32xl\\:rounded-bl-full{
    border-bottom-left-radius: 9999px;
  }

  .\\32xl\\:border-solid{
    border-style: solid;
  }

  .\\32xl\\:border-dashed{
    border-style: dashed;
  }

  .\\32xl\\:border-dotted{
    border-style: dotted;
  }

  .\\32xl\\:border-double{
    border-style: double;
  }

  .\\32xl\\:border-none{
    border-style: none;
  }

  .\\32xl\\:border-0{
    border-width: 0;
  }

  .\\32xl\\:border-2{
    border-width: 2px;
  }

  .\\32xl\\:border-3{
    border-width: 3px;
  }

  .\\32xl\\:border-4{
    border-width: 4px;
  }

  .\\32xl\\:border-5{
    border-width: 5px;
  }

  .\\32xl\\:border-6{
    border-width: 6px;
  }

  .\\32xl\\:border-8{
    border-width: 8px;
  }

  .\\32xl\\:border{
    border-width: 1px;
  }

  .\\32xl\\:border-t-0{
    border-top-width: 0;
  }

  .\\32xl\\:border-r-0{
    border-right-width: 0;
  }

  .\\32xl\\:border-b-0{
    border-bottom-width: 0;
  }

  .\\32xl\\:border-l-0{
    border-left-width: 0;
  }

  .\\32xl\\:border-t-2{
    border-top-width: 2px;
  }

  .\\32xl\\:border-r-2{
    border-right-width: 2px;
  }

  .\\32xl\\:border-b-2{
    border-bottom-width: 2px;
  }

  .\\32xl\\:border-l-2{
    border-left-width: 2px;
  }

  .\\32xl\\:border-t-3{
    border-top-width: 3px;
  }

  .\\32xl\\:border-r-3{
    border-right-width: 3px;
  }

  .\\32xl\\:border-b-3{
    border-bottom-width: 3px;
  }

  .\\32xl\\:border-l-3{
    border-left-width: 3px;
  }

  .\\32xl\\:border-t-4{
    border-top-width: 4px;
  }

  .\\32xl\\:border-r-4{
    border-right-width: 4px;
  }

  .\\32xl\\:border-b-4{
    border-bottom-width: 4px;
  }

  .\\32xl\\:border-l-4{
    border-left-width: 4px;
  }

  .\\32xl\\:border-t-5{
    border-top-width: 5px;
  }

  .\\32xl\\:border-r-5{
    border-right-width: 5px;
  }

  .\\32xl\\:border-b-5{
    border-bottom-width: 5px;
  }

  .\\32xl\\:border-l-5{
    border-left-width: 5px;
  }

  .\\32xl\\:border-t-6{
    border-top-width: 6px;
  }

  .\\32xl\\:border-r-6{
    border-right-width: 6px;
  }

  .\\32xl\\:border-b-6{
    border-bottom-width: 6px;
  }

  .\\32xl\\:border-l-6{
    border-left-width: 6px;
  }

  .\\32xl\\:border-t-8{
    border-top-width: 8px;
  }

  .\\32xl\\:border-r-8{
    border-right-width: 8px;
  }

  .\\32xl\\:border-b-8{
    border-bottom-width: 8px;
  }

  .\\32xl\\:border-l-8{
    border-left-width: 8px;
  }

  .\\32xl\\:border-t{
    border-top-width: 1px;
  }

  .\\32xl\\:border-r{
    border-right-width: 1px;
  }

  .\\32xl\\:border-b{
    border-bottom-width: 1px;
  }

  .\\32xl\\:border-l{
    border-left-width: 1px;
  }

  .\\32xl\\:first\\:border-0:first-child{
    border-width: 0;
  }

  .\\32xl\\:first\\:border-2:first-child{
    border-width: 2px;
  }

  .\\32xl\\:first\\:border-3:first-child{
    border-width: 3px;
  }

  .\\32xl\\:first\\:border-4:first-child{
    border-width: 4px;
  }

  .\\32xl\\:first\\:border-5:first-child{
    border-width: 5px;
  }

  .\\32xl\\:first\\:border-6:first-child{
    border-width: 6px;
  }

  .\\32xl\\:first\\:border-8:first-child{
    border-width: 8px;
  }

  .\\32xl\\:first\\:border:first-child{
    border-width: 1px;
  }

  .\\32xl\\:first\\:border-t-0:first-child{
    border-top-width: 0;
  }

  .\\32xl\\:first\\:border-r-0:first-child{
    border-right-width: 0;
  }

  .\\32xl\\:first\\:border-b-0:first-child{
    border-bottom-width: 0;
  }

  .\\32xl\\:first\\:border-l-0:first-child{
    border-left-width: 0;
  }

  .\\32xl\\:first\\:border-t-2:first-child{
    border-top-width: 2px;
  }

  .\\32xl\\:first\\:border-r-2:first-child{
    border-right-width: 2px;
  }

  .\\32xl\\:first\\:border-b-2:first-child{
    border-bottom-width: 2px;
  }

  .\\32xl\\:first\\:border-l-2:first-child{
    border-left-width: 2px;
  }

  .\\32xl\\:first\\:border-t-3:first-child{
    border-top-width: 3px;
  }

  .\\32xl\\:first\\:border-r-3:first-child{
    border-right-width: 3px;
  }

  .\\32xl\\:first\\:border-b-3:first-child{
    border-bottom-width: 3px;
  }

  .\\32xl\\:first\\:border-l-3:first-child{
    border-left-width: 3px;
  }

  .\\32xl\\:first\\:border-t-4:first-child{
    border-top-width: 4px;
  }

  .\\32xl\\:first\\:border-r-4:first-child{
    border-right-width: 4px;
  }

  .\\32xl\\:first\\:border-b-4:first-child{
    border-bottom-width: 4px;
  }

  .\\32xl\\:first\\:border-l-4:first-child{
    border-left-width: 4px;
  }

  .\\32xl\\:first\\:border-t-5:first-child{
    border-top-width: 5px;
  }

  .\\32xl\\:first\\:border-r-5:first-child{
    border-right-width: 5px;
  }

  .\\32xl\\:first\\:border-b-5:first-child{
    border-bottom-width: 5px;
  }

  .\\32xl\\:first\\:border-l-5:first-child{
    border-left-width: 5px;
  }

  .\\32xl\\:first\\:border-t-6:first-child{
    border-top-width: 6px;
  }

  .\\32xl\\:first\\:border-r-6:first-child{
    border-right-width: 6px;
  }

  .\\32xl\\:first\\:border-b-6:first-child{
    border-bottom-width: 6px;
  }

  .\\32xl\\:first\\:border-l-6:first-child{
    border-left-width: 6px;
  }

  .\\32xl\\:first\\:border-t-8:first-child{
    border-top-width: 8px;
  }

  .\\32xl\\:first\\:border-r-8:first-child{
    border-right-width: 8px;
  }

  .\\32xl\\:first\\:border-b-8:first-child{
    border-bottom-width: 8px;
  }

  .\\32xl\\:first\\:border-l-8:first-child{
    border-left-width: 8px;
  }

  .\\32xl\\:first\\:border-t:first-child{
    border-top-width: 1px;
  }

  .\\32xl\\:first\\:border-r:first-child{
    border-right-width: 1px;
  }

  .\\32xl\\:first\\:border-b:first-child{
    border-bottom-width: 1px;
  }

  .\\32xl\\:first\\:border-l:first-child{
    border-left-width: 1px;
  }

  .\\32xl\\:box-border{
    box-sizing: border-box;
  }

  .\\32xl\\:box-content{
    box-sizing: content-box;
  }

  .\\32xl\\:cursor-auto{
    cursor: auto;
  }

  .\\32xl\\:cursor-default{
    cursor: default;
  }

  .\\32xl\\:cursor-pointer{
    cursor: pointer;
  }

  .\\32xl\\:cursor-wait{
    cursor: wait;
  }

  .\\32xl\\:cursor-move{
    cursor: move;
  }

  .\\32xl\\:cursor-not-allowed{
    cursor: not-allowed;
  }

  .\\32xl\\:block{
    display: block;
  }

  .\\32xl\\:inline-block{
    display: inline-block;
  }

  .\\32xl\\:inline{
    display: inline;
  }

  .\\32xl\\:flex{
    display: flex;
  }

  .\\32xl\\:inline-flex{
    display: inline-flex;
  }

  .\\32xl\\:table{
    display: table;
  }

  .\\32xl\\:table-caption{
    display: table-caption;
  }

  .\\32xl\\:table-cell{
    display: table-cell;
  }

  .\\32xl\\:table-column{
    display: table-column;
  }

  .\\32xl\\:table-column-group{
    display: table-column-group;
  }

  .\\32xl\\:table-footer-group{
    display: table-footer-group;
  }

  .\\32xl\\:table-header-group{
    display: table-header-group;
  }

  .\\32xl\\:table-row-group{
    display: table-row-group;
  }

  .\\32xl\\:table-row{
    display: table-row;
  }

  .\\32xl\\:flow-root{
    display: flow-root;
  }

  .\\32xl\\:grid{
    display: grid;
  }

  .\\32xl\\:inline-grid{
    display: inline-grid;
  }

  .\\32xl\\:contents{
    display: contents;
  }

  .\\32xl\\:hidden{
    display: none;
  }

  .\\32xl\\:flex-row{
    flex-direction: row;
  }

  .\\32xl\\:flex-row-reverse{
    flex-direction: row-reverse;
  }

  .\\32xl\\:flex-col{
    flex-direction: column;
  }

  .\\32xl\\:flex-col-reverse{
    flex-direction: column-reverse;
  }

  .\\32xl\\:flex-wrap{
    flex-wrap: wrap;
  }

  .\\32xl\\:flex-wrap-reverse{
    flex-wrap: wrap-reverse;
  }

  .\\32xl\\:flex-no-wrap{
    flex-wrap: nowrap;
  }

  .\\32xl\\:place-items-auto{
    align-items: auto;
    justify-items: auto;
    place-items: auto;
  }

  .\\32xl\\:place-items-start{
    align-items: start;
    justify-items: start;
    place-items: start;
  }

  .\\32xl\\:place-items-end{
    align-items: end;
    justify-items: end;
    place-items: end;
  }

  .\\32xl\\:place-items-center{
    align-items: center;
    justify-items: center;
    place-items: center;
  }

  .\\32xl\\:place-items-stretch{
    align-items: stretch;
    justify-items: stretch;
    place-items: stretch;
  }

  .\\32xl\\:place-content-center{
    align-content: center;
    justify-content: center;
    place-content: center;
  }

  .\\32xl\\:place-content-start{
    align-content: start;
    justify-content: start;
    place-content: start;
  }

  .\\32xl\\:place-content-end{
    align-content: end;
    justify-content: end;
    place-content: end;
  }

  .\\32xl\\:place-content-between{
    align-content: space-between;
    justify-content: space-between;
    place-content: space-between;
  }

  .\\32xl\\:place-content-around{
    align-content: space-around;
    justify-content: space-around;
    place-content: space-around;
  }

  .\\32xl\\:place-content-evenly{
    align-content: space-evenly;
    justify-content: space-evenly;
    place-content: space-evenly;
  }

  .\\32xl\\:place-content-stretch{
    align-content: stretch;
    justify-content: stretch;
    place-content: stretch;
  }

  .\\32xl\\:place-self-auto{
    align-self: auto;
    justify-self: auto;
    place-self: auto;
  }

  .\\32xl\\:place-self-start{
    align-self: start;
    justify-self: start;
    place-self: start;
  }

  .\\32xl\\:place-self-end{
    align-self: end;
    justify-self: end;
    place-self: end;
  }

  .\\32xl\\:place-self-center{
    align-self: center;
    justify-self: center;
    place-self: center;
  }

  .\\32xl\\:place-self-stretch{
    align-self: stretch;
    justify-self: stretch;
    place-self: stretch;
  }

  .\\32xl\\:items-start{
    align-items: flex-start;
  }

  .\\32xl\\:items-end{
    align-items: flex-end;
  }

  .\\32xl\\:items-center{
    align-items: center;
  }

  .\\32xl\\:items-baseline{
    align-items: baseline;
  }

  .\\32xl\\:items-stretch{
    align-items: stretch;
  }

  .\\32xl\\:content-center{
    align-content: center;
  }

  .\\32xl\\:content-start{
    align-content: flex-start;
  }

  .\\32xl\\:content-end{
    align-content: flex-end;
  }

  .\\32xl\\:content-between{
    align-content: space-between;
  }

  .\\32xl\\:content-around{
    align-content: space-around;
  }

  .\\32xl\\:content-evenly{
    align-content: space-evenly;
  }

  .\\32xl\\:self-auto{
    align-self: auto;
  }

  .\\32xl\\:self-start{
    align-self: flex-start;
  }

  .\\32xl\\:self-end{
    align-self: flex-end;
  }

  .\\32xl\\:self-center{
    align-self: center;
  }

  .\\32xl\\:self-stretch{
    align-self: stretch;
  }

  .\\32xl\\:justify-items-auto{
    justify-items: auto;
  }

  .\\32xl\\:justify-items-start{
    justify-items: start;
  }

  .\\32xl\\:justify-items-end{
    justify-items: end;
  }

  .\\32xl\\:justify-items-center{
    justify-items: center;
  }

  .\\32xl\\:justify-items-stretch{
    justify-items: stretch;
  }

  .\\32xl\\:justify-start{
    justify-content: flex-start;
  }

  .\\32xl\\:justify-end{
    justify-content: flex-end;
  }

  .\\32xl\\:justify-center{
    justify-content: center;
  }

  .\\32xl\\:justify-between{
    justify-content: space-between;
  }

  .\\32xl\\:justify-around{
    justify-content: space-around;
  }

  .\\32xl\\:justify-evenly{
    justify-content: space-evenly;
  }

  .\\32xl\\:justify-self-auto{
    justify-self: auto;
  }

  .\\32xl\\:justify-self-start{
    justify-self: start;
  }

  .\\32xl\\:justify-self-end{
    justify-self: end;
  }

  .\\32xl\\:justify-self-center{
    justify-self: center;
  }

  .\\32xl\\:justify-self-stretch{
    justify-self: stretch;
  }

  .\\32xl\\:flex-1{
    flex: 1 1 0%;
  }

  .\\32xl\\:flex-auto{
    flex: 1 1 auto;
  }

  .\\32xl\\:flex-initial{
    flex: 0 1 auto;
  }

  .\\32xl\\:flex-none{
    flex: none;
  }

  .\\32xl\\:flex-grow-0{
    flex-grow: 0;
  }

  .\\32xl\\:flex-grow{
    flex-grow: 1;
  }

  .\\32xl\\:flex-shrink-0{
    flex-shrink: 0;
  }

  .\\32xl\\:flex-shrink{
    flex-shrink: 1;
  }

  .\\32xl\\:order-1{
    order: 1;
  }

  .\\32xl\\:order-2{
    order: 2;
  }

  .\\32xl\\:order-3{
    order: 3;
  }

  .\\32xl\\:order-4{
    order: 4;
  }

  .\\32xl\\:order-5{
    order: 5;
  }

  .\\32xl\\:order-6{
    order: 6;
  }

  .\\32xl\\:order-7{
    order: 7;
  }

  .\\32xl\\:order-8{
    order: 8;
  }

  .\\32xl\\:order-9{
    order: 9;
  }

  .\\32xl\\:order-10{
    order: 10;
  }

  .\\32xl\\:order-11{
    order: 11;
  }

  .\\32xl\\:order-12{
    order: 12;
  }

  .\\32xl\\:order-first{
    order: -9999;
  }

  .\\32xl\\:order-last{
    order: 9999;
  }

  .\\32xl\\:order-none{
    order: 0;
  }

  .\\32xl\\:float-right{
    float: right;
  }

  .\\32xl\\:float-left{
    float: left;
  }

  .\\32xl\\:float-none{
    float: none;
  }

  .\\32xl\\:clearfix:after{
    content: "";
    display: table;
    clear: both;
  }

  .\\32xl\\:clear-left{
    clear: left;
  }

  .\\32xl\\:clear-right{
    clear: right;
  }

  .\\32xl\\:clear-both{
    clear: both;
  }

  .\\32xl\\:clear-none{
    clear: none;
  }

  .\\32xl\\:font-sans{
    font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }

  .\\32xl\\:font-serif{
    font-family: Georgia, Cambria, "Times New Roman", Times, serif;
  }

  .\\32xl\\:font-mono{
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }

  .\\32xl\\:font-light{
    font-weight: 100;
  }

  .\\32xl\\:font-regular{
    font-weight: 400;
  }

  .\\32xl\\:font-semibold{
    font-weight: 600;
  }

  .\\32xl\\:font-bold{
    font-weight: 700;
  }

  .\\32xl\\:hover\\:font-light:hover{
    font-weight: 100;
  }

  .\\32xl\\:hover\\:font-regular:hover{
    font-weight: 400;
  }

  .\\32xl\\:hover\\:font-semibold:hover{
    font-weight: 600;
  }

  .\\32xl\\:hover\\:font-bold:hover{
    font-weight: 700;
  }

  .\\32xl\\:focus\\:font-light:focus{
    font-weight: 100;
  }

  .\\32xl\\:focus\\:font-regular:focus{
    font-weight: 400;
  }

  .\\32xl\\:focus\\:font-semibold:focus{
    font-weight: 600;
  }

  .\\32xl\\:focus\\:font-bold:focus{
    font-weight: 700;
  }

  .\\32xl\\:h-0{
    height: 0;
  }

  .\\32xl\\:h-1{
    height: 0.25rem;
  }

  .\\32xl\\:h-2{
    height: 0.5rem;
  }

  .\\32xl\\:h-3{
    height: 0.75rem;
  }

  .\\32xl\\:h-4{
    height: 1rem;
  }

  .\\32xl\\:h-5{
    height: 1.25rem;
  }

  .\\32xl\\:h-6{
    height: 1.5rem;
  }

  .\\32xl\\:h-7{
    height: 1.75rem;
  }

  .\\32xl\\:h-8{
    height: 2rem;
  }

  .\\32xl\\:h-9{
    height: 2.25rem;
  }

  .\\32xl\\:h-10{
    height: 2.5rem;
  }

  .\\32xl\\:h-11{
    height: 2.75rem;
  }

  .\\32xl\\:h-12{
    height: 3rem;
  }

  .\\32xl\\:h-14{
    height: 3.5rem;
  }

  .\\32xl\\:h-15{
    height: 3.75rem;
  }

  .\\32xl\\:h-16{
    height: 4rem;
  }

  .\\32xl\\:h-18{
    height: 4.5rem;
  }

  .\\32xl\\:h-20{
    height: 5rem;
  }

  .\\32xl\\:h-22{
    height: 5.5rem;
  }

  .\\32xl\\:h-23{
    height: 5.75rem;
  }

  .\\32xl\\:h-24{
    height: 6rem;
  }

  .\\32xl\\:h-25{
    height: 6.25rem;
  }

  .\\32xl\\:h-26{
    height: 6.5rem;
  }

  .\\32xl\\:h-28{
    height: 7rem;
  }

  .\\32xl\\:h-30{
    height: 7.5rem;
  }

  .\\32xl\\:h-32{
    height: 8rem;
  }

  .\\32xl\\:h-34{
    height: 8.5rem;
  }

  .\\32xl\\:h-40{
    height: 10rem;
  }

  .\\32xl\\:h-42{
    height: 10.5rem;
  }

  .\\32xl\\:h-44{
    height: 11rem;
  }

  .\\32xl\\:h-48{
    height: 12rem;
  }

  .\\32xl\\:h-52{
    height: 13rem;
  }

  .\\32xl\\:h-54{
    height: 13.5rem;
  }

  .\\32xl\\:h-56{
    height: 14rem;
  }

  .\\32xl\\:h-60{
    height: 15rem;
  }

  .\\32xl\\:h-64{
    height: 16rem;
  }

  .\\32xl\\:h-68{
    height: 17rem;
  }

  .\\32xl\\:h-72{
    height: 18rem;
  }

  .\\32xl\\:h-74{
    height: 18.5rem;
  }

  .\\32xl\\:h-76{
    height: 19rem;
  }

  .\\32xl\\:h-78{
    height: 19.5rem;
  }

  .\\32xl\\:h-80{
    height: 20rem;
  }

  .\\32xl\\:h-82{
    height: 20.5rem;
  }

  .\\32xl\\:h-84{
    height: 21rem;
  }

  .\\32xl\\:h-88{
    height: 22rem;
  }

  .\\32xl\\:h-92{
    height: 23rem;
  }

  .\\32xl\\:h-96{
    height: 24rem;
  }

  .\\32xl\\:h-98{
    height: 24.5rem;
  }

  .\\32xl\\:h-100{
    height: 25rem;
  }

  .\\32xl\\:h-104{
    height: 26rem;
  }

  .\\32xl\\:h-112{
    height: 28rem;
  }

  .\\32xl\\:h-124{
    height: 31rem;
  }

  .\\32xl\\:h-128{
    height: 32rem;
  }

  .\\32xl\\:h-140{
    height: 35rem;
  }

  .\\32xl\\:h-152{
    height: 38rem;
  }

  .\\32xl\\:h-160{
    height: 40rem;
  }

  .\\32xl\\:h-162{
    height: 41rem;
  }

  .\\32xl\\:h-192{
    height: 48rem;
  }

  .\\32xl\\:h-208{
    height: 52rem;
  }

  .\\32xl\\:h-224{
    height: 56rem;
  }

  .\\32xl\\:h-256{
    height: 64rem;
  }

  .\\32xl\\:h-auto{
    height: auto;
  }

  .\\32xl\\:h-px{
    height: 1px;
  }

  .\\32xl\\:h-full{
    height: 100%;
  }

  .\\32xl\\:h-screen{
    height: 100vh;
  }

  .\\32xl\\:text-xs{
    font-size: 0.74rem;
  }

  .\\32xl\\:text-sm{
    font-size: 0.86rem;
  }

  .\\32xl\\:text-base{
    font-size: 1rem;
  }

  .\\32xl\\:text-lg{
    font-size: 1.15rem;
  }

  .\\32xl\\:text-xl{
    font-size: 1.42rem;
  }

  .\\32xl\\:text-2xl{
    font-size: 1.85rem;
  }

  .\\32xl\\:text-3xl{
    font-size: 1.95rem;
  }

  .\\32xl\\:text-4xl{
    font-size: 2.25rem;
  }

  .\\32xl\\:text-5xl{
    font-size: 3rem;
  }

  .\\32xl\\:text-6xl{
    font-size: 4rem;
  }

  .\\32xl\\:text-7xl{
    font-size: 5rem;
  }

  .\\32xl\\:leading-none{
    line-height: 1;
  }

  .\\32xl\\:leading-tight{
    line-height: 1.2;
  }

  .\\32xl\\:leading-snug{
    line-height: 1.3;
  }

  .\\32xl\\:leading-normal{
    line-height: 1.4;
  }

  .\\32xl\\:leading-relaxed{
    line-height: 1.6;
  }

  .\\32xl\\:list-inside{
    list-style-position: inside;
  }

  .\\32xl\\:list-outside{
    list-style-position: outside;
  }

  .\\32xl\\:list-none{
    list-style-type: none;
  }

  .\\32xl\\:list-disc{
    list-style-type: disc;
  }

  .\\32xl\\:list-decimal{
    list-style-type: decimal;
  }

  .\\32xl\\:m-0{
    margin: 0;
  }

  .\\32xl\\:m-1{
    margin: 0.25rem;
  }

  .\\32xl\\:m-2{
    margin: 0.5rem;
  }

  .\\32xl\\:m-3{
    margin: 0.75rem;
  }

  .\\32xl\\:m-4{
    margin: 1rem;
  }

  .\\32xl\\:m-5{
    margin: 1.25rem;
  }

  .\\32xl\\:m-6{
    margin: 1.5rem;
  }

  .\\32xl\\:m-7{
    margin: 1.75rem;
  }

  .\\32xl\\:m-8{
    margin: 2rem;
  }

  .\\32xl\\:m-9{
    margin: 2.25rem;
  }

  .\\32xl\\:m-10{
    margin: 2.5rem;
  }

  .\\32xl\\:m-11{
    margin: 2.75rem;
  }

  .\\32xl\\:m-12{
    margin: 3rem;
  }

  .\\32xl\\:m-14{
    margin: 3.5rem;
  }

  .\\32xl\\:m-15{
    margin: 3.75rem;
  }

  .\\32xl\\:m-16{
    margin: 4rem;
  }

  .\\32xl\\:m-18{
    margin: 4.5rem;
  }

  .\\32xl\\:m-20{
    margin: 5rem;
  }

  .\\32xl\\:m-22{
    margin: 5.5rem;
  }

  .\\32xl\\:m-23{
    margin: 5.75rem;
  }

  .\\32xl\\:m-24{
    margin: 6rem;
  }

  .\\32xl\\:m-25{
    margin: 6.25rem;
  }

  .\\32xl\\:m-26{
    margin: 6.5rem;
  }

  .\\32xl\\:m-28{
    margin: 7rem;
  }

  .\\32xl\\:m-30{
    margin: 7.5rem;
  }

  .\\32xl\\:m-32{
    margin: 8rem;
  }

  .\\32xl\\:m-34{
    margin: 8.5rem;
  }

  .\\32xl\\:m-40{
    margin: 10rem;
  }

  .\\32xl\\:m-42{
    margin: 10.5rem;
  }

  .\\32xl\\:m-44{
    margin: 11rem;
  }

  .\\32xl\\:m-48{
    margin: 12rem;
  }

  .\\32xl\\:m-52{
    margin: 13rem;
  }

  .\\32xl\\:m-54{
    margin: 13.5rem;
  }

  .\\32xl\\:m-56{
    margin: 14rem;
  }

  .\\32xl\\:m-60{
    margin: 15rem;
  }

  .\\32xl\\:m-64{
    margin: 16rem;
  }

  .\\32xl\\:m-68{
    margin: 17rem;
  }

  .\\32xl\\:m-72{
    margin: 18rem;
  }

  .\\32xl\\:m-74{
    margin: 18.5rem;
  }

  .\\32xl\\:m-76{
    margin: 19rem;
  }

  .\\32xl\\:m-78{
    margin: 19.5rem;
  }

  .\\32xl\\:m-80{
    margin: 20rem;
  }

  .\\32xl\\:m-82{
    margin: 20.5rem;
  }

  .\\32xl\\:m-84{
    margin: 21rem;
  }

  .\\32xl\\:m-88{
    margin: 22rem;
  }

  .\\32xl\\:m-92{
    margin: 23rem;
  }

  .\\32xl\\:m-96{
    margin: 24rem;
  }

  .\\32xl\\:m-98{
    margin: 24.5rem;
  }

  .\\32xl\\:m-100{
    margin: 25rem;
  }

  .\\32xl\\:m-104{
    margin: 26rem;
  }

  .\\32xl\\:m-112{
    margin: 28rem;
  }

  .\\32xl\\:m-124{
    margin: 31rem;
  }

  .\\32xl\\:m-128{
    margin: 32rem;
  }

  .\\32xl\\:m-140{
    margin: 35rem;
  }

  .\\32xl\\:m-152{
    margin: 38rem;
  }

  .\\32xl\\:m-160{
    margin: 40rem;
  }

  .\\32xl\\:m-162{
    margin: 41rem;
  }

  .\\32xl\\:m-192{
    margin: 48rem;
  }

  .\\32xl\\:m-208{
    margin: 52rem;
  }

  .\\32xl\\:m-224{
    margin: 56rem;
  }

  .\\32xl\\:m-256{
    margin: 64rem;
  }

  .\\32xl\\:m-auto{
    margin: auto;
  }

  .\\32xl\\:m-px{
    margin: 1px;
  }

  .\\32xl\\:-m-1{
    margin: -0.25rem;
  }

  .\\32xl\\:-m-2{
    margin: -0.5rem;
  }

  .\\32xl\\:-m-3{
    margin: -0.75rem;
  }

  .\\32xl\\:-m-4{
    margin: -1rem;
  }

  .\\32xl\\:-m-5{
    margin: -1.25rem;
  }

  .\\32xl\\:-m-6{
    margin: -1.5rem;
  }

  .\\32xl\\:-m-7{
    margin: -1.75rem;
  }

  .\\32xl\\:-m-8{
    margin: -2rem;
  }

  .\\32xl\\:-m-9{
    margin: -2.25rem;
  }

  .\\32xl\\:-m-10{
    margin: -2.5rem;
  }

  .\\32xl\\:-m-11{
    margin: -2.75rem;
  }

  .\\32xl\\:-m-12{
    margin: -3rem;
  }

  .\\32xl\\:-m-14{
    margin: -3.5rem;
  }

  .\\32xl\\:-m-15{
    margin: -3.75rem;
  }

  .\\32xl\\:-m-16{
    margin: -4rem;
  }

  .\\32xl\\:-m-18{
    margin: -4.5rem;
  }

  .\\32xl\\:-m-20{
    margin: -5rem;
  }

  .\\32xl\\:-m-22{
    margin: -5.5rem;
  }

  .\\32xl\\:-m-23{
    margin: -5.75rem;
  }

  .\\32xl\\:-m-24{
    margin: -6rem;
  }

  .\\32xl\\:-m-25{
    margin: -6.25rem;
  }

  .\\32xl\\:-m-26{
    margin: -6.5rem;
  }

  .\\32xl\\:-m-28{
    margin: -7rem;
  }

  .\\32xl\\:-m-30{
    margin: -7.5rem;
  }

  .\\32xl\\:-m-32{
    margin: -8rem;
  }

  .\\32xl\\:-m-34{
    margin: -8.5rem;
  }

  .\\32xl\\:-m-40{
    margin: -10rem;
  }

  .\\32xl\\:-m-42{
    margin: -10.5rem;
  }

  .\\32xl\\:-m-44{
    margin: -11rem;
  }

  .\\32xl\\:-m-48{
    margin: -12rem;
  }

  .\\32xl\\:-m-52{
    margin: -13rem;
  }

  .\\32xl\\:-m-54{
    margin: -13.5rem;
  }

  .\\32xl\\:-m-56{
    margin: -14rem;
  }

  .\\32xl\\:-m-60{
    margin: -15rem;
  }

  .\\32xl\\:-m-64{
    margin: -16rem;
  }

  .\\32xl\\:-m-68{
    margin: -17rem;
  }

  .\\32xl\\:-m-72{
    margin: -18rem;
  }

  .\\32xl\\:-m-74{
    margin: -18.5rem;
  }

  .\\32xl\\:-m-76{
    margin: -19rem;
  }

  .\\32xl\\:-m-78{
    margin: -19.5rem;
  }

  .\\32xl\\:-m-80{
    margin: -20rem;
  }

  .\\32xl\\:-m-82{
    margin: -20.5rem;
  }

  .\\32xl\\:-m-84{
    margin: -21rem;
  }

  .\\32xl\\:-m-88{
    margin: -22rem;
  }

  .\\32xl\\:-m-92{
    margin: -23rem;
  }

  .\\32xl\\:-m-96{
    margin: -24rem;
  }

  .\\32xl\\:-m-98{
    margin: -24.5rem;
  }

  .\\32xl\\:-m-100{
    margin: -25rem;
  }

  .\\32xl\\:-m-104{
    margin: -26rem;
  }

  .\\32xl\\:-m-112{
    margin: -28rem;
  }

  .\\32xl\\:-m-124{
    margin: -31rem;
  }

  .\\32xl\\:-m-128{
    margin: -32rem;
  }

  .\\32xl\\:-m-140{
    margin: -35rem;
  }

  .\\32xl\\:-m-152{
    margin: -38rem;
  }

  .\\32xl\\:-m-160{
    margin: -40rem;
  }

  .\\32xl\\:-m-162{
    margin: -41rem;
  }

  .\\32xl\\:-m-192{
    margin: -48rem;
  }

  .\\32xl\\:-m-208{
    margin: -52rem;
  }

  .\\32xl\\:-m-224{
    margin: -56rem;
  }

  .\\32xl\\:-m-256{
    margin: -64rem;
  }

  .\\32xl\\:-m-px{
    margin: -1px;
  }

  .\\32xl\\:my-0{
    margin-top: 0;
    margin-bottom: 0;
  }

  .\\32xl\\:mx-0{
    margin-left: 0;
    margin-right: 0;
  }

  .\\32xl\\:my-1{
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .\\32xl\\:mx-1{
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .\\32xl\\:my-2{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .\\32xl\\:mx-2{
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .\\32xl\\:my-3{
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .\\32xl\\:mx-3{
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .\\32xl\\:my-4{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .\\32xl\\:mx-4{
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .\\32xl\\:my-5{
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .\\32xl\\:mx-5{
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .\\32xl\\:my-6{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .\\32xl\\:mx-6{
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .\\32xl\\:my-7{
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }

  .\\32xl\\:mx-7{
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }

  .\\32xl\\:my-8{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .\\32xl\\:mx-8{
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .\\32xl\\:my-9{
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }

  .\\32xl\\:mx-9{
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }

  .\\32xl\\:my-10{
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .\\32xl\\:mx-10{
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .\\32xl\\:my-11{
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;
  }

  .\\32xl\\:mx-11{
    margin-left: 2.75rem;
    margin-right: 2.75rem;
  }

  .\\32xl\\:my-12{
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .\\32xl\\:mx-12{
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .\\32xl\\:my-14{
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
  }

  .\\32xl\\:mx-14{
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }

  .\\32xl\\:my-15{
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
  }

  .\\32xl\\:mx-15{
    margin-left: 3.75rem;
    margin-right: 3.75rem;
  }

  .\\32xl\\:my-16{
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .\\32xl\\:mx-16{
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .\\32xl\\:my-18{
    margin-top: 4.5rem;
    margin-bottom: 4.5rem;
  }

  .\\32xl\\:mx-18{
    margin-left: 4.5rem;
    margin-right: 4.5rem;
  }

  .\\32xl\\:my-20{
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .\\32xl\\:mx-20{
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .\\32xl\\:my-22{
    margin-top: 5.5rem;
    margin-bottom: 5.5rem;
  }

  .\\32xl\\:mx-22{
    margin-left: 5.5rem;
    margin-right: 5.5rem;
  }

  .\\32xl\\:my-23{
    margin-top: 5.75rem;
    margin-bottom: 5.75rem;
  }

  .\\32xl\\:mx-23{
    margin-left: 5.75rem;
    margin-right: 5.75rem;
  }

  .\\32xl\\:my-24{
    margin-top: 6rem;
    margin-bottom: 6rem;
  }

  .\\32xl\\:mx-24{
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .\\32xl\\:my-25{
    margin-top: 6.25rem;
    margin-bottom: 6.25rem;
  }

  .\\32xl\\:mx-25{
    margin-left: 6.25rem;
    margin-right: 6.25rem;
  }

  .\\32xl\\:my-26{
    margin-top: 6.5rem;
    margin-bottom: 6.5rem;
  }

  .\\32xl\\:mx-26{
    margin-left: 6.5rem;
    margin-right: 6.5rem;
  }

  .\\32xl\\:my-28{
    margin-top: 7rem;
    margin-bottom: 7rem;
  }

  .\\32xl\\:mx-28{
    margin-left: 7rem;
    margin-right: 7rem;
  }

  .\\32xl\\:my-30{
    margin-top: 7.5rem;
    margin-bottom: 7.5rem;
  }

  .\\32xl\\:mx-30{
    margin-left: 7.5rem;
    margin-right: 7.5rem;
  }

  .\\32xl\\:my-32{
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  .\\32xl\\:mx-32{
    margin-left: 8rem;
    margin-right: 8rem;
  }

  .\\32xl\\:my-34{
    margin-top: 8.5rem;
    margin-bottom: 8.5rem;
  }

  .\\32xl\\:mx-34{
    margin-left: 8.5rem;
    margin-right: 8.5rem;
  }

  .\\32xl\\:my-40{
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .\\32xl\\:mx-40{
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .\\32xl\\:my-42{
    margin-top: 10.5rem;
    margin-bottom: 10.5rem;
  }

  .\\32xl\\:mx-42{
    margin-left: 10.5rem;
    margin-right: 10.5rem;
  }

  .\\32xl\\:my-44{
    margin-top: 11rem;
    margin-bottom: 11rem;
  }

  .\\32xl\\:mx-44{
    margin-left: 11rem;
    margin-right: 11rem;
  }

  .\\32xl\\:my-48{
    margin-top: 12rem;
    margin-bottom: 12rem;
  }

  .\\32xl\\:mx-48{
    margin-left: 12rem;
    margin-right: 12rem;
  }

  .\\32xl\\:my-52{
    margin-top: 13rem;
    margin-bottom: 13rem;
  }

  .\\32xl\\:mx-52{
    margin-left: 13rem;
    margin-right: 13rem;
  }

  .\\32xl\\:my-54{
    margin-top: 13.5rem;
    margin-bottom: 13.5rem;
  }

  .\\32xl\\:mx-54{
    margin-left: 13.5rem;
    margin-right: 13.5rem;
  }

  .\\32xl\\:my-56{
    margin-top: 14rem;
    margin-bottom: 14rem;
  }

  .\\32xl\\:mx-56{
    margin-left: 14rem;
    margin-right: 14rem;
  }

  .\\32xl\\:my-60{
    margin-top: 15rem;
    margin-bottom: 15rem;
  }

  .\\32xl\\:mx-60{
    margin-left: 15rem;
    margin-right: 15rem;
  }

  .\\32xl\\:my-64{
    margin-top: 16rem;
    margin-bottom: 16rem;
  }

  .\\32xl\\:mx-64{
    margin-left: 16rem;
    margin-right: 16rem;
  }

  .\\32xl\\:my-68{
    margin-top: 17rem;
    margin-bottom: 17rem;
  }

  .\\32xl\\:mx-68{
    margin-left: 17rem;
    margin-right: 17rem;
  }

  .\\32xl\\:my-72{
    margin-top: 18rem;
    margin-bottom: 18rem;
  }

  .\\32xl\\:mx-72{
    margin-left: 18rem;
    margin-right: 18rem;
  }

  .\\32xl\\:my-74{
    margin-top: 18.5rem;
    margin-bottom: 18.5rem;
  }

  .\\32xl\\:mx-74{
    margin-left: 18.5rem;
    margin-right: 18.5rem;
  }

  .\\32xl\\:my-76{
    margin-top: 19rem;
    margin-bottom: 19rem;
  }

  .\\32xl\\:mx-76{
    margin-left: 19rem;
    margin-right: 19rem;
  }

  .\\32xl\\:my-78{
    margin-top: 19.5rem;
    margin-bottom: 19.5rem;
  }

  .\\32xl\\:mx-78{
    margin-left: 19.5rem;
    margin-right: 19.5rem;
  }

  .\\32xl\\:my-80{
    margin-top: 20rem;
    margin-bottom: 20rem;
  }

  .\\32xl\\:mx-80{
    margin-left: 20rem;
    margin-right: 20rem;
  }

  .\\32xl\\:my-82{
    margin-top: 20.5rem;
    margin-bottom: 20.5rem;
  }

  .\\32xl\\:mx-82{
    margin-left: 20.5rem;
    margin-right: 20.5rem;
  }

  .\\32xl\\:my-84{
    margin-top: 21rem;
    margin-bottom: 21rem;
  }

  .\\32xl\\:mx-84{
    margin-left: 21rem;
    margin-right: 21rem;
  }

  .\\32xl\\:my-88{
    margin-top: 22rem;
    margin-bottom: 22rem;
  }

  .\\32xl\\:mx-88{
    margin-left: 22rem;
    margin-right: 22rem;
  }

  .\\32xl\\:my-92{
    margin-top: 23rem;
    margin-bottom: 23rem;
  }

  .\\32xl\\:mx-92{
    margin-left: 23rem;
    margin-right: 23rem;
  }

  .\\32xl\\:my-96{
    margin-top: 24rem;
    margin-bottom: 24rem;
  }

  .\\32xl\\:mx-96{
    margin-left: 24rem;
    margin-right: 24rem;
  }

  .\\32xl\\:my-98{
    margin-top: 24.5rem;
    margin-bottom: 24.5rem;
  }

  .\\32xl\\:mx-98{
    margin-left: 24.5rem;
    margin-right: 24.5rem;
  }

  .\\32xl\\:my-100{
    margin-top: 25rem;
    margin-bottom: 25rem;
  }

  .\\32xl\\:mx-100{
    margin-left: 25rem;
    margin-right: 25rem;
  }

  .\\32xl\\:my-104{
    margin-top: 26rem;
    margin-bottom: 26rem;
  }

  .\\32xl\\:mx-104{
    margin-left: 26rem;
    margin-right: 26rem;
  }

  .\\32xl\\:my-112{
    margin-top: 28rem;
    margin-bottom: 28rem;
  }

  .\\32xl\\:mx-112{
    margin-left: 28rem;
    margin-right: 28rem;
  }

  .\\32xl\\:my-124{
    margin-top: 31rem;
    margin-bottom: 31rem;
  }

  .\\32xl\\:mx-124{
    margin-left: 31rem;
    margin-right: 31rem;
  }

  .\\32xl\\:my-128{
    margin-top: 32rem;
    margin-bottom: 32rem;
  }

  .\\32xl\\:mx-128{
    margin-left: 32rem;
    margin-right: 32rem;
  }

  .\\32xl\\:my-140{
    margin-top: 35rem;
    margin-bottom: 35rem;
  }

  .\\32xl\\:mx-140{
    margin-left: 35rem;
    margin-right: 35rem;
  }

  .\\32xl\\:my-152{
    margin-top: 38rem;
    margin-bottom: 38rem;
  }

  .\\32xl\\:mx-152{
    margin-left: 38rem;
    margin-right: 38rem;
  }

  .\\32xl\\:my-160{
    margin-top: 40rem;
    margin-bottom: 40rem;
  }

  .\\32xl\\:mx-160{
    margin-left: 40rem;
    margin-right: 40rem;
  }

  .\\32xl\\:my-162{
    margin-top: 41rem;
    margin-bottom: 41rem;
  }

  .\\32xl\\:mx-162{
    margin-left: 41rem;
    margin-right: 41rem;
  }

  .\\32xl\\:my-192{
    margin-top: 48rem;
    margin-bottom: 48rem;
  }

  .\\32xl\\:mx-192{
    margin-left: 48rem;
    margin-right: 48rem;
  }

  .\\32xl\\:my-208{
    margin-top: 52rem;
    margin-bottom: 52rem;
  }

  .\\32xl\\:mx-208{
    margin-left: 52rem;
    margin-right: 52rem;
  }

  .\\32xl\\:my-224{
    margin-top: 56rem;
    margin-bottom: 56rem;
  }

  .\\32xl\\:mx-224{
    margin-left: 56rem;
    margin-right: 56rem;
  }

  .\\32xl\\:my-256{
    margin-top: 64rem;
    margin-bottom: 64rem;
  }

  .\\32xl\\:mx-256{
    margin-left: 64rem;
    margin-right: 64rem;
  }

  .\\32xl\\:my-auto{
    margin-top: auto;
    margin-bottom: auto;
  }

  .\\32xl\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }

  .\\32xl\\:my-px{
    margin-top: 1px;
    margin-bottom: 1px;
  }

  .\\32xl\\:mx-px{
    margin-left: 1px;
    margin-right: 1px;
  }

  .\\32xl\\:-my-1{
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .\\32xl\\:-mx-1{
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .\\32xl\\:-my-2{
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }

  .\\32xl\\:-mx-2{
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .\\32xl\\:-my-3{
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }

  .\\32xl\\:-mx-3{
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .\\32xl\\:-my-4{
    margin-top: -1rem;
    margin-bottom: -1rem;
  }

  .\\32xl\\:-mx-4{
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .\\32xl\\:-my-5{
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }

  .\\32xl\\:-mx-5{
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .\\32xl\\:-my-6{
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }

  .\\32xl\\:-mx-6{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .\\32xl\\:-my-7{
    margin-top: -1.75rem;
    margin-bottom: -1.75rem;
  }

  .\\32xl\\:-mx-7{
    margin-left: -1.75rem;
    margin-right: -1.75rem;
  }

  .\\32xl\\:-my-8{
    margin-top: -2rem;
    margin-bottom: -2rem;
  }

  .\\32xl\\:-mx-8{
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .\\32xl\\:-my-9{
    margin-top: -2.25rem;
    margin-bottom: -2.25rem;
  }

  .\\32xl\\:-mx-9{
    margin-left: -2.25rem;
    margin-right: -2.25rem;
  }

  .\\32xl\\:-my-10{
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }

  .\\32xl\\:-mx-10{
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .\\32xl\\:-my-11{
    margin-top: -2.75rem;
    margin-bottom: -2.75rem;
  }

  .\\32xl\\:-mx-11{
    margin-left: -2.75rem;
    margin-right: -2.75rem;
  }

  .\\32xl\\:-my-12{
    margin-top: -3rem;
    margin-bottom: -3rem;
  }

  .\\32xl\\:-mx-12{
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .\\32xl\\:-my-14{
    margin-top: -3.5rem;
    margin-bottom: -3.5rem;
  }

  .\\32xl\\:-mx-14{
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }

  .\\32xl\\:-my-15{
    margin-top: -3.75rem;
    margin-bottom: -3.75rem;
  }

  .\\32xl\\:-mx-15{
    margin-left: -3.75rem;
    margin-right: -3.75rem;
  }

  .\\32xl\\:-my-16{
    margin-top: -4rem;
    margin-bottom: -4rem;
  }

  .\\32xl\\:-mx-16{
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .\\32xl\\:-my-18{
    margin-top: -4.5rem;
    margin-bottom: -4.5rem;
  }

  .\\32xl\\:-mx-18{
    margin-left: -4.5rem;
    margin-right: -4.5rem;
  }

  .\\32xl\\:-my-20{
    margin-top: -5rem;
    margin-bottom: -5rem;
  }

  .\\32xl\\:-mx-20{
    margin-left: -5rem;
    margin-right: -5rem;
  }

  .\\32xl\\:-my-22{
    margin-top: -5.5rem;
    margin-bottom: -5.5rem;
  }

  .\\32xl\\:-mx-22{
    margin-left: -5.5rem;
    margin-right: -5.5rem;
  }

  .\\32xl\\:-my-23{
    margin-top: -5.75rem;
    margin-bottom: -5.75rem;
  }

  .\\32xl\\:-mx-23{
    margin-left: -5.75rem;
    margin-right: -5.75rem;
  }

  .\\32xl\\:-my-24{
    margin-top: -6rem;
    margin-bottom: -6rem;
  }

  .\\32xl\\:-mx-24{
    margin-left: -6rem;
    margin-right: -6rem;
  }

  .\\32xl\\:-my-25{
    margin-top: -6.25rem;
    margin-bottom: -6.25rem;
  }

  .\\32xl\\:-mx-25{
    margin-left: -6.25rem;
    margin-right: -6.25rem;
  }

  .\\32xl\\:-my-26{
    margin-top: -6.5rem;
    margin-bottom: -6.5rem;
  }

  .\\32xl\\:-mx-26{
    margin-left: -6.5rem;
    margin-right: -6.5rem;
  }

  .\\32xl\\:-my-28{
    margin-top: -7rem;
    margin-bottom: -7rem;
  }

  .\\32xl\\:-mx-28{
    margin-left: -7rem;
    margin-right: -7rem;
  }

  .\\32xl\\:-my-30{
    margin-top: -7.5rem;
    margin-bottom: -7.5rem;
  }

  .\\32xl\\:-mx-30{
    margin-left: -7.5rem;
    margin-right: -7.5rem;
  }

  .\\32xl\\:-my-32{
    margin-top: -8rem;
    margin-bottom: -8rem;
  }

  .\\32xl\\:-mx-32{
    margin-left: -8rem;
    margin-right: -8rem;
  }

  .\\32xl\\:-my-34{
    margin-top: -8.5rem;
    margin-bottom: -8.5rem;
  }

  .\\32xl\\:-mx-34{
    margin-left: -8.5rem;
    margin-right: -8.5rem;
  }

  .\\32xl\\:-my-40{
    margin-top: -10rem;
    margin-bottom: -10rem;
  }

  .\\32xl\\:-mx-40{
    margin-left: -10rem;
    margin-right: -10rem;
  }

  .\\32xl\\:-my-42{
    margin-top: -10.5rem;
    margin-bottom: -10.5rem;
  }

  .\\32xl\\:-mx-42{
    margin-left: -10.5rem;
    margin-right: -10.5rem;
  }

  .\\32xl\\:-my-44{
    margin-top: -11rem;
    margin-bottom: -11rem;
  }

  .\\32xl\\:-mx-44{
    margin-left: -11rem;
    margin-right: -11rem;
  }

  .\\32xl\\:-my-48{
    margin-top: -12rem;
    margin-bottom: -12rem;
  }

  .\\32xl\\:-mx-48{
    margin-left: -12rem;
    margin-right: -12rem;
  }

  .\\32xl\\:-my-52{
    margin-top: -13rem;
    margin-bottom: -13rem;
  }

  .\\32xl\\:-mx-52{
    margin-left: -13rem;
    margin-right: -13rem;
  }

  .\\32xl\\:-my-54{
    margin-top: -13.5rem;
    margin-bottom: -13.5rem;
  }

  .\\32xl\\:-mx-54{
    margin-left: -13.5rem;
    margin-right: -13.5rem;
  }

  .\\32xl\\:-my-56{
    margin-top: -14rem;
    margin-bottom: -14rem;
  }

  .\\32xl\\:-mx-56{
    margin-left: -14rem;
    margin-right: -14rem;
  }

  .\\32xl\\:-my-60{
    margin-top: -15rem;
    margin-bottom: -15rem;
  }

  .\\32xl\\:-mx-60{
    margin-left: -15rem;
    margin-right: -15rem;
  }

  .\\32xl\\:-my-64{
    margin-top: -16rem;
    margin-bottom: -16rem;
  }

  .\\32xl\\:-mx-64{
    margin-left: -16rem;
    margin-right: -16rem;
  }

  .\\32xl\\:-my-68{
    margin-top: -17rem;
    margin-bottom: -17rem;
  }

  .\\32xl\\:-mx-68{
    margin-left: -17rem;
    margin-right: -17rem;
  }

  .\\32xl\\:-my-72{
    margin-top: -18rem;
    margin-bottom: -18rem;
  }

  .\\32xl\\:-mx-72{
    margin-left: -18rem;
    margin-right: -18rem;
  }

  .\\32xl\\:-my-74{
    margin-top: -18.5rem;
    margin-bottom: -18.5rem;
  }

  .\\32xl\\:-mx-74{
    margin-left: -18.5rem;
    margin-right: -18.5rem;
  }

  .\\32xl\\:-my-76{
    margin-top: -19rem;
    margin-bottom: -19rem;
  }

  .\\32xl\\:-mx-76{
    margin-left: -19rem;
    margin-right: -19rem;
  }

  .\\32xl\\:-my-78{
    margin-top: -19.5rem;
    margin-bottom: -19.5rem;
  }

  .\\32xl\\:-mx-78{
    margin-left: -19.5rem;
    margin-right: -19.5rem;
  }

  .\\32xl\\:-my-80{
    margin-top: -20rem;
    margin-bottom: -20rem;
  }

  .\\32xl\\:-mx-80{
    margin-left: -20rem;
    margin-right: -20rem;
  }

  .\\32xl\\:-my-82{
    margin-top: -20.5rem;
    margin-bottom: -20.5rem;
  }

  .\\32xl\\:-mx-82{
    margin-left: -20.5rem;
    margin-right: -20.5rem;
  }

  .\\32xl\\:-my-84{
    margin-top: -21rem;
    margin-bottom: -21rem;
  }

  .\\32xl\\:-mx-84{
    margin-left: -21rem;
    margin-right: -21rem;
  }

  .\\32xl\\:-my-88{
    margin-top: -22rem;
    margin-bottom: -22rem;
  }

  .\\32xl\\:-mx-88{
    margin-left: -22rem;
    margin-right: -22rem;
  }

  .\\32xl\\:-my-92{
    margin-top: -23rem;
    margin-bottom: -23rem;
  }

  .\\32xl\\:-mx-92{
    margin-left: -23rem;
    margin-right: -23rem;
  }

  .\\32xl\\:-my-96{
    margin-top: -24rem;
    margin-bottom: -24rem;
  }

  .\\32xl\\:-mx-96{
    margin-left: -24rem;
    margin-right: -24rem;
  }

  .\\32xl\\:-my-98{
    margin-top: -24.5rem;
    margin-bottom: -24.5rem;
  }

  .\\32xl\\:-mx-98{
    margin-left: -24.5rem;
    margin-right: -24.5rem;
  }

  .\\32xl\\:-my-100{
    margin-top: -25rem;
    margin-bottom: -25rem;
  }

  .\\32xl\\:-mx-100{
    margin-left: -25rem;
    margin-right: -25rem;
  }

  .\\32xl\\:-my-104{
    margin-top: -26rem;
    margin-bottom: -26rem;
  }

  .\\32xl\\:-mx-104{
    margin-left: -26rem;
    margin-right: -26rem;
  }

  .\\32xl\\:-my-112{
    margin-top: -28rem;
    margin-bottom: -28rem;
  }

  .\\32xl\\:-mx-112{
    margin-left: -28rem;
    margin-right: -28rem;
  }

  .\\32xl\\:-my-124{
    margin-top: -31rem;
    margin-bottom: -31rem;
  }

  .\\32xl\\:-mx-124{
    margin-left: -31rem;
    margin-right: -31rem;
  }

  .\\32xl\\:-my-128{
    margin-top: -32rem;
    margin-bottom: -32rem;
  }

  .\\32xl\\:-mx-128{
    margin-left: -32rem;
    margin-right: -32rem;
  }

  .\\32xl\\:-my-140{
    margin-top: -35rem;
    margin-bottom: -35rem;
  }

  .\\32xl\\:-mx-140{
    margin-left: -35rem;
    margin-right: -35rem;
  }

  .\\32xl\\:-my-152{
    margin-top: -38rem;
    margin-bottom: -38rem;
  }

  .\\32xl\\:-mx-152{
    margin-left: -38rem;
    margin-right: -38rem;
  }

  .\\32xl\\:-my-160{
    margin-top: -40rem;
    margin-bottom: -40rem;
  }

  .\\32xl\\:-mx-160{
    margin-left: -40rem;
    margin-right: -40rem;
  }

  .\\32xl\\:-my-162{
    margin-top: -41rem;
    margin-bottom: -41rem;
  }

  .\\32xl\\:-mx-162{
    margin-left: -41rem;
    margin-right: -41rem;
  }

  .\\32xl\\:-my-192{
    margin-top: -48rem;
    margin-bottom: -48rem;
  }

  .\\32xl\\:-mx-192{
    margin-left: -48rem;
    margin-right: -48rem;
  }

  .\\32xl\\:-my-208{
    margin-top: -52rem;
    margin-bottom: -52rem;
  }

  .\\32xl\\:-mx-208{
    margin-left: -52rem;
    margin-right: -52rem;
  }

  .\\32xl\\:-my-224{
    margin-top: -56rem;
    margin-bottom: -56rem;
  }

  .\\32xl\\:-mx-224{
    margin-left: -56rem;
    margin-right: -56rem;
  }

  .\\32xl\\:-my-256{
    margin-top: -64rem;
    margin-bottom: -64rem;
  }

  .\\32xl\\:-mx-256{
    margin-left: -64rem;
    margin-right: -64rem;
  }

  .\\32xl\\:-my-px{
    margin-top: -1px;
    margin-bottom: -1px;
  }

  .\\32xl\\:-mx-px{
    margin-left: -1px;
    margin-right: -1px;
  }

  .\\32xl\\:mt-0{
    margin-top: 0;
  }

  .\\32xl\\:mr-0{
    margin-right: 0;
  }

  .\\32xl\\:mb-0{
    margin-bottom: 0;
  }

  .\\32xl\\:ml-0{
    margin-left: 0;
  }

  .\\32xl\\:mt-1{
    margin-top: 0.25rem;
  }

  .\\32xl\\:mr-1{
    margin-right: 0.25rem;
  }

  .\\32xl\\:mb-1{
    margin-bottom: 0.25rem;
  }

  .\\32xl\\:ml-1{
    margin-left: 0.25rem;
  }

  .\\32xl\\:mt-2{
    margin-top: 0.5rem;
  }

  .\\32xl\\:mr-2{
    margin-right: 0.5rem;
  }

  .\\32xl\\:mb-2{
    margin-bottom: 0.5rem;
  }

  .\\32xl\\:ml-2{
    margin-left: 0.5rem;
  }

  .\\32xl\\:mt-3{
    margin-top: 0.75rem;
  }

  .\\32xl\\:mr-3{
    margin-right: 0.75rem;
  }

  .\\32xl\\:mb-3{
    margin-bottom: 0.75rem;
  }

  .\\32xl\\:ml-3{
    margin-left: 0.75rem;
  }

  .\\32xl\\:mt-4{
    margin-top: 1rem;
  }

  .\\32xl\\:mr-4{
    margin-right: 1rem;
  }

  .\\32xl\\:mb-4{
    margin-bottom: 1rem;
  }

  .\\32xl\\:ml-4{
    margin-left: 1rem;
  }

  .\\32xl\\:mt-5{
    margin-top: 1.25rem;
  }

  .\\32xl\\:mr-5{
    margin-right: 1.25rem;
  }

  .\\32xl\\:mb-5{
    margin-bottom: 1.25rem;
  }

  .\\32xl\\:ml-5{
    margin-left: 1.25rem;
  }

  .\\32xl\\:mt-6{
    margin-top: 1.5rem;
  }

  .\\32xl\\:mr-6{
    margin-right: 1.5rem;
  }

  .\\32xl\\:mb-6{
    margin-bottom: 1.5rem;
  }

  .\\32xl\\:ml-6{
    margin-left: 1.5rem;
  }

  .\\32xl\\:mt-7{
    margin-top: 1.75rem;
  }

  .\\32xl\\:mr-7{
    margin-right: 1.75rem;
  }

  .\\32xl\\:mb-7{
    margin-bottom: 1.75rem;
  }

  .\\32xl\\:ml-7{
    margin-left: 1.75rem;
  }

  .\\32xl\\:mt-8{
    margin-top: 2rem;
  }

  .\\32xl\\:mr-8{
    margin-right: 2rem;
  }

  .\\32xl\\:mb-8{
    margin-bottom: 2rem;
  }

  .\\32xl\\:ml-8{
    margin-left: 2rem;
  }

  .\\32xl\\:mt-9{
    margin-top: 2.25rem;
  }

  .\\32xl\\:mr-9{
    margin-right: 2.25rem;
  }

  .\\32xl\\:mb-9{
    margin-bottom: 2.25rem;
  }

  .\\32xl\\:ml-9{
    margin-left: 2.25rem;
  }

  .\\32xl\\:mt-10{
    margin-top: 2.5rem;
  }

  .\\32xl\\:mr-10{
    margin-right: 2.5rem;
  }

  .\\32xl\\:mb-10{
    margin-bottom: 2.5rem;
  }

  .\\32xl\\:ml-10{
    margin-left: 2.5rem;
  }

  .\\32xl\\:mt-11{
    margin-top: 2.75rem;
  }

  .\\32xl\\:mr-11{
    margin-right: 2.75rem;
  }

  .\\32xl\\:mb-11{
    margin-bottom: 2.75rem;
  }

  .\\32xl\\:ml-11{
    margin-left: 2.75rem;
  }

  .\\32xl\\:mt-12{
    margin-top: 3rem;
  }

  .\\32xl\\:mr-12{
    margin-right: 3rem;
  }

  .\\32xl\\:mb-12{
    margin-bottom: 3rem;
  }

  .\\32xl\\:ml-12{
    margin-left: 3rem;
  }

  .\\32xl\\:mt-14{
    margin-top: 3.5rem;
  }

  .\\32xl\\:mr-14{
    margin-right: 3.5rem;
  }

  .\\32xl\\:mb-14{
    margin-bottom: 3.5rem;
  }

  .\\32xl\\:ml-14{
    margin-left: 3.5rem;
  }

  .\\32xl\\:mt-15{
    margin-top: 3.75rem;
  }

  .\\32xl\\:mr-15{
    margin-right: 3.75rem;
  }

  .\\32xl\\:mb-15{
    margin-bottom: 3.75rem;
  }

  .\\32xl\\:ml-15{
    margin-left: 3.75rem;
  }

  .\\32xl\\:mt-16{
    margin-top: 4rem;
  }

  .\\32xl\\:mr-16{
    margin-right: 4rem;
  }

  .\\32xl\\:mb-16{
    margin-bottom: 4rem;
  }

  .\\32xl\\:ml-16{
    margin-left: 4rem;
  }

  .\\32xl\\:mt-18{
    margin-top: 4.5rem;
  }

  .\\32xl\\:mr-18{
    margin-right: 4.5rem;
  }

  .\\32xl\\:mb-18{
    margin-bottom: 4.5rem;
  }

  .\\32xl\\:ml-18{
    margin-left: 4.5rem;
  }

  .\\32xl\\:mt-20{
    margin-top: 5rem;
  }

  .\\32xl\\:mr-20{
    margin-right: 5rem;
  }

  .\\32xl\\:mb-20{
    margin-bottom: 5rem;
  }

  .\\32xl\\:ml-20{
    margin-left: 5rem;
  }

  .\\32xl\\:mt-22{
    margin-top: 5.5rem;
  }

  .\\32xl\\:mr-22{
    margin-right: 5.5rem;
  }

  .\\32xl\\:mb-22{
    margin-bottom: 5.5rem;
  }

  .\\32xl\\:ml-22{
    margin-left: 5.5rem;
  }

  .\\32xl\\:mt-23{
    margin-top: 5.75rem;
  }

  .\\32xl\\:mr-23{
    margin-right: 5.75rem;
  }

  .\\32xl\\:mb-23{
    margin-bottom: 5.75rem;
  }

  .\\32xl\\:ml-23{
    margin-left: 5.75rem;
  }

  .\\32xl\\:mt-24{
    margin-top: 6rem;
  }

  .\\32xl\\:mr-24{
    margin-right: 6rem;
  }

  .\\32xl\\:mb-24{
    margin-bottom: 6rem;
  }

  .\\32xl\\:ml-24{
    margin-left: 6rem;
  }

  .\\32xl\\:mt-25{
    margin-top: 6.25rem;
  }

  .\\32xl\\:mr-25{
    margin-right: 6.25rem;
  }

  .\\32xl\\:mb-25{
    margin-bottom: 6.25rem;
  }

  .\\32xl\\:ml-25{
    margin-left: 6.25rem;
  }

  .\\32xl\\:mt-26{
    margin-top: 6.5rem;
  }

  .\\32xl\\:mr-26{
    margin-right: 6.5rem;
  }

  .\\32xl\\:mb-26{
    margin-bottom: 6.5rem;
  }

  .\\32xl\\:ml-26{
    margin-left: 6.5rem;
  }

  .\\32xl\\:mt-28{
    margin-top: 7rem;
  }

  .\\32xl\\:mr-28{
    margin-right: 7rem;
  }

  .\\32xl\\:mb-28{
    margin-bottom: 7rem;
  }

  .\\32xl\\:ml-28{
    margin-left: 7rem;
  }

  .\\32xl\\:mt-30{
    margin-top: 7.5rem;
  }

  .\\32xl\\:mr-30{
    margin-right: 7.5rem;
  }

  .\\32xl\\:mb-30{
    margin-bottom: 7.5rem;
  }

  .\\32xl\\:ml-30{
    margin-left: 7.5rem;
  }

  .\\32xl\\:mt-32{
    margin-top: 8rem;
  }

  .\\32xl\\:mr-32{
    margin-right: 8rem;
  }

  .\\32xl\\:mb-32{
    margin-bottom: 8rem;
  }

  .\\32xl\\:ml-32{
    margin-left: 8rem;
  }

  .\\32xl\\:mt-34{
    margin-top: 8.5rem;
  }

  .\\32xl\\:mr-34{
    margin-right: 8.5rem;
  }

  .\\32xl\\:mb-34{
    margin-bottom: 8.5rem;
  }

  .\\32xl\\:ml-34{
    margin-left: 8.5rem;
  }

  .\\32xl\\:mt-40{
    margin-top: 10rem;
  }

  .\\32xl\\:mr-40{
    margin-right: 10rem;
  }

  .\\32xl\\:mb-40{
    margin-bottom: 10rem;
  }

  .\\32xl\\:ml-40{
    margin-left: 10rem;
  }

  .\\32xl\\:mt-42{
    margin-top: 10.5rem;
  }

  .\\32xl\\:mr-42{
    margin-right: 10.5rem;
  }

  .\\32xl\\:mb-42{
    margin-bottom: 10.5rem;
  }

  .\\32xl\\:ml-42{
    margin-left: 10.5rem;
  }

  .\\32xl\\:mt-44{
    margin-top: 11rem;
  }

  .\\32xl\\:mr-44{
    margin-right: 11rem;
  }

  .\\32xl\\:mb-44{
    margin-bottom: 11rem;
  }

  .\\32xl\\:ml-44{
    margin-left: 11rem;
  }

  .\\32xl\\:mt-48{
    margin-top: 12rem;
  }

  .\\32xl\\:mr-48{
    margin-right: 12rem;
  }

  .\\32xl\\:mb-48{
    margin-bottom: 12rem;
  }

  .\\32xl\\:ml-48{
    margin-left: 12rem;
  }

  .\\32xl\\:mt-52{
    margin-top: 13rem;
  }

  .\\32xl\\:mr-52{
    margin-right: 13rem;
  }

  .\\32xl\\:mb-52{
    margin-bottom: 13rem;
  }

  .\\32xl\\:ml-52{
    margin-left: 13rem;
  }

  .\\32xl\\:mt-54{
    margin-top: 13.5rem;
  }

  .\\32xl\\:mr-54{
    margin-right: 13.5rem;
  }

  .\\32xl\\:mb-54{
    margin-bottom: 13.5rem;
  }

  .\\32xl\\:ml-54{
    margin-left: 13.5rem;
  }

  .\\32xl\\:mt-56{
    margin-top: 14rem;
  }

  .\\32xl\\:mr-56{
    margin-right: 14rem;
  }

  .\\32xl\\:mb-56{
    margin-bottom: 14rem;
  }

  .\\32xl\\:ml-56{
    margin-left: 14rem;
  }

  .\\32xl\\:mt-60{
    margin-top: 15rem;
  }

  .\\32xl\\:mr-60{
    margin-right: 15rem;
  }

  .\\32xl\\:mb-60{
    margin-bottom: 15rem;
  }

  .\\32xl\\:ml-60{
    margin-left: 15rem;
  }

  .\\32xl\\:mt-64{
    margin-top: 16rem;
  }

  .\\32xl\\:mr-64{
    margin-right: 16rem;
  }

  .\\32xl\\:mb-64{
    margin-bottom: 16rem;
  }

  .\\32xl\\:ml-64{
    margin-left: 16rem;
  }

  .\\32xl\\:mt-68{
    margin-top: 17rem;
  }

  .\\32xl\\:mr-68{
    margin-right: 17rem;
  }

  .\\32xl\\:mb-68{
    margin-bottom: 17rem;
  }

  .\\32xl\\:ml-68{
    margin-left: 17rem;
  }

  .\\32xl\\:mt-72{
    margin-top: 18rem;
  }

  .\\32xl\\:mr-72{
    margin-right: 18rem;
  }

  .\\32xl\\:mb-72{
    margin-bottom: 18rem;
  }

  .\\32xl\\:ml-72{
    margin-left: 18rem;
  }

  .\\32xl\\:mt-74{
    margin-top: 18.5rem;
  }

  .\\32xl\\:mr-74{
    margin-right: 18.5rem;
  }

  .\\32xl\\:mb-74{
    margin-bottom: 18.5rem;
  }

  .\\32xl\\:ml-74{
    margin-left: 18.5rem;
  }

  .\\32xl\\:mt-76{
    margin-top: 19rem;
  }

  .\\32xl\\:mr-76{
    margin-right: 19rem;
  }

  .\\32xl\\:mb-76{
    margin-bottom: 19rem;
  }

  .\\32xl\\:ml-76{
    margin-left: 19rem;
  }

  .\\32xl\\:mt-78{
    margin-top: 19.5rem;
  }

  .\\32xl\\:mr-78{
    margin-right: 19.5rem;
  }

  .\\32xl\\:mb-78{
    margin-bottom: 19.5rem;
  }

  .\\32xl\\:ml-78{
    margin-left: 19.5rem;
  }

  .\\32xl\\:mt-80{
    margin-top: 20rem;
  }

  .\\32xl\\:mr-80{
    margin-right: 20rem;
  }

  .\\32xl\\:mb-80{
    margin-bottom: 20rem;
  }

  .\\32xl\\:ml-80{
    margin-left: 20rem;
  }

  .\\32xl\\:mt-82{
    margin-top: 20.5rem;
  }

  .\\32xl\\:mr-82{
    margin-right: 20.5rem;
  }

  .\\32xl\\:mb-82{
    margin-bottom: 20.5rem;
  }

  .\\32xl\\:ml-82{
    margin-left: 20.5rem;
  }

  .\\32xl\\:mt-84{
    margin-top: 21rem;
  }

  .\\32xl\\:mr-84{
    margin-right: 21rem;
  }

  .\\32xl\\:mb-84{
    margin-bottom: 21rem;
  }

  .\\32xl\\:ml-84{
    margin-left: 21rem;
  }

  .\\32xl\\:mt-88{
    margin-top: 22rem;
  }

  .\\32xl\\:mr-88{
    margin-right: 22rem;
  }

  .\\32xl\\:mb-88{
    margin-bottom: 22rem;
  }

  .\\32xl\\:ml-88{
    margin-left: 22rem;
  }

  .\\32xl\\:mt-92{
    margin-top: 23rem;
  }

  .\\32xl\\:mr-92{
    margin-right: 23rem;
  }

  .\\32xl\\:mb-92{
    margin-bottom: 23rem;
  }

  .\\32xl\\:ml-92{
    margin-left: 23rem;
  }

  .\\32xl\\:mt-96{
    margin-top: 24rem;
  }

  .\\32xl\\:mr-96{
    margin-right: 24rem;
  }

  .\\32xl\\:mb-96{
    margin-bottom: 24rem;
  }

  .\\32xl\\:ml-96{
    margin-left: 24rem;
  }

  .\\32xl\\:mt-98{
    margin-top: 24.5rem;
  }

  .\\32xl\\:mr-98{
    margin-right: 24.5rem;
  }

  .\\32xl\\:mb-98{
    margin-bottom: 24.5rem;
  }

  .\\32xl\\:ml-98{
    margin-left: 24.5rem;
  }

  .\\32xl\\:mt-100{
    margin-top: 25rem;
  }

  .\\32xl\\:mr-100{
    margin-right: 25rem;
  }

  .\\32xl\\:mb-100{
    margin-bottom: 25rem;
  }

  .\\32xl\\:ml-100{
    margin-left: 25rem;
  }

  .\\32xl\\:mt-104{
    margin-top: 26rem;
  }

  .\\32xl\\:mr-104{
    margin-right: 26rem;
  }

  .\\32xl\\:mb-104{
    margin-bottom: 26rem;
  }

  .\\32xl\\:ml-104{
    margin-left: 26rem;
  }

  .\\32xl\\:mt-112{
    margin-top: 28rem;
  }

  .\\32xl\\:mr-112{
    margin-right: 28rem;
  }

  .\\32xl\\:mb-112{
    margin-bottom: 28rem;
  }

  .\\32xl\\:ml-112{
    margin-left: 28rem;
  }

  .\\32xl\\:mt-124{
    margin-top: 31rem;
  }

  .\\32xl\\:mr-124{
    margin-right: 31rem;
  }

  .\\32xl\\:mb-124{
    margin-bottom: 31rem;
  }

  .\\32xl\\:ml-124{
    margin-left: 31rem;
  }

  .\\32xl\\:mt-128{
    margin-top: 32rem;
  }

  .\\32xl\\:mr-128{
    margin-right: 32rem;
  }

  .\\32xl\\:mb-128{
    margin-bottom: 32rem;
  }

  .\\32xl\\:ml-128{
    margin-left: 32rem;
  }

  .\\32xl\\:mt-140{
    margin-top: 35rem;
  }

  .\\32xl\\:mr-140{
    margin-right: 35rem;
  }

  .\\32xl\\:mb-140{
    margin-bottom: 35rem;
  }

  .\\32xl\\:ml-140{
    margin-left: 35rem;
  }

  .\\32xl\\:mt-152{
    margin-top: 38rem;
  }

  .\\32xl\\:mr-152{
    margin-right: 38rem;
  }

  .\\32xl\\:mb-152{
    margin-bottom: 38rem;
  }

  .\\32xl\\:ml-152{
    margin-left: 38rem;
  }

  .\\32xl\\:mt-160{
    margin-top: 40rem;
  }

  .\\32xl\\:mr-160{
    margin-right: 40rem;
  }

  .\\32xl\\:mb-160{
    margin-bottom: 40rem;
  }

  .\\32xl\\:ml-160{
    margin-left: 40rem;
  }

  .\\32xl\\:mt-162{
    margin-top: 41rem;
  }

  .\\32xl\\:mr-162{
    margin-right: 41rem;
  }

  .\\32xl\\:mb-162{
    margin-bottom: 41rem;
  }

  .\\32xl\\:ml-162{
    margin-left: 41rem;
  }

  .\\32xl\\:mt-192{
    margin-top: 48rem;
  }

  .\\32xl\\:mr-192{
    margin-right: 48rem;
  }

  .\\32xl\\:mb-192{
    margin-bottom: 48rem;
  }

  .\\32xl\\:ml-192{
    margin-left: 48rem;
  }

  .\\32xl\\:mt-208{
    margin-top: 52rem;
  }

  .\\32xl\\:mr-208{
    margin-right: 52rem;
  }

  .\\32xl\\:mb-208{
    margin-bottom: 52rem;
  }

  .\\32xl\\:ml-208{
    margin-left: 52rem;
  }

  .\\32xl\\:mt-224{
    margin-top: 56rem;
  }

  .\\32xl\\:mr-224{
    margin-right: 56rem;
  }

  .\\32xl\\:mb-224{
    margin-bottom: 56rem;
  }

  .\\32xl\\:ml-224{
    margin-left: 56rem;
  }

  .\\32xl\\:mt-256{
    margin-top: 64rem;
  }

  .\\32xl\\:mr-256{
    margin-right: 64rem;
  }

  .\\32xl\\:mb-256{
    margin-bottom: 64rem;
  }

  .\\32xl\\:ml-256{
    margin-left: 64rem;
  }

  .\\32xl\\:mt-auto{
    margin-top: auto;
  }

  .\\32xl\\:mr-auto{
    margin-right: auto;
  }

  .\\32xl\\:mb-auto{
    margin-bottom: auto;
  }

  .\\32xl\\:ml-auto{
    margin-left: auto;
  }

  .\\32xl\\:mt-px{
    margin-top: 1px;
  }

  .\\32xl\\:mr-px{
    margin-right: 1px;
  }

  .\\32xl\\:mb-px{
    margin-bottom: 1px;
  }

  .\\32xl\\:ml-px{
    margin-left: 1px;
  }

  .\\32xl\\:-mt-1{
    margin-top: -0.25rem;
  }

  .\\32xl\\:-mr-1{
    margin-right: -0.25rem;
  }

  .\\32xl\\:-mb-1{
    margin-bottom: -0.25rem;
  }

  .\\32xl\\:-ml-1{
    margin-left: -0.25rem;
  }

  .\\32xl\\:-mt-2{
    margin-top: -0.5rem;
  }

  .\\32xl\\:-mr-2{
    margin-right: -0.5rem;
  }

  .\\32xl\\:-mb-2{
    margin-bottom: -0.5rem;
  }

  .\\32xl\\:-ml-2{
    margin-left: -0.5rem;
  }

  .\\32xl\\:-mt-3{
    margin-top: -0.75rem;
  }

  .\\32xl\\:-mr-3{
    margin-right: -0.75rem;
  }

  .\\32xl\\:-mb-3{
    margin-bottom: -0.75rem;
  }

  .\\32xl\\:-ml-3{
    margin-left: -0.75rem;
  }

  .\\32xl\\:-mt-4{
    margin-top: -1rem;
  }

  .\\32xl\\:-mr-4{
    margin-right: -1rem;
  }

  .\\32xl\\:-mb-4{
    margin-bottom: -1rem;
  }

  .\\32xl\\:-ml-4{
    margin-left: -1rem;
  }

  .\\32xl\\:-mt-5{
    margin-top: -1.25rem;
  }

  .\\32xl\\:-mr-5{
    margin-right: -1.25rem;
  }

  .\\32xl\\:-mb-5{
    margin-bottom: -1.25rem;
  }

  .\\32xl\\:-ml-5{
    margin-left: -1.25rem;
  }

  .\\32xl\\:-mt-6{
    margin-top: -1.5rem;
  }

  .\\32xl\\:-mr-6{
    margin-right: -1.5rem;
  }

  .\\32xl\\:-mb-6{
    margin-bottom: -1.5rem;
  }

  .\\32xl\\:-ml-6{
    margin-left: -1.5rem;
  }

  .\\32xl\\:-mt-7{
    margin-top: -1.75rem;
  }

  .\\32xl\\:-mr-7{
    margin-right: -1.75rem;
  }

  .\\32xl\\:-mb-7{
    margin-bottom: -1.75rem;
  }

  .\\32xl\\:-ml-7{
    margin-left: -1.75rem;
  }

  .\\32xl\\:-mt-8{
    margin-top: -2rem;
  }

  .\\32xl\\:-mr-8{
    margin-right: -2rem;
  }

  .\\32xl\\:-mb-8{
    margin-bottom: -2rem;
  }

  .\\32xl\\:-ml-8{
    margin-left: -2rem;
  }

  .\\32xl\\:-mt-9{
    margin-top: -2.25rem;
  }

  .\\32xl\\:-mr-9{
    margin-right: -2.25rem;
  }

  .\\32xl\\:-mb-9{
    margin-bottom: -2.25rem;
  }

  .\\32xl\\:-ml-9{
    margin-left: -2.25rem;
  }

  .\\32xl\\:-mt-10{
    margin-top: -2.5rem;
  }

  .\\32xl\\:-mr-10{
    margin-right: -2.5rem;
  }

  .\\32xl\\:-mb-10{
    margin-bottom: -2.5rem;
  }

  .\\32xl\\:-ml-10{
    margin-left: -2.5rem;
  }

  .\\32xl\\:-mt-11{
    margin-top: -2.75rem;
  }

  .\\32xl\\:-mr-11{
    margin-right: -2.75rem;
  }

  .\\32xl\\:-mb-11{
    margin-bottom: -2.75rem;
  }

  .\\32xl\\:-ml-11{
    margin-left: -2.75rem;
  }

  .\\32xl\\:-mt-12{
    margin-top: -3rem;
  }

  .\\32xl\\:-mr-12{
    margin-right: -3rem;
  }

  .\\32xl\\:-mb-12{
    margin-bottom: -3rem;
  }

  .\\32xl\\:-ml-12{
    margin-left: -3rem;
  }

  .\\32xl\\:-mt-14{
    margin-top: -3.5rem;
  }

  .\\32xl\\:-mr-14{
    margin-right: -3.5rem;
  }

  .\\32xl\\:-mb-14{
    margin-bottom: -3.5rem;
  }

  .\\32xl\\:-ml-14{
    margin-left: -3.5rem;
  }

  .\\32xl\\:-mt-15{
    margin-top: -3.75rem;
  }

  .\\32xl\\:-mr-15{
    margin-right: -3.75rem;
  }

  .\\32xl\\:-mb-15{
    margin-bottom: -3.75rem;
  }

  .\\32xl\\:-ml-15{
    margin-left: -3.75rem;
  }

  .\\32xl\\:-mt-16{
    margin-top: -4rem;
  }

  .\\32xl\\:-mr-16{
    margin-right: -4rem;
  }

  .\\32xl\\:-mb-16{
    margin-bottom: -4rem;
  }

  .\\32xl\\:-ml-16{
    margin-left: -4rem;
  }

  .\\32xl\\:-mt-18{
    margin-top: -4.5rem;
  }

  .\\32xl\\:-mr-18{
    margin-right: -4.5rem;
  }

  .\\32xl\\:-mb-18{
    margin-bottom: -4.5rem;
  }

  .\\32xl\\:-ml-18{
    margin-left: -4.5rem;
  }

  .\\32xl\\:-mt-20{
    margin-top: -5rem;
  }

  .\\32xl\\:-mr-20{
    margin-right: -5rem;
  }

  .\\32xl\\:-mb-20{
    margin-bottom: -5rem;
  }

  .\\32xl\\:-ml-20{
    margin-left: -5rem;
  }

  .\\32xl\\:-mt-22{
    margin-top: -5.5rem;
  }

  .\\32xl\\:-mr-22{
    margin-right: -5.5rem;
  }

  .\\32xl\\:-mb-22{
    margin-bottom: -5.5rem;
  }

  .\\32xl\\:-ml-22{
    margin-left: -5.5rem;
  }

  .\\32xl\\:-mt-23{
    margin-top: -5.75rem;
  }

  .\\32xl\\:-mr-23{
    margin-right: -5.75rem;
  }

  .\\32xl\\:-mb-23{
    margin-bottom: -5.75rem;
  }

  .\\32xl\\:-ml-23{
    margin-left: -5.75rem;
  }

  .\\32xl\\:-mt-24{
    margin-top: -6rem;
  }

  .\\32xl\\:-mr-24{
    margin-right: -6rem;
  }

  .\\32xl\\:-mb-24{
    margin-bottom: -6rem;
  }

  .\\32xl\\:-ml-24{
    margin-left: -6rem;
  }

  .\\32xl\\:-mt-25{
    margin-top: -6.25rem;
  }

  .\\32xl\\:-mr-25{
    margin-right: -6.25rem;
  }

  .\\32xl\\:-mb-25{
    margin-bottom: -6.25rem;
  }

  .\\32xl\\:-ml-25{
    margin-left: -6.25rem;
  }

  .\\32xl\\:-mt-26{
    margin-top: -6.5rem;
  }

  .\\32xl\\:-mr-26{
    margin-right: -6.5rem;
  }

  .\\32xl\\:-mb-26{
    margin-bottom: -6.5rem;
  }

  .\\32xl\\:-ml-26{
    margin-left: -6.5rem;
  }

  .\\32xl\\:-mt-28{
    margin-top: -7rem;
  }

  .\\32xl\\:-mr-28{
    margin-right: -7rem;
  }

  .\\32xl\\:-mb-28{
    margin-bottom: -7rem;
  }

  .\\32xl\\:-ml-28{
    margin-left: -7rem;
  }

  .\\32xl\\:-mt-30{
    margin-top: -7.5rem;
  }

  .\\32xl\\:-mr-30{
    margin-right: -7.5rem;
  }

  .\\32xl\\:-mb-30{
    margin-bottom: -7.5rem;
  }

  .\\32xl\\:-ml-30{
    margin-left: -7.5rem;
  }

  .\\32xl\\:-mt-32{
    margin-top: -8rem;
  }

  .\\32xl\\:-mr-32{
    margin-right: -8rem;
  }

  .\\32xl\\:-mb-32{
    margin-bottom: -8rem;
  }

  .\\32xl\\:-ml-32{
    margin-left: -8rem;
  }

  .\\32xl\\:-mt-34{
    margin-top: -8.5rem;
  }

  .\\32xl\\:-mr-34{
    margin-right: -8.5rem;
  }

  .\\32xl\\:-mb-34{
    margin-bottom: -8.5rem;
  }

  .\\32xl\\:-ml-34{
    margin-left: -8.5rem;
  }

  .\\32xl\\:-mt-40{
    margin-top: -10rem;
  }

  .\\32xl\\:-mr-40{
    margin-right: -10rem;
  }

  .\\32xl\\:-mb-40{
    margin-bottom: -10rem;
  }

  .\\32xl\\:-ml-40{
    margin-left: -10rem;
  }

  .\\32xl\\:-mt-42{
    margin-top: -10.5rem;
  }

  .\\32xl\\:-mr-42{
    margin-right: -10.5rem;
  }

  .\\32xl\\:-mb-42{
    margin-bottom: -10.5rem;
  }

  .\\32xl\\:-ml-42{
    margin-left: -10.5rem;
  }

  .\\32xl\\:-mt-44{
    margin-top: -11rem;
  }

  .\\32xl\\:-mr-44{
    margin-right: -11rem;
  }

  .\\32xl\\:-mb-44{
    margin-bottom: -11rem;
  }

  .\\32xl\\:-ml-44{
    margin-left: -11rem;
  }

  .\\32xl\\:-mt-48{
    margin-top: -12rem;
  }

  .\\32xl\\:-mr-48{
    margin-right: -12rem;
  }

  .\\32xl\\:-mb-48{
    margin-bottom: -12rem;
  }

  .\\32xl\\:-ml-48{
    margin-left: -12rem;
  }

  .\\32xl\\:-mt-52{
    margin-top: -13rem;
  }

  .\\32xl\\:-mr-52{
    margin-right: -13rem;
  }

  .\\32xl\\:-mb-52{
    margin-bottom: -13rem;
  }

  .\\32xl\\:-ml-52{
    margin-left: -13rem;
  }

  .\\32xl\\:-mt-54{
    margin-top: -13.5rem;
  }

  .\\32xl\\:-mr-54{
    margin-right: -13.5rem;
  }

  .\\32xl\\:-mb-54{
    margin-bottom: -13.5rem;
  }

  .\\32xl\\:-ml-54{
    margin-left: -13.5rem;
  }

  .\\32xl\\:-mt-56{
    margin-top: -14rem;
  }

  .\\32xl\\:-mr-56{
    margin-right: -14rem;
  }

  .\\32xl\\:-mb-56{
    margin-bottom: -14rem;
  }

  .\\32xl\\:-ml-56{
    margin-left: -14rem;
  }

  .\\32xl\\:-mt-60{
    margin-top: -15rem;
  }

  .\\32xl\\:-mr-60{
    margin-right: -15rem;
  }

  .\\32xl\\:-mb-60{
    margin-bottom: -15rem;
  }

  .\\32xl\\:-ml-60{
    margin-left: -15rem;
  }

  .\\32xl\\:-mt-64{
    margin-top: -16rem;
  }

  .\\32xl\\:-mr-64{
    margin-right: -16rem;
  }

  .\\32xl\\:-mb-64{
    margin-bottom: -16rem;
  }

  .\\32xl\\:-ml-64{
    margin-left: -16rem;
  }

  .\\32xl\\:-mt-68{
    margin-top: -17rem;
  }

  .\\32xl\\:-mr-68{
    margin-right: -17rem;
  }

  .\\32xl\\:-mb-68{
    margin-bottom: -17rem;
  }

  .\\32xl\\:-ml-68{
    margin-left: -17rem;
  }

  .\\32xl\\:-mt-72{
    margin-top: -18rem;
  }

  .\\32xl\\:-mr-72{
    margin-right: -18rem;
  }

  .\\32xl\\:-mb-72{
    margin-bottom: -18rem;
  }

  .\\32xl\\:-ml-72{
    margin-left: -18rem;
  }

  .\\32xl\\:-mt-74{
    margin-top: -18.5rem;
  }

  .\\32xl\\:-mr-74{
    margin-right: -18.5rem;
  }

  .\\32xl\\:-mb-74{
    margin-bottom: -18.5rem;
  }

  .\\32xl\\:-ml-74{
    margin-left: -18.5rem;
  }

  .\\32xl\\:-mt-76{
    margin-top: -19rem;
  }

  .\\32xl\\:-mr-76{
    margin-right: -19rem;
  }

  .\\32xl\\:-mb-76{
    margin-bottom: -19rem;
  }

  .\\32xl\\:-ml-76{
    margin-left: -19rem;
  }

  .\\32xl\\:-mt-78{
    margin-top: -19.5rem;
  }

  .\\32xl\\:-mr-78{
    margin-right: -19.5rem;
  }

  .\\32xl\\:-mb-78{
    margin-bottom: -19.5rem;
  }

  .\\32xl\\:-ml-78{
    margin-left: -19.5rem;
  }

  .\\32xl\\:-mt-80{
    margin-top: -20rem;
  }

  .\\32xl\\:-mr-80{
    margin-right: -20rem;
  }

  .\\32xl\\:-mb-80{
    margin-bottom: -20rem;
  }

  .\\32xl\\:-ml-80{
    margin-left: -20rem;
  }

  .\\32xl\\:-mt-82{
    margin-top: -20.5rem;
  }

  .\\32xl\\:-mr-82{
    margin-right: -20.5rem;
  }

  .\\32xl\\:-mb-82{
    margin-bottom: -20.5rem;
  }

  .\\32xl\\:-ml-82{
    margin-left: -20.5rem;
  }

  .\\32xl\\:-mt-84{
    margin-top: -21rem;
  }

  .\\32xl\\:-mr-84{
    margin-right: -21rem;
  }

  .\\32xl\\:-mb-84{
    margin-bottom: -21rem;
  }

  .\\32xl\\:-ml-84{
    margin-left: -21rem;
  }

  .\\32xl\\:-mt-88{
    margin-top: -22rem;
  }

  .\\32xl\\:-mr-88{
    margin-right: -22rem;
  }

  .\\32xl\\:-mb-88{
    margin-bottom: -22rem;
  }

  .\\32xl\\:-ml-88{
    margin-left: -22rem;
  }

  .\\32xl\\:-mt-92{
    margin-top: -23rem;
  }

  .\\32xl\\:-mr-92{
    margin-right: -23rem;
  }

  .\\32xl\\:-mb-92{
    margin-bottom: -23rem;
  }

  .\\32xl\\:-ml-92{
    margin-left: -23rem;
  }

  .\\32xl\\:-mt-96{
    margin-top: -24rem;
  }

  .\\32xl\\:-mr-96{
    margin-right: -24rem;
  }

  .\\32xl\\:-mb-96{
    margin-bottom: -24rem;
  }

  .\\32xl\\:-ml-96{
    margin-left: -24rem;
  }

  .\\32xl\\:-mt-98{
    margin-top: -24.5rem;
  }

  .\\32xl\\:-mr-98{
    margin-right: -24.5rem;
  }

  .\\32xl\\:-mb-98{
    margin-bottom: -24.5rem;
  }

  .\\32xl\\:-ml-98{
    margin-left: -24.5rem;
  }

  .\\32xl\\:-mt-100{
    margin-top: -25rem;
  }

  .\\32xl\\:-mr-100{
    margin-right: -25rem;
  }

  .\\32xl\\:-mb-100{
    margin-bottom: -25rem;
  }

  .\\32xl\\:-ml-100{
    margin-left: -25rem;
  }

  .\\32xl\\:-mt-104{
    margin-top: -26rem;
  }

  .\\32xl\\:-mr-104{
    margin-right: -26rem;
  }

  .\\32xl\\:-mb-104{
    margin-bottom: -26rem;
  }

  .\\32xl\\:-ml-104{
    margin-left: -26rem;
  }

  .\\32xl\\:-mt-112{
    margin-top: -28rem;
  }

  .\\32xl\\:-mr-112{
    margin-right: -28rem;
  }

  .\\32xl\\:-mb-112{
    margin-bottom: -28rem;
  }

  .\\32xl\\:-ml-112{
    margin-left: -28rem;
  }

  .\\32xl\\:-mt-124{
    margin-top: -31rem;
  }

  .\\32xl\\:-mr-124{
    margin-right: -31rem;
  }

  .\\32xl\\:-mb-124{
    margin-bottom: -31rem;
  }

  .\\32xl\\:-ml-124{
    margin-left: -31rem;
  }

  .\\32xl\\:-mt-128{
    margin-top: -32rem;
  }

  .\\32xl\\:-mr-128{
    margin-right: -32rem;
  }

  .\\32xl\\:-mb-128{
    margin-bottom: -32rem;
  }

  .\\32xl\\:-ml-128{
    margin-left: -32rem;
  }

  .\\32xl\\:-mt-140{
    margin-top: -35rem;
  }

  .\\32xl\\:-mr-140{
    margin-right: -35rem;
  }

  .\\32xl\\:-mb-140{
    margin-bottom: -35rem;
  }

  .\\32xl\\:-ml-140{
    margin-left: -35rem;
  }

  .\\32xl\\:-mt-152{
    margin-top: -38rem;
  }

  .\\32xl\\:-mr-152{
    margin-right: -38rem;
  }

  .\\32xl\\:-mb-152{
    margin-bottom: -38rem;
  }

  .\\32xl\\:-ml-152{
    margin-left: -38rem;
  }

  .\\32xl\\:-mt-160{
    margin-top: -40rem;
  }

  .\\32xl\\:-mr-160{
    margin-right: -40rem;
  }

  .\\32xl\\:-mb-160{
    margin-bottom: -40rem;
  }

  .\\32xl\\:-ml-160{
    margin-left: -40rem;
  }

  .\\32xl\\:-mt-162{
    margin-top: -41rem;
  }

  .\\32xl\\:-mr-162{
    margin-right: -41rem;
  }

  .\\32xl\\:-mb-162{
    margin-bottom: -41rem;
  }

  .\\32xl\\:-ml-162{
    margin-left: -41rem;
  }

  .\\32xl\\:-mt-192{
    margin-top: -48rem;
  }

  .\\32xl\\:-mr-192{
    margin-right: -48rem;
  }

  .\\32xl\\:-mb-192{
    margin-bottom: -48rem;
  }

  .\\32xl\\:-ml-192{
    margin-left: -48rem;
  }

  .\\32xl\\:-mt-208{
    margin-top: -52rem;
  }

  .\\32xl\\:-mr-208{
    margin-right: -52rem;
  }

  .\\32xl\\:-mb-208{
    margin-bottom: -52rem;
  }

  .\\32xl\\:-ml-208{
    margin-left: -52rem;
  }

  .\\32xl\\:-mt-224{
    margin-top: -56rem;
  }

  .\\32xl\\:-mr-224{
    margin-right: -56rem;
  }

  .\\32xl\\:-mb-224{
    margin-bottom: -56rem;
  }

  .\\32xl\\:-ml-224{
    margin-left: -56rem;
  }

  .\\32xl\\:-mt-256{
    margin-top: -64rem;
  }

  .\\32xl\\:-mr-256{
    margin-right: -64rem;
  }

  .\\32xl\\:-mb-256{
    margin-bottom: -64rem;
  }

  .\\32xl\\:-ml-256{
    margin-left: -64rem;
  }

  .\\32xl\\:-mt-px{
    margin-top: -1px;
  }

  .\\32xl\\:-mr-px{
    margin-right: -1px;
  }

  .\\32xl\\:-mb-px{
    margin-bottom: -1px;
  }

  .\\32xl\\:-ml-px{
    margin-left: -1px;
  }

  .\\32xl\\:first\\:m-0:first-child{
    margin: 0;
  }

  .\\32xl\\:first\\:m-1:first-child{
    margin: 0.25rem;
  }

  .\\32xl\\:first\\:m-2:first-child{
    margin: 0.5rem;
  }

  .\\32xl\\:first\\:m-3:first-child{
    margin: 0.75rem;
  }

  .\\32xl\\:first\\:m-4:first-child{
    margin: 1rem;
  }

  .\\32xl\\:first\\:m-5:first-child{
    margin: 1.25rem;
  }

  .\\32xl\\:first\\:m-6:first-child{
    margin: 1.5rem;
  }

  .\\32xl\\:first\\:m-7:first-child{
    margin: 1.75rem;
  }

  .\\32xl\\:first\\:m-8:first-child{
    margin: 2rem;
  }

  .\\32xl\\:first\\:m-9:first-child{
    margin: 2.25rem;
  }

  .\\32xl\\:first\\:m-10:first-child{
    margin: 2.5rem;
  }

  .\\32xl\\:first\\:m-11:first-child{
    margin: 2.75rem;
  }

  .\\32xl\\:first\\:m-12:first-child{
    margin: 3rem;
  }

  .\\32xl\\:first\\:m-14:first-child{
    margin: 3.5rem;
  }

  .\\32xl\\:first\\:m-15:first-child{
    margin: 3.75rem;
  }

  .\\32xl\\:first\\:m-16:first-child{
    margin: 4rem;
  }

  .\\32xl\\:first\\:m-18:first-child{
    margin: 4.5rem;
  }

  .\\32xl\\:first\\:m-20:first-child{
    margin: 5rem;
  }

  .\\32xl\\:first\\:m-22:first-child{
    margin: 5.5rem;
  }

  .\\32xl\\:first\\:m-23:first-child{
    margin: 5.75rem;
  }

  .\\32xl\\:first\\:m-24:first-child{
    margin: 6rem;
  }

  .\\32xl\\:first\\:m-25:first-child{
    margin: 6.25rem;
  }

  .\\32xl\\:first\\:m-26:first-child{
    margin: 6.5rem;
  }

  .\\32xl\\:first\\:m-28:first-child{
    margin: 7rem;
  }

  .\\32xl\\:first\\:m-30:first-child{
    margin: 7.5rem;
  }

  .\\32xl\\:first\\:m-32:first-child{
    margin: 8rem;
  }

  .\\32xl\\:first\\:m-34:first-child{
    margin: 8.5rem;
  }

  .\\32xl\\:first\\:m-40:first-child{
    margin: 10rem;
  }

  .\\32xl\\:first\\:m-42:first-child{
    margin: 10.5rem;
  }

  .\\32xl\\:first\\:m-44:first-child{
    margin: 11rem;
  }

  .\\32xl\\:first\\:m-48:first-child{
    margin: 12rem;
  }

  .\\32xl\\:first\\:m-52:first-child{
    margin: 13rem;
  }

  .\\32xl\\:first\\:m-54:first-child{
    margin: 13.5rem;
  }

  .\\32xl\\:first\\:m-56:first-child{
    margin: 14rem;
  }

  .\\32xl\\:first\\:m-60:first-child{
    margin: 15rem;
  }

  .\\32xl\\:first\\:m-64:first-child{
    margin: 16rem;
  }

  .\\32xl\\:first\\:m-68:first-child{
    margin: 17rem;
  }

  .\\32xl\\:first\\:m-72:first-child{
    margin: 18rem;
  }

  .\\32xl\\:first\\:m-74:first-child{
    margin: 18.5rem;
  }

  .\\32xl\\:first\\:m-76:first-child{
    margin: 19rem;
  }

  .\\32xl\\:first\\:m-78:first-child{
    margin: 19.5rem;
  }

  .\\32xl\\:first\\:m-80:first-child{
    margin: 20rem;
  }

  .\\32xl\\:first\\:m-82:first-child{
    margin: 20.5rem;
  }

  .\\32xl\\:first\\:m-84:first-child{
    margin: 21rem;
  }

  .\\32xl\\:first\\:m-88:first-child{
    margin: 22rem;
  }

  .\\32xl\\:first\\:m-92:first-child{
    margin: 23rem;
  }

  .\\32xl\\:first\\:m-96:first-child{
    margin: 24rem;
  }

  .\\32xl\\:first\\:m-98:first-child{
    margin: 24.5rem;
  }

  .\\32xl\\:first\\:m-100:first-child{
    margin: 25rem;
  }

  .\\32xl\\:first\\:m-104:first-child{
    margin: 26rem;
  }

  .\\32xl\\:first\\:m-112:first-child{
    margin: 28rem;
  }

  .\\32xl\\:first\\:m-124:first-child{
    margin: 31rem;
  }

  .\\32xl\\:first\\:m-128:first-child{
    margin: 32rem;
  }

  .\\32xl\\:first\\:m-140:first-child{
    margin: 35rem;
  }

  .\\32xl\\:first\\:m-152:first-child{
    margin: 38rem;
  }

  .\\32xl\\:first\\:m-160:first-child{
    margin: 40rem;
  }

  .\\32xl\\:first\\:m-162:first-child{
    margin: 41rem;
  }

  .\\32xl\\:first\\:m-192:first-child{
    margin: 48rem;
  }

  .\\32xl\\:first\\:m-208:first-child{
    margin: 52rem;
  }

  .\\32xl\\:first\\:m-224:first-child{
    margin: 56rem;
  }

  .\\32xl\\:first\\:m-256:first-child{
    margin: 64rem;
  }

  .\\32xl\\:first\\:m-auto:first-child{
    margin: auto;
  }

  .\\32xl\\:first\\:m-px:first-child{
    margin: 1px;
  }

  .\\32xl\\:first\\:-m-1:first-child{
    margin: -0.25rem;
  }

  .\\32xl\\:first\\:-m-2:first-child{
    margin: -0.5rem;
  }

  .\\32xl\\:first\\:-m-3:first-child{
    margin: -0.75rem;
  }

  .\\32xl\\:first\\:-m-4:first-child{
    margin: -1rem;
  }

  .\\32xl\\:first\\:-m-5:first-child{
    margin: -1.25rem;
  }

  .\\32xl\\:first\\:-m-6:first-child{
    margin: -1.5rem;
  }

  .\\32xl\\:first\\:-m-7:first-child{
    margin: -1.75rem;
  }

  .\\32xl\\:first\\:-m-8:first-child{
    margin: -2rem;
  }

  .\\32xl\\:first\\:-m-9:first-child{
    margin: -2.25rem;
  }

  .\\32xl\\:first\\:-m-10:first-child{
    margin: -2.5rem;
  }

  .\\32xl\\:first\\:-m-11:first-child{
    margin: -2.75rem;
  }

  .\\32xl\\:first\\:-m-12:first-child{
    margin: -3rem;
  }

  .\\32xl\\:first\\:-m-14:first-child{
    margin: -3.5rem;
  }

  .\\32xl\\:first\\:-m-15:first-child{
    margin: -3.75rem;
  }

  .\\32xl\\:first\\:-m-16:first-child{
    margin: -4rem;
  }

  .\\32xl\\:first\\:-m-18:first-child{
    margin: -4.5rem;
  }

  .\\32xl\\:first\\:-m-20:first-child{
    margin: -5rem;
  }

  .\\32xl\\:first\\:-m-22:first-child{
    margin: -5.5rem;
  }

  .\\32xl\\:first\\:-m-23:first-child{
    margin: -5.75rem;
  }

  .\\32xl\\:first\\:-m-24:first-child{
    margin: -6rem;
  }

  .\\32xl\\:first\\:-m-25:first-child{
    margin: -6.25rem;
  }

  .\\32xl\\:first\\:-m-26:first-child{
    margin: -6.5rem;
  }

  .\\32xl\\:first\\:-m-28:first-child{
    margin: -7rem;
  }

  .\\32xl\\:first\\:-m-30:first-child{
    margin: -7.5rem;
  }

  .\\32xl\\:first\\:-m-32:first-child{
    margin: -8rem;
  }

  .\\32xl\\:first\\:-m-34:first-child{
    margin: -8.5rem;
  }

  .\\32xl\\:first\\:-m-40:first-child{
    margin: -10rem;
  }

  .\\32xl\\:first\\:-m-42:first-child{
    margin: -10.5rem;
  }

  .\\32xl\\:first\\:-m-44:first-child{
    margin: -11rem;
  }

  .\\32xl\\:first\\:-m-48:first-child{
    margin: -12rem;
  }

  .\\32xl\\:first\\:-m-52:first-child{
    margin: -13rem;
  }

  .\\32xl\\:first\\:-m-54:first-child{
    margin: -13.5rem;
  }

  .\\32xl\\:first\\:-m-56:first-child{
    margin: -14rem;
  }

  .\\32xl\\:first\\:-m-60:first-child{
    margin: -15rem;
  }

  .\\32xl\\:first\\:-m-64:first-child{
    margin: -16rem;
  }

  .\\32xl\\:first\\:-m-68:first-child{
    margin: -17rem;
  }

  .\\32xl\\:first\\:-m-72:first-child{
    margin: -18rem;
  }

  .\\32xl\\:first\\:-m-74:first-child{
    margin: -18.5rem;
  }

  .\\32xl\\:first\\:-m-76:first-child{
    margin: -19rem;
  }

  .\\32xl\\:first\\:-m-78:first-child{
    margin: -19.5rem;
  }

  .\\32xl\\:first\\:-m-80:first-child{
    margin: -20rem;
  }

  .\\32xl\\:first\\:-m-82:first-child{
    margin: -20.5rem;
  }

  .\\32xl\\:first\\:-m-84:first-child{
    margin: -21rem;
  }

  .\\32xl\\:first\\:-m-88:first-child{
    margin: -22rem;
  }

  .\\32xl\\:first\\:-m-92:first-child{
    margin: -23rem;
  }

  .\\32xl\\:first\\:-m-96:first-child{
    margin: -24rem;
  }

  .\\32xl\\:first\\:-m-98:first-child{
    margin: -24.5rem;
  }

  .\\32xl\\:first\\:-m-100:first-child{
    margin: -25rem;
  }

  .\\32xl\\:first\\:-m-104:first-child{
    margin: -26rem;
  }

  .\\32xl\\:first\\:-m-112:first-child{
    margin: -28rem;
  }

  .\\32xl\\:first\\:-m-124:first-child{
    margin: -31rem;
  }

  .\\32xl\\:first\\:-m-128:first-child{
    margin: -32rem;
  }

  .\\32xl\\:first\\:-m-140:first-child{
    margin: -35rem;
  }

  .\\32xl\\:first\\:-m-152:first-child{
    margin: -38rem;
  }

  .\\32xl\\:first\\:-m-160:first-child{
    margin: -40rem;
  }

  .\\32xl\\:first\\:-m-162:first-child{
    margin: -41rem;
  }

  .\\32xl\\:first\\:-m-192:first-child{
    margin: -48rem;
  }

  .\\32xl\\:first\\:-m-208:first-child{
    margin: -52rem;
  }

  .\\32xl\\:first\\:-m-224:first-child{
    margin: -56rem;
  }

  .\\32xl\\:first\\:-m-256:first-child{
    margin: -64rem;
  }

  .\\32xl\\:first\\:-m-px:first-child{
    margin: -1px;
  }

  .\\32xl\\:first\\:my-0:first-child{
    margin-top: 0;
    margin-bottom: 0;
  }

  .\\32xl\\:first\\:mx-0:first-child{
    margin-left: 0;
    margin-right: 0;
  }

  .\\32xl\\:first\\:my-1:first-child{
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .\\32xl\\:first\\:mx-1:first-child{
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .\\32xl\\:first\\:my-2:first-child{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .\\32xl\\:first\\:mx-2:first-child{
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .\\32xl\\:first\\:my-3:first-child{
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .\\32xl\\:first\\:mx-3:first-child{
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .\\32xl\\:first\\:my-4:first-child{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .\\32xl\\:first\\:mx-4:first-child{
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .\\32xl\\:first\\:my-5:first-child{
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .\\32xl\\:first\\:mx-5:first-child{
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .\\32xl\\:first\\:my-6:first-child{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .\\32xl\\:first\\:mx-6:first-child{
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .\\32xl\\:first\\:my-7:first-child{
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }

  .\\32xl\\:first\\:mx-7:first-child{
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }

  .\\32xl\\:first\\:my-8:first-child{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .\\32xl\\:first\\:mx-8:first-child{
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .\\32xl\\:first\\:my-9:first-child{
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }

  .\\32xl\\:first\\:mx-9:first-child{
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }

  .\\32xl\\:first\\:my-10:first-child{
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .\\32xl\\:first\\:mx-10:first-child{
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .\\32xl\\:first\\:my-11:first-child{
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;
  }

  .\\32xl\\:first\\:mx-11:first-child{
    margin-left: 2.75rem;
    margin-right: 2.75rem;
  }

  .\\32xl\\:first\\:my-12:first-child{
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .\\32xl\\:first\\:mx-12:first-child{
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .\\32xl\\:first\\:my-14:first-child{
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
  }

  .\\32xl\\:first\\:mx-14:first-child{
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }

  .\\32xl\\:first\\:my-15:first-child{
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
  }

  .\\32xl\\:first\\:mx-15:first-child{
    margin-left: 3.75rem;
    margin-right: 3.75rem;
  }

  .\\32xl\\:first\\:my-16:first-child{
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .\\32xl\\:first\\:mx-16:first-child{
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .\\32xl\\:first\\:my-18:first-child{
    margin-top: 4.5rem;
    margin-bottom: 4.5rem;
  }

  .\\32xl\\:first\\:mx-18:first-child{
    margin-left: 4.5rem;
    margin-right: 4.5rem;
  }

  .\\32xl\\:first\\:my-20:first-child{
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .\\32xl\\:first\\:mx-20:first-child{
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .\\32xl\\:first\\:my-22:first-child{
    margin-top: 5.5rem;
    margin-bottom: 5.5rem;
  }

  .\\32xl\\:first\\:mx-22:first-child{
    margin-left: 5.5rem;
    margin-right: 5.5rem;
  }

  .\\32xl\\:first\\:my-23:first-child{
    margin-top: 5.75rem;
    margin-bottom: 5.75rem;
  }

  .\\32xl\\:first\\:mx-23:first-child{
    margin-left: 5.75rem;
    margin-right: 5.75rem;
  }

  .\\32xl\\:first\\:my-24:first-child{
    margin-top: 6rem;
    margin-bottom: 6rem;
  }

  .\\32xl\\:first\\:mx-24:first-child{
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .\\32xl\\:first\\:my-25:first-child{
    margin-top: 6.25rem;
    margin-bottom: 6.25rem;
  }

  .\\32xl\\:first\\:mx-25:first-child{
    margin-left: 6.25rem;
    margin-right: 6.25rem;
  }

  .\\32xl\\:first\\:my-26:first-child{
    margin-top: 6.5rem;
    margin-bottom: 6.5rem;
  }

  .\\32xl\\:first\\:mx-26:first-child{
    margin-left: 6.5rem;
    margin-right: 6.5rem;
  }

  .\\32xl\\:first\\:my-28:first-child{
    margin-top: 7rem;
    margin-bottom: 7rem;
  }

  .\\32xl\\:first\\:mx-28:first-child{
    margin-left: 7rem;
    margin-right: 7rem;
  }

  .\\32xl\\:first\\:my-30:first-child{
    margin-top: 7.5rem;
    margin-bottom: 7.5rem;
  }

  .\\32xl\\:first\\:mx-30:first-child{
    margin-left: 7.5rem;
    margin-right: 7.5rem;
  }

  .\\32xl\\:first\\:my-32:first-child{
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  .\\32xl\\:first\\:mx-32:first-child{
    margin-left: 8rem;
    margin-right: 8rem;
  }

  .\\32xl\\:first\\:my-34:first-child{
    margin-top: 8.5rem;
    margin-bottom: 8.5rem;
  }

  .\\32xl\\:first\\:mx-34:first-child{
    margin-left: 8.5rem;
    margin-right: 8.5rem;
  }

  .\\32xl\\:first\\:my-40:first-child{
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .\\32xl\\:first\\:mx-40:first-child{
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .\\32xl\\:first\\:my-42:first-child{
    margin-top: 10.5rem;
    margin-bottom: 10.5rem;
  }

  .\\32xl\\:first\\:mx-42:first-child{
    margin-left: 10.5rem;
    margin-right: 10.5rem;
  }

  .\\32xl\\:first\\:my-44:first-child{
    margin-top: 11rem;
    margin-bottom: 11rem;
  }

  .\\32xl\\:first\\:mx-44:first-child{
    margin-left: 11rem;
    margin-right: 11rem;
  }

  .\\32xl\\:first\\:my-48:first-child{
    margin-top: 12rem;
    margin-bottom: 12rem;
  }

  .\\32xl\\:first\\:mx-48:first-child{
    margin-left: 12rem;
    margin-right: 12rem;
  }

  .\\32xl\\:first\\:my-52:first-child{
    margin-top: 13rem;
    margin-bottom: 13rem;
  }

  .\\32xl\\:first\\:mx-52:first-child{
    margin-left: 13rem;
    margin-right: 13rem;
  }

  .\\32xl\\:first\\:my-54:first-child{
    margin-top: 13.5rem;
    margin-bottom: 13.5rem;
  }

  .\\32xl\\:first\\:mx-54:first-child{
    margin-left: 13.5rem;
    margin-right: 13.5rem;
  }

  .\\32xl\\:first\\:my-56:first-child{
    margin-top: 14rem;
    margin-bottom: 14rem;
  }

  .\\32xl\\:first\\:mx-56:first-child{
    margin-left: 14rem;
    margin-right: 14rem;
  }

  .\\32xl\\:first\\:my-60:first-child{
    margin-top: 15rem;
    margin-bottom: 15rem;
  }

  .\\32xl\\:first\\:mx-60:first-child{
    margin-left: 15rem;
    margin-right: 15rem;
  }

  .\\32xl\\:first\\:my-64:first-child{
    margin-top: 16rem;
    margin-bottom: 16rem;
  }

  .\\32xl\\:first\\:mx-64:first-child{
    margin-left: 16rem;
    margin-right: 16rem;
  }

  .\\32xl\\:first\\:my-68:first-child{
    margin-top: 17rem;
    margin-bottom: 17rem;
  }

  .\\32xl\\:first\\:mx-68:first-child{
    margin-left: 17rem;
    margin-right: 17rem;
  }

  .\\32xl\\:first\\:my-72:first-child{
    margin-top: 18rem;
    margin-bottom: 18rem;
  }

  .\\32xl\\:first\\:mx-72:first-child{
    margin-left: 18rem;
    margin-right: 18rem;
  }

  .\\32xl\\:first\\:my-74:first-child{
    margin-top: 18.5rem;
    margin-bottom: 18.5rem;
  }

  .\\32xl\\:first\\:mx-74:first-child{
    margin-left: 18.5rem;
    margin-right: 18.5rem;
  }

  .\\32xl\\:first\\:my-76:first-child{
    margin-top: 19rem;
    margin-bottom: 19rem;
  }

  .\\32xl\\:first\\:mx-76:first-child{
    margin-left: 19rem;
    margin-right: 19rem;
  }

  .\\32xl\\:first\\:my-78:first-child{
    margin-top: 19.5rem;
    margin-bottom: 19.5rem;
  }

  .\\32xl\\:first\\:mx-78:first-child{
    margin-left: 19.5rem;
    margin-right: 19.5rem;
  }

  .\\32xl\\:first\\:my-80:first-child{
    margin-top: 20rem;
    margin-bottom: 20rem;
  }

  .\\32xl\\:first\\:mx-80:first-child{
    margin-left: 20rem;
    margin-right: 20rem;
  }

  .\\32xl\\:first\\:my-82:first-child{
    margin-top: 20.5rem;
    margin-bottom: 20.5rem;
  }

  .\\32xl\\:first\\:mx-82:first-child{
    margin-left: 20.5rem;
    margin-right: 20.5rem;
  }

  .\\32xl\\:first\\:my-84:first-child{
    margin-top: 21rem;
    margin-bottom: 21rem;
  }

  .\\32xl\\:first\\:mx-84:first-child{
    margin-left: 21rem;
    margin-right: 21rem;
  }

  .\\32xl\\:first\\:my-88:first-child{
    margin-top: 22rem;
    margin-bottom: 22rem;
  }

  .\\32xl\\:first\\:mx-88:first-child{
    margin-left: 22rem;
    margin-right: 22rem;
  }

  .\\32xl\\:first\\:my-92:first-child{
    margin-top: 23rem;
    margin-bottom: 23rem;
  }

  .\\32xl\\:first\\:mx-92:first-child{
    margin-left: 23rem;
    margin-right: 23rem;
  }

  .\\32xl\\:first\\:my-96:first-child{
    margin-top: 24rem;
    margin-bottom: 24rem;
  }

  .\\32xl\\:first\\:mx-96:first-child{
    margin-left: 24rem;
    margin-right: 24rem;
  }

  .\\32xl\\:first\\:my-98:first-child{
    margin-top: 24.5rem;
    margin-bottom: 24.5rem;
  }

  .\\32xl\\:first\\:mx-98:first-child{
    margin-left: 24.5rem;
    margin-right: 24.5rem;
  }

  .\\32xl\\:first\\:my-100:first-child{
    margin-top: 25rem;
    margin-bottom: 25rem;
  }

  .\\32xl\\:first\\:mx-100:first-child{
    margin-left: 25rem;
    margin-right: 25rem;
  }

  .\\32xl\\:first\\:my-104:first-child{
    margin-top: 26rem;
    margin-bottom: 26rem;
  }

  .\\32xl\\:first\\:mx-104:first-child{
    margin-left: 26rem;
    margin-right: 26rem;
  }

  .\\32xl\\:first\\:my-112:first-child{
    margin-top: 28rem;
    margin-bottom: 28rem;
  }

  .\\32xl\\:first\\:mx-112:first-child{
    margin-left: 28rem;
    margin-right: 28rem;
  }

  .\\32xl\\:first\\:my-124:first-child{
    margin-top: 31rem;
    margin-bottom: 31rem;
  }

  .\\32xl\\:first\\:mx-124:first-child{
    margin-left: 31rem;
    margin-right: 31rem;
  }

  .\\32xl\\:first\\:my-128:first-child{
    margin-top: 32rem;
    margin-bottom: 32rem;
  }

  .\\32xl\\:first\\:mx-128:first-child{
    margin-left: 32rem;
    margin-right: 32rem;
  }

  .\\32xl\\:first\\:my-140:first-child{
    margin-top: 35rem;
    margin-bottom: 35rem;
  }

  .\\32xl\\:first\\:mx-140:first-child{
    margin-left: 35rem;
    margin-right: 35rem;
  }

  .\\32xl\\:first\\:my-152:first-child{
    margin-top: 38rem;
    margin-bottom: 38rem;
  }

  .\\32xl\\:first\\:mx-152:first-child{
    margin-left: 38rem;
    margin-right: 38rem;
  }

  .\\32xl\\:first\\:my-160:first-child{
    margin-top: 40rem;
    margin-bottom: 40rem;
  }

  .\\32xl\\:first\\:mx-160:first-child{
    margin-left: 40rem;
    margin-right: 40rem;
  }

  .\\32xl\\:first\\:my-162:first-child{
    margin-top: 41rem;
    margin-bottom: 41rem;
  }

  .\\32xl\\:first\\:mx-162:first-child{
    margin-left: 41rem;
    margin-right: 41rem;
  }

  .\\32xl\\:first\\:my-192:first-child{
    margin-top: 48rem;
    margin-bottom: 48rem;
  }

  .\\32xl\\:first\\:mx-192:first-child{
    margin-left: 48rem;
    margin-right: 48rem;
  }

  .\\32xl\\:first\\:my-208:first-child{
    margin-top: 52rem;
    margin-bottom: 52rem;
  }

  .\\32xl\\:first\\:mx-208:first-child{
    margin-left: 52rem;
    margin-right: 52rem;
  }

  .\\32xl\\:first\\:my-224:first-child{
    margin-top: 56rem;
    margin-bottom: 56rem;
  }

  .\\32xl\\:first\\:mx-224:first-child{
    margin-left: 56rem;
    margin-right: 56rem;
  }

  .\\32xl\\:first\\:my-256:first-child{
    margin-top: 64rem;
    margin-bottom: 64rem;
  }

  .\\32xl\\:first\\:mx-256:first-child{
    margin-left: 64rem;
    margin-right: 64rem;
  }

  .\\32xl\\:first\\:my-auto:first-child{
    margin-top: auto;
    margin-bottom: auto;
  }

  .\\32xl\\:first\\:mx-auto:first-child{
    margin-left: auto;
    margin-right: auto;
  }

  .\\32xl\\:first\\:my-px:first-child{
    margin-top: 1px;
    margin-bottom: 1px;
  }

  .\\32xl\\:first\\:mx-px:first-child{
    margin-left: 1px;
    margin-right: 1px;
  }

  .\\32xl\\:first\\:-my-1:first-child{
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .\\32xl\\:first\\:-mx-1:first-child{
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .\\32xl\\:first\\:-my-2:first-child{
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }

  .\\32xl\\:first\\:-mx-2:first-child{
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .\\32xl\\:first\\:-my-3:first-child{
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }

  .\\32xl\\:first\\:-mx-3:first-child{
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .\\32xl\\:first\\:-my-4:first-child{
    margin-top: -1rem;
    margin-bottom: -1rem;
  }

  .\\32xl\\:first\\:-mx-4:first-child{
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .\\32xl\\:first\\:-my-5:first-child{
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }

  .\\32xl\\:first\\:-mx-5:first-child{
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .\\32xl\\:first\\:-my-6:first-child{
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }

  .\\32xl\\:first\\:-mx-6:first-child{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .\\32xl\\:first\\:-my-7:first-child{
    margin-top: -1.75rem;
    margin-bottom: -1.75rem;
  }

  .\\32xl\\:first\\:-mx-7:first-child{
    margin-left: -1.75rem;
    margin-right: -1.75rem;
  }

  .\\32xl\\:first\\:-my-8:first-child{
    margin-top: -2rem;
    margin-bottom: -2rem;
  }

  .\\32xl\\:first\\:-mx-8:first-child{
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .\\32xl\\:first\\:-my-9:first-child{
    margin-top: -2.25rem;
    margin-bottom: -2.25rem;
  }

  .\\32xl\\:first\\:-mx-9:first-child{
    margin-left: -2.25rem;
    margin-right: -2.25rem;
  }

  .\\32xl\\:first\\:-my-10:first-child{
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }

  .\\32xl\\:first\\:-mx-10:first-child{
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .\\32xl\\:first\\:-my-11:first-child{
    margin-top: -2.75rem;
    margin-bottom: -2.75rem;
  }

  .\\32xl\\:first\\:-mx-11:first-child{
    margin-left: -2.75rem;
    margin-right: -2.75rem;
  }

  .\\32xl\\:first\\:-my-12:first-child{
    margin-top: -3rem;
    margin-bottom: -3rem;
  }

  .\\32xl\\:first\\:-mx-12:first-child{
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .\\32xl\\:first\\:-my-14:first-child{
    margin-top: -3.5rem;
    margin-bottom: -3.5rem;
  }

  .\\32xl\\:first\\:-mx-14:first-child{
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }

  .\\32xl\\:first\\:-my-15:first-child{
    margin-top: -3.75rem;
    margin-bottom: -3.75rem;
  }

  .\\32xl\\:first\\:-mx-15:first-child{
    margin-left: -3.75rem;
    margin-right: -3.75rem;
  }

  .\\32xl\\:first\\:-my-16:first-child{
    margin-top: -4rem;
    margin-bottom: -4rem;
  }

  .\\32xl\\:first\\:-mx-16:first-child{
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .\\32xl\\:first\\:-my-18:first-child{
    margin-top: -4.5rem;
    margin-bottom: -4.5rem;
  }

  .\\32xl\\:first\\:-mx-18:first-child{
    margin-left: -4.5rem;
    margin-right: -4.5rem;
  }

  .\\32xl\\:first\\:-my-20:first-child{
    margin-top: -5rem;
    margin-bottom: -5rem;
  }

  .\\32xl\\:first\\:-mx-20:first-child{
    margin-left: -5rem;
    margin-right: -5rem;
  }

  .\\32xl\\:first\\:-my-22:first-child{
    margin-top: -5.5rem;
    margin-bottom: -5.5rem;
  }

  .\\32xl\\:first\\:-mx-22:first-child{
    margin-left: -5.5rem;
    margin-right: -5.5rem;
  }

  .\\32xl\\:first\\:-my-23:first-child{
    margin-top: -5.75rem;
    margin-bottom: -5.75rem;
  }

  .\\32xl\\:first\\:-mx-23:first-child{
    margin-left: -5.75rem;
    margin-right: -5.75rem;
  }

  .\\32xl\\:first\\:-my-24:first-child{
    margin-top: -6rem;
    margin-bottom: -6rem;
  }

  .\\32xl\\:first\\:-mx-24:first-child{
    margin-left: -6rem;
    margin-right: -6rem;
  }

  .\\32xl\\:first\\:-my-25:first-child{
    margin-top: -6.25rem;
    margin-bottom: -6.25rem;
  }

  .\\32xl\\:first\\:-mx-25:first-child{
    margin-left: -6.25rem;
    margin-right: -6.25rem;
  }

  .\\32xl\\:first\\:-my-26:first-child{
    margin-top: -6.5rem;
    margin-bottom: -6.5rem;
  }

  .\\32xl\\:first\\:-mx-26:first-child{
    margin-left: -6.5rem;
    margin-right: -6.5rem;
  }

  .\\32xl\\:first\\:-my-28:first-child{
    margin-top: -7rem;
    margin-bottom: -7rem;
  }

  .\\32xl\\:first\\:-mx-28:first-child{
    margin-left: -7rem;
    margin-right: -7rem;
  }

  .\\32xl\\:first\\:-my-30:first-child{
    margin-top: -7.5rem;
    margin-bottom: -7.5rem;
  }

  .\\32xl\\:first\\:-mx-30:first-child{
    margin-left: -7.5rem;
    margin-right: -7.5rem;
  }

  .\\32xl\\:first\\:-my-32:first-child{
    margin-top: -8rem;
    margin-bottom: -8rem;
  }

  .\\32xl\\:first\\:-mx-32:first-child{
    margin-left: -8rem;
    margin-right: -8rem;
  }

  .\\32xl\\:first\\:-my-34:first-child{
    margin-top: -8.5rem;
    margin-bottom: -8.5rem;
  }

  .\\32xl\\:first\\:-mx-34:first-child{
    margin-left: -8.5rem;
    margin-right: -8.5rem;
  }

  .\\32xl\\:first\\:-my-40:first-child{
    margin-top: -10rem;
    margin-bottom: -10rem;
  }

  .\\32xl\\:first\\:-mx-40:first-child{
    margin-left: -10rem;
    margin-right: -10rem;
  }

  .\\32xl\\:first\\:-my-42:first-child{
    margin-top: -10.5rem;
    margin-bottom: -10.5rem;
  }

  .\\32xl\\:first\\:-mx-42:first-child{
    margin-left: -10.5rem;
    margin-right: -10.5rem;
  }

  .\\32xl\\:first\\:-my-44:first-child{
    margin-top: -11rem;
    margin-bottom: -11rem;
  }

  .\\32xl\\:first\\:-mx-44:first-child{
    margin-left: -11rem;
    margin-right: -11rem;
  }

  .\\32xl\\:first\\:-my-48:first-child{
    margin-top: -12rem;
    margin-bottom: -12rem;
  }

  .\\32xl\\:first\\:-mx-48:first-child{
    margin-left: -12rem;
    margin-right: -12rem;
  }

  .\\32xl\\:first\\:-my-52:first-child{
    margin-top: -13rem;
    margin-bottom: -13rem;
  }

  .\\32xl\\:first\\:-mx-52:first-child{
    margin-left: -13rem;
    margin-right: -13rem;
  }

  .\\32xl\\:first\\:-my-54:first-child{
    margin-top: -13.5rem;
    margin-bottom: -13.5rem;
  }

  .\\32xl\\:first\\:-mx-54:first-child{
    margin-left: -13.5rem;
    margin-right: -13.5rem;
  }

  .\\32xl\\:first\\:-my-56:first-child{
    margin-top: -14rem;
    margin-bottom: -14rem;
  }

  .\\32xl\\:first\\:-mx-56:first-child{
    margin-left: -14rem;
    margin-right: -14rem;
  }

  .\\32xl\\:first\\:-my-60:first-child{
    margin-top: -15rem;
    margin-bottom: -15rem;
  }

  .\\32xl\\:first\\:-mx-60:first-child{
    margin-left: -15rem;
    margin-right: -15rem;
  }

  .\\32xl\\:first\\:-my-64:first-child{
    margin-top: -16rem;
    margin-bottom: -16rem;
  }

  .\\32xl\\:first\\:-mx-64:first-child{
    margin-left: -16rem;
    margin-right: -16rem;
  }

  .\\32xl\\:first\\:-my-68:first-child{
    margin-top: -17rem;
    margin-bottom: -17rem;
  }

  .\\32xl\\:first\\:-mx-68:first-child{
    margin-left: -17rem;
    margin-right: -17rem;
  }

  .\\32xl\\:first\\:-my-72:first-child{
    margin-top: -18rem;
    margin-bottom: -18rem;
  }

  .\\32xl\\:first\\:-mx-72:first-child{
    margin-left: -18rem;
    margin-right: -18rem;
  }

  .\\32xl\\:first\\:-my-74:first-child{
    margin-top: -18.5rem;
    margin-bottom: -18.5rem;
  }

  .\\32xl\\:first\\:-mx-74:first-child{
    margin-left: -18.5rem;
    margin-right: -18.5rem;
  }

  .\\32xl\\:first\\:-my-76:first-child{
    margin-top: -19rem;
    margin-bottom: -19rem;
  }

  .\\32xl\\:first\\:-mx-76:first-child{
    margin-left: -19rem;
    margin-right: -19rem;
  }

  .\\32xl\\:first\\:-my-78:first-child{
    margin-top: -19.5rem;
    margin-bottom: -19.5rem;
  }

  .\\32xl\\:first\\:-mx-78:first-child{
    margin-left: -19.5rem;
    margin-right: -19.5rem;
  }

  .\\32xl\\:first\\:-my-80:first-child{
    margin-top: -20rem;
    margin-bottom: -20rem;
  }

  .\\32xl\\:first\\:-mx-80:first-child{
    margin-left: -20rem;
    margin-right: -20rem;
  }

  .\\32xl\\:first\\:-my-82:first-child{
    margin-top: -20.5rem;
    margin-bottom: -20.5rem;
  }

  .\\32xl\\:first\\:-mx-82:first-child{
    margin-left: -20.5rem;
    margin-right: -20.5rem;
  }

  .\\32xl\\:first\\:-my-84:first-child{
    margin-top: -21rem;
    margin-bottom: -21rem;
  }

  .\\32xl\\:first\\:-mx-84:first-child{
    margin-left: -21rem;
    margin-right: -21rem;
  }

  .\\32xl\\:first\\:-my-88:first-child{
    margin-top: -22rem;
    margin-bottom: -22rem;
  }

  .\\32xl\\:first\\:-mx-88:first-child{
    margin-left: -22rem;
    margin-right: -22rem;
  }

  .\\32xl\\:first\\:-my-92:first-child{
    margin-top: -23rem;
    margin-bottom: -23rem;
  }

  .\\32xl\\:first\\:-mx-92:first-child{
    margin-left: -23rem;
    margin-right: -23rem;
  }

  .\\32xl\\:first\\:-my-96:first-child{
    margin-top: -24rem;
    margin-bottom: -24rem;
  }

  .\\32xl\\:first\\:-mx-96:first-child{
    margin-left: -24rem;
    margin-right: -24rem;
  }

  .\\32xl\\:first\\:-my-98:first-child{
    margin-top: -24.5rem;
    margin-bottom: -24.5rem;
  }

  .\\32xl\\:first\\:-mx-98:first-child{
    margin-left: -24.5rem;
    margin-right: -24.5rem;
  }

  .\\32xl\\:first\\:-my-100:first-child{
    margin-top: -25rem;
    margin-bottom: -25rem;
  }

  .\\32xl\\:first\\:-mx-100:first-child{
    margin-left: -25rem;
    margin-right: -25rem;
  }

  .\\32xl\\:first\\:-my-104:first-child{
    margin-top: -26rem;
    margin-bottom: -26rem;
  }

  .\\32xl\\:first\\:-mx-104:first-child{
    margin-left: -26rem;
    margin-right: -26rem;
  }

  .\\32xl\\:first\\:-my-112:first-child{
    margin-top: -28rem;
    margin-bottom: -28rem;
  }

  .\\32xl\\:first\\:-mx-112:first-child{
    margin-left: -28rem;
    margin-right: -28rem;
  }

  .\\32xl\\:first\\:-my-124:first-child{
    margin-top: -31rem;
    margin-bottom: -31rem;
  }

  .\\32xl\\:first\\:-mx-124:first-child{
    margin-left: -31rem;
    margin-right: -31rem;
  }

  .\\32xl\\:first\\:-my-128:first-child{
    margin-top: -32rem;
    margin-bottom: -32rem;
  }

  .\\32xl\\:first\\:-mx-128:first-child{
    margin-left: -32rem;
    margin-right: -32rem;
  }

  .\\32xl\\:first\\:-my-140:first-child{
    margin-top: -35rem;
    margin-bottom: -35rem;
  }

  .\\32xl\\:first\\:-mx-140:first-child{
    margin-left: -35rem;
    margin-right: -35rem;
  }

  .\\32xl\\:first\\:-my-152:first-child{
    margin-top: -38rem;
    margin-bottom: -38rem;
  }

  .\\32xl\\:first\\:-mx-152:first-child{
    margin-left: -38rem;
    margin-right: -38rem;
  }

  .\\32xl\\:first\\:-my-160:first-child{
    margin-top: -40rem;
    margin-bottom: -40rem;
  }

  .\\32xl\\:first\\:-mx-160:first-child{
    margin-left: -40rem;
    margin-right: -40rem;
  }

  .\\32xl\\:first\\:-my-162:first-child{
    margin-top: -41rem;
    margin-bottom: -41rem;
  }

  .\\32xl\\:first\\:-mx-162:first-child{
    margin-left: -41rem;
    margin-right: -41rem;
  }

  .\\32xl\\:first\\:-my-192:first-child{
    margin-top: -48rem;
    margin-bottom: -48rem;
  }

  .\\32xl\\:first\\:-mx-192:first-child{
    margin-left: -48rem;
    margin-right: -48rem;
  }

  .\\32xl\\:first\\:-my-208:first-child{
    margin-top: -52rem;
    margin-bottom: -52rem;
  }

  .\\32xl\\:first\\:-mx-208:first-child{
    margin-left: -52rem;
    margin-right: -52rem;
  }

  .\\32xl\\:first\\:-my-224:first-child{
    margin-top: -56rem;
    margin-bottom: -56rem;
  }

  .\\32xl\\:first\\:-mx-224:first-child{
    margin-left: -56rem;
    margin-right: -56rem;
  }

  .\\32xl\\:first\\:-my-256:first-child{
    margin-top: -64rem;
    margin-bottom: -64rem;
  }

  .\\32xl\\:first\\:-mx-256:first-child{
    margin-left: -64rem;
    margin-right: -64rem;
  }

  .\\32xl\\:first\\:-my-px:first-child{
    margin-top: -1px;
    margin-bottom: -1px;
  }

  .\\32xl\\:first\\:-mx-px:first-child{
    margin-left: -1px;
    margin-right: -1px;
  }

  .\\32xl\\:first\\:mt-0:first-child{
    margin-top: 0;
  }

  .\\32xl\\:first\\:mr-0:first-child{
    margin-right: 0;
  }

  .\\32xl\\:first\\:mb-0:first-child{
    margin-bottom: 0;
  }

  .\\32xl\\:first\\:ml-0:first-child{
    margin-left: 0;
  }

  .\\32xl\\:first\\:mt-1:first-child{
    margin-top: 0.25rem;
  }

  .\\32xl\\:first\\:mr-1:first-child{
    margin-right: 0.25rem;
  }

  .\\32xl\\:first\\:mb-1:first-child{
    margin-bottom: 0.25rem;
  }

  .\\32xl\\:first\\:ml-1:first-child{
    margin-left: 0.25rem;
  }

  .\\32xl\\:first\\:mt-2:first-child{
    margin-top: 0.5rem;
  }

  .\\32xl\\:first\\:mr-2:first-child{
    margin-right: 0.5rem;
  }

  .\\32xl\\:first\\:mb-2:first-child{
    margin-bottom: 0.5rem;
  }

  .\\32xl\\:first\\:ml-2:first-child{
    margin-left: 0.5rem;
  }

  .\\32xl\\:first\\:mt-3:first-child{
    margin-top: 0.75rem;
  }

  .\\32xl\\:first\\:mr-3:first-child{
    margin-right: 0.75rem;
  }

  .\\32xl\\:first\\:mb-3:first-child{
    margin-bottom: 0.75rem;
  }

  .\\32xl\\:first\\:ml-3:first-child{
    margin-left: 0.75rem;
  }

  .\\32xl\\:first\\:mt-4:first-child{
    margin-top: 1rem;
  }

  .\\32xl\\:first\\:mr-4:first-child{
    margin-right: 1rem;
  }

  .\\32xl\\:first\\:mb-4:first-child{
    margin-bottom: 1rem;
  }

  .\\32xl\\:first\\:ml-4:first-child{
    margin-left: 1rem;
  }

  .\\32xl\\:first\\:mt-5:first-child{
    margin-top: 1.25rem;
  }

  .\\32xl\\:first\\:mr-5:first-child{
    margin-right: 1.25rem;
  }

  .\\32xl\\:first\\:mb-5:first-child{
    margin-bottom: 1.25rem;
  }

  .\\32xl\\:first\\:ml-5:first-child{
    margin-left: 1.25rem;
  }

  .\\32xl\\:first\\:mt-6:first-child{
    margin-top: 1.5rem;
  }

  .\\32xl\\:first\\:mr-6:first-child{
    margin-right: 1.5rem;
  }

  .\\32xl\\:first\\:mb-6:first-child{
    margin-bottom: 1.5rem;
  }

  .\\32xl\\:first\\:ml-6:first-child{
    margin-left: 1.5rem;
  }

  .\\32xl\\:first\\:mt-7:first-child{
    margin-top: 1.75rem;
  }

  .\\32xl\\:first\\:mr-7:first-child{
    margin-right: 1.75rem;
  }

  .\\32xl\\:first\\:mb-7:first-child{
    margin-bottom: 1.75rem;
  }

  .\\32xl\\:first\\:ml-7:first-child{
    margin-left: 1.75rem;
  }

  .\\32xl\\:first\\:mt-8:first-child{
    margin-top: 2rem;
  }

  .\\32xl\\:first\\:mr-8:first-child{
    margin-right: 2rem;
  }

  .\\32xl\\:first\\:mb-8:first-child{
    margin-bottom: 2rem;
  }

  .\\32xl\\:first\\:ml-8:first-child{
    margin-left: 2rem;
  }

  .\\32xl\\:first\\:mt-9:first-child{
    margin-top: 2.25rem;
  }

  .\\32xl\\:first\\:mr-9:first-child{
    margin-right: 2.25rem;
  }

  .\\32xl\\:first\\:mb-9:first-child{
    margin-bottom: 2.25rem;
  }

  .\\32xl\\:first\\:ml-9:first-child{
    margin-left: 2.25rem;
  }

  .\\32xl\\:first\\:mt-10:first-child{
    margin-top: 2.5rem;
  }

  .\\32xl\\:first\\:mr-10:first-child{
    margin-right: 2.5rem;
  }

  .\\32xl\\:first\\:mb-10:first-child{
    margin-bottom: 2.5rem;
  }

  .\\32xl\\:first\\:ml-10:first-child{
    margin-left: 2.5rem;
  }

  .\\32xl\\:first\\:mt-11:first-child{
    margin-top: 2.75rem;
  }

  .\\32xl\\:first\\:mr-11:first-child{
    margin-right: 2.75rem;
  }

  .\\32xl\\:first\\:mb-11:first-child{
    margin-bottom: 2.75rem;
  }

  .\\32xl\\:first\\:ml-11:first-child{
    margin-left: 2.75rem;
  }

  .\\32xl\\:first\\:mt-12:first-child{
    margin-top: 3rem;
  }

  .\\32xl\\:first\\:mr-12:first-child{
    margin-right: 3rem;
  }

  .\\32xl\\:first\\:mb-12:first-child{
    margin-bottom: 3rem;
  }

  .\\32xl\\:first\\:ml-12:first-child{
    margin-left: 3rem;
  }

  .\\32xl\\:first\\:mt-14:first-child{
    margin-top: 3.5rem;
  }

  .\\32xl\\:first\\:mr-14:first-child{
    margin-right: 3.5rem;
  }

  .\\32xl\\:first\\:mb-14:first-child{
    margin-bottom: 3.5rem;
  }

  .\\32xl\\:first\\:ml-14:first-child{
    margin-left: 3.5rem;
  }

  .\\32xl\\:first\\:mt-15:first-child{
    margin-top: 3.75rem;
  }

  .\\32xl\\:first\\:mr-15:first-child{
    margin-right: 3.75rem;
  }

  .\\32xl\\:first\\:mb-15:first-child{
    margin-bottom: 3.75rem;
  }

  .\\32xl\\:first\\:ml-15:first-child{
    margin-left: 3.75rem;
  }

  .\\32xl\\:first\\:mt-16:first-child{
    margin-top: 4rem;
  }

  .\\32xl\\:first\\:mr-16:first-child{
    margin-right: 4rem;
  }

  .\\32xl\\:first\\:mb-16:first-child{
    margin-bottom: 4rem;
  }

  .\\32xl\\:first\\:ml-16:first-child{
    margin-left: 4rem;
  }

  .\\32xl\\:first\\:mt-18:first-child{
    margin-top: 4.5rem;
  }

  .\\32xl\\:first\\:mr-18:first-child{
    margin-right: 4.5rem;
  }

  .\\32xl\\:first\\:mb-18:first-child{
    margin-bottom: 4.5rem;
  }

  .\\32xl\\:first\\:ml-18:first-child{
    margin-left: 4.5rem;
  }

  .\\32xl\\:first\\:mt-20:first-child{
    margin-top: 5rem;
  }

  .\\32xl\\:first\\:mr-20:first-child{
    margin-right: 5rem;
  }

  .\\32xl\\:first\\:mb-20:first-child{
    margin-bottom: 5rem;
  }

  .\\32xl\\:first\\:ml-20:first-child{
    margin-left: 5rem;
  }

  .\\32xl\\:first\\:mt-22:first-child{
    margin-top: 5.5rem;
  }

  .\\32xl\\:first\\:mr-22:first-child{
    margin-right: 5.5rem;
  }

  .\\32xl\\:first\\:mb-22:first-child{
    margin-bottom: 5.5rem;
  }

  .\\32xl\\:first\\:ml-22:first-child{
    margin-left: 5.5rem;
  }

  .\\32xl\\:first\\:mt-23:first-child{
    margin-top: 5.75rem;
  }

  .\\32xl\\:first\\:mr-23:first-child{
    margin-right: 5.75rem;
  }

  .\\32xl\\:first\\:mb-23:first-child{
    margin-bottom: 5.75rem;
  }

  .\\32xl\\:first\\:ml-23:first-child{
    margin-left: 5.75rem;
  }

  .\\32xl\\:first\\:mt-24:first-child{
    margin-top: 6rem;
  }

  .\\32xl\\:first\\:mr-24:first-child{
    margin-right: 6rem;
  }

  .\\32xl\\:first\\:mb-24:first-child{
    margin-bottom: 6rem;
  }

  .\\32xl\\:first\\:ml-24:first-child{
    margin-left: 6rem;
  }

  .\\32xl\\:first\\:mt-25:first-child{
    margin-top: 6.25rem;
  }

  .\\32xl\\:first\\:mr-25:first-child{
    margin-right: 6.25rem;
  }

  .\\32xl\\:first\\:mb-25:first-child{
    margin-bottom: 6.25rem;
  }

  .\\32xl\\:first\\:ml-25:first-child{
    margin-left: 6.25rem;
  }

  .\\32xl\\:first\\:mt-26:first-child{
    margin-top: 6.5rem;
  }

  .\\32xl\\:first\\:mr-26:first-child{
    margin-right: 6.5rem;
  }

  .\\32xl\\:first\\:mb-26:first-child{
    margin-bottom: 6.5rem;
  }

  .\\32xl\\:first\\:ml-26:first-child{
    margin-left: 6.5rem;
  }

  .\\32xl\\:first\\:mt-28:first-child{
    margin-top: 7rem;
  }

  .\\32xl\\:first\\:mr-28:first-child{
    margin-right: 7rem;
  }

  .\\32xl\\:first\\:mb-28:first-child{
    margin-bottom: 7rem;
  }

  .\\32xl\\:first\\:ml-28:first-child{
    margin-left: 7rem;
  }

  .\\32xl\\:first\\:mt-30:first-child{
    margin-top: 7.5rem;
  }

  .\\32xl\\:first\\:mr-30:first-child{
    margin-right: 7.5rem;
  }

  .\\32xl\\:first\\:mb-30:first-child{
    margin-bottom: 7.5rem;
  }

  .\\32xl\\:first\\:ml-30:first-child{
    margin-left: 7.5rem;
  }

  .\\32xl\\:first\\:mt-32:first-child{
    margin-top: 8rem;
  }

  .\\32xl\\:first\\:mr-32:first-child{
    margin-right: 8rem;
  }

  .\\32xl\\:first\\:mb-32:first-child{
    margin-bottom: 8rem;
  }

  .\\32xl\\:first\\:ml-32:first-child{
    margin-left: 8rem;
  }

  .\\32xl\\:first\\:mt-34:first-child{
    margin-top: 8.5rem;
  }

  .\\32xl\\:first\\:mr-34:first-child{
    margin-right: 8.5rem;
  }

  .\\32xl\\:first\\:mb-34:first-child{
    margin-bottom: 8.5rem;
  }

  .\\32xl\\:first\\:ml-34:first-child{
    margin-left: 8.5rem;
  }

  .\\32xl\\:first\\:mt-40:first-child{
    margin-top: 10rem;
  }

  .\\32xl\\:first\\:mr-40:first-child{
    margin-right: 10rem;
  }

  .\\32xl\\:first\\:mb-40:first-child{
    margin-bottom: 10rem;
  }

  .\\32xl\\:first\\:ml-40:first-child{
    margin-left: 10rem;
  }

  .\\32xl\\:first\\:mt-42:first-child{
    margin-top: 10.5rem;
  }

  .\\32xl\\:first\\:mr-42:first-child{
    margin-right: 10.5rem;
  }

  .\\32xl\\:first\\:mb-42:first-child{
    margin-bottom: 10.5rem;
  }

  .\\32xl\\:first\\:ml-42:first-child{
    margin-left: 10.5rem;
  }

  .\\32xl\\:first\\:mt-44:first-child{
    margin-top: 11rem;
  }

  .\\32xl\\:first\\:mr-44:first-child{
    margin-right: 11rem;
  }

  .\\32xl\\:first\\:mb-44:first-child{
    margin-bottom: 11rem;
  }

  .\\32xl\\:first\\:ml-44:first-child{
    margin-left: 11rem;
  }

  .\\32xl\\:first\\:mt-48:first-child{
    margin-top: 12rem;
  }

  .\\32xl\\:first\\:mr-48:first-child{
    margin-right: 12rem;
  }

  .\\32xl\\:first\\:mb-48:first-child{
    margin-bottom: 12rem;
  }

  .\\32xl\\:first\\:ml-48:first-child{
    margin-left: 12rem;
  }

  .\\32xl\\:first\\:mt-52:first-child{
    margin-top: 13rem;
  }

  .\\32xl\\:first\\:mr-52:first-child{
    margin-right: 13rem;
  }

  .\\32xl\\:first\\:mb-52:first-child{
    margin-bottom: 13rem;
  }

  .\\32xl\\:first\\:ml-52:first-child{
    margin-left: 13rem;
  }

  .\\32xl\\:first\\:mt-54:first-child{
    margin-top: 13.5rem;
  }

  .\\32xl\\:first\\:mr-54:first-child{
    margin-right: 13.5rem;
  }

  .\\32xl\\:first\\:mb-54:first-child{
    margin-bottom: 13.5rem;
  }

  .\\32xl\\:first\\:ml-54:first-child{
    margin-left: 13.5rem;
  }

  .\\32xl\\:first\\:mt-56:first-child{
    margin-top: 14rem;
  }

  .\\32xl\\:first\\:mr-56:first-child{
    margin-right: 14rem;
  }

  .\\32xl\\:first\\:mb-56:first-child{
    margin-bottom: 14rem;
  }

  .\\32xl\\:first\\:ml-56:first-child{
    margin-left: 14rem;
  }

  .\\32xl\\:first\\:mt-60:first-child{
    margin-top: 15rem;
  }

  .\\32xl\\:first\\:mr-60:first-child{
    margin-right: 15rem;
  }

  .\\32xl\\:first\\:mb-60:first-child{
    margin-bottom: 15rem;
  }

  .\\32xl\\:first\\:ml-60:first-child{
    margin-left: 15rem;
  }

  .\\32xl\\:first\\:mt-64:first-child{
    margin-top: 16rem;
  }

  .\\32xl\\:first\\:mr-64:first-child{
    margin-right: 16rem;
  }

  .\\32xl\\:first\\:mb-64:first-child{
    margin-bottom: 16rem;
  }

  .\\32xl\\:first\\:ml-64:first-child{
    margin-left: 16rem;
  }

  .\\32xl\\:first\\:mt-68:first-child{
    margin-top: 17rem;
  }

  .\\32xl\\:first\\:mr-68:first-child{
    margin-right: 17rem;
  }

  .\\32xl\\:first\\:mb-68:first-child{
    margin-bottom: 17rem;
  }

  .\\32xl\\:first\\:ml-68:first-child{
    margin-left: 17rem;
  }

  .\\32xl\\:first\\:mt-72:first-child{
    margin-top: 18rem;
  }

  .\\32xl\\:first\\:mr-72:first-child{
    margin-right: 18rem;
  }

  .\\32xl\\:first\\:mb-72:first-child{
    margin-bottom: 18rem;
  }

  .\\32xl\\:first\\:ml-72:first-child{
    margin-left: 18rem;
  }

  .\\32xl\\:first\\:mt-74:first-child{
    margin-top: 18.5rem;
  }

  .\\32xl\\:first\\:mr-74:first-child{
    margin-right: 18.5rem;
  }

  .\\32xl\\:first\\:mb-74:first-child{
    margin-bottom: 18.5rem;
  }

  .\\32xl\\:first\\:ml-74:first-child{
    margin-left: 18.5rem;
  }

  .\\32xl\\:first\\:mt-76:first-child{
    margin-top: 19rem;
  }

  .\\32xl\\:first\\:mr-76:first-child{
    margin-right: 19rem;
  }

  .\\32xl\\:first\\:mb-76:first-child{
    margin-bottom: 19rem;
  }

  .\\32xl\\:first\\:ml-76:first-child{
    margin-left: 19rem;
  }

  .\\32xl\\:first\\:mt-78:first-child{
    margin-top: 19.5rem;
  }

  .\\32xl\\:first\\:mr-78:first-child{
    margin-right: 19.5rem;
  }

  .\\32xl\\:first\\:mb-78:first-child{
    margin-bottom: 19.5rem;
  }

  .\\32xl\\:first\\:ml-78:first-child{
    margin-left: 19.5rem;
  }

  .\\32xl\\:first\\:mt-80:first-child{
    margin-top: 20rem;
  }

  .\\32xl\\:first\\:mr-80:first-child{
    margin-right: 20rem;
  }

  .\\32xl\\:first\\:mb-80:first-child{
    margin-bottom: 20rem;
  }

  .\\32xl\\:first\\:ml-80:first-child{
    margin-left: 20rem;
  }

  .\\32xl\\:first\\:mt-82:first-child{
    margin-top: 20.5rem;
  }

  .\\32xl\\:first\\:mr-82:first-child{
    margin-right: 20.5rem;
  }

  .\\32xl\\:first\\:mb-82:first-child{
    margin-bottom: 20.5rem;
  }

  .\\32xl\\:first\\:ml-82:first-child{
    margin-left: 20.5rem;
  }

  .\\32xl\\:first\\:mt-84:first-child{
    margin-top: 21rem;
  }

  .\\32xl\\:first\\:mr-84:first-child{
    margin-right: 21rem;
  }

  .\\32xl\\:first\\:mb-84:first-child{
    margin-bottom: 21rem;
  }

  .\\32xl\\:first\\:ml-84:first-child{
    margin-left: 21rem;
  }

  .\\32xl\\:first\\:mt-88:first-child{
    margin-top: 22rem;
  }

  .\\32xl\\:first\\:mr-88:first-child{
    margin-right: 22rem;
  }

  .\\32xl\\:first\\:mb-88:first-child{
    margin-bottom: 22rem;
  }

  .\\32xl\\:first\\:ml-88:first-child{
    margin-left: 22rem;
  }

  .\\32xl\\:first\\:mt-92:first-child{
    margin-top: 23rem;
  }

  .\\32xl\\:first\\:mr-92:first-child{
    margin-right: 23rem;
  }

  .\\32xl\\:first\\:mb-92:first-child{
    margin-bottom: 23rem;
  }

  .\\32xl\\:first\\:ml-92:first-child{
    margin-left: 23rem;
  }

  .\\32xl\\:first\\:mt-96:first-child{
    margin-top: 24rem;
  }

  .\\32xl\\:first\\:mr-96:first-child{
    margin-right: 24rem;
  }

  .\\32xl\\:first\\:mb-96:first-child{
    margin-bottom: 24rem;
  }

  .\\32xl\\:first\\:ml-96:first-child{
    margin-left: 24rem;
  }

  .\\32xl\\:first\\:mt-98:first-child{
    margin-top: 24.5rem;
  }

  .\\32xl\\:first\\:mr-98:first-child{
    margin-right: 24.5rem;
  }

  .\\32xl\\:first\\:mb-98:first-child{
    margin-bottom: 24.5rem;
  }

  .\\32xl\\:first\\:ml-98:first-child{
    margin-left: 24.5rem;
  }

  .\\32xl\\:first\\:mt-100:first-child{
    margin-top: 25rem;
  }

  .\\32xl\\:first\\:mr-100:first-child{
    margin-right: 25rem;
  }

  .\\32xl\\:first\\:mb-100:first-child{
    margin-bottom: 25rem;
  }

  .\\32xl\\:first\\:ml-100:first-child{
    margin-left: 25rem;
  }

  .\\32xl\\:first\\:mt-104:first-child{
    margin-top: 26rem;
  }

  .\\32xl\\:first\\:mr-104:first-child{
    margin-right: 26rem;
  }

  .\\32xl\\:first\\:mb-104:first-child{
    margin-bottom: 26rem;
  }

  .\\32xl\\:first\\:ml-104:first-child{
    margin-left: 26rem;
  }

  .\\32xl\\:first\\:mt-112:first-child{
    margin-top: 28rem;
  }

  .\\32xl\\:first\\:mr-112:first-child{
    margin-right: 28rem;
  }

  .\\32xl\\:first\\:mb-112:first-child{
    margin-bottom: 28rem;
  }

  .\\32xl\\:first\\:ml-112:first-child{
    margin-left: 28rem;
  }

  .\\32xl\\:first\\:mt-124:first-child{
    margin-top: 31rem;
  }

  .\\32xl\\:first\\:mr-124:first-child{
    margin-right: 31rem;
  }

  .\\32xl\\:first\\:mb-124:first-child{
    margin-bottom: 31rem;
  }

  .\\32xl\\:first\\:ml-124:first-child{
    margin-left: 31rem;
  }

  .\\32xl\\:first\\:mt-128:first-child{
    margin-top: 32rem;
  }

  .\\32xl\\:first\\:mr-128:first-child{
    margin-right: 32rem;
  }

  .\\32xl\\:first\\:mb-128:first-child{
    margin-bottom: 32rem;
  }

  .\\32xl\\:first\\:ml-128:first-child{
    margin-left: 32rem;
  }

  .\\32xl\\:first\\:mt-140:first-child{
    margin-top: 35rem;
  }

  .\\32xl\\:first\\:mr-140:first-child{
    margin-right: 35rem;
  }

  .\\32xl\\:first\\:mb-140:first-child{
    margin-bottom: 35rem;
  }

  .\\32xl\\:first\\:ml-140:first-child{
    margin-left: 35rem;
  }

  .\\32xl\\:first\\:mt-152:first-child{
    margin-top: 38rem;
  }

  .\\32xl\\:first\\:mr-152:first-child{
    margin-right: 38rem;
  }

  .\\32xl\\:first\\:mb-152:first-child{
    margin-bottom: 38rem;
  }

  .\\32xl\\:first\\:ml-152:first-child{
    margin-left: 38rem;
  }

  .\\32xl\\:first\\:mt-160:first-child{
    margin-top: 40rem;
  }

  .\\32xl\\:first\\:mr-160:first-child{
    margin-right: 40rem;
  }

  .\\32xl\\:first\\:mb-160:first-child{
    margin-bottom: 40rem;
  }

  .\\32xl\\:first\\:ml-160:first-child{
    margin-left: 40rem;
  }

  .\\32xl\\:first\\:mt-162:first-child{
    margin-top: 41rem;
  }

  .\\32xl\\:first\\:mr-162:first-child{
    margin-right: 41rem;
  }

  .\\32xl\\:first\\:mb-162:first-child{
    margin-bottom: 41rem;
  }

  .\\32xl\\:first\\:ml-162:first-child{
    margin-left: 41rem;
  }

  .\\32xl\\:first\\:mt-192:first-child{
    margin-top: 48rem;
  }

  .\\32xl\\:first\\:mr-192:first-child{
    margin-right: 48rem;
  }

  .\\32xl\\:first\\:mb-192:first-child{
    margin-bottom: 48rem;
  }

  .\\32xl\\:first\\:ml-192:first-child{
    margin-left: 48rem;
  }

  .\\32xl\\:first\\:mt-208:first-child{
    margin-top: 52rem;
  }

  .\\32xl\\:first\\:mr-208:first-child{
    margin-right: 52rem;
  }

  .\\32xl\\:first\\:mb-208:first-child{
    margin-bottom: 52rem;
  }

  .\\32xl\\:first\\:ml-208:first-child{
    margin-left: 52rem;
  }

  .\\32xl\\:first\\:mt-224:first-child{
    margin-top: 56rem;
  }

  .\\32xl\\:first\\:mr-224:first-child{
    margin-right: 56rem;
  }

  .\\32xl\\:first\\:mb-224:first-child{
    margin-bottom: 56rem;
  }

  .\\32xl\\:first\\:ml-224:first-child{
    margin-left: 56rem;
  }

  .\\32xl\\:first\\:mt-256:first-child{
    margin-top: 64rem;
  }

  .\\32xl\\:first\\:mr-256:first-child{
    margin-right: 64rem;
  }

  .\\32xl\\:first\\:mb-256:first-child{
    margin-bottom: 64rem;
  }

  .\\32xl\\:first\\:ml-256:first-child{
    margin-left: 64rem;
  }

  .\\32xl\\:first\\:mt-auto:first-child{
    margin-top: auto;
  }

  .\\32xl\\:first\\:mr-auto:first-child{
    margin-right: auto;
  }

  .\\32xl\\:first\\:mb-auto:first-child{
    margin-bottom: auto;
  }

  .\\32xl\\:first\\:ml-auto:first-child{
    margin-left: auto;
  }

  .\\32xl\\:first\\:mt-px:first-child{
    margin-top: 1px;
  }

  .\\32xl\\:first\\:mr-px:first-child{
    margin-right: 1px;
  }

  .\\32xl\\:first\\:mb-px:first-child{
    margin-bottom: 1px;
  }

  .\\32xl\\:first\\:ml-px:first-child{
    margin-left: 1px;
  }

  .\\32xl\\:first\\:-mt-1:first-child{
    margin-top: -0.25rem;
  }

  .\\32xl\\:first\\:-mr-1:first-child{
    margin-right: -0.25rem;
  }

  .\\32xl\\:first\\:-mb-1:first-child{
    margin-bottom: -0.25rem;
  }

  .\\32xl\\:first\\:-ml-1:first-child{
    margin-left: -0.25rem;
  }

  .\\32xl\\:first\\:-mt-2:first-child{
    margin-top: -0.5rem;
  }

  .\\32xl\\:first\\:-mr-2:first-child{
    margin-right: -0.5rem;
  }

  .\\32xl\\:first\\:-mb-2:first-child{
    margin-bottom: -0.5rem;
  }

  .\\32xl\\:first\\:-ml-2:first-child{
    margin-left: -0.5rem;
  }

  .\\32xl\\:first\\:-mt-3:first-child{
    margin-top: -0.75rem;
  }

  .\\32xl\\:first\\:-mr-3:first-child{
    margin-right: -0.75rem;
  }

  .\\32xl\\:first\\:-mb-3:first-child{
    margin-bottom: -0.75rem;
  }

  .\\32xl\\:first\\:-ml-3:first-child{
    margin-left: -0.75rem;
  }

  .\\32xl\\:first\\:-mt-4:first-child{
    margin-top: -1rem;
  }

  .\\32xl\\:first\\:-mr-4:first-child{
    margin-right: -1rem;
  }

  .\\32xl\\:first\\:-mb-4:first-child{
    margin-bottom: -1rem;
  }

  .\\32xl\\:first\\:-ml-4:first-child{
    margin-left: -1rem;
  }

  .\\32xl\\:first\\:-mt-5:first-child{
    margin-top: -1.25rem;
  }

  .\\32xl\\:first\\:-mr-5:first-child{
    margin-right: -1.25rem;
  }

  .\\32xl\\:first\\:-mb-5:first-child{
    margin-bottom: -1.25rem;
  }

  .\\32xl\\:first\\:-ml-5:first-child{
    margin-left: -1.25rem;
  }

  .\\32xl\\:first\\:-mt-6:first-child{
    margin-top: -1.5rem;
  }

  .\\32xl\\:first\\:-mr-6:first-child{
    margin-right: -1.5rem;
  }

  .\\32xl\\:first\\:-mb-6:first-child{
    margin-bottom: -1.5rem;
  }

  .\\32xl\\:first\\:-ml-6:first-child{
    margin-left: -1.5rem;
  }

  .\\32xl\\:first\\:-mt-7:first-child{
    margin-top: -1.75rem;
  }

  .\\32xl\\:first\\:-mr-7:first-child{
    margin-right: -1.75rem;
  }

  .\\32xl\\:first\\:-mb-7:first-child{
    margin-bottom: -1.75rem;
  }

  .\\32xl\\:first\\:-ml-7:first-child{
    margin-left: -1.75rem;
  }

  .\\32xl\\:first\\:-mt-8:first-child{
    margin-top: -2rem;
  }

  .\\32xl\\:first\\:-mr-8:first-child{
    margin-right: -2rem;
  }

  .\\32xl\\:first\\:-mb-8:first-child{
    margin-bottom: -2rem;
  }

  .\\32xl\\:first\\:-ml-8:first-child{
    margin-left: -2rem;
  }

  .\\32xl\\:first\\:-mt-9:first-child{
    margin-top: -2.25rem;
  }

  .\\32xl\\:first\\:-mr-9:first-child{
    margin-right: -2.25rem;
  }

  .\\32xl\\:first\\:-mb-9:first-child{
    margin-bottom: -2.25rem;
  }

  .\\32xl\\:first\\:-ml-9:first-child{
    margin-left: -2.25rem;
  }

  .\\32xl\\:first\\:-mt-10:first-child{
    margin-top: -2.5rem;
  }

  .\\32xl\\:first\\:-mr-10:first-child{
    margin-right: -2.5rem;
  }

  .\\32xl\\:first\\:-mb-10:first-child{
    margin-bottom: -2.5rem;
  }

  .\\32xl\\:first\\:-ml-10:first-child{
    margin-left: -2.5rem;
  }

  .\\32xl\\:first\\:-mt-11:first-child{
    margin-top: -2.75rem;
  }

  .\\32xl\\:first\\:-mr-11:first-child{
    margin-right: -2.75rem;
  }

  .\\32xl\\:first\\:-mb-11:first-child{
    margin-bottom: -2.75rem;
  }

  .\\32xl\\:first\\:-ml-11:first-child{
    margin-left: -2.75rem;
  }

  .\\32xl\\:first\\:-mt-12:first-child{
    margin-top: -3rem;
  }

  .\\32xl\\:first\\:-mr-12:first-child{
    margin-right: -3rem;
  }

  .\\32xl\\:first\\:-mb-12:first-child{
    margin-bottom: -3rem;
  }

  .\\32xl\\:first\\:-ml-12:first-child{
    margin-left: -3rem;
  }

  .\\32xl\\:first\\:-mt-14:first-child{
    margin-top: -3.5rem;
  }

  .\\32xl\\:first\\:-mr-14:first-child{
    margin-right: -3.5rem;
  }

  .\\32xl\\:first\\:-mb-14:first-child{
    margin-bottom: -3.5rem;
  }

  .\\32xl\\:first\\:-ml-14:first-child{
    margin-left: -3.5rem;
  }

  .\\32xl\\:first\\:-mt-15:first-child{
    margin-top: -3.75rem;
  }

  .\\32xl\\:first\\:-mr-15:first-child{
    margin-right: -3.75rem;
  }

  .\\32xl\\:first\\:-mb-15:first-child{
    margin-bottom: -3.75rem;
  }

  .\\32xl\\:first\\:-ml-15:first-child{
    margin-left: -3.75rem;
  }

  .\\32xl\\:first\\:-mt-16:first-child{
    margin-top: -4rem;
  }

  .\\32xl\\:first\\:-mr-16:first-child{
    margin-right: -4rem;
  }

  .\\32xl\\:first\\:-mb-16:first-child{
    margin-bottom: -4rem;
  }

  .\\32xl\\:first\\:-ml-16:first-child{
    margin-left: -4rem;
  }

  .\\32xl\\:first\\:-mt-18:first-child{
    margin-top: -4.5rem;
  }

  .\\32xl\\:first\\:-mr-18:first-child{
    margin-right: -4.5rem;
  }

  .\\32xl\\:first\\:-mb-18:first-child{
    margin-bottom: -4.5rem;
  }

  .\\32xl\\:first\\:-ml-18:first-child{
    margin-left: -4.5rem;
  }

  .\\32xl\\:first\\:-mt-20:first-child{
    margin-top: -5rem;
  }

  .\\32xl\\:first\\:-mr-20:first-child{
    margin-right: -5rem;
  }

  .\\32xl\\:first\\:-mb-20:first-child{
    margin-bottom: -5rem;
  }

  .\\32xl\\:first\\:-ml-20:first-child{
    margin-left: -5rem;
  }

  .\\32xl\\:first\\:-mt-22:first-child{
    margin-top: -5.5rem;
  }

  .\\32xl\\:first\\:-mr-22:first-child{
    margin-right: -5.5rem;
  }

  .\\32xl\\:first\\:-mb-22:first-child{
    margin-bottom: -5.5rem;
  }

  .\\32xl\\:first\\:-ml-22:first-child{
    margin-left: -5.5rem;
  }

  .\\32xl\\:first\\:-mt-23:first-child{
    margin-top: -5.75rem;
  }

  .\\32xl\\:first\\:-mr-23:first-child{
    margin-right: -5.75rem;
  }

  .\\32xl\\:first\\:-mb-23:first-child{
    margin-bottom: -5.75rem;
  }

  .\\32xl\\:first\\:-ml-23:first-child{
    margin-left: -5.75rem;
  }

  .\\32xl\\:first\\:-mt-24:first-child{
    margin-top: -6rem;
  }

  .\\32xl\\:first\\:-mr-24:first-child{
    margin-right: -6rem;
  }

  .\\32xl\\:first\\:-mb-24:first-child{
    margin-bottom: -6rem;
  }

  .\\32xl\\:first\\:-ml-24:first-child{
    margin-left: -6rem;
  }

  .\\32xl\\:first\\:-mt-25:first-child{
    margin-top: -6.25rem;
  }

  .\\32xl\\:first\\:-mr-25:first-child{
    margin-right: -6.25rem;
  }

  .\\32xl\\:first\\:-mb-25:first-child{
    margin-bottom: -6.25rem;
  }

  .\\32xl\\:first\\:-ml-25:first-child{
    margin-left: -6.25rem;
  }

  .\\32xl\\:first\\:-mt-26:first-child{
    margin-top: -6.5rem;
  }

  .\\32xl\\:first\\:-mr-26:first-child{
    margin-right: -6.5rem;
  }

  .\\32xl\\:first\\:-mb-26:first-child{
    margin-bottom: -6.5rem;
  }

  .\\32xl\\:first\\:-ml-26:first-child{
    margin-left: -6.5rem;
  }

  .\\32xl\\:first\\:-mt-28:first-child{
    margin-top: -7rem;
  }

  .\\32xl\\:first\\:-mr-28:first-child{
    margin-right: -7rem;
  }

  .\\32xl\\:first\\:-mb-28:first-child{
    margin-bottom: -7rem;
  }

  .\\32xl\\:first\\:-ml-28:first-child{
    margin-left: -7rem;
  }

  .\\32xl\\:first\\:-mt-30:first-child{
    margin-top: -7.5rem;
  }

  .\\32xl\\:first\\:-mr-30:first-child{
    margin-right: -7.5rem;
  }

  .\\32xl\\:first\\:-mb-30:first-child{
    margin-bottom: -7.5rem;
  }

  .\\32xl\\:first\\:-ml-30:first-child{
    margin-left: -7.5rem;
  }

  .\\32xl\\:first\\:-mt-32:first-child{
    margin-top: -8rem;
  }

  .\\32xl\\:first\\:-mr-32:first-child{
    margin-right: -8rem;
  }

  .\\32xl\\:first\\:-mb-32:first-child{
    margin-bottom: -8rem;
  }

  .\\32xl\\:first\\:-ml-32:first-child{
    margin-left: -8rem;
  }

  .\\32xl\\:first\\:-mt-34:first-child{
    margin-top: -8.5rem;
  }

  .\\32xl\\:first\\:-mr-34:first-child{
    margin-right: -8.5rem;
  }

  .\\32xl\\:first\\:-mb-34:first-child{
    margin-bottom: -8.5rem;
  }

  .\\32xl\\:first\\:-ml-34:first-child{
    margin-left: -8.5rem;
  }

  .\\32xl\\:first\\:-mt-40:first-child{
    margin-top: -10rem;
  }

  .\\32xl\\:first\\:-mr-40:first-child{
    margin-right: -10rem;
  }

  .\\32xl\\:first\\:-mb-40:first-child{
    margin-bottom: -10rem;
  }

  .\\32xl\\:first\\:-ml-40:first-child{
    margin-left: -10rem;
  }

  .\\32xl\\:first\\:-mt-42:first-child{
    margin-top: -10.5rem;
  }

  .\\32xl\\:first\\:-mr-42:first-child{
    margin-right: -10.5rem;
  }

  .\\32xl\\:first\\:-mb-42:first-child{
    margin-bottom: -10.5rem;
  }

  .\\32xl\\:first\\:-ml-42:first-child{
    margin-left: -10.5rem;
  }

  .\\32xl\\:first\\:-mt-44:first-child{
    margin-top: -11rem;
  }

  .\\32xl\\:first\\:-mr-44:first-child{
    margin-right: -11rem;
  }

  .\\32xl\\:first\\:-mb-44:first-child{
    margin-bottom: -11rem;
  }

  .\\32xl\\:first\\:-ml-44:first-child{
    margin-left: -11rem;
  }

  .\\32xl\\:first\\:-mt-48:first-child{
    margin-top: -12rem;
  }

  .\\32xl\\:first\\:-mr-48:first-child{
    margin-right: -12rem;
  }

  .\\32xl\\:first\\:-mb-48:first-child{
    margin-bottom: -12rem;
  }

  .\\32xl\\:first\\:-ml-48:first-child{
    margin-left: -12rem;
  }

  .\\32xl\\:first\\:-mt-52:first-child{
    margin-top: -13rem;
  }

  .\\32xl\\:first\\:-mr-52:first-child{
    margin-right: -13rem;
  }

  .\\32xl\\:first\\:-mb-52:first-child{
    margin-bottom: -13rem;
  }

  .\\32xl\\:first\\:-ml-52:first-child{
    margin-left: -13rem;
  }

  .\\32xl\\:first\\:-mt-54:first-child{
    margin-top: -13.5rem;
  }

  .\\32xl\\:first\\:-mr-54:first-child{
    margin-right: -13.5rem;
  }

  .\\32xl\\:first\\:-mb-54:first-child{
    margin-bottom: -13.5rem;
  }

  .\\32xl\\:first\\:-ml-54:first-child{
    margin-left: -13.5rem;
  }

  .\\32xl\\:first\\:-mt-56:first-child{
    margin-top: -14rem;
  }

  .\\32xl\\:first\\:-mr-56:first-child{
    margin-right: -14rem;
  }

  .\\32xl\\:first\\:-mb-56:first-child{
    margin-bottom: -14rem;
  }

  .\\32xl\\:first\\:-ml-56:first-child{
    margin-left: -14rem;
  }

  .\\32xl\\:first\\:-mt-60:first-child{
    margin-top: -15rem;
  }

  .\\32xl\\:first\\:-mr-60:first-child{
    margin-right: -15rem;
  }

  .\\32xl\\:first\\:-mb-60:first-child{
    margin-bottom: -15rem;
  }

  .\\32xl\\:first\\:-ml-60:first-child{
    margin-left: -15rem;
  }

  .\\32xl\\:first\\:-mt-64:first-child{
    margin-top: -16rem;
  }

  .\\32xl\\:first\\:-mr-64:first-child{
    margin-right: -16rem;
  }

  .\\32xl\\:first\\:-mb-64:first-child{
    margin-bottom: -16rem;
  }

  .\\32xl\\:first\\:-ml-64:first-child{
    margin-left: -16rem;
  }

  .\\32xl\\:first\\:-mt-68:first-child{
    margin-top: -17rem;
  }

  .\\32xl\\:first\\:-mr-68:first-child{
    margin-right: -17rem;
  }

  .\\32xl\\:first\\:-mb-68:first-child{
    margin-bottom: -17rem;
  }

  .\\32xl\\:first\\:-ml-68:first-child{
    margin-left: -17rem;
  }

  .\\32xl\\:first\\:-mt-72:first-child{
    margin-top: -18rem;
  }

  .\\32xl\\:first\\:-mr-72:first-child{
    margin-right: -18rem;
  }

  .\\32xl\\:first\\:-mb-72:first-child{
    margin-bottom: -18rem;
  }

  .\\32xl\\:first\\:-ml-72:first-child{
    margin-left: -18rem;
  }

  .\\32xl\\:first\\:-mt-74:first-child{
    margin-top: -18.5rem;
  }

  .\\32xl\\:first\\:-mr-74:first-child{
    margin-right: -18.5rem;
  }

  .\\32xl\\:first\\:-mb-74:first-child{
    margin-bottom: -18.5rem;
  }

  .\\32xl\\:first\\:-ml-74:first-child{
    margin-left: -18.5rem;
  }

  .\\32xl\\:first\\:-mt-76:first-child{
    margin-top: -19rem;
  }

  .\\32xl\\:first\\:-mr-76:first-child{
    margin-right: -19rem;
  }

  .\\32xl\\:first\\:-mb-76:first-child{
    margin-bottom: -19rem;
  }

  .\\32xl\\:first\\:-ml-76:first-child{
    margin-left: -19rem;
  }

  .\\32xl\\:first\\:-mt-78:first-child{
    margin-top: -19.5rem;
  }

  .\\32xl\\:first\\:-mr-78:first-child{
    margin-right: -19.5rem;
  }

  .\\32xl\\:first\\:-mb-78:first-child{
    margin-bottom: -19.5rem;
  }

  .\\32xl\\:first\\:-ml-78:first-child{
    margin-left: -19.5rem;
  }

  .\\32xl\\:first\\:-mt-80:first-child{
    margin-top: -20rem;
  }

  .\\32xl\\:first\\:-mr-80:first-child{
    margin-right: -20rem;
  }

  .\\32xl\\:first\\:-mb-80:first-child{
    margin-bottom: -20rem;
  }

  .\\32xl\\:first\\:-ml-80:first-child{
    margin-left: -20rem;
  }

  .\\32xl\\:first\\:-mt-82:first-child{
    margin-top: -20.5rem;
  }

  .\\32xl\\:first\\:-mr-82:first-child{
    margin-right: -20.5rem;
  }

  .\\32xl\\:first\\:-mb-82:first-child{
    margin-bottom: -20.5rem;
  }

  .\\32xl\\:first\\:-ml-82:first-child{
    margin-left: -20.5rem;
  }

  .\\32xl\\:first\\:-mt-84:first-child{
    margin-top: -21rem;
  }

  .\\32xl\\:first\\:-mr-84:first-child{
    margin-right: -21rem;
  }

  .\\32xl\\:first\\:-mb-84:first-child{
    margin-bottom: -21rem;
  }

  .\\32xl\\:first\\:-ml-84:first-child{
    margin-left: -21rem;
  }

  .\\32xl\\:first\\:-mt-88:first-child{
    margin-top: -22rem;
  }

  .\\32xl\\:first\\:-mr-88:first-child{
    margin-right: -22rem;
  }

  .\\32xl\\:first\\:-mb-88:first-child{
    margin-bottom: -22rem;
  }

  .\\32xl\\:first\\:-ml-88:first-child{
    margin-left: -22rem;
  }

  .\\32xl\\:first\\:-mt-92:first-child{
    margin-top: -23rem;
  }

  .\\32xl\\:first\\:-mr-92:first-child{
    margin-right: -23rem;
  }

  .\\32xl\\:first\\:-mb-92:first-child{
    margin-bottom: -23rem;
  }

  .\\32xl\\:first\\:-ml-92:first-child{
    margin-left: -23rem;
  }

  .\\32xl\\:first\\:-mt-96:first-child{
    margin-top: -24rem;
  }

  .\\32xl\\:first\\:-mr-96:first-child{
    margin-right: -24rem;
  }

  .\\32xl\\:first\\:-mb-96:first-child{
    margin-bottom: -24rem;
  }

  .\\32xl\\:first\\:-ml-96:first-child{
    margin-left: -24rem;
  }

  .\\32xl\\:first\\:-mt-98:first-child{
    margin-top: -24.5rem;
  }

  .\\32xl\\:first\\:-mr-98:first-child{
    margin-right: -24.5rem;
  }

  .\\32xl\\:first\\:-mb-98:first-child{
    margin-bottom: -24.5rem;
  }

  .\\32xl\\:first\\:-ml-98:first-child{
    margin-left: -24.5rem;
  }

  .\\32xl\\:first\\:-mt-100:first-child{
    margin-top: -25rem;
  }

  .\\32xl\\:first\\:-mr-100:first-child{
    margin-right: -25rem;
  }

  .\\32xl\\:first\\:-mb-100:first-child{
    margin-bottom: -25rem;
  }

  .\\32xl\\:first\\:-ml-100:first-child{
    margin-left: -25rem;
  }

  .\\32xl\\:first\\:-mt-104:first-child{
    margin-top: -26rem;
  }

  .\\32xl\\:first\\:-mr-104:first-child{
    margin-right: -26rem;
  }

  .\\32xl\\:first\\:-mb-104:first-child{
    margin-bottom: -26rem;
  }

  .\\32xl\\:first\\:-ml-104:first-child{
    margin-left: -26rem;
  }

  .\\32xl\\:first\\:-mt-112:first-child{
    margin-top: -28rem;
  }

  .\\32xl\\:first\\:-mr-112:first-child{
    margin-right: -28rem;
  }

  .\\32xl\\:first\\:-mb-112:first-child{
    margin-bottom: -28rem;
  }

  .\\32xl\\:first\\:-ml-112:first-child{
    margin-left: -28rem;
  }

  .\\32xl\\:first\\:-mt-124:first-child{
    margin-top: -31rem;
  }

  .\\32xl\\:first\\:-mr-124:first-child{
    margin-right: -31rem;
  }

  .\\32xl\\:first\\:-mb-124:first-child{
    margin-bottom: -31rem;
  }

  .\\32xl\\:first\\:-ml-124:first-child{
    margin-left: -31rem;
  }

  .\\32xl\\:first\\:-mt-128:first-child{
    margin-top: -32rem;
  }

  .\\32xl\\:first\\:-mr-128:first-child{
    margin-right: -32rem;
  }

  .\\32xl\\:first\\:-mb-128:first-child{
    margin-bottom: -32rem;
  }

  .\\32xl\\:first\\:-ml-128:first-child{
    margin-left: -32rem;
  }

  .\\32xl\\:first\\:-mt-140:first-child{
    margin-top: -35rem;
  }

  .\\32xl\\:first\\:-mr-140:first-child{
    margin-right: -35rem;
  }

  .\\32xl\\:first\\:-mb-140:first-child{
    margin-bottom: -35rem;
  }

  .\\32xl\\:first\\:-ml-140:first-child{
    margin-left: -35rem;
  }

  .\\32xl\\:first\\:-mt-152:first-child{
    margin-top: -38rem;
  }

  .\\32xl\\:first\\:-mr-152:first-child{
    margin-right: -38rem;
  }

  .\\32xl\\:first\\:-mb-152:first-child{
    margin-bottom: -38rem;
  }

  .\\32xl\\:first\\:-ml-152:first-child{
    margin-left: -38rem;
  }

  .\\32xl\\:first\\:-mt-160:first-child{
    margin-top: -40rem;
  }

  .\\32xl\\:first\\:-mr-160:first-child{
    margin-right: -40rem;
  }

  .\\32xl\\:first\\:-mb-160:first-child{
    margin-bottom: -40rem;
  }

  .\\32xl\\:first\\:-ml-160:first-child{
    margin-left: -40rem;
  }

  .\\32xl\\:first\\:-mt-162:first-child{
    margin-top: -41rem;
  }

  .\\32xl\\:first\\:-mr-162:first-child{
    margin-right: -41rem;
  }

  .\\32xl\\:first\\:-mb-162:first-child{
    margin-bottom: -41rem;
  }

  .\\32xl\\:first\\:-ml-162:first-child{
    margin-left: -41rem;
  }

  .\\32xl\\:first\\:-mt-192:first-child{
    margin-top: -48rem;
  }

  .\\32xl\\:first\\:-mr-192:first-child{
    margin-right: -48rem;
  }

  .\\32xl\\:first\\:-mb-192:first-child{
    margin-bottom: -48rem;
  }

  .\\32xl\\:first\\:-ml-192:first-child{
    margin-left: -48rem;
  }

  .\\32xl\\:first\\:-mt-208:first-child{
    margin-top: -52rem;
  }

  .\\32xl\\:first\\:-mr-208:first-child{
    margin-right: -52rem;
  }

  .\\32xl\\:first\\:-mb-208:first-child{
    margin-bottom: -52rem;
  }

  .\\32xl\\:first\\:-ml-208:first-child{
    margin-left: -52rem;
  }

  .\\32xl\\:first\\:-mt-224:first-child{
    margin-top: -56rem;
  }

  .\\32xl\\:first\\:-mr-224:first-child{
    margin-right: -56rem;
  }

  .\\32xl\\:first\\:-mb-224:first-child{
    margin-bottom: -56rem;
  }

  .\\32xl\\:first\\:-ml-224:first-child{
    margin-left: -56rem;
  }

  .\\32xl\\:first\\:-mt-256:first-child{
    margin-top: -64rem;
  }

  .\\32xl\\:first\\:-mr-256:first-child{
    margin-right: -64rem;
  }

  .\\32xl\\:first\\:-mb-256:first-child{
    margin-bottom: -64rem;
  }

  .\\32xl\\:first\\:-ml-256:first-child{
    margin-left: -64rem;
  }

  .\\32xl\\:first\\:-mt-px:first-child{
    margin-top: -1px;
  }

  .\\32xl\\:first\\:-mr-px:first-child{
    margin-right: -1px;
  }

  .\\32xl\\:first\\:-mb-px:first-child{
    margin-bottom: -1px;
  }

  .\\32xl\\:first\\:-ml-px:first-child{
    margin-left: -1px;
  }

  .\\32xl\\:max-h-0{
    max-height: 0;
  }

  .\\32xl\\:max-h-1{
    max-height: 0.25rem;
  }

  .\\32xl\\:max-h-2{
    max-height: 0.5rem;
  }

  .\\32xl\\:max-h-3{
    max-height: 0.75rem;
  }

  .\\32xl\\:max-h-4{
    max-height: 1rem;
  }

  .\\32xl\\:max-h-5{
    max-height: 1.25rem;
  }

  .\\32xl\\:max-h-6{
    max-height: 1.5rem;
  }

  .\\32xl\\:max-h-7{
    max-height: 1.75rem;
  }

  .\\32xl\\:max-h-8{
    max-height: 2rem;
  }

  .\\32xl\\:max-h-9{
    max-height: 2.25rem;
  }

  .\\32xl\\:max-h-10{
    max-height: 2.5rem;
  }

  .\\32xl\\:max-h-11{
    max-height: 2.75rem;
  }

  .\\32xl\\:max-h-12{
    max-height: 3rem;
  }

  .\\32xl\\:max-h-14{
    max-height: 3.5rem;
  }

  .\\32xl\\:max-h-15{
    max-height: 3.75rem;
  }

  .\\32xl\\:max-h-16{
    max-height: 4rem;
  }

  .\\32xl\\:max-h-18{
    max-height: 4.5rem;
  }

  .\\32xl\\:max-h-20{
    max-height: 5rem;
  }

  .\\32xl\\:max-h-22{
    max-height: 5.5rem;
  }

  .\\32xl\\:max-h-23{
    max-height: 5.75rem;
  }

  .\\32xl\\:max-h-24{
    max-height: 6rem;
  }

  .\\32xl\\:max-h-25{
    max-height: 6.25rem;
  }

  .\\32xl\\:max-h-26{
    max-height: 6.5rem;
  }

  .\\32xl\\:max-h-28{
    max-height: 7rem;
  }

  .\\32xl\\:max-h-30{
    max-height: 7.5rem;
  }

  .\\32xl\\:max-h-32{
    max-height: 8rem;
  }

  .\\32xl\\:max-h-34{
    max-height: 8.5rem;
  }

  .\\32xl\\:max-h-40{
    max-height: 10rem;
  }

  .\\32xl\\:max-h-42{
    max-height: 10.5rem;
  }

  .\\32xl\\:max-h-44{
    max-height: 11rem;
  }

  .\\32xl\\:max-h-48{
    max-height: 12rem;
  }

  .\\32xl\\:max-h-52{
    max-height: 13rem;
  }

  .\\32xl\\:max-h-54{
    max-height: 13.5rem;
  }

  .\\32xl\\:max-h-56{
    max-height: 14rem;
  }

  .\\32xl\\:max-h-60{
    max-height: 15rem;
  }

  .\\32xl\\:max-h-64{
    max-height: 16rem;
  }

  .\\32xl\\:max-h-68{
    max-height: 17rem;
  }

  .\\32xl\\:max-h-72{
    max-height: 18rem;
  }

  .\\32xl\\:max-h-74{
    max-height: 18.5rem;
  }

  .\\32xl\\:max-h-76{
    max-height: 19rem;
  }

  .\\32xl\\:max-h-78{
    max-height: 19.5rem;
  }

  .\\32xl\\:max-h-80{
    max-height: 20rem;
  }

  .\\32xl\\:max-h-82{
    max-height: 20.5rem;
  }

  .\\32xl\\:max-h-84{
    max-height: 21rem;
  }

  .\\32xl\\:max-h-88{
    max-height: 22rem;
  }

  .\\32xl\\:max-h-92{
    max-height: 23rem;
  }

  .\\32xl\\:max-h-96{
    max-height: 24rem;
  }

  .\\32xl\\:max-h-98{
    max-height: 24.5rem;
  }

  .\\32xl\\:max-h-100{
    max-height: 25rem;
  }

  .\\32xl\\:max-h-104{
    max-height: 26rem;
  }

  .\\32xl\\:max-h-112{
    max-height: 28rem;
  }

  .\\32xl\\:max-h-124{
    max-height: 31rem;
  }

  .\\32xl\\:max-h-128{
    max-height: 32rem;
  }

  .\\32xl\\:max-h-140{
    max-height: 35rem;
  }

  .\\32xl\\:max-h-152{
    max-height: 38rem;
  }

  .\\32xl\\:max-h-160{
    max-height: 40rem;
  }

  .\\32xl\\:max-h-162{
    max-height: 41rem;
  }

  .\\32xl\\:max-h-192{
    max-height: 48rem;
  }

  .\\32xl\\:max-h-208{
    max-height: 52rem;
  }

  .\\32xl\\:max-h-224{
    max-height: 56rem;
  }

  .\\32xl\\:max-h-256{
    max-height: 64rem;
  }

  .\\32xl\\:max-h-px{
    max-height: 1px;
  }

  .\\32xl\\:max-h-full{
    max-height: 100%;
  }

  .\\32xl\\:max-h-screen{
    max-height: 100vh;
  }

  .\\32xl\\:max-w-0{
    max-width: 0;
  }

  .\\32xl\\:max-w-1{
    max-width: 0.25rem;
  }

  .\\32xl\\:max-w-2{
    max-width: 0.5rem;
  }

  .\\32xl\\:max-w-3{
    max-width: 0.75rem;
  }

  .\\32xl\\:max-w-4{
    max-width: 1rem;
  }

  .\\32xl\\:max-w-5{
    max-width: 1.25rem;
  }

  .\\32xl\\:max-w-6{
    max-width: 1.5rem;
  }

  .\\32xl\\:max-w-7{
    max-width: 1.75rem;
  }

  .\\32xl\\:max-w-8{
    max-width: 2rem;
  }

  .\\32xl\\:max-w-9{
    max-width: 2.25rem;
  }

  .\\32xl\\:max-w-10{
    max-width: 2.5rem;
  }

  .\\32xl\\:max-w-11{
    max-width: 2.75rem;
  }

  .\\32xl\\:max-w-12{
    max-width: 3rem;
  }

  .\\32xl\\:max-w-14{
    max-width: 3.5rem;
  }

  .\\32xl\\:max-w-15{
    max-width: 3.75rem;
  }

  .\\32xl\\:max-w-16{
    max-width: 4rem;
  }

  .\\32xl\\:max-w-18{
    max-width: 4.5rem;
  }

  .\\32xl\\:max-w-20{
    max-width: 5rem;
  }

  .\\32xl\\:max-w-22{
    max-width: 5.5rem;
  }

  .\\32xl\\:max-w-23{
    max-width: 5.75rem;
  }

  .\\32xl\\:max-w-24{
    max-width: 6rem;
  }

  .\\32xl\\:max-w-25{
    max-width: 6.25rem;
  }

  .\\32xl\\:max-w-26{
    max-width: 6.5rem;
  }

  .\\32xl\\:max-w-28{
    max-width: 7rem;
  }

  .\\32xl\\:max-w-30{
    max-width: 7.5rem;
  }

  .\\32xl\\:max-w-32{
    max-width: 8rem;
  }

  .\\32xl\\:max-w-34{
    max-width: 8.5rem;
  }

  .\\32xl\\:max-w-40{
    max-width: 10rem;
  }

  .\\32xl\\:max-w-42{
    max-width: 10.5rem;
  }

  .\\32xl\\:max-w-44{
    max-width: 11rem;
  }

  .\\32xl\\:max-w-48{
    max-width: 12rem;
  }

  .\\32xl\\:max-w-52{
    max-width: 13rem;
  }

  .\\32xl\\:max-w-54{
    max-width: 13.5rem;
  }

  .\\32xl\\:max-w-56{
    max-width: 14rem;
  }

  .\\32xl\\:max-w-60{
    max-width: 15rem;
  }

  .\\32xl\\:max-w-64{
    max-width: 16rem;
  }

  .\\32xl\\:max-w-68{
    max-width: 17rem;
  }

  .\\32xl\\:max-w-72{
    max-width: 18rem;
  }

  .\\32xl\\:max-w-74{
    max-width: 18.5rem;
  }

  .\\32xl\\:max-w-76{
    max-width: 19rem;
  }

  .\\32xl\\:max-w-78{
    max-width: 19.5rem;
  }

  .\\32xl\\:max-w-80{
    max-width: 20rem;
  }

  .\\32xl\\:max-w-82{
    max-width: 20.5rem;
  }

  .\\32xl\\:max-w-84{
    max-width: 21rem;
  }

  .\\32xl\\:max-w-88{
    max-width: 22rem;
  }

  .\\32xl\\:max-w-92{
    max-width: 23rem;
  }

  .\\32xl\\:max-w-96{
    max-width: 24rem;
  }

  .\\32xl\\:max-w-98{
    max-width: 24.5rem;
  }

  .\\32xl\\:max-w-100{
    max-width: 25rem;
  }

  .\\32xl\\:max-w-104{
    max-width: 26rem;
  }

  .\\32xl\\:max-w-112{
    max-width: 28rem;
  }

  .\\32xl\\:max-w-124{
    max-width: 31rem;
  }

  .\\32xl\\:max-w-128{
    max-width: 32rem;
  }

  .\\32xl\\:max-w-140{
    max-width: 35rem;
  }

  .\\32xl\\:max-w-152{
    max-width: 38rem;
  }

  .\\32xl\\:max-w-160{
    max-width: 40rem;
  }

  .\\32xl\\:max-w-162{
    max-width: 41rem;
  }

  .\\32xl\\:max-w-192{
    max-width: 48rem;
  }

  .\\32xl\\:max-w-208{
    max-width: 52rem;
  }

  .\\32xl\\:max-w-224{
    max-width: 56rem;
  }

  .\\32xl\\:max-w-256{
    max-width: 64rem;
  }

  .\\32xl\\:max-w-none{
    max-width: none;
  }

  .\\32xl\\:max-w-xs{
    max-width: 20rem;
  }

  .\\32xl\\:max-w-sm{
    max-width: 24rem;
  }

  .\\32xl\\:max-w-md{
    max-width: 28rem;
  }

  .\\32xl\\:max-w-lg{
    max-width: 32rem;
  }

  .\\32xl\\:max-w-xl{
    max-width: 36rem;
  }

  .\\32xl\\:max-w-2xl{
    max-width: 42rem;
  }

  .\\32xl\\:max-w-3xl{
    max-width: 48rem;
  }

  .\\32xl\\:max-w-4xl{
    max-width: 56rem;
  }

  .\\32xl\\:max-w-5xl{
    max-width: 64rem;
  }

  .\\32xl\\:max-w-6xl{
    max-width: 76rem;
  }

  .\\32xl\\:max-w-7xl{
    max-width: 92rem;
  }

  .\\32xl\\:max-w-8xl{
    max-width: 112rem;
  }

  .\\32xl\\:max-w-9xl{
    max-width: 130rem;
  }

  .\\32xl\\:max-w-full{
    max-width: 100%;
  }

  .\\32xl\\:max-w-px{
    max-width: 1px;
  }

  .\\32xl\\:min-h-0{
    min-height: 0;
  }

  .\\32xl\\:min-h-1{
    min-height: 0.25rem;
  }

  .\\32xl\\:min-h-2{
    min-height: 0.5rem;
  }

  .\\32xl\\:min-h-3{
    min-height: 0.75rem;
  }

  .\\32xl\\:min-h-4{
    min-height: 1rem;
  }

  .\\32xl\\:min-h-5{
    min-height: 1.25rem;
  }

  .\\32xl\\:min-h-6{
    min-height: 1.5rem;
  }

  .\\32xl\\:min-h-7{
    min-height: 1.75rem;
  }

  .\\32xl\\:min-h-8{
    min-height: 2rem;
  }

  .\\32xl\\:min-h-9{
    min-height: 2.25rem;
  }

  .\\32xl\\:min-h-10{
    min-height: 2.5rem;
  }

  .\\32xl\\:min-h-11{
    min-height: 2.75rem;
  }

  .\\32xl\\:min-h-12{
    min-height: 3rem;
  }

  .\\32xl\\:min-h-14{
    min-height: 3.5rem;
  }

  .\\32xl\\:min-h-15{
    min-height: 3.75rem;
  }

  .\\32xl\\:min-h-16{
    min-height: 4rem;
  }

  .\\32xl\\:min-h-18{
    min-height: 4.5rem;
  }

  .\\32xl\\:min-h-20{
    min-height: 5rem;
  }

  .\\32xl\\:min-h-22{
    min-height: 5.5rem;
  }

  .\\32xl\\:min-h-23{
    min-height: 5.75rem;
  }

  .\\32xl\\:min-h-24{
    min-height: 6rem;
  }

  .\\32xl\\:min-h-25{
    min-height: 6.25rem;
  }

  .\\32xl\\:min-h-26{
    min-height: 6.5rem;
  }

  .\\32xl\\:min-h-28{
    min-height: 7rem;
  }

  .\\32xl\\:min-h-30{
    min-height: 7.5rem;
  }

  .\\32xl\\:min-h-32{
    min-height: 8rem;
  }

  .\\32xl\\:min-h-34{
    min-height: 8.5rem;
  }

  .\\32xl\\:min-h-40{
    min-height: 10rem;
  }

  .\\32xl\\:min-h-42{
    min-height: 10.5rem;
  }

  .\\32xl\\:min-h-44{
    min-height: 11rem;
  }

  .\\32xl\\:min-h-48{
    min-height: 12rem;
  }

  .\\32xl\\:min-h-52{
    min-height: 13rem;
  }

  .\\32xl\\:min-h-54{
    min-height: 13.5rem;
  }

  .\\32xl\\:min-h-56{
    min-height: 14rem;
  }

  .\\32xl\\:min-h-60{
    min-height: 15rem;
  }

  .\\32xl\\:min-h-64{
    min-height: 16rem;
  }

  .\\32xl\\:min-h-68{
    min-height: 17rem;
  }

  .\\32xl\\:min-h-72{
    min-height: 18rem;
  }

  .\\32xl\\:min-h-74{
    min-height: 18.5rem;
  }

  .\\32xl\\:min-h-76{
    min-height: 19rem;
  }

  .\\32xl\\:min-h-78{
    min-height: 19.5rem;
  }

  .\\32xl\\:min-h-80{
    min-height: 20rem;
  }

  .\\32xl\\:min-h-82{
    min-height: 20.5rem;
  }

  .\\32xl\\:min-h-84{
    min-height: 21rem;
  }

  .\\32xl\\:min-h-88{
    min-height: 22rem;
  }

  .\\32xl\\:min-h-92{
    min-height: 23rem;
  }

  .\\32xl\\:min-h-96{
    min-height: 24rem;
  }

  .\\32xl\\:min-h-98{
    min-height: 24.5rem;
  }

  .\\32xl\\:min-h-100{
    min-height: 25rem;
  }

  .\\32xl\\:min-h-104{
    min-height: 26rem;
  }

  .\\32xl\\:min-h-112{
    min-height: 28rem;
  }

  .\\32xl\\:min-h-124{
    min-height: 31rem;
  }

  .\\32xl\\:min-h-128{
    min-height: 32rem;
  }

  .\\32xl\\:min-h-140{
    min-height: 35rem;
  }

  .\\32xl\\:min-h-152{
    min-height: 38rem;
  }

  .\\32xl\\:min-h-160{
    min-height: 40rem;
  }

  .\\32xl\\:min-h-162{
    min-height: 41rem;
  }

  .\\32xl\\:min-h-192{
    min-height: 48rem;
  }

  .\\32xl\\:min-h-208{
    min-height: 52rem;
  }

  .\\32xl\\:min-h-224{
    min-height: 56rem;
  }

  .\\32xl\\:min-h-256{
    min-height: 64rem;
  }

  .\\32xl\\:min-h-full{
    min-height: 100%;
  }

  .\\32xl\\:min-h-px{
    min-height: 1px;
  }

  .\\32xl\\:min-h-screen{
    min-height: 100vh;
  }

  .\\32xl\\:min-w-0{
    min-width: 0;
  }

  .\\32xl\\:min-w-1{
    min-width: 0.25rem;
  }

  .\\32xl\\:min-w-2{
    min-width: 0.5rem;
  }

  .\\32xl\\:min-w-3{
    min-width: 0.75rem;
  }

  .\\32xl\\:min-w-4{
    min-width: 1rem;
  }

  .\\32xl\\:min-w-5{
    min-width: 1.25rem;
  }

  .\\32xl\\:min-w-6{
    min-width: 1.5rem;
  }

  .\\32xl\\:min-w-7{
    min-width: 1.75rem;
  }

  .\\32xl\\:min-w-8{
    min-width: 2rem;
  }

  .\\32xl\\:min-w-9{
    min-width: 2.25rem;
  }

  .\\32xl\\:min-w-10{
    min-width: 2.5rem;
  }

  .\\32xl\\:min-w-11{
    min-width: 2.75rem;
  }

  .\\32xl\\:min-w-12{
    min-width: 3rem;
  }

  .\\32xl\\:min-w-14{
    min-width: 3.5rem;
  }

  .\\32xl\\:min-w-15{
    min-width: 3.75rem;
  }

  .\\32xl\\:min-w-16{
    min-width: 4rem;
  }

  .\\32xl\\:min-w-18{
    min-width: 4.5rem;
  }

  .\\32xl\\:min-w-20{
    min-width: 5rem;
  }

  .\\32xl\\:min-w-22{
    min-width: 5.5rem;
  }

  .\\32xl\\:min-w-23{
    min-width: 5.75rem;
  }

  .\\32xl\\:min-w-24{
    min-width: 6rem;
  }

  .\\32xl\\:min-w-25{
    min-width: 6.25rem;
  }

  .\\32xl\\:min-w-26{
    min-width: 6.5rem;
  }

  .\\32xl\\:min-w-28{
    min-width: 7rem;
  }

  .\\32xl\\:min-w-30{
    min-width: 7.5rem;
  }

  .\\32xl\\:min-w-32{
    min-width: 8rem;
  }

  .\\32xl\\:min-w-34{
    min-width: 8.5rem;
  }

  .\\32xl\\:min-w-40{
    min-width: 10rem;
  }

  .\\32xl\\:min-w-42{
    min-width: 10.5rem;
  }

  .\\32xl\\:min-w-44{
    min-width: 11rem;
  }

  .\\32xl\\:min-w-48{
    min-width: 12rem;
  }

  .\\32xl\\:min-w-52{
    min-width: 13rem;
  }

  .\\32xl\\:min-w-54{
    min-width: 13.5rem;
  }

  .\\32xl\\:min-w-56{
    min-width: 14rem;
  }

  .\\32xl\\:min-w-60{
    min-width: 15rem;
  }

  .\\32xl\\:min-w-64{
    min-width: 16rem;
  }

  .\\32xl\\:min-w-68{
    min-width: 17rem;
  }

  .\\32xl\\:min-w-72{
    min-width: 18rem;
  }

  .\\32xl\\:min-w-74{
    min-width: 18.5rem;
  }

  .\\32xl\\:min-w-76{
    min-width: 19rem;
  }

  .\\32xl\\:min-w-78{
    min-width: 19.5rem;
  }

  .\\32xl\\:min-w-80{
    min-width: 20rem;
  }

  .\\32xl\\:min-w-82{
    min-width: 20.5rem;
  }

  .\\32xl\\:min-w-84{
    min-width: 21rem;
  }

  .\\32xl\\:min-w-88{
    min-width: 22rem;
  }

  .\\32xl\\:min-w-92{
    min-width: 23rem;
  }

  .\\32xl\\:min-w-96{
    min-width: 24rem;
  }

  .\\32xl\\:min-w-98{
    min-width: 24.5rem;
  }

  .\\32xl\\:min-w-100{
    min-width: 25rem;
  }

  .\\32xl\\:min-w-104{
    min-width: 26rem;
  }

  .\\32xl\\:min-w-112{
    min-width: 28rem;
  }

  .\\32xl\\:min-w-124{
    min-width: 31rem;
  }

  .\\32xl\\:min-w-128{
    min-width: 32rem;
  }

  .\\32xl\\:min-w-140{
    min-width: 35rem;
  }

  .\\32xl\\:min-w-152{
    min-width: 38rem;
  }

  .\\32xl\\:min-w-160{
    min-width: 40rem;
  }

  .\\32xl\\:min-w-162{
    min-width: 41rem;
  }

  .\\32xl\\:min-w-192{
    min-width: 48rem;
  }

  .\\32xl\\:min-w-208{
    min-width: 52rem;
  }

  .\\32xl\\:min-w-224{
    min-width: 56rem;
  }

  .\\32xl\\:min-w-256{
    min-width: 64rem;
  }

  .\\32xl\\:min-w-px{
    min-width: 1px;
  }

  .\\32xl\\:min-w-full{
    min-width: 100%;
  }

  .\\32xl\\:object-contain{
    object-fit: contain;
  }

  .\\32xl\\:object-cover{
    object-fit: cover;
  }

  .\\32xl\\:object-fill{
    object-fit: fill;
  }

  .\\32xl\\:object-none{
    object-fit: none;
  }

  .\\32xl\\:object-scale-down{
    object-fit: scale-down;
  }

  .\\32xl\\:object-bottom{
    object-position: bottom;
  }

  .\\32xl\\:object-center{
    object-position: center;
  }

  .\\32xl\\:object-left{
    object-position: left;
  }

  .\\32xl\\:object-left-bottom{
    object-position: left bottom;
  }

  .\\32xl\\:object-left-top{
    object-position: left top;
  }

  .\\32xl\\:object-right{
    object-position: right;
  }

  .\\32xl\\:object-right-bottom{
    object-position: right bottom;
  }

  .\\32xl\\:object-right-top{
    object-position: right top;
  }

  .\\32xl\\:object-top{
    object-position: top;
  }

  .\\32xl\\:opacity-0{
    opacity: 0;
  }

  .\\32xl\\:opacity-25{
    opacity: .25;
  }

  .\\32xl\\:opacity-50{
    opacity: .5;
  }

  .\\32xl\\:opacity-75{
    opacity: .75;
  }

  .\\32xl\\:opacity-100{
    opacity: 1;
  }

  .\\32xl\\:overflow-auto{
    overflow: auto;
  }

  .\\32xl\\:overflow-hidden{
    overflow: hidden;
  }

  .\\32xl\\:overflow-visible{
    overflow: visible;
  }

  .\\32xl\\:overflow-scroll{
    overflow: scroll;
  }

  .\\32xl\\:overflow-x-auto{
    overflow-x: auto;
  }

  .\\32xl\\:overflow-y-auto{
    overflow-y: auto;
  }

  .\\32xl\\:overflow-x-hidden{
    overflow-x: hidden;
  }

  .\\32xl\\:overflow-y-hidden{
    overflow-y: hidden;
  }

  .\\32xl\\:overflow-x-visible{
    overflow-x: visible;
  }

  .\\32xl\\:overflow-y-visible{
    overflow-y: visible;
  }

  .\\32xl\\:overflow-x-scroll{
    overflow-x: scroll;
  }

  .\\32xl\\:overflow-y-scroll{
    overflow-y: scroll;
  }

  .\\32xl\\:scrolling-touch{
    -webkit-overflow-scrolling: touch;
  }

  .\\32xl\\:scrolling-auto{
    -webkit-overflow-scrolling: auto;
  }

  .\\32xl\\:overscroll-auto{
    overscroll-behavior: auto;
  }

  .\\32xl\\:overscroll-contain{
    overscroll-behavior: contain;
  }

  .\\32xl\\:overscroll-none{
    overscroll-behavior: none;
  }

  .\\32xl\\:overscroll-y-auto{
    overscroll-behavior-y: auto;
  }

  .\\32xl\\:overscroll-y-contain{
    overscroll-behavior-y: contain;
  }

  .\\32xl\\:overscroll-y-none{
    overscroll-behavior-y: none;
  }

  .\\32xl\\:overscroll-x-auto{
    overscroll-behavior-x: auto;
  }

  .\\32xl\\:overscroll-x-contain{
    overscroll-behavior-x: contain;
  }

  .\\32xl\\:overscroll-x-none{
    overscroll-behavior-x: none;
  }

  .\\32xl\\:p-0{
    padding: 0;
  }

  .\\32xl\\:p-1{
    padding: 0.25rem;
  }

  .\\32xl\\:p-2{
    padding: 0.5rem;
  }

  .\\32xl\\:p-3{
    padding: 0.75rem;
  }

  .\\32xl\\:p-4{
    padding: 1rem;
  }

  .\\32xl\\:p-5{
    padding: 1.25rem;
  }

  .\\32xl\\:p-6{
    padding: 1.5rem;
  }

  .\\32xl\\:p-7{
    padding: 1.75rem;
  }

  .\\32xl\\:p-8{
    padding: 2rem;
  }

  .\\32xl\\:p-9{
    padding: 2.25rem;
  }

  .\\32xl\\:p-10{
    padding: 2.5rem;
  }

  .\\32xl\\:p-11{
    padding: 2.75rem;
  }

  .\\32xl\\:p-12{
    padding: 3rem;
  }

  .\\32xl\\:p-14{
    padding: 3.5rem;
  }

  .\\32xl\\:p-15{
    padding: 3.75rem;
  }

  .\\32xl\\:p-16{
    padding: 4rem;
  }

  .\\32xl\\:p-18{
    padding: 4.5rem;
  }

  .\\32xl\\:p-20{
    padding: 5rem;
  }

  .\\32xl\\:p-22{
    padding: 5.5rem;
  }

  .\\32xl\\:p-23{
    padding: 5.75rem;
  }

  .\\32xl\\:p-24{
    padding: 6rem;
  }

  .\\32xl\\:p-25{
    padding: 6.25rem;
  }

  .\\32xl\\:p-26{
    padding: 6.5rem;
  }

  .\\32xl\\:p-28{
    padding: 7rem;
  }

  .\\32xl\\:p-30{
    padding: 7.5rem;
  }

  .\\32xl\\:p-32{
    padding: 8rem;
  }

  .\\32xl\\:p-34{
    padding: 8.5rem;
  }

  .\\32xl\\:p-40{
    padding: 10rem;
  }

  .\\32xl\\:p-42{
    padding: 10.5rem;
  }

  .\\32xl\\:p-44{
    padding: 11rem;
  }

  .\\32xl\\:p-48{
    padding: 12rem;
  }

  .\\32xl\\:p-52{
    padding: 13rem;
  }

  .\\32xl\\:p-54{
    padding: 13.5rem;
  }

  .\\32xl\\:p-56{
    padding: 14rem;
  }

  .\\32xl\\:p-60{
    padding: 15rem;
  }

  .\\32xl\\:p-64{
    padding: 16rem;
  }

  .\\32xl\\:p-68{
    padding: 17rem;
  }

  .\\32xl\\:p-72{
    padding: 18rem;
  }

  .\\32xl\\:p-74{
    padding: 18.5rem;
  }

  .\\32xl\\:p-76{
    padding: 19rem;
  }

  .\\32xl\\:p-78{
    padding: 19.5rem;
  }

  .\\32xl\\:p-80{
    padding: 20rem;
  }

  .\\32xl\\:p-82{
    padding: 20.5rem;
  }

  .\\32xl\\:p-84{
    padding: 21rem;
  }

  .\\32xl\\:p-88{
    padding: 22rem;
  }

  .\\32xl\\:p-92{
    padding: 23rem;
  }

  .\\32xl\\:p-96{
    padding: 24rem;
  }

  .\\32xl\\:p-98{
    padding: 24.5rem;
  }

  .\\32xl\\:p-100{
    padding: 25rem;
  }

  .\\32xl\\:p-104{
    padding: 26rem;
  }

  .\\32xl\\:p-112{
    padding: 28rem;
  }

  .\\32xl\\:p-124{
    padding: 31rem;
  }

  .\\32xl\\:p-128{
    padding: 32rem;
  }

  .\\32xl\\:p-140{
    padding: 35rem;
  }

  .\\32xl\\:p-152{
    padding: 38rem;
  }

  .\\32xl\\:p-160{
    padding: 40rem;
  }

  .\\32xl\\:p-162{
    padding: 41rem;
  }

  .\\32xl\\:p-192{
    padding: 48rem;
  }

  .\\32xl\\:p-208{
    padding: 52rem;
  }

  .\\32xl\\:p-224{
    padding: 56rem;
  }

  .\\32xl\\:p-256{
    padding: 64rem;
  }

  .\\32xl\\:p-px{
    padding: 1px;
  }

  .\\32xl\\:py-0{
    padding-top: 0;
    padding-bottom: 0;
  }

  .\\32xl\\:px-0{
    padding-left: 0;
    padding-right: 0;
  }

  .\\32xl\\:py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .\\32xl\\:px-1{
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .\\32xl\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .\\32xl\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .\\32xl\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .\\32xl\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .\\32xl\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .\\32xl\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .\\32xl\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .\\32xl\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .\\32xl\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .\\32xl\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .\\32xl\\:py-7{
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .\\32xl\\:px-7{
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .\\32xl\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .\\32xl\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .\\32xl\\:py-9{
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .\\32xl\\:px-9{
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .\\32xl\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .\\32xl\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .\\32xl\\:py-11{
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .\\32xl\\:px-11{
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .\\32xl\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .\\32xl\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .\\32xl\\:py-14{
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .\\32xl\\:px-14{
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .\\32xl\\:py-15{
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .\\32xl\\:px-15{
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .\\32xl\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .\\32xl\\:px-16{
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .\\32xl\\:py-18{
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .\\32xl\\:px-18{
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .\\32xl\\:py-20{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .\\32xl\\:px-20{
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .\\32xl\\:py-22{
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .\\32xl\\:px-22{
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .\\32xl\\:py-23{
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .\\32xl\\:px-23{
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .\\32xl\\:py-24{
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .\\32xl\\:px-24{
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .\\32xl\\:py-25{
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .\\32xl\\:px-25{
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .\\32xl\\:py-26{
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .\\32xl\\:px-26{
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .\\32xl\\:py-28{
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .\\32xl\\:px-28{
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .\\32xl\\:py-30{
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .\\32xl\\:px-30{
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .\\32xl\\:py-32{
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .\\32xl\\:px-32{
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .\\32xl\\:py-34{
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .\\32xl\\:px-34{
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .\\32xl\\:py-40{
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .\\32xl\\:px-40{
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .\\32xl\\:py-42{
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .\\32xl\\:px-42{
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .\\32xl\\:py-44{
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .\\32xl\\:px-44{
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .\\32xl\\:py-48{
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .\\32xl\\:px-48{
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .\\32xl\\:py-52{
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .\\32xl\\:px-52{
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .\\32xl\\:py-54{
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .\\32xl\\:px-54{
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .\\32xl\\:py-56{
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .\\32xl\\:px-56{
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .\\32xl\\:py-60{
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .\\32xl\\:px-60{
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .\\32xl\\:py-64{
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .\\32xl\\:px-64{
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .\\32xl\\:py-68{
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .\\32xl\\:px-68{
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .\\32xl\\:py-72{
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .\\32xl\\:px-72{
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .\\32xl\\:py-74{
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .\\32xl\\:px-74{
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .\\32xl\\:py-76{
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .\\32xl\\:px-76{
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .\\32xl\\:py-78{
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .\\32xl\\:px-78{
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .\\32xl\\:py-80{
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .\\32xl\\:px-80{
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .\\32xl\\:py-82{
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .\\32xl\\:px-82{
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .\\32xl\\:py-84{
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .\\32xl\\:px-84{
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .\\32xl\\:py-88{
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .\\32xl\\:px-88{
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .\\32xl\\:py-92{
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .\\32xl\\:px-92{
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .\\32xl\\:py-96{
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .\\32xl\\:px-96{
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .\\32xl\\:py-98{
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .\\32xl\\:px-98{
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .\\32xl\\:py-100{
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .\\32xl\\:px-100{
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .\\32xl\\:py-104{
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .\\32xl\\:px-104{
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .\\32xl\\:py-112{
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .\\32xl\\:px-112{
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .\\32xl\\:py-124{
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .\\32xl\\:px-124{
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .\\32xl\\:py-128{
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .\\32xl\\:px-128{
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .\\32xl\\:py-140{
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .\\32xl\\:px-140{
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .\\32xl\\:py-152{
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .\\32xl\\:px-152{
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .\\32xl\\:py-160{
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .\\32xl\\:px-160{
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .\\32xl\\:py-162{
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .\\32xl\\:px-162{
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .\\32xl\\:py-192{
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .\\32xl\\:px-192{
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .\\32xl\\:py-208{
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .\\32xl\\:px-208{
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .\\32xl\\:py-224{
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .\\32xl\\:px-224{
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .\\32xl\\:py-256{
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .\\32xl\\:px-256{
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .\\32xl\\:py-px{
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .\\32xl\\:px-px{
    padding-left: 1px;
    padding-right: 1px;
  }

  .\\32xl\\:pt-0{
    padding-top: 0;
  }

  .\\32xl\\:pr-0{
    padding-right: 0;
  }

  .\\32xl\\:pb-0{
    padding-bottom: 0;
  }

  .\\32xl\\:pl-0{
    padding-left: 0;
  }

  .\\32xl\\:pt-1{
    padding-top: 0.25rem;
  }

  .\\32xl\\:pr-1{
    padding-right: 0.25rem;
  }

  .\\32xl\\:pb-1{
    padding-bottom: 0.25rem;
  }

  .\\32xl\\:pl-1{
    padding-left: 0.25rem;
  }

  .\\32xl\\:pt-2{
    padding-top: 0.5rem;
  }

  .\\32xl\\:pr-2{
    padding-right: 0.5rem;
  }

  .\\32xl\\:pb-2{
    padding-bottom: 0.5rem;
  }

  .\\32xl\\:pl-2{
    padding-left: 0.5rem;
  }

  .\\32xl\\:pt-3{
    padding-top: 0.75rem;
  }

  .\\32xl\\:pr-3{
    padding-right: 0.75rem;
  }

  .\\32xl\\:pb-3{
    padding-bottom: 0.75rem;
  }

  .\\32xl\\:pl-3{
    padding-left: 0.75rem;
  }

  .\\32xl\\:pt-4{
    padding-top: 1rem;
  }

  .\\32xl\\:pr-4{
    padding-right: 1rem;
  }

  .\\32xl\\:pb-4{
    padding-bottom: 1rem;
  }

  .\\32xl\\:pl-4{
    padding-left: 1rem;
  }

  .\\32xl\\:pt-5{
    padding-top: 1.25rem;
  }

  .\\32xl\\:pr-5{
    padding-right: 1.25rem;
  }

  .\\32xl\\:pb-5{
    padding-bottom: 1.25rem;
  }

  .\\32xl\\:pl-5{
    padding-left: 1.25rem;
  }

  .\\32xl\\:pt-6{
    padding-top: 1.5rem;
  }

  .\\32xl\\:pr-6{
    padding-right: 1.5rem;
  }

  .\\32xl\\:pb-6{
    padding-bottom: 1.5rem;
  }

  .\\32xl\\:pl-6{
    padding-left: 1.5rem;
  }

  .\\32xl\\:pt-7{
    padding-top: 1.75rem;
  }

  .\\32xl\\:pr-7{
    padding-right: 1.75rem;
  }

  .\\32xl\\:pb-7{
    padding-bottom: 1.75rem;
  }

  .\\32xl\\:pl-7{
    padding-left: 1.75rem;
  }

  .\\32xl\\:pt-8{
    padding-top: 2rem;
  }

  .\\32xl\\:pr-8{
    padding-right: 2rem;
  }

  .\\32xl\\:pb-8{
    padding-bottom: 2rem;
  }

  .\\32xl\\:pl-8{
    padding-left: 2rem;
  }

  .\\32xl\\:pt-9{
    padding-top: 2.25rem;
  }

  .\\32xl\\:pr-9{
    padding-right: 2.25rem;
  }

  .\\32xl\\:pb-9{
    padding-bottom: 2.25rem;
  }

  .\\32xl\\:pl-9{
    padding-left: 2.25rem;
  }

  .\\32xl\\:pt-10{
    padding-top: 2.5rem;
  }

  .\\32xl\\:pr-10{
    padding-right: 2.5rem;
  }

  .\\32xl\\:pb-10{
    padding-bottom: 2.5rem;
  }

  .\\32xl\\:pl-10{
    padding-left: 2.5rem;
  }

  .\\32xl\\:pt-11{
    padding-top: 2.75rem;
  }

  .\\32xl\\:pr-11{
    padding-right: 2.75rem;
  }

  .\\32xl\\:pb-11{
    padding-bottom: 2.75rem;
  }

  .\\32xl\\:pl-11{
    padding-left: 2.75rem;
  }

  .\\32xl\\:pt-12{
    padding-top: 3rem;
  }

  .\\32xl\\:pr-12{
    padding-right: 3rem;
  }

  .\\32xl\\:pb-12{
    padding-bottom: 3rem;
  }

  .\\32xl\\:pl-12{
    padding-left: 3rem;
  }

  .\\32xl\\:pt-14{
    padding-top: 3.5rem;
  }

  .\\32xl\\:pr-14{
    padding-right: 3.5rem;
  }

  .\\32xl\\:pb-14{
    padding-bottom: 3.5rem;
  }

  .\\32xl\\:pl-14{
    padding-left: 3.5rem;
  }

  .\\32xl\\:pt-15{
    padding-top: 3.75rem;
  }

  .\\32xl\\:pr-15{
    padding-right: 3.75rem;
  }

  .\\32xl\\:pb-15{
    padding-bottom: 3.75rem;
  }

  .\\32xl\\:pl-15{
    padding-left: 3.75rem;
  }

  .\\32xl\\:pt-16{
    padding-top: 4rem;
  }

  .\\32xl\\:pr-16{
    padding-right: 4rem;
  }

  .\\32xl\\:pb-16{
    padding-bottom: 4rem;
  }

  .\\32xl\\:pl-16{
    padding-left: 4rem;
  }

  .\\32xl\\:pt-18{
    padding-top: 4.5rem;
  }

  .\\32xl\\:pr-18{
    padding-right: 4.5rem;
  }

  .\\32xl\\:pb-18{
    padding-bottom: 4.5rem;
  }

  .\\32xl\\:pl-18{
    padding-left: 4.5rem;
  }

  .\\32xl\\:pt-20{
    padding-top: 5rem;
  }

  .\\32xl\\:pr-20{
    padding-right: 5rem;
  }

  .\\32xl\\:pb-20{
    padding-bottom: 5rem;
  }

  .\\32xl\\:pl-20{
    padding-left: 5rem;
  }

  .\\32xl\\:pt-22{
    padding-top: 5.5rem;
  }

  .\\32xl\\:pr-22{
    padding-right: 5.5rem;
  }

  .\\32xl\\:pb-22{
    padding-bottom: 5.5rem;
  }

  .\\32xl\\:pl-22{
    padding-left: 5.5rem;
  }

  .\\32xl\\:pt-23{
    padding-top: 5.75rem;
  }

  .\\32xl\\:pr-23{
    padding-right: 5.75rem;
  }

  .\\32xl\\:pb-23{
    padding-bottom: 5.75rem;
  }

  .\\32xl\\:pl-23{
    padding-left: 5.75rem;
  }

  .\\32xl\\:pt-24{
    padding-top: 6rem;
  }

  .\\32xl\\:pr-24{
    padding-right: 6rem;
  }

  .\\32xl\\:pb-24{
    padding-bottom: 6rem;
  }

  .\\32xl\\:pl-24{
    padding-left: 6rem;
  }

  .\\32xl\\:pt-25{
    padding-top: 6.25rem;
  }

  .\\32xl\\:pr-25{
    padding-right: 6.25rem;
  }

  .\\32xl\\:pb-25{
    padding-bottom: 6.25rem;
  }

  .\\32xl\\:pl-25{
    padding-left: 6.25rem;
  }

  .\\32xl\\:pt-26{
    padding-top: 6.5rem;
  }

  .\\32xl\\:pr-26{
    padding-right: 6.5rem;
  }

  .\\32xl\\:pb-26{
    padding-bottom: 6.5rem;
  }

  .\\32xl\\:pl-26{
    padding-left: 6.5rem;
  }

  .\\32xl\\:pt-28{
    padding-top: 7rem;
  }

  .\\32xl\\:pr-28{
    padding-right: 7rem;
  }

  .\\32xl\\:pb-28{
    padding-bottom: 7rem;
  }

  .\\32xl\\:pl-28{
    padding-left: 7rem;
  }

  .\\32xl\\:pt-30{
    padding-top: 7.5rem;
  }

  .\\32xl\\:pr-30{
    padding-right: 7.5rem;
  }

  .\\32xl\\:pb-30{
    padding-bottom: 7.5rem;
  }

  .\\32xl\\:pl-30{
    padding-left: 7.5rem;
  }

  .\\32xl\\:pt-32{
    padding-top: 8rem;
  }

  .\\32xl\\:pr-32{
    padding-right: 8rem;
  }

  .\\32xl\\:pb-32{
    padding-bottom: 8rem;
  }

  .\\32xl\\:pl-32{
    padding-left: 8rem;
  }

  .\\32xl\\:pt-34{
    padding-top: 8.5rem;
  }

  .\\32xl\\:pr-34{
    padding-right: 8.5rem;
  }

  .\\32xl\\:pb-34{
    padding-bottom: 8.5rem;
  }

  .\\32xl\\:pl-34{
    padding-left: 8.5rem;
  }

  .\\32xl\\:pt-40{
    padding-top: 10rem;
  }

  .\\32xl\\:pr-40{
    padding-right: 10rem;
  }

  .\\32xl\\:pb-40{
    padding-bottom: 10rem;
  }

  .\\32xl\\:pl-40{
    padding-left: 10rem;
  }

  .\\32xl\\:pt-42{
    padding-top: 10.5rem;
  }

  .\\32xl\\:pr-42{
    padding-right: 10.5rem;
  }

  .\\32xl\\:pb-42{
    padding-bottom: 10.5rem;
  }

  .\\32xl\\:pl-42{
    padding-left: 10.5rem;
  }

  .\\32xl\\:pt-44{
    padding-top: 11rem;
  }

  .\\32xl\\:pr-44{
    padding-right: 11rem;
  }

  .\\32xl\\:pb-44{
    padding-bottom: 11rem;
  }

  .\\32xl\\:pl-44{
    padding-left: 11rem;
  }

  .\\32xl\\:pt-48{
    padding-top: 12rem;
  }

  .\\32xl\\:pr-48{
    padding-right: 12rem;
  }

  .\\32xl\\:pb-48{
    padding-bottom: 12rem;
  }

  .\\32xl\\:pl-48{
    padding-left: 12rem;
  }

  .\\32xl\\:pt-52{
    padding-top: 13rem;
  }

  .\\32xl\\:pr-52{
    padding-right: 13rem;
  }

  .\\32xl\\:pb-52{
    padding-bottom: 13rem;
  }

  .\\32xl\\:pl-52{
    padding-left: 13rem;
  }

  .\\32xl\\:pt-54{
    padding-top: 13.5rem;
  }

  .\\32xl\\:pr-54{
    padding-right: 13.5rem;
  }

  .\\32xl\\:pb-54{
    padding-bottom: 13.5rem;
  }

  .\\32xl\\:pl-54{
    padding-left: 13.5rem;
  }

  .\\32xl\\:pt-56{
    padding-top: 14rem;
  }

  .\\32xl\\:pr-56{
    padding-right: 14rem;
  }

  .\\32xl\\:pb-56{
    padding-bottom: 14rem;
  }

  .\\32xl\\:pl-56{
    padding-left: 14rem;
  }

  .\\32xl\\:pt-60{
    padding-top: 15rem;
  }

  .\\32xl\\:pr-60{
    padding-right: 15rem;
  }

  .\\32xl\\:pb-60{
    padding-bottom: 15rem;
  }

  .\\32xl\\:pl-60{
    padding-left: 15rem;
  }

  .\\32xl\\:pt-64{
    padding-top: 16rem;
  }

  .\\32xl\\:pr-64{
    padding-right: 16rem;
  }

  .\\32xl\\:pb-64{
    padding-bottom: 16rem;
  }

  .\\32xl\\:pl-64{
    padding-left: 16rem;
  }

  .\\32xl\\:pt-68{
    padding-top: 17rem;
  }

  .\\32xl\\:pr-68{
    padding-right: 17rem;
  }

  .\\32xl\\:pb-68{
    padding-bottom: 17rem;
  }

  .\\32xl\\:pl-68{
    padding-left: 17rem;
  }

  .\\32xl\\:pt-72{
    padding-top: 18rem;
  }

  .\\32xl\\:pr-72{
    padding-right: 18rem;
  }

  .\\32xl\\:pb-72{
    padding-bottom: 18rem;
  }

  .\\32xl\\:pl-72{
    padding-left: 18rem;
  }

  .\\32xl\\:pt-74{
    padding-top: 18.5rem;
  }

  .\\32xl\\:pr-74{
    padding-right: 18.5rem;
  }

  .\\32xl\\:pb-74{
    padding-bottom: 18.5rem;
  }

  .\\32xl\\:pl-74{
    padding-left: 18.5rem;
  }

  .\\32xl\\:pt-76{
    padding-top: 19rem;
  }

  .\\32xl\\:pr-76{
    padding-right: 19rem;
  }

  .\\32xl\\:pb-76{
    padding-bottom: 19rem;
  }

  .\\32xl\\:pl-76{
    padding-left: 19rem;
  }

  .\\32xl\\:pt-78{
    padding-top: 19.5rem;
  }

  .\\32xl\\:pr-78{
    padding-right: 19.5rem;
  }

  .\\32xl\\:pb-78{
    padding-bottom: 19.5rem;
  }

  .\\32xl\\:pl-78{
    padding-left: 19.5rem;
  }

  .\\32xl\\:pt-80{
    padding-top: 20rem;
  }

  .\\32xl\\:pr-80{
    padding-right: 20rem;
  }

  .\\32xl\\:pb-80{
    padding-bottom: 20rem;
  }

  .\\32xl\\:pl-80{
    padding-left: 20rem;
  }

  .\\32xl\\:pt-82{
    padding-top: 20.5rem;
  }

  .\\32xl\\:pr-82{
    padding-right: 20.5rem;
  }

  .\\32xl\\:pb-82{
    padding-bottom: 20.5rem;
  }

  .\\32xl\\:pl-82{
    padding-left: 20.5rem;
  }

  .\\32xl\\:pt-84{
    padding-top: 21rem;
  }

  .\\32xl\\:pr-84{
    padding-right: 21rem;
  }

  .\\32xl\\:pb-84{
    padding-bottom: 21rem;
  }

  .\\32xl\\:pl-84{
    padding-left: 21rem;
  }

  .\\32xl\\:pt-88{
    padding-top: 22rem;
  }

  .\\32xl\\:pr-88{
    padding-right: 22rem;
  }

  .\\32xl\\:pb-88{
    padding-bottom: 22rem;
  }

  .\\32xl\\:pl-88{
    padding-left: 22rem;
  }

  .\\32xl\\:pt-92{
    padding-top: 23rem;
  }

  .\\32xl\\:pr-92{
    padding-right: 23rem;
  }

  .\\32xl\\:pb-92{
    padding-bottom: 23rem;
  }

  .\\32xl\\:pl-92{
    padding-left: 23rem;
  }

  .\\32xl\\:pt-96{
    padding-top: 24rem;
  }

  .\\32xl\\:pr-96{
    padding-right: 24rem;
  }

  .\\32xl\\:pb-96{
    padding-bottom: 24rem;
  }

  .\\32xl\\:pl-96{
    padding-left: 24rem;
  }

  .\\32xl\\:pt-98{
    padding-top: 24.5rem;
  }

  .\\32xl\\:pr-98{
    padding-right: 24.5rem;
  }

  .\\32xl\\:pb-98{
    padding-bottom: 24.5rem;
  }

  .\\32xl\\:pl-98{
    padding-left: 24.5rem;
  }

  .\\32xl\\:pt-100{
    padding-top: 25rem;
  }

  .\\32xl\\:pr-100{
    padding-right: 25rem;
  }

  .\\32xl\\:pb-100{
    padding-bottom: 25rem;
  }

  .\\32xl\\:pl-100{
    padding-left: 25rem;
  }

  .\\32xl\\:pt-104{
    padding-top: 26rem;
  }

  .\\32xl\\:pr-104{
    padding-right: 26rem;
  }

  .\\32xl\\:pb-104{
    padding-bottom: 26rem;
  }

  .\\32xl\\:pl-104{
    padding-left: 26rem;
  }

  .\\32xl\\:pt-112{
    padding-top: 28rem;
  }

  .\\32xl\\:pr-112{
    padding-right: 28rem;
  }

  .\\32xl\\:pb-112{
    padding-bottom: 28rem;
  }

  .\\32xl\\:pl-112{
    padding-left: 28rem;
  }

  .\\32xl\\:pt-124{
    padding-top: 31rem;
  }

  .\\32xl\\:pr-124{
    padding-right: 31rem;
  }

  .\\32xl\\:pb-124{
    padding-bottom: 31rem;
  }

  .\\32xl\\:pl-124{
    padding-left: 31rem;
  }

  .\\32xl\\:pt-128{
    padding-top: 32rem;
  }

  .\\32xl\\:pr-128{
    padding-right: 32rem;
  }

  .\\32xl\\:pb-128{
    padding-bottom: 32rem;
  }

  .\\32xl\\:pl-128{
    padding-left: 32rem;
  }

  .\\32xl\\:pt-140{
    padding-top: 35rem;
  }

  .\\32xl\\:pr-140{
    padding-right: 35rem;
  }

  .\\32xl\\:pb-140{
    padding-bottom: 35rem;
  }

  .\\32xl\\:pl-140{
    padding-left: 35rem;
  }

  .\\32xl\\:pt-152{
    padding-top: 38rem;
  }

  .\\32xl\\:pr-152{
    padding-right: 38rem;
  }

  .\\32xl\\:pb-152{
    padding-bottom: 38rem;
  }

  .\\32xl\\:pl-152{
    padding-left: 38rem;
  }

  .\\32xl\\:pt-160{
    padding-top: 40rem;
  }

  .\\32xl\\:pr-160{
    padding-right: 40rem;
  }

  .\\32xl\\:pb-160{
    padding-bottom: 40rem;
  }

  .\\32xl\\:pl-160{
    padding-left: 40rem;
  }

  .\\32xl\\:pt-162{
    padding-top: 41rem;
  }

  .\\32xl\\:pr-162{
    padding-right: 41rem;
  }

  .\\32xl\\:pb-162{
    padding-bottom: 41rem;
  }

  .\\32xl\\:pl-162{
    padding-left: 41rem;
  }

  .\\32xl\\:pt-192{
    padding-top: 48rem;
  }

  .\\32xl\\:pr-192{
    padding-right: 48rem;
  }

  .\\32xl\\:pb-192{
    padding-bottom: 48rem;
  }

  .\\32xl\\:pl-192{
    padding-left: 48rem;
  }

  .\\32xl\\:pt-208{
    padding-top: 52rem;
  }

  .\\32xl\\:pr-208{
    padding-right: 52rem;
  }

  .\\32xl\\:pb-208{
    padding-bottom: 52rem;
  }

  .\\32xl\\:pl-208{
    padding-left: 52rem;
  }

  .\\32xl\\:pt-224{
    padding-top: 56rem;
  }

  .\\32xl\\:pr-224{
    padding-right: 56rem;
  }

  .\\32xl\\:pb-224{
    padding-bottom: 56rem;
  }

  .\\32xl\\:pl-224{
    padding-left: 56rem;
  }

  .\\32xl\\:pt-256{
    padding-top: 64rem;
  }

  .\\32xl\\:pr-256{
    padding-right: 64rem;
  }

  .\\32xl\\:pb-256{
    padding-bottom: 64rem;
  }

  .\\32xl\\:pl-256{
    padding-left: 64rem;
  }

  .\\32xl\\:pt-px{
    padding-top: 1px;
  }

  .\\32xl\\:pr-px{
    padding-right: 1px;
  }

  .\\32xl\\:pb-px{
    padding-bottom: 1px;
  }

  .\\32xl\\:pl-px{
    padding-left: 1px;
  }

  .\\32xl\\:odd\\:p-0:nth-child(odd){
    padding: 0;
  }

  .\\32xl\\:odd\\:p-1:nth-child(odd){
    padding: 0.25rem;
  }

  .\\32xl\\:odd\\:p-2:nth-child(odd){
    padding: 0.5rem;
  }

  .\\32xl\\:odd\\:p-3:nth-child(odd){
    padding: 0.75rem;
  }

  .\\32xl\\:odd\\:p-4:nth-child(odd){
    padding: 1rem;
  }

  .\\32xl\\:odd\\:p-5:nth-child(odd){
    padding: 1.25rem;
  }

  .\\32xl\\:odd\\:p-6:nth-child(odd){
    padding: 1.5rem;
  }

  .\\32xl\\:odd\\:p-7:nth-child(odd){
    padding: 1.75rem;
  }

  .\\32xl\\:odd\\:p-8:nth-child(odd){
    padding: 2rem;
  }

  .\\32xl\\:odd\\:p-9:nth-child(odd){
    padding: 2.25rem;
  }

  .\\32xl\\:odd\\:p-10:nth-child(odd){
    padding: 2.5rem;
  }

  .\\32xl\\:odd\\:p-11:nth-child(odd){
    padding: 2.75rem;
  }

  .\\32xl\\:odd\\:p-12:nth-child(odd){
    padding: 3rem;
  }

  .\\32xl\\:odd\\:p-14:nth-child(odd){
    padding: 3.5rem;
  }

  .\\32xl\\:odd\\:p-15:nth-child(odd){
    padding: 3.75rem;
  }

  .\\32xl\\:odd\\:p-16:nth-child(odd){
    padding: 4rem;
  }

  .\\32xl\\:odd\\:p-18:nth-child(odd){
    padding: 4.5rem;
  }

  .\\32xl\\:odd\\:p-20:nth-child(odd){
    padding: 5rem;
  }

  .\\32xl\\:odd\\:p-22:nth-child(odd){
    padding: 5.5rem;
  }

  .\\32xl\\:odd\\:p-23:nth-child(odd){
    padding: 5.75rem;
  }

  .\\32xl\\:odd\\:p-24:nth-child(odd){
    padding: 6rem;
  }

  .\\32xl\\:odd\\:p-25:nth-child(odd){
    padding: 6.25rem;
  }

  .\\32xl\\:odd\\:p-26:nth-child(odd){
    padding: 6.5rem;
  }

  .\\32xl\\:odd\\:p-28:nth-child(odd){
    padding: 7rem;
  }

  .\\32xl\\:odd\\:p-30:nth-child(odd){
    padding: 7.5rem;
  }

  .\\32xl\\:odd\\:p-32:nth-child(odd){
    padding: 8rem;
  }

  .\\32xl\\:odd\\:p-34:nth-child(odd){
    padding: 8.5rem;
  }

  .\\32xl\\:odd\\:p-40:nth-child(odd){
    padding: 10rem;
  }

  .\\32xl\\:odd\\:p-42:nth-child(odd){
    padding: 10.5rem;
  }

  .\\32xl\\:odd\\:p-44:nth-child(odd){
    padding: 11rem;
  }

  .\\32xl\\:odd\\:p-48:nth-child(odd){
    padding: 12rem;
  }

  .\\32xl\\:odd\\:p-52:nth-child(odd){
    padding: 13rem;
  }

  .\\32xl\\:odd\\:p-54:nth-child(odd){
    padding: 13.5rem;
  }

  .\\32xl\\:odd\\:p-56:nth-child(odd){
    padding: 14rem;
  }

  .\\32xl\\:odd\\:p-60:nth-child(odd){
    padding: 15rem;
  }

  .\\32xl\\:odd\\:p-64:nth-child(odd){
    padding: 16rem;
  }

  .\\32xl\\:odd\\:p-68:nth-child(odd){
    padding: 17rem;
  }

  .\\32xl\\:odd\\:p-72:nth-child(odd){
    padding: 18rem;
  }

  .\\32xl\\:odd\\:p-74:nth-child(odd){
    padding: 18.5rem;
  }

  .\\32xl\\:odd\\:p-76:nth-child(odd){
    padding: 19rem;
  }

  .\\32xl\\:odd\\:p-78:nth-child(odd){
    padding: 19.5rem;
  }

  .\\32xl\\:odd\\:p-80:nth-child(odd){
    padding: 20rem;
  }

  .\\32xl\\:odd\\:p-82:nth-child(odd){
    padding: 20.5rem;
  }

  .\\32xl\\:odd\\:p-84:nth-child(odd){
    padding: 21rem;
  }

  .\\32xl\\:odd\\:p-88:nth-child(odd){
    padding: 22rem;
  }

  .\\32xl\\:odd\\:p-92:nth-child(odd){
    padding: 23rem;
  }

  .\\32xl\\:odd\\:p-96:nth-child(odd){
    padding: 24rem;
  }

  .\\32xl\\:odd\\:p-98:nth-child(odd){
    padding: 24.5rem;
  }

  .\\32xl\\:odd\\:p-100:nth-child(odd){
    padding: 25rem;
  }

  .\\32xl\\:odd\\:p-104:nth-child(odd){
    padding: 26rem;
  }

  .\\32xl\\:odd\\:p-112:nth-child(odd){
    padding: 28rem;
  }

  .\\32xl\\:odd\\:p-124:nth-child(odd){
    padding: 31rem;
  }

  .\\32xl\\:odd\\:p-128:nth-child(odd){
    padding: 32rem;
  }

  .\\32xl\\:odd\\:p-140:nth-child(odd){
    padding: 35rem;
  }

  .\\32xl\\:odd\\:p-152:nth-child(odd){
    padding: 38rem;
  }

  .\\32xl\\:odd\\:p-160:nth-child(odd){
    padding: 40rem;
  }

  .\\32xl\\:odd\\:p-162:nth-child(odd){
    padding: 41rem;
  }

  .\\32xl\\:odd\\:p-192:nth-child(odd){
    padding: 48rem;
  }

  .\\32xl\\:odd\\:p-208:nth-child(odd){
    padding: 52rem;
  }

  .\\32xl\\:odd\\:p-224:nth-child(odd){
    padding: 56rem;
  }

  .\\32xl\\:odd\\:p-256:nth-child(odd){
    padding: 64rem;
  }

  .\\32xl\\:odd\\:p-px:nth-child(odd){
    padding: 1px;
  }

  .\\32xl\\:odd\\:py-0:nth-child(odd){
    padding-top: 0;
    padding-bottom: 0;
  }

  .\\32xl\\:odd\\:px-0:nth-child(odd){
    padding-left: 0;
    padding-right: 0;
  }

  .\\32xl\\:odd\\:py-1:nth-child(odd){
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .\\32xl\\:odd\\:px-1:nth-child(odd){
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .\\32xl\\:odd\\:py-2:nth-child(odd){
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .\\32xl\\:odd\\:px-2:nth-child(odd){
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .\\32xl\\:odd\\:py-3:nth-child(odd){
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .\\32xl\\:odd\\:px-3:nth-child(odd){
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .\\32xl\\:odd\\:py-4:nth-child(odd){
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .\\32xl\\:odd\\:px-4:nth-child(odd){
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .\\32xl\\:odd\\:py-5:nth-child(odd){
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .\\32xl\\:odd\\:px-5:nth-child(odd){
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .\\32xl\\:odd\\:py-6:nth-child(odd){
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .\\32xl\\:odd\\:px-6:nth-child(odd){
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .\\32xl\\:odd\\:py-7:nth-child(odd){
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .\\32xl\\:odd\\:px-7:nth-child(odd){
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .\\32xl\\:odd\\:py-8:nth-child(odd){
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .\\32xl\\:odd\\:px-8:nth-child(odd){
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .\\32xl\\:odd\\:py-9:nth-child(odd){
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .\\32xl\\:odd\\:px-9:nth-child(odd){
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .\\32xl\\:odd\\:py-10:nth-child(odd){
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .\\32xl\\:odd\\:px-10:nth-child(odd){
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .\\32xl\\:odd\\:py-11:nth-child(odd){
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .\\32xl\\:odd\\:px-11:nth-child(odd){
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .\\32xl\\:odd\\:py-12:nth-child(odd){
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .\\32xl\\:odd\\:px-12:nth-child(odd){
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .\\32xl\\:odd\\:py-14:nth-child(odd){
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .\\32xl\\:odd\\:px-14:nth-child(odd){
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .\\32xl\\:odd\\:py-15:nth-child(odd){
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .\\32xl\\:odd\\:px-15:nth-child(odd){
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .\\32xl\\:odd\\:py-16:nth-child(odd){
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .\\32xl\\:odd\\:px-16:nth-child(odd){
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .\\32xl\\:odd\\:py-18:nth-child(odd){
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .\\32xl\\:odd\\:px-18:nth-child(odd){
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .\\32xl\\:odd\\:py-20:nth-child(odd){
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .\\32xl\\:odd\\:px-20:nth-child(odd){
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .\\32xl\\:odd\\:py-22:nth-child(odd){
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .\\32xl\\:odd\\:px-22:nth-child(odd){
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .\\32xl\\:odd\\:py-23:nth-child(odd){
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .\\32xl\\:odd\\:px-23:nth-child(odd){
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .\\32xl\\:odd\\:py-24:nth-child(odd){
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .\\32xl\\:odd\\:px-24:nth-child(odd){
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .\\32xl\\:odd\\:py-25:nth-child(odd){
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .\\32xl\\:odd\\:px-25:nth-child(odd){
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .\\32xl\\:odd\\:py-26:nth-child(odd){
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .\\32xl\\:odd\\:px-26:nth-child(odd){
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .\\32xl\\:odd\\:py-28:nth-child(odd){
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .\\32xl\\:odd\\:px-28:nth-child(odd){
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .\\32xl\\:odd\\:py-30:nth-child(odd){
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .\\32xl\\:odd\\:px-30:nth-child(odd){
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .\\32xl\\:odd\\:py-32:nth-child(odd){
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .\\32xl\\:odd\\:px-32:nth-child(odd){
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .\\32xl\\:odd\\:py-34:nth-child(odd){
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .\\32xl\\:odd\\:px-34:nth-child(odd){
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .\\32xl\\:odd\\:py-40:nth-child(odd){
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .\\32xl\\:odd\\:px-40:nth-child(odd){
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .\\32xl\\:odd\\:py-42:nth-child(odd){
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .\\32xl\\:odd\\:px-42:nth-child(odd){
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .\\32xl\\:odd\\:py-44:nth-child(odd){
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .\\32xl\\:odd\\:px-44:nth-child(odd){
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .\\32xl\\:odd\\:py-48:nth-child(odd){
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .\\32xl\\:odd\\:px-48:nth-child(odd){
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .\\32xl\\:odd\\:py-52:nth-child(odd){
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .\\32xl\\:odd\\:px-52:nth-child(odd){
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .\\32xl\\:odd\\:py-54:nth-child(odd){
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .\\32xl\\:odd\\:px-54:nth-child(odd){
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .\\32xl\\:odd\\:py-56:nth-child(odd){
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .\\32xl\\:odd\\:px-56:nth-child(odd){
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .\\32xl\\:odd\\:py-60:nth-child(odd){
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .\\32xl\\:odd\\:px-60:nth-child(odd){
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .\\32xl\\:odd\\:py-64:nth-child(odd){
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .\\32xl\\:odd\\:px-64:nth-child(odd){
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .\\32xl\\:odd\\:py-68:nth-child(odd){
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .\\32xl\\:odd\\:px-68:nth-child(odd){
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .\\32xl\\:odd\\:py-72:nth-child(odd){
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .\\32xl\\:odd\\:px-72:nth-child(odd){
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .\\32xl\\:odd\\:py-74:nth-child(odd){
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .\\32xl\\:odd\\:px-74:nth-child(odd){
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .\\32xl\\:odd\\:py-76:nth-child(odd){
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .\\32xl\\:odd\\:px-76:nth-child(odd){
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .\\32xl\\:odd\\:py-78:nth-child(odd){
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .\\32xl\\:odd\\:px-78:nth-child(odd){
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .\\32xl\\:odd\\:py-80:nth-child(odd){
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .\\32xl\\:odd\\:px-80:nth-child(odd){
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .\\32xl\\:odd\\:py-82:nth-child(odd){
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .\\32xl\\:odd\\:px-82:nth-child(odd){
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .\\32xl\\:odd\\:py-84:nth-child(odd){
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .\\32xl\\:odd\\:px-84:nth-child(odd){
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .\\32xl\\:odd\\:py-88:nth-child(odd){
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .\\32xl\\:odd\\:px-88:nth-child(odd){
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .\\32xl\\:odd\\:py-92:nth-child(odd){
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .\\32xl\\:odd\\:px-92:nth-child(odd){
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .\\32xl\\:odd\\:py-96:nth-child(odd){
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .\\32xl\\:odd\\:px-96:nth-child(odd){
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .\\32xl\\:odd\\:py-98:nth-child(odd){
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .\\32xl\\:odd\\:px-98:nth-child(odd){
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .\\32xl\\:odd\\:py-100:nth-child(odd){
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .\\32xl\\:odd\\:px-100:nth-child(odd){
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .\\32xl\\:odd\\:py-104:nth-child(odd){
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .\\32xl\\:odd\\:px-104:nth-child(odd){
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .\\32xl\\:odd\\:py-112:nth-child(odd){
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .\\32xl\\:odd\\:px-112:nth-child(odd){
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .\\32xl\\:odd\\:py-124:nth-child(odd){
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .\\32xl\\:odd\\:px-124:nth-child(odd){
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .\\32xl\\:odd\\:py-128:nth-child(odd){
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .\\32xl\\:odd\\:px-128:nth-child(odd){
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .\\32xl\\:odd\\:py-140:nth-child(odd){
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .\\32xl\\:odd\\:px-140:nth-child(odd){
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .\\32xl\\:odd\\:py-152:nth-child(odd){
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .\\32xl\\:odd\\:px-152:nth-child(odd){
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .\\32xl\\:odd\\:py-160:nth-child(odd){
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .\\32xl\\:odd\\:px-160:nth-child(odd){
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .\\32xl\\:odd\\:py-162:nth-child(odd){
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .\\32xl\\:odd\\:px-162:nth-child(odd){
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .\\32xl\\:odd\\:py-192:nth-child(odd){
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .\\32xl\\:odd\\:px-192:nth-child(odd){
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .\\32xl\\:odd\\:py-208:nth-child(odd){
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .\\32xl\\:odd\\:px-208:nth-child(odd){
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .\\32xl\\:odd\\:py-224:nth-child(odd){
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .\\32xl\\:odd\\:px-224:nth-child(odd){
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .\\32xl\\:odd\\:py-256:nth-child(odd){
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .\\32xl\\:odd\\:px-256:nth-child(odd){
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .\\32xl\\:odd\\:py-px:nth-child(odd){
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .\\32xl\\:odd\\:px-px:nth-child(odd){
    padding-left: 1px;
    padding-right: 1px;
  }

  .\\32xl\\:odd\\:pt-0:nth-child(odd){
    padding-top: 0;
  }

  .\\32xl\\:odd\\:pr-0:nth-child(odd){
    padding-right: 0;
  }

  .\\32xl\\:odd\\:pb-0:nth-child(odd){
    padding-bottom: 0;
  }

  .\\32xl\\:odd\\:pl-0:nth-child(odd){
    padding-left: 0;
  }

  .\\32xl\\:odd\\:pt-1:nth-child(odd){
    padding-top: 0.25rem;
  }

  .\\32xl\\:odd\\:pr-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  .\\32xl\\:odd\\:pb-1:nth-child(odd){
    padding-bottom: 0.25rem;
  }

  .\\32xl\\:odd\\:pl-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  .\\32xl\\:odd\\:pt-2:nth-child(odd){
    padding-top: 0.5rem;
  }

  .\\32xl\\:odd\\:pr-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  .\\32xl\\:odd\\:pb-2:nth-child(odd){
    padding-bottom: 0.5rem;
  }

  .\\32xl\\:odd\\:pl-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  .\\32xl\\:odd\\:pt-3:nth-child(odd){
    padding-top: 0.75rem;
  }

  .\\32xl\\:odd\\:pr-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  .\\32xl\\:odd\\:pb-3:nth-child(odd){
    padding-bottom: 0.75rem;
  }

  .\\32xl\\:odd\\:pl-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  .\\32xl\\:odd\\:pt-4:nth-child(odd){
    padding-top: 1rem;
  }

  .\\32xl\\:odd\\:pr-4:nth-child(odd){
    padding-right: 1rem;
  }

  .\\32xl\\:odd\\:pb-4:nth-child(odd){
    padding-bottom: 1rem;
  }

  .\\32xl\\:odd\\:pl-4:nth-child(odd){
    padding-left: 1rem;
  }

  .\\32xl\\:odd\\:pt-5:nth-child(odd){
    padding-top: 1.25rem;
  }

  .\\32xl\\:odd\\:pr-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  .\\32xl\\:odd\\:pb-5:nth-child(odd){
    padding-bottom: 1.25rem;
  }

  .\\32xl\\:odd\\:pl-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  .\\32xl\\:odd\\:pt-6:nth-child(odd){
    padding-top: 1.5rem;
  }

  .\\32xl\\:odd\\:pr-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  .\\32xl\\:odd\\:pb-6:nth-child(odd){
    padding-bottom: 1.5rem;
  }

  .\\32xl\\:odd\\:pl-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  .\\32xl\\:odd\\:pt-7:nth-child(odd){
    padding-top: 1.75rem;
  }

  .\\32xl\\:odd\\:pr-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  .\\32xl\\:odd\\:pb-7:nth-child(odd){
    padding-bottom: 1.75rem;
  }

  .\\32xl\\:odd\\:pl-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  .\\32xl\\:odd\\:pt-8:nth-child(odd){
    padding-top: 2rem;
  }

  .\\32xl\\:odd\\:pr-8:nth-child(odd){
    padding-right: 2rem;
  }

  .\\32xl\\:odd\\:pb-8:nth-child(odd){
    padding-bottom: 2rem;
  }

  .\\32xl\\:odd\\:pl-8:nth-child(odd){
    padding-left: 2rem;
  }

  .\\32xl\\:odd\\:pt-9:nth-child(odd){
    padding-top: 2.25rem;
  }

  .\\32xl\\:odd\\:pr-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  .\\32xl\\:odd\\:pb-9:nth-child(odd){
    padding-bottom: 2.25rem;
  }

  .\\32xl\\:odd\\:pl-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  .\\32xl\\:odd\\:pt-10:nth-child(odd){
    padding-top: 2.5rem;
  }

  .\\32xl\\:odd\\:pr-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  .\\32xl\\:odd\\:pb-10:nth-child(odd){
    padding-bottom: 2.5rem;
  }

  .\\32xl\\:odd\\:pl-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  .\\32xl\\:odd\\:pt-11:nth-child(odd){
    padding-top: 2.75rem;
  }

  .\\32xl\\:odd\\:pr-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  .\\32xl\\:odd\\:pb-11:nth-child(odd){
    padding-bottom: 2.75rem;
  }

  .\\32xl\\:odd\\:pl-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  .\\32xl\\:odd\\:pt-12:nth-child(odd){
    padding-top: 3rem;
  }

  .\\32xl\\:odd\\:pr-12:nth-child(odd){
    padding-right: 3rem;
  }

  .\\32xl\\:odd\\:pb-12:nth-child(odd){
    padding-bottom: 3rem;
  }

  .\\32xl\\:odd\\:pl-12:nth-child(odd){
    padding-left: 3rem;
  }

  .\\32xl\\:odd\\:pt-14:nth-child(odd){
    padding-top: 3.5rem;
  }

  .\\32xl\\:odd\\:pr-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  .\\32xl\\:odd\\:pb-14:nth-child(odd){
    padding-bottom: 3.5rem;
  }

  .\\32xl\\:odd\\:pl-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  .\\32xl\\:odd\\:pt-15:nth-child(odd){
    padding-top: 3.75rem;
  }

  .\\32xl\\:odd\\:pr-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  .\\32xl\\:odd\\:pb-15:nth-child(odd){
    padding-bottom: 3.75rem;
  }

  .\\32xl\\:odd\\:pl-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  .\\32xl\\:odd\\:pt-16:nth-child(odd){
    padding-top: 4rem;
  }

  .\\32xl\\:odd\\:pr-16:nth-child(odd){
    padding-right: 4rem;
  }

  .\\32xl\\:odd\\:pb-16:nth-child(odd){
    padding-bottom: 4rem;
  }

  .\\32xl\\:odd\\:pl-16:nth-child(odd){
    padding-left: 4rem;
  }

  .\\32xl\\:odd\\:pt-18:nth-child(odd){
    padding-top: 4.5rem;
  }

  .\\32xl\\:odd\\:pr-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  .\\32xl\\:odd\\:pb-18:nth-child(odd){
    padding-bottom: 4.5rem;
  }

  .\\32xl\\:odd\\:pl-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  .\\32xl\\:odd\\:pt-20:nth-child(odd){
    padding-top: 5rem;
  }

  .\\32xl\\:odd\\:pr-20:nth-child(odd){
    padding-right: 5rem;
  }

  .\\32xl\\:odd\\:pb-20:nth-child(odd){
    padding-bottom: 5rem;
  }

  .\\32xl\\:odd\\:pl-20:nth-child(odd){
    padding-left: 5rem;
  }

  .\\32xl\\:odd\\:pt-22:nth-child(odd){
    padding-top: 5.5rem;
  }

  .\\32xl\\:odd\\:pr-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  .\\32xl\\:odd\\:pb-22:nth-child(odd){
    padding-bottom: 5.5rem;
  }

  .\\32xl\\:odd\\:pl-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  .\\32xl\\:odd\\:pt-23:nth-child(odd){
    padding-top: 5.75rem;
  }

  .\\32xl\\:odd\\:pr-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  .\\32xl\\:odd\\:pb-23:nth-child(odd){
    padding-bottom: 5.75rem;
  }

  .\\32xl\\:odd\\:pl-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  .\\32xl\\:odd\\:pt-24:nth-child(odd){
    padding-top: 6rem;
  }

  .\\32xl\\:odd\\:pr-24:nth-child(odd){
    padding-right: 6rem;
  }

  .\\32xl\\:odd\\:pb-24:nth-child(odd){
    padding-bottom: 6rem;
  }

  .\\32xl\\:odd\\:pl-24:nth-child(odd){
    padding-left: 6rem;
  }

  .\\32xl\\:odd\\:pt-25:nth-child(odd){
    padding-top: 6.25rem;
  }

  .\\32xl\\:odd\\:pr-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  .\\32xl\\:odd\\:pb-25:nth-child(odd){
    padding-bottom: 6.25rem;
  }

  .\\32xl\\:odd\\:pl-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  .\\32xl\\:odd\\:pt-26:nth-child(odd){
    padding-top: 6.5rem;
  }

  .\\32xl\\:odd\\:pr-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  .\\32xl\\:odd\\:pb-26:nth-child(odd){
    padding-bottom: 6.5rem;
  }

  .\\32xl\\:odd\\:pl-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  .\\32xl\\:odd\\:pt-28:nth-child(odd){
    padding-top: 7rem;
  }

  .\\32xl\\:odd\\:pr-28:nth-child(odd){
    padding-right: 7rem;
  }

  .\\32xl\\:odd\\:pb-28:nth-child(odd){
    padding-bottom: 7rem;
  }

  .\\32xl\\:odd\\:pl-28:nth-child(odd){
    padding-left: 7rem;
  }

  .\\32xl\\:odd\\:pt-30:nth-child(odd){
    padding-top: 7.5rem;
  }

  .\\32xl\\:odd\\:pr-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  .\\32xl\\:odd\\:pb-30:nth-child(odd){
    padding-bottom: 7.5rem;
  }

  .\\32xl\\:odd\\:pl-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  .\\32xl\\:odd\\:pt-32:nth-child(odd){
    padding-top: 8rem;
  }

  .\\32xl\\:odd\\:pr-32:nth-child(odd){
    padding-right: 8rem;
  }

  .\\32xl\\:odd\\:pb-32:nth-child(odd){
    padding-bottom: 8rem;
  }

  .\\32xl\\:odd\\:pl-32:nth-child(odd){
    padding-left: 8rem;
  }

  .\\32xl\\:odd\\:pt-34:nth-child(odd){
    padding-top: 8.5rem;
  }

  .\\32xl\\:odd\\:pr-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  .\\32xl\\:odd\\:pb-34:nth-child(odd){
    padding-bottom: 8.5rem;
  }

  .\\32xl\\:odd\\:pl-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  .\\32xl\\:odd\\:pt-40:nth-child(odd){
    padding-top: 10rem;
  }

  .\\32xl\\:odd\\:pr-40:nth-child(odd){
    padding-right: 10rem;
  }

  .\\32xl\\:odd\\:pb-40:nth-child(odd){
    padding-bottom: 10rem;
  }

  .\\32xl\\:odd\\:pl-40:nth-child(odd){
    padding-left: 10rem;
  }

  .\\32xl\\:odd\\:pt-42:nth-child(odd){
    padding-top: 10.5rem;
  }

  .\\32xl\\:odd\\:pr-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  .\\32xl\\:odd\\:pb-42:nth-child(odd){
    padding-bottom: 10.5rem;
  }

  .\\32xl\\:odd\\:pl-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  .\\32xl\\:odd\\:pt-44:nth-child(odd){
    padding-top: 11rem;
  }

  .\\32xl\\:odd\\:pr-44:nth-child(odd){
    padding-right: 11rem;
  }

  .\\32xl\\:odd\\:pb-44:nth-child(odd){
    padding-bottom: 11rem;
  }

  .\\32xl\\:odd\\:pl-44:nth-child(odd){
    padding-left: 11rem;
  }

  .\\32xl\\:odd\\:pt-48:nth-child(odd){
    padding-top: 12rem;
  }

  .\\32xl\\:odd\\:pr-48:nth-child(odd){
    padding-right: 12rem;
  }

  .\\32xl\\:odd\\:pb-48:nth-child(odd){
    padding-bottom: 12rem;
  }

  .\\32xl\\:odd\\:pl-48:nth-child(odd){
    padding-left: 12rem;
  }

  .\\32xl\\:odd\\:pt-52:nth-child(odd){
    padding-top: 13rem;
  }

  .\\32xl\\:odd\\:pr-52:nth-child(odd){
    padding-right: 13rem;
  }

  .\\32xl\\:odd\\:pb-52:nth-child(odd){
    padding-bottom: 13rem;
  }

  .\\32xl\\:odd\\:pl-52:nth-child(odd){
    padding-left: 13rem;
  }

  .\\32xl\\:odd\\:pt-54:nth-child(odd){
    padding-top: 13.5rem;
  }

  .\\32xl\\:odd\\:pr-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  .\\32xl\\:odd\\:pb-54:nth-child(odd){
    padding-bottom: 13.5rem;
  }

  .\\32xl\\:odd\\:pl-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  .\\32xl\\:odd\\:pt-56:nth-child(odd){
    padding-top: 14rem;
  }

  .\\32xl\\:odd\\:pr-56:nth-child(odd){
    padding-right: 14rem;
  }

  .\\32xl\\:odd\\:pb-56:nth-child(odd){
    padding-bottom: 14rem;
  }

  .\\32xl\\:odd\\:pl-56:nth-child(odd){
    padding-left: 14rem;
  }

  .\\32xl\\:odd\\:pt-60:nth-child(odd){
    padding-top: 15rem;
  }

  .\\32xl\\:odd\\:pr-60:nth-child(odd){
    padding-right: 15rem;
  }

  .\\32xl\\:odd\\:pb-60:nth-child(odd){
    padding-bottom: 15rem;
  }

  .\\32xl\\:odd\\:pl-60:nth-child(odd){
    padding-left: 15rem;
  }

  .\\32xl\\:odd\\:pt-64:nth-child(odd){
    padding-top: 16rem;
  }

  .\\32xl\\:odd\\:pr-64:nth-child(odd){
    padding-right: 16rem;
  }

  .\\32xl\\:odd\\:pb-64:nth-child(odd){
    padding-bottom: 16rem;
  }

  .\\32xl\\:odd\\:pl-64:nth-child(odd){
    padding-left: 16rem;
  }

  .\\32xl\\:odd\\:pt-68:nth-child(odd){
    padding-top: 17rem;
  }

  .\\32xl\\:odd\\:pr-68:nth-child(odd){
    padding-right: 17rem;
  }

  .\\32xl\\:odd\\:pb-68:nth-child(odd){
    padding-bottom: 17rem;
  }

  .\\32xl\\:odd\\:pl-68:nth-child(odd){
    padding-left: 17rem;
  }

  .\\32xl\\:odd\\:pt-72:nth-child(odd){
    padding-top: 18rem;
  }

  .\\32xl\\:odd\\:pr-72:nth-child(odd){
    padding-right: 18rem;
  }

  .\\32xl\\:odd\\:pb-72:nth-child(odd){
    padding-bottom: 18rem;
  }

  .\\32xl\\:odd\\:pl-72:nth-child(odd){
    padding-left: 18rem;
  }

  .\\32xl\\:odd\\:pt-74:nth-child(odd){
    padding-top: 18.5rem;
  }

  .\\32xl\\:odd\\:pr-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  .\\32xl\\:odd\\:pb-74:nth-child(odd){
    padding-bottom: 18.5rem;
  }

  .\\32xl\\:odd\\:pl-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  .\\32xl\\:odd\\:pt-76:nth-child(odd){
    padding-top: 19rem;
  }

  .\\32xl\\:odd\\:pr-76:nth-child(odd){
    padding-right: 19rem;
  }

  .\\32xl\\:odd\\:pb-76:nth-child(odd){
    padding-bottom: 19rem;
  }

  .\\32xl\\:odd\\:pl-76:nth-child(odd){
    padding-left: 19rem;
  }

  .\\32xl\\:odd\\:pt-78:nth-child(odd){
    padding-top: 19.5rem;
  }

  .\\32xl\\:odd\\:pr-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  .\\32xl\\:odd\\:pb-78:nth-child(odd){
    padding-bottom: 19.5rem;
  }

  .\\32xl\\:odd\\:pl-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  .\\32xl\\:odd\\:pt-80:nth-child(odd){
    padding-top: 20rem;
  }

  .\\32xl\\:odd\\:pr-80:nth-child(odd){
    padding-right: 20rem;
  }

  .\\32xl\\:odd\\:pb-80:nth-child(odd){
    padding-bottom: 20rem;
  }

  .\\32xl\\:odd\\:pl-80:nth-child(odd){
    padding-left: 20rem;
  }

  .\\32xl\\:odd\\:pt-82:nth-child(odd){
    padding-top: 20.5rem;
  }

  .\\32xl\\:odd\\:pr-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  .\\32xl\\:odd\\:pb-82:nth-child(odd){
    padding-bottom: 20.5rem;
  }

  .\\32xl\\:odd\\:pl-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  .\\32xl\\:odd\\:pt-84:nth-child(odd){
    padding-top: 21rem;
  }

  .\\32xl\\:odd\\:pr-84:nth-child(odd){
    padding-right: 21rem;
  }

  .\\32xl\\:odd\\:pb-84:nth-child(odd){
    padding-bottom: 21rem;
  }

  .\\32xl\\:odd\\:pl-84:nth-child(odd){
    padding-left: 21rem;
  }

  .\\32xl\\:odd\\:pt-88:nth-child(odd){
    padding-top: 22rem;
  }

  .\\32xl\\:odd\\:pr-88:nth-child(odd){
    padding-right: 22rem;
  }

  .\\32xl\\:odd\\:pb-88:nth-child(odd){
    padding-bottom: 22rem;
  }

  .\\32xl\\:odd\\:pl-88:nth-child(odd){
    padding-left: 22rem;
  }

  .\\32xl\\:odd\\:pt-92:nth-child(odd){
    padding-top: 23rem;
  }

  .\\32xl\\:odd\\:pr-92:nth-child(odd){
    padding-right: 23rem;
  }

  .\\32xl\\:odd\\:pb-92:nth-child(odd){
    padding-bottom: 23rem;
  }

  .\\32xl\\:odd\\:pl-92:nth-child(odd){
    padding-left: 23rem;
  }

  .\\32xl\\:odd\\:pt-96:nth-child(odd){
    padding-top: 24rem;
  }

  .\\32xl\\:odd\\:pr-96:nth-child(odd){
    padding-right: 24rem;
  }

  .\\32xl\\:odd\\:pb-96:nth-child(odd){
    padding-bottom: 24rem;
  }

  .\\32xl\\:odd\\:pl-96:nth-child(odd){
    padding-left: 24rem;
  }

  .\\32xl\\:odd\\:pt-98:nth-child(odd){
    padding-top: 24.5rem;
  }

  .\\32xl\\:odd\\:pr-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  .\\32xl\\:odd\\:pb-98:nth-child(odd){
    padding-bottom: 24.5rem;
  }

  .\\32xl\\:odd\\:pl-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  .\\32xl\\:odd\\:pt-100:nth-child(odd){
    padding-top: 25rem;
  }

  .\\32xl\\:odd\\:pr-100:nth-child(odd){
    padding-right: 25rem;
  }

  .\\32xl\\:odd\\:pb-100:nth-child(odd){
    padding-bottom: 25rem;
  }

  .\\32xl\\:odd\\:pl-100:nth-child(odd){
    padding-left: 25rem;
  }

  .\\32xl\\:odd\\:pt-104:nth-child(odd){
    padding-top: 26rem;
  }

  .\\32xl\\:odd\\:pr-104:nth-child(odd){
    padding-right: 26rem;
  }

  .\\32xl\\:odd\\:pb-104:nth-child(odd){
    padding-bottom: 26rem;
  }

  .\\32xl\\:odd\\:pl-104:nth-child(odd){
    padding-left: 26rem;
  }

  .\\32xl\\:odd\\:pt-112:nth-child(odd){
    padding-top: 28rem;
  }

  .\\32xl\\:odd\\:pr-112:nth-child(odd){
    padding-right: 28rem;
  }

  .\\32xl\\:odd\\:pb-112:nth-child(odd){
    padding-bottom: 28rem;
  }

  .\\32xl\\:odd\\:pl-112:nth-child(odd){
    padding-left: 28rem;
  }

  .\\32xl\\:odd\\:pt-124:nth-child(odd){
    padding-top: 31rem;
  }

  .\\32xl\\:odd\\:pr-124:nth-child(odd){
    padding-right: 31rem;
  }

  .\\32xl\\:odd\\:pb-124:nth-child(odd){
    padding-bottom: 31rem;
  }

  .\\32xl\\:odd\\:pl-124:nth-child(odd){
    padding-left: 31rem;
  }

  .\\32xl\\:odd\\:pt-128:nth-child(odd){
    padding-top: 32rem;
  }

  .\\32xl\\:odd\\:pr-128:nth-child(odd){
    padding-right: 32rem;
  }

  .\\32xl\\:odd\\:pb-128:nth-child(odd){
    padding-bottom: 32rem;
  }

  .\\32xl\\:odd\\:pl-128:nth-child(odd){
    padding-left: 32rem;
  }

  .\\32xl\\:odd\\:pt-140:nth-child(odd){
    padding-top: 35rem;
  }

  .\\32xl\\:odd\\:pr-140:nth-child(odd){
    padding-right: 35rem;
  }

  .\\32xl\\:odd\\:pb-140:nth-child(odd){
    padding-bottom: 35rem;
  }

  .\\32xl\\:odd\\:pl-140:nth-child(odd){
    padding-left: 35rem;
  }

  .\\32xl\\:odd\\:pt-152:nth-child(odd){
    padding-top: 38rem;
  }

  .\\32xl\\:odd\\:pr-152:nth-child(odd){
    padding-right: 38rem;
  }

  .\\32xl\\:odd\\:pb-152:nth-child(odd){
    padding-bottom: 38rem;
  }

  .\\32xl\\:odd\\:pl-152:nth-child(odd){
    padding-left: 38rem;
  }

  .\\32xl\\:odd\\:pt-160:nth-child(odd){
    padding-top: 40rem;
  }

  .\\32xl\\:odd\\:pr-160:nth-child(odd){
    padding-right: 40rem;
  }

  .\\32xl\\:odd\\:pb-160:nth-child(odd){
    padding-bottom: 40rem;
  }

  .\\32xl\\:odd\\:pl-160:nth-child(odd){
    padding-left: 40rem;
  }

  .\\32xl\\:odd\\:pt-162:nth-child(odd){
    padding-top: 41rem;
  }

  .\\32xl\\:odd\\:pr-162:nth-child(odd){
    padding-right: 41rem;
  }

  .\\32xl\\:odd\\:pb-162:nth-child(odd){
    padding-bottom: 41rem;
  }

  .\\32xl\\:odd\\:pl-162:nth-child(odd){
    padding-left: 41rem;
  }

  .\\32xl\\:odd\\:pt-192:nth-child(odd){
    padding-top: 48rem;
  }

  .\\32xl\\:odd\\:pr-192:nth-child(odd){
    padding-right: 48rem;
  }

  .\\32xl\\:odd\\:pb-192:nth-child(odd){
    padding-bottom: 48rem;
  }

  .\\32xl\\:odd\\:pl-192:nth-child(odd){
    padding-left: 48rem;
  }

  .\\32xl\\:odd\\:pt-208:nth-child(odd){
    padding-top: 52rem;
  }

  .\\32xl\\:odd\\:pr-208:nth-child(odd){
    padding-right: 52rem;
  }

  .\\32xl\\:odd\\:pb-208:nth-child(odd){
    padding-bottom: 52rem;
  }

  .\\32xl\\:odd\\:pl-208:nth-child(odd){
    padding-left: 52rem;
  }

  .\\32xl\\:odd\\:pt-224:nth-child(odd){
    padding-top: 56rem;
  }

  .\\32xl\\:odd\\:pr-224:nth-child(odd){
    padding-right: 56rem;
  }

  .\\32xl\\:odd\\:pb-224:nth-child(odd){
    padding-bottom: 56rem;
  }

  .\\32xl\\:odd\\:pl-224:nth-child(odd){
    padding-left: 56rem;
  }

  .\\32xl\\:odd\\:pt-256:nth-child(odd){
    padding-top: 64rem;
  }

  .\\32xl\\:odd\\:pr-256:nth-child(odd){
    padding-right: 64rem;
  }

  .\\32xl\\:odd\\:pb-256:nth-child(odd){
    padding-bottom: 64rem;
  }

  .\\32xl\\:odd\\:pl-256:nth-child(odd){
    padding-left: 64rem;
  }

  .\\32xl\\:odd\\:pt-px:nth-child(odd){
    padding-top: 1px;
  }

  .\\32xl\\:odd\\:pr-px:nth-child(odd){
    padding-right: 1px;
  }

  .\\32xl\\:odd\\:pb-px:nth-child(odd){
    padding-bottom: 1px;
  }

  .\\32xl\\:odd\\:pl-px:nth-child(odd){
    padding-left: 1px;
  }

  .\\32xl\\:even\\:p-0:nth-child(even){
    padding: 0;
  }

  .\\32xl\\:even\\:p-1:nth-child(even){
    padding: 0.25rem;
  }

  .\\32xl\\:even\\:p-2:nth-child(even){
    padding: 0.5rem;
  }

  .\\32xl\\:even\\:p-3:nth-child(even){
    padding: 0.75rem;
  }

  .\\32xl\\:even\\:p-4:nth-child(even){
    padding: 1rem;
  }

  .\\32xl\\:even\\:p-5:nth-child(even){
    padding: 1.25rem;
  }

  .\\32xl\\:even\\:p-6:nth-child(even){
    padding: 1.5rem;
  }

  .\\32xl\\:even\\:p-7:nth-child(even){
    padding: 1.75rem;
  }

  .\\32xl\\:even\\:p-8:nth-child(even){
    padding: 2rem;
  }

  .\\32xl\\:even\\:p-9:nth-child(even){
    padding: 2.25rem;
  }

  .\\32xl\\:even\\:p-10:nth-child(even){
    padding: 2.5rem;
  }

  .\\32xl\\:even\\:p-11:nth-child(even){
    padding: 2.75rem;
  }

  .\\32xl\\:even\\:p-12:nth-child(even){
    padding: 3rem;
  }

  .\\32xl\\:even\\:p-14:nth-child(even){
    padding: 3.5rem;
  }

  .\\32xl\\:even\\:p-15:nth-child(even){
    padding: 3.75rem;
  }

  .\\32xl\\:even\\:p-16:nth-child(even){
    padding: 4rem;
  }

  .\\32xl\\:even\\:p-18:nth-child(even){
    padding: 4.5rem;
  }

  .\\32xl\\:even\\:p-20:nth-child(even){
    padding: 5rem;
  }

  .\\32xl\\:even\\:p-22:nth-child(even){
    padding: 5.5rem;
  }

  .\\32xl\\:even\\:p-23:nth-child(even){
    padding: 5.75rem;
  }

  .\\32xl\\:even\\:p-24:nth-child(even){
    padding: 6rem;
  }

  .\\32xl\\:even\\:p-25:nth-child(even){
    padding: 6.25rem;
  }

  .\\32xl\\:even\\:p-26:nth-child(even){
    padding: 6.5rem;
  }

  .\\32xl\\:even\\:p-28:nth-child(even){
    padding: 7rem;
  }

  .\\32xl\\:even\\:p-30:nth-child(even){
    padding: 7.5rem;
  }

  .\\32xl\\:even\\:p-32:nth-child(even){
    padding: 8rem;
  }

  .\\32xl\\:even\\:p-34:nth-child(even){
    padding: 8.5rem;
  }

  .\\32xl\\:even\\:p-40:nth-child(even){
    padding: 10rem;
  }

  .\\32xl\\:even\\:p-42:nth-child(even){
    padding: 10.5rem;
  }

  .\\32xl\\:even\\:p-44:nth-child(even){
    padding: 11rem;
  }

  .\\32xl\\:even\\:p-48:nth-child(even){
    padding: 12rem;
  }

  .\\32xl\\:even\\:p-52:nth-child(even){
    padding: 13rem;
  }

  .\\32xl\\:even\\:p-54:nth-child(even){
    padding: 13.5rem;
  }

  .\\32xl\\:even\\:p-56:nth-child(even){
    padding: 14rem;
  }

  .\\32xl\\:even\\:p-60:nth-child(even){
    padding: 15rem;
  }

  .\\32xl\\:even\\:p-64:nth-child(even){
    padding: 16rem;
  }

  .\\32xl\\:even\\:p-68:nth-child(even){
    padding: 17rem;
  }

  .\\32xl\\:even\\:p-72:nth-child(even){
    padding: 18rem;
  }

  .\\32xl\\:even\\:p-74:nth-child(even){
    padding: 18.5rem;
  }

  .\\32xl\\:even\\:p-76:nth-child(even){
    padding: 19rem;
  }

  .\\32xl\\:even\\:p-78:nth-child(even){
    padding: 19.5rem;
  }

  .\\32xl\\:even\\:p-80:nth-child(even){
    padding: 20rem;
  }

  .\\32xl\\:even\\:p-82:nth-child(even){
    padding: 20.5rem;
  }

  .\\32xl\\:even\\:p-84:nth-child(even){
    padding: 21rem;
  }

  .\\32xl\\:even\\:p-88:nth-child(even){
    padding: 22rem;
  }

  .\\32xl\\:even\\:p-92:nth-child(even){
    padding: 23rem;
  }

  .\\32xl\\:even\\:p-96:nth-child(even){
    padding: 24rem;
  }

  .\\32xl\\:even\\:p-98:nth-child(even){
    padding: 24.5rem;
  }

  .\\32xl\\:even\\:p-100:nth-child(even){
    padding: 25rem;
  }

  .\\32xl\\:even\\:p-104:nth-child(even){
    padding: 26rem;
  }

  .\\32xl\\:even\\:p-112:nth-child(even){
    padding: 28rem;
  }

  .\\32xl\\:even\\:p-124:nth-child(even){
    padding: 31rem;
  }

  .\\32xl\\:even\\:p-128:nth-child(even){
    padding: 32rem;
  }

  .\\32xl\\:even\\:p-140:nth-child(even){
    padding: 35rem;
  }

  .\\32xl\\:even\\:p-152:nth-child(even){
    padding: 38rem;
  }

  .\\32xl\\:even\\:p-160:nth-child(even){
    padding: 40rem;
  }

  .\\32xl\\:even\\:p-162:nth-child(even){
    padding: 41rem;
  }

  .\\32xl\\:even\\:p-192:nth-child(even){
    padding: 48rem;
  }

  .\\32xl\\:even\\:p-208:nth-child(even){
    padding: 52rem;
  }

  .\\32xl\\:even\\:p-224:nth-child(even){
    padding: 56rem;
  }

  .\\32xl\\:even\\:p-256:nth-child(even){
    padding: 64rem;
  }

  .\\32xl\\:even\\:p-px:nth-child(even){
    padding: 1px;
  }

  .\\32xl\\:even\\:py-0:nth-child(even){
    padding-top: 0;
    padding-bottom: 0;
  }

  .\\32xl\\:even\\:px-0:nth-child(even){
    padding-left: 0;
    padding-right: 0;
  }

  .\\32xl\\:even\\:py-1:nth-child(even){
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .\\32xl\\:even\\:px-1:nth-child(even){
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .\\32xl\\:even\\:py-2:nth-child(even){
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .\\32xl\\:even\\:px-2:nth-child(even){
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .\\32xl\\:even\\:py-3:nth-child(even){
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .\\32xl\\:even\\:px-3:nth-child(even){
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .\\32xl\\:even\\:py-4:nth-child(even){
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .\\32xl\\:even\\:px-4:nth-child(even){
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .\\32xl\\:even\\:py-5:nth-child(even){
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .\\32xl\\:even\\:px-5:nth-child(even){
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .\\32xl\\:even\\:py-6:nth-child(even){
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .\\32xl\\:even\\:px-6:nth-child(even){
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .\\32xl\\:even\\:py-7:nth-child(even){
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .\\32xl\\:even\\:px-7:nth-child(even){
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .\\32xl\\:even\\:py-8:nth-child(even){
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .\\32xl\\:even\\:px-8:nth-child(even){
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .\\32xl\\:even\\:py-9:nth-child(even){
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .\\32xl\\:even\\:px-9:nth-child(even){
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .\\32xl\\:even\\:py-10:nth-child(even){
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .\\32xl\\:even\\:px-10:nth-child(even){
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .\\32xl\\:even\\:py-11:nth-child(even){
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .\\32xl\\:even\\:px-11:nth-child(even){
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .\\32xl\\:even\\:py-12:nth-child(even){
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .\\32xl\\:even\\:px-12:nth-child(even){
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .\\32xl\\:even\\:py-14:nth-child(even){
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .\\32xl\\:even\\:px-14:nth-child(even){
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .\\32xl\\:even\\:py-15:nth-child(even){
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .\\32xl\\:even\\:px-15:nth-child(even){
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .\\32xl\\:even\\:py-16:nth-child(even){
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .\\32xl\\:even\\:px-16:nth-child(even){
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .\\32xl\\:even\\:py-18:nth-child(even){
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .\\32xl\\:even\\:px-18:nth-child(even){
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .\\32xl\\:even\\:py-20:nth-child(even){
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .\\32xl\\:even\\:px-20:nth-child(even){
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .\\32xl\\:even\\:py-22:nth-child(even){
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .\\32xl\\:even\\:px-22:nth-child(even){
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .\\32xl\\:even\\:py-23:nth-child(even){
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .\\32xl\\:even\\:px-23:nth-child(even){
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .\\32xl\\:even\\:py-24:nth-child(even){
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .\\32xl\\:even\\:px-24:nth-child(even){
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .\\32xl\\:even\\:py-25:nth-child(even){
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .\\32xl\\:even\\:px-25:nth-child(even){
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .\\32xl\\:even\\:py-26:nth-child(even){
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .\\32xl\\:even\\:px-26:nth-child(even){
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .\\32xl\\:even\\:py-28:nth-child(even){
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .\\32xl\\:even\\:px-28:nth-child(even){
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .\\32xl\\:even\\:py-30:nth-child(even){
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .\\32xl\\:even\\:px-30:nth-child(even){
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .\\32xl\\:even\\:py-32:nth-child(even){
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .\\32xl\\:even\\:px-32:nth-child(even){
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .\\32xl\\:even\\:py-34:nth-child(even){
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .\\32xl\\:even\\:px-34:nth-child(even){
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .\\32xl\\:even\\:py-40:nth-child(even){
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .\\32xl\\:even\\:px-40:nth-child(even){
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .\\32xl\\:even\\:py-42:nth-child(even){
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .\\32xl\\:even\\:px-42:nth-child(even){
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .\\32xl\\:even\\:py-44:nth-child(even){
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .\\32xl\\:even\\:px-44:nth-child(even){
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .\\32xl\\:even\\:py-48:nth-child(even){
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .\\32xl\\:even\\:px-48:nth-child(even){
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .\\32xl\\:even\\:py-52:nth-child(even){
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .\\32xl\\:even\\:px-52:nth-child(even){
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .\\32xl\\:even\\:py-54:nth-child(even){
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .\\32xl\\:even\\:px-54:nth-child(even){
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .\\32xl\\:even\\:py-56:nth-child(even){
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .\\32xl\\:even\\:px-56:nth-child(even){
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .\\32xl\\:even\\:py-60:nth-child(even){
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .\\32xl\\:even\\:px-60:nth-child(even){
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .\\32xl\\:even\\:py-64:nth-child(even){
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .\\32xl\\:even\\:px-64:nth-child(even){
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .\\32xl\\:even\\:py-68:nth-child(even){
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .\\32xl\\:even\\:px-68:nth-child(even){
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .\\32xl\\:even\\:py-72:nth-child(even){
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .\\32xl\\:even\\:px-72:nth-child(even){
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .\\32xl\\:even\\:py-74:nth-child(even){
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .\\32xl\\:even\\:px-74:nth-child(even){
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .\\32xl\\:even\\:py-76:nth-child(even){
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .\\32xl\\:even\\:px-76:nth-child(even){
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .\\32xl\\:even\\:py-78:nth-child(even){
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .\\32xl\\:even\\:px-78:nth-child(even){
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .\\32xl\\:even\\:py-80:nth-child(even){
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .\\32xl\\:even\\:px-80:nth-child(even){
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .\\32xl\\:even\\:py-82:nth-child(even){
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .\\32xl\\:even\\:px-82:nth-child(even){
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .\\32xl\\:even\\:py-84:nth-child(even){
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .\\32xl\\:even\\:px-84:nth-child(even){
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .\\32xl\\:even\\:py-88:nth-child(even){
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .\\32xl\\:even\\:px-88:nth-child(even){
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .\\32xl\\:even\\:py-92:nth-child(even){
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .\\32xl\\:even\\:px-92:nth-child(even){
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .\\32xl\\:even\\:py-96:nth-child(even){
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .\\32xl\\:even\\:px-96:nth-child(even){
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .\\32xl\\:even\\:py-98:nth-child(even){
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .\\32xl\\:even\\:px-98:nth-child(even){
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .\\32xl\\:even\\:py-100:nth-child(even){
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .\\32xl\\:even\\:px-100:nth-child(even){
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .\\32xl\\:even\\:py-104:nth-child(even){
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .\\32xl\\:even\\:px-104:nth-child(even){
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .\\32xl\\:even\\:py-112:nth-child(even){
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .\\32xl\\:even\\:px-112:nth-child(even){
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .\\32xl\\:even\\:py-124:nth-child(even){
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .\\32xl\\:even\\:px-124:nth-child(even){
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .\\32xl\\:even\\:py-128:nth-child(even){
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .\\32xl\\:even\\:px-128:nth-child(even){
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .\\32xl\\:even\\:py-140:nth-child(even){
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .\\32xl\\:even\\:px-140:nth-child(even){
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .\\32xl\\:even\\:py-152:nth-child(even){
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .\\32xl\\:even\\:px-152:nth-child(even){
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .\\32xl\\:even\\:py-160:nth-child(even){
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .\\32xl\\:even\\:px-160:nth-child(even){
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .\\32xl\\:even\\:py-162:nth-child(even){
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .\\32xl\\:even\\:px-162:nth-child(even){
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .\\32xl\\:even\\:py-192:nth-child(even){
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .\\32xl\\:even\\:px-192:nth-child(even){
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .\\32xl\\:even\\:py-208:nth-child(even){
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .\\32xl\\:even\\:px-208:nth-child(even){
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .\\32xl\\:even\\:py-224:nth-child(even){
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .\\32xl\\:even\\:px-224:nth-child(even){
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .\\32xl\\:even\\:py-256:nth-child(even){
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .\\32xl\\:even\\:px-256:nth-child(even){
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .\\32xl\\:even\\:py-px:nth-child(even){
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .\\32xl\\:even\\:px-px:nth-child(even){
    padding-left: 1px;
    padding-right: 1px;
  }

  .\\32xl\\:even\\:pt-0:nth-child(even){
    padding-top: 0;
  }

  .\\32xl\\:even\\:pr-0:nth-child(even){
    padding-right: 0;
  }

  .\\32xl\\:even\\:pb-0:nth-child(even){
    padding-bottom: 0;
  }

  .\\32xl\\:even\\:pl-0:nth-child(even){
    padding-left: 0;
  }

  .\\32xl\\:even\\:pt-1:nth-child(even){
    padding-top: 0.25rem;
  }

  .\\32xl\\:even\\:pr-1:nth-child(even){
    padding-right: 0.25rem;
  }

  .\\32xl\\:even\\:pb-1:nth-child(even){
    padding-bottom: 0.25rem;
  }

  .\\32xl\\:even\\:pl-1:nth-child(even){
    padding-left: 0.25rem;
  }

  .\\32xl\\:even\\:pt-2:nth-child(even){
    padding-top: 0.5rem;
  }

  .\\32xl\\:even\\:pr-2:nth-child(even){
    padding-right: 0.5rem;
  }

  .\\32xl\\:even\\:pb-2:nth-child(even){
    padding-bottom: 0.5rem;
  }

  .\\32xl\\:even\\:pl-2:nth-child(even){
    padding-left: 0.5rem;
  }

  .\\32xl\\:even\\:pt-3:nth-child(even){
    padding-top: 0.75rem;
  }

  .\\32xl\\:even\\:pr-3:nth-child(even){
    padding-right: 0.75rem;
  }

  .\\32xl\\:even\\:pb-3:nth-child(even){
    padding-bottom: 0.75rem;
  }

  .\\32xl\\:even\\:pl-3:nth-child(even){
    padding-left: 0.75rem;
  }

  .\\32xl\\:even\\:pt-4:nth-child(even){
    padding-top: 1rem;
  }

  .\\32xl\\:even\\:pr-4:nth-child(even){
    padding-right: 1rem;
  }

  .\\32xl\\:even\\:pb-4:nth-child(even){
    padding-bottom: 1rem;
  }

  .\\32xl\\:even\\:pl-4:nth-child(even){
    padding-left: 1rem;
  }

  .\\32xl\\:even\\:pt-5:nth-child(even){
    padding-top: 1.25rem;
  }

  .\\32xl\\:even\\:pr-5:nth-child(even){
    padding-right: 1.25rem;
  }

  .\\32xl\\:even\\:pb-5:nth-child(even){
    padding-bottom: 1.25rem;
  }

  .\\32xl\\:even\\:pl-5:nth-child(even){
    padding-left: 1.25rem;
  }

  .\\32xl\\:even\\:pt-6:nth-child(even){
    padding-top: 1.5rem;
  }

  .\\32xl\\:even\\:pr-6:nth-child(even){
    padding-right: 1.5rem;
  }

  .\\32xl\\:even\\:pb-6:nth-child(even){
    padding-bottom: 1.5rem;
  }

  .\\32xl\\:even\\:pl-6:nth-child(even){
    padding-left: 1.5rem;
  }

  .\\32xl\\:even\\:pt-7:nth-child(even){
    padding-top: 1.75rem;
  }

  .\\32xl\\:even\\:pr-7:nth-child(even){
    padding-right: 1.75rem;
  }

  .\\32xl\\:even\\:pb-7:nth-child(even){
    padding-bottom: 1.75rem;
  }

  .\\32xl\\:even\\:pl-7:nth-child(even){
    padding-left: 1.75rem;
  }

  .\\32xl\\:even\\:pt-8:nth-child(even){
    padding-top: 2rem;
  }

  .\\32xl\\:even\\:pr-8:nth-child(even){
    padding-right: 2rem;
  }

  .\\32xl\\:even\\:pb-8:nth-child(even){
    padding-bottom: 2rem;
  }

  .\\32xl\\:even\\:pl-8:nth-child(even){
    padding-left: 2rem;
  }

  .\\32xl\\:even\\:pt-9:nth-child(even){
    padding-top: 2.25rem;
  }

  .\\32xl\\:even\\:pr-9:nth-child(even){
    padding-right: 2.25rem;
  }

  .\\32xl\\:even\\:pb-9:nth-child(even){
    padding-bottom: 2.25rem;
  }

  .\\32xl\\:even\\:pl-9:nth-child(even){
    padding-left: 2.25rem;
  }

  .\\32xl\\:even\\:pt-10:nth-child(even){
    padding-top: 2.5rem;
  }

  .\\32xl\\:even\\:pr-10:nth-child(even){
    padding-right: 2.5rem;
  }

  .\\32xl\\:even\\:pb-10:nth-child(even){
    padding-bottom: 2.5rem;
  }

  .\\32xl\\:even\\:pl-10:nth-child(even){
    padding-left: 2.5rem;
  }

  .\\32xl\\:even\\:pt-11:nth-child(even){
    padding-top: 2.75rem;
  }

  .\\32xl\\:even\\:pr-11:nth-child(even){
    padding-right: 2.75rem;
  }

  .\\32xl\\:even\\:pb-11:nth-child(even){
    padding-bottom: 2.75rem;
  }

  .\\32xl\\:even\\:pl-11:nth-child(even){
    padding-left: 2.75rem;
  }

  .\\32xl\\:even\\:pt-12:nth-child(even){
    padding-top: 3rem;
  }

  .\\32xl\\:even\\:pr-12:nth-child(even){
    padding-right: 3rem;
  }

  .\\32xl\\:even\\:pb-12:nth-child(even){
    padding-bottom: 3rem;
  }

  .\\32xl\\:even\\:pl-12:nth-child(even){
    padding-left: 3rem;
  }

  .\\32xl\\:even\\:pt-14:nth-child(even){
    padding-top: 3.5rem;
  }

  .\\32xl\\:even\\:pr-14:nth-child(even){
    padding-right: 3.5rem;
  }

  .\\32xl\\:even\\:pb-14:nth-child(even){
    padding-bottom: 3.5rem;
  }

  .\\32xl\\:even\\:pl-14:nth-child(even){
    padding-left: 3.5rem;
  }

  .\\32xl\\:even\\:pt-15:nth-child(even){
    padding-top: 3.75rem;
  }

  .\\32xl\\:even\\:pr-15:nth-child(even){
    padding-right: 3.75rem;
  }

  .\\32xl\\:even\\:pb-15:nth-child(even){
    padding-bottom: 3.75rem;
  }

  .\\32xl\\:even\\:pl-15:nth-child(even){
    padding-left: 3.75rem;
  }

  .\\32xl\\:even\\:pt-16:nth-child(even){
    padding-top: 4rem;
  }

  .\\32xl\\:even\\:pr-16:nth-child(even){
    padding-right: 4rem;
  }

  .\\32xl\\:even\\:pb-16:nth-child(even){
    padding-bottom: 4rem;
  }

  .\\32xl\\:even\\:pl-16:nth-child(even){
    padding-left: 4rem;
  }

  .\\32xl\\:even\\:pt-18:nth-child(even){
    padding-top: 4.5rem;
  }

  .\\32xl\\:even\\:pr-18:nth-child(even){
    padding-right: 4.5rem;
  }

  .\\32xl\\:even\\:pb-18:nth-child(even){
    padding-bottom: 4.5rem;
  }

  .\\32xl\\:even\\:pl-18:nth-child(even){
    padding-left: 4.5rem;
  }

  .\\32xl\\:even\\:pt-20:nth-child(even){
    padding-top: 5rem;
  }

  .\\32xl\\:even\\:pr-20:nth-child(even){
    padding-right: 5rem;
  }

  .\\32xl\\:even\\:pb-20:nth-child(even){
    padding-bottom: 5rem;
  }

  .\\32xl\\:even\\:pl-20:nth-child(even){
    padding-left: 5rem;
  }

  .\\32xl\\:even\\:pt-22:nth-child(even){
    padding-top: 5.5rem;
  }

  .\\32xl\\:even\\:pr-22:nth-child(even){
    padding-right: 5.5rem;
  }

  .\\32xl\\:even\\:pb-22:nth-child(even){
    padding-bottom: 5.5rem;
  }

  .\\32xl\\:even\\:pl-22:nth-child(even){
    padding-left: 5.5rem;
  }

  .\\32xl\\:even\\:pt-23:nth-child(even){
    padding-top: 5.75rem;
  }

  .\\32xl\\:even\\:pr-23:nth-child(even){
    padding-right: 5.75rem;
  }

  .\\32xl\\:even\\:pb-23:nth-child(even){
    padding-bottom: 5.75rem;
  }

  .\\32xl\\:even\\:pl-23:nth-child(even){
    padding-left: 5.75rem;
  }

  .\\32xl\\:even\\:pt-24:nth-child(even){
    padding-top: 6rem;
  }

  .\\32xl\\:even\\:pr-24:nth-child(even){
    padding-right: 6rem;
  }

  .\\32xl\\:even\\:pb-24:nth-child(even){
    padding-bottom: 6rem;
  }

  .\\32xl\\:even\\:pl-24:nth-child(even){
    padding-left: 6rem;
  }

  .\\32xl\\:even\\:pt-25:nth-child(even){
    padding-top: 6.25rem;
  }

  .\\32xl\\:even\\:pr-25:nth-child(even){
    padding-right: 6.25rem;
  }

  .\\32xl\\:even\\:pb-25:nth-child(even){
    padding-bottom: 6.25rem;
  }

  .\\32xl\\:even\\:pl-25:nth-child(even){
    padding-left: 6.25rem;
  }

  .\\32xl\\:even\\:pt-26:nth-child(even){
    padding-top: 6.5rem;
  }

  .\\32xl\\:even\\:pr-26:nth-child(even){
    padding-right: 6.5rem;
  }

  .\\32xl\\:even\\:pb-26:nth-child(even){
    padding-bottom: 6.5rem;
  }

  .\\32xl\\:even\\:pl-26:nth-child(even){
    padding-left: 6.5rem;
  }

  .\\32xl\\:even\\:pt-28:nth-child(even){
    padding-top: 7rem;
  }

  .\\32xl\\:even\\:pr-28:nth-child(even){
    padding-right: 7rem;
  }

  .\\32xl\\:even\\:pb-28:nth-child(even){
    padding-bottom: 7rem;
  }

  .\\32xl\\:even\\:pl-28:nth-child(even){
    padding-left: 7rem;
  }

  .\\32xl\\:even\\:pt-30:nth-child(even){
    padding-top: 7.5rem;
  }

  .\\32xl\\:even\\:pr-30:nth-child(even){
    padding-right: 7.5rem;
  }

  .\\32xl\\:even\\:pb-30:nth-child(even){
    padding-bottom: 7.5rem;
  }

  .\\32xl\\:even\\:pl-30:nth-child(even){
    padding-left: 7.5rem;
  }

  .\\32xl\\:even\\:pt-32:nth-child(even){
    padding-top: 8rem;
  }

  .\\32xl\\:even\\:pr-32:nth-child(even){
    padding-right: 8rem;
  }

  .\\32xl\\:even\\:pb-32:nth-child(even){
    padding-bottom: 8rem;
  }

  .\\32xl\\:even\\:pl-32:nth-child(even){
    padding-left: 8rem;
  }

  .\\32xl\\:even\\:pt-34:nth-child(even){
    padding-top: 8.5rem;
  }

  .\\32xl\\:even\\:pr-34:nth-child(even){
    padding-right: 8.5rem;
  }

  .\\32xl\\:even\\:pb-34:nth-child(even){
    padding-bottom: 8.5rem;
  }

  .\\32xl\\:even\\:pl-34:nth-child(even){
    padding-left: 8.5rem;
  }

  .\\32xl\\:even\\:pt-40:nth-child(even){
    padding-top: 10rem;
  }

  .\\32xl\\:even\\:pr-40:nth-child(even){
    padding-right: 10rem;
  }

  .\\32xl\\:even\\:pb-40:nth-child(even){
    padding-bottom: 10rem;
  }

  .\\32xl\\:even\\:pl-40:nth-child(even){
    padding-left: 10rem;
  }

  .\\32xl\\:even\\:pt-42:nth-child(even){
    padding-top: 10.5rem;
  }

  .\\32xl\\:even\\:pr-42:nth-child(even){
    padding-right: 10.5rem;
  }

  .\\32xl\\:even\\:pb-42:nth-child(even){
    padding-bottom: 10.5rem;
  }

  .\\32xl\\:even\\:pl-42:nth-child(even){
    padding-left: 10.5rem;
  }

  .\\32xl\\:even\\:pt-44:nth-child(even){
    padding-top: 11rem;
  }

  .\\32xl\\:even\\:pr-44:nth-child(even){
    padding-right: 11rem;
  }

  .\\32xl\\:even\\:pb-44:nth-child(even){
    padding-bottom: 11rem;
  }

  .\\32xl\\:even\\:pl-44:nth-child(even){
    padding-left: 11rem;
  }

  .\\32xl\\:even\\:pt-48:nth-child(even){
    padding-top: 12rem;
  }

  .\\32xl\\:even\\:pr-48:nth-child(even){
    padding-right: 12rem;
  }

  .\\32xl\\:even\\:pb-48:nth-child(even){
    padding-bottom: 12rem;
  }

  .\\32xl\\:even\\:pl-48:nth-child(even){
    padding-left: 12rem;
  }

  .\\32xl\\:even\\:pt-52:nth-child(even){
    padding-top: 13rem;
  }

  .\\32xl\\:even\\:pr-52:nth-child(even){
    padding-right: 13rem;
  }

  .\\32xl\\:even\\:pb-52:nth-child(even){
    padding-bottom: 13rem;
  }

  .\\32xl\\:even\\:pl-52:nth-child(even){
    padding-left: 13rem;
  }

  .\\32xl\\:even\\:pt-54:nth-child(even){
    padding-top: 13.5rem;
  }

  .\\32xl\\:even\\:pr-54:nth-child(even){
    padding-right: 13.5rem;
  }

  .\\32xl\\:even\\:pb-54:nth-child(even){
    padding-bottom: 13.5rem;
  }

  .\\32xl\\:even\\:pl-54:nth-child(even){
    padding-left: 13.5rem;
  }

  .\\32xl\\:even\\:pt-56:nth-child(even){
    padding-top: 14rem;
  }

  .\\32xl\\:even\\:pr-56:nth-child(even){
    padding-right: 14rem;
  }

  .\\32xl\\:even\\:pb-56:nth-child(even){
    padding-bottom: 14rem;
  }

  .\\32xl\\:even\\:pl-56:nth-child(even){
    padding-left: 14rem;
  }

  .\\32xl\\:even\\:pt-60:nth-child(even){
    padding-top: 15rem;
  }

  .\\32xl\\:even\\:pr-60:nth-child(even){
    padding-right: 15rem;
  }

  .\\32xl\\:even\\:pb-60:nth-child(even){
    padding-bottom: 15rem;
  }

  .\\32xl\\:even\\:pl-60:nth-child(even){
    padding-left: 15rem;
  }

  .\\32xl\\:even\\:pt-64:nth-child(even){
    padding-top: 16rem;
  }

  .\\32xl\\:even\\:pr-64:nth-child(even){
    padding-right: 16rem;
  }

  .\\32xl\\:even\\:pb-64:nth-child(even){
    padding-bottom: 16rem;
  }

  .\\32xl\\:even\\:pl-64:nth-child(even){
    padding-left: 16rem;
  }

  .\\32xl\\:even\\:pt-68:nth-child(even){
    padding-top: 17rem;
  }

  .\\32xl\\:even\\:pr-68:nth-child(even){
    padding-right: 17rem;
  }

  .\\32xl\\:even\\:pb-68:nth-child(even){
    padding-bottom: 17rem;
  }

  .\\32xl\\:even\\:pl-68:nth-child(even){
    padding-left: 17rem;
  }

  .\\32xl\\:even\\:pt-72:nth-child(even){
    padding-top: 18rem;
  }

  .\\32xl\\:even\\:pr-72:nth-child(even){
    padding-right: 18rem;
  }

  .\\32xl\\:even\\:pb-72:nth-child(even){
    padding-bottom: 18rem;
  }

  .\\32xl\\:even\\:pl-72:nth-child(even){
    padding-left: 18rem;
  }

  .\\32xl\\:even\\:pt-74:nth-child(even){
    padding-top: 18.5rem;
  }

  .\\32xl\\:even\\:pr-74:nth-child(even){
    padding-right: 18.5rem;
  }

  .\\32xl\\:even\\:pb-74:nth-child(even){
    padding-bottom: 18.5rem;
  }

  .\\32xl\\:even\\:pl-74:nth-child(even){
    padding-left: 18.5rem;
  }

  .\\32xl\\:even\\:pt-76:nth-child(even){
    padding-top: 19rem;
  }

  .\\32xl\\:even\\:pr-76:nth-child(even){
    padding-right: 19rem;
  }

  .\\32xl\\:even\\:pb-76:nth-child(even){
    padding-bottom: 19rem;
  }

  .\\32xl\\:even\\:pl-76:nth-child(even){
    padding-left: 19rem;
  }

  .\\32xl\\:even\\:pt-78:nth-child(even){
    padding-top: 19.5rem;
  }

  .\\32xl\\:even\\:pr-78:nth-child(even){
    padding-right: 19.5rem;
  }

  .\\32xl\\:even\\:pb-78:nth-child(even){
    padding-bottom: 19.5rem;
  }

  .\\32xl\\:even\\:pl-78:nth-child(even){
    padding-left: 19.5rem;
  }

  .\\32xl\\:even\\:pt-80:nth-child(even){
    padding-top: 20rem;
  }

  .\\32xl\\:even\\:pr-80:nth-child(even){
    padding-right: 20rem;
  }

  .\\32xl\\:even\\:pb-80:nth-child(even){
    padding-bottom: 20rem;
  }

  .\\32xl\\:even\\:pl-80:nth-child(even){
    padding-left: 20rem;
  }

  .\\32xl\\:even\\:pt-82:nth-child(even){
    padding-top: 20.5rem;
  }

  .\\32xl\\:even\\:pr-82:nth-child(even){
    padding-right: 20.5rem;
  }

  .\\32xl\\:even\\:pb-82:nth-child(even){
    padding-bottom: 20.5rem;
  }

  .\\32xl\\:even\\:pl-82:nth-child(even){
    padding-left: 20.5rem;
  }

  .\\32xl\\:even\\:pt-84:nth-child(even){
    padding-top: 21rem;
  }

  .\\32xl\\:even\\:pr-84:nth-child(even){
    padding-right: 21rem;
  }

  .\\32xl\\:even\\:pb-84:nth-child(even){
    padding-bottom: 21rem;
  }

  .\\32xl\\:even\\:pl-84:nth-child(even){
    padding-left: 21rem;
  }

  .\\32xl\\:even\\:pt-88:nth-child(even){
    padding-top: 22rem;
  }

  .\\32xl\\:even\\:pr-88:nth-child(even){
    padding-right: 22rem;
  }

  .\\32xl\\:even\\:pb-88:nth-child(even){
    padding-bottom: 22rem;
  }

  .\\32xl\\:even\\:pl-88:nth-child(even){
    padding-left: 22rem;
  }

  .\\32xl\\:even\\:pt-92:nth-child(even){
    padding-top: 23rem;
  }

  .\\32xl\\:even\\:pr-92:nth-child(even){
    padding-right: 23rem;
  }

  .\\32xl\\:even\\:pb-92:nth-child(even){
    padding-bottom: 23rem;
  }

  .\\32xl\\:even\\:pl-92:nth-child(even){
    padding-left: 23rem;
  }

  .\\32xl\\:even\\:pt-96:nth-child(even){
    padding-top: 24rem;
  }

  .\\32xl\\:even\\:pr-96:nth-child(even){
    padding-right: 24rem;
  }

  .\\32xl\\:even\\:pb-96:nth-child(even){
    padding-bottom: 24rem;
  }

  .\\32xl\\:even\\:pl-96:nth-child(even){
    padding-left: 24rem;
  }

  .\\32xl\\:even\\:pt-98:nth-child(even){
    padding-top: 24.5rem;
  }

  .\\32xl\\:even\\:pr-98:nth-child(even){
    padding-right: 24.5rem;
  }

  .\\32xl\\:even\\:pb-98:nth-child(even){
    padding-bottom: 24.5rem;
  }

  .\\32xl\\:even\\:pl-98:nth-child(even){
    padding-left: 24.5rem;
  }

  .\\32xl\\:even\\:pt-100:nth-child(even){
    padding-top: 25rem;
  }

  .\\32xl\\:even\\:pr-100:nth-child(even){
    padding-right: 25rem;
  }

  .\\32xl\\:even\\:pb-100:nth-child(even){
    padding-bottom: 25rem;
  }

  .\\32xl\\:even\\:pl-100:nth-child(even){
    padding-left: 25rem;
  }

  .\\32xl\\:even\\:pt-104:nth-child(even){
    padding-top: 26rem;
  }

  .\\32xl\\:even\\:pr-104:nth-child(even){
    padding-right: 26rem;
  }

  .\\32xl\\:even\\:pb-104:nth-child(even){
    padding-bottom: 26rem;
  }

  .\\32xl\\:even\\:pl-104:nth-child(even){
    padding-left: 26rem;
  }

  .\\32xl\\:even\\:pt-112:nth-child(even){
    padding-top: 28rem;
  }

  .\\32xl\\:even\\:pr-112:nth-child(even){
    padding-right: 28rem;
  }

  .\\32xl\\:even\\:pb-112:nth-child(even){
    padding-bottom: 28rem;
  }

  .\\32xl\\:even\\:pl-112:nth-child(even){
    padding-left: 28rem;
  }

  .\\32xl\\:even\\:pt-124:nth-child(even){
    padding-top: 31rem;
  }

  .\\32xl\\:even\\:pr-124:nth-child(even){
    padding-right: 31rem;
  }

  .\\32xl\\:even\\:pb-124:nth-child(even){
    padding-bottom: 31rem;
  }

  .\\32xl\\:even\\:pl-124:nth-child(even){
    padding-left: 31rem;
  }

  .\\32xl\\:even\\:pt-128:nth-child(even){
    padding-top: 32rem;
  }

  .\\32xl\\:even\\:pr-128:nth-child(even){
    padding-right: 32rem;
  }

  .\\32xl\\:even\\:pb-128:nth-child(even){
    padding-bottom: 32rem;
  }

  .\\32xl\\:even\\:pl-128:nth-child(even){
    padding-left: 32rem;
  }

  .\\32xl\\:even\\:pt-140:nth-child(even){
    padding-top: 35rem;
  }

  .\\32xl\\:even\\:pr-140:nth-child(even){
    padding-right: 35rem;
  }

  .\\32xl\\:even\\:pb-140:nth-child(even){
    padding-bottom: 35rem;
  }

  .\\32xl\\:even\\:pl-140:nth-child(even){
    padding-left: 35rem;
  }

  .\\32xl\\:even\\:pt-152:nth-child(even){
    padding-top: 38rem;
  }

  .\\32xl\\:even\\:pr-152:nth-child(even){
    padding-right: 38rem;
  }

  .\\32xl\\:even\\:pb-152:nth-child(even){
    padding-bottom: 38rem;
  }

  .\\32xl\\:even\\:pl-152:nth-child(even){
    padding-left: 38rem;
  }

  .\\32xl\\:even\\:pt-160:nth-child(even){
    padding-top: 40rem;
  }

  .\\32xl\\:even\\:pr-160:nth-child(even){
    padding-right: 40rem;
  }

  .\\32xl\\:even\\:pb-160:nth-child(even){
    padding-bottom: 40rem;
  }

  .\\32xl\\:even\\:pl-160:nth-child(even){
    padding-left: 40rem;
  }

  .\\32xl\\:even\\:pt-162:nth-child(even){
    padding-top: 41rem;
  }

  .\\32xl\\:even\\:pr-162:nth-child(even){
    padding-right: 41rem;
  }

  .\\32xl\\:even\\:pb-162:nth-child(even){
    padding-bottom: 41rem;
  }

  .\\32xl\\:even\\:pl-162:nth-child(even){
    padding-left: 41rem;
  }

  .\\32xl\\:even\\:pt-192:nth-child(even){
    padding-top: 48rem;
  }

  .\\32xl\\:even\\:pr-192:nth-child(even){
    padding-right: 48rem;
  }

  .\\32xl\\:even\\:pb-192:nth-child(even){
    padding-bottom: 48rem;
  }

  .\\32xl\\:even\\:pl-192:nth-child(even){
    padding-left: 48rem;
  }

  .\\32xl\\:even\\:pt-208:nth-child(even){
    padding-top: 52rem;
  }

  .\\32xl\\:even\\:pr-208:nth-child(even){
    padding-right: 52rem;
  }

  .\\32xl\\:even\\:pb-208:nth-child(even){
    padding-bottom: 52rem;
  }

  .\\32xl\\:even\\:pl-208:nth-child(even){
    padding-left: 52rem;
  }

  .\\32xl\\:even\\:pt-224:nth-child(even){
    padding-top: 56rem;
  }

  .\\32xl\\:even\\:pr-224:nth-child(even){
    padding-right: 56rem;
  }

  .\\32xl\\:even\\:pb-224:nth-child(even){
    padding-bottom: 56rem;
  }

  .\\32xl\\:even\\:pl-224:nth-child(even){
    padding-left: 56rem;
  }

  .\\32xl\\:even\\:pt-256:nth-child(even){
    padding-top: 64rem;
  }

  .\\32xl\\:even\\:pr-256:nth-child(even){
    padding-right: 64rem;
  }

  .\\32xl\\:even\\:pb-256:nth-child(even){
    padding-bottom: 64rem;
  }

  .\\32xl\\:even\\:pl-256:nth-child(even){
    padding-left: 64rem;
  }

  .\\32xl\\:even\\:pt-px:nth-child(even){
    padding-top: 1px;
  }

  .\\32xl\\:even\\:pr-px:nth-child(even){
    padding-right: 1px;
  }

  .\\32xl\\:even\\:pb-px:nth-child(even){
    padding-bottom: 1px;
  }

  .\\32xl\\:even\\:pl-px:nth-child(even){
    padding-left: 1px;
  }

  .\\32xl\\:placeholder-transparent::placeholder{
    color: transparent;
  }

  .\\32xl\\:placeholder-focus::placeholder{
    color: rgba(4, 21, 39, 0.8);;
  }

  .\\32xl\\:placeholder-black::placeholder{
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-white::placeholder{
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-primary::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-disabled::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-translucent-60::placeholder{
    color: rgba(256, 256, 256, 0.6);
  }

  .\\32xl\\:placeholder-translucent-90::placeholder{
    color: rgba(256, 256, 256, 0.9);
  }

  .\\32xl\\:placeholder-green-200::placeholder{
    --placeholder-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-green-400::placeholder{
    --placeholder-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-green-500::placeholder{
    --placeholder-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-green-600::placeholder{
    --placeholder-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-green-700::placeholder{
    --placeholder-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-green-400a50::placeholder{
    color: rgba(108,202,152,0.50196);
  }

  .\\32xl\\:placeholder-green-500a25::placeholder{
    color: rgba(151,232,18,0.09804);
  }

  .\\32xl\\:placeholder-yellow-200::placeholder{
    --placeholder-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-yellow-300::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-yellow-500::placeholder{
    --placeholder-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-yellow-600::placeholder{
    --placeholder-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-yellow-700::placeholder{
    --placeholder-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-yellow-300a66::placeholder{
    color: rgba(255,233,189,0.66667);
  }

  .\\32xl\\:placeholder-yellow-500a25::placeholder{
    color: rgba(255,200,44,0.09804);
  }

  .\\32xl\\:placeholder-orange-200::placeholder{
    --placeholder-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-orange-400::placeholder{
    --placeholder-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-orange-500::placeholder{
    --placeholder-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-orange-800::placeholder{
    --placeholder-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-orange-900::placeholder{
    --placeholder-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-orange-500a25::placeholder{
    color: rgba(240,115,23,0.09804);
  }

  .\\32xl\\:placeholder-red-100::placeholder{
    --placeholder-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-red-150::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-red-200::placeholder{
    --placeholder-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-red-300::placeholder{
    --placeholder-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-red-400::placeholder{
    --placeholder-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-red-500::placeholder{
    --placeholder-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-red-700::placeholder{
    --placeholder-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-gray-50::placeholder{
    --placeholder-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-gray-100::placeholder{
    --placeholder-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-gray-150::placeholder{
    --placeholder-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-gray-200::placeholder{
    --placeholder-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-gray-300::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-gray-400::placeholder{
    color: rgba(114,114,114,0.8);
  }

  .\\32xl\\:placeholder-gray-425::placeholder{
    color: rgba(4, 21, 39, 0.8);
  }

  .\\32xl\\:placeholder-gray-450::placeholder{
    --placeholder-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-gray-500::placeholder{
    --placeholder-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-gray-600::placeholder{
    --placeholder-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-gray-625::placeholder{
    color: rgba(90,98,107,0.8);
  }

  .\\32xl\\:placeholder-gray-700::placeholder{
    --placeholder-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-gray-800::placeholder{
    --placeholder-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-gray-200a50::placeholder{
    color: rgba(224, 226, 228, 0.5);
  }

  .\\32xl\\:placeholder-blue-50::placeholder{
    --placeholder-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-blue-100::placeholder{
    --placeholder-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-blue-150::placeholder{
    --placeholder-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-blue-200::placeholder{
    --placeholder-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-blue-300::placeholder{
    --placeholder-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-blue-400::placeholder{
    --placeholder-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-blue-500::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-blue-600::placeholder{
    --placeholder-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-blue-700::placeholder{
    --placeholder-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-blue-750::placeholder{
    --placeholder-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-blue-800::placeholder{
    --placeholder-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-blue-900::placeholder{
    --placeholder-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-blue-950::placeholder{
    --placeholder-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-blue-500a25::placeholder{
    color: rgba(55, 164, 220, 0.2);
  }

  .\\32xl\\:placeholder-blue-500a50::placeholder{
    color: rgba(55, 164, 220, 0.5);
  }

  .\\32xl\\:placeholder-blue-700a75::placeholder{
    --placeholder-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-blue-700a30::placeholder{
    --placeholder-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-blue-750a25::placeholder{
    color: rgba(86,130,170,0.09804);
  }

  .\\32xl\\:placeholder-blue-750a15::placeholder{
    color: rgba(86,130,170,0.05882);
  }

  .\\32xl\\:placeholder-blue-800a60::placeholder{
    color: rgba(31, 69, 102, 0.6);
  }

  .\\32xl\\:placeholder-programEditorTabColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-programEditorTabColors-2::placeholder{
    --placeholder-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-programEditorTabColors-3::placeholder{
    --placeholder-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-programEditorTabColors-4::placeholder{
    --placeholder-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-programEditorTabColors-5::placeholder{
    --placeholder-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-programEditorTabColors-6::placeholder{
    --placeholder-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-programEditorTabColors-1h::placeholder{
    --placeholder-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-programEditorTabColors-2h::placeholder{
    --placeholder-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-programEditorTabColors-3h::placeholder{
    --placeholder-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-programEditorTabColors-4h::placeholder{
    --placeholder-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-programEditorTabColors-5h::placeholder{
    --placeholder-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-programEditorTabColors-6h::placeholder{
    --placeholder-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-programEditorPresetTabColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-programEditorPresetTabColors-1h::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-borgScaleColors-0::placeholder{
    --placeholder-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-borgScaleColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-borgScaleColors-2::placeholder{
    --placeholder-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-borgScaleColors-3::placeholder{
    --placeholder-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-borgScaleColors-4::placeholder{
    --placeholder-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-borgScaleColors-5::placeholder{
    --placeholder-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-borgScaleColors-6::placeholder{
    --placeholder-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-borgScaleColors-7::placeholder{
    --placeholder-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-borgScaleColors-8::placeholder{
    --placeholder-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-borgScaleColors-9::placeholder{
    --placeholder-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-borgScaleColors-10::placeholder{
    --placeholder-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-transparent:focus::placeholder{
    color: transparent;
  }

  .\\32xl\\:focus\\:placeholder-focus:focus::placeholder{
    color: rgba(4, 21, 39, 0.8);;
  }

  .\\32xl\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-primary:focus::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-disabled:focus::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-translucent-60:focus::placeholder{
    color: rgba(256, 256, 256, 0.6);
  }

  .\\32xl\\:focus\\:placeholder-translucent-90:focus::placeholder{
    color: rgba(256, 256, 256, 0.9);
  }

  .\\32xl\\:focus\\:placeholder-green-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-green-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-green-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-green-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-green-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-green-400a50:focus::placeholder{
    color: rgba(108,202,152,0.50196);
  }

  .\\32xl\\:focus\\:placeholder-green-500a25:focus::placeholder{
    color: rgba(151,232,18,0.09804);
  }

  .\\32xl\\:focus\\:placeholder-yellow-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-yellow-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-yellow-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-yellow-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-yellow-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-yellow-300a66:focus::placeholder{
    color: rgba(255,233,189,0.66667);
  }

  .\\32xl\\:focus\\:placeholder-yellow-500a25:focus::placeholder{
    color: rgba(255,200,44,0.09804);
  }

  .\\32xl\\:focus\\:placeholder-orange-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-orange-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-orange-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-orange-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-orange-900:focus::placeholder{
    --placeholder-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-orange-500a25:focus::placeholder{
    color: rgba(240,115,23,0.09804);
  }

  .\\32xl\\:focus\\:placeholder-red-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-red-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-red-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-red-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-red-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-red-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-red-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-gray-50:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-gray-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-gray-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-gray-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-gray-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-gray-400:focus::placeholder{
    color: rgba(114,114,114,0.8);
  }

  .\\32xl\\:focus\\:placeholder-gray-425:focus::placeholder{
    color: rgba(4, 21, 39, 0.8);
  }

  .\\32xl\\:focus\\:placeholder-gray-450:focus::placeholder{
    --placeholder-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-gray-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-gray-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-gray-625:focus::placeholder{
    color: rgba(90,98,107,0.8);
  }

  .\\32xl\\:focus\\:placeholder-gray-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-gray-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-gray-200a50:focus::placeholder{
    color: rgba(224, 226, 228, 0.5);
  }

  .\\32xl\\:focus\\:placeholder-blue-50:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-blue-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-blue-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-blue-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-blue-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-blue-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-blue-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-blue-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-blue-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-blue-750:focus::placeholder{
    --placeholder-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-blue-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-blue-900:focus::placeholder{
    --placeholder-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-blue-950:focus::placeholder{
    --placeholder-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-blue-500a25:focus::placeholder{
    color: rgba(55, 164, 220, 0.2);
  }

  .\\32xl\\:focus\\:placeholder-blue-500a50:focus::placeholder{
    color: rgba(55, 164, 220, 0.5);
  }

  .\\32xl\\:focus\\:placeholder-blue-700a75:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-blue-700a30:focus::placeholder{
    --placeholder-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-blue-750a25:focus::placeholder{
    color: rgba(86,130,170,0.09804);
  }

  .\\32xl\\:focus\\:placeholder-blue-750a15:focus::placeholder{
    color: rgba(86,130,170,0.05882);
  }

  .\\32xl\\:focus\\:placeholder-blue-800a60:focus::placeholder{
    color: rgba(31, 69, 102, 0.6);
  }

  .\\32xl\\:focus\\:placeholder-programEditorTabColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-programEditorTabColors-2:focus::placeholder{
    --placeholder-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-programEditorTabColors-3:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-programEditorTabColors-4:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-programEditorTabColors-5:focus::placeholder{
    --placeholder-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-programEditorTabColors-6:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-programEditorTabColors-1h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-programEditorTabColors-2h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-programEditorTabColors-3h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-programEditorTabColors-4h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-programEditorTabColors-5h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-programEditorTabColors-6h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-programEditorPresetTabColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-programEditorPresetTabColors-1h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-borgScaleColors-0:focus::placeholder{
    --placeholder-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-borgScaleColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-borgScaleColors-2:focus::placeholder{
    --placeholder-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-borgScaleColors-3:focus::placeholder{
    --placeholder-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-borgScaleColors-4:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-borgScaleColors-5:focus::placeholder{
    --placeholder-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-borgScaleColors-6:focus::placeholder{
    --placeholder-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-borgScaleColors-7:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-borgScaleColors-8:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-borgScaleColors-9:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, var(--placeholder-opacity));
  }

  .\\32xl\\:focus\\:placeholder-borgScaleColors-10:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, var(--placeholder-opacity));
  }

  .\\32xl\\:placeholder-opacity-0::placeholder{
    --placeholder-opacity: 0;
  }

  .\\32xl\\:placeholder-opacity-25::placeholder{
    --placeholder-opacity: .25;
  }

  .\\32xl\\:placeholder-opacity-50::placeholder{
    --placeholder-opacity: .5;
  }

  .\\32xl\\:placeholder-opacity-75::placeholder{
    --placeholder-opacity: .75;
  }

  .\\32xl\\:placeholder-opacity-100::placeholder{
    --placeholder-opacity: 1;
  }

  .\\32xl\\:focus\\:placeholder-opacity-0:focus::placeholder{
    --placeholder-opacity: 0;
  }

  .\\32xl\\:focus\\:placeholder-opacity-25:focus::placeholder{
    --placeholder-opacity: .25;
  }

  .\\32xl\\:focus\\:placeholder-opacity-50:focus::placeholder{
    --placeholder-opacity: .5;
  }

  .\\32xl\\:focus\\:placeholder-opacity-75:focus::placeholder{
    --placeholder-opacity: .75;
  }

  .\\32xl\\:focus\\:placeholder-opacity-100:focus::placeholder{
    --placeholder-opacity: 1;
  }

  .\\32xl\\:pointer-events-none{
    pointer-events: none;
  }

  .\\32xl\\:pointer-events-auto{
    pointer-events: auto;
  }

  .\\32xl\\:static{
    position: static;
  }

  .\\32xl\\:fixed{
    position: fixed;
  }

  .\\32xl\\:absolute{
    position: absolute;
  }

  .\\32xl\\:relative{
    position: relative;
  }

  .\\32xl\\:sticky{
    position: sticky;
  }

  .\\32xl\\:inset-0{
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .\\32xl\\:inset-auto{
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }

  .\\32xl\\:inset-y-0{
    top: 0;
    bottom: 0;
  }

  .\\32xl\\:inset-x-0{
    right: 0;
    left: 0;
  }

  .\\32xl\\:inset-y-auto{
    top: auto;
    bottom: auto;
  }

  .\\32xl\\:inset-x-auto{
    right: auto;
    left: auto;
  }

  .\\32xl\\:top-0{
    top: 0;
  }

  .\\32xl\\:right-0{
    right: 0;
  }

  .\\32xl\\:bottom-0{
    bottom: 0;
  }

  .\\32xl\\:left-0{
    left: 0;
  }

  .\\32xl\\:top-auto{
    top: auto;
  }

  .\\32xl\\:right-auto{
    right: auto;
  }

  .\\32xl\\:bottom-auto{
    bottom: auto;
  }

  .\\32xl\\:left-auto{
    left: auto;
  }

  .\\32xl\\:resize-none{
    resize: none;
  }

  .\\32xl\\:resize-y{
    resize: vertical;
  }

  .\\32xl\\:resize-x{
    resize: horizontal;
  }

  .\\32xl\\:resize{
    resize: both;
  }

  .\\32xl\\:shadow{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .\\32xl\\:shadow-overlaptop{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .\\32xl\\:shadow-overlapbottom{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .\\32xl\\:shadow-xs{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .\\32xl\\:shadow-sm{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .\\32xl\\:shadow-md{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .\\32xl\\:shadow-lg{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .\\32xl\\:shadow-xl{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .\\32xl\\:shadow-2xl{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .\\32xl\\:shadow-none{
    box-shadow: none;
  }

  .\\32xl\\:hover\\:shadow:hover{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .\\32xl\\:hover\\:shadow-overlaptop:hover{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .\\32xl\\:hover\\:shadow-overlapbottom:hover{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .\\32xl\\:hover\\:shadow-xs:hover{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .\\32xl\\:hover\\:shadow-sm:hover{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .\\32xl\\:hover\\:shadow-md:hover{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .\\32xl\\:hover\\:shadow-lg:hover{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .\\32xl\\:hover\\:shadow-xl:hover{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .\\32xl\\:hover\\:shadow-2xl:hover{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .\\32xl\\:hover\\:shadow-none:hover{
    box-shadow: none;
  }

  .\\32xl\\:focus\\:shadow:focus{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .\\32xl\\:focus\\:shadow-overlaptop:focus{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .\\32xl\\:focus\\:shadow-overlapbottom:focus{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .\\32xl\\:focus\\:shadow-xs:focus{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .\\32xl\\:focus\\:shadow-sm:focus{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .\\32xl\\:focus\\:shadow-md:focus{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .\\32xl\\:focus\\:shadow-lg:focus{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .\\32xl\\:focus\\:shadow-xl:focus{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .\\32xl\\:focus\\:shadow-2xl:focus{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .\\32xl\\:focus\\:shadow-none:focus{
    box-shadow: none;
  }

  .\\32xl\\:stroke-0{
    stroke-width: 0;
  }

  .\\32xl\\:stroke-1{
    stroke-width: 1;
  }

  .\\32xl\\:stroke-2{
    stroke-width: 2;
  }

  .\\32xl\\:table-auto{
    table-layout: auto;
  }

  .\\32xl\\:table-fixed{
    table-layout: fixed;
  }

  .\\32xl\\:text-left{
    text-align: left;
  }

  .\\32xl\\:text-center{
    text-align: center;
  }

  .\\32xl\\:text-right{
    text-align: right;
  }

  .\\32xl\\:text-justify{
    text-align: justify;
  }

  .\\32xl\\:text-transparent{
    color: transparent;
  }

  .\\32xl\\:text-focus{
    color: rgba(4, 21, 39, 0.8);;
  }

  .\\32xl\\:text-black{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .\\32xl\\:text-white{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .\\32xl\\:text-primary{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .\\32xl\\:text-disabled{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .\\32xl\\:text-translucent-60{
    color: rgba(256, 256, 256, 0.6);
  }

  .\\32xl\\:text-translucent-90{
    color: rgba(256, 256, 256, 0.9);
  }

  .\\32xl\\:text-green-200{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .\\32xl\\:text-green-400{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .\\32xl\\:text-green-500{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .\\32xl\\:text-green-600{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .\\32xl\\:text-green-700{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .\\32xl\\:text-green-400a50{
    color: rgba(108,202,152,0.50196);
  }

  .\\32xl\\:text-green-500a25{
    color: rgba(151,232,18,0.09804);
  }

  .\\32xl\\:text-yellow-200{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .\\32xl\\:text-yellow-300{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .\\32xl\\:text-yellow-500{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .\\32xl\\:text-yellow-600{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .\\32xl\\:text-yellow-700{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .\\32xl\\:text-yellow-300a66{
    color: rgba(255,233,189,0.66667);
  }

  .\\32xl\\:text-yellow-500a25{
    color: rgba(255,200,44,0.09804);
  }

  .\\32xl\\:text-orange-200{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .\\32xl\\:text-orange-400{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .\\32xl\\:text-orange-500{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .\\32xl\\:text-orange-800{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .\\32xl\\:text-orange-900{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .\\32xl\\:text-orange-500a25{
    color: rgba(240,115,23,0.09804);
  }

  .\\32xl\\:text-red-100{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .\\32xl\\:text-red-150{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .\\32xl\\:text-red-200{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .\\32xl\\:text-red-300{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .\\32xl\\:text-red-400{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .\\32xl\\:text-red-500{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .\\32xl\\:text-red-700{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .\\32xl\\:text-gray-50{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .\\32xl\\:text-gray-100{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .\\32xl\\:text-gray-150{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .\\32xl\\:text-gray-200{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .\\32xl\\:text-gray-300{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .\\32xl\\:text-gray-400{
    color: rgba(114,114,114,0.8);
  }

  .\\32xl\\:text-gray-425{
    color: rgba(4, 21, 39, 0.8);
  }

  .\\32xl\\:text-gray-450{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .\\32xl\\:text-gray-500{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .\\32xl\\:text-gray-600{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .\\32xl\\:text-gray-625{
    color: rgba(90,98,107,0.8);
  }

  .\\32xl\\:text-gray-700{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .\\32xl\\:text-gray-800{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .\\32xl\\:text-gray-200a50{
    color: rgba(224, 226, 228, 0.5);
  }

  .\\32xl\\:text-blue-50{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .\\32xl\\:text-blue-100{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .\\32xl\\:text-blue-150{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .\\32xl\\:text-blue-200{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .\\32xl\\:text-blue-300{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .\\32xl\\:text-blue-400{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .\\32xl\\:text-blue-500{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .\\32xl\\:text-blue-600{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .\\32xl\\:text-blue-700{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .\\32xl\\:text-blue-750{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .\\32xl\\:text-blue-800{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .\\32xl\\:text-blue-900{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .\\32xl\\:text-blue-950{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .\\32xl\\:text-blue-500a25{
    color: rgba(55, 164, 220, 0.2);
  }

  .\\32xl\\:text-blue-500a50{
    color: rgba(55, 164, 220, 0.5);
  }

  .\\32xl\\:text-blue-700a75{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .\\32xl\\:text-blue-700a30{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .\\32xl\\:text-blue-750a25{
    color: rgba(86,130,170,0.09804);
  }

  .\\32xl\\:text-blue-750a15{
    color: rgba(86,130,170,0.05882);
  }

  .\\32xl\\:text-blue-800a60{
    color: rgba(31, 69, 102, 0.6);
  }

  .\\32xl\\:text-programEditorTabColors-1{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .\\32xl\\:text-programEditorTabColors-2{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .\\32xl\\:text-programEditorTabColors-3{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .\\32xl\\:text-programEditorTabColors-4{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .\\32xl\\:text-programEditorTabColors-5{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .\\32xl\\:text-programEditorTabColors-6{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .\\32xl\\:text-programEditorTabColors-1h{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .\\32xl\\:text-programEditorTabColors-2h{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .\\32xl\\:text-programEditorTabColors-3h{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .\\32xl\\:text-programEditorTabColors-4h{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .\\32xl\\:text-programEditorTabColors-5h{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .\\32xl\\:text-programEditorTabColors-6h{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .\\32xl\\:text-programEditorPresetTabColors-1{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .\\32xl\\:text-programEditorPresetTabColors-1h{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .\\32xl\\:text-borgScaleColors-0{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .\\32xl\\:text-borgScaleColors-1{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .\\32xl\\:text-borgScaleColors-2{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .\\32xl\\:text-borgScaleColors-3{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .\\32xl\\:text-borgScaleColors-4{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .\\32xl\\:text-borgScaleColors-5{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .\\32xl\\:text-borgScaleColors-6{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .\\32xl\\:text-borgScaleColors-7{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .\\32xl\\:text-borgScaleColors-8{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .\\32xl\\:text-borgScaleColors-9{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .\\32xl\\:text-borgScaleColors-10{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-transparent:hover{
    color: transparent;
  }

  .\\32xl\\:hover\\:text-focus:hover{
    color: rgba(4, 21, 39, 0.8);;
  }

  .\\32xl\\:hover\\:text-black:hover{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-white:hover{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-primary:hover{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-disabled:hover{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-translucent-60:hover{
    color: rgba(256, 256, 256, 0.6);
  }

  .\\32xl\\:hover\\:text-translucent-90:hover{
    color: rgba(256, 256, 256, 0.9);
  }

  .\\32xl\\:hover\\:text-green-200:hover{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-green-400:hover{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-green-500:hover{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-green-600:hover{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-green-700:hover{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-green-400a50:hover{
    color: rgba(108,202,152,0.50196);
  }

  .\\32xl\\:hover\\:text-green-500a25:hover{
    color: rgba(151,232,18,0.09804);
  }

  .\\32xl\\:hover\\:text-yellow-200:hover{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-yellow-300:hover{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-yellow-500:hover{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-yellow-600:hover{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-yellow-700:hover{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-yellow-300a66:hover{
    color: rgba(255,233,189,0.66667);
  }

  .\\32xl\\:hover\\:text-yellow-500a25:hover{
    color: rgba(255,200,44,0.09804);
  }

  .\\32xl\\:hover\\:text-orange-200:hover{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-orange-400:hover{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-orange-500:hover{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-orange-800:hover{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-orange-900:hover{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-orange-500a25:hover{
    color: rgba(240,115,23,0.09804);
  }

  .\\32xl\\:hover\\:text-red-100:hover{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-red-150:hover{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-red-200:hover{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-red-300:hover{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-red-400:hover{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-red-500:hover{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-red-700:hover{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-gray-50:hover{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-gray-100:hover{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-gray-150:hover{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-gray-200:hover{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-gray-300:hover{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-gray-400:hover{
    color: rgba(114,114,114,0.8);
  }

  .\\32xl\\:hover\\:text-gray-425:hover{
    color: rgba(4, 21, 39, 0.8);
  }

  .\\32xl\\:hover\\:text-gray-450:hover{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-gray-500:hover{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-gray-600:hover{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-gray-625:hover{
    color: rgba(90,98,107,0.8);
  }

  .\\32xl\\:hover\\:text-gray-700:hover{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-gray-800:hover{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-gray-200a50:hover{
    color: rgba(224, 226, 228, 0.5);
  }

  .\\32xl\\:hover\\:text-blue-50:hover{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-blue-100:hover{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-blue-150:hover{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-blue-200:hover{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-blue-300:hover{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-blue-400:hover{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-blue-500:hover{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-blue-600:hover{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-blue-700:hover{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-blue-750:hover{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-blue-800:hover{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-blue-900:hover{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-blue-950:hover{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-blue-500a25:hover{
    color: rgba(55, 164, 220, 0.2);
  }

  .\\32xl\\:hover\\:text-blue-500a50:hover{
    color: rgba(55, 164, 220, 0.5);
  }

  .\\32xl\\:hover\\:text-blue-700a75:hover{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-blue-700a30:hover{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-blue-750a25:hover{
    color: rgba(86,130,170,0.09804);
  }

  .\\32xl\\:hover\\:text-blue-750a15:hover{
    color: rgba(86,130,170,0.05882);
  }

  .\\32xl\\:hover\\:text-blue-800a60:hover{
    color: rgba(31, 69, 102, 0.6);
  }

  .\\32xl\\:hover\\:text-programEditorTabColors-1:hover{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-programEditorTabColors-2:hover{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-programEditorTabColors-3:hover{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-programEditorTabColors-4:hover{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-programEditorTabColors-5:hover{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-programEditorTabColors-6:hover{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-programEditorTabColors-1h:hover{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-programEditorTabColors-2h:hover{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-programEditorTabColors-3h:hover{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-programEditorTabColors-4h:hover{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-programEditorTabColors-5h:hover{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-programEditorTabColors-6h:hover{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-programEditorPresetTabColors-1:hover{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-programEditorPresetTabColors-1h:hover{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-borgScaleColors-0:hover{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-borgScaleColors-1:hover{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-borgScaleColors-2:hover{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-borgScaleColors-3:hover{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-borgScaleColors-4:hover{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-borgScaleColors-5:hover{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-borgScaleColors-6:hover{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-borgScaleColors-7:hover{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-borgScaleColors-8:hover{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-borgScaleColors-9:hover{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .\\32xl\\:hover\\:text-borgScaleColors-10:hover{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-transparent:focus{
    color: transparent;
  }

  .\\32xl\\:focus\\:text-focus:focus{
    color: rgba(4, 21, 39, 0.8);;
  }

  .\\32xl\\:focus\\:text-black:focus{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-white:focus{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-primary:focus{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-disabled:focus{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-translucent-60:focus{
    color: rgba(256, 256, 256, 0.6);
  }

  .\\32xl\\:focus\\:text-translucent-90:focus{
    color: rgba(256, 256, 256, 0.9);
  }

  .\\32xl\\:focus\\:text-green-200:focus{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-green-400:focus{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-green-500:focus{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-green-600:focus{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-green-700:focus{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-green-400a50:focus{
    color: rgba(108,202,152,0.50196);
  }

  .\\32xl\\:focus\\:text-green-500a25:focus{
    color: rgba(151,232,18,0.09804);
  }

  .\\32xl\\:focus\\:text-yellow-200:focus{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-yellow-300:focus{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-yellow-500:focus{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-yellow-600:focus{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-yellow-700:focus{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-yellow-300a66:focus{
    color: rgba(255,233,189,0.66667);
  }

  .\\32xl\\:focus\\:text-yellow-500a25:focus{
    color: rgba(255,200,44,0.09804);
  }

  .\\32xl\\:focus\\:text-orange-200:focus{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-orange-400:focus{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-orange-500:focus{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-orange-800:focus{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-orange-900:focus{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-orange-500a25:focus{
    color: rgba(240,115,23,0.09804);
  }

  .\\32xl\\:focus\\:text-red-100:focus{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-red-150:focus{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-red-200:focus{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-red-300:focus{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-red-400:focus{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-red-500:focus{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-red-700:focus{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-gray-50:focus{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-gray-100:focus{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-gray-150:focus{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-gray-200:focus{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-gray-300:focus{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-gray-400:focus{
    color: rgba(114,114,114,0.8);
  }

  .\\32xl\\:focus\\:text-gray-425:focus{
    color: rgba(4, 21, 39, 0.8);
  }

  .\\32xl\\:focus\\:text-gray-450:focus{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-gray-500:focus{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-gray-600:focus{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-gray-625:focus{
    color: rgba(90,98,107,0.8);
  }

  .\\32xl\\:focus\\:text-gray-700:focus{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-gray-800:focus{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-gray-200a50:focus{
    color: rgba(224, 226, 228, 0.5);
  }

  .\\32xl\\:focus\\:text-blue-50:focus{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-blue-100:focus{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-blue-150:focus{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-blue-200:focus{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-blue-300:focus{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-blue-400:focus{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-blue-500:focus{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-blue-600:focus{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-blue-700:focus{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-blue-750:focus{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-blue-800:focus{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-blue-900:focus{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-blue-950:focus{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-blue-500a25:focus{
    color: rgba(55, 164, 220, 0.2);
  }

  .\\32xl\\:focus\\:text-blue-500a50:focus{
    color: rgba(55, 164, 220, 0.5);
  }

  .\\32xl\\:focus\\:text-blue-700a75:focus{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-blue-700a30:focus{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-blue-750a25:focus{
    color: rgba(86,130,170,0.09804);
  }

  .\\32xl\\:focus\\:text-blue-750a15:focus{
    color: rgba(86,130,170,0.05882);
  }

  .\\32xl\\:focus\\:text-blue-800a60:focus{
    color: rgba(31, 69, 102, 0.6);
  }

  .\\32xl\\:focus\\:text-programEditorTabColors-1:focus{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-programEditorTabColors-2:focus{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-programEditorTabColors-3:focus{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-programEditorTabColors-4:focus{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-programEditorTabColors-5:focus{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-programEditorTabColors-6:focus{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-programEditorTabColors-1h:focus{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-programEditorTabColors-2h:focus{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-programEditorTabColors-3h:focus{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-programEditorTabColors-4h:focus{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-programEditorTabColors-5h:focus{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-programEditorTabColors-6h:focus{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-programEditorPresetTabColors-1:focus{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-programEditorPresetTabColors-1h:focus{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-borgScaleColors-0:focus{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-borgScaleColors-1:focus{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-borgScaleColors-2:focus{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-borgScaleColors-3:focus{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-borgScaleColors-4:focus{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-borgScaleColors-5:focus{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-borgScaleColors-6:focus{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-borgScaleColors-7:focus{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-borgScaleColors-8:focus{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-borgScaleColors-9:focus{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .\\32xl\\:focus\\:text-borgScaleColors-10:focus{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .\\32xl\\:text-opacity-0{
    --text-opacity: 0;
  }

  .\\32xl\\:text-opacity-25{
    --text-opacity: .25;
  }

  .\\32xl\\:text-opacity-50{
    --text-opacity: .5;
  }

  .\\32xl\\:text-opacity-75{
    --text-opacity: .75;
  }

  .\\32xl\\:text-opacity-100{
    --text-opacity: 1;
  }

  .\\32xl\\:hover\\:text-opacity-0:hover{
    --text-opacity: 0;
  }

  .\\32xl\\:hover\\:text-opacity-25:hover{
    --text-opacity: .25;
  }

  .\\32xl\\:hover\\:text-opacity-50:hover{
    --text-opacity: .5;
  }

  .\\32xl\\:hover\\:text-opacity-75:hover{
    --text-opacity: .75;
  }

  .\\32xl\\:hover\\:text-opacity-100:hover{
    --text-opacity: 1;
  }

  .\\32xl\\:focus\\:text-opacity-0:focus{
    --text-opacity: 0;
  }

  .\\32xl\\:focus\\:text-opacity-25:focus{
    --text-opacity: .25;
  }

  .\\32xl\\:focus\\:text-opacity-50:focus{
    --text-opacity: .5;
  }

  .\\32xl\\:focus\\:text-opacity-75:focus{
    --text-opacity: .75;
  }

  .\\32xl\\:focus\\:text-opacity-100:focus{
    --text-opacity: 1;
  }

  .\\32xl\\:italic{
    font-style: italic;
  }

  .\\32xl\\:not-italic{
    font-style: normal;
  }

  .\\32xl\\:uppercase{
    text-transform: uppercase;
  }

  .\\32xl\\:lowercase{
    text-transform: lowercase;
  }

  .\\32xl\\:capitalize{
    text-transform: capitalize;
  }

  .\\32xl\\:normal-case{
    text-transform: none;
  }

  .\\32xl\\:underline{
    text-decoration: underline;
  }

  .\\32xl\\:line-through{
    text-decoration: line-through;
  }

  .\\32xl\\:no-underline{
    text-decoration: none;
  }

  .\\32xl\\:hover\\:underline:hover{
    text-decoration: underline;
  }

  .\\32xl\\:hover\\:line-through:hover{
    text-decoration: line-through;
  }

  .\\32xl\\:hover\\:no-underline:hover{
    text-decoration: none;
  }

  .\\32xl\\:focus\\:underline:focus{
    text-decoration: underline;
  }

  .\\32xl\\:focus\\:line-through:focus{
    text-decoration: line-through;
  }

  .\\32xl\\:focus\\:no-underline:focus{
    text-decoration: none;
  }

  .\\32xl\\:antialiased{
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .\\32xl\\:subpixel-antialiased{
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }

  .\\32xl\\:ordinal, .\\32xl\\:slashed-zero, .\\32xl\\:lining-nums, .\\32xl\\:oldstyle-nums, .\\32xl\\:proportional-nums, .\\32xl\\:tabular-nums, .\\32xl\\:diagonal-fractions, .\\32xl\\:stacked-fractions{
    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);
    font-feature-settings: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
  }

  .\\32xl\\:normal-nums{
    font-feature-settings: normal;
    font-variant-numeric: normal;
  }

  .\\32xl\\:ordinal{
    --font-variant-numeric-ordinal: ordinal;
  }

  .\\32xl\\:slashed-zero{
    --font-variant-numeric-slashed-zero: slashed-zero;
  }

  .\\32xl\\:lining-nums{
    --font-variant-numeric-figure: lining-nums;
  }

  .\\32xl\\:oldstyle-nums{
    --font-variant-numeric-figure: oldstyle-nums;
  }

  .\\32xl\\:proportional-nums{
    --font-variant-numeric-spacing: proportional-nums;
  }

  .\\32xl\\:tabular-nums{
    --font-variant-numeric-spacing: tabular-nums;
  }

  .\\32xl\\:diagonal-fractions{
    --font-variant-numeric-fraction: diagonal-fractions;
  }

  .\\32xl\\:stacked-fractions{
    --font-variant-numeric-fraction: stacked-fractions;
  }

  .\\32xl\\:tracking-tight{
    letter-spacing: -0.025em;
  }

  .\\32xl\\:tracking-normal{
    letter-spacing: 0;
  }

  .\\32xl\\:tracking-wide{
    letter-spacing: 0.01em;
  }

  .\\32xl\\:tracking-wider{
    letter-spacing: 0.02em;
  }

  .\\32xl\\:tracking-widest{
    letter-spacing: 0.05em;
  }

  .\\32xl\\:select-none{
    -webkit-user-select: none;
            user-select: none;
  }

  .\\32xl\\:select-text{
    -webkit-user-select: text;
            user-select: text;
  }

  .\\32xl\\:select-all{
    -webkit-user-select: all;
            user-select: all;
  }

  .\\32xl\\:select-auto{
    -webkit-user-select: auto;
            user-select: auto;
  }

  .\\32xl\\:align-baseline{
    vertical-align: baseline;
  }

  .\\32xl\\:align-top{
    vertical-align: top;
  }

  .\\32xl\\:align-middle{
    vertical-align: middle;
  }

  .\\32xl\\:align-bottom{
    vertical-align: bottom;
  }

  .\\32xl\\:align-text-top{
    vertical-align: text-top;
  }

  .\\32xl\\:align-text-bottom{
    vertical-align: text-bottom;
  }

  .\\32xl\\:visible{
    visibility: visible;
  }

  .\\32xl\\:invisible{
    visibility: hidden;
  }

  .\\32xl\\:whitespace-normal{
    white-space: normal;
  }

  .\\32xl\\:whitespace-no-wrap{
    white-space: nowrap;
  }

  .\\32xl\\:whitespace-pre{
    white-space: pre;
  }

  .\\32xl\\:whitespace-pre-line{
    white-space: pre-line;
  }

  .\\32xl\\:whitespace-pre-wrap{
    white-space: pre-wrap;
  }

  .\\32xl\\:break-normal{
    word-wrap: normal;
    word-wrap: normal;
    word-break: normal;
  }

  .\\32xl\\:break-words{
    word-wrap: break-word;
    word-wrap: break-word;
  }

  .\\32xl\\:break-all{
    word-break: break-all;
  }

  .\\32xl\\:truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .\\32xl\\:w-0{
    width: 0;
  }

  .\\32xl\\:w-1{
    width: 0.25rem;
  }

  .\\32xl\\:w-2{
    width: 0.5rem;
  }

  .\\32xl\\:w-3{
    width: 0.75rem;
  }

  .\\32xl\\:w-4{
    width: 1rem;
  }

  .\\32xl\\:w-5{
    width: 1.25rem;
  }

  .\\32xl\\:w-6{
    width: 1.5rem;
  }

  .\\32xl\\:w-7{
    width: 1.75rem;
  }

  .\\32xl\\:w-8{
    width: 2rem;
  }

  .\\32xl\\:w-9{
    width: 2.25rem;
  }

  .\\32xl\\:w-10{
    width: 2.5rem;
  }

  .\\32xl\\:w-11{
    width: 2.75rem;
  }

  .\\32xl\\:w-12{
    width: 3rem;
  }

  .\\32xl\\:w-14{
    width: 3.5rem;
  }

  .\\32xl\\:w-15{
    width: 3.75rem;
  }

  .\\32xl\\:w-16{
    width: 4rem;
  }

  .\\32xl\\:w-18{
    width: 4.5rem;
  }

  .\\32xl\\:w-20{
    width: 5rem;
  }

  .\\32xl\\:w-22{
    width: 5.5rem;
  }

  .\\32xl\\:w-23{
    width: 5.75rem;
  }

  .\\32xl\\:w-24{
    width: 6rem;
  }

  .\\32xl\\:w-25{
    width: 6.25rem;
  }

  .\\32xl\\:w-26{
    width: 6.5rem;
  }

  .\\32xl\\:w-28{
    width: 7rem;
  }

  .\\32xl\\:w-30{
    width: 7.5rem;
  }

  .\\32xl\\:w-32{
    width: 8rem;
  }

  .\\32xl\\:w-34{
    width: 8.5rem;
  }

  .\\32xl\\:w-40{
    width: 10rem;
  }

  .\\32xl\\:w-42{
    width: 10.5rem;
  }

  .\\32xl\\:w-44{
    width: 11rem;
  }

  .\\32xl\\:w-48{
    width: 12rem;
  }

  .\\32xl\\:w-52{
    width: 13rem;
  }

  .\\32xl\\:w-54{
    width: 13.5rem;
  }

  .\\32xl\\:w-56{
    width: 14rem;
  }

  .\\32xl\\:w-60{
    width: 15rem;
  }

  .\\32xl\\:w-64{
    width: 16rem;
  }

  .\\32xl\\:w-68{
    width: 17rem;
  }

  .\\32xl\\:w-72{
    width: 18rem;
  }

  .\\32xl\\:w-74{
    width: 18.5rem;
  }

  .\\32xl\\:w-76{
    width: 19rem;
  }

  .\\32xl\\:w-78{
    width: 19.5rem;
  }

  .\\32xl\\:w-80{
    width: 20rem;
  }

  .\\32xl\\:w-82{
    width: 20.5rem;
  }

  .\\32xl\\:w-84{
    width: 21rem;
  }

  .\\32xl\\:w-88{
    width: 22rem;
  }

  .\\32xl\\:w-92{
    width: 23rem;
  }

  .\\32xl\\:w-96{
    width: 24rem;
  }

  .\\32xl\\:w-98{
    width: 24.5rem;
  }

  .\\32xl\\:w-100{
    width: 25rem;
  }

  .\\32xl\\:w-104{
    width: 26rem;
  }

  .\\32xl\\:w-112{
    width: 28rem;
  }

  .\\32xl\\:w-124{
    width: 31rem;
  }

  .\\32xl\\:w-128{
    width: 32rem;
  }

  .\\32xl\\:w-140{
    width: 35rem;
  }

  .\\32xl\\:w-152{
    width: 38rem;
  }

  .\\32xl\\:w-160{
    width: 40rem;
  }

  .\\32xl\\:w-162{
    width: 41rem;
  }

  .\\32xl\\:w-192{
    width: 48rem;
  }

  .\\32xl\\:w-208{
    width: 52rem;
  }

  .\\32xl\\:w-224{
    width: 56rem;
  }

  .\\32xl\\:w-256{
    width: 64rem;
  }

  .\\32xl\\:w-auto{
    width: auto;
  }

  .\\32xl\\:w-px{
    width: 1px;
  }

  .\\32xl\\:w-1\\/2{
    width: 50%;
  }

  .\\32xl\\:w-1\\/3{
    width: 33.33333%;
  }

  .\\32xl\\:w-2\\/3{
    width: 66.66667%;
  }

  .\\32xl\\:w-1\\/4{
    width: 25%;
  }

  .\\32xl\\:w-3\\/4{
    width: 75%;
  }

  .\\32xl\\:w-1\\/5{
    width: 20%;
  }

  .\\32xl\\:w-2\\/5{
    width: 40%;
  }

  .\\32xl\\:w-3\\/5{
    width: 60%;
  }

  .\\32xl\\:w-4\\/5{
    width: 80%;
  }

  .\\32xl\\:w-1\\/6{
    width: 16.66667%;
  }

  .\\32xl\\:w-5\\/6{
    width: 83.33333%;
  }

  .\\32xl\\:w-1\\/7{
    width: 14.285714285%;
  }

  .\\32xl\\:w-2\\/7{
    width: 28.571428571%;
  }

  .\\32xl\\:w-3\\/7{
    width: 42.85714285%;
  }

  .\\32xl\\:w-4\\/7{
    width: 57.14285714%;
  }

  .\\32xl\\:w-1\\/9{
    width: 11.1111%;
  }

  .\\32xl\\:w-9\\/10{
    width: 90%;
  }

  .\\32xl\\:w-full{
    width: 100%;
  }

  .\\32xl\\:w-screen{
    width: 100vw;
  }

  .\\32xl\\:w-max{
    width: max-content;
  }

  .\\32xl\\:z-0{
    z-index: 0;
  }

  .\\32xl\\:z-10{
    z-index: 10;
  }

  .\\32xl\\:z-20{
    z-index: 20;
  }

  .\\32xl\\:z-30{
    z-index: 30;
  }

  .\\32xl\\:z-40{
    z-index: 40;
  }

  .\\32xl\\:z-50{
    z-index: 50;
  }

  .\\32xl\\:z-auto{
    z-index: auto;
  }

  .\\32xl\\:gap-0{
    grid-gap: 0;
    gap: 0;
  }

  .\\32xl\\:gap-1{
    grid-gap: 0.25rem;
    gap: 0.25rem;
  }

  .\\32xl\\:gap-2{
    grid-gap: 0.5rem;
    gap: 0.5rem;
  }

  .\\32xl\\:gap-3{
    grid-gap: 0.75rem;
    gap: 0.75rem;
  }

  .\\32xl\\:gap-4{
    grid-gap: 1rem;
    gap: 1rem;
  }

  .\\32xl\\:gap-5{
    grid-gap: 1.25rem;
    gap: 1.25rem;
  }

  .\\32xl\\:gap-6{
    grid-gap: 1.5rem;
    gap: 1.5rem;
  }

  .\\32xl\\:gap-7{
    grid-gap: 1.75rem;
    gap: 1.75rem;
  }

  .\\32xl\\:gap-8{
    grid-gap: 2rem;
    gap: 2rem;
  }

  .\\32xl\\:gap-9{
    grid-gap: 2.25rem;
    gap: 2.25rem;
  }

  .\\32xl\\:gap-10{
    grid-gap: 2.5rem;
    gap: 2.5rem;
  }

  .\\32xl\\:gap-11{
    grid-gap: 2.75rem;
    gap: 2.75rem;
  }

  .\\32xl\\:gap-12{
    grid-gap: 3rem;
    gap: 3rem;
  }

  .\\32xl\\:gap-14{
    grid-gap: 3.5rem;
    gap: 3.5rem;
  }

  .\\32xl\\:gap-15{
    grid-gap: 3.75rem;
    gap: 3.75rem;
  }

  .\\32xl\\:gap-16{
    grid-gap: 4rem;
    gap: 4rem;
  }

  .\\32xl\\:gap-18{
    grid-gap: 4.5rem;
    gap: 4.5rem;
  }

  .\\32xl\\:gap-20{
    grid-gap: 5rem;
    gap: 5rem;
  }

  .\\32xl\\:gap-22{
    grid-gap: 5.5rem;
    gap: 5.5rem;
  }

  .\\32xl\\:gap-23{
    grid-gap: 5.75rem;
    gap: 5.75rem;
  }

  .\\32xl\\:gap-24{
    grid-gap: 6rem;
    gap: 6rem;
  }

  .\\32xl\\:gap-25{
    grid-gap: 6.25rem;
    gap: 6.25rem;
  }

  .\\32xl\\:gap-26{
    grid-gap: 6.5rem;
    gap: 6.5rem;
  }

  .\\32xl\\:gap-28{
    grid-gap: 7rem;
    gap: 7rem;
  }

  .\\32xl\\:gap-30{
    grid-gap: 7.5rem;
    gap: 7.5rem;
  }

  .\\32xl\\:gap-32{
    grid-gap: 8rem;
    gap: 8rem;
  }

  .\\32xl\\:gap-34{
    grid-gap: 8.5rem;
    gap: 8.5rem;
  }

  .\\32xl\\:gap-40{
    grid-gap: 10rem;
    gap: 10rem;
  }

  .\\32xl\\:gap-42{
    grid-gap: 10.5rem;
    gap: 10.5rem;
  }

  .\\32xl\\:gap-44{
    grid-gap: 11rem;
    gap: 11rem;
  }

  .\\32xl\\:gap-48{
    grid-gap: 12rem;
    gap: 12rem;
  }

  .\\32xl\\:gap-52{
    grid-gap: 13rem;
    gap: 13rem;
  }

  .\\32xl\\:gap-54{
    grid-gap: 13.5rem;
    gap: 13.5rem;
  }

  .\\32xl\\:gap-56{
    grid-gap: 14rem;
    gap: 14rem;
  }

  .\\32xl\\:gap-60{
    grid-gap: 15rem;
    gap: 15rem;
  }

  .\\32xl\\:gap-64{
    grid-gap: 16rem;
    gap: 16rem;
  }

  .\\32xl\\:gap-68{
    grid-gap: 17rem;
    gap: 17rem;
  }

  .\\32xl\\:gap-72{
    grid-gap: 18rem;
    gap: 18rem;
  }

  .\\32xl\\:gap-74{
    grid-gap: 18.5rem;
    gap: 18.5rem;
  }

  .\\32xl\\:gap-76{
    grid-gap: 19rem;
    gap: 19rem;
  }

  .\\32xl\\:gap-78{
    grid-gap: 19.5rem;
    gap: 19.5rem;
  }

  .\\32xl\\:gap-80{
    grid-gap: 20rem;
    gap: 20rem;
  }

  .\\32xl\\:gap-82{
    grid-gap: 20.5rem;
    gap: 20.5rem;
  }

  .\\32xl\\:gap-84{
    grid-gap: 21rem;
    gap: 21rem;
  }

  .\\32xl\\:gap-88{
    grid-gap: 22rem;
    gap: 22rem;
  }

  .\\32xl\\:gap-92{
    grid-gap: 23rem;
    gap: 23rem;
  }

  .\\32xl\\:gap-96{
    grid-gap: 24rem;
    gap: 24rem;
  }

  .\\32xl\\:gap-98{
    grid-gap: 24.5rem;
    gap: 24.5rem;
  }

  .\\32xl\\:gap-100{
    grid-gap: 25rem;
    gap: 25rem;
  }

  .\\32xl\\:gap-104{
    grid-gap: 26rem;
    gap: 26rem;
  }

  .\\32xl\\:gap-112{
    grid-gap: 28rem;
    gap: 28rem;
  }

  .\\32xl\\:gap-124{
    grid-gap: 31rem;
    gap: 31rem;
  }

  .\\32xl\\:gap-128{
    grid-gap: 32rem;
    gap: 32rem;
  }

  .\\32xl\\:gap-140{
    grid-gap: 35rem;
    gap: 35rem;
  }

  .\\32xl\\:gap-152{
    grid-gap: 38rem;
    gap: 38rem;
  }

  .\\32xl\\:gap-160{
    grid-gap: 40rem;
    gap: 40rem;
  }

  .\\32xl\\:gap-162{
    grid-gap: 41rem;
    gap: 41rem;
  }

  .\\32xl\\:gap-192{
    grid-gap: 48rem;
    gap: 48rem;
  }

  .\\32xl\\:gap-208{
    grid-gap: 52rem;
    gap: 52rem;
  }

  .\\32xl\\:gap-224{
    grid-gap: 56rem;
    gap: 56rem;
  }

  .\\32xl\\:gap-256{
    grid-gap: 64rem;
    gap: 64rem;
  }

  .\\32xl\\:gap-px{
    grid-gap: 1px;
    gap: 1px;
  }

  .\\32xl\\:gap-x-0{
    grid-column-gap: 0;
    -moz-column-gap: 0;
         column-gap: 0;
  }

  .\\32xl\\:gap-x-1{
    grid-column-gap: 0.25rem;
    -moz-column-gap: 0.25rem;
         column-gap: 0.25rem;
  }

  .\\32xl\\:gap-x-2{
    grid-column-gap: 0.5rem;
    -moz-column-gap: 0.5rem;
         column-gap: 0.5rem;
  }

  .\\32xl\\:gap-x-3{
    grid-column-gap: 0.75rem;
    -moz-column-gap: 0.75rem;
         column-gap: 0.75rem;
  }

  .\\32xl\\:gap-x-4{
    grid-column-gap: 1rem;
    -moz-column-gap: 1rem;
         column-gap: 1rem;
  }

  .\\32xl\\:gap-x-5{
    grid-column-gap: 1.25rem;
    -moz-column-gap: 1.25rem;
         column-gap: 1.25rem;
  }

  .\\32xl\\:gap-x-6{
    grid-column-gap: 1.5rem;
    -moz-column-gap: 1.5rem;
         column-gap: 1.5rem;
  }

  .\\32xl\\:gap-x-7{
    grid-column-gap: 1.75rem;
    -moz-column-gap: 1.75rem;
         column-gap: 1.75rem;
  }

  .\\32xl\\:gap-x-8{
    grid-column-gap: 2rem;
    -moz-column-gap: 2rem;
         column-gap: 2rem;
  }

  .\\32xl\\:gap-x-9{
    grid-column-gap: 2.25rem;
    -moz-column-gap: 2.25rem;
         column-gap: 2.25rem;
  }

  .\\32xl\\:gap-x-10{
    grid-column-gap: 2.5rem;
    -moz-column-gap: 2.5rem;
         column-gap: 2.5rem;
  }

  .\\32xl\\:gap-x-11{
    grid-column-gap: 2.75rem;
    -moz-column-gap: 2.75rem;
         column-gap: 2.75rem;
  }

  .\\32xl\\:gap-x-12{
    grid-column-gap: 3rem;
    -moz-column-gap: 3rem;
         column-gap: 3rem;
  }

  .\\32xl\\:gap-x-14{
    grid-column-gap: 3.5rem;
    -moz-column-gap: 3.5rem;
         column-gap: 3.5rem;
  }

  .\\32xl\\:gap-x-15{
    grid-column-gap: 3.75rem;
    -moz-column-gap: 3.75rem;
         column-gap: 3.75rem;
  }

  .\\32xl\\:gap-x-16{
    grid-column-gap: 4rem;
    -moz-column-gap: 4rem;
         column-gap: 4rem;
  }

  .\\32xl\\:gap-x-18{
    grid-column-gap: 4.5rem;
    -moz-column-gap: 4.5rem;
         column-gap: 4.5rem;
  }

  .\\32xl\\:gap-x-20{
    grid-column-gap: 5rem;
    -moz-column-gap: 5rem;
         column-gap: 5rem;
  }

  .\\32xl\\:gap-x-22{
    grid-column-gap: 5.5rem;
    -moz-column-gap: 5.5rem;
         column-gap: 5.5rem;
  }

  .\\32xl\\:gap-x-23{
    grid-column-gap: 5.75rem;
    -moz-column-gap: 5.75rem;
         column-gap: 5.75rem;
  }

  .\\32xl\\:gap-x-24{
    grid-column-gap: 6rem;
    -moz-column-gap: 6rem;
         column-gap: 6rem;
  }

  .\\32xl\\:gap-x-25{
    grid-column-gap: 6.25rem;
    -moz-column-gap: 6.25rem;
         column-gap: 6.25rem;
  }

  .\\32xl\\:gap-x-26{
    grid-column-gap: 6.5rem;
    -moz-column-gap: 6.5rem;
         column-gap: 6.5rem;
  }

  .\\32xl\\:gap-x-28{
    grid-column-gap: 7rem;
    -moz-column-gap: 7rem;
         column-gap: 7rem;
  }

  .\\32xl\\:gap-x-30{
    grid-column-gap: 7.5rem;
    -moz-column-gap: 7.5rem;
         column-gap: 7.5rem;
  }

  .\\32xl\\:gap-x-32{
    grid-column-gap: 8rem;
    -moz-column-gap: 8rem;
         column-gap: 8rem;
  }

  .\\32xl\\:gap-x-34{
    grid-column-gap: 8.5rem;
    -moz-column-gap: 8.5rem;
         column-gap: 8.5rem;
  }

  .\\32xl\\:gap-x-40{
    grid-column-gap: 10rem;
    -moz-column-gap: 10rem;
         column-gap: 10rem;
  }

  .\\32xl\\:gap-x-42{
    grid-column-gap: 10.5rem;
    -moz-column-gap: 10.5rem;
         column-gap: 10.5rem;
  }

  .\\32xl\\:gap-x-44{
    grid-column-gap: 11rem;
    -moz-column-gap: 11rem;
         column-gap: 11rem;
  }

  .\\32xl\\:gap-x-48{
    grid-column-gap: 12rem;
    -moz-column-gap: 12rem;
         column-gap: 12rem;
  }

  .\\32xl\\:gap-x-52{
    grid-column-gap: 13rem;
    -moz-column-gap: 13rem;
         column-gap: 13rem;
  }

  .\\32xl\\:gap-x-54{
    grid-column-gap: 13.5rem;
    -moz-column-gap: 13.5rem;
         column-gap: 13.5rem;
  }

  .\\32xl\\:gap-x-56{
    grid-column-gap: 14rem;
    -moz-column-gap: 14rem;
         column-gap: 14rem;
  }

  .\\32xl\\:gap-x-60{
    grid-column-gap: 15rem;
    -moz-column-gap: 15rem;
         column-gap: 15rem;
  }

  .\\32xl\\:gap-x-64{
    grid-column-gap: 16rem;
    -moz-column-gap: 16rem;
         column-gap: 16rem;
  }

  .\\32xl\\:gap-x-68{
    grid-column-gap: 17rem;
    -moz-column-gap: 17rem;
         column-gap: 17rem;
  }

  .\\32xl\\:gap-x-72{
    grid-column-gap: 18rem;
    -moz-column-gap: 18rem;
         column-gap: 18rem;
  }

  .\\32xl\\:gap-x-74{
    grid-column-gap: 18.5rem;
    -moz-column-gap: 18.5rem;
         column-gap: 18.5rem;
  }

  .\\32xl\\:gap-x-76{
    grid-column-gap: 19rem;
    -moz-column-gap: 19rem;
         column-gap: 19rem;
  }

  .\\32xl\\:gap-x-78{
    grid-column-gap: 19.5rem;
    -moz-column-gap: 19.5rem;
         column-gap: 19.5rem;
  }

  .\\32xl\\:gap-x-80{
    grid-column-gap: 20rem;
    -moz-column-gap: 20rem;
         column-gap: 20rem;
  }

  .\\32xl\\:gap-x-82{
    grid-column-gap: 20.5rem;
    -moz-column-gap: 20.5rem;
         column-gap: 20.5rem;
  }

  .\\32xl\\:gap-x-84{
    grid-column-gap: 21rem;
    -moz-column-gap: 21rem;
         column-gap: 21rem;
  }

  .\\32xl\\:gap-x-88{
    grid-column-gap: 22rem;
    -moz-column-gap: 22rem;
         column-gap: 22rem;
  }

  .\\32xl\\:gap-x-92{
    grid-column-gap: 23rem;
    -moz-column-gap: 23rem;
         column-gap: 23rem;
  }

  .\\32xl\\:gap-x-96{
    grid-column-gap: 24rem;
    -moz-column-gap: 24rem;
         column-gap: 24rem;
  }

  .\\32xl\\:gap-x-98{
    grid-column-gap: 24.5rem;
    -moz-column-gap: 24.5rem;
         column-gap: 24.5rem;
  }

  .\\32xl\\:gap-x-100{
    grid-column-gap: 25rem;
    -moz-column-gap: 25rem;
         column-gap: 25rem;
  }

  .\\32xl\\:gap-x-104{
    grid-column-gap: 26rem;
    -moz-column-gap: 26rem;
         column-gap: 26rem;
  }

  .\\32xl\\:gap-x-112{
    grid-column-gap: 28rem;
    -moz-column-gap: 28rem;
         column-gap: 28rem;
  }

  .\\32xl\\:gap-x-124{
    grid-column-gap: 31rem;
    -moz-column-gap: 31rem;
         column-gap: 31rem;
  }

  .\\32xl\\:gap-x-128{
    grid-column-gap: 32rem;
    -moz-column-gap: 32rem;
         column-gap: 32rem;
  }

  .\\32xl\\:gap-x-140{
    grid-column-gap: 35rem;
    -moz-column-gap: 35rem;
         column-gap: 35rem;
  }

  .\\32xl\\:gap-x-152{
    grid-column-gap: 38rem;
    -moz-column-gap: 38rem;
         column-gap: 38rem;
  }

  .\\32xl\\:gap-x-160{
    grid-column-gap: 40rem;
    -moz-column-gap: 40rem;
         column-gap: 40rem;
  }

  .\\32xl\\:gap-x-162{
    grid-column-gap: 41rem;
    -moz-column-gap: 41rem;
         column-gap: 41rem;
  }

  .\\32xl\\:gap-x-192{
    grid-column-gap: 48rem;
    -moz-column-gap: 48rem;
         column-gap: 48rem;
  }

  .\\32xl\\:gap-x-208{
    grid-column-gap: 52rem;
    -moz-column-gap: 52rem;
         column-gap: 52rem;
  }

  .\\32xl\\:gap-x-224{
    grid-column-gap: 56rem;
    -moz-column-gap: 56rem;
         column-gap: 56rem;
  }

  .\\32xl\\:gap-x-256{
    grid-column-gap: 64rem;
    -moz-column-gap: 64rem;
         column-gap: 64rem;
  }

  .\\32xl\\:gap-x-px{
    grid-column-gap: 1px;
    -moz-column-gap: 1px;
         column-gap: 1px;
  }

  .\\32xl\\:gap-y-0{
    grid-row-gap: 0;
    row-gap: 0;
  }

  .\\32xl\\:gap-y-1{
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }

  .\\32xl\\:gap-y-2{
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }

  .\\32xl\\:gap-y-3{
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }

  .\\32xl\\:gap-y-4{
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }

  .\\32xl\\:gap-y-5{
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }

  .\\32xl\\:gap-y-6{
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }

  .\\32xl\\:gap-y-7{
    grid-row-gap: 1.75rem;
    row-gap: 1.75rem;
  }

  .\\32xl\\:gap-y-8{
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }

  .\\32xl\\:gap-y-9{
    grid-row-gap: 2.25rem;
    row-gap: 2.25rem;
  }

  .\\32xl\\:gap-y-10{
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }

  .\\32xl\\:gap-y-11{
    grid-row-gap: 2.75rem;
    row-gap: 2.75rem;
  }

  .\\32xl\\:gap-y-12{
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }

  .\\32xl\\:gap-y-14{
    grid-row-gap: 3.5rem;
    row-gap: 3.5rem;
  }

  .\\32xl\\:gap-y-15{
    grid-row-gap: 3.75rem;
    row-gap: 3.75rem;
  }

  .\\32xl\\:gap-y-16{
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }

  .\\32xl\\:gap-y-18{
    grid-row-gap: 4.5rem;
    row-gap: 4.5rem;
  }

  .\\32xl\\:gap-y-20{
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }

  .\\32xl\\:gap-y-22{
    grid-row-gap: 5.5rem;
    row-gap: 5.5rem;
  }

  .\\32xl\\:gap-y-23{
    grid-row-gap: 5.75rem;
    row-gap: 5.75rem;
  }

  .\\32xl\\:gap-y-24{
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }

  .\\32xl\\:gap-y-25{
    grid-row-gap: 6.25rem;
    row-gap: 6.25rem;
  }

  .\\32xl\\:gap-y-26{
    grid-row-gap: 6.5rem;
    row-gap: 6.5rem;
  }

  .\\32xl\\:gap-y-28{
    grid-row-gap: 7rem;
    row-gap: 7rem;
  }

  .\\32xl\\:gap-y-30{
    grid-row-gap: 7.5rem;
    row-gap: 7.5rem;
  }

  .\\32xl\\:gap-y-32{
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }

  .\\32xl\\:gap-y-34{
    grid-row-gap: 8.5rem;
    row-gap: 8.5rem;
  }

  .\\32xl\\:gap-y-40{
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }

  .\\32xl\\:gap-y-42{
    grid-row-gap: 10.5rem;
    row-gap: 10.5rem;
  }

  .\\32xl\\:gap-y-44{
    grid-row-gap: 11rem;
    row-gap: 11rem;
  }

  .\\32xl\\:gap-y-48{
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }

  .\\32xl\\:gap-y-52{
    grid-row-gap: 13rem;
    row-gap: 13rem;
  }

  .\\32xl\\:gap-y-54{
    grid-row-gap: 13.5rem;
    row-gap: 13.5rem;
  }

  .\\32xl\\:gap-y-56{
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }

  .\\32xl\\:gap-y-60{
    grid-row-gap: 15rem;
    row-gap: 15rem;
  }

  .\\32xl\\:gap-y-64{
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }

  .\\32xl\\:gap-y-68{
    grid-row-gap: 17rem;
    row-gap: 17rem;
  }

  .\\32xl\\:gap-y-72{
    grid-row-gap: 18rem;
    row-gap: 18rem;
  }

  .\\32xl\\:gap-y-74{
    grid-row-gap: 18.5rem;
    row-gap: 18.5rem;
  }

  .\\32xl\\:gap-y-76{
    grid-row-gap: 19rem;
    row-gap: 19rem;
  }

  .\\32xl\\:gap-y-78{
    grid-row-gap: 19.5rem;
    row-gap: 19.5rem;
  }

  .\\32xl\\:gap-y-80{
    grid-row-gap: 20rem;
    row-gap: 20rem;
  }

  .\\32xl\\:gap-y-82{
    grid-row-gap: 20.5rem;
    row-gap: 20.5rem;
  }

  .\\32xl\\:gap-y-84{
    grid-row-gap: 21rem;
    row-gap: 21rem;
  }

  .\\32xl\\:gap-y-88{
    grid-row-gap: 22rem;
    row-gap: 22rem;
  }

  .\\32xl\\:gap-y-92{
    grid-row-gap: 23rem;
    row-gap: 23rem;
  }

  .\\32xl\\:gap-y-96{
    grid-row-gap: 24rem;
    row-gap: 24rem;
  }

  .\\32xl\\:gap-y-98{
    grid-row-gap: 24.5rem;
    row-gap: 24.5rem;
  }

  .\\32xl\\:gap-y-100{
    grid-row-gap: 25rem;
    row-gap: 25rem;
  }

  .\\32xl\\:gap-y-104{
    grid-row-gap: 26rem;
    row-gap: 26rem;
  }

  .\\32xl\\:gap-y-112{
    grid-row-gap: 28rem;
    row-gap: 28rem;
  }

  .\\32xl\\:gap-y-124{
    grid-row-gap: 31rem;
    row-gap: 31rem;
  }

  .\\32xl\\:gap-y-128{
    grid-row-gap: 32rem;
    row-gap: 32rem;
  }

  .\\32xl\\:gap-y-140{
    grid-row-gap: 35rem;
    row-gap: 35rem;
  }

  .\\32xl\\:gap-y-152{
    grid-row-gap: 38rem;
    row-gap: 38rem;
  }

  .\\32xl\\:gap-y-160{
    grid-row-gap: 40rem;
    row-gap: 40rem;
  }

  .\\32xl\\:gap-y-162{
    grid-row-gap: 41rem;
    row-gap: 41rem;
  }

  .\\32xl\\:gap-y-192{
    grid-row-gap: 48rem;
    row-gap: 48rem;
  }

  .\\32xl\\:gap-y-208{
    grid-row-gap: 52rem;
    row-gap: 52rem;
  }

  .\\32xl\\:gap-y-224{
    grid-row-gap: 56rem;
    row-gap: 56rem;
  }

  .\\32xl\\:gap-y-256{
    grid-row-gap: 64rem;
    row-gap: 64rem;
  }

  .\\32xl\\:gap-y-px{
    grid-row-gap: 1px;
    row-gap: 1px;
  }

  .\\32xl\\:grid-flow-row{
    grid-auto-flow: row;
  }

  .\\32xl\\:grid-flow-col{
    grid-auto-flow: column;
  }

  .\\32xl\\:grid-flow-row-dense{
    grid-auto-flow: row dense;
  }

  .\\32xl\\:grid-flow-col-dense{
    grid-auto-flow: column dense;
  }

  .\\32xl\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-9{
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-10{
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-11{
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-14{
    grid-template-columns: repeat(14, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-none{
    grid-template-columns: none;
  }

  .\\32xl\\:auto-cols-auto{
    grid-auto-columns: auto;
  }

  .\\32xl\\:auto-cols-min{
    grid-auto-columns: min-content;
  }

  .\\32xl\\:auto-cols-max{
    grid-auto-columns: max-content;
  }

  .\\32xl\\:auto-cols-fr{
    grid-auto-columns: minmax(0, 1fr);
  }

  .\\32xl\\:col-auto{
    grid-column: auto;
  }

  .\\32xl\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .\\32xl\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .\\32xl\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .\\32xl\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .\\32xl\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .\\32xl\\:col-span-6{
    grid-column: span 6 / span 6;
  }

  .\\32xl\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .\\32xl\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .\\32xl\\:col-span-9{
    grid-column: span 9 / span 9;
  }

  .\\32xl\\:col-span-10{
    grid-column: span 10 / span 10;
  }

  .\\32xl\\:col-span-11{
    grid-column: span 11 / span 11;
  }

  .\\32xl\\:col-span-12{
    grid-column: span 12 / span 12;
  }

  .\\32xl\\:col-span-full{
    grid-column: 1 / -1;
  }

  .\\32xl\\:col-start-1{
    grid-column-start: 1;
  }

  .\\32xl\\:col-start-2{
    grid-column-start: 2;
  }

  .\\32xl\\:col-start-3{
    grid-column-start: 3;
  }

  .\\32xl\\:col-start-4{
    grid-column-start: 4;
  }

  .\\32xl\\:col-start-5{
    grid-column-start: 5;
  }

  .\\32xl\\:col-start-6{
    grid-column-start: 6;
  }

  .\\32xl\\:col-start-7{
    grid-column-start: 7;
  }

  .\\32xl\\:col-start-8{
    grid-column-start: 8;
  }

  .\\32xl\\:col-start-9{
    grid-column-start: 9;
  }

  .\\32xl\\:col-start-10{
    grid-column-start: 10;
  }

  .\\32xl\\:col-start-11{
    grid-column-start: 11;
  }

  .\\32xl\\:col-start-12{
    grid-column-start: 12;
  }

  .\\32xl\\:col-start-13{
    grid-column-start: 13;
  }

  .\\32xl\\:col-start-14{
    grid-column-start: 14;
  }

  .\\32xl\\:col-start-15{
    grid-column-start: 15;
  }

  .\\32xl\\:col-start-auto{
    grid-column-start: auto;
  }

  .\\32xl\\:col-end-1{
    grid-column-end: 1;
  }

  .\\32xl\\:col-end-2{
    grid-column-end: 2;
  }

  .\\32xl\\:col-end-3{
    grid-column-end: 3;
  }

  .\\32xl\\:col-end-4{
    grid-column-end: 4;
  }

  .\\32xl\\:col-end-5{
    grid-column-end: 5;
  }

  .\\32xl\\:col-end-6{
    grid-column-end: 6;
  }

  .\\32xl\\:col-end-7{
    grid-column-end: 7;
  }

  .\\32xl\\:col-end-8{
    grid-column-end: 8;
  }

  .\\32xl\\:col-end-9{
    grid-column-end: 9;
  }

  .\\32xl\\:col-end-10{
    grid-column-end: 10;
  }

  .\\32xl\\:col-end-11{
    grid-column-end: 11;
  }

  .\\32xl\\:col-end-12{
    grid-column-end: 12;
  }

  .\\32xl\\:col-end-13{
    grid-column-end: 13;
  }

  .\\32xl\\:col-end-14{
    grid-column-end: 14;
  }

  .\\32xl\\:col-end-15{
    grid-column-end: 15;
  }

  .\\32xl\\:col-end-auto{
    grid-column-end: auto;
  }

  .\\32xl\\:grid-rows-1{
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .\\32xl\\:grid-rows-2{
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .\\32xl\\:grid-rows-3{
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }

  .\\32xl\\:grid-rows-4{
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }

  .\\32xl\\:grid-rows-5{
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }

  .\\32xl\\:grid-rows-6{
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }

  .\\32xl\\:grid-rows-none{
    grid-template-rows: none;
  }

  .\\32xl\\:auto-rows-auto{
    grid-auto-rows: auto;
  }

  .\\32xl\\:auto-rows-min{
    grid-auto-rows: min-content;
  }

  .\\32xl\\:auto-rows-max{
    grid-auto-rows: max-content;
  }

  .\\32xl\\:auto-rows-fr{
    grid-auto-rows: minmax(0, 1fr);
  }

  .\\32xl\\:row-auto{
    grid-row: auto;
  }

  .\\32xl\\:row-span-1{
    grid-row: span 1 / span 1;
  }

  .\\32xl\\:row-span-2{
    grid-row: span 2 / span 2;
  }

  .\\32xl\\:row-span-3{
    grid-row: span 3 / span 3;
  }

  .\\32xl\\:row-span-4{
    grid-row: span 4 / span 4;
  }

  .\\32xl\\:row-span-5{
    grid-row: span 5 / span 5;
  }

  .\\32xl\\:row-span-6{
    grid-row: span 6 / span 6;
  }

  .\\32xl\\:row-span-full{
    grid-row: 1 / -1;
  }

  .\\32xl\\:row-start-1{
    grid-row-start: 1;
  }

  .\\32xl\\:row-start-2{
    grid-row-start: 2;
  }

  .\\32xl\\:row-start-3{
    grid-row-start: 3;
  }

  .\\32xl\\:row-start-4{
    grid-row-start: 4;
  }

  .\\32xl\\:row-start-5{
    grid-row-start: 5;
  }

  .\\32xl\\:row-start-6{
    grid-row-start: 6;
  }

  .\\32xl\\:row-start-7{
    grid-row-start: 7;
  }

  .\\32xl\\:row-start-auto{
    grid-row-start: auto;
  }

  .\\32xl\\:row-end-1{
    grid-row-end: 1;
  }

  .\\32xl\\:row-end-2{
    grid-row-end: 2;
  }

  .\\32xl\\:row-end-3{
    grid-row-end: 3;
  }

  .\\32xl\\:row-end-4{
    grid-row-end: 4;
  }

  .\\32xl\\:row-end-5{
    grid-row-end: 5;
  }

  .\\32xl\\:row-end-6{
    grid-row-end: 6;
  }

  .\\32xl\\:row-end-7{
    grid-row-end: 7;
  }

  .\\32xl\\:row-end-auto{
    grid-row-end: auto;
  }

  .\\32xl\\:transform{
    --transform-translate-x: 0;
    --transform-translate-y: 0;
    --transform-rotate: 0;
    --transform-skew-x: 0;
    --transform-skew-y: 0;
    --transform-scale-x: 1;
    --transform-scale-y: 1;
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
  }

  .\\32xl\\:transform-none{
    transform: none;
  }

  .\\32xl\\:origin-center{
    transform-origin: center;
  }

  .\\32xl\\:origin-top{
    transform-origin: top;
  }

  .\\32xl\\:origin-top-right{
    transform-origin: top right;
  }

  .\\32xl\\:origin-right{
    transform-origin: right;
  }

  .\\32xl\\:origin-bottom-right{
    transform-origin: bottom right;
  }

  .\\32xl\\:origin-bottom{
    transform-origin: bottom;
  }

  .\\32xl\\:origin-bottom-left{
    transform-origin: bottom left;
  }

  .\\32xl\\:origin-left{
    transform-origin: left;
  }

  .\\32xl\\:origin-top-left{
    transform-origin: top left;
  }

  .\\32xl\\:scale-0{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .\\32xl\\:scale-50{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .\\32xl\\:scale-75{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .\\32xl\\:scale-90{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .\\32xl\\:scale-95{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .\\32xl\\:scale-100{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .\\32xl\\:scale-105{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .\\32xl\\:scale-110{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .\\32xl\\:scale-125{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .\\32xl\\:scale-150{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .\\32xl\\:scale-x-0{
    --transform-scale-x: 0;
  }

  .\\32xl\\:scale-x-50{
    --transform-scale-x: .5;
  }

  .\\32xl\\:scale-x-75{
    --transform-scale-x: .75;
  }

  .\\32xl\\:scale-x-90{
    --transform-scale-x: .9;
  }

  .\\32xl\\:scale-x-95{
    --transform-scale-x: .95;
  }

  .\\32xl\\:scale-x-100{
    --transform-scale-x: 1;
  }

  .\\32xl\\:scale-x-105{
    --transform-scale-x: 1.05;
  }

  .\\32xl\\:scale-x-110{
    --transform-scale-x: 1.1;
  }

  .\\32xl\\:scale-x-125{
    --transform-scale-x: 1.25;
  }

  .\\32xl\\:scale-x-150{
    --transform-scale-x: 1.5;
  }

  .\\32xl\\:scale-y-0{
    --transform-scale-y: 0;
  }

  .\\32xl\\:scale-y-50{
    --transform-scale-y: .5;
  }

  .\\32xl\\:scale-y-75{
    --transform-scale-y: .75;
  }

  .\\32xl\\:scale-y-90{
    --transform-scale-y: .9;
  }

  .\\32xl\\:scale-y-95{
    --transform-scale-y: .95;
  }

  .\\32xl\\:scale-y-100{
    --transform-scale-y: 1;
  }

  .\\32xl\\:scale-y-105{
    --transform-scale-y: 1.05;
  }

  .\\32xl\\:scale-y-110{
    --transform-scale-y: 1.1;
  }

  .\\32xl\\:scale-y-125{
    --transform-scale-y: 1.25;
  }

  .\\32xl\\:scale-y-150{
    --transform-scale-y: 1.5;
  }

  .\\32xl\\:hover\\:scale-0:hover{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .\\32xl\\:hover\\:scale-50:hover{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .\\32xl\\:hover\\:scale-75:hover{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .\\32xl\\:hover\\:scale-90:hover{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .\\32xl\\:hover\\:scale-95:hover{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .\\32xl\\:hover\\:scale-100:hover{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .\\32xl\\:hover\\:scale-105:hover{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .\\32xl\\:hover\\:scale-110:hover{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .\\32xl\\:hover\\:scale-125:hover{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .\\32xl\\:hover\\:scale-150:hover{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .\\32xl\\:hover\\:scale-x-0:hover{
    --transform-scale-x: 0;
  }

  .\\32xl\\:hover\\:scale-x-50:hover{
    --transform-scale-x: .5;
  }

  .\\32xl\\:hover\\:scale-x-75:hover{
    --transform-scale-x: .75;
  }

  .\\32xl\\:hover\\:scale-x-90:hover{
    --transform-scale-x: .9;
  }

  .\\32xl\\:hover\\:scale-x-95:hover{
    --transform-scale-x: .95;
  }

  .\\32xl\\:hover\\:scale-x-100:hover{
    --transform-scale-x: 1;
  }

  .\\32xl\\:hover\\:scale-x-105:hover{
    --transform-scale-x: 1.05;
  }

  .\\32xl\\:hover\\:scale-x-110:hover{
    --transform-scale-x: 1.1;
  }

  .\\32xl\\:hover\\:scale-x-125:hover{
    --transform-scale-x: 1.25;
  }

  .\\32xl\\:hover\\:scale-x-150:hover{
    --transform-scale-x: 1.5;
  }

  .\\32xl\\:hover\\:scale-y-0:hover{
    --transform-scale-y: 0;
  }

  .\\32xl\\:hover\\:scale-y-50:hover{
    --transform-scale-y: .5;
  }

  .\\32xl\\:hover\\:scale-y-75:hover{
    --transform-scale-y: .75;
  }

  .\\32xl\\:hover\\:scale-y-90:hover{
    --transform-scale-y: .9;
  }

  .\\32xl\\:hover\\:scale-y-95:hover{
    --transform-scale-y: .95;
  }

  .\\32xl\\:hover\\:scale-y-100:hover{
    --transform-scale-y: 1;
  }

  .\\32xl\\:hover\\:scale-y-105:hover{
    --transform-scale-y: 1.05;
  }

  .\\32xl\\:hover\\:scale-y-110:hover{
    --transform-scale-y: 1.1;
  }

  .\\32xl\\:hover\\:scale-y-125:hover{
    --transform-scale-y: 1.25;
  }

  .\\32xl\\:hover\\:scale-y-150:hover{
    --transform-scale-y: 1.5;
  }

  .\\32xl\\:focus\\:scale-0:focus{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .\\32xl\\:focus\\:scale-50:focus{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .\\32xl\\:focus\\:scale-75:focus{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .\\32xl\\:focus\\:scale-90:focus{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .\\32xl\\:focus\\:scale-95:focus{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .\\32xl\\:focus\\:scale-100:focus{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .\\32xl\\:focus\\:scale-105:focus{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .\\32xl\\:focus\\:scale-110:focus{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .\\32xl\\:focus\\:scale-125:focus{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .\\32xl\\:focus\\:scale-150:focus{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .\\32xl\\:focus\\:scale-x-0:focus{
    --transform-scale-x: 0;
  }

  .\\32xl\\:focus\\:scale-x-50:focus{
    --transform-scale-x: .5;
  }

  .\\32xl\\:focus\\:scale-x-75:focus{
    --transform-scale-x: .75;
  }

  .\\32xl\\:focus\\:scale-x-90:focus{
    --transform-scale-x: .9;
  }

  .\\32xl\\:focus\\:scale-x-95:focus{
    --transform-scale-x: .95;
  }

  .\\32xl\\:focus\\:scale-x-100:focus{
    --transform-scale-x: 1;
  }

  .\\32xl\\:focus\\:scale-x-105:focus{
    --transform-scale-x: 1.05;
  }

  .\\32xl\\:focus\\:scale-x-110:focus{
    --transform-scale-x: 1.1;
  }

  .\\32xl\\:focus\\:scale-x-125:focus{
    --transform-scale-x: 1.25;
  }

  .\\32xl\\:focus\\:scale-x-150:focus{
    --transform-scale-x: 1.5;
  }

  .\\32xl\\:focus\\:scale-y-0:focus{
    --transform-scale-y: 0;
  }

  .\\32xl\\:focus\\:scale-y-50:focus{
    --transform-scale-y: .5;
  }

  .\\32xl\\:focus\\:scale-y-75:focus{
    --transform-scale-y: .75;
  }

  .\\32xl\\:focus\\:scale-y-90:focus{
    --transform-scale-y: .9;
  }

  .\\32xl\\:focus\\:scale-y-95:focus{
    --transform-scale-y: .95;
  }

  .\\32xl\\:focus\\:scale-y-100:focus{
    --transform-scale-y: 1;
  }

  .\\32xl\\:focus\\:scale-y-105:focus{
    --transform-scale-y: 1.05;
  }

  .\\32xl\\:focus\\:scale-y-110:focus{
    --transform-scale-y: 1.1;
  }

  .\\32xl\\:focus\\:scale-y-125:focus{
    --transform-scale-y: 1.25;
  }

  .\\32xl\\:focus\\:scale-y-150:focus{
    --transform-scale-y: 1.5;
  }

  .\\32xl\\:rotate-0{
    --transform-rotate: 0;
  }

  .\\32xl\\:rotate-1{
    --transform-rotate: 1deg;
  }

  .\\32xl\\:rotate-2{
    --transform-rotate: 2deg;
  }

  .\\32xl\\:rotate-3{
    --transform-rotate: 3deg;
  }

  .\\32xl\\:rotate-6{
    --transform-rotate: 6deg;
  }

  .\\32xl\\:rotate-12{
    --transform-rotate: 12deg;
  }

  .\\32xl\\:rotate-45{
    --transform-rotate: 45deg;
  }

  .\\32xl\\:rotate-90{
    --transform-rotate: 90deg;
  }

  .\\32xl\\:rotate-180{
    --transform-rotate: 180deg;
  }

  .\\32xl\\:-rotate-180{
    --transform-rotate: -180deg;
  }

  .\\32xl\\:-rotate-90{
    --transform-rotate: -90deg;
  }

  .\\32xl\\:-rotate-45{
    --transform-rotate: -45deg;
  }

  .\\32xl\\:-rotate-12{
    --transform-rotate: -12deg;
  }

  .\\32xl\\:-rotate-6{
    --transform-rotate: -6deg;
  }

  .\\32xl\\:-rotate-3{
    --transform-rotate: -3deg;
  }

  .\\32xl\\:-rotate-2{
    --transform-rotate: -2deg;
  }

  .\\32xl\\:-rotate-1{
    --transform-rotate: -1deg;
  }

  .\\32xl\\:hover\\:rotate-0:hover{
    --transform-rotate: 0;
  }

  .\\32xl\\:hover\\:rotate-1:hover{
    --transform-rotate: 1deg;
  }

  .\\32xl\\:hover\\:rotate-2:hover{
    --transform-rotate: 2deg;
  }

  .\\32xl\\:hover\\:rotate-3:hover{
    --transform-rotate: 3deg;
  }

  .\\32xl\\:hover\\:rotate-6:hover{
    --transform-rotate: 6deg;
  }

  .\\32xl\\:hover\\:rotate-12:hover{
    --transform-rotate: 12deg;
  }

  .\\32xl\\:hover\\:rotate-45:hover{
    --transform-rotate: 45deg;
  }

  .\\32xl\\:hover\\:rotate-90:hover{
    --transform-rotate: 90deg;
  }

  .\\32xl\\:hover\\:rotate-180:hover{
    --transform-rotate: 180deg;
  }

  .\\32xl\\:hover\\:-rotate-180:hover{
    --transform-rotate: -180deg;
  }

  .\\32xl\\:hover\\:-rotate-90:hover{
    --transform-rotate: -90deg;
  }

  .\\32xl\\:hover\\:-rotate-45:hover{
    --transform-rotate: -45deg;
  }

  .\\32xl\\:hover\\:-rotate-12:hover{
    --transform-rotate: -12deg;
  }

  .\\32xl\\:hover\\:-rotate-6:hover{
    --transform-rotate: -6deg;
  }

  .\\32xl\\:hover\\:-rotate-3:hover{
    --transform-rotate: -3deg;
  }

  .\\32xl\\:hover\\:-rotate-2:hover{
    --transform-rotate: -2deg;
  }

  .\\32xl\\:hover\\:-rotate-1:hover{
    --transform-rotate: -1deg;
  }

  .\\32xl\\:focus\\:rotate-0:focus{
    --transform-rotate: 0;
  }

  .\\32xl\\:focus\\:rotate-1:focus{
    --transform-rotate: 1deg;
  }

  .\\32xl\\:focus\\:rotate-2:focus{
    --transform-rotate: 2deg;
  }

  .\\32xl\\:focus\\:rotate-3:focus{
    --transform-rotate: 3deg;
  }

  .\\32xl\\:focus\\:rotate-6:focus{
    --transform-rotate: 6deg;
  }

  .\\32xl\\:focus\\:rotate-12:focus{
    --transform-rotate: 12deg;
  }

  .\\32xl\\:focus\\:rotate-45:focus{
    --transform-rotate: 45deg;
  }

  .\\32xl\\:focus\\:rotate-90:focus{
    --transform-rotate: 90deg;
  }

  .\\32xl\\:focus\\:rotate-180:focus{
    --transform-rotate: 180deg;
  }

  .\\32xl\\:focus\\:-rotate-180:focus{
    --transform-rotate: -180deg;
  }

  .\\32xl\\:focus\\:-rotate-90:focus{
    --transform-rotate: -90deg;
  }

  .\\32xl\\:focus\\:-rotate-45:focus{
    --transform-rotate: -45deg;
  }

  .\\32xl\\:focus\\:-rotate-12:focus{
    --transform-rotate: -12deg;
  }

  .\\32xl\\:focus\\:-rotate-6:focus{
    --transform-rotate: -6deg;
  }

  .\\32xl\\:focus\\:-rotate-3:focus{
    --transform-rotate: -3deg;
  }

  .\\32xl\\:focus\\:-rotate-2:focus{
    --transform-rotate: -2deg;
  }

  .\\32xl\\:focus\\:-rotate-1:focus{
    --transform-rotate: -1deg;
  }

  .\\32xl\\:translate-x-0{
    --transform-translate-x: 0;
  }

  .\\32xl\\:translate-x-1{
    --transform-translate-x: 0.25rem;
  }

  .\\32xl\\:translate-x-2{
    --transform-translate-x: 0.5rem;
  }

  .\\32xl\\:translate-x-3{
    --transform-translate-x: 0.75rem;
  }

  .\\32xl\\:translate-x-4{
    --transform-translate-x: 1rem;
  }

  .\\32xl\\:translate-x-5{
    --transform-translate-x: 1.25rem;
  }

  .\\32xl\\:translate-x-6{
    --transform-translate-x: 1.5rem;
  }

  .\\32xl\\:translate-x-7{
    --transform-translate-x: 1.75rem;
  }

  .\\32xl\\:translate-x-8{
    --transform-translate-x: 2rem;
  }

  .\\32xl\\:translate-x-9{
    --transform-translate-x: 2.25rem;
  }

  .\\32xl\\:translate-x-10{
    --transform-translate-x: 2.5rem;
  }

  .\\32xl\\:translate-x-11{
    --transform-translate-x: 2.75rem;
  }

  .\\32xl\\:translate-x-12{
    --transform-translate-x: 3rem;
  }

  .\\32xl\\:translate-x-14{
    --transform-translate-x: 3.5rem;
  }

  .\\32xl\\:translate-x-15{
    --transform-translate-x: 3.75rem;
  }

  .\\32xl\\:translate-x-16{
    --transform-translate-x: 4rem;
  }

  .\\32xl\\:translate-x-18{
    --transform-translate-x: 4.5rem;
  }

  .\\32xl\\:translate-x-20{
    --transform-translate-x: 5rem;
  }

  .\\32xl\\:translate-x-22{
    --transform-translate-x: 5.5rem;
  }

  .\\32xl\\:translate-x-23{
    --transform-translate-x: 5.75rem;
  }

  .\\32xl\\:translate-x-24{
    --transform-translate-x: 6rem;
  }

  .\\32xl\\:translate-x-25{
    --transform-translate-x: 6.25rem;
  }

  .\\32xl\\:translate-x-26{
    --transform-translate-x: 6.5rem;
  }

  .\\32xl\\:translate-x-28{
    --transform-translate-x: 7rem;
  }

  .\\32xl\\:translate-x-30{
    --transform-translate-x: 7.5rem;
  }

  .\\32xl\\:translate-x-32{
    --transform-translate-x: 8rem;
  }

  .\\32xl\\:translate-x-34{
    --transform-translate-x: 8.5rem;
  }

  .\\32xl\\:translate-x-40{
    --transform-translate-x: 10rem;
  }

  .\\32xl\\:translate-x-42{
    --transform-translate-x: 10.5rem;
  }

  .\\32xl\\:translate-x-44{
    --transform-translate-x: 11rem;
  }

  .\\32xl\\:translate-x-48{
    --transform-translate-x: 12rem;
  }

  .\\32xl\\:translate-x-52{
    --transform-translate-x: 13rem;
  }

  .\\32xl\\:translate-x-54{
    --transform-translate-x: 13.5rem;
  }

  .\\32xl\\:translate-x-56{
    --transform-translate-x: 14rem;
  }

  .\\32xl\\:translate-x-60{
    --transform-translate-x: 15rem;
  }

  .\\32xl\\:translate-x-64{
    --transform-translate-x: 16rem;
  }

  .\\32xl\\:translate-x-68{
    --transform-translate-x: 17rem;
  }

  .\\32xl\\:translate-x-72{
    --transform-translate-x: 18rem;
  }

  .\\32xl\\:translate-x-74{
    --transform-translate-x: 18.5rem;
  }

  .\\32xl\\:translate-x-76{
    --transform-translate-x: 19rem;
  }

  .\\32xl\\:translate-x-78{
    --transform-translate-x: 19.5rem;
  }

  .\\32xl\\:translate-x-80{
    --transform-translate-x: 20rem;
  }

  .\\32xl\\:translate-x-82{
    --transform-translate-x: 20.5rem;
  }

  .\\32xl\\:translate-x-84{
    --transform-translate-x: 21rem;
  }

  .\\32xl\\:translate-x-88{
    --transform-translate-x: 22rem;
  }

  .\\32xl\\:translate-x-92{
    --transform-translate-x: 23rem;
  }

  .\\32xl\\:translate-x-96{
    --transform-translate-x: 24rem;
  }

  .\\32xl\\:translate-x-98{
    --transform-translate-x: 24.5rem;
  }

  .\\32xl\\:translate-x-100{
    --transform-translate-x: 25rem;
  }

  .\\32xl\\:translate-x-104{
    --transform-translate-x: 26rem;
  }

  .\\32xl\\:translate-x-112{
    --transform-translate-x: 28rem;
  }

  .\\32xl\\:translate-x-124{
    --transform-translate-x: 31rem;
  }

  .\\32xl\\:translate-x-128{
    --transform-translate-x: 32rem;
  }

  .\\32xl\\:translate-x-140{
    --transform-translate-x: 35rem;
  }

  .\\32xl\\:translate-x-152{
    --transform-translate-x: 38rem;
  }

  .\\32xl\\:translate-x-160{
    --transform-translate-x: 40rem;
  }

  .\\32xl\\:translate-x-162{
    --transform-translate-x: 41rem;
  }

  .\\32xl\\:translate-x-192{
    --transform-translate-x: 48rem;
  }

  .\\32xl\\:translate-x-208{
    --transform-translate-x: 52rem;
  }

  .\\32xl\\:translate-x-224{
    --transform-translate-x: 56rem;
  }

  .\\32xl\\:translate-x-256{
    --transform-translate-x: 64rem;
  }

  .\\32xl\\:translate-x-px{
    --transform-translate-x: 1px;
  }

  .\\32xl\\:-translate-x-1{
    --transform-translate-x: -0.25rem;
  }

  .\\32xl\\:-translate-x-2{
    --transform-translate-x: -0.5rem;
  }

  .\\32xl\\:-translate-x-3{
    --transform-translate-x: -0.75rem;
  }

  .\\32xl\\:-translate-x-4{
    --transform-translate-x: -1rem;
  }

  .\\32xl\\:-translate-x-5{
    --transform-translate-x: -1.25rem;
  }

  .\\32xl\\:-translate-x-6{
    --transform-translate-x: -1.5rem;
  }

  .\\32xl\\:-translate-x-7{
    --transform-translate-x: -1.75rem;
  }

  .\\32xl\\:-translate-x-8{
    --transform-translate-x: -2rem;
  }

  .\\32xl\\:-translate-x-9{
    --transform-translate-x: -2.25rem;
  }

  .\\32xl\\:-translate-x-10{
    --transform-translate-x: -2.5rem;
  }

  .\\32xl\\:-translate-x-11{
    --transform-translate-x: -2.75rem;
  }

  .\\32xl\\:-translate-x-12{
    --transform-translate-x: -3rem;
  }

  .\\32xl\\:-translate-x-14{
    --transform-translate-x: -3.5rem;
  }

  .\\32xl\\:-translate-x-15{
    --transform-translate-x: -3.75rem;
  }

  .\\32xl\\:-translate-x-16{
    --transform-translate-x: -4rem;
  }

  .\\32xl\\:-translate-x-18{
    --transform-translate-x: -4.5rem;
  }

  .\\32xl\\:-translate-x-20{
    --transform-translate-x: -5rem;
  }

  .\\32xl\\:-translate-x-22{
    --transform-translate-x: -5.5rem;
  }

  .\\32xl\\:-translate-x-23{
    --transform-translate-x: -5.75rem;
  }

  .\\32xl\\:-translate-x-24{
    --transform-translate-x: -6rem;
  }

  .\\32xl\\:-translate-x-25{
    --transform-translate-x: -6.25rem;
  }

  .\\32xl\\:-translate-x-26{
    --transform-translate-x: -6.5rem;
  }

  .\\32xl\\:-translate-x-28{
    --transform-translate-x: -7rem;
  }

  .\\32xl\\:-translate-x-30{
    --transform-translate-x: -7.5rem;
  }

  .\\32xl\\:-translate-x-32{
    --transform-translate-x: -8rem;
  }

  .\\32xl\\:-translate-x-34{
    --transform-translate-x: -8.5rem;
  }

  .\\32xl\\:-translate-x-40{
    --transform-translate-x: -10rem;
  }

  .\\32xl\\:-translate-x-42{
    --transform-translate-x: -10.5rem;
  }

  .\\32xl\\:-translate-x-44{
    --transform-translate-x: -11rem;
  }

  .\\32xl\\:-translate-x-48{
    --transform-translate-x: -12rem;
  }

  .\\32xl\\:-translate-x-52{
    --transform-translate-x: -13rem;
  }

  .\\32xl\\:-translate-x-54{
    --transform-translate-x: -13.5rem;
  }

  .\\32xl\\:-translate-x-56{
    --transform-translate-x: -14rem;
  }

  .\\32xl\\:-translate-x-60{
    --transform-translate-x: -15rem;
  }

  .\\32xl\\:-translate-x-64{
    --transform-translate-x: -16rem;
  }

  .\\32xl\\:-translate-x-68{
    --transform-translate-x: -17rem;
  }

  .\\32xl\\:-translate-x-72{
    --transform-translate-x: -18rem;
  }

  .\\32xl\\:-translate-x-74{
    --transform-translate-x: -18.5rem;
  }

  .\\32xl\\:-translate-x-76{
    --transform-translate-x: -19rem;
  }

  .\\32xl\\:-translate-x-78{
    --transform-translate-x: -19.5rem;
  }

  .\\32xl\\:-translate-x-80{
    --transform-translate-x: -20rem;
  }

  .\\32xl\\:-translate-x-82{
    --transform-translate-x: -20.5rem;
  }

  .\\32xl\\:-translate-x-84{
    --transform-translate-x: -21rem;
  }

  .\\32xl\\:-translate-x-88{
    --transform-translate-x: -22rem;
  }

  .\\32xl\\:-translate-x-92{
    --transform-translate-x: -23rem;
  }

  .\\32xl\\:-translate-x-96{
    --transform-translate-x: -24rem;
  }

  .\\32xl\\:-translate-x-98{
    --transform-translate-x: -24.5rem;
  }

  .\\32xl\\:-translate-x-100{
    --transform-translate-x: -25rem;
  }

  .\\32xl\\:-translate-x-104{
    --transform-translate-x: -26rem;
  }

  .\\32xl\\:-translate-x-112{
    --transform-translate-x: -28rem;
  }

  .\\32xl\\:-translate-x-124{
    --transform-translate-x: -31rem;
  }

  .\\32xl\\:-translate-x-128{
    --transform-translate-x: -32rem;
  }

  .\\32xl\\:-translate-x-140{
    --transform-translate-x: -35rem;
  }

  .\\32xl\\:-translate-x-152{
    --transform-translate-x: -38rem;
  }

  .\\32xl\\:-translate-x-160{
    --transform-translate-x: -40rem;
  }

  .\\32xl\\:-translate-x-162{
    --transform-translate-x: -41rem;
  }

  .\\32xl\\:-translate-x-192{
    --transform-translate-x: -48rem;
  }

  .\\32xl\\:-translate-x-208{
    --transform-translate-x: -52rem;
  }

  .\\32xl\\:-translate-x-224{
    --transform-translate-x: -56rem;
  }

  .\\32xl\\:-translate-x-256{
    --transform-translate-x: -64rem;
  }

  .\\32xl\\:-translate-x-px{
    --transform-translate-x: -1px;
  }

  .\\32xl\\:-translate-x-full{
    --transform-translate-x: -100%;
  }

  .\\32xl\\:-translate-x-1\\/2{
    --transform-translate-x: -50%;
  }

  .\\32xl\\:translate-x-1\\/2{
    --transform-translate-x: 50%;
  }

  .\\32xl\\:translate-x-full{
    --transform-translate-x: 100%;
  }

  .\\32xl\\:translate-y-0{
    --transform-translate-y: 0;
  }

  .\\32xl\\:translate-y-1{
    --transform-translate-y: 0.25rem;
  }

  .\\32xl\\:translate-y-2{
    --transform-translate-y: 0.5rem;
  }

  .\\32xl\\:translate-y-3{
    --transform-translate-y: 0.75rem;
  }

  .\\32xl\\:translate-y-4{
    --transform-translate-y: 1rem;
  }

  .\\32xl\\:translate-y-5{
    --transform-translate-y: 1.25rem;
  }

  .\\32xl\\:translate-y-6{
    --transform-translate-y: 1.5rem;
  }

  .\\32xl\\:translate-y-7{
    --transform-translate-y: 1.75rem;
  }

  .\\32xl\\:translate-y-8{
    --transform-translate-y: 2rem;
  }

  .\\32xl\\:translate-y-9{
    --transform-translate-y: 2.25rem;
  }

  .\\32xl\\:translate-y-10{
    --transform-translate-y: 2.5rem;
  }

  .\\32xl\\:translate-y-11{
    --transform-translate-y: 2.75rem;
  }

  .\\32xl\\:translate-y-12{
    --transform-translate-y: 3rem;
  }

  .\\32xl\\:translate-y-14{
    --transform-translate-y: 3.5rem;
  }

  .\\32xl\\:translate-y-15{
    --transform-translate-y: 3.75rem;
  }

  .\\32xl\\:translate-y-16{
    --transform-translate-y: 4rem;
  }

  .\\32xl\\:translate-y-18{
    --transform-translate-y: 4.5rem;
  }

  .\\32xl\\:translate-y-20{
    --transform-translate-y: 5rem;
  }

  .\\32xl\\:translate-y-22{
    --transform-translate-y: 5.5rem;
  }

  .\\32xl\\:translate-y-23{
    --transform-translate-y: 5.75rem;
  }

  .\\32xl\\:translate-y-24{
    --transform-translate-y: 6rem;
  }

  .\\32xl\\:translate-y-25{
    --transform-translate-y: 6.25rem;
  }

  .\\32xl\\:translate-y-26{
    --transform-translate-y: 6.5rem;
  }

  .\\32xl\\:translate-y-28{
    --transform-translate-y: 7rem;
  }

  .\\32xl\\:translate-y-30{
    --transform-translate-y: 7.5rem;
  }

  .\\32xl\\:translate-y-32{
    --transform-translate-y: 8rem;
  }

  .\\32xl\\:translate-y-34{
    --transform-translate-y: 8.5rem;
  }

  .\\32xl\\:translate-y-40{
    --transform-translate-y: 10rem;
  }

  .\\32xl\\:translate-y-42{
    --transform-translate-y: 10.5rem;
  }

  .\\32xl\\:translate-y-44{
    --transform-translate-y: 11rem;
  }

  .\\32xl\\:translate-y-48{
    --transform-translate-y: 12rem;
  }

  .\\32xl\\:translate-y-52{
    --transform-translate-y: 13rem;
  }

  .\\32xl\\:translate-y-54{
    --transform-translate-y: 13.5rem;
  }

  .\\32xl\\:translate-y-56{
    --transform-translate-y: 14rem;
  }

  .\\32xl\\:translate-y-60{
    --transform-translate-y: 15rem;
  }

  .\\32xl\\:translate-y-64{
    --transform-translate-y: 16rem;
  }

  .\\32xl\\:translate-y-68{
    --transform-translate-y: 17rem;
  }

  .\\32xl\\:translate-y-72{
    --transform-translate-y: 18rem;
  }

  .\\32xl\\:translate-y-74{
    --transform-translate-y: 18.5rem;
  }

  .\\32xl\\:translate-y-76{
    --transform-translate-y: 19rem;
  }

  .\\32xl\\:translate-y-78{
    --transform-translate-y: 19.5rem;
  }

  .\\32xl\\:translate-y-80{
    --transform-translate-y: 20rem;
  }

  .\\32xl\\:translate-y-82{
    --transform-translate-y: 20.5rem;
  }

  .\\32xl\\:translate-y-84{
    --transform-translate-y: 21rem;
  }

  .\\32xl\\:translate-y-88{
    --transform-translate-y: 22rem;
  }

  .\\32xl\\:translate-y-92{
    --transform-translate-y: 23rem;
  }

  .\\32xl\\:translate-y-96{
    --transform-translate-y: 24rem;
  }

  .\\32xl\\:translate-y-98{
    --transform-translate-y: 24.5rem;
  }

  .\\32xl\\:translate-y-100{
    --transform-translate-y: 25rem;
  }

  .\\32xl\\:translate-y-104{
    --transform-translate-y: 26rem;
  }

  .\\32xl\\:translate-y-112{
    --transform-translate-y: 28rem;
  }

  .\\32xl\\:translate-y-124{
    --transform-translate-y: 31rem;
  }

  .\\32xl\\:translate-y-128{
    --transform-translate-y: 32rem;
  }

  .\\32xl\\:translate-y-140{
    --transform-translate-y: 35rem;
  }

  .\\32xl\\:translate-y-152{
    --transform-translate-y: 38rem;
  }

  .\\32xl\\:translate-y-160{
    --transform-translate-y: 40rem;
  }

  .\\32xl\\:translate-y-162{
    --transform-translate-y: 41rem;
  }

  .\\32xl\\:translate-y-192{
    --transform-translate-y: 48rem;
  }

  .\\32xl\\:translate-y-208{
    --transform-translate-y: 52rem;
  }

  .\\32xl\\:translate-y-224{
    --transform-translate-y: 56rem;
  }

  .\\32xl\\:translate-y-256{
    --transform-translate-y: 64rem;
  }

  .\\32xl\\:translate-y-px{
    --transform-translate-y: 1px;
  }

  .\\32xl\\:-translate-y-1{
    --transform-translate-y: -0.25rem;
  }

  .\\32xl\\:-translate-y-2{
    --transform-translate-y: -0.5rem;
  }

  .\\32xl\\:-translate-y-3{
    --transform-translate-y: -0.75rem;
  }

  .\\32xl\\:-translate-y-4{
    --transform-translate-y: -1rem;
  }

  .\\32xl\\:-translate-y-5{
    --transform-translate-y: -1.25rem;
  }

  .\\32xl\\:-translate-y-6{
    --transform-translate-y: -1.5rem;
  }

  .\\32xl\\:-translate-y-7{
    --transform-translate-y: -1.75rem;
  }

  .\\32xl\\:-translate-y-8{
    --transform-translate-y: -2rem;
  }

  .\\32xl\\:-translate-y-9{
    --transform-translate-y: -2.25rem;
  }

  .\\32xl\\:-translate-y-10{
    --transform-translate-y: -2.5rem;
  }

  .\\32xl\\:-translate-y-11{
    --transform-translate-y: -2.75rem;
  }

  .\\32xl\\:-translate-y-12{
    --transform-translate-y: -3rem;
  }

  .\\32xl\\:-translate-y-14{
    --transform-translate-y: -3.5rem;
  }

  .\\32xl\\:-translate-y-15{
    --transform-translate-y: -3.75rem;
  }

  .\\32xl\\:-translate-y-16{
    --transform-translate-y: -4rem;
  }

  .\\32xl\\:-translate-y-18{
    --transform-translate-y: -4.5rem;
  }

  .\\32xl\\:-translate-y-20{
    --transform-translate-y: -5rem;
  }

  .\\32xl\\:-translate-y-22{
    --transform-translate-y: -5.5rem;
  }

  .\\32xl\\:-translate-y-23{
    --transform-translate-y: -5.75rem;
  }

  .\\32xl\\:-translate-y-24{
    --transform-translate-y: -6rem;
  }

  .\\32xl\\:-translate-y-25{
    --transform-translate-y: -6.25rem;
  }

  .\\32xl\\:-translate-y-26{
    --transform-translate-y: -6.5rem;
  }

  .\\32xl\\:-translate-y-28{
    --transform-translate-y: -7rem;
  }

  .\\32xl\\:-translate-y-30{
    --transform-translate-y: -7.5rem;
  }

  .\\32xl\\:-translate-y-32{
    --transform-translate-y: -8rem;
  }

  .\\32xl\\:-translate-y-34{
    --transform-translate-y: -8.5rem;
  }

  .\\32xl\\:-translate-y-40{
    --transform-translate-y: -10rem;
  }

  .\\32xl\\:-translate-y-42{
    --transform-translate-y: -10.5rem;
  }

  .\\32xl\\:-translate-y-44{
    --transform-translate-y: -11rem;
  }

  .\\32xl\\:-translate-y-48{
    --transform-translate-y: -12rem;
  }

  .\\32xl\\:-translate-y-52{
    --transform-translate-y: -13rem;
  }

  .\\32xl\\:-translate-y-54{
    --transform-translate-y: -13.5rem;
  }

  .\\32xl\\:-translate-y-56{
    --transform-translate-y: -14rem;
  }

  .\\32xl\\:-translate-y-60{
    --transform-translate-y: -15rem;
  }

  .\\32xl\\:-translate-y-64{
    --transform-translate-y: -16rem;
  }

  .\\32xl\\:-translate-y-68{
    --transform-translate-y: -17rem;
  }

  .\\32xl\\:-translate-y-72{
    --transform-translate-y: -18rem;
  }

  .\\32xl\\:-translate-y-74{
    --transform-translate-y: -18.5rem;
  }

  .\\32xl\\:-translate-y-76{
    --transform-translate-y: -19rem;
  }

  .\\32xl\\:-translate-y-78{
    --transform-translate-y: -19.5rem;
  }

  .\\32xl\\:-translate-y-80{
    --transform-translate-y: -20rem;
  }

  .\\32xl\\:-translate-y-82{
    --transform-translate-y: -20.5rem;
  }

  .\\32xl\\:-translate-y-84{
    --transform-translate-y: -21rem;
  }

  .\\32xl\\:-translate-y-88{
    --transform-translate-y: -22rem;
  }

  .\\32xl\\:-translate-y-92{
    --transform-translate-y: -23rem;
  }

  .\\32xl\\:-translate-y-96{
    --transform-translate-y: -24rem;
  }

  .\\32xl\\:-translate-y-98{
    --transform-translate-y: -24.5rem;
  }

  .\\32xl\\:-translate-y-100{
    --transform-translate-y: -25rem;
  }

  .\\32xl\\:-translate-y-104{
    --transform-translate-y: -26rem;
  }

  .\\32xl\\:-translate-y-112{
    --transform-translate-y: -28rem;
  }

  .\\32xl\\:-translate-y-124{
    --transform-translate-y: -31rem;
  }

  .\\32xl\\:-translate-y-128{
    --transform-translate-y: -32rem;
  }

  .\\32xl\\:-translate-y-140{
    --transform-translate-y: -35rem;
  }

  .\\32xl\\:-translate-y-152{
    --transform-translate-y: -38rem;
  }

  .\\32xl\\:-translate-y-160{
    --transform-translate-y: -40rem;
  }

  .\\32xl\\:-translate-y-162{
    --transform-translate-y: -41rem;
  }

  .\\32xl\\:-translate-y-192{
    --transform-translate-y: -48rem;
  }

  .\\32xl\\:-translate-y-208{
    --transform-translate-y: -52rem;
  }

  .\\32xl\\:-translate-y-224{
    --transform-translate-y: -56rem;
  }

  .\\32xl\\:-translate-y-256{
    --transform-translate-y: -64rem;
  }

  .\\32xl\\:-translate-y-px{
    --transform-translate-y: -1px;
  }

  .\\32xl\\:-translate-y-full{
    --transform-translate-y: -100%;
  }

  .\\32xl\\:-translate-y-1\\/2{
    --transform-translate-y: -50%;
  }

  .\\32xl\\:translate-y-1\\/2{
    --transform-translate-y: 50%;
  }

  .\\32xl\\:translate-y-full{
    --transform-translate-y: 100%;
  }

  .\\32xl\\:hover\\:translate-x-0:hover{
    --transform-translate-x: 0;
  }

  .\\32xl\\:hover\\:translate-x-1:hover{
    --transform-translate-x: 0.25rem;
  }

  .\\32xl\\:hover\\:translate-x-2:hover{
    --transform-translate-x: 0.5rem;
  }

  .\\32xl\\:hover\\:translate-x-3:hover{
    --transform-translate-x: 0.75rem;
  }

  .\\32xl\\:hover\\:translate-x-4:hover{
    --transform-translate-x: 1rem;
  }

  .\\32xl\\:hover\\:translate-x-5:hover{
    --transform-translate-x: 1.25rem;
  }

  .\\32xl\\:hover\\:translate-x-6:hover{
    --transform-translate-x: 1.5rem;
  }

  .\\32xl\\:hover\\:translate-x-7:hover{
    --transform-translate-x: 1.75rem;
  }

  .\\32xl\\:hover\\:translate-x-8:hover{
    --transform-translate-x: 2rem;
  }

  .\\32xl\\:hover\\:translate-x-9:hover{
    --transform-translate-x: 2.25rem;
  }

  .\\32xl\\:hover\\:translate-x-10:hover{
    --transform-translate-x: 2.5rem;
  }

  .\\32xl\\:hover\\:translate-x-11:hover{
    --transform-translate-x: 2.75rem;
  }

  .\\32xl\\:hover\\:translate-x-12:hover{
    --transform-translate-x: 3rem;
  }

  .\\32xl\\:hover\\:translate-x-14:hover{
    --transform-translate-x: 3.5rem;
  }

  .\\32xl\\:hover\\:translate-x-15:hover{
    --transform-translate-x: 3.75rem;
  }

  .\\32xl\\:hover\\:translate-x-16:hover{
    --transform-translate-x: 4rem;
  }

  .\\32xl\\:hover\\:translate-x-18:hover{
    --transform-translate-x: 4.5rem;
  }

  .\\32xl\\:hover\\:translate-x-20:hover{
    --transform-translate-x: 5rem;
  }

  .\\32xl\\:hover\\:translate-x-22:hover{
    --transform-translate-x: 5.5rem;
  }

  .\\32xl\\:hover\\:translate-x-23:hover{
    --transform-translate-x: 5.75rem;
  }

  .\\32xl\\:hover\\:translate-x-24:hover{
    --transform-translate-x: 6rem;
  }

  .\\32xl\\:hover\\:translate-x-25:hover{
    --transform-translate-x: 6.25rem;
  }

  .\\32xl\\:hover\\:translate-x-26:hover{
    --transform-translate-x: 6.5rem;
  }

  .\\32xl\\:hover\\:translate-x-28:hover{
    --transform-translate-x: 7rem;
  }

  .\\32xl\\:hover\\:translate-x-30:hover{
    --transform-translate-x: 7.5rem;
  }

  .\\32xl\\:hover\\:translate-x-32:hover{
    --transform-translate-x: 8rem;
  }

  .\\32xl\\:hover\\:translate-x-34:hover{
    --transform-translate-x: 8.5rem;
  }

  .\\32xl\\:hover\\:translate-x-40:hover{
    --transform-translate-x: 10rem;
  }

  .\\32xl\\:hover\\:translate-x-42:hover{
    --transform-translate-x: 10.5rem;
  }

  .\\32xl\\:hover\\:translate-x-44:hover{
    --transform-translate-x: 11rem;
  }

  .\\32xl\\:hover\\:translate-x-48:hover{
    --transform-translate-x: 12rem;
  }

  .\\32xl\\:hover\\:translate-x-52:hover{
    --transform-translate-x: 13rem;
  }

  .\\32xl\\:hover\\:translate-x-54:hover{
    --transform-translate-x: 13.5rem;
  }

  .\\32xl\\:hover\\:translate-x-56:hover{
    --transform-translate-x: 14rem;
  }

  .\\32xl\\:hover\\:translate-x-60:hover{
    --transform-translate-x: 15rem;
  }

  .\\32xl\\:hover\\:translate-x-64:hover{
    --transform-translate-x: 16rem;
  }

  .\\32xl\\:hover\\:translate-x-68:hover{
    --transform-translate-x: 17rem;
  }

  .\\32xl\\:hover\\:translate-x-72:hover{
    --transform-translate-x: 18rem;
  }

  .\\32xl\\:hover\\:translate-x-74:hover{
    --transform-translate-x: 18.5rem;
  }

  .\\32xl\\:hover\\:translate-x-76:hover{
    --transform-translate-x: 19rem;
  }

  .\\32xl\\:hover\\:translate-x-78:hover{
    --transform-translate-x: 19.5rem;
  }

  .\\32xl\\:hover\\:translate-x-80:hover{
    --transform-translate-x: 20rem;
  }

  .\\32xl\\:hover\\:translate-x-82:hover{
    --transform-translate-x: 20.5rem;
  }

  .\\32xl\\:hover\\:translate-x-84:hover{
    --transform-translate-x: 21rem;
  }

  .\\32xl\\:hover\\:translate-x-88:hover{
    --transform-translate-x: 22rem;
  }

  .\\32xl\\:hover\\:translate-x-92:hover{
    --transform-translate-x: 23rem;
  }

  .\\32xl\\:hover\\:translate-x-96:hover{
    --transform-translate-x: 24rem;
  }

  .\\32xl\\:hover\\:translate-x-98:hover{
    --transform-translate-x: 24.5rem;
  }

  .\\32xl\\:hover\\:translate-x-100:hover{
    --transform-translate-x: 25rem;
  }

  .\\32xl\\:hover\\:translate-x-104:hover{
    --transform-translate-x: 26rem;
  }

  .\\32xl\\:hover\\:translate-x-112:hover{
    --transform-translate-x: 28rem;
  }

  .\\32xl\\:hover\\:translate-x-124:hover{
    --transform-translate-x: 31rem;
  }

  .\\32xl\\:hover\\:translate-x-128:hover{
    --transform-translate-x: 32rem;
  }

  .\\32xl\\:hover\\:translate-x-140:hover{
    --transform-translate-x: 35rem;
  }

  .\\32xl\\:hover\\:translate-x-152:hover{
    --transform-translate-x: 38rem;
  }

  .\\32xl\\:hover\\:translate-x-160:hover{
    --transform-translate-x: 40rem;
  }

  .\\32xl\\:hover\\:translate-x-162:hover{
    --transform-translate-x: 41rem;
  }

  .\\32xl\\:hover\\:translate-x-192:hover{
    --transform-translate-x: 48rem;
  }

  .\\32xl\\:hover\\:translate-x-208:hover{
    --transform-translate-x: 52rem;
  }

  .\\32xl\\:hover\\:translate-x-224:hover{
    --transform-translate-x: 56rem;
  }

  .\\32xl\\:hover\\:translate-x-256:hover{
    --transform-translate-x: 64rem;
  }

  .\\32xl\\:hover\\:translate-x-px:hover{
    --transform-translate-x: 1px;
  }

  .\\32xl\\:hover\\:-translate-x-1:hover{
    --transform-translate-x: -0.25rem;
  }

  .\\32xl\\:hover\\:-translate-x-2:hover{
    --transform-translate-x: -0.5rem;
  }

  .\\32xl\\:hover\\:-translate-x-3:hover{
    --transform-translate-x: -0.75rem;
  }

  .\\32xl\\:hover\\:-translate-x-4:hover{
    --transform-translate-x: -1rem;
  }

  .\\32xl\\:hover\\:-translate-x-5:hover{
    --transform-translate-x: -1.25rem;
  }

  .\\32xl\\:hover\\:-translate-x-6:hover{
    --transform-translate-x: -1.5rem;
  }

  .\\32xl\\:hover\\:-translate-x-7:hover{
    --transform-translate-x: -1.75rem;
  }

  .\\32xl\\:hover\\:-translate-x-8:hover{
    --transform-translate-x: -2rem;
  }

  .\\32xl\\:hover\\:-translate-x-9:hover{
    --transform-translate-x: -2.25rem;
  }

  .\\32xl\\:hover\\:-translate-x-10:hover{
    --transform-translate-x: -2.5rem;
  }

  .\\32xl\\:hover\\:-translate-x-11:hover{
    --transform-translate-x: -2.75rem;
  }

  .\\32xl\\:hover\\:-translate-x-12:hover{
    --transform-translate-x: -3rem;
  }

  .\\32xl\\:hover\\:-translate-x-14:hover{
    --transform-translate-x: -3.5rem;
  }

  .\\32xl\\:hover\\:-translate-x-15:hover{
    --transform-translate-x: -3.75rem;
  }

  .\\32xl\\:hover\\:-translate-x-16:hover{
    --transform-translate-x: -4rem;
  }

  .\\32xl\\:hover\\:-translate-x-18:hover{
    --transform-translate-x: -4.5rem;
  }

  .\\32xl\\:hover\\:-translate-x-20:hover{
    --transform-translate-x: -5rem;
  }

  .\\32xl\\:hover\\:-translate-x-22:hover{
    --transform-translate-x: -5.5rem;
  }

  .\\32xl\\:hover\\:-translate-x-23:hover{
    --transform-translate-x: -5.75rem;
  }

  .\\32xl\\:hover\\:-translate-x-24:hover{
    --transform-translate-x: -6rem;
  }

  .\\32xl\\:hover\\:-translate-x-25:hover{
    --transform-translate-x: -6.25rem;
  }

  .\\32xl\\:hover\\:-translate-x-26:hover{
    --transform-translate-x: -6.5rem;
  }

  .\\32xl\\:hover\\:-translate-x-28:hover{
    --transform-translate-x: -7rem;
  }

  .\\32xl\\:hover\\:-translate-x-30:hover{
    --transform-translate-x: -7.5rem;
  }

  .\\32xl\\:hover\\:-translate-x-32:hover{
    --transform-translate-x: -8rem;
  }

  .\\32xl\\:hover\\:-translate-x-34:hover{
    --transform-translate-x: -8.5rem;
  }

  .\\32xl\\:hover\\:-translate-x-40:hover{
    --transform-translate-x: -10rem;
  }

  .\\32xl\\:hover\\:-translate-x-42:hover{
    --transform-translate-x: -10.5rem;
  }

  .\\32xl\\:hover\\:-translate-x-44:hover{
    --transform-translate-x: -11rem;
  }

  .\\32xl\\:hover\\:-translate-x-48:hover{
    --transform-translate-x: -12rem;
  }

  .\\32xl\\:hover\\:-translate-x-52:hover{
    --transform-translate-x: -13rem;
  }

  .\\32xl\\:hover\\:-translate-x-54:hover{
    --transform-translate-x: -13.5rem;
  }

  .\\32xl\\:hover\\:-translate-x-56:hover{
    --transform-translate-x: -14rem;
  }

  .\\32xl\\:hover\\:-translate-x-60:hover{
    --transform-translate-x: -15rem;
  }

  .\\32xl\\:hover\\:-translate-x-64:hover{
    --transform-translate-x: -16rem;
  }

  .\\32xl\\:hover\\:-translate-x-68:hover{
    --transform-translate-x: -17rem;
  }

  .\\32xl\\:hover\\:-translate-x-72:hover{
    --transform-translate-x: -18rem;
  }

  .\\32xl\\:hover\\:-translate-x-74:hover{
    --transform-translate-x: -18.5rem;
  }

  .\\32xl\\:hover\\:-translate-x-76:hover{
    --transform-translate-x: -19rem;
  }

  .\\32xl\\:hover\\:-translate-x-78:hover{
    --transform-translate-x: -19.5rem;
  }

  .\\32xl\\:hover\\:-translate-x-80:hover{
    --transform-translate-x: -20rem;
  }

  .\\32xl\\:hover\\:-translate-x-82:hover{
    --transform-translate-x: -20.5rem;
  }

  .\\32xl\\:hover\\:-translate-x-84:hover{
    --transform-translate-x: -21rem;
  }

  .\\32xl\\:hover\\:-translate-x-88:hover{
    --transform-translate-x: -22rem;
  }

  .\\32xl\\:hover\\:-translate-x-92:hover{
    --transform-translate-x: -23rem;
  }

  .\\32xl\\:hover\\:-translate-x-96:hover{
    --transform-translate-x: -24rem;
  }

  .\\32xl\\:hover\\:-translate-x-98:hover{
    --transform-translate-x: -24.5rem;
  }

  .\\32xl\\:hover\\:-translate-x-100:hover{
    --transform-translate-x: -25rem;
  }

  .\\32xl\\:hover\\:-translate-x-104:hover{
    --transform-translate-x: -26rem;
  }

  .\\32xl\\:hover\\:-translate-x-112:hover{
    --transform-translate-x: -28rem;
  }

  .\\32xl\\:hover\\:-translate-x-124:hover{
    --transform-translate-x: -31rem;
  }

  .\\32xl\\:hover\\:-translate-x-128:hover{
    --transform-translate-x: -32rem;
  }

  .\\32xl\\:hover\\:-translate-x-140:hover{
    --transform-translate-x: -35rem;
  }

  .\\32xl\\:hover\\:-translate-x-152:hover{
    --transform-translate-x: -38rem;
  }

  .\\32xl\\:hover\\:-translate-x-160:hover{
    --transform-translate-x: -40rem;
  }

  .\\32xl\\:hover\\:-translate-x-162:hover{
    --transform-translate-x: -41rem;
  }

  .\\32xl\\:hover\\:-translate-x-192:hover{
    --transform-translate-x: -48rem;
  }

  .\\32xl\\:hover\\:-translate-x-208:hover{
    --transform-translate-x: -52rem;
  }

  .\\32xl\\:hover\\:-translate-x-224:hover{
    --transform-translate-x: -56rem;
  }

  .\\32xl\\:hover\\:-translate-x-256:hover{
    --transform-translate-x: -64rem;
  }

  .\\32xl\\:hover\\:-translate-x-px:hover{
    --transform-translate-x: -1px;
  }

  .\\32xl\\:hover\\:-translate-x-full:hover{
    --transform-translate-x: -100%;
  }

  .\\32xl\\:hover\\:-translate-x-1\\/2:hover{
    --transform-translate-x: -50%;
  }

  .\\32xl\\:hover\\:translate-x-1\\/2:hover{
    --transform-translate-x: 50%;
  }

  .\\32xl\\:hover\\:translate-x-full:hover{
    --transform-translate-x: 100%;
  }

  .\\32xl\\:hover\\:translate-y-0:hover{
    --transform-translate-y: 0;
  }

  .\\32xl\\:hover\\:translate-y-1:hover{
    --transform-translate-y: 0.25rem;
  }

  .\\32xl\\:hover\\:translate-y-2:hover{
    --transform-translate-y: 0.5rem;
  }

  .\\32xl\\:hover\\:translate-y-3:hover{
    --transform-translate-y: 0.75rem;
  }

  .\\32xl\\:hover\\:translate-y-4:hover{
    --transform-translate-y: 1rem;
  }

  .\\32xl\\:hover\\:translate-y-5:hover{
    --transform-translate-y: 1.25rem;
  }

  .\\32xl\\:hover\\:translate-y-6:hover{
    --transform-translate-y: 1.5rem;
  }

  .\\32xl\\:hover\\:translate-y-7:hover{
    --transform-translate-y: 1.75rem;
  }

  .\\32xl\\:hover\\:translate-y-8:hover{
    --transform-translate-y: 2rem;
  }

  .\\32xl\\:hover\\:translate-y-9:hover{
    --transform-translate-y: 2.25rem;
  }

  .\\32xl\\:hover\\:translate-y-10:hover{
    --transform-translate-y: 2.5rem;
  }

  .\\32xl\\:hover\\:translate-y-11:hover{
    --transform-translate-y: 2.75rem;
  }

  .\\32xl\\:hover\\:translate-y-12:hover{
    --transform-translate-y: 3rem;
  }

  .\\32xl\\:hover\\:translate-y-14:hover{
    --transform-translate-y: 3.5rem;
  }

  .\\32xl\\:hover\\:translate-y-15:hover{
    --transform-translate-y: 3.75rem;
  }

  .\\32xl\\:hover\\:translate-y-16:hover{
    --transform-translate-y: 4rem;
  }

  .\\32xl\\:hover\\:translate-y-18:hover{
    --transform-translate-y: 4.5rem;
  }

  .\\32xl\\:hover\\:translate-y-20:hover{
    --transform-translate-y: 5rem;
  }

  .\\32xl\\:hover\\:translate-y-22:hover{
    --transform-translate-y: 5.5rem;
  }

  .\\32xl\\:hover\\:translate-y-23:hover{
    --transform-translate-y: 5.75rem;
  }

  .\\32xl\\:hover\\:translate-y-24:hover{
    --transform-translate-y: 6rem;
  }

  .\\32xl\\:hover\\:translate-y-25:hover{
    --transform-translate-y: 6.25rem;
  }

  .\\32xl\\:hover\\:translate-y-26:hover{
    --transform-translate-y: 6.5rem;
  }

  .\\32xl\\:hover\\:translate-y-28:hover{
    --transform-translate-y: 7rem;
  }

  .\\32xl\\:hover\\:translate-y-30:hover{
    --transform-translate-y: 7.5rem;
  }

  .\\32xl\\:hover\\:translate-y-32:hover{
    --transform-translate-y: 8rem;
  }

  .\\32xl\\:hover\\:translate-y-34:hover{
    --transform-translate-y: 8.5rem;
  }

  .\\32xl\\:hover\\:translate-y-40:hover{
    --transform-translate-y: 10rem;
  }

  .\\32xl\\:hover\\:translate-y-42:hover{
    --transform-translate-y: 10.5rem;
  }

  .\\32xl\\:hover\\:translate-y-44:hover{
    --transform-translate-y: 11rem;
  }

  .\\32xl\\:hover\\:translate-y-48:hover{
    --transform-translate-y: 12rem;
  }

  .\\32xl\\:hover\\:translate-y-52:hover{
    --transform-translate-y: 13rem;
  }

  .\\32xl\\:hover\\:translate-y-54:hover{
    --transform-translate-y: 13.5rem;
  }

  .\\32xl\\:hover\\:translate-y-56:hover{
    --transform-translate-y: 14rem;
  }

  .\\32xl\\:hover\\:translate-y-60:hover{
    --transform-translate-y: 15rem;
  }

  .\\32xl\\:hover\\:translate-y-64:hover{
    --transform-translate-y: 16rem;
  }

  .\\32xl\\:hover\\:translate-y-68:hover{
    --transform-translate-y: 17rem;
  }

  .\\32xl\\:hover\\:translate-y-72:hover{
    --transform-translate-y: 18rem;
  }

  .\\32xl\\:hover\\:translate-y-74:hover{
    --transform-translate-y: 18.5rem;
  }

  .\\32xl\\:hover\\:translate-y-76:hover{
    --transform-translate-y: 19rem;
  }

  .\\32xl\\:hover\\:translate-y-78:hover{
    --transform-translate-y: 19.5rem;
  }

  .\\32xl\\:hover\\:translate-y-80:hover{
    --transform-translate-y: 20rem;
  }

  .\\32xl\\:hover\\:translate-y-82:hover{
    --transform-translate-y: 20.5rem;
  }

  .\\32xl\\:hover\\:translate-y-84:hover{
    --transform-translate-y: 21rem;
  }

  .\\32xl\\:hover\\:translate-y-88:hover{
    --transform-translate-y: 22rem;
  }

  .\\32xl\\:hover\\:translate-y-92:hover{
    --transform-translate-y: 23rem;
  }

  .\\32xl\\:hover\\:translate-y-96:hover{
    --transform-translate-y: 24rem;
  }

  .\\32xl\\:hover\\:translate-y-98:hover{
    --transform-translate-y: 24.5rem;
  }

  .\\32xl\\:hover\\:translate-y-100:hover{
    --transform-translate-y: 25rem;
  }

  .\\32xl\\:hover\\:translate-y-104:hover{
    --transform-translate-y: 26rem;
  }

  .\\32xl\\:hover\\:translate-y-112:hover{
    --transform-translate-y: 28rem;
  }

  .\\32xl\\:hover\\:translate-y-124:hover{
    --transform-translate-y: 31rem;
  }

  .\\32xl\\:hover\\:translate-y-128:hover{
    --transform-translate-y: 32rem;
  }

  .\\32xl\\:hover\\:translate-y-140:hover{
    --transform-translate-y: 35rem;
  }

  .\\32xl\\:hover\\:translate-y-152:hover{
    --transform-translate-y: 38rem;
  }

  .\\32xl\\:hover\\:translate-y-160:hover{
    --transform-translate-y: 40rem;
  }

  .\\32xl\\:hover\\:translate-y-162:hover{
    --transform-translate-y: 41rem;
  }

  .\\32xl\\:hover\\:translate-y-192:hover{
    --transform-translate-y: 48rem;
  }

  .\\32xl\\:hover\\:translate-y-208:hover{
    --transform-translate-y: 52rem;
  }

  .\\32xl\\:hover\\:translate-y-224:hover{
    --transform-translate-y: 56rem;
  }

  .\\32xl\\:hover\\:translate-y-256:hover{
    --transform-translate-y: 64rem;
  }

  .\\32xl\\:hover\\:translate-y-px:hover{
    --transform-translate-y: 1px;
  }

  .\\32xl\\:hover\\:-translate-y-1:hover{
    --transform-translate-y: -0.25rem;
  }

  .\\32xl\\:hover\\:-translate-y-2:hover{
    --transform-translate-y: -0.5rem;
  }

  .\\32xl\\:hover\\:-translate-y-3:hover{
    --transform-translate-y: -0.75rem;
  }

  .\\32xl\\:hover\\:-translate-y-4:hover{
    --transform-translate-y: -1rem;
  }

  .\\32xl\\:hover\\:-translate-y-5:hover{
    --transform-translate-y: -1.25rem;
  }

  .\\32xl\\:hover\\:-translate-y-6:hover{
    --transform-translate-y: -1.5rem;
  }

  .\\32xl\\:hover\\:-translate-y-7:hover{
    --transform-translate-y: -1.75rem;
  }

  .\\32xl\\:hover\\:-translate-y-8:hover{
    --transform-translate-y: -2rem;
  }

  .\\32xl\\:hover\\:-translate-y-9:hover{
    --transform-translate-y: -2.25rem;
  }

  .\\32xl\\:hover\\:-translate-y-10:hover{
    --transform-translate-y: -2.5rem;
  }

  .\\32xl\\:hover\\:-translate-y-11:hover{
    --transform-translate-y: -2.75rem;
  }

  .\\32xl\\:hover\\:-translate-y-12:hover{
    --transform-translate-y: -3rem;
  }

  .\\32xl\\:hover\\:-translate-y-14:hover{
    --transform-translate-y: -3.5rem;
  }

  .\\32xl\\:hover\\:-translate-y-15:hover{
    --transform-translate-y: -3.75rem;
  }

  .\\32xl\\:hover\\:-translate-y-16:hover{
    --transform-translate-y: -4rem;
  }

  .\\32xl\\:hover\\:-translate-y-18:hover{
    --transform-translate-y: -4.5rem;
  }

  .\\32xl\\:hover\\:-translate-y-20:hover{
    --transform-translate-y: -5rem;
  }

  .\\32xl\\:hover\\:-translate-y-22:hover{
    --transform-translate-y: -5.5rem;
  }

  .\\32xl\\:hover\\:-translate-y-23:hover{
    --transform-translate-y: -5.75rem;
  }

  .\\32xl\\:hover\\:-translate-y-24:hover{
    --transform-translate-y: -6rem;
  }

  .\\32xl\\:hover\\:-translate-y-25:hover{
    --transform-translate-y: -6.25rem;
  }

  .\\32xl\\:hover\\:-translate-y-26:hover{
    --transform-translate-y: -6.5rem;
  }

  .\\32xl\\:hover\\:-translate-y-28:hover{
    --transform-translate-y: -7rem;
  }

  .\\32xl\\:hover\\:-translate-y-30:hover{
    --transform-translate-y: -7.5rem;
  }

  .\\32xl\\:hover\\:-translate-y-32:hover{
    --transform-translate-y: -8rem;
  }

  .\\32xl\\:hover\\:-translate-y-34:hover{
    --transform-translate-y: -8.5rem;
  }

  .\\32xl\\:hover\\:-translate-y-40:hover{
    --transform-translate-y: -10rem;
  }

  .\\32xl\\:hover\\:-translate-y-42:hover{
    --transform-translate-y: -10.5rem;
  }

  .\\32xl\\:hover\\:-translate-y-44:hover{
    --transform-translate-y: -11rem;
  }

  .\\32xl\\:hover\\:-translate-y-48:hover{
    --transform-translate-y: -12rem;
  }

  .\\32xl\\:hover\\:-translate-y-52:hover{
    --transform-translate-y: -13rem;
  }

  .\\32xl\\:hover\\:-translate-y-54:hover{
    --transform-translate-y: -13.5rem;
  }

  .\\32xl\\:hover\\:-translate-y-56:hover{
    --transform-translate-y: -14rem;
  }

  .\\32xl\\:hover\\:-translate-y-60:hover{
    --transform-translate-y: -15rem;
  }

  .\\32xl\\:hover\\:-translate-y-64:hover{
    --transform-translate-y: -16rem;
  }

  .\\32xl\\:hover\\:-translate-y-68:hover{
    --transform-translate-y: -17rem;
  }

  .\\32xl\\:hover\\:-translate-y-72:hover{
    --transform-translate-y: -18rem;
  }

  .\\32xl\\:hover\\:-translate-y-74:hover{
    --transform-translate-y: -18.5rem;
  }

  .\\32xl\\:hover\\:-translate-y-76:hover{
    --transform-translate-y: -19rem;
  }

  .\\32xl\\:hover\\:-translate-y-78:hover{
    --transform-translate-y: -19.5rem;
  }

  .\\32xl\\:hover\\:-translate-y-80:hover{
    --transform-translate-y: -20rem;
  }

  .\\32xl\\:hover\\:-translate-y-82:hover{
    --transform-translate-y: -20.5rem;
  }

  .\\32xl\\:hover\\:-translate-y-84:hover{
    --transform-translate-y: -21rem;
  }

  .\\32xl\\:hover\\:-translate-y-88:hover{
    --transform-translate-y: -22rem;
  }

  .\\32xl\\:hover\\:-translate-y-92:hover{
    --transform-translate-y: -23rem;
  }

  .\\32xl\\:hover\\:-translate-y-96:hover{
    --transform-translate-y: -24rem;
  }

  .\\32xl\\:hover\\:-translate-y-98:hover{
    --transform-translate-y: -24.5rem;
  }

  .\\32xl\\:hover\\:-translate-y-100:hover{
    --transform-translate-y: -25rem;
  }

  .\\32xl\\:hover\\:-translate-y-104:hover{
    --transform-translate-y: -26rem;
  }

  .\\32xl\\:hover\\:-translate-y-112:hover{
    --transform-translate-y: -28rem;
  }

  .\\32xl\\:hover\\:-translate-y-124:hover{
    --transform-translate-y: -31rem;
  }

  .\\32xl\\:hover\\:-translate-y-128:hover{
    --transform-translate-y: -32rem;
  }

  .\\32xl\\:hover\\:-translate-y-140:hover{
    --transform-translate-y: -35rem;
  }

  .\\32xl\\:hover\\:-translate-y-152:hover{
    --transform-translate-y: -38rem;
  }

  .\\32xl\\:hover\\:-translate-y-160:hover{
    --transform-translate-y: -40rem;
  }

  .\\32xl\\:hover\\:-translate-y-162:hover{
    --transform-translate-y: -41rem;
  }

  .\\32xl\\:hover\\:-translate-y-192:hover{
    --transform-translate-y: -48rem;
  }

  .\\32xl\\:hover\\:-translate-y-208:hover{
    --transform-translate-y: -52rem;
  }

  .\\32xl\\:hover\\:-translate-y-224:hover{
    --transform-translate-y: -56rem;
  }

  .\\32xl\\:hover\\:-translate-y-256:hover{
    --transform-translate-y: -64rem;
  }

  .\\32xl\\:hover\\:-translate-y-px:hover{
    --transform-translate-y: -1px;
  }

  .\\32xl\\:hover\\:-translate-y-full:hover{
    --transform-translate-y: -100%;
  }

  .\\32xl\\:hover\\:-translate-y-1\\/2:hover{
    --transform-translate-y: -50%;
  }

  .\\32xl\\:hover\\:translate-y-1\\/2:hover{
    --transform-translate-y: 50%;
  }

  .\\32xl\\:hover\\:translate-y-full:hover{
    --transform-translate-y: 100%;
  }

  .\\32xl\\:focus\\:translate-x-0:focus{
    --transform-translate-x: 0;
  }

  .\\32xl\\:focus\\:translate-x-1:focus{
    --transform-translate-x: 0.25rem;
  }

  .\\32xl\\:focus\\:translate-x-2:focus{
    --transform-translate-x: 0.5rem;
  }

  .\\32xl\\:focus\\:translate-x-3:focus{
    --transform-translate-x: 0.75rem;
  }

  .\\32xl\\:focus\\:translate-x-4:focus{
    --transform-translate-x: 1rem;
  }

  .\\32xl\\:focus\\:translate-x-5:focus{
    --transform-translate-x: 1.25rem;
  }

  .\\32xl\\:focus\\:translate-x-6:focus{
    --transform-translate-x: 1.5rem;
  }

  .\\32xl\\:focus\\:translate-x-7:focus{
    --transform-translate-x: 1.75rem;
  }

  .\\32xl\\:focus\\:translate-x-8:focus{
    --transform-translate-x: 2rem;
  }

  .\\32xl\\:focus\\:translate-x-9:focus{
    --transform-translate-x: 2.25rem;
  }

  .\\32xl\\:focus\\:translate-x-10:focus{
    --transform-translate-x: 2.5rem;
  }

  .\\32xl\\:focus\\:translate-x-11:focus{
    --transform-translate-x: 2.75rem;
  }

  .\\32xl\\:focus\\:translate-x-12:focus{
    --transform-translate-x: 3rem;
  }

  .\\32xl\\:focus\\:translate-x-14:focus{
    --transform-translate-x: 3.5rem;
  }

  .\\32xl\\:focus\\:translate-x-15:focus{
    --transform-translate-x: 3.75rem;
  }

  .\\32xl\\:focus\\:translate-x-16:focus{
    --transform-translate-x: 4rem;
  }

  .\\32xl\\:focus\\:translate-x-18:focus{
    --transform-translate-x: 4.5rem;
  }

  .\\32xl\\:focus\\:translate-x-20:focus{
    --transform-translate-x: 5rem;
  }

  .\\32xl\\:focus\\:translate-x-22:focus{
    --transform-translate-x: 5.5rem;
  }

  .\\32xl\\:focus\\:translate-x-23:focus{
    --transform-translate-x: 5.75rem;
  }

  .\\32xl\\:focus\\:translate-x-24:focus{
    --transform-translate-x: 6rem;
  }

  .\\32xl\\:focus\\:translate-x-25:focus{
    --transform-translate-x: 6.25rem;
  }

  .\\32xl\\:focus\\:translate-x-26:focus{
    --transform-translate-x: 6.5rem;
  }

  .\\32xl\\:focus\\:translate-x-28:focus{
    --transform-translate-x: 7rem;
  }

  .\\32xl\\:focus\\:translate-x-30:focus{
    --transform-translate-x: 7.5rem;
  }

  .\\32xl\\:focus\\:translate-x-32:focus{
    --transform-translate-x: 8rem;
  }

  .\\32xl\\:focus\\:translate-x-34:focus{
    --transform-translate-x: 8.5rem;
  }

  .\\32xl\\:focus\\:translate-x-40:focus{
    --transform-translate-x: 10rem;
  }

  .\\32xl\\:focus\\:translate-x-42:focus{
    --transform-translate-x: 10.5rem;
  }

  .\\32xl\\:focus\\:translate-x-44:focus{
    --transform-translate-x: 11rem;
  }

  .\\32xl\\:focus\\:translate-x-48:focus{
    --transform-translate-x: 12rem;
  }

  .\\32xl\\:focus\\:translate-x-52:focus{
    --transform-translate-x: 13rem;
  }

  .\\32xl\\:focus\\:translate-x-54:focus{
    --transform-translate-x: 13.5rem;
  }

  .\\32xl\\:focus\\:translate-x-56:focus{
    --transform-translate-x: 14rem;
  }

  .\\32xl\\:focus\\:translate-x-60:focus{
    --transform-translate-x: 15rem;
  }

  .\\32xl\\:focus\\:translate-x-64:focus{
    --transform-translate-x: 16rem;
  }

  .\\32xl\\:focus\\:translate-x-68:focus{
    --transform-translate-x: 17rem;
  }

  .\\32xl\\:focus\\:translate-x-72:focus{
    --transform-translate-x: 18rem;
  }

  .\\32xl\\:focus\\:translate-x-74:focus{
    --transform-translate-x: 18.5rem;
  }

  .\\32xl\\:focus\\:translate-x-76:focus{
    --transform-translate-x: 19rem;
  }

  .\\32xl\\:focus\\:translate-x-78:focus{
    --transform-translate-x: 19.5rem;
  }

  .\\32xl\\:focus\\:translate-x-80:focus{
    --transform-translate-x: 20rem;
  }

  .\\32xl\\:focus\\:translate-x-82:focus{
    --transform-translate-x: 20.5rem;
  }

  .\\32xl\\:focus\\:translate-x-84:focus{
    --transform-translate-x: 21rem;
  }

  .\\32xl\\:focus\\:translate-x-88:focus{
    --transform-translate-x: 22rem;
  }

  .\\32xl\\:focus\\:translate-x-92:focus{
    --transform-translate-x: 23rem;
  }

  .\\32xl\\:focus\\:translate-x-96:focus{
    --transform-translate-x: 24rem;
  }

  .\\32xl\\:focus\\:translate-x-98:focus{
    --transform-translate-x: 24.5rem;
  }

  .\\32xl\\:focus\\:translate-x-100:focus{
    --transform-translate-x: 25rem;
  }

  .\\32xl\\:focus\\:translate-x-104:focus{
    --transform-translate-x: 26rem;
  }

  .\\32xl\\:focus\\:translate-x-112:focus{
    --transform-translate-x: 28rem;
  }

  .\\32xl\\:focus\\:translate-x-124:focus{
    --transform-translate-x: 31rem;
  }

  .\\32xl\\:focus\\:translate-x-128:focus{
    --transform-translate-x: 32rem;
  }

  .\\32xl\\:focus\\:translate-x-140:focus{
    --transform-translate-x: 35rem;
  }

  .\\32xl\\:focus\\:translate-x-152:focus{
    --transform-translate-x: 38rem;
  }

  .\\32xl\\:focus\\:translate-x-160:focus{
    --transform-translate-x: 40rem;
  }

  .\\32xl\\:focus\\:translate-x-162:focus{
    --transform-translate-x: 41rem;
  }

  .\\32xl\\:focus\\:translate-x-192:focus{
    --transform-translate-x: 48rem;
  }

  .\\32xl\\:focus\\:translate-x-208:focus{
    --transform-translate-x: 52rem;
  }

  .\\32xl\\:focus\\:translate-x-224:focus{
    --transform-translate-x: 56rem;
  }

  .\\32xl\\:focus\\:translate-x-256:focus{
    --transform-translate-x: 64rem;
  }

  .\\32xl\\:focus\\:translate-x-px:focus{
    --transform-translate-x: 1px;
  }

  .\\32xl\\:focus\\:-translate-x-1:focus{
    --transform-translate-x: -0.25rem;
  }

  .\\32xl\\:focus\\:-translate-x-2:focus{
    --transform-translate-x: -0.5rem;
  }

  .\\32xl\\:focus\\:-translate-x-3:focus{
    --transform-translate-x: -0.75rem;
  }

  .\\32xl\\:focus\\:-translate-x-4:focus{
    --transform-translate-x: -1rem;
  }

  .\\32xl\\:focus\\:-translate-x-5:focus{
    --transform-translate-x: -1.25rem;
  }

  .\\32xl\\:focus\\:-translate-x-6:focus{
    --transform-translate-x: -1.5rem;
  }

  .\\32xl\\:focus\\:-translate-x-7:focus{
    --transform-translate-x: -1.75rem;
  }

  .\\32xl\\:focus\\:-translate-x-8:focus{
    --transform-translate-x: -2rem;
  }

  .\\32xl\\:focus\\:-translate-x-9:focus{
    --transform-translate-x: -2.25rem;
  }

  .\\32xl\\:focus\\:-translate-x-10:focus{
    --transform-translate-x: -2.5rem;
  }

  .\\32xl\\:focus\\:-translate-x-11:focus{
    --transform-translate-x: -2.75rem;
  }

  .\\32xl\\:focus\\:-translate-x-12:focus{
    --transform-translate-x: -3rem;
  }

  .\\32xl\\:focus\\:-translate-x-14:focus{
    --transform-translate-x: -3.5rem;
  }

  .\\32xl\\:focus\\:-translate-x-15:focus{
    --transform-translate-x: -3.75rem;
  }

  .\\32xl\\:focus\\:-translate-x-16:focus{
    --transform-translate-x: -4rem;
  }

  .\\32xl\\:focus\\:-translate-x-18:focus{
    --transform-translate-x: -4.5rem;
  }

  .\\32xl\\:focus\\:-translate-x-20:focus{
    --transform-translate-x: -5rem;
  }

  .\\32xl\\:focus\\:-translate-x-22:focus{
    --transform-translate-x: -5.5rem;
  }

  .\\32xl\\:focus\\:-translate-x-23:focus{
    --transform-translate-x: -5.75rem;
  }

  .\\32xl\\:focus\\:-translate-x-24:focus{
    --transform-translate-x: -6rem;
  }

  .\\32xl\\:focus\\:-translate-x-25:focus{
    --transform-translate-x: -6.25rem;
  }

  .\\32xl\\:focus\\:-translate-x-26:focus{
    --transform-translate-x: -6.5rem;
  }

  .\\32xl\\:focus\\:-translate-x-28:focus{
    --transform-translate-x: -7rem;
  }

  .\\32xl\\:focus\\:-translate-x-30:focus{
    --transform-translate-x: -7.5rem;
  }

  .\\32xl\\:focus\\:-translate-x-32:focus{
    --transform-translate-x: -8rem;
  }

  .\\32xl\\:focus\\:-translate-x-34:focus{
    --transform-translate-x: -8.5rem;
  }

  .\\32xl\\:focus\\:-translate-x-40:focus{
    --transform-translate-x: -10rem;
  }

  .\\32xl\\:focus\\:-translate-x-42:focus{
    --transform-translate-x: -10.5rem;
  }

  .\\32xl\\:focus\\:-translate-x-44:focus{
    --transform-translate-x: -11rem;
  }

  .\\32xl\\:focus\\:-translate-x-48:focus{
    --transform-translate-x: -12rem;
  }

  .\\32xl\\:focus\\:-translate-x-52:focus{
    --transform-translate-x: -13rem;
  }

  .\\32xl\\:focus\\:-translate-x-54:focus{
    --transform-translate-x: -13.5rem;
  }

  .\\32xl\\:focus\\:-translate-x-56:focus{
    --transform-translate-x: -14rem;
  }

  .\\32xl\\:focus\\:-translate-x-60:focus{
    --transform-translate-x: -15rem;
  }

  .\\32xl\\:focus\\:-translate-x-64:focus{
    --transform-translate-x: -16rem;
  }

  .\\32xl\\:focus\\:-translate-x-68:focus{
    --transform-translate-x: -17rem;
  }

  .\\32xl\\:focus\\:-translate-x-72:focus{
    --transform-translate-x: -18rem;
  }

  .\\32xl\\:focus\\:-translate-x-74:focus{
    --transform-translate-x: -18.5rem;
  }

  .\\32xl\\:focus\\:-translate-x-76:focus{
    --transform-translate-x: -19rem;
  }

  .\\32xl\\:focus\\:-translate-x-78:focus{
    --transform-translate-x: -19.5rem;
  }

  .\\32xl\\:focus\\:-translate-x-80:focus{
    --transform-translate-x: -20rem;
  }

  .\\32xl\\:focus\\:-translate-x-82:focus{
    --transform-translate-x: -20.5rem;
  }

  .\\32xl\\:focus\\:-translate-x-84:focus{
    --transform-translate-x: -21rem;
  }

  .\\32xl\\:focus\\:-translate-x-88:focus{
    --transform-translate-x: -22rem;
  }

  .\\32xl\\:focus\\:-translate-x-92:focus{
    --transform-translate-x: -23rem;
  }

  .\\32xl\\:focus\\:-translate-x-96:focus{
    --transform-translate-x: -24rem;
  }

  .\\32xl\\:focus\\:-translate-x-98:focus{
    --transform-translate-x: -24.5rem;
  }

  .\\32xl\\:focus\\:-translate-x-100:focus{
    --transform-translate-x: -25rem;
  }

  .\\32xl\\:focus\\:-translate-x-104:focus{
    --transform-translate-x: -26rem;
  }

  .\\32xl\\:focus\\:-translate-x-112:focus{
    --transform-translate-x: -28rem;
  }

  .\\32xl\\:focus\\:-translate-x-124:focus{
    --transform-translate-x: -31rem;
  }

  .\\32xl\\:focus\\:-translate-x-128:focus{
    --transform-translate-x: -32rem;
  }

  .\\32xl\\:focus\\:-translate-x-140:focus{
    --transform-translate-x: -35rem;
  }

  .\\32xl\\:focus\\:-translate-x-152:focus{
    --transform-translate-x: -38rem;
  }

  .\\32xl\\:focus\\:-translate-x-160:focus{
    --transform-translate-x: -40rem;
  }

  .\\32xl\\:focus\\:-translate-x-162:focus{
    --transform-translate-x: -41rem;
  }

  .\\32xl\\:focus\\:-translate-x-192:focus{
    --transform-translate-x: -48rem;
  }

  .\\32xl\\:focus\\:-translate-x-208:focus{
    --transform-translate-x: -52rem;
  }

  .\\32xl\\:focus\\:-translate-x-224:focus{
    --transform-translate-x: -56rem;
  }

  .\\32xl\\:focus\\:-translate-x-256:focus{
    --transform-translate-x: -64rem;
  }

  .\\32xl\\:focus\\:-translate-x-px:focus{
    --transform-translate-x: -1px;
  }

  .\\32xl\\:focus\\:-translate-x-full:focus{
    --transform-translate-x: -100%;
  }

  .\\32xl\\:focus\\:-translate-x-1\\/2:focus{
    --transform-translate-x: -50%;
  }

  .\\32xl\\:focus\\:translate-x-1\\/2:focus{
    --transform-translate-x: 50%;
  }

  .\\32xl\\:focus\\:translate-x-full:focus{
    --transform-translate-x: 100%;
  }

  .\\32xl\\:focus\\:translate-y-0:focus{
    --transform-translate-y: 0;
  }

  .\\32xl\\:focus\\:translate-y-1:focus{
    --transform-translate-y: 0.25rem;
  }

  .\\32xl\\:focus\\:translate-y-2:focus{
    --transform-translate-y: 0.5rem;
  }

  .\\32xl\\:focus\\:translate-y-3:focus{
    --transform-translate-y: 0.75rem;
  }

  .\\32xl\\:focus\\:translate-y-4:focus{
    --transform-translate-y: 1rem;
  }

  .\\32xl\\:focus\\:translate-y-5:focus{
    --transform-translate-y: 1.25rem;
  }

  .\\32xl\\:focus\\:translate-y-6:focus{
    --transform-translate-y: 1.5rem;
  }

  .\\32xl\\:focus\\:translate-y-7:focus{
    --transform-translate-y: 1.75rem;
  }

  .\\32xl\\:focus\\:translate-y-8:focus{
    --transform-translate-y: 2rem;
  }

  .\\32xl\\:focus\\:translate-y-9:focus{
    --transform-translate-y: 2.25rem;
  }

  .\\32xl\\:focus\\:translate-y-10:focus{
    --transform-translate-y: 2.5rem;
  }

  .\\32xl\\:focus\\:translate-y-11:focus{
    --transform-translate-y: 2.75rem;
  }

  .\\32xl\\:focus\\:translate-y-12:focus{
    --transform-translate-y: 3rem;
  }

  .\\32xl\\:focus\\:translate-y-14:focus{
    --transform-translate-y: 3.5rem;
  }

  .\\32xl\\:focus\\:translate-y-15:focus{
    --transform-translate-y: 3.75rem;
  }

  .\\32xl\\:focus\\:translate-y-16:focus{
    --transform-translate-y: 4rem;
  }

  .\\32xl\\:focus\\:translate-y-18:focus{
    --transform-translate-y: 4.5rem;
  }

  .\\32xl\\:focus\\:translate-y-20:focus{
    --transform-translate-y: 5rem;
  }

  .\\32xl\\:focus\\:translate-y-22:focus{
    --transform-translate-y: 5.5rem;
  }

  .\\32xl\\:focus\\:translate-y-23:focus{
    --transform-translate-y: 5.75rem;
  }

  .\\32xl\\:focus\\:translate-y-24:focus{
    --transform-translate-y: 6rem;
  }

  .\\32xl\\:focus\\:translate-y-25:focus{
    --transform-translate-y: 6.25rem;
  }

  .\\32xl\\:focus\\:translate-y-26:focus{
    --transform-translate-y: 6.5rem;
  }

  .\\32xl\\:focus\\:translate-y-28:focus{
    --transform-translate-y: 7rem;
  }

  .\\32xl\\:focus\\:translate-y-30:focus{
    --transform-translate-y: 7.5rem;
  }

  .\\32xl\\:focus\\:translate-y-32:focus{
    --transform-translate-y: 8rem;
  }

  .\\32xl\\:focus\\:translate-y-34:focus{
    --transform-translate-y: 8.5rem;
  }

  .\\32xl\\:focus\\:translate-y-40:focus{
    --transform-translate-y: 10rem;
  }

  .\\32xl\\:focus\\:translate-y-42:focus{
    --transform-translate-y: 10.5rem;
  }

  .\\32xl\\:focus\\:translate-y-44:focus{
    --transform-translate-y: 11rem;
  }

  .\\32xl\\:focus\\:translate-y-48:focus{
    --transform-translate-y: 12rem;
  }

  .\\32xl\\:focus\\:translate-y-52:focus{
    --transform-translate-y: 13rem;
  }

  .\\32xl\\:focus\\:translate-y-54:focus{
    --transform-translate-y: 13.5rem;
  }

  .\\32xl\\:focus\\:translate-y-56:focus{
    --transform-translate-y: 14rem;
  }

  .\\32xl\\:focus\\:translate-y-60:focus{
    --transform-translate-y: 15rem;
  }

  .\\32xl\\:focus\\:translate-y-64:focus{
    --transform-translate-y: 16rem;
  }

  .\\32xl\\:focus\\:translate-y-68:focus{
    --transform-translate-y: 17rem;
  }

  .\\32xl\\:focus\\:translate-y-72:focus{
    --transform-translate-y: 18rem;
  }

  .\\32xl\\:focus\\:translate-y-74:focus{
    --transform-translate-y: 18.5rem;
  }

  .\\32xl\\:focus\\:translate-y-76:focus{
    --transform-translate-y: 19rem;
  }

  .\\32xl\\:focus\\:translate-y-78:focus{
    --transform-translate-y: 19.5rem;
  }

  .\\32xl\\:focus\\:translate-y-80:focus{
    --transform-translate-y: 20rem;
  }

  .\\32xl\\:focus\\:translate-y-82:focus{
    --transform-translate-y: 20.5rem;
  }

  .\\32xl\\:focus\\:translate-y-84:focus{
    --transform-translate-y: 21rem;
  }

  .\\32xl\\:focus\\:translate-y-88:focus{
    --transform-translate-y: 22rem;
  }

  .\\32xl\\:focus\\:translate-y-92:focus{
    --transform-translate-y: 23rem;
  }

  .\\32xl\\:focus\\:translate-y-96:focus{
    --transform-translate-y: 24rem;
  }

  .\\32xl\\:focus\\:translate-y-98:focus{
    --transform-translate-y: 24.5rem;
  }

  .\\32xl\\:focus\\:translate-y-100:focus{
    --transform-translate-y: 25rem;
  }

  .\\32xl\\:focus\\:translate-y-104:focus{
    --transform-translate-y: 26rem;
  }

  .\\32xl\\:focus\\:translate-y-112:focus{
    --transform-translate-y: 28rem;
  }

  .\\32xl\\:focus\\:translate-y-124:focus{
    --transform-translate-y: 31rem;
  }

  .\\32xl\\:focus\\:translate-y-128:focus{
    --transform-translate-y: 32rem;
  }

  .\\32xl\\:focus\\:translate-y-140:focus{
    --transform-translate-y: 35rem;
  }

  .\\32xl\\:focus\\:translate-y-152:focus{
    --transform-translate-y: 38rem;
  }

  .\\32xl\\:focus\\:translate-y-160:focus{
    --transform-translate-y: 40rem;
  }

  .\\32xl\\:focus\\:translate-y-162:focus{
    --transform-translate-y: 41rem;
  }

  .\\32xl\\:focus\\:translate-y-192:focus{
    --transform-translate-y: 48rem;
  }

  .\\32xl\\:focus\\:translate-y-208:focus{
    --transform-translate-y: 52rem;
  }

  .\\32xl\\:focus\\:translate-y-224:focus{
    --transform-translate-y: 56rem;
  }

  .\\32xl\\:focus\\:translate-y-256:focus{
    --transform-translate-y: 64rem;
  }

  .\\32xl\\:focus\\:translate-y-px:focus{
    --transform-translate-y: 1px;
  }

  .\\32xl\\:focus\\:-translate-y-1:focus{
    --transform-translate-y: -0.25rem;
  }

  .\\32xl\\:focus\\:-translate-y-2:focus{
    --transform-translate-y: -0.5rem;
  }

  .\\32xl\\:focus\\:-translate-y-3:focus{
    --transform-translate-y: -0.75rem;
  }

  .\\32xl\\:focus\\:-translate-y-4:focus{
    --transform-translate-y: -1rem;
  }

  .\\32xl\\:focus\\:-translate-y-5:focus{
    --transform-translate-y: -1.25rem;
  }

  .\\32xl\\:focus\\:-translate-y-6:focus{
    --transform-translate-y: -1.5rem;
  }

  .\\32xl\\:focus\\:-translate-y-7:focus{
    --transform-translate-y: -1.75rem;
  }

  .\\32xl\\:focus\\:-translate-y-8:focus{
    --transform-translate-y: -2rem;
  }

  .\\32xl\\:focus\\:-translate-y-9:focus{
    --transform-translate-y: -2.25rem;
  }

  .\\32xl\\:focus\\:-translate-y-10:focus{
    --transform-translate-y: -2.5rem;
  }

  .\\32xl\\:focus\\:-translate-y-11:focus{
    --transform-translate-y: -2.75rem;
  }

  .\\32xl\\:focus\\:-translate-y-12:focus{
    --transform-translate-y: -3rem;
  }

  .\\32xl\\:focus\\:-translate-y-14:focus{
    --transform-translate-y: -3.5rem;
  }

  .\\32xl\\:focus\\:-translate-y-15:focus{
    --transform-translate-y: -3.75rem;
  }

  .\\32xl\\:focus\\:-translate-y-16:focus{
    --transform-translate-y: -4rem;
  }

  .\\32xl\\:focus\\:-translate-y-18:focus{
    --transform-translate-y: -4.5rem;
  }

  .\\32xl\\:focus\\:-translate-y-20:focus{
    --transform-translate-y: -5rem;
  }

  .\\32xl\\:focus\\:-translate-y-22:focus{
    --transform-translate-y: -5.5rem;
  }

  .\\32xl\\:focus\\:-translate-y-23:focus{
    --transform-translate-y: -5.75rem;
  }

  .\\32xl\\:focus\\:-translate-y-24:focus{
    --transform-translate-y: -6rem;
  }

  .\\32xl\\:focus\\:-translate-y-25:focus{
    --transform-translate-y: -6.25rem;
  }

  .\\32xl\\:focus\\:-translate-y-26:focus{
    --transform-translate-y: -6.5rem;
  }

  .\\32xl\\:focus\\:-translate-y-28:focus{
    --transform-translate-y: -7rem;
  }

  .\\32xl\\:focus\\:-translate-y-30:focus{
    --transform-translate-y: -7.5rem;
  }

  .\\32xl\\:focus\\:-translate-y-32:focus{
    --transform-translate-y: -8rem;
  }

  .\\32xl\\:focus\\:-translate-y-34:focus{
    --transform-translate-y: -8.5rem;
  }

  .\\32xl\\:focus\\:-translate-y-40:focus{
    --transform-translate-y: -10rem;
  }

  .\\32xl\\:focus\\:-translate-y-42:focus{
    --transform-translate-y: -10.5rem;
  }

  .\\32xl\\:focus\\:-translate-y-44:focus{
    --transform-translate-y: -11rem;
  }

  .\\32xl\\:focus\\:-translate-y-48:focus{
    --transform-translate-y: -12rem;
  }

  .\\32xl\\:focus\\:-translate-y-52:focus{
    --transform-translate-y: -13rem;
  }

  .\\32xl\\:focus\\:-translate-y-54:focus{
    --transform-translate-y: -13.5rem;
  }

  .\\32xl\\:focus\\:-translate-y-56:focus{
    --transform-translate-y: -14rem;
  }

  .\\32xl\\:focus\\:-translate-y-60:focus{
    --transform-translate-y: -15rem;
  }

  .\\32xl\\:focus\\:-translate-y-64:focus{
    --transform-translate-y: -16rem;
  }

  .\\32xl\\:focus\\:-translate-y-68:focus{
    --transform-translate-y: -17rem;
  }

  .\\32xl\\:focus\\:-translate-y-72:focus{
    --transform-translate-y: -18rem;
  }

  .\\32xl\\:focus\\:-translate-y-74:focus{
    --transform-translate-y: -18.5rem;
  }

  .\\32xl\\:focus\\:-translate-y-76:focus{
    --transform-translate-y: -19rem;
  }

  .\\32xl\\:focus\\:-translate-y-78:focus{
    --transform-translate-y: -19.5rem;
  }

  .\\32xl\\:focus\\:-translate-y-80:focus{
    --transform-translate-y: -20rem;
  }

  .\\32xl\\:focus\\:-translate-y-82:focus{
    --transform-translate-y: -20.5rem;
  }

  .\\32xl\\:focus\\:-translate-y-84:focus{
    --transform-translate-y: -21rem;
  }

  .\\32xl\\:focus\\:-translate-y-88:focus{
    --transform-translate-y: -22rem;
  }

  .\\32xl\\:focus\\:-translate-y-92:focus{
    --transform-translate-y: -23rem;
  }

  .\\32xl\\:focus\\:-translate-y-96:focus{
    --transform-translate-y: -24rem;
  }

  .\\32xl\\:focus\\:-translate-y-98:focus{
    --transform-translate-y: -24.5rem;
  }

  .\\32xl\\:focus\\:-translate-y-100:focus{
    --transform-translate-y: -25rem;
  }

  .\\32xl\\:focus\\:-translate-y-104:focus{
    --transform-translate-y: -26rem;
  }

  .\\32xl\\:focus\\:-translate-y-112:focus{
    --transform-translate-y: -28rem;
  }

  .\\32xl\\:focus\\:-translate-y-124:focus{
    --transform-translate-y: -31rem;
  }

  .\\32xl\\:focus\\:-translate-y-128:focus{
    --transform-translate-y: -32rem;
  }

  .\\32xl\\:focus\\:-translate-y-140:focus{
    --transform-translate-y: -35rem;
  }

  .\\32xl\\:focus\\:-translate-y-152:focus{
    --transform-translate-y: -38rem;
  }

  .\\32xl\\:focus\\:-translate-y-160:focus{
    --transform-translate-y: -40rem;
  }

  .\\32xl\\:focus\\:-translate-y-162:focus{
    --transform-translate-y: -41rem;
  }

  .\\32xl\\:focus\\:-translate-y-192:focus{
    --transform-translate-y: -48rem;
  }

  .\\32xl\\:focus\\:-translate-y-208:focus{
    --transform-translate-y: -52rem;
  }

  .\\32xl\\:focus\\:-translate-y-224:focus{
    --transform-translate-y: -56rem;
  }

  .\\32xl\\:focus\\:-translate-y-256:focus{
    --transform-translate-y: -64rem;
  }

  .\\32xl\\:focus\\:-translate-y-px:focus{
    --transform-translate-y: -1px;
  }

  .\\32xl\\:focus\\:-translate-y-full:focus{
    --transform-translate-y: -100%;
  }

  .\\32xl\\:focus\\:-translate-y-1\\/2:focus{
    --transform-translate-y: -50%;
  }

  .\\32xl\\:focus\\:translate-y-1\\/2:focus{
    --transform-translate-y: 50%;
  }

  .\\32xl\\:focus\\:translate-y-full:focus{
    --transform-translate-y: 100%;
  }

  .\\32xl\\:skew-x-0{
    --transform-skew-x: 0;
  }

  .\\32xl\\:skew-x-1{
    --transform-skew-x: 1deg;
  }

  .\\32xl\\:skew-x-2{
    --transform-skew-x: 2deg;
  }

  .\\32xl\\:skew-x-3{
    --transform-skew-x: 3deg;
  }

  .\\32xl\\:skew-x-6{
    --transform-skew-x: 6deg;
  }

  .\\32xl\\:skew-x-12{
    --transform-skew-x: 12deg;
  }

  .\\32xl\\:-skew-x-12{
    --transform-skew-x: -12deg;
  }

  .\\32xl\\:-skew-x-6{
    --transform-skew-x: -6deg;
  }

  .\\32xl\\:-skew-x-3{
    --transform-skew-x: -3deg;
  }

  .\\32xl\\:-skew-x-2{
    --transform-skew-x: -2deg;
  }

  .\\32xl\\:-skew-x-1{
    --transform-skew-x: -1deg;
  }

  .\\32xl\\:skew-y-0{
    --transform-skew-y: 0;
  }

  .\\32xl\\:skew-y-1{
    --transform-skew-y: 1deg;
  }

  .\\32xl\\:skew-y-2{
    --transform-skew-y: 2deg;
  }

  .\\32xl\\:skew-y-3{
    --transform-skew-y: 3deg;
  }

  .\\32xl\\:skew-y-6{
    --transform-skew-y: 6deg;
  }

  .\\32xl\\:skew-y-12{
    --transform-skew-y: 12deg;
  }

  .\\32xl\\:-skew-y-12{
    --transform-skew-y: -12deg;
  }

  .\\32xl\\:-skew-y-6{
    --transform-skew-y: -6deg;
  }

  .\\32xl\\:-skew-y-3{
    --transform-skew-y: -3deg;
  }

  .\\32xl\\:-skew-y-2{
    --transform-skew-y: -2deg;
  }

  .\\32xl\\:-skew-y-1{
    --transform-skew-y: -1deg;
  }

  .\\32xl\\:hover\\:skew-x-0:hover{
    --transform-skew-x: 0;
  }

  .\\32xl\\:hover\\:skew-x-1:hover{
    --transform-skew-x: 1deg;
  }

  .\\32xl\\:hover\\:skew-x-2:hover{
    --transform-skew-x: 2deg;
  }

  .\\32xl\\:hover\\:skew-x-3:hover{
    --transform-skew-x: 3deg;
  }

  .\\32xl\\:hover\\:skew-x-6:hover{
    --transform-skew-x: 6deg;
  }

  .\\32xl\\:hover\\:skew-x-12:hover{
    --transform-skew-x: 12deg;
  }

  .\\32xl\\:hover\\:-skew-x-12:hover{
    --transform-skew-x: -12deg;
  }

  .\\32xl\\:hover\\:-skew-x-6:hover{
    --transform-skew-x: -6deg;
  }

  .\\32xl\\:hover\\:-skew-x-3:hover{
    --transform-skew-x: -3deg;
  }

  .\\32xl\\:hover\\:-skew-x-2:hover{
    --transform-skew-x: -2deg;
  }

  .\\32xl\\:hover\\:-skew-x-1:hover{
    --transform-skew-x: -1deg;
  }

  .\\32xl\\:hover\\:skew-y-0:hover{
    --transform-skew-y: 0;
  }

  .\\32xl\\:hover\\:skew-y-1:hover{
    --transform-skew-y: 1deg;
  }

  .\\32xl\\:hover\\:skew-y-2:hover{
    --transform-skew-y: 2deg;
  }

  .\\32xl\\:hover\\:skew-y-3:hover{
    --transform-skew-y: 3deg;
  }

  .\\32xl\\:hover\\:skew-y-6:hover{
    --transform-skew-y: 6deg;
  }

  .\\32xl\\:hover\\:skew-y-12:hover{
    --transform-skew-y: 12deg;
  }

  .\\32xl\\:hover\\:-skew-y-12:hover{
    --transform-skew-y: -12deg;
  }

  .\\32xl\\:hover\\:-skew-y-6:hover{
    --transform-skew-y: -6deg;
  }

  .\\32xl\\:hover\\:-skew-y-3:hover{
    --transform-skew-y: -3deg;
  }

  .\\32xl\\:hover\\:-skew-y-2:hover{
    --transform-skew-y: -2deg;
  }

  .\\32xl\\:hover\\:-skew-y-1:hover{
    --transform-skew-y: -1deg;
  }

  .\\32xl\\:focus\\:skew-x-0:focus{
    --transform-skew-x: 0;
  }

  .\\32xl\\:focus\\:skew-x-1:focus{
    --transform-skew-x: 1deg;
  }

  .\\32xl\\:focus\\:skew-x-2:focus{
    --transform-skew-x: 2deg;
  }

  .\\32xl\\:focus\\:skew-x-3:focus{
    --transform-skew-x: 3deg;
  }

  .\\32xl\\:focus\\:skew-x-6:focus{
    --transform-skew-x: 6deg;
  }

  .\\32xl\\:focus\\:skew-x-12:focus{
    --transform-skew-x: 12deg;
  }

  .\\32xl\\:focus\\:-skew-x-12:focus{
    --transform-skew-x: -12deg;
  }

  .\\32xl\\:focus\\:-skew-x-6:focus{
    --transform-skew-x: -6deg;
  }

  .\\32xl\\:focus\\:-skew-x-3:focus{
    --transform-skew-x: -3deg;
  }

  .\\32xl\\:focus\\:-skew-x-2:focus{
    --transform-skew-x: -2deg;
  }

  .\\32xl\\:focus\\:-skew-x-1:focus{
    --transform-skew-x: -1deg;
  }

  .\\32xl\\:focus\\:skew-y-0:focus{
    --transform-skew-y: 0;
  }

  .\\32xl\\:focus\\:skew-y-1:focus{
    --transform-skew-y: 1deg;
  }

  .\\32xl\\:focus\\:skew-y-2:focus{
    --transform-skew-y: 2deg;
  }

  .\\32xl\\:focus\\:skew-y-3:focus{
    --transform-skew-y: 3deg;
  }

  .\\32xl\\:focus\\:skew-y-6:focus{
    --transform-skew-y: 6deg;
  }

  .\\32xl\\:focus\\:skew-y-12:focus{
    --transform-skew-y: 12deg;
  }

  .\\32xl\\:focus\\:-skew-y-12:focus{
    --transform-skew-y: -12deg;
  }

  .\\32xl\\:focus\\:-skew-y-6:focus{
    --transform-skew-y: -6deg;
  }

  .\\32xl\\:focus\\:-skew-y-3:focus{
    --transform-skew-y: -3deg;
  }

  .\\32xl\\:focus\\:-skew-y-2:focus{
    --transform-skew-y: -2deg;
  }

  .\\32xl\\:focus\\:-skew-y-1:focus{
    --transform-skew-y: -1deg;
  }

  .\\32xl\\:transition-none{
    transition-property: none;
  }

  .\\32xl\\:transition-all{
    transition-property: all;
  }

  .\\32xl\\:transition{
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  }

  .\\32xl\\:transition-colors{
    transition-property: background-color, border-color, color, fill, stroke;
  }

  .\\32xl\\:transition-opacity{
    transition-property: opacity;
  }

  .\\32xl\\:transition-shadow{
    transition-property: box-shadow;
  }

  .\\32xl\\:transition-transform{
    transition-property: transform;
  }

  .\\32xl\\:ease-linear{
    transition-timing-function: linear;
  }

  .\\32xl\\:ease-in{
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  }

  .\\32xl\\:ease-out{
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }

  .\\32xl\\:ease-in-out{
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }

  .\\32xl\\:duration-75{
    transition-duration: 75ms;
  }

  .\\32xl\\:duration-100{
    transition-duration: 100ms;
  }

  .\\32xl\\:duration-150{
    transition-duration: 150ms;
  }

  .\\32xl\\:duration-200{
    transition-duration: 200ms;
  }

  .\\32xl\\:duration-300{
    transition-duration: 300ms;
  }

  .\\32xl\\:duration-500{
    transition-duration: 500ms;
  }

  .\\32xl\\:duration-700{
    transition-duration: 700ms;
  }

  .\\32xl\\:duration-1000{
    transition-duration: 1000ms;
  }

  .\\32xl\\:delay-75{
    transition-delay: 75ms;
  }

  .\\32xl\\:delay-100{
    transition-delay: 100ms;
  }

  .\\32xl\\:delay-150{
    transition-delay: 150ms;
  }

  .\\32xl\\:delay-200{
    transition-delay: 200ms;
  }

  .\\32xl\\:delay-300{
    transition-delay: 300ms;
  }

  .\\32xl\\:delay-500{
    transition-delay: 500ms;
  }

  .\\32xl\\:delay-700{
    transition-delay: 700ms;
  }

  .\\32xl\\:delay-1000{
    transition-delay: 1000ms;
  }

  .\\32xl\\:animate-none{
    animation: none;
  }

  .\\32xl\\:animate-spin{
    animation: spin 1s linear infinite;
  }

  .\\32xl\\:animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }

  .\\32xl\\:animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  .\\32xl\\:animate-bounce{
    animation: bounce 1s infinite;
  }

  [dir="ltr"] .\\32xl\\:ps-0{
    padding-left: 0;
  }

  [dir="rtl"] .\\32xl\\:ps-0{
    padding-right: 0;
  }

  [dir="ltr"] .\\32xl\\:pe-0{
    padding-right: 0;
  }

  [dir="rtl"] .\\32xl\\:pe-0{
    padding-left: 0;
  }

  [dir="ltr"] .\\32xl\\:ps-1{
    padding-left: 0.25rem;
  }

  [dir="rtl"] .\\32xl\\:ps-1{
    padding-right: 0.25rem;
  }

  [dir="ltr"] .\\32xl\\:pe-1{
    padding-right: 0.25rem;
  }

  [dir="rtl"] .\\32xl\\:pe-1{
    padding-left: 0.25rem;
  }

  [dir="ltr"] .\\32xl\\:ps-2{
    padding-left: 0.5rem;
  }

  [dir="rtl"] .\\32xl\\:ps-2{
    padding-right: 0.5rem;
  }

  [dir="ltr"] .\\32xl\\:pe-2{
    padding-right: 0.5rem;
  }

  [dir="rtl"] .\\32xl\\:pe-2{
    padding-left: 0.5rem;
  }

  [dir="ltr"] .\\32xl\\:ps-3{
    padding-left: 0.75rem;
  }

  [dir="rtl"] .\\32xl\\:ps-3{
    padding-right: 0.75rem;
  }

  [dir="ltr"] .\\32xl\\:pe-3{
    padding-right: 0.75rem;
  }

  [dir="rtl"] .\\32xl\\:pe-3{
    padding-left: 0.75rem;
  }

  [dir="ltr"] .\\32xl\\:ps-4{
    padding-left: 1rem;
  }

  [dir="rtl"] .\\32xl\\:ps-4{
    padding-right: 1rem;
  }

  [dir="ltr"] .\\32xl\\:pe-4{
    padding-right: 1rem;
  }

  [dir="rtl"] .\\32xl\\:pe-4{
    padding-left: 1rem;
  }

  [dir="ltr"] .\\32xl\\:ps-5{
    padding-left: 1.25rem;
  }

  [dir="rtl"] .\\32xl\\:ps-5{
    padding-right: 1.25rem;
  }

  [dir="ltr"] .\\32xl\\:pe-5{
    padding-right: 1.25rem;
  }

  [dir="rtl"] .\\32xl\\:pe-5{
    padding-left: 1.25rem;
  }

  [dir="ltr"] .\\32xl\\:ps-6{
    padding-left: 1.5rem;
  }

  [dir="rtl"] .\\32xl\\:ps-6{
    padding-right: 1.5rem;
  }

  [dir="ltr"] .\\32xl\\:pe-6{
    padding-right: 1.5rem;
  }

  [dir="rtl"] .\\32xl\\:pe-6{
    padding-left: 1.5rem;
  }

  [dir="ltr"] .\\32xl\\:ps-7{
    padding-left: 1.75rem;
  }

  [dir="rtl"] .\\32xl\\:ps-7{
    padding-right: 1.75rem;
  }

  [dir="ltr"] .\\32xl\\:pe-7{
    padding-right: 1.75rem;
  }

  [dir="rtl"] .\\32xl\\:pe-7{
    padding-left: 1.75rem;
  }

  [dir="ltr"] .\\32xl\\:ps-8{
    padding-left: 2rem;
  }

  [dir="rtl"] .\\32xl\\:ps-8{
    padding-right: 2rem;
  }

  [dir="ltr"] .\\32xl\\:pe-8{
    padding-right: 2rem;
  }

  [dir="rtl"] .\\32xl\\:pe-8{
    padding-left: 2rem;
  }

  [dir="ltr"] .\\32xl\\:ps-9{
    padding-left: 2.25rem;
  }

  [dir="rtl"] .\\32xl\\:ps-9{
    padding-right: 2.25rem;
  }

  [dir="ltr"] .\\32xl\\:pe-9{
    padding-right: 2.25rem;
  }

  [dir="rtl"] .\\32xl\\:pe-9{
    padding-left: 2.25rem;
  }

  [dir="ltr"] .\\32xl\\:ps-10{
    padding-left: 2.5rem;
  }

  [dir="rtl"] .\\32xl\\:ps-10{
    padding-right: 2.5rem;
  }

  [dir="ltr"] .\\32xl\\:pe-10{
    padding-right: 2.5rem;
  }

  [dir="rtl"] .\\32xl\\:pe-10{
    padding-left: 2.5rem;
  }

  [dir="ltr"] .\\32xl\\:ps-11{
    padding-left: 2.75rem;
  }

  [dir="rtl"] .\\32xl\\:ps-11{
    padding-right: 2.75rem;
  }

  [dir="ltr"] .\\32xl\\:pe-11{
    padding-right: 2.75rem;
  }

  [dir="rtl"] .\\32xl\\:pe-11{
    padding-left: 2.75rem;
  }

  [dir="ltr"] .\\32xl\\:ps-12{
    padding-left: 3rem;
  }

  [dir="rtl"] .\\32xl\\:ps-12{
    padding-right: 3rem;
  }

  [dir="ltr"] .\\32xl\\:pe-12{
    padding-right: 3rem;
  }

  [dir="rtl"] .\\32xl\\:pe-12{
    padding-left: 3rem;
  }

  [dir="ltr"] .\\32xl\\:ps-14{
    padding-left: 3.5rem;
  }

  [dir="rtl"] .\\32xl\\:ps-14{
    padding-right: 3.5rem;
  }

  [dir="ltr"] .\\32xl\\:pe-14{
    padding-right: 3.5rem;
  }

  [dir="rtl"] .\\32xl\\:pe-14{
    padding-left: 3.5rem;
  }

  [dir="ltr"] .\\32xl\\:ps-15{
    padding-left: 3.75rem;
  }

  [dir="rtl"] .\\32xl\\:ps-15{
    padding-right: 3.75rem;
  }

  [dir="ltr"] .\\32xl\\:pe-15{
    padding-right: 3.75rem;
  }

  [dir="rtl"] .\\32xl\\:pe-15{
    padding-left: 3.75rem;
  }

  [dir="ltr"] .\\32xl\\:ps-16{
    padding-left: 4rem;
  }

  [dir="rtl"] .\\32xl\\:ps-16{
    padding-right: 4rem;
  }

  [dir="ltr"] .\\32xl\\:pe-16{
    padding-right: 4rem;
  }

  [dir="rtl"] .\\32xl\\:pe-16{
    padding-left: 4rem;
  }

  [dir="ltr"] .\\32xl\\:ps-18{
    padding-left: 4.5rem;
  }

  [dir="rtl"] .\\32xl\\:ps-18{
    padding-right: 4.5rem;
  }

  [dir="ltr"] .\\32xl\\:pe-18{
    padding-right: 4.5rem;
  }

  [dir="rtl"] .\\32xl\\:pe-18{
    padding-left: 4.5rem;
  }

  [dir="ltr"] .\\32xl\\:ps-20{
    padding-left: 5rem;
  }

  [dir="rtl"] .\\32xl\\:ps-20{
    padding-right: 5rem;
  }

  [dir="ltr"] .\\32xl\\:pe-20{
    padding-right: 5rem;
  }

  [dir="rtl"] .\\32xl\\:pe-20{
    padding-left: 5rem;
  }

  [dir="ltr"] .\\32xl\\:ps-22{
    padding-left: 5.5rem;
  }

  [dir="rtl"] .\\32xl\\:ps-22{
    padding-right: 5.5rem;
  }

  [dir="ltr"] .\\32xl\\:pe-22{
    padding-right: 5.5rem;
  }

  [dir="rtl"] .\\32xl\\:pe-22{
    padding-left: 5.5rem;
  }

  [dir="ltr"] .\\32xl\\:ps-23{
    padding-left: 5.75rem;
  }

  [dir="rtl"] .\\32xl\\:ps-23{
    padding-right: 5.75rem;
  }

  [dir="ltr"] .\\32xl\\:pe-23{
    padding-right: 5.75rem;
  }

  [dir="rtl"] .\\32xl\\:pe-23{
    padding-left: 5.75rem;
  }

  [dir="ltr"] .\\32xl\\:ps-24{
    padding-left: 6rem;
  }

  [dir="rtl"] .\\32xl\\:ps-24{
    padding-right: 6rem;
  }

  [dir="ltr"] .\\32xl\\:pe-24{
    padding-right: 6rem;
  }

  [dir="rtl"] .\\32xl\\:pe-24{
    padding-left: 6rem;
  }

  [dir="ltr"] .\\32xl\\:ps-25{
    padding-left: 6.25rem;
  }

  [dir="rtl"] .\\32xl\\:ps-25{
    padding-right: 6.25rem;
  }

  [dir="ltr"] .\\32xl\\:pe-25{
    padding-right: 6.25rem;
  }

  [dir="rtl"] .\\32xl\\:pe-25{
    padding-left: 6.25rem;
  }

  [dir="ltr"] .\\32xl\\:ps-26{
    padding-left: 6.5rem;
  }

  [dir="rtl"] .\\32xl\\:ps-26{
    padding-right: 6.5rem;
  }

  [dir="ltr"] .\\32xl\\:pe-26{
    padding-right: 6.5rem;
  }

  [dir="rtl"] .\\32xl\\:pe-26{
    padding-left: 6.5rem;
  }

  [dir="ltr"] .\\32xl\\:ps-28{
    padding-left: 7rem;
  }

  [dir="rtl"] .\\32xl\\:ps-28{
    padding-right: 7rem;
  }

  [dir="ltr"] .\\32xl\\:pe-28{
    padding-right: 7rem;
  }

  [dir="rtl"] .\\32xl\\:pe-28{
    padding-left: 7rem;
  }

  [dir="ltr"] .\\32xl\\:ps-30{
    padding-left: 7.5rem;
  }

  [dir="rtl"] .\\32xl\\:ps-30{
    padding-right: 7.5rem;
  }

  [dir="ltr"] .\\32xl\\:pe-30{
    padding-right: 7.5rem;
  }

  [dir="rtl"] .\\32xl\\:pe-30{
    padding-left: 7.5rem;
  }

  [dir="ltr"] .\\32xl\\:ps-32{
    padding-left: 8rem;
  }

  [dir="rtl"] .\\32xl\\:ps-32{
    padding-right: 8rem;
  }

  [dir="ltr"] .\\32xl\\:pe-32{
    padding-right: 8rem;
  }

  [dir="rtl"] .\\32xl\\:pe-32{
    padding-left: 8rem;
  }

  [dir="ltr"] .\\32xl\\:ps-34{
    padding-left: 8.5rem;
  }

  [dir="rtl"] .\\32xl\\:ps-34{
    padding-right: 8.5rem;
  }

  [dir="ltr"] .\\32xl\\:pe-34{
    padding-right: 8.5rem;
  }

  [dir="rtl"] .\\32xl\\:pe-34{
    padding-left: 8.5rem;
  }

  [dir="ltr"] .\\32xl\\:ps-40{
    padding-left: 10rem;
  }

  [dir="rtl"] .\\32xl\\:ps-40{
    padding-right: 10rem;
  }

  [dir="ltr"] .\\32xl\\:pe-40{
    padding-right: 10rem;
  }

  [dir="rtl"] .\\32xl\\:pe-40{
    padding-left: 10rem;
  }

  [dir="ltr"] .\\32xl\\:ps-42{
    padding-left: 10.5rem;
  }

  [dir="rtl"] .\\32xl\\:ps-42{
    padding-right: 10.5rem;
  }

  [dir="ltr"] .\\32xl\\:pe-42{
    padding-right: 10.5rem;
  }

  [dir="rtl"] .\\32xl\\:pe-42{
    padding-left: 10.5rem;
  }

  [dir="ltr"] .\\32xl\\:ps-44{
    padding-left: 11rem;
  }

  [dir="rtl"] .\\32xl\\:ps-44{
    padding-right: 11rem;
  }

  [dir="ltr"] .\\32xl\\:pe-44{
    padding-right: 11rem;
  }

  [dir="rtl"] .\\32xl\\:pe-44{
    padding-left: 11rem;
  }

  [dir="ltr"] .\\32xl\\:ps-48{
    padding-left: 12rem;
  }

  [dir="rtl"] .\\32xl\\:ps-48{
    padding-right: 12rem;
  }

  [dir="ltr"] .\\32xl\\:pe-48{
    padding-right: 12rem;
  }

  [dir="rtl"] .\\32xl\\:pe-48{
    padding-left: 12rem;
  }

  [dir="ltr"] .\\32xl\\:ps-52{
    padding-left: 13rem;
  }

  [dir="rtl"] .\\32xl\\:ps-52{
    padding-right: 13rem;
  }

  [dir="ltr"] .\\32xl\\:pe-52{
    padding-right: 13rem;
  }

  [dir="rtl"] .\\32xl\\:pe-52{
    padding-left: 13rem;
  }

  [dir="ltr"] .\\32xl\\:ps-54{
    padding-left: 13.5rem;
  }

  [dir="rtl"] .\\32xl\\:ps-54{
    padding-right: 13.5rem;
  }

  [dir="ltr"] .\\32xl\\:pe-54{
    padding-right: 13.5rem;
  }

  [dir="rtl"] .\\32xl\\:pe-54{
    padding-left: 13.5rem;
  }

  [dir="ltr"] .\\32xl\\:ps-56{
    padding-left: 14rem;
  }

  [dir="rtl"] .\\32xl\\:ps-56{
    padding-right: 14rem;
  }

  [dir="ltr"] .\\32xl\\:pe-56{
    padding-right: 14rem;
  }

  [dir="rtl"] .\\32xl\\:pe-56{
    padding-left: 14rem;
  }

  [dir="ltr"] .\\32xl\\:ps-60{
    padding-left: 15rem;
  }

  [dir="rtl"] .\\32xl\\:ps-60{
    padding-right: 15rem;
  }

  [dir="ltr"] .\\32xl\\:pe-60{
    padding-right: 15rem;
  }

  [dir="rtl"] .\\32xl\\:pe-60{
    padding-left: 15rem;
  }

  [dir="ltr"] .\\32xl\\:ps-64{
    padding-left: 16rem;
  }

  [dir="rtl"] .\\32xl\\:ps-64{
    padding-right: 16rem;
  }

  [dir="ltr"] .\\32xl\\:pe-64{
    padding-right: 16rem;
  }

  [dir="rtl"] .\\32xl\\:pe-64{
    padding-left: 16rem;
  }

  [dir="ltr"] .\\32xl\\:ps-68{
    padding-left: 17rem;
  }

  [dir="rtl"] .\\32xl\\:ps-68{
    padding-right: 17rem;
  }

  [dir="ltr"] .\\32xl\\:pe-68{
    padding-right: 17rem;
  }

  [dir="rtl"] .\\32xl\\:pe-68{
    padding-left: 17rem;
  }

  [dir="ltr"] .\\32xl\\:ps-72{
    padding-left: 18rem;
  }

  [dir="rtl"] .\\32xl\\:ps-72{
    padding-right: 18rem;
  }

  [dir="ltr"] .\\32xl\\:pe-72{
    padding-right: 18rem;
  }

  [dir="rtl"] .\\32xl\\:pe-72{
    padding-left: 18rem;
  }

  [dir="ltr"] .\\32xl\\:ps-74{
    padding-left: 18.5rem;
  }

  [dir="rtl"] .\\32xl\\:ps-74{
    padding-right: 18.5rem;
  }

  [dir="ltr"] .\\32xl\\:pe-74{
    padding-right: 18.5rem;
  }

  [dir="rtl"] .\\32xl\\:pe-74{
    padding-left: 18.5rem;
  }

  [dir="ltr"] .\\32xl\\:ps-76{
    padding-left: 19rem;
  }

  [dir="rtl"] .\\32xl\\:ps-76{
    padding-right: 19rem;
  }

  [dir="ltr"] .\\32xl\\:pe-76{
    padding-right: 19rem;
  }

  [dir="rtl"] .\\32xl\\:pe-76{
    padding-left: 19rem;
  }

  [dir="ltr"] .\\32xl\\:ps-78{
    padding-left: 19.5rem;
  }

  [dir="rtl"] .\\32xl\\:ps-78{
    padding-right: 19.5rem;
  }

  [dir="ltr"] .\\32xl\\:pe-78{
    padding-right: 19.5rem;
  }

  [dir="rtl"] .\\32xl\\:pe-78{
    padding-left: 19.5rem;
  }

  [dir="ltr"] .\\32xl\\:ps-80{
    padding-left: 20rem;
  }

  [dir="rtl"] .\\32xl\\:ps-80{
    padding-right: 20rem;
  }

  [dir="ltr"] .\\32xl\\:pe-80{
    padding-right: 20rem;
  }

  [dir="rtl"] .\\32xl\\:pe-80{
    padding-left: 20rem;
  }

  [dir="ltr"] .\\32xl\\:ps-82{
    padding-left: 20.5rem;
  }

  [dir="rtl"] .\\32xl\\:ps-82{
    padding-right: 20.5rem;
  }

  [dir="ltr"] .\\32xl\\:pe-82{
    padding-right: 20.5rem;
  }

  [dir="rtl"] .\\32xl\\:pe-82{
    padding-left: 20.5rem;
  }

  [dir="ltr"] .\\32xl\\:ps-84{
    padding-left: 21rem;
  }

  [dir="rtl"] .\\32xl\\:ps-84{
    padding-right: 21rem;
  }

  [dir="ltr"] .\\32xl\\:pe-84{
    padding-right: 21rem;
  }

  [dir="rtl"] .\\32xl\\:pe-84{
    padding-left: 21rem;
  }

  [dir="ltr"] .\\32xl\\:ps-88{
    padding-left: 22rem;
  }

  [dir="rtl"] .\\32xl\\:ps-88{
    padding-right: 22rem;
  }

  [dir="ltr"] .\\32xl\\:pe-88{
    padding-right: 22rem;
  }

  [dir="rtl"] .\\32xl\\:pe-88{
    padding-left: 22rem;
  }

  [dir="ltr"] .\\32xl\\:ps-92{
    padding-left: 23rem;
  }

  [dir="rtl"] .\\32xl\\:ps-92{
    padding-right: 23rem;
  }

  [dir="ltr"] .\\32xl\\:pe-92{
    padding-right: 23rem;
  }

  [dir="rtl"] .\\32xl\\:pe-92{
    padding-left: 23rem;
  }

  [dir="ltr"] .\\32xl\\:ps-96{
    padding-left: 24rem;
  }

  [dir="rtl"] .\\32xl\\:ps-96{
    padding-right: 24rem;
  }

  [dir="ltr"] .\\32xl\\:pe-96{
    padding-right: 24rem;
  }

  [dir="rtl"] .\\32xl\\:pe-96{
    padding-left: 24rem;
  }

  [dir="ltr"] .\\32xl\\:ps-98{
    padding-left: 24.5rem;
  }

  [dir="rtl"] .\\32xl\\:ps-98{
    padding-right: 24.5rem;
  }

  [dir="ltr"] .\\32xl\\:pe-98{
    padding-right: 24.5rem;
  }

  [dir="rtl"] .\\32xl\\:pe-98{
    padding-left: 24.5rem;
  }

  [dir="ltr"] .\\32xl\\:ps-100{
    padding-left: 25rem;
  }

  [dir="rtl"] .\\32xl\\:ps-100{
    padding-right: 25rem;
  }

  [dir="ltr"] .\\32xl\\:pe-100{
    padding-right: 25rem;
  }

  [dir="rtl"] .\\32xl\\:pe-100{
    padding-left: 25rem;
  }

  [dir="ltr"] .\\32xl\\:ps-104{
    padding-left: 26rem;
  }

  [dir="rtl"] .\\32xl\\:ps-104{
    padding-right: 26rem;
  }

  [dir="ltr"] .\\32xl\\:pe-104{
    padding-right: 26rem;
  }

  [dir="rtl"] .\\32xl\\:pe-104{
    padding-left: 26rem;
  }

  [dir="ltr"] .\\32xl\\:ps-112{
    padding-left: 28rem;
  }

  [dir="rtl"] .\\32xl\\:ps-112{
    padding-right: 28rem;
  }

  [dir="ltr"] .\\32xl\\:pe-112{
    padding-right: 28rem;
  }

  [dir="rtl"] .\\32xl\\:pe-112{
    padding-left: 28rem;
  }

  [dir="ltr"] .\\32xl\\:ps-124{
    padding-left: 31rem;
  }

  [dir="rtl"] .\\32xl\\:ps-124{
    padding-right: 31rem;
  }

  [dir="ltr"] .\\32xl\\:pe-124{
    padding-right: 31rem;
  }

  [dir="rtl"] .\\32xl\\:pe-124{
    padding-left: 31rem;
  }

  [dir="ltr"] .\\32xl\\:ps-128{
    padding-left: 32rem;
  }

  [dir="rtl"] .\\32xl\\:ps-128{
    padding-right: 32rem;
  }

  [dir="ltr"] .\\32xl\\:pe-128{
    padding-right: 32rem;
  }

  [dir="rtl"] .\\32xl\\:pe-128{
    padding-left: 32rem;
  }

  [dir="ltr"] .\\32xl\\:ps-140{
    padding-left: 35rem;
  }

  [dir="rtl"] .\\32xl\\:ps-140{
    padding-right: 35rem;
  }

  [dir="ltr"] .\\32xl\\:pe-140{
    padding-right: 35rem;
  }

  [dir="rtl"] .\\32xl\\:pe-140{
    padding-left: 35rem;
  }

  [dir="ltr"] .\\32xl\\:ps-152{
    padding-left: 38rem;
  }

  [dir="rtl"] .\\32xl\\:ps-152{
    padding-right: 38rem;
  }

  [dir="ltr"] .\\32xl\\:pe-152{
    padding-right: 38rem;
  }

  [dir="rtl"] .\\32xl\\:pe-152{
    padding-left: 38rem;
  }

  [dir="ltr"] .\\32xl\\:ps-160{
    padding-left: 40rem;
  }

  [dir="rtl"] .\\32xl\\:ps-160{
    padding-right: 40rem;
  }

  [dir="ltr"] .\\32xl\\:pe-160{
    padding-right: 40rem;
  }

  [dir="rtl"] .\\32xl\\:pe-160{
    padding-left: 40rem;
  }

  [dir="ltr"] .\\32xl\\:ps-162{
    padding-left: 41rem;
  }

  [dir="rtl"] .\\32xl\\:ps-162{
    padding-right: 41rem;
  }

  [dir="ltr"] .\\32xl\\:pe-162{
    padding-right: 41rem;
  }

  [dir="rtl"] .\\32xl\\:pe-162{
    padding-left: 41rem;
  }

  [dir="ltr"] .\\32xl\\:ps-192{
    padding-left: 48rem;
  }

  [dir="rtl"] .\\32xl\\:ps-192{
    padding-right: 48rem;
  }

  [dir="ltr"] .\\32xl\\:pe-192{
    padding-right: 48rem;
  }

  [dir="rtl"] .\\32xl\\:pe-192{
    padding-left: 48rem;
  }

  [dir="ltr"] .\\32xl\\:ps-208{
    padding-left: 52rem;
  }

  [dir="rtl"] .\\32xl\\:ps-208{
    padding-right: 52rem;
  }

  [dir="ltr"] .\\32xl\\:pe-208{
    padding-right: 52rem;
  }

  [dir="rtl"] .\\32xl\\:pe-208{
    padding-left: 52rem;
  }

  [dir="ltr"] .\\32xl\\:ps-224{
    padding-left: 56rem;
  }

  [dir="rtl"] .\\32xl\\:ps-224{
    padding-right: 56rem;
  }

  [dir="ltr"] .\\32xl\\:pe-224{
    padding-right: 56rem;
  }

  [dir="rtl"] .\\32xl\\:pe-224{
    padding-left: 56rem;
  }

  [dir="ltr"] .\\32xl\\:ps-256{
    padding-left: 64rem;
  }

  [dir="rtl"] .\\32xl\\:ps-256{
    padding-right: 64rem;
  }

  [dir="ltr"] .\\32xl\\:pe-256{
    padding-right: 64rem;
  }

  [dir="rtl"] .\\32xl\\:pe-256{
    padding-left: 64rem;
  }

  [dir="ltr"] .\\32xl\\:ps-px{
    padding-left: 1px;
  }

  [dir="rtl"] .\\32xl\\:ps-px{
    padding-right: 1px;
  }

  [dir="ltr"] .\\32xl\\:pe-px{
    padding-right: 1px;
  }

  [dir="rtl"] .\\32xl\\:pe-px{
    padding-left: 1px;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-0:nth-child(odd){
    padding-left: 0;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-0:nth-child(odd){
    padding-right: 0;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-0:nth-child(odd){
    padding-right: 0;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-0:nth-child(odd){
    padding-left: 0;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-4:nth-child(odd){
    padding-left: 1rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-4:nth-child(odd){
    padding-right: 1rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-4:nth-child(odd){
    padding-right: 1rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-4:nth-child(odd){
    padding-left: 1rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-8:nth-child(odd){
    padding-left: 2rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-8:nth-child(odd){
    padding-right: 2rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-8:nth-child(odd){
    padding-right: 2rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-8:nth-child(odd){
    padding-left: 2rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-12:nth-child(odd){
    padding-left: 3rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-12:nth-child(odd){
    padding-right: 3rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-12:nth-child(odd){
    padding-right: 3rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-12:nth-child(odd){
    padding-left: 3rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-16:nth-child(odd){
    padding-left: 4rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-16:nth-child(odd){
    padding-right: 4rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-16:nth-child(odd){
    padding-right: 4rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-16:nth-child(odd){
    padding-left: 4rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-20:nth-child(odd){
    padding-left: 5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-20:nth-child(odd){
    padding-right: 5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-20:nth-child(odd){
    padding-right: 5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-20:nth-child(odd){
    padding-left: 5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-24:nth-child(odd){
    padding-left: 6rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-24:nth-child(odd){
    padding-right: 6rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-24:nth-child(odd){
    padding-right: 6rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-24:nth-child(odd){
    padding-left: 6rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-28:nth-child(odd){
    padding-left: 7rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-28:nth-child(odd){
    padding-right: 7rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-28:nth-child(odd){
    padding-right: 7rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-28:nth-child(odd){
    padding-left: 7rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-32:nth-child(odd){
    padding-left: 8rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-32:nth-child(odd){
    padding-right: 8rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-32:nth-child(odd){
    padding-right: 8rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-32:nth-child(odd){
    padding-left: 8rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-40:nth-child(odd){
    padding-left: 10rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-40:nth-child(odd){
    padding-right: 10rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-40:nth-child(odd){
    padding-right: 10rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-40:nth-child(odd){
    padding-left: 10rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-44:nth-child(odd){
    padding-left: 11rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-44:nth-child(odd){
    padding-right: 11rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-44:nth-child(odd){
    padding-right: 11rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-44:nth-child(odd){
    padding-left: 11rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-48:nth-child(odd){
    padding-left: 12rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-48:nth-child(odd){
    padding-right: 12rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-48:nth-child(odd){
    padding-right: 12rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-48:nth-child(odd){
    padding-left: 12rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-52:nth-child(odd){
    padding-left: 13rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-52:nth-child(odd){
    padding-right: 13rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-52:nth-child(odd){
    padding-right: 13rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-52:nth-child(odd){
    padding-left: 13rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-56:nth-child(odd){
    padding-left: 14rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-56:nth-child(odd){
    padding-right: 14rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-56:nth-child(odd){
    padding-right: 14rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-56:nth-child(odd){
    padding-left: 14rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-60:nth-child(odd){
    padding-left: 15rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-60:nth-child(odd){
    padding-right: 15rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-60:nth-child(odd){
    padding-right: 15rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-60:nth-child(odd){
    padding-left: 15rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-64:nth-child(odd){
    padding-left: 16rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-64:nth-child(odd){
    padding-right: 16rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-64:nth-child(odd){
    padding-right: 16rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-64:nth-child(odd){
    padding-left: 16rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-68:nth-child(odd){
    padding-left: 17rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-68:nth-child(odd){
    padding-right: 17rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-68:nth-child(odd){
    padding-right: 17rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-68:nth-child(odd){
    padding-left: 17rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-72:nth-child(odd){
    padding-left: 18rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-72:nth-child(odd){
    padding-right: 18rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-72:nth-child(odd){
    padding-right: 18rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-72:nth-child(odd){
    padding-left: 18rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-76:nth-child(odd){
    padding-left: 19rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-76:nth-child(odd){
    padding-right: 19rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-76:nth-child(odd){
    padding-right: 19rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-76:nth-child(odd){
    padding-left: 19rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-80:nth-child(odd){
    padding-left: 20rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-80:nth-child(odd){
    padding-right: 20rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-80:nth-child(odd){
    padding-right: 20rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-80:nth-child(odd){
    padding-left: 20rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-84:nth-child(odd){
    padding-left: 21rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-84:nth-child(odd){
    padding-right: 21rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-84:nth-child(odd){
    padding-right: 21rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-84:nth-child(odd){
    padding-left: 21rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-88:nth-child(odd){
    padding-left: 22rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-88:nth-child(odd){
    padding-right: 22rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-88:nth-child(odd){
    padding-right: 22rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-88:nth-child(odd){
    padding-left: 22rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-92:nth-child(odd){
    padding-left: 23rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-92:nth-child(odd){
    padding-right: 23rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-92:nth-child(odd){
    padding-right: 23rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-92:nth-child(odd){
    padding-left: 23rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-96:nth-child(odd){
    padding-left: 24rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-96:nth-child(odd){
    padding-right: 24rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-96:nth-child(odd){
    padding-right: 24rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-96:nth-child(odd){
    padding-left: 24rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-100:nth-child(odd){
    padding-left: 25rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-100:nth-child(odd){
    padding-right: 25rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-100:nth-child(odd){
    padding-right: 25rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-100:nth-child(odd){
    padding-left: 25rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-104:nth-child(odd){
    padding-left: 26rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-104:nth-child(odd){
    padding-right: 26rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-104:nth-child(odd){
    padding-right: 26rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-104:nth-child(odd){
    padding-left: 26rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-112:nth-child(odd){
    padding-left: 28rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-112:nth-child(odd){
    padding-right: 28rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-112:nth-child(odd){
    padding-right: 28rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-112:nth-child(odd){
    padding-left: 28rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-124:nth-child(odd){
    padding-left: 31rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-124:nth-child(odd){
    padding-right: 31rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-124:nth-child(odd){
    padding-right: 31rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-124:nth-child(odd){
    padding-left: 31rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-128:nth-child(odd){
    padding-left: 32rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-128:nth-child(odd){
    padding-right: 32rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-128:nth-child(odd){
    padding-right: 32rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-128:nth-child(odd){
    padding-left: 32rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-140:nth-child(odd){
    padding-left: 35rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-140:nth-child(odd){
    padding-right: 35rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-140:nth-child(odd){
    padding-right: 35rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-140:nth-child(odd){
    padding-left: 35rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-152:nth-child(odd){
    padding-left: 38rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-152:nth-child(odd){
    padding-right: 38rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-152:nth-child(odd){
    padding-right: 38rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-152:nth-child(odd){
    padding-left: 38rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-160:nth-child(odd){
    padding-left: 40rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-160:nth-child(odd){
    padding-right: 40rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-160:nth-child(odd){
    padding-right: 40rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-160:nth-child(odd){
    padding-left: 40rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-162:nth-child(odd){
    padding-left: 41rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-162:nth-child(odd){
    padding-right: 41rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-162:nth-child(odd){
    padding-right: 41rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-162:nth-child(odd){
    padding-left: 41rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-192:nth-child(odd){
    padding-left: 48rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-192:nth-child(odd){
    padding-right: 48rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-192:nth-child(odd){
    padding-right: 48rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-192:nth-child(odd){
    padding-left: 48rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-208:nth-child(odd){
    padding-left: 52rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-208:nth-child(odd){
    padding-right: 52rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-208:nth-child(odd){
    padding-right: 52rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-208:nth-child(odd){
    padding-left: 52rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-224:nth-child(odd){
    padding-left: 56rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-224:nth-child(odd){
    padding-right: 56rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-224:nth-child(odd){
    padding-right: 56rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-224:nth-child(odd){
    padding-left: 56rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-256:nth-child(odd){
    padding-left: 64rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-256:nth-child(odd){
    padding-right: 64rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-256:nth-child(odd){
    padding-right: 64rem;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-256:nth-child(odd){
    padding-left: 64rem;
  }

  [dir="ltr"] .\\32xl\\:odd\\:ps-px:nth-child(odd){
    padding-left: 1px;
  }

  [dir="rtl"] .\\32xl\\:odd\\:ps-px:nth-child(odd){
    padding-right: 1px;
  }

  [dir="ltr"] .\\32xl\\:odd\\:pe-px:nth-child(odd){
    padding-right: 1px;
  }

  [dir="rtl"] .\\32xl\\:odd\\:pe-px:nth-child(odd){
    padding-left: 1px;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-0:nth-child(even){
    padding-left: 0;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-0:nth-child(even){
    padding-right: 0;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-0:nth-child(even){
    padding-right: 0;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-0:nth-child(even){
    padding-left: 0;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-1:nth-child(even){
    padding-left: 0.25rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-1:nth-child(even){
    padding-right: 0.25rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-1:nth-child(even){
    padding-right: 0.25rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-1:nth-child(even){
    padding-left: 0.25rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-2:nth-child(even){
    padding-left: 0.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-2:nth-child(even){
    padding-right: 0.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-2:nth-child(even){
    padding-right: 0.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-2:nth-child(even){
    padding-left: 0.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-3:nth-child(even){
    padding-left: 0.75rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-3:nth-child(even){
    padding-right: 0.75rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-3:nth-child(even){
    padding-right: 0.75rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-3:nth-child(even){
    padding-left: 0.75rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-4:nth-child(even){
    padding-left: 1rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-4:nth-child(even){
    padding-right: 1rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-4:nth-child(even){
    padding-right: 1rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-4:nth-child(even){
    padding-left: 1rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-5:nth-child(even){
    padding-left: 1.25rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-5:nth-child(even){
    padding-right: 1.25rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-5:nth-child(even){
    padding-right: 1.25rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-5:nth-child(even){
    padding-left: 1.25rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-6:nth-child(even){
    padding-left: 1.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-6:nth-child(even){
    padding-right: 1.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-6:nth-child(even){
    padding-right: 1.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-6:nth-child(even){
    padding-left: 1.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-7:nth-child(even){
    padding-left: 1.75rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-7:nth-child(even){
    padding-right: 1.75rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-7:nth-child(even){
    padding-right: 1.75rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-7:nth-child(even){
    padding-left: 1.75rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-8:nth-child(even){
    padding-left: 2rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-8:nth-child(even){
    padding-right: 2rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-8:nth-child(even){
    padding-right: 2rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-8:nth-child(even){
    padding-left: 2rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-9:nth-child(even){
    padding-left: 2.25rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-9:nth-child(even){
    padding-right: 2.25rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-9:nth-child(even){
    padding-right: 2.25rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-9:nth-child(even){
    padding-left: 2.25rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-10:nth-child(even){
    padding-left: 2.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-10:nth-child(even){
    padding-right: 2.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-10:nth-child(even){
    padding-right: 2.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-10:nth-child(even){
    padding-left: 2.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-11:nth-child(even){
    padding-left: 2.75rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-11:nth-child(even){
    padding-right: 2.75rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-11:nth-child(even){
    padding-right: 2.75rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-11:nth-child(even){
    padding-left: 2.75rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-12:nth-child(even){
    padding-left: 3rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-12:nth-child(even){
    padding-right: 3rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-12:nth-child(even){
    padding-right: 3rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-12:nth-child(even){
    padding-left: 3rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-14:nth-child(even){
    padding-left: 3.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-14:nth-child(even){
    padding-right: 3.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-14:nth-child(even){
    padding-right: 3.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-14:nth-child(even){
    padding-left: 3.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-15:nth-child(even){
    padding-left: 3.75rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-15:nth-child(even){
    padding-right: 3.75rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-15:nth-child(even){
    padding-right: 3.75rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-15:nth-child(even){
    padding-left: 3.75rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-16:nth-child(even){
    padding-left: 4rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-16:nth-child(even){
    padding-right: 4rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-16:nth-child(even){
    padding-right: 4rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-16:nth-child(even){
    padding-left: 4rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-18:nth-child(even){
    padding-left: 4.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-18:nth-child(even){
    padding-right: 4.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-18:nth-child(even){
    padding-right: 4.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-18:nth-child(even){
    padding-left: 4.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-20:nth-child(even){
    padding-left: 5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-20:nth-child(even){
    padding-right: 5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-20:nth-child(even){
    padding-right: 5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-20:nth-child(even){
    padding-left: 5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-22:nth-child(even){
    padding-left: 5.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-22:nth-child(even){
    padding-right: 5.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-22:nth-child(even){
    padding-right: 5.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-22:nth-child(even){
    padding-left: 5.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-23:nth-child(even){
    padding-left: 5.75rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-23:nth-child(even){
    padding-right: 5.75rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-23:nth-child(even){
    padding-right: 5.75rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-23:nth-child(even){
    padding-left: 5.75rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-24:nth-child(even){
    padding-left: 6rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-24:nth-child(even){
    padding-right: 6rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-24:nth-child(even){
    padding-right: 6rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-24:nth-child(even){
    padding-left: 6rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-25:nth-child(even){
    padding-left: 6.25rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-25:nth-child(even){
    padding-right: 6.25rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-25:nth-child(even){
    padding-right: 6.25rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-25:nth-child(even){
    padding-left: 6.25rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-26:nth-child(even){
    padding-left: 6.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-26:nth-child(even){
    padding-right: 6.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-26:nth-child(even){
    padding-right: 6.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-26:nth-child(even){
    padding-left: 6.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-28:nth-child(even){
    padding-left: 7rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-28:nth-child(even){
    padding-right: 7rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-28:nth-child(even){
    padding-right: 7rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-28:nth-child(even){
    padding-left: 7rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-30:nth-child(even){
    padding-left: 7.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-30:nth-child(even){
    padding-right: 7.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-30:nth-child(even){
    padding-right: 7.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-30:nth-child(even){
    padding-left: 7.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-32:nth-child(even){
    padding-left: 8rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-32:nth-child(even){
    padding-right: 8rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-32:nth-child(even){
    padding-right: 8rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-32:nth-child(even){
    padding-left: 8rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-34:nth-child(even){
    padding-left: 8.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-34:nth-child(even){
    padding-right: 8.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-34:nth-child(even){
    padding-right: 8.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-34:nth-child(even){
    padding-left: 8.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-40:nth-child(even){
    padding-left: 10rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-40:nth-child(even){
    padding-right: 10rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-40:nth-child(even){
    padding-right: 10rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-40:nth-child(even){
    padding-left: 10rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-42:nth-child(even){
    padding-left: 10.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-42:nth-child(even){
    padding-right: 10.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-42:nth-child(even){
    padding-right: 10.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-42:nth-child(even){
    padding-left: 10.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-44:nth-child(even){
    padding-left: 11rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-44:nth-child(even){
    padding-right: 11rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-44:nth-child(even){
    padding-right: 11rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-44:nth-child(even){
    padding-left: 11rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-48:nth-child(even){
    padding-left: 12rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-48:nth-child(even){
    padding-right: 12rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-48:nth-child(even){
    padding-right: 12rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-48:nth-child(even){
    padding-left: 12rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-52:nth-child(even){
    padding-left: 13rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-52:nth-child(even){
    padding-right: 13rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-52:nth-child(even){
    padding-right: 13rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-52:nth-child(even){
    padding-left: 13rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-54:nth-child(even){
    padding-left: 13.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-54:nth-child(even){
    padding-right: 13.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-54:nth-child(even){
    padding-right: 13.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-54:nth-child(even){
    padding-left: 13.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-56:nth-child(even){
    padding-left: 14rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-56:nth-child(even){
    padding-right: 14rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-56:nth-child(even){
    padding-right: 14rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-56:nth-child(even){
    padding-left: 14rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-60:nth-child(even){
    padding-left: 15rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-60:nth-child(even){
    padding-right: 15rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-60:nth-child(even){
    padding-right: 15rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-60:nth-child(even){
    padding-left: 15rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-64:nth-child(even){
    padding-left: 16rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-64:nth-child(even){
    padding-right: 16rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-64:nth-child(even){
    padding-right: 16rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-64:nth-child(even){
    padding-left: 16rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-68:nth-child(even){
    padding-left: 17rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-68:nth-child(even){
    padding-right: 17rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-68:nth-child(even){
    padding-right: 17rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-68:nth-child(even){
    padding-left: 17rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-72:nth-child(even){
    padding-left: 18rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-72:nth-child(even){
    padding-right: 18rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-72:nth-child(even){
    padding-right: 18rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-72:nth-child(even){
    padding-left: 18rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-74:nth-child(even){
    padding-left: 18.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-74:nth-child(even){
    padding-right: 18.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-74:nth-child(even){
    padding-right: 18.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-74:nth-child(even){
    padding-left: 18.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-76:nth-child(even){
    padding-left: 19rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-76:nth-child(even){
    padding-right: 19rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-76:nth-child(even){
    padding-right: 19rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-76:nth-child(even){
    padding-left: 19rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-78:nth-child(even){
    padding-left: 19.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-78:nth-child(even){
    padding-right: 19.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-78:nth-child(even){
    padding-right: 19.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-78:nth-child(even){
    padding-left: 19.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-80:nth-child(even){
    padding-left: 20rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-80:nth-child(even){
    padding-right: 20rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-80:nth-child(even){
    padding-right: 20rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-80:nth-child(even){
    padding-left: 20rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-82:nth-child(even){
    padding-left: 20.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-82:nth-child(even){
    padding-right: 20.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-82:nth-child(even){
    padding-right: 20.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-82:nth-child(even){
    padding-left: 20.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-84:nth-child(even){
    padding-left: 21rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-84:nth-child(even){
    padding-right: 21rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-84:nth-child(even){
    padding-right: 21rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-84:nth-child(even){
    padding-left: 21rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-88:nth-child(even){
    padding-left: 22rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-88:nth-child(even){
    padding-right: 22rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-88:nth-child(even){
    padding-right: 22rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-88:nth-child(even){
    padding-left: 22rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-92:nth-child(even){
    padding-left: 23rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-92:nth-child(even){
    padding-right: 23rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-92:nth-child(even){
    padding-right: 23rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-92:nth-child(even){
    padding-left: 23rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-96:nth-child(even){
    padding-left: 24rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-96:nth-child(even){
    padding-right: 24rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-96:nth-child(even){
    padding-right: 24rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-96:nth-child(even){
    padding-left: 24rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-98:nth-child(even){
    padding-left: 24.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-98:nth-child(even){
    padding-right: 24.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-98:nth-child(even){
    padding-right: 24.5rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-98:nth-child(even){
    padding-left: 24.5rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-100:nth-child(even){
    padding-left: 25rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-100:nth-child(even){
    padding-right: 25rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-100:nth-child(even){
    padding-right: 25rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-100:nth-child(even){
    padding-left: 25rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-104:nth-child(even){
    padding-left: 26rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-104:nth-child(even){
    padding-right: 26rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-104:nth-child(even){
    padding-right: 26rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-104:nth-child(even){
    padding-left: 26rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-112:nth-child(even){
    padding-left: 28rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-112:nth-child(even){
    padding-right: 28rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-112:nth-child(even){
    padding-right: 28rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-112:nth-child(even){
    padding-left: 28rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-124:nth-child(even){
    padding-left: 31rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-124:nth-child(even){
    padding-right: 31rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-124:nth-child(even){
    padding-right: 31rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-124:nth-child(even){
    padding-left: 31rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-128:nth-child(even){
    padding-left: 32rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-128:nth-child(even){
    padding-right: 32rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-128:nth-child(even){
    padding-right: 32rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-128:nth-child(even){
    padding-left: 32rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-140:nth-child(even){
    padding-left: 35rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-140:nth-child(even){
    padding-right: 35rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-140:nth-child(even){
    padding-right: 35rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-140:nth-child(even){
    padding-left: 35rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-152:nth-child(even){
    padding-left: 38rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-152:nth-child(even){
    padding-right: 38rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-152:nth-child(even){
    padding-right: 38rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-152:nth-child(even){
    padding-left: 38rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-160:nth-child(even){
    padding-left: 40rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-160:nth-child(even){
    padding-right: 40rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-160:nth-child(even){
    padding-right: 40rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-160:nth-child(even){
    padding-left: 40rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-162:nth-child(even){
    padding-left: 41rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-162:nth-child(even){
    padding-right: 41rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-162:nth-child(even){
    padding-right: 41rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-162:nth-child(even){
    padding-left: 41rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-192:nth-child(even){
    padding-left: 48rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-192:nth-child(even){
    padding-right: 48rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-192:nth-child(even){
    padding-right: 48rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-192:nth-child(even){
    padding-left: 48rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-208:nth-child(even){
    padding-left: 52rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-208:nth-child(even){
    padding-right: 52rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-208:nth-child(even){
    padding-right: 52rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-208:nth-child(even){
    padding-left: 52rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-224:nth-child(even){
    padding-left: 56rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-224:nth-child(even){
    padding-right: 56rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-224:nth-child(even){
    padding-right: 56rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-224:nth-child(even){
    padding-left: 56rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-256:nth-child(even){
    padding-left: 64rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-256:nth-child(even){
    padding-right: 64rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-256:nth-child(even){
    padding-right: 64rem;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-256:nth-child(even){
    padding-left: 64rem;
  }

  [dir="ltr"] .\\32xl\\:even\\:ps-px:nth-child(even){
    padding-left: 1px;
  }

  [dir="rtl"] .\\32xl\\:even\\:ps-px:nth-child(even){
    padding-right: 1px;
  }

  [dir="ltr"] .\\32xl\\:even\\:pe-px:nth-child(even){
    padding-right: 1px;
  }

  [dir="rtl"] .\\32xl\\:even\\:pe-px:nth-child(even){
    padding-left: 1px;
  }

  [dir="ltr"] .\\32xl\\:ms-0{
    margin-left: 0;
  }

  [dir="rtl"] .\\32xl\\:ms-0{
    margin-right: 0;
  }

  [dir="ltr"] .\\32xl\\:me-0{
    margin-right: 0;
  }

  [dir="rtl"] .\\32xl\\:me-0{
    margin-left: 0;
  }

  [dir="ltr"] .\\32xl\\:ms-1{
    margin-left: 0.25rem;
  }

  [dir="rtl"] .\\32xl\\:ms-1{
    margin-right: 0.25rem;
  }

  [dir="ltr"] .\\32xl\\:me-1{
    margin-right: 0.25rem;
  }

  [dir="rtl"] .\\32xl\\:me-1{
    margin-left: 0.25rem;
  }

  [dir="ltr"] .\\32xl\\:ms-2{
    margin-left: 0.5rem;
  }

  [dir="rtl"] .\\32xl\\:ms-2{
    margin-right: 0.5rem;
  }

  [dir="ltr"] .\\32xl\\:me-2{
    margin-right: 0.5rem;
  }

  [dir="rtl"] .\\32xl\\:me-2{
    margin-left: 0.5rem;
  }

  [dir="ltr"] .\\32xl\\:ms-3{
    margin-left: 0.75rem;
  }

  [dir="rtl"] .\\32xl\\:ms-3{
    margin-right: 0.75rem;
  }

  [dir="ltr"] .\\32xl\\:me-3{
    margin-right: 0.75rem;
  }

  [dir="rtl"] .\\32xl\\:me-3{
    margin-left: 0.75rem;
  }

  [dir="ltr"] .\\32xl\\:ms-4{
    margin-left: 1rem;
  }

  [dir="rtl"] .\\32xl\\:ms-4{
    margin-right: 1rem;
  }

  [dir="ltr"] .\\32xl\\:me-4{
    margin-right: 1rem;
  }

  [dir="rtl"] .\\32xl\\:me-4{
    margin-left: 1rem;
  }

  [dir="ltr"] .\\32xl\\:ms-5{
    margin-left: 1.25rem;
  }

  [dir="rtl"] .\\32xl\\:ms-5{
    margin-right: 1.25rem;
  }

  [dir="ltr"] .\\32xl\\:me-5{
    margin-right: 1.25rem;
  }

  [dir="rtl"] .\\32xl\\:me-5{
    margin-left: 1.25rem;
  }

  [dir="ltr"] .\\32xl\\:ms-6{
    margin-left: 1.5rem;
  }

  [dir="rtl"] .\\32xl\\:ms-6{
    margin-right: 1.5rem;
  }

  [dir="ltr"] .\\32xl\\:me-6{
    margin-right: 1.5rem;
  }

  [dir="rtl"] .\\32xl\\:me-6{
    margin-left: 1.5rem;
  }

  [dir="ltr"] .\\32xl\\:ms-7{
    margin-left: 1.75rem;
  }

  [dir="rtl"] .\\32xl\\:ms-7{
    margin-right: 1.75rem;
  }

  [dir="ltr"] .\\32xl\\:me-7{
    margin-right: 1.75rem;
  }

  [dir="rtl"] .\\32xl\\:me-7{
    margin-left: 1.75rem;
  }

  [dir="ltr"] .\\32xl\\:ms-8{
    margin-left: 2rem;
  }

  [dir="rtl"] .\\32xl\\:ms-8{
    margin-right: 2rem;
  }

  [dir="ltr"] .\\32xl\\:me-8{
    margin-right: 2rem;
  }

  [dir="rtl"] .\\32xl\\:me-8{
    margin-left: 2rem;
  }

  [dir="ltr"] .\\32xl\\:ms-9{
    margin-left: 2.25rem;
  }

  [dir="rtl"] .\\32xl\\:ms-9{
    margin-right: 2.25rem;
  }

  [dir="ltr"] .\\32xl\\:me-9{
    margin-right: 2.25rem;
  }

  [dir="rtl"] .\\32xl\\:me-9{
    margin-left: 2.25rem;
  }

  [dir="ltr"] .\\32xl\\:ms-10{
    margin-left: 2.5rem;
  }

  [dir="rtl"] .\\32xl\\:ms-10{
    margin-right: 2.5rem;
  }

  [dir="ltr"] .\\32xl\\:me-10{
    margin-right: 2.5rem;
  }

  [dir="rtl"] .\\32xl\\:me-10{
    margin-left: 2.5rem;
  }

  [dir="ltr"] .\\32xl\\:ms-11{
    margin-left: 2.75rem;
  }

  [dir="rtl"] .\\32xl\\:ms-11{
    margin-right: 2.75rem;
  }

  [dir="ltr"] .\\32xl\\:me-11{
    margin-right: 2.75rem;
  }

  [dir="rtl"] .\\32xl\\:me-11{
    margin-left: 2.75rem;
  }

  [dir="ltr"] .\\32xl\\:ms-12{
    margin-left: 3rem;
  }

  [dir="rtl"] .\\32xl\\:ms-12{
    margin-right: 3rem;
  }

  [dir="ltr"] .\\32xl\\:me-12{
    margin-right: 3rem;
  }

  [dir="rtl"] .\\32xl\\:me-12{
    margin-left: 3rem;
  }

  [dir="ltr"] .\\32xl\\:ms-14{
    margin-left: 3.5rem;
  }

  [dir="rtl"] .\\32xl\\:ms-14{
    margin-right: 3.5rem;
  }

  [dir="ltr"] .\\32xl\\:me-14{
    margin-right: 3.5rem;
  }

  [dir="rtl"] .\\32xl\\:me-14{
    margin-left: 3.5rem;
  }

  [dir="ltr"] .\\32xl\\:ms-15{
    margin-left: 3.75rem;
  }

  [dir="rtl"] .\\32xl\\:ms-15{
    margin-right: 3.75rem;
  }

  [dir="ltr"] .\\32xl\\:me-15{
    margin-right: 3.75rem;
  }

  [dir="rtl"] .\\32xl\\:me-15{
    margin-left: 3.75rem;
  }

  [dir="ltr"] .\\32xl\\:ms-16{
    margin-left: 4rem;
  }

  [dir="rtl"] .\\32xl\\:ms-16{
    margin-right: 4rem;
  }

  [dir="ltr"] .\\32xl\\:me-16{
    margin-right: 4rem;
  }

  [dir="rtl"] .\\32xl\\:me-16{
    margin-left: 4rem;
  }

  [dir="ltr"] .\\32xl\\:ms-18{
    margin-left: 4.5rem;
  }

  [dir="rtl"] .\\32xl\\:ms-18{
    margin-right: 4.5rem;
  }

  [dir="ltr"] .\\32xl\\:me-18{
    margin-right: 4.5rem;
  }

  [dir="rtl"] .\\32xl\\:me-18{
    margin-left: 4.5rem;
  }

  [dir="ltr"] .\\32xl\\:ms-20{
    margin-left: 5rem;
  }

  [dir="rtl"] .\\32xl\\:ms-20{
    margin-right: 5rem;
  }

  [dir="ltr"] .\\32xl\\:me-20{
    margin-right: 5rem;
  }

  [dir="rtl"] .\\32xl\\:me-20{
    margin-left: 5rem;
  }

  [dir="ltr"] .\\32xl\\:ms-22{
    margin-left: 5.5rem;
  }

  [dir="rtl"] .\\32xl\\:ms-22{
    margin-right: 5.5rem;
  }

  [dir="ltr"] .\\32xl\\:me-22{
    margin-right: 5.5rem;
  }

  [dir="rtl"] .\\32xl\\:me-22{
    margin-left: 5.5rem;
  }

  [dir="ltr"] .\\32xl\\:ms-23{
    margin-left: 5.75rem;
  }

  [dir="rtl"] .\\32xl\\:ms-23{
    margin-right: 5.75rem;
  }

  [dir="ltr"] .\\32xl\\:me-23{
    margin-right: 5.75rem;
  }

  [dir="rtl"] .\\32xl\\:me-23{
    margin-left: 5.75rem;
  }

  [dir="ltr"] .\\32xl\\:ms-24{
    margin-left: 6rem;
  }

  [dir="rtl"] .\\32xl\\:ms-24{
    margin-right: 6rem;
  }

  [dir="ltr"] .\\32xl\\:me-24{
    margin-right: 6rem;
  }

  [dir="rtl"] .\\32xl\\:me-24{
    margin-left: 6rem;
  }

  [dir="ltr"] .\\32xl\\:ms-25{
    margin-left: 6.25rem;
  }

  [dir="rtl"] .\\32xl\\:ms-25{
    margin-right: 6.25rem;
  }

  [dir="ltr"] .\\32xl\\:me-25{
    margin-right: 6.25rem;
  }

  [dir="rtl"] .\\32xl\\:me-25{
    margin-left: 6.25rem;
  }

  [dir="ltr"] .\\32xl\\:ms-26{
    margin-left: 6.5rem;
  }

  [dir="rtl"] .\\32xl\\:ms-26{
    margin-right: 6.5rem;
  }

  [dir="ltr"] .\\32xl\\:me-26{
    margin-right: 6.5rem;
  }

  [dir="rtl"] .\\32xl\\:me-26{
    margin-left: 6.5rem;
  }

  [dir="ltr"] .\\32xl\\:ms-28{
    margin-left: 7rem;
  }

  [dir="rtl"] .\\32xl\\:ms-28{
    margin-right: 7rem;
  }

  [dir="ltr"] .\\32xl\\:me-28{
    margin-right: 7rem;
  }

  [dir="rtl"] .\\32xl\\:me-28{
    margin-left: 7rem;
  }

  [dir="ltr"] .\\32xl\\:ms-30{
    margin-left: 7.5rem;
  }

  [dir="rtl"] .\\32xl\\:ms-30{
    margin-right: 7.5rem;
  }

  [dir="ltr"] .\\32xl\\:me-30{
    margin-right: 7.5rem;
  }

  [dir="rtl"] .\\32xl\\:me-30{
    margin-left: 7.5rem;
  }

  [dir="ltr"] .\\32xl\\:ms-32{
    margin-left: 8rem;
  }

  [dir="rtl"] .\\32xl\\:ms-32{
    margin-right: 8rem;
  }

  [dir="ltr"] .\\32xl\\:me-32{
    margin-right: 8rem;
  }

  [dir="rtl"] .\\32xl\\:me-32{
    margin-left: 8rem;
  }

  [dir="ltr"] .\\32xl\\:ms-34{
    margin-left: 8.5rem;
  }

  [dir="rtl"] .\\32xl\\:ms-34{
    margin-right: 8.5rem;
  }

  [dir="ltr"] .\\32xl\\:me-34{
    margin-right: 8.5rem;
  }

  [dir="rtl"] .\\32xl\\:me-34{
    margin-left: 8.5rem;
  }

  [dir="ltr"] .\\32xl\\:ms-40{
    margin-left: 10rem;
  }

  [dir="rtl"] .\\32xl\\:ms-40{
    margin-right: 10rem;
  }

  [dir="ltr"] .\\32xl\\:me-40{
    margin-right: 10rem;
  }

  [dir="rtl"] .\\32xl\\:me-40{
    margin-left: 10rem;
  }

  [dir="ltr"] .\\32xl\\:ms-42{
    margin-left: 10.5rem;
  }

  [dir="rtl"] .\\32xl\\:ms-42{
    margin-right: 10.5rem;
  }

  [dir="ltr"] .\\32xl\\:me-42{
    margin-right: 10.5rem;
  }

  [dir="rtl"] .\\32xl\\:me-42{
    margin-left: 10.5rem;
  }

  [dir="ltr"] .\\32xl\\:ms-44{
    margin-left: 11rem;
  }

  [dir="rtl"] .\\32xl\\:ms-44{
    margin-right: 11rem;
  }

  [dir="ltr"] .\\32xl\\:me-44{
    margin-right: 11rem;
  }

  [dir="rtl"] .\\32xl\\:me-44{
    margin-left: 11rem;
  }

  [dir="ltr"] .\\32xl\\:ms-48{
    margin-left: 12rem;
  }

  [dir="rtl"] .\\32xl\\:ms-48{
    margin-right: 12rem;
  }

  [dir="ltr"] .\\32xl\\:me-48{
    margin-right: 12rem;
  }

  [dir="rtl"] .\\32xl\\:me-48{
    margin-left: 12rem;
  }

  [dir="ltr"] .\\32xl\\:ms-52{
    margin-left: 13rem;
  }

  [dir="rtl"] .\\32xl\\:ms-52{
    margin-right: 13rem;
  }

  [dir="ltr"] .\\32xl\\:me-52{
    margin-right: 13rem;
  }

  [dir="rtl"] .\\32xl\\:me-52{
    margin-left: 13rem;
  }

  [dir="ltr"] .\\32xl\\:ms-54{
    margin-left: 13.5rem;
  }

  [dir="rtl"] .\\32xl\\:ms-54{
    margin-right: 13.5rem;
  }

  [dir="ltr"] .\\32xl\\:me-54{
    margin-right: 13.5rem;
  }

  [dir="rtl"] .\\32xl\\:me-54{
    margin-left: 13.5rem;
  }

  [dir="ltr"] .\\32xl\\:ms-56{
    margin-left: 14rem;
  }

  [dir="rtl"] .\\32xl\\:ms-56{
    margin-right: 14rem;
  }

  [dir="ltr"] .\\32xl\\:me-56{
    margin-right: 14rem;
  }

  [dir="rtl"] .\\32xl\\:me-56{
    margin-left: 14rem;
  }

  [dir="ltr"] .\\32xl\\:ms-60{
    margin-left: 15rem;
  }

  [dir="rtl"] .\\32xl\\:ms-60{
    margin-right: 15rem;
  }

  [dir="ltr"] .\\32xl\\:me-60{
    margin-right: 15rem;
  }

  [dir="rtl"] .\\32xl\\:me-60{
    margin-left: 15rem;
  }

  [dir="ltr"] .\\32xl\\:ms-64{
    margin-left: 16rem;
  }

  [dir="rtl"] .\\32xl\\:ms-64{
    margin-right: 16rem;
  }

  [dir="ltr"] .\\32xl\\:me-64{
    margin-right: 16rem;
  }

  [dir="rtl"] .\\32xl\\:me-64{
    margin-left: 16rem;
  }

  [dir="ltr"] .\\32xl\\:ms-68{
    margin-left: 17rem;
  }

  [dir="rtl"] .\\32xl\\:ms-68{
    margin-right: 17rem;
  }

  [dir="ltr"] .\\32xl\\:me-68{
    margin-right: 17rem;
  }

  [dir="rtl"] .\\32xl\\:me-68{
    margin-left: 17rem;
  }

  [dir="ltr"] .\\32xl\\:ms-72{
    margin-left: 18rem;
  }

  [dir="rtl"] .\\32xl\\:ms-72{
    margin-right: 18rem;
  }

  [dir="ltr"] .\\32xl\\:me-72{
    margin-right: 18rem;
  }

  [dir="rtl"] .\\32xl\\:me-72{
    margin-left: 18rem;
  }

  [dir="ltr"] .\\32xl\\:ms-74{
    margin-left: 18.5rem;
  }

  [dir="rtl"] .\\32xl\\:ms-74{
    margin-right: 18.5rem;
  }

  [dir="ltr"] .\\32xl\\:me-74{
    margin-right: 18.5rem;
  }

  [dir="rtl"] .\\32xl\\:me-74{
    margin-left: 18.5rem;
  }

  [dir="ltr"] .\\32xl\\:ms-76{
    margin-left: 19rem;
  }

  [dir="rtl"] .\\32xl\\:ms-76{
    margin-right: 19rem;
  }

  [dir="ltr"] .\\32xl\\:me-76{
    margin-right: 19rem;
  }

  [dir="rtl"] .\\32xl\\:me-76{
    margin-left: 19rem;
  }

  [dir="ltr"] .\\32xl\\:ms-78{
    margin-left: 19.5rem;
  }

  [dir="rtl"] .\\32xl\\:ms-78{
    margin-right: 19.5rem;
  }

  [dir="ltr"] .\\32xl\\:me-78{
    margin-right: 19.5rem;
  }

  [dir="rtl"] .\\32xl\\:me-78{
    margin-left: 19.5rem;
  }

  [dir="ltr"] .\\32xl\\:ms-80{
    margin-left: 20rem;
  }

  [dir="rtl"] .\\32xl\\:ms-80{
    margin-right: 20rem;
  }

  [dir="ltr"] .\\32xl\\:me-80{
    margin-right: 20rem;
  }

  [dir="rtl"] .\\32xl\\:me-80{
    margin-left: 20rem;
  }

  [dir="ltr"] .\\32xl\\:ms-82{
    margin-left: 20.5rem;
  }

  [dir="rtl"] .\\32xl\\:ms-82{
    margin-right: 20.5rem;
  }

  [dir="ltr"] .\\32xl\\:me-82{
    margin-right: 20.5rem;
  }

  [dir="rtl"] .\\32xl\\:me-82{
    margin-left: 20.5rem;
  }

  [dir="ltr"] .\\32xl\\:ms-84{
    margin-left: 21rem;
  }

  [dir="rtl"] .\\32xl\\:ms-84{
    margin-right: 21rem;
  }

  [dir="ltr"] .\\32xl\\:me-84{
    margin-right: 21rem;
  }

  [dir="rtl"] .\\32xl\\:me-84{
    margin-left: 21rem;
  }

  [dir="ltr"] .\\32xl\\:ms-88{
    margin-left: 22rem;
  }

  [dir="rtl"] .\\32xl\\:ms-88{
    margin-right: 22rem;
  }

  [dir="ltr"] .\\32xl\\:me-88{
    margin-right: 22rem;
  }

  [dir="rtl"] .\\32xl\\:me-88{
    margin-left: 22rem;
  }

  [dir="ltr"] .\\32xl\\:ms-92{
    margin-left: 23rem;
  }

  [dir="rtl"] .\\32xl\\:ms-92{
    margin-right: 23rem;
  }

  [dir="ltr"] .\\32xl\\:me-92{
    margin-right: 23rem;
  }

  [dir="rtl"] .\\32xl\\:me-92{
    margin-left: 23rem;
  }

  [dir="ltr"] .\\32xl\\:ms-96{
    margin-left: 24rem;
  }

  [dir="rtl"] .\\32xl\\:ms-96{
    margin-right: 24rem;
  }

  [dir="ltr"] .\\32xl\\:me-96{
    margin-right: 24rem;
  }

  [dir="rtl"] .\\32xl\\:me-96{
    margin-left: 24rem;
  }

  [dir="ltr"] .\\32xl\\:ms-98{
    margin-left: 24.5rem;
  }

  [dir="rtl"] .\\32xl\\:ms-98{
    margin-right: 24.5rem;
  }

  [dir="ltr"] .\\32xl\\:me-98{
    margin-right: 24.5rem;
  }

  [dir="rtl"] .\\32xl\\:me-98{
    margin-left: 24.5rem;
  }

  [dir="ltr"] .\\32xl\\:ms-100{
    margin-left: 25rem;
  }

  [dir="rtl"] .\\32xl\\:ms-100{
    margin-right: 25rem;
  }

  [dir="ltr"] .\\32xl\\:me-100{
    margin-right: 25rem;
  }

  [dir="rtl"] .\\32xl\\:me-100{
    margin-left: 25rem;
  }

  [dir="ltr"] .\\32xl\\:ms-104{
    margin-left: 26rem;
  }

  [dir="rtl"] .\\32xl\\:ms-104{
    margin-right: 26rem;
  }

  [dir="ltr"] .\\32xl\\:me-104{
    margin-right: 26rem;
  }

  [dir="rtl"] .\\32xl\\:me-104{
    margin-left: 26rem;
  }

  [dir="ltr"] .\\32xl\\:ms-112{
    margin-left: 28rem;
  }

  [dir="rtl"] .\\32xl\\:ms-112{
    margin-right: 28rem;
  }

  [dir="ltr"] .\\32xl\\:me-112{
    margin-right: 28rem;
  }

  [dir="rtl"] .\\32xl\\:me-112{
    margin-left: 28rem;
  }

  [dir="ltr"] .\\32xl\\:ms-124{
    margin-left: 31rem;
  }

  [dir="rtl"] .\\32xl\\:ms-124{
    margin-right: 31rem;
  }

  [dir="ltr"] .\\32xl\\:me-124{
    margin-right: 31rem;
  }

  [dir="rtl"] .\\32xl\\:me-124{
    margin-left: 31rem;
  }

  [dir="ltr"] .\\32xl\\:ms-128{
    margin-left: 32rem;
  }

  [dir="rtl"] .\\32xl\\:ms-128{
    margin-right: 32rem;
  }

  [dir="ltr"] .\\32xl\\:me-128{
    margin-right: 32rem;
  }

  [dir="rtl"] .\\32xl\\:me-128{
    margin-left: 32rem;
  }

  [dir="ltr"] .\\32xl\\:ms-140{
    margin-left: 35rem;
  }

  [dir="rtl"] .\\32xl\\:ms-140{
    margin-right: 35rem;
  }

  [dir="ltr"] .\\32xl\\:me-140{
    margin-right: 35rem;
  }

  [dir="rtl"] .\\32xl\\:me-140{
    margin-left: 35rem;
  }

  [dir="ltr"] .\\32xl\\:ms-152{
    margin-left: 38rem;
  }

  [dir="rtl"] .\\32xl\\:ms-152{
    margin-right: 38rem;
  }

  [dir="ltr"] .\\32xl\\:me-152{
    margin-right: 38rem;
  }

  [dir="rtl"] .\\32xl\\:me-152{
    margin-left: 38rem;
  }

  [dir="ltr"] .\\32xl\\:ms-160{
    margin-left: 40rem;
  }

  [dir="rtl"] .\\32xl\\:ms-160{
    margin-right: 40rem;
  }

  [dir="ltr"] .\\32xl\\:me-160{
    margin-right: 40rem;
  }

  [dir="rtl"] .\\32xl\\:me-160{
    margin-left: 40rem;
  }

  [dir="ltr"] .\\32xl\\:ms-162{
    margin-left: 41rem;
  }

  [dir="rtl"] .\\32xl\\:ms-162{
    margin-right: 41rem;
  }

  [dir="ltr"] .\\32xl\\:me-162{
    margin-right: 41rem;
  }

  [dir="rtl"] .\\32xl\\:me-162{
    margin-left: 41rem;
  }

  [dir="ltr"] .\\32xl\\:ms-192{
    margin-left: 48rem;
  }

  [dir="rtl"] .\\32xl\\:ms-192{
    margin-right: 48rem;
  }

  [dir="ltr"] .\\32xl\\:me-192{
    margin-right: 48rem;
  }

  [dir="rtl"] .\\32xl\\:me-192{
    margin-left: 48rem;
  }

  [dir="ltr"] .\\32xl\\:ms-208{
    margin-left: 52rem;
  }

  [dir="rtl"] .\\32xl\\:ms-208{
    margin-right: 52rem;
  }

  [dir="ltr"] .\\32xl\\:me-208{
    margin-right: 52rem;
  }

  [dir="rtl"] .\\32xl\\:me-208{
    margin-left: 52rem;
  }

  [dir="ltr"] .\\32xl\\:ms-224{
    margin-left: 56rem;
  }

  [dir="rtl"] .\\32xl\\:ms-224{
    margin-right: 56rem;
  }

  [dir="ltr"] .\\32xl\\:me-224{
    margin-right: 56rem;
  }

  [dir="rtl"] .\\32xl\\:me-224{
    margin-left: 56rem;
  }

  [dir="ltr"] .\\32xl\\:ms-256{
    margin-left: 64rem;
  }

  [dir="rtl"] .\\32xl\\:ms-256{
    margin-right: 64rem;
  }

  [dir="ltr"] .\\32xl\\:me-256{
    margin-right: 64rem;
  }

  [dir="rtl"] .\\32xl\\:me-256{
    margin-left: 64rem;
  }

  [dir="ltr"] .\\32xl\\:ms-auto{
    margin-left: auto;
  }

  [dir="rtl"] .\\32xl\\:ms-auto{
    margin-right: auto;
  }

  [dir="ltr"] .\\32xl\\:me-auto{
    margin-right: auto;
  }

  [dir="rtl"] .\\32xl\\:me-auto{
    margin-left: auto;
  }

  [dir="ltr"] .\\32xl\\:ms-px{
    margin-left: 1px;
  }

  [dir="rtl"] .\\32xl\\:ms-px{
    margin-right: 1px;
  }

  [dir="ltr"] .\\32xl\\:me-px{
    margin-right: 1px;
  }

  [dir="rtl"] .\\32xl\\:me-px{
    margin-left: 1px;
  }

  [dir="ltr"] .\\32xl\\:-ms-1{
    margin-left: -0.25rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-1{
    margin-right: -0.25rem;
  }

  [dir="ltr"] .\\32xl\\:-me-1{
    margin-right: -0.25rem;
  }

  [dir="rtl"] .\\32xl\\:-me-1{
    margin-left: -0.25rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-2{
    margin-left: -0.5rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-2{
    margin-right: -0.5rem;
  }

  [dir="ltr"] .\\32xl\\:-me-2{
    margin-right: -0.5rem;
  }

  [dir="rtl"] .\\32xl\\:-me-2{
    margin-left: -0.5rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-3{
    margin-left: -0.75rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-3{
    margin-right: -0.75rem;
  }

  [dir="ltr"] .\\32xl\\:-me-3{
    margin-right: -0.75rem;
  }

  [dir="rtl"] .\\32xl\\:-me-3{
    margin-left: -0.75rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-4{
    margin-left: -1rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-4{
    margin-right: -1rem;
  }

  [dir="ltr"] .\\32xl\\:-me-4{
    margin-right: -1rem;
  }

  [dir="rtl"] .\\32xl\\:-me-4{
    margin-left: -1rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-5{
    margin-left: -1.25rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-5{
    margin-right: -1.25rem;
  }

  [dir="ltr"] .\\32xl\\:-me-5{
    margin-right: -1.25rem;
  }

  [dir="rtl"] .\\32xl\\:-me-5{
    margin-left: -1.25rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-6{
    margin-left: -1.5rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-6{
    margin-right: -1.5rem;
  }

  [dir="ltr"] .\\32xl\\:-me-6{
    margin-right: -1.5rem;
  }

  [dir="rtl"] .\\32xl\\:-me-6{
    margin-left: -1.5rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-7{
    margin-left: -1.75rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-7{
    margin-right: -1.75rem;
  }

  [dir="ltr"] .\\32xl\\:-me-7{
    margin-right: -1.75rem;
  }

  [dir="rtl"] .\\32xl\\:-me-7{
    margin-left: -1.75rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-8{
    margin-left: -2rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-8{
    margin-right: -2rem;
  }

  [dir="ltr"] .\\32xl\\:-me-8{
    margin-right: -2rem;
  }

  [dir="rtl"] .\\32xl\\:-me-8{
    margin-left: -2rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-9{
    margin-left: -2.25rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-9{
    margin-right: -2.25rem;
  }

  [dir="ltr"] .\\32xl\\:-me-9{
    margin-right: -2.25rem;
  }

  [dir="rtl"] .\\32xl\\:-me-9{
    margin-left: -2.25rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-10{
    margin-left: -2.5rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-10{
    margin-right: -2.5rem;
  }

  [dir="ltr"] .\\32xl\\:-me-10{
    margin-right: -2.5rem;
  }

  [dir="rtl"] .\\32xl\\:-me-10{
    margin-left: -2.5rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-11{
    margin-left: -2.75rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-11{
    margin-right: -2.75rem;
  }

  [dir="ltr"] .\\32xl\\:-me-11{
    margin-right: -2.75rem;
  }

  [dir="rtl"] .\\32xl\\:-me-11{
    margin-left: -2.75rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-12{
    margin-left: -3rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-12{
    margin-right: -3rem;
  }

  [dir="ltr"] .\\32xl\\:-me-12{
    margin-right: -3rem;
  }

  [dir="rtl"] .\\32xl\\:-me-12{
    margin-left: -3rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-14{
    margin-left: -3.5rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-14{
    margin-right: -3.5rem;
  }

  [dir="ltr"] .\\32xl\\:-me-14{
    margin-right: -3.5rem;
  }

  [dir="rtl"] .\\32xl\\:-me-14{
    margin-left: -3.5rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-15{
    margin-left: -3.75rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-15{
    margin-right: -3.75rem;
  }

  [dir="ltr"] .\\32xl\\:-me-15{
    margin-right: -3.75rem;
  }

  [dir="rtl"] .\\32xl\\:-me-15{
    margin-left: -3.75rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-16{
    margin-left: -4rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-16{
    margin-right: -4rem;
  }

  [dir="ltr"] .\\32xl\\:-me-16{
    margin-right: -4rem;
  }

  [dir="rtl"] .\\32xl\\:-me-16{
    margin-left: -4rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-18{
    margin-left: -4.5rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-18{
    margin-right: -4.5rem;
  }

  [dir="ltr"] .\\32xl\\:-me-18{
    margin-right: -4.5rem;
  }

  [dir="rtl"] .\\32xl\\:-me-18{
    margin-left: -4.5rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-20{
    margin-left: -5rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-20{
    margin-right: -5rem;
  }

  [dir="ltr"] .\\32xl\\:-me-20{
    margin-right: -5rem;
  }

  [dir="rtl"] .\\32xl\\:-me-20{
    margin-left: -5rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-22{
    margin-left: -5.5rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-22{
    margin-right: -5.5rem;
  }

  [dir="ltr"] .\\32xl\\:-me-22{
    margin-right: -5.5rem;
  }

  [dir="rtl"] .\\32xl\\:-me-22{
    margin-left: -5.5rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-23{
    margin-left: -5.75rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-23{
    margin-right: -5.75rem;
  }

  [dir="ltr"] .\\32xl\\:-me-23{
    margin-right: -5.75rem;
  }

  [dir="rtl"] .\\32xl\\:-me-23{
    margin-left: -5.75rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-24{
    margin-left: -6rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-24{
    margin-right: -6rem;
  }

  [dir="ltr"] .\\32xl\\:-me-24{
    margin-right: -6rem;
  }

  [dir="rtl"] .\\32xl\\:-me-24{
    margin-left: -6rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-25{
    margin-left: -6.25rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-25{
    margin-right: -6.25rem;
  }

  [dir="ltr"] .\\32xl\\:-me-25{
    margin-right: -6.25rem;
  }

  [dir="rtl"] .\\32xl\\:-me-25{
    margin-left: -6.25rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-26{
    margin-left: -6.5rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-26{
    margin-right: -6.5rem;
  }

  [dir="ltr"] .\\32xl\\:-me-26{
    margin-right: -6.5rem;
  }

  [dir="rtl"] .\\32xl\\:-me-26{
    margin-left: -6.5rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-28{
    margin-left: -7rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-28{
    margin-right: -7rem;
  }

  [dir="ltr"] .\\32xl\\:-me-28{
    margin-right: -7rem;
  }

  [dir="rtl"] .\\32xl\\:-me-28{
    margin-left: -7rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-30{
    margin-left: -7.5rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-30{
    margin-right: -7.5rem;
  }

  [dir="ltr"] .\\32xl\\:-me-30{
    margin-right: -7.5rem;
  }

  [dir="rtl"] .\\32xl\\:-me-30{
    margin-left: -7.5rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-32{
    margin-left: -8rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-32{
    margin-right: -8rem;
  }

  [dir="ltr"] .\\32xl\\:-me-32{
    margin-right: -8rem;
  }

  [dir="rtl"] .\\32xl\\:-me-32{
    margin-left: -8rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-34{
    margin-left: -8.5rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-34{
    margin-right: -8.5rem;
  }

  [dir="ltr"] .\\32xl\\:-me-34{
    margin-right: -8.5rem;
  }

  [dir="rtl"] .\\32xl\\:-me-34{
    margin-left: -8.5rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-40{
    margin-left: -10rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-40{
    margin-right: -10rem;
  }

  [dir="ltr"] .\\32xl\\:-me-40{
    margin-right: -10rem;
  }

  [dir="rtl"] .\\32xl\\:-me-40{
    margin-left: -10rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-42{
    margin-left: -10.5rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-42{
    margin-right: -10.5rem;
  }

  [dir="ltr"] .\\32xl\\:-me-42{
    margin-right: -10.5rem;
  }

  [dir="rtl"] .\\32xl\\:-me-42{
    margin-left: -10.5rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-44{
    margin-left: -11rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-44{
    margin-right: -11rem;
  }

  [dir="ltr"] .\\32xl\\:-me-44{
    margin-right: -11rem;
  }

  [dir="rtl"] .\\32xl\\:-me-44{
    margin-left: -11rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-48{
    margin-left: -12rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-48{
    margin-right: -12rem;
  }

  [dir="ltr"] .\\32xl\\:-me-48{
    margin-right: -12rem;
  }

  [dir="rtl"] .\\32xl\\:-me-48{
    margin-left: -12rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-52{
    margin-left: -13rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-52{
    margin-right: -13rem;
  }

  [dir="ltr"] .\\32xl\\:-me-52{
    margin-right: -13rem;
  }

  [dir="rtl"] .\\32xl\\:-me-52{
    margin-left: -13rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-54{
    margin-left: -13.5rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-54{
    margin-right: -13.5rem;
  }

  [dir="ltr"] .\\32xl\\:-me-54{
    margin-right: -13.5rem;
  }

  [dir="rtl"] .\\32xl\\:-me-54{
    margin-left: -13.5rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-56{
    margin-left: -14rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-56{
    margin-right: -14rem;
  }

  [dir="ltr"] .\\32xl\\:-me-56{
    margin-right: -14rem;
  }

  [dir="rtl"] .\\32xl\\:-me-56{
    margin-left: -14rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-60{
    margin-left: -15rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-60{
    margin-right: -15rem;
  }

  [dir="ltr"] .\\32xl\\:-me-60{
    margin-right: -15rem;
  }

  [dir="rtl"] .\\32xl\\:-me-60{
    margin-left: -15rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-64{
    margin-left: -16rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-64{
    margin-right: -16rem;
  }

  [dir="ltr"] .\\32xl\\:-me-64{
    margin-right: -16rem;
  }

  [dir="rtl"] .\\32xl\\:-me-64{
    margin-left: -16rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-68{
    margin-left: -17rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-68{
    margin-right: -17rem;
  }

  [dir="ltr"] .\\32xl\\:-me-68{
    margin-right: -17rem;
  }

  [dir="rtl"] .\\32xl\\:-me-68{
    margin-left: -17rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-72{
    margin-left: -18rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-72{
    margin-right: -18rem;
  }

  [dir="ltr"] .\\32xl\\:-me-72{
    margin-right: -18rem;
  }

  [dir="rtl"] .\\32xl\\:-me-72{
    margin-left: -18rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-74{
    margin-left: -18.5rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-74{
    margin-right: -18.5rem;
  }

  [dir="ltr"] .\\32xl\\:-me-74{
    margin-right: -18.5rem;
  }

  [dir="rtl"] .\\32xl\\:-me-74{
    margin-left: -18.5rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-76{
    margin-left: -19rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-76{
    margin-right: -19rem;
  }

  [dir="ltr"] .\\32xl\\:-me-76{
    margin-right: -19rem;
  }

  [dir="rtl"] .\\32xl\\:-me-76{
    margin-left: -19rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-78{
    margin-left: -19.5rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-78{
    margin-right: -19.5rem;
  }

  [dir="ltr"] .\\32xl\\:-me-78{
    margin-right: -19.5rem;
  }

  [dir="rtl"] .\\32xl\\:-me-78{
    margin-left: -19.5rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-80{
    margin-left: -20rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-80{
    margin-right: -20rem;
  }

  [dir="ltr"] .\\32xl\\:-me-80{
    margin-right: -20rem;
  }

  [dir="rtl"] .\\32xl\\:-me-80{
    margin-left: -20rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-82{
    margin-left: -20.5rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-82{
    margin-right: -20.5rem;
  }

  [dir="ltr"] .\\32xl\\:-me-82{
    margin-right: -20.5rem;
  }

  [dir="rtl"] .\\32xl\\:-me-82{
    margin-left: -20.5rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-84{
    margin-left: -21rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-84{
    margin-right: -21rem;
  }

  [dir="ltr"] .\\32xl\\:-me-84{
    margin-right: -21rem;
  }

  [dir="rtl"] .\\32xl\\:-me-84{
    margin-left: -21rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-88{
    margin-left: -22rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-88{
    margin-right: -22rem;
  }

  [dir="ltr"] .\\32xl\\:-me-88{
    margin-right: -22rem;
  }

  [dir="rtl"] .\\32xl\\:-me-88{
    margin-left: -22rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-92{
    margin-left: -23rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-92{
    margin-right: -23rem;
  }

  [dir="ltr"] .\\32xl\\:-me-92{
    margin-right: -23rem;
  }

  [dir="rtl"] .\\32xl\\:-me-92{
    margin-left: -23rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-96{
    margin-left: -24rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-96{
    margin-right: -24rem;
  }

  [dir="ltr"] .\\32xl\\:-me-96{
    margin-right: -24rem;
  }

  [dir="rtl"] .\\32xl\\:-me-96{
    margin-left: -24rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-98{
    margin-left: -24.5rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-98{
    margin-right: -24.5rem;
  }

  [dir="ltr"] .\\32xl\\:-me-98{
    margin-right: -24.5rem;
  }

  [dir="rtl"] .\\32xl\\:-me-98{
    margin-left: -24.5rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-100{
    margin-left: -25rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-100{
    margin-right: -25rem;
  }

  [dir="ltr"] .\\32xl\\:-me-100{
    margin-right: -25rem;
  }

  [dir="rtl"] .\\32xl\\:-me-100{
    margin-left: -25rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-104{
    margin-left: -26rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-104{
    margin-right: -26rem;
  }

  [dir="ltr"] .\\32xl\\:-me-104{
    margin-right: -26rem;
  }

  [dir="rtl"] .\\32xl\\:-me-104{
    margin-left: -26rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-112{
    margin-left: -28rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-112{
    margin-right: -28rem;
  }

  [dir="ltr"] .\\32xl\\:-me-112{
    margin-right: -28rem;
  }

  [dir="rtl"] .\\32xl\\:-me-112{
    margin-left: -28rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-124{
    margin-left: -31rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-124{
    margin-right: -31rem;
  }

  [dir="ltr"] .\\32xl\\:-me-124{
    margin-right: -31rem;
  }

  [dir="rtl"] .\\32xl\\:-me-124{
    margin-left: -31rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-128{
    margin-left: -32rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-128{
    margin-right: -32rem;
  }

  [dir="ltr"] .\\32xl\\:-me-128{
    margin-right: -32rem;
  }

  [dir="rtl"] .\\32xl\\:-me-128{
    margin-left: -32rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-140{
    margin-left: -35rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-140{
    margin-right: -35rem;
  }

  [dir="ltr"] .\\32xl\\:-me-140{
    margin-right: -35rem;
  }

  [dir="rtl"] .\\32xl\\:-me-140{
    margin-left: -35rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-152{
    margin-left: -38rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-152{
    margin-right: -38rem;
  }

  [dir="ltr"] .\\32xl\\:-me-152{
    margin-right: -38rem;
  }

  [dir="rtl"] .\\32xl\\:-me-152{
    margin-left: -38rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-160{
    margin-left: -40rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-160{
    margin-right: -40rem;
  }

  [dir="ltr"] .\\32xl\\:-me-160{
    margin-right: -40rem;
  }

  [dir="rtl"] .\\32xl\\:-me-160{
    margin-left: -40rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-162{
    margin-left: -41rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-162{
    margin-right: -41rem;
  }

  [dir="ltr"] .\\32xl\\:-me-162{
    margin-right: -41rem;
  }

  [dir="rtl"] .\\32xl\\:-me-162{
    margin-left: -41rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-192{
    margin-left: -48rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-192{
    margin-right: -48rem;
  }

  [dir="ltr"] .\\32xl\\:-me-192{
    margin-right: -48rem;
  }

  [dir="rtl"] .\\32xl\\:-me-192{
    margin-left: -48rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-208{
    margin-left: -52rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-208{
    margin-right: -52rem;
  }

  [dir="ltr"] .\\32xl\\:-me-208{
    margin-right: -52rem;
  }

  [dir="rtl"] .\\32xl\\:-me-208{
    margin-left: -52rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-224{
    margin-left: -56rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-224{
    margin-right: -56rem;
  }

  [dir="ltr"] .\\32xl\\:-me-224{
    margin-right: -56rem;
  }

  [dir="rtl"] .\\32xl\\:-me-224{
    margin-left: -56rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-256{
    margin-left: -64rem;
  }

  [dir="rtl"] .\\32xl\\:-ms-256{
    margin-right: -64rem;
  }

  [dir="ltr"] .\\32xl\\:-me-256{
    margin-right: -64rem;
  }

  [dir="rtl"] .\\32xl\\:-me-256{
    margin-left: -64rem;
  }

  [dir="ltr"] .\\32xl\\:-ms-px{
    margin-left: -1px;
  }

  [dir="rtl"] .\\32xl\\:-ms-px{
    margin-right: -1px;
  }

  [dir="ltr"] .\\32xl\\:-me-px{
    margin-right: -1px;
  }

  [dir="rtl"] .\\32xl\\:-me-px{
    margin-left: -1px;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-0:first-child{
    margin-left: 0;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-0:first-child{
    margin-right: 0;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-0:first-child{
    margin-right: 0;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-0:first-child{
    margin-left: 0;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-1:first-child{
    margin-left: 0.25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-1:first-child{
    margin-right: 0.25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-1:first-child{
    margin-right: 0.25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-1:first-child{
    margin-left: 0.25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-2:first-child{
    margin-left: 0.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-2:first-child{
    margin-right: 0.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-2:first-child{
    margin-right: 0.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-2:first-child{
    margin-left: 0.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-3:first-child{
    margin-left: 0.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-3:first-child{
    margin-right: 0.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-3:first-child{
    margin-right: 0.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-3:first-child{
    margin-left: 0.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-4:first-child{
    margin-left: 1rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-4:first-child{
    margin-right: 1rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-4:first-child{
    margin-right: 1rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-4:first-child{
    margin-left: 1rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-5:first-child{
    margin-left: 1.25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-5:first-child{
    margin-right: 1.25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-5:first-child{
    margin-right: 1.25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-5:first-child{
    margin-left: 1.25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-6:first-child{
    margin-left: 1.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-6:first-child{
    margin-right: 1.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-6:first-child{
    margin-right: 1.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-6:first-child{
    margin-left: 1.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-7:first-child{
    margin-left: 1.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-7:first-child{
    margin-right: 1.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-7:first-child{
    margin-right: 1.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-7:first-child{
    margin-left: 1.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-8:first-child{
    margin-left: 2rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-8:first-child{
    margin-right: 2rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-8:first-child{
    margin-right: 2rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-8:first-child{
    margin-left: 2rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-9:first-child{
    margin-left: 2.25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-9:first-child{
    margin-right: 2.25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-9:first-child{
    margin-right: 2.25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-9:first-child{
    margin-left: 2.25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-10:first-child{
    margin-left: 2.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-10:first-child{
    margin-right: 2.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-10:first-child{
    margin-right: 2.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-10:first-child{
    margin-left: 2.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-11:first-child{
    margin-left: 2.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-11:first-child{
    margin-right: 2.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-11:first-child{
    margin-right: 2.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-11:first-child{
    margin-left: 2.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-12:first-child{
    margin-left: 3rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-12:first-child{
    margin-right: 3rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-12:first-child{
    margin-right: 3rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-12:first-child{
    margin-left: 3rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-14:first-child{
    margin-left: 3.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-14:first-child{
    margin-right: 3.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-14:first-child{
    margin-right: 3.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-14:first-child{
    margin-left: 3.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-15:first-child{
    margin-left: 3.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-15:first-child{
    margin-right: 3.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-15:first-child{
    margin-right: 3.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-15:first-child{
    margin-left: 3.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-16:first-child{
    margin-left: 4rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-16:first-child{
    margin-right: 4rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-16:first-child{
    margin-right: 4rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-16:first-child{
    margin-left: 4rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-18:first-child{
    margin-left: 4.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-18:first-child{
    margin-right: 4.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-18:first-child{
    margin-right: 4.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-18:first-child{
    margin-left: 4.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-20:first-child{
    margin-left: 5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-20:first-child{
    margin-right: 5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-20:first-child{
    margin-right: 5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-20:first-child{
    margin-left: 5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-22:first-child{
    margin-left: 5.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-22:first-child{
    margin-right: 5.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-22:first-child{
    margin-right: 5.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-22:first-child{
    margin-left: 5.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-23:first-child{
    margin-left: 5.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-23:first-child{
    margin-right: 5.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-23:first-child{
    margin-right: 5.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-23:first-child{
    margin-left: 5.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-24:first-child{
    margin-left: 6rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-24:first-child{
    margin-right: 6rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-24:first-child{
    margin-right: 6rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-24:first-child{
    margin-left: 6rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-25:first-child{
    margin-left: 6.25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-25:first-child{
    margin-right: 6.25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-25:first-child{
    margin-right: 6.25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-25:first-child{
    margin-left: 6.25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-26:first-child{
    margin-left: 6.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-26:first-child{
    margin-right: 6.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-26:first-child{
    margin-right: 6.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-26:first-child{
    margin-left: 6.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-28:first-child{
    margin-left: 7rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-28:first-child{
    margin-right: 7rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-28:first-child{
    margin-right: 7rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-28:first-child{
    margin-left: 7rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-30:first-child{
    margin-left: 7.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-30:first-child{
    margin-right: 7.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-30:first-child{
    margin-right: 7.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-30:first-child{
    margin-left: 7.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-32:first-child{
    margin-left: 8rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-32:first-child{
    margin-right: 8rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-32:first-child{
    margin-right: 8rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-32:first-child{
    margin-left: 8rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-34:first-child{
    margin-left: 8.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-34:first-child{
    margin-right: 8.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-34:first-child{
    margin-right: 8.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-34:first-child{
    margin-left: 8.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-40:first-child{
    margin-left: 10rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-40:first-child{
    margin-right: 10rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-40:first-child{
    margin-right: 10rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-40:first-child{
    margin-left: 10rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-42:first-child{
    margin-left: 10.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-42:first-child{
    margin-right: 10.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-42:first-child{
    margin-right: 10.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-42:first-child{
    margin-left: 10.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-44:first-child{
    margin-left: 11rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-44:first-child{
    margin-right: 11rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-44:first-child{
    margin-right: 11rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-44:first-child{
    margin-left: 11rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-48:first-child{
    margin-left: 12rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-48:first-child{
    margin-right: 12rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-48:first-child{
    margin-right: 12rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-48:first-child{
    margin-left: 12rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-52:first-child{
    margin-left: 13rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-52:first-child{
    margin-right: 13rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-52:first-child{
    margin-right: 13rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-52:first-child{
    margin-left: 13rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-54:first-child{
    margin-left: 13.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-54:first-child{
    margin-right: 13.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-54:first-child{
    margin-right: 13.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-54:first-child{
    margin-left: 13.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-56:first-child{
    margin-left: 14rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-56:first-child{
    margin-right: 14rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-56:first-child{
    margin-right: 14rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-56:first-child{
    margin-left: 14rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-60:first-child{
    margin-left: 15rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-60:first-child{
    margin-right: 15rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-60:first-child{
    margin-right: 15rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-60:first-child{
    margin-left: 15rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-64:first-child{
    margin-left: 16rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-64:first-child{
    margin-right: 16rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-64:first-child{
    margin-right: 16rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-64:first-child{
    margin-left: 16rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-68:first-child{
    margin-left: 17rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-68:first-child{
    margin-right: 17rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-68:first-child{
    margin-right: 17rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-68:first-child{
    margin-left: 17rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-72:first-child{
    margin-left: 18rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-72:first-child{
    margin-right: 18rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-72:first-child{
    margin-right: 18rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-72:first-child{
    margin-left: 18rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-74:first-child{
    margin-left: 18.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-74:first-child{
    margin-right: 18.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-74:first-child{
    margin-right: 18.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-74:first-child{
    margin-left: 18.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-76:first-child{
    margin-left: 19rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-76:first-child{
    margin-right: 19rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-76:first-child{
    margin-right: 19rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-76:first-child{
    margin-left: 19rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-78:first-child{
    margin-left: 19.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-78:first-child{
    margin-right: 19.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-78:first-child{
    margin-right: 19.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-78:first-child{
    margin-left: 19.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-80:first-child{
    margin-left: 20rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-80:first-child{
    margin-right: 20rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-80:first-child{
    margin-right: 20rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-80:first-child{
    margin-left: 20rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-82:first-child{
    margin-left: 20.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-82:first-child{
    margin-right: 20.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-82:first-child{
    margin-right: 20.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-82:first-child{
    margin-left: 20.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-84:first-child{
    margin-left: 21rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-84:first-child{
    margin-right: 21rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-84:first-child{
    margin-right: 21rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-84:first-child{
    margin-left: 21rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-88:first-child{
    margin-left: 22rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-88:first-child{
    margin-right: 22rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-88:first-child{
    margin-right: 22rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-88:first-child{
    margin-left: 22rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-92:first-child{
    margin-left: 23rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-92:first-child{
    margin-right: 23rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-92:first-child{
    margin-right: 23rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-92:first-child{
    margin-left: 23rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-96:first-child{
    margin-left: 24rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-96:first-child{
    margin-right: 24rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-96:first-child{
    margin-right: 24rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-96:first-child{
    margin-left: 24rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-98:first-child{
    margin-left: 24.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-98:first-child{
    margin-right: 24.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-98:first-child{
    margin-right: 24.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-98:first-child{
    margin-left: 24.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-100:first-child{
    margin-left: 25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-100:first-child{
    margin-right: 25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-100:first-child{
    margin-right: 25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-100:first-child{
    margin-left: 25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-104:first-child{
    margin-left: 26rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-104:first-child{
    margin-right: 26rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-104:first-child{
    margin-right: 26rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-104:first-child{
    margin-left: 26rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-112:first-child{
    margin-left: 28rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-112:first-child{
    margin-right: 28rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-112:first-child{
    margin-right: 28rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-112:first-child{
    margin-left: 28rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-124:first-child{
    margin-left: 31rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-124:first-child{
    margin-right: 31rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-124:first-child{
    margin-right: 31rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-124:first-child{
    margin-left: 31rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-128:first-child{
    margin-left: 32rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-128:first-child{
    margin-right: 32rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-128:first-child{
    margin-right: 32rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-128:first-child{
    margin-left: 32rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-140:first-child{
    margin-left: 35rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-140:first-child{
    margin-right: 35rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-140:first-child{
    margin-right: 35rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-140:first-child{
    margin-left: 35rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-152:first-child{
    margin-left: 38rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-152:first-child{
    margin-right: 38rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-152:first-child{
    margin-right: 38rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-152:first-child{
    margin-left: 38rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-160:first-child{
    margin-left: 40rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-160:first-child{
    margin-right: 40rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-160:first-child{
    margin-right: 40rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-160:first-child{
    margin-left: 40rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-162:first-child{
    margin-left: 41rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-162:first-child{
    margin-right: 41rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-162:first-child{
    margin-right: 41rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-162:first-child{
    margin-left: 41rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-192:first-child{
    margin-left: 48rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-192:first-child{
    margin-right: 48rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-192:first-child{
    margin-right: 48rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-192:first-child{
    margin-left: 48rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-208:first-child{
    margin-left: 52rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-208:first-child{
    margin-right: 52rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-208:first-child{
    margin-right: 52rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-208:first-child{
    margin-left: 52rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-224:first-child{
    margin-left: 56rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-224:first-child{
    margin-right: 56rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-224:first-child{
    margin-right: 56rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-224:first-child{
    margin-left: 56rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-256:first-child{
    margin-left: 64rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-256:first-child{
    margin-right: 64rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-256:first-child{
    margin-right: 64rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-256:first-child{
    margin-left: 64rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-auto:first-child{
    margin-left: auto;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-auto:first-child{
    margin-right: auto;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-auto:first-child{
    margin-right: auto;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-auto:first-child{
    margin-left: auto;
  }

  [dir="ltr"] .\\32xl\\:first\\:ms-px:first-child{
    margin-left: 1px;
  }

  [dir="rtl"] .\\32xl\\:first\\:ms-px:first-child{
    margin-right: 1px;
  }

  [dir="ltr"] .\\32xl\\:first\\:me-px:first-child{
    margin-right: 1px;
  }

  [dir="rtl"] .\\32xl\\:first\\:me-px:first-child{
    margin-left: 1px;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-1:first-child{
    margin-left: -0.25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-1:first-child{
    margin-right: -0.25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-1:first-child{
    margin-right: -0.25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-1:first-child{
    margin-left: -0.25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-2:first-child{
    margin-left: -0.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-2:first-child{
    margin-right: -0.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-2:first-child{
    margin-right: -0.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-2:first-child{
    margin-left: -0.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-3:first-child{
    margin-left: -0.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-3:first-child{
    margin-right: -0.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-3:first-child{
    margin-right: -0.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-3:first-child{
    margin-left: -0.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-4:first-child{
    margin-left: -1rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-4:first-child{
    margin-right: -1rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-4:first-child{
    margin-right: -1rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-4:first-child{
    margin-left: -1rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-5:first-child{
    margin-left: -1.25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-5:first-child{
    margin-right: -1.25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-5:first-child{
    margin-right: -1.25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-5:first-child{
    margin-left: -1.25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-6:first-child{
    margin-left: -1.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-6:first-child{
    margin-right: -1.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-6:first-child{
    margin-right: -1.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-6:first-child{
    margin-left: -1.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-7:first-child{
    margin-left: -1.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-7:first-child{
    margin-right: -1.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-7:first-child{
    margin-right: -1.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-7:first-child{
    margin-left: -1.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-8:first-child{
    margin-left: -2rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-8:first-child{
    margin-right: -2rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-8:first-child{
    margin-right: -2rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-8:first-child{
    margin-left: -2rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-9:first-child{
    margin-left: -2.25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-9:first-child{
    margin-right: -2.25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-9:first-child{
    margin-right: -2.25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-9:first-child{
    margin-left: -2.25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-10:first-child{
    margin-left: -2.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-10:first-child{
    margin-right: -2.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-10:first-child{
    margin-right: -2.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-10:first-child{
    margin-left: -2.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-11:first-child{
    margin-left: -2.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-11:first-child{
    margin-right: -2.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-11:first-child{
    margin-right: -2.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-11:first-child{
    margin-left: -2.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-12:first-child{
    margin-left: -3rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-12:first-child{
    margin-right: -3rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-12:first-child{
    margin-right: -3rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-12:first-child{
    margin-left: -3rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-14:first-child{
    margin-left: -3.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-14:first-child{
    margin-right: -3.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-14:first-child{
    margin-right: -3.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-14:first-child{
    margin-left: -3.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-15:first-child{
    margin-left: -3.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-15:first-child{
    margin-right: -3.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-15:first-child{
    margin-right: -3.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-15:first-child{
    margin-left: -3.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-16:first-child{
    margin-left: -4rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-16:first-child{
    margin-right: -4rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-16:first-child{
    margin-right: -4rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-16:first-child{
    margin-left: -4rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-18:first-child{
    margin-left: -4.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-18:first-child{
    margin-right: -4.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-18:first-child{
    margin-right: -4.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-18:first-child{
    margin-left: -4.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-20:first-child{
    margin-left: -5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-20:first-child{
    margin-right: -5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-20:first-child{
    margin-right: -5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-20:first-child{
    margin-left: -5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-22:first-child{
    margin-left: -5.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-22:first-child{
    margin-right: -5.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-22:first-child{
    margin-right: -5.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-22:first-child{
    margin-left: -5.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-23:first-child{
    margin-left: -5.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-23:first-child{
    margin-right: -5.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-23:first-child{
    margin-right: -5.75rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-23:first-child{
    margin-left: -5.75rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-24:first-child{
    margin-left: -6rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-24:first-child{
    margin-right: -6rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-24:first-child{
    margin-right: -6rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-24:first-child{
    margin-left: -6rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-25:first-child{
    margin-left: -6.25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-25:first-child{
    margin-right: -6.25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-25:first-child{
    margin-right: -6.25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-25:first-child{
    margin-left: -6.25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-26:first-child{
    margin-left: -6.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-26:first-child{
    margin-right: -6.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-26:first-child{
    margin-right: -6.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-26:first-child{
    margin-left: -6.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-28:first-child{
    margin-left: -7rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-28:first-child{
    margin-right: -7rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-28:first-child{
    margin-right: -7rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-28:first-child{
    margin-left: -7rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-30:first-child{
    margin-left: -7.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-30:first-child{
    margin-right: -7.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-30:first-child{
    margin-right: -7.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-30:first-child{
    margin-left: -7.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-32:first-child{
    margin-left: -8rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-32:first-child{
    margin-right: -8rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-32:first-child{
    margin-right: -8rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-32:first-child{
    margin-left: -8rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-34:first-child{
    margin-left: -8.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-34:first-child{
    margin-right: -8.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-34:first-child{
    margin-right: -8.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-34:first-child{
    margin-left: -8.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-40:first-child{
    margin-left: -10rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-40:first-child{
    margin-right: -10rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-40:first-child{
    margin-right: -10rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-40:first-child{
    margin-left: -10rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-42:first-child{
    margin-left: -10.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-42:first-child{
    margin-right: -10.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-42:first-child{
    margin-right: -10.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-42:first-child{
    margin-left: -10.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-44:first-child{
    margin-left: -11rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-44:first-child{
    margin-right: -11rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-44:first-child{
    margin-right: -11rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-44:first-child{
    margin-left: -11rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-48:first-child{
    margin-left: -12rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-48:first-child{
    margin-right: -12rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-48:first-child{
    margin-right: -12rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-48:first-child{
    margin-left: -12rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-52:first-child{
    margin-left: -13rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-52:first-child{
    margin-right: -13rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-52:first-child{
    margin-right: -13rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-52:first-child{
    margin-left: -13rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-54:first-child{
    margin-left: -13.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-54:first-child{
    margin-right: -13.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-54:first-child{
    margin-right: -13.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-54:first-child{
    margin-left: -13.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-56:first-child{
    margin-left: -14rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-56:first-child{
    margin-right: -14rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-56:first-child{
    margin-right: -14rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-56:first-child{
    margin-left: -14rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-60:first-child{
    margin-left: -15rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-60:first-child{
    margin-right: -15rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-60:first-child{
    margin-right: -15rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-60:first-child{
    margin-left: -15rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-64:first-child{
    margin-left: -16rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-64:first-child{
    margin-right: -16rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-64:first-child{
    margin-right: -16rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-64:first-child{
    margin-left: -16rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-68:first-child{
    margin-left: -17rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-68:first-child{
    margin-right: -17rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-68:first-child{
    margin-right: -17rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-68:first-child{
    margin-left: -17rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-72:first-child{
    margin-left: -18rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-72:first-child{
    margin-right: -18rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-72:first-child{
    margin-right: -18rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-72:first-child{
    margin-left: -18rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-74:first-child{
    margin-left: -18.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-74:first-child{
    margin-right: -18.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-74:first-child{
    margin-right: -18.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-74:first-child{
    margin-left: -18.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-76:first-child{
    margin-left: -19rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-76:first-child{
    margin-right: -19rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-76:first-child{
    margin-right: -19rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-76:first-child{
    margin-left: -19rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-78:first-child{
    margin-left: -19.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-78:first-child{
    margin-right: -19.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-78:first-child{
    margin-right: -19.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-78:first-child{
    margin-left: -19.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-80:first-child{
    margin-left: -20rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-80:first-child{
    margin-right: -20rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-80:first-child{
    margin-right: -20rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-80:first-child{
    margin-left: -20rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-82:first-child{
    margin-left: -20.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-82:first-child{
    margin-right: -20.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-82:first-child{
    margin-right: -20.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-82:first-child{
    margin-left: -20.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-84:first-child{
    margin-left: -21rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-84:first-child{
    margin-right: -21rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-84:first-child{
    margin-right: -21rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-84:first-child{
    margin-left: -21rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-88:first-child{
    margin-left: -22rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-88:first-child{
    margin-right: -22rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-88:first-child{
    margin-right: -22rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-88:first-child{
    margin-left: -22rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-92:first-child{
    margin-left: -23rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-92:first-child{
    margin-right: -23rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-92:first-child{
    margin-right: -23rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-92:first-child{
    margin-left: -23rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-96:first-child{
    margin-left: -24rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-96:first-child{
    margin-right: -24rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-96:first-child{
    margin-right: -24rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-96:first-child{
    margin-left: -24rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-98:first-child{
    margin-left: -24.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-98:first-child{
    margin-right: -24.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-98:first-child{
    margin-right: -24.5rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-98:first-child{
    margin-left: -24.5rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-100:first-child{
    margin-left: -25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-100:first-child{
    margin-right: -25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-100:first-child{
    margin-right: -25rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-100:first-child{
    margin-left: -25rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-104:first-child{
    margin-left: -26rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-104:first-child{
    margin-right: -26rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-104:first-child{
    margin-right: -26rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-104:first-child{
    margin-left: -26rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-112:first-child{
    margin-left: -28rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-112:first-child{
    margin-right: -28rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-112:first-child{
    margin-right: -28rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-112:first-child{
    margin-left: -28rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-124:first-child{
    margin-left: -31rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-124:first-child{
    margin-right: -31rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-124:first-child{
    margin-right: -31rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-124:first-child{
    margin-left: -31rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-128:first-child{
    margin-left: -32rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-128:first-child{
    margin-right: -32rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-128:first-child{
    margin-right: -32rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-128:first-child{
    margin-left: -32rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-140:first-child{
    margin-left: -35rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-140:first-child{
    margin-right: -35rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-140:first-child{
    margin-right: -35rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-140:first-child{
    margin-left: -35rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-152:first-child{
    margin-left: -38rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-152:first-child{
    margin-right: -38rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-152:first-child{
    margin-right: -38rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-152:first-child{
    margin-left: -38rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-160:first-child{
    margin-left: -40rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-160:first-child{
    margin-right: -40rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-160:first-child{
    margin-right: -40rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-160:first-child{
    margin-left: -40rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-162:first-child{
    margin-left: -41rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-162:first-child{
    margin-right: -41rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-162:first-child{
    margin-right: -41rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-162:first-child{
    margin-left: -41rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-192:first-child{
    margin-left: -48rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-192:first-child{
    margin-right: -48rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-192:first-child{
    margin-right: -48rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-192:first-child{
    margin-left: -48rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-208:first-child{
    margin-left: -52rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-208:first-child{
    margin-right: -52rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-208:first-child{
    margin-right: -52rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-208:first-child{
    margin-left: -52rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-224:first-child{
    margin-left: -56rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-224:first-child{
    margin-right: -56rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-224:first-child{
    margin-right: -56rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-224:first-child{
    margin-left: -56rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-256:first-child{
    margin-left: -64rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-256:first-child{
    margin-right: -64rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-256:first-child{
    margin-right: -64rem;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-256:first-child{
    margin-left: -64rem;
  }

  [dir="ltr"] .\\32xl\\:first\\:-ms-px:first-child{
    margin-left: -1px;
  }

  [dir="rtl"] .\\32xl\\:first\\:-ms-px:first-child{
    margin-right: -1px;
  }

  [dir="ltr"] .\\32xl\\:first\\:-me-px:first-child{
    margin-right: -1px;
  }

  [dir="rtl"] .\\32xl\\:first\\:-me-px:first-child{
    margin-left: -1px;
  }

  [dir="rtl"] .\\32xl\\:start-0{
    right: 0;
  }

  [dir="rtl"] .\\32xl\\:end-0{
    left: 0;
  }

  [dir="ltr"] .\\32xl\\:end-0{
    right: 0;
  }

  [dir="ltr"] .\\32xl\\:start-0{
    left: 0;
  }

  [dir="rtl"] .\\32xl\\:start-auto{
    right: auto;
  }

  [dir="rtl"] .\\32xl\\:end-auto{
    left: auto;
  }

  [dir="ltr"] .\\32xl\\:end-auto{
    right: auto;
  }

  [dir="ltr"] .\\32xl\\:start-auto{
    left: auto;
  }

  [dir="ltr"] .\\32xl\\:rounded-e-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .\\32xl\\:rounded-s-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .\\32xl\\:rounded-e-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .\\32xl\\:rounded-s-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .\\32xl\\:rounded-e-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-s-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-e-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-s-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-e{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-s{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-e{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-s{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-e-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-s-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-e-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-s-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-e-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-s-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-e-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-s-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-e-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .\\32xl\\:rounded-s-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .\\32xl\\:rounded-e-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .\\32xl\\:rounded-s-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .\\32xl\\:rounded-ts-none{
    border-top-left-radius: 0;
  }

  [dir="ltr"] .\\32xl\\:rounded-te-none{
    border-top-right-radius: 0;
  }

  [dir="ltr"] .\\32xl\\:rounded-be-none{
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .\\32xl\\:rounded-bs-none{
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .\\32xl\\:rounded-te-none{
    border-top-left-radius: 0;
  }

  [dir="rtl"] .\\32xl\\:rounded-ts-none{
    border-top-right-radius: 0;
  }

  [dir="rtl"] .\\32xl\\:rounded-bs-none{
    border-bottom-right-radius: 0;
  }

  [dir="rtl"] .\\32xl\\:rounded-be-none{
    border-bottom-left-radius: 0;
  }

  [dir="ltr"] .\\32xl\\:rounded-ts-sm{
    border-top-left-radius: .25rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-te-sm{
    border-top-right-radius: .25rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-be-sm{
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-bs-sm{
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-te-sm{
    border-top-left-radius: .25rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-ts-sm{
    border-top-right-radius: .25rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-bs-sm{
    border-bottom-right-radius: .25rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-be-sm{
    border-bottom-left-radius: .25rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-ts{
    border-top-left-radius: .375rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-te{
    border-top-right-radius: .375rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-be{
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-bs{
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-te{
    border-top-left-radius: .375rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-ts{
    border-top-right-radius: .375rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-bs{
    border-bottom-right-radius: .375rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-be{
    border-bottom-left-radius: .375rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-ts-lg{
    border-top-left-radius: .5rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-te-lg{
    border-top-right-radius: .5rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-be-lg{
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-bs-lg{
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-te-lg{
    border-top-left-radius: .5rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-ts-lg{
    border-top-right-radius: .5rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-bs-lg{
    border-bottom-right-radius: .5rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-be-lg{
    border-bottom-left-radius: .5rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-ts-xl{
    border-top-left-radius: .75rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-te-xl{
    border-top-right-radius: .75rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-be-xl{
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-bs-xl{
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-te-xl{
    border-top-left-radius: .75rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-ts-xl{
    border-top-right-radius: .75rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-bs-xl{
    border-bottom-right-radius: .75rem;
  }

  [dir="rtl"] .\\32xl\\:rounded-be-xl{
    border-bottom-left-radius: .75rem;
  }

  [dir="ltr"] .\\32xl\\:rounded-ts-full{
    border-top-left-radius: 9999px;
  }

  [dir="ltr"] .\\32xl\\:rounded-te-full{
    border-top-right-radius: 9999px;
  }

  [dir="ltr"] .\\32xl\\:rounded-be-full{
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .\\32xl\\:rounded-bs-full{
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .\\32xl\\:rounded-te-full{
    border-top-left-radius: 9999px;
  }

  [dir="rtl"] .\\32xl\\:rounded-ts-full{
    border-top-right-radius: 9999px;
  }

  [dir="rtl"] .\\32xl\\:rounded-bs-full{
    border-bottom-right-radius: 9999px;
  }

  [dir="rtl"] .\\32xl\\:rounded-be-full{
    border-bottom-left-radius: 9999px;
  }

  [dir="ltr"] .\\32xl\\:clear-start{
    clear: left;
  }

  [dir="ltr"] .\\32xl\\:clear-end{
    clear: right;
  }

  [dir="rtl"] .\\32xl\\:clear-start{
    clear: right;
  }

  [dir="rtl"] .\\32xl\\:clear-end{
    clear: left;
  }

  [dir="rtl"] .\\32xl\\:float-start{
    float: right;
  }

  [dir="rtl"] .\\32xl\\:float-end{
    float: left;
  }

  [dir="ltr"] .\\32xl\\:float-end{
    float: right;
  }

  [dir="ltr"] .\\32xl\\:float-start{
    float: left;
  }

  [dir="ltr"] .\\32xl\\:border-e-0{
    border-right-width: 0;
  }

  [dir="rtl"] .\\32xl\\:border-e-0{
    border-left-width: 0;
  }

  [dir="ltr"] .\\32xl\\:border-s-0{
    border-left-width: 0;
  }

  [dir="rtl"] .\\32xl\\:border-s-0{
    border-right-width: 0;
  }

  [dir="ltr"] .\\32xl\\:border-e-2{
    border-right-width: 2px;
  }

  [dir="rtl"] .\\32xl\\:border-e-2{
    border-left-width: 2px;
  }

  [dir="ltr"] .\\32xl\\:border-s-2{
    border-left-width: 2px;
  }

  [dir="rtl"] .\\32xl\\:border-s-2{
    border-right-width: 2px;
  }

  [dir="ltr"] .\\32xl\\:border-e-3{
    border-right-width: 3px;
  }

  [dir="rtl"] .\\32xl\\:border-e-3{
    border-left-width: 3px;
  }

  [dir="ltr"] .\\32xl\\:border-s-3{
    border-left-width: 3px;
  }

  [dir="rtl"] .\\32xl\\:border-s-3{
    border-right-width: 3px;
  }

  [dir="ltr"] .\\32xl\\:border-e-4{
    border-right-width: 4px;
  }

  [dir="rtl"] .\\32xl\\:border-e-4{
    border-left-width: 4px;
  }

  [dir="ltr"] .\\32xl\\:border-s-4{
    border-left-width: 4px;
  }

  [dir="rtl"] .\\32xl\\:border-s-4{
    border-right-width: 4px;
  }

  [dir="ltr"] .\\32xl\\:border-e-5{
    border-right-width: 5px;
  }

  [dir="rtl"] .\\32xl\\:border-e-5{
    border-left-width: 5px;
  }

  [dir="ltr"] .\\32xl\\:border-s-5{
    border-left-width: 5px;
  }

  [dir="rtl"] .\\32xl\\:border-s-5{
    border-right-width: 5px;
  }

  [dir="ltr"] .\\32xl\\:border-e-6{
    border-right-width: 6px;
  }

  [dir="rtl"] .\\32xl\\:border-e-6{
    border-left-width: 6px;
  }

  [dir="ltr"] .\\32xl\\:border-s-6{
    border-left-width: 6px;
  }

  [dir="rtl"] .\\32xl\\:border-s-6{
    border-right-width: 6px;
  }

  [dir="ltr"] .\\32xl\\:border-e-8{
    border-right-width: 8px;
  }

  [dir="rtl"] .\\32xl\\:border-e-8{
    border-left-width: 8px;
  }

  [dir="ltr"] .\\32xl\\:border-s-8{
    border-left-width: 8px;
  }

  [dir="rtl"] .\\32xl\\:border-s-8{
    border-right-width: 8px;
  }

  [dir="ltr"] .\\32xl\\:border-e{
    border-right-width: 1px;
  }

  [dir="rtl"] .\\32xl\\:border-e{
    border-left-width: 1px;
  }

  [dir="ltr"] .\\32xl\\:border-s{
    border-left-width: 1px;
  }

  [dir="rtl"] .\\32xl\\:border-s{
    border-right-width: 1px;
  }

  [dir="ltr"] .\\32xl\\:first\\:border-e-0:first-child{
    border-right-width: 0;
  }

  [dir="rtl"] .\\32xl\\:first\\:border-e-0:first-child{
    border-left-width: 0;
  }

  [dir="ltr"] .\\32xl\\:first\\:border-s-0:first-child{
    border-left-width: 0;
  }

  [dir="rtl"] .\\32xl\\:first\\:border-s-0:first-child{
    border-right-width: 0;
  }

  [dir="ltr"] .\\32xl\\:first\\:border-e-2:first-child{
    border-right-width: 2px;
  }

  [dir="rtl"] .\\32xl\\:first\\:border-e-2:first-child{
    border-left-width: 2px;
  }

  [dir="ltr"] .\\32xl\\:first\\:border-s-2:first-child{
    border-left-width: 2px;
  }

  [dir="rtl"] .\\32xl\\:first\\:border-s-2:first-child{
    border-right-width: 2px;
  }

  [dir="ltr"] .\\32xl\\:first\\:border-e-3:first-child{
    border-right-width: 3px;
  }

  [dir="rtl"] .\\32xl\\:first\\:border-e-3:first-child{
    border-left-width: 3px;
  }

  [dir="ltr"] .\\32xl\\:first\\:border-s-3:first-child{
    border-left-width: 3px;
  }

  [dir="rtl"] .\\32xl\\:first\\:border-s-3:first-child{
    border-right-width: 3px;
  }

  [dir="ltr"] .\\32xl\\:first\\:border-e-4:first-child{
    border-right-width: 4px;
  }

  [dir="rtl"] .\\32xl\\:first\\:border-e-4:first-child{
    border-left-width: 4px;
  }

  [dir="ltr"] .\\32xl\\:first\\:border-s-4:first-child{
    border-left-width: 4px;
  }

  [dir="rtl"] .\\32xl\\:first\\:border-s-4:first-child{
    border-right-width: 4px;
  }

  [dir="ltr"] .\\32xl\\:first\\:border-e-5:first-child{
    border-right-width: 5px;
  }

  [dir="rtl"] .\\32xl\\:first\\:border-e-5:first-child{
    border-left-width: 5px;
  }

  [dir="ltr"] .\\32xl\\:first\\:border-s-5:first-child{
    border-left-width: 5px;
  }

  [dir="rtl"] .\\32xl\\:first\\:border-s-5:first-child{
    border-right-width: 5px;
  }

  [dir="ltr"] .\\32xl\\:first\\:border-e-6:first-child{
    border-right-width: 6px;
  }

  [dir="rtl"] .\\32xl\\:first\\:border-e-6:first-child{
    border-left-width: 6px;
  }

  [dir="ltr"] .\\32xl\\:first\\:border-s-6:first-child{
    border-left-width: 6px;
  }

  [dir="rtl"] .\\32xl\\:first\\:border-s-6:first-child{
    border-right-width: 6px;
  }

  [dir="ltr"] .\\32xl\\:first\\:border-e-8:first-child{
    border-right-width: 8px;
  }

  [dir="rtl"] .\\32xl\\:first\\:border-e-8:first-child{
    border-left-width: 8px;
  }

  [dir="ltr"] .\\32xl\\:first\\:border-s-8:first-child{
    border-left-width: 8px;
  }

  [dir="rtl"] .\\32xl\\:first\\:border-s-8:first-child{
    border-right-width: 8px;
  }

  [dir="ltr"] .\\32xl\\:first\\:border-e:first-child{
    border-right-width: 1px;
  }

  [dir="rtl"] .\\32xl\\:first\\:border-e:first-child{
    border-left-width: 1px;
  }

  [dir="ltr"] .\\32xl\\:first\\:border-s:first-child{
    border-left-width: 1px;
  }

  [dir="rtl"] .\\32xl\\:first\\:border-s:first-child{
    border-right-width: 1px;
  }

  [dir="rtl"] .\\32xl\\:text-start{
    text-align: right;
  }

  [dir="rtl"] .\\32xl\\:text-end{
    text-align: left;
  }

  [dir="ltr"] .\\32xl\\:text-end{
    text-align: right;
  }

  [dir="ltr"] .\\32xl\\:text-start{
    text-align: left;
  }

  [dir="ltr"] .\\32xl\\:origin-top-start{
    transform-origin: top left;
  }

  [dir="ltr"] .\\32xl\\:origin-top-end{
    transform-origin: top right;
  }

  [dir="ltr"] .\\32xl\\:origin-bottom-start{
    transform-origin: bottom left;
  }

  [dir="ltr"] .\\32xl\\:origin-bottom-end{
    transform-origin: bottom right;
  }

  [dir="ltr"] .\\32xl\\:origin-start{
    transform-origin: left;
  }

  [dir="ltr"] .\\32xl\\:origin-end{
    transform-origin: right;
  }

  [dir="rtl"] .\\32xl\\:origin-top-start{
    transform-origin: top right;
  }

  [dir="rtl"] .\\32xl\\:origin-top-end{
    transform-origin: top left;
  }

  [dir="rtl"] .\\32xl\\:origin-bottom-start{
    transform-origin: bottom right;
  }

  [dir="rtl"] .\\32xl\\:origin-bottom-end{
    transform-origin: bottom left;
  }

  [dir="rtl"] .\\32xl\\:origin-start{
    transform-origin: right;
  }

  [dir="rtl"] .\\32xl\\:origin-end{
    transform-origin: left;
  }

  [dir="ltr"] .\\32xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\32xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\32xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\32xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\32xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\32xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * (1 - var(--tw-space-s-reverse)));
  }

  .\\32xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  .\\32xl\\:space-s-reverse > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 1;
  }
}

@media (min-width: 1920px){
  .\\33xl\\:prose{
    color: #4a5568;
    max-width: 65ch;
  }

  .\\33xl\\:prose [class~="lead"]{
    color: #4a5568;
    font-size: 1.25em;
    line-height: 1.6;
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .\\33xl\\:prose a{
    color: #1a202c;
    text-decoration: underline;
  }

  .\\33xl\\:prose strong{
    color: #1a202c;
    font-weight: 600;
  }

  .\\33xl\\:prose ol{
    counter-reset: list-counter;
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .\\33xl\\:prose ol > li{
    position: relative;
    counter-increment: list-counter;
    padding-left: 1.75em;
  }

  .\\33xl\\:prose ol > li::before{
    content: ;
    position: absolute;
    font-weight: 400;
    color: #718096;
  }

  .\\33xl\\:prose ul > li{
    position: relative;
    padding-left: 1.75em;
  }

  .\\33xl\\:prose ul > li::before{
    content: "";
    position: absolute;
    background-color: #cbd5e0;
    border-radius: 50%;
    width: 0.375em;
    height: 0.375em;
    top: calc(0.875em - 0.1875em);
    left: 0.25em;
  }

  .\\33xl\\:prose hr{
    border-color: #e2e8f0;
    border-top-width: 1px;
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .\\33xl\\:prose blockquote{
    font-weight: 500;
    font-style: italic;
    color: #1a202c;
    border-left-width: 0.25rem;
    border-left-color: #e2e8f0;
    quotes: "\\201C""\\201D""\\2018""\\2019";
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1em;
  }

  .\\33xl\\:prose blockquote p:first-of-type::before{
    content: open-quote;
  }

  .\\33xl\\:prose blockquote p:last-of-type::after{
    content: close-quote;
  }

  .\\33xl\\:prose h1{
    color: #1a202c;
    font-weight: 800;
    font-size: 2.25em;
    margin-top: 0;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }

  .\\33xl\\:prose h2{
    color: #1a202c;
    font-weight: 700;
    font-size: 1.5em;
    margin-top: 2em;
    margin-bottom: 1em;
    line-height: 1.3333333;
  }

  .\\33xl\\:prose h3{
    color: #1a202c;
    font-weight: 600;
    font-size: 1.25em;
    margin-top: 1.6em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }

  .\\33xl\\:prose h4{
    color: #1a202c;
    font-weight: 600;
    margin-top: 1.5em;
    margin-bottom: 0.5em;
    line-height: 1.5;
  }

  .\\33xl\\:prose figure figcaption{
    color: #718096;
    font-size: 0.875em;
    line-height: 1.4285714;
    margin-top: 0.8571429em;
  }

  .\\33xl\\:prose code{
    color: #1a202c;
    font-weight: 600;
    font-size: 0.875em;
  }

  .\\33xl\\:prose code::before{
    content: "\`";
  }

  .\\33xl\\:prose code::after{
    content: "\`";
  }

  .\\33xl\\:prose pre{
    color: #e2e8f0;
    background-color: #2d3748;
    overflow-x: auto;
    font-size: 0.875em;
    line-height: 1.7142857;
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
    border-radius: 0.375rem;
    padding-top: 0.8571429em;
    padding-right: 1.1428571em;
    padding-bottom: 0.8571429em;
    padding-left: 1.1428571em;
  }

  .\\33xl\\:prose pre code{
    background-color: transparent;
    border-width: 0;
    border-radius: 0;
    padding: 0;
    font-weight: 400;
    color: inherit;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
  }

  .\\33xl\\:prose pre code::before{
    content: "";
  }

  .\\33xl\\:prose pre code::after{
    content: "";
  }

  .\\33xl\\:prose table{
    width: 100%;
    table-layout: auto;
    text-align: left;
    margin-top: 2em;
    margin-bottom: 2em;
    font-size: 0.875em;
    line-height: 1.7142857;
  }

  .\\33xl\\:prose thead{
    color: #1a202c;
    font-weight: 600;
    border-bottom-width: 1px;
    border-bottom-color: #cbd5e0;
  }

  .\\33xl\\:prose thead th{
    vertical-align: bottom;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }

  .\\33xl\\:prose tbody tr{
    border-bottom-width: 1px;
    border-bottom-color: #e2e8f0;
  }

  .\\33xl\\:prose tbody tr:last-child{
    border-bottom-width: 0;
  }

  .\\33xl\\:prose tbody td{
    vertical-align: top;
    padding-top: 0.5714286em;
    padding-right: 0.5714286em;
    padding-bottom: 0.5714286em;
    padding-left: 0.5714286em;
  }

  .\\33xl\\:prose{
    font-size: 1rem;
    line-height: 1.75;
  }

  .\\33xl\\:prose p{
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .\\33xl\\:prose img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\33xl\\:prose video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\33xl\\:prose figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\33xl\\:prose figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .\\33xl\\:prose h2 code{
    font-size: 0.875em;
  }

  .\\33xl\\:prose h3 code{
    font-size: 0.9em;
  }

  .\\33xl\\:prose ul{
    margin-top: 1.25em;
    margin-bottom: 1.25em;
  }

  .\\33xl\\:prose li{
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .\\33xl\\:prose ol > li:before{
    left: 0;
  }

  .\\33xl\\:prose > ul > li p{
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }

  .\\33xl\\:prose > ul > li > *:first-child{
    margin-top: 1.25em;
  }

  .\\33xl\\:prose > ul > li > *:last-child{
    margin-bottom: 1.25em;
  }

  .\\33xl\\:prose > ol > li > *:first-child{
    margin-top: 1.25em;
  }

  .\\33xl\\:prose > ol > li > *:last-child{
    margin-bottom: 1.25em;
  }

  .\\33xl\\:prose ul ul, .\\33xl\\:prose ul ol, .\\33xl\\:prose ol ul, .\\33xl\\:prose ol ol{
    margin-top: 0.75em;
    margin-bottom: 0.75em;
  }

  .\\33xl\\:prose hr + *{
    margin-top: 0;
  }

  .\\33xl\\:prose h2 + *{
    margin-top: 0;
  }

  .\\33xl\\:prose h3 + *{
    margin-top: 0;
  }

  .\\33xl\\:prose h4 + *{
    margin-top: 0;
  }

  .\\33xl\\:prose thead th:first-child{
    padding-left: 0;
  }

  .\\33xl\\:prose thead th:last-child{
    padding-right: 0;
  }

  .\\33xl\\:prose tbody td:first-child{
    padding-left: 0;
  }

  .\\33xl\\:prose tbody td:last-child{
    padding-right: 0;
  }

  .\\33xl\\:prose > :first-child{
    margin-top: 0;
  }

  .\\33xl\\:prose > :last-child{
    margin-bottom: 0;
  }

  .\\33xl\\:prose-sm{
    font-size: 0.875rem;
    line-height: 1.7142857;
  }

  .\\33xl\\:prose-sm p{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .\\33xl\\:prose-sm [class~="lead"]{
    font-size: 1.2857143em;
    line-height: 1.5555556;
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .\\33xl\\:prose-sm blockquote{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
    padding-left: 1.1111111em;
  }

  .\\33xl\\:prose-sm h1{
    font-size: 2.1428571em;
    margin-top: 0;
    margin-bottom: 0.8em;
    line-height: 1.2;
  }

  .\\33xl\\:prose-sm h2{
    font-size: 1.4285714em;
    margin-top: 1.6em;
    margin-bottom: 0.8em;
    line-height: 1.4;
  }

  .\\33xl\\:prose-sm h3{
    font-size: 1.2857143em;
    margin-top: 1.5555556em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }

  .\\33xl\\:prose-sm h4{
    margin-top: 1.4285714em;
    margin-bottom: 0.5714286em;
    line-height: 1.4285714;
  }

  .\\33xl\\:prose-sm img{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .\\33xl\\:prose-sm video{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .\\33xl\\:prose-sm figure{
    margin-top: 1.7142857em;
    margin-bottom: 1.7142857em;
  }

  .\\33xl\\:prose-sm figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .\\33xl\\:prose-sm figure figcaption{
    font-size: 0.8571429em;
    line-height: 1.3333333;
    margin-top: 0.6666667em;
  }

  .\\33xl\\:prose-sm code{
    font-size: 0.8571429em;
  }

  .\\33xl\\:prose-sm h2 code{
    font-size: 0.9em;
  }

  .\\33xl\\:prose-sm h3 code{
    font-size: 0.8888889em;
  }

  .\\33xl\\:prose-sm pre{
    font-size: 0.8571429em;
    line-height: 1.6666667;
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    border-radius: 0.25rem;
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .\\33xl\\:prose-sm ol{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .\\33xl\\:prose-sm ul{
    margin-top: 1.1428571em;
    margin-bottom: 1.1428571em;
  }

  .\\33xl\\:prose-sm li{
    margin-top: 0.2857143em;
    margin-bottom: 0.2857143em;
  }

  .\\33xl\\:prose-sm ol > li{
    padding-left: 1.5714286em;
  }

  .\\33xl\\:prose-sm ol > li:before{
    left: 0;
  }

  .\\33xl\\:prose-sm ul > li{
    padding-left: 1.5714286em;
  }

  .\\33xl\\:prose-sm ul > li::before{
    height: 0.3571429em;
    width: 0.3571429em;
    top: calc(0.8571429em - 0.1785714em);
    left: 0.2142857em;
  }

  .\\33xl\\:prose-sm > ul > li p{
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }

  .\\33xl\\:prose-sm > ul > li > *:first-child{
    margin-top: 1.1428571em;
  }

  .\\33xl\\:prose-sm > ul > li > *:last-child{
    margin-bottom: 1.1428571em;
  }

  .\\33xl\\:prose-sm > ol > li > *:first-child{
    margin-top: 1.1428571em;
  }

  .\\33xl\\:prose-sm > ol > li > *:last-child{
    margin-bottom: 1.1428571em;
  }

  .\\33xl\\:prose-sm ul ul, .\\33xl\\:prose-sm ul ol, .\\33xl\\:prose-sm ol ul, .\\33xl\\:prose-sm ol ol{
    margin-top: 0.5714286em;
    margin-bottom: 0.5714286em;
  }

  .\\33xl\\:prose-sm hr{
    margin-top: 2.8571429em;
    margin-bottom: 2.8571429em;
  }

  .\\33xl\\:prose-sm hr + *{
    margin-top: 0;
  }

  .\\33xl\\:prose-sm h2 + *{
    margin-top: 0;
  }

  .\\33xl\\:prose-sm h3 + *{
    margin-top: 0;
  }

  .\\33xl\\:prose-sm h4 + *{
    margin-top: 0;
  }

  .\\33xl\\:prose-sm table{
    font-size: 0.8571429em;
    line-height: 1.5;
  }

  .\\33xl\\:prose-sm thead th{
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .\\33xl\\:prose-sm thead th:first-child{
    padding-left: 0;
  }

  .\\33xl\\:prose-sm thead th:last-child{
    padding-right: 0;
  }

  .\\33xl\\:prose-sm tbody td{
    padding-top: 0.6666667em;
    padding-right: 1em;
    padding-bottom: 0.6666667em;
    padding-left: 1em;
  }

  .\\33xl\\:prose-sm tbody td:first-child{
    padding-left: 0;
  }

  .\\33xl\\:prose-sm tbody td:last-child{
    padding-right: 0;
  }

  .\\33xl\\:prose-sm > :first-child{
    margin-top: 0;
  }

  .\\33xl\\:prose-sm > :last-child{
    margin-bottom: 0;
  }

  .\\33xl\\:prose-lg{
    font-size: 1.125rem;
    line-height: 1.7777778;
  }

  .\\33xl\\:prose-lg p{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .\\33xl\\:prose-lg [class~="lead"]{
    font-size: 1.2222222em;
    line-height: 1.4545455;
    margin-top: 1.0909091em;
    margin-bottom: 1.0909091em;
  }

  .\\33xl\\:prose-lg blockquote{
    margin-top: 1.6666667em;
    margin-bottom: 1.6666667em;
    padding-left: 1em;
  }

  .\\33xl\\:prose-lg h1{
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.8333333em;
    line-height: 1;
  }

  .\\33xl\\:prose-lg h2{
    font-size: 1.6666667em;
    margin-top: 1.8666667em;
    margin-bottom: 1.0666667em;
    line-height: 1.3333333;
  }

  .\\33xl\\:prose-lg h3{
    font-size: 1.3333333em;
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }

  .\\33xl\\:prose-lg h4{
    margin-top: 1.7777778em;
    margin-bottom: 0.4444444em;
    line-height: 1.5555556;
  }

  .\\33xl\\:prose-lg img{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .\\33xl\\:prose-lg video{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .\\33xl\\:prose-lg figure{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
  }

  .\\33xl\\:prose-lg figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .\\33xl\\:prose-lg figure figcaption{
    font-size: 0.8888889em;
    line-height: 1.5;
    margin-top: 1em;
  }

  .\\33xl\\:prose-lg code{
    font-size: 0.8888889em;
  }

  .\\33xl\\:prose-lg h2 code{
    font-size: 0.8666667em;
  }

  .\\33xl\\:prose-lg h3 code{
    font-size: 0.875em;
  }

  .\\33xl\\:prose-lg pre{
    font-size: 0.8888889em;
    line-height: 1.75;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.375rem;
    padding-top: 1em;
    padding-right: 1.5em;
    padding-bottom: 1em;
    padding-left: 1.5em;
  }

  .\\33xl\\:prose-lg ol{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .\\33xl\\:prose-lg ul{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .\\33xl\\:prose-lg li{
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }

  .\\33xl\\:prose-lg ol > li{
    padding-left: 1.6666667em;
  }

  .\\33xl\\:prose-lg ol > li:before{
    left: 0;
  }

  .\\33xl\\:prose-lg ul > li{
    padding-left: 1.6666667em;
  }

  .\\33xl\\:prose-lg ul > li::before{
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8888889em - 0.1666667em);
    left: 0.2222222em;
  }

  .\\33xl\\:prose-lg > ul > li p{
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .\\33xl\\:prose-lg > ul > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .\\33xl\\:prose-lg > ul > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .\\33xl\\:prose-lg > ol > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .\\33xl\\:prose-lg > ol > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .\\33xl\\:prose-lg ul ul, .\\33xl\\:prose-lg ul ol, .\\33xl\\:prose-lg ol ul, .\\33xl\\:prose-lg ol ol{
    margin-top: 0.8888889em;
    margin-bottom: 0.8888889em;
  }

  .\\33xl\\:prose-lg hr{
    margin-top: 3.1111111em;
    margin-bottom: 3.1111111em;
  }

  .\\33xl\\:prose-lg hr + *{
    margin-top: 0;
  }

  .\\33xl\\:prose-lg h2 + *{
    margin-top: 0;
  }

  .\\33xl\\:prose-lg h3 + *{
    margin-top: 0;
  }

  .\\33xl\\:prose-lg h4 + *{
    margin-top: 0;
  }

  .\\33xl\\:prose-lg table{
    font-size: 0.8888889em;
    line-height: 1.5;
  }

  .\\33xl\\:prose-lg thead th{
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }

  .\\33xl\\:prose-lg thead th:first-child{
    padding-left: 0;
  }

  .\\33xl\\:prose-lg thead th:last-child{
    padding-right: 0;
  }

  .\\33xl\\:prose-lg tbody td{
    padding-top: 0.75em;
    padding-right: 0.75em;
    padding-bottom: 0.75em;
    padding-left: 0.75em;
  }

  .\\33xl\\:prose-lg tbody td:first-child{
    padding-left: 0;
  }

  .\\33xl\\:prose-lg tbody td:last-child{
    padding-right: 0;
  }

  .\\33xl\\:prose-lg > :first-child{
    margin-top: 0;
  }

  .\\33xl\\:prose-lg > :last-child{
    margin-bottom: 0;
  }

  .\\33xl\\:prose-xl{
    font-size: 1.25rem;
    line-height: 1.8;
  }

  .\\33xl\\:prose-xl p{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .\\33xl\\:prose-xl [class~="lead"]{
    font-size: 1.2em;
    line-height: 1.5;
    margin-top: 1em;
    margin-bottom: 1em;
  }

  .\\33xl\\:prose-xl blockquote{
    margin-top: 1.6em;
    margin-bottom: 1.6em;
    padding-left: 1.0666667em;
  }

  .\\33xl\\:prose-xl h1{
    font-size: 2.8em;
    margin-top: 0;
    margin-bottom: 0.8571429em;
    line-height: 1;
  }

  .\\33xl\\:prose-xl h2{
    font-size: 1.8em;
    margin-top: 1.5555556em;
    margin-bottom: 0.8888889em;
    line-height: 1.1111111;
  }

  .\\33xl\\:prose-xl h3{
    font-size: 1.5em;
    margin-top: 1.6em;
    margin-bottom: 0.6666667em;
    line-height: 1.3333333;
  }

  .\\33xl\\:prose-xl h4{
    margin-top: 1.8em;
    margin-bottom: 0.6em;
    line-height: 1.6;
  }

  .\\33xl\\:prose-xl img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\33xl\\:prose-xl video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\33xl\\:prose-xl figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\33xl\\:prose-xl figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .\\33xl\\:prose-xl figure figcaption{
    font-size: 0.9em;
    line-height: 1.5555556;
    margin-top: 1em;
  }

  .\\33xl\\:prose-xl code{
    font-size: 0.9em;
  }

  .\\33xl\\:prose-xl h2 code{
    font-size: 0.8611111em;
  }

  .\\33xl\\:prose-xl h3 code{
    font-size: 0.9em;
  }

  .\\33xl\\:prose-xl pre{
    font-size: 0.9em;
    line-height: 1.7777778;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.1111111em;
    padding-right: 1.3333333em;
    padding-bottom: 1.1111111em;
    padding-left: 1.3333333em;
  }

  .\\33xl\\:prose-xl ol{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .\\33xl\\:prose-xl ul{
    margin-top: 1.2em;
    margin-bottom: 1.2em;
  }

  .\\33xl\\:prose-xl li{
    margin-top: 0.6em;
    margin-bottom: 0.6em;
  }

  .\\33xl\\:prose-xl ol > li{
    padding-left: 1.8em;
  }

  .\\33xl\\:prose-xl ol > li:before{
    left: 0;
  }

  .\\33xl\\:prose-xl ul > li{
    padding-left: 1.8em;
  }

  .\\33xl\\:prose-xl ul > li::before{
    width: 0.35em;
    height: 0.35em;
    top: calc(0.9em - 0.175em);
    left: 0.25em;
  }

  .\\33xl\\:prose-xl > ul > li p{
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }

  .\\33xl\\:prose-xl > ul > li > *:first-child{
    margin-top: 1.2em;
  }

  .\\33xl\\:prose-xl > ul > li > *:last-child{
    margin-bottom: 1.2em;
  }

  .\\33xl\\:prose-xl > ol > li > *:first-child{
    margin-top: 1.2em;
  }

  .\\33xl\\:prose-xl > ol > li > *:last-child{
    margin-bottom: 1.2em;
  }

  .\\33xl\\:prose-xl ul ul, .\\33xl\\:prose-xl ul ol, .\\33xl\\:prose-xl ol ul, .\\33xl\\:prose-xl ol ol{
    margin-top: 0.8em;
    margin-bottom: 0.8em;
  }

  .\\33xl\\:prose-xl hr{
    margin-top: 2.8em;
    margin-bottom: 2.8em;
  }

  .\\33xl\\:prose-xl hr + *{
    margin-top: 0;
  }

  .\\33xl\\:prose-xl h2 + *{
    margin-top: 0;
  }

  .\\33xl\\:prose-xl h3 + *{
    margin-top: 0;
  }

  .\\33xl\\:prose-xl h4 + *{
    margin-top: 0;
  }

  .\\33xl\\:prose-xl table{
    font-size: 0.9em;
    line-height: 1.5555556;
  }

  .\\33xl\\:prose-xl thead th{
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }

  .\\33xl\\:prose-xl thead th:first-child{
    padding-left: 0;
  }

  .\\33xl\\:prose-xl thead th:last-child{
    padding-right: 0;
  }

  .\\33xl\\:prose-xl tbody td{
    padding-top: 0.8888889em;
    padding-right: 0.6666667em;
    padding-bottom: 0.8888889em;
    padding-left: 0.6666667em;
  }

  .\\33xl\\:prose-xl tbody td:first-child{
    padding-left: 0;
  }

  .\\33xl\\:prose-xl tbody td:last-child{
    padding-right: 0;
  }

  .\\33xl\\:prose-xl > :first-child{
    margin-top: 0;
  }

  .\\33xl\\:prose-xl > :last-child{
    margin-bottom: 0;
  }

  .\\33xl\\:prose-2xl{
    font-size: 1.5rem;
    line-height: 1.6666667;
  }

  .\\33xl\\:prose-2xl p{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .\\33xl\\:prose-2xl [class~="lead"]{
    font-size: 1.25em;
    line-height: 1.4666667;
    margin-top: 1.0666667em;
    margin-bottom: 1.0666667em;
  }

  .\\33xl\\:prose-2xl blockquote{
    margin-top: 1.7777778em;
    margin-bottom: 1.7777778em;
    padding-left: 1.1111111em;
  }

  .\\33xl\\:prose-2xl h1{
    font-size: 2.6666667em;
    margin-top: 0;
    margin-bottom: 0.875em;
    line-height: 1;
  }

  .\\33xl\\:prose-2xl h2{
    font-size: 2em;
    margin-top: 1.5em;
    margin-bottom: 0.8333333em;
    line-height: 1.0833333;
  }

  .\\33xl\\:prose-2xl h3{
    font-size: 1.5em;
    margin-top: 1.5555556em;
    margin-bottom: 0.6666667em;
    line-height: 1.2222222;
  }

  .\\33xl\\:prose-2xl h4{
    margin-top: 1.6666667em;
    margin-bottom: 0.6666667em;
    line-height: 1.5;
  }

  .\\33xl\\:prose-2xl img{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\33xl\\:prose-2xl video{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\33xl\\:prose-2xl figure{
    margin-top: 2em;
    margin-bottom: 2em;
  }

  .\\33xl\\:prose-2xl figure > *{
    margin-top: 0;
    margin-bottom: 0;
  }

  .\\33xl\\:prose-2xl figure figcaption{
    font-size: 0.8333333em;
    line-height: 1.6;
    margin-top: 1em;
  }

  .\\33xl\\:prose-2xl code{
    font-size: 0.8333333em;
  }

  .\\33xl\\:prose-2xl h2 code{
    font-size: 0.875em;
  }

  .\\33xl\\:prose-2xl h3 code{
    font-size: 0.8888889em;
  }

  .\\33xl\\:prose-2xl pre{
    font-size: 0.8333333em;
    line-height: 1.8;
    margin-top: 2em;
    margin-bottom: 2em;
    border-radius: 0.5rem;
    padding-top: 1.2em;
    padding-right: 1.6em;
    padding-bottom: 1.2em;
    padding-left: 1.6em;
  }

  .\\33xl\\:prose-2xl ol{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .\\33xl\\:prose-2xl ul{
    margin-top: 1.3333333em;
    margin-bottom: 1.3333333em;
  }

  .\\33xl\\:prose-2xl li{
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  .\\33xl\\:prose-2xl ol > li{
    padding-left: 1.6666667em;
  }

  .\\33xl\\:prose-2xl ol > li:before{
    left: 0;
  }

  .\\33xl\\:prose-2xl ul > li{
    padding-left: 1.6666667em;
  }

  .\\33xl\\:prose-2xl ul > li::before{
    width: 0.3333333em;
    height: 0.3333333em;
    top: calc(0.8333333em - 0.1666667em);
    left: 0.25em;
  }

  .\\33xl\\:prose-2xl > ul > li p{
    margin-top: 0.8333333em;
    margin-bottom: 0.8333333em;
  }

  .\\33xl\\:prose-2xl > ul > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .\\33xl\\:prose-2xl > ul > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .\\33xl\\:prose-2xl > ol > li > *:first-child{
    margin-top: 1.3333333em;
  }

  .\\33xl\\:prose-2xl > ol > li > *:last-child{
    margin-bottom: 1.3333333em;
  }

  .\\33xl\\:prose-2xl ul ul, .\\33xl\\:prose-2xl ul ol, .\\33xl\\:prose-2xl ol ul, .\\33xl\\:prose-2xl ol ol{
    margin-top: 0.6666667em;
    margin-bottom: 0.6666667em;
  }

  .\\33xl\\:prose-2xl hr{
    margin-top: 3em;
    margin-bottom: 3em;
  }

  .\\33xl\\:prose-2xl hr + *{
    margin-top: 0;
  }

  .\\33xl\\:prose-2xl h2 + *{
    margin-top: 0;
  }

  .\\33xl\\:prose-2xl h3 + *{
    margin-top: 0;
  }

  .\\33xl\\:prose-2xl h4 + *{
    margin-top: 0;
  }

  .\\33xl\\:prose-2xl table{
    font-size: 0.8333333em;
    line-height: 1.4;
  }

  .\\33xl\\:prose-2xl thead th{
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }

  .\\33xl\\:prose-2xl thead th:first-child{
    padding-left: 0;
  }

  .\\33xl\\:prose-2xl thead th:last-child{
    padding-right: 0;
  }

  .\\33xl\\:prose-2xl tbody td{
    padding-top: 0.8em;
    padding-right: 0.6em;
    padding-bottom: 0.8em;
    padding-left: 0.6em;
  }

  .\\33xl\\:prose-2xl tbody td:first-child{
    padding-left: 0;
  }

  .\\33xl\\:prose-2xl tbody td:last-child{
    padding-right: 0;
  }

  .\\33xl\\:prose-2xl > :first-child{
    margin-top: 0;
  }

  .\\33xl\\:prose-2xl > :last-child{
    margin-bottom: 0;
  }

  .\\33xl\\:space-y-0 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0px * (1 - var(--space-y-reverse)));
    margin-top: calc(0px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0px * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-0 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0px * var(--space-x-reverse));
    margin-left: calc(0px * (1 - var(--space-x-reverse)));
    margin-left: calc(0px * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.25rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--space-x-reverse));
    margin-left: calc(0.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.5rem * var(--space-x-reverse));
    margin-left: calc(0.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(0.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(0.75rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(0.75rem * var(--space-x-reverse));
    margin-left: calc(0.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(0.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1rem * var(--space-x-reverse));
    margin-left: calc(1rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.25rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.25rem * var(--space-x-reverse));
    margin-left: calc(1.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.5rem * var(--space-x-reverse));
    margin-left: calc(1.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-7 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1.75rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-7 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1.75rem * var(--space-x-reverse));
    margin-left: calc(1.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(1.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2rem * var(--space-x-reverse));
    margin-left: calc(2rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-9 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.25rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-9 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.25rem * var(--space-x-reverse));
    margin-left: calc(2.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.5rem * var(--space-x-reverse));
    margin-left: calc(2.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-11 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(2.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(2.75rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-11 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(2.75rem * var(--space-x-reverse));
    margin-left: calc(2.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(2.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3rem * var(--space-x-reverse));
    margin-left: calc(3rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-14 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-14 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3.5rem * var(--space-x-reverse));
    margin-left: calc(3.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-15 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(3.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(3.75rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-15 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(3.75rem * var(--space-x-reverse));
    margin-left: calc(3.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(3.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(4rem * (1 - var(--space-y-reverse)));
    margin-top: calc(4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(4rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(4rem * var(--space-x-reverse));
    margin-left: calc(4rem * (1 - var(--space-x-reverse)));
    margin-left: calc(4rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-18 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(4.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(4.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(4.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-18 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(4.5rem * var(--space-x-reverse));
    margin-left: calc(4.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(4.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5rem * var(--space-x-reverse));
    margin-left: calc(5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-22 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-22 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5.5rem * var(--space-x-reverse));
    margin-left: calc(5.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-23 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(5.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(5.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(5.75rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-23 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(5.75rem * var(--space-x-reverse));
    margin-left: calc(5.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(5.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6rem * var(--space-x-reverse));
    margin-left: calc(6rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-25 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6.25rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-25 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6.25rem * var(--space-x-reverse));
    margin-left: calc(6.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6.25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-26 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(6.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(6.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(6.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-26 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(6.5rem * var(--space-x-reverse));
    margin-left: calc(6.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(6.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-28 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(7rem * (1 - var(--space-y-reverse)));
    margin-top: calc(7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(7rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-28 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(7rem * var(--space-x-reverse));
    margin-left: calc(7rem * (1 - var(--space-x-reverse)));
    margin-left: calc(7rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-30 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(7.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(7.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(7.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-30 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(7.5rem * var(--space-x-reverse));
    margin-left: calc(7.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(7.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(8rem * (1 - var(--space-y-reverse)));
    margin-top: calc(8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(8rem * var(--space-x-reverse));
    margin-left: calc(8rem * (1 - var(--space-x-reverse)));
    margin-left: calc(8rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-34 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(8.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(8.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(8.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-34 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(8.5rem * var(--space-x-reverse));
    margin-left: calc(8.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(8.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(10rem * (1 - var(--space-y-reverse)));
    margin-top: calc(10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(10rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(10rem * var(--space-x-reverse));
    margin-left: calc(10rem * (1 - var(--space-x-reverse)));
    margin-left: calc(10rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-42 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(10.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(10.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(10.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-42 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(10.5rem * var(--space-x-reverse));
    margin-left: calc(10.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(10.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-44 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(11rem * (1 - var(--space-y-reverse)));
    margin-top: calc(11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(11rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-44 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(11rem * var(--space-x-reverse));
    margin-left: calc(11rem * (1 - var(--space-x-reverse)));
    margin-left: calc(11rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(12rem * (1 - var(--space-y-reverse)));
    margin-top: calc(12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(12rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(12rem * var(--space-x-reverse));
    margin-left: calc(12rem * (1 - var(--space-x-reverse)));
    margin-left: calc(12rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-52 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(13rem * (1 - var(--space-y-reverse)));
    margin-top: calc(13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(13rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-52 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(13rem * var(--space-x-reverse));
    margin-left: calc(13rem * (1 - var(--space-x-reverse)));
    margin-left: calc(13rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-54 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(13.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(13.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(13.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-54 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(13.5rem * var(--space-x-reverse));
    margin-left: calc(13.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(13.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(14rem * (1 - var(--space-y-reverse)));
    margin-top: calc(14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(14rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(14rem * var(--space-x-reverse));
    margin-left: calc(14rem * (1 - var(--space-x-reverse)));
    margin-left: calc(14rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-60 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(15rem * (1 - var(--space-y-reverse)));
    margin-top: calc(15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(15rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-60 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(15rem * var(--space-x-reverse));
    margin-left: calc(15rem * (1 - var(--space-x-reverse)));
    margin-left: calc(15rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(16rem * (1 - var(--space-y-reverse)));
    margin-top: calc(16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(16rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(16rem * var(--space-x-reverse));
    margin-left: calc(16rem * (1 - var(--space-x-reverse)));
    margin-left: calc(16rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-68 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(17rem * (1 - var(--space-y-reverse)));
    margin-top: calc(17rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(17rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-68 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(17rem * var(--space-x-reverse));
    margin-left: calc(17rem * (1 - var(--space-x-reverse)));
    margin-left: calc(17rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-72 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(18rem * (1 - var(--space-y-reverse)));
    margin-top: calc(18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(18rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-72 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(18rem * var(--space-x-reverse));
    margin-left: calc(18rem * (1 - var(--space-x-reverse)));
    margin-left: calc(18rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-74 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(18.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(18.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(18.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-74 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(18.5rem * var(--space-x-reverse));
    margin-left: calc(18.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(18.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-76 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(19rem * (1 - var(--space-y-reverse)));
    margin-top: calc(19rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(19rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-76 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(19rem * var(--space-x-reverse));
    margin-left: calc(19rem * (1 - var(--space-x-reverse)));
    margin-left: calc(19rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-78 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(19.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(19.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(19.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-78 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(19.5rem * var(--space-x-reverse));
    margin-left: calc(19.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(19.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-80 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(20rem * (1 - var(--space-y-reverse)));
    margin-top: calc(20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-80 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(20rem * var(--space-x-reverse));
    margin-left: calc(20rem * (1 - var(--space-x-reverse)));
    margin-left: calc(20rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-82 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(20.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(20.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(20.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-82 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(20.5rem * var(--space-x-reverse));
    margin-left: calc(20.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(20.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-84 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(21rem * (1 - var(--space-y-reverse)));
    margin-top: calc(21rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(21rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-84 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(21rem * var(--space-x-reverse));
    margin-left: calc(21rem * (1 - var(--space-x-reverse)));
    margin-left: calc(21rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-88 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(22rem * (1 - var(--space-y-reverse)));
    margin-top: calc(22rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(22rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-88 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(22rem * var(--space-x-reverse));
    margin-left: calc(22rem * (1 - var(--space-x-reverse)));
    margin-left: calc(22rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-92 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(23rem * (1 - var(--space-y-reverse)));
    margin-top: calc(23rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(23rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-92 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(23rem * var(--space-x-reverse));
    margin-left: calc(23rem * (1 - var(--space-x-reverse)));
    margin-left: calc(23rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-96 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(24rem * (1 - var(--space-y-reverse)));
    margin-top: calc(24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(24rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-96 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(24rem * var(--space-x-reverse));
    margin-left: calc(24rem * (1 - var(--space-x-reverse)));
    margin-left: calc(24rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-98 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(24.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(24.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(24.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-98 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(24.5rem * var(--space-x-reverse));
    margin-left: calc(24.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(24.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-100 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(25rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-100 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(25rem * var(--space-x-reverse));
    margin-left: calc(25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-104 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(26rem * (1 - var(--space-y-reverse)));
    margin-top: calc(26rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(26rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-104 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(26rem * var(--space-x-reverse));
    margin-left: calc(26rem * (1 - var(--space-x-reverse)));
    margin-left: calc(26rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-112 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(28rem * (1 - var(--space-y-reverse)));
    margin-top: calc(28rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(28rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-112 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(28rem * var(--space-x-reverse));
    margin-left: calc(28rem * (1 - var(--space-x-reverse)));
    margin-left: calc(28rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-124 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(31rem * (1 - var(--space-y-reverse)));
    margin-top: calc(31rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(31rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-124 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(31rem * var(--space-x-reverse));
    margin-left: calc(31rem * (1 - var(--space-x-reverse)));
    margin-left: calc(31rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-128 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(32rem * (1 - var(--space-y-reverse)));
    margin-top: calc(32rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(32rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-128 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(32rem * var(--space-x-reverse));
    margin-left: calc(32rem * (1 - var(--space-x-reverse)));
    margin-left: calc(32rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-140 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(35rem * (1 - var(--space-y-reverse)));
    margin-top: calc(35rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(35rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-140 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(35rem * var(--space-x-reverse));
    margin-left: calc(35rem * (1 - var(--space-x-reverse)));
    margin-left: calc(35rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-152 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(38rem * (1 - var(--space-y-reverse)));
    margin-top: calc(38rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(38rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-152 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(38rem * var(--space-x-reverse));
    margin-left: calc(38rem * (1 - var(--space-x-reverse)));
    margin-left: calc(38rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-160 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(40rem * (1 - var(--space-y-reverse)));
    margin-top: calc(40rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(40rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-160 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(40rem * var(--space-x-reverse));
    margin-left: calc(40rem * (1 - var(--space-x-reverse)));
    margin-left: calc(40rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-162 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(41rem * (1 - var(--space-y-reverse)));
    margin-top: calc(41rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(41rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-162 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(41rem * var(--space-x-reverse));
    margin-left: calc(41rem * (1 - var(--space-x-reverse)));
    margin-left: calc(41rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-192 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(48rem * (1 - var(--space-y-reverse)));
    margin-top: calc(48rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(48rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-192 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(48rem * var(--space-x-reverse));
    margin-left: calc(48rem * (1 - var(--space-x-reverse)));
    margin-left: calc(48rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-208 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(52rem * (1 - var(--space-y-reverse)));
    margin-top: calc(52rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(52rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-208 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(52rem * var(--space-x-reverse));
    margin-left: calc(52rem * (1 - var(--space-x-reverse)));
    margin-left: calc(52rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-224 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(56rem * (1 - var(--space-y-reverse)));
    margin-top: calc(56rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(56rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-224 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(56rem * var(--space-x-reverse));
    margin-left: calc(56rem * (1 - var(--space-x-reverse)));
    margin-left: calc(56rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-256 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(64rem * (1 - var(--space-y-reverse)));
    margin-top: calc(64rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(64rem * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-256 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(64rem * var(--space-x-reverse));
    margin-left: calc(64rem * (1 - var(--space-x-reverse)));
    margin-left: calc(64rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(1px * (1 - var(--space-y-reverse)));
    margin-top: calc(1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(1px * var(--space-y-reverse));
  }

  .\\33xl\\:space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(1px * var(--space-x-reverse));
    margin-left: calc(1px * (1 - var(--space-x-reverse)));
    margin-left: calc(1px * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-1 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.25rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-1 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.25rem * var(--space-x-reverse));
    margin-left: calc(-0.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-2 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-2 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.5rem * var(--space-x-reverse));
    margin-left: calc(-0.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-3 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-0.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-0.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-0.75rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-3 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-0.75rem * var(--space-x-reverse));
    margin-left: calc(-0.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-0.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-4 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-4 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1rem * var(--space-x-reverse));
    margin-left: calc(-1rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-5 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.25rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-5 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.25rem * var(--space-x-reverse));
    margin-left: calc(-1.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-6 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-6 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.5rem * var(--space-x-reverse));
    margin-left: calc(-1.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-7 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-1.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1.75rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-7 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1.75rem * var(--space-x-reverse));
    margin-left: calc(-1.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-1.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-8 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-8 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2rem * var(--space-x-reverse));
    margin-left: calc(-2rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-9 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.25rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-9 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.25rem * var(--space-x-reverse));
    margin-left: calc(-2.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-10 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-10 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.5rem * var(--space-x-reverse));
    margin-left: calc(-2.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-11 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-2.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-2.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-2.75rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-11 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-2.75rem * var(--space-x-reverse));
    margin-left: calc(-2.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-2.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-12 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-12 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3rem * var(--space-x-reverse));
    margin-left: calc(-3rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-14 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-14 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3.5rem * var(--space-x-reverse));
    margin-left: calc(-3.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-15 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-3.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-3.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-3.75rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-15 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-3.75rem * var(--space-x-reverse));
    margin-left: calc(-3.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-3.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-16 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-4rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-4rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-4rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-16 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-4rem * var(--space-x-reverse));
    margin-left: calc(-4rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-4rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-18 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-4.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-4.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-4.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-18 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-4.5rem * var(--space-x-reverse));
    margin-left: calc(-4.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-4.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-20 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-20 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5rem * var(--space-x-reverse));
    margin-left: calc(-5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-22 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-22 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5.5rem * var(--space-x-reverse));
    margin-left: calc(-5.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-23 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-5.75rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-5.75rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-5.75rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-23 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-5.75rem * var(--space-x-reverse));
    margin-left: calc(-5.75rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-5.75rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-24 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-24 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6rem * var(--space-x-reverse));
    margin-left: calc(-6rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-25 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6.25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6.25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6.25rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-25 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6.25rem * var(--space-x-reverse));
    margin-left: calc(-6.25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6.25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-26 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-6.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-6.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-6.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-26 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-6.5rem * var(--space-x-reverse));
    margin-left: calc(-6.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-6.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-28 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-7rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-7rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-7rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-28 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-7rem * var(--space-x-reverse));
    margin-left: calc(-7rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-7rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-30 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-7.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-7.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-7.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-30 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-7.5rem * var(--space-x-reverse));
    margin-left: calc(-7.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-7.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-32 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-8rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-8rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-32 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-8rem * var(--space-x-reverse));
    margin-left: calc(-8rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-8rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-34 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-8.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-8.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-8.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-34 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-8.5rem * var(--space-x-reverse));
    margin-left: calc(-8.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-8.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-40 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-10rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-10rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-10rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-40 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-10rem * var(--space-x-reverse));
    margin-left: calc(-10rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-10rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-42 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-10.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-10.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-10.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-42 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-10.5rem * var(--space-x-reverse));
    margin-left: calc(-10.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-10.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-44 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-11rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-11rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-11rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-44 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-11rem * var(--space-x-reverse));
    margin-left: calc(-11rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-11rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-48 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-12rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-12rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-12rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-48 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-12rem * var(--space-x-reverse));
    margin-left: calc(-12rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-12rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-52 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-13rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-13rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-13rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-52 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-13rem * var(--space-x-reverse));
    margin-left: calc(-13rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-13rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-54 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-13.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-13.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-13.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-54 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-13.5rem * var(--space-x-reverse));
    margin-left: calc(-13.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-13.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-56 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-14rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-14rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-14rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-56 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-14rem * var(--space-x-reverse));
    margin-left: calc(-14rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-14rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-60 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-15rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-15rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-15rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-60 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-15rem * var(--space-x-reverse));
    margin-left: calc(-15rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-15rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-64 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-16rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-16rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-16rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-64 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-16rem * var(--space-x-reverse));
    margin-left: calc(-16rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-16rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-68 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-17rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-17rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-17rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-68 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-17rem * var(--space-x-reverse));
    margin-left: calc(-17rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-17rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-72 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-18rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-18rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-18rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-72 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-18rem * var(--space-x-reverse));
    margin-left: calc(-18rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-18rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-74 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-18.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-18.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-18.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-74 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-18.5rem * var(--space-x-reverse));
    margin-left: calc(-18.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-18.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-76 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-19rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-19rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-19rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-76 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-19rem * var(--space-x-reverse));
    margin-left: calc(-19rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-19rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-78 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-19.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-19.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-19.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-78 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-19.5rem * var(--space-x-reverse));
    margin-left: calc(-19.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-19.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-80 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-20rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-20rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-80 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-20rem * var(--space-x-reverse));
    margin-left: calc(-20rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-20rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-82 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-20.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-20.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-20.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-82 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-20.5rem * var(--space-x-reverse));
    margin-left: calc(-20.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-20.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-84 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-21rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-21rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-21rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-84 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-21rem * var(--space-x-reverse));
    margin-left: calc(-21rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-21rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-88 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-22rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-22rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-22rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-88 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-22rem * var(--space-x-reverse));
    margin-left: calc(-22rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-22rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-92 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-23rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-23rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-23rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-92 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-23rem * var(--space-x-reverse));
    margin-left: calc(-23rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-23rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-96 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-24rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-24rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-24rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-96 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-24rem * var(--space-x-reverse));
    margin-left: calc(-24rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-24rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-98 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-24.5rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-24.5rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-24.5rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-98 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-24.5rem * var(--space-x-reverse));
    margin-left: calc(-24.5rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-24.5rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-100 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-25rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-25rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-25rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-100 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-25rem * var(--space-x-reverse));
    margin-left: calc(-25rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-25rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-104 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-26rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-26rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-26rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-104 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-26rem * var(--space-x-reverse));
    margin-left: calc(-26rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-26rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-112 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-28rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-28rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-28rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-112 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-28rem * var(--space-x-reverse));
    margin-left: calc(-28rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-28rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-124 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-31rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-31rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-31rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-124 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-31rem * var(--space-x-reverse));
    margin-left: calc(-31rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-31rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-128 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-32rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-32rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-32rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-128 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-32rem * var(--space-x-reverse));
    margin-left: calc(-32rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-32rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-140 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-35rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-35rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-35rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-140 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-35rem * var(--space-x-reverse));
    margin-left: calc(-35rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-35rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-152 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-38rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-38rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-38rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-152 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-38rem * var(--space-x-reverse));
    margin-left: calc(-38rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-38rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-160 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-40rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-40rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-40rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-160 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-40rem * var(--space-x-reverse));
    margin-left: calc(-40rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-40rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-162 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-41rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-41rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-41rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-162 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-41rem * var(--space-x-reverse));
    margin-left: calc(-41rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-41rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-192 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-48rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-48rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-48rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-192 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-48rem * var(--space-x-reverse));
    margin-left: calc(-48rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-48rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-208 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-52rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-52rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-52rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-208 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-52rem * var(--space-x-reverse));
    margin-left: calc(-52rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-52rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-224 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-56rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-56rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-56rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-224 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-56rem * var(--space-x-reverse));
    margin-left: calc(-56rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-56rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-256 > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-64rem * (1 - var(--space-y-reverse)));
    margin-top: calc(-64rem * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-64rem * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-256 > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-64rem * var(--space-x-reverse));
    margin-left: calc(-64rem * (1 - var(--space-x-reverse)));
    margin-left: calc(-64rem * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:-space-y-px > :not(template) ~ :not(template){
    --space-y-reverse: 0;
    margin-top: calc(-1px * (1 - var(--space-y-reverse)));
    margin-top: calc(-1px * calc(1 - var(--space-y-reverse)));
    margin-bottom: calc(-1px * var(--space-y-reverse));
  }

  .\\33xl\\:-space-x-px > :not(template) ~ :not(template){
    --space-x-reverse: 0;
    margin-right: calc(-1px * var(--space-x-reverse));
    margin-left: calc(-1px * (1 - var(--space-x-reverse)));
    margin-left: calc(-1px * calc(1 - var(--space-x-reverse)));
  }

  .\\33xl\\:space-y-reverse > :not(template) ~ :not(template){
    --space-y-reverse: 1;
  }

  .\\33xl\\:space-x-reverse > :not(template) ~ :not(template){
    --space-x-reverse: 1;
  }

  .\\33xl\\:divide-y-0 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(0px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(0px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(0px * var(--divide-y-reverse));
  }

  .\\33xl\\:divide-x-0 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(0px * var(--divide-x-reverse));
    border-left-width: calc(0px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(0px * calc(1 - var(--divide-x-reverse)));
  }

  .\\33xl\\:divide-y-2 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(2px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(2px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(2px * var(--divide-y-reverse));
  }

  .\\33xl\\:divide-x-2 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(2px * var(--divide-x-reverse));
    border-left-width: calc(2px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(2px * calc(1 - var(--divide-x-reverse)));
  }

  .\\33xl\\:divide-y-3 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(3px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(3px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(3px * var(--divide-y-reverse));
  }

  .\\33xl\\:divide-x-3 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(3px * var(--divide-x-reverse));
    border-left-width: calc(3px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(3px * calc(1 - var(--divide-x-reverse)));
  }

  .\\33xl\\:divide-y-4 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(4px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(4px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(4px * var(--divide-y-reverse));
  }

  .\\33xl\\:divide-x-4 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(4px * var(--divide-x-reverse));
    border-left-width: calc(4px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(4px * calc(1 - var(--divide-x-reverse)));
  }

  .\\33xl\\:divide-y-5 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(5px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(5px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(5px * var(--divide-y-reverse));
  }

  .\\33xl\\:divide-x-5 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(5px * var(--divide-x-reverse));
    border-left-width: calc(5px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(5px * calc(1 - var(--divide-x-reverse)));
  }

  .\\33xl\\:divide-y-6 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(6px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(6px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(6px * var(--divide-y-reverse));
  }

  .\\33xl\\:divide-x-6 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(6px * var(--divide-x-reverse));
    border-left-width: calc(6px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(6px * calc(1 - var(--divide-x-reverse)));
  }

  .\\33xl\\:divide-y-8 > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(8px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(8px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(8px * var(--divide-y-reverse));
  }

  .\\33xl\\:divide-x-8 > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(8px * var(--divide-x-reverse));
    border-left-width: calc(8px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(8px * calc(1 - var(--divide-x-reverse)));
  }

  .\\33xl\\:divide-y > :not(template) ~ :not(template){
    --divide-y-reverse: 0;
    border-top-width: calc(1px * (1 - var(--divide-y-reverse)));
    border-top-width: calc(1px * calc(1 - var(--divide-y-reverse)));
    border-bottom-width: calc(1px * var(--divide-y-reverse));
  }

  .\\33xl\\:divide-x > :not(template) ~ :not(template){
    --divide-x-reverse: 0;
    border-right-width: calc(1px * var(--divide-x-reverse));
    border-left-width: calc(1px * (1 - var(--divide-x-reverse)));
    border-left-width: calc(1px * calc(1 - var(--divide-x-reverse)));
  }

  .\\33xl\\:divide-y-reverse > :not(template) ~ :not(template){
    --divide-y-reverse: 1;
  }

  .\\33xl\\:divide-x-reverse > :not(template) ~ :not(template){
    --divide-x-reverse: 1;
  }

  .\\33xl\\:divide-transparent > :not(template) ~ :not(template){
    border-color: transparent;
  }

  .\\33xl\\:divide-focus > :not(template) ~ :not(template){
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .\\33xl\\:divide-black > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--divide-opacity));
  }

  .\\33xl\\:divide-white > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--divide-opacity));
  }

  .\\33xl\\:divide-primary > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--divide-opacity));
  }

  .\\33xl\\:divide-disabled > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--divide-opacity));
  }

  .\\33xl\\:divide-translucent-60 > :not(template) ~ :not(template){
    border-color: rgba(256, 256, 256, 0.6);
  }

  .\\33xl\\:divide-translucent-90 > :not(template) ~ :not(template){
    border-color: rgba(256, 256, 256, 0.9);
  }

  .\\33xl\\:divide-green-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--divide-opacity));
  }

  .\\33xl\\:divide-green-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--divide-opacity));
  }

  .\\33xl\\:divide-green-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--divide-opacity));
  }

  .\\33xl\\:divide-green-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--divide-opacity));
  }

  .\\33xl\\:divide-green-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--divide-opacity));
  }

  .\\33xl\\:divide-green-400a50 > :not(template) ~ :not(template){
    border-color: rgba(108,202,152,0.50196);
  }

  .\\33xl\\:divide-green-500a25 > :not(template) ~ :not(template){
    border-color: rgba(151,232,18,0.09804);
  }

  .\\33xl\\:divide-yellow-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--divide-opacity));
  }

  .\\33xl\\:divide-yellow-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--divide-opacity));
  }

  .\\33xl\\:divide-yellow-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--divide-opacity));
  }

  .\\33xl\\:divide-yellow-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--divide-opacity));
  }

  .\\33xl\\:divide-yellow-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--divide-opacity));
  }

  .\\33xl\\:divide-yellow-300a66 > :not(template) ~ :not(template){
    border-color: rgba(255,233,189,0.66667);
  }

  .\\33xl\\:divide-yellow-500a25 > :not(template) ~ :not(template){
    border-color: rgba(255,200,44,0.09804);
  }

  .\\33xl\\:divide-orange-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--divide-opacity));
  }

  .\\33xl\\:divide-orange-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--divide-opacity));
  }

  .\\33xl\\:divide-orange-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--divide-opacity));
  }

  .\\33xl\\:divide-orange-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--divide-opacity));
  }

  .\\33xl\\:divide-orange-900 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--divide-opacity));
  }

  .\\33xl\\:divide-orange-500a25 > :not(template) ~ :not(template){
    border-color: rgba(240,115,23,0.09804);
  }

  .\\33xl\\:divide-red-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--divide-opacity));
  }

  .\\33xl\\:divide-red-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--divide-opacity));
  }

  .\\33xl\\:divide-red-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--divide-opacity));
  }

  .\\33xl\\:divide-red-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--divide-opacity));
  }

  .\\33xl\\:divide-red-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--divide-opacity));
  }

  .\\33xl\\:divide-red-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--divide-opacity));
  }

  .\\33xl\\:divide-red-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--divide-opacity));
  }

  .\\33xl\\:divide-gray-50 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--divide-opacity));
  }

  .\\33xl\\:divide-gray-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--divide-opacity));
  }

  .\\33xl\\:divide-gray-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--divide-opacity));
  }

  .\\33xl\\:divide-gray-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--divide-opacity));
  }

  .\\33xl\\:divide-gray-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--divide-opacity));
  }

  .\\33xl\\:divide-gray-400 > :not(template) ~ :not(template){
    border-color: rgba(114,114,114,0.8);
  }

  .\\33xl\\:divide-gray-425 > :not(template) ~ :not(template){
    border-color: rgba(4, 21, 39, 0.8);
  }

  .\\33xl\\:divide-gray-450 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--divide-opacity));
  }

  .\\33xl\\:divide-gray-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--divide-opacity));
  }

  .\\33xl\\:divide-gray-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--divide-opacity));
  }

  .\\33xl\\:divide-gray-625 > :not(template) ~ :not(template){
    border-color: rgba(90,98,107,0.8);
  }

  .\\33xl\\:divide-gray-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--divide-opacity));
  }

  .\\33xl\\:divide-gray-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--divide-opacity));
  }

  .\\33xl\\:divide-gray-200a50 > :not(template) ~ :not(template){
    border-color: rgba(224, 226, 228, 0.5);
  }

  .\\33xl\\:divide-blue-50 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--divide-opacity));
  }

  .\\33xl\\:divide-blue-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--divide-opacity));
  }

  .\\33xl\\:divide-blue-150 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--divide-opacity));
  }

  .\\33xl\\:divide-blue-200 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--divide-opacity));
  }

  .\\33xl\\:divide-blue-300 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--divide-opacity));
  }

  .\\33xl\\:divide-blue-400 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--divide-opacity));
  }

  .\\33xl\\:divide-blue-500 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--divide-opacity));
  }

  .\\33xl\\:divide-blue-600 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--divide-opacity));
  }

  .\\33xl\\:divide-blue-700 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--divide-opacity));
  }

  .\\33xl\\:divide-blue-750 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--divide-opacity));
  }

  .\\33xl\\:divide-blue-800 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--divide-opacity));
  }

  .\\33xl\\:divide-blue-900 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--divide-opacity));
  }

  .\\33xl\\:divide-blue-950 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--divide-opacity));
  }

  .\\33xl\\:divide-blue-500a25 > :not(template) ~ :not(template){
    border-color: rgba(55, 164, 220, 0.2);
  }

  .\\33xl\\:divide-blue-500a50 > :not(template) ~ :not(template){
    border-color: rgba(55, 164, 220, 0.5);
  }

  .\\33xl\\:divide-blue-700a75 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--divide-opacity));
  }

  .\\33xl\\:divide-blue-700a30 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--divide-opacity));
  }

  .\\33xl\\:divide-blue-750a25 > :not(template) ~ :not(template){
    border-color: rgba(86,130,170,0.09804);
  }

  .\\33xl\\:divide-blue-750a15 > :not(template) ~ :not(template){
    border-color: rgba(86,130,170,0.05882);
  }

  .\\33xl\\:divide-blue-800a60 > :not(template) ~ :not(template){
    border-color: rgba(31, 69, 102, 0.6);
  }

  .\\33xl\\:divide-programEditorTabColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--divide-opacity));
  }

  .\\33xl\\:divide-programEditorTabColors-2 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--divide-opacity));
  }

  .\\33xl\\:divide-programEditorTabColors-3 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--divide-opacity));
  }

  .\\33xl\\:divide-programEditorTabColors-4 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--divide-opacity));
  }

  .\\33xl\\:divide-programEditorTabColors-5 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--divide-opacity));
  }

  .\\33xl\\:divide-programEditorTabColors-6 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--divide-opacity));
  }

  .\\33xl\\:divide-programEditorTabColors-1h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--divide-opacity));
  }

  .\\33xl\\:divide-programEditorTabColors-2h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--divide-opacity));
  }

  .\\33xl\\:divide-programEditorTabColors-3h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--divide-opacity));
  }

  .\\33xl\\:divide-programEditorTabColors-4h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--divide-opacity));
  }

  .\\33xl\\:divide-programEditorTabColors-5h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--divide-opacity));
  }

  .\\33xl\\:divide-programEditorTabColors-6h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--divide-opacity));
  }

  .\\33xl\\:divide-programEditorPresetTabColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--divide-opacity));
  }

  .\\33xl\\:divide-programEditorPresetTabColors-1h > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--divide-opacity));
  }

  .\\33xl\\:divide-borgScaleColors-0 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--divide-opacity));
  }

  .\\33xl\\:divide-borgScaleColors-1 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--divide-opacity));
  }

  .\\33xl\\:divide-borgScaleColors-2 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--divide-opacity));
  }

  .\\33xl\\:divide-borgScaleColors-3 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--divide-opacity));
  }

  .\\33xl\\:divide-borgScaleColors-4 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--divide-opacity));
  }

  .\\33xl\\:divide-borgScaleColors-5 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--divide-opacity));
  }

  .\\33xl\\:divide-borgScaleColors-6 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--divide-opacity));
  }

  .\\33xl\\:divide-borgScaleColors-7 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--divide-opacity));
  }

  .\\33xl\\:divide-borgScaleColors-8 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--divide-opacity));
  }

  .\\33xl\\:divide-borgScaleColors-9 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--divide-opacity));
  }

  .\\33xl\\:divide-borgScaleColors-10 > :not(template) ~ :not(template){
    --divide-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--divide-opacity));
  }

  .\\33xl\\:divide-solid > :not(template) ~ :not(template){
    border-style: solid;
  }

  .\\33xl\\:divide-dashed > :not(template) ~ :not(template){
    border-style: dashed;
  }

  .\\33xl\\:divide-dotted > :not(template) ~ :not(template){
    border-style: dotted;
  }

  .\\33xl\\:divide-double > :not(template) ~ :not(template){
    border-style: double;
  }

  .\\33xl\\:divide-none > :not(template) ~ :not(template){
    border-style: none;
  }

  .\\33xl\\:divide-opacity-0 > :not(template) ~ :not(template){
    --divide-opacity: 0;
  }

  .\\33xl\\:divide-opacity-25 > :not(template) ~ :not(template){
    --divide-opacity: .25;
  }

  .\\33xl\\:divide-opacity-50 > :not(template) ~ :not(template){
    --divide-opacity: .5;
  }

  .\\33xl\\:divide-opacity-75 > :not(template) ~ :not(template){
    --divide-opacity: .75;
  }

  .\\33xl\\:divide-opacity-100 > :not(template) ~ :not(template){
    --divide-opacity: 1;
  }

  .\\33xl\\:sr-only{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .\\33xl\\:not-sr-only{
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .\\33xl\\:focus\\:sr-only:focus{
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .\\33xl\\:focus\\:not-sr-only:focus{
    position: static;
    width: auto;
    height: auto;
    padding: 0;
    margin: 0;
    overflow: visible;
    clip: auto;
    white-space: normal;
  }

  .\\33xl\\:appearance-none{
    -webkit-appearance: none;
            appearance: none;
  }

  .\\33xl\\:bg-fixed{
    background-attachment: fixed;
  }

  .\\33xl\\:bg-local{
    background-attachment: local;
  }

  .\\33xl\\:bg-scroll{
    background-attachment: scroll;
  }

  .\\33xl\\:bg-clip-border{
    background-clip: border-box;
  }

  .\\33xl\\:bg-clip-padding{
    background-clip: padding-box;
  }

  .\\33xl\\:bg-clip-content{
    background-clip: content-box;
  }

  .\\33xl\\:bg-clip-text{
    -webkit-background-clip: text;
            background-clip: text;
  }

  .\\33xl\\:bg-transparent{
    background-color: transparent;
  }

  .\\33xl\\:bg-focus{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .\\33xl\\:bg-black{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .\\33xl\\:bg-white{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .\\33xl\\:bg-primary{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .\\33xl\\:bg-disabled{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .\\33xl\\:bg-translucent-60{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .\\33xl\\:bg-translucent-90{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .\\33xl\\:bg-green-200{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .\\33xl\\:bg-green-400{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .\\33xl\\:bg-green-500{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .\\33xl\\:bg-green-600{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .\\33xl\\:bg-green-700{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .\\33xl\\:bg-green-400a50{
    background-color: rgba(108,202,152,0.50196);
  }

  .\\33xl\\:bg-green-500a25{
    background-color: rgba(151,232,18,0.09804);
  }

  .\\33xl\\:bg-yellow-200{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .\\33xl\\:bg-yellow-300{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .\\33xl\\:bg-yellow-500{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .\\33xl\\:bg-yellow-600{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .\\33xl\\:bg-yellow-700{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .\\33xl\\:bg-yellow-300a66{
    background-color: rgba(255,233,189,0.66667);
  }

  .\\33xl\\:bg-yellow-500a25{
    background-color: rgba(255,200,44,0.09804);
  }

  .\\33xl\\:bg-orange-200{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .\\33xl\\:bg-orange-400{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .\\33xl\\:bg-orange-500{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .\\33xl\\:bg-orange-800{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .\\33xl\\:bg-orange-900{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .\\33xl\\:bg-orange-500a25{
    background-color: rgba(240,115,23,0.09804);
  }

  .\\33xl\\:bg-red-100{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .\\33xl\\:bg-red-150{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .\\33xl\\:bg-red-200{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .\\33xl\\:bg-red-300{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .\\33xl\\:bg-red-400{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .\\33xl\\:bg-red-500{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .\\33xl\\:bg-red-700{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .\\33xl\\:bg-gray-50{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .\\33xl\\:bg-gray-100{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .\\33xl\\:bg-gray-150{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .\\33xl\\:bg-gray-200{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .\\33xl\\:bg-gray-300{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .\\33xl\\:bg-gray-400{
    background-color: rgba(114,114,114,0.8);
  }

  .\\33xl\\:bg-gray-425{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .\\33xl\\:bg-gray-450{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .\\33xl\\:bg-gray-500{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .\\33xl\\:bg-gray-600{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .\\33xl\\:bg-gray-625{
    background-color: rgba(90,98,107,0.8);
  }

  .\\33xl\\:bg-gray-700{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .\\33xl\\:bg-gray-800{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .\\33xl\\:bg-gray-200a50{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .\\33xl\\:bg-blue-50{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .\\33xl\\:bg-blue-100{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .\\33xl\\:bg-blue-150{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .\\33xl\\:bg-blue-200{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .\\33xl\\:bg-blue-300{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .\\33xl\\:bg-blue-400{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .\\33xl\\:bg-blue-500{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .\\33xl\\:bg-blue-600{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .\\33xl\\:bg-blue-700{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .\\33xl\\:bg-blue-750{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .\\33xl\\:bg-blue-800{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .\\33xl\\:bg-blue-900{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .\\33xl\\:bg-blue-950{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .\\33xl\\:bg-blue-500a25{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .\\33xl\\:bg-blue-500a50{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .\\33xl\\:bg-blue-700a75{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .\\33xl\\:bg-blue-700a30{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .\\33xl\\:bg-blue-750a25{
    background-color: rgba(86,130,170,0.09804);
  }

  .\\33xl\\:bg-blue-750a15{
    background-color: rgba(86,130,170,0.05882);
  }

  .\\33xl\\:bg-blue-800a60{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .\\33xl\\:bg-programEditorTabColors-1{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .\\33xl\\:bg-programEditorTabColors-2{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .\\33xl\\:bg-programEditorTabColors-3{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .\\33xl\\:bg-programEditorTabColors-4{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .\\33xl\\:bg-programEditorTabColors-5{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .\\33xl\\:bg-programEditorTabColors-6{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .\\33xl\\:bg-programEditorTabColors-1h{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .\\33xl\\:bg-programEditorTabColors-2h{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .\\33xl\\:bg-programEditorTabColors-3h{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .\\33xl\\:bg-programEditorTabColors-4h{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .\\33xl\\:bg-programEditorTabColors-5h{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .\\33xl\\:bg-programEditorTabColors-6h{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .\\33xl\\:bg-programEditorPresetTabColors-1{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .\\33xl\\:bg-programEditorPresetTabColors-1h{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .\\33xl\\:bg-borgScaleColors-0{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .\\33xl\\:bg-borgScaleColors-1{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .\\33xl\\:bg-borgScaleColors-2{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .\\33xl\\:bg-borgScaleColors-3{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .\\33xl\\:bg-borgScaleColors-4{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .\\33xl\\:bg-borgScaleColors-5{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .\\33xl\\:bg-borgScaleColors-6{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .\\33xl\\:bg-borgScaleColors-7{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .\\33xl\\:bg-borgScaleColors-8{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .\\33xl\\:bg-borgScaleColors-9{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .\\33xl\\:bg-borgScaleColors-10{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-transparent:hover{
    background-color: transparent;
  }

  .\\33xl\\:hover\\:bg-focus:hover{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .\\33xl\\:hover\\:bg-black:hover{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-white:hover{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-primary:hover{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-disabled:hover{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-translucent-60:hover{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .\\33xl\\:hover\\:bg-translucent-90:hover{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .\\33xl\\:hover\\:bg-green-200:hover{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-green-400:hover{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-green-500:hover{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-green-600:hover{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-green-700:hover{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-green-400a50:hover{
    background-color: rgba(108,202,152,0.50196);
  }

  .\\33xl\\:hover\\:bg-green-500a25:hover{
    background-color: rgba(151,232,18,0.09804);
  }

  .\\33xl\\:hover\\:bg-yellow-200:hover{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-yellow-300:hover{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-yellow-500:hover{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-yellow-600:hover{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-yellow-700:hover{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-yellow-300a66:hover{
    background-color: rgba(255,233,189,0.66667);
  }

  .\\33xl\\:hover\\:bg-yellow-500a25:hover{
    background-color: rgba(255,200,44,0.09804);
  }

  .\\33xl\\:hover\\:bg-orange-200:hover{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-orange-400:hover{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-orange-500:hover{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-orange-800:hover{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-orange-900:hover{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-orange-500a25:hover{
    background-color: rgba(240,115,23,0.09804);
  }

  .\\33xl\\:hover\\:bg-red-100:hover{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-red-150:hover{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-red-200:hover{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-red-300:hover{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-red-400:hover{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-red-500:hover{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-red-700:hover{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-gray-50:hover{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-gray-100:hover{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-gray-150:hover{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-gray-200:hover{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-gray-300:hover{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-gray-400:hover{
    background-color: rgba(114,114,114,0.8);
  }

  .\\33xl\\:hover\\:bg-gray-425:hover{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .\\33xl\\:hover\\:bg-gray-450:hover{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-gray-500:hover{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-gray-600:hover{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-gray-625:hover{
    background-color: rgba(90,98,107,0.8);
  }

  .\\33xl\\:hover\\:bg-gray-700:hover{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-gray-800:hover{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-gray-200a50:hover{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .\\33xl\\:hover\\:bg-blue-50:hover{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-blue-100:hover{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-blue-150:hover{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-blue-200:hover{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-blue-300:hover{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-blue-400:hover{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-blue-500:hover{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-blue-600:hover{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-blue-700:hover{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-blue-750:hover{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-blue-800:hover{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-blue-900:hover{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-blue-950:hover{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-blue-500a25:hover{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .\\33xl\\:hover\\:bg-blue-500a50:hover{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .\\33xl\\:hover\\:bg-blue-700a75:hover{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-blue-700a30:hover{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-blue-750a25:hover{
    background-color: rgba(86,130,170,0.09804);
  }

  .\\33xl\\:hover\\:bg-blue-750a15:hover{
    background-color: rgba(86,130,170,0.05882);
  }

  .\\33xl\\:hover\\:bg-blue-800a60:hover{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .\\33xl\\:hover\\:bg-programEditorTabColors-1:hover{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-programEditorTabColors-2:hover{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-programEditorTabColors-3:hover{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-programEditorTabColors-4:hover{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-programEditorTabColors-5:hover{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-programEditorTabColors-6:hover{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-programEditorTabColors-1h:hover{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-programEditorTabColors-2h:hover{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-programEditorTabColors-3h:hover{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-programEditorTabColors-4h:hover{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-programEditorTabColors-5h:hover{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-programEditorTabColors-6h:hover{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-programEditorPresetTabColors-1:hover{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-programEditorPresetTabColors-1h:hover{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-borgScaleColors-0:hover{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-borgScaleColors-1:hover{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-borgScaleColors-2:hover{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-borgScaleColors-3:hover{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-borgScaleColors-4:hover{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-borgScaleColors-5:hover{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-borgScaleColors-6:hover{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-borgScaleColors-7:hover{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-borgScaleColors-8:hover{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-borgScaleColors-9:hover{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .\\33xl\\:hover\\:bg-borgScaleColors-10:hover{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-transparent:focus{
    background-color: transparent;
  }

  .\\33xl\\:focus\\:bg-focus:focus{
    background-color: rgba(4, 21, 39, 0.8);;
  }

  .\\33xl\\:focus\\:bg-black:focus{
    --bg-opacity: 1;
    background-color: #000;
    background-color: rgba(0, 0, 0, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-white:focus{
    --bg-opacity: 1;
    background-color: #fff;
    background-color: rgba(255, 255, 255, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-primary:focus{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-disabled:focus{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-translucent-60:focus{
    background-color: rgba(256, 256, 256, 0.6);
  }

  .\\33xl\\:focus\\:bg-translucent-90:focus{
    background-color: rgba(256, 256, 256, 0.9);
  }

  .\\33xl\\:focus\\:bg-green-200:focus{
    --bg-opacity: 1;
    background-color: #f4fcea;
    background-color: rgba(244, 252, 234, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-green-400:focus{
    --bg-opacity: 1;
    background-color: #6CCA98;
    background-color: rgba(108, 202, 152, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-green-500:focus{
    --bg-opacity: 1;
    background-color: #97E812;
    background-color: rgba(151, 232, 18, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-green-600:focus{
    --bg-opacity: 1;
    background-color: #4f9112;
    background-color: rgba(79, 145, 18, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-green-700:focus{
    --bg-opacity: 1;
    background-color: #3e7211;
    background-color: rgba(62, 114, 17, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-green-400a50:focus{
    background-color: rgba(108,202,152,0.50196);
  }

  .\\33xl\\:focus\\:bg-green-500a25:focus{
    background-color: rgba(151,232,18,0.09804);
  }

  .\\33xl\\:focus\\:bg-yellow-200:focus{
    --bg-opacity: 1;
    background-color: #fff9eb;
    background-color: rgba(255, 249, 235, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-yellow-300:focus{
    --bg-opacity: 1;
    background-color: #ffe9bd;
    background-color: rgba(255, 233, 189, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-yellow-500:focus{
    --bg-opacity: 1;
    background-color: #FFC82C;
    background-color: rgba(255, 200, 44, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-yellow-600:focus{
    --bg-opacity: 1;
    background-color: #F7931E;
    background-color: rgba(247, 147, 30, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-yellow-700:focus{
    --bg-opacity: 1;
    background-color: #E1AD28;
    background-color: rgba(225, 173, 40, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-yellow-300a66:focus{
    background-color: rgba(255,233,189,0.66667);
  }

  .\\33xl\\:focus\\:bg-yellow-500a25:focus{
    background-color: rgba(255,200,44,0.09804);
  }

  .\\33xl\\:focus\\:bg-orange-200:focus{
    --bg-opacity: 1;
    background-color: #fdf0ea;
    background-color: rgba(253, 240, 234, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-orange-400:focus{
    --bg-opacity: 1;
    background-color: #f6c66f;
    background-color: rgba(246, 198, 111, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-orange-500:focus{
    --bg-opacity: 1;
    background-color: #F07313;
    background-color: rgba(240, 115, 19, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-orange-800:focus{
    --bg-opacity: 1;
    background-color: #db5d0c;
    background-color: rgba(219, 93, 12, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-orange-900:focus{
    --bg-opacity: 1;
    background-color: #b86814;
    background-color: rgba(184, 104, 20, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-orange-500a25:focus{
    background-color: rgba(240,115,23,0.09804);
  }

  .\\33xl\\:focus\\:bg-red-100:focus{
    --bg-opacity: 1;
    background-color: #FEF5F5;
    background-color: rgba(254, 245, 245, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-red-150:focus{
    --bg-opacity: 1;
    background-color: #ffe9e8;
    background-color: rgba(255, 233, 232, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-red-200:focus{
    --bg-opacity: 1;
    background-color: #F8CECC;
    background-color: rgba(248, 206, 204, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-red-300:focus{
    --bg-opacity: 1;
    background-color: #ff8585;
    background-color: rgba(255, 133, 133, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-red-400:focus{
    --bg-opacity: 1;
    background-color: #ff3535;
    background-color: rgba(255, 53, 53, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-red-500:focus{
    --bg-opacity: 1;
    background-color: #DD4746;
    background-color: rgba(221, 71, 70, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-red-700:focus{
    --bg-opacity: 1;
    background-color: #A23C24;
    background-color: rgba(162, 60, 36, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-gray-50:focus{
    --bg-opacity: 1;
    background-color: #F9F9F9;
    background-color: rgba(249, 249, 249, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-gray-100:focus{
    --bg-opacity: 1;
    background-color: #F1F1F2;
    background-color: rgba(241, 241, 242, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-gray-150:focus{
    --bg-opacity: 1;
    background-color: #e6e6e6;
    background-color: rgba(230, 230, 230, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-gray-200:focus{
    --bg-opacity: 1;
    background-color: #E0E2E4;
    background-color: rgba(224, 226, 228, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-gray-300:focus{
    --bg-opacity: 1;
    background-color: #BFBFBF;
    background-color: rgba(191, 191, 191, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-gray-400:focus{
    background-color: rgba(114,114,114,0.8);
  }

  .\\33xl\\:focus\\:bg-gray-425:focus{
    background-color: rgba(4, 21, 39, 0.8);
  }

  .\\33xl\\:focus\\:bg-gray-450:focus{
    --bg-opacity: 1;
    background-color: #959595;
    background-color: rgba(149, 149, 149, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-gray-500:focus{
    --bg-opacity: 1;
    background-color: #727272;
    background-color: rgba(114, 114, 114, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-gray-600:focus{
    --bg-opacity: 1;
    background-color: #5a626b;
    background-color: rgba(90, 98, 107, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-gray-625:focus{
    background-color: rgba(90,98,107,0.8);
  }

  .\\33xl\\:focus\\:bg-gray-700:focus{
    --bg-opacity: 1;
    background-color: #464C59;
    background-color: rgba(70, 76, 89, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-gray-800:focus{
    --bg-opacity: 1;
    background-color: #3c3b3b;
    background-color: rgba(60, 59, 59, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-gray-200a50:focus{
    background-color: rgba(224, 226, 228, 0.5);
  }

  .\\33xl\\:focus\\:bg-blue-50:focus{
    --bg-opacity: 1;
    background-color: #f2fbff;
    background-color: rgba(242, 251, 255, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-blue-100:focus{
    --bg-opacity: 1;
    background-color: #EBF6FC;
    background-color: rgba(235, 246, 252, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-blue-150:focus{
    --bg-opacity: 1;
    background-color: #E8EEF1;
    background-color: rgba(232, 238, 241, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-blue-200:focus{
    --bg-opacity: 1;
    background-color: #CCE6F5;
    background-color: rgba(204, 230, 245, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-blue-300:focus{
    --bg-opacity: 1;
    background-color: #73BFE7;
    background-color: rgba(115, 191, 231, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-blue-400:focus{
    --bg-opacity: 1;
    background-color: #4BA4F7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-blue-500:focus{
    --bg-opacity: 1;
    background-color: #37A4DC;
    background-color: rgba(55, 164, 220, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-blue-600:focus{
    --bg-opacity: 1;
    background-color: #6AA2D6;
    background-color: rgba(106, 162, 214, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-blue-700:focus{
    --bg-opacity: 1;
    background-color: #456E9A;
    background-color: rgba(69, 110, 154, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-blue-750:focus{
    --bg-opacity: 1;
    background-color: #5682AA;
    background-color: rgba(86, 130, 170, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-blue-800:focus{
    --bg-opacity: 1;
    background-color: #1F4566;
    background-color: rgba(31, 69, 102, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-blue-900:focus{
    --bg-opacity: 1;
    background-color: #183453;
    background-color: rgba(24, 52, 83, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-blue-950:focus{
    --bg-opacity: 1;
    background-color: #041527;
    background-color: rgba(4, 21, 39, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-blue-500a25:focus{
    background-color: rgba(55, 164, 220, 0.2);
  }

  .\\33xl\\:focus\\:bg-blue-500a50:focus{
    background-color: rgba(55, 164, 220, 0.5);
  }

  .\\33xl\\:focus\\:bg-blue-700a75:focus{
    --bg-opacity: 1;
    background-color: #3B648D;
    background-color: rgba(59, 100, 141, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-blue-700a30:focus{
    --bg-opacity: 1;
    background-color: #2A5176;
    background-color: rgba(42, 81, 118, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-blue-750a25:focus{
    background-color: rgba(86,130,170,0.09804);
  }

  .\\33xl\\:focus\\:bg-blue-750a15:focus{
    background-color: rgba(86,130,170,0.05882);
  }

  .\\33xl\\:focus\\:bg-blue-800a60:focus{
    background-color: rgba(31, 69, 102, 0.6);
  }

  .\\33xl\\:focus\\:bg-programEditorTabColors-1:focus{
    --bg-opacity: 1;
    background-color: #3cacae;
    background-color: rgba(60, 172, 174, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-programEditorTabColors-2:focus{
    --bg-opacity: 1;
    background-color: #8e346a;
    background-color: rgba(142, 52, 106, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-programEditorTabColors-3:focus{
    --bg-opacity: 1;
    background-color: #ff72b7;
    background-color: rgba(255, 114, 183, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-programEditorTabColors-4:focus{
    --bg-opacity: 1;
    background-color: #ce941c;
    background-color: rgba(206, 148, 28, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-programEditorTabColors-5:focus{
    --bg-opacity: 1;
    background-color: #b973d9;
    background-color: rgba(185, 115, 217, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-programEditorTabColors-6:focus{
    --bg-opacity: 1;
    background-color: #ff9082;
    background-color: rgba(255, 144, 130, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-programEditorTabColors-1h:focus{
    --bg-opacity: 1;
    background-color: #d9f2f2;
    background-color: rgba(217, 242, 242, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-programEditorTabColors-2h:focus{
    --bg-opacity: 1;
    background-color: #f1dae8;
    background-color: rgba(241, 218, 232, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-programEditorTabColors-3h:focus{
    --bg-opacity: 1;
    background-color: #ffe6f2;
    background-color: rgba(255, 230, 242, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-programEditorTabColors-4h:focus{
    --bg-opacity: 1;
    background-color: #f9ecd2;
    background-color: rgba(249, 236, 210, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-programEditorTabColors-5h:focus{
    --bg-opacity: 1;
    background-color: #f5ebfa;
    background-color: rgba(245, 235, 250, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-programEditorTabColors-6h:focus{
    --bg-opacity: 1;
    background-color: #ffe8e6;
    background-color: rgba(255, 232, 230, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-programEditorPresetTabColors-1:focus{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-programEditorPresetTabColors-1h:focus{
    --bg-opacity: 1;
    background-color: #798fa3;
    background-color: rgba(121, 143, 163, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-borgScaleColors-0:focus{
    --bg-opacity: 1;
    background-color: #c5d1ff;
    background-color: rgba(197, 209, 255, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-borgScaleColors-1:focus{
    --bg-opacity: 1;
    background-color: #a0b5fc;
    background-color: rgba(160, 181, 252, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-borgScaleColors-2:focus{
    --bg-opacity: 1;
    background-color: #7492ff;
    background-color: rgba(116, 146, 255, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-borgScaleColors-3:focus{
    --bg-opacity: 1;
    background-color: #82bbf1;
    background-color: rgba(130, 187, 241, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-borgScaleColors-4:focus{
    --bg-opacity: 1;
    background-color: #4ba4f7;
    background-color: rgba(75, 164, 247, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-borgScaleColors-5:focus{
    --bg-opacity: 1;
    background-color: #9cdd57;
    background-color: rgba(156, 221, 87, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-borgScaleColors-6:focus{
    --bg-opacity: 1;
    background-color: #68af00;
    background-color: rgba(104, 175, 0, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-borgScaleColors-7:focus{
    --bg-opacity: 1;
    background-color: #f5e380;
    background-color: rgba(245, 227, 128, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-borgScaleColors-8:focus{
    --bg-opacity: 1;
    background-color: #ffc246;
    background-color: rgba(255, 194, 70, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-borgScaleColors-9:focus{
    --bg-opacity: 1;
    background-color: #ff782f;
    background-color: rgba(255, 120, 47, var(--bg-opacity));
  }

  .\\33xl\\:focus\\:bg-borgScaleColors-10:focus{
    --bg-opacity: 1;
    background-color: #f25757;
    background-color: rgba(242, 87, 87, var(--bg-opacity));
  }

  .\\33xl\\:bg-none{
    background-image: none;
  }

  .\\33xl\\:bg-gradient-to-t{
    background-image: linear-gradient(to top, var(--gradient-color-stops));
  }

  .\\33xl\\:bg-gradient-to-tr{
    background-image: linear-gradient(to top right, var(--gradient-color-stops));
  }

  .\\33xl\\:bg-gradient-to-r{
    background-image: linear-gradient(to right, var(--gradient-color-stops));
  }

  .\\33xl\\:bg-gradient-to-br{
    background-image: linear-gradient(to bottom right, var(--gradient-color-stops));
  }

  .\\33xl\\:bg-gradient-to-b{
    background-image: linear-gradient(to bottom, var(--gradient-color-stops));
  }

  .\\33xl\\:bg-gradient-to-bl{
    background-image: linear-gradient(to bottom left, var(--gradient-color-stops));
  }

  .\\33xl\\:bg-gradient-to-l{
    background-image: linear-gradient(to left, var(--gradient-color-stops));
  }

  .\\33xl\\:bg-gradient-to-tl{
    background-image: linear-gradient(to top left, var(--gradient-color-stops));
  }

  .\\33xl\\:from-transparent{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\33xl\\:from-focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:from-black{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\33xl\\:from-white{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:from-primary{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:from-disabled{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\33xl\\:from-translucent-60{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:from-translucent-90{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:from-green-200{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .\\33xl\\:from-green-400{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\33xl\\:from-green-500{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\33xl\\:from-green-600{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .\\33xl\\:from-green-700{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .\\33xl\\:from-green-400a50{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\33xl\\:from-green-500a25{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\33xl\\:from-yellow-200{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .\\33xl\\:from-yellow-300{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\33xl\\:from-yellow-500{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\33xl\\:from-yellow-600{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .\\33xl\\:from-yellow-700{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .\\33xl\\:from-yellow-300a66{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\33xl\\:from-yellow-500a25{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\33xl\\:from-orange-200{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .\\33xl\\:from-orange-400{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .\\33xl\\:from-orange-500{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .\\33xl\\:from-orange-800{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .\\33xl\\:from-orange-900{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .\\33xl\\:from-orange-500a25{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .\\33xl\\:from-red-100{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .\\33xl\\:from-red-150{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .\\33xl\\:from-red-200{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .\\33xl\\:from-red-300{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .\\33xl\\:from-red-400{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .\\33xl\\:from-red-500{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .\\33xl\\:from-red-700{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .\\33xl\\:from-gray-50{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .\\33xl\\:from-gray-100{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .\\33xl\\:from-gray-150{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .\\33xl\\:from-gray-200{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\33xl\\:from-gray-300{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\33xl\\:from-gray-400{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\33xl\\:from-gray-425{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\33xl\\:from-gray-450{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .\\33xl\\:from-gray-500{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\33xl\\:from-gray-600{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\33xl\\:from-gray-625{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\33xl\\:from-gray-700{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .\\33xl\\:from-gray-800{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .\\33xl\\:from-gray-200a50{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\33xl\\:from-blue-50{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .\\33xl\\:from-blue-100{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .\\33xl\\:from-blue-150{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .\\33xl\\:from-blue-200{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .\\33xl\\:from-blue-300{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .\\33xl\\:from-blue-400{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\33xl\\:from-blue-500{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:from-blue-600{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .\\33xl\\:from-blue-700{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .\\33xl\\:from-blue-750{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:from-blue-800{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\33xl\\:from-blue-900{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .\\33xl\\:from-blue-950{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\33xl\\:from-blue-500a25{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:from-blue-500a50{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:from-blue-700a75{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .\\33xl\\:from-blue-700a30{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .\\33xl\\:from-blue-750a25{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:from-blue-750a15{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:from-blue-800a60{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\33xl\\:from-programEditorTabColors-1{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .\\33xl\\:from-programEditorTabColors-2{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .\\33xl\\:from-programEditorTabColors-3{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .\\33xl\\:from-programEditorTabColors-4{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .\\33xl\\:from-programEditorTabColors-5{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .\\33xl\\:from-programEditorTabColors-6{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .\\33xl\\:from-programEditorTabColors-1h{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .\\33xl\\:from-programEditorTabColors-2h{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .\\33xl\\:from-programEditorTabColors-3h{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .\\33xl\\:from-programEditorTabColors-4h{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .\\33xl\\:from-programEditorTabColors-5h{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .\\33xl\\:from-programEditorTabColors-6h{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .\\33xl\\:from-programEditorPresetTabColors-1{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\33xl\\:from-programEditorPresetTabColors-1h{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\33xl\\:from-borgScaleColors-0{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .\\33xl\\:from-borgScaleColors-1{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .\\33xl\\:from-borgScaleColors-2{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .\\33xl\\:from-borgScaleColors-3{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .\\33xl\\:from-borgScaleColors-4{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\33xl\\:from-borgScaleColors-5{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .\\33xl\\:from-borgScaleColors-6{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .\\33xl\\:from-borgScaleColors-7{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .\\33xl\\:from-borgScaleColors-8{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .\\33xl\\:from-borgScaleColors-9{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .\\33xl\\:from-borgScaleColors-10{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .\\33xl\\:via-transparent{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\33xl\\:via-focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:via-black{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\33xl\\:via-white{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:via-primary{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:via-disabled{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\33xl\\:via-translucent-60{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:via-translucent-90{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:via-green-200{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .\\33xl\\:via-green-400{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\33xl\\:via-green-500{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\33xl\\:via-green-600{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .\\33xl\\:via-green-700{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .\\33xl\\:via-green-400a50{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\33xl\\:via-green-500a25{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\33xl\\:via-yellow-200{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .\\33xl\\:via-yellow-300{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\33xl\\:via-yellow-500{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\33xl\\:via-yellow-600{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .\\33xl\\:via-yellow-700{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .\\33xl\\:via-yellow-300a66{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\33xl\\:via-yellow-500a25{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\33xl\\:via-orange-200{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .\\33xl\\:via-orange-400{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .\\33xl\\:via-orange-500{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .\\33xl\\:via-orange-800{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .\\33xl\\:via-orange-900{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .\\33xl\\:via-orange-500a25{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .\\33xl\\:via-red-100{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .\\33xl\\:via-red-150{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .\\33xl\\:via-red-200{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .\\33xl\\:via-red-300{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .\\33xl\\:via-red-400{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .\\33xl\\:via-red-500{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .\\33xl\\:via-red-700{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .\\33xl\\:via-gray-50{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .\\33xl\\:via-gray-100{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .\\33xl\\:via-gray-150{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .\\33xl\\:via-gray-200{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\33xl\\:via-gray-300{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\33xl\\:via-gray-400{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\33xl\\:via-gray-425{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\33xl\\:via-gray-450{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .\\33xl\\:via-gray-500{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\33xl\\:via-gray-600{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\33xl\\:via-gray-625{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\33xl\\:via-gray-700{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .\\33xl\\:via-gray-800{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .\\33xl\\:via-gray-200a50{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\33xl\\:via-blue-50{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .\\33xl\\:via-blue-100{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .\\33xl\\:via-blue-150{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .\\33xl\\:via-blue-200{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .\\33xl\\:via-blue-300{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .\\33xl\\:via-blue-400{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\33xl\\:via-blue-500{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:via-blue-600{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .\\33xl\\:via-blue-700{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .\\33xl\\:via-blue-750{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:via-blue-800{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\33xl\\:via-blue-900{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .\\33xl\\:via-blue-950{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\33xl\\:via-blue-500a25{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:via-blue-500a50{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:via-blue-700a75{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .\\33xl\\:via-blue-700a30{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .\\33xl\\:via-blue-750a25{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:via-blue-750a15{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:via-blue-800a60{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\33xl\\:via-programEditorTabColors-1{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .\\33xl\\:via-programEditorTabColors-2{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .\\33xl\\:via-programEditorTabColors-3{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .\\33xl\\:via-programEditorTabColors-4{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .\\33xl\\:via-programEditorTabColors-5{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .\\33xl\\:via-programEditorTabColors-6{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .\\33xl\\:via-programEditorTabColors-1h{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .\\33xl\\:via-programEditorTabColors-2h{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .\\33xl\\:via-programEditorTabColors-3h{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .\\33xl\\:via-programEditorTabColors-4h{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .\\33xl\\:via-programEditorTabColors-5h{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .\\33xl\\:via-programEditorTabColors-6h{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .\\33xl\\:via-programEditorPresetTabColors-1{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\33xl\\:via-programEditorPresetTabColors-1h{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\33xl\\:via-borgScaleColors-0{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .\\33xl\\:via-borgScaleColors-1{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .\\33xl\\:via-borgScaleColors-2{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .\\33xl\\:via-borgScaleColors-3{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .\\33xl\\:via-borgScaleColors-4{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\33xl\\:via-borgScaleColors-5{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .\\33xl\\:via-borgScaleColors-6{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .\\33xl\\:via-borgScaleColors-7{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .\\33xl\\:via-borgScaleColors-8{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .\\33xl\\:via-borgScaleColors-9{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .\\33xl\\:via-borgScaleColors-10{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .\\33xl\\:to-transparent{
    --gradient-to-color: transparent;
  }

  .\\33xl\\:to-focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .\\33xl\\:to-black{
    --gradient-to-color: #000;
  }

  .\\33xl\\:to-white{
    --gradient-to-color: #fff;
  }

  .\\33xl\\:to-primary{
    --gradient-to-color: #37A4DC;
  }

  .\\33xl\\:to-disabled{
    --gradient-to-color: #BFBFBF;
  }

  .\\33xl\\:to-translucent-60{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .\\33xl\\:to-translucent-90{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .\\33xl\\:to-green-200{
    --gradient-to-color: #f4fcea;
  }

  .\\33xl\\:to-green-400{
    --gradient-to-color: #6CCA98;
  }

  .\\33xl\\:to-green-500{
    --gradient-to-color: #97E812;
  }

  .\\33xl\\:to-green-600{
    --gradient-to-color: #4f9112;
  }

  .\\33xl\\:to-green-700{
    --gradient-to-color: #3e7211;
  }

  .\\33xl\\:to-green-400a50{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .\\33xl\\:to-green-500a25{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .\\33xl\\:to-yellow-200{
    --gradient-to-color: #fff9eb;
  }

  .\\33xl\\:to-yellow-300{
    --gradient-to-color: #ffe9bd;
  }

  .\\33xl\\:to-yellow-500{
    --gradient-to-color: #FFC82C;
  }

  .\\33xl\\:to-yellow-600{
    --gradient-to-color: #F7931E;
  }

  .\\33xl\\:to-yellow-700{
    --gradient-to-color: #E1AD28;
  }

  .\\33xl\\:to-yellow-300a66{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .\\33xl\\:to-yellow-500a25{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .\\33xl\\:to-orange-200{
    --gradient-to-color: #fdf0ea;
  }

  .\\33xl\\:to-orange-400{
    --gradient-to-color: #f6c66f;
  }

  .\\33xl\\:to-orange-500{
    --gradient-to-color: #F07313;
  }

  .\\33xl\\:to-orange-800{
    --gradient-to-color: #db5d0c;
  }

  .\\33xl\\:to-orange-900{
    --gradient-to-color: #b86814;
  }

  .\\33xl\\:to-orange-500a25{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .\\33xl\\:to-red-100{
    --gradient-to-color: #FEF5F5;
  }

  .\\33xl\\:to-red-150{
    --gradient-to-color: #ffe9e8;
  }

  .\\33xl\\:to-red-200{
    --gradient-to-color: #F8CECC;
  }

  .\\33xl\\:to-red-300{
    --gradient-to-color: #ff8585;
  }

  .\\33xl\\:to-red-400{
    --gradient-to-color: #ff3535;
  }

  .\\33xl\\:to-red-500{
    --gradient-to-color: #DD4746;
  }

  .\\33xl\\:to-red-700{
    --gradient-to-color: #A23C24;
  }

  .\\33xl\\:to-gray-50{
    --gradient-to-color: #F9F9F9;
  }

  .\\33xl\\:to-gray-100{
    --gradient-to-color: #F1F1F2;
  }

  .\\33xl\\:to-gray-150{
    --gradient-to-color: #e6e6e6;
  }

  .\\33xl\\:to-gray-200{
    --gradient-to-color: #E0E2E4;
  }

  .\\33xl\\:to-gray-300{
    --gradient-to-color: #BFBFBF;
  }

  .\\33xl\\:to-gray-400{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .\\33xl\\:to-gray-425{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .\\33xl\\:to-gray-450{
    --gradient-to-color: #959595;
  }

  .\\33xl\\:to-gray-500{
    --gradient-to-color: #727272;
  }

  .\\33xl\\:to-gray-600{
    --gradient-to-color: #5a626b;
  }

  .\\33xl\\:to-gray-625{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .\\33xl\\:to-gray-700{
    --gradient-to-color: #464C59;
  }

  .\\33xl\\:to-gray-800{
    --gradient-to-color: #3c3b3b;
  }

  .\\33xl\\:to-gray-200a50{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .\\33xl\\:to-blue-50{
    --gradient-to-color: #f2fbff;
  }

  .\\33xl\\:to-blue-100{
    --gradient-to-color: #EBF6FC;
  }

  .\\33xl\\:to-blue-150{
    --gradient-to-color: #E8EEF1;
  }

  .\\33xl\\:to-blue-200{
    --gradient-to-color: #CCE6F5;
  }

  .\\33xl\\:to-blue-300{
    --gradient-to-color: #73BFE7;
  }

  .\\33xl\\:to-blue-400{
    --gradient-to-color: #4BA4F7;
  }

  .\\33xl\\:to-blue-500{
    --gradient-to-color: #37A4DC;
  }

  .\\33xl\\:to-blue-600{
    --gradient-to-color: #6AA2D6;
  }

  .\\33xl\\:to-blue-700{
    --gradient-to-color: #456E9A;
  }

  .\\33xl\\:to-blue-750{
    --gradient-to-color: #5682AA;
  }

  .\\33xl\\:to-blue-800{
    --gradient-to-color: #1F4566;
  }

  .\\33xl\\:to-blue-900{
    --gradient-to-color: #183453;
  }

  .\\33xl\\:to-blue-950{
    --gradient-to-color: #041527;
  }

  .\\33xl\\:to-blue-500a25{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .\\33xl\\:to-blue-500a50{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .\\33xl\\:to-blue-700a75{
    --gradient-to-color: #3B648D;
  }

  .\\33xl\\:to-blue-700a30{
    --gradient-to-color: #2A5176;
  }

  .\\33xl\\:to-blue-750a25{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .\\33xl\\:to-blue-750a15{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .\\33xl\\:to-blue-800a60{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .\\33xl\\:to-programEditorTabColors-1{
    --gradient-to-color: #3cacae;
  }

  .\\33xl\\:to-programEditorTabColors-2{
    --gradient-to-color: #8e346a;
  }

  .\\33xl\\:to-programEditorTabColors-3{
    --gradient-to-color: #ff72b7;
  }

  .\\33xl\\:to-programEditorTabColors-4{
    --gradient-to-color: #ce941c;
  }

  .\\33xl\\:to-programEditorTabColors-5{
    --gradient-to-color: #b973d9;
  }

  .\\33xl\\:to-programEditorTabColors-6{
    --gradient-to-color: #ff9082;
  }

  .\\33xl\\:to-programEditorTabColors-1h{
    --gradient-to-color: #d9f2f2;
  }

  .\\33xl\\:to-programEditorTabColors-2h{
    --gradient-to-color: #f1dae8;
  }

  .\\33xl\\:to-programEditorTabColors-3h{
    --gradient-to-color: #ffe6f2;
  }

  .\\33xl\\:to-programEditorTabColors-4h{
    --gradient-to-color: #f9ecd2;
  }

  .\\33xl\\:to-programEditorTabColors-5h{
    --gradient-to-color: #f5ebfa;
  }

  .\\33xl\\:to-programEditorTabColors-6h{
    --gradient-to-color: #ffe8e6;
  }

  .\\33xl\\:to-programEditorPresetTabColors-1{
    --gradient-to-color: #798fa3;
  }

  .\\33xl\\:to-programEditorPresetTabColors-1h{
    --gradient-to-color: #798fa3;
  }

  .\\33xl\\:to-borgScaleColors-0{
    --gradient-to-color: #c5d1ff;
  }

  .\\33xl\\:to-borgScaleColors-1{
    --gradient-to-color: #a0b5fc;
  }

  .\\33xl\\:to-borgScaleColors-2{
    --gradient-to-color: #7492ff;
  }

  .\\33xl\\:to-borgScaleColors-3{
    --gradient-to-color: #82bbf1;
  }

  .\\33xl\\:to-borgScaleColors-4{
    --gradient-to-color: #4ba4f7;
  }

  .\\33xl\\:to-borgScaleColors-5{
    --gradient-to-color: #9cdd57;
  }

  .\\33xl\\:to-borgScaleColors-6{
    --gradient-to-color: #68af00;
  }

  .\\33xl\\:to-borgScaleColors-7{
    --gradient-to-color: #f5e380;
  }

  .\\33xl\\:to-borgScaleColors-8{
    --gradient-to-color: #ffc246;
  }

  .\\33xl\\:to-borgScaleColors-9{
    --gradient-to-color: #ff782f;
  }

  .\\33xl\\:to-borgScaleColors-10{
    --gradient-to-color: #f25757;
  }

  .\\33xl\\:hover\\:from-transparent:hover{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\33xl\\:hover\\:from-focus:hover{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:hover\\:from-black:hover{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\33xl\\:hover\\:from-white:hover{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:hover\\:from-primary:hover{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:hover\\:from-disabled:hover{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\33xl\\:hover\\:from-translucent-60:hover{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:hover\\:from-translucent-90:hover{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:hover\\:from-green-200:hover{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .\\33xl\\:hover\\:from-green-400:hover{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\33xl\\:hover\\:from-green-500:hover{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\33xl\\:hover\\:from-green-600:hover{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .\\33xl\\:hover\\:from-green-700:hover{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .\\33xl\\:hover\\:from-green-400a50:hover{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\33xl\\:hover\\:from-green-500a25:hover{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\33xl\\:hover\\:from-yellow-200:hover{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .\\33xl\\:hover\\:from-yellow-300:hover{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\33xl\\:hover\\:from-yellow-500:hover{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\33xl\\:hover\\:from-yellow-600:hover{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .\\33xl\\:hover\\:from-yellow-700:hover{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .\\33xl\\:hover\\:from-yellow-300a66:hover{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\33xl\\:hover\\:from-yellow-500a25:hover{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\33xl\\:hover\\:from-orange-200:hover{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .\\33xl\\:hover\\:from-orange-400:hover{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .\\33xl\\:hover\\:from-orange-500:hover{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .\\33xl\\:hover\\:from-orange-800:hover{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .\\33xl\\:hover\\:from-orange-900:hover{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .\\33xl\\:hover\\:from-orange-500a25:hover{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .\\33xl\\:hover\\:from-red-100:hover{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .\\33xl\\:hover\\:from-red-150:hover{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .\\33xl\\:hover\\:from-red-200:hover{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .\\33xl\\:hover\\:from-red-300:hover{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .\\33xl\\:hover\\:from-red-400:hover{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .\\33xl\\:hover\\:from-red-500:hover{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .\\33xl\\:hover\\:from-red-700:hover{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .\\33xl\\:hover\\:from-gray-50:hover{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .\\33xl\\:hover\\:from-gray-100:hover{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .\\33xl\\:hover\\:from-gray-150:hover{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .\\33xl\\:hover\\:from-gray-200:hover{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\33xl\\:hover\\:from-gray-300:hover{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\33xl\\:hover\\:from-gray-400:hover{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\33xl\\:hover\\:from-gray-425:hover{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\33xl\\:hover\\:from-gray-450:hover{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .\\33xl\\:hover\\:from-gray-500:hover{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\33xl\\:hover\\:from-gray-600:hover{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\33xl\\:hover\\:from-gray-625:hover{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\33xl\\:hover\\:from-gray-700:hover{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .\\33xl\\:hover\\:from-gray-800:hover{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .\\33xl\\:hover\\:from-gray-200a50:hover{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\33xl\\:hover\\:from-blue-50:hover{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .\\33xl\\:hover\\:from-blue-100:hover{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .\\33xl\\:hover\\:from-blue-150:hover{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .\\33xl\\:hover\\:from-blue-200:hover{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .\\33xl\\:hover\\:from-blue-300:hover{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .\\33xl\\:hover\\:from-blue-400:hover{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\33xl\\:hover\\:from-blue-500:hover{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:hover\\:from-blue-600:hover{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .\\33xl\\:hover\\:from-blue-700:hover{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .\\33xl\\:hover\\:from-blue-750:hover{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:hover\\:from-blue-800:hover{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\33xl\\:hover\\:from-blue-900:hover{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .\\33xl\\:hover\\:from-blue-950:hover{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\33xl\\:hover\\:from-blue-500a25:hover{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:hover\\:from-blue-500a50:hover{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:hover\\:from-blue-700a75:hover{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .\\33xl\\:hover\\:from-blue-700a30:hover{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .\\33xl\\:hover\\:from-blue-750a25:hover{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:hover\\:from-blue-750a15:hover{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:hover\\:from-blue-800a60:hover{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\33xl\\:hover\\:from-programEditorTabColors-1:hover{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .\\33xl\\:hover\\:from-programEditorTabColors-2:hover{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .\\33xl\\:hover\\:from-programEditorTabColors-3:hover{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .\\33xl\\:hover\\:from-programEditorTabColors-4:hover{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .\\33xl\\:hover\\:from-programEditorTabColors-5:hover{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .\\33xl\\:hover\\:from-programEditorTabColors-6:hover{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .\\33xl\\:hover\\:from-programEditorTabColors-1h:hover{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .\\33xl\\:hover\\:from-programEditorTabColors-2h:hover{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .\\33xl\\:hover\\:from-programEditorTabColors-3h:hover{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .\\33xl\\:hover\\:from-programEditorTabColors-4h:hover{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .\\33xl\\:hover\\:from-programEditorTabColors-5h:hover{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .\\33xl\\:hover\\:from-programEditorTabColors-6h:hover{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .\\33xl\\:hover\\:from-programEditorPresetTabColors-1:hover{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\33xl\\:hover\\:from-programEditorPresetTabColors-1h:hover{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\33xl\\:hover\\:from-borgScaleColors-0:hover{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .\\33xl\\:hover\\:from-borgScaleColors-1:hover{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .\\33xl\\:hover\\:from-borgScaleColors-2:hover{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .\\33xl\\:hover\\:from-borgScaleColors-3:hover{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .\\33xl\\:hover\\:from-borgScaleColors-4:hover{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\33xl\\:hover\\:from-borgScaleColors-5:hover{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .\\33xl\\:hover\\:from-borgScaleColors-6:hover{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .\\33xl\\:hover\\:from-borgScaleColors-7:hover{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .\\33xl\\:hover\\:from-borgScaleColors-8:hover{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .\\33xl\\:hover\\:from-borgScaleColors-9:hover{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .\\33xl\\:hover\\:from-borgScaleColors-10:hover{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .\\33xl\\:hover\\:via-transparent:hover{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\33xl\\:hover\\:via-focus:hover{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:hover\\:via-black:hover{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\33xl\\:hover\\:via-white:hover{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:hover\\:via-primary:hover{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:hover\\:via-disabled:hover{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\33xl\\:hover\\:via-translucent-60:hover{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:hover\\:via-translucent-90:hover{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:hover\\:via-green-200:hover{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .\\33xl\\:hover\\:via-green-400:hover{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\33xl\\:hover\\:via-green-500:hover{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\33xl\\:hover\\:via-green-600:hover{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .\\33xl\\:hover\\:via-green-700:hover{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .\\33xl\\:hover\\:via-green-400a50:hover{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\33xl\\:hover\\:via-green-500a25:hover{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\33xl\\:hover\\:via-yellow-200:hover{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .\\33xl\\:hover\\:via-yellow-300:hover{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\33xl\\:hover\\:via-yellow-500:hover{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\33xl\\:hover\\:via-yellow-600:hover{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .\\33xl\\:hover\\:via-yellow-700:hover{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .\\33xl\\:hover\\:via-yellow-300a66:hover{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\33xl\\:hover\\:via-yellow-500a25:hover{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\33xl\\:hover\\:via-orange-200:hover{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .\\33xl\\:hover\\:via-orange-400:hover{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .\\33xl\\:hover\\:via-orange-500:hover{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .\\33xl\\:hover\\:via-orange-800:hover{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .\\33xl\\:hover\\:via-orange-900:hover{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .\\33xl\\:hover\\:via-orange-500a25:hover{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .\\33xl\\:hover\\:via-red-100:hover{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .\\33xl\\:hover\\:via-red-150:hover{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .\\33xl\\:hover\\:via-red-200:hover{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .\\33xl\\:hover\\:via-red-300:hover{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .\\33xl\\:hover\\:via-red-400:hover{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .\\33xl\\:hover\\:via-red-500:hover{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .\\33xl\\:hover\\:via-red-700:hover{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .\\33xl\\:hover\\:via-gray-50:hover{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .\\33xl\\:hover\\:via-gray-100:hover{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .\\33xl\\:hover\\:via-gray-150:hover{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .\\33xl\\:hover\\:via-gray-200:hover{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\33xl\\:hover\\:via-gray-300:hover{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\33xl\\:hover\\:via-gray-400:hover{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\33xl\\:hover\\:via-gray-425:hover{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\33xl\\:hover\\:via-gray-450:hover{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .\\33xl\\:hover\\:via-gray-500:hover{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\33xl\\:hover\\:via-gray-600:hover{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\33xl\\:hover\\:via-gray-625:hover{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\33xl\\:hover\\:via-gray-700:hover{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .\\33xl\\:hover\\:via-gray-800:hover{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .\\33xl\\:hover\\:via-gray-200a50:hover{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\33xl\\:hover\\:via-blue-50:hover{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .\\33xl\\:hover\\:via-blue-100:hover{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .\\33xl\\:hover\\:via-blue-150:hover{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .\\33xl\\:hover\\:via-blue-200:hover{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .\\33xl\\:hover\\:via-blue-300:hover{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .\\33xl\\:hover\\:via-blue-400:hover{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\33xl\\:hover\\:via-blue-500:hover{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:hover\\:via-blue-600:hover{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .\\33xl\\:hover\\:via-blue-700:hover{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .\\33xl\\:hover\\:via-blue-750:hover{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:hover\\:via-blue-800:hover{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\33xl\\:hover\\:via-blue-900:hover{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .\\33xl\\:hover\\:via-blue-950:hover{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\33xl\\:hover\\:via-blue-500a25:hover{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:hover\\:via-blue-500a50:hover{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:hover\\:via-blue-700a75:hover{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .\\33xl\\:hover\\:via-blue-700a30:hover{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .\\33xl\\:hover\\:via-blue-750a25:hover{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:hover\\:via-blue-750a15:hover{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:hover\\:via-blue-800a60:hover{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\33xl\\:hover\\:via-programEditorTabColors-1:hover{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .\\33xl\\:hover\\:via-programEditorTabColors-2:hover{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .\\33xl\\:hover\\:via-programEditorTabColors-3:hover{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .\\33xl\\:hover\\:via-programEditorTabColors-4:hover{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .\\33xl\\:hover\\:via-programEditorTabColors-5:hover{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .\\33xl\\:hover\\:via-programEditorTabColors-6:hover{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .\\33xl\\:hover\\:via-programEditorTabColors-1h:hover{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .\\33xl\\:hover\\:via-programEditorTabColors-2h:hover{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .\\33xl\\:hover\\:via-programEditorTabColors-3h:hover{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .\\33xl\\:hover\\:via-programEditorTabColors-4h:hover{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .\\33xl\\:hover\\:via-programEditorTabColors-5h:hover{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .\\33xl\\:hover\\:via-programEditorTabColors-6h:hover{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .\\33xl\\:hover\\:via-programEditorPresetTabColors-1:hover{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\33xl\\:hover\\:via-programEditorPresetTabColors-1h:hover{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\33xl\\:hover\\:via-borgScaleColors-0:hover{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .\\33xl\\:hover\\:via-borgScaleColors-1:hover{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .\\33xl\\:hover\\:via-borgScaleColors-2:hover{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .\\33xl\\:hover\\:via-borgScaleColors-3:hover{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .\\33xl\\:hover\\:via-borgScaleColors-4:hover{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\33xl\\:hover\\:via-borgScaleColors-5:hover{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .\\33xl\\:hover\\:via-borgScaleColors-6:hover{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .\\33xl\\:hover\\:via-borgScaleColors-7:hover{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .\\33xl\\:hover\\:via-borgScaleColors-8:hover{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .\\33xl\\:hover\\:via-borgScaleColors-9:hover{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .\\33xl\\:hover\\:via-borgScaleColors-10:hover{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .\\33xl\\:hover\\:to-transparent:hover{
    --gradient-to-color: transparent;
  }

  .\\33xl\\:hover\\:to-focus:hover{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .\\33xl\\:hover\\:to-black:hover{
    --gradient-to-color: #000;
  }

  .\\33xl\\:hover\\:to-white:hover{
    --gradient-to-color: #fff;
  }

  .\\33xl\\:hover\\:to-primary:hover{
    --gradient-to-color: #37A4DC;
  }

  .\\33xl\\:hover\\:to-disabled:hover{
    --gradient-to-color: #BFBFBF;
  }

  .\\33xl\\:hover\\:to-translucent-60:hover{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .\\33xl\\:hover\\:to-translucent-90:hover{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .\\33xl\\:hover\\:to-green-200:hover{
    --gradient-to-color: #f4fcea;
  }

  .\\33xl\\:hover\\:to-green-400:hover{
    --gradient-to-color: #6CCA98;
  }

  .\\33xl\\:hover\\:to-green-500:hover{
    --gradient-to-color: #97E812;
  }

  .\\33xl\\:hover\\:to-green-600:hover{
    --gradient-to-color: #4f9112;
  }

  .\\33xl\\:hover\\:to-green-700:hover{
    --gradient-to-color: #3e7211;
  }

  .\\33xl\\:hover\\:to-green-400a50:hover{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .\\33xl\\:hover\\:to-green-500a25:hover{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .\\33xl\\:hover\\:to-yellow-200:hover{
    --gradient-to-color: #fff9eb;
  }

  .\\33xl\\:hover\\:to-yellow-300:hover{
    --gradient-to-color: #ffe9bd;
  }

  .\\33xl\\:hover\\:to-yellow-500:hover{
    --gradient-to-color: #FFC82C;
  }

  .\\33xl\\:hover\\:to-yellow-600:hover{
    --gradient-to-color: #F7931E;
  }

  .\\33xl\\:hover\\:to-yellow-700:hover{
    --gradient-to-color: #E1AD28;
  }

  .\\33xl\\:hover\\:to-yellow-300a66:hover{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .\\33xl\\:hover\\:to-yellow-500a25:hover{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .\\33xl\\:hover\\:to-orange-200:hover{
    --gradient-to-color: #fdf0ea;
  }

  .\\33xl\\:hover\\:to-orange-400:hover{
    --gradient-to-color: #f6c66f;
  }

  .\\33xl\\:hover\\:to-orange-500:hover{
    --gradient-to-color: #F07313;
  }

  .\\33xl\\:hover\\:to-orange-800:hover{
    --gradient-to-color: #db5d0c;
  }

  .\\33xl\\:hover\\:to-orange-900:hover{
    --gradient-to-color: #b86814;
  }

  .\\33xl\\:hover\\:to-orange-500a25:hover{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .\\33xl\\:hover\\:to-red-100:hover{
    --gradient-to-color: #FEF5F5;
  }

  .\\33xl\\:hover\\:to-red-150:hover{
    --gradient-to-color: #ffe9e8;
  }

  .\\33xl\\:hover\\:to-red-200:hover{
    --gradient-to-color: #F8CECC;
  }

  .\\33xl\\:hover\\:to-red-300:hover{
    --gradient-to-color: #ff8585;
  }

  .\\33xl\\:hover\\:to-red-400:hover{
    --gradient-to-color: #ff3535;
  }

  .\\33xl\\:hover\\:to-red-500:hover{
    --gradient-to-color: #DD4746;
  }

  .\\33xl\\:hover\\:to-red-700:hover{
    --gradient-to-color: #A23C24;
  }

  .\\33xl\\:hover\\:to-gray-50:hover{
    --gradient-to-color: #F9F9F9;
  }

  .\\33xl\\:hover\\:to-gray-100:hover{
    --gradient-to-color: #F1F1F2;
  }

  .\\33xl\\:hover\\:to-gray-150:hover{
    --gradient-to-color: #e6e6e6;
  }

  .\\33xl\\:hover\\:to-gray-200:hover{
    --gradient-to-color: #E0E2E4;
  }

  .\\33xl\\:hover\\:to-gray-300:hover{
    --gradient-to-color: #BFBFBF;
  }

  .\\33xl\\:hover\\:to-gray-400:hover{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .\\33xl\\:hover\\:to-gray-425:hover{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .\\33xl\\:hover\\:to-gray-450:hover{
    --gradient-to-color: #959595;
  }

  .\\33xl\\:hover\\:to-gray-500:hover{
    --gradient-to-color: #727272;
  }

  .\\33xl\\:hover\\:to-gray-600:hover{
    --gradient-to-color: #5a626b;
  }

  .\\33xl\\:hover\\:to-gray-625:hover{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .\\33xl\\:hover\\:to-gray-700:hover{
    --gradient-to-color: #464C59;
  }

  .\\33xl\\:hover\\:to-gray-800:hover{
    --gradient-to-color: #3c3b3b;
  }

  .\\33xl\\:hover\\:to-gray-200a50:hover{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .\\33xl\\:hover\\:to-blue-50:hover{
    --gradient-to-color: #f2fbff;
  }

  .\\33xl\\:hover\\:to-blue-100:hover{
    --gradient-to-color: #EBF6FC;
  }

  .\\33xl\\:hover\\:to-blue-150:hover{
    --gradient-to-color: #E8EEF1;
  }

  .\\33xl\\:hover\\:to-blue-200:hover{
    --gradient-to-color: #CCE6F5;
  }

  .\\33xl\\:hover\\:to-blue-300:hover{
    --gradient-to-color: #73BFE7;
  }

  .\\33xl\\:hover\\:to-blue-400:hover{
    --gradient-to-color: #4BA4F7;
  }

  .\\33xl\\:hover\\:to-blue-500:hover{
    --gradient-to-color: #37A4DC;
  }

  .\\33xl\\:hover\\:to-blue-600:hover{
    --gradient-to-color: #6AA2D6;
  }

  .\\33xl\\:hover\\:to-blue-700:hover{
    --gradient-to-color: #456E9A;
  }

  .\\33xl\\:hover\\:to-blue-750:hover{
    --gradient-to-color: #5682AA;
  }

  .\\33xl\\:hover\\:to-blue-800:hover{
    --gradient-to-color: #1F4566;
  }

  .\\33xl\\:hover\\:to-blue-900:hover{
    --gradient-to-color: #183453;
  }

  .\\33xl\\:hover\\:to-blue-950:hover{
    --gradient-to-color: #041527;
  }

  .\\33xl\\:hover\\:to-blue-500a25:hover{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .\\33xl\\:hover\\:to-blue-500a50:hover{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .\\33xl\\:hover\\:to-blue-700a75:hover{
    --gradient-to-color: #3B648D;
  }

  .\\33xl\\:hover\\:to-blue-700a30:hover{
    --gradient-to-color: #2A5176;
  }

  .\\33xl\\:hover\\:to-blue-750a25:hover{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .\\33xl\\:hover\\:to-blue-750a15:hover{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .\\33xl\\:hover\\:to-blue-800a60:hover{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .\\33xl\\:hover\\:to-programEditorTabColors-1:hover{
    --gradient-to-color: #3cacae;
  }

  .\\33xl\\:hover\\:to-programEditorTabColors-2:hover{
    --gradient-to-color: #8e346a;
  }

  .\\33xl\\:hover\\:to-programEditorTabColors-3:hover{
    --gradient-to-color: #ff72b7;
  }

  .\\33xl\\:hover\\:to-programEditorTabColors-4:hover{
    --gradient-to-color: #ce941c;
  }

  .\\33xl\\:hover\\:to-programEditorTabColors-5:hover{
    --gradient-to-color: #b973d9;
  }

  .\\33xl\\:hover\\:to-programEditorTabColors-6:hover{
    --gradient-to-color: #ff9082;
  }

  .\\33xl\\:hover\\:to-programEditorTabColors-1h:hover{
    --gradient-to-color: #d9f2f2;
  }

  .\\33xl\\:hover\\:to-programEditorTabColors-2h:hover{
    --gradient-to-color: #f1dae8;
  }

  .\\33xl\\:hover\\:to-programEditorTabColors-3h:hover{
    --gradient-to-color: #ffe6f2;
  }

  .\\33xl\\:hover\\:to-programEditorTabColors-4h:hover{
    --gradient-to-color: #f9ecd2;
  }

  .\\33xl\\:hover\\:to-programEditorTabColors-5h:hover{
    --gradient-to-color: #f5ebfa;
  }

  .\\33xl\\:hover\\:to-programEditorTabColors-6h:hover{
    --gradient-to-color: #ffe8e6;
  }

  .\\33xl\\:hover\\:to-programEditorPresetTabColors-1:hover{
    --gradient-to-color: #798fa3;
  }

  .\\33xl\\:hover\\:to-programEditorPresetTabColors-1h:hover{
    --gradient-to-color: #798fa3;
  }

  .\\33xl\\:hover\\:to-borgScaleColors-0:hover{
    --gradient-to-color: #c5d1ff;
  }

  .\\33xl\\:hover\\:to-borgScaleColors-1:hover{
    --gradient-to-color: #a0b5fc;
  }

  .\\33xl\\:hover\\:to-borgScaleColors-2:hover{
    --gradient-to-color: #7492ff;
  }

  .\\33xl\\:hover\\:to-borgScaleColors-3:hover{
    --gradient-to-color: #82bbf1;
  }

  .\\33xl\\:hover\\:to-borgScaleColors-4:hover{
    --gradient-to-color: #4ba4f7;
  }

  .\\33xl\\:hover\\:to-borgScaleColors-5:hover{
    --gradient-to-color: #9cdd57;
  }

  .\\33xl\\:hover\\:to-borgScaleColors-6:hover{
    --gradient-to-color: #68af00;
  }

  .\\33xl\\:hover\\:to-borgScaleColors-7:hover{
    --gradient-to-color: #f5e380;
  }

  .\\33xl\\:hover\\:to-borgScaleColors-8:hover{
    --gradient-to-color: #ffc246;
  }

  .\\33xl\\:hover\\:to-borgScaleColors-9:hover{
    --gradient-to-color: #ff782f;
  }

  .\\33xl\\:hover\\:to-borgScaleColors-10:hover{
    --gradient-to-color: #f25757;
  }

  .\\33xl\\:focus\\:from-transparent:focus{
    --gradient-from-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\33xl\\:focus\\:from-focus:focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:focus\\:from-black:focus{
    --gradient-from-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\33xl\\:focus\\:from-white:focus{
    --gradient-from-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:focus\\:from-primary:focus{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:focus\\:from-disabled:focus{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\33xl\\:focus\\:from-translucent-60:focus{
    --gradient-from-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:focus\\:from-translucent-90:focus{
    --gradient-from-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:focus\\:from-green-200:focus{
    --gradient-from-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .\\33xl\\:focus\\:from-green-400:focus{
    --gradient-from-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\33xl\\:focus\\:from-green-500:focus{
    --gradient-from-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\33xl\\:focus\\:from-green-600:focus{
    --gradient-from-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .\\33xl\\:focus\\:from-green-700:focus{
    --gradient-from-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .\\33xl\\:focus\\:from-green-400a50:focus{
    --gradient-from-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\33xl\\:focus\\:from-green-500a25:focus{
    --gradient-from-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\33xl\\:focus\\:from-yellow-200:focus{
    --gradient-from-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .\\33xl\\:focus\\:from-yellow-300:focus{
    --gradient-from-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\33xl\\:focus\\:from-yellow-500:focus{
    --gradient-from-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\33xl\\:focus\\:from-yellow-600:focus{
    --gradient-from-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .\\33xl\\:focus\\:from-yellow-700:focus{
    --gradient-from-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .\\33xl\\:focus\\:from-yellow-300a66:focus{
    --gradient-from-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\33xl\\:focus\\:from-yellow-500a25:focus{
    --gradient-from-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\33xl\\:focus\\:from-orange-200:focus{
    --gradient-from-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .\\33xl\\:focus\\:from-orange-400:focus{
    --gradient-from-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .\\33xl\\:focus\\:from-orange-500:focus{
    --gradient-from-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .\\33xl\\:focus\\:from-orange-800:focus{
    --gradient-from-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .\\33xl\\:focus\\:from-orange-900:focus{
    --gradient-from-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .\\33xl\\:focus\\:from-orange-500a25:focus{
    --gradient-from-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .\\33xl\\:focus\\:from-red-100:focus{
    --gradient-from-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .\\33xl\\:focus\\:from-red-150:focus{
    --gradient-from-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .\\33xl\\:focus\\:from-red-200:focus{
    --gradient-from-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .\\33xl\\:focus\\:from-red-300:focus{
    --gradient-from-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .\\33xl\\:focus\\:from-red-400:focus{
    --gradient-from-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .\\33xl\\:focus\\:from-red-500:focus{
    --gradient-from-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .\\33xl\\:focus\\:from-red-700:focus{
    --gradient-from-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .\\33xl\\:focus\\:from-gray-50:focus{
    --gradient-from-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .\\33xl\\:focus\\:from-gray-100:focus{
    --gradient-from-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .\\33xl\\:focus\\:from-gray-150:focus{
    --gradient-from-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .\\33xl\\:focus\\:from-gray-200:focus{
    --gradient-from-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\33xl\\:focus\\:from-gray-300:focus{
    --gradient-from-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\33xl\\:focus\\:from-gray-400:focus{
    --gradient-from-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\33xl\\:focus\\:from-gray-425:focus{
    --gradient-from-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\33xl\\:focus\\:from-gray-450:focus{
    --gradient-from-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .\\33xl\\:focus\\:from-gray-500:focus{
    --gradient-from-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\33xl\\:focus\\:from-gray-600:focus{
    --gradient-from-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\33xl\\:focus\\:from-gray-625:focus{
    --gradient-from-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\33xl\\:focus\\:from-gray-700:focus{
    --gradient-from-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .\\33xl\\:focus\\:from-gray-800:focus{
    --gradient-from-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .\\33xl\\:focus\\:from-gray-200a50:focus{
    --gradient-from-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\33xl\\:focus\\:from-blue-50:focus{
    --gradient-from-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .\\33xl\\:focus\\:from-blue-100:focus{
    --gradient-from-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .\\33xl\\:focus\\:from-blue-150:focus{
    --gradient-from-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .\\33xl\\:focus\\:from-blue-200:focus{
    --gradient-from-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .\\33xl\\:focus\\:from-blue-300:focus{
    --gradient-from-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .\\33xl\\:focus\\:from-blue-400:focus{
    --gradient-from-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\33xl\\:focus\\:from-blue-500:focus{
    --gradient-from-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:focus\\:from-blue-600:focus{
    --gradient-from-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .\\33xl\\:focus\\:from-blue-700:focus{
    --gradient-from-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .\\33xl\\:focus\\:from-blue-750:focus{
    --gradient-from-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:focus\\:from-blue-800:focus{
    --gradient-from-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\33xl\\:focus\\:from-blue-900:focus{
    --gradient-from-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .\\33xl\\:focus\\:from-blue-950:focus{
    --gradient-from-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\33xl\\:focus\\:from-blue-500a25:focus{
    --gradient-from-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:focus\\:from-blue-500a50:focus{
    --gradient-from-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:focus\\:from-blue-700a75:focus{
    --gradient-from-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .\\33xl\\:focus\\:from-blue-700a30:focus{
    --gradient-from-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .\\33xl\\:focus\\:from-blue-750a25:focus{
    --gradient-from-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:focus\\:from-blue-750a15:focus{
    --gradient-from-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:focus\\:from-blue-800a60:focus{
    --gradient-from-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\33xl\\:focus\\:from-programEditorTabColors-1:focus{
    --gradient-from-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .\\33xl\\:focus\\:from-programEditorTabColors-2:focus{
    --gradient-from-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .\\33xl\\:focus\\:from-programEditorTabColors-3:focus{
    --gradient-from-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .\\33xl\\:focus\\:from-programEditorTabColors-4:focus{
    --gradient-from-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .\\33xl\\:focus\\:from-programEditorTabColors-5:focus{
    --gradient-from-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .\\33xl\\:focus\\:from-programEditorTabColors-6:focus{
    --gradient-from-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .\\33xl\\:focus\\:from-programEditorTabColors-1h:focus{
    --gradient-from-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .\\33xl\\:focus\\:from-programEditorTabColors-2h:focus{
    --gradient-from-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .\\33xl\\:focus\\:from-programEditorTabColors-3h:focus{
    --gradient-from-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .\\33xl\\:focus\\:from-programEditorTabColors-4h:focus{
    --gradient-from-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .\\33xl\\:focus\\:from-programEditorTabColors-5h:focus{
    --gradient-from-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .\\33xl\\:focus\\:from-programEditorTabColors-6h:focus{
    --gradient-from-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .\\33xl\\:focus\\:from-programEditorPresetTabColors-1:focus{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\33xl\\:focus\\:from-programEditorPresetTabColors-1h:focus{
    --gradient-from-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\33xl\\:focus\\:from-borgScaleColors-0:focus{
    --gradient-from-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .\\33xl\\:focus\\:from-borgScaleColors-1:focus{
    --gradient-from-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .\\33xl\\:focus\\:from-borgScaleColors-2:focus{
    --gradient-from-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .\\33xl\\:focus\\:from-borgScaleColors-3:focus{
    --gradient-from-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .\\33xl\\:focus\\:from-borgScaleColors-4:focus{
    --gradient-from-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\33xl\\:focus\\:from-borgScaleColors-5:focus{
    --gradient-from-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .\\33xl\\:focus\\:from-borgScaleColors-6:focus{
    --gradient-from-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .\\33xl\\:focus\\:from-borgScaleColors-7:focus{
    --gradient-from-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .\\33xl\\:focus\\:from-borgScaleColors-8:focus{
    --gradient-from-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .\\33xl\\:focus\\:from-borgScaleColors-9:focus{
    --gradient-from-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .\\33xl\\:focus\\:from-borgScaleColors-10:focus{
    --gradient-from-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .\\33xl\\:focus\\:via-transparent:focus{
    --gradient-via-color: transparent;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\33xl\\:focus\\:via-focus:focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:focus\\:via-black:focus{
    --gradient-via-color: #000;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(0, 0, 0, 0));
  }

  .\\33xl\\:focus\\:via-white:focus{
    --gradient-via-color: #fff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:focus\\:via-primary:focus{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:focus\\:via-disabled:focus{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\33xl\\:focus\\:via-translucent-60:focus{
    --gradient-via-color: rgba(256, 256, 256, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:focus\\:via-translucent-90:focus{
    --gradient-via-color: rgba(256, 256, 256, 0.9);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 255, 255, 0));
  }

  .\\33xl\\:focus\\:via-green-200:focus{
    --gradient-via-color: #f4fcea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(244, 252, 234, 0));
  }

  .\\33xl\\:focus\\:via-green-400:focus{
    --gradient-via-color: #6CCA98;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\33xl\\:focus\\:via-green-500:focus{
    --gradient-via-color: #97E812;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\33xl\\:focus\\:via-green-600:focus{
    --gradient-via-color: #4f9112;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(79, 145, 18, 0));
  }

  .\\33xl\\:focus\\:via-green-700:focus{
    --gradient-via-color: #3e7211;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(62, 114, 17, 0));
  }

  .\\33xl\\:focus\\:via-green-400a50:focus{
    --gradient-via-color: rgba(108,202,152,0.50196);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(108, 202, 152, 0));
  }

  .\\33xl\\:focus\\:via-green-500a25:focus{
    --gradient-via-color: rgba(151,232,18,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(151, 232, 18, 0));
  }

  .\\33xl\\:focus\\:via-yellow-200:focus{
    --gradient-via-color: #fff9eb;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 249, 235, 0));
  }

  .\\33xl\\:focus\\:via-yellow-300:focus{
    --gradient-via-color: #ffe9bd;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\33xl\\:focus\\:via-yellow-500:focus{
    --gradient-via-color: #FFC82C;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\33xl\\:focus\\:via-yellow-600:focus{
    --gradient-via-color: #F7931E;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(247, 147, 30, 0));
  }

  .\\33xl\\:focus\\:via-yellow-700:focus{
    --gradient-via-color: #E1AD28;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(225, 173, 40, 0));
  }

  .\\33xl\\:focus\\:via-yellow-300a66:focus{
    --gradient-via-color: rgba(255,233,189,0.66667);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 189, 0));
  }

  .\\33xl\\:focus\\:via-yellow-500a25:focus{
    --gradient-via-color: rgba(255,200,44,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 200, 44, 0));
  }

  .\\33xl\\:focus\\:via-orange-200:focus{
    --gradient-via-color: #fdf0ea;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(253, 240, 234, 0));
  }

  .\\33xl\\:focus\\:via-orange-400:focus{
    --gradient-via-color: #f6c66f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(246, 198, 111, 0));
  }

  .\\33xl\\:focus\\:via-orange-500:focus{
    --gradient-via-color: #F07313;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 19, 0));
  }

  .\\33xl\\:focus\\:via-orange-800:focus{
    --gradient-via-color: #db5d0c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(219, 93, 12, 0));
  }

  .\\33xl\\:focus\\:via-orange-900:focus{
    --gradient-via-color: #b86814;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(184, 104, 20, 0));
  }

  .\\33xl\\:focus\\:via-orange-500a25:focus{
    --gradient-via-color: rgba(240,115,23,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(240, 115, 23, 0));
  }

  .\\33xl\\:focus\\:via-red-100:focus{
    --gradient-via-color: #FEF5F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(254, 245, 245, 0));
  }

  .\\33xl\\:focus\\:via-red-150:focus{
    --gradient-via-color: #ffe9e8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 233, 232, 0));
  }

  .\\33xl\\:focus\\:via-red-200:focus{
    --gradient-via-color: #F8CECC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(248, 206, 204, 0));
  }

  .\\33xl\\:focus\\:via-red-300:focus{
    --gradient-via-color: #ff8585;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 133, 133, 0));
  }

  .\\33xl\\:focus\\:via-red-400:focus{
    --gradient-via-color: #ff3535;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 53, 53, 0));
  }

  .\\33xl\\:focus\\:via-red-500:focus{
    --gradient-via-color: #DD4746;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(221, 71, 70, 0));
  }

  .\\33xl\\:focus\\:via-red-700:focus{
    --gradient-via-color: #A23C24;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(162, 60, 36, 0));
  }

  .\\33xl\\:focus\\:via-gray-50:focus{
    --gradient-via-color: #F9F9F9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 249, 249, 0));
  }

  .\\33xl\\:focus\\:via-gray-100:focus{
    --gradient-via-color: #F1F1F2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 241, 242, 0));
  }

  .\\33xl\\:focus\\:via-gray-150:focus{
    --gradient-via-color: #e6e6e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(230, 230, 230, 0));
  }

  .\\33xl\\:focus\\:via-gray-200:focus{
    --gradient-via-color: #E0E2E4;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\33xl\\:focus\\:via-gray-300:focus{
    --gradient-via-color: #BFBFBF;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(191, 191, 191, 0));
  }

  .\\33xl\\:focus\\:via-gray-400:focus{
    --gradient-via-color: rgba(114,114,114,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\33xl\\:focus\\:via-gray-425:focus{
    --gradient-via-color: rgba(4, 21, 39, 0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\33xl\\:focus\\:via-gray-450:focus{
    --gradient-via-color: #959595;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(149, 149, 149, 0));
  }

  .\\33xl\\:focus\\:via-gray-500:focus{
    --gradient-via-color: #727272;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(114, 114, 114, 0));
  }

  .\\33xl\\:focus\\:via-gray-600:focus{
    --gradient-via-color: #5a626b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\33xl\\:focus\\:via-gray-625:focus{
    --gradient-via-color: rgba(90,98,107,0.8);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(90, 98, 107, 0));
  }

  .\\33xl\\:focus\\:via-gray-700:focus{
    --gradient-via-color: #464C59;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(70, 76, 89, 0));
  }

  .\\33xl\\:focus\\:via-gray-800:focus{
    --gradient-via-color: #3c3b3b;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 59, 59, 0));
  }

  .\\33xl\\:focus\\:via-gray-200a50:focus{
    --gradient-via-color: rgba(224, 226, 228, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(224, 226, 228, 0));
  }

  .\\33xl\\:focus\\:via-blue-50:focus{
    --gradient-via-color: #f2fbff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 251, 255, 0));
  }

  .\\33xl\\:focus\\:via-blue-100:focus{
    --gradient-via-color: #EBF6FC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(235, 246, 252, 0));
  }

  .\\33xl\\:focus\\:via-blue-150:focus{
    --gradient-via-color: #E8EEF1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(232, 238, 241, 0));
  }

  .\\33xl\\:focus\\:via-blue-200:focus{
    --gradient-via-color: #CCE6F5;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(204, 230, 245, 0));
  }

  .\\33xl\\:focus\\:via-blue-300:focus{
    --gradient-via-color: #73BFE7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(115, 191, 231, 0));
  }

  .\\33xl\\:focus\\:via-blue-400:focus{
    --gradient-via-color: #4BA4F7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\33xl\\:focus\\:via-blue-500:focus{
    --gradient-via-color: #37A4DC;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:focus\\:via-blue-600:focus{
    --gradient-via-color: #6AA2D6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(106, 162, 214, 0));
  }

  .\\33xl\\:focus\\:via-blue-700:focus{
    --gradient-via-color: #456E9A;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(69, 110, 154, 0));
  }

  .\\33xl\\:focus\\:via-blue-750:focus{
    --gradient-via-color: #5682AA;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:focus\\:via-blue-800:focus{
    --gradient-via-color: #1F4566;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\33xl\\:focus\\:via-blue-900:focus{
    --gradient-via-color: #183453;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(24, 52, 83, 0));
  }

  .\\33xl\\:focus\\:via-blue-950:focus{
    --gradient-via-color: #041527;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(4, 21, 39, 0));
  }

  .\\33xl\\:focus\\:via-blue-500a25:focus{
    --gradient-via-color: rgba(55, 164, 220, 0.2);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:focus\\:via-blue-500a50:focus{
    --gradient-via-color: rgba(55, 164, 220, 0.5);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(55, 164, 220, 0));
  }

  .\\33xl\\:focus\\:via-blue-700a75:focus{
    --gradient-via-color: #3B648D;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(59, 100, 141, 0));
  }

  .\\33xl\\:focus\\:via-blue-700a30:focus{
    --gradient-via-color: #2A5176;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(42, 81, 118, 0));
  }

  .\\33xl\\:focus\\:via-blue-750a25:focus{
    --gradient-via-color: rgba(86,130,170,0.09804);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:focus\\:via-blue-750a15:focus{
    --gradient-via-color: rgba(86,130,170,0.05882);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(86, 130, 170, 0));
  }

  .\\33xl\\:focus\\:via-blue-800a60:focus{
    --gradient-via-color: rgba(31, 69, 102, 0.6);
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(31, 69, 102, 0));
  }

  .\\33xl\\:focus\\:via-programEditorTabColors-1:focus{
    --gradient-via-color: #3cacae;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(60, 172, 174, 0));
  }

  .\\33xl\\:focus\\:via-programEditorTabColors-2:focus{
    --gradient-via-color: #8e346a;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(142, 52, 106, 0));
  }

  .\\33xl\\:focus\\:via-programEditorTabColors-3:focus{
    --gradient-via-color: #ff72b7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 114, 183, 0));
  }

  .\\33xl\\:focus\\:via-programEditorTabColors-4:focus{
    --gradient-via-color: #ce941c;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(206, 148, 28, 0));
  }

  .\\33xl\\:focus\\:via-programEditorTabColors-5:focus{
    --gradient-via-color: #b973d9;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(185, 115, 217, 0));
  }

  .\\33xl\\:focus\\:via-programEditorTabColors-6:focus{
    --gradient-via-color: #ff9082;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 144, 130, 0));
  }

  .\\33xl\\:focus\\:via-programEditorTabColors-1h:focus{
    --gradient-via-color: #d9f2f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(217, 242, 242, 0));
  }

  .\\33xl\\:focus\\:via-programEditorTabColors-2h:focus{
    --gradient-via-color: #f1dae8;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(241, 218, 232, 0));
  }

  .\\33xl\\:focus\\:via-programEditorTabColors-3h:focus{
    --gradient-via-color: #ffe6f2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 230, 242, 0));
  }

  .\\33xl\\:focus\\:via-programEditorTabColors-4h:focus{
    --gradient-via-color: #f9ecd2;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(249, 236, 210, 0));
  }

  .\\33xl\\:focus\\:via-programEditorTabColors-5h:focus{
    --gradient-via-color: #f5ebfa;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 235, 250, 0));
  }

  .\\33xl\\:focus\\:via-programEditorTabColors-6h:focus{
    --gradient-via-color: #ffe8e6;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 232, 230, 0));
  }

  .\\33xl\\:focus\\:via-programEditorPresetTabColors-1:focus{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\33xl\\:focus\\:via-programEditorPresetTabColors-1h:focus{
    --gradient-via-color: #798fa3;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(121, 143, 163, 0));
  }

  .\\33xl\\:focus\\:via-borgScaleColors-0:focus{
    --gradient-via-color: #c5d1ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(197, 209, 255, 0));
  }

  .\\33xl\\:focus\\:via-borgScaleColors-1:focus{
    --gradient-via-color: #a0b5fc;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(160, 181, 252, 0));
  }

  .\\33xl\\:focus\\:via-borgScaleColors-2:focus{
    --gradient-via-color: #7492ff;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(116, 146, 255, 0));
  }

  .\\33xl\\:focus\\:via-borgScaleColors-3:focus{
    --gradient-via-color: #82bbf1;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(130, 187, 241, 0));
  }

  .\\33xl\\:focus\\:via-borgScaleColors-4:focus{
    --gradient-via-color: #4ba4f7;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(75, 164, 247, 0));
  }

  .\\33xl\\:focus\\:via-borgScaleColors-5:focus{
    --gradient-via-color: #9cdd57;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(156, 221, 87, 0));
  }

  .\\33xl\\:focus\\:via-borgScaleColors-6:focus{
    --gradient-via-color: #68af00;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(104, 175, 0, 0));
  }

  .\\33xl\\:focus\\:via-borgScaleColors-7:focus{
    --gradient-via-color: #f5e380;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(245, 227, 128, 0));
  }

  .\\33xl\\:focus\\:via-borgScaleColors-8:focus{
    --gradient-via-color: #ffc246;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 194, 70, 0));
  }

  .\\33xl\\:focus\\:via-borgScaleColors-9:focus{
    --gradient-via-color: #ff782f;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(255, 120, 47, 0));
  }

  .\\33xl\\:focus\\:via-borgScaleColors-10:focus{
    --gradient-via-color: #f25757;
    --gradient-color-stops: var(--gradient-from-color), var(--gradient-via-color), var(--gradient-to-color, rgba(242, 87, 87, 0));
  }

  .\\33xl\\:focus\\:to-transparent:focus{
    --gradient-to-color: transparent;
  }

  .\\33xl\\:focus\\:to-focus:focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);;
  }

  .\\33xl\\:focus\\:to-black:focus{
    --gradient-to-color: #000;
  }

  .\\33xl\\:focus\\:to-white:focus{
    --gradient-to-color: #fff;
  }

  .\\33xl\\:focus\\:to-primary:focus{
    --gradient-to-color: #37A4DC;
  }

  .\\33xl\\:focus\\:to-disabled:focus{
    --gradient-to-color: #BFBFBF;
  }

  .\\33xl\\:focus\\:to-translucent-60:focus{
    --gradient-to-color: rgba(256, 256, 256, 0.6);
  }

  .\\33xl\\:focus\\:to-translucent-90:focus{
    --gradient-to-color: rgba(256, 256, 256, 0.9);
  }

  .\\33xl\\:focus\\:to-green-200:focus{
    --gradient-to-color: #f4fcea;
  }

  .\\33xl\\:focus\\:to-green-400:focus{
    --gradient-to-color: #6CCA98;
  }

  .\\33xl\\:focus\\:to-green-500:focus{
    --gradient-to-color: #97E812;
  }

  .\\33xl\\:focus\\:to-green-600:focus{
    --gradient-to-color: #4f9112;
  }

  .\\33xl\\:focus\\:to-green-700:focus{
    --gradient-to-color: #3e7211;
  }

  .\\33xl\\:focus\\:to-green-400a50:focus{
    --gradient-to-color: rgba(108,202,152,0.50196);
  }

  .\\33xl\\:focus\\:to-green-500a25:focus{
    --gradient-to-color: rgba(151,232,18,0.09804);
  }

  .\\33xl\\:focus\\:to-yellow-200:focus{
    --gradient-to-color: #fff9eb;
  }

  .\\33xl\\:focus\\:to-yellow-300:focus{
    --gradient-to-color: #ffe9bd;
  }

  .\\33xl\\:focus\\:to-yellow-500:focus{
    --gradient-to-color: #FFC82C;
  }

  .\\33xl\\:focus\\:to-yellow-600:focus{
    --gradient-to-color: #F7931E;
  }

  .\\33xl\\:focus\\:to-yellow-700:focus{
    --gradient-to-color: #E1AD28;
  }

  .\\33xl\\:focus\\:to-yellow-300a66:focus{
    --gradient-to-color: rgba(255,233,189,0.66667);
  }

  .\\33xl\\:focus\\:to-yellow-500a25:focus{
    --gradient-to-color: rgba(255,200,44,0.09804);
  }

  .\\33xl\\:focus\\:to-orange-200:focus{
    --gradient-to-color: #fdf0ea;
  }

  .\\33xl\\:focus\\:to-orange-400:focus{
    --gradient-to-color: #f6c66f;
  }

  .\\33xl\\:focus\\:to-orange-500:focus{
    --gradient-to-color: #F07313;
  }

  .\\33xl\\:focus\\:to-orange-800:focus{
    --gradient-to-color: #db5d0c;
  }

  .\\33xl\\:focus\\:to-orange-900:focus{
    --gradient-to-color: #b86814;
  }

  .\\33xl\\:focus\\:to-orange-500a25:focus{
    --gradient-to-color: rgba(240,115,23,0.09804);
  }

  .\\33xl\\:focus\\:to-red-100:focus{
    --gradient-to-color: #FEF5F5;
  }

  .\\33xl\\:focus\\:to-red-150:focus{
    --gradient-to-color: #ffe9e8;
  }

  .\\33xl\\:focus\\:to-red-200:focus{
    --gradient-to-color: #F8CECC;
  }

  .\\33xl\\:focus\\:to-red-300:focus{
    --gradient-to-color: #ff8585;
  }

  .\\33xl\\:focus\\:to-red-400:focus{
    --gradient-to-color: #ff3535;
  }

  .\\33xl\\:focus\\:to-red-500:focus{
    --gradient-to-color: #DD4746;
  }

  .\\33xl\\:focus\\:to-red-700:focus{
    --gradient-to-color: #A23C24;
  }

  .\\33xl\\:focus\\:to-gray-50:focus{
    --gradient-to-color: #F9F9F9;
  }

  .\\33xl\\:focus\\:to-gray-100:focus{
    --gradient-to-color: #F1F1F2;
  }

  .\\33xl\\:focus\\:to-gray-150:focus{
    --gradient-to-color: #e6e6e6;
  }

  .\\33xl\\:focus\\:to-gray-200:focus{
    --gradient-to-color: #E0E2E4;
  }

  .\\33xl\\:focus\\:to-gray-300:focus{
    --gradient-to-color: #BFBFBF;
  }

  .\\33xl\\:focus\\:to-gray-400:focus{
    --gradient-to-color: rgba(114,114,114,0.8);
  }

  .\\33xl\\:focus\\:to-gray-425:focus{
    --gradient-to-color: rgba(4, 21, 39, 0.8);
  }

  .\\33xl\\:focus\\:to-gray-450:focus{
    --gradient-to-color: #959595;
  }

  .\\33xl\\:focus\\:to-gray-500:focus{
    --gradient-to-color: #727272;
  }

  .\\33xl\\:focus\\:to-gray-600:focus{
    --gradient-to-color: #5a626b;
  }

  .\\33xl\\:focus\\:to-gray-625:focus{
    --gradient-to-color: rgba(90,98,107,0.8);
  }

  .\\33xl\\:focus\\:to-gray-700:focus{
    --gradient-to-color: #464C59;
  }

  .\\33xl\\:focus\\:to-gray-800:focus{
    --gradient-to-color: #3c3b3b;
  }

  .\\33xl\\:focus\\:to-gray-200a50:focus{
    --gradient-to-color: rgba(224, 226, 228, 0.5);
  }

  .\\33xl\\:focus\\:to-blue-50:focus{
    --gradient-to-color: #f2fbff;
  }

  .\\33xl\\:focus\\:to-blue-100:focus{
    --gradient-to-color: #EBF6FC;
  }

  .\\33xl\\:focus\\:to-blue-150:focus{
    --gradient-to-color: #E8EEF1;
  }

  .\\33xl\\:focus\\:to-blue-200:focus{
    --gradient-to-color: #CCE6F5;
  }

  .\\33xl\\:focus\\:to-blue-300:focus{
    --gradient-to-color: #73BFE7;
  }

  .\\33xl\\:focus\\:to-blue-400:focus{
    --gradient-to-color: #4BA4F7;
  }

  .\\33xl\\:focus\\:to-blue-500:focus{
    --gradient-to-color: #37A4DC;
  }

  .\\33xl\\:focus\\:to-blue-600:focus{
    --gradient-to-color: #6AA2D6;
  }

  .\\33xl\\:focus\\:to-blue-700:focus{
    --gradient-to-color: #456E9A;
  }

  .\\33xl\\:focus\\:to-blue-750:focus{
    --gradient-to-color: #5682AA;
  }

  .\\33xl\\:focus\\:to-blue-800:focus{
    --gradient-to-color: #1F4566;
  }

  .\\33xl\\:focus\\:to-blue-900:focus{
    --gradient-to-color: #183453;
  }

  .\\33xl\\:focus\\:to-blue-950:focus{
    --gradient-to-color: #041527;
  }

  .\\33xl\\:focus\\:to-blue-500a25:focus{
    --gradient-to-color: rgba(55, 164, 220, 0.2);
  }

  .\\33xl\\:focus\\:to-blue-500a50:focus{
    --gradient-to-color: rgba(55, 164, 220, 0.5);
  }

  .\\33xl\\:focus\\:to-blue-700a75:focus{
    --gradient-to-color: #3B648D;
  }

  .\\33xl\\:focus\\:to-blue-700a30:focus{
    --gradient-to-color: #2A5176;
  }

  .\\33xl\\:focus\\:to-blue-750a25:focus{
    --gradient-to-color: rgba(86,130,170,0.09804);
  }

  .\\33xl\\:focus\\:to-blue-750a15:focus{
    --gradient-to-color: rgba(86,130,170,0.05882);
  }

  .\\33xl\\:focus\\:to-blue-800a60:focus{
    --gradient-to-color: rgba(31, 69, 102, 0.6);
  }

  .\\33xl\\:focus\\:to-programEditorTabColors-1:focus{
    --gradient-to-color: #3cacae;
  }

  .\\33xl\\:focus\\:to-programEditorTabColors-2:focus{
    --gradient-to-color: #8e346a;
  }

  .\\33xl\\:focus\\:to-programEditorTabColors-3:focus{
    --gradient-to-color: #ff72b7;
  }

  .\\33xl\\:focus\\:to-programEditorTabColors-4:focus{
    --gradient-to-color: #ce941c;
  }

  .\\33xl\\:focus\\:to-programEditorTabColors-5:focus{
    --gradient-to-color: #b973d9;
  }

  .\\33xl\\:focus\\:to-programEditorTabColors-6:focus{
    --gradient-to-color: #ff9082;
  }

  .\\33xl\\:focus\\:to-programEditorTabColors-1h:focus{
    --gradient-to-color: #d9f2f2;
  }

  .\\33xl\\:focus\\:to-programEditorTabColors-2h:focus{
    --gradient-to-color: #f1dae8;
  }

  .\\33xl\\:focus\\:to-programEditorTabColors-3h:focus{
    --gradient-to-color: #ffe6f2;
  }

  .\\33xl\\:focus\\:to-programEditorTabColors-4h:focus{
    --gradient-to-color: #f9ecd2;
  }

  .\\33xl\\:focus\\:to-programEditorTabColors-5h:focus{
    --gradient-to-color: #f5ebfa;
  }

  .\\33xl\\:focus\\:to-programEditorTabColors-6h:focus{
    --gradient-to-color: #ffe8e6;
  }

  .\\33xl\\:focus\\:to-programEditorPresetTabColors-1:focus{
    --gradient-to-color: #798fa3;
  }

  .\\33xl\\:focus\\:to-programEditorPresetTabColors-1h:focus{
    --gradient-to-color: #798fa3;
  }

  .\\33xl\\:focus\\:to-borgScaleColors-0:focus{
    --gradient-to-color: #c5d1ff;
  }

  .\\33xl\\:focus\\:to-borgScaleColors-1:focus{
    --gradient-to-color: #a0b5fc;
  }

  .\\33xl\\:focus\\:to-borgScaleColors-2:focus{
    --gradient-to-color: #7492ff;
  }

  .\\33xl\\:focus\\:to-borgScaleColors-3:focus{
    --gradient-to-color: #82bbf1;
  }

  .\\33xl\\:focus\\:to-borgScaleColors-4:focus{
    --gradient-to-color: #4ba4f7;
  }

  .\\33xl\\:focus\\:to-borgScaleColors-5:focus{
    --gradient-to-color: #9cdd57;
  }

  .\\33xl\\:focus\\:to-borgScaleColors-6:focus{
    --gradient-to-color: #68af00;
  }

  .\\33xl\\:focus\\:to-borgScaleColors-7:focus{
    --gradient-to-color: #f5e380;
  }

  .\\33xl\\:focus\\:to-borgScaleColors-8:focus{
    --gradient-to-color: #ffc246;
  }

  .\\33xl\\:focus\\:to-borgScaleColors-9:focus{
    --gradient-to-color: #ff782f;
  }

  .\\33xl\\:focus\\:to-borgScaleColors-10:focus{
    --gradient-to-color: #f25757;
  }

  .\\33xl\\:bg-opacity-0{
    --bg-opacity: 0;
  }

  .\\33xl\\:bg-opacity-25{
    --bg-opacity: .25;
  }

  .\\33xl\\:bg-opacity-50{
    --bg-opacity: .5;
  }

  .\\33xl\\:bg-opacity-75{
    --bg-opacity: .75;
  }

  .\\33xl\\:bg-opacity-100{
    --bg-opacity: 1;
  }

  .\\33xl\\:hover\\:bg-opacity-0:hover{
    --bg-opacity: 0;
  }

  .\\33xl\\:hover\\:bg-opacity-25:hover{
    --bg-opacity: .25;
  }

  .\\33xl\\:hover\\:bg-opacity-50:hover{
    --bg-opacity: .5;
  }

  .\\33xl\\:hover\\:bg-opacity-75:hover{
    --bg-opacity: .75;
  }

  .\\33xl\\:hover\\:bg-opacity-100:hover{
    --bg-opacity: 1;
  }

  .\\33xl\\:focus\\:bg-opacity-0:focus{
    --bg-opacity: 0;
  }

  .\\33xl\\:focus\\:bg-opacity-25:focus{
    --bg-opacity: .25;
  }

  .\\33xl\\:focus\\:bg-opacity-50:focus{
    --bg-opacity: .5;
  }

  .\\33xl\\:focus\\:bg-opacity-75:focus{
    --bg-opacity: .75;
  }

  .\\33xl\\:focus\\:bg-opacity-100:focus{
    --bg-opacity: 1;
  }

  .\\33xl\\:bg-bottom{
    background-position: bottom;
  }

  .\\33xl\\:bg-center{
    background-position: center;
  }

  .\\33xl\\:bg-left{
    background-position: left;
  }

  .\\33xl\\:bg-left-bottom{
    background-position: left bottom;
  }

  .\\33xl\\:bg-left-top{
    background-position: left top;
  }

  .\\33xl\\:bg-right{
    background-position: right;
  }

  .\\33xl\\:bg-right-bottom{
    background-position: right bottom;
  }

  .\\33xl\\:bg-right-top{
    background-position: right top;
  }

  .\\33xl\\:bg-top{
    background-position: top;
  }

  .\\33xl\\:bg-repeat{
    background-repeat: repeat;
  }

  .\\33xl\\:bg-no-repeat{
    background-repeat: no-repeat;
  }

  .\\33xl\\:bg-repeat-x{
    background-repeat: repeat-x;
  }

  .\\33xl\\:bg-repeat-y{
    background-repeat: repeat-y;
  }

  .\\33xl\\:bg-repeat-round{
    background-repeat: round;
  }

  .\\33xl\\:bg-repeat-space{
    background-repeat: space;
  }

  .\\33xl\\:bg-auto{
    background-size: auto;
  }

  .\\33xl\\:bg-cover{
    background-size: cover;
  }

  .\\33xl\\:bg-contain{
    background-size: contain;
  }

  .\\33xl\\:border-transparent{
    border-color: transparent;
  }

  .\\33xl\\:border-focus{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .\\33xl\\:border-black{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .\\33xl\\:border-white{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .\\33xl\\:border-primary{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .\\33xl\\:border-disabled{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .\\33xl\\:border-translucent-60{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .\\33xl\\:border-translucent-90{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .\\33xl\\:border-green-200{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .\\33xl\\:border-green-400{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .\\33xl\\:border-green-500{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .\\33xl\\:border-green-600{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .\\33xl\\:border-green-700{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .\\33xl\\:border-green-400a50{
    border-color: rgba(108,202,152,0.50196);
  }

  .\\33xl\\:border-green-500a25{
    border-color: rgba(151,232,18,0.09804);
  }

  .\\33xl\\:border-yellow-200{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .\\33xl\\:border-yellow-300{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .\\33xl\\:border-yellow-500{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .\\33xl\\:border-yellow-600{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .\\33xl\\:border-yellow-700{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .\\33xl\\:border-yellow-300a66{
    border-color: rgba(255,233,189,0.66667);
  }

  .\\33xl\\:border-yellow-500a25{
    border-color: rgba(255,200,44,0.09804);
  }

  .\\33xl\\:border-orange-200{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .\\33xl\\:border-orange-400{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .\\33xl\\:border-orange-500{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .\\33xl\\:border-orange-800{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .\\33xl\\:border-orange-900{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .\\33xl\\:border-orange-500a25{
    border-color: rgba(240,115,23,0.09804);
  }

  .\\33xl\\:border-red-100{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .\\33xl\\:border-red-150{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .\\33xl\\:border-red-200{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .\\33xl\\:border-red-300{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .\\33xl\\:border-red-400{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .\\33xl\\:border-red-500{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .\\33xl\\:border-red-700{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .\\33xl\\:border-gray-50{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .\\33xl\\:border-gray-100{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .\\33xl\\:border-gray-150{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .\\33xl\\:border-gray-200{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .\\33xl\\:border-gray-300{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .\\33xl\\:border-gray-400{
    border-color: rgba(114,114,114,0.8);
  }

  .\\33xl\\:border-gray-425{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .\\33xl\\:border-gray-450{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .\\33xl\\:border-gray-500{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .\\33xl\\:border-gray-600{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .\\33xl\\:border-gray-625{
    border-color: rgba(90,98,107,0.8);
  }

  .\\33xl\\:border-gray-700{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .\\33xl\\:border-gray-800{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .\\33xl\\:border-gray-200a50{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .\\33xl\\:border-blue-50{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .\\33xl\\:border-blue-100{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .\\33xl\\:border-blue-150{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .\\33xl\\:border-blue-200{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .\\33xl\\:border-blue-300{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .\\33xl\\:border-blue-400{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .\\33xl\\:border-blue-500{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .\\33xl\\:border-blue-600{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .\\33xl\\:border-blue-700{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .\\33xl\\:border-blue-750{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .\\33xl\\:border-blue-800{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .\\33xl\\:border-blue-900{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .\\33xl\\:border-blue-950{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .\\33xl\\:border-blue-500a25{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .\\33xl\\:border-blue-500a50{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .\\33xl\\:border-blue-700a75{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .\\33xl\\:border-blue-700a30{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .\\33xl\\:border-blue-750a25{
    border-color: rgba(86,130,170,0.09804);
  }

  .\\33xl\\:border-blue-750a15{
    border-color: rgba(86,130,170,0.05882);
  }

  .\\33xl\\:border-blue-800a60{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .\\33xl\\:border-programEditorTabColors-1{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .\\33xl\\:border-programEditorTabColors-2{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .\\33xl\\:border-programEditorTabColors-3{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .\\33xl\\:border-programEditorTabColors-4{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .\\33xl\\:border-programEditorTabColors-5{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .\\33xl\\:border-programEditorTabColors-6{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .\\33xl\\:border-programEditorTabColors-1h{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .\\33xl\\:border-programEditorTabColors-2h{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .\\33xl\\:border-programEditorTabColors-3h{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .\\33xl\\:border-programEditorTabColors-4h{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .\\33xl\\:border-programEditorTabColors-5h{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .\\33xl\\:border-programEditorTabColors-6h{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .\\33xl\\:border-programEditorPresetTabColors-1{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .\\33xl\\:border-programEditorPresetTabColors-1h{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .\\33xl\\:border-borgScaleColors-0{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .\\33xl\\:border-borgScaleColors-1{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .\\33xl\\:border-borgScaleColors-2{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .\\33xl\\:border-borgScaleColors-3{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .\\33xl\\:border-borgScaleColors-4{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .\\33xl\\:border-borgScaleColors-5{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .\\33xl\\:border-borgScaleColors-6{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .\\33xl\\:border-borgScaleColors-7{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .\\33xl\\:border-borgScaleColors-8{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .\\33xl\\:border-borgScaleColors-9{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .\\33xl\\:border-borgScaleColors-10{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-transparent:hover{
    border-color: transparent;
  }

  .\\33xl\\:hover\\:border-focus:hover{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .\\33xl\\:hover\\:border-black:hover{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-white:hover{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-primary:hover{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-disabled:hover{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-translucent-60:hover{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .\\33xl\\:hover\\:border-translucent-90:hover{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .\\33xl\\:hover\\:border-green-200:hover{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-green-400:hover{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-green-500:hover{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-green-600:hover{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-green-700:hover{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-green-400a50:hover{
    border-color: rgba(108,202,152,0.50196);
  }

  .\\33xl\\:hover\\:border-green-500a25:hover{
    border-color: rgba(151,232,18,0.09804);
  }

  .\\33xl\\:hover\\:border-yellow-200:hover{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-yellow-300:hover{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-yellow-500:hover{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-yellow-600:hover{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-yellow-700:hover{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-yellow-300a66:hover{
    border-color: rgba(255,233,189,0.66667);
  }

  .\\33xl\\:hover\\:border-yellow-500a25:hover{
    border-color: rgba(255,200,44,0.09804);
  }

  .\\33xl\\:hover\\:border-orange-200:hover{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-orange-400:hover{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-orange-500:hover{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-orange-800:hover{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-orange-900:hover{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-orange-500a25:hover{
    border-color: rgba(240,115,23,0.09804);
  }

  .\\33xl\\:hover\\:border-red-100:hover{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-red-150:hover{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-red-200:hover{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-red-300:hover{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-red-400:hover{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-red-500:hover{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-red-700:hover{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-gray-50:hover{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-gray-100:hover{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-gray-150:hover{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-gray-200:hover{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-gray-300:hover{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-gray-400:hover{
    border-color: rgba(114,114,114,0.8);
  }

  .\\33xl\\:hover\\:border-gray-425:hover{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .\\33xl\\:hover\\:border-gray-450:hover{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-gray-500:hover{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-gray-600:hover{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-gray-625:hover{
    border-color: rgba(90,98,107,0.8);
  }

  .\\33xl\\:hover\\:border-gray-700:hover{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-gray-800:hover{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-gray-200a50:hover{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .\\33xl\\:hover\\:border-blue-50:hover{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-blue-100:hover{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-blue-150:hover{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-blue-200:hover{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-blue-300:hover{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-blue-400:hover{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-blue-500:hover{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-blue-600:hover{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-blue-700:hover{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-blue-750:hover{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-blue-800:hover{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-blue-900:hover{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-blue-950:hover{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-blue-500a25:hover{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .\\33xl\\:hover\\:border-blue-500a50:hover{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .\\33xl\\:hover\\:border-blue-700a75:hover{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-blue-700a30:hover{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-blue-750a25:hover{
    border-color: rgba(86,130,170,0.09804);
  }

  .\\33xl\\:hover\\:border-blue-750a15:hover{
    border-color: rgba(86,130,170,0.05882);
  }

  .\\33xl\\:hover\\:border-blue-800a60:hover{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .\\33xl\\:hover\\:border-programEditorTabColors-1:hover{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-programEditorTabColors-2:hover{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-programEditorTabColors-3:hover{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-programEditorTabColors-4:hover{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-programEditorTabColors-5:hover{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-programEditorTabColors-6:hover{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-programEditorTabColors-1h:hover{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-programEditorTabColors-2h:hover{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-programEditorTabColors-3h:hover{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-programEditorTabColors-4h:hover{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-programEditorTabColors-5h:hover{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-programEditorTabColors-6h:hover{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-programEditorPresetTabColors-1:hover{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-programEditorPresetTabColors-1h:hover{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-borgScaleColors-0:hover{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-borgScaleColors-1:hover{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-borgScaleColors-2:hover{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-borgScaleColors-3:hover{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-borgScaleColors-4:hover{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-borgScaleColors-5:hover{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-borgScaleColors-6:hover{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-borgScaleColors-7:hover{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-borgScaleColors-8:hover{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-borgScaleColors-9:hover{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .\\33xl\\:hover\\:border-borgScaleColors-10:hover{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-transparent:focus{
    border-color: transparent;
  }

  .\\33xl\\:focus\\:border-focus:focus{
    border-color: rgba(4, 21, 39, 0.8);;
  }

  .\\33xl\\:focus\\:border-black:focus{
    --border-opacity: 1;
    border-color: #000;
    border-color: rgba(0, 0, 0, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-white:focus{
    --border-opacity: 1;
    border-color: #fff;
    border-color: rgba(255, 255, 255, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-primary:focus{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-disabled:focus{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-translucent-60:focus{
    border-color: rgba(256, 256, 256, 0.6);
  }

  .\\33xl\\:focus\\:border-translucent-90:focus{
    border-color: rgba(256, 256, 256, 0.9);
  }

  .\\33xl\\:focus\\:border-green-200:focus{
    --border-opacity: 1;
    border-color: #f4fcea;
    border-color: rgba(244, 252, 234, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-green-400:focus{
    --border-opacity: 1;
    border-color: #6CCA98;
    border-color: rgba(108, 202, 152, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-green-500:focus{
    --border-opacity: 1;
    border-color: #97E812;
    border-color: rgba(151, 232, 18, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-green-600:focus{
    --border-opacity: 1;
    border-color: #4f9112;
    border-color: rgba(79, 145, 18, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-green-700:focus{
    --border-opacity: 1;
    border-color: #3e7211;
    border-color: rgba(62, 114, 17, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-green-400a50:focus{
    border-color: rgba(108,202,152,0.50196);
  }

  .\\33xl\\:focus\\:border-green-500a25:focus{
    border-color: rgba(151,232,18,0.09804);
  }

  .\\33xl\\:focus\\:border-yellow-200:focus{
    --border-opacity: 1;
    border-color: #fff9eb;
    border-color: rgba(255, 249, 235, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-yellow-300:focus{
    --border-opacity: 1;
    border-color: #ffe9bd;
    border-color: rgba(255, 233, 189, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-yellow-500:focus{
    --border-opacity: 1;
    border-color: #FFC82C;
    border-color: rgba(255, 200, 44, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-yellow-600:focus{
    --border-opacity: 1;
    border-color: #F7931E;
    border-color: rgba(247, 147, 30, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-yellow-700:focus{
    --border-opacity: 1;
    border-color: #E1AD28;
    border-color: rgba(225, 173, 40, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-yellow-300a66:focus{
    border-color: rgba(255,233,189,0.66667);
  }

  .\\33xl\\:focus\\:border-yellow-500a25:focus{
    border-color: rgba(255,200,44,0.09804);
  }

  .\\33xl\\:focus\\:border-orange-200:focus{
    --border-opacity: 1;
    border-color: #fdf0ea;
    border-color: rgba(253, 240, 234, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-orange-400:focus{
    --border-opacity: 1;
    border-color: #f6c66f;
    border-color: rgba(246, 198, 111, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-orange-500:focus{
    --border-opacity: 1;
    border-color: #F07313;
    border-color: rgba(240, 115, 19, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-orange-800:focus{
    --border-opacity: 1;
    border-color: #db5d0c;
    border-color: rgba(219, 93, 12, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-orange-900:focus{
    --border-opacity: 1;
    border-color: #b86814;
    border-color: rgba(184, 104, 20, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-orange-500a25:focus{
    border-color: rgba(240,115,23,0.09804);
  }

  .\\33xl\\:focus\\:border-red-100:focus{
    --border-opacity: 1;
    border-color: #FEF5F5;
    border-color: rgba(254, 245, 245, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-red-150:focus{
    --border-opacity: 1;
    border-color: #ffe9e8;
    border-color: rgba(255, 233, 232, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-red-200:focus{
    --border-opacity: 1;
    border-color: #F8CECC;
    border-color: rgba(248, 206, 204, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-red-300:focus{
    --border-opacity: 1;
    border-color: #ff8585;
    border-color: rgba(255, 133, 133, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-red-400:focus{
    --border-opacity: 1;
    border-color: #ff3535;
    border-color: rgba(255, 53, 53, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-red-500:focus{
    --border-opacity: 1;
    border-color: #DD4746;
    border-color: rgba(221, 71, 70, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-red-700:focus{
    --border-opacity: 1;
    border-color: #A23C24;
    border-color: rgba(162, 60, 36, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-gray-50:focus{
    --border-opacity: 1;
    border-color: #F9F9F9;
    border-color: rgba(249, 249, 249, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-gray-100:focus{
    --border-opacity: 1;
    border-color: #F1F1F2;
    border-color: rgba(241, 241, 242, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-gray-150:focus{
    --border-opacity: 1;
    border-color: #e6e6e6;
    border-color: rgba(230, 230, 230, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-gray-200:focus{
    --border-opacity: 1;
    border-color: #E0E2E4;
    border-color: rgba(224, 226, 228, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-gray-300:focus{
    --border-opacity: 1;
    border-color: #BFBFBF;
    border-color: rgba(191, 191, 191, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-gray-400:focus{
    border-color: rgba(114,114,114,0.8);
  }

  .\\33xl\\:focus\\:border-gray-425:focus{
    border-color: rgba(4, 21, 39, 0.8);
  }

  .\\33xl\\:focus\\:border-gray-450:focus{
    --border-opacity: 1;
    border-color: #959595;
    border-color: rgba(149, 149, 149, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-gray-500:focus{
    --border-opacity: 1;
    border-color: #727272;
    border-color: rgba(114, 114, 114, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-gray-600:focus{
    --border-opacity: 1;
    border-color: #5a626b;
    border-color: rgba(90, 98, 107, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-gray-625:focus{
    border-color: rgba(90,98,107,0.8);
  }

  .\\33xl\\:focus\\:border-gray-700:focus{
    --border-opacity: 1;
    border-color: #464C59;
    border-color: rgba(70, 76, 89, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-gray-800:focus{
    --border-opacity: 1;
    border-color: #3c3b3b;
    border-color: rgba(60, 59, 59, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-gray-200a50:focus{
    border-color: rgba(224, 226, 228, 0.5);
  }

  .\\33xl\\:focus\\:border-blue-50:focus{
    --border-opacity: 1;
    border-color: #f2fbff;
    border-color: rgba(242, 251, 255, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-blue-100:focus{
    --border-opacity: 1;
    border-color: #EBF6FC;
    border-color: rgba(235, 246, 252, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-blue-150:focus{
    --border-opacity: 1;
    border-color: #E8EEF1;
    border-color: rgba(232, 238, 241, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-blue-200:focus{
    --border-opacity: 1;
    border-color: #CCE6F5;
    border-color: rgba(204, 230, 245, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-blue-300:focus{
    --border-opacity: 1;
    border-color: #73BFE7;
    border-color: rgba(115, 191, 231, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-blue-400:focus{
    --border-opacity: 1;
    border-color: #4BA4F7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-blue-500:focus{
    --border-opacity: 1;
    border-color: #37A4DC;
    border-color: rgba(55, 164, 220, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-blue-600:focus{
    --border-opacity: 1;
    border-color: #6AA2D6;
    border-color: rgba(106, 162, 214, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-blue-700:focus{
    --border-opacity: 1;
    border-color: #456E9A;
    border-color: rgba(69, 110, 154, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-blue-750:focus{
    --border-opacity: 1;
    border-color: #5682AA;
    border-color: rgba(86, 130, 170, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-blue-800:focus{
    --border-opacity: 1;
    border-color: #1F4566;
    border-color: rgba(31, 69, 102, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-blue-900:focus{
    --border-opacity: 1;
    border-color: #183453;
    border-color: rgba(24, 52, 83, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-blue-950:focus{
    --border-opacity: 1;
    border-color: #041527;
    border-color: rgba(4, 21, 39, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-blue-500a25:focus{
    border-color: rgba(55, 164, 220, 0.2);
  }

  .\\33xl\\:focus\\:border-blue-500a50:focus{
    border-color: rgba(55, 164, 220, 0.5);
  }

  .\\33xl\\:focus\\:border-blue-700a75:focus{
    --border-opacity: 1;
    border-color: #3B648D;
    border-color: rgba(59, 100, 141, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-blue-700a30:focus{
    --border-opacity: 1;
    border-color: #2A5176;
    border-color: rgba(42, 81, 118, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-blue-750a25:focus{
    border-color: rgba(86,130,170,0.09804);
  }

  .\\33xl\\:focus\\:border-blue-750a15:focus{
    border-color: rgba(86,130,170,0.05882);
  }

  .\\33xl\\:focus\\:border-blue-800a60:focus{
    border-color: rgba(31, 69, 102, 0.6);
  }

  .\\33xl\\:focus\\:border-programEditorTabColors-1:focus{
    --border-opacity: 1;
    border-color: #3cacae;
    border-color: rgba(60, 172, 174, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-programEditorTabColors-2:focus{
    --border-opacity: 1;
    border-color: #8e346a;
    border-color: rgba(142, 52, 106, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-programEditorTabColors-3:focus{
    --border-opacity: 1;
    border-color: #ff72b7;
    border-color: rgba(255, 114, 183, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-programEditorTabColors-4:focus{
    --border-opacity: 1;
    border-color: #ce941c;
    border-color: rgba(206, 148, 28, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-programEditorTabColors-5:focus{
    --border-opacity: 1;
    border-color: #b973d9;
    border-color: rgba(185, 115, 217, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-programEditorTabColors-6:focus{
    --border-opacity: 1;
    border-color: #ff9082;
    border-color: rgba(255, 144, 130, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-programEditorTabColors-1h:focus{
    --border-opacity: 1;
    border-color: #d9f2f2;
    border-color: rgba(217, 242, 242, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-programEditorTabColors-2h:focus{
    --border-opacity: 1;
    border-color: #f1dae8;
    border-color: rgba(241, 218, 232, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-programEditorTabColors-3h:focus{
    --border-opacity: 1;
    border-color: #ffe6f2;
    border-color: rgba(255, 230, 242, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-programEditorTabColors-4h:focus{
    --border-opacity: 1;
    border-color: #f9ecd2;
    border-color: rgba(249, 236, 210, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-programEditorTabColors-5h:focus{
    --border-opacity: 1;
    border-color: #f5ebfa;
    border-color: rgba(245, 235, 250, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-programEditorTabColors-6h:focus{
    --border-opacity: 1;
    border-color: #ffe8e6;
    border-color: rgba(255, 232, 230, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-programEditorPresetTabColors-1:focus{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-programEditorPresetTabColors-1h:focus{
    --border-opacity: 1;
    border-color: #798fa3;
    border-color: rgba(121, 143, 163, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-borgScaleColors-0:focus{
    --border-opacity: 1;
    border-color: #c5d1ff;
    border-color: rgba(197, 209, 255, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-borgScaleColors-1:focus{
    --border-opacity: 1;
    border-color: #a0b5fc;
    border-color: rgba(160, 181, 252, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-borgScaleColors-2:focus{
    --border-opacity: 1;
    border-color: #7492ff;
    border-color: rgba(116, 146, 255, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-borgScaleColors-3:focus{
    --border-opacity: 1;
    border-color: #82bbf1;
    border-color: rgba(130, 187, 241, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-borgScaleColors-4:focus{
    --border-opacity: 1;
    border-color: #4ba4f7;
    border-color: rgba(75, 164, 247, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-borgScaleColors-5:focus{
    --border-opacity: 1;
    border-color: #9cdd57;
    border-color: rgba(156, 221, 87, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-borgScaleColors-6:focus{
    --border-opacity: 1;
    border-color: #68af00;
    border-color: rgba(104, 175, 0, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-borgScaleColors-7:focus{
    --border-opacity: 1;
    border-color: #f5e380;
    border-color: rgba(245, 227, 128, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-borgScaleColors-8:focus{
    --border-opacity: 1;
    border-color: #ffc246;
    border-color: rgba(255, 194, 70, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-borgScaleColors-9:focus{
    --border-opacity: 1;
    border-color: #ff782f;
    border-color: rgba(255, 120, 47, var(--border-opacity));
  }

  .\\33xl\\:focus\\:border-borgScaleColors-10:focus{
    --border-opacity: 1;
    border-color: #f25757;
    border-color: rgba(242, 87, 87, var(--border-opacity));
  }

  .\\33xl\\:border-opacity-0{
    --border-opacity: 0;
  }

  .\\33xl\\:border-opacity-25{
    --border-opacity: .25;
  }

  .\\33xl\\:border-opacity-50{
    --border-opacity: .5;
  }

  .\\33xl\\:border-opacity-75{
    --border-opacity: .75;
  }

  .\\33xl\\:border-opacity-100{
    --border-opacity: 1;
  }

  .\\33xl\\:hover\\:border-opacity-0:hover{
    --border-opacity: 0;
  }

  .\\33xl\\:hover\\:border-opacity-25:hover{
    --border-opacity: .25;
  }

  .\\33xl\\:hover\\:border-opacity-50:hover{
    --border-opacity: .5;
  }

  .\\33xl\\:hover\\:border-opacity-75:hover{
    --border-opacity: .75;
  }

  .\\33xl\\:hover\\:border-opacity-100:hover{
    --border-opacity: 1;
  }

  .\\33xl\\:focus\\:border-opacity-0:focus{
    --border-opacity: 0;
  }

  .\\33xl\\:focus\\:border-opacity-25:focus{
    --border-opacity: .25;
  }

  .\\33xl\\:focus\\:border-opacity-50:focus{
    --border-opacity: .5;
  }

  .\\33xl\\:focus\\:border-opacity-75:focus{
    --border-opacity: .75;
  }

  .\\33xl\\:focus\\:border-opacity-100:focus{
    --border-opacity: 1;
  }

  .\\33xl\\:rounded-none{
    border-radius: 0;
  }

  .\\33xl\\:rounded-sm{
    border-radius: .25rem;
  }

  .\\33xl\\:rounded{
    border-radius: .375rem;
  }

  .\\33xl\\:rounded-lg{
    border-radius: .5rem;
  }

  .\\33xl\\:rounded-xl{
    border-radius: .75rem;
  }

  .\\33xl\\:rounded-full{
    border-radius: 9999px;
  }

  .\\33xl\\:rounded-t-none{
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  .\\33xl\\:rounded-r-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  .\\33xl\\:rounded-b-none{
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }

  .\\33xl\\:rounded-l-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .\\33xl\\:rounded-t-sm{
    border-top-left-radius: .25rem;
    border-top-right-radius: .25rem;
  }

  .\\33xl\\:rounded-r-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  .\\33xl\\:rounded-b-sm{
    border-bottom-right-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  .\\33xl\\:rounded-l-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  .\\33xl\\:rounded-t{
    border-top-left-radius: .375rem;
    border-top-right-radius: .375rem;
  }

  .\\33xl\\:rounded-r{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  .\\33xl\\:rounded-b{
    border-bottom-right-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  .\\33xl\\:rounded-l{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  .\\33xl\\:rounded-t-lg{
    border-top-left-radius: .5rem;
    border-top-right-radius: .5rem;
  }

  .\\33xl\\:rounded-r-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  .\\33xl\\:rounded-b-lg{
    border-bottom-right-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  .\\33xl\\:rounded-l-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  .\\33xl\\:rounded-t-xl{
    border-top-left-radius: .75rem;
    border-top-right-radius: .75rem;
  }

  .\\33xl\\:rounded-r-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  .\\33xl\\:rounded-b-xl{
    border-bottom-right-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  .\\33xl\\:rounded-l-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  .\\33xl\\:rounded-t-full{
    border-top-left-radius: 9999px;
    border-top-right-radius: 9999px;
  }

  .\\33xl\\:rounded-r-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  .\\33xl\\:rounded-b-full{
    border-bottom-right-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .\\33xl\\:rounded-l-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  .\\33xl\\:rounded-tl-none{
    border-top-left-radius: 0;
  }

  .\\33xl\\:rounded-tr-none{
    border-top-right-radius: 0;
  }

  .\\33xl\\:rounded-br-none{
    border-bottom-right-radius: 0;
  }

  .\\33xl\\:rounded-bl-none{
    border-bottom-left-radius: 0;
  }

  .\\33xl\\:rounded-tl-sm{
    border-top-left-radius: .25rem;
  }

  .\\33xl\\:rounded-tr-sm{
    border-top-right-radius: .25rem;
  }

  .\\33xl\\:rounded-br-sm{
    border-bottom-right-radius: .25rem;
  }

  .\\33xl\\:rounded-bl-sm{
    border-bottom-left-radius: .25rem;
  }

  .\\33xl\\:rounded-tl{
    border-top-left-radius: .375rem;
  }

  .\\33xl\\:rounded-tr{
    border-top-right-radius: .375rem;
  }

  .\\33xl\\:rounded-br{
    border-bottom-right-radius: .375rem;
  }

  .\\33xl\\:rounded-bl{
    border-bottom-left-radius: .375rem;
  }

  .\\33xl\\:rounded-tl-lg{
    border-top-left-radius: .5rem;
  }

  .\\33xl\\:rounded-tr-lg{
    border-top-right-radius: .5rem;
  }

  .\\33xl\\:rounded-br-lg{
    border-bottom-right-radius: .5rem;
  }

  .\\33xl\\:rounded-bl-lg{
    border-bottom-left-radius: .5rem;
  }

  .\\33xl\\:rounded-tl-xl{
    border-top-left-radius: .75rem;
  }

  .\\33xl\\:rounded-tr-xl{
    border-top-right-radius: .75rem;
  }

  .\\33xl\\:rounded-br-xl{
    border-bottom-right-radius: .75rem;
  }

  .\\33xl\\:rounded-bl-xl{
    border-bottom-left-radius: .75rem;
  }

  .\\33xl\\:rounded-tl-full{
    border-top-left-radius: 9999px;
  }

  .\\33xl\\:rounded-tr-full{
    border-top-right-radius: 9999px;
  }

  .\\33xl\\:rounded-br-full{
    border-bottom-right-radius: 9999px;
  }

  .\\33xl\\:rounded-bl-full{
    border-bottom-left-radius: 9999px;
  }

  .\\33xl\\:border-solid{
    border-style: solid;
  }

  .\\33xl\\:border-dashed{
    border-style: dashed;
  }

  .\\33xl\\:border-dotted{
    border-style: dotted;
  }

  .\\33xl\\:border-double{
    border-style: double;
  }

  .\\33xl\\:border-none{
    border-style: none;
  }

  .\\33xl\\:border-0{
    border-width: 0;
  }

  .\\33xl\\:border-2{
    border-width: 2px;
  }

  .\\33xl\\:border-3{
    border-width: 3px;
  }

  .\\33xl\\:border-4{
    border-width: 4px;
  }

  .\\33xl\\:border-5{
    border-width: 5px;
  }

  .\\33xl\\:border-6{
    border-width: 6px;
  }

  .\\33xl\\:border-8{
    border-width: 8px;
  }

  .\\33xl\\:border{
    border-width: 1px;
  }

  .\\33xl\\:border-t-0{
    border-top-width: 0;
  }

  .\\33xl\\:border-r-0{
    border-right-width: 0;
  }

  .\\33xl\\:border-b-0{
    border-bottom-width: 0;
  }

  .\\33xl\\:border-l-0{
    border-left-width: 0;
  }

  .\\33xl\\:border-t-2{
    border-top-width: 2px;
  }

  .\\33xl\\:border-r-2{
    border-right-width: 2px;
  }

  .\\33xl\\:border-b-2{
    border-bottom-width: 2px;
  }

  .\\33xl\\:border-l-2{
    border-left-width: 2px;
  }

  .\\33xl\\:border-t-3{
    border-top-width: 3px;
  }

  .\\33xl\\:border-r-3{
    border-right-width: 3px;
  }

  .\\33xl\\:border-b-3{
    border-bottom-width: 3px;
  }

  .\\33xl\\:border-l-3{
    border-left-width: 3px;
  }

  .\\33xl\\:border-t-4{
    border-top-width: 4px;
  }

  .\\33xl\\:border-r-4{
    border-right-width: 4px;
  }

  .\\33xl\\:border-b-4{
    border-bottom-width: 4px;
  }

  .\\33xl\\:border-l-4{
    border-left-width: 4px;
  }

  .\\33xl\\:border-t-5{
    border-top-width: 5px;
  }

  .\\33xl\\:border-r-5{
    border-right-width: 5px;
  }

  .\\33xl\\:border-b-5{
    border-bottom-width: 5px;
  }

  .\\33xl\\:border-l-5{
    border-left-width: 5px;
  }

  .\\33xl\\:border-t-6{
    border-top-width: 6px;
  }

  .\\33xl\\:border-r-6{
    border-right-width: 6px;
  }

  .\\33xl\\:border-b-6{
    border-bottom-width: 6px;
  }

  .\\33xl\\:border-l-6{
    border-left-width: 6px;
  }

  .\\33xl\\:border-t-8{
    border-top-width: 8px;
  }

  .\\33xl\\:border-r-8{
    border-right-width: 8px;
  }

  .\\33xl\\:border-b-8{
    border-bottom-width: 8px;
  }

  .\\33xl\\:border-l-8{
    border-left-width: 8px;
  }

  .\\33xl\\:border-t{
    border-top-width: 1px;
  }

  .\\33xl\\:border-r{
    border-right-width: 1px;
  }

  .\\33xl\\:border-b{
    border-bottom-width: 1px;
  }

  .\\33xl\\:border-l{
    border-left-width: 1px;
  }

  .\\33xl\\:first\\:border-0:first-child{
    border-width: 0;
  }

  .\\33xl\\:first\\:border-2:first-child{
    border-width: 2px;
  }

  .\\33xl\\:first\\:border-3:first-child{
    border-width: 3px;
  }

  .\\33xl\\:first\\:border-4:first-child{
    border-width: 4px;
  }

  .\\33xl\\:first\\:border-5:first-child{
    border-width: 5px;
  }

  .\\33xl\\:first\\:border-6:first-child{
    border-width: 6px;
  }

  .\\33xl\\:first\\:border-8:first-child{
    border-width: 8px;
  }

  .\\33xl\\:first\\:border:first-child{
    border-width: 1px;
  }

  .\\33xl\\:first\\:border-t-0:first-child{
    border-top-width: 0;
  }

  .\\33xl\\:first\\:border-r-0:first-child{
    border-right-width: 0;
  }

  .\\33xl\\:first\\:border-b-0:first-child{
    border-bottom-width: 0;
  }

  .\\33xl\\:first\\:border-l-0:first-child{
    border-left-width: 0;
  }

  .\\33xl\\:first\\:border-t-2:first-child{
    border-top-width: 2px;
  }

  .\\33xl\\:first\\:border-r-2:first-child{
    border-right-width: 2px;
  }

  .\\33xl\\:first\\:border-b-2:first-child{
    border-bottom-width: 2px;
  }

  .\\33xl\\:first\\:border-l-2:first-child{
    border-left-width: 2px;
  }

  .\\33xl\\:first\\:border-t-3:first-child{
    border-top-width: 3px;
  }

  .\\33xl\\:first\\:border-r-3:first-child{
    border-right-width: 3px;
  }

  .\\33xl\\:first\\:border-b-3:first-child{
    border-bottom-width: 3px;
  }

  .\\33xl\\:first\\:border-l-3:first-child{
    border-left-width: 3px;
  }

  .\\33xl\\:first\\:border-t-4:first-child{
    border-top-width: 4px;
  }

  .\\33xl\\:first\\:border-r-4:first-child{
    border-right-width: 4px;
  }

  .\\33xl\\:first\\:border-b-4:first-child{
    border-bottom-width: 4px;
  }

  .\\33xl\\:first\\:border-l-4:first-child{
    border-left-width: 4px;
  }

  .\\33xl\\:first\\:border-t-5:first-child{
    border-top-width: 5px;
  }

  .\\33xl\\:first\\:border-r-5:first-child{
    border-right-width: 5px;
  }

  .\\33xl\\:first\\:border-b-5:first-child{
    border-bottom-width: 5px;
  }

  .\\33xl\\:first\\:border-l-5:first-child{
    border-left-width: 5px;
  }

  .\\33xl\\:first\\:border-t-6:first-child{
    border-top-width: 6px;
  }

  .\\33xl\\:first\\:border-r-6:first-child{
    border-right-width: 6px;
  }

  .\\33xl\\:first\\:border-b-6:first-child{
    border-bottom-width: 6px;
  }

  .\\33xl\\:first\\:border-l-6:first-child{
    border-left-width: 6px;
  }

  .\\33xl\\:first\\:border-t-8:first-child{
    border-top-width: 8px;
  }

  .\\33xl\\:first\\:border-r-8:first-child{
    border-right-width: 8px;
  }

  .\\33xl\\:first\\:border-b-8:first-child{
    border-bottom-width: 8px;
  }

  .\\33xl\\:first\\:border-l-8:first-child{
    border-left-width: 8px;
  }

  .\\33xl\\:first\\:border-t:first-child{
    border-top-width: 1px;
  }

  .\\33xl\\:first\\:border-r:first-child{
    border-right-width: 1px;
  }

  .\\33xl\\:first\\:border-b:first-child{
    border-bottom-width: 1px;
  }

  .\\33xl\\:first\\:border-l:first-child{
    border-left-width: 1px;
  }

  .\\33xl\\:box-border{
    box-sizing: border-box;
  }

  .\\33xl\\:box-content{
    box-sizing: content-box;
  }

  .\\33xl\\:cursor-auto{
    cursor: auto;
  }

  .\\33xl\\:cursor-default{
    cursor: default;
  }

  .\\33xl\\:cursor-pointer{
    cursor: pointer;
  }

  .\\33xl\\:cursor-wait{
    cursor: wait;
  }

  .\\33xl\\:cursor-move{
    cursor: move;
  }

  .\\33xl\\:cursor-not-allowed{
    cursor: not-allowed;
  }

  .\\33xl\\:block{
    display: block;
  }

  .\\33xl\\:inline-block{
    display: inline-block;
  }

  .\\33xl\\:inline{
    display: inline;
  }

  .\\33xl\\:flex{
    display: flex;
  }

  .\\33xl\\:inline-flex{
    display: inline-flex;
  }

  .\\33xl\\:table{
    display: table;
  }

  .\\33xl\\:table-caption{
    display: table-caption;
  }

  .\\33xl\\:table-cell{
    display: table-cell;
  }

  .\\33xl\\:table-column{
    display: table-column;
  }

  .\\33xl\\:table-column-group{
    display: table-column-group;
  }

  .\\33xl\\:table-footer-group{
    display: table-footer-group;
  }

  .\\33xl\\:table-header-group{
    display: table-header-group;
  }

  .\\33xl\\:table-row-group{
    display: table-row-group;
  }

  .\\33xl\\:table-row{
    display: table-row;
  }

  .\\33xl\\:flow-root{
    display: flow-root;
  }

  .\\33xl\\:grid{
    display: grid;
  }

  .\\33xl\\:inline-grid{
    display: inline-grid;
  }

  .\\33xl\\:contents{
    display: contents;
  }

  .\\33xl\\:hidden{
    display: none;
  }

  .\\33xl\\:flex-row{
    flex-direction: row;
  }

  .\\33xl\\:flex-row-reverse{
    flex-direction: row-reverse;
  }

  .\\33xl\\:flex-col{
    flex-direction: column;
  }

  .\\33xl\\:flex-col-reverse{
    flex-direction: column-reverse;
  }

  .\\33xl\\:flex-wrap{
    flex-wrap: wrap;
  }

  .\\33xl\\:flex-wrap-reverse{
    flex-wrap: wrap-reverse;
  }

  .\\33xl\\:flex-no-wrap{
    flex-wrap: nowrap;
  }

  .\\33xl\\:place-items-auto{
    align-items: auto;
    justify-items: auto;
    place-items: auto;
  }

  .\\33xl\\:place-items-start{
    align-items: start;
    justify-items: start;
    place-items: start;
  }

  .\\33xl\\:place-items-end{
    align-items: end;
    justify-items: end;
    place-items: end;
  }

  .\\33xl\\:place-items-center{
    align-items: center;
    justify-items: center;
    place-items: center;
  }

  .\\33xl\\:place-items-stretch{
    align-items: stretch;
    justify-items: stretch;
    place-items: stretch;
  }

  .\\33xl\\:place-content-center{
    align-content: center;
    justify-content: center;
    place-content: center;
  }

  .\\33xl\\:place-content-start{
    align-content: start;
    justify-content: start;
    place-content: start;
  }

  .\\33xl\\:place-content-end{
    align-content: end;
    justify-content: end;
    place-content: end;
  }

  .\\33xl\\:place-content-between{
    align-content: space-between;
    justify-content: space-between;
    place-content: space-between;
  }

  .\\33xl\\:place-content-around{
    align-content: space-around;
    justify-content: space-around;
    place-content: space-around;
  }

  .\\33xl\\:place-content-evenly{
    align-content: space-evenly;
    justify-content: space-evenly;
    place-content: space-evenly;
  }

  .\\33xl\\:place-content-stretch{
    align-content: stretch;
    justify-content: stretch;
    place-content: stretch;
  }

  .\\33xl\\:place-self-auto{
    align-self: auto;
    justify-self: auto;
    place-self: auto;
  }

  .\\33xl\\:place-self-start{
    align-self: start;
    justify-self: start;
    place-self: start;
  }

  .\\33xl\\:place-self-end{
    align-self: end;
    justify-self: end;
    place-self: end;
  }

  .\\33xl\\:place-self-center{
    align-self: center;
    justify-self: center;
    place-self: center;
  }

  .\\33xl\\:place-self-stretch{
    align-self: stretch;
    justify-self: stretch;
    place-self: stretch;
  }

  .\\33xl\\:items-start{
    align-items: flex-start;
  }

  .\\33xl\\:items-end{
    align-items: flex-end;
  }

  .\\33xl\\:items-center{
    align-items: center;
  }

  .\\33xl\\:items-baseline{
    align-items: baseline;
  }

  .\\33xl\\:items-stretch{
    align-items: stretch;
  }

  .\\33xl\\:content-center{
    align-content: center;
  }

  .\\33xl\\:content-start{
    align-content: flex-start;
  }

  .\\33xl\\:content-end{
    align-content: flex-end;
  }

  .\\33xl\\:content-between{
    align-content: space-between;
  }

  .\\33xl\\:content-around{
    align-content: space-around;
  }

  .\\33xl\\:content-evenly{
    align-content: space-evenly;
  }

  .\\33xl\\:self-auto{
    align-self: auto;
  }

  .\\33xl\\:self-start{
    align-self: flex-start;
  }

  .\\33xl\\:self-end{
    align-self: flex-end;
  }

  .\\33xl\\:self-center{
    align-self: center;
  }

  .\\33xl\\:self-stretch{
    align-self: stretch;
  }

  .\\33xl\\:justify-items-auto{
    justify-items: auto;
  }

  .\\33xl\\:justify-items-start{
    justify-items: start;
  }

  .\\33xl\\:justify-items-end{
    justify-items: end;
  }

  .\\33xl\\:justify-items-center{
    justify-items: center;
  }

  .\\33xl\\:justify-items-stretch{
    justify-items: stretch;
  }

  .\\33xl\\:justify-start{
    justify-content: flex-start;
  }

  .\\33xl\\:justify-end{
    justify-content: flex-end;
  }

  .\\33xl\\:justify-center{
    justify-content: center;
  }

  .\\33xl\\:justify-between{
    justify-content: space-between;
  }

  .\\33xl\\:justify-around{
    justify-content: space-around;
  }

  .\\33xl\\:justify-evenly{
    justify-content: space-evenly;
  }

  .\\33xl\\:justify-self-auto{
    justify-self: auto;
  }

  .\\33xl\\:justify-self-start{
    justify-self: start;
  }

  .\\33xl\\:justify-self-end{
    justify-self: end;
  }

  .\\33xl\\:justify-self-center{
    justify-self: center;
  }

  .\\33xl\\:justify-self-stretch{
    justify-self: stretch;
  }

  .\\33xl\\:flex-1{
    flex: 1 1 0%;
  }

  .\\33xl\\:flex-auto{
    flex: 1 1 auto;
  }

  .\\33xl\\:flex-initial{
    flex: 0 1 auto;
  }

  .\\33xl\\:flex-none{
    flex: none;
  }

  .\\33xl\\:flex-grow-0{
    flex-grow: 0;
  }

  .\\33xl\\:flex-grow{
    flex-grow: 1;
  }

  .\\33xl\\:flex-shrink-0{
    flex-shrink: 0;
  }

  .\\33xl\\:flex-shrink{
    flex-shrink: 1;
  }

  .\\33xl\\:order-1{
    order: 1;
  }

  .\\33xl\\:order-2{
    order: 2;
  }

  .\\33xl\\:order-3{
    order: 3;
  }

  .\\33xl\\:order-4{
    order: 4;
  }

  .\\33xl\\:order-5{
    order: 5;
  }

  .\\33xl\\:order-6{
    order: 6;
  }

  .\\33xl\\:order-7{
    order: 7;
  }

  .\\33xl\\:order-8{
    order: 8;
  }

  .\\33xl\\:order-9{
    order: 9;
  }

  .\\33xl\\:order-10{
    order: 10;
  }

  .\\33xl\\:order-11{
    order: 11;
  }

  .\\33xl\\:order-12{
    order: 12;
  }

  .\\33xl\\:order-first{
    order: -9999;
  }

  .\\33xl\\:order-last{
    order: 9999;
  }

  .\\33xl\\:order-none{
    order: 0;
  }

  .\\33xl\\:float-right{
    float: right;
  }

  .\\33xl\\:float-left{
    float: left;
  }

  .\\33xl\\:float-none{
    float: none;
  }

  .\\33xl\\:clearfix:after{
    content: "";
    display: table;
    clear: both;
  }

  .\\33xl\\:clear-left{
    clear: left;
  }

  .\\33xl\\:clear-right{
    clear: right;
  }

  .\\33xl\\:clear-both{
    clear: both;
  }

  .\\33xl\\:clear-none{
    clear: none;
  }

  .\\33xl\\:font-sans{
    font-family: Open Sans, -apple-system, BlinkMacSystemFont, "Segoe UI", "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  }

  .\\33xl\\:font-serif{
    font-family: Georgia, Cambria, "Times New Roman", Times, serif;
  }

  .\\33xl\\:font-mono{
    font-family: Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  }

  .\\33xl\\:font-light{
    font-weight: 100;
  }

  .\\33xl\\:font-regular{
    font-weight: 400;
  }

  .\\33xl\\:font-semibold{
    font-weight: 600;
  }

  .\\33xl\\:font-bold{
    font-weight: 700;
  }

  .\\33xl\\:hover\\:font-light:hover{
    font-weight: 100;
  }

  .\\33xl\\:hover\\:font-regular:hover{
    font-weight: 400;
  }

  .\\33xl\\:hover\\:font-semibold:hover{
    font-weight: 600;
  }

  .\\33xl\\:hover\\:font-bold:hover{
    font-weight: 700;
  }

  .\\33xl\\:focus\\:font-light:focus{
    font-weight: 100;
  }

  .\\33xl\\:focus\\:font-regular:focus{
    font-weight: 400;
  }

  .\\33xl\\:focus\\:font-semibold:focus{
    font-weight: 600;
  }

  .\\33xl\\:focus\\:font-bold:focus{
    font-weight: 700;
  }

  .\\33xl\\:h-0{
    height: 0;
  }

  .\\33xl\\:h-1{
    height: 0.25rem;
  }

  .\\33xl\\:h-2{
    height: 0.5rem;
  }

  .\\33xl\\:h-3{
    height: 0.75rem;
  }

  .\\33xl\\:h-4{
    height: 1rem;
  }

  .\\33xl\\:h-5{
    height: 1.25rem;
  }

  .\\33xl\\:h-6{
    height: 1.5rem;
  }

  .\\33xl\\:h-7{
    height: 1.75rem;
  }

  .\\33xl\\:h-8{
    height: 2rem;
  }

  .\\33xl\\:h-9{
    height: 2.25rem;
  }

  .\\33xl\\:h-10{
    height: 2.5rem;
  }

  .\\33xl\\:h-11{
    height: 2.75rem;
  }

  .\\33xl\\:h-12{
    height: 3rem;
  }

  .\\33xl\\:h-14{
    height: 3.5rem;
  }

  .\\33xl\\:h-15{
    height: 3.75rem;
  }

  .\\33xl\\:h-16{
    height: 4rem;
  }

  .\\33xl\\:h-18{
    height: 4.5rem;
  }

  .\\33xl\\:h-20{
    height: 5rem;
  }

  .\\33xl\\:h-22{
    height: 5.5rem;
  }

  .\\33xl\\:h-23{
    height: 5.75rem;
  }

  .\\33xl\\:h-24{
    height: 6rem;
  }

  .\\33xl\\:h-25{
    height: 6.25rem;
  }

  .\\33xl\\:h-26{
    height: 6.5rem;
  }

  .\\33xl\\:h-28{
    height: 7rem;
  }

  .\\33xl\\:h-30{
    height: 7.5rem;
  }

  .\\33xl\\:h-32{
    height: 8rem;
  }

  .\\33xl\\:h-34{
    height: 8.5rem;
  }

  .\\33xl\\:h-40{
    height: 10rem;
  }

  .\\33xl\\:h-42{
    height: 10.5rem;
  }

  .\\33xl\\:h-44{
    height: 11rem;
  }

  .\\33xl\\:h-48{
    height: 12rem;
  }

  .\\33xl\\:h-52{
    height: 13rem;
  }

  .\\33xl\\:h-54{
    height: 13.5rem;
  }

  .\\33xl\\:h-56{
    height: 14rem;
  }

  .\\33xl\\:h-60{
    height: 15rem;
  }

  .\\33xl\\:h-64{
    height: 16rem;
  }

  .\\33xl\\:h-68{
    height: 17rem;
  }

  .\\33xl\\:h-72{
    height: 18rem;
  }

  .\\33xl\\:h-74{
    height: 18.5rem;
  }

  .\\33xl\\:h-76{
    height: 19rem;
  }

  .\\33xl\\:h-78{
    height: 19.5rem;
  }

  .\\33xl\\:h-80{
    height: 20rem;
  }

  .\\33xl\\:h-82{
    height: 20.5rem;
  }

  .\\33xl\\:h-84{
    height: 21rem;
  }

  .\\33xl\\:h-88{
    height: 22rem;
  }

  .\\33xl\\:h-92{
    height: 23rem;
  }

  .\\33xl\\:h-96{
    height: 24rem;
  }

  .\\33xl\\:h-98{
    height: 24.5rem;
  }

  .\\33xl\\:h-100{
    height: 25rem;
  }

  .\\33xl\\:h-104{
    height: 26rem;
  }

  .\\33xl\\:h-112{
    height: 28rem;
  }

  .\\33xl\\:h-124{
    height: 31rem;
  }

  .\\33xl\\:h-128{
    height: 32rem;
  }

  .\\33xl\\:h-140{
    height: 35rem;
  }

  .\\33xl\\:h-152{
    height: 38rem;
  }

  .\\33xl\\:h-160{
    height: 40rem;
  }

  .\\33xl\\:h-162{
    height: 41rem;
  }

  .\\33xl\\:h-192{
    height: 48rem;
  }

  .\\33xl\\:h-208{
    height: 52rem;
  }

  .\\33xl\\:h-224{
    height: 56rem;
  }

  .\\33xl\\:h-256{
    height: 64rem;
  }

  .\\33xl\\:h-auto{
    height: auto;
  }

  .\\33xl\\:h-px{
    height: 1px;
  }

  .\\33xl\\:h-full{
    height: 100%;
  }

  .\\33xl\\:h-screen{
    height: 100vh;
  }

  .\\33xl\\:text-xs{
    font-size: 0.74rem;
  }

  .\\33xl\\:text-sm{
    font-size: 0.86rem;
  }

  .\\33xl\\:text-base{
    font-size: 1rem;
  }

  .\\33xl\\:text-lg{
    font-size: 1.15rem;
  }

  .\\33xl\\:text-xl{
    font-size: 1.42rem;
  }

  .\\33xl\\:text-2xl{
    font-size: 1.85rem;
  }

  .\\33xl\\:text-3xl{
    font-size: 1.95rem;
  }

  .\\33xl\\:text-4xl{
    font-size: 2.25rem;
  }

  .\\33xl\\:text-5xl{
    font-size: 3rem;
  }

  .\\33xl\\:text-6xl{
    font-size: 4rem;
  }

  .\\33xl\\:text-7xl{
    font-size: 5rem;
  }

  .\\33xl\\:leading-none{
    line-height: 1;
  }

  .\\33xl\\:leading-tight{
    line-height: 1.2;
  }

  .\\33xl\\:leading-snug{
    line-height: 1.3;
  }

  .\\33xl\\:leading-normal{
    line-height: 1.4;
  }

  .\\33xl\\:leading-relaxed{
    line-height: 1.6;
  }

  .\\33xl\\:list-inside{
    list-style-position: inside;
  }

  .\\33xl\\:list-outside{
    list-style-position: outside;
  }

  .\\33xl\\:list-none{
    list-style-type: none;
  }

  .\\33xl\\:list-disc{
    list-style-type: disc;
  }

  .\\33xl\\:list-decimal{
    list-style-type: decimal;
  }

  .\\33xl\\:m-0{
    margin: 0;
  }

  .\\33xl\\:m-1{
    margin: 0.25rem;
  }

  .\\33xl\\:m-2{
    margin: 0.5rem;
  }

  .\\33xl\\:m-3{
    margin: 0.75rem;
  }

  .\\33xl\\:m-4{
    margin: 1rem;
  }

  .\\33xl\\:m-5{
    margin: 1.25rem;
  }

  .\\33xl\\:m-6{
    margin: 1.5rem;
  }

  .\\33xl\\:m-7{
    margin: 1.75rem;
  }

  .\\33xl\\:m-8{
    margin: 2rem;
  }

  .\\33xl\\:m-9{
    margin: 2.25rem;
  }

  .\\33xl\\:m-10{
    margin: 2.5rem;
  }

  .\\33xl\\:m-11{
    margin: 2.75rem;
  }

  .\\33xl\\:m-12{
    margin: 3rem;
  }

  .\\33xl\\:m-14{
    margin: 3.5rem;
  }

  .\\33xl\\:m-15{
    margin: 3.75rem;
  }

  .\\33xl\\:m-16{
    margin: 4rem;
  }

  .\\33xl\\:m-18{
    margin: 4.5rem;
  }

  .\\33xl\\:m-20{
    margin: 5rem;
  }

  .\\33xl\\:m-22{
    margin: 5.5rem;
  }

  .\\33xl\\:m-23{
    margin: 5.75rem;
  }

  .\\33xl\\:m-24{
    margin: 6rem;
  }

  .\\33xl\\:m-25{
    margin: 6.25rem;
  }

  .\\33xl\\:m-26{
    margin: 6.5rem;
  }

  .\\33xl\\:m-28{
    margin: 7rem;
  }

  .\\33xl\\:m-30{
    margin: 7.5rem;
  }

  .\\33xl\\:m-32{
    margin: 8rem;
  }

  .\\33xl\\:m-34{
    margin: 8.5rem;
  }

  .\\33xl\\:m-40{
    margin: 10rem;
  }

  .\\33xl\\:m-42{
    margin: 10.5rem;
  }

  .\\33xl\\:m-44{
    margin: 11rem;
  }

  .\\33xl\\:m-48{
    margin: 12rem;
  }

  .\\33xl\\:m-52{
    margin: 13rem;
  }

  .\\33xl\\:m-54{
    margin: 13.5rem;
  }

  .\\33xl\\:m-56{
    margin: 14rem;
  }

  .\\33xl\\:m-60{
    margin: 15rem;
  }

  .\\33xl\\:m-64{
    margin: 16rem;
  }

  .\\33xl\\:m-68{
    margin: 17rem;
  }

  .\\33xl\\:m-72{
    margin: 18rem;
  }

  .\\33xl\\:m-74{
    margin: 18.5rem;
  }

  .\\33xl\\:m-76{
    margin: 19rem;
  }

  .\\33xl\\:m-78{
    margin: 19.5rem;
  }

  .\\33xl\\:m-80{
    margin: 20rem;
  }

  .\\33xl\\:m-82{
    margin: 20.5rem;
  }

  .\\33xl\\:m-84{
    margin: 21rem;
  }

  .\\33xl\\:m-88{
    margin: 22rem;
  }

  .\\33xl\\:m-92{
    margin: 23rem;
  }

  .\\33xl\\:m-96{
    margin: 24rem;
  }

  .\\33xl\\:m-98{
    margin: 24.5rem;
  }

  .\\33xl\\:m-100{
    margin: 25rem;
  }

  .\\33xl\\:m-104{
    margin: 26rem;
  }

  .\\33xl\\:m-112{
    margin: 28rem;
  }

  .\\33xl\\:m-124{
    margin: 31rem;
  }

  .\\33xl\\:m-128{
    margin: 32rem;
  }

  .\\33xl\\:m-140{
    margin: 35rem;
  }

  .\\33xl\\:m-152{
    margin: 38rem;
  }

  .\\33xl\\:m-160{
    margin: 40rem;
  }

  .\\33xl\\:m-162{
    margin: 41rem;
  }

  .\\33xl\\:m-192{
    margin: 48rem;
  }

  .\\33xl\\:m-208{
    margin: 52rem;
  }

  .\\33xl\\:m-224{
    margin: 56rem;
  }

  .\\33xl\\:m-256{
    margin: 64rem;
  }

  .\\33xl\\:m-auto{
    margin: auto;
  }

  .\\33xl\\:m-px{
    margin: 1px;
  }

  .\\33xl\\:-m-1{
    margin: -0.25rem;
  }

  .\\33xl\\:-m-2{
    margin: -0.5rem;
  }

  .\\33xl\\:-m-3{
    margin: -0.75rem;
  }

  .\\33xl\\:-m-4{
    margin: -1rem;
  }

  .\\33xl\\:-m-5{
    margin: -1.25rem;
  }

  .\\33xl\\:-m-6{
    margin: -1.5rem;
  }

  .\\33xl\\:-m-7{
    margin: -1.75rem;
  }

  .\\33xl\\:-m-8{
    margin: -2rem;
  }

  .\\33xl\\:-m-9{
    margin: -2.25rem;
  }

  .\\33xl\\:-m-10{
    margin: -2.5rem;
  }

  .\\33xl\\:-m-11{
    margin: -2.75rem;
  }

  .\\33xl\\:-m-12{
    margin: -3rem;
  }

  .\\33xl\\:-m-14{
    margin: -3.5rem;
  }

  .\\33xl\\:-m-15{
    margin: -3.75rem;
  }

  .\\33xl\\:-m-16{
    margin: -4rem;
  }

  .\\33xl\\:-m-18{
    margin: -4.5rem;
  }

  .\\33xl\\:-m-20{
    margin: -5rem;
  }

  .\\33xl\\:-m-22{
    margin: -5.5rem;
  }

  .\\33xl\\:-m-23{
    margin: -5.75rem;
  }

  .\\33xl\\:-m-24{
    margin: -6rem;
  }

  .\\33xl\\:-m-25{
    margin: -6.25rem;
  }

  .\\33xl\\:-m-26{
    margin: -6.5rem;
  }

  .\\33xl\\:-m-28{
    margin: -7rem;
  }

  .\\33xl\\:-m-30{
    margin: -7.5rem;
  }

  .\\33xl\\:-m-32{
    margin: -8rem;
  }

  .\\33xl\\:-m-34{
    margin: -8.5rem;
  }

  .\\33xl\\:-m-40{
    margin: -10rem;
  }

  .\\33xl\\:-m-42{
    margin: -10.5rem;
  }

  .\\33xl\\:-m-44{
    margin: -11rem;
  }

  .\\33xl\\:-m-48{
    margin: -12rem;
  }

  .\\33xl\\:-m-52{
    margin: -13rem;
  }

  .\\33xl\\:-m-54{
    margin: -13.5rem;
  }

  .\\33xl\\:-m-56{
    margin: -14rem;
  }

  .\\33xl\\:-m-60{
    margin: -15rem;
  }

  .\\33xl\\:-m-64{
    margin: -16rem;
  }

  .\\33xl\\:-m-68{
    margin: -17rem;
  }

  .\\33xl\\:-m-72{
    margin: -18rem;
  }

  .\\33xl\\:-m-74{
    margin: -18.5rem;
  }

  .\\33xl\\:-m-76{
    margin: -19rem;
  }

  .\\33xl\\:-m-78{
    margin: -19.5rem;
  }

  .\\33xl\\:-m-80{
    margin: -20rem;
  }

  .\\33xl\\:-m-82{
    margin: -20.5rem;
  }

  .\\33xl\\:-m-84{
    margin: -21rem;
  }

  .\\33xl\\:-m-88{
    margin: -22rem;
  }

  .\\33xl\\:-m-92{
    margin: -23rem;
  }

  .\\33xl\\:-m-96{
    margin: -24rem;
  }

  .\\33xl\\:-m-98{
    margin: -24.5rem;
  }

  .\\33xl\\:-m-100{
    margin: -25rem;
  }

  .\\33xl\\:-m-104{
    margin: -26rem;
  }

  .\\33xl\\:-m-112{
    margin: -28rem;
  }

  .\\33xl\\:-m-124{
    margin: -31rem;
  }

  .\\33xl\\:-m-128{
    margin: -32rem;
  }

  .\\33xl\\:-m-140{
    margin: -35rem;
  }

  .\\33xl\\:-m-152{
    margin: -38rem;
  }

  .\\33xl\\:-m-160{
    margin: -40rem;
  }

  .\\33xl\\:-m-162{
    margin: -41rem;
  }

  .\\33xl\\:-m-192{
    margin: -48rem;
  }

  .\\33xl\\:-m-208{
    margin: -52rem;
  }

  .\\33xl\\:-m-224{
    margin: -56rem;
  }

  .\\33xl\\:-m-256{
    margin: -64rem;
  }

  .\\33xl\\:-m-px{
    margin: -1px;
  }

  .\\33xl\\:my-0{
    margin-top: 0;
    margin-bottom: 0;
  }

  .\\33xl\\:mx-0{
    margin-left: 0;
    margin-right: 0;
  }

  .\\33xl\\:my-1{
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .\\33xl\\:mx-1{
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .\\33xl\\:my-2{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .\\33xl\\:mx-2{
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .\\33xl\\:my-3{
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .\\33xl\\:mx-3{
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .\\33xl\\:my-4{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .\\33xl\\:mx-4{
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .\\33xl\\:my-5{
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .\\33xl\\:mx-5{
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .\\33xl\\:my-6{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .\\33xl\\:mx-6{
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .\\33xl\\:my-7{
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }

  .\\33xl\\:mx-7{
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }

  .\\33xl\\:my-8{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .\\33xl\\:mx-8{
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .\\33xl\\:my-9{
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }

  .\\33xl\\:mx-9{
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }

  .\\33xl\\:my-10{
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .\\33xl\\:mx-10{
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .\\33xl\\:my-11{
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;
  }

  .\\33xl\\:mx-11{
    margin-left: 2.75rem;
    margin-right: 2.75rem;
  }

  .\\33xl\\:my-12{
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .\\33xl\\:mx-12{
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .\\33xl\\:my-14{
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
  }

  .\\33xl\\:mx-14{
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }

  .\\33xl\\:my-15{
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
  }

  .\\33xl\\:mx-15{
    margin-left: 3.75rem;
    margin-right: 3.75rem;
  }

  .\\33xl\\:my-16{
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .\\33xl\\:mx-16{
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .\\33xl\\:my-18{
    margin-top: 4.5rem;
    margin-bottom: 4.5rem;
  }

  .\\33xl\\:mx-18{
    margin-left: 4.5rem;
    margin-right: 4.5rem;
  }

  .\\33xl\\:my-20{
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .\\33xl\\:mx-20{
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .\\33xl\\:my-22{
    margin-top: 5.5rem;
    margin-bottom: 5.5rem;
  }

  .\\33xl\\:mx-22{
    margin-left: 5.5rem;
    margin-right: 5.5rem;
  }

  .\\33xl\\:my-23{
    margin-top: 5.75rem;
    margin-bottom: 5.75rem;
  }

  .\\33xl\\:mx-23{
    margin-left: 5.75rem;
    margin-right: 5.75rem;
  }

  .\\33xl\\:my-24{
    margin-top: 6rem;
    margin-bottom: 6rem;
  }

  .\\33xl\\:mx-24{
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .\\33xl\\:my-25{
    margin-top: 6.25rem;
    margin-bottom: 6.25rem;
  }

  .\\33xl\\:mx-25{
    margin-left: 6.25rem;
    margin-right: 6.25rem;
  }

  .\\33xl\\:my-26{
    margin-top: 6.5rem;
    margin-bottom: 6.5rem;
  }

  .\\33xl\\:mx-26{
    margin-left: 6.5rem;
    margin-right: 6.5rem;
  }

  .\\33xl\\:my-28{
    margin-top: 7rem;
    margin-bottom: 7rem;
  }

  .\\33xl\\:mx-28{
    margin-left: 7rem;
    margin-right: 7rem;
  }

  .\\33xl\\:my-30{
    margin-top: 7.5rem;
    margin-bottom: 7.5rem;
  }

  .\\33xl\\:mx-30{
    margin-left: 7.5rem;
    margin-right: 7.5rem;
  }

  .\\33xl\\:my-32{
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  .\\33xl\\:mx-32{
    margin-left: 8rem;
    margin-right: 8rem;
  }

  .\\33xl\\:my-34{
    margin-top: 8.5rem;
    margin-bottom: 8.5rem;
  }

  .\\33xl\\:mx-34{
    margin-left: 8.5rem;
    margin-right: 8.5rem;
  }

  .\\33xl\\:my-40{
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .\\33xl\\:mx-40{
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .\\33xl\\:my-42{
    margin-top: 10.5rem;
    margin-bottom: 10.5rem;
  }

  .\\33xl\\:mx-42{
    margin-left: 10.5rem;
    margin-right: 10.5rem;
  }

  .\\33xl\\:my-44{
    margin-top: 11rem;
    margin-bottom: 11rem;
  }

  .\\33xl\\:mx-44{
    margin-left: 11rem;
    margin-right: 11rem;
  }

  .\\33xl\\:my-48{
    margin-top: 12rem;
    margin-bottom: 12rem;
  }

  .\\33xl\\:mx-48{
    margin-left: 12rem;
    margin-right: 12rem;
  }

  .\\33xl\\:my-52{
    margin-top: 13rem;
    margin-bottom: 13rem;
  }

  .\\33xl\\:mx-52{
    margin-left: 13rem;
    margin-right: 13rem;
  }

  .\\33xl\\:my-54{
    margin-top: 13.5rem;
    margin-bottom: 13.5rem;
  }

  .\\33xl\\:mx-54{
    margin-left: 13.5rem;
    margin-right: 13.5rem;
  }

  .\\33xl\\:my-56{
    margin-top: 14rem;
    margin-bottom: 14rem;
  }

  .\\33xl\\:mx-56{
    margin-left: 14rem;
    margin-right: 14rem;
  }

  .\\33xl\\:my-60{
    margin-top: 15rem;
    margin-bottom: 15rem;
  }

  .\\33xl\\:mx-60{
    margin-left: 15rem;
    margin-right: 15rem;
  }

  .\\33xl\\:my-64{
    margin-top: 16rem;
    margin-bottom: 16rem;
  }

  .\\33xl\\:mx-64{
    margin-left: 16rem;
    margin-right: 16rem;
  }

  .\\33xl\\:my-68{
    margin-top: 17rem;
    margin-bottom: 17rem;
  }

  .\\33xl\\:mx-68{
    margin-left: 17rem;
    margin-right: 17rem;
  }

  .\\33xl\\:my-72{
    margin-top: 18rem;
    margin-bottom: 18rem;
  }

  .\\33xl\\:mx-72{
    margin-left: 18rem;
    margin-right: 18rem;
  }

  .\\33xl\\:my-74{
    margin-top: 18.5rem;
    margin-bottom: 18.5rem;
  }

  .\\33xl\\:mx-74{
    margin-left: 18.5rem;
    margin-right: 18.5rem;
  }

  .\\33xl\\:my-76{
    margin-top: 19rem;
    margin-bottom: 19rem;
  }

  .\\33xl\\:mx-76{
    margin-left: 19rem;
    margin-right: 19rem;
  }

  .\\33xl\\:my-78{
    margin-top: 19.5rem;
    margin-bottom: 19.5rem;
  }

  .\\33xl\\:mx-78{
    margin-left: 19.5rem;
    margin-right: 19.5rem;
  }

  .\\33xl\\:my-80{
    margin-top: 20rem;
    margin-bottom: 20rem;
  }

  .\\33xl\\:mx-80{
    margin-left: 20rem;
    margin-right: 20rem;
  }

  .\\33xl\\:my-82{
    margin-top: 20.5rem;
    margin-bottom: 20.5rem;
  }

  .\\33xl\\:mx-82{
    margin-left: 20.5rem;
    margin-right: 20.5rem;
  }

  .\\33xl\\:my-84{
    margin-top: 21rem;
    margin-bottom: 21rem;
  }

  .\\33xl\\:mx-84{
    margin-left: 21rem;
    margin-right: 21rem;
  }

  .\\33xl\\:my-88{
    margin-top: 22rem;
    margin-bottom: 22rem;
  }

  .\\33xl\\:mx-88{
    margin-left: 22rem;
    margin-right: 22rem;
  }

  .\\33xl\\:my-92{
    margin-top: 23rem;
    margin-bottom: 23rem;
  }

  .\\33xl\\:mx-92{
    margin-left: 23rem;
    margin-right: 23rem;
  }

  .\\33xl\\:my-96{
    margin-top: 24rem;
    margin-bottom: 24rem;
  }

  .\\33xl\\:mx-96{
    margin-left: 24rem;
    margin-right: 24rem;
  }

  .\\33xl\\:my-98{
    margin-top: 24.5rem;
    margin-bottom: 24.5rem;
  }

  .\\33xl\\:mx-98{
    margin-left: 24.5rem;
    margin-right: 24.5rem;
  }

  .\\33xl\\:my-100{
    margin-top: 25rem;
    margin-bottom: 25rem;
  }

  .\\33xl\\:mx-100{
    margin-left: 25rem;
    margin-right: 25rem;
  }

  .\\33xl\\:my-104{
    margin-top: 26rem;
    margin-bottom: 26rem;
  }

  .\\33xl\\:mx-104{
    margin-left: 26rem;
    margin-right: 26rem;
  }

  .\\33xl\\:my-112{
    margin-top: 28rem;
    margin-bottom: 28rem;
  }

  .\\33xl\\:mx-112{
    margin-left: 28rem;
    margin-right: 28rem;
  }

  .\\33xl\\:my-124{
    margin-top: 31rem;
    margin-bottom: 31rem;
  }

  .\\33xl\\:mx-124{
    margin-left: 31rem;
    margin-right: 31rem;
  }

  .\\33xl\\:my-128{
    margin-top: 32rem;
    margin-bottom: 32rem;
  }

  .\\33xl\\:mx-128{
    margin-left: 32rem;
    margin-right: 32rem;
  }

  .\\33xl\\:my-140{
    margin-top: 35rem;
    margin-bottom: 35rem;
  }

  .\\33xl\\:mx-140{
    margin-left: 35rem;
    margin-right: 35rem;
  }

  .\\33xl\\:my-152{
    margin-top: 38rem;
    margin-bottom: 38rem;
  }

  .\\33xl\\:mx-152{
    margin-left: 38rem;
    margin-right: 38rem;
  }

  .\\33xl\\:my-160{
    margin-top: 40rem;
    margin-bottom: 40rem;
  }

  .\\33xl\\:mx-160{
    margin-left: 40rem;
    margin-right: 40rem;
  }

  .\\33xl\\:my-162{
    margin-top: 41rem;
    margin-bottom: 41rem;
  }

  .\\33xl\\:mx-162{
    margin-left: 41rem;
    margin-right: 41rem;
  }

  .\\33xl\\:my-192{
    margin-top: 48rem;
    margin-bottom: 48rem;
  }

  .\\33xl\\:mx-192{
    margin-left: 48rem;
    margin-right: 48rem;
  }

  .\\33xl\\:my-208{
    margin-top: 52rem;
    margin-bottom: 52rem;
  }

  .\\33xl\\:mx-208{
    margin-left: 52rem;
    margin-right: 52rem;
  }

  .\\33xl\\:my-224{
    margin-top: 56rem;
    margin-bottom: 56rem;
  }

  .\\33xl\\:mx-224{
    margin-left: 56rem;
    margin-right: 56rem;
  }

  .\\33xl\\:my-256{
    margin-top: 64rem;
    margin-bottom: 64rem;
  }

  .\\33xl\\:mx-256{
    margin-left: 64rem;
    margin-right: 64rem;
  }

  .\\33xl\\:my-auto{
    margin-top: auto;
    margin-bottom: auto;
  }

  .\\33xl\\:mx-auto{
    margin-left: auto;
    margin-right: auto;
  }

  .\\33xl\\:my-px{
    margin-top: 1px;
    margin-bottom: 1px;
  }

  .\\33xl\\:mx-px{
    margin-left: 1px;
    margin-right: 1px;
  }

  .\\33xl\\:-my-1{
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .\\33xl\\:-mx-1{
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .\\33xl\\:-my-2{
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }

  .\\33xl\\:-mx-2{
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .\\33xl\\:-my-3{
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }

  .\\33xl\\:-mx-3{
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .\\33xl\\:-my-4{
    margin-top: -1rem;
    margin-bottom: -1rem;
  }

  .\\33xl\\:-mx-4{
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .\\33xl\\:-my-5{
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }

  .\\33xl\\:-mx-5{
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .\\33xl\\:-my-6{
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }

  .\\33xl\\:-mx-6{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .\\33xl\\:-my-7{
    margin-top: -1.75rem;
    margin-bottom: -1.75rem;
  }

  .\\33xl\\:-mx-7{
    margin-left: -1.75rem;
    margin-right: -1.75rem;
  }

  .\\33xl\\:-my-8{
    margin-top: -2rem;
    margin-bottom: -2rem;
  }

  .\\33xl\\:-mx-8{
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .\\33xl\\:-my-9{
    margin-top: -2.25rem;
    margin-bottom: -2.25rem;
  }

  .\\33xl\\:-mx-9{
    margin-left: -2.25rem;
    margin-right: -2.25rem;
  }

  .\\33xl\\:-my-10{
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }

  .\\33xl\\:-mx-10{
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .\\33xl\\:-my-11{
    margin-top: -2.75rem;
    margin-bottom: -2.75rem;
  }

  .\\33xl\\:-mx-11{
    margin-left: -2.75rem;
    margin-right: -2.75rem;
  }

  .\\33xl\\:-my-12{
    margin-top: -3rem;
    margin-bottom: -3rem;
  }

  .\\33xl\\:-mx-12{
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .\\33xl\\:-my-14{
    margin-top: -3.5rem;
    margin-bottom: -3.5rem;
  }

  .\\33xl\\:-mx-14{
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }

  .\\33xl\\:-my-15{
    margin-top: -3.75rem;
    margin-bottom: -3.75rem;
  }

  .\\33xl\\:-mx-15{
    margin-left: -3.75rem;
    margin-right: -3.75rem;
  }

  .\\33xl\\:-my-16{
    margin-top: -4rem;
    margin-bottom: -4rem;
  }

  .\\33xl\\:-mx-16{
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .\\33xl\\:-my-18{
    margin-top: -4.5rem;
    margin-bottom: -4.5rem;
  }

  .\\33xl\\:-mx-18{
    margin-left: -4.5rem;
    margin-right: -4.5rem;
  }

  .\\33xl\\:-my-20{
    margin-top: -5rem;
    margin-bottom: -5rem;
  }

  .\\33xl\\:-mx-20{
    margin-left: -5rem;
    margin-right: -5rem;
  }

  .\\33xl\\:-my-22{
    margin-top: -5.5rem;
    margin-bottom: -5.5rem;
  }

  .\\33xl\\:-mx-22{
    margin-left: -5.5rem;
    margin-right: -5.5rem;
  }

  .\\33xl\\:-my-23{
    margin-top: -5.75rem;
    margin-bottom: -5.75rem;
  }

  .\\33xl\\:-mx-23{
    margin-left: -5.75rem;
    margin-right: -5.75rem;
  }

  .\\33xl\\:-my-24{
    margin-top: -6rem;
    margin-bottom: -6rem;
  }

  .\\33xl\\:-mx-24{
    margin-left: -6rem;
    margin-right: -6rem;
  }

  .\\33xl\\:-my-25{
    margin-top: -6.25rem;
    margin-bottom: -6.25rem;
  }

  .\\33xl\\:-mx-25{
    margin-left: -6.25rem;
    margin-right: -6.25rem;
  }

  .\\33xl\\:-my-26{
    margin-top: -6.5rem;
    margin-bottom: -6.5rem;
  }

  .\\33xl\\:-mx-26{
    margin-left: -6.5rem;
    margin-right: -6.5rem;
  }

  .\\33xl\\:-my-28{
    margin-top: -7rem;
    margin-bottom: -7rem;
  }

  .\\33xl\\:-mx-28{
    margin-left: -7rem;
    margin-right: -7rem;
  }

  .\\33xl\\:-my-30{
    margin-top: -7.5rem;
    margin-bottom: -7.5rem;
  }

  .\\33xl\\:-mx-30{
    margin-left: -7.5rem;
    margin-right: -7.5rem;
  }

  .\\33xl\\:-my-32{
    margin-top: -8rem;
    margin-bottom: -8rem;
  }

  .\\33xl\\:-mx-32{
    margin-left: -8rem;
    margin-right: -8rem;
  }

  .\\33xl\\:-my-34{
    margin-top: -8.5rem;
    margin-bottom: -8.5rem;
  }

  .\\33xl\\:-mx-34{
    margin-left: -8.5rem;
    margin-right: -8.5rem;
  }

  .\\33xl\\:-my-40{
    margin-top: -10rem;
    margin-bottom: -10rem;
  }

  .\\33xl\\:-mx-40{
    margin-left: -10rem;
    margin-right: -10rem;
  }

  .\\33xl\\:-my-42{
    margin-top: -10.5rem;
    margin-bottom: -10.5rem;
  }

  .\\33xl\\:-mx-42{
    margin-left: -10.5rem;
    margin-right: -10.5rem;
  }

  .\\33xl\\:-my-44{
    margin-top: -11rem;
    margin-bottom: -11rem;
  }

  .\\33xl\\:-mx-44{
    margin-left: -11rem;
    margin-right: -11rem;
  }

  .\\33xl\\:-my-48{
    margin-top: -12rem;
    margin-bottom: -12rem;
  }

  .\\33xl\\:-mx-48{
    margin-left: -12rem;
    margin-right: -12rem;
  }

  .\\33xl\\:-my-52{
    margin-top: -13rem;
    margin-bottom: -13rem;
  }

  .\\33xl\\:-mx-52{
    margin-left: -13rem;
    margin-right: -13rem;
  }

  .\\33xl\\:-my-54{
    margin-top: -13.5rem;
    margin-bottom: -13.5rem;
  }

  .\\33xl\\:-mx-54{
    margin-left: -13.5rem;
    margin-right: -13.5rem;
  }

  .\\33xl\\:-my-56{
    margin-top: -14rem;
    margin-bottom: -14rem;
  }

  .\\33xl\\:-mx-56{
    margin-left: -14rem;
    margin-right: -14rem;
  }

  .\\33xl\\:-my-60{
    margin-top: -15rem;
    margin-bottom: -15rem;
  }

  .\\33xl\\:-mx-60{
    margin-left: -15rem;
    margin-right: -15rem;
  }

  .\\33xl\\:-my-64{
    margin-top: -16rem;
    margin-bottom: -16rem;
  }

  .\\33xl\\:-mx-64{
    margin-left: -16rem;
    margin-right: -16rem;
  }

  .\\33xl\\:-my-68{
    margin-top: -17rem;
    margin-bottom: -17rem;
  }

  .\\33xl\\:-mx-68{
    margin-left: -17rem;
    margin-right: -17rem;
  }

  .\\33xl\\:-my-72{
    margin-top: -18rem;
    margin-bottom: -18rem;
  }

  .\\33xl\\:-mx-72{
    margin-left: -18rem;
    margin-right: -18rem;
  }

  .\\33xl\\:-my-74{
    margin-top: -18.5rem;
    margin-bottom: -18.5rem;
  }

  .\\33xl\\:-mx-74{
    margin-left: -18.5rem;
    margin-right: -18.5rem;
  }

  .\\33xl\\:-my-76{
    margin-top: -19rem;
    margin-bottom: -19rem;
  }

  .\\33xl\\:-mx-76{
    margin-left: -19rem;
    margin-right: -19rem;
  }

  .\\33xl\\:-my-78{
    margin-top: -19.5rem;
    margin-bottom: -19.5rem;
  }

  .\\33xl\\:-mx-78{
    margin-left: -19.5rem;
    margin-right: -19.5rem;
  }

  .\\33xl\\:-my-80{
    margin-top: -20rem;
    margin-bottom: -20rem;
  }

  .\\33xl\\:-mx-80{
    margin-left: -20rem;
    margin-right: -20rem;
  }

  .\\33xl\\:-my-82{
    margin-top: -20.5rem;
    margin-bottom: -20.5rem;
  }

  .\\33xl\\:-mx-82{
    margin-left: -20.5rem;
    margin-right: -20.5rem;
  }

  .\\33xl\\:-my-84{
    margin-top: -21rem;
    margin-bottom: -21rem;
  }

  .\\33xl\\:-mx-84{
    margin-left: -21rem;
    margin-right: -21rem;
  }

  .\\33xl\\:-my-88{
    margin-top: -22rem;
    margin-bottom: -22rem;
  }

  .\\33xl\\:-mx-88{
    margin-left: -22rem;
    margin-right: -22rem;
  }

  .\\33xl\\:-my-92{
    margin-top: -23rem;
    margin-bottom: -23rem;
  }

  .\\33xl\\:-mx-92{
    margin-left: -23rem;
    margin-right: -23rem;
  }

  .\\33xl\\:-my-96{
    margin-top: -24rem;
    margin-bottom: -24rem;
  }

  .\\33xl\\:-mx-96{
    margin-left: -24rem;
    margin-right: -24rem;
  }

  .\\33xl\\:-my-98{
    margin-top: -24.5rem;
    margin-bottom: -24.5rem;
  }

  .\\33xl\\:-mx-98{
    margin-left: -24.5rem;
    margin-right: -24.5rem;
  }

  .\\33xl\\:-my-100{
    margin-top: -25rem;
    margin-bottom: -25rem;
  }

  .\\33xl\\:-mx-100{
    margin-left: -25rem;
    margin-right: -25rem;
  }

  .\\33xl\\:-my-104{
    margin-top: -26rem;
    margin-bottom: -26rem;
  }

  .\\33xl\\:-mx-104{
    margin-left: -26rem;
    margin-right: -26rem;
  }

  .\\33xl\\:-my-112{
    margin-top: -28rem;
    margin-bottom: -28rem;
  }

  .\\33xl\\:-mx-112{
    margin-left: -28rem;
    margin-right: -28rem;
  }

  .\\33xl\\:-my-124{
    margin-top: -31rem;
    margin-bottom: -31rem;
  }

  .\\33xl\\:-mx-124{
    margin-left: -31rem;
    margin-right: -31rem;
  }

  .\\33xl\\:-my-128{
    margin-top: -32rem;
    margin-bottom: -32rem;
  }

  .\\33xl\\:-mx-128{
    margin-left: -32rem;
    margin-right: -32rem;
  }

  .\\33xl\\:-my-140{
    margin-top: -35rem;
    margin-bottom: -35rem;
  }

  .\\33xl\\:-mx-140{
    margin-left: -35rem;
    margin-right: -35rem;
  }

  .\\33xl\\:-my-152{
    margin-top: -38rem;
    margin-bottom: -38rem;
  }

  .\\33xl\\:-mx-152{
    margin-left: -38rem;
    margin-right: -38rem;
  }

  .\\33xl\\:-my-160{
    margin-top: -40rem;
    margin-bottom: -40rem;
  }

  .\\33xl\\:-mx-160{
    margin-left: -40rem;
    margin-right: -40rem;
  }

  .\\33xl\\:-my-162{
    margin-top: -41rem;
    margin-bottom: -41rem;
  }

  .\\33xl\\:-mx-162{
    margin-left: -41rem;
    margin-right: -41rem;
  }

  .\\33xl\\:-my-192{
    margin-top: -48rem;
    margin-bottom: -48rem;
  }

  .\\33xl\\:-mx-192{
    margin-left: -48rem;
    margin-right: -48rem;
  }

  .\\33xl\\:-my-208{
    margin-top: -52rem;
    margin-bottom: -52rem;
  }

  .\\33xl\\:-mx-208{
    margin-left: -52rem;
    margin-right: -52rem;
  }

  .\\33xl\\:-my-224{
    margin-top: -56rem;
    margin-bottom: -56rem;
  }

  .\\33xl\\:-mx-224{
    margin-left: -56rem;
    margin-right: -56rem;
  }

  .\\33xl\\:-my-256{
    margin-top: -64rem;
    margin-bottom: -64rem;
  }

  .\\33xl\\:-mx-256{
    margin-left: -64rem;
    margin-right: -64rem;
  }

  .\\33xl\\:-my-px{
    margin-top: -1px;
    margin-bottom: -1px;
  }

  .\\33xl\\:-mx-px{
    margin-left: -1px;
    margin-right: -1px;
  }

  .\\33xl\\:mt-0{
    margin-top: 0;
  }

  .\\33xl\\:mr-0{
    margin-right: 0;
  }

  .\\33xl\\:mb-0{
    margin-bottom: 0;
  }

  .\\33xl\\:ml-0{
    margin-left: 0;
  }

  .\\33xl\\:mt-1{
    margin-top: 0.25rem;
  }

  .\\33xl\\:mr-1{
    margin-right: 0.25rem;
  }

  .\\33xl\\:mb-1{
    margin-bottom: 0.25rem;
  }

  .\\33xl\\:ml-1{
    margin-left: 0.25rem;
  }

  .\\33xl\\:mt-2{
    margin-top: 0.5rem;
  }

  .\\33xl\\:mr-2{
    margin-right: 0.5rem;
  }

  .\\33xl\\:mb-2{
    margin-bottom: 0.5rem;
  }

  .\\33xl\\:ml-2{
    margin-left: 0.5rem;
  }

  .\\33xl\\:mt-3{
    margin-top: 0.75rem;
  }

  .\\33xl\\:mr-3{
    margin-right: 0.75rem;
  }

  .\\33xl\\:mb-3{
    margin-bottom: 0.75rem;
  }

  .\\33xl\\:ml-3{
    margin-left: 0.75rem;
  }

  .\\33xl\\:mt-4{
    margin-top: 1rem;
  }

  .\\33xl\\:mr-4{
    margin-right: 1rem;
  }

  .\\33xl\\:mb-4{
    margin-bottom: 1rem;
  }

  .\\33xl\\:ml-4{
    margin-left: 1rem;
  }

  .\\33xl\\:mt-5{
    margin-top: 1.25rem;
  }

  .\\33xl\\:mr-5{
    margin-right: 1.25rem;
  }

  .\\33xl\\:mb-5{
    margin-bottom: 1.25rem;
  }

  .\\33xl\\:ml-5{
    margin-left: 1.25rem;
  }

  .\\33xl\\:mt-6{
    margin-top: 1.5rem;
  }

  .\\33xl\\:mr-6{
    margin-right: 1.5rem;
  }

  .\\33xl\\:mb-6{
    margin-bottom: 1.5rem;
  }

  .\\33xl\\:ml-6{
    margin-left: 1.5rem;
  }

  .\\33xl\\:mt-7{
    margin-top: 1.75rem;
  }

  .\\33xl\\:mr-7{
    margin-right: 1.75rem;
  }

  .\\33xl\\:mb-7{
    margin-bottom: 1.75rem;
  }

  .\\33xl\\:ml-7{
    margin-left: 1.75rem;
  }

  .\\33xl\\:mt-8{
    margin-top: 2rem;
  }

  .\\33xl\\:mr-8{
    margin-right: 2rem;
  }

  .\\33xl\\:mb-8{
    margin-bottom: 2rem;
  }

  .\\33xl\\:ml-8{
    margin-left: 2rem;
  }

  .\\33xl\\:mt-9{
    margin-top: 2.25rem;
  }

  .\\33xl\\:mr-9{
    margin-right: 2.25rem;
  }

  .\\33xl\\:mb-9{
    margin-bottom: 2.25rem;
  }

  .\\33xl\\:ml-9{
    margin-left: 2.25rem;
  }

  .\\33xl\\:mt-10{
    margin-top: 2.5rem;
  }

  .\\33xl\\:mr-10{
    margin-right: 2.5rem;
  }

  .\\33xl\\:mb-10{
    margin-bottom: 2.5rem;
  }

  .\\33xl\\:ml-10{
    margin-left: 2.5rem;
  }

  .\\33xl\\:mt-11{
    margin-top: 2.75rem;
  }

  .\\33xl\\:mr-11{
    margin-right: 2.75rem;
  }

  .\\33xl\\:mb-11{
    margin-bottom: 2.75rem;
  }

  .\\33xl\\:ml-11{
    margin-left: 2.75rem;
  }

  .\\33xl\\:mt-12{
    margin-top: 3rem;
  }

  .\\33xl\\:mr-12{
    margin-right: 3rem;
  }

  .\\33xl\\:mb-12{
    margin-bottom: 3rem;
  }

  .\\33xl\\:ml-12{
    margin-left: 3rem;
  }

  .\\33xl\\:mt-14{
    margin-top: 3.5rem;
  }

  .\\33xl\\:mr-14{
    margin-right: 3.5rem;
  }

  .\\33xl\\:mb-14{
    margin-bottom: 3.5rem;
  }

  .\\33xl\\:ml-14{
    margin-left: 3.5rem;
  }

  .\\33xl\\:mt-15{
    margin-top: 3.75rem;
  }

  .\\33xl\\:mr-15{
    margin-right: 3.75rem;
  }

  .\\33xl\\:mb-15{
    margin-bottom: 3.75rem;
  }

  .\\33xl\\:ml-15{
    margin-left: 3.75rem;
  }

  .\\33xl\\:mt-16{
    margin-top: 4rem;
  }

  .\\33xl\\:mr-16{
    margin-right: 4rem;
  }

  .\\33xl\\:mb-16{
    margin-bottom: 4rem;
  }

  .\\33xl\\:ml-16{
    margin-left: 4rem;
  }

  .\\33xl\\:mt-18{
    margin-top: 4.5rem;
  }

  .\\33xl\\:mr-18{
    margin-right: 4.5rem;
  }

  .\\33xl\\:mb-18{
    margin-bottom: 4.5rem;
  }

  .\\33xl\\:ml-18{
    margin-left: 4.5rem;
  }

  .\\33xl\\:mt-20{
    margin-top: 5rem;
  }

  .\\33xl\\:mr-20{
    margin-right: 5rem;
  }

  .\\33xl\\:mb-20{
    margin-bottom: 5rem;
  }

  .\\33xl\\:ml-20{
    margin-left: 5rem;
  }

  .\\33xl\\:mt-22{
    margin-top: 5.5rem;
  }

  .\\33xl\\:mr-22{
    margin-right: 5.5rem;
  }

  .\\33xl\\:mb-22{
    margin-bottom: 5.5rem;
  }

  .\\33xl\\:ml-22{
    margin-left: 5.5rem;
  }

  .\\33xl\\:mt-23{
    margin-top: 5.75rem;
  }

  .\\33xl\\:mr-23{
    margin-right: 5.75rem;
  }

  .\\33xl\\:mb-23{
    margin-bottom: 5.75rem;
  }

  .\\33xl\\:ml-23{
    margin-left: 5.75rem;
  }

  .\\33xl\\:mt-24{
    margin-top: 6rem;
  }

  .\\33xl\\:mr-24{
    margin-right: 6rem;
  }

  .\\33xl\\:mb-24{
    margin-bottom: 6rem;
  }

  .\\33xl\\:ml-24{
    margin-left: 6rem;
  }

  .\\33xl\\:mt-25{
    margin-top: 6.25rem;
  }

  .\\33xl\\:mr-25{
    margin-right: 6.25rem;
  }

  .\\33xl\\:mb-25{
    margin-bottom: 6.25rem;
  }

  .\\33xl\\:ml-25{
    margin-left: 6.25rem;
  }

  .\\33xl\\:mt-26{
    margin-top: 6.5rem;
  }

  .\\33xl\\:mr-26{
    margin-right: 6.5rem;
  }

  .\\33xl\\:mb-26{
    margin-bottom: 6.5rem;
  }

  .\\33xl\\:ml-26{
    margin-left: 6.5rem;
  }

  .\\33xl\\:mt-28{
    margin-top: 7rem;
  }

  .\\33xl\\:mr-28{
    margin-right: 7rem;
  }

  .\\33xl\\:mb-28{
    margin-bottom: 7rem;
  }

  .\\33xl\\:ml-28{
    margin-left: 7rem;
  }

  .\\33xl\\:mt-30{
    margin-top: 7.5rem;
  }

  .\\33xl\\:mr-30{
    margin-right: 7.5rem;
  }

  .\\33xl\\:mb-30{
    margin-bottom: 7.5rem;
  }

  .\\33xl\\:ml-30{
    margin-left: 7.5rem;
  }

  .\\33xl\\:mt-32{
    margin-top: 8rem;
  }

  .\\33xl\\:mr-32{
    margin-right: 8rem;
  }

  .\\33xl\\:mb-32{
    margin-bottom: 8rem;
  }

  .\\33xl\\:ml-32{
    margin-left: 8rem;
  }

  .\\33xl\\:mt-34{
    margin-top: 8.5rem;
  }

  .\\33xl\\:mr-34{
    margin-right: 8.5rem;
  }

  .\\33xl\\:mb-34{
    margin-bottom: 8.5rem;
  }

  .\\33xl\\:ml-34{
    margin-left: 8.5rem;
  }

  .\\33xl\\:mt-40{
    margin-top: 10rem;
  }

  .\\33xl\\:mr-40{
    margin-right: 10rem;
  }

  .\\33xl\\:mb-40{
    margin-bottom: 10rem;
  }

  .\\33xl\\:ml-40{
    margin-left: 10rem;
  }

  .\\33xl\\:mt-42{
    margin-top: 10.5rem;
  }

  .\\33xl\\:mr-42{
    margin-right: 10.5rem;
  }

  .\\33xl\\:mb-42{
    margin-bottom: 10.5rem;
  }

  .\\33xl\\:ml-42{
    margin-left: 10.5rem;
  }

  .\\33xl\\:mt-44{
    margin-top: 11rem;
  }

  .\\33xl\\:mr-44{
    margin-right: 11rem;
  }

  .\\33xl\\:mb-44{
    margin-bottom: 11rem;
  }

  .\\33xl\\:ml-44{
    margin-left: 11rem;
  }

  .\\33xl\\:mt-48{
    margin-top: 12rem;
  }

  .\\33xl\\:mr-48{
    margin-right: 12rem;
  }

  .\\33xl\\:mb-48{
    margin-bottom: 12rem;
  }

  .\\33xl\\:ml-48{
    margin-left: 12rem;
  }

  .\\33xl\\:mt-52{
    margin-top: 13rem;
  }

  .\\33xl\\:mr-52{
    margin-right: 13rem;
  }

  .\\33xl\\:mb-52{
    margin-bottom: 13rem;
  }

  .\\33xl\\:ml-52{
    margin-left: 13rem;
  }

  .\\33xl\\:mt-54{
    margin-top: 13.5rem;
  }

  .\\33xl\\:mr-54{
    margin-right: 13.5rem;
  }

  .\\33xl\\:mb-54{
    margin-bottom: 13.5rem;
  }

  .\\33xl\\:ml-54{
    margin-left: 13.5rem;
  }

  .\\33xl\\:mt-56{
    margin-top: 14rem;
  }

  .\\33xl\\:mr-56{
    margin-right: 14rem;
  }

  .\\33xl\\:mb-56{
    margin-bottom: 14rem;
  }

  .\\33xl\\:ml-56{
    margin-left: 14rem;
  }

  .\\33xl\\:mt-60{
    margin-top: 15rem;
  }

  .\\33xl\\:mr-60{
    margin-right: 15rem;
  }

  .\\33xl\\:mb-60{
    margin-bottom: 15rem;
  }

  .\\33xl\\:ml-60{
    margin-left: 15rem;
  }

  .\\33xl\\:mt-64{
    margin-top: 16rem;
  }

  .\\33xl\\:mr-64{
    margin-right: 16rem;
  }

  .\\33xl\\:mb-64{
    margin-bottom: 16rem;
  }

  .\\33xl\\:ml-64{
    margin-left: 16rem;
  }

  .\\33xl\\:mt-68{
    margin-top: 17rem;
  }

  .\\33xl\\:mr-68{
    margin-right: 17rem;
  }

  .\\33xl\\:mb-68{
    margin-bottom: 17rem;
  }

  .\\33xl\\:ml-68{
    margin-left: 17rem;
  }

  .\\33xl\\:mt-72{
    margin-top: 18rem;
  }

  .\\33xl\\:mr-72{
    margin-right: 18rem;
  }

  .\\33xl\\:mb-72{
    margin-bottom: 18rem;
  }

  .\\33xl\\:ml-72{
    margin-left: 18rem;
  }

  .\\33xl\\:mt-74{
    margin-top: 18.5rem;
  }

  .\\33xl\\:mr-74{
    margin-right: 18.5rem;
  }

  .\\33xl\\:mb-74{
    margin-bottom: 18.5rem;
  }

  .\\33xl\\:ml-74{
    margin-left: 18.5rem;
  }

  .\\33xl\\:mt-76{
    margin-top: 19rem;
  }

  .\\33xl\\:mr-76{
    margin-right: 19rem;
  }

  .\\33xl\\:mb-76{
    margin-bottom: 19rem;
  }

  .\\33xl\\:ml-76{
    margin-left: 19rem;
  }

  .\\33xl\\:mt-78{
    margin-top: 19.5rem;
  }

  .\\33xl\\:mr-78{
    margin-right: 19.5rem;
  }

  .\\33xl\\:mb-78{
    margin-bottom: 19.5rem;
  }

  .\\33xl\\:ml-78{
    margin-left: 19.5rem;
  }

  .\\33xl\\:mt-80{
    margin-top: 20rem;
  }

  .\\33xl\\:mr-80{
    margin-right: 20rem;
  }

  .\\33xl\\:mb-80{
    margin-bottom: 20rem;
  }

  .\\33xl\\:ml-80{
    margin-left: 20rem;
  }

  .\\33xl\\:mt-82{
    margin-top: 20.5rem;
  }

  .\\33xl\\:mr-82{
    margin-right: 20.5rem;
  }

  .\\33xl\\:mb-82{
    margin-bottom: 20.5rem;
  }

  .\\33xl\\:ml-82{
    margin-left: 20.5rem;
  }

  .\\33xl\\:mt-84{
    margin-top: 21rem;
  }

  .\\33xl\\:mr-84{
    margin-right: 21rem;
  }

  .\\33xl\\:mb-84{
    margin-bottom: 21rem;
  }

  .\\33xl\\:ml-84{
    margin-left: 21rem;
  }

  .\\33xl\\:mt-88{
    margin-top: 22rem;
  }

  .\\33xl\\:mr-88{
    margin-right: 22rem;
  }

  .\\33xl\\:mb-88{
    margin-bottom: 22rem;
  }

  .\\33xl\\:ml-88{
    margin-left: 22rem;
  }

  .\\33xl\\:mt-92{
    margin-top: 23rem;
  }

  .\\33xl\\:mr-92{
    margin-right: 23rem;
  }

  .\\33xl\\:mb-92{
    margin-bottom: 23rem;
  }

  .\\33xl\\:ml-92{
    margin-left: 23rem;
  }

  .\\33xl\\:mt-96{
    margin-top: 24rem;
  }

  .\\33xl\\:mr-96{
    margin-right: 24rem;
  }

  .\\33xl\\:mb-96{
    margin-bottom: 24rem;
  }

  .\\33xl\\:ml-96{
    margin-left: 24rem;
  }

  .\\33xl\\:mt-98{
    margin-top: 24.5rem;
  }

  .\\33xl\\:mr-98{
    margin-right: 24.5rem;
  }

  .\\33xl\\:mb-98{
    margin-bottom: 24.5rem;
  }

  .\\33xl\\:ml-98{
    margin-left: 24.5rem;
  }

  .\\33xl\\:mt-100{
    margin-top: 25rem;
  }

  .\\33xl\\:mr-100{
    margin-right: 25rem;
  }

  .\\33xl\\:mb-100{
    margin-bottom: 25rem;
  }

  .\\33xl\\:ml-100{
    margin-left: 25rem;
  }

  .\\33xl\\:mt-104{
    margin-top: 26rem;
  }

  .\\33xl\\:mr-104{
    margin-right: 26rem;
  }

  .\\33xl\\:mb-104{
    margin-bottom: 26rem;
  }

  .\\33xl\\:ml-104{
    margin-left: 26rem;
  }

  .\\33xl\\:mt-112{
    margin-top: 28rem;
  }

  .\\33xl\\:mr-112{
    margin-right: 28rem;
  }

  .\\33xl\\:mb-112{
    margin-bottom: 28rem;
  }

  .\\33xl\\:ml-112{
    margin-left: 28rem;
  }

  .\\33xl\\:mt-124{
    margin-top: 31rem;
  }

  .\\33xl\\:mr-124{
    margin-right: 31rem;
  }

  .\\33xl\\:mb-124{
    margin-bottom: 31rem;
  }

  .\\33xl\\:ml-124{
    margin-left: 31rem;
  }

  .\\33xl\\:mt-128{
    margin-top: 32rem;
  }

  .\\33xl\\:mr-128{
    margin-right: 32rem;
  }

  .\\33xl\\:mb-128{
    margin-bottom: 32rem;
  }

  .\\33xl\\:ml-128{
    margin-left: 32rem;
  }

  .\\33xl\\:mt-140{
    margin-top: 35rem;
  }

  .\\33xl\\:mr-140{
    margin-right: 35rem;
  }

  .\\33xl\\:mb-140{
    margin-bottom: 35rem;
  }

  .\\33xl\\:ml-140{
    margin-left: 35rem;
  }

  .\\33xl\\:mt-152{
    margin-top: 38rem;
  }

  .\\33xl\\:mr-152{
    margin-right: 38rem;
  }

  .\\33xl\\:mb-152{
    margin-bottom: 38rem;
  }

  .\\33xl\\:ml-152{
    margin-left: 38rem;
  }

  .\\33xl\\:mt-160{
    margin-top: 40rem;
  }

  .\\33xl\\:mr-160{
    margin-right: 40rem;
  }

  .\\33xl\\:mb-160{
    margin-bottom: 40rem;
  }

  .\\33xl\\:ml-160{
    margin-left: 40rem;
  }

  .\\33xl\\:mt-162{
    margin-top: 41rem;
  }

  .\\33xl\\:mr-162{
    margin-right: 41rem;
  }

  .\\33xl\\:mb-162{
    margin-bottom: 41rem;
  }

  .\\33xl\\:ml-162{
    margin-left: 41rem;
  }

  .\\33xl\\:mt-192{
    margin-top: 48rem;
  }

  .\\33xl\\:mr-192{
    margin-right: 48rem;
  }

  .\\33xl\\:mb-192{
    margin-bottom: 48rem;
  }

  .\\33xl\\:ml-192{
    margin-left: 48rem;
  }

  .\\33xl\\:mt-208{
    margin-top: 52rem;
  }

  .\\33xl\\:mr-208{
    margin-right: 52rem;
  }

  .\\33xl\\:mb-208{
    margin-bottom: 52rem;
  }

  .\\33xl\\:ml-208{
    margin-left: 52rem;
  }

  .\\33xl\\:mt-224{
    margin-top: 56rem;
  }

  .\\33xl\\:mr-224{
    margin-right: 56rem;
  }

  .\\33xl\\:mb-224{
    margin-bottom: 56rem;
  }

  .\\33xl\\:ml-224{
    margin-left: 56rem;
  }

  .\\33xl\\:mt-256{
    margin-top: 64rem;
  }

  .\\33xl\\:mr-256{
    margin-right: 64rem;
  }

  .\\33xl\\:mb-256{
    margin-bottom: 64rem;
  }

  .\\33xl\\:ml-256{
    margin-left: 64rem;
  }

  .\\33xl\\:mt-auto{
    margin-top: auto;
  }

  .\\33xl\\:mr-auto{
    margin-right: auto;
  }

  .\\33xl\\:mb-auto{
    margin-bottom: auto;
  }

  .\\33xl\\:ml-auto{
    margin-left: auto;
  }

  .\\33xl\\:mt-px{
    margin-top: 1px;
  }

  .\\33xl\\:mr-px{
    margin-right: 1px;
  }

  .\\33xl\\:mb-px{
    margin-bottom: 1px;
  }

  .\\33xl\\:ml-px{
    margin-left: 1px;
  }

  .\\33xl\\:-mt-1{
    margin-top: -0.25rem;
  }

  .\\33xl\\:-mr-1{
    margin-right: -0.25rem;
  }

  .\\33xl\\:-mb-1{
    margin-bottom: -0.25rem;
  }

  .\\33xl\\:-ml-1{
    margin-left: -0.25rem;
  }

  .\\33xl\\:-mt-2{
    margin-top: -0.5rem;
  }

  .\\33xl\\:-mr-2{
    margin-right: -0.5rem;
  }

  .\\33xl\\:-mb-2{
    margin-bottom: -0.5rem;
  }

  .\\33xl\\:-ml-2{
    margin-left: -0.5rem;
  }

  .\\33xl\\:-mt-3{
    margin-top: -0.75rem;
  }

  .\\33xl\\:-mr-3{
    margin-right: -0.75rem;
  }

  .\\33xl\\:-mb-3{
    margin-bottom: -0.75rem;
  }

  .\\33xl\\:-ml-3{
    margin-left: -0.75rem;
  }

  .\\33xl\\:-mt-4{
    margin-top: -1rem;
  }

  .\\33xl\\:-mr-4{
    margin-right: -1rem;
  }

  .\\33xl\\:-mb-4{
    margin-bottom: -1rem;
  }

  .\\33xl\\:-ml-4{
    margin-left: -1rem;
  }

  .\\33xl\\:-mt-5{
    margin-top: -1.25rem;
  }

  .\\33xl\\:-mr-5{
    margin-right: -1.25rem;
  }

  .\\33xl\\:-mb-5{
    margin-bottom: -1.25rem;
  }

  .\\33xl\\:-ml-5{
    margin-left: -1.25rem;
  }

  .\\33xl\\:-mt-6{
    margin-top: -1.5rem;
  }

  .\\33xl\\:-mr-6{
    margin-right: -1.5rem;
  }

  .\\33xl\\:-mb-6{
    margin-bottom: -1.5rem;
  }

  .\\33xl\\:-ml-6{
    margin-left: -1.5rem;
  }

  .\\33xl\\:-mt-7{
    margin-top: -1.75rem;
  }

  .\\33xl\\:-mr-7{
    margin-right: -1.75rem;
  }

  .\\33xl\\:-mb-7{
    margin-bottom: -1.75rem;
  }

  .\\33xl\\:-ml-7{
    margin-left: -1.75rem;
  }

  .\\33xl\\:-mt-8{
    margin-top: -2rem;
  }

  .\\33xl\\:-mr-8{
    margin-right: -2rem;
  }

  .\\33xl\\:-mb-8{
    margin-bottom: -2rem;
  }

  .\\33xl\\:-ml-8{
    margin-left: -2rem;
  }

  .\\33xl\\:-mt-9{
    margin-top: -2.25rem;
  }

  .\\33xl\\:-mr-9{
    margin-right: -2.25rem;
  }

  .\\33xl\\:-mb-9{
    margin-bottom: -2.25rem;
  }

  .\\33xl\\:-ml-9{
    margin-left: -2.25rem;
  }

  .\\33xl\\:-mt-10{
    margin-top: -2.5rem;
  }

  .\\33xl\\:-mr-10{
    margin-right: -2.5rem;
  }

  .\\33xl\\:-mb-10{
    margin-bottom: -2.5rem;
  }

  .\\33xl\\:-ml-10{
    margin-left: -2.5rem;
  }

  .\\33xl\\:-mt-11{
    margin-top: -2.75rem;
  }

  .\\33xl\\:-mr-11{
    margin-right: -2.75rem;
  }

  .\\33xl\\:-mb-11{
    margin-bottom: -2.75rem;
  }

  .\\33xl\\:-ml-11{
    margin-left: -2.75rem;
  }

  .\\33xl\\:-mt-12{
    margin-top: -3rem;
  }

  .\\33xl\\:-mr-12{
    margin-right: -3rem;
  }

  .\\33xl\\:-mb-12{
    margin-bottom: -3rem;
  }

  .\\33xl\\:-ml-12{
    margin-left: -3rem;
  }

  .\\33xl\\:-mt-14{
    margin-top: -3.5rem;
  }

  .\\33xl\\:-mr-14{
    margin-right: -3.5rem;
  }

  .\\33xl\\:-mb-14{
    margin-bottom: -3.5rem;
  }

  .\\33xl\\:-ml-14{
    margin-left: -3.5rem;
  }

  .\\33xl\\:-mt-15{
    margin-top: -3.75rem;
  }

  .\\33xl\\:-mr-15{
    margin-right: -3.75rem;
  }

  .\\33xl\\:-mb-15{
    margin-bottom: -3.75rem;
  }

  .\\33xl\\:-ml-15{
    margin-left: -3.75rem;
  }

  .\\33xl\\:-mt-16{
    margin-top: -4rem;
  }

  .\\33xl\\:-mr-16{
    margin-right: -4rem;
  }

  .\\33xl\\:-mb-16{
    margin-bottom: -4rem;
  }

  .\\33xl\\:-ml-16{
    margin-left: -4rem;
  }

  .\\33xl\\:-mt-18{
    margin-top: -4.5rem;
  }

  .\\33xl\\:-mr-18{
    margin-right: -4.5rem;
  }

  .\\33xl\\:-mb-18{
    margin-bottom: -4.5rem;
  }

  .\\33xl\\:-ml-18{
    margin-left: -4.5rem;
  }

  .\\33xl\\:-mt-20{
    margin-top: -5rem;
  }

  .\\33xl\\:-mr-20{
    margin-right: -5rem;
  }

  .\\33xl\\:-mb-20{
    margin-bottom: -5rem;
  }

  .\\33xl\\:-ml-20{
    margin-left: -5rem;
  }

  .\\33xl\\:-mt-22{
    margin-top: -5.5rem;
  }

  .\\33xl\\:-mr-22{
    margin-right: -5.5rem;
  }

  .\\33xl\\:-mb-22{
    margin-bottom: -5.5rem;
  }

  .\\33xl\\:-ml-22{
    margin-left: -5.5rem;
  }

  .\\33xl\\:-mt-23{
    margin-top: -5.75rem;
  }

  .\\33xl\\:-mr-23{
    margin-right: -5.75rem;
  }

  .\\33xl\\:-mb-23{
    margin-bottom: -5.75rem;
  }

  .\\33xl\\:-ml-23{
    margin-left: -5.75rem;
  }

  .\\33xl\\:-mt-24{
    margin-top: -6rem;
  }

  .\\33xl\\:-mr-24{
    margin-right: -6rem;
  }

  .\\33xl\\:-mb-24{
    margin-bottom: -6rem;
  }

  .\\33xl\\:-ml-24{
    margin-left: -6rem;
  }

  .\\33xl\\:-mt-25{
    margin-top: -6.25rem;
  }

  .\\33xl\\:-mr-25{
    margin-right: -6.25rem;
  }

  .\\33xl\\:-mb-25{
    margin-bottom: -6.25rem;
  }

  .\\33xl\\:-ml-25{
    margin-left: -6.25rem;
  }

  .\\33xl\\:-mt-26{
    margin-top: -6.5rem;
  }

  .\\33xl\\:-mr-26{
    margin-right: -6.5rem;
  }

  .\\33xl\\:-mb-26{
    margin-bottom: -6.5rem;
  }

  .\\33xl\\:-ml-26{
    margin-left: -6.5rem;
  }

  .\\33xl\\:-mt-28{
    margin-top: -7rem;
  }

  .\\33xl\\:-mr-28{
    margin-right: -7rem;
  }

  .\\33xl\\:-mb-28{
    margin-bottom: -7rem;
  }

  .\\33xl\\:-ml-28{
    margin-left: -7rem;
  }

  .\\33xl\\:-mt-30{
    margin-top: -7.5rem;
  }

  .\\33xl\\:-mr-30{
    margin-right: -7.5rem;
  }

  .\\33xl\\:-mb-30{
    margin-bottom: -7.5rem;
  }

  .\\33xl\\:-ml-30{
    margin-left: -7.5rem;
  }

  .\\33xl\\:-mt-32{
    margin-top: -8rem;
  }

  .\\33xl\\:-mr-32{
    margin-right: -8rem;
  }

  .\\33xl\\:-mb-32{
    margin-bottom: -8rem;
  }

  .\\33xl\\:-ml-32{
    margin-left: -8rem;
  }

  .\\33xl\\:-mt-34{
    margin-top: -8.5rem;
  }

  .\\33xl\\:-mr-34{
    margin-right: -8.5rem;
  }

  .\\33xl\\:-mb-34{
    margin-bottom: -8.5rem;
  }

  .\\33xl\\:-ml-34{
    margin-left: -8.5rem;
  }

  .\\33xl\\:-mt-40{
    margin-top: -10rem;
  }

  .\\33xl\\:-mr-40{
    margin-right: -10rem;
  }

  .\\33xl\\:-mb-40{
    margin-bottom: -10rem;
  }

  .\\33xl\\:-ml-40{
    margin-left: -10rem;
  }

  .\\33xl\\:-mt-42{
    margin-top: -10.5rem;
  }

  .\\33xl\\:-mr-42{
    margin-right: -10.5rem;
  }

  .\\33xl\\:-mb-42{
    margin-bottom: -10.5rem;
  }

  .\\33xl\\:-ml-42{
    margin-left: -10.5rem;
  }

  .\\33xl\\:-mt-44{
    margin-top: -11rem;
  }

  .\\33xl\\:-mr-44{
    margin-right: -11rem;
  }

  .\\33xl\\:-mb-44{
    margin-bottom: -11rem;
  }

  .\\33xl\\:-ml-44{
    margin-left: -11rem;
  }

  .\\33xl\\:-mt-48{
    margin-top: -12rem;
  }

  .\\33xl\\:-mr-48{
    margin-right: -12rem;
  }

  .\\33xl\\:-mb-48{
    margin-bottom: -12rem;
  }

  .\\33xl\\:-ml-48{
    margin-left: -12rem;
  }

  .\\33xl\\:-mt-52{
    margin-top: -13rem;
  }

  .\\33xl\\:-mr-52{
    margin-right: -13rem;
  }

  .\\33xl\\:-mb-52{
    margin-bottom: -13rem;
  }

  .\\33xl\\:-ml-52{
    margin-left: -13rem;
  }

  .\\33xl\\:-mt-54{
    margin-top: -13.5rem;
  }

  .\\33xl\\:-mr-54{
    margin-right: -13.5rem;
  }

  .\\33xl\\:-mb-54{
    margin-bottom: -13.5rem;
  }

  .\\33xl\\:-ml-54{
    margin-left: -13.5rem;
  }

  .\\33xl\\:-mt-56{
    margin-top: -14rem;
  }

  .\\33xl\\:-mr-56{
    margin-right: -14rem;
  }

  .\\33xl\\:-mb-56{
    margin-bottom: -14rem;
  }

  .\\33xl\\:-ml-56{
    margin-left: -14rem;
  }

  .\\33xl\\:-mt-60{
    margin-top: -15rem;
  }

  .\\33xl\\:-mr-60{
    margin-right: -15rem;
  }

  .\\33xl\\:-mb-60{
    margin-bottom: -15rem;
  }

  .\\33xl\\:-ml-60{
    margin-left: -15rem;
  }

  .\\33xl\\:-mt-64{
    margin-top: -16rem;
  }

  .\\33xl\\:-mr-64{
    margin-right: -16rem;
  }

  .\\33xl\\:-mb-64{
    margin-bottom: -16rem;
  }

  .\\33xl\\:-ml-64{
    margin-left: -16rem;
  }

  .\\33xl\\:-mt-68{
    margin-top: -17rem;
  }

  .\\33xl\\:-mr-68{
    margin-right: -17rem;
  }

  .\\33xl\\:-mb-68{
    margin-bottom: -17rem;
  }

  .\\33xl\\:-ml-68{
    margin-left: -17rem;
  }

  .\\33xl\\:-mt-72{
    margin-top: -18rem;
  }

  .\\33xl\\:-mr-72{
    margin-right: -18rem;
  }

  .\\33xl\\:-mb-72{
    margin-bottom: -18rem;
  }

  .\\33xl\\:-ml-72{
    margin-left: -18rem;
  }

  .\\33xl\\:-mt-74{
    margin-top: -18.5rem;
  }

  .\\33xl\\:-mr-74{
    margin-right: -18.5rem;
  }

  .\\33xl\\:-mb-74{
    margin-bottom: -18.5rem;
  }

  .\\33xl\\:-ml-74{
    margin-left: -18.5rem;
  }

  .\\33xl\\:-mt-76{
    margin-top: -19rem;
  }

  .\\33xl\\:-mr-76{
    margin-right: -19rem;
  }

  .\\33xl\\:-mb-76{
    margin-bottom: -19rem;
  }

  .\\33xl\\:-ml-76{
    margin-left: -19rem;
  }

  .\\33xl\\:-mt-78{
    margin-top: -19.5rem;
  }

  .\\33xl\\:-mr-78{
    margin-right: -19.5rem;
  }

  .\\33xl\\:-mb-78{
    margin-bottom: -19.5rem;
  }

  .\\33xl\\:-ml-78{
    margin-left: -19.5rem;
  }

  .\\33xl\\:-mt-80{
    margin-top: -20rem;
  }

  .\\33xl\\:-mr-80{
    margin-right: -20rem;
  }

  .\\33xl\\:-mb-80{
    margin-bottom: -20rem;
  }

  .\\33xl\\:-ml-80{
    margin-left: -20rem;
  }

  .\\33xl\\:-mt-82{
    margin-top: -20.5rem;
  }

  .\\33xl\\:-mr-82{
    margin-right: -20.5rem;
  }

  .\\33xl\\:-mb-82{
    margin-bottom: -20.5rem;
  }

  .\\33xl\\:-ml-82{
    margin-left: -20.5rem;
  }

  .\\33xl\\:-mt-84{
    margin-top: -21rem;
  }

  .\\33xl\\:-mr-84{
    margin-right: -21rem;
  }

  .\\33xl\\:-mb-84{
    margin-bottom: -21rem;
  }

  .\\33xl\\:-ml-84{
    margin-left: -21rem;
  }

  .\\33xl\\:-mt-88{
    margin-top: -22rem;
  }

  .\\33xl\\:-mr-88{
    margin-right: -22rem;
  }

  .\\33xl\\:-mb-88{
    margin-bottom: -22rem;
  }

  .\\33xl\\:-ml-88{
    margin-left: -22rem;
  }

  .\\33xl\\:-mt-92{
    margin-top: -23rem;
  }

  .\\33xl\\:-mr-92{
    margin-right: -23rem;
  }

  .\\33xl\\:-mb-92{
    margin-bottom: -23rem;
  }

  .\\33xl\\:-ml-92{
    margin-left: -23rem;
  }

  .\\33xl\\:-mt-96{
    margin-top: -24rem;
  }

  .\\33xl\\:-mr-96{
    margin-right: -24rem;
  }

  .\\33xl\\:-mb-96{
    margin-bottom: -24rem;
  }

  .\\33xl\\:-ml-96{
    margin-left: -24rem;
  }

  .\\33xl\\:-mt-98{
    margin-top: -24.5rem;
  }

  .\\33xl\\:-mr-98{
    margin-right: -24.5rem;
  }

  .\\33xl\\:-mb-98{
    margin-bottom: -24.5rem;
  }

  .\\33xl\\:-ml-98{
    margin-left: -24.5rem;
  }

  .\\33xl\\:-mt-100{
    margin-top: -25rem;
  }

  .\\33xl\\:-mr-100{
    margin-right: -25rem;
  }

  .\\33xl\\:-mb-100{
    margin-bottom: -25rem;
  }

  .\\33xl\\:-ml-100{
    margin-left: -25rem;
  }

  .\\33xl\\:-mt-104{
    margin-top: -26rem;
  }

  .\\33xl\\:-mr-104{
    margin-right: -26rem;
  }

  .\\33xl\\:-mb-104{
    margin-bottom: -26rem;
  }

  .\\33xl\\:-ml-104{
    margin-left: -26rem;
  }

  .\\33xl\\:-mt-112{
    margin-top: -28rem;
  }

  .\\33xl\\:-mr-112{
    margin-right: -28rem;
  }

  .\\33xl\\:-mb-112{
    margin-bottom: -28rem;
  }

  .\\33xl\\:-ml-112{
    margin-left: -28rem;
  }

  .\\33xl\\:-mt-124{
    margin-top: -31rem;
  }

  .\\33xl\\:-mr-124{
    margin-right: -31rem;
  }

  .\\33xl\\:-mb-124{
    margin-bottom: -31rem;
  }

  .\\33xl\\:-ml-124{
    margin-left: -31rem;
  }

  .\\33xl\\:-mt-128{
    margin-top: -32rem;
  }

  .\\33xl\\:-mr-128{
    margin-right: -32rem;
  }

  .\\33xl\\:-mb-128{
    margin-bottom: -32rem;
  }

  .\\33xl\\:-ml-128{
    margin-left: -32rem;
  }

  .\\33xl\\:-mt-140{
    margin-top: -35rem;
  }

  .\\33xl\\:-mr-140{
    margin-right: -35rem;
  }

  .\\33xl\\:-mb-140{
    margin-bottom: -35rem;
  }

  .\\33xl\\:-ml-140{
    margin-left: -35rem;
  }

  .\\33xl\\:-mt-152{
    margin-top: -38rem;
  }

  .\\33xl\\:-mr-152{
    margin-right: -38rem;
  }

  .\\33xl\\:-mb-152{
    margin-bottom: -38rem;
  }

  .\\33xl\\:-ml-152{
    margin-left: -38rem;
  }

  .\\33xl\\:-mt-160{
    margin-top: -40rem;
  }

  .\\33xl\\:-mr-160{
    margin-right: -40rem;
  }

  .\\33xl\\:-mb-160{
    margin-bottom: -40rem;
  }

  .\\33xl\\:-ml-160{
    margin-left: -40rem;
  }

  .\\33xl\\:-mt-162{
    margin-top: -41rem;
  }

  .\\33xl\\:-mr-162{
    margin-right: -41rem;
  }

  .\\33xl\\:-mb-162{
    margin-bottom: -41rem;
  }

  .\\33xl\\:-ml-162{
    margin-left: -41rem;
  }

  .\\33xl\\:-mt-192{
    margin-top: -48rem;
  }

  .\\33xl\\:-mr-192{
    margin-right: -48rem;
  }

  .\\33xl\\:-mb-192{
    margin-bottom: -48rem;
  }

  .\\33xl\\:-ml-192{
    margin-left: -48rem;
  }

  .\\33xl\\:-mt-208{
    margin-top: -52rem;
  }

  .\\33xl\\:-mr-208{
    margin-right: -52rem;
  }

  .\\33xl\\:-mb-208{
    margin-bottom: -52rem;
  }

  .\\33xl\\:-ml-208{
    margin-left: -52rem;
  }

  .\\33xl\\:-mt-224{
    margin-top: -56rem;
  }

  .\\33xl\\:-mr-224{
    margin-right: -56rem;
  }

  .\\33xl\\:-mb-224{
    margin-bottom: -56rem;
  }

  .\\33xl\\:-ml-224{
    margin-left: -56rem;
  }

  .\\33xl\\:-mt-256{
    margin-top: -64rem;
  }

  .\\33xl\\:-mr-256{
    margin-right: -64rem;
  }

  .\\33xl\\:-mb-256{
    margin-bottom: -64rem;
  }

  .\\33xl\\:-ml-256{
    margin-left: -64rem;
  }

  .\\33xl\\:-mt-px{
    margin-top: -1px;
  }

  .\\33xl\\:-mr-px{
    margin-right: -1px;
  }

  .\\33xl\\:-mb-px{
    margin-bottom: -1px;
  }

  .\\33xl\\:-ml-px{
    margin-left: -1px;
  }

  .\\33xl\\:first\\:m-0:first-child{
    margin: 0;
  }

  .\\33xl\\:first\\:m-1:first-child{
    margin: 0.25rem;
  }

  .\\33xl\\:first\\:m-2:first-child{
    margin: 0.5rem;
  }

  .\\33xl\\:first\\:m-3:first-child{
    margin: 0.75rem;
  }

  .\\33xl\\:first\\:m-4:first-child{
    margin: 1rem;
  }

  .\\33xl\\:first\\:m-5:first-child{
    margin: 1.25rem;
  }

  .\\33xl\\:first\\:m-6:first-child{
    margin: 1.5rem;
  }

  .\\33xl\\:first\\:m-7:first-child{
    margin: 1.75rem;
  }

  .\\33xl\\:first\\:m-8:first-child{
    margin: 2rem;
  }

  .\\33xl\\:first\\:m-9:first-child{
    margin: 2.25rem;
  }

  .\\33xl\\:first\\:m-10:first-child{
    margin: 2.5rem;
  }

  .\\33xl\\:first\\:m-11:first-child{
    margin: 2.75rem;
  }

  .\\33xl\\:first\\:m-12:first-child{
    margin: 3rem;
  }

  .\\33xl\\:first\\:m-14:first-child{
    margin: 3.5rem;
  }

  .\\33xl\\:first\\:m-15:first-child{
    margin: 3.75rem;
  }

  .\\33xl\\:first\\:m-16:first-child{
    margin: 4rem;
  }

  .\\33xl\\:first\\:m-18:first-child{
    margin: 4.5rem;
  }

  .\\33xl\\:first\\:m-20:first-child{
    margin: 5rem;
  }

  .\\33xl\\:first\\:m-22:first-child{
    margin: 5.5rem;
  }

  .\\33xl\\:first\\:m-23:first-child{
    margin: 5.75rem;
  }

  .\\33xl\\:first\\:m-24:first-child{
    margin: 6rem;
  }

  .\\33xl\\:first\\:m-25:first-child{
    margin: 6.25rem;
  }

  .\\33xl\\:first\\:m-26:first-child{
    margin: 6.5rem;
  }

  .\\33xl\\:first\\:m-28:first-child{
    margin: 7rem;
  }

  .\\33xl\\:first\\:m-30:first-child{
    margin: 7.5rem;
  }

  .\\33xl\\:first\\:m-32:first-child{
    margin: 8rem;
  }

  .\\33xl\\:first\\:m-34:first-child{
    margin: 8.5rem;
  }

  .\\33xl\\:first\\:m-40:first-child{
    margin: 10rem;
  }

  .\\33xl\\:first\\:m-42:first-child{
    margin: 10.5rem;
  }

  .\\33xl\\:first\\:m-44:first-child{
    margin: 11rem;
  }

  .\\33xl\\:first\\:m-48:first-child{
    margin: 12rem;
  }

  .\\33xl\\:first\\:m-52:first-child{
    margin: 13rem;
  }

  .\\33xl\\:first\\:m-54:first-child{
    margin: 13.5rem;
  }

  .\\33xl\\:first\\:m-56:first-child{
    margin: 14rem;
  }

  .\\33xl\\:first\\:m-60:first-child{
    margin: 15rem;
  }

  .\\33xl\\:first\\:m-64:first-child{
    margin: 16rem;
  }

  .\\33xl\\:first\\:m-68:first-child{
    margin: 17rem;
  }

  .\\33xl\\:first\\:m-72:first-child{
    margin: 18rem;
  }

  .\\33xl\\:first\\:m-74:first-child{
    margin: 18.5rem;
  }

  .\\33xl\\:first\\:m-76:first-child{
    margin: 19rem;
  }

  .\\33xl\\:first\\:m-78:first-child{
    margin: 19.5rem;
  }

  .\\33xl\\:first\\:m-80:first-child{
    margin: 20rem;
  }

  .\\33xl\\:first\\:m-82:first-child{
    margin: 20.5rem;
  }

  .\\33xl\\:first\\:m-84:first-child{
    margin: 21rem;
  }

  .\\33xl\\:first\\:m-88:first-child{
    margin: 22rem;
  }

  .\\33xl\\:first\\:m-92:first-child{
    margin: 23rem;
  }

  .\\33xl\\:first\\:m-96:first-child{
    margin: 24rem;
  }

  .\\33xl\\:first\\:m-98:first-child{
    margin: 24.5rem;
  }

  .\\33xl\\:first\\:m-100:first-child{
    margin: 25rem;
  }

  .\\33xl\\:first\\:m-104:first-child{
    margin: 26rem;
  }

  .\\33xl\\:first\\:m-112:first-child{
    margin: 28rem;
  }

  .\\33xl\\:first\\:m-124:first-child{
    margin: 31rem;
  }

  .\\33xl\\:first\\:m-128:first-child{
    margin: 32rem;
  }

  .\\33xl\\:first\\:m-140:first-child{
    margin: 35rem;
  }

  .\\33xl\\:first\\:m-152:first-child{
    margin: 38rem;
  }

  .\\33xl\\:first\\:m-160:first-child{
    margin: 40rem;
  }

  .\\33xl\\:first\\:m-162:first-child{
    margin: 41rem;
  }

  .\\33xl\\:first\\:m-192:first-child{
    margin: 48rem;
  }

  .\\33xl\\:first\\:m-208:first-child{
    margin: 52rem;
  }

  .\\33xl\\:first\\:m-224:first-child{
    margin: 56rem;
  }

  .\\33xl\\:first\\:m-256:first-child{
    margin: 64rem;
  }

  .\\33xl\\:first\\:m-auto:first-child{
    margin: auto;
  }

  .\\33xl\\:first\\:m-px:first-child{
    margin: 1px;
  }

  .\\33xl\\:first\\:-m-1:first-child{
    margin: -0.25rem;
  }

  .\\33xl\\:first\\:-m-2:first-child{
    margin: -0.5rem;
  }

  .\\33xl\\:first\\:-m-3:first-child{
    margin: -0.75rem;
  }

  .\\33xl\\:first\\:-m-4:first-child{
    margin: -1rem;
  }

  .\\33xl\\:first\\:-m-5:first-child{
    margin: -1.25rem;
  }

  .\\33xl\\:first\\:-m-6:first-child{
    margin: -1.5rem;
  }

  .\\33xl\\:first\\:-m-7:first-child{
    margin: -1.75rem;
  }

  .\\33xl\\:first\\:-m-8:first-child{
    margin: -2rem;
  }

  .\\33xl\\:first\\:-m-9:first-child{
    margin: -2.25rem;
  }

  .\\33xl\\:first\\:-m-10:first-child{
    margin: -2.5rem;
  }

  .\\33xl\\:first\\:-m-11:first-child{
    margin: -2.75rem;
  }

  .\\33xl\\:first\\:-m-12:first-child{
    margin: -3rem;
  }

  .\\33xl\\:first\\:-m-14:first-child{
    margin: -3.5rem;
  }

  .\\33xl\\:first\\:-m-15:first-child{
    margin: -3.75rem;
  }

  .\\33xl\\:first\\:-m-16:first-child{
    margin: -4rem;
  }

  .\\33xl\\:first\\:-m-18:first-child{
    margin: -4.5rem;
  }

  .\\33xl\\:first\\:-m-20:first-child{
    margin: -5rem;
  }

  .\\33xl\\:first\\:-m-22:first-child{
    margin: -5.5rem;
  }

  .\\33xl\\:first\\:-m-23:first-child{
    margin: -5.75rem;
  }

  .\\33xl\\:first\\:-m-24:first-child{
    margin: -6rem;
  }

  .\\33xl\\:first\\:-m-25:first-child{
    margin: -6.25rem;
  }

  .\\33xl\\:first\\:-m-26:first-child{
    margin: -6.5rem;
  }

  .\\33xl\\:first\\:-m-28:first-child{
    margin: -7rem;
  }

  .\\33xl\\:first\\:-m-30:first-child{
    margin: -7.5rem;
  }

  .\\33xl\\:first\\:-m-32:first-child{
    margin: -8rem;
  }

  .\\33xl\\:first\\:-m-34:first-child{
    margin: -8.5rem;
  }

  .\\33xl\\:first\\:-m-40:first-child{
    margin: -10rem;
  }

  .\\33xl\\:first\\:-m-42:first-child{
    margin: -10.5rem;
  }

  .\\33xl\\:first\\:-m-44:first-child{
    margin: -11rem;
  }

  .\\33xl\\:first\\:-m-48:first-child{
    margin: -12rem;
  }

  .\\33xl\\:first\\:-m-52:first-child{
    margin: -13rem;
  }

  .\\33xl\\:first\\:-m-54:first-child{
    margin: -13.5rem;
  }

  .\\33xl\\:first\\:-m-56:first-child{
    margin: -14rem;
  }

  .\\33xl\\:first\\:-m-60:first-child{
    margin: -15rem;
  }

  .\\33xl\\:first\\:-m-64:first-child{
    margin: -16rem;
  }

  .\\33xl\\:first\\:-m-68:first-child{
    margin: -17rem;
  }

  .\\33xl\\:first\\:-m-72:first-child{
    margin: -18rem;
  }

  .\\33xl\\:first\\:-m-74:first-child{
    margin: -18.5rem;
  }

  .\\33xl\\:first\\:-m-76:first-child{
    margin: -19rem;
  }

  .\\33xl\\:first\\:-m-78:first-child{
    margin: -19.5rem;
  }

  .\\33xl\\:first\\:-m-80:first-child{
    margin: -20rem;
  }

  .\\33xl\\:first\\:-m-82:first-child{
    margin: -20.5rem;
  }

  .\\33xl\\:first\\:-m-84:first-child{
    margin: -21rem;
  }

  .\\33xl\\:first\\:-m-88:first-child{
    margin: -22rem;
  }

  .\\33xl\\:first\\:-m-92:first-child{
    margin: -23rem;
  }

  .\\33xl\\:first\\:-m-96:first-child{
    margin: -24rem;
  }

  .\\33xl\\:first\\:-m-98:first-child{
    margin: -24.5rem;
  }

  .\\33xl\\:first\\:-m-100:first-child{
    margin: -25rem;
  }

  .\\33xl\\:first\\:-m-104:first-child{
    margin: -26rem;
  }

  .\\33xl\\:first\\:-m-112:first-child{
    margin: -28rem;
  }

  .\\33xl\\:first\\:-m-124:first-child{
    margin: -31rem;
  }

  .\\33xl\\:first\\:-m-128:first-child{
    margin: -32rem;
  }

  .\\33xl\\:first\\:-m-140:first-child{
    margin: -35rem;
  }

  .\\33xl\\:first\\:-m-152:first-child{
    margin: -38rem;
  }

  .\\33xl\\:first\\:-m-160:first-child{
    margin: -40rem;
  }

  .\\33xl\\:first\\:-m-162:first-child{
    margin: -41rem;
  }

  .\\33xl\\:first\\:-m-192:first-child{
    margin: -48rem;
  }

  .\\33xl\\:first\\:-m-208:first-child{
    margin: -52rem;
  }

  .\\33xl\\:first\\:-m-224:first-child{
    margin: -56rem;
  }

  .\\33xl\\:first\\:-m-256:first-child{
    margin: -64rem;
  }

  .\\33xl\\:first\\:-m-px:first-child{
    margin: -1px;
  }

  .\\33xl\\:first\\:my-0:first-child{
    margin-top: 0;
    margin-bottom: 0;
  }

  .\\33xl\\:first\\:mx-0:first-child{
    margin-left: 0;
    margin-right: 0;
  }

  .\\33xl\\:first\\:my-1:first-child{
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
  }

  .\\33xl\\:first\\:mx-1:first-child{
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .\\33xl\\:first\\:my-2:first-child{
    margin-top: 0.5rem;
    margin-bottom: 0.5rem;
  }

  .\\33xl\\:first\\:mx-2:first-child{
    margin-left: 0.5rem;
    margin-right: 0.5rem;
  }

  .\\33xl\\:first\\:my-3:first-child{
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }

  .\\33xl\\:first\\:mx-3:first-child{
    margin-left: 0.75rem;
    margin-right: 0.75rem;
  }

  .\\33xl\\:first\\:my-4:first-child{
    margin-top: 1rem;
    margin-bottom: 1rem;
  }

  .\\33xl\\:first\\:mx-4:first-child{
    margin-left: 1rem;
    margin-right: 1rem;
  }

  .\\33xl\\:first\\:my-5:first-child{
    margin-top: 1.25rem;
    margin-bottom: 1.25rem;
  }

  .\\33xl\\:first\\:mx-5:first-child{
    margin-left: 1.25rem;
    margin-right: 1.25rem;
  }

  .\\33xl\\:first\\:my-6:first-child{
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .\\33xl\\:first\\:mx-6:first-child{
    margin-left: 1.5rem;
    margin-right: 1.5rem;
  }

  .\\33xl\\:first\\:my-7:first-child{
    margin-top: 1.75rem;
    margin-bottom: 1.75rem;
  }

  .\\33xl\\:first\\:mx-7:first-child{
    margin-left: 1.75rem;
    margin-right: 1.75rem;
  }

  .\\33xl\\:first\\:my-8:first-child{
    margin-top: 2rem;
    margin-bottom: 2rem;
  }

  .\\33xl\\:first\\:mx-8:first-child{
    margin-left: 2rem;
    margin-right: 2rem;
  }

  .\\33xl\\:first\\:my-9:first-child{
    margin-top: 2.25rem;
    margin-bottom: 2.25rem;
  }

  .\\33xl\\:first\\:mx-9:first-child{
    margin-left: 2.25rem;
    margin-right: 2.25rem;
  }

  .\\33xl\\:first\\:my-10:first-child{
    margin-top: 2.5rem;
    margin-bottom: 2.5rem;
  }

  .\\33xl\\:first\\:mx-10:first-child{
    margin-left: 2.5rem;
    margin-right: 2.5rem;
  }

  .\\33xl\\:first\\:my-11:first-child{
    margin-top: 2.75rem;
    margin-bottom: 2.75rem;
  }

  .\\33xl\\:first\\:mx-11:first-child{
    margin-left: 2.75rem;
    margin-right: 2.75rem;
  }

  .\\33xl\\:first\\:my-12:first-child{
    margin-top: 3rem;
    margin-bottom: 3rem;
  }

  .\\33xl\\:first\\:mx-12:first-child{
    margin-left: 3rem;
    margin-right: 3rem;
  }

  .\\33xl\\:first\\:my-14:first-child{
    margin-top: 3.5rem;
    margin-bottom: 3.5rem;
  }

  .\\33xl\\:first\\:mx-14:first-child{
    margin-left: 3.5rem;
    margin-right: 3.5rem;
  }

  .\\33xl\\:first\\:my-15:first-child{
    margin-top: 3.75rem;
    margin-bottom: 3.75rem;
  }

  .\\33xl\\:first\\:mx-15:first-child{
    margin-left: 3.75rem;
    margin-right: 3.75rem;
  }

  .\\33xl\\:first\\:my-16:first-child{
    margin-top: 4rem;
    margin-bottom: 4rem;
  }

  .\\33xl\\:first\\:mx-16:first-child{
    margin-left: 4rem;
    margin-right: 4rem;
  }

  .\\33xl\\:first\\:my-18:first-child{
    margin-top: 4.5rem;
    margin-bottom: 4.5rem;
  }

  .\\33xl\\:first\\:mx-18:first-child{
    margin-left: 4.5rem;
    margin-right: 4.5rem;
  }

  .\\33xl\\:first\\:my-20:first-child{
    margin-top: 5rem;
    margin-bottom: 5rem;
  }

  .\\33xl\\:first\\:mx-20:first-child{
    margin-left: 5rem;
    margin-right: 5rem;
  }

  .\\33xl\\:first\\:my-22:first-child{
    margin-top: 5.5rem;
    margin-bottom: 5.5rem;
  }

  .\\33xl\\:first\\:mx-22:first-child{
    margin-left: 5.5rem;
    margin-right: 5.5rem;
  }

  .\\33xl\\:first\\:my-23:first-child{
    margin-top: 5.75rem;
    margin-bottom: 5.75rem;
  }

  .\\33xl\\:first\\:mx-23:first-child{
    margin-left: 5.75rem;
    margin-right: 5.75rem;
  }

  .\\33xl\\:first\\:my-24:first-child{
    margin-top: 6rem;
    margin-bottom: 6rem;
  }

  .\\33xl\\:first\\:mx-24:first-child{
    margin-left: 6rem;
    margin-right: 6rem;
  }

  .\\33xl\\:first\\:my-25:first-child{
    margin-top: 6.25rem;
    margin-bottom: 6.25rem;
  }

  .\\33xl\\:first\\:mx-25:first-child{
    margin-left: 6.25rem;
    margin-right: 6.25rem;
  }

  .\\33xl\\:first\\:my-26:first-child{
    margin-top: 6.5rem;
    margin-bottom: 6.5rem;
  }

  .\\33xl\\:first\\:mx-26:first-child{
    margin-left: 6.5rem;
    margin-right: 6.5rem;
  }

  .\\33xl\\:first\\:my-28:first-child{
    margin-top: 7rem;
    margin-bottom: 7rem;
  }

  .\\33xl\\:first\\:mx-28:first-child{
    margin-left: 7rem;
    margin-right: 7rem;
  }

  .\\33xl\\:first\\:my-30:first-child{
    margin-top: 7.5rem;
    margin-bottom: 7.5rem;
  }

  .\\33xl\\:first\\:mx-30:first-child{
    margin-left: 7.5rem;
    margin-right: 7.5rem;
  }

  .\\33xl\\:first\\:my-32:first-child{
    margin-top: 8rem;
    margin-bottom: 8rem;
  }

  .\\33xl\\:first\\:mx-32:first-child{
    margin-left: 8rem;
    margin-right: 8rem;
  }

  .\\33xl\\:first\\:my-34:first-child{
    margin-top: 8.5rem;
    margin-bottom: 8.5rem;
  }

  .\\33xl\\:first\\:mx-34:first-child{
    margin-left: 8.5rem;
    margin-right: 8.5rem;
  }

  .\\33xl\\:first\\:my-40:first-child{
    margin-top: 10rem;
    margin-bottom: 10rem;
  }

  .\\33xl\\:first\\:mx-40:first-child{
    margin-left: 10rem;
    margin-right: 10rem;
  }

  .\\33xl\\:first\\:my-42:first-child{
    margin-top: 10.5rem;
    margin-bottom: 10.5rem;
  }

  .\\33xl\\:first\\:mx-42:first-child{
    margin-left: 10.5rem;
    margin-right: 10.5rem;
  }

  .\\33xl\\:first\\:my-44:first-child{
    margin-top: 11rem;
    margin-bottom: 11rem;
  }

  .\\33xl\\:first\\:mx-44:first-child{
    margin-left: 11rem;
    margin-right: 11rem;
  }

  .\\33xl\\:first\\:my-48:first-child{
    margin-top: 12rem;
    margin-bottom: 12rem;
  }

  .\\33xl\\:first\\:mx-48:first-child{
    margin-left: 12rem;
    margin-right: 12rem;
  }

  .\\33xl\\:first\\:my-52:first-child{
    margin-top: 13rem;
    margin-bottom: 13rem;
  }

  .\\33xl\\:first\\:mx-52:first-child{
    margin-left: 13rem;
    margin-right: 13rem;
  }

  .\\33xl\\:first\\:my-54:first-child{
    margin-top: 13.5rem;
    margin-bottom: 13.5rem;
  }

  .\\33xl\\:first\\:mx-54:first-child{
    margin-left: 13.5rem;
    margin-right: 13.5rem;
  }

  .\\33xl\\:first\\:my-56:first-child{
    margin-top: 14rem;
    margin-bottom: 14rem;
  }

  .\\33xl\\:first\\:mx-56:first-child{
    margin-left: 14rem;
    margin-right: 14rem;
  }

  .\\33xl\\:first\\:my-60:first-child{
    margin-top: 15rem;
    margin-bottom: 15rem;
  }

  .\\33xl\\:first\\:mx-60:first-child{
    margin-left: 15rem;
    margin-right: 15rem;
  }

  .\\33xl\\:first\\:my-64:first-child{
    margin-top: 16rem;
    margin-bottom: 16rem;
  }

  .\\33xl\\:first\\:mx-64:first-child{
    margin-left: 16rem;
    margin-right: 16rem;
  }

  .\\33xl\\:first\\:my-68:first-child{
    margin-top: 17rem;
    margin-bottom: 17rem;
  }

  .\\33xl\\:first\\:mx-68:first-child{
    margin-left: 17rem;
    margin-right: 17rem;
  }

  .\\33xl\\:first\\:my-72:first-child{
    margin-top: 18rem;
    margin-bottom: 18rem;
  }

  .\\33xl\\:first\\:mx-72:first-child{
    margin-left: 18rem;
    margin-right: 18rem;
  }

  .\\33xl\\:first\\:my-74:first-child{
    margin-top: 18.5rem;
    margin-bottom: 18.5rem;
  }

  .\\33xl\\:first\\:mx-74:first-child{
    margin-left: 18.5rem;
    margin-right: 18.5rem;
  }

  .\\33xl\\:first\\:my-76:first-child{
    margin-top: 19rem;
    margin-bottom: 19rem;
  }

  .\\33xl\\:first\\:mx-76:first-child{
    margin-left: 19rem;
    margin-right: 19rem;
  }

  .\\33xl\\:first\\:my-78:first-child{
    margin-top: 19.5rem;
    margin-bottom: 19.5rem;
  }

  .\\33xl\\:first\\:mx-78:first-child{
    margin-left: 19.5rem;
    margin-right: 19.5rem;
  }

  .\\33xl\\:first\\:my-80:first-child{
    margin-top: 20rem;
    margin-bottom: 20rem;
  }

  .\\33xl\\:first\\:mx-80:first-child{
    margin-left: 20rem;
    margin-right: 20rem;
  }

  .\\33xl\\:first\\:my-82:first-child{
    margin-top: 20.5rem;
    margin-bottom: 20.5rem;
  }

  .\\33xl\\:first\\:mx-82:first-child{
    margin-left: 20.5rem;
    margin-right: 20.5rem;
  }

  .\\33xl\\:first\\:my-84:first-child{
    margin-top: 21rem;
    margin-bottom: 21rem;
  }

  .\\33xl\\:first\\:mx-84:first-child{
    margin-left: 21rem;
    margin-right: 21rem;
  }

  .\\33xl\\:first\\:my-88:first-child{
    margin-top: 22rem;
    margin-bottom: 22rem;
  }

  .\\33xl\\:first\\:mx-88:first-child{
    margin-left: 22rem;
    margin-right: 22rem;
  }

  .\\33xl\\:first\\:my-92:first-child{
    margin-top: 23rem;
    margin-bottom: 23rem;
  }

  .\\33xl\\:first\\:mx-92:first-child{
    margin-left: 23rem;
    margin-right: 23rem;
  }

  .\\33xl\\:first\\:my-96:first-child{
    margin-top: 24rem;
    margin-bottom: 24rem;
  }

  .\\33xl\\:first\\:mx-96:first-child{
    margin-left: 24rem;
    margin-right: 24rem;
  }

  .\\33xl\\:first\\:my-98:first-child{
    margin-top: 24.5rem;
    margin-bottom: 24.5rem;
  }

  .\\33xl\\:first\\:mx-98:first-child{
    margin-left: 24.5rem;
    margin-right: 24.5rem;
  }

  .\\33xl\\:first\\:my-100:first-child{
    margin-top: 25rem;
    margin-bottom: 25rem;
  }

  .\\33xl\\:first\\:mx-100:first-child{
    margin-left: 25rem;
    margin-right: 25rem;
  }

  .\\33xl\\:first\\:my-104:first-child{
    margin-top: 26rem;
    margin-bottom: 26rem;
  }

  .\\33xl\\:first\\:mx-104:first-child{
    margin-left: 26rem;
    margin-right: 26rem;
  }

  .\\33xl\\:first\\:my-112:first-child{
    margin-top: 28rem;
    margin-bottom: 28rem;
  }

  .\\33xl\\:first\\:mx-112:first-child{
    margin-left: 28rem;
    margin-right: 28rem;
  }

  .\\33xl\\:first\\:my-124:first-child{
    margin-top: 31rem;
    margin-bottom: 31rem;
  }

  .\\33xl\\:first\\:mx-124:first-child{
    margin-left: 31rem;
    margin-right: 31rem;
  }

  .\\33xl\\:first\\:my-128:first-child{
    margin-top: 32rem;
    margin-bottom: 32rem;
  }

  .\\33xl\\:first\\:mx-128:first-child{
    margin-left: 32rem;
    margin-right: 32rem;
  }

  .\\33xl\\:first\\:my-140:first-child{
    margin-top: 35rem;
    margin-bottom: 35rem;
  }

  .\\33xl\\:first\\:mx-140:first-child{
    margin-left: 35rem;
    margin-right: 35rem;
  }

  .\\33xl\\:first\\:my-152:first-child{
    margin-top: 38rem;
    margin-bottom: 38rem;
  }

  .\\33xl\\:first\\:mx-152:first-child{
    margin-left: 38rem;
    margin-right: 38rem;
  }

  .\\33xl\\:first\\:my-160:first-child{
    margin-top: 40rem;
    margin-bottom: 40rem;
  }

  .\\33xl\\:first\\:mx-160:first-child{
    margin-left: 40rem;
    margin-right: 40rem;
  }

  .\\33xl\\:first\\:my-162:first-child{
    margin-top: 41rem;
    margin-bottom: 41rem;
  }

  .\\33xl\\:first\\:mx-162:first-child{
    margin-left: 41rem;
    margin-right: 41rem;
  }

  .\\33xl\\:first\\:my-192:first-child{
    margin-top: 48rem;
    margin-bottom: 48rem;
  }

  .\\33xl\\:first\\:mx-192:first-child{
    margin-left: 48rem;
    margin-right: 48rem;
  }

  .\\33xl\\:first\\:my-208:first-child{
    margin-top: 52rem;
    margin-bottom: 52rem;
  }

  .\\33xl\\:first\\:mx-208:first-child{
    margin-left: 52rem;
    margin-right: 52rem;
  }

  .\\33xl\\:first\\:my-224:first-child{
    margin-top: 56rem;
    margin-bottom: 56rem;
  }

  .\\33xl\\:first\\:mx-224:first-child{
    margin-left: 56rem;
    margin-right: 56rem;
  }

  .\\33xl\\:first\\:my-256:first-child{
    margin-top: 64rem;
    margin-bottom: 64rem;
  }

  .\\33xl\\:first\\:mx-256:first-child{
    margin-left: 64rem;
    margin-right: 64rem;
  }

  .\\33xl\\:first\\:my-auto:first-child{
    margin-top: auto;
    margin-bottom: auto;
  }

  .\\33xl\\:first\\:mx-auto:first-child{
    margin-left: auto;
    margin-right: auto;
  }

  .\\33xl\\:first\\:my-px:first-child{
    margin-top: 1px;
    margin-bottom: 1px;
  }

  .\\33xl\\:first\\:mx-px:first-child{
    margin-left: 1px;
    margin-right: 1px;
  }

  .\\33xl\\:first\\:-my-1:first-child{
    margin-top: -0.25rem;
    margin-bottom: -0.25rem;
  }

  .\\33xl\\:first\\:-mx-1:first-child{
    margin-left: -0.25rem;
    margin-right: -0.25rem;
  }

  .\\33xl\\:first\\:-my-2:first-child{
    margin-top: -0.5rem;
    margin-bottom: -0.5rem;
  }

  .\\33xl\\:first\\:-mx-2:first-child{
    margin-left: -0.5rem;
    margin-right: -0.5rem;
  }

  .\\33xl\\:first\\:-my-3:first-child{
    margin-top: -0.75rem;
    margin-bottom: -0.75rem;
  }

  .\\33xl\\:first\\:-mx-3:first-child{
    margin-left: -0.75rem;
    margin-right: -0.75rem;
  }

  .\\33xl\\:first\\:-my-4:first-child{
    margin-top: -1rem;
    margin-bottom: -1rem;
  }

  .\\33xl\\:first\\:-mx-4:first-child{
    margin-left: -1rem;
    margin-right: -1rem;
  }

  .\\33xl\\:first\\:-my-5:first-child{
    margin-top: -1.25rem;
    margin-bottom: -1.25rem;
  }

  .\\33xl\\:first\\:-mx-5:first-child{
    margin-left: -1.25rem;
    margin-right: -1.25rem;
  }

  .\\33xl\\:first\\:-my-6:first-child{
    margin-top: -1.5rem;
    margin-bottom: -1.5rem;
  }

  .\\33xl\\:first\\:-mx-6:first-child{
    margin-left: -1.5rem;
    margin-right: -1.5rem;
  }

  .\\33xl\\:first\\:-my-7:first-child{
    margin-top: -1.75rem;
    margin-bottom: -1.75rem;
  }

  .\\33xl\\:first\\:-mx-7:first-child{
    margin-left: -1.75rem;
    margin-right: -1.75rem;
  }

  .\\33xl\\:first\\:-my-8:first-child{
    margin-top: -2rem;
    margin-bottom: -2rem;
  }

  .\\33xl\\:first\\:-mx-8:first-child{
    margin-left: -2rem;
    margin-right: -2rem;
  }

  .\\33xl\\:first\\:-my-9:first-child{
    margin-top: -2.25rem;
    margin-bottom: -2.25rem;
  }

  .\\33xl\\:first\\:-mx-9:first-child{
    margin-left: -2.25rem;
    margin-right: -2.25rem;
  }

  .\\33xl\\:first\\:-my-10:first-child{
    margin-top: -2.5rem;
    margin-bottom: -2.5rem;
  }

  .\\33xl\\:first\\:-mx-10:first-child{
    margin-left: -2.5rem;
    margin-right: -2.5rem;
  }

  .\\33xl\\:first\\:-my-11:first-child{
    margin-top: -2.75rem;
    margin-bottom: -2.75rem;
  }

  .\\33xl\\:first\\:-mx-11:first-child{
    margin-left: -2.75rem;
    margin-right: -2.75rem;
  }

  .\\33xl\\:first\\:-my-12:first-child{
    margin-top: -3rem;
    margin-bottom: -3rem;
  }

  .\\33xl\\:first\\:-mx-12:first-child{
    margin-left: -3rem;
    margin-right: -3rem;
  }

  .\\33xl\\:first\\:-my-14:first-child{
    margin-top: -3.5rem;
    margin-bottom: -3.5rem;
  }

  .\\33xl\\:first\\:-mx-14:first-child{
    margin-left: -3.5rem;
    margin-right: -3.5rem;
  }

  .\\33xl\\:first\\:-my-15:first-child{
    margin-top: -3.75rem;
    margin-bottom: -3.75rem;
  }

  .\\33xl\\:first\\:-mx-15:first-child{
    margin-left: -3.75rem;
    margin-right: -3.75rem;
  }

  .\\33xl\\:first\\:-my-16:first-child{
    margin-top: -4rem;
    margin-bottom: -4rem;
  }

  .\\33xl\\:first\\:-mx-16:first-child{
    margin-left: -4rem;
    margin-right: -4rem;
  }

  .\\33xl\\:first\\:-my-18:first-child{
    margin-top: -4.5rem;
    margin-bottom: -4.5rem;
  }

  .\\33xl\\:first\\:-mx-18:first-child{
    margin-left: -4.5rem;
    margin-right: -4.5rem;
  }

  .\\33xl\\:first\\:-my-20:first-child{
    margin-top: -5rem;
    margin-bottom: -5rem;
  }

  .\\33xl\\:first\\:-mx-20:first-child{
    margin-left: -5rem;
    margin-right: -5rem;
  }

  .\\33xl\\:first\\:-my-22:first-child{
    margin-top: -5.5rem;
    margin-bottom: -5.5rem;
  }

  .\\33xl\\:first\\:-mx-22:first-child{
    margin-left: -5.5rem;
    margin-right: -5.5rem;
  }

  .\\33xl\\:first\\:-my-23:first-child{
    margin-top: -5.75rem;
    margin-bottom: -5.75rem;
  }

  .\\33xl\\:first\\:-mx-23:first-child{
    margin-left: -5.75rem;
    margin-right: -5.75rem;
  }

  .\\33xl\\:first\\:-my-24:first-child{
    margin-top: -6rem;
    margin-bottom: -6rem;
  }

  .\\33xl\\:first\\:-mx-24:first-child{
    margin-left: -6rem;
    margin-right: -6rem;
  }

  .\\33xl\\:first\\:-my-25:first-child{
    margin-top: -6.25rem;
    margin-bottom: -6.25rem;
  }

  .\\33xl\\:first\\:-mx-25:first-child{
    margin-left: -6.25rem;
    margin-right: -6.25rem;
  }

  .\\33xl\\:first\\:-my-26:first-child{
    margin-top: -6.5rem;
    margin-bottom: -6.5rem;
  }

  .\\33xl\\:first\\:-mx-26:first-child{
    margin-left: -6.5rem;
    margin-right: -6.5rem;
  }

  .\\33xl\\:first\\:-my-28:first-child{
    margin-top: -7rem;
    margin-bottom: -7rem;
  }

  .\\33xl\\:first\\:-mx-28:first-child{
    margin-left: -7rem;
    margin-right: -7rem;
  }

  .\\33xl\\:first\\:-my-30:first-child{
    margin-top: -7.5rem;
    margin-bottom: -7.5rem;
  }

  .\\33xl\\:first\\:-mx-30:first-child{
    margin-left: -7.5rem;
    margin-right: -7.5rem;
  }

  .\\33xl\\:first\\:-my-32:first-child{
    margin-top: -8rem;
    margin-bottom: -8rem;
  }

  .\\33xl\\:first\\:-mx-32:first-child{
    margin-left: -8rem;
    margin-right: -8rem;
  }

  .\\33xl\\:first\\:-my-34:first-child{
    margin-top: -8.5rem;
    margin-bottom: -8.5rem;
  }

  .\\33xl\\:first\\:-mx-34:first-child{
    margin-left: -8.5rem;
    margin-right: -8.5rem;
  }

  .\\33xl\\:first\\:-my-40:first-child{
    margin-top: -10rem;
    margin-bottom: -10rem;
  }

  .\\33xl\\:first\\:-mx-40:first-child{
    margin-left: -10rem;
    margin-right: -10rem;
  }

  .\\33xl\\:first\\:-my-42:first-child{
    margin-top: -10.5rem;
    margin-bottom: -10.5rem;
  }

  .\\33xl\\:first\\:-mx-42:first-child{
    margin-left: -10.5rem;
    margin-right: -10.5rem;
  }

  .\\33xl\\:first\\:-my-44:first-child{
    margin-top: -11rem;
    margin-bottom: -11rem;
  }

  .\\33xl\\:first\\:-mx-44:first-child{
    margin-left: -11rem;
    margin-right: -11rem;
  }

  .\\33xl\\:first\\:-my-48:first-child{
    margin-top: -12rem;
    margin-bottom: -12rem;
  }

  .\\33xl\\:first\\:-mx-48:first-child{
    margin-left: -12rem;
    margin-right: -12rem;
  }

  .\\33xl\\:first\\:-my-52:first-child{
    margin-top: -13rem;
    margin-bottom: -13rem;
  }

  .\\33xl\\:first\\:-mx-52:first-child{
    margin-left: -13rem;
    margin-right: -13rem;
  }

  .\\33xl\\:first\\:-my-54:first-child{
    margin-top: -13.5rem;
    margin-bottom: -13.5rem;
  }

  .\\33xl\\:first\\:-mx-54:first-child{
    margin-left: -13.5rem;
    margin-right: -13.5rem;
  }

  .\\33xl\\:first\\:-my-56:first-child{
    margin-top: -14rem;
    margin-bottom: -14rem;
  }

  .\\33xl\\:first\\:-mx-56:first-child{
    margin-left: -14rem;
    margin-right: -14rem;
  }

  .\\33xl\\:first\\:-my-60:first-child{
    margin-top: -15rem;
    margin-bottom: -15rem;
  }

  .\\33xl\\:first\\:-mx-60:first-child{
    margin-left: -15rem;
    margin-right: -15rem;
  }

  .\\33xl\\:first\\:-my-64:first-child{
    margin-top: -16rem;
    margin-bottom: -16rem;
  }

  .\\33xl\\:first\\:-mx-64:first-child{
    margin-left: -16rem;
    margin-right: -16rem;
  }

  .\\33xl\\:first\\:-my-68:first-child{
    margin-top: -17rem;
    margin-bottom: -17rem;
  }

  .\\33xl\\:first\\:-mx-68:first-child{
    margin-left: -17rem;
    margin-right: -17rem;
  }

  .\\33xl\\:first\\:-my-72:first-child{
    margin-top: -18rem;
    margin-bottom: -18rem;
  }

  .\\33xl\\:first\\:-mx-72:first-child{
    margin-left: -18rem;
    margin-right: -18rem;
  }

  .\\33xl\\:first\\:-my-74:first-child{
    margin-top: -18.5rem;
    margin-bottom: -18.5rem;
  }

  .\\33xl\\:first\\:-mx-74:first-child{
    margin-left: -18.5rem;
    margin-right: -18.5rem;
  }

  .\\33xl\\:first\\:-my-76:first-child{
    margin-top: -19rem;
    margin-bottom: -19rem;
  }

  .\\33xl\\:first\\:-mx-76:first-child{
    margin-left: -19rem;
    margin-right: -19rem;
  }

  .\\33xl\\:first\\:-my-78:first-child{
    margin-top: -19.5rem;
    margin-bottom: -19.5rem;
  }

  .\\33xl\\:first\\:-mx-78:first-child{
    margin-left: -19.5rem;
    margin-right: -19.5rem;
  }

  .\\33xl\\:first\\:-my-80:first-child{
    margin-top: -20rem;
    margin-bottom: -20rem;
  }

  .\\33xl\\:first\\:-mx-80:first-child{
    margin-left: -20rem;
    margin-right: -20rem;
  }

  .\\33xl\\:first\\:-my-82:first-child{
    margin-top: -20.5rem;
    margin-bottom: -20.5rem;
  }

  .\\33xl\\:first\\:-mx-82:first-child{
    margin-left: -20.5rem;
    margin-right: -20.5rem;
  }

  .\\33xl\\:first\\:-my-84:first-child{
    margin-top: -21rem;
    margin-bottom: -21rem;
  }

  .\\33xl\\:first\\:-mx-84:first-child{
    margin-left: -21rem;
    margin-right: -21rem;
  }

  .\\33xl\\:first\\:-my-88:first-child{
    margin-top: -22rem;
    margin-bottom: -22rem;
  }

  .\\33xl\\:first\\:-mx-88:first-child{
    margin-left: -22rem;
    margin-right: -22rem;
  }

  .\\33xl\\:first\\:-my-92:first-child{
    margin-top: -23rem;
    margin-bottom: -23rem;
  }

  .\\33xl\\:first\\:-mx-92:first-child{
    margin-left: -23rem;
    margin-right: -23rem;
  }

  .\\33xl\\:first\\:-my-96:first-child{
    margin-top: -24rem;
    margin-bottom: -24rem;
  }

  .\\33xl\\:first\\:-mx-96:first-child{
    margin-left: -24rem;
    margin-right: -24rem;
  }

  .\\33xl\\:first\\:-my-98:first-child{
    margin-top: -24.5rem;
    margin-bottom: -24.5rem;
  }

  .\\33xl\\:first\\:-mx-98:first-child{
    margin-left: -24.5rem;
    margin-right: -24.5rem;
  }

  .\\33xl\\:first\\:-my-100:first-child{
    margin-top: -25rem;
    margin-bottom: -25rem;
  }

  .\\33xl\\:first\\:-mx-100:first-child{
    margin-left: -25rem;
    margin-right: -25rem;
  }

  .\\33xl\\:first\\:-my-104:first-child{
    margin-top: -26rem;
    margin-bottom: -26rem;
  }

  .\\33xl\\:first\\:-mx-104:first-child{
    margin-left: -26rem;
    margin-right: -26rem;
  }

  .\\33xl\\:first\\:-my-112:first-child{
    margin-top: -28rem;
    margin-bottom: -28rem;
  }

  .\\33xl\\:first\\:-mx-112:first-child{
    margin-left: -28rem;
    margin-right: -28rem;
  }

  .\\33xl\\:first\\:-my-124:first-child{
    margin-top: -31rem;
    margin-bottom: -31rem;
  }

  .\\33xl\\:first\\:-mx-124:first-child{
    margin-left: -31rem;
    margin-right: -31rem;
  }

  .\\33xl\\:first\\:-my-128:first-child{
    margin-top: -32rem;
    margin-bottom: -32rem;
  }

  .\\33xl\\:first\\:-mx-128:first-child{
    margin-left: -32rem;
    margin-right: -32rem;
  }

  .\\33xl\\:first\\:-my-140:first-child{
    margin-top: -35rem;
    margin-bottom: -35rem;
  }

  .\\33xl\\:first\\:-mx-140:first-child{
    margin-left: -35rem;
    margin-right: -35rem;
  }

  .\\33xl\\:first\\:-my-152:first-child{
    margin-top: -38rem;
    margin-bottom: -38rem;
  }

  .\\33xl\\:first\\:-mx-152:first-child{
    margin-left: -38rem;
    margin-right: -38rem;
  }

  .\\33xl\\:first\\:-my-160:first-child{
    margin-top: -40rem;
    margin-bottom: -40rem;
  }

  .\\33xl\\:first\\:-mx-160:first-child{
    margin-left: -40rem;
    margin-right: -40rem;
  }

  .\\33xl\\:first\\:-my-162:first-child{
    margin-top: -41rem;
    margin-bottom: -41rem;
  }

  .\\33xl\\:first\\:-mx-162:first-child{
    margin-left: -41rem;
    margin-right: -41rem;
  }

  .\\33xl\\:first\\:-my-192:first-child{
    margin-top: -48rem;
    margin-bottom: -48rem;
  }

  .\\33xl\\:first\\:-mx-192:first-child{
    margin-left: -48rem;
    margin-right: -48rem;
  }

  .\\33xl\\:first\\:-my-208:first-child{
    margin-top: -52rem;
    margin-bottom: -52rem;
  }

  .\\33xl\\:first\\:-mx-208:first-child{
    margin-left: -52rem;
    margin-right: -52rem;
  }

  .\\33xl\\:first\\:-my-224:first-child{
    margin-top: -56rem;
    margin-bottom: -56rem;
  }

  .\\33xl\\:first\\:-mx-224:first-child{
    margin-left: -56rem;
    margin-right: -56rem;
  }

  .\\33xl\\:first\\:-my-256:first-child{
    margin-top: -64rem;
    margin-bottom: -64rem;
  }

  .\\33xl\\:first\\:-mx-256:first-child{
    margin-left: -64rem;
    margin-right: -64rem;
  }

  .\\33xl\\:first\\:-my-px:first-child{
    margin-top: -1px;
    margin-bottom: -1px;
  }

  .\\33xl\\:first\\:-mx-px:first-child{
    margin-left: -1px;
    margin-right: -1px;
  }

  .\\33xl\\:first\\:mt-0:first-child{
    margin-top: 0;
  }

  .\\33xl\\:first\\:mr-0:first-child{
    margin-right: 0;
  }

  .\\33xl\\:first\\:mb-0:first-child{
    margin-bottom: 0;
  }

  .\\33xl\\:first\\:ml-0:first-child{
    margin-left: 0;
  }

  .\\33xl\\:first\\:mt-1:first-child{
    margin-top: 0.25rem;
  }

  .\\33xl\\:first\\:mr-1:first-child{
    margin-right: 0.25rem;
  }

  .\\33xl\\:first\\:mb-1:first-child{
    margin-bottom: 0.25rem;
  }

  .\\33xl\\:first\\:ml-1:first-child{
    margin-left: 0.25rem;
  }

  .\\33xl\\:first\\:mt-2:first-child{
    margin-top: 0.5rem;
  }

  .\\33xl\\:first\\:mr-2:first-child{
    margin-right: 0.5rem;
  }

  .\\33xl\\:first\\:mb-2:first-child{
    margin-bottom: 0.5rem;
  }

  .\\33xl\\:first\\:ml-2:first-child{
    margin-left: 0.5rem;
  }

  .\\33xl\\:first\\:mt-3:first-child{
    margin-top: 0.75rem;
  }

  .\\33xl\\:first\\:mr-3:first-child{
    margin-right: 0.75rem;
  }

  .\\33xl\\:first\\:mb-3:first-child{
    margin-bottom: 0.75rem;
  }

  .\\33xl\\:first\\:ml-3:first-child{
    margin-left: 0.75rem;
  }

  .\\33xl\\:first\\:mt-4:first-child{
    margin-top: 1rem;
  }

  .\\33xl\\:first\\:mr-4:first-child{
    margin-right: 1rem;
  }

  .\\33xl\\:first\\:mb-4:first-child{
    margin-bottom: 1rem;
  }

  .\\33xl\\:first\\:ml-4:first-child{
    margin-left: 1rem;
  }

  .\\33xl\\:first\\:mt-5:first-child{
    margin-top: 1.25rem;
  }

  .\\33xl\\:first\\:mr-5:first-child{
    margin-right: 1.25rem;
  }

  .\\33xl\\:first\\:mb-5:first-child{
    margin-bottom: 1.25rem;
  }

  .\\33xl\\:first\\:ml-5:first-child{
    margin-left: 1.25rem;
  }

  .\\33xl\\:first\\:mt-6:first-child{
    margin-top: 1.5rem;
  }

  .\\33xl\\:first\\:mr-6:first-child{
    margin-right: 1.5rem;
  }

  .\\33xl\\:first\\:mb-6:first-child{
    margin-bottom: 1.5rem;
  }

  .\\33xl\\:first\\:ml-6:first-child{
    margin-left: 1.5rem;
  }

  .\\33xl\\:first\\:mt-7:first-child{
    margin-top: 1.75rem;
  }

  .\\33xl\\:first\\:mr-7:first-child{
    margin-right: 1.75rem;
  }

  .\\33xl\\:first\\:mb-7:first-child{
    margin-bottom: 1.75rem;
  }

  .\\33xl\\:first\\:ml-7:first-child{
    margin-left: 1.75rem;
  }

  .\\33xl\\:first\\:mt-8:first-child{
    margin-top: 2rem;
  }

  .\\33xl\\:first\\:mr-8:first-child{
    margin-right: 2rem;
  }

  .\\33xl\\:first\\:mb-8:first-child{
    margin-bottom: 2rem;
  }

  .\\33xl\\:first\\:ml-8:first-child{
    margin-left: 2rem;
  }

  .\\33xl\\:first\\:mt-9:first-child{
    margin-top: 2.25rem;
  }

  .\\33xl\\:first\\:mr-9:first-child{
    margin-right: 2.25rem;
  }

  .\\33xl\\:first\\:mb-9:first-child{
    margin-bottom: 2.25rem;
  }

  .\\33xl\\:first\\:ml-9:first-child{
    margin-left: 2.25rem;
  }

  .\\33xl\\:first\\:mt-10:first-child{
    margin-top: 2.5rem;
  }

  .\\33xl\\:first\\:mr-10:first-child{
    margin-right: 2.5rem;
  }

  .\\33xl\\:first\\:mb-10:first-child{
    margin-bottom: 2.5rem;
  }

  .\\33xl\\:first\\:ml-10:first-child{
    margin-left: 2.5rem;
  }

  .\\33xl\\:first\\:mt-11:first-child{
    margin-top: 2.75rem;
  }

  .\\33xl\\:first\\:mr-11:first-child{
    margin-right: 2.75rem;
  }

  .\\33xl\\:first\\:mb-11:first-child{
    margin-bottom: 2.75rem;
  }

  .\\33xl\\:first\\:ml-11:first-child{
    margin-left: 2.75rem;
  }

  .\\33xl\\:first\\:mt-12:first-child{
    margin-top: 3rem;
  }

  .\\33xl\\:first\\:mr-12:first-child{
    margin-right: 3rem;
  }

  .\\33xl\\:first\\:mb-12:first-child{
    margin-bottom: 3rem;
  }

  .\\33xl\\:first\\:ml-12:first-child{
    margin-left: 3rem;
  }

  .\\33xl\\:first\\:mt-14:first-child{
    margin-top: 3.5rem;
  }

  .\\33xl\\:first\\:mr-14:first-child{
    margin-right: 3.5rem;
  }

  .\\33xl\\:first\\:mb-14:first-child{
    margin-bottom: 3.5rem;
  }

  .\\33xl\\:first\\:ml-14:first-child{
    margin-left: 3.5rem;
  }

  .\\33xl\\:first\\:mt-15:first-child{
    margin-top: 3.75rem;
  }

  .\\33xl\\:first\\:mr-15:first-child{
    margin-right: 3.75rem;
  }

  .\\33xl\\:first\\:mb-15:first-child{
    margin-bottom: 3.75rem;
  }

  .\\33xl\\:first\\:ml-15:first-child{
    margin-left: 3.75rem;
  }

  .\\33xl\\:first\\:mt-16:first-child{
    margin-top: 4rem;
  }

  .\\33xl\\:first\\:mr-16:first-child{
    margin-right: 4rem;
  }

  .\\33xl\\:first\\:mb-16:first-child{
    margin-bottom: 4rem;
  }

  .\\33xl\\:first\\:ml-16:first-child{
    margin-left: 4rem;
  }

  .\\33xl\\:first\\:mt-18:first-child{
    margin-top: 4.5rem;
  }

  .\\33xl\\:first\\:mr-18:first-child{
    margin-right: 4.5rem;
  }

  .\\33xl\\:first\\:mb-18:first-child{
    margin-bottom: 4.5rem;
  }

  .\\33xl\\:first\\:ml-18:first-child{
    margin-left: 4.5rem;
  }

  .\\33xl\\:first\\:mt-20:first-child{
    margin-top: 5rem;
  }

  .\\33xl\\:first\\:mr-20:first-child{
    margin-right: 5rem;
  }

  .\\33xl\\:first\\:mb-20:first-child{
    margin-bottom: 5rem;
  }

  .\\33xl\\:first\\:ml-20:first-child{
    margin-left: 5rem;
  }

  .\\33xl\\:first\\:mt-22:first-child{
    margin-top: 5.5rem;
  }

  .\\33xl\\:first\\:mr-22:first-child{
    margin-right: 5.5rem;
  }

  .\\33xl\\:first\\:mb-22:first-child{
    margin-bottom: 5.5rem;
  }

  .\\33xl\\:first\\:ml-22:first-child{
    margin-left: 5.5rem;
  }

  .\\33xl\\:first\\:mt-23:first-child{
    margin-top: 5.75rem;
  }

  .\\33xl\\:first\\:mr-23:first-child{
    margin-right: 5.75rem;
  }

  .\\33xl\\:first\\:mb-23:first-child{
    margin-bottom: 5.75rem;
  }

  .\\33xl\\:first\\:ml-23:first-child{
    margin-left: 5.75rem;
  }

  .\\33xl\\:first\\:mt-24:first-child{
    margin-top: 6rem;
  }

  .\\33xl\\:first\\:mr-24:first-child{
    margin-right: 6rem;
  }

  .\\33xl\\:first\\:mb-24:first-child{
    margin-bottom: 6rem;
  }

  .\\33xl\\:first\\:ml-24:first-child{
    margin-left: 6rem;
  }

  .\\33xl\\:first\\:mt-25:first-child{
    margin-top: 6.25rem;
  }

  .\\33xl\\:first\\:mr-25:first-child{
    margin-right: 6.25rem;
  }

  .\\33xl\\:first\\:mb-25:first-child{
    margin-bottom: 6.25rem;
  }

  .\\33xl\\:first\\:ml-25:first-child{
    margin-left: 6.25rem;
  }

  .\\33xl\\:first\\:mt-26:first-child{
    margin-top: 6.5rem;
  }

  .\\33xl\\:first\\:mr-26:first-child{
    margin-right: 6.5rem;
  }

  .\\33xl\\:first\\:mb-26:first-child{
    margin-bottom: 6.5rem;
  }

  .\\33xl\\:first\\:ml-26:first-child{
    margin-left: 6.5rem;
  }

  .\\33xl\\:first\\:mt-28:first-child{
    margin-top: 7rem;
  }

  .\\33xl\\:first\\:mr-28:first-child{
    margin-right: 7rem;
  }

  .\\33xl\\:first\\:mb-28:first-child{
    margin-bottom: 7rem;
  }

  .\\33xl\\:first\\:ml-28:first-child{
    margin-left: 7rem;
  }

  .\\33xl\\:first\\:mt-30:first-child{
    margin-top: 7.5rem;
  }

  .\\33xl\\:first\\:mr-30:first-child{
    margin-right: 7.5rem;
  }

  .\\33xl\\:first\\:mb-30:first-child{
    margin-bottom: 7.5rem;
  }

  .\\33xl\\:first\\:ml-30:first-child{
    margin-left: 7.5rem;
  }

  .\\33xl\\:first\\:mt-32:first-child{
    margin-top: 8rem;
  }

  .\\33xl\\:first\\:mr-32:first-child{
    margin-right: 8rem;
  }

  .\\33xl\\:first\\:mb-32:first-child{
    margin-bottom: 8rem;
  }

  .\\33xl\\:first\\:ml-32:first-child{
    margin-left: 8rem;
  }

  .\\33xl\\:first\\:mt-34:first-child{
    margin-top: 8.5rem;
  }

  .\\33xl\\:first\\:mr-34:first-child{
    margin-right: 8.5rem;
  }

  .\\33xl\\:first\\:mb-34:first-child{
    margin-bottom: 8.5rem;
  }

  .\\33xl\\:first\\:ml-34:first-child{
    margin-left: 8.5rem;
  }

  .\\33xl\\:first\\:mt-40:first-child{
    margin-top: 10rem;
  }

  .\\33xl\\:first\\:mr-40:first-child{
    margin-right: 10rem;
  }

  .\\33xl\\:first\\:mb-40:first-child{
    margin-bottom: 10rem;
  }

  .\\33xl\\:first\\:ml-40:first-child{
    margin-left: 10rem;
  }

  .\\33xl\\:first\\:mt-42:first-child{
    margin-top: 10.5rem;
  }

  .\\33xl\\:first\\:mr-42:first-child{
    margin-right: 10.5rem;
  }

  .\\33xl\\:first\\:mb-42:first-child{
    margin-bottom: 10.5rem;
  }

  .\\33xl\\:first\\:ml-42:first-child{
    margin-left: 10.5rem;
  }

  .\\33xl\\:first\\:mt-44:first-child{
    margin-top: 11rem;
  }

  .\\33xl\\:first\\:mr-44:first-child{
    margin-right: 11rem;
  }

  .\\33xl\\:first\\:mb-44:first-child{
    margin-bottom: 11rem;
  }

  .\\33xl\\:first\\:ml-44:first-child{
    margin-left: 11rem;
  }

  .\\33xl\\:first\\:mt-48:first-child{
    margin-top: 12rem;
  }

  .\\33xl\\:first\\:mr-48:first-child{
    margin-right: 12rem;
  }

  .\\33xl\\:first\\:mb-48:first-child{
    margin-bottom: 12rem;
  }

  .\\33xl\\:first\\:ml-48:first-child{
    margin-left: 12rem;
  }

  .\\33xl\\:first\\:mt-52:first-child{
    margin-top: 13rem;
  }

  .\\33xl\\:first\\:mr-52:first-child{
    margin-right: 13rem;
  }

  .\\33xl\\:first\\:mb-52:first-child{
    margin-bottom: 13rem;
  }

  .\\33xl\\:first\\:ml-52:first-child{
    margin-left: 13rem;
  }

  .\\33xl\\:first\\:mt-54:first-child{
    margin-top: 13.5rem;
  }

  .\\33xl\\:first\\:mr-54:first-child{
    margin-right: 13.5rem;
  }

  .\\33xl\\:first\\:mb-54:first-child{
    margin-bottom: 13.5rem;
  }

  .\\33xl\\:first\\:ml-54:first-child{
    margin-left: 13.5rem;
  }

  .\\33xl\\:first\\:mt-56:first-child{
    margin-top: 14rem;
  }

  .\\33xl\\:first\\:mr-56:first-child{
    margin-right: 14rem;
  }

  .\\33xl\\:first\\:mb-56:first-child{
    margin-bottom: 14rem;
  }

  .\\33xl\\:first\\:ml-56:first-child{
    margin-left: 14rem;
  }

  .\\33xl\\:first\\:mt-60:first-child{
    margin-top: 15rem;
  }

  .\\33xl\\:first\\:mr-60:first-child{
    margin-right: 15rem;
  }

  .\\33xl\\:first\\:mb-60:first-child{
    margin-bottom: 15rem;
  }

  .\\33xl\\:first\\:ml-60:first-child{
    margin-left: 15rem;
  }

  .\\33xl\\:first\\:mt-64:first-child{
    margin-top: 16rem;
  }

  .\\33xl\\:first\\:mr-64:first-child{
    margin-right: 16rem;
  }

  .\\33xl\\:first\\:mb-64:first-child{
    margin-bottom: 16rem;
  }

  .\\33xl\\:first\\:ml-64:first-child{
    margin-left: 16rem;
  }

  .\\33xl\\:first\\:mt-68:first-child{
    margin-top: 17rem;
  }

  .\\33xl\\:first\\:mr-68:first-child{
    margin-right: 17rem;
  }

  .\\33xl\\:first\\:mb-68:first-child{
    margin-bottom: 17rem;
  }

  .\\33xl\\:first\\:ml-68:first-child{
    margin-left: 17rem;
  }

  .\\33xl\\:first\\:mt-72:first-child{
    margin-top: 18rem;
  }

  .\\33xl\\:first\\:mr-72:first-child{
    margin-right: 18rem;
  }

  .\\33xl\\:first\\:mb-72:first-child{
    margin-bottom: 18rem;
  }

  .\\33xl\\:first\\:ml-72:first-child{
    margin-left: 18rem;
  }

  .\\33xl\\:first\\:mt-74:first-child{
    margin-top: 18.5rem;
  }

  .\\33xl\\:first\\:mr-74:first-child{
    margin-right: 18.5rem;
  }

  .\\33xl\\:first\\:mb-74:first-child{
    margin-bottom: 18.5rem;
  }

  .\\33xl\\:first\\:ml-74:first-child{
    margin-left: 18.5rem;
  }

  .\\33xl\\:first\\:mt-76:first-child{
    margin-top: 19rem;
  }

  .\\33xl\\:first\\:mr-76:first-child{
    margin-right: 19rem;
  }

  .\\33xl\\:first\\:mb-76:first-child{
    margin-bottom: 19rem;
  }

  .\\33xl\\:first\\:ml-76:first-child{
    margin-left: 19rem;
  }

  .\\33xl\\:first\\:mt-78:first-child{
    margin-top: 19.5rem;
  }

  .\\33xl\\:first\\:mr-78:first-child{
    margin-right: 19.5rem;
  }

  .\\33xl\\:first\\:mb-78:first-child{
    margin-bottom: 19.5rem;
  }

  .\\33xl\\:first\\:ml-78:first-child{
    margin-left: 19.5rem;
  }

  .\\33xl\\:first\\:mt-80:first-child{
    margin-top: 20rem;
  }

  .\\33xl\\:first\\:mr-80:first-child{
    margin-right: 20rem;
  }

  .\\33xl\\:first\\:mb-80:first-child{
    margin-bottom: 20rem;
  }

  .\\33xl\\:first\\:ml-80:first-child{
    margin-left: 20rem;
  }

  .\\33xl\\:first\\:mt-82:first-child{
    margin-top: 20.5rem;
  }

  .\\33xl\\:first\\:mr-82:first-child{
    margin-right: 20.5rem;
  }

  .\\33xl\\:first\\:mb-82:first-child{
    margin-bottom: 20.5rem;
  }

  .\\33xl\\:first\\:ml-82:first-child{
    margin-left: 20.5rem;
  }

  .\\33xl\\:first\\:mt-84:first-child{
    margin-top: 21rem;
  }

  .\\33xl\\:first\\:mr-84:first-child{
    margin-right: 21rem;
  }

  .\\33xl\\:first\\:mb-84:first-child{
    margin-bottom: 21rem;
  }

  .\\33xl\\:first\\:ml-84:first-child{
    margin-left: 21rem;
  }

  .\\33xl\\:first\\:mt-88:first-child{
    margin-top: 22rem;
  }

  .\\33xl\\:first\\:mr-88:first-child{
    margin-right: 22rem;
  }

  .\\33xl\\:first\\:mb-88:first-child{
    margin-bottom: 22rem;
  }

  .\\33xl\\:first\\:ml-88:first-child{
    margin-left: 22rem;
  }

  .\\33xl\\:first\\:mt-92:first-child{
    margin-top: 23rem;
  }

  .\\33xl\\:first\\:mr-92:first-child{
    margin-right: 23rem;
  }

  .\\33xl\\:first\\:mb-92:first-child{
    margin-bottom: 23rem;
  }

  .\\33xl\\:first\\:ml-92:first-child{
    margin-left: 23rem;
  }

  .\\33xl\\:first\\:mt-96:first-child{
    margin-top: 24rem;
  }

  .\\33xl\\:first\\:mr-96:first-child{
    margin-right: 24rem;
  }

  .\\33xl\\:first\\:mb-96:first-child{
    margin-bottom: 24rem;
  }

  .\\33xl\\:first\\:ml-96:first-child{
    margin-left: 24rem;
  }

  .\\33xl\\:first\\:mt-98:first-child{
    margin-top: 24.5rem;
  }

  .\\33xl\\:first\\:mr-98:first-child{
    margin-right: 24.5rem;
  }

  .\\33xl\\:first\\:mb-98:first-child{
    margin-bottom: 24.5rem;
  }

  .\\33xl\\:first\\:ml-98:first-child{
    margin-left: 24.5rem;
  }

  .\\33xl\\:first\\:mt-100:first-child{
    margin-top: 25rem;
  }

  .\\33xl\\:first\\:mr-100:first-child{
    margin-right: 25rem;
  }

  .\\33xl\\:first\\:mb-100:first-child{
    margin-bottom: 25rem;
  }

  .\\33xl\\:first\\:ml-100:first-child{
    margin-left: 25rem;
  }

  .\\33xl\\:first\\:mt-104:first-child{
    margin-top: 26rem;
  }

  .\\33xl\\:first\\:mr-104:first-child{
    margin-right: 26rem;
  }

  .\\33xl\\:first\\:mb-104:first-child{
    margin-bottom: 26rem;
  }

  .\\33xl\\:first\\:ml-104:first-child{
    margin-left: 26rem;
  }

  .\\33xl\\:first\\:mt-112:first-child{
    margin-top: 28rem;
  }

  .\\33xl\\:first\\:mr-112:first-child{
    margin-right: 28rem;
  }

  .\\33xl\\:first\\:mb-112:first-child{
    margin-bottom: 28rem;
  }

  .\\33xl\\:first\\:ml-112:first-child{
    margin-left: 28rem;
  }

  .\\33xl\\:first\\:mt-124:first-child{
    margin-top: 31rem;
  }

  .\\33xl\\:first\\:mr-124:first-child{
    margin-right: 31rem;
  }

  .\\33xl\\:first\\:mb-124:first-child{
    margin-bottom: 31rem;
  }

  .\\33xl\\:first\\:ml-124:first-child{
    margin-left: 31rem;
  }

  .\\33xl\\:first\\:mt-128:first-child{
    margin-top: 32rem;
  }

  .\\33xl\\:first\\:mr-128:first-child{
    margin-right: 32rem;
  }

  .\\33xl\\:first\\:mb-128:first-child{
    margin-bottom: 32rem;
  }

  .\\33xl\\:first\\:ml-128:first-child{
    margin-left: 32rem;
  }

  .\\33xl\\:first\\:mt-140:first-child{
    margin-top: 35rem;
  }

  .\\33xl\\:first\\:mr-140:first-child{
    margin-right: 35rem;
  }

  .\\33xl\\:first\\:mb-140:first-child{
    margin-bottom: 35rem;
  }

  .\\33xl\\:first\\:ml-140:first-child{
    margin-left: 35rem;
  }

  .\\33xl\\:first\\:mt-152:first-child{
    margin-top: 38rem;
  }

  .\\33xl\\:first\\:mr-152:first-child{
    margin-right: 38rem;
  }

  .\\33xl\\:first\\:mb-152:first-child{
    margin-bottom: 38rem;
  }

  .\\33xl\\:first\\:ml-152:first-child{
    margin-left: 38rem;
  }

  .\\33xl\\:first\\:mt-160:first-child{
    margin-top: 40rem;
  }

  .\\33xl\\:first\\:mr-160:first-child{
    margin-right: 40rem;
  }

  .\\33xl\\:first\\:mb-160:first-child{
    margin-bottom: 40rem;
  }

  .\\33xl\\:first\\:ml-160:first-child{
    margin-left: 40rem;
  }

  .\\33xl\\:first\\:mt-162:first-child{
    margin-top: 41rem;
  }

  .\\33xl\\:first\\:mr-162:first-child{
    margin-right: 41rem;
  }

  .\\33xl\\:first\\:mb-162:first-child{
    margin-bottom: 41rem;
  }

  .\\33xl\\:first\\:ml-162:first-child{
    margin-left: 41rem;
  }

  .\\33xl\\:first\\:mt-192:first-child{
    margin-top: 48rem;
  }

  .\\33xl\\:first\\:mr-192:first-child{
    margin-right: 48rem;
  }

  .\\33xl\\:first\\:mb-192:first-child{
    margin-bottom: 48rem;
  }

  .\\33xl\\:first\\:ml-192:first-child{
    margin-left: 48rem;
  }

  .\\33xl\\:first\\:mt-208:first-child{
    margin-top: 52rem;
  }

  .\\33xl\\:first\\:mr-208:first-child{
    margin-right: 52rem;
  }

  .\\33xl\\:first\\:mb-208:first-child{
    margin-bottom: 52rem;
  }

  .\\33xl\\:first\\:ml-208:first-child{
    margin-left: 52rem;
  }

  .\\33xl\\:first\\:mt-224:first-child{
    margin-top: 56rem;
  }

  .\\33xl\\:first\\:mr-224:first-child{
    margin-right: 56rem;
  }

  .\\33xl\\:first\\:mb-224:first-child{
    margin-bottom: 56rem;
  }

  .\\33xl\\:first\\:ml-224:first-child{
    margin-left: 56rem;
  }

  .\\33xl\\:first\\:mt-256:first-child{
    margin-top: 64rem;
  }

  .\\33xl\\:first\\:mr-256:first-child{
    margin-right: 64rem;
  }

  .\\33xl\\:first\\:mb-256:first-child{
    margin-bottom: 64rem;
  }

  .\\33xl\\:first\\:ml-256:first-child{
    margin-left: 64rem;
  }

  .\\33xl\\:first\\:mt-auto:first-child{
    margin-top: auto;
  }

  .\\33xl\\:first\\:mr-auto:first-child{
    margin-right: auto;
  }

  .\\33xl\\:first\\:mb-auto:first-child{
    margin-bottom: auto;
  }

  .\\33xl\\:first\\:ml-auto:first-child{
    margin-left: auto;
  }

  .\\33xl\\:first\\:mt-px:first-child{
    margin-top: 1px;
  }

  .\\33xl\\:first\\:mr-px:first-child{
    margin-right: 1px;
  }

  .\\33xl\\:first\\:mb-px:first-child{
    margin-bottom: 1px;
  }

  .\\33xl\\:first\\:ml-px:first-child{
    margin-left: 1px;
  }

  .\\33xl\\:first\\:-mt-1:first-child{
    margin-top: -0.25rem;
  }

  .\\33xl\\:first\\:-mr-1:first-child{
    margin-right: -0.25rem;
  }

  .\\33xl\\:first\\:-mb-1:first-child{
    margin-bottom: -0.25rem;
  }

  .\\33xl\\:first\\:-ml-1:first-child{
    margin-left: -0.25rem;
  }

  .\\33xl\\:first\\:-mt-2:first-child{
    margin-top: -0.5rem;
  }

  .\\33xl\\:first\\:-mr-2:first-child{
    margin-right: -0.5rem;
  }

  .\\33xl\\:first\\:-mb-2:first-child{
    margin-bottom: -0.5rem;
  }

  .\\33xl\\:first\\:-ml-2:first-child{
    margin-left: -0.5rem;
  }

  .\\33xl\\:first\\:-mt-3:first-child{
    margin-top: -0.75rem;
  }

  .\\33xl\\:first\\:-mr-3:first-child{
    margin-right: -0.75rem;
  }

  .\\33xl\\:first\\:-mb-3:first-child{
    margin-bottom: -0.75rem;
  }

  .\\33xl\\:first\\:-ml-3:first-child{
    margin-left: -0.75rem;
  }

  .\\33xl\\:first\\:-mt-4:first-child{
    margin-top: -1rem;
  }

  .\\33xl\\:first\\:-mr-4:first-child{
    margin-right: -1rem;
  }

  .\\33xl\\:first\\:-mb-4:first-child{
    margin-bottom: -1rem;
  }

  .\\33xl\\:first\\:-ml-4:first-child{
    margin-left: -1rem;
  }

  .\\33xl\\:first\\:-mt-5:first-child{
    margin-top: -1.25rem;
  }

  .\\33xl\\:first\\:-mr-5:first-child{
    margin-right: -1.25rem;
  }

  .\\33xl\\:first\\:-mb-5:first-child{
    margin-bottom: -1.25rem;
  }

  .\\33xl\\:first\\:-ml-5:first-child{
    margin-left: -1.25rem;
  }

  .\\33xl\\:first\\:-mt-6:first-child{
    margin-top: -1.5rem;
  }

  .\\33xl\\:first\\:-mr-6:first-child{
    margin-right: -1.5rem;
  }

  .\\33xl\\:first\\:-mb-6:first-child{
    margin-bottom: -1.5rem;
  }

  .\\33xl\\:first\\:-ml-6:first-child{
    margin-left: -1.5rem;
  }

  .\\33xl\\:first\\:-mt-7:first-child{
    margin-top: -1.75rem;
  }

  .\\33xl\\:first\\:-mr-7:first-child{
    margin-right: -1.75rem;
  }

  .\\33xl\\:first\\:-mb-7:first-child{
    margin-bottom: -1.75rem;
  }

  .\\33xl\\:first\\:-ml-7:first-child{
    margin-left: -1.75rem;
  }

  .\\33xl\\:first\\:-mt-8:first-child{
    margin-top: -2rem;
  }

  .\\33xl\\:first\\:-mr-8:first-child{
    margin-right: -2rem;
  }

  .\\33xl\\:first\\:-mb-8:first-child{
    margin-bottom: -2rem;
  }

  .\\33xl\\:first\\:-ml-8:first-child{
    margin-left: -2rem;
  }

  .\\33xl\\:first\\:-mt-9:first-child{
    margin-top: -2.25rem;
  }

  .\\33xl\\:first\\:-mr-9:first-child{
    margin-right: -2.25rem;
  }

  .\\33xl\\:first\\:-mb-9:first-child{
    margin-bottom: -2.25rem;
  }

  .\\33xl\\:first\\:-ml-9:first-child{
    margin-left: -2.25rem;
  }

  .\\33xl\\:first\\:-mt-10:first-child{
    margin-top: -2.5rem;
  }

  .\\33xl\\:first\\:-mr-10:first-child{
    margin-right: -2.5rem;
  }

  .\\33xl\\:first\\:-mb-10:first-child{
    margin-bottom: -2.5rem;
  }

  .\\33xl\\:first\\:-ml-10:first-child{
    margin-left: -2.5rem;
  }

  .\\33xl\\:first\\:-mt-11:first-child{
    margin-top: -2.75rem;
  }

  .\\33xl\\:first\\:-mr-11:first-child{
    margin-right: -2.75rem;
  }

  .\\33xl\\:first\\:-mb-11:first-child{
    margin-bottom: -2.75rem;
  }

  .\\33xl\\:first\\:-ml-11:first-child{
    margin-left: -2.75rem;
  }

  .\\33xl\\:first\\:-mt-12:first-child{
    margin-top: -3rem;
  }

  .\\33xl\\:first\\:-mr-12:first-child{
    margin-right: -3rem;
  }

  .\\33xl\\:first\\:-mb-12:first-child{
    margin-bottom: -3rem;
  }

  .\\33xl\\:first\\:-ml-12:first-child{
    margin-left: -3rem;
  }

  .\\33xl\\:first\\:-mt-14:first-child{
    margin-top: -3.5rem;
  }

  .\\33xl\\:first\\:-mr-14:first-child{
    margin-right: -3.5rem;
  }

  .\\33xl\\:first\\:-mb-14:first-child{
    margin-bottom: -3.5rem;
  }

  .\\33xl\\:first\\:-ml-14:first-child{
    margin-left: -3.5rem;
  }

  .\\33xl\\:first\\:-mt-15:first-child{
    margin-top: -3.75rem;
  }

  .\\33xl\\:first\\:-mr-15:first-child{
    margin-right: -3.75rem;
  }

  .\\33xl\\:first\\:-mb-15:first-child{
    margin-bottom: -3.75rem;
  }

  .\\33xl\\:first\\:-ml-15:first-child{
    margin-left: -3.75rem;
  }

  .\\33xl\\:first\\:-mt-16:first-child{
    margin-top: -4rem;
  }

  .\\33xl\\:first\\:-mr-16:first-child{
    margin-right: -4rem;
  }

  .\\33xl\\:first\\:-mb-16:first-child{
    margin-bottom: -4rem;
  }

  .\\33xl\\:first\\:-ml-16:first-child{
    margin-left: -4rem;
  }

  .\\33xl\\:first\\:-mt-18:first-child{
    margin-top: -4.5rem;
  }

  .\\33xl\\:first\\:-mr-18:first-child{
    margin-right: -4.5rem;
  }

  .\\33xl\\:first\\:-mb-18:first-child{
    margin-bottom: -4.5rem;
  }

  .\\33xl\\:first\\:-ml-18:first-child{
    margin-left: -4.5rem;
  }

  .\\33xl\\:first\\:-mt-20:first-child{
    margin-top: -5rem;
  }

  .\\33xl\\:first\\:-mr-20:first-child{
    margin-right: -5rem;
  }

  .\\33xl\\:first\\:-mb-20:first-child{
    margin-bottom: -5rem;
  }

  .\\33xl\\:first\\:-ml-20:first-child{
    margin-left: -5rem;
  }

  .\\33xl\\:first\\:-mt-22:first-child{
    margin-top: -5.5rem;
  }

  .\\33xl\\:first\\:-mr-22:first-child{
    margin-right: -5.5rem;
  }

  .\\33xl\\:first\\:-mb-22:first-child{
    margin-bottom: -5.5rem;
  }

  .\\33xl\\:first\\:-ml-22:first-child{
    margin-left: -5.5rem;
  }

  .\\33xl\\:first\\:-mt-23:first-child{
    margin-top: -5.75rem;
  }

  .\\33xl\\:first\\:-mr-23:first-child{
    margin-right: -5.75rem;
  }

  .\\33xl\\:first\\:-mb-23:first-child{
    margin-bottom: -5.75rem;
  }

  .\\33xl\\:first\\:-ml-23:first-child{
    margin-left: -5.75rem;
  }

  .\\33xl\\:first\\:-mt-24:first-child{
    margin-top: -6rem;
  }

  .\\33xl\\:first\\:-mr-24:first-child{
    margin-right: -6rem;
  }

  .\\33xl\\:first\\:-mb-24:first-child{
    margin-bottom: -6rem;
  }

  .\\33xl\\:first\\:-ml-24:first-child{
    margin-left: -6rem;
  }

  .\\33xl\\:first\\:-mt-25:first-child{
    margin-top: -6.25rem;
  }

  .\\33xl\\:first\\:-mr-25:first-child{
    margin-right: -6.25rem;
  }

  .\\33xl\\:first\\:-mb-25:first-child{
    margin-bottom: -6.25rem;
  }

  .\\33xl\\:first\\:-ml-25:first-child{
    margin-left: -6.25rem;
  }

  .\\33xl\\:first\\:-mt-26:first-child{
    margin-top: -6.5rem;
  }

  .\\33xl\\:first\\:-mr-26:first-child{
    margin-right: -6.5rem;
  }

  .\\33xl\\:first\\:-mb-26:first-child{
    margin-bottom: -6.5rem;
  }

  .\\33xl\\:first\\:-ml-26:first-child{
    margin-left: -6.5rem;
  }

  .\\33xl\\:first\\:-mt-28:first-child{
    margin-top: -7rem;
  }

  .\\33xl\\:first\\:-mr-28:first-child{
    margin-right: -7rem;
  }

  .\\33xl\\:first\\:-mb-28:first-child{
    margin-bottom: -7rem;
  }

  .\\33xl\\:first\\:-ml-28:first-child{
    margin-left: -7rem;
  }

  .\\33xl\\:first\\:-mt-30:first-child{
    margin-top: -7.5rem;
  }

  .\\33xl\\:first\\:-mr-30:first-child{
    margin-right: -7.5rem;
  }

  .\\33xl\\:first\\:-mb-30:first-child{
    margin-bottom: -7.5rem;
  }

  .\\33xl\\:first\\:-ml-30:first-child{
    margin-left: -7.5rem;
  }

  .\\33xl\\:first\\:-mt-32:first-child{
    margin-top: -8rem;
  }

  .\\33xl\\:first\\:-mr-32:first-child{
    margin-right: -8rem;
  }

  .\\33xl\\:first\\:-mb-32:first-child{
    margin-bottom: -8rem;
  }

  .\\33xl\\:first\\:-ml-32:first-child{
    margin-left: -8rem;
  }

  .\\33xl\\:first\\:-mt-34:first-child{
    margin-top: -8.5rem;
  }

  .\\33xl\\:first\\:-mr-34:first-child{
    margin-right: -8.5rem;
  }

  .\\33xl\\:first\\:-mb-34:first-child{
    margin-bottom: -8.5rem;
  }

  .\\33xl\\:first\\:-ml-34:first-child{
    margin-left: -8.5rem;
  }

  .\\33xl\\:first\\:-mt-40:first-child{
    margin-top: -10rem;
  }

  .\\33xl\\:first\\:-mr-40:first-child{
    margin-right: -10rem;
  }

  .\\33xl\\:first\\:-mb-40:first-child{
    margin-bottom: -10rem;
  }

  .\\33xl\\:first\\:-ml-40:first-child{
    margin-left: -10rem;
  }

  .\\33xl\\:first\\:-mt-42:first-child{
    margin-top: -10.5rem;
  }

  .\\33xl\\:first\\:-mr-42:first-child{
    margin-right: -10.5rem;
  }

  .\\33xl\\:first\\:-mb-42:first-child{
    margin-bottom: -10.5rem;
  }

  .\\33xl\\:first\\:-ml-42:first-child{
    margin-left: -10.5rem;
  }

  .\\33xl\\:first\\:-mt-44:first-child{
    margin-top: -11rem;
  }

  .\\33xl\\:first\\:-mr-44:first-child{
    margin-right: -11rem;
  }

  .\\33xl\\:first\\:-mb-44:first-child{
    margin-bottom: -11rem;
  }

  .\\33xl\\:first\\:-ml-44:first-child{
    margin-left: -11rem;
  }

  .\\33xl\\:first\\:-mt-48:first-child{
    margin-top: -12rem;
  }

  .\\33xl\\:first\\:-mr-48:first-child{
    margin-right: -12rem;
  }

  .\\33xl\\:first\\:-mb-48:first-child{
    margin-bottom: -12rem;
  }

  .\\33xl\\:first\\:-ml-48:first-child{
    margin-left: -12rem;
  }

  .\\33xl\\:first\\:-mt-52:first-child{
    margin-top: -13rem;
  }

  .\\33xl\\:first\\:-mr-52:first-child{
    margin-right: -13rem;
  }

  .\\33xl\\:first\\:-mb-52:first-child{
    margin-bottom: -13rem;
  }

  .\\33xl\\:first\\:-ml-52:first-child{
    margin-left: -13rem;
  }

  .\\33xl\\:first\\:-mt-54:first-child{
    margin-top: -13.5rem;
  }

  .\\33xl\\:first\\:-mr-54:first-child{
    margin-right: -13.5rem;
  }

  .\\33xl\\:first\\:-mb-54:first-child{
    margin-bottom: -13.5rem;
  }

  .\\33xl\\:first\\:-ml-54:first-child{
    margin-left: -13.5rem;
  }

  .\\33xl\\:first\\:-mt-56:first-child{
    margin-top: -14rem;
  }

  .\\33xl\\:first\\:-mr-56:first-child{
    margin-right: -14rem;
  }

  .\\33xl\\:first\\:-mb-56:first-child{
    margin-bottom: -14rem;
  }

  .\\33xl\\:first\\:-ml-56:first-child{
    margin-left: -14rem;
  }

  .\\33xl\\:first\\:-mt-60:first-child{
    margin-top: -15rem;
  }

  .\\33xl\\:first\\:-mr-60:first-child{
    margin-right: -15rem;
  }

  .\\33xl\\:first\\:-mb-60:first-child{
    margin-bottom: -15rem;
  }

  .\\33xl\\:first\\:-ml-60:first-child{
    margin-left: -15rem;
  }

  .\\33xl\\:first\\:-mt-64:first-child{
    margin-top: -16rem;
  }

  .\\33xl\\:first\\:-mr-64:first-child{
    margin-right: -16rem;
  }

  .\\33xl\\:first\\:-mb-64:first-child{
    margin-bottom: -16rem;
  }

  .\\33xl\\:first\\:-ml-64:first-child{
    margin-left: -16rem;
  }

  .\\33xl\\:first\\:-mt-68:first-child{
    margin-top: -17rem;
  }

  .\\33xl\\:first\\:-mr-68:first-child{
    margin-right: -17rem;
  }

  .\\33xl\\:first\\:-mb-68:first-child{
    margin-bottom: -17rem;
  }

  .\\33xl\\:first\\:-ml-68:first-child{
    margin-left: -17rem;
  }

  .\\33xl\\:first\\:-mt-72:first-child{
    margin-top: -18rem;
  }

  .\\33xl\\:first\\:-mr-72:first-child{
    margin-right: -18rem;
  }

  .\\33xl\\:first\\:-mb-72:first-child{
    margin-bottom: -18rem;
  }

  .\\33xl\\:first\\:-ml-72:first-child{
    margin-left: -18rem;
  }

  .\\33xl\\:first\\:-mt-74:first-child{
    margin-top: -18.5rem;
  }

  .\\33xl\\:first\\:-mr-74:first-child{
    margin-right: -18.5rem;
  }

  .\\33xl\\:first\\:-mb-74:first-child{
    margin-bottom: -18.5rem;
  }

  .\\33xl\\:first\\:-ml-74:first-child{
    margin-left: -18.5rem;
  }

  .\\33xl\\:first\\:-mt-76:first-child{
    margin-top: -19rem;
  }

  .\\33xl\\:first\\:-mr-76:first-child{
    margin-right: -19rem;
  }

  .\\33xl\\:first\\:-mb-76:first-child{
    margin-bottom: -19rem;
  }

  .\\33xl\\:first\\:-ml-76:first-child{
    margin-left: -19rem;
  }

  .\\33xl\\:first\\:-mt-78:first-child{
    margin-top: -19.5rem;
  }

  .\\33xl\\:first\\:-mr-78:first-child{
    margin-right: -19.5rem;
  }

  .\\33xl\\:first\\:-mb-78:first-child{
    margin-bottom: -19.5rem;
  }

  .\\33xl\\:first\\:-ml-78:first-child{
    margin-left: -19.5rem;
  }

  .\\33xl\\:first\\:-mt-80:first-child{
    margin-top: -20rem;
  }

  .\\33xl\\:first\\:-mr-80:first-child{
    margin-right: -20rem;
  }

  .\\33xl\\:first\\:-mb-80:first-child{
    margin-bottom: -20rem;
  }

  .\\33xl\\:first\\:-ml-80:first-child{
    margin-left: -20rem;
  }

  .\\33xl\\:first\\:-mt-82:first-child{
    margin-top: -20.5rem;
  }

  .\\33xl\\:first\\:-mr-82:first-child{
    margin-right: -20.5rem;
  }

  .\\33xl\\:first\\:-mb-82:first-child{
    margin-bottom: -20.5rem;
  }

  .\\33xl\\:first\\:-ml-82:first-child{
    margin-left: -20.5rem;
  }

  .\\33xl\\:first\\:-mt-84:first-child{
    margin-top: -21rem;
  }

  .\\33xl\\:first\\:-mr-84:first-child{
    margin-right: -21rem;
  }

  .\\33xl\\:first\\:-mb-84:first-child{
    margin-bottom: -21rem;
  }

  .\\33xl\\:first\\:-ml-84:first-child{
    margin-left: -21rem;
  }

  .\\33xl\\:first\\:-mt-88:first-child{
    margin-top: -22rem;
  }

  .\\33xl\\:first\\:-mr-88:first-child{
    margin-right: -22rem;
  }

  .\\33xl\\:first\\:-mb-88:first-child{
    margin-bottom: -22rem;
  }

  .\\33xl\\:first\\:-ml-88:first-child{
    margin-left: -22rem;
  }

  .\\33xl\\:first\\:-mt-92:first-child{
    margin-top: -23rem;
  }

  .\\33xl\\:first\\:-mr-92:first-child{
    margin-right: -23rem;
  }

  .\\33xl\\:first\\:-mb-92:first-child{
    margin-bottom: -23rem;
  }

  .\\33xl\\:first\\:-ml-92:first-child{
    margin-left: -23rem;
  }

  .\\33xl\\:first\\:-mt-96:first-child{
    margin-top: -24rem;
  }

  .\\33xl\\:first\\:-mr-96:first-child{
    margin-right: -24rem;
  }

  .\\33xl\\:first\\:-mb-96:first-child{
    margin-bottom: -24rem;
  }

  .\\33xl\\:first\\:-ml-96:first-child{
    margin-left: -24rem;
  }

  .\\33xl\\:first\\:-mt-98:first-child{
    margin-top: -24.5rem;
  }

  .\\33xl\\:first\\:-mr-98:first-child{
    margin-right: -24.5rem;
  }

  .\\33xl\\:first\\:-mb-98:first-child{
    margin-bottom: -24.5rem;
  }

  .\\33xl\\:first\\:-ml-98:first-child{
    margin-left: -24.5rem;
  }

  .\\33xl\\:first\\:-mt-100:first-child{
    margin-top: -25rem;
  }

  .\\33xl\\:first\\:-mr-100:first-child{
    margin-right: -25rem;
  }

  .\\33xl\\:first\\:-mb-100:first-child{
    margin-bottom: -25rem;
  }

  .\\33xl\\:first\\:-ml-100:first-child{
    margin-left: -25rem;
  }

  .\\33xl\\:first\\:-mt-104:first-child{
    margin-top: -26rem;
  }

  .\\33xl\\:first\\:-mr-104:first-child{
    margin-right: -26rem;
  }

  .\\33xl\\:first\\:-mb-104:first-child{
    margin-bottom: -26rem;
  }

  .\\33xl\\:first\\:-ml-104:first-child{
    margin-left: -26rem;
  }

  .\\33xl\\:first\\:-mt-112:first-child{
    margin-top: -28rem;
  }

  .\\33xl\\:first\\:-mr-112:first-child{
    margin-right: -28rem;
  }

  .\\33xl\\:first\\:-mb-112:first-child{
    margin-bottom: -28rem;
  }

  .\\33xl\\:first\\:-ml-112:first-child{
    margin-left: -28rem;
  }

  .\\33xl\\:first\\:-mt-124:first-child{
    margin-top: -31rem;
  }

  .\\33xl\\:first\\:-mr-124:first-child{
    margin-right: -31rem;
  }

  .\\33xl\\:first\\:-mb-124:first-child{
    margin-bottom: -31rem;
  }

  .\\33xl\\:first\\:-ml-124:first-child{
    margin-left: -31rem;
  }

  .\\33xl\\:first\\:-mt-128:first-child{
    margin-top: -32rem;
  }

  .\\33xl\\:first\\:-mr-128:first-child{
    margin-right: -32rem;
  }

  .\\33xl\\:first\\:-mb-128:first-child{
    margin-bottom: -32rem;
  }

  .\\33xl\\:first\\:-ml-128:first-child{
    margin-left: -32rem;
  }

  .\\33xl\\:first\\:-mt-140:first-child{
    margin-top: -35rem;
  }

  .\\33xl\\:first\\:-mr-140:first-child{
    margin-right: -35rem;
  }

  .\\33xl\\:first\\:-mb-140:first-child{
    margin-bottom: -35rem;
  }

  .\\33xl\\:first\\:-ml-140:first-child{
    margin-left: -35rem;
  }

  .\\33xl\\:first\\:-mt-152:first-child{
    margin-top: -38rem;
  }

  .\\33xl\\:first\\:-mr-152:first-child{
    margin-right: -38rem;
  }

  .\\33xl\\:first\\:-mb-152:first-child{
    margin-bottom: -38rem;
  }

  .\\33xl\\:first\\:-ml-152:first-child{
    margin-left: -38rem;
  }

  .\\33xl\\:first\\:-mt-160:first-child{
    margin-top: -40rem;
  }

  .\\33xl\\:first\\:-mr-160:first-child{
    margin-right: -40rem;
  }

  .\\33xl\\:first\\:-mb-160:first-child{
    margin-bottom: -40rem;
  }

  .\\33xl\\:first\\:-ml-160:first-child{
    margin-left: -40rem;
  }

  .\\33xl\\:first\\:-mt-162:first-child{
    margin-top: -41rem;
  }

  .\\33xl\\:first\\:-mr-162:first-child{
    margin-right: -41rem;
  }

  .\\33xl\\:first\\:-mb-162:first-child{
    margin-bottom: -41rem;
  }

  .\\33xl\\:first\\:-ml-162:first-child{
    margin-left: -41rem;
  }

  .\\33xl\\:first\\:-mt-192:first-child{
    margin-top: -48rem;
  }

  .\\33xl\\:first\\:-mr-192:first-child{
    margin-right: -48rem;
  }

  .\\33xl\\:first\\:-mb-192:first-child{
    margin-bottom: -48rem;
  }

  .\\33xl\\:first\\:-ml-192:first-child{
    margin-left: -48rem;
  }

  .\\33xl\\:first\\:-mt-208:first-child{
    margin-top: -52rem;
  }

  .\\33xl\\:first\\:-mr-208:first-child{
    margin-right: -52rem;
  }

  .\\33xl\\:first\\:-mb-208:first-child{
    margin-bottom: -52rem;
  }

  .\\33xl\\:first\\:-ml-208:first-child{
    margin-left: -52rem;
  }

  .\\33xl\\:first\\:-mt-224:first-child{
    margin-top: -56rem;
  }

  .\\33xl\\:first\\:-mr-224:first-child{
    margin-right: -56rem;
  }

  .\\33xl\\:first\\:-mb-224:first-child{
    margin-bottom: -56rem;
  }

  .\\33xl\\:first\\:-ml-224:first-child{
    margin-left: -56rem;
  }

  .\\33xl\\:first\\:-mt-256:first-child{
    margin-top: -64rem;
  }

  .\\33xl\\:first\\:-mr-256:first-child{
    margin-right: -64rem;
  }

  .\\33xl\\:first\\:-mb-256:first-child{
    margin-bottom: -64rem;
  }

  .\\33xl\\:first\\:-ml-256:first-child{
    margin-left: -64rem;
  }

  .\\33xl\\:first\\:-mt-px:first-child{
    margin-top: -1px;
  }

  .\\33xl\\:first\\:-mr-px:first-child{
    margin-right: -1px;
  }

  .\\33xl\\:first\\:-mb-px:first-child{
    margin-bottom: -1px;
  }

  .\\33xl\\:first\\:-ml-px:first-child{
    margin-left: -1px;
  }

  .\\33xl\\:max-h-0{
    max-height: 0;
  }

  .\\33xl\\:max-h-1{
    max-height: 0.25rem;
  }

  .\\33xl\\:max-h-2{
    max-height: 0.5rem;
  }

  .\\33xl\\:max-h-3{
    max-height: 0.75rem;
  }

  .\\33xl\\:max-h-4{
    max-height: 1rem;
  }

  .\\33xl\\:max-h-5{
    max-height: 1.25rem;
  }

  .\\33xl\\:max-h-6{
    max-height: 1.5rem;
  }

  .\\33xl\\:max-h-7{
    max-height: 1.75rem;
  }

  .\\33xl\\:max-h-8{
    max-height: 2rem;
  }

  .\\33xl\\:max-h-9{
    max-height: 2.25rem;
  }

  .\\33xl\\:max-h-10{
    max-height: 2.5rem;
  }

  .\\33xl\\:max-h-11{
    max-height: 2.75rem;
  }

  .\\33xl\\:max-h-12{
    max-height: 3rem;
  }

  .\\33xl\\:max-h-14{
    max-height: 3.5rem;
  }

  .\\33xl\\:max-h-15{
    max-height: 3.75rem;
  }

  .\\33xl\\:max-h-16{
    max-height: 4rem;
  }

  .\\33xl\\:max-h-18{
    max-height: 4.5rem;
  }

  .\\33xl\\:max-h-20{
    max-height: 5rem;
  }

  .\\33xl\\:max-h-22{
    max-height: 5.5rem;
  }

  .\\33xl\\:max-h-23{
    max-height: 5.75rem;
  }

  .\\33xl\\:max-h-24{
    max-height: 6rem;
  }

  .\\33xl\\:max-h-25{
    max-height: 6.25rem;
  }

  .\\33xl\\:max-h-26{
    max-height: 6.5rem;
  }

  .\\33xl\\:max-h-28{
    max-height: 7rem;
  }

  .\\33xl\\:max-h-30{
    max-height: 7.5rem;
  }

  .\\33xl\\:max-h-32{
    max-height: 8rem;
  }

  .\\33xl\\:max-h-34{
    max-height: 8.5rem;
  }

  .\\33xl\\:max-h-40{
    max-height: 10rem;
  }

  .\\33xl\\:max-h-42{
    max-height: 10.5rem;
  }

  .\\33xl\\:max-h-44{
    max-height: 11rem;
  }

  .\\33xl\\:max-h-48{
    max-height: 12rem;
  }

  .\\33xl\\:max-h-52{
    max-height: 13rem;
  }

  .\\33xl\\:max-h-54{
    max-height: 13.5rem;
  }

  .\\33xl\\:max-h-56{
    max-height: 14rem;
  }

  .\\33xl\\:max-h-60{
    max-height: 15rem;
  }

  .\\33xl\\:max-h-64{
    max-height: 16rem;
  }

  .\\33xl\\:max-h-68{
    max-height: 17rem;
  }

  .\\33xl\\:max-h-72{
    max-height: 18rem;
  }

  .\\33xl\\:max-h-74{
    max-height: 18.5rem;
  }

  .\\33xl\\:max-h-76{
    max-height: 19rem;
  }

  .\\33xl\\:max-h-78{
    max-height: 19.5rem;
  }

  .\\33xl\\:max-h-80{
    max-height: 20rem;
  }

  .\\33xl\\:max-h-82{
    max-height: 20.5rem;
  }

  .\\33xl\\:max-h-84{
    max-height: 21rem;
  }

  .\\33xl\\:max-h-88{
    max-height: 22rem;
  }

  .\\33xl\\:max-h-92{
    max-height: 23rem;
  }

  .\\33xl\\:max-h-96{
    max-height: 24rem;
  }

  .\\33xl\\:max-h-98{
    max-height: 24.5rem;
  }

  .\\33xl\\:max-h-100{
    max-height: 25rem;
  }

  .\\33xl\\:max-h-104{
    max-height: 26rem;
  }

  .\\33xl\\:max-h-112{
    max-height: 28rem;
  }

  .\\33xl\\:max-h-124{
    max-height: 31rem;
  }

  .\\33xl\\:max-h-128{
    max-height: 32rem;
  }

  .\\33xl\\:max-h-140{
    max-height: 35rem;
  }

  .\\33xl\\:max-h-152{
    max-height: 38rem;
  }

  .\\33xl\\:max-h-160{
    max-height: 40rem;
  }

  .\\33xl\\:max-h-162{
    max-height: 41rem;
  }

  .\\33xl\\:max-h-192{
    max-height: 48rem;
  }

  .\\33xl\\:max-h-208{
    max-height: 52rem;
  }

  .\\33xl\\:max-h-224{
    max-height: 56rem;
  }

  .\\33xl\\:max-h-256{
    max-height: 64rem;
  }

  .\\33xl\\:max-h-px{
    max-height: 1px;
  }

  .\\33xl\\:max-h-full{
    max-height: 100%;
  }

  .\\33xl\\:max-h-screen{
    max-height: 100vh;
  }

  .\\33xl\\:max-w-0{
    max-width: 0;
  }

  .\\33xl\\:max-w-1{
    max-width: 0.25rem;
  }

  .\\33xl\\:max-w-2{
    max-width: 0.5rem;
  }

  .\\33xl\\:max-w-3{
    max-width: 0.75rem;
  }

  .\\33xl\\:max-w-4{
    max-width: 1rem;
  }

  .\\33xl\\:max-w-5{
    max-width: 1.25rem;
  }

  .\\33xl\\:max-w-6{
    max-width: 1.5rem;
  }

  .\\33xl\\:max-w-7{
    max-width: 1.75rem;
  }

  .\\33xl\\:max-w-8{
    max-width: 2rem;
  }

  .\\33xl\\:max-w-9{
    max-width: 2.25rem;
  }

  .\\33xl\\:max-w-10{
    max-width: 2.5rem;
  }

  .\\33xl\\:max-w-11{
    max-width: 2.75rem;
  }

  .\\33xl\\:max-w-12{
    max-width: 3rem;
  }

  .\\33xl\\:max-w-14{
    max-width: 3.5rem;
  }

  .\\33xl\\:max-w-15{
    max-width: 3.75rem;
  }

  .\\33xl\\:max-w-16{
    max-width: 4rem;
  }

  .\\33xl\\:max-w-18{
    max-width: 4.5rem;
  }

  .\\33xl\\:max-w-20{
    max-width: 5rem;
  }

  .\\33xl\\:max-w-22{
    max-width: 5.5rem;
  }

  .\\33xl\\:max-w-23{
    max-width: 5.75rem;
  }

  .\\33xl\\:max-w-24{
    max-width: 6rem;
  }

  .\\33xl\\:max-w-25{
    max-width: 6.25rem;
  }

  .\\33xl\\:max-w-26{
    max-width: 6.5rem;
  }

  .\\33xl\\:max-w-28{
    max-width: 7rem;
  }

  .\\33xl\\:max-w-30{
    max-width: 7.5rem;
  }

  .\\33xl\\:max-w-32{
    max-width: 8rem;
  }

  .\\33xl\\:max-w-34{
    max-width: 8.5rem;
  }

  .\\33xl\\:max-w-40{
    max-width: 10rem;
  }

  .\\33xl\\:max-w-42{
    max-width: 10.5rem;
  }

  .\\33xl\\:max-w-44{
    max-width: 11rem;
  }

  .\\33xl\\:max-w-48{
    max-width: 12rem;
  }

  .\\33xl\\:max-w-52{
    max-width: 13rem;
  }

  .\\33xl\\:max-w-54{
    max-width: 13.5rem;
  }

  .\\33xl\\:max-w-56{
    max-width: 14rem;
  }

  .\\33xl\\:max-w-60{
    max-width: 15rem;
  }

  .\\33xl\\:max-w-64{
    max-width: 16rem;
  }

  .\\33xl\\:max-w-68{
    max-width: 17rem;
  }

  .\\33xl\\:max-w-72{
    max-width: 18rem;
  }

  .\\33xl\\:max-w-74{
    max-width: 18.5rem;
  }

  .\\33xl\\:max-w-76{
    max-width: 19rem;
  }

  .\\33xl\\:max-w-78{
    max-width: 19.5rem;
  }

  .\\33xl\\:max-w-80{
    max-width: 20rem;
  }

  .\\33xl\\:max-w-82{
    max-width: 20.5rem;
  }

  .\\33xl\\:max-w-84{
    max-width: 21rem;
  }

  .\\33xl\\:max-w-88{
    max-width: 22rem;
  }

  .\\33xl\\:max-w-92{
    max-width: 23rem;
  }

  .\\33xl\\:max-w-96{
    max-width: 24rem;
  }

  .\\33xl\\:max-w-98{
    max-width: 24.5rem;
  }

  .\\33xl\\:max-w-100{
    max-width: 25rem;
  }

  .\\33xl\\:max-w-104{
    max-width: 26rem;
  }

  .\\33xl\\:max-w-112{
    max-width: 28rem;
  }

  .\\33xl\\:max-w-124{
    max-width: 31rem;
  }

  .\\33xl\\:max-w-128{
    max-width: 32rem;
  }

  .\\33xl\\:max-w-140{
    max-width: 35rem;
  }

  .\\33xl\\:max-w-152{
    max-width: 38rem;
  }

  .\\33xl\\:max-w-160{
    max-width: 40rem;
  }

  .\\33xl\\:max-w-162{
    max-width: 41rem;
  }

  .\\33xl\\:max-w-192{
    max-width: 48rem;
  }

  .\\33xl\\:max-w-208{
    max-width: 52rem;
  }

  .\\33xl\\:max-w-224{
    max-width: 56rem;
  }

  .\\33xl\\:max-w-256{
    max-width: 64rem;
  }

  .\\33xl\\:max-w-none{
    max-width: none;
  }

  .\\33xl\\:max-w-xs{
    max-width: 20rem;
  }

  .\\33xl\\:max-w-sm{
    max-width: 24rem;
  }

  .\\33xl\\:max-w-md{
    max-width: 28rem;
  }

  .\\33xl\\:max-w-lg{
    max-width: 32rem;
  }

  .\\33xl\\:max-w-xl{
    max-width: 36rem;
  }

  .\\33xl\\:max-w-2xl{
    max-width: 42rem;
  }

  .\\33xl\\:max-w-3xl{
    max-width: 48rem;
  }

  .\\33xl\\:max-w-4xl{
    max-width: 56rem;
  }

  .\\33xl\\:max-w-5xl{
    max-width: 64rem;
  }

  .\\33xl\\:max-w-6xl{
    max-width: 76rem;
  }

  .\\33xl\\:max-w-7xl{
    max-width: 92rem;
  }

  .\\33xl\\:max-w-8xl{
    max-width: 112rem;
  }

  .\\33xl\\:max-w-9xl{
    max-width: 130rem;
  }

  .\\33xl\\:max-w-full{
    max-width: 100%;
  }

  .\\33xl\\:max-w-px{
    max-width: 1px;
  }

  .\\33xl\\:min-h-0{
    min-height: 0;
  }

  .\\33xl\\:min-h-1{
    min-height: 0.25rem;
  }

  .\\33xl\\:min-h-2{
    min-height: 0.5rem;
  }

  .\\33xl\\:min-h-3{
    min-height: 0.75rem;
  }

  .\\33xl\\:min-h-4{
    min-height: 1rem;
  }

  .\\33xl\\:min-h-5{
    min-height: 1.25rem;
  }

  .\\33xl\\:min-h-6{
    min-height: 1.5rem;
  }

  .\\33xl\\:min-h-7{
    min-height: 1.75rem;
  }

  .\\33xl\\:min-h-8{
    min-height: 2rem;
  }

  .\\33xl\\:min-h-9{
    min-height: 2.25rem;
  }

  .\\33xl\\:min-h-10{
    min-height: 2.5rem;
  }

  .\\33xl\\:min-h-11{
    min-height: 2.75rem;
  }

  .\\33xl\\:min-h-12{
    min-height: 3rem;
  }

  .\\33xl\\:min-h-14{
    min-height: 3.5rem;
  }

  .\\33xl\\:min-h-15{
    min-height: 3.75rem;
  }

  .\\33xl\\:min-h-16{
    min-height: 4rem;
  }

  .\\33xl\\:min-h-18{
    min-height: 4.5rem;
  }

  .\\33xl\\:min-h-20{
    min-height: 5rem;
  }

  .\\33xl\\:min-h-22{
    min-height: 5.5rem;
  }

  .\\33xl\\:min-h-23{
    min-height: 5.75rem;
  }

  .\\33xl\\:min-h-24{
    min-height: 6rem;
  }

  .\\33xl\\:min-h-25{
    min-height: 6.25rem;
  }

  .\\33xl\\:min-h-26{
    min-height: 6.5rem;
  }

  .\\33xl\\:min-h-28{
    min-height: 7rem;
  }

  .\\33xl\\:min-h-30{
    min-height: 7.5rem;
  }

  .\\33xl\\:min-h-32{
    min-height: 8rem;
  }

  .\\33xl\\:min-h-34{
    min-height: 8.5rem;
  }

  .\\33xl\\:min-h-40{
    min-height: 10rem;
  }

  .\\33xl\\:min-h-42{
    min-height: 10.5rem;
  }

  .\\33xl\\:min-h-44{
    min-height: 11rem;
  }

  .\\33xl\\:min-h-48{
    min-height: 12rem;
  }

  .\\33xl\\:min-h-52{
    min-height: 13rem;
  }

  .\\33xl\\:min-h-54{
    min-height: 13.5rem;
  }

  .\\33xl\\:min-h-56{
    min-height: 14rem;
  }

  .\\33xl\\:min-h-60{
    min-height: 15rem;
  }

  .\\33xl\\:min-h-64{
    min-height: 16rem;
  }

  .\\33xl\\:min-h-68{
    min-height: 17rem;
  }

  .\\33xl\\:min-h-72{
    min-height: 18rem;
  }

  .\\33xl\\:min-h-74{
    min-height: 18.5rem;
  }

  .\\33xl\\:min-h-76{
    min-height: 19rem;
  }

  .\\33xl\\:min-h-78{
    min-height: 19.5rem;
  }

  .\\33xl\\:min-h-80{
    min-height: 20rem;
  }

  .\\33xl\\:min-h-82{
    min-height: 20.5rem;
  }

  .\\33xl\\:min-h-84{
    min-height: 21rem;
  }

  .\\33xl\\:min-h-88{
    min-height: 22rem;
  }

  .\\33xl\\:min-h-92{
    min-height: 23rem;
  }

  .\\33xl\\:min-h-96{
    min-height: 24rem;
  }

  .\\33xl\\:min-h-98{
    min-height: 24.5rem;
  }

  .\\33xl\\:min-h-100{
    min-height: 25rem;
  }

  .\\33xl\\:min-h-104{
    min-height: 26rem;
  }

  .\\33xl\\:min-h-112{
    min-height: 28rem;
  }

  .\\33xl\\:min-h-124{
    min-height: 31rem;
  }

  .\\33xl\\:min-h-128{
    min-height: 32rem;
  }

  .\\33xl\\:min-h-140{
    min-height: 35rem;
  }

  .\\33xl\\:min-h-152{
    min-height: 38rem;
  }

  .\\33xl\\:min-h-160{
    min-height: 40rem;
  }

  .\\33xl\\:min-h-162{
    min-height: 41rem;
  }

  .\\33xl\\:min-h-192{
    min-height: 48rem;
  }

  .\\33xl\\:min-h-208{
    min-height: 52rem;
  }

  .\\33xl\\:min-h-224{
    min-height: 56rem;
  }

  .\\33xl\\:min-h-256{
    min-height: 64rem;
  }

  .\\33xl\\:min-h-full{
    min-height: 100%;
  }

  .\\33xl\\:min-h-px{
    min-height: 1px;
  }

  .\\33xl\\:min-h-screen{
    min-height: 100vh;
  }

  .\\33xl\\:min-w-0{
    min-width: 0;
  }

  .\\33xl\\:min-w-1{
    min-width: 0.25rem;
  }

  .\\33xl\\:min-w-2{
    min-width: 0.5rem;
  }

  .\\33xl\\:min-w-3{
    min-width: 0.75rem;
  }

  .\\33xl\\:min-w-4{
    min-width: 1rem;
  }

  .\\33xl\\:min-w-5{
    min-width: 1.25rem;
  }

  .\\33xl\\:min-w-6{
    min-width: 1.5rem;
  }

  .\\33xl\\:min-w-7{
    min-width: 1.75rem;
  }

  .\\33xl\\:min-w-8{
    min-width: 2rem;
  }

  .\\33xl\\:min-w-9{
    min-width: 2.25rem;
  }

  .\\33xl\\:min-w-10{
    min-width: 2.5rem;
  }

  .\\33xl\\:min-w-11{
    min-width: 2.75rem;
  }

  .\\33xl\\:min-w-12{
    min-width: 3rem;
  }

  .\\33xl\\:min-w-14{
    min-width: 3.5rem;
  }

  .\\33xl\\:min-w-15{
    min-width: 3.75rem;
  }

  .\\33xl\\:min-w-16{
    min-width: 4rem;
  }

  .\\33xl\\:min-w-18{
    min-width: 4.5rem;
  }

  .\\33xl\\:min-w-20{
    min-width: 5rem;
  }

  .\\33xl\\:min-w-22{
    min-width: 5.5rem;
  }

  .\\33xl\\:min-w-23{
    min-width: 5.75rem;
  }

  .\\33xl\\:min-w-24{
    min-width: 6rem;
  }

  .\\33xl\\:min-w-25{
    min-width: 6.25rem;
  }

  .\\33xl\\:min-w-26{
    min-width: 6.5rem;
  }

  .\\33xl\\:min-w-28{
    min-width: 7rem;
  }

  .\\33xl\\:min-w-30{
    min-width: 7.5rem;
  }

  .\\33xl\\:min-w-32{
    min-width: 8rem;
  }

  .\\33xl\\:min-w-34{
    min-width: 8.5rem;
  }

  .\\33xl\\:min-w-40{
    min-width: 10rem;
  }

  .\\33xl\\:min-w-42{
    min-width: 10.5rem;
  }

  .\\33xl\\:min-w-44{
    min-width: 11rem;
  }

  .\\33xl\\:min-w-48{
    min-width: 12rem;
  }

  .\\33xl\\:min-w-52{
    min-width: 13rem;
  }

  .\\33xl\\:min-w-54{
    min-width: 13.5rem;
  }

  .\\33xl\\:min-w-56{
    min-width: 14rem;
  }

  .\\33xl\\:min-w-60{
    min-width: 15rem;
  }

  .\\33xl\\:min-w-64{
    min-width: 16rem;
  }

  .\\33xl\\:min-w-68{
    min-width: 17rem;
  }

  .\\33xl\\:min-w-72{
    min-width: 18rem;
  }

  .\\33xl\\:min-w-74{
    min-width: 18.5rem;
  }

  .\\33xl\\:min-w-76{
    min-width: 19rem;
  }

  .\\33xl\\:min-w-78{
    min-width: 19.5rem;
  }

  .\\33xl\\:min-w-80{
    min-width: 20rem;
  }

  .\\33xl\\:min-w-82{
    min-width: 20.5rem;
  }

  .\\33xl\\:min-w-84{
    min-width: 21rem;
  }

  .\\33xl\\:min-w-88{
    min-width: 22rem;
  }

  .\\33xl\\:min-w-92{
    min-width: 23rem;
  }

  .\\33xl\\:min-w-96{
    min-width: 24rem;
  }

  .\\33xl\\:min-w-98{
    min-width: 24.5rem;
  }

  .\\33xl\\:min-w-100{
    min-width: 25rem;
  }

  .\\33xl\\:min-w-104{
    min-width: 26rem;
  }

  .\\33xl\\:min-w-112{
    min-width: 28rem;
  }

  .\\33xl\\:min-w-124{
    min-width: 31rem;
  }

  .\\33xl\\:min-w-128{
    min-width: 32rem;
  }

  .\\33xl\\:min-w-140{
    min-width: 35rem;
  }

  .\\33xl\\:min-w-152{
    min-width: 38rem;
  }

  .\\33xl\\:min-w-160{
    min-width: 40rem;
  }

  .\\33xl\\:min-w-162{
    min-width: 41rem;
  }

  .\\33xl\\:min-w-192{
    min-width: 48rem;
  }

  .\\33xl\\:min-w-208{
    min-width: 52rem;
  }

  .\\33xl\\:min-w-224{
    min-width: 56rem;
  }

  .\\33xl\\:min-w-256{
    min-width: 64rem;
  }

  .\\33xl\\:min-w-px{
    min-width: 1px;
  }

  .\\33xl\\:min-w-full{
    min-width: 100%;
  }

  .\\33xl\\:object-contain{
    object-fit: contain;
  }

  .\\33xl\\:object-cover{
    object-fit: cover;
  }

  .\\33xl\\:object-fill{
    object-fit: fill;
  }

  .\\33xl\\:object-none{
    object-fit: none;
  }

  .\\33xl\\:object-scale-down{
    object-fit: scale-down;
  }

  .\\33xl\\:object-bottom{
    object-position: bottom;
  }

  .\\33xl\\:object-center{
    object-position: center;
  }

  .\\33xl\\:object-left{
    object-position: left;
  }

  .\\33xl\\:object-left-bottom{
    object-position: left bottom;
  }

  .\\33xl\\:object-left-top{
    object-position: left top;
  }

  .\\33xl\\:object-right{
    object-position: right;
  }

  .\\33xl\\:object-right-bottom{
    object-position: right bottom;
  }

  .\\33xl\\:object-right-top{
    object-position: right top;
  }

  .\\33xl\\:object-top{
    object-position: top;
  }

  .\\33xl\\:opacity-0{
    opacity: 0;
  }

  .\\33xl\\:opacity-25{
    opacity: .25;
  }

  .\\33xl\\:opacity-50{
    opacity: .5;
  }

  .\\33xl\\:opacity-75{
    opacity: .75;
  }

  .\\33xl\\:opacity-100{
    opacity: 1;
  }

  .\\33xl\\:overflow-auto{
    overflow: auto;
  }

  .\\33xl\\:overflow-hidden{
    overflow: hidden;
  }

  .\\33xl\\:overflow-visible{
    overflow: visible;
  }

  .\\33xl\\:overflow-scroll{
    overflow: scroll;
  }

  .\\33xl\\:overflow-x-auto{
    overflow-x: auto;
  }

  .\\33xl\\:overflow-y-auto{
    overflow-y: auto;
  }

  .\\33xl\\:overflow-x-hidden{
    overflow-x: hidden;
  }

  .\\33xl\\:overflow-y-hidden{
    overflow-y: hidden;
  }

  .\\33xl\\:overflow-x-visible{
    overflow-x: visible;
  }

  .\\33xl\\:overflow-y-visible{
    overflow-y: visible;
  }

  .\\33xl\\:overflow-x-scroll{
    overflow-x: scroll;
  }

  .\\33xl\\:overflow-y-scroll{
    overflow-y: scroll;
  }

  .\\33xl\\:scrolling-touch{
    -webkit-overflow-scrolling: touch;
  }

  .\\33xl\\:scrolling-auto{
    -webkit-overflow-scrolling: auto;
  }

  .\\33xl\\:overscroll-auto{
    overscroll-behavior: auto;
  }

  .\\33xl\\:overscroll-contain{
    overscroll-behavior: contain;
  }

  .\\33xl\\:overscroll-none{
    overscroll-behavior: none;
  }

  .\\33xl\\:overscroll-y-auto{
    overscroll-behavior-y: auto;
  }

  .\\33xl\\:overscroll-y-contain{
    overscroll-behavior-y: contain;
  }

  .\\33xl\\:overscroll-y-none{
    overscroll-behavior-y: none;
  }

  .\\33xl\\:overscroll-x-auto{
    overscroll-behavior-x: auto;
  }

  .\\33xl\\:overscroll-x-contain{
    overscroll-behavior-x: contain;
  }

  .\\33xl\\:overscroll-x-none{
    overscroll-behavior-x: none;
  }

  .\\33xl\\:p-0{
    padding: 0;
  }

  .\\33xl\\:p-1{
    padding: 0.25rem;
  }

  .\\33xl\\:p-2{
    padding: 0.5rem;
  }

  .\\33xl\\:p-3{
    padding: 0.75rem;
  }

  .\\33xl\\:p-4{
    padding: 1rem;
  }

  .\\33xl\\:p-5{
    padding: 1.25rem;
  }

  .\\33xl\\:p-6{
    padding: 1.5rem;
  }

  .\\33xl\\:p-7{
    padding: 1.75rem;
  }

  .\\33xl\\:p-8{
    padding: 2rem;
  }

  .\\33xl\\:p-9{
    padding: 2.25rem;
  }

  .\\33xl\\:p-10{
    padding: 2.5rem;
  }

  .\\33xl\\:p-11{
    padding: 2.75rem;
  }

  .\\33xl\\:p-12{
    padding: 3rem;
  }

  .\\33xl\\:p-14{
    padding: 3.5rem;
  }

  .\\33xl\\:p-15{
    padding: 3.75rem;
  }

  .\\33xl\\:p-16{
    padding: 4rem;
  }

  .\\33xl\\:p-18{
    padding: 4.5rem;
  }

  .\\33xl\\:p-20{
    padding: 5rem;
  }

  .\\33xl\\:p-22{
    padding: 5.5rem;
  }

  .\\33xl\\:p-23{
    padding: 5.75rem;
  }

  .\\33xl\\:p-24{
    padding: 6rem;
  }

  .\\33xl\\:p-25{
    padding: 6.25rem;
  }

  .\\33xl\\:p-26{
    padding: 6.5rem;
  }

  .\\33xl\\:p-28{
    padding: 7rem;
  }

  .\\33xl\\:p-30{
    padding: 7.5rem;
  }

  .\\33xl\\:p-32{
    padding: 8rem;
  }

  .\\33xl\\:p-34{
    padding: 8.5rem;
  }

  .\\33xl\\:p-40{
    padding: 10rem;
  }

  .\\33xl\\:p-42{
    padding: 10.5rem;
  }

  .\\33xl\\:p-44{
    padding: 11rem;
  }

  .\\33xl\\:p-48{
    padding: 12rem;
  }

  .\\33xl\\:p-52{
    padding: 13rem;
  }

  .\\33xl\\:p-54{
    padding: 13.5rem;
  }

  .\\33xl\\:p-56{
    padding: 14rem;
  }

  .\\33xl\\:p-60{
    padding: 15rem;
  }

  .\\33xl\\:p-64{
    padding: 16rem;
  }

  .\\33xl\\:p-68{
    padding: 17rem;
  }

  .\\33xl\\:p-72{
    padding: 18rem;
  }

  .\\33xl\\:p-74{
    padding: 18.5rem;
  }

  .\\33xl\\:p-76{
    padding: 19rem;
  }

  .\\33xl\\:p-78{
    padding: 19.5rem;
  }

  .\\33xl\\:p-80{
    padding: 20rem;
  }

  .\\33xl\\:p-82{
    padding: 20.5rem;
  }

  .\\33xl\\:p-84{
    padding: 21rem;
  }

  .\\33xl\\:p-88{
    padding: 22rem;
  }

  .\\33xl\\:p-92{
    padding: 23rem;
  }

  .\\33xl\\:p-96{
    padding: 24rem;
  }

  .\\33xl\\:p-98{
    padding: 24.5rem;
  }

  .\\33xl\\:p-100{
    padding: 25rem;
  }

  .\\33xl\\:p-104{
    padding: 26rem;
  }

  .\\33xl\\:p-112{
    padding: 28rem;
  }

  .\\33xl\\:p-124{
    padding: 31rem;
  }

  .\\33xl\\:p-128{
    padding: 32rem;
  }

  .\\33xl\\:p-140{
    padding: 35rem;
  }

  .\\33xl\\:p-152{
    padding: 38rem;
  }

  .\\33xl\\:p-160{
    padding: 40rem;
  }

  .\\33xl\\:p-162{
    padding: 41rem;
  }

  .\\33xl\\:p-192{
    padding: 48rem;
  }

  .\\33xl\\:p-208{
    padding: 52rem;
  }

  .\\33xl\\:p-224{
    padding: 56rem;
  }

  .\\33xl\\:p-256{
    padding: 64rem;
  }

  .\\33xl\\:p-px{
    padding: 1px;
  }

  .\\33xl\\:py-0{
    padding-top: 0;
    padding-bottom: 0;
  }

  .\\33xl\\:px-0{
    padding-left: 0;
    padding-right: 0;
  }

  .\\33xl\\:py-1{
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .\\33xl\\:px-1{
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .\\33xl\\:py-2{
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .\\33xl\\:px-2{
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .\\33xl\\:py-3{
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .\\33xl\\:px-3{
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .\\33xl\\:py-4{
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .\\33xl\\:px-4{
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .\\33xl\\:py-5{
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .\\33xl\\:px-5{
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .\\33xl\\:py-6{
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .\\33xl\\:px-6{
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .\\33xl\\:py-7{
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .\\33xl\\:px-7{
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .\\33xl\\:py-8{
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .\\33xl\\:px-8{
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .\\33xl\\:py-9{
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .\\33xl\\:px-9{
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .\\33xl\\:py-10{
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .\\33xl\\:px-10{
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .\\33xl\\:py-11{
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .\\33xl\\:px-11{
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .\\33xl\\:py-12{
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .\\33xl\\:px-12{
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .\\33xl\\:py-14{
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .\\33xl\\:px-14{
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .\\33xl\\:py-15{
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .\\33xl\\:px-15{
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .\\33xl\\:py-16{
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .\\33xl\\:px-16{
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .\\33xl\\:py-18{
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .\\33xl\\:px-18{
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .\\33xl\\:py-20{
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .\\33xl\\:px-20{
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .\\33xl\\:py-22{
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .\\33xl\\:px-22{
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .\\33xl\\:py-23{
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .\\33xl\\:px-23{
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .\\33xl\\:py-24{
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .\\33xl\\:px-24{
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .\\33xl\\:py-25{
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .\\33xl\\:px-25{
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .\\33xl\\:py-26{
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .\\33xl\\:px-26{
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .\\33xl\\:py-28{
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .\\33xl\\:px-28{
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .\\33xl\\:py-30{
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .\\33xl\\:px-30{
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .\\33xl\\:py-32{
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .\\33xl\\:px-32{
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .\\33xl\\:py-34{
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .\\33xl\\:px-34{
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .\\33xl\\:py-40{
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .\\33xl\\:px-40{
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .\\33xl\\:py-42{
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .\\33xl\\:px-42{
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .\\33xl\\:py-44{
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .\\33xl\\:px-44{
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .\\33xl\\:py-48{
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .\\33xl\\:px-48{
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .\\33xl\\:py-52{
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .\\33xl\\:px-52{
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .\\33xl\\:py-54{
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .\\33xl\\:px-54{
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .\\33xl\\:py-56{
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .\\33xl\\:px-56{
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .\\33xl\\:py-60{
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .\\33xl\\:px-60{
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .\\33xl\\:py-64{
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .\\33xl\\:px-64{
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .\\33xl\\:py-68{
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .\\33xl\\:px-68{
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .\\33xl\\:py-72{
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .\\33xl\\:px-72{
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .\\33xl\\:py-74{
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .\\33xl\\:px-74{
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .\\33xl\\:py-76{
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .\\33xl\\:px-76{
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .\\33xl\\:py-78{
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .\\33xl\\:px-78{
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .\\33xl\\:py-80{
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .\\33xl\\:px-80{
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .\\33xl\\:py-82{
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .\\33xl\\:px-82{
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .\\33xl\\:py-84{
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .\\33xl\\:px-84{
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .\\33xl\\:py-88{
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .\\33xl\\:px-88{
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .\\33xl\\:py-92{
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .\\33xl\\:px-92{
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .\\33xl\\:py-96{
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .\\33xl\\:px-96{
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .\\33xl\\:py-98{
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .\\33xl\\:px-98{
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .\\33xl\\:py-100{
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .\\33xl\\:px-100{
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .\\33xl\\:py-104{
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .\\33xl\\:px-104{
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .\\33xl\\:py-112{
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .\\33xl\\:px-112{
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .\\33xl\\:py-124{
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .\\33xl\\:px-124{
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .\\33xl\\:py-128{
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .\\33xl\\:px-128{
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .\\33xl\\:py-140{
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .\\33xl\\:px-140{
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .\\33xl\\:py-152{
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .\\33xl\\:px-152{
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .\\33xl\\:py-160{
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .\\33xl\\:px-160{
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .\\33xl\\:py-162{
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .\\33xl\\:px-162{
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .\\33xl\\:py-192{
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .\\33xl\\:px-192{
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .\\33xl\\:py-208{
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .\\33xl\\:px-208{
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .\\33xl\\:py-224{
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .\\33xl\\:px-224{
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .\\33xl\\:py-256{
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .\\33xl\\:px-256{
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .\\33xl\\:py-px{
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .\\33xl\\:px-px{
    padding-left: 1px;
    padding-right: 1px;
  }

  .\\33xl\\:pt-0{
    padding-top: 0;
  }

  .\\33xl\\:pr-0{
    padding-right: 0;
  }

  .\\33xl\\:pb-0{
    padding-bottom: 0;
  }

  .\\33xl\\:pl-0{
    padding-left: 0;
  }

  .\\33xl\\:pt-1{
    padding-top: 0.25rem;
  }

  .\\33xl\\:pr-1{
    padding-right: 0.25rem;
  }

  .\\33xl\\:pb-1{
    padding-bottom: 0.25rem;
  }

  .\\33xl\\:pl-1{
    padding-left: 0.25rem;
  }

  .\\33xl\\:pt-2{
    padding-top: 0.5rem;
  }

  .\\33xl\\:pr-2{
    padding-right: 0.5rem;
  }

  .\\33xl\\:pb-2{
    padding-bottom: 0.5rem;
  }

  .\\33xl\\:pl-2{
    padding-left: 0.5rem;
  }

  .\\33xl\\:pt-3{
    padding-top: 0.75rem;
  }

  .\\33xl\\:pr-3{
    padding-right: 0.75rem;
  }

  .\\33xl\\:pb-3{
    padding-bottom: 0.75rem;
  }

  .\\33xl\\:pl-3{
    padding-left: 0.75rem;
  }

  .\\33xl\\:pt-4{
    padding-top: 1rem;
  }

  .\\33xl\\:pr-4{
    padding-right: 1rem;
  }

  .\\33xl\\:pb-4{
    padding-bottom: 1rem;
  }

  .\\33xl\\:pl-4{
    padding-left: 1rem;
  }

  .\\33xl\\:pt-5{
    padding-top: 1.25rem;
  }

  .\\33xl\\:pr-5{
    padding-right: 1.25rem;
  }

  .\\33xl\\:pb-5{
    padding-bottom: 1.25rem;
  }

  .\\33xl\\:pl-5{
    padding-left: 1.25rem;
  }

  .\\33xl\\:pt-6{
    padding-top: 1.5rem;
  }

  .\\33xl\\:pr-6{
    padding-right: 1.5rem;
  }

  .\\33xl\\:pb-6{
    padding-bottom: 1.5rem;
  }

  .\\33xl\\:pl-6{
    padding-left: 1.5rem;
  }

  .\\33xl\\:pt-7{
    padding-top: 1.75rem;
  }

  .\\33xl\\:pr-7{
    padding-right: 1.75rem;
  }

  .\\33xl\\:pb-7{
    padding-bottom: 1.75rem;
  }

  .\\33xl\\:pl-7{
    padding-left: 1.75rem;
  }

  .\\33xl\\:pt-8{
    padding-top: 2rem;
  }

  .\\33xl\\:pr-8{
    padding-right: 2rem;
  }

  .\\33xl\\:pb-8{
    padding-bottom: 2rem;
  }

  .\\33xl\\:pl-8{
    padding-left: 2rem;
  }

  .\\33xl\\:pt-9{
    padding-top: 2.25rem;
  }

  .\\33xl\\:pr-9{
    padding-right: 2.25rem;
  }

  .\\33xl\\:pb-9{
    padding-bottom: 2.25rem;
  }

  .\\33xl\\:pl-9{
    padding-left: 2.25rem;
  }

  .\\33xl\\:pt-10{
    padding-top: 2.5rem;
  }

  .\\33xl\\:pr-10{
    padding-right: 2.5rem;
  }

  .\\33xl\\:pb-10{
    padding-bottom: 2.5rem;
  }

  .\\33xl\\:pl-10{
    padding-left: 2.5rem;
  }

  .\\33xl\\:pt-11{
    padding-top: 2.75rem;
  }

  .\\33xl\\:pr-11{
    padding-right: 2.75rem;
  }

  .\\33xl\\:pb-11{
    padding-bottom: 2.75rem;
  }

  .\\33xl\\:pl-11{
    padding-left: 2.75rem;
  }

  .\\33xl\\:pt-12{
    padding-top: 3rem;
  }

  .\\33xl\\:pr-12{
    padding-right: 3rem;
  }

  .\\33xl\\:pb-12{
    padding-bottom: 3rem;
  }

  .\\33xl\\:pl-12{
    padding-left: 3rem;
  }

  .\\33xl\\:pt-14{
    padding-top: 3.5rem;
  }

  .\\33xl\\:pr-14{
    padding-right: 3.5rem;
  }

  .\\33xl\\:pb-14{
    padding-bottom: 3.5rem;
  }

  .\\33xl\\:pl-14{
    padding-left: 3.5rem;
  }

  .\\33xl\\:pt-15{
    padding-top: 3.75rem;
  }

  .\\33xl\\:pr-15{
    padding-right: 3.75rem;
  }

  .\\33xl\\:pb-15{
    padding-bottom: 3.75rem;
  }

  .\\33xl\\:pl-15{
    padding-left: 3.75rem;
  }

  .\\33xl\\:pt-16{
    padding-top: 4rem;
  }

  .\\33xl\\:pr-16{
    padding-right: 4rem;
  }

  .\\33xl\\:pb-16{
    padding-bottom: 4rem;
  }

  .\\33xl\\:pl-16{
    padding-left: 4rem;
  }

  .\\33xl\\:pt-18{
    padding-top: 4.5rem;
  }

  .\\33xl\\:pr-18{
    padding-right: 4.5rem;
  }

  .\\33xl\\:pb-18{
    padding-bottom: 4.5rem;
  }

  .\\33xl\\:pl-18{
    padding-left: 4.5rem;
  }

  .\\33xl\\:pt-20{
    padding-top: 5rem;
  }

  .\\33xl\\:pr-20{
    padding-right: 5rem;
  }

  .\\33xl\\:pb-20{
    padding-bottom: 5rem;
  }

  .\\33xl\\:pl-20{
    padding-left: 5rem;
  }

  .\\33xl\\:pt-22{
    padding-top: 5.5rem;
  }

  .\\33xl\\:pr-22{
    padding-right: 5.5rem;
  }

  .\\33xl\\:pb-22{
    padding-bottom: 5.5rem;
  }

  .\\33xl\\:pl-22{
    padding-left: 5.5rem;
  }

  .\\33xl\\:pt-23{
    padding-top: 5.75rem;
  }

  .\\33xl\\:pr-23{
    padding-right: 5.75rem;
  }

  .\\33xl\\:pb-23{
    padding-bottom: 5.75rem;
  }

  .\\33xl\\:pl-23{
    padding-left: 5.75rem;
  }

  .\\33xl\\:pt-24{
    padding-top: 6rem;
  }

  .\\33xl\\:pr-24{
    padding-right: 6rem;
  }

  .\\33xl\\:pb-24{
    padding-bottom: 6rem;
  }

  .\\33xl\\:pl-24{
    padding-left: 6rem;
  }

  .\\33xl\\:pt-25{
    padding-top: 6.25rem;
  }

  .\\33xl\\:pr-25{
    padding-right: 6.25rem;
  }

  .\\33xl\\:pb-25{
    padding-bottom: 6.25rem;
  }

  .\\33xl\\:pl-25{
    padding-left: 6.25rem;
  }

  .\\33xl\\:pt-26{
    padding-top: 6.5rem;
  }

  .\\33xl\\:pr-26{
    padding-right: 6.5rem;
  }

  .\\33xl\\:pb-26{
    padding-bottom: 6.5rem;
  }

  .\\33xl\\:pl-26{
    padding-left: 6.5rem;
  }

  .\\33xl\\:pt-28{
    padding-top: 7rem;
  }

  .\\33xl\\:pr-28{
    padding-right: 7rem;
  }

  .\\33xl\\:pb-28{
    padding-bottom: 7rem;
  }

  .\\33xl\\:pl-28{
    padding-left: 7rem;
  }

  .\\33xl\\:pt-30{
    padding-top: 7.5rem;
  }

  .\\33xl\\:pr-30{
    padding-right: 7.5rem;
  }

  .\\33xl\\:pb-30{
    padding-bottom: 7.5rem;
  }

  .\\33xl\\:pl-30{
    padding-left: 7.5rem;
  }

  .\\33xl\\:pt-32{
    padding-top: 8rem;
  }

  .\\33xl\\:pr-32{
    padding-right: 8rem;
  }

  .\\33xl\\:pb-32{
    padding-bottom: 8rem;
  }

  .\\33xl\\:pl-32{
    padding-left: 8rem;
  }

  .\\33xl\\:pt-34{
    padding-top: 8.5rem;
  }

  .\\33xl\\:pr-34{
    padding-right: 8.5rem;
  }

  .\\33xl\\:pb-34{
    padding-bottom: 8.5rem;
  }

  .\\33xl\\:pl-34{
    padding-left: 8.5rem;
  }

  .\\33xl\\:pt-40{
    padding-top: 10rem;
  }

  .\\33xl\\:pr-40{
    padding-right: 10rem;
  }

  .\\33xl\\:pb-40{
    padding-bottom: 10rem;
  }

  .\\33xl\\:pl-40{
    padding-left: 10rem;
  }

  .\\33xl\\:pt-42{
    padding-top: 10.5rem;
  }

  .\\33xl\\:pr-42{
    padding-right: 10.5rem;
  }

  .\\33xl\\:pb-42{
    padding-bottom: 10.5rem;
  }

  .\\33xl\\:pl-42{
    padding-left: 10.5rem;
  }

  .\\33xl\\:pt-44{
    padding-top: 11rem;
  }

  .\\33xl\\:pr-44{
    padding-right: 11rem;
  }

  .\\33xl\\:pb-44{
    padding-bottom: 11rem;
  }

  .\\33xl\\:pl-44{
    padding-left: 11rem;
  }

  .\\33xl\\:pt-48{
    padding-top: 12rem;
  }

  .\\33xl\\:pr-48{
    padding-right: 12rem;
  }

  .\\33xl\\:pb-48{
    padding-bottom: 12rem;
  }

  .\\33xl\\:pl-48{
    padding-left: 12rem;
  }

  .\\33xl\\:pt-52{
    padding-top: 13rem;
  }

  .\\33xl\\:pr-52{
    padding-right: 13rem;
  }

  .\\33xl\\:pb-52{
    padding-bottom: 13rem;
  }

  .\\33xl\\:pl-52{
    padding-left: 13rem;
  }

  .\\33xl\\:pt-54{
    padding-top: 13.5rem;
  }

  .\\33xl\\:pr-54{
    padding-right: 13.5rem;
  }

  .\\33xl\\:pb-54{
    padding-bottom: 13.5rem;
  }

  .\\33xl\\:pl-54{
    padding-left: 13.5rem;
  }

  .\\33xl\\:pt-56{
    padding-top: 14rem;
  }

  .\\33xl\\:pr-56{
    padding-right: 14rem;
  }

  .\\33xl\\:pb-56{
    padding-bottom: 14rem;
  }

  .\\33xl\\:pl-56{
    padding-left: 14rem;
  }

  .\\33xl\\:pt-60{
    padding-top: 15rem;
  }

  .\\33xl\\:pr-60{
    padding-right: 15rem;
  }

  .\\33xl\\:pb-60{
    padding-bottom: 15rem;
  }

  .\\33xl\\:pl-60{
    padding-left: 15rem;
  }

  .\\33xl\\:pt-64{
    padding-top: 16rem;
  }

  .\\33xl\\:pr-64{
    padding-right: 16rem;
  }

  .\\33xl\\:pb-64{
    padding-bottom: 16rem;
  }

  .\\33xl\\:pl-64{
    padding-left: 16rem;
  }

  .\\33xl\\:pt-68{
    padding-top: 17rem;
  }

  .\\33xl\\:pr-68{
    padding-right: 17rem;
  }

  .\\33xl\\:pb-68{
    padding-bottom: 17rem;
  }

  .\\33xl\\:pl-68{
    padding-left: 17rem;
  }

  .\\33xl\\:pt-72{
    padding-top: 18rem;
  }

  .\\33xl\\:pr-72{
    padding-right: 18rem;
  }

  .\\33xl\\:pb-72{
    padding-bottom: 18rem;
  }

  .\\33xl\\:pl-72{
    padding-left: 18rem;
  }

  .\\33xl\\:pt-74{
    padding-top: 18.5rem;
  }

  .\\33xl\\:pr-74{
    padding-right: 18.5rem;
  }

  .\\33xl\\:pb-74{
    padding-bottom: 18.5rem;
  }

  .\\33xl\\:pl-74{
    padding-left: 18.5rem;
  }

  .\\33xl\\:pt-76{
    padding-top: 19rem;
  }

  .\\33xl\\:pr-76{
    padding-right: 19rem;
  }

  .\\33xl\\:pb-76{
    padding-bottom: 19rem;
  }

  .\\33xl\\:pl-76{
    padding-left: 19rem;
  }

  .\\33xl\\:pt-78{
    padding-top: 19.5rem;
  }

  .\\33xl\\:pr-78{
    padding-right: 19.5rem;
  }

  .\\33xl\\:pb-78{
    padding-bottom: 19.5rem;
  }

  .\\33xl\\:pl-78{
    padding-left: 19.5rem;
  }

  .\\33xl\\:pt-80{
    padding-top: 20rem;
  }

  .\\33xl\\:pr-80{
    padding-right: 20rem;
  }

  .\\33xl\\:pb-80{
    padding-bottom: 20rem;
  }

  .\\33xl\\:pl-80{
    padding-left: 20rem;
  }

  .\\33xl\\:pt-82{
    padding-top: 20.5rem;
  }

  .\\33xl\\:pr-82{
    padding-right: 20.5rem;
  }

  .\\33xl\\:pb-82{
    padding-bottom: 20.5rem;
  }

  .\\33xl\\:pl-82{
    padding-left: 20.5rem;
  }

  .\\33xl\\:pt-84{
    padding-top: 21rem;
  }

  .\\33xl\\:pr-84{
    padding-right: 21rem;
  }

  .\\33xl\\:pb-84{
    padding-bottom: 21rem;
  }

  .\\33xl\\:pl-84{
    padding-left: 21rem;
  }

  .\\33xl\\:pt-88{
    padding-top: 22rem;
  }

  .\\33xl\\:pr-88{
    padding-right: 22rem;
  }

  .\\33xl\\:pb-88{
    padding-bottom: 22rem;
  }

  .\\33xl\\:pl-88{
    padding-left: 22rem;
  }

  .\\33xl\\:pt-92{
    padding-top: 23rem;
  }

  .\\33xl\\:pr-92{
    padding-right: 23rem;
  }

  .\\33xl\\:pb-92{
    padding-bottom: 23rem;
  }

  .\\33xl\\:pl-92{
    padding-left: 23rem;
  }

  .\\33xl\\:pt-96{
    padding-top: 24rem;
  }

  .\\33xl\\:pr-96{
    padding-right: 24rem;
  }

  .\\33xl\\:pb-96{
    padding-bottom: 24rem;
  }

  .\\33xl\\:pl-96{
    padding-left: 24rem;
  }

  .\\33xl\\:pt-98{
    padding-top: 24.5rem;
  }

  .\\33xl\\:pr-98{
    padding-right: 24.5rem;
  }

  .\\33xl\\:pb-98{
    padding-bottom: 24.5rem;
  }

  .\\33xl\\:pl-98{
    padding-left: 24.5rem;
  }

  .\\33xl\\:pt-100{
    padding-top: 25rem;
  }

  .\\33xl\\:pr-100{
    padding-right: 25rem;
  }

  .\\33xl\\:pb-100{
    padding-bottom: 25rem;
  }

  .\\33xl\\:pl-100{
    padding-left: 25rem;
  }

  .\\33xl\\:pt-104{
    padding-top: 26rem;
  }

  .\\33xl\\:pr-104{
    padding-right: 26rem;
  }

  .\\33xl\\:pb-104{
    padding-bottom: 26rem;
  }

  .\\33xl\\:pl-104{
    padding-left: 26rem;
  }

  .\\33xl\\:pt-112{
    padding-top: 28rem;
  }

  .\\33xl\\:pr-112{
    padding-right: 28rem;
  }

  .\\33xl\\:pb-112{
    padding-bottom: 28rem;
  }

  .\\33xl\\:pl-112{
    padding-left: 28rem;
  }

  .\\33xl\\:pt-124{
    padding-top: 31rem;
  }

  .\\33xl\\:pr-124{
    padding-right: 31rem;
  }

  .\\33xl\\:pb-124{
    padding-bottom: 31rem;
  }

  .\\33xl\\:pl-124{
    padding-left: 31rem;
  }

  .\\33xl\\:pt-128{
    padding-top: 32rem;
  }

  .\\33xl\\:pr-128{
    padding-right: 32rem;
  }

  .\\33xl\\:pb-128{
    padding-bottom: 32rem;
  }

  .\\33xl\\:pl-128{
    padding-left: 32rem;
  }

  .\\33xl\\:pt-140{
    padding-top: 35rem;
  }

  .\\33xl\\:pr-140{
    padding-right: 35rem;
  }

  .\\33xl\\:pb-140{
    padding-bottom: 35rem;
  }

  .\\33xl\\:pl-140{
    padding-left: 35rem;
  }

  .\\33xl\\:pt-152{
    padding-top: 38rem;
  }

  .\\33xl\\:pr-152{
    padding-right: 38rem;
  }

  .\\33xl\\:pb-152{
    padding-bottom: 38rem;
  }

  .\\33xl\\:pl-152{
    padding-left: 38rem;
  }

  .\\33xl\\:pt-160{
    padding-top: 40rem;
  }

  .\\33xl\\:pr-160{
    padding-right: 40rem;
  }

  .\\33xl\\:pb-160{
    padding-bottom: 40rem;
  }

  .\\33xl\\:pl-160{
    padding-left: 40rem;
  }

  .\\33xl\\:pt-162{
    padding-top: 41rem;
  }

  .\\33xl\\:pr-162{
    padding-right: 41rem;
  }

  .\\33xl\\:pb-162{
    padding-bottom: 41rem;
  }

  .\\33xl\\:pl-162{
    padding-left: 41rem;
  }

  .\\33xl\\:pt-192{
    padding-top: 48rem;
  }

  .\\33xl\\:pr-192{
    padding-right: 48rem;
  }

  .\\33xl\\:pb-192{
    padding-bottom: 48rem;
  }

  .\\33xl\\:pl-192{
    padding-left: 48rem;
  }

  .\\33xl\\:pt-208{
    padding-top: 52rem;
  }

  .\\33xl\\:pr-208{
    padding-right: 52rem;
  }

  .\\33xl\\:pb-208{
    padding-bottom: 52rem;
  }

  .\\33xl\\:pl-208{
    padding-left: 52rem;
  }

  .\\33xl\\:pt-224{
    padding-top: 56rem;
  }

  .\\33xl\\:pr-224{
    padding-right: 56rem;
  }

  .\\33xl\\:pb-224{
    padding-bottom: 56rem;
  }

  .\\33xl\\:pl-224{
    padding-left: 56rem;
  }

  .\\33xl\\:pt-256{
    padding-top: 64rem;
  }

  .\\33xl\\:pr-256{
    padding-right: 64rem;
  }

  .\\33xl\\:pb-256{
    padding-bottom: 64rem;
  }

  .\\33xl\\:pl-256{
    padding-left: 64rem;
  }

  .\\33xl\\:pt-px{
    padding-top: 1px;
  }

  .\\33xl\\:pr-px{
    padding-right: 1px;
  }

  .\\33xl\\:pb-px{
    padding-bottom: 1px;
  }

  .\\33xl\\:pl-px{
    padding-left: 1px;
  }

  .\\33xl\\:odd\\:p-0:nth-child(odd){
    padding: 0;
  }

  .\\33xl\\:odd\\:p-1:nth-child(odd){
    padding: 0.25rem;
  }

  .\\33xl\\:odd\\:p-2:nth-child(odd){
    padding: 0.5rem;
  }

  .\\33xl\\:odd\\:p-3:nth-child(odd){
    padding: 0.75rem;
  }

  .\\33xl\\:odd\\:p-4:nth-child(odd){
    padding: 1rem;
  }

  .\\33xl\\:odd\\:p-5:nth-child(odd){
    padding: 1.25rem;
  }

  .\\33xl\\:odd\\:p-6:nth-child(odd){
    padding: 1.5rem;
  }

  .\\33xl\\:odd\\:p-7:nth-child(odd){
    padding: 1.75rem;
  }

  .\\33xl\\:odd\\:p-8:nth-child(odd){
    padding: 2rem;
  }

  .\\33xl\\:odd\\:p-9:nth-child(odd){
    padding: 2.25rem;
  }

  .\\33xl\\:odd\\:p-10:nth-child(odd){
    padding: 2.5rem;
  }

  .\\33xl\\:odd\\:p-11:nth-child(odd){
    padding: 2.75rem;
  }

  .\\33xl\\:odd\\:p-12:nth-child(odd){
    padding: 3rem;
  }

  .\\33xl\\:odd\\:p-14:nth-child(odd){
    padding: 3.5rem;
  }

  .\\33xl\\:odd\\:p-15:nth-child(odd){
    padding: 3.75rem;
  }

  .\\33xl\\:odd\\:p-16:nth-child(odd){
    padding: 4rem;
  }

  .\\33xl\\:odd\\:p-18:nth-child(odd){
    padding: 4.5rem;
  }

  .\\33xl\\:odd\\:p-20:nth-child(odd){
    padding: 5rem;
  }

  .\\33xl\\:odd\\:p-22:nth-child(odd){
    padding: 5.5rem;
  }

  .\\33xl\\:odd\\:p-23:nth-child(odd){
    padding: 5.75rem;
  }

  .\\33xl\\:odd\\:p-24:nth-child(odd){
    padding: 6rem;
  }

  .\\33xl\\:odd\\:p-25:nth-child(odd){
    padding: 6.25rem;
  }

  .\\33xl\\:odd\\:p-26:nth-child(odd){
    padding: 6.5rem;
  }

  .\\33xl\\:odd\\:p-28:nth-child(odd){
    padding: 7rem;
  }

  .\\33xl\\:odd\\:p-30:nth-child(odd){
    padding: 7.5rem;
  }

  .\\33xl\\:odd\\:p-32:nth-child(odd){
    padding: 8rem;
  }

  .\\33xl\\:odd\\:p-34:nth-child(odd){
    padding: 8.5rem;
  }

  .\\33xl\\:odd\\:p-40:nth-child(odd){
    padding: 10rem;
  }

  .\\33xl\\:odd\\:p-42:nth-child(odd){
    padding: 10.5rem;
  }

  .\\33xl\\:odd\\:p-44:nth-child(odd){
    padding: 11rem;
  }

  .\\33xl\\:odd\\:p-48:nth-child(odd){
    padding: 12rem;
  }

  .\\33xl\\:odd\\:p-52:nth-child(odd){
    padding: 13rem;
  }

  .\\33xl\\:odd\\:p-54:nth-child(odd){
    padding: 13.5rem;
  }

  .\\33xl\\:odd\\:p-56:nth-child(odd){
    padding: 14rem;
  }

  .\\33xl\\:odd\\:p-60:nth-child(odd){
    padding: 15rem;
  }

  .\\33xl\\:odd\\:p-64:nth-child(odd){
    padding: 16rem;
  }

  .\\33xl\\:odd\\:p-68:nth-child(odd){
    padding: 17rem;
  }

  .\\33xl\\:odd\\:p-72:nth-child(odd){
    padding: 18rem;
  }

  .\\33xl\\:odd\\:p-74:nth-child(odd){
    padding: 18.5rem;
  }

  .\\33xl\\:odd\\:p-76:nth-child(odd){
    padding: 19rem;
  }

  .\\33xl\\:odd\\:p-78:nth-child(odd){
    padding: 19.5rem;
  }

  .\\33xl\\:odd\\:p-80:nth-child(odd){
    padding: 20rem;
  }

  .\\33xl\\:odd\\:p-82:nth-child(odd){
    padding: 20.5rem;
  }

  .\\33xl\\:odd\\:p-84:nth-child(odd){
    padding: 21rem;
  }

  .\\33xl\\:odd\\:p-88:nth-child(odd){
    padding: 22rem;
  }

  .\\33xl\\:odd\\:p-92:nth-child(odd){
    padding: 23rem;
  }

  .\\33xl\\:odd\\:p-96:nth-child(odd){
    padding: 24rem;
  }

  .\\33xl\\:odd\\:p-98:nth-child(odd){
    padding: 24.5rem;
  }

  .\\33xl\\:odd\\:p-100:nth-child(odd){
    padding: 25rem;
  }

  .\\33xl\\:odd\\:p-104:nth-child(odd){
    padding: 26rem;
  }

  .\\33xl\\:odd\\:p-112:nth-child(odd){
    padding: 28rem;
  }

  .\\33xl\\:odd\\:p-124:nth-child(odd){
    padding: 31rem;
  }

  .\\33xl\\:odd\\:p-128:nth-child(odd){
    padding: 32rem;
  }

  .\\33xl\\:odd\\:p-140:nth-child(odd){
    padding: 35rem;
  }

  .\\33xl\\:odd\\:p-152:nth-child(odd){
    padding: 38rem;
  }

  .\\33xl\\:odd\\:p-160:nth-child(odd){
    padding: 40rem;
  }

  .\\33xl\\:odd\\:p-162:nth-child(odd){
    padding: 41rem;
  }

  .\\33xl\\:odd\\:p-192:nth-child(odd){
    padding: 48rem;
  }

  .\\33xl\\:odd\\:p-208:nth-child(odd){
    padding: 52rem;
  }

  .\\33xl\\:odd\\:p-224:nth-child(odd){
    padding: 56rem;
  }

  .\\33xl\\:odd\\:p-256:nth-child(odd){
    padding: 64rem;
  }

  .\\33xl\\:odd\\:p-px:nth-child(odd){
    padding: 1px;
  }

  .\\33xl\\:odd\\:py-0:nth-child(odd){
    padding-top: 0;
    padding-bottom: 0;
  }

  .\\33xl\\:odd\\:px-0:nth-child(odd){
    padding-left: 0;
    padding-right: 0;
  }

  .\\33xl\\:odd\\:py-1:nth-child(odd){
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .\\33xl\\:odd\\:px-1:nth-child(odd){
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .\\33xl\\:odd\\:py-2:nth-child(odd){
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .\\33xl\\:odd\\:px-2:nth-child(odd){
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .\\33xl\\:odd\\:py-3:nth-child(odd){
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .\\33xl\\:odd\\:px-3:nth-child(odd){
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .\\33xl\\:odd\\:py-4:nth-child(odd){
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .\\33xl\\:odd\\:px-4:nth-child(odd){
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .\\33xl\\:odd\\:py-5:nth-child(odd){
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .\\33xl\\:odd\\:px-5:nth-child(odd){
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .\\33xl\\:odd\\:py-6:nth-child(odd){
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .\\33xl\\:odd\\:px-6:nth-child(odd){
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .\\33xl\\:odd\\:py-7:nth-child(odd){
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .\\33xl\\:odd\\:px-7:nth-child(odd){
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .\\33xl\\:odd\\:py-8:nth-child(odd){
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .\\33xl\\:odd\\:px-8:nth-child(odd){
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .\\33xl\\:odd\\:py-9:nth-child(odd){
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .\\33xl\\:odd\\:px-9:nth-child(odd){
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .\\33xl\\:odd\\:py-10:nth-child(odd){
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .\\33xl\\:odd\\:px-10:nth-child(odd){
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .\\33xl\\:odd\\:py-11:nth-child(odd){
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .\\33xl\\:odd\\:px-11:nth-child(odd){
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .\\33xl\\:odd\\:py-12:nth-child(odd){
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .\\33xl\\:odd\\:px-12:nth-child(odd){
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .\\33xl\\:odd\\:py-14:nth-child(odd){
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .\\33xl\\:odd\\:px-14:nth-child(odd){
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .\\33xl\\:odd\\:py-15:nth-child(odd){
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .\\33xl\\:odd\\:px-15:nth-child(odd){
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .\\33xl\\:odd\\:py-16:nth-child(odd){
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .\\33xl\\:odd\\:px-16:nth-child(odd){
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .\\33xl\\:odd\\:py-18:nth-child(odd){
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .\\33xl\\:odd\\:px-18:nth-child(odd){
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .\\33xl\\:odd\\:py-20:nth-child(odd){
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .\\33xl\\:odd\\:px-20:nth-child(odd){
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .\\33xl\\:odd\\:py-22:nth-child(odd){
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .\\33xl\\:odd\\:px-22:nth-child(odd){
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .\\33xl\\:odd\\:py-23:nth-child(odd){
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .\\33xl\\:odd\\:px-23:nth-child(odd){
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .\\33xl\\:odd\\:py-24:nth-child(odd){
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .\\33xl\\:odd\\:px-24:nth-child(odd){
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .\\33xl\\:odd\\:py-25:nth-child(odd){
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .\\33xl\\:odd\\:px-25:nth-child(odd){
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .\\33xl\\:odd\\:py-26:nth-child(odd){
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .\\33xl\\:odd\\:px-26:nth-child(odd){
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .\\33xl\\:odd\\:py-28:nth-child(odd){
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .\\33xl\\:odd\\:px-28:nth-child(odd){
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .\\33xl\\:odd\\:py-30:nth-child(odd){
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .\\33xl\\:odd\\:px-30:nth-child(odd){
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .\\33xl\\:odd\\:py-32:nth-child(odd){
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .\\33xl\\:odd\\:px-32:nth-child(odd){
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .\\33xl\\:odd\\:py-34:nth-child(odd){
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .\\33xl\\:odd\\:px-34:nth-child(odd){
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .\\33xl\\:odd\\:py-40:nth-child(odd){
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .\\33xl\\:odd\\:px-40:nth-child(odd){
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .\\33xl\\:odd\\:py-42:nth-child(odd){
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .\\33xl\\:odd\\:px-42:nth-child(odd){
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .\\33xl\\:odd\\:py-44:nth-child(odd){
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .\\33xl\\:odd\\:px-44:nth-child(odd){
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .\\33xl\\:odd\\:py-48:nth-child(odd){
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .\\33xl\\:odd\\:px-48:nth-child(odd){
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .\\33xl\\:odd\\:py-52:nth-child(odd){
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .\\33xl\\:odd\\:px-52:nth-child(odd){
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .\\33xl\\:odd\\:py-54:nth-child(odd){
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .\\33xl\\:odd\\:px-54:nth-child(odd){
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .\\33xl\\:odd\\:py-56:nth-child(odd){
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .\\33xl\\:odd\\:px-56:nth-child(odd){
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .\\33xl\\:odd\\:py-60:nth-child(odd){
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .\\33xl\\:odd\\:px-60:nth-child(odd){
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .\\33xl\\:odd\\:py-64:nth-child(odd){
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .\\33xl\\:odd\\:px-64:nth-child(odd){
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .\\33xl\\:odd\\:py-68:nth-child(odd){
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .\\33xl\\:odd\\:px-68:nth-child(odd){
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .\\33xl\\:odd\\:py-72:nth-child(odd){
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .\\33xl\\:odd\\:px-72:nth-child(odd){
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .\\33xl\\:odd\\:py-74:nth-child(odd){
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .\\33xl\\:odd\\:px-74:nth-child(odd){
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .\\33xl\\:odd\\:py-76:nth-child(odd){
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .\\33xl\\:odd\\:px-76:nth-child(odd){
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .\\33xl\\:odd\\:py-78:nth-child(odd){
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .\\33xl\\:odd\\:px-78:nth-child(odd){
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .\\33xl\\:odd\\:py-80:nth-child(odd){
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .\\33xl\\:odd\\:px-80:nth-child(odd){
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .\\33xl\\:odd\\:py-82:nth-child(odd){
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .\\33xl\\:odd\\:px-82:nth-child(odd){
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .\\33xl\\:odd\\:py-84:nth-child(odd){
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .\\33xl\\:odd\\:px-84:nth-child(odd){
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .\\33xl\\:odd\\:py-88:nth-child(odd){
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .\\33xl\\:odd\\:px-88:nth-child(odd){
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .\\33xl\\:odd\\:py-92:nth-child(odd){
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .\\33xl\\:odd\\:px-92:nth-child(odd){
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .\\33xl\\:odd\\:py-96:nth-child(odd){
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .\\33xl\\:odd\\:px-96:nth-child(odd){
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .\\33xl\\:odd\\:py-98:nth-child(odd){
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .\\33xl\\:odd\\:px-98:nth-child(odd){
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .\\33xl\\:odd\\:py-100:nth-child(odd){
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .\\33xl\\:odd\\:px-100:nth-child(odd){
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .\\33xl\\:odd\\:py-104:nth-child(odd){
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .\\33xl\\:odd\\:px-104:nth-child(odd){
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .\\33xl\\:odd\\:py-112:nth-child(odd){
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .\\33xl\\:odd\\:px-112:nth-child(odd){
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .\\33xl\\:odd\\:py-124:nth-child(odd){
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .\\33xl\\:odd\\:px-124:nth-child(odd){
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .\\33xl\\:odd\\:py-128:nth-child(odd){
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .\\33xl\\:odd\\:px-128:nth-child(odd){
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .\\33xl\\:odd\\:py-140:nth-child(odd){
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .\\33xl\\:odd\\:px-140:nth-child(odd){
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .\\33xl\\:odd\\:py-152:nth-child(odd){
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .\\33xl\\:odd\\:px-152:nth-child(odd){
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .\\33xl\\:odd\\:py-160:nth-child(odd){
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .\\33xl\\:odd\\:px-160:nth-child(odd){
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .\\33xl\\:odd\\:py-162:nth-child(odd){
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .\\33xl\\:odd\\:px-162:nth-child(odd){
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .\\33xl\\:odd\\:py-192:nth-child(odd){
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .\\33xl\\:odd\\:px-192:nth-child(odd){
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .\\33xl\\:odd\\:py-208:nth-child(odd){
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .\\33xl\\:odd\\:px-208:nth-child(odd){
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .\\33xl\\:odd\\:py-224:nth-child(odd){
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .\\33xl\\:odd\\:px-224:nth-child(odd){
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .\\33xl\\:odd\\:py-256:nth-child(odd){
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .\\33xl\\:odd\\:px-256:nth-child(odd){
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .\\33xl\\:odd\\:py-px:nth-child(odd){
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .\\33xl\\:odd\\:px-px:nth-child(odd){
    padding-left: 1px;
    padding-right: 1px;
  }

  .\\33xl\\:odd\\:pt-0:nth-child(odd){
    padding-top: 0;
  }

  .\\33xl\\:odd\\:pr-0:nth-child(odd){
    padding-right: 0;
  }

  .\\33xl\\:odd\\:pb-0:nth-child(odd){
    padding-bottom: 0;
  }

  .\\33xl\\:odd\\:pl-0:nth-child(odd){
    padding-left: 0;
  }

  .\\33xl\\:odd\\:pt-1:nth-child(odd){
    padding-top: 0.25rem;
  }

  .\\33xl\\:odd\\:pr-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  .\\33xl\\:odd\\:pb-1:nth-child(odd){
    padding-bottom: 0.25rem;
  }

  .\\33xl\\:odd\\:pl-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  .\\33xl\\:odd\\:pt-2:nth-child(odd){
    padding-top: 0.5rem;
  }

  .\\33xl\\:odd\\:pr-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  .\\33xl\\:odd\\:pb-2:nth-child(odd){
    padding-bottom: 0.5rem;
  }

  .\\33xl\\:odd\\:pl-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  .\\33xl\\:odd\\:pt-3:nth-child(odd){
    padding-top: 0.75rem;
  }

  .\\33xl\\:odd\\:pr-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  .\\33xl\\:odd\\:pb-3:nth-child(odd){
    padding-bottom: 0.75rem;
  }

  .\\33xl\\:odd\\:pl-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  .\\33xl\\:odd\\:pt-4:nth-child(odd){
    padding-top: 1rem;
  }

  .\\33xl\\:odd\\:pr-4:nth-child(odd){
    padding-right: 1rem;
  }

  .\\33xl\\:odd\\:pb-4:nth-child(odd){
    padding-bottom: 1rem;
  }

  .\\33xl\\:odd\\:pl-4:nth-child(odd){
    padding-left: 1rem;
  }

  .\\33xl\\:odd\\:pt-5:nth-child(odd){
    padding-top: 1.25rem;
  }

  .\\33xl\\:odd\\:pr-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  .\\33xl\\:odd\\:pb-5:nth-child(odd){
    padding-bottom: 1.25rem;
  }

  .\\33xl\\:odd\\:pl-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  .\\33xl\\:odd\\:pt-6:nth-child(odd){
    padding-top: 1.5rem;
  }

  .\\33xl\\:odd\\:pr-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  .\\33xl\\:odd\\:pb-6:nth-child(odd){
    padding-bottom: 1.5rem;
  }

  .\\33xl\\:odd\\:pl-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  .\\33xl\\:odd\\:pt-7:nth-child(odd){
    padding-top: 1.75rem;
  }

  .\\33xl\\:odd\\:pr-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  .\\33xl\\:odd\\:pb-7:nth-child(odd){
    padding-bottom: 1.75rem;
  }

  .\\33xl\\:odd\\:pl-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  .\\33xl\\:odd\\:pt-8:nth-child(odd){
    padding-top: 2rem;
  }

  .\\33xl\\:odd\\:pr-8:nth-child(odd){
    padding-right: 2rem;
  }

  .\\33xl\\:odd\\:pb-8:nth-child(odd){
    padding-bottom: 2rem;
  }

  .\\33xl\\:odd\\:pl-8:nth-child(odd){
    padding-left: 2rem;
  }

  .\\33xl\\:odd\\:pt-9:nth-child(odd){
    padding-top: 2.25rem;
  }

  .\\33xl\\:odd\\:pr-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  .\\33xl\\:odd\\:pb-9:nth-child(odd){
    padding-bottom: 2.25rem;
  }

  .\\33xl\\:odd\\:pl-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  .\\33xl\\:odd\\:pt-10:nth-child(odd){
    padding-top: 2.5rem;
  }

  .\\33xl\\:odd\\:pr-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  .\\33xl\\:odd\\:pb-10:nth-child(odd){
    padding-bottom: 2.5rem;
  }

  .\\33xl\\:odd\\:pl-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  .\\33xl\\:odd\\:pt-11:nth-child(odd){
    padding-top: 2.75rem;
  }

  .\\33xl\\:odd\\:pr-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  .\\33xl\\:odd\\:pb-11:nth-child(odd){
    padding-bottom: 2.75rem;
  }

  .\\33xl\\:odd\\:pl-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  .\\33xl\\:odd\\:pt-12:nth-child(odd){
    padding-top: 3rem;
  }

  .\\33xl\\:odd\\:pr-12:nth-child(odd){
    padding-right: 3rem;
  }

  .\\33xl\\:odd\\:pb-12:nth-child(odd){
    padding-bottom: 3rem;
  }

  .\\33xl\\:odd\\:pl-12:nth-child(odd){
    padding-left: 3rem;
  }

  .\\33xl\\:odd\\:pt-14:nth-child(odd){
    padding-top: 3.5rem;
  }

  .\\33xl\\:odd\\:pr-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  .\\33xl\\:odd\\:pb-14:nth-child(odd){
    padding-bottom: 3.5rem;
  }

  .\\33xl\\:odd\\:pl-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  .\\33xl\\:odd\\:pt-15:nth-child(odd){
    padding-top: 3.75rem;
  }

  .\\33xl\\:odd\\:pr-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  .\\33xl\\:odd\\:pb-15:nth-child(odd){
    padding-bottom: 3.75rem;
  }

  .\\33xl\\:odd\\:pl-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  .\\33xl\\:odd\\:pt-16:nth-child(odd){
    padding-top: 4rem;
  }

  .\\33xl\\:odd\\:pr-16:nth-child(odd){
    padding-right: 4rem;
  }

  .\\33xl\\:odd\\:pb-16:nth-child(odd){
    padding-bottom: 4rem;
  }

  .\\33xl\\:odd\\:pl-16:nth-child(odd){
    padding-left: 4rem;
  }

  .\\33xl\\:odd\\:pt-18:nth-child(odd){
    padding-top: 4.5rem;
  }

  .\\33xl\\:odd\\:pr-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  .\\33xl\\:odd\\:pb-18:nth-child(odd){
    padding-bottom: 4.5rem;
  }

  .\\33xl\\:odd\\:pl-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  .\\33xl\\:odd\\:pt-20:nth-child(odd){
    padding-top: 5rem;
  }

  .\\33xl\\:odd\\:pr-20:nth-child(odd){
    padding-right: 5rem;
  }

  .\\33xl\\:odd\\:pb-20:nth-child(odd){
    padding-bottom: 5rem;
  }

  .\\33xl\\:odd\\:pl-20:nth-child(odd){
    padding-left: 5rem;
  }

  .\\33xl\\:odd\\:pt-22:nth-child(odd){
    padding-top: 5.5rem;
  }

  .\\33xl\\:odd\\:pr-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  .\\33xl\\:odd\\:pb-22:nth-child(odd){
    padding-bottom: 5.5rem;
  }

  .\\33xl\\:odd\\:pl-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  .\\33xl\\:odd\\:pt-23:nth-child(odd){
    padding-top: 5.75rem;
  }

  .\\33xl\\:odd\\:pr-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  .\\33xl\\:odd\\:pb-23:nth-child(odd){
    padding-bottom: 5.75rem;
  }

  .\\33xl\\:odd\\:pl-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  .\\33xl\\:odd\\:pt-24:nth-child(odd){
    padding-top: 6rem;
  }

  .\\33xl\\:odd\\:pr-24:nth-child(odd){
    padding-right: 6rem;
  }

  .\\33xl\\:odd\\:pb-24:nth-child(odd){
    padding-bottom: 6rem;
  }

  .\\33xl\\:odd\\:pl-24:nth-child(odd){
    padding-left: 6rem;
  }

  .\\33xl\\:odd\\:pt-25:nth-child(odd){
    padding-top: 6.25rem;
  }

  .\\33xl\\:odd\\:pr-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  .\\33xl\\:odd\\:pb-25:nth-child(odd){
    padding-bottom: 6.25rem;
  }

  .\\33xl\\:odd\\:pl-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  .\\33xl\\:odd\\:pt-26:nth-child(odd){
    padding-top: 6.5rem;
  }

  .\\33xl\\:odd\\:pr-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  .\\33xl\\:odd\\:pb-26:nth-child(odd){
    padding-bottom: 6.5rem;
  }

  .\\33xl\\:odd\\:pl-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  .\\33xl\\:odd\\:pt-28:nth-child(odd){
    padding-top: 7rem;
  }

  .\\33xl\\:odd\\:pr-28:nth-child(odd){
    padding-right: 7rem;
  }

  .\\33xl\\:odd\\:pb-28:nth-child(odd){
    padding-bottom: 7rem;
  }

  .\\33xl\\:odd\\:pl-28:nth-child(odd){
    padding-left: 7rem;
  }

  .\\33xl\\:odd\\:pt-30:nth-child(odd){
    padding-top: 7.5rem;
  }

  .\\33xl\\:odd\\:pr-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  .\\33xl\\:odd\\:pb-30:nth-child(odd){
    padding-bottom: 7.5rem;
  }

  .\\33xl\\:odd\\:pl-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  .\\33xl\\:odd\\:pt-32:nth-child(odd){
    padding-top: 8rem;
  }

  .\\33xl\\:odd\\:pr-32:nth-child(odd){
    padding-right: 8rem;
  }

  .\\33xl\\:odd\\:pb-32:nth-child(odd){
    padding-bottom: 8rem;
  }

  .\\33xl\\:odd\\:pl-32:nth-child(odd){
    padding-left: 8rem;
  }

  .\\33xl\\:odd\\:pt-34:nth-child(odd){
    padding-top: 8.5rem;
  }

  .\\33xl\\:odd\\:pr-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  .\\33xl\\:odd\\:pb-34:nth-child(odd){
    padding-bottom: 8.5rem;
  }

  .\\33xl\\:odd\\:pl-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  .\\33xl\\:odd\\:pt-40:nth-child(odd){
    padding-top: 10rem;
  }

  .\\33xl\\:odd\\:pr-40:nth-child(odd){
    padding-right: 10rem;
  }

  .\\33xl\\:odd\\:pb-40:nth-child(odd){
    padding-bottom: 10rem;
  }

  .\\33xl\\:odd\\:pl-40:nth-child(odd){
    padding-left: 10rem;
  }

  .\\33xl\\:odd\\:pt-42:nth-child(odd){
    padding-top: 10.5rem;
  }

  .\\33xl\\:odd\\:pr-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  .\\33xl\\:odd\\:pb-42:nth-child(odd){
    padding-bottom: 10.5rem;
  }

  .\\33xl\\:odd\\:pl-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  .\\33xl\\:odd\\:pt-44:nth-child(odd){
    padding-top: 11rem;
  }

  .\\33xl\\:odd\\:pr-44:nth-child(odd){
    padding-right: 11rem;
  }

  .\\33xl\\:odd\\:pb-44:nth-child(odd){
    padding-bottom: 11rem;
  }

  .\\33xl\\:odd\\:pl-44:nth-child(odd){
    padding-left: 11rem;
  }

  .\\33xl\\:odd\\:pt-48:nth-child(odd){
    padding-top: 12rem;
  }

  .\\33xl\\:odd\\:pr-48:nth-child(odd){
    padding-right: 12rem;
  }

  .\\33xl\\:odd\\:pb-48:nth-child(odd){
    padding-bottom: 12rem;
  }

  .\\33xl\\:odd\\:pl-48:nth-child(odd){
    padding-left: 12rem;
  }

  .\\33xl\\:odd\\:pt-52:nth-child(odd){
    padding-top: 13rem;
  }

  .\\33xl\\:odd\\:pr-52:nth-child(odd){
    padding-right: 13rem;
  }

  .\\33xl\\:odd\\:pb-52:nth-child(odd){
    padding-bottom: 13rem;
  }

  .\\33xl\\:odd\\:pl-52:nth-child(odd){
    padding-left: 13rem;
  }

  .\\33xl\\:odd\\:pt-54:nth-child(odd){
    padding-top: 13.5rem;
  }

  .\\33xl\\:odd\\:pr-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  .\\33xl\\:odd\\:pb-54:nth-child(odd){
    padding-bottom: 13.5rem;
  }

  .\\33xl\\:odd\\:pl-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  .\\33xl\\:odd\\:pt-56:nth-child(odd){
    padding-top: 14rem;
  }

  .\\33xl\\:odd\\:pr-56:nth-child(odd){
    padding-right: 14rem;
  }

  .\\33xl\\:odd\\:pb-56:nth-child(odd){
    padding-bottom: 14rem;
  }

  .\\33xl\\:odd\\:pl-56:nth-child(odd){
    padding-left: 14rem;
  }

  .\\33xl\\:odd\\:pt-60:nth-child(odd){
    padding-top: 15rem;
  }

  .\\33xl\\:odd\\:pr-60:nth-child(odd){
    padding-right: 15rem;
  }

  .\\33xl\\:odd\\:pb-60:nth-child(odd){
    padding-bottom: 15rem;
  }

  .\\33xl\\:odd\\:pl-60:nth-child(odd){
    padding-left: 15rem;
  }

  .\\33xl\\:odd\\:pt-64:nth-child(odd){
    padding-top: 16rem;
  }

  .\\33xl\\:odd\\:pr-64:nth-child(odd){
    padding-right: 16rem;
  }

  .\\33xl\\:odd\\:pb-64:nth-child(odd){
    padding-bottom: 16rem;
  }

  .\\33xl\\:odd\\:pl-64:nth-child(odd){
    padding-left: 16rem;
  }

  .\\33xl\\:odd\\:pt-68:nth-child(odd){
    padding-top: 17rem;
  }

  .\\33xl\\:odd\\:pr-68:nth-child(odd){
    padding-right: 17rem;
  }

  .\\33xl\\:odd\\:pb-68:nth-child(odd){
    padding-bottom: 17rem;
  }

  .\\33xl\\:odd\\:pl-68:nth-child(odd){
    padding-left: 17rem;
  }

  .\\33xl\\:odd\\:pt-72:nth-child(odd){
    padding-top: 18rem;
  }

  .\\33xl\\:odd\\:pr-72:nth-child(odd){
    padding-right: 18rem;
  }

  .\\33xl\\:odd\\:pb-72:nth-child(odd){
    padding-bottom: 18rem;
  }

  .\\33xl\\:odd\\:pl-72:nth-child(odd){
    padding-left: 18rem;
  }

  .\\33xl\\:odd\\:pt-74:nth-child(odd){
    padding-top: 18.5rem;
  }

  .\\33xl\\:odd\\:pr-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  .\\33xl\\:odd\\:pb-74:nth-child(odd){
    padding-bottom: 18.5rem;
  }

  .\\33xl\\:odd\\:pl-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  .\\33xl\\:odd\\:pt-76:nth-child(odd){
    padding-top: 19rem;
  }

  .\\33xl\\:odd\\:pr-76:nth-child(odd){
    padding-right: 19rem;
  }

  .\\33xl\\:odd\\:pb-76:nth-child(odd){
    padding-bottom: 19rem;
  }

  .\\33xl\\:odd\\:pl-76:nth-child(odd){
    padding-left: 19rem;
  }

  .\\33xl\\:odd\\:pt-78:nth-child(odd){
    padding-top: 19.5rem;
  }

  .\\33xl\\:odd\\:pr-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  .\\33xl\\:odd\\:pb-78:nth-child(odd){
    padding-bottom: 19.5rem;
  }

  .\\33xl\\:odd\\:pl-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  .\\33xl\\:odd\\:pt-80:nth-child(odd){
    padding-top: 20rem;
  }

  .\\33xl\\:odd\\:pr-80:nth-child(odd){
    padding-right: 20rem;
  }

  .\\33xl\\:odd\\:pb-80:nth-child(odd){
    padding-bottom: 20rem;
  }

  .\\33xl\\:odd\\:pl-80:nth-child(odd){
    padding-left: 20rem;
  }

  .\\33xl\\:odd\\:pt-82:nth-child(odd){
    padding-top: 20.5rem;
  }

  .\\33xl\\:odd\\:pr-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  .\\33xl\\:odd\\:pb-82:nth-child(odd){
    padding-bottom: 20.5rem;
  }

  .\\33xl\\:odd\\:pl-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  .\\33xl\\:odd\\:pt-84:nth-child(odd){
    padding-top: 21rem;
  }

  .\\33xl\\:odd\\:pr-84:nth-child(odd){
    padding-right: 21rem;
  }

  .\\33xl\\:odd\\:pb-84:nth-child(odd){
    padding-bottom: 21rem;
  }

  .\\33xl\\:odd\\:pl-84:nth-child(odd){
    padding-left: 21rem;
  }

  .\\33xl\\:odd\\:pt-88:nth-child(odd){
    padding-top: 22rem;
  }

  .\\33xl\\:odd\\:pr-88:nth-child(odd){
    padding-right: 22rem;
  }

  .\\33xl\\:odd\\:pb-88:nth-child(odd){
    padding-bottom: 22rem;
  }

  .\\33xl\\:odd\\:pl-88:nth-child(odd){
    padding-left: 22rem;
  }

  .\\33xl\\:odd\\:pt-92:nth-child(odd){
    padding-top: 23rem;
  }

  .\\33xl\\:odd\\:pr-92:nth-child(odd){
    padding-right: 23rem;
  }

  .\\33xl\\:odd\\:pb-92:nth-child(odd){
    padding-bottom: 23rem;
  }

  .\\33xl\\:odd\\:pl-92:nth-child(odd){
    padding-left: 23rem;
  }

  .\\33xl\\:odd\\:pt-96:nth-child(odd){
    padding-top: 24rem;
  }

  .\\33xl\\:odd\\:pr-96:nth-child(odd){
    padding-right: 24rem;
  }

  .\\33xl\\:odd\\:pb-96:nth-child(odd){
    padding-bottom: 24rem;
  }

  .\\33xl\\:odd\\:pl-96:nth-child(odd){
    padding-left: 24rem;
  }

  .\\33xl\\:odd\\:pt-98:nth-child(odd){
    padding-top: 24.5rem;
  }

  .\\33xl\\:odd\\:pr-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  .\\33xl\\:odd\\:pb-98:nth-child(odd){
    padding-bottom: 24.5rem;
  }

  .\\33xl\\:odd\\:pl-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  .\\33xl\\:odd\\:pt-100:nth-child(odd){
    padding-top: 25rem;
  }

  .\\33xl\\:odd\\:pr-100:nth-child(odd){
    padding-right: 25rem;
  }

  .\\33xl\\:odd\\:pb-100:nth-child(odd){
    padding-bottom: 25rem;
  }

  .\\33xl\\:odd\\:pl-100:nth-child(odd){
    padding-left: 25rem;
  }

  .\\33xl\\:odd\\:pt-104:nth-child(odd){
    padding-top: 26rem;
  }

  .\\33xl\\:odd\\:pr-104:nth-child(odd){
    padding-right: 26rem;
  }

  .\\33xl\\:odd\\:pb-104:nth-child(odd){
    padding-bottom: 26rem;
  }

  .\\33xl\\:odd\\:pl-104:nth-child(odd){
    padding-left: 26rem;
  }

  .\\33xl\\:odd\\:pt-112:nth-child(odd){
    padding-top: 28rem;
  }

  .\\33xl\\:odd\\:pr-112:nth-child(odd){
    padding-right: 28rem;
  }

  .\\33xl\\:odd\\:pb-112:nth-child(odd){
    padding-bottom: 28rem;
  }

  .\\33xl\\:odd\\:pl-112:nth-child(odd){
    padding-left: 28rem;
  }

  .\\33xl\\:odd\\:pt-124:nth-child(odd){
    padding-top: 31rem;
  }

  .\\33xl\\:odd\\:pr-124:nth-child(odd){
    padding-right: 31rem;
  }

  .\\33xl\\:odd\\:pb-124:nth-child(odd){
    padding-bottom: 31rem;
  }

  .\\33xl\\:odd\\:pl-124:nth-child(odd){
    padding-left: 31rem;
  }

  .\\33xl\\:odd\\:pt-128:nth-child(odd){
    padding-top: 32rem;
  }

  .\\33xl\\:odd\\:pr-128:nth-child(odd){
    padding-right: 32rem;
  }

  .\\33xl\\:odd\\:pb-128:nth-child(odd){
    padding-bottom: 32rem;
  }

  .\\33xl\\:odd\\:pl-128:nth-child(odd){
    padding-left: 32rem;
  }

  .\\33xl\\:odd\\:pt-140:nth-child(odd){
    padding-top: 35rem;
  }

  .\\33xl\\:odd\\:pr-140:nth-child(odd){
    padding-right: 35rem;
  }

  .\\33xl\\:odd\\:pb-140:nth-child(odd){
    padding-bottom: 35rem;
  }

  .\\33xl\\:odd\\:pl-140:nth-child(odd){
    padding-left: 35rem;
  }

  .\\33xl\\:odd\\:pt-152:nth-child(odd){
    padding-top: 38rem;
  }

  .\\33xl\\:odd\\:pr-152:nth-child(odd){
    padding-right: 38rem;
  }

  .\\33xl\\:odd\\:pb-152:nth-child(odd){
    padding-bottom: 38rem;
  }

  .\\33xl\\:odd\\:pl-152:nth-child(odd){
    padding-left: 38rem;
  }

  .\\33xl\\:odd\\:pt-160:nth-child(odd){
    padding-top: 40rem;
  }

  .\\33xl\\:odd\\:pr-160:nth-child(odd){
    padding-right: 40rem;
  }

  .\\33xl\\:odd\\:pb-160:nth-child(odd){
    padding-bottom: 40rem;
  }

  .\\33xl\\:odd\\:pl-160:nth-child(odd){
    padding-left: 40rem;
  }

  .\\33xl\\:odd\\:pt-162:nth-child(odd){
    padding-top: 41rem;
  }

  .\\33xl\\:odd\\:pr-162:nth-child(odd){
    padding-right: 41rem;
  }

  .\\33xl\\:odd\\:pb-162:nth-child(odd){
    padding-bottom: 41rem;
  }

  .\\33xl\\:odd\\:pl-162:nth-child(odd){
    padding-left: 41rem;
  }

  .\\33xl\\:odd\\:pt-192:nth-child(odd){
    padding-top: 48rem;
  }

  .\\33xl\\:odd\\:pr-192:nth-child(odd){
    padding-right: 48rem;
  }

  .\\33xl\\:odd\\:pb-192:nth-child(odd){
    padding-bottom: 48rem;
  }

  .\\33xl\\:odd\\:pl-192:nth-child(odd){
    padding-left: 48rem;
  }

  .\\33xl\\:odd\\:pt-208:nth-child(odd){
    padding-top: 52rem;
  }

  .\\33xl\\:odd\\:pr-208:nth-child(odd){
    padding-right: 52rem;
  }

  .\\33xl\\:odd\\:pb-208:nth-child(odd){
    padding-bottom: 52rem;
  }

  .\\33xl\\:odd\\:pl-208:nth-child(odd){
    padding-left: 52rem;
  }

  .\\33xl\\:odd\\:pt-224:nth-child(odd){
    padding-top: 56rem;
  }

  .\\33xl\\:odd\\:pr-224:nth-child(odd){
    padding-right: 56rem;
  }

  .\\33xl\\:odd\\:pb-224:nth-child(odd){
    padding-bottom: 56rem;
  }

  .\\33xl\\:odd\\:pl-224:nth-child(odd){
    padding-left: 56rem;
  }

  .\\33xl\\:odd\\:pt-256:nth-child(odd){
    padding-top: 64rem;
  }

  .\\33xl\\:odd\\:pr-256:nth-child(odd){
    padding-right: 64rem;
  }

  .\\33xl\\:odd\\:pb-256:nth-child(odd){
    padding-bottom: 64rem;
  }

  .\\33xl\\:odd\\:pl-256:nth-child(odd){
    padding-left: 64rem;
  }

  .\\33xl\\:odd\\:pt-px:nth-child(odd){
    padding-top: 1px;
  }

  .\\33xl\\:odd\\:pr-px:nth-child(odd){
    padding-right: 1px;
  }

  .\\33xl\\:odd\\:pb-px:nth-child(odd){
    padding-bottom: 1px;
  }

  .\\33xl\\:odd\\:pl-px:nth-child(odd){
    padding-left: 1px;
  }

  .\\33xl\\:even\\:p-0:nth-child(even){
    padding: 0;
  }

  .\\33xl\\:even\\:p-1:nth-child(even){
    padding: 0.25rem;
  }

  .\\33xl\\:even\\:p-2:nth-child(even){
    padding: 0.5rem;
  }

  .\\33xl\\:even\\:p-3:nth-child(even){
    padding: 0.75rem;
  }

  .\\33xl\\:even\\:p-4:nth-child(even){
    padding: 1rem;
  }

  .\\33xl\\:even\\:p-5:nth-child(even){
    padding: 1.25rem;
  }

  .\\33xl\\:even\\:p-6:nth-child(even){
    padding: 1.5rem;
  }

  .\\33xl\\:even\\:p-7:nth-child(even){
    padding: 1.75rem;
  }

  .\\33xl\\:even\\:p-8:nth-child(even){
    padding: 2rem;
  }

  .\\33xl\\:even\\:p-9:nth-child(even){
    padding: 2.25rem;
  }

  .\\33xl\\:even\\:p-10:nth-child(even){
    padding: 2.5rem;
  }

  .\\33xl\\:even\\:p-11:nth-child(even){
    padding: 2.75rem;
  }

  .\\33xl\\:even\\:p-12:nth-child(even){
    padding: 3rem;
  }

  .\\33xl\\:even\\:p-14:nth-child(even){
    padding: 3.5rem;
  }

  .\\33xl\\:even\\:p-15:nth-child(even){
    padding: 3.75rem;
  }

  .\\33xl\\:even\\:p-16:nth-child(even){
    padding: 4rem;
  }

  .\\33xl\\:even\\:p-18:nth-child(even){
    padding: 4.5rem;
  }

  .\\33xl\\:even\\:p-20:nth-child(even){
    padding: 5rem;
  }

  .\\33xl\\:even\\:p-22:nth-child(even){
    padding: 5.5rem;
  }

  .\\33xl\\:even\\:p-23:nth-child(even){
    padding: 5.75rem;
  }

  .\\33xl\\:even\\:p-24:nth-child(even){
    padding: 6rem;
  }

  .\\33xl\\:even\\:p-25:nth-child(even){
    padding: 6.25rem;
  }

  .\\33xl\\:even\\:p-26:nth-child(even){
    padding: 6.5rem;
  }

  .\\33xl\\:even\\:p-28:nth-child(even){
    padding: 7rem;
  }

  .\\33xl\\:even\\:p-30:nth-child(even){
    padding: 7.5rem;
  }

  .\\33xl\\:even\\:p-32:nth-child(even){
    padding: 8rem;
  }

  .\\33xl\\:even\\:p-34:nth-child(even){
    padding: 8.5rem;
  }

  .\\33xl\\:even\\:p-40:nth-child(even){
    padding: 10rem;
  }

  .\\33xl\\:even\\:p-42:nth-child(even){
    padding: 10.5rem;
  }

  .\\33xl\\:even\\:p-44:nth-child(even){
    padding: 11rem;
  }

  .\\33xl\\:even\\:p-48:nth-child(even){
    padding: 12rem;
  }

  .\\33xl\\:even\\:p-52:nth-child(even){
    padding: 13rem;
  }

  .\\33xl\\:even\\:p-54:nth-child(even){
    padding: 13.5rem;
  }

  .\\33xl\\:even\\:p-56:nth-child(even){
    padding: 14rem;
  }

  .\\33xl\\:even\\:p-60:nth-child(even){
    padding: 15rem;
  }

  .\\33xl\\:even\\:p-64:nth-child(even){
    padding: 16rem;
  }

  .\\33xl\\:even\\:p-68:nth-child(even){
    padding: 17rem;
  }

  .\\33xl\\:even\\:p-72:nth-child(even){
    padding: 18rem;
  }

  .\\33xl\\:even\\:p-74:nth-child(even){
    padding: 18.5rem;
  }

  .\\33xl\\:even\\:p-76:nth-child(even){
    padding: 19rem;
  }

  .\\33xl\\:even\\:p-78:nth-child(even){
    padding: 19.5rem;
  }

  .\\33xl\\:even\\:p-80:nth-child(even){
    padding: 20rem;
  }

  .\\33xl\\:even\\:p-82:nth-child(even){
    padding: 20.5rem;
  }

  .\\33xl\\:even\\:p-84:nth-child(even){
    padding: 21rem;
  }

  .\\33xl\\:even\\:p-88:nth-child(even){
    padding: 22rem;
  }

  .\\33xl\\:even\\:p-92:nth-child(even){
    padding: 23rem;
  }

  .\\33xl\\:even\\:p-96:nth-child(even){
    padding: 24rem;
  }

  .\\33xl\\:even\\:p-98:nth-child(even){
    padding: 24.5rem;
  }

  .\\33xl\\:even\\:p-100:nth-child(even){
    padding: 25rem;
  }

  .\\33xl\\:even\\:p-104:nth-child(even){
    padding: 26rem;
  }

  .\\33xl\\:even\\:p-112:nth-child(even){
    padding: 28rem;
  }

  .\\33xl\\:even\\:p-124:nth-child(even){
    padding: 31rem;
  }

  .\\33xl\\:even\\:p-128:nth-child(even){
    padding: 32rem;
  }

  .\\33xl\\:even\\:p-140:nth-child(even){
    padding: 35rem;
  }

  .\\33xl\\:even\\:p-152:nth-child(even){
    padding: 38rem;
  }

  .\\33xl\\:even\\:p-160:nth-child(even){
    padding: 40rem;
  }

  .\\33xl\\:even\\:p-162:nth-child(even){
    padding: 41rem;
  }

  .\\33xl\\:even\\:p-192:nth-child(even){
    padding: 48rem;
  }

  .\\33xl\\:even\\:p-208:nth-child(even){
    padding: 52rem;
  }

  .\\33xl\\:even\\:p-224:nth-child(even){
    padding: 56rem;
  }

  .\\33xl\\:even\\:p-256:nth-child(even){
    padding: 64rem;
  }

  .\\33xl\\:even\\:p-px:nth-child(even){
    padding: 1px;
  }

  .\\33xl\\:even\\:py-0:nth-child(even){
    padding-top: 0;
    padding-bottom: 0;
  }

  .\\33xl\\:even\\:px-0:nth-child(even){
    padding-left: 0;
    padding-right: 0;
  }

  .\\33xl\\:even\\:py-1:nth-child(even){
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
  }

  .\\33xl\\:even\\:px-1:nth-child(even){
    padding-left: 0.25rem;
    padding-right: 0.25rem;
  }

  .\\33xl\\:even\\:py-2:nth-child(even){
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }

  .\\33xl\\:even\\:px-2:nth-child(even){
    padding-left: 0.5rem;
    padding-right: 0.5rem;
  }

  .\\33xl\\:even\\:py-3:nth-child(even){
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }

  .\\33xl\\:even\\:px-3:nth-child(even){
    padding-left: 0.75rem;
    padding-right: 0.75rem;
  }

  .\\33xl\\:even\\:py-4:nth-child(even){
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .\\33xl\\:even\\:px-4:nth-child(even){
    padding-left: 1rem;
    padding-right: 1rem;
  }

  .\\33xl\\:even\\:py-5:nth-child(even){
    padding-top: 1.25rem;
    padding-bottom: 1.25rem;
  }

  .\\33xl\\:even\\:px-5:nth-child(even){
    padding-left: 1.25rem;
    padding-right: 1.25rem;
  }

  .\\33xl\\:even\\:py-6:nth-child(even){
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }

  .\\33xl\\:even\\:px-6:nth-child(even){
    padding-left: 1.5rem;
    padding-right: 1.5rem;
  }

  .\\33xl\\:even\\:py-7:nth-child(even){
    padding-top: 1.75rem;
    padding-bottom: 1.75rem;
  }

  .\\33xl\\:even\\:px-7:nth-child(even){
    padding-left: 1.75rem;
    padding-right: 1.75rem;
  }

  .\\33xl\\:even\\:py-8:nth-child(even){
    padding-top: 2rem;
    padding-bottom: 2rem;
  }

  .\\33xl\\:even\\:px-8:nth-child(even){
    padding-left: 2rem;
    padding-right: 2rem;
  }

  .\\33xl\\:even\\:py-9:nth-child(even){
    padding-top: 2.25rem;
    padding-bottom: 2.25rem;
  }

  .\\33xl\\:even\\:px-9:nth-child(even){
    padding-left: 2.25rem;
    padding-right: 2.25rem;
  }

  .\\33xl\\:even\\:py-10:nth-child(even){
    padding-top: 2.5rem;
    padding-bottom: 2.5rem;
  }

  .\\33xl\\:even\\:px-10:nth-child(even){
    padding-left: 2.5rem;
    padding-right: 2.5rem;
  }

  .\\33xl\\:even\\:py-11:nth-child(even){
    padding-top: 2.75rem;
    padding-bottom: 2.75rem;
  }

  .\\33xl\\:even\\:px-11:nth-child(even){
    padding-left: 2.75rem;
    padding-right: 2.75rem;
  }

  .\\33xl\\:even\\:py-12:nth-child(even){
    padding-top: 3rem;
    padding-bottom: 3rem;
  }

  .\\33xl\\:even\\:px-12:nth-child(even){
    padding-left: 3rem;
    padding-right: 3rem;
  }

  .\\33xl\\:even\\:py-14:nth-child(even){
    padding-top: 3.5rem;
    padding-bottom: 3.5rem;
  }

  .\\33xl\\:even\\:px-14:nth-child(even){
    padding-left: 3.5rem;
    padding-right: 3.5rem;
  }

  .\\33xl\\:even\\:py-15:nth-child(even){
    padding-top: 3.75rem;
    padding-bottom: 3.75rem;
  }

  .\\33xl\\:even\\:px-15:nth-child(even){
    padding-left: 3.75rem;
    padding-right: 3.75rem;
  }

  .\\33xl\\:even\\:py-16:nth-child(even){
    padding-top: 4rem;
    padding-bottom: 4rem;
  }

  .\\33xl\\:even\\:px-16:nth-child(even){
    padding-left: 4rem;
    padding-right: 4rem;
  }

  .\\33xl\\:even\\:py-18:nth-child(even){
    padding-top: 4.5rem;
    padding-bottom: 4.5rem;
  }

  .\\33xl\\:even\\:px-18:nth-child(even){
    padding-left: 4.5rem;
    padding-right: 4.5rem;
  }

  .\\33xl\\:even\\:py-20:nth-child(even){
    padding-top: 5rem;
    padding-bottom: 5rem;
  }

  .\\33xl\\:even\\:px-20:nth-child(even){
    padding-left: 5rem;
    padding-right: 5rem;
  }

  .\\33xl\\:even\\:py-22:nth-child(even){
    padding-top: 5.5rem;
    padding-bottom: 5.5rem;
  }

  .\\33xl\\:even\\:px-22:nth-child(even){
    padding-left: 5.5rem;
    padding-right: 5.5rem;
  }

  .\\33xl\\:even\\:py-23:nth-child(even){
    padding-top: 5.75rem;
    padding-bottom: 5.75rem;
  }

  .\\33xl\\:even\\:px-23:nth-child(even){
    padding-left: 5.75rem;
    padding-right: 5.75rem;
  }

  .\\33xl\\:even\\:py-24:nth-child(even){
    padding-top: 6rem;
    padding-bottom: 6rem;
  }

  .\\33xl\\:even\\:px-24:nth-child(even){
    padding-left: 6rem;
    padding-right: 6rem;
  }

  .\\33xl\\:even\\:py-25:nth-child(even){
    padding-top: 6.25rem;
    padding-bottom: 6.25rem;
  }

  .\\33xl\\:even\\:px-25:nth-child(even){
    padding-left: 6.25rem;
    padding-right: 6.25rem;
  }

  .\\33xl\\:even\\:py-26:nth-child(even){
    padding-top: 6.5rem;
    padding-bottom: 6.5rem;
  }

  .\\33xl\\:even\\:px-26:nth-child(even){
    padding-left: 6.5rem;
    padding-right: 6.5rem;
  }

  .\\33xl\\:even\\:py-28:nth-child(even){
    padding-top: 7rem;
    padding-bottom: 7rem;
  }

  .\\33xl\\:even\\:px-28:nth-child(even){
    padding-left: 7rem;
    padding-right: 7rem;
  }

  .\\33xl\\:even\\:py-30:nth-child(even){
    padding-top: 7.5rem;
    padding-bottom: 7.5rem;
  }

  .\\33xl\\:even\\:px-30:nth-child(even){
    padding-left: 7.5rem;
    padding-right: 7.5rem;
  }

  .\\33xl\\:even\\:py-32:nth-child(even){
    padding-top: 8rem;
    padding-bottom: 8rem;
  }

  .\\33xl\\:even\\:px-32:nth-child(even){
    padding-left: 8rem;
    padding-right: 8rem;
  }

  .\\33xl\\:even\\:py-34:nth-child(even){
    padding-top: 8.5rem;
    padding-bottom: 8.5rem;
  }

  .\\33xl\\:even\\:px-34:nth-child(even){
    padding-left: 8.5rem;
    padding-right: 8.5rem;
  }

  .\\33xl\\:even\\:py-40:nth-child(even){
    padding-top: 10rem;
    padding-bottom: 10rem;
  }

  .\\33xl\\:even\\:px-40:nth-child(even){
    padding-left: 10rem;
    padding-right: 10rem;
  }

  .\\33xl\\:even\\:py-42:nth-child(even){
    padding-top: 10.5rem;
    padding-bottom: 10.5rem;
  }

  .\\33xl\\:even\\:px-42:nth-child(even){
    padding-left: 10.5rem;
    padding-right: 10.5rem;
  }

  .\\33xl\\:even\\:py-44:nth-child(even){
    padding-top: 11rem;
    padding-bottom: 11rem;
  }

  .\\33xl\\:even\\:px-44:nth-child(even){
    padding-left: 11rem;
    padding-right: 11rem;
  }

  .\\33xl\\:even\\:py-48:nth-child(even){
    padding-top: 12rem;
    padding-bottom: 12rem;
  }

  .\\33xl\\:even\\:px-48:nth-child(even){
    padding-left: 12rem;
    padding-right: 12rem;
  }

  .\\33xl\\:even\\:py-52:nth-child(even){
    padding-top: 13rem;
    padding-bottom: 13rem;
  }

  .\\33xl\\:even\\:px-52:nth-child(even){
    padding-left: 13rem;
    padding-right: 13rem;
  }

  .\\33xl\\:even\\:py-54:nth-child(even){
    padding-top: 13.5rem;
    padding-bottom: 13.5rem;
  }

  .\\33xl\\:even\\:px-54:nth-child(even){
    padding-left: 13.5rem;
    padding-right: 13.5rem;
  }

  .\\33xl\\:even\\:py-56:nth-child(even){
    padding-top: 14rem;
    padding-bottom: 14rem;
  }

  .\\33xl\\:even\\:px-56:nth-child(even){
    padding-left: 14rem;
    padding-right: 14rem;
  }

  .\\33xl\\:even\\:py-60:nth-child(even){
    padding-top: 15rem;
    padding-bottom: 15rem;
  }

  .\\33xl\\:even\\:px-60:nth-child(even){
    padding-left: 15rem;
    padding-right: 15rem;
  }

  .\\33xl\\:even\\:py-64:nth-child(even){
    padding-top: 16rem;
    padding-bottom: 16rem;
  }

  .\\33xl\\:even\\:px-64:nth-child(even){
    padding-left: 16rem;
    padding-right: 16rem;
  }

  .\\33xl\\:even\\:py-68:nth-child(even){
    padding-top: 17rem;
    padding-bottom: 17rem;
  }

  .\\33xl\\:even\\:px-68:nth-child(even){
    padding-left: 17rem;
    padding-right: 17rem;
  }

  .\\33xl\\:even\\:py-72:nth-child(even){
    padding-top: 18rem;
    padding-bottom: 18rem;
  }

  .\\33xl\\:even\\:px-72:nth-child(even){
    padding-left: 18rem;
    padding-right: 18rem;
  }

  .\\33xl\\:even\\:py-74:nth-child(even){
    padding-top: 18.5rem;
    padding-bottom: 18.5rem;
  }

  .\\33xl\\:even\\:px-74:nth-child(even){
    padding-left: 18.5rem;
    padding-right: 18.5rem;
  }

  .\\33xl\\:even\\:py-76:nth-child(even){
    padding-top: 19rem;
    padding-bottom: 19rem;
  }

  .\\33xl\\:even\\:px-76:nth-child(even){
    padding-left: 19rem;
    padding-right: 19rem;
  }

  .\\33xl\\:even\\:py-78:nth-child(even){
    padding-top: 19.5rem;
    padding-bottom: 19.5rem;
  }

  .\\33xl\\:even\\:px-78:nth-child(even){
    padding-left: 19.5rem;
    padding-right: 19.5rem;
  }

  .\\33xl\\:even\\:py-80:nth-child(even){
    padding-top: 20rem;
    padding-bottom: 20rem;
  }

  .\\33xl\\:even\\:px-80:nth-child(even){
    padding-left: 20rem;
    padding-right: 20rem;
  }

  .\\33xl\\:even\\:py-82:nth-child(even){
    padding-top: 20.5rem;
    padding-bottom: 20.5rem;
  }

  .\\33xl\\:even\\:px-82:nth-child(even){
    padding-left: 20.5rem;
    padding-right: 20.5rem;
  }

  .\\33xl\\:even\\:py-84:nth-child(even){
    padding-top: 21rem;
    padding-bottom: 21rem;
  }

  .\\33xl\\:even\\:px-84:nth-child(even){
    padding-left: 21rem;
    padding-right: 21rem;
  }

  .\\33xl\\:even\\:py-88:nth-child(even){
    padding-top: 22rem;
    padding-bottom: 22rem;
  }

  .\\33xl\\:even\\:px-88:nth-child(even){
    padding-left: 22rem;
    padding-right: 22rem;
  }

  .\\33xl\\:even\\:py-92:nth-child(even){
    padding-top: 23rem;
    padding-bottom: 23rem;
  }

  .\\33xl\\:even\\:px-92:nth-child(even){
    padding-left: 23rem;
    padding-right: 23rem;
  }

  .\\33xl\\:even\\:py-96:nth-child(even){
    padding-top: 24rem;
    padding-bottom: 24rem;
  }

  .\\33xl\\:even\\:px-96:nth-child(even){
    padding-left: 24rem;
    padding-right: 24rem;
  }

  .\\33xl\\:even\\:py-98:nth-child(even){
    padding-top: 24.5rem;
    padding-bottom: 24.5rem;
  }

  .\\33xl\\:even\\:px-98:nth-child(even){
    padding-left: 24.5rem;
    padding-right: 24.5rem;
  }

  .\\33xl\\:even\\:py-100:nth-child(even){
    padding-top: 25rem;
    padding-bottom: 25rem;
  }

  .\\33xl\\:even\\:px-100:nth-child(even){
    padding-left: 25rem;
    padding-right: 25rem;
  }

  .\\33xl\\:even\\:py-104:nth-child(even){
    padding-top: 26rem;
    padding-bottom: 26rem;
  }

  .\\33xl\\:even\\:px-104:nth-child(even){
    padding-left: 26rem;
    padding-right: 26rem;
  }

  .\\33xl\\:even\\:py-112:nth-child(even){
    padding-top: 28rem;
    padding-bottom: 28rem;
  }

  .\\33xl\\:even\\:px-112:nth-child(even){
    padding-left: 28rem;
    padding-right: 28rem;
  }

  .\\33xl\\:even\\:py-124:nth-child(even){
    padding-top: 31rem;
    padding-bottom: 31rem;
  }

  .\\33xl\\:even\\:px-124:nth-child(even){
    padding-left: 31rem;
    padding-right: 31rem;
  }

  .\\33xl\\:even\\:py-128:nth-child(even){
    padding-top: 32rem;
    padding-bottom: 32rem;
  }

  .\\33xl\\:even\\:px-128:nth-child(even){
    padding-left: 32rem;
    padding-right: 32rem;
  }

  .\\33xl\\:even\\:py-140:nth-child(even){
    padding-top: 35rem;
    padding-bottom: 35rem;
  }

  .\\33xl\\:even\\:px-140:nth-child(even){
    padding-left: 35rem;
    padding-right: 35rem;
  }

  .\\33xl\\:even\\:py-152:nth-child(even){
    padding-top: 38rem;
    padding-bottom: 38rem;
  }

  .\\33xl\\:even\\:px-152:nth-child(even){
    padding-left: 38rem;
    padding-right: 38rem;
  }

  .\\33xl\\:even\\:py-160:nth-child(even){
    padding-top: 40rem;
    padding-bottom: 40rem;
  }

  .\\33xl\\:even\\:px-160:nth-child(even){
    padding-left: 40rem;
    padding-right: 40rem;
  }

  .\\33xl\\:even\\:py-162:nth-child(even){
    padding-top: 41rem;
    padding-bottom: 41rem;
  }

  .\\33xl\\:even\\:px-162:nth-child(even){
    padding-left: 41rem;
    padding-right: 41rem;
  }

  .\\33xl\\:even\\:py-192:nth-child(even){
    padding-top: 48rem;
    padding-bottom: 48rem;
  }

  .\\33xl\\:even\\:px-192:nth-child(even){
    padding-left: 48rem;
    padding-right: 48rem;
  }

  .\\33xl\\:even\\:py-208:nth-child(even){
    padding-top: 52rem;
    padding-bottom: 52rem;
  }

  .\\33xl\\:even\\:px-208:nth-child(even){
    padding-left: 52rem;
    padding-right: 52rem;
  }

  .\\33xl\\:even\\:py-224:nth-child(even){
    padding-top: 56rem;
    padding-bottom: 56rem;
  }

  .\\33xl\\:even\\:px-224:nth-child(even){
    padding-left: 56rem;
    padding-right: 56rem;
  }

  .\\33xl\\:even\\:py-256:nth-child(even){
    padding-top: 64rem;
    padding-bottom: 64rem;
  }

  .\\33xl\\:even\\:px-256:nth-child(even){
    padding-left: 64rem;
    padding-right: 64rem;
  }

  .\\33xl\\:even\\:py-px:nth-child(even){
    padding-top: 1px;
    padding-bottom: 1px;
  }

  .\\33xl\\:even\\:px-px:nth-child(even){
    padding-left: 1px;
    padding-right: 1px;
  }

  .\\33xl\\:even\\:pt-0:nth-child(even){
    padding-top: 0;
  }

  .\\33xl\\:even\\:pr-0:nth-child(even){
    padding-right: 0;
  }

  .\\33xl\\:even\\:pb-0:nth-child(even){
    padding-bottom: 0;
  }

  .\\33xl\\:even\\:pl-0:nth-child(even){
    padding-left: 0;
  }

  .\\33xl\\:even\\:pt-1:nth-child(even){
    padding-top: 0.25rem;
  }

  .\\33xl\\:even\\:pr-1:nth-child(even){
    padding-right: 0.25rem;
  }

  .\\33xl\\:even\\:pb-1:nth-child(even){
    padding-bottom: 0.25rem;
  }

  .\\33xl\\:even\\:pl-1:nth-child(even){
    padding-left: 0.25rem;
  }

  .\\33xl\\:even\\:pt-2:nth-child(even){
    padding-top: 0.5rem;
  }

  .\\33xl\\:even\\:pr-2:nth-child(even){
    padding-right: 0.5rem;
  }

  .\\33xl\\:even\\:pb-2:nth-child(even){
    padding-bottom: 0.5rem;
  }

  .\\33xl\\:even\\:pl-2:nth-child(even){
    padding-left: 0.5rem;
  }

  .\\33xl\\:even\\:pt-3:nth-child(even){
    padding-top: 0.75rem;
  }

  .\\33xl\\:even\\:pr-3:nth-child(even){
    padding-right: 0.75rem;
  }

  .\\33xl\\:even\\:pb-3:nth-child(even){
    padding-bottom: 0.75rem;
  }

  .\\33xl\\:even\\:pl-3:nth-child(even){
    padding-left: 0.75rem;
  }

  .\\33xl\\:even\\:pt-4:nth-child(even){
    padding-top: 1rem;
  }

  .\\33xl\\:even\\:pr-4:nth-child(even){
    padding-right: 1rem;
  }

  .\\33xl\\:even\\:pb-4:nth-child(even){
    padding-bottom: 1rem;
  }

  .\\33xl\\:even\\:pl-4:nth-child(even){
    padding-left: 1rem;
  }

  .\\33xl\\:even\\:pt-5:nth-child(even){
    padding-top: 1.25rem;
  }

  .\\33xl\\:even\\:pr-5:nth-child(even){
    padding-right: 1.25rem;
  }

  .\\33xl\\:even\\:pb-5:nth-child(even){
    padding-bottom: 1.25rem;
  }

  .\\33xl\\:even\\:pl-5:nth-child(even){
    padding-left: 1.25rem;
  }

  .\\33xl\\:even\\:pt-6:nth-child(even){
    padding-top: 1.5rem;
  }

  .\\33xl\\:even\\:pr-6:nth-child(even){
    padding-right: 1.5rem;
  }

  .\\33xl\\:even\\:pb-6:nth-child(even){
    padding-bottom: 1.5rem;
  }

  .\\33xl\\:even\\:pl-6:nth-child(even){
    padding-left: 1.5rem;
  }

  .\\33xl\\:even\\:pt-7:nth-child(even){
    padding-top: 1.75rem;
  }

  .\\33xl\\:even\\:pr-7:nth-child(even){
    padding-right: 1.75rem;
  }

  .\\33xl\\:even\\:pb-7:nth-child(even){
    padding-bottom: 1.75rem;
  }

  .\\33xl\\:even\\:pl-7:nth-child(even){
    padding-left: 1.75rem;
  }

  .\\33xl\\:even\\:pt-8:nth-child(even){
    padding-top: 2rem;
  }

  .\\33xl\\:even\\:pr-8:nth-child(even){
    padding-right: 2rem;
  }

  .\\33xl\\:even\\:pb-8:nth-child(even){
    padding-bottom: 2rem;
  }

  .\\33xl\\:even\\:pl-8:nth-child(even){
    padding-left: 2rem;
  }

  .\\33xl\\:even\\:pt-9:nth-child(even){
    padding-top: 2.25rem;
  }

  .\\33xl\\:even\\:pr-9:nth-child(even){
    padding-right: 2.25rem;
  }

  .\\33xl\\:even\\:pb-9:nth-child(even){
    padding-bottom: 2.25rem;
  }

  .\\33xl\\:even\\:pl-9:nth-child(even){
    padding-left: 2.25rem;
  }

  .\\33xl\\:even\\:pt-10:nth-child(even){
    padding-top: 2.5rem;
  }

  .\\33xl\\:even\\:pr-10:nth-child(even){
    padding-right: 2.5rem;
  }

  .\\33xl\\:even\\:pb-10:nth-child(even){
    padding-bottom: 2.5rem;
  }

  .\\33xl\\:even\\:pl-10:nth-child(even){
    padding-left: 2.5rem;
  }

  .\\33xl\\:even\\:pt-11:nth-child(even){
    padding-top: 2.75rem;
  }

  .\\33xl\\:even\\:pr-11:nth-child(even){
    padding-right: 2.75rem;
  }

  .\\33xl\\:even\\:pb-11:nth-child(even){
    padding-bottom: 2.75rem;
  }

  .\\33xl\\:even\\:pl-11:nth-child(even){
    padding-left: 2.75rem;
  }

  .\\33xl\\:even\\:pt-12:nth-child(even){
    padding-top: 3rem;
  }

  .\\33xl\\:even\\:pr-12:nth-child(even){
    padding-right: 3rem;
  }

  .\\33xl\\:even\\:pb-12:nth-child(even){
    padding-bottom: 3rem;
  }

  .\\33xl\\:even\\:pl-12:nth-child(even){
    padding-left: 3rem;
  }

  .\\33xl\\:even\\:pt-14:nth-child(even){
    padding-top: 3.5rem;
  }

  .\\33xl\\:even\\:pr-14:nth-child(even){
    padding-right: 3.5rem;
  }

  .\\33xl\\:even\\:pb-14:nth-child(even){
    padding-bottom: 3.5rem;
  }

  .\\33xl\\:even\\:pl-14:nth-child(even){
    padding-left: 3.5rem;
  }

  .\\33xl\\:even\\:pt-15:nth-child(even){
    padding-top: 3.75rem;
  }

  .\\33xl\\:even\\:pr-15:nth-child(even){
    padding-right: 3.75rem;
  }

  .\\33xl\\:even\\:pb-15:nth-child(even){
    padding-bottom: 3.75rem;
  }

  .\\33xl\\:even\\:pl-15:nth-child(even){
    padding-left: 3.75rem;
  }

  .\\33xl\\:even\\:pt-16:nth-child(even){
    padding-top: 4rem;
  }

  .\\33xl\\:even\\:pr-16:nth-child(even){
    padding-right: 4rem;
  }

  .\\33xl\\:even\\:pb-16:nth-child(even){
    padding-bottom: 4rem;
  }

  .\\33xl\\:even\\:pl-16:nth-child(even){
    padding-left: 4rem;
  }

  .\\33xl\\:even\\:pt-18:nth-child(even){
    padding-top: 4.5rem;
  }

  .\\33xl\\:even\\:pr-18:nth-child(even){
    padding-right: 4.5rem;
  }

  .\\33xl\\:even\\:pb-18:nth-child(even){
    padding-bottom: 4.5rem;
  }

  .\\33xl\\:even\\:pl-18:nth-child(even){
    padding-left: 4.5rem;
  }

  .\\33xl\\:even\\:pt-20:nth-child(even){
    padding-top: 5rem;
  }

  .\\33xl\\:even\\:pr-20:nth-child(even){
    padding-right: 5rem;
  }

  .\\33xl\\:even\\:pb-20:nth-child(even){
    padding-bottom: 5rem;
  }

  .\\33xl\\:even\\:pl-20:nth-child(even){
    padding-left: 5rem;
  }

  .\\33xl\\:even\\:pt-22:nth-child(even){
    padding-top: 5.5rem;
  }

  .\\33xl\\:even\\:pr-22:nth-child(even){
    padding-right: 5.5rem;
  }

  .\\33xl\\:even\\:pb-22:nth-child(even){
    padding-bottom: 5.5rem;
  }

  .\\33xl\\:even\\:pl-22:nth-child(even){
    padding-left: 5.5rem;
  }

  .\\33xl\\:even\\:pt-23:nth-child(even){
    padding-top: 5.75rem;
  }

  .\\33xl\\:even\\:pr-23:nth-child(even){
    padding-right: 5.75rem;
  }

  .\\33xl\\:even\\:pb-23:nth-child(even){
    padding-bottom: 5.75rem;
  }

  .\\33xl\\:even\\:pl-23:nth-child(even){
    padding-left: 5.75rem;
  }

  .\\33xl\\:even\\:pt-24:nth-child(even){
    padding-top: 6rem;
  }

  .\\33xl\\:even\\:pr-24:nth-child(even){
    padding-right: 6rem;
  }

  .\\33xl\\:even\\:pb-24:nth-child(even){
    padding-bottom: 6rem;
  }

  .\\33xl\\:even\\:pl-24:nth-child(even){
    padding-left: 6rem;
  }

  .\\33xl\\:even\\:pt-25:nth-child(even){
    padding-top: 6.25rem;
  }

  .\\33xl\\:even\\:pr-25:nth-child(even){
    padding-right: 6.25rem;
  }

  .\\33xl\\:even\\:pb-25:nth-child(even){
    padding-bottom: 6.25rem;
  }

  .\\33xl\\:even\\:pl-25:nth-child(even){
    padding-left: 6.25rem;
  }

  .\\33xl\\:even\\:pt-26:nth-child(even){
    padding-top: 6.5rem;
  }

  .\\33xl\\:even\\:pr-26:nth-child(even){
    padding-right: 6.5rem;
  }

  .\\33xl\\:even\\:pb-26:nth-child(even){
    padding-bottom: 6.5rem;
  }

  .\\33xl\\:even\\:pl-26:nth-child(even){
    padding-left: 6.5rem;
  }

  .\\33xl\\:even\\:pt-28:nth-child(even){
    padding-top: 7rem;
  }

  .\\33xl\\:even\\:pr-28:nth-child(even){
    padding-right: 7rem;
  }

  .\\33xl\\:even\\:pb-28:nth-child(even){
    padding-bottom: 7rem;
  }

  .\\33xl\\:even\\:pl-28:nth-child(even){
    padding-left: 7rem;
  }

  .\\33xl\\:even\\:pt-30:nth-child(even){
    padding-top: 7.5rem;
  }

  .\\33xl\\:even\\:pr-30:nth-child(even){
    padding-right: 7.5rem;
  }

  .\\33xl\\:even\\:pb-30:nth-child(even){
    padding-bottom: 7.5rem;
  }

  .\\33xl\\:even\\:pl-30:nth-child(even){
    padding-left: 7.5rem;
  }

  .\\33xl\\:even\\:pt-32:nth-child(even){
    padding-top: 8rem;
  }

  .\\33xl\\:even\\:pr-32:nth-child(even){
    padding-right: 8rem;
  }

  .\\33xl\\:even\\:pb-32:nth-child(even){
    padding-bottom: 8rem;
  }

  .\\33xl\\:even\\:pl-32:nth-child(even){
    padding-left: 8rem;
  }

  .\\33xl\\:even\\:pt-34:nth-child(even){
    padding-top: 8.5rem;
  }

  .\\33xl\\:even\\:pr-34:nth-child(even){
    padding-right: 8.5rem;
  }

  .\\33xl\\:even\\:pb-34:nth-child(even){
    padding-bottom: 8.5rem;
  }

  .\\33xl\\:even\\:pl-34:nth-child(even){
    padding-left: 8.5rem;
  }

  .\\33xl\\:even\\:pt-40:nth-child(even){
    padding-top: 10rem;
  }

  .\\33xl\\:even\\:pr-40:nth-child(even){
    padding-right: 10rem;
  }

  .\\33xl\\:even\\:pb-40:nth-child(even){
    padding-bottom: 10rem;
  }

  .\\33xl\\:even\\:pl-40:nth-child(even){
    padding-left: 10rem;
  }

  .\\33xl\\:even\\:pt-42:nth-child(even){
    padding-top: 10.5rem;
  }

  .\\33xl\\:even\\:pr-42:nth-child(even){
    padding-right: 10.5rem;
  }

  .\\33xl\\:even\\:pb-42:nth-child(even){
    padding-bottom: 10.5rem;
  }

  .\\33xl\\:even\\:pl-42:nth-child(even){
    padding-left: 10.5rem;
  }

  .\\33xl\\:even\\:pt-44:nth-child(even){
    padding-top: 11rem;
  }

  .\\33xl\\:even\\:pr-44:nth-child(even){
    padding-right: 11rem;
  }

  .\\33xl\\:even\\:pb-44:nth-child(even){
    padding-bottom: 11rem;
  }

  .\\33xl\\:even\\:pl-44:nth-child(even){
    padding-left: 11rem;
  }

  .\\33xl\\:even\\:pt-48:nth-child(even){
    padding-top: 12rem;
  }

  .\\33xl\\:even\\:pr-48:nth-child(even){
    padding-right: 12rem;
  }

  .\\33xl\\:even\\:pb-48:nth-child(even){
    padding-bottom: 12rem;
  }

  .\\33xl\\:even\\:pl-48:nth-child(even){
    padding-left: 12rem;
  }

  .\\33xl\\:even\\:pt-52:nth-child(even){
    padding-top: 13rem;
  }

  .\\33xl\\:even\\:pr-52:nth-child(even){
    padding-right: 13rem;
  }

  .\\33xl\\:even\\:pb-52:nth-child(even){
    padding-bottom: 13rem;
  }

  .\\33xl\\:even\\:pl-52:nth-child(even){
    padding-left: 13rem;
  }

  .\\33xl\\:even\\:pt-54:nth-child(even){
    padding-top: 13.5rem;
  }

  .\\33xl\\:even\\:pr-54:nth-child(even){
    padding-right: 13.5rem;
  }

  .\\33xl\\:even\\:pb-54:nth-child(even){
    padding-bottom: 13.5rem;
  }

  .\\33xl\\:even\\:pl-54:nth-child(even){
    padding-left: 13.5rem;
  }

  .\\33xl\\:even\\:pt-56:nth-child(even){
    padding-top: 14rem;
  }

  .\\33xl\\:even\\:pr-56:nth-child(even){
    padding-right: 14rem;
  }

  .\\33xl\\:even\\:pb-56:nth-child(even){
    padding-bottom: 14rem;
  }

  .\\33xl\\:even\\:pl-56:nth-child(even){
    padding-left: 14rem;
  }

  .\\33xl\\:even\\:pt-60:nth-child(even){
    padding-top: 15rem;
  }

  .\\33xl\\:even\\:pr-60:nth-child(even){
    padding-right: 15rem;
  }

  .\\33xl\\:even\\:pb-60:nth-child(even){
    padding-bottom: 15rem;
  }

  .\\33xl\\:even\\:pl-60:nth-child(even){
    padding-left: 15rem;
  }

  .\\33xl\\:even\\:pt-64:nth-child(even){
    padding-top: 16rem;
  }

  .\\33xl\\:even\\:pr-64:nth-child(even){
    padding-right: 16rem;
  }

  .\\33xl\\:even\\:pb-64:nth-child(even){
    padding-bottom: 16rem;
  }

  .\\33xl\\:even\\:pl-64:nth-child(even){
    padding-left: 16rem;
  }

  .\\33xl\\:even\\:pt-68:nth-child(even){
    padding-top: 17rem;
  }

  .\\33xl\\:even\\:pr-68:nth-child(even){
    padding-right: 17rem;
  }

  .\\33xl\\:even\\:pb-68:nth-child(even){
    padding-bottom: 17rem;
  }

  .\\33xl\\:even\\:pl-68:nth-child(even){
    padding-left: 17rem;
  }

  .\\33xl\\:even\\:pt-72:nth-child(even){
    padding-top: 18rem;
  }

  .\\33xl\\:even\\:pr-72:nth-child(even){
    padding-right: 18rem;
  }

  .\\33xl\\:even\\:pb-72:nth-child(even){
    padding-bottom: 18rem;
  }

  .\\33xl\\:even\\:pl-72:nth-child(even){
    padding-left: 18rem;
  }

  .\\33xl\\:even\\:pt-74:nth-child(even){
    padding-top: 18.5rem;
  }

  .\\33xl\\:even\\:pr-74:nth-child(even){
    padding-right: 18.5rem;
  }

  .\\33xl\\:even\\:pb-74:nth-child(even){
    padding-bottom: 18.5rem;
  }

  .\\33xl\\:even\\:pl-74:nth-child(even){
    padding-left: 18.5rem;
  }

  .\\33xl\\:even\\:pt-76:nth-child(even){
    padding-top: 19rem;
  }

  .\\33xl\\:even\\:pr-76:nth-child(even){
    padding-right: 19rem;
  }

  .\\33xl\\:even\\:pb-76:nth-child(even){
    padding-bottom: 19rem;
  }

  .\\33xl\\:even\\:pl-76:nth-child(even){
    padding-left: 19rem;
  }

  .\\33xl\\:even\\:pt-78:nth-child(even){
    padding-top: 19.5rem;
  }

  .\\33xl\\:even\\:pr-78:nth-child(even){
    padding-right: 19.5rem;
  }

  .\\33xl\\:even\\:pb-78:nth-child(even){
    padding-bottom: 19.5rem;
  }

  .\\33xl\\:even\\:pl-78:nth-child(even){
    padding-left: 19.5rem;
  }

  .\\33xl\\:even\\:pt-80:nth-child(even){
    padding-top: 20rem;
  }

  .\\33xl\\:even\\:pr-80:nth-child(even){
    padding-right: 20rem;
  }

  .\\33xl\\:even\\:pb-80:nth-child(even){
    padding-bottom: 20rem;
  }

  .\\33xl\\:even\\:pl-80:nth-child(even){
    padding-left: 20rem;
  }

  .\\33xl\\:even\\:pt-82:nth-child(even){
    padding-top: 20.5rem;
  }

  .\\33xl\\:even\\:pr-82:nth-child(even){
    padding-right: 20.5rem;
  }

  .\\33xl\\:even\\:pb-82:nth-child(even){
    padding-bottom: 20.5rem;
  }

  .\\33xl\\:even\\:pl-82:nth-child(even){
    padding-left: 20.5rem;
  }

  .\\33xl\\:even\\:pt-84:nth-child(even){
    padding-top: 21rem;
  }

  .\\33xl\\:even\\:pr-84:nth-child(even){
    padding-right: 21rem;
  }

  .\\33xl\\:even\\:pb-84:nth-child(even){
    padding-bottom: 21rem;
  }

  .\\33xl\\:even\\:pl-84:nth-child(even){
    padding-left: 21rem;
  }

  .\\33xl\\:even\\:pt-88:nth-child(even){
    padding-top: 22rem;
  }

  .\\33xl\\:even\\:pr-88:nth-child(even){
    padding-right: 22rem;
  }

  .\\33xl\\:even\\:pb-88:nth-child(even){
    padding-bottom: 22rem;
  }

  .\\33xl\\:even\\:pl-88:nth-child(even){
    padding-left: 22rem;
  }

  .\\33xl\\:even\\:pt-92:nth-child(even){
    padding-top: 23rem;
  }

  .\\33xl\\:even\\:pr-92:nth-child(even){
    padding-right: 23rem;
  }

  .\\33xl\\:even\\:pb-92:nth-child(even){
    padding-bottom: 23rem;
  }

  .\\33xl\\:even\\:pl-92:nth-child(even){
    padding-left: 23rem;
  }

  .\\33xl\\:even\\:pt-96:nth-child(even){
    padding-top: 24rem;
  }

  .\\33xl\\:even\\:pr-96:nth-child(even){
    padding-right: 24rem;
  }

  .\\33xl\\:even\\:pb-96:nth-child(even){
    padding-bottom: 24rem;
  }

  .\\33xl\\:even\\:pl-96:nth-child(even){
    padding-left: 24rem;
  }

  .\\33xl\\:even\\:pt-98:nth-child(even){
    padding-top: 24.5rem;
  }

  .\\33xl\\:even\\:pr-98:nth-child(even){
    padding-right: 24.5rem;
  }

  .\\33xl\\:even\\:pb-98:nth-child(even){
    padding-bottom: 24.5rem;
  }

  .\\33xl\\:even\\:pl-98:nth-child(even){
    padding-left: 24.5rem;
  }

  .\\33xl\\:even\\:pt-100:nth-child(even){
    padding-top: 25rem;
  }

  .\\33xl\\:even\\:pr-100:nth-child(even){
    padding-right: 25rem;
  }

  .\\33xl\\:even\\:pb-100:nth-child(even){
    padding-bottom: 25rem;
  }

  .\\33xl\\:even\\:pl-100:nth-child(even){
    padding-left: 25rem;
  }

  .\\33xl\\:even\\:pt-104:nth-child(even){
    padding-top: 26rem;
  }

  .\\33xl\\:even\\:pr-104:nth-child(even){
    padding-right: 26rem;
  }

  .\\33xl\\:even\\:pb-104:nth-child(even){
    padding-bottom: 26rem;
  }

  .\\33xl\\:even\\:pl-104:nth-child(even){
    padding-left: 26rem;
  }

  .\\33xl\\:even\\:pt-112:nth-child(even){
    padding-top: 28rem;
  }

  .\\33xl\\:even\\:pr-112:nth-child(even){
    padding-right: 28rem;
  }

  .\\33xl\\:even\\:pb-112:nth-child(even){
    padding-bottom: 28rem;
  }

  .\\33xl\\:even\\:pl-112:nth-child(even){
    padding-left: 28rem;
  }

  .\\33xl\\:even\\:pt-124:nth-child(even){
    padding-top: 31rem;
  }

  .\\33xl\\:even\\:pr-124:nth-child(even){
    padding-right: 31rem;
  }

  .\\33xl\\:even\\:pb-124:nth-child(even){
    padding-bottom: 31rem;
  }

  .\\33xl\\:even\\:pl-124:nth-child(even){
    padding-left: 31rem;
  }

  .\\33xl\\:even\\:pt-128:nth-child(even){
    padding-top: 32rem;
  }

  .\\33xl\\:even\\:pr-128:nth-child(even){
    padding-right: 32rem;
  }

  .\\33xl\\:even\\:pb-128:nth-child(even){
    padding-bottom: 32rem;
  }

  .\\33xl\\:even\\:pl-128:nth-child(even){
    padding-left: 32rem;
  }

  .\\33xl\\:even\\:pt-140:nth-child(even){
    padding-top: 35rem;
  }

  .\\33xl\\:even\\:pr-140:nth-child(even){
    padding-right: 35rem;
  }

  .\\33xl\\:even\\:pb-140:nth-child(even){
    padding-bottom: 35rem;
  }

  .\\33xl\\:even\\:pl-140:nth-child(even){
    padding-left: 35rem;
  }

  .\\33xl\\:even\\:pt-152:nth-child(even){
    padding-top: 38rem;
  }

  .\\33xl\\:even\\:pr-152:nth-child(even){
    padding-right: 38rem;
  }

  .\\33xl\\:even\\:pb-152:nth-child(even){
    padding-bottom: 38rem;
  }

  .\\33xl\\:even\\:pl-152:nth-child(even){
    padding-left: 38rem;
  }

  .\\33xl\\:even\\:pt-160:nth-child(even){
    padding-top: 40rem;
  }

  .\\33xl\\:even\\:pr-160:nth-child(even){
    padding-right: 40rem;
  }

  .\\33xl\\:even\\:pb-160:nth-child(even){
    padding-bottom: 40rem;
  }

  .\\33xl\\:even\\:pl-160:nth-child(even){
    padding-left: 40rem;
  }

  .\\33xl\\:even\\:pt-162:nth-child(even){
    padding-top: 41rem;
  }

  .\\33xl\\:even\\:pr-162:nth-child(even){
    padding-right: 41rem;
  }

  .\\33xl\\:even\\:pb-162:nth-child(even){
    padding-bottom: 41rem;
  }

  .\\33xl\\:even\\:pl-162:nth-child(even){
    padding-left: 41rem;
  }

  .\\33xl\\:even\\:pt-192:nth-child(even){
    padding-top: 48rem;
  }

  .\\33xl\\:even\\:pr-192:nth-child(even){
    padding-right: 48rem;
  }

  .\\33xl\\:even\\:pb-192:nth-child(even){
    padding-bottom: 48rem;
  }

  .\\33xl\\:even\\:pl-192:nth-child(even){
    padding-left: 48rem;
  }

  .\\33xl\\:even\\:pt-208:nth-child(even){
    padding-top: 52rem;
  }

  .\\33xl\\:even\\:pr-208:nth-child(even){
    padding-right: 52rem;
  }

  .\\33xl\\:even\\:pb-208:nth-child(even){
    padding-bottom: 52rem;
  }

  .\\33xl\\:even\\:pl-208:nth-child(even){
    padding-left: 52rem;
  }

  .\\33xl\\:even\\:pt-224:nth-child(even){
    padding-top: 56rem;
  }

  .\\33xl\\:even\\:pr-224:nth-child(even){
    padding-right: 56rem;
  }

  .\\33xl\\:even\\:pb-224:nth-child(even){
    padding-bottom: 56rem;
  }

  .\\33xl\\:even\\:pl-224:nth-child(even){
    padding-left: 56rem;
  }

  .\\33xl\\:even\\:pt-256:nth-child(even){
    padding-top: 64rem;
  }

  .\\33xl\\:even\\:pr-256:nth-child(even){
    padding-right: 64rem;
  }

  .\\33xl\\:even\\:pb-256:nth-child(even){
    padding-bottom: 64rem;
  }

  .\\33xl\\:even\\:pl-256:nth-child(even){
    padding-left: 64rem;
  }

  .\\33xl\\:even\\:pt-px:nth-child(even){
    padding-top: 1px;
  }

  .\\33xl\\:even\\:pr-px:nth-child(even){
    padding-right: 1px;
  }

  .\\33xl\\:even\\:pb-px:nth-child(even){
    padding-bottom: 1px;
  }

  .\\33xl\\:even\\:pl-px:nth-child(even){
    padding-left: 1px;
  }

  .\\33xl\\:placeholder-transparent::placeholder{
    color: transparent;
  }

  .\\33xl\\:placeholder-focus::placeholder{
    color: rgba(4, 21, 39, 0.8);;
  }

  .\\33xl\\:placeholder-black::placeholder{
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-white::placeholder{
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-primary::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-disabled::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-translucent-60::placeholder{
    color: rgba(256, 256, 256, 0.6);
  }

  .\\33xl\\:placeholder-translucent-90::placeholder{
    color: rgba(256, 256, 256, 0.9);
  }

  .\\33xl\\:placeholder-green-200::placeholder{
    --placeholder-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-green-400::placeholder{
    --placeholder-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-green-500::placeholder{
    --placeholder-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-green-600::placeholder{
    --placeholder-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-green-700::placeholder{
    --placeholder-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-green-400a50::placeholder{
    color: rgba(108,202,152,0.50196);
  }

  .\\33xl\\:placeholder-green-500a25::placeholder{
    color: rgba(151,232,18,0.09804);
  }

  .\\33xl\\:placeholder-yellow-200::placeholder{
    --placeholder-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-yellow-300::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-yellow-500::placeholder{
    --placeholder-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-yellow-600::placeholder{
    --placeholder-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-yellow-700::placeholder{
    --placeholder-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-yellow-300a66::placeholder{
    color: rgba(255,233,189,0.66667);
  }

  .\\33xl\\:placeholder-yellow-500a25::placeholder{
    color: rgba(255,200,44,0.09804);
  }

  .\\33xl\\:placeholder-orange-200::placeholder{
    --placeholder-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-orange-400::placeholder{
    --placeholder-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-orange-500::placeholder{
    --placeholder-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-orange-800::placeholder{
    --placeholder-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-orange-900::placeholder{
    --placeholder-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-orange-500a25::placeholder{
    color: rgba(240,115,23,0.09804);
  }

  .\\33xl\\:placeholder-red-100::placeholder{
    --placeholder-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-red-150::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-red-200::placeholder{
    --placeholder-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-red-300::placeholder{
    --placeholder-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-red-400::placeholder{
    --placeholder-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-red-500::placeholder{
    --placeholder-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-red-700::placeholder{
    --placeholder-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-gray-50::placeholder{
    --placeholder-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-gray-100::placeholder{
    --placeholder-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-gray-150::placeholder{
    --placeholder-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-gray-200::placeholder{
    --placeholder-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-gray-300::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-gray-400::placeholder{
    color: rgba(114,114,114,0.8);
  }

  .\\33xl\\:placeholder-gray-425::placeholder{
    color: rgba(4, 21, 39, 0.8);
  }

  .\\33xl\\:placeholder-gray-450::placeholder{
    --placeholder-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-gray-500::placeholder{
    --placeholder-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-gray-600::placeholder{
    --placeholder-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-gray-625::placeholder{
    color: rgba(90,98,107,0.8);
  }

  .\\33xl\\:placeholder-gray-700::placeholder{
    --placeholder-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-gray-800::placeholder{
    --placeholder-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-gray-200a50::placeholder{
    color: rgba(224, 226, 228, 0.5);
  }

  .\\33xl\\:placeholder-blue-50::placeholder{
    --placeholder-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-blue-100::placeholder{
    --placeholder-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-blue-150::placeholder{
    --placeholder-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-blue-200::placeholder{
    --placeholder-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-blue-300::placeholder{
    --placeholder-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-blue-400::placeholder{
    --placeholder-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-blue-500::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-blue-600::placeholder{
    --placeholder-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-blue-700::placeholder{
    --placeholder-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-blue-750::placeholder{
    --placeholder-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-blue-800::placeholder{
    --placeholder-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-blue-900::placeholder{
    --placeholder-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-blue-950::placeholder{
    --placeholder-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-blue-500a25::placeholder{
    color: rgba(55, 164, 220, 0.2);
  }

  .\\33xl\\:placeholder-blue-500a50::placeholder{
    color: rgba(55, 164, 220, 0.5);
  }

  .\\33xl\\:placeholder-blue-700a75::placeholder{
    --placeholder-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-blue-700a30::placeholder{
    --placeholder-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-blue-750a25::placeholder{
    color: rgba(86,130,170,0.09804);
  }

  .\\33xl\\:placeholder-blue-750a15::placeholder{
    color: rgba(86,130,170,0.05882);
  }

  .\\33xl\\:placeholder-blue-800a60::placeholder{
    color: rgba(31, 69, 102, 0.6);
  }

  .\\33xl\\:placeholder-programEditorTabColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-programEditorTabColors-2::placeholder{
    --placeholder-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-programEditorTabColors-3::placeholder{
    --placeholder-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-programEditorTabColors-4::placeholder{
    --placeholder-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-programEditorTabColors-5::placeholder{
    --placeholder-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-programEditorTabColors-6::placeholder{
    --placeholder-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-programEditorTabColors-1h::placeholder{
    --placeholder-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-programEditorTabColors-2h::placeholder{
    --placeholder-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-programEditorTabColors-3h::placeholder{
    --placeholder-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-programEditorTabColors-4h::placeholder{
    --placeholder-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-programEditorTabColors-5h::placeholder{
    --placeholder-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-programEditorTabColors-6h::placeholder{
    --placeholder-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-programEditorPresetTabColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-programEditorPresetTabColors-1h::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-borgScaleColors-0::placeholder{
    --placeholder-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-borgScaleColors-1::placeholder{
    --placeholder-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-borgScaleColors-2::placeholder{
    --placeholder-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-borgScaleColors-3::placeholder{
    --placeholder-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-borgScaleColors-4::placeholder{
    --placeholder-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-borgScaleColors-5::placeholder{
    --placeholder-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-borgScaleColors-6::placeholder{
    --placeholder-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-borgScaleColors-7::placeholder{
    --placeholder-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-borgScaleColors-8::placeholder{
    --placeholder-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-borgScaleColors-9::placeholder{
    --placeholder-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-borgScaleColors-10::placeholder{
    --placeholder-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-transparent:focus::placeholder{
    color: transparent;
  }

  .\\33xl\\:focus\\:placeholder-focus:focus::placeholder{
    color: rgba(4, 21, 39, 0.8);;
  }

  .\\33xl\\:focus\\:placeholder-black:focus::placeholder{
    --placeholder-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-white:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-primary:focus::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-disabled:focus::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-translucent-60:focus::placeholder{
    color: rgba(256, 256, 256, 0.6);
  }

  .\\33xl\\:focus\\:placeholder-translucent-90:focus::placeholder{
    color: rgba(256, 256, 256, 0.9);
  }

  .\\33xl\\:focus\\:placeholder-green-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-green-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-green-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-green-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-green-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-green-400a50:focus::placeholder{
    color: rgba(108,202,152,0.50196);
  }

  .\\33xl\\:focus\\:placeholder-green-500a25:focus::placeholder{
    color: rgba(151,232,18,0.09804);
  }

  .\\33xl\\:focus\\:placeholder-yellow-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-yellow-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-yellow-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-yellow-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-yellow-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-yellow-300a66:focus::placeholder{
    color: rgba(255,233,189,0.66667);
  }

  .\\33xl\\:focus\\:placeholder-yellow-500a25:focus::placeholder{
    color: rgba(255,200,44,0.09804);
  }

  .\\33xl\\:focus\\:placeholder-orange-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-orange-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-orange-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-orange-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-orange-900:focus::placeholder{
    --placeholder-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-orange-500a25:focus::placeholder{
    color: rgba(240,115,23,0.09804);
  }

  .\\33xl\\:focus\\:placeholder-red-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-red-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-red-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-red-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-red-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-red-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-red-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-gray-50:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-gray-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-gray-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-gray-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-gray-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-gray-400:focus::placeholder{
    color: rgba(114,114,114,0.8);
  }

  .\\33xl\\:focus\\:placeholder-gray-425:focus::placeholder{
    color: rgba(4, 21, 39, 0.8);
  }

  .\\33xl\\:focus\\:placeholder-gray-450:focus::placeholder{
    --placeholder-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-gray-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-gray-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-gray-625:focus::placeholder{
    color: rgba(90,98,107,0.8);
  }

  .\\33xl\\:focus\\:placeholder-gray-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-gray-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-gray-200a50:focus::placeholder{
    color: rgba(224, 226, 228, 0.5);
  }

  .\\33xl\\:focus\\:placeholder-blue-50:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-blue-100:focus::placeholder{
    --placeholder-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-blue-150:focus::placeholder{
    --placeholder-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-blue-200:focus::placeholder{
    --placeholder-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-blue-300:focus::placeholder{
    --placeholder-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-blue-400:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-blue-500:focus::placeholder{
    --placeholder-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-blue-600:focus::placeholder{
    --placeholder-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-blue-700:focus::placeholder{
    --placeholder-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-blue-750:focus::placeholder{
    --placeholder-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-blue-800:focus::placeholder{
    --placeholder-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-blue-900:focus::placeholder{
    --placeholder-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-blue-950:focus::placeholder{
    --placeholder-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-blue-500a25:focus::placeholder{
    color: rgba(55, 164, 220, 0.2);
  }

  .\\33xl\\:focus\\:placeholder-blue-500a50:focus::placeholder{
    color: rgba(55, 164, 220, 0.5);
  }

  .\\33xl\\:focus\\:placeholder-blue-700a75:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-blue-700a30:focus::placeholder{
    --placeholder-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-blue-750a25:focus::placeholder{
    color: rgba(86,130,170,0.09804);
  }

  .\\33xl\\:focus\\:placeholder-blue-750a15:focus::placeholder{
    color: rgba(86,130,170,0.05882);
  }

  .\\33xl\\:focus\\:placeholder-blue-800a60:focus::placeholder{
    color: rgba(31, 69, 102, 0.6);
  }

  .\\33xl\\:focus\\:placeholder-programEditorTabColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-programEditorTabColors-2:focus::placeholder{
    --placeholder-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-programEditorTabColors-3:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-programEditorTabColors-4:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-programEditorTabColors-5:focus::placeholder{
    --placeholder-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-programEditorTabColors-6:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-programEditorTabColors-1h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-programEditorTabColors-2h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-programEditorTabColors-3h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-programEditorTabColors-4h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-programEditorTabColors-5h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-programEditorTabColors-6h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-programEditorPresetTabColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-programEditorPresetTabColors-1h:focus::placeholder{
    --placeholder-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-borgScaleColors-0:focus::placeholder{
    --placeholder-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-borgScaleColors-1:focus::placeholder{
    --placeholder-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-borgScaleColors-2:focus::placeholder{
    --placeholder-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-borgScaleColors-3:focus::placeholder{
    --placeholder-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-borgScaleColors-4:focus::placeholder{
    --placeholder-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-borgScaleColors-5:focus::placeholder{
    --placeholder-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-borgScaleColors-6:focus::placeholder{
    --placeholder-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-borgScaleColors-7:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-borgScaleColors-8:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-borgScaleColors-9:focus::placeholder{
    --placeholder-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, var(--placeholder-opacity));
  }

  .\\33xl\\:focus\\:placeholder-borgScaleColors-10:focus::placeholder{
    --placeholder-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, var(--placeholder-opacity));
  }

  .\\33xl\\:placeholder-opacity-0::placeholder{
    --placeholder-opacity: 0;
  }

  .\\33xl\\:placeholder-opacity-25::placeholder{
    --placeholder-opacity: .25;
  }

  .\\33xl\\:placeholder-opacity-50::placeholder{
    --placeholder-opacity: .5;
  }

  .\\33xl\\:placeholder-opacity-75::placeholder{
    --placeholder-opacity: .75;
  }

  .\\33xl\\:placeholder-opacity-100::placeholder{
    --placeholder-opacity: 1;
  }

  .\\33xl\\:focus\\:placeholder-opacity-0:focus::placeholder{
    --placeholder-opacity: 0;
  }

  .\\33xl\\:focus\\:placeholder-opacity-25:focus::placeholder{
    --placeholder-opacity: .25;
  }

  .\\33xl\\:focus\\:placeholder-opacity-50:focus::placeholder{
    --placeholder-opacity: .5;
  }

  .\\33xl\\:focus\\:placeholder-opacity-75:focus::placeholder{
    --placeholder-opacity: .75;
  }

  .\\33xl\\:focus\\:placeholder-opacity-100:focus::placeholder{
    --placeholder-opacity: 1;
  }

  .\\33xl\\:pointer-events-none{
    pointer-events: none;
  }

  .\\33xl\\:pointer-events-auto{
    pointer-events: auto;
  }

  .\\33xl\\:static{
    position: static;
  }

  .\\33xl\\:fixed{
    position: fixed;
  }

  .\\33xl\\:absolute{
    position: absolute;
  }

  .\\33xl\\:relative{
    position: relative;
  }

  .\\33xl\\:sticky{
    position: sticky;
  }

  .\\33xl\\:inset-0{
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .\\33xl\\:inset-auto{
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
  }

  .\\33xl\\:inset-y-0{
    top: 0;
    bottom: 0;
  }

  .\\33xl\\:inset-x-0{
    right: 0;
    left: 0;
  }

  .\\33xl\\:inset-y-auto{
    top: auto;
    bottom: auto;
  }

  .\\33xl\\:inset-x-auto{
    right: auto;
    left: auto;
  }

  .\\33xl\\:top-0{
    top: 0;
  }

  .\\33xl\\:right-0{
    right: 0;
  }

  .\\33xl\\:bottom-0{
    bottom: 0;
  }

  .\\33xl\\:left-0{
    left: 0;
  }

  .\\33xl\\:top-auto{
    top: auto;
  }

  .\\33xl\\:right-auto{
    right: auto;
  }

  .\\33xl\\:bottom-auto{
    bottom: auto;
  }

  .\\33xl\\:left-auto{
    left: auto;
  }

  .\\33xl\\:resize-none{
    resize: none;
  }

  .\\33xl\\:resize-y{
    resize: vertical;
  }

  .\\33xl\\:resize-x{
    resize: horizontal;
  }

  .\\33xl\\:resize{
    resize: both;
  }

  .\\33xl\\:shadow{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .\\33xl\\:shadow-overlaptop{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .\\33xl\\:shadow-overlapbottom{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .\\33xl\\:shadow-xs{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .\\33xl\\:shadow-sm{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .\\33xl\\:shadow-md{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .\\33xl\\:shadow-lg{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .\\33xl\\:shadow-xl{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .\\33xl\\:shadow-2xl{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .\\33xl\\:shadow-none{
    box-shadow: none;
  }

  .\\33xl\\:hover\\:shadow:hover{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .\\33xl\\:hover\\:shadow-overlaptop:hover{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .\\33xl\\:hover\\:shadow-overlapbottom:hover{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .\\33xl\\:hover\\:shadow-xs:hover{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .\\33xl\\:hover\\:shadow-sm:hover{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .\\33xl\\:hover\\:shadow-md:hover{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .\\33xl\\:hover\\:shadow-lg:hover{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .\\33xl\\:hover\\:shadow-xl:hover{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .\\33xl\\:hover\\:shadow-2xl:hover{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .\\33xl\\:hover\\:shadow-none:hover{
    box-shadow: none;
  }

  .\\33xl\\:focus\\:shadow:focus{
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05), 0 1px 2px 3px rgba(0, 0, 0, 0.06);
  }

  .\\33xl\\:focus\\:shadow-overlaptop:focus{
    box-shadow: rgba(0, 0, 0, 0.1) 0px -7px 3px -2px;
  }

  .\\33xl\\:focus\\:shadow-overlapbottom:focus{
    box-shadow: rgba(0, 0, 0, 0.1) 0px 7px 3px -2px;
  }

  .\\33xl\\:focus\\:shadow-xs:focus{
    box-shadow: 4px -2px 1px rgba(0, 0, 0, 0.02), -1px 1px 1px 2px rgba(0, 0, 0, 0.01);
  }

  .\\33xl\\:focus\\:shadow-sm:focus{
    box-shadow: 0 1px 1px 0 rgba(0, 0, 0, 0.05), 0 1px 1px 1px rgba(0, 0, 0, 0.06);
  }

  .\\33xl\\:focus\\:shadow-md:focus{
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }

  .\\33xl\\:focus\\:shadow-lg:focus{
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  }

  .\\33xl\\:focus\\:shadow-xl:focus{
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  }

  .\\33xl\\:focus\\:shadow-2xl:focus{
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  }

  .\\33xl\\:focus\\:shadow-none:focus{
    box-shadow: none;
  }

  .\\33xl\\:stroke-0{
    stroke-width: 0;
  }

  .\\33xl\\:stroke-1{
    stroke-width: 1;
  }

  .\\33xl\\:stroke-2{
    stroke-width: 2;
  }

  .\\33xl\\:table-auto{
    table-layout: auto;
  }

  .\\33xl\\:table-fixed{
    table-layout: fixed;
  }

  .\\33xl\\:text-left{
    text-align: left;
  }

  .\\33xl\\:text-center{
    text-align: center;
  }

  .\\33xl\\:text-right{
    text-align: right;
  }

  .\\33xl\\:text-justify{
    text-align: justify;
  }

  .\\33xl\\:text-transparent{
    color: transparent;
  }

  .\\33xl\\:text-focus{
    color: rgba(4, 21, 39, 0.8);;
  }

  .\\33xl\\:text-black{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .\\33xl\\:text-white{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .\\33xl\\:text-primary{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .\\33xl\\:text-disabled{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .\\33xl\\:text-translucent-60{
    color: rgba(256, 256, 256, 0.6);
  }

  .\\33xl\\:text-translucent-90{
    color: rgba(256, 256, 256, 0.9);
  }

  .\\33xl\\:text-green-200{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .\\33xl\\:text-green-400{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .\\33xl\\:text-green-500{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .\\33xl\\:text-green-600{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .\\33xl\\:text-green-700{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .\\33xl\\:text-green-400a50{
    color: rgba(108,202,152,0.50196);
  }

  .\\33xl\\:text-green-500a25{
    color: rgba(151,232,18,0.09804);
  }

  .\\33xl\\:text-yellow-200{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .\\33xl\\:text-yellow-300{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .\\33xl\\:text-yellow-500{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .\\33xl\\:text-yellow-600{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .\\33xl\\:text-yellow-700{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .\\33xl\\:text-yellow-300a66{
    color: rgba(255,233,189,0.66667);
  }

  .\\33xl\\:text-yellow-500a25{
    color: rgba(255,200,44,0.09804);
  }

  .\\33xl\\:text-orange-200{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .\\33xl\\:text-orange-400{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .\\33xl\\:text-orange-500{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .\\33xl\\:text-orange-800{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .\\33xl\\:text-orange-900{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .\\33xl\\:text-orange-500a25{
    color: rgba(240,115,23,0.09804);
  }

  .\\33xl\\:text-red-100{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .\\33xl\\:text-red-150{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .\\33xl\\:text-red-200{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .\\33xl\\:text-red-300{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .\\33xl\\:text-red-400{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .\\33xl\\:text-red-500{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .\\33xl\\:text-red-700{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .\\33xl\\:text-gray-50{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .\\33xl\\:text-gray-100{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .\\33xl\\:text-gray-150{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .\\33xl\\:text-gray-200{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .\\33xl\\:text-gray-300{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .\\33xl\\:text-gray-400{
    color: rgba(114,114,114,0.8);
  }

  .\\33xl\\:text-gray-425{
    color: rgba(4, 21, 39, 0.8);
  }

  .\\33xl\\:text-gray-450{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .\\33xl\\:text-gray-500{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .\\33xl\\:text-gray-600{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .\\33xl\\:text-gray-625{
    color: rgba(90,98,107,0.8);
  }

  .\\33xl\\:text-gray-700{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .\\33xl\\:text-gray-800{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .\\33xl\\:text-gray-200a50{
    color: rgba(224, 226, 228, 0.5);
  }

  .\\33xl\\:text-blue-50{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .\\33xl\\:text-blue-100{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .\\33xl\\:text-blue-150{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .\\33xl\\:text-blue-200{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .\\33xl\\:text-blue-300{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .\\33xl\\:text-blue-400{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .\\33xl\\:text-blue-500{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .\\33xl\\:text-blue-600{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .\\33xl\\:text-blue-700{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .\\33xl\\:text-blue-750{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .\\33xl\\:text-blue-800{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .\\33xl\\:text-blue-900{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .\\33xl\\:text-blue-950{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .\\33xl\\:text-blue-500a25{
    color: rgba(55, 164, 220, 0.2);
  }

  .\\33xl\\:text-blue-500a50{
    color: rgba(55, 164, 220, 0.5);
  }

  .\\33xl\\:text-blue-700a75{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .\\33xl\\:text-blue-700a30{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .\\33xl\\:text-blue-750a25{
    color: rgba(86,130,170,0.09804);
  }

  .\\33xl\\:text-blue-750a15{
    color: rgba(86,130,170,0.05882);
  }

  .\\33xl\\:text-blue-800a60{
    color: rgba(31, 69, 102, 0.6);
  }

  .\\33xl\\:text-programEditorTabColors-1{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .\\33xl\\:text-programEditorTabColors-2{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .\\33xl\\:text-programEditorTabColors-3{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .\\33xl\\:text-programEditorTabColors-4{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .\\33xl\\:text-programEditorTabColors-5{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .\\33xl\\:text-programEditorTabColors-6{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .\\33xl\\:text-programEditorTabColors-1h{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .\\33xl\\:text-programEditorTabColors-2h{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .\\33xl\\:text-programEditorTabColors-3h{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .\\33xl\\:text-programEditorTabColors-4h{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .\\33xl\\:text-programEditorTabColors-5h{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .\\33xl\\:text-programEditorTabColors-6h{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .\\33xl\\:text-programEditorPresetTabColors-1{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .\\33xl\\:text-programEditorPresetTabColors-1h{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .\\33xl\\:text-borgScaleColors-0{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .\\33xl\\:text-borgScaleColors-1{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .\\33xl\\:text-borgScaleColors-2{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .\\33xl\\:text-borgScaleColors-3{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .\\33xl\\:text-borgScaleColors-4{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .\\33xl\\:text-borgScaleColors-5{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .\\33xl\\:text-borgScaleColors-6{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .\\33xl\\:text-borgScaleColors-7{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .\\33xl\\:text-borgScaleColors-8{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .\\33xl\\:text-borgScaleColors-9{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .\\33xl\\:text-borgScaleColors-10{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-transparent:hover{
    color: transparent;
  }

  .\\33xl\\:hover\\:text-focus:hover{
    color: rgba(4, 21, 39, 0.8);;
  }

  .\\33xl\\:hover\\:text-black:hover{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-white:hover{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-primary:hover{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-disabled:hover{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-translucent-60:hover{
    color: rgba(256, 256, 256, 0.6);
  }

  .\\33xl\\:hover\\:text-translucent-90:hover{
    color: rgba(256, 256, 256, 0.9);
  }

  .\\33xl\\:hover\\:text-green-200:hover{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-green-400:hover{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-green-500:hover{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-green-600:hover{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-green-700:hover{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-green-400a50:hover{
    color: rgba(108,202,152,0.50196);
  }

  .\\33xl\\:hover\\:text-green-500a25:hover{
    color: rgba(151,232,18,0.09804);
  }

  .\\33xl\\:hover\\:text-yellow-200:hover{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-yellow-300:hover{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-yellow-500:hover{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-yellow-600:hover{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-yellow-700:hover{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-yellow-300a66:hover{
    color: rgba(255,233,189,0.66667);
  }

  .\\33xl\\:hover\\:text-yellow-500a25:hover{
    color: rgba(255,200,44,0.09804);
  }

  .\\33xl\\:hover\\:text-orange-200:hover{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-orange-400:hover{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-orange-500:hover{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-orange-800:hover{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-orange-900:hover{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-orange-500a25:hover{
    color: rgba(240,115,23,0.09804);
  }

  .\\33xl\\:hover\\:text-red-100:hover{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-red-150:hover{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-red-200:hover{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-red-300:hover{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-red-400:hover{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-red-500:hover{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-red-700:hover{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-gray-50:hover{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-gray-100:hover{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-gray-150:hover{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-gray-200:hover{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-gray-300:hover{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-gray-400:hover{
    color: rgba(114,114,114,0.8);
  }

  .\\33xl\\:hover\\:text-gray-425:hover{
    color: rgba(4, 21, 39, 0.8);
  }

  .\\33xl\\:hover\\:text-gray-450:hover{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-gray-500:hover{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-gray-600:hover{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-gray-625:hover{
    color: rgba(90,98,107,0.8);
  }

  .\\33xl\\:hover\\:text-gray-700:hover{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-gray-800:hover{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-gray-200a50:hover{
    color: rgba(224, 226, 228, 0.5);
  }

  .\\33xl\\:hover\\:text-blue-50:hover{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-blue-100:hover{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-blue-150:hover{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-blue-200:hover{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-blue-300:hover{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-blue-400:hover{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-blue-500:hover{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-blue-600:hover{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-blue-700:hover{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-blue-750:hover{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-blue-800:hover{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-blue-900:hover{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-blue-950:hover{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-blue-500a25:hover{
    color: rgba(55, 164, 220, 0.2);
  }

  .\\33xl\\:hover\\:text-blue-500a50:hover{
    color: rgba(55, 164, 220, 0.5);
  }

  .\\33xl\\:hover\\:text-blue-700a75:hover{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-blue-700a30:hover{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-blue-750a25:hover{
    color: rgba(86,130,170,0.09804);
  }

  .\\33xl\\:hover\\:text-blue-750a15:hover{
    color: rgba(86,130,170,0.05882);
  }

  .\\33xl\\:hover\\:text-blue-800a60:hover{
    color: rgba(31, 69, 102, 0.6);
  }

  .\\33xl\\:hover\\:text-programEditorTabColors-1:hover{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-programEditorTabColors-2:hover{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-programEditorTabColors-3:hover{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-programEditorTabColors-4:hover{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-programEditorTabColors-5:hover{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-programEditorTabColors-6:hover{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-programEditorTabColors-1h:hover{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-programEditorTabColors-2h:hover{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-programEditorTabColors-3h:hover{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-programEditorTabColors-4h:hover{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-programEditorTabColors-5h:hover{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-programEditorTabColors-6h:hover{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-programEditorPresetTabColors-1:hover{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-programEditorPresetTabColors-1h:hover{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-borgScaleColors-0:hover{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-borgScaleColors-1:hover{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-borgScaleColors-2:hover{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-borgScaleColors-3:hover{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-borgScaleColors-4:hover{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-borgScaleColors-5:hover{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-borgScaleColors-6:hover{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-borgScaleColors-7:hover{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-borgScaleColors-8:hover{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-borgScaleColors-9:hover{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .\\33xl\\:hover\\:text-borgScaleColors-10:hover{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-transparent:focus{
    color: transparent;
  }

  .\\33xl\\:focus\\:text-focus:focus{
    color: rgba(4, 21, 39, 0.8);;
  }

  .\\33xl\\:focus\\:text-black:focus{
    --text-opacity: 1;
    color: #000;
    color: rgba(0, 0, 0, 1);
    color: rgba(0, 0, 0, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-white:focus{
    --text-opacity: 1;
    color: #fff;
    color: rgba(255, 255, 255, 1);
    color: rgba(255, 255, 255, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-primary:focus{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-disabled:focus{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-translucent-60:focus{
    color: rgba(256, 256, 256, 0.6);
  }

  .\\33xl\\:focus\\:text-translucent-90:focus{
    color: rgba(256, 256, 256, 0.9);
  }

  .\\33xl\\:focus\\:text-green-200:focus{
    --text-opacity: 1;
    color: #f4fcea;
    color: rgba(244, 252, 234, 1);
    color: rgba(244, 252, 234, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-green-400:focus{
    --text-opacity: 1;
    color: #6CCA98;
    color: rgba(108, 202, 152, 1);
    color: rgba(108, 202, 152, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-green-500:focus{
    --text-opacity: 1;
    color: #97E812;
    color: rgba(151, 232, 18, 1);
    color: rgba(151, 232, 18, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-green-600:focus{
    --text-opacity: 1;
    color: #4f9112;
    color: rgba(79, 145, 18, 1);
    color: rgba(79, 145, 18, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-green-700:focus{
    --text-opacity: 1;
    color: #3e7211;
    color: rgba(62, 114, 17, 1);
    color: rgba(62, 114, 17, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-green-400a50:focus{
    color: rgba(108,202,152,0.50196);
  }

  .\\33xl\\:focus\\:text-green-500a25:focus{
    color: rgba(151,232,18,0.09804);
  }

  .\\33xl\\:focus\\:text-yellow-200:focus{
    --text-opacity: 1;
    color: #fff9eb;
    color: rgba(255, 249, 235, 1);
    color: rgba(255, 249, 235, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-yellow-300:focus{
    --text-opacity: 1;
    color: #ffe9bd;
    color: rgba(255, 233, 189, 1);
    color: rgba(255, 233, 189, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-yellow-500:focus{
    --text-opacity: 1;
    color: #FFC82C;
    color: rgba(255, 200, 44, 1);
    color: rgba(255, 200, 44, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-yellow-600:focus{
    --text-opacity: 1;
    color: #F7931E;
    color: rgba(247, 147, 30, 1);
    color: rgba(247, 147, 30, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-yellow-700:focus{
    --text-opacity: 1;
    color: #E1AD28;
    color: rgba(225, 173, 40, 1);
    color: rgba(225, 173, 40, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-yellow-300a66:focus{
    color: rgba(255,233,189,0.66667);
  }

  .\\33xl\\:focus\\:text-yellow-500a25:focus{
    color: rgba(255,200,44,0.09804);
  }

  .\\33xl\\:focus\\:text-orange-200:focus{
    --text-opacity: 1;
    color: #fdf0ea;
    color: rgba(253, 240, 234, 1);
    color: rgba(253, 240, 234, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-orange-400:focus{
    --text-opacity: 1;
    color: #f6c66f;
    color: rgba(246, 198, 111, 1);
    color: rgba(246, 198, 111, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-orange-500:focus{
    --text-opacity: 1;
    color: #F07313;
    color: rgba(240, 115, 19, 1);
    color: rgba(240, 115, 19, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-orange-800:focus{
    --text-opacity: 1;
    color: #db5d0c;
    color: rgba(219, 93, 12, 1);
    color: rgba(219, 93, 12, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-orange-900:focus{
    --text-opacity: 1;
    color: #b86814;
    color: rgba(184, 104, 20, 1);
    color: rgba(184, 104, 20, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-orange-500a25:focus{
    color: rgba(240,115,23,0.09804);
  }

  .\\33xl\\:focus\\:text-red-100:focus{
    --text-opacity: 1;
    color: #FEF5F5;
    color: rgba(254, 245, 245, 1);
    color: rgba(254, 245, 245, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-red-150:focus{
    --text-opacity: 1;
    color: #ffe9e8;
    color: rgba(255, 233, 232, 1);
    color: rgba(255, 233, 232, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-red-200:focus{
    --text-opacity: 1;
    color: #F8CECC;
    color: rgba(248, 206, 204, 1);
    color: rgba(248, 206, 204, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-red-300:focus{
    --text-opacity: 1;
    color: #ff8585;
    color: rgba(255, 133, 133, 1);
    color: rgba(255, 133, 133, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-red-400:focus{
    --text-opacity: 1;
    color: #ff3535;
    color: rgba(255, 53, 53, 1);
    color: rgba(255, 53, 53, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-red-500:focus{
    --text-opacity: 1;
    color: #DD4746;
    color: rgba(221, 71, 70, 1);
    color: rgba(221, 71, 70, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-red-700:focus{
    --text-opacity: 1;
    color: #A23C24;
    color: rgba(162, 60, 36, 1);
    color: rgba(162, 60, 36, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-gray-50:focus{
    --text-opacity: 1;
    color: #F9F9F9;
    color: rgba(249, 249, 249, 1);
    color: rgba(249, 249, 249, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-gray-100:focus{
    --text-opacity: 1;
    color: #F1F1F2;
    color: rgba(241, 241, 242, 1);
    color: rgba(241, 241, 242, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-gray-150:focus{
    --text-opacity: 1;
    color: #e6e6e6;
    color: rgba(230, 230, 230, 1);
    color: rgba(230, 230, 230, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-gray-200:focus{
    --text-opacity: 1;
    color: #E0E2E4;
    color: rgba(224, 226, 228, 1);
    color: rgba(224, 226, 228, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-gray-300:focus{
    --text-opacity: 1;
    color: #BFBFBF;
    color: rgba(191, 191, 191, 1);
    color: rgba(191, 191, 191, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-gray-400:focus{
    color: rgba(114,114,114,0.8);
  }

  .\\33xl\\:focus\\:text-gray-425:focus{
    color: rgba(4, 21, 39, 0.8);
  }

  .\\33xl\\:focus\\:text-gray-450:focus{
    --text-opacity: 1;
    color: #959595;
    color: rgba(149, 149, 149, 1);
    color: rgba(149, 149, 149, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-gray-500:focus{
    --text-opacity: 1;
    color: #727272;
    color: rgba(114, 114, 114, 1);
    color: rgba(114, 114, 114, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-gray-600:focus{
    --text-opacity: 1;
    color: #5a626b;
    color: rgba(90, 98, 107, 1);
    color: rgba(90, 98, 107, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-gray-625:focus{
    color: rgba(90,98,107,0.8);
  }

  .\\33xl\\:focus\\:text-gray-700:focus{
    --text-opacity: 1;
    color: #464C59;
    color: rgba(70, 76, 89, 1);
    color: rgba(70, 76, 89, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-gray-800:focus{
    --text-opacity: 1;
    color: #3c3b3b;
    color: rgba(60, 59, 59, 1);
    color: rgba(60, 59, 59, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-gray-200a50:focus{
    color: rgba(224, 226, 228, 0.5);
  }

  .\\33xl\\:focus\\:text-blue-50:focus{
    --text-opacity: 1;
    color: #f2fbff;
    color: rgba(242, 251, 255, 1);
    color: rgba(242, 251, 255, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-blue-100:focus{
    --text-opacity: 1;
    color: #EBF6FC;
    color: rgba(235, 246, 252, 1);
    color: rgba(235, 246, 252, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-blue-150:focus{
    --text-opacity: 1;
    color: #E8EEF1;
    color: rgba(232, 238, 241, 1);
    color: rgba(232, 238, 241, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-blue-200:focus{
    --text-opacity: 1;
    color: #CCE6F5;
    color: rgba(204, 230, 245, 1);
    color: rgba(204, 230, 245, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-blue-300:focus{
    --text-opacity: 1;
    color: #73BFE7;
    color: rgba(115, 191, 231, 1);
    color: rgba(115, 191, 231, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-blue-400:focus{
    --text-opacity: 1;
    color: #4BA4F7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-blue-500:focus{
    --text-opacity: 1;
    color: #37A4DC;
    color: rgba(55, 164, 220, 1);
    color: rgba(55, 164, 220, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-blue-600:focus{
    --text-opacity: 1;
    color: #6AA2D6;
    color: rgba(106, 162, 214, 1);
    color: rgba(106, 162, 214, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-blue-700:focus{
    --text-opacity: 1;
    color: #456E9A;
    color: rgba(69, 110, 154, 1);
    color: rgba(69, 110, 154, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-blue-750:focus{
    --text-opacity: 1;
    color: #5682AA;
    color: rgba(86, 130, 170, 1);
    color: rgba(86, 130, 170, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-blue-800:focus{
    --text-opacity: 1;
    color: #1F4566;
    color: rgba(31, 69, 102, 1);
    color: rgba(31, 69, 102, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-blue-900:focus{
    --text-opacity: 1;
    color: #183453;
    color: rgba(24, 52, 83, 1);
    color: rgba(24, 52, 83, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-blue-950:focus{
    --text-opacity: 1;
    color: #041527;
    color: rgba(4, 21, 39, 1);
    color: rgba(4, 21, 39, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-blue-500a25:focus{
    color: rgba(55, 164, 220, 0.2);
  }

  .\\33xl\\:focus\\:text-blue-500a50:focus{
    color: rgba(55, 164, 220, 0.5);
  }

  .\\33xl\\:focus\\:text-blue-700a75:focus{
    --text-opacity: 1;
    color: #3B648D;
    color: rgba(59, 100, 141, 1);
    color: rgba(59, 100, 141, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-blue-700a30:focus{
    --text-opacity: 1;
    color: #2A5176;
    color: rgba(42, 81, 118, 1);
    color: rgba(42, 81, 118, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-blue-750a25:focus{
    color: rgba(86,130,170,0.09804);
  }

  .\\33xl\\:focus\\:text-blue-750a15:focus{
    color: rgba(86,130,170,0.05882);
  }

  .\\33xl\\:focus\\:text-blue-800a60:focus{
    color: rgba(31, 69, 102, 0.6);
  }

  .\\33xl\\:focus\\:text-programEditorTabColors-1:focus{
    --text-opacity: 1;
    color: #3cacae;
    color: rgba(60, 172, 174, 1);
    color: rgba(60, 172, 174, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-programEditorTabColors-2:focus{
    --text-opacity: 1;
    color: #8e346a;
    color: rgba(142, 52, 106, 1);
    color: rgba(142, 52, 106, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-programEditorTabColors-3:focus{
    --text-opacity: 1;
    color: #ff72b7;
    color: rgba(255, 114, 183, 1);
    color: rgba(255, 114, 183, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-programEditorTabColors-4:focus{
    --text-opacity: 1;
    color: #ce941c;
    color: rgba(206, 148, 28, 1);
    color: rgba(206, 148, 28, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-programEditorTabColors-5:focus{
    --text-opacity: 1;
    color: #b973d9;
    color: rgba(185, 115, 217, 1);
    color: rgba(185, 115, 217, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-programEditorTabColors-6:focus{
    --text-opacity: 1;
    color: #ff9082;
    color: rgba(255, 144, 130, 1);
    color: rgba(255, 144, 130, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-programEditorTabColors-1h:focus{
    --text-opacity: 1;
    color: #d9f2f2;
    color: rgba(217, 242, 242, 1);
    color: rgba(217, 242, 242, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-programEditorTabColors-2h:focus{
    --text-opacity: 1;
    color: #f1dae8;
    color: rgba(241, 218, 232, 1);
    color: rgba(241, 218, 232, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-programEditorTabColors-3h:focus{
    --text-opacity: 1;
    color: #ffe6f2;
    color: rgba(255, 230, 242, 1);
    color: rgba(255, 230, 242, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-programEditorTabColors-4h:focus{
    --text-opacity: 1;
    color: #f9ecd2;
    color: rgba(249, 236, 210, 1);
    color: rgba(249, 236, 210, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-programEditorTabColors-5h:focus{
    --text-opacity: 1;
    color: #f5ebfa;
    color: rgba(245, 235, 250, 1);
    color: rgba(245, 235, 250, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-programEditorTabColors-6h:focus{
    --text-opacity: 1;
    color: #ffe8e6;
    color: rgba(255, 232, 230, 1);
    color: rgba(255, 232, 230, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-programEditorPresetTabColors-1:focus{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-programEditorPresetTabColors-1h:focus{
    --text-opacity: 1;
    color: #798fa3;
    color: rgba(121, 143, 163, 1);
    color: rgba(121, 143, 163, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-borgScaleColors-0:focus{
    --text-opacity: 1;
    color: #c5d1ff;
    color: rgba(197, 209, 255, 1);
    color: rgba(197, 209, 255, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-borgScaleColors-1:focus{
    --text-opacity: 1;
    color: #a0b5fc;
    color: rgba(160, 181, 252, 1);
    color: rgba(160, 181, 252, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-borgScaleColors-2:focus{
    --text-opacity: 1;
    color: #7492ff;
    color: rgba(116, 146, 255, 1);
    color: rgba(116, 146, 255, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-borgScaleColors-3:focus{
    --text-opacity: 1;
    color: #82bbf1;
    color: rgba(130, 187, 241, 1);
    color: rgba(130, 187, 241, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-borgScaleColors-4:focus{
    --text-opacity: 1;
    color: #4ba4f7;
    color: rgba(75, 164, 247, 1);
    color: rgba(75, 164, 247, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-borgScaleColors-5:focus{
    --text-opacity: 1;
    color: #9cdd57;
    color: rgba(156, 221, 87, 1);
    color: rgba(156, 221, 87, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-borgScaleColors-6:focus{
    --text-opacity: 1;
    color: #68af00;
    color: rgba(104, 175, 0, 1);
    color: rgba(104, 175, 0, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-borgScaleColors-7:focus{
    --text-opacity: 1;
    color: #f5e380;
    color: rgba(245, 227, 128, 1);
    color: rgba(245, 227, 128, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-borgScaleColors-8:focus{
    --text-opacity: 1;
    color: #ffc246;
    color: rgba(255, 194, 70, 1);
    color: rgba(255, 194, 70, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-borgScaleColors-9:focus{
    --text-opacity: 1;
    color: #ff782f;
    color: rgba(255, 120, 47, 1);
    color: rgba(255, 120, 47, var(--text-opacity));
  }

  .\\33xl\\:focus\\:text-borgScaleColors-10:focus{
    --text-opacity: 1;
    color: #f25757;
    color: rgba(242, 87, 87, 1);
    color: rgba(242, 87, 87, var(--text-opacity));
  }

  .\\33xl\\:text-opacity-0{
    --text-opacity: 0;
  }

  .\\33xl\\:text-opacity-25{
    --text-opacity: .25;
  }

  .\\33xl\\:text-opacity-50{
    --text-opacity: .5;
  }

  .\\33xl\\:text-opacity-75{
    --text-opacity: .75;
  }

  .\\33xl\\:text-opacity-100{
    --text-opacity: 1;
  }

  .\\33xl\\:hover\\:text-opacity-0:hover{
    --text-opacity: 0;
  }

  .\\33xl\\:hover\\:text-opacity-25:hover{
    --text-opacity: .25;
  }

  .\\33xl\\:hover\\:text-opacity-50:hover{
    --text-opacity: .5;
  }

  .\\33xl\\:hover\\:text-opacity-75:hover{
    --text-opacity: .75;
  }

  .\\33xl\\:hover\\:text-opacity-100:hover{
    --text-opacity: 1;
  }

  .\\33xl\\:focus\\:text-opacity-0:focus{
    --text-opacity: 0;
  }

  .\\33xl\\:focus\\:text-opacity-25:focus{
    --text-opacity: .25;
  }

  .\\33xl\\:focus\\:text-opacity-50:focus{
    --text-opacity: .5;
  }

  .\\33xl\\:focus\\:text-opacity-75:focus{
    --text-opacity: .75;
  }

  .\\33xl\\:focus\\:text-opacity-100:focus{
    --text-opacity: 1;
  }

  .\\33xl\\:italic{
    font-style: italic;
  }

  .\\33xl\\:not-italic{
    font-style: normal;
  }

  .\\33xl\\:uppercase{
    text-transform: uppercase;
  }

  .\\33xl\\:lowercase{
    text-transform: lowercase;
  }

  .\\33xl\\:capitalize{
    text-transform: capitalize;
  }

  .\\33xl\\:normal-case{
    text-transform: none;
  }

  .\\33xl\\:underline{
    text-decoration: underline;
  }

  .\\33xl\\:line-through{
    text-decoration: line-through;
  }

  .\\33xl\\:no-underline{
    text-decoration: none;
  }

  .\\33xl\\:hover\\:underline:hover{
    text-decoration: underline;
  }

  .\\33xl\\:hover\\:line-through:hover{
    text-decoration: line-through;
  }

  .\\33xl\\:hover\\:no-underline:hover{
    text-decoration: none;
  }

  .\\33xl\\:focus\\:underline:focus{
    text-decoration: underline;
  }

  .\\33xl\\:focus\\:line-through:focus{
    text-decoration: line-through;
  }

  .\\33xl\\:focus\\:no-underline:focus{
    text-decoration: none;
  }

  .\\33xl\\:antialiased{
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .\\33xl\\:subpixel-antialiased{
    -webkit-font-smoothing: auto;
    -moz-osx-font-smoothing: auto;
  }

  .\\33xl\\:ordinal, .\\33xl\\:slashed-zero, .\\33xl\\:lining-nums, .\\33xl\\:oldstyle-nums, .\\33xl\\:proportional-nums, .\\33xl\\:tabular-nums, .\\33xl\\:diagonal-fractions, .\\33xl\\:stacked-fractions{
    --font-variant-numeric-ordinal: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-slashed-zero: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-figure: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-spacing: var(--tailwind-empty,/*!*/ /*!*/);
    --font-variant-numeric-fraction: var(--tailwind-empty,/*!*/ /*!*/);
    font-feature-settings: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
    font-variant-numeric: var(--font-variant-numeric-ordinal) var(--font-variant-numeric-slashed-zero) var(--font-variant-numeric-figure) var(--font-variant-numeric-spacing) var(--font-variant-numeric-fraction);
  }

  .\\33xl\\:normal-nums{
    font-feature-settings: normal;
    font-variant-numeric: normal;
  }

  .\\33xl\\:ordinal{
    --font-variant-numeric-ordinal: ordinal;
  }

  .\\33xl\\:slashed-zero{
    --font-variant-numeric-slashed-zero: slashed-zero;
  }

  .\\33xl\\:lining-nums{
    --font-variant-numeric-figure: lining-nums;
  }

  .\\33xl\\:oldstyle-nums{
    --font-variant-numeric-figure: oldstyle-nums;
  }

  .\\33xl\\:proportional-nums{
    --font-variant-numeric-spacing: proportional-nums;
  }

  .\\33xl\\:tabular-nums{
    --font-variant-numeric-spacing: tabular-nums;
  }

  .\\33xl\\:diagonal-fractions{
    --font-variant-numeric-fraction: diagonal-fractions;
  }

  .\\33xl\\:stacked-fractions{
    --font-variant-numeric-fraction: stacked-fractions;
  }

  .\\33xl\\:tracking-tight{
    letter-spacing: -0.025em;
  }

  .\\33xl\\:tracking-normal{
    letter-spacing: 0;
  }

  .\\33xl\\:tracking-wide{
    letter-spacing: 0.01em;
  }

  .\\33xl\\:tracking-wider{
    letter-spacing: 0.02em;
  }

  .\\33xl\\:tracking-widest{
    letter-spacing: 0.05em;
  }

  .\\33xl\\:select-none{
    -webkit-user-select: none;
            user-select: none;
  }

  .\\33xl\\:select-text{
    -webkit-user-select: text;
            user-select: text;
  }

  .\\33xl\\:select-all{
    -webkit-user-select: all;
            user-select: all;
  }

  .\\33xl\\:select-auto{
    -webkit-user-select: auto;
            user-select: auto;
  }

  .\\33xl\\:align-baseline{
    vertical-align: baseline;
  }

  .\\33xl\\:align-top{
    vertical-align: top;
  }

  .\\33xl\\:align-middle{
    vertical-align: middle;
  }

  .\\33xl\\:align-bottom{
    vertical-align: bottom;
  }

  .\\33xl\\:align-text-top{
    vertical-align: text-top;
  }

  .\\33xl\\:align-text-bottom{
    vertical-align: text-bottom;
  }

  .\\33xl\\:visible{
    visibility: visible;
  }

  .\\33xl\\:invisible{
    visibility: hidden;
  }

  .\\33xl\\:whitespace-normal{
    white-space: normal;
  }

  .\\33xl\\:whitespace-no-wrap{
    white-space: nowrap;
  }

  .\\33xl\\:whitespace-pre{
    white-space: pre;
  }

  .\\33xl\\:whitespace-pre-line{
    white-space: pre-line;
  }

  .\\33xl\\:whitespace-pre-wrap{
    white-space: pre-wrap;
  }

  .\\33xl\\:break-normal{
    word-wrap: normal;
    word-wrap: normal;
    word-break: normal;
  }

  .\\33xl\\:break-words{
    word-wrap: break-word;
    word-wrap: break-word;
  }

  .\\33xl\\:break-all{
    word-break: break-all;
  }

  .\\33xl\\:truncate{
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .\\33xl\\:w-0{
    width: 0;
  }

  .\\33xl\\:w-1{
    width: 0.25rem;
  }

  .\\33xl\\:w-2{
    width: 0.5rem;
  }

  .\\33xl\\:w-3{
    width: 0.75rem;
  }

  .\\33xl\\:w-4{
    width: 1rem;
  }

  .\\33xl\\:w-5{
    width: 1.25rem;
  }

  .\\33xl\\:w-6{
    width: 1.5rem;
  }

  .\\33xl\\:w-7{
    width: 1.75rem;
  }

  .\\33xl\\:w-8{
    width: 2rem;
  }

  .\\33xl\\:w-9{
    width: 2.25rem;
  }

  .\\33xl\\:w-10{
    width: 2.5rem;
  }

  .\\33xl\\:w-11{
    width: 2.75rem;
  }

  .\\33xl\\:w-12{
    width: 3rem;
  }

  .\\33xl\\:w-14{
    width: 3.5rem;
  }

  .\\33xl\\:w-15{
    width: 3.75rem;
  }

  .\\33xl\\:w-16{
    width: 4rem;
  }

  .\\33xl\\:w-18{
    width: 4.5rem;
  }

  .\\33xl\\:w-20{
    width: 5rem;
  }

  .\\33xl\\:w-22{
    width: 5.5rem;
  }

  .\\33xl\\:w-23{
    width: 5.75rem;
  }

  .\\33xl\\:w-24{
    width: 6rem;
  }

  .\\33xl\\:w-25{
    width: 6.25rem;
  }

  .\\33xl\\:w-26{
    width: 6.5rem;
  }

  .\\33xl\\:w-28{
    width: 7rem;
  }

  .\\33xl\\:w-30{
    width: 7.5rem;
  }

  .\\33xl\\:w-32{
    width: 8rem;
  }

  .\\33xl\\:w-34{
    width: 8.5rem;
  }

  .\\33xl\\:w-40{
    width: 10rem;
  }

  .\\33xl\\:w-42{
    width: 10.5rem;
  }

  .\\33xl\\:w-44{
    width: 11rem;
  }

  .\\33xl\\:w-48{
    width: 12rem;
  }

  .\\33xl\\:w-52{
    width: 13rem;
  }

  .\\33xl\\:w-54{
    width: 13.5rem;
  }

  .\\33xl\\:w-56{
    width: 14rem;
  }

  .\\33xl\\:w-60{
    width: 15rem;
  }

  .\\33xl\\:w-64{
    width: 16rem;
  }

  .\\33xl\\:w-68{
    width: 17rem;
  }

  .\\33xl\\:w-72{
    width: 18rem;
  }

  .\\33xl\\:w-74{
    width: 18.5rem;
  }

  .\\33xl\\:w-76{
    width: 19rem;
  }

  .\\33xl\\:w-78{
    width: 19.5rem;
  }

  .\\33xl\\:w-80{
    width: 20rem;
  }

  .\\33xl\\:w-82{
    width: 20.5rem;
  }

  .\\33xl\\:w-84{
    width: 21rem;
  }

  .\\33xl\\:w-88{
    width: 22rem;
  }

  .\\33xl\\:w-92{
    width: 23rem;
  }

  .\\33xl\\:w-96{
    width: 24rem;
  }

  .\\33xl\\:w-98{
    width: 24.5rem;
  }

  .\\33xl\\:w-100{
    width: 25rem;
  }

  .\\33xl\\:w-104{
    width: 26rem;
  }

  .\\33xl\\:w-112{
    width: 28rem;
  }

  .\\33xl\\:w-124{
    width: 31rem;
  }

  .\\33xl\\:w-128{
    width: 32rem;
  }

  .\\33xl\\:w-140{
    width: 35rem;
  }

  .\\33xl\\:w-152{
    width: 38rem;
  }

  .\\33xl\\:w-160{
    width: 40rem;
  }

  .\\33xl\\:w-162{
    width: 41rem;
  }

  .\\33xl\\:w-192{
    width: 48rem;
  }

  .\\33xl\\:w-208{
    width: 52rem;
  }

  .\\33xl\\:w-224{
    width: 56rem;
  }

  .\\33xl\\:w-256{
    width: 64rem;
  }

  .\\33xl\\:w-auto{
    width: auto;
  }

  .\\33xl\\:w-px{
    width: 1px;
  }

  .\\33xl\\:w-1\\/2{
    width: 50%;
  }

  .\\33xl\\:w-1\\/3{
    width: 33.33333%;
  }

  .\\33xl\\:w-2\\/3{
    width: 66.66667%;
  }

  .\\33xl\\:w-1\\/4{
    width: 25%;
  }

  .\\33xl\\:w-3\\/4{
    width: 75%;
  }

  .\\33xl\\:w-1\\/5{
    width: 20%;
  }

  .\\33xl\\:w-2\\/5{
    width: 40%;
  }

  .\\33xl\\:w-3\\/5{
    width: 60%;
  }

  .\\33xl\\:w-4\\/5{
    width: 80%;
  }

  .\\33xl\\:w-1\\/6{
    width: 16.66667%;
  }

  .\\33xl\\:w-5\\/6{
    width: 83.33333%;
  }

  .\\33xl\\:w-1\\/7{
    width: 14.285714285%;
  }

  .\\33xl\\:w-2\\/7{
    width: 28.571428571%;
  }

  .\\33xl\\:w-3\\/7{
    width: 42.85714285%;
  }

  .\\33xl\\:w-4\\/7{
    width: 57.14285714%;
  }

  .\\33xl\\:w-1\\/9{
    width: 11.1111%;
  }

  .\\33xl\\:w-9\\/10{
    width: 90%;
  }

  .\\33xl\\:w-full{
    width: 100%;
  }

  .\\33xl\\:w-screen{
    width: 100vw;
  }

  .\\33xl\\:w-max{
    width: max-content;
  }

  .\\33xl\\:z-0{
    z-index: 0;
  }

  .\\33xl\\:z-10{
    z-index: 10;
  }

  .\\33xl\\:z-20{
    z-index: 20;
  }

  .\\33xl\\:z-30{
    z-index: 30;
  }

  .\\33xl\\:z-40{
    z-index: 40;
  }

  .\\33xl\\:z-50{
    z-index: 50;
  }

  .\\33xl\\:z-auto{
    z-index: auto;
  }

  .\\33xl\\:gap-0{
    grid-gap: 0;
    gap: 0;
  }

  .\\33xl\\:gap-1{
    grid-gap: 0.25rem;
    gap: 0.25rem;
  }

  .\\33xl\\:gap-2{
    grid-gap: 0.5rem;
    gap: 0.5rem;
  }

  .\\33xl\\:gap-3{
    grid-gap: 0.75rem;
    gap: 0.75rem;
  }

  .\\33xl\\:gap-4{
    grid-gap: 1rem;
    gap: 1rem;
  }

  .\\33xl\\:gap-5{
    grid-gap: 1.25rem;
    gap: 1.25rem;
  }

  .\\33xl\\:gap-6{
    grid-gap: 1.5rem;
    gap: 1.5rem;
  }

  .\\33xl\\:gap-7{
    grid-gap: 1.75rem;
    gap: 1.75rem;
  }

  .\\33xl\\:gap-8{
    grid-gap: 2rem;
    gap: 2rem;
  }

  .\\33xl\\:gap-9{
    grid-gap: 2.25rem;
    gap: 2.25rem;
  }

  .\\33xl\\:gap-10{
    grid-gap: 2.5rem;
    gap: 2.5rem;
  }

  .\\33xl\\:gap-11{
    grid-gap: 2.75rem;
    gap: 2.75rem;
  }

  .\\33xl\\:gap-12{
    grid-gap: 3rem;
    gap: 3rem;
  }

  .\\33xl\\:gap-14{
    grid-gap: 3.5rem;
    gap: 3.5rem;
  }

  .\\33xl\\:gap-15{
    grid-gap: 3.75rem;
    gap: 3.75rem;
  }

  .\\33xl\\:gap-16{
    grid-gap: 4rem;
    gap: 4rem;
  }

  .\\33xl\\:gap-18{
    grid-gap: 4.5rem;
    gap: 4.5rem;
  }

  .\\33xl\\:gap-20{
    grid-gap: 5rem;
    gap: 5rem;
  }

  .\\33xl\\:gap-22{
    grid-gap: 5.5rem;
    gap: 5.5rem;
  }

  .\\33xl\\:gap-23{
    grid-gap: 5.75rem;
    gap: 5.75rem;
  }

  .\\33xl\\:gap-24{
    grid-gap: 6rem;
    gap: 6rem;
  }

  .\\33xl\\:gap-25{
    grid-gap: 6.25rem;
    gap: 6.25rem;
  }

  .\\33xl\\:gap-26{
    grid-gap: 6.5rem;
    gap: 6.5rem;
  }

  .\\33xl\\:gap-28{
    grid-gap: 7rem;
    gap: 7rem;
  }

  .\\33xl\\:gap-30{
    grid-gap: 7.5rem;
    gap: 7.5rem;
  }

  .\\33xl\\:gap-32{
    grid-gap: 8rem;
    gap: 8rem;
  }

  .\\33xl\\:gap-34{
    grid-gap: 8.5rem;
    gap: 8.5rem;
  }

  .\\33xl\\:gap-40{
    grid-gap: 10rem;
    gap: 10rem;
  }

  .\\33xl\\:gap-42{
    grid-gap: 10.5rem;
    gap: 10.5rem;
  }

  .\\33xl\\:gap-44{
    grid-gap: 11rem;
    gap: 11rem;
  }

  .\\33xl\\:gap-48{
    grid-gap: 12rem;
    gap: 12rem;
  }

  .\\33xl\\:gap-52{
    grid-gap: 13rem;
    gap: 13rem;
  }

  .\\33xl\\:gap-54{
    grid-gap: 13.5rem;
    gap: 13.5rem;
  }

  .\\33xl\\:gap-56{
    grid-gap: 14rem;
    gap: 14rem;
  }

  .\\33xl\\:gap-60{
    grid-gap: 15rem;
    gap: 15rem;
  }

  .\\33xl\\:gap-64{
    grid-gap: 16rem;
    gap: 16rem;
  }

  .\\33xl\\:gap-68{
    grid-gap: 17rem;
    gap: 17rem;
  }

  .\\33xl\\:gap-72{
    grid-gap: 18rem;
    gap: 18rem;
  }

  .\\33xl\\:gap-74{
    grid-gap: 18.5rem;
    gap: 18.5rem;
  }

  .\\33xl\\:gap-76{
    grid-gap: 19rem;
    gap: 19rem;
  }

  .\\33xl\\:gap-78{
    grid-gap: 19.5rem;
    gap: 19.5rem;
  }

  .\\33xl\\:gap-80{
    grid-gap: 20rem;
    gap: 20rem;
  }

  .\\33xl\\:gap-82{
    grid-gap: 20.5rem;
    gap: 20.5rem;
  }

  .\\33xl\\:gap-84{
    grid-gap: 21rem;
    gap: 21rem;
  }

  .\\33xl\\:gap-88{
    grid-gap: 22rem;
    gap: 22rem;
  }

  .\\33xl\\:gap-92{
    grid-gap: 23rem;
    gap: 23rem;
  }

  .\\33xl\\:gap-96{
    grid-gap: 24rem;
    gap: 24rem;
  }

  .\\33xl\\:gap-98{
    grid-gap: 24.5rem;
    gap: 24.5rem;
  }

  .\\33xl\\:gap-100{
    grid-gap: 25rem;
    gap: 25rem;
  }

  .\\33xl\\:gap-104{
    grid-gap: 26rem;
    gap: 26rem;
  }

  .\\33xl\\:gap-112{
    grid-gap: 28rem;
    gap: 28rem;
  }

  .\\33xl\\:gap-124{
    grid-gap: 31rem;
    gap: 31rem;
  }

  .\\33xl\\:gap-128{
    grid-gap: 32rem;
    gap: 32rem;
  }

  .\\33xl\\:gap-140{
    grid-gap: 35rem;
    gap: 35rem;
  }

  .\\33xl\\:gap-152{
    grid-gap: 38rem;
    gap: 38rem;
  }

  .\\33xl\\:gap-160{
    grid-gap: 40rem;
    gap: 40rem;
  }

  .\\33xl\\:gap-162{
    grid-gap: 41rem;
    gap: 41rem;
  }

  .\\33xl\\:gap-192{
    grid-gap: 48rem;
    gap: 48rem;
  }

  .\\33xl\\:gap-208{
    grid-gap: 52rem;
    gap: 52rem;
  }

  .\\33xl\\:gap-224{
    grid-gap: 56rem;
    gap: 56rem;
  }

  .\\33xl\\:gap-256{
    grid-gap: 64rem;
    gap: 64rem;
  }

  .\\33xl\\:gap-px{
    grid-gap: 1px;
    gap: 1px;
  }

  .\\33xl\\:gap-x-0{
    grid-column-gap: 0;
    -moz-column-gap: 0;
         column-gap: 0;
  }

  .\\33xl\\:gap-x-1{
    grid-column-gap: 0.25rem;
    -moz-column-gap: 0.25rem;
         column-gap: 0.25rem;
  }

  .\\33xl\\:gap-x-2{
    grid-column-gap: 0.5rem;
    -moz-column-gap: 0.5rem;
         column-gap: 0.5rem;
  }

  .\\33xl\\:gap-x-3{
    grid-column-gap: 0.75rem;
    -moz-column-gap: 0.75rem;
         column-gap: 0.75rem;
  }

  .\\33xl\\:gap-x-4{
    grid-column-gap: 1rem;
    -moz-column-gap: 1rem;
         column-gap: 1rem;
  }

  .\\33xl\\:gap-x-5{
    grid-column-gap: 1.25rem;
    -moz-column-gap: 1.25rem;
         column-gap: 1.25rem;
  }

  .\\33xl\\:gap-x-6{
    grid-column-gap: 1.5rem;
    -moz-column-gap: 1.5rem;
         column-gap: 1.5rem;
  }

  .\\33xl\\:gap-x-7{
    grid-column-gap: 1.75rem;
    -moz-column-gap: 1.75rem;
         column-gap: 1.75rem;
  }

  .\\33xl\\:gap-x-8{
    grid-column-gap: 2rem;
    -moz-column-gap: 2rem;
         column-gap: 2rem;
  }

  .\\33xl\\:gap-x-9{
    grid-column-gap: 2.25rem;
    -moz-column-gap: 2.25rem;
         column-gap: 2.25rem;
  }

  .\\33xl\\:gap-x-10{
    grid-column-gap: 2.5rem;
    -moz-column-gap: 2.5rem;
         column-gap: 2.5rem;
  }

  .\\33xl\\:gap-x-11{
    grid-column-gap: 2.75rem;
    -moz-column-gap: 2.75rem;
         column-gap: 2.75rem;
  }

  .\\33xl\\:gap-x-12{
    grid-column-gap: 3rem;
    -moz-column-gap: 3rem;
         column-gap: 3rem;
  }

  .\\33xl\\:gap-x-14{
    grid-column-gap: 3.5rem;
    -moz-column-gap: 3.5rem;
         column-gap: 3.5rem;
  }

  .\\33xl\\:gap-x-15{
    grid-column-gap: 3.75rem;
    -moz-column-gap: 3.75rem;
         column-gap: 3.75rem;
  }

  .\\33xl\\:gap-x-16{
    grid-column-gap: 4rem;
    -moz-column-gap: 4rem;
         column-gap: 4rem;
  }

  .\\33xl\\:gap-x-18{
    grid-column-gap: 4.5rem;
    -moz-column-gap: 4.5rem;
         column-gap: 4.5rem;
  }

  .\\33xl\\:gap-x-20{
    grid-column-gap: 5rem;
    -moz-column-gap: 5rem;
         column-gap: 5rem;
  }

  .\\33xl\\:gap-x-22{
    grid-column-gap: 5.5rem;
    -moz-column-gap: 5.5rem;
         column-gap: 5.5rem;
  }

  .\\33xl\\:gap-x-23{
    grid-column-gap: 5.75rem;
    -moz-column-gap: 5.75rem;
         column-gap: 5.75rem;
  }

  .\\33xl\\:gap-x-24{
    grid-column-gap: 6rem;
    -moz-column-gap: 6rem;
         column-gap: 6rem;
  }

  .\\33xl\\:gap-x-25{
    grid-column-gap: 6.25rem;
    -moz-column-gap: 6.25rem;
         column-gap: 6.25rem;
  }

  .\\33xl\\:gap-x-26{
    grid-column-gap: 6.5rem;
    -moz-column-gap: 6.5rem;
         column-gap: 6.5rem;
  }

  .\\33xl\\:gap-x-28{
    grid-column-gap: 7rem;
    -moz-column-gap: 7rem;
         column-gap: 7rem;
  }

  .\\33xl\\:gap-x-30{
    grid-column-gap: 7.5rem;
    -moz-column-gap: 7.5rem;
         column-gap: 7.5rem;
  }

  .\\33xl\\:gap-x-32{
    grid-column-gap: 8rem;
    -moz-column-gap: 8rem;
         column-gap: 8rem;
  }

  .\\33xl\\:gap-x-34{
    grid-column-gap: 8.5rem;
    -moz-column-gap: 8.5rem;
         column-gap: 8.5rem;
  }

  .\\33xl\\:gap-x-40{
    grid-column-gap: 10rem;
    -moz-column-gap: 10rem;
         column-gap: 10rem;
  }

  .\\33xl\\:gap-x-42{
    grid-column-gap: 10.5rem;
    -moz-column-gap: 10.5rem;
         column-gap: 10.5rem;
  }

  .\\33xl\\:gap-x-44{
    grid-column-gap: 11rem;
    -moz-column-gap: 11rem;
         column-gap: 11rem;
  }

  .\\33xl\\:gap-x-48{
    grid-column-gap: 12rem;
    -moz-column-gap: 12rem;
         column-gap: 12rem;
  }

  .\\33xl\\:gap-x-52{
    grid-column-gap: 13rem;
    -moz-column-gap: 13rem;
         column-gap: 13rem;
  }

  .\\33xl\\:gap-x-54{
    grid-column-gap: 13.5rem;
    -moz-column-gap: 13.5rem;
         column-gap: 13.5rem;
  }

  .\\33xl\\:gap-x-56{
    grid-column-gap: 14rem;
    -moz-column-gap: 14rem;
         column-gap: 14rem;
  }

  .\\33xl\\:gap-x-60{
    grid-column-gap: 15rem;
    -moz-column-gap: 15rem;
         column-gap: 15rem;
  }

  .\\33xl\\:gap-x-64{
    grid-column-gap: 16rem;
    -moz-column-gap: 16rem;
         column-gap: 16rem;
  }

  .\\33xl\\:gap-x-68{
    grid-column-gap: 17rem;
    -moz-column-gap: 17rem;
         column-gap: 17rem;
  }

  .\\33xl\\:gap-x-72{
    grid-column-gap: 18rem;
    -moz-column-gap: 18rem;
         column-gap: 18rem;
  }

  .\\33xl\\:gap-x-74{
    grid-column-gap: 18.5rem;
    -moz-column-gap: 18.5rem;
         column-gap: 18.5rem;
  }

  .\\33xl\\:gap-x-76{
    grid-column-gap: 19rem;
    -moz-column-gap: 19rem;
         column-gap: 19rem;
  }

  .\\33xl\\:gap-x-78{
    grid-column-gap: 19.5rem;
    -moz-column-gap: 19.5rem;
         column-gap: 19.5rem;
  }

  .\\33xl\\:gap-x-80{
    grid-column-gap: 20rem;
    -moz-column-gap: 20rem;
         column-gap: 20rem;
  }

  .\\33xl\\:gap-x-82{
    grid-column-gap: 20.5rem;
    -moz-column-gap: 20.5rem;
         column-gap: 20.5rem;
  }

  .\\33xl\\:gap-x-84{
    grid-column-gap: 21rem;
    -moz-column-gap: 21rem;
         column-gap: 21rem;
  }

  .\\33xl\\:gap-x-88{
    grid-column-gap: 22rem;
    -moz-column-gap: 22rem;
         column-gap: 22rem;
  }

  .\\33xl\\:gap-x-92{
    grid-column-gap: 23rem;
    -moz-column-gap: 23rem;
         column-gap: 23rem;
  }

  .\\33xl\\:gap-x-96{
    grid-column-gap: 24rem;
    -moz-column-gap: 24rem;
         column-gap: 24rem;
  }

  .\\33xl\\:gap-x-98{
    grid-column-gap: 24.5rem;
    -moz-column-gap: 24.5rem;
         column-gap: 24.5rem;
  }

  .\\33xl\\:gap-x-100{
    grid-column-gap: 25rem;
    -moz-column-gap: 25rem;
         column-gap: 25rem;
  }

  .\\33xl\\:gap-x-104{
    grid-column-gap: 26rem;
    -moz-column-gap: 26rem;
         column-gap: 26rem;
  }

  .\\33xl\\:gap-x-112{
    grid-column-gap: 28rem;
    -moz-column-gap: 28rem;
         column-gap: 28rem;
  }

  .\\33xl\\:gap-x-124{
    grid-column-gap: 31rem;
    -moz-column-gap: 31rem;
         column-gap: 31rem;
  }

  .\\33xl\\:gap-x-128{
    grid-column-gap: 32rem;
    -moz-column-gap: 32rem;
         column-gap: 32rem;
  }

  .\\33xl\\:gap-x-140{
    grid-column-gap: 35rem;
    -moz-column-gap: 35rem;
         column-gap: 35rem;
  }

  .\\33xl\\:gap-x-152{
    grid-column-gap: 38rem;
    -moz-column-gap: 38rem;
         column-gap: 38rem;
  }

  .\\33xl\\:gap-x-160{
    grid-column-gap: 40rem;
    -moz-column-gap: 40rem;
         column-gap: 40rem;
  }

  .\\33xl\\:gap-x-162{
    grid-column-gap: 41rem;
    -moz-column-gap: 41rem;
         column-gap: 41rem;
  }

  .\\33xl\\:gap-x-192{
    grid-column-gap: 48rem;
    -moz-column-gap: 48rem;
         column-gap: 48rem;
  }

  .\\33xl\\:gap-x-208{
    grid-column-gap: 52rem;
    -moz-column-gap: 52rem;
         column-gap: 52rem;
  }

  .\\33xl\\:gap-x-224{
    grid-column-gap: 56rem;
    -moz-column-gap: 56rem;
         column-gap: 56rem;
  }

  .\\33xl\\:gap-x-256{
    grid-column-gap: 64rem;
    -moz-column-gap: 64rem;
         column-gap: 64rem;
  }

  .\\33xl\\:gap-x-px{
    grid-column-gap: 1px;
    -moz-column-gap: 1px;
         column-gap: 1px;
  }

  .\\33xl\\:gap-y-0{
    grid-row-gap: 0;
    row-gap: 0;
  }

  .\\33xl\\:gap-y-1{
    grid-row-gap: 0.25rem;
    row-gap: 0.25rem;
  }

  .\\33xl\\:gap-y-2{
    grid-row-gap: 0.5rem;
    row-gap: 0.5rem;
  }

  .\\33xl\\:gap-y-3{
    grid-row-gap: 0.75rem;
    row-gap: 0.75rem;
  }

  .\\33xl\\:gap-y-4{
    grid-row-gap: 1rem;
    row-gap: 1rem;
  }

  .\\33xl\\:gap-y-5{
    grid-row-gap: 1.25rem;
    row-gap: 1.25rem;
  }

  .\\33xl\\:gap-y-6{
    grid-row-gap: 1.5rem;
    row-gap: 1.5rem;
  }

  .\\33xl\\:gap-y-7{
    grid-row-gap: 1.75rem;
    row-gap: 1.75rem;
  }

  .\\33xl\\:gap-y-8{
    grid-row-gap: 2rem;
    row-gap: 2rem;
  }

  .\\33xl\\:gap-y-9{
    grid-row-gap: 2.25rem;
    row-gap: 2.25rem;
  }

  .\\33xl\\:gap-y-10{
    grid-row-gap: 2.5rem;
    row-gap: 2.5rem;
  }

  .\\33xl\\:gap-y-11{
    grid-row-gap: 2.75rem;
    row-gap: 2.75rem;
  }

  .\\33xl\\:gap-y-12{
    grid-row-gap: 3rem;
    row-gap: 3rem;
  }

  .\\33xl\\:gap-y-14{
    grid-row-gap: 3.5rem;
    row-gap: 3.5rem;
  }

  .\\33xl\\:gap-y-15{
    grid-row-gap: 3.75rem;
    row-gap: 3.75rem;
  }

  .\\33xl\\:gap-y-16{
    grid-row-gap: 4rem;
    row-gap: 4rem;
  }

  .\\33xl\\:gap-y-18{
    grid-row-gap: 4.5rem;
    row-gap: 4.5rem;
  }

  .\\33xl\\:gap-y-20{
    grid-row-gap: 5rem;
    row-gap: 5rem;
  }

  .\\33xl\\:gap-y-22{
    grid-row-gap: 5.5rem;
    row-gap: 5.5rem;
  }

  .\\33xl\\:gap-y-23{
    grid-row-gap: 5.75rem;
    row-gap: 5.75rem;
  }

  .\\33xl\\:gap-y-24{
    grid-row-gap: 6rem;
    row-gap: 6rem;
  }

  .\\33xl\\:gap-y-25{
    grid-row-gap: 6.25rem;
    row-gap: 6.25rem;
  }

  .\\33xl\\:gap-y-26{
    grid-row-gap: 6.5rem;
    row-gap: 6.5rem;
  }

  .\\33xl\\:gap-y-28{
    grid-row-gap: 7rem;
    row-gap: 7rem;
  }

  .\\33xl\\:gap-y-30{
    grid-row-gap: 7.5rem;
    row-gap: 7.5rem;
  }

  .\\33xl\\:gap-y-32{
    grid-row-gap: 8rem;
    row-gap: 8rem;
  }

  .\\33xl\\:gap-y-34{
    grid-row-gap: 8.5rem;
    row-gap: 8.5rem;
  }

  .\\33xl\\:gap-y-40{
    grid-row-gap: 10rem;
    row-gap: 10rem;
  }

  .\\33xl\\:gap-y-42{
    grid-row-gap: 10.5rem;
    row-gap: 10.5rem;
  }

  .\\33xl\\:gap-y-44{
    grid-row-gap: 11rem;
    row-gap: 11rem;
  }

  .\\33xl\\:gap-y-48{
    grid-row-gap: 12rem;
    row-gap: 12rem;
  }

  .\\33xl\\:gap-y-52{
    grid-row-gap: 13rem;
    row-gap: 13rem;
  }

  .\\33xl\\:gap-y-54{
    grid-row-gap: 13.5rem;
    row-gap: 13.5rem;
  }

  .\\33xl\\:gap-y-56{
    grid-row-gap: 14rem;
    row-gap: 14rem;
  }

  .\\33xl\\:gap-y-60{
    grid-row-gap: 15rem;
    row-gap: 15rem;
  }

  .\\33xl\\:gap-y-64{
    grid-row-gap: 16rem;
    row-gap: 16rem;
  }

  .\\33xl\\:gap-y-68{
    grid-row-gap: 17rem;
    row-gap: 17rem;
  }

  .\\33xl\\:gap-y-72{
    grid-row-gap: 18rem;
    row-gap: 18rem;
  }

  .\\33xl\\:gap-y-74{
    grid-row-gap: 18.5rem;
    row-gap: 18.5rem;
  }

  .\\33xl\\:gap-y-76{
    grid-row-gap: 19rem;
    row-gap: 19rem;
  }

  .\\33xl\\:gap-y-78{
    grid-row-gap: 19.5rem;
    row-gap: 19.5rem;
  }

  .\\33xl\\:gap-y-80{
    grid-row-gap: 20rem;
    row-gap: 20rem;
  }

  .\\33xl\\:gap-y-82{
    grid-row-gap: 20.5rem;
    row-gap: 20.5rem;
  }

  .\\33xl\\:gap-y-84{
    grid-row-gap: 21rem;
    row-gap: 21rem;
  }

  .\\33xl\\:gap-y-88{
    grid-row-gap: 22rem;
    row-gap: 22rem;
  }

  .\\33xl\\:gap-y-92{
    grid-row-gap: 23rem;
    row-gap: 23rem;
  }

  .\\33xl\\:gap-y-96{
    grid-row-gap: 24rem;
    row-gap: 24rem;
  }

  .\\33xl\\:gap-y-98{
    grid-row-gap: 24.5rem;
    row-gap: 24.5rem;
  }

  .\\33xl\\:gap-y-100{
    grid-row-gap: 25rem;
    row-gap: 25rem;
  }

  .\\33xl\\:gap-y-104{
    grid-row-gap: 26rem;
    row-gap: 26rem;
  }

  .\\33xl\\:gap-y-112{
    grid-row-gap: 28rem;
    row-gap: 28rem;
  }

  .\\33xl\\:gap-y-124{
    grid-row-gap: 31rem;
    row-gap: 31rem;
  }

  .\\33xl\\:gap-y-128{
    grid-row-gap: 32rem;
    row-gap: 32rem;
  }

  .\\33xl\\:gap-y-140{
    grid-row-gap: 35rem;
    row-gap: 35rem;
  }

  .\\33xl\\:gap-y-152{
    grid-row-gap: 38rem;
    row-gap: 38rem;
  }

  .\\33xl\\:gap-y-160{
    grid-row-gap: 40rem;
    row-gap: 40rem;
  }

  .\\33xl\\:gap-y-162{
    grid-row-gap: 41rem;
    row-gap: 41rem;
  }

  .\\33xl\\:gap-y-192{
    grid-row-gap: 48rem;
    row-gap: 48rem;
  }

  .\\33xl\\:gap-y-208{
    grid-row-gap: 52rem;
    row-gap: 52rem;
  }

  .\\33xl\\:gap-y-224{
    grid-row-gap: 56rem;
    row-gap: 56rem;
  }

  .\\33xl\\:gap-y-256{
    grid-row-gap: 64rem;
    row-gap: 64rem;
  }

  .\\33xl\\:gap-y-px{
    grid-row-gap: 1px;
    row-gap: 1px;
  }

  .\\33xl\\:grid-flow-row{
    grid-auto-flow: row;
  }

  .\\33xl\\:grid-flow-col{
    grid-auto-flow: column;
  }

  .\\33xl\\:grid-flow-row-dense{
    grid-auto-flow: row dense;
  }

  .\\33xl\\:grid-flow-col-dense{
    grid-auto-flow: column dense;
  }

  .\\33xl\\:grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr));
  }

  .\\33xl\\:grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .\\33xl\\:grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .\\33xl\\:grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .\\33xl\\:grid-cols-5{
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .\\33xl\\:grid-cols-6{
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .\\33xl\\:grid-cols-7{
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }

  .\\33xl\\:grid-cols-8{
    grid-template-columns: repeat(8, minmax(0, 1fr));
  }

  .\\33xl\\:grid-cols-9{
    grid-template-columns: repeat(9, minmax(0, 1fr));
  }

  .\\33xl\\:grid-cols-10{
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }

  .\\33xl\\:grid-cols-11{
    grid-template-columns: repeat(11, minmax(0, 1fr));
  }

  .\\33xl\\:grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .\\33xl\\:grid-cols-14{
    grid-template-columns: repeat(14, minmax(0, 1fr));
  }

  .\\33xl\\:grid-cols-none{
    grid-template-columns: none;
  }

  .\\33xl\\:auto-cols-auto{
    grid-auto-columns: auto;
  }

  .\\33xl\\:auto-cols-min{
    grid-auto-columns: min-content;
  }

  .\\33xl\\:auto-cols-max{
    grid-auto-columns: max-content;
  }

  .\\33xl\\:auto-cols-fr{
    grid-auto-columns: minmax(0, 1fr);
  }

  .\\33xl\\:col-auto{
    grid-column: auto;
  }

  .\\33xl\\:col-span-1{
    grid-column: span 1 / span 1;
  }

  .\\33xl\\:col-span-2{
    grid-column: span 2 / span 2;
  }

  .\\33xl\\:col-span-3{
    grid-column: span 3 / span 3;
  }

  .\\33xl\\:col-span-4{
    grid-column: span 4 / span 4;
  }

  .\\33xl\\:col-span-5{
    grid-column: span 5 / span 5;
  }

  .\\33xl\\:col-span-6{
    grid-column: span 6 / span 6;
  }

  .\\33xl\\:col-span-7{
    grid-column: span 7 / span 7;
  }

  .\\33xl\\:col-span-8{
    grid-column: span 8 / span 8;
  }

  .\\33xl\\:col-span-9{
    grid-column: span 9 / span 9;
  }

  .\\33xl\\:col-span-10{
    grid-column: span 10 / span 10;
  }

  .\\33xl\\:col-span-11{
    grid-column: span 11 / span 11;
  }

  .\\33xl\\:col-span-12{
    grid-column: span 12 / span 12;
  }

  .\\33xl\\:col-span-full{
    grid-column: 1 / -1;
  }

  .\\33xl\\:col-start-1{
    grid-column-start: 1;
  }

  .\\33xl\\:col-start-2{
    grid-column-start: 2;
  }

  .\\33xl\\:col-start-3{
    grid-column-start: 3;
  }

  .\\33xl\\:col-start-4{
    grid-column-start: 4;
  }

  .\\33xl\\:col-start-5{
    grid-column-start: 5;
  }

  .\\33xl\\:col-start-6{
    grid-column-start: 6;
  }

  .\\33xl\\:col-start-7{
    grid-column-start: 7;
  }

  .\\33xl\\:col-start-8{
    grid-column-start: 8;
  }

  .\\33xl\\:col-start-9{
    grid-column-start: 9;
  }

  .\\33xl\\:col-start-10{
    grid-column-start: 10;
  }

  .\\33xl\\:col-start-11{
    grid-column-start: 11;
  }

  .\\33xl\\:col-start-12{
    grid-column-start: 12;
  }

  .\\33xl\\:col-start-13{
    grid-column-start: 13;
  }

  .\\33xl\\:col-start-14{
    grid-column-start: 14;
  }

  .\\33xl\\:col-start-15{
    grid-column-start: 15;
  }

  .\\33xl\\:col-start-auto{
    grid-column-start: auto;
  }

  .\\33xl\\:col-end-1{
    grid-column-end: 1;
  }

  .\\33xl\\:col-end-2{
    grid-column-end: 2;
  }

  .\\33xl\\:col-end-3{
    grid-column-end: 3;
  }

  .\\33xl\\:col-end-4{
    grid-column-end: 4;
  }

  .\\33xl\\:col-end-5{
    grid-column-end: 5;
  }

  .\\33xl\\:col-end-6{
    grid-column-end: 6;
  }

  .\\33xl\\:col-end-7{
    grid-column-end: 7;
  }

  .\\33xl\\:col-end-8{
    grid-column-end: 8;
  }

  .\\33xl\\:col-end-9{
    grid-column-end: 9;
  }

  .\\33xl\\:col-end-10{
    grid-column-end: 10;
  }

  .\\33xl\\:col-end-11{
    grid-column-end: 11;
  }

  .\\33xl\\:col-end-12{
    grid-column-end: 12;
  }

  .\\33xl\\:col-end-13{
    grid-column-end: 13;
  }

  .\\33xl\\:col-end-14{
    grid-column-end: 14;
  }

  .\\33xl\\:col-end-15{
    grid-column-end: 15;
  }

  .\\33xl\\:col-end-auto{
    grid-column-end: auto;
  }

  .\\33xl\\:grid-rows-1{
    grid-template-rows: repeat(1, minmax(0, 1fr));
  }

  .\\33xl\\:grid-rows-2{
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }

  .\\33xl\\:grid-rows-3{
    grid-template-rows: repeat(3, minmax(0, 1fr));
  }

  .\\33xl\\:grid-rows-4{
    grid-template-rows: repeat(4, minmax(0, 1fr));
  }

  .\\33xl\\:grid-rows-5{
    grid-template-rows: repeat(5, minmax(0, 1fr));
  }

  .\\33xl\\:grid-rows-6{
    grid-template-rows: repeat(6, minmax(0, 1fr));
  }

  .\\33xl\\:grid-rows-none{
    grid-template-rows: none;
  }

  .\\33xl\\:auto-rows-auto{
    grid-auto-rows: auto;
  }

  .\\33xl\\:auto-rows-min{
    grid-auto-rows: min-content;
  }

  .\\33xl\\:auto-rows-max{
    grid-auto-rows: max-content;
  }

  .\\33xl\\:auto-rows-fr{
    grid-auto-rows: minmax(0, 1fr);
  }

  .\\33xl\\:row-auto{
    grid-row: auto;
  }

  .\\33xl\\:row-span-1{
    grid-row: span 1 / span 1;
  }

  .\\33xl\\:row-span-2{
    grid-row: span 2 / span 2;
  }

  .\\33xl\\:row-span-3{
    grid-row: span 3 / span 3;
  }

  .\\33xl\\:row-span-4{
    grid-row: span 4 / span 4;
  }

  .\\33xl\\:row-span-5{
    grid-row: span 5 / span 5;
  }

  .\\33xl\\:row-span-6{
    grid-row: span 6 / span 6;
  }

  .\\33xl\\:row-span-full{
    grid-row: 1 / -1;
  }

  .\\33xl\\:row-start-1{
    grid-row-start: 1;
  }

  .\\33xl\\:row-start-2{
    grid-row-start: 2;
  }

  .\\33xl\\:row-start-3{
    grid-row-start: 3;
  }

  .\\33xl\\:row-start-4{
    grid-row-start: 4;
  }

  .\\33xl\\:row-start-5{
    grid-row-start: 5;
  }

  .\\33xl\\:row-start-6{
    grid-row-start: 6;
  }

  .\\33xl\\:row-start-7{
    grid-row-start: 7;
  }

  .\\33xl\\:row-start-auto{
    grid-row-start: auto;
  }

  .\\33xl\\:row-end-1{
    grid-row-end: 1;
  }

  .\\33xl\\:row-end-2{
    grid-row-end: 2;
  }

  .\\33xl\\:row-end-3{
    grid-row-end: 3;
  }

  .\\33xl\\:row-end-4{
    grid-row-end: 4;
  }

  .\\33xl\\:row-end-5{
    grid-row-end: 5;
  }

  .\\33xl\\:row-end-6{
    grid-row-end: 6;
  }

  .\\33xl\\:row-end-7{
    grid-row-end: 7;
  }

  .\\33xl\\:row-end-auto{
    grid-row-end: auto;
  }

  .\\33xl\\:transform{
    --transform-translate-x: 0;
    --transform-translate-y: 0;
    --transform-rotate: 0;
    --transform-skew-x: 0;
    --transform-skew-y: 0;
    --transform-scale-x: 1;
    --transform-scale-y: 1;
    transform: translateX(var(--transform-translate-x)) translateY(var(--transform-translate-y)) rotate(var(--transform-rotate)) skewX(var(--transform-skew-x)) skewY(var(--transform-skew-y)) scaleX(var(--transform-scale-x)) scaleY(var(--transform-scale-y));
  }

  .\\33xl\\:transform-none{
    transform: none;
  }

  .\\33xl\\:origin-center{
    transform-origin: center;
  }

  .\\33xl\\:origin-top{
    transform-origin: top;
  }

  .\\33xl\\:origin-top-right{
    transform-origin: top right;
  }

  .\\33xl\\:origin-right{
    transform-origin: right;
  }

  .\\33xl\\:origin-bottom-right{
    transform-origin: bottom right;
  }

  .\\33xl\\:origin-bottom{
    transform-origin: bottom;
  }

  .\\33xl\\:origin-bottom-left{
    transform-origin: bottom left;
  }

  .\\33xl\\:origin-left{
    transform-origin: left;
  }

  .\\33xl\\:origin-top-left{
    transform-origin: top left;
  }

  .\\33xl\\:scale-0{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .\\33xl\\:scale-50{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .\\33xl\\:scale-75{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .\\33xl\\:scale-90{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .\\33xl\\:scale-95{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .\\33xl\\:scale-100{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .\\33xl\\:scale-105{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .\\33xl\\:scale-110{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .\\33xl\\:scale-125{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .\\33xl\\:scale-150{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .\\33xl\\:scale-x-0{
    --transform-scale-x: 0;
  }

  .\\33xl\\:scale-x-50{
    --transform-scale-x: .5;
  }

  .\\33xl\\:scale-x-75{
    --transform-scale-x: .75;
  }

  .\\33xl\\:scale-x-90{
    --transform-scale-x: .9;
  }

  .\\33xl\\:scale-x-95{
    --transform-scale-x: .95;
  }

  .\\33xl\\:scale-x-100{
    --transform-scale-x: 1;
  }

  .\\33xl\\:scale-x-105{
    --transform-scale-x: 1.05;
  }

  .\\33xl\\:scale-x-110{
    --transform-scale-x: 1.1;
  }

  .\\33xl\\:scale-x-125{
    --transform-scale-x: 1.25;
  }

  .\\33xl\\:scale-x-150{
    --transform-scale-x: 1.5;
  }

  .\\33xl\\:scale-y-0{
    --transform-scale-y: 0;
  }

  .\\33xl\\:scale-y-50{
    --transform-scale-y: .5;
  }

  .\\33xl\\:scale-y-75{
    --transform-scale-y: .75;
  }

  .\\33xl\\:scale-y-90{
    --transform-scale-y: .9;
  }

  .\\33xl\\:scale-y-95{
    --transform-scale-y: .95;
  }

  .\\33xl\\:scale-y-100{
    --transform-scale-y: 1;
  }

  .\\33xl\\:scale-y-105{
    --transform-scale-y: 1.05;
  }

  .\\33xl\\:scale-y-110{
    --transform-scale-y: 1.1;
  }

  .\\33xl\\:scale-y-125{
    --transform-scale-y: 1.25;
  }

  .\\33xl\\:scale-y-150{
    --transform-scale-y: 1.5;
  }

  .\\33xl\\:hover\\:scale-0:hover{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .\\33xl\\:hover\\:scale-50:hover{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .\\33xl\\:hover\\:scale-75:hover{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .\\33xl\\:hover\\:scale-90:hover{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .\\33xl\\:hover\\:scale-95:hover{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .\\33xl\\:hover\\:scale-100:hover{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .\\33xl\\:hover\\:scale-105:hover{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .\\33xl\\:hover\\:scale-110:hover{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .\\33xl\\:hover\\:scale-125:hover{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .\\33xl\\:hover\\:scale-150:hover{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .\\33xl\\:hover\\:scale-x-0:hover{
    --transform-scale-x: 0;
  }

  .\\33xl\\:hover\\:scale-x-50:hover{
    --transform-scale-x: .5;
  }

  .\\33xl\\:hover\\:scale-x-75:hover{
    --transform-scale-x: .75;
  }

  .\\33xl\\:hover\\:scale-x-90:hover{
    --transform-scale-x: .9;
  }

  .\\33xl\\:hover\\:scale-x-95:hover{
    --transform-scale-x: .95;
  }

  .\\33xl\\:hover\\:scale-x-100:hover{
    --transform-scale-x: 1;
  }

  .\\33xl\\:hover\\:scale-x-105:hover{
    --transform-scale-x: 1.05;
  }

  .\\33xl\\:hover\\:scale-x-110:hover{
    --transform-scale-x: 1.1;
  }

  .\\33xl\\:hover\\:scale-x-125:hover{
    --transform-scale-x: 1.25;
  }

  .\\33xl\\:hover\\:scale-x-150:hover{
    --transform-scale-x: 1.5;
  }

  .\\33xl\\:hover\\:scale-y-0:hover{
    --transform-scale-y: 0;
  }

  .\\33xl\\:hover\\:scale-y-50:hover{
    --transform-scale-y: .5;
  }

  .\\33xl\\:hover\\:scale-y-75:hover{
    --transform-scale-y: .75;
  }

  .\\33xl\\:hover\\:scale-y-90:hover{
    --transform-scale-y: .9;
  }

  .\\33xl\\:hover\\:scale-y-95:hover{
    --transform-scale-y: .95;
  }

  .\\33xl\\:hover\\:scale-y-100:hover{
    --transform-scale-y: 1;
  }

  .\\33xl\\:hover\\:scale-y-105:hover{
    --transform-scale-y: 1.05;
  }

  .\\33xl\\:hover\\:scale-y-110:hover{
    --transform-scale-y: 1.1;
  }

  .\\33xl\\:hover\\:scale-y-125:hover{
    --transform-scale-y: 1.25;
  }

  .\\33xl\\:hover\\:scale-y-150:hover{
    --transform-scale-y: 1.5;
  }

  .\\33xl\\:focus\\:scale-0:focus{
    --transform-scale-x: 0;
    --transform-scale-y: 0;
  }

  .\\33xl\\:focus\\:scale-50:focus{
    --transform-scale-x: .5;
    --transform-scale-y: .5;
  }

  .\\33xl\\:focus\\:scale-75:focus{
    --transform-scale-x: .75;
    --transform-scale-y: .75;
  }

  .\\33xl\\:focus\\:scale-90:focus{
    --transform-scale-x: .9;
    --transform-scale-y: .9;
  }

  .\\33xl\\:focus\\:scale-95:focus{
    --transform-scale-x: .95;
    --transform-scale-y: .95;
  }

  .\\33xl\\:focus\\:scale-100:focus{
    --transform-scale-x: 1;
    --transform-scale-y: 1;
  }

  .\\33xl\\:focus\\:scale-105:focus{
    --transform-scale-x: 1.05;
    --transform-scale-y: 1.05;
  }

  .\\33xl\\:focus\\:scale-110:focus{
    --transform-scale-x: 1.1;
    --transform-scale-y: 1.1;
  }

  .\\33xl\\:focus\\:scale-125:focus{
    --transform-scale-x: 1.25;
    --transform-scale-y: 1.25;
  }

  .\\33xl\\:focus\\:scale-150:focus{
    --transform-scale-x: 1.5;
    --transform-scale-y: 1.5;
  }

  .\\33xl\\:focus\\:scale-x-0:focus{
    --transform-scale-x: 0;
  }

  .\\33xl\\:focus\\:scale-x-50:focus{
    --transform-scale-x: .5;
  }

  .\\33xl\\:focus\\:scale-x-75:focus{
    --transform-scale-x: .75;
  }

  .\\33xl\\:focus\\:scale-x-90:focus{
    --transform-scale-x: .9;
  }

  .\\33xl\\:focus\\:scale-x-95:focus{
    --transform-scale-x: .95;
  }

  .\\33xl\\:focus\\:scale-x-100:focus{
    --transform-scale-x: 1;
  }

  .\\33xl\\:focus\\:scale-x-105:focus{
    --transform-scale-x: 1.05;
  }

  .\\33xl\\:focus\\:scale-x-110:focus{
    --transform-scale-x: 1.1;
  }

  .\\33xl\\:focus\\:scale-x-125:focus{
    --transform-scale-x: 1.25;
  }

  .\\33xl\\:focus\\:scale-x-150:focus{
    --transform-scale-x: 1.5;
  }

  .\\33xl\\:focus\\:scale-y-0:focus{
    --transform-scale-y: 0;
  }

  .\\33xl\\:focus\\:scale-y-50:focus{
    --transform-scale-y: .5;
  }

  .\\33xl\\:focus\\:scale-y-75:focus{
    --transform-scale-y: .75;
  }

  .\\33xl\\:focus\\:scale-y-90:focus{
    --transform-scale-y: .9;
  }

  .\\33xl\\:focus\\:scale-y-95:focus{
    --transform-scale-y: .95;
  }

  .\\33xl\\:focus\\:scale-y-100:focus{
    --transform-scale-y: 1;
  }

  .\\33xl\\:focus\\:scale-y-105:focus{
    --transform-scale-y: 1.05;
  }

  .\\33xl\\:focus\\:scale-y-110:focus{
    --transform-scale-y: 1.1;
  }

  .\\33xl\\:focus\\:scale-y-125:focus{
    --transform-scale-y: 1.25;
  }

  .\\33xl\\:focus\\:scale-y-150:focus{
    --transform-scale-y: 1.5;
  }

  .\\33xl\\:rotate-0{
    --transform-rotate: 0;
  }

  .\\33xl\\:rotate-1{
    --transform-rotate: 1deg;
  }

  .\\33xl\\:rotate-2{
    --transform-rotate: 2deg;
  }

  .\\33xl\\:rotate-3{
    --transform-rotate: 3deg;
  }

  .\\33xl\\:rotate-6{
    --transform-rotate: 6deg;
  }

  .\\33xl\\:rotate-12{
    --transform-rotate: 12deg;
  }

  .\\33xl\\:rotate-45{
    --transform-rotate: 45deg;
  }

  .\\33xl\\:rotate-90{
    --transform-rotate: 90deg;
  }

  .\\33xl\\:rotate-180{
    --transform-rotate: 180deg;
  }

  .\\33xl\\:-rotate-180{
    --transform-rotate: -180deg;
  }

  .\\33xl\\:-rotate-90{
    --transform-rotate: -90deg;
  }

  .\\33xl\\:-rotate-45{
    --transform-rotate: -45deg;
  }

  .\\33xl\\:-rotate-12{
    --transform-rotate: -12deg;
  }

  .\\33xl\\:-rotate-6{
    --transform-rotate: -6deg;
  }

  .\\33xl\\:-rotate-3{
    --transform-rotate: -3deg;
  }

  .\\33xl\\:-rotate-2{
    --transform-rotate: -2deg;
  }

  .\\33xl\\:-rotate-1{
    --transform-rotate: -1deg;
  }

  .\\33xl\\:hover\\:rotate-0:hover{
    --transform-rotate: 0;
  }

  .\\33xl\\:hover\\:rotate-1:hover{
    --transform-rotate: 1deg;
  }

  .\\33xl\\:hover\\:rotate-2:hover{
    --transform-rotate: 2deg;
  }

  .\\33xl\\:hover\\:rotate-3:hover{
    --transform-rotate: 3deg;
  }

  .\\33xl\\:hover\\:rotate-6:hover{
    --transform-rotate: 6deg;
  }

  .\\33xl\\:hover\\:rotate-12:hover{
    --transform-rotate: 12deg;
  }

  .\\33xl\\:hover\\:rotate-45:hover{
    --transform-rotate: 45deg;
  }

  .\\33xl\\:hover\\:rotate-90:hover{
    --transform-rotate: 90deg;
  }

  .\\33xl\\:hover\\:rotate-180:hover{
    --transform-rotate: 180deg;
  }

  .\\33xl\\:hover\\:-rotate-180:hover{
    --transform-rotate: -180deg;
  }

  .\\33xl\\:hover\\:-rotate-90:hover{
    --transform-rotate: -90deg;
  }

  .\\33xl\\:hover\\:-rotate-45:hover{
    --transform-rotate: -45deg;
  }

  .\\33xl\\:hover\\:-rotate-12:hover{
    --transform-rotate: -12deg;
  }

  .\\33xl\\:hover\\:-rotate-6:hover{
    --transform-rotate: -6deg;
  }

  .\\33xl\\:hover\\:-rotate-3:hover{
    --transform-rotate: -3deg;
  }

  .\\33xl\\:hover\\:-rotate-2:hover{
    --transform-rotate: -2deg;
  }

  .\\33xl\\:hover\\:-rotate-1:hover{
    --transform-rotate: -1deg;
  }

  .\\33xl\\:focus\\:rotate-0:focus{
    --transform-rotate: 0;
  }

  .\\33xl\\:focus\\:rotate-1:focus{
    --transform-rotate: 1deg;
  }

  .\\33xl\\:focus\\:rotate-2:focus{
    --transform-rotate: 2deg;
  }

  .\\33xl\\:focus\\:rotate-3:focus{
    --transform-rotate: 3deg;
  }

  .\\33xl\\:focus\\:rotate-6:focus{
    --transform-rotate: 6deg;
  }

  .\\33xl\\:focus\\:rotate-12:focus{
    --transform-rotate: 12deg;
  }

  .\\33xl\\:focus\\:rotate-45:focus{
    --transform-rotate: 45deg;
  }

  .\\33xl\\:focus\\:rotate-90:focus{
    --transform-rotate: 90deg;
  }

  .\\33xl\\:focus\\:rotate-180:focus{
    --transform-rotate: 180deg;
  }

  .\\33xl\\:focus\\:-rotate-180:focus{
    --transform-rotate: -180deg;
  }

  .\\33xl\\:focus\\:-rotate-90:focus{
    --transform-rotate: -90deg;
  }

  .\\33xl\\:focus\\:-rotate-45:focus{
    --transform-rotate: -45deg;
  }

  .\\33xl\\:focus\\:-rotate-12:focus{
    --transform-rotate: -12deg;
  }

  .\\33xl\\:focus\\:-rotate-6:focus{
    --transform-rotate: -6deg;
  }

  .\\33xl\\:focus\\:-rotate-3:focus{
    --transform-rotate: -3deg;
  }

  .\\33xl\\:focus\\:-rotate-2:focus{
    --transform-rotate: -2deg;
  }

  .\\33xl\\:focus\\:-rotate-1:focus{
    --transform-rotate: -1deg;
  }

  .\\33xl\\:translate-x-0{
    --transform-translate-x: 0;
  }

  .\\33xl\\:translate-x-1{
    --transform-translate-x: 0.25rem;
  }

  .\\33xl\\:translate-x-2{
    --transform-translate-x: 0.5rem;
  }

  .\\33xl\\:translate-x-3{
    --transform-translate-x: 0.75rem;
  }

  .\\33xl\\:translate-x-4{
    --transform-translate-x: 1rem;
  }

  .\\33xl\\:translate-x-5{
    --transform-translate-x: 1.25rem;
  }

  .\\33xl\\:translate-x-6{
    --transform-translate-x: 1.5rem;
  }

  .\\33xl\\:translate-x-7{
    --transform-translate-x: 1.75rem;
  }

  .\\33xl\\:translate-x-8{
    --transform-translate-x: 2rem;
  }

  .\\33xl\\:translate-x-9{
    --transform-translate-x: 2.25rem;
  }

  .\\33xl\\:translate-x-10{
    --transform-translate-x: 2.5rem;
  }

  .\\33xl\\:translate-x-11{
    --transform-translate-x: 2.75rem;
  }

  .\\33xl\\:translate-x-12{
    --transform-translate-x: 3rem;
  }

  .\\33xl\\:translate-x-14{
    --transform-translate-x: 3.5rem;
  }

  .\\33xl\\:translate-x-15{
    --transform-translate-x: 3.75rem;
  }

  .\\33xl\\:translate-x-16{
    --transform-translate-x: 4rem;
  }

  .\\33xl\\:translate-x-18{
    --transform-translate-x: 4.5rem;
  }

  .\\33xl\\:translate-x-20{
    --transform-translate-x: 5rem;
  }

  .\\33xl\\:translate-x-22{
    --transform-translate-x: 5.5rem;
  }

  .\\33xl\\:translate-x-23{
    --transform-translate-x: 5.75rem;
  }

  .\\33xl\\:translate-x-24{
    --transform-translate-x: 6rem;
  }

  .\\33xl\\:translate-x-25{
    --transform-translate-x: 6.25rem;
  }

  .\\33xl\\:translate-x-26{
    --transform-translate-x: 6.5rem;
  }

  .\\33xl\\:translate-x-28{
    --transform-translate-x: 7rem;
  }

  .\\33xl\\:translate-x-30{
    --transform-translate-x: 7.5rem;
  }

  .\\33xl\\:translate-x-32{
    --transform-translate-x: 8rem;
  }

  .\\33xl\\:translate-x-34{
    --transform-translate-x: 8.5rem;
  }

  .\\33xl\\:translate-x-40{
    --transform-translate-x: 10rem;
  }

  .\\33xl\\:translate-x-42{
    --transform-translate-x: 10.5rem;
  }

  .\\33xl\\:translate-x-44{
    --transform-translate-x: 11rem;
  }

  .\\33xl\\:translate-x-48{
    --transform-translate-x: 12rem;
  }

  .\\33xl\\:translate-x-52{
    --transform-translate-x: 13rem;
  }

  .\\33xl\\:translate-x-54{
    --transform-translate-x: 13.5rem;
  }

  .\\33xl\\:translate-x-56{
    --transform-translate-x: 14rem;
  }

  .\\33xl\\:translate-x-60{
    --transform-translate-x: 15rem;
  }

  .\\33xl\\:translate-x-64{
    --transform-translate-x: 16rem;
  }

  .\\33xl\\:translate-x-68{
    --transform-translate-x: 17rem;
  }

  .\\33xl\\:translate-x-72{
    --transform-translate-x: 18rem;
  }

  .\\33xl\\:translate-x-74{
    --transform-translate-x: 18.5rem;
  }

  .\\33xl\\:translate-x-76{
    --transform-translate-x: 19rem;
  }

  .\\33xl\\:translate-x-78{
    --transform-translate-x: 19.5rem;
  }

  .\\33xl\\:translate-x-80{
    --transform-translate-x: 20rem;
  }

  .\\33xl\\:translate-x-82{
    --transform-translate-x: 20.5rem;
  }

  .\\33xl\\:translate-x-84{
    --transform-translate-x: 21rem;
  }

  .\\33xl\\:translate-x-88{
    --transform-translate-x: 22rem;
  }

  .\\33xl\\:translate-x-92{
    --transform-translate-x: 23rem;
  }

  .\\33xl\\:translate-x-96{
    --transform-translate-x: 24rem;
  }

  .\\33xl\\:translate-x-98{
    --transform-translate-x: 24.5rem;
  }

  .\\33xl\\:translate-x-100{
    --transform-translate-x: 25rem;
  }

  .\\33xl\\:translate-x-104{
    --transform-translate-x: 26rem;
  }

  .\\33xl\\:translate-x-112{
    --transform-translate-x: 28rem;
  }

  .\\33xl\\:translate-x-124{
    --transform-translate-x: 31rem;
  }

  .\\33xl\\:translate-x-128{
    --transform-translate-x: 32rem;
  }

  .\\33xl\\:translate-x-140{
    --transform-translate-x: 35rem;
  }

  .\\33xl\\:translate-x-152{
    --transform-translate-x: 38rem;
  }

  .\\33xl\\:translate-x-160{
    --transform-translate-x: 40rem;
  }

  .\\33xl\\:translate-x-162{
    --transform-translate-x: 41rem;
  }

  .\\33xl\\:translate-x-192{
    --transform-translate-x: 48rem;
  }

  .\\33xl\\:translate-x-208{
    --transform-translate-x: 52rem;
  }

  .\\33xl\\:translate-x-224{
    --transform-translate-x: 56rem;
  }

  .\\33xl\\:translate-x-256{
    --transform-translate-x: 64rem;
  }

  .\\33xl\\:translate-x-px{
    --transform-translate-x: 1px;
  }

  .\\33xl\\:-translate-x-1{
    --transform-translate-x: -0.25rem;
  }

  .\\33xl\\:-translate-x-2{
    --transform-translate-x: -0.5rem;
  }

  .\\33xl\\:-translate-x-3{
    --transform-translate-x: -0.75rem;
  }

  .\\33xl\\:-translate-x-4{
    --transform-translate-x: -1rem;
  }

  .\\33xl\\:-translate-x-5{
    --transform-translate-x: -1.25rem;
  }

  .\\33xl\\:-translate-x-6{
    --transform-translate-x: -1.5rem;
  }

  .\\33xl\\:-translate-x-7{
    --transform-translate-x: -1.75rem;
  }

  .\\33xl\\:-translate-x-8{
    --transform-translate-x: -2rem;
  }

  .\\33xl\\:-translate-x-9{
    --transform-translate-x: -2.25rem;
  }

  .\\33xl\\:-translate-x-10{
    --transform-translate-x: -2.5rem;
  }

  .\\33xl\\:-translate-x-11{
    --transform-translate-x: -2.75rem;
  }

  .\\33xl\\:-translate-x-12{
    --transform-translate-x: -3rem;
  }

  .\\33xl\\:-translate-x-14{
    --transform-translate-x: -3.5rem;
  }

  .\\33xl\\:-translate-x-15{
    --transform-translate-x: -3.75rem;
  }

  .\\33xl\\:-translate-x-16{
    --transform-translate-x: -4rem;
  }

  .\\33xl\\:-translate-x-18{
    --transform-translate-x: -4.5rem;
  }

  .\\33xl\\:-translate-x-20{
    --transform-translate-x: -5rem;
  }

  .\\33xl\\:-translate-x-22{
    --transform-translate-x: -5.5rem;
  }

  .\\33xl\\:-translate-x-23{
    --transform-translate-x: -5.75rem;
  }

  .\\33xl\\:-translate-x-24{
    --transform-translate-x: -6rem;
  }

  .\\33xl\\:-translate-x-25{
    --transform-translate-x: -6.25rem;
  }

  .\\33xl\\:-translate-x-26{
    --transform-translate-x: -6.5rem;
  }

  .\\33xl\\:-translate-x-28{
    --transform-translate-x: -7rem;
  }

  .\\33xl\\:-translate-x-30{
    --transform-translate-x: -7.5rem;
  }

  .\\33xl\\:-translate-x-32{
    --transform-translate-x: -8rem;
  }

  .\\33xl\\:-translate-x-34{
    --transform-translate-x: -8.5rem;
  }

  .\\33xl\\:-translate-x-40{
    --transform-translate-x: -10rem;
  }

  .\\33xl\\:-translate-x-42{
    --transform-translate-x: -10.5rem;
  }

  .\\33xl\\:-translate-x-44{
    --transform-translate-x: -11rem;
  }

  .\\33xl\\:-translate-x-48{
    --transform-translate-x: -12rem;
  }

  .\\33xl\\:-translate-x-52{
    --transform-translate-x: -13rem;
  }

  .\\33xl\\:-translate-x-54{
    --transform-translate-x: -13.5rem;
  }

  .\\33xl\\:-translate-x-56{
    --transform-translate-x: -14rem;
  }

  .\\33xl\\:-translate-x-60{
    --transform-translate-x: -15rem;
  }

  .\\33xl\\:-translate-x-64{
    --transform-translate-x: -16rem;
  }

  .\\33xl\\:-translate-x-68{
    --transform-translate-x: -17rem;
  }

  .\\33xl\\:-translate-x-72{
    --transform-translate-x: -18rem;
  }

  .\\33xl\\:-translate-x-74{
    --transform-translate-x: -18.5rem;
  }

  .\\33xl\\:-translate-x-76{
    --transform-translate-x: -19rem;
  }

  .\\33xl\\:-translate-x-78{
    --transform-translate-x: -19.5rem;
  }

  .\\33xl\\:-translate-x-80{
    --transform-translate-x: -20rem;
  }

  .\\33xl\\:-translate-x-82{
    --transform-translate-x: -20.5rem;
  }

  .\\33xl\\:-translate-x-84{
    --transform-translate-x: -21rem;
  }

  .\\33xl\\:-translate-x-88{
    --transform-translate-x: -22rem;
  }

  .\\33xl\\:-translate-x-92{
    --transform-translate-x: -23rem;
  }

  .\\33xl\\:-translate-x-96{
    --transform-translate-x: -24rem;
  }

  .\\33xl\\:-translate-x-98{
    --transform-translate-x: -24.5rem;
  }

  .\\33xl\\:-translate-x-100{
    --transform-translate-x: -25rem;
  }

  .\\33xl\\:-translate-x-104{
    --transform-translate-x: -26rem;
  }

  .\\33xl\\:-translate-x-112{
    --transform-translate-x: -28rem;
  }

  .\\33xl\\:-translate-x-124{
    --transform-translate-x: -31rem;
  }

  .\\33xl\\:-translate-x-128{
    --transform-translate-x: -32rem;
  }

  .\\33xl\\:-translate-x-140{
    --transform-translate-x: -35rem;
  }

  .\\33xl\\:-translate-x-152{
    --transform-translate-x: -38rem;
  }

  .\\33xl\\:-translate-x-160{
    --transform-translate-x: -40rem;
  }

  .\\33xl\\:-translate-x-162{
    --transform-translate-x: -41rem;
  }

  .\\33xl\\:-translate-x-192{
    --transform-translate-x: -48rem;
  }

  .\\33xl\\:-translate-x-208{
    --transform-translate-x: -52rem;
  }

  .\\33xl\\:-translate-x-224{
    --transform-translate-x: -56rem;
  }

  .\\33xl\\:-translate-x-256{
    --transform-translate-x: -64rem;
  }

  .\\33xl\\:-translate-x-px{
    --transform-translate-x: -1px;
  }

  .\\33xl\\:-translate-x-full{
    --transform-translate-x: -100%;
  }

  .\\33xl\\:-translate-x-1\\/2{
    --transform-translate-x: -50%;
  }

  .\\33xl\\:translate-x-1\\/2{
    --transform-translate-x: 50%;
  }

  .\\33xl\\:translate-x-full{
    --transform-translate-x: 100%;
  }

  .\\33xl\\:translate-y-0{
    --transform-translate-y: 0;
  }

  .\\33xl\\:translate-y-1{
    --transform-translate-y: 0.25rem;
  }

  .\\33xl\\:translate-y-2{
    --transform-translate-y: 0.5rem;
  }

  .\\33xl\\:translate-y-3{
    --transform-translate-y: 0.75rem;
  }

  .\\33xl\\:translate-y-4{
    --transform-translate-y: 1rem;
  }

  .\\33xl\\:translate-y-5{
    --transform-translate-y: 1.25rem;
  }

  .\\33xl\\:translate-y-6{
    --transform-translate-y: 1.5rem;
  }

  .\\33xl\\:translate-y-7{
    --transform-translate-y: 1.75rem;
  }

  .\\33xl\\:translate-y-8{
    --transform-translate-y: 2rem;
  }

  .\\33xl\\:translate-y-9{
    --transform-translate-y: 2.25rem;
  }

  .\\33xl\\:translate-y-10{
    --transform-translate-y: 2.5rem;
  }

  .\\33xl\\:translate-y-11{
    --transform-translate-y: 2.75rem;
  }

  .\\33xl\\:translate-y-12{
    --transform-translate-y: 3rem;
  }

  .\\33xl\\:translate-y-14{
    --transform-translate-y: 3.5rem;
  }

  .\\33xl\\:translate-y-15{
    --transform-translate-y: 3.75rem;
  }

  .\\33xl\\:translate-y-16{
    --transform-translate-y: 4rem;
  }

  .\\33xl\\:translate-y-18{
    --transform-translate-y: 4.5rem;
  }

  .\\33xl\\:translate-y-20{
    --transform-translate-y: 5rem;
  }

  .\\33xl\\:translate-y-22{
    --transform-translate-y: 5.5rem;
  }

  .\\33xl\\:translate-y-23{
    --transform-translate-y: 5.75rem;
  }

  .\\33xl\\:translate-y-24{
    --transform-translate-y: 6rem;
  }

  .\\33xl\\:translate-y-25{
    --transform-translate-y: 6.25rem;
  }

  .\\33xl\\:translate-y-26{
    --transform-translate-y: 6.5rem;
  }

  .\\33xl\\:translate-y-28{
    --transform-translate-y: 7rem;
  }

  .\\33xl\\:translate-y-30{
    --transform-translate-y: 7.5rem;
  }

  .\\33xl\\:translate-y-32{
    --transform-translate-y: 8rem;
  }

  .\\33xl\\:translate-y-34{
    --transform-translate-y: 8.5rem;
  }

  .\\33xl\\:translate-y-40{
    --transform-translate-y: 10rem;
  }

  .\\33xl\\:translate-y-42{
    --transform-translate-y: 10.5rem;
  }

  .\\33xl\\:translate-y-44{
    --transform-translate-y: 11rem;
  }

  .\\33xl\\:translate-y-48{
    --transform-translate-y: 12rem;
  }

  .\\33xl\\:translate-y-52{
    --transform-translate-y: 13rem;
  }

  .\\33xl\\:translate-y-54{
    --transform-translate-y: 13.5rem;
  }

  .\\33xl\\:translate-y-56{
    --transform-translate-y: 14rem;
  }

  .\\33xl\\:translate-y-60{
    --transform-translate-y: 15rem;
  }

  .\\33xl\\:translate-y-64{
    --transform-translate-y: 16rem;
  }

  .\\33xl\\:translate-y-68{
    --transform-translate-y: 17rem;
  }

  .\\33xl\\:translate-y-72{
    --transform-translate-y: 18rem;
  }

  .\\33xl\\:translate-y-74{
    --transform-translate-y: 18.5rem;
  }

  .\\33xl\\:translate-y-76{
    --transform-translate-y: 19rem;
  }

  .\\33xl\\:translate-y-78{
    --transform-translate-y: 19.5rem;
  }

  .\\33xl\\:translate-y-80{
    --transform-translate-y: 20rem;
  }

  .\\33xl\\:translate-y-82{
    --transform-translate-y: 20.5rem;
  }

  .\\33xl\\:translate-y-84{
    --transform-translate-y: 21rem;
  }

  .\\33xl\\:translate-y-88{
    --transform-translate-y: 22rem;
  }

  .\\33xl\\:translate-y-92{
    --transform-translate-y: 23rem;
  }

  .\\33xl\\:translate-y-96{
    --transform-translate-y: 24rem;
  }

  .\\33xl\\:translate-y-98{
    --transform-translate-y: 24.5rem;
  }

  .\\33xl\\:translate-y-100{
    --transform-translate-y: 25rem;
  }

  .\\33xl\\:translate-y-104{
    --transform-translate-y: 26rem;
  }

  .\\33xl\\:translate-y-112{
    --transform-translate-y: 28rem;
  }

  .\\33xl\\:translate-y-124{
    --transform-translate-y: 31rem;
  }

  .\\33xl\\:translate-y-128{
    --transform-translate-y: 32rem;
  }

  .\\33xl\\:translate-y-140{
    --transform-translate-y: 35rem;
  }

  .\\33xl\\:translate-y-152{
    --transform-translate-y: 38rem;
  }

  .\\33xl\\:translate-y-160{
    --transform-translate-y: 40rem;
  }

  .\\33xl\\:translate-y-162{
    --transform-translate-y: 41rem;
  }

  .\\33xl\\:translate-y-192{
    --transform-translate-y: 48rem;
  }

  .\\33xl\\:translate-y-208{
    --transform-translate-y: 52rem;
  }

  .\\33xl\\:translate-y-224{
    --transform-translate-y: 56rem;
  }

  .\\33xl\\:translate-y-256{
    --transform-translate-y: 64rem;
  }

  .\\33xl\\:translate-y-px{
    --transform-translate-y: 1px;
  }

  .\\33xl\\:-translate-y-1{
    --transform-translate-y: -0.25rem;
  }

  .\\33xl\\:-translate-y-2{
    --transform-translate-y: -0.5rem;
  }

  .\\33xl\\:-translate-y-3{
    --transform-translate-y: -0.75rem;
  }

  .\\33xl\\:-translate-y-4{
    --transform-translate-y: -1rem;
  }

  .\\33xl\\:-translate-y-5{
    --transform-translate-y: -1.25rem;
  }

  .\\33xl\\:-translate-y-6{
    --transform-translate-y: -1.5rem;
  }

  .\\33xl\\:-translate-y-7{
    --transform-translate-y: -1.75rem;
  }

  .\\33xl\\:-translate-y-8{
    --transform-translate-y: -2rem;
  }

  .\\33xl\\:-translate-y-9{
    --transform-translate-y: -2.25rem;
  }

  .\\33xl\\:-translate-y-10{
    --transform-translate-y: -2.5rem;
  }

  .\\33xl\\:-translate-y-11{
    --transform-translate-y: -2.75rem;
  }

  .\\33xl\\:-translate-y-12{
    --transform-translate-y: -3rem;
  }

  .\\33xl\\:-translate-y-14{
    --transform-translate-y: -3.5rem;
  }

  .\\33xl\\:-translate-y-15{
    --transform-translate-y: -3.75rem;
  }

  .\\33xl\\:-translate-y-16{
    --transform-translate-y: -4rem;
  }

  .\\33xl\\:-translate-y-18{
    --transform-translate-y: -4.5rem;
  }

  .\\33xl\\:-translate-y-20{
    --transform-translate-y: -5rem;
  }

  .\\33xl\\:-translate-y-22{
    --transform-translate-y: -5.5rem;
  }

  .\\33xl\\:-translate-y-23{
    --transform-translate-y: -5.75rem;
  }

  .\\33xl\\:-translate-y-24{
    --transform-translate-y: -6rem;
  }

  .\\33xl\\:-translate-y-25{
    --transform-translate-y: -6.25rem;
  }

  .\\33xl\\:-translate-y-26{
    --transform-translate-y: -6.5rem;
  }

  .\\33xl\\:-translate-y-28{
    --transform-translate-y: -7rem;
  }

  .\\33xl\\:-translate-y-30{
    --transform-translate-y: -7.5rem;
  }

  .\\33xl\\:-translate-y-32{
    --transform-translate-y: -8rem;
  }

  .\\33xl\\:-translate-y-34{
    --transform-translate-y: -8.5rem;
  }

  .\\33xl\\:-translate-y-40{
    --transform-translate-y: -10rem;
  }

  .\\33xl\\:-translate-y-42{
    --transform-translate-y: -10.5rem;
  }

  .\\33xl\\:-translate-y-44{
    --transform-translate-y: -11rem;
  }

  .\\33xl\\:-translate-y-48{
    --transform-translate-y: -12rem;
  }

  .\\33xl\\:-translate-y-52{
    --transform-translate-y: -13rem;
  }

  .\\33xl\\:-translate-y-54{
    --transform-translate-y: -13.5rem;
  }

  .\\33xl\\:-translate-y-56{
    --transform-translate-y: -14rem;
  }

  .\\33xl\\:-translate-y-60{
    --transform-translate-y: -15rem;
  }

  .\\33xl\\:-translate-y-64{
    --transform-translate-y: -16rem;
  }

  .\\33xl\\:-translate-y-68{
    --transform-translate-y: -17rem;
  }

  .\\33xl\\:-translate-y-72{
    --transform-translate-y: -18rem;
  }

  .\\33xl\\:-translate-y-74{
    --transform-translate-y: -18.5rem;
  }

  .\\33xl\\:-translate-y-76{
    --transform-translate-y: -19rem;
  }

  .\\33xl\\:-translate-y-78{
    --transform-translate-y: -19.5rem;
  }

  .\\33xl\\:-translate-y-80{
    --transform-translate-y: -20rem;
  }

  .\\33xl\\:-translate-y-82{
    --transform-translate-y: -20.5rem;
  }

  .\\33xl\\:-translate-y-84{
    --transform-translate-y: -21rem;
  }

  .\\33xl\\:-translate-y-88{
    --transform-translate-y: -22rem;
  }

  .\\33xl\\:-translate-y-92{
    --transform-translate-y: -23rem;
  }

  .\\33xl\\:-translate-y-96{
    --transform-translate-y: -24rem;
  }

  .\\33xl\\:-translate-y-98{
    --transform-translate-y: -24.5rem;
  }

  .\\33xl\\:-translate-y-100{
    --transform-translate-y: -25rem;
  }

  .\\33xl\\:-translate-y-104{
    --transform-translate-y: -26rem;
  }

  .\\33xl\\:-translate-y-112{
    --transform-translate-y: -28rem;
  }

  .\\33xl\\:-translate-y-124{
    --transform-translate-y: -31rem;
  }

  .\\33xl\\:-translate-y-128{
    --transform-translate-y: -32rem;
  }

  .\\33xl\\:-translate-y-140{
    --transform-translate-y: -35rem;
  }

  .\\33xl\\:-translate-y-152{
    --transform-translate-y: -38rem;
  }

  .\\33xl\\:-translate-y-160{
    --transform-translate-y: -40rem;
  }

  .\\33xl\\:-translate-y-162{
    --transform-translate-y: -41rem;
  }

  .\\33xl\\:-translate-y-192{
    --transform-translate-y: -48rem;
  }

  .\\33xl\\:-translate-y-208{
    --transform-translate-y: -52rem;
  }

  .\\33xl\\:-translate-y-224{
    --transform-translate-y: -56rem;
  }

  .\\33xl\\:-translate-y-256{
    --transform-translate-y: -64rem;
  }

  .\\33xl\\:-translate-y-px{
    --transform-translate-y: -1px;
  }

  .\\33xl\\:-translate-y-full{
    --transform-translate-y: -100%;
  }

  .\\33xl\\:-translate-y-1\\/2{
    --transform-translate-y: -50%;
  }

  .\\33xl\\:translate-y-1\\/2{
    --transform-translate-y: 50%;
  }

  .\\33xl\\:translate-y-full{
    --transform-translate-y: 100%;
  }

  .\\33xl\\:hover\\:translate-x-0:hover{
    --transform-translate-x: 0;
  }

  .\\33xl\\:hover\\:translate-x-1:hover{
    --transform-translate-x: 0.25rem;
  }

  .\\33xl\\:hover\\:translate-x-2:hover{
    --transform-translate-x: 0.5rem;
  }

  .\\33xl\\:hover\\:translate-x-3:hover{
    --transform-translate-x: 0.75rem;
  }

  .\\33xl\\:hover\\:translate-x-4:hover{
    --transform-translate-x: 1rem;
  }

  .\\33xl\\:hover\\:translate-x-5:hover{
    --transform-translate-x: 1.25rem;
  }

  .\\33xl\\:hover\\:translate-x-6:hover{
    --transform-translate-x: 1.5rem;
  }

  .\\33xl\\:hover\\:translate-x-7:hover{
    --transform-translate-x: 1.75rem;
  }

  .\\33xl\\:hover\\:translate-x-8:hover{
    --transform-translate-x: 2rem;
  }

  .\\33xl\\:hover\\:translate-x-9:hover{
    --transform-translate-x: 2.25rem;
  }

  .\\33xl\\:hover\\:translate-x-10:hover{
    --transform-translate-x: 2.5rem;
  }

  .\\33xl\\:hover\\:translate-x-11:hover{
    --transform-translate-x: 2.75rem;
  }

  .\\33xl\\:hover\\:translate-x-12:hover{
    --transform-translate-x: 3rem;
  }

  .\\33xl\\:hover\\:translate-x-14:hover{
    --transform-translate-x: 3.5rem;
  }

  .\\33xl\\:hover\\:translate-x-15:hover{
    --transform-translate-x: 3.75rem;
  }

  .\\33xl\\:hover\\:translate-x-16:hover{
    --transform-translate-x: 4rem;
  }

  .\\33xl\\:hover\\:translate-x-18:hover{
    --transform-translate-x: 4.5rem;
  }

  .\\33xl\\:hover\\:translate-x-20:hover{
    --transform-translate-x: 5rem;
  }

  .\\33xl\\:hover\\:translate-x-22:hover{
    --transform-translate-x: 5.5rem;
  }

  .\\33xl\\:hover\\:translate-x-23:hover{
    --transform-translate-x: 5.75rem;
  }

  .\\33xl\\:hover\\:translate-x-24:hover{
    --transform-translate-x: 6rem;
  }

  .\\33xl\\:hover\\:translate-x-25:hover{
    --transform-translate-x: 6.25rem;
  }

  .\\33xl\\:hover\\:translate-x-26:hover{
    --transform-translate-x: 6.5rem;
  }

  .\\33xl\\:hover\\:translate-x-28:hover{
    --transform-translate-x: 7rem;
  }

  .\\33xl\\:hover\\:translate-x-30:hover{
    --transform-translate-x: 7.5rem;
  }

  .\\33xl\\:hover\\:translate-x-32:hover{
    --transform-translate-x: 8rem;
  }

  .\\33xl\\:hover\\:translate-x-34:hover{
    --transform-translate-x: 8.5rem;
  }

  .\\33xl\\:hover\\:translate-x-40:hover{
    --transform-translate-x: 10rem;
  }

  .\\33xl\\:hover\\:translate-x-42:hover{
    --transform-translate-x: 10.5rem;
  }

  .\\33xl\\:hover\\:translate-x-44:hover{
    --transform-translate-x: 11rem;
  }

  .\\33xl\\:hover\\:translate-x-48:hover{
    --transform-translate-x: 12rem;
  }

  .\\33xl\\:hover\\:translate-x-52:hover{
    --transform-translate-x: 13rem;
  }

  .\\33xl\\:hover\\:translate-x-54:hover{
    --transform-translate-x: 13.5rem;
  }

  .\\33xl\\:hover\\:translate-x-56:hover{
    --transform-translate-x: 14rem;
  }

  .\\33xl\\:hover\\:translate-x-60:hover{
    --transform-translate-x: 15rem;
  }

  .\\33xl\\:hover\\:translate-x-64:hover{
    --transform-translate-x: 16rem;
  }

  .\\33xl\\:hover\\:translate-x-68:hover{
    --transform-translate-x: 17rem;
  }

  .\\33xl\\:hover\\:translate-x-72:hover{
    --transform-translate-x: 18rem;
  }

  .\\33xl\\:hover\\:translate-x-74:hover{
    --transform-translate-x: 18.5rem;
  }

  .\\33xl\\:hover\\:translate-x-76:hover{
    --transform-translate-x: 19rem;
  }

  .\\33xl\\:hover\\:translate-x-78:hover{
    --transform-translate-x: 19.5rem;
  }

  .\\33xl\\:hover\\:translate-x-80:hover{
    --transform-translate-x: 20rem;
  }

  .\\33xl\\:hover\\:translate-x-82:hover{
    --transform-translate-x: 20.5rem;
  }

  .\\33xl\\:hover\\:translate-x-84:hover{
    --transform-translate-x: 21rem;
  }

  .\\33xl\\:hover\\:translate-x-88:hover{
    --transform-translate-x: 22rem;
  }

  .\\33xl\\:hover\\:translate-x-92:hover{
    --transform-translate-x: 23rem;
  }

  .\\33xl\\:hover\\:translate-x-96:hover{
    --transform-translate-x: 24rem;
  }

  .\\33xl\\:hover\\:translate-x-98:hover{
    --transform-translate-x: 24.5rem;
  }

  .\\33xl\\:hover\\:translate-x-100:hover{
    --transform-translate-x: 25rem;
  }

  .\\33xl\\:hover\\:translate-x-104:hover{
    --transform-translate-x: 26rem;
  }

  .\\33xl\\:hover\\:translate-x-112:hover{
    --transform-translate-x: 28rem;
  }

  .\\33xl\\:hover\\:translate-x-124:hover{
    --transform-translate-x: 31rem;
  }

  .\\33xl\\:hover\\:translate-x-128:hover{
    --transform-translate-x: 32rem;
  }

  .\\33xl\\:hover\\:translate-x-140:hover{
    --transform-translate-x: 35rem;
  }

  .\\33xl\\:hover\\:translate-x-152:hover{
    --transform-translate-x: 38rem;
  }

  .\\33xl\\:hover\\:translate-x-160:hover{
    --transform-translate-x: 40rem;
  }

  .\\33xl\\:hover\\:translate-x-162:hover{
    --transform-translate-x: 41rem;
  }

  .\\33xl\\:hover\\:translate-x-192:hover{
    --transform-translate-x: 48rem;
  }

  .\\33xl\\:hover\\:translate-x-208:hover{
    --transform-translate-x: 52rem;
  }

  .\\33xl\\:hover\\:translate-x-224:hover{
    --transform-translate-x: 56rem;
  }

  .\\33xl\\:hover\\:translate-x-256:hover{
    --transform-translate-x: 64rem;
  }

  .\\33xl\\:hover\\:translate-x-px:hover{
    --transform-translate-x: 1px;
  }

  .\\33xl\\:hover\\:-translate-x-1:hover{
    --transform-translate-x: -0.25rem;
  }

  .\\33xl\\:hover\\:-translate-x-2:hover{
    --transform-translate-x: -0.5rem;
  }

  .\\33xl\\:hover\\:-translate-x-3:hover{
    --transform-translate-x: -0.75rem;
  }

  .\\33xl\\:hover\\:-translate-x-4:hover{
    --transform-translate-x: -1rem;
  }

  .\\33xl\\:hover\\:-translate-x-5:hover{
    --transform-translate-x: -1.25rem;
  }

  .\\33xl\\:hover\\:-translate-x-6:hover{
    --transform-translate-x: -1.5rem;
  }

  .\\33xl\\:hover\\:-translate-x-7:hover{
    --transform-translate-x: -1.75rem;
  }

  .\\33xl\\:hover\\:-translate-x-8:hover{
    --transform-translate-x: -2rem;
  }

  .\\33xl\\:hover\\:-translate-x-9:hover{
    --transform-translate-x: -2.25rem;
  }

  .\\33xl\\:hover\\:-translate-x-10:hover{
    --transform-translate-x: -2.5rem;
  }

  .\\33xl\\:hover\\:-translate-x-11:hover{
    --transform-translate-x: -2.75rem;
  }

  .\\33xl\\:hover\\:-translate-x-12:hover{
    --transform-translate-x: -3rem;
  }

  .\\33xl\\:hover\\:-translate-x-14:hover{
    --transform-translate-x: -3.5rem;
  }

  .\\33xl\\:hover\\:-translate-x-15:hover{
    --transform-translate-x: -3.75rem;
  }

  .\\33xl\\:hover\\:-translate-x-16:hover{
    --transform-translate-x: -4rem;
  }

  .\\33xl\\:hover\\:-translate-x-18:hover{
    --transform-translate-x: -4.5rem;
  }

  .\\33xl\\:hover\\:-translate-x-20:hover{
    --transform-translate-x: -5rem;
  }

  .\\33xl\\:hover\\:-translate-x-22:hover{
    --transform-translate-x: -5.5rem;
  }

  .\\33xl\\:hover\\:-translate-x-23:hover{
    --transform-translate-x: -5.75rem;
  }

  .\\33xl\\:hover\\:-translate-x-24:hover{
    --transform-translate-x: -6rem;
  }

  .\\33xl\\:hover\\:-translate-x-25:hover{
    --transform-translate-x: -6.25rem;
  }

  .\\33xl\\:hover\\:-translate-x-26:hover{
    --transform-translate-x: -6.5rem;
  }

  .\\33xl\\:hover\\:-translate-x-28:hover{
    --transform-translate-x: -7rem;
  }

  .\\33xl\\:hover\\:-translate-x-30:hover{
    --transform-translate-x: -7.5rem;
  }

  .\\33xl\\:hover\\:-translate-x-32:hover{
    --transform-translate-x: -8rem;
  }

  .\\33xl\\:hover\\:-translate-x-34:hover{
    --transform-translate-x: -8.5rem;
  }

  .\\33xl\\:hover\\:-translate-x-40:hover{
    --transform-translate-x: -10rem;
  }

  .\\33xl\\:hover\\:-translate-x-42:hover{
    --transform-translate-x: -10.5rem;
  }

  .\\33xl\\:hover\\:-translate-x-44:hover{
    --transform-translate-x: -11rem;
  }

  .\\33xl\\:hover\\:-translate-x-48:hover{
    --transform-translate-x: -12rem;
  }

  .\\33xl\\:hover\\:-translate-x-52:hover{
    --transform-translate-x: -13rem;
  }

  .\\33xl\\:hover\\:-translate-x-54:hover{
    --transform-translate-x: -13.5rem;
  }

  .\\33xl\\:hover\\:-translate-x-56:hover{
    --transform-translate-x: -14rem;
  }

  .\\33xl\\:hover\\:-translate-x-60:hover{
    --transform-translate-x: -15rem;
  }

  .\\33xl\\:hover\\:-translate-x-64:hover{
    --transform-translate-x: -16rem;
  }

  .\\33xl\\:hover\\:-translate-x-68:hover{
    --transform-translate-x: -17rem;
  }

  .\\33xl\\:hover\\:-translate-x-72:hover{
    --transform-translate-x: -18rem;
  }

  .\\33xl\\:hover\\:-translate-x-74:hover{
    --transform-translate-x: -18.5rem;
  }

  .\\33xl\\:hover\\:-translate-x-76:hover{
    --transform-translate-x: -19rem;
  }

  .\\33xl\\:hover\\:-translate-x-78:hover{
    --transform-translate-x: -19.5rem;
  }

  .\\33xl\\:hover\\:-translate-x-80:hover{
    --transform-translate-x: -20rem;
  }

  .\\33xl\\:hover\\:-translate-x-82:hover{
    --transform-translate-x: -20.5rem;
  }

  .\\33xl\\:hover\\:-translate-x-84:hover{
    --transform-translate-x: -21rem;
  }

  .\\33xl\\:hover\\:-translate-x-88:hover{
    --transform-translate-x: -22rem;
  }

  .\\33xl\\:hover\\:-translate-x-92:hover{
    --transform-translate-x: -23rem;
  }

  .\\33xl\\:hover\\:-translate-x-96:hover{
    --transform-translate-x: -24rem;
  }

  .\\33xl\\:hover\\:-translate-x-98:hover{
    --transform-translate-x: -24.5rem;
  }

  .\\33xl\\:hover\\:-translate-x-100:hover{
    --transform-translate-x: -25rem;
  }

  .\\33xl\\:hover\\:-translate-x-104:hover{
    --transform-translate-x: -26rem;
  }

  .\\33xl\\:hover\\:-translate-x-112:hover{
    --transform-translate-x: -28rem;
  }

  .\\33xl\\:hover\\:-translate-x-124:hover{
    --transform-translate-x: -31rem;
  }

  .\\33xl\\:hover\\:-translate-x-128:hover{
    --transform-translate-x: -32rem;
  }

  .\\33xl\\:hover\\:-translate-x-140:hover{
    --transform-translate-x: -35rem;
  }

  .\\33xl\\:hover\\:-translate-x-152:hover{
    --transform-translate-x: -38rem;
  }

  .\\33xl\\:hover\\:-translate-x-160:hover{
    --transform-translate-x: -40rem;
  }

  .\\33xl\\:hover\\:-translate-x-162:hover{
    --transform-translate-x: -41rem;
  }

  .\\33xl\\:hover\\:-translate-x-192:hover{
    --transform-translate-x: -48rem;
  }

  .\\33xl\\:hover\\:-translate-x-208:hover{
    --transform-translate-x: -52rem;
  }

  .\\33xl\\:hover\\:-translate-x-224:hover{
    --transform-translate-x: -56rem;
  }

  .\\33xl\\:hover\\:-translate-x-256:hover{
    --transform-translate-x: -64rem;
  }

  .\\33xl\\:hover\\:-translate-x-px:hover{
    --transform-translate-x: -1px;
  }

  .\\33xl\\:hover\\:-translate-x-full:hover{
    --transform-translate-x: -100%;
  }

  .\\33xl\\:hover\\:-translate-x-1\\/2:hover{
    --transform-translate-x: -50%;
  }

  .\\33xl\\:hover\\:translate-x-1\\/2:hover{
    --transform-translate-x: 50%;
  }

  .\\33xl\\:hover\\:translate-x-full:hover{
    --transform-translate-x: 100%;
  }

  .\\33xl\\:hover\\:translate-y-0:hover{
    --transform-translate-y: 0;
  }

  .\\33xl\\:hover\\:translate-y-1:hover{
    --transform-translate-y: 0.25rem;
  }

  .\\33xl\\:hover\\:translate-y-2:hover{
    --transform-translate-y: 0.5rem;
  }

  .\\33xl\\:hover\\:translate-y-3:hover{
    --transform-translate-y: 0.75rem;
  }

  .\\33xl\\:hover\\:translate-y-4:hover{
    --transform-translate-y: 1rem;
  }

  .\\33xl\\:hover\\:translate-y-5:hover{
    --transform-translate-y: 1.25rem;
  }

  .\\33xl\\:hover\\:translate-y-6:hover{
    --transform-translate-y: 1.5rem;
  }

  .\\33xl\\:hover\\:translate-y-7:hover{
    --transform-translate-y: 1.75rem;
  }

  .\\33xl\\:hover\\:translate-y-8:hover{
    --transform-translate-y: 2rem;
  }

  .\\33xl\\:hover\\:translate-y-9:hover{
    --transform-translate-y: 2.25rem;
  }

  .\\33xl\\:hover\\:translate-y-10:hover{
    --transform-translate-y: 2.5rem;
  }

  .\\33xl\\:hover\\:translate-y-11:hover{
    --transform-translate-y: 2.75rem;
  }

  .\\33xl\\:hover\\:translate-y-12:hover{
    --transform-translate-y: 3rem;
  }

  .\\33xl\\:hover\\:translate-y-14:hover{
    --transform-translate-y: 3.5rem;
  }

  .\\33xl\\:hover\\:translate-y-15:hover{
    --transform-translate-y: 3.75rem;
  }

  .\\33xl\\:hover\\:translate-y-16:hover{
    --transform-translate-y: 4rem;
  }

  .\\33xl\\:hover\\:translate-y-18:hover{
    --transform-translate-y: 4.5rem;
  }

  .\\33xl\\:hover\\:translate-y-20:hover{
    --transform-translate-y: 5rem;
  }

  .\\33xl\\:hover\\:translate-y-22:hover{
    --transform-translate-y: 5.5rem;
  }

  .\\33xl\\:hover\\:translate-y-23:hover{
    --transform-translate-y: 5.75rem;
  }

  .\\33xl\\:hover\\:translate-y-24:hover{
    --transform-translate-y: 6rem;
  }

  .\\33xl\\:hover\\:translate-y-25:hover{
    --transform-translate-y: 6.25rem;
  }

  .\\33xl\\:hover\\:translate-y-26:hover{
    --transform-translate-y: 6.5rem;
  }

  .\\33xl\\:hover\\:translate-y-28:hover{
    --transform-translate-y: 7rem;
  }

  .\\33xl\\:hover\\:translate-y-30:hover{
    --transform-translate-y: 7.5rem;
  }

  .\\33xl\\:hover\\:translate-y-32:hover{
    --transform-translate-y: 8rem;
  }

  .\\33xl\\:hover\\:translate-y-34:hover{
    --transform-translate-y: 8.5rem;
  }

  .\\33xl\\:hover\\:translate-y-40:hover{
    --transform-translate-y: 10rem;
  }

  .\\33xl\\:hover\\:translate-y-42:hover{
    --transform-translate-y: 10.5rem;
  }

  .\\33xl\\:hover\\:translate-y-44:hover{
    --transform-translate-y: 11rem;
  }

  .\\33xl\\:hover\\:translate-y-48:hover{
    --transform-translate-y: 12rem;
  }

  .\\33xl\\:hover\\:translate-y-52:hover{
    --transform-translate-y: 13rem;
  }

  .\\33xl\\:hover\\:translate-y-54:hover{
    --transform-translate-y: 13.5rem;
  }

  .\\33xl\\:hover\\:translate-y-56:hover{
    --transform-translate-y: 14rem;
  }

  .\\33xl\\:hover\\:translate-y-60:hover{
    --transform-translate-y: 15rem;
  }

  .\\33xl\\:hover\\:translate-y-64:hover{
    --transform-translate-y: 16rem;
  }

  .\\33xl\\:hover\\:translate-y-68:hover{
    --transform-translate-y: 17rem;
  }

  .\\33xl\\:hover\\:translate-y-72:hover{
    --transform-translate-y: 18rem;
  }

  .\\33xl\\:hover\\:translate-y-74:hover{
    --transform-translate-y: 18.5rem;
  }

  .\\33xl\\:hover\\:translate-y-76:hover{
    --transform-translate-y: 19rem;
  }

  .\\33xl\\:hover\\:translate-y-78:hover{
    --transform-translate-y: 19.5rem;
  }

  .\\33xl\\:hover\\:translate-y-80:hover{
    --transform-translate-y: 20rem;
  }

  .\\33xl\\:hover\\:translate-y-82:hover{
    --transform-translate-y: 20.5rem;
  }

  .\\33xl\\:hover\\:translate-y-84:hover{
    --transform-translate-y: 21rem;
  }

  .\\33xl\\:hover\\:translate-y-88:hover{
    --transform-translate-y: 22rem;
  }

  .\\33xl\\:hover\\:translate-y-92:hover{
    --transform-translate-y: 23rem;
  }

  .\\33xl\\:hover\\:translate-y-96:hover{
    --transform-translate-y: 24rem;
  }

  .\\33xl\\:hover\\:translate-y-98:hover{
    --transform-translate-y: 24.5rem;
  }

  .\\33xl\\:hover\\:translate-y-100:hover{
    --transform-translate-y: 25rem;
  }

  .\\33xl\\:hover\\:translate-y-104:hover{
    --transform-translate-y: 26rem;
  }

  .\\33xl\\:hover\\:translate-y-112:hover{
    --transform-translate-y: 28rem;
  }

  .\\33xl\\:hover\\:translate-y-124:hover{
    --transform-translate-y: 31rem;
  }

  .\\33xl\\:hover\\:translate-y-128:hover{
    --transform-translate-y: 32rem;
  }

  .\\33xl\\:hover\\:translate-y-140:hover{
    --transform-translate-y: 35rem;
  }

  .\\33xl\\:hover\\:translate-y-152:hover{
    --transform-translate-y: 38rem;
  }

  .\\33xl\\:hover\\:translate-y-160:hover{
    --transform-translate-y: 40rem;
  }

  .\\33xl\\:hover\\:translate-y-162:hover{
    --transform-translate-y: 41rem;
  }

  .\\33xl\\:hover\\:translate-y-192:hover{
    --transform-translate-y: 48rem;
  }

  .\\33xl\\:hover\\:translate-y-208:hover{
    --transform-translate-y: 52rem;
  }

  .\\33xl\\:hover\\:translate-y-224:hover{
    --transform-translate-y: 56rem;
  }

  .\\33xl\\:hover\\:translate-y-256:hover{
    --transform-translate-y: 64rem;
  }

  .\\33xl\\:hover\\:translate-y-px:hover{
    --transform-translate-y: 1px;
  }

  .\\33xl\\:hover\\:-translate-y-1:hover{
    --transform-translate-y: -0.25rem;
  }

  .\\33xl\\:hover\\:-translate-y-2:hover{
    --transform-translate-y: -0.5rem;
  }

  .\\33xl\\:hover\\:-translate-y-3:hover{
    --transform-translate-y: -0.75rem;
  }

  .\\33xl\\:hover\\:-translate-y-4:hover{
    --transform-translate-y: -1rem;
  }

  .\\33xl\\:hover\\:-translate-y-5:hover{
    --transform-translate-y: -1.25rem;
  }

  .\\33xl\\:hover\\:-translate-y-6:hover{
    --transform-translate-y: -1.5rem;
  }

  .\\33xl\\:hover\\:-translate-y-7:hover{
    --transform-translate-y: -1.75rem;
  }

  .\\33xl\\:hover\\:-translate-y-8:hover{
    --transform-translate-y: -2rem;
  }

  .\\33xl\\:hover\\:-translate-y-9:hover{
    --transform-translate-y: -2.25rem;
  }

  .\\33xl\\:hover\\:-translate-y-10:hover{
    --transform-translate-y: -2.5rem;
  }

  .\\33xl\\:hover\\:-translate-y-11:hover{
    --transform-translate-y: -2.75rem;
  }

  .\\33xl\\:hover\\:-translate-y-12:hover{
    --transform-translate-y: -3rem;
  }

  .\\33xl\\:hover\\:-translate-y-14:hover{
    --transform-translate-y: -3.5rem;
  }

  .\\33xl\\:hover\\:-translate-y-15:hover{
    --transform-translate-y: -3.75rem;
  }

  .\\33xl\\:hover\\:-translate-y-16:hover{
    --transform-translate-y: -4rem;
  }

  .\\33xl\\:hover\\:-translate-y-18:hover{
    --transform-translate-y: -4.5rem;
  }

  .\\33xl\\:hover\\:-translate-y-20:hover{
    --transform-translate-y: -5rem;
  }

  .\\33xl\\:hover\\:-translate-y-22:hover{
    --transform-translate-y: -5.5rem;
  }

  .\\33xl\\:hover\\:-translate-y-23:hover{
    --transform-translate-y: -5.75rem;
  }

  .\\33xl\\:hover\\:-translate-y-24:hover{
    --transform-translate-y: -6rem;
  }

  .\\33xl\\:hover\\:-translate-y-25:hover{
    --transform-translate-y: -6.25rem;
  }

  .\\33xl\\:hover\\:-translate-y-26:hover{
    --transform-translate-y: -6.5rem;
  }

  .\\33xl\\:hover\\:-translate-y-28:hover{
    --transform-translate-y: -7rem;
  }

  .\\33xl\\:hover\\:-translate-y-30:hover{
    --transform-translate-y: -7.5rem;
  }

  .\\33xl\\:hover\\:-translate-y-32:hover{
    --transform-translate-y: -8rem;
  }

  .\\33xl\\:hover\\:-translate-y-34:hover{
    --transform-translate-y: -8.5rem;
  }

  .\\33xl\\:hover\\:-translate-y-40:hover{
    --transform-translate-y: -10rem;
  }

  .\\33xl\\:hover\\:-translate-y-42:hover{
    --transform-translate-y: -10.5rem;
  }

  .\\33xl\\:hover\\:-translate-y-44:hover{
    --transform-translate-y: -11rem;
  }

  .\\33xl\\:hover\\:-translate-y-48:hover{
    --transform-translate-y: -12rem;
  }

  .\\33xl\\:hover\\:-translate-y-52:hover{
    --transform-translate-y: -13rem;
  }

  .\\33xl\\:hover\\:-translate-y-54:hover{
    --transform-translate-y: -13.5rem;
  }

  .\\33xl\\:hover\\:-translate-y-56:hover{
    --transform-translate-y: -14rem;
  }

  .\\33xl\\:hover\\:-translate-y-60:hover{
    --transform-translate-y: -15rem;
  }

  .\\33xl\\:hover\\:-translate-y-64:hover{
    --transform-translate-y: -16rem;
  }

  .\\33xl\\:hover\\:-translate-y-68:hover{
    --transform-translate-y: -17rem;
  }

  .\\33xl\\:hover\\:-translate-y-72:hover{
    --transform-translate-y: -18rem;
  }

  .\\33xl\\:hover\\:-translate-y-74:hover{
    --transform-translate-y: -18.5rem;
  }

  .\\33xl\\:hover\\:-translate-y-76:hover{
    --transform-translate-y: -19rem;
  }

  .\\33xl\\:hover\\:-translate-y-78:hover{
    --transform-translate-y: -19.5rem;
  }

  .\\33xl\\:hover\\:-translate-y-80:hover{
    --transform-translate-y: -20rem;
  }

  .\\33xl\\:hover\\:-translate-y-82:hover{
    --transform-translate-y: -20.5rem;
  }

  .\\33xl\\:hover\\:-translate-y-84:hover{
    --transform-translate-y: -21rem;
  }

  .\\33xl\\:hover\\:-translate-y-88:hover{
    --transform-translate-y: -22rem;
  }

  .\\33xl\\:hover\\:-translate-y-92:hover{
    --transform-translate-y: -23rem;
  }

  .\\33xl\\:hover\\:-translate-y-96:hover{
    --transform-translate-y: -24rem;
  }

  .\\33xl\\:hover\\:-translate-y-98:hover{
    --transform-translate-y: -24.5rem;
  }

  .\\33xl\\:hover\\:-translate-y-100:hover{
    --transform-translate-y: -25rem;
  }

  .\\33xl\\:hover\\:-translate-y-104:hover{
    --transform-translate-y: -26rem;
  }

  .\\33xl\\:hover\\:-translate-y-112:hover{
    --transform-translate-y: -28rem;
  }

  .\\33xl\\:hover\\:-translate-y-124:hover{
    --transform-translate-y: -31rem;
  }

  .\\33xl\\:hover\\:-translate-y-128:hover{
    --transform-translate-y: -32rem;
  }

  .\\33xl\\:hover\\:-translate-y-140:hover{
    --transform-translate-y: -35rem;
  }

  .\\33xl\\:hover\\:-translate-y-152:hover{
    --transform-translate-y: -38rem;
  }

  .\\33xl\\:hover\\:-translate-y-160:hover{
    --transform-translate-y: -40rem;
  }

  .\\33xl\\:hover\\:-translate-y-162:hover{
    --transform-translate-y: -41rem;
  }

  .\\33xl\\:hover\\:-translate-y-192:hover{
    --transform-translate-y: -48rem;
  }

  .\\33xl\\:hover\\:-translate-y-208:hover{
    --transform-translate-y: -52rem;
  }

  .\\33xl\\:hover\\:-translate-y-224:hover{
    --transform-translate-y: -56rem;
  }

  .\\33xl\\:hover\\:-translate-y-256:hover{
    --transform-translate-y: -64rem;
  }

  .\\33xl\\:hover\\:-translate-y-px:hover{
    --transform-translate-y: -1px;
  }

  .\\33xl\\:hover\\:-translate-y-full:hover{
    --transform-translate-y: -100%;
  }

  .\\33xl\\:hover\\:-translate-y-1\\/2:hover{
    --transform-translate-y: -50%;
  }

  .\\33xl\\:hover\\:translate-y-1\\/2:hover{
    --transform-translate-y: 50%;
  }

  .\\33xl\\:hover\\:translate-y-full:hover{
    --transform-translate-y: 100%;
  }

  .\\33xl\\:focus\\:translate-x-0:focus{
    --transform-translate-x: 0;
  }

  .\\33xl\\:focus\\:translate-x-1:focus{
    --transform-translate-x: 0.25rem;
  }

  .\\33xl\\:focus\\:translate-x-2:focus{
    --transform-translate-x: 0.5rem;
  }

  .\\33xl\\:focus\\:translate-x-3:focus{
    --transform-translate-x: 0.75rem;
  }

  .\\33xl\\:focus\\:translate-x-4:focus{
    --transform-translate-x: 1rem;
  }

  .\\33xl\\:focus\\:translate-x-5:focus{
    --transform-translate-x: 1.25rem;
  }

  .\\33xl\\:focus\\:translate-x-6:focus{
    --transform-translate-x: 1.5rem;
  }

  .\\33xl\\:focus\\:translate-x-7:focus{
    --transform-translate-x: 1.75rem;
  }

  .\\33xl\\:focus\\:translate-x-8:focus{
    --transform-translate-x: 2rem;
  }

  .\\33xl\\:focus\\:translate-x-9:focus{
    --transform-translate-x: 2.25rem;
  }

  .\\33xl\\:focus\\:translate-x-10:focus{
    --transform-translate-x: 2.5rem;
  }

  .\\33xl\\:focus\\:translate-x-11:focus{
    --transform-translate-x: 2.75rem;
  }

  .\\33xl\\:focus\\:translate-x-12:focus{
    --transform-translate-x: 3rem;
  }

  .\\33xl\\:focus\\:translate-x-14:focus{
    --transform-translate-x: 3.5rem;
  }

  .\\33xl\\:focus\\:translate-x-15:focus{
    --transform-translate-x: 3.75rem;
  }

  .\\33xl\\:focus\\:translate-x-16:focus{
    --transform-translate-x: 4rem;
  }

  .\\33xl\\:focus\\:translate-x-18:focus{
    --transform-translate-x: 4.5rem;
  }

  .\\33xl\\:focus\\:translate-x-20:focus{
    --transform-translate-x: 5rem;
  }

  .\\33xl\\:focus\\:translate-x-22:focus{
    --transform-translate-x: 5.5rem;
  }

  .\\33xl\\:focus\\:translate-x-23:focus{
    --transform-translate-x: 5.75rem;
  }

  .\\33xl\\:focus\\:translate-x-24:focus{
    --transform-translate-x: 6rem;
  }

  .\\33xl\\:focus\\:translate-x-25:focus{
    --transform-translate-x: 6.25rem;
  }

  .\\33xl\\:focus\\:translate-x-26:focus{
    --transform-translate-x: 6.5rem;
  }

  .\\33xl\\:focus\\:translate-x-28:focus{
    --transform-translate-x: 7rem;
  }

  .\\33xl\\:focus\\:translate-x-30:focus{
    --transform-translate-x: 7.5rem;
  }

  .\\33xl\\:focus\\:translate-x-32:focus{
    --transform-translate-x: 8rem;
  }

  .\\33xl\\:focus\\:translate-x-34:focus{
    --transform-translate-x: 8.5rem;
  }

  .\\33xl\\:focus\\:translate-x-40:focus{
    --transform-translate-x: 10rem;
  }

  .\\33xl\\:focus\\:translate-x-42:focus{
    --transform-translate-x: 10.5rem;
  }

  .\\33xl\\:focus\\:translate-x-44:focus{
    --transform-translate-x: 11rem;
  }

  .\\33xl\\:focus\\:translate-x-48:focus{
    --transform-translate-x: 12rem;
  }

  .\\33xl\\:focus\\:translate-x-52:focus{
    --transform-translate-x: 13rem;
  }

  .\\33xl\\:focus\\:translate-x-54:focus{
    --transform-translate-x: 13.5rem;
  }

  .\\33xl\\:focus\\:translate-x-56:focus{
    --transform-translate-x: 14rem;
  }

  .\\33xl\\:focus\\:translate-x-60:focus{
    --transform-translate-x: 15rem;
  }

  .\\33xl\\:focus\\:translate-x-64:focus{
    --transform-translate-x: 16rem;
  }

  .\\33xl\\:focus\\:translate-x-68:focus{
    --transform-translate-x: 17rem;
  }

  .\\33xl\\:focus\\:translate-x-72:focus{
    --transform-translate-x: 18rem;
  }

  .\\33xl\\:focus\\:translate-x-74:focus{
    --transform-translate-x: 18.5rem;
  }

  .\\33xl\\:focus\\:translate-x-76:focus{
    --transform-translate-x: 19rem;
  }

  .\\33xl\\:focus\\:translate-x-78:focus{
    --transform-translate-x: 19.5rem;
  }

  .\\33xl\\:focus\\:translate-x-80:focus{
    --transform-translate-x: 20rem;
  }

  .\\33xl\\:focus\\:translate-x-82:focus{
    --transform-translate-x: 20.5rem;
  }

  .\\33xl\\:focus\\:translate-x-84:focus{
    --transform-translate-x: 21rem;
  }

  .\\33xl\\:focus\\:translate-x-88:focus{
    --transform-translate-x: 22rem;
  }

  .\\33xl\\:focus\\:translate-x-92:focus{
    --transform-translate-x: 23rem;
  }

  .\\33xl\\:focus\\:translate-x-96:focus{
    --transform-translate-x: 24rem;
  }

  .\\33xl\\:focus\\:translate-x-98:focus{
    --transform-translate-x: 24.5rem;
  }

  .\\33xl\\:focus\\:translate-x-100:focus{
    --transform-translate-x: 25rem;
  }

  .\\33xl\\:focus\\:translate-x-104:focus{
    --transform-translate-x: 26rem;
  }

  .\\33xl\\:focus\\:translate-x-112:focus{
    --transform-translate-x: 28rem;
  }

  .\\33xl\\:focus\\:translate-x-124:focus{
    --transform-translate-x: 31rem;
  }

  .\\33xl\\:focus\\:translate-x-128:focus{
    --transform-translate-x: 32rem;
  }

  .\\33xl\\:focus\\:translate-x-140:focus{
    --transform-translate-x: 35rem;
  }

  .\\33xl\\:focus\\:translate-x-152:focus{
    --transform-translate-x: 38rem;
  }

  .\\33xl\\:focus\\:translate-x-160:focus{
    --transform-translate-x: 40rem;
  }

  .\\33xl\\:focus\\:translate-x-162:focus{
    --transform-translate-x: 41rem;
  }

  .\\33xl\\:focus\\:translate-x-192:focus{
    --transform-translate-x: 48rem;
  }

  .\\33xl\\:focus\\:translate-x-208:focus{
    --transform-translate-x: 52rem;
  }

  .\\33xl\\:focus\\:translate-x-224:focus{
    --transform-translate-x: 56rem;
  }

  .\\33xl\\:focus\\:translate-x-256:focus{
    --transform-translate-x: 64rem;
  }

  .\\33xl\\:focus\\:translate-x-px:focus{
    --transform-translate-x: 1px;
  }

  .\\33xl\\:focus\\:-translate-x-1:focus{
    --transform-translate-x: -0.25rem;
  }

  .\\33xl\\:focus\\:-translate-x-2:focus{
    --transform-translate-x: -0.5rem;
  }

  .\\33xl\\:focus\\:-translate-x-3:focus{
    --transform-translate-x: -0.75rem;
  }

  .\\33xl\\:focus\\:-translate-x-4:focus{
    --transform-translate-x: -1rem;
  }

  .\\33xl\\:focus\\:-translate-x-5:focus{
    --transform-translate-x: -1.25rem;
  }

  .\\33xl\\:focus\\:-translate-x-6:focus{
    --transform-translate-x: -1.5rem;
  }

  .\\33xl\\:focus\\:-translate-x-7:focus{
    --transform-translate-x: -1.75rem;
  }

  .\\33xl\\:focus\\:-translate-x-8:focus{
    --transform-translate-x: -2rem;
  }

  .\\33xl\\:focus\\:-translate-x-9:focus{
    --transform-translate-x: -2.25rem;
  }

  .\\33xl\\:focus\\:-translate-x-10:focus{
    --transform-translate-x: -2.5rem;
  }

  .\\33xl\\:focus\\:-translate-x-11:focus{
    --transform-translate-x: -2.75rem;
  }

  .\\33xl\\:focus\\:-translate-x-12:focus{
    --transform-translate-x: -3rem;
  }

  .\\33xl\\:focus\\:-translate-x-14:focus{
    --transform-translate-x: -3.5rem;
  }

  .\\33xl\\:focus\\:-translate-x-15:focus{
    --transform-translate-x: -3.75rem;
  }

  .\\33xl\\:focus\\:-translate-x-16:focus{
    --transform-translate-x: -4rem;
  }

  .\\33xl\\:focus\\:-translate-x-18:focus{
    --transform-translate-x: -4.5rem;
  }

  .\\33xl\\:focus\\:-translate-x-20:focus{
    --transform-translate-x: -5rem;
  }

  .\\33xl\\:focus\\:-translate-x-22:focus{
    --transform-translate-x: -5.5rem;
  }

  .\\33xl\\:focus\\:-translate-x-23:focus{
    --transform-translate-x: -5.75rem;
  }

  .\\33xl\\:focus\\:-translate-x-24:focus{
    --transform-translate-x: -6rem;
  }

  .\\33xl\\:focus\\:-translate-x-25:focus{
    --transform-translate-x: -6.25rem;
  }

  .\\33xl\\:focus\\:-translate-x-26:focus{
    --transform-translate-x: -6.5rem;
  }

  .\\33xl\\:focus\\:-translate-x-28:focus{
    --transform-translate-x: -7rem;
  }

  .\\33xl\\:focus\\:-translate-x-30:focus{
    --transform-translate-x: -7.5rem;
  }

  .\\33xl\\:focus\\:-translate-x-32:focus{
    --transform-translate-x: -8rem;
  }

  .\\33xl\\:focus\\:-translate-x-34:focus{
    --transform-translate-x: -8.5rem;
  }

  .\\33xl\\:focus\\:-translate-x-40:focus{
    --transform-translate-x: -10rem;
  }

  .\\33xl\\:focus\\:-translate-x-42:focus{
    --transform-translate-x: -10.5rem;
  }

  .\\33xl\\:focus\\:-translate-x-44:focus{
    --transform-translate-x: -11rem;
  }

  .\\33xl\\:focus\\:-translate-x-48:focus{
    --transform-translate-x: -12rem;
  }

  .\\33xl\\:focus\\:-translate-x-52:focus{
    --transform-translate-x: -13rem;
  }

  .\\33xl\\:focus\\:-translate-x-54:focus{
    --transform-translate-x: -13.5rem;
  }

  .\\33xl\\:focus\\:-translate-x-56:focus{
    --transform-translate-x: -14rem;
  }

  .\\33xl\\:focus\\:-translate-x-60:focus{
    --transform-translate-x: -15rem;
  }

  .\\33xl\\:focus\\:-translate-x-64:focus{
    --transform-translate-x: -16rem;
  }

  .\\33xl\\:focus\\:-translate-x-68:focus{
    --transform-translate-x: -17rem;
  }

  .\\33xl\\:focus\\:-translate-x-72:focus{
    --transform-translate-x: -18rem;
  }

  .\\33xl\\:focus\\:-translate-x-74:focus{
    --transform-translate-x: -18.5rem;
  }

  .\\33xl\\:focus\\:-translate-x-76:focus{
    --transform-translate-x: -19rem;
  }

  .\\33xl\\:focus\\:-translate-x-78:focus{
    --transform-translate-x: -19.5rem;
  }

  .\\33xl\\:focus\\:-translate-x-80:focus{
    --transform-translate-x: -20rem;
  }

  .\\33xl\\:focus\\:-translate-x-82:focus{
    --transform-translate-x: -20.5rem;
  }

  .\\33xl\\:focus\\:-translate-x-84:focus{
    --transform-translate-x: -21rem;
  }

  .\\33xl\\:focus\\:-translate-x-88:focus{
    --transform-translate-x: -22rem;
  }

  .\\33xl\\:focus\\:-translate-x-92:focus{
    --transform-translate-x: -23rem;
  }

  .\\33xl\\:focus\\:-translate-x-96:focus{
    --transform-translate-x: -24rem;
  }

  .\\33xl\\:focus\\:-translate-x-98:focus{
    --transform-translate-x: -24.5rem;
  }

  .\\33xl\\:focus\\:-translate-x-100:focus{
    --transform-translate-x: -25rem;
  }

  .\\33xl\\:focus\\:-translate-x-104:focus{
    --transform-translate-x: -26rem;
  }

  .\\33xl\\:focus\\:-translate-x-112:focus{
    --transform-translate-x: -28rem;
  }

  .\\33xl\\:focus\\:-translate-x-124:focus{
    --transform-translate-x: -31rem;
  }

  .\\33xl\\:focus\\:-translate-x-128:focus{
    --transform-translate-x: -32rem;
  }

  .\\33xl\\:focus\\:-translate-x-140:focus{
    --transform-translate-x: -35rem;
  }

  .\\33xl\\:focus\\:-translate-x-152:focus{
    --transform-translate-x: -38rem;
  }

  .\\33xl\\:focus\\:-translate-x-160:focus{
    --transform-translate-x: -40rem;
  }

  .\\33xl\\:focus\\:-translate-x-162:focus{
    --transform-translate-x: -41rem;
  }

  .\\33xl\\:focus\\:-translate-x-192:focus{
    --transform-translate-x: -48rem;
  }

  .\\33xl\\:focus\\:-translate-x-208:focus{
    --transform-translate-x: -52rem;
  }

  .\\33xl\\:focus\\:-translate-x-224:focus{
    --transform-translate-x: -56rem;
  }

  .\\33xl\\:focus\\:-translate-x-256:focus{
    --transform-translate-x: -64rem;
  }

  .\\33xl\\:focus\\:-translate-x-px:focus{
    --transform-translate-x: -1px;
  }

  .\\33xl\\:focus\\:-translate-x-full:focus{
    --transform-translate-x: -100%;
  }

  .\\33xl\\:focus\\:-translate-x-1\\/2:focus{
    --transform-translate-x: -50%;
  }

  .\\33xl\\:focus\\:translate-x-1\\/2:focus{
    --transform-translate-x: 50%;
  }

  .\\33xl\\:focus\\:translate-x-full:focus{
    --transform-translate-x: 100%;
  }

  .\\33xl\\:focus\\:translate-y-0:focus{
    --transform-translate-y: 0;
  }

  .\\33xl\\:focus\\:translate-y-1:focus{
    --transform-translate-y: 0.25rem;
  }

  .\\33xl\\:focus\\:translate-y-2:focus{
    --transform-translate-y: 0.5rem;
  }

  .\\33xl\\:focus\\:translate-y-3:focus{
    --transform-translate-y: 0.75rem;
  }

  .\\33xl\\:focus\\:translate-y-4:focus{
    --transform-translate-y: 1rem;
  }

  .\\33xl\\:focus\\:translate-y-5:focus{
    --transform-translate-y: 1.25rem;
  }

  .\\33xl\\:focus\\:translate-y-6:focus{
    --transform-translate-y: 1.5rem;
  }

  .\\33xl\\:focus\\:translate-y-7:focus{
    --transform-translate-y: 1.75rem;
  }

  .\\33xl\\:focus\\:translate-y-8:focus{
    --transform-translate-y: 2rem;
  }

  .\\33xl\\:focus\\:translate-y-9:focus{
    --transform-translate-y: 2.25rem;
  }

  .\\33xl\\:focus\\:translate-y-10:focus{
    --transform-translate-y: 2.5rem;
  }

  .\\33xl\\:focus\\:translate-y-11:focus{
    --transform-translate-y: 2.75rem;
  }

  .\\33xl\\:focus\\:translate-y-12:focus{
    --transform-translate-y: 3rem;
  }

  .\\33xl\\:focus\\:translate-y-14:focus{
    --transform-translate-y: 3.5rem;
  }

  .\\33xl\\:focus\\:translate-y-15:focus{
    --transform-translate-y: 3.75rem;
  }

  .\\33xl\\:focus\\:translate-y-16:focus{
    --transform-translate-y: 4rem;
  }

  .\\33xl\\:focus\\:translate-y-18:focus{
    --transform-translate-y: 4.5rem;
  }

  .\\33xl\\:focus\\:translate-y-20:focus{
    --transform-translate-y: 5rem;
  }

  .\\33xl\\:focus\\:translate-y-22:focus{
    --transform-translate-y: 5.5rem;
  }

  .\\33xl\\:focus\\:translate-y-23:focus{
    --transform-translate-y: 5.75rem;
  }

  .\\33xl\\:focus\\:translate-y-24:focus{
    --transform-translate-y: 6rem;
  }

  .\\33xl\\:focus\\:translate-y-25:focus{
    --transform-translate-y: 6.25rem;
  }

  .\\33xl\\:focus\\:translate-y-26:focus{
    --transform-translate-y: 6.5rem;
  }

  .\\33xl\\:focus\\:translate-y-28:focus{
    --transform-translate-y: 7rem;
  }

  .\\33xl\\:focus\\:translate-y-30:focus{
    --transform-translate-y: 7.5rem;
  }

  .\\33xl\\:focus\\:translate-y-32:focus{
    --transform-translate-y: 8rem;
  }

  .\\33xl\\:focus\\:translate-y-34:focus{
    --transform-translate-y: 8.5rem;
  }

  .\\33xl\\:focus\\:translate-y-40:focus{
    --transform-translate-y: 10rem;
  }

  .\\33xl\\:focus\\:translate-y-42:focus{
    --transform-translate-y: 10.5rem;
  }

  .\\33xl\\:focus\\:translate-y-44:focus{
    --transform-translate-y: 11rem;
  }

  .\\33xl\\:focus\\:translate-y-48:focus{
    --transform-translate-y: 12rem;
  }

  .\\33xl\\:focus\\:translate-y-52:focus{
    --transform-translate-y: 13rem;
  }

  .\\33xl\\:focus\\:translate-y-54:focus{
    --transform-translate-y: 13.5rem;
  }

  .\\33xl\\:focus\\:translate-y-56:focus{
    --transform-translate-y: 14rem;
  }

  .\\33xl\\:focus\\:translate-y-60:focus{
    --transform-translate-y: 15rem;
  }

  .\\33xl\\:focus\\:translate-y-64:focus{
    --transform-translate-y: 16rem;
  }

  .\\33xl\\:focus\\:translate-y-68:focus{
    --transform-translate-y: 17rem;
  }

  .\\33xl\\:focus\\:translate-y-72:focus{
    --transform-translate-y: 18rem;
  }

  .\\33xl\\:focus\\:translate-y-74:focus{
    --transform-translate-y: 18.5rem;
  }

  .\\33xl\\:focus\\:translate-y-76:focus{
    --transform-translate-y: 19rem;
  }

  .\\33xl\\:focus\\:translate-y-78:focus{
    --transform-translate-y: 19.5rem;
  }

  .\\33xl\\:focus\\:translate-y-80:focus{
    --transform-translate-y: 20rem;
  }

  .\\33xl\\:focus\\:translate-y-82:focus{
    --transform-translate-y: 20.5rem;
  }

  .\\33xl\\:focus\\:translate-y-84:focus{
    --transform-translate-y: 21rem;
  }

  .\\33xl\\:focus\\:translate-y-88:focus{
    --transform-translate-y: 22rem;
  }

  .\\33xl\\:focus\\:translate-y-92:focus{
    --transform-translate-y: 23rem;
  }

  .\\33xl\\:focus\\:translate-y-96:focus{
    --transform-translate-y: 24rem;
  }

  .\\33xl\\:focus\\:translate-y-98:focus{
    --transform-translate-y: 24.5rem;
  }

  .\\33xl\\:focus\\:translate-y-100:focus{
    --transform-translate-y: 25rem;
  }

  .\\33xl\\:focus\\:translate-y-104:focus{
    --transform-translate-y: 26rem;
  }

  .\\33xl\\:focus\\:translate-y-112:focus{
    --transform-translate-y: 28rem;
  }

  .\\33xl\\:focus\\:translate-y-124:focus{
    --transform-translate-y: 31rem;
  }

  .\\33xl\\:focus\\:translate-y-128:focus{
    --transform-translate-y: 32rem;
  }

  .\\33xl\\:focus\\:translate-y-140:focus{
    --transform-translate-y: 35rem;
  }

  .\\33xl\\:focus\\:translate-y-152:focus{
    --transform-translate-y: 38rem;
  }

  .\\33xl\\:focus\\:translate-y-160:focus{
    --transform-translate-y: 40rem;
  }

  .\\33xl\\:focus\\:translate-y-162:focus{
    --transform-translate-y: 41rem;
  }

  .\\33xl\\:focus\\:translate-y-192:focus{
    --transform-translate-y: 48rem;
  }

  .\\33xl\\:focus\\:translate-y-208:focus{
    --transform-translate-y: 52rem;
  }

  .\\33xl\\:focus\\:translate-y-224:focus{
    --transform-translate-y: 56rem;
  }

  .\\33xl\\:focus\\:translate-y-256:focus{
    --transform-translate-y: 64rem;
  }

  .\\33xl\\:focus\\:translate-y-px:focus{
    --transform-translate-y: 1px;
  }

  .\\33xl\\:focus\\:-translate-y-1:focus{
    --transform-translate-y: -0.25rem;
  }

  .\\33xl\\:focus\\:-translate-y-2:focus{
    --transform-translate-y: -0.5rem;
  }

  .\\33xl\\:focus\\:-translate-y-3:focus{
    --transform-translate-y: -0.75rem;
  }

  .\\33xl\\:focus\\:-translate-y-4:focus{
    --transform-translate-y: -1rem;
  }

  .\\33xl\\:focus\\:-translate-y-5:focus{
    --transform-translate-y: -1.25rem;
  }

  .\\33xl\\:focus\\:-translate-y-6:focus{
    --transform-translate-y: -1.5rem;
  }

  .\\33xl\\:focus\\:-translate-y-7:focus{
    --transform-translate-y: -1.75rem;
  }

  .\\33xl\\:focus\\:-translate-y-8:focus{
    --transform-translate-y: -2rem;
  }

  .\\33xl\\:focus\\:-translate-y-9:focus{
    --transform-translate-y: -2.25rem;
  }

  .\\33xl\\:focus\\:-translate-y-10:focus{
    --transform-translate-y: -2.5rem;
  }

  .\\33xl\\:focus\\:-translate-y-11:focus{
    --transform-translate-y: -2.75rem;
  }

  .\\33xl\\:focus\\:-translate-y-12:focus{
    --transform-translate-y: -3rem;
  }

  .\\33xl\\:focus\\:-translate-y-14:focus{
    --transform-translate-y: -3.5rem;
  }

  .\\33xl\\:focus\\:-translate-y-15:focus{
    --transform-translate-y: -3.75rem;
  }

  .\\33xl\\:focus\\:-translate-y-16:focus{
    --transform-translate-y: -4rem;
  }

  .\\33xl\\:focus\\:-translate-y-18:focus{
    --transform-translate-y: -4.5rem;
  }

  .\\33xl\\:focus\\:-translate-y-20:focus{
    --transform-translate-y: -5rem;
  }

  .\\33xl\\:focus\\:-translate-y-22:focus{
    --transform-translate-y: -5.5rem;
  }

  .\\33xl\\:focus\\:-translate-y-23:focus{
    --transform-translate-y: -5.75rem;
  }

  .\\33xl\\:focus\\:-translate-y-24:focus{
    --transform-translate-y: -6rem;
  }

  .\\33xl\\:focus\\:-translate-y-25:focus{
    --transform-translate-y: -6.25rem;
  }

  .\\33xl\\:focus\\:-translate-y-26:focus{
    --transform-translate-y: -6.5rem;
  }

  .\\33xl\\:focus\\:-translate-y-28:focus{
    --transform-translate-y: -7rem;
  }

  .\\33xl\\:focus\\:-translate-y-30:focus{
    --transform-translate-y: -7.5rem;
  }

  .\\33xl\\:focus\\:-translate-y-32:focus{
    --transform-translate-y: -8rem;
  }

  .\\33xl\\:focus\\:-translate-y-34:focus{
    --transform-translate-y: -8.5rem;
  }

  .\\33xl\\:focus\\:-translate-y-40:focus{
    --transform-translate-y: -10rem;
  }

  .\\33xl\\:focus\\:-translate-y-42:focus{
    --transform-translate-y: -10.5rem;
  }

  .\\33xl\\:focus\\:-translate-y-44:focus{
    --transform-translate-y: -11rem;
  }

  .\\33xl\\:focus\\:-translate-y-48:focus{
    --transform-translate-y: -12rem;
  }

  .\\33xl\\:focus\\:-translate-y-52:focus{
    --transform-translate-y: -13rem;
  }

  .\\33xl\\:focus\\:-translate-y-54:focus{
    --transform-translate-y: -13.5rem;
  }

  .\\33xl\\:focus\\:-translate-y-56:focus{
    --transform-translate-y: -14rem;
  }

  .\\33xl\\:focus\\:-translate-y-60:focus{
    --transform-translate-y: -15rem;
  }

  .\\33xl\\:focus\\:-translate-y-64:focus{
    --transform-translate-y: -16rem;
  }

  .\\33xl\\:focus\\:-translate-y-68:focus{
    --transform-translate-y: -17rem;
  }

  .\\33xl\\:focus\\:-translate-y-72:focus{
    --transform-translate-y: -18rem;
  }

  .\\33xl\\:focus\\:-translate-y-74:focus{
    --transform-translate-y: -18.5rem;
  }

  .\\33xl\\:focus\\:-translate-y-76:focus{
    --transform-translate-y: -19rem;
  }

  .\\33xl\\:focus\\:-translate-y-78:focus{
    --transform-translate-y: -19.5rem;
  }

  .\\33xl\\:focus\\:-translate-y-80:focus{
    --transform-translate-y: -20rem;
  }

  .\\33xl\\:focus\\:-translate-y-82:focus{
    --transform-translate-y: -20.5rem;
  }

  .\\33xl\\:focus\\:-translate-y-84:focus{
    --transform-translate-y: -21rem;
  }

  .\\33xl\\:focus\\:-translate-y-88:focus{
    --transform-translate-y: -22rem;
  }

  .\\33xl\\:focus\\:-translate-y-92:focus{
    --transform-translate-y: -23rem;
  }

  .\\33xl\\:focus\\:-translate-y-96:focus{
    --transform-translate-y: -24rem;
  }

  .\\33xl\\:focus\\:-translate-y-98:focus{
    --transform-translate-y: -24.5rem;
  }

  .\\33xl\\:focus\\:-translate-y-100:focus{
    --transform-translate-y: -25rem;
  }

  .\\33xl\\:focus\\:-translate-y-104:focus{
    --transform-translate-y: -26rem;
  }

  .\\33xl\\:focus\\:-translate-y-112:focus{
    --transform-translate-y: -28rem;
  }

  .\\33xl\\:focus\\:-translate-y-124:focus{
    --transform-translate-y: -31rem;
  }

  .\\33xl\\:focus\\:-translate-y-128:focus{
    --transform-translate-y: -32rem;
  }

  .\\33xl\\:focus\\:-translate-y-140:focus{
    --transform-translate-y: -35rem;
  }

  .\\33xl\\:focus\\:-translate-y-152:focus{
    --transform-translate-y: -38rem;
  }

  .\\33xl\\:focus\\:-translate-y-160:focus{
    --transform-translate-y: -40rem;
  }

  .\\33xl\\:focus\\:-translate-y-162:focus{
    --transform-translate-y: -41rem;
  }

  .\\33xl\\:focus\\:-translate-y-192:focus{
    --transform-translate-y: -48rem;
  }

  .\\33xl\\:focus\\:-translate-y-208:focus{
    --transform-translate-y: -52rem;
  }

  .\\33xl\\:focus\\:-translate-y-224:focus{
    --transform-translate-y: -56rem;
  }

  .\\33xl\\:focus\\:-translate-y-256:focus{
    --transform-translate-y: -64rem;
  }

  .\\33xl\\:focus\\:-translate-y-px:focus{
    --transform-translate-y: -1px;
  }

  .\\33xl\\:focus\\:-translate-y-full:focus{
    --transform-translate-y: -100%;
  }

  .\\33xl\\:focus\\:-translate-y-1\\/2:focus{
    --transform-translate-y: -50%;
  }

  .\\33xl\\:focus\\:translate-y-1\\/2:focus{
    --transform-translate-y: 50%;
  }

  .\\33xl\\:focus\\:translate-y-full:focus{
    --transform-translate-y: 100%;
  }

  .\\33xl\\:skew-x-0{
    --transform-skew-x: 0;
  }

  .\\33xl\\:skew-x-1{
    --transform-skew-x: 1deg;
  }

  .\\33xl\\:skew-x-2{
    --transform-skew-x: 2deg;
  }

  .\\33xl\\:skew-x-3{
    --transform-skew-x: 3deg;
  }

  .\\33xl\\:skew-x-6{
    --transform-skew-x: 6deg;
  }

  .\\33xl\\:skew-x-12{
    --transform-skew-x: 12deg;
  }

  .\\33xl\\:-skew-x-12{
    --transform-skew-x: -12deg;
  }

  .\\33xl\\:-skew-x-6{
    --transform-skew-x: -6deg;
  }

  .\\33xl\\:-skew-x-3{
    --transform-skew-x: -3deg;
  }

  .\\33xl\\:-skew-x-2{
    --transform-skew-x: -2deg;
  }

  .\\33xl\\:-skew-x-1{
    --transform-skew-x: -1deg;
  }

  .\\33xl\\:skew-y-0{
    --transform-skew-y: 0;
  }

  .\\33xl\\:skew-y-1{
    --transform-skew-y: 1deg;
  }

  .\\33xl\\:skew-y-2{
    --transform-skew-y: 2deg;
  }

  .\\33xl\\:skew-y-3{
    --transform-skew-y: 3deg;
  }

  .\\33xl\\:skew-y-6{
    --transform-skew-y: 6deg;
  }

  .\\33xl\\:skew-y-12{
    --transform-skew-y: 12deg;
  }

  .\\33xl\\:-skew-y-12{
    --transform-skew-y: -12deg;
  }

  .\\33xl\\:-skew-y-6{
    --transform-skew-y: -6deg;
  }

  .\\33xl\\:-skew-y-3{
    --transform-skew-y: -3deg;
  }

  .\\33xl\\:-skew-y-2{
    --transform-skew-y: -2deg;
  }

  .\\33xl\\:-skew-y-1{
    --transform-skew-y: -1deg;
  }

  .\\33xl\\:hover\\:skew-x-0:hover{
    --transform-skew-x: 0;
  }

  .\\33xl\\:hover\\:skew-x-1:hover{
    --transform-skew-x: 1deg;
  }

  .\\33xl\\:hover\\:skew-x-2:hover{
    --transform-skew-x: 2deg;
  }

  .\\33xl\\:hover\\:skew-x-3:hover{
    --transform-skew-x: 3deg;
  }

  .\\33xl\\:hover\\:skew-x-6:hover{
    --transform-skew-x: 6deg;
  }

  .\\33xl\\:hover\\:skew-x-12:hover{
    --transform-skew-x: 12deg;
  }

  .\\33xl\\:hover\\:-skew-x-12:hover{
    --transform-skew-x: -12deg;
  }

  .\\33xl\\:hover\\:-skew-x-6:hover{
    --transform-skew-x: -6deg;
  }

  .\\33xl\\:hover\\:-skew-x-3:hover{
    --transform-skew-x: -3deg;
  }

  .\\33xl\\:hover\\:-skew-x-2:hover{
    --transform-skew-x: -2deg;
  }

  .\\33xl\\:hover\\:-skew-x-1:hover{
    --transform-skew-x: -1deg;
  }

  .\\33xl\\:hover\\:skew-y-0:hover{
    --transform-skew-y: 0;
  }

  .\\33xl\\:hover\\:skew-y-1:hover{
    --transform-skew-y: 1deg;
  }

  .\\33xl\\:hover\\:skew-y-2:hover{
    --transform-skew-y: 2deg;
  }

  .\\33xl\\:hover\\:skew-y-3:hover{
    --transform-skew-y: 3deg;
  }

  .\\33xl\\:hover\\:skew-y-6:hover{
    --transform-skew-y: 6deg;
  }

  .\\33xl\\:hover\\:skew-y-12:hover{
    --transform-skew-y: 12deg;
  }

  .\\33xl\\:hover\\:-skew-y-12:hover{
    --transform-skew-y: -12deg;
  }

  .\\33xl\\:hover\\:-skew-y-6:hover{
    --transform-skew-y: -6deg;
  }

  .\\33xl\\:hover\\:-skew-y-3:hover{
    --transform-skew-y: -3deg;
  }

  .\\33xl\\:hover\\:-skew-y-2:hover{
    --transform-skew-y: -2deg;
  }

  .\\33xl\\:hover\\:-skew-y-1:hover{
    --transform-skew-y: -1deg;
  }

  .\\33xl\\:focus\\:skew-x-0:focus{
    --transform-skew-x: 0;
  }

  .\\33xl\\:focus\\:skew-x-1:focus{
    --transform-skew-x: 1deg;
  }

  .\\33xl\\:focus\\:skew-x-2:focus{
    --transform-skew-x: 2deg;
  }

  .\\33xl\\:focus\\:skew-x-3:focus{
    --transform-skew-x: 3deg;
  }

  .\\33xl\\:focus\\:skew-x-6:focus{
    --transform-skew-x: 6deg;
  }

  .\\33xl\\:focus\\:skew-x-12:focus{
    --transform-skew-x: 12deg;
  }

  .\\33xl\\:focus\\:-skew-x-12:focus{
    --transform-skew-x: -12deg;
  }

  .\\33xl\\:focus\\:-skew-x-6:focus{
    --transform-skew-x: -6deg;
  }

  .\\33xl\\:focus\\:-skew-x-3:focus{
    --transform-skew-x: -3deg;
  }

  .\\33xl\\:focus\\:-skew-x-2:focus{
    --transform-skew-x: -2deg;
  }

  .\\33xl\\:focus\\:-skew-x-1:focus{
    --transform-skew-x: -1deg;
  }

  .\\33xl\\:focus\\:skew-y-0:focus{
    --transform-skew-y: 0;
  }

  .\\33xl\\:focus\\:skew-y-1:focus{
    --transform-skew-y: 1deg;
  }

  .\\33xl\\:focus\\:skew-y-2:focus{
    --transform-skew-y: 2deg;
  }

  .\\33xl\\:focus\\:skew-y-3:focus{
    --transform-skew-y: 3deg;
  }

  .\\33xl\\:focus\\:skew-y-6:focus{
    --transform-skew-y: 6deg;
  }

  .\\33xl\\:focus\\:skew-y-12:focus{
    --transform-skew-y: 12deg;
  }

  .\\33xl\\:focus\\:-skew-y-12:focus{
    --transform-skew-y: -12deg;
  }

  .\\33xl\\:focus\\:-skew-y-6:focus{
    --transform-skew-y: -6deg;
  }

  .\\33xl\\:focus\\:-skew-y-3:focus{
    --transform-skew-y: -3deg;
  }

  .\\33xl\\:focus\\:-skew-y-2:focus{
    --transform-skew-y: -2deg;
  }

  .\\33xl\\:focus\\:-skew-y-1:focus{
    --transform-skew-y: -1deg;
  }

  .\\33xl\\:transition-none{
    transition-property: none;
  }

  .\\33xl\\:transition-all{
    transition-property: all;
  }

  .\\33xl\\:transition{
    transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform;
  }

  .\\33xl\\:transition-colors{
    transition-property: background-color, border-color, color, fill, stroke;
  }

  .\\33xl\\:transition-opacity{
    transition-property: opacity;
  }

  .\\33xl\\:transition-shadow{
    transition-property: box-shadow;
  }

  .\\33xl\\:transition-transform{
    transition-property: transform;
  }

  .\\33xl\\:ease-linear{
    transition-timing-function: linear;
  }

  .\\33xl\\:ease-in{
    transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
  }

  .\\33xl\\:ease-out{
    transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }

  .\\33xl\\:ease-in-out{
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  }

  .\\33xl\\:duration-75{
    transition-duration: 75ms;
  }

  .\\33xl\\:duration-100{
    transition-duration: 100ms;
  }

  .\\33xl\\:duration-150{
    transition-duration: 150ms;
  }

  .\\33xl\\:duration-200{
    transition-duration: 200ms;
  }

  .\\33xl\\:duration-300{
    transition-duration: 300ms;
  }

  .\\33xl\\:duration-500{
    transition-duration: 500ms;
  }

  .\\33xl\\:duration-700{
    transition-duration: 700ms;
  }

  .\\33xl\\:duration-1000{
    transition-duration: 1000ms;
  }

  .\\33xl\\:delay-75{
    transition-delay: 75ms;
  }

  .\\33xl\\:delay-100{
    transition-delay: 100ms;
  }

  .\\33xl\\:delay-150{
    transition-delay: 150ms;
  }

  .\\33xl\\:delay-200{
    transition-delay: 200ms;
  }

  .\\33xl\\:delay-300{
    transition-delay: 300ms;
  }

  .\\33xl\\:delay-500{
    transition-delay: 500ms;
  }

  .\\33xl\\:delay-700{
    transition-delay: 700ms;
  }

  .\\33xl\\:delay-1000{
    transition-delay: 1000ms;
  }

  .\\33xl\\:animate-none{
    animation: none;
  }

  .\\33xl\\:animate-spin{
    animation: spin 1s linear infinite;
  }

  .\\33xl\\:animate-ping{
    animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
  }

  .\\33xl\\:animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  .\\33xl\\:animate-bounce{
    animation: bounce 1s infinite;
  }

  [dir="ltr"] .\\33xl\\:ps-0{
    padding-left: 0;
  }

  [dir="rtl"] .\\33xl\\:ps-0{
    padding-right: 0;
  }

  [dir="ltr"] .\\33xl\\:pe-0{
    padding-right: 0;
  }

  [dir="rtl"] .\\33xl\\:pe-0{
    padding-left: 0;
  }

  [dir="ltr"] .\\33xl\\:ps-1{
    padding-left: 0.25rem;
  }

  [dir="rtl"] .\\33xl\\:ps-1{
    padding-right: 0.25rem;
  }

  [dir="ltr"] .\\33xl\\:pe-1{
    padding-right: 0.25rem;
  }

  [dir="rtl"] .\\33xl\\:pe-1{
    padding-left: 0.25rem;
  }

  [dir="ltr"] .\\33xl\\:ps-2{
    padding-left: 0.5rem;
  }

  [dir="rtl"] .\\33xl\\:ps-2{
    padding-right: 0.5rem;
  }

  [dir="ltr"] .\\33xl\\:pe-2{
    padding-right: 0.5rem;
  }

  [dir="rtl"] .\\33xl\\:pe-2{
    padding-left: 0.5rem;
  }

  [dir="ltr"] .\\33xl\\:ps-3{
    padding-left: 0.75rem;
  }

  [dir="rtl"] .\\33xl\\:ps-3{
    padding-right: 0.75rem;
  }

  [dir="ltr"] .\\33xl\\:pe-3{
    padding-right: 0.75rem;
  }

  [dir="rtl"] .\\33xl\\:pe-3{
    padding-left: 0.75rem;
  }

  [dir="ltr"] .\\33xl\\:ps-4{
    padding-left: 1rem;
  }

  [dir="rtl"] .\\33xl\\:ps-4{
    padding-right: 1rem;
  }

  [dir="ltr"] .\\33xl\\:pe-4{
    padding-right: 1rem;
  }

  [dir="rtl"] .\\33xl\\:pe-4{
    padding-left: 1rem;
  }

  [dir="ltr"] .\\33xl\\:ps-5{
    padding-left: 1.25rem;
  }

  [dir="rtl"] .\\33xl\\:ps-5{
    padding-right: 1.25rem;
  }

  [dir="ltr"] .\\33xl\\:pe-5{
    padding-right: 1.25rem;
  }

  [dir="rtl"] .\\33xl\\:pe-5{
    padding-left: 1.25rem;
  }

  [dir="ltr"] .\\33xl\\:ps-6{
    padding-left: 1.5rem;
  }

  [dir="rtl"] .\\33xl\\:ps-6{
    padding-right: 1.5rem;
  }

  [dir="ltr"] .\\33xl\\:pe-6{
    padding-right: 1.5rem;
  }

  [dir="rtl"] .\\33xl\\:pe-6{
    padding-left: 1.5rem;
  }

  [dir="ltr"] .\\33xl\\:ps-7{
    padding-left: 1.75rem;
  }

  [dir="rtl"] .\\33xl\\:ps-7{
    padding-right: 1.75rem;
  }

  [dir="ltr"] .\\33xl\\:pe-7{
    padding-right: 1.75rem;
  }

  [dir="rtl"] .\\33xl\\:pe-7{
    padding-left: 1.75rem;
  }

  [dir="ltr"] .\\33xl\\:ps-8{
    padding-left: 2rem;
  }

  [dir="rtl"] .\\33xl\\:ps-8{
    padding-right: 2rem;
  }

  [dir="ltr"] .\\33xl\\:pe-8{
    padding-right: 2rem;
  }

  [dir="rtl"] .\\33xl\\:pe-8{
    padding-left: 2rem;
  }

  [dir="ltr"] .\\33xl\\:ps-9{
    padding-left: 2.25rem;
  }

  [dir="rtl"] .\\33xl\\:ps-9{
    padding-right: 2.25rem;
  }

  [dir="ltr"] .\\33xl\\:pe-9{
    padding-right: 2.25rem;
  }

  [dir="rtl"] .\\33xl\\:pe-9{
    padding-left: 2.25rem;
  }

  [dir="ltr"] .\\33xl\\:ps-10{
    padding-left: 2.5rem;
  }

  [dir="rtl"] .\\33xl\\:ps-10{
    padding-right: 2.5rem;
  }

  [dir="ltr"] .\\33xl\\:pe-10{
    padding-right: 2.5rem;
  }

  [dir="rtl"] .\\33xl\\:pe-10{
    padding-left: 2.5rem;
  }

  [dir="ltr"] .\\33xl\\:ps-11{
    padding-left: 2.75rem;
  }

  [dir="rtl"] .\\33xl\\:ps-11{
    padding-right: 2.75rem;
  }

  [dir="ltr"] .\\33xl\\:pe-11{
    padding-right: 2.75rem;
  }

  [dir="rtl"] .\\33xl\\:pe-11{
    padding-left: 2.75rem;
  }

  [dir="ltr"] .\\33xl\\:ps-12{
    padding-left: 3rem;
  }

  [dir="rtl"] .\\33xl\\:ps-12{
    padding-right: 3rem;
  }

  [dir="ltr"] .\\33xl\\:pe-12{
    padding-right: 3rem;
  }

  [dir="rtl"] .\\33xl\\:pe-12{
    padding-left: 3rem;
  }

  [dir="ltr"] .\\33xl\\:ps-14{
    padding-left: 3.5rem;
  }

  [dir="rtl"] .\\33xl\\:ps-14{
    padding-right: 3.5rem;
  }

  [dir="ltr"] .\\33xl\\:pe-14{
    padding-right: 3.5rem;
  }

  [dir="rtl"] .\\33xl\\:pe-14{
    padding-left: 3.5rem;
  }

  [dir="ltr"] .\\33xl\\:ps-15{
    padding-left: 3.75rem;
  }

  [dir="rtl"] .\\33xl\\:ps-15{
    padding-right: 3.75rem;
  }

  [dir="ltr"] .\\33xl\\:pe-15{
    padding-right: 3.75rem;
  }

  [dir="rtl"] .\\33xl\\:pe-15{
    padding-left: 3.75rem;
  }

  [dir="ltr"] .\\33xl\\:ps-16{
    padding-left: 4rem;
  }

  [dir="rtl"] .\\33xl\\:ps-16{
    padding-right: 4rem;
  }

  [dir="ltr"] .\\33xl\\:pe-16{
    padding-right: 4rem;
  }

  [dir="rtl"] .\\33xl\\:pe-16{
    padding-left: 4rem;
  }

  [dir="ltr"] .\\33xl\\:ps-18{
    padding-left: 4.5rem;
  }

  [dir="rtl"] .\\33xl\\:ps-18{
    padding-right: 4.5rem;
  }

  [dir="ltr"] .\\33xl\\:pe-18{
    padding-right: 4.5rem;
  }

  [dir="rtl"] .\\33xl\\:pe-18{
    padding-left: 4.5rem;
  }

  [dir="ltr"] .\\33xl\\:ps-20{
    padding-left: 5rem;
  }

  [dir="rtl"] .\\33xl\\:ps-20{
    padding-right: 5rem;
  }

  [dir="ltr"] .\\33xl\\:pe-20{
    padding-right: 5rem;
  }

  [dir="rtl"] .\\33xl\\:pe-20{
    padding-left: 5rem;
  }

  [dir="ltr"] .\\33xl\\:ps-22{
    padding-left: 5.5rem;
  }

  [dir="rtl"] .\\33xl\\:ps-22{
    padding-right: 5.5rem;
  }

  [dir="ltr"] .\\33xl\\:pe-22{
    padding-right: 5.5rem;
  }

  [dir="rtl"] .\\33xl\\:pe-22{
    padding-left: 5.5rem;
  }

  [dir="ltr"] .\\33xl\\:ps-23{
    padding-left: 5.75rem;
  }

  [dir="rtl"] .\\33xl\\:ps-23{
    padding-right: 5.75rem;
  }

  [dir="ltr"] .\\33xl\\:pe-23{
    padding-right: 5.75rem;
  }

  [dir="rtl"] .\\33xl\\:pe-23{
    padding-left: 5.75rem;
  }

  [dir="ltr"] .\\33xl\\:ps-24{
    padding-left: 6rem;
  }

  [dir="rtl"] .\\33xl\\:ps-24{
    padding-right: 6rem;
  }

  [dir="ltr"] .\\33xl\\:pe-24{
    padding-right: 6rem;
  }

  [dir="rtl"] .\\33xl\\:pe-24{
    padding-left: 6rem;
  }

  [dir="ltr"] .\\33xl\\:ps-25{
    padding-left: 6.25rem;
  }

  [dir="rtl"] .\\33xl\\:ps-25{
    padding-right: 6.25rem;
  }

  [dir="ltr"] .\\33xl\\:pe-25{
    padding-right: 6.25rem;
  }

  [dir="rtl"] .\\33xl\\:pe-25{
    padding-left: 6.25rem;
  }

  [dir="ltr"] .\\33xl\\:ps-26{
    padding-left: 6.5rem;
  }

  [dir="rtl"] .\\33xl\\:ps-26{
    padding-right: 6.5rem;
  }

  [dir="ltr"] .\\33xl\\:pe-26{
    padding-right: 6.5rem;
  }

  [dir="rtl"] .\\33xl\\:pe-26{
    padding-left: 6.5rem;
  }

  [dir="ltr"] .\\33xl\\:ps-28{
    padding-left: 7rem;
  }

  [dir="rtl"] .\\33xl\\:ps-28{
    padding-right: 7rem;
  }

  [dir="ltr"] .\\33xl\\:pe-28{
    padding-right: 7rem;
  }

  [dir="rtl"] .\\33xl\\:pe-28{
    padding-left: 7rem;
  }

  [dir="ltr"] .\\33xl\\:ps-30{
    padding-left: 7.5rem;
  }

  [dir="rtl"] .\\33xl\\:ps-30{
    padding-right: 7.5rem;
  }

  [dir="ltr"] .\\33xl\\:pe-30{
    padding-right: 7.5rem;
  }

  [dir="rtl"] .\\33xl\\:pe-30{
    padding-left: 7.5rem;
  }

  [dir="ltr"] .\\33xl\\:ps-32{
    padding-left: 8rem;
  }

  [dir="rtl"] .\\33xl\\:ps-32{
    padding-right: 8rem;
  }

  [dir="ltr"] .\\33xl\\:pe-32{
    padding-right: 8rem;
  }

  [dir="rtl"] .\\33xl\\:pe-32{
    padding-left: 8rem;
  }

  [dir="ltr"] .\\33xl\\:ps-34{
    padding-left: 8.5rem;
  }

  [dir="rtl"] .\\33xl\\:ps-34{
    padding-right: 8.5rem;
  }

  [dir="ltr"] .\\33xl\\:pe-34{
    padding-right: 8.5rem;
  }

  [dir="rtl"] .\\33xl\\:pe-34{
    padding-left: 8.5rem;
  }

  [dir="ltr"] .\\33xl\\:ps-40{
    padding-left: 10rem;
  }

  [dir="rtl"] .\\33xl\\:ps-40{
    padding-right: 10rem;
  }

  [dir="ltr"] .\\33xl\\:pe-40{
    padding-right: 10rem;
  }

  [dir="rtl"] .\\33xl\\:pe-40{
    padding-left: 10rem;
  }

  [dir="ltr"] .\\33xl\\:ps-42{
    padding-left: 10.5rem;
  }

  [dir="rtl"] .\\33xl\\:ps-42{
    padding-right: 10.5rem;
  }

  [dir="ltr"] .\\33xl\\:pe-42{
    padding-right: 10.5rem;
  }

  [dir="rtl"] .\\33xl\\:pe-42{
    padding-left: 10.5rem;
  }

  [dir="ltr"] .\\33xl\\:ps-44{
    padding-left: 11rem;
  }

  [dir="rtl"] .\\33xl\\:ps-44{
    padding-right: 11rem;
  }

  [dir="ltr"] .\\33xl\\:pe-44{
    padding-right: 11rem;
  }

  [dir="rtl"] .\\33xl\\:pe-44{
    padding-left: 11rem;
  }

  [dir="ltr"] .\\33xl\\:ps-48{
    padding-left: 12rem;
  }

  [dir="rtl"] .\\33xl\\:ps-48{
    padding-right: 12rem;
  }

  [dir="ltr"] .\\33xl\\:pe-48{
    padding-right: 12rem;
  }

  [dir="rtl"] .\\33xl\\:pe-48{
    padding-left: 12rem;
  }

  [dir="ltr"] .\\33xl\\:ps-52{
    padding-left: 13rem;
  }

  [dir="rtl"] .\\33xl\\:ps-52{
    padding-right: 13rem;
  }

  [dir="ltr"] .\\33xl\\:pe-52{
    padding-right: 13rem;
  }

  [dir="rtl"] .\\33xl\\:pe-52{
    padding-left: 13rem;
  }

  [dir="ltr"] .\\33xl\\:ps-54{
    padding-left: 13.5rem;
  }

  [dir="rtl"] .\\33xl\\:ps-54{
    padding-right: 13.5rem;
  }

  [dir="ltr"] .\\33xl\\:pe-54{
    padding-right: 13.5rem;
  }

  [dir="rtl"] .\\33xl\\:pe-54{
    padding-left: 13.5rem;
  }

  [dir="ltr"] .\\33xl\\:ps-56{
    padding-left: 14rem;
  }

  [dir="rtl"] .\\33xl\\:ps-56{
    padding-right: 14rem;
  }

  [dir="ltr"] .\\33xl\\:pe-56{
    padding-right: 14rem;
  }

  [dir="rtl"] .\\33xl\\:pe-56{
    padding-left: 14rem;
  }

  [dir="ltr"] .\\33xl\\:ps-60{
    padding-left: 15rem;
  }

  [dir="rtl"] .\\33xl\\:ps-60{
    padding-right: 15rem;
  }

  [dir="ltr"] .\\33xl\\:pe-60{
    padding-right: 15rem;
  }

  [dir="rtl"] .\\33xl\\:pe-60{
    padding-left: 15rem;
  }

  [dir="ltr"] .\\33xl\\:ps-64{
    padding-left: 16rem;
  }

  [dir="rtl"] .\\33xl\\:ps-64{
    padding-right: 16rem;
  }

  [dir="ltr"] .\\33xl\\:pe-64{
    padding-right: 16rem;
  }

  [dir="rtl"] .\\33xl\\:pe-64{
    padding-left: 16rem;
  }

  [dir="ltr"] .\\33xl\\:ps-68{
    padding-left: 17rem;
  }

  [dir="rtl"] .\\33xl\\:ps-68{
    padding-right: 17rem;
  }

  [dir="ltr"] .\\33xl\\:pe-68{
    padding-right: 17rem;
  }

  [dir="rtl"] .\\33xl\\:pe-68{
    padding-left: 17rem;
  }

  [dir="ltr"] .\\33xl\\:ps-72{
    padding-left: 18rem;
  }

  [dir="rtl"] .\\33xl\\:ps-72{
    padding-right: 18rem;
  }

  [dir="ltr"] .\\33xl\\:pe-72{
    padding-right: 18rem;
  }

  [dir="rtl"] .\\33xl\\:pe-72{
    padding-left: 18rem;
  }

  [dir="ltr"] .\\33xl\\:ps-74{
    padding-left: 18.5rem;
  }

  [dir="rtl"] .\\33xl\\:ps-74{
    padding-right: 18.5rem;
  }

  [dir="ltr"] .\\33xl\\:pe-74{
    padding-right: 18.5rem;
  }

  [dir="rtl"] .\\33xl\\:pe-74{
    padding-left: 18.5rem;
  }

  [dir="ltr"] .\\33xl\\:ps-76{
    padding-left: 19rem;
  }

  [dir="rtl"] .\\33xl\\:ps-76{
    padding-right: 19rem;
  }

  [dir="ltr"] .\\33xl\\:pe-76{
    padding-right: 19rem;
  }

  [dir="rtl"] .\\33xl\\:pe-76{
    padding-left: 19rem;
  }

  [dir="ltr"] .\\33xl\\:ps-78{
    padding-left: 19.5rem;
  }

  [dir="rtl"] .\\33xl\\:ps-78{
    padding-right: 19.5rem;
  }

  [dir="ltr"] .\\33xl\\:pe-78{
    padding-right: 19.5rem;
  }

  [dir="rtl"] .\\33xl\\:pe-78{
    padding-left: 19.5rem;
  }

  [dir="ltr"] .\\33xl\\:ps-80{
    padding-left: 20rem;
  }

  [dir="rtl"] .\\33xl\\:ps-80{
    padding-right: 20rem;
  }

  [dir="ltr"] .\\33xl\\:pe-80{
    padding-right: 20rem;
  }

  [dir="rtl"] .\\33xl\\:pe-80{
    padding-left: 20rem;
  }

  [dir="ltr"] .\\33xl\\:ps-82{
    padding-left: 20.5rem;
  }

  [dir="rtl"] .\\33xl\\:ps-82{
    padding-right: 20.5rem;
  }

  [dir="ltr"] .\\33xl\\:pe-82{
    padding-right: 20.5rem;
  }

  [dir="rtl"] .\\33xl\\:pe-82{
    padding-left: 20.5rem;
  }

  [dir="ltr"] .\\33xl\\:ps-84{
    padding-left: 21rem;
  }

  [dir="rtl"] .\\33xl\\:ps-84{
    padding-right: 21rem;
  }

  [dir="ltr"] .\\33xl\\:pe-84{
    padding-right: 21rem;
  }

  [dir="rtl"] .\\33xl\\:pe-84{
    padding-left: 21rem;
  }

  [dir="ltr"] .\\33xl\\:ps-88{
    padding-left: 22rem;
  }

  [dir="rtl"] .\\33xl\\:ps-88{
    padding-right: 22rem;
  }

  [dir="ltr"] .\\33xl\\:pe-88{
    padding-right: 22rem;
  }

  [dir="rtl"] .\\33xl\\:pe-88{
    padding-left: 22rem;
  }

  [dir="ltr"] .\\33xl\\:ps-92{
    padding-left: 23rem;
  }

  [dir="rtl"] .\\33xl\\:ps-92{
    padding-right: 23rem;
  }

  [dir="ltr"] .\\33xl\\:pe-92{
    padding-right: 23rem;
  }

  [dir="rtl"] .\\33xl\\:pe-92{
    padding-left: 23rem;
  }

  [dir="ltr"] .\\33xl\\:ps-96{
    padding-left: 24rem;
  }

  [dir="rtl"] .\\33xl\\:ps-96{
    padding-right: 24rem;
  }

  [dir="ltr"] .\\33xl\\:pe-96{
    padding-right: 24rem;
  }

  [dir="rtl"] .\\33xl\\:pe-96{
    padding-left: 24rem;
  }

  [dir="ltr"] .\\33xl\\:ps-98{
    padding-left: 24.5rem;
  }

  [dir="rtl"] .\\33xl\\:ps-98{
    padding-right: 24.5rem;
  }

  [dir="ltr"] .\\33xl\\:pe-98{
    padding-right: 24.5rem;
  }

  [dir="rtl"] .\\33xl\\:pe-98{
    padding-left: 24.5rem;
  }

  [dir="ltr"] .\\33xl\\:ps-100{
    padding-left: 25rem;
  }

  [dir="rtl"] .\\33xl\\:ps-100{
    padding-right: 25rem;
  }

  [dir="ltr"] .\\33xl\\:pe-100{
    padding-right: 25rem;
  }

  [dir="rtl"] .\\33xl\\:pe-100{
    padding-left: 25rem;
  }

  [dir="ltr"] .\\33xl\\:ps-104{
    padding-left: 26rem;
  }

  [dir="rtl"] .\\33xl\\:ps-104{
    padding-right: 26rem;
  }

  [dir="ltr"] .\\33xl\\:pe-104{
    padding-right: 26rem;
  }

  [dir="rtl"] .\\33xl\\:pe-104{
    padding-left: 26rem;
  }

  [dir="ltr"] .\\33xl\\:ps-112{
    padding-left: 28rem;
  }

  [dir="rtl"] .\\33xl\\:ps-112{
    padding-right: 28rem;
  }

  [dir="ltr"] .\\33xl\\:pe-112{
    padding-right: 28rem;
  }

  [dir="rtl"] .\\33xl\\:pe-112{
    padding-left: 28rem;
  }

  [dir="ltr"] .\\33xl\\:ps-124{
    padding-left: 31rem;
  }

  [dir="rtl"] .\\33xl\\:ps-124{
    padding-right: 31rem;
  }

  [dir="ltr"] .\\33xl\\:pe-124{
    padding-right: 31rem;
  }

  [dir="rtl"] .\\33xl\\:pe-124{
    padding-left: 31rem;
  }

  [dir="ltr"] .\\33xl\\:ps-128{
    padding-left: 32rem;
  }

  [dir="rtl"] .\\33xl\\:ps-128{
    padding-right: 32rem;
  }

  [dir="ltr"] .\\33xl\\:pe-128{
    padding-right: 32rem;
  }

  [dir="rtl"] .\\33xl\\:pe-128{
    padding-left: 32rem;
  }

  [dir="ltr"] .\\33xl\\:ps-140{
    padding-left: 35rem;
  }

  [dir="rtl"] .\\33xl\\:ps-140{
    padding-right: 35rem;
  }

  [dir="ltr"] .\\33xl\\:pe-140{
    padding-right: 35rem;
  }

  [dir="rtl"] .\\33xl\\:pe-140{
    padding-left: 35rem;
  }

  [dir="ltr"] .\\33xl\\:ps-152{
    padding-left: 38rem;
  }

  [dir="rtl"] .\\33xl\\:ps-152{
    padding-right: 38rem;
  }

  [dir="ltr"] .\\33xl\\:pe-152{
    padding-right: 38rem;
  }

  [dir="rtl"] .\\33xl\\:pe-152{
    padding-left: 38rem;
  }

  [dir="ltr"] .\\33xl\\:ps-160{
    padding-left: 40rem;
  }

  [dir="rtl"] .\\33xl\\:ps-160{
    padding-right: 40rem;
  }

  [dir="ltr"] .\\33xl\\:pe-160{
    padding-right: 40rem;
  }

  [dir="rtl"] .\\33xl\\:pe-160{
    padding-left: 40rem;
  }

  [dir="ltr"] .\\33xl\\:ps-162{
    padding-left: 41rem;
  }

  [dir="rtl"] .\\33xl\\:ps-162{
    padding-right: 41rem;
  }

  [dir="ltr"] .\\33xl\\:pe-162{
    padding-right: 41rem;
  }

  [dir="rtl"] .\\33xl\\:pe-162{
    padding-left: 41rem;
  }

  [dir="ltr"] .\\33xl\\:ps-192{
    padding-left: 48rem;
  }

  [dir="rtl"] .\\33xl\\:ps-192{
    padding-right: 48rem;
  }

  [dir="ltr"] .\\33xl\\:pe-192{
    padding-right: 48rem;
  }

  [dir="rtl"] .\\33xl\\:pe-192{
    padding-left: 48rem;
  }

  [dir="ltr"] .\\33xl\\:ps-208{
    padding-left: 52rem;
  }

  [dir="rtl"] .\\33xl\\:ps-208{
    padding-right: 52rem;
  }

  [dir="ltr"] .\\33xl\\:pe-208{
    padding-right: 52rem;
  }

  [dir="rtl"] .\\33xl\\:pe-208{
    padding-left: 52rem;
  }

  [dir="ltr"] .\\33xl\\:ps-224{
    padding-left: 56rem;
  }

  [dir="rtl"] .\\33xl\\:ps-224{
    padding-right: 56rem;
  }

  [dir="ltr"] .\\33xl\\:pe-224{
    padding-right: 56rem;
  }

  [dir="rtl"] .\\33xl\\:pe-224{
    padding-left: 56rem;
  }

  [dir="ltr"] .\\33xl\\:ps-256{
    padding-left: 64rem;
  }

  [dir="rtl"] .\\33xl\\:ps-256{
    padding-right: 64rem;
  }

  [dir="ltr"] .\\33xl\\:pe-256{
    padding-right: 64rem;
  }

  [dir="rtl"] .\\33xl\\:pe-256{
    padding-left: 64rem;
  }

  [dir="ltr"] .\\33xl\\:ps-px{
    padding-left: 1px;
  }

  [dir="rtl"] .\\33xl\\:ps-px{
    padding-right: 1px;
  }

  [dir="ltr"] .\\33xl\\:pe-px{
    padding-right: 1px;
  }

  [dir="rtl"] .\\33xl\\:pe-px{
    padding-left: 1px;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-0:nth-child(odd){
    padding-left: 0;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-0:nth-child(odd){
    padding-right: 0;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-0:nth-child(odd){
    padding-right: 0;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-0:nth-child(odd){
    padding-left: 0;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-1:nth-child(odd){
    padding-right: 0.25rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-1:nth-child(odd){
    padding-left: 0.25rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-2:nth-child(odd){
    padding-right: 0.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-2:nth-child(odd){
    padding-left: 0.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-3:nth-child(odd){
    padding-right: 0.75rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-3:nth-child(odd){
    padding-left: 0.75rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-4:nth-child(odd){
    padding-left: 1rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-4:nth-child(odd){
    padding-right: 1rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-4:nth-child(odd){
    padding-right: 1rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-4:nth-child(odd){
    padding-left: 1rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-5:nth-child(odd){
    padding-right: 1.25rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-5:nth-child(odd){
    padding-left: 1.25rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-6:nth-child(odd){
    padding-right: 1.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-6:nth-child(odd){
    padding-left: 1.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-7:nth-child(odd){
    padding-right: 1.75rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-7:nth-child(odd){
    padding-left: 1.75rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-8:nth-child(odd){
    padding-left: 2rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-8:nth-child(odd){
    padding-right: 2rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-8:nth-child(odd){
    padding-right: 2rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-8:nth-child(odd){
    padding-left: 2rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-9:nth-child(odd){
    padding-right: 2.25rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-9:nth-child(odd){
    padding-left: 2.25rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-10:nth-child(odd){
    padding-right: 2.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-10:nth-child(odd){
    padding-left: 2.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-11:nth-child(odd){
    padding-right: 2.75rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-11:nth-child(odd){
    padding-left: 2.75rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-12:nth-child(odd){
    padding-left: 3rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-12:nth-child(odd){
    padding-right: 3rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-12:nth-child(odd){
    padding-right: 3rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-12:nth-child(odd){
    padding-left: 3rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-14:nth-child(odd){
    padding-right: 3.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-14:nth-child(odd){
    padding-left: 3.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-15:nth-child(odd){
    padding-right: 3.75rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-15:nth-child(odd){
    padding-left: 3.75rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-16:nth-child(odd){
    padding-left: 4rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-16:nth-child(odd){
    padding-right: 4rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-16:nth-child(odd){
    padding-right: 4rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-16:nth-child(odd){
    padding-left: 4rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-18:nth-child(odd){
    padding-right: 4.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-18:nth-child(odd){
    padding-left: 4.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-20:nth-child(odd){
    padding-left: 5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-20:nth-child(odd){
    padding-right: 5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-20:nth-child(odd){
    padding-right: 5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-20:nth-child(odd){
    padding-left: 5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-22:nth-child(odd){
    padding-right: 5.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-22:nth-child(odd){
    padding-left: 5.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-23:nth-child(odd){
    padding-right: 5.75rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-23:nth-child(odd){
    padding-left: 5.75rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-24:nth-child(odd){
    padding-left: 6rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-24:nth-child(odd){
    padding-right: 6rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-24:nth-child(odd){
    padding-right: 6rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-24:nth-child(odd){
    padding-left: 6rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-25:nth-child(odd){
    padding-right: 6.25rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-25:nth-child(odd){
    padding-left: 6.25rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-26:nth-child(odd){
    padding-right: 6.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-26:nth-child(odd){
    padding-left: 6.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-28:nth-child(odd){
    padding-left: 7rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-28:nth-child(odd){
    padding-right: 7rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-28:nth-child(odd){
    padding-right: 7rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-28:nth-child(odd){
    padding-left: 7rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-30:nth-child(odd){
    padding-right: 7.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-30:nth-child(odd){
    padding-left: 7.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-32:nth-child(odd){
    padding-left: 8rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-32:nth-child(odd){
    padding-right: 8rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-32:nth-child(odd){
    padding-right: 8rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-32:nth-child(odd){
    padding-left: 8rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-34:nth-child(odd){
    padding-right: 8.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-34:nth-child(odd){
    padding-left: 8.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-40:nth-child(odd){
    padding-left: 10rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-40:nth-child(odd){
    padding-right: 10rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-40:nth-child(odd){
    padding-right: 10rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-40:nth-child(odd){
    padding-left: 10rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-42:nth-child(odd){
    padding-right: 10.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-42:nth-child(odd){
    padding-left: 10.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-44:nth-child(odd){
    padding-left: 11rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-44:nth-child(odd){
    padding-right: 11rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-44:nth-child(odd){
    padding-right: 11rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-44:nth-child(odd){
    padding-left: 11rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-48:nth-child(odd){
    padding-left: 12rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-48:nth-child(odd){
    padding-right: 12rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-48:nth-child(odd){
    padding-right: 12rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-48:nth-child(odd){
    padding-left: 12rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-52:nth-child(odd){
    padding-left: 13rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-52:nth-child(odd){
    padding-right: 13rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-52:nth-child(odd){
    padding-right: 13rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-52:nth-child(odd){
    padding-left: 13rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-54:nth-child(odd){
    padding-right: 13.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-54:nth-child(odd){
    padding-left: 13.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-56:nth-child(odd){
    padding-left: 14rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-56:nth-child(odd){
    padding-right: 14rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-56:nth-child(odd){
    padding-right: 14rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-56:nth-child(odd){
    padding-left: 14rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-60:nth-child(odd){
    padding-left: 15rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-60:nth-child(odd){
    padding-right: 15rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-60:nth-child(odd){
    padding-right: 15rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-60:nth-child(odd){
    padding-left: 15rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-64:nth-child(odd){
    padding-left: 16rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-64:nth-child(odd){
    padding-right: 16rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-64:nth-child(odd){
    padding-right: 16rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-64:nth-child(odd){
    padding-left: 16rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-68:nth-child(odd){
    padding-left: 17rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-68:nth-child(odd){
    padding-right: 17rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-68:nth-child(odd){
    padding-right: 17rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-68:nth-child(odd){
    padding-left: 17rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-72:nth-child(odd){
    padding-left: 18rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-72:nth-child(odd){
    padding-right: 18rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-72:nth-child(odd){
    padding-right: 18rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-72:nth-child(odd){
    padding-left: 18rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-74:nth-child(odd){
    padding-right: 18.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-74:nth-child(odd){
    padding-left: 18.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-76:nth-child(odd){
    padding-left: 19rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-76:nth-child(odd){
    padding-right: 19rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-76:nth-child(odd){
    padding-right: 19rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-76:nth-child(odd){
    padding-left: 19rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-78:nth-child(odd){
    padding-right: 19.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-78:nth-child(odd){
    padding-left: 19.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-80:nth-child(odd){
    padding-left: 20rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-80:nth-child(odd){
    padding-right: 20rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-80:nth-child(odd){
    padding-right: 20rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-80:nth-child(odd){
    padding-left: 20rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-82:nth-child(odd){
    padding-right: 20.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-82:nth-child(odd){
    padding-left: 20.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-84:nth-child(odd){
    padding-left: 21rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-84:nth-child(odd){
    padding-right: 21rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-84:nth-child(odd){
    padding-right: 21rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-84:nth-child(odd){
    padding-left: 21rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-88:nth-child(odd){
    padding-left: 22rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-88:nth-child(odd){
    padding-right: 22rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-88:nth-child(odd){
    padding-right: 22rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-88:nth-child(odd){
    padding-left: 22rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-92:nth-child(odd){
    padding-left: 23rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-92:nth-child(odd){
    padding-right: 23rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-92:nth-child(odd){
    padding-right: 23rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-92:nth-child(odd){
    padding-left: 23rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-96:nth-child(odd){
    padding-left: 24rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-96:nth-child(odd){
    padding-right: 24rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-96:nth-child(odd){
    padding-right: 24rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-96:nth-child(odd){
    padding-left: 24rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-98:nth-child(odd){
    padding-right: 24.5rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-98:nth-child(odd){
    padding-left: 24.5rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-100:nth-child(odd){
    padding-left: 25rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-100:nth-child(odd){
    padding-right: 25rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-100:nth-child(odd){
    padding-right: 25rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-100:nth-child(odd){
    padding-left: 25rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-104:nth-child(odd){
    padding-left: 26rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-104:nth-child(odd){
    padding-right: 26rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-104:nth-child(odd){
    padding-right: 26rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-104:nth-child(odd){
    padding-left: 26rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-112:nth-child(odd){
    padding-left: 28rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-112:nth-child(odd){
    padding-right: 28rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-112:nth-child(odd){
    padding-right: 28rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-112:nth-child(odd){
    padding-left: 28rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-124:nth-child(odd){
    padding-left: 31rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-124:nth-child(odd){
    padding-right: 31rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-124:nth-child(odd){
    padding-right: 31rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-124:nth-child(odd){
    padding-left: 31rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-128:nth-child(odd){
    padding-left: 32rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-128:nth-child(odd){
    padding-right: 32rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-128:nth-child(odd){
    padding-right: 32rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-128:nth-child(odd){
    padding-left: 32rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-140:nth-child(odd){
    padding-left: 35rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-140:nth-child(odd){
    padding-right: 35rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-140:nth-child(odd){
    padding-right: 35rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-140:nth-child(odd){
    padding-left: 35rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-152:nth-child(odd){
    padding-left: 38rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-152:nth-child(odd){
    padding-right: 38rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-152:nth-child(odd){
    padding-right: 38rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-152:nth-child(odd){
    padding-left: 38rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-160:nth-child(odd){
    padding-left: 40rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-160:nth-child(odd){
    padding-right: 40rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-160:nth-child(odd){
    padding-right: 40rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-160:nth-child(odd){
    padding-left: 40rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-162:nth-child(odd){
    padding-left: 41rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-162:nth-child(odd){
    padding-right: 41rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-162:nth-child(odd){
    padding-right: 41rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-162:nth-child(odd){
    padding-left: 41rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-192:nth-child(odd){
    padding-left: 48rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-192:nth-child(odd){
    padding-right: 48rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-192:nth-child(odd){
    padding-right: 48rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-192:nth-child(odd){
    padding-left: 48rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-208:nth-child(odd){
    padding-left: 52rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-208:nth-child(odd){
    padding-right: 52rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-208:nth-child(odd){
    padding-right: 52rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-208:nth-child(odd){
    padding-left: 52rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-224:nth-child(odd){
    padding-left: 56rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-224:nth-child(odd){
    padding-right: 56rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-224:nth-child(odd){
    padding-right: 56rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-224:nth-child(odd){
    padding-left: 56rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-256:nth-child(odd){
    padding-left: 64rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-256:nth-child(odd){
    padding-right: 64rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-256:nth-child(odd){
    padding-right: 64rem;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-256:nth-child(odd){
    padding-left: 64rem;
  }

  [dir="ltr"] .\\33xl\\:odd\\:ps-px:nth-child(odd){
    padding-left: 1px;
  }

  [dir="rtl"] .\\33xl\\:odd\\:ps-px:nth-child(odd){
    padding-right: 1px;
  }

  [dir="ltr"] .\\33xl\\:odd\\:pe-px:nth-child(odd){
    padding-right: 1px;
  }

  [dir="rtl"] .\\33xl\\:odd\\:pe-px:nth-child(odd){
    padding-left: 1px;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-0:nth-child(even){
    padding-left: 0;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-0:nth-child(even){
    padding-right: 0;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-0:nth-child(even){
    padding-right: 0;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-0:nth-child(even){
    padding-left: 0;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-1:nth-child(even){
    padding-left: 0.25rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-1:nth-child(even){
    padding-right: 0.25rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-1:nth-child(even){
    padding-right: 0.25rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-1:nth-child(even){
    padding-left: 0.25rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-2:nth-child(even){
    padding-left: 0.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-2:nth-child(even){
    padding-right: 0.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-2:nth-child(even){
    padding-right: 0.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-2:nth-child(even){
    padding-left: 0.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-3:nth-child(even){
    padding-left: 0.75rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-3:nth-child(even){
    padding-right: 0.75rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-3:nth-child(even){
    padding-right: 0.75rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-3:nth-child(even){
    padding-left: 0.75rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-4:nth-child(even){
    padding-left: 1rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-4:nth-child(even){
    padding-right: 1rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-4:nth-child(even){
    padding-right: 1rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-4:nth-child(even){
    padding-left: 1rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-5:nth-child(even){
    padding-left: 1.25rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-5:nth-child(even){
    padding-right: 1.25rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-5:nth-child(even){
    padding-right: 1.25rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-5:nth-child(even){
    padding-left: 1.25rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-6:nth-child(even){
    padding-left: 1.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-6:nth-child(even){
    padding-right: 1.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-6:nth-child(even){
    padding-right: 1.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-6:nth-child(even){
    padding-left: 1.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-7:nth-child(even){
    padding-left: 1.75rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-7:nth-child(even){
    padding-right: 1.75rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-7:nth-child(even){
    padding-right: 1.75rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-7:nth-child(even){
    padding-left: 1.75rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-8:nth-child(even){
    padding-left: 2rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-8:nth-child(even){
    padding-right: 2rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-8:nth-child(even){
    padding-right: 2rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-8:nth-child(even){
    padding-left: 2rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-9:nth-child(even){
    padding-left: 2.25rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-9:nth-child(even){
    padding-right: 2.25rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-9:nth-child(even){
    padding-right: 2.25rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-9:nth-child(even){
    padding-left: 2.25rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-10:nth-child(even){
    padding-left: 2.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-10:nth-child(even){
    padding-right: 2.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-10:nth-child(even){
    padding-right: 2.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-10:nth-child(even){
    padding-left: 2.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-11:nth-child(even){
    padding-left: 2.75rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-11:nth-child(even){
    padding-right: 2.75rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-11:nth-child(even){
    padding-right: 2.75rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-11:nth-child(even){
    padding-left: 2.75rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-12:nth-child(even){
    padding-left: 3rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-12:nth-child(even){
    padding-right: 3rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-12:nth-child(even){
    padding-right: 3rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-12:nth-child(even){
    padding-left: 3rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-14:nth-child(even){
    padding-left: 3.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-14:nth-child(even){
    padding-right: 3.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-14:nth-child(even){
    padding-right: 3.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-14:nth-child(even){
    padding-left: 3.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-15:nth-child(even){
    padding-left: 3.75rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-15:nth-child(even){
    padding-right: 3.75rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-15:nth-child(even){
    padding-right: 3.75rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-15:nth-child(even){
    padding-left: 3.75rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-16:nth-child(even){
    padding-left: 4rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-16:nth-child(even){
    padding-right: 4rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-16:nth-child(even){
    padding-right: 4rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-16:nth-child(even){
    padding-left: 4rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-18:nth-child(even){
    padding-left: 4.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-18:nth-child(even){
    padding-right: 4.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-18:nth-child(even){
    padding-right: 4.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-18:nth-child(even){
    padding-left: 4.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-20:nth-child(even){
    padding-left: 5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-20:nth-child(even){
    padding-right: 5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-20:nth-child(even){
    padding-right: 5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-20:nth-child(even){
    padding-left: 5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-22:nth-child(even){
    padding-left: 5.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-22:nth-child(even){
    padding-right: 5.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-22:nth-child(even){
    padding-right: 5.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-22:nth-child(even){
    padding-left: 5.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-23:nth-child(even){
    padding-left: 5.75rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-23:nth-child(even){
    padding-right: 5.75rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-23:nth-child(even){
    padding-right: 5.75rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-23:nth-child(even){
    padding-left: 5.75rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-24:nth-child(even){
    padding-left: 6rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-24:nth-child(even){
    padding-right: 6rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-24:nth-child(even){
    padding-right: 6rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-24:nth-child(even){
    padding-left: 6rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-25:nth-child(even){
    padding-left: 6.25rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-25:nth-child(even){
    padding-right: 6.25rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-25:nth-child(even){
    padding-right: 6.25rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-25:nth-child(even){
    padding-left: 6.25rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-26:nth-child(even){
    padding-left: 6.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-26:nth-child(even){
    padding-right: 6.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-26:nth-child(even){
    padding-right: 6.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-26:nth-child(even){
    padding-left: 6.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-28:nth-child(even){
    padding-left: 7rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-28:nth-child(even){
    padding-right: 7rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-28:nth-child(even){
    padding-right: 7rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-28:nth-child(even){
    padding-left: 7rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-30:nth-child(even){
    padding-left: 7.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-30:nth-child(even){
    padding-right: 7.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-30:nth-child(even){
    padding-right: 7.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-30:nth-child(even){
    padding-left: 7.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-32:nth-child(even){
    padding-left: 8rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-32:nth-child(even){
    padding-right: 8rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-32:nth-child(even){
    padding-right: 8rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-32:nth-child(even){
    padding-left: 8rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-34:nth-child(even){
    padding-left: 8.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-34:nth-child(even){
    padding-right: 8.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-34:nth-child(even){
    padding-right: 8.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-34:nth-child(even){
    padding-left: 8.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-40:nth-child(even){
    padding-left: 10rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-40:nth-child(even){
    padding-right: 10rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-40:nth-child(even){
    padding-right: 10rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-40:nth-child(even){
    padding-left: 10rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-42:nth-child(even){
    padding-left: 10.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-42:nth-child(even){
    padding-right: 10.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-42:nth-child(even){
    padding-right: 10.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-42:nth-child(even){
    padding-left: 10.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-44:nth-child(even){
    padding-left: 11rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-44:nth-child(even){
    padding-right: 11rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-44:nth-child(even){
    padding-right: 11rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-44:nth-child(even){
    padding-left: 11rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-48:nth-child(even){
    padding-left: 12rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-48:nth-child(even){
    padding-right: 12rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-48:nth-child(even){
    padding-right: 12rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-48:nth-child(even){
    padding-left: 12rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-52:nth-child(even){
    padding-left: 13rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-52:nth-child(even){
    padding-right: 13rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-52:nth-child(even){
    padding-right: 13rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-52:nth-child(even){
    padding-left: 13rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-54:nth-child(even){
    padding-left: 13.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-54:nth-child(even){
    padding-right: 13.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-54:nth-child(even){
    padding-right: 13.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-54:nth-child(even){
    padding-left: 13.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-56:nth-child(even){
    padding-left: 14rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-56:nth-child(even){
    padding-right: 14rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-56:nth-child(even){
    padding-right: 14rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-56:nth-child(even){
    padding-left: 14rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-60:nth-child(even){
    padding-left: 15rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-60:nth-child(even){
    padding-right: 15rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-60:nth-child(even){
    padding-right: 15rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-60:nth-child(even){
    padding-left: 15rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-64:nth-child(even){
    padding-left: 16rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-64:nth-child(even){
    padding-right: 16rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-64:nth-child(even){
    padding-right: 16rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-64:nth-child(even){
    padding-left: 16rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-68:nth-child(even){
    padding-left: 17rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-68:nth-child(even){
    padding-right: 17rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-68:nth-child(even){
    padding-right: 17rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-68:nth-child(even){
    padding-left: 17rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-72:nth-child(even){
    padding-left: 18rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-72:nth-child(even){
    padding-right: 18rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-72:nth-child(even){
    padding-right: 18rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-72:nth-child(even){
    padding-left: 18rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-74:nth-child(even){
    padding-left: 18.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-74:nth-child(even){
    padding-right: 18.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-74:nth-child(even){
    padding-right: 18.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-74:nth-child(even){
    padding-left: 18.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-76:nth-child(even){
    padding-left: 19rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-76:nth-child(even){
    padding-right: 19rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-76:nth-child(even){
    padding-right: 19rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-76:nth-child(even){
    padding-left: 19rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-78:nth-child(even){
    padding-left: 19.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-78:nth-child(even){
    padding-right: 19.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-78:nth-child(even){
    padding-right: 19.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-78:nth-child(even){
    padding-left: 19.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-80:nth-child(even){
    padding-left: 20rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-80:nth-child(even){
    padding-right: 20rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-80:nth-child(even){
    padding-right: 20rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-80:nth-child(even){
    padding-left: 20rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-82:nth-child(even){
    padding-left: 20.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-82:nth-child(even){
    padding-right: 20.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-82:nth-child(even){
    padding-right: 20.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-82:nth-child(even){
    padding-left: 20.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-84:nth-child(even){
    padding-left: 21rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-84:nth-child(even){
    padding-right: 21rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-84:nth-child(even){
    padding-right: 21rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-84:nth-child(even){
    padding-left: 21rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-88:nth-child(even){
    padding-left: 22rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-88:nth-child(even){
    padding-right: 22rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-88:nth-child(even){
    padding-right: 22rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-88:nth-child(even){
    padding-left: 22rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-92:nth-child(even){
    padding-left: 23rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-92:nth-child(even){
    padding-right: 23rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-92:nth-child(even){
    padding-right: 23rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-92:nth-child(even){
    padding-left: 23rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-96:nth-child(even){
    padding-left: 24rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-96:nth-child(even){
    padding-right: 24rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-96:nth-child(even){
    padding-right: 24rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-96:nth-child(even){
    padding-left: 24rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-98:nth-child(even){
    padding-left: 24.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-98:nth-child(even){
    padding-right: 24.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-98:nth-child(even){
    padding-right: 24.5rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-98:nth-child(even){
    padding-left: 24.5rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-100:nth-child(even){
    padding-left: 25rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-100:nth-child(even){
    padding-right: 25rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-100:nth-child(even){
    padding-right: 25rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-100:nth-child(even){
    padding-left: 25rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-104:nth-child(even){
    padding-left: 26rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-104:nth-child(even){
    padding-right: 26rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-104:nth-child(even){
    padding-right: 26rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-104:nth-child(even){
    padding-left: 26rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-112:nth-child(even){
    padding-left: 28rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-112:nth-child(even){
    padding-right: 28rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-112:nth-child(even){
    padding-right: 28rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-112:nth-child(even){
    padding-left: 28rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-124:nth-child(even){
    padding-left: 31rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-124:nth-child(even){
    padding-right: 31rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-124:nth-child(even){
    padding-right: 31rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-124:nth-child(even){
    padding-left: 31rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-128:nth-child(even){
    padding-left: 32rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-128:nth-child(even){
    padding-right: 32rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-128:nth-child(even){
    padding-right: 32rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-128:nth-child(even){
    padding-left: 32rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-140:nth-child(even){
    padding-left: 35rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-140:nth-child(even){
    padding-right: 35rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-140:nth-child(even){
    padding-right: 35rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-140:nth-child(even){
    padding-left: 35rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-152:nth-child(even){
    padding-left: 38rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-152:nth-child(even){
    padding-right: 38rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-152:nth-child(even){
    padding-right: 38rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-152:nth-child(even){
    padding-left: 38rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-160:nth-child(even){
    padding-left: 40rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-160:nth-child(even){
    padding-right: 40rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-160:nth-child(even){
    padding-right: 40rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-160:nth-child(even){
    padding-left: 40rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-162:nth-child(even){
    padding-left: 41rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-162:nth-child(even){
    padding-right: 41rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-162:nth-child(even){
    padding-right: 41rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-162:nth-child(even){
    padding-left: 41rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-192:nth-child(even){
    padding-left: 48rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-192:nth-child(even){
    padding-right: 48rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-192:nth-child(even){
    padding-right: 48rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-192:nth-child(even){
    padding-left: 48rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-208:nth-child(even){
    padding-left: 52rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-208:nth-child(even){
    padding-right: 52rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-208:nth-child(even){
    padding-right: 52rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-208:nth-child(even){
    padding-left: 52rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-224:nth-child(even){
    padding-left: 56rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-224:nth-child(even){
    padding-right: 56rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-224:nth-child(even){
    padding-right: 56rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-224:nth-child(even){
    padding-left: 56rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-256:nth-child(even){
    padding-left: 64rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-256:nth-child(even){
    padding-right: 64rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-256:nth-child(even){
    padding-right: 64rem;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-256:nth-child(even){
    padding-left: 64rem;
  }

  [dir="ltr"] .\\33xl\\:even\\:ps-px:nth-child(even){
    padding-left: 1px;
  }

  [dir="rtl"] .\\33xl\\:even\\:ps-px:nth-child(even){
    padding-right: 1px;
  }

  [dir="ltr"] .\\33xl\\:even\\:pe-px:nth-child(even){
    padding-right: 1px;
  }

  [dir="rtl"] .\\33xl\\:even\\:pe-px:nth-child(even){
    padding-left: 1px;
  }

  [dir="ltr"] .\\33xl\\:ms-0{
    margin-left: 0;
  }

  [dir="rtl"] .\\33xl\\:ms-0{
    margin-right: 0;
  }

  [dir="ltr"] .\\33xl\\:me-0{
    margin-right: 0;
  }

  [dir="rtl"] .\\33xl\\:me-0{
    margin-left: 0;
  }

  [dir="ltr"] .\\33xl\\:ms-1{
    margin-left: 0.25rem;
  }

  [dir="rtl"] .\\33xl\\:ms-1{
    margin-right: 0.25rem;
  }

  [dir="ltr"] .\\33xl\\:me-1{
    margin-right: 0.25rem;
  }

  [dir="rtl"] .\\33xl\\:me-1{
    margin-left: 0.25rem;
  }

  [dir="ltr"] .\\33xl\\:ms-2{
    margin-left: 0.5rem;
  }

  [dir="rtl"] .\\33xl\\:ms-2{
    margin-right: 0.5rem;
  }

  [dir="ltr"] .\\33xl\\:me-2{
    margin-right: 0.5rem;
  }

  [dir="rtl"] .\\33xl\\:me-2{
    margin-left: 0.5rem;
  }

  [dir="ltr"] .\\33xl\\:ms-3{
    margin-left: 0.75rem;
  }

  [dir="rtl"] .\\33xl\\:ms-3{
    margin-right: 0.75rem;
  }

  [dir="ltr"] .\\33xl\\:me-3{
    margin-right: 0.75rem;
  }

  [dir="rtl"] .\\33xl\\:me-3{
    margin-left: 0.75rem;
  }

  [dir="ltr"] .\\33xl\\:ms-4{
    margin-left: 1rem;
  }

  [dir="rtl"] .\\33xl\\:ms-4{
    margin-right: 1rem;
  }

  [dir="ltr"] .\\33xl\\:me-4{
    margin-right: 1rem;
  }

  [dir="rtl"] .\\33xl\\:me-4{
    margin-left: 1rem;
  }

  [dir="ltr"] .\\33xl\\:ms-5{
    margin-left: 1.25rem;
  }

  [dir="rtl"] .\\33xl\\:ms-5{
    margin-right: 1.25rem;
  }

  [dir="ltr"] .\\33xl\\:me-5{
    margin-right: 1.25rem;
  }

  [dir="rtl"] .\\33xl\\:me-5{
    margin-left: 1.25rem;
  }

  [dir="ltr"] .\\33xl\\:ms-6{
    margin-left: 1.5rem;
  }

  [dir="rtl"] .\\33xl\\:ms-6{
    margin-right: 1.5rem;
  }

  [dir="ltr"] .\\33xl\\:me-6{
    margin-right: 1.5rem;
  }

  [dir="rtl"] .\\33xl\\:me-6{
    margin-left: 1.5rem;
  }

  [dir="ltr"] .\\33xl\\:ms-7{
    margin-left: 1.75rem;
  }

  [dir="rtl"] .\\33xl\\:ms-7{
    margin-right: 1.75rem;
  }

  [dir="ltr"] .\\33xl\\:me-7{
    margin-right: 1.75rem;
  }

  [dir="rtl"] .\\33xl\\:me-7{
    margin-left: 1.75rem;
  }

  [dir="ltr"] .\\33xl\\:ms-8{
    margin-left: 2rem;
  }

  [dir="rtl"] .\\33xl\\:ms-8{
    margin-right: 2rem;
  }

  [dir="ltr"] .\\33xl\\:me-8{
    margin-right: 2rem;
  }

  [dir="rtl"] .\\33xl\\:me-8{
    margin-left: 2rem;
  }

  [dir="ltr"] .\\33xl\\:ms-9{
    margin-left: 2.25rem;
  }

  [dir="rtl"] .\\33xl\\:ms-9{
    margin-right: 2.25rem;
  }

  [dir="ltr"] .\\33xl\\:me-9{
    margin-right: 2.25rem;
  }

  [dir="rtl"] .\\33xl\\:me-9{
    margin-left: 2.25rem;
  }

  [dir="ltr"] .\\33xl\\:ms-10{
    margin-left: 2.5rem;
  }

  [dir="rtl"] .\\33xl\\:ms-10{
    margin-right: 2.5rem;
  }

  [dir="ltr"] .\\33xl\\:me-10{
    margin-right: 2.5rem;
  }

  [dir="rtl"] .\\33xl\\:me-10{
    margin-left: 2.5rem;
  }

  [dir="ltr"] .\\33xl\\:ms-11{
    margin-left: 2.75rem;
  }

  [dir="rtl"] .\\33xl\\:ms-11{
    margin-right: 2.75rem;
  }

  [dir="ltr"] .\\33xl\\:me-11{
    margin-right: 2.75rem;
  }

  [dir="rtl"] .\\33xl\\:me-11{
    margin-left: 2.75rem;
  }

  [dir="ltr"] .\\33xl\\:ms-12{
    margin-left: 3rem;
  }

  [dir="rtl"] .\\33xl\\:ms-12{
    margin-right: 3rem;
  }

  [dir="ltr"] .\\33xl\\:me-12{
    margin-right: 3rem;
  }

  [dir="rtl"] .\\33xl\\:me-12{
    margin-left: 3rem;
  }

  [dir="ltr"] .\\33xl\\:ms-14{
    margin-left: 3.5rem;
  }

  [dir="rtl"] .\\33xl\\:ms-14{
    margin-right: 3.5rem;
  }

  [dir="ltr"] .\\33xl\\:me-14{
    margin-right: 3.5rem;
  }

  [dir="rtl"] .\\33xl\\:me-14{
    margin-left: 3.5rem;
  }

  [dir="ltr"] .\\33xl\\:ms-15{
    margin-left: 3.75rem;
  }

  [dir="rtl"] .\\33xl\\:ms-15{
    margin-right: 3.75rem;
  }

  [dir="ltr"] .\\33xl\\:me-15{
    margin-right: 3.75rem;
  }

  [dir="rtl"] .\\33xl\\:me-15{
    margin-left: 3.75rem;
  }

  [dir="ltr"] .\\33xl\\:ms-16{
    margin-left: 4rem;
  }

  [dir="rtl"] .\\33xl\\:ms-16{
    margin-right: 4rem;
  }

  [dir="ltr"] .\\33xl\\:me-16{
    margin-right: 4rem;
  }

  [dir="rtl"] .\\33xl\\:me-16{
    margin-left: 4rem;
  }

  [dir="ltr"] .\\33xl\\:ms-18{
    margin-left: 4.5rem;
  }

  [dir="rtl"] .\\33xl\\:ms-18{
    margin-right: 4.5rem;
  }

  [dir="ltr"] .\\33xl\\:me-18{
    margin-right: 4.5rem;
  }

  [dir="rtl"] .\\33xl\\:me-18{
    margin-left: 4.5rem;
  }

  [dir="ltr"] .\\33xl\\:ms-20{
    margin-left: 5rem;
  }

  [dir="rtl"] .\\33xl\\:ms-20{
    margin-right: 5rem;
  }

  [dir="ltr"] .\\33xl\\:me-20{
    margin-right: 5rem;
  }

  [dir="rtl"] .\\33xl\\:me-20{
    margin-left: 5rem;
  }

  [dir="ltr"] .\\33xl\\:ms-22{
    margin-left: 5.5rem;
  }

  [dir="rtl"] .\\33xl\\:ms-22{
    margin-right: 5.5rem;
  }

  [dir="ltr"] .\\33xl\\:me-22{
    margin-right: 5.5rem;
  }

  [dir="rtl"] .\\33xl\\:me-22{
    margin-left: 5.5rem;
  }

  [dir="ltr"] .\\33xl\\:ms-23{
    margin-left: 5.75rem;
  }

  [dir="rtl"] .\\33xl\\:ms-23{
    margin-right: 5.75rem;
  }

  [dir="ltr"] .\\33xl\\:me-23{
    margin-right: 5.75rem;
  }

  [dir="rtl"] .\\33xl\\:me-23{
    margin-left: 5.75rem;
  }

  [dir="ltr"] .\\33xl\\:ms-24{
    margin-left: 6rem;
  }

  [dir="rtl"] .\\33xl\\:ms-24{
    margin-right: 6rem;
  }

  [dir="ltr"] .\\33xl\\:me-24{
    margin-right: 6rem;
  }

  [dir="rtl"] .\\33xl\\:me-24{
    margin-left: 6rem;
  }

  [dir="ltr"] .\\33xl\\:ms-25{
    margin-left: 6.25rem;
  }

  [dir="rtl"] .\\33xl\\:ms-25{
    margin-right: 6.25rem;
  }

  [dir="ltr"] .\\33xl\\:me-25{
    margin-right: 6.25rem;
  }

  [dir="rtl"] .\\33xl\\:me-25{
    margin-left: 6.25rem;
  }

  [dir="ltr"] .\\33xl\\:ms-26{
    margin-left: 6.5rem;
  }

  [dir="rtl"] .\\33xl\\:ms-26{
    margin-right: 6.5rem;
  }

  [dir="ltr"] .\\33xl\\:me-26{
    margin-right: 6.5rem;
  }

  [dir="rtl"] .\\33xl\\:me-26{
    margin-left: 6.5rem;
  }

  [dir="ltr"] .\\33xl\\:ms-28{
    margin-left: 7rem;
  }

  [dir="rtl"] .\\33xl\\:ms-28{
    margin-right: 7rem;
  }

  [dir="ltr"] .\\33xl\\:me-28{
    margin-right: 7rem;
  }

  [dir="rtl"] .\\33xl\\:me-28{
    margin-left: 7rem;
  }

  [dir="ltr"] .\\33xl\\:ms-30{
    margin-left: 7.5rem;
  }

  [dir="rtl"] .\\33xl\\:ms-30{
    margin-right: 7.5rem;
  }

  [dir="ltr"] .\\33xl\\:me-30{
    margin-right: 7.5rem;
  }

  [dir="rtl"] .\\33xl\\:me-30{
    margin-left: 7.5rem;
  }

  [dir="ltr"] .\\33xl\\:ms-32{
    margin-left: 8rem;
  }

  [dir="rtl"] .\\33xl\\:ms-32{
    margin-right: 8rem;
  }

  [dir="ltr"] .\\33xl\\:me-32{
    margin-right: 8rem;
  }

  [dir="rtl"] .\\33xl\\:me-32{
    margin-left: 8rem;
  }

  [dir="ltr"] .\\33xl\\:ms-34{
    margin-left: 8.5rem;
  }

  [dir="rtl"] .\\33xl\\:ms-34{
    margin-right: 8.5rem;
  }

  [dir="ltr"] .\\33xl\\:me-34{
    margin-right: 8.5rem;
  }

  [dir="rtl"] .\\33xl\\:me-34{
    margin-left: 8.5rem;
  }

  [dir="ltr"] .\\33xl\\:ms-40{
    margin-left: 10rem;
  }

  [dir="rtl"] .\\33xl\\:ms-40{
    margin-right: 10rem;
  }

  [dir="ltr"] .\\33xl\\:me-40{
    margin-right: 10rem;
  }

  [dir="rtl"] .\\33xl\\:me-40{
    margin-left: 10rem;
  }

  [dir="ltr"] .\\33xl\\:ms-42{
    margin-left: 10.5rem;
  }

  [dir="rtl"] .\\33xl\\:ms-42{
    margin-right: 10.5rem;
  }

  [dir="ltr"] .\\33xl\\:me-42{
    margin-right: 10.5rem;
  }

  [dir="rtl"] .\\33xl\\:me-42{
    margin-left: 10.5rem;
  }

  [dir="ltr"] .\\33xl\\:ms-44{
    margin-left: 11rem;
  }

  [dir="rtl"] .\\33xl\\:ms-44{
    margin-right: 11rem;
  }

  [dir="ltr"] .\\33xl\\:me-44{
    margin-right: 11rem;
  }

  [dir="rtl"] .\\33xl\\:me-44{
    margin-left: 11rem;
  }

  [dir="ltr"] .\\33xl\\:ms-48{
    margin-left: 12rem;
  }

  [dir="rtl"] .\\33xl\\:ms-48{
    margin-right: 12rem;
  }

  [dir="ltr"] .\\33xl\\:me-48{
    margin-right: 12rem;
  }

  [dir="rtl"] .\\33xl\\:me-48{
    margin-left: 12rem;
  }

  [dir="ltr"] .\\33xl\\:ms-52{
    margin-left: 13rem;
  }

  [dir="rtl"] .\\33xl\\:ms-52{
    margin-right: 13rem;
  }

  [dir="ltr"] .\\33xl\\:me-52{
    margin-right: 13rem;
  }

  [dir="rtl"] .\\33xl\\:me-52{
    margin-left: 13rem;
  }

  [dir="ltr"] .\\33xl\\:ms-54{
    margin-left: 13.5rem;
  }

  [dir="rtl"] .\\33xl\\:ms-54{
    margin-right: 13.5rem;
  }

  [dir="ltr"] .\\33xl\\:me-54{
    margin-right: 13.5rem;
  }

  [dir="rtl"] .\\33xl\\:me-54{
    margin-left: 13.5rem;
  }

  [dir="ltr"] .\\33xl\\:ms-56{
    margin-left: 14rem;
  }

  [dir="rtl"] .\\33xl\\:ms-56{
    margin-right: 14rem;
  }

  [dir="ltr"] .\\33xl\\:me-56{
    margin-right: 14rem;
  }

  [dir="rtl"] .\\33xl\\:me-56{
    margin-left: 14rem;
  }

  [dir="ltr"] .\\33xl\\:ms-60{
    margin-left: 15rem;
  }

  [dir="rtl"] .\\33xl\\:ms-60{
    margin-right: 15rem;
  }

  [dir="ltr"] .\\33xl\\:me-60{
    margin-right: 15rem;
  }

  [dir="rtl"] .\\33xl\\:me-60{
    margin-left: 15rem;
  }

  [dir="ltr"] .\\33xl\\:ms-64{
    margin-left: 16rem;
  }

  [dir="rtl"] .\\33xl\\:ms-64{
    margin-right: 16rem;
  }

  [dir="ltr"] .\\33xl\\:me-64{
    margin-right: 16rem;
  }

  [dir="rtl"] .\\33xl\\:me-64{
    margin-left: 16rem;
  }

  [dir="ltr"] .\\33xl\\:ms-68{
    margin-left: 17rem;
  }

  [dir="rtl"] .\\33xl\\:ms-68{
    margin-right: 17rem;
  }

  [dir="ltr"] .\\33xl\\:me-68{
    margin-right: 17rem;
  }

  [dir="rtl"] .\\33xl\\:me-68{
    margin-left: 17rem;
  }

  [dir="ltr"] .\\33xl\\:ms-72{
    margin-left: 18rem;
  }

  [dir="rtl"] .\\33xl\\:ms-72{
    margin-right: 18rem;
  }

  [dir="ltr"] .\\33xl\\:me-72{
    margin-right: 18rem;
  }

  [dir="rtl"] .\\33xl\\:me-72{
    margin-left: 18rem;
  }

  [dir="ltr"] .\\33xl\\:ms-74{
    margin-left: 18.5rem;
  }

  [dir="rtl"] .\\33xl\\:ms-74{
    margin-right: 18.5rem;
  }

  [dir="ltr"] .\\33xl\\:me-74{
    margin-right: 18.5rem;
  }

  [dir="rtl"] .\\33xl\\:me-74{
    margin-left: 18.5rem;
  }

  [dir="ltr"] .\\33xl\\:ms-76{
    margin-left: 19rem;
  }

  [dir="rtl"] .\\33xl\\:ms-76{
    margin-right: 19rem;
  }

  [dir="ltr"] .\\33xl\\:me-76{
    margin-right: 19rem;
  }

  [dir="rtl"] .\\33xl\\:me-76{
    margin-left: 19rem;
  }

  [dir="ltr"] .\\33xl\\:ms-78{
    margin-left: 19.5rem;
  }

  [dir="rtl"] .\\33xl\\:ms-78{
    margin-right: 19.5rem;
  }

  [dir="ltr"] .\\33xl\\:me-78{
    margin-right: 19.5rem;
  }

  [dir="rtl"] .\\33xl\\:me-78{
    margin-left: 19.5rem;
  }

  [dir="ltr"] .\\33xl\\:ms-80{
    margin-left: 20rem;
  }

  [dir="rtl"] .\\33xl\\:ms-80{
    margin-right: 20rem;
  }

  [dir="ltr"] .\\33xl\\:me-80{
    margin-right: 20rem;
  }

  [dir="rtl"] .\\33xl\\:me-80{
    margin-left: 20rem;
  }

  [dir="ltr"] .\\33xl\\:ms-82{
    margin-left: 20.5rem;
  }

  [dir="rtl"] .\\33xl\\:ms-82{
    margin-right: 20.5rem;
  }

  [dir="ltr"] .\\33xl\\:me-82{
    margin-right: 20.5rem;
  }

  [dir="rtl"] .\\33xl\\:me-82{
    margin-left: 20.5rem;
  }

  [dir="ltr"] .\\33xl\\:ms-84{
    margin-left: 21rem;
  }

  [dir="rtl"] .\\33xl\\:ms-84{
    margin-right: 21rem;
  }

  [dir="ltr"] .\\33xl\\:me-84{
    margin-right: 21rem;
  }

  [dir="rtl"] .\\33xl\\:me-84{
    margin-left: 21rem;
  }

  [dir="ltr"] .\\33xl\\:ms-88{
    margin-left: 22rem;
  }

  [dir="rtl"] .\\33xl\\:ms-88{
    margin-right: 22rem;
  }

  [dir="ltr"] .\\33xl\\:me-88{
    margin-right: 22rem;
  }

  [dir="rtl"] .\\33xl\\:me-88{
    margin-left: 22rem;
  }

  [dir="ltr"] .\\33xl\\:ms-92{
    margin-left: 23rem;
  }

  [dir="rtl"] .\\33xl\\:ms-92{
    margin-right: 23rem;
  }

  [dir="ltr"] .\\33xl\\:me-92{
    margin-right: 23rem;
  }

  [dir="rtl"] .\\33xl\\:me-92{
    margin-left: 23rem;
  }

  [dir="ltr"] .\\33xl\\:ms-96{
    margin-left: 24rem;
  }

  [dir="rtl"] .\\33xl\\:ms-96{
    margin-right: 24rem;
  }

  [dir="ltr"] .\\33xl\\:me-96{
    margin-right: 24rem;
  }

  [dir="rtl"] .\\33xl\\:me-96{
    margin-left: 24rem;
  }

  [dir="ltr"] .\\33xl\\:ms-98{
    margin-left: 24.5rem;
  }

  [dir="rtl"] .\\33xl\\:ms-98{
    margin-right: 24.5rem;
  }

  [dir="ltr"] .\\33xl\\:me-98{
    margin-right: 24.5rem;
  }

  [dir="rtl"] .\\33xl\\:me-98{
    margin-left: 24.5rem;
  }

  [dir="ltr"] .\\33xl\\:ms-100{
    margin-left: 25rem;
  }

  [dir="rtl"] .\\33xl\\:ms-100{
    margin-right: 25rem;
  }

  [dir="ltr"] .\\33xl\\:me-100{
    margin-right: 25rem;
  }

  [dir="rtl"] .\\33xl\\:me-100{
    margin-left: 25rem;
  }

  [dir="ltr"] .\\33xl\\:ms-104{
    margin-left: 26rem;
  }

  [dir="rtl"] .\\33xl\\:ms-104{
    margin-right: 26rem;
  }

  [dir="ltr"] .\\33xl\\:me-104{
    margin-right: 26rem;
  }

  [dir="rtl"] .\\33xl\\:me-104{
    margin-left: 26rem;
  }

  [dir="ltr"] .\\33xl\\:ms-112{
    margin-left: 28rem;
  }

  [dir="rtl"] .\\33xl\\:ms-112{
    margin-right: 28rem;
  }

  [dir="ltr"] .\\33xl\\:me-112{
    margin-right: 28rem;
  }

  [dir="rtl"] .\\33xl\\:me-112{
    margin-left: 28rem;
  }

  [dir="ltr"] .\\33xl\\:ms-124{
    margin-left: 31rem;
  }

  [dir="rtl"] .\\33xl\\:ms-124{
    margin-right: 31rem;
  }

  [dir="ltr"] .\\33xl\\:me-124{
    margin-right: 31rem;
  }

  [dir="rtl"] .\\33xl\\:me-124{
    margin-left: 31rem;
  }

  [dir="ltr"] .\\33xl\\:ms-128{
    margin-left: 32rem;
  }

  [dir="rtl"] .\\33xl\\:ms-128{
    margin-right: 32rem;
  }

  [dir="ltr"] .\\33xl\\:me-128{
    margin-right: 32rem;
  }

  [dir="rtl"] .\\33xl\\:me-128{
    margin-left: 32rem;
  }

  [dir="ltr"] .\\33xl\\:ms-140{
    margin-left: 35rem;
  }

  [dir="rtl"] .\\33xl\\:ms-140{
    margin-right: 35rem;
  }

  [dir="ltr"] .\\33xl\\:me-140{
    margin-right: 35rem;
  }

  [dir="rtl"] .\\33xl\\:me-140{
    margin-left: 35rem;
  }

  [dir="ltr"] .\\33xl\\:ms-152{
    margin-left: 38rem;
  }

  [dir="rtl"] .\\33xl\\:ms-152{
    margin-right: 38rem;
  }

  [dir="ltr"] .\\33xl\\:me-152{
    margin-right: 38rem;
  }

  [dir="rtl"] .\\33xl\\:me-152{
    margin-left: 38rem;
  }

  [dir="ltr"] .\\33xl\\:ms-160{
    margin-left: 40rem;
  }

  [dir="rtl"] .\\33xl\\:ms-160{
    margin-right: 40rem;
  }

  [dir="ltr"] .\\33xl\\:me-160{
    margin-right: 40rem;
  }

  [dir="rtl"] .\\33xl\\:me-160{
    margin-left: 40rem;
  }

  [dir="ltr"] .\\33xl\\:ms-162{
    margin-left: 41rem;
  }

  [dir="rtl"] .\\33xl\\:ms-162{
    margin-right: 41rem;
  }

  [dir="ltr"] .\\33xl\\:me-162{
    margin-right: 41rem;
  }

  [dir="rtl"] .\\33xl\\:me-162{
    margin-left: 41rem;
  }

  [dir="ltr"] .\\33xl\\:ms-192{
    margin-left: 48rem;
  }

  [dir="rtl"] .\\33xl\\:ms-192{
    margin-right: 48rem;
  }

  [dir="ltr"] .\\33xl\\:me-192{
    margin-right: 48rem;
  }

  [dir="rtl"] .\\33xl\\:me-192{
    margin-left: 48rem;
  }

  [dir="ltr"] .\\33xl\\:ms-208{
    margin-left: 52rem;
  }

  [dir="rtl"] .\\33xl\\:ms-208{
    margin-right: 52rem;
  }

  [dir="ltr"] .\\33xl\\:me-208{
    margin-right: 52rem;
  }

  [dir="rtl"] .\\33xl\\:me-208{
    margin-left: 52rem;
  }

  [dir="ltr"] .\\33xl\\:ms-224{
    margin-left: 56rem;
  }

  [dir="rtl"] .\\33xl\\:ms-224{
    margin-right: 56rem;
  }

  [dir="ltr"] .\\33xl\\:me-224{
    margin-right: 56rem;
  }

  [dir="rtl"] .\\33xl\\:me-224{
    margin-left: 56rem;
  }

  [dir="ltr"] .\\33xl\\:ms-256{
    margin-left: 64rem;
  }

  [dir="rtl"] .\\33xl\\:ms-256{
    margin-right: 64rem;
  }

  [dir="ltr"] .\\33xl\\:me-256{
    margin-right: 64rem;
  }

  [dir="rtl"] .\\33xl\\:me-256{
    margin-left: 64rem;
  }

  [dir="ltr"] .\\33xl\\:ms-auto{
    margin-left: auto;
  }

  [dir="rtl"] .\\33xl\\:ms-auto{
    margin-right: auto;
  }

  [dir="ltr"] .\\33xl\\:me-auto{
    margin-right: auto;
  }

  [dir="rtl"] .\\33xl\\:me-auto{
    margin-left: auto;
  }

  [dir="ltr"] .\\33xl\\:ms-px{
    margin-left: 1px;
  }

  [dir="rtl"] .\\33xl\\:ms-px{
    margin-right: 1px;
  }

  [dir="ltr"] .\\33xl\\:me-px{
    margin-right: 1px;
  }

  [dir="rtl"] .\\33xl\\:me-px{
    margin-left: 1px;
  }

  [dir="ltr"] .\\33xl\\:-ms-1{
    margin-left: -0.25rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-1{
    margin-right: -0.25rem;
  }

  [dir="ltr"] .\\33xl\\:-me-1{
    margin-right: -0.25rem;
  }

  [dir="rtl"] .\\33xl\\:-me-1{
    margin-left: -0.25rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-2{
    margin-left: -0.5rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-2{
    margin-right: -0.5rem;
  }

  [dir="ltr"] .\\33xl\\:-me-2{
    margin-right: -0.5rem;
  }

  [dir="rtl"] .\\33xl\\:-me-2{
    margin-left: -0.5rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-3{
    margin-left: -0.75rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-3{
    margin-right: -0.75rem;
  }

  [dir="ltr"] .\\33xl\\:-me-3{
    margin-right: -0.75rem;
  }

  [dir="rtl"] .\\33xl\\:-me-3{
    margin-left: -0.75rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-4{
    margin-left: -1rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-4{
    margin-right: -1rem;
  }

  [dir="ltr"] .\\33xl\\:-me-4{
    margin-right: -1rem;
  }

  [dir="rtl"] .\\33xl\\:-me-4{
    margin-left: -1rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-5{
    margin-left: -1.25rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-5{
    margin-right: -1.25rem;
  }

  [dir="ltr"] .\\33xl\\:-me-5{
    margin-right: -1.25rem;
  }

  [dir="rtl"] .\\33xl\\:-me-5{
    margin-left: -1.25rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-6{
    margin-left: -1.5rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-6{
    margin-right: -1.5rem;
  }

  [dir="ltr"] .\\33xl\\:-me-6{
    margin-right: -1.5rem;
  }

  [dir="rtl"] .\\33xl\\:-me-6{
    margin-left: -1.5rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-7{
    margin-left: -1.75rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-7{
    margin-right: -1.75rem;
  }

  [dir="ltr"] .\\33xl\\:-me-7{
    margin-right: -1.75rem;
  }

  [dir="rtl"] .\\33xl\\:-me-7{
    margin-left: -1.75rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-8{
    margin-left: -2rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-8{
    margin-right: -2rem;
  }

  [dir="ltr"] .\\33xl\\:-me-8{
    margin-right: -2rem;
  }

  [dir="rtl"] .\\33xl\\:-me-8{
    margin-left: -2rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-9{
    margin-left: -2.25rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-9{
    margin-right: -2.25rem;
  }

  [dir="ltr"] .\\33xl\\:-me-9{
    margin-right: -2.25rem;
  }

  [dir="rtl"] .\\33xl\\:-me-9{
    margin-left: -2.25rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-10{
    margin-left: -2.5rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-10{
    margin-right: -2.5rem;
  }

  [dir="ltr"] .\\33xl\\:-me-10{
    margin-right: -2.5rem;
  }

  [dir="rtl"] .\\33xl\\:-me-10{
    margin-left: -2.5rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-11{
    margin-left: -2.75rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-11{
    margin-right: -2.75rem;
  }

  [dir="ltr"] .\\33xl\\:-me-11{
    margin-right: -2.75rem;
  }

  [dir="rtl"] .\\33xl\\:-me-11{
    margin-left: -2.75rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-12{
    margin-left: -3rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-12{
    margin-right: -3rem;
  }

  [dir="ltr"] .\\33xl\\:-me-12{
    margin-right: -3rem;
  }

  [dir="rtl"] .\\33xl\\:-me-12{
    margin-left: -3rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-14{
    margin-left: -3.5rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-14{
    margin-right: -3.5rem;
  }

  [dir="ltr"] .\\33xl\\:-me-14{
    margin-right: -3.5rem;
  }

  [dir="rtl"] .\\33xl\\:-me-14{
    margin-left: -3.5rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-15{
    margin-left: -3.75rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-15{
    margin-right: -3.75rem;
  }

  [dir="ltr"] .\\33xl\\:-me-15{
    margin-right: -3.75rem;
  }

  [dir="rtl"] .\\33xl\\:-me-15{
    margin-left: -3.75rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-16{
    margin-left: -4rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-16{
    margin-right: -4rem;
  }

  [dir="ltr"] .\\33xl\\:-me-16{
    margin-right: -4rem;
  }

  [dir="rtl"] .\\33xl\\:-me-16{
    margin-left: -4rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-18{
    margin-left: -4.5rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-18{
    margin-right: -4.5rem;
  }

  [dir="ltr"] .\\33xl\\:-me-18{
    margin-right: -4.5rem;
  }

  [dir="rtl"] .\\33xl\\:-me-18{
    margin-left: -4.5rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-20{
    margin-left: -5rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-20{
    margin-right: -5rem;
  }

  [dir="ltr"] .\\33xl\\:-me-20{
    margin-right: -5rem;
  }

  [dir="rtl"] .\\33xl\\:-me-20{
    margin-left: -5rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-22{
    margin-left: -5.5rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-22{
    margin-right: -5.5rem;
  }

  [dir="ltr"] .\\33xl\\:-me-22{
    margin-right: -5.5rem;
  }

  [dir="rtl"] .\\33xl\\:-me-22{
    margin-left: -5.5rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-23{
    margin-left: -5.75rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-23{
    margin-right: -5.75rem;
  }

  [dir="ltr"] .\\33xl\\:-me-23{
    margin-right: -5.75rem;
  }

  [dir="rtl"] .\\33xl\\:-me-23{
    margin-left: -5.75rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-24{
    margin-left: -6rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-24{
    margin-right: -6rem;
  }

  [dir="ltr"] .\\33xl\\:-me-24{
    margin-right: -6rem;
  }

  [dir="rtl"] .\\33xl\\:-me-24{
    margin-left: -6rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-25{
    margin-left: -6.25rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-25{
    margin-right: -6.25rem;
  }

  [dir="ltr"] .\\33xl\\:-me-25{
    margin-right: -6.25rem;
  }

  [dir="rtl"] .\\33xl\\:-me-25{
    margin-left: -6.25rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-26{
    margin-left: -6.5rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-26{
    margin-right: -6.5rem;
  }

  [dir="ltr"] .\\33xl\\:-me-26{
    margin-right: -6.5rem;
  }

  [dir="rtl"] .\\33xl\\:-me-26{
    margin-left: -6.5rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-28{
    margin-left: -7rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-28{
    margin-right: -7rem;
  }

  [dir="ltr"] .\\33xl\\:-me-28{
    margin-right: -7rem;
  }

  [dir="rtl"] .\\33xl\\:-me-28{
    margin-left: -7rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-30{
    margin-left: -7.5rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-30{
    margin-right: -7.5rem;
  }

  [dir="ltr"] .\\33xl\\:-me-30{
    margin-right: -7.5rem;
  }

  [dir="rtl"] .\\33xl\\:-me-30{
    margin-left: -7.5rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-32{
    margin-left: -8rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-32{
    margin-right: -8rem;
  }

  [dir="ltr"] .\\33xl\\:-me-32{
    margin-right: -8rem;
  }

  [dir="rtl"] .\\33xl\\:-me-32{
    margin-left: -8rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-34{
    margin-left: -8.5rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-34{
    margin-right: -8.5rem;
  }

  [dir="ltr"] .\\33xl\\:-me-34{
    margin-right: -8.5rem;
  }

  [dir="rtl"] .\\33xl\\:-me-34{
    margin-left: -8.5rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-40{
    margin-left: -10rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-40{
    margin-right: -10rem;
  }

  [dir="ltr"] .\\33xl\\:-me-40{
    margin-right: -10rem;
  }

  [dir="rtl"] .\\33xl\\:-me-40{
    margin-left: -10rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-42{
    margin-left: -10.5rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-42{
    margin-right: -10.5rem;
  }

  [dir="ltr"] .\\33xl\\:-me-42{
    margin-right: -10.5rem;
  }

  [dir="rtl"] .\\33xl\\:-me-42{
    margin-left: -10.5rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-44{
    margin-left: -11rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-44{
    margin-right: -11rem;
  }

  [dir="ltr"] .\\33xl\\:-me-44{
    margin-right: -11rem;
  }

  [dir="rtl"] .\\33xl\\:-me-44{
    margin-left: -11rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-48{
    margin-left: -12rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-48{
    margin-right: -12rem;
  }

  [dir="ltr"] .\\33xl\\:-me-48{
    margin-right: -12rem;
  }

  [dir="rtl"] .\\33xl\\:-me-48{
    margin-left: -12rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-52{
    margin-left: -13rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-52{
    margin-right: -13rem;
  }

  [dir="ltr"] .\\33xl\\:-me-52{
    margin-right: -13rem;
  }

  [dir="rtl"] .\\33xl\\:-me-52{
    margin-left: -13rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-54{
    margin-left: -13.5rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-54{
    margin-right: -13.5rem;
  }

  [dir="ltr"] .\\33xl\\:-me-54{
    margin-right: -13.5rem;
  }

  [dir="rtl"] .\\33xl\\:-me-54{
    margin-left: -13.5rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-56{
    margin-left: -14rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-56{
    margin-right: -14rem;
  }

  [dir="ltr"] .\\33xl\\:-me-56{
    margin-right: -14rem;
  }

  [dir="rtl"] .\\33xl\\:-me-56{
    margin-left: -14rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-60{
    margin-left: -15rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-60{
    margin-right: -15rem;
  }

  [dir="ltr"] .\\33xl\\:-me-60{
    margin-right: -15rem;
  }

  [dir="rtl"] .\\33xl\\:-me-60{
    margin-left: -15rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-64{
    margin-left: -16rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-64{
    margin-right: -16rem;
  }

  [dir="ltr"] .\\33xl\\:-me-64{
    margin-right: -16rem;
  }

  [dir="rtl"] .\\33xl\\:-me-64{
    margin-left: -16rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-68{
    margin-left: -17rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-68{
    margin-right: -17rem;
  }

  [dir="ltr"] .\\33xl\\:-me-68{
    margin-right: -17rem;
  }

  [dir="rtl"] .\\33xl\\:-me-68{
    margin-left: -17rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-72{
    margin-left: -18rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-72{
    margin-right: -18rem;
  }

  [dir="ltr"] .\\33xl\\:-me-72{
    margin-right: -18rem;
  }

  [dir="rtl"] .\\33xl\\:-me-72{
    margin-left: -18rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-74{
    margin-left: -18.5rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-74{
    margin-right: -18.5rem;
  }

  [dir="ltr"] .\\33xl\\:-me-74{
    margin-right: -18.5rem;
  }

  [dir="rtl"] .\\33xl\\:-me-74{
    margin-left: -18.5rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-76{
    margin-left: -19rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-76{
    margin-right: -19rem;
  }

  [dir="ltr"] .\\33xl\\:-me-76{
    margin-right: -19rem;
  }

  [dir="rtl"] .\\33xl\\:-me-76{
    margin-left: -19rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-78{
    margin-left: -19.5rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-78{
    margin-right: -19.5rem;
  }

  [dir="ltr"] .\\33xl\\:-me-78{
    margin-right: -19.5rem;
  }

  [dir="rtl"] .\\33xl\\:-me-78{
    margin-left: -19.5rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-80{
    margin-left: -20rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-80{
    margin-right: -20rem;
  }

  [dir="ltr"] .\\33xl\\:-me-80{
    margin-right: -20rem;
  }

  [dir="rtl"] .\\33xl\\:-me-80{
    margin-left: -20rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-82{
    margin-left: -20.5rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-82{
    margin-right: -20.5rem;
  }

  [dir="ltr"] .\\33xl\\:-me-82{
    margin-right: -20.5rem;
  }

  [dir="rtl"] .\\33xl\\:-me-82{
    margin-left: -20.5rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-84{
    margin-left: -21rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-84{
    margin-right: -21rem;
  }

  [dir="ltr"] .\\33xl\\:-me-84{
    margin-right: -21rem;
  }

  [dir="rtl"] .\\33xl\\:-me-84{
    margin-left: -21rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-88{
    margin-left: -22rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-88{
    margin-right: -22rem;
  }

  [dir="ltr"] .\\33xl\\:-me-88{
    margin-right: -22rem;
  }

  [dir="rtl"] .\\33xl\\:-me-88{
    margin-left: -22rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-92{
    margin-left: -23rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-92{
    margin-right: -23rem;
  }

  [dir="ltr"] .\\33xl\\:-me-92{
    margin-right: -23rem;
  }

  [dir="rtl"] .\\33xl\\:-me-92{
    margin-left: -23rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-96{
    margin-left: -24rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-96{
    margin-right: -24rem;
  }

  [dir="ltr"] .\\33xl\\:-me-96{
    margin-right: -24rem;
  }

  [dir="rtl"] .\\33xl\\:-me-96{
    margin-left: -24rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-98{
    margin-left: -24.5rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-98{
    margin-right: -24.5rem;
  }

  [dir="ltr"] .\\33xl\\:-me-98{
    margin-right: -24.5rem;
  }

  [dir="rtl"] .\\33xl\\:-me-98{
    margin-left: -24.5rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-100{
    margin-left: -25rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-100{
    margin-right: -25rem;
  }

  [dir="ltr"] .\\33xl\\:-me-100{
    margin-right: -25rem;
  }

  [dir="rtl"] .\\33xl\\:-me-100{
    margin-left: -25rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-104{
    margin-left: -26rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-104{
    margin-right: -26rem;
  }

  [dir="ltr"] .\\33xl\\:-me-104{
    margin-right: -26rem;
  }

  [dir="rtl"] .\\33xl\\:-me-104{
    margin-left: -26rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-112{
    margin-left: -28rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-112{
    margin-right: -28rem;
  }

  [dir="ltr"] .\\33xl\\:-me-112{
    margin-right: -28rem;
  }

  [dir="rtl"] .\\33xl\\:-me-112{
    margin-left: -28rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-124{
    margin-left: -31rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-124{
    margin-right: -31rem;
  }

  [dir="ltr"] .\\33xl\\:-me-124{
    margin-right: -31rem;
  }

  [dir="rtl"] .\\33xl\\:-me-124{
    margin-left: -31rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-128{
    margin-left: -32rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-128{
    margin-right: -32rem;
  }

  [dir="ltr"] .\\33xl\\:-me-128{
    margin-right: -32rem;
  }

  [dir="rtl"] .\\33xl\\:-me-128{
    margin-left: -32rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-140{
    margin-left: -35rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-140{
    margin-right: -35rem;
  }

  [dir="ltr"] .\\33xl\\:-me-140{
    margin-right: -35rem;
  }

  [dir="rtl"] .\\33xl\\:-me-140{
    margin-left: -35rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-152{
    margin-left: -38rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-152{
    margin-right: -38rem;
  }

  [dir="ltr"] .\\33xl\\:-me-152{
    margin-right: -38rem;
  }

  [dir="rtl"] .\\33xl\\:-me-152{
    margin-left: -38rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-160{
    margin-left: -40rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-160{
    margin-right: -40rem;
  }

  [dir="ltr"] .\\33xl\\:-me-160{
    margin-right: -40rem;
  }

  [dir="rtl"] .\\33xl\\:-me-160{
    margin-left: -40rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-162{
    margin-left: -41rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-162{
    margin-right: -41rem;
  }

  [dir="ltr"] .\\33xl\\:-me-162{
    margin-right: -41rem;
  }

  [dir="rtl"] .\\33xl\\:-me-162{
    margin-left: -41rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-192{
    margin-left: -48rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-192{
    margin-right: -48rem;
  }

  [dir="ltr"] .\\33xl\\:-me-192{
    margin-right: -48rem;
  }

  [dir="rtl"] .\\33xl\\:-me-192{
    margin-left: -48rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-208{
    margin-left: -52rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-208{
    margin-right: -52rem;
  }

  [dir="ltr"] .\\33xl\\:-me-208{
    margin-right: -52rem;
  }

  [dir="rtl"] .\\33xl\\:-me-208{
    margin-left: -52rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-224{
    margin-left: -56rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-224{
    margin-right: -56rem;
  }

  [dir="ltr"] .\\33xl\\:-me-224{
    margin-right: -56rem;
  }

  [dir="rtl"] .\\33xl\\:-me-224{
    margin-left: -56rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-256{
    margin-left: -64rem;
  }

  [dir="rtl"] .\\33xl\\:-ms-256{
    margin-right: -64rem;
  }

  [dir="ltr"] .\\33xl\\:-me-256{
    margin-right: -64rem;
  }

  [dir="rtl"] .\\33xl\\:-me-256{
    margin-left: -64rem;
  }

  [dir="ltr"] .\\33xl\\:-ms-px{
    margin-left: -1px;
  }

  [dir="rtl"] .\\33xl\\:-ms-px{
    margin-right: -1px;
  }

  [dir="ltr"] .\\33xl\\:-me-px{
    margin-right: -1px;
  }

  [dir="rtl"] .\\33xl\\:-me-px{
    margin-left: -1px;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-0:first-child{
    margin-left: 0;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-0:first-child{
    margin-right: 0;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-0:first-child{
    margin-right: 0;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-0:first-child{
    margin-left: 0;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-1:first-child{
    margin-left: 0.25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-1:first-child{
    margin-right: 0.25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-1:first-child{
    margin-right: 0.25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-1:first-child{
    margin-left: 0.25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-2:first-child{
    margin-left: 0.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-2:first-child{
    margin-right: 0.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-2:first-child{
    margin-right: 0.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-2:first-child{
    margin-left: 0.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-3:first-child{
    margin-left: 0.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-3:first-child{
    margin-right: 0.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-3:first-child{
    margin-right: 0.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-3:first-child{
    margin-left: 0.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-4:first-child{
    margin-left: 1rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-4:first-child{
    margin-right: 1rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-4:first-child{
    margin-right: 1rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-4:first-child{
    margin-left: 1rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-5:first-child{
    margin-left: 1.25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-5:first-child{
    margin-right: 1.25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-5:first-child{
    margin-right: 1.25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-5:first-child{
    margin-left: 1.25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-6:first-child{
    margin-left: 1.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-6:first-child{
    margin-right: 1.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-6:first-child{
    margin-right: 1.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-6:first-child{
    margin-left: 1.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-7:first-child{
    margin-left: 1.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-7:first-child{
    margin-right: 1.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-7:first-child{
    margin-right: 1.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-7:first-child{
    margin-left: 1.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-8:first-child{
    margin-left: 2rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-8:first-child{
    margin-right: 2rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-8:first-child{
    margin-right: 2rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-8:first-child{
    margin-left: 2rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-9:first-child{
    margin-left: 2.25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-9:first-child{
    margin-right: 2.25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-9:first-child{
    margin-right: 2.25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-9:first-child{
    margin-left: 2.25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-10:first-child{
    margin-left: 2.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-10:first-child{
    margin-right: 2.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-10:first-child{
    margin-right: 2.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-10:first-child{
    margin-left: 2.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-11:first-child{
    margin-left: 2.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-11:first-child{
    margin-right: 2.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-11:first-child{
    margin-right: 2.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-11:first-child{
    margin-left: 2.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-12:first-child{
    margin-left: 3rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-12:first-child{
    margin-right: 3rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-12:first-child{
    margin-right: 3rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-12:first-child{
    margin-left: 3rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-14:first-child{
    margin-left: 3.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-14:first-child{
    margin-right: 3.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-14:first-child{
    margin-right: 3.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-14:first-child{
    margin-left: 3.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-15:first-child{
    margin-left: 3.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-15:first-child{
    margin-right: 3.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-15:first-child{
    margin-right: 3.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-15:first-child{
    margin-left: 3.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-16:first-child{
    margin-left: 4rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-16:first-child{
    margin-right: 4rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-16:first-child{
    margin-right: 4rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-16:first-child{
    margin-left: 4rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-18:first-child{
    margin-left: 4.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-18:first-child{
    margin-right: 4.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-18:first-child{
    margin-right: 4.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-18:first-child{
    margin-left: 4.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-20:first-child{
    margin-left: 5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-20:first-child{
    margin-right: 5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-20:first-child{
    margin-right: 5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-20:first-child{
    margin-left: 5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-22:first-child{
    margin-left: 5.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-22:first-child{
    margin-right: 5.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-22:first-child{
    margin-right: 5.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-22:first-child{
    margin-left: 5.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-23:first-child{
    margin-left: 5.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-23:first-child{
    margin-right: 5.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-23:first-child{
    margin-right: 5.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-23:first-child{
    margin-left: 5.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-24:first-child{
    margin-left: 6rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-24:first-child{
    margin-right: 6rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-24:first-child{
    margin-right: 6rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-24:first-child{
    margin-left: 6rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-25:first-child{
    margin-left: 6.25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-25:first-child{
    margin-right: 6.25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-25:first-child{
    margin-right: 6.25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-25:first-child{
    margin-left: 6.25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-26:first-child{
    margin-left: 6.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-26:first-child{
    margin-right: 6.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-26:first-child{
    margin-right: 6.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-26:first-child{
    margin-left: 6.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-28:first-child{
    margin-left: 7rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-28:first-child{
    margin-right: 7rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-28:first-child{
    margin-right: 7rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-28:first-child{
    margin-left: 7rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-30:first-child{
    margin-left: 7.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-30:first-child{
    margin-right: 7.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-30:first-child{
    margin-right: 7.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-30:first-child{
    margin-left: 7.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-32:first-child{
    margin-left: 8rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-32:first-child{
    margin-right: 8rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-32:first-child{
    margin-right: 8rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-32:first-child{
    margin-left: 8rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-34:first-child{
    margin-left: 8.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-34:first-child{
    margin-right: 8.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-34:first-child{
    margin-right: 8.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-34:first-child{
    margin-left: 8.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-40:first-child{
    margin-left: 10rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-40:first-child{
    margin-right: 10rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-40:first-child{
    margin-right: 10rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-40:first-child{
    margin-left: 10rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-42:first-child{
    margin-left: 10.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-42:first-child{
    margin-right: 10.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-42:first-child{
    margin-right: 10.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-42:first-child{
    margin-left: 10.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-44:first-child{
    margin-left: 11rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-44:first-child{
    margin-right: 11rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-44:first-child{
    margin-right: 11rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-44:first-child{
    margin-left: 11rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-48:first-child{
    margin-left: 12rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-48:first-child{
    margin-right: 12rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-48:first-child{
    margin-right: 12rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-48:first-child{
    margin-left: 12rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-52:first-child{
    margin-left: 13rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-52:first-child{
    margin-right: 13rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-52:first-child{
    margin-right: 13rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-52:first-child{
    margin-left: 13rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-54:first-child{
    margin-left: 13.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-54:first-child{
    margin-right: 13.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-54:first-child{
    margin-right: 13.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-54:first-child{
    margin-left: 13.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-56:first-child{
    margin-left: 14rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-56:first-child{
    margin-right: 14rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-56:first-child{
    margin-right: 14rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-56:first-child{
    margin-left: 14rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-60:first-child{
    margin-left: 15rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-60:first-child{
    margin-right: 15rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-60:first-child{
    margin-right: 15rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-60:first-child{
    margin-left: 15rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-64:first-child{
    margin-left: 16rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-64:first-child{
    margin-right: 16rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-64:first-child{
    margin-right: 16rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-64:first-child{
    margin-left: 16rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-68:first-child{
    margin-left: 17rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-68:first-child{
    margin-right: 17rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-68:first-child{
    margin-right: 17rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-68:first-child{
    margin-left: 17rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-72:first-child{
    margin-left: 18rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-72:first-child{
    margin-right: 18rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-72:first-child{
    margin-right: 18rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-72:first-child{
    margin-left: 18rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-74:first-child{
    margin-left: 18.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-74:first-child{
    margin-right: 18.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-74:first-child{
    margin-right: 18.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-74:first-child{
    margin-left: 18.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-76:first-child{
    margin-left: 19rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-76:first-child{
    margin-right: 19rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-76:first-child{
    margin-right: 19rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-76:first-child{
    margin-left: 19rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-78:first-child{
    margin-left: 19.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-78:first-child{
    margin-right: 19.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-78:first-child{
    margin-right: 19.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-78:first-child{
    margin-left: 19.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-80:first-child{
    margin-left: 20rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-80:first-child{
    margin-right: 20rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-80:first-child{
    margin-right: 20rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-80:first-child{
    margin-left: 20rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-82:first-child{
    margin-left: 20.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-82:first-child{
    margin-right: 20.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-82:first-child{
    margin-right: 20.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-82:first-child{
    margin-left: 20.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-84:first-child{
    margin-left: 21rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-84:first-child{
    margin-right: 21rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-84:first-child{
    margin-right: 21rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-84:first-child{
    margin-left: 21rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-88:first-child{
    margin-left: 22rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-88:first-child{
    margin-right: 22rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-88:first-child{
    margin-right: 22rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-88:first-child{
    margin-left: 22rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-92:first-child{
    margin-left: 23rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-92:first-child{
    margin-right: 23rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-92:first-child{
    margin-right: 23rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-92:first-child{
    margin-left: 23rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-96:first-child{
    margin-left: 24rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-96:first-child{
    margin-right: 24rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-96:first-child{
    margin-right: 24rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-96:first-child{
    margin-left: 24rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-98:first-child{
    margin-left: 24.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-98:first-child{
    margin-right: 24.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-98:first-child{
    margin-right: 24.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-98:first-child{
    margin-left: 24.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-100:first-child{
    margin-left: 25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-100:first-child{
    margin-right: 25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-100:first-child{
    margin-right: 25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-100:first-child{
    margin-left: 25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-104:first-child{
    margin-left: 26rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-104:first-child{
    margin-right: 26rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-104:first-child{
    margin-right: 26rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-104:first-child{
    margin-left: 26rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-112:first-child{
    margin-left: 28rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-112:first-child{
    margin-right: 28rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-112:first-child{
    margin-right: 28rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-112:first-child{
    margin-left: 28rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-124:first-child{
    margin-left: 31rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-124:first-child{
    margin-right: 31rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-124:first-child{
    margin-right: 31rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-124:first-child{
    margin-left: 31rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-128:first-child{
    margin-left: 32rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-128:first-child{
    margin-right: 32rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-128:first-child{
    margin-right: 32rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-128:first-child{
    margin-left: 32rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-140:first-child{
    margin-left: 35rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-140:first-child{
    margin-right: 35rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-140:first-child{
    margin-right: 35rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-140:first-child{
    margin-left: 35rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-152:first-child{
    margin-left: 38rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-152:first-child{
    margin-right: 38rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-152:first-child{
    margin-right: 38rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-152:first-child{
    margin-left: 38rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-160:first-child{
    margin-left: 40rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-160:first-child{
    margin-right: 40rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-160:first-child{
    margin-right: 40rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-160:first-child{
    margin-left: 40rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-162:first-child{
    margin-left: 41rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-162:first-child{
    margin-right: 41rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-162:first-child{
    margin-right: 41rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-162:first-child{
    margin-left: 41rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-192:first-child{
    margin-left: 48rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-192:first-child{
    margin-right: 48rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-192:first-child{
    margin-right: 48rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-192:first-child{
    margin-left: 48rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-208:first-child{
    margin-left: 52rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-208:first-child{
    margin-right: 52rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-208:first-child{
    margin-right: 52rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-208:first-child{
    margin-left: 52rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-224:first-child{
    margin-left: 56rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-224:first-child{
    margin-right: 56rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-224:first-child{
    margin-right: 56rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-224:first-child{
    margin-left: 56rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-256:first-child{
    margin-left: 64rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-256:first-child{
    margin-right: 64rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-256:first-child{
    margin-right: 64rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-256:first-child{
    margin-left: 64rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-auto:first-child{
    margin-left: auto;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-auto:first-child{
    margin-right: auto;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-auto:first-child{
    margin-right: auto;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-auto:first-child{
    margin-left: auto;
  }

  [dir="ltr"] .\\33xl\\:first\\:ms-px:first-child{
    margin-left: 1px;
  }

  [dir="rtl"] .\\33xl\\:first\\:ms-px:first-child{
    margin-right: 1px;
  }

  [dir="ltr"] .\\33xl\\:first\\:me-px:first-child{
    margin-right: 1px;
  }

  [dir="rtl"] .\\33xl\\:first\\:me-px:first-child{
    margin-left: 1px;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-1:first-child{
    margin-left: -0.25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-1:first-child{
    margin-right: -0.25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-1:first-child{
    margin-right: -0.25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-1:first-child{
    margin-left: -0.25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-2:first-child{
    margin-left: -0.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-2:first-child{
    margin-right: -0.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-2:first-child{
    margin-right: -0.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-2:first-child{
    margin-left: -0.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-3:first-child{
    margin-left: -0.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-3:first-child{
    margin-right: -0.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-3:first-child{
    margin-right: -0.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-3:first-child{
    margin-left: -0.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-4:first-child{
    margin-left: -1rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-4:first-child{
    margin-right: -1rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-4:first-child{
    margin-right: -1rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-4:first-child{
    margin-left: -1rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-5:first-child{
    margin-left: -1.25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-5:first-child{
    margin-right: -1.25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-5:first-child{
    margin-right: -1.25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-5:first-child{
    margin-left: -1.25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-6:first-child{
    margin-left: -1.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-6:first-child{
    margin-right: -1.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-6:first-child{
    margin-right: -1.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-6:first-child{
    margin-left: -1.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-7:first-child{
    margin-left: -1.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-7:first-child{
    margin-right: -1.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-7:first-child{
    margin-right: -1.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-7:first-child{
    margin-left: -1.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-8:first-child{
    margin-left: -2rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-8:first-child{
    margin-right: -2rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-8:first-child{
    margin-right: -2rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-8:first-child{
    margin-left: -2rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-9:first-child{
    margin-left: -2.25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-9:first-child{
    margin-right: -2.25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-9:first-child{
    margin-right: -2.25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-9:first-child{
    margin-left: -2.25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-10:first-child{
    margin-left: -2.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-10:first-child{
    margin-right: -2.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-10:first-child{
    margin-right: -2.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-10:first-child{
    margin-left: -2.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-11:first-child{
    margin-left: -2.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-11:first-child{
    margin-right: -2.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-11:first-child{
    margin-right: -2.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-11:first-child{
    margin-left: -2.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-12:first-child{
    margin-left: -3rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-12:first-child{
    margin-right: -3rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-12:first-child{
    margin-right: -3rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-12:first-child{
    margin-left: -3rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-14:first-child{
    margin-left: -3.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-14:first-child{
    margin-right: -3.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-14:first-child{
    margin-right: -3.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-14:first-child{
    margin-left: -3.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-15:first-child{
    margin-left: -3.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-15:first-child{
    margin-right: -3.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-15:first-child{
    margin-right: -3.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-15:first-child{
    margin-left: -3.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-16:first-child{
    margin-left: -4rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-16:first-child{
    margin-right: -4rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-16:first-child{
    margin-right: -4rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-16:first-child{
    margin-left: -4rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-18:first-child{
    margin-left: -4.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-18:first-child{
    margin-right: -4.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-18:first-child{
    margin-right: -4.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-18:first-child{
    margin-left: -4.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-20:first-child{
    margin-left: -5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-20:first-child{
    margin-right: -5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-20:first-child{
    margin-right: -5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-20:first-child{
    margin-left: -5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-22:first-child{
    margin-left: -5.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-22:first-child{
    margin-right: -5.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-22:first-child{
    margin-right: -5.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-22:first-child{
    margin-left: -5.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-23:first-child{
    margin-left: -5.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-23:first-child{
    margin-right: -5.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-23:first-child{
    margin-right: -5.75rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-23:first-child{
    margin-left: -5.75rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-24:first-child{
    margin-left: -6rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-24:first-child{
    margin-right: -6rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-24:first-child{
    margin-right: -6rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-24:first-child{
    margin-left: -6rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-25:first-child{
    margin-left: -6.25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-25:first-child{
    margin-right: -6.25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-25:first-child{
    margin-right: -6.25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-25:first-child{
    margin-left: -6.25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-26:first-child{
    margin-left: -6.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-26:first-child{
    margin-right: -6.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-26:first-child{
    margin-right: -6.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-26:first-child{
    margin-left: -6.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-28:first-child{
    margin-left: -7rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-28:first-child{
    margin-right: -7rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-28:first-child{
    margin-right: -7rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-28:first-child{
    margin-left: -7rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-30:first-child{
    margin-left: -7.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-30:first-child{
    margin-right: -7.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-30:first-child{
    margin-right: -7.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-30:first-child{
    margin-left: -7.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-32:first-child{
    margin-left: -8rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-32:first-child{
    margin-right: -8rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-32:first-child{
    margin-right: -8rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-32:first-child{
    margin-left: -8rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-34:first-child{
    margin-left: -8.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-34:first-child{
    margin-right: -8.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-34:first-child{
    margin-right: -8.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-34:first-child{
    margin-left: -8.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-40:first-child{
    margin-left: -10rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-40:first-child{
    margin-right: -10rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-40:first-child{
    margin-right: -10rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-40:first-child{
    margin-left: -10rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-42:first-child{
    margin-left: -10.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-42:first-child{
    margin-right: -10.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-42:first-child{
    margin-right: -10.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-42:first-child{
    margin-left: -10.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-44:first-child{
    margin-left: -11rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-44:first-child{
    margin-right: -11rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-44:first-child{
    margin-right: -11rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-44:first-child{
    margin-left: -11rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-48:first-child{
    margin-left: -12rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-48:first-child{
    margin-right: -12rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-48:first-child{
    margin-right: -12rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-48:first-child{
    margin-left: -12rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-52:first-child{
    margin-left: -13rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-52:first-child{
    margin-right: -13rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-52:first-child{
    margin-right: -13rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-52:first-child{
    margin-left: -13rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-54:first-child{
    margin-left: -13.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-54:first-child{
    margin-right: -13.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-54:first-child{
    margin-right: -13.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-54:first-child{
    margin-left: -13.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-56:first-child{
    margin-left: -14rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-56:first-child{
    margin-right: -14rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-56:first-child{
    margin-right: -14rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-56:first-child{
    margin-left: -14rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-60:first-child{
    margin-left: -15rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-60:first-child{
    margin-right: -15rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-60:first-child{
    margin-right: -15rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-60:first-child{
    margin-left: -15rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-64:first-child{
    margin-left: -16rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-64:first-child{
    margin-right: -16rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-64:first-child{
    margin-right: -16rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-64:first-child{
    margin-left: -16rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-68:first-child{
    margin-left: -17rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-68:first-child{
    margin-right: -17rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-68:first-child{
    margin-right: -17rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-68:first-child{
    margin-left: -17rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-72:first-child{
    margin-left: -18rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-72:first-child{
    margin-right: -18rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-72:first-child{
    margin-right: -18rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-72:first-child{
    margin-left: -18rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-74:first-child{
    margin-left: -18.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-74:first-child{
    margin-right: -18.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-74:first-child{
    margin-right: -18.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-74:first-child{
    margin-left: -18.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-76:first-child{
    margin-left: -19rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-76:first-child{
    margin-right: -19rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-76:first-child{
    margin-right: -19rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-76:first-child{
    margin-left: -19rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-78:first-child{
    margin-left: -19.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-78:first-child{
    margin-right: -19.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-78:first-child{
    margin-right: -19.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-78:first-child{
    margin-left: -19.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-80:first-child{
    margin-left: -20rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-80:first-child{
    margin-right: -20rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-80:first-child{
    margin-right: -20rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-80:first-child{
    margin-left: -20rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-82:first-child{
    margin-left: -20.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-82:first-child{
    margin-right: -20.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-82:first-child{
    margin-right: -20.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-82:first-child{
    margin-left: -20.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-84:first-child{
    margin-left: -21rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-84:first-child{
    margin-right: -21rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-84:first-child{
    margin-right: -21rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-84:first-child{
    margin-left: -21rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-88:first-child{
    margin-left: -22rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-88:first-child{
    margin-right: -22rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-88:first-child{
    margin-right: -22rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-88:first-child{
    margin-left: -22rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-92:first-child{
    margin-left: -23rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-92:first-child{
    margin-right: -23rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-92:first-child{
    margin-right: -23rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-92:first-child{
    margin-left: -23rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-96:first-child{
    margin-left: -24rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-96:first-child{
    margin-right: -24rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-96:first-child{
    margin-right: -24rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-96:first-child{
    margin-left: -24rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-98:first-child{
    margin-left: -24.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-98:first-child{
    margin-right: -24.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-98:first-child{
    margin-right: -24.5rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-98:first-child{
    margin-left: -24.5rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-100:first-child{
    margin-left: -25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-100:first-child{
    margin-right: -25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-100:first-child{
    margin-right: -25rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-100:first-child{
    margin-left: -25rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-104:first-child{
    margin-left: -26rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-104:first-child{
    margin-right: -26rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-104:first-child{
    margin-right: -26rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-104:first-child{
    margin-left: -26rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-112:first-child{
    margin-left: -28rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-112:first-child{
    margin-right: -28rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-112:first-child{
    margin-right: -28rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-112:first-child{
    margin-left: -28rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-124:first-child{
    margin-left: -31rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-124:first-child{
    margin-right: -31rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-124:first-child{
    margin-right: -31rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-124:first-child{
    margin-left: -31rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-128:first-child{
    margin-left: -32rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-128:first-child{
    margin-right: -32rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-128:first-child{
    margin-right: -32rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-128:first-child{
    margin-left: -32rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-140:first-child{
    margin-left: -35rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-140:first-child{
    margin-right: -35rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-140:first-child{
    margin-right: -35rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-140:first-child{
    margin-left: -35rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-152:first-child{
    margin-left: -38rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-152:first-child{
    margin-right: -38rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-152:first-child{
    margin-right: -38rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-152:first-child{
    margin-left: -38rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-160:first-child{
    margin-left: -40rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-160:first-child{
    margin-right: -40rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-160:first-child{
    margin-right: -40rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-160:first-child{
    margin-left: -40rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-162:first-child{
    margin-left: -41rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-162:first-child{
    margin-right: -41rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-162:first-child{
    margin-right: -41rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-162:first-child{
    margin-left: -41rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-192:first-child{
    margin-left: -48rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-192:first-child{
    margin-right: -48rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-192:first-child{
    margin-right: -48rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-192:first-child{
    margin-left: -48rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-208:first-child{
    margin-left: -52rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-208:first-child{
    margin-right: -52rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-208:first-child{
    margin-right: -52rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-208:first-child{
    margin-left: -52rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-224:first-child{
    margin-left: -56rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-224:first-child{
    margin-right: -56rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-224:first-child{
    margin-right: -56rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-224:first-child{
    margin-left: -56rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-256:first-child{
    margin-left: -64rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-256:first-child{
    margin-right: -64rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-256:first-child{
    margin-right: -64rem;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-256:first-child{
    margin-left: -64rem;
  }

  [dir="ltr"] .\\33xl\\:first\\:-ms-px:first-child{
    margin-left: -1px;
  }

  [dir="rtl"] .\\33xl\\:first\\:-ms-px:first-child{
    margin-right: -1px;
  }

  [dir="ltr"] .\\33xl\\:first\\:-me-px:first-child{
    margin-right: -1px;
  }

  [dir="rtl"] .\\33xl\\:first\\:-me-px:first-child{
    margin-left: -1px;
  }

  [dir="rtl"] .\\33xl\\:start-0{
    right: 0;
  }

  [dir="rtl"] .\\33xl\\:end-0{
    left: 0;
  }

  [dir="ltr"] .\\33xl\\:end-0{
    right: 0;
  }

  [dir="ltr"] .\\33xl\\:start-0{
    left: 0;
  }

  [dir="rtl"] .\\33xl\\:start-auto{
    right: auto;
  }

  [dir="rtl"] .\\33xl\\:end-auto{
    left: auto;
  }

  [dir="ltr"] .\\33xl\\:end-auto{
    right: auto;
  }

  [dir="ltr"] .\\33xl\\:start-auto{
    left: auto;
  }

  [dir="ltr"] .\\33xl\\:rounded-e-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .\\33xl\\:rounded-s-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .\\33xl\\:rounded-e-none{
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .\\33xl\\:rounded-s-none{
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .\\33xl\\:rounded-e-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-s-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-e-sm{
    border-top-left-radius: .25rem;
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-s-sm{
    border-top-right-radius: .25rem;
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-e{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-s{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-e{
    border-top-left-radius: .375rem;
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-s{
    border-top-right-radius: .375rem;
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-e-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-s-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-e-lg{
    border-top-left-radius: .5rem;
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-s-lg{
    border-top-right-radius: .5rem;
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-e-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-s-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-e-xl{
    border-top-left-radius: .75rem;
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-s-xl{
    border-top-right-radius: .75rem;
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-e-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .\\33xl\\:rounded-s-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .\\33xl\\:rounded-e-full{
    border-top-left-radius: 9999px;
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .\\33xl\\:rounded-s-full{
    border-top-right-radius: 9999px;
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .\\33xl\\:rounded-ts-none{
    border-top-left-radius: 0;
  }

  [dir="ltr"] .\\33xl\\:rounded-te-none{
    border-top-right-radius: 0;
  }

  [dir="ltr"] .\\33xl\\:rounded-be-none{
    border-bottom-right-radius: 0;
  }

  [dir="ltr"] .\\33xl\\:rounded-bs-none{
    border-bottom-left-radius: 0;
  }

  [dir="rtl"] .\\33xl\\:rounded-te-none{
    border-top-left-radius: 0;
  }

  [dir="rtl"] .\\33xl\\:rounded-ts-none{
    border-top-right-radius: 0;
  }

  [dir="rtl"] .\\33xl\\:rounded-bs-none{
    border-bottom-right-radius: 0;
  }

  [dir="rtl"] .\\33xl\\:rounded-be-none{
    border-bottom-left-radius: 0;
  }

  [dir="ltr"] .\\33xl\\:rounded-ts-sm{
    border-top-left-radius: .25rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-te-sm{
    border-top-right-radius: .25rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-be-sm{
    border-bottom-right-radius: .25rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-bs-sm{
    border-bottom-left-radius: .25rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-te-sm{
    border-top-left-radius: .25rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-ts-sm{
    border-top-right-radius: .25rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-bs-sm{
    border-bottom-right-radius: .25rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-be-sm{
    border-bottom-left-radius: .25rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-ts{
    border-top-left-radius: .375rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-te{
    border-top-right-radius: .375rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-be{
    border-bottom-right-radius: .375rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-bs{
    border-bottom-left-radius: .375rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-te{
    border-top-left-radius: .375rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-ts{
    border-top-right-radius: .375rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-bs{
    border-bottom-right-radius: .375rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-be{
    border-bottom-left-radius: .375rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-ts-lg{
    border-top-left-radius: .5rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-te-lg{
    border-top-right-radius: .5rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-be-lg{
    border-bottom-right-radius: .5rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-bs-lg{
    border-bottom-left-radius: .5rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-te-lg{
    border-top-left-radius: .5rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-ts-lg{
    border-top-right-radius: .5rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-bs-lg{
    border-bottom-right-radius: .5rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-be-lg{
    border-bottom-left-radius: .5rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-ts-xl{
    border-top-left-radius: .75rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-te-xl{
    border-top-right-radius: .75rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-be-xl{
    border-bottom-right-radius: .75rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-bs-xl{
    border-bottom-left-radius: .75rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-te-xl{
    border-top-left-radius: .75rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-ts-xl{
    border-top-right-radius: .75rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-bs-xl{
    border-bottom-right-radius: .75rem;
  }

  [dir="rtl"] .\\33xl\\:rounded-be-xl{
    border-bottom-left-radius: .75rem;
  }

  [dir="ltr"] .\\33xl\\:rounded-ts-full{
    border-top-left-radius: 9999px;
  }

  [dir="ltr"] .\\33xl\\:rounded-te-full{
    border-top-right-radius: 9999px;
  }

  [dir="ltr"] .\\33xl\\:rounded-be-full{
    border-bottom-right-radius: 9999px;
  }

  [dir="ltr"] .\\33xl\\:rounded-bs-full{
    border-bottom-left-radius: 9999px;
  }

  [dir="rtl"] .\\33xl\\:rounded-te-full{
    border-top-left-radius: 9999px;
  }

  [dir="rtl"] .\\33xl\\:rounded-ts-full{
    border-top-right-radius: 9999px;
  }

  [dir="rtl"] .\\33xl\\:rounded-bs-full{
    border-bottom-right-radius: 9999px;
  }

  [dir="rtl"] .\\33xl\\:rounded-be-full{
    border-bottom-left-radius: 9999px;
  }

  [dir="ltr"] .\\33xl\\:clear-start{
    clear: left;
  }

  [dir="ltr"] .\\33xl\\:clear-end{
    clear: right;
  }

  [dir="rtl"] .\\33xl\\:clear-start{
    clear: right;
  }

  [dir="rtl"] .\\33xl\\:clear-end{
    clear: left;
  }

  [dir="rtl"] .\\33xl\\:float-start{
    float: right;
  }

  [dir="rtl"] .\\33xl\\:float-end{
    float: left;
  }

  [dir="ltr"] .\\33xl\\:float-end{
    float: right;
  }

  [dir="ltr"] .\\33xl\\:float-start{
    float: left;
  }

  [dir="ltr"] .\\33xl\\:border-e-0{
    border-right-width: 0;
  }

  [dir="rtl"] .\\33xl\\:border-e-0{
    border-left-width: 0;
  }

  [dir="ltr"] .\\33xl\\:border-s-0{
    border-left-width: 0;
  }

  [dir="rtl"] .\\33xl\\:border-s-0{
    border-right-width: 0;
  }

  [dir="ltr"] .\\33xl\\:border-e-2{
    border-right-width: 2px;
  }

  [dir="rtl"] .\\33xl\\:border-e-2{
    border-left-width: 2px;
  }

  [dir="ltr"] .\\33xl\\:border-s-2{
    border-left-width: 2px;
  }

  [dir="rtl"] .\\33xl\\:border-s-2{
    border-right-width: 2px;
  }

  [dir="ltr"] .\\33xl\\:border-e-3{
    border-right-width: 3px;
  }

  [dir="rtl"] .\\33xl\\:border-e-3{
    border-left-width: 3px;
  }

  [dir="ltr"] .\\33xl\\:border-s-3{
    border-left-width: 3px;
  }

  [dir="rtl"] .\\33xl\\:border-s-3{
    border-right-width: 3px;
  }

  [dir="ltr"] .\\33xl\\:border-e-4{
    border-right-width: 4px;
  }

  [dir="rtl"] .\\33xl\\:border-e-4{
    border-left-width: 4px;
  }

  [dir="ltr"] .\\33xl\\:border-s-4{
    border-left-width: 4px;
  }

  [dir="rtl"] .\\33xl\\:border-s-4{
    border-right-width: 4px;
  }

  [dir="ltr"] .\\33xl\\:border-e-5{
    border-right-width: 5px;
  }

  [dir="rtl"] .\\33xl\\:border-e-5{
    border-left-width: 5px;
  }

  [dir="ltr"] .\\33xl\\:border-s-5{
    border-left-width: 5px;
  }

  [dir="rtl"] .\\33xl\\:border-s-5{
    border-right-width: 5px;
  }

  [dir="ltr"] .\\33xl\\:border-e-6{
    border-right-width: 6px;
  }

  [dir="rtl"] .\\33xl\\:border-e-6{
    border-left-width: 6px;
  }

  [dir="ltr"] .\\33xl\\:border-s-6{
    border-left-width: 6px;
  }

  [dir="rtl"] .\\33xl\\:border-s-6{
    border-right-width: 6px;
  }

  [dir="ltr"] .\\33xl\\:border-e-8{
    border-right-width: 8px;
  }

  [dir="rtl"] .\\33xl\\:border-e-8{
    border-left-width: 8px;
  }

  [dir="ltr"] .\\33xl\\:border-s-8{
    border-left-width: 8px;
  }

  [dir="rtl"] .\\33xl\\:border-s-8{
    border-right-width: 8px;
  }

  [dir="ltr"] .\\33xl\\:border-e{
    border-right-width: 1px;
  }

  [dir="rtl"] .\\33xl\\:border-e{
    border-left-width: 1px;
  }

  [dir="ltr"] .\\33xl\\:border-s{
    border-left-width: 1px;
  }

  [dir="rtl"] .\\33xl\\:border-s{
    border-right-width: 1px;
  }

  [dir="ltr"] .\\33xl\\:first\\:border-e-0:first-child{
    border-right-width: 0;
  }

  [dir="rtl"] .\\33xl\\:first\\:border-e-0:first-child{
    border-left-width: 0;
  }

  [dir="ltr"] .\\33xl\\:first\\:border-s-0:first-child{
    border-left-width: 0;
  }

  [dir="rtl"] .\\33xl\\:first\\:border-s-0:first-child{
    border-right-width: 0;
  }

  [dir="ltr"] .\\33xl\\:first\\:border-e-2:first-child{
    border-right-width: 2px;
  }

  [dir="rtl"] .\\33xl\\:first\\:border-e-2:first-child{
    border-left-width: 2px;
  }

  [dir="ltr"] .\\33xl\\:first\\:border-s-2:first-child{
    border-left-width: 2px;
  }

  [dir="rtl"] .\\33xl\\:first\\:border-s-2:first-child{
    border-right-width: 2px;
  }

  [dir="ltr"] .\\33xl\\:first\\:border-e-3:first-child{
    border-right-width: 3px;
  }

  [dir="rtl"] .\\33xl\\:first\\:border-e-3:first-child{
    border-left-width: 3px;
  }

  [dir="ltr"] .\\33xl\\:first\\:border-s-3:first-child{
    border-left-width: 3px;
  }

  [dir="rtl"] .\\33xl\\:first\\:border-s-3:first-child{
    border-right-width: 3px;
  }

  [dir="ltr"] .\\33xl\\:first\\:border-e-4:first-child{
    border-right-width: 4px;
  }

  [dir="rtl"] .\\33xl\\:first\\:border-e-4:first-child{
    border-left-width: 4px;
  }

  [dir="ltr"] .\\33xl\\:first\\:border-s-4:first-child{
    border-left-width: 4px;
  }

  [dir="rtl"] .\\33xl\\:first\\:border-s-4:first-child{
    border-right-width: 4px;
  }

  [dir="ltr"] .\\33xl\\:first\\:border-e-5:first-child{
    border-right-width: 5px;
  }

  [dir="rtl"] .\\33xl\\:first\\:border-e-5:first-child{
    border-left-width: 5px;
  }

  [dir="ltr"] .\\33xl\\:first\\:border-s-5:first-child{
    border-left-width: 5px;
  }

  [dir="rtl"] .\\33xl\\:first\\:border-s-5:first-child{
    border-right-width: 5px;
  }

  [dir="ltr"] .\\33xl\\:first\\:border-e-6:first-child{
    border-right-width: 6px;
  }

  [dir="rtl"] .\\33xl\\:first\\:border-e-6:first-child{
    border-left-width: 6px;
  }

  [dir="ltr"] .\\33xl\\:first\\:border-s-6:first-child{
    border-left-width: 6px;
  }

  [dir="rtl"] .\\33xl\\:first\\:border-s-6:first-child{
    border-right-width: 6px;
  }

  [dir="ltr"] .\\33xl\\:first\\:border-e-8:first-child{
    border-right-width: 8px;
  }

  [dir="rtl"] .\\33xl\\:first\\:border-e-8:first-child{
    border-left-width: 8px;
  }

  [dir="ltr"] .\\33xl\\:first\\:border-s-8:first-child{
    border-left-width: 8px;
  }

  [dir="rtl"] .\\33xl\\:first\\:border-s-8:first-child{
    border-right-width: 8px;
  }

  [dir="ltr"] .\\33xl\\:first\\:border-e:first-child{
    border-right-width: 1px;
  }

  [dir="rtl"] .\\33xl\\:first\\:border-e:first-child{
    border-left-width: 1px;
  }

  [dir="ltr"] .\\33xl\\:first\\:border-s:first-child{
    border-left-width: 1px;
  }

  [dir="rtl"] .\\33xl\\:first\\:border-s:first-child{
    border-right-width: 1px;
  }

  [dir="rtl"] .\\33xl\\:text-start{
    text-align: right;
  }

  [dir="rtl"] .\\33xl\\:text-end{
    text-align: left;
  }

  [dir="ltr"] .\\33xl\\:text-end{
    text-align: right;
  }

  [dir="ltr"] .\\33xl\\:text-start{
    text-align: left;
  }

  [dir="ltr"] .\\33xl\\:origin-top-start{
    transform-origin: top left;
  }

  [dir="ltr"] .\\33xl\\:origin-top-end{
    transform-origin: top right;
  }

  [dir="ltr"] .\\33xl\\:origin-bottom-start{
    transform-origin: bottom left;
  }

  [dir="ltr"] .\\33xl\\:origin-bottom-end{
    transform-origin: bottom right;
  }

  [dir="ltr"] .\\33xl\\:origin-start{
    transform-origin: left;
  }

  [dir="ltr"] .\\33xl\\:origin-end{
    transform-origin: right;
  }

  [dir="rtl"] .\\33xl\\:origin-top-start{
    transform-origin: top right;
  }

  [dir="rtl"] .\\33xl\\:origin-top-end{
    transform-origin: top left;
  }

  [dir="rtl"] .\\33xl\\:origin-bottom-start{
    transform-origin: bottom right;
  }

  [dir="rtl"] .\\33xl\\:origin-bottom-end{
    transform-origin: bottom left;
  }

  [dir="rtl"] .\\33xl\\:origin-start{
    transform-origin: right;
  }

  [dir="rtl"] .\\33xl\\:origin-end{
    transform-origin: left;
  }

  [dir="ltr"] .\\33xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0px * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-0 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-9 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-11 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-12 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-14 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-15 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-16 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-18 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-20 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-22 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-23 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-24 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-25 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-26 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-28 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-30 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-32 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-34 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-40 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-42 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(11rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(11rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-44 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(12rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(12rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-48 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-52 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-54 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(14rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(14rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-56 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(15rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(15rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-60 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(16rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(16rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-64 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(17rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(17rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-68 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-72 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-74 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-76 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-78 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-80 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-82 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(21rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(21rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-84 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(22rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(22rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-88 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(23rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(23rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-92 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-96 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-98 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-100 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(26rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(26rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-104 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(28rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(28rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-112 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(31rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(31rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-124 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(32rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(32rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-128 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(35rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(35rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-140 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(38rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(38rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-152 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(40rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(40rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-160 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(41rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(41rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-162 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(48rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(48rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-192 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(52rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(52rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-208 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(56rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(56rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-224 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(64rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(64rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-256 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(1px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(1px * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:space-s-px > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-0.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-0.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-7 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-8 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-9 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-10 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-2.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-2.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-11 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-12 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-14 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-3.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-3.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-15 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-4rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-16 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-4.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-4.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-18 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-20 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-22 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-5.75rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-5.75rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-23 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-24 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6.25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-25 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-6.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-6.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-26 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-7rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-28 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-7.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-7.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-30 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-8rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-32 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-8.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-8.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-34 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-10rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-40 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-10.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-10.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-42 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-11rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-11rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-11rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-44 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-12rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-12rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-12rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-48 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-13rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-52 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-13.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-13.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-54 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-14rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-14rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-14rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-56 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-15rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-15rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-15rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-60 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-16rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-16rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-16rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-64 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-17rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-17rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-17rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-68 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-18rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-72 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-18.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-18.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-74 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-19rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-76 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-19.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-19.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-78 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-20rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-80 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-20.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-20.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-82 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-21rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-21rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-21rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-84 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-22rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-22rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-22rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-88 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-23rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-23rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-23rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-92 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-24rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-96 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-24.5rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-24.5rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-98 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-25rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-25rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-25rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-100 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-26rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-26rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-26rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-104 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-28rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-28rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-28rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-112 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-31rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-31rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-31rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-124 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-32rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-32rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-32rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-128 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-35rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-35rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-35rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-140 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-38rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-38rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-38rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-152 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-40rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-40rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-40rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-160 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-41rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-41rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-41rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-162 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-48rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-48rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-48rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-192 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-52rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-52rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-52rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-208 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-56rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-56rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-56rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-224 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-64rem * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-64rem * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-64rem * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-256 > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  [dir="ltr"] .\\33xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * var(--tw-space-s-reverse));
  }

  [dir="rtl"] .\\33xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * var(--tw-space-s-reverse));
  }

  [dir="ltr"] .\\33xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * (1 - var(--tw-space-s-reverse)));
    margin-left: calc(-1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * (1 - var(--tw-space-s-reverse)));
    margin-right: calc(-1px * calc(1 - var(--tw-space-s-reverse)));
  }

  [dir="ltr"] .\\33xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-left: calc(-1px * (1 - var(--tw-space-s-reverse)));
  }

  [dir="rtl"] .\\33xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    margin-right: calc(-1px * (1 - var(--tw-space-s-reverse)));
  }

  .\\33xl\\:-space-s-px > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 0;
  }

  .\\33xl\\:space-s-reverse > :not([hidden]) ~ :not([hidden]){
    --tw-space-s-reverse: 1;
  }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
